/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 131);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(137)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.app_Id = undefined;

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(7);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _axios = __webpack_require__(28);

var _axios2 = _interopRequireDefault(_axios);

var _blueimpMd = __webpack_require__(37);

var _blueimpMd2 = _interopRequireDefault(_blueimpMd);

var _tf_web_log = __webpack_require__(67);

var _tf_web_log2 = _interopRequireDefault(_tf_web_log);

var _index = __webpack_require__(68);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app_Id = exports.app_Id = null;

var tfWebLog = _tf_web_log2.default.getInstance();
exports.default = {
  getQueryDsId: getQueryDsId,
  getQueryChannelId: getQueryChannelId,
  getQueryString: getQueryString,
  getQueryString2: getQueryString2,
  baseUrl: baseUrl,
  baseUrl1: baseUrl1,
  baseUrl2: baseUrl2,
  baseUrl3: baseUrl3,
  tencentOssUrl: tencentOssUrl,
  aliOssUrl: aliOssUrl,
  baseUrlUser: baseUrlUser,
  baseUrlSchool: baseUrlSchool,
  changeTime: changeTime,
  setCookie: setCookie,
  getCookie: getCookie,
  delCookie: delCookie,
  two: two,
  isWeixin: isWeixin,
  encrypt: encrypt,
  getDsInfo: getDsInfo,
  getCache: getCache,
  clearAllCookie: clearAllCookie,
  imgPath: imgPath,
  login: login,
  checkPhoneType: checkPhoneType,
  bugTicket: bugTicket,
  getCoupon: getCoupon,
  weixinPay: weixinPay,
  DrawingCanvas: DrawingCanvas,
  getIsDeveloper: getIsDeveloper,
  updateOnlineStatus: updateOnlineStatus,
  getFakeLiveInfo: getFakeLiveInfo,
  getQueryData: getQueryData,
  getUrlAddQuery: getUrlAddQuery,
  getDs_id: getDs_id,
  setDs_id: setDs_id,
  clearFansInfo: clearFansInfo,
  getCommentTimes: getCommentTimes,
  LoginJumpQQ: LoginJumpQQ,
  LoginJumpWx: LoginJumpWx,
  getUserInfoReloadByToken: getUserInfoReloadByToken,
  getCacheUserInfo: getCacheUserInfo,
  Weixin: Weixin,
  baseUrlUserBak: baseUrlUserBak,
  isWeixinMP: isWeixinMP,
  isWeixinMPInPC: isWeixinMPInPC,
  guid: guid,
  setAppID: setAppID
};


_axios2.default.interceptors.response.use(function (response) {
  console.log('success');
  return response;
}, function (err) {
  console.log('fail');
});
var that = undefined;
var developer; //是否在开发者环境
var fans_id = "";
var userSig;
var tokenStr;
var agreement = 'http://';

var globalDirectSeeding = {};

function getIsDeveloper() {
  return developer;
}

if (true) {
  developer = false;
  agreement = 'https://';
  // 取消日志打印
  // console.log = function() {};
} else {
  console.log("当前在测试环境");
  developer = true;
}
developer = false;
agreement = 'https://';

function imgPath() {
  if (developer) {
    return "../../../statics/imgs/";
  } else {
    return agreement + "res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/";
  }
}

function baseUrl() {
  var baseUrl;
  if (developer) {
    baseUrl = agreement + "liveapi.tenghuiwangxiao.cn";
  } else {
    baseUrl = agreement + "liveapi.tenghuiwangxiao.cn";
  }
  return baseUrl;
}

function baseUrl1() {
  if (developer) {
    return agreement + "liveapi2.tenghuiwangxiao.cn";
  } else {
    return agreement + "liveapi2.tenghuiwangxiao.cn";
  }
}

function baseUrl2() {
  if (developer) {
    return agreement + "liveapi2.tenghuiwangxiao.cn/api";
  } else {
    return agreement + "liveapi2.tenghuiwangxiao.cn/api";
  }
}

function baseUrl3() {
  if (developer) {
    return agreement + "liveapi2.tenghuiwangxiao.cn/wap";
  } else {
    return agreement + "liveapi2.tenghuiwangxiao.cn/wap";
  }
}

function baseUrlUser() {
  if (developer) {
    return agreement + "user-data.tenghuiwangxiao.cn";
  } else {
    return agreement + "user-data.tenghuiwangxiao.cn";
  }
}

function baseUrlUserBak() {
  if (developer) {
    return agreement + "user-data.tengface.com";
  } else {
    return agreement + "user-data.tengface.com";
  }
}

function baseUrlSchool() {
  if (developer) {
    return agreement + "online.tenghuiwangxiao.cn";
  } else {
    return agreement + "online.tenghuiwangxiao.cn";
  }
}

function tencentOssUrl() {
  return 'https://tengface-live-user-1308721187.cos.accelerate.myqcloud.com';
}

function aliOssUrl() {
  return 'https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com';
}

function baseUrlSchool() {
  if (developer) {
    return agreement + "online.tenghuiwangxiao.cn";
  } else {
    return agreement + "online.tenghuiwangxiao.cn";
  }
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function getQueryDsId() {
  var ds_id = getQueryString('ds_id');
  var d = getQueryString('d');
  if (ds_id) {
    return ds_id;
  }
  if (d) {
    return d;
  }
  return null;
}

function getQueryChannelId() {
  var channel_id = getQueryString('channel_id');
  var c = getQueryString('c');
  if (channel_id) {
    return channel_id;
  }
  if (c) {
    return c;
  }
  return null;
}

function getQueryString2(urlStr, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  if (urlStr.indexOf("?") != -1) {
    urlStr = "?" + urlStr.substr(urlStr.indexOf("?") + 1);
    var r = urlStr.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
  }
  return null;
}

function setCookie(name, value, Days) {
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
}

function getCookie(name) {
  var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}

function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
    }
  }
}

function changeTime(time) {
  if (time && parseInt(time).toString() != "NaN") {
    var h = parseInt(time / 3600);
    var m = parseInt(time % 3600 / 60);
    var s = parseInt(time % 60);
    return two(h) + ":" + two(m) + ":" + two(s);
  } else {
    return "00:00:00";
  }
}

function two(num) {
  if (num < 10) {
    return "0" + num;
  }
  return num;
}

function isWeixin() {
  var agent = navigator.userAgent.toLowerCase();
  if (agent.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

function is_qq() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  if (sUserAgent.match(/QQ/i) == 'qq') {
    return true;
  } else {
    return false;
  }
}

//小程序
function isWeixinMP() {
  var agent = navigator.userAgent.toLowerCase();
  if (agent.match(/miniprogram/i) == "miniprogram") {
    return true;
  } else {
    return false;
  }
}

function isWeixinMPInPC() {
  var agent = navigator.userAgent.toLowerCase();
  if (agent.match(/miniprogram/i) == "miniprogram" && agent.match(/windowswechat/i) == "windowswechat") {
    return true;
  } else {
    return false;
  }
}

function encrypt(option) {
  var Base64 = __webpack_require__(34).Base64;
  var verifyCode = _data2.default.verifyCode;
  console.log(verifyCode);
  var tmp;
  var tmp1;

  var data1 = JSON.stringify(option);
  var params1 = Base64.encode(data1).replace(/\+/g, "%2B");
  var newstr1 = "";
  var tmp2 = params1.substring(0, 3);
  var tmp3 = params1.substring(3, params1.length);
  newstr1 += tmp2 + (0, _blueimpMd2.default)(data1 + verifyCode) + tmp3;
  newstr1 = "data=" + newstr1;
  return newstr1;
}

function setDs_id(new_ds_id) {
  ds_id = new_ds_id;
}

function getDs_id() {
  return ds_id;
}

function setAppID(app_id) {
  exports.app_Id = app_Id = app_id;
}

var ds_id = getQueryString("ds_id");
var nick;
var userSig;
var loginCode;
var Weixin = isWeixin();
var fans = {};

function login(liveapp_id, liveapp_uid, callback, title) {

  initLoginGetAppId(liveapp_id, function (appidTmp) {
    var isCache = getCache(appidTmp);
    if (isCache) {
      //有缓存
      callback(fans);
    } else {
      //没有缓冲
      if (!Weixin) {
        //qq登录
        exports.app_Id = app_Id = "102004807";
        var isCache = getCache(app_Id);
        if (isCache) {
          //有缓存
          callback(fans);
        } else {
          //没有缓冲
          //先判断code是否存在
          loginCode = getQueryString("code");
          if (!loginCode) {
            //不存在,获取code
            if (is_qq()) {
              //qq内
              initLoginJumpQQ(app_Id, title);
            } else {
              callback({ showQQPopUp: true });
            }
          } else {
            //有code
            getFansInfo('qq', callback, title);
          }
        }
      } else {
        //微信
        loginCode = getQueryString("code");
        if (!loginCode) {
          callback({ showWxPopUp: true });
          //不存在,获取code
          // initLoginJumpWx(appidTmp);
        } else {
          var loginType = getQueryString("loginType");

          if (loginType == "cloudapi") {
            getFansInfoCloudApi(liveapp_uid, callback);
          } else {
            getFansInfo('wx', callback, title);
          }
        }
      }
    }
  }, function () {
    callback({});
  });
}

function LoginJumpQQ(title) {
  initLoginJumpQQ(app_Id, title);
}

function LoginJumpWx(title) {
  initLoginJumpWx(app_Id, '', title);
}

//获取用户数据缓存
function getCache(appIdTmp) {
  //判断缓存是否存在
  try {
    fans = JSON.parse(localStorage.getItem(appIdTmp));
    if (fans && fans.unReal != 1 && (fans.openid || fans.isTokenLogin)) {
      //不是虚拟用户
      //适配其他的应用
      setCookie("fans_id", fans.fans_id);
      fans_id = fans.fans_id;
      userSig = fans.userSig;
      nick = fans.nick;
      tokenStr = fans.token;
      return true;
    }
    clearFansInfo();
  } catch (e) {
    clearFansInfo();
    return false;
  }

  return false;
}

function getCacheUserInfo(appIdTmp) {
  try {
    fans = JSON.parse(localStorage.getItem(appIdTmp));
    if (fans) {
      //适配其他的应用
      setCookie("fans_id", fans.fans_id);
      fans_id = fans.fans_id;
      userSig = fans.userSig;
      nick = fans.nick;
      tokenStr = fans.token;
      return fans;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}

function clearFansInfo() {
  if (app_Id) {
    localStorage.removeItem(app_Id);
    delCookie('fans_id');
  }
}

//获取动态参数
function getFansInfo(type, callback, title) {
  var loginUrl = baseUrl2() + "/user/login/autoLogin/?code=" + loginCode + "&ds_id=" + ds_id;
  console.log(loginUrl);

  if (type == "qq") {
    loginUrl = baseUrl2() + "/user/login/qqLogin?code=" + loginCode + "&ds_id=" + ds_id;
  }

  _axios2.default.get(loginUrl, { timeout: 2000 }).then(function (data) {
    if (data.data.code == 200) {
      var data = data.data.data;
      //这里需要缓存数据,然后重新加载
      fans = {
        fans_id: data.fans_id,
        header: data.header,
        nick: data.nick,
        userSig: data.tsl_sig,
        real_auth: data.real_auth,
        status: data.status,
        token: data.token,
        openid: data.openid
      };
      //适配其他的应用
      setCookie("fans_id", data.fans_id);
      if (app_Id) {
        localStorage.setItem("current_app_Id", app_Id);
        localStorage.setItem(app_Id, JSON.stringify(fans));
      }
      callback(fans);
    } else if (data.data.code == 400) {
      if (data.data.message == '直播间不存在!') {
        (0, _toast2.default)({ message: data.data.message, duration: 0 });
      } else {
        if (type == "qq") {
          initLoginJumpQQ(app_Id, title);
        } else {
          initLoginJumpWx(app_Id);
        }
      }
    }
  }).catch(function (data) {
    // Toast("网络错误！");
    console.log(JSON.stringify(data));
    if (type == 'wx') {
      initLoginJumpWx(app_Id, 'cloudapi');
    } else {
      callback({});
    }
  });
}

function createCode() {
  var demo = "";
  //这里取的是4位，所以for循环4次，如果是6位数字验证码则为6
  for (var i = 0; i < 6; i++) {
    //设置随机数范围,这设置为0 ~ 9
    var a = Math.floor(Math.random() * 9);
    a = a == 0 ? 1 : a;
    //拼接字符串
    demo += a;
  }
  return demo;
}

function getFansInfoCloudApi(liveapp_uid, callback) {
  var loginUrl = "https://service-856tq6q0-1258158934.gz.apigw.tencentcs.com/release/getUserInfo";
  // let params = `code=${loginCode}`
  console.log(loginUrl);
  _axios2.default.post(loginUrl, { code: loginCode }, { timeout: 5000 }).then(function (data) {
    console.log("getFansInfoCloudApi====>", data);
    if (data.data.code == 200) {
      var data = data.data.data;
      console.log("getFansInfoCloudApi2====>", data);
      registerUserInfo(liveapp_uid, data, callback);
    } else if (data.data.code == 400) {
      initLoginJumpWx(app_Id, 'cloudapi');
    }
  }).catch(function (data) {
    // Toast("网络错误！");
    console.log("网络错误！", data);
    // console.log(JSON.stringify(data));
    var fansInfoTMp = getCacheUserInfo(app_Id);
    if (fansInfoTMp) {
      //用缓存用户信息
      callback(fansInfoTMp);
    } else {
      //随机用户信息
      var fansIdTmp = createCode();
      var _fans = {
        fans_id: fansIdTmp,
        header: "https://tengface-live.oss-cn-beijing.aliyuncs.com/admin/img/youke_header.png",
        nick: "\u7528\u6237_" + fansIdTmp,
        userSig: "",
        token: "",
        unReal: 1
      };
      //适配其他的应用
      setCookie("fans_id", data.fans_id);
      if (app_Id) {
        localStorage.setItem("current_app_Id", app_Id);
        localStorage.setItem(app_Id, JSON.stringify(_fans));
      }
      callback(_fans);
    }
  });
}

//注册用户信息
function registerUserInfo(liveapp_uid, userInfo, callBack) {

  var params = "nick=" + userInfo.nickname + "&uid=" + liveapp_uid + "&openid=" + userInfo.openid + "&header=" + userInfo.headimgurl;
  _axios2.default.post(baseUrl2() + "/user/login/register", params).then(function (response) {
    if (response.data.code == 200) {
      var data = response.data.data;
      fans = {
        fans_id: data.fans_id,
        header: data.header,
        nick: data.nick,
        userSig: data.tsl_sig,
        real_auth: data.real_auth,
        status: data.status,
        token: data.token,
        openid: userInfo.openid
      };
      //适配其他的应用
      setCookie("fans_id", data.fans_id);
      if (app_Id) {
        localStorage.setItem("current_app_Id", app_Id);
        localStorage.setItem(app_Id, JSON.stringify(fans));
      }
      callBack(fans);
    } else {
      fans = {
        fans_id: userInfo.fans_id,
        header: userInfo.headimgurl,
        nick: userInfo.nickname,
        userSig: userInfo.tsl_sig,
        real_auth: userInfo.real_auth,
        status: userInfo.status,
        token: userInfo.token,
        unReal: 1
      };
      //适配其他的应用
      setCookie("fans_id", userInfo.fans_id);
      if (app_Id) {
        localStorage.setItem("current_app_Id", app_Id);
        localStorage.setItem(app_Id, JSON.stringify(fans));
      }
      callBack(fans);
    }
  }).catch(function (error) {
    //这里需要缓存数据,然后重新加载
    var fans = {
      fans_id: userInfo.fans_id,
      header: userInfo.headimgurl,
      nick: userInfo.nickname,
      userSig: userInfo.tsl_sig,
      real_auth: userInfo.real_auth,
      status: userInfo.status,
      token: userInfo.token,
      unReal: 1
    };
    //适配其他的应用
    setCookie("fans_id", userInfo.fans_id);
    if (app_Id) {
      localStorage.setItem("current_app_Id", app_Id);
      localStorage.setItem(app_Id, JSON.stringify(fans));
    }
    callBack(fans);
  });
}

// 获取伪直播信息
function getFakeLiveInfo(tid, callback) {
  _axios2.default.post(baseUrl3() + "/live/getLiveInfoById", "tid=" + tid).then(function (response) {
    if (response.data.code == 200) {
      callback(true, response.data.data);
    } else {
      callback(false, response);
    }
  }).catch(function (error) {
    callback(false, error);
  });
}

function mergeDsData(fakeInfo, dsInfo) {
  var newInfo = _extends({}, dsInfo);
  newInfo.direct_seeding.room_id = fakeInfo.room_id;
  newInfo.direct_seeding.name = fakeInfo.name;
  newInfo.direct_seeding.real_start_time = fakeInfo.start_time_real;
  newInfo.direct_seeding.real_end_time = fakeInfo.end_time_real;
  newInfo.direct_seeding.start_time = fakeInfo.start_time;
  newInfo.fakeLive = true;
  newInfo.fakeTemplateId = fakeInfo.t_id;
  newInfo.direct_seeding.break_point = [];
  if (fakeInfo.status == '1') {
    newInfo.direct_seeding.direct_status = 'not_started';
    newInfo.box_info = {};
  } else if (fakeInfo.status == '2') {
    newInfo.direct_seeding.direct_status = 'running';
    newInfo.box_info = {
      pull_stream_url: JSON.stringify({
        flv_url: fakeInfo.play_url_flv,
        m3u8_url: fakeInfo.play_url_m3u8,
        play_url_web_rtc: fakeInfo.play_url_web_rtc
      })
    };
  } else if (fakeInfo.status == '3') {
    newInfo.direct_seeding.direct_status = 'end';
    newInfo.box_info = {};
  }

  return newInfo;
}

//新版获取直播间信息方法
function getDsInfo(callback, fakeInfo) {
  var tencentOssUrl = "https://tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com/ds/larave_cache/dsCache_" + ds_id + ".json?" + new Date().getTime() + parseInt(Math.random() * 10e4);
  var use_time_b = new Date();
  _axios2.default.get(tencentOssUrl, { timeout: 2000 }).then(function (data) {
    var use_time = new Date() - use_time_b;
    tfWebLog.putLogs(10000, 1, { responseData: data, use_time: use_time });
    getDsInfoSuccess(data, callback, fakeInfo);
  }).catch(function (error) {
    var use_time = new Date() - use_time_b;
    var message = error && error.message ? error.message : error;
    tfWebLog.putLogs(10000, 1, { responseData: message, use_time: use_time });
    //发生错误时执行的代码
    console.log("获取初始化数据失败了");
    getDsInfoRequest(callback, fakeInfo);
  });
}

var getDsInfoSuccess = function getDsInfoSuccess(data, callback, fakeInfo) {
  if (data.data) {
    if (fakeInfo) {
      data.data = mergeDsData(fakeInfo, data.data);
    }
    _index2.default.dispatch('dsInfo/getDsInfo', data.data);
    _data2.default.setInitData(data.data);
    if (data.data.direct_seeding) {
      globalDirectSeeding = data.data.direct_seeding;
      document.title = data.data.direct_seeding.name;
      document.getElementById("description").content = data.data.direct_seeding.desc;
    }
    exports.app_Id = app_Id = data.data.direct_seeding.appid;
    getUserInfoByToken(data.data, function () {
      callback(data.data);
    });
  } else {
    getDsInfoRequest(callback, fakeInfo);
  }
};

function getDsInfoRequest(callback, fakeInfo) {
  _axios2.default.post(baseUrl2() + "/init/index/index", "ds_id=" + ds_id).then(function (response) {
    console.log(response);
    var data = response.data;
    if (data.code == 200) {
      if (fakeInfo) {
        data.data = mergeDsData(fakeInfo, data.data);
      }
      _data2.default.setInitData(data.data);
      document.title = data.data.direct_seeding.name;
      document.getElementById("description").content = data.data.direct_seeding.desc;
      exports.app_Id = app_Id = data.data.direct_seeding.appid;
      getUserInfoByToken(data.data, function () {
        callback(data.data);
      });
    } else if (data.code == 400) {
      (0, _toast2.default)({ message: data.message, duration: 0 });
    } else {
      console.log("init/index/index调用接口失败了200");
    }
  }).catch(function (error) {
    console.log("init/index/index调用接口失败了" + error);
  });
}

function initLoginGetAppId(liveapp_id, callback, errorCallBack) {
  if (liveapp_id) {
    exports.app_Id = app_Id = liveapp_id;
    localStorage.setItem("current_app_Id", liveapp_id);
    callback(liveapp_id);
  } else {
    _axios2.default.post(baseUrl2() + "/init/getDsInfo", "ds_id=" + ds_id).then(function (response) {
      var data = response.data;
      if (data.code == 200) {
        exports.app_Id = app_Id = data.data;
        //获取当前的appid
        console.log("获取当前的appid:" + app_Id);
        localStorage.setItem("current_app_Id", data.data);
        callback(data.data);
      } else {
        (0, _toast2.default)(data.message);
        console.log("/init/getDsInfo调用接口失败了else");
      }
    }).catch(function (error) {
      console.log(JSON.stringify(error));
      errorCallBack();
      (0, _toast2.default)("网络错误！");
      console.log("/init/getDsInfo调用接口失败了" + error);
    });
  }
}

// 获取到了token更新用户信息
function getUserInfoReloadByToken(token) {
  if (token) {
    var user = { token: token };
    localStorage.setItem(app_Id, JSON.stringify(user));
    _axios2.default.post(baseUrl2() + "/user/getUserInfoByToken", "").then(function (res) {
      if (res.data.code == 200) {
        var userInfo = res.data.data;
        fans = {
          fans_id: userInfo.fans_id,
          header: userInfo.header,
          nick: userInfo.nick,
          userSig: userInfo.tsl_sig,
          real_auth: userInfo.real_auth,
          status: userInfo.status,
          isTokenLogin: 1,
          token: userInfo.token
        };
        //适配其他的应用
        setCookie("fans_id", userInfo.fans_id);
        if (app_Id) {
          localStorage.setItem("current_app_Id", app_Id);
          localStorage.setItem(app_Id, JSON.stringify(fans));
        }
        window.location.reload();
      }
    }).catch(function (error) {
      console.error("getUserInfoByToken", error);
    });
  } else {
    console.error("getUserInfoReloadByToken", "token不存在");
  }
}

// 用token获取用户信息
function getUserInfoByToken(dsInfo, callBack) {
  var token = getQueryString("token");
  var otherLogin = getQueryString('other');
  var shool_token = getQueryString('shool_token');
  //  测试环境也可以 和  iOS safair浏览器下有效 而且不在微信环境
  if (token) {
    if (isIhponeSafari() && !isWeixin() || developer || otherLogin) {

      if (dsInfo.direct_seeding.is_shanhu == 2) {
        //珊瑚跳转
        var user = { token: token };
        localStorage.setItem(app_Id, JSON.stringify(user));
        _axios2.default.post(baseUrl2() + "/user/login/getShToken", "").then(function (res) {
          if (res.data.code == 200) {
            var shToken = res.data.data.shToken;
            if (app_Id) {
              localStorage.removeItem(app_Id);
            }
            location.href = "https://u.shkt.online/?ds_id=" + ds_id + "&token=" + shToken + "&other=" + otherLogin + "&shool_token=" + shool_token;
            return;
          }
          clearToken();
          if (callBack) {
            callBack();
          }
        }).catch(function (error) {
          clearToken();
          if (callBack) {
            callBack();
          }
        });
      } else {
        if (shool_token) {
          setCookie("netschool_token", shool_token, 30);
        }
        var _user = { token: token };
        localStorage.setItem(app_Id, JSON.stringify(_user));
        _axios2.default.post(baseUrl2() + "/user/getUserInfoByToken", "").then(function (res) {
          if (res.data.code == 200) {
            var userInfo = res.data.data;
            fans = {
              fans_id: userInfo.fans_id,
              header: userInfo.header,
              nick: userInfo.nick,
              userSig: userInfo.tsl_sig,
              real_auth: userInfo.real_auth,
              status: userInfo.status,
              token: userInfo.token,
              isTokenLogin: 1
            };
            //适配其他的应用
            setCookie("fans_id", userInfo.fans_id);
            setCookie("user_token", userInfo.token, 30);
            if (app_Id) {
              localStorage.setItem(app_Id, JSON.stringify(fans));
            }
            clearToken();
          }
          if (callBack) {
            callBack();
          }
        }).catch(function (error) {
          console.error("getUserInfoByToken", error);
          clearToken();
          if (callBack) {
            callBack();
          }
        });
      }

      return;
    }
    if (callBack) {
      callBack();
    }
  } else {
    if (callBack) {
      callBack();
    }
  }
}

function isIhponeSafari() {
  var ua = navigator.userAgent.toLowerCase();
  //判断是不是在iPhone的Safair浏览器打开的本页面
  if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 && ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 && ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
    console.log("是safari");
    return true;
  } else {
    console.log("不是safari");
    return false;
  }
}

function getQueryData(url) {
  var urlAll = url;
  var tmp = urlAll.split("#")[0];
  tmp = tmp.split("?");
  if (tmp.length == 1) {
    return {};
  }
  var list = tmp[1].split("&");
  console.log(list);
  var data = {};
  for (var index = 0; index < list.length; index++) {
    var element = list[index];
    var arr = element.split('=');
    if (arr.length >= 2) {
      data[arr[0]] = element.substring(arr[0].length + 1);
    }
  }
  return data;
}

function getUrlAddQuery(url, data) {
  var isFrist = true;
  for (var key in data) {
    var value = data[key];
    if (value === '') {
      continue;
    }
    if (isFrist) {
      isFrist = false;
      url = url + '?';
      url = url + key + '=' + value;
    } else {
      url = url + '&' + key + '=' + value;
    }
  }
  return url;
}

function clearToken() {
  var data = getQueryData(window.location.href);
  data.token = '';
  data.shool_token = '';
  if (checkPhoneType() == 2) {
    var url = getUrlAddQuery(window.location.pathname, data);
    window.history.replaceState({}, "除去URL参数", url);
    window.location.href = url;
  } else {
    var url = getUrlAddQuery(window.location.protocol + "//" + window.location.host + window.location.pathname, data);
    window.location.href = url;
  }
}

function initLoginJumpWx(appid, loginType, liveTitle) {
  var redirect_uri = window.location.href;
  redirect_uri = redirect_uri.split("&code")[0];
  if (loginType == "cloudapi" && redirect_uri.indexOf("loginType") == -1) {
    redirect_uri = redirect_uri + "&loginType=cloudapi";
  }
  // window.location.href =
  //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
  //   appid +
  //   "&redirect_uri=" +
  //   encodeURIComponent(redirect_uri) +
  //   "&response_type=code&scope=snsapi_userinfo&state=STATE";
  var redirectUrl = encodeURIComponent(redirect_uri);
  if (globalDirectSeeding && globalDirectSeeding.is_customize_domain == 2 && globalDirectSeeding.is_config_official_account == 2) {
    window.location.href = location.origin + "/login/#/wx-login?appId=" + appid + "&redirectUrl=" + redirectUrl + "&title=" + liveTitle + "&origin=tengface";
  } else {
    window.location.href = "https://login.bbxiuc.cn/login/#/wx-login?appId=" + appid + "&redirectUrl=" + redirectUrl + "&title=" + liveTitle + "&origin=tengface";
  }
}

function initLoginJumpQQ(appid, liveTitle) {
  // var redirect_uri = "https://"+window.location.host+"/index.html"+window.location.search;
  // redirect_uri = redirect_uri.split("&code")[0];
  // alert(redirect_uri)
  // window.location.href =
  //   "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=" +
  //   appid +
  //   "&redirect_uri=" +
  //   encodeURIComponent(redirect_uri) +
  //   "&state=qq&origin=tengface";
  var redirect_uri = window.location.href;
  redirect_uri = redirect_uri.split("&code")[0];
  var redirectUrl = encodeURIComponent(redirect_uri);
  window.location.href = "https://login.bbxiuc.cn/login/#/qq-login?appId=" + appid + "&redirectUrl=" + redirectUrl + "&title=" + liveTitle + "&origin=tengface";
}

function checkPhoneType() {
  var u = navigator.userAgent;
  // 1是安卓机	2 是苹果机	3 未知机型 4 winphone
  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    //安卓手机
    return 1;
  } else if (u.indexOf("iPhone") > -1) {
    //苹果手机
    // window.location.href = "mobile/index.html";
    return 2;
  } else if (u.indexOf("Windows Phone") > -1) {
    //winphone手机
    return 4;
  } else {
    return 3;
  }
}

function bugTicket(id, callback) {
  var that = this;
  _axios2.default.post(baseUrl3() + "/ticket/order", "ds_id=" + ds_id + "&fans_id=" + fans_id + "&coupon_id=" + id).then(function (data) {
    if (data.data.code == "200") {
      weixinPay(data.data.data, callback);
    } else if (data.data.code == "2000") {
      (0, _toast2.default)("抵扣成功");
      callback();
    } else {
      (0, _toast2.default)("购买门票失败！");
    }
  }).catch(function (res) {
    (0, _toast2.default)("购买门票失败！");
  });
}

function weixinPay(p, callback) {
  var that = this;
  console.log(p);

  WeixinJSBridge.invoke("getBrandWCPayRequest", {
    appId: p.appId, //公众号名称，由商户传入
    timeStamp: String(p.timeStamp), //时间戳，自1970年以来的秒数
    nonceStr: p.nonceStr, //随机串
    package: p.package,
    signType: p.signType, //微信签名方式：
    paySign: p.paySign //微信签名
  }, function (res) {
    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回		ok，但并不保证它绝对可靠。
    if (res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
      (0, _toast2.default)("门票购买成功");
      callback();
    }
  });
}

function getCoupon(callback) {
  var that = this;
  _axios2.default.post(baseUrl3() + "/ticket/get_coupon", "ds_id=" + ds_id + "&fans_id=" + fans_id).then(function (data) {
    var data = data.data;
    if (data.code == 200) {
      console.log(data.data);
      callback(data.data);
    }
  }).catch(function (data) {
    console.log("错误" + data);
  });
}

function DrawingCanvas(image) {
  // 创建canvas DOM元素，并设置其宽高和图片一样
  var canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
  canvas.getContext("2d").drawImage(image, 0, 0);
  return canvas;
}

function updateOnlineStatus(ds_id, fans_id, is_live) {
  var params = "ds_id=" + ds_id + "&fans_id=" + fans_id + "&is_live=" + is_live;

  _axios2.default.post(baseUrl() + "/statistics/analysis/updateOnlineStatus", params).then(function (response) {
    console.log(response);
    var data = response.data;
    if (data.code == 200) {
      console.log("updateOnlineStatus1");
    } else {
      console.log("updateOnlineStatus2");
    }
  }).catch(function (error) {
    console.log("updateOnlineStatus3" + error);
  });
}

function getCommentTimes(timeStr) {
  var time = new Date();
  if (timeStr) {
    time = new Date(timeStr);
  }
  var year = time.getFullYear();
  var month = two(time.getMonth() + 1);
  var date = two(time.getDate());
  var hours = two(time.getHours());
  var minutes = two(time.getMinutes());
  var seconds = two(time.getSeconds());

  return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
}

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Vue.js v2.7.14
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' ||
    // $flow-disable-line
    (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' || typeof value === 'boolean';
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null ? '' : Array.isArray(val) || isPlainObject(val) && val.toString === _toString ? JSON.stringify(val, null, 2) : String(val);
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) {
        return map[val.toLowerCase()];
    } : function (val) {
        return map[val];
    };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    var len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) {
        return c ? c.toUpperCase() : '';
    });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) {}
/**
 * Always return false.
 */
var no = function no(a, b, c) {
    return false;
};
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function identity(_) {
    return _;
};
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b) return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return a.length === b.length && a.every(function (e, i) {
                    return looseEqual(e, b[i]);
                });
            } else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            } else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return keysA.length === keysB.length && keysA.every(function (key) {
                    return looseEqual(a[key], b[key]);
                });
            } else {
                /* istanbul ignore next */
                return false;
            }
        } catch (e) {
            /* istanbul ignore next */
            return false;
        }
    } else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    } else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val)) return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    } else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = ['beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed', 'activated', 'deactivated', 'errorCaptured', 'serverPrefetch', 'renderTracked', 'renderTriggered'];

var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: "production" !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: "production" !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj) return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function get() {
                /* istanbul ignore next */
                supportsPassive = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    } catch (e) {}
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function isServerRendering() {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
        } else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) && typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
} else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }();
}

var currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function getCurrentInstance() {
    return currentInstance && { proxy: currentInstance };
}
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) {
        vm = null;
    }
    if (!vm) currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function get() {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}();
var createEmptyVNode = function createEmptyVNode(text) {
    if (text === void 0) {
        text = '';
    }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return _assign.apply(this, arguments);
};

var uid$2 = 0;
var pendingCleanupDeps = [];
var cleanupDeps = function cleanupDeps() {
    for (var i = 0; i < pendingCleanupDeps.length; i++) {
        var dep = pendingCleanupDeps[i];
        dep.subs = dep.subs.filter(function (s) {
            return s;
        });
        dep._pending = false;
    }
    pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */function () {
    function Dep() {
        // pending subs cleanup
        this._pending = false;
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            pendingCleanupDeps.push(this);
        }
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (false) {
                Dep.target.onTrack(_assign({ effect: Dep.target }, info));
            }
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.filter(function (s) {
            return s;
        });
        if (false) {
            // subs aren't sorted in scheduler if not running async
            // we need to sort them now to make sure they fire in correct
            // order
            subs.sort(function (a, b) {
                return a.id - b.id;
            });
        }
        for (var i = 0, l = subs.length; i < l; i++) {
            var sub = subs[i];
            if (false) {
                sub.onTrigger && sub.onTrigger(_assign({ effect: subs[i] }, info));
            }
            sub.update();
        }
    };
    return Dep;
}();
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted) ob.observeArray(inserted);
        // notify change
        if (false) {
            ob.dep.notify({
                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */
                , target: this,
                key: method
            });
        } else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INIITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) {
            shallow = false;
        }
        if (mock === void 0) {
            mock = false;
        }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                } else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        } else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INIITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}();
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (value && hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        return value.__ob__;
    }
    if (shouldObserve && (ssrMockReactivity || !isServerRendering()) && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value.__v_skip /* ReactiveFlags.SKIP */ && !isRef(value) && !(value instanceof VNode)) {
        return new Observer(value, shallow, ssrMockReactivity);
    }
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) && (val === NO_INIITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = !shallow && observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (false) {
                    dep.depend({
                        target: obj,
                        type: "get" /* TrackOpTypes.GET */
                        , key: key
                    });
                } else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (false) {
                customSetter();
            }
            if (setter) {
                setter.call(obj, newVal);
            } else if (getter) {
                // #7981: for accessor properties without setter
                return;
            } else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            } else {
                val = newVal;
            }
            childOb = !shallow && observe(newVal, false, mock);
            if (false) {
                dep.notify({
                    type: "set" /* TriggerOpTypes.SET */
                    , target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value
                });
            } else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || ob && ob.vmCount) {
        "production" !== 'production' && warn('Avoid adding reactive properties to a Vue instance or its root $data ' + 'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (false) {
        ob.dep.notify({
            type: "add" /* TriggerOpTypes.ADD */
            , target: target,
            key: key,
            newValue: val,
            oldValue: undefined
        });
    } else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || ob && ob.vmCount) {
        "production" !== 'production' && warn('Avoid deleting properties on a Vue instance or its root $data ' + '- just set it to null.');
        return;
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (false) {
        ob.dep.notify({
            type: "delete" /* TriggerOpTypes.DELETE */
            , target: target,
            key: key
        });
    } else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}

function reactive(target) {
    makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (false) {
            if (isArray(target)) {
                warn("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
            }
            var existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) {
                warn("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
            }
        }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (false) {
            if (target == null || isPrimitive(target)) {
                warn("value cannot be made reactive: ".concat(String(target)));
            }
            if (isCollectionType(target)) {
                warn("Vue 2 does not support reactive collection types such as Map or Set.");
            }
        }
    }
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
    }
    return !!(value && value.__ob__);
}
function isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) {
        def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
    }
    return value;
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet';
}

/**
 * @internal
 */
var RefFlag = "__v_isRef";
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref$1(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    var ref = {};
    def(ref, RefFlag, true);
    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
    return ref;
}
function triggerRef(ref) {
    if (false) {
        warn("received object is not a triggerable ref.");
    }
    if (false) {
        ref.dep && ref.dep.notify({
            type: "set" /* TriggerOpTypes.SET */
            , target: ref,
            key: 'value'
        });
    } else {
        ref.dep && ref.dep.notify();
    }
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function proxyRefs(objectWithRefs) {
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for (var i = 0; i < keys.length; i++) {
        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    }
    return proxy;
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function get() {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            } else {
                var ob = val && val.__ob__;
                if (ob) ob.dep.depend();
                return val;
            }
        },
        set: function set(value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            } else {
                source[key] = value;
            }
        }
    });
}
function customRef(factory) {
    var dep = new Dep();
    var _a = factory(function () {
        if (false) {
            dep.depend({
                target: ref,
                type: "get" /* TrackOpTypes.GET */
                , key: 'value'
            });
        } else {
            dep.depend();
        }
    }, function () {
        if (false) {
            dep.notify({
                target: ref,
                type: "set" /* TriggerOpTypes.SET */
                , key: 'value'
            });
        } else {
            dep.notify();
        }
    }),
        get = _a.get,
        set = _a.set;
    var ref = {
        get value() {
            return get();
        },
        set value(newVal) {
            set(newVal);
        }
    };
    def(ref, RefFlag, true);
    return ref;
}
function toRefs(object) {
    if (false) {
        warn("toRefs() expects a reactive object but received a plain one.");
    }
    var ret = isArray(object) ? new Array(object.length) : {};
    for (var key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
function toRef(object, key, defaultValue) {
    var val = object[key];
    if (isRef(val)) {
        return val;
    }
    var ref = {
        get value() {
            var val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value(newVal) {
            object[key] = newVal;
        }
    };
    def(ref, RefFlag, true);
    return ref;
}

var rawToReadonlyFlag = "__v_rawToReadonly";
var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function readonly(target) {
    return createReadonly(target, false);
}
function createReadonly(target, shallow) {
    if (!isPlainObject(target)) {
        if (false) {
            if (isArray(target)) {
                warn("Vue 2 does not support readonly arrays.");
            } else if (isCollectionType(target)) {
                warn("Vue 2 does not support readonly collection types such as Map or Set.");
            } else {
                warn("value cannot be made readonly: ".concat(typeof target === 'undefined' ? 'undefined' : _typeof(target)));
            }
        }
        return target;
    }
    if (false) {
        warn("Vue 2 does not support creating readonly proxy for non-extensible object.");
    }
    // already a readonly object
    if (isReadonly(target)) {
        return target;
    }
    // already has a readonly proxy
    var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) {
        return existingProxy;
    }
    var proxy = Object.create(Object.getPrototypeOf(target));
    def(target, existingFlag, proxy);
    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
    if (isRef(target)) {
        def(proxy, RefFlag, true);
    }
    if (shallow || isShallow(target)) {
        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineReadonlyProperty(proxy, target, keys[i], shallow);
    }
    return proxy;
}
function defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function get() {
            var val = target[key];
            return shallow || !isPlainObject(val) ? val : readonly(val);
        },
        set: function set() {
            "production" !== 'production' && warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReadonly(target, true);
}

function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter =  false ? function () {
            warn('Write operation failed: computed value is readonly');
        } : noop;
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = isServerRendering() ? null : new Watcher(currentInstance, getter, noop, { lazy: true });
    if (false) {
        watcher.onTrack = debugOptions.onTrack;
        watcher.onTrigger = debugOptions.onTrigger;
    }
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value() {
            if (watcher) {
                if (watcher.dirty) {
                    watcher.evaluate();
                }
                if (Dep.target) {
                    if (false) {
                        Dep.target.onTrack({
                            effect: Dep.target,
                            target: ref,
                            type: "get" /* TrackOpTypes.GET */
                            , key: 'value'
                        });
                    }
                    watcher.depend();
                }
                return watcher.value;
            } else {
                return getter();
            }
        },
        set value(newVal) {
            setter(newVal);
        }
    };
    def(ref, RefFlag, true);
    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
    return ref;
}

var WATCHER = "watcher";
var WATCHER_CB = "".concat(WATCHER, " callback");
var WATCHER_GETTER = "".concat(WATCHER, " getter");
var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null,  false ? _assign(_assign({}, options), { flush: 'post' }) : { flush: 'post' });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null,  false ? _assign(_assign({}, options), { flush: 'sync' }) : { flush: 'sync' });
}
// initial value for watchers to trigger on undefined initial values
var INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {
        warn("`watch(fn, options?)` signature has been moved to a separate API. " + "Use `watchEffect(fn, options?)` instead. `watch` now only " + "supports `watch(source, cb, options?) signature.");
    }
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? emptyObject : _a,
        immediate = _b.immediate,
        deep = _b.deep,
        _c = _b.flush,
        flush = _c === void 0 ? 'pre' : _c,
        onTrack = _b.onTrack,
        onTrigger = _b.onTrigger;
    if (false) {
        if (immediate !== undefined) {
            warn("watch() \"immediate\" option is only respected when using the " + "watch(source, callback, options?) signature.");
        }
        if (deep !== undefined) {
            warn("watch() \"deep\" option is only respected when using the " + "watch(source, callback, options?) signature.");
        }
    }
    var warnInvalidSource = function warnInvalidSource(s) {
        warn("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") + "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var call = function call(fn, type, args) {
        if (args === void 0) {
            args = null;
        }
        return invokeWithErrorHandling(fn, null, args, instance, type);
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function getter() {
            return source.value;
        };
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = function getter() {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    } else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) {
            return isReactive(s) || isShallow(s);
        });
        getter = function getter() {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                } else if (isReactive(s)) {
                    return traverse(s);
                } else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                } else {
                    "production" !== 'production' && warnInvalidSource(s);
                }
            });
        };
    } else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function getter() {
                return call(source, WATCHER_GETTER);
            };
        } else {
            // no cb -> simple effect
            getter = function getter() {
                if (instance && instance._isDestroyed) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return call(source, WATCHER, [onCleanup]);
            };
        }
    } else {
        getter = noop;
        "production" !== 'production' && warnInvalidSource(source);
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function getter() {
            return traverse(baseGetter_1());
        };
    }
    var cleanup;
    var onCleanup = function onCleanup(fn) {
        cleanup = watcher.onStop = function () {
            call(fn, WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = noop;
        if (!cb) {
            getter();
        } else if (immediate) {
            call(cb, WATCHER_CB, [getter(), isMultiSource ? [] : undefined, onCleanup]);
        }
        return noop;
    }
    var watcher = new Watcher(currentInstance, getter, noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function () {
        if (!watcher.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function (v, i) {
                return hasChanged(v, oldValue[i]);
            }) : hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                call(cb, WATCHER_CB, [newValue,
                // pass undefined as the old value when it's changed for the first time
                oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue, onCleanup]);
                oldValue = newValue;
            }
        } else {
            // watchEffect
            watcher.get();
        }
    };
    if (flush === 'sync') {
        watcher.update = watcher.run;
    } else if (flush === 'post') {
        watcher.post = true;
        watcher.update = function () {
            return queueWatcher(watcher);
        };
    } else {
        // pre
        watcher.update = function () {
            if (instance && instance === currentInstance && !instance._isMounted) {
                // pre-watcher triggered before
                var buffer = instance._preWatchers || (instance._preWatchers = []);
                if (buffer.indexOf(watcher) < 0) buffer.push(watcher);
            } else {
                queueWatcher(watcher);
            }
        };
    }
    if (false) {
        watcher.onTrack = onTrack;
        watcher.onTrigger = onTrigger;
    }
    // initial run
    if (cb) {
        if (immediate) {
            watcher.run();
        } else {
            oldValue = watcher.get();
        }
    } else if (flush === 'post' && instance) {
        instance.$once('hook:mounted', function () {
            return watcher.get();
        });
    } else {
        watcher.get();
    }
    return function () {
        watcher.teardown();
    };
}

var activeEffectScope;
var EffectScope = /** @class */function () {
    function EffectScope(detached) {
        if (detached === void 0) {
            detached = false;
        }
        this.detached = detached;
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) {
            this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            } finally {
                activeEffectScope = currentEffectScope;
            }
        } else if (false) {
            warn("cannot run an inactive effect scope.");
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0,
                l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    };
    return EffectScope;
}();
function effectScope(detached) {
    return new EffectScope(detached);
}
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) {
        scope = activeEffectScope;
    }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    } else if (false) {
        warn("onScopeDispose() is called when there is no active effect scope" + " to be associated with.");
    }
}

function provide(key, value) {
    if (!currentInstance) {
        if (false) {
            warn("provide() can only be used inside setup().");
        }
    } else {
        // TS doesn't allow symbol as index type
        resolveProvided(currentInstance)[key] = value;
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return vm._provided = Object.create(parentProvides);
    } else {
        return existing;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) {
        treatDefaultAsFactory = false;
    }
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        } else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance) : defaultValue;
        } else if (false) {
            warn("injection \"".concat(String(key), "\" not found."));
        }
    } else if (false) {
        warn("inject() can only be used inside setup() or functional components.");
    }
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        } else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
            "production" !== 'production' && warn("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
        } else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        } else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    } else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        } else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs,
        props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (false) {
                var keyInLowerCase = key.toLowerCase();
                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                    tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") + "".concat(formatComponentName(
                    // @ts-expect-error tag is string
                    tag || Ctor), ", but the declared prop name is") + " \"".concat(key, "\". ") + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                }
            }
            checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        } else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children) ? [createTextVNode(children)] : isArray(children) ? normalizeArrayChildren(children) : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean') continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        } else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            } else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        } else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            } else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null,
        i,
        l,
        keys,
        key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    } else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    } else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        } else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (false) {
                warn('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
        }
        nodes = scopedSlotFn(props) || (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    } else {
        nodes = this.$slots[name] || (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    } else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    } else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    } else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    } else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
            "production" !== 'production' && warn('v-bind without argument expects an Object or Array value', this);
        } else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function _loop_1(key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                } else {
                    var type = data.attrs && data.attrs.type;
                    hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    } else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
            "production" !== 'production' && warn('v-on without argument expects an Object value', this);
        } else {
            var on = data.on = data.on ? extend({}, data.on) : {};
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res,
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        } else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        } else if (false) {
            // null is a special value for explicitly removing a binding
            warn("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
        }
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            } else {
                slot.push(child);
            }
        } else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return node.isComment && !node.asyncFactory || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    } else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    } else if (isStable && prevScopedSlots && prevScopedSlots !== emptyObject && key === prevScopedSlots.$key && !hasNormalSlots && !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    } else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function normalized() {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res = res && (typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object' && !isArray(res) ? [res] // single vnode
        : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res && (!vnode || res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
        ? undefined : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () {
        return slots[key];
    };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = vm._setupContext = createSetupContext(vm);
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        } else if (isObject(setupResult)) {
            // bindings
            if (false) {
                warn("setup() should not return VNodes directly - " + "return a render function instead.");
            }
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    } else if (false) {
                        warn("Avoid using variables that start with _ or $ in setup().");
                    }
                }
            } else {
                // exposed for compiled render fn
                var proxy = vm._setupProxy = {};
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        } else if (false) {
            warn("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult === 'undefined' ? 'undefined' : _typeof(setupResult)));
        }
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = vm._attrsProxy = {};
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = vm._listenersProxy = {};
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind(vm.$emit, vm),
        expose: function expose(exposed) {
            if (false) {
                if (exposeCalled) {
                    warn("expose() should be called only once per setup().", vm);
                }
                exposeCalled = true;
            }
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        } else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function get() {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots(vm._slotsProxy = {}, vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useSlots() {
    return getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useAttrs() {
    return getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useListeners() {
    return getContext().listeners;
}
function getContext() {
    if (false) {
        warn("useContext() called without active instance.");
    }
    var vm = currentInstance;
    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    var props = isArray(raw) ? raw.reduce(function (normalized, p) {
        return normalized[p] = {}, normalized;
    }, {}) : raw;
    for (var key in defaults) {
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            } else {
                opt.default = defaults[key];
            }
        } else if (opt === null) {
            props[key] = { default: defaults[key] };
        } else if (false) {
            warn("props default key \"".concat(key, "\" has no corresponding declaration."));
        }
    }
    return props;
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots) : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) {
        return createElement$1(vm, a, b, c, d, false);
    };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) {
        return createElement$1(vm, a, b, c, d, true);
    };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (false) {
        defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
            !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
        }, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
        }, true);
    } else {
        defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options,
            render = _a.render,
            _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
            // There's no need to maintain a stack because all render fns are called
            // separately from one another. Nested component's render fns are called
            // when parent component is patched.
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        } catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (false) {
                try {
                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                } catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                }
            } else {
                vnode = vm._vnode;
            }
        } finally {
            currentRenderingInstance = null;
            setCurrentInstance();
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (false) {
                warn('Multiple root nodes returned from render function. Render function ' + 'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === 'Module') {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = factory.owners = [owner];
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () {
            return remove$2(owners_1, owner);
        });
        var forceRender_1 = function forceRender_1(renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            } else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
            "production" !== 'production' && warn("Failed to resolve async component: ".concat(String(factory)) + (reason ? "\nReason: ".concat(reason) : ''));
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            } else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    } else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1( false ? "timeout (".concat(res_1.timeout, "ms)") : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
        "production" !== 'production' && warn("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (false) {
        warn('Avoid using non-primitive value as key, ' + 'use string/number value instead.', context);
    }
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    } else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
            // platform built-in elements
            if (false) {
                warn("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
            }
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        } else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    } else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    } else if (isDef(vnode)) {
        if (isDef(ns)) applyNS(vnode, ns);
        if (isDef(data)) registerDeepBindings(data);
        return vnode;
    } else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== 'svg')) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function h(type, props, children) {
    if (!currentInstance) {
        "production" !== 'production' && warn("globally imported h() can only be invoked when there is an active " + "component instance, e.g. synchronously in a component's render or setup function.");
    }
    return createElement$1(currentInstance, type, props, children, 2, true);
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while (cur = cur.$parent) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture) return;
                        } catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    } finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) {
                return handleError(e, vm, info + " (Promise/async)");
            });
            res._handled = true;
        }
    } catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
        try {
            return config.errorHandler.call(null, err, vm, info);
        } catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (false) {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    } else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function timerFunc() {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS) setTimeout(noop);
    };
    isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (isNative(MutationObserver) ||
// PhantomJS and iOS 7.x
MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function timerFunc() {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function timerFunc() {
        setImmediate(flushCallbacks);
    };
} else {
    // Fallback to setTimeout.
    timerFunc = function timerFunc() {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            } catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        } else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

function useCssModule(name) {
    if (name === void 0) {
        name = '$style';
    }
    /* istanbul ignore else */
    {
        if (!currentInstance) {
            "production" !== 'production' && warn("useCssModule must be called inside setup()");
            return emptyObject;
        }
        var mod = currentInstance[name];
        if (!mod) {
            "production" !== 'production' && warn("Current instance does not have CSS module named \"".concat(name, "\"."));
            return emptyObject;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    if (!inBrowser && !false) return;
    var instance = currentInstance;
    if (!instance) {
        "production" !== 'production' && warn("useCssVars is called without current active component instance.");
        return;
    }
    watchPostEffect(function () {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for (var key in vars) {
                style.setProperty("--".concat(key), vars[key]);
            }
        }
    });
}

/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader,
        loadingComponent = source.loadingComponent,
        errorComponent = source.errorComponent,
        _a = source.delay,
        delay = _a === void 0 ? 200 : _a,
        timeout = source.timeout,
        // undefined = never times out
    _b = source.suspensible,
        // undefined = never times out
    suspensible = _b === void 0 ? false : _b,
        // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function retry() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function load() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function (err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) {
                return new Promise(function (resolve, reject) {
                    var userRetry = function userRetry() {
                        return resolve(retry());
                    };
                    var userFail = function userFail() {
                        return reject(err);
                    };
                    userOnError(err, userRetry, userFail, retries + 1);
                });
            } else {
                throw err;
            }
        }).then(function (comp) {
            if (thisRequest !== pendingRequest && pendingRequest) {
                return pendingRequest;
            }
            if (false) {
                warn("Async component loader resolved to undefined. " + "If you are using retry(), make sure to return its return value.");
            }
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                comp = comp.default;
            }
            if (false) {
                throw new Error("Invalid async component load result: ".concat(comp));
            }
            return comp;
        }));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}

function createLifeCycle(hookName) {
    return function (fn, target) {
        if (target === void 0) {
            target = currentInstance;
        }
        if (!target) {
            "production" !== 'production' && warn("".concat(formatName(hookName), " is called when there is no active component instance to be ") + "associated with. " + "Lifecycle injection APIs can only be used during execution of setup().");
            return;
        }
        return injectHook(target, hookName, fn);
    };
}
function formatName(name) {
    if (name === 'beforeDestroy') {
        name = 'beforeUnmount';
    } else if (name === 'destroyed') {
        name = 'unmounted';
    }
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = mergeLifecycleHook(options[hookName], fn);
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');
var onRenderTracked = createLifeCycle('renderTracked');
var onRenderTriggered = createLifeCycle('renderTriggered');
var injectErrorCapturedHook = createLifeCycle('errorCaptured');
function onErrorCaptured(hook, target) {
    if (target === void 0) {
        target = currentInstance;
    }
    injectErrorCapturedHook(hook, target);
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.14';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */
function defineComponent(options) {
    return options;
}

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if (!isA && !isObject(val) || val.__v_skip /* ReactiveFlags.SKIP */ || Object.isFrozen(val) || val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--) {
            _traverse(val[i], seen);
        }
    } else if (isRef(val)) {
        _traverse(val.value, seen);
    } else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--) {
            _traverse(val[keys[i]], seen);
        }
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this,
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm ? activeEffectScope : vm ? vm._scope : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (false) {
                this.onTrack = options.onTrack;
                this.onTrigger = options.onTrigger;
            }
        } else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression =  false ? expOrFn.toString() : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        } else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                "production" !== 'production' && warn("Failed watching path: \"".concat(expOrFn, "\" ") + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        } catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            } else {
                throw e;
            }
        } finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        } else if (this.sync) {
            this.run();
        } else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
            // Deep watchers and watchers on Object/Arrays should fire even
            // when the value is the same, because the value may
            // have mutated.
            isObject(value) || this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                } else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}();

var mark;
var measure;
if (false) {
    var perf_1 = inBrowser && window.performance;
    /* istanbul ignore if */
    if (perf_1 &&
    // @ts-ignore
    perf_1.mark &&
    // @ts-ignore
    perf_1.measure &&
    // @ts-ignore
    perf_1.clearMarks &&
    // @ts-ignore
    perf_1.clearMeasures) {
        mark = function mark(tag) {
            return perf_1.mark(tag);
        };
        measure = function measure(name, startTag, endTag) {
            perf_1.measure(name, startTag, endTag);
            perf_1.clearMarks(startTag);
            perf_1.clearMarks(endTag);
            // perf.clearMeasures(name)
        };
    }
}

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        } else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") + "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
            }
        }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        } else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper && wrapper.$vnode && wrapper.$parent && wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (false) {
            /* istanbul ignore if */
            if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) {
                warn('You are using the runtime-only build of Vue where the template ' + 'compiler is not available. Either pre-compile the templates into ' + 'render functions, or use the compiler-included build.', vm);
            } else {
                warn('Failed to mount component: template or render function not defined.', vm);
            }
        }
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (false) {
        updateComponent = function updateComponent() {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:".concat(id);
            var endTag = "vue-perf-end:".concat(id);
            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue ".concat(name, " render"), startTag, endTag);
            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue ".concat(name, " patch"), startTag, endTag);
        };
    } else {
        updateComponent = function updateComponent() {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function before() {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (false) {
        watcherOptions.onTrack = function (e) {
            return callHook$1(vm, 'renderTracked', [e]);
        };
        watcherOptions.onTrigger = function (e) {
            return callHook$1(vm, 'renderTriggered', [e]);
        };
    }
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (false) {
        isUpdatingChildComponent = true;
    }
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key);
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
    vm.$options._renderChildren || // has old static slots
    hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, prevVNode.data && prevVNode.data.attrs || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (false) {
        isUpdatingChildComponent = false;
    }
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive) return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    } else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) {
        setContext = true;
    }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prev = currentInstance;
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    setContext && setCurrentInstance(prev);
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index = queue.length = activatedChildren.length = 0;
    has = {};
    if (false) {
        circular = {};
    }
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
    var performance_1 = window.performance;
    if (performance_1 && typeof performance_1.now === 'function' && getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function getNow() {
            return performance_1.now();
        };
    }
}
var sortCompareFn = function sortCompareFn(a, b) {
    if (a.post) {
        if (!b.post) return 1;
    } else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index = 0; index < queue.length; index++) {
        watcher = queue[index];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
                warn('You may have an infinite update loop ' + (watcher.user ? "in watcher with expression \"".concat(watcher.expression, "\"") : "in a component render function."), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    cleanupDeps();
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    } else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (false) {
            flushSchedulerQueue();
            return;
        }
        nextTick(flushSchedulerQueue);
    }
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption) ? provideOption.call(vm) : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (false) {
                defineReactive(vm, key, result[key], function () {
                    warn("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + "injection being mutated: \"".concat(key, "\""), vm);
                });
            } else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__') continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            } else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault) ? provideDefault.call(vm) : provideDefault;
            } else if (false) {
                warn("Injection \"".concat(key, "\" not found"), vm);
            }
        }
        return result;
    }
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    } else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, _this.$slots = resolveSlots(children, parent));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function get() {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    } else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    } else {
        if (isDef(data.attrs)) mergeProps(props, data.attrs);
        if (isDef(data.props)) mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    } else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (false) {
        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
    }
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function init(vnode, hydrating) {
        if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        } else {
            var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance);
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function prepatch(oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = vnode.componentInstance = oldVnode.componentInstance;
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function insert(vnode) {
        var context = vnode.context,
            componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            } else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function destroy(vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            } else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (false) {
            warn("Invalid Component definition: ".concat(String(Ctor)), context);
        }
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context,
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode,
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function merged(a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = options.model && options.model.prop || 'value';
    var event = options.model && options.model.event || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    } else {
        on[event] = callback;
    }
}

var warn = noop;
var tip = noop;
var generateComponentTrace; // work around flow check
var formatComponentName;
if (false) {
    var hasConsole_1 = typeof console !== 'undefined';
    var classifyRE_1 = /(?:^|[-_])(\w)/g;
    var classify_1 = function classify_1(str) {
        return str.replace(classifyRE_1, function (c) {
            return c.toUpperCase();
        }).replace(/[-_]/g, '');
    };
    warn = function warn(msg, vm) {
        if (vm === void 0) {
            vm = currentInstance;
        }
        var trace = vm ? generateComponentTrace(vm) : '';
        if (config.warnHandler) {
            config.warnHandler.call(null, msg, vm, trace);
        } else if (hasConsole_1 && !config.silent) {
            console.error("[Vue warn]: ".concat(msg).concat(trace));
        }
    };
    tip = function tip(msg, vm) {
        if (hasConsole_1 && !config.silent) {
            console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
        }
    };
    formatComponentName = function formatComponentName(vm, includeFile) {
        if (vm.$root === vm) {
            return '<Root>';
        }
        var options = isFunction(vm) && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm;
        var name = getComponentName(options);
        var file = options.__file;
        if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return (name ? "<".concat(classify_1(name), ">") : "<Anonymous>") + (file && includeFile !== false ? " at ".concat(file) : '');
    };
    var repeat_1 = function repeat_1(str, n) {
        var res = '';
        while (n) {
            if (n % 2 === 1) res += str;
            if (n > 1) str += str;
            n >>= 1;
        }
        return res;
    };
    generateComponentTrace = function generateComponentTrace(vm) {
        if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
                if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    } else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [last, currentRecursiveSequence];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return '\n\nfound in\n\n' + tree.map(function (vm, i) {
                return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm) ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)") : formatComponentName(vm));
            }).join('\n');
        } else {
            return "\n\n(found in ".concat(formatComponentName(vm), ")");
        }
    };
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (false) {
    strats.el = strats.propsData = function (parent, child, vm, key) {
        if (!vm) {
            warn("option \"".concat(key, "\" can only be used during instance ") + 'creation with the `new` keyword.');
        }
        return defaultStrat(parent, child);
    };
}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from, recursive) {
    if (recursive === void 0) {
        recursive = true;
    }
    if (!from) return to;
    var key, toVal, fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__') continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !hasOwn(to, key)) {
            set(to, key, fromVal);
        } else if (toVal !== fromVal && isPlainObject(toVal) && isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    } else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal) ? childVal.call(vm, vm) : childVal;
            var defaultData = isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            } else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            "production" !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
        "production" !== 'production' && assertObjectType(key, childVal, vm);
        return extend(res, childVal);
    } else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch) parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch) childVal = undefined;
    /* istanbul ignore if */
    if (!childVal) return Object.create(parentVal || null);
    if (false) {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal) return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props = strats.methods = strats.inject = strats.computed = function (parentVal, childVal, vm, key) {
    if (childVal && "production" !== 'production') {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal) return childVal;
    var ret = Object.create(null);
    extend(ret, parentVal);
    if (childVal) extend(ret, childVal);
    return ret;
};
strats.provide = function (parentVal, childVal) {
    if (!parentVal) return childVal;
    return function () {
        var ret = Object.create(null);
        mergeData(ret, isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) {
            mergeData(ret, isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
            );
        }
        return ret;
    };
};
/**
 * Default strategy.
 */
var defaultStrat = function defaultStrat(parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn('Invalid component name: "' + name + '". Component names ' + 'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props) return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            } else if (false) {
                warn('props must be strings when using array syntax.');
            }
        }
    } else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    } else if (false) {
        warn("Invalid value for option \"props\": expected an Array or an Object, " + "but got ".concat(toRawType(props), "."), vm);
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject) return;
    var normalized = options.inject = {};
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    } else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val) ? extend({ from: key }, val) : { from: val };
        }
    } else if (false) {
        warn("Invalid value for option \"inject\": expected an Array or an Object, " + "but got ".concat(toRawType(inject), "."), vm);
    }
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn("Invalid value for option \"".concat(name, "\": expected an Object, ") + "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (false) {
        checkComponents(child);
    }
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id)) return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId)) return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId)) return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (false) {
        warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    }
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        } else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (false) {
        assertProp(prop, key, value, vm, absent);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (false) {
        warn('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function' ? def.call(vm) : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) {
        return t;
    });
    if (!valid && haveExpectedTypes) {
        warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    } else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    } else if (expectedType === 'Array') {
        valid = isArray(value);
    } else {
        try {
            valid = value instanceof type;
        } catch (e) {
            warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") + " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && isExplicable(expectedType) && isExplicable(typeof value === 'undefined' ? 'undefined' : _typeof(value)) && !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    } else if (type === 'Number') {
        return "".concat(Number(value));
    } else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) {
        return value.toLowerCase() === elem;
    });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) {
        return elem.toLowerCase() === 'boolean';
    });
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (false) {
    var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' + 'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' + 'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' + 'require' // for Webpack/Browserify
    );
    var warnNonPresent_1 = function warnNonPresent_1(target, key) {
        warn("Property or method \"".concat(key, "\" is not defined on the instance but ") + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    var warnReservedPrefix_1 = function warnReservedPrefix_1(target, key) {
        warn("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") + 'properties starting with "$" or "_" are not proxied in the Vue instance to ' + 'prevent conflicts with Vue internals. ' + 'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
    if (hasProxy_1) {
        var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        config.keyCodes = new Proxy(config.keyCodes, {
            set: function set(target, key, value) {
                if (isBuiltInModifier_1(key)) {
                    warn("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                    return false;
                } else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    var hasHandler_1 = {
        has: function has(target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals_1(key) || typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data);
            if (!has && !isAllowed) {
                if (key in target.$data) warnReservedPrefix_1(target, key);else warnNonPresent_1(target, key);
            }
            return has || !isAllowed;
        }
    };
    var getHandler_1 = {
        get: function get(target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data) warnReservedPrefix_1(target, key);else warnNonPresent_1(target, key);
            }
            return target[key];
        }
    };
    initProxy = function initProxy(vm) {
        if (hasProxy_1) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
            vm._renderProxy = new Proxy(vm, handlers);
        } else {
            vm._renderProxy = vm;
        }
    };
}

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props) initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods) initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    } else {
        var ob = observe(vm._data = {});
        ob && ob.vmCount++;
    }
    if (opts.computed) initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = vm._props = shallowReactive({});
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = vm.$options._propKeys = [];
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function _loop_1(key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
                warn("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
            }
            defineReactive(props, key, value, function () {
                if (!isRoot && !isUpdatingChildComponent) {
                    warn("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + "value. Prop being mutated: \"".concat(key, "\""), vm);
                }
            });
        } else {
            defineReactive(props, key, value);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
        "production" !== 'production' && warn('data functions should return an object:\n' + 'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (false) {
            if (methods && hasOwn(methods, key)) {
                warn("Method \"".concat(key, "\" has already been defined as a data property."), vm);
            }
        }
        if (props && hasOwn(props, key)) {
            "production" !== 'production' && warn("The data property \"".concat(key, "\" is already declared as a prop. ") + "Use prop default value instead.", vm);
        } else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    } catch (e) {
        handleError(e, vm, "data()");
        return {};
    } finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = vm._computedWatchers = Object.create(null);
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (false) {
            warn("Getter is missing for computed property \"".concat(key, "\"."), vm);
        }
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        } else if (false) {
            if (key in vm.$data) {
                warn("The computed property \"".concat(key, "\" is already defined in data."), vm);
            } else if (vm.$options.props && key in vm.$options.props) {
                warn("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
            } else if (vm.$options.methods && key in vm.$options.methods) {
                warn("The computed property \"".concat(key, "\" is already defined as a method."), vm);
            }
        }
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    } else {
        sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : createGetterInvoker(userDef.get) : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (false) {
        sharedPropertyDefinition.set = function () {
            warn("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
        };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (false) {
                    Dep.target.onTrack({
                        effect: Dep.target,
                        target: this,
                        type: "get" /* TrackOpTypes.GET */
                        , key: key
                    });
                }
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (false) {
            if (typeof methods[key] !== 'function') {
                warn("Method \"".concat(key, "\" has type \"").concat(_typeof(methods[key]), "\" in the component definition. ") + "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
                warn("Method \"".concat(key, "\" has already been defined as a prop."), vm);
            }
            if (key in vm && isReserved(key)) {
                warn("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") + "Avoid defining component methods that start with _ or $.");
            }
        }
        vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        } else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (false) {
        dataDef.set = function () {
            warn('Avoid replacing instance root $data. ' + 'Use nested data properties instead.', this);
        };
        propsDef.set = function () {
            warn("$props is readonly.", this);
        };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {
            startTag = "vue-perf-start:".concat(vm._uid);
            endTag = "vue-perf-end:".concat(vm._uid);
            mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        } else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (false) {
            initProxy(vm);
        } else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (false) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue ".concat(vm._name, " init"), startTag, endTag);
        }
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = vm.$options = Object.create(vm.constructor.options);
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified) modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function Vue(options) {
    if (false) {
        warn('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        } else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (false) {
            validateComponentName(name);
        }
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            } else {
                /* istanbul ignore if */
                if (false) {
                    validateComponentName(id);
                }
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    } else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    } else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache,
        keys = keepAliveInstance.keys,
        _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function cacheVNode() {
            var _a = this,
                cache = _a.cache,
                keys = _a.keys,
                vnodeToCache = _a.vnodeToCache,
                keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag,
                    componentInstance = vnodeToCache.componentInstance,
                    componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function created() {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function destroyed() {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) {
                return matches(val, name);
            });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) {
                return !matches(val, name);
            });
        });
    },
    updated: function updated() {
        this.cacheVNode();
    },
    render: function render() {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this,
                include = _a.include,
                exclude = _a.exclude;
            if (
            // not included
            include && (!name_2 || !matches(include, name_2)) ||
            // excluded
            exclude && name_2 && matches(exclude, name_2)) {
                return vnode;
            }
            var _b = this,
                cache = _b.cache,
                keys = _b.keys;
            var key = vnode.key == null ? // same constructor may get registered as different local components
            // so cid alone is not enough (#3269)
            componentOptions.Ctor.cid + (componentOptions.tag ? "::".concat(componentOptions.tag) : '') : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            } else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || slot && slot[0];
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () {
        return config;
    };
    if (false) {
        configDef.set = function () {
            warn('Do not replace the Vue.config object, set individual fields instead.');
        };
    }
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function get() {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function mustUseProp(tag, type, attr) {
    return attr === 'value' && acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function convertEnumeratedValue(key, value) {
    return isFalsyAttrValue(value) || value === 'false' ? 'false' : // allow arbitrary string value for contenteditable
    key === 'contenteditable' && isValidContentEditableValue(value) ? value : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' + 'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' + 'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' + 'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' + 'required,reversed,scoped,seamless,selected,sortable,' + 'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function isXlink(name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function getXlinkProp(name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function isFalsyAttrValue(val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef(parentNode = parentNode.parent)) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? b ? a + ' ' + b : a : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
            if (res) res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res) res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' + 'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' + 'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' + 'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' + 's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' + 'embed,object,param,source,canvas,script,noscript,del,ins,' + 'caption,col,colgroup,table,thead,tbody,td,th,tr,' + 'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' + 'output,progress,select,textarea,' + 'details,dialog,menu,menuitem,summary,' + 'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' + 'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' + 'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isReservedTag = function isReservedTag(tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // http://stackoverflow.com/a/28210364/1070244
        return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
        return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
            "production" !== 'production' && warn('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    } else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createElement: createElement,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    setStyleScope: setStyleScope
});

var ref = {
    create: function create(_, vnode) {
        registerRef(vnode);
    },
    update: function update(oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function destroy(vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref)) return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            } else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    } else {
                        ref.value = [refValue];
                    }
                } else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        } else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        } else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        } else if (false) {
            warn("Invalid template ref type: ".concat(typeof ref === 'undefined' ? 'undefined' : _typeof(ref)));
        }
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        } else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error));
}
function sameInputType(a, b) {
    if (a.tag !== 'input') return true;
    var i;
    var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
    var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
    return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key)) map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules,
        nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function (ignore) {
            return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
        })) && config.isUnknownElement(vnode.tag);
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (false) {
                if (data && data.pre) {
                    creatingElmInVPre++;
                }
                if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
                }
            }
            vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (false) {
                creatingElmInVPre--;
            }
        } else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        } else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef(i = i.hook) && isDef(i = i.init)) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        } else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            } else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (false) {
                checkDuplicateKeys(children);
            }
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        } else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create)) i.create(emptyNode, vnode);
            if (isDef(i.insert)) insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef(i = vnode.fnScopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
        } else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.destroy)) i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i) {
                cbs.destroy[i](vnode);
            }
        }
        if (isDef(i = vnode.children)) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                } else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            } else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef(i_3 = vnode.componentInstance) && isDef(i_3 = i_3._vnode) && isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef(i_3 = vnode.data.hook) && isDef(i_3 = i_3.remove)) {
                i_3(vnode, rm);
            } else {
                rm();
            }
        } else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (false) {
            checkDuplicateKeys(newCh);
        }
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            } else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            } else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                } else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    } else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        } else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                } else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c)) return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = vnode.elm = oldVnode.elm;
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            } else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i) {
                cbs.update[i](oldVnode, vnode);
            }if (isDef(i = data.hook) && isDef(i = i.update)) i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            } else if (isDef(ch)) {
                if (false) {
                    checkDuplicateKeys(ch);
                }
                if (isDef(oldVnode.text)) nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            } else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        } else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.postpatch)) i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        } else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag,
            data = vnode.data,
            children = vnode.children;
        inVPre = inVPre || data && data.pre;
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (false) {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
                return false;
            }
        }
        if (isDef(data)) {
            if (isDef(i = data.hook) && isDef(i = i.init)) i(vnode, true /* hydrating */);
            if (isDef(i = vnode.componentInstance)) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                } else {
                    // v-html and domProps: innerHTML
                    if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    } else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode || !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        } else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
        } else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode)) invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        } else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            } else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        } else if (false) {
                            warn('The client-side rendered virtual DOM tree is not matching ' + 'server-rendered content. This is likely caused by incorrect ' + 'HTML markup, for example nesting block-level elements inside ' + '<p>, or missing <tbody>. Bailing hydration and performing ' + 'full client-side render.');
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue,
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                for (var i_10 = 1; i_10 < insert_1.fns.length; i_10++) {
                                    insert_1.fns[i_10]();
                                }
                            }
                        } else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                } else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        } else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function callInsert() {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        } else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef
                };
            } else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.'));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        } catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            } else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    } else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        } else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    } else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    } else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        } else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    } else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    } else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE && !isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && value !== '' && !el.__ieph) {
            var blocker_1 = function blocker_1(e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass = {
    create: updateClass,
    update: updateClass
};

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
            // event is fired after handler attachment
            e.timeStamp >= attachedTimestamp_1 ||
            // bail for environments that have buggy event.timeStamp implementations
            // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
            // #9681 QtWebEngine event.timeStamp is negative value
            e.timeStamp <= 0 ||
            // #9448 bail if event is fired in another document in a multi-page
            // electron/nw.js app, since event.timeStamp will be using a different
            // starting reference
            e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name,
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function destroy(vnode) {
        return updateDOMListeners(vnode, emptyNode);
    }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children) vnode.children.length = 0;
            if (cur === oldProps[key]) continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        } else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            } catch (e) {}
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
        //@ts-expect-error
        !elm.composing && (elm.tagName === 'OPTION' || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal))
    );
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    } catch (e) {}
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if (styleData = normalizeStyleData(vnode.data)) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (parentNode = parentNode.parent) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function setProp(el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    } else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    } else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        } else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        if (cur !== oldStyle[name]) {
            // ie9 setting to null has no effect, must use empty string
            setProp(el, name, cur == null ? '' : cur);
        }
    }
}
var style = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE).forEach(function (c) {
                return el.classList.add(c);
            });
        } else {
            el.classList.add(cls);
        }
    } else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE).forEach(function (c) {
                return el.classList.remove(c);
            });
        } else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    } else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        } else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if ((typeof def === 'undefined' ? 'undefined' : _typeof(def)) === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    } else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : /* istanbul ignore next */function ( /* istanbul ignore next */fn) {
    return fn();
};
function nextFrame(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType),
        type = _a.type,
        timeout = _a.timeout,
        propCount = _a.propCount;
    if (!type) return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function end() {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function onEnd(e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css,
        type = data.type,
        enterClass = data.enterClass,
        enterToClass = data.enterToClass,
        enterActiveClass = data.enterActiveClass,
        appearClass = data.appearClass,
        appearToClass = data.appearToClass,
        appearActiveClass = data.appearActiveClass,
        beforeEnter = data.beforeEnter,
        enter = data.enter,
        afterEnter = data.afterEnter,
        enterCancelled = data.enterCancelled,
        beforeAppear = data.beforeAppear,
        appear = data.appear,
        afterAppear = data.afterAppear,
        appearCancelled = data.appearCancelled,
        duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? isFunction(appear) ? appear : enter : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (false) {
        checkDuration(explicitEnterDuration, 'enter', vnode);
    }
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        } else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    });
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    } else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css,
        type = data.type,
        leaveClass = data.leaveClass,
        leaveToClass = data.leaveToClass,
        leaveActiveClass = data.leaveActiveClass,
        beforeLeave = data.beforeLeave,
        leave = data.leave,
        afterLeave = data.afterLeave,
        leaveCancelled = data.leaveCancelled,
        delayLeave = data.delayLeave,
        duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (false) {
        checkDuration(explicitLeaveDuration, 'leave', vnode);
    }
    var cb = el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        } else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    });
    if (delayLeave) {
        delayLeave(performLeave);
    } else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        } else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn("<transition> explicit ".concat(name, " duration is not a valid number - ") + "got ".concat(JSON.stringify(val), "."), vnode.context);
    } else if (isNaN(val)) {
        warn("<transition> explicit ".concat(name, " duration is NaN - ") + 'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    } else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser ? {
    create: _enter,
    activate: _enter,
    remove: function remove(vnode, rm) {
        /* istanbul ignore else */
        if (vnode.data.show !== true) {
            // @ts-expect-error
            leave(vnode, rm);
        } else {
            rm();
        }
    }
} : {};

var platformModules = [attrs, klass, events, domProps, style, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function inserted(el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            } else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function componentUpdated(el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = el._vOptions = [].map.call(el.options, getValue);
            if (curOptions_1.some(function (o, i) {
                return !looseEqual(o, prevOptions_1[i]);
            })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple ? binding.value.some(function (v) {
                    return hasNoMatchingOption(v, curOptions_1);
                }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        "production" !== 'production' && warn("<select multiple v-model=\"".concat(binding.expression, "\"> ") + "expects an Array value for its binding, but got ".concat(Object.prototype.toString.call(value).slice(8, -1)), vm);
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        } else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) {
        return !looseEqual(o, value);
    });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
}
var show = {
    bind: function bind(el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        } else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function update(el, _a, vnode) {
        var value = _a.value,
            oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue) return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            } else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        } else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    } else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while (vnode = vnode.parent) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function isNotTextNode(c) {
    return c.tag || isAsyncPlaceholder(c);
};
var isVShowDirective = function isVShowDirective(d) {
    return d.name === 'show';
};
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function render(h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (false) {
            warn('<transition> can only be used on a single element. Use ' + '<transition-group> for lists.', this.$parent);
        }
        var mode = this.mode;
        // warn invalid mode
        if (false) {
            warn('invalid <transition> mode: ' + mode, this.$parent);
        }
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
        var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) &&
        // #6687 component root is a comment node
        !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = oldChild.data.transition = extend({}, data);
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            } else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function performLeave() {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function beforeMount() {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function render(h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = this.prevChildren = this.children;
        var rawChildren = this.$slots.default || [];
        var children = this.children = [];
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                } else if (false) {
                    var opts = c.componentOptions;
                    var name_1 = opts ? getComponentName(opts.Ctor.options) || opts.tag || '' : c.tag;
                    warn("<transition-group> children must be keyed: <".concat(name_1, ">"));
                }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                } else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function updated() {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                });
            }
        });
    },
    methods: {
        hasMove: function hasMove(el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return this._hasMove = info.hasTransform;
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            } else if (false) {
                // @ts-expect-error
                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
            }
        }
        if (false) {
            // @ts-expect-error
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
        }
    }, 0);
}

exports.EffectScope = EffectScope;
exports.computed = computed;
exports.customRef = customRef;
exports.default = Vue;
exports.defineAsyncComponent = defineAsyncComponent;
exports.defineComponent = defineComponent;
exports.del = del;
exports.effectScope = effectScope;
exports.getCurrentInstance = getCurrentInstance;
exports.getCurrentScope = getCurrentScope;
exports.h = h;
exports.inject = inject;
exports.isProxy = isProxy;
exports.isReactive = isReactive;
exports.isReadonly = isReadonly;
exports.isRef = isRef;
exports.isShallow = isShallow;
exports.markRaw = markRaw;
exports.mergeDefaults = mergeDefaults;
exports.nextTick = nextTick;
exports.onActivated = onActivated;
exports.onBeforeMount = onBeforeMount;
exports.onBeforeUnmount = onBeforeUnmount;
exports.onBeforeUpdate = onBeforeUpdate;
exports.onDeactivated = onDeactivated;
exports.onErrorCaptured = onErrorCaptured;
exports.onMounted = onMounted;
exports.onRenderTracked = onRenderTracked;
exports.onRenderTriggered = onRenderTriggered;
exports.onScopeDispose = onScopeDispose;
exports.onServerPrefetch = onServerPrefetch;
exports.onUnmounted = onUnmounted;
exports.onUpdated = onUpdated;
exports.provide = provide;
exports.proxyRefs = proxyRefs;
exports.reactive = reactive;
exports.readonly = readonly;
exports.ref = ref$1;
exports.set = set;
exports.shallowReactive = shallowReactive;
exports.shallowReadonly = shallowReadonly;
exports.shallowRef = shallowRef;
exports.toRaw = toRaw;
exports.toRef = toRef;
exports.toRefs = toRefs;
exports.triggerRef = triggerRef;
exports.unref = unref;
exports.useAttrs = useAttrs;
exports.useCssModule = useCssModule;
exports.useCssVars = useCssVars;
exports.useListeners = useListeners;
exports.useSlots = useSlots;
exports.version = version;
exports.watch = watch;
exports.watchEffect = watchEffect;
exports.watchPostEffect = watchPostEffect;
exports.watchSyncEffect = watchSyncEffect;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(132).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isServer = exports.use = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _use = __webpack_require__(140);

Object.defineProperty(exports, 'use', {
  enumerable: true,
  get: function get() {
    return _use.use;
  }
});
exports.noop = noop;
exports.isDef = isDef;
exports.isObj = isObj;
exports.get = get;
exports.camelize = camelize;
exports.isAndroid = isAndroid;
exports.isIOS = isIOS;
exports.range = range;
exports.isInDocument = isInDocument;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = exports.isServer = _vue2.default.prototype.$isServer;
function noop() {}
function isDef(value) {
  return value !== undefined && value !== null;
}
function isObj(x) {
  var type = typeof x === 'undefined' ? 'undefined' : _typeof(x);
  return x !== null && (type === 'object' || type === 'function');
}
function get(object, path) {
  var keys = path.split('.');
  var result = object;
  keys.forEach(function (key) {
    result = isDef(result[key]) ? result[key] : '';
  });
  return result;
}
var camelizeRE = /-(\w)/g;
function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c.toUpperCase();
  });
}
function isAndroid() {
  /* istanbul ignore next */
  return isServer ? false : /android/.test(navigator.userAgent.toLowerCase());
}
function isIOS() {
  /* istanbul ignore next */
  return isServer ? false : /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}
function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
function isInDocument(element) {
  return document.body.contains(element);
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Toast = __webpack_require__(139);

var _Toast2 = _interopRequireDefault(_Toast);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  type: 'text',
  mask: false,
  value: true,
  message: '',
  className: '',
  onClose: null,
  duration: 3000,
  position: 'middle',
  forbidClick: false,
  loadingType: 'circular',
  getContainer: 'body',
  overlayStyle: null
};

var parseOptions = function parseOptions(message) {
  return (0, _utils.isObj)(message) ? message : {
    message: message
  };
};

var queue = [];
var multiple = false;

var currentOptions = (0, _extends3.default)({}, defaultOptions);

function createInstance() {
  /* istanbul ignore if */
  if (_utils.isServer) {
    return {};
  }

  if (!queue.length || multiple) {
    var toast = new (_vue2.default.extend(_Toast2.default))({
      el: document.createElement('div')
    });
    queue.push(toast);
  }

  return queue[queue.length - 1];
} // transform toast options to popup props


function transformer(options) {
  options.overlay = options.mask;
  return options;
}

function Toast(options) {
  if (options === void 0) {
    options = {};
  }

  var toast = createInstance(); // should add z-index if previous toast has not disappeared

  if (toast.value) {
    toast.updateZIndex();
  }

  options = (0, _extends3.default)({}, currentOptions, parseOptions(options), {
    clear: function clear() {
      toast.value = false;

      if (options.onClose) {
        options.onClose();
      }

      if (multiple && !_utils.isServer) {
        clearTimeout(toast.timer);
        queue = queue.filter(function (item) {
          return item !== toast;
        });
        var parent = toast.$el.parentNode;

        if (parent) {
          parent.removeChild(toast.$el);
        }

        toast.$destroy();
      }
    }
  });

  (0, _extends3.default)(toast, transformer(options));

  clearTimeout(toast.timer);

  if (options.duration > 0) {
    toast.timer = setTimeout(function () {
      toast.clear();
    }, options.duration);
  }

  return toast;
}

var createMethod = function createMethod(type) {
  return function (options) {
    return Toast((0, _extends3.default)({
      type: type
    }, parseOptions(options)));
  };
};

['loading', 'success', 'fail'].forEach(function (method) {
  Toast[method] = createMethod(method);
});

Toast.clear = function (all) {
  if (queue.length) {
    if (all) {
      queue.forEach(function (toast) {
        toast.clear();
      });
      queue = [];
    } else if (!multiple) {
      queue[0].clear();
    } else {
      queue.shift().clear();
    }
  }
};

Toast.setDefaultOptions = function (options) {
  (0, _extends3.default)(currentOptions, options);
};

Toast.resetDefaultOptions = function () {
  currentOptions = (0, _extends3.default)({}, defaultOptions);
};

Toast.allowMultiple = function (value) {
  if (value === void 0) {
    value = true;
  }

  multiple = value;
};

Toast.install = function () {
  _vue2.default.use(_Toast2.default);
};

_vue2.default.prototype.$toast = Toast;
exports.default = Toast;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(32);

__webpack_require__(152);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(149);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./base.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./base.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(150);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//这JS用来保存数据
exports.default = {
	setInitData: setInitData,
	getInitData: getInitData,
	isShowQRimg: isShowQRimg,
	passwordedWatch: passwordedWatch,
	verifyCode: verifyCode,
	fans_id: fans_id,
	header: header,
	identifierNick: identifierNick,
	userSig: userSig,
	real_auth: real_auth,
	status: status,
	loginCode: loginCode,
	setUserData: setUserData,
	getUserData: getUserData
};


var loginCode = "";

var fans_id = 0;
var header = "";
var identifierNick = "";
var userSig = "";
var real_auth = "";
var status = "";

//二维码是否显示了一次
var isShowQRimg = false;
//是否已经输入过密码
var passwordedWatch = false;

var verifyCode = '';

function setInitData(data) {
	sessionStorage.setItem('initData', JSON.stringify(data));
}
function getInitData() {
	var initData = JSON.parse(sessionStorage.getItem('initData'));
	if (initData == null) {
		return false;
	} else {
		return initData;
	}
}
function setUserData(data) {
	sessionStorage.setItem('userData', JSON.stringify(data));
}
function getUserData() {
	var userData = JSON.parse(sessionStorage.getItem('userData'));
	if (userData == null) {
		return false;
	} else {
		return userData;
	}
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _extends;
function _extends() {
  exports.default = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportsPassive = undefined;
exports.on = on;
exports.off = off;
exports.stopPropagation = stopPropagation;
exports.preventDefault = preventDefault;

var _ = __webpack_require__(5);

var supportsPassive = exports.supportsPassive = false; /* eslint-disable no-empty */

/* eslint-disable getter-return */

/* eslint-disable import/no-mutable-exports */


if (!_.isServer) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', {
      get: function get() {
        /* istanbul ignore next */
        exports.supportsPassive = supportsPassive = true;
      }
    });
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

function on(target, event, handler, passive) {
  if (passive === void 0) {
    passive = false;
  }

  if (!_.isServer) {
    target.addEventListener(event, handler, supportsPassive ? {
      capture: false,
      passive: passive
    } : false);
  }
}
function off(target, event, handler) {
  if (!_.isServer) {
    target.removeEventListener(event, handler);
  }
}
function stopPropagation(event) {
  event.stopPropagation();
}
function preventDefault(event, isStopPropagation) {
  /* istanbul ignore else */
  if (typeof event.cancelable !== 'boolean' || event.cancelable) {
    event.preventDefault();
  }

  if (isStopPropagation) {
    stopPropagation(event);
  }
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__(62);
var isBuffer = __webpack_require__(155);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }return a;
  }, _extends.apply(this, arguments);
}var normalMerge = ["attrs", "props", "domProps"],
    toArrayMerge = ["class", "style", "directives"],
    functionalMerge = ["on", "nativeOn"],
    mergeJsxProps = function mergeJsxProps(a) {
  return a.reduce(function (c, a) {
    for (var b in a) {
      if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
        var d = c[b] instanceof Array ? c[b] : [c[b]],
            e = a[b] instanceof Array ? a[b] : [a[b]];c[b] = [].concat(d, e);
      } else if (-1 !== functionalMerge.indexOf(b)) {
        for (var f in a[b]) {
          if (c[b][f]) {
            var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
                h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];c[b][f] = [].concat(g, h);
          } else c[b][f] = a[b][f];
        }
      } else if ("hook" === b) for (var i in a[b]) {
        c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];
      } else c[b] = a[b];
    }return c;
  }, {});
},
    mergeFn = function mergeFn(a, b) {
  return function () {
    a && a.apply(this, arguments), b && b.apply(this, arguments);
  };
};module.exports = mergeJsxProps;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inherit = inherit;
exports.emit = emit;
exports.mount = mount;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inheritKey = ['ref', 'style', 'class', 'attrs', 'nativeOn', 'directives', 'staticClass', 'staticStyle'];
var mapInheritKey = {
  nativeOn: 'on'
}; // inherit partial context, map nativeOn to on

function inherit(context, inheritListeners) {
  var result = inheritKey.reduce(function (obj, key) {
    if (context.data[key]) {
      obj[mapInheritKey[key] || key] = context.data[key];
    }

    return obj;
  }, {});

  if (inheritListeners) {
    result.on = result.on || {};

    (0, _extends3.default)(result.on, context.data.on);
  }

  return result;
} // emit event

function emit(context, eventName) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var listeners = context.listeners[eventName];

  if (listeners) {
    if (Array.isArray(listeners)) {
      listeners.forEach(function (listener) {
        listener.apply(void 0, args);
      });
    } else {
      listeners.apply(void 0, args);
    }
  }
} // mount functional component

function mount(Component, data) {
  var instance = new _vue2.default({
    el: document.createElement('div'),
    props: Component.props,
    render: function render(h) {
      return h(Component, (0, _extends3.default)({
        props: this.$props
      }, data));
    }
  });
  document.body.appendChild(instance.$el);
  return instance;
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _directive = __webpack_require__(189);

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_directive2.default.install = function (Vue) {
  if (false) {
    console.warn('[Vant] Waterfall is deprecated, please use List component instread');
  }

  Vue.directive('WaterfallLower', (0, _directive2.default)('lower'));
  Vue.directive('WaterfallUpper', (0, _directive2.default)('upper'));
};

exports.default = _directive2.default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(208);
var parse = __webpack_require__(219);
var formats = __webpack_require__(53);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _popup = __webpack_require__(30);

var _use = (0, _utils.use)('popup'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  mixins: [_popup.PopupMixin],
  props: {
    position: String,
    transition: String,
    overlay: {
      type: Boolean,
      "default": true
    },
    closeOnClickOverlay: {
      type: Boolean,
      "default": true
    }
  },
  render: function render(h) {
    var _this = this,
        _bem;

    if (!this.shouldRender) {
      return;
    }

    var position = this.position;

    var emit = function emit(event) {
      return function () {
        return _this.$emit(event);
      };
    };

    var transitionName = this.transition || (position ? "van-popup-slide-" + position : 'van-fade');
    return h("transition", {
      "attrs": {
        "name": transitionName
      },
      "on": {
        "afterEnter": emit('opened'),
        "afterLeave": emit('closed')
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "class": bem((_bem = {}, _bem[position] = position, _bem))
    }, [this.slots()])]);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

var _router = __webpack_require__(78);

var _loading = __webpack_require__(24);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('button'),
    sfc = _use[0],
    bem = _use[1];

function Button(h, props, slots, ctx) {
  var tag = props.tag,
      type = props.type,
      disabled = props.disabled,
      loading = props.loading,
      hairline = props.hairline,
      loadingText = props.loadingText;

  var onClick = function onClick(event) {
    if (!loading && !disabled) {
      (0, _functional.emit)(ctx, 'click', event);
      (0, _router.functionalRoute)(ctx);
    }
  };

  var onTouchstart = function onTouchstart(event) {
    (0, _functional.emit)(ctx, 'touchstart', event);
  };

  var classes = [bem([type, props.size, {
    loading: loading,
    disabled: disabled,
    hairline: hairline,
    block: props.block,
    plain: props.plain,
    round: props.round,
    square: props.square,
    'bottom-action': props.bottomAction
  }]), {
    'van-hairline--surround': hairline
  }];
  return h(tag, (0, _babelHelperVueJsxMergeProps2.default)([{
    "class": classes,
    "attrs": {
      "type": props.nativeType,
      "disabled": disabled
    },
    "on": {
      "click": onClick,
      "touchstart": onTouchstart
    }
  }, (0, _functional.inherit)(ctx)]), [loading ? [h(_loading2.default, {
    "attrs": {
      "size": props.loadingSize,
      "color": type === 'default' ? undefined : ''
    }
  }), loadingText && h("span", {
    "class": bem('loading-text')
  }, [loadingText])] : h("span", {
    "class": bem('text')
  }, [slots["default"] ? slots["default"]() : props.text])]);
}

Button.props = (0, _extends3.default)({}, _router.routeProps, {
  text: String,
  block: Boolean,
  plain: Boolean,
  round: Boolean,
  square: Boolean,
  loading: Boolean,
  hairline: Boolean,
  disabled: Boolean,
  nativeType: String,
  loadingText: String,
  bottomAction: Boolean,
  tag: {
    type: String,
    "default": 'button'
  },
  type: {
    type: String,
    "default": 'default'
  },
  size: {
    type: String,
    "default": 'normal'
  },
  loadingSize: {
    type: String,
    "default": '20px'
  }
});
exports.default = sfc(Button);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(32);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

var _info = __webpack_require__(148);

var _info2 = _interopRequireDefault(_info);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('icon'),
    sfc = _use[0];

function isImage(name) {
  return name ? name.indexOf('/') !== -1 : false;
}

function Icon(h, props, slots, ctx) {
  var urlIcon = isImage(props.name);
  return h(props.tag, (0, _babelHelperVueJsxMergeProps2.default)([{
    "class": [props.classPrefix, urlIcon ? 'van-icon--image' : props.classPrefix + "-" + props.name],
    "style": {
      color: props.color,
      fontSize: props.size
    }
  }, (0, _functional.inherit)(ctx, true)]), [slots["default"] && slots["default"](), urlIcon && h("img", {
    "attrs": {
      "src": props.name
    }
  }), h(_info2.default, {
    "attrs": {
      "info": props.info
    }
  })]);
}

Icon.props = {
  name: String,
  size: String,
  color: String,
  info: [String, Number],
  tag: {
    type: String,
    "default": 'i'
  },
  classPrefix: {
    type: String,
    "default": 'van-icon'
  }
};
exports.default = sfc(Icon);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('loading'),
    sfc = _use[0],
    bem = _use[1];

var DEFAULT_COLOR = '#c9c9c9';

function Loading(h, props, slots, ctx) {
  var color = props.color,
      size = props.size,
      type = props.type;
  var colorType = color === 'white' || color === 'black' ? color : '';
  var style = {
    color: color === 'black' ? DEFAULT_COLOR : color,
    width: size,
    height: size
  };
  var Spin = [];

  if (type === 'spinner') {
    for (var i = 0; i < 12; i++) {
      Spin.push(h("i"));
    }
  }

  var Circular = type === 'circular' && h("svg", {
    "class": bem('circular'),
    "attrs": {
      "viewBox": "25 25 50 50"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })]);
  return h("div", (0, _babelHelperVueJsxMergeProps2.default)([{
    "class": bem([type, colorType]),
    "style": style
  }, (0, _functional.inherit)(ctx, true)]), [h("span", {
    "class": bem('spinner', type)
  }, [Spin, Circular])]);
}

Loading.props = {
  size: String,
  type: {
    type: String,
    "default": 'circular'
  },
  color: {
    type: String,
    "default": DEFAULT_COLOR
  }
};
exports.default = sfc(Loading);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var QRMode = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
};

var QRErrorCorrectionLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
};

var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7

  // QRMode: 1,2,4,8
  // QRErrorCorrectionLevel: 0,1,2,3
};var QRCapacity = {
  "Numeric": {
    "0": ["34", "63", "101", "149", "202", "255", "293", "365", "432", "513", "604", "691", "796", "871", "991", "1082", "1212", "1346", "1500", "1600", "1708", "1872", "2059", "2188", "2395", "2544", "2701", "2857", "3035", "3289", "3486", "3693", "3909", "4134", "4343", "4588", "4775", "5039", "5313", "5596"],
    "1": ["41", "77", "127", "187", "255", "322", "370", "461", "552", "652", "772", "883", "1022", "1101", "1250", "1408", "1548", "1725", "1903", "2061", "2232", "2409", "2620", "2812", "3057", "3283", "3517", "3669", "3909", "4158", "4417", "4686", "4965", "5253", "5529", "5836", "6153", "6479", "6743", "7089"],
    "2": ["17", "34", "58", "82", "106", "139", "154", "202", "235", "288", "331", "374", "427", "468", "530", "602", "674", "746", "813", "919", "969", "1056", "1108", "1228", "1286", "1425", "1501", "1581", "1677", "1782", "1897", "2022", "2157", "2301", "2361", "2524", "2625", "2735", "2927", "3057"],
    "3": ["27", "48", "77", "111", "144", "178", "207", "259", "312", "364", "427", "489", "580", "621", "703", "775", "876", "948", "1063", "1159", "1224", "1358", "1468", "1588", "1718", "1804", "1933", "2085", "2181", "2358", "2473", "2670", "2805", "2949", "3081", "3244", "3417", "3599", "3791", "3993"]
  },
  "Alphanumeric": {
    "0": ["20", "38", "61", "90", "122", "154", "178", "221", "262", "311", "366", "419", "483", "528", "600", "656", "734", "816", "909", "970", "1035", "1134", "1248", "1326", "1451", "1542", "1637", "1732", "1839", "1994", "2113", "2238", "2369", "2506", "2632", "2780", "2894", "3054", "3220", "3391"],
    "1": ["25", "47", "77", "114", "154", "195", "224", "279", "335", "395", "468", "535", "619", "667", "758", "854", "938", "1046", "1153", "1249", "1352", "1460", "1588", "1704", "1853", "1990", "2132", "2223", "2369", "2520", "2677", "2840", "3009", "3183", "3351", "3537", "3729", "3927", "4087", "4296"],
    "2": ["10", "20", "35", "50", "64", "84", "93", "122", "143", "174", "200", "227", "259", "283", "321", "365", "408", "452", "493", "557", "587", "640", "672", "744", "779", "864", "910", "958", "1016", "1080", "1150", "1226", "1307", "1394", "1431", "1530", "1591", "1658", "1774", "1852"],
    "3": ["16", "29", "47", "67", "87", "108", "125", "157", "189", "221", "259", "296", "352", "376", "426", "470", "531", "574", "644", "702", "742", "823", "890", "963", "1041", "1094", "1172", "1263", "1322", "1429", "1499", "1618", "1700", "1787", "1867", "1966", "2071", "2181", "2298", "2420"]
  },
  "Byte": {
    "0": ["14", "26", "42", "62", "84", "106", "122", "152", "180", "213", "251", "287", "331", "362", "412", "450", "504", "560", "624", "666", "711", "779", "857", "911", "997", "1059", "1125", "1190", "1264", "1370", "1452", "1538", "1628", "1722", "1809", "1911", "1989", "2099", "2213", "2331"],
    "1": ["17", "32", "53", "78", "106", "134", "154", "192", "230", "271", "321", "367", "425", "458", "520", "586", "644", "718", "792", "858", "929", "1003", "1091", "1171", "1273", "1367", "1465", "1528", "1628", "1732", "1840", "1952", "2068", "2188", "2303", "2431", "2563", "2699", "2809", "2953"],
    "2": ["7", "14", "24", "34", "44", "58", "64", "84", "98", "119", "137", "155", "177", "194", "220", "250", "280", "310", "338", "382", "403", "439", "461", "511", "535", "593", "625", "658", "698", "742", "790", "842", "898", "958", "983", "1051", "1093", "1139", "1219", "1273"],
    "3": ["11", "20", "32", "46", "60", "74", "86", "108", "130", "151", "177", "203", "241", "258", "292", "322", "364", "394", "442", "482", "509", "565", "611", "661", "715", "751", "805", "868", "908", "982", "1030", "1112", "1168", "1228", "1283", "1351", "1423", "1499", "1579", "1663"]
  },
  "Kanji": {
    "0": ["8", "16", "26", "38", "52", "65", "75", "93", "111", "131", "155", "177", "204", "223", "254", "277", "310", "345", "384", "410", "438", "480", "528", "561", "614", "652", "692", "732", "778", "843", "894", "947", "1002", "1060", "1113", "1176", "1224", "1292", "1362", "1435"],
    "1": ["10", "20", "32", "48", "65", "82", "95", "118", "141", "167", "198", "226", "262", "282", "320", "361", "397", "442", "488", "528", "572", "618", "672", "721", "784", "842", "902", "940", "1002", "1066", "1132", "1201", "1273", "1347", "1417", "1496", "1577", "1661", "1729", "1817"],
    "2": ["4", "8", "15", "21", "27", "36", "39", "52", "60", "74", "85", "96", "109", "120", "136", "154", "173", "191", "208", "235", "248", "270", "284", "315", "330", "365", "385", "405", "430", "457", "486", "518", "553", "590", "605", "647", "673", "701", "750", "784"],
    "3": ["7", "12", "20", "28", "37", "45", "53", "66", "80", "93", "109", "125", "149", "159", "180", "198", "224", "243", "272", "297", "314", "348", "376", "407", "440", "462", "496", "534", "559", "604", "634", "684", "719", "756", "790", "832", "876", "923", "972", "1024"]
  }
};

var PAD0 = 0xEC;
var PAD1 = 0x11;

var RS_BLOCK_TABLE = [

// L
// M
// Q
// H

// 1
[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9],

// 2
[1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16],

// 3
[1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13],

// 4
[1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9],

// 5
[1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12],

// 6
[2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15],

// 7
[2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14],

// 8
[2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15],

// 9
[2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13],

// 10
[2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16],

// 11
[4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13],

// 12
[2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15],

// 13
[4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12],

// 14
[3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13],

// 15
[5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12, 7, 37, 13],

// 16
[5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16],

// 17
[1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15],

// 18
[5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15],

// 19
[3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14],

// 20
[3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16],

// 21
[4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17],

// 22
[2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13],

// 23
[4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16],

// 24
[6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17],

// 25
[8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16],

// 26
[10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17],

// 27
[8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16],

// 28
[3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16],

// 29
[7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16],

// 30
[5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16],

// 31
[13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16],

// 32
[17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16],

// 33
[17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16],

// 34
[13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17],

// 35
[12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16],

// 36
[6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16],

// 37
[17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16],

// 38
[4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16],

// 39
[20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16],

// 40
[19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];

function Qrrsblock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}

function getRsBlockTable(typeNumber, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case QRErrorCorrectionLevel.L:
      return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
    case QRErrorCorrectionLevel.M:
      return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
    case QRErrorCorrectionLevel.Q:
      return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
    case QRErrorCorrectionLevel.H:
      return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
    default:
      return undefined;
  }
}

var QRRSBlock = {
  getRSBlocks: function getRSBlocks(typeNumber, errorCorrectionLevel) {
    var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
    if (typeof rsBlock === 'undefined') {
      throw new Error('bad rs block @ typeNumber:' + typeNumber + '/errorCorrectionLevel:' + errorCorrectionLevel);
    }

    var length = rsBlock.length / 3;
    var list = [];

    for (var i = 0; i < length; i += 1) {
      var count = rsBlock[i * 3 + 0];
      var totalCount = rsBlock[i * 3 + 1];
      var dataCount = rsBlock[i * 3 + 2];

      for (var j = 0; j < count; j += 1) {
        list.push(new Qrrsblock(totalCount, dataCount));
      }
    }

    return list;
  }
};

var EXP_TABLE = new Array(256);
var LOG_TABLE = new Array(256);
// initialize tables
for (var i = 0; i < 8; i += 1) {
  EXP_TABLE[i] = 1 << i;
}
for (var _i = 8; _i < 256; _i += 1) {
  EXP_TABLE[_i] = EXP_TABLE[_i - 4] ^ EXP_TABLE[_i - 5] ^ EXP_TABLE[_i - 6] ^ EXP_TABLE[_i - 8];
}
for (var _i2 = 0; _i2 < 255; _i2 += 1) {
  LOG_TABLE[EXP_TABLE[_i2]] = _i2;
}

var QRMath = {
  glog: function glog(n) {
    if (n < 1) {
      throw new Error('glog(' + n + ')');
    }

    return LOG_TABLE[n];
  },
  gexp: function gexp(n) {
    while (n < 0) {
      n += 255;
    }

    while (n >= 256) {
      n -= 255;
    }

    return EXP_TABLE[n];
  }
};

function QRPolynomial(num, shift) {
  if (typeof num.length === 'undefined') {
    throw new Error(num.length + '/' + shift);
  }

  this._num = function () {
    var offset = 0;
    while (offset < num.length && num[offset] === 0) {
      offset += 1;
    }
    var _num = new Array(num.length - offset + shift);
    for (var _i3 = 0; _i3 < num.length - offset; _i3 += 1) {
      _num[_i3] = num[_i3 + offset];
    }
    return _num;
  }();
}

QRPolynomial.prototype = {
  getAt: function getAt(index) {
    return this._num[index];
  },
  getLength: function getLength() {
    return this._num.length;
  },
  multiply: function multiply(e) {
    var num = new Array(this.getLength() + e.getLength() - 1);
    for (var _i4 = 0; _i4 < this.getLength(); _i4 += 1) {
      for (var j = 0; j < e.getLength(); j += 1) {
        num[_i4 + j] ^= QRMath.gexp(QRMath.glog(this.getAt(_i4)) + QRMath.glog(e.getAt(j)));
      }
    }

    return new QRPolynomial(num, 0);
  },
  mod: function mod(e) {
    if (this.getLength() - e.getLength() < 0) {
      return this;
    }

    var ratio = QRMath.glog(this.getAt(0)) - QRMath.glog(e.getAt(0));
    var num = new Array(this.getLength());
    for (var _i5 = 0; _i5 < this.getLength(); _i5 += 1) {
      num[_i5] = this.getAt(_i5);
    }

    for (var _i6 = 0; _i6 < e.getLength(); _i6 += 1) {
      num[_i6] ^= QRMath.gexp(QRMath.glog(e.getAt(_i6)) + ratio);
    }

    // recursive call
    return new QRPolynomial(num, 0).mod(e);
  }
};

var PATTERN_POSITION_TABLE = [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]];
var G15 = 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0;
var G18 = 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0;
var G15_MASK = 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1;

function getBCHDigit(data) {
  var digit = 0;
  while (data !== 0) {
    digit += 1;
    data >>>= 1;
  }
  return digit;
}

var QRUtil = {
  getBCHTypeInfo: function getBCHTypeInfo(data) {
    var d = data << 10;
    while (getBCHDigit(d) - getBCHDigit(G15) >= 0) {
      d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
    }
    return (data << 10 | d) ^ G15_MASK;
  },
  getBCHTypeNumber: function getBCHTypeNumber(data) {
    var d = data << 12;
    while (getBCHDigit(d) - getBCHDigit(G18) >= 0) {
      d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
    }
    return data << 12 | d;
  },
  getPatternPosition: function getPatternPosition(typeNumber) {
    return PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMaskFunction: function getMaskFunction(maskPattern) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return function (i, j) {
          return (i + j) % 2 === 0;
        };
      case QRMaskPattern.PATTERN001:
        return function (i) {
          return i % 2 === 0;
        };
      case QRMaskPattern.PATTERN010:
        return function (i, j) {
          return j % 3 === 0;
        };
      case QRMaskPattern.PATTERN011:
        return function (i, j) {
          return (i + j) % 3 === 0;
        };
      case QRMaskPattern.PATTERN100:
        return function (i, j) {
          return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        };
      case QRMaskPattern.PATTERN101:
        return function (i, j) {
          return i * j % 2 + i * j % 3 === 0;
        };
      case QRMaskPattern.PATTERN110:
        return function (i, j) {
          return (i * j % 2 + i * j % 3) % 2 === 0;
        };
      case QRMaskPattern.PATTERN111:
        return function (i, j) {
          return (i * j % 3 + (i + j) % 2) % 2 === 0;
        };
      default:
        throw new Error('bad maskPattern:' + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function getErrorCorrectPolynomial(errorCorrectLength) {
    var a = new QRPolynomial([1], 0);
    for (var _i7 = 0; _i7 < errorCorrectLength; _i7 += 1) {
      a = a.multiply(new QRPolynomial([1, QRMath.gexp(_i7)], 0));
    }
    return a;
  },
  getLengthInBits: function getLengthInBits(mode, type) {
    if (type >= 1 && type < 10) {
      // 1 - 9
      switch (mode) {
        case QRMode.MODE_NUMBER:
          return 10;
        case QRMode.MODE_ALPHA_NUM:
          return 9;
        case QRMode.MODE_8BIT_BYTE:
          return 8;
        case QRMode.MODE_KANJI:
          return 8;
        default:
          throw new Error('mode:' + mode);
      }
    } else if (type < 27) {
      // 10 - 26
      switch (mode) {
        case QRMode.MODE_NUMBER:
          return 12;
        case QRMode.MODE_ALPHA_NUM:
          return 11;
        case QRMode.MODE_8BIT_BYTE:
          return 16;
        case QRMode.MODE_KANJI:
          return 10;
        default:
          throw new Error('mode:' + mode);
      }
    } else if (type < 41) {
      // 27 - 40
      switch (mode) {
        case QRMode.MODE_NUMBER:
          return 14;
        case QRMode.MODE_ALPHA_NUM:
          return 13;
        case QRMode.MODE_8BIT_BYTE:
          return 16;
        case QRMode.MODE_KANJI:
          return 12;
        default:
          throw new Error('mode:' + mode);
      }
    } else {
      throw new Error('type:' + type);
    }
  },
  getLostPoint: function getLostPoint(qrcode) {
    var moduleCount = qrcode.getModuleCount();
    var lostPoint = 0;
    // LEVEL1
    for (var row = 0; row < moduleCount; row += 1) {
      for (var col = 0; col < moduleCount; col += 1) {
        var sameCount = 0;
        var dark = qrcode.isDark(row, col);
        for (var r = -1; r <= 1; r += 1) {
          if (row + r < 0 || moduleCount <= row + r) {
            continue;
          }

          for (var c = -1; c <= 1; c += 1) {
            if (col + c < 0 || moduleCount <= col + c) {
              continue;
            }

            if (r === 0 && c === 0) {
              continue;
            }

            if (dark === qrcode.isDark(row + r, col + c)) {
              sameCount += 1;
            }
          }
        }

        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    }

    // LEVEL2
    for (var _row = 0; _row < moduleCount - 1; _row += 1) {
      for (var _col = 0; _col < moduleCount - 1; _col += 1) {
        var count = 0;
        if (qrcode.isDark(_row, _col)) count += 1;
        if (qrcode.isDark(_row + 1, _col)) count += 1;
        if (qrcode.isDark(_row, _col + 1)) count += 1;
        if (qrcode.isDark(_row + 1, _col + 1)) count += 1;
        if (count === 0 || count === 4) {
          lostPoint += 3;
        }
      }
    }

    // LEVEL3
    for (var _row2 = 0; _row2 < moduleCount; _row2 += 1) {
      for (var _col2 = 0; _col2 < moduleCount - 6; _col2 += 1) {
        if (qrcode.isDark(_row2, _col2) && !qrcode.isDark(_row2, _col2 + 1) && qrcode.isDark(_row2, _col2 + 2) && qrcode.isDark(_row2, _col2 + 3) && qrcode.isDark(_row2, _col2 + 4) && !qrcode.isDark(_row2, _col2 + 5) && qrcode.isDark(_row2, _col2 + 6)) {
          lostPoint += 40;
        }
      }
    }

    for (var _col3 = 0; _col3 < moduleCount; _col3 += 1) {
      for (var _row3 = 0; _row3 < moduleCount - 6; _row3 += 1) {
        if (qrcode.isDark(_row3, _col3) && !qrcode.isDark(_row3 + 1, _col3) && qrcode.isDark(_row3 + 2, _col3) && qrcode.isDark(_row3 + 3, _col3) && qrcode.isDark(_row3 + 4, _col3) && !qrcode.isDark(_row3 + 5, _col3) && qrcode.isDark(_row3 + 6, _col3)) {
          lostPoint += 40;
        }
      }
    }

    // LEVEL4
    var darkCount = 0;
    for (var _col4 = 0; _col4 < moduleCount; _col4 += 1) {
      for (var _row4 = 0; _row4 < moduleCount; _row4 += 1) {
        if (qrcode.isDark(_row4, _col4)) {
          darkCount += 1;
        }
      }
    }

    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;

    return lostPoint;
  }
};

function QRBitBuffer() {
  this._buffer = [];
  this._length = 0;
}

QRBitBuffer.prototype = {
  getBuffer: function getBuffer() {
    return this._buffer;
  },
  getAt: function getAt(index) {
    var bufIndex = Math.floor(index / 8);
    return (this._buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
  },
  put: function put(num, length) {
    for (var i = 0; i < length; i += 1) {
      this.putBit((num >>> length - i - 1 & 1) === 1);
    }
  },
  getLengthInBits: function getLengthInBits() {
    return this._length;
  },
  putBit: function putBit(bit) {
    var bufIndex = Math.floor(this._length / 8);
    if (this._buffer.length <= bufIndex) {
      this._buffer.push(0);
    }

    if (bit) {
      this._buffer[bufIndex] |= 0x80 >>> this._length % 8;
    }

    this._length += 1;
  }
};

function chatToNum(c) {
  if (c >= '0' && c <= '9') {
    return c.charCodeAt(0) - '0'.charCodeAt(0);
  }
  throw new Error('illegal char :' + c);
}

function strToNum(s) {
  var num = 0;
  for (var _i8 = 0; _i8 < s.length; _i8 += 1) {
    num = num * 10 + chatToNum(s.charAt(_i8));
  }
  return num;
}

function QRNumber(data) {
  this._mode = QRMode.MODE_NUMBER;
  this._data = data;
}

QRNumber.prototype = {
  getMode: function getMode() {
    return this._mode;
  },
  getLength: function getLength() {
    return this._data.length;
  },
  write: function write(buffer) {
    var data = this._data;
    var i = 0;

    while (i + 2 < data.length) {
      buffer.put(strToNum(data.substring(i, i + 3)), 10);
      i += 3;
    }

    if (i < data.length) {
      if (data.length - i === 1) {
        buffer.put(strToNum(data.substring(i, i + 1)), 4);
      } else if (data.length - i === 2) {
        buffer.put(strToNum(data.substring(i, i + 2)), 7);
      }
    }
  }
};

function getCode(c) {
  if (c >= '0' && c <= '9') {
    return c.charCodeAt(0) - '0'.charCodeAt(0);
  } else if (c >= 'A' && c <= 'Z') {
    return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
  } else {
    switch (c) {
      case ' ':
        return 36;
      case '$':
        return 37;
      case '%':
        return 38;
      case '*':
        return 39;
      case '+':
        return 40;
      case '-':
        return 41;
      case '.':
        return 42;
      case '/':
        return 43;
      case ':':
        return 44;
      default:
        throw new Error('illegal char :' + c);
    }
  }
}

function QRAlphaNum(data) {
  this._mode = QRMode.MODE_ALPHA_NUM;
  this._data = data;
}

QRAlphaNum.prototype = {
  getMode: function getMode() {
    return this._mode;
  },
  getLength: function getLength() {
    return this._data.length;
  },
  write: function write(buffer) {
    var s = this._data;
    var i = 0;

    while (i + 1 < s.length) {
      buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
      i += 2;
    }

    if (i < s.length) {
      buffer.put(getCode(s.charAt(i)), 6);
    }
  }
};

function Base64DecodeInputStream(str) {
  this._str = str;
  this._pos = 0;
  this._buffer = 0;
  this._buflen = 0;
}

Base64DecodeInputStream.prototype = {
  read: function read() {
    while (this._buflen < 8) {
      if (this._pos >= this._str.length) {
        if (this._buflen === 0) {
          return -1;
        }
        throw new Error('unexpected end of file./' + this._buflen);
      }

      var c = this._str.charAt(this._pos);
      this._pos += 1;

      if (c === '=') {
        this._buflen = 0;
        return -1;
      } else if (c.match(/^\s$/)) {
        // ignore if whitespace.
        continue;
      }

      this._buffer = this._buffer << 6 | this.decode(c.charCodeAt(0));
      this._buflen += 6;
    }

    var n = this._buffer >>> this._buflen - 8 & 0xff;
    this._buflen -= 8;
    return n;
  },
  decode: function decode(c) {
    if (c >= 0x41 && c <= 0x5a) {
      return c - 0x41;
    } else if (c >= 0x61 && c <= 0x7a) {
      return c - 0x61 + 26;
    } else if (c >= 0x30 && c <= 0x39) {
      return c - 0x30 + 52;
    } else if (c === 0x2b) {
      return 62;
    } else if (c === 0x2f) {
      return 63;
    } else {
      throw new Error('c:' + c);
    }
  }
};

var stringToBytesFuncs = {
  'default': function _default(s) {
    var bytes = [];
    for (var _i9 = 0; _i9 < s.length; _i9 += 1) {
      var c = s.charCodeAt(_i9);
      bytes.push(c & 0xff);
    }
    return bytes;
  }

  // eslint-disable-next-line no-useless-escape
};var sjis = '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';

stringToBytesFuncs['SJIS'] = createStringToBytes(sjis, 7070);

stringToBytesFuncs['UTF-8'] = function (s) {
  // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
  function toUTF8Array(str) {
    var utf8 = [];
    for (var _i10 = 0; _i10 < str.length; _i10++) {
      var charcode = str.charCodeAt(_i10);
      if (charcode < 0x80) {
        utf8.push(charcode);
      } else if (charcode < 0x800) {
        utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
      } else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
      } else {
        _i10++;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(_i10) & 0x3ff);
        utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
      }
    }
    return utf8;
  }
  return toUTF8Array(s);
};

function createStringToBytes(unicodeData, numChars) {
  // create conversion map.
  var unicodeMap = function () {
    var bin = new Base64DecodeInputStream(unicodeData);
    var read = function read() {
      var b = bin.read();
      if (b === -1) throw new Error();
      return b;
    };

    var count = 0;
    var unicodeMap = {};
    // eslint-disable-next-line no-constant-condition
    while (true) {
      var b0 = bin.read();
      if (b0 === -1) break;
      var b1 = read();
      var b2 = read();
      var b3 = read();
      var k = String.fromCharCode(b0 << 8 | b1);
      var v = b2 << 8 | b3;
      unicodeMap[k] = v;
      count += 1;
    }
    if (count !== numChars) {
      throw new Error(count + ' != ' + numChars);
    }

    return unicodeMap;
  }();

  var unknownChar = '?'.charCodeAt(0);

  return function (s) {
    var bytes = [];
    for (var _i11 = 0; _i11 < s.length; _i11 += 1) {
      var c = s.charCodeAt(_i11);
      if (c < 128) {
        bytes.push(c);
      } else {
        var b = unicodeMap[s.charAt(_i11)];
        if (typeof b === 'number') {
          if ((b & 0xff) === b) {
            // 1byte
            bytes.push(b);
          } else {
            // 2bytes
            bytes.push(b >>> 8);
            bytes.push(b & 0xff);
          }
        } else {
          bytes.push(unknownChar);
        }
      }
    }
    return bytes;
  };
}

function QR8BitByte(data) {
  this._mode = QRMode.MODE_8BIT_BYTE;
  this._data = data;
  this._bytes = stringToBytesFuncs['default'](data);
}

QR8BitByte.prototype = {
  getMode: function getMode() {
    return this._mode;
  },
  getLength: function getLength() {
    return this._bytes.length;
  },
  write: function write(buffer) {
    for (var i = 0; i < this._bytes.length; i += 1) {
      buffer.put(this._bytes[i], 8);
    }
  }
};

function QRKanji(data) {
  this._mode = QRMode.MODE_KANJI;
  this._data = data;
  this._bytes = stringToBytesFuncs['SJIS'](data);

  !function (c, code) {
    // self test for sjis support.
    var test = stringToBytesFuncs['default'](c);
    if (test.length !== 2 || (test[0] << 8 | test[1]) !== code) {
      throw new Error('sjis not supported.');
    }
  }("\u53CB", 0x9746);
}

QRKanji.prototype = {
  getMode: function getMode() {
    return this._mode;
  },
  getLength: function getLength() {
    return ~~(this._bytes.length / 2);
  },
  write: function write(buffer) {
    var data = this._bytes;
    var i = 0;

    while (i + 1 < data.length) {
      var c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
      if (c >= 0x8140 && c <= 0x9FFC) {
        c -= 0x8140;
      } else if (c >= 0xE040 && c <= 0xEBBF) {
        c -= 0xC140;
      } else {
        throw new Error('illegal char at ' + (i + 1) + '/' + c);
      }

      c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
      buffer.put(c, 13);

      i += 2;
    }

    if (i < data.length) {
      throw new Error('illegal char at ' + (i + 1));
    }
  }
};

function ByteArrayOutputStream() {
  this._bytes = [];
}

ByteArrayOutputStream.prototype = {
  writeByte: function writeByte(b) {
    this._bytes.push(b & 0xff);
  },
  writeShort: function writeShort(i) {
    this.writeByte(i);
    this.writeByte(i >>> 8);
  },
  writeBytes: function writeBytes(b, off, len) {
    off = off || 0;
    len = len || b.length;
    for (var _i12 = 0; _i12 < len; _i12 += 1) {
      this.writeByte(b[_i12 + off]);
    }
  },
  writeString: function writeString(s) {
    for (var _i13 = 0; _i13 < s.length; _i13 += 1) {
      this.writeByte(s.charCodeAt(_i13));
    }
  },
  toByteArray: function toByteArray() {
    return this._bytes;
  },
  toString: function toString() {
    var s = '';
    s += '[';
    for (var _i14 = 0; _i14 < this._bytes.length; _i14 += 1) {
      if (_i14 > 0) {
        s += ',';
      }
      s += this._bytes[_i14];
    }
    s += ']';
    return s;
  }
};

function BitOutputStream(out) {
  this._out = out;
  this._bitLength = 0;
  this._bitBuffer = 0;
}

BitOutputStream.prototype = {
  write: function write(data, length) {
    if (data >>> length !== 0) {
      throw new Error('length over');
    }

    while (this._bitLength + length >= 8) {
      this._out.writeByte(0xff & (data << this._bitLength | this._bitBuffer));
      length -= 8 - this._bitLength;
      data >>>= 8 - this._bitLength;
      this._bitBuffer = 0;
      this._bitLength = 0;
    }

    this._bitBuffer = data << this._bitLength | this._bitBuffer;
    this._bitLength = this._bitLength + length;
  },
  flush: function flush() {
    if (this._bitLength > 0) {
      this._out.writeByte(this._bitBuffer);
    }
  }
};

function LzwTable() {
  this._map = {};
  this._size = 0;
}

LzwTable.prototype = {
  add: function add(key) {
    if (this.contains(key)) {
      throw new Error('dup key:' + key);
    }
    this._map[key] = this._size;
    this._size += 1;
  },
  size: function size() {
    return this._size;
  },
  indexOf: function indexOf(key) {
    return this._map[key];
  },
  contains: function contains(key) {
    return typeof this._map[key] !== 'undefined';
  }
};

function GifImage(width, height) {
  this._width = width;
  this._height = height;
  this._data = new Array(width * height);
}

GifImage.prototype = {
  setPixel: function setPixel(x, y, pixel) {
    this._data[y * this._width + x] = pixel;
  },
  write: function write(out) {
    // GIF Signature
    out.writeString('GIF87a'

    // Screen Descriptor
    );out.writeShort(this._width);
    out.writeShort(this._height
    // 2bit
    );out.writeByte(0x80);
    out.writeByte(0);
    out.writeByte(0

    // Global Color Map
    // black
    );out.writeByte(0x00);
    out.writeByte(0x00);
    out.writeByte(0x00

    // white
    );out.writeByte(0xff);
    out.writeByte(0xff);
    out.writeByte(0xff

    // Image Descriptor
    );out.writeString(',');
    out.writeShort(0);
    out.writeShort(0);
    out.writeShort(this._width);
    out.writeShort(this._height);
    out.writeByte(0

    // Local Color Map
    // Raster Data
    );var lzwMinCodeSize = 2;
    var raster = this.getLZWRaster(lzwMinCodeSize);

    out.writeByte(lzwMinCodeSize);

    var offset = 0;
    while (raster.length - offset > 255) {
      out.writeByte(255);
      out.writeBytes(raster, offset, 255);
      offset += 255;
    }

    out.writeByte(raster.length - offset);
    out.writeBytes(raster, offset, raster.length - offset);
    out.writeByte(0x00

    // GIF Terminator
    );out.writeString(';');
  },
  getLZWRaster: function getLZWRaster(lzwMinCodeSize) {
    var clearCode = 1 << lzwMinCodeSize;
    var endCode = (1 << lzwMinCodeSize) + 1;
    var bitLength = lzwMinCodeSize + 1;

    // Setup LZWTable
    var table = new LzwTable();

    for (var _i15 = 0; _i15 < clearCode; _i15 += 1) {
      table.add(String.fromCharCode(_i15));
    }
    table.add(String.fromCharCode(clearCode));
    table.add(String.fromCharCode(endCode));

    var byteOut = new ByteArrayOutputStream();
    var bitOut = new BitOutputStream(byteOut);

    // clear code
    bitOut.write(clearCode, bitLength);

    var dataIndex = 0;
    var s = String.fromCharCode(this._data[dataIndex]);
    dataIndex += 1;

    while (dataIndex < this._data.length) {
      var c = String.fromCharCode(this._data[dataIndex]);
      dataIndex += 1;

      if (table.contains(s + c)) {
        s = s + c;
      } else {
        bitOut.write(table.indexOf(s), bitLength);
        if (table.size() < 0xfff) {
          if (table.size() === 1 << bitLength) {
            bitLength += 1;
          }

          table.add(s + c);
        }

        s = c;
      }
    }

    bitOut.write(table.indexOf(s), bitLength
    // end code
    );bitOut.write(endCode, bitLength);
    bitOut.flush();

    return byteOut.toByteArray();
  }
};

function Base64EncodeOutputStream() {
  this._buffer = 0;
  this._buflen = 0;
  this._length = 0;
  this._base64 = '';
}

Base64EncodeOutputStream.prototype = {
  writeEncoded: function writeEncoded(b) {
    this._base64 += String.fromCharCode(this.encode(b & 0x3f));
  },
  encode: function encode(n) {
    if (n < 0) {
      // error.
    } else if (n < 26) {
      return 0x41 + n;
    } else if (n < 52) {
      return 0x61 + (n - 26);
    } else if (n < 62) {
      return 0x30 + (n - 52);
    } else if (n === 62) {
      return 0x2b;
    } else if (n === 63) {
      return 0x2f;
    }
    throw new Error('n:' + n);
  },
  writeByte: function writeByte(n) {
    this._buffer = this._buffer << 8 | n & 0xff;
    this._buflen += 8;
    this._length += 1;

    while (this._buflen >= 6) {
      this.writeEncoded(this._buffer >>> this._buflen - 6);
      this._buflen -= 6;
    }
  },
  flush: function flush() {
    if (this._buflen > 0) {
      this.writeEncoded(this._buffer << 6 - this._buflen);
      this._buffer = 0;
      this._buflen = 0;
    }

    if (this._length % 3 !== 0) {
      var padlen = 3 - this._length % 3;
      for (var _i16 = 0; _i16 < padlen; _i16 += 1) {
        this._base64 += '=';
      }
    }
  },
  toString: function toString() {
    return this._base64;
  }
};

var types = 'Boolean Number String Function Array Date RegExp Object Error'.split(' ');
var class2type = {};

for (var _i17 = 0; _i17 < types.length; _i17++) {
  class2type['[object ' + types[_i17] + ']'] = types[_i17].toLowerCase();
}

function type(obj) {
  if (obj === null) {
    return obj + '';
  }
  return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' || typeof obj === 'function' ? class2type[Object.prototype.toString.call(obj)] || 'object' : typeof obj === "undefined" ? "undefined" : _typeof(obj);
}

/**
 * qrcode
 * @param typeNumber 1 to 40
 * @param errorCorrectionLevel 'L','M','Q','H'
 */
function QRCoder(options) {
  if (type(options) !== 'object') {
    throw new Error('options should be a Object.');
  }
  this._options = options;

  var errorCorrectionLevel = QRErrorCorrectionLevel[this._options.errorCorrectionLevel || 'L'];
  var typeNumber = this._options.typeNumber || this.calcTypeNumber(this._options.data, errorCorrectionLevel, this._options.mode) || 4;
  this._typeNumber = typeNumber;
  this._errorCorrectionLevel = errorCorrectionLevel;
  this._modules = null;
  this._moduleCount = 0;
  this._dataCache = null;
  this._dataList = [];

  if (this._options.data) {
    this.addData(this._options.data);
    this.make();
  }
}

QRCoder.prototype = {
  makeImpl: function makeImpl(test, maskPattern) {
    this._moduleCount = this._typeNumber * 4 + 17;
    this._modules = function (moduleCount) {
      var modules = new Array(moduleCount);
      for (var row = 0; row < moduleCount; row += 1) {
        modules[row] = new Array(moduleCount);
        for (var col = 0; col < moduleCount; col += 1) {
          modules[row][col] = null;
        }
      }
      return modules;
    }(this._moduleCount);

    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this._moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this._moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);

    if (this._typeNumber >= 7) {
      this.setupTypeNumber(test);
    }

    if (this._dataCache == null) {
      this._dataCache = this.createData(this._typeNumber, this._errorCorrectionLevel, this._dataList);
    }

    this.mapData(this._dataCache, maskPattern);
  },
  setupPositionProbePattern: function setupPositionProbePattern(row, col) {
    for (var r = -1; r <= 7; r += 1) {
      if (row + r <= -1 || this._moduleCount <= row + r) {
        continue;
      }

      for (var c = -1; c <= 7; c += 1) {
        if (col + c <= -1 || this._moduleCount <= col + c) {
          continue;
        }

        if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) {
          this._modules[row + r][col + c] = true;
        } else {
          this._modules[row + r][col + c] = false;
        }
      }
    }
  },
  getBestMaskPattern: function getBestMaskPattern() {
    var minLostPoint = 0;
    var pattern = 0;
    for (var i = 0; i < 8; i += 1) {
      this.makeImpl(true, i);
      var lostPoint = QRUtil.getLostPoint(this);

      if (i === 0 || minLostPoint > lostPoint) {
        minLostPoint = lostPoint;
        pattern = i;
      }
    }

    return pattern;
  },
  setupTimingPattern: function setupTimingPattern() {
    for (var r = 8; r < this._moduleCount - 8; r += 1) {
      if (this._modules[r][6] != null) {
        continue;
      }
      this._modules[r][6] = r % 2 === 0;
    }

    for (var c = 8; c < this._moduleCount - 8; c += 1) {
      if (this._modules[6][c] != null) {
        continue;
      }
      this._modules[6][c] = c % 2 === 0;
    }
  },
  setupPositionAdjustPattern: function setupPositionAdjustPattern() {
    var pos = QRUtil.getPatternPosition(this._typeNumber);

    for (var _i18 = 0; _i18 < pos.length; _i18 += 1) {
      for (var j = 0; j < pos.length; j += 1) {
        var row = pos[_i18];
        var col = pos[j];

        if (this._modules[row][col] != null) {
          continue;
        }

        for (var r = -2; r <= 2; r += 1) {
          for (var c = -2; c <= 2; c += 1) {
            if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) {
              this._modules[row + r][col + c] = true;
            } else {
              this._modules[row + r][col + c] = false;
            }
          }
        }
      }
    }
  },
  setupTypeNumber: function setupTypeNumber(test) {
    var bits = QRUtil.getBCHTypeNumber(this._typeNumber);

    for (var _i19 = 0; _i19 < 18; _i19 += 1) {
      var mod = !test && (bits >> _i19 & 1) === 1;
      this._modules[Math.floor(_i19 / 3)][_i19 % 3 + this._moduleCount - 8 - 3] = mod;
    }

    for (var _i20 = 0; _i20 < 18; _i20 += 1) {
      var _mod = !test && (bits >> _i20 & 1) === 1;
      this._modules[_i20 % 3 + this._moduleCount - 8 - 3][Math.floor(_i20 / 3)] = _mod;
    }
  },
  setupTypeInfo: function setupTypeInfo(test, maskPattern) {
    var data = this._errorCorrectionLevel << 3 | maskPattern;
    var bits = QRUtil.getBCHTypeInfo(data

    // vertical
    );for (var _i21 = 0; _i21 < 15; _i21 += 1) {
      var mod = !test && (bits >> _i21 & 1) === 1;

      if (_i21 < 6) {
        this._modules[_i21][8] = mod;
      } else if (_i21 < 8) {
        this._modules[_i21 + 1][8] = mod;
      } else {
        this._modules[this._moduleCount - 15 + _i21][8] = mod;
      }
    }

    // horizontal
    for (var _i22 = 0; _i22 < 15; _i22 += 1) {
      var _mod2 = !test && (bits >> _i22 & 1) === 1;

      if (_i22 < 8) {
        this._modules[8][this._moduleCount - _i22 - 1] = _mod2;
      } else if (_i22 < 9) {
        this._modules[8][15 - _i22 - 1 + 1] = _mod2;
      } else {
        this._modules[8][15 - _i22 - 1] = _mod2;
      }
    }

    // fixed module
    this._modules[this._moduleCount - 8][8] = !test;
  },
  mapData: function mapData(data, maskPattern) {
    var inc = -1;
    var row = this._moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    var maskFunc = QRUtil.getMaskFunction(maskPattern);

    for (var col = this._moduleCount - 1; col > 0; col -= 2) {
      if (col === 6) {
        col -= 1;
      }

      // eslint-disable-next-line no-constant-condition
      while (true) {
        for (var c = 0; c < 2; c += 1) {
          if (this._modules[row][col - c] == null) {
            var dark = false;
            if (byteIndex < data.length) {
              dark = (data[byteIndex] >>> bitIndex & 1) === 1;
            }

            var mask = maskFunc(row, col - c);

            if (mask) {
              dark = !dark;
            }

            this._modules[row][col - c] = dark;
            bitIndex -= 1;

            if (bitIndex === -1) {
              byteIndex += 1;
              bitIndex = 7;
            }
          }
        }

        row += inc;

        if (row < 0 || this._moduleCount <= row) {
          row -= inc;
          inc = -inc;
          break;
        }
      }
    }
  },
  createBytes: function createBytes(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);

    for (var r = 0; r < rsBlocks.length; r += 1) {
      var dcCount = rsBlocks[r].dataCount;
      var ecCount = rsBlocks[r].totalCount - dcCount;

      maxDcCount = Math.max(maxDcCount, dcCount);
      maxEcCount = Math.max(maxEcCount, ecCount);

      dcdata[r] = new Array(dcCount);

      for (var _i23 = 0; _i23 < dcdata[r].length; _i23 += 1) {
        dcdata[r][_i23] = 0xff & buffer.getBuffer()[_i23 + offset];
      }
      offset += dcCount;

      var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
      var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);

      var modPoly = rawPoly.mod(rsPoly);
      ecdata[r] = new Array(rsPoly.getLength() - 1);
      for (var _i24 = 0; _i24 < ecdata[r].length; _i24 += 1) {
        var modIndex = _i24 + modPoly.getLength() - ecdata[r].length;
        ecdata[r][_i24] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
      }
    }

    var totalCodeCount = 0;
    for (var _i25 = 0; _i25 < rsBlocks.length; _i25 += 1) {
      totalCodeCount += rsBlocks[_i25].totalCount;
    }

    var data = new Array(totalCodeCount);
    var index = 0;

    for (var _i26 = 0; _i26 < maxDcCount; _i26 += 1) {
      for (var _r = 0; _r < rsBlocks.length; _r += 1) {
        if (_i26 < dcdata[_r].length) {
          data[index] = dcdata[_r][_i26];
          index += 1;
        }
      }
    }

    for (var _i27 = 0; _i27 < maxEcCount; _i27 += 1) {
      for (var _r2 = 0; _r2 < rsBlocks.length; _r2 += 1) {
        if (_i27 < ecdata[_r2].length) {
          data[index] = ecdata[_r2][_i27];
          index += 1;
        }
      }
    }

    return data;
  },
  createData: function createData(typeNumber, errorCorrectionLevel, dataList) {
    var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
    var buffer = new QRBitBuffer();

    for (var _i28 = 0; _i28 < dataList.length; _i28 += 1) {
      var data = dataList[_i28];
      buffer.put(data.getMode(), 4);
      buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber));
      data.write(buffer);
    }

    // calc num max data.
    var totalDataCount = 0;
    for (var _i29 = 0; _i29 < rsBlocks.length; _i29 += 1) {
      totalDataCount += rsBlocks[_i29].dataCount;
    }

    if (buffer.getLengthInBits() > totalDataCount * 8) {
      throw new Error('code length overflow. (' + buffer.getLengthInBits() + '>' + totalDataCount * 8 + ')');
    }

    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
      buffer.put(0, 4);
    }

    // padding
    while (buffer.getLengthInBits() % 8 !== 0) {
      buffer.putBit(false);
    }

    // padding
    // eslint-disable-next-line no-constant-condition
    while (true) {
      if (buffer.getLengthInBits() >= totalDataCount * 8) {
        break;
      }
      buffer.put(PAD0, 8);

      if (buffer.getLengthInBits() >= totalDataCount * 8) {
        break;
      }
      buffer.put(PAD1, 8);
    }

    return this.createBytes(buffer, rsBlocks);
  },
  addData: function addData(data, mode) {
    mode = mode || this._options.mode || 'Byte';
    var newData = null;

    switch (mode) {
      case 'Numeric':
        newData = new QRNumber(data);
        break;
      case 'Alphanumeric':
        newData = new QRAlphaNum(data);
        break;
      case 'Byte':
        newData = new QR8BitByte(data);
        break;
      case 'Kanji':
        newData = new QRKanji(data);
        break;
      default:
        throw new Error('mode:' + mode);
    }

    this._dataList.push(newData);
    this._dataCache = null;
  },
  isDark: function isDark(row, col) {
    if (row < 0 || this._moduleCount <= row || col < 0 || this._moduleCount <= col) {
      throw new Error(row + ',' + col);
    }
    return this._modules[row][col];
  },
  getModuleCount: function getModuleCount() {
    return this._moduleCount;
  },
  make: function make() {
    this.makeImpl(false, this.getBestMaskPattern());
  },
  createTableTag: function createTableTag() {
    var _calcSpec = this.calcSpec(),
        cellSize = _calcSpec.cellSize,
        margin = _calcSpec.margin;

    var qrHtml = '';
    qrHtml += '<table style="';
    qrHtml += ' border-width: 0px; border-style: none;';
    qrHtml += ' border-collapse: collapse;';
    qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
    qrHtml += '">';
    qrHtml += '<tbody>';

    for (var r = 0; r < this.getModuleCount(); r += 1) {
      qrHtml += '<tr>';
      for (var c = 0; c < this.getModuleCount(); c += 1) {
        qrHtml += '<td style="';
        qrHtml += ' border-width: 0px; border-style: none;';
        qrHtml += ' border-collapse: collapse;';
        qrHtml += ' padding: 0px; margin: 0px;';
        qrHtml += ' width: ' + cellSize + 'px;';
        qrHtml += ' height: ' + cellSize + 'px;';
        qrHtml += ' background-color: ';
        qrHtml += this.isDark(r, c) ? '#000000' : '#ffffff';
        qrHtml += ';';
        qrHtml += '"/>';
      }

      qrHtml += '</tr>';
    }

    qrHtml += '</tbody>';
    qrHtml += '</table>';

    return qrHtml;
  },
  createSvgTag: function createSvgTag() {
    var _calcSpec2 = this.calcSpec(),
        cellSize = _calcSpec2.cellSize,
        margin = _calcSpec2.margin,
        size = _calcSpec2.size;

    var c = void 0;
    var mc = void 0;
    var r = void 0;
    var mr = void 0;
    var qrSvg = '';
    var rect = void 0;

    rect = 'l' + cellSize + ',0 0,' + cellSize + ' -' + cellSize + ',0 0,-' + cellSize + 'z ';

    qrSvg += '<svg';
    qrSvg += ' width="' + size + 'px"';
    qrSvg += ' height="' + size + 'px"';
    qrSvg += ' xmlns="http://www.w3.org/2000/svg"';
    qrSvg += '>';
    qrSvg += '<path d="';

    for (r = 0; r < this.getModuleCount(); r += 1) {
      mr = r * cellSize + margin;
      for (c = 0; c < this.getModuleCount(); c += 1) {
        if (this.isDark(r, c)) {
          mc = c * cellSize + margin;
          qrSvg += 'M' + mc + ',' + mr + rect;
        }
      }
    }

    qrSvg += '" stroke="transparent" fill="black"/>';
    qrSvg += '</svg>';

    return qrSvg;
  },
  createImgTag: function createImgTag() {
    var _calcSpec3 = this.calcSpec(),
        cellSize = _calcSpec3.cellSize,
        margin = _calcSpec3.margin,
        size = _calcSpec3.size;

    var alt = this._options.alt || '';

    var dataUrl = this.getDataURL(cellSize, margin);

    return _createImgTag(size, size, dataUrl, alt);
  },
  getDataURL: function getDataURL() {
    var _this = this;

    var _calcSpec4 = this.calcSpec(),
        cellSize = _calcSpec4.cellSize,
        margin = _calcSpec4.margin,
        size = _calcSpec4.size;

    var min = margin;
    var max = size - margin;

    return getGifDataURL(size, size, function (x, y) {
      if (min <= x && x < max && min <= y && y < max) {
        var c = Math.floor((x - min) / cellSize);
        var r = Math.floor((y - min) / cellSize);
        return _this.isDark(r, c) ? 0 : 1;
      } else {
        return 1;
      }
    });
  },
  calcTypeNumber: function calcTypeNumber(data, errorCorrectionLevel, mode) {
    mode = mode || 'Byte';
    if (!data) {
      return;
    }

    var arrCapacity = QRCapacity[mode][errorCorrectionLevel];
    for (var _i30 = 0; _i30 < arrCapacity.length; _i30++) {
      if (data.length < +arrCapacity[_i30]) {
        return _i30 + 1;
      }
    }

    throw new Error('code length overflow. ');
  },
  calcSpec: function calcSpec() {
    var cellSize = void 0;
    var margin = void 0;
    var size = void 0;
    var moduleCount = this.getModuleCount();
    if (!this._options.cellSize && !this._options.margin && this._options.size) {
      // clac cellSize, margin
      var _size = this._options.size;
      cellSize = Math.floor(_size / moduleCount);
      if (cellSize < 1) {
        console.log('size is less than moduleCount');
        cellSize = 1;
        margin = 0;
      } else {
        margin = Math.floor(_size % moduleCount / 2);
      }
    } else {
      cellSize = cellSize || this._options.cellSize || 2, margin = margin || this._options.margin || cellSize * 4;
    }

    size = moduleCount * cellSize + margin * 2;

    return {
      cellSize: cellSize,
      margin: margin,
      size: size
    };
  },
  getSize: function getSize() {
    var _calcSpec5 = this.calcSpec(),
        size = _calcSpec5.size;

    return size;
  },
  getCellSize: function getCellSize() {
    var _calcSpec6 = this.calcSpec(),
        cellSize = _calcSpec6.cellSize;

    return cellSize;
  },
  getMargin: function getMargin() {
    var _calcSpec7 = this.calcSpec(),
        margin = _calcSpec7.margin;

    return margin;
  }
};

QRCoder.stringToBytesFuncs = stringToBytesFuncs;

QRCoder.stringToBytes = stringToBytesFuncs['default'];
/**
 * @param unicodeData base64 string of byte array.
 * [16bit Unicode],[16bit Bytes], ...
 * @param numChars
 */
QRCoder.createStringToBytes = createStringToBytes;

function _createImgTag(width, height, dataUrl, alt) {
  var img = '';
  img += '<img';
  img += " src=\"";
  img += dataUrl;
  img += '"';
  img += " width=\"";
  img += width;
  img += '"';
  img += " height=\"";
  img += height;
  img += '"';
  if (alt) {
    img += " alt=\"";
    img += alt;
    img += '"';
  }
  img += '/>';

  return img;
}

function getGifDataURL(width, height, getPixel) {
  var gif = new GifImage(width, height);
  for (var y = 0; y < height; y += 1) {
    for (var x = 0; x < width; x += 1) {
      gif.setPixel(x, y, getPixel(x, y));
    }
  }

  var b = new ByteArrayOutputStream();
  gif.write(b);

  var base64 = new Base64EncodeOutputStream();
  var bytes = b.toByteArray();
  for (var _i31 = 0; _i31 < bytes.length; _i31 += 1) {
    base64.writeByte(bytes[_i31]);
  }
  base64.flush();

  return 'data:image/gif;base64,' + base64;
}

exports.default = QRCoder;
//# sourceMappingURL=qrcoder.esm.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollEventTarget = getScrollEventTarget;
exports.getScrollTop = getScrollTop;
exports.setScrollTop = setScrollTop;
exports.getRootScrollTop = getRootScrollTop;
exports.getElementTop = getElementTop;
exports.getVisibleHeight = getVisibleHeight;
// get nearest scroll element
// http://w3help.org/zh-cn/causes/SD9013
// http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
function getScrollEventTarget(element, rootParent) {
  if (rootParent === void 0) {
    rootParent = window;
  }

  var node = element;

  while (node && node.tagName !== 'HTML' && node.tagName !== 'BODY' && node.nodeType === 1 && node !== rootParent) {
    var _window$getComputedSt = window.getComputedStyle(node),
        overflowY = _window$getComputedSt.overflowY;

    if (overflowY === 'scroll' || overflowY === 'auto') {
      return node;
    }

    node = node.parentNode;
  }

  return rootParent;
}
function getScrollTop(element) {
  return 'scrollTop' in element ? element.scrollTop : element.pageYOffset;
}
function setScrollTop(element, value) {
  'scrollTop' in element ? element.scrollTop = value : element.scrollTo(element.scrollX, value);
}
function getRootScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
} // get distance from element top to page top

function getElementTop(element) {
  return (element === window ? 0 : element.getBoundingClientRect().top) + getScrollTop(window);
}
function getVisibleHeight(element) {
  return element === window ? element.innerHeight : element.getBoundingClientRect().height;
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(154);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin(Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if (options === void 0) options = {};

      options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit() {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function' ? options.store() : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin(store) {
  if (!devtoolHook) {
    return;
  }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
  return list.filter(f)[0];
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy(obj, cache) {
  if (cache === void 0) cache = [];

  // just return if obj is immutable value
  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) {
    return c.original === obj;
  });
  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

/**
 * forEach for object
 */
function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error("[vuex] " + msg);
  }
}

function partial(fn, arg) {
  return function () {
    return fn(arg);
  };
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module(rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced;
};

Module.prototype.addChild = function addChild(key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild(key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild(key) {
  return this._children[key];
};

Module.prototype.hasChild = function hasChild(key) {
  return key in this._children;
};

Module.prototype.update = function update(rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild(fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter(fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction(fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation(fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties(Module.prototype, prototypeAccessors);

var ModuleCollection = function ModuleCollection(rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get(path) {
  return path.reduce(function (module, key) {
    return module.getChild(key);
  }, this.root);
};

ModuleCollection.prototype.getNamespace = function getNamespace(path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '');
  }, '');
};

ModuleCollection.prototype.update = function update$1(rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
  var this$1 = this;
  if (runtime === void 0) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if (false) {
      console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
    }
    return;
  }

  if (!child.runtime) {
    return;
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key);
  }

  return false;
};

function update(path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
        }
        return;
      }
      update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
  }
}

var functionAssert = {
  assert: function assert(value) {
    return typeof value === 'function';
  },
  expected: 'function'
};

var objectAssert = {
  assert: function assert(value) {
    return typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.handler === 'function';
  },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule(path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) {
      return;
    }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(assertOptions.assert(value), makeAssertionMessage(path, key, type, value, assertOptions.expected));
    });
  });
}

function makeAssertionMessage(path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + path.join('.') + "\"";
  }
  buf += " is " + JSON.stringify(value) + ".";
  return buf;
}

var Vue; // bind on install

var Store = function Store(options) {
  var this$1 = this;
  if (options === void 0) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins;if (plugins === void 0) plugins = [];
  var strict = options.strict;if (strict === void 0) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch(type, payload) {
    return dispatch.call(store, type, payload);
  };
  this.commit = function boundCommit(type, payload, options) {
    return commit.call(store, type, payload, options);
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) {
    return plugin(this$1);
  });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state;
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit(_type, _payload, _options) {
  var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
  var type = ref.type;
  var payload = ref.payload;
  var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown mutation type: " + type);
    }
    return;
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator(handler) {
      handler(payload);
    });
  });

  this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
  .forEach(function (sub) {
    return sub(mutation, this$1.state);
  });

  if (false) {
    console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
  }
};

Store.prototype.dispatch = function dispatch(_type, _payload) {
  var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
  var type = ref.type;
  var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown action type: " + type);
    }
    return;
  }

  try {
    this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .filter(function (sub) {
      return sub.before;
    }).forEach(function (sub) {
      return sub.before(action, this$1.state);
    });
  } catch (e) {
    if (false) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1 ? Promise.all(entry.map(function (handler) {
    return handler(payload);
  })) : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.after;
        }).forEach(function (sub) {
          return sub.after(action, this$1.state);
        });
      } catch (e) {
        if (false) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.error;
        }).forEach(function (sub) {
          return sub.error(action, this$1.state, error);
        });
      } catch (e) {
        if (false) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  });
};

Store.prototype.subscribe = function subscribe(fn, options) {
  return genericSubscribe(fn, this._subscribers, options);
};

Store.prototype.subscribeAction = function subscribeAction(fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options);
};

Store.prototype.watch = function watch(getter, cb, options) {
  var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () {
    return getter(this$1.state, this$1.getters);
  }, cb, options);
};

Store.prototype.replaceState = function replaceState(state) {
  var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule(path, rawModule, options) {
  if (options === void 0) options = {};

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule(path) {
  var this$1 = this;

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule(path) {
  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path);
};

Store.prototype.hotUpdate = function hotUpdate(newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit(fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties(Store.prototype, prototypeAccessors$1);

function genericSubscribe(fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend ? subs.unshift(fn) : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  };
}

function resetStore(store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM(store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function get() {
        return store._vm[key];
      },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () {
      return oldVm.$destroy();
    });
  }
}

function installModule(store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && "production" !== 'production') {
      console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if (false) {
        if (moduleName in parentState) {
          console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext(store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
          return;
        }
      }

      return store.dispatch(type, payload);
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
          return;
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace ? function () {
        return store.getters;
      } : function () {
        return makeLocalGetters(store, namespace);
      }
    },
    state: {
      get: function get() {
        return getNestedState(store.state, path);
      }
    }
  });

  return local;
}

function makeLocalGetters(store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) {
        return;
      }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function get() {
          return store.getters[type];
        },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace];
}

function registerMutation(store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler(payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction(store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler(payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err;
      });
    } else {
      return res;
    }
  });
}

function registerGetter(store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error("[vuex] duplicate getter key: " + type);
    }
    return;
  }
  store._wrappedGetters[type] = function wrappedGetter(store) {
    return rawGetter(local.state, // local state
    local.getters, // local getters
    store.state, // root state
    store.getters // root getters
    );
  };
}

function enableStrictMode(store) {
  store._vm.$watch(function () {
    return this._data.$$state;
  }, function () {
    if (false) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState(state, path) {
  return path.reduce(function (state, key) {
    return state[key];
  }, state);
}

function unifyObjectStyle(type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', "expects string as the type, but found " + (typeof type === 'undefined' ? 'undefined' : _typeof(type)) + ".");
  }

  return { type: type, payload: payload, options: options };
}

function install(_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error('[vuex] already installed. Vue.use(Vuex) should be called only once.');
    }
    return;
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState() {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return;
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function' ? val.call(this, state, getters) : state[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      } // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return;
        }
        commit = module.context.commit;
      }
      return typeof val === 'function' ? val.apply(this, [commit].concat(args)) : commit.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter() {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return;
      }
      if (false) {
        console.error("[vuex] unknown getter: " + val);
        return;
      }
      return this.$store.getters[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      } // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return;
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function' ? val.apply(this, [dispatch].concat(args)) : dispatch.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function createNamespacedHelpers(namespace) {
  return {
    mapState: mapState.bind(null, namespace),
    mapGetters: mapGetters.bind(null, namespace),
    mapMutations: mapMutations.bind(null, namespace),
    mapActions: mapActions.bind(null, namespace)
  };
};

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap(map) {
  if (!isValidMap(map)) {
    return [];
  }
  return Array.isArray(map) ? map.map(function (key) {
    return { key: key, val: key };
  }) : Object.keys(map).map(function (key) {
    return { key: key, val: map[key] };
  });
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap(map) {
  return Array.isArray(map) || isObject(map);
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace(fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map);
  };
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace(store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
  }
  return module;
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger(ref) {
  if (ref === void 0) ref = {};
  var collapsed = ref.collapsed;if (collapsed === void 0) collapsed = true;
  var filter = ref.filter;if (filter === void 0) filter = function filter(mutation, stateBefore, stateAfter) {
    return true;
  };
  var transformer = ref.transformer;if (transformer === void 0) transformer = function transformer(state) {
    return state;
  };
  var mutationTransformer = ref.mutationTransformer;if (mutationTransformer === void 0) mutationTransformer = function mutationTransformer(mut) {
    return mut;
  };
  var actionFilter = ref.actionFilter;if (actionFilter === void 0) actionFilter = function actionFilter(action, state) {
    return true;
  };
  var actionTransformer = ref.actionTransformer;if (actionTransformer === void 0) actionTransformer = function actionTransformer(act) {
    return act;
  };
  var logMutations = ref.logMutations;if (logMutations === void 0) logMutations = true;
  var logActions = ref.logActions;if (logActions === void 0) logActions = true;
  var logger = ref.logger;if (logger === void 0) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return;
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + mutation.type + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + action.type + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  };
}

function startMessage(logger, message, collapsed) {
  var startMessage = collapsed ? logger.groupCollapsed : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage(logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime() {
  var time = new Date();
  return " @ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num;
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

exports.default = index;
exports.Store = Store;
exports.createLogger = createLogger;
exports.createNamespacedHelpers = createNamespacedHelpers;
exports.install = install;
exports.mapActions = mapActions;
exports.mapGetters = mapGetters;
exports.mapMutations = mapMutations;
exports.mapState = mapState;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupMixin = undefined;

var _context = __webpack_require__(61);

var _touch = __webpack_require__(31);

var _event = __webpack_require__(12);

var _overlay = __webpack_require__(146);

var _scroll = __webpack_require__(27);

var PopupMixin = exports.PopupMixin = {
  mixins: [_touch.TouchMixin],
  props: {
    // whether to show popup
    value: Boolean,
    // whether to show overlay
    overlay: Boolean,
    // overlay custom style
    overlayStyle: Object,
    // overlay custom class name
    overlayClass: String,
    // whether to close popup when click overlay
    closeOnClickOverlay: Boolean,
    // z-index
    zIndex: [String, Number],
    // return the mount node for popup
    getContainer: [String, Function],
    // prevent body scroll
    lockScroll: {
      type: Boolean,
      "default": true
    },
    // whether to lazy render
    lazyRender: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      inited: this.value
    };
  },
  computed: {
    shouldRender: function shouldRender() {
      return this.inited || !this.lazyRender;
    }
  },
  watch: {
    value: function value(val) {
      var type = val ? 'open' : 'close';
      this.inited = this.inited || this.value;
      this[type]();
      this.$emit(type);
    },
    getContainer: function getContainer() {
      this.move();
    },
    overlay: function overlay() {
      this.renderOverlay();
    }
  },
  mounted: function mounted() {
    if (this.getContainer) {
      this.move();
    }

    if (this.value) {
      this.open();
    }
  },
  activated: function activated() {
    /* istanbul ignore next */
    if (this.value) {
      this.open();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.close();

    if (this.getContainer && this.$parent && this.$parent.$el) {
      this.$parent.$el.appendChild(this.$el);
    }
  },
  deactivated: function deactivated() {
    /* istanbul ignore next */
    this.close();
  },
  methods: {
    open: function open() {
      /* istanbul ignore next */
      if (this.$isServer || this.opened) {
        return;
      } // cover default zIndex


      if (this.zIndex !== undefined) {
        _context.context.zIndex = this.zIndex;
      }

      this.opened = true;
      this.renderOverlay();

      if (this.lockScroll) {
        (0, _event.on)(document, 'touchstart', this.touchStart);
        (0, _event.on)(document, 'touchmove', this.onTouchMove);

        if (!_context.context.lockCount) {
          document.body.classList.add('van-overflow-hidden');
        }

        _context.context.lockCount++;
      }
    },
    close: function close() {
      if (!this.opened) {
        return;
      }

      if (this.lockScroll) {
        _context.context.lockCount--;
        (0, _event.off)(document, 'touchstart', this.touchStart);
        (0, _event.off)(document, 'touchmove', this.onTouchMove);

        if (!_context.context.lockCount) {
          document.body.classList.remove('van-overflow-hidden');
        }
      }

      this.opened = false;
      (0, _overlay.closeOverlay)(this);
      this.$emit('input', false);
    },
    move: function move() {
      var container;
      var getContainer = this.getContainer;

      if (getContainer) {
        container = typeof getContainer === 'string' ? document.querySelector(getContainer) : getContainer();
      } else if (this.$parent) {
        container = this.$parent.$el;
      }

      if (container && container !== this.$el.parentNode) {
        container.appendChild(this.$el);
      }

      if (this.overlay) {
        (0, _overlay.updateOverlay)();
      }
    },
    onTouchMove: function onTouchMove(event) {
      this.touchMove(event);
      var direction = this.deltaY > 0 ? '10' : '01';
      var el = (0, _scroll.getScrollEventTarget)(event.target, this.$el);
      var scrollHeight = el.scrollHeight,
          offsetHeight = el.offsetHeight,
          scrollTop = el.scrollTop;
      var status = '11';
      /* istanbul ignore next */

      if (scrollTop === 0) {
        status = offsetHeight >= scrollHeight ? '00' : '01';
      } else if (scrollTop + offsetHeight >= scrollHeight) {
        status = '10';
      }
      /* istanbul ignore next */

      if (status !== '11' && this.direction === 'vertical' && !(parseInt(status, 2) & parseInt(direction, 2))) {
        (0, _event.preventDefault)(event, true);
      }
    },
    renderOverlay: function renderOverlay() {
      if (this.$isServer || !this.value) {
        return;
      }

      if (this.overlay) {
        (0, _overlay.openOverlay)(this, {
          zIndex: _context.context.zIndex++,
          className: this.overlayClass,
          customStyle: this.overlayStyle
        });
      } else {
        (0, _overlay.closeOverlay)(this);
      }

      this.updateZIndex();
    },
    updateZIndex: function updateZIndex() {
      var _this = this;

      this.$nextTick(function () {
        _this.$el.style.zIndex = _context.context.zIndex++;
      });
    }
  }
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MIN_DISTANCE = 10;

function getDirection(x, y) {
  if (x > y && x > MIN_DISTANCE) {
    return 'horizontal';
  }

  if (y > x && y > MIN_DISTANCE) {
    return 'vertical';
  }

  return '';
}

var TouchMixin = exports.TouchMixin = {
  data: function data() {
    return {
      direction: ''
    };
  },
  methods: {
    touchStart: function touchStart(event) {
      this.resetTouchStatus();
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    },
    touchMove: function touchMove(event) {
      var touch = event.touches[0];
      this.deltaX = touch.clientX - this.startX;
      this.deltaY = touch.clientY - this.startY;
      this.offsetX = Math.abs(this.deltaX);
      this.offsetY = Math.abs(this.deltaY);
      this.direction = this.direction || getDirection(this.offsetX, this.offsetY);
    },
    resetTouchStatus: function resetTouchStatus() {
      this.direction = '';
      this.deltaX = 0;
      this.deltaY = 0;
      this.offsetX = 0;
      this.offsetY = 0;
    }
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(151);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 *  base64.js
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */
;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(global) :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global);
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : undefined, function (global) {
    'use strict';
    // existing version for noConflict()

    global = global || {};
    var _Base64 = global.Base64;
    var version = "2.6.4";
    // constants
    var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function (bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) {
            t[bin.charAt(i)] = i;
        }return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function cb_utob(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        } else {
            var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
            return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function utob(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function cb_encode(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
            ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0),
            chars = [b64chars.charAt(ord >>> 18), b64chars.charAt(ord >>> 12 & 63), padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63), padlen >= 1 ? '=' : b64chars.charAt(ord & 63)];
        return chars.join('');
    };
    var btoa = global.btoa && typeof global.btoa == 'function' ? function (b) {
        return global.btoa(b);
    } : function (b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError('The string contains invalid characters.');
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function _encode(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function mkUriSafe(b64) {
        return b64.replace(/[+\/]/g, function (m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encode = function encode(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function encodeURI(u) {
        return encode(u, true);
    };
    var fromUint8Array;
    if (global.Uint8Array) fromUint8Array = function fromUint8Array(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = '';
        for (var i = 0, l = a.length; i < l; i += 3) {
            var a0 = a[i],
                a1 = a[i + 1],
                a2 = a[i + 2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != 'undefined' ? b64chars.charAt(ord >>> 6 & 63) : '=') + (typeof a2 != 'undefined' ? b64chars.charAt(ord & 63) : '=');
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function cb_btou(cccc) {
        switch (cccc.length) {
            case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3),
                    offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
            case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
            default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
        }
    };
    var btou = function btou(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function cb_decode(cccc) {
        var len = cccc.length,
            padlen = len % 4,
            n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0),
            chars = [fromCharCode(n >>> 16), fromCharCode(n >>> 8 & 0xff), fromCharCode(n & 0xff)];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var _atob = global.atob && typeof global.atob == 'function' ? function (a) {
        return global.atob(a);
    } : function (a) {
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function atob(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = function _decode(a) {
        return btou(_atob(a));
    };
    var _fromURI = function _fromURI(a) {
        return String(a).replace(/[-_]/g, function (m0) {
            return m0 == '-' ? '+' : '/';
        }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };
    var decode = function decode(a) {
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global.Uint8Array) toUint8Array = function toUint8Array(a) {
        return Uint8Array.from(atob(_fromURI(a)), function (c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function noConflict() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function noEnum(v) {
            return { value: v, enumerable: false, writable: true, configurable: true };
        };
        global.Base64.extendString = function () {
            Object.defineProperty(String.prototype, 'fromBase64', noEnum(function () {
                return decode(this);
            }));
            Object.defineProperty(String.prototype, 'toBase64', noEnum(function (urisafe) {
                return encode(this, urisafe);
            }));
            Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function () {
                return encode(this, true);
            }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global['Meteor']) {
        // Meteor.js
        Base64 = global.Base64;
    }
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if (typeof module !== 'undefined' && module.exports) {
        module.exports.Base64 = global.Base64;
    } else if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return global.Base64;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    // that's it!
    return { Base64: global.Base64 };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var _touch = __webpack_require__(31);

var _use = (0, _utils.use)('swipe'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  mixins: [_touch.TouchMixin],
  props: {
    width: Number,
    height: Number,
    autoplay: Number,
    vertical: Boolean,
    initialSwipe: Number,
    indicatorColor: String,
    loop: {
      type: Boolean,
      "default": true
    },
    touchable: {
      type: Boolean,
      "default": true
    },
    showIndicators: {
      type: Boolean,
      "default": true
    },
    duration: {
      type: Number,
      "default": 500
    }
  },
  data: function data() {
    return {
      computedWidth: 0,
      computedHeight: 0,
      offset: 0,
      active: 0,
      deltaX: 0,
      deltaY: 0,
      swipes: [],
      swiping: false
    };
  },
  mounted: function mounted() {
    this.initialize();

    if (!this.$isServer) {
      (0, _event.on)(window, 'resize', this.onResize, true);
    }
  },
  activated: function activated() {
    if (this.rendered) {
      this.initialize();
    }

    this.rendered = true;
  },
  destroyed: function destroyed() {
    this.clear();

    if (!this.$isServer) {
      (0, _event.off)(window, 'resize', this.onResize, true);
    }
  },
  watch: {
    swipes: function swipes() {
      this.initialize();
    },
    initialSwipe: function initialSwipe() {
      this.initialize();
    },
    autoplay: function autoplay(_autoplay) {
      if (!_autoplay) {
        this.clear();
      } else {
        this.autoPlay();
      }
    }
  },
  computed: {
    count: function count() {
      return this.swipes.length;
    },
    delta: function delta() {
      return this.vertical ? this.deltaY : this.deltaX;
    },
    size: function size() {
      return this[this.vertical ? 'computedHeight' : 'computedWidth'];
    },
    trackSize: function trackSize() {
      return this.count * this.size;
    },
    activeIndicator: function activeIndicator() {
      return (this.active + this.count) % this.count;
    },
    isCorrectDirection: function isCorrectDirection() {
      var expect = this.vertical ? 'vertical' : 'horizontal';
      return this.direction === expect;
    },
    trackStyle: function trackStyle() {
      var _ref;

      var mainAxis = this.vertical ? 'height' : 'width';
      var crossAxis = this.vertical ? 'width' : 'height';
      return _ref = {}, _ref[mainAxis] = this.trackSize + "px", _ref[crossAxis] = this[crossAxis] ? this[crossAxis] + "px" : '', _ref.transitionDuration = (this.swiping ? 0 : this.duration) + "ms", _ref.transform = "translate" + (this.vertical ? 'Y' : 'X') + "(" + this.offset + "px)", _ref;
    },
    indicatorStyle: function indicatorStyle() {
      return {
        backgroundColor: this.indicatorColor
      };
    }
  },
  methods: {
    // initialize swipe position
    initialize: function initialize(active) {
      if (active === void 0) {
        active = this.initialSwipe;
      }

      clearTimeout(this.timer);

      if (this.$el) {
        var rect = this.$el.getBoundingClientRect();
        this.computedWidth = this.width || rect.width;
        this.computedHeight = this.height || rect.height;
      }

      this.swiping = true;
      this.active = active;
      this.offset = this.count > 1 ? -this.size * this.active : 0;
      this.swipes.forEach(function (swipe) {
        swipe.offset = 0;
      });
      this.autoPlay();
    },
    onResize: function onResize() {
      this.initialize(this.activeIndicator);
    },
    onTouchStart: function onTouchStart(event) {
      if (!this.touchable) return;
      this.clear();
      this.swiping = true;
      this.touchStart(event);
      this.correctPosition();
    },
    onTouchMove: function onTouchMove(event) {
      if (!this.touchable || !this.swiping) return;
      this.touchMove(event);

      if (this.isCorrectDirection) {
        (0, _event.preventDefault)(event, true);
        this.move({
          offset: Math.min(Math.max(this.delta, -this.size), this.size)
        });
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (!this.touchable || !this.swiping) return;

      if (this.delta && this.isCorrectDirection) {
        var offset = this.vertical ? this.offsetY : this.offsetX;
        this.move({
          pace: offset > 0 ? this.delta > 0 ? -1 : 1 : 0,
          emitChange: true
        });
      }

      this.swiping = false;
      this.autoPlay();
    },
    move: function move(_ref2) {
      var _ref2$pace = _ref2.pace,
          pace = _ref2$pace === void 0 ? 0 : _ref2$pace,
          _ref2$offset = _ref2.offset,
          offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
          emitChange = _ref2.emitChange;
      var delta = this.delta,
          active = this.active,
          count = this.count,
          swipes = this.swipes,
          trackSize = this.trackSize;
      var atFirst = active === 0;
      var atLast = active === count - 1;
      var outOfBounds = !this.loop && (atFirst && (offset > 0 || pace < 0) || atLast && (offset < 0 || pace > 0));

      if (outOfBounds || count <= 1) {
        return;
      }

      if (swipes[0]) {
        swipes[0].offset = atLast && (delta < 0 || pace > 0) ? trackSize : 0;
      }

      if (swipes[count - 1]) {
        swipes[count - 1].offset = atFirst && (delta > 0 || pace < 0) ? -trackSize : 0;
      }

      if (pace && active + pace >= -1 && active + pace <= count) {
        this.active += pace;

        if (emitChange) {
          this.$emit('change', this.activeIndicator);
        }
      }

      this.offset = Math.round(offset - this.active * this.size);
    },
    swipeTo: function swipeTo(index) {
      var _this = this;

      this.swiping = true;
      this.resetTouchStatus();
      this.correctPosition();
      setTimeout(function () {
        _this.swiping = false;

        _this.move({
          pace: index % _this.count - _this.active,
          emitChange: true
        });
      }, 30);
    },
    correctPosition: function correctPosition() {
      if (this.active <= -1) {
        this.move({
          pace: this.count
        });
      }

      if (this.active >= this.count) {
        this.move({
          pace: -this.count
        });
      }
    },
    clear: function clear() {
      clearTimeout(this.timer);
    },
    autoPlay: function autoPlay() {
      var _this2 = this;

      var autoplay = this.autoplay;

      if (autoplay && this.count > 1) {
        this.clear();
        this.timer = setTimeout(function () {
          _this2.swiping = true;

          _this2.resetTouchStatus();

          _this2.correctPosition();

          setTimeout(function () {
            _this2.swiping = false;

            _this2.move({
              pace: 1,
              emitChange: true
            });

            _this2.autoPlay();
          }, 30);
        }, autoplay);
      }
    }
  },
  render: function render(h) {
    var _this3 = this;

    var count = this.count,
        activeIndicator = this.activeIndicator;
    var Indicator = this.slots('indicator') || this.showIndicators && count > 1 && h("div", {
      "class": bem('indicators', {
        vertical: this.vertical
      })
    }, [Array.apply(void 0, Array(count)).map(function (empty, index) {
      return h("i", {
        "class": bem('indicator', {
          active: index === activeIndicator
        }),
        "style": index === activeIndicator ? _this3.indicatorStyle : null
      });
    })]);
    return h("div", {
      "class": bem()
    }, [h("div", {
      "ref": "track",
      "style": this.trackStyle,
      "class": bem('track'),
      "on": {
        "touchstart": this.onTouchStart,
        "touchmove": this.onTouchMove,
        "touchend": this.onTouchEnd,
        "touchcancel": this.onTouchEnd
      }
    }, [this.slots()]), Indicator]);
  }
});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('swipe-item'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  data: function data() {
    return {
      offset: 0
    };
  },
  beforeCreate: function beforeCreate() {
    this.$parent.swipes.push(this);
  },
  destroyed: function destroyed() {
    this.$parent.swipes.splice(this.$parent.swipes.indexOf(this), 1);
  },
  render: function render(h) {
    var _this$$parent = this.$parent,
        vertical = _this$$parent.vertical,
        computedWidth = _this$$parent.computedWidth,
        computedHeight = _this$$parent.computedHeight;
    var style = {
      width: computedWidth + 'px',
      height: vertical ? computedHeight + 'px' : '100%',
      transform: "translate" + (vertical ? 'Y' : 'X') + "(" + this.offset + "px)"
    };
    return h("div", {
      "class": bem(),
      "style": style,
      "on": (0, _extends3.default)({}, this.$listeners)
    }, [this.slots()]);
  }
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/* global define */

/* eslint-disable strict */

;(function ($) {
  'use strict';

  /**
   * Add integers, wrapping at 2^32.
   * This uses 16-bit operations internally to work around bugs in interpreters.
   *
   * @param {number} x First integer
   * @param {number} y Second integer
   * @returns {number} Sum
   */

  function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
  }

  /**
   * Bitwise rotate a 32-bit number to the left.
   *
   * @param {number} num 32-bit number
   * @param {number} cnt Rotation count
   * @returns {number} Rotated number
   */
  function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }

  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} q q
   * @param {number} a a
   * @param {number} b b
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
  }

  /**
   * Calculate the MD5 of an array of little-endian words, and a bit length.
   *
   * @param {Array} x Array of little-endian words
   * @param {number} len Bit length
   * @returns {Array<number>} MD5 Array
   */
  function binlMD5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;

    var i;
    var olda;
    var oldb;
    var oldc;
    var oldd;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (i = 0; i < x.length; i += 16) {
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;

      a = md5ff(a, b, c, d, x[i], 7, -680876936);
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5gg(b, c, d, a, x[i], 20, -373897302);
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

      a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5hh(d, a, b, c, x[i], 11, -358537222);
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

      a = md5ii(a, b, c, d, x[i], 6, -198630844);
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

      a = safeAdd(a, olda);
      b = safeAdd(b, oldb);
      c = safeAdd(c, oldc);
      d = safeAdd(d, oldd);
    }
    return [a, b, c, d];
  }

  /**
   * Convert an array of little-endian words to a string
   *
   * @param {Array<number>} input MD5 Array
   * @returns {string} MD5 string
   */
  function binl2rstr(input) {
    var i;
    var output = '';
    var length32 = input.length * 32;
    for (i = 0; i < length32; i += 8) {
      output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
    }
    return output;
  }

  /**
   * Convert a raw string to an array of little-endian words
   * Characters >255 have their high-byte silently ignored.
   *
   * @param {string} input Raw input string
   * @returns {Array<number>} Array of little-endian words
   */
  function rstr2binl(input) {
    var i;
    var output = [];
    output[(input.length >> 2) - 1] = undefined;
    for (i = 0; i < output.length; i += 1) {
      output[i] = 0;
    }
    var length8 = input.length * 8;
    for (i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
    }
    return output;
  }

  /**
   * Calculate the MD5 of a raw string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */
  function rstrMD5(s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
  }

  /**
   * Calculates the HMAC-MD5 of a key and some data (raw strings)
   *
   * @param {string} key HMAC key
   * @param {string} data Raw input string
   * @returns {string} Raw MD5 string
   */
  function rstrHMACMD5(key, data) {
    var i;
    var bkey = rstr2binl(key);
    var ipad = [];
    var opad = [];
    var hash;
    ipad[15] = opad[15] = undefined;
    if (bkey.length > 16) {
      bkey = binlMD5(bkey, key.length * 8);
    }
    for (i = 0; i < 16; i += 1) {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5c5c5c5c;
    }
    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
  }

  /**
   * Convert a raw string to a hex string
   *
   * @param {string} input Raw input string
   * @returns {string} Hex encoded string
   */
  function rstr2hex(input) {
    var hexTab = '0123456789abcdef';
    var output = '';
    var x;
    var i;
    for (i = 0; i < input.length; i += 1) {
      x = input.charCodeAt(i);
      output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
    }
    return output;
  }

  /**
   * Encode a string as UTF-8
   *
   * @param {string} input Input string
   * @returns {string} UTF8 string
   */
  function str2rstrUTF8(input) {
    return unescape(encodeURIComponent(input));
  }

  /**
   * Encodes input string as raw MD5 string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */
  function rawMD5(s) {
    return rstrMD5(str2rstrUTF8(s));
  }
  /**
   * Encodes input string as Hex encoded string
   *
   * @param {string} s Input string
   * @returns {string} Hex encoded string
   */
  function hexMD5(s) {
    return rstr2hex(rawMD5(s));
  }
  /**
   * Calculates the raw HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */
  function rawHMACMD5(k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
  }
  /**
   * Calculates the Hex encoded HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */
  function hexHMACMD5(k, d) {
    return rstr2hex(rawHMACMD5(k, d));
  }

  /**
   * Calculates MD5 value for a given string.
   * If a key is provided, calculates the HMAC-MD5 value.
   * Returns a Hex encoded string unless the raw argument is given.
   *
   * @param {string} string Input string
   * @param {string} [key] HMAC key
   * @param {boolean} [raw] Raw output switch
   * @returns {string} MD5 output
   */
  function md5(string, key, raw) {
    if (!key) {
      if (!raw) {
        return hexMD5(string);
      }
      return rawMD5(string);
    }
    if (!raw) {
      return hexHMACMD5(key, string);
    }
    return rawHMACMD5(key, string);
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return md5;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    module.exports = md5;
  } else {
    $.md5 = md5;
  }
})(undefined);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(79);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(80);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _newim = __webpack_require__(84);

var _newim2 = _interopRequireDefault(_newim);

var _yunxinim = __webpack_require__(206);

var _yunxinim2 = _interopRequireDefault(_yunxinim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  loginIM: loginIM,
  logout: logout,
  loginYunXinChatRoom: loginYunXinChatRoom,
  sendApplyLink: sendApplyLink,
  sendSureLink: sendSureLink,
  sendRefuseLink: sendRefuseLink,
  sendCannotLink: sendCannotLink,
  sendTextMsg: sendTextMsg,
  onSendP2PMsg: onSendP2PMsg,
  studentOneKeyLinkMic: studentOneKeyLinkMic

  // var memberMsgListener
  // function setMemberMsgListener (cb) {
  //   memberMsgListener = cb
  // }

  // var imStatusListener
  // function setImStatusListener (cb) {
  //   imStatusListener = cb
  // }

  // var normalCallBack // 普通消息回调，在互动页面显示的消息为普通消息
  // function setMsgListener (cb) {
  //   normalCallBack = cb
  // }
};
var currIMType = 0; // 1 腾讯  2 网易
var loginInfo = {};
// 配置IM
function loginIM(data, imType, callBackObj) {
  // currentGroupId = data.room_id
  // loginInfo.identifier = data.fans_id
  // loginInfo.identifierNick = data.nick
  // loginInfo.headurl = data.header
  // loginInfo.userSig = data.tsl_sig
  loginInfo = data;
  currIMType = imType;
  if (imType === 1) {
    // 腾讯IM
    _newim2.default.configIM(data);
    _newim2.default.logout(function () {
      _newim2.default.loginAndJoinGroup(function (isOK) {
        if (isOK) {
          console.log('加入直播间成功1204');
          // 发送消息
          _newim2.default.setMsgListener(function (msgdata) {
            // 群聊消息
            callBackObj && callBackObj.setMsgListener && callBackObj.setMsgListener(msgdata);
          });
          _newim2.default.setImStatusListener(function (msgdata) {
            // im状态
            callBackObj && callBackObj.setImStatusListener && callBackObj.setImStatusListener(msgdata);
          });
          _newim2.default.setMemberMsgListener(function (msgdata) {
            // 私聊消息
            callBackObj && callBackObj.setMemberMsgListener && callBackObj.setMemberMsgListener(msgdata);
          });
        }
      });
    });
  } else if (imType === 2) {
    // 网易IM
    // appKey: data.appKey,
    // account: data.fans_id,
    // token: data.token,
    // chatroomId: data.chatroomId,
    // chatroomAddresses: data.address,
    // quickReconnect: true,
    // tags: data.tags,
    _yunxinim2.default.setMsgListener(function (msgdata, element) {
      // 群聊消息
      callBackObj && callBackObj.setMsgListener && callBackObj.setMsgListener(msgdata, element);
    });
    _yunxinim2.default.setImStatusListener(function (msgdata) {
      // im状态
      callBackObj && callBackObj.setImStatusListener && callBackObj.setImStatusListener(msgdata);
    });
    _yunxinim2.default.setMemberMsgListener(function (msgdata) {
      // 私聊消息
      callBackObj && callBackObj.setMemberMsgListener && callBackObj.setMemberMsgListener(msgdata);
    });
    _yunxinim2.default.loginIM(data);
  }
}

function loginYunXinChatRoom(data, callBackObj) {
  _yunxinim2.default.setImStatusListener(function (msgdata) {
    // im状态
    callBackObj && callBackObj.setImStatusListener && callBackObj.setImStatusListener(msgdata);
  });
  _yunxinim2.default.loginYunXinChatRoom(data);
}

// 申请连麦
function sendApplyLink() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'applyLink';

  // var text = JSON.stringify(obj)
  onSendMsg(obj);
}

// 接收老师邀请，确认上麦
function sendSureLink() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'sureLink';
  // var text = JSON.stringify(obj)
  onSendMsg(obj);
}

// 学生一键连麦
function studentOneKeyLinkMic() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.student_onekey_linkMic = 1;
  obj.module = 'applyLink';
  // var text = JSON.stringify(obj)
  onSendMsg(obj);
}

// 接收老师邀请，拒绝上麦
function sendRefuseLink() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'refuseLink';
  // var text = JSON.stringify(obj)
  onSendMsg(obj);
}

function sendTextMsg(msg) {
  // var text = JSON.stringify(msg)
  onSendMsg(msg);
}

// 当前设备不支持连麦
function sendCannotLink(content) {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'cannotLink';
  obj.content = content;
  // var text = JSON.stringify(obj)
  onSendMsg(obj);
}
// eslint-disable-next-line no-extend-native
Date.prototype.pattern = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468' : '') + week[this.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

// 发送IM消息
function onSendMsg(text) {
  if (currIMType === 2) {
    // 云信
    _yunxinim2.default.sendTextMsg(text);
  } else {
    // 腾讯
    _newim2.default.sendTextMsg(text);
  }
}

// eslint-disable-next-line camelcase
function onSendP2PMsg(text, fans_id) {
  if (currIMType === 2) {
    // 云信
    _yunxinim2.default.onSendP2PMsg(text, fans_id);
  } else {
    // 腾讯
    _newim2.default.onSendP2PMsg(text, fans_id);
  }
}

function logout(params) {
  if (currIMType == 2) {
    _yunxinim2.default.logout();
  } else {
    _newim2.default.logout(function () {});
  }
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)
__webpack_require__(368)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  "data-v-030933f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(13);
var normalizeHeaderName = __webpack_require__(157);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(63);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(63);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _findParent = __webpack_require__(76);

/* eslint-disable object-shorthand */
var _use = (0, _utils.use)('tab'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  mixins: [_findParent.FindParentMixin],
  props: {
    title: String,
    disabled: Boolean
  },
  data: function data() {
    return {
      inited: false
    };
  },
  computed: {
    index: function index() {
      return this.parent.tabs.indexOf(this);
    },
    selected: function selected() {
      return this.index === this.parent.curActive;
    }
  },
  watch: {
    'parent.curActive': function parentCurActive() {
      this.inited = this.inited || this.selected;
    },
    title: function title() {
      this.parent.setLine();
    }
  },
  created: function created() {
    this.findParent('van-tabs');
  },
  mounted: function mounted() {
    var tabs = this.parent.tabs;
    var index = this.parent.slots().indexOf(this.$vnode);
    tabs.splice(index === -1 ? tabs.length : index, 0, this);

    if (this.slots('title')) {
      this.parent.renderTitle(this.$refs.title, this.index);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.parent.tabs.splice(this.index, 1);
  },
  render: function render(h) {
    var slots = this.slots;
    var shouldRender = this.inited || !this.parent.lazyRender;
    return h("div", {
      "directives": [{
        name: "show",
        value: this.selected || this.parent.animated
      }],
      "class": bem('pane')
    }, [shouldRender ? slots() : h(), slots('title') && h("div", {
      "ref": "title"
    }, [slots('title')])]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _raf = __webpack_require__(192);

var _event = __webpack_require__(12);

var _touch = __webpack_require__(31);

var _scroll = __webpack_require__(27);

var _use = (0, _utils.use)('tabs'),
    sfc = _use[0],
    bem = _use[1];

var tabBem = (0, _utils.use)('tab')[1];
exports.default = sfc({
  mixins: [_touch.TouchMixin],
  model: {
    prop: 'active'
  },
  props: {
    color: String,
    sticky: Boolean,
    animated: Boolean,
    offsetTop: Number,
    swipeable: Boolean,
    background: String,
    titleActiveColor: String,
    titleInactiveColor: String,
    ellipsis: {
      type: Boolean,
      "default": true
    },
    lazyRender: {
      type: Boolean,
      "default": true
    },
    lineWidth: {
      type: Number,
      "default": null
    },
    lineHeight: {
      type: Number,
      "default": null
    },
    active: {
      type: [Number, String],
      "default": 0
    },
    type: {
      type: String,
      "default": 'line'
    },
    duration: {
      type: Number,
      "default": 0.3
    },
    swipeThreshold: {
      type: Number,
      "default": 4
    }
  },
  data: function data() {
    return {
      tabs: [],
      position: '',
      curActive: null,
      lineStyle: {
        backgroundColor: this.color
      },
      events: {
        resize: false,
        sticky: false,
        swipeable: false
      }
    };
  },
  computed: {
    // whether the nav is scrollable
    scrollable: function scrollable() {
      return this.tabs.length > this.swipeThreshold || !this.ellipsis;
    },
    wrapStyle: function wrapStyle() {
      switch (this.position) {
        case 'top':
          return {
            top: this.offsetTop + 'px',
            position: 'fixed'
          };

        case 'bottom':
          return {
            top: 'auto',
            bottom: 0
          };

        default:
          return null;
      }
    },
    navStyle: function navStyle() {
      return {
        borderColor: this.color,
        background: this.background
      };
    },
    trackStyle: function trackStyle() {
      if (this.animated) {
        return {
          left: -1 * this.curActive * 100 + "%",
          transitionDuration: this.duration + "s"
        };
      }
    }
  },
  watch: {
    active: function active(val) {
      if (val !== this.curActive) {
        this.correctActive(val);
      }
    },
    color: function color() {
      this.setLine();
    },
    tabs: function tabs() {
      this.correctActive(this.curActive || this.active);
      this.scrollIntoView();
      this.setLine();
    },
    curActive: function curActive() {
      this.scrollIntoView();
      this.setLine(); // scroll to correct position

      if (this.position === 'top' || this.position === 'bottom') {
        (0, _scroll.setScrollTop)(window, (0, _scroll.getElementTop)(this.$el) - this.offsetTop);
      }
    },
    sticky: function sticky() {
      this.handlers(true);
    },
    swipeable: function swipeable() {
      this.handlers(true);
    }
  },
  mounted: function mounted() {
    this.onShow();
  },
  activated: function activated() {
    this.onShow();
    this.setLine();
  },
  deactivated: function deactivated() {
    this.handlers(false);
  },
  beforeDestroy: function beforeDestroy() {
    this.handlers(false);
  },
  methods: {
    onShow: function onShow() {
      var _this = this;

      this.$nextTick(function () {
        _this.inited = true;

        _this.handlers(true);

        _this.scrollIntoView(true);
      });
    },
    // whether to bind sticky listener
    handlers: function handlers(bind) {
      var events = this.events;
      var sticky = this.sticky && bind;
      var swipeable = this.swipeable && bind; // listen to window resize event

      if (events.resize !== bind) {
        events.resize = bind;
        (bind ? _event.on : _event.off)(window, 'resize', this.setLine, true);
      } // listen to scroll event


      if (events.sticky !== sticky) {
        events.sticky = sticky;
        this.scrollEl = this.scrollEl || (0, _scroll.getScrollEventTarget)(this.$el);
        (sticky ? _event.on : _event.off)(this.scrollEl, 'scroll', this.onScroll, true);
        this.onScroll();
      } // listen to touch event


      if (events.swipeable !== swipeable) {
        events.swipeable = swipeable;
        var content = this.$refs.content;
        var action = swipeable ? _event.on : _event.off;
        action(content, 'touchstart', this.touchStart);
        action(content, 'touchmove', this.touchMove);
        action(content, 'touchend', this.onTouchEnd);
        action(content, 'touchcancel', this.onTouchEnd);
      }
    },
    // watch swipe touch end
    onTouchEnd: function onTouchEnd() {
      var direction = this.direction,
          deltaX = this.deltaX,
          curActive = this.curActive;
      var minSwipeDistance = 50;
      /* istanbul ignore else */

      if (direction === 'horizontal' && this.offsetX >= minSwipeDistance) {
        /* istanbul ignore else */
        if (deltaX > 0 && curActive !== 0) {
          this.setCurActive(curActive - 1);
        } else if (deltaX < 0 && curActive !== this.tabs.length - 1) {
          this.setCurActive(curActive + 1);
        }
      }
    },
    // adjust tab position
    onScroll: function onScroll() {
      var scrollTop = (0, _scroll.getScrollTop)(window) + this.offsetTop;
      var elTopToPageTop = (0, _scroll.getElementTop)(this.$el);
      var elBottomToPageTop = elTopToPageTop + this.$el.offsetHeight - this.$refs.wrap.offsetHeight;

      if (scrollTop > elBottomToPageTop) {
        this.position = 'bottom';
      } else if (scrollTop > elTopToPageTop) {
        this.position = 'top';
      } else {
        this.position = '';
      }

      var scrollParams = {
        scrollTop: scrollTop,
        isFixed: this.position === 'top'
      };
      this.$emit('scroll', scrollParams);
    },
    // update nav bar style
    setLine: function setLine() {
      var _this2 = this;

      var shouldAnimate = this.inited;
      this.$nextTick(function () {
        var tabs = _this2.$refs.tabs;

        if (!tabs || !tabs[_this2.curActive] || _this2.type !== 'line') {
          return;
        }

        var tab = tabs[_this2.curActive];
        var lineWidth = _this2.lineWidth,
            lineHeight = _this2.lineHeight;
        var width = (0, _utils.isDef)(lineWidth) ? lineWidth : tab.offsetWidth / 2;
        var left = tab.offsetLeft + (tab.offsetWidth - width) / 2;
        var lineStyle = {
          width: width + "px",
          backgroundColor: _this2.color,
          transform: "translateX(" + left + "px)"
        };

        if (shouldAnimate) {
          lineStyle.transitionDuration = _this2.duration + "s";
        }

        if ((0, _utils.isDef)(lineHeight)) {
          var height = lineHeight + "px";
          lineStyle.height = height;
          lineStyle.borderRadius = height;
        }

        _this2.lineStyle = lineStyle;
      });
    },
    // correct the value of active
    correctActive: function correctActive(active) {
      active = +active;
      var exist = this.tabs.some(function (tab) {
        return tab.index === active;
      });
      var defaultActive = (this.tabs[0] || {}).index || 0;
      this.setCurActive(exist ? active : defaultActive);
    },
    setCurActive: function setCurActive(active) {
      active = this.findAvailableTab(active, active < this.curActive);

      if ((0, _utils.isDef)(active) && active !== this.curActive) {
        this.$emit('input', active);

        if (this.curActive !== null) {
          this.$emit('change', active, this.tabs[active].title);
        }

        this.curActive = active;
      }
    },
    findAvailableTab: function findAvailableTab(active, reverse) {
      var diff = reverse ? -1 : 1;
      var index = active;

      while (index >= 0 && index < this.tabs.length) {
        if (!this.tabs[index].disabled) {
          return index;
        }

        index += diff;
      }
    },
    // emit event when clicked
    onClick: function onClick(index) {
      var _this$tabs$index = this.tabs[index],
          title = _this$tabs$index.title,
          disabled = _this$tabs$index.disabled;

      if (disabled) {
        this.$emit('disabled', index, title);
      } else {
        this.setCurActive(index);
        this.$emit('click', index, title);
      }
    },
    // scroll active tab into view
    scrollIntoView: function scrollIntoView(immediate) {
      var tabs = this.$refs.tabs;

      if (!this.scrollable || !tabs || !tabs[this.curActive]) {
        return;
      }

      var nav = this.$refs.nav;
      var scrollLeft = nav.scrollLeft,
          navWidth = nav.offsetWidth;
      var _tabs$this$curActive = tabs[this.curActive],
          offsetLeft = _tabs$this$curActive.offsetLeft,
          tabWidth = _tabs$this$curActive.offsetWidth;
      this.scrollTo(nav, scrollLeft, offsetLeft - (navWidth - tabWidth) / 2, immediate);
    },
    // animate the scrollLeft of nav
    scrollTo: function scrollTo(el, from, to, immediate) {
      if (immediate) {
        el.scrollLeft += to - from;
        return;
      }

      var count = 0;
      var frames = Math.round(this.duration * 1000 / 16);

      var animate = function animate() {
        el.scrollLeft += (to - from) / frames;
        /* istanbul ignore next */

        if (++count < frames) {
          (0, _raf.raf)(animate);
        }
      };

      animate();
    },
    // render title slot of child tab
    renderTitle: function renderTitle(el, index) {
      var _this3 = this;

      this.$nextTick(function () {
        var title = _this3.$refs.title[index];
        title.parentNode.replaceChild(el, title);
      });
    },
    getTabStyle: function getTabStyle(item, index) {
      var style = {};
      var color = this.color;
      var active = index === this.curActive;
      var isCard = this.type === 'card'; // theme color

      if (color) {
        if (!item.disabled && isCard && !active) {
          style.color = color;
        }

        if (!item.disabled && isCard && active) {
          style.backgroundColor = color;
        }

        if (isCard) {
          style.borderColor = color;
        }
      }

      var titleColor = active ? this.titleActiveColor : this.titleInactiveColor;

      if (titleColor) {
        style.color = titleColor;
      }

      if (this.scrollable && this.ellipsis) {
        style.flexBasis = 88 / this.swipeThreshold + '%';
      }

      return style;
    }
  },
  render: function render(h) {
    var _this4 = this;

    var type = this.type,
        ellipsis = this.ellipsis,
        animated = this.animated,
        scrollable = this.scrollable;
    var Nav = this.tabs.map(function (tab, index) {
      return h("div", {
        "ref": "tabs",
        "refInFor": true,
        "class": tabBem({
          active: index === _this4.curActive,
          disabled: tab.disabled,
          complete: !ellipsis
        }),
        "style": _this4.getTabStyle(tab, index),
        "on": {
          "click": function click() {
            _this4.onClick(index);
          }
        }
      }, [h("span", {
        "ref": "title",
        "refInFor": true,
        "class": {
          'van-ellipsis': ellipsis
        }
      }, [tab.title])]);
    });
    return h("div", {
      "class": bem([type])
    }, [h("div", {
      "ref": "wrap",
      "style": this.wrapStyle,
      "class": [bem('wrap', {
        scrollable: scrollable
      }), {
        'van-hairline--top-bottom': type === 'line'
      }]
    }, [h("div", {
      "ref": "nav",
      "class": bem('nav', [type]),
      "style": this.navStyle
    }, [this.slots('nav-left'), type === 'line' && h("div", {
      "class": bem('line'),
      "style": this.lineStyle
    }), Nav, this.slots('nav-right')])]), h("div", {
      "ref": "content",
      "class": bem('content', {
        animated: animated
      })
    }, [animated ? h("div", {
      "class": bem('track'),
      "style": this.trackStyle
    }, [this.slots()]) : this.slots()])]);
  }
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _icon = __webpack_require__(23);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('notice-bar'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    text: String,
    mode: String,
    color: String,
    leftIcon: String,
    wrapable: Boolean,
    background: String,
    delay: {
      type: [String, Number],
      "default": 1
    },
    scrollable: {
      type: Boolean,
      "default": true
    },
    speed: {
      type: Number,
      "default": 50
    }
  },
  data: function data() {
    return {
      wrapWidth: 0,
      firstRound: true,
      duration: 0,
      offsetWidth: 0,
      showNoticeBar: true,
      animationClass: ''
    };
  },
  watch: {
    text: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          var _this$$refs = _this.$refs,
              wrap = _this$$refs.wrap,
              content = _this$$refs.content;

          if (!wrap || !content) {
            return;
          }

          var wrapWidth = wrap.getBoundingClientRect().width;
          var offsetWidth = content.getBoundingClientRect().width;

          if (_this.scrollable && offsetWidth > wrapWidth) {
            _this.wrapWidth = wrapWidth;
            _this.offsetWidth = offsetWidth;
            _this.duration = offsetWidth / _this.speed;
            _this.animationClass = bem('play');
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    onClickIcon: function onClickIcon() {
      if (this.mode === 'closeable') {
        this.showNoticeBar = false;
        this.$emit('close');
      }
    },
    onAnimationEnd: function onAnimationEnd() {
      var _this2 = this;

      this.firstRound = false;
      this.$nextTick(function () {
        _this2.duration = (_this2.offsetWidth + _this2.wrapWidth) / _this2.speed;
        _this2.animationClass = bem('play--infinite');
      });
    }
  },
  render: function render(h) {
    var _this3 = this;

    var mode = this.mode;
    var iconName = mode === 'closeable' ? 'cross' : mode === 'link' ? 'arrow' : '';
    var barStyle = {
      color: this.color,
      background: this.background
    };
    var contentStyle = {
      paddingLeft: this.firstRound ? 0 : this.wrapWidth + 'px',
      animationDelay: (this.firstRound ? this.delay : 0) + 's',
      animationDuration: this.duration + 's'
    };
    return h("div", {
      "directives": [{
        name: "show",
        value: this.showNoticeBar
      }],
      "class": bem({
        withicon: mode,
        wrapable: this.wrapable
      }),
      "style": barStyle,
      "on": {
        "click": function click() {
          _this3.$emit('click');
        }
      }
    }, [this.leftIcon && h(_icon2.default, {
      "class": bem('left-icon'),
      "attrs": {
        "name": this.leftIcon
      }
    }), h("div", {
      "ref": "wrap",
      "class": bem('wrap')
    }, [h("div", {
      "ref": "content",
      "class": [bem('content'), this.animationClass, {
        'van-ellipsis': !this.scrollable && !this.wrapable
      }],
      "style": contentStyle,
      "on": {
        "animationend": this.onAnimationEnd,
        "webkitAnimationEnd": this.onAnimationEnd
      }
    }, [this.slots() || this.text])]), iconName && h(_icon2.default, {
      "class": bem('right-icon'),
      "attrs": {
        "name": iconName
      },
      "on": {
        "click": this.onClickIcon
      }
    })]);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Dialog = __webpack_require__(193);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance;

function initInstance() {
  if (instance) {
    instance.$destroy();
  }

  instance = new (_vue2.default.extend(_Dialog2.default))({
    el: document.createElement('div'),
    // avoid missing animation when first rendered
    propsData: {
      lazyRender: false
    }
  });
  instance.$on('input', function (value) {
    instance.value = value;
  });
}

function Dialog(options) {
  /* istanbul ignore if */
  if (_utils.isServer) {
    return Promise.resolve();
  }

  return new Promise(function (resolve, reject) {
    if (!instance || !(0, _utils.isInDocument)(instance.$el)) {
      initInstance();
    }

    (0, _extends3.default)(instance, Dialog.currentOptions, options, {
      resolve: resolve,
      reject: reject
    });
  });
}

Dialog.defaultOptions = {
  value: true,
  title: '',
  message: '',
  overlay: true,
  className: '',
  lockScroll: true,
  beforeClose: null,
  messageAlign: '',
  getContainer: 'body',
  cancelButtonText: '',
  cancelButtonColor: null,
  confirmButtonText: '',
  confirmButtonColor: null,
  showConfirmButton: true,
  showCancelButton: false,
  closeOnClickOverlay: false,
  callback: function callback(action) {
    instance[action === 'confirm' ? 'resolve' : 'reject'](action);
  }
};
Dialog.alert = Dialog;

Dialog.confirm = function (options) {
  return Dialog((0, _extends3.default)({
    showCancelButton: true
  }, options));
};

Dialog.close = function () {
  if (instance) {
    instance.value = false;
  }
};

Dialog.setDefaultOptions = function (options) {
  (0, _extends3.default)(Dialog.currentOptions, options);
};

Dialog.resetDefaultOptions = function () {
  Dialog.currentOptions = (0, _extends3.default)({}, Dialog.defaultOptions);
};

Dialog.resetDefaultOptions();

Dialog.install = function () {
  _vue2.default.use(_Dialog2.default);
};

_vue2.default.prototype.$dialog = Dialog;
exports.default = Dialog;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(200);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(202);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(32);

__webpack_require__(204);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function throwTypeError() {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
	try {
		// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
		arguments.callee; // IE 8 does not throw here
		return throwTypeError;
	} catch (calleeThrows) {
		try {
			// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
			return $gOPD(arguments, 'callee').get;
		} catch (gOPDthrows) {
			return throwTypeError;
		}
	}
}() : throwTypeError;

var hasSymbols = __webpack_require__(210)();
var hasProto = __webpack_require__(212)();

var getProto = Object.getPrototypeOf || (hasProto ? function (x) {
	return x.__proto__;
} // eslint-disable-line no-proto
: null);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': (typeof JSON === 'undefined' ? 'undefined' : _typeof(JSON)) === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(52);
var hasOwn = __webpack_require__(214);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && i + 1 >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(213);

module.exports = Function.prototype.bind || implementation;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function RFC1738(value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function RFC3986(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-16c6edc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  "data-v-e8888c28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _icon = __webpack_require__(23);

var _icon2 = _interopRequireDefault(_icon);

var _cell = __webpack_require__(126);

var _cell2 = _interopRequireDefault(_cell);

var _shared = __webpack_require__(127);

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var _scroll = __webpack_require__(27);

var _number = __webpack_require__(481);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('field'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  inheritAttrs: false,
  props: (0, _extends3.default)({}, _shared.cellProps, {
    error: Boolean,
    leftIcon: String,
    rightIcon: String,
    readonly: Boolean,
    clearable: Boolean,
    labelWidth: [String, Number],
    labelAlign: String,
    inputAlign: String,
    onIconClick: Function,
    autosize: [Boolean, Object],
    errorMessage: String,
    errorMessageAlign: String,
    type: {
      type: String,
      "default": 'text'
    }
  }),
  data: function data() {
    return {
      focused: false
    };
  },
  watch: {
    value: function value() {
      this.$nextTick(this.adjustSize);
    }
  },
  mounted: function mounted() {
    this.format();
    this.$nextTick(this.adjustSize);
  },
  computed: {
    showClear: function showClear() {
      return this.clearable && this.focused && this.value !== '' && (0, _utils.isDef)(this.value) && !this.readonly;
    },
    listeners: function listeners() {
      return (0, _extends3.default)({}, this.$listeners, {
        input: this.onInput,
        keypress: this.onKeypress,
        focus: this.onFocus,
        blur: this.onBlur
      });
    },
    labelStyle: function labelStyle() {
      var labelWidth = this.labelWidth;

      if (labelWidth) {
        var width = (0, _number.isNumber)(String(labelWidth)) ? labelWidth + "px" : labelWidth;
        return {
          maxWidth: width,
          minWidth: width
        };
      }
    }
  },
  methods: {
    focus: function focus() {
      this.$refs.input && this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input && this.$refs.input.blur();
    },
    // native maxlength not work when type = number
    format: function format(target) {
      if (target === void 0) {
        target = this.$refs.input;
      }

      var _target = target,
          value = _target.value;
      var maxlength = this.$attrs.maxlength;

      if (this.type === 'number' && (0, _utils.isDef)(maxlength) && value.length > maxlength) {
        value = value.slice(0, maxlength);
        target.value = value;
      }

      return value;
    },
    onInput: function onInput(event) {
      this.$emit('input', this.format(event.target));
    },
    onFocus: function onFocus(event) {
      this.focused = true;
      this.$emit('focus', event); // hack for safari

      /* istanbul ignore if */

      if (this.readonly) {
        this.blur();
      }
    },
    onBlur: function onBlur(event) {
      this.focused = false;
      this.$emit('blur', event); // Hack for iOS12 page scroll
      // https://developers.weixin.qq.com/community/develop/doc/00044ae90742f8c82fb78fcae56800

      /* istanbul ignore next */

      if ((0, _utils.isIOS)()) {
        window.scrollTo(0, (0, _scroll.getRootScrollTop)());
      }
    },
    onClickLeftIcon: function onClickLeftIcon() {
      this.$emit('click-left-icon');
    },
    onClickRightIcon: function onClickRightIcon() {
      // compatible old version
      this.$emit('click-icon');
      this.$emit('click-right-icon');
      this.onIconClick && this.onIconClick();
    },
    onClear: function onClear(event) {
      (0, _event.preventDefault)(event);
      this.$emit('input', '');
      this.$emit('clear');
    },
    onKeypress: function onKeypress(event) {
      if (this.type === 'number') {
        var keyCode = event.keyCode;
        var allowPoint = String(this.value).indexOf('.') === -1;
        var isValidKey = keyCode >= 48 && keyCode <= 57 || keyCode === 46 && allowPoint || keyCode === 45;

        if (!isValidKey) {
          (0, _event.preventDefault)(event);
        }
      } // trigger blur after click keyboard search button

      /* istanbul ignore next */

      if (this.type === 'search' && event.keyCode === 13) {
        this.blur();
      }

      this.$emit('keypress', event);
    },
    adjustSize: function adjustSize() {
      var input = this.$refs.input;

      if (!(this.type === 'textarea' && this.autosize) || !input) {
        return;
      }

      input.style.height = 'auto';
      var height = input.scrollHeight;

      if ((0, _utils.isObj)(this.autosize)) {
        var _this$autosize = this.autosize,
            maxHeight = _this$autosize.maxHeight,
            minHeight = _this$autosize.minHeight;

        if (maxHeight) {
          height = Math.min(height, maxHeight);
        }

        if (minHeight) {
          height = Math.max(height, minHeight);
        }
      }

      if (height) {
        input.style.height = height + 'px';
      }
    },
    renderInput: function renderInput() {
      var h = this.$createElement;
      var inputProps = {
        ref: 'input',
        "class": bem('control', this.inputAlign),
        domProps: {
          value: this.value
        },
        attrs: (0, _extends3.default)({}, this.$attrs, {
          readonly: this.readonly
        }),
        on: this.listeners
      };

      if (this.type === 'textarea') {
        return h("textarea", (0, _babelHelperVueJsxMergeProps2.default)([{}, inputProps]));
      }

      return h("input", (0, _babelHelperVueJsxMergeProps2.default)([{
        "attrs": {
          "type": this.type
        }
      }, inputProps]));
    },
    renderLeftIcon: function renderLeftIcon() {
      var h = this.$createElement;
      var showLeftIcon = this.slots('left-icon') || this.leftIcon;

      if (showLeftIcon) {
        return h("div", {
          "class": bem('left-icon'),
          "on": {
            "click": this.onClickLeftIcon
          }
        }, [this.slots('left-icon') || h(_icon2.default, {
          "attrs": {
            "name": this.leftIcon
          }
        })]);
      }
    },
    renderRightIcon: function renderRightIcon() {
      var h = this.$createElement;
      var slots = this.slots;
      var showRightIcon = slots('right-icon') || slots('icon') || this.rightIcon || this.icon;

      if (showRightIcon) {
        return h("div", {
          "class": bem('right-icon'),
          "on": {
            "click": this.onClickRightIcon
          }
        }, [slots('right-icon') || slots('icon') || h(_icon2.default, {
          "attrs": {
            "name": this.rightIcon || this.icon
          }
        })]);
      }
    }
  },
  render: function render(h) {
    var _bem;

    var slots = this.slots,
        labelAlign = this.labelAlign;
    var scopedSlots = {
      icon: this.renderLeftIcon
    };

    if (slots('label')) {
      scopedSlots.title = function () {
        return slots('label');
      };
    }

    return h(_cell2.default, {
      "attrs": {
        "icon": this.leftIcon,
        "size": this.size,
        "title": this.label,
        "center": this.center,
        "border": this.border,
        "isLink": this.isLink,
        "required": this.required,
        "titleStyle": this.labelStyle,
        "titleClass": bem('label', labelAlign)
      },
      "class": bem((_bem = {
        error: this.error,
        disabled: this.$attrs.disabled
      }, _bem["label-" + labelAlign] = labelAlign, _bem['min-height'] = this.type === 'textarea' && !this.autosize, _bem)),
      "scopedSlots": scopedSlots
    }, [h("div", {
      "class": bem('body')
    }, [this.renderInput(), this.showClear && h(_icon2.default, {
      "attrs": {
        "name": "clear"
      },
      "class": bem('clear'),
      "on": {
        "touchstart": this.onClear
      }
    }), this.renderRightIcon(), slots('button') && h("div", {
      "class": bem('button')
    }, [slots('button')])]), this.errorMessage && h("div", {
      "class": bem('error-message', this.errorMessageAlign)
    }, [this.errorMessage])]);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(482);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _deepAssign = __webpack_require__(60);

var _zhCN = __webpack_require__(143);

var _zhCN2 = _interopRequireDefault(_zhCN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var proto = _vue2.default.prototype;
var defineReactive = _vue2.default.util.defineReactive;
defineReactive(proto, '$vantLang', 'zh-CN');
defineReactive(proto, '$vantMessages', {
  'zh-CN': _zhCN2.default
});
exports.default = {
  messages: function messages() {
    return proto.$vantMessages[proto.$vantLang];
  },
  use: function use(lang, messages) {
    var _this$add;

    proto.$vantLang = lang;
    this.add((_this$add = {}, _this$add[lang] = messages, _this$add));
  },
  add: function add(messages) {
    if (messages === void 0) {
      messages = {};
    }

    (0, _deepAssign.deepAssign)(proto.$vantMessages, messages);
  }
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepAssign = deepAssign;

var _ = __webpack_require__(5);

var hasOwnProperty = Object.prototype.hasOwnProperty; /* eslint-disable no-use-before-define */


function assignKey(to, from, key) {
  var val = from[key];

  if (!(0, _.isDef)(val)) {
    return;
  }

  if (!hasOwnProperty.call(to, key) || !(0, _.isObj)(val)) {
    to[key] = val;
  } else {
    to[key] = deepAssign(Object(to[key]), from[key]);
  }
}

function deepAssign(to, from) {
  Object.keys(from).forEach(function (key) {
    assignKey(to, from, key);
  });
  return to;
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var context = exports.context = {
  zIndex: 2000,
  lockCount: 0,
  stack: [],

  get top() {
    return this.stack[this.stack.length - 1];
  }

};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var settle = __webpack_require__(158);
var buildURL = __webpack_require__(160);
var parseHeaders = __webpack_require__(161);
var isURLSameOrigin = __webpack_require__(162);
var createError = __webpack_require__(64);
var btoa = typeof window !== 'undefined' && window.btoa && window.btoa.bind(window) || __webpack_require__(163);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || request.readyState !== 4 && !xDomain) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(164);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(159);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.TFWebLog = e() : t.TFWebLog = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;var o = n[r] = { i: r, l: !1, exports: {} };return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }var n = {};return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, { configurable: !1, enumerable: !0, get: r });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "/", e(e.s = 12);
  }([function (t, e, n) {
    "use strict";
    function r(t) {
      return "[object Array]" === E.call(t);
    }function o(t) {
      return void 0 === t;
    }function i(t) {
      return null !== t && !o(t) && null !== t.constructor && !o(t.constructor) && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
    }function s(t) {
      return "[object ArrayBuffer]" === E.call(t);
    }function u(t) {
      return "undefined" != typeof FormData && t instanceof FormData;
    }function a(t) {
      return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
    }function c(t) {
      return "string" == typeof t;
    }function f(t) {
      return "number" == typeof t;
    }function p(t) {
      return null !== t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t));
    }function l(t) {
      if ("[object Object]" !== E.call(t)) return !1;var e = Object.getPrototypeOf(t);return null === e || e === Object.prototype;
    }function d(t) {
      return "[object Date]" === E.call(t);
    }function h(t) {
      return "[object File]" === E.call(t);
    }function g(t) {
      return "[object Blob]" === E.call(t);
    }function m(t) {
      return "[object Function]" === E.call(t);
    }function _(t) {
      return p(t) && m(t.pipe);
    }function y(t) {
      return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
    }function v(t) {
      return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
    }function T() {
      return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
    }function O(t, e) {
      if (null !== t && void 0 !== t) if ("object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) && (t = [t]), r(t)) for (var n = 0, o = t.length; n < o; n++) {
        e.call(null, t[n], n, t);
      } else for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && e.call(null, t[i], i, t);
      }
    }function b() {
      function t(t, n) {
        l(e[n]) && l(t) ? e[n] = b(e[n], t) : l(t) ? e[n] = b({}, t) : r(t) ? e[n] = t.slice() : e[n] = t;
      }for (var e = {}, n = 0, o = arguments.length; n < o; n++) {
        O(arguments[n], t);
      }return e;
    }function S(t, e, n) {
      return O(e, function (e, r) {
        t[r] = n && "function" == typeof e ? C(e, n) : e;
      }), t;
    }function w(t) {
      return 65279 === t.charCodeAt(0) && (t = t.slice(1)), t;
    }var C = n(4),
        E = Object.prototype.toString;t.exports = { isArray: r, isArrayBuffer: s, isBuffer: i, isFormData: u, isArrayBufferView: a, isString: c, isNumber: f, isObject: p, isPlainObject: l, isUndefined: o, isDate: d, isFile: h, isBlob: g, isFunction: m, isStream: _, isURLSearchParams: y, isStandardBrowserEnv: T, forEach: O, merge: b, extend: S, trim: v, stripBOM: w };
  }, function (t, e, n) {
    "use strict";
    (function (e) {
      function r(t, e) {
        !i.isUndefined(t) && i.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
      }function o(t, e, n) {
        if (i.isString(t)) try {
          return (e || JSON.parse)(t), i.trim(t);
        } catch (t) {
          if ("SyntaxError" !== t.name) throw t;
        }return (n || JSON.stringify)(t);
      }var i = n(0),
          s = n(28),
          u = n(6),
          a = { "Content-Type": "application/x-www-form-urlencoded" },
          c = { transitional: { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, adapter: function () {
          var t;return "undefined" != typeof XMLHttpRequest ? t = n(7) : void 0 !== e && "[object process]" === Object.prototype.toString.call(e) && (t = n(7)), t;
        }(), transformRequest: [function (t, e) {
          return s(e, "Accept"), s(e, "Content-Type"), i.isFormData(t) || i.isArrayBuffer(t) || i.isBuffer(t) || i.isStream(t) || i.isFile(t) || i.isBlob(t) ? t : i.isArrayBufferView(t) ? t.buffer : i.isURLSearchParams(t) ? (r(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : i.isObject(t) || e && "application/json" === e["Content-Type"] ? (r(e, "application/json"), o(t)) : t;
        }], transformResponse: [function (t) {
          var e = this.transitional || c.transitional,
              n = e && e.silentJSONParsing,
              r = e && e.forcedJSONParsing,
              o = !n && "json" === this.responseType;if (o || r && i.isString(t) && t.length) try {
            return JSON.parse(t);
          } catch (t) {
            if (o) {
              if ("SyntaxError" === t.name) throw u(t, this, "E_JSON_PARSE");throw t;
            }
          }return t;
        }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, validateStatus: function validateStatus(t) {
          return t >= 200 && t < 300;
        }, headers: { common: { Accept: "application/json, text/plain, */*" } } };i.forEach(["delete", "get", "head"], function (t) {
        c.headers[t] = {};
      }), i.forEach(["post", "put", "patch"], function (t) {
        c.headers[t] = i.merge(a);
      }), t.exports = c;
    }).call(e, n(27));
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      this.message = t;
    }r.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, r.prototype.__CANCEL__ = !0, t.exports = r;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Response = void 0;var r = function () {
      function t() {
        this.httpStatusCode = 0, this.mHeaders = {}, this.errorCode = "", this.errorMessage = "";
      }return t.prototype.getHeader = function (t) {
        return this.mHeaders[t] ? this.mHeaders[t] : [];
      }, t.prototype.setHttpStatusCode = function (t) {
        this.httpStatusCode = t;
      }, t.prototype.setErrorCode = function (t) {
        this.errorCode = t;
      }, t.prototype.setErrorMessage = function (t) {
        this.errorMessage = t;
      }, t.prototype.getHttpStatusCode = function () {
        return this.httpStatusCode;
      }, t.prototype.getErrorCode = function () {
        return this.errorCode;
      }, t.prototype.getErrorMessage = function () {
        return this.errorMessage;
      }, t.prototype.setAllHeaders = function (t) {
        this.mHeaders = t;
      }, t.prototype.getAllHeaders = function () {
        return this.mHeaders;
      }, t;
    }();e.Response = r;
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t, e) {
      return function () {
        for (var n = new Array(arguments.length), r = 0; r < n.length; r++) {
          n[r] = arguments[r];
        }return t.apply(e, n);
      };
    };
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }var o = n(0);t.exports = function (t, e, n) {
      if (!e) return t;var i;if (n) i = n(e);else if (o.isURLSearchParams(e)) i = e.toString();else {
        var s = [];o.forEach(e, function (t, e) {
          null !== t && void 0 !== t && (o.isArray(t) ? e += "[]" : t = [t], o.forEach(t, function (t) {
            o.isDate(t) ? t = t.toISOString() : o.isObject(t) && (t = JSON.stringify(t)), s.push(r(e) + "=" + r(t));
          }));
        }), i = s.join("&");
      }if (i) {
        var u = t.indexOf("#");-1 !== u && (t = t.slice(0, u)), t += (-1 === t.indexOf("?") ? "?" : "&") + i;
      }return t;
    };
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t, e, n, r, o) {
      return t.config = e, n && (t.code = n), t.request = r, t.response = o, t.isAxiosError = !0, t.toJSON = function () {
        return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: this.config, code: this.code, status: this.response && this.response.status ? this.response.status : null };
      }, t;
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(0),
        o = n(29),
        i = n(30),
        s = n(5),
        u = n(31),
        a = n(34),
        c = n(35),
        f = n(8),
        p = n(1),
        l = n(2);t.exports = function (t) {
      return new Promise(function (e, n) {
        function d() {
          t.cancelToken && t.cancelToken.unsubscribe(g), t.signal && t.signal.removeEventListener("abort", g);
        }function h() {
          if (v) {
            var r = "getAllResponseHeaders" in v ? a(v.getAllResponseHeaders()) : null,
                i = y && "text" !== y && "json" !== y ? v.response : v.responseText,
                s = { data: i, status: v.status, statusText: v.statusText, headers: r, config: t, request: v };o(function (t) {
              e(t), d();
            }, function (t) {
              n(t), d();
            }, s), v = null;
          }
        }var g,
            m = t.data,
            _ = t.headers,
            y = t.responseType;r.isFormData(m) && delete _["Content-Type"];var v = new XMLHttpRequest();if (t.auth) {
          var T = t.auth.username || "",
              O = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";_.Authorization = "Basic " + btoa(T + ":" + O);
        }var b = u(t.baseURL, t.url);if (v.open(t.method.toUpperCase(), s(b, t.params, t.paramsSerializer), !0), v.timeout = t.timeout, "onloadend" in v ? v.onloadend = h : v.onreadystatechange = function () {
          v && 4 === v.readyState && (0 !== v.status || v.responseURL && 0 === v.responseURL.indexOf("file:")) && setTimeout(h);
        }, v.onabort = function () {
          v && (n(f("Request aborted", t, "ECONNABORTED", v)), v = null);
        }, v.onerror = function () {
          n(f("Network Error", t, null, v)), v = null;
        }, v.ontimeout = function () {
          var e = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded",
              r = t.transitional || p.transitional;t.timeoutErrorMessage && (e = t.timeoutErrorMessage), n(f(e, t, r.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", v)), v = null;
        }, r.isStandardBrowserEnv()) {
          var S = (t.withCredentials || c(b)) && t.xsrfCookieName ? i.read(t.xsrfCookieName) : void 0;S && (_[t.xsrfHeaderName] = S);
        }"setRequestHeader" in v && r.forEach(_, function (t, e) {
          void 0 === m && "content-type" === e.toLowerCase() ? delete _[e] : v.setRequestHeader(e, t);
        }), r.isUndefined(t.withCredentials) || (v.withCredentials = !!t.withCredentials), y && "json" !== y && (v.responseType = t.responseType), "function" == typeof t.onDownloadProgress && v.addEventListener("progress", t.onDownloadProgress), "function" == typeof t.onUploadProgress && v.upload && v.upload.addEventListener("progress", t.onUploadProgress), (t.cancelToken || t.signal) && (g = function g(t) {
          v && (n(!t || t && t.type ? new l("canceled") : t), v.abort(), v = null);
        }, t.cancelToken && t.cancelToken.subscribe(g), t.signal && (t.signal.aborted ? g() : t.signal.addEventListener("abort", g))), m || (m = null), v.send(m);
      });
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(6);t.exports = function (t, e, n, o, i) {
      var s = new Error(t);return r(s, e, n, o, i);
    };
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t) {
      return !(!t || !t.__CANCEL__);
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(0);t.exports = function (t, e) {
      function n(t, e) {
        return r.isPlainObject(t) && r.isPlainObject(e) ? r.merge(t, e) : r.isPlainObject(e) ? r.merge({}, e) : r.isArray(e) ? e.slice() : e;
      }function o(o) {
        return r.isUndefined(e[o]) ? r.isUndefined(t[o]) ? void 0 : n(void 0, t[o]) : n(t[o], e[o]);
      }function i(t) {
        if (!r.isUndefined(e[t])) return n(void 0, e[t]);
      }function s(o) {
        return r.isUndefined(e[o]) ? r.isUndefined(t[o]) ? void 0 : n(void 0, t[o]) : n(void 0, e[o]);
      }function u(r) {
        return r in e ? n(t[r], e[r]) : r in t ? n(void 0, t[r]) : void 0;
      }e = e || {};var a = {},
          c = { url: i, method: i, data: i, baseURL: s, transformRequest: s, transformResponse: s, paramsSerializer: s, timeout: s, timeoutMessage: s, withCredentials: s, adapter: s, responseType: s, xsrfCookieName: s, xsrfHeaderName: s, onUploadProgress: s, onDownloadProgress: s, decompress: s, maxContentLength: s, maxBodyLength: s, transport: s, httpAgent: s, httpsAgent: s, cancelToken: s, socketPath: s, responseEncoding: s, validateStatus: u };return r.forEach(Object.keys(t).concat(Object.keys(e)), function (t) {
        var e = c[t] || o,
            n = e(t);r.isUndefined(n) && e !== u || (a[t] = n);
      }), a;
    };
  }, function (t, e) {
    t.exports = { version: "0.24.0" };
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var r = n(13);e.default = r.a;
  }, function (t, e, n) {
    "use strict";
    function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }var o = n(14),
        i = (n.n(o), "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    }),
        s = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }return t;
    },
        u = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        a = function () {
      function t() {
        r(this, t);
      }return u(t, [{ key: "init", value: function value(t, e, n) {
          this._terminal_type = t, this._fans_id = e || 0, n && (n.endpoint && (this._endpoint = endpoint), n.topicList && (this._topic_list = n.topicList));
        } }, { key: "setCommonKeyValue", value: function value(t, e) {
          this._common_data[t] = e;
        } }, { key: "putLogs", value: function value(t, e, n) {
          var r = this;if (!t || !e) return !1;e && (this._topic_id = this._topic_list[e - 1]);var i = s({}, n);i.topic_id = this._topic_id, i.code = t + "", i.type = e, i.fans_id = this._fans_id, i.terminal_type = this._terminal_type, i.sessionId = this._sessionId, i.UUID = this._UUID, i.userAgent = navigator.userAgent, i.domainUrl = window.location.href, i.time = new Date().valueOf(), i.org_id = this._org_id;for (var u in this._common_data) {
            i[u] = this._common_data[u];
          }if (n.sendType && "immediately" == n.sendType) {
            this._logGroup = new o.LogGroup();var a = new o.Log(Date.now());return this.logAddData(a, i), this._logGroup.addLog(a), void this.sendRequest();
          }if (this._time) {
            var c = new o.Log(Date.now());this.logAddData(c, i), this._logGroup || (this._logGroup = new o.LogGroup()), this._logGroup.addLog(c);
          } else {
            this._time = setTimeout(function () {
              r._logGroup && r.sendRequest(), r._time = null;
            }, 3e3), this._logGroup = new o.LogGroup();var f = new o.Log(Date.now());this.logAddData(f, i), this._logGroup.addLog(f), this.sendRequest();
          }
        } }, { key: "logAddData", value: function value(t, e) {
          for (var n in e) {
            var r = e[n];if ("object" === (void 0 === r ? "undefined" : i(r))) try {
              r = JSON.stringify(r);
            } catch (t) {
              console.log(t);
            }"string" == typeof r && (r = r.replace("#", "^*"), r = r.replace("&", "^^")), t.addContent(n, r + "");
          }
        } }, { key: "sendRequest", value: function value() {
          var t = this,
              e = new o.AsyncClient({ endpoint: this._endpoint, retry_times: 3 }),
              n = new o.PutLogsRequest(this.topic_id, this._logGroup);e.PutLogs(n).then(function () {
            t._logGroup = null;
          }, function (e) {
            console.log("上传日志报错"), t.putLogs(10004, 2, e);
          });
        } }, { key: "randomString", value: function value(t) {
          for (var e = "", n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = n.length, o = 0; o < t; o++) {
            e += n.charAt(Math.floor(Math.random() * r));
          }return e;
        } }, { key: "topic_id", set: function set(t) {
          this._topic_id = t;
        }, get: function get() {
          return this._topic_id;
        } }, { key: "fans_id", set: function set(t) {
          this._fans_id = t;
        }, get: function get() {
          return this._fans_id;
        } }, { key: "org_id", set: function set(t) {
          this._org_id = t;
        }, get: function get() {
          return this._org_id;
        } }, { key: "common_data", set: function set(t) {
          this._common_data = t;
        }, get: function get() {
          return this._common_data;
        } }, { key: "endpoint", set: function set(t) {
          this._endpoint = t;
        }, get: function get() {
          return this._endpoint;
        } }, { key: "topic_list", set: function set(t) {
          this._topic_list = t;
        }, get: function get() {
          return this._topic_list;
        } }, { key: "sessionID", set: function set(t) {
          this._sessionId = t;
        }, get: function get() {
          return this._sessionId;
        } }, { key: "UUID", get: function get() {
          return window.localStorage.getItem("tengface_log_uuid") ? (this._UUID = window.localStorage.getItem("tengface_log_uuid"), window.localStorage.getItem("tengface_log_uuid")) : (this._UUID = uuid, uuid);
        } }], [{ key: "getInstance", value: function value() {
          if (!this._instance) {
            if (this._instance = new t(), this._instance._topic_id = "5306a7a8-586b-46af-9304-f6b090062924", this._instance._common_data = {}, this._instance._org_id = 0, window.localStorage.getItem("tengface_log_uuid")) this._instance._UUID = window.localStorage.getItem("tengface_log_uuid");else {
              var e = this._instance.randomString(32);window.localStorage.setItem("tengface_log_uuid", e), this._instance._UUID = e;
            }this._instance._sessionId = this._instance.randomString(32), this._instance._endpoint = "https://ap-guangzhou.cls.tencentcs.com", this._instance._topic_list = ["5306a7a8-586b-46af-9304-f6b090062924", "861ae792-e310-44dc-a41f-5e97e1db55af", "1dfb7976-6e2e-420c-85ca-8bff69337e3c"];
          }return this._instance;
        } }]), t;
    }();e.a = a;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 }), e.AsyncClient = e.Log = e.LogGroup = e.Response = e.PutLogsRequest = void 0;var r = n(15);Object.defineProperty(e, "PutLogsRequest", { enumerable: !0, get: function get() {
        return r.PutLogsRequest;
      } });var o = n(3);Object.defineProperty(e, "Response", { enumerable: !0, get: function get() {
        return o.Response;
      } });var i = n(17);Object.defineProperty(e, "LogGroup", { enumerable: !0, get: function get() {
        return i.LogGroup;
      } }), Object.defineProperty(e, "Log", { enumerable: !0, get: function get() {
        return i.Log;
      } });var s = n(18);Object.defineProperty(e, "AsyncClient", { enumerable: !0, get: function get() {
        return s.AsyncClient;
      } });
  }, function (t, e, n) {
    "use strict";
    var r = this && this.__extends || function () {
      var _t = function t(e, n) {
        return (_t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }
        })(e, n);
      };return function (e, n) {
        function r() {
          this.constructor = e;
        }if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");_t(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 }), e.PutLogsRequest = void 0;var o = n(16),
        i = function (t) {
      function e(e, n) {
        var r = t.call(this) || this;return r.topic = e, r.logItems = n, r;
      }return r(e, t), e.prototype.getFilename = function () {
        return this.logItems.getFilename();
      }, e.prototype.setFilename = function (t) {
        this.logItems.setFilename(t);
      }, e.prototype.getTopic = function () {
        return this.topic;
      }, e.prototype.setTopic = function (t) {
        this.topic = t;
      }, e.prototype.getSource = function () {
        return this.source;
      }, e.prototype.setSource = function (t) {
        this.source = t;
      }, e.prototype.getLogItems = function () {
        return this.logItems;
      }, e.prototype.setlogItems = function (t) {
        this.logItems = t;
      }, e.prototype.encodeLogItems = function () {
        return JSON.stringify(this.logItems);
      }, e;
    }(o.Request);e.PutLogsRequest = i;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Request = void 0;var r = function () {
      function t() {
        this.mParams = new Map();
      }return t.prototype.getParam = function (t) {
        return this.mParams.has(t) ? this.mParams.get(t) || "" : "";
      }, t.prototype.setParam = function (t, e) {
        null == e ? this.mParams.set(t, "") : this.mParams.set(t, e);
      }, t.prototype.getAllParams = function () {
        return this.mParams;
      }, t;
    }();e.Request = r;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 }), e.LogGroup = e.Log = void 0;var r = function () {
      function t(t) {
        this.contents = {}, this.time = t;
      }return t.prototype.setTime = function (t) {
        this.time = t;
      }, t.prototype.getTime = function () {
        return this.time;
      }, t.prototype.addContent = function (t, e) {
        this.contents[t] = e;
      }, t;
    }();e.Log = r;var o = function () {
      function t(t, e, n) {
        this.logs = [], this.source = t, null != e && void 0 != e && (this.filename = ""), null != n && void 0 != n && (this.contextflow = "");
      }return t.prototype.setSource = function (t) {
        this.source = t;
      }, t.prototype.getSource = function () {
        return this.source;
      }, t.prototype.setContextFlow = function () {
        this.contextflow = this.contextflow;
      }, t.prototype.getContextFlow = function () {
        return this.contextflow;
      }, t.prototype.setFilename = function (t) {
        this.filename = t;
      }, t.prototype.getFilename = function () {
        return this.filename;
      }, t.prototype.setLogs = function (t) {
        this.logs = t;
      }, t.prototype.getLogs = function () {
        return this.logs;
      }, t.prototype.addLog = function (t) {
        this.logs.push(t);
      }, t;
    }();e.LogGroup = o;
  }, function (t, e, n) {
    "use strict";
    var r = this && this.__awaiter || function (t, e, n, r) {
      function o(t) {
        return t instanceof n ? t : new n(function (e) {
          e(t);
        });
      }return new (n || (n = Promise))(function (n, i) {
        function s(t) {
          try {
            a(r.next(t));
          } catch (t) {
            i(t);
          }
        }function u(t) {
          try {
            a(r.throw(t));
          } catch (t) {
            i(t);
          }
        }function a(t) {
          t.done ? n(t.value) : o(t.value).then(s, u);
        }a((r = r.apply(t, e || [])).next());
      });
    },
        o = this && this.__generator || function (t, e) {
      function n(t) {
        return function (e) {
          return r([t, e]);
        };
      }function r(n) {
        if (o) throw new TypeError("Generator is already executing.");for (; a;) {
          try {
            if (o = 1, i && (s = 2 & n[0] ? i.return : n[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, n[1])).done) return s;switch (i = 0, s && (n = [2 & n[0], s.value]), n[0]) {case 0:case 1:
                s = n;break;case 4:
                return a.label++, { value: n[1], done: !1 };case 5:
                a.label++, i = n[1], n = [0];continue;case 7:
                n = a.ops.pop(), a.trys.pop();continue;default:
                if (s = a.trys, !(s = s.length > 0 && s[s.length - 1]) && (6 === n[0] || 2 === n[0])) {
                  a = 0;continue;
                }if (3 === n[0] && (!s || n[1] > s[0] && n[1] < s[3])) {
                  a.label = n[1];break;
                }if (6 === n[0] && a.label < s[1]) {
                  a.label = s[1], s = n;break;
                }if (s && a.label < s[2]) {
                  a.label = s[2], a.ops.push(n);break;
                }s[2] && a.ops.pop(), a.trys.pop();continue;}n = e.call(t, a);
          } catch (t) {
            n = [6, t], i = 0;
          } finally {
            o = s = 0;
          }
        }if (5 & n[0]) throw n[1];return { value: n[0] ? n[1] : void 0, done: !0 };
      }var o,
          i,
          s,
          u,
          a = { label: 0, sent: function sent() {
          if (1 & s[0]) throw s[1];return s[1];
        }, trys: [], ops: [] };return u = { next: n(0), throw: n(1), return: n(2) }, "function" == typeof Symbol && (u[Symbol.iterator] = function () {
        return this;
      }), u;
    };Object.defineProperty(e, "__esModule", { value: !0 }), e.AsyncClient = void 0;var i = n(19),
        s = n(20),
        u = n(21),
        a = n(3),
        c = function () {
      function t(t) {
        if (null == t || void 0 == t) throw new i.default("AsyncClientOptions invalid");if (null == t.endpoint || void 0 == t.endpoint || 0 == t.endpoint.length) throw new i.default("options endpoint can not be empty");for (this.retry_times = t.retry_times, 0 != t.retry_times && void 0 != t.retry_times && null != t.retry_times || (this.retry_times = 5), t.endpoint.startsWith("http://") ? (this.hostName = t.endpoint.substring(7), this.httpType = "http://") : t.endpoint.startsWith("https://") ? (this.hostName = t.endpoint.substring(8), this.httpType = "https://") : (this.hostName = t.endpoint, this.httpType = "http://"); this.hostName.endsWith("/");) {
          this.hostName = this.hostName.substring(0, this.hostName.length - 1);
        }
      }return t.prototype.PutLogs = function (t) {
        return r(this, void 0, void 0, function () {
          var e, n, r, u, c, f, p, c, c;return o(this, function (o) {
            switch (o.label) {case 0:
                if (e = t.encodeLogItems(), e.length > s.CONST_MAX_PUT_SIZE) throw new i.default("InvalidLogSize. logItems' size exceeds maximum limitation : " + s.CONST_MAX_PUT_SIZE + " bytes, logBytes=" + e.length + ", topic=" + t.getTopic());n = this.getCommonHeadPara(s.CONST_JSON), t.setParam(s.TOPIC_ID, t.getTopic()), r = 0, o.label = 1;case 1:
                if (!(r < this.retry_times)) return [3, 6];o.label = 2;case 2:
                return o.trys.push([2, 4,, 5]), [4, this.sendLogs(s.UPLOAD_LOG_RESOURCE_URI, n, e, t.getTopic())];case 3:
                if (u = o.sent(), c = new a.Response(), c.setAllHeaders(u.headers), c.setHttpStatusCode(u.status), 200 == c.getHttpStatusCode()) return [2, c];if (r + 1 >= this.retry_times) throw new i.default("send log failed and exceed retry times");return [3, 5];case 4:
                if (f = o.sent(), p = "", f.response && f.response.headers && (p = f.response.headers["x-cls-requestid"]), f.response && 413 == f.response.status) return c = new a.Response(), c.setAllHeaders(f.response.headers), c.setHttpStatusCode(f.response.status), null != f.response.data.errorcode && void 0 != f.response.data.errorcode && c.setErrorCode(f.response.data.errorcode), null != f.response.data.errormessage && void 0 != f.response.data.errormessage && c.setErrorMessage(f.response.data.errormessage), [2, c];if (r + 1 >= this.retry_times) throw c = new a.Response(), f.response && (c.setAllHeaders(f.response.headers), c.setHttpStatusCode(f.response.status), null != f.response.data.errorcode && void 0 != f.response.data.errorcode && c.setErrorCode(f.response.data.errorcode), null != f.response.data.errormessage && void 0 != f.response.data.errormessage && c.setErrorMessage(f.response.data.errormessage)), new i.default("send log failed and exceed retry times. reason: " + JSON.stringify(c) + ",  error: " + f.message + ".", p);return [3, 5];case 5:
                return r++, [3, 1];case 6:
                return [2];}
          });
        });
      }, t.prototype.sendLogs = function (t, e, n, i) {
        return r(this, void 0, void 0, function () {
          var r, a, c;return o(this, function (o) {
            return r = this.stringToArrayBuffer(n), a = new Uint8Array(r), c = {}, e.forEach(function (t, e) {
              c[e] = t;
            }), [2, u.default({ url: this.httpType + this.hostName + t + "?" + s.TOPIC_ID + "=" + i, method: "post", data: a, headers: c })];
          });
        });
      }, t.prototype.getCommonHeadPara = function (t) {
        var e = new Map();return e.set(s.CONST_CONTENT_TYPE, t), e;
      }, t.prototype.stringToArrayBuffer = function (t) {
        var e,
            n,
            r = new Array();e = t.length;for (var o = 0; o < e; o++) {
          n = t.charCodeAt(o), n >= 65536 && n <= 1114111 ? (r.push(n >> 18 & 7 | 240), r.push(n >> 12 & 63 | 128), r.push(n >> 6 & 63 | 128), r.push(63 & n | 128)) : n >= 2048 && n <= 65535 ? (r.push(n >> 12 & 15 | 224), r.push(n >> 6 & 63 | 128), r.push(63 & n | 128)) : n >= 128 && n <= 2047 ? (r.push(n >> 6 & 31 | 192), r.push(63 & n | 128)) : r.push(255 & n);
        }var i = new Int8Array(r.length);for (var s in r) {
          i[s] = r[s];
        }return i.buffer;
      }, t;
    }();e.AsyncClient = c;
  }, function (t, e, n) {
    "use strict";
    var r = this && this.__extends || function () {
      var _t2 = function t(e, n) {
        return (_t2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }
        })(e, n);
      };return function (e, n) {
        function r() {
          this.constructor = e;
        }if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");_t2(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();Object.defineProperty(e, "__esModule", { value: !0 });var o = function (t) {
      function e(e, n) {
        void 0 === n && (n = "");var r = t.call(this, e) || this;return r.requestId = n || "", r;
      }return r(e, t), e.prototype.getMessage = function () {
        return this.message;
      }, e.prototype.getRequestId = function () {
        return this.requestId;
      }, e.prototype.toString = function () {
        return "[TencentCloudSDKException]message:" + this.getMessage() + "  requestId:" + this.getRequestId();
      }, e.prototype.toLocaleString = function () {
        return "[TencentCloudSDKException]message:" + this.getMessage() + "  requestId:" + this.getRequestId();
      }, e;
    }(Error);e.default = o;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 }), e.SORT = e.CONTEXT = e.LIMIT = e.QUERY_STRING = e.END_TIME = e.START_TIME = e.LOGSET_ID = e.TOPIC_IDS = e.CONST_LZ4 = e.CONST_X_SLS_COMPRESSTYPE = e.CONST_MAX_PUT_SIZE = e.UPLOAD_LOG_RESOURCE_URI = e.TOPIC_ID = e.HTTP_SEND_TIME_OUT = e.HTTP_CONNECT_TIME_OUT = e.CONST_LOCAL_IP = e.UTF_8_ENCODING = e.CONST_MD5 = e.CONST_HOST = e.CONST_X_SLS_REQUESTID = e.CONST_HTTP_METHOD_GET = e.CONST_HTTP_METHOD_POST = e.CONST_GZIP_ENCODING = e.CONST_AUTHORIZATION = e.CONST_CONTENT_LENGTH = e.CONST_JSON = e.CONST_PROTO_BUF = e.CONST_CONTENT_TYPE = void 0, e.CONST_CONTENT_TYPE = "Content-Type", e.CONST_PROTO_BUF = "application/x-protobuf", e.CONST_JSON = "application/json", e.CONST_CONTENT_LENGTH = "Content-Length", e.CONST_AUTHORIZATION = "Authorization", e.CONST_GZIP_ENCODING = "deflate", e.CONST_HTTP_METHOD_POST = "POST", e.CONST_HTTP_METHOD_GET = "GET", e.CONST_X_SLS_REQUESTID = "x-log-requestid", e.CONST_HOST = "Host", e.CONST_MD5 = "MD5", e.UTF_8_ENCODING = "UTF-8", e.CONST_LOCAL_IP = "127.0.0.1", e.HTTP_CONNECT_TIME_OUT = 6e4, e.HTTP_SEND_TIME_OUT = 6e4, e.TOPIC_ID = "topic_id", e.UPLOAD_LOG_RESOURCE_URI = "/tracklog", e.CONST_MAX_PUT_SIZE = 1048576, e.CONST_X_SLS_COMPRESSTYPE = "x-cls-compress-type", e.CONST_LZ4 = "lz4", e.TOPIC_IDS = "topic_ids", e.LOGSET_ID = "logset_id", e.START_TIME = "start_time", e.END_TIME = "end_time", e.QUERY_STRING = "query_string", e.LIMIT = "limit", e.CONTEXT = "context", e.SORT = "sort";
  }, function (t, e, n) {
    t.exports = n(22);
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      var e = new s(t),
          n = i(s.prototype.request, e);return o.extend(n, s.prototype, e), o.extend(n, e), n.create = function (e) {
        return r(u(t, e));
      }, n;
    }var o = n(0),
        i = n(4),
        s = n(23),
        u = n(10),
        a = n(1),
        c = r(a);c.Axios = s, c.Cancel = n(2), c.CancelToken = n(37), c.isCancel = n(9), c.VERSION = n(11).version, c.all = function (t) {
      return Promise.all(t);
    }, c.spread = n(38), c.isAxiosError = n(39), t.exports = c, t.exports.default = c;
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      this.defaults = t, this.interceptors = { request: new s(), response: new s() };
    }var o = n(0),
        i = n(5),
        s = n(24),
        u = n(25),
        a = n(10),
        c = n(36),
        f = c.validators;r.prototype.request = function (t) {
      "string" == typeof t ? (t = arguments[1] || {}, t.url = arguments[0]) : t = t || {}, t = a(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";var e = t.transitional;void 0 !== e && c.assertOptions(e, { silentJSONParsing: f.transitional(f.boolean), forcedJSONParsing: f.transitional(f.boolean), clarifyTimeoutError: f.transitional(f.boolean) }, !1);var n = [],
          r = !0;this.interceptors.request.forEach(function (e) {
        "function" == typeof e.runWhen && !1 === e.runWhen(t) || (r = r && e.synchronous, n.unshift(e.fulfilled, e.rejected));
      });var o = [];this.interceptors.response.forEach(function (t) {
        o.push(t.fulfilled, t.rejected);
      });var i;if (!r) {
        var s = [u, void 0];for (Array.prototype.unshift.apply(s, n), s = s.concat(o), i = Promise.resolve(t); s.length;) {
          i = i.then(s.shift(), s.shift());
        }return i;
      }for (var p = t; n.length;) {
        var l = n.shift(),
            d = n.shift();try {
          p = l(p);
        } catch (t) {
          d(t);break;
        }
      }try {
        i = u(p);
      } catch (t) {
        return Promise.reject(t);
      }for (; o.length;) {
        i = i.then(o.shift(), o.shift());
      }return i;
    }, r.prototype.getUri = function (t) {
      return t = a(this.defaults, t), i(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
    }, o.forEach(["delete", "get", "head", "options"], function (t) {
      r.prototype[t] = function (e, n) {
        return this.request(a(n || {}, { method: t, url: e, data: (n || {}).data }));
      };
    }), o.forEach(["post", "put", "patch"], function (t) {
      r.prototype[t] = function (e, n, r) {
        return this.request(a(r || {}, { method: t, url: e, data: n }));
      };
    }), t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r() {
      this.handlers = [];
    }var o = n(0);r.prototype.use = function (t, e, n) {
      return this.handlers.push({ fulfilled: t, rejected: e, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
    }, r.prototype.eject = function (t) {
      this.handlers[t] && (this.handlers[t] = null);
    }, r.prototype.forEach = function (t) {
      o.forEach(this.handlers, function (e) {
        null !== e && t(e);
      });
    }, t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new a("canceled");
    }var o = n(0),
        i = n(26),
        s = n(9),
        u = n(1),
        a = n(2);t.exports = function (t) {
      return r(t), t.headers = t.headers || {}, t.data = i.call(t, t.data, t.headers, t.transformRequest), t.headers = o.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers), o.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (e) {
        delete t.headers[e];
      }), (t.adapter || u.adapter)(t).then(function (e) {
        return r(t), e.data = i.call(t, e.data, e.headers, t.transformResponse), e;
      }, function (e) {
        return s(e) || (r(t), e && e.response && (e.response.data = i.call(t, e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
      });
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(0),
        o = n(1);t.exports = function (t, e, n) {
      var i = this || o;return r.forEach(n, function (n) {
        t = n.call(i, t, e);
      }), t;
    };
  }, function (t, e) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }function r() {
      throw new Error("clearTimeout has not been defined");
    }function o(t) {
      if (f === setTimeout) return setTimeout(t, 0);if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(t, 0);try {
        return f(t, 0);
      } catch (e) {
        try {
          return f.call(null, t, 0);
        } catch (e) {
          return f.call(this, t, 0);
        }
      }
    }function i(t) {
      if (p === clearTimeout) return clearTimeout(t);if ((p === r || !p) && clearTimeout) return p = clearTimeout, clearTimeout(t);try {
        return p(t);
      } catch (e) {
        try {
          return p.call(null, t);
        } catch (e) {
          return p.call(this, t);
        }
      }
    }function s() {
      g && d && (g = !1, d.length ? h = d.concat(h) : m = -1, h.length && u());
    }function u() {
      if (!g) {
        var t = o(s);g = !0;for (var e = h.length; e;) {
          for (d = h, h = []; ++m < e;) {
            d && d[m].run();
          }m = -1, e = h.length;
        }d = null, g = !1, i(t);
      }
    }function a(t, e) {
      this.fun = t, this.array = e;
    }function c() {}var f,
        p,
        l = t.exports = {};!function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : n;
      } catch (t) {
        f = n;
      }try {
        p = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (t) {
        p = r;
      }
    }();var d,
        h = [],
        g = !1,
        m = -1;l.nextTick = function (t) {
      var e = new Array(arguments.length - 1);if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }h.push(new a(t, e)), 1 !== h.length || g || o(u);
    }, a.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, l.title = "browser", l.browser = !0, l.env = {}, l.argv = [], l.version = "", l.versions = {}, l.on = c, l.addListener = c, l.once = c, l.off = c, l.removeListener = c, l.removeAllListeners = c, l.emit = c, l.prependListener = c, l.prependOnceListener = c, l.listeners = function (t) {
      return [];
    }, l.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, l.cwd = function () {
      return "/";
    }, l.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, l.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(0);t.exports = function (t, e) {
      r.forEach(t, function (n, r) {
        r !== e && r.toUpperCase() === e.toUpperCase() && (t[e] = n, delete t[r]);
      });
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(8);t.exports = function (t, e, n) {
      var o = n.config.validateStatus;n.status && o && !o(n.status) ? e(r("Request failed with status code " + n.status, n.config, null, n.request, n)) : t(n);
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(0);t.exports = r.isStandardBrowserEnv() ? function () {
      return { write: function write(t, e, n, o, i, s) {
          var u = [];u.push(t + "=" + encodeURIComponent(e)), r.isNumber(n) && u.push("expires=" + new Date(n).toGMTString()), r.isString(o) && u.push("path=" + o), r.isString(i) && u.push("domain=" + i), !0 === s && u.push("secure"), document.cookie = u.join("; ");
        }, read: function read(t) {
          var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));return e ? decodeURIComponent(e[3]) : null;
        }, remove: function remove(t) {
          this.write(t, "", Date.now() - 864e5);
        } };
    }() : function () {
      return { write: function write() {}, read: function read() {
          return null;
        }, remove: function remove() {} };
    }();
  }, function (t, e, n) {
    "use strict";
    var r = n(32),
        o = n(33);t.exports = function (t, e) {
      return t && !r(e) ? o(t, e) : e;
    };
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t) {
      return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t)
      );
    };
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t, e) {
      return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(0),
        o = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];t.exports = function (t) {
      var e,
          n,
          i,
          s = {};return t ? (r.forEach(t.split("\n"), function (t) {
        if (i = t.indexOf(":"), e = r.trim(t.substr(0, i)).toLowerCase(), n = r.trim(t.substr(i + 1)), e) {
          if (s[e] && o.indexOf(e) >= 0) return;s[e] = "set-cookie" === e ? (s[e] ? s[e] : []).concat([n]) : s[e] ? s[e] + ", " + n : n;
        }
      }), s) : s;
    };
  }, function (t, e, n) {
    "use strict";
    var r = n(0);t.exports = r.isStandardBrowserEnv() ? function () {
      function t(t) {
        var e = t;return n && (o.setAttribute("href", e), e = o.href), o.setAttribute("href", e), { href: o.href, protocol: o.protocol ? o.protocol.replace(/:$/, "") : "", host: o.host, search: o.search ? o.search.replace(/^\?/, "") : "", hash: o.hash ? o.hash.replace(/^#/, "") : "", hostname: o.hostname, port: o.port, pathname: "/" === o.pathname.charAt(0) ? o.pathname : "/" + o.pathname };
      }var e,
          n = /(msie|trident)/i.test(navigator.userAgent),
          o = document.createElement("a");return e = t(window.location.href), function (n) {
        var o = r.isString(n) ? t(n) : n;return o.protocol === e.protocol && o.host === e.host;
      };
    }() : function () {
      return function () {
        return !0;
      };
    }();
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n) {
      if ("object" != (typeof t === "undefined" ? "undefined" : _typeof(t))) throw new TypeError("options must be an object");for (var r = Object.keys(t), o = r.length; o-- > 0;) {
        var i = r[o],
            s = e[i];if (s) {
          var u = t[i],
              a = void 0 === u || s(u, i, t);if (!0 !== a) throw new TypeError("option " + i + " must be " + a);
        } else if (!0 !== n) throw Error("Unknown option " + i);
      }
    }var o = n(11).version,
        i = {};["object", "boolean", "number", "function", "string", "symbol"].forEach(function (t, e) {
      i[t] = function (n) {
        return (typeof n === "undefined" ? "undefined" : _typeof(n)) === t || "a" + (e < 1 ? "n " : " ") + t;
      };
    });var s = {};i.transitional = function (t, e, n) {
      function r(t, e) {
        return "[Axios v" + o + "] Transitional option '" + t + "'" + e + (n ? ". " + n : "");
      }return function (n, o, i) {
        if (!1 === t) throw new Error(r(o, " has been removed" + (e ? " in " + e : "")));return e && !s[o] && (s[o] = !0, console.warn(r(o, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(n, o, i);
      };
    }, t.exports = { assertOptions: r, validators: i };
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      if ("function" != typeof t) throw new TypeError("executor must be a function.");var e;this.promise = new Promise(function (t) {
        e = t;
      });var n = this;this.promise.then(function (t) {
        if (n._listeners) {
          var e,
              r = n._listeners.length;for (e = 0; e < r; e++) {
            n._listeners[e](t);
          }n._listeners = null;
        }
      }), this.promise.then = function (t) {
        var e,
            r = new Promise(function (t) {
          n.subscribe(t), e = t;
        }).then(t);return r.cancel = function () {
          n.unsubscribe(e);
        }, r;
      }, t(function (t) {
        n.reason || (n.reason = new o(t), e(n.reason));
      });
    }var o = n(2);r.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, r.prototype.subscribe = function (t) {
      if (this.reason) return void t(this.reason);this._listeners ? this._listeners.push(t) : this._listeners = [t];
    }, r.prototype.unsubscribe = function (t) {
      if (this._listeners) {
        var e = this._listeners.indexOf(t);-1 !== e && this._listeners.splice(e, 1);
      }
    }, r.source = function () {
      var t;return { token: new r(function (e) {
          t = e;
        }), cancel: t };
    }, t.exports = r;
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    };
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t) {
      return "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && !0 === t.isAxiosError;
    };
  }]).default;
});
//# sourceMappingURL=TFWebLog.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(29);

var _vuex2 = _interopRequireDefault(_vuex);

var _DsInfo = __webpack_require__(172);

var _DsInfo2 = _interopRequireDefault(_DsInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  modules: {
    dsInfo: _DsInfo2.default
  }
});

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDirective = exports.defaultDOMPurifyInstanceBuilder = void 0;
var dompurify_1 = __importDefault(__webpack_require__(180));
function defaultDOMPurifyInstanceBuilder() {
    return dompurify_1.default;
}
exports.defaultDOMPurifyInstanceBuilder = defaultDOMPurifyInstanceBuilder;
function setUpHooks(config, dompurifyInstance) {
    var _a;
    var hooks = (_a = config.hooks) !== null && _a !== void 0 ? _a : {};
    var hookName;
    for (hookName in hooks) {
        var hook = hooks[hookName];
        if (hook !== undefined) {
            dompurifyInstance.addHook(hookName, hook);
        }
    }
}
function buildDirective(config, buildDOMPurifyInstance) {
    if (config === void 0) {
        config = {};
    }
    if (buildDOMPurifyInstance === void 0) {
        buildDOMPurifyInstance = defaultDOMPurifyInstanceBuilder;
    }
    var dompurifyInstance = buildDOMPurifyInstance();
    setUpHooks(config, dompurifyInstance);
    var updateComponent = function updateComponent(el, binding) {
        var _a;
        if (binding.oldValue === binding.value) {
            return;
        }
        var arg = binding.arg;
        var namedConfigurations = config.namedConfigurations;
        if (namedConfigurations && arg !== undefined && typeof namedConfigurations[arg] !== 'undefined') {
            el.innerHTML = dompurifyInstance.sanitize(binding.value, namedConfigurations[arg]);
            return;
        }
        el.innerHTML = dompurifyInstance.sanitize(binding.value, (_a = config.default) !== null && _a !== void 0 ? _a : {});
    };
    return {
        inserted: updateComponent,
        update: updateComponent,
        unbind: function unbind(el) {
            el.innerHTML = '';
        }
    };
}
exports.buildDirective = buildDirective;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url;
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
    }

    return url;
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "body{margin:0;padding:0;background:#fff;font-size:14px;color:#666;font-family:PingFangSC-Regular;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}dd,div,dl,dt,h1,h2,h3,h4,h5,h6,li,p,ul{list-style:none;margin:0;padding:0}input:disabled{background:none}h1,h2,h3,h4,h5,h6{font-weight:400}#LiveHotel,body,html{height:100%;width:100%;-webkit-text-size-adjust:100%!important;scroll-behavior:smooth}#LiveHotel{position:relative}body>div.van-toast-wrapper{height:auto}body>div.zan-box{min-height:auto}img{max-width:100%}.linebox{padding:15px}.btbox{text-align:center;padding:15px 0;line-height:20px}.btbox .van-icon{font-size:20px}.box-center{padding:10px;text-align:center;line-height:40px}.van-popup{padding:10px;width:80%;min-width:auto;border-radius:10px}.van-popup--bottom{padding:0}.full.van-popup{width:100%}#Vote .van-popup{width:100%;border-radius:0;padding:0}.paydialog.van-popup{padding:0}.clearfix:after{content:\".\";display:block;height:0;clear:both;visibility:hidden}.fl{float:left}.fr{float:right}.formbox{min-width:300px}.formbox p{margin:10px 0;padding-left:15px}.setting .van-field__control{text-align:right}.nothing{text-align:center;margin-top:70px}.nothing img{width:102px}.red{color:#f44}.yellow{color:#fdf400}.orange{color:#fbab00}.pink{color:#fe4095}.bigsize{font-size:16px;color:#333;font-weight:700}.ellipsis{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}textarea{　　box-shadow:0 0 0 transparent;-webkit-appearance:none}.nomore{text-align:center;margin:0 15px;overflow:hidden;position:relative;height:30px;line-height:30px;color:#7b7979}.nomore:after,.nomore:before{content:\"\";display:block;width:100%;height:1px;background:#7b7979;position:absolute;top:15px}.nomore:before{right:50%;margin-right:50px}.nomore:after{left:50%;margin-left:50px}.musk,.musk2{position:fixed;top:0;bottom:0;width:100%;z-index:3000}.musk{background-color:rgba(0,0,0,.6)}.musk2{background-color:rgba(0,0,0,.8)}.box{position:absolute;width:80%;background-color:#fff;transform:translate(-50%,-50%);top:50%;left:50%;border-radius:10px;overflow:hidden}", ""]);

// exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var _deepClone = __webpack_require__(73);

var _shared = __webpack_require__(190);

var _loading = __webpack_require__(24);

var _loading2 = _interopRequireDefault(_loading);

var _PickerColumn = __webpack_require__(191);

var _PickerColumn2 = _interopRequireDefault(_PickerColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('picker'),
    sfc = _use[0],
    bem = _use[1],
    t = _use[2];

exports.default = sfc({
  props: (0, _extends3.default)({}, _shared.pickerProps, {
    columns: Array,
    defaultIndex: {
      type: Number,
      "default": 0
    },
    valueKey: {
      type: String,
      "default": 'text'
    }
  }),
  data: function data() {
    return {
      children: []
    };
  },
  computed: {
    simple: function simple() {
      return this.columns.length && !this.columns[0].values;
    }
  },
  watch: {
    columns: function columns() {
      this.setColumns();
    }
  },
  methods: {
    setColumns: function setColumns() {
      var _this = this;

      var columns = this.simple ? [{
        values: this.columns
      }] : this.columns;
      columns.forEach(function (column, index) {
        _this.setColumnValues(index, (0, _deepClone.deepClone)(column.values));
      });
    },
    emit: function emit(event) {
      if (this.simple) {
        this.$emit(event, this.getColumnValue(0), this.getColumnIndex(0));
      } else {
        this.$emit(event, this.getValues(), this.getIndexes());
      }
    },
    onChange: function onChange(columnIndex) {
      if (this.simple) {
        this.$emit('change', this, this.getColumnValue(0), this.getColumnIndex(0));
      } else {
        this.$emit('change', this, this.getValues(), columnIndex);
      }
    },
    // get column instance by index
    getColumn: function getColumn(index) {
      return this.children[index];
    },
    // get column value by index
    getColumnValue: function getColumnValue(index) {
      var column = this.getColumn(index);
      return column && column.getValue();
    },
    // set column value by index
    setColumnValue: function setColumnValue(index, value) {
      var column = this.getColumn(index);
      column && column.setValue(value);
    },
    // get column option index by column index
    getColumnIndex: function getColumnIndex(columnIndex) {
      return (this.getColumn(columnIndex) || {}).currentIndex;
    },
    // set column option index by column index
    setColumnIndex: function setColumnIndex(columnIndex, optionIndex) {
      var column = this.getColumn(columnIndex);
      column && column.setIndex(optionIndex);
    },
    // get options of column by index
    getColumnValues: function getColumnValues(index) {
      return (this.children[index] || {}).options;
    },
    // set options of column by index
    setColumnValues: function setColumnValues(index, options) {
      var column = this.children[index];

      if (column && JSON.stringify(column.options) !== JSON.stringify(options)) {
        column.options = options;
        column.setIndex(0);
      }
    },
    // get values of all columns
    getValues: function getValues() {
      return this.children.map(function (child) {
        return child.getValue();
      });
    },
    // set values of all columns
    setValues: function setValues(values) {
      var _this2 = this;

      values.forEach(function (value, index) {
        _this2.setColumnValue(index, value);
      });
    },
    // get indexes of all columns
    getIndexes: function getIndexes() {
      return this.children.map(function (child) {
        return child.currentIndex;
      });
    },
    // set indexes of all columns
    setIndexes: function setIndexes(indexes) {
      var _this3 = this;

      indexes.forEach(function (optionIndex, columnIndex) {
        _this3.setColumnIndex(columnIndex, optionIndex);
      });
    },
    onConfirm: function onConfirm() {
      this.emit('confirm');
    },
    onCancel: function onCancel() {
      this.emit('cancel');
    }
  },
  render: function render(h) {
    var _this4 = this;

    var itemHeight = this.itemHeight;
    var columns = this.simple ? [this.columns] : this.columns;
    var frameStyle = {
      height: itemHeight + "px"
    };
    var columnsStyle = {
      height: itemHeight * this.visibleItemCount + "px"
    };
    var Toolbar = this.showToolbar && h("div", {
      "class": ['van-hairline--top-bottom', bem('toolbar')]
    }, [this.slots() || [h("div", {
      "class": bem('cancel'),
      "on": {
        "click": this.onCancel
      }
    }, [this.cancelButtonText || t('cancel')]), this.slots('title') || this.title && h("div", {
      "class": ['van-ellipsis', bem('title')]
    }, [this.title]), h("div", {
      "class": bem('confirm'),
      "on": {
        "click": this.onConfirm
      }
    }, [this.confirmButtonText || t('confirm')])]]);
    return h("div", {
      "class": bem()
    }, [Toolbar, this.loading ? h("div", {
      "class": bem('loading')
    }, [h(_loading2.default)]) : h(), h("div", {
      "class": bem('columns'),
      "style": columnsStyle,
      "on": {
        "touchmove": _event.preventDefault
      }
    }, [columns.map(function (item, index) {
      return h(_PickerColumn2.default, {
        "attrs": {
          "valueKey": _this4.valueKey,
          "className": item.className,
          "itemHeight": _this4.itemHeight,
          "defaultIndex": item.defaultIndex || _this4.defaultIndex,
          "visibleItemCount": _this4.visibleItemCount,
          "initialOptions": _this4.simple ? item : item.values
        },
        "on": {
          "change": function change() {
            _this4.onChange(index);
          }
        }
      });
    }), h("div", {
      "class": ['van-hairline--top-bottom', bem('frame')],
      "style": frameStyle
    })])]);
  }
});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.deepClone = deepClone;

var _deepAssign = __webpack_require__(60);

function deepClone(obj) {
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return deepClone(item);
    });
  }

  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    return (0, _deepAssign.deepAssign)({}, obj);
  }

  return obj;
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _checkbox = __webpack_require__(75);

var _use = (0, _utils.use)('radio'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  mixins: [(0, _checkbox.CheckboxMixin)('van-radio-group', bem)],
  computed: {
    currentValue: {
      get: function get() {
        return this.parent ? this.parent.value : this.value;
      },
      set: function set(val) {
        (this.parent || this).$emit('input', val);
      }
    },
    checked: function checked() {
      return this.currentValue === this.name;
    }
  },
  methods: {
    onClickIcon: function onClickIcon() {
      if (!this.isDisabled) {
        this.currentValue = this.name;
      }
    },
    onClickLabel: function onClickLabel() {
      if (!this.isDisabled && !this.labelDisabled) {
        this.currentValue = this.name;
      }
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxMixin = undefined;

var _icon = __webpack_require__(23);

var _icon2 = _interopRequireDefault(_icon);

var _findParent = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Common part of Checkbox & Radio
 */
var CheckboxMixin = exports.CheckboxMixin = function CheckboxMixin(parent, bem) {
  return {
    mixins: [_findParent.FindParentMixin],
    props: {
      name: null,
      value: null,
      disabled: Boolean,
      checkedColor: String,
      labelPosition: String,
      labelDisabled: Boolean,
      shape: {
        type: String,
        "default": 'round'
      },
      bindGroup: {
        type: Boolean,
        "default": true
      }
    },
    created: function created() {
      if (this.bindGroup) {
        this.findParent(parent);
      }
    },
    computed: {
      isDisabled: function isDisabled() {
        return this.parent && this.parent.disabled || this.disabled;
      },
      iconStyle: function iconStyle() {
        var checkedColor = this.checkedColor;

        if (checkedColor && this.checked && !this.isDisabled) {
          return {
            borderColor: checkedColor,
            backgroundColor: checkedColor
          };
        }
      }
    },
    render: function render() {
      var _this = this;

      var h = arguments[0];
      var slots = this.slots,
          checked = this.checked;
      var CheckIcon = slots('icon', {
        checked: checked
      }) || h(_icon2.default, {
        "attrs": {
          "name": "success"
        },
        "style": this.iconStyle
      });
      var Label = slots() && h("span", {
        "class": bem('label', [this.labelPosition, {
          disabled: this.isDisabled
        }]),
        "on": {
          "click": this.onClickLabel
        }
      }, [slots()]);
      return h("div", {
        "class": bem(),
        "on": {
          "click": function click(event) {
            _this.$emit('click', event);
          }
        }
      }, [h("div", {
        "class": bem('icon', [this.shape, {
          disabled: this.isDisabled,
          checked: checked
        }]),
        "on": {
          "click": this.onClickIcon
        }
      }, [CheckIcon]), Label]);
    }
  };
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * find parent component by name
 */
var FindParentMixin = exports.FindParentMixin = {
  data: function data() {
    return {
      parent: null
    };
  },
  methods: {
    findParent: function findParent(name) {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name === name) {
          this.parent = parent;
          break;
        }

        parent = parent.$parent;
      }
    }
  }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _use = (0, _utils.use)('radio-group'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    value: null,
    disabled: Boolean
  },
  watch: {
    value: function value(_value) {
      this.$emit('change', _value);
    }
  },
  render: function render(h) {
    return h("div", {
      "class": bem()
    }, [this.slots()]);
  }
});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.route = route;
exports.functionalRoute = functionalRoute;
/**
 * Vue Router support
 */
function route(router, config) {
  var to = config.to,
      url = config.url,
      replace = config.replace;

  if (to && router) {
    router[replace ? 'replace' : 'push'](to);
  } else if (url) {
    replace ? location.replace(url) : location.href = url;
  }
}
function functionalRoute(context) {
  route(context.parent && context.parent.$router, context.props);
}
var routeProps = exports.routeProps = {
  url: String,
  replace: Boolean,
  to: [String, Object]
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(194);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(195);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(196);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(198);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _timJsSdk = __webpack_require__(85);

var _timJsSdk2 = _interopRequireDefault(_timJsSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  loginIM: loginIM,
  logout: logout,
  applyJoinBigGroup: applyJoinBigGroup,
  quitBigGroup: quitBigGroup,
  loginAndJoinGroup: loginAndJoinGroup,
  configIM: configIM,
  setMsgListener: setMsgListener,
  onSendTextMsg: onSendTextMsg,
  sendApplyLink: sendApplyLink,
  sendSureLink: sendSureLink,
  sendRefuseLink: sendRefuseLink,
  sendCannotLink: sendCannotLink,
  setImStatusListener: setImStatusListener,
  setMemberMsgListener: setMemberMsgListener,
  sendTextMsg: sendTextMsg,
  onSendP2PMsg: onSendP2PMsg,
  getNotification: getNotification,
  studentOneKeyLinkMic: studentOneKeyLinkMic

  // 当前用户身份
};
var loginInfo = {
  identifier: 0, // 当前用户ID,必须是否字符串类型，选填
  identifierNick: '', // 当前用户昵称，选填
  userSig: '', // 当前用户身份凭证，必须是字符串类型，选填
  headurl: '' // 当前用户默认头像，选填
};

var currentGroupId = '';
var tim = null;

var memberMsgListener;
function setMemberMsgListener(cb) {
  memberMsgListener = cb;
}

var imStatusListener;
function setImStatusListener(cb) {
  imStatusListener = cb;
}

var normalCallBack; // 普通消息回调，在互动页面显示的消息为普通消息
function setMsgListener(cb) {
  normalCallBack = cb;
}

// 配置IM
function configIM(data) {
  currentGroupId = data.currentGroupId;
  loginInfo.identifier = data.identifier;
  loginInfo.identifierNick = data.identifierNick;
  loginInfo.headurl = data.headurl;
  loginInfo.userSig = data.userSig;
  tim = _timJsSdk2.default.create({ SDKAppID: 1400058601 });
  tim.setLogLevel(0);
  // 监听事件，如：
  tim.on(_timJsSdk2.default.EVENT.SDK_READY, function (event) {
    console.log('TIM.EVENT.SDK_READY');
    var promise = tim.updateMyProfile({
      nick: loginInfo.identifierNick
    });
    promise.then(function (imResponse) {
      console.log('更新资料成功', imResponse.data); // 更新资料成功
    }).catch(function (imError) {
      console.warn('updateMyProfile error:', imError); // 更新资料失败的相关信息
    });
  });

  tim.on(_timJsSdk2.default.EVENT.NET_STATE_CHANGE, function (event) {
    // 网络状态发生改变（v2.5.0 起支持）
    // event.name - TIM.EVENT.NET_STATE_CHANGE
    // event.data.state 当前网络状态，枚举值及说明如下：
    //   - TIM.TYPES.NET_STATE_CONNECTED - 已接入网络
    //   - TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
    //   - TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
    console.log('TIM.EVENT.NET_STATE_CHANGE', event);
    if (imStatusListener) {
      if (event.data.state === _timJsSdk2.default.TYPES.NET_STATE_CONNECTED) {
        imStatusListener({ ErrorCode: 1 });
      } else if (event.data.state === _timJsSdk2.default.TYPES.NET_STATE_CONNECTING) {
        // imStatusListener({ErrorCode: 1})
      } else if (event.data.state === _timJsSdk2.default.TYPES.NET_STATE_DISCONNECTED) {
        imStatusListener({ ErrorCode: 9999 });
      }
    }
  });

  tim.on(_timJsSdk2.default.EVENT.MESSAGE_RECEIVED, function (event) {
    // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
    // event.name - TIM.EVENT.MESSAGE_RECEIVED
    // event.data - 存储 Message 对象的数组 - [Message]
    // console.log('TIM.EVENT.MESSAGE_RECEIVED', event)
    for (var index = 0; index < event.data.length; index++) {
      var element = event.data[index];
      var text = element.payload.text;
      var msgData = null;
      if (text) {
        text = text.replace(/&quot;/g, '"');
        msgData = JSON.parse(text);
      }
      if (element.conversationType === _timJsSdk2.default.TYPES.CONV_C2C) {
        // 1V1消息
        if (msgData) {
          memberMsgListener && memberMsgListener(msgData);
        }
      } else if (element.conversationType === _timJsSdk2.default.TYPES.CONV_GROUP && currentGroupId == element.to) {
        // 群消息
        if (element.type === 'TIMGroupTipElem') {
          // 群信息修改提示
          var groupProfile = element.payload.newGroupProfile;
          if (groupProfile) {
            if (groupProfile.introduction && groupProfile.introduction != "{}") {
              normalCallBack && normalCallBack({
                module: 'system_message_group_introduction',
                content: JSON.parse(groupProfile.introduction) || {}
              });
            }
            if (groupProfile.notification) {
              normalCallBack && normalCallBack({
                module: 'system_message_group_notification',
                content: JSON.parse(groupProfile.notification) || {}
              });
            }
          }
        } else if (element.type === 'TIMCustomElem') {
          if (element.payload.extension == "TXWhiteBoardExt") {
            normalCallBack && normalCallBack({
              module: 'TXWhiteBoardExt',
              content: element.payload.data
            });
          }
        } else {
          if (msgData) {
            normalCallBack && normalCallBack(msgData);
          }
        }
      }
    }
  });
}

function loginAndJoinGroup(callBack) {
  console.log("调了几次");
  // 这里需要获取IM数据
  loginIM(function (isSuccess) {
    if (isSuccess) {
      // 登入成功了
      applyJoinBigGroup(callBack);
    } else {
      // 登入失败了
      callBack(false);
    }
  });
}

// 登录方法
function loginIM(callBack) {
  console.log('登录方法');
  // 开始登录
  tim.login({ userID: '' + loginInfo.identifier, userSig: loginInfo.userSig }).then(function (imResponse) {
    console.log('开始登录', imResponse.data);
    callBack(true);
  }).catch(function (imError) {
    callBack(false);
    console.warn('login error:', imError); // 登录失败的相关信息
  });
}
// 登出
function logout(callBack) {
  if (tim) {
    tim.logout().then(function (res) {
      callBack(true);
    }).catch(function (imError) {
      callBack(true);
    });
  }
}

// 进入大群
function applyJoinBigGroup(callBack) {
  console.log('进入大群____applyJoinBigGroup');
  var promise = tim.joinGroup({ groupID: currentGroupId, type: _timJsSdk2.default.TYPES.GRP_AVCHATROOM });
  promise.then(function (imResponse) {
    console.log('加入群聊回调', imResponse);
    switch (imResponse.data.status) {
      case _timJsSdk2.default.TYPES.JOIN_STATUS_WAIT_APPROVAL:
        break; // 等待管理员同意
      case _timJsSdk2.default.TYPES.JOIN_STATUS_SUCCESS:
        // 加群成功
        console.log(imResponse.data.group); // 加入的群组资料
        console.log('加入群聊成功');
        callBack(true);
        var groupInfo = imResponse.data.group;
        if (groupInfo && groupInfo.introduction && groupInfo.introduction != "{}") {
          normalCallBack && normalCallBack({
            module: 'system_message_group_introduction',
            content: JSON.parse(groupInfo.introduction) || {}
          });
        }
        if (groupInfo && groupInfo.notification && groupInfo.notification != "{}") {
          normalCallBack && normalCallBack({
            module: 'system_message_group_notification',
            content: JSON.parse(groupInfo.notification) || {}
          });
        }
        break;
      case _timJsSdk2.default.TYPES.JOIN_STATUS_ALREADY_IN_GROUP:
        // 已经在群中
        console.log(imResponse.data.group); // 加入的群组资料
        console.log('加入群聊成功');
        callBack(true);
        var groupInfo2 = imResponse.data.group;
        if (groupInfo2 && groupInfo2.introduction) {
          normalCallBack && normalCallBack({
            module: 'system_message_group_introduction',
            content: JSON.parse(groupInfo2.introduction)
          });
        }
        if (groupInfo2 && groupInfo2.notification) {
          normalCallBack && normalCallBack({
            module: 'system_message_group_notification',
            content: JSON.parse(groupInfo2.notification)
          });
        }
        break;
      default:
        break;
    }
  }).catch(function (imError) {
    callBack(false);
    console.warn('joinGroup error:', imError); // 申请加群失败的相关信息
  });
}

// 申请连麦
function sendApplyLink() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'applyLink';

  var text = JSON.stringify(obj);
  onSendMsg(text);
}

// 接收老师邀请，确认上麦
function sendSureLink() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'sureLink';
  var text = JSON.stringify(obj);
  onSendMsg(text);
}

// 学生一键连麦
function studentOneKeyLinkMic() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.student_onekey_linkMic = 1;
  obj.module = 'applyLink';
  var text = JSON.stringify(obj);
  onSendMsg(text);
}

// 接收老师邀请，拒绝上麦
function sendRefuseLink() {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'refuseLink';
  var text = JSON.stringify(obj);
  onSendMsg(text);
}

function sendTextMsg(msg) {
  var text = JSON.stringify(msg);
  onSendMsg(text);
}

// 当前设备不支持连麦
function sendCannotLink(content) {
  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');
  var obj = {};
  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.time = time;
  obj.msgid = timestamp;
  obj.module = 'cannotLink';
  obj.content = content;
  var text = JSON.stringify(obj);
  onSendMsg(text);
}

// 退出大群
function quitBigGroup() {
  var promise = tim.quitGroup(currentGroupId + '');
  promise.then(function (imResponse) {
    console.log(imResponse.data.groupID); // 退出成功的群 ID
  }).catch(function (imError) {
    console.warn('quitGroup error:', imError); // 退出群组失败的相关信息
  });
}

function onSendP2PMsg(text, userId) {
  console.log('发送私聊消息');
  // 发送文本消息，Web 端与小程序端相同
  // 1. 创建消息实例，接口返回的实例可以上屏
  if (tim) {
    var message = tim.createTextMessage({
      to: userId + '',
      conversationType: _timJsSdk2.default.TYPES.CONV_C2C,
      // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
      // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
      // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
      payload: {
        text: text
        // 消息自定义数据（云端保存，会发送到对端，程序卸载重装后还能拉取到，v2.10.2起支持）
        // cloudCustomData: 'your cloud custom data'
      } });
    // 2. 发送消息
    var promise = tim.sendMessage(message);
    promise.then(function (imResponse) {
      // 发送成功
      console.log('发送成功');
    }).catch(function (imError) {
      // 发送失败
      console.warn('sendMessage error:', imError);
    });
  }
}

// eslint-disable-next-line no-extend-native
Date.prototype.pattern = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468' : '') + week[this.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

// 发送普通IM消息
function onSendTextMsg(text, type) {
  // 获取消息内容

  if (text.length < 1) {
    alert('发送的消息不能为空!');
    return;
  }

  var date1 = new Date();
  var timestamp = Date.parse(date1);
  var time = date1.pattern('MM-dd hh:mm');

  var obj = {};

  obj.nick = loginInfo.identifierNick;
  obj.header_url = loginInfo.headurl;
  obj.fans_id = loginInfo.identifier;
  obj.conent = text;
  obj.like_num = 0;
  obj.time = time;
  obj.msgid = timestamp;

  if (type === 1) {
    obj.module = 'enterPerson';
  }

  // eslint-disable-next-line no-redeclare
  var text = JSON.stringify(obj);
  onSendMsg(text);
}

// 发送IM消息
function onSendMsg(text) {
  if (tim) {
    var message = tim.createTextMessage({
      to: currentGroupId + '',
      conversationType: _timJsSdk2.default.TYPES.CONV_GROUP, // 群组会话
      payload: {
        text: text
      }
    });
    tim.sendMessage(message).then(function (imResponse) {
      // 发送成功
      console.log('发送成功');
    }).catch(function (imError) {
      // 发送失败
      console.log('发送失败');
    });
  }
}

//获取群公告
function getNotification(callBack) {
  var data = {};
  //静态秘钥写死，不需要网络获取秘钥
  data.Notification = "1111110111";
  callBack(data);
  return;
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};!function(e,t){"object"==( false?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=t(): true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(e="undefined"!=typeof globalThis?globalThis:e||self).TIM=t();}(undefined,function(){function e(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable;})),n.push.apply(n,o);}return n;}function t(t){for(var n=1;n<arguments.length;n++){var o=null!=arguments[n]?arguments[n]:{};n%2?e(Object(o),!0).forEach(function(e){r(t,e,o[e]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(o)):e(Object(o)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(o,e));});}return t;}function n(e){return(n="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return typeof e==="undefined"?"undefined":_typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e==="undefined"?"undefined":_typeof(e);})(e);}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}function s(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}function a(e,t,n){return t&&s(e.prototype,t),n&&s(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e;}function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e;}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&c(e,t);}function u(e){return(u=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e);})(e);}function c(e,t){return(c=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e;})(e,t);}function l(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0;}catch(e){return!1;}}function p(e,t,n){return(p=l()?Reflect.construct.bind():function(e,t,n){var o=[null];o.push.apply(o,t);var s=new(Function.bind.apply(e,o))();return n&&c(s,n.prototype),s;}).apply(null,arguments);}function d(e){var t="function"==typeof Map?new Map():void 0;return(d=function d(e){if(null===e||(n=e,-1===Function.toString.call(n).indexOf("[native code]")))return e;var n;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,o);}function o(){return p(e,arguments,u(this).constructor);}return o.prototype=Object.create(e.prototype,{constructor:{value:o,enumerable:!1,writable:!0,configurable:!0}}),c(o,e);})(e);}function g(e,t){if(null==e)return{};var n,o,s=function(e,t){if(null==e)return{};var n,o,s={},a=Object.keys(e);for(o=0;o<a.length;o++){n=a[o],t.indexOf(n)>=0||(s[n]=e[n]);}return s;}(e,t);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);for(o=0;o<a.length;o++){n=a[o],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(s[n]=e[n]);}}return s;}function _(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;}function h(e,t){if(t&&("object"==(typeof t==="undefined"?"undefined":_typeof(t))||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return _(e);}function f(e){var t=l();return function(){var n,o=u(e);if(t){var s=u(this).constructor;n=Reflect.construct(o,arguments,s);}else n=o.apply(this,arguments);return h(this,n);};}function v(e,t){return M(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null==n)return;var o,s,a=[],r=!0,i=!1;try{for(n=n.call(e);!(r=(o=n.next()).done)&&(a.push(o.value),!t||a.length!==t);r=!0){}}catch(u){i=!0,s=u;}finally{try{r||null==n.return||n.return();}finally{if(i)throw s;}}return a;}(e,t)||I(e,t)||T();}function m(e){return function(e){if(Array.isArray(e))return C(e);}(e)||y(e)||I(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}();}function M(e){if(Array.isArray(e))return e;}function y(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e);}function I(e,t){if(e){if("string"==typeof e)return C(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?C(e,t):void 0;}}function C(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++){o[n]=e[n];}return o;}function T(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function D(e,t){var _n2="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!_n2){if(Array.isArray(e)||(_n2=I(e))||t&&e&&"number"==typeof e.length){_n2&&(e=_n2);var o=0,s=function s(){};return{s:s,n:function n(){return o>=e.length?{done:!0}:{done:!1,value:e[o++]};},e:function e(_e2){throw _e2;},f:s};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var a,r=!0,i=!1;return{s:function s(){_n2=_n2.call(e);},n:function n(){var e=_n2.next();return r=e.done,e;},e:function e(_e3){i=!0,a=_e3;},f:function f(){try{r||null==_n2.return||_n2.return();}finally{if(i)throw a;}}};}var E={SDK_READY:"sdkStateReady",SDK_NOT_READY:"sdkStateNotReady",SDK_DESTROY:"sdkDestroy",MESSAGE_RECEIVED:"onMessageReceived",MESSAGE_MODIFIED:"onMessageModified",MESSAGE_REVOKED:"onMessageRevoked",MESSAGE_READ_BY_PEER:"onMessageReadByPeer",MESSAGE_READ_RECEIPT_RECEIVED:"onMessageReadReceiptReceived",MESSAGE_EXTENSIONS_UPDATED:"onMessageExtensionsUpdated",MESSAGE_EXTENSIONS_DELETED:"onMessageExtensionsDeleted",CONVERSATION_LIST_UPDATED:"onConversationListUpdated",TOTAL_UNREAD_MESSAGE_COUNT_UPDATED:"onTotalUnreadMessageCountUpdated",CONVERSATION_GROUP_LIST_UPDATED:"onConversationGroupListUpdated",CONVERSATION_IN_GROUP_UPDATED:"onConversationInGroupUpdated",GROUP_LIST_UPDATED:"onGroupListUpdated",GROUP_SYSTEM_NOTICE_RECEIVED:"receiveGroupSystemNotice",GROUP_ATTRIBUTES_UPDATED:"groupAttributesUpdated",GROUP_COUNTER_UPDATED:"onGroupCounterUpdated",TOPIC_CREATED:"onTopicCreated",TOPIC_DELETED:"onTopicDeleted",TOPIC_UPDATED:"onTopicUpdated",PROFILE_UPDATED:"onProfileUpdated",USER_STATUS_UPDATED:"onUserStatusUpdated",BLACKLIST_UPDATED:"blacklistUpdated",FRIEND_LIST_UPDATED:"onFriendListUpdated",FRIEND_GROUP_LIST_UPDATED:"onFriendGroupListUpdated",FRIEND_APPLICATION_LIST_UPDATED:"onFriendApplicationListUpdated",KICKED_OUT:"kickedOut",ERROR:"error",NET_STATE_CHANGE:"netStateChange",SDK_RELOAD:"sdkReload"},S={MSG_TEXT:"TIMTextElem",MSG_IMAGE:"TIMImageElem",MSG_SOUND:"TIMSoundElem",MSG_AUDIO:"TIMSoundElem",MSG_FILE:"TIMFileElem",MSG_FACE:"TIMFaceElem",MSG_VIDEO:"TIMVideoFileElem",MSG_GEO:"TIMLocationElem",MSG_LOCATION:"TIMLocationElem",MSG_GRP_TIP:"TIMGroupTipElem",MSG_GRP_SYS_NOTICE:"TIMGroupSystemNoticeElem",MSG_CUSTOM:"TIMCustomElem",MSG_MERGER:"TIMRelayElem",MSG_PRIORITY_HIGH:"High",MSG_PRIORITY_NORMAL:"Normal",MSG_PRIORITY_LOW:"Low",MSG_PRIORITY_LOWEST:"Lowest",CONV_C2C:"C2C",CONV_GROUP:"GROUP",CONV_TOPIC:"TOPIC",CONV_SYSTEM:"@TIM#SYSTEM",CONV_AT_ME:1,CONV_AT_ALL:2,CONV_AT_ALL_AT_ME:3,CONV_MARK_TYPE_STAR:1,CONV_MARK_TYPE_UNREAD:2,CONV_MARK_TYPE_FOLD:4,CONV_MARK_TYPE_HIDE:8,GRP_PRIVATE:"Private",GRP_WORK:"Private",GRP_PUBLIC:"Public",GRP_CHATROOM:"ChatRoom",GRP_MEETING:"ChatRoom",GRP_AVCHATROOM:"AVChatRoom",GRP_COMMUNITY:"Community",GRP_MBR_ROLE_OWNER:"Owner",GRP_MBR_ROLE_ADMIN:"Admin",GRP_MBR_ROLE_MEMBER:"Member",GRP_MBR_ROLE_CUSTOM:"Custom",GRP_TIP_MBR_JOIN:1,GRP_TIP_MBR_QUIT:2,GRP_TIP_MBR_KICKED_OUT:3,GRP_TIP_MBR_SET_ADMIN:4,GRP_TIP_MBR_CANCELED_ADMIN:5,GRP_TIP_GRP_PROFILE_UPDATED:6,GRP_TIP_MBR_PROFILE_UPDATED:7,GRP_TIP_BAN_AVCHATROOM_MEMBER:10,GRP_TIP_UNBAN_AVCHATROOM_MEMBER:11,MSG_REMIND_ACPT_AND_NOTE:"AcceptAndNotify",MSG_REMIND_ACPT_NOT_NOTE:"AcceptNotNotify",MSG_REMIND_DISCARD:"Discard",GENDER_UNKNOWN:"Gender_Type_Unknown",GENDER_FEMALE:"Gender_Type_Female",GENDER_MALE:"Gender_Type_Male",KICKED_OUT_MULT_ACCOUNT:"multipleAccount",KICKED_OUT_MULT_DEVICE:"multipleDevice",KICKED_OUT_USERSIG_EXPIRED:"userSigExpired",KICKED_OUT_REST_API:"REST_API_Kick",ALLOW_TYPE_ALLOW_ANY:"AllowType_Type_AllowAny",ALLOW_TYPE_NEED_CONFIRM:"AllowType_Type_NeedConfirm",ALLOW_TYPE_DENY_ANY:"AllowType_Type_DenyAny",FORBID_TYPE_NONE:"AdminForbid_Type_None",FORBID_TYPE_SEND_OUT:"AdminForbid_Type_SendOut",JOIN_OPTIONS_FREE_ACCESS:"FreeAccess",JOIN_OPTIONS_NEED_PERMISSION:"NeedPermission",JOIN_OPTIONS_DISABLE_APPLY:"DisableApply",JOIN_STATUS_SUCCESS:"JoinedSuccess",JOIN_STATUS_ALREADY_IN_GROUP:"AlreadyInGroup",JOIN_STATUS_WAIT_APPROVAL:"WaitAdminApproval",INVITE_OPTIONS_DISABLE_INVITE:"DisableInvite",INVITE_OPTIONS_NEED_PERMISSION:"NeedPermission",INVITE_OPTIONS_FREE_ACCESS:"FreeAccess",GRP_PROFILE_OWNER_ID:"ownerID",GRP_PROFILE_CREATE_TIME:"createTime",GRP_PROFILE_LAST_INFO_TIME:"lastInfoTime",GRP_PROFILE_MEMBER_NUM:"memberNum",GRP_PROFILE_MAX_MEMBER_NUM:"maxMemberNum",GRP_PROFILE_JOIN_OPTION:"joinOption",GRP_PROFILE_INVITE_OPTION:"inviteOption",GRP_PROFILE_INTRODUCTION:"introduction",GRP_PROFILE_NOTIFICATION:"notification",GRP_PROFILE_MUTE_ALL_MBRS:"muteAllMembers",SNS_ADD_TYPE_SINGLE:"Add_Type_Single",SNS_ADD_TYPE_BOTH:"Add_Type_Both",SNS_DELETE_TYPE_SINGLE:"Delete_Type_Single",SNS_DELETE_TYPE_BOTH:"Delete_Type_Both",SNS_APPLICATION_TYPE_BOTH:"Pendency_Type_Both",SNS_APPLICATION_SENT_TO_ME:"Pendency_Type_ComeIn",SNS_APPLICATION_SENT_BY_ME:"Pendency_Type_SendOut",SNS_APPLICATION_AGREE:"Response_Action_Agree",SNS_APPLICATION_AGREE_AND_ADD:"Response_Action_AgreeAndAdd",SNS_CHECK_TYPE_BOTH:"CheckResult_Type_Both",SNS_CHECK_TYPE_SINGLE:"CheckResult_Type_Single",SNS_TYPE_NO_RELATION:"CheckResult_Type_NoRelation",SNS_TYPE_A_WITH_B:"CheckResult_Type_AWithB",SNS_TYPE_B_WITH_A:"CheckResult_Type_BWithA",SNS_TYPE_BOTH_WAY:"CheckResult_Type_BothWay",NET_STATE_CONNECTED:"connected",NET_STATE_CONNECTING:"connecting",NET_STATE_DISCONNECTED:"disconnected",MSG_AT_ALL:"__kImSDK_MesssageAtALL__",READ_ALL_C2C_MSG:"readAllC2CMessage",READ_ALL_GROUP_MSG:"readAllGroupMessage",READ_ALL_MSG:"readAllMessage",USER_STATUS_UNKNOWN:0,USER_STATUS_ONLINE:1,USER_STATUS_OFFLINE:2,USER_STATUS_UNLOGINED:3},k=function(){function e(){o(this,e),this.cache=[],this.options=null;}return a(e,[{key:"use",value:function value(e){if("function"!=typeof e)throw"middleware must be a function";return this.cache.push(e),this;}},{key:"next",value:function value(e){if(this.middlewares&&this.middlewares.length>0)return this.middlewares.shift().call(this,this.options,this.next.bind(this));}},{key:"run",value:function value(e){return this.middlewares=this.cache.map(function(e){return e;}),this.options=e,this.next();}}]),e;}(),L=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;o(this,e),this.high=t,this.low=n;}return a(e,[{key:"equal",value:function value(e){return null!==e&&this.low===e.low&&this.high===e.high;}},{key:"toString",value:function value(){var e=Number(this.high).toString(16),t=Number(this.low).toString(16);if(t.length<8)for(var n=8-t.length;n;){t="0"+t,n--;}return e+t;}}]),e;}(),A={TEST:{CHINA:{DEFAULT:"wss://wss-dev.tim.qq.com"},OVERSEA:{DEFAULT:"wss://wss-dev.tim.qq.com"},SINGAPORE:{DEFAULT:"wss://wsssgp-dev.im.qcloud.com"},KOREA:{DEFAULT:"wss://wsskr-dev.im.qcloud.com"},GERMANY:{DEFAULT:"wss://wssger-dev.im.qcloud.com"},IND:{DEFAULT:"wss://wssind-dev.im.qcloud.com"},JPN:{DEFAULT:"wss://wssjpn-dev.im.qcloud.com"},USA:{DEFAULT:"wss://wssusa-dev.im.qcloud.com"}},PRODUCTION:{CHINA:{DEFAULT:"wss://wss.im.qcloud.com",BACKUP:"wss://wss.tim.qq.com",STAT:"https://events.im.qcloud.com",ANYCAST:"wss://162.14.13.203"},OVERSEA:{DEFAULT:"wss://wss.im.qcloud.com",BACKUP:"wss://wss.my-imcloud.com",STAT:"https://api.my-imcloud.com"},SINGAPORE:{DEFAULT:"wss://wsssgp.im.qcloud.com",BACKUP:"wss://wsssgp.my-imcloud.com",STAT:"https://apisgp.my-imcloud.com"},KOREA:{DEFAULT:"wss://wsskr.im.qcloud.com",BACKUP:"wss://wsskr.my-imcloud.com",STAT:"https://apikr.my-imcloud.com"},GERMANY:{DEFAULT:"wss://wssger.im.qcloud.com",BACKUP:"wss://wssger.my-imcloud.com",STAT:"https://apiger.my-imcloud.com"},IND:{DEFAULT:"wss://wssind.my-imcloud.com",BACKUP:"wss://wssind.im.qcloud.com",STAT:"https://apiind.my-imcloud.com"},JPN:{DEFAULT:"wss://wssjpn.im.qcloud.com",BACKUP:"wss://wssjpn.my-imcloud.com",STAT:"https://apijpn.my-imcloud.com"},USA:{DEFAULT:"wss://wssusa.im.qcloud.com",BACKUP:"wss://wssusa.my-imcloud.com",STAT:"https://apiusa.my-imcloud.com"}}},R={ANDROID:2,IOS:3,MAC:4,WEB:7,WX_MP:8,QQ_MP:9,TT_MP:10,BAIDU_MP:11,ALI_MP:12,IPAD:13,UNI_NATIVE_APP:15},N="1.7.3",O=537048168,G="CHINA",U="OVERSEA",P="SINGAPORE",b="KOREA",w="GERMANY",F="IND",q="JPN",x="USA",V={HOST:{CURRENT:{DEFAULT:"wss://wss.im.qcloud.com",STAT:"https://events.im.qcloud.com"},setCurrent:function setCurrent(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:G;this.CURRENT=A.PRODUCTION[e];}},NAME:{OPEN_IM:"openim",OPEN_IM_MSG_EXT:"openim_msg_ext_http_svc",GROUP:"group_open_http_svc",GROUP_AVCHATROOM:"group_open_avchatroom_http_svc",GROUP_COMMUNITY:"million_group_open_http_svc",GROUP_ATTR:"group_open_attr_http_svc",FRIEND:"sns",PROFILE:"profile",RECENT_CONTACT:"recentcontact",PIC:"openpic",BIG_GROUP_NO_AUTH:"group_open_http_noauth_svc",BIG_GROUP_LONG_POLLING:"group_open_long_polling_http_svc",BIG_GROUP_LONG_POLLING_NO_AUTH:"group_open_long_polling_http_noauth_svc",IM_OPEN_STAT:"imopenstat",WEB_IM:"webim",IM_COS_SIGN:"im_cos_sign_svr",CUSTOM_UPLOAD:"im_cos_msg",HEARTBEAT:"heartbeat",IM_OPEN_PUSH:"im_open_push",IM_OPEN_STATUS:"im_open_status",IM_LONG_MESSAGE:"im_long_msg",IM_CONFIG_MANAGER:"im_sdk_config_mgr",STAT_SERVICE:"StatSvc",OVERLOAD_PUSH:"OverLoadPush",IM_MSG_AUDIT_MGR:"im_msg_audit_mgr",TUIROOM_SVR:"tui_room_svr",IM_OPEN_TRANSLATE:"im_open_translate"},CMD:{LOGIN:"wslogin",LOGOUT_LONG_POLL:"longpollinglogout",LOGOUT:"wslogout",HELLO:"wshello",STAT_BACKGROUND:"ws_stat_background",STAT_FOREGROUND:"ws_stat_foreground",SET_TOKEN:"ws_stat_settoken",PORTRAIT_GET:"portrait_get_all",PORTRAIT_SET:"portrait_set",GET_LONG_POLL_ID:"getlongpollingid",LONG_POLL:"longpolling",AVCHATROOM_LONG_POLL:"get_msg",ADD_FRIEND:"friend_add",UPDATE_FRIEND:"friend_update",GET_FRIEND_LIST:"friend_get",GET_FRIEND_PROFILE:"friend_get_specified",DELETE_FRIEND:"friend_delete",CHECK_FRIEND:"friend_check",GET_FRIEND_GROUP_LIST:"group_get",RESPOND_FRIEND_APPLICATION:"friend_response",GET_FRIEND_APPLICATION_LIST:"pendency_get",DELETE_FRIEND_APPLICATION:"pendency_delete",REPORT_FRIEND_APPLICATION:"pendency_report",GET_GROUP_APPLICATION:"get_pendency",CREATE_FRIEND_GROUP:"group_add",DELETE_FRIEND_GROUP:"group_delete",UPDATE_FRIEND_GROUP:"group_update",GET_BLACKLIST:"black_list_get",ADD_BLACKLIST:"black_list_add",DELETE_BLACKLIST:"black_list_delete",CREATE_GROUP:"create_group",GET_JOINED_GROUPS:"get_joined_group_list",SET_GROUP_ATTRIBUTES:"set_group_attr",MODIFY_GROUP_ATTRIBUTES:"modify_group_attr",DELETE_GROUP_ATTRIBUTES:"delete_group_attr",CLEAR_GROUP_ATTRIBUTES:"clear_group_attr",GET_GROUP_ATTRIBUTES:"get_group_attr",SEND_MESSAGE:"sendmsg",REVOKE_C2C_MESSAGE:"msgwithdraw",DELETE_C2C_MESSAGE:"delete_c2c_msg_ramble",MODIFY_C2C_MESSAGE:"modify_c2c_msg",MODIFY_C2C_MESSAGE_EXTENSIONS:"set_key_values",GET_C2C_MESSAGE_EXTENSIONS:"get_key_values",SEND_GROUP_MESSAGE:"send_group_msg",REVOKE_GROUP_MESSAGE:"group_msg_recall",DELETE_GROUP_MESSAGE:"delete_group_ramble_msg_by_seq",MODIFY_GROUP_MESSAGE:"modify_group_msg",MODIFY_GROUP_MESSAGE_EXTENSIONS:"group_set_key_values",GET_GROUP_MESSAGE_EXTENSIONS:"group_get_key_values",GET_GROUP_INFO:"get_group_self_member_info",GET_GROUP_MEMBER_INFO:"get_specified_group_member_info",GET_GROUP_MEMBER_LIST:"get_group_member_info",GET_AVCHATROOM_MEMBER_LIST:"get_members",MARK_AVCHATROOM_MEMBER_INFO:"modify_user_info",QUIT_GROUP:"quit_group",CHANGE_GROUP_OWNER:"change_group_owner",DESTROY_GROUP:"destroy_group",ADD_GROUP_MEMBER:"add_group_member",DELETE_GROUP_MEMBER:"delete_group_member",BAN_AVCHATROOM_MEMBER:"ban_group_member",SEARCH_GROUP_BY_ID:"get_group_public_info",APPLY_JOIN_GROUP:"apply_join_group",HANDLE_APPLY_JOIN_GROUP:"handle_apply_join_group",HANDLE_INVITE_JOIN_GROUP:"handle_invite_join_permission_group",HANDLE_GROUP_INVITATION:"handle_invite_join_group",MODIFY_GROUP_INFO:"modify_group_base_info",MODIFY_GROUP_MEMBER_INFO:"modify_group_member_info",DELETE_GROUP_SYSTEM_MESSAGE:"deletemsg",DELETE_GROUP_AT_TIPS:"deletemsg",GET_GROUP_NOTIFY:"get_group_notify",GET_CONVERSATION_LIST:"get",PAGING_GET_CONVERSATION_LIST:"page_get",DELETE_CONVERSATION:"batch_delete",CLEAR_HISTORY_MESSAGE:"clear_msg",PIN_CONVERSATION:"top",SET_CONVERSATION_CUSTOM_DATA:"mark_contact",MARK_CONVERSATION:"mark_contact",CREATE_CONVERSATION_GROUP:"create_contact_group",DELETE_CONVERSATION_GROUP:"del_contact_group",UPDATE_CONVERSATION_GROUP:"update_contact_group",GET_CONVERSATION_GROUP_LIST:"get_contact_group",GET_MESSAGES:"getmsg",GET_C2C_ROAM_MESSAGES:"getroammsg",SET_C2C_PEER_MUTE_NOTIFICATIONS:"set_c2c_peer_mute_notifications",GET_C2C_PEER_MUTE_NOTIFICATIONS:"get_c2c_peer_mute_notifications",GET_GROUP_ROAM_MESSAGES:"group_msg_get",GET_READ_RECEIPT:"get_group_msg_receipt",GET_READ_RECEIPT_DETAIL:"get_group_msg_receipt_detail",SEND_READ_RECEIPT:"group_msg_receipt",SEND_C2C_READ_RECEIPT:"c2c_msg_read_receipt",SET_C2C_MESSAGE_READ:"msgreaded",GET_PEER_READ_TIME:"get_peer_read_time",SET_GROUP_MESSAGE_READ:"msg_read_report",FILE_READ_AND_WRITE_AUTHKEY:"authkey",FILE_UPLOAD:"pic_up",COS_SIGN:"cos",COS_PRE_SIG:"pre_sig",VIDEO_COVER:"video_cover",TIM_WEB_REPORT_V2:"tim_web_report_v2",BIG_DATA_HALLWAY_AUTH_KEY:"authkey",GET_ONLINE_MEMBER_NUM:"get_online_member_num",ALIVE:"alive",MESSAGE_PUSH:"msg_push",MULTI_MESSAGE_PUSH:"multi_msg_push_ws",MESSAGE_PUSH_ACK:"ws_msg_push_ack",STATUS_FORCE_OFFLINE:"stat_forceoffline",DOWNLOAD_MERGER_MESSAGE:"get_relay_json_msg",UPLOAD_MERGER_MESSAGE:"save_relay_json_msg",FETCH_CLOUD_CONTROL_CONFIG:"fetch_config",PUSHED_CLOUD_CONTROL_CONFIG:"push_configv2",FETCH_COMMERCIAL_CONFIG:"fetch_imsdk_purchase_bitsv2",PUSHED_COMMERCIAL_CONFIG:"push_imsdk_purchase_bitsv2",KICK_OTHER:"KickOther",OVERLOAD_NOTIFY:"notify2",SET_ALL_MESSAGE_READ:"read_all_unread_msg",CREATE_TOPIC:"create_topic",DELETE_TOPIC:"destroy_topic",UPDATE_TOPIC_PROFILE:"modify_topic",GET_TOPIC_LIST:"get_topic",SET_SELF_STATUS:"ws_set_custom_status",GET_USER_STATUS:"ws_get_user_status",SUBSCRIBE_USER_STATUS:"ws_status_subscribe",UNSUBSCRIBE_USER_STATUS:"ws_status_unsubscribe",GET_RPOFANITY_LIST:"get_local_words",TRANSLATE_TEXT:"ws_batch_trans_text",UPDATE_GROUP_COUNTER:"update_group_counter",GET_GROUP_COUNTER:"get_group_counter"},CHANNEL:{SOCKET:1,XHR:2,AUTO:0},NAME_VERSION:{openim:"v4",group_open_http_svc:"v4",sns:"v4",profile:"v4",recentcontact:"v4",openpic:"v4",group_open_http_noauth_svc:"v4",group_open_long_polling_http_svc:"v4",group_open_long_polling_http_noauth_svc:"v4",imopenstat:"v4",im_cos_sign_svr:"v4",im_cos_msg:"v4",webim:"v4",im_open_push:"v4",im_open_status:"v4"}},B={SEARCH_MSG:new L(0,Math.pow(2,0)).toString(),SEARCH_GRP_SNS:new L(0,Math.pow(2,1)).toString(),AVCHATROOM_HISTORY_MSG:new L(0,Math.pow(2,2)).toString(),GRP_COMMUNITY:new L(0,Math.pow(2,3)).toString(),MSG_TO_SPECIFIED_GRP_MBR:new L(0,Math.pow(2,4)).toString(),AVCHATROOM_MBR_LIST:new L(0,Math.pow(2,6)).toString(),USER_STATUS:new L(0,Math.pow(2,7)).toString(),CONV_MARK:new L(0,Math.pow(2,9)).toString(),CONV_GROUP:new L(0,Math.pow(2,10)).toString(),AVCHATROOM_BAN_MBR:new L(0,Math.pow(2,11)).toString(),MSG_EXT:new L(0,Math.pow(2,13)).toString(),GRP_COUNTER:new L(0,Math.pow(2,15)).toString()},H="c2c_text_message",K="c2c_custom_message",W="group_text_message",Y="group_custom_message",j="user_profile",z="group_profile",J="group_member_profile";V.HOST.setCurrent(G);var X="undefined"!=typeof wx&&"function"==typeof wx.getSystemInfoSync&&Boolean(wx.getSystemInfoSync().fontSizeSetting),Q="undefined"!=typeof qq&&"function"==typeof qq.getSystemInfoSync&&Boolean(qq.getSystemInfoSync().fontSizeSetting),Z="undefined"!=typeof tt&&"function"==typeof tt.getSystemInfoSync&&Boolean(tt.getSystemInfoSync().fontSizeSetting),$="undefined"!=typeof swan&&"function"==typeof swan.getSystemInfoSync&&Boolean(swan.getSystemInfoSync().fontSizeSetting),ee="undefined"!=typeof my&&"function"==typeof my.getSystemInfoSync&&Boolean(my.getSystemInfoSync().fontSizeSetting),te="undefined"!=typeof jd&&"function"==typeof jd.getSystemInfoSync,ne="undefined"!=typeof uni&&"undefined"==typeof window&&"function"==typeof uni.requireNativePlugin,oe="undefined"!=typeof uni,se=X||Q||Z||$||ee||ne||te,ae=("undefined"!=typeof uni||"undefined"!=typeof window)&&!se,re=Q?qq:Z?tt:$?swan:ee?my:X?wx:ne?uni:te?jd:{},ie=ae&&window&&window.navigator&&window.navigator.userAgent||"",ue=/(micromessenger|webbrowser)/i.test(ie),ce=/AppleWebKit\/([\d.]+)/i.exec(ie);ce&&parseFloat(ce.pop());var le,pe,de=(le="WEB",ue?le="WEB":Q?le="QQ_MP":Z?le="TT_MP":$?le="BAIDU_MP":ee?le="ALI_MP":X?le="WX_MP":ne&&(le="UNI_NATIVE_APP"),R[le]),ge=/iPad/i.test(ie),_e=/iPhone/i.test(ie)&&!ge,he=/iPod/i.test(ie),fe=_e||ge||he,ve=(pe=ie.match(/OS (\d+)_/i))&&pe[1]?pe[1]:null,me=/Android/i.test(ie),Me=function(){var e=ie.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);if(!e)return null;var t=e[1]&&parseFloat(e[1]),n=e[2]&&parseFloat(e[2]);return t&&n?parseFloat(e[1]+"."+e[2]):t||null;}();!function(){var e=ie.match(/Chrome\/(\d+)/);e&&e[1]&&parseFloat(e[1]);}();var ye=/MSIE/.test(ie)||ie.indexOf("Trident")>-1&&ie.indexOf("rv:11.0")>-1,Ie=function(){var e=/MSIE\s(\d+)\.\d/.exec(ie),t=e&&parseFloat(e[1]);return!t&&/Trident\/7.0/i.test(ie)&&/rv:11.0/.test(ie)&&(t=11),t;}();!function(){var e=ie.match(/TBS\/(\d+)/i);if(e&&e[1])e[1];}();var Ce,Te,De=/Windows/i.test(ie),Ee=/MAC OS X/i.test(ie),Se=ae&&"undefined"!=typeof Worker&&!ye,ke=me||fe,Le=ae&&void 0!==window.tencent_cloud_im_csig_flutter_for_web_25F_cy;Ce="undefined"!=typeof console?console:"undefined"!=typeof global&&global.console?global.console:"undefined"!=typeof window&&window.console?window.console:{};for(var Ae=function Ae(){},Re=["assert","clear","count","debug","dir","dirxml","error","group","groupCollapsed","groupEnd","info","log","profile","profileEnd","table","time","timeEnd","timeStamp","trace","warn"],Ne=Re.length;Ne--;){Te=Re[Ne],console[Te]||(Ce[Te]=Ae);}var Oe=Ce,Ge=0,Ue=function Ue(){return new Date().getTime()+Ge;},Pe=function Pe(){Ge=0;},be=function be(){return Math.floor(Ue()/1e3);},we=0;function Fe(){return Ht()?"%c TIM %c":"TIM";}function qe(){var e,t=((e=new Date()).setTime(Ue()),e);return t.toLocaleTimeString("en-US",{hour12:!1})+"."+function(e){var t;switch(e.toString().length){case 1:t="00"+e;break;case 2:t="0"+e;break;default:t=e;}return t;}(t.getMilliseconds());}var xe={arguments2String:function arguments2String(e){var t="";if(1===e.length)t=e[0];else for(var n=0,o=e.length;n<o;n++){rt(e[n])?ut(e[n])?t+=dt(e[n]):t+=JSON.stringify(e[n]):t+=e[n],t+=" ";}return t;},_exec:function _exec(e,t){Ht()?Oe[e](Fe(),"background:#0abf5b; padding:1px; border-radius:3px; color: #fff","background:transparent",qe(),t):Oe[e]("".concat(Fe()," ").concat(qe()," ").concat(t));},d:function d(){if(we<=-1){var e=this.arguments2String(arguments);this._exec("debug",e);}},l:function l(){if(we<=0){var e=this.arguments2String(arguments);this._exec("log",e);}},log:function log(){if(we<=0){var e=this.arguments2String(arguments);this._exec("log",e);}},i:function i(){if(we<=1){var e=this.arguments2String(arguments);this._exec("info",e);}},w:function w(){if(we<=2){var e=this.arguments2String(arguments);this._exec("warn",e);}},e:function e(){if(we<=3){var e=this.arguments2String(arguments);this._exec("error",e);}},setLevel:function setLevel(e){e<4&&this._exec("log","set level from "+we+" to "+e),we=e;},getLevel:function getLevel(){return we;}},Ve={JPG:1,JPEG:1,GIF:2,PNG:3,BMP:4,UNKNOWN:255},Be={NICK:"Tag_Profile_IM_Nick",GENDER:"Tag_Profile_IM_Gender",BIRTHDAY:"Tag_Profile_IM_BirthDay",LOCATION:"Tag_Profile_IM_Location",SELFSIGNATURE:"Tag_Profile_IM_SelfSignature",ALLOWTYPE:"Tag_Profile_IM_AllowType",LANGUAGE:"Tag_Profile_IM_Language",AVATAR:"Tag_Profile_IM_Image",MESSAGESETTINGS:"Tag_Profile_IM_MsgSettings",ADMINFORBIDTYPE:"Tag_Profile_IM_AdminForbidType",LEVEL:"Tag_Profile_IM_Level",ROLE:"Tag_Profile_IM_Role"},He={UNKNOWN:"Gender_Type_Unknown",FEMALE:"Gender_Type_Female",MALE:"Gender_Type_Male"},Ke={NONE:"AdminForbid_Type_None",SEND_OUT:"AdminForbid_Type_SendOut"},We={NEED_CONFIRM:"AllowType_Type_NeedConfirm",ALLOW_ANY:"AllowType_Type_AllowAny",DENY_ANY:"AllowType_Type_DenyAny"},Ye="JoinedSuccess",je="WaitAdminApproval",ze="@TGS#_",Je="@TOPIC#_",Xe=["url"],Qe=function Qe(e){return"map"===ct(e);},Ze=function Ze(e){return"file"===ct(e);},$e=function $e(e){return null!==e&&("number"==typeof e&&!isNaN(e-0)||"object"===n(e)&&e.constructor===Number);},et=function et(e){return"string"==typeof e;},nt=function nt(e){return null!==e&&"object"===n(e);},ot=function ot(e){if("object"!==n(e)||null===e)return!1;var t=Object.getPrototypeOf(e);if(null===t)return!0;for(var o=t;null!==Object.getPrototypeOf(o);){o=Object.getPrototypeOf(o);}return t===o;},st=function st(e){return"function"==typeof Array.isArray?Array.isArray(e):"array"===ct(e);},at=function at(e){return void 0===e;},rt=function rt(e){return st(e)||nt(e);},it=function it(e){return"function"==typeof e;},ut=function ut(e){return e instanceof Error;},ct=function ct(e){return Object.prototype.toString.call(e).match(/^\[object (.*)\]$/)[1].toLowerCase();},lt=function lt(e){if("string"!=typeof e)return!1;var t=e[0];return!/[^a-zA-Z0-9]/.test(t);};Date.now||(Date.now=function(){return new Date().getTime();});var pt=function e(t,n,o,s){if(!rt(t)||!rt(n))return 0;for(var a,r=0,i=Object.keys(n),u=0,c=i.length;u<c;u++){if(a=i[u],!(at(n[a])||o&&o.includes(a)))if(rt(t[a])&&rt(n[a]))r+=e(t[a],n[a],o,s);else{if(s&&s.includes(n[a]))continue;t[a]!==n[a]&&(t[a]=n[a],r+=1);}}return r;},dt=function dt(e){return JSON.stringify(e,["message","code"]);},gt=function gt(e){if(0===e.length)return 0;for(var t=0,n=0,o="undefined"!=typeof document&&void 0!==document.characterSet?document.characterSet:"UTF-8";void 0!==e[t];){n+=e[t++].charCodeAt[t]<=255?1:!1===o?3:2;}return n;},_t=function _t(e){var t=e||99999999;return Math.round(Math.random()*t);},ht="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",ft=ht.length,vt=function vt(e,t){for(var n in e){if(e[n]===t)return!0;}return!1;},mt={},Mt=function Mt(e){return-1===e.indexOf("http://")||-1===e.indexOf("https://")?"https://"+e:e.replace(/https|http/,"https");},yt=function e(t){if(0===Object.getOwnPropertyNames(t).length)return Object.create(null);var o=Array.isArray(t)?[]:Object.create(null),s="";for(var a in t){null!==t[a]?void 0!==t[a]?(s=n(t[a]),["string","number","function","boolean"].indexOf(s)>=0?o[a]=t[a]:o[a]=e(t[a])):o[a]=void 0:o[a]=null;}return o;};function It(e,t){if(!st(e)||!st(t))return!1;var n=!1;return t.forEach(function(t){var o=t.key,s=t.value,a=e.find(function(e){return e.key===o;});a?a.value!==s&&(a.value=s,n=!0):(e.push({key:o,value:s}),n=!0);}),n;}var Ct=function Ct(e){return e===S.GRP_AVCHATROOM;},Tt=function Tt(e){var t=e.type,n=e.groupID;return t===S.GRP_COMMUNITY||"".concat(n).startsWith(ze)&&!"".concat(n).includes(Je);},Dt=function Dt(e){return"".concat(e).startsWith(ze)&&"".concat(e).includes(Je);},Et=function Et(e){return et(e)&&e.slice(0,3)===S.CONV_C2C;},St=function St(e){return et(e)&&e.slice(0,5)===S.CONV_GROUP;},kt=function kt(e){return et(e)&&e===S.CONV_SYSTEM;};function Lt(e,t){var n={};return Object.keys(e).forEach(function(o){n[o]=t(e[o],o);}),n;}function At(e){return se?new Promise(function(t,n){re.getImageInfo({src:e,success:function success(e){t({width:e.width,height:e.height});},fail:function fail(){t({width:0,height:0});}});}):ye&&9===Ie?Promise.resolve({width:0,height:0}):new Promise(function(t,n){var o=new Image();o.onload=function(){t({width:this.width,height:this.height}),o=null;},o.onerror=function(){t({width:0,height:0}),o=null;},o.src=e;});}function Rt(){function e(){return(65536*(1+Math.random())|0).toString(16).substring(1);}return"".concat(e()+e()).concat(e()).concat(e()).concat(e()).concat(e()).concat(e()).concat(e());}function Nt(){var e="unknown";if(Ee&&(e="mac"),De&&(e="windows"),fe&&(e="ios"),me&&(e="android"),se)try{var t=re.getSystemInfoSync().platform;void 0!==t&&(e=t);}catch(n){}return e;}function Ot(e,t){e=e.split("."),t=t.split(".");for(var n=Math.max(e.length,t.length);e.length<n;){e.push("0");}for(;t.length<n;){t.push("0");}for(var o=0;o<n;o++){var s=parseInt(e[o]),a=parseInt(t[o]);if(s>a)return 1;if(s<a)return-1;}return 0;}function Gt(e){var t=e.originUrl,n=void 0===t?void 0:t,o=e.originWidth,s=e.originHeight,a=e.min,r=void 0===a?198:a,i=parseInt(o),u=parseInt(s),c={url:void 0,width:0,height:0};if((i<=u?i:u)<=r)c.url=n,c.width=i,c.height=u;else{u<=i?(c.width=Math.ceil(i*r/u),c.height=r):(c.width=r,c.height=Math.ceil(u*r/i));var l=n&&n.indexOf("?")>-1?"".concat(n,"&"):"".concat(n,"?");c.url="".concat(l,198===r?"imageView2/3/w/198/h/198":"imageView2/3/w/720/h/720");}return at(n)?(c.url,g(c,Xe)):c;}function Ut(e){var t=e[2];e[2]=e[1],e[1]=t;for(var n=0;n<e.length;n++){e[n].setType(n);}}function Pt(e){var t=e.servcmd;return t.slice(t.indexOf(".")+1);}function bt(e,t){return Math.round(Number(e)*Math.pow(10,t))/Math.pow(10,t);}function wt(e,t){return e.includes(t);}function Ft(e,t){return e.includes(t);}function qt(e){return e.split(Je)[0];}var xt=function xt(e,t,n){if(at(t))return"";switch(e){case S.MSG_TEXT:return t.text;case S.MSG_IMAGE:return n?"[Image]":"[图片]";case S.MSG_LOCATION:return n?"[Location]":"[位置]";case S.MSG_AUDIO:return n?"[Voice]":"[语音]";case S.MSG_VIDEO:return n?"[Video]":"[视频]";case S.MSG_FILE:return n?"[File]":"[文件]";case S.MSG_CUSTOM:return n?"[Custom Messages]":"[自定义消息]";case S.MSG_GRP_TIP:return n?"[Group Notification]":"[群提示消息]";case S.MSG_GRP_SYS_NOTICE:return n?"[Group System Message]":"[群系统通知]";case S.MSG_FACE:return n?"[Animated Sticker]":"[动画表情]";case S.MSG_MERGER:return n?"[Chat Record]":"[聊天记录]";default:return"";}};function Vt(e){return e===S.MSG_TEXT||e===S.MSG_CUSTOM||e===S.MSG_LOCATION||e===S.MSG_FACE;}function Bt(e){var t=[];if(!et(e))return t;var n=e.length;if(0===n)return t;for(var o=n-1;o>=0;o--){"1"===e[o]&&t.push(Math.pow(2,n-o-1));}return t;}function Ht(){return!ye&&!se;}function Kt(e){return"the length of userIDList cannot exceed ".concat(e);}function Wt(e,t){if(e){var n=e;return t&&(e.startsWith("http://")?n=e.replace(/^http:\/\/[^/]+/,t):e.startsWith("https://")&&(n=e.replace(/^https:\/\/[^/]+/,t))),n;}}var Yt=Object.prototype.hasOwnProperty;function jt(e){if(null==e)return!0;if("boolean"==typeof e)return!1;if("number"==typeof e)return 0===e;if("string"==typeof e)return 0===e.length;if("function"==typeof e)return 0===e.length;if(Array.isArray(e))return 0===e.length;if(e instanceof Error)return""===e.message;if(ot(e)){for(var t in e){if(Yt.call(e,t))return!1;}return!0;}return!(!Qe(e)&&(n=e,"set"!==ct(n))&&!Ze(e))&&0===e.size;var n;}function zt(e,t,n){if(void 0===t)return!0;var o=!0;if(ot(t))Object.keys(t).forEach(function(s){var a=1===e.length?e[0][s]:void 0;o=!!Jt(a,t[s],n,s)&&o;});else if(st(t))for(var s=0;s<t.length;s++){o=!!Jt(e[s],t[s],n,t[s].name)&&o;}if(o)return o;throw new Error("Params validate failed.");}function Jt(e,t,n,o){if(void 0===t)return!0;var s=!0;if(t.required&&jt(e)&&(xe.e("[".concat(n,'] Missing required params: "').concat(o,'".')),s=!1),!jt(e)){var a=ct(e),r=t.type.toLowerCase();a!==r&&("asyncfunction"===a&&"function"===r||(xe.e("[".concat(n,'] Invalid params: type check failed for "').concat(o,'".Expected ').concat(t.type,".")),s=!1));}return t.validator&&!t.validator(e)&&(xe.e("[".concat(n,"] Invalid params: custom validator check failed for params.")),s=!1),s;}var Xt,Qt={UNSEND:"unSend",SUCCESS:"success",FAIL:"fail"},Zt={NOT_START:"notStart",PENDING:"pending",RESOLVED:"resolved",REJECTED:"rejected"},$t=function $t(e){if(!e)return!1;if(Et(e)||St(e)||kt(e))return!0;var t=Sn("InvalidConversationID",e);return t&&xe.w(t),!1;},en=function en(e){""!==e.desc&&""!==Sn("API_REFER")&&xe.w("[".concat(e.api,"] | ").concat(e.param," | ").concat(e.desc,", ").concat(Sn("API_REFER")).concat(e.api));},tn=function tn(){return Sn("StringRequiredLog");},nn=function nn(e){return Sn("NonEmptyStringRequiredLog",e);},on=function on(){return Sn("NumberRequiredLog");},sn=function sn(){return Sn("UndefinedNotAllowedLog");},an=function an(){return Sn("FileRequiredLog");},rn=function rn(){return Sn("FunctionRequiredLog");},un=function un(){return Sn("ArrayRequiredLog");},cn=function cn(){return Sn("NonEmptyArrayLog");},ln=function ln(){return Sn("CallbackMissingLog");},pn=function pn(){return Sn("PositiveIntegerRequiredLog");},dn=function dn(e,t){return Sn("StringNotLongerThanLog",e,t);},gn=function gn(e,t){return Sn("NumberLessThanLog",e,t);},_n=function _n(e){return Sn("KeyValueStringRequiredLog",e);},hn=function hn(){return Sn("PlainObjectRequiredLog");},fn=function fn(){return Sn("NonEmptyContentRequiredLog");},vn=function vn(){return Sn("FileNotSelectedLog");},mn=function mn(){return Sn("MessageInstanceRequiredLog");},Mn=function Mn(){return Sn("NonAnonymousFunctionLog");},yn=function yn(){return Sn("MessageExtensionNotAvailableLog");},In={type:"String",required:!0},Cn={type:"Array",required:!0},Tn={type:"Object",required:!0},Dn={type:"Boolean",required:!0},En={type:"number",required:!0},Sn=null,kn={hookGetAPITips:function hookGetAPITips(e){Sn=e;},login:{userID:In,userSig:In},addToBlacklist:{userIDList:Cn},removeFromBlacklist:{userIDList:Cn},on:[{name:"eventName",type:"String",validator:function validator(e){return"string"==typeof e&&0!==e.length||(en({api:"on",param:"eventName",desc:nn("eventName")}),!1);}},{name:"handler",type:"Function",validator:function validator(e){return"function"!=typeof e?(en({api:"on",param:"handler",desc:rn()}),!1):(""===e.name&&en({api:"on",param:"handler",desc:Mn()}),!0);}}],once:[{name:"eventName",type:"String",validator:function validator(e){return"string"==typeof e&&0!==e.length||(en({api:"once",param:"eventName",desc:nn("eventName")}),!1);}},{name:"handler",type:"Function",validator:function validator(e){return"function"!=typeof e?(en({api:"once",param:"handler",desc:rn()}),!1):(""===e.name&&en({api:"once",param:"handler",desc:Mn()}),!0);}}],off:[{name:"eventName",type:"String",validator:function validator(e){return"string"==typeof e&&0!==e.length||(en({api:"off",param:"eventName",desc:nn("eventName")}),!1);}},{name:"handler",type:"Function",validator:function validator(e){return"function"!=typeof e?(en({api:"off",param:"handler",desc:rn()}),!1):(""===e.name&&en({api:"off",param:"handler",desc:Mn()}),!0);}}],sendMessage:[t({name:"message"},Tn)],setMessageExtensions:[t(t({name:"message"},Tn),{},{validator:function validator(e){return e.status===Qt.SUCCESS&&!0===e.isSupportExtension||(en({api:"setMessageExtensions",param:"message",desc:yn()}),!1);}}),t({name:"extensions"},Cn)],getMessageExtensions:[t(t({name:"message"},Tn),{},{validator:function validator(e){return e.status===Qt.SUCCESS&&!0===e.isSupportExtension||(en({api:"getMessageExtensions",param:"message",desc:yn()}),!1);}})],deleteMessageExtensions:[t(t({name:"message"},Tn),{},{validator:function validator(e){return e.status===Qt.SUCCESS&&!0===e.isSupportExtension||(en({api:"deleteMessageExtensions",param:"message",desc:yn()}),!1);}})],getMessageList:{conversationID:t(t({},In),{},{validator:function validator(e){return $t(e);}}),nextReqMessageID:{type:"String"},count:{type:"Number",validator:function validator(e){return!(!at(e)&&!/^[1-9][0-9]*$/.test(e))||(en({api:"getMessageList",param:"count",desc:pn()}),!1);}}},getMessageListHopping:{conversationID:t(t({},In),{},{validator:function validator(e){return $t(e);}}),sequence:{type:"Number"},time:{type:"Number"},direction:{type:"Number",validator:function validator(e){return!(!at(e)&&0!==e&&1!==e)||(en({api:"getMessageListHopping",param:"direction",desc:Sn("0Or1RequiredLog")}),!1);}},count:{type:"Number",validator:function validator(e){return!(!at(e)&&!/^[1-9][0-9]*$/.test(e))||(en({api:"getMessageListHopping",param:"count",desc:pn}),!1);}}},setMessageRead:{conversationID:t(t({},In),{},{validator:function validator(e){return $t(e);}})},setAllMessageRead:{scope:{type:"String",required:!1,validator:function validator(e){return!e||-1!==[S.READ_ALL_C2C_MSG,S.READ_ALL_GROUP_MSG,S.READ_ALL_MSG].indexOf(e)||(en({api:"setAllMessageRead",param:"scope",desc:"TIM.TYPES.READ_ALL_C2C_MSG or TIM.TYPES.READ_ALL_GROUP_MSG or TIM.TYPES.READ_ALL_MSG required"}),!1);}}},getConversationProfile:[t(t({name:"conversationID"},In),{},{validator:function validator(e){return $t(e);}})],clearHistoryMessage:[t(t({name:"conversationID"},In),{},{validator:function validator(e){return $t(e);}})],pinConversation:{conversationID:t(t({},In),{},{validator:function validator(e){return $t(e);}}),isPinned:t({},Dn)},setConversationCustomData:{conversationIDList:t({},Cn),customData:{type:"String",validator:function validator(e){return et(e)?!(e.length>256)||(en({api:"setConversationCustomData",param:"customData",desc:dn("customData",256)}),!1):(en({api:"setConversationCustomData",param:"customData",desc:tn()}),!1);}}},markConversation:{conversationIDList:t({},Cn),markType:{type:"number",validator:function validator(e){return $e(e)?e<=0?(en({api:"markConversation",param:"markType",desc:(t="markType",n=0,Sn("NumberGreaterThanLog",t,n))}),!1):!(e>=Math.pow(2,64))||(en({api:"markConversation",param:"markType",desc:gn("markType","Math.pow(2,64)")}),!1):(en({api:"markConversation",param:"markType",desc:on()}),!1);var t,n;}},enableMark:t({},Dn)},createConversationGroup:{conversationIDList:t({},Cn),groupName:t(t({},In),{},{validator:function validator(e){return!!e&&(!(e.length>32)||(en({api:"createConversationGroup",param:"groupName",desc:dn("groupName",32)}),!1));}})},deleteConversationGroup:[t({name:"groupName"},In)],renameConversationGroup:{oldName:t({},In),newName:t(t({},In),{},{validator:function validator(e){return!!e&&(!(e.length>32)||(en({api:"renameConversationGroup",param:"newName",desc:dn("newName",32)}),!1));}})},addConversationsToGroup:{conversationIDList:t({},Cn),groupName:t({},In)},deleteConversationsFromGroup:{conversationIDList:t({},Cn),groupName:t({},In)},getGroupList:{groupProfileFilter:{type:"Array"}},getGroupProfile:{groupID:In,groupCustomFieldFilter:{type:"Array"},memberCustomFieldFilter:{type:"Array"}},getGroupProfileAdvance:{groupIDList:Cn},createGroup:{name:In},joinGroup:{groupID:In,type:{type:"String"},applyMessage:{type:"String"}},quitGroup:[t({name:"groupID"},In)],handleApplication:{message:Tn,handleAction:In,handleMessage:{type:"String"}},changeGroupOwner:{groupID:In,newOwnerID:In},updateGroupProfile:{groupID:In,muteAllMembers:{type:"Boolean"}},dismissGroup:[t({name:"groupID"},In)],searchGroupByID:[t({name:"groupID"},In)],initGroupAttributes:{groupID:In,groupAttributes:t(t({},Tn),{},{validator:function validator(e){var t=!0;return Object.keys(e).forEach(function(n){if(!et(e[n]))return en({api:"initGroupAttributes",param:"groupAttributes",desc:_n("value")}),t=!1;}),t;}})},setGroupAttributes:{groupID:In,groupAttributes:t(t({},Tn),{},{validator:function validator(e){var t=!0;return Object.keys(e).forEach(function(n){if(!et(e[n]))return en({api:"setGroupAttributes",param:"groupAttributes",desc:_n("value")}),t=!1;}),t;}})},deleteGroupAttributes:{groupID:In,keyList:{type:"Array",validator:function validator(e){if(at(e)||!st(e))return en({api:"deleteGroupAttributes",param:"keyList",desc:un()}),!1;if(!jt(e)){var t=!0;return e.forEach(function(e){if(!et(e))return en({api:"deleteGroupAttributes",param:"keyList",desc:Sn("StringArrayRequiredLog")}),t=!1;}),t;}return!0;}}},getGroupAttributes:{groupID:In,keyList:{type:"Array",validator:function validator(e){if(at(e)||!st(e))return en({api:"getGroupAttributes",param:"keyList",desc:un()}),!1;if(!jt(e)){var t=!0;return e.forEach(function(e){if(!et(e))return en({api:"getGroupAttributes",param:"keyList",desc:_n("key")}),t=!1;}),t;}return!0;}}},setGroupCounters:{groupID:In,counters:Tn},increaseGroupCounter:{groupID:In,key:In,value:En},decreaseGroupCounter:{groupID:In,key:In,value:En},getGroupCounters:{groupID:In},getGroupMemberList:{groupID:In,count:{type:"Number"}},getGroupMemberProfile:{groupID:In,userIDList:Cn,memberCustomFieldFilter:{type:"Array"}},addGroupMember:{groupID:In,userIDList:Cn},setGroupMemberRole:{groupID:In,userID:In,role:In},setGroupMemberMuteTime:{groupID:In,userID:In,muteTime:{type:"Number",validator:function validator(e){return e>=0;}}},setGroupMemberNameCard:{groupID:In,userID:{type:"String"},nameCard:{type:"String",validator:function validator(e){return et(e)?(e.length,!0):(en({api:"setGroupMemberNameCard",param:"nameCard",desc:tn()}),!1);}}},setGroupMemberCustomField:{groupID:In,userID:{type:"String"},memberCustomField:Cn},deleteGroupMember:{groupID:In},markGroupMemberList:{groupID:In,markType:{type:"number",validator:function validator(e){return $e(e)?!(e<1e3)||(en({api:"markGroupMemberList",param:"markType",desc:(t="markType",n=1e3,Sn("NumberGreaterOrEqualLog",t,n))}),!1):(en({api:"markGroupMemberList",param:"markType",desc:on()}),!1);var t,n;}},userIDList:t({},Cn),enableMark:t({},Dn)},createTextMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){return ot(e)?et(e.text)?0!==e.text.length||(en({api:"createTextMessage",param:"payload.text",desc:fn()}),!1):(en({api:"createTextMessage",param:"payload.text",desc:tn()}),!1):(en({api:"createTextMessage",param:"payload",desc:hn()}),!1);}})},createTextAtMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){return ot(e)?et(e.text)?0===e.text.length?(en({api:"createTextAtMessage",param:"payload.text",desc:fn()}),!1):!(e.atUserList&&!st(e.atUserList))||(en({api:"createTextAtMessage",param:"payload.atUserList",desc:un()}),!1):(en({api:"createTextAtMessage",param:"payload.text",desc:tn()}),!1):(en({api:"createTextAtMessage",param:"payload",desc:hn()}),!1);}})},createCustomMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){return ot(e)?e.data&&!et(e.data)?(en({api:"createCustomMessage",param:"payload.data",desc:tn()}),!1):e.description&&!et(e.description)?(en({api:"createCustomMessage",param:"payload.description",desc:tn()}),!1):!(e.extension&&!et(e.extension))||(en({api:"createCustomMessage",param:"payload.extension",desc:tn()}),!1):(en({api:"createCustomMessage",param:"payload",desc:hn()}),!1);}})},createImageMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){if(!ot(e))return en({api:"createImageMessage",param:"payload",desc:hn()}),!1;if(at(e.file))return en({api:"createImageMessage",param:"payload.file",desc:sn()}),!1;if(ae){if(!(e.file instanceof HTMLInputElement||Ze(e.file)))return ot(e.file)&&"undefined"!=typeof uni?0!==e.file.tempFilePaths.length&&0!==e.file.tempFiles.length||(en({api:"createImageMessage",param:"payload.file",desc:vn()}),!1):(en({api:"createImageMessage",param:"payload.file",desc:an()}),!1);if(e.file instanceof HTMLInputElement&&0===e.file.files.length)return en({api:"createImageMessage",param:"payload.file",desc:vn()}),!1;}return!0;},onProgress:{type:"Function",required:!1,validator:function validator(e){return at(e)&&en({api:"createImageMessage",param:"onProgress",desc:ln()}),!0;}}})},createAudioMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){return!!ot(e)||(en({api:"createAudioMessage",param:"payload",desc:hn()}),!1);}}),onProgress:{type:"Function",required:!1,validator:function validator(e){return at(e)&&en({api:"createAudioMessage",param:"onProgress",desc:ln()}),!0;}}},createVideoMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){if(!ot(e))return en({api:"createVideoMessage",param:"payload",desc:hn()}),!1;if(at(e.file))return en({api:"createVideoMessage",param:"payload.file",desc:sn()}),!1;if(ae){if(!(e.file instanceof HTMLInputElement||Ze(e.file)))return ot(e.file)&&"undefined"!=typeof uni?!!Ze(e.file.tempFile)||(en({api:"createVideoMessage",param:"payload.file",desc:vn()}),!1):(en({api:"createVideoMessage",param:"payload.file",desc:an()}),!1);if(e.file instanceof HTMLInputElement&&0===e.file.files.length)return en({api:"createVideoMessage",param:"payload.file",desc:vn()}),!1;}return!0;}}),onProgress:{type:"Function",required:!1,validator:function validator(e){return at(e)&&en({api:"createVideoMessage",param:"onProgress",desc:ln()}),!0;}}},createFaceMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){return ot(e)?$e(e.index)?!!et(e.data)||(en({api:"createFaceMessage",param:"payload.data",desc:tn()}),!1):(en({api:"createFaceMessage",param:"payload.index",desc:on()}),!1):(en({api:"createFaceMessage",param:"payload",desc:hn()}),!1);}})},createFileMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){if(!ot(e))return en({api:"createFileMessage",param:"payload",desc:hn()}),!1;if(at(e.file))return en({api:"createFileMessage",param:"payload.file",desc:sn()}),!1;if(ae){if(!(e.file instanceof HTMLInputElement||Ze(e.file)))return ot(e.file)&&"undefined"!=typeof uni?0!==e.file.tempFilePaths.length&&0!==e.file.tempFiles.length||(en({api:"createFileMessage",param:"payload.file",desc:vn()}),!1):(en({api:"createFileMessage",param:"payload.file",desc:an()}),!1);if(e.file instanceof HTMLInputElement&&0===e.file.files.length)return en({api:"createFileMessage",param:"payload.file",desc:vn()}),!1;}return!0;}}),onProgress:{type:"Function",required:!1,validator:function validator(e){return at(e)&&en({api:"createFileMessage",param:"onProgress",desc:ln()}),!0;}}},createLocationMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){return ot(e)?et(e.description)?$e(e.longitude)?!!$e(e.latitude)||(en({api:"createLocationMessage",param:"payload.latitude",desc:on()}),!1):(en({api:"createLocationMessage",param:"payload.longitude",desc:on()}),!1):(en({api:"createLocationMessage",param:"payload.description",desc:tn()}),!1):(en({api:"createLocationMessage",param:"payload",desc:hn()}),!1);}})},createMergerMessage:{to:In,conversationType:In,payload:t(t({},Tn),{},{validator:function validator(e){if(jt(e.messageList))return en({api:"createMergerMessage",param:"payload.messageList",desc:cn()}),!1;if(jt(e.compatibleText))return en({api:"createMergerMessage",param:"payload.compatibleText",desc:nn("compatibleText")}),!1;var t=!1;return e.messageList.forEach(function(e){e.status===Qt.FAIL&&(t=!0);}),!t||(en({api:"createMergerMessage",param:"payload.messageList",desc:Sn("MergeFailedMessageLog")}),!1);}})},revokeMessage:[t(t({name:"message"},Tn),{},{validator:function validator(e){return jt(e)?(en({api:"revokeMessage",param:"message",desc:mn()}),!1):e.conversationType===S.CONV_SYSTEM?(en({api:"revokeMessage",param:"message",desc:Sn("MessageCanBeRevokedDesc")}),!1):!0!==e.isRevoked||(en({api:"revokeMessage",param:"message",desc:Sn("MessageRevokedLog")}),!1);}})],deleteMessage:[t(t({name:"messageList"},Cn),{},{validator:function validator(e){return!jt(e)||(en({api:"deleteMessage",param:"messageList",desc:cn()}),!1);}})],translateText:{sourceTextList:Cn,sourceLanguage:In,targetLanguage:In},modifyMessage:[t(t({name:"message"},Tn),{},{validator:function validator(e){return jt(e)?(en({api:"modifyMessage",param:"message",desc:mn()}),!1):e.conversationType===S.CONV_SYSTEM?(en({api:"modifyMessage",param:"message",desc:Sn("MessageCanBeModifiedLog")}),!1):!0!==e._onlineOnlyFlag||(en({api:"modifyMessage",param:"message",desc:Sn("OnlineMessageNotSupportLog")}),!1);}})],getUserProfile:{userIDList:{type:"Array",validator:function validator(e){return st(e)?(0===e.length&&en({api:"getUserProfile",param:"userIDList",desc:cn()}),!0):(en({api:"getUserProfile",param:"userIDList",desc:un()}),!1);}}},updateMyProfile:{profileCustomField:{type:"Array",validator:function validator(e){return!!at(e)||!!st(e)||(en({api:"updateMyProfile",param:"profileCustomField",desc:un()}),!1);}}},setSelfStatus:{customStatus:{type:"String",validator:function validator(e){return!!et(e)||(en({api:"setSelfStatus",param:"customStatus",desc:tn()}),!1);}}},getUserStatus:{userIDList:{type:"Array",validator:function validator(e){return st(e)?0!==e.length||(en({api:"getUserStatus",param:"userIDList",desc:cn()}),!1):(en({api:"getUserStatus",param:"userIDList",desc:un()}),!1);}}},subscribeUserStatus:{userIDList:{type:"Array",validator:function validator(e){return st(e)?0!==e.length||(en({api:"subscribeUserStatus",param:"userIDList",desc:cn()}),!1):(en({api:"subscribeUserStatus",param:"userIDList",desc:un()}),!1);}}},unsubscribeUserStatus:{userIDList:{type:"Array",validator:function validator(e){return!e||!!st(e)||(en({api:"subscribeUserStatus",param:"userIDList",desc:un()}),!1);}}},addFriend:{to:In,source:{type:"String",required:!0,validator:function validator(e){return!!e&&(e.startsWith("AddSource_Type_")?!(e.replace("AddSource_Type_","").length>8)||(en({api:"addFriend",param:"source",desc:dn("keyword",8)}),!1):(en({api:"addFriend",param:"source",desc:Sn("SourcePrefixLog")}),!1));}},remark:{type:"String",required:!1,validator:function validator(e){return!(et(e)&&e.length>96)||(en({api:"addFriend",param:"remark",desc:dn("remark",96)}),!1);}}},deleteFriend:{userIDList:Cn},checkFriend:{userIDList:Cn},getFriendProfile:{userIDList:Cn},updateFriend:{userID:In,remark:{type:"String",required:!1,validator:function validator(e){return!(et(e)&&e.length>96)||(en({api:"updateFriend",param:"remark",desc:dn("remark",96)}),!1);}},friendCustomField:{type:"Array",required:!1,validator:function validator(e){if(e){if(!st(e))return en({api:"updateFriend",param:"friendCustomField",desc:un()}),!1;var t=!0;return e.forEach(function(e){return et(e.key)&&-1!==e.key.indexOf("Tag_SNS_Custom")?et(e.value)?e.key.replace("Tag_SNS_Custom_","").length>8?(en({api:"updateFriend",param:"friendCustomField",desc:dn("keyword",8)}),t=!1):void 0:(en({api:"updateFriend",param:"friendCustomField",desc:_n("value")}),t=!1):(en({api:"updateFriend",param:"friendCustomField",desc:Sn("FriendCustomFieldPrefixLog")}),t=!1);}),t;}return!0;}}},acceptFriendApplication:{userID:In},refuseFriendApplication:{userID:In},deleteFriendApplication:{userID:In},createFriendGroup:{name:In},deleteFriendGroup:{name:In},addToFriendGroup:{name:In,userIDList:Cn},removeFromFriendGroup:{name:In,userIDList:Cn},renameFriendGroup:{oldName:In,newName:In},sendMessageReadReceipt:[{name:"messageList",type:"Array",validator:function validator(e){return st(e)?0!==e.length||(en({api:"sendMessageReadReceipt",param:"messageList",desc:cn()}),!1):(en({api:"sendMessageReadReceipt",param:"messageList",desc:un()}),!1);}}],getMessageReadReceiptList:[{name:"messageList",type:"Array",validator:function validator(e){return st(e)?0!==e.length||(en({api:"getMessageReadReceiptList",param:"messageList",desc:cn()}),!1):(en({api:"getMessageReadReceiptList",param:"messageList",desc:un()}),!1);}}],createTopicInCommunity:{groupID:In,topicName:In},deleteTopicFromCommunity:{groupID:In,topicIDList:{type:"Array",validator:function validator(e){return!e||!!st(e)||(en({api:"deleteTopicFromCommunity",param:"topicIDList",desc:un()}),!1);}}},updateTopicProfile:{groupID:In,topicID:In},getTopicList:{groupID:In,topicIDList:{type:"Array",validator:function validator(e){return!e||!!st(e)||(en({api:"getTopicList",param:"topicIDList",desc:un()}),!1);}}}},Ln={login:1,logout:1,on:1,once:1,off:1,setLogLevel:1,registerPlugin:1,destroy:1,createTextMessage:1,createTextAtMessage:1,createImageMessage:1,createAudioMessage:1,createVideoMessage:1,createCustomMessage:1,createFaceMessage:1,createFileMessage:1,createLocationMessage:1,createMergerMessage:1,downloadMergerMessage:1,createForwardMessage:1,sendMessage:1,resendMessage:1,revokeMessage:1,deleteMessage:1,translateText:1,modifyMessage:1,sendMessageReadReceipt:1,getGroupMessageReadMemberList:1,getMessageReadReceiptList:1,setMessageExtensions:1,getMessageExtensions:1,deleteMessageExtensions:1,getMessageList:1,findMessage:1,getMessageListHopping:1,setMessageRead:1,setAllMessageRead:1,getConversationList:1,getConversationProfile:1,deleteConversation:1,pinConversation:1,getTotalUnreadMessageCount:1,setConversationCustomData:1,markConversation:1,createConversationGroup:1,getConversationGroupList:1,deleteConversationGroup:1,renameConversationGroup:1,addConversationsToGroup:1,deleteConversationsFromGroup:1,clearHistoryMessage:1,getGroupList:1,getGroupProfile:1,createGroup:1,joinGroup:1,updateGroupProfile:1,quitGroup:1,dismissGroup:1,changeGroupOwner:1,searchGroupByID:1,setMessageRemindType:1,getGroupApplicationList:1,handleGroupApplication:1,initGroupAttributes:1,setGroupAttributes:1,deleteGroupAttributes:1,getGroupAttributes:1,setGroupCounters:1,increaseGroupCounter:1,decreaseGroupCounter:1,getGroupCounters:1,getJoinedCommunityList:1,createTopicInCommunity:1,deleteTopicFromCommunity:1,updateTopicProfile:1,getTopicList:1,getGroupMemberProfile:1,getGroupMemberList:1,addGroupMember:1,deleteGroupMember:1,setGroupMemberNameCard:1,setGroupMemberMuteTime:1,setGroupMemberRole:1,setGroupMemberCustomField:1,getGroupOnlineMemberCount:1,markGroupMemberList:1,getMyProfile:1,getUserProfile:1,updateMyProfile:1,setSelfStatus:1,getUserStatus:1,subscribeUserStatus:1,unsubscribeUserStatus:1,getBlacklist:1,addToBlacklist:1,removeFromBlacklist:1,getFriendList:1,addFriend:1,deleteFriend:1,checkFriend:1,updateFriend:1,getFriendProfile:1,getFriendApplicationList:1,refuseFriendApplication:1,deleteFriendApplication:1,acceptFriendApplication:1,setFriendApplicationRead:1,getFriendGroupList:1,createFriendGroup:1,renameFriendGroup:1,deleteFriendGroup:1,addToFriendGroup:1,removeFromFriendGroup:1,callExperimentalAPI:1},An=1,Rn=2,Nn=3,On=4,Gn=6,Un=7,Pn=8,bn=9,wn=10,Fn=11,qn=12,xn=13,Vn=14,Bn=15,Hn=16,Kn=17,Wn=18,Yn=19,jn=20,zn=21,Jn=22,Xn=23,Qn=24,Zn=25,$n=26,eo=27,to=28,no=29,oo=30,so=31,ao=32,ro=function(){function e(t){o(this,e),this._m=t,this._n="";}return a(e,[{key:"isLoggedIn",value:function value(){return this._m.getModule(qn).isLoggedIn();}},{key:"isOversea",value:function value(){return this._m.getModule(qn).isOversea();}},{key:"isPrivateNetWork",value:function value(){return this._m.getModule(qn).isPrivateNetWork();}},{key:"getFileDownloadProxy",value:function value(){return this._m.getModule(qn).getFileDownloadProxy();}},{key:"getMyUserID",value:function value(){return this._m.getModule(qn).getUserID();}},{key:"getMyTinyID",value:function value(){return this._m.getModule(qn).getTinyID();}},{key:"getSDKAppID",value:function value(){return this._m.getModule(qn).getSDKAppID();}},{key:"isIntl",value:function value(){return this._m.getModule(qn).isIntl();}},{key:"isDevMode",value:function value(){return this._m.getModule(qn).isDevMode();}},{key:"getModule",value:function value(e){return this._m.getModule(e);}},{key:"getPlatform",value:function value(){return de;}},{key:"getNetworkType",value:function value(){return this._m.getModule(Bn).getNetworkType();}},{key:"probeNetwork",value:function value(e){return this._m.getModule(Bn).probe(e);}},{key:"getCloudConfig",value:function value(e){return this._m.getModule(Xn).getCloudConfig(e);}},{key:"emitOuterEvent",value:function value(e,t){this._m.getOuterEmitterInstance().emit(e,t);}},{key:"emitInnerEvent",value:function value(e,t){this._m.getInnerEmitterInstance().emit(e,t);}},{key:"getInnerEmitterInstance",value:function value(){return this._m.getInnerEmitterInstance();}},{key:"generateTjgID",value:function value(e){return this._m.getModule(qn).getTinyID()+"-"+e.random;}},{key:"filterModifiedMessage",value:function value(e){if(!jt(e)){var t=e.filter(function(e){return!0===e.isModified;});t.length>0&&this.emitOuterEvent(E.MESSAGE_MODIFIED,t);}}},{key:"filterUnmodifiedMessage",value:function value(e){return jt(e)?[]:e.filter(function(e){return!1===e.isModified;});}},{key:"request",value:function value(e){return this._m.getModule(jn).request(e);}},{key:"canIUse",value:function value(e){return this._m.getModule(eo).canIUse(e);}},{key:"getErrorMessage",value:function value(e,t,n){return this._m.getErrorMessage(e,t,n);}},{key:"outputWarning",value:function value(e,t,n){var o=this.getErrorMessage(e,t,n);o&&xe.w(o);}}]),e;}(),io="wslogin",uo="wslogout",co="wshello",lo="KickOther",po="getmsg",go="authkey",_o="sendmsg",ho="send_group_msg",fo="portrait_get_all",vo="portrait_set",mo="black_list_get",Mo="black_list_add",yo="black_list_delete",Io="msgwithdraw",Co="msgreaded",To="set_c2c_peer_mute_notifications",Do="get_c2c_peer_mute_notifications",Eo="getroammsg",So="get_peer_read_time",ko="delete_c2c_msg_ramble",Lo="modify_c2c_msg",Ao="set_key_values",Ro="get_key_values",No="page_get",Oo="get",Go="batch_delete",Uo="clear_msg",Po="top",bo="deletemsg",wo="set_conv_custom_data",Fo="mark_contact",qo="create_contact_group",xo="del_contact_group",Vo="update_contact_group",Bo="add_conv_to_group",Ho="del_conv_from_group",Ko="get_contact_group",Wo="get_joined_group_list",Yo="get_group_self_member_info",jo="create_group",zo="destroy_group",Jo="modify_group_base_info",Xo="apply_join_group",Qo="apply_join_group_noauth",Zo="quit_group",$o="get_group_public_info",es="change_group_owner",ts="handle_apply_join_group",ns="handle_invite_join_permission_group",os="handle_invite_join_group",ss="group_msg_recall",as="msg_read_report",rs="read_all_unread_msg",is="group_msg_get",us="get_group_msg_receipt",cs="group_msg_receipt",ls="c2c_msg_read_receipt",ps="get_group_msg_receipt_detail",ds="get_pendency",gs="deletemsg",_s="get_msg",hs="get_msg_noauth",fs="get_online_member_num",vs="delete_group_ramble_msg_by_seq",ms="modify_group_msg",Ms="set_group_attr",ys="modify_group_attr",Is="delete_group_attr",Cs="clear_group_attr",Ts="get_group_attr",Ds="group_set_key_values",Es="group_get_key_values",Ss="get_group_notify",ks="update_group_counter",Ls="get_group_counter",As="get_group_member_info",Rs="get_members",Ns="get_specified_group_member_info",Os="add_group_member",Gs="delete_group_member",Us="ban_group_member",Ps="modify_group_member_info",bs="modify_user_info",ws="cos",Fs="pre_sig",qs="video_cover",xs="tim_web_report_v2",Vs="alive",Bs="msg_push",Hs="multi_msg_push_ws",Ks="ws_msg_push_ack",Ws="stat_forceoffline",Ys="save_relay_json_msg",js="get_relay_json_msg",zs="fetch_config",Js="push_configv2",Xs="fetch_imsdk_purchase_bitsv2",Qs="push_imsdk_purchase_bitsv2",Zs="notify2",$s="create_topic",ea="destroy_topic",ta="modify_topic",na="get_topic",oa="ws_set_custom_status",sa="ws_get_user_status",aa="ws_status_subscribe",ra="ws_status_unsubscribe",ia="ws_stat_background",ua="ws_stat_foreground",ca="ws_stat_settoken",la="get_local_words",pa="ws_batch_trans_text",da={NO_SDKAPPID:2e3,NO_ACCOUNT_TYPE:2001,NO_IDENTIFIER:2002,NO_USERSIG:2003,NO_TINYID:2022,NO_A2KEY:2023,USER_NOT_LOGGED_IN:2024,REPEAT_LOGIN:2025,COS_UNDETECTED:2040,COS_GET_SIG_FAIL:2041,MESSAGE_SEND_FAIL:2100,MESSAGE_SEND_FAIL_NOT_IN_AVCHATROOM:2101,MESSAGE_SEND_NEED_MESSAGE_INSTANCE:2105,MESSAGE_SEND_INVALID_CONVERSATION_TYPE:2106,MESSAGE_FILE_IS_EMPTY:2108,MESSAGE_ONPROGRESS_FUNCTION_ERROR:2109,MESSAGE_REVOKE_FAIL:2110,MESSAGE_DELETE_FAIL:2111,MESSAGE_UNREAD_ALL_FAIL:2112,READ_RECEIPT_MESSAGE_LIST_EMPTY:2114,MESSAGE_SEND_GROUP_WITH_TOPIC_FAIL:2115,CANNOT_DELETE_GROUP_SYSTEM_NOTICE:2116,TRANSLATE_TEXT_FAIL:2117,MESSAGE_IMAGE_SELECT_FILE_FIRST:2251,MESSAGE_IMAGE_TYPES_LIMIT:2252,MESSAGE_IMAGE_SIZE_LIMIT:2253,MESSAGE_AUDIO_UPLOAD_FAIL:2300,MESSAGE_AUDIO_SIZE_LIMIT:2301,MESSAGE_VIDEO_UPLOAD_FAIL:2350,MESSAGE_VIDEO_SIZE_LIMIT:2351,MESSAGE_VIDEO_TYPES_LIMIT:2352,MESSAGE_FILE_UPLOAD_FAIL:2400,MESSAGE_FILE_SELECT_FILE_FIRST:2401,MESSAGE_FILE_SIZE_LIMIT:2402,MESSAGE_FILE_URL_IS_EMPTY:2403,MESSAGE_MERGER_TYPE_INVALID:2450,MESSAGE_MERGER_KEY_INVALID:2451,MESSAGE_MERGER_DOWNLOAD_FAIL:2452,MESSAGE_FORWARD_TYPE_INVALID:2453,MESSAGE_MODIFY_CONFLICT:2480,MESSAGE_MODIFY_DISABLED_IN_AVCHATROOM:2481,CONVERSATION_NOT_FOUND:2500,USER_OR_GROUP_NOT_FOUND:2501,CONVERSATION_UN_RECORDED_TYPE:2502,INVALID_CONVERSATION_ID:2503,ILLEGAL_GROUP_TYPE:2600,CANNOT_JOIN_WORK:2601,ILLEGAL_GROUP_ID:2602,CANNOT_FIND_GROUP:2603,CANNOT_CHANGE_OWNER_IN_AVCHATROOM:2620,CANNOT_CHANGE_OWNER_TO_SELF:2621,CANNOT_DISMISS_WORK:2622,MEMBER_NOT_IN_GROUP:2623,JOIN_GROUP_FAIL:2660,CANNOT_ADD_MEMBER_IN_AVCHATROOM:2661,CANNOT_JOIN_NON_AVCHATROOM_WITHOUT_LOGIN:2662,NOT_OWNER:2681,CANNOT_SET_MEMBER_ROLE_IN_WORK_AND_AVCHATROOM:2682,INVALID_MEMBER_ROLE:2683,CANNOT_SET_SELF_MEMBER_ROLE:2684,CANNOT_MUTE_SELF:2685,BAN_DURATION_INVALID:2686,NOT_MY_FRIEND:2700,ALREADY_MY_FRIEND:2701,FRIEND_GROUP_EXISTED:2710,FRIEND_GROUP_NOT_EXIST:2711,FRIEND_APPLICATION_NOT_EXIST:2716,UPDATE_PROFILE_INVALID_PARAM:2721,UPDATE_PROFILE_NO_KEY:2722,CANNOT_ADD_SELF_TO_BLACKLIST:2742,NETWORK_ERROR:2800,NETWORK_TIMEOUT:2801,NO_NETWORK:2805,UNCAUGHT_ERROR:2903,INVALID_OPERATION:2905,INVALID_TRTC_CMD:2995,OVER_FREQUENCY_LIMIT:2996,CANNOT_FIND_PROTOCOL:2997,CANNOT_FIND_MODULE:2998,SDK_IS_NOT_READY:2999,LOGGING_IN:3e3,LOGIN_FAILED:3001,KICKED_OUT_MULT_DEVICE:3002,KICKED_OUT_MULT_ACCOUNT:3003,KICKED_OUT_USERSIG_EXPIRED:3004,LOGGED_OUT:3005,KICKED_OUT_REST_API:3006,ILLEGAL_TOPIC_ID:3021,CANNOT_USE_COMMERCIAL_ABILITY:3122,PROFANITY_FOUND:3123,MESSAGE_A2KEY_EXPIRED:20002,ACCOUNT_A2KEY_EXPIRED:70001,HELLO_ANSWER_KICKED_OUT:1002,OPEN_SERVICE_OVERLOAD_ERROR:60022},ga="networkRTT",_a="messageE2EDelay",ha="sendMessageC2C",fa="sendMessageGroup",va="sendMessageGroupAV",ma="sendMessageRichMedia",Ma="cosUpload",ya="messageReceivedGroup",Ia="messageReceivedGroupAVPush",Ca="messageReceivedGroupAVPull",Ta=(r(Xt={},ga,2),r(Xt,_a,3),r(Xt,ha,4),r(Xt,fa,5),r(Xt,va,6),r(Xt,ma,7),r(Xt,ya,8),r(Xt,Ia,9),r(Xt,Ca,10),r(Xt,Ma,11),Xt),Da={info:4,warning:5,error:6},Ea={wifi:1,"2g":2,"3g":3,"4g":4,"5g":5,unknown:6,none:7,online:8},Sa={login:4},ka=function(){function e(t){o(this,e),this._n="SSOLogData",this.eventType=Sa[t]||0,this.timestamp=0,this.networkType=8,this.code=0,this.message="",this.moreMessage="",this.extension=t,this.costTime=0,this.duplicate=!1,this.level=4,this.uiPlatform=void 0,this._sentFlag=!1,this._startts=Ue();}return a(e,[{key:"updateTimeStamp",value:function value(){this.timestamp=Ue();}},{key:"start",value:function value(e){return this._startts=e,this;}},{key:"end",value:function value(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(!this._sentFlag){var n=Ue();0===this.costTime&&(this.costTime=n-this._startts),this.setMoreMessage("startts:".concat(this._startts," endts:").concat(n)),t?(this._sentFlag=!0,this._eventStatModule&&this._eventStatModule.pushIn(this)):setTimeout(function(){e._sentFlag=!0,e._eventStatModule&&e._eventStatModule.pushIn(e);},0);}}},{key:"setError",value:function value(e,t,n){if(!(e instanceof Error))return xe.w("".concat(this._n,".setError value not instanceof Error, please check!")),this;if(this._sentFlag)return this;if(this.setNetworkType(n),t)e.code&&this.setCode(e.code),e.message&&this.setMoreMessage(e.message);else{var o=da.NO_NETWORK;this.setCode(o);}return this.setLevel("error"),this;}},{key:"setCode",value:function value(e){return at(e)||this._sentFlag||("ECONNABORTED"===e&&(this.code=103),$e(e)?this.code=e:xe.w("".concat(this._n,".setCode value not a number, please check!"),e,n(e))),this;}},{key:"setMessage",value:function value(e){return at(e)||this._sentFlag||($e(e)&&(this.message=e.toString()),et(e)&&(this.message=e)),this;}},{key:"setCostTime",value:function value(e){return this.costTime=e,this;}},{key:"setLevel",value:function value(e){return at(e)||this._sentFlag||(this.level=Da[e]),this;}},{key:"setMoreMessage",value:function value(e){return jt(this.moreMessage)?this.moreMessage="".concat(e):this.moreMessage+=" ".concat(e),this;}},{key:"setNetworkType",value:function value(e){if(at(e))xe.w("".concat(this._n,".setNetworkType value is undefined, please check!"));else{var t=Ea[e.toLowerCase()];at(t)||(this.networkType=t);}return this;}},{key:"getStartTs",value:function value(){return this._startts;}},{key:"setUIPlatform",value:function value(e){this.uiPlatform=e;}}],[{key:"bindEventStatModule",value:function value(t){e.prototype._eventStatModule=t;}}]),e;}(),La=function(){function e(t){o(this,e),this.type=S.MSG_TEXT,this.content={text:t.text||""};}return a(e,[{key:"setText",value:function value(e){this.content.text=e;}},{key:"sendable",value:function value(){return 0!==this.content.text.length;}}]),e;}(),Aa=function(){function e(t,n){o(this,e),this._imageMemoryURL="",this._fileDownloadProxy=n,se?this.createImageDataASURLInWXMiniApp(t.file):this.createImageDataASURLInWeb(t.file),this._initImageInfoModel(),this.type=S.MSG_IMAGE,this._percent=0,this.content={imageFormat:t.imageFormat||Ve.UNKNOWN,uuid:t.uuid,imageInfoArray:[]},this.initImageInfoArray(t.imageInfoArray),this._autoFixUrl();}return a(e,[{key:"_initImageInfoModel",value:function value(){var e=this;this._ImageInfoModel=function(t){this.instanceID=_t(9999999),this.sizeType=t.type||0,this.type=0,this.size=t.size||0,this.width=t.width||0,this.height=t.height||0,this.imageUrl=t.url||"",this.url=Wt(t.url||e._imageMemoryURL,e._fileDownloadProxy);},this._ImageInfoModel.prototype={setSizeType:function setSizeType(e){this.sizeType=e;},setType:function setType(e){this.type=e;},setImageUrl:function setImageUrl(e){e&&(this.imageUrl=e);},getImageUrl:function getImageUrl(){return this.imageUrl;}};}},{key:"initImageInfoArray",value:function value(e){for(var t=0,n=null,o=null;t<=2;){o=at(e)||at(e[t])?{type:0,size:0,width:0,height:0,url:""}:e[t],(n=new this._ImageInfoModel(o)).setSizeType(t+1),n.setType(t),this.addImageInfo(n),t++;}this.updateAccessSideImageInfoArray();}},{key:"updateImageInfoArray",value:function value(e){for(var t,n=this.content.imageInfoArray.length,o=0;o<n;o++){t=this.content.imageInfoArray[o],e[o].size&&(t.size=e[o].size),e[o].url&&t.setImageUrl(e[o].url),e[o].width&&(t.width=e[o].width),e[o].height&&(t.height=e[o].height);}}},{key:"_autoFixUrl",value:function value(){for(var e=this.content.imageInfoArray.length,t="",n="",o=["http","https"],s=null,a=0;a<e;a++){this.content.imageInfoArray[a].url&&""!==(s=this.content.imageInfoArray[a]).imageUrl&&(n=s.imageUrl.slice(0,s.imageUrl.indexOf("://")+1),t=s.imageUrl.slice(s.imageUrl.indexOf("://")+1),o.indexOf(n)<0&&(n="https:"),this.content.imageInfoArray[a].setImageUrl([n,t].join("")));}}},{key:"updatePercent",value:function value(e){this._percent=e,this._percent>1&&(this._percent=1);}},{key:"updateImageFormat",value:function value(e){this.content.imageFormat=Ve[e.toUpperCase()]||Ve.UNKNOWN;}},{key:"createImageDataASURLInWeb",value:function value(e){void 0!==e&&e.files.length>0&&(this._imageMemoryURL=window.URL.createObjectURL(e.files[0]));}},{key:"createImageDataASURLInWXMiniApp",value:function value(e){e&&e.url&&(this._imageMemoryURL=e.url);}},{key:"replaceImageInfo",value:function value(e,t){this.content.imageInfoArray[t]instanceof this._ImageInfoModel||(this.content.imageInfoArray[t]=e);}},{key:"addImageInfo",value:function value(e){this.content.imageInfoArray.length>=3||this.content.imageInfoArray.push(e);}},{key:"updateAccessSideImageInfoArray",value:function value(){var e=this.content.imageInfoArray,t=e[0],n=t.width,o=void 0===n?0:n,s=t.height,a=void 0===s?0:s;0!==o&&0!==a&&(Ut(e),Object.assign(e[2],Gt({originWidth:o,originHeight:a,min:720})));}},{key:"sendable",value:function value(){return 0!==this.content.imageInfoArray.length&&""!==this.content.imageInfoArray[0].imageUrl&&0!==this.content.imageInfoArray[0].size;}}]),e;}(),Ra=function(){function e(t){o(this,e),this.type=S.MSG_FACE,this.content=t||null;}return a(e,[{key:"sendable",value:function value(){return null!==this.content;}}]),e;}(),Na=function(){function e(t,n){o(this,e),this.type=S.MSG_AUDIO,this._percent=0,this.content={downloadFlag:2,second:t.second,size:t.size,url:Wt(t.url,n),remoteAudioUrl:t.url||"",uuid:t.uuid};}return a(e,[{key:"updatePercent",value:function value(e){this._percent=e,this._percent>1&&(this._percent=1);}},{key:"updateAudioUrl",value:function value(e){this.content.remoteAudioUrl=e;}},{key:"sendable",value:function value(){return""!==this.content.remoteAudioUrl;}}]),e;}(),Oa={from:!0,groupID:!0,groupName:!0,to:!0},Ga=function(){function e(t){o(this,e),this.type=S.MSG_GRP_TIP,this.content={},this._initContent(t);}return a(e,[{key:"_initContent",value:function value(e){var t=this;Object.keys(e).forEach(function(n){switch(n){case"remarkInfo":break;case"groupProfile":t.content.groupProfile={},t._initGroupProfile(e[n]);break;case"operatorInfo":break;case"memberInfoList":case"msgMemberInfo":t._updateMemberList(e[n]);break;case"memberExtraInfo":case"onlineMemberInfo":break;case"memberNum":t.content[n]=e[n],t.content.memberCount=e[n];break;case"newGroupProfile":t.content.newGroupProfile={},t._initNewGroupProfile(e[n]);break;default:t.content[n]=e[n];}}),this.content.userIDList||(this.content.userIDList=[this.content.operatorID]);}},{key:"_initGroupProfile",value:function value(e){for(var t=Object.keys(e),n=0;n<t.length;n++){var o=t[n];Oa[o]&&(this.content.groupProfile[o]=e[o]);}}},{key:"_updateMemberList",value:function value(e){jt(this.content.memberList)?this.content.memberList=e:this.content.memberList.forEach(function(t){e.forEach(function(e){t.userID===e.userID&&Object.assign(t,e);});});}},{key:"_initNewGroupProfile",value:function value(e){for(var t=Object.keys(e),n=0;n<t.length;n++){var o=t[n];"muteAllMembers"!==o?this.content.newGroupProfile[o]=e[o]:this.content.newGroupProfile[o]=1===e[o];}}}]),e;}(),Ua={from:!0,groupID:!0,groupName:!0,to:!0},Pa=function(){function e(t){o(this,e),this.type=S.MSG_GRP_SYS_NOTICE,this.content={},this._initContent(t);}return a(e,[{key:"_initContent",value:function value(e){var t=this;Object.keys(e).forEach(function(n){switch(n){case"memberInfoList":break;case"remarkInfo":t.content.handleMessage=e[n];break;case"groupProfile":t.content.groupProfile={},t._initGroupProfile(e[n]);break;default:t.content[n]=e[n];}});}},{key:"_initGroupProfile",value:function value(e){for(var t=Object.keys(e),n=0;n<t.length;n++){var o=t[n];Ua[o]&&("groupName"===o?this.content.groupProfile.name=e[o]:this.content.groupProfile[o]=e[o]);}}}]),e;}(),ba=function(){function e(t,n){o(this,e),this.type=S.MSG_FILE,this._percent=0;var s=this._getFileInfo(t);this.content={downloadFlag:2,fileUrl:Wt(t.url,n)||"",uuid:t.uuid,fileName:s.name||"",fileSize:s.size||0};}return a(e,[{key:"_getFileInfo",value:function value(e){if(!at(e.fileName)&&!at(e.fileSize))return{size:e.fileSize,name:e.fileName};var t=e.file.files[0];if(ne){if(t.path&&-1!==t.path.indexOf(".")){var n=t.path.slice(t.path.lastIndexOf(".")+1).toLowerCase();t.type=n,t.name||(t.name="".concat(_t(999999),".").concat(n));}t.name||(t.type="",t.name=t.path.slice(t.path.lastIndexOf("/")+1).toLowerCase()),t.suffix&&(t.type=t.suffix),t.url||(t.url=t.path);}return{size:t.size,name:t.name};}},{key:"updatePercent",value:function value(e){this._percent=e,this._percent>1&&(this._percent=1);}},{key:"updateFileUrl",value:function value(e){this.content.fileUrl=e;}},{key:"sendable",value:function value(){return""!==this.content.fileUrl&&""!==this.content.fileName&&0!==this.content.fileSize;}}]),e;}(),wa=function(){function e(t){o(this,e),this.type=S.MSG_CUSTOM,this.content={data:t.data||"",description:t.description||"",extension:t.extension||""};}return a(e,[{key:"setData",value:function value(e){return this.content.data=e,this;}},{key:"setDescription",value:function value(e){return this.content.description=e,this;}},{key:"setExtension",value:function value(e){return this.content.extension=e,this;}},{key:"sendable",value:function value(){return 0!==this.content.data.length||0!==this.content.description.length||0!==this.content.extension.length;}}]),e;}(),Fa=function(){function e(t,n){o(this,e),this.type=S.MSG_VIDEO,this._percent=0,this.content={remoteVideoUrl:t.remoteVideoUrl||t.videoUrl||"",videoFormat:t.videoFormat,videoSecond:parseInt(t.videoSecond,10),videoSize:t.videoSize,videoUrl:Wt(t.videoUrl,n),videoDownloadFlag:2,videoUUID:t.videoUUID,thumbUUID:t.thumbUUID,thumbFormat:t.thumbFormat,thumbWidth:t.thumbWidth,snapshotWidth:t.thumbWidth,thumbHeight:t.thumbHeight,snapshotHeight:t.thumbHeight,thumbSize:t.thumbSize,snapshotSize:t.thumbSize,thumbDownloadFlag:2,thumbUrl:Wt(t.thumbUrl,n),snapshotUrl:Wt(t.thumbUrl,n)};}return a(e,[{key:"updatePercent",value:function value(e){this._percent=e,this._percent>1&&(this._percent=1);}},{key:"updateVideoUrl",value:function value(e){e&&(this.content.remoteVideoUrl=e);}},{key:"updateSnapshotInfo",value:function value(e){var t=e.snapshotUrl,n=e.snapshotWidth,o=e.snapshotHeight;jt(t)||(this.content.thumbUrl=this.content.snapshotUrl=t),jt(n)||(this.content.thumbWidth=this.content.snapshotWidth=Number(n)),jt(o)||(this.content.thumbHeight=this.content.snapshotHeight=Number(o));}},{key:"sendable",value:function value(){return""!==this.content.remoteVideoUrl;}}]),e;}(),qa=function(){function e(t){o(this,e),this.type=S.MSG_LOCATION;var n=t.description,s=t.longitude,a=t.latitude;this.content={description:n,longitude:s,latitude:a};}return a(e,[{key:"sendable",value:function value(){return!0;}}]),e;}(),xa=function(){function e(t,n){if(o(this,e),this.from=t.from,this.messageSender=t.from,this.time=t.time,this.messageSequence=t.sequence,this.clientSequence=t.clientSequence||t.sequence,this.messageRandom=t.random,this.cloudCustomData=t.cloudCustomData||"",this.clientTime=t.clientTime||void 0,t.ID)this.ID=t.ID||"",this.nick=t.nick||"",this.avatar=t.avatar||"",this.messageBody=[{type:t.type,payload:t.payload}],t.conversationType.startsWith(S.CONV_C2C)?this.receiverUserID=t.to:t.conversationType.startsWith(S.CONV_GROUP)&&(this.receiverGroupID=t.to),this.messageReceiver=t.to;else{this.nick=t.nick||"",this.avatar=t.avatar||"",this.messageBody=[];var s=t.elements[0].type,a=t.elements[0].content;this._patchRichMediaPayload(s,a),this._updateRichMediaDownloadUrl(s,a,n),s===S.MSG_MERGER?this.messageBody.push({type:s,payload:new Va(a).content}):this.messageBody.push({type:s,payload:a}),t.groupID&&(this.receiverGroupID=t.groupID,this.messageReceiver=t.groupID),t.to&&(this.receiverUserID=t.to,this.messageReceiver=t.to),this.ID="".concat(t.tinyID,"-").concat(t.clientTime,"-").concat(t.random);}}return a(e,[{key:"_patchRichMediaPayload",value:function value(e,t){e===S.MSG_IMAGE?t.imageInfoArray.forEach(function(e){!e.imageUrl&&e.url&&(e.imageUrl=e.url,e.sizeType=e.type,1===e.type?e.type=0:3===e.type&&(e.type=1));}):e===S.MSG_VIDEO?!t.remoteVideoUrl&&t.videoUrl&&(t.remoteVideoUrl=t.videoUrl):e===S.MSG_AUDIO?!t.remoteAudioUrl&&t.url&&(t.remoteAudioUrl=t.url):e===S.MSG_FILE&&!t.fileUrl&&t.url&&(t.fileUrl=t.url,t.url=void 0);}},{key:"_updateRichMediaDownloadUrl",value:function value(e,t,n){n&&(e===S.MSG_IMAGE?t.imageInfoArray.forEach(function(e){e.url=Wt(e.url,n);}):e===S.MSG_VIDEO?(t.videoUrl=Wt(t.videoUrl,n),t.snapshotUrl=Wt(t.thumbUrl,n),t.snapshotHeight=t.thumbHeight,t.snapshotWidth=t.thumbWidth):e===S.MSG_AUDIO?t.url=Wt(t.url,n):e===S.MSG_FILE&&(t.fileUrl=Wt(t.fileUrl,n)));}}]),e;}(),Va=function(){function e(t,n){if(o(this,e),this.type=S.MSG_MERGER,this.content={downloadKey:"",pbDownloadKey:"",messageList:[],title:"",abstractList:[],compatibleText:"",version:0,layersOverLimit:!1},t.downloadKey){var s=t.downloadKey,a=t.pbDownloadKey,r=t.title,i=t.abstractList,u=t.compatibleText,c=t.version;this.content.downloadKey=s,this.content.pbDownloadKey=a,this.content.title=r,this.content.abstractList=i,this.content.compatibleText=u,this.content.version=c||0;}else if(jt(t.messageList))1===t.layersOverLimit&&(this.content.layersOverLimit=!0);else{var l=t.messageList,p=t.title,d=t.abstractList,g=t.compatibleText,_=t.version,h=[];l.forEach(function(e){if(!jt(e)){var t=new xa(e,n);h.push(t);}}),this.content.messageList=h,this.content.title=p,this.content.abstractList=d,this.content.compatibleText=g,this.content.version=_||0;}}return a(e,[{key:"sendable",value:function value(){return!jt(this.content.messageList)||!jt(this.content.downloadKey);}}]),e;}(),Ba={1:S.MSG_PRIORITY_HIGH,2:S.MSG_PRIORITY_NORMAL,3:S.MSG_PRIORITY_LOW,4:S.MSG_PRIORITY_LOWEST},Ha=function(){function e(t){o(this,e),this.ID="",this.conversationID=t.conversationID||null,this.conversationType=t.conversationType||S.CONV_C2C,this.conversationSubType=t.conversationSubType,this.time=t.time||Math.ceil(Date.now()/1e3),this.sequence=t.sequence||0,this.clientSequence=t.clientSequence||t.sequence||0,this.random=t.random||0===t.random?t.random:_t(),this.priority=this._computePriority(t.priority),this.nick=t.nick||"",this.avatar=t.avatar||"",this.isPeerRead=!1,this.nameCard="",this._elements=[],this.isPlaceMessage=t.isPlaceMessage||0,this.isRevoked=2===t.isPlaceMessage||8===t.msgFlagBits,this.from=t.from||null,this.to=t.to||null,this.flow="",this.isSystemMessage=t.isSystemMessage||!1,this.protocol=t.protocol||"JSON",this.isResend=!1,this.isRead=!1,this.status=t.status||Qt.SUCCESS,this._onlineOnlyFlag=!1,this._groupAtInfoList=[],this._relayFlag=!1,this.atUserList=[],this.cloudCustomData=t.cloudCustomData||"",this.isDeleted=!1,this.isModified=!1,this._isExcludedFromUnreadCount=!(!t.messageControlInfo||1!==t.messageControlInfo.excludedFromUnreadCount),this._isExcludedFromLastMessage=!(!t.messageControlInfo||1!==t.messageControlInfo.excludedFromLastMessage),this.clientTime=t.clientTime||be()||0,this.senderTinyID=t.senderTinyID||t.tinyID||"",this.readReceiptInfo=t.readReceiptInfo||{readCount:void 0,unreadCount:void 0,isPeerRead:void 0},this.needReadReceipt=!0===t.needReadReceipt||1===t.needReadReceipt,this.version=t.messageVersion||0,this.isBroadcastMessage=t.isBroadcastMessage||!1,this._receiverList=t.receiverList||void 0,this.isSupportExtension=!0===t.isSupportExtension||1===t.isSupportExtension,this.revoker=t.revokerInfo&&t.revokerInfo.revoker||null,this.reInitialize(t.currentUser),this.extractGroupInfo(t.groupProfile||null),this.handleGroupAtInfo(t),this.initC2CReadReceiptInfo(t.readReceiptSentByPeer);}return a(e,[{key:"elements",get:function get(){return this._elements;}},{key:"getElements",value:function value(){return this._elements;}},{key:"extractGroupInfo",value:function value(e){if(null!==e){et(e.nick)&&(this.nick=e.nick),et(e.avatar)&&(this.avatar=e.avatar);var t=e.messageFromAccountExtraInformation;ot(t)&&et(t.nameCard)&&(this.nameCard=t.nameCard);}}},{key:"handleGroupAtInfo",value:function value(e){var t=this;e.payload&&e.payload.atUserList&&e.payload.atUserList.forEach(function(e){e!==S.MSG_AT_ALL?(t._groupAtInfoList.push({groupAtAllFlag:0,groupAtUserID:e}),t.atUserList.push(e)):(t._groupAtInfoList.push({groupAtAllFlag:1}),t.atUserList.push(S.MSG_AT_ALL));}),st(e.groupAtInfo)&&e.groupAtInfo.forEach(function(e){0===e.groupAtAllFlag?t.atUserList.push(e.groupAtUserID):1===e.groupAtAllFlag&&t.atUserList.push(S.MSG_AT_ALL);});}},{key:"getGroupAtInfoList",value:function value(){return this._groupAtInfoList;}},{key:"_initProxy",value:function value(){this._elements[0]&&(this.payload=this._elements[0].content,this.type=this._elements[0].type);}},{key:"reInitialize",value:function value(e){e&&(this.status=this.from?Qt.SUCCESS:Qt.UNSEND,!this.from&&(this.from=e)),this._initFlow(e),this._initSequence(e),this._concatConversationID(e),this.generateMessageID();}},{key:"isSendable",value:function value(){return 0!==this._elements.length&&"function"==typeof this._elements[0].sendable&&this._elements[0].sendable();}},{key:"_initTo",value:function value(e){this.conversationType===S.CONV_GROUP&&(this.to=e.groupID);}},{key:"_initSequence",value:function value(e){0===this.clientSequence&&e&&(this.clientSequence=function(e){if(!e)return!1;if(void 0===mt[e]){var t=new Date(),n="3".concat(t.getHours()).slice(-2),o="0".concat(t.getMinutes()).slice(-2),s="0".concat(t.getSeconds()).slice(-2);mt[e]=parseInt([n,o,s,"0001"].join("")),n=null,o=null,s=null,xe.l("autoIncrementIndex start index:".concat(mt[e]));}return mt[e]++;}(e)),0===this.sequence&&this.conversationType===S.CONV_C2C&&(this.sequence=this.clientSequence);}},{key:"generateMessageID",value:function value(){this.from===S.CONV_SYSTEM&&(this.senderTinyID="144115198244471703"),this.ID="".concat(this.senderTinyID,"-").concat(this.clientTime,"-").concat(this.random);}},{key:"_initFlow",value:function value(e){""!==e&&(e===this.from?(this.flow="out",this.isRead=!0):this.flow="in");}},{key:"_concatConversationID",value:function value(e){var t=this.to,n="",o=this.conversationType;o!==S.CONV_SYSTEM?(n=o===S.CONV_C2C?e===this.from?t:this.from:this.to,this.conversationID=n?"".concat(o).concat(n):null):this.conversationID=S.CONV_SYSTEM;}},{key:"isElement",value:function value(e){return e instanceof La||e instanceof Aa||e instanceof Ra||e instanceof Na||e instanceof ba||e instanceof Fa||e instanceof Ga||e instanceof Pa||e instanceof wa||e instanceof qa||e instanceof Va;}},{key:"setElement",value:function value(e,t){var n=this;if(this.isElement(e))return this._elements=[e],void this._initProxy();var o=function o(e){if(e.type&&e.content)switch(e.type){case S.MSG_TEXT:n.setTextElement(e.content);break;case S.MSG_IMAGE:n.setImageElement(e.content,t);break;case S.MSG_AUDIO:n.setAudioElement(e.content,t);break;case S.MSG_FILE:n.setFileElement(e.content,t);break;case S.MSG_VIDEO:n.setVideoElement(e.content,t);break;case S.MSG_CUSTOM:n.setCustomElement(e.content);break;case S.MSG_LOCATION:n.setLocationElement(e.content);break;case S.MSG_GRP_TIP:n.setGroupTipElement(e.content);break;case S.MSG_GRP_SYS_NOTICE:n.setGroupSystemNoticeElement(e.content);break;case S.MSG_FACE:n.setFaceElement(e.content);break;case S.MSG_MERGER:n.setMergerElement(e.content,t);}};if(st(e))for(var s=0;s<e.length;s++){o(e[s]);}else o(e);this._initProxy();}},{key:"clearElement",value:function value(){this._elements.length=0;}},{key:"setTextElement",value:function value(e){var t="string"==typeof e?e:e.text,n=new La({text:t});this._elements.push(n);}},{key:"setImageElement",value:function value(e,t){var n=new Aa(e,t);this._elements.push(n);}},{key:"setAudioElement",value:function value(e,t){var n=new Na(e,t);this._elements.push(n);}},{key:"setFileElement",value:function value(e,t){var n=new ba(e,t);this._elements.push(n);}},{key:"setVideoElement",value:function value(e,t){var n=new Fa(e,t);this._elements.push(n);}},{key:"setLocationElement",value:function value(e){var t=new qa(e);this._elements.push(t);}},{key:"setCustomElement",value:function value(e){var t=new wa(e);this._elements.push(t);}},{key:"setGroupTipElement",value:function value(e){var t={},n=e.operationType;if(jt(e.memberInfoList)?e.operatorInfo&&(t=e.operatorInfo):n!==S.GRP_TIP_MBR_JOIN&&n!==S.GRP_TIP_MBR_KICKED_OUT&&n!==S.GRP_TIP_MBR_SET_ADMIN&&n!==S.GRP_TIP_MBR_CANCELED_ADMIN||(t=e.memberInfoList[0]),!jt(e.memberExtraInfo)){var o=e.memberExtraInfo.reason;e.msgMemberInfo.forEach(function(e){e.reason=o;});}var s=t,a=s.nick,r=s.avatar;et(a)&&(this.nick=a),et(r)&&(this.avatar=r);var i=new Ga(e);this._elements.push(i);}},{key:"setGroupSystemNoticeElement",value:function value(e){var t=new Pa(e);this._elements.push(t);}},{key:"setFaceElement",value:function value(e){var t=new Ra(e);this._elements.push(t);}},{key:"setMergerElement",value:function value(e,t){var n=new Va(e,t);this._elements.push(n);}},{key:"setIsRead",value:function value(e){this.isRead=e;}},{key:"setRelayFlag",value:function value(e){this._relayFlag=e;}},{key:"getRelayFlag",value:function value(){return this._relayFlag;}},{key:"_computePriority",value:function value(e){if(at(e))return S.MSG_PRIORITY_NORMAL;if(et(e)&&-1!==Object.values(Ba).indexOf(e))return e;if($e(e)){var t=""+e;if(-1!==Object.keys(Ba).indexOf(t))return Ba[t];}return S.MSG_PRIORITY_NORMAL;}},{key:"setNickAndAvatar",value:function value(e){var t=e.nick,n=e.avatar;et(t)&&(this.nick=t),et(n)&&(this.avatar=n);}},{key:"setNameCard",value:function value(e){et(e)&&(this.nameCard=e);}},{key:"initC2CReadReceiptInfo",value:function value(e){this.conversationType===S.CONV_C2C&&!0===this.needReadReceipt&&(this.readReceiptInfo.isPeerRead=1===e);}}]),e;}(),Ka=function Ka(e){return{code:0,data:e||{}};},Wa=function(e){i(n,e);var t=f(n);function n(e){var s;o(this,n),s=t.call(this);var a=e.code,r=e.message,i=e.data;return s.code=a,s.message=r||s._getErrorMessage(s.code),s.data=i||{},s;}return a(n);}(d(Error)),Ya=null,ja=function ja(e){Ya=e;},za=function za(e){return Promise.resolve(Ka(e));},Ja=function Ja(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(e instanceof Wa)return t&&null!==Ya&&Ya.emit(E.ERROR,e),Promise.reject(e);if(e instanceof Error){var n=new Wa({code:da.UNCAUGHT_ERROR});return t&&null!==Ya&&Ya.emit(E.ERROR,n),Promise.reject(n);}if(!at(e)&&!at(e.code)){var o=new Wa(e);return t&&null!==Ya&&Ya.emit(E.ERROR,o),Promise.reject(o);}},Xa=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="C2CModule",t._messageFromUnreadDBMap=new Map(),t._signalingFromUnreadDBList=[],t;}return a(s,[{key:"onNewC2CMessage",value:function value(e){var t=e.dataList,n=e.isInstantMessage,o=e.C2CRemainingUnreadList,s=e.C2CPairUnreadList;xe.d("".concat(this._n,".onNewC2CMessage count:").concat(t.length," isInstantMessage:").concat(n));var a=this._newC2CMessageStoredAndSummary({dataList:t,C2CRemainingUnreadList:o,C2CPairUnreadList:s,isInstantMessage:n}),r=a.conversationOptionsList,i=a.messageList,u=a.isUnreadC2CMessage;(this.filterModifiedMessage(i),r.length>0)&&this.getModule(Fn).onNewMessage({conversationOptionsList:r,isInstantMessage:n,isUnreadC2CMessage:u});var c=this.filterUnmodifiedMessage(i);n&&c.length>0&&this.emitOuterEvent(E.MESSAGE_RECEIVED,c),i.length=0;}},{key:"_newC2CMessageStoredAndSummary",value:function value(e){for(var t=e.dataList,n=e.C2CRemainingUnreadList,o=e.C2CPairUnreadList,s=e.isInstantMessage,a=null,r=[],i=[],u={},c=this.getModule(Hn),l=this.getModule($n),p=!1,d=this.getModule(Fn),g=this.getFileDownloadProxy(),_=0,h=t.length;_<h;_++){if(this._isSignaling(t[_]))this._signalingFromUnreadDBList.push(t[_].eventArray[0].c2CNotifyMsgArray[0]);else{var f=t[_];f.currentUser=this.getMyUserID(),f.conversationType=S.CONV_C2C,f.isSystemMessage=!!f.isSystemMessage,(at(f.nick)||at(f.avatar))&&(p=!0,xe.d("".concat(this._n,"._newC2CMessageStoredAndSummary nick or avatar missing!"))),a=new Ha(f),f.elements=c.parseElements(f.elements,f.from),a.setElement(f.elements,g),a.setNickAndAvatar({nick:f.nick,avatar:f.avatar});var v=a.conversationID;if(s){if(1===this._messageFromUnreadDBMap.get(a.ID))continue;var m=!1;if(a.from!==this.getMyUserID()){var M=d.getLatestMessageSentByPeer(v);if(M){var y=M.nick,I=M.avatar;p?a.setNickAndAvatar({nick:y,avatar:I}):y===a.nick&&I===a.avatar||(m=!0);}}else{var C=d.getLatestMessageSentByMe(v);if(C){var T=C.nick,D=C.avatar;T===a.nick&&D===a.avatar||d.modifyMessageSentByMe({conversationID:v,latestNick:a.nick,latestAvatar:a.avatar});}}var E=1===t[_].isModified;if(d.isMessageSentByCurrentInstance(a)?a.isModified=E:E=!1,0===f.msgLifeTime)a._onlineOnlyFlag=!0,d.isMessageSentByCurrentInstance(a)||i.push(a);else{if(!d.pushIntoMessageList(i,a,E))continue;m&&(d.modifyMessageSentByPeer({conversationID:v,latestNick:a.nick,latestAvatar:a.avatar}),d.updateUserProfileSpecifiedKey({conversationID:v,nick:a.nick,avatar:a.avatar}));}s&&a.clientTime>0&&l.addMessageDelay(a.clientTime);}else this._messageFromUnreadDBMap.set(a.ID,1);if(0!==f.msgLifeTime){if(!1===a._onlineOnlyFlag){var k=d.getLastMessageTime(v);if($e(k)&&a.time<k)continue;if(at(u[v])){var L=0;"in"===a.flow&&(a._isExcludedFromUnreadCount||(L=1)),u[v]=r.push({conversationID:v,unreadCount:L,type:a.conversationType,subType:a.conversationSubType,lastMessage:a._isExcludedFromLastMessage?"":a})-1;}else{var A=u[v];r[A].type=a.conversationType,r[A].subType=a.conversationSubType,r[A].lastMessage=a._isExcludedFromLastMessage?"":a,"in"===a.flow&&(a._isExcludedFromUnreadCount||r[A].unreadCount++);}}}else a._onlineOnlyFlag=!0;}}this._handleSignalingFromUnreadDB();var R=!1;if(st(o))for(var N=function N(e,t){if(o[e].unreadCount>0){R=!0;var n=r.find(function(t){return t.conversationID==="C2C".concat(o[e].from);});n?n.unreadCount=o[e].unreadCount:r.push({conversationID:"C2C".concat(o[e].from),unreadCount:o[e].unreadCount,type:S.CONV_C2C});}},O=0,G=o.length;O<G;O++){N(O);}if(st(n))for(var U=function U(e,t){r.find(function(t){return t.conversationID==="C2C".concat(n[e].from);})||r.push({conversationID:"C2C".concat(n[e].from),type:S.CONV_C2C,lastMsgTime:n[e].lastMsgTime});},P=0,b=n.length;P<b;P++){U(P);}return{conversationOptionsList:r,messageList:i,isUnreadC2CMessage:R};}},{key:"_isSignaling",value:function value(e){var t=e.eventArray;return!(!st(t)||10!==t[0].event);}},{key:"_handleSignalingFromUnreadDB",value:function value(){var e=this._signalingFromUnreadDBList.length;if(xe.l("".concat(this._n,"._handleSignalingFromUnreadDB signalingCount:").concat(e)),0!==e){var t=[];this._signalingFromUnreadDBList.forEach(function(e){e.hasOwnProperty("c2cMessageRevokedNotify")&&t.push(e);}),this.onC2CMessageRevoked({dataList:t}),this._signalingFromUnreadDBList.length=0,t.length=0;}}},{key:"onC2CMessageRevoked",value:function value(e){var t=this,n=this.getModule(Fn),o=[],s=null,a=!0;e.dataList.forEach(function(e){if(e.c2cMessageRevokedNotify){var r=e.c2cMessageRevokedNotify.revokedInfos;at(r)||r.forEach(function(e){var r=t.getMyUserID()===e.from?"".concat(S.CONV_C2C).concat(e.to):"".concat(S.CONV_C2C).concat(e.from);s=n.revoke(r,e.sequence,e.random);var i=e.revokerInfo&&e.revokerInfo.revoker;if(s)s.revoker||(s.revoker=i,o.push(s));else{var u={conversationID:r,sequence:e.sequence,time:e.time,revoker:i};n.isLastMessageRevoked(u)&&(o.push(u),a=!1);}});}}),0!==o.length&&(n.onMessageRevoked(o),!0===a&&(xe.l("".concat(this._n,".onC2CMessageRevoked count:").concat(o.length)),this.emitOuterEvent(E.MESSAGE_REVOKED,o)));}},{key:"onC2CMessageReadReceipt",value:function value(e){var t=this;e.dataList.forEach(function(e){if(!jt(e.c2cMessageReadReceipt)){var n=e.c2cMessageReadReceipt.to;e.c2cMessageReadReceipt.uinPairReadArray.forEach(function(e){var o=e.peerReadTime;xe.d("".concat(t._n,"._onC2CMessageReadReceipt to:").concat(n," peerReadTime:").concat(o));var s="".concat(S.CONV_C2C).concat(n),a=t.getModule(Fn);a.recordPeerReadTime(s,o),a.updateMessageIsPeerReadProperty(s,o);});}});}},{key:"onC2CMessageReadNotice",value:function value(e){var t=this;e.dataList.forEach(function(e){if(!jt(e.c2cMessageReadNotice)){var n=t.getModule(Fn);e.c2cMessageReadNotice.uinPairReadArray.forEach(function(e){var o=e.from,s=e.peerReadTime;xe.d("".concat(t._n,".onC2CMessageReadNotice from:").concat(o," lastReadTime:").concat(s));var a="".concat(S.CONV_C2C).concat(o);n.updateIsReadAfterReadReport({conversationID:a,lastMessageTime:s}),n.updateUnreadCount(a);});}});}},{key:"onC2CMessageModified",value:function value(e){xe.d("".concat(this._n,".onC2CMessageModified options:"),JSON.stringify(e));var n=this.getModule(Fn);e.dataList.forEach(function(e){n.onMessageModified(t(t({},e),{},{conversationType:S.CONV_C2C}));});}},{key:"onReadReceiptList",value:function value(e){xe.d("".concat(this._n,".onReadReceiptList options:"),JSON.stringify(e));var t=e.dataList,n=t.userID,o=t.readReceiptList;this.getModule(Fn).updateReadReceiptInfo({userID:n,readReceiptList:o});}},{key:"sendMessage",value:function value(e,t){var n=this._createC2CMessagePack(e,t);return this.request(n);}},{key:"_createC2CMessagePack",value:function value(e,t){var n=null;t&&(t.offlinePushInfo&&(n=t.offlinePushInfo),!0===t.onlineUserOnly&&(n?n.disablePush=!0:n={disablePush:!0}));var o="";et(e.cloudCustomData)&&e.cloudCustomData.length>0&&(o=e.cloudCustomData);var s=[];if(ot(t)&&ot(t.messageControlInfo)){var a=t.messageControlInfo,r=a.excludedFromUnreadCount,i=a.excludedFromLastMessage,u=a.excludedFromContentModeration;!0===r&&s.push("NoUnread"),!0===i&&s.push("NoLastMsg"),!0===u&&s.push("NoMsgCheck");}var c=this.isOnlineMessage(e,t)?0:void 0;return{protocolName:_o,tjgID:this.generateTjgID(e),requestData:{fromAccount:this.getMyUserID(),toAccount:e.to,msgBody:e.getElements(),cloudCustomData:o,msgSeq:e.sequence,msgRandom:e.random,msgLifeTime:c,nick:e.nick,avatar:e.avatar,offlinePushInfo:n?{pushFlag:!0===n.disablePush?1:0,title:n.title||"",desc:n.description||"",ext:n.extension||"",apnsInfo:{badgeMode:!0===n.ignoreIOSBadge?1:0,isVoipPush:this._isVoipPush(n)},androidInfo:{OPPOChannelID:n.androidOPPOChannelID||""}}:void 0,messageControlInfo:0!==c?s:void 0,clientTime:e.clientTime,needReadReceipt:!0===e.needReadReceipt?1:0,isSupportExtension:!0===e.isSupportExtension?1:0}};}},{key:"_isVoipPush",value:function value(e){var t=void 0;return at(e.disableVoipPush)||(t=!1===e.disableVoipPush?1:0),t;}},{key:"isOnlineMessage",value:function value(e,t){return!(!t||!0!==t.onlineUserOnly);}},{key:"revokeMessage",value:function value(e){return this.request({protocolName:Io,requestData:{msgInfo:{fromAccount:e.from,toAccount:e.to,msgSeq:e.sequence,msgRandom:e.random,msgTimeStamp:e.time}}});}},{key:"deleteMessage",value:function value(e){var t=e.to,n=e.keyList;return xe.l("".concat(this._n,".deleteMessage toAccount:").concat(t," count:").concat(n.length)),this.request({protocolName:ko,requestData:{fromAccount:this.getMyUserID(),to:t,keyList:n}});}},{key:"modifyRemoteMessage",value:function value(e){var t=e.from,n=e.to,o=e.version,s=void 0===o?0:o,a=e.sequence,r=e.random,i=e.time,u=e.payload,c=e.type,l=e.cloudCustomData,p=void 0;return Vt(c)&&(p=[]).push({type:c,content:u}),this.request({protocolName:Lo,requestData:{from:t,to:n,version:s,sequence:a,random:r,time:i,elements:p,cloudCustomData:l}});}},{key:"setMessageRead",value:function value(e){var t=this,n=e.conversationID,o=e.lastMessageTime,s="".concat(this._n,".setMessageRead");xe.l("".concat(s," conversationID:").concat(n," lastMessageTime:").concat(o)),$e(o)||this.outputWarning("DoNotModifyLastTime");var a=new ka("setC2CMessageRead");return a.setMessage("conversationID:".concat(n," lastMessageTime:").concat(o)),this.request({protocolName:Co,requestData:{C2CMsgReaded:{cookie:"",C2CMsgReadedItem:[{toAccount:n.replace("C2C",""),lastMessageTime:o,receipt:1}]}}}).then(function(){a.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(s," ok"));var e=t.getModule(Fn);return e.updateIsReadAfterReadReport({conversationID:n,lastMessageTime:o}),e.updateUnreadCount(n),Ka();}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];a.setError(e,o,s).end();}),xe.l("".concat(s," failed. error:"),e),Ja(e);});}},{key:"getRoamingMessage",value:function value(e){var t=this,n="".concat(this._n,".getRoamingMessage"),o=e.peerAccount,s=e.conversationID,a=e.count,r=e.lastMessageTime,i=e.messageKey,u="peerAccount:".concat(o," count:").concat(a||15," lastMessageTime:").concat(r||0," messageKey:").concat(i);xe.l("".concat(n," ").concat(u));var c=new ka("getC2CRoamingMessages");return this.request({protocolName:Eo,requestData:{peerAccount:o,count:a||15,lastMessageTime:r||0,messageKey:i}}).then(function(e){var o=e.data,a=o.complete,r=o.messageList,i=o.messageKey,l=o.lastMessageTime;at(r)?xe.l("".concat(n," ok. complete:").concat(a," but messageList is undefined!")):xe.l("".concat(n," ok. complete:").concat(a," count:").concat(r.length)),c.setNetworkType(t.getNetworkType()).setMessage("".concat(u," complete:").concat(a," length:").concat(r.length)).end();var p=t.getModule(Fn);1===a&&p.setCompleted(s);var d=p.onRoamingMessage(r,s);p.modifyMessageList(s),p.updateIsRead(s),p.updateRoamingMessageKeyAndTime(s,i,l);var g=p.getPeerReadTime(s);if(xe.l("".concat(n," update isPeerRead property. conversationID:").concat(s," peerReadTime:").concat(g)),g)p.updateMessageIsPeerReadProperty(s,g);else{var _=s.replace(S.CONV_C2C,"");t.getRemotePeerReadTime([_]).then(function(){p.updateMessageIsPeerReadProperty(s,p.getPeerReadTime(s));});}var h="";if(d.length>0)h=d[0].ID;else{var f=p.getLocalOldestMessage(s);f&&(h=f.ID);}return xe.l("".concat(n," nextReqID:").concat(h," stored message count:").concat(d.length)),{nextReqID:h,storedMessageList:d};}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];c.setMessage(u).setError(e,o,s).end();}),xe.w("".concat(n," failed. error:"),e),Ja(e);});}},{key:"getRoamingMessagesHopping",value:function value(e){var t=this,n="".concat(this._n,".getRoamingMessagesHopping"),o=e.peerAccount,s=e.time,a=void 0===s?0:s,r=e.count,i=e.direction,u="".concat(S.CONV_C2C).concat(o),c="peerAccount:".concat(o," count:").concat(r," time:").concat(a," direction:").concat(i);xe.l("".concat(n," ").concat(c));var l=new ka("getC2CRoamingMessagesHopping");return this.request({protocolName:Eo,requestData:{peerAccount:o,count:r+1,lastMessageTime:a,direction:i}}).then(function(e){var o=e.data,s=o.complete,a=o.messageList,r=void 0===a?[]:a,p=o.lastMessageTime;xe.l("".concat(n," ok. complete:").concat(s," count:").concat(r.length)),l.setNetworkType(t.getNetworkType()).setMessage("".concat(c," complete:").concat(s," length:").concat(r.length)).end(),1!==s&&(1===i?r.pop():r.shift());var d=t.getModule(Fn).onRoamingMessage(r,u,!1);t._modifyMessageList(u,d);var g=t._computeResult({complete:s,lastMessageTime:p,resultList:d});return Ka(g);}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];l.setMessage(c).setError(e,o,s).end();}),xe.w("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_computeResult",value:function value(e){var t=e.complete,n=void 0===t?0:t,o=e.lastMessageTime,s=e.resultList,a={messageList:m(void 0===s?[]:s),isCompleted:!1,nextMessageTime:""};return 1===n?(a.isCompleted=!0,a):(a.nextMessageTime=o,a);}},{key:"_modifyMessageList",value:function value(e,t){var n=this.getModule(Fn).getLocalConversation(e);if(n)for(var o=n.userProfile.nick,s=n.userProfile.avatar,a=this.getModule(On).getNickAndAvatarByUserID(this.getMyUserID()),r=a.nick,i=a.avatar,u=t.length-1;u>=0;u--){var c=t[u];"in"===c.flow&&(c.nick!==o&&c.setNickAndAvatar({nick:o}),c.avatar!==s&&c.setNickAndAvatar({avatar:s})),"out"===c.flow&&(c.nick!==r&&c.setNickAndAvatar({nick:r}),c.avatar!==i&&c.setNickAndAvatar({avatar:i}));}}},{key:"getRemotePeerReadTime",value:function value(e){var t=this,n="".concat(this._n,".getRemotePeerReadTime");if(jt(e))return xe.w("".concat(n," userIDList is empty!")),Promise.resolve();var o=new ka("getPeerReadTime");return xe.l("".concat(n," userIDList:").concat(e)),this.request({protocolName:So,requestData:{userIDList:e}}).then(function(s){var a=s.data.peerReadTimeList;xe.l("".concat(n," ok. peerReadTimeList:").concat(a));for(var r="",i=t.getModule(Fn),u=0;u<e.length;u++){r+="".concat(e[u],"-").concat(a[u]," "),a[u]>0&&i.recordPeerReadTime("C2C".concat(e[u]),a[u]);}o.setNetworkType(t.getNetworkType()).setMessage(r).end();}).catch(function(e){t.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.w("".concat(n," failed. error:"),e);});}},{key:"sendReadReceipt",value:function value(e){var t=this,n=e[0].conversationID.replace(S.CONV_C2C,""),o=new ka("sendC2CReadReceipt");o.setMessage("peerAccount:".concat(n));var s=this.getMyUserID(),a=e.filter(function(e){return e.from!==s&&!0===e.needReadReceipt;}).map(function(e){return{fromAccount:e.from,toAccount:e.to,sequence:e.sequence,random:e.random,time:e.time,clientTime:e.clientTime};});if(0===a.length)return Ja({code:da.READ_RECEIPT_MESSAGE_LIST_EMPTY});var r="".concat(this._n,".sendReadReceipt");return xe.l("".concat(r,". peerAccount:").concat(n," messageInfoList length:").concat(a.length)),this.request({protocolName:ls,requestData:{peerAccount:n,messageInfoList:a}}).then(function(e){return o.end(),xe.l("".concat(r," ok")),Ka();}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.w("".concat(r," failed. error:"),e),Ja(e);});}},{key:"getReadReceiptList",value:function value(e){var t="".concat(this._n,".getReadReceiptList"),n=this.getMyUserID(),o=e.filter(function(e){return e.from===n&&!0===e.needReadReceipt;});return xe.l("".concat(t," userID:").concat(n," messageList length:").concat(o.length)),za({messageList:o});}},{key:"getMessageExtensions",value:function value(e,t){return xe.l("".concat(this._n,".getMessageExtensions startSequence:").concat(t)),this.request({protocolName:Ro,requestData:{from:e.from,to:e.to,messageKey:this._getMessageKey(e),startSequence:t}});}},{key:"modifyMessageExtensions",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;return xe.l("".concat(this._n,".modifyMessageExtensions operateType:").concat(n)),this.request({protocolName:Ao,requestData:{from:e.from,to:e.to,messageKey:this._getMessageKey(e),extensionList:t,operateType:n}});}},{key:"_getMessageKey",value:function value(e){var t=e.clientSequence,n=e.random,o=e.time;return"".concat(t,"_").concat(n,"_").concat(o);}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._messageFromUnreadDBMap.clear(),this._signalingFromUnreadDBList.length=0;}}]),s;}(ro),Qa=function(){function e(){o(this,e),this.list=new Map(),this._n="MessageListHandler",this._latestMessageSentByPeerMap=new Map(),this._latestMessageSentByMeMap=new Map();}return a(e,[{key:"getLocalOldestMessageByConversationID",value:function value(e){if(!e)return null;if(!this.list.has(e))return null;var t=this.list.get(e).values();return t?t.next().value:null;}},{key:"pushIn",value:function value(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=e.conversationID,o=!0;this.list.has(n)||this.list.set(n,new Map());var s=this._getUniqueIDOfMessage(e),a=this.list.get(n).has(s);if(a){var r=this.list.get(n).get(s);if(!t||!0===r.isModified)return o=!1;}return this.list.get(n).set(s,e),this._setLatestMessageSentByPeer(n,e),this._setLatestMessageSentByMe(n,e),o;}},{key:"unshift",value:function value(e,t){var n;if(st(e)?e.length>0&&(n=e[0].conversationID,this._unshiftMultipleMessages(e,t)):(n=e.conversationID,this._unshiftSingleMessage(e,t)),n&&n.startsWith(S.CONV_C2C)){var o=Array.from(this.list.get(n).values()),s=o.length;if(0===s)return;for(var a=s-1;a>=0;a--){if("out"===o[a].flow){this._setLatestMessageSentByMe(n,o[a]);break;}}for(var r=s-1;r>=0;r--){if("in"===o[r].flow){this._setLatestMessageSentByPeer(n,o[r]);break;}}}}},{key:"_unshiftSingleMessage",value:function value(e,t){var n=e.conversationID,o=this._getUniqueIDOfMessage(e);if(!this.list.has(n))return this.list.set(n,new Map()),this.list.get(n).set(o,e),void t.push(e);var s=this.list.get(n),a=Array.from(s);s.has(o)||(a.unshift([o,e]),this.list.set(n,new Map(a)),t.push(e));}},{key:"_unshiftMultipleMessages",value:function value(e,t){for(var n=e.length,o=[],s=e[0].conversationID,a=this.list.get(s),r=this.list.has(s)?Array.from(a):[],i=0;i<n;i++){var u=this._getUniqueIDOfMessage(e[i]);a&&a.has(u)||(o.push([u,e[i]]),t.push(e[i]));}this.list.set(s,new Map(o.concat(r)));}},{key:"remove",value:function value(e){var t=e.conversationID,n=this._getUniqueIDOfMessage(e);this.list.has(t)&&this.list.get(t).delete(n);}},{key:"revoke",value:function value(e,t,n){if(xe.d("revoke message",e,t,n),this.list.has(e)){var o,s=D(this.list.get(e));try{for(s.s();!(o=s.n()).done;){var a=v(o.value,2)[1];if(a.sequence===t&&(at(n)||a.random===n))return a.isRevoked||(a.isRevoked=!0),a;}}catch(r){s.e(r);}finally{s.f();}}return null;}},{key:"removeByConversationID",value:function value(e){this.list.has(e)&&(this.list.delete(e),this._latestMessageSentByPeerMap.delete(e),this._latestMessageSentByMeMap.delete(e));}},{key:"findMessage",value:function value(e){var t,n=null,o=D(this.list);try{for(o.s();!(t=o.n()).done;){for(var s=m(v(t.value,2)[1].values()),a=s.length,r=0;r<a;r++){if(s[r].ID===e){n=s[r];break;}}}}catch(i){o.e(i);}finally{o.f();}return n;}},{key:"updateMessageIsPeerReadProperty",value:function value(e,t){var n=[];if(this.list.has(e)){var o,s=D(this.list.get(e));try{for(s.s();!(o=s.n()).done;){var a=v(o.value,2)[1];a.time<=t&&!a.isPeerRead&&"out"===a.flow&&(a.isPeerRead=!0,n.push(a));}}catch(r){s.e(r);}finally{s.f();}xe.l("".concat(this._n,".updateMessageIsPeerReadProperty conversationID:").concat(e," peerReadTime:").concat(t," count:").concat(n.length));}return n;}},{key:"updateMessageIsModifiedProperty",value:function value(e){var t=e.conversationID;if(this.list.has(t)){var n=this._getUniqueIDOfMessage(e),o=this.list.get(t).get(n);o&&(o.isModified=!0);}}},{key:"hasLocalMessageList",value:function value(e){return this.list.has(e);}},{key:"getLocalMessageList",value:function value(e){return this.hasLocalMessageList(e)?m(this.list.get(e).values()):[];}},{key:"hasLocalMessage",value:function value(e,t){for(var n=!1,o=this.getLocalMessageList(e),s=o.length,a=0;a<s;a++){o[a].ID===t&&(n=!0);}return n;}},{key:"getLocalMessage",value:function value(e,t){for(var n=null,o=this.getLocalMessageList(e),s=o.length,a=0;a<s;a++){if(o[a].ID===t){n=o[a];break;}}return n;}},{key:"getLocalLastMessage",value:function value(e){var t=this.getLocalMessageList(e);return t[t.length-1];}},{key:"getLocalOldestMessage",value:function value(e){return this.getLocalMessageList(e)[0];}},{key:"_setLatestMessageSentByPeer",value:function value(e,t){e.startsWith(S.CONV_C2C)&&"in"===t.flow&&this._latestMessageSentByPeerMap.set(e,t);}},{key:"_setLatestMessageSentByMe",value:function value(e,t){e.startsWith(S.CONV_C2C)&&"out"===t.flow&&this._latestMessageSentByMeMap.set(e,t);}},{key:"getLatestMessageSentByPeer",value:function value(e){return this._latestMessageSentByPeerMap.get(e);}},{key:"getLatestMessageSentByMe",value:function value(e){return this._latestMessageSentByMeMap.get(e);}},{key:"modifyMessageSentByPeer",value:function value(e){var t=e.conversationID,n=e.latestNick,o=e.latestAvatar,s=this.list.get(t);if(!jt(s)){var a=Array.from(s.values()),r=a.length;if(0!==r){for(var i=null,u=0,c=!1,l=r-1;l>=0;l--){"in"===a[l].flow&&((i=a[l]).nick!==n&&(i.setNickAndAvatar({nick:n}),c=!0),i.avatar!==o&&(i.setNickAndAvatar({avatar:o}),c=!0),c&&(u+=1));}xe.l("".concat(this._n,".modifyMessageSentByPeer conversationID:").concat(t," count:").concat(u));}}}},{key:"modifyMessageSentByMe",value:function value(e){var t=e.conversationID,n=e.latestNick,o=e.latestAvatar,s=this.list.get(t);if(!jt(s)){var a=Array.from(s.values()),r=a.length;if(0!==r){for(var i=null,u=0,c=!1,l=r-1;l>=0;l--){"out"===a[l].flow&&((i=a[l]).nick!==n&&(i.setNickAndAvatar({nick:n}),c=!0),i.avatar!==o&&(i.setNickAndAvatar({avatar:o}),c=!0),c&&(u+=1));}xe.l("".concat(this._n,".modifyMessageSentByMe conversationID:").concat(t," count:").concat(u));}}}},{key:"getTopicConversationIDList",value:function value(e){return m(this.list.keys()).filter(function(t){return t.startsWith("".concat(S.CONV_GROUP).concat(e));});}},{key:"traversal",value:function value(){if(0!==this.list.size&&-1===xe.getLevel()){console.group("conversationID-messageCount");var e,t=D(this.list);try{for(t.s();!(e=t.n()).done;){var n=v(e.value,2),o=n[0],s=n[1];console.log("".concat(o,"-").concat(s.size));}}catch(a){t.e(a);}finally{t.f();}console.groupEnd();}}},{key:"onMessageModified",value:function value(e,t){if(!this.list.has(e))return{isUpdated:!1,message:null};var n=this._getUniqueIDOfMessage(t),o=this.list.get(e).has(n);if(xe.d("".concat(this._n,".onMessageModified conversationID:").concat(e," uniqueID:").concat(n," has:").concat(o)),o){var s=this.list.get(e).get(n),a=t.messageVersion,r=t.elements,i=t.cloudCustomData;return s.version<a?(s.version=a,s._elements=JSON.parse(JSON.stringify(r)),s.payload=JSON.parse(JSON.stringify(r[0].content)),s.type=r[0].type,s.cloudCustomData=i,s.isModified=!0,{isUpdated:!0,message:s}):{isUpdated:!1,message:s};}return{isUpdated:!1,message:null};}},{key:"_getUniqueIDOfMessage",value:function value(e){var t=e.from,n=e.to,o=e.random,s=e.sequence,a=e.time;return"".concat(t,"-").concat(n,"-").concat(o,"-").concat(s,"-").concat(a);}},{key:"reset",value:function value(){this.list.clear(),this._latestMessageSentByPeerMap.clear(),this._latestMessageSentByMeMap.clear();}}]),e;}(),Za="_a2KeyAndTinyIDUpdated",$a="_cloudConfigUpdated",er="_profileUpdated";function tr(e){this.mixin(e);}tr.mixin=function(e){var t=e.prototype||e;t._isReady=!1,t.ready=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(e)return this._isReady?void(t?e.call(this):setTimeout(e,1)):(this._readyQueue=this._readyQueue||[],void this._readyQueue.push(e));},t.triggerReady=function(){var e=this;this._isReady=!0,setTimeout(function(){var t=e._readyQueue;e._readyQueue=[],t&&t.length>0&&t.forEach(function(e){e.call(this);},e);},1);},t.resetReady=function(){this._isReady=!1,this._readyQueue=[];},t.isReady=function(){return this._isReady;};};var nr=["jpg","jpeg","gif","png","bmp","image","webp"],or=["mp4","quicktime","mov"],sr=1,ar=2,rr=3,ir=255,ur=function(){function e(t){var n=this;o(this,e),jt(t)||(this.userID=t.userID||"",this.nick=t.nick||"",this.gender=t.gender||"",this.birthday=t.birthday||0,this.location=t.location||"",this.selfSignature=t.selfSignature||"",this.allowType=t.allowType||S.ALLOW_TYPE_ALLOW_ANY,this.language=t.language||0,this.avatar=t.avatar||"",this.messageSettings=t.messageSettings||0,this.adminForbidType=t.adminForbidType||S.FORBID_TYPE_NONE,this.level=t.level||0,this.role=t.role||0,this.lastUpdatedTime=0,this.profileCustomField=[],jt(t.profileCustomField)||t.profileCustomField.forEach(function(e){n.profileCustomField.push({key:e.key,value:e.value});}));}return a(e,[{key:"validate",value:function value(e){var t=!0,n="";if(jt(e))return{valid:!1,tips:"empty options"};if(e.profileCustomField)for(var o=e.profileCustomField.length,s=null,a=0;a<o;a++){if(s=e.profileCustomField[a],!et(s.key)||-1===s.key.indexOf("Tag_Profile_Custom"))return{valid:!1,tips:"The prefix of keys of the custom profile key-value pairs (which is profileCustomField) must be Tag_Profile_Custom"};if(!et(s.value))return{valid:!1,tips:"The type of values of the custom profile key-value pairs (which is profileCustomField) must be String"};}for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r)){if("profileCustomField"===r)continue;if(jt(e[r])&&!et(e[r])&&!$e(e[r])){n="key:"+r+", invalid value:"+e[r],t=!1;continue;}switch(r){case"nick":et(e[r])||(n="nick must be a string",t=!1),gt(e[r])>500&&(n="nick name limited: must less than or equal to ".concat(500," bytes, current size: ").concat(gt(e[r])," bytes"),t=!1);break;case"gender":vt(He,e.gender)||(n="key:gender, invalid value:"+e.gender,t=!1);break;case"birthday":$e(e.birthday)||(n="birthday must be a number",t=!1);break;case"location":et(e.location)||(n="location must be a string",t=!1);break;case"selfSignature":et(e.selfSignature)||(n="selfSignature must be a string",t=!1);break;case"allowType":vt(We,e.allowType)||(n="key:allowType, invalid value:"+e.allowType,t=!1);break;case"language":$e(e.language)||(n="language must be a number",t=!1);break;case"avatar":et(e.avatar)||(n="avatar must be a string",t=!1);break;case"messageSettings":0!==e.messageSettings&&1!==e.messageSettings&&(n="messageSettings must be 0 or 1",t=!1);break;case"adminForbidType":vt(Ke,e.adminForbidType)||(n="key:adminForbidType, invalid value:"+e.adminForbidType,t=!1);break;case"level":$e(e.level)||(n="level must be a number",t=!1);break;case"role":$e(e.role)||(n="role must be a number",t=!1);break;default:n="unknown key:"+r+"  "+e[r],t=!1;}}}return{valid:t,tips:n};}}]),e;}(),cr=a(function e(t){o(this,e),this.value=t,this.next=null;}),lr=function(){function e(t){o(this,e),this.MAX_LENGTH=t,this.pTail=null,this.pNodeToDel=null,this.map=new Map();}return a(e,[{key:"set",value:function value(e){var t=new cr(e);if(this.map.size<this.MAX_LENGTH)null===this.pTail?(this.pTail=t,this.pNodeToDel=t):(this.pTail.next=t,this.pTail=t),this.map.set(e,1);else{var n=this.pNodeToDel;this.pNodeToDel=this.pNodeToDel.next,this.map.delete(n.value),n.next=null,n=null,this.pTail.next=t,this.pTail=t,this.map.set(e,1);}}},{key:"has",value:function value(e){return this.map.has(e);}},{key:"delete",value:function value(e){this.has(e)&&this.map.delete(e);}},{key:"tail",value:function value(){return this.pTail;}},{key:"size",value:function value(){return this.map.size;}},{key:"data",value:function value(){return Array.from(this.map.keys());}},{key:"reset",value:function value(){for(var e;null!==this.pNodeToDel;){e=this.pNodeToDel,this.pNodeToDel=this.pNodeToDel.next,e.next=null,e=null;}this.pTail=null,this.map.clear();}}]),e;}(),pr=["groupID","name","avatar","type","introduction","notification","ownerID","selfInfo","createTime","infoSequence","lastInfoTime","lastMessage","nextMessageSeq","memberNum","maxMemberNum","memberList","joinOption","groupCustomField","muteAllMembers","isSupportTopic","inviteOption","_lastRevokedTime"],dr=function(){function e(t){o(this,e),this.groupID="",this.name="",this.avatar="",this.type="",this.introduction="",this.notification="",this.ownerID="",this.createTime="",this.infoSequence="",this.lastInfoTime="",this.selfInfo={messageRemindType:"",joinTime:"",nameCard:"",role:"",userID:"",memberCustomField:void 0,readedSequence:0,excludedUnreadSequenceList:void 0},this.lastMessage={lastTime:"",lastSequence:"",fromAccount:"",messageForShow:""},this.nextMessageSeq="",this.memberNum="",this.memberCount="",this.maxMemberNum="",this.maxMemberCount="",this.joinOption="",this.inviteOption="",this.groupCustomField=[],this.muteAllMembers=!1,this.isSupportTopic=!1,this._lastRevokedTime=0,this._initGroup(t);}return a(e,[{key:"memberNum",get:function get(){return this.memberCount;},set:function set(e){}},{key:"maxMemberNum",get:function get(){return this.maxMemberCount;},set:function set(e){}},{key:"_initGroup",value:function value(e){for(var t in e){pr.indexOf(t)<0||("selfInfo"!==t?("memberNum"===t&&(this.memberCount=e[t]),"maxMemberNum"===t&&(this.maxMemberCount=e[t]),"isSupportTopic"!==t?this[t]=e[t]:this.isSupportTopic=1===e[t]):this.updateSelfInfo(e[t]));}}},{key:"updateGroup",value:function value(e){var t=this;e.appid=void 0,e.grossTopicNextMsgSeq=void 0,e.selfInfo&&(e.selfInfo.grossTopicReadSeq=void 0);var n=JSON.parse(JSON.stringify(e));n.lastMsgTime&&(this.lastMessage.lastTime=n.lastMsgTime),at(n.muteAllMembers)||("On"===n.muteAllMembers?n.muteAllMembers=!0:n.muteAllMembers=!1),n.groupCustomField&&It(this.groupCustomField,n.groupCustomField),at(n.memberNum)||(this.memberCount=n.memberNum),at(n.maxMemberNum)||(this.maxMemberCount=n.maxMemberNum),at(n.isSupportTopic)||(this.isSupportTopic=$e(n.isSupportTopic)?1===n.isSupportTopic:n.isSupportTopic),pt(this,n,["members","errorCode","lastMsgTime","groupCustomField","memberNum","maxMemberNum","isSupportTopic"]),st(n.members)&&n.members.length>0&&n.members.forEach(function(e){e.userID===t.selfInfo.userID&&pt(t.selfInfo,e,["sequence"]);});}},{key:"updateSelfInfo",value:function value(e){var n={nameCard:e.nameCard,joinTime:e.joinTime,role:e.role,messageRemindType:e.messageRemindType,readedSequence:e.readedSequence,excludedUnreadSequenceList:e.excludedUnreadSequenceList};pt(this.selfInfo,t({},n),[],["",null,void 0,0,NaN]);}},{key:"setSelfNameCard",value:function value(e){this.selfInfo.nameCard=e;}}]),e;}(),gr=function gr(e,n){return at(e)?{lastTime:0,lastSequence:0,fromAccount:0,messageForShow:"",payload:null,type:"",isRevoked:!1,cloudCustomData:"",onlineOnlyFlag:!1,nick:"",nameCard:"",version:0,isPeerRead:!1,revoker:null}:e instanceof Ha?{lastTime:e.time||0,lastSequence:e.sequence||0,fromAccount:e.from||"",messageForShow:xt(e.type,e.payload,n),payload:e.payload||null,type:e.type||null,isRevoked:e.isRevoked||!1,cloudCustomData:e.cloudCustomData||"",onlineOnlyFlag:e._onlineOnlyFlag||!1,nick:e.nick||"",nameCard:e.nameCard||"",version:e.version||0,isPeerRead:e.isPeerRead||!1,revoker:e.revoker||null}:t(t({},e),{},{messageForShow:xt(e.type,e.payload,n)});},_r=function(){function e(t,n){o(this,e),this.conversationID=t.conversationID||"",this.unreadCount=t.unreadCount||0,this.type=t.type||"",this.lastMessage=gr(t.lastMessage,n),t.lastMsgTime&&(this.lastMessage.lastTime=t.lastMsgTime),this._isInfoCompleted=!1,this.peerReadTime=t.peerReadTime||0,this.groupAtInfoList=[],this.remark="",this.isPinned=t.isPinned||!1,this.messageRemindType="",this.markList=t.markList||[],this.customData=t.customData||"",this.conversationGroupList=t.conversationGroupList||[],this._initProfile(t);}return a(e,[{key:"toAccount",get:function get(){return this.conversationID.startsWith(S.CONV_C2C)?this.conversationID.replace(S.CONV_C2C,""):this.conversationID.startsWith(S.CONV_GROUP)?this.conversationID.replace(S.CONV_GROUP,""):"";}},{key:"subType",get:function get(){return this.groupProfile?this.groupProfile.type:"";}},{key:"_initProfile",value:function value(e){var t=this;Object.keys(e).forEach(function(n){switch(n){case"userProfile":t.userProfile=e.userProfile;break;case"groupProfile":t.groupProfile=e.groupProfile;}}),at(this.userProfile)&&this.type===S.CONV_C2C?this.userProfile=new ur({userID:e.conversationID.replace("C2C","")}):at(this.groupProfile)&&this.type===S.CONV_GROUP&&(this.groupProfile=new dr({groupID:e.conversationID.replace("GROUP","")}));}},{key:"updateUnreadCount",value:function value(e){var t=e.nextUnreadCount,n=e.isFromGetConversations,o=e.isUnreadC2CMessage;at(t)||(Ct(this.subType)?this.unreadCount=0:n&&this.type===S.CONV_GROUP||n&&this.type===S.CONV_TOPIC||o&&this.type===S.CONV_C2C?this.unreadCount=t:this.unreadCount=this.unreadCount+t);}},{key:"updateLastMessage",value:function value(e){this.lastMessage=gr(e);}},{key:"updateGroupAtInfoList",value:function value(e){if(!this._isNeedMergeGroupAtInfo(e)){var t,n=(M(t=e.groupAtType)||y(t)||I(t)||T()).slice(0);-1!==n.indexOf(S.CONV_AT_ME)&&-1!==n.indexOf(S.CONV_AT_ALL)&&(n=[S.CONV_AT_ALL_AT_ME]);var o={from:e.from,groupID:e.groupID,topicID:e.topicID,messageSequence:e.sequence,atTypeArray:n,__random:e.__random,__sequence:e.__sequence};this.groupAtInfoList.push(o);}}},{key:"_isNeedMergeGroupAtInfo",value:function value(e){var t=e.groupID,n=e.sequence;if(!Tt({groupID:t}))return!1;var o=!1;return this.groupAtInfoList.forEach(function(t){t.messageSequence===n&&(t.atTypeArray.indexOf(S.CONV_AT_ME)>-1&&e.groupAtType.indexOf(S.CONV_AT_ALL)>-1&&(t.atTypeArray=[S.CONV_AT_ALL_AT_ME]),t.atTypeArray.indexOf(S.CONV_AT_ALL)>-1&&e.groupAtType.indexOf(S.CONV_AT_ME)>-1&&(t.atTypeArray=[S.CONV_AT_ALL_AT_ME],t.__random=e.__random,t.__sequence=e.__sequence),o=!0);}),o;}},{key:"clearGroupAtInfoList",value:function value(){this.groupAtInfoList.length=0;}},{key:"reduceUnreadCount",value:function value(){return this.unreadCount>=1&&(this.unreadCount-=1,!0);}},{key:"isLastMessageRevoked",value:function value(e){var t=e.sequence,n=e.time;return this.type===S.CONV_C2C&&t===this.lastMessage.lastSequence&&n===this.lastMessage.lastTime||this.type===S.CONV_GROUP&&t===this.lastMessage.lastSequence;}},{key:"setLastMessageRevoked",value:function value(e){this.lastMessage.isRevoked=e;}},{key:"setLastMessageRevoker",value:function value(e){this.lastMessage.revoker=e;}}]),e;}(),hr=function(){function e(t){o(this,e),this._conversationModule=t,this._n="MessageRemindHandler",this._updateSequence=0;}return a(e,[{key:"getC2CMessageRemindType",value:function value(){var e=this,t="".concat(this._n,".getC2CMessageRemindType");return this._conversationModule.request({protocolName:Do,updateSequence:this._updateSequence}).then(function(n){xe.l("".concat(t," ok"));var o=n.data,s=o.updateSequence,a=o.muteFlagList;e._updateSequence=s,e._patchC2CMessageRemindType(a);}).catch(function(e){xe.e("".concat(t," failed. error:"),e);});}},{key:"_patchC2CMessageRemindType",value:function value(e){var t=this,n=0,o="";st(e)&&e.length>0&&e.forEach(function(e){var s=e.userID,a=e.muteFlag;0===a?o=S.MSG_REMIND_ACPT_AND_NOTE:1===a?o=S.MSG_REMIND_DISCARD:2===a&&(o=S.MSG_REMIND_ACPT_NOT_NOTE),!0===t._conversationModule.patchMessageRemindType({ID:s,isC2CConversation:!0,messageRemindType:o})&&(n+=1);}),xe.l("".concat(this._n,"._patchC2CMessageRemindType count:").concat(n));}},{key:"set",value:function value(e){return e.groupID?this._setGroupMessageRemindType(e):st(e.userIDList)?this._setC2CMessageRemindType(e):void 0;}},{key:"_setGroupMessageRemindType",value:function value(e){var t=this,n="".concat(this._n,"._setGroupMessageRemindType"),o=e.groupID,s=e.messageRemindType,a="groupID:".concat(o," messageRemindType:").concat(s),r=new ka("setMessageRemindType");return r.setMessage(a),this._getModule(bn).modifyGroupMemberInfo({groupID:o,messageRemindType:s,userID:this._conversationModule.getMyUserID()}).then(function(){r.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok. ").concat(a));var o=t.onGroupMessageRemindTypeUpdated(e);return t._conversationModule.emitTotalUnreadMessageCountUpdate(),Ka(o);}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"onGroupMessageRemindTypeUpdated",value:function value(e){var t=e.groupID,n=e.messageRemindType,o=this._getModule(Un).getLocalGroupProfile(t);if(o&&(o.selfInfo.messageRemindType=n),Dt(t)){var s=t,a=qt(s),r=this._getModule(wn).getLocalTopic(a,s);return r&&(r.updateSelfInfo({messageRemindType:n}),this._conversationModule.emitOuterEvent(E.TOPIC_UPDATED,{groupID:a,topic:r})),{topic:r};}return this._conversationModule.patchMessageRemindType({ID:t,isC2CConversation:!1,messageRemindType:n})&&this._emitConversationUpdate(),{group:o};}},{key:"_setC2CMessageRemindType",value:function value(e){var t=this,n="".concat(this._n,"._setC2CMessageRemindType"),o=e.userIDList,s=e.messageRemindType,a=o.slice(0,30),r=0;s===S.MSG_REMIND_DISCARD?r=1:s===S.MSG_REMIND_ACPT_NOT_NOTE&&(r=2);var i="userIDList:".concat(a," messageRemindType:").concat(s),u=new ka("setMessageRemindType");return u.setMessage(i),this._conversationModule.request({protocolName:To,requestData:{userIDList:a,muteFlag:r}}).then(function(e){u.setNetworkType(t._conversationModule.getNetworkType()).end();var o=e.data,r=o.updateSequence,i=o.errorList;t._updateSequence=r;var c=[],l=[];st(i)&&i.forEach(function(e){c.push(e.userID),l.push({userID:e.userID,code:e.errorCode});});var p=a.filter(function(e){return-1===c.indexOf(e);});xe.l("".concat(n," ok. successUserIDList:").concat(p," failureUserIDList:").concat(JSON.stringify(l)));var d=0;return p.forEach(function(e){t._conversationModule.patchMessageRemindType({ID:e,isC2CConversation:!0,messageRemindType:s})&&(d+=1);}),d>=1&&t._emitConversationUpdate(),a.length=c.length=0,t._conversationModule.emitTotalUnreadMessageCountUpdate(),za({successUserIDList:p.map(function(e){return{userID:e};}),failureUserIDList:l});}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_getModule",value:function value(e){return this._conversationModule.getModule(e);}},{key:"_emitConversationUpdate",value:function value(){this._conversationModule.emitConversationUpdate(!0,!1);}},{key:"setUpdateSequence",value:function value(e){this._updateSequence=e;}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._updateSequence=0;}}]),e;}(),fr=function(){function e(t){o(this,e),this._conversationModule=t,this._n="ConvGroupHandler",this._convGroupMap=new Map(),this._startIndex=0,this._pagingStatus=Zt.NOT_START;}return a(e,[{key:"setConvCustomData",value:function value(e){var t=this,n="".concat(this._n,".").concat("setConvCustomData"),o=e.conversationIDList,s=e.customData;xe.l("".concat(n," options:"),e);var a=new ka("setConvCustomData");a.setMessage(JSON.stringify(e));var r={fromAccount:this._getMyUserID(),itemList:[]},i=[],u=[];return o.forEach(function(e){if(!t._hasLocalConversation(e))return t._onConversationNotFound(u,e),!0;if(!Et(e)&&!St(e))return t._onConversationIDInvalid(u,e),!0;var n={operationType:2,contactItem:void 0,customMark:s};Et(e)?n.contactItem={type:1,toAccount:e.replace(S.CONV_C2C,"")}:St(e)&&(n.contactItem={type:2,groupID:e.replace(S.CONV_GROUP,"")}),r.itemList.push(n);}),u.length===o.length?za({successConversationIDList:i,failureConversationIDList:u}):this._conversationModule.request({protocolName:wo,requestData:r}).then(function(e){a.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok"));var o=e.data.resultItem;if(st(o)){var r,c,l=!1;o.forEach(function(e){r=t._concatConversationID(e.contactItem),0===e.resultCode?(i.push(r),(c=t._getLocalConversation(r))&&c.customData!==s&&(c.customData=s,l=!0)):u.push({conversationID:r,code:e.resultCode,message:e.resultInfo});}),!0===l&&t._emitConversationUpdate();}return Ka({successConversationIDList:i,failureConversationIDList:u});}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];a.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"markConversation",value:function value(e){var t=this;if(!this._conversationModule.canIUse(B.CONV_MARK))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".").concat("markConversation"),o=e.conversationIDList,s=e.markType,a=e.enableMark;xe.l("".concat(n," options:"),e);var r=new ka("markConversation");r.setMessage(JSON.stringify(e));var i=void 0,u=void 0,c=this._getFlagBit(s);!0===a?u=[c]:i=[c];var l={fromAccount:this._getMyUserID(),itemList:[]},p=[],d=[];return o.forEach(function(e){if(!t._hasLocalConversation(e))return t._onConversationNotFound(d,e),!0;if(!Et(e)&&!St(e))return t._onConversationIDInvalid(d,e),!0;var n={operationType:1,contactItem:void 0,clearMark:i,setMark:u};Et(e)?n.contactItem={type:1,toAccount:e.replace(S.CONV_C2C,"")}:St(e)&&(n.contactItem={type:2,groupID:e.replace(S.CONV_GROUP,"")}),l.itemList.push(n);}),d.length===o.length?za({successConversationIDList:p,failureConversationIDList:d}):this._conversationModule.request({protocolName:Fo,requestData:l}).then(function(e){r.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok"));var o=e.data.resultItem;if(st(o)){var i,u,c=!1;o.forEach(function(e){if(i=t._concatConversationID(e.contactItem),0===e.resultCode){if(p.push(i),u=t._getLocalConversation(i)){var n=u.markList.indexOf(s);!0===a?-1===n&&(u.markList.push(s),c=!0):-1!==n&&(u.markList.splice(n,1),c=!0);}}else d.push({conversationID:i,code:e.resultCode,message:e.resultInfo});}),!0===c&&t._emitConversationUpdate();}return Ka({successConversationIDList:p,failureConversationIDList:d});}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"getLocalConvGroupList",value:function value(){var e=this;return xe.l("".concat(this._n,".getLocalConvGroupList pagingStatus:").concat(this._pagingStatus)),this._pagingStatus===Zt.REJECTED?this.getRemoteConvGroupList().then(function(){return Ka(m(e._convGroupMap.values()));}):za(m(this._convGroupMap.values()));}},{key:"getRemoteConvGroupList",value:function value(){var e=this,t="".concat(this._n,".getRemoteConvGroupList");return this._pagingStatus=Zt.PENDING,this._conversationModule.request({protocolName:Ko,requestData:{fromAccount:this._getMyUserID(),startIndex:this._startIndex,startTime:be()}}).then(function(n){var o,s,a=n.data,r=a.completeFlag,i=a.contactItem,u=a.nextStartIndex,c=void 0===u?0:u,l=a.groupItem;(e._startIndex=c,xe.l("".concat(t," completeFlag:").concat(r," nextStartIndex:").concat(c)),st(l)&&l.forEach(function(t){var n=t.convGroupID,o=t.groupName;e._convGroupMap.set(n,o);}),st(i))&&i.forEach(function(t){var n=t.standardMark,a=t.customData,r=t.convGroupIDList;if(o=e._concatConversationID(t),(s=e._getLocalConversation(o))&&(s.markList=Bt(n),s.customData=a||"",st(r))){var i=[];r.forEach(function(t){e._convGroupMap.has(t)&&i.push(e._convGroupMap.get(t));}),s.conversationGroupList=[].concat(i),i.length=0;}});if(0===r)return e.getRemoteConvGroupList();1===r&&(e._pagingStatus=Zt.RESOLVED,e._emitConversationUpdate(),e._emitConvGroupListUpdate());}).catch(function(n){e._pagingStatus=Zt.REJECTED,xe.w("".concat(t," failed. error:"),n);});}},{key:"createConvGroup",value:function value(e){var t=this;if(!this._conversationModule.canIUse(B.CONV_GROUP))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".").concat("createConvGroup");xe.l("".concat(n," options:"),e);var o=new ka("createConvGroup");o.setMessage(JSON.stringify(e));var s=e.groupName,a=e.conversationIDList,r={fromAccount:this._getMyUserID(),itemList:[{groupName:s,contactItem:[]}]},i=[],u=[];return a.forEach(function(e){return t._hasLocalConversation(e)?Et(e)||St(e)?void(Et(e)?r.itemList[0].contactItem.push({type:1,toAccount:e.replace(S.CONV_C2C,"")}):St(e)&&r.itemList[0].contactItem.push({type:2,groupID:e.replace(S.CONV_GROUP,"")})):(t._onConversationIDInvalid(u,e),!0):(t._onConversationNotFound(u,e),!0);}),u.length===a.length?za({successConversationIDList:i,failureConversationIDList:u}):this._conversationModule.request({protocolName:qo,requestData:r}).then(function(e){o.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok"));var a=e.data.groupResultItem[0],r=a.groupItem,c=a.resultItem;if(ot(r)&&(t._convGroupMap.set(r.convGroupID,r.groupName),t._emitConvGroupListUpdate()),st(c)){var l,p,d=!1;c.forEach(function(e){l=t._concatConversationID(e.contactItem),0===e.resultCode?(i.push(l),(p=t._getLocalConversation(l))&&-1===p.conversationGroupList.indexOf(s)&&(p.conversationGroupList.push(s),d=!0)):u.push({conversationID:l,code:e.resultCode,message:e.resultInfo});}),!0===d&&(t._emitConversationUpdate(),t._emitConvGroupListUpdate());}return Ka({successConversationIDList:i,failureConversationIDList:u});}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"deleteConvGroup",value:function value(e){var t=this;if(!this._conversationModule.canIUse(B.CONV_GROUP))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".").concat("deleteConvGroup");xe.l("".concat(n," groupName:").concat(e));var o=new ka("deleteConvGroup");return o.setMessage(e),this._conversationModule.request({protocolName:xo,requestData:{fromAccount:this._getMyUserID(),groupName:[e]}}).then(function(s){o.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok"));var a=s.data.groupItem;if(st(a)){var r=!1;a.forEach(function(e){t._convGroupMap.has(e.convGroupID)&&(t._convGroupMap.delete(e.convGroupID),r=!0);}),!0===r&&t._emitConvGroupListUpdate();}t._eraseFromConversationGroupList([e]);}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"renameConvGroup",value:function value(e){var t=this;if(!this._conversationModule.canIUse(B.CONV_GROUP))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".").concat("renameConvGroup");xe.l("".concat(n," options:"),e);var o=new ka("renameConvGroup");o.setMessage(JSON.stringify(e));var s=e.oldName,a=e.newName;return this._conversationModule.request({protocolName:Vo,requestData:{fromAccount:this._getMyUserID(),updateType:1,updateGroup:{updateGroupType:1,oldName:s,newName:a}}}).then(function(e){o.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok"));var r=e.data.updateGroupResult.convGroupID;t._convGroupMap.set(r,a),t._emitConvGroupListUpdate();var i,u,c=t._conversationModule.getLocalConversationList(),l=!1;c.forEach(function(e){i=e.conversationGroupList,-1!==(u=i.indexOf(s))&&(i.splice(u,1,a),l=!0);}),!0===l&&t._emitConversationUpdate();}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"addConvsToGroup",value:function value(e){var t=this;if(!this._conversationModule.canIUse(B.CONV_GROUP))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".").concat("addConvsToGroup");xe.l("".concat(n," options:"),e);var o=new ka("addConvsToGroup");o.setMessage(JSON.stringify(e));var s=e.conversationIDList,a=e.groupName,r={fromAccount:this._getMyUserID(),updateType:1,updateGroup:{updateGroupType:2,groupName:a,updateItem:[]}},i=[],u=[];return s.forEach(function(e){return t._hasLocalConversation(e)?Et(e)||St(e)?void(Et(e)?r.updateGroup.updateItem.push({operationType:1,contactItem:{type:1,toAccount:e.replace(S.CONV_C2C,"")}}):St(e)&&r.updateGroup.updateItem.push({operationType:1,contactItem:{type:2,groupID:e.replace(S.CONV_GROUP,"")}})):(t._onConversationIDInvalid(u,e),!0):(t._onConversationNotFound(u,e),!0);}),u.length===s.length?za({successConversationIDList:i,failureConversationIDList:u}):this._conversationModule.request({protocolName:Bo,requestData:r}).then(function(e){o.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok"));var s=e.data.updateGroupResult.contactResultItem;if(st(s)){var r,c,l=!1;s.forEach(function(e){r=t._concatConversationID(e.contactItem),0===e.resultCode?(c=t._getLocalConversation(r))&&-1===c.conversationGroupList.indexOf(a)&&(c.conversationGroupList.push(a),i.push(r),l=!0):u.push({conversationID:r,code:e.resultCode,message:e.resultInfo});}),!0===l&&(t._emitConversationUpdate(),t._emitConvInGroupUpdate(a));}return Ka({successConversationIDList:i,failureConversationIDList:u});}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"deleteConvsFromGroup",value:function value(e){var t=this;if(!this._conversationModule.canIUse(B.CONV_GROUP))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".").concat("deleteConvsFromGroup");xe.l("".concat(n," options:"),e);var o=new ka("deleteConvsFromGroup");o.setMessage(JSON.stringify(e));var s=e.conversationIDList,a=e.groupName,r={fromAccount:this._getMyUserID(),updateType:1,updateGroup:{updateGroupType:2,groupName:a,updateItem:[]}},i=[],u=[];return s.forEach(function(e){return t._hasLocalConversation(e)?Et(e)||St(e)?void(Et(e)?r.updateGroup.updateItem.push({operationType:2,contactItem:{type:1,toAccount:e.replace(S.CONV_C2C,"")}}):St(e)&&r.updateGroup.updateItem.push({operationType:2,contactItem:{type:2,groupID:e.replace(S.CONV_GROUP,"")}})):(t._onConversationIDInvalid(u,e),!0):(t._onConversationNotFound(u,e),!0);}),u.length===s.length?za({successConversationIDList:i,failureConversationIDList:u}):this._conversationModule.request({protocolName:Ho,requestData:r}).then(function(e){o.setNetworkType(t._conversationModule.getNetworkType()).end(),xe.l("".concat(n," ok"));var s=e.data.updateGroupResult.contactResultItem;if(st(s)){var r,c,l=!1;s.forEach(function(e){if(r=t._concatConversationID(e.contactItem),0===e.resultCode){if(c=t._getLocalConversation(r)){var n=c.conversationGroupList.indexOf(a);-1!==n&&(c.conversationGroupList.splice(n,1),i.push(r),l=!0);}}else u.push({conversationID:r,code:e.resultCode,message:e.resultInfo});}),!0===l&&(t._emitConversationUpdate(),t._emitConvInGroupUpdate(a));}return Ka({successConversationIDList:i,failureConversationIDList:u});}).catch(function(e){return t._conversationModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"onConvMarkUpdated",value:function value(e){var t=this;if(!jt(e)){var n,o;xe.d("".concat(this._n,".onConvMarkUpdated markItemList:"),e);var s=!1;e.forEach(function(e){var a=e.recentContactItem,r=e.optType,i=e.standardMark,u=e.customMark;if(n=t._concatConversationID(a),o=t._getLocalConversation(n))if(1===r){var c=Bt(i);!0!==function(e,t){if(e===t)return!0;if(!e||!t)return!1;if(e.length!==t.length)return!1;for(var n=0,o=e.length;n<o;n++){if(e[n]!==t[n])return!1;}return!0;}(o.markList,c)&&(o.markList=c,s=!0);}else 2===r&&o.customData!==u&&void 0!==u&&(o.customData=u,s=!0);}),!0===s&&this._emitConversationUpdate();}}},{key:"onConvGroupCreated",value:function value(e){var t=this;xe.d("".concat(this._n,".onConvGroupCreated resultList:"),e);var n=!1,o=!1;st(e)&&(e.forEach(function(e){var s=e.msgGroupItem,a=s.groupID,r=s.groupName;t._convGroupMap.get(a)!==r&&(t._convGroupMap.set(a,r),o=!0);var i,u,c=e.msgRecentContactItem;st(c)&&c.forEach(function(e){i=t._concatConversationID(e),(u=t._getLocalConversation(i))&&-1===u.conversationGroupList.indexOf(r)&&(u.conversationGroupList.push(r),n=!0);});}),!0===n&&this._emitConversationUpdate(),!0===o&&this._emitConvGroupListUpdate());}},{key:"onConvGroupDeleted",value:function value(e){var t=this;xe.d("".concat(this._n,".onConvGroupDeleted groupItemList:"),e);var n=[];if(st(e)){var o=!1;e.forEach(function(e){var s=e.groupID,a=e.groupName;t._convGroupMap.has(s)&&(t._convGroupMap.delete(s),o=!0,n.push(a));}),!0===o&&this._emitConvGroupListUpdate();}this._eraseFromConversationGroupList(n);}},{key:"_eraseFromConversationGroupList",value:function value(e){jt(e)||(this._conversationModule.getLocalConversationList().forEach(function(t){t.conversationGroupList=t.conversationGroupList.filter(function(t){return!e.includes(t);});}),this._emitConversationUpdate());}},{key:"onConvGroupNameUpdated",value:function value(e){xe.d("".concat(this._n,".onConvGroupNameUpdated options:"),e);var t=e.groupID,n=e.groupName,o=e.oldGroupName;if(this._convGroupMap.get(t)!==n){this._convGroupMap.set(t,n),this._emitConvGroupListUpdate();var s,a,r=this._conversationModule.getLocalConversationList(),i=!1;r.forEach(function(e){s=e.conversationGroupList,-1!==(a=s.indexOf(o))&&(s.splice(a,1,n),i=!0);}),!0===i&&this._emitConversationUpdate();}}},{key:"onConvInGroupUpdated",value:function value(e){var t=this;xe.d("".concat(this._n,".onConvInGroupUpdated options:"),e);var n=e.oldGroupName,o=e.recentContactUpdateGroupItem;if(st(o)){var s,a,r,i=!1;o.forEach(function(e){var o=e.contactOptType,u=e.recentContactItem;s=t._concatConversationID(u),(a=t._getLocalConversation(s))&&(r=a.conversationGroupList.indexOf(n),1===o?-1===r&&(a.conversationGroupList.push(n),i=!0):2===o&&-1!==r&&(a.conversationGroupList.splice(r,1),i=!0));}),!0===i&&(this._emitConversationUpdate(),this._emitConvInGroupUpdate(n));}}},{key:"onConvAddedToOrDeletedFromGroup",value:function value(e){var t=this;xe.d("".concat(this._n,".onConvAddedToOrDeletedFromGroup options:"),e);var n=e.msgRecentContactItem,o=e.msgRecentContactUpdateContactItem,s=this._concatConversationID(n),a=this._getLocalConversation(s);if(a&&st(o)){var r,i=!1;o.forEach(function(e){var n=e.groupOptType,o=e.recentContactGroupItem.groupName;r=a.conversationGroupList.indexOf(o),1===n?-1===r&&(a.conversationGroupList.push(o),i=!0):2===n&&-1!==r&&(a.conversationGroupList.splice(r,1),i=!0),!0===i&&t._emitConvInGroupUpdate(o);}),!0===i&&this._emitConversationUpdate();}}},{key:"onConvGroupListSynced",value:function value(e){var t=this;st(e)&&0!==e.length&&(xe.l("".concat(this._n,".onConvGroupListSynced groupItemList:"),e),e.forEach(function(e){t._convGroupMap.set(e.convGroupID,e.groupName);}));}},{key:"getConvGroupListByID",value:function value(e){var t=this;if(!jt(e)){var n=[];return e.forEach(function(e){t._convGroupMap.has(e)&&n.push(t._convGroupMap.get(e));}),n;}}},{key:"_onConversationNotFound",value:function value(e,t){e.push({conversationID:t,code:da.CONVERSATION_NOT_FOUND,message:this._conversationModule.getErrorMessage(da.CONVERSATION_NOT_FOUND)});}},{key:"_onConversationIDInvalid",value:function value(e,t){e.push({conversationID:t,code:da.INVALID_CONVERSATION_ID,message:this._conversationModule.getErrorMessage(da.INVALID_CONVERSATION_ID)});}},{key:"_getFlagBit",value:function value(e){for(var t=e.toString(2),n=t.length,o=n-1;o>=0;o--){if("1"===t[o])return n-o-1;}}},{key:"_concatConversationID",value:function value(e){var t,n=e.type,o=e.to,s=e.groupID,a=e.userID;return 1===n?at(a)?at(o)||(t="".concat(S.CONV_C2C).concat(o)):t="".concat(S.CONV_C2C).concat(a):2===n&&(t="".concat(S.CONV_GROUP).concat(s)),t;}},{key:"_getMyUserID",value:function value(){return this._conversationModule.getMyUserID();}},{key:"_insertConversationGroup",value:function value(e,t){var n=this._getLocalConversation(e);if(n){var o=n.conversationGroupList;-1===o.indexOf(t)&&o.push(t);}}},{key:"_getLocalConversation",value:function value(e){return this._conversationModule.getLocalConversation(e);}},{key:"_hasLocalConversation",value:function value(e){return this._conversationModule.hasLocalConversation(e);}},{key:"_emitConversationUpdate",value:function value(){this._conversationModule.emitConversationUpdate(!0,!1);}},{key:"_emitConvGroupListUpdate",value:function value(){this._conversationModule.emitOuterEvent(E.CONVERSATION_GROUP_LIST_UPDATED,m(this._convGroupMap.values()));}},{key:"_emitConvInGroupUpdate",value:function value(e){var t={groupName:e,conversationList:[]},n=this._conversationModule.getLocalConversationList();t.conversationList=n.filter(function(t){return t.conversationGroupList.includes(e);}),this._conversationModule.emitOuterEvent(E.CONVERSATION_IN_GROUP_UPDATED,t);}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._convGroupMap.clear(),this._startIndex=0,this._pagingStatus=Zt.NOT_START;}}]),e;}(),vr=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="ConversationModule",tr.mixin(_(t)),t._messageListHandler=new Qa(),t._messageRemindHandler=new hr(_(t)),t._convGroupHandler=new fr(_(t)),t.singlyLinkedList=new lr(100),t._pagingStatus=Zt.NOT_START,t._pagingTimeStamp=0,t._pagingStartIndex=0,t._pagingPinnedTimeStamp=0,t._pagingPinnedStartIndex=0,t._pagingConvIDMap=new Map(),t._convIDFromUnreadDBMap=new Map(),t._conversationMap=new Map(),t._tmpGroupList=[],t._tmpGroupAtTipsList=[],t._peerReadTimeMap=new Map(),t._completedMap=new Map(),t._roamingMessageKeyAndTimeMap=new Map(),t._roamingMessageSequenceMap=new Map(),t._remoteGroupReadSequenceMap=new Map(),t._convTotalUnreadCount=0,t._pagingGetCostList=[],t._initListeners(),t;}return a(s,[{key:"_initListeners",value:function value(){var e=this.getInnerEmitterInstance();e.on(Za,this._initLocalConversationList,this),e.on(er,this._onProfileUpdated,this);}},{key:"onCheckTimer",value:function value(e){e%60==0&&this._messageListHandler.traversal();}},{key:"_initLocalConversationList",value:function value(){var e=this,t=new ka("_initLocalConversationList");xe.l("".concat(this._n,".").concat("_initLocalConversationList"));var n="",o=this._getStorageConversationList(),s=this.isIntl();if(o){for(var a=o.length,r=0;r<a;r++){var i=o[r];if(i){if(i.conversationID==="".concat(S.CONV_C2C,"@TLS#ERROR")||i.conversationID==="".concat(S.CONV_C2C,"@TLS#NOT_FOUND"))continue;if(i.groupProfile){var u=i.groupProfile.type;if(Ct(u))continue;}}this._conversationMap.set(o[r].conversationID,new _r(o[r],s));}this.emitConversationUpdate(!0,!1),n="count:".concat(a);}else n="count:0";t.setNetworkType(this.getNetworkType()).setMessage(n).end(),this.getModule(Gn)||this.triggerReady(),this.ready(function(){e._tmpGroupList.length>0&&(e.updateConversationGroupProfile(e._tmpGroupList),e._tmpGroupList.length=0);}),this.syncConversationList();}},{key:"onMessageSent",value:function value(e){this._onSendOrReceiveMessage({conversationOptionsList:e.conversationOptionsList,isInstantMessage:!0});}},{key:"onNewMessage",value:function value(e){this._onSendOrReceiveMessage(e);}},{key:"_onSendOrReceiveMessage",value:function value(e){var t=this,n=e.conversationOptionsList,o=e.isInstantMessage,s=void 0===o||o,a=e.isUnreadC2CMessage,r=void 0!==a&&a,i=e.updateUnreadCount,u=void 0===i||i;this._isReady?0!==n.length&&(this._getC2CPeerReadTime(n),this._updateLocalConversationList({conversationOptionsList:n,isInstantMessage:s,isUnreadC2CMessage:r,isFromGetConversations:!1,updateUnreadCount:u}),s||(this._convIDFromUnreadDBMap=new Map([].concat(m(this._convIDFromUnreadDBMap),m(n.map(function(e){return[e.conversationID,1];})))),this._diffAndDeleteConversation()),this._setStorageConversationList(),n.filter(function(e){return e.type===S.CONV_TOPIC;}).length>0||this.emitConversationUpdate()):this.ready(function(){t._onSendOrReceiveMessage(e);});}},{key:"updateConversationGroupProfile",value:function value(e){var t=this;if(!st(e)||0!==e.length)if(0!==this._conversationMap.size){var n=!1;e.forEach(function(e){var o="GROUP".concat(e.groupID);if(t._conversationMap.has(o)){n=!0;var s=t._conversationMap.get(o);s.groupProfile=JSON.parse(JSON.stringify(e)),s.lastMessage.lastSequence<e.nextMessageSeq&&(s.lastMessage.lastSequence=e.nextMessageSeq-1),s.subType||(s.subType=e.type);}}),n&&this.emitConversationUpdate(!0,!1);}else this._tmpGroupList=e;}},{key:"_updateConversationUserProfile",value:function value(e){var t=this;e.data.forEach(function(e){var n="C2C".concat(e.userID);t._conversationMap.has(n)&&(t._conversationMap.get(n).userProfile=e);}),this.emitConversationUpdate(!0,!1);}},{key:"onMessageRevoked",value:function value(e){var t=this;if(0!==e.length){var n=null,o=!1,s=[];e.forEach(function(e){(n=t._conversationMap.get(e.conversationID))&&(n.type===S.CONV_TOPIC?s.push(e):(n.reduceUnreadCount()&&(o=!0),n.isLastMessageRevoked({sequence:e.sequence,time:e.time})&&(n.setLastMessageRevoked(!0),n.setLastMessageRevoker(e.revoker),o=!0)));}),this.getModule(wn).onMessageRevoked(s),o&&(this.emitConversationUpdate(!0,!1),this.emitTotalUnreadMessageCountUpdate());}}},{key:"isLastMessageRevoked",value:function value(e){var t=!1,n=e.conversationID,o=e.sequence,s=e.time,a=this._conversationMap.get(n);a&&(t=a.type===S.CONV_TOPIC?this.getModule(wn).isLastMessageRevoked({topicID:n.replace(S.CONV_GROUP,""),sequence:o}):a.isLastMessageRevoked({sequence:o,time:s}));return xe.l("".concat(this._n,".isLastMessageRevoked options:").concat(JSON.stringify(e)," ret:").concat(t)),t;}},{key:"onMessageDeleted",value:function value(e){var t=this;if(0!==e.length){var n=null;e.forEach(function(e){(n=t._messageListHandler.getLocalMessage(e.conversationID,e.ID))&&(n.isDeleted=!0),e!==n&&(e.isDeleted=!0);});for(var o=e[0].conversationID,s=this._messageListHandler.getLocalMessageList(o),a={},r=s.length-1;r>=0;r--){if(!s[r].isDeleted){a=s[r];break;}}var i=this._conversationMap.get(o);if(i){var u=!1;i.lastMessage.lastSequence===a.sequence&&i.lastMessage.lastTime===a.time||(jt(a)&&(a=void 0),i.updateLastMessage(a),i.type!==S.CONV_TOPIC&&(u=!0),xe.l("".concat(this._n,".onMessageDeleted. update conversationID:").concat(o," with lastMessage:"),i.lastMessage)),o.startsWith(S.CONV_C2C)&&this.updateUnreadCount(o),u&&this.emitConversationUpdate(!0,!1);}}}},{key:"onMessageModified",value:function value(e){var t=e.conversationType,n=e.from,o=e.to,s=e.time,a=e.sequence,r=e.elements,i=e.cloudCustomData,u=e.messageVersion,c=this.getMyUserID(),l="".concat(t).concat(o);o===c&&t===S.CONV_C2C&&(l="".concat(t).concat(n));var p=this._messageListHandler.onMessageModified(l,e),d=p.isUpdated,g=p.message;!0===d&&this.emitOuterEvent(E.MESSAGE_MODIFIED,[g]);var _=this._isTopicConversation(l);if(xe.l("".concat(this._n,".onMessageModified isUpdated:").concat(d," isTopicMessage:").concat(_," from:").concat(n," to:").concat(o)),_){this.getModule(wn).onMessageModified(e);}else{var h=this._conversationMap.get(l);if(h){var f=h.lastMessage;xe.d("".concat(this._n.onMessageModified," lastMessage:"),JSON.stringify(f),"options:",JSON.stringify(e)),f&&f.lastTime===s&&f.lastSequence===a&&f.version!==u&&(f.type=r[0].type,f.payload=r[0].content,f.messageForShow=xt(f.type,f.payload,this.isIntl()),f.cloudCustomData=i,f.version=u,this.emitConversationUpdate(!0,!1));}}return g;}},{key:"onNewGroupAtTips",value:function value(e){var n=this,o=e.dataList,s=null;o.forEach(function(e){e.groupAtTips?s=e.groupAtTips:e.elements?s=t(t({},e.elements),{},{sync:!0}):e.groupAtType&&(s=t(t({},e),{},{sync:!0})),s.__random=e.random,s.__sequence=e.clientSequence,n._tmpGroupAtTipsList.push(s);}),xe.d("".concat(this._n,".onNewGroupAtTips isReady:").concat(this._isReady),this._tmpGroupAtTipsList),this._isReady&&this._handleGroupAtTipsList();}},{key:"_handleGroupAtTipsList",value:function value(){var e=this;if(0!==this._tmpGroupAtTipsList.length){var t=!1;this._tmpGroupAtTipsList.forEach(function(n){var o=n.groupID,s=n.from,a=n.topicID,r=void 0===a?void 0:a,i=n.sync,u=void 0!==i&&i;if(s!==e.getMyUserID())if(at(r)){var c=e._conversationMap.get("".concat(S.CONV_GROUP).concat(o));c&&(c.updateGroupAtInfoList(n),t=!0);}else{var l=e._conversationMap.get("".concat(S.CONV_GROUP).concat(r));if(l){l.updateGroupAtInfoList(n);var p=e.getModule(wn),d=l.groupAtInfoList;p.onConversationProxy({topicID:r,groupAtInfoList:d});}if(jt(l)&&u)e.updateTopicConversation([{conversationID:"".concat(S.CONV_GROUP).concat(r),type:S.CONV_TOPIC}]),e._conversationMap.get("".concat(S.CONV_GROUP).concat(r)).updateGroupAtInfoList(n);}}),t&&this.emitConversationUpdate(!0,!1),this._tmpGroupAtTipsList.length=0;}}},{key:"_getC2CPeerReadTime",value:function value(e){var t=this,n=[];if(e.forEach(function(e){t._conversationMap.has(e.conversationID)||e.type!==S.CONV_C2C||n.push(e.conversationID.replace(S.CONV_C2C,""));}),n.length>0){xe.d("".concat(this._n,"._getC2CPeerReadTime userIDList:").concat(n));var o=this.getModule(Gn);o&&o.getRemotePeerReadTime(n);}}},{key:"_getStorageConversationList",value:function value(){return this.getModule(xn).getItem("conversationMap");}},{key:"_setStorageConversationList",value:function value(){var e=this.getLocalConversationList().filter(function(e){return e.type===S.CONV_C2C||e.type===S.CONV_GROUP&&e.lastMessage.type!==S.MSG_GRP_TIP;}).slice(0,20).map(function(e){return{conversationID:e.conversationID,type:e.type,subType:e.subType,lastMessage:e.lastMessage,groupProfile:e.groupProfile,userProfile:e.userProfile};});this.getModule(xn).setItem("conversationMap",e);}},{key:"emitConversationUpdate",value:function value(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=this.getLocalConversationList();if(t){var o=this.getModule(Un);o&&o.updateGroupLastMessage(n);}e&&this.emitOuterEvent(E.CONVERSATION_LIST_UPDATED);}},{key:"getLocalConversationList",value:function value(){return m(this._conversationMap.values()).filter(function(e){return e.type!==S.CONV_TOPIC;});}},{key:"getLocalConversation",value:function value(e){return this._conversationMap.get(e);}},{key:"hasLocalConversation",value:function value(e){return this._conversationMap.has(e);}},{key:"getLocalOldestMessage",value:function value(e){return this._messageListHandler.getLocalOldestMessage(e);}},{key:"syncConversationList",value:function value(){var e=this,t=new ka("syncConversationList");return this._pagingStatus===Zt.NOT_START&&this._conversationMap.clear(),this._pagingGetConversationList().then(function(n){var o=function(e){if(st(e)&&0!==e.length){var t=0;return e.forEach(function(e){t+=e;}),(t/e.length).toFixed(0);}}(e._pagingGetCostList);return xe.l("".concat(e._n,".").concat("syncConversationList",". sum ").concat(function(e){if(st(e)&&0!==e.length){var t=0;return e.forEach(function(e){t+=e;}),t.toFixed(0);}}(e._pagingGetCostList)," ms, average ").concat(o," ms")),e._pagingGetCostList.length=0,e._pagingStatus=Zt.RESOLVED,e._diffAndDeleteConversation(),e.emitConversationUpdate(!0,!1),e._setStorageConversationList(),e._handleC2CPeerReadTime(),e._patchConversationProperties(),t.setMessage(e._conversationMap.size).setMoreMessage(o).setNetworkType(e.getNetworkType()).end(),n;}).catch(function(n){return e._pagingStatus=Zt.REJECTED,t.setMessage(e._pagingTimeStamp),e.probeNetwork().then(function(e){var o=v(e,2),s=o[0],a=o[1];t.setError(n,s,a).end();}),Ja(n);});}},{key:"_diffAndDeleteConversation",value:function value(){var e=this;if(this._isSyncCompleted()){var t=[];this._conversationMap.forEach(function(n,o){!e._pagingConvIDMap.has(o)&&e._convIDFromUnreadDBMap.has(o)&&(e._conversationMap.delete(o),t.push(o));}),xe.l("".concat(this._n,"._diffAndDeleteConversation list:").concat(t));}}},{key:"_patchConversationProperties",value:function value(){var e=this,t=Date.now(),n=this.checkAndPatchRemark(),o=this._messageRemindHandler.getC2CMessageRemindType(),s=this.getModule(Un).getGroupList();Promise.all([n,o,s]).then(function(){var n=Date.now()-t;xe.l("".concat(e._n,"._patchConversationProperties ok. cost ").concat(n," ms")),e.emitConversationUpdate(!0,!1),e.emitTotalUnreadMessageCountUpdate();});}},{key:"_pagingGetConversationList",value:function value(){var e=this,t="".concat(this._n,"._pagingGetConversationList");xe.l("".concat(t," timeStamp:").concat(this._pagingTimeStamp," startIndex:").concat(this._pagingStartIndex)+" pinnedTimeStamp:".concat(this._pagingPinnedTimeStamp," pinnedStartIndex:").concat(this._pagingPinnedStartIndex));var n=Date.now();return this._pagingStatus=Zt.PENDING,this.request({protocolName:No,requestData:{fromAccount:this.getMyUserID(),timeStamp:this._pagingTimeStamp,startIndex:this._pagingStartIndex,pinnedTimeStamp:this._pagingPinnedTimeStamp,pinnedStartIndex:this._pagingPinnedStartIndex,orderType:1}}).then(function(o){var s=o.data,a=s.completeFlag,r=s.conversations,i=void 0===r?[]:r,u=s.timeStamp,c=s.startIndex,l=s.pinnedTimeStamp,p=s.pinnedStartIndex,d=s.groupItem,g=Date.now()-n;if(e._pagingGetCostList.push(g),xe.l("".concat(t," ok. completeFlag:").concat(a," count:").concat(i.length," cost ").concat(g," ms")),e._convGroupHandler.onConvGroupListSynced(d),i.length>0){var _=e._getConversationOptions(i);e._pagingConvIDMap=new Map([].concat(m(e._pagingConvIDMap),m(_.map(function(e){return[e.conversationID,1];})))),e._updateLocalConversationList({conversationOptionsList:_,isFromGetConversations:!0}),e.isLoggedIn()&&e.emitConversationUpdate();}if(!e._isReady){if(!e.isLoggedIn())return za();e.triggerReady();}return e._pagingTimeStamp=u,e._pagingStartIndex=c,e._pagingPinnedTimeStamp=l,e._pagingPinnedStartIndex=p,1!==a?e._pagingGetConversationList():(e._handleGroupAtTipsList(),e._convGroupHandler.getRemoteConvGroupList(),za());}).catch(function(n){throw e.isLoggedIn()&&(e._isReady||(xe.w("".concat(t," failed. error:"),n),e.triggerReady())),n;});}},{key:"_updateLocalConversationList",value:function value(e){var t,n=e.isFromGetConversations,o=e.isInstantMessage,s=Date.now();t=this._getTmpConversationListMapping(e),this._conversationMap=new Map(this._sortConversationList([].concat(m(t.toBeUpdatedConversationList),m(this._conversationMap)))),n||(this._updateUserOrGroupProfile(t.newConversationList),o&&this.emitTotalUnreadMessageCountUpdate()),xe.d("".concat(this._n,"._updateLocalConversationList cost ").concat(Date.now()-s," ms"));}},{key:"_getTmpConversationListMapping",value:function value(e){for(var t=e.conversationOptionsList,n=e.isFromGetConversations,o=e.isInstantMessage,s=e.isUnreadC2CMessage,a=void 0!==s&&s,r=e.updateUnreadCount,i=[],u=[],c=this.getModule(Un),l=this.getModule(Pn),p=this.isIntl(),d=0,g=t.length;d<g;d++){var _=new _r(t[d],p),h=_.conversationID;if(h!=="".concat(S.CONV_C2C,"@TLS#ERROR")&&h!=="".concat(S.CONV_C2C,"@TLS#NOT_FOUND"))if(this._conversationMap.has(h)){var f=this._conversationMap.get(h),v=["unreadCount","allowType","adminForbidType","payload","isPinned"];!1===o&&v.push("lastMessage");var m=t[d].lastMessage,M=!at(m);M||t[d].type===S.CONV_TOPIC||this._onLastMessageNotExist(t[d]),at(o)&&M&&null===f.lastMessage.payload&&(f.lastMessage.payload=m.payload),jt(f.lastMessage.revoker)||(f.lastMessage.revoker=null),pt(f,_,v,[null,void 0,"",0,NaN]),!0===r&&f.updateUnreadCount({nextUnreadCount:_.unreadCount,isFromGetConversations:n,isUnreadC2CMessage:a}),o&&M&&(m.payload&&(f.lastMessage.payload=m.payload),f.type===S.CONV_GROUP&&(f.lastMessage.nameCard=m.nameCard,f.lastMessage.nick=m.nick)),M&&f.lastMessage.cloudCustomData!==m.cloudCustomData&&(f.lastMessage.cloudCustomData=m.cloudCustomData||""),this._conversationMap.delete(h),i.push([h,f]);}else{if(_.type===S.CONV_GROUP&&c){var y=_.groupProfile.groupID,I=c.getLocalGroupProfile(y);I&&(_.groupProfile=I,!0===r&&_.updateUnreadCount({nextUnreadCount:0}));}else if(_.type===S.CONV_C2C){var C=h.replace(S.CONV_C2C,"");l&&l.isMyFriend(C)&&(_.remark=l.getFriendRemark(C));}u.push(_),i.push([h,_]);}}var T=this.getModule(wn);return i.forEach(function(e){if(e[1].type===S.CONV_TOPIC){var t=e[1],n=t.conversationID,o=t.unreadCount,s=t.groupAtInfoList;T.onConversationProxy({topicID:n.replace(S.CONV_GROUP,""),unreadCount:o,groupAtInfoList:jt(s)?void 0:s});}}),{toBeUpdatedConversationList:i,newConversationList:u};}},{key:"_onLastMessageNotExist",value:function value(e){new ka("lastMessageNotExist").setMessage("".concat(JSON.stringify(e))).setNetworkType(this.getNetworkType()).end();}},{key:"_sortConversationList",value:function value(e){var t=[],n=[],o=[],s=[];return e.forEach(function(e){!0===e[1].isPinned?jt(e[1].lastMessage.lastTime)?n.push(e):t.push(e):jt(e[1].lastMessage.lastTime)?s.push(e):o.push(e);}),t.sort(function(e,t){return t[1].lastMessage.lastTime-e[1].lastMessage.lastTime;}).concat(n).concat(o.sort(function(e,t){return t[1].lastMessage.lastTime-e[1].lastMessage.lastTime;})).concat(s);}},{key:"_sortConversationListAndEmitEvent",value:function value(){this._conversationMap=new Map(this._sortConversationList(m(this._conversationMap))),this.emitConversationUpdate(!0,!1);}},{key:"_updateUserOrGroupProfile",value:function value(e){var t=this;if(0!==e.length){var n=[],o=[],s=this.getModule(On),a=this.getModule(Un);e.forEach(function(e){if(e.type===S.CONV_C2C)n.push(e.toAccount);else if(e.type===S.CONV_GROUP){var t=e.toAccount;a.hasLocalGroup(t)?e.groupProfile=a.getLocalGroupProfile(t):o.push(t);}}),xe.l("".concat(this._n,"._updateUserOrGroupProfile c2cUserIDList:").concat(n," groupIDList:").concat(o)),n.length>0&&s.getUserProfile({userIDList:n}).then(function(e){var n=e.data;st(n)?n.forEach(function(e){t._doUpdateUserProfile("C2C".concat(e.userID),e);}):t._doUpdateUserProfile("C2C".concat(n.userID),n);}),o.length>0&&a.getGroupProfileAdvance({groupIDList:o,responseFilter:{groupBaseInfoFilter:["Type","Name","FaceUrl"]}}).then(function(e){e.data.successGroupList.forEach(function(e){var n="GROUP".concat(e.groupID);if(t._conversationMap.has(n)){var o=t._conversationMap.get(n);pt(o.groupProfile,e,[],[null,void 0,"",0,NaN]),!o.subType&&e.type&&(o.subType=e.type);}});});}}},{key:"_doUpdateUserProfile",value:function value(e,t){this.hasLocalConversation(e)&&(this.getLocalConversation(e).userProfile=t);}},{key:"_getConversationOptions",value:function value(e){var n=this,o=[],s=e.filter(function(e){var t=e.type,n=e.userID;return 1===t&&"@TLS#NOT_FOUND"!==n&&"@TLS#ERROR"!==n||2===t;}),a=this.getMyUserID(),r=s.map(function(e){if(at(e.lastMsg)&&(e.lastMsg={elements:[]}),1===e.type){var s={userID:e.userID,nick:e.peerNick,avatar:e.peerAvatar};return o.push(s),{conversationID:"C2C".concat(e.userID),type:"C2C",lastMessage:{lastTime:e.time,lastSequence:e.sequence,fromAccount:e.lastC2CMsgFromAccount,messageForShow:e.messageShow,type:e.lastMsg.elements[0]?e.lastMsg.elements[0].type:null,payload:e.lastMsg.elements[0]?n._amendLayersOverLimitProperty(e.lastMsg.elements[0].content):null,cloudCustomData:e.lastMsg.cloudCustomData||"",isRevoked:8===e.lastMessageFlag,onlineOnlyFlag:!1,nick:"",nameCard:"",version:0,isPeerRead:e.lastC2CMsgFromAccount===a&&e.time<=e.c2cPeerReadTime,revoker:e.lastMsg.revokerInfo?e.lastMsg.revokerInfo.revoker:null},userProfile:new ur(s),peerReadTime:e.c2cPeerReadTime,isPinned:1===e.isPinned,messageRemindType:"",customData:e.customMark||"",markList:Bt(e.standardMark),conversationGroupList:n._convGroupHandler.getConvGroupListByID(e.contactGroupId)};}return{conversationID:"GROUP".concat(e.groupID),type:"GROUP",lastMessage:t(t({lastTime:e.time,lastSequence:e.sequence,fromAccount:e.msgGroupFromAccount,messageForShow:e.messageShow},n._patchTypeAndPayload(e)),{},{cloudCustomData:e.lastMsg.cloudCustomData||"",isRevoked:2===e.lastMessageFlag,onlineOnlyFlag:!1,nick:e.senderNick||"",nameCard:e.senderNameCard||"",revoker:e.lastMsg.revokerInfo?e.lastMsg.revokerInfo.revoker:null}),groupProfile:new dr({groupID:e.groupID,name:e.groupNick,avatar:e.groupImage}),unreadCount:e.unreadCount,peerReadTime:0,isPinned:1===e.isPinned,messageRemindType:"",version:0,customData:e.customMark||"",markList:Bt(e.standardMark),conversationGroupList:n._convGroupHandler.getConvGroupListByID(e.contactGroupId)};});o.length>0&&this.getModule(On).onConversationsProfileUpdated(o);return r;}},{key:"_patchTypeAndPayload",value:function value(e){var n=e.lastMsg,o=n.event,s=void 0===o?void 0:o,a=n.elements,r=void 0===a?[]:a,i=n.groupTips,u=void 0===i?{}:i;if(!at(s)&&!jt(u)){var c=new Ha(u);c.setElement({type:S.MSG_GRP_TIP,content:t(t({},u.elements),{},{groupProfile:u.groupProfile})});var l=JSON.parse(JSON.stringify(c.payload));return c=null,{type:S.MSG_GRP_TIP,payload:l};}return{type:r[0]?r[0].type:null,payload:r[0]?this._amendLayersOverLimitProperty(r[0].content):null};}},{key:"_amendLayersOverLimitProperty",value:function value(e){var t=e.layersOverLimit;return 0===t?e.layersOverLimit=!1:1===t&&(e.layersOverLimit=!0),e;}},{key:"getLocalMessageList",value:function value(e){return this._messageListHandler.getLocalMessageList(e);}},{key:"deleteLocalMessage",value:function value(e){e instanceof Ha&&this._messageListHandler.remove(e);}},{key:"onConversationDeleted",value:function value(e){if(st(e)){var t=e.map(function(e){var t=e.type,n=e.userID,o=e.groupID;return 1===t?"".concat(S.CONV_C2C).concat(n):2===t?"".concat(S.CONV_GROUP).concat(o):void 0;});xe.l("".concat(this._n,".onConversationDeleted conversationIDList:").concat(t)),this.deleteLocalConversationList(t);}}},{key:"onConversationPinned",value:function value(e){var t=this;if(st(e)){var n=!1;e.forEach(function(e){var o,s=e.type,a=e.userID,r=e.groupID;1===s?o=t.getLocalConversation("".concat(S.CONV_C2C).concat(a)):2===s&&(o=t.getLocalConversation("".concat(S.CONV_GROUP).concat(r))),o&&(xe.l("".concat(t._n,".onConversationPinned conversationID:").concat(o.conversationID," isPinned:").concat(o.isPinned)),o.isPinned||(o.isPinned=!0,n=!0));}),n&&this._sortConversationListAndEmitEvent();}}},{key:"onConversationUnpinned",value:function value(e){var t=this;if(st(e)){var n=!1;e.forEach(function(e){var o,s=e.type,a=e.userID,r=e.groupID;1===s?o=t.getLocalConversation("".concat(S.CONV_C2C).concat(a)):2===s&&(o=t.getLocalConversation("".concat(S.CONV_GROUP).concat(r))),o&&(xe.l("".concat(t._n,".onConversationUnpinned conversationID:").concat(o.conversationID," isPinned:").concat(o.isPinned)),o.isPinned&&(o.isPinned=!1,n=!0));}),n&&this._sortConversationListAndEmitEvent();}}},{key:"getMessageList",value:function value(e){var t=this,n=e.conversationID,o=e.nextReqMessageID,s=e.count,a="".concat(this._n,".getMessageList"),r=this.getLocalConversation(n),i="";if(r&&r.groupProfile&&(i=r.groupProfile.type),Ct(i))return xe.l("".concat(a," not available in avchatroom. conversationID:").concat(n)),za({messageList:[],nextReqMessageID:"",isCompleted:!0});(at(s)||s>15)&&(s=15),!o&&this._isNotInCommunity(n)&&(this._messageListHandler.removeByConversationID(n),this._completedMap.delete(n),this._roamingMessageSequenceMap.delete(n));var u=this._computeRemainingCount({conversationID:n,nextReqMessageID:o}),c=this._completedMap.has(n);if(xe.l("".concat(a," conversationID:").concat(n," nextReqMessageID:").concat(o)+" remainingCount:".concat(u," count:").concat(s," isCompleted:").concat(c)),this._needGetHistory({conversationID:n,remainingCount:u,count:s}))return this.getHistoryMessages({conversationID:n,nextReqMessageID:o,count:20}).then(function(e){var o=e.nextReqID,s=e.storedMessageList,r=t._completedMap.has(n),i=s;u>0&&(i=t._messageListHandler.getLocalMessageList(n).slice(0,s.length+u));var c={nextReqMessageID:r?"":o,messageList:i,isCompleted:r};return xe.l("".concat(a," ret.nextReqMessageID:").concat(c.nextReqMessageID," ret.isCompleted:").concat(c.isCompleted," ret.length:").concat(i.length)),Ka(c);});this.modifyMessageList(n);var l=this._getMessageListFromMemory({conversationID:n,nextReqMessageID:o,count:s});return za(l);}},{key:"_getMessageListFromMemory",value:function value(e){var t=e.conversationID,n=e.nextReqMessageID,o=e.count,s="".concat(this._n,"._getMessageListFromMemory"),a=this._messageListHandler.getLocalMessageList(t),r=a.length,i=0,u={isCompleted:!1,nextReqMessageID:"",messageList:[]};return n?(i=a.findIndex(function(e){return e.ID===n;}))>o?(u.messageList=a.slice(i-o,i),u.nextReqMessageID=a[i-o].ID):(u.messageList=a.slice(0,i),u.isCompleted=!0):r>o?(i=r-o,u.messageList=a.slice(i,r),u.nextReqMessageID=a[i].ID):(u.messageList=a.slice(0,r),u.isCompleted=!0),xe.l("".concat(s," conversationID:").concat(t)+" ret.nextReqMessageID:".concat(u.nextReqMessageID," ret.isCompleted:").concat(u.isCompleted," ret.length:").concat(u.messageList.length)),u;}},{key:"getMessageListHopping",value:function value(e){var t=e.conversationID,n=e.sequence,o=e.time,s=e.count,a=e.direction,r=void 0===a?0:a;if((at(s)||s>15)&&(s=15),t.startsWith(S.CONV_C2C)){var i=this.getModule(Gn),u=t.replace(S.CONV_C2C,"");return i.getRoamingMessagesHopping({peerAccount:u,time:o,count:s,direction:r});}if(t.startsWith(S.CONV_GROUP)){var c=this.getModule(Un),l=t.replace(S.CONV_GROUP,"");return c.getRoamingMessagesHopping({groupID:l,sequence:n,count:s,direction:r});}}},{key:"_computeRemainingCount",value:function value(e){var t=e.conversationID,n=e.nextReqMessageID,o=this._messageListHandler.getLocalMessageList(t),s=o.length;if(!n)return s;var a=0;return Et(t)?a=o.findIndex(function(e){return e.ID===n;}):St(t)&&(a=-1!==n.indexOf("-")?o.findIndex(function(e){return e.ID===n;}):o.findIndex(function(e){return e.sequence===n;})),-1===a&&(a=0),a;}},{key:"_getMessageListSize",value:function value(e){return this._messageListHandler.getLocalMessageList(e).length;}},{key:"_needGetHistory",value:function value(e){var t=e.conversationID,n=e.remainingCount,o=e.count,s=this.getLocalConversation(t),a="";return s&&s.groupProfile&&(a=s.groupProfile.type),!kt(t)&&!Ct(a)&&!(St(t)&&this._isPagingGetGroupListCompleted()&&this._getLocalGroupCount()<=4e3&&!this._hasLocalGroup(t)&&!this._isTopicConversation(t))&&n<=o&&!this._completedMap.has(t);}},{key:"_isTopicConversation",value:function value(e){var t=e.replace(S.CONV_GROUP,"");return Dt(t);}},{key:"getHistoryMessages",value:function value(e){var t=e.conversationID,n=e.count;if(t===S.CONV_SYSTEM)return za();var o=15;n>20&&(o=20);var s=null;if(Et(t)){var a=this._roamingMessageKeyAndTimeMap.has(t);return(s=this.getModule(Gn))?s.getRoamingMessage({conversationID:t,peerAccount:t.replace(S.CONV_C2C,""),count:o,lastMessageTime:a?this._roamingMessageKeyAndTimeMap.get(t).lastMessageTime:0,messageKey:a?this._roamingMessageKeyAndTimeMap.get(t).messageKey:""}):Ja({code:da.CANNOT_FIND_MODULE});}if(St(t)){if(!(s=this.getModule(Un)))return Ja({code:da.CANNOT_FIND_MODULE});var r=null;this._conversationMap.has(t)&&(r=this._conversationMap.get(t).lastMessage);var i=0;r&&(i=r.lastSequence);var u=this._roamingMessageSequenceMap.get(t);return s.getRoamingMessage({conversationID:t,groupID:t.replace(S.CONV_GROUP,""),count:o,sequence:u||i});}return za();}},{key:"patchConversationLastMessage",value:function value(e){var t=this.getLocalConversation(e);if(t){var n=t.lastMessage,o=n.messageForShow,s=n.payload;if(jt(o)||jt(s)){var a=this._messageListHandler.getLocalMessageList(e);if(0===a.length)return;var r=a[a.length-1];xe.l("".concat(this._n,".patchConversationLastMessage conversationID:").concat(e," payload:"),r.payload),t.updateLastMessage(r);}}}},{key:"onRoamingMessage",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1?arguments[1]:void 0,o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],s=n.startsWith(S.CONV_C2C)?S.CONV_C2C:S.CONV_GROUP,a=null,r=[],i=[],u=0,c=e.length,l=null,p=s===S.CONV_GROUP,d=this.getModule(Hn),g=this.getFileDownloadProxy(),_=function _(){u=p?e.length-1:0,c=p?0:e.length;},h=function h(){p?--u:++u;},f=function f(){return p?u>=c:u<c;};for(_();f();h()){if(p&&1===e[u].sequence&&o&&this.setCompleted(n),1!==e[u].isPlaceMessage)if((a=new Ha(e[u])).to=e[u].to,s!==S.CONV_GROUP||at(e[u].topicID)||(a.to=e[u].topicID),a.isSystemMessage=!!e[u].isSystemMessage,a.conversationType=s,4===e[u].event?l={type:S.MSG_GRP_TIP,content:t(t({},e[u].elements),{},{groupProfile:e[u].groupProfile})}:(e[u].elements=d.parseElements(e[u].elements,e[u].from),l=e[u].elements),p||a.setNickAndAvatar({nick:e[u].nick,avatar:e[u].avatar}),jt(l)){var v=new ka("emptyMessageBody");v.setMessage("from:".concat(a.from," to:").concat(a.to," sequence:").concat(a.sequence," event:").concat(e[u].event)),v.setNetworkType(this.getNetworkType()).setLevel("warning").end();}else a.setElement(l,g),a.reInitialize(this.getMyUserID()),r.push(a);}return _=h=f=null,o?(this._messageListHandler.unshift(r,i),r=null,i):(i=null,r);}},{key:"findMessage",value:function value(e){return this._messageListHandler.findMessage(e);}},{key:"_isNotInCommunity",value:function value(e){var t=!1;if(e.startsWith(S.CONV_GROUP)&&this._isTopicConversation(e)){var n=qt(e.replace(S.CONV_GROUP,""));this.getModule(Un).hasLocalGroup(n)||(t=!0);}return t;}},{key:"deleteTopicRoamingMessageInfo",value:function value(e){var t=this;Tt({groupID:e})&&this._messageListHandler.getTopicConversationIDList(e).forEach(function(e){t._messageListHandler.removeByConversationID(e),t._completedMap.delete(e),t._roamingMessageSequenceMap.delete(e);});}},{key:"deleteGroupRomaingMessageInfo",value:function value(e){var t="".concat(S.CONV_GROUP).concat(e);this._messageListHandler.removeByConversationID(t),this._completedMap.delete(t),this._roamingMessageSequenceMap.delete(t);}},{key:"setMessageRead",value:function value(e){var t=e.conversationID,n=this.getLocalConversation(t);if(xe.l("".concat(this._n,".setMessageRead conversationID:").concat(t," unreadCount:").concat(n?n.unreadCount:0)),!n)return za();if(n.type!==S.CONV_GROUP&&n.type!==S.CONV_TOPIC||jt(n.groupAtInfoList)||this.deleteGroupAtTips(t),0===n.unreadCount)return za();if(n.type===S.CONV_GROUP&&!this._hasLocalGroup(t))return 0!==n.unreadCount&&(n.unreadCount=0,this.emitConversationUpdate(!0,!1)),za();var o=this._messageListHandler.getLocalLastMessage(t),s=n.lastMessage.lastTime;o&&s<o.time&&(s=o.time);var a=n.lastMessage.lastSequence;if(o&&a<o.sequence&&(a=o.sequence),n.type===S.CONV_TOPIC&&at(o)){var r=this.getModule(wn),i=t.replace(S.CONV_GROUP,""),u=qt(i),c=r.getLocalTopic(u,i);c&&(a=c.nextMessageSeq-1);}var l=null;switch(n.type){case S.CONV_C2C:return(l=this.getModule(Gn))?l.setMessageRead({conversationID:t,lastMessageTime:s}):Ja({code:da.CANNOT_FIND_MODULE});case S.CONV_GROUP:case S.CONV_TOPIC:return(l=this.getModule(Un))?l.setMessageRead({conversationID:t,lastMessageSeq:a}):Ja({code:da.CANNOT_FIND_MODULE});case S.CONV_SYSTEM:return n.unreadCount=0,this.emitConversationUpdate(!0,!1),za();default:return za();}}},{key:"setAllMessageRead",value:function value(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n="setAllMessageRead",o="".concat(this._n,".").concat(n);t.scope||(t.scope=S.READ_ALL_MSG),xe.l("".concat(o," options:"),t);var s=this._createSetAllMessageReadPack(t);if(0===s.readAllC2CMessage&&0===s.groupMessageReadInfoList.length)return za();var a=new ka(n);return this.request({protocolName:rs,requestData:s}).then(function(n){var o=n.data,s=e._handleAllMessageRead(o);return a.setMessage("scope:".concat(t.scope," failureGroups:").concat(JSON.stringify(s))).setNetworkType(e.getNetworkType()).end(),za();}).catch(function(t){return e.probeNetwork().then(function(e){var n=v(e,2),o=n[0],s=n[1];a.setError(t,o,s).end();}),xe.w("".concat(o," failed. error:"),t),Ja({code:t&&t.code?t.code:da.MESSAGE_UNREAD_ALL_FAIL,message:t&&t.message?t.message:void 0});});}},{key:"setConversationCustomData",value:function value(e){return this._convGroupHandler.setConvCustomData(e);}},{key:"markConversation",value:function value(e){return this._convGroupHandler.markConversation(e);}},{key:"getConversationGroupList",value:function value(){return this._convGroupHandler.getLocalConvGroupList();}},{key:"createConversationGroup",value:function value(e){return this._convGroupHandler.createConvGroup(e);}},{key:"deleteConversationGroup",value:function value(e){return this._convGroupHandler.deleteConvGroup(e);}},{key:"renameConversationGroup",value:function value(e){return this._convGroupHandler.renameConvGroup(e);}},{key:"addConversationsToGroup",value:function value(e){return this._convGroupHandler.addConvsToGroup(e);}},{key:"deleteConversationsFromGroup",value:function value(e){return this._convGroupHandler.deleteConvsFromGroup(e);}},{key:"onConversationMarkUpdated",value:function value(e){this._convGroupHandler.onConvMarkUpdated(e);}},{key:"onConversationGroupCreated",value:function value(e){this._convGroupHandler.onConvGroupCreated(e);}},{key:"onConversationGroupDeleted",value:function value(e){this._convGroupHandler.onConvGroupDeleted(e);}},{key:"onConversationGroupNameUpdated",value:function value(e){this._convGroupHandler.onConvGroupNameUpdated(e);}},{key:"onConversationInGroupUpdated",value:function value(e){this._convGroupHandler.onConvInGroupUpdated(e);}},{key:"onConversationAddedToOrDeletedFromGroup",value:function value(e){this._convGroupHandler.onConvAddedToOrDeletedFromGroup(e);}},{key:"_getConversationLastMessageSequence",value:function value(e){var t=this._messageListHandler.getLocalLastMessage(e.conversationID),n=e.lastMessage.lastSequence;return t&&n<t.sequence&&(n=t.sequence),n;}},{key:"_getConversationLastMessageTime",value:function value(e){var t=this._messageListHandler.getLocalLastMessage(e.conversationID),n=e.lastMessage.lastTime;return t&&n<t.time&&(n=t.time),n;}},{key:"_createSetAllMessageReadPack",value:function value(e){var t,n={readAllC2CMessage:0,groupMessageReadInfoList:[]},o=e.scope,s=D(this._conversationMap);try{for(s.s();!(t=s.n()).done;){var a=v(t.value,2)[1];if(a.unreadCount>0)if(a.type===S.CONV_C2C&&0===n.readAllC2CMessage){if(o===S.READ_ALL_MSG)n.readAllC2CMessage=1;else if(o===S.READ_ALL_C2C_MSG){n.readAllC2CMessage=1;break;}}else if(a.type===S.CONV_GROUP&&(o===S.READ_ALL_GROUP_MSG||o===S.READ_ALL_MSG)){var r=this._getConversationLastMessageSequence(a);n.groupMessageReadInfoList.push({groupID:a.groupProfile.groupID,messageSequence:r});}}}catch(i){s.e(i);}finally{s.f();}return n;}},{key:"onPushedAllMessageRead",value:function value(e){this._handleAllMessageRead(e);}},{key:"_handleAllMessageRead",value:function value(e){var t=e.groupMessageReadInfoList,n=e.readAllC2CMessage,o=this._parseGroupReadInfo(t);return this._updateAllConversationUnreadCount({readAllC2CMessage:n})>=1&&(this.emitConversationUpdate(!0,!1),this.emitTotalUnreadMessageCountUpdate()),o;}},{key:"_parseGroupReadInfo",value:function value(e){var t=[];if(e&&e.length)for(var n=0,o=e.length;n<o;n++){var s=e[n],a=s.groupID,r=s.sequence,i=s.retCode,u=s.lastMessageSeq;at(i)?this._remoteGroupReadSequenceMap.set(a,u):(this._remoteGroupReadSequenceMap.set(a,r),0!==i&&t.push("".concat(a,"-").concat(r,"-").concat(i)));}return t;}},{key:"_updateAllConversationUnreadCount",value:function value(e){var t,n=e.readAllC2CMessage,o=0,s=D(this._conversationMap);try{for(s.s();!(t=s.n()).done;){var a=v(t.value,2),r=a[0],i=a[1];if(i.unreadCount>=1){if(1===n&&i.type===S.CONV_C2C){var u=this._getConversationLastMessageTime(i);this.updateIsReadAfterReadReport({conversationID:r,lastMessageTime:u});}else if(i.type===S.CONV_GROUP){var c=r.replace(S.CONV_GROUP,"");if(this._remoteGroupReadSequenceMap.has(c)){var l=this._remoteGroupReadSequenceMap.get(c),p=this._getConversationLastMessageSequence(i);this.updateIsReadAfterReadReport({conversationID:r,remoteReadSequence:l}),p>=l&&this._remoteGroupReadSequenceMap.delete(c);}}this.updateUnreadCount(r,!1)&&(o+=1);}}}catch(d){s.e(d);}finally{s.f();}return o;}},{key:"isRemoteRead",value:function value(e){var t=e.conversationID,n=e.sequence,o=t.replace(S.CONV_GROUP,""),s=!1;if(this._remoteGroupReadSequenceMap.has(o)){var a=this._remoteGroupReadSequenceMap.get(o);n<=a&&(s=!0,xe.l("".concat(this._n,".isRemoteRead conversationID:").concat(t," messageSequence:").concat(n," remoteReadSequence:").concat(a))),n>=a+10&&this._remoteGroupReadSequenceMap.delete(o);}return s;}},{key:"updateIsReadAfterReadReport",value:function value(e){var t=e.conversationID,n=e.lastMessageSeq,o=e.lastMessageTime,s=this._messageListHandler.getLocalMessageList(t);if(0!==s.length)for(var a,r=s.length-1;r>=0;r--){if(a=s[r],!(o&&a.time>o||n&&a.sequence>n)){if("in"===a.flow&&a.isRead)break;a.setIsRead(!0);}}}},{key:"updateUnreadCount",value:function value(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=!1,o=this.getLocalConversation(e),s=this._messageListHandler.getLocalMessageList(e);if(o){var a=o.unreadCount,r=s.filter(function(e){return!e.isRead&&!e._onlineOnlyFlag&&!e.isDeleted;}).length;if(a!==r&&(o.unreadCount=r,n=!0,xe.l("".concat(this._n,".updateUnreadCount from ").concat(a," to ").concat(r,", conversationID:").concat(e)),!0===t&&(this.emitConversationUpdate(!0,!1),this.emitTotalUnreadMessageCountUpdate())),n&&o.type===S.CONV_TOPIC){var i=o.unreadCount,u=this.getModule(wn),c=e.replace(S.CONV_GROUP,"");u.onConversationProxy({topicID:c,unreadCount:i});}return n;}}},{key:"clearGroupAtInfoList",value:function value(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=this.getLocalConversation(e);if(n&&n.groupAtInfoList.length>0){if(n.clearGroupAtInfoList(),xe.l("".concat(this._n,".clearGroupAtInfoList conversationID:").concat(e)),n.type===S.CONV_TOPIC){var o=n.groupAtInfoList,s=this.getModule(wn),a=e.replace(S.CONV_GROUP,"");s.onConversationProxy({topicID:a,groupAtInfoList:o});}!0===t&&this.emitConversationUpdate(!0,!1);}}},{key:"updateReadReceiptInfo",value:function value(e){var t=this,n=e.userID,o=void 0===n?void 0:n,s=e.groupID,a=void 0===s?void 0:s,r=e.readReceiptList;if(!jt(r)){var i=[];if(at(o)){if(!at(a)){var u="".concat(S.CONV_GROUP).concat(a);r.forEach(function(e){var n=e.tinyID,o=e.clientTime,s=e.random,r=e.readCount,c=e.unreadCount,l="".concat(n,"-").concat(o,"-").concat(s),p=t._messageListHandler.getLocalMessage(u,l),d={groupID:a,messageID:l,readCount:0,unreadCount:0};p&&($e(r)&&(p.readReceiptInfo.readCount=r,d.readCount=r),$e(c)&&(p.readReceiptInfo.unreadCount=c,d.unreadCount=c),i.push(d));});}}else{var c="".concat(S.CONV_C2C).concat(o);r.forEach(function(e){var n=e.tinyID,s=e.clientTime,a=e.random,r="".concat(n,"-").concat(s,"-").concat(a),u=t._messageListHandler.getLocalMessage(c,r);if(u){u.readReceiptInfo.isPeerRead=!0;var l={userID:o,messageID:r,isPeerRead:!0};i.push(l);}});}i.length>0&&this.emitOuterEvent(E.MESSAGE_READ_RECEIPT_RECEIVED,i);}}},{key:"recomputeGroupUnreadCount",value:function value(e){var t=e.conversationID,n=e.count,o=this.getLocalConversation(t);if(o){var s=o.unreadCount,a=s-n;a<0&&(a=0),o.unreadCount=a,xe.l("".concat(this._n,".recomputeGroupUnreadCount from ").concat(s," to ").concat(a,", conversationID:").concat(t));}}},{key:"updateIsRead",value:function value(e){var t=this.getLocalConversation(e),n=this.getLocalMessageList(e);if(t&&0!==n.length&&!kt(t.type)){for(var o=[],s=0,a=n.length;s<a;s++){"in"!==n[s].flow?"out"!==n[s].flow||n[s].isRead||n[s].setIsRead(!0):o.push(n[s]);}var r=0;if(t.type===S.CONV_C2C){var i=o.slice(-t.unreadCount).filter(function(e){return e.isRevoked;}).length;r=o.length-t.unreadCount-i;}else r=o.length-t.unreadCount;for(var u=0;u<r&&!o[u].isRead;u++){o[u].setIsRead(!0);}}}},{key:"deleteGroupAtTips",value:function value(e){var t=this,n="".concat(this._n,".deleteGroupAtTips");xe.l("".concat(n));var o=this._conversationMap.get(e);if(!o)return Promise.resolve();var s=o.groupAtInfoList;if(0===s.length)return Promise.resolve();var a=void 0;e.startsWith(S.CONV_GROUP)&&(a=e.replace(S.CONV_GROUP,""));var r=m(s);if((Tt({groupID:a})||Dt(a))&&0===(r=s.filter(function(e){return!e.atTypeArray.includes(S.CONV_AT_ALL);})).length)return this.clearGroupAtInfoList(e,!1),Promise.resolve();var i=this.getMyUserID();return this.request({protocolName:bo,requestData:{messageListToDelete:r.map(function(e){return{from:e.from,to:i,messageSeq:e.__sequence,messageRandom:e.__random,groupID:at(e.topicID)?e.groupID:e.topicID};})}}).then(function(){return xe.l("".concat(n," ok. count:").concat(s.length)),t.clearGroupAtInfoList(e,!1),Promise.resolve();}).catch(function(e){return xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"appendToMessageList",value:function value(e){this._messageListHandler.pushIn(e);}},{key:"setMessageRandom",value:function value(e){this.singlyLinkedList.set(e.random);}},{key:"deleteMessageRandom",value:function value(e){this.singlyLinkedList.delete(e.random);}},{key:"pushIntoMessageList",value:function value(e,t,n){return!(!this._messageListHandler.pushIn(t,n)||this._isMessageFromCurrentInstance(t)&&!n)&&(e.push(t),!0);}},{key:"_isMessageFromCurrentInstance",value:function value(e){return this.singlyLinkedList.has(e.random);}},{key:"revoke",value:function value(e,t,n){return this._messageListHandler.revoke(e,t,n);}},{key:"getPeerReadTime",value:function value(e){return this._peerReadTimeMap.get(e);}},{key:"recordPeerReadTime",value:function value(e,t){this._peerReadTimeMap.has(e)?this._peerReadTimeMap.get(e)<t&&this._peerReadTimeMap.set(e,t):this._peerReadTimeMap.set(e,t);}},{key:"updateMessageIsPeerReadProperty",value:function value(e,t){if(e.startsWith(S.CONV_C2C)&&t>0){var n=this._messageListHandler.updateMessageIsPeerReadProperty(e,t);if(n.length>0&&this.emitOuterEvent(E.MESSAGE_READ_BY_PEER,n),this._conversationMap.has(e)){var o=this._conversationMap.get(e).lastMessage;jt(o)||o.fromAccount===this.getMyUserID()&&o.lastTime<=t&&!o.isPeerRead&&(o.isPeerRead=!0,this.emitConversationUpdate(!0,!1));}}}},{key:"updateMessageIsModifiedProperty",value:function value(e){this._messageListHandler.updateMessageIsModifiedProperty(e);}},{key:"setCompleted",value:function value(e){xe.l("".concat(this._n,".setCompleted. conversationID:").concat(e)),this._completedMap.set(e,!0);}},{key:"updateRoamingMessageKeyAndTime",value:function value(e,t,n){this._roamingMessageKeyAndTimeMap.set(e,{messageKey:t,lastMessageTime:n});}},{key:"updateRoamingMessageSequence",value:function value(e,t){this._roamingMessageSequenceMap.set(e,t);}},{key:"getConversationList",value:function value(e){var t=this,n="getConversationList",o="".concat(this._n,".").concat(n),s="pagingStatus:".concat(this._pagingStatus,", local conversation count:").concat(this._conversationMap.size,", options:").concat(e);if(xe.l("".concat(o,". ").concat(s)),this._pagingStatus===Zt.REJECTED){var a=new ka(n);return a.setMessage(s),this.syncConversationList().then(function(){a.setNetworkType(t.getNetworkType()).end();var n=t._getConversationList(e);return Ka({conversationList:n,isSyncCompleted:t._isSyncCompleted()});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];a.setError(e,o,s).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}if(0===this._conversationMap.size){var r=new ka(n);return r.setMessage(s),this.syncConversationList().then(function(){r.setNetworkType(t.getNetworkType()).end();var n=t._getConversationList(e);return Ka({conversationList:n,isSyncCompleted:t._isSyncCompleted()});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}var i=this._getConversationList(e);return xe.l("".concat(o,". returned conversation count:").concat(i.length)),za({conversationList:i,isSyncCompleted:this._isSyncCompleted()});}},{key:"_getConversationList",value:function value(e){if(at(e))return this.getLocalConversationList();if(st(e))return 0===e.length?[]:this.getLocalConversationList().filter(function(t){return e.includes(t.conversationID);});if(ot(e)){var t=e.type,n=e.markType,o=e.groupName;return this.getLocalConversationList().filter(function(e){return(t!==S.CONV_C2C&&t!==S.CONV_GROUP||e.type===t)&&(!et(o)||e.conversationGroupList.includes(o))&&(!$e(n)||e.markList.includes(n));});}return[];}},{key:"_handleC2CPeerReadTime",value:function value(){var e,t=D(this._conversationMap);try{for(t.s();!(e=t.n()).done;){var n=v(e.value,2),o=n[0],s=n[1];s.type===S.CONV_C2C&&(xe.d("".concat(this._n,"._handleC2CPeerReadTime conversationID:").concat(o," peerReadTime:").concat(s.peerReadTime)),this.recordPeerReadTime(o,s.peerReadTime));}}catch(a){t.e(a);}finally{t.f();}}},{key:"_isPagingGetGroupListCompleted",value:function value(){return this.getModule(Un).isPagingGetCompleted();}},{key:"_getLocalGroupCount",value:function value(){return this.getModule(Un).getLocalGroupList().length;}},{key:"_hasLocalGroup",value:function value(e){return this.getModule(Un).hasLocalGroup(e.replace(S.CONV_GROUP,""));}},{key:"getConversationProfile",value:function value(e){var t,n=this;if((t=this._conversationMap.has(e)?this._conversationMap.get(e):new _r({conversationID:e,type:e.slice(0,3)===S.CONV_C2C?S.CONV_C2C:S.CONV_GROUP},this.isIntl()))._isInfoCompleted||t.type===S.CONV_SYSTEM)return za({conversation:t});if(St(e)&&!this._hasLocalGroup(e))return za({conversation:t});var o="".concat(this._n,".").concat("getConversationProfile"),s=new ka("getConversationProfile");return xe.l("".concat(o,". conversationID:").concat(e," remark:").concat(t.remark," lastMessage:"),t.lastMessage),this._updateUserOrGroupProfileCompletely(t).then(function(a){s.setNetworkType(n.getNetworkType()).setMessage("conversationID:".concat(e," unreadCount:").concat(a.data.conversation.unreadCount)).end();var r=n.getModule(Pn);if(r&&t.type===S.CONV_C2C){var i=e.replace(S.CONV_C2C,"");if(r.isMyFriend(i)){var u=r.getFriendRemark(i);t.remark!==u&&(t.remark=u,xe.l("".concat(o,". conversationID:").concat(e," patch remark:").concat(t.remark)));}}return xe.l("".concat(o," ok. conversationID:").concat(e)),a;}).catch(function(t){return n.probeNetwork().then(function(n){var o=v(n,2),a=o[0],r=o[1];s.setError(t,a,r).setMessage("conversationID:".concat(e)).end();}),xe.e("".concat(o," failed. error:"),t),Ja(t);});}},{key:"_updateUserOrGroupProfileCompletely",value:function value(e){var t=this;return e.type===S.CONV_C2C?this.getModule(On).getUserProfile({userIDList:[e.toAccount]}).then(function(n){var o=n.data;return 0===o.length?Ja(new Wa({code:da.USER_OR_GROUP_NOT_FOUND})):(e.userProfile=o[0],e._isInfoCompleted=!0,t._unshiftConversation(e),za({conversation:e}));}):this.getModule(Un).getGroupProfile({groupID:e.toAccount}).then(function(n){return e.groupProfile=n.data.group,e._isInfoCompleted=!0,t._unshiftConversation(e),za({conversation:e});});}},{key:"_unshiftConversation",value:function value(e){e instanceof _r&&!this._conversationMap.has(e.conversationID)&&(this._conversationMap=new Map([[e.conversationID,e]].concat(m(this._conversationMap))),this._setStorageConversationList(),this.emitConversationUpdate(!0,!1));}},{key:"_onProfileUpdated",value:function value(e){var t=this;e.data.forEach(function(e){var n=e.userID;if(n===t.getMyUserID())t._onMyProfileModified({latestNick:e.nick,latestAvatar:e.avatar});else{var o=t._conversationMap.get("".concat(S.CONV_C2C).concat(n));o&&(o.userProfile=e);}});}},{key:"_isSyncCompleted",value:function value(){return this._pagingStatus===Zt.RESOLVED;}},{key:"_errorLog",value:function value(e,t,n,o){var s=new Error("Params validate failed."),a="".concat(this.getErrorMessage("API_REFER")).concat(e);throw xe.w("[".concat(e,"] | ").concat(t," | ").concat(this.getErrorMessage(n,o),", ").concat(a)),xe.e("[".concat(e,"] Invalid ").concat(t,": type check failed for ").concat(t,".")),s;}},{key:"_isValidConversationID",value:function value(e){return Et(e)||St(e)||kt(e);}},{key:"deleteConversation",value:function value(e){var t=this,n="deleteConversation";return et(e)||nt(e)||this._errorLog(n,"options","StringOrObjectRequiredLog"),et(e)?(this._isValidConversationID(e)||this._errorLog(n,"options","InvalidConversationID",e),xe.l("".concat(this._n,".").concat(n," conversationID:").concat(e)),this.deleteConversationList({conversationIDList:[e],flag:1})):(st(e.conversationIDList)||this._errorLog(n,"conversationIDList","ArrayRequiredLog"),0===e.conversationIDList.length&&this._errorLog(n,"conversationIDList","NonEmptyArrayLog"),e.conversationIDList.forEach(function(e){t._isValidConversationID(e)||t._errorLog(n,"conversationIDList","InvalidConversationID",e);}),"clearHistoryMessage"in e&&"boolean"!=typeof e.clearHistoryMessage&&this._errorLog(n,"clearHistoryMessage","BooleanRequiredLog"),e.conversationIDList.length>100&&(e.conversationIDList=e.conversationIDList.slice(0,100)),this.deleteConversationList(e));}},{key:"deleteConversationList",value:function value(e){var t=this,n=e.conversationIDList,o=void 0===n?[]:n,s=e.clearHistoryMessage,a=void 0===s||s,r=e.flag,i=void 0===r?0:r,u="".concat(this._n,".").concat("deleteConversationList");xe.l("".concat(u," conversationIDList.length:").concat(o.length," clearHistoryMessage:").concat(a));var c=new ka("deleteConversationList");return c.setMessage("conversationIDList:".concat(o)),Promise.all([this.rmLocalOnlyConversationList(o),this.rmLocalAndRemoteConversationList(o,a)]).then(function(e){c.setNetworkType(t.getNetworkType()).end();var n=[].concat(m(e[0]),m(e[1]));return 0===n.length?Ja(new Wa({code:da.CONVERSATION_NOT_FOUND})):(xe.l("".concat(u," ok")),za(1===i?{conversationID:n[0]}:{conversationIDList:n}));}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];c.setError(e,o,s).end();}),xe.e("".concat(u," failed. error:"),e),Ja(e);});}},{key:"rmLocalOnlyConversationList",value:function value(e){var t=this;return e.filter(function(e){if(!t._conversationMap.has(e))return!1;var n=t.getLocalConversation(e).type;return n!==S.CONV_GROUP||t._hasLocalGroup(e)?n===S.CONV_SYSTEM&&(t.getModule(Un).deleteGroupSystemNotice({messageList:t._messageListHandler.getLocalMessageList(e)}),t.deleteLocalConversation(e),!0):(t.deleteLocalConversation(e),!0);});}},{key:"rmLocalAndRemoteConversationList",value:function value(e,t){var n=this,o={fromAccount:this.getMyUserID(),conversationList:[],clearHistoryMessage:t?1:0};return e.forEach(function(e){if(n._conversationMap.has(e)){var t=n.getLocalConversation(e).type;t===S.CONV_C2C?o.conversationList.push({toAccount:e.replace(t,""),type:1}):t===S.CONV_GROUP&&n._hasLocalGroup(e)&&o.conversationList.push({toGroupID:e.replace(t,""),type:2});}}),0===o.conversationList.length?[]:this.request({protocolName:Go,requestData:o}).then(function(e){var t=[];return e.data.resultList.length>0&&e.data.resultList.map(function(e){if(0===e.code){var n=1===e.type?"".concat(S.CONV_C2C).concat(e.to):"".concat(S.CONV_GROUP).concat(e.groupID);t.push(n);}}),n.deleteLocalConversationList(t),t;});}},{key:"clearHistoryMessage",value:function value(e){var t=this,n={fromAccount:this.getMyUserID(),toAccount:void 0,type:void 0,toGroupID:void 0};if(!this._conversationMap.has(e))return Ja({code:da.CONVERSATION_NOT_FOUND});var o=this._conversationMap.get(e).type;if(o===S.CONV_C2C)n.type=1,n.toAccount=e.replace(S.CONV_C2C,"");else{if(o!==S.CONV_GROUP)return o===S.CONV_SYSTEM?(this.getModule(Un).deleteGroupSystemNotice({messageList:this._messageListHandler.getLocalMessageList(e)}),za({conversationID:e})):Ja({code:da.CONVERSATION_UN_RECORDED_TYPE});n.type=2,n.toGroupID=e.replace(S.CONV_GROUP,"");}var s="".concat(this._n,".").concat("clearHistoryMessage"),a=new ka("clearHistoryMessage");return a.setMessage("conversationID:".concat(e)),xe.l("".concat(s,". conversationID:").concat(e)),this.setMessageRead({conversationID:e}).then(function(){return t.request({protocolName:Uo,requestData:n});}).then(function(){a.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(s," ok")),t._messageListHandler.removeByConversationID(e),t.setCompleted(e);var n=t.getLocalConversation(e);return n&&(n.updateLastMessage(),t._sortConversationListAndEmitEvent()),za({conversationID:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];a.setError(e,o,s).end();}),xe.e("".concat(s," failed. error:"),e),Ja(e);});}},{key:"pinConversation",value:function value(e){var t=this,n=e.conversationID,o=e.isPinned;if(!this._conversationMap.has(n))return Ja({code:da.CONVERSATION_NOT_FOUND});var s=this.getLocalConversation(n);if(s.isPinned===o)return za({conversationID:n});var a="".concat(this._n,".").concat("pinConversation"),r=new ka("pinConversation");r.setMessage("conversationID:".concat(n," isPinned:").concat(o)),xe.l("".concat(a,". conversationID:").concat(n," isPinned:").concat(o));var i=null;return Et(n)?i={type:1,toAccount:n.replace(S.CONV_C2C,"")}:St(n)&&(i={type:2,groupID:n.replace(S.CONV_GROUP,"")}),this.request({protocolName:Po,requestData:{fromAccount:this.getMyUserID(),operationType:!0===o?1:2,itemList:[i]}}).then(function(){return r.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(a," ok")),s.isPinned!==o&&(s.isPinned=o,t._sortConversationListAndEmitEvent()),Ka({conversationID:n});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(a," failed. error:"),e),Ja(e);});}},{key:"setMessageRemindType",value:function value(e){return this._messageRemindHandler.set(e);}},{key:"patchMessageRemindType",value:function value(e){var t=e.ID,n=e.isC2CConversation,o=e.messageRemindType,s=!1,a=this.getLocalConversation(n?"".concat(S.CONV_C2C).concat(t):"".concat(S.CONV_GROUP).concat(t));return a&&a.messageRemindType!==o&&(a.messageRemindType=o,s=!0),xe.d("".concat(this._n,".patchMessageRemindType options:"),e,"ret:".concat(s)),s;}},{key:"onC2CMessageRemindTypeSynced",value:function value(e){var t=this,n="".concat(this._n,".onC2CMessageRemindTypeSynced");xe.d(n,e),e.dataList.forEach(function(e){if(!jt(e.muteNotificationsSync)){var o,s=e.muteNotificationsSync,a=s.to,r=s.updateSequence,i=s.muteFlag;t._messageRemindHandler.setUpdateSequence(r),0===i?o=S.MSG_REMIND_ACPT_AND_NOTE:1===i?o=S.MSG_REMIND_DISCARD:2===i&&(o=S.MSG_REMIND_ACPT_NOT_NOTE);var u=0;t.patchMessageRemindType({ID:a,isC2CConversation:!0,messageRemindType:o})&&(u+=1),xe.l("".concat(n," updateCount:").concat(u)),u>=1&&t.emitConversationUpdate(!0,!1);}});}},{key:"onGroupMessageRemindTypeSynced",value:function value(e){xe.d("".concat(this._n,".onGroupMessageRemindTypeSynced options:"),e),this._messageRemindHandler.onGroupMessageRemindTypeUpdated(e);}},{key:"deleteLocalConversation",value:function value(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=this._conversationMap.has(e);if(xe.d("".concat(this._n,".deleteLocalConversation conversationID:").concat(e," has:").concat(n)),n&&(this._conversationMap.delete(e),this._roamingMessageKeyAndTimeMap.has(e)&&this._roamingMessageKeyAndTimeMap.delete(e),this._roamingMessageSequenceMap.has(e)&&this._roamingMessageSequenceMap.delete(e),this._setStorageConversationList(),this._messageListHandler.removeByConversationID(e),this._completedMap.delete(e),t)){var o=!this._isTopicConversation(e);this.emitConversationUpdate(o,!1);}}},{key:"deleteLocalConversationList",value:function value(e){var t=this,n=0,o=!1;e.forEach(function(e){t._conversationMap.has(e)&&(n+=t._conversationMap.get(e).unreadCount||0,t.deleteLocalConversation(e,!1),o=!0);}),xe.l("".concat(this._n,".deleteLocalConversationList conversationIDList.length:").concat(e.length," isConvIDExisted:").concat(o)),o&&(this.emitConversationUpdate(!0,!1),n>0&&this.emitTotalUnreadMessageCountUpdate());}},{key:"isMessageSentByCurrentInstance",value:function value(e){return!(!this._messageListHandler.hasLocalMessage(e.conversationID,e.ID)&&!this.singlyLinkedList.has(e.random));}},{key:"modifyMessageList",value:function value(e){if(e.startsWith(S.CONV_C2C)&&this._conversationMap.has(e)){var t=this._conversationMap.get(e),n=Date.now();this._messageListHandler.modifyMessageSentByPeer({conversationID:e,latestNick:t.userProfile.nick,latestAvatar:t.userProfile.avatar});var o=this.getModule(On).getNickAndAvatarByUserID(this.getMyUserID());this._messageListHandler.modifyMessageSentByMe({conversationID:e,latestNick:o.nick,latestAvatar:o.avatar}),xe.l("".concat(this._n,".modifyMessageList conversationID:").concat(e," cost ").concat(Date.now()-n," ms"));}}},{key:"updateUserProfileSpecifiedKey",value:function value(e){xe.l("".concat(this._n,".updateUserProfileSpecifiedKey options:"),e);var t=e.conversationID,n=e.nick,o=e.avatar;if(this._conversationMap.has(t)){var s=this._conversationMap.get(t).userProfile;et(n)&&s.nick!==n&&(s.nick=n),et(o)&&s.avatar!==o&&(s.avatar=o),this.emitConversationUpdate(!0,!1);}}},{key:"_onMyProfileModified",value:function value(e){var n=this,o=this.getLocalConversationList(),s=Date.now();o.forEach(function(o){n.modifyMessageSentByMe(t({conversationID:o.conversationID},e));}),xe.l("".concat(this._n,"._onMyProfileModified. modify all messages sent by me, cost ").concat(Date.now()-s," ms"));}},{key:"modifyMessageSentByMe",value:function value(e){this._messageListHandler.modifyMessageSentByMe(e);}},{key:"getLatestMessageSentByMe",value:function value(e){return this._messageListHandler.getLatestMessageSentByMe(e);}},{key:"modifyMessageSentByPeer",value:function value(e){this._messageListHandler.modifyMessageSentByPeer(e);}},{key:"getLatestMessageSentByPeer",value:function value(e){return this._messageListHandler.getLatestMessageSentByPeer(e);}},{key:"pushIntoNoticeResult",value:function value(e,t){return!(!this._messageListHandler.pushIn(t)||this.singlyLinkedList.has(t.random))&&(e.push(t),!0);}},{key:"getLocalLastMessage",value:function value(e){return this._messageListHandler.getLocalLastMessage(e);}},{key:"checkAndPatchRemark",value:function value(){var e=Promise.resolve();if(0===this._conversationMap.size)return e;var t=this.getModule(Pn);if(!t)return e;var n=m(this._conversationMap.values()).filter(function(e){return e.type===S.CONV_C2C;});if(0===n.length)return e;var o=0;return n.forEach(function(e){var n=e.conversationID.replace(S.CONV_C2C,"");if(t.isMyFriend(n)){var s=t.getFriendRemark(n);e.remark!==s&&(e.remark=s,o+=1);}}),xe.l("".concat(this._n,".checkAndPatchRemark. c2c conversation count:").concat(n.length,", patched count:").concat(o)),e;}},{key:"updateTopicConversation",value:function value(e){this._updateLocalConversationList({conversationOptionsList:e,isFromGetConversations:!0});}},{key:"sendReadReceipt",value:function value(e){var t=e[0],n=null;return t.conversationType===S.CONV_C2C?n=this._m.getModule(Gn):t.conversationType===S.CONV_GROUP&&(n=this._m.getModule(Un)),n?n.sendReadReceipt(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"getReadReceiptList",value:function value(e){var t=e[0],n=null;return t.conversationType===S.CONV_C2C?n=this._m.getModule(Gn):t.conversationType===S.CONV_GROUP&&(n=this._m.getModule(Un)),n?n.getReadReceiptList(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"getLastMessageTime",value:function value(e){var t=this.getLocalConversation(e);return t?t.lastMessage.lastTime:0;}},{key:"getTotalUnreadMessageCount",value:function value(){var e=this.getLocalConversationList(),t=0;return e.forEach(function(e){e.type!==S.CONV_SYSTEM&&(""!==e.messageRemindType&&e.messageRemindType!==S.MSG_REMIND_ACPT_AND_NOTE||(t+=e.unreadCount));}),t;}},{key:"emitTotalUnreadMessageCountUpdate",value:function value(){var e=this.getTotalUnreadMessageCount();this._convTotalUnreadCount!==e&&(xe.l("".concat(this._n,".emitTotalUnreadMessageCountUpdate from ").concat(this._convTotalUnreadCount," to ").concat(e)),this._convTotalUnreadCount=e,this.emitOuterEvent(E.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED));}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._pagingStatus=Zt.NOT_START,this._messageListHandler.reset(),this._messageRemindHandler.reset(),this._roamingMessageKeyAndTimeMap.clear(),this._roamingMessageSequenceMap.clear(),this.singlyLinkedList.reset(),this._peerReadTimeMap.clear(),this._completedMap.clear(),this._conversationMap.clear(),this._pagingTimeStamp=0,this._pagingStartIndex=0,this._pagingPinnedTimeStamp=0,this._pagingPinnedStartIndex=0,this._remoteGroupReadSequenceMap.clear(),this._convTotalUnreadCount=0,this._pagingGetCostList.length=0,this.resetReady();}}]),s;}(ro),mr=function(){function e(t){o(this,e),this._groupModule=t,this._n="GroupTipsHandler",this._cachedGroupTipsMap=new Map(),this._checkCountMap=new Map(),this.MAX_CHECK_COUNT=4,this._getTopicPendingMap=new Map();}return a(e,[{key:"onCheckTimer",value:function value(e){e%1==0&&this._cachedGroupTipsMap.size>0&&this._checkCachedGroupTips();}},{key:"_checkCachedGroupTips",value:function value(){var e=this;this._cachedGroupTipsMap.forEach(function(t,n){var o=e._checkCountMap.get(n),s=e._groupModule.hasLocalGroup(n);xe.l("".concat(e._n,"._checkCachedGroupTips groupID:").concat(n," hasLocalGroup:").concat(s," checkCount:").concat(o)),s?(e._notifyCachedGroupTips(n),e._checkCountMap.delete(n),e._groupModule.deleteUnjoinedAVChatRoom(n)):o>=e.MAX_CHECK_COUNT?(e._deleteCachedGroupTips(n),e._checkCountMap.delete(n)):(o++,e._checkCountMap.set(n,o));});}},{key:"onNewGroupTips",value:function value(e){xe.d("".concat(this._n,".onReceiveGroupTips count:").concat(e.dataList.length));var t=this.newGroupTipsStoredAndSummary(e),n=t.eventDataList,o=t.result,s=t.AVChatRoomMessageList;(s.length>0&&this._groupModule.onAVChatRoomMessage(s),n.length>0)&&(this._groupModule.updateNextMessageSeq(n),this._groupModule.getModule(Fn).onNewMessage({conversationOptionsList:n,isInstantMessage:!0}));o.length>0&&(this._groupModule.emitOuterEvent(E.MESSAGE_RECEIVED,o),this.handleMessageList(o));}},{key:"newGroupTipsStoredAndSummary",value:function value(e){for(var n=this,o=e.event,s=e.dataList,a=null,r=[],i=[],u={},c=[],l=function l(e,_l){var p=yt(s[e]);if(6===o){if(n._groupModule.isGroupAttributesUpdatedNotice(p))return"continue";if(n._groupModule.isGroupCountersNotice(p))return"continue";}var d=p.groupProfile,g=d.groupID,_=d.communityType,h=void 0===_?0:_,f=d.topicID,v=void 0===f?void 0:f,m=d.invisible,M=void 0,y=n._groupModule.isMessageFromTopic(h,v);if(y){M=S.CONV_TOPIC,p.to=v;var I=n._groupModule.getModule(wn);I.hasLocalTopic(g,v)||n._getTopicPendingMap.has(v)||(n._getTopicPendingMap.set(v,1),I.getTopicList({groupID:g,topicIDList:[v]}).finally(function(){n._getTopicPendingMap.delete(v);}));}var C=n._groupModule.hasLocalGroup(g);if(!C&&n._groupModule.isUnjoinedAVChatRoom(g))return"continue";if(!C&&!y)return n._cacheGroupTipsAndProbe({groupID:g,event:o,item:p}),"continue";if(n._groupModule.isMessageFromOrToAVChatroom(g))return p.event=o,c.push(p),"continue";if(p.currentUser=n._groupModule.getMyUserID(),p.conversationType=S.CONV_GROUP,(a=new Ha(p)).setElement({type:S.MSG_GRP_TIP,content:t(t({},p.elements),{},{groupProfile:p.groupProfile})}),a.isSystemMessage=!1,1===m)return n._qualityStat(a),"continue";var T=n._groupModule.getModule(Fn),D=a,E=D.conversationID,k=D.sequence;if(6===o)a._onlineOnlyFlag=!0,i.push(a);else if(!T.pushIntoNoticeResult(i,a))return"continue";if(n._groupModule.isMessageFromCommunityOfTopic(h,v))return"continue";if(6===o&&T.getLocalConversation(E))return"continue";6!==o&&n._qualityStat(a);var L=T.isRemoteRead({conversationID:E,sequence:k});if(at(u[E])){var A=0;"in"===a.flow&&(a._isExcludedFromUnreadCount||a._onlineOnlyFlag||L||(A=1)),u[E]=r.push({conversationID:E,unreadCount:A,type:at(M)?a.conversationType:M,subType:a.conversationSubType,lastMessage:a._isExcludedFromLastMessage?"":a})-1;}else{var R=u[E];r[R].type=a.conversationType,r[R].subType=a.conversationSubType,r[R].lastMessage=a._isExcludedFromLastMessage?"":a,"in"===a.flow&&(a._isExcludedFromUnreadCount||a._onlineOnlyFlag||L||r[R].unreadCount++);}},p=0,d=s.length;p<d;p++){l(p);}return{eventDataList:r,result:i,AVChatRoomMessageList:c};}},{key:"_qualityStat",value:function value(e){this._groupModule.getModule($n).addMessageSequence({key:ya,message:e});}},{key:"handleMessageList",value:function value(e){var t=this;e.forEach(function(e){switch(e.payload.operationType){case 1:t._onNewMemberComeIn(e);break;case 2:t._onMemberQuit(e);break;case 3:t._onMemberKickedOut(e);break;case 4:t._onMemberSetAdmin(e);break;case 5:t._onMemberCancelledAdmin(e);break;case 6:t._onGroupProfileModified(e);break;case 7:t._onMemberInfoModified(e);break;case 8:t._onTopicProfileUpdated(e);break;default:xe.w("".concat(t._n,".handleMessageList unknown operationType:").concat(e.payload.operationType));}});}},{key:"_onNewMemberComeIn",value:function value(e){var t=e.payload,n=t.memberNum,o=t.groupProfile.groupID,s=this._groupModule.getLocalGroupProfile(o);s&&$e(n)&&s.memberCount!==n&&(s.memberCount=n,this._updateConversationGroupProfile(s));}},{key:"_onMemberQuit",value:function value(e){var t=e.payload,n=t.memberNum,o=t.groupProfile.groupID,s=this._groupModule.getLocalGroupProfile(o);s&&$e(n)&&s.memberCount!==n&&(s.memberCount=n,this._updateConversationGroupProfile(s)),this._groupModule.getModule(bn).deleteLocalGroupMembers(o,e.payload.userIDList);}},{key:"_onMemberKickedOut",value:function value(e){var t=e.payload,n=t.memberNum,o=t.groupProfile.groupID,s=this._groupModule.getLocalGroupProfile(o);s&&$e(n)&&s.memberCount!==n&&(s.memberCount=n,this._updateConversationGroupProfile(s)),this._groupModule.getModule(bn).deleteLocalGroupMembers(o,e.payload.userIDList);}},{key:"_updateConversationGroupProfile",value:function value(e){this._groupModule.getModule(Fn).updateConversationGroupProfile([e]);}},{key:"_onMemberSetAdmin",value:function value(e){var t=e.payload.groupProfile.groupID,n=e.payload.userIDList,o=this._groupModule.getModule(bn);n.forEach(function(e){var n=o.getLocalGroupMemberInfo(t,e);n&&n.updateRole(S.GRP_MBR_ROLE_ADMIN);});}},{key:"_onMemberCancelledAdmin",value:function value(e){var t=e.payload.groupProfile.groupID,n=e.payload.userIDList,o=this._groupModule.getModule(bn);n.forEach(function(e){var n=o.getLocalGroupMemberInfo(t,e);n&&n.updateRole(S.GRP_MBR_ROLE_MEMBER);});}},{key:"_onGroupProfileModified",value:function value(e){var t=this,n=e.payload,o=n.newGroupProfile,s=n.groupProfile.groupID,a=this._groupModule.getLocalGroupProfile(s);Object.keys(o).forEach(function(e){switch(e){case"ownerID":t._ownerChanged(a,o);break;case"groupName":a.name=o[e];break;default:a[e]=o[e];}});var r=!a.isSupportTopic;this._groupModule.emitGroupListUpdate(!0,r);}},{key:"_ownerChanged",value:function value(e,t){var n=e.groupID,o=this._groupModule.getLocalGroupProfile(n),s=this._groupModule.getMyUserID();if(s===t.ownerID){o.updateGroup({selfInfo:{role:S.GRP_MBR_ROLE_OWNER}});var a=this._groupModule.getModule(bn),r=a.getLocalGroupMemberInfo(n,s),i=this._groupModule.getLocalGroupProfile(n).ownerID,u=a.getLocalGroupMemberInfo(n,i);r&&r.updateRole(S.GRP_MBR_ROLE_OWNER),u&&u.updateRole(S.GRP_MBR_ROLE_MEMBER);}}},{key:"_onMemberInfoModified",value:function value(e){var t=e.to,n=e.payload,o=n.groupProfile,s=n.memberList,a=o.groupID;Dt(t)&&this._updateTopicMuteTime(e);var r=this._groupModule.getModule(bn);s.forEach(function(e){var t=r.getLocalGroupMemberInfo(a,e.userID);t&&$e(e.muteTime)&&t.updateMuteUntil(e.muteTime);});}},{key:"_updateTopicMuteTime",value:function value(e){var t=e.to,n=e.payload,o=n.groupProfile,s=n.memberList,a=void 0===s?[]:s,r=this._groupModule.getModule(wn),i=o.groupID,u=r.getLocalTopic(i,t);if(u){for(var c=!1,l=0;l<a.length;l++){var p=a[l];if(p.userID===this._groupModule.getMyUserID()&&p.muteTime>=0){u.updateSelfInfo({muteTime:p.muteTime}),c=!0;break;}}c&&this._groupModule.emitOuterEvent(E.TOPIC_UPDATED,{groupID:i,topic:u});}}},{key:"_onTopicProfileUpdated",value:function value(e){var n=e.payload,o=n.groupProfile.groupID,s=n.newTopicInfo;this._groupModule.getModule(wn).onTopicProfileUpdated(t({groupID:o,topicID:e.to},s));}},{key:"_cacheGroupTips",value:function value(e,t){this._cachedGroupTipsMap.has(e)||this._cachedGroupTipsMap.set(e,[]),this._cachedGroupTipsMap.get(e).push(t);}},{key:"_deleteCachedGroupTips",value:function value(e){this._cachedGroupTipsMap.has(e)&&this._cachedGroupTipsMap.delete(e);}},{key:"_notifyCachedGroupTips",value:function value(e){var t=this,n=this._cachedGroupTipsMap.get(e)||[];n.forEach(function(e){t.onNewGroupTips(e);}),this._deleteCachedGroupTips(e),xe.l("".concat(this._n,"._notifyCachedGroupTips groupID:").concat(e," count:").concat(n.length));}},{key:"_cacheGroupTipsAndProbe",value:function value(e){var t=this,n=e.groupID,o=e.event,s=e.item;this._cacheGroupTips(n,{event:o,dataList:[s]}),this._groupModule.getGroupSimplifiedInfo(n).then(function(e){e.type===S.GRP_AVCHATROOM?t._groupModule.hasLocalGroup(n)?t._notifyCachedGroupTips(n):t._groupModule.setUnjoinedAVChatRoom(n):(t._groupModule.updateGroupMap([e]),t._notifyCachedGroupTips(n));}),this._checkCountMap.has(n)||this._checkCountMap.set(n,0),xe.l("".concat(this._n,"._cacheGroupTipsAndProbe groupID:").concat(n));}},{key:"reset",value:function value(){this._cachedGroupTipsMap.clear(),this._checkCountMap.clear(),this._getTopicPendingMap.clear();}}]),e;}(),Mr=function(){function e(t){o(this,e),this._groupModule=t,this._n="CommonGroupHandler",this.tempConversationList=null,this._cachedGroupMessageMap=new Map(),this._checkCountMap=new Map(),this.MAX_CHECK_COUNT=4,this._getTopicPendingMap=new Map(),this._isPagingGetCompleted=!1,t.getInnerEmitterInstance().once(Za,this._initGroupList,this);}return a(e,[{key:"onCheckTimer",value:function value(e){e%1==0&&this._cachedGroupMessageMap.size>0&&this._checkCachedGroupMessage();}},{key:"_checkCachedGroupMessage",value:function value(){var e=this;this._cachedGroupMessageMap.forEach(function(t,n){var o=e._checkCountMap.get(n),s=e._groupModule.hasLocalGroup(n);xe.l("".concat(e._n,"._checkCachedGroupMessage groupID:").concat(n," hasLocalGroup:").concat(s," checkCount:").concat(o)),s?(e._notifyCachedGroupMessage(n),e._checkCountMap.delete(n),e._groupModule.deleteUnjoinedAVChatRoom(n)):o>=e.MAX_CHECK_COUNT?(e._deleteCachedGroupMessage(n),e._checkCountMap.delete(n)):(o++,e._checkCountMap.set(n,o));});}},{key:"_initGroupList",value:function value(){var e=this;xe.l("".concat(this._n,"._initGroupList"));var t=new ka("getGroupListInStorage"),n=this._groupModule.getStorageGroupList();if(st(n)&&n.length>0){n.forEach(function(t){e._groupModule.initGroupMap(t);}),this._groupModule.emitGroupListUpdate(!0,!1);var o=this._groupModule.getLocalGroupList().length;t.setNetworkType(this._groupModule.getNetworkType()).setMessage("group count:".concat(o)).end();}else t.setNetworkType(this._groupModule.getNetworkType()).setMessage("group count:0").end();xe.l("".concat(this._n,"._initGroupList ok"));}},{key:"handleUpdateGroupLastMessage",value:function value(e){var n="".concat(this._n,".handleUpdateGroupLastMessage");if(xe.l("".concat(n," conversation count:").concat(e.length,", local group count:").concat(this._groupModule.getLocalGroupList().length)),0!==this._groupModule.getGroupMap().size){for(var o,s,a,r=!1,i=0,u=e.length;i<u;i++){(o=e[i]).type===S.CONV_GROUP&&(s=o.conversationID.split(/^GROUP/)[1],(a=this._groupModule.getLocalGroupProfile(s))&&(a.lastMessage=t({},o.lastMessage),r=!0));}r&&(this._groupModule.sortLocalGroupList(),this._groupModule.emitGroupListUpdate(!0,!1));}else this.tempConversationList=e;}},{key:"onNewGroupMessage",value:function value(e){xe.d("".concat(this._n,".onNewGroupMessage count:").concat(e.dataList.length));var t=this._newGroupMessageStoredAndSummary(e),n=t.conversationOptionsList,o=t.messageList,s=t.AVChatRoomMessageList;(s.length>0&&this._groupModule.onAVChatRoomMessage(s),this._groupModule.filterModifiedMessage(o),n.length>0)&&(this._groupModule.updateNextMessageSeq(n),this._groupModule.getModule(Fn).onNewMessage({conversationOptionsList:n,isInstantMessage:e.isInstantMessage||!0,updateUnreadCount:e.updateUnreadCount||!0}));var a=this._groupModule.filterUnmodifiedMessage(o);a.length>0&&this._groupModule.emitOuterEvent(E.MESSAGE_RECEIVED,a),o.length=0;}},{key:"_newGroupMessageStoredAndSummary",value:function value(e){var t=this,n=e.dataList,o=e.event,s=e.isInstantMessage,a=null,r=[],i=[],u=[],c={},l=this._groupModule.getModule(Hn),p=this._groupModule.getFileDownloadProxy(),d=n.length;d>1&&n.sort(function(e,t){return e.sequence-t.sequence;});for(var g=function g(e){var d=yt(n[e]),g=d.groupProfile,_=g.groupID,h=g.communityType,f=void 0===h?0:h,v=g.topicID,m=void 0===v?void 0:v,M=g.invisible,y=void 0,I=t._groupModule.isMessageFromTopic(f,m);if(I){y=S.CONV_TOPIC,d.to=m;var C=t._groupModule.getModule(wn);C.hasLocalTopic(_,m)||t._getTopicPendingMap.has(m)||(t._getTopicPendingMap.set(m,1),C.getTopicList({groupID:_,topicIDList:[m]}).finally(function(){t._getTopicPendingMap.delete(m);}));}var T=t._groupModule.hasLocalGroup(_);if(!T&&t._groupModule.isUnjoinedAVChatRoom(_))return"continue";if(!T&&!I)return t._cacheGroupMessageAndProbe({groupID:_,event:o,item:d}),"continue";if(t._groupModule.isMessageFromOrToAVChatroom(_))return d.event=o,u.push(d),"continue";if(d.currentUser=t._groupModule.getMyUserID(),d.conversationType=S.CONV_GROUP,d.isSystemMessage=!!d.isSystemMessage,a=new Ha(d),d.elements=l.parseElements(d.elements,d.from),a.setElement(d.elements,p),1===M)return t._qualityStat(s,a),"continue";var D=1===n[e].isModified,E=t._groupModule.getModule(Fn);if(E.isMessageSentByCurrentInstance(a)?a.isModified=D:D=!1,1===d.onlineOnlyFlag)a._onlineOnlyFlag=!0,E.isMessageSentByCurrentInstance(a)||i.push(a);else{if(t._groupModule.isMessageFromCommunityOfTopic(f,m))return i.push(a),"continue";if(!E.pushIntoMessageList(i,a,D))return"continue";t._qualityStat(s,a);var k=a,L=k.conversationID,A=k.sequence,R=E.isRemoteRead({conversationID:L,sequence:A});if(at(c[L])){var N=0;"in"===a.flow&&(a._isExcludedFromUnreadCount||R||(N=1)),c[L]=r.push({conversationID:L,unreadCount:N,type:at(y)?a.conversationType:y,subType:a.conversationSubType,lastMessage:a._isExcludedFromLastMessage?"":a})-1;}else{var O=c[L];r[O].type=at(y)?a.conversationType:y,r[O].subType=a.conversationSubType,r[O].lastMessage=a._isExcludedFromLastMessage?"":a,"in"===a.flow&&(a._isExcludedFromUnreadCount||R||r[O].unreadCount++);}}},_=0;_<d;_++){g(_);}return{conversationOptionsList:r,messageList:i,AVChatRoomMessageList:u};}},{key:"_qualityStat",value:function value(e,t){var n=this._groupModule.getModule($n);n.addMessageSequence({key:ya,message:t}),e&&t.clientTime>0&&n.addMessageDelay(t.clientTime);}},{key:"onGroupMessageRevoked",value:function value(e){var t=this._groupModule.getModule(Fn),n=[],o=null,s=!0;e.dataList.forEach(function(e){var a=e.elements.revokedInfos;at(a)||a.forEach(function(e){var a=jt(e.topicID)?"GROUP".concat(e.groupID):"GROUP".concat(e.topicID);o=t.revoke(a,e.sequence,e.random);var r=e.revokerInfo&&e.revokerInfo.revoker;if(o)o.revoker=r,n.push(o);else{var i={conversationID:a,to:e.topicID||"",sequence:e.sequence,time:e.time,revoker:r};t.isLastMessageRevoked(i)&&(n.push(i),s=!1);}});}),0!==n.length&&(t.onMessageRevoked(n),!0===s&&(xe.l("".concat(this._n,".onGroupMessageRevoked count:").concat(n.length)),this._groupModule.emitOuterEvent(E.MESSAGE_REVOKED,n)));}},{key:"_groupListTreeShaking",value:function value(e){for(var t=new Map(m(this._groupModule.getGroupMap())),n=0,o=e.length;n<o;n++){t.delete(e[n].groupID);}this._groupModule.hasJoinedAVChatRoom()&&this._groupModule.getJoinedAVChatRoom().forEach(function(e){t.delete(e);});this._groupModule.getGroupMap().forEach(function(e,n){e.isSupportTopic&&t.delete(n);});for(var s=m(t.keys()),a=0,r=s.length;a<r;a++){this._groupModule.deleteGroup(s[a]);}}},{key:"getGroupList",value:function value(e){var t=this,n="".concat(this._n,".").concat("getGroupList"),o=new ka("getGroupList");xe.l("".concat(n));var s={introduction:"Introduction",notification:"Notification",createTime:"CreateTime",ownerID:"Owner_Account",lastInfoTime:"LastInfoTime",memberNum:"MemberNum",maxMemberNum:"MaxMemberNum",joinOption:"ApplyJoinOption",inviteOption:"InviteJoinOption",muteAllMembers:"ShutUpAllMember"},a=["Type","Name","FaceUrl","NextMsgSeq","LastMsgTime","AtInfoList","LastRecallTime"],r=[];e&&e.groupProfileFilter&&e.groupProfileFilter.forEach(function(e){s[e]&&a.push(s[e]);});var i=(e||{}).isGroupWithTopicOnly,u=void 0!==i&&i;return this._pagingGetGroupList({limit:50,offset:0,groupBaseInfoFilter:a,groupList:r,isGroupWithTopicOnly:u}).then(function(){xe.l("".concat(n," ok. count:").concat(r.length," isGroupWithTopicOnly:").concat(u)),u||t._groupListTreeShaking(r),t._groupModule.updateGroupMap(r);var e=t._groupModule.getLocalGroupList().length;o.setNetworkType(t._groupModule.getNetworkType()).setMessage("remote count:".concat(r.length,", after tree shaking, local count:").concat(e,", isGroupWithTopicOnly:").concat(u)).end(),t.tempConversationList&&(t.handleUpdateGroupLastMessage(t.tempConversationList),t.tempConversationList=null),t._groupModule.patchGroupMessageRemindType(),t._groupModule.recomputeUnreadCount(),t._groupModule.emitGroupListUpdate(!0,!u);var s=t._groupModule.getLocalGroupList();if(u){var a=s.filter(function(e){return!0===e.isSupportTopic;});return Ka({groupList:a});}return t._isPagingGetCompleted=!0,Ka({groupList:s});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"isPagingGetCompleted",value:function value(){return this._isPagingGetCompleted;}},{key:"_pagingGetGroupList",value:function value(e){var t=this,n="".concat(this._n,".").concat("_pagingGetGroupList"),o=e.isCommunityRelay,s=void 0!==o&&o,a=e.isGroupWithTopicOnly,r=void 0!==a&&a,i=e.limit,u=e.offset,c=e.groupBaseInfoFilter,l=e.groupList;if(r)return this._pagingGetGroupListWithTopic({limit:i,offset:u,groupBaseInfoFilter:c,groupList:l});var p=new ka("_pagingGetGroupList");return this._groupModule.request({protocolName:Wo,requestData:{type:s?S.GRP_COMMUNITY:void 0,memberAccount:this._groupModule.getMyUserID(),limit:i,offset:u,responseFilter:{groupBaseInfoFilter:c,selfInfoFilter:["Role","JoinTime","MsgFlag","MsgSeq"]}}}).then(function(e){var o=e.data,a=o.groups,r=void 0===a?[]:a,d=o.totalCount;l.push.apply(l,m(r)),t._handleGroupAtInfoWithoutTopic(s,r);var g=u+i,_=!(d>g),h="offset:".concat(u," totalCount:").concat(d," isCompleted:").concat(_," ")+"currentCount:".concat(l.length," isCommunityRelay:").concat(s);return p.setNetworkType(t._groupModule.getNetworkType()).setMessage("".concat(h)).end(),s||_?!s&&_?(xe.l("".concat(n," start to get community list")),u=0,t._pagingGetGroupList({limit:i,offset:u,groupBaseInfoFilter:c,groupList:l,isCommunityRelay:!0})):s&&!_?(u=g,t._pagingGetGroupList({limit:i,offset:u,groupBaseInfoFilter:c,groupList:l,isCommunityRelay:!0})):(xe.l("".concat(n," ok. totalCount:").concat(l.length)),Ka({groupList:l})):(u=g,t._pagingGetGroupList({limit:i,offset:u,groupBaseInfoFilter:c,groupList:l}));}).catch(function(e){return 11e3!==e.code&&t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];p.setMessage("isCommunityRelay:".concat(s)).setError(e,o,a).end();}),s?(11e3===e.code&&(p=null,xe.l("".concat(n," ok. community unavailable"))),za({groupList:l})):Ja(e);});}},{key:"_pagingGetGroupListWithTopic",value:function value(e){var t=this,n="".concat(this._n,"._pagingGetGroupListWithTopic"),o=e.limit,s=e.offset,a=e.groupBaseInfoFilter,r=e.groupList,i=new ka("pagingGetGroupListWithTopic");return this._groupModule.request({protocolName:Wo,requestData:{type:S.GRP_COMMUNITY,memberAccount:this._groupModule.getMyUserID(),limit:o,offset:s,responseFilter:{groupBaseInfoFilter:a,selfInfoFilter:["Role","JoinTime","MsgFlag","MsgSeq"]},isSupportTopic:1}}).then(function(e){var u=e.data,c=u.groups,l=void 0===c?[]:c,p=u.totalCount;r.push.apply(r,m(l));var d=s+o,g=!(p>d),_="offset:".concat(s," totalCount:").concat(p," isCompleted:").concat(g," ")+"currentCount:".concat(r.length);return i.setNetworkType(t._groupModule.getNetworkType()).setMessage("".concat(_)).end(),g?(xe.l("".concat(n," ok. totalCount:").concat(r.length)),Ka({groupList:r})):(s=d,t._pagingGetGroupListWithTopic({limit:o,offset:s,groupBaseInfoFilter:a,groupList:r}));}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];i.setError(e,o,s).end();}),Ja(e);});}},{key:"_cacheGroupMessage",value:function value(e,t){this._cachedGroupMessageMap.has(e)||this._cachedGroupMessageMap.set(e,[]),this._cachedGroupMessageMap.get(e).push(t);}},{key:"_deleteCachedGroupMessage",value:function value(e){this._cachedGroupMessageMap.has(e)&&this._cachedGroupMessageMap.delete(e);}},{key:"_notifyCachedGroupMessage",value:function value(e){var t=this,n=this._cachedGroupMessageMap.get(e)||[];n.forEach(function(e){t.onNewGroupMessage(e);}),this._deleteCachedGroupMessage(e),xe.l("".concat(this._n,"._notifyCachedGroupMessage groupID:").concat(e," count:").concat(n.length));}},{key:"_cacheGroupMessageAndProbe",value:function value(e){var t=this,n=e.groupID,o=e.event,s=e.item;this._cacheGroupMessage(n,{event:o,dataList:[s]}),this._groupModule.getGroupSimplifiedInfo(n).then(function(e){e.type===S.GRP_AVCHATROOM?t._groupModule.hasLocalGroup(n)?t._notifyCachedGroupMessage(n):t._groupModule.setUnjoinedAVChatRoom(n):(t._groupModule.updateGroupMap([e]),t._notifyCachedGroupMessage(n));}),this._checkCountMap.has(n)||this._checkCountMap.set(n,0),xe.l("".concat(this._n,"._cacheGroupMessageAndProbe groupID:").concat(n));}},{key:"_handleGroupAtInfoWithoutTopic",value:function value(e,n){var o=this;e&&0!==n.length&&n.forEach(function(e){var n=e.groupID,s=e.groupAtInfoList,a=[];at(s)||(s.forEach(function(e){a.push(t(t({},e),{},{groupID:n}));}),o._groupModule.getModule(Fn).onNewGroupAtTips({dataList:a}));});}},{key:"reset",value:function value(){this._cachedGroupMessageMap.clear(),this._checkCountMap.clear(),this._getTopicPendingMap.clear(),this._isPagingGetCompleted=!1,this._groupModule.getInnerEmitterInstance().once(Za,this._initGroupList,this);}}]),e;}(),yr=1,Ir=2,Cr=3,Tr=4,Dr=5,Er=function(){function e(t){o(this,e),this._groupModule=t,this._n="GroupAttributesHandler",this._groupAttributesMap=new Map(),this._groupAttributesCopy={},this.CACHE_EXPIRE_TIME=3e4,this._groupModule.getInnerEmitterInstance().on($a,this._onCloudConfigUpdated,this);}return a(e,[{key:"_onCloudConfigUpdated",value:function value(){var e=this._groupModule.getCloudConfig("grp_attr_cache_time");at(e)||(this.CACHE_EXPIRE_TIME=Number(e));}},{key:"updateLocalMainSequenceOnReconnected",value:function value(){this._groupAttributesMap.forEach(function(e){e.localMainSequence=0;});}},{key:"isGroupAttributesUpdatedNotice",value:function value(e){var t=e.to,n=e.elements.newGroupProfile,o=!at(n)&&!jt(n.groupAttributeOption);return o&&this._onGroupAttributesUpdated({groupID:t,groupAttributeOption:n.groupAttributeOption}),o;}},{key:"_onGroupAttributesUpdated",value:function value(e){var t=this,n=e.groupID,o=e.groupAttributeOption,s=o.mainSequence,a=o.isWithChangedAttributeInfo,r=o.groupAttributeList,i=void 0===r?[]:r,u=o.operationType;if(xe.l("".concat(this._n,".onGroupAttributesUpdated. ")+"groupID:".concat(n," isWithChangedAttributeInfo:").concat(a," operationType:").concat(u)),!at(u)){this._groupAttributesCopy=this._getCachedAttributes({groupID:n});var c=s-this._getLocalGroupAttributes(n).localMainSequence;if(0!==c){if(1===a&&1===c)return this._refreshCachedGroupAttributes({groupID:n,remoteMainSequence:s,groupAttributeList:i,operationType:u}),void this._emitGroupAttributesUpdated(n);if(this._hasLocalGroupAttributes(n)){var l=this._getLocalGroupAttributes(n).avChatRoomKey;this._getGroupAttributes({groupID:n,avChatRoomKey:l}).then(function(){t._emitGroupAttributesUpdated(n);});}}}}},{key:"initGroupAttributesCache",value:function value(e){var t=e.groupID,n=e.avChatRoomKey,o=void 0===n?void 0:n;this._groupAttributesMap.set(t,{lastUpdateTime:0,localMainSequence:0,remoteMainSequence:0,attributes:new Map(),avChatRoomKey:o}),xe.l("".concat(this._n,".initGroupAttributesCache groupID:").concat(t," avChatRoomKey:").concat(o));}},{key:"initGroupAttributes",value:function value(e){var t=this,n=e.groupID,o=e.groupAttributes,s=this._getLocalGroupAttributes(n),a=s.remoteMainSequence,r=s.avChatRoomKey,i=new ka("initGroupAttributes");return i.setMessage("groupID:".concat(n," avChatRoomKey:").concat(r," mainSequence:").concat(a)),this._groupModule.request({protocolName:Ms,requestData:{groupID:n,avChatRoomKey:r,mainSequence:a,groupAttributeList:this._transformGroupAttributes(o)}}).then(function(e){xe.l("".concat(t._n,".").concat("initGroupAttributes"," ok. groupID:").concat(n));var s=e.data,a=s.mainSequence,r=m(s.groupAttributeList);return r.forEach(function(e){e.value=o[e.key];}),t._groupAttributesCopy=t._getCachedAttributes({groupID:n}),t._refreshCachedGroupAttributes({groupID:n,remoteMainSequence:a,groupAttributeList:r,operationType:yr}),t._emitGroupAttributesUpdated(n),i.setNetworkType(t._groupModule.getNetworkType()).end(),Ka({groupAttributes:o});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];i.setError(e,o,s).end();}),Ja(e);});}},{key:"setGroupAttributes",value:function value(e){var t=this,n="".concat(this._n,".").concat("setGroupAttributes"),o=e.groupID,s=e.groupAttributes,a=this._getLocalGroupAttributes(o),r=a.remoteMainSequence,i=a.avChatRoomKey,u=a.attributes,c=this._transformGroupAttributes(s);c.forEach(function(e){var t=e.key;e.sequence=0,u.has(t)&&(e.sequence=u.get(t).sequence);});var l=new ka("setGroupAttributes");return l.setMessage("groupID:".concat(o," groupAttributes:").concat(JSON.stringify(s))),xe.l("".concat(n,". groupID:").concat(o," mainSequence:").concat(r)),this._groupModule.request({protocolName:ys,requestData:{groupID:o,avChatRoomKey:i,mainSequence:r,groupAttributeList:c}}).then(function(e){xe.l("".concat(n," ok."));var a=e.data,r=a.mainSequence,i=m(a.groupAttributeList);return i.forEach(function(e){e.value=s[e.key];}),t._groupAttributesCopy=t._getCachedAttributes({groupID:o}),t._refreshCachedGroupAttributes({groupID:o,remoteMainSequence:r,groupAttributeList:i,operationType:Ir}),t._emitGroupAttributesUpdated(o),l.setNetworkType(t._groupModule.getNetworkType()).end(),Ka({groupAttributes:s});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];l.setError(e,o,s).end();}),Ja(e);});}},{key:"deleteGroupAttributes",value:function value(e){var t=this,n=e.groupID,o=e.keyList,s=void 0===o?[]:o,a=this._getLocalGroupAttributes(n),r=a.remoteMainSequence,i=a.avChatRoomKey,u=a.attributes,c=m(u.keys()),l=Cs,p=Cr,d={groupID:n,avChatRoomKey:i,mainSequence:r},g=[];s.length>0&&(c=[],l=Is,p=Tr,s.forEach(function(e){var t=0;u.has(e)&&(t=u.get(e).sequence,c.push(e)),g.push({key:e,sequence:t});}),d.groupAttributeList=g);var _=new ka("deleteGroupAttributes");return _.setMessage("groupID:".concat(n," mainSequence:").concat(r," keyList:").concat(s," protocolName:").concat(l)),this._groupModule.request({protocolName:l,requestData:d}).then(function(e){xe.l("".concat(t._n,".").concat("deleteGroupAttributes"," ok. groupID:").concat(n));var o=e.data.mainSequence;return t._groupAttributesCopy=t._getCachedAttributes({groupID:n}),t._refreshCachedGroupAttributes({groupID:n,remoteMainSequence:o,groupAttributeList:g,operationType:p}),t._emitGroupAttributesUpdated(n),_.setNetworkType(t._groupModule.getNetworkType()).end(),Ka({keyList:c});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];_.setError(e,o,s).end();}),Ja(e);});}},{key:"getGroupAttributes",value:function value(e){var t=this,n="".concat(this._n,".").concat("getGroupAttributes"),o=e.groupID,s=this._getLocalGroupAttributes(o),a=s.avChatRoomKey,r=s.lastUpdateTime,i=s.localMainSequence,u=s.remoteMainSequence,c=new ka("getGroupAttributes");if(c.setMessage("groupID:".concat(o," localMainSequence:").concat(i," remoteMainSequence:").concat(u," keyList:").concat(e.keyList)),Date.now()-r>=this.CACHE_EXPIRE_TIME||i<u)return this._getGroupAttributes({groupID:o,avChatRoomKey:a}).then(function(s){c.setMoreMessage("get attributes from remote. count:".concat(s.length)).setNetworkType(t._groupModule.getNetworkType()).end(),xe.l("".concat(n," from remote. groupID:").concat(o));var a=t._getCachedAttributes(e);return Ka({groupAttributes:a});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];c.setError(e,o,s).end();}),Ja(e);});c.setMoreMessage("get attributes from cache").setNetworkType(this._groupModule.getNetworkType()).end(),xe.l("".concat(n," from cache. groupID:").concat(o));var l=this._getCachedAttributes(e);return za({groupAttributes:l});}},{key:"_getGroupAttributes",value:function value(e){var n=this,o=0;return at(e.avChatRoomKey)||(o=1),this._groupModule.request({protocolName:Ts,requestData:t(t({},e),{},{groupType:o})}).then(function(t){xe.l("".concat(n._n,"._getGroupAttributes ok. groupID:").concat(e.groupID));var o=t.data,s=o.mainSequence,a=o.groupAttributeList,r=m(a);return at(s)||n._refreshCachedGroupAttributes({groupID:e.groupID,remoteMainSequence:s,groupAttributeList:r,operationType:Dr}),a;}).catch(function(e){return Ja(e);});}},{key:"_refreshCachedGroupAttributes",value:function value(e){var t=e.groupID,n=e.remoteMainSequence,o=e.groupAttributeList,s=e.operationType;if(this._hasLocalGroupAttributes(t)){var a=this._getLocalGroupAttributes(t),r=a.localMainSequence;if(s===Dr||n-r==1)a.remoteMainSequence=n,a.localMainSequence=n,a.lastUpdateTime=Date.now(),this._updateCachedAttributes({groupAttributes:a,groupAttributeList:o,operationType:s});else{if(r===n)return;a.remoteMainSequence=n;}this._groupAttributesMap.set(t,a);var i="operationType:".concat(s," localMainSequence:").concat(r," remoteMainSequence:").concat(n);xe.l("".concat(this._n,"._refreshCachedGroupAttributes. ").concat(i));}}},{key:"_getCachedAttributes",value:function value(e){var t=e.groupID,n=e.keyList,o=void 0===n?[]:n,s={};if(this._hasLocalGroupAttributes(t)){var a=this._getLocalGroupAttributes(t).attributes;if(o.length>0)o.forEach(function(e){a.has(e)&&(s[e]=a.get(e).value);});else{var r,i=D(a.keys());try{for(i.s();!(r=i.n()).done;){var u=r.value;s[u]=a.get(u).value;}}catch(c){i.e(c);}finally{i.f();}}}return s;}},{key:"_updateCachedAttributes",value:function value(e){var t=e.groupAttributes,n=e.groupAttributeList,o=e.operationType;o!==Cr?o!==Tr?(o===yr&&t.attributes.clear(),n.forEach(function(e){var n=e.key,o=e.value,s=e.sequence;t.attributes.set(n,{value:o,sequence:s});})):n.forEach(function(e){t.attributes.delete(e.key);}):t.attributes.clear();}},{key:"_hasLocalGroupAttributes",value:function value(e){return this._groupAttributesMap.has(e);}},{key:"_getLocalGroupAttributes",value:function value(e){return this._hasLocalGroupAttributes(e)||this.initGroupAttributesCache({groupID:e}),this._groupAttributesMap.get(e);}},{key:"_transformGroupAttributes",value:function value(e){var t=[];return Object.keys(e).forEach(function(n){t.push({key:n,value:e[n]});}),t;}},{key:"_emitGroupAttributesUpdated",value:function value(e){var t=this._getCachedAttributes({groupID:e}),n=this._computeAttrChangedInfo(t),o=n.updatedKeyList,s=n.deletedKeyList;xe.l("".concat(this._n,"._emitGroupAttributesUpdated update:").concat(o.length,", delete:").concat(s.length)),0===o.length&&0===s.length||this._groupModule.emitOuterEvent(E.GROUP_ATTRIBUTES_UPDATED,{groupID:e,groupAttributes:t,updatedKeyList:o,deletedKeyList:s});}},{key:"_computeAttrChangedInfo",value:function value(e){var t=this,n=[],o=[];return Object.keys(e).forEach(function(o){e[o]!==t._groupAttributesCopy[o]&&n.push(o);}),Object.keys(this._groupAttributesCopy).forEach(function(t){at(e[t])&&o.push(t);}),this._groupAttributesCopy={},{updatedKeyList:n,deletedKeyList:o};}},{key:"deleteLocalGroupAttributes",value:function value(e){this._hasLocalGroupAttributes(e)&&this._groupAttributesMap.delete(e);}},{key:"reset",value:function value(){this._groupAttributesMap.clear(),this._groupAttributesCopy={},this.CACHE_EXPIRE_TIME=3e4;}}]),e;}(),Sr="Set",kr="Increase",Lr="Decrease",Ar=function(){function e(t){o(this,e),this._groupModule=t,this._n="GroupCountersHandler",this._groupCountersMap=new Map(),this.EXPIRE_TIME=3e4,this._groupModule.getInnerEmitterInstance().on($a,this._onCloudConfigUpdated,this);}return a(e,[{key:"_onCloudConfigUpdated",value:function value(){var e=this._groupModule.getCloudConfig("grp_counter_expire_time");at(e)||(this.EXPIRE_TIME=Number(e));}},{key:"isGroupCountersNotice",value:function value(e){var t=e.to,n=e.elements.groupCounterInfo,o=!1;return jt(n)||(this._onGroupCountersUpdated({groupID:t,groupCounterInfo:n}),o=!0),o;}},{key:"_onGroupCountersUpdated",value:function value(e){var t=this,n=e.groupID;e.groupCounterInfo.forEach(function(e){var o=e.type,s=e.groupCounterSeq,a=e.counterList,r=void 0===a?[]:a;0!==o&&2!==o||(t._updateLocalGroupCounters({groupID:n,groupCounterSeq:s,counterList:r}),r.forEach(function(e){t._groupModule.emitOuterEvent(E.GROUP_COUNTER_UPDATED,{groupID:n,key:e.key,value:e.value});})),1===o&&t._deleteLocalGroupCounters({groupID:n,groupCounterSeq:s,counterList:r});}),xe.l("".concat(this._n,"._onGroupCountersUpdated groupID:").concat(n));}},{key:"initGroupCountersCache",value:function value(e){var t=e.groupID,n=e.avChatRoomKey;this._groupCountersMap.set(t,{lastUpdateTime:0,groupCounterSeq:0,counters:new Map(),avChatRoomKey:n}),xe.l("".concat(this._n,".initGroupCountersCache groupID:").concat(t," avChatRoomKey:").concat(n));}},{key:"setGroupCounters",value:function value(e){var t=this;if(!this._groupModule.canIUse(B.GRP_COUNTER))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".setGroupCounters"),o=e.groupID,s=e.counters,a=this._convertObjectToList(s),r=this._getLocalGroupCounters(o).avChatRoomKey,i="groupID:".concat(o," count:").concat(a.length),u=new ka("setGroupCounters");return u.setMessage("".concat(i)),xe.l("".concat(n,". ").concat(i)),this._updateGroupCounters({groupID:o,counterList:a,avChatRoomKey:r,mode:Sr}).then(function(e){return u.end(),xe.l("".concat(n," ok.")),Ka({counters:e});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"increaseGroupCounter",value:function value(e){var t=this;if(!this._groupModule.canIUse(B.GRP_COUNTER))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".increaseGroupCounters"),o=e.groupID,s=e.key,a=e.value,r=this._getLocalGroupCounters(o).avChatRoomKey,i="groupID:".concat(o," key:").concat(s," value:").concat(a),u=new ka("increaseGroupCounter");u.setMessage("".concat(i)),xe.l("".concat(n,". ").concat(i));var c=[{key:s,value:a}];return this._updateGroupCounters({groupID:o,counterList:c,avChatRoomKey:r,mode:kr}).then(function(e){return u.end(),xe.l("".concat(n," ok.")),Ka({counters:e});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"decreaseGroupCounter",value:function value(e){var t=this;if(!this._groupModule.canIUse(B.GRP_COUNTER))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".decreaseGroupCounter"),o=e.groupID,s=e.key,a=e.value,r=this._getLocalGroupCounters(o).avChatRoomKey,i="groupID:".concat(o," key:").concat(s," value:").concat(a),u=new ka("decreaseGroupCounter");u.setMessage("".concat(i)),xe.l("".concat(n,". ").concat(i));var c=[{key:s,value:a}];return this._updateGroupCounters({groupID:o,counterList:c,avChatRoomKey:r,mode:Lr}).then(function(e){return u.end(),xe.l("".concat(n," ok.")),Ka({counters:e});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"getGroupCounters",value:function value(e){var t=this;if(!this._groupModule.canIUse(B.GRP_COUNTER))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".getGroupCounters"),o=e.groupID,s=e.keyList,a=void 0===s?[]:s,r=this._getLocalGroupCounters(o),i=r.avChatRoomKey,u=r.lastUpdateTime,c=new ka("getGroupCounters");if(c.setMessage("groupID:".concat(o)),Date.now()-u>=this.EXPIRE_TIME)return this._getRemoteGroupCounters({groupID:o,avChatRoomKey:i}).then(function(e){c.setMoreMessage("from remote. count:".concat(e.length)).end(),xe.l("".concat(n," from remote. groupID:").concat(o));var s=t._getLocalCounters(o,a);return Ka({counters:s});}).catch(function(e){return t._groupModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];c.setError(e,o,s).end();}),Ja(e);});c.setMoreMessage("from cache").end(),xe.l("".concat(n," from cache. groupID:").concat(o));var l=this._getLocalCounters(o,a);return za({counters:l});}},{key:"_getRemoteGroupCounters",value:function value(e){var n=this;return this._groupModule.request({protocolName:Ls,requestData:t({},e)}).then(function(t){var o=t.data,s=o.counterList,a=void 0===s?[]:s,r=o.groupCounterSeq;return n._updateLocalGroupCounters({groupID:e.groupID,counterList:a,groupCounterSeq:r}),xe.l("".concat(n._n,"._getRemoteGroupCounters ok. groupID:").concat(e.groupID)),a;}).catch(function(e){return Ja(e);});}},{key:"_convertObjectToList",value:function value(e){var t=[];return Object.keys(e).forEach(function(n){t.push({key:n,value:e[n]});}),t;}},{key:"_updateGroupCounters",value:function value(e){var n="".concat(this._n,"._updateGroupCounters"),o=e.groupID,s=e.avChatRoomKey,a=e.mode;return xe.l("".concat(n,". groupID:").concat(o," avChatRoomKey:").concat(s," mode:").concat(a)),this._groupModule.request({protocolName:ks,requestData:t({},e)}).then(function(e){xe.l("".concat(n," ok."));var t=e.data.counterList,o={};return(void 0===t?[]:t).forEach(function(e){var t=e.key,n=e.value;o[t]=n;}),o;}).catch(function(e){return Ja(e);});}},{key:"_hasLocalGroupCounters",value:function value(e){return this._groupCountersMap.has(e);}},{key:"_getLocalGroupCounters",value:function value(e){return this._hasLocalGroupCounters(e)||this.initGroupCountersCache({groupID:e}),this._groupCountersMap.get(e);}},{key:"_updateLocalGroupCounters",value:function value(e){var t=e.groupID,n=e.counterList,o=void 0===n?[]:n,s=e.groupCounterSeq;if(this._hasLocalGroupCounters(t)){var a=this._getLocalGroupCounters(t),r=a.counters,i=a.avChatRoomKey,u=a.groupCounterSeq;if(s>0&&s<u)return;o.forEach(function(e){var t=e.key,n=e.value;r.set(t,n);}),this._groupCountersMap.set(t,{lastUpdateTime:Date.now(),groupCounterSeq:s,counters:r,avChatRoomKey:i});}}},{key:"_deleteLocalGroupCounters",value:function value(e){var t=e.groupID,n=e.counterList,o=void 0===n?[]:n,s=e.groupCounterSeq;if(this._hasLocalGroupCounters(t)){var a=this._getLocalGroupCounters(t),r=a.counters,i=a.avChatRoomKey;o.forEach(function(e){r.delete(e.key);}),this._groupCountersMap.set(t,{lastUpdateTime:Date.now(),groupCounterSeq:s,counters:r,avChatRoomKey:i});}}},{key:"_getLocalCounters",value:function value(e,t){var n={};if(!this._hasLocalGroupCounters(e))return n;var o=this._getLocalGroupCounters(e).counters;if(t.length>0)t.forEach(function(e){o.has(e)&&(n[e]=o.get(e));});else{var s,a=D(o.keys());try{for(a.s();!(s=a.n()).done;){var r=s.value;n[r]=o.get(r);}}catch(i){a.e(i);}finally{a.f();}}return n;}},{key:"reset",value:function value(){this._groupCountersMap.clear(),this.EXPIRE_TIME=3e4;}}]),e;}(),Rr=function(){function e(t){o(this,e);var n=t.manager,s=t.groupID,a=t.onInit,r=t.onSuccess,i=t.onFail;this._n="Polling",this._manager=n,this._groupModule=n._groupModule,this._onInit=a,this._onSuccess=r,this._onFail=i,this._groupID=s,this._timeoutID=-1,this._isRunning=!1,this._protocolName=_s;}return a(e,[{key:"start",value:function value(){var e=this._groupModule.isLoggedIn();e||(this._protocolName=hs),xe.l("".concat(this._n,".start pollingInterval:").concat(this._manager.getPollingInterval()," isLoggedIn:").concat(e)),this._isRunning=!0,this._request();}},{key:"isRunning",value:function value(){return this._isRunning;}},{key:"_request",value:function value(){var e=this,t=this._onInit(this._groupID);this._groupModule.request({protocolName:this._protocolName,requestData:t}).then(function(t){e._onSuccess(e._groupID,t),e.isRunning()&&(clearTimeout(e._timeoutID),e._timeoutID=setTimeout(e._request.bind(e),e._manager.getPollingInterval()));}).catch(function(t){e._onFail(e._groupID,t),e.isRunning()&&(clearTimeout(e._timeoutID),e._timeoutID=setTimeout(e._request.bind(e),e._manager.MAX_POLLING_INTERVAL));});}},{key:"stop",value:function value(){xe.l("".concat(this._n,".stop")),this._timeoutID>0&&(clearTimeout(this._timeoutID),this._timeoutID=-1),this._isRunning=!1;}},{key:"getPollingTimerID",value:function value(){return this._timeoutID;}}]),e;}(),Nr={3:!0,4:!0,5:!0,6:!0,17:!0},Or=function(){function e(t){o(this,e),this._groupModule=t,this._n="AVChatRoomHandler",this._joinedGroupMap=new Map(),this._pollingRequestInfoMap=new Map(),this._pollingInstanceMap=new Map(),this.sequencesLinkedList=new lr(200),this.messageIDLinkedList=new lr(100),this.receivedMessageCount=0,this._reportMessageStackedCount=0,this._onlineMemberCountMap=new Map(),this.DEFAULT_EXPIRE_TIME=60,this.DEFAULT_POLLING_INTERVAL=300,this.MAX_POLLING_INTERVAL=2e3,this._pollingInterval=this.DEFAULT_POLLING_INTERVAL,this.DEFAULT_POLLING_NO_MESSAGE_COUNT=20,this.DEFAULT_POLLING_INTERVAL_PLUS=2e3,this._pollingNoMessageCount=0,this._startBroadcastSeq=1,this._broadcastMessageIDMap=new Map(),this.DEFAULT_POLLING_SIMPLIFIED_MSG=0;}return a(e,[{key:"hasJoinedAVChatRoom",value:function value(){return this._joinedGroupMap.size>0;}},{key:"checkJoinedAVChatRoomByID",value:function value(e){return this._joinedGroupMap.has(e);}},{key:"getJoinedAVChatRoom",value:function value(){return this._joinedGroupMap.size>0?m(this._joinedGroupMap.keys()):null;}},{key:"_updateRequestData",value:function value(e){var n=this._pollingRequestInfoMap.get(e);return e===m(this._pollingInstanceMap.keys())[0]?t(t({},n),{},{startBroadcastSeq:this._startBroadcastSeq,simplifiedMessage:this.DEFAULT_POLLING_SIMPLIFIED_MSG}):t(t({},n),{},{simplifiedMessage:this.DEFAULT_POLLING_SIMPLIFIED_MSG});}},{key:"_handleSuccess",value:function value(e,t){var n=t.data,o=n.key,s=n.nextSeq,a=n.rspMsgList,r=n.errorCode,i=n.nextBroadcastSeq,u=n.broadcastMessageList;if(0!==r){var c=this._pollingRequestInfoMap.get(e),l=new ka("longPollingAVError"),p=c?"".concat(c.key,"-").concat(c.startSeq):"requestInfo is undefined";l.setMessage("".concat(e,"-").concat(p,"-").concat(t.errorInfo)).setCode(t.errorCode).setNetworkType(this._groupModule.getNetworkType()).end(!0);}else{if(!this.checkJoinedAVChatRoomByID(e))return;et(o)&&$e(s)&&this._pollingRequestInfoMap.set(e,{key:o,startSeq:s}),$e(i)&&i>this._startBroadcastSeq&&(this._startBroadcastSeq=i),st(a)&&a.length>0?(a.forEach(function(e){e.to=e.groupID;}),this.onMessage(a)):(this._pollingNoMessageCount+=1,this._pollingNoMessageCount===this.DEFAULT_POLLING_NO_MESSAGE_COUNT&&(this._pollingInterval=this.DEFAULT_POLLING_INTERVAL+this.DEFAULT_POLLING_INTERVAL_PLUS)),this._onBroadcastMessage(u);}}},{key:"_handleFailure",value:function value(e,t){}},{key:"onMessage",value:function value(e){if(st(e)&&0!==e.length){0!==this._pollingNoMessageCount&&(this._pollingNoMessageCount=0,this._pollingInterval=this.DEFAULT_POLLING_INTERVAL);var t=null,n=[],o=this._getModule(Fn),s=this._getModule($n),a=e.length;a>1&&e.sort(function(e,t){return e.sequence-t.sequence;});for(var r=this._getModule(qn),i=0;i<a;i++){var u=this.restoreMessageFromSimplified(e[i]);if(Nr[u.event]){if(6===u.event){if(this._groupModule.isGroupAttributesUpdatedNotice(u))continue;if(this._groupModule.isGroupCountersNotice(u))continue;}this.receivedMessageCount+=1,t=this.packMessage(u,u.event);var c=1===u.isModified,l=1===u.isHistoryMessage;if((r.isUnlimitedAVChatRoom()||!this.sequencesLinkedList.has(t.sequence))&&!this.messageIDLinkedList.has(t.ID)){var p=t.conversationID;if(this.receivedMessageCount%50==0?this._getModule(Jn).detectFirstRound(p,this.sequencesLinkedList.data()):this.receivedMessageCount%80==0&&this._getModule(Jn).detectSecondRound(p,this.sequencesLinkedList.data()),null!==this.sequencesLinkedList.tail()){var d=this.sequencesLinkedList.tail().value,g=t.sequence-d;g>1&&g<=20?this._getModule(Jn).onMessageMaybeLost(p,d+1,g-1):g<-1&&g>=-20&&this._getModule(Jn).onMessageMaybeLost(p,t.sequence+1,Math.abs(g)-1);}this.sequencesLinkedList.set(t.sequence),this.messageIDLinkedList.set(t.ID);var _=!1;if(this._isMessageSentByCurrentInstance(t)?c&&(_=!0,t.isModified=c,o.updateMessageIsModifiedProperty(t)):_=!0,_){if(t.conversationType===S.CONV_SYSTEM&&5===t.payload.operationType&&this._onGroupDismissed(t.payload.groupProfile.groupID),!l&&t.conversationType!==S.CONV_SYSTEM){var h=t.conversationID.replace(S.CONV_GROUP,"");this._pollingInstanceMap.has(h)?this._groupModule.isLoggedIn()&&s.addMessageSequence({key:Ca,message:t}):(t.type!==S.MSG_GRP_TIP&&t.clientTime>0&&s.addMessageDelay(t.clientTime),s.addMessageSequence({key:Ia,message:t}));}n.push(t);}}}else xe.w("".concat(this._n,".onMessage unknown event:").concat(u.event));}if(0!==n.length){this._groupModule.filterModifiedMessage(n);var f=this.packConversationOption(n);if(f.length>0)this._getModule(Fn).onNewMessage({conversationOptionsList:f,isInstantMessage:!0});xe.d("".concat(this._n,".onMessage count:").concat(n.length)),this._checkMessageStacked(n);var v=this._groupModule.filterUnmodifiedMessage(n);v.length>0&&this._groupModule.emitOuterEvent(E.MESSAGE_RECEIVED,v),n.length=0;}}}},{key:"isBroadcastOrNormal",value:function value(e){return 3===e||17===e;}},{key:"isGroupTip",value:function value(e){return 4===e||6===e;}},{key:"isGroupSystemNotice",value:function value(e){return 5===e;}},{key:"restoreGroupTipElements",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e.groupJoinType||(e.groupJoinType=1);var t=e.operatorInfo,n=void 0===t?{}:t,o=e.operatorID,s=e.userIDList,a=void 0===s?[]:s,r=n.userID,i=void 0===r?o:r,u=n.avatar,c=void 0===u?"":u,l=n.nick,p=void 0===l?"":l;e.operatorInfo={userID:i,avatar:c,nick:p};var d=a.map(function(e){return{userID:e};});return e.memberInfoList=e.memberInfoList||d,e;}},{key:"restoreMessageFromSimplified",value:function value(e){var n=e.event;if(this.isBroadcastOrNormal(n)&&(e.cloudCustomData=e.cloudCustomData||"",e.elements=e.elements.map(function(e){if(e.type===S.MSG_CUSTOM){var n=e.content,o=void 0===n?{}:n;e.content=t({data:"",description:"",extension:""},o);}return e;})),(this.isGroupTip(n)||this.isGroupSystemNotice(n))&&(e.from=e.from||"@TIM#SYSTEM"),this.isGroupTip(n)){e.elements=this.restoreGroupTipElements(e.elements);var o=e.elements,s=void 0===o?{}:o,a=s.operationType,i=s.operatorInfo;if(1===a){var u=[{userID:(void 0===i?{}:i).userID}];s.memberInfoList=s.memberInfoList||u;}}if(this.isGroupSystemNotice(n)){var c=e.elements,l=c.memberInfoList,p=c.operatorInfo;l||(l=void 0===p?{}:p),e.elements.memberInfoList=t({userID:e.elements.operatorID,avatar:"",nick:""},l),e.elements=t({authentication:"",remarkInfo:"",messageKey:1e3*e.time},e.elements);var d=Object.keys(e.elements).filter(function(e){return"operatorInfo"!==e;}).reduce(function(n,o){return t(t({},n),{},r({},o,e.elements[o]));},{});e.elements=d;}return e;}},{key:"_onGroupDismissed",value:function value(e){xe.l("".concat(this._n,"._onGroupDismissed groupID:").concat(e)),this._groupModule.deleteLocalGroupAndConversation(e),this.reset(e);}},{key:"_checkMessageStacked",value:function value(e){var t="MessageStacked",n=e.length;n>=100&&(this._groupModule.outputWarning(t,n),this._reportMessageStackedCount<5&&(new ka(t).setNetworkType(this._groupModule.getNetworkType()).setMessage("count:".concat(n," groupID:").concat(m(this._joinedGroupMap.keys()))).setLevel("warning").end(),this._reportMessageStackedCount+=1));}},{key:"_isMessageSentByCurrentInstance",value:function value(e){return!!this._getModule(Fn).isMessageSentByCurrentInstance(e);}},{key:"packMessage",value:function value(e,t){e.currentUser=this._groupModule.getMyUserID(),e.conversationType=5===t?S.CONV_SYSTEM:S.CONV_GROUP,e.isSystemMessage=!!e.isSystemMessage;var n=new Ha(e),o=this.packElements(e,t);return n.setElement(o,this._groupModule.getFileDownloadProxy()),n;}},{key:"packElements",value:function value(e,n){return 4===n||6===n?(this._updateMemberCountByGroupTips(e),{type:S.MSG_GRP_TIP,content:t(t({},e.elements),{},{groupProfile:e.groupProfile})}):5===n?{type:S.MSG_GRP_SYS_NOTICE,content:t(t({},e.elements),{},{groupProfile:t(t({},e.groupProfile),{},{groupID:e.groupID})})}:this._getModule(Hn).parseElements(e.elements,e.from);}},{key:"packConversationOption",value:function value(e){for(var t=new Map(),n=0;n<e.length;n++){var o=e[n],s=o.conversationID;if(t.has(s)){var a=t.get(s);a.lastMessage=o,"in"===o.flow&&a.unreadCount++;}else t.set(s,{conversationID:o.conversationID,unreadCount:"out"===o.flow?0:1,type:o.conversationType,subType:o.conversationSubType,lastMessage:o});}return m(t.values());}},{key:"_updateMemberCountByGroupTips",value:function value(e){var t=e.groupProfile.groupID,n=e.elements.onlineMemberInfo,o=void 0===n?void 0:n;if(!jt(o)){var s=o.onlineMemberNum,a=void 0===s?0:s,r=o.expireTime,i=void 0===r?this.DEFAULT_EXPIRE_TIME:r,u=this._onlineMemberCountMap.get(t)||{},c=Date.now();jt(u)?Object.assign(u,{lastReqTime:0,lastSyncTime:0,latestUpdateTime:c,memberCount:a,expireTime:i}):(u.latestUpdateTime=c,u.memberCount=a),xe.d("".concat(this._n,"._updateMemberCountByGroupTips info:"),u),this._onlineMemberCountMap.set(t,u);}}},{key:"_onBroadcastMessage",value:function value(e){if(!jt(e)){for(var t=[],n=e.length,o=null,s=0;s<n;s++){var a=this.restoreMessageFromSimplified(e[s]);Nr[a.event]?((o=this.packMessage(a,a.event)).isBroadcastMessage=!0,this._broadcastMessageIDMap.has(o.ID)||(t.push(o),this._broadcastMessageIDMap.set(o.ID,1))):xe.w("".concat(this._n,"._onBroadcastMessage unknown event:").concat(a.event));}t.length>0&&this._groupModule.emitOuterEvent(E.MESSAGE_RECEIVED,t);}}},{key:"start",value:function value(e){if(this._pollingInstanceMap.has(e)){var t=this._pollingInstanceMap.get(e);t.isRunning()||t.start();}else{var n=new Rr({manager:this,groupID:e,onInit:this._updateRequestData.bind(this),onSuccess:this._handleSuccess.bind(this),onFail:this._handleFailure.bind(this)});n.start(),this._pollingInstanceMap.set(e,n),xe.l("".concat(this._n,".start groupID:").concat(e));}}},{key:"handleJoinResult",value:function value(e){var t=this;return this._preCheck().then(function(){var n=e.longPollingKey,o=e.group,s=o.groupID;return t._joinedGroupMap.set(s,o),t._groupModule.updateGroupMap([o]),t._groupModule.deleteUnjoinedAVChatRoom(s),t._groupModule.emitGroupListUpdate(!0,!1),at(n)?za({status:Ye,group:o}):Promise.resolve();});}},{key:"startRunLoop",value:function value(e){var t=this;return this.handleJoinResult(e).then(function(){var n=e.longPollingKey,o=e.group,s=e.startSeq,a=void 0===s?0:s,r=o.groupID;return t._pollingRequestInfoMap.set(r,{key:n,startSeq:a}),t.start(r),t._groupModule.isLoggedIn()?za({status:Ye,group:o}):za({status:Ye});});}},{key:"_preCheck",value:function value(){if(this._getModule(qn).isUnlimitedAVChatRoom())return Promise.resolve();if(!this.hasJoinedAVChatRoom())return Promise.resolve();var e=v(this._joinedGroupMap.entries().next().value,2),t=e[0],n=e[1];if(this._groupModule.isLoggedIn()){if(!(n.selfInfo.role===S.GRP_MBR_ROLE_OWNER||n.ownerID===this._groupModule.getMyUserID()))return this._groupModule.quitGroup(t);this._groupModule.deleteLocalGroupAndConversation(t);}else this._groupModule.deleteLocalGroupAndConversation(t);return this.reset(t),Promise.resolve();}},{key:"joinWithoutAuth",value:function value(e){var t=this,n=e.groupID,o="".concat(this._n,".").concat("joinWithoutAuth"),s=new ka("joinWithoutAuth");return this._groupModule.request({protocolName:Qo,requestData:e}).then(function(e){var a=e.data.longPollingKey;if(t._groupModule.probeNetwork().then(function(e){var t=v(e,2);t[0];var o=t[1];s.setNetworkType(o).setMessage("groupID:".concat(n," longPollingKey:").concat(a)).end(!0);}),at(a))return Ja({code:da.CANNOT_JOIN_NON_AVCHATROOM_WITHOUT_LOGIN});xe.l("".concat(o," ok. groupID:").concat(n)),t._getModule(Fn).setCompleted("".concat(S.CONV_GROUP).concat(n));var r=new dr({groupID:n});return t.startRunLoop({group:r,longPollingKey:a}),Ka({status:Ye});}).catch(function(e){return xe.e("".concat(o," failed. groupID:").concat(n," error:"),e),t._groupModule.probeNetwork().then(function(t){var o=v(t,2),a=o[0],r=o[1];s.setError(e,a,r).setMessage("groupID:".concat(n)).end(!0);}),Ja(e);}).finally(function(){t._groupModule.getModule(Vn).reportAtOnce();});}},{key:"getGroupOnlineMemberCount",value:function value(e){var t=this._onlineMemberCountMap.get(e)||{},n=Date.now();return jt(t)||n-t.lastSyncTime>1e3*t.expireTime&&n-t.latestUpdateTime>1e4&&n-t.lastReqTime>3e3?(t.lastReqTime=n,this._onlineMemberCountMap.set(e,t),this._getGroupOnlineMemberCount(e).then(function(e){return Ka({memberCount:e.memberCount});}).catch(function(e){return Ja(e);})):za({memberCount:t.memberCount});}},{key:"_getGroupOnlineMemberCount",value:function value(e){var t=this,n="".concat(this._n,".").concat("_getGroupOnlineMemberCount");return this._groupModule.request({protocolName:fs,requestData:{groupID:e}}).then(function(o){var s=t._onlineMemberCountMap.get(e)||{},a=o.data,r=a.onlineMemberNum,i=void 0===r?0:r,u=a.expireTime,c=void 0===u?t.DEFAULT_EXPIRE_TIME:u;xe.l("".concat(n," ok. groupID:").concat(e," memberCount:").concat(i," expireTime:").concat(c));var l=Date.now();return jt(s)&&(s.lastReqTime=l),t._onlineMemberCountMap.set(e,Object.assign(s,{lastSyncTime:l,latestUpdateTime:l,memberCount:i,expireTime:c})),{memberCount:i};}).catch(function(o){return xe.w("".concat(n," failed. error:"),o),new ka("_getGroupOnlineMemberCount").setCode(o.code).setMessage("groupID:".concat(e," error:").concat(JSON.stringify(o))).setNetworkType(t._groupModule.getNetworkType()).end(),Promise.reject(o);});}},{key:"_getModule",value:function value(e){return this._groupModule.getModule(e);}},{key:"setPollingInterval",value:function value(e){at(e)||($e(e)?this._pollingInterval=this.DEFAULT_POLLING_INTERVAL=e:this._pollingInterval=this.DEFAULT_POLLING_INTERVAL=parseInt(e,10));}},{key:"setPollingIntervalPlus",value:function value(e){at(e)||($e(e)?this.DEFAULT_POLLING_INTERVAL_PLUS=e:this.DEFAULT_POLLING_INTERVAL_PLUS=parseInt(e,10));}},{key:"setPollingNoMessageCount",value:function value(e){at(e)||($e(e)?this.DEFAULT_POLLING_NO_MESSAGE_COUNT=e:this.DEFAULT_POLLING_NO_MESSAGE_COUNT=parseInt(e,10));}},{key:"setPollingSimplifiedMessage",value:function value(e){at(e)||"0"!==e&&"1"!==e||(this.DEFAULT_POLLING_SIMPLIFIED_MSG=parseInt(e,10));}},{key:"getPollingInterval",value:function value(){return this._pollingInterval;}},{key:"onAVChatRoomMemberBanned",value:function value(e){var t=e.payload.groupProfile.groupID;xe.l("".concat(this._n,".onAVChatRoomMemberBanned groupID:").concat(t)),this._groupModule.deleteLocalGroupAndConversation(t),this.reset(t);}},{key:"restartPolling",value:function value(){xe.l("".concat(this._n,".restartPolling count:").concat(this._pollingInstanceMap.size));var e,t=D(this._pollingInstanceMap.values());try{for(t.s();!(e=t.n()).done;){var n=e.value;n.stop(),n.start();}}catch(o){t.e(o);}finally{t.f();}}},{key:"getPollingTimerID",value:function value(e){if(!this._pollingInstanceMap.has(e))return-1;var t=this._pollingInstanceMap.get(e).getPollingTimerID();return xe.l("".concat(this._n,".getPollingTimerID groupID:").concat(e," timerID:").concat(t)),t;}},{key:"reset",value:function value(e){if(e){xe.l("".concat(this._n,".reset groupID:").concat(e));var t=this._pollingInstanceMap.get(e);t&&t.stop(),this._pollingInstanceMap.delete(e),this._joinedGroupMap.delete(e),this._pollingRequestInfoMap.delete(e),this._onlineMemberCountMap.delete(e);}else{xe.l("".concat(this._n,".reset all"));var n,o=D(this._pollingInstanceMap.values());try{for(o.s();!(n=o.n()).done;){n.value.stop();}}catch(s){o.e(s);}finally{o.f();}this._pollingInstanceMap.clear(),this._joinedGroupMap.clear(),this._pollingRequestInfoMap.clear(),this._onlineMemberCountMap.clear(),this._broadcastMessageIDMap.clear();}this.sequencesLinkedList.reset(),this.messageIDLinkedList.reset(),this.receivedMessageCount=0,this._reportMessageStackedCount=0,this._pollingInterval=this.DEFAULT_POLLING_INTERVAL=300,this.DEFAULT_POLLING_NO_MESSAGE_COUNT=20,this.DEFAULT_POLLING_INTERVAL_PLUS=2e3,this._pollingNoMessageCount=0;}}]),e;}(),Gr=1,Ur=15,Pr=function(){function e(t){o(this,e),this._groupModule=t,this._n="GroupSystemNoticeHandler",this.pendencyMap=new Map();}return a(e,[{key:"onNewGroupSystemNotice",value:function value(e){var t=e.dataList,n=e.isSyncingEnded,o=e.isInstantMessage;xe.d("".concat(this._n,".onReceiveSystemNotice count:").concat(t.length));var s=this.newSystemNoticeStoredAndSummary({notifiesList:t,isInstantMessage:o}),a=s.eventDataList,r=s.result;a.length>0&&(this._groupModule.getModule(Fn).onNewMessage({conversationOptionsList:a,isInstantMessage:o}),this._onReceivedGroupSystemNotice({result:r,isInstantMessage:o}));o?r.length>0&&this._groupModule.emitOuterEvent(E.MESSAGE_RECEIVED,r):!0===n&&this._clearGroupSystemNotice();}},{key:"newSystemNoticeStoredAndSummary",value:function value(e){var n=e.notifiesList,o=e.isInstantMessage,s=null,a=n.length,r=0,i=[],u={conversationID:S.CONV_SYSTEM,unreadCount:0,type:S.CONV_SYSTEM,subType:null,lastMessage:null};for(r=0;r<a;r++){var c=n[r],l=c.groupProfile,p=l.communityType,d=void 0===p?0:p,g=l.topicID,_=void 0===g?void 0:g,h=c.elements,f=h.topicIDList,v=void 0===f?void 0:f,m=h.operationType;if(!(2!==d||jt(_)&&jt(v))){if([17,18,20].includes(m)){this._handleTopicSystemNotice(c);continue;}jt(_)||(c.to=_);}if(c.elements.operationType!==Ur)c.currentUser=this._groupModule.getMyUserID(),c.conversationType=S.CONV_SYSTEM,c.conversationID=S.CONV_SYSTEM,(s=new Ha(c)).setElement({type:S.MSG_GRP_SYS_NOTICE,content:t(t({},c.elements),{},{groupProfile:t({},c.groupProfile)})}),s.isSystemMessage=!0,(1===s.sequence&&1===s.random||2===s.sequence&&2===s.random)&&(s.sequence=_t(),s.random=_t(),s.generateMessageID(),xe.l("".concat(this._n,".newSystemNoticeStoredAndSummary sequence and random maybe duplicated, regenerate. ID:").concat(s.ID))),this._groupModule.getModule(Fn).pushIntoNoticeResult(i,s)&&(o?u.unreadCount++:s.setIsRead(!0),u.subType=s.conversationSubType);}return u.lastMessage=i[i.length-1],{eventDataList:i.length>0?[u]:[],result:i};}},{key:"_clearGroupSystemNotice",value:function value(){var e=this;this._getPendencyList().then(function(t){t.forEach(function(t){e.pendencyMap.set("".concat(t.from,"_").concat(t.groupID,"_").concat(t.to),t);});var n=e._groupModule.getModule(Fn).getLocalMessageList(S.CONV_SYSTEM),o=[];n.forEach(function(t){var n=t.payload,s=n.operatorID,a=n.operationType,r=n.groupProfile;if(a===Gr){var i="".concat(s,"_").concat(r.groupID,"_").concat(r.to),u=e.pendencyMap.get(i);u&&$e(u.handled)&&0!==u.handled&&o.push(t);}}),e.deleteGroupSystemNotice({messageList:o});});}},{key:"deleteGroupSystemNotice",value:function value(e){var t=this,n="".concat(this._n,".deleteGroupSystemNotice");return st(e.messageList)&&0!==e.messageList.length?(xe.l("".concat(n," ")+e.messageList.map(function(e){return e.ID;})),this._groupModule.request({protocolName:gs,requestData:{messageListToDelete:e.messageList.map(function(e){return{from:S.CONV_SYSTEM,messageSeq:e.clientSequence,messageRandom:e.random};})}}).then(function(){xe.l("".concat(n," ok"));var o=t._groupModule.getModule(Fn);return e.messageList.forEach(function(e){o.deleteLocalMessage(e);}),Ka();}).catch(function(e){return xe.e("".concat(n," error:"),e),Ja(e);})):za();}},{key:"_getPendencyList",value:function value(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.type,o=void 0===n?void 0:n,s=t.startTime,a=void 0===s?0:s,r=t.limit,i=void 0===r?20:r;return this._groupModule.request({protocolName:ds,requestData:{type:o,startTime:a,limit:i,handleAccount:this._groupModule.getMyUserID()}}).then(function(t){var n=t.data.pendencyList;return 0!==t.data.nextStartTime?e._getPendencyList({startTime:t.data.nextStartTime}).then(function(e){return[].concat(m(n),m(e));}):n;});}},{key:"getGroupApplicationList",value:function value(){var e=this;return this._getPendencyList().then(function(t){return e._getPendencyList({type:S.GRP_COMMUNITY}).then(function(n){return t.push.apply(t,m(n)),e._handlePendencyResult(t);}).catch(function(n){return e._handlePendencyResult(t);});});}},{key:"_handlePendencyResult",value:function value(e){var t=this,n=[];return e.forEach(function(e){t.pendencyMap.set("".concat(e.from,"_").concat(e.groupID,"_").concat(e.to),e),0===e.handled&&n.push({applicant:e.from,applicantNick:e.fromUserNickName,groupName:e.groupName,groupID:e.groupID,authentication:e.authentication,messageKey:e.time,applicationType:e.applicationType,userID:e.userID});}),za({applicationList:n});}},{key:"_onReceivedGroupSystemNotice",value:function value(e){var t=this,n=e.result;e.isInstantMessage&&n.forEach(function(e){switch(e.payload.operationType){case 1:break;case 2:t._onApplyGroupRequestAgreed(e);break;case 3:break;case 4:t._onMemberKicked(e);break;case 5:t._onGroupDismissed(e);break;case 6:break;case 7:t._onInviteGroup(e);break;case 8:t._onQuitGroup(e);break;case 9:t._onSetManager(e);break;case 10:t._onDeleteManager(e);break;case 11:case 12:case 15:break;case 20:t._onMessageRemindTypeSynced(e);break;case 21:t._groupModule.onAVChatRoomMemberBanned(e);}});}},{key:"_onApplyGroupRequestAgreed",value:function value(e){var t=this,n=e.payload.groupProfile.groupID;this._groupModule.hasLocalGroup(n)||this._groupModule.getGroupProfile({groupID:n}).then(function(e){var n=e.data.group;if(n){t._groupModule.updateGroupMap([n]);var o=!n.isSupportTopic;t._groupModule.emitGroupListUpdate(!0,o);}});}},{key:"_onMemberKicked",value:function value(e){var t=e.payload.groupProfile.groupID;this._groupModule.hasLocalGroup(t)&&this._groupModule.deleteLocalGroupAndConversation(t);}},{key:"_onGroupDismissed",value:function value(e){var t=e.payload.groupProfile.groupID;this._groupModule.hasLocalGroup(t)&&this._groupModule.deleteLocalGroupAndConversation(t);var n=this._groupModule._AVChatRoomHandler;n&&n.checkJoinedAVChatRoomByID(t)&&n.reset(t);}},{key:"_onInviteGroup",value:function value(e){var t=this,n=e.payload.groupProfile.groupID;this._groupModule.hasLocalGroup(n)||this._groupModule.getGroupProfile({groupID:n}).then(function(e){var n=e.data.group;n&&(t._groupModule.updateGroupMap([n]),t._groupModule.emitGroupListUpdate());});}},{key:"_onQuitGroup",value:function value(e){var t=e.payload.groupProfile.groupID;this._groupModule.hasLocalGroup(t)&&this._groupModule.deleteLocalGroupAndConversation(t);}},{key:"_onSetManager",value:function value(e){var t=e.payload.groupProfile,n=t.to,o=t.groupID,s=this._groupModule.getModule(bn).getLocalGroupMemberInfo(o,n);s&&s.updateRole(S.GRP_MBR_ROLE_ADMIN);}},{key:"_onDeleteManager",value:function value(e){var t=e.payload.groupProfile,n=t.to,o=t.groupID,s=this._groupModule.getModule(bn).getLocalGroupMemberInfo(o,n);s&&s.updateRole(S.GRP_MBR_ROLE_MEMBER);}},{key:"_onMessageRemindTypeSynced",value:function value(e){var t=e.payload.groupProfile.groupID,n=e.payload.messageRemindType;this._groupModule.getModule(Fn).onGroupMessageRemindTypeSynced({groupID:t,messageRemindType:n});}},{key:"_handleTopicSystemNotice",value:function value(e){var t=e.groupProfile,n=t.groupID,o=t.topicID,s=e.elements,a=s.operationType,r=s.topicIDList,i=s.messageRemindType,u=this._groupModule.getModule(wn);17===a?u.onTopicCreated({groupID:n,topicID:o}):18===a?u.onTopicDeleted({groupID:n,topicIDList:r}):20===a&&u.onTopicMessageRemindTypeUpdated({groupID:n,topicID:o,messageRemindType:i});}},{key:"reset",value:function value(){this.pendencyMap.clear();}}]),e;}(),br=["relayFlag"],wr=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="GroupModule",t._commonGroupHandler=null,t._AVChatRoomHandler=null,t._groupSystemNoticeHandler=null,t._commonGroupHandler=new Mr(_(t)),t._groupAttributesHandler=new Er(_(t)),t._groupCountersHandler=new Ar(_(t)),t._AVChatRoomHandler=new Or(_(t)),t._groupTipsHandler=new mr(_(t)),t._groupSystemNoticeHandler=new Pr(_(t)),t.groupMap=new Map(),t._unjoinedAVChatRoomList=new Map(),t._receiptDetailCompleteMap=new Map(),t.getInnerEmitterInstance().on($a,t._onCloudConfigUpdated,_(t)),t;}return a(s,[{key:"_onCloudConfigUpdated",value:function value(){var e=this.getCloudConfig("polling_interval"),t=this.getCloudConfig("polling_interval_plus"),n=this.getCloudConfig("polling_no_msg_count"),o=this.getCloudConfig("polling_simplified_msg");this._AVChatRoomHandler&&(xe.l("".concat(this._n,"._onCloudConfigUpdated pollingInterval:").concat(e)+" pollingIntervalPlus:".concat(t," pollingNoMessageCount:").concat(n)+" pollingSimplifiedMessage:".concat(o)),this._AVChatRoomHandler.setPollingInterval(e),this._AVChatRoomHandler.setPollingIntervalPlus(t),this._AVChatRoomHandler.setPollingNoMessageCount(n),this._AVChatRoomHandler.setPollingSimplifiedMessage(o));}},{key:"onCheckTimer",value:function value(e){this.isLoggedIn()&&(this._commonGroupHandler.onCheckTimer(e),this._groupTipsHandler.onCheckTimer(e));}},{key:"guardForAVChatRoom",value:function value(e){var t=this;if(e.conversationType===S.CONV_GROUP){var n=Dt(e.to)?qt(e.to):e.to;return this.hasLocalGroup(n)?za():this.getGroupProfile({groupID:n}).then(function(o){var s=o.data.group.type;if(xe.l("".concat(t._n,".guardForAVChatRoom. groupID:").concat(n," type:").concat(s)),s===S.GRP_AVCHATROOM){var a=da.MESSAGE_SEND_FAIL_NOT_IN_AVCHATROOM;return Ja(new Wa({code:a,message:t.getErrorMessage(a,e.from,n),data:{message:e}}));}return za();});}return za();}},{key:"checkJoinedAVChatRoomByID",value:function value(e){return!!this._AVChatRoomHandler&&this._AVChatRoomHandler.checkJoinedAVChatRoomByID(e);}},{key:"onNewGroupMessage",value:function value(e){this._commonGroupHandler&&this._commonGroupHandler.onNewGroupMessage(e);}},{key:"updateNextMessageSeq",value:function value(e){var t=this;if(st(e)){var n=this.getModule(wn);e.forEach(function(e){var o=e.conversationID.replace(S.CONV_GROUP,"");Dt(o)&&n.updateLastMessage(o,e.lastMessage),t.groupMap.has(o)&&(t.groupMap.get(o).nextMessageSeq=e.lastMessage.sequence+1);});}}},{key:"onNewGroupTips",value:function value(e){this._groupTipsHandler&&this._groupTipsHandler.onNewGroupTips(e);}},{key:"onGroupMessageRevoked",value:function value(e){this._commonGroupHandler&&this._commonGroupHandler.onGroupMessageRevoked(e);}},{key:"onNewGroupSystemNotice",value:function value(e){this._groupSystemNoticeHandler&&this._groupSystemNoticeHandler.onNewGroupSystemNotice(e);}},{key:"onGroupMessageReadNotice",value:function value(e){var t=this;e.dataList.forEach(function(e){var n=e.elements.groupMessageReadNotice;if(!at(n)){var o=t.getModule(Fn);n.forEach(function(e){var n=e.groupID,s=e.topicID,a=void 0===s?void 0:s,r=e.lastMessageSeq;xe.d("".concat(t._n,".onGroupMessageReadNotice groupID:").concat(n," lastMessageSeq:").concat(r));var i="".concat(S.CONV_GROUP).concat(n),u=!0;jt(a)||(i="".concat(S.CONV_GROUP).concat(a),u=!1),o.updateIsReadAfterReadReport({conversationID:i,lastMessageSeq:r}),o.updateUnreadCount(i,u),o.clearGroupAtInfoList(i,u);});}});}},{key:"onReadReceiptList",value:function value(e){var t=this;xe.d("".concat(this._n,".onReadReceiptList options:"),JSON.stringify(e)),e.dataList.forEach(function(e){var n=e.groupProfile,o=e.elements,s=n.groupID,a=t.getModule(Fn),r=o.readReceiptList;a.updateReadReceiptInfo({groupID:s,readReceiptList:r});});}},{key:"onGroupMessageModified",value:function value(e){xe.d("".concat(this._n,".onGroupMessageModified options:"),JSON.stringify(e));var n=this.getModule(Fn);e.dataList.forEach(function(e){n.onMessageModified(t(t({},e),{},{conversationType:S.CONV_GROUP,to:e.topicID?e.topicID:e.groupID}));});}},{key:"deleteGroupSystemNotice",value:function value(e){this._groupSystemNoticeHandler&&this._groupSystemNoticeHandler.deleteGroupSystemNotice(e);}},{key:"initGroupMap",value:function value(e){this.groupMap.set(e.groupID,new dr(e));}},{key:"deleteGroup",value:function value(e){this.groupMap.delete(e);}},{key:"updateGroupMap",value:function value(e){var t,n=this,o=this.getModule(Fn);e.forEach(function(e){t=e.groupID,n.groupMap.has(t)?n.groupMap.get(t).updateGroup(e):(n.groupMap.set(t,new dr(e)),o.deleteGroupRomaingMessageInfo(t));});var s,a=this.getMyUserID(),r=D(this.groupMap);try{for(r.s();!(s=r.n()).done;){var i=v(s.value,2)[1];i.selfInfo.userID=a,"Owner"===i.selfInfo.role&&(i.ownerID=a);}}catch(u){r.e(u);}finally{r.f();}this._setStorageGroupList();}},{key:"getStorageGroupList",value:function value(){return this.getModule(xn).getItem("groupMap");}},{key:"_setStorageGroupList",value:function value(){var e=this.getLocalGroupList().filter(function(e){var t=e.type;return!Ct(t);}).filter(function(e){return!e.isSupportTopic;}).slice(0,20).map(function(e){return{groupID:e.groupID,name:e.name,avatar:e.avatar,type:e.type};});this.getModule(xn).setItem("groupMap",e);}},{key:"getGroupMap",value:function value(){return this.groupMap;}},{key:"getLocalGroupList",value:function value(){return m(this.groupMap.values());}},{key:"getLocalGroupProfile",value:function value(e){return this.groupMap.get(e);}},{key:"sortLocalGroupList",value:function value(){var e=m(this.groupMap).filter(function(e){var t=v(e,2);return t[0],!jt(t[1].lastMessage);});e.sort(function(e,t){return t[1].lastMessage.lastTime-e[1].lastMessage.lastTime;}),this.groupMap=new Map(m(e));}},{key:"updateGroupLastMessage",value:function value(e){this._commonGroupHandler&&this._commonGroupHandler.handleUpdateGroupLastMessage(e);}},{key:"emitGroupListUpdate",value:function value(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=this.getLocalGroupList();if(e&&this.emitOuterEvent(E.GROUP_LIST_UPDATED),t){var o=JSON.parse(JSON.stringify(n)),s=this.getModule(Fn);s.updateConversationGroupProfile(o);}}},{key:"patchGroupMessageRemindType",value:function value(){var e=this.getLocalGroupList(),t=this.getModule(Fn),n=0;e.forEach(function(e){!0===t.patchMessageRemindType({ID:e.groupID,isC2CConversation:!1,messageRemindType:e.selfInfo.messageRemindType})&&(n+=1);}),xe.l("".concat(this._n,".patchGroupMessageRemindType count:").concat(n));}},{key:"recomputeUnreadCount",value:function value(){var e=this.getLocalGroupList(),t=this.getModule(Fn);e.forEach(function(e){var n=e.groupID,o=e.selfInfo,s=o.excludedUnreadSequenceList,a=o.readedSequence;if(st(s)){var r=0;s.forEach(function(t){t>=a&&t<=e.nextMessageSeq-1&&(r+=1);}),r>=1&&t.recomputeGroupUnreadCount({conversationID:"".concat(S.CONV_GROUP).concat(n),count:r});}});}},{key:"getMyNameCardByGroupID",value:function value(e){var t=this.getLocalGroupProfile(e);return t?t.selfInfo.nameCard:"";}},{key:"isPagingGetCompleted",value:function value(){return!!this._commonGroupHandler&&this._commonGroupHandler.isPagingGetCompleted();}},{key:"getGroupList",value:function value(e){return this._commonGroupHandler?this._commonGroupHandler.getGroupList(e):za();}},{key:"getGroupProfile",value:function value(e){var t=this,n="".concat(this._n,".").concat("getGroupProfile"),o=new ka("getGroupProfile"),s=e.groupID,a=e.groupCustomFieldFilter;xe.l("".concat(n," groupID:").concat(s));var r={groupIDList:[s],responseFilter:{groupBaseInfoFilter:["Type","Name","Introduction","Notification","FaceUrl","Owner_Account","CreateTime","InfoSeq","LastInfoTime","LastMsgTime","MemberNum","MaxMemberNum","ApplyJoinOption","NextMsgSeq","ShutUpAllMember","InviteJoinOption"],groupCustomFieldFilter:a,memberInfoFilter:["Role","JoinTime","MsgSeq","MsgFlag","NameCard"]}};return this.getGroupProfileAdvance(r).then(function(e){var a,r=e.data,i=r.successGroupList,u=r.failureGroupList;if(xe.l("".concat(n," ok")),u.length>0)return Ja(u[0]);(Ct(i[0].type)&&!t.hasLocalGroup(s)?a=new dr(i[0]):(t.updateGroupMap(i),a=t.getLocalGroupProfile(s)),a.isSupportTopic)||t.getModule(Fn).updateConversationGroupProfile([a]);return o.setNetworkType(t.getNetworkType()).setMessage("groupID:".concat(s," type:").concat(a.type," muteAllMembers:").concat(a.muteAllMembers," ownerID:").concat(a.ownerID)).end(),Ka({group:a});}).catch(function(s){return t.probeNetwork().then(function(t){var n=v(t,2),a=n[0],r=n[1];o.setError(s,a,r).setMessage("groupID:".concat(e.groupID)).end();}),xe.e("".concat(n," failed. error:"),s),Ja(s);});}},{key:"getGroupProfileAdvance",value:function value(e){var n="".concat(this._n,".getGroupProfileAdvance"),o=e.groupIDList;st(o)&&o.length>50&&(this.outputWarning("GetGroupProfileLimit"),o.length=50);var s=[],a=[];o.forEach(function(e){Tt({groupID:e})?a.push(e):s.push(e);});var r=[];if(s.length>0){var i=this._getGroupProfileAdvance(t(t({},e),{},{groupIDList:s}));r.push(i);}if(a.length>0){var u=this._getGroupProfileAdvance(t(t({},e),{},{groupIDList:a,relayFlag:s.length>0}));r.push(u);}return Promise.all(r).then(function(e){var t=[],n=[];return e.forEach(function(e){t.push.apply(t,m(e.successGroupList)),n.push.apply(n,m(e.failureGroupList));}),Ka({successGroupList:t,failureGroupList:n});}).catch(function(e){return xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_getGroupProfileAdvance",value:function value(e){var t=this,n=e.relayFlag,o=void 0!==n&&n,s=g(e,br);return this.request({protocolName:Yo,requestData:s}).then(function(e){xe.l("".concat(t._n,"._getGroupProfileAdvance ok."));var n=e.data.groups;return{successGroupList:n.filter(function(e){return at(e.errorCode)||0===e.errorCode;}),failureGroupList:n.filter(function(e){return e.errorCode&&0!==e.errorCode;}).map(function(e){return new Wa({code:e.errorCode,message:e.errorInfo,data:{groupID:e.groupID}});})};}).catch(function(t){return o&&Tt({groupID:e.groupIDList[0]})?{successGroupList:[],failureGroupList:[]}:Ja(t);});}},{key:"createGroup",value:function value(e){var n=this,o="".concat(this._n,".").concat("createGroup"),s=e.type,a=e.groupID;if(e.name&&!1===this._filterProfanity("name",e))return Ja({code:da.PROFANITY_FOUND});if(e.introduction&&!1===this._filterProfanity("introduction",e))return Ja({code:da.PROFANITY_FOUND});if(e.notification&&!1===this._filterProfanity("notification",e))return Ja({code:da.PROFANITY_FOUND});if(!["Public","Private","ChatRoom","AVChatRoom","Community"].includes(s))return Ja({code:da.ILLEGAL_GROUP_TYPE});if(!Tt({type:s})){if(!jt(a)&&Tt({groupID:a}))return Ja({code:da.ILLEGAL_GROUP_ID});e.isSupportTopic=void 0;}if(Ct(s)&&!at(e.memberList)&&e.memberList.length>0&&(e.memberList=void 0),this._canIUseJoinOption(s)||at(e.joinOption)||(e.joinOption=void 0),Tt({type:s})){if(!jt(a)&&!Tt({groupID:a}))return Ja({code:da.ILLEGAL_GROUP_ID});e.isSupportTopic=!0===e.isSupportTopic?1:0;}var r=new ka("createGroup");xe.l("".concat(o," options:"),e);var i=null,u=[];return this.request({protocolName:jo,requestData:t(t({},e),{},{ownerID:this.getMyUserID(),webPushFlag:1})}).then(function(s){var a=s.data,c=a.groupID,l=a.overLimitUserIDList,p=void 0===l?[]:l;if(i=c,u=p,r.setNetworkType(n.getNetworkType()).setMessage("groupType:".concat(e.type," groupID:").concat(c," overLimitUserIDList=").concat(p)).end(),xe.l("".concat(o," ok groupID:").concat(c," overLimitUserIDList:"),p),e.type===S.GRP_AVCHATROOM)return n.getGroupProfile({groupID:c});if(e.type===S.GRP_COMMUNITY&&1===e.isSupportTopic)return n.getGroupProfile({groupID:c});jt(e.memberList)||jt(p)||(e.memberList=e.memberList.filter(function(e){return-1===p.indexOf(e.userID);})),n.updateGroupMap([t(t({},e),{},{groupID:c})]);var d=n.getModule(Rn),g=d.createCustomMessage({to:c,conversationType:S.CONV_GROUP,payload:{data:"group_create",extension:n.isIntl()?"".concat(n.getMyUserID()," created a group"):"".concat(n.getMyUserID(),"创建群组")}});return d.sendMessageInstance(g),n.emitGroupListUpdate(),n.getGroupProfile({groupID:c});}).then(function(e){var t=e.data.group,n=t.selfInfo,o=n.nameCard,s=n.joinTime;return t.updateSelfInfo({nameCard:o,joinTime:s,messageRemindType:S.MSG_REMIND_ACPT_AND_NOTE,role:S.GRP_MBR_ROLE_OWNER}),Ka({group:t,overLimitUserIDList:u});}).catch(function(s){if(r.setMessage("groupType:".concat(e.type)),n.probeNetwork().then(function(e){var t=v(e,2),n=t[0],o=t[1];r.setError(s,n,o).end();}),10010===s.code||10007===s.code){n.updateGroupMap([t(t({},e),{},{groupID:i})]);var a=n.getLocalGroupProfile(i);return xe.l("".concat(o," success, but failed to get group profile.")),Ka({group:a,overLimitUserIDList:u});}return xe.e("".concat(o," failed. error:"),s),Ja(s);});}},{key:"dismissGroup",value:function value(e){var t=this,n="".concat(this._n,".").concat("dismissGroup");if(this.hasLocalGroup(e)&&this.getLocalGroupProfile(e).type===S.GRP_WORK)return Ja(new Wa({code:da.CANNOT_DISMISS_WORK}));var o=new ka("dismissGroup");return o.setMessage("groupID:".concat(e)),xe.l("".concat(n," groupID:").concat(e)),this.request({protocolName:zo,requestData:{groupID:e}}).then(function(){return o.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok")),t.deleteLocalGroupAndConversation(e),t.checkJoinedAVChatRoomByID(e)&&t._AVChatRoomHandler.reset(e),t._groupAttributesHandler.deleteLocalGroupAttributes(e),Ka({groupID:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"updateGroupProfile",value:function value(e){var t=this,n="".concat(this._n,".").concat("updateGroupProfile");if(this.hasLocalGroup(e.groupID)){var o=this.getLocalGroupProfile(e.groupID).type;this._canIUseJoinOption(o)||at(e.joinOption)||(xe.w("".concat(n," joinOption is unavailable for Work/Meeting/AVChatRoom")),e.joinOption=void 0);}if(at(e.muteAllMembers)||(e.muteAllMembers?e.muteAllMembers="On":e.muteAllMembers="Off"),e.name&&!1===this._filterProfanity("name",e))return Ja({code:da.PROFANITY_FOUND});if(e.introduction&&!1===this._filterProfanity("introduction",e))return Ja({code:da.PROFANITY_FOUND});if(e.notification&&!1===this._filterProfanity("notification",e))return Ja({code:da.PROFANITY_FOUND});var s=new ka("updateGroupProfile");return s.setMessage(JSON.stringify(e)),xe.l("".concat(n," groupID:").concat(e.groupID)),this.request({protocolName:Jo,requestData:e}).then(function(){(s.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok")),t.hasLocalGroup(e.groupID))&&(t.groupMap.get(e.groupID).updateGroup(e),t._setStorageGroupList());return Ka({group:t.groupMap.get(e.groupID)});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];s.setError(e,o,a).end();}),xe.l("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_filterProfanity",value:function value(e,t){var n=this.getModule(no);if(!n)return!0;var o=n.filterText(t[e],z),s=o.isAllowedToSend,a=o.modifiedText;return!0===s&&(t[e]=a,!0);}},{key:"joinGroup",value:function value(e){var t=this,n=e.groupID,o=e.type,s="".concat(this._n,".joinGroup");if(o===S.GRP_WORK)return Ja({code:da.CANNOT_JOIN_WORK});if(this.deleteUnjoinedAVChatRoom(n),this.hasLocalGroup(n)){if(!this.isLoggedIn())return za({status:S.JOIN_STATUS_ALREADY_IN_GROUP});var a=new ka("applyJoinGroup");return this.getGroupProfile({groupID:n}).then(function(){return a.setNetworkType(t.getNetworkType()).setMessage("groupID:".concat(n," joinedStatus:").concat(S.JOIN_STATUS_ALREADY_IN_GROUP)).end(),za({status:S.JOIN_STATUS_ALREADY_IN_GROUP});}).catch(function(o){return a.setNetworkType(t.getNetworkType()).setMessage("groupID:".concat(n," unjoined")).end(),xe.w("".concat(s," ").concat(n," was unjoined, now join!")),t.groupMap.delete(n),t.applyJoinGroup(e);});}return xe.l("".concat(s," groupID:").concat(n)),this.isLoggedIn()?this.applyJoinGroup(e):this._AVChatRoomHandler.joinWithoutAuth(e);}},{key:"applyJoinGroup",value:function value(e){var n=this,o="".concat(this._n,".").concat("applyJoinGroup"),s=e.groupID;if(!jt(e.applyMessage)&&!1===this._filterProfanity("applyMessage",e))return Ja({code:da.PROFANITY_FOUND});var a=new ka("applyJoinGroup"),r=t({},e),i=this.canIUse(B.AVCHATROOM_HISTORY_MSG);return i&&(r.historyMessageFlag=1),this.getModule(Fn).deleteTopicRoamingMessageInfo(s),this.request({protocolName:Xo,requestData:r}).then(function(e){var t=e.data,r=t.joinedStatus,u=t.longPollingKey,c=t.startSeq,l=t.avChatRoomFlag,p=t.avChatRoomKey,d=t.messageList,g="groupID:".concat(s," joinedStatus:").concat(r," longPollingKey:").concat(u," startSeq:").concat(c)+" avChatRoomFlag:".concat(l," canGetAVChatRoomHistoryMessage:").concat(i,",")+" history message count:".concat(jt(d)?0:d.length);switch(a.setNetworkType(n.getNetworkType()).setMessage("".concat(g)).end(),xe.l("".concat(o," ok. ").concat(g)),r){case je:return Ka({status:je});case Ye:return n.getGroupProfile({groupID:s}).then(function(e){var t=e.data.group;return n._handleJoinResult({group:t,avChatRoomFlag:l,longPollingKey:u,startSeq:c,avChatRoomKey:p,messageList:d});}).catch(function(){var e=new dr({groupID:s});return n._handleJoinResult({group:e,avChatRoomFlag:l,longPollingKey:u,startSeq:c,avChatRoomKey:p,messageList:d});});default:var _=new Wa({code:da.JOIN_GROUP_FAIL});return xe.e("".concat(o," failed. error:"),_),Ja(_);}}).catch(function(e){return a.setMessage("groupID:".concat(s)),n.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];a.setError(e,o,s).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}},{key:"_handleJoinResult",value:function value(e){var t,n=this,o=e.group,s=e.avChatRoomFlag,a=e.longPollingKey,r=e.startSeq,i=e.avChatRoomKey,u=e.messageList,c=o.groupID;return 1===s?(this.getModule(Fn).setCompleted("".concat(S.CONV_GROUP).concat(c)),this._groupAttributesHandler.initGroupAttributesCache({groupID:c,avChatRoomKey:i}),this._groupCountersHandler.initGroupCountersCache({groupID:c,avChatRoomKey:i}),(t=at(a)?this._AVChatRoomHandler.handleJoinResult({group:o}):this._AVChatRoomHandler.startRunLoop({group:o,longPollingKey:a,startSeq:r})).then(function(){n._onAVChatRoomHistoryMessage(u);}),t):(this.emitGroupListUpdate(!0,!1),Ka({status:Ye,group:o}));}},{key:"quitGroup",value:function value(e){var t=this,n="".concat(this._n,".").concat("quitGroup");xe.l("".concat(n," groupID:").concat(e));var o=this.checkJoinedAVChatRoomByID(e);if(!o&&!this.hasLocalGroup(e))return Ja({code:da.MEMBER_NOT_IN_GROUP});if(o&&!this.isLoggedIn())return xe.l("".concat(n," anonymously ok. groupID:").concat(e)),this.deleteLocalGroupAndConversation(e),this._AVChatRoomHandler.reset(e),za({groupID:e});var s=new ka("quitGroup");return s.setMessage("groupID:".concat(e)),this.request({protocolName:Zo,requestData:{groupID:e}}).then(function(){return s.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok")),t.deleteLocalGroupAndConversation(e),o&&t._AVChatRoomHandler.reset(e),t._groupAttributesHandler.deleteLocalGroupAttributes(e),Ka({groupID:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];s.setError(e,o,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"searchGroupByID",value:function value(e){var t=this,n="".concat(this._n,".").concat("searchGroupByID"),o={groupIDList:[e]},s=new ka("searchGroupByID");return s.setMessage("groupID:".concat(e)),xe.l("".concat(n," groupID:").concat(e)),this.request({protocolName:$o,requestData:o}).then(function(e){var o=e.data.groupProfile;if(0!==o[0].errorCode)throw new Wa({code:o[0].errorCode,message:o[0].errorInfo});return s.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok")),Ka({group:new dr(o[0])});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];s.setError(e,o,a).end();}),xe.w("".concat(n," failed. error:"),e),Ja(e);});}},{key:"changeGroupOwner",value:function value(e){var t=this,n="".concat(this._n,".").concat("changeGroupOwner");if(this.hasLocalGroup(e.groupID)&&this.getLocalGroupProfile(e.groupID).type===S.GRP_AVCHATROOM)return Ja({code:da.CANNOT_CHANGE_OWNER_IN_AVCHATROOM});if(e.newOwnerID===this.getMyUserID())return Ja({code:da.CANNOT_CHANGE_OWNER_TO_SELF});var o=new ka("changeGroupOwner");return o.setMessage("groupID:".concat(e.groupID," newOwnerID:").concat(e.newOwnerID)),xe.l("".concat(n," groupID:").concat(e.groupID)),this.request({protocolName:es,requestData:e}).then(function(){o.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok"));var s=e.groupID,a=e.newOwnerID;t.groupMap.get(s).ownerID=a;var r=t.getModule(bn).getLocalGroupMemberList(s);if(r instanceof Map){var i=r.get(t.getMyUserID());at(i)||(i.updateRole("Member"),t.groupMap.get(s).selfInfo.role="Member");var u=r.get(a);at(u)||u.updateRole("Owner");}return t.emitGroupListUpdate(!0,!1),Ka({group:t.groupMap.get(s)});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"getGroupApplicationList",value:function value(){return this._groupSystemNoticeHandler.getGroupApplicationList();}},{key:"handleGroupApplication",value:function value(e){var t,n,o,s,a,r=this,i="".concat(this._n,".").concat("handleGroupApplication"),u=e.handleAction,c=e.handleMessage,l=e.message,p=e.application;l?(t=l.payload.operatorID,n=l.payload.groupProfile.groupID,o=l.payload.authentication,s=l.payload.messageKey):p&&(t=p.applicant,n=p.groupID,o=p.authentication,s=p.messageKey);var d=ts;p&&2===p.applicationType&&(d=ns,a=p.userID);var g=new ka("handleGroupApplication");return g.setMessage("groupID:".concat(n)),xe.l("".concat(i," groupID:").concat(n)),this.request({protocolName:d,requestData:{handleAction:u,handleMessage:c,applicant:t,invitee:a,groupID:n,authentication:o,messageKey:s}}).then(function(){return g.setNetworkType(r.getNetworkType()).end(),xe.l("".concat(i," ok")),l&&r._groupSystemNoticeHandler.deleteGroupSystemNotice({messageList:[e.message]}),Ka({group:r.getLocalGroupProfile(n)});}).catch(function(e){return r.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];g.setError(e,o,s).end();}),xe.e("".concat(i," failed. error"),e),Ja(e);});}},{key:"handleGroupInvitation",value:function value(e){var n=this,o="".concat(this._n,".").concat("handleGroupInvitation"),s=e.message.payload,a=s.groupProfile.groupID,r=s.authentication,i=s.messageKey,u=s.operatorID,c=e.handleAction,l=new ka("handleGroupInvitation");return l.setMessage("groupID:".concat(a," inviter:").concat(u," handleAction:").concat(c)),xe.l("".concat(o," groupID:").concat(a," inviter:").concat(u," handleAction:").concat(c)),this.request({protocolName:os,requestData:t(t({},e),{},{inviter:u,groupID:a,authentication:r,messageKey:i})}).then(function(){return l.setNetworkType(n.getNetworkType()).end(),xe.l("".concat(o," ok")),n._groupSystemNoticeHandler.deleteGroupSystemNotice({messageList:[e.message]}),Ka({group:n.getLocalGroupProfile(a)});}).catch(function(e){return n.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];l.setError(e,o,s).end();}),xe.e("".concat(o," failed. error"),e),Ja(e);});}},{key:"getGroupOnlineMemberCount",value:function value(e){return this._AVChatRoomHandler?this._AVChatRoomHandler.checkJoinedAVChatRoomByID(e)?this._AVChatRoomHandler.getGroupOnlineMemberCount(e):za({memberCount:0}):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"hasLocalGroup",value:function value(e){return this.groupMap.has(e);}},{key:"deleteLocalGroupAndConversation",value:function value(e){var t=this.checkJoinedAVChatRoomByID(e);(xe.l("".concat(this._n,".deleteLocalGroupAndConversation isJoinedAVChatRoom:").concat(t)),t)&&this.getModule(Fn).deleteLocalConversation("".concat(S.CONV_GROUP).concat(e));if(Tt({groupID:e})){var n=this.getLocalGroupProfile(e);if(n&&!0===n.isSupportTopic)this.getModule(wn).deleteTopicListInCommunity(e);}this._deleteLocalGroup(e),this.emitGroupListUpdate(!0,!1);}},{key:"_deleteLocalGroup",value:function value(e){this.groupMap.delete(e),this.getModule(bn).deleteGroupMemberList(e),this._setStorageGroupList();}},{key:"sendMessage",value:function value(e,t){if(st(e._receiverList)&&e._receiverList.length>0&&!this.canIUse(B.MSG_TO_SPECIFIED_GRP_MBR))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n=this.createGroupMessagePack(e,t);return this.request(n);}},{key:"createGroupMessagePack",value:function value(e,t){var n=null;t&&t.offlinePushInfo&&(n=t.offlinePushInfo);var o="";et(e.cloudCustomData)&&e.cloudCustomData.length>0&&(o=e.cloudCustomData);var s=[];if(ot(t)&&ot(t.messageControlInfo)){var a=t.messageControlInfo,r=a.excludedFromUnreadCount,i=a.excludedFromLastMessage,u=a.excludedFromContentModeration;!0===r&&s.push("NoUnread"),!0===i&&s.push("NoLastMsg"),!0===u&&s.push("NoMsgCheck");}var c=void 0;st(e._receiverList)&&e._receiverList.length>0&&(c=e._receiverList,e._receiverList.length>50&&(c=e._receiverList.slice(0,50),this.outputWarning("ReceiverListLimit")));var l=this.isOnlineMessage(e,t)?1:0,p=e.getGroupAtInfoList(),d={fromAccount:this.getMyUserID(),groupID:e.to,msgBody:e.getElements(),cloudCustomData:o,random:e.random,priority:e.priority,clientSequence:e.clientSequence,groupAtInfo:e.type!==S.MSG_TEXT||jt(p)?void 0:p,onlineOnlyFlag:l,clientTime:e.clientTime,offlinePushInfo:n?{pushFlag:!0===n.disablePush?1:0,title:n.title||"",desc:n.description||"",ext:n.extension||"",apnsInfo:{badgeMode:!0===n.ignoreIOSBadge?1:0,isVoipPush:this._isVoipPush(n)},androidInfo:{OPPOChannelID:n.androidOPPOChannelID||""}}:void 0,messageControlInfo:0===l?s:void 0,needReadReceipt:!0!==e.needReadReceipt||this.isMessageFromOrToAVChatroom(e.to)?0:1,receiverList:c,isSupportExtension:!0===e.isSupportExtension?1:0};return Dt(e.to)&&(d.groupID=qt(e.to),d.topicID=e.to),{protocolName:ho,tjgID:this.generateTjgID(e),requestData:d};}},{key:"_isVoipPush",value:function value(e){var t=void 0;return at(e.disableVoipPush)||(t=!1===e.disableVoipPush?1:0),t;}},{key:"revokeMessage",value:function value(e){var t={groupID:e.to,msgSeqList:[{msgSeq:e.sequence}]};return Dt(e.to)&&(t.groupID=qt(e.to),t.topicID=e.to),this.request({protocolName:ss,requestData:t});}},{key:"deleteMessage",value:function value(e){var t=e.to,n=e.keyList;xe.l("".concat(this._n,".deleteMessage groupID:").concat(t," count:").concat(n.length));var o={groupID:t,deleter:this.getMyUserID(),keyList:n};return Dt(t)&&(o.groupID=qt(t),o.topicID=t),this.request({protocolName:vs,requestData:o});}},{key:"modifyRemoteMessage",value:function value(e){var t=e.to,n=e.sequence,o=e.payload,s=e.type,a=e.version,r=void 0===a?0:a,i=e.cloudCustomData,u=t,c=void 0;Dt(t)&&(u=qt(t),c=t);var l=void 0;return Vt(s)&&(l=[]).push({type:s,content:o}),this.request({protocolName:ms,requestData:{groupID:u,topicID:c,sequence:n,version:r,elements:l,cloudCustomData:i}});}},{key:"getRoamingMessage",value:function value(e){var t=this,n="".concat(this._n,".getRoamingMessage"),o=e.conversationID,s=e.groupID,a=e.sequence,r=new ka("getGroupRoamingMessages"),i=0,u=void 0;return Dt(s)&&(s=qt(u=s)),this._computeLastSequence({groupID:s,topicID:u,sequence:a}).then(function(e){return i=e,xe.l("".concat(n," groupID:").concat(s," startSequence:").concat(i)),t.request({protocolName:is,requestData:{groupID:s,count:21,sequence:i,topicID:u}});}).then(function(e){var a=e.data,c=a.messageList,l=a.complete,p=a.invisibleSequenceList,d=void 0===p?[]:p;at(c)?xe.l("".concat(n," ok. complete:").concat(l," but messageList is undefined!")):xe.l("".concat(n," ok. complete:").concat(l," count:").concat(c.length));var g=t._getMinSequence(d,c)-1;r.setNetworkType(t.getNetworkType()).setMessage("groupID:".concat(s," topicID:").concat(u," startSequence:").concat(i," complete:").concat(l," nextSequence:").concat(g)).end();var _=t.getModule(Fn),h=[];return jt(c)||(_.updateRoamingMessageSequence(o,g),h=_.onRoamingMessage(c,o),_.updateIsRead(o),_.patchConversationLastMessage(o)),(2===l||g<=1)&&(_.setCompleted(o),g=""),xe.l("".concat(n," nextReqID:").concat(g,", stored message count:").concat(h.length,", invisible sequence count:").concat(d.length)),{nextReqID:g+"",storedMessageList:h};}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];r.setError(e,o,a).setMessage("groupID:".concat(s," topicID:").concat(u," startSequence:").concat(i)).end();}),xe.w("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_getGroupIDOfMessage",value:function value(e){return e.conversationID.replace(S.CONV_GROUP,"");}},{key:"_getMinSequence",value:function value(e,t){var n=0;jt(t)||(n=t[t.length-1].sequence);var o=0;jt(e)||(o=e[e.length-1]);return xe.l("".concat(this._n,"._getMinSequence minVisibleSequence:").concat(n," minInvisibleSequence:").concat(o)),o>0&&o<n?o:n;}},{key:"getReadReceiptList",value:function value(e){var t=this,n="".concat(this._n,".").concat("getReadReceiptList"),o=this._getGroupIDOfMessage(e[0]),s=this.getMyUserID(),a=e.filter(function(e){return e.from===s&&!0===e.needReadReceipt;}).map(function(e){return{sequence:e.sequence};});if(xe.l("".concat(n," groupID:").concat(o," sequenceList:").concat(JSON.stringify(a))),0===a.length)return za({messageList:e});var r=new ka("getReadReceiptList");return r.setMessage("groupID:".concat(o)),this.request({protocolName:us,requestData:{groupID:o,sequenceList:a}}).then(function(t){r.end(),xe.l("".concat(n," ok"));var o=t.data.readReceiptList;return st(o)&&o.forEach(function(t){e.forEach(function(e){0===t.code&&t.sequence===e.sequence&&(e.readReceiptInfo.readCount=t.readCount,e.readReceiptInfo.unreadCount=t.unreadCount);});}),Ka({messageList:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.w("".concat(n," failed. error:"),e),Ja(e);});}},{key:"sendReadReceipt",value:function value(e){var t=this,n="".concat(this._n,".").concat("sendReadReceipt"),o=this._getGroupIDOfMessage(e[0]),s=new ka("sendReadReceipt");s.setMessage("groupID:".concat(o));var a=this.getMyUserID(),r=e.filter(function(e){return e.from!==a&&!0===e.needReadReceipt;}).map(function(e){return{sequence:e.sequence};});return 0===r.length?Ja({code:da.READ_RECEIPT_MESSAGE_LIST_EMPTY}):(xe.l("".concat(n,". sequenceList:").concat(JSON.stringify(r))),this.request({protocolName:cs,requestData:{groupID:o,sequenceList:r}}).then(function(e){return s.end(),xe.l("".concat(n," ok")),Ka();}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];s.setError(e,o,a).end();}),xe.w("".concat(n," failed. error:"),e),Ja(e);}));}},{key:"getReadReceiptDetail",value:function value(e){var t=this,n=e.message,o=e.filter,s=e.cursor,a=e.count,r=this._getGroupIDOfMessage(n),i=n.ID,u=n.sequence,c="".concat(this._n,".").concat("getReadReceiptDetail"),l=this._receiptDetailCompleteMap.get(i)||!1,p=0!==o&&1!==o?0:o,d=et(s)?s:"",g=!$e(a)||a<=0||a>=100?100:a,_="groupID:".concat(r," sequence:").concat(u," cursor:").concat(d," filter:").concat(p," completeFlag:").concat(l);xe.l("".concat(c," ").concat(_));var h={cursor:"",isCompleted:!1,messageID:i,unreadUserIDList:[],readUserIDList:[]},f=new ka("getReadReceiptDetail");return f.setMessage(_),this.request({protocolName:ps,requestData:{groupID:r,sequence:u,flag:p,cursor:d,count:g}}).then(function(e){f.end();var n=e.data,o=n.cursor,s=n.isCompleted,a=n.unreadUserIDList,r=n.readUserIDList;return h.cursor=o,1===s&&(h.isCompleted=!0,t._receiptDetailCompleteMap.set(i,!0)),0===p?h.readUserIDList=r.map(function(e){return e.userID;}):1===p&&(h.unreadUserIDList=a.map(function(e){return e.userID;})),xe.l("".concat(c," ok")),Ka(h);}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];f.setError(e,o,s).end();}),xe.w("".concat(c," failed. error:"),e),Ja(e);});}},{key:"getRoamingMessagesHopping",value:function value(e){var t=this,n="".concat(this._n,".getRoamingMessagesHopping"),o=new ka("getGroupRoamingMessagesHopping"),s=e.groupID,a=e.count,r=e.sequence,i=e.direction,u=r;1===i&&(u=r+a-1);var c=void 0;Dt(s)&&(s=qt(c=s));var l="".concat(c?"topicID:".concat(c):"groupID:".concat(s)," sequence:").concat(r," direction:").concat(i);return xe.l("".concat(n," ").concat(l)),this.request({protocolName:is,requestData:{groupID:s,topicID:c,count:a,sequence:u}}).then(function(s){var a=s.data,u=a.messageList,c=a.complete,p="complete:".concat(c," count:").concat(u?u.length:0);if(xe.l("".concat(n," ok. ").concat(p)),o.setNetworkType(t.getNetworkType()).setMessage("".concat(l," ").concat(p)).end(),2===c||jt(u)){var d=t._computeResult();return Ka(d);}var g="".concat(S.CONV_GROUP).concat(e.groupID),_=t.getModule(Fn).onRoamingMessage(u,g,!1),h=t._computeResult({direction:i,sequence:r,remoteMessageList:u,processedMessageList:_});return Ka(h);}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),i=n[0],u=n[1];o.setError(e,i,u).setMessage("groupID:".concat(s," sequence:").concat(r," count:").concat(a)).end();}),xe.w("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_computeResult",value:function value(e){var t={messageList:[],isCompleted:!1,nextMessageSeq:""};if(at(e))return t.isCompleted=!0,t;var n=e.direction,o=e.sequence,s=e.remoteMessageList,a=void 0===s?[]:s,r=e.processedMessageList,i=void 0===r?[]:r,u=a.length;return 1===n?(t.nextMessageSeq=a[0].sequence+1,i.forEach(function(e){e.sequence>=o&&t.messageList.push(e);}),0===t.messageList.length&&a[0].sequence<o&&(t.isCompleted=!0,t.nextMessageSeq=""),t):(t.nextMessageSeq=a[u-1].sequence-1,t.messageList=m(i),0===t.nextMessageSeq&&(t.isCompleted=!0,t.nextMessageSeq=""),t);}},{key:"setMessageRead",value:function value(e){var t=this,n=e.conversationID,o=e.lastMessageSeq,s="".concat(this._n,".setMessageRead");xe.l("".concat(s," conversationID:").concat(n," lastMessageSeq:").concat(o)),$e(o)||this.outputWarning("DoNotModifyLastSeq");var a=new ka("setGroupMessageRead");a.setMessage("".concat(n,"-").concat(o));var r=n.replace(S.CONV_GROUP,""),i=void 0;return Dt(r)&&(r=qt(i=r)),this.request({protocolName:as,requestData:{groupID:r,topicID:i,messageReadSeq:o}}).then(function(){a.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(s," ok."));var e=t.getModule(Fn);e.updateIsReadAfterReadReport({conversationID:n,lastMessageSeq:o});var u=!0;if(!at(i)){u=!1;var c=t.getModule(wn).getLocalTopic(r,i);c&&c.updateSelfInfo({readedSequence:o});}return e.updateUnreadCount(n,u),Ka();}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];a.setError(e,o,s).end();}),xe.l("".concat(s," failed. error:"),e),Ja(e);});}},{key:"_computeLastSequence",value:function value(e){var t=e.groupID,n=e.topicID,o=void 0===n?void 0:n,s=e.sequence;return s>0?Promise.resolve(s):at(o)||this.hasLocalGroup(t)?at(o)?this.getGroupLastSequence(t):this.getTopicLastSequence({groupID:t,topicID:o}):Promise.resolve(0);}},{key:"getGroupLastSequence",value:function value(e){var t=this,n="".concat(this._n,".").concat("getGroupLastSequence"),o=new ka("getGroupLastSequence"),s=0,a="";if(this.hasLocalGroup(e)){var r=this.getLocalGroupProfile(e),i=r.lastMessage;if(i.lastSequence>0&&!1===i.onlineOnlyFlag)return s=i.lastSequence,a="got lastSequence:".concat(s," from local group profile[lastMessage.lastSequence]. groupID:").concat(e),xe.l("".concat(n," ").concat(a)),o.setNetworkType(this.getNetworkType()).setMessage("".concat(a)).end(),Promise.resolve(s);if(r.nextMessageSeq>1)return s=r.nextMessageSeq-1,a="got lastSequence:".concat(s," from local group profile[nextMessageSeq]. groupID:").concat(e),xe.l("".concat(n," ").concat(a)),o.setNetworkType(this.getNetworkType()).setMessage("".concat(a)).end(),Promise.resolve(s);}var u="GROUP".concat(e),c=this.getModule(Fn).getLocalConversation(u);if(c&&c.lastMessage.lastSequence&&!1===c.lastMessage.onlineOnlyFlag)return s=c.lastMessage.lastSequence,a="got lastSequence:".concat(s," from local conversation profile[lastMessage.lastSequence]. groupID:").concat(e),xe.l("".concat(n," ").concat(a)),o.setNetworkType(this.getNetworkType()).setMessage("".concat(a)).end(),Promise.resolve(s);var l={groupIDList:[e],responseFilter:{groupBaseInfoFilter:["NextMsgSeq"]}};return this.getGroupProfileAdvance(l).then(function(r){var i=r.data.successGroupList;return jt(i)?xe.l("".concat(n," successGroupList is empty. groupID:").concat(e)):(s=i[0].nextMessageSeq-1,a="got lastSequence:".concat(s," from getGroupProfileAdvance. groupID:").concat(e),xe.l("".concat(n," ").concat(a))),o.setNetworkType(t.getNetworkType()).setMessage("".concat(a)).end(),s;}).catch(function(s){return t.probeNetwork().then(function(t){var n=v(t,2),a=n[0],r=n[1];o.setError(s,a,r).setMessage("get lastSequence failed from getGroupProfileAdvance. groupID:".concat(e)).end();}),xe.w("".concat(n," failed. error:"),s),Ja(s);});}},{key:"getTopicLastSequence",value:function value(e){var t=this,n=e.groupID,o=e.topicID,s="".concat(this._n,".").concat("getTopicLastSequence"),a=new ka("getTopicLastSequence"),r=0,i="",u=this.getModule(wn);return u.hasLocalTopic(n,o)?(r=u.getLocalTopic(n,o).nextMessageSeq-1,i="get lastSequence:".concat(r," from local topic info[nextMessageSeq]. topicID:").concat(o),xe.l("".concat(s," ").concat(i)),a.setNetworkType(this.getNetworkType()).setMessage("".concat(i)).end(),Promise.resolve(r)):u.getTopicList({groupID:n,topicIDList:[o]}).then(function(e){var n=e.data.successTopicList;return jt(n)?xe.l("".concat(s," successTopicList is empty. topicID:").concat(o)):(r=n[0].nextMessageSeq-1,i="get lastSequence:".concat(r," from getTopicList. topicID:").concat(o),xe.l("".concat(s," ").concat(i))),a.setNetworkType(t.getNetworkType()).setMessage("".concat(i)).end(),r;}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),s=n[0],r=n[1];a.setError(e,s,r).setMessage("get lastSequence failed from getTopicList. topicID:".concat(o)).end();}),xe.w("".concat(s," failed. error:"),e),Ja(e);});}},{key:"isMessageFromOrToAVChatroom",value:function value(e){return!!this._AVChatRoomHandler&&this._AVChatRoomHandler.checkJoinedAVChatRoomByID(e);}},{key:"hasJoinedAVChatRoom",value:function value(){return this._AVChatRoomHandler?this._AVChatRoomHandler.hasJoinedAVChatRoom():0;}},{key:"getJoinedAVChatRoom",value:function value(){return this._AVChatRoomHandler?this._AVChatRoomHandler.getJoinedAVChatRoom():[];}},{key:"isOnlineMessage",value:function value(e,t){return!(!this._canIUseOnlineOnlyFlag(e)||!t||!0!==t.onlineUserOnly);}},{key:"_canIUseOnlineOnlyFlag",value:function value(e){var t=this.getJoinedAVChatRoom();return!t||!t.includes(e.to)||e.conversationType!==S.CONV_GROUP;}},{key:"_onAVChatRoomHistoryMessage",value:function value(e){if(!jt(e)){xe.l("".concat(this._n,"._onAVChatRoomHistoryMessage count:").concat(e.length));var n=[];e.forEach(function(e){n.push(t(t({},e),{},{isHistoryMessage:1}));}),this.onAVChatRoomMessage(n);}}},{key:"onAVChatRoomMessage",value:function value(e){this._AVChatRoomHandler&&this._AVChatRoomHandler.onMessage(e);}},{key:"onAVChatRoomMemberBanned",value:function value(e){this._AVChatRoomHandler&&this._AVChatRoomHandler.onAVChatRoomMemberBanned(e);}},{key:"getGroupSimplifiedInfo",value:function value(e){var t=this,n=new ka("getGroupSimplifiedInfo"),o={groupIDList:[e],responseFilter:{groupBaseInfoFilter:["Type","Name"]}};return this.getGroupProfileAdvance(o).then(function(o){var s=o.data.successGroupList;return n.setNetworkType(t.getNetworkType()).setMessage("groupID:".concat(e," type:").concat(s[0].type)).end(),s[0];}).catch(function(o){t.probeNetwork().then(function(t){var s=v(t,2),a=s[0],r=s[1];n.setError(o,a,r).setMessage("groupID:".concat(e)).end();});});}},{key:"setUnjoinedAVChatRoom",value:function value(e){this._unjoinedAVChatRoomList.set(e,1);}},{key:"deleteUnjoinedAVChatRoom",value:function value(e){this._unjoinedAVChatRoomList.has(e)&&this._unjoinedAVChatRoomList.delete(e);}},{key:"isUnjoinedAVChatRoom",value:function value(e){return this._unjoinedAVChatRoomList.has(e);}},{key:"isGroupAttributesUpdatedNotice",value:function value(e){return this._groupAttributesHandler.isGroupAttributesUpdatedNotice(e);}},{key:"updateLocalMainSequenceOnReconnected",value:function value(){this._groupAttributesHandler.updateLocalMainSequenceOnReconnected();}},{key:"initGroupAttributes",value:function value(e){return this._groupAttributesHandler.initGroupAttributes(e);}},{key:"setGroupAttributes",value:function value(e){return this._groupAttributesHandler.setGroupAttributes(e);}},{key:"deleteGroupAttributes",value:function value(e){return this._groupAttributesHandler.deleteGroupAttributes(e);}},{key:"getGroupAttributes",value:function value(e){return this._groupAttributesHandler.getGroupAttributes(e);}},{key:"isMessageFromTopic",value:function value(e,t){return 2===e&&!jt(t);}},{key:"isMessageFromCommunityOfTopic",value:function value(e,t){return 2===e&&jt(t);}},{key:"getMessageExtensions",value:function value(e,t){return xe.l("".concat(this._n,".getMessageExtensions startSequence:").concat(t)),this.request({protocolName:Es,requestData:{groupID:e.to,messageSequence:e.sequence,startSequence:t}});}},{key:"modifyMessageExtensions",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;return xe.l("".concat(this._n,".modifyMessageExtensions operateType:").concat(n)),this.request({protocolName:Ds,requestData:{groupID:e.to,messageSequence:e.sequence,extensionList:t,operateType:n}});}},{key:"getGroupNotify",value:function value(e){var n=this;if(this.hasLocalGroup(e)){var o=this.getLocalGroupProfile(e),s=o.type,a=o.isSupportTopic;if(!Ct(s)&&!a){var r="".concat(this._n,".getGroupNotify"),i=this._getGroupLastRevokedTime(e),u=1e3*Ue();xe.l("".concat(r," groupID:").concat(e," type:").concat(s," beginTime:").concat(i," endTime:").concat(u)),this.request({protocolName:Ss,requestData:{type:Tt({type:s,groupID:e})?S.GRP_COMMUNITY:void 0,groupID:e,beginTime:i,endTime:u}}).then(function(o){var s=o.data,a=s.nextRevokedTime,i=s.notifyList;xe.l("".concat(r," ok. groupID:").concat(e," nextRevokedTime:").concat(a));var u={dataList:[{elements:{revokedInfos:[]}}]};st(i)&&i.forEach(function(n){u.dataList[0].elements.revokedInfos.push({groupID:e,sequence:n.sequence,random:n.random,revokerInfo:t({},n.revokerInfo)});}),n.onGroupMessageRevoked(u),0!==a?(n._setGroupLastRevokedTime(e,a),n.getGroupNotify(e)):n._setGroupLastRevokedTime(e,1e3*Ue());}).catch(function(e){xe.e("".concat(r," failed. error:"),e);});}}}},{key:"_getGroupLastRevokedTime",value:function value(e){return this.hasLocalGroup(e)?this.getLocalGroupProfile(e)._lastRevokedTime:0;}},{key:"_setGroupLastRevokedTime",value:function value(e,t){this.hasLocalGroup(e)&&(this.getLocalGroupProfile(e)._lastRevokedTime=t);}},{key:"isGroupCountersNotice",value:function value(e){return this._groupCountersHandler.isGroupCountersNotice(e);}},{key:"setGroupCounters",value:function value(e){return this._groupCountersHandler.setGroupCounters(e);}},{key:"increaseGroupCounter",value:function value(e){return this._groupCountersHandler.increaseGroupCounter(e);}},{key:"decreaseGroupCounter",value:function value(e){return this._groupCountersHandler.decreaseGroupCounter(e);}},{key:"getGroupCounters",value:function value(e){return this._groupCountersHandler.getGroupCounters(e);}},{key:"restartPolling",value:function value(){this._AVChatRoomHandler&&this._AVChatRoomHandler.restartPolling();}},{key:"getPollingTimerID",value:function value(e){if(!e)return-1;var t=this.getLocalGroupProfile(e);return t&&Ct(t.type)?this._AVChatRoomHandler.getPollingTimerID(e):-1;}},{key:"_canIUseJoinOption",value:function value(e){return function(e){return e===S.GRP_PUBLIC;}(e)||Tt({type:e});}},{key:"reset",value:function value(){this.groupMap.clear(),this._unjoinedAVChatRoomList.clear(),this._receiptDetailCompleteMap.clear(),this._commonGroupHandler.reset(),this._groupSystemNoticeHandler.reset(),this._groupTipsHandler.reset(),this._groupAttributesHandler.reset(),this._groupCountersHandler.reset(),this._AVChatRoomHandler&&this._AVChatRoomHandler.reset();}}]),s;}(ro),Fr=function(){function e(t){o(this,e),this.userID="",this.avatar="",this.nick="",this.role="",this.joinTime="",this.lastSendMsgTime="",this.nameCard="",this.muteUntil=0,this.memberCustomField=[],this._initMember(t);}return a(e,[{key:"_initMember",value:function value(e){this.updateMember(e);}},{key:"updateMember",value:function value(e){var t=[null,void 0,"",0,NaN];e.memberCustomField&&It(this.memberCustomField,e.memberCustomField),pt(this,e,["memberCustomField","marks"],t);}},{key:"updateRole",value:function value(e){["Owner","Admin","Member"].indexOf(e)<0||(this.role=e);}},{key:"updateMuteUntil",value:function value(e){at(e)||(this.muteUntil=Math.floor((Date.now()+1e3*e)/1e3));}},{key:"updateNameCard",value:function value(e){at(e)||(this.nameCard=e);}},{key:"updateMemberCustomField",value:function value(e){e&&It(this.memberCustomField,e);}}]),e;}(),qr=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="GroupMemberModule",t.groupMemberListMap=new Map(),t.getInnerEmitterInstance().on(er,t._onProfileUpdated,_(t)),t;}return a(s,[{key:"_onProfileUpdated",value:function value(e){for(var t=this,n=e.data,o=function o(e){var o=n[e];t.groupMemberListMap.forEach(function(e){e.has(o.userID)&&e.get(o.userID).updateMember({nick:o.nick,avatar:o.avatar});});},s=0;s<n.length;s++){o(s);}}},{key:"deleteGroupMemberList",value:function value(e){this.groupMemberListMap.delete(e);}},{key:"getGroupMemberList",value:function value(e){var t=this,n=e.groupID,o=e.offset,s=void 0===o?0:o,a=e.count,r=void 0===a?15:a,i=e.filter,u=void 0===i?void 0:i,c="".concat(this._n,".").concat("getGroupMemberList"),l=this.getModule(Un),p=l.hasLocalGroup(n);if(xe.l("".concat(c," groupID:").concat(n," offset:").concat(s," count:").concat(r," hasLocalGroup:").concat(p)),!p)return za({memberList:[],offset:0});if(l.getLocalGroupProfile(n).type===S.GRP_AVCHATROOM){if(this.canIUse(B.AVCHATROOM_MBR_LIST))return this._getAVChatRoomMemberList({groupID:n,offset:s,filter:u});this.outputWarning("LiveOnlineMember");}var d=new ka("getGroupMemberList"),g=0,_={groupID:n,limit:r>100?100:r};Tt({groupID:n})?_.next="".concat(s):(_.offset=s,g=s+r);var h=[];return this.request({protocolName:As,requestData:_}).then(function(e){var o=e.data,s=o.members,a=o.memberNum,r=o.next,i=void 0===r?void 0:r;if(at(i)||(g=jt(i)?0:i),!st(s)||0===s.length)return g=0,Promise.resolve([]);var u=t.getModule(Un);return u.hasLocalGroup(n)&&(u.getLocalGroupProfile(n).memberNum=a),h=t._updateLocalGroupMemberMap(n,s),t.getModule(On).getUserProfile({userIDList:s.map(function(e){return e.userID;}),tagList:[Be.NICK,Be.AVATAR]});}).then(function(e){var o=e.data;if(!st(o)||0===o.length)return za({memberList:[],offset:g});var a=o.map(function(e){return{userID:e.userID,nick:e.nick,avatar:e.avatar};});return t._updateLocalGroupMemberMap(n,a),h.length<r&&(g=0),d.setNetworkType(t.getNetworkType()).setMessage("groupID:".concat(n," offset:").concat(s," count:").concat(r)).end(),xe.l("".concat(c," ok.")),Ka({memberList:h,offset:g});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];d.setError(e,o,s).end();}),xe.e("".concat(c," failed. error:"),e),Ja(e);});}},{key:"_getAVChatRoomMemberList",value:function value(e){var t=this,n=e.groupID,o=e.offset,s=e.filter,a="".concat(this._n,".").concat("_getAVChatRoomMemberList"),r=new ka("_getAVChatRoomMemberList");return r.setMessage("groupID:".concat(n," offset:").concat(o," filter:").concat(s)),this.request({protocolName:Rs,requestData:{groupID:n,offset:o,filter:s}}).then(function(e){var o=e.data,s=o.memberList,i=void 0===s?[]:s,u=o.offset,c=void 0===u?0:u;r.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(a," ok. member count:").concat(i.length,", next request timestamp:").concat(c));var l=t._updateLocalGroupMemberMap(n,i);return Ka({memberList:l,offset:c});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(a," failed. error:"),e),Ja(e);});}},{key:"getGroupMemberProfile",value:function value(e){var n=this,o="".concat(this._n,".").concat("getGroupMemberProfile"),s=new ka("getGroupMemberProfile");s.setMessage(e.userIDList.length>5?"userIDList.length:".concat(e.userIDList.length):"userIDList:".concat(e.userIDList)),xe.l("".concat(o," groupID:").concat(e.groupID," userIDList:").concat(e.userIDList.join(","))),e.userIDList.length>50&&(e.userIDList=e.userIDList.slice(0,50));var a=e.groupID,r=e.userIDList;return this._getGroupMemberProfileAdvance(t(t({},e),{},{userIDList:r})).then(function(e){var t=e.data.members;return st(t)&&0!==t.length?(n._updateLocalGroupMemberMap(a,t),n.getModule(On).getUserProfile({userIDList:t.map(function(e){return e.userID;}),tagList:[Be.NICK,Be.AVATAR]})):za([]);}).then(function(e){var t=e.data.map(function(e){return{userID:e.userID,nick:e.nick,avatar:e.avatar};});n._updateLocalGroupMemberMap(a,t);var o=r.filter(function(e){return n.hasLocalGroupMember(a,e);}).map(function(e){return n.getLocalGroupMemberInfo(a,e);});return s.setNetworkType(n.getNetworkType()).end(),Ka({memberList:o});});}},{key:"addGroupMember",value:function value(e){var t=this,n="".concat(this._n,".").concat("addGroupMember"),o=e.groupID,s=this.getModule(Un).getLocalGroupProfile(o),a=s.type,r=new ka("addGroupMember");if(r.setMessage("groupID:".concat(o," groupType:").concat(a)),Ct(a)){var i=new Wa({code:da.CANNOT_ADD_MEMBER_IN_AVCHATROOM});return r.setError(i,!0,this.getNetworkType()).end(),Ja(i);}return e.userIDList=e.userIDList.map(function(e){return{userID:e};}),xe.l("".concat(n," groupID:").concat(o)),this.request({protocolName:Os,requestData:e}).then(function(o){var a=o.data.members;xe.l("".concat(n," ok"));var i=a.filter(function(e){return 1===e.result;}).map(function(e){return e.userID;}),u=a.filter(function(e){return 0===e.result;}).map(function(e){return e.userID;}),c=a.filter(function(e){return 2===e.result;}).map(function(e){return e.userID;}),l=a.filter(function(e){return 4===e.result;}).map(function(e){return e.userID;}),p="groupID:".concat(e.groupID,", ")+"successUserIDList:".concat(i,", ")+"failureUserIDList:".concat(u,", ")+"existedUserIDList:".concat(c,", ")+"overLimitUserIDList:".concat(l);return r.setNetworkType(t.getNetworkType()).setMoreMessage(p).end(),0===i.length?Ka({successUserIDList:i,failureUserIDList:u,existedUserIDList:c,overLimitUserIDList:l}):(s.memberCount+=i.length,t._updateConversationGroupProfile(s),Ka({successUserIDList:i,failureUserIDList:u,existedUserIDList:c,overLimitUserIDList:l,group:s}));}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"deleteGroupMember",value:function value(e){var t=this,n="".concat(this._n,".").concat("deleteGroupMember"),o=e.groupID,s=e.userIDList,a=this.getModule(Un).getLocalGroupProfile(o);if(at(a))return Ja({code:da.CANNOT_FIND_GROUP});if(Ct(a.type))return this.canIUse(B.AVCHATROOM_BAN_MBR)?this._banAVChatRoomMember(e):Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var r=new ka("deleteGroupMember"),i="groupID:".concat(o," ").concat(s.length>5?"userIDList.length:".concat(s.length):"userIDList:".concat(s));return r.setMessage(i),xe.l("".concat(n," groupID:").concat(o," userIDList:"),s),this.request({protocolName:Gs,requestData:e}).then(function(){return r.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok")),a.memberCount-=1,t._updateConversationGroupProfile(a),t.deleteLocalGroupMembers(o,s),Ka({group:a,userIDList:s});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_updateConversationGroupProfile",value:function value(e){this.getModule(Fn).updateConversationGroupProfile([e]);}},{key:"_banAVChatRoomMember",value:function value(e){var t=this,n="".concat(this._n,".").concat("deleteGroupMember"),o=e.groupID,s=e.userIDList,a="groupID:".concat(o," ").concat(s.length>5?"userIDList.length:".concat(s.length):"userIDList:".concat(s)),r=new ka("deleteGroupMember");r.setMessage(a),xe.l("".concat(n," groupID:").concat(o," userIDList:"),s);var i=this.getModule(Un).getLocalGroupProfile(o);return at(e.duration)||0===e.duration?Ja({code:da.BAN_DURATION_INVALID}):this.request({protocolName:Us,requestData:e}).then(function(){return r.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok")),t.deleteLocalGroupMembers(o,s),Ka({group:i,userIDList:s});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"setGroupMemberMuteTime",value:function value(e){var t=this,n=e.groupID,o=e.userID,s=e.muteTime,a="".concat(this._n,".").concat("setGroupMemberMuteTime");if(o===this.getMyUserID())return Ja(new Wa({code:da.CANNOT_MUTE_SELF}));xe.l("".concat(a," groupID:").concat(n," userID:").concat(o));var r=new ka("setGroupMemberMuteTime");return r.setMessage("groupID:".concat(n," userID:").concat(o," muteTime:").concat(s)),this.modifyGroupMemberInfo({groupID:n,userID:o,muteTime:s}).then(function(e){r.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(a," ok"));var o=t.getModule(Un);return Ka({group:o.getLocalGroupProfile(n),member:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(a," failed. error:"),e),Ja(e);});}},{key:"setGroupMemberRole",value:function value(e){var t=this,n="".concat(this._n,".").concat("setGroupMemberRole"),o=e.groupID,s=e.userID,a=e.role,r=this.getModule(Un).getLocalGroupProfile(o);if(r.selfInfo.role!==S.GRP_MBR_ROLE_OWNER)return Ja({code:da.NOT_OWNER});if([S.GRP_WORK,S.GRP_AVCHATROOM].includes(r.type))return Ja({code:da.CANNOT_SET_MEMBER_ROLE_IN_WORK_AND_AVCHATROOM});var i=[S.GRP_MBR_ROLE_ADMIN,S.GRP_MBR_ROLE_MEMBER];if(Tt({groupID:o})&&i.push(S.GRP_MBR_ROLE_CUSTOM),i.indexOf(a)<0)return Ja({code:da.INVALID_MEMBER_ROLE});if(s===this.getMyUserID())return Ja({code:da.CANNOT_SET_SELF_MEMBER_ROLE});var u=new ka("setGroupMemberRole");return u.setMessage("groupID:".concat(o," userID:").concat(s," role:").concat(a)),xe.l("".concat(n," groupID:").concat(o," userID:").concat(s)),this.modifyGroupMemberInfo({groupID:o,userID:s,role:a}).then(function(e){return u.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok")),Ka({group:r,member:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_filterProfanity",value:function value(e,t){var n=this.getModule(no);if(!n)return!0;var o=n.filterText(t[e],J),s=o.isAllowedToSend,a=o.modifiedText;return!0===s&&(t[e]=a,!0);}},{key:"setGroupMemberNameCard",value:function value(e){var t=this,n="".concat(this._n,".").concat("setGroupMemberNameCard");if(e.nameCard&&!1===this._filterProfanity("nameCard",e))return Ja({code:da.PROFANITY_FOUND});var o=e.groupID,s=e.userID,a=void 0===s?this.getMyUserID():s,r=e.nameCard;xe.l("".concat(n," groupID:").concat(o," userID:").concat(a));var i=new ka("setGroupMemberNameCard");return i.setMessage("groupID:".concat(o," userID:").concat(a," nameCard:").concat(r)),this.modifyGroupMemberInfo({groupID:o,userID:a,nameCard:r}).then(function(e){xe.l("".concat(n," ok")),i.setNetworkType(t.getNetworkType()).end();var s=t.getModule(Un).getLocalGroupProfile(o);return a===t.getMyUserID()&&s&&s.setSelfNameCard(r),Ka({group:s,member:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];i.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"setGroupMemberCustomField",value:function value(e){var t=this,n="".concat(this._n,".").concat("setGroupMemberCustomField"),o=e.groupID,s=e.userID,a=void 0===s?this.getMyUserID():s,r=e.memberCustomField;xe.l("".concat(n," groupID:").concat(o," userID:").concat(a));var i=new ka("setGroupMemberCustomField");return i.setMessage("groupID:".concat(o," userID:").concat(a," memberCustomField:").concat(JSON.stringify(r))),this.modifyGroupMemberInfo({groupID:o,userID:a,memberCustomField:r}).then(function(e){i.setNetworkType(t.getNetworkType()).end(),xe.l("".concat(n," ok"));var s=t.getModule(Un).getLocalGroupProfile(o);return Ka({group:s,member:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];i.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"modifyGroupMemberInfo",value:function value(e){var n=this,o=e.groupID,s=e.userID,a=void 0;return Dt(o)&&(o=qt(a=o)),this.request({protocolName:Ps,requestData:t(t({},e),{},{groupID:o,topicID:a})}).then(function(){if(n.hasLocalGroupMember(o,s)){var t=n.getLocalGroupMemberInfo(o,s);return at(e.muteTime)||t.updateMuteUntil(e.muteTime),at(e.role)||t.updateRole(e.role),at(e.nameCard)||t.updateNameCard(e.nameCard),at(e.memberCustomField)||t.updateMemberCustomField(e.memberCustomField),t;}return n.getGroupMemberProfile({groupID:o,userIDList:[s]}).then(function(e){return v(e.data.memberList,1)[0];});});}},{key:"markGroupMemberList",value:function value(e){var t=this,n="".concat(this._n,".").concat("markGroupMemberList"),o=e.groupID,s=e.markType,a=e.enableMark,r=e.userIDList,i=void 0===r?[]:r,u="groupID:".concat(o," markType:").concat(s," enableMark:").concat(a," userIDList count: ").concat(i.length);xe.l("".concat(n," ").concat(u));var c=2,l=[];!0===a&&(c=1);var p=m(i);i.length>500&&(p=i.slice(0,500),xe.w("".concat(n," ").concat(Kt(500)))),p.forEach(function(e){l.push({userID:e,markType:[s]});}),p=null;var d=new ka("markGroupMemberList");return d.setMessage("".concat(u)),this.request({protocolName:bs,requestData:{groupID:o,operationType:c,memberList:l}}).then(function(e){var o=e.data.memberList,s=void 0===o?[]:o,a=[],r=[];s.length===i.length?a.push.apply(a,m(i)):(s.forEach(function(e){a.push(e.userID);}),i.forEach(function(e){a.includes(e)||r.push(e);}));var u="success count:".concat(a.length," fail count:").concat(r.length);return d.setNetworkType(t.getNetworkType()).setMessage(u).end(),xe.l("".concat(n," ok. ").concat(u)),Ka({successUserIDList:a,failureUserIDList:r});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];d.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_getGroupMemberProfileAdvance",value:function value(e){return this.request({protocolName:Ns,requestData:t(t({},e),{},{memberInfoFilter:e.memberInfoFilter?e.memberInfoFilter:["Role","JoinTime","NameCard","ShutUpUntil"]})});}},{key:"_updateLocalGroupMemberMap",value:function value(e,t){var n=this;return st(t)&&0!==t.length?t.map(function(t){return n.hasLocalGroupMember(e,t.userID)?n.getLocalGroupMemberInfo(e,t.userID).updateMember(t):n.setLocalGroupMember(e,new Fr(t)),n.getLocalGroupMemberInfo(e,t.userID);}):[];}},{key:"deleteLocalGroupMembers",value:function value(e,t){var n=this.groupMemberListMap.get(e);n&&t.forEach(function(e){n.delete(e);});}},{key:"getLocalGroupMemberInfo",value:function value(e,t){return this.groupMemberListMap.has(e)?this.groupMemberListMap.get(e).get(t):null;}},{key:"setLocalGroupMember",value:function value(e,t){if(this.groupMemberListMap.has(e))this.groupMemberListMap.get(e).set(t.userID,t);else{var n=new Map().set(t.userID,t);this.groupMemberListMap.set(e,n);}}},{key:"getLocalGroupMemberList",value:function value(e){return this.groupMemberListMap.get(e);}},{key:"hasLocalGroupMember",value:function value(e,t){return this.groupMemberListMap.has(e)&&this.groupMemberListMap.get(e).has(t);}},{key:"hasLocalGroupMemberMap",value:function value(e){return this.groupMemberListMap.has(e);}},{key:"reset",value:function value(){this.groupMemberListMap.clear();}}]),s;}(ro),xr=["topicID","topicName","avatar","introduction","notification","unreadCount","muteAllMembers","customData","groupAtInfoList","nextMessageSeq","selfInfo"],Vr=function Vr(e,t){return jt(e)?{lastTime:0,lastSequence:0,fromAccount:"",payload:null,type:"",messageForShow:"",nick:"",version:0,cloudCustomData:"",isRevoked:!1,revoker:null}:{lastTime:e.time||0,lastSequence:e.sequence||0,fromAccount:e.from||"",payload:e.payload||null,type:e.type||"",messageForShow:xt(e.type,e.payload,t),nick:e.nick||"",version:e.version||0,cloudCustomData:e.cloudCustomData||"",isRevoked:e.isRevoked||!1,revoker:e.revoker||null};},Br=function(){function e(t,n){o(this,e),this.topicID="",this.topicName="",this.avatar="",this.introduction="",this.notification="",this.unreadCount=0,this.muteAllMembers=!1,this.customData="",this.groupAtInfoList=[],this.nextMessageSeq=0,this.lastMessage=Vr(t.lastMessage,n),this.selfInfo={muteTime:0,readedSequence:0,messageRemindType:"",excludedUnreadSequenceList:void 0},this._initTopic(t);}return a(e,[{key:"_initTopic",value:function value(e){for(var t in e){xr.indexOf(t)<0||("selfInfo"===t?this.updateSelfInfo(e[t]):this[t]="muteAllMembers"===t?1===e[t]:e[t]);}}},{key:"updateUnreadCount",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;this.unreadCount=e;}},{key:"updateNextMessageSeq",value:function value(e){this.nextMessageSeq=e;}},{key:"updateLastMessage",value:function value(e){this.lastMessage=Vr(e);}},{key:"updateGroupAtInfoList",value:function value(e){this.groupAtInfoList=JSON.parse(JSON.stringify(e));}},{key:"updateTopic",value:function value(e){at(e.selfInfo)||this.updateSelfInfo(e.selfInfo),at(e.muteAllMembers)||(this.muteAllMembers=1===e.muteAllMembers),pt(this,e,["groupID","lastMessageTime","selfInfo","muteAllMembers","lastMsg"]);}},{key:"updateSelfInfo",value:function value(e){return 0!==pt(this.selfInfo,e,[],[""]);}},{key:"reduceUnreadCount",value:function value(){return this.unreadCount>=1&&(this.unreadCount-=1,!0);}},{key:"isLastMessageRevoked",value:function value(e){return e.sequence===this.lastMessage.lastSequence;}},{key:"setLastMessageRevoked",value:function value(e){this.lastMessage.isRevoked=e;}},{key:"setLastMessageRevoker",value:function value(e){this.lastMessage.revoker=e;}}]),e;}(),Hr=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="TopicModule",t._topicMap=new Map(),t._getTopicTimeMap=new Map(),t.TOPIC_CACHE_TIME=300,t.TOPIC_LAST_ACTIVE_TIME=3600,t.getInnerEmitterInstance().on($a,t._onCloudConfigUpdated,_(t)),t;}return a(s,[{key:"_onCloudConfigUpdated",value:function value(){var e=this.getCloudConfig("topic_cache_time"),t=this.getCloudConfig("topic_last_active_time");at(e)||(this.TOPIC_CACHE_TIME=Number(e)),at(t)||(this.TOPIC_LAST_ACTIVE_TIME=Number(t));}},{key:"onTopicCreated",value:function value(e){var t=e.groupID;this.resetGetTopicTime(t),this.emitOuterEvent(E.TOPIC_CREATED,e);}},{key:"onTopicDeleted",value:function value(e){var t=this,n=e.groupID,o=e.topicIDList;(void 0===o?[]:o).forEach(function(e){t._deleteLocalTopic(n,e);}),this.emitOuterEvent(E.TOPIC_DELETED,e);}},{key:"onTopicMessageRemindTypeUpdated",value:function value(e){var t=e.groupID,n=e.topicID,o=e.messageRemindType,s=this.getLocalTopic(t,n);if(s){var a=s.updateSelfInfo({messageRemindType:o});a&&this.emitOuterEvent(E.TOPIC_UPDATED,{groupID:t,topic:s}),xe.d("".concat(this._n,".onTopicMessageRemindTypeUpdated topicID:").concat(n)+" messageRemindType:".concat(o," isTopicUpdated:").concat(a));}}},{key:"onTopicProfileUpdated",value:function value(e){var t=e.groupID,n=e.topicID,o=this.getLocalTopic(t,n);o&&(o.updateTopic(e),this.emitOuterEvent(E.TOPIC_UPDATED,{groupID:t,topic:o}));}},{key:"onConversationProxy",value:function value(e){var t=e.topicID,n=e.unreadCount,o=e.groupAtInfoList,s=qt(t),a=this.getLocalTopic(s,t),r=!1;a&&(at(n)||a.unreadCount===n||(a.updateUnreadCount(n),r=!0),at(o)||(a.updateGroupAtInfoList(o),r=!0)),r&&this.emitOuterEvent(E.TOPIC_UPDATED,{groupID:s,topic:a});}},{key:"onMessageSent",value:function value(e){var t=e.groupID,n=e.topicID,o=e.lastMessage,s=this.getLocalTopic(t,n);s&&(s.nextMessageSeq+=1,s.updateLastMessage(o),this.emitOuterEvent(E.TOPIC_UPDATED,{groupID:t,topic:s}));}},{key:"onMessageModified",value:function value(e){var t=e.to,n=e.time,o=e.sequence,s=e.elements,a=e.cloudCustomData,r=e.messageVersion,i=qt(t),u=this.getLocalTopic(i,t);if(u){var c=u.lastMessage;xe.d("".concat(this._n,".onMessageModified topicID:").concat(t," lastMessage:"),JSON.stringify(c),"options:",JSON.stringify(e)),c&&(null===c.payload||c.lastTime===n&&c.lastSequence===o&&c.version!==r)&&(c.type=s[0].type,c.payload=s[0].content,c.messageForShow=xt(c.type,c.payload,this.isIntl()),c.cloudCustomData=a,c.version=r,c.lastSequence=o,c.lastTime=n,this.emitOuterEvent(E.TOPIC_UPDATED,{groupID:i,topic:u}));}}},{key:"onMessageRevoked",value:function value(e){var t=this;if(0!==e.length){var n=null,o=null,s=!1;e.forEach(function(e){var a=e.to;o=qt(a),(n=t.getLocalTopic(o,a))&&(n.reduceUnreadCount()&&(s=!0),n.isLastMessageRevoked(e)&&(n.setLastMessageRevoked(!0),n.setLastMessageRevoker(e.revoker),s=!0));}),s&&this.emitOuterEvent(E.TOPIC_UPDATED,{groupID:o,topic:n});}}},{key:"isLastMessageRevoked",value:function value(e){var t=e.topicID,n=e.sequence,o=qt(t),s=this.getLocalTopic(o,t),a=!1;return s&&(a=s.isLastMessageRevoked({sequence:n})),a;}},{key:"getJoinedCommunityList",value:function value(){return this.getModule(Un).getGroupList({isGroupWithTopicOnly:!0}).then(function(e){var t=e.data.groupList;return Ka({groupList:void 0===t?[]:t});}).catch(function(e){return Ja(e);});}},{key:"createTopicInCommunity",value:function value(e){var n=this,o="".concat(this._n,".").concat("createTopicInCommunity"),s=e.topicID;if(!at(s)&&!Dt(s))return Ja({code:da.ILLEGAL_TOPIC_ID});if(e.topicName&&!1===this._filterProfanity("topicName",e))return Ja({code:da.PROFANITY_FOUND});if(e.introduction&&!1===this._filterProfanity("introduction",e))return Ja({code:da.PROFANITY_FOUND});if(e.notification&&!1===this._filterProfanity("notification",e))return Ja({code:da.PROFANITY_FOUND});var a=new ka("createTopicInCommunity");return this.request({protocolName:$s,requestData:t({},e)}).then(function(s){var r=s.data.topicID;return a.setMessage("topicID:".concat(r)).setNetworkType(n.getNetworkType()).end(),xe.l("".concat(o," ok")),n._updateTopicMap([t(t({},e),{},{topicID:r})]),Ka({topicID:r});}).catch(function(e){return n.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];a.setError(e,o,s).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}},{key:"deleteTopicFromCommunity",value:function value(e){var t=this,n="".concat(this._n,".").concat("deleteTopicFromCommunity"),o=e.groupID,s=e.topicIDList,a=void 0===s?[]:s,r=new ka("deleteTopicFromCommunity");return r.setMessage("groupID:".concat(o," topicIDList:").concat(a)),this.request({protocolName:ea,requestData:{groupID:o,topicIDList:a}}).then(function(e){var n=e.data.resultList,s=[],a=[];(void 0===n?[]:n).forEach(function(e){var t=e.topicID,n=e.errorCode,o=e.errorInfo;0===n?s.push({topicID:t}):a.push({topicID:t,code:n,message:o});});var i="success count:".concat(s.length,", fail count:").concat(a.length);return r.setMoreMessage("".concat(i)).setNetworkType(t.getNetworkType()).end(),xe.l("".concat(i)),s.forEach(function(e){t._deleteLocalTopic(o,e.topicID);}),Ka({successTopicList:s,failureTopicList:a});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"updateTopicProfile",value:function value(e){var n=this,o="".concat(this._n,".").concat("updateTopicProfile");if(xe.l("".concat(o," options:"),e),e.topicName&&!1===this._filterProfanity("topicName",e))return Ja({code:da.PROFANITY_FOUND});if(e.introduction&&!1===this._filterProfanity("introduction",e))return Ja({code:da.PROFANITY_FOUND});if(e.notification&&!1===this._filterProfanity("notification",e))return Ja({code:da.PROFANITY_FOUND});var s=new ka("updateTopicProfile");return s.setMessage("groupID:".concat(e.groupID," topicID:").concat(e.topicID)),at(e.muteAllMembers)||(e.muteAllMembers=!0===e.muteAllMembers?"On":"Off"),this.request({protocolName:ta,requestData:t({},e)}).then(function(){return s.setNetworkType(n.getNetworkType()).end(),xe.l("".concat(o," ok")),n._updateTopicMap([e]),Ka({topic:n.getLocalTopic(e.groupID,e.topicID)});}).catch(function(e){return n.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];s.setError(e,o,a).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}},{key:"getTopicList",value:function value(e){var n=this,o="".concat(this._n,".").concat("getTopicList"),s=e.groupID,a=e.topicIDList,r=void 0===a?[]:a,i=0===r.length,u=new ka("getTopicList");if(u.setMessage("groupID:".concat(s)),this._getTopicTimeMap.has(s)){var c=this._getTopicTimeMap.get(s),l=c.isGetAll,p=c.time;if((l||!l&&!i)&&Date.now()-p<1e3*this.TOPIC_CACHE_TIME){var d=this._getLocalTopicList(s,r);if(i||d.length===r.length)return u.setNetworkType(this.getNetworkType()).setMoreMessage("from cache, topic count:".concat(d.length)).end(),xe.l("".concat(o," groupID:").concat(s," from cache, topic count:").concat(d.length)),za({successTopicList:d,failureTopicList:[]});}}return this.request({protocolName:na,requestData:{groupID:s,topicIDList:r}}).then(function(e){var a=e.data.topicInfoList,r=[],c=[],l=[];(void 0===a?[]:a).forEach(function(e){var n=e.topic,o=e.selfInfo,s=e.errorCode,a=e.errorInfo,i=n.topicID;0===s?(r.push(t(t({},n),{},{selfInfo:o})),c.push(i)):l.push({topicID:i,code:s,message:a});}),n._updateTopicMap(r),n._handleTopicAtInfo(r);var p="success count:".concat(c.length,", fail count:").concat(l.length);u.setNetworkType(n.getNetworkType()).setMoreMessage("".concat(p)).end(),xe.l("".concat(o," groupID:").concat(s," from remote, ").concat(p));var d=[];return jt(c)||(n._getTopicTimeMap.set(s,{time:Date.now(),isGetAll:i}),d=n._getLocalTopicList(s,c)),Ka({successTopicList:d,failureTopicList:l});}).catch(function(e){return n.probeNetwork(e).then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}},{key:"hasLocalTopic",value:function value(e,t){return!!this._topicMap.has(e)&&this._topicMap.get(e).has(t);}},{key:"getLocalTopic",value:function value(e,t){var n=null;return this._topicMap.has(e)&&(n=this._topicMap.get(e).get(t)),n;}},{key:"_getLocalTopicList",value:function value(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=this._topicMap.get(e),o=[];return n&&(o=m(n.values())),0===t.length?o:o.filter(function(e){return t.includes(e.topicID);});}},{key:"_deleteLocalTopic",value:function value(e,t){this._topicMap.has(e)&&(this._topicMap.get(e).delete(t),xe.l("".concat(this._n,"._deleteLocalTopic groupID:").concat(e," topicID:").concat(t)));}},{key:"_updateTopicMap",value:function value(e){var t=this,n=[];(e.forEach(function(e){var o=e.groupID,s=e.topicID,a=null;t._topicMap.has(o)||t._topicMap.set(o,new Map()),t._topicMap.get(o).has(s)?(a=t._topicMap.get(o).get(s)).updateTopic(e):(t._getTopicLastMessage(e),a=new Br(e,t.isIntl()),t._topicMap.get(o).set(s,a));var r=t._computeUnreadCount(a);a.updateUnreadCount(r),n.push({conversationID:"".concat(S.CONV_GROUP).concat(s),type:S.CONV_TOPIC,unreadCount:r});}),n.length>0)&&this.getModule(Fn).updateTopicConversation(n);}},{key:"resetGetTopicTime",value:function value(e){var t=this;at(e)?m(this._getTopicTimeMap.keys()).forEach(function(e){t._getTopicTimeMap.set(e,0);}):this._getTopicTimeMap.set(e,0);}},{key:"getTopicListOnReconnected",value:function value(){var e=this,t=m(this._topicMap.keys()),n=[];t.forEach(function(t){var o=[];e._getLocalTopicList(t).forEach(function(t){var n=t.lastMessage.lastTime,s=void 0===n?0:n;Date.now()-1e3*s<1e3*e.TOPIC_LAST_ACTIVE_TIME&&o.push(t.topicID);}),o.length>0&&n.push({groupID:t,topicIDList:o});}),xe.l("".concat(this._n,".getTopicListOnReconnected. active community count:").concat(n.length)),this._relayGetTopicList(n);}},{key:"_relayGetTopicList",value:function value(e){var t=this;if(0!==e.length){var n=e.shift(),o=n.topicIDList.length>5?"topicIDList.length:".concat(n.topicIDList.length):"topicIDList:".concat(n.topicIDList),s=new ka("relayGetTopicList");s.setMessage(o),xe.l("".concat(this._n,"._relayGetTopicList. ").concat(o)),this.getTopicList(n).then(function(){s.setNetworkType(t.getNetworkType()).end(),t._relayGetTopicList(e);}).catch(function(n){t.probeNetwork().then(function(e){var t=v(e,2),o=t[0],a=t[1];s.setError(n,o,a).end();}),t._relayGetTopicList(e);});}}},{key:"_handleTopicAtInfo",value:function value(e){var n=this;0!==e.length&&e.forEach(function(e){var o=e.groupID,s=e.topicID,a=e.groupAtInfoList,r=[];at(a)||(a.forEach(function(e){r.push(t(t({},e),{},{groupID:o,topicID:s}));}),n.getModule(Fn).onNewGroupAtTips({dataList:r}));});}},{key:"_getTopicLastMessage",value:function value(e){if(!at(e.lastMsg)){var t={time:e.lastMsg.time,sequence:e.lastMsg.sequence,from:e.lastMsg.from,payload:e.lastMsg.elements[0]?e.lastMsg.elements[0].content:null,type:e.lastMsg.elements[0]?e.lastMsg.elements[0].type:"",nick:e.lastMsg.nick,version:e.lastMsg.messageVersion,cloudCustomData:e.lastMsg.cloudCustomData,isRevoked:2===e.lastMsg.isPlaceMessage,revoker:jt(e.lastMsg.revokerInfo)?null:e.lastMsg.revokerInfo.revoker};e.lastMessage=t;}}},{key:"deleteTopicListInCommunity",value:function value(e){var t=this,n=this._getLocalTopicList(e),o=this.getModule(Fn);n.forEach(function(n){var s=n.topicID;t._deleteLocalTopic(e,s),t._getTopicTimeMap.delete(e),o.deleteLocalConversation("".concat(S.CONV_GROUP).concat(s));});}},{key:"_computeUnreadCount",value:function value(e){var t=e.selfInfo,n=t.excludedUnreadSequenceList,o=t.readedSequence,s=e.nextMessageSeq-e.selfInfo.readedSequence-1;if(st(n)){var a=0;n.forEach(function(t){t>=o&&t<=e.nextMessageSeq-1&&(a+=1);}),a>=1&&(s-=a);}return s<0?0:s;}},{key:"_filterProfanity",value:function value(e,t){var n=this.getModule(no);if(!n)return!0;var o=n.filterText(t[e],z),s=o.isAllowedToSend,a=o.modifiedText;return!0===s&&(t[e]=a,!0);}},{key:"updateLastMessage",value:function value(e,t){var n=qt(e),o=this.getLocalTopic(n,e);if(o){var s=t.sequence+1;o.updateNextMessageSeq(s),o.updateLastMessage(t),this.emitOuterEvent(E.TOPIC_UPDATED,{groupID:n,topic:o});}}},{key:"getMessageExtensions",value:function value(e,t){xe.l("".concat(this._n,".getMessageExtensions startSequence:").concat(t));var n=qt(e.to);return this.request({protocolName:Es,requestData:{groupID:n,topicID:e.to,messageSequence:e.sequence,startSequence:t}});}},{key:"modifyMessageExtensions",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;xe.l("".concat(this._n,".modifyMessageExtensions operateType:").concat(n));var o=qt(e.to);return this.request({protocolName:Ds,requestData:{groupID:o,topicID:e.to,messageSequence:e.sequence,extensionList:t,operateType:n}});}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._topicMap.clear(),this._getTopicTimeMap.clear(),this.TOPIC_CACHE_TIME=300,this.TOPIC_LAST_ACTIVE_TIME=3600;}}]),s;}(ro),Kr=function(){function e(t){o(this,e),this._userModule=t,this._n="ProfileHandler",this.TAG="profile",this.accountProfileMap=new Map(),this.expirationTime=864e5;}return a(e,[{key:"setExpirationTime",value:function value(e){this.expirationTime=e;}},{key:"getUserProfile",value:function value(e){var t=this,n="".concat(this._n,".").concat("getUserProfile"),o=e.userIDList;e.fromAccount=this._userModule.getMyAccount(),o.length>100&&(xe.w("".concat(n," ").concat(Kt(100))),o.length=100);for(var s,a=[],r=[],i=0,u=o.length;i<u;i++){s=o[i],this._userModule.isMyFriend(s)&&this._contains(s)?r.push(this._getProfileFromMap(s)):a.push(s);}if(0===a.length)return za(r);e.toAccount=a;var c=e.bFromGetMyProfile||!1,l=[];e.toAccount.forEach(function(e){l.push({toAccount:e,standardSequence:0,customSequence:0});}),e.userItem=l;var p=new ka("getUserProfile");return p.setMessage(o.length>5?"userIDList.length:".concat(o.length):"userIDList:".concat(o)),this._userModule.request({protocolName:fo,requestData:e}).then(function(e){p.setNetworkType(t._userModule.getNetworkType()).end(),xe.i("".concat(n," ok"));var o=t._handleResponse(e).concat(r);return Ka(c?o[0]:o);}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];p.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"getMyProfile",value:function value(){var e=this._userModule.getMyAccount(),t="".concat(this._n,".getMyProfile");if(xe.l("".concat(t," myAccount:").concat(e)),this._fill(),this._contains(e)){var n=this._getProfileFromMap(e);return xe.d("".concat(t," from cache, myProfile:").concat(JSON.stringify(n))),za(n);}return this.getUserProfile({fromAccount:e,userIDList:[e],bFromGetMyProfile:!0});}},{key:"_handleResponse",value:function value(e){var t=e.data.userProfileItem;if(!st(t))return[];for(var n=[],o=Date.now(),s=0,a=t.length;s<a;s++){var r=t[s],i=r.to,u=r.profileItem;if("@TLS#NOT_FOUND"!==i&&""!==i){var c=this._update(i,this._getLatestProfileFromResponse(i,u)).latestProfile;n.push(c);}}return xe.l("".concat(this._n,"._handleResponse cost ").concat(Date.now()-o," ms")),n;}},{key:"_getLatestProfileFromResponse",value:function value(e,t){var n={userID:e,profileCustomField:[]};if(!jt(t))for(var o=0,s=t.length;o<s;o++){if(t[o].tag.indexOf("Tag_Profile_Custom")>-1)n.profileCustomField.push({key:t[o].tag,value:t[o].value});else switch(t[o].tag){case Be.NICK:n.nick=t[o].value;break;case Be.GENDER:n.gender=t[o].value;break;case Be.BIRTHDAY:n.birthday=t[o].value;break;case Be.LOCATION:n.location=t[o].value;break;case Be.SELFSIGNATURE:n.selfSignature=t[o].value;break;case Be.ALLOWTYPE:n.allowType=t[o].value;break;case Be.LANGUAGE:n.language=t[o].value;break;case Be.AVATAR:n.avatar=t[o].value;break;case Be.MESSAGESETTINGS:n.messageSettings=t[o].value;break;case Be.ADMINFORBIDTYPE:n.adminForbidType=t[o].value;break;case Be.LEVEL:n.level=t[o].value;break;case Be.ROLE:n.role=t[o].value;break;default:xe.w("".concat(this._n,"._getLatestProfileFromResponse unknown tag:"),t[o].tag,t[o].value);}}return n;}},{key:"updateMyProfile",value:function value(e){var t=this,n="".concat(this._n,".").concat("updateMyProfile");if(e.nick&&!1===this._userModule.filterProfanity("nick",e))return Ja({code:da.PROFANITY_FOUND});if(e.selfSignature&&!1===this._userModule.filterProfanity("selfSignature",e))return Ja({code:da.PROFANITY_FOUND});var o=new ka("updateMyProfile");o.setMessage(JSON.stringify(e));var s=new ur().validate(e);if(!s.valid)return o.setCode(da.UPDATE_PROFILE_INVALID_PARAM).setMoreMessage("info:".concat(s.tips)).setNetworkType(this._userModule.getNetworkType()).end(),xe.e("".concat(n," info:").concat(s.tips)),Ja({code:da.UPDATE_PROFILE_INVALID_PARAM});var a=[];for(var r in e){Object.prototype.hasOwnProperty.call(e,r)&&("profileCustomField"===r?e.profileCustomField.forEach(function(e){a.push({tag:e.key,value:e.value});}):a.push({tag:Be[r.toUpperCase()],value:e[r]}));}if(0===a.length){var i=new Wa({code:da.UPDATE_PROFILE_NO_KEY});return o.setError(i,!0,this._userModule.getNetworkType()).end(),xe.e("".concat(n," failed. error:"),i),Ja(i);}var u=this._userModule.getMyAccount();return this._userModule.request({protocolName:vo,requestData:{fromAccount:u,profileItem:a}}).then(function(s){o.setNetworkType(t._userModule.getNetworkType()).end(),xe.i("".concat(n," ok"));var a=t._update(u,e),r=a.isProfileUpdated,i=a.latestProfile;return!0===r&&t._userModule.emitOuterEvent(E.PROFILE_UPDATED,[i]),za(i);}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"onProfileModified",value:function value(e){var t=e.dataList;if(!jt(t)){var n,o=t.length;xe.d("".concat(this._n,".onProfileModified count:").concat(o," dataList:"),e.dataList);for(var s=[],a=0;a<o;a++){n=t[a].userID;var r=this._update(n,this._getLatestProfileFromResponse(n,t[a].profileList)),i=r.isProfileUpdated,u=r.latestProfile;!0===i&&s.push(u);}s.length>0&&(this._userModule.emitInnerEvent(er,s),this._userModule.emitOuterEvent(E.PROFILE_UPDATED,s));}}},{key:"_fill",value:function value(){if(0===this.accountProfileMap.size){for(var e=this._getCachedProfiles(),t=Date.now(),n=0,o=e.length;n<o;n++){t-e[n].lastUpdatedTime<this.expirationTime&&this.accountProfileMap.set(e[n].userID,e[n]);}xe.l("".concat(this._n,"._fill from cache, size:").concat(this.accountProfileMap.size));}}},{key:"_update",value:function value(e,t){var n,o=!1,s=Date.now();this._contains(e)?(n=this._getProfileFromMap(e),t.profileCustomField&&!0===It(n.profileCustomField,t.profileCustomField)&&(n.lastUpdatedTime=s,o=!0),pt(n,t,["profileCustomField"])>0&&(n.lastUpdatedTime=s,o=!0)):(n=new ur(t),(this._userModule.isMyFriend(e)||e===this._userModule.getMyAccount())&&(n.lastUpdatedTime=s,o=!0,this.accountProfileMap.set(e,n)));return this._flush(e===this._userModule.getMyAccount()),xe.l("".concat(this._n,"._update account:").concat(e," isProfileUpdated:").concat(o)),{isProfileUpdated:o,latestProfile:n};}},{key:"_flush",value:function value(e){var t=m(this.accountProfileMap.values()),n=this._userModule.getStorageModule();xe.d("".concat(this._n,"._flush length:").concat(t.length," flushAtOnce:").concat(e)),n.setItem(this.TAG,t,e);}},{key:"_contains",value:function value(e){return this.accountProfileMap.has(e);}},{key:"_getProfileFromMap",value:function value(e){return this.accountProfileMap.get(e);}},{key:"_getCachedProfiles",value:function value(){var e=this._userModule.getStorageModule().getItem(this.TAG);return jt(e)?[]:e;}},{key:"onConversationsProfileUpdated",value:function value(e){for(var t,n,o,s=[],a=0,r=e.length;a<r;a++){n=(t=e[a]).userID,this._userModule.isMyFriend(n)&&(this._contains(n)?(o=this._getProfileFromMap(n),pt(o,t)>0&&s.push(n)):s.push(t.userID));}0!==s.length&&(xe.i("".concat(this._n,".onConversationsProfileUpdated toAccountList:").concat(s)),this.getUserProfile({userIDList:s}));}},{key:"getNickAndAvatarByUserID",value:function value(e){if(this._contains(e)){var t=this._getProfileFromMap(e);return{nick:t.nick,avatar:t.avatar};}return{nick:"",avatar:""};}},{key:"reset",value:function value(){this._flush(!0),this.accountProfileMap.clear();}}]),e;}(),Wr=a(function e(t){o(this,e),jt||(this.userID=t.userID||"",this.timeStamp=t.timeStamp||0);}),Yr=function(){function e(t){o(this,e),this._userModule=t,this._n="BlacklistHandler",this._blacklistMap=new Map(),this.startIndex=0,this.maxLimited=100,this.currentSequence=0;}return a(e,[{key:"getLocalBlacklist",value:function value(){return m(this._blacklistMap.keys());}},{key:"getBlacklist",value:function value(){var e=this,t="".concat(this._n,".getBlacklist"),n={fromAccount:this._userModule.getMyAccount(),maxLimited:this.maxLimited,startIndex:0,lastSequence:this.currentSequence},o=new ka("getBlacklist");return this._userModule.request({protocolName:mo,requestData:n}).then(function(n){var s=n.data,a=s.blackListItem,r=s.currentSequence,i=jt(a)?0:a.length;o.setNetworkType(e._userModule.getNetworkType()).setMessage("count:".concat(i)).end(),xe.i("".concat(t," ok")),e.currentSequence=r,e._handleResponse(a,!0),e._userModule.emitOuterEvent(E.BLACKLIST_UPDATED,m(e._blacklistMap.keys()));}).catch(function(n){return e._userModule.probeNetwork().then(function(e){var t=v(e,2),s=t[0],a=t[1];o.setError(n,s,a).end();}),xe.e("".concat(t," failed. error:"),n),Ja(n);});}},{key:"addBlacklist",value:function value(e){var t=this,n=new ka("addToBlacklist"),o="".concat(this._n,".addBlacklist"),s=this._userModule.getMyAccount();if(1===e.userIDList.length&&e.userIDList[0]===s){var a=da.CANNOT_ADD_SELF_TO_BLACKLIST,r=this._userModule.getErrorMessage(a);n.setCode(a).setMessage(r).setNetworkType(this._userModule.getNetworkType()).end();var i=new Wa({code:a});return xe.e("".concat(o," failed. error:"),i),Ja(i);}return e.userIDList.includes(s)&&(e.userIDList=e.userIDList.filter(function(e){return e!==s;})),e.fromAccount=this._userModule.getMyAccount(),e.toAccount=e.userIDList,this._userModule.request({protocolName:Mo,requestData:e}).then(function(s){return n.setNetworkType(t._userModule.getNetworkType()).setMessage(e.userIDList.length>5?"userIDList.length:".concat(e.userIDList.length):"userIDList:".concat(e.userIDList)).end(),xe.i("".concat(o," ok")),t._handleResponse(s.resultItem,!0),Ka(m(t._blacklistMap.keys()));}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var o=v(t,2),s=o[0],a=o[1];n.setError(e,s,a).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}},{key:"_handleResponse",value:function value(e,t){if(!jt(e))for(var n,o,s,a=0,r=e.length;a<r;a++){o=e[a].to,s=e[a].resultCode,(at(s)||0===s)&&(t?((n=this._blacklistMap.has(o)?this._blacklistMap.get(o):new Wr()).userID=o,!jt(e[a].addBlackTimeStamp)&&(n.timeStamp=e[a].addBlackTimeStamp),this._blacklistMap.set(o,n)):this._blacklistMap.has(o)&&(n=this._blacklistMap.get(o),this._blacklistMap.delete(o)));}xe.l("".concat(this._n,"._handleResponse total:").concat(this._blacklistMap.size," bAdd:").concat(t));}},{key:"deleteBlacklist",value:function value(e){var t=this,n="".concat(this._n,".deleteBlacklist"),o=new ka("removeFromBlacklist");return e.fromAccount=this._userModule.getMyAccount(),e.toAccount=e.userIDList,this._userModule.request({protocolName:yo,requestData:e}).then(function(s){return o.setNetworkType(t._userModule.getNetworkType()).setMessage(e.userIDList.length>5?"userIDList.length:".concat(e.userIDList.length):"userIDList:".concat(e.userIDList)).end(),xe.i("".concat(n," ok")),t._handleResponse(s.data.resultItem,!1),Ka(m(t._blacklistMap.keys()));}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"onAccountDeleted",value:function value(e){for(var t,n=[],o=0,s=e.length;o<s;o++){t=e[o],this._blacklistMap.has(t)&&(this._blacklistMap.delete(t),n.push(t));}n.length>0&&(xe.l("".concat(this._n,".onAccountDeleted count:").concat(n.length," userIDList:"),n),this._userModule.emitOuterEvent(E.BLACKLIST_UPDATED,m(this._blacklistMap.keys())));}},{key:"onAccountAdded",value:function value(e){for(var t,n=[],o=0,s=e.length;o<s;o++){t=e[o],this._blacklistMap.has(t)||(this._blacklistMap.set(t,new Wr({userID:t})),n.push(t));}n.length>0&&(xe.l("".concat(this._n,".onAccountAdded count:").concat(n.length," userIDList:"),n),this._userModule.emitOuterEvent(E.BLACKLIST_UPDATED,m(this._blacklistMap.keys())));}},{key:"reset",value:function value(){this._blacklistMap.clear(),this.startIndex=0,this.maxLimited=100,this.currentSequence=0;}}]),e;}(),jr=function jr(e){var t=String(e).replace(/[=]+$/,""),n="";if(t.length%4==1)return"";for(var o,s,a=0,r=0;s=t.charAt(r++);~s&&(o=a%4?64*o+s:s,a++%4)?n+=String.fromCharCode(255&o>>(-2*a&6)):0){s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s);}try{return decodeURIComponent(escape(n));}catch(i){return"";}},zr=function(){function e(t){o(this,e),this._userModule=t,this._n="UserStatusHandler",this.MAX_QUERY_USER_COUNT=500,this.MAX_SUBSCRIBE_USER_COUNT=100,this.MAX_UNSUBSCRIBE_USER_COUNT=100,this._userModule.getInnerEmitterInstance().on($a,this._onCloudConfigUpdated,this);}return a(e,[{key:"_onCloudConfigUpdated",value:function value(){var e=this._userModule.getCloudConfig("status_query_count"),t=this._userModule.getCloudConfig("status_sub_count"),n=this._userModule.getCloudConfig("status_unsub_count");xe.l("".concat(this._n,"._onCloudConfigUpdated statusQueryCount:").concat(e," statusSubscribeCount:").concat(t)+" statusUnsubscribeCount:".concat(n)),at(e)||(this.MAX_QUERY_USER_COUNT=parseInt(e,10)),at(e)||(this.MAX_SUBSCRIBE_USER_COUNT=parseInt(t,10)),at(e)||(this.MAX_UNSUBSCRIBE_USER_COUNT=parseInt(n,10));}},{key:"onUserStatusUpdated",value:function value(e){var t=e.dataList,n=this._userModule.getMyUserID(),o=this._userModule.getModule(qn),s=t.map(function(e){var t=e.to,s=e.statusType,a=e.customStatus,r=jr(a);return t===n&&o.setCustomStatus(r),{userID:t,statusType:s,customStatus:r};});this._userModule.emitOuterEvent(E.USER_STATUS_UPDATED,s);}},{key:"setSelfStatus",value:function value(e){var t=this,n="".concat(this._n,".setSelfStatus");if(!1===this._userModule.filterProfanity("customStatus",e))return Ja({code:da.PROFANITY_FOUND});var o=new ka("setSelfStatus"),s=e.customStatus;return this._userModule.request({protocolName:oa,requestData:{customStatus:s}}).then(function(e){return o.setNetworkType(t._userModule.getNetworkType()).setMessage("customStatus:".concat(s)).end(),xe.l("".concat(n," ok. customStatus:").concat(s)),t._userModule.getModule(qn).setCustomStatus(s),Ka({userID:t._userModule.getMyUserID(),statusType:1,customStatus:s});}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var n=v(t,2),s=n[0],a=n[1];o.setError(e,s,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"getUserStatus",value:function value(e){var t=this,n="".concat(this._n,".getUserStatus"),o=e.userIDList,s=void 0===o?[]:o,a=this._userModule.getMyUserID(),r=m(s),i=void 0,u=r.indexOf(a);if(u>-1){r.splice(u,1);var c=this._userModule.getModule(qn).getCustomStatus();i={userID:a,statusType:1,customStatus:c};}if(0===r.length)return za({successUserList:[i],failureUserList:[]});if(!this._userModule.canIUse(B.USER_STATUS))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});r.length>this.MAX_QUERY_USER_COUNT&&(xe.w("".concat(n," ").concat(Kt(this.MAX_QUERY_USER_COUNT))),r=s.slice(0,this.MAX_QUERY_USER_COUNT));var l=new ka("getUserStatus");return this._userModule.request({protocolName:sa,requestData:{userIDList:r}}).then(function(e){var o=e.data,a=o.successUserList,r=void 0===a?[]:a,u=o.failureUserList,c=void 0===u?[]:u,p=r.map(function(e){var t=e.userID,n=e.statusType,o=e.customStatus;return{userID:t,statusType:n,customStatus:jr(o)};}),d=c.map(function(e){var t=e.userID,n=e.invalidUserID,o=e.errorCode,s=e.errorInfo;return{userID:jt(n)?t:n,code:o,message:s};});at(i)||p.unshift(i);var g="userID count:".concat(s.length,", success count:").concat(p.length,", fail count:").concat(d.length);return l.setNetworkType(t._userModule.getNetworkType()).setMessage("".concat(g)).end(),xe.l("".concat(n," ok. ").concat(g,".")),Ka({successUserList:p,failureUserList:d});}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],a=n[1];l.setMessage("userID count:".concat(s.length)).setError(e,o,a).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"subscribeUserStatus",value:function value(e){var t=this;if(!this._userModule.canIUse(B.USER_STATUS))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".subscribeUserStatus"),o=e.userIDList,s=void 0===o?[]:o,a=m(s);a.length>this.MAX_SUBSCRIBE_USER_COUNT&&(xe.w("".concat(n," ").concat(Kt(this.MAX_SUBSCRIBE_USER_COUNT))),a=s.slice(0,this.MAX_SUBSCRIBE_USER_COUNT));var r=new ka("subscribeUserStatus"),i="userID count:".concat(s.length);return xe.l("".concat(n," ").concat(i)),this._userModule.request({protocolName:aa,requestData:{userIDList:a}}).then(function(e){var o=e.data.failureUserList,s=(void 0===o?[]:o).map(function(e){var t=e.userID,n=e.invalidUserID,o=e.errorCode,s=e.errorInfo;return{userID:jt(n)?t:n,code:o,message:s};});return r.setNetworkType(t._userModule.getNetworkType()).setMessage("".concat(i," fail count:").concat(s.length)).end(),xe.l("".concat(n," ok. fail count:").concat(s.length,".")),Ka({failureUserList:s});}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setMessage("".concat(i)).setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"unsubscribeUserStatus",value:function value(e){var t=this;if(!this._userModule.canIUse(B.USER_STATUS))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".unsubscribeUserStatus"),o=(e||{}).userIDList,s=void 0===o?[]:o,a=m(s);s.length>this.MAX_UNSUBSCRIBE_USER_COUNT&&(xe.w("".concat(n," ").concat(Kt(this.MAX_UNSUBSCRIBE_USER_COUNT))),a=s.slice(0,this.MAX_UNSUBSCRIBE_USER_COUNT));var r=new ka("unsubscribeUserStatus"),i="userID count:".concat(s.length);xe.l("".concat(n," ").concat(i));var u={userIDList:a};return 0===a.length&&(u.userIDList=void 0,u.unsubscribeAll=1),this._userModule.request({protocolName:ra,requestData:u}).then(function(e){var o=e.data.failureUserList,s=(void 0===o?[]:o).map(function(e){var t=e.userID,n=e.invalidUserID,o=e.errorCode,s=e.errorInfo;return{userID:jt(n)?t:n,code:o,message:s};});return r.setNetworkType(t._userModule.getNetworkType()).setMessage("".concat(i," fail count:").concat(s.length)).end(),xe.l("".concat(n," ok. fail count:").concat(s.length,".")),Ka({failureUserList:s});}).catch(function(e){return t._userModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setMessage("".concat(i)).setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"reset",value:function value(){this.MAX_QUERY_USER_COUNT=500,this.MAX_SUBSCRIBE_USER_COUNT=100,this.MAX_UNSUBSCRIBE_USER_COUNT=100;}}]),e;}(),Jr=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="UserModule",s._profileHandler=new Kr(_(s)),s._blacklistHandler=new Yr(_(s)),s._userStatusHandler=new zr(_(s)),s.getInnerEmitterInstance().on(Za,s.onContextUpdated,_(s)),s;}return a(n,[{key:"onContextUpdated",value:function value(e){this._profileHandler.getMyProfile(),this._blacklistHandler.getBlacklist();}},{key:"onProfileModified",value:function value(e){this._profileHandler.onProfileModified(e);}},{key:"onRelationChainModified",value:function value(e){var t=e.dataList;if(!jt(t)){var n=[];t.forEach(function(e){e.blackListDelAccount&&n.push.apply(n,m(e.blackListDelAccount));}),n.length>0&&this._blacklistHandler.onAccountDeleted(n);var o=[];t.forEach(function(e){e.blackListAddAccount&&o.push.apply(o,m(e.blackListAddAccount));}),o.length>0&&this._blacklistHandler.onAccountAdded(o);}}},{key:"onConversationsProfileUpdated",value:function value(e){this._profileHandler.onConversationsProfileUpdated(e);}},{key:"getMyAccount",value:function value(){return this.getMyUserID();}},{key:"getMyProfile",value:function value(){return this._profileHandler.getMyProfile();}},{key:"getStorageModule",value:function value(){return this.getModule(xn);}},{key:"filterProfanity",value:function value(e,t){var n=this.getModule(no);if(!n)return!0;var o=n.filterText(t[e],j),s=o.isAllowedToSend,a=o.modifiedText;return!0===s&&(t[e]=a,!0);}},{key:"isMyFriend",value:function value(e){var t=this.getModule(Pn);return!!t&&t.isMyFriend(e);}},{key:"getUserProfile",value:function value(e){return this._profileHandler.getUserProfile(e);}},{key:"updateMyProfile",value:function value(e){return this._profileHandler.updateMyProfile(e);}},{key:"getNickAndAvatarByUserID",value:function value(e){return this._profileHandler.getNickAndAvatarByUserID(e);}},{key:"getLocalBlacklist",value:function value(){var e=this._blacklistHandler.getLocalBlacklist();return za(e);}},{key:"addBlacklist",value:function value(e){return this._blacklistHandler.addBlacklist(e);}},{key:"deleteBlacklist",value:function value(e){return this._blacklistHandler.deleteBlacklist(e);}},{key:"onUserStatusUpdated",value:function value(e){this._userStatusHandler.onUserStatusUpdated(e);}},{key:"setSelfStatus",value:function value(e){return this._userStatusHandler.setSelfStatus(e);}},{key:"getUserStatus",value:function value(e){return this._userStatusHandler.getUserStatus(e);}},{key:"subscribeUserStatus",value:function value(e){return this._userStatusHandler.subscribeUserStatus(e);}},{key:"unsubscribeUserStatus",value:function value(e){return this._userStatusHandler.unsubscribeUserStatus(e);}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._profileHandler.reset(),this._blacklistHandler.reset(),this._userStatusHandler.reset();}}]),n;}(ro),Xr=function(){function e(t,n){o(this,e),this._m=t,this._isLoggedIn=!1,this._SDKAppID=n.SDKAppID,this._userID=n.userID||"",this._userSig=n.userSig||"",this._version="2.27.5",this._a2Key="",this._tinyID="",this._customStatus="",this._contentType="json",this._unlimitedAVChatRoom=n.unlimitedAVChatRoom,this._scene=n.scene||"",this._oversea=n.oversea,this._instanceID=n.instanceID,this._statusInstanceID=0,this._isDevMode=n.devMode,this._proxyServer=n.proxyServer,this._fileUploadProxy=n.fileUploadProxy,this._fileDownloadProxy=n.fileDownloadProxy;}return a(e,[{key:"isLoggedIn",value:function value(){return this._isLoggedIn;}},{key:"isOversea",value:function value(){return this._oversea;}},{key:"isPrivateNetWork",value:function value(){return this._proxyServer;}},{key:"isDevMode",value:function value(){return this._isDevMode;}},{key:"isSingaporeSite",value:function value(){return this._SDKAppID>=2e7&&this._SDKAppID<3e7||this._SDKAppID>=172e7&&this._SDKAppID<173e7;}},{key:"isKoreaSite",value:function value(){return this._SDKAppID>=3e7&&this._SDKAppID<4e7||this._SDKAppID>=173e7&&this._SDKAppID<174e7;}},{key:"isGermanySite",value:function value(){return this._SDKAppID>=4e7&&this._SDKAppID<5e7||this._SDKAppID>=174e7&&this._SDKAppID<175e7;}},{key:"isIndiaSite",value:function value(){return this._SDKAppID>=5e7&&this._SDKAppID<6e7||this._SDKAppID>=175e7&&this._SDKAppID<176e7;}},{key:"isJapanSite",value:function value(){return this._SDKAppID>=6e7&&this._SDKAppID<7e7||this._SDKAppID>=176e7&&this._SDKAppID<177e7;}},{key:"isUSASite",value:function value(){return this._SDKAppID>=7e7&&this._SDKAppID<8e7||this._SDKAppID>=177e7&&this._SDKAppID<178e7;}},{key:"isIntl",value:function value(){return 0===(e=this._SDKAppID)||e>=2e7&&e<8e7||e>=172e7&&e<178e7;var e;}},{key:"isUnlimitedAVChatRoom",value:function value(){return this._unlimitedAVChatRoom;}},{key:"setUserID",value:function value(e){this._userID=e;}},{key:"getUserID",value:function value(){return this._userID;}},{key:"setUserSig",value:function value(e){this._userSig=e;}},{key:"getUserSig",value:function value(){return this._userSig;}},{key:"getSDKAppID",value:function value(){return this._SDKAppID;}},{key:"setTinyID",value:function value(e){this._tinyID=e,this._isLoggedIn=!0;}},{key:"getTinyID",value:function value(){return this._tinyID;}},{key:"setCustomStatus",value:function value(e){this._customStatus=e;}},{key:"getCustomStatus",value:function value(){return this._customStatus;}},{key:"getScene",value:function value(){return Le?window.tencent_cloud_im_csig_flutter_for_web_25F_cy:this._isTUIKit()?"tuikit":this._scene;}},{key:"getInstanceID",value:function value(){return this._instanceID;}},{key:"getStatusInstanceID",value:function value(){return this._statusInstanceID;}},{key:"setStatusInstanceID",value:function value(e){this._statusInstanceID=e;}},{key:"getVersion",value:function value(){return this._version;}},{key:"getA2Key",value:function value(){return this._a2Key;}},{key:"setA2Key",value:function value(e){this._a2Key=e;}},{key:"getContentType",value:function value(){return this._contentType;}},{key:"getProxyServer",value:function value(){return this._proxyServer;}},{key:"getFileUploadProxy",value:function value(){return this._fileUploadProxy;}},{key:"getFileDownloadProxy",value:function value(){return this._fileDownloadProxy;}},{key:"_isTUIKit",value:function value(){var e=!1,t=!1,n=!1,o=!1,s=[];se&&(s=Object.keys(re)),ae&&(s=oe?Object.keys(uni):Object.keys(window));for(var a=0,r=s.length;a<r;a++){if(s[a].toLowerCase().includes("uikit")){e=!0;break;}}if(s=null,se&&!it(re.createGamePortal)&&it(getApp)&&!at(getApp())){var i=getApp().globalData;ot(i)&&!0===i.isTUIKit&&(t=!0);}!0===this._m.getModule(xn).getStorageSync("TIM_".concat(this._SDKAppID,"_isTUIKit"))&&(n=!0);var u=null;if(X&&!Z&&"undefined"==typeof uni&&__wxConfig&&(u=__wxConfig.pages),Q&&"undefined"==typeof uni&&__qqConfig&&(u=__qqConfig.pages),st(u)&&u.length>0){for(var c=0,l=u.length;c<l;c++){if(u[c].toLowerCase().includes("tui")){o=!0;break;}}u=null;}return e||t||n||o;}},{key:"reset",value:function value(){this._isLoggedIn=!1,this._userSig="",this._a2Key="",this._tinyID="",this._customStatus="",this._statusInstanceID=0;}}]),e;}(),Qr=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="SignModule",s._helloInterval=120,s._lastLoginTs=0,s._lastWsHelloTs=0,s._isWebUniapp=0,tr.mixin(_(s)),s;}return a(n,[{key:"onCheckTimer",value:function value(e){this.isLoggedIn()&&e%this._helloInterval==0&&this._hello();}},{key:"login",value:function value(e){var t="";if(this.isLoggedIn()){var n=this.getMyUserID();return(t=this.getErrorMessage("RepeatLogin",n))&&xe.w(t),za({actionStatus:"OK",errorCode:0,errorInfo:t,repeatLogin:!0});}if(Date.now()-this._lastLoginTs<=15e3)return this.outputWarning("LoggingIn",e.userID),Ja({code:da.REPEAT_LOGIN});xe.l("".concat(this._n,".login userID:").concat(e.userID));var o=this._checkLoginInfo(e);if(0!==o.code)return Ja(o);var s=this.getModule(qn),a=e.userID,r=e.userSig;return s.setUserID(a),s.setUserSig(r),this.getModule(jn).updateProtocolConfig(),this._login();}},{key:"_login",value:function value(){var e=this,t=this.getModule(qn),n=t.getScene(),o=0,s=new ka("login");s.setMessage("".concat(n)).setMoreMessage("identifier:".concat(this.getMyUserID())),oe?"tuikit"===n?s.setUIPlatform(4):s.setUIPlatform(3):se?"tuikit"===n?s.setUIPlatform(12):s.setUIPlatform(11):ae&&(Le?"flutter_web_uikit"===n?s.setUIPlatform(21):s.setUIPlatform(20):this._isReactUIKit()?ke?s.setUIPlatform(25):s.setUIPlatform(24):ke?"tuikit"===n?s.setUIPlatform(17):s.setUIPlatform(16):"tuikit"===n?s.setUIPlatform(14):s.setUIPlatform(13));var a=this.getModule(to);if(a.canIUseOfflinePush()){this._isWebUniapp=a.getUniAppPlatform();var r=this._getStatusInstanceID();t.setStatusInstanceID(r),this.getModule(jn).updateProtocolConfig(),o=a.getDeviceBrand();}var i="".concat(this._n,"._login");return this._lastLoginTs=Date.now(),this.request({protocolName:io,requestData:{deviceBrand:o,isWebUniapp:this._isWebUniapp}}).then(function(o){e._lastLoginTs=0;var a=Date.now(),r=null,u=o.data,c=u.a2Key,l=u.tinyID,p=u.helloInterval,d=u.instanceID,g=u.timeStamp,_=u.customStatus,h=void 0===_?"":_,f=u.purchaseBits;xe.l("".concat(i," ok. scene:").concat(n," helloInterval:").concat(p," instanceID:").concat(d," timeStamp:").concat(g));var v=1e3*g,m=a-s.getStartTs(),M=v+parseInt(m/2)-a,y=s.getStartTs()+M;if(s.start(y),function(e,t){Ge=t;var n=new Date();n.setTime(e),xe.i("baseTime from server:".concat(n," offset:").concat(Ge));}(v,M),!l)throw r=new Wa({code:da.NO_TINYID}),s.setError(r,!0,e.getNetworkType()).end(),r;if(!c)throw r=new Wa({code:da.NO_A2KEY}),s.setError(r,!0,e.getNetworkType()).end(),r;var I=jr(h);(s.setNetworkType(e.getNetworkType()).setMoreMessage("helloInterval:".concat(p," instanceID:").concat(d," offset:").concat(M," customStatus:").concat(I)).end(),t.setA2Key(c),t.setTinyID(l),t.setStatusInstanceID(d),t.setCustomStatus(I),f)&&e.getModule(eo).onPushedConfig({errorCode:0,expiredTime:0,purchaseBits:f});e.getModule(jn).updateProtocolConfig(),e.emitInnerEvent(Za),e._helloInterval=p,e.triggerReady();var C=e.getModule(to);return C.canIUseOfflinePush()&&(uni.setStorageSync("timUniAppInstanceID",d),C.init()),e._fetchCloudControlConfig(),e.getModule(no).init(),o;}).catch(function(t){return e.probeNetwork().then(function(e){var n=v(e,2),o=n[0],a=n[1];s.setError(t,o,a).end(!0);}),e._m.setNotReadyReason(da.LOGIN_FAILED),xe.e("".concat(i," failed. error:"),t),e._lastLoginTs=0,e._m.onLoginFailed(),Ja(t);});}},{key:"logout",value:function value(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;if(!this.isLoggedIn())return Ja({code:da.USER_NOT_LOGGED_IN});var n=new ka("logout");n.setNetworkType(this.getNetworkType()).setMessage("identifier:".concat(this.getMyUserID())).end(!0);var o="".concat(this._n,".logout");return xe.i("".concat(o," type:").concat(t)),0===t&&this._m.setNotReadyReason(da.LOGGED_OUT),this.request({protocolName:uo,requestData:{type:t}}).then(function(){return e.resetReady(),za({});}).catch(function(t){return xe.e("".concat(o," error:"),t),e.resetReady(),za({});});}},{key:"_fetchCloudControlConfig",value:function value(){this.getModule(Xn).fetchConfig();}},{key:"_getStatusInstanceID",value:function value(){return uni.getStorageSync("timUniAppInstanceID");}},{key:"_hello",value:function value(){var e=this;this._lastWsHelloTs=Date.now(),this.request({protocolName:co,requestData:{isWebUniapp:this._isWebUniapp}}).catch(function(t){xe.w("".concat(e._n,"._hello error:"),t);});}},{key:"getLastWsHelloTs",value:function value(){return this._lastWsHelloTs;}},{key:"_checkLoginInfo",value:function value(e){var t=0;return jt(this.getModule(qn).getSDKAppID())?t=da.NO_SDKAPPID:jt(e.userID)?t=da.NO_IDENTIFIER:jt(e.userSig)&&(t=da.NO_USERSIG),{code:t};}},{key:"_isReactUIKit",value:function value(){return ae&&void 0!==window.tencent_cloud_im_csig_react_uikit_23F_xa;}},{key:"onMultipleAccountKickedOut",value:function value(e){var t=this;new ka("kickedOut").setNetworkType(this.getNetworkType()).setMessage("type:".concat(S.KICKED_OUT_MULT_ACCOUNT," newInstanceInfo:").concat(JSON.stringify(e))).end(!0),xe.w("".concat(this._n,".onMultipleAccountKickedOut userID:").concat(this.getMyUserID()," newInstanceInfo:"),e),this.logout(1).then(function(){t.emitOuterEvent(E.KICKED_OUT,{type:S.KICKED_OUT_MULT_ACCOUNT}),t._m.setNotReadyReason(da.KICKED_OUT_MULT_ACCOUNT),t._m.reset();});}},{key:"onMultipleDeviceKickedOut",value:function value(e){var t=this;new ka("kickedOut").setNetworkType(this.getNetworkType()).setMessage("type:".concat(S.KICKED_OUT_MULT_DEVICE," newInstanceInfo:").concat(JSON.stringify(e))).end(!0),xe.w("".concat(this._n,".onMultipleDeviceKickedOut userID:").concat(this.getMyUserID()," newInstanceInfo:"),e),this.logout(1).then(function(){t.emitOuterEvent(E.KICKED_OUT,{type:S.KICKED_OUT_MULT_DEVICE}),t._m.setNotReadyReason(da.KICKED_OUT_MULT_DEVICE),t._m.reset();});}},{key:"onUserSigExpired",value:function value(){new ka("kickedOut").setNetworkType(this.getNetworkType()).setMessage(S.KICKED_OUT_USERSIG_EXPIRED).end(!0),xe.w("".concat(this._n,".onUserSigExpired: userSig expired")),0!==this.getModule(qn).getStatusInstanceID()&&(this.emitOuterEvent(E.KICKED_OUT,{type:S.KICKED_OUT_USERSIG_EXPIRED}),this._m.setNotReadyReason(da.KICKED_OUT_USERSIG_EXPIRED),this._m.reset());}},{key:"onRestApiKickedOut",value:function value(e){(new ka("kickedOut").setNetworkType(this.getNetworkType()).setMessage("type:".concat(S.KICKED_OUT_REST_API," newInstanceInfo:").concat(JSON.stringify(e))).end(!0),xe.w("".concat(this._n,".onRestApiKickedOut userID:").concat(this.getMyUserID()," newInstanceInfo:"),e),0!==this.getModule(qn).getStatusInstanceID())&&(this.emitOuterEvent(E.KICKED_OUT,{type:S.KICKED_OUT_REST_API}),this._m.setNotReadyReason(da.KICKED_OUT_REST_API),this._m.reset(),this.getModule(zn).onRestApiKickedOut());}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this.resetReady(),this._helloInterval=120,this._lastLoginTs=0,this._lastWsHelloTs=0,this._isWebUniapp=0;}}]),n;}(ro);function Zr(){return null;}var $r=function(){function e(t){o(this,e),this._m=t,this._n="StorageModule",this._storageQueue=new Map(),this._errorTolerantHandle();}return a(e,[{key:"_errorTolerantHandle",value:function value(){se||!at(window)&&this._canIUseCookies()||(this.getItem=Zr,this.setItem=Zr,this.removeItem=Zr,this.clear=Zr);}},{key:"onCheckTimer",value:function value(e){if(e%20==0){if(0===this._storageQueue.size)return;this._doFlush();}}},{key:"_doFlush",value:function value(){try{var e,t=D(this._storageQueue);try{for(t.s();!(e=t.n()).done;){var n=v(e.value,2),o=n[0],s=n[1];this._setStorageSync(this._getKey(o),s);}}catch(a){t.e(a);}finally{t.f();}this._storageQueue.clear();}catch(r){xe.w("".concat(this._n,"._doFlush error:"),r);}}},{key:"_getPrefix",value:function value(){var e=this._m.getModule(qn);return"TIM_".concat(e.getSDKAppID(),"_").concat(e.getUserID(),"_");}},{key:"_getKey",value:function value(e){return"".concat(this._getPrefix()).concat(e);}},{key:"getItem",value:function value(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];try{var n=t?this._getKey(e):e;return this.getStorageSync(n);}catch(o){return xe.w("".concat(this._n,".getItem error:"),o),{};}}},{key:"setItem",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],o=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];if(n){var s=o?this._getKey(e):e;this._setStorageSync(s,t);}else this._storageQueue.set(e,t);}},{key:"clear",value:function value(){try{se?re.clearStorageSync():this._canIUseCookies()&&localStorage.clear();}catch(e){xe.w("".concat(this._n,".clear error:"),e);}}},{key:"removeItem",value:function value(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];try{var n=t?this._getKey(e):e;this._removeStorageSync(n);}catch(o){xe.w("".concat(this._n,".removeItem error:"),o);}}},{key:"getSize",value:function value(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"b";try{var o={size:0,limitSize:5242880,unit:n};if(Object.defineProperty(o,"leftSize",{enumerable:!0,get:function get(){return o.limitSize-o.size;}}),se&&(o.limitSize=1024*re.getStorageInfoSync().limitSize),e)o.size=JSON.stringify(this.getItem(e)).length+this._getKey(e).length;else if(se){var s=re.getStorageInfoSync(),a=s.keys;a.forEach(function(e){o.size+=JSON.stringify(t.getStorageSync(e)).length+t._getKey(e).length;});}else if(this._canIUseCookies())for(var r in localStorage){localStorage.hasOwnProperty(r)&&(o.size+=localStorage.getItem(r).length+r.length);}return this._convertUnit(o);}catch(i){xe.w("".concat(this._n," error:"),i);}}},{key:"_convertUnit",value:function value(e){var t={},n=e.unit;for(var o in t.unit=n,e){"number"==typeof e[o]&&("kb"===n.toLowerCase()?t[o]=Math.round(e[o]/1024):"mb"===n.toLowerCase()?t[o]=Math.round(e[o]/1024/1024):t[o]=e[o]);}return t;}},{key:"_setStorageSync",value:function value(e,t){se?ee?my.setStorageSync({key:e,data:t}):re.setStorageSync(e,t):this._canIUseCookies()&&localStorage.setItem(e,JSON.stringify(t));}},{key:"getStorageSync",value:function value(e){return se?ee?my.getStorageSync({key:e}).data:re.getStorageSync(e):this._canIUseCookies()?JSON.parse(localStorage.getItem(e)):{};}},{key:"_removeStorageSync",value:function value(e){se?ee?my.removeStorageSync({key:e}):re.removeStorageSync(e):this._canIUseCookies()&&localStorage.removeItem(e);}},{key:"_canIUseCookies",value:function value(){return navigator&&navigator.cookieEnabled&&localStorage;}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._doFlush();}}]),e;}(),ei=function(){function e(t){o(this,e),this._n="SSOLogBody",this._report=[];}return a(e,[{key:"pushIn",value:function value(e){xe.d("".concat(this._n,".pushIn"),this._report.length,e),this._report.push(e);}},{key:"backfill",value:function value(e){var t;st(e)&&0!==e.length&&(xe.d("".concat(this._n,".backfill"),this._report.length,e.length),(t=this._report).unshift.apply(t,m(e)));}},{key:"getLogsNumInMemory",value:function value(){return this._report.length;}},{key:"isEmpty",value:function value(){return 0===this._report.length;}},{key:"_reset",value:function value(){this._report.length=0,this._report=[];}},{key:"getLogsInMemory",value:function value(){var e=this._report.slice();return this._reset(),e;}}]),e;}(),ti=function ti(e){var t=e.getModule(qn);return{SDKType:10,SDKAppID:t.getSDKAppID(),SDKVersion:t.getVersion(),tinyID:Number(t.getTinyID()),userID:t.getUserID(),platform:e.getPlatform(),instanceID:t.getInstanceID(),traceID:Ue()};},ni=function(e){i(s,e);var n=f(s);function s(e){var t;o(this,s),(t=n.call(this,e))._n="EventStatModule",t.TAG="im-ssolog-event",t._reportBody=new ei(),t.MIN_THRESHOLD=20,t.MAX_THRESHOLD=100,t.WAITING_TIME=6e4,t.REPORT_LEVEL=[4,5,6],t.REPORT_SDKAPPID_BLACKLIST=[],t.REPORT_TINYID_WHITELIST=[],t._lastReportTime=Date.now();var a=t.getInnerEmitterInstance();return a.on(Za,t._onLoginSuccess,_(t)),a.on($a,t._onCloudConfigUpdated,_(t)),t;}return a(s,[{key:"reportAtOnce",value:function value(){xe.d("".concat(this._n,".reportAtOnce")),this._report();}},{key:"_onLoginSuccess",value:function value(){var e=this,t=this.getModule(xn),n=t.getItem(this.TAG,!1);!jt(n)&&it(n.forEach)&&(xe.l("".concat(this._n,"._onLoginSuccess get ssolog in storage, count:").concat(n.length)),n.forEach(function(t){e._reportBody.pushIn(t);}),t.removeItem(this.TAG,!1));}},{key:"_onCloudConfigUpdated",value:function value(){var e=this.getCloudConfig("evt_rpt_threshold"),t=this.getCloudConfig("evt_rpt_waiting"),n=this.getCloudConfig("evt_rpt_level"),o=this.getCloudConfig("evt_rpt_sdkappid_bl"),s=this.getCloudConfig("evt_rpt_tinyid_wl");at(e)||(this.MIN_THRESHOLD=Number(e)),at(t)||(this.WAITING_TIME=Number(t)),at(n)||(this.REPORT_LEVEL=n.split(",").map(function(e){return Number(e);})),at(o)||(this.REPORT_SDKAPPID_BLACKLIST=o.split(",").map(function(e){return Number(e);})),at(s)||(this.REPORT_TINYID_WHITELIST=s.split(","));}},{key:"pushIn",value:function value(e){e instanceof ka&&(e.updateTimeStamp(),this._reportBody.pushIn(e),this._reportBody.getLogsNumInMemory()>=this.MIN_THRESHOLD&&this._report());}},{key:"onCheckTimer",value:function value(){Date.now()<this._lastReportTime+this.WAITING_TIME||this._reportBody.isEmpty()||this._report();}},{key:"_filterLogs",value:function value(e){var t=this,n=this.getModule(qn),o=n.getSDKAppID(),s=n.getTinyID();return wt(this.REPORT_SDKAPPID_BLACKLIST,o)&&!Ft(this.REPORT_TINYID_WHITELIST,s)?[]:e.filter(function(e){return t.REPORT_LEVEL.includes(e.level);});}},{key:"_report",value:function value(){var e=this;if(!this._reportBody.isEmpty()){var n=this._reportBody.getLogsInMemory(),o=this._filterLogs(n);if(0!==o.length){var s={header:ti(this),event:o};this.request({protocolName:xs,requestData:t({},s)}).then(function(){e._lastReportTime=Date.now();}).catch(function(t){xe.w("".concat(e._n,".report failed. networkType:").concat(e.getNetworkType()," error:"),t),e._reportBody.backfill(n),e._reportBody.getLogsNumInMemory()>e.MAX_THRESHOLD&&e._flushAtOnce();});}else this._lastReportTime=Date.now();}}},{key:"_flushAtOnce",value:function value(){var e=this.getModule(xn),t=e.getItem(this.TAG,!1),n=this._reportBody.getLogsInMemory(),o="".concat(this._n,"._flushAtOnce");if(jt(t))xe.l("".concat(o," count:").concat(n.length)),e.setItem(this.TAG,n,!0,!1);else{var s=n.concat(t);s.length>this.MAX_THRESHOLD&&(s=s.slice(0,this.MAX_THRESHOLD)),xe.l("".concat(o," count:").concat(s.length)),e.setItem(this.TAG,s,!0,!1);}}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._lastReportTime=0,this._report(),this.REPORT_SDKAPPID_BLACKLIST=[],this.REPORT_TINYID_WHITELIST=[];}}]),s;}(ro),oi="none",si="online",ai=[da.OVER_FREQUENCY_LIMIT,da.OPEN_SERVICE_OVERLOAD_ERROR],ri=function(){function e(t){o(this,e),this._m=t,this._networkType="",this._n="NetMonitorModule",this.MAX_WAIT_TIME=3e3,this._mpNetworkStatusCallback=null,this._webOnlineCallback=null,this._webOfflineCallback=null;}return a(e,[{key:"start",value:function value(){var e=this;se?(re.getNetworkType({success:function success(t){e._networkType=t.networkType||t.subtype||"",t.networkType===oi?xe.w("".concat(e._n,".start no network, please check!")):xe.i("".concat(e._n,".start networkType:").concat(t.networkType));}}),this._mpNetworkStatusCallback=this._onNetworkStatusChange.bind(this),re.onNetworkStatusChange(this._mpNetworkStatusCallback)):(this._networkType=si,this._webOnlineCallback=this._onWebOnline.bind(this),this._webOfflineCallback=this._onWebOffline.bind(this),window&&(window.addEventListener("online",this._webOnlineCallback),window.addEventListener("offline",this._webOfflineCallback)));}},{key:"_onWebOnline",value:function value(){this._onNetworkStatusChange({isConnected:!0,networkType:si});}},{key:"_onWebOffline",value:function value(){this._onNetworkStatusChange({isConnected:!1,networkType:oi});}},{key:"_onNetworkStatusChange",value:function value(e){var t=e.isConnected,n=e.networkType,o="".concat(this._n,"._onNetworkStatusChange"),s=!1;t?(xe.i("".concat(o," previous:").concat(this._networkType," current:").concat(n)),this._networkType!==n&&(s=!0,this._m.getModule(zn).reConnect(!0))):this._networkType!==n&&(s=!0,xe.w("".concat(o," no network, please check!")),this._m.getModule(zn).offline());s&&(new ka("networkChange").setMessage("isConnected:".concat(t," previousNetworkType:").concat(this._networkType," networkType:").concat(n)).end(),this._networkType=n);}},{key:"probe",value:function value(e){var t=this;if(!at(e)&&ai.includes(e.code))return Promise.resolve([!0,this._networkType]);var n="".concat(this._n,".probe");return new Promise(function(e,o){se?re.getNetworkType({success:function success(o){t._networkType=o.networkType,o.networkType===oi?(xe.w("".concat(n," no network, please check!")),e([!1,o.networkType])):(xe.i("".concat(n," networkType:").concat(o.networkType)),e([!0,o.networkType]));}}):t._networkType===oi?e([!1,oi]):e([!0,si]);});}},{key:"getNetworkType",value:function value(){return this._networkType;}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),se?null!==this._mpNetworkStatusCallback&&(re.offNetworkStatusChange&&(ne||Z?re.offNetworkStatusChange(this._mpNetworkStatusCallback):re.offNetworkStatusChange()),this._mpNetworkStatusCallback=null):window&&(null!==this._webOnlineCallback&&(window.removeEventListener("online",this._webOnlineCallback),this._webOnlineCallback=null),null!==this._onWebOffline&&(window.removeEventListener("offline",this._webOfflineCallback),this._webOfflineCallback=null));}}]),e;}();var ii=function(e,t){return e(t={exports:{}},t.exports),t.exports;}(function(e){var t=Object.prototype.hasOwnProperty,n="~";function o(){}function s(e,t,n){this.fn=e,this.context=t,this.once=n||!1;}function a(e,t,o,a,r){if("function"!=typeof o)throw new TypeError("The listener must be a function");var i=new s(o,a||e,r),u=n?n+t:t;return e._events[u]?e._events[u].fn?e._events[u]=[e._events[u],i]:e._events[u].push(i):(e._events[u]=i,e._eventsCount++),e;}function r(e,t){0==--e._eventsCount?e._events=new o():delete e._events[t];}function i(){this._events=new o(),this._eventsCount=0;}Object.create&&(o.prototype=Object.create(null),new o().__proto__||(n=!1)),i.prototype.eventNames=function(){var e,o,s=[];if(0===this._eventsCount)return s;for(o in e=this._events){t.call(e,o)&&s.push(n?o.slice(1):o);}return Object.getOwnPropertySymbols?s.concat(Object.getOwnPropertySymbols(e)):s;},i.prototype.listeners=function(e){var t=n?n+e:e,o=this._events[t];if(!o)return[];if(o.fn)return[o.fn];for(var s=0,a=o.length,r=new Array(a);s<a;s++){r[s]=o[s].fn;}return r;},i.prototype.listenerCount=function(e){var t=n?n+e:e,o=this._events[t];return o?o.fn?1:o.length:0;},i.prototype.emit=function(e,t,o,s,a,r){var i=n?n+e:e;if(!this._events[i])return!1;var u,c,l=this._events[i],p=arguments.length;if(l.fn){switch(l.once&&this.removeListener(e,l.fn,void 0,!0),p){case 1:return l.fn.call(l.context),!0;case 2:return l.fn.call(l.context,t),!0;case 3:return l.fn.call(l.context,t,o),!0;case 4:return l.fn.call(l.context,t,o,s),!0;case 5:return l.fn.call(l.context,t,o,s,a),!0;case 6:return l.fn.call(l.context,t,o,s,a,r),!0;}for(c=1,u=new Array(p-1);c<p;c++){u[c-1]=arguments[c];}l.fn.apply(l.context,u);}else{var d,g=l.length;for(c=0;c<g;c++){switch(l[c].once&&this.removeListener(e,l[c].fn,void 0,!0),p){case 1:l[c].fn.call(l[c].context);break;case 2:l[c].fn.call(l[c].context,t);break;case 3:l[c].fn.call(l[c].context,t,o);break;case 4:l[c].fn.call(l[c].context,t,o,s);break;default:if(!u)for(d=1,u=new Array(p-1);d<p;d++){u[d-1]=arguments[d];}l[c].fn.apply(l[c].context,u);}}}return!0;},i.prototype.on=function(e,t,n){return a(this,e,t,n,!1);},i.prototype.once=function(e,t,n){return a(this,e,t,n,!0);},i.prototype.removeListener=function(e,t,o,s){var a=n?n+e:e;if(!this._events[a])return this;if(!t)return r(this,a),this;var i=this._events[a];if(i.fn)i.fn!==t||s&&!i.once||o&&i.context!==o||r(this,a);else{for(var u=0,c=[],l=i.length;u<l;u++){(i[u].fn!==t||s&&!i[u].once||o&&i[u].context!==o)&&c.push(i[u]);}c.length?this._events[a]=1===c.length?c[0]:c:r(this,a);}return this;},i.prototype.removeAllListeners=function(e){var t;return e?(t=n?n+e:e,this._events[t]&&r(this,t)):(this._events=new o(),this._eventsCount=0),this;},i.prototype.off=i.prototype.removeListener,i.prototype.addListener=i.prototype.on,i.prefixed=n,i.EventEmitter=i,e.exports=i;}),ui=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="BigDataChannelModule",s.FILETYPE={SOUND:2106,FILE:2107,VIDEO:2113},s._bdh_download_server="grouptalk.c2c.qq.com",s._BDHBizID=10001,s._authKey="",s._expireTime=0,s.getInnerEmitterInstance().on(Za,s._getAuthKey,_(s)),s;}return a(n,[{key:"_getAuthKey",value:function value(){var e=this;this.isIntl()||this.request({protocolName:go}).then(function(t){t.data.authKey&&(e._authKey=t.data.authKey,e._expireTime=parseInt(t.data.expireTime));});}},{key:"_isFromOlderVersion",value:function value(e){return!(!e.content||2===e.content.downloadFlag);}},{key:"parseElements",value:function value(e,t){if(!st(e)||!t)return[];for(var n=[],o=null,s=0;s<e.length;s++){o=e[s],this._needParse(o)?n.push(this._parseElement(o,t)):n.push(e[s]);}return n;}},{key:"_needParse",value:function value(e){return!e.cloudCustomData&&!(!this._isFromOlderVersion(e)||e.type!==S.MSG_AUDIO&&e.type!==S.MSG_FILE&&e.type!==S.MSG_VIDEO);}},{key:"_parseElement",value:function value(e,t){switch(e.type){case S.MSG_AUDIO:return this._parseAudioElement(e,t);case S.MSG_FILE:return this._parseFileElement(e,t);case S.MSG_VIDEO:return this._parseVideoElement(e,t);}}},{key:"_parseAudioElement",value:function value(e,t){return e.content.url=this._genAudioUrl(e.content.uuid,t),e;}},{key:"_parseFileElement",value:function value(e,t){return e.content.url=this._genFileUrl(e.content.uuid,t,e.content.fileName),e;}},{key:"_parseVideoElement",value:function value(e,t){return e.content.url=this._genVideoUrl(e.content.uuid,t),e;}},{key:"_genAudioUrl",value:function value(e,t){if(""===this._authKey)return"";var n=this.getModule(qn).getSDKAppID();return"https://".concat(this._bdh_download_server,"/asn.com/stddownload_common_file?authkey=").concat(this._authKey,"&bid=").concat(this._BDHBizID,"&subbid=").concat(n,"&fileid=").concat(e,"&filetype=").concat(this.FILETYPE.SOUND,"&openid=").concat(t,"&ver=0");}},{key:"_genFileUrl",value:function value(e,t,n){if(""===this._authKey)return"";n||(n="".concat(Math.floor(1e5*Math.random()),"-").concat(Date.now()));var o=this.getModule(qn).getSDKAppID();return"https://".concat(this._bdh_download_server,"/asn.com/stddownload_common_file?authkey=").concat(this._authKey,"&bid=").concat(this._BDHBizID,"&subbid=").concat(o,"&fileid=").concat(e,"&filetype=").concat(this.FILETYPE.FILE,"&openid=").concat(t,"&ver=0&filename=").concat(encodeURIComponent(n));}},{key:"_genVideoUrl",value:function value(e,t){if(""===this._authKey)return"";var n=this.getModule(qn).getSDKAppID();return"https://".concat(this._bdh_download_server,"/asn.com/stddownload_common_file?authkey=").concat(this._authKey,"&bid=").concat(this._BDHBizID,"&subbid=").concat(n,"&fileid=").concat(e,"&filetype=").concat(this.FILETYPE.VIDEO,"&openid=").concat(t,"&ver=0");}},{key:"reset",value:function value(){this._authKey="",this.expireTime=0;}}]),n;}(ro),ci=["requestSnapshotUrl"],li=function(e){i(s,e);var n=f(s);function s(e){var t;o(this,s),(t=n.call(this,e))._n="UploadModule",t.TIMUploadPlugin=null,t.timUploadPlugin=null,t.COSSDK=null,t._cosUploadMethod=null,t.expiredTimeLimit=600,t.appid=0,t.bucketName="",t.ciUrl="",t.directory="",t.downloadUrl="",t.uploadUrl="",t.region="ap-shanghai",t.cos=null,t.cosOptions={secretId:"",secretKey:"",sessionToken:"",expiredTime:0},t.uploadFileType="",t.duration=900,t.tryCount=0,t.UPLOAD_SIZE_LIMIT={AUDIO:20971520,FILE:104857600,IMAGE:20971520,VIDEO:104857600};var a=t.getInnerEmitterInstance();return a.on(Za,t._init,_(t)),a.on($a,t._onCloudConfigUpdated,_(t)),t;}return a(s,[{key:"_init",value:function value(){var e=this.getModule(Wn);if(this.TIMUploadPlugin=e.getPlugin("tim-upload-plugin"),this.TIMUploadPlugin)this._initUploaderMethod();else{var t=se?"cos-wx-sdk":"cos-js-sdk";this.COSSDK=e.getPlugin(t),this.COSSDK?(this._getAuthorizationKey(),this.outputWarning("CosReplacement",t)):this.outputWarning("PluginUndetected");}}},{key:"_onCloudConfigUpdated",value:function value(){var e="".concat(this._n,"._onCloudConfigUpdated"),t=this.getCloudConfig("upload_size_limit");if(xe.l("".concat(e," uploadSizeLimit:").concat(t)),!at(t))try{var n=JSON.parse(t);this.UPLOAD_SIZE_LIMIT={AUDIO:n.a?1048576*parseInt(n.a):this.UPLOAD_SIZE_LIMIT.AUDIO,FILE:n.f?1048576*parseInt(n.f):this.UPLOAD_SIZE_LIMIT.FILE,IMAGE:n.i?1048576*parseInt(n.i):this.UPLOAD_SIZE_LIMIT.IMAGE,VIDEO:n.v?1048576*parseInt(n.v):this.UPLOAD_SIZE_LIMIT.VIDEO};}catch(o){xe.e("".concat(e," JSON parse error. uploadSizeLimit:"),t);}}},{key:"_getAuthorizationKey",value:function value(){var e=this,t="".concat(this._n,".").concat("_getAuthorizationKey"),n=new ka("_getAuthorizationKey"),o=Math.ceil(Date.now()/1e3);this.request({protocolName:ws,requestData:{duration:this.expiredTimeLimit}}).then(function(s){var a=s.data;xe.l("".concat(t," ok. data:"),a);var r=a.expiredTime-o;n.setMessage("requestId:".concat(a.requestId," requestTime:").concat(o," expiredTime:").concat(a.expiredTime," diff:").concat(r,"s")).setNetworkType(e.getNetworkType()).end(),!se&&a.region&&(e.region=a.region),e.appid=a.appid,e.bucketName=a.bucketName,e.ciUrl=a.ciUrl,e.directory=a.directory,e.downloadUrl=a.downloadUrl,e.uploadUrl=a.uploadUrl,e.cosOptions={secretId:a.secretId,secretKey:a.secretKey,sessionToken:a.sessionToken,expiredTime:a.expiredTime},xe.l("".concat(t," ok. region:").concat(e.region," bucketName:").concat(e.bucketName)),e._initUploaderMethod();}).catch(function(o){e.probeNetwork().then(function(e){var t=v(e,2),s=t[0],a=t[1];n.setError(o,s,a).end();}),xe.w("".concat(t," failed. error:"),o);});}},{key:"_getCosPreSigUrl",value:function value(e){var t=this,n="".concat(this._n,".").concat("_getCosPreSigUrl"),o=Math.ceil(Date.now()/1e3),s=new ka("_getCosPreSigUrl");return this.request({protocolName:Fs,requestData:{fileType:e.fileType,fileName:e.fileName,uploadMethod:e.uploadMethod,duration:e.duration}}).then(function(e){t.tryCount=0;var a=e.data||{},r=a.expiredTime-o;return xe.l("".concat(n," ok. data:"),a),s.setMessage("requestId:".concat(a.requestId," expiredTime:").concat(a.expiredTime," diff:").concat(r,"s")).setNetworkType(t.getNetworkType()).end(),a;}).catch(function(o){return-1===o.code&&(o.code=da.COS_GET_SIG_FAIL),t.probeNetwork().then(function(e){var t=v(e,2),n=t[0],a=t[1];s.setError(o,n,a).end();}),xe.w("".concat(n," failed. error:"),o),t.tryCount<1?(t.tryCount++,t._getCosPreSigUrl(e)):(t.tryCount=0,Ja({code:da.COS_GET_SIG_FAIL}));});}},{key:"_initUploaderMethod",value:function value(){var e=this;if(this.TIMUploadPlugin)return this.timUploadPlugin=new this.TIMUploadPlugin(),void(this._cosUploadMethod=function(t,n){e.timUploadPlugin.uploadFile(t,n);});this.appid&&(this.cos=se?new this.COSSDK({ForcePathStyle:!0,getAuthorization:this._getAuthorization.bind(this)}):new this.COSSDK({getAuthorization:this._getAuthorization.bind(this)}),this._cosUploadMethod=se?function(t,n){e.cos.postObject(t,n);}:function(t,n){e.cos.uploadFiles(t,n);});}},{key:"onCheckTimer",value:function value(e){this.COSSDK&&(this.TIMUploadPlugin||this.isLoggedIn()&&e%60==0&&Math.ceil(Date.now()/1e3)>=this.cosOptions.expiredTime-120&&this._getAuthorizationKey());}},{key:"_getAuthorization",value:function value(e,t){t({TmpSecretId:this.cosOptions.secretId,TmpSecretKey:this.cosOptions.secretKey,XCosSecurityToken:this.cosOptions.sessionToken,ExpiredTime:this.cosOptions.expiredTime});}},{key:"upload",value:function value(e){if(!0===e.getRelayFlag())return Promise.resolve();var t=this.getModule($n);switch(e.type){case S.MSG_IMAGE:return t.addTotalCount(Ma),this._uploadImage(e);case S.MSG_FILE:return t.addTotalCount(Ma),this._uploadFile(e);case S.MSG_AUDIO:return t.addTotalCount(Ma),this._uploadAudio(e);case S.MSG_VIDEO:return t.addTotalCount(Ma),this._uploadVideo(e);default:return Promise.resolve();}}},{key:"_uploadImage",value:function value(e){var n=this,o=this.getModule(Rn),s=e.getElements()[0],a=o.getMessageOption(e.clientSequence);return this.doUploadImage({file:a.payload.file,to:a.to,onProgress:function onProgress(e){if(s.updatePercent(e),it(a.onProgress))try{a.onProgress(e);}catch(t){return Ja({code:da.MESSAGE_ONPROGRESS_FUNCTION_ERROR});}}}).then(function(o){var a,r,i=o.location,u=o.fileType,c=o.fileSize,l=o.width,p=o.height,d=o.smallImageUrl,g=o.smallImageWidth,_=o.smallImageHeight,h=o.largeImageUrl,f=o.largeImageWidth,v=o.largeImageHeight,m=n.isPrivateNetWork()?i:Mt(i);return s.updateImageFormat(u),d&&h?(a={url:d,width:g,height:_},r={url:h,width:f,height:v}):(a=Gt({originUrl:m,originWidth:l,originHeight:p,min:198}),r=Gt({originUrl:m,originWidth:l,originHeight:p,min:720})),s.updateImageInfoArray([{size:c,url:m,width:l,height:p},t({},r),t({},a)]),e;});}},{key:"_uploadFile",value:function value(e){var t=this,n=this.getModule(Rn),o=e.getElements()[0],s=n.getMessageOption(e.clientSequence);return this.doUploadFile({file:s.payload.file,to:s.to,onProgress:function onProgress(e){if(o.updatePercent(e),it(s.onProgress))try{s.onProgress(e);}catch(t){return Ja({code:da.MESSAGE_ONPROGRESS_FUNCTION_ERROR});}}}).then(function(n){var s=n.location,a=t.isPrivateNetWork()?s:Mt(s);return o.updateFileUrl(a),e;});}},{key:"_uploadAudio",value:function value(e){var t=this,n=this.getModule(Rn),o=e.getElements()[0],s=n.getMessageOption(e.clientSequence);return this.doUploadAudio({file:s.payload.file,to:s.to,onProgress:function onProgress(e){if(o.updatePercent(e),it(s.onProgress))try{s.onProgress(e);}catch(t){return Ja({code:da.MESSAGE_ONPROGRESS_FUNCTION_ERROR});}}}).then(function(n){var s=n.location,a=t.isPrivateNetWork()?s:Mt(s);return o.updateAudioUrl(a),e;});}},{key:"_uploadVideo",value:function value(e){var t=this,n=this.getModule(Rn),o=e.getElements()[0],s=n.getMessageOption(e.clientSequence);return this.doUploadVideo({file:s.payload.file,to:s.to,onProgress:function onProgress(e){if(o.updatePercent(e),it(s.onProgress))try{s.onProgress(e);}catch(t){return Ja({code:da.MESSAGE_ONPROGRESS_FUNCTION_ERROR});}}}).then(function(n){var s=n.location,a=n.snapshotInfo,r=t.isPrivateNetWork()?s:Mt(s);return o.updateVideoUrl(r),jt(a)||o.updateSnapshotInfo(a),e;});}},{key:"_checkSizeError",value:function value(e){return Ja({code:da["MESSAGE_".concat(e,"_SIZE_LIMIT")],message:this.getErrorMessage("UploadSizeLimit",e.toLowerCase(),"".concat(this.UPLOAD_SIZE_LIMIT[e]/1048576," MB"))});}},{key:"doUploadImage",value:function value(e){var t=this;if(!e.file)return Ja({code:da.MESSAGE_IMAGE_SELECT_FILE_FIRST});var n=this._checkImageType(e.file);if(!0!==n)return n;var o=this._checkImageSize(e.file);if(!0!==o)return o;var s=null;return this._setUploadFileType(sr),this.uploadByCOS(e).then(function(e){return s=e,t.isPrivateNetWork()?At(e.location):At("https://".concat(e.location));}).then(function(e){return s.width=e.width,s.height=e.height,Promise.resolve(s);});}},{key:"_checkImageType",value:function value(e){var t="";return t=se?e.url.slice(e.url.lastIndexOf(".")+1):e.files[0].name.slice(e.files[0].name.lastIndexOf(".")+1),nr.indexOf(t.toLowerCase())>=0||Ja({code:da.MESSAGE_IMAGE_TYPES_LIMIT});}},{key:"_checkImageSize",value:function value(e){var t=0;return 0===(t=se?e.size:e.files[0].size)?Ja({code:da.MESSAGE_FILE_IS_EMPTY}):t<this.UPLOAD_SIZE_LIMIT.IMAGE||this._checkSizeError("IMAGE");}},{key:"doUploadFile",value:function value(e){return e.file?e.file.files[0].size>this.UPLOAD_SIZE_LIMIT.FILE?this._checkSizeError("FILE"):0===e.file.files[0].size?Ja({code:da.MESSAGE_FILE_IS_EMPTY}):(this._setUploadFileType(ir),this.uploadByCOS(e)):Ja({code:da.MESSAGE_FILE_SELECT_FILE_FIRST});}},{key:"doUploadVideo",value:function value(e){return e.file.videoFile.size>this.UPLOAD_SIZE_LIMIT.VIDEO?this._checkSizeError("VIDEO"):0===e.file.videoFile.size?Ja({code:da.MESSAGE_FILE_IS_EMPTY}):-1===or.indexOf(e.file.videoFile.type)?Ja({code:da.MESSAGE_VIDEO_TYPES_LIMIT}):(this._setUploadFileType(ar),se?this.handleVideoUpload({file:e.file.videoFile,onProgress:e.onProgress}):ae?this.handleVideoUpload(e):void 0);}},{key:"handleVideoUpload",value:function value(e){var t=this;return new Promise(function(n,o){t.uploadByCOS(e).then(function(e){n(e);}).catch(function(){t.uploadByCOS(e).then(function(e){n(e);}).catch(function(){o(new Wa({code:da.MESSAGE_VIDEO_UPLOAD_FAIL}));});});});}},{key:"doUploadAudio",value:function value(e){return e.file?e.file.size>this.UPLOAD_SIZE_LIMIT.AUDIO?this._checkSizeError("AUDIO"):0===e.file.size?Ja({code:da.MESSAGE_FILE_IS_EMPTY}):(this._setUploadFileType(rr),this.uploadByCOS(e)):Ja({code:da.MESSAGE_AUDIO_UPLOAD_FAIL});}},{key:"uploadByCOS",value:function value(e){var t=this;if(!it(this._cosUploadMethod))return this.outputWarning("PluginUndetected"),Ja({code:da.COS_UNDETECTED});if(this.timUploadPlugin)return this._uploadWithPreSigUrl(e);var n=new ka("upload"),o="".concat(this._n,".uploadByCOS"),s=Date.now(),a=this._getFile(e);return new Promise(function(r,i){var u=se?t._createCosOptionsWXMiniApp(e):t._createCosOptionsWeb(e),c=t;t._cosUploadMethod(u,function(e,u){var l=Object.create(null);if(u){if(e||st(u.files)&&u.files[0].error){var p=new Wa({code:da.MESSAGE_FILE_UPLOAD_FAIL});return n.setError(p,!0,t.getNetworkType()).end(),xe.l("".concat(o," failed. error:"),u.files[0].error),403===u.files[0].error.statusCode&&(xe.w("".concat(o," failed. cos AccessKeyId was invalid, regain auth key!")),t._getAuthorizationKey()),void i(p);}l.fileName=a.name,l.fileSize=a.size,l.fileType=a.type.slice(a.type.indexOf("/")+1).toLowerCase(),l.location=se?u.Location:u.files[0].data.Location;var d=Date.now()-s,g=c._formatFileSize(a.size),_=c._formatSpeed(1e3*a.size/d),h="size:".concat(g," time:").concat(d,"ms speed:").concat(_);xe.l("".concat(o," success. name:").concat(a.name," ").concat(h)),r(l);var f=t.getModule($n);return f.addCost(Ma,d),f.addFileSize(Ma,a.size),void n.setNetworkType(t.getNetworkType()).setMessage(h).end();}var v=new Wa({code:da.MESSAGE_FILE_UPLOAD_FAIL});n.setError(v,!0,c.getNetworkType()).end(),xe.w("".concat(o," failed. error:"),e),403===e.statusCode&&(xe.w("".concat(o," failed. cos AccessKeyId was invalid, regain auth key!")),t._getAuthorizationKey()),i(v);});});}},{key:"_uploadWithPreSigUrl",value:function value(e){var t=this,n="".concat(this._n,"._uploadWithPreSigUrl"),o=this._getFile(e);return this._createCosOptionsPreSigUrl(e).then(function(e){return new Promise(function(s,a){var r=new ka("upload"),i=e.requestSnapshotUrl,u=void 0===i?void 0:i,c=g(e,ci),l=Date.now();t._cosUploadMethod(c,function(e,i){if(e||403===i.statusCode)return r.setError(new Wa(e),!0,t.getNetworkType()).end(),xe.l("".concat(n," failed, error:"),e),void a(new Wa({code:da.MESSAGE_FILE_UPLOAD_FAIL}));var p=Object.create(null),d=i.data.location||"";t.isPrivateNetWork()||0!==d.indexOf("https://")&&0!==d.indexOf("http://")||(d=d.split("//")[1]),p.fileName=o.name,p.fileSize=o.size,p.fileType=o.type.slice(o.type.indexOf("/")+1).toLowerCase(),p.location=d;var g=Date.now()-l,_=t._formatFileSize(o.size),h=t._formatSpeed(1e3*o.size/g),f="size:".concat(_,",time:").concat(g,"ms,speed:").concat(h," res:").concat(JSON.stringify(i.data));xe.l("".concat(n," success name:").concat(o.name,",").concat(f)),r.setNetworkType(t.getNetworkType()).setMessage(f).end();var v=t.getModule($n);v.addCost(Ma,g),v.addFileSize(Ma,o.size);var m=[];if(c.thumbUrl&&c.largeUrl&&(m=[t._getSmallImageInfoByUrl(c.thumbUrl,p),t._getLargeImageInfoByUrl(c.largeUrl,p)]),u&&m.push(t._getSnapshotInfoByUrl(u,p)),m.length>0)return Promise.all(m).then(function(){s(p);});s(p);});});});}},{key:"_getRawOrUploadProxyUrl",value:function value(e){var t=this.getModule(qn).getFileUploadProxy(),n=e;return t&&(n=e.replace(/^https:\/\/[^/]+/,t)),n;}},{key:"_getFile",value:function value(e){var t;return st(e.file.files)||(t=e.file.files,"filelist"===ct(t))?e.file.files[0]:e.file;}},{key:"_formatFileSize",value:function value(e){return e<1024?e+"B":e<1048576?Math.floor(e/1024)+"KB":Math.floor(e/1048576)+"MB";}},{key:"_formatSpeed",value:function value(e){return e<=1048576?bt(e/1024,1)+"KB/s":bt(e/1048576,1)+"MB/s";}},{key:"_createCosOptionsWeb",value:function value(e){var t=this._getFile(e),n=t.name,o=n.slice(n.lastIndexOf(".")),s=this._genFileName("".concat(_t(999999)).concat(o));return{files:[{Bucket:"".concat(this.bucketName,"-").concat(this.appid),Region:this.region,Key:"".concat(this.directory,"/").concat(s),Body:t}],SliceSize:1048576,onProgress:function onProgress(t){if("function"==typeof e.onProgress)try{e.onProgress(t.percent);}catch(n){xe.w("onProgress callback error:",n);}},onFileFinish:function onFileFinish(e,t,n){}};}},{key:"_createCosOptionsWXMiniApp",value:function value(e){var t=this._getFile(e),n=this._genFileName(t.name),o=t.url;return{Bucket:"".concat(this.bucketName,"-").concat(this.appid),Region:this.region,Key:"".concat(this.directory,"/").concat(n),FilePath:o,onProgress:function onProgress(t){if(xe.l(JSON.stringify(t)),"function"==typeof e.onProgress)try{e.onProgress(t.percent);}catch(n){xe.w("onProgress callback error:",n);}}};}},{key:"_createCosOptionsPreSigUrl",value:function value(e){var t=this,n="",o="",s=0,a=this._getFile(e);if(se)n=this._genFileName(a.name),o=a.url,s=1;else{var r=a.name,i=r.slice(r.lastIndexOf("."));n=this._genFileName("".concat(_t(999999)).concat(i)),o=a,s=0;}return this._getCosPreSigUrl({fileType:this.uploadFileType,fileName:n,uploadMethod:s,duration:this.duration}).then(function(s){var a=s.uploadUrl,r=s.downloadUrl,i=s.requestSnapshotUrl,u=void 0===i?void 0:i,c=s.thumbUrl,l=s.largeUrl;return{url:t._getRawOrUploadProxyUrl(a),fileType:t.uploadFileType,fileName:n,resources:o,downloadUrl:r,requestSnapshotUrl:u,thumbUrl:c,largeUrl:l,onProgress:function onProgress(t){if("function"==typeof e.onProgress)try{e.onProgress(t.percent);}catch(n){xe.w("onProgress callback error:",n),xe.e(n);}}};});}},{key:"_genFileName",value:function value(e){return"".concat(Rt(),"-").concat(e);}},{key:"_setUploadFileType",value:function value(e){this.uploadFileType=e;}},{key:"_getSnapshotInfoByUrl",value:function value(e,t){var n=this,o=new ka("getSnapshotInfo");return this.request({protocolName:qs,requestData:{platform:this.getPlatform(),coverName:this._genFileName(_t(99999)),requestSnapshotUrl:e}}).then(function(e){var n=(e.data||{}).snapshotUrl;return o.setMessage("snapshotUrl:".concat(n)).end(),jt(n)?{}:At(n).then(function(e){t.snapshotInfo={snapshotUrl:n,snapshotWidth:e.width,snapshotHeight:e.height};});}).catch(function(e){return xe.w("".concat(n._n,"._getSnapshotInfoByUrl failed. error:"),e),o.setCode(e.errorCode).setMessage(e.errorInfo).end(),{};});}},{key:"_getSmallImageInfoByUrl",value:function value(e,t){return At(e).then(function(n){t.smallImageUrl=e,t.smallImageWidth=n.width,t.smallImageHeight=n.height;});}},{key:"_getLargeImageInfoByUrl",value:function value(e,t){return At(e).then(function(n){t.largeImageUrl=e,t.largeImageWidth=n.width,t.largeImageHeight=n.height;});}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset"));}}]),s;}(ro),pi=["downloadKey","pbDownloadKey","messageList"],di=function(){function e(t){o(this,e),this._n="MergerMessageHandler",this._messageModule=t;}return a(e,[{key:"uploadMergerMessage",value:function value(e,t){var n=this,o="".concat(this._n,".").concat("uploadMergerMessage");xe.d("".concat(o," message:"),e,"messageBytes:".concat(t));var s=e.payload.messageList,a=s.length,r=new ka("uploadMergerMessage");return this._messageModule.request({protocolName:Ys,requestData:{messageList:s}}).then(function(e){xe.d("".concat(o," ok. response:"),e.data);var s=e.data,i=s.pbDownloadKey,u=s.downloadKey,c={pbDownloadKey:i,downloadKey:u,messageNumber:a};return r.setNetworkType(n._messageModule.getNetworkType()).setMessage("".concat(a,"-").concat(t,"-").concat(u)).end(),c;}).catch(function(e){throw xe.w("".concat(o," failed. error:"),e),n._messageModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),e;});}},{key:"downloadMergerMessage",value:function value(e){var n=this,o="".concat(this._n,".").concat("downloadMergerMessage");xe.d("".concat(o," message:"),e);var s=e.payload.downloadKey,a=this._messageModule.getFileDownloadProxy(),r=new ka("downloadMergerMessage");return r.setMessage("downloadKey:".concat(s)),this._messageModule.request({protocolName:js,requestData:{downloadKey:s}}).then(function(s){if(xe.d("".concat(o," ok. response:"),s.data),it(e.clearElement)){var i=e.payload;i.downloadKey,i.pbDownloadKey,i.messageList;var u=g(i,pi);e.clearElement(),e.setElement({type:e.type,content:t({messageList:s.data.messageList},u)},a);}else{var c=[];s.data.messageList.forEach(function(e){if(!jt(e)){var t=new xa(e,a);c.push(t);}}),e.payload.messageList=c,e.payload.downloadKey="",e.payload.pbDownloadKey="";}return r.setNetworkType(n._messageModule.getNetworkType()).end(),e;}).catch(function(e){throw xe.w("".concat(o," failed. key:").concat(s," error:"),e),n._messageModule.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];r.setError(e,o,s).end();}),e;});}},{key:"createMergerMessagePack",value:function value(e,t,n){return e.conversationType===S.CONV_C2C?this._createC2CMergerMessagePack(e,t,n):this._createGroupMergerMessagePack(e,t,n);}},{key:"_createC2CMergerMessagePack",value:function value(e,t,n){var o=null;t&&(t.offlinePushInfo&&(o=t.offlinePushInfo),!0===t.onlineUserOnly&&(o?o.disablePush=!0:o={disablePush:!0}));var s=[];if(ot(t)&&ot(t.messageControlInfo)){var a=t.messageControlInfo,r=a.excludedFromUnreadCount,i=a.excludedFromLastMessage,u=a.excludedFromContentModeration;!0===r&&s.push("NoUnread"),!0===i&&s.push("NoLastMsg"),!0===u&&s.push("NoMsgCheck");}var c="";et(e.cloudCustomData)&&e.cloudCustomData.length>0&&(c=e.cloudCustomData);var l=n.pbDownloadKey,p=n.downloadKey,d=n.messageNumber,g=e.payload,_=g.title,h=g.abstractList,f=g.compatibleText,v=this._messageModule.getModule(Gn),m=v&&v.isOnlineMessage(e,t)?0:void 0;return{protocolName:_o,tjgID:this._messageModule.generateTjgID(e),requestData:{fromAccount:this._messageModule.getMyUserID(),toAccount:e.to,msgBody:[{msgType:e.type,msgContent:{pbDownloadKey:l,downloadKey:p,title:_,abstractList:h,compatibleText:f,messageNumber:d}}],cloudCustomData:c,clientTime:e.clientTime,msgSeq:e.sequence,msgRandom:e.random,msgLifeTime:m,offlinePushInfo:o?{pushFlag:!0===o.disablePush?1:0,title:o.title||"",desc:o.description||"",ext:o.extension||"",apnsInfo:{badgeMode:!0===o.ignoreIOSBadge?1:0},androidInfo:{OPPOChannelID:o.androidOPPOChannelID||""}}:void 0,messageControlInfo:0!==m?s:void 0,isSupportExtension:!0===e.isSupportExtension?1:0}};}},{key:"_createGroupMergerMessagePack",value:function value(e,t,n){var o=null;t&&t.offlinePushInfo&&(o=t.offlinePushInfo);var s=[];if(ot(t)&&ot(t.messageControlInfo)){var a=t.messageControlInfo,r=a.excludedFromUnreadCount,i=a.excludedFromLastMessage,u=a.excludedFromContentModeration;!0===r&&s.push("NoUnread"),!0===i&&s.push("NoLastMsg"),!0===u&&s.push("NoMsgCheck");}var c="";et(e.cloudCustomData)&&e.cloudCustomData.length>0&&(c=e.cloudCustomData);var l=n.pbDownloadKey,p=n.downloadKey,d=n.messageNumber,g=e.payload,_=g.title,h=g.abstractList,f=g.compatibleText,v=this._messageModule.getModule(Un),m=v&&v.isOnlineMessage(e,t)?1:0;return{protocolName:ho,tjgID:this._messageModule.generateTjgID(e),requestData:{fromAccount:this._messageModule.getMyUserID(),groupID:e.to,msgBody:[{msgType:e.type,msgContent:{pbDownloadKey:l,downloadKey:p,title:_,abstractList:h,compatibleText:f,messageNumber:d}}],random:e.random,priority:e.priority,clientSequence:e.clientSequence,groupAtInfo:void 0,cloudCustomData:c,onlineOnlyFlag:m,offlinePushInfo:o?{pushFlag:!0===o.disablePush?1:0,title:o.title||"",desc:o.description||"",ext:o.extension||"",apnsInfo:{badgeMode:!0===o.ignoreIOSBadge?1:0},androidInfo:{OPPOChannelID:o.androidOPPOChannelID||""}}:void 0,clientTime:e.clientTime,needReadReceipt:!0!==e.needReadReceipt||v.isMessageFromOrToAVChatroom(e.to)?0:1,messageControlInfo:0===m?s:void 0,isSupportExtension:!0===e.isSupportExtension?1:0}};}}]),e;}(),gi={ERR_SVR_COMM_SENSITIVE_TEXT:80001,ERR_SVR_COMM_BODY_SIZE_LIMIT:80002,OPEN_SERVICE_OVERLOAD_ERROR:60022,ERR_SVR_MSG_PKG_PARSE_FAILED:20001,ERR_SVR_MSG_INTERNAL_AUTH_FAILED:20002,ERR_SVR_MSG_INVALID_ID:20003,ERR_SVR_MSG_PUSH_DENY:20006,ERR_SVR_MSG_IN_PEER_BLACKLIST:20007,ERR_SVR_MSG_BOTH_NOT_FRIEND:20009,ERR_SVR_MSG_NOT_PEER_FRIEND:20010,ERR_SVR_MSG_NOT_SELF_FRIEND:20011,ERR_SVR_MSG_SHUTUP_DENY:20012,ERR_SVR_GROUP_INVALID_PARAMETERS:10004,ERR_SVR_GROUP_PERMISSION_DENY:10007,ERR_SVR_GROUP_NOT_FOUND:10010,ERR_SVR_GROUP_INVALID_GROUPID:10015,ERR_SVR_GROUP_REJECT_FROM_THIRDPARTY:10016,ERR_SVR_GROUP_SHUTUP_DENY:10017,MESSAGE_SEND_FAIL:2100,OVER_FREQUENCY_LIMIT:2996},_i=[da.MESSAGE_ONPROGRESS_FUNCTION_ERROR,da.MESSAGE_IMAGE_SELECT_FILE_FIRST,da.MESSAGE_IMAGE_TYPES_LIMIT,da.MESSAGE_FILE_IS_EMPTY,da.MESSAGE_IMAGE_SIZE_LIMIT,da.MESSAGE_FILE_SELECT_FILE_FIRST,da.MESSAGE_FILE_SIZE_LIMIT,da.MESSAGE_VIDEO_SIZE_LIMIT,da.MESSAGE_VIDEO_TYPES_LIMIT,da.MESSAGE_AUDIO_UPLOAD_FAIL,da.MESSAGE_AUDIO_SIZE_LIMIT,da.COS_UNDETECTED];function hi(e){var t=!1;return Object.values(gi).includes(e)&&(t=!0),(e>=120001&&e<=13e4||e>=10100&&e<=10200)&&(t=!0),t;}var fi=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="MessageModule",t._messageOptionsMap=new Map(),t._mergerMessageHandler=new di(_(t)),t;}return a(s,[{key:"createTextMessage",value:function value(e){var t=this.getMyUserID();e.currentUser=t,e.senderTinyID=this.getMyTinyID();var n=new Ha(e),o="string"==typeof e.payload?e.payload:e.payload.text,s=new La({text:o}),a=this._getNickAndAvatarByUserID(t);return n.setElement(s),n.setNickAndAvatar(a),n.setNameCard(this._getNameCardByGroupID(n)),n;}},{key:"createImageMessage",value:function value(e){var t=this.getMyUserID();e.currentUser=t,e.senderTinyID=this.getMyTinyID();var n=new Ha(e);if(se){var o=e.payload.file;if(Ze(o))return void this.outputWarning("FileUnsupportedInMP","createImageMessage");var s=o.tempFiles[0].path||o.tempFiles[0].tempFilePath,a={url:s,name:s.slice(s.lastIndexOf("/")+1),size:o.tempFiles&&o.tempFiles[0].size||1,type:s.slice(s.lastIndexOf(".")+1).toLowerCase()};e.payload.file=a;}else if(ae)if(Ze(e.payload.file)){var r=e.payload.file;e.payload.file={files:[r]};}else if(ot(e.payload.file)&&"undefined"!=typeof uni){var i=e.payload.file.tempFiles[0];e.payload.file={files:[i]};}var u=new Aa({imageFormat:Ve.UNKNOWN,uuid:this._generateUUID(e.payload.file),file:e.payload.file}),c=this._getNickAndAvatarByUserID(t);return n.setElement(u),n.setNickAndAvatar(c),n.setNameCard(this._getNameCardByGroupID(n)),this._messageOptionsMap.set(n.clientSequence,e),n;}},{key:"createAudioMessage",value:function value(e){var t=e.payload.file;if(se){var n={url:t.tempFilePath,name:t.tempFilePath.slice(t.tempFilePath.lastIndexOf("/")+1),size:t.fileSize,second:parseInt(t.duration)/1e3,type:t.tempFilePath.slice(t.tempFilePath.lastIndexOf(".")+1).toLowerCase()};e.payload.file=n;}var o=this.getMyUserID();e.currentUser=o,e.senderTinyID=this.getMyTinyID();var s=new Ha(e),a=new Na({second:Math.floor(t.duration/1e3),size:t.fileSize||t.size,url:t.tempFilePath,uuid:this._generateUUID(e.payload.file)}),r=this._getNickAndAvatarByUserID(o);return s.setElement(a),s.setNickAndAvatar(r),s.setNameCard(this._getNameCardByGroupID(s)),this._messageOptionsMap.set(s.clientSequence,e),s;}},{key:"createVideoMessage",value:function value(e){var t=this.getMyUserID();e.currentUser=t,e.senderTinyID=this.getMyTinyID(),e.payload.file.thumbUrl="",e.payload.file.thumbSize=0;var n={};if(se){if(ee)return void this.outputWarning("VideoUnsupportedInAlipay");if(Ze(e.payload.file))return void this.outputWarning("FileUnsupportedInMP","createVideoMessage");var o=e.payload.file;st(o.tempFiles)&&(o=o.tempFiles[0]),n.url=o.tempFilePath,n.name=o.tempFilePath.slice(o.tempFilePath.lastIndexOf("/")+1),n.size=o.size||1,n.second=o.duration||0,n.type=o.tempFilePath.slice(o.tempFilePath.lastIndexOf(".")+1).toLowerCase();}else if(ae){if(Ze(e.payload.file)){var s=e.payload.file;e.payload.file.files=[s];}else if(ot(e.payload.file)&&"undefined"!=typeof uni){var a=e.payload.file.tempFile;e.payload.file.files=[a];}var r=e.payload.file;n.url=window.URL.createObjectURL(r.files[0]),n.name=r.files[0].name,n.size=r.files[0].size||1,n.second=r.files[0].duration||0,n.type=r.files[0].type.split("/")[1];}e.payload.file.videoFile=n;var i=new Ha(e),u=new Fa({videoFormat:n.type,videoSecond:bt(n.second,0),videoSize:n.size,remoteVideoUrl:"",videoUrl:n.url,videoUUID:this._generateUUID(e.payload.file.videoFile),thumbUUID:this._generateUUID(e.payload.file.videoFile),thumbWidth:e.payload.file.width||200,thumbHeight:e.payload.file.height||200,thumbUrl:e.payload.file.thumbUrl,thumbSize:e.payload.file.thumbSize,thumbFormat:e.payload.file.thumbUrl.slice(e.payload.file.thumbUrl.lastIndexOf(".")+1).toLowerCase()}),c=this._getNickAndAvatarByUserID(t);return i.setElement(u),i.setNickAndAvatar(c),i.setNameCard(this._getNameCardByGroupID(i)),this._messageOptionsMap.set(i.clientSequence,e),i;}},{key:"createCustomMessage",value:function value(e){var t=this.getMyUserID();e.currentUser=t,e.senderTinyID=this.getMyTinyID();var n=new Ha(e),o=new wa({data:e.payload.data,description:e.payload.description,extension:e.payload.extension}),s=this._getNickAndAvatarByUserID(t);return n.setElement(o),n.setNickAndAvatar(s),n.setNameCard(this._getNameCardByGroupID(n)),n;}},{key:"createFaceMessage",value:function value(e){var t=this.getMyUserID();e.currentUser=t,e.senderTinyID=this.getMyTinyID();var n=new Ha(e),o=new Ra(e.payload),s=this._getNickAndAvatarByUserID(t);return n.setElement(o),n.setNickAndAvatar(s),n.setNameCard(this._getNameCardByGroupID(n)),n;}},{key:"createMergerMessage",value:function value(e){var t=this.getMyUserID();e.currentUser=t,e.senderTinyID=this.getMyTinyID();var n=this._getNickAndAvatarByUserID(t),o=new Ha(e),s=new Va(e.payload);return o.setElement(s),o.setNickAndAvatar(n),o.setNameCard(this._getNameCardByGroupID(o)),o.setRelayFlag(!0),o;}},{key:"createForwardMessage",value:function value(e){var t=e.to,n=e.conversationType,o=e.priority,s=e.payload,a=e.needReadReceipt,r=e.receiverList,i=this.getMyUserID(),u=this._getNickAndAvatarByUserID(i);if(s.type===S.MSG_GRP_TIP)return Ja({code:da.MESSAGE_FORWARD_TYPE_INVALID});var c={to:t,conversationType:n,conversationID:"".concat(n).concat(t),priority:o,isPlaceMessage:0,status:Qt.UNSEND,currentUser:i,senderTinyID:this.getMyTinyID(),cloudCustomData:e.cloudCustomData||s.cloudCustomData||"",needReadReceipt:a,receiverList:r,isSupportExtension:e.isSupportExtension||!1},l=new Ha(c);return l.setElement(s.getElements()[0]),l.setNickAndAvatar(u),l.setNameCard(this._getNameCardByGroupID(s)),l.setRelayFlag(!0),l;}},{key:"downloadMergerMessage",value:function value(e){return this._mergerMessageHandler.downloadMergerMessage(e);}},{key:"createFileMessage",value:function value(e){if(se){if(!X&&!Q&&!ne)return;var n=re.getSystemInfoSync().SDKVersion;if(X&&Ot(n,"2.5.0")<0)return void this.outputWarning("WXChooseMessageFile");if(Q&&Ot(n,"1.18.0")<0)return void this.outputWarning("QQChooseMessageFile");}if(ae||ne){if(Ze(e.payload.file)){var o=e.payload.file;e.payload.file={files:[o]};}else if(ot(e.payload.file)&&"undefined"!=typeof uni){var s=e.payload.file,a=s.tempFiles,r=s.files,i=null;st(a)?i=a[0]:st(r)&&(i=r[0]),e.payload.file={files:[i]};}}else if(X||Q){var u=e.payload.file.tempFiles,c=t(t({},u[0]),{},{url:u[0].path});e.payload.file={files:[c]};}var l=this.getMyUserID();e.currentUser=l,e.senderTinyID=this.getMyTinyID();var p=new Ha(e),d=new ba({uuid:this._generateUUID(e.payload.file),file:e.payload.file}),g=this._getNickAndAvatarByUserID(l);return p.setElement(d),p.setNickAndAvatar(g),p.setNameCard(this._getNameCardByGroupID(p)),this._messageOptionsMap.set(p.clientSequence,e),p;}},{key:"createLocationMessage",value:function value(e){var t=this.getMyUserID();e.currentUser=t,e.senderTinyID=this.getMyTinyID();var n=new Ha(e),o=new qa(e.payload),s=this._getNickAndAvatarByUserID(t);return n.setElement(o),n.setNickAndAvatar(s),n.setNameCard(this._getNameCardByGroupID(n)),n;}},{key:"_onCannotFindModule",value:function value(){return Ja({code:da.CANNOT_FIND_MODULE});}},{key:"sendMessageInstance",value:function value(e,t){var n=this;if(!1===this.getModule(no).filterMessage(e,t))return this._onSendMessageFailed(e,new Wa({code:da.PROFANITY_FOUND}));var o,s=null;switch(e.conversationType){case S.CONV_C2C:if(!(s=this.getModule(Gn)))return this._onCannotFindModule();break;case S.CONV_GROUP:if(!(s=this.getModule(Un)))return this._onCannotFindModule();if(Tt({groupID:e.to})){var a=s.getLocalGroupProfile(e.to);if(a&&a.isSupportTopic)return Ja({code:da.MESSAGE_SEND_GROUP_WITH_TOPIC_FAIL});}break;default:return Ja({code:da.MESSAGE_SEND_INVALID_CONVERSATION_TYPE});}var r=this.getModule(Kn),i=this.getModule(Un);return r.upload(e).then(function(){n._getSendMessageSpecifiedKey(e)===ma&&n.getModule($n).addSuccessCount(Ma);return i.guardForAVChatRoom(e).then(function(){if(!e.isSendable())return Ja({code:da.MESSAGE_FILE_URL_IS_EMPTY});n._addSendMessageTotalCount(e),o=Date.now();var a=function(e){var t="utf-8";ae&&document&&(t=document.charset.toLowerCase());var n,o,s=0;if(o=e.length,"utf-8"===t||"utf8"===t)for(var a=0;a<o;a++){(n=e.codePointAt(a))<=127?s+=1:n<=2047?s+=2:n<=65535?s+=3:(s+=4,a++);}else if("utf-16"===t||"utf16"===t)for(var r=0;r<o;r++){(n=e.codePointAt(r))<=65535?s+=2:(s+=4,r++);}else s=e.replace(/[^\x00-\xff]/g,"aa").length;return s;}(JSON.stringify(e));return e.type===S.MSG_MERGER&&a>11264?n._mergerMessageHandler.uploadMergerMessage(e,a).then(function(o){var s=n._mergerMessageHandler.createMergerMessagePack(e,t,o);return n.request(s);}):(n.getModule(Fn).setMessageRandom(e),e.conversationType===S.CONV_C2C||e.conversationType===S.CONV_GROUP?s.sendMessage(e,t):void 0);}).then(function(a){var r=a.data,i=r.time,u=r.sequence,c=r.readReceiptCode;$e(c)&&0!==c&&(new ka("sendMessageWithReceipt").setMessage("from:".concat(e.from," to:").concat(e.to," sequence:").concat(u," readReceiptCode:").concat(c)).end(),xe.w("".concat(n._n,".sendMessageInstance readReceiptCode:").concat(c," message:").concat(n.getErrorMessage(c))));n._addSendMessageSuccessCount(e,o),n._messageOptionsMap.delete(e.clientSequence);var l=n.getModule(Fn);e.status=Qt.SUCCESS,e.time=i;var p=!1;if(e.conversationType===S.CONV_GROUP)e.sequence=u;else if(e.conversationType===S.CONV_C2C){var d=l.getLatestMessageSentByMe(e.conversationID);if(d){var g=d.nick,_=d.avatar;g===e.nick&&_===e.avatar||(p=!0);}}if(p&&l.modifyMessageSentByMe({conversationID:e.conversationID,latestNick:e.nick,latestAvatar:e.avatar}),s.isOnlineMessage(e,t))e._onlineOnlyFlag=!0;else{l.appendToMessageList(e);var h=e;ot(t)&&ot(t.messageControlInfo)&&(!0===t.messageControlInfo.excludedFromLastMessage&&(e._isExcludedFromLastMessage=!0,h=""),!0===t.messageControlInfo.excludedFromUnreadCount&&(e._isExcludedFromUnreadCount=!0));var f=e.conversationType;if(Dt(e.to))f=S.CONV_TOPIC,n.getModule(wn).onMessageSent({groupID:qt(e.to),topicID:e.to,lastMessage:h});l.onMessageSent({conversationOptionsList:[{conversationID:e.conversationID,unreadCount:0,type:f,subType:e.conversationSubType,lastMessage:h}]});}return e.getRelayFlag()||"TIMImageElem"!==e.type||Ut(e.payload.imageInfoArray),Ka({message:e});});}).catch(function(t){return n._onSendMessageFailed(e,t);});}},{key:"_onSendMessageFailed",value:function value(e,t){e.status=Qt.FAIL,this.getModule(Fn).deleteMessageRandom(e),this._addSendMessageFailCountOnUser(e,t);var n=new ka("sendMessage");return n.setMessage("tjg_id:".concat(this.generateTjgID(e)," type:").concat(e.type," from:").concat(e.from," to:").concat(e.to)),this.probeNetwork().then(function(e){var o=v(e,2),s=o[0],a=o[1];n.setError(t,s,a).end();}),xe.e("".concat(this._n,"._onSendMessageFailed error:"),t),Ja(new Wa({code:t&&t.code?t.code:da.MESSAGE_SEND_FAIL,message:t&&t.message?t.message:void 0,data:{message:e}}));}},{key:"_getSendMessageSpecifiedKey",value:function value(e){if([S.MSG_IMAGE,S.MSG_AUDIO,S.MSG_VIDEO,S.MSG_FILE].includes(e.type))return ma;if(e.conversationType===S.CONV_C2C)return ha;if(e.conversationType===S.CONV_GROUP){var t=this.getModule(Un).getLocalGroupProfile(e.to);if(!t)return;var n=t.type;return Ct(n)?va:fa;}}},{key:"_addSendMessageTotalCount",value:function value(e){var t=this._getSendMessageSpecifiedKey(e);t&&this.getModule($n).addTotalCount(t);}},{key:"_addSendMessageSuccessCount",value:function value(e,t){var n=Math.abs(Date.now()-t),o=this._getSendMessageSpecifiedKey(e);if(o){var s=this.getModule($n);s.addSuccessCount(o),s.addCost(o,n);}}},{key:"_addSendMessageFailCountOnUser",value:function value(e,t){var n,o,s=t.code,a=void 0===s?-1:s,r=this.getModule($n),i=this._getSendMessageSpecifiedKey(e);i===ma&&(n=a,o=!1,_i.includes(n)&&(o=!0),o)?r.addFailedCountOfUserSide(Ma):hi(a)&&i&&r.addFailedCountOfUserSide(i);}},{key:"resendMessage",value:function value(e){return e.isResend=!0,e.status=Qt.UNSEND,this.sendMessageInstance(e);}},{key:"revokeMessage",value:function value(e){var t=this,n=null;if(e.conversationType===S.CONV_C2C?n=this.getModule(Gn):e.conversationType===S.CONV_GROUP&&(n=this.getModule(Un)),!n)return this._onCannotFindModule();var o=new ka("revokeMessage");o.setMessage("tjg_id:".concat(this.generateTjgID(e)," type:").concat(e.type," from:").concat(e.from," to:").concat(e.to));var s="".concat(this._n,".").concat("revokeMessage");return n.revokeMessage(e).then(function(n){var a=n.data.recallRetList;if(!jt(a)&&0!==a[0].retCode){var r=new Wa({code:a[0].retCode,data:{message:e}});return o.setCode(r.code).setMoreMessage(r.message).end(),Ja(r);}return xe.i("".concat(s," ok. ID:").concat(e.ID)),e.isRevoked=!0,o.end(),t.getModule(Fn).onMessageRevoked([e]),Ka({message:e});}).catch(function(n){t.probeNetwork().then(function(e){var t=v(e,2),s=t[0],a=t[1];o.setError(n,s,a).end();});var a=new Wa({code:n&&n.code?n.code:da.MESSAGE_REVOKE_FAIL,message:n&&n.message?n.message:void 0,data:{message:e}});return xe.w("".concat(s," failed. error:"),n),Ja(a);});}},{key:"deleteMessage",value:function value(e){var t=this,n=null,o=e[0],s=o.conversationID,a="",r=[],i=[];if(o.conversationType===S.CONV_C2C)n=this.getModule(Gn),a=s.replace(S.CONV_C2C,""),e.forEach(function(e){e&&e.status===Qt.SUCCESS&&e.conversationID===s&&(e._onlineOnlyFlag||r.push("".concat(e.sequence,"_").concat(e.random,"_").concat(e.time)),i.push(e));});else if(o.conversationType===S.CONV_GROUP)n=this.getModule(Un),a=s.replace(S.CONV_GROUP,""),e.forEach(function(e){e&&e.status===Qt.SUCCESS&&e.conversationID===s&&(e._onlineOnlyFlag||r.push("".concat(e.sequence)),i.push(e));});else if(o.conversationType===S.CONV_SYSTEM)return Ja({code:da.CANNOT_DELETE_GROUP_SYSTEM_NOTICE});if(!n)return this._onCannotFindModule();if(0===r.length)return this._onMessageDeleted(i);r.length>30&&(r=r.slice(0,30),i=i.slice(0,30));var u=new ka("deleteMessage");u.setMessage("to:".concat(a," count:").concat(r.length));var c="".concat(this._n,".").concat("deleteMessage");return n.deleteMessage({to:a,keyList:r}).then(function(e){return u.end(),xe.i("".concat(c," ok")),t._onMessageDeleted(i);}).catch(function(e){t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.w("".concat(c," failed. error:"),e);var n=new Wa({code:e&&e.code?e.code:da.MESSAGE_DELETE_FAIL,message:e&&e.message?e.message:void 0});return Ja(n);});}},{key:"_onMessageDeleted",value:function value(e){return this.getModule(Fn).onMessageDeleted(e),za({messageList:e});}},{key:"translateText",value:function value(e){var n="".concat(this._n,".").concat("translateText"),o=e.sourceTextList,s=e.sourceLanguage,a=e.targetLanguage,r=new ka("translateText");return r.setMessage("sourceLanguage:".concat(s," targetLanguage:").concat(a)),this.request({protocolName:pa,requestData:{sourceTextList:o,source:s||"auto",target:a,from:this.getMyTinyID(),SDKAppID:this.getSDKAppID()}}).then(function(e){var o=e.data,s=o.error,a=o.requestID,i=o.translatedTextList;if(0===s.code)return r.end(),xe.i("".concat(n," ok. requestID:").concat(a)),Ka({translatedTextList:i});throw t(t({},s),{},{requestID:a});}).catch(function(e){return r.setCode(e.code).setMoreMessage(e.requestID).end(),xe.w("".concat(n," failed. error:"),e),Ja({code:da.TRANSLATE_TEXT_FAIL});});}},{key:"modifyRemoteMessage",value:function value(e){var t=this,n=null,o=e.conversationType,s=e.to;if(this.getModule(Un).isMessageFromOrToAVChatroom(s))return Ja({code:da.MESSAGE_MODIFY_DISABLED_IN_AVCHATROOM,data:{message:e}});if(!1===this.getModule(no).filterMessage(e))return Ja({code:da.PROFANITY_FOUND,data:{message:e}});o===S.CONV_C2C?n=this.getModule(Gn):o===S.CONV_GROUP&&(n=this.getModule(Un));var a=new ka("modifyMessage");a.setMessage("to:".concat(s));var r="".concat(this._n,".modifyRemoteMessage");return n.modifyRemoteMessage(e).then(function(n){a.end(),xe.i("".concat(r," ok"));var o=t._onModifyRemoteMessageResp(e,n.data);return Ka({message:o});}).catch(function(n){if(a.setCode(n.code).setMoreMessage(n.message).end(),xe.w("".concat(r," failed. error:"),n),20027===n.code){var o=t._onModifyRemoteMessageResp(e,n.data);return Ja({code:da.MESSAGE_MODIFY_CONFLICT,data:{message:o}});}return Ja({code:n.code,message:n.message,data:{message:e}});});}},{key:"_onModifyRemoteMessageResp",value:function value(e,t){xe.d("".concat(this._n,"._onModifyRemoteMessageResp options:"),t);var n=e.conversationType,o=e.from,s=e.to,a=e.random,r=e.sequence,i=e.time,u=t.elements,c=t.messageVersion,l=t.cloudCustomData,p=void 0===l?"":l;return this.getModule(Fn).onMessageModified({conversationType:n,from:o,to:s,time:i,random:a,sequence:r,elements:u,cloudCustomData:p,messageVersion:c});}},{key:"_generateUUID",value:function value(e){var t=this.getModule(qn),n="".concat(t.getSDKAppID(),"-").concat(t.getUserID(),"-").concat(function(){for(var e="",t=32;t>0;--t){e+=ht[Math.floor(Math.random()*ft)];}return e;}()),o=e.name||e.value||e.url||e.tempFilePath,s=o&&o.slice(o.lastIndexOf(".")+1);return s&&(n="".concat(n,".").concat(s)),n;}},{key:"getMessageOption",value:function value(e){return this._messageOptionsMap.get(e);}},{key:"_getNickAndAvatarByUserID",value:function value(e){return this.getModule(On).getNickAndAvatarByUserID(e);}},{key:"_getNameCardByGroupID",value:function value(e){if(e.conversationType===S.CONV_GROUP){var t=this.getModule(Un);if(t)return t.getMyNameCardByGroupID(e.to);}return"";}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._messageOptionsMap.clear();}}]),s;}(ro),vi=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="MessageExtensionModule",s.messageExtensionMap=new Map(),s.globalSeqMap=new Map(),s.getMessageExtensionsMap=new Map(),s;}return a(n,[{key:"onMessageExtensionNotify",value:function value(e){var t=this,n=e.dataList,o=n.messageInfo,s=n.operateType,a=n.operateResultList,r=n.tinyID,i=n.globalSequence,u=o.clientTime,c=o.random,l="".concat(r,"-").concat(u,"-").concat(c),p=[],d=[];xe.l("".concat(this._n,".onMessageExtensionNotify messageID:").concat(l," operateType:").concat(s," globalSequence:").concat(i)),this._updateGlobalSequence(l,i);var g=!1,_=!1;a.forEach(function(e){var n=e.extensions,o=void 0===n?[]:n,a=e.clearSequence;if(1===s)g=!0,o.forEach(function(e){p.push({key:e.key,value:e.value});}),t._updateLocalExtension(l,o);else if(2===s)_=!0,o.forEach(function(e){d.push(e.key);}),t._updateLocalExtension(l,o);else if(3===s){if(_=!0,t._hasLocalExtension(l))t._getLocalExtension(l).forEach(function(e,t){e.seq<=a&&!jt(e.value)&&d.push(t);});t._clearLocalExtension(l,a);}}),g&&this.emitOuterEvent(E.MESSAGE_EXTENSIONS_UPDATED,{messageID:l,extensions:p}),_&&this.emitOuterEvent(E.MESSAGE_EXTENSIONS_DELETED,{messageID:l,keyList:d});}},{key:"setMessageExtensions",value:function value(e,t){var n=this;if(!this.canIUse(B.MSG_EXT))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var o="".concat(this._n,".").concat("setMessageExtensions"),s=e.ID,a=e.conversationID,r=e.sequence,i=e.time,u=m(t);t.length>20&&(u=t.slice(0,20),xe.w("".concat(o,". the length of extensions cannot exceed 20.")));var c="conversationID:".concat(a," messageID:").concat(s," sequence:").concat(r," time:").concat(i," count:").concat(u.length),l=new ka("setMessageExtensions");return l.setMessage(c),xe.l("".concat(o," ").concat(c)),this._modifyMessageExtensions(e,u).then(function(e){var t=e.resultList,n=e.successCount,s=e.failureCount,a="success count:".concat(n," fail count:").concat(s);return l.setMoreMessage(a).end(),xe.l("".concat(o," ok. ").concat(a)),Ka({extensions:t});}).catch(function(e){return n.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];l.setError(e,o,s).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}},{key:"getMessageExtensions",value:function value(e){var t=this;if(!this.canIUse(B.MSG_EXT))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var n="".concat(this._n,".").concat("getMessageExtensions"),o=e.ID,s=e.conversationID,a=e.sequence,r=e.time,i="conversationID:".concat(s," messageID:").concat(o," sequence:").concat(a," time:").concat(r),u=new ka("getMessageExtensions");u.setMessage(i),xe.l("".concat(n," ").concat(i));var c=void 0;return this.getMessageExtensionsMap.has(o)&&(c=this._getGlobalSequence(o)),this._getMessageExtensions(e,c).then(function(e){return u.end(),xe.l("".concat(n," ok. total count:").concat(e.length)),at(c)&&e.length>0&&t.getMessageExtensionsMap.set(o,1),Ka({extensions:e});}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];u.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"deleteMessageExtensions",value:function value(e,t){var n=this;if(!this.canIUse(B.MSG_EXT))return Ja({code:da.CANNOT_USE_COMMERCIAL_ABILITY});var o="".concat(this._n,".").concat("deleteMessageExtensions"),s=[],a=3;jt(t)||(a=2,t.forEach(function(e){s.push({key:e,value:"",seq:0});}));var r=e.ID,i=e.conversationID,u=e.sequence,c=e.time,l="conversationID:".concat(i," messageID:").concat(r," sequence:").concat(u," time:").concat(c," operateType:").concat(a),p=new ka("deleteMessageExtensions");return p.setMessage(l),xe.l("".concat(o," ").concat(l)),this._modifyMessageExtensions(e,s,a).then(function(e){var t=e.resultList,n=e.successCount,s=e.failureCount,r="";return 2===a&&(r="success count:".concat(n," fail count:").concat(s)),p.setMoreMessage("".concat(r)).end(),xe.l("".concat(o," ok. ").concat(r)),Ka({extensions:t});}).catch(function(e){return n.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];p.setError(e,o,s).end();}),xe.e("".concat(o," failed. error:"),e),Ja(e);});}},{key:"_modifyMessageExtensions",value:function value(e,t){var n=this,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,s=Dt(e.to)?S.CONV_TOPIC:e.conversationType,a=void 0;3!==o&&(a=this._getRequestExtensions(e,t));var r=null;switch(s){case S.CONV_C2C:r=this.getModule(Gn);break;case S.CONV_GROUP:r=this.getModule(Un);break;case S.CONV_TOPIC:r=this.getModule(wn);break;default:return Ja({code:da.CANNOT_FIND_MODULE});}return r.modifyMessageExtensions(e,a,o).then(function(t){var o=t.data,s=o.extensions,a=o.seq,r=[],i=0,u=0,c=[];return(s=jt(s)?[]:s).forEach(function(e){var t=e.errorCode,n=e.extension,o=n.key,s=n.value,a=n.seq;r.push({code:t,key:o,value:s}),0===t?i++:u++,c.push({key:o,value:s,seq:a});}),n._updateGlobalSequence(e.ID,a),c.length>0&&(n._updateLocalExtension(e.ID,c),c=null),{resultList:r,successCount:i,failureCount:u};}).catch(function(e){return Ja(e);});}},{key:"_getRequestExtensions",value:function value(e,t){var n=[];if(this._hasLocalExtension(e.ID)){var o=this._getLocalExtension(e.ID);return t.forEach(function(e){var t=e.key,s=e.value,a=0;o.has(t)&&(a=o.get(t).seq),n.push({key:t,value:s,seq:a});}),n;}return t.forEach(function(e){var t=e.key,o=e.value;n.push({key:t,value:o,seq:0});}),n;}},{key:"_getMessageExtensions",value:function value(e,t){var n=this,o="".concat(this._n,"._getMessageExtensions"),s=e.ID,a=e.to,r=null;switch(Dt(a)?S.CONV_TOPIC:e.conversationType){case S.CONV_C2C:r=this.getModule(Gn);break;case S.CONV_GROUP:r=this.getModule(Un);break;case S.CONV_TOPIC:r=this.getModule(wn);break;default:return Ja({code:da.CANNOT_FIND_MODULE});}return r.getMessageExtensions(e,t).then(function(t){var a=t.data,r=a.extensions,i=a.completeFlag,u=a.globalSequence,c=a.clearSequence;if(r=jt(r)?[]:r,xe.l("".concat(o," ok. completeFlag:").concat(i," globalSequence:").concat(u," clearSequence:").concat(c," count:").concat(r.length)),n._updateLocalExtension(s,r),n._clearLocalExtension(s,c),n._updateGlobalSequence(s,u),1!==i){var l=r.slice(-1)[0].seq+1;return n._getMessageExtensions(e,l);}return n._getLocalExtensions(s);}).catch(function(e){return Ja(e);});}},{key:"_hasLocalExtension",value:function value(e){return this.messageExtensionMap.has(e);}},{key:"_getLocalExtension",value:function value(e){return this.messageExtensionMap.get(e);}},{key:"_updateLocalExtension",value:function value(e,t){this._hasLocalExtension(e)||this.messageExtensionMap.set(e,new Map());var n=this._getLocalExtension(e);t.forEach(function(e){var t=e.key,o=e.value,s=void 0===o?"":o,a=e.seq;n.set(t,{value:s,seq:a});});}},{key:"_clearLocalExtension",value:function value(e,t){if(!(t<=0)&&this._hasLocalExtension(e)){var n=this._getLocalExtension(e);n.forEach(function(e,o){e.seq<=t&&n.delete(o);});}}},{key:"_getLocalExtensions",value:function value(e){var t=[];this._hasLocalExtension(e)&&this._getLocalExtension(e).forEach(function(e,n){var o=e.value;jt(o)||t.push({key:n,value:o});});return t;}},{key:"_getGlobalSequence",value:function value(e){return this.globalSeqMap.get(e);}},{key:"_updateGlobalSequence",value:function value(e,t){this.globalSeqMap.set(e,t);}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this.messageExtensionMap.clear(),this.globalSeqMap.clear(),this.getMessageExtensionsMap.clear();}}]),n;}(ro),mi=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="ComboMessageModule",s;}return a(n,[{key:"sendMessage",value:function value(e){var t=this,n=this._constructMessageInstance(e);if(null===n)return Ja({code:da.MESSAGE_SEND_FAIL});this._addSendMessageTotalCount(n);var o=Date.now();return this.getModule(Fn).setMessageRandom(n),this._sendComboMessage(n,e).then(function(e){var s=e.data,a=s.time,r=s.sequence,i=s.readReceiptCode;$e(i)&&0!==i&&(new ka("sendMessageWithReceipt").setMessage("from:".concat(n.from," to:").concat(n.to," sequence:").concat(r," readReceiptCode:").concat(i)).end(),xe.w("".concat(t._n,".sendMessage readReceiptCode:").concat(i," message:").concat(t.getErrorMessage(i))));t._addSendMessageSuccessCount(n,o);var u=t.getModule(Fn);n.status=Qt.SUCCESS,n.time=a,n.conversationType===S.CONV_GROUP&&(n.sequence=r),u.appendToMessageList(n);var c=n;return!0===n._isExcludedFromLastMessage&&(c=""),u.onMessageSent({conversationOptionsList:[{conversationID:n.conversationID,unreadCount:0,type:n.conversationType,subType:n.conversationSubType,lastMessage:c}]}),Ka({message:n});}).catch(function(e){return t._onSendMessageFailed(n,e);});}},{key:"_sendComboMessage",value:function value(e,t){var n=this._m.getModule(jn),o="";return e.conversationType===S.CONV_C2C&&(o="".concat(V.NAME.OPEN_IM,".").concat(V.CMD.SEND_MESSAGE)),e.conversationType===S.CONV_GROUP&&(o="".concat(V.NAME.GROUP,".").concat(V.CMD.SEND_GROUP_MESSAGE)),n.sendComboMessage({servcmd:o,data:t});}},{key:"_constructMessageInstance",value:function value(e){var t="".concat(this._n,"._constructMessageInstance"),n=null;try{var o=this.getMyUserID(),s={};if(s.senderTinyID=this.getMyTinyID(),s.currentUser=o,s.from=e.From_Account||o,e.GroupId?(s.conversationID="".concat(S.CONV_GROUP).concat(e.GroupId),s.conversationType=S.CONV_GROUP,s.to=e.GroupId):e.To_Account&&(s.conversationID="".concat(S.CONV_C2C).concat(e.To_Account),s.conversationType=S.CONV_C2C,s.to=e.To_Account),s.time=e.MsgTimeStamp||0,s.random=e.Random||e.MsgRandom||0,s.priority=e.MsgPriority,et(e.CloudCustomData)&&e.CloudCustomData.length>0&&(s.cloudCustomData=e.CloudCustomData),st(e.SendMsgControl)&&(s.messageControlInfo={},e.SendMsgControl.includes("NoUnread")&&(s.messageControlInfo.excludedFromUnreadCount=1),e.SendMsgControl.includes("NoLastMsg")&&(s.messageControlInfo.excludedFromLastMessage=1)),s.conversationType===S.CONV_GROUP&&st(e.To_Account)&&e.To_Account.length>0){var a=e.To_Account;e.To_Account.length>50&&(a=e.To_Account.slice(0,50),xe.w("".concat(t," To_Account must be less than or equal to 50."))),s.receiverList=m(a),e.To_Account=m(a);}1!==e.IsNeedReadReceipt&&1!==e.NeedReadReceipt||(s.needReadReceipt=!0),1===e.SupportMessageExtension&&(s.isSupportExtension=!0),(n=new Ha(s)).status=Qt.UNSEND,e.MsgClientTime=n.clientTime,n.conversationType===S.CONV_C2C&&(e.MsgSeq=n.sequence);for(var r,i=e.MsgBody.length,u=0;u<i;u++){"TIMTextElem"===(r=e.MsgBody[u]).MsgType?n.setTextElement(r.MsgContent.Text):"TIMCustomElem"===r.MsgType?n.setCustomElement({data:r.MsgContent.Data||"",description:r.MsgContent.Desc||"",extension:r.MsgContent.Ext||""}):"TIMFaceElem"===r.MsgType&&n.setFaceElement({index:r.MsgContent.Index,data:r.MsgContent.Data});}var c=n.getElements();n.payload=c[0].content,n.type=c[0].type;}catch(l){n=null,xe.e("".concat(t," failed. error:"),l);}return n;}},{key:"_onSendMessageFailed",value:function value(e,t){e.status=Qt.FAIL,this.getModule(Fn).deleteMessageRandom(e),this._addSendMessageFailCountOnUser(e,t);var n=new ka("sendMessage");return n.setMessage("tjg_id:".concat(this.generateTjgID(e)," type:").concat(e.type," from:").concat(e.from," to:").concat(e.to)),this.probeNetwork().then(function(e){var o=v(e,2),s=o[0],a=o[1];n.setError(t,s,a).end();}),xe.e("".concat(this._n,"._onSendMessageFailed error:"),t),Ja(new Wa({code:t&&t.code?t.code:da.MESSAGE_SEND_FAIL,message:t&&t.message?t.message:void 0,data:{message:e}}));}},{key:"_getSendMessageSpecifiedKey",value:function value(e){if(e.conversationType===S.CONV_C2C)return ha;if(e.conversationType===S.CONV_GROUP){var t=this.getModule(Un).getLocalGroupProfile(e.to);if(!t)return;var n=t.type;return Ct(n)?va:fa;}}},{key:"_addSendMessageTotalCount",value:function value(e){var t=this._getSendMessageSpecifiedKey(e);t&&this.getModule($n).addTotalCount(t);}},{key:"_addSendMessageSuccessCount",value:function value(e,t){var n=Math.abs(Date.now()-t),o=this._getSendMessageSpecifiedKey(e);if(o){var s=this.getModule($n);s.addSuccessCount(o),s.addCost(o,n);}}},{key:"_addSendMessageFailCountOnUser",value:function value(e,t){var n=t.code,o=void 0===n?-1:n,s=this.getModule($n),a=this._getSendMessageSpecifiedKey(e);hi(o)&&a&&s.addFailedCountOfUserSide(a);}}]),n;}(ro),Mi=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="PluginModule",s.plugins={},s;}return a(n,[{key:"registerPlugin",value:function value(e){var t=this;Object.keys(e).forEach(function(n){t.plugins[n]=e[n];}),new ka("registerPlugin").setMessage("".concat(Object.keys(e))).end();}},{key:"getPlugin",value:function value(e){return this.plugins[e];}},{key:"reset",value:function value(){}}]),n;}(ro),yi=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="SyncUnreadMessageModule",t._cookie="",t._onlineSyncFlag=!1,t.getInnerEmitterInstance().on(Za,t._onLoginSuccess,_(t)),t;}return a(s,[{key:"_onLoginSuccess",value:function value(e){this._startSync({cookie:this._cookie,syncFlag:0,isOnlineSync:0});}},{key:"_startSync",value:function value(e){var n=this,o=e.cookie,s=e.syncFlag,a=e.isOnlineSync,r="".concat(this._n,"._startSync");xe.l("".concat(r," cookie:").concat(o," syncFlag:").concat(s," isOnlineSync:").concat(a)),this.request({protocolName:po,requestData:{cookie:o,syncFlag:s,isOnlineSync:a}}).then(function(e){var o=e.data,s=o.cookie,a=o.syncFlag;n._cookie=s,jt(s)||(0===a||1===a?(n._dispatchUnreadMessage(t(t({},e.data),{},{isSyncingEnded:!1})),n._startSync({cookie:s,syncFlag:a,isOnlineSync:0})):2===a&&n._dispatchUnreadMessage(t(t({},e.data),{},{isSyncingEnded:!0})));}).catch(function(e){xe.e("".concat(r," failed. error:"),e);});}},{key:"_dispatchUnreadMessage",value:function value(e){e.eventArray&&this.getModule(jn).onMessage({head:{},body:{eventArray:e.eventArray,isInstantMessage:this._onlineSyncFlag,isSyncingEnded:e.isSyncingEnded}});this.getModule(Gn).onNewC2CMessage({dataList:e.messageList,isInstantMessage:!!e.isSyncingEnded&&this._onlineSyncFlag,C2CRemainingUnreadList:e.C2CRemainingUnreadList,C2CPairUnreadList:e.C2CPairUnreadList});}},{key:"startOnlineSync",value:function value(){xe.l("".concat(this._n,".startOnlineSync")),this._onlineSyncFlag=!0,this._startSync({cookie:this._cookie,syncFlag:0,isOnlineSync:1});}},{key:"startSyncOnReconnected",value:function value(){xe.l("".concat(this._n,".startSyncOnReconnected.")),this._onlineSyncFlag=!0,this._startSync({cookie:this._cookie,syncFlag:0,isOnlineSync:0});}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._onlineSyncFlag=!1,this._cookie="";}}]),s;}(ro),Ii={request:{toAccount:"To_Account",fromAccount:"From_Account",to:"To_Account",from:"From_Account",groupID:"GroupId",groupAtUserID:"GroupAt_Account",extension:"Ext",data:"Data",description:"Desc",elements:"MsgBody",sizeType:"Type",downloadFlag:"Download_Flag",thumbUUID:"ThumbUUID",videoUUID:"VideoUUID",remoteAudioUrl:"Url",remoteVideoUrl:"VideoUrl",videoUrl:"",imageUrl:"URL",fileUrl:"Url",uuid:"UUID",priority:"MsgPriority",receiverUserID:"To_Account",receiverGroupID:"GroupId",messageSender:"SenderId",messageReceiver:"ReceiverId",nick:"From_AccountNick",avatar:"From_AccountHeadurl",messageNumber:"MsgNum",pbDownloadKey:"PbMsgKey",downloadKey:"JsonMsgKey",applicationType:"PendencyType",userIDList:"To_Account",groupNameList:"GroupName",userID:"To_Account",groupAttributeList:"GroupAttr",mainSequence:"AttrMainSeq",avChatRoomKey:"BytesKey",attributeControl:"AttrControl",sequence:"seq",messageControlInfo:"SendMsgControl",updateSequence:"UpdateSeq",clientTime:"MsgClientTime",sequenceList:"MsgSeqList",topicID:"TopicId",customData:"CustomString",isSupportTopic:"SupportTopic",isWebUniapp:"is_web_uniapp",isSupportExtension:"SupportMessageExtension",messageSequence:"MsgSeq",messageKey:"MsgKey",startSequence:"startSeq",simplifiedMessage:"DownsizeFlag"},response:{MsgPriority:"priority",ThumbUUID:"thumbUUID",VideoUUID:"videoUUID",Download_Flag:"downloadFlag",GroupId:"groupID",Member_Account:"userID",MsgList:"messageList",SyncFlag:"syncFlag",To_Account:"to",From_Account:"from",MsgSeq:"sequence",MsgRandom:"random",MsgTime:"time",MsgTimeStamp:"time",MsgContent:"content",MsgBody:"elements",From_AccountNick:"nick",From_AccountHeadurl:"avatar",GroupWithdrawInfoArray:"revokedInfos",GroupReadInfoArray:"groupMessageReadNotice",LastReadMsgSeq:"lastMessageSeq",WithdrawC2cMsgNotify:"c2cMessageRevokedNotify",C2cWithdrawInfoArray:"revokedInfos",C2cReadedReceipt:"c2cMessageReadReceipt",ReadC2cMsgNotify:"c2cMessageReadNotice",LastReadTime:"peerReadTime",MsgRand:"random",MsgType:"type",MsgShow:"messageShow",NextMsgSeq:"nextMessageSeq",FaceUrl:"avatar",ProfileDataMod:"profileModify",Profile_Account:"userID",ValueBytes:"value",ValueNum:"value",NoticeSeq:"noticeSequence",NotifySeq:"notifySequence",MsgFrom_AccountExtraInfo:"messageFromAccountExtraInformation",Operator_Account:"operatorID",OpType:"operationType",ReportType:"operationType",UserId:"userID",User_Account:"userID",List_Account:"userIDList",MsgOperatorMemberExtraInfo:"operatorInfo",MsgMemberExtraInfo:"memberInfoList",ImageUrl:"avatar",NickName:"nick",MsgGroupNewInfo:"newGroupProfile",MsgAppDefinedData:"groupCustomField",Owner_Account:"ownerID",GroupFaceUrl:"avatar",GroupIntroduction:"introduction",GroupNotification:"notification",GroupApplyJoinOption:"joinOption",MsgKey:"messageKey",GroupInfo:"groupProfile",ShutupTime:"muteTime",Desc:"description",Ext:"extension",GroupAt_Account:"groupAtUserID",MsgNum:"messageNumber",PbMsgKey:"pbDownloadKey",JsonMsgKey:"downloadKey",MsgModifiedFlag:"isModified",PendencyItem:"applicationItem",PendencyType:"applicationType",AddTime:"time",AddSource:"source",AddWording:"wording",ProfileImImage:"avatar",PendencyAdd:"friendApplicationAdded",FrienPencydDel_Account:"friendApplicationDeletedUserIDList",Peer_Account:"userID",GroupAttr:"groupAttributeList",GroupAttrAry:"groupAttributeList",AttrMainSeq:"mainSequence",seq:"sequence",GroupAttrOption:"groupAttributeOption",BytesChangedKeys:"changedKeyList",GroupAttrInfo:"groupAttributeList",GroupAttrSeq:"mainSequence",PushChangedAttrValFlag:"isWithChangedAttributeInfo",SubKeySeq:"sequence",Val:"value",MsgGroupFromCardName:"senderNameCard",MsgGroupFromNickName:"senderNick",C2cNick:"peerNick",C2cImage:"peerAvatar",SendMsgControl:"messageControlInfo",NoLastMsg:"excludedFromLastMessage",NoUnread:"excludedFromUnreadCount",UpdateSeq:"updateSequence",MuteNotifications:"muteFlag",MsgClientTime:"clientTime",TinyId:"tinyID",GroupMsgReceiptList:"readReceiptList",ReadNum:"readCount",UnreadNum:"unreadCount",TopicId:"topicID",MillionGroupFlag:"communityType",SupportTopic:"isSupportTopic",MsgTopicNewInfo:"newTopicInfo",ShutupAll:"muteAllMembers",CustomString:"customData",TopicFaceUrl:"avatar",TopicIntroduction:"introduction",TopicNotification:"notification",TopicIdArray:"topicIDList",MsgVersion:"messageVersion",C2cMsgModNotifys:"c2cMessageModified",GroupMsgModNotifys:"groupMessageModified",ApplyJoinOption:"joinOption",MsgFlag:"messageRemindType",AtInfoList:"groupAtInfoList",AtFlagList:"groupAtType",AtMsgSeq:"sequence",BanDuration:"duration",BanDescription:"reason",NotVisible:"invisible",BytesTag:"tag",BytesValue:"value",RptBytesValue:"value",LatestSeq:"globalSequence",ClearSeq:"clearSequence",SupportMessageExtension:"isSupportExtension",ExtensionList:"extensions",GroupCounter:"counterList",Revoker_Account:"revoker",MsgExtensionNotify:"messageExtensionNotify",ExtensionC2cMsgInfo:"messageInfo",ExtensionGroupMsgInfo:"messageInfo",MsgOptType:"operateType",SetKVInfo:"operateResultList",DeleteKVInfo:"operateResultList",ClearKVInfo:"operateResultList",MsgKeyValue:"extensions",ClearMsgSeq:"clearSequence",MsgLastSeq:"globalSequence",InviteJoinOption:"inviteOption",MemberList_Account:"inviteeList",MsgMemberExtraInfoList:"inviteeInfoList",E:"event",GInf:"groupProfile",MCT:"clientTime",MR:"random",MP:"priority",MTS:"time",GId:"groupID",MS:"sequence",CCD:"cloudCustomData",F_Account:"from",F_Hd:"avatar",F_NN:"nick",GN:"groupName",GT:"groupType",IsSys:"isSystemMessage",OpInf:"operatorInfo",Img:"avatar",NN:"nick",OnlineInf:"onlineMemberInfo",ET:"expireTime",Num:"onlineMemberNum",Opt:"operationType",O_Account:"operatorID",RT:"operationType",UDF:"userDefinedField",L_Account:"userIDList"},ignoreKeyWord:["C2C","ID","USP"]};function Ci(e,t){if("string"!=typeof e&&!Array.isArray(e))throw new TypeError("Expected the input to be `string | string[]`");t=Object.assign({pascalCase:!1},t);var n;return 0===(e=Array.isArray(e)?e.map(function(e){return e.trim();}).filter(function(e){return e.length;}).join("-"):e.trim()).length?"":1===e.length?t.pascalCase?e.toUpperCase():e.toLowerCase():(e!==e.toLowerCase()&&(e=Ti(e)),e=e.replace(/^[_.\- ]+/,"").toLowerCase().replace(/[_.\- ]+(\w|$)/g,function(e,t){return t.toUpperCase();}).replace(/\d+(\w|$)/g,function(e){return e.toUpperCase();}),n=e,t.pascalCase?n.charAt(0).toUpperCase()+n.slice(1):n);}var Ti=function Ti(e){for(var t=!1,n=!1,o=!1,s=0;s<e.length;s++){var a=e[s];t&&/[a-zA-Z]/.test(a)&&a.toUpperCase()===a?(e=e.slice(0,s)+"-"+e.slice(s),t=!1,o=n,n=!0,s++):n&&o&&/[a-zA-Z]/.test(a)&&a.toLowerCase()===a?(e=e.slice(0,s-1)+"-"+e.slice(s-1),o=n,n=!1,t=!0):(t=a.toLowerCase()===a&&a.toUpperCase()!==a,o=n,n=a.toUpperCase()===a&&a.toLowerCase()!==a);}return e;};function Di(e,t){var n=0;return function e(t,o){if(++n>100)return n--,t;if(st(t)){var s=t.map(function(t){return nt(t)?e(t,o):t;});return n--,s;}if(nt(t)){var a=(r=t,i=function i(e,t){if(!lt(t))return!1;if((s=t)!==Ci(s))for(var n=0;n<Ii.ignoreKeyWord.length&&!t.includes(Ii.ignoreKeyWord[n]);n++){}var s;return at(o[t])?function(e){return"OPPOChannelID"===e?e:e[0].toUpperCase()+Ci(e).slice(1);}(t):o[t];},u=Object.create(null),Object.keys(r).forEach(function(e){var t=i(r[e],e);t&&(u[t]=r[e]);}),u);return a=Lt(a,function(t,n){return st(t)||nt(t)?e(t,o):t;}),n--,a;}var r,i,u;}(e,t);}function Ei(e,t){if(st(e))return e.map(function(e){return nt(e)?Ei(e,t):e;});if(nt(e)){var n=(o=e,s=function s(e,n){return at(t[n])?Ci(n):t[n];},a={},Object.keys(o).forEach(function(e){a[s(o[e],e)]=o[e];}),a);return n=Lt(n,function(e){return st(e)||nt(e)?Ei(e,t):e;});}var o,s,a;}var Si=String.fromCharCode,ki=function ki(e){var t=0|e.charCodeAt(0);if(55296<=t)if(t<56320){var n=0|e.charCodeAt(1);if(56320<=n&&n<=57343){if((t=(t<<10)+n-56613888|0)>65535)return Si(240|t>>>18,128|t>>>12&63,128|t>>>6&63,128|63&t);}else t=65533;}else t<=57343&&(t=65533);return t<=2047?Si(192|t>>>6,128|63&t):Si(224|t>>>12,128|t>>>6&63,128|63&t);},Li=function Li(e){for(var t=void 0===e?"":(""+e).replace(/[\x80-\uD7ff\uDC00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g,ki),n=0|t.length,o=new Uint8Array(n),s=0;s<n;s=s+1|0){o[s]=0|t.charCodeAt(s);}return o;},Ai=function Ai(e){for(var t=new Uint8Array(e),n="",o=0,s=t.length;o<s;){var a=t[o],r=0,i=0;if(a<=127?(r=0,i=255&a):a<=223?(r=1,i=31&a):a<=239?(r=2,i=15&a):a<=244&&(r=3,i=7&a),s-o-r>0)for(var u=0;u<r;){i=i<<6|63&(a=t[o+u+1]),u+=1;}else i=65533,r=s-o;n+=String.fromCodePoint(i),o+=r+1;}return n;},Ri=function(){function e(t){o(this,e),this._handler=t;var n=t.getURL();if(this._socket=null,this._workerSocket=null,this._id=_t(),this._handler.getIsWorkerEnabled()){var s=URL.createObjectURL(new Blob([';let _socket = null;onmessage = function(event) {  if (event.data.cmd === "start") {    const url = event.data.url;    _socket = new WebSocket(url);    _socket.binaryType = "arraybuffer";    _socket.onopen = function() {      postMessage({ callback: "onOpen" });    };    _socket.onclose = function(e) {      postMessage({ callback: "onOpen", e: { code: e.code, reason: e.reason } });    };    _socket.onmessage = function(e) {      postMessage({ callback: "onMessage", data: e.data });    };    _socket.onerror = function(e) {      postMessage({ callback: "onError", e: { isTrusted: "true" } });    };  } else if (event.data.cmd === "sendMessage") {    if (_socket !== null) {      _socket.send(event.data.data);    }  } else if (event.data.cmd === "stop") {    if (_socket !== null) {      _socket.close(event.data.code);      _socket = null;    }  }};'],{type:"application/javascript; charset=utf-8"}));this._workerSocket=new Worker(s);var a=this;this._workerSocket.onmessage=function(e){var t=e.data,n=t.callback,o=t.e;"onOpen"===n?a._onOpen():"onClose"===n?a._onClose(o):"onError"===n?a._onError(o):"onMessage"===n&&a._onMessage(e.data);},this._workerSocket.postMessage({cmd:"start",id:this._id,url:n});}else se?ee?(re.connectSocket({url:n,header:{"content-type":"application/json"}}),re.onSocketClose(this._onClose.bind(this)),re.onSocketOpen(this._onOpen.bind(this)),re.onSocketMessage(this._onMessage.bind(this)),re.onSocketError(this._onError.bind(this))):(this._socket=re.connectSocket({url:n,header:{"content-type":"application/json"},complete:function complete(){}}),this._socket.onClose(this._onClose.bind(this)),this._socket.onOpen(this._onOpen.bind(this)),this._socket.onMessage(this._onMessage.bind(this)),this._socket.onError(this._onError.bind(this))):ae&&(this._socket=new WebSocket(n),this._socket.binaryType="arraybuffer",this._socket.onopen=this._onOpen.bind(this),this._socket.onmessage=this._onMessage.bind(this),this._socket.onclose=this._onClose.bind(this),this._socket.onerror=this._onError.bind(this));this._canIUseBinaryFrame=t.canIUseBinaryFrame();}return a(e,[{key:"getID",value:function value(){return this._id;}},{key:"_onOpen",value:function value(){this._handler.onOpen({id:this._id});}},{key:"_onClose",value:function value(e){this._handler.onClose({id:this._id,e:e});}},{key:"_onMessage",value:function value(e){this._handler.onMessage({data:this._canIUseBinaryFrame?Ai(e.data):e.data});}},{key:"_onError",value:function value(e){this._handler.onError({id:this._id,e:e});}},{key:"setIsWorkerEnabled",value:function value(e){this._isWorkerEnabled=!0;}},{key:"close",value:function value(e){if(this._workerSocket&&(this._workerSocket.postMessage({cmd:"stop",code:e}),this._workerSocket.terminate(),this._workerSocket=null),ee)return re.offSocketClose(),re.offSocketMessage(),re.offSocketOpen(),re.offSocketError(),void re.closeSocket();this._socket&&(se?(this._socket.onClose(function(){}),this._socket.onOpen(function(){}),this._socket.onMessage(function(){}),this._socket.onError(function(){})):ae&&(this._socket.onopen=null,this._socket.onmessage=null,this._socket.onclose=null,this._socket.onerror=null),$?this._socket.close({code:e}):this._socket.close(e),this._socket=null);}},{key:"send",value:function value(e){if(this._workerSocket)this._workerSocket.postMessage({cmd:"sendMessage",data:this._canIUseBinaryFrame?Li(e.data).buffer:e.data});else{if(ee)return void re.sendSocketMessage({data:e.data,fail:function fail(){e.fail&&e.requestID&&e.fail(e.requestID);}});this._socket&&(se?this._socket.send({data:this._canIUseBinaryFrame?Li(e.data).buffer:e.data,fail:function fail(){e.fail&&e.requestID&&e.fail(e.requestID);}}):ae&&this._socket.send(this._canIUseBinaryFrame?Li(e.data).buffer:e.data));}}}]),e;}(),Ni=4e3,Oi=4001,Gi=["keyMap"],Ui=["keyMap"],Pi="connected",bi="connecting",wi="disconnected",Fi=function(){function e(t){o(this,e),this._channelModule=t,this._n="SocketHandler",this._promiseMap=new Map(),this._readyState=wi,this._simpleRequestMap=new Map(),this.MAX_SIZE=100,this._startSequence=_t(),this._startTs=0,this._reConnectFlag=!1,this._nextPingTs=0,this._reConnectCount=0,this.MAX_RECONNECT_COUNT=3,this._socketID=-1,this._random=0,this._socket=null,this._url="",this._onOpenTs=0,this._canIUseBinaryFrame=!0,this._isWorkerEnabled=!0,this._setWebsocketHost(),this._initConnection();}return a(e,[{key:"_setWebsocketHost",value:function value(){var e=this._channelModule.getModule(qn),t=G;this._channelModule.isOversea()&&(t=U),e.isSingaporeSite()?t=P:e.isKoreaSite()?t=b:e.isGermanySite()?t=w:e.isIndiaSite()?t=F:e.isJapanSite()?t=q:e.isUSASite()&&(t=x),V.HOST.setCurrent(t);}},{key:"_initConnection",value:function value(){at(V.HOST.CURRENT.BACKUP)||""===this._url?this._url=V.HOST.CURRENT.DEFAULT:this._url===V.HOST.CURRENT.DEFAULT?this._url=V.HOST.CURRENT.BACKUP:this._url===V.HOST.CURRENT.BACKUP?this._url=this._canIUseAnyCast()?V.HOST.CURRENT.ANYCAST:V.HOST.CURRENT.DEFAULT:this._url===V.HOST.CURRENT.ANYCAST&&(V.HOST.CURRENT.ANYCAST="",this._url=V.HOST.CURRENT.DEFAULT);var e=this._channelModule.getModule(qn).getProxyServer();jt(e)||(this._url=e),this._connect(),this._nextPingTs=0;}},{key:"_canIUseAnyCast",value:function value(){return ae&&V.HOST.CURRENT.ANYCAST;}},{key:"onCheckTimer",value:function value(e){e%1==0&&this._checkPromiseMap();}},{key:"_checkPromiseMap",value:function value(){var e=this;0!==this._promiseMap.size&&this._promiseMap.forEach(function(t,n){var o=t.reject,s=t.timestamp,a=15e3;-1!==n.indexOf(io)&&(a=9e4),Date.now()-s>=a&&(xe.l("".concat(e._n,"._checkPromiseMap request timeout, delete requestID:").concat(n)),e._promiseMap.delete(n),o(new Wa({code:da.NETWORK_TIMEOUT})),e._channelModule.onRequestTimeout(n));});}},{key:"onOpen",value:function value(e){if(""!==this._readyState){this._onOpenTs=Date.now();var t=e.id;this._socketID=t;var n=Date.now()-this._startTs;xe.l("".concat(this._n,"._onOpen cost ").concat(n," ms. socketID:").concat(t)),new ka("wsOnOpen").setMessage(n).setCostTime(n).setMoreMessage("socketID:".concat(t)).end(),e.id===this._socketID&&(this._readyState=Pi,this._reConnectCount=0,this._resend(),!0===this._reConnectFlag&&(this._channelModule.onReconnected(),this._reConnectFlag=!1),this._channelModule.onOpen());}}},{key:"onClose",value:function value(e){var t=new ka("wsOnClose"),n=e.id,o=e.e,s="sourceSocketID:".concat(n," currentSocketID:").concat(this._socketID," code:").concat(o.code," reason:").concat(o.reason),a=0;0!==this._onOpenTs&&(a=Date.now()-this._onOpenTs),t.setMessage(a).setCostTime(a).setMoreMessage(s).setCode(o.code).end(),xe.l("".concat(this._n,"._onClose ").concat(s," onlineTime:").concat(a)),n===this._socketID&&(this._readyState=wi,a<1e3?this._channelModule.onReconnectFailed():this._channelModule.onClose());}},{key:"onError",value:function value(e){var t=e.id,n=e.e,o="sourceSocketID:".concat(t," currentSocketID:").concat(this._socketID);new ka("wsOnError").setMessage(n.errMsg||dt(n)).setMoreMessage(o).setLevel("error").end(),xe.w("".concat(this._n,"._onError"),n,o),t===this._socketID&&(this._readyState="",this._channelModule.onError());}},{key:"onMessage",value:function value(e){var t;try{t=JSON.parse(e.data);}catch(c){new ka("jsonParseError").setMessage(e.data).end();}if(t&&t.head){var n=this._getRequestIDFromHead(t.head),o=t.body;if(!this._isTRTCCommand(n)){var s=Pt(t.head);o=Ei(t.body,this._getResponseKeyMap(s));}if(xe.d("".concat(this._n,".onMessage ret:").concat(JSON.stringify(o)," requestID:").concat(n," has:").concat(this._promiseMap.has(n))),this._setNextPingTs(),this._promiseMap.has(n)){var a=this._promiseMap.get(n),r=a.resolve,i=a.reject,u=a.timestamp;return this._promiseMap.delete(n),this._calcRTT(u),void(o.errorCode&&0!==o.errorCode?(this._channelModule.onErrorCodeNotZero(o),i(new Wa({code:o.errorCode,message:o.errorInfo||"",data:n.includes(Lo)||n.includes(ms)?{elements:o.elements,messageVersion:o.messageVersion,cloudCustomData:o.cloudCustomData}:void 0}))):r(Ka(o)));}this._channelModule.onMessage({head:t.head,body:o});}}},{key:"_isTRTCCommand",value:function value(e){for(var t=this._channelModule.getModule(oo).getCommandList(),n=!1,o=0;o<t.length;o++){if(e.startsWith(t[o])){n=!0;break;}}return n;}},{key:"_calcRTT",value:function value(e){var t=Date.now()-e;this._channelModule.getModule($n).addRTT(t);}},{key:"_connect",value:function value(){this._startTs=Date.now(),this._onOpenTs=0,this._socket=new Ri(this),this._socketID=this._socket.getID(),this._readyState=bi,xe.l("".concat(this._n,"._connect isWorkerEnabled:").concat(this.getIsWorkerEnabled()," socketID:").concat(this._socketID," url:").concat(this.getURL())),new ka("wsConnect").setMessage("socketID:".concat(this._socketID," url:").concat(this.getURL())).end();}},{key:"getURL",value:function value(){this._channelModule.isDevMode()&&(this._canIUseBinaryFrame=!1);var e=Nt();(ee||X&&"windows"===e||ne)&&(this._canIUseBinaryFrame=!1);var t=-1;"ios"===e?t=ve||-1:"android"===e&&(t=Me||-1);var n=this._channelModule.getModule(qn),o=this._channelModule.getPlatform(),s=n.getSDKAppID(),a=n.getInstanceID(),r="sdkappid=".concat(s,"&instanceid=").concat(a,"&random=").concat(this._getRandom(),"&platform=").concat(o,"&host=").concat(e,"&version=").concat(t);return this._canIUseBinaryFrame?"".concat(this._url,"/binfo?").concat(r):"".concat(this._url,"/info?").concat(r);}},{key:"_closeConnection",value:function value(e){xe.l("".concat(this._n,"._closeConnection socketID:").concat(this._socketID)),this._socket&&(this._socket.close(e),this._socketID=-1,this._socket=null,this._readyState=wi);}},{key:"_resend",value:function value(){var e=this;if(xe.l("".concat(this._n,"._resend reConnectFlag:").concat(this._reConnectFlag),"promiseMap.size:".concat(this._promiseMap.size," simpleRequestMap.size:").concat(this._simpleRequestMap.size)),this._promiseMap.size>0&&this._promiseMap.forEach(function(t,n){var o=t.uplinkData,s=t.resolve,a=t.reject;e._promiseMap.set(n,{resolve:s,reject:a,timestamp:Date.now(),uplinkData:o}),e._execute(n,o);}),this._simpleRequestMap.size>0){var t,n=D(this._simpleRequestMap);try{for(n.s();!(t=n.n()).done;){var o=v(t.value,2),s=o[0],a=o[1];this._execute(s,a);}}catch(r){n.e(r);}finally{n.f();}this._simpleRequestMap.clear();}}},{key:"send",value:function value(e){var t=this;e.head.seq=this._getSequence(),e.head.reqtime=Math.floor(Date.now()/1e3),e.keyMap;var n=g(e,Gi),o=this._getRequestIDFromHead(e.head),s=JSON.stringify(n);return new Promise(function(e,a){(t._promiseMap.set(o,{resolve:e,reject:a,timestamp:Date.now(),uplinkData:s}),xe.d("".concat(t._n,".send uplinkData:").concat(JSON.stringify(n)," requestID:").concat(o," readyState:").concat(t._readyState)),t._readyState!==Pi)?t._reConnect():(t._execute(o,s),t._channelModule.getModule($n).addRequestCount());});}},{key:"simplySend",value:function value(e){e.head.seq=this._getSequence(),e.head.reqtime=Math.floor(Date.now()/1e3),e.keyMap;var t=g(e,Ui),n=this._getRequestIDFromHead(e.head),o=JSON.stringify(t);this._readyState!==Pi?(this._simpleRequestMap.size<this.MAX_SIZE?this._simpleRequestMap.set(n,o):xe.l("".concat(this._n,".simplySend. simpleRequestMap is full, drop request!")),this._reConnect()):this._execute(n,o);}},{key:"_execute",value:function value(e,t){this._socket.send({data:t,fail:se?this._onSendFail.bind(this):void 0,requestID:e});}},{key:"_onSendFail",value:function value(e){xe.l("".concat(this._n,"._onSendFail requestID:").concat(e));}},{key:"_getSequence",value:function value(){var e;if(this._startSequence<2415919103)return e=this._startSequence,this._startSequence+=1,2415919103===this._startSequence&&(this._startSequence=_t()),e;}},{key:"_getRequestIDFromHead",value:function value(e){return e.servcmd+e.seq;}},{key:"_getResponseKeyMap",value:function value(e){var n=this._channelModule.getKeyMap(e);return t(t({},Ii.response),n.response);}},{key:"_reConnect",value:function value(){this._readyState!==Pi&&this._readyState!==bi&&this.forcedReconnect();}},{key:"forcedReconnect",value:function value(){var e=this,t="".concat(this._n,".forcedReconnect");xe.l("".concat(t," count:").concat(this._reConnectCount," readyState:").concat(this._readyState)),this._reConnectFlag=!0,this._resetRandom(),this._reConnectCount<this.MAX_RECONNECT_COUNT?(this._reConnectCount+=1,this._closeConnection(Oi),this._initConnection()):(this._reConnectCount=0,this._channelModule.probeNetwork().then(function(n){var o=v(n,2),s=o[0];o[1],s?(xe.w("".concat(t," disconnected from wsserver but network is ok, continue...")),e._closeConnection(Oi),e._initConnection()):e._channelModule.onReconnectFailed();}));}},{key:"getReconnectFlag",value:function value(){return this._reConnectFlag;}},{key:"_setNextPingTs",value:function value(){this._nextPingTs=Date.now()+1e4;}},{key:"getNextPingTs",value:function value(){return this._nextPingTs;}},{key:"isConnected",value:function value(){return this._readyState===Pi;}},{key:"canIUseBinaryFrame",value:function value(){return this._canIUseBinaryFrame;}},{key:"setIsWorkerEnabled",value:function value(e){xe.l("".concat(this._n,".setIsWorkerEnabled flag:").concat(e)),this._isWorkerEnabled=e;}},{key:"getIsWorkerEnabled",value:function value(){return this._isWorkerEnabled&&Se;}},{key:"_getRandom",value:function value(){return 0===this._random&&(this._random=Math.random()),this._random;}},{key:"_resetRandom",value:function value(){this._random=0;}},{key:"close",value:function value(){xe.l("".concat(this._n,".close")),this._closeConnection(Ni),this._promiseMap.clear(),this._startSequence=_t(),this._readyState=wi,this._simpleRequestMap.clear(),this._reConnectFlag=!1,this._reConnectCount=0,this._onOpenTs=0,this._url="",this._random=0,this._canIUseBinaryFrame=!0,this._isWorkerEnabled=!0;}}]),e;}(),qi=function(e){i(n,e);var t=f(n);function n(e){var s;if(o(this,n),(s=t.call(this,e))._n="ChannelModule",s._socketHandler=new Fi(_(s)),s._probing=!1,s._isAppShowing=!0,s._previousState=S.NET_STATE_CONNECTED,se&&"function"==typeof re.onAppShow&&"function"==typeof re.onAppHide){var a=s._onAppHide.bind(_(s)),r=s._onAppShow.bind(_(s));"function"==typeof re.offAppHide&&re.offAppHide(a),"function"==typeof re.offAppShow&&re.offAppShow(r),re.onAppHide(a),re.onAppShow(r);}return s._timerForNotLoggedIn=-1,s._timerForNotLoggedIn=setInterval(s.onCheckTimer.bind(_(s)),1e3),s._fatalErrorFlag=!1,s;}return a(n,[{key:"onCheckTimer",value:function value(e){this._socketHandler&&(this.isLoggedIn()?(this._timerForNotLoggedIn>0&&(clearInterval(this._timerForNotLoggedIn),this._timerForNotLoggedIn=-1),this._socketHandler.onCheckTimer(e)):this._socketHandler.onCheckTimer(1),this._checkNextPing());}},{key:"onErrorCodeNotZero",value:function value(e){this.getModule(jn).onErrorCodeNotZero(e);}},{key:"onMessage",value:function value(e){this.getModule(jn).onMessage(e);}},{key:"send",value:function value(e){return this._socketHandler?this._previousState!==S.NET_STATE_CONNECTED&&e.head.servcmd.includes(xs)?(this.reConnect(),this._sendLogViaHTTP(e)):this._socketHandler.send(e):Promise.reject();}},{key:"_sendLogViaHTTP",value:function value(e){var t=V.HOST.CURRENT.STAT;return new Promise(function(n,o){var s="".concat(t,"/v4/imopenstat/tim_web_report_v2?sdkappid=").concat(e.head.sdkappid,"&reqtime=").concat(Date.now()),a=JSON.stringify(e.body),r="application/x-www-form-urlencoded;charset=UTF-8";if(se)re.request({url:s,data:a,method:"POST",timeout:3e3,header:{"content-type":r},success:function success(){n();},fail:function fail(){o(new Wa({code:da.NETWORK_ERROR}));}});else{var i=new XMLHttpRequest(),u=setTimeout(function(){i.abort(),o(new Wa({code:da.NETWORK_TIMEOUT}));},3e3);i.onreadystatechange=function(){4===i.readyState&&(clearTimeout(u),200===i.status||304===i.status?n():o(new Wa({code:da.NETWORK_ERROR})));},i.open("POST",s,!0),i.setRequestHeader("Content-type",r),i.send(a);}});}},{key:"simplySend",value:function value(e){return this._socketHandler?this._socketHandler.simplySend(e):Promise.reject();}},{key:"onOpen",value:function value(){this._ping();}},{key:"onClose",value:function value(){this._socketHandler&&this._socketHandler.getReconnectFlag()&&this._emitNetStateChangeEvent(S.NET_STATE_DISCONNECTED);this.reConnect();}},{key:"onError",value:function value(){se&&!ne&&this.outputWarning("DomainNameInMP"),this._emitNetStateChangeEvent(S.NET_STATE_DISCONNECTED);}},{key:"getKeyMap",value:function value(e){return this.getModule(jn).getKeyMap(e);}},{key:"_onAppHide",value:function value(){this._isAppShowing=!1;}},{key:"_onAppShow",value:function value(){this._isAppShowing=!0;}},{key:"onRequestTimeout",value:function value(e){}},{key:"onReconnected",value:function value(){xe.l("".concat(this._n,".onReconnected")),this._m.restartTimer(),this.getModule(jn).onReconnected(),this._emitNetStateChangeEvent(S.NET_STATE_CONNECTED);}},{key:"onReconnectFailed",value:function value(){xe.l("".concat(this._n,".onReconnectFailed")),this._emitNetStateChangeEvent(S.NET_STATE_DISCONNECTED);}},{key:"setIsWorkerEnabled",value:function value(e){this._socketHandler&&this._socketHandler.setIsWorkerEnabled(!1);}},{key:"offline",value:function value(){this._emitNetStateChangeEvent(S.NET_STATE_DISCONNECTED);}},{key:"reConnect",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=!1;this._socketHandler&&(t=this._socketHandler.getReconnectFlag());var n="forcedFlag:".concat(e," fatalErrorFlag:").concat(this._fatalErrorFlag," previousState:").concat(this._previousState," reconnectFlag:").concat(t);if(xe.l("".concat(this._n,".reConnect ").concat(n)),!this._fatalErrorFlag&&this._socketHandler){if(!0===e)this._socketHandler.forcedReconnect();else{if(this._previousState===S.NET_STATE_CONNECTING&&t)return;this._socketHandler.forcedReconnect();}this._emitNetStateChangeEvent(S.NET_STATE_CONNECTING);}}},{key:"_emitNetStateChangeEvent",value:function value(e){this._previousState!==e&&(xe.l("".concat(this._n,"._emitNetStateChangeEvent from ").concat(this._previousState," to ").concat(e)),this._previousState=e,this.emitOuterEvent(E.NET_STATE_CHANGE,{state:e}));}},{key:"_ping",value:function value(){var e=this;if(!0!==this._probing){this._probing=!0;var t=this.getModule(jn).getProtocolData({protocolName:Vs});this.send(t).then(function(){e._probing=!1;}).catch(function(t){if(xe.w("".concat(e._n,"._ping failed. error:"),t),e._probing=!1,t&&60002===t.code)return new ka("error").setMessage("code:".concat(t.code," message:").concat(t.message)).setNetworkType(e.getModule(Bn).getNetworkType()).end(),e._fatalErrorFlag=!0,void e._emitNetStateChangeEvent(S.NET_STATE_DISCONNECTED);e.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];xe.l("".concat(e._n,"._ping failed. probe network, isAppShowing:").concat(e._isAppShowing," online:").concat(o," networkType:").concat(s)),o?e.reConnect():e._emitNetStateChangeEvent(S.NET_STATE_DISCONNECTED);});});}}},{key:"_checkNextPing",value:function value(){this._socketHandler&&this._socketHandler.isConnected()&&Date.now()>=this._socketHandler.getNextPingTs()&&this._ping();}},{key:"dealloc",value:function value(){this._socketHandler&&(this._socketHandler.close(),this._socketHandler=null),this._timerForNotLoggedIn>-1&&clearInterval(this._timerForNotLoggedIn);}},{key:"onRestApiKickedOut",value:function value(){this._socketHandler&&(this._socketHandler.close(),this.reConnect(!0));}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._previousState=S.NET_STATE_CONNECTED,this._probing=!1,this._fatalErrorFlag=!1,this._timerForNotLoggedIn=setInterval(this.onCheckTimer.bind(this),1e3);}}]),n;}(ro),xi=["a2","tinyid"],Vi=["a2","tinyid"],Bi=function(){function e(t){o(this,e),this._n="ProtocolHandler",this._sessionModule=t,this._configMap=new Map(),this._fillConfigMap();}return a(e,[{key:"_fillConfigMap",value:function value(){this._configMap.clear();var e=this._sessionModule.genCommonHead(),n=this._sessionModule.genCosSpecifiedHead(),o=this._sessionModule.genSSOReportHead(),s=this._sessionModule.isIntl();this._configMap.set(io,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.LOGIN)}),body:{state:"Online",isWebUniapp:0,deviceBrand:0},keyMap:{request:{deviceBrand:"InstType"},response:{InstId:"instanceID",HelloInterval:"helloInterval"}}};}(e)),this._configMap.set(uo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.LOGOUT)}),body:{type:0},keyMap:{request:{type:"wslogout_type"}}};}(e)),this._configMap.set(co,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.HELLO)}),body:{isWebUniapp:0},keyMap:{response:{NewInstInfo:"newInstanceInfo"}}};}(e)),this._configMap.set(lo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.STAT_SERVICE,".").concat(V.CMD.KICK_OTHER)}),body:{}};}(e)),this._configMap.set(ws,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_COS_SIGN,".").concat(V.CMD.COS_SIGN)}),body:{cmd:"open_im_cos_svc",subCmd:"get_cos_token",duration:300,version:2},keyMap:{request:{userSig:"usersig",subCmd:"sub_cmd",cmd:"cmd",duration:"duration",version:"version"},response:{expired_time:"expiredTime",bucket_name:"bucketName",session_token:"sessionToken",tmp_secret_id:"secretId",tmp_secret_key:"secretKey"}}};}(n)),this._configMap.set(Fs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.CUSTOM_UPLOAD,".").concat(V.CMD.COS_PRE_SIG)}),body:{fileType:void 0,fileName:void 0,uploadMethod:0,duration:900},keyMap:{request:{userSig:"usersig",fileType:"file_type",fileName:"file_name",uploadMethod:"upload_method"},response:{expired_time:"expiredTime",request_id:"requestId",head_url:"headUrl",upload_url:"uploadUrl",download_url:"downloadUrl",ci_url:"ciUrl",snapshot_url:"requestSnapshotUrl"}}};}(n)),this._configMap.set(qs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.CUSTOM_UPLOAD,".").concat(V.CMD.VIDEO_COVER)}),body:{version:1,platform:void 0,coverName:void 0,requestSnapshotUrl:void 0},keyMap:{request:{version:"version",platform:"platform",coverName:"cover_name",requestSnapshotUrl:"snapshot_url"},response:{error_code:"errorCode",error_msg:"errorInfo",download_url:"snapshotUrl"}}};}(n)),this._configMap.set(Xs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_CONFIG_MANAGER,".").concat(V.CMD.FETCH_COMMERCIAL_CONFIG)}),body:{SDKAppID:0},keyMap:{request:{SDKAppID:"uint32_sdkappid"},response:{int32_error_code:"errorCode",str_error_message:"errorMessage",str_purchase_bits:"purchaseBits",uint32_expired_time:"expiredTime"}}};}(e)),this._configMap.set(Qs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_CONFIG_MANAGER,".").concat(V.CMD.PUSHED_COMMERCIAL_CONFIG)}),body:{},keyMap:{response:{int32_error_code:"errorCode",str_error_message:"errorMessage",str_purchase_bits:"purchaseBits",uint32_expired_time:"expiredTime"}}};}(e)),this._configMap.set(zs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_CONFIG_MANAGER,".").concat(V.CMD.FETCH_CLOUD_CONTROL_CONFIG)}),body:{SDKAppID:0,version:0},keyMap:{request:{SDKAppID:"uint32_sdkappid",version:"uint64_version"},response:{int32_error_code:"errorCode",str_error_message:"errorMessage",str_json_config:"cloudControlConfig",uint32_expired_time:"expiredTime",uint32_sdkappid:"SDKAppID",uint64_version:"version"}}};}(e)),this._configMap.set(Js,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_CONFIG_MANAGER,".").concat(V.CMD.PUSHED_CLOUD_CONTROL_CONFIG)}),body:{},keyMap:{response:{int32_error_code:"errorCode",str_error_message:"errorMessage",str_json_config:"cloudControlConfig",uint32_expired_time:"expiredTime",uint32_sdkappid:"SDKAppID",uint64_version:"version"}}};}(e)),this._configMap.set(Zs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OVERLOAD_PUSH,".").concat(V.CMD.OVERLOAD_NOTIFY)}),body:{},keyMap:{response:{OverLoadServCmd:"overloadCommand",DelaySecs:"waitingTime"}}};}(e)),this._configMap.set(po,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.GET_MESSAGES)}),body:{cookie:"",syncFlag:0,needAbstract:1,isOnlineSync:0,needSignaling:1},keyMap:{request:{fromAccount:"From_Account",toAccount:"To_Account",from:"From_Account",to:"To_Account",time:"MsgTimeStamp",sequence:"MsgSeq",random:"MsgRandom",elements:"MsgBody"},response:{MsgList:"messageList",SyncFlag:"syncFlag",To_Account:"to",From_Account:"from",ClientSeq:"clientSequence",MsgSeq:"sequence",NoticeSeq:"noticeSequence",NotifySeq:"notifySequence",MsgRandom:"random",MsgTimeStamp:"time",MsgContent:"content",ToGroupId:"to",MsgKey:"messageKey",GroupTips:"groupTips",MsgBody:"elements",MsgType:"type",C2CRemainingUnreadCount:"C2CRemainingUnreadList",C2CPairUnreadCount:"C2CPairUnreadList"}}};}(e)),s||(this._configMap.set(go,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.BIG_DATA_HALLWAY_AUTH_KEY)}),body:{}};}(e)),this._configMap.set(la,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_MSG_AUDIT_MGR,".").concat(V.CMD.GET_RPOFANITY_LIST)}),body:{version:0,deviceID:"",startIndex:void 0},keyMap:{request:{version:"uint64_version",deviceID:"str_device_id",startIndex:"uint64_start_index"},response:{msg_cmd_error_code:"errorInfo",str_err_msg:"errorMessage",uint32_code:"errorCode",msg_scene_ctl_config:"filterConfig",uint64_c2c_custom_msg_flag:"c2c_custom_message",uint64_c2c_text_msg_flag:"c2c_text_message",uint64_group_custom_msg_flag:"group_custom_message",uint64_group_text_msg_flag:"group_text_message",uint64_group_info_flag:"group_profile",uint64_group_member_info_flag:"group_member_profile",uint64_relation_chain_flag:"sns",uint64_user_info_flag:"user_profile",rpt_msg_dirty_word:"lexicon",str_dirty_word:"profanity",str_replaced_content:"replacement",uint64_filter_type:"filterType",uint64_id:"id",uint64_word_type:"profanityType",uint64_complete_flag:"completeFlag",uint64_next_start_index:"nextStartIndex",uint64_version:"version",uint64_expired_time:"expiredTime"}}};}(e))),this._configMap.set(_o,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.SEND_MESSAGE)}),body:{fromAccount:"",toAccount:"",msgSeq:0,msgRandom:0,msgBody:[],cloudCustomData:void 0,nick:"",avatar:"",msgLifeTime:void 0,offlinePushInfo:{pushFlag:0,title:"",desc:"",ext:"",apnsInfo:{badgeMode:0,isVoipPush:void 0},androidInfo:{OPPOChannelID:""}},messageControlInfo:void 0,clientTime:void 0,needReadReceipt:0,isSupportExtension:0},keyMap:{request:{fromAccount:"From_Account",toAccount:"To_Account",msgTimeStamp:"MsgTimeStamp",msgSeq:"MsgSeq",msgRandom:"MsgRandom",msgBody:"MsgBody",count:"MaxCnt",lastMessageTime:"LastMsgTime",messageKey:"MsgKey",peerAccount:"Peer_Account",data:"Data",description:"Desc",extension:"Ext",type:"MsgType",content:"MsgContent",sizeType:"Type",uuid:"UUID",url:"",imageUrl:"URL",fileUrl:"Url",remoteAudioUrl:"Url",remoteVideoUrl:"VideoUrl",thumbUUID:"ThumbUUID",videoUUID:"VideoUUID",videoUrl:"",downloadFlag:"Download_Flag",nick:"From_AccountNick",avatar:"From_AccountHeadurl",from:"From_Account",time:"MsgTimeStamp",messageRandom:"MsgRandom",messageSequence:"MsgSeq",elements:"MsgBody",clientSequence:"ClientSeq",payload:"MsgContent",messageList:"MsgList",messageNumber:"MsgNum",abstractList:"AbstractList",messageBody:"MsgBody",needReadReceipt:"IsNeedReadReceipt"}}};}(e)),this._configMap.set(ho,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.SEND_GROUP_MESSAGE)}),body:{fromAccount:"",groupID:"",random:0,clientSequence:0,priority:"",msgBody:[],cloudCustomData:void 0,onlineOnlyFlag:0,offlinePushInfo:{pushFlag:0,title:"",desc:"",ext:"",apnsInfo:{badgeMode:0,isVoipPush:void 0},androidInfo:{OPPOChannelID:""}},groupAtInfo:[],messageControlInfo:void 0,clientTime:void 0,needReadReceipt:0,topicID:void 0,receiverList:void 0,isSupportExtension:0},keyMap:{request:{to:"GroupId",extension:"Ext",data:"Data",description:"Desc",random:"Random",sequence:"ReqMsgSeq",count:"ReqMsgNumber",type:"MsgType",priority:"MsgPriority",content:"MsgContent",elements:"MsgBody",sizeType:"Type",uuid:"UUID",url:"",imageUrl:"URL",fileUrl:"Url",remoteAudioUrl:"Url",remoteVideoUrl:"VideoUrl",thumbUUID:"ThumbUUID",videoUUID:"VideoUUID",videoUrl:"",downloadFlag:"Download_Flag",clientSequence:"ClientSeq",from:"From_Account",time:"MsgTimeStamp",messageRandom:"MsgRandom",messageSequence:"MsgSeq",payload:"MsgContent",messageList:"MsgList",messageNumber:"MsgNum",abstractList:"AbstractList",messageBody:"MsgBody",needReadReceipt:"NeedReadReceipt",receiverList:"To_Account"},response:{MsgTime:"time",MsgSeq:"sequence"}}};}(e)),this._configMap.set(Io,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.REVOKE_C2C_MESSAGE)}),body:{msgInfo:{fromAccount:"",toAccount:"",msgTimeStamp:0,msgSeq:0,msgRandom:0}},keyMap:{request:{msgInfo:"MsgInfo",msgTimeStamp:"MsgTimeStamp",msgSeq:"MsgSeq",msgRandom:"MsgRandom"}}};}(e)),this._configMap.set(ss,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.REVOKE_GROUP_MESSAGE)}),body:{groupID:"",msgSeqList:void 0,topicID:""},keyMap:{request:{msgSeqList:"MsgSeqList",msgSeq:"MsgSeq"}}};}(e)),this._configMap.set(Eo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.GET_C2C_ROAM_MESSAGES)}),body:{peerAccount:"",count:15,lastMessageTime:0,messageKey:"",withRecalledMessage:1,direction:0},keyMap:{request:{messageKey:"MsgKey",peerAccount:"Peer_Account",count:"MaxCnt",lastMessageTime:"LastMsgTime",withRecalledMessage:"WithRecalledMsg",direction:"GetDirection"},response:{LastMsgTime:"lastMessageTime",IsNeedReadReceipt:"needReadReceipt",IsPeerRead:"readReceiptSentByPeer"}}};}(e)),this._configMap.set(Lo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.MODIFY_C2C_MESSAGE)}),body:{from:"",to:"",sequence:0,random:0,time:0,version:0,elements:void 0,cloudCustomData:void 0},keyMap:{request:{sequence:"MsgSeq",random:"MsgRandom",time:"MsgTime",version:"MsgVersion",type:"MsgType",content:"MsgContent"}}};}(e)),this._configMap.set(is,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_GROUP_ROAM_MESSAGES)}),body:{withRecalledMsg:1,groupID:"",count:15,sequence:"",topicID:void 0},keyMap:{request:{sequence:"ReqMsgSeq",count:"ReqMsgNumber",withRecalledMessage:"WithRecalledMsg"},response:{Random:"random",MsgTime:"time",MsgSeq:"sequence",ReqMsgSeq:"sequence",RspMsgList:"messageList",IsPlaceMsg:"isPlaceMessage",IsSystemMsg:"isSystemMessage",ToGroupId:"to",EnumFrom_AccountType:"fromAccountType",EnumTo_AccountType:"toAccountType",GroupCode:"groupCode",MsgPriority:"priority",MsgBody:"elements",MsgType:"type",MsgContent:"content",IsFinished:"complete",Download_Flag:"downloadFlag",ClientSeq:"clientSequence",ThumbUUID:"thumbUUID",VideoUUID:"videoUUID",ToTopicId:"topicID",InvisibleMsgSeq:"invisibleSequenceList"}}};}(e)),this._configMap.set(Co,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.SET_C2C_MESSAGE_READ)}),body:{C2CMsgReaded:void 0},keyMap:{request:{lastMessageTime:"LastedMsgTime"}}};}(e)),this._configMap.set(To,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.SET_C2C_PEER_MUTE_NOTIFICATIONS)}),body:{userIDList:void 0,muteFlag:0},keyMap:{request:{userIDList:"Peer_Account",muteFlag:"Mute_Notifications"}}};}(e)),this._configMap.set(Do,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.GET_C2C_PEER_MUTE_NOTIFICATIONS)}),body:{updateSequence:0},keyMap:{response:{MuteNotificationsList:"muteFlagList"}}};}(e)),this._configMap.set(as,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.SET_GROUP_MESSAGE_READ)}),body:{groupID:void 0,messageReadSeq:void 0,topicID:void 0},keyMap:{request:{messageReadSeq:"MsgReadedSeq"}}};}(e)),this._configMap.set(rs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.SET_ALL_MESSAGE_READ)}),body:{readAllC2CMessage:0,groupMessageReadInfoList:[]},keyMap:{request:{readAllC2CMessage:"C2CReadAllMsg",groupMessageReadInfoList:"GroupReadInfo",messageSequence:"MsgSeq"},response:{C2CReadAllMsg:"readAllC2CMessage",GroupReadInfoArray:"groupMessageReadInfoList"}}};}(e)),this._configMap.set(ko,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.DELETE_C2C_MESSAGE)}),body:{fromAccount:"",to:"",keyList:void 0},keyMap:{request:{keyList:"MsgKeyList"}}};}(e)),this._configMap.set(vs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.DELETE_GROUP_MESSAGE)}),body:{groupID:"",deleter:"",keyList:void 0,topicID:void 0},keyMap:{request:{deleter:"Deleter_Account",keyList:"Seqs"}}};}(e)),this._configMap.set(pa,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_TRANSLATE,".").concat(V.CMD.TRANSLATE_TEXT)}),body:{sourceTextList:void 0,SDKAppID:0,from:0,source:"",target:""},keyMap:{request:{sourceTextList:"SourceText",SDKAppID:"SdkAppId",from:"FromAccount"},response:{TargetText:"translatedTextList",RequestId:"requestID",CmdErrorCode:"error",ErrorCode:"code",ErrorInfo:"message"}}};}(e)),this._configMap.set(ms,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.MODIFY_GROUP_MESSAGE)}),body:{groupID:"",topicID:void 0,sequence:0,version:0,elements:void 0,cloudCustomData:void 0},keyMap:{request:{sequence:"MsgSeq",version:"MsgVersion",type:"MsgType",content:"MsgContent"}}};}(e)),this._configMap.set(us,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_READ_RECEIPT)}),body:{groupID:"",sequenceList:void 0},keyMap:{request:{sequence:"MsgSeq"}}};}(e)),this._configMap.set(ls,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.SEND_C2C_READ_RECEIPT)}),body:{peerAccount:"",messageInfoList:void 0},keyMap:{request:{peerAccount:"Peer_Account",messageInfoList:"C2CMsgInfo",fromAccount:"From_Account",toAccount:"To_Account",sequence:"MsgSeq",random:"MsgRandom",time:"MsgTime",clientTime:"MsgClientTime"}}};}(e)),this._configMap.set(cs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.SEND_READ_RECEIPT)}),body:{groupID:"",sequenceList:void 0},keyMap:{request:{sequenceList:"MsgSeqList",sequence:"MsgSeq"}}};}(e)),this._configMap.set(ps,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_READ_RECEIPT_DETAIL)}),body:{groupID:"",sequence:void 0,flag:0,cursor:0,count:0},keyMap:{request:{sequence:"MsgSeq",count:"Num"},response:{ReadList:"readUserIDList",Read_Account:"userID",UnreadList:"unreadUserIDList",Unread_Account:"userID",IsFinish:"isCompleted"}}};}(e)),this._configMap.set(Ao,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM_MSG_EXT,".").concat(V.CMD.MODIFY_C2C_MESSAGE_EXTENSIONS)}),body:{from:void 0,to:void 0,messageKey:void 0,operateType:void 0,extensionList:void 0}};}(e)),this._configMap.set(Ro,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM_MSG_EXT,".").concat(V.CMD.GET_C2C_MESSAGE_EXTENSIONS)}),body:{from:void 0,to:void 0,messageKey:void 0,startSequence:void 0}};}(e)),this._configMap.set(Ds,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM_MSG_EXT,".").concat(V.CMD.MODIFY_GROUP_MESSAGE_EXTENSIONS)}),body:{groupID:void 0,topicID:void 0,messageSequence:void 0,operateType:void 0,extensionList:void 0}};}(e)),this._configMap.set(Es,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM_MSG_EXT,".").concat(V.CMD.GET_GROUP_MESSAGE_EXTENSIONS)}),body:{groupID:void 0,topicID:void 0,messageSequence:void 0,startSequence:void 0}};}(e)),this._configMap.set(So,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.GET_PEER_READ_TIME)}),body:{userIDList:void 0},keyMap:{request:{userIDList:"To_Account"},response:{ReadTime:"peerReadTimeList"}}};}(e)),this._configMap.set(Oo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.GET_CONVERSATION_LIST)}),body:{fromAccount:void 0,count:0},keyMap:{request:{},response:{SessionItem:"conversations",ToAccount:"groupID",To_Account:"userID",UnreadMsgCount:"unreadCount",MsgGroupReadedSeq:"messageReadSeq",C2cPeerReadTime:"c2cPeerReadTime"}}};}(e)),this._configMap.set(No,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.PAGING_GET_CONVERSATION_LIST)}),body:{fromAccount:void 0,timeStamp:void 0,startIndex:void 0,pinnedTimeStamp:void 0,pinnedStartIndex:void 0,orderType:void 0,messageAssistFlag:4,assistFlag:15},keyMap:{request:{messageAssistFlag:"MsgAssistFlags",assistFlag:"AssistFlags",pinnedTimeStamp:"TopTimeStamp",pinnedStartIndex:"TopStartIndex"},response:{SessionItem:"conversations",ToAccount:"groupID",To_Account:"userID",UnreadMsgCount:"unreadCount",MsgGroupReadedSeq:"messageReadSeq",C2cPeerReadTime:"c2cPeerReadTime",LastMsgFlags:"lastMessageFlag",TopFlags:"isPinned",TopTimeStamp:"pinnedTimeStamp",TopStartIndex:"pinnedStartIndex",GroupId:"convGroupID"}}};}(e)),this._configMap.set(Go,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.DELETE_CONVERSATION)}),body:{fromAccount:"",conversationList:void 0,clearHistoryMessage:void 0},keyMap:{request:{toGroupID:"ToGroupid",clearHistoryMessage:"ClearRamble",conversationList:"ContactItem"},response:{ResultItem:"resultList",ToGroupid:"groupID",ResultCode:"code",ResultInfo:"info"}}};}(e)),this._configMap.set(Uo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.CLEAR_HISTORY_MESSAGE)}),body:{fromAccount:"",toAccount:void 0,type:1,toGroupID:void 0},keyMap:{request:{toGroupID:"ToGroupid"}}};}(e)),this._configMap.set(Po,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.PIN_CONVERSATION)}),body:{fromAccount:"",operationType:1,itemList:void 0},keyMap:{request:{itemList:"RecentContactItem"}}};}(e)),this._configMap.set(bo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.DELETE_GROUP_AT_TIPS)}),body:{messageListToDelete:void 0},keyMap:{request:{messageListToDelete:"DelMsgList",messageSeq:"MsgSeq",messageRandom:"MsgRandom"}}};}(e)),this._configMap.set(wo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.MARK_CONVERSATION)}),body:{fromAccount:"",itemList:void 0},keyMap:{request:{itemList:"MarkItem",operationType:"OptType",groupID:"ToGroupId"},response:{ToGroupId:"groupID",OptType:"operationType"}}};}(e)),this._configMap.set(Fo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.MARK_CONVERSATION)}),body:{fromAccount:"",itemList:void 0},keyMap:{request:{itemList:"MarkItem",operationType:"OptType",groupID:"ToGroupId"},response:{ToGroupId:"groupID",OptType:"operationType"}}};}(e)),this._configMap.set(qo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.CREATE_CONVERSATION_GROUP)}),body:{fromAccount:"",itemList:void 0},keyMap:{request:{itemList:"GroupContactItem",groupID:"ToGroupId"},response:{GroupId:"convGroupID",ToGroupId:"groupID",OptType:"operationType"}}};}(e)),this._configMap.set(xo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.DELETE_CONVERSATION_GROUP)}),body:{fromAccount:"",groupName:void 0},keyMap:{request:{},response:{GroupId:"convGroupID"}}};}(e)),this._configMap.set(Vo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.UPDATE_CONVERSATION_GROUP)}),body:{fromAccount:"",updateType:void 0,updateGroup:void 0},keyMap:{request:{oldName:"OldGroupName",newName:"NewGroupName",groupID:"ToGroupId",operationType:"ContactOptType",groupName:"OldGroupName",updateItem:"ContactUpdateItem"},response:{ContactOptType:"operationType",ToGroupId:"groupID",GroupId:"convGroupID"}}};}(e)),this._configMap.set(Bo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.UPDATE_CONVERSATION_GROUP)}),body:{fromAccount:"",updateType:void 0,updateGroup:{groupName:void 0,updateGroupType:void 0,updateItem:void 0}},keyMap:{request:{},response:{}}};}(e)),this._configMap.set(Ho,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.UPDATE_CONVERSATION_GROUP)}),body:{fromAccount:"",updateType:void 0,updateGroup:void 0},keyMap:{request:{},response:{}}};}(e)),this._configMap.set(Ko,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.RECENT_CONTACT,".").concat(V.CMD.GET_CONVERSATION_GROUP_LIST)}),body:{fromAccount:"",startTime:void 0,startIndex:void 0},keyMap:{request:{},response:{GroupId:"convGroupID",ToGroupId:"groupID",OptType:"operationType",CustomMark:"customData",ContactGroupId:"convGroupIDList"}}};}(e)),this._configMap.set(fo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.PROFILE,".").concat(V.CMD.PORTRAIT_GET)}),body:{fromAccount:"",userItem:[]},keyMap:{request:{toAccount:"To_Account",standardSequence:"StandardSequence",customSequence:"CustomSequence"}}};}(e)),this._configMap.set(vo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.PROFILE,".").concat(V.CMD.PORTRAIT_SET)}),body:{fromAccount:"",profileItem:[{tag:Be.NICK,value:""},{tag:Be.GENDER,value:""},{tag:Be.ALLOWTYPE,value:""},{tag:Be.AVATAR,value:""}]},keyMap:{request:{toAccount:"To_Account",standardSequence:"StandardSequence",customSequence:"CustomSequence"}}};}(e)),this._configMap.set(mo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.FRIEND,".").concat(V.CMD.GET_BLACKLIST)}),body:{fromAccount:"",startIndex:0,maxLimited:30,lastSequence:0},keyMap:{response:{CurruentSequence:"currentSequence"}}};}(e)),this._configMap.set(Mo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.FRIEND,".").concat(V.CMD.ADD_BLACKLIST)}),body:{fromAccount:"",toAccount:[]}};}(e)),this._configMap.set(yo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.FRIEND,".").concat(V.CMD.DELETE_BLACKLIST)}),body:{fromAccount:"",toAccount:[]}};}(e)),this._configMap.set(oa,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.SET_SELF_STATUS)}),body:{customStatus:""},keyMap:{}};}(e)),this._configMap.set(sa,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.GET_USER_STATUS)}),body:{userIDList:void 0},keyMap:{response:{UserStatusList:"successUserList",ErrorList:"failureUserList",To_Account:"userID",Invalid_Account:"invalidUserID",Status:"statusType"}}};}(e)),this._configMap.set(aa,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.SUBSCRIBE_USER_STATUS)}),body:{userIDList:void 0},keyMap:{response:{ErrorList:"failureUserList",To_Account:"userID",Invalid_Account:"invalidUserID"}}};}(e)),this._configMap.set(ra,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.UNSUBSCRIBE_USER_STATUS)}),body:{userIDList:void 0,unsubscribeAll:void 0},keyMap:{response:{ErrorList:"failureUserList",To_Account:"userID",Invalid_Account:"invalidUserID"}}};}(e)),this._configMap.set(Wo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_JOINED_GROUPS)}),body:{memberAccount:"",limit:void 0,offset:void 0,groupType:void 0,responseFilter:{groupBaseInfoFilter:void 0,selfInfoFilter:void 0},isSupportTopic:0},keyMap:{request:{memberAccount:"Member_Account"},response:{GroupIdList:"groups",NoUnreadSeqList:"excludedUnreadSequenceList",MsgSeq:"readedSequence",LastRecallTime:"_lastRevokedTime"}}};}(e)),this._configMap.set(Yo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_GROUP_INFO)}),body:{groupIDList:void 0,responseFilter:{groupBaseInfoFilter:["Type","Name","Introduction","Notification","FaceUrl","Owner_Account","CreateTime","InfoSeq","LastInfoTime","LastMsgTime","MemberNum","MaxMemberNum","ApplyJoinOption","NextMsgSeq","ShutUpAllMember"],groupCustomFieldFilter:void 0,memberInfoFilter:void 0,memberCustomFieldFilter:void 0}},keyMap:{request:{groupIDList:"GroupIdList",groupCustomField:"AppDefinedData",memberCustomField:"AppMemberDefinedData",groupCustomFieldFilter:"AppDefinedDataFilter_Group",memberCustomFieldFilter:"AppDefinedDataFilter_GroupMember"},response:{GroupIdList:"groups",AppDefinedData:"groupCustomField",AppMemberDefinedData:"memberCustomField",AppDefinedDataFilter_Group:"groupCustomFieldFilter",AppDefinedDataFilter_GroupMember:"memberCustomFieldFilter",InfoSeq:"infoSequence",MemberList:"members",GroupInfo:"groups",ShutUpUntil:"muteUntil",ShutUpAllMember:"muteAllMembers"}}};}(e)),this._configMap.set(jo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.CREATE_GROUP)}),body:{type:void 0,name:void 0,groupID:void 0,ownerID:void 0,introduction:void 0,notification:void 0,maxMemberNum:void 0,joinOption:void 0,memberList:void 0,groupCustomField:void 0,memberCustomField:void 0,webPushFlag:1,avatar:"",isSupportTopic:void 0,inviteOption:void 0},keyMap:{request:{ownerID:"Owner_Account",userID:"Member_Account",avatar:"FaceUrl",maxMemberNum:"MaxMemberCount",joinOption:"ApplyJoinOption",groupCustomField:"AppDefinedData",memberCustomField:"AppMemberDefinedData",inviteOption:"InviteJoinOption"},response:{HugeGroupFlag:"avChatRoomFlag",OverJoinedGroupLimit_Account:"overLimitUserIDList"}}};}(e)),this._configMap.set(zo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.DESTROY_GROUP)}),body:{groupID:void 0}};}(e)),this._configMap.set(Jo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.MODIFY_GROUP_INFO)}),body:{groupID:void 0,name:void 0,introduction:void 0,notification:void 0,avatar:void 0,joinOption:void 0,groupCustomField:void 0,muteAllMembers:void 0,inviteOption:void 0},keyMap:{request:{groupCustomField:"AppDefinedData",muteAllMembers:"ShutUpAllMember",joinOption:"ApplyJoinOption",avatar:"FaceUrl",inviteOption:"InviteJoinOption"},response:{AppDefinedData:"groupCustomField",ShutUpAllMember:"muteAllMembers"}}};}(e)),this._configMap.set(Xo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.APPLY_JOIN_GROUP)}),body:{groupID:void 0,applyMessage:void 0,userDefinedField:void 0,webPushFlag:1,historyMessageFlag:void 0},keyMap:{request:{applyMessage:"ApplyMsg",historyMessageFlag:"HugeGroupHistoryMsgFlag"},response:{HugeGroupFlag:"avChatRoomFlag",AVChatRoomKey:"avChatRoomKey",RspMsgList:"messageList",ToGroupId:"to"}}};}(e)),this._configMap.set(Qo,function(e){return e.a2,e.tinyid,{head:t(t({},g(e,xi)),{},{servcmd:"".concat(V.NAME.BIG_GROUP_NO_AUTH,".").concat(V.CMD.APPLY_JOIN_GROUP)}),body:{groupID:void 0,applyMessage:void 0,userDefinedField:void 0,webPushFlag:1},keyMap:{request:{applyMessage:"ApplyMsg"},response:{HugeGroupFlag:"avChatRoomFlag"}}};}(e)),this._configMap.set(Zo,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.QUIT_GROUP)}),body:{groupID:void 0}};}(e)),this._configMap.set($o,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.SEARCH_GROUP_BY_ID)}),body:{groupIDList:void 0,responseFilter:{groupBasePublicInfoFilter:["Type","Name","Introduction","Notification","FaceUrl","CreateTime","Owner_Account","LastInfoTime","LastMsgTime","NextMsgSeq","MemberNum","MaxMemberNum","ApplyJoinOption","InviteJoinOption"]}},keyMap:{response:{}}};}(e)),this._configMap.set(es,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.CHANGE_GROUP_OWNER)}),body:{groupID:void 0,newOwnerID:void 0},keyMap:{request:{newOwnerID:"NewOwner_Account"}}};}(e)),this._configMap.set(ts,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.HANDLE_APPLY_JOIN_GROUP)}),body:{groupID:void 0,applicant:void 0,handleAction:void 0,handleMessage:void 0,authentication:void 0,messageKey:void 0,userDefinedField:void 0},keyMap:{request:{applicant:"Applicant_Account",handleAction:"HandleMsg",handleMessage:"ApprovalMsg",messageKey:"MsgKey"}}};}(e)),this._configMap.set(ns,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.HANDLE_INVITE_JOIN_GROUP)}),body:{groupID:void 0,applicant:void 0,invitee:void 0,handleAction:void 0,handleMessage:void 0,authentication:void 0,userDefinedField:void 0},keyMap:{request:{applicant:"Applicant_Account",invitee:"Invited_Account",handleAction:"HandleMsg",handleMessage:"ApprovalMsg"}}};}(e)),this._configMap.set(os,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.HANDLE_GROUP_INVITATION)}),body:{groupID:void 0,inviter:void 0,handleAction:void 0,handleMessage:void 0,authentication:void 0,messageKey:void 0,userDefinedField:void 0},keyMap:{request:{inviter:"Inviter_Account",handleAction:"HandleMsg",handleMessage:"ApprovalMsg",messageKey:"MsgKey"}}};}(e)),this._configMap.set(ds,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_GROUP_APPLICATION)}),body:{startTime:void 0,limit:void 0,handleAccount:void 0},keyMap:{request:{handleAccount:"Handle_Account"},response:{To_Account:"userID"}}};}(e)),this._configMap.set(gs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.DELETE_GROUP_SYSTEM_MESSAGE)}),body:{messageListToDelete:void 0},keyMap:{request:{messageListToDelete:"DelMsgList",messageSeq:"MsgSeq",messageRandom:"MsgRandom"}}};}(e)),this._configMap.set(_s,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.BIG_GROUP_LONG_POLLING,".").concat(V.CMD.AVCHATROOM_LONG_POLL)}),body:{USP:1,startSeq:1,startBroadcastSeq:void 0,holdTime:90,key:void 0,simplifiedMessage:void 0},keyMap:{request:{USP:"USP"},response:{ToGroupId:"groupID",RspBroadcastMsgList:"broadcastMessageList",IsSystemMsg:"isSystemMessage"}}};}(e)),this._configMap.set(hs,function(e){return e.a2,e.tinyid,{head:t(t({},g(e,Vi)),{},{servcmd:"".concat(V.NAME.BIG_GROUP_LONG_POLLING_NO_AUTH,".").concat(V.CMD.AVCHATROOM_LONG_POLL)}),body:{USP:1,startSeq:1,holdTime:90,key:void 0,simplifiedMessage:void 0},keyMap:{request:{USP:"USP"},response:{ToGroupId:"groupID",RspBroadcastMsgList:"broadcastMessageList",IsSystemMsg:"isSystemMessage"}}};}(e)),this._configMap.set(fs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_ONLINE_MEMBER_NUM)}),body:{groupID:void 0}};}(e)),this._configMap.set(Ms,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.SET_GROUP_ATTRIBUTES)}),body:{groupID:void 0,groupAttributeList:void 0,mainSequence:void 0,avChatRoomKey:void 0,attributeControl:["RaceConflict"]},keyMap:{request:{key:"key",value:"value"}}};}(e)),this._configMap.set(ys,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.MODIFY_GROUP_ATTRIBUTES)}),body:{groupID:void 0,groupAttributeList:void 0,mainSequence:void 0,avChatRoomKey:void 0,attributeControl:["RaceConflict"]},keyMap:{request:{key:"key",value:"value"}}};}(e)),this._configMap.set(Is,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.DELETE_GROUP_ATTRIBUTES)}),body:{groupID:void 0,groupAttributeList:void 0,mainSequence:void 0,avChatRoomKey:void 0,attributeControl:["RaceConflict"]},keyMap:{request:{key:"key"}}};}(e)),this._configMap.set(Cs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.CLEAR_GROUP_ATTRIBUTES)}),body:{groupID:void 0,mainSequence:void 0,avChatRoomKey:void 0,attributeControl:["RaceConflict"]}};}(e)),this._configMap.set(Ts,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP_ATTR,".").concat(V.CMD.GET_GROUP_ATTRIBUTES)}),body:{groupID:void 0,avChatRoomKey:void 0,groupType:1},keyMap:{request:{avChatRoomKey:"Key",groupType:"GroupType"}}};}(e)),this._configMap.set(Ss,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_GROUP_NOTIFY)}),body:{notifyType:1,groupID:"",beginTime:0,endTime:0,limit:20},keyMap:{request:{},response:{NextMsgTime:"nextRevokedTime",NotifyMsgList:"notifyList"}}};}(e)),this._configMap.set(ks,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.UPDATE_GROUP_COUNTER)}),body:{groupID:void 0,counterList:void 0,avChatRoomKey:void 0,mode:void 0},keyMap:{request:{counterList:"GroupCounter"}}};}(e)),this._configMap.set(Ls,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_GROUP_COUNTER)}),body:{groupID:void 0,keyList:[],avChatRoomKey:void 0},keyMap:{request:{keyList:"GroupCounterKeys"}}};}(e)),this._configMap.set($s,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP_COMMUNITY,".").concat(V.CMD.CREATE_TOPIC)}),body:{groupID:void 0,topicName:void 0,avatar:void 0,customData:void 0,topicID:void 0,notification:void 0,introduction:void 0},keyMap:{request:{avatar:"FaceUrl"}}};}(e)),this._configMap.set(ea,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP_COMMUNITY,".").concat(V.CMD.DELETE_TOPIC)}),body:{groupID:void 0,topicIDList:void 0},keyMap:{request:{topicIDList:"TopicIdList"},response:{DestroyResultItem:"resultList"}}};}(e)),this._configMap.set(ta,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP_COMMUNITY,".").concat(V.CMD.UPDATE_TOPIC_PROFILE)}),body:{groupID:void 0,topicID:void 0,avatar:void 0,customData:void 0,notification:void 0,introduction:void 0,muteAllMembers:void 0,topicName:void 0},keyMap:{request:{avatar:"FaceUrl",muteAllMembers:"ShutUpAllMember"}}};}(e)),this._configMap.set(na,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP_COMMUNITY,".").concat(V.CMD.GET_TOPIC_LIST)}),body:{groupID:void 0,topicIDList:void 0,MemberInfoFilter:["NoUnreadSeqList"]},keyMap:{request:{topicIDList:"TopicIdList"},response:{TopicAndSelfInfo:"topicInfoList",TopicInfo:"topic",GroupID:"groupID",ShutUpTime:"muteTime",ShutUpAllFlag:"muteAllMembers",LastMsgTime:"lastMessageTime",MsgSeq:"readedSequence",LastMsgSeq:"sequence",NoUnreadSeqList:"excludedUnreadSequenceList"}}};}(e)),this._configMap.set(As,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_GROUP_MEMBER_LIST)}),body:{groupID:void 0,limit:0,offset:void 0,next:void 0,memberRoleFilter:void 0,memberInfoFilter:["Role","NameCard","ShutUpUntil","JoinTime"],memberCustomFieldFilter:void 0},keyMap:{request:{memberCustomFieldFilter:"AppDefinedDataFilter_GroupMember"},response:{AppMemberDefinedData:"memberCustomField",AppDefinedDataFilter_GroupMember:"memberCustomFieldFilter",MemberList:"members",ShutUpUntil:"muteUntil"}}};}(e)),this._configMap.set(Rs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP_AVCHATROOM,".").concat(V.CMD.GET_AVCHATROOM_MEMBER_LIST)}),body:{groupID:void 0,offset:void 0,filter:void 0},keyMap:{request:{offset:"Timestamp",filter:"Mark"},response:{NextTimestamp:"offset"}}};}(e)),this._configMap.set(Ns,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.GET_GROUP_MEMBER_INFO)}),body:{groupID:void 0,userIDList:void 0,memberInfoFilter:void 0,memberCustomFieldFilter:void 0},keyMap:{request:{userIDList:"Member_List_Account",memberCustomFieldFilter:"AppDefinedDataFilter_GroupMember"},response:{MemberList:"members",ShutUpUntil:"muteUntil",AppDefinedDataFilter_GroupMember:"memberCustomFieldFilter",AppMemberDefinedData:"memberCustomField"}}};}(e)),this._configMap.set(Os,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.ADD_GROUP_MEMBER)}),body:{groupID:void 0,silence:void 0,userIDList:void 0},keyMap:{request:{userID:"Member_Account",userIDList:"MemberList"},response:{MemberList:"members"}}};}(e)),this._configMap.set(Gs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.DELETE_GROUP_MEMBER)}),body:{groupID:void 0,userIDList:void 0,reason:void 0},keyMap:{request:{userIDList:"MemberToDel_Account"}}};}(e)),this._configMap.set(Us,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.BAN_AVCHATROOM_MEMBER)}),body:{groupID:void 0,userIDList:void 0,duration:void 0,reason:""},keyMap:{request:{userIDList:"Members_Account",duration:"Duration",reason:"Description"}}};}(e)),this._configMap.set(Ps,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP,".").concat(V.CMD.MODIFY_GROUP_MEMBER_INFO)}),body:{groupID:void 0,topicID:void 0,userID:void 0,messageRemindType:void 0,nameCard:void 0,role:void 0,memberCustomField:void 0,muteTime:void 0},keyMap:{request:{userID:"Member_Account",memberCustomField:"AppMemberDefinedData",muteTime:"ShutUpTime",messageRemindType:"MsgFlag"}}};}(e)),this._configMap.set(bs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.GROUP_AVCHATROOM,".").concat(V.CMD.MARK_AVCHATROOM_MEMBER_INFO)}),body:{groupID:void 0,operationType:1,memberList:[]},keyMap:{request:{operationType:"CommandType",memberList:"MemberList",markType:"Marks",userID:"Member_Account"},response:{CommandType:"operationType",Marks:"markType",Member_Account:"userID"}}};}(e)),this._configMap.set(xs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STAT,".").concat(V.CMD.TIM_WEB_REPORT_V2)}),body:{header:{},event:[],quality:[]},keyMap:{request:{SDKType:"sdk_type",SDKVersion:"sdk_version",deviceType:"device_type",platform:"platform",instanceID:"instance_id",traceID:"trace_id",SDKAppID:"sdk_app_id",userID:"user_id",tinyID:"tiny_id",extension:"extension",timestamp:"timestamp",networkType:"network_type",eventType:"event_type",code:"error_code",message:"error_message",moreMessage:"more_message",duplicate:"duplicate",costTime:"cost_time",level:"level",qualityType:"quality_type",reportIndex:"report_index",wholePeriod:"whole_period",totalCount:"total_count",rttCount:"success_count_business",successRateOfRequest:"percent_business",countLessThan1Second:"success_count_business",percentOfCountLessThan1Second:"percent_business",countLessThan3Second:"success_count_platform",percentOfCountLessThan3Second:"percent_platform",successCountOfBusiness:"success_count_business",successRateOfBusiness:"percent_business",successCountOfPlatform:"success_count_platform",successRateOfPlatform:"percent_platform",successCountOfMessageReceived:"success_count_business",successRateOfMessageReceived:"percent_business",avgRTT:"average_value",avgDelay:"average_value",avgValue:"average_value",uiPlatform:"ui_platform"}}};}(o)),this._configMap.set(Vs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.HEARTBEAT,".").concat(V.CMD.ALIVE)}),body:{}};}(e)),this._configMap.set(Bs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_PUSH,".").concat(V.CMD.MESSAGE_PUSH)}),body:{},keyMap:{response:{C2cMsgArray:"C2CMessageArray",GroupMsgArray:"groupMessageArray",GroupTips:"groupTips",C2cNotifyMsgArray:"C2CNotifyMessageArray",C2cMsgInfo:"C2CReadReceiptArray",ClientSeq:"clientSequence",MsgPriority:"priority",NoticeSeq:"noticeSequence",MsgContent:"content",MsgType:"type",MsgBody:"elements",ToGroupId:"to",Desc:"description",Ext:"extension",IsSyncMsg:"isSyncMessage",Flag:"needSync",NeedAck:"needAck",PendencyAdd_Account:"userID",ProfileImNick:"nick",PendencyType:"applicationType",C2CReadAllMsg:"readAllC2CMessage",IsNeedReadReceipt:"needReadReceipt",Status:"statusType"}}};}(e)),this._configMap.set(Hs,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_PUSH,".").concat(V.CMD.MULTI_MESSAGE_PUSH)}),body:{},keyMap:{response:{GroupMsgArray:"groupMessageArray",GroupTips:"groupTips",ClientSeq:"clientSequence",MsgPriority:"priority",NoticeSeq:"noticeSequence",MsgContent:"content",MsgType:"type",MsgBody:"elements",ToGroupId:"to",Desc:"description",Ext:"extension",IsSyncMsg:"isSyncMessage",Flag:"needSync",NeedAck:"needAck",PendencyType:"applicationType"}}};}(e)),this._configMap.set(Ks,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.OPEN_IM,".").concat(V.CMD.MESSAGE_PUSH_ACK)}),body:{sessionData:void 0},keyMap:{request:{sessionData:"SessionData"}}};}(e)),this._configMap.set(Ws,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.STATUS_FORCE_OFFLINE)}),body:{},keyMap:{response:{C2cNotifyMsgArray:"C2CNotifyMessageArray",NoticeSeq:"noticeSequence",KickoutMsgNotify:"kickoutMsgNotify",NewInstInfo:"newInstanceInfo"}}};}(e)),this._configMap.set(js,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_LONG_MESSAGE,".").concat(V.CMD.DOWNLOAD_MERGER_MESSAGE)}),body:{downloadKey:""},keyMap:{response:{Data:"data",Desc:"description",Ext:"extension",Download_Flag:"downloadFlag",ThumbUUID:"thumbUUID",VideoUUID:"videoUUID"}}};}(e)),this._configMap.set(Ys,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_LONG_MESSAGE,".").concat(V.CMD.UPLOAD_MERGER_MESSAGE)}),body:{messageList:[]},keyMap:{request:{fromAccount:"From_Account",toAccount:"To_Account",msgTimeStamp:"MsgTimeStamp",msgSeq:"MsgSeq",msgRandom:"MsgRandom",msgBody:"MsgBody",type:"MsgType",content:"MsgContent",data:"Data",description:"Desc",extension:"Ext",sizeType:"Type",uuid:"UUID",url:"",imageUrl:"URL",fileUrl:"Url",remoteAudioUrl:"Url",remoteVideoUrl:"VideoUrl",thumbUUID:"ThumbUUID",videoUUID:"VideoUUID",videoUrl:"",downloadFlag:"Download_Flag",from:"From_Account",time:"MsgTimeStamp",messageRandom:"MsgRandom",messageSequence:"MsgSeq",elements:"MsgBody",clientSequence:"ClientSeq",payload:"MsgContent",messageList:"MsgList",messageNumber:"MsgNum",abstractList:"AbstractList",messageBody:"MsgBody"}}};}(e)),this._configMap.set(ca,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.SET_TOKEN)}),body:{tokenID:"",pushMsg:0,sdkAppID:0,businessID:"",deviceBrand:"",deviceToken:"",isTpns:0,isWebUniapp:0},keyMap:{request:{tokenID:"TokenID",pushMsg:"PushMsg",sdkAppID:"EnterVersion",businessID:"BusiID",deviceBrand:"InstType",deviceToken:"VarToken",isTpns:"IsTpns"}}};}(e)),this._configMap.set(ua,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.STAT_FOREGROUND)}),body:{isWebUniapp:0}};}(e)),this._configMap.set(ia,function(e){return{head:t(t({},e),{},{servcmd:"".concat(V.NAME.IM_OPEN_STATUS,".").concat(V.CMD.STAT_BACKGROUND)}),body:{C2CUnread:0,GroupUnread:0,isWebUniapp:0},keyMap:{request:{c2cUnreadCount:"C2cUnread",groupUnreadCount:"GrpUnread"}}};}(e));}},{key:"has",value:function value(e){return this._configMap.has(e);}},{key:"get",value:function value(e){return this._configMap.get(e);}},{key:"update",value:function value(){this._fillConfigMap();}},{key:"getKeyMap",value:function value(e){return this.has(e)?this.get(e).keyMap||{}:(xe.w("".concat(this._n,".getKeyMap unknown protocolName:").concat(e)),{});}},{key:"getProtocolData",value:function value(e){var t=e.protocolName,n=e.requestData,o=this.get(t),s=null;if(n){var a=this._simpleDeepCopy(o),r=this._updateService(n,a),i=r.body,u=Object.create(null);for(var c in i){if(Object.prototype.hasOwnProperty.call(i,c)){if(u[c]=i[c],void 0===n[c])continue;u[c]=n[c];}}r.body=u,s=this._getUplinkData(r);}else s=this._getUplinkData(o);return s;}},{key:"_getUplinkData",value:function value(e){var t=this._requestDataCleaner(e),n=Pt(t.head),o=Di(t.body,this._getRequestKeyMap(n));return t.body=o,t;}},{key:"_updateService",value:function value(e,t){var n=Pt(t.head);if(this._isFromGroupRequest(t)){var o=e.type,s=e.groupID,a=void 0===s?void 0:s,r=e.groupIDList,i=void 0===r?[]:r;at(a)&&(a=i[0]||""),Tt({type:o,groupID:a})&&(t.head.servcmd="".concat(V.NAME.GROUP_COMMUNITY,".").concat(n));}return t;}},{key:"_isFromGroupRequest",value:function value(e){return e.head.servcmd.includes(V.NAME.GROUP)||e.head.servcmd.includes(V.NAME.GROUP_ATTR);}},{key:"_getRequestKeyMap",value:function value(e){var n=this.getKeyMap(e);return t(t({},Ii.request),n.request);}},{key:"_requestDataCleaner",value:function value(e){var t=Array.isArray(e)?[]:Object.create(null);for(var o in e){Object.prototype.hasOwnProperty.call(e,o)&&lt(o)&&null!==e[o]&&void 0!==e[o]&&("object"!==n(e[o])?t[o]=e[o]:t[o]=this._requestDataCleaner.bind(this)(e[o]));}return t;}},{key:"_simpleDeepCopy",value:function value(e){for(var t,n=Object.keys(e),o={},s=0,a=n.length;s<a;s++){t=n[s],st(e[t])?o[t]=Array.from(e[t]):nt(e[t])?o[t]=this._simpleDeepCopy(e[t]):o[t]=e[t];}return o;}}]),e;}(),Hi=[Ks],Ki=function(){function e(t){o(this,e),this._sessionModule=t,this._n="DownlinkHandler",this._eventHandlerMap=new Map(),this._eventHandlerMap.set("C2CMessageArray",this._c2cMessageArrayHandler.bind(this)),this._eventHandlerMap.set("groupMessageArray",this._groupMessageArrayHandler.bind(this)),this._eventHandlerMap.set("groupTips",this._groupTipsHandler.bind(this)),this._eventHandlerMap.set("C2CNotifyMessageArray",this._C2CNotifyMessageArrayHandler.bind(this)),this._eventHandlerMap.set("C2CReadReceiptArray",this._C2CReadReceiptArrayHandler.bind(this)),this._eventHandlerMap.set("profileModify",this._profileHandler.bind(this)),this._eventHandlerMap.set("friendListMod",this._relationChainHandler.bind(this)),this._eventHandlerMap.set("recentContactMod",this._recentContactHandler.bind(this)),this._eventHandlerMap.set("readAllC2CMessage",this._allMessageReadHandler.bind(this)),this._eventHandlerMap.set("c2cMessageModified",this._c2cMessageModifiedHandler.bind(this)),this._eventHandlerMap.set("groupMessageModified",this._groupMessageModifiedHandler.bind(this)),this._eventHandlerMap.set("userStatusList",this._userStatusListHandler.bind(this)),this._eventHandlerMap.set("messageExtensionNotify",this._messageExtensionNotifyHandler.bind(this)),this._keys=m(this._eventHandlerMap.keys());}return a(e,[{key:"_c2cMessageArrayHandler",value:function value(e){var t=this._sessionModule.getModule(Gn);if(t){if(e.dataList.forEach(function(e){if(1===e.isSyncMessage){var t=e.from;e.from=e.to,e.to=t;}}),1===e.needSync)this._sessionModule.getModule(Yn).startOnlineSync();t.onNewC2CMessage({dataList:e.dataList,isInstantMessage:!0});}}},{key:"_c2cMessageModifiedHandler",value:function value(e){var t=this._sessionModule.getModule(Gn);t&&t.onC2CMessageModified(e);}},{key:"_groupMessageArrayHandler",value:function value(e){var t=this._sessionModule.getModule(Un);t&&t.onNewGroupMessage({event:e.event,dataList:e.dataList,isInstantMessage:!0});}},{key:"_groupMessageModifiedHandler",value:function value(e){var t=this._sessionModule.getModule(Un);t&&t.onGroupMessageModified(e);}},{key:"_groupTipsHandler",value:function value(e){var t=this._sessionModule.getModule(Un);if(t){var n=e.event,o=e.dataList,s=e.isInstantMessage,a=void 0===s||s,r=e.isSyncingEnded;switch(n){case 4:case 6:t.onNewGroupTips({event:n,dataList:o});break;case 5:for(var i=0;i<o.length;i++){if(st(o[i].elements.revokedInfos))t.onGroupMessageRevoked({dataList:o});else if(st(o[i].elements.groupMessageReadNotice))t.onGroupMessageReadNotice({dataList:o});else{if(!st(o[i].elements.readReceiptList)){t.onNewGroupSystemNotice({dataList:o,isInstantMessage:a,isSyncingEnded:r});break;}t.onReadReceiptList({dataList:o});}}break;case 12:this._sessionModule.getModule(Fn).onNewGroupAtTips({dataList:o});break;default:xe.l("".concat(this._n,"._groupTipsHandler unknown event:").concat(n," dataList:"),o);}}}},{key:"_C2CNotifyMessageArrayHandler",value:function value(e){var t=this,n=e.dataList;if(st(n)){var o=this._sessionModule.getModule(Gn);n.forEach(function(e){if(ot(e))if(e.hasOwnProperty("kickoutMsgNotify")){var s=e.kickoutMsgNotify,a=s.kickType,r=s.newInstanceInfo,i=void 0===r?{}:r;1===a?t._sessionModule.onMultipleAccountKickedOut(i):2===a?t._sessionModule.onMultipleDeviceKickedOut(i):3===a&&t._sessionModule.onRestApiKickedOut(i);}else if(e.hasOwnProperty("c2cMessageRevokedNotify"))o&&o.onC2CMessageRevoked({dataList:n});else if(e.hasOwnProperty("c2cMessageReadReceipt"))o&&o.onC2CMessageReadReceipt({dataList:n});else if(e.hasOwnProperty("c2cMessageReadNotice"))o&&o.onC2CMessageReadNotice({dataList:n});else if(e.hasOwnProperty("muteNotificationsSync")){t._sessionModule.getModule(Fn).onC2CMessageRemindTypeSynced({dataList:n});}});}}},{key:"_C2CReadReceiptArrayHandler",value:function value(e){this._sessionModule.getModule(Gn).onReadReceiptList(e);}},{key:"_profileHandler",value:function value(e){this._sessionModule.getModule(On).onProfileModified({dataList:e.dataList});var t=this._sessionModule.getModule(Pn);t&&t.onFriendProfileModified({dataList:e.dataList});}},{key:"_relationChainHandler",value:function value(e){this._sessionModule.getModule(On).onRelationChainModified({dataList:e.dataList});var t=this._sessionModule.getModule(Pn);t&&t.onRelationChainModified({dataList:e.dataList});}},{key:"_recentContactHandler",value:function value(e){var t=e.dataList;if(st(t)){var n=this._sessionModule.getModule(Fn);n&&t.forEach(function(e){var t=e.pushType;if(1===t){var o=e.recentContactDeleteItem;n.onConversationDeleted(o.recentContactList);}else if(2===t){var s=e.recentContactTopItem;n.onConversationPinned(s.recentContactList);}else if(3===t){var a=e.recentContactTopItem;n.onConversationUnpinned(a.recentContactList);}else if(4===t){var r=e.recentContactMarkContact;n.onConversationMarkUpdated(r.recentContactMarkContactItem);}else if(5===t){var i=e.recentContactCreateContactGroup;n.onConversationGroupCreated(i.msgContactGroupContactItem);}else if(6===t){var u=e.recentContactDelContactGroup;n.onConversationGroupDeleted(u.msgGroupItem);}else if(7===t){var c=e.recentContactUpdateContactGroup,l=c.updateType,p=c.msgUpdateGroup,d=c.msgUpdateContact;if(1===l){var g=p.updateGroupType;1===g?n.onConversationGroupNameUpdated(p):2===g&&n.onConversationInGroupUpdated(p);}else 2===l&&n.onConversationAddedToOrDeletedFromGroup(d);}});}}},{key:"_allMessageReadHandler",value:function value(e){var t=e.dataList,n=this._sessionModule.getModule(Fn);n&&n.onPushedAllMessageRead(t);}},{key:"_userStatusListHandler",value:function value(e){this._sessionModule.getModule(On).onUserStatusUpdated(e);}},{key:"_messageExtensionNotifyHandler",value:function value(e){this._sessionModule.getModule(Nn).onMessageExtensionNotify(e);}},{key:"onMessage",value:function value(e){var t=this,n=e.body;if(this._filterMessageFromIMOpenPush(e)){var o=n.eventArray,s=n.isInstantMessage,a=n.isSyncingEnded,r=n.needSync;if(st(o))for(var i=null,u=null,c=0,l=0,p=o.length;l<p;l++){c=(i=o[l]).event;var d=Object.keys(i).find(function(e){return-1!==t._keys.indexOf(e);});d?(u=14===c?{readAllC2CMessage:i[d],groupMessageReadInfoList:i.groupMessageReadNotice||[]}:16===c?{userID:i.userID,readReceiptList:i[d]}:i[d],this._eventHandlerMap.get(d)({event:c,dataList:u,isInstantMessage:s,isSyncingEnded:a,needSync:r})):xe.l("".concat(this._n,".onMessage unknown eventItem:").concat(i));}}}},{key:"_filterMessageFromIMOpenPush",value:function value(e){var t=e.head,n=e.body,o=t.servcmd,s=!1;if(at(o)||(s=o.includes(V.NAME.IM_CONFIG_MANAGER)||o.includes(V.NAME.OVERLOAD_PUSH)||o.includes(V.NAME.STAT_SERVICE)),!s)return!0;if(o.includes(V.CMD.PUSHED_CLOUD_CONTROL_CONFIG))this._sessionModule.getModule(Xn).onPushedCloudControlConfig(n);else if(o.includes(V.CMD.PUSHED_COMMERCIAL_CONFIG)){this._sessionModule.getModule(eo).onPushedConfig(n);}else if(o.includes(V.CMD.OVERLOAD_NOTIFY))this._sessionModule.onPushedServerOverload(n);else if(o.includes(V.CMD.KICK_OTHER)){var a=Date.now();this._sessionModule.reLoginOnKickOther();var r=new ka("kickOther"),i=this._sessionModule.getModule(An).getLastWsHelloTs(),u=a-i;r.setMessage("last wshello time:".concat(i," diff:").concat(u,"ms")).setNetworkType(this._sessionModule.getNetworkType()).end();}return!1;}}]),e;}(),Wi=[{cmd:V.CMD.GET_GROUP_INFO,interval:1,count:20},{cmd:V.CMD.GET_AVCHATROOM_MEMBER_LIST,interval:3,count:1},{cmd:V.CMD.GET_GROUP_APPLICATION,interval:1,count:15},{cmd:V.CMD.GET_TOPIC_LIST,interval:1,count:10},{cmd:V.CMD.SET_GROUP_ATTRIBUTES,interval:5,count:10},{cmd:V.CMD.MODIFY_GROUP_ATTRIBUTES,interval:5,count:10},{cmd:V.CMD.DELETE_GROUP_ATTRIBUTES,interval:5,count:10},{cmd:V.CMD.CLEAR_GROUP_ATTRIBUTES,interval:5,count:10},{cmd:V.CMD.GET_GROUP_ATTRIBUTES,interval:5,count:20},{cmd:V.CMD.UPDATE_GROUP_COUNTER,interval:5,count:20},{cmd:V.CMD.GET_GROUP_COUNTER,interval:5,count:20},{cmd:V.CMD.SET_ALL_MESSAGE_READ,interval:1,count:1},{cmd:V.CMD.GET_USER_STATUS,interval:5,count:20},{cmd:V.CMD.SUBSCRIBE_USER_STATUS,interval:5,count:20},{cmd:V.CMD.UNSUBSCRIBE_USER_STATUS,interval:5,count:20}],Yi=function(e){i(s,e);var n=f(s);function s(e){var t;return o(this,s),(t=n.call(this,e))._n="SessionModule",t._platform=t.getPlatform(),t._protocolHandler=new Bi(_(t)),t._messageDispatcher=new Ki(_(t)),t._commandFrequencyLimitMap=new Map(),t._commandRequestInfoMap=new Map(),t._serverOverloadInfoMap=new Map(),t._init(),t.getInnerEmitterInstance().on($a,t._onCloudConfigUpdated,_(t)),t;}return a(s,[{key:"_init",value:function value(){this._updateCommandFrequencyLimitMap(Wi);}},{key:"_onCloudConfigUpdated",value:function value(){var e=this.getCloudConfig("cmd_frequency_limit");at(e)||(e=JSON.parse(e),this._updateCommandFrequencyLimitMap(e));}},{key:"_updateCommandFrequencyLimitMap",value:function value(e){var t=this;e.forEach(function(e){t._commandFrequencyLimitMap.set(e.cmd,{interval:e.interval,count:e.count});});}},{key:"updateProtocolConfig",value:function value(){this._protocolHandler.update();}},{key:"request",value:function value(e){xe.d("".concat(this._n,".request options:"),e);var t=e.protocolName,n=e.tjgID;if(!this._protocolHandler.has(t))return xe.w("".concat(this._n,".request unknown protocol:").concat(t)),Ja({code:da.CANNOT_FIND_PROTOCOL});var o=this.getProtocolData(e),s=o.head.servcmd;if(this._isFrequencyOverLimit(s))return Ja({code:da.OVER_FREQUENCY_LIMIT});if(this._isServerOverload(s))return Ja({code:da.OPEN_SERVICE_OVERLOAD_ERROR});jt(n)||(o.head.tjgID=n);var a=this.getModule(zn);return Hi.includes(t)?a.simplySend(o):a.send(o);}},{key:"getKeyMap",value:function value(e){return this._protocolHandler.getKeyMap(e);}},{key:"genCommonHead",value:function value(){var e=this.getModule(qn);return{ver:"v4",platform:this._platform,websdkappid:O,websdkversion:N,a2:e.getA2Key()||void 0,tinyid:e.getTinyID()||void 0,status_instid:e.getStatusInstanceID(),sdkappid:e.getSDKAppID(),contenttype:e.getContentType(),reqtime:0,identifier:e.getA2Key()?void 0:e.getUserID(),usersig:e.getA2Key()?void 0:e.getUserSig(),sdkability:192371,tjgID:""};}},{key:"genCosSpecifiedHead",value:function value(){var e=this.getModule(qn);return{ver:"v4",platform:this._platform,websdkappid:O,websdkversion:N,sdkappid:e.getSDKAppID(),contenttype:e.getContentType(),reqtime:0,identifier:e.getUserID(),usersig:e.getUserSig(),status_instid:e.getStatusInstanceID(),sdkability:192371};}},{key:"genSSOReportHead",value:function value(){var e=this.getModule(qn);return{ver:"v4",platform:this._platform,websdkappid:O,websdkversion:N,sdkappid:e.getSDKAppID(),contenttype:"",reqtime:0,identifier:"",usersig:"",status_instid:e.getStatusInstanceID(),sdkability:192371};}},{key:"getProtocolData",value:function value(e){return this._protocolHandler.getProtocolData(e);}},{key:"trans",value:function value(e){var n=e.servcmd,o=e.data,s={head:t(t({},this.genCommonHead()),{},{servcmd:n}),body:o};return this.getModule(zn).send(s);}},{key:"sendComboMessage",value:function value(e){var n=e.servcmd,o=e.data,s={head:t(t({},this.genCommonHead()),{},{servcmd:n}),body:o};return this.getModule(zn).send(s);}},{key:"onErrorCodeNotZero",value:function value(e){var t=e.errorCode;if(t===da.HELLO_ANSWER_KICKED_OUT){var n=e.kickType,o=e.newInstanceInfo,s=void 0===o?{}:o;1===n?this.onMultipleAccountKickedOut(s):2===n?this.onMultipleDeviceKickedOut(s):3===n&&this.onRestApiKickedOut(s);}t!==da.MESSAGE_A2KEY_EXPIRED&&t!==da.ACCOUNT_A2KEY_EXPIRED||(this._onUserSigExpired(),this.getModule(zn).reConnect());}},{key:"onMessage",value:function value(e){var t=e.body,n=t.needAck,o=void 0===n?0:n,s=t.sessionData;1===o&&this._sendACK(s),this._messageDispatcher.onMessage(e);}},{key:"onReconnected",value:function value(){this._reLoginOnReconnected();}},{key:"reLoginOnKickOther",value:function value(){xe.l("".concat(this._n,".reLoginOnKickOther")),this._reLogin();}},{key:"_reLoginOnReconnected",value:function value(){xe.l("".concat(this._n,"._reLoginOnReconnected")),this._reLogin();}},{key:"_reLogin",value:function value(){var e=this;if(this.isLoggedIn()){var t=0,n=this.getModule(to);n.canIUseOfflinePush()&&(t=n.getUniAppPlatform()),this.request({protocolName:io,requestData:{isWebUniapp:t}}).then(function(t){var n=t.data.instanceID;e.getModule(qn).setStatusInstanceID(n),xe.l("".concat(e._n,"._reLogin ok.")),e.getModule(Fn).syncConversationList().then(function(){xe.l("".concat(e._n,"._reLogin, sync conversation list ok.")),e.getModule(Zn).start();}),e.getModule(Un).updateLocalMainSequenceOnReconnected();var o=e.getModule(wn);o.resetGetTopicTime(),o.getTopicListOnReconnected();});}}},{key:"onMultipleAccountKickedOut",value:function value(e){this.getModule(An).onMultipleAccountKickedOut(e);}},{key:"onMultipleDeviceKickedOut",value:function value(e){this.getModule(An).onMultipleDeviceKickedOut(e);}},{key:"_onUserSigExpired",value:function value(){this.getModule(An).onUserSigExpired();}},{key:"onRestApiKickedOut",value:function value(e){this.getModule(An).onRestApiKickedOut(e);}},{key:"_sendACK",value:function value(e){this.request({protocolName:Ks,requestData:{sessionData:e}});}},{key:"_isFrequencyOverLimit",value:function value(e){var t=e.split(".")[1];if(!this._commandFrequencyLimitMap.has(t))return!1;if(!this._commandRequestInfoMap.has(t))return this._commandRequestInfoMap.set(t,{startTime:Date.now(),requestCount:1}),!1;var n=this._commandFrequencyLimitMap.get(t),o=n.count,s=n.interval,a=this._commandRequestInfoMap.get(t),r=a.startTime,i=a.requestCount;if(Date.now()-r>1e3*s)return this._commandRequestInfoMap.set(t,{startTime:Date.now(),requestCount:1}),!1;i+=1,this._commandRequestInfoMap.set(t,{startTime:r,requestCount:i});var u=!1;return i>o&&(u=!0),u;}},{key:"_isServerOverload",value:function value(e){if(!this._serverOverloadInfoMap.has(e))return!1;var t=this._serverOverloadInfoMap.get(e),n=t.overloadTime,o=t.waitingTime,s=!1;return Date.now()-n<=1e3*o?s=!0:(this._serverOverloadInfoMap.delete(e),s=!1),s;}},{key:"onPushedServerOverload",value:function value(e){var t=e.overloadCommand,n=e.waitingTime;this._serverOverloadInfoMap.set(t,{overloadTime:Date.now(),waitingTime:n}),xe.w("".concat(this._n,".onPushedServerOverload waitingTime:").concat(n,"s"));}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._updateCommandFrequencyLimitMap(Wi),this._commandRequestInfoMap.clear(),this._serverOverloadInfoMap.clear();}}]),s;}(ro),ji=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="MessageLossDetectionModule",s._maybeLostSequencesMap=new Map(),s._firstRoundRet=[],s;}return a(n,[{key:"onMessageMaybeLost",value:function value(e,t,n){this._maybeLostSequencesMap.has(e)||this._maybeLostSequencesMap.set(e,[]);for(var o=this._maybeLostSequencesMap.get(e),s=0;s<n;s++){-1===o.indexOf(t+s)&&o.push(t+s);}}},{key:"detectFirstRound",value:function value(e,t){var n=this._maybeLostSequencesMap.get(e);if(!jt(n)&&!jt(t)){var o=n.filter(function(e){return-1===t.indexOf(e);});0===o.length?xe.i("".concat(this._n,".detectFirstRound no message loss. conversationID:").concat(e)):this._firstRoundRet=this._firstRoundRet.concat(o),n.length=0;}}},{key:"detectSecondRound",value:function value(e,t){if(!jt(this._firstRoundRet)&&!jt(t)){var n=this._firstRoundRet.filter(function(e){return-1===t.indexOf(e);});this._firstRoundRet.length=0;var o,s=n.length;if(0!==s)s<=5?o=e+"-"+n.join("-"):(n.sort(function(e,t){return e-t;}),o=e+" start:"+n[0]+" end:"+n[s-1]+" count:"+s),new ka("messageLoss").setMessage(o).setNetworkType(this.getNetworkType()).setLevel("warning").end(),xe.i("".concat(this._n,".detectSecondRound message loss detected. conversationID:").concat(e," lostSequences:").concat(n));}}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._maybeLostSequencesMap.clear(),this._firstRoundRet.length=0;}}]),n;}(ro),zi=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="CloudControlModule",s._cloudConfig=new Map(),s._expiredTime=0,s._version=0,s._isFetching=!1,s;}return a(n,[{key:"getCloudConfig",value:function value(e){return at(e)?this._cloudConfig:this._cloudConfig.has(e)?this._cloudConfig.get(e):void 0;}},{key:"_canFetchConfig",value:function value(){return this.isLoggedIn()&&!this._isFetching&&Date.now()>=this._expiredTime;}},{key:"fetchConfig",value:function value(){var e=this,t=this._canFetchConfig();if(xe.l("".concat(this._n,".fetchConfig canFetchConfig:").concat(t)),t){var n=new ka("fetchCloudControlConfig"),o=this.getModule(qn).getSDKAppID();this._isFetching=!0,this.request({protocolName:zs,requestData:{SDKAppID:o,version:this._version}}).then(function(t){e._isFetching=!1,n.setMessage("version:".concat(e._version," newVersion:").concat(t.data.version," config:").concat(t.data.cloudControlConfig)).setNetworkType(e.getNetworkType()).end(),xe.l("".concat(e._n,".fetchConfig ok")),e._parseCloudControlConfig(t.data);}).catch(function(t){e._isFetching=!1,e.probeNetwork().then(function(e){var o=v(e,2),s=o[0],a=o[1];n.setError(t,s,a).end();}),xe.l("".concat(e._n,".fetchConfig failed. error:"),t),e._setExpiredTimeOnResponseError(12e4);});}}},{key:"onPushedCloudControlConfig",value:function value(e){xe.l("".concat(this._n,".onPushedCloudControlConfig")),new ka("pushedCloudControlConfig").setNetworkType(this.getNetworkType()).setMessage("newVersion:".concat(e.version," config:").concat(e.cloudControlConfig)).end(),this._parseCloudControlConfig(e);}},{key:"onCheckTimer",value:function value(e){this._canFetchConfig()&&this.fetchConfig();}},{key:"_parseCloudControlConfig",value:function value(e){var t=this,n="".concat(this._n,"._parseCloudControlConfig"),o=e.errorCode,s=e.errorMessage,a=e.cloudControlConfig,r=e.version,i=e.expiredTime;if(0===o){if(this._version!==r){var u=null;try{u=JSON.parse(a);}catch(c){this.isPrivateNetWork()||xe.e("".concat(n," JSON parse error. cloudControlConfig:"),a);}u&&(this._cloudConfig.clear(),Object.keys(u).forEach(function(e){t._cloudConfig.set(e,u[e]);}),this._version=r,this.emitInnerEvent($a));}this._expiredTime=Date.now()+1e3*i;}else at(o)?(xe.l("".concat(n," failed. Invalid message format:"),e),this._setExpiredTimeOnResponseError(36e5)):(xe.e("".concat(n," errorCode:").concat(o," errorMessage:").concat(s)),this._setExpiredTimeOnResponseError(12e4));}},{key:"_setExpiredTimeOnResponseError",value:function value(e){this._expiredTime=Date.now()+e;}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._cloudConfig.clear(),this._expiredTime=0,this._version=0,this._isFetching=!1;}}]),n;}(ro),Ji=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="RecoverMessageModule",s.PULL_LIMIT_COUNT=15,s;}return a(n,[{key:"start",value:function value(){this._recoverGroupChat(),this._recoverC2CChat();}},{key:"_recoverGroupChat",value:function value(){var e,t,n=this,o=this._getLocalConversationList().filter(function(e){return e.type===S.CONV_GROUP&&e.groupProfile.type!==S.GRP_AVCHATROOM;}),s=this.getModule(Fn),a=0,r=0,i=0;o.forEach(function(o){var u=o.conversationID,c=o.lastMessage;t=u.replace(S.CONV_GROUP,""),e=s.getLocalLastMessage(u),c&&0!==c.lastSequence&&e?(r=c.lastSequence,a=e.sequence,i=r-a,a>0&&i>=1&&i<300?n._recoverGroupMessage({groupID:t,localLastMessageSequence:a,remoteLastMessageSequence:r}):n._getGroupNotify(t)):n._getGroupNotify(t);});}},{key:"_recoverC2CChat",value:function value(){var e,t=this,n=this._getLocalConversationList().filter(function(e){return e.type===S.CONV_C2C;}),o=this.getModule(Fn),s=0,a=0,r=0,i=[Promise.resolve()];n.forEach(function(n){var u=n.conversationID,c=n.lastMessage;e=o.getLocalLastMessage(u),c&&0!==c.lastTime&&e&&(a=c.lastTime,s=e.time,r=a-s,s>0&&r>=1&&r<=600&&i.push(t._recoverC2CMessage({conversationID:u,localLastMessageTime:s,remoteLastMessageTime:a})));}),Promise.all(i).then(function(){xe.l("".concat(t._n,"._recoverC2CChat all promise fulfilled, start to sync unread messages")),t.getModule(Yn).startSyncOnReconnected();});}},{key:"_getLocalConversationList",value:function value(){return this.getModule(Fn).getLocalConversationList();}},{key:"_recoverGroupMessage",value:function value(e){var t=this,n="".concat(this._n,"._recoverGroupMessage");xe.l("".concat(n," options:"),e);var o=e.groupID,s=e.localLastMessageSequence,a=e.remoteLastMessageSequence;this._getGroupRomaingMessage({groupID:o,sequence:s}).then(function(e){var s=e.data,r=s.complete,i=s.messageList;if(!at(i)){var u=i[0].sequence;xe.l("".concat(n," pkgLastMessageSequence:").concat(u," complete:").concat(r)),u<a&&2!==r&&t._recoverGroupMessage({groupID:o,localLastMessageSequence:u,remoteLastMessageSequence:a}),new ka("recoverMessage").setNetworkType(t.getNetworkType()).setMessage("groupID:".concat(o," complete:").concat(r," messageList length:").concat(i.length)).end();var c=t.getModule(Un);i.length>1&&i.sort(function(e,t){return e.sequence-t.sequence;});for(var l=0;l<i.length;l++){var p=i[l];p.from!==S.CONV_SYSTEM?c.onNewGroupMessage({dataList:[p],isInstantMessage:!1,updateUnreadCount:!1}):c.onNewGroupTips({event:p.event,dataList:[p]});}t._getGroupNotify(o);}});}},{key:"_getGroupNotify",value:function value(e){this.getModule(Un).getGroupNotify(e);}},{key:"_getGroupRomaingMessage",value:function value(e){var t=e.groupID,n=e.sequence;return this.request({protocolName:is,requestData:{groupID:t,count:this.PULL_LIMIT_COUNT,sequence:n+this.PULL_LIMIT_COUNT-1}});}},{key:"_recoverC2CMessage",value:function value(e){var t=this,n="".concat(this._n,"._recoverC2CMessage");xe.l("".concat(this._n,"._recoverC2CMessage options:"),e);var o=e.conversationID,s=e.localLastMessageTime,a=e.remoteLastMessageTime;return this._getC2CRoamingMessage({conversationID:o,time:s}).then(function(e){var s=e.data,r=s.complete,i=s.messageList;if(!at(i)){var u=i.length;new ka("recoverMessage").setNetworkType(t.getNetworkType()).setMessage("".concat(o," complete:").concat(r," messageList length:").concat(u)).end(),t.getModule(Gn).onNewC2CMessage({dataList:i,isInstantMessage:!0});var c=i[u-1].time;if(xe.l("".concat(n," pkgLastMessageTime:").concat(c," complete:").concat(r)),c<a&&1!==r)return t._recoverC2CMessage({conversationID:o,localLastMessageTime:c,remoteLastMessageTime:a});}});}},{key:"_getC2CRoamingMessage",value:function value(e){var t=e.conversationID,n=e.time;return this.request({protocolName:Eo,requestData:{peerAccount:t.replace(S.CONV_C2C,""),count:this.PULL_LIMIT_COUNT+1,lastMessageTime:n,direction:1}});}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset"));}}]),n;}(ro),Xi=function(){function e(){o(this,e),this._n="AvgE2EDelay",this._e2eDelayArray=[];}return a(e,[{key:"addMessageDelay",value:function value(e){var t=be()-e;t>=0&&this._e2eDelayArray.push(t);}},{key:"_calcAvg",value:function value(e,t){if(0===t)return 0;var n=0;return e.forEach(function(e){n+=e;}),bt(n/t,1);}},{key:"_calcCountWithLimit",value:function value(e){var t=e.e2eDelayArray,n=e.min,o=e.max;return t.filter(function(e){return n<=e&&e<o;}).length;}},{key:"_calcPercent",value:function value(e,t){var n=bt(e/t*100,2);return n>100&&(n=100),n;}},{key:"_checkE2EDelayException",value:function value(e,t){var n=e.filter(function(e){return e>t;});if(n.length>0){var o=n.length,s=Math.min.apply(Math,m(n)),a=Math.max.apply(Math,m(n)),r=this._calcAvg(n,o),i=bt(o/e.length*100,2);if(i>50)new ka("messageE2EDelayException").setMessage("count:".concat(o," min:").concat(s," max:").concat(a," avg:").concat(r," percent:").concat(i)).setLevel("warning").end();}}},{key:"getStatResult",value:function value(){var e=this._e2eDelayArray.length;if(0===e)return null;var t=m(this._e2eDelayArray),n=this._calcCountWithLimit({e2eDelayArray:t,min:0,max:1}),o=this._calcCountWithLimit({e2eDelayArray:t,min:1,max:3}),s=this._calcPercent(n,e),a=this._calcPercent(o,e),r=this._calcAvg(t,e);return this._checkE2EDelayException(t,3),t.length=0,this.reset(),{totalCount:e,countLessThan1Second:n,percentOfCountLessThan1Second:s,countLessThan3Second:o,percentOfCountLessThan3Second:a,avgDelay:r};}},{key:"reset",value:function value(){this._e2eDelayArray.length=0;}}]),e;}(),Qi=function(){function e(){o(this,e),this._n="AvgRTT",this._requestCount=0,this._rttArray=[];}return a(e,[{key:"addRequestCount",value:function value(){this._requestCount+=1;}},{key:"addRTT",value:function value(e){this._rttArray.push(e);}},{key:"_calcTotalCount",value:function value(){return this._requestCount;}},{key:"_calcRTTCount",value:function value(e){return e.length;}},{key:"_calcSuccessRateOfRequest",value:function value(e,t){if(0===t)return 0;var n=bt(e/t*100,2);return n>100&&(n=100),n;}},{key:"_calcAvg",value:function value(e,t){if(0===t)return 0;var n=0;return e.forEach(function(e){n+=e;}),parseInt(n/t);}},{key:"_calcMax",value:function value(){return Math.max.apply(Math,m(this._rttArray));}},{key:"_calcMin",value:function value(){return Math.min.apply(Math,m(this._rttArray));}},{key:"getStatResult",value:function value(){var e=this._calcTotalCount(),t=m(this._rttArray);if(0===e)return null;var n=this._calcRTTCount(t),o=this._calcSuccessRateOfRequest(n,e),s=this._calcAvg(t,n);return xe.l("".concat(this._n,".getStatResult max:").concat(this._calcMax()," min:").concat(this._calcMin()," avg:").concat(s)),this.reset(),{totalCount:e,rttCount:n,successRateOfRequest:o,avgRTT:s};}},{key:"reset",value:function value(){this._requestCount=0,this._rttArray.length=0;}}]),e;}(),Zi=function(){function e(){o(this,e),this._map=new Map();}return a(e,[{key:"initMap",value:function value(e){var t=this;e.forEach(function(e){t._map.set(e,{totalCount:0,successCount:0,failedCountOfUserSide:0,costArray:[],fileSizeArray:[]});});}},{key:"addTotalCount",value:function value(e){return!(at(e)||!this._map.has(e))&&(this._map.get(e).totalCount+=1,!0);}},{key:"addSuccessCount",value:function value(e){return!(at(e)||!this._map.has(e))&&(this._map.get(e).successCount+=1,!0);}},{key:"addFailedCountOfUserSide",value:function value(e){return!(at(e)||!this._map.has(e))&&(this._map.get(e).failedCountOfUserSide+=1,!0);}},{key:"addCost",value:function value(e,t){return!(at(e)||!this._map.has(e))&&(this._map.get(e).costArray.push(t),!0);}},{key:"addFileSize",value:function value(e,t){return!(at(e)||!this._map.has(e))&&(this._map.get(e).fileSizeArray.push(t),!0);}},{key:"_calcSuccessRateOfBusiness",value:function value(e){if(at(e)||!this._map.has(e))return-1;var t=this._map.get(e),n=bt(t.successCount/t.totalCount*100,2);return n>100&&(n=100),n;}},{key:"_calcSuccessRateOfPlatform",value:function value(e){if(at(e)||!this._map.has(e))return-1;var t=this._map.get(e),n=this._calcSuccessCountOfPlatform(e)/t.totalCount*100;return(n=bt(n,2))>100&&(n=100),n;}},{key:"_calcTotalCount",value:function value(e){return at(e)||!this._map.has(e)?-1:this._map.get(e).totalCount;}},{key:"_calcSuccessCountOfBusiness",value:function value(e){return at(e)||!this._map.has(e)?-1:this._map.get(e).successCount;}},{key:"_calcSuccessCountOfPlatform",value:function value(e){if(at(e)||!this._map.has(e))return-1;var t=this._map.get(e);return t.successCount+t.failedCountOfUserSide;}},{key:"_calcAvg",value:function value(e){return at(e)||!this._map.has(e)?-1:e===Ma?this._calcAvgSpeed(e):this._calcAvgCost(e);}},{key:"_calcAvgCost",value:function value(e){var t=this._map.get(e).costArray.length;if(0===t)return 0;var n=0;return this._map.get(e).costArray.forEach(function(e){n+=e;}),parseInt(n/t);}},{key:"_calcAvgSpeed",value:function value(e){var t=0,n=0;return this._map.get(e).costArray.forEach(function(e){t+=e;}),this._map.get(e).fileSizeArray.forEach(function(e){n+=e;}),parseInt(1e3*n/t);}},{key:"getStatResult",value:function value(e){var t=this._calcTotalCount(e);if(0===t)return null;var n=this._calcSuccessCountOfBusiness(e),o=this._calcSuccessRateOfBusiness(e),s=this._calcSuccessCountOfPlatform(e),a=this._calcSuccessRateOfPlatform(e),r=this._calcAvg(e);return this.reset(e),{totalCount:t,successCountOfBusiness:n,successRateOfBusiness:o,successCountOfPlatform:s,successRateOfPlatform:a,avgValue:r};}},{key:"reset",value:function value(e){at(e)?this._map.clear():this._map.set(e,{totalCount:0,successCount:0,failedCountOfUserSide:0,costArray:[],fileSizeArray:[]});}}]),e;}(),$i=function(){function e(){o(this,e),this._lastMap=new Map(),this._currentMap=new Map();}return a(e,[{key:"initMap",value:function value(e){var t=this;e.forEach(function(e){t._lastMap.set(e,new Map()),t._currentMap.set(e,new Map());});}},{key:"addMessageSequence",value:function value(e){var t=e.key,n=e.message;if(at(t)||!this._lastMap.has(t)||!this._currentMap.has(t))return!1;var o=n.conversationID,s=n.sequence,a=o.replace(S.CONV_GROUP,"");if(0===this._lastMap.get(t).size)this._addCurrentMap(e);else if(this._lastMap.get(t).has(a)){var r=this._lastMap.get(t).get(a),i=r.length-1;s>r[0]&&s<r[i]?(r.push(s),r.sort(),this._lastMap.get(t).set(a,r)):this._addCurrentMap(e);}else this._addCurrentMap(e);return!0;}},{key:"_addCurrentMap",value:function value(e){var t=e.key,n=e.message,o=n.conversationID,s=n.sequence,a=o.replace(S.CONV_GROUP,"");this._currentMap.get(t).has(a)||this._currentMap.get(t).set(a,[]),this._currentMap.get(t).get(a).push(s);}},{key:"_copyData",value:function value(e){if(!at(e)){this._lastMap.set(e,new Map());var t,n=this._lastMap.get(e),o=D(this._currentMap.get(e));try{for(o.s();!(t=o.n()).done;){var s=v(t.value,2),a=s[0],r=s[1];n.set(a,r);}}catch(i){o.e(i);}finally{o.f();}n=null,this._currentMap.set(e,new Map());}}},{key:"getStatResult",value:function value(e){if(at(this._currentMap.get(e))||at(this._lastMap.get(e)))return null;if(0===this._lastMap.get(e).size)return this._copyData(e),null;var t=0,n=0;if(this._lastMap.get(e).forEach(function(e,o){var s=m(e.values()),a=s.length,r=s[a-1]-s[0]+1;t+=r,n+=a;}),0===t)return null;var o=bt(n/t*100,2);return o>100&&(o=100),this._copyData(e),{totalCount:t,successCountOfMessageReceived:n,successRateOfMessageReceived:o};}},{key:"reset",value:function value(){this._currentMap.clear(),this._lastMap.clear();}}]),e;}(),eu=function(e){i(s,e);var n=f(s);function s(e){var t;o(this,s),(t=n.call(this,e))._n="QualityStatModule",t.TAG="im-ssolog-quality-stat",t.reportIndex=0,t.wholePeriod=!1,t._qualityItems=[ga,_a,ha,fa,va,ma,Ma,ya,Ia,Ca],t._messageSentItems=[ha,fa,va,ma,Ma],t._messageReceivedItems=[ya,Ia,Ca],t.REPORT_INTERVAL=120,t.REPORT_SDKAPPID_BLACKLIST=[],t.REPORT_TINYID_WHITELIST=[],t._statInfoArr=[],t._avgRTT=new Qi(),t._avgE2EDelay=new Xi(),t._rateMessageSent=new Zi(),t._rateMessageReceived=new $i();var a=t.getInnerEmitterInstance();return a.on(Za,t._onLoginSuccess,_(t)),a.on($a,t._onCloudConfigUpdated,_(t)),t;}return a(s,[{key:"_onLoginSuccess",value:function value(){var e=this;this._rateMessageSent.initMap(this._messageSentItems),this._rateMessageReceived.initMap(this._messageReceivedItems);var t=this.getModule(xn),n=t.getItem(this.TAG,!1);!jt(n)&&it(n.forEach)&&(xe.l("".concat(this._n,"._onLoginSuccess get quality stat logs from local storage, count:").concat(n.length)),n.forEach(function(t){e._statInfoArr.push(t);}),t.removeItem(this.TAG,!1));}},{key:"_onCloudConfigUpdated",value:function value(){var e=this.getCloudConfig("q_rpt_interval"),t=this.getCloudConfig("q_rpt_sdkappid_bl"),n=this.getCloudConfig("q_rpt_tinyid_wl");at(e)||(this.REPORT_INTERVAL=Number(e)),at(t)||(this.REPORT_SDKAPPID_BLACKLIST=t.split(",").map(function(e){return Number(e);})),at(n)||(this.REPORT_TINYID_WHITELIST=n.split(","));}},{key:"onCheckTimer",value:function value(e){this.isLoggedIn()&&e%this.REPORT_INTERVAL==0&&(this.wholePeriod=!0,this._report());}},{key:"addRequestCount",value:function value(){this._avgRTT.addRequestCount();}},{key:"addRTT",value:function value(e){this._avgRTT.addRTT(e);}},{key:"addMessageDelay",value:function value(e){this._avgE2EDelay.addMessageDelay(e);}},{key:"addTotalCount",value:function value(e){this._rateMessageSent.addTotalCount(e)||xe.w("".concat(this._n,".addTotalCount invalid key:"),e);}},{key:"addSuccessCount",value:function value(e){this._rateMessageSent.addSuccessCount(e)||xe.w("".concat(this._n,".addSuccessCount invalid key:"),e);}},{key:"addFailedCountOfUserSide",value:function value(e){this._rateMessageSent.addFailedCountOfUserSide(e)||xe.w("".concat(this._n,".addFailedCountOfUserSide invalid key:"),e);}},{key:"addCost",value:function value(e,t){this._rateMessageSent.addCost(e,t)||xe.w("".concat(this._n,".addCost invalid key or cost:"),e,t);}},{key:"addFileSize",value:function value(e,t){this._rateMessageSent.addFileSize(e,t)||xe.w("".concat(this._n,".addFileSize invalid key or size:"),e,t);}},{key:"addMessageSequence",value:function value(e){this._rateMessageReceived.addMessageSequence(e)||xe.w("".concat(this._n,".addMessageSequence invalid key:"),e.key);}},{key:"_getQualityItem",value:function value(e){var n={},o=Ea[this.getNetworkType()];at(o)&&(o=8);var s={qualityType:Ta[e],timestamp:Ue(),networkType:o,extension:""};switch(e){case ga:n=this._avgRTT.getStatResult();break;case _a:n=this._avgE2EDelay.getStatResult();break;case ha:case fa:case va:case ma:case Ma:n=this._rateMessageSent.getStatResult(e);break;case ya:case Ia:case Ca:n=this._rateMessageReceived.getStatResult(e);}return null===n?null:t(t({},s),n);}},{key:"_report",value:function value(e){var t=this,n=[],o=null;at(e)?this._qualityItems.forEach(function(e){null!==(o=t._getQualityItem(e))&&(o.reportIndex=t.reportIndex,o.wholePeriod=t.wholePeriod,n.push(o));}):null!==(o=this._getQualityItem(e))&&(o.reportIndex=this.reportIndex,o.wholePeriod=this.wholePeriod,n.push(o)),xe.d("".concat(this._n,"._report"),n),this._statInfoArr.length>0&&(n=n.concat(this._statInfoArr),this._statInfoArr=[]);var s=this.getModule(qn),a=s.getSDKAppID(),r=s.getTinyID();wt(this.REPORT_SDKAPPID_BLACKLIST,a)&&!Ft(this.REPORT_TINYID_WHITELIST,r)&&(n=[]),n.length>0&&this._doReport(n);}},{key:"_doReport",value:function value(e){var n=this,o={header:ti(this),quality:e};this.request({protocolName:xs,requestData:t({},o)}).then(function(){n.reportIndex++,n.wholePeriod=!1;}).catch(function(t){xe.w("".concat(n._n,"._doReport, online:").concat(n.getNetworkType()," error:"),t),n._statInfoArr=n._statInfoArr.concat(e),n._flushAtOnce();});}},{key:"_flushAtOnce",value:function value(){var e=this.getModule(xn),t=e.getItem(this.TAG,!1),n=this._statInfoArr,o="".concat(this._n,"._flushAtOnce");if(jt(t))xe.l("".concat(o," count:").concat(n.length)),e.setItem(this.TAG,n,!0,!1);else{var s=n.concat(t);s.length>10&&(s=s.slice(0,10)),xe.l("".concat(o," count:").concat(s.length)),e.setItem(this.TAG,s,!0,!1);}this._statInfoArr=[];}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._report(),this.reportIndex=0,this.wholePeriod=!1,this.REPORT_SDKAPPID_BLACKLIST=[],this.REPORT_TINYID_WHITELIST=[],this._avgRTT.reset(),this._avgE2EDelay.reset(),this._rateMessageSent.reset(),this._rateMessageReceived.reset();}}]),s;}(ro),tu=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="WorkerTimerModule",s._isWorkerEnabled=!0,s._workerTimer=null,s._timerID=-1,s._init(),s.getInnerEmitterInstance().on($a,s._onCloudConfigUpdated,_(s)),s;}return a(n,[{key:"isWorkerEnabled",value:function value(){return this._isWorkerEnabled&&Se;}},{key:"startWorkerTimer",value:function value(){xe.l("".concat(this._n,".startWorkerTimer")),this._workerTimer&&this._workerTimer.postMessage("start");}},{key:"stopWorkerTimer",value:function value(){xe.l("".concat(this._n,".stopWorkerTimer")),this._workerTimer&&this._workerTimer.postMessage("stop");}},{key:"_init",value:function value(){if(Se){var e=URL.createObjectURL(new Blob(['let interval = -1;onmessage = function(event) {  if (event.data === "start") {    if (interval > 0) {      clearInterval(interval);    }    interval = setInterval(() => {      postMessage("");    }, 1000);    postMessage(interval);  } else if (event.data === "stop") {    clearInterval(interval);    interval = -1;  }};'],{type:"application/javascript; charset=utf-8"}));this._workerTimer=new Worker(e);var t=this;this._workerTimer.onmessage=function(e){e.data?(t._timerID=e.data,xe.l("".concat(t._n,"._init seed:").concat(t._timerID))):t._m.onCheckTimer();};}}},{key:"_onCloudConfigUpdated",value:function value(){var e=this.getCloudConfig("enable_worker");xe.l("".concat(this._n,"._onCloudConfigUpdated enableWorker:").concat(e)),at(e)||"1"===e?!this._isWorkerEnabled&&Se&&(this._isWorkerEnabled=!0,this.startWorkerTimer(),this._m.onWorkerTimerEnabled()):this._isWorkerEnabled&&Se&&(this._isWorkerEnabled=!1,this.stopWorkerTimer(),this._m.onWorkerTimerDisabled());}},{key:"terminate",value:function value(){xe.l("".concat(this._n,".terminate")),this._workerTimer&&(this._workerTimer.terminate(),this._workerTimer=null,this._timerID=-1);}},{key:"getTimerID",value:function value(){return this._timerID;}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset"));}}]),n;}(ro),nu=function(){function e(){o(this,e),this._n="PurchasedFeatureHandler",this._purchasedFeatureMap=new Map();}return a(e,[{key:"isValidPurchaseBits",value:function value(e){return e&&"string"==typeof e&&e.length>=1&&e.length<=64&&/[01]{1,64}/.test(e);}},{key:"parsePurchaseBits",value:function value(e){if(this.isValidPurchaseBits(e)){this._purchasedFeatureMap.clear();for(var t=null,n=e.length-1,o=0;n>=0;n--,o++){t=o<32?new L(0,Math.pow(2,o)).toString():new L(Math.pow(2,o-32),0).toString(),"1"===e[n]?this._purchasedFeatureMap.set(t,!0):this._purchasedFeatureMap.set(t,!1);}}else xe.w("".concat(this._n,".parsePurchaseBits invalid purchasebits:").concat(e));}},{key:"hasPurchasedFeature",value:function value(e){return!!this._purchasedFeatureMap.get(e);}},{key:"isFeatureEnabled",value:function value(e){for(var t=parseInt(e).toString(2),n=void 0,o=!0,s=t.length-1,a=0;s>=0;s--,a++){if("1"===t.charAt(s)&&(n=a<32?new L(0,Math.pow(2,a)).toString():new L(Math.pow(2,a-32),0).toString(),!this._purchasedFeatureMap.get(n))){o=!1;break;}}return xe.l("".concat(this._n,".isFeatureEnabled decimalNumber:").concat(e," binaryString:").concat(t," ret:").concat(o)),za({enabled:o});}},{key:"clear",value:function value(){this._purchasedFeatureMap.clear();}}]),e;}(),ou=function(){function e(t){o(this,e),this._m=t,this._n="CommercialConfigModule",this._expiredTime=0,this._isFetching=!1,this._purchasedFeatureHandler=new nu();}return a(e,[{key:"_canFetch",value:function value(){return this._getModule(qn).isLoggedIn()?!this._isFetching&&Date.now()>=this._expiredTime:(this._expiredTime=Date.now()+2e3,!1);}},{key:"onCheckTimer",value:function value(e){this._canFetch()&&this.fetchConfig();}},{key:"fetchConfig",value:function value(){var e=this,t=this._canFetch(),n="".concat(this._n,".fetchConfig");if(xe.l("".concat(n," canFetch:").concat(t)),t){var o=this._getModule(Bn),s=new ka("fetchCommercialConfig");s.setNetworkType(o.getNetworkType());var a=this._getModule(qn).getSDKAppID(),r=this._getModule(jn);this._isFetching=!0,r.request({protocolName:Xs,requestData:{SDKAppID:a}}).then(function(t){s.setMessage("purchaseBits:".concat(t.data.purchaseBits)).end(),xe.l("".concat(n," ok.")),e._parseConfig(t.data),e._isFetching=!1;}).catch(function(t){o.probe().then(function(e){var n=v(e,2),o=n[0],a=n[1];s.setError(t,o,a).end();}),e._isFetching=!1;});}}},{key:"onPushedConfig",value:function value(e){var t="".concat(this._n,".onPushedConfig data:").concat(JSON.stringify(e));xe.l("".concat(t)),new ka("pushedCommercialConfig").setNetworkType(this._getModule(Bn).getNetworkType()).setMessage("purchaseBits:".concat(e.purchaseBits)).end(),this._parseConfig(e);}},{key:"_parseConfig",value:function value(e){var t="".concat(this._n,"._parseConfig"),n=e.errorCode,o=e.errorMessage,s=e.purchaseBits,a=e.expiredTime;0===n?(this._purchasedFeatureHandler.parsePurchaseBits(s),this._expiredTime=Date.now()+1e3*a):at(n)?(xe.l("".concat(t," failed. Invalid message format:"),e),this._setExpiredTimeOnResponseError(36e5)):(xe.e("".concat(t," errorCode:").concat(n," errorMessage:").concat(o)),this._setExpiredTimeOnResponseError(12e4));}},{key:"_setExpiredTimeOnResponseError",value:function value(e){this._expiredTime=Date.now()+e;}},{key:"canIUse",value:function value(e){return this._purchasedFeatureHandler.hasPurchasedFeature(e);}},{key:"isFeatureEnabled",value:function value(e){return this._purchasedFeatureHandler.isFeatureEnabled(e);}},{key:"_getModule",value:function value(e){return this._m.getModule(e);}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._expiredTime=0,this._isFetching=!1,this._purchasedFeatureHandler.clear();}}]),e;}(),su=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._m=e,s._n="OfflinePushModule",s._offlinePushPlugin=void 0,s._androidPushConfig={huaweiPushBussinessId:"",xiaomiPushBussinessId:"",xiaomiPushAppId:"",xiaomiPushAppKey:"",meizuPushBussinessId:"",meizuPushAppId:"",meizuPushAppKey:"",vivoPushBussinessId:"",fcmPushBussinessId:"",oppoPushBussinessId:"",oppoPushAppKey:"",oppoPushAppSecret:"",honorPushBussinessId:""},s._deviceToken="",s._businessID=0,s._iosBusinessID=0,s._c2cUnreadCount=0,s._groupUnreadCount=0,s._isWebUniapp=0,s;}return a(n,[{key:"registerPlugin",value:function value(e){if(ne){this._offlinePushPlugin=e["tim-offline-push-plugin"];var t=e.offlinePushConfig||{},n=t.huaweiBusinessID,o=t.xiaomiBusinessID,s=t.xiaomiAppID,a=t.xiaomiAppKey,r=t.meizuBusinessID,i=t.meizuAppID,u=t.meizuAppKey,c=t.vivoBusinessID,l=t.oppoBusinessID,p=t.oppoAppKey,d=t.oppoAppSecret,g=t.honorBusinessID,_=t.iosBusinessID;this._androidPushConfig.huaweiPushBussinessId=n,this._androidPushConfig.xiaomiPushBussinessId=o,this._androidPushConfig.xiaomiPushAppId=s,this._androidPushConfig.xiaomiPushAppKey=a,this._androidPushConfig.meizuPushBussinessId=r,this._androidPushConfig.meizuPushAppId=i,this._androidPushConfig.meizuPushAppKey=u,this._androidPushConfig.vivoPushBussinessId=c,this._androidPushConfig.oppoPushBussinessId=l,this._androidPushConfig.oppoPushAppKey=p,this._androidPushConfig.oppoPushAppSecret=d,this._androidPushConfig.honorPushBussinessId=g,new ka("registerPlugin").setMessage("tim-offline-push-plugin").setMoreMessage("isExist:".concat(!at(this._offlinePushPlugin))).end(!0),xe.l("".concat(this._n,".").concat("registerPlugin"," ok. offlinePushConfig:").concat(JSON.stringify(e.offlinePushConfig))),this._iosBusinessID=_,this._setAppShowListener();}else this.outputWarning("OfflinePushInUniapp");}},{key:"init",value:function value(){this._isWebUniapp=this.getUniAppPlatform(),this._getDeviceToken();}},{key:"_getDeviceToken",value:function value(){var e=this,t="".concat(this._n,".").concat("_getDeviceToken");if(it(this._offlinePushPlugin.getDeviceToken)){var n="androidPushConfig:".concat(JSON.stringify(this._androidPushConfig),", iosBusinessID:").concat(this._iosBusinessID);xe.l("".concat(t," start. ").concat(n)),new ka("_getDeviceToken").setMessage("".concat(n)).end(!0),this._offlinePushPlugin.getDeviceToken(this._androidPushConfig,function(o){var s=new ka("getDeviceTokenRes"),a=o.code,r=o.msg;if(0===a){var i=o.data,u=i.deviceToken,c=i.deviceBrand,l=i.deviceType,p=i.bussinessId;e._deviceToken=u,e._businessID=p||e._iosBusinessID,n="deviceToken:".concat(u,", deviceBrand:").concat(c||l,", businessID:").concat(e._businessID),xe.l("".concat(t," ok. ").concat(n)),s.setMessage(n).end(!0),e._setToken();}else s.setMessage("code:".concat(a,", msg:").concat(r)).end(!0),xe.e("".concat(t," failed. error:"),o);});}else xe.e("".concat(t," getDeviceToken is not a function"));}},{key:"canIUseOfflinePush",value:function value(){return ne&&!at(this._offlinePushPlugin);}},{key:"_setAppShowListener",value:function value(){var e=this,t="".concat(this._n,".").concat("_setAppShowListener");at(this._offlinePushPlugin)?xe.e("".concat(t," offlinePushPlugin is undefined")):it(this._offlinePushPlugin.setAppShowListener)?(new ka("_setAppShowListener").end(!0),xe.l("".concat(t," start")),this._offlinePushPlugin.setAppShowListener(function(n){var o=(n||{}).appShow;new ka("setAppShowListenerRes").setMessage("appShow:".concat(o)).end(!0),xe.l("".concat(t," ok. appShow:").concat(o)),e._m.isReady()&&(0===o?(e._getConvUnreadCount(),e._onBackground()):1===o&&e._onForeground());})):xe.e("".concat(t," setAppShowListener is not a function"));}},{key:"getDeviceBrand",value:function value(){if(!at(this._offlinePushPlugin)&&it(this._offlinePushPlugin.getDeviceType)){var e=(this._offlinePushPlugin.getDeviceType()||{}).deviceType;return xe.l("".concat(this._n,".getDeviceBrand ok. deviceType:").concat(e)),e;}}},{key:"_setToken",value:function value(){var e,t=this,n="".concat(this._n,"._setToken"),o=this.getModule(qn),s=1,a="",r="";jt(this._deviceToken)&&(s=0);var i=this.getUniAppPlatform(),u=this.getDeviceBrand();i===R.IOS||i===R.IPAD||i===R.MAC?r=this._deviceToken:i===R.ANDROID&&(a=this._deviceToken);var c=new ka("offlinePushSetToken");return e="deviceToken:".concat(r||a,", businessID:").concat(this._businessID,", ")+"deviceBrand:".concat(u,", isWebUniapp:").concat(this._isWebUniapp,", pushMsg:").concat(s,", platform:").concat(i),c.setMessage("".concat(e)),xe.l("".concat(n," ").concat(e)),this.request({protocolName:ca,requestData:{tokenID:a,pushMsg:s,sdkAppID:o.getSDKAppID(),businessID:parseInt(this._businessID),deviceBrand:u,deviceToken:r,isWebUniapp:this._isWebUniapp}}).then(function(e){return c.end(),xe.l("".concat(n," ok")),e;}).catch(function(e){return t.probeNetwork().then(function(t){var n=v(t,2),o=n[0],s=n[1];c.setError(e,o,s).end();}),xe.e("".concat(n," failed. error:"),e),Ja(e);});}},{key:"_getConvUnreadCount",value:function value(){var e=this;this._c2cUnreadCount=0,this._groupUnreadCount=0,this.getModule(Fn).getLocalConversationList().forEach(function(t){t.type===S.CONV_C2C&&(e._c2cUnreadCount+=t.unreadCount),t.type===S.CONV_GROUP&&(e._groupUnreadCount+=t.unreadCount);});}},{key:"_onBackground",value:function value(){var e=this,t="".concat(this._n,".").concat("_onBackground"),n=new ka("_onBackground");this.request({protocolName:ia,requestData:{c2cUnreadCount:this._c2cUnreadCount,groupUnreadCount:this._groupUnreadCount,isWebUniapp:this._isWebUniapp}}).then(function(o){return n.setMessage("c2cUnreadCount: ".concat(e._c2cUnreadCount,", groupUnreadCount: ").concat(e._groupUnreadCount)).end(),xe.l("".concat(t," ok")),o;}).catch(function(o){e.probeNetwork().then(function(e){var t=v(e,2),s=t[0],a=t[1];n.setError(o,s,a).end();}),xe.e("".concat(t," failed. error:"),o);});}},{key:"_onForeground",value:function value(){var e=this,t="".concat(this._n,".").concat("_onForeground"),n=new ka("_onForeground");this.request({protocolName:ua,requestData:{isWebUniapp:this._isWebUniapp}}).then(function(e){return n.end(),xe.l("".concat(t," ok")),e;}).catch(function(o){e.probeNetwork().then(function(e){var t=v(e,2),s=t[0],a=t[1];n.setError(o,s,a).end();}),xe.e("".concat(t," failed. error:"),o);});}},{key:"getUniAppPlatform",value:function value(){var e=uni.getSystemInfoSync().platform,t=this.getDeviceBrand();return"ios"===e?R.IOS:"android"===e?R.ANDROID:1002===t?R.IPAD:1001===t?R.MAC:void 0;}},{key:"reset",value:function value(){this._deviceToken="",this._businessID=0,this._c2cUnreadCount=0,this._groupUnreadCount=0,this._isWebUniapp=0,xe.l("".concat(this._n,".reset"));}}]),n;}(ro),au=function(e){i(n,e);var t=f(n);function n(e){var s;return o(this,n),(s=t.call(this,e))._n="ProfanityFilterModule",s._plugin=null,s._filterConfigMap=new Map(),s._startIndex=0,s._version=0,s._canIUseLexicon=!1,s._isFetching=!1,s._expiredTime=0,s;}return a(n,[{key:"init",value:function value(){var e=this.getModule(Wn).getPlugin("tim-profanity-filter-plugin");e?(this._plugin=new e({logger:xe,isArray:st,isMap:Qe,isDevMode:this.isDevMode()}),this._getLexicon()):this.outputWarning("ProfanityPluginNotFound");}},{key:"onCheckTimer",value:function value(){this._plugin&&this._canIUseLexicon&&this.isLoggedIn()&&!this._isFetching&&Date.now()>=this._expiredTime&&this._getLexicon();}},{key:"filterMessage",value:function value(e,t){var n=!0;if(!this._plugin||!this._canIUseLexicon)return n;if(t&&t.messageControlInfo&&!0===t.messageControlInfo.excludedFromContentModeration)return n;var o=e.type,s=e.conversationType;if(o!==S.MSG_TEXT&&o!==S.MSG_CUSTOM)return n;var a,r="".concat(this._n,".filterMessage");if(xe.l("".concat(r)),o===S.MSG_TEXT){if(s===S.CONV_C2C?a=H:s===S.CONV_GROUP&&(a=W),!this._isConfigOn(a))return n;var i=this._plugin.filter(e.payload.text),u=i.type,c=i.modifiedText;1===u?n=!1:2===u&&(e.payload.text=c);}else if(o===S.MSG_CUSTOM){if(s===S.CONV_C2C?a=K:s===S.CONV_GROUP&&(a=Y),!this._isConfigOn(a))return n;var l=this._plugin.filter(e.payload.data),p=this._plugin.filter(e.payload.description),d=this._plugin.filter(e.payload.extension);1===l.type||1===p.type||1===d.type?n=!1:(2===l.type&&(e.payload.data=l.modifiedText),2===p.type&&(e.payload.description=p.modifiedText),2===d.type&&(e.payload.extension=d.modifiedText));}return xe.l("".concat(r," done. isAllowedToSend:").concat(n)),n;}},{key:"filterText",value:function value(e,t){var n="".concat(this._n,".filterText"),o={isAllowedToSend:!0,modifiedText:e};if(!this._plugin||!this._canIUseLexicon)return o;if(!this._isConfigOn(t))return o;xe.l("".concat(n));var s=this._plugin.filter(e),a=s.type,r=s.modifiedText;return 1===a?o.isAllowedToSend=!1:2===a&&(o.modifiedText=r),xe.l("".concat(n," done. ret:"),o),o;}},{key:"_getLexicon",value:function value(){var e=this,t=new ka("profanityFilter"),n="".concat(this._n,"._getLexicon");this._isFetching=!0,this.request({protocolName:la,requestData:{startIndex:this._startIndex,version:this._version}}).then(function(o){var s=o.data,a=s.errorInfo,r=s.filterConfig,i=s.lexicon,u=s.strToken,c=s.completeFlag,l=s.nextStartIndex,p=s.version,d=s.expiredTime,g=a.errorCode,_=a.errorMessage;return 0!==g?(e._isFetching=!1,xe.w("".concat(n," failed. error:"),a),void t.setCode(g).setMessage(_).end()):(e._onFilterConfig(r),e._getToken(u),1===c?(xe.l("".concat(n," done. version:").concat(p," expiredTime:").concat(d)),e._version=p,e._canIUseLexicon=!0,e._isFetching=!1,e._expiredTime=Date.now()+1e3*d,void e._plugin.onLexiconCompleted(i)):(e._startIndex=l,e._plugin.onLexiconSliced(i),void e._getLexicon()));}).catch(function(o){e.probeNetwork().then(function(e){var n=v(e,2),s=n[0],a=n[1];t.setError(o,s,a).end();}),e._isFetching=!1,xe.l("".concat(n," failed. error:"),o);});}},{key:"_onFilterConfig",value:function value(e){var t=this;jt(e)||(this._filterConfigMap.clear(),Object.keys(e).forEach(function(n){t._filterConfigMap.set(n,e[n]);}),xe.l("".concat(this._n,"._onFilterConfig. keys:").concat(Array.from(this._filterConfigMap.keys())," values:").concat(Array.from(this._filterConfigMap.values()))));}},{key:"_isConfigOn",value:function value(e){return 1===this._filterConfigMap.get(e);}},{key:"_getToken",value:function value(e){if(et(e)){var t=e.length,n="";if(t%2==0)for(var o=0;o<=t-1;o+=2){n+=e[o+1],n+=e[o];}else{for(var s=0;s<t-1;s+=2){n+=e[s+1],n+=e[s];}n+=e[t-1];}this._plugin.onToken(n);}}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),this._plugin&&(this._plugin.reset(),this._plugin=null),this._filterConfigMap.clear(),this._startIndex=0,this._version=0,this._canIUseLexicon=!1,this._isFetching=!1,this._expiredTime=0;}}]),n;}(ro),ru=function(){function e(t){o(this,e),this._m=t,this._n="TransCmdModule",this._TRTCCommandList=["tui_room_svr.*"],this._m.getInnerEmitterInstance().on($a,this._onCloudConfigUpdated,this);}return a(e,[{key:"_onCloudConfigUpdated",value:function value(){var e=this,t=this._m.getModule(Xn).getCloudConfig("rtc_cmd");at(t)||(t=JSON.parse(t)).forEach(function(t){e._TRTCCommandList.includes(t)||e._TRTCCommandList.push(t);});}},{key:"sendTRTCCustomData",value:function value(e){var t=e.serviceCommand,n=e.data,o="".concat(V.NAME.TUIROOM_SVR,".*");return at(t)||(o=t),this._TRTCCommandList.includes(o)?this._trans({servcmd:o,data:n}):Ja({code:da.INVALID_TRTC_CMD});}},{key:"_trans",value:function value(e){xe.d("".concat(this._n,"._trans. options:").concat(JSON.stringify(e)));var t=e.servcmd,n=e.data;return this._m.getModule(jn).trans({servcmd:t,data:et(n)?JSON.parse(n):n});}},{key:"getCommandList",value:function value(){return this._TRTCCommandList;}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset"));}}]),e;}(),iu=function(){function e(t){o(this,e),this._m=t,this._n="ErrorMessageModule",this.TIM_ERROR_ASSISTANCE="tim_error_assistance",this.STORAGE_EXPIRES_TIME=6048e5,this._map=new Map(),this._init();}return a(e,[{key:"_init",value:function value(){var e=this._getStorageModule().getItem(this.TIM_ERROR_ASSISTANCE,!1);if(e){var t;try{t=JSON.parse(e);}catch(n){this._getStorageModule().removeItem(this.TIM_ERROR_ASSISTANCE,!1),xe.w("".concat(this._n,"._init error:"),n);}t&&(this._needToUpdate(t)?this._fetch():this._fillMap(t.message));}else this._fetch();}},{key:"_needToUpdate",value:function value(e){var t=e.localSavedTime,n=e.localSavedVersion,o=t&&new Date().getTime()-t>=this.STORAGE_EXPIRES_TIME,s=!n||"2.27.5"!==n;return xe.l("".concat(this._n,"._needToUpdate isTimeout:").concat(o," isDifferentVersion:").concat(s)),o||s;}},{key:"_fetch",value:function value(){if(!this._m.getModule(qn).isPrivateNetWork()){var e="https://web.sdk.qcloud.com/im/download/error-message/0.0.1/tim-error-message.txt",t="application/x-www-form-urlencoded;charset=UTF-8",n="".concat(this._n,"._fetch ok in"),o=this;if(se)re.request({url:e,method:"GET",timeout:3e3,header:{"content-type":t},dataType:"text",success:function success(e){o._fillAndSave(e.data),xe.l("".concat(n," mini program"));},fail:function fail(){}});else{var s=new XMLHttpRequest(),a=setTimeout(function(){s.abort();},3e3);s.onreadystatechange=function(){4===s.readyState&&(clearTimeout(a),200!==s.status&&304!==s.status||(xe.l("".concat(n," browser")),o._fillAndSave(s.responseText)));},s.open("GET",e,!0),s.setRequestHeader("Content-type",t),s.send();}}}},{key:"_fillAndSave",value:function value(e){this._fillMap(e),this._getStorageModule().setItem(this.TIM_ERROR_ASSISTANCE,JSON.stringify({message:e,localSavedTime:new Date().getTime(),localSavedVersion:"2.27.5"}),!0,!1);}},{key:"_getStorageModule",value:function value(){return this._m.getModule(xn);}},{key:"_fillMap",value:function value(e){this._map.clear();for(var t,n,o,s=e.split(";\n"),a=s.length,r=new RegExp(/'/g),i=0;i<a;i++){if(t=s[i].indexOf(":"),n=s[i].slice(0,t),o=s[i].slice(t+1,s[i].length),!n.startsWith("//")){if(at(o))continue;this._map.set(n,o.replace(r,""));}}}},{key:"get",value:function value(e){var t=e.isIntl,n=e.key,o=e.replacement1,s=e.replacement2,a="".concat(n,t?"_en":"_cn");!this._map.has(a)&&this._map.has(n)&&(a=n);var r="";return this._map.has(a)?(r=this._map.get(a),at(o)||(r=r.replace("$replacement1",o)),at(s)||(r=r.replace("$replacement2",s)),r):r;}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset"));}}]),e;}(),uu=function(){function e(t){o(this,e);var n=new ka("sdkConstruct");this._n="ModuleManager",this._isReady=!1,this._reason=da.USER_NOT_LOGGED_IN,this._startLoginTs=0,this._moduleMap=new Map(),this._innerEmitter=null,this._outerEmitter=null,this._checkCount=0,this._checkTimer=-1,this._moduleMap.set(qn,new Xr(this,t)),this._moduleMap.set(eo,new ou(this)),this._moduleMap.set(Xn,new zi(this)),this._moduleMap.set(Qn,new tu(this)),this._moduleMap.set($n,new eu(this)),this._moduleMap.set(zn,new qi(this)),this._moduleMap.set(jn,new Yi(this)),this._moduleMap.set(An,new Qr(this)),this._moduleMap.set(Rn,new fi(this)),this._moduleMap.set(Nn,new vi(this)),this._moduleMap.set(so,new mi(this)),this._moduleMap.set(On,new Jr(this)),this._moduleMap.set(Gn,new Xa(this)),this._moduleMap.set(Fn,new vr(this)),this._moduleMap.set(Un,new wr(this)),this._moduleMap.set(bn,new qr(this)),this._moduleMap.set(wn,new Hr(this)),this._moduleMap.set(xn,new $r(this)),this._moduleMap.set(ao,new iu(this)),this._moduleMap.set(Vn,new ni(this)),this._moduleMap.set(Bn,new ri(this)),this._moduleMap.set(Hn,new ui(this)),this._moduleMap.set(Kn,new li(this)),this._moduleMap.set(Wn,new Mi(this)),this._moduleMap.set(Yn,new yi(this)),this._moduleMap.set(Jn,new ji(this)),this._moduleMap.set(Zn,new Ji(this)),this._moduleMap.set(to,new su(this)),this._moduleMap.set(no,new au(this)),this._moduleMap.set(oo,new ru(this)),this._eventThrottleMap=new Map();var s=t.instanceID,a=t.oversea,r=t.SDKAppID,i="instanceID:".concat(s," SDKAppID:").concat(r," host:").concat(Nt()," oversea:").concat(a," inBrowser:").concat(ae," inMiniApp:").concat(se)+" workerAvailable:".concat(Se," UserAgent:").concat(ie);ka.bindEventStatModule(this._moduleMap.get(Vn)),n.setMessage("".concat(i," ").concat(function(){var e="";if(se)try{var t=re.getSystemInfoSync(),n=t.model,o=t.version,s=t.system,a=t.platform,r=t.SDKVersion;e="model:".concat(n," version:").concat(o," system:").concat(s," platform:").concat(a," SDKVersion:").concat(r);}catch(i){e="";}return e;}())).end(),xe.i("SDK ".concat(i)),Wa.prototype._getErrorMessage=this.getErrorMessage.bind(this),this._readyList=void 0,this._ssoLogForReady=null,this._initReadyList();}return a(e,[{key:"_startTimer",value:function value(){var e=this._moduleMap.get(Qn),t=e.isWorkerEnabled();xe.l("".concat(this._n,".startTimer isWorkerEnabled:").concat(t," seed:").concat(this._checkTimer)),t?e.startWorkerTimer():this._startMainThreadTimer();}},{key:"_startMainThreadTimer",value:function value(){this._checkTimer<0&&(this._checkTimer=setInterval(this.onCheckTimer.bind(this),1e3)),xe.l("".concat(this._n,"._startMainThreadTimer seed:").concat(this._checkTimer));}},{key:"stopTimer",value:function value(){var e=this._moduleMap.get(Qn),t=e.isWorkerEnabled();xe.l("".concat(this._n,".stopTimer isWorkerEnabled:").concat(t," seed:").concat(this._checkTimer)),t?e.stopWorkerTimer():this._stopMainThreadTimer();}},{key:"_stopMainThreadTimer",value:function value(){xe.l("".concat(this._n,"._stopMainThreadTimer")),this._checkTimer>0&&(clearInterval(this._checkTimer),this._checkTimer=-1,this._checkCount=0);}},{key:"_stopMainThreadSocket",value:function value(){xe.l("".concat(this._n,"._stopMainThreadSocket"));var e=this._moduleMap.get(zn);e.setIsWorkerEnabled(!0),e.reConnect();}},{key:"_startMainThreadSocket",value:function value(){xe.l("".concat(this._n,"._startMainThreadSocket"));var e=this._moduleMap.get(zn);e.setIsWorkerEnabled(!1),e.reConnect();}},{key:"onWorkerTimerEnabled",value:function value(){xe.l("".concat(this._n,".onWorkerTimerEnabled, disable main thread timer and socket")),this._stopMainThreadTimer(),this._stopMainThreadSocket();}},{key:"onWorkerTimerDisabled",value:function value(){xe.l("".concat(this._n,".onWorkerTimerDisabled, enable main thread timer and socket")),this._startMainThreadTimer(),this._startMainThreadSocket();}},{key:"onCheckTimer",value:function value(){this._checkCount+=1;var e,t=D(this._moduleMap);try{for(t.s();!(e=t.n()).done;){var n=v(e.value,2)[1];n.onCheckTimer&&n.onCheckTimer(this._checkCount);}}catch(o){t.e(o);}finally{t.f();}}},{key:"_initReadyList",value:function value(){var e=this;this._readyList=[this._moduleMap.get(An),this._moduleMap.get(Fn)],this._readyList.forEach(function(t){t.ready(function(){return e._onModuleReady();});});}},{key:"_onModuleReady",value:function value(){var e=!0;if(this._readyList.forEach(function(t){t.isReady()||(e=!1);}),e&&!this._isReady){this._isReady=!0,this._outerEmitter.emit(E.SDK_READY);var t=Date.now()-this._startLoginTs;xe.w("SDK is ready. cost ".concat(t," ms")),this._startLoginTs=Date.now();var n=this._moduleMap.get(Bn).getNetworkType(),o=this._ssoLogForReady.getStartTs()+Ge;this._ssoLogForReady.setNetworkType(n).setMessage(t).start(o).end();}}},{key:"login",value:function value(){0===this._startLoginTs&&(Pe(),this._startLoginTs=Date.now(),this._startTimer(),this._moduleMap.get(Bn).start(),this._ssoLogForReady=new ka("sdkReady"),this._reason=da.LOGGING_IN);}},{key:"onLoginFailed",value:function value(){this._startLoginTs=0;}},{key:"getOuterEmitterInstance",value:function value(){return null===this._outerEmitter&&(this._outerEmitter=new ii(),ja(this._outerEmitter),this._outerEmitter._emit=this._outerEmitter.emit,this._outerEmitter.emit=function(e,t){var n=this;if(e===E.CONVERSATION_LIST_UPDATED||e===E.FRIEND_LIST_UPDATED||e===E.GROUP_LIST_UPDATED||e===E.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED){if(this._eventThrottleMap.has(e)){var o=Date.now(),s=this._eventThrottleMap.get(e);o-s.last<=1e3?(s.timeoutID&&clearTimeout(s.timeoutID),s.timeoutID=setTimeout(function(){s.last=Date.now(),n._outerEmitter._emit.apply(n._outerEmitter,[e,{name:e,data:n._getEventData(e)}]);},1e3)):(s.last=o,this._outerEmitter._emit.apply(this._outerEmitter,[e,{name:e,data:this._getEventData(e)}]));}else this._eventThrottleMap.set(e,{last:Date.now(),timeoutID:-1}),this._outerEmitter._emit.apply(this._outerEmitter,[e,{name:e,data:this._getEventData(e)}]);}else this._outerEmitter._emit.apply(this._outerEmitter,[e,{name:e,data:arguments[1]}]);}.bind(this)),this._outerEmitter;}},{key:"_getEventData",value:function value(e){return e===E.CONVERSATION_LIST_UPDATED?this._moduleMap.get(Fn).getLocalConversationList():e===E.FRIEND_LIST_UPDATED?this._moduleMap.get(Pn).getLocalFriendList(!1):e===E.GROUP_LIST_UPDATED?this._moduleMap.get(Un).getLocalGroupList():e===E.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED?this._moduleMap.get(Fn).getTotalUnreadMessageCount():void 0;}},{key:"getInnerEmitterInstance",value:function value(){return null===this._innerEmitter&&(this._innerEmitter=new ii(),this._innerEmitter._emit=this._innerEmitter.emit,this._innerEmitter.emit=function(e,t){var n;n=ot(arguments[1])&&arguments[1].data?[e,{name:arguments[0],data:arguments[1].data}]:[e,{name:arguments[0],data:arguments[1]}],this._innerEmitter._emit.apply(this._innerEmitter,n);}.bind(this)),this._innerEmitter;}},{key:"hasModule",value:function value(e){return this._moduleMap.has(e);}},{key:"getModule",value:function value(e){return this._moduleMap.get(e);}},{key:"isReady",value:function value(){return this._isReady;}},{key:"isIntl",value:function value(){return this.getModule(qn).isIntl();}},{key:"getNotReadyReason",value:function value(){return this._reason;}},{key:"setNotReadyReason",value:function value(e){this._reason=e;}},{key:"getErrorMessage",value:function value(e,t,n){return this._moduleMap.get(ao).get({key:e,replacement1:t,replacement2:n,isIntl:this.isIntl()});}},{key:"outputWarning",value:function value(e,t,n){var o=this.getErrorMessage(e,t,n);o&&xe.w(o);}},{key:"onError",value:function value(e){var t="code:".concat(e.code," message:").concat(e.message);xe.w("Oops! ".concat(t)),new ka("error").setMessage(t).setNetworkType(this.getModule(Bn).getNetworkType()).setLevel("error").end(),this.getOuterEmitterInstance().emit(E.ERROR,e);}},{key:"restartTimer",value:function value(){xe.l("".concat(this._n,".restartTimer")),this.stopTimer(),this._startTimer(),this.getModule(Un).restartPolling();}},{key:"getTimerID",value:function value(){var e=this._moduleMap.get(Qn);return e.isWorkerEnabled()?e.getTimerID():this._checkTimer;}},{key:"getPollingTimerID",value:function value(e){return this._moduleMap.get(Un).getPollingTimerID(e);}},{key:"reset",value:function value(){xe.l("".concat(this._n,".reset")),Pe();var e,t=D(this._moduleMap);try{for(t.s();!(e=t.n()).done;){var n=v(e.value,2)[1];n.reset&&n.reset();}}catch(r){t.e(r);}finally{t.f();}this._startLoginTs=0,this._initReadyList(),this._isReady=!1,this.stopTimer(),this._outerEmitter.emit(E.SDK_NOT_READY);var o,s=D(this._eventThrottleMap);try{for(s.s();!(o=s.n()).done;){var a=v(o.value,2)[1];a.timeoutID&&clearTimeout(a.timeoutID);}}catch(r){s.e(r);}finally{s.f();}this._eventThrottleMap.clear();}}]),e;}(),cu=function(){function e(t){o(this,e),this._funcMap=new Map(),this._m=t;}return a(e,[{key:"defense",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;if("string"!=typeof e)return null;if(0===e.length)return null;if("function"!=typeof t)return null;if(this._funcMap.has(e)&&this._funcMap.get(e).has(t))return this._funcMap.get(e).get(t);this._funcMap.has(e)||this._funcMap.set(e,new Map());var o=null;return this._funcMap.get(e).has(t)?o=this._funcMap.get(e).get(t):(o=this._pack(e,t,n),this._funcMap.get(e).set(t,o)),o;}},{key:"defenseOnce",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;return"function"!=typeof t?null:this._pack(e,t,n);}},{key:"find",value:function value(e,t){return"string"!=typeof e||0===e.length||"function"!=typeof t?null:this._funcMap.has(e)&&this._funcMap.get(e).has(t)?this._funcMap.get(e).get(t):(this._m.outputWarning("ListenerFnNotFound",e),null);}},{key:"delete",value:function value(e,t){return"function"==typeof t&&!!this._funcMap.has(e)&&!!this._funcMap.get(e).has(t)&&(this._funcMap.get(e).delete(t),0===this._funcMap.get(e).size&&this._funcMap.delete(e),!0);}},{key:"_pack",value:function value(e,t,n){var o=this;return function(){try{t.apply(n,Array.from(arguments));}catch(u){var s=Object.values(E).indexOf(e),a="CallbackError";if(-1!==s){var r=Object.keys(E)[s];o._m.outputWarning(a,r,u);}var i=new ka(a);i.setMessage("eventName:".concat(e)).setMoreMessage(u.message).end();}};}}]),e;}(),lu=function(){function e(t){o(this,e);var n={SDKAppID:t.SDKAppID,unlimitedAVChatRoom:t.unlimitedAVChatRoom||!1,scene:t.scene||"",oversea:t.oversea||!1,instanceID:Rt(),devMode:t.devMode||!1,proxyServer:t.proxyServer||void 0,fileUploadProxy:t.fileUploadProxy||void 0,fileDownloadProxy:t.fileDownloadProxy||t.fileUploadProxy||void 0};this._m=new uu(n),this._safetyCallbackFactory=new cu(this._m);}return a(e,[{key:"onError",value:function value(e){this._m.onError(e);}},{key:"login",value:function value(e){return this._m.login(),this._getModule(An).login(e);}},{key:"logout",value:function value(){var e=this;return this._getModule(An).logout().then(function(t){return e._m.reset(),t;});}},{key:"isReady",value:function value(){return this._m.isReady();}},{key:"isIntl",value:function value(){return this._m.isIntl();}},{key:"getNotReadyReason",value:function value(){return this._m.getNotReadyReason();}},{key:"getErrorMessage",value:function value(e,t,n){return this._m.getErrorMessage(e,t,n);}},{key:"_getModule",value:function value(e){return this._m.getModule(e);}},{key:"destroy",value:function value(){var e=this;return this.logout().finally(function(){e._m.stopTimer(),e._getModule(Qn).terminate(),e._getModule(zn).dealloc();var t=e._m.getOuterEmitterInstance(),n=e._getModule(qn);t.emit(E.SDK_DESTROY,{SDKAppID:n.getSDKAppID()});});}},{key:"on",value:function value(e,t,n){xe.d("on","eventName:".concat(e)),this._m.getOuterEmitterInstance().on(e,this._safetyCallbackFactory.defense(e,t,n),n);}},{key:"once",value:function value(e,t,n){xe.d("once","eventName:".concat(e)),this._m.getOuterEmitterInstance().once(e,this._safetyCallbackFactory.defenseOnce(e,t,n),n||this);}},{key:"off",value:function value(e,t,n,o){xe.d("off","eventName:".concat(e));var s=this._safetyCallbackFactory.find(e,t);null!==s&&(this._m.getOuterEmitterInstance().off(e,s,n,o),this._safetyCallbackFactory.delete(e,t));}},{key:"registerPlugin",value:function value(e){at(e["tim-offline-push-plugin"])?this._getModule(Wn).registerPlugin(e):this._getModule(to).registerPlugin(e);}},{key:"setLogLevel",value:function value(e){if(e<=0){var t=this.getErrorMessage("TIM_ASCII_ART");t&&console.log(t);var n=this.getErrorMessage("API_REFER");if(n){Ht()?console.log("%c ".concat("IM SDK API ->"," %c"),"background:#ff9d00; padding:1px; border-radius:3px; color: #fff","background:transparent",n):console.log("IM SDK API ->",n);}var o=this.getErrorMessage("DOCS_GUIDE");o&&console.log(o);}xe.setLevel(e);}},{key:"createTextMessage",value:function value(e){return this._getModule(Rn).createTextMessage(e);}},{key:"createTextAtMessage",value:function value(e){return this._getModule(Rn).createTextMessage(e);}},{key:"createImageMessage",value:function value(e){return this._getModule(Rn).createImageMessage(e);}},{key:"createAudioMessage",value:function value(e){return this._getModule(Rn).createAudioMessage(e);}},{key:"createVideoMessage",value:function value(e){return this._getModule(Rn).createVideoMessage(e);}},{key:"createCustomMessage",value:function value(e){return this._getModule(Rn).createCustomMessage(e);}},{key:"createFaceMessage",value:function value(e){return this._getModule(Rn).createFaceMessage(e);}},{key:"createFileMessage",value:function value(e){return this._getModule(Rn).createFileMessage(e);}},{key:"createLocationMessage",value:function value(e){return this._getModule(Rn).createLocationMessage(e);}},{key:"createMergerMessage",value:function value(e){return this._getModule(Rn).createMergerMessage(e);}},{key:"downloadMergerMessage",value:function value(e){return e.type!==S.MSG_MERGER?Ja({code:da.MESSAGE_MERGER_TYPE_INVALID}):jt(e.payload.downloadKey)?Ja({code:da.MESSAGE_MERGER_KEY_INVALID}):this._getModule(Rn).downloadMergerMessage(e).catch(function(e){return Ja({code:da.MESSAGE_MERGER_DOWNLOAD_FAIL});});}},{key:"createForwardMessage",value:function value(e){return this._getModule(Rn).createForwardMessage(e);}},{key:"sendMessage",value:function value(e,t){return e instanceof Ha?this._getModule(Rn).sendMessageInstance(e,t):Ja({code:da.MESSAGE_SEND_NEED_MESSAGE_INSTANCE});}},{key:"callExperimentalAPI",value:function value(e,t){return"sendComboMessage"===e?this._getModule(so).sendMessage(t):"handleGroupInvitation"===e?this._getModule(Un).handleGroupInvitation(t):"isCommercialAbilityEnabled"===e?this._getModule(eo).isFeatureEnabled(t):"isIntl"===e?this.isIntl():"sendTRTCCustomData"===e?this._getModule(oo).sendTRTCCustomData(t):"getTimerID"===e?this._m.getTimerID():"getPollingTimerID"===e?this._m.getPollingTimerID(t):Ja({code:da.INVALID_OPERATION});}},{key:"revokeMessage",value:function value(e){return this._getModule(Rn).revokeMessage(e);}},{key:"resendMessage",value:function value(e){return this._getModule(Rn).resendMessage(e);}},{key:"deleteMessage",value:function value(e){return this._getModule(Rn).deleteMessage(e);}},{key:"translateText",value:function value(e){return this._getModule(Rn).translateText(e);}},{key:"setMessageExtensions",value:function value(e,t){return this._getModule(Nn).setMessageExtensions(e,t);}},{key:"getMessageExtensions",value:function value(e){return this._getModule(Nn).getMessageExtensions(e);}},{key:"deleteMessageExtensions",value:function value(e,t){return this._getModule(Nn).deleteMessageExtensions(e,t);}},{key:"modifyMessage",value:function value(e){return this._getModule(Rn).modifyRemoteMessage(e);}},{key:"getMessageList",value:function value(e){return this._getModule(Fn).getMessageList(e);}},{key:"getMessageListHopping",value:function value(e){return this._getModule(Fn).getMessageListHopping(e);}},{key:"sendMessageReadReceipt",value:function value(e){return this._getModule(Fn).sendReadReceipt(e);}},{key:"getMessageReadReceiptList",value:function value(e){return this._getModule(Fn).getReadReceiptList(e);}},{key:"getGroupMessageReadMemberList",value:function value(e){return this._getModule(Un).getReadReceiptDetail(e);}},{key:"findMessage",value:function value(e){return this._getModule(Fn).findMessage(e);}},{key:"setMessageRead",value:function value(e){return this._getModule(Fn).setMessageRead(e);}},{key:"getConversationList",value:function value(e){return this._getModule(Fn).getConversationList(e);}},{key:"getConversationProfile",value:function value(e){return this._getModule(Fn).getConversationProfile(e);}},{key:"deleteConversation",value:function value(e){return this._getModule(Fn).deleteConversation(e);}},{key:"clearHistoryMessage",value:function value(e){return this._getModule(Fn).clearHistoryMessage(e);}},{key:"pinConversation",value:function value(e){return this._getModule(Fn).pinConversation(e);}},{key:"setAllMessageRead",value:function value(e){return this._getModule(Fn).setAllMessageRead(e);}},{key:"setMessageRemindType",value:function value(e){return this._getModule(Fn).setMessageRemindType(e);}},{key:"getTotalUnreadMessageCount",value:function value(){return this._getModule(Fn).getTotalUnreadMessageCount();}},{key:"setConversationCustomData",value:function value(e){return this._getModule(Fn).setConversationCustomData(e);}},{key:"markConversation",value:function value(e){return this._getModule(Fn).markConversation(e);}},{key:"getConversationGroupList",value:function value(){return this._getModule(Fn).getConversationGroupList();}},{key:"createConversationGroup",value:function value(e){return this._getModule(Fn).createConversationGroup(e);}},{key:"deleteConversationGroup",value:function value(e){return this._getModule(Fn).deleteConversationGroup(e);}},{key:"renameConversationGroup",value:function value(e){return this._getModule(Fn).renameConversationGroup(e);}},{key:"addConversationsToGroup",value:function value(e){return this._getModule(Fn).addConversationsToGroup(e);}},{key:"deleteConversationsFromGroup",value:function value(e){return this._getModule(Fn).deleteConversationsFromGroup(e);}},{key:"getMyProfile",value:function value(){return this._getModule(On).getMyProfile();}},{key:"getUserProfile",value:function value(e){return this._getModule(On).getUserProfile(e);}},{key:"updateMyProfile",value:function value(e){return this._getModule(On).updateMyProfile(e);}},{key:"getBlacklist",value:function value(){return this._getModule(On).getLocalBlacklist();}},{key:"addToBlacklist",value:function value(e){return this._getModule(On).addBlacklist(e);}},{key:"removeFromBlacklist",value:function value(e){return this._getModule(On).deleteBlacklist(e);}},{key:"setSelfStatus",value:function value(e){return this._getModule(On).setSelfStatus(e);}},{key:"getUserStatus",value:function value(e){return this._getModule(On).getUserStatus(e);}},{key:"subscribeUserStatus",value:function value(e){return this._getModule(On).subscribeUserStatus(e);}},{key:"unsubscribeUserStatus",value:function value(e){return this._getModule(On).unsubscribeUserStatus(e);}},{key:"getFriendList",value:function value(){var e=this._getModule(Pn);return e?e.getLocalFriendList():Ja({code:da.CANNOT_FIND_MODULE});}},{key:"addFriend",value:function value(e){var t=this._getModule(Pn);return t?t.addFriend(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"deleteFriend",value:function value(e){var t=this._getModule(Pn);return t?t.deleteFriend(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"checkFriend",value:function value(e){var t=this._getModule(Pn);return t?t.checkFriend(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"getFriendProfile",value:function value(e){var t=this._getModule(Pn);return t?t.getFriendProfile(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"updateFriend",value:function value(e){var t=this._getModule(Pn);return t?t.updateFriend(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"getFriendApplicationList",value:function value(){var e=this._getModule(Pn);return e?e.getLocalFriendApplicationList():Ja({code:da.CANNOT_FIND_MODULE});}},{key:"acceptFriendApplication",value:function value(e){var t=this._getModule(Pn);return t?t.acceptFriendApplication(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"refuseFriendApplication",value:function value(e){var t=this._getModule(Pn);return t?t.refuseFriendApplication(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"deleteFriendApplication",value:function value(e){var t=this._getModule(Pn);return t?t.deleteFriendApplication(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"setFriendApplicationRead",value:function value(){var e=this._getModule(Pn);return e?e.setFriendApplicationRead():Ja({code:da.CANNOT_FIND_MODULE});}},{key:"getFriendGroupList",value:function value(){var e=this._getModule(Pn);return e?e.getLocalFriendGroupList():Ja({code:da.CANNOT_FIND_MODULE});}},{key:"createFriendGroup",value:function value(e){var t=this._getModule(Pn);return t?t.createFriendGroup(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"deleteFriendGroup",value:function value(e){var t=this._getModule(Pn);return t?t.deleteFriendGroup(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"addToFriendGroup",value:function value(e){var t=this._getModule(Pn);return t?t.addToFriendGroup(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"removeFromFriendGroup",value:function value(e){var t=this._getModule(Pn);return t?t.removeFromFriendGroup(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"renameFriendGroup",value:function value(e){var t=this._getModule(Pn);return t?t.renameFriendGroup(e):Ja({code:da.CANNOT_FIND_MODULE});}},{key:"getGroupList",value:function value(e){return this._getModule(Un).getGroupList(e);}},{key:"getGroupProfile",value:function value(e){return this._getModule(Un).getGroupProfile(e);}},{key:"createGroup",value:function value(e){return this._getModule(Un).createGroup(e);}},{key:"dismissGroup",value:function value(e){return this._getModule(Un).dismissGroup(e);}},{key:"updateGroupProfile",value:function value(e){return this._getModule(Un).updateGroupProfile(e);}},{key:"joinGroup",value:function value(e){return this._getModule(Un).joinGroup(e);}},{key:"quitGroup",value:function value(e){return this._getModule(Un).quitGroup(e);}},{key:"searchGroupByID",value:function value(e){return this._getModule(Un).searchGroupByID(e);}},{key:"getGroupOnlineMemberCount",value:function value(e){return this._getModule(Un).getGroupOnlineMemberCount(e);}},{key:"changeGroupOwner",value:function value(e){return this._getModule(Un).changeGroupOwner(e);}},{key:"getGroupApplicationList",value:function value(){return this._getModule(Un).getGroupApplicationList();}},{key:"handleGroupApplication",value:function value(e){return this._getModule(Un).handleGroupApplication(e);}},{key:"initGroupAttributes",value:function value(e){return this._getModule(Un).initGroupAttributes(e);}},{key:"setGroupAttributes",value:function value(e){return this._getModule(Un).setGroupAttributes(e);}},{key:"deleteGroupAttributes",value:function value(e){return this._getModule(Un).deleteGroupAttributes(e);}},{key:"getGroupAttributes",value:function value(e){return this._getModule(Un).getGroupAttributes(e);}},{key:"setGroupCounters",value:function value(e){return this._getModule(Un).setGroupCounters(e);}},{key:"increaseGroupCounter",value:function value(e){return this._getModule(Un).increaseGroupCounter(e);}},{key:"decreaseGroupCounter",value:function value(e){return this._getModule(Un).decreaseGroupCounter(e);}},{key:"getGroupCounters",value:function value(e){return this._getModule(Un).getGroupCounters(e);}},{key:"getGroupMemberList",value:function value(e){return this._getModule(bn).getGroupMemberList(e);}},{key:"getGroupMemberProfile",value:function value(e){return this._getModule(bn).getGroupMemberProfile(e);}},{key:"addGroupMember",value:function value(e){return this._getModule(bn).addGroupMember(e);}},{key:"deleteGroupMember",value:function value(e){return this._getModule(bn).deleteGroupMember(e);}},{key:"setGroupMemberMuteTime",value:function value(e){return this._getModule(bn).setGroupMemberMuteTime(e);}},{key:"setGroupMemberRole",value:function value(e){return this._getModule(bn).setGroupMemberRole(e);}},{key:"setGroupMemberNameCard",value:function value(e){return this._getModule(bn).setGroupMemberNameCard(e);}},{key:"setGroupMemberCustomField",value:function value(e){return this._getModule(bn).setGroupMemberCustomField(e);}},{key:"markGroupMemberList",value:function value(e){return this._getModule(bn).markGroupMemberList(e);}},{key:"getJoinedCommunityList",value:function value(){return this._getModule(wn).getJoinedCommunityList();}},{key:"createTopicInCommunity",value:function value(e){return this._getModule(wn).createTopicInCommunity(e);}},{key:"deleteTopicFromCommunity",value:function value(e){return this._getModule(wn).deleteTopicFromCommunity(e);}},{key:"updateTopicProfile",value:function value(e){return this._getModule(wn).updateTopicProfile(e);}},{key:"getTopicList",value:function value(e){return this._getModule(wn).getTopicList(e);}}]),e;}(),pu={login:1,logout:1,destroy:1,on:1,off:1,ready:1,setLogLevel:1,joinGroup:1,quitGroup:1,registerPlugin:1,getGroupOnlineMemberCount:1};function du(e,t){if(e.isReady()||1===pu[t])return!0;var n=e.getNotReadyReason(),o={code:n,message:"".concat(e.getErrorMessage(n)," | ").concat(t," | ").concat(e.getErrorMessage(da.SDK_IS_NOT_READY))};return e.onError(o),o;}var gu={},_u={};return _u.create=function(e){var n=0,o=e.SDKAppID;if($e(o))n=o;else if(n=parseInt(o),isNaN(o))return xe.e("".concat("TIM.create"," failed. Failed to parse the SDKAppID, please check the arguments")),null;if(n&&gu[n])return gu[n];xe.l("".concat("TIM.create"));var s=new lu(t(t({},e),{},{SDKAppID:n}));s.on(E.SDK_DESTROY,function(e){gu[e.data.SDKAppID]=null,delete gu[e.data.SDKAppID];});var a=function(e){var t=Object.create(null);return Object.keys(Ln).forEach(function(n){if(e[n]){var o=new k();t[n]=function(){var t=Array.from(arguments);return o.use(function(t,o){var s=du(e,n);return!0===s?o():Ja(s);}).use(function(e,t){if(!0===zt(e,kn[n],n))return t();}).use(function(t,o){return e[n].apply(e,t);}),o.run(t);};}}),t;}(s);return gu[n]=a,kn.hookGetAPITips(s.getErrorMessage.bind(s)),xe.l("".concat("TIM.create"," ok")),a;},_u.TYPES=S,_u.EVENT=E,_u.VERSION="2.27.5",xe.l("TIM.VERSION:".concat(_u.VERSION)),_u;});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(28);

var _axios2 = _interopRequireDefault(_axios);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startTime = null;
var totalCount = 0;
var commentList = [];
var sendMsgCallBack = null;
var timer = null;
var t_id = 0;
var commentTime = 1; //评论后置时间

function setCommentCallback(callBack) {
  sendMsgCallBack = callBack;
}

function startCommentRun() {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
  timer = setInterval(function () {
    if (commentList.length == 0) {
      return;
    }
    var tmpTime = new Date(startTime.replace(/-/g, '/')).valueOf();
    var comment = commentList[0];
    if (parseInt(comment.send_time) * 1000 + tmpTime + commentTime * 1000 < new Date().valueOf()) {
      //需要发送消息
      if (sendMsgCallBack) {
        var item = {
          module: "text_comment",
          content: comment.content,
          nick: comment.nick,
          header: comment.header
        };
        commentList.shift();
        // console.log(commentList);
        sendMsgCallBack(item);
        return;
      }
    }
  }, 50);
}

function startLoad(start_time, tid, callBack) {
  startTime = start_time;
  t_id = tid;
  var tmpTime = new Date(start_time.replace(/-/g, '/')).valueOf();
  var option = "tid=" + tid + "&page_num=" + 10000;
  _axios2.default.post(_Tools2.default.baseUrl1() + "/api/fakeLive/getCommentList", option).then(function (res) {
    if (res.data.code == 200) {
      var list = res.data.data.list;
      list.sort(function (a, b) {
        if (a.send_time == b.send_time) {
          return a.create_time - b.create_time;
        } else {
          return a.send_time - b.send_time;
        }
      });
      //删除当前时间已经评论过
      var index = list.findIndex(function (item) {
        return tmpTime + parseInt(item.send_time * 1000) > new Date().valueOf();
      });
      if (index != -1) {
        list.splice(0, index);
      } else {
        list = [];
      }
      commentList = list;
      totalCount = res.data.data.total_count;
      if (callBack) {
        callBack(true);
      }
    } else {
      if (callBack) {
        callBack(false);
      }
      console.error("获取评论失败:", res);
    }
  }).catch(function (error) {
    if (callBack) {
      callBack(false);
    }
    console.error("获取评论失败:", error);
  });
}

exports.default = {
  setCommentCallback: setCommentCallback,
  startCommentRun: startCommentRun,
  startLoad: startLoad
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var formats = __webpack_require__(53);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}();

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || (typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && (typeof targetItem === 'undefined' ? 'undefined' : _typeof(targetItem)) === 'object' && item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function decode(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if ((typeof str === 'undefined' ? 'undefined' : _typeof(str)) === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (c === 0x2D // -
        || c === 0x2E // .
        || c === 0x5F // _
        || c === 0x7E // ~
        || c >= 0x30 && c <= 0x39 // 0-9
        || c >= 0x41 && c <= 0x5A // a-z
        || c >= 0x61 && c <= 0x7A // A-Z
        || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
                out += string.charAt(i);
                continue;
            }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
        }

        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
})(undefined, function () {
    'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
      Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var _extendStatics = function extendStatics(d, b) {
        _extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        } || function (d, b) {
            for (var p in b) {
                if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            }
        };
        return _extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        _extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var _assign = function __assign() {
        _assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) {
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
            }
            return t;
        };
        return _assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function sent() {
                if (t[0] & 1) throw t[1];return t[1];
            }, trys: [], ops: [] },
            f,
            y,
            t,
            g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
        }), g;
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) {
                try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:case 1:
                            t = op;break;
                        case 4:
                            _.label++;return { value: op[1], done: false };
                        case 5:
                            _.label++;y = op[1];op = [0];continue;
                        case 7:
                            op = _.ops.pop();_.trys.pop();continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];t = op;break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];_.ops.push(op);break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];y = 0;
                } finally {
                    f = t = 0;
                }
            }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function parseBounds(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function parseDocumentSize(document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function toCodePoints$1(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                } else {
                    codePoints.push(value);
                    i--;
                }
            } else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function fromCodePoint$1() {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            } else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function decode$1(base64) {
        var bufferLength = base64.length * 0.75,
            len = base64.length,
            i,
            p = 0,
            encoded1,
            encoded2,
            encoded3,
            encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function polyUint16Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push(buffer[i + 1] << 8 | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function polyUint32Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function slice16$1(view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function slice32$1(view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function createTrieFromBase64$1(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints, lineBreak) {
        if (lineBreak === void 0) {
            lineBreak = 'strict';
        }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) {
                    return types.push(ID);
                } else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            } else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) ||
        // ( OP | HY ) × NU
        [OP, HY].indexOf(current) !== -1 && next === NU ||
        // NU ×	(NU | SY | IS)
        current === NU && [NU, SY, IS].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                } else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                } else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                } else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                } else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                } else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak),
            indicies = _a[0],
            classTypes = _a[1],
            isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) {
                return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
            });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function (letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function LineBreaker(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options),
            indicies = _a[0],
            classTypes = _a[1],
            forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function next() {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1) {}
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            }
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function isDigit(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function isSurrogateCodePoint(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function isHex(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function isLowerCaseLetter(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function isUpperCaseLetter(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function isLetter(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function isNonASCIICodePoint(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function isWhiteSpace(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function isNameStartCodePoint(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function isNameCodePoint(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function isNonPrintableCodePoint(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function isValidEscape(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function isIdentifierStart(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        } else if (isNameStartCodePoint(c1)) {
            return true;
        } else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function isNumberStart(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function stringToNumber(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            } else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                        this.consumeWhiteSpace();
                        if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                            this.consumeCodePoint();
                            return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                        }
                    }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                } else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    } else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(),
                number = _a[0],
                flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                } else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                } else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();

    var Parser = /** @class */function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                    throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
                }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                    return value;
                }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                        return values;
                    }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                        return cssFunction;
                    }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function isDimensionToken(token) {
        return token.type === 15 /* DIMENSION_TOKEN */;
    };
    var isNumberToken = function isNumberToken(token) {
        return token.type === 17 /* NUMBER_TOKEN */;
    };
    var isIdentToken = function isIdentToken(token) {
        return token.type === 20 /* IDENT_TOKEN */;
    };
    var isStringToken = function isStringToken(token) {
        return token.type === 0 /* STRING_TOKEN */;
    };
    var isIdentWithValue = function isIdentWithValue(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function nonWhiteSpace(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */;
    };
    var nonFunctionArgSeparator = function nonFunctionArgSeparator(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function parseFunctionArgs(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                    if (arg.length === 0) {
                        throw new Error("Error parsing function args, zero tokens for arg");
                    }
                    args.push(arg);
                    arg = [];
                    return;
                }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                    arg.push(token);
                }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function isEndingTokenFor(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
                return true;
            }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
                return true;
            }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function isLength(token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function isLengthPercentage(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function parseLengthPercentageTuple(tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */
        , number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */
        , number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */
        , number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function getAbsoluteValueForTuple(tuple, width, height) {
        var x = tuple[0],
            y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function getAbsoluteValue(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
                return token.number / 100 * parent;
            }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                    switch (value.unit) {
                        case DEG:
                            return Math.PI * value.number / 180;
                        case GRAD:
                            return Math.PI / 200 * value.number;
                        case RAD:
                            return value.number;
                        case TURN:
                            return Math.PI * 2 * value.number;
                    }
                }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function isAngle(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
                if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                    return true;
                }
            }
        return false;
    };
    var parseNamedSide = function parseNamedSide(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function (ident) {
            return ident.value;
        }).join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function deg(_deg) {
        return Math.PI * _deg / 180;
    };

    var color$1 = {
        name: 'color',
        parse: function parse(context, value) {
            if (value.type === 18 /* FUNCTION */) {
                    var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                    if (typeof colorFunction === 'undefined') {
                        throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                    }
                    return colorFunction(context, value.values);
                }
            if (value.type === 5 /* HASH_TOKEN */) {
                    if (value.value.length === 3) {
                        var r = value.value.substring(0, 1);
                        var g = value.value.substring(1, 2);
                        var b = value.value.substring(2, 3);
                        return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                    }
                    if (value.value.length === 4) {
                        var r = value.value.substring(0, 1);
                        var g = value.value.substring(1, 2);
                        var b = value.value.substring(2, 3);
                        var a = value.value.substring(3, 4);
                        return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                    }
                    if (value.value.length === 6) {
                        var r = value.value.substring(0, 2);
                        var g = value.value.substring(2, 4);
                        var b = value.value.substring(4, 6);
                        return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                    }
                    if (value.value.length === 8) {
                        var r = value.value.substring(0, 2);
                        var g = value.value.substring(2, 4);
                        var b = value.value.substring(4, 6);
                        var a = value.value.substring(6, 8);
                        return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                    }
                }
            if (value.type === 20 /* IDENT_TOKEN */) {
                    var namedColor = COLORS[value.value.toUpperCase()];
                    if (typeof namedColor !== 'undefined') {
                        return namedColor;
                    }
                }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function isTransparent(color) {
        return (0xff & color) === 0;
    };
    var asString = function asString(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function pack(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function getTokenColorValue(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
                var max = i === 3 ? 1 : 255;
                return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
            }
        return 0;
    };
    var rgb = function rgb(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue),
                r = _a[0],
                g = _a[1],
                b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue),
                r = _b[0],
                g = _b[1],
                b = _b[2],
                a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        } else if (hue < 1 / 2) {
            return t2;
        } else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        } else {
            return t1;
        }
    }
    var hsl = function hsl(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0],
            saturation = tokens[1],
            lightness = tokens[2],
            alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function parseColor(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */
        , format: 'color'
    };

    var parseColorStop = function parseColorStop(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function processColorStops(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                } else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            } else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function getAngleFromCorner(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function calculateGradientDirection(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function distance(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function findCorner(width, height, x, y, closest) {
        var corners = [[0, 0], [0, height], [width, 0], [width, height]];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0],
                cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function calculateRadius(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        rx = Math.min(Math.abs(x), Math.abs(x - width));
                        ry = Math.min(Math.abs(y), Math.abs(y - height));
                    }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                        var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                        var _a = findCorner(width, height, x, y, true),
                            cx = _a[0],
                            cy = _a[1];
                        rx = distance(cx - x, (cy - y) / c);
                        ry = c * rx;
                    }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        rx = Math.max(Math.abs(x), Math.abs(x - width));
                        ry = Math.max(Math.abs(y), Math.abs(y - height));
                    }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                        var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                        var _b = findCorner(width, height, x, y, false),
                            cx = _b[0],
                            cy = _b[1];
                        rx = distance(cx - x, (cy - y) / c);
                        ry = c * rx;
                    }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function linearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function prefixLinearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function webkitGradient(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                    if (firstToken.name === 'from') {
                        var color = color$1.parse(context, firstToken.values[0]);
                        stops.push({ stop: ZERO_LENGTH, color: color });
                    } else if (firstToken.name === 'to') {
                        var color = color$1.parse(context, firstToken.values[0]);
                        stops.push({ stop: HUNDRED_PERCENT, color: color });
                    } else if (firstToken.name === 'color-stop') {
                        var values = firstToken.values.filter(nonFunctionArgSeparator);
                        if (values.length === 2) {
                            var color = color$1.parse(context, values[1]);
                            var stop_1 = values[0];
                            if (isNumberToken(stop_1)) {
                                stops.push({
                                    stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                    color: color
                                });
                            }
                        }
                    }
                }
        });
        return type === 1 /* LINEAR_GRADIENT */
        ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function radialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        } else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    } else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    } else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function prefixRadialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    } else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            } else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    } else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function isLinearGradient(background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function isRadialGradient(background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function parse(context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                    var image_1 = { url: value.value, type: 0 /* URL */ };
                    context.cache.addImage(value.value);
                    return image_1;
                }
            if (value.type === 18 /* FUNCTION */) {
                    var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                    if (typeof imageFunction === 'undefined') {
                        throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                    }
                    return imageFunction(context, value.values);
                }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') && (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */
        , prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens.filter(function (value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function (value) {
                return image.parse(context, value);
            });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */
        , prefix: false,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) {
                return values.filter(isIdentToken).map(function (token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function parseBackgroundRepeat(value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function isBackgroundSizeInfoToken(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function borderColorForSide(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */
            , format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function borderRadiusForSide(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */
            , parse: function parse(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function borderStyleForSide(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */
            , parse: function parse(_context, style) {
                switch (style) {
                    case 'none':
                        return 0 /* NONE */;
                    case 'dashed':
                        return 2 /* DASHED */;
                    case 'dotted':
                        return 3 /* DOTTED */;
                    case 'double':
                        return 4 /* DOUBLE */;
                }
                return 1 /* SOLID */;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function borderWidthForSide(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */
            , prefix: false,
            parse: function parse(_context, token) {
                if (isDimensionToken(token)) {
                    return token.number;
                }
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */
        , format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function parseDisplayValue(display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */
        , parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                    return token.number;
                }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                    return token.number;
                }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function computeLineHeight(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        } else if (token.type === 17 /* NUMBER_TOKEN */) {
                return fontSize * token.number;
            } else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */
        , prefix: false,
        parse: function parse(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function marginForSide(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function paddingForSide(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */
            , format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */
        , prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        } else if (c === 1) {
                            shadow.offsetY = token;
                        } else {
                            shadow.blur = token;
                        }
                        c++;
                    } else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */
        , parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                    var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                    if (typeof transformFunction === 'undefined') {
                        throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                    }
                    return transformFunction(token.values);
                }
            return null;
        }
    };
    var matrix = function matrix(args) {
        var values = args.filter(function (arg) {
            return arg.type === 17 /* NUMBER_TOKEN */;
        }).map(function (arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function matrix3d(args) {
        var values = args.filter(function (arg) {
            return arg.type === 17 /* NUMBER_TOKEN */;
        }).map(function (arg) {
            return arg.number;
        });
        var a1 = values[0],
            b1 = values[1];values[2];values[3];var a2 = values[4],
            b2 = values[5];values[6];values[7];values[8];values[9];values[10];values[11];var a4 = values[12],
            b4 = values[13];values[14];values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */
        , number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */
        , parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                    return { auto: true, order: 0 };
                }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                    switch (value.unit.toLowerCase()) {
                        case 's':
                            return 1000 * value.number;
                        case 'ms':
                            return value.number;
                    }
                }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */
        , prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */
        , format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            }).filter(function (line) {
                return line !== 0 /* NONE */;
            });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */
        , format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */
        , prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */
        , prefix: false,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) {
                return token.value;
            });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */
        , parse: function parse(_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function contains(bit, value) {
        return (bit & value) !== 0;
    };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */
        , prefix: false,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                        var increment = next && isNumberToken(next) ? next.number : 1;
                        increments.push({ counter: counter.value, increment: increment });
                    }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) {
                return time.parse(context, token);
            });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function getQuote(quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */
        , prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    } else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        } else if (c === 1) {
                            shadow.offsetY = token;
                        } else if (c === 2) {
                            shadow.blur = token;
                        } else {
                            shadow.spread = token;
                        }
                        c++;
                    } else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */
        , parse: function parse(_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */
        , format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */
        , prefix: false,
        parse: function parse(_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return contains(this.display, 4 /* INLINE */) || contains(this.display, 33554432 /* INLINE_BLOCK */) || contains(this.display, 268435456 /* INLINE_FLEX */) || contains(this.display, 536870912 /* INLINE_GRID */) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */) || contains(this.display, 134217728 /* INLINE_TABLE */);
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function parse(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function getElementDebugType(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function isDebugging(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) {
                    return duration > 0;
                })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }();

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function decode(base64) {
        var bufferLength = base64.length * 0.75,
            len = base64.length,
            i,
            p = 0,
            encoded1,
            encoded2,
            encoded3,
            encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function polyUint16Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push(buffer[i + 1] << 8 | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function polyUint32Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function slice16(view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function slice32(view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function createTrieFromBase64(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function toCodePoints(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                } else {
                    codePoints.push(value);
                    i--;
                }
            } else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function fromCodePoint() {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            } else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function codePointToClass(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function _graphemeBreakAtIndex(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function GraphemeBreaker(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function next() {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) {}
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            }
        };
    };
    var splitGraphemes = function splitGraphemes(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function testRangeBounds(document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function testIOSLineBreak(document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function testCORS() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function testResponseType() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function testSVG(document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function isGreenPixel(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function testForeignObject(document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function () {
            return false;
        });
    };
    var createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function loadSerializedSVG$1(svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function parseTextBounds(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function getWrapperBounds(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function createRange(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function segmentGraphemes(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function segmentWords(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function breakText(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function breakWords(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function _loop_1() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    } else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function transform(text, _transform) {
        switch (_transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function capitalize(m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);

    var CanvasElementContainer = /** @class */function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);

    var SVGElementContainer = /** @class */function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);

    var LIElementContainer = /** @class */function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);

    var OLElementContainer = /** @class */function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);

    var CHECKBOX_BORDER_RADIUS = [{
        type: 15 /* DIMENSION_TOKEN */
        , flags: 0,
        unit: 'px',
        number: 3
    }];
    var RADIO_BORDER_RADIUS = [{
        type: 16 /* PERCENTAGE_TOKEN */
        , flags: 0,
        number: 50
    }];
    var reformatInputBounds = function reformatInputBounds(bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        } else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function getInputValue(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);

    var SelectElementContainer = /** @class */function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);

    var TextareaElementContainer = /** @class */function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);

    var IFrameElementContainer = /** @class */function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function parseNodeTree(context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            } else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) {
                        return parseNodeTree(context, childNode, parent, root);
                    });
                } else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        } else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        } else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function createContainer(context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function parseTree(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function createsRealStackingContext(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function createsStackingContext(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function isHTMLElementNode(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function isSVGElementNode(element) {
        return _typeof(element.className) === 'object';
    };
    var isLIElement = function isLIElement(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function isOLElement(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function isInputElement(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function isHTMLElement(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function isSVGElement(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function isBodyElement(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function isCanvasElement(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function isVideoElement(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function isImageElement(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function isIFrameElement(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function isStyleElement(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function isScriptElement(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function isTextareaElement(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function isSelectElement(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function isSlotElement(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function isCustomElement(node) {
        return node.tagName.indexOf('-') > 0;
    };

    var CounterState = /** @class */function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
        values: ['Ք', 'Փ', 'Ւ', 'Ց', 'Ր', 'Տ', 'Վ', 'Ս', 'Ռ', 'Ջ', 'Պ', 'Չ', 'Ո', 'Շ', 'Ն', 'Յ', 'Մ', 'Ճ', 'Ղ', 'Ձ', 'Հ', 'Կ', 'Ծ', 'Խ', 'Լ', 'Ի', 'Ժ', 'Թ', 'Ը', 'Է', 'Զ', 'Ե', 'Դ', 'Գ', 'Բ', 'Ա']
    };
    var HEBREW = {
        integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
        values: ['י׳', 'ט׳', 'ח׳', 'ז׳', 'ו׳', 'ה׳', 'ד׳', 'ג׳', 'ב׳', 'א׳', 'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'יט', 'יח', 'יז', 'טז', 'טו', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א']
    };
    var GEORGIAN = {
        integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
        values: ['ჵ', 'ჰ', 'ჯ', 'ჴ', 'ხ', 'ჭ', 'წ', 'ძ', 'ც', 'ჩ', 'შ', 'ყ', 'ღ', 'ქ', 'ფ', 'ჳ', 'ტ', 'ს', 'რ', 'ჟ', 'პ', 'ო', 'ჲ', 'ნ', 'მ', 'ლ', 'კ', 'ი', 'თ', 'ჱ', 'ზ', 'ვ', 'ე', 'დ', 'გ', 'ბ', 'ა']
    };
    var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols, suffix) {
        if (suffix === void 0) {
            suffix = '. ';
        }
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            } else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function createCounterText(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () {
                return __awaiter(_this, void 0, void 0, function () {
                    var onclone, referenceElement;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') {
                                    return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                                }
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                                return [4 /*yield*/, documentClone.fonts.ready];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                                return [4 /*yield*/, imagesReady(documentClone)];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') {
                                    return [2 /*return*/, Promise.resolve().then(function () {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function () {
                                        return iframe;
                                    })];
                                }
                                return [2 /*return*/, iframe];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    } else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) {
                            return _this.appendChildNode(clone, assignedNode, copyStyles);
                        });
                    }
                } else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                        anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    } else if (token.type === 22 /* URL_TOKEN */) {
                        var img = document.createElement('img');
                        img.src = token.value;
                        img.style.opacity = '1';
                        anonymousReplacedElement.appendChild(img);
                    } else if (token.type === 18 /* FUNCTION */) {
                        if (token.name === 'attr') {
                            var attr = token.values.filter(isIdentToken);
                            if (attr.length) {
                                anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                            }
                        } else if (token.name === 'counter') {
                            var _a = token.values.filter(nonFunctionArgSeparator),
                                counter = _a[0],
                                counterStyle = _a[1];
                            if (counter && isIdentToken(counter)) {
                                var counterState = _this.counters.getCounterValue(counter.value);
                                var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */;
                                anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                            }
                        } else if (token.name === 'counters') {
                            var _b = token.values.filter(nonFunctionArgSeparator),
                                counter = _b[0],
                                delim = _b[1],
                                counterStyle = _b[2];
                            if (counter && isIdentToken(counter)) {
                                var counterStates = _this.counters.getCounterValues(counter.value);
                                var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */;
                                var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                                var text = counterStates.map(function (value) {
                                    return createCounterText(value, counterType_1, false);
                                }).join(separator);
                                anonymousReplacedElement.appendChild(document.createTextNode(text));
                            }
                        } else ;
                    } else if (token.type === 20 /* IDENT_TOKEN */) {
                        switch (token.value) {
                            case 'open-quote':
                                anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                                break;
                            case 'close-quote':
                                anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                                break;
                            default:
                                // safari doesn't parse string tokens correctly because of lack of quotes
                                anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                        }
                    }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            } else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function createIFrameContainer(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function imageReady(img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function imagesReady(document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function iframeLoader(iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = ['all', 'd', 'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function copyCSSStyles(style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function serializeDoctype(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function restoreNodeScroll(_a) {
        var element = _a[0],
            x = _a[1],
            y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function createPseudoHideStyles(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function createStyles(body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */function () {
        function CacheStorage() {}
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var img = new Image();
                                img.onload = function () {
                                    return resolve(img);
                                };
                                img.onerror = reject;
                                //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                if (isInlineBase64Image(src) || useCORS) {
                                    img.crossOrigin = 'anonymous';
                                }
                                img.src = src;
                                if (img.complete === true) {
                                    // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function () {
                                        return resolve(img);
                                    }, 500);
                                }
                                if (_this._options.imageTimeout > 0) {
                                    setTimeout(function () {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                }
                            })];
                        case 3:
                            return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        } else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function (e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function isRenderable(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function isInlineImage(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function isInlineBase64Image(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function isBlobImage(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function isSVG(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };

    var Vector = /** @class */function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();

    var lerp = function lerp(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function isBezierCurve(path) {
        return path.type === 1 /* BEZIER_CURVE */;
    };

    var BoundCurves = /** @class */function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height),
                tlh = _a[0],
                tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height),
                trh = _b[0],
                trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height),
                brh = _c[0],
                brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height),
                blh = _d[0],
                blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function calculateContentBoxPath(curves) {
        return [curves.topLeftContentBox, curves.topRightContentBox, curves.bottomRightContentBox, curves.bottomLeftContentBox];
    };
    var calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
        return [curves.topLeftPaddingBox, curves.topRightPaddingBox, curves.bottomRightPaddingBox, curves.bottomLeftPaddingBox];
    };

    var TransformEffect = /** @class */function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function isTransformEffect(effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function isClipEffect(effect) {
        return effect.type === 1 /* CLIP */;
    };
    var isOpacityEffect = function isOpacityEffect(effect) {
        return effect.type === 2 /* OPACITY */;
    };

    var equalPath = function equalPath(a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) {
                return v === b[i];
            });
        }
        return false;
    };
    var transformPath = function transformPath(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                    var borderBox = calculateBorderBoxPath(this.curves);
                    var paddingBox = calculatePaddingBoxPath(this.curves);
                    if (equalPath(borderBox, paddingBox)) {
                        this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                    } else {
                        this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                        this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                    }
                }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                            var borderBox = calculateBorderBoxPath(parent.curves);
                            var paddingBox = calculatePaddingBoxPath(parent.curves);
                            if (!equalPath(borderBox, paddingBox)) {
                                effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                            }
                        }
                } else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function parseStackTree(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                } else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    } else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                } else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function processListItems(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function parseStackingContexts(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function parsePathForBorder(curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function parsePathForBorderDoubleOuter(curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function parsePathForBorderDoubleInner(curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function parsePathForBorderStroke(curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function createStrokePathFromCurves(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        } else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        } else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        } else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        } else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        } else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        } else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function paddingBox(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function contentBox(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function calculateBackgroundPositioningArea(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
                return element.bounds;
            }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
                return contentBox(element);
            }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function calculateBackgroundPaintingArea(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
                return element.bounds;
            }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
                return contentBox(element);
            }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function calculateBackgroundRendering(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0],
            sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function isAuto(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function hasIntrinsicValue(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function calculateBackgroundSize(size, _a, bounds) {
        var intrinsicWidth = _a[0],
            intrinsicHeight = _a[1],
            intrinsicProportion = _a[2];
        var first = size[0],
            second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [bounds.width, bounds.width / intrinsicProportion] : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            } else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            } else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        } else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function getBackgroundValueForIndex(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0],
            y = _a[1];
        var width = _b[0],
            height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)), new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)), new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)), new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))];
            case 3 /* REPEAT_Y */:
                return [new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)), new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)), new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)), new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))];
            case 1 /* NO_REPEAT */:
                return [new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)), new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)), new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)), new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))];
            default:
                return [new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)), new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)), new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)), new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }();

    var Renderer = /** @class */function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            } else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant.filter(function (variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [[styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '), fontFamily, fontSize];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7,, 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11,, 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([new Vector(bounds.left, bounds.top), new Vector(bounds.left + bounds.width, bounds.top), new Vector(bounds.left + bounds.width, bounds.top + bounds.height), new Vector(bounds.left, bounds.top + bounds.height)]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17,, 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18:
                            return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                    fontFamily = this.createFontStyle(styles)[0];
                                    this.ctx.font = fontFamily;
                                    this.ctx.fillStyle = asString(styles.color);
                                    this.ctx.textBaseline = 'middle';
                                    this.ctx.textAlign = 'right';
                                    bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                    this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                    this.ctx.textBaseline = 'bottom';
                                    this.ctx.textAlign = 'left';
                                }
                            _c.label = 20;
                        case 20:
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30:
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                } else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function _loop_1(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3,, 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [image.width, image.height, image.width / image.height]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [null, null, null]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [{ style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth }, { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth }, { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth }, { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9:
                            return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13:
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                            this.path(boxPaths);
                            this.ctx.clip();
                        }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    } else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                            this.formatPath(strokePaths);
                        } else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                            dashLength = width;
                            spaceLength = width;
                        }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    } else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                                this.ctx.setLineDash([0, dashLength + spaceLength]);
                            } else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                            this.ctx.lineCap = 'round';
                            this.ctx.lineWidth = width;
                        } else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                            if (isBezierCurve(boxPaths[0])) {
                                path1 = boxPaths[3];
                                path2 = boxPaths[0];
                                this.ctx.beginPath();
                                this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                                this.ctx.stroke();
                            }
                            if (isBezierCurve(boxPaths[1])) {
                                path1 = boxPaths[1];
                                path2 = boxPaths[2];
                                this.ctx.beginPath();
                                this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                                this.ctx.stroke();
                            }
                        }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function isTextInputElement(container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        } else if (container instanceof SelectElementContainer) {
            return true;
        } else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function calculateBackgroundCurvedPaintingArea(clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function canvasTextAlign(textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function fixIOSSystemFonts(fontFamilies) {
        return (/iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function (fontFamily) {
                return iOSBrokenFonts.indexOf(fontFamily) === -1;
            }) : fontFamilies
        );
    };

    var ForeignObjectRenderer = /** @class */function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function loadSerializedSVG(svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */function () {
        function Logger(_a) {
            var id = _a.id,
                enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                } else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                } else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                } else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }();

    var Context = /** @class */function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();

    var html2canvas = function html2canvas(element, options) {
        if (options === void 0) {
            options = {};
        }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function renderElement(element, opts) {
        return __awaiter(void 0, void 0, void 0, function () {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function (_u) {
                switch (_u.label) {
                    case 0:
                        if (!element || (typeof element === 'undefined' ? 'undefined' : _typeof(element)) !== 'object') {
                            return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                        }
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) {
                            throw new Error("Element is not attached to a Document");
                        }
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) {
                            throw new Error("Document is not attached to a Window");
                        }
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = _assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) {
                            return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                        }
                        return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [3 /*break*/, 3];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [4 /*yield*/, renderer.render(clonedElement)];
                    case 2:
                        canvas = _u.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) {
                            root.styles.backgroundColor = COLORS.TRANSPARENT;
                        }
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [4 /*yield*/, renderer.render(root)];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) {
                                context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                            }
                        }
                        context.logger.debug("Finished rendering");
                        return [2 /*return*/, canvas];
                }
            });
        });
    };
    var parseBackgroundColor = function parseBackgroundColor(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };

    return html2canvas;
});
//# sourceMappingURL=html2canvas.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty2(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*! TFPlayer built @2024/9/3 上午10:09:21 */(function webpackUniversalModuleDefinition(root,factory){if(( false?'undefined':_typeof2(exports))==='object'&&( false?'undefined':_typeof2(module))==='object')module.exports=factory();else if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if((typeof exports==='undefined'?'undefined':_typeof2(exports))==='object')exports["TFPlayer"]=factory();else root["TFPlayer"]=factory();})(typeof self!=='undefined'?self:this,function(){return(/******/function(modules){// webpackBootstrap
/******/// The module cache
/******/var installedModules={};/******//******/// The require function
/******/function __webpack_require__(moduleId){/******//******/// Check if module is in cache
/******/if(installedModules[moduleId]){/******/return installedModules[moduleId].exports;/******/}/******/// Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/i:moduleId,/******/l:false,/******/exports:{}/******/};/******//******/// Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******//******/// Flag the module as loaded
/******/module.l=true;/******//******/// Return the exports of the module
/******/return module.exports;/******/}/******//******//******/// expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******//******/// expose the module cache
/******/__webpack_require__.c=installedModules;/******//******/// define getter function for harmony exports
/******/__webpack_require__.d=function(exports,name,getter){/******/if(!__webpack_require__.o(exports,name)){/******/Object.defineProperty(exports,name,{/******/configurable:false,/******/enumerable:true,/******/get:getter/******/});/******/}/******/};/******//******/// getDefaultExport function for compatibility with non-harmony modules
/******/__webpack_require__.n=function(module){/******/var getter=module&&module.__esModule?/******/function getDefault(){return module['default'];}:/******/function getModuleExports(){return module;};/******/__webpack_require__.d(getter,'a',getter);/******/return getter;/******/};/******//******/// Object.prototype.hasOwnProperty.call
/******/__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property);};/******//******/// __webpack_public_path__
/******/__webpack_require__.p="/";/******//******/// Load entry module and return exports
/******/return __webpack_require__(__webpack_require__.s=20);/******/}(/************************************************************************//******/[/* 0 *//***/function(module,exports,__webpack_require__){"use strict";var bind=__webpack_require__(7);/*global toString:true*/// utils is a library of generic helper functions non-specific to axios
var toString=Object.prototype.toString;/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */function isArray(val){return toString.call(val)==='[object Array]';}/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */function isUndefined(val){return typeof val==='undefined';}/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */function isBuffer(val){return val!==null&&!isUndefined(val)&&val.constructor!==null&&!isUndefined(val.constructor)&&typeof val.constructor.isBuffer==='function'&&val.constructor.isBuffer(val);}/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */function isArrayBuffer(val){return toString.call(val)==='[object ArrayBuffer]';}/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */function isFormData(val){return typeof FormData!=='undefined'&&val instanceof FormData;}/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */function isArrayBufferView(val){var result;if(typeof ArrayBuffer!=='undefined'&&ArrayBuffer.isView){result=ArrayBuffer.isView(val);}else{result=val&&val.buffer&&val.buffer instanceof ArrayBuffer;}return result;}/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */function isString(val){return typeof val==='string';}/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */function isNumber(val){return typeof val==='number';}/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */function isObject(val){return val!==null&&(typeof val==='undefined'?'undefined':_typeof2(val))==='object';}/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */function isPlainObject(val){if(toString.call(val)!=='[object Object]'){return false;}var prototype=Object.getPrototypeOf(val);return prototype===null||prototype===Object.prototype;}/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */function isDate(val){return toString.call(val)==='[object Date]';}/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */function isFile(val){return toString.call(val)==='[object File]';}/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */function isBlob(val){return toString.call(val)==='[object Blob]';}/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */function isFunction(val){return toString.call(val)==='[object Function]';}/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */function isStream(val){return isObject(val)&&isFunction(val.pipe);}/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */function isURLSearchParams(val){return typeof URLSearchParams!=='undefined'&&val instanceof URLSearchParams;}/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */function trim(str){return str.replace(/^\s*/,'').replace(/\s*$/,'');}/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */function isStandardBrowserEnv(){if(typeof navigator!=='undefined'&&(navigator.product==='ReactNative'||navigator.product==='NativeScript'||navigator.product==='NS')){return false;}return typeof window!=='undefined'&&typeof document!=='undefined';}/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */function forEach(obj,fn){// Don't bother if no value provided
if(obj===null||typeof obj==='undefined'){return;}// Force an array if not already something iterable
if((typeof obj==='undefined'?'undefined':_typeof2(obj))!=='object'){/*eslint no-param-reassign:0*/obj=[obj];}if(isArray(obj)){// Iterate over array values
for(var i=0,l=obj.length;i<l;i++){fn.call(null,obj[i],i,obj);}}else{// Iterate over object keys
for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){fn.call(null,obj[key],key,obj);}}}}/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */function merge()/* obj1, obj2, obj3, ... */{var result={};function assignValue(val,key){if(isPlainObject(result[key])&&isPlainObject(val)){result[key]=merge(result[key],val);}else if(isPlainObject(val)){result[key]=merge({},val);}else if(isArray(val)){result[key]=val.slice();}else{result[key]=val;}}for(var i=0,l=arguments.length;i<l;i++){forEach(arguments[i],assignValue);}return result;}/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */function extend(a,b,thisArg){forEach(b,function assignValue(val,key){if(thisArg&&typeof val==='function'){a[key]=bind(val,thisArg);}else{a[key]=val;}});return a;}/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */function stripBOM(content){if(content.charCodeAt(0)===0xFEFF){content=content.slice(1);}return content;}module.exports={isArray:isArray,isArrayBuffer:isArrayBuffer,isBuffer:isBuffer,isFormData:isFormData,isArrayBufferView:isArrayBufferView,isString:isString,isNumber:isNumber,isObject:isObject,isPlainObject:isPlainObject,isUndefined:isUndefined,isDate:isDate,isFile:isFile,isBlob:isBlob,isFunction:isFunction,isStream:isStream,isURLSearchParams:isURLSearchParams,isStandardBrowserEnv:isStandardBrowserEnv,forEach:forEach,merge:merge,extend:extend,trim:trim,stripBOM:stripBOM};/***/},/* 1 *//***/function(module,exports){/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/// css base code, injected by the css-loader
module.exports=function(useSourceMap){var list=[];// return the list of modules as css string
list.toString=function toString(){return this.map(function(item){var content=cssWithMappingToString(item,useSourceMap);if(item[2]){return"@media "+item[2]+"{"+content+"}";}else{return content;}}).join("");};// import a list of modules into the list
list.i=function(modules,mediaQuery){if(typeof modules==="string")modules=[[null,modules,""]];var alreadyImportedModules={};for(var i=0;i<this.length;i++){var id=this[i][0];if(typeof id==="number")alreadyImportedModules[id]=true;}for(i=0;i<modules.length;i++){var item=modules[i];// skip already imported module
// this implementation is not 100% perfect for weird media query combinations
//  when a module is imported multiple times with different media queries.
//  I hope this will never occur (Hey this way we have smaller bundles)
if(typeof item[0]!=="number"||!alreadyImportedModules[item[0]]){if(mediaQuery&&!item[2]){item[2]=mediaQuery;}else if(mediaQuery){item[2]="("+item[2]+") and ("+mediaQuery+")";}list.push(item);}}};return list;};function cssWithMappingToString(item,useSourceMap){var content=item[1]||'';var cssMapping=item[3];if(!cssMapping){return content;}if(useSourceMap&&typeof btoa==='function'){var sourceMapping=toComment(cssMapping);var sourceURLs=cssMapping.sources.map(function(source){return'/*# sourceURL='+cssMapping.sourceRoot+source+' */';});return[content].concat(sourceURLs).concat([sourceMapping]).join('\n');}return[content].join('\n');}// Adapted from convert-source-map (MIT)
function toComment(sourceMap){// eslint-disable-next-line no-undef
var base64=btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));var data='sourceMappingURL=data:application/json;charset=utf-8;base64,'+base64;return'/*# '+data+' */';}/***/},/* 2 *//***/function(module,exports,__webpack_require__){/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/var hasDocument=typeof document!=='undefined';if(typeof DEBUG!=='undefined'&&DEBUG){if(!hasDocument){throw new Error('vue-style-loader cannot be used in a non-browser environment. '+"Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");}}var listToStyles=__webpack_require__(24);/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/var stylesInDom={/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/};var head=hasDocument&&(document.head||document.getElementsByTagName('head')[0]);var singletonElement=null;var singletonCounter=0;var isProduction=false;var noop=function noop(){};var options=null;var ssrIdKey='data-vue-ssr-id';// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE=typeof navigator!=='undefined'&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());module.exports=function(parentId,list,_isProduction,_options){isProduction=_isProduction;options=_options||{};var styles=listToStyles(parentId,list);addStylesToDom(styles);return function update(newList){var mayRemove=[];for(var i=0;i<styles.length;i++){var item=styles[i];var domStyle=stylesInDom[item.id];domStyle.refs--;mayRemove.push(domStyle);}if(newList){styles=listToStyles(parentId,newList);addStylesToDom(styles);}else{styles=[];}for(var i=0;i<mayRemove.length;i++){var domStyle=mayRemove[i];if(domStyle.refs===0){for(var j=0;j<domStyle.parts.length;j++){domStyle.parts[j]();}delete stylesInDom[domStyle.id];}}};};function addStylesToDom(styles/* Array<StyleObject> */){for(var i=0;i<styles.length;i++){var item=styles[i];var domStyle=stylesInDom[item.id];if(domStyle){domStyle.refs++;for(var j=0;j<domStyle.parts.length;j++){domStyle.parts[j](item.parts[j]);}for(;j<item.parts.length;j++){domStyle.parts.push(addStyle(item.parts[j]));}if(domStyle.parts.length>item.parts.length){domStyle.parts.length=item.parts.length;}}else{var parts=[];for(var j=0;j<item.parts.length;j++){parts.push(addStyle(item.parts[j]));}stylesInDom[item.id]={id:item.id,refs:1,parts:parts};}}}function createStyleElement(){var styleElement=document.createElement('style');styleElement.type='text/css';head.appendChild(styleElement);return styleElement;}function addStyle(obj/* StyleObjectPart */){var update,remove;var styleElement=document.querySelector('style['+ssrIdKey+'~="'+obj.id+'"]');if(styleElement){if(isProduction){// has SSR styles and in production mode.
// simply do nothing.
return noop;}else{// has SSR styles but in dev mode.
// for some reason Chrome can't handle source map in server-rendered
// style tags - source maps in <style> only works if the style tag is
// created and inserted dynamically. So we remove the server rendered
// styles and inject new ones.
styleElement.parentNode.removeChild(styleElement);}}if(isOldIE){// use singleton mode for IE9.
var styleIndex=singletonCounter++;styleElement=singletonElement||(singletonElement=createStyleElement());update=applyToSingletonTag.bind(null,styleElement,styleIndex,false);remove=applyToSingletonTag.bind(null,styleElement,styleIndex,true);}else{// use multi-style-tag mode in all other cases
styleElement=createStyleElement();update=applyToTag.bind(null,styleElement);remove=function remove(){styleElement.parentNode.removeChild(styleElement);};}update(obj);return function updateStyle(newObj/* StyleObjectPart */){if(newObj){if(newObj.css===obj.css&&newObj.media===obj.media&&newObj.sourceMap===obj.sourceMap){return;}update(obj=newObj);}else{remove();}};}var replaceText=function(){var textStore=[];return function(index,replacement){textStore[index]=replacement;return textStore.filter(Boolean).join('\n');};}();function applyToSingletonTag(styleElement,index,remove,obj){var css=remove?'':obj.css;if(styleElement.styleSheet){styleElement.styleSheet.cssText=replaceText(index,css);}else{var cssNode=document.createTextNode(css);var childNodes=styleElement.childNodes;if(childNodes[index])styleElement.removeChild(childNodes[index]);if(childNodes.length){styleElement.insertBefore(cssNode,childNodes[index]);}else{styleElement.appendChild(cssNode);}}}function applyToTag(styleElement,obj){var css=obj.css;var media=obj.media;var sourceMap=obj.sourceMap;if(media){styleElement.setAttribute('media',media);}if(options.ssrId){styleElement.setAttribute(ssrIdKey,obj.id);}if(sourceMap){// https://developer.chrome.com/devtools/docs/javascript-debugging
// this makes source maps inside style tags work properly in Chrome
css+='\n/*# sourceURL='+sourceMap.sources[0]+' */';// http://stackoverflow.com/a/26603875
css+='\n/*# sourceMappingURL=data:application/json;base64,'+btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))))+' */';}if(styleElement.styleSheet){styleElement.styleSheet.cssText=css;}else{while(styleElement.firstChild){styleElement.removeChild(styleElement.firstChild);}styleElement.appendChild(document.createTextNode(css));}}/***/},/* 3 *//***/function(module,exports){/* globals __VUE_SSR_CONTEXT__ */// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.
module.exports=function normalizeComponent(rawScriptExports,compiledTemplate,functionalTemplate,injectStyles,scopeId,moduleIdentifier/* server only */){var esModule;var scriptExports=rawScriptExports=rawScriptExports||{};// ES6 modules interop
var type=_typeof2(rawScriptExports.default);if(type==='object'||type==='function'){esModule=rawScriptExports;scriptExports=rawScriptExports.default;}// Vue.extend constructor export interop
var options=typeof scriptExports==='function'?scriptExports.options:scriptExports;// render functions
if(compiledTemplate){options.render=compiledTemplate.render;options.staticRenderFns=compiledTemplate.staticRenderFns;options._compiled=true;}// functional template
if(functionalTemplate){options.functional=true;}// scopedId
if(scopeId){options._scopeId=scopeId;}var hook;if(moduleIdentifier){// server build
hook=function hook(context){// 2.3 injection
context=context||// cached call
this.$vnode&&this.$vnode.ssrContext||// stateful
this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext;// functional
// 2.2 with runInNewContext: true
if(!context&&typeof __VUE_SSR_CONTEXT__!=='undefined'){context=__VUE_SSR_CONTEXT__;}// inject component styles
if(injectStyles){injectStyles.call(this,context);}// register component module identifier for async chunk inferrence
if(context&&context._registeredComponents){context._registeredComponents.add(moduleIdentifier);}};// used by ssr in case component is cached and beforeCreate
// never gets called
options._ssrRegister=hook;}else if(injectStyles){hook=injectStyles;}if(hook){var functional=options.functional;var existing=functional?options.render:options.beforeCreate;if(!functional){// inject component registration as beforeCreate hook
options.beforeCreate=existing?[].concat(existing,hook):[hook];}else{// for template-only hot-reload because in that case the render fn doesn't
// go through the normalizer
options._injectStyles=hook;// register for functioal component in vue file
options.render=function renderWithStyleInjection(h,context){hook.call(context);return existing(h,context);};}}return{esModule:esModule,exports:scriptExports,options:options};};/***/},/* 4 *//***/function(module,exports,__webpack_require__){module.exports=__webpack_require__(28);/***/},/* 5 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__FastLivePlayer_vue__=__webpack_require__(25);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__LivePlayer_vue__=__webpack_require__(49);/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__RtcPlayer_vue__=__webpack_require__(53);/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__vodPlayer_index_vue__=__webpack_require__(59);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4_axios__=__webpack_require__(4);/* harmony import */var __WEBPACK_IMPORTED_MODULE_4_axios___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__js_base64__=__webpack_require__(75);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */__webpack_exports__["a"]={props:{videoPoster:{type:String,default:''},initData:{type:Object,default:function _default(){}},fans_id:{type:Number|String,default:0},staff_id:{type:[Number,String],default:0},videoIndex:{type:Number,default:0},showWatermark:{type:Boolean,default:false},showH5Xianlu:{type:Boolean,default:false},playerid:{type:String,default:''},isWhitebord:{type:Boolean,default:false},isThreeScreen:{type:Boolean,default:false},isMiniWindow:{type:Boolean,default:false},isShowMiniWindowIcon:{type:Boolean,default:false},nick:{type:String,default:''},remark:{type:String,default:''},runObj:{type:Object,default:function _default(){return{};}},copyrightObj:{type:Object,default:function _default(){return{};}},isThird:{type:Boolean,default:true}},watch:{fans_id:function fans_id(to,from){console.error("fans_id变化了");},initData:{handler:function handler(to,from){if(to&&to.direct_seeding&&to.direct_seeding.ds_id){console.error("to",to);// console.error("解密==23332==", this.decodeBase64("bHS0dDpvM2ypemWwcGG5MnSlcmemZWOlMmOvcS:sbX[lMzRwOzZzY3SlcmemZWOlY2ypemWfNTJwPF9zNTJ4OF9xMm[seg>="))
this.fakeLive=to.fakeLive||false;this.videoImg=to.direct_seeding.pic_url;var play_style=to.direct_seeding.play_style;this.isRTC=play_style!="1";//1.高延时直播 2.竖屏直播 3.低延时 4.互动课堂 5.三分屏
this.ds_id=to.direct_seeding.ds_id;this.box_info_play_type=to.box_info.play_type;this.isVertical=play_style=="2";//竖屏直播
// 获取直播是否需要上报播放数据
this.getShouldReport(to.direct_seeding.im_type);//默认播放方式
if(this.box_info_play_type=="rtc"){this.netPlayType="rtc";}if(this.netDsList[this.ds_id]&&this.netDsList[this.ds_id].playType){this.netPlayType=this.netDsList[this.ds_id].playType;}this.push_user=to.box_info.current_uid;this.videoPlayList=to.direct_seeding.break_point;if(to.direct_seeding.direct_status=="end"){this.liveStatus=3;}else if(to.direct_seeding.direct_status=="running"){var pull=JSON.parse(to.box_info.pull_stream_url)||{};if(this.isWhitebord){pull=JSON.parse(to.box_info.wb_pull_stream_url)||{};}var playDataTmp={pull_url_hls:this.isWhitebord?pull.wb_m3u8_url:pull.m3u8_url,pull_url_flv:this.isWhitebord?pull.wb_flv_url:pull.flv_url,play_url_web_rtc:this.isWhitebord?pull.wb_play_url_web_rtc:pull.play_url_web_rtc};console.log("playDataTmp==11111==>",JSON.stringify(playDataTmp));var channel_id=this.isWhitebord?to.box_info.wb_channel_id:to.box_info.channel_id;if(to.direct_seeding.encodeType==1){//需要解密
playDataTmp={pull_url_hls:this.decodeBase64(playDataTmp.pull_url_hls),pull_url_flv:this.decodeBase64(playDataTmp.pull_url_flv),play_url_web_rtc:this.decodeBase64(playDataTmp.play_url_web_rtc)};channel_id=this.decodeBase64(channel_id);}console.log("playDataTmp==2222==>",playDataTmp);// 没有快直播链接构造一个
if(!playDataTmp.play_url_web_rtc){playDataTmp.play_url_web_rtc='webrtc://liveplay.tengface.com/live/'+channel_id;// if (this.isshanhu) {
//   playDataTmp.play_url_web_rtc = 'webrtc://liveplay.shanhuketang.com/live/' + channel_id;
// }
}this.playData=playDataTmp;this.liveStatus=2;}else if(to.direct_seeding.direct_status=="not_started"){this.liveStatus=1;this.showCover=true;}}},immediate:true},videoIndex:function videoIndex(to,from){var _this=this;if(to==-1){return;}this.showCover=false;if(this.liveStatus==3||this.liveStatus==1){//结束 未开始
if(this.initData.direct_seeding.direct_status=="running"){this.videoStatus=4;// 直播时播放点播视频又切换成直播时
if(to==0){this.$refs.vodPlayer.pause();this.liveStatus=2;if(this.isRTC&&this.isSupportRTC&&!this.isWhitebord){this.selectPlayType=1;this.$refs.rtcPlayer.playRtc();}else{this.selectPlayType=2;this.$refs.livePlayer.playLive(this.playData);}return;}}if(this.videoPlayList&&this.videoPlayList.length>0){this.videoStatus=4;this.selectPlayType=4;this.$refs.vodPlayer.playVod(this.videoPlayList,to);}else{this.showCover=true;this.videoStatus=1;if(this.initData.direct_seeding.direct_status=="end"){this.liveStatus=3;}else{this.liveStatus=1;}}}else{if(to===0){this.$refs.vodPlayer.pause();this.liveStatus=2;if(this.isRTC&&this.isSupportRTC&&!this.isWhitebord){this.selectPlayType=1;//rtc
this.$refs.rtcPlayer.playRtc();}else{this.selectPlayType=2;this.$refs.livePlayer.playLive(this.playData);}}else{// 直播时播放点播视频时
if(this.isRTC&&this.isSupportRTC&&!this.isWhitebord){this.$refs.fastLivePlayer.stopPlay();if(this.$refs.rtcPlayer){this.$refs.rtcPlayer.rtcLiveLeave();}}else{this.$refs.fastLivePlayer.stopPlay();this.$refs.livePlayer.stopPlay();}this.liveStatus=3;if(this.videoPlayList&&this.videoPlayList.length>0){this.selectPlayType=4;setTimeout(function(){_this.videoStatus=4;},100);this.$refs.vodPlayer.playVod(this.videoPlayList,to);}}}}},components:{LivePlayer:__WEBPACK_IMPORTED_MODULE_1__LivePlayer_vue__["a"/* default */],RtcPlayer:__WEBPACK_IMPORTED_MODULE_2__RtcPlayer_vue__["a"/* default */],VodePlayer:__WEBPACK_IMPORTED_MODULE_3__vodPlayer_index_vue__["a"/* default */],FastLivePlayer:__WEBPACK_IMPORTED_MODULE_0__FastLivePlayer_vue__["a"/* default */]},computed:{playType:function playType(){// 确定直播使用的播放方式  1 为rtc直播   2 为普通直播   3 为快直播   4为点播
if(this.selectPlayType!==0){return this.selectPlayType;}if(this.liveStatus!=2){return 4;}if(this.fakeLive){if(this.isSupportFastLive){return 3;}else{return 2;}}else{if(this.initData.direct_seeding.play_style==1){return 2;}else{if(this.isRTC&&this.isSupportRTC&&this.liveStatus==2){if(this.netPlayType=='fast'&&!this.isLink){return 3;}else{return 1;}}else{if(this.isSupportFastLive){return 3;}else{return 2;}}}}}},created:function created(){var _this2=this;return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var posturl,data,u;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:__WEBPACK_IMPORTED_MODULE_4_axios___default.a.default.timeout=5000;// 全局配置  5秒加载不出来报错
_context.prev=1;//加载推荐播放模式
posturl='https://shkt-online-live-1317978474.cos.accelerate.myqcloud.com/web/config/playType.json?id='+new Date().valueOf();_context.next=5;return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(posturl);case 5:data=_context.sent;if(data.data&&data.data.playType){_this2.netPlayType=data.data.playType;_this2.canPlayH265=data.data.canPlayH265;if(_this2.box_info_play_type=="rtc"&&!_this2.isWhitebord){_this2.netPlayType="rtc";}_this2.netDsList=data.data.extList;if(_this2.ds_id&&_this2.netDsList[_this2.ds_id]&&_this2.netDsList[_this2.ds_id].playType){_this2.netPlayType=_this2.netDsList[_this2.ds_id].playType;}}_context.next=11;break;case 9:_context.prev=9;_context.t0=_context["catch"](1);case 11:u=navigator.userAgent;if(u.indexOf("Android")>0||u.indexOf("Linux")>0||u.indexOf("iPhone")>0||u.indexOf("Windows Phone")>0){//电脑版调转到PC页面
_this2.isPc=false;}else{_this2.isPc=true;}case 13:case"end":return _context.stop();}}},_callee,_this2,[[1,9]]);}))();},mounted:function mounted(){console.log("版本号====12.3.41");console.log("播放器组件创建===",this.playerid);},data:function data(){return{isPc:false,fakeLive:false,//是否是伪直播
ds_id:0,showCover:true,liveStatus:1,//  1 未开始 2 进行中  3 已结束
videoStatus:1,// 1 未加载 2 播放中  3 暂停   4 加载中
videoImg:"",netPlayType:'fast',netDsList:{},isRTC:false,isSupportRTC:true,isSupportFastLive:true,push_user:0,playData:null,videoPlayList:[],isLink:false,selectPlayType:0,shouldReportLiveInfo:false,// 是否需要上报播放日志
box_info_play_type:"",isVertical:false,canPlayH265:true//是否支持h265
};},methods:{getShouldReport:function getShouldReport(im_type){var _this3=this;var url="https://liveapi2.tenghuiwangxiao.cn/api/init/qryDsConfig?ds_id="+this.ds_id;if(im_type==2){url="https://live.shanhuketang.com/liveapi/api/init/qryDsConfig?ds_id="+this.ds_id;}__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then(function(res){if(res.data&&res.data.data){var list=res.data.data;list.forEach(function(item){if(item.key==='report_live_info'){if(item.value==='true'){_this3.shouldReportLiveInfo=true;}else{_this3.shouldReportLiveInfo=false;}}});}}).catch(function(res){});},playFailed:function playFailed(data){// 播放失败了的回调
this.$emit('playFailed',this.playType,data);},getPlayerIsfullScreen:function getPlayerIsfullScreen(){if(this.playType==3){return this.$refs.fastLivePlayer.getPlayerIsfullScreen();}return false;},exitFullScreen:function exitFullScreen(){if(this.playType==3){return this.$refs.fastLivePlayer.exitFullScreen();}return false;},changePlayType:function changePlayType(type){var _this4=this;console.error("changePlayType",type);if(this.playType==1){this.$refs.rtcPlayer.rtcLiveLeave(function(){_this4.selectPlayType=type;_this4.playVideoClicked();});}else if(this.playType==2){this.$refs.livePlayer.stopPlay();this.selectPlayType=type;this.playVideoClicked();}else if(this.playType==3){this.$refs.fastLivePlayer.stopPlay();this.selectPlayType=type;this.playVideoClicked();}},toStop:function toStop(){this.videoStatus=1;this.showCover=true;console.log("切换视频toStop");},isSupportFastLiveCallback:function isSupportFastLiveCallback(isSupportFastLive){console.log("isSupportFastLive",isSupportFastLive);this.isSupportFastLive=isSupportFastLive;},playVideoClickedBtn:function playVideoClickedBtn(){this.playVideoClicked();this.$emit('playerBtnClick',this.playerid);},playVideoClicked:function playVideoClicked(){if(this.liveStatus==1||this.liveStatus==3){if(!this.videoPlayList||this.videoPlayList.length<1){if(!this.fakeLive){this.$emit('unAutoPlay',{message:'直播未开始',type:'info'});}else{this.$emit('unAutoPlay',{message:'当前未直播',type:'info'});}return;}else{this.$refs.vodPlayer.playVod(this.videoPlayList);this.showCover=false;this.videoStatus=4;}return;}if(this.liveStatus==2){this.showCover=false;this.videoStatus=4;if(this.selectPlayType!==0){if(this.selectPlayType==1){this.$refs.rtcPlayer.playRtc();}else if(this.selectPlayType==2){this.$refs.livePlayer.playLive(this.playData);}else if(this.selectPlayType==3){this.$refs.fastLivePlayer.playLive(this.playData);}return;}if(this.fakeLive){//伪直播设置
if(this.isSupportFastLive){this.$refs.fastLivePlayer.playLive(this.playData);}else{this.$refs.livePlayer.playLive(this.playData);}}else{if(this.initData.direct_seeding.play_style==1){this.$refs.livePlayer.playLive(this.playData);}else{if(this.isRTC&&this.isSupportRTC){if(!this.isLink&&this.netPlayType=='fast'&&this.isSupportFastLive){this.$refs.fastLivePlayer.playLive(this.playData);}else{this.$refs.rtcPlayer.playRtc();}}else{if(this.isSupportFastLive){this.$refs.fastLivePlayer.playLive(this.playData);}else{this.$refs.livePlayer.playLive(this.playData);}}}}return;}},playerRefresh:function playerRefresh(){if(this.playType==1){this.$refs.rtcPlayer.shuaxingCliked();}if(this.playType==2){this.$refs.livePlayer.shuaxingCliked();}if(this.playType==3){this.$refs.fastLivePlayer.shuaxingCliked();}},rtcLiveLeave:function rtcLiveLeave(callback){this.$refs.rtcPlayer.rtcLiveLeave(callback);},isSupportRTCCallback:function isSupportRTCCallback(value){this.isSupportRTC=value;},getIsSupportRTCLink:function getIsSupportRTCLink(){return this.isSupportRTC;},statusChange:function statusChange(to){console.log("点前播放模式statusChange",to);this.videoStatus=to;this.$emit("statusChange",to,this.playType);if(to==3){this.showCover=true;}},rtcLink:function rtcLink(){var _this5=this;// 判断当先播放是什么播放模式
console.log("点前播放模式===",this.playType);console.log("点前播放模式===",this.selectPlayType);if(this.playType==3){this.$refs.fastLivePlayer.stopPlay();}this.isLink=true;this.netPlayType='rtc';if(this.selectPlayType!==0&&this.selectPlayType!==1){if(this.playType==2){this.$refs.livePlayer.stopPlay();this.selectPlayType=1;}else if(this.playType==3){this.$refs.fastLivePlayer.stopPlay();this.selectPlayType=1;}}//RTC上麦
this.$refs.rtcPlayer.rtcLink(function(_ref){var isOK=_ref.isOK,data=_ref.data;if(isOK){_this5.$emit("linkTypeChange",3);}});},rtcLinkDown:function rtcLinkDown(){//RTC下麦
console.log("下麦操作");this.isLink=false;this.$refs.rtcPlayer.rtcLinkDown();this.$emit("linkTypeChange",1);},unAutoPlay:function unAutoPlay(errorData){this.$emit("unAutoPlay",errorData);},errorReport:function errorReport(data){var _this6=this;return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var postData;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:postData={fans_id:_this6.fans_id,error_code:""+data.error_code,ds_id:_this6.ds_id,uid:_this6.push_user,data:data};_context2.prev=1;_context2.next=4;return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://report.tenghuiwangxiao.cn/app/report/errorReport',postData);case 4:_context2.next=8;break;case 6:_context2.prev=6;_context2.t0=_context2["catch"](1);case 8:case"end":return _context2.stop();}}},_callee2,_this6,[[1,6]]);}))();},playerListener:function playerListener(data){this.$emit('playerListener',data);},decodeBase64:function decodeBase64(data){var orginData=data;if(data){try{var base64codeStr="";for(var i=0;i<data.length;i++){var charcodeStr=data[i];if(i%2==0){var charCodeNum=data.charCodeAt(i)-1;charcodeStr=String.fromCharCode(charCodeNum);}base64codeStr=""+base64codeStr+charcodeStr;}orginData=window.atob?window.atob(base64codeStr):Object(__WEBPACK_IMPORTED_MODULE_5__js_base64__["a"/* base64_decode */])(base64codeStr);}catch(error){}}return orginData;},getCurrentTime:function getCurrentTime(){if(this.$refs.vodPlayer){return this.$refs.vodPlayer.getCurrentTime();}return 0;},getDuration:function getDuration(){if(this.$refs.vodPlayer){return this.$refs.vodPlayer.getDuration();}return 0;},setCurrentTime:function setCurrentTime(time){if(this.$refs.vodPlayer){this.$refs.vodPlayer.setCurrentTime(time);}},pause:function pause(){if(this.$refs.vodPlayer){this.$refs.vodPlayer.pause();}},play:function play(){if(this.$refs.vodPlayer){this.$refs.vodPlayer.play();}},changePlaySpeed:function changePlaySpeed(value){if(this.$refs.vodPlayer){this.$refs.vodPlayer.changePlaySpeed(value);}}}};/***/},/* 6 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_axios__=__webpack_require__(4);/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_axios___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__js_DetectRTC__=__webpack_require__(46);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__js_DetectRTC___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__js_DetectRTC__);var _props;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import volumebar from "./components/volumebar.vue";
/* harmony default export */__webpack_exports__["a"]={props:(_props={fakeLive:{type:[Number,Boolean],default:false},ds_id:{type:[Number,String],default:0},shouldReportLiveInfo:{type:[Boolean,String],default:false},staff_id:{type:[Number,String],default:0},showWatermark:{type:Boolean,default:false},showH5Xianlu:{type:Boolean,default:false},playerid:{type:String,default:''},isWhitebord:{type:Boolean,default:false},isThreeScreen:{type:Boolean,default:false},isMiniWindow:{type:Boolean,default:false},isShowMiniWindowIcon:{type:Boolean,default:false},isVertical:{type:Boolean,default:false},fans_id:{type:Number|String,default:0},nick:{type:String,default:''},remark:{type:String,default:''}},_defineProperty(_props,'ds_id',{type:[Number,String],default:0}),_defineProperty(_props,'shouldReportLiveInfo',{type:[Boolean,String],default:false}),_defineProperty(_props,'runObj',{type:Object,default:function _default(){}}),_defineProperty(_props,'copyrightObj',{type:Object,default:function _default(){}}),_defineProperty(_props,'isThird',{type:Boolean,default:true}),_props),beforeDestroy:function beforeDestroy(){this.stopPlayerTime();clearInterval(this.intervalID);},// components:{
//   volumebar
// },
mounted:function mounted(){var _this=this;this.intervalID=setInterval(this.moveBox,80);__WEBPACK_IMPORTED_MODULE_1__js_DetectRTC___default.a.support(function(res){if(res.h264Support&&res.support&&!_this.isAndroidLowerVersion()){_this.$emit("isSupportFastLive",true);}else{_this.$emit("isSupportFastLive",false);}});//iOS设备全屏
if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){this.$refs.fastVideo.addEventListener("webkitendfullscreen",function(e){setTimeout(function(){_this.$emit("toStop");_this.$emit("unAutoPlay",{message:'当前浏览器不支持自动播放，请点击播放按钮观看直播',type:511});},300);});}this.$refs.fastVideo.addEventListener("playing",function(e){_this.playStatus=2;_this.showLoading=false;console.log("fastVideo playing",e);});this.$refs.fastVideo.addEventListener('error',function(e){console.log("fastVideo error",e);});this.$refs.fastVideo.addEventListener('loadstart',function(e){console.log("fastVideo loadstart",e);});this.$refs.fastVideo.addEventListener('waiting',function(e){_this.showLoading=true;console.log("fastVideo waiting",e);});this.$refs.fastVideo.addEventListener("canplay",_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('canplay触发');// 这里是自动播放逻辑
_context.prev=1;_this.mouseOver();_context.next=5;return _this.$refs.fastVideo.play();case 5:_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);console.error('canplay触发error',_context.t0);setTimeout(function(){_this.$emit("toStop");_this.$emit("unAutoPlay",{message:'当前浏览器不支持自动播放，请点击播放按钮观看直播',type:511});},300);case 11:case'end':return _context.stop();}}},_callee,_this,[[1,7]]);})));var u=navigator.userAgent;if(u.indexOf("Android")>0||u.indexOf("Linux")>0||u.indexOf("iPhone")>0||u.indexOf("Windows Phone")>0){//电脑版调转到PC页面
this.isPc=false;}else{this.isPc=true;this.$nextTick(function(){document.addEventListener('fullscreenchange',function(v){var isfullScreen=document.fullScreen||document.webkitIsFullScreen||document.mozFullScreen||document.msFullScreen;if(!isfullScreen){_this.isfullScreen=false;}});});}},computed:{objectFit:function objectFit(){if(this.isVertical){if(!this.isPc){return'cover';}}return'contain';}},watch:{playData:function playData(to,from){},playStatus:function playStatus(to,from){this.$emit("statusChange",to);},showWatermark:function showWatermark(to,from){var _this2=this;this.$nextTick(function(){if(to&&!_this2.showWatermarkTimer){_this2.showWatermarkTimer=setInterval(function(){if(!_this2.showWatermark){clearInterval(_this2.showWatermarkTimer);_this2.showWatermarkTimer=null;return;}var id_fast_video_watermark=document.getElementById("id_fast_video_watermark");if(_this2.$refs.livePlayer){if(id_fast_video_watermark){_this2.$refs.livePlayer.removeChild(id_fast_video_watermark);}var id_fast_video_watermark2=document.createElement("div");id_fast_video_watermark2.id="id_fast_video_watermark";id_fast_video_watermark2.innerText='\u52A9\u6559ID:'+_this2.staff_id;id_fast_video_watermark2.setAttribute("style","position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);text-align: center;font-size: 89px;color: black;white-space:nowrap;min-width: 300px;min-height: 100px;background-color: red;word-break: break-word;");console.log(_this2.$refs.livePlayer.firstChild);_this2.$refs.livePlayer.insertBefore(id_fast_video_watermark2,_this2.$refs.livePlayer.firstChild);}},600000);}});},isfullScreen:function isfullScreen(to,from){if(this.showWatermark){var id_fast_video_watermark=document.getElementById("id_fast_video_watermark");if(id_fast_video_watermark){if(to){id_fast_video_watermark.style.fontSize="200px";}else{id_fast_video_watermark.style.fontSize="89px";}}}}},data:function data(){return{rotateRunBox:false,isPc:false,player:null,streamUrl:"",streamId:"",svrSig:"",isMuted:false,playStatus:1,//1 未播放  2正在播放
peerConnection:null,showControns:false,isfullScreen:false,timer:null,isShuaxing:false,playData:null,showXianLuBox:false,trackAudio:null,trackVideo:null,errorTimer:null,videoStatsTime:null,audioStatsTime:null,playTimer:null,isShowHud:false,boxLeft:10,// 初始左边距离
boxTop:10,// 初始顶部距离
winMax:10,// 设置最大视觉差
sx:0,// x轴移动状态，0表示正向移动，1表示返回
sy:0,// y轴移动状态，0表示正向移动，1表示返回
intervalID:null,// setInterval 的 ID
showLoading:false,isPad:/iPad/i.test(window.navigator.userAgent)||window.navigator.platform==='MacIntel'&&window.navigator.maxTouchPoints>1};},methods:{getVolumeValue:function getVolumeValue(value){if(value==0){this.isMuted=true;}else{this.isMuted=false;}this.$refs.fastVideo.volume=value;},moveBox:function moveBox(){// 获取 runBox 的宽度和高度
var runBox=this.$refs.runBoxRef;if(runBox&&runBox.offsetWidth){var runBoxWidth=runBox.offsetWidth;var runBoxHeight=runBox.offsetHeight;// 计算盒子在x轴上最远达到的距离
var winx=runBoxWidth-42-this.winMax;// 100 是盒子的宽度
// 计算盒子在y轴上最远达到的距离
var winy=runBoxHeight-24-this.winMax;// 100 是盒子的高度
// x轴移动
if(this.sx===0){this.boxLeft++;}else{this.boxLeft--;}if(this.boxLeft<=0){this.sx=0;}else if(this.boxLeft>=winx){this.sx=1;}// y轴移动
if(this.sy===0){this.boxTop++;}else{this.boxTop--;}if(this.boxTop<=0){this.sy=0;}else if(this.boxTop>=winy){this.sy=1;}}},isAndroidLowerVersion:function isAndroidLowerVersion(){var isWexin=navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=="micromessenger";var isAndroid=navigator.userAgent.indexOf("Android")>0;var android_ver=navigator.userAgent.toLowerCase().match(/android (.*?);/i);var number=10;if(android_ver){try{number=parseInt(android_ver[1].split(".")[0]);}catch(error){number=10;}}if(!isWexin&&isAndroid&&number<9){console.error("[播放器日志] 不支持快直播");return true;}return false;},startPlayerTime:function startPlayerTime(){var _this3=this;if(this.playTimer){clearInterval(this.playTimer);this.playTimer=null;}this.playTimer=setInterval(_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var videoElement,_data,videoStats,audioStats,videoSelector,audioSelector,statsOutput,_statsOutput;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!_this3.shouldReportLiveInfo){_context2.next=67;break;}videoElement=_this3.$refs.fastVideo;_data={};_data['video_volume']=videoElement.volume;_data['video_mute']=videoElement.muted;_data['play_type']='fast';_data['error_code']='50000';videoStats=null;audioStats=null;if(!(_this3.peerConnection.getRemoteStreams().length==0)){_context2.next=18;break;}videoStats='this.peerConnection.getRemoteStreams().length 等于0';audioStats='this.peerConnection.getRemoteStreams().length 等于0';_data['videoStats']=videoStats;_data['audioStats']=audioStats;_data['vdieo_track']=_this3.trackVideo.id;_data['audio_track']=_this3.trackAudio.id;_this3.$emit('errorReport',_data);return _context2.abrupt('return');case 18:if(!(_this3.peerConnection.getRemoteStreams()[0].getVideoTracks()==0)){_context2.next=27;break;}videoStats='this.peerConnection.getRemoteStreams()[0].getVideoTracks() 等于0';audioStats='this.peerConnection.getRemoteStreams()[0].getVideoTracks() 等于0';_data['videoStats']=videoStats;_data['audioStats']=audioStats;_data['vdieo_track']=_this3.trackVideo.id;_data['audio_track']=_this3.trackAudio.id;_this3.$emit('errorReport',_data);return _context2.abrupt('return');case 27:if(!(_this3.peerConnection.getRemoteStreams()[0].getAudioTracks()==0)){_context2.next=36;break;}videoStats='this.peerConnection.getRemoteStreams()[0].getAudioTracks() 等于0';audioStats='this.peerConnection.getRemoteStreams()[0].getAudioTracks() 等于0';_data['videoStats']=videoStats;_data['audioStats']=audioStats;_data['vdieo_track']=_this3.trackVideo.id;_data['audio_track']=_this3.trackAudio.id;_this3.$emit('errorReport',_data);return _context2.abrupt('return');case 36:videoSelector=_this3.peerConnection.getRemoteStreams()[0].getVideoTracks()[0];audioSelector=_this3.peerConnection.getRemoteStreams()[0].getAudioTracks()[0];_context2.prev=38;_context2.next=41;return _this3.peerConnection.getStats(videoSelector);case 41:videoStats=_context2.sent;statsOutput={};videoStats.forEach(function(report){statsOutput[report['id']]=report;});videoStats=statsOutput;_context2.next=50;break;case 47:_context2.prev=47;_context2.t0=_context2['catch'](38);videoStats=_context2.t0;case 50:_context2.prev=50;_context2.next=53;return _this3.peerConnection.getStats(audioSelector);case 53:audioStats=_context2.sent;_statsOutput={};audioStats.forEach(function(report){_statsOutput[report['id']]=report;});audioStats=_statsOutput;_context2.next=62;break;case 59:_context2.prev=59;_context2.t1=_context2['catch'](50);audioStats=_context2.t1;case 62:_data['videoStats']=videoStats;_data['audioStats']=audioStats;_data['vdieo_track']=_this3.trackVideo.id;_data['audio_track']=_this3.trackAudio.id;_this3.$emit('errorReport',_data);case 67:case'end':return _context2.stop();}}},_callee2,_this3,[[38,47],[50,59]]);})),5000);},stopPlayerTime:function stopPlayerTime(){if(this.playTimer){clearInterval(this.playTimer);this.playTimer=null;}},changePlayType:function changePlayType(type){this.$emit('changePlayType',type);},mouseOver:function mouseOver(){var _this4=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this4.showControns=false;_this4.showXianLuBox=false;},5000);},mousemove:function mousemove(){var _this5=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this5.showControns=false;_this5.showXianLuBox=false;},5000);},mouseLeave:function mouseLeave(){var _this6=this;this.timer=setTimeout(function(){_this6.showControns=false;_this6.showXianLuBox=false;},5000);},shuaxingCliked:function shuaxingCliked(){var _this7=this;if(!this.isShuaxing){this.isShuaxing=true;this.stopPlay();setTimeout(function(){_this7.playLive(_this7.playData);_this7.isShuaxing=false;},500);}},jingyingClicked:function jingyingClicked(){if(this.isMuted){this.isMuted=false;this.$refs.fastVideo.muted=false;// if (this.$refs.volumebar) {
//     this.$refs.volumebar.setValue(this.$refs.fastVideo.volume)
// }
}else{this.isMuted=true;this.$refs.fastVideo.muted=true;// if (this.$refs.volumebar) {
//     this.$refs.volumebar.setValue(0)
// }
}},quanpingCliked:function quanpingCliked(){// 苹果手机只要点击就是全屏
if(!this.isfullScreen||this.checkPhoneType()==2){this.enterFullScreen();}else{this.exitFullScreen();}},enterFullScreen:function enterFullScreen(){//   console.log(5461654894178);
//  if(this.checkPhoneType()!=3){
//      this.rotateRunBox = true;
//               // 获取视口的宽度和高度
//     const viewportWidth = window.innerWidth;
//     const viewportHeight = window.innerHeight;
//     const copyrightElements = document.querySelectorAll('.copyright');
//     copyrightElements.forEach(element => {
//         element.style.width = `${viewportHeight}px`;
//         element.style.transformOrigin = 'top left';
//         // 平移盒子的效果
//         const translateXValue = viewportWidth;
//         element.style.transform = `rotate(90deg) translateY(-${translateXValue}px)`;
//     });
//  }
var livePlayer=this.$refs.livePlayer;var fastVideo=this.$refs.fastVideo;if(livePlayer.requestFullscreen){this.isfullScreen=true;livePlayer.requestFullscreen();return;}else if(livePlayer.mozRequestFullScreen){this.isfullScreen=true;livePlayer.mozRequestFullScreen();return;}else if(livePlayer.webkitRequestFullscreen){this.isfullScreen=true;livePlayer.webkitRequestFullscreen();return;}else if(fastVideo.webkitEnterFullscreen){this.isfullScreen=true;fastVideo.webkitEnterFullscreen();return;}else if(livePlayer.msRequestFullscreen){this.isfullScreen=true;livePlayer.msRequestFullscreen();return;}this.$emit("unAutoPlay",{message:'全屏播放失败',type:'error'});},exitFullScreen:function exitFullScreen(){// this.rotateRunBox = false;
// // 还原盒子样式
//   const copyrightElements = document.querySelectorAll('.copyright');
//   copyrightElements.forEach(element => {
//         element.style.width = '100%'; // 还原宽度
//         element.style.transformOrigin = ''; // 还原变换原点
//         element.style.transform = ''; // 还原变换
//   });
var fastVideo=this.$refs.fastVideo;this.isfullScreen=false;if(document.exitFullscreen){return document.exitFullscreen();}else if(document.cancelFullScreen){document.cancelFullScreen();}else if(document.mozCancelFullScreen){return document.mozCancelFullScreen();}else if(fastVideo.webkitCancelFullScreen){return fastVideo.webkitCancelFullScreen();}else if(document.msCancelFullScreen){return document.msCancelFullScreen();}else if(document.msExitFullscreen){return document.msExitFullscreen();}this.$emit("unAutoPlay",{message:'退出全屏失败',type:'error'});},getPlayerIsfullScreen:function getPlayerIsfullScreen(){return this.isfullScreen;},checkPhoneType:function checkPhoneType(){var u=navigator.userAgent;// 1是安卓机 2 是苹果机	3 未知机型 4 winphone
if(u.indexOf("Android")>-1||u.indexOf("Linux")>-1){//安卓手机
return 1;}else if(u.indexOf("iPhone")>-1){//苹果手机
return 2;}else if(u.indexOf("Windows Phone")>-1){//winphone手机
return 4;}else{return 3;}},playLive:function playLive(playData){var _this8=this;console.log('copyrightObj: ',this.copyrightObj);this.$refs.fastVideo.play();this.startPlayerTime();__WEBPACK_IMPORTED_MODULE_1__js_DetectRTC___default.a.support(function(res){if(res.h264Support&&res.support){}else{_this8.playFailedFunc(data);return;}});if(this.peerConnection){this.peerConnection.close();}if(playData){this.playData=playData;}this.streamUrl=playData.play_url_web_rtc;this.streamId=this.getStreamId(this.streamUrl);var config={iceServers:[],bundlePolicy:"max-bundle",rtcpMuxPolicy:"require",tcpCandidatePolicy:"disable",IceTransportsType:"nohost",sdpSemantics:"unified-plan"};var optional={optional:[{DtlsSrtpKeyAgreement:true}]};var offerSdpOption={offerToReceiveAudio:true,offerToReceiveVideo:true,voiceActivityDetection:false};var peerConnection=new RTCPeerConnection(config,optional);this.peerConnection=peerConnection;this.peerConnection.onicecandidate=function(e){};this.peerConnection.onaddstream=function(e){};this.peerConnection.onremovestream=function(e){};this.peerConnection.ontrack=function(e){console.log("peerConnection.ontrack, kind:"+e.track.kind+",track.id:"+e.track.id,e);var track=e.track;if(track.kind=="audio"){_this8.trackAudio=track;}if(track.kind=="video"){_this8.trackVideo=track;}if(!_this8.peerConnection.stream){_this8.peerConnection.streamId=_this8.streamId;_this8.peerConnection.stream=new MediaStream();_this8.peerConnection.stream.addTrack(track);_this8.onAddStream(_this8.peerConnection);}else{console.log("onAddStream",track,_this8.peerConnection.stream);// 把原来的音视频流处理好
if(track.kind=="audio"){var audioTrack=_this8.peerConnection.stream.getAudioTracks();console.log("audioTrack",audioTrack);if(audioTrack.length>0){_this8.peerConnection.stream.removeTrack(audioTrack[0]);}}if(track.kind=="video"){var videoTrack=_this8.peerConnection.stream.getVideoTracks();console.log("videoTrack",videoTrack);if(videoTrack.length>0){_this8.peerConnection.stream.removeTrack(videoTrack[0]);}}_this8.peerConnection.stream.addTrack(track);_this8.onAddStream(_this8.peerConnection);console.log("track.lenght:"+_this8.peerConnection.stream.getTracks().length);}};this.peerConnection.onconnectionstatechange=function(e){console.log("链接状态变化",e.target.connectionState);switch(e.target.connectionState){case"connecting":console.log("正在连接");break;case"connected":// The connection has become fully connected
console.error("连接成功");_this8.$emit('fastConnected');break;case"disconnected":console.log("失去链接");if(_this8.playStatus==2){_this8.$emit('errorReport',{error_code:611,message:'webrtc失去链接'});}break;case"failed":// One or more transports has terminated unexpectedly or in an error
console.log("链接失败");if(_this8.playStatus==2){_this8.$emit('errorReport',{error_code:612,message:'webrtc链接失败'});}_this8.playLive(_this8.playData);break;case"closed":// The connection has been closed
console.log("关闭连接");break;}};this.peerConnection.oniceconnectionstatechange=function(e){console.log("oniceconnectionstatechange 链接状态变化 "+e.target.connectionState);switch(e.target.connectionState){case"connected":// The connection has become fully connected
console.log("连接成功");break;case"disconnected":console.log("失去链接");break;case"failed":// One or more transports has terminated unexpectedly or in an error
console.log("链接失败");break;case"closed":// The connection has been closed
console.log("关闭连接");break;case"connecting":console.log("正在连接");break;}};this.peerConnection.onicegatheringstatechange=function(e){};this.peerConnection.onsignalingstatechange=function(e){};this.peerConnection.onnegotiationneeded=function(e){};this.peerConnection.createOffer(offerSdpOption).then(function(offer){offer.sdp=offer.sdp.split('\r\n').map(function(item){return item.includes('a=fmtp:111')?item+';stereo=1':item;}).join('\r\n');_this8.peerConnection.setLocalDescription(offer);var url="https://overseas-webrtc.liveplay.myqcloud.com/webrtc/v1/pullstream";var sessionId="sessionId_Test";var clientInfo="clientinfo_test";var reqBody={streamurl:_this8.streamUrl,sessionid:sessionId,clientinfo:clientInfo,localsdp:offer};__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url,reqBody,{timeout:3000}).then(function(res){var data=res.data;var errCode=data.errcode;var errMsg=data.errmsg;if(errCode!=0){_this8.playFailedFunc(data);return;}var remoteSdp=data.remotesdp;_this8.svrSig=data.svrsig;_this8.peerConnection.setRemoteDescription(new RTCSessionDescription(remoteSdp),function(){// console.log("setRemoteSdp succ!");
},function(e){// console.log("setRemoteSdp failed, exception = " + e.message);
});// 开启定时器 如果 5s 内音视频流没有加载完成播放失败
_this8.errorTimer=setTimeout(function(){if(!_this8.trackVideo||!_this8.trackAudio){_this8.playFailedFunc({"error":"音频或者视频加载失败"});}else{}},5000);}).catch(function(res){console.log(res);_this8.playFailedFunc(res);});}).catch(function(reason){console.log("create offer failed : reason = "+reason);});},onAddStream:function onAddStream(e){var streamId=e.streamId;var video=this.$refs.fastVideo;video.autoplay=true;this.player=video;// 开启声音播放
if(!this.isWhitebord){this.player.muted=false;this.isMuted=false;}video.srcObject=e.stream;console.log('onAddStream方法调用');},playFailedFunc:function playFailedFunc(res){this.stopPlay();this.$emit("playFailed",res);},stopPlay:function stopPlay(){this.stopPlayerTime();if(this.player){var url="https://webrtc.liveplay.myqcloud.com/webrtc/v1/stopstream";var reqBody={streamurl:this.streamUrl,svrsig:this.svrSig};__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url,reqBody).then(function(res){}).catch(function(res){});if(this.peerConnection){this.peerConnection.close();this.peerConnection=null;}if(this.videoStatsTime){clearInterval(this.videoStatsTime);this.videoStatsTime=null;}if(this.audioStatsTime){clearInterval(this.audioStatsTime);this.audioStatsTime=null;}this.player.srcObject=null;this.playStatus=1;this.player.pause();this.player=null;}console.log('fast stopPlay');},getStreamId:function getStreamId(url){//var url = "webrtc://domain/path/stream_id[?txSecret=xxx&txTime=xxx]";
var parseStreamid=/^(?:webrtc:\/\/)(?:[0-9.\-A-Za-z_]+)(?:\/)(?:[0-9.\-A-Za-z_]+)(?:\/)([^?#]*)(?:\?*)(?:[^?#]*)/;var result=parseStreamid.exec(url);if(result)return result[1];return null;}}};/***/},/* 7 *//***/function(module,exports,__webpack_require__){"use strict";module.exports=function bind(fn,thisArg){return function wrap(){var args=new Array(arguments.length);for(var i=0;i<args.length;i++){args[i]=arguments[i];}return fn.apply(thisArg,args);};};/***/},/* 8 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);function encode(val){return encodeURIComponent(val).replace(/%3A/gi,':').replace(/%24/g,'$').replace(/%2C/gi,',').replace(/%20/g,'+').replace(/%5B/gi,'[').replace(/%5D/gi,']');}/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */module.exports=function buildURL(url,params,paramsSerializer){/*eslint no-param-reassign:0*/if(!params){return url;}var serializedParams;if(paramsSerializer){serializedParams=paramsSerializer(params);}else if(utils.isURLSearchParams(params)){serializedParams=params.toString();}else{var parts=[];utils.forEach(params,function serialize(val,key){if(val===null||typeof val==='undefined'){return;}if(utils.isArray(val)){key=key+'[]';}else{val=[val];}utils.forEach(val,function parseValue(v){if(utils.isDate(v)){v=v.toISOString();}else if(utils.isObject(v)){v=JSON.stringify(v);}parts.push(encode(key)+'='+encode(v));});});serializedParams=parts.join('&');}if(serializedParams){var hashmarkIndex=url.indexOf('#');if(hashmarkIndex!==-1){url=url.slice(0,hashmarkIndex);}url+=(url.indexOf('?')===-1?'?':'&')+serializedParams;}return url;};/***/},/* 9 *//***/function(module,exports,__webpack_require__){"use strict";module.exports=function isCancel(value){return!!(value&&value.__CANCEL__);};/***/},/* 10 *//***/function(module,exports,__webpack_require__){"use strict";/* WEBPACK VAR INJECTION */(function(process){var utils=__webpack_require__(0);var normalizeHeaderName=__webpack_require__(34);var DEFAULT_CONTENT_TYPE={'Content-Type':'application/x-www-form-urlencoded'};function setContentTypeIfUnset(headers,value){if(!utils.isUndefined(headers)&&utils.isUndefined(headers['Content-Type'])){headers['Content-Type']=value;}}function getDefaultAdapter(){var adapter;if(typeof XMLHttpRequest!=='undefined'){// For browsers use XHR adapter
adapter=__webpack_require__(11);}else if(typeof process!=='undefined'&&Object.prototype.toString.call(process)==='[object process]'){// For node use HTTP adapter
adapter=__webpack_require__(11);}return adapter;}var defaults={adapter:getDefaultAdapter(),transformRequest:[function transformRequest(data,headers){normalizeHeaderName(headers,'Accept');normalizeHeaderName(headers,'Content-Type');if(utils.isFormData(data)||utils.isArrayBuffer(data)||utils.isBuffer(data)||utils.isStream(data)||utils.isFile(data)||utils.isBlob(data)){return data;}if(utils.isArrayBufferView(data)){return data.buffer;}if(utils.isURLSearchParams(data)){setContentTypeIfUnset(headers,'application/x-www-form-urlencoded;charset=utf-8');return data.toString();}if(utils.isObject(data)){setContentTypeIfUnset(headers,'application/json;charset=utf-8');return JSON.stringify(data);}return data;}],transformResponse:[function transformResponse(data){/*eslint no-param-reassign:0*/if(typeof data==='string'){try{data=JSON.parse(data);}catch(e){/* Ignore */}}return data;}],/**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */timeout:0,xsrfCookieName:'XSRF-TOKEN',xsrfHeaderName:'X-XSRF-TOKEN',maxContentLength:-1,maxBodyLength:-1,validateStatus:function validateStatus(status){return status>=200&&status<300;}};defaults.headers={common:{'Accept':'application/json, text/plain, */*'}};utils.forEach(['delete','get','head'],function forEachMethodNoData(method){defaults.headers[method]={};});utils.forEach(['post','put','patch'],function forEachMethodWithData(method){defaults.headers[method]=utils.merge(DEFAULT_CONTENT_TYPE);});module.exports=defaults;/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(33));/***/},/* 11 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);var settle=__webpack_require__(35);var cookies=__webpack_require__(37);var buildURL=__webpack_require__(8);var buildFullPath=__webpack_require__(38);var parseHeaders=__webpack_require__(41);var isURLSameOrigin=__webpack_require__(42);var createError=__webpack_require__(12);module.exports=function xhrAdapter(config){return new Promise(function dispatchXhrRequest(resolve,reject){var requestData=config.data;var requestHeaders=config.headers;if(utils.isFormData(requestData)){delete requestHeaders['Content-Type'];// Let the browser set it
}var request=new XMLHttpRequest();// HTTP basic authentication
if(config.auth){var username=config.auth.username||'';var password=config.auth.password?unescape(encodeURIComponent(config.auth.password)):'';requestHeaders.Authorization='Basic '+btoa(username+':'+password);}var fullPath=buildFullPath(config.baseURL,config.url);request.open(config.method.toUpperCase(),buildURL(fullPath,config.params,config.paramsSerializer),true);// Set the request timeout in MS
request.timeout=config.timeout;// Listen for ready state
request.onreadystatechange=function handleLoad(){if(!request||request.readyState!==4){return;}// The request errored out and we didn't get a response, this will be
// handled by onerror instead
// With one exception: request that using file: protocol, most browsers
// will return status as 0 even though it's a successful request
if(request.status===0&&!(request.responseURL&&request.responseURL.indexOf('file:')===0)){return;}// Prepare the response
var responseHeaders='getAllResponseHeaders'in request?parseHeaders(request.getAllResponseHeaders()):null;var responseData=!config.responseType||config.responseType==='text'?request.responseText:request.response;var response={data:responseData,status:request.status,statusText:request.statusText,headers:responseHeaders,config:config,request:request};settle(resolve,reject,response);// Clean up request
request=null;};// Handle browser request cancellation (as opposed to a manual cancellation)
request.onabort=function handleAbort(){if(!request){return;}reject(createError('Request aborted',config,'ECONNABORTED',request));// Clean up request
request=null;};// Handle low level network errors
request.onerror=function handleError(){// Real errors are hidden from us by the browser
// onerror should only fire if it's a network error
reject(createError('Network Error',config,null,request));// Clean up request
request=null;};// Handle timeout
request.ontimeout=function handleTimeout(){var timeoutErrorMessage='timeout of '+config.timeout+'ms exceeded';if(config.timeoutErrorMessage){timeoutErrorMessage=config.timeoutErrorMessage;}reject(createError(timeoutErrorMessage,config,'ECONNABORTED',request));// Clean up request
request=null;};// Add xsrf header
// This is only done if running in a standard browser environment.
// Specifically not if we're in a web worker, or react-native.
if(utils.isStandardBrowserEnv()){// Add xsrf header
var xsrfValue=(config.withCredentials||isURLSameOrigin(fullPath))&&config.xsrfCookieName?cookies.read(config.xsrfCookieName):undefined;if(xsrfValue){requestHeaders[config.xsrfHeaderName]=xsrfValue;}}// Add headers to the request
if('setRequestHeader'in request){utils.forEach(requestHeaders,function setRequestHeader(val,key){if(typeof requestData==='undefined'&&key.toLowerCase()==='content-type'){// Remove Content-Type if data is undefined
delete requestHeaders[key];}else{// Otherwise add header to the request
request.setRequestHeader(key,val);}});}// Add withCredentials to request if needed
if(!utils.isUndefined(config.withCredentials)){request.withCredentials=!!config.withCredentials;}// Add responseType to request if needed
if(config.responseType){try{request.responseType=config.responseType;}catch(e){// Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
// But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
if(config.responseType!=='json'){throw e;}}}// Handle progress if needed
if(typeof config.onDownloadProgress==='function'){request.addEventListener('progress',config.onDownloadProgress);}// Not all browsers support upload events
if(typeof config.onUploadProgress==='function'&&request.upload){request.upload.addEventListener('progress',config.onUploadProgress);}if(config.cancelToken){// Handle cancellation
config.cancelToken.promise.then(function onCanceled(cancel){if(!request){return;}request.abort();reject(cancel);// Clean up request
request=null;});}if(!requestData){requestData=null;}// Send the request
request.send(requestData);});};/***/},/* 12 *//***/function(module,exports,__webpack_require__){"use strict";var enhanceError=__webpack_require__(36);/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */module.exports=function createError(message,config,code,request,response){var error=new Error(message);return enhanceError(error,config,code,request,response);};/***/},/* 13 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */module.exports=function mergeConfig(config1,config2){// eslint-disable-next-line no-param-reassign
config2=config2||{};var config={};var valueFromConfig2Keys=['url','method','data'];var mergeDeepPropertiesKeys=['headers','auth','proxy','params'];var defaultToConfig2Keys=['baseURL','transformRequest','transformResponse','paramsSerializer','timeout','timeoutMessage','withCredentials','adapter','responseType','xsrfCookieName','xsrfHeaderName','onUploadProgress','onDownloadProgress','decompress','maxContentLength','maxBodyLength','maxRedirects','transport','httpAgent','httpsAgent','cancelToken','socketPath','responseEncoding'];var directMergeKeys=['validateStatus'];function getMergedValue(target,source){if(utils.isPlainObject(target)&&utils.isPlainObject(source)){return utils.merge(target,source);}else if(utils.isPlainObject(source)){return utils.merge({},source);}else if(utils.isArray(source)){return source.slice();}return source;}function mergeDeepProperties(prop){if(!utils.isUndefined(config2[prop])){config[prop]=getMergedValue(config1[prop],config2[prop]);}else if(!utils.isUndefined(config1[prop])){config[prop]=getMergedValue(undefined,config1[prop]);}}utils.forEach(valueFromConfig2Keys,function valueFromConfig2(prop){if(!utils.isUndefined(config2[prop])){config[prop]=getMergedValue(undefined,config2[prop]);}});utils.forEach(mergeDeepPropertiesKeys,mergeDeepProperties);utils.forEach(defaultToConfig2Keys,function defaultToConfig2(prop){if(!utils.isUndefined(config2[prop])){config[prop]=getMergedValue(undefined,config2[prop]);}else if(!utils.isUndefined(config1[prop])){config[prop]=getMergedValue(undefined,config1[prop]);}});utils.forEach(directMergeKeys,function merge(prop){if(prop in config2){config[prop]=getMergedValue(config1[prop],config2[prop]);}else if(prop in config1){config[prop]=getMergedValue(undefined,config1[prop]);}});var axiosKeys=valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);var otherKeys=Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key){return axiosKeys.indexOf(key)===-1;});utils.forEach(otherKeys,mergeDeepProperties);return config;};/***/},/* 14 *//***/function(module,exports,__webpack_require__){"use strict";/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */function Cancel(message){this.message=message;}Cancel.prototype.toString=function toString(){return'Cancel'+(this.message?': '+this.message:'');};Cancel.prototype.__CANCEL__=true;module.exports=Cancel;/***/},/* 15 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */__webpack_exports__["a"]={props:{playData:{type:Object,default:function _default(){}},fakeLive:{type:[Number,Boolean],default:false},shouldReportLiveInfo:{type:[Boolean,String],default:true},isRTC:{type:[Number,Boolean],default:true},staff_id:{type:[Number,String],default:0},showWatermark:{type:Boolean,default:false},showH5Xianlu:{type:Boolean,default:false},playerid:{type:String,default:''},isWhitebord:{type:Boolean,default:false},isThreeScreen:{type:Boolean,default:false},isMiniWindow:{type:Boolean,default:false},isShowMiniWindowIcon:{type:Boolean,default:false},isVertical:{type:Boolean,default:false},runObj:{type:Object,default:function _default(){return{};}},copyrightObj:{type:Object,default:function _default(){return{};}},fans_id:{type:Number|String,default:0},nick:{type:String,default:''},remark:{type:String,default:''},isThird:{type:Boolean,default:true}},mounted:function mounted(){var _this=this;this.intervalID=setInterval(this.moveBox,80);var u=navigator.userAgent;if(u.indexOf("Android")>0||u.indexOf("Linux")>0||u.indexOf("iPhone")>0||u.indexOf("Windows Phone")>0){//电脑版调转到PC页面
this.isPc=false;}else{this.isPc=true;// this.$nextTick(()=>{
//   document.addEventListener('fullscreenchange', v => {
//     console.log("===============fullscreenchange================")
//       let isfullScreen =  document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullScreen;
//        if (!isfullScreen) {
//         console.log("===============fullscreenchange================",isfullScreen)
//            this.isfullScreen = false
//        }
//   })
// })
}var videoElement=this.$refs.liveVideo;videoElement.addEventListener("playing",function(){_this.playStatus=2;_this.showLoading=false;console.log("LivePalyer  playing");});videoElement.addEventListener("waiting",function(){console.log("LivePalyer  waiting");_this.showLoading=true;});videoElement.addEventListener("canplay",_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log("LivePalyer  canplay");// 这里是自动播放逻辑
_context.prev=1;_this.mouseOver();_context.next=5;return videoElement.play();case 5:_context.next=10;break;case 7:_context.prev=7;_context.t0=_context['catch'](1);if(!(/Safari/.test(navigator.userAgent)&&!/Chrome/.test(navigator.userAgent))){_this.$emit("toStop");_this.$emit("unAutoPlay",{message:'当前浏览器不支持自动播放，请点击播放按钮观看直播',type:511});}case 10:case'end':return _context.stop();}}},_callee,_this,[[1,7]]);})));//iOS设备全屏
if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){this.$refs.liveVideo.addEventListener("webkitendfullscreen",function(e){setTimeout(function(){_this.$emit("toStop");_this.$emit("unAutoPlay",{message:'当前浏览器不支持自动播放，请点击播放按钮观看直播',type:511});},300);});}},beforeDestroy:function beforeDestroy(){this.stopPlayerTime();clearInterval(this.intervalID);},computed:{objectFit:function objectFit(){if(this.isVertical){if(!this.isPc){return'cover';}}return'contain';}},watch:{playData:function playData(to,from){},playStatus:function playStatus(to,from){this.$emit("statusChange",to);},showWatermark:function showWatermark(to,from){var _this2=this;this.$nextTick(function(){if(to&&!_this2.showWatermarkTimer){_this2.showWatermarkTimer=setInterval(function(){if(!_this2.showWatermark){clearInterval(_this2.showWatermarkTimer);_this2.showWatermarkTimer=null;return;}var id_fast_video_watermark=document.getElementById("id_live_video_watermark");if(_this2.$refs.livePlayer){if(id_fast_video_watermark){_this2.$refs.livePlayer.removeChild(id_fast_video_watermark);}var id_fast_video_watermark2=document.createElement("div");id_fast_video_watermark2.id="id_live_video_watermark";id_fast_video_watermark2.innerText='\u52A9\u6559ID:'+_this2.staff_id;id_fast_video_watermark2.setAttribute("style","position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);text-align: center;font-size: 89px;color: black;white-space:nowrap;min-width: 300px;min-height: 100px;background-color: red;word-break: break-word;");_this2.$refs.livePlayer.insertBefore(id_fast_video_watermark2,_this2.$refs.livePlayer.firstChild);}},600000);}});},isfullScreen:function isfullScreen(to,from){if(this.showWatermark){var id_fast_video_watermark=document.getElementById("id_live_video_watermark");if(id_fast_video_watermark){if(to){id_fast_video_watermark.style.fontSize="200px";}else{id_fast_video_watermark.style.fontSize="89px";}}}}},data:function data(){return{isPc:false,player:null,playStatus:1,showControns:false,isMuted:false,playD:null,showXianLuBox:false,playTimer:null,showLoading:false,showWatermarkTimer:null,id_live_video_watermark:this.playerid,isfullScreen:false,isShowHud:false,boxLeft:10,// 初始左边距离
boxTop:10,// 初始顶部距离
winMax:10,// 设置最大视觉差
sx:0,// x轴移动状态，0表示正向移动，1表示返回
sy:0,// y轴移动状态，0表示正向移动，1表示返回
intervalID:null,rotateRunBox:false,isPad:/iPad/i.test(window.navigator.userAgent)||window.navigator.platform==='MacIntel'&&window.navigator.maxTouchPoints>1};},methods:{moveBox:function moveBox(){// 获取 runBox 的宽度和高度
var runBox=this.$refs.runBoxRef;if(runBox&&runBox.offsetWidth){var runBoxWidth=runBox.offsetWidth;var runBoxHeight=runBox.offsetHeight;// 计算盒子在x轴上最远达到的距离
var winx=runBoxWidth-42-this.winMax;// 100 是盒子的宽度
// 计算盒子在y轴上最远达到的距离
var winy=runBoxHeight-24-this.winMax;// 100 是盒子的高度
// x轴移动
if(this.sx===0){this.boxLeft++;}else{this.boxLeft--;}if(this.boxLeft<=0){this.sx=0;}else if(this.boxLeft>=winx){this.sx=1;}// y轴移动
if(this.sy===0){this.boxTop++;}else{this.boxTop--;}if(this.boxTop<=0){this.sy=0;}else if(this.boxTop>=winy){this.sy=1;}}},startPlayerTime:function startPlayerTime(){var _this3=this;if(this.playTimer){clearInterval(this.playTimer);this.playTimer=null;}this.playTimer=setInterval(function(){if(_this3.shouldReportLiveInfo){var videoElement=_this3.$refs.liveVideo;var data={};data['video_volume']=videoElement.volume;data['video_mute']=videoElement.muted;data['play_type']='live';data['error_code']='50000';_this3.$emit('errorReport',data);}},5000);},stopPlayerTime:function stopPlayerTime(){if(this.playTimer){clearInterval(this.playTimer);this.playTimer=null;}},changePlayType:function changePlayType(type){this.$emit('changePlayType',type);},mouseOver:function mouseOver(){var _this4=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this4.showControns=false;_this4.showXianLuBox=false;},5000);},mousemove:function mousemove(){var _this5=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this5.showControns=false;_this5.showXianLuBox=false;},5000);},mouseLeave:function mouseLeave(){var _this6=this;this.timer=setTimeout(function(){_this6.showControns=false;_this6.showXianLuBox=false;},5000);},shuaxingCliked:function shuaxingCliked(){this.playLive(this.playD);},quanpingCliked:function quanpingCliked(){var livePlayer=this.$refs.livePlayer;var fastVideo=this.$refs.liveVideo;if(!this.isfullScreen){if(livePlayer.requestFullscreen){this.isfullScreen=true;livePlayer.requestFullscreen();return;}else if(livePlayer.mozRequestFullScreen){this.isfullScreen=true;livePlayer.mozRequestFullScreen();return;}else if(livePlayer.webkitRequestFullscreen){this.isfullScreen=true;livePlayer.webkitRequestFullscreen();return;}else if(fastVideo.webkitEnterFullscreen){this.isfullScreen=true;fastVideo.webkitEnterFullscreen();return;}else if(fastVideo.webkitEnterFullScreen){this.isfullScreen=true;fastVideo.webkitEnterFullScreen();return;}else if(livePlayer.msRequestFullscreen){this.isfullScreen=true;livePlayer.msRequestFullscreen();return;}this.$emit("unAutoPlay",{message:'全屏播放失败',type:'error'});}else{if(document.exitFullscreen){this.isfullScreen=false;return document.exitFullscreen();}else if(document.cancelFullScreen){this.isfullScreen=false;document.cancelFullScreen();}else if(document.mozCancelFullScreen){this.isfullScreen=false;return document.mozCancelFullScreen();}else if(document.webkitCancelFullScreen){this.isfullScreen=false;return document.webkitCancelFullScreen();}else if(document.webkitCancelFullscreen){this.isfullScreen=false;return document.webkitCancelFullscreen();}else if(document.msCancelFullScreen){this.isfullScreen=false;return document.msCancelFullScreen();}else if(document.msExitFullscreen){this.isfullScreen=false;return document.msExitFullscreen();}this.$emit("unAutoPlay",{message:'退出全屏失败',type:'error'});}//  var u = navigator.userAgent;
//   if (
//     !(u.indexOf("Android") < 0 &&
//     u.indexOf("Linux") < 0 &&
//     u.indexOf("iPhone") < 0 &&
//     u.indexOf("Windows Phone") < 0 &&
//     u.indexOf("MiniProgram") < 0)&&this.isfullScreen
//   ) {
//       console.log('shoujishoujishoujishoujishoujishoujishoujishoujishoujishoujishouji');
//       this.rotateRunBox = true;
//                 // 获取视口的宽度和高度
//       const viewportWidth = window.innerWidth;
//       const viewportHeight = window.innerHeight;
//       // 将盒子的宽度设置为视口的高度
//       const copyright =  document.querySelector('#copyrightThree');
//       console.log(copyright,'copyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyright');
//       copyright.style.width = `${viewportHeight}px`;
//        copyright.style.transformOrigin = 'top left';
//       // 平移盒子的效果
//       const translateXValue = viewportWidth;
//       copyright.style.transform = `rotate(90deg) translateY(-${translateXValue}px)`;
//       console.log(copyright,'copyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyright');
//   }else{
//     this.rotateRunBox = false;
//     // 还原盒子样式
//     const copyright = document.querySelector('#copyrightThree');
//     copyright.style.width = ''; // 还原宽度
//     copyright.style.transformOrigin = ''; // 还原变换原点
//     copyright.style.transform = ''; // 还原变换
//   }
},jingyingClicked:function jingyingClicked(){var videoElement=this.$refs.liveVideo;if(this.isMuted){this.isMuted=false;videoElement.muted=false;}else{this.isMuted=true;videoElement.muted=true;}},playLive:function playLive(playData){var _this7=this;return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var videoElement;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this7.playD=playData;_this7.startPlayerTime();videoElement=_this7.$refs.liveVideo;if(videoElement){videoElement.play();}if(flvjs.isSupported()){// 播放 flv
if(_this7.player){videoElement.pause();_this7.player.unload();_this7.player.detachMediaElement();_this7.player.destroy();_this7.player=null;}_this7.player=flvjs.createPlayer({type:'flv',url:playData.pull_url_flv});_this7.player.attachMediaElement(videoElement);_this7.player.load();//加载
videoElement.autoplay=true;}else{// 直接播放hls
videoElement.src=playData.pull_url_hls;videoElement.autoplay=true;}case 5:case'end':return _context2.stop();}}},_callee2,_this7);}))();},stopPlay:function stopPlay(){var videoElement=this.$refs.liveVideo;this.stopPlayerTime();if(videoElement){videoElement.pause();}if(this.player){this.player.unload();this.player.detachMediaElement();this.player.destroy();this.player=null;}this.playStatus=1;console.log('live stopPlay');}}};/***/},/* 16 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_trtc_js_sdk__=__webpack_require__(56);/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_trtc_js_sdk___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_trtc_js_sdk__);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_axios__=__webpack_require__(4);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1_axios___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);var _props;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import TRTC from "./js/trtc.js";
/* harmony default export */__webpack_exports__["a"]={props:(_props={fans_id:{type:Number|String,default:0},ds_id:{type:Number,default:0},push_user:{type:Number|String,default:0},shouldReportLiveInfo:{type:[Boolean,String],default:true},staff_id:{type:[Number,String],default:0},showWatermark:{type:Boolean,default:false},showH5Xianlu:{type:Boolean,default:false},isshanhu:{type:Boolean,default:false},playerid:{type:String,default:''},isWhitebord:{type:Boolean,default:false},isThreeScreen:{type:Boolean,default:false},isMiniWindow:{type:Boolean,default:false},isShowMiniWindowIcon:{type:Boolean,default:false},isVertical:{type:Boolean,default:false},runObj:{type:Object,default:function _default(){return{};}},copyrightObj:{type:Object,default:function _default(){return{};}}},_defineProperty(_props,'fans_id',{type:Number|String,default:0}),_defineProperty(_props,'nick',{type:String,default:''}),_defineProperty(_props,'remark',{type:String,default:''}),_defineProperty(_props,'isThird',{type:Boolean,default:true}),_props),computed:{objectFit:function objectFit(){if(this.isVertical){if(!this.isPc){return'cover';}}return'contain';}},watch:{fans_id:function fans_id(to,from){console.log("to",this.fans_id);if(to!=0&&!this.rtcClient&&!this.isWhitebord){this.initWebRtc();}},playStatus:function playStatus(to,from){this.$emit("statusChange",to);},showWatermark:function showWatermark(to,from){var _this=this;this.$nextTick(function(){if(to&&!_this.showWatermarkTimer){_this.showWatermarkTimer=setInterval(function(){if(!_this.showWatermark){clearInterval(_this.showWatermarkTimer);_this.showWatermarkTimer=null;return;}var id_fast_video_watermark=document.getElementById("id_rtc_video_watermark");if(_this.$refs.rtcPlayer){if(id_fast_video_watermark){_this.$refs.rtcPlayer.removeChild(id_fast_video_watermark);}var id_fast_video_watermark2=document.createElement("div");id_fast_video_watermark2.id="id_rtc_video_watermark";id_fast_video_watermark2.innerText='\u52A9\u6559ID:'+_this.staff_id;id_fast_video_watermark2.setAttribute("style","position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);text-align: center;font-size: 89px;color: black;white-space:nowrap;min-width: 300px;min-height: 100px;background-color: red;word-break: break-word;");_this.$refs.rtcPlayer.insertBefore(id_fast_video_watermark2,_this.$refs.rtcPlayer.firstChild);}},600000);}});},isfullScreen:function isfullScreen(to,from){if(this.showWatermark){var id_fast_video_watermark=document.getElementById("id_rtc_video_watermark");if(id_fast_video_watermark){if(to){id_fast_video_watermark.style.fontSize="200px";}else{id_fast_video_watermark.style.fontSize="89px";}}}}},mounted:function mounted(){var _this2=this;console.log("rtc 准备工作",this.fans_id);this.intervalID=setInterval(this.moveBox,80);//rtc 准备工作
var self=this;__WEBPACK_IMPORTED_MODULE_0_trtc_js_sdk___default.a.checkSystemRequirements().then(function(result){console.log("rtc是否支持",result);var u=navigator.userAgent;if(u.indexOf("WindowsWechat")!=-1){result=false;}if(_this2.isAndroidLowerVersion()){result=false;}self.$emit("isSupportRTCCallback",result);if(result&&self.fans_id!=0&&!self.isWhitebord){self.initWebRtc();}});this.$refs.rtcVideo.addEventListener("canplay",_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this2.mouseOver();_context.next=4;return _this2.$refs.rtcVideo.play();case 4:_context.next=11;break;case 6:_context.prev=6;_context.t0=_context['catch'](0);_this2.rtcLiveLeave();_this2.$emit("toStop");_this2.$emit("unAutoPlay",{message:'当前浏览器不支持自动播放，请点击播放按钮观看直播',type:511});case 11:case'end':return _context.stop();}}},_callee,_this2,[[0,6]]);})));this.$refs.rtcVideo.addEventListener("playing",function(){self.mediaStreamList.forEach(function(stream){if(self.$refs.rtcVideo.muted){stream.setAudioVolume(0);}else{stream.setAudioVolume(self.$refs.rtcVideo.volume);}});_this2.playStatus=2;_this2.showLoading=false;});this.$refs.rtcVideo.addEventListener("waiting",function(){_this2.showLoading=true;});this.$refs.rtcVideo.addEventListener("volumechange",function(event){_this2.mediaStreamList.forEach(function(stream){if(self.$refs.rtcVideo.muted){stream.setAudioVolume(0);}else{stream.setAudioVolume(self.$refs.rtcVideo.volume);}});});var u=navigator.userAgent;if(u.indexOf("Android")>0||u.indexOf("Linux")>0||u.indexOf("iPhone")>0||u.indexOf("Windows Phone")>0){//电脑版调转到PC页面
this.isPc=false;}else{this.isPc=true;this.$nextTick(function(){document.addEventListener('fullscreenchange',function(v){var isfullScreen=document.fullScreen||document.webkitIsFullScreen||document.mozFullScreen||document.msFullScreen;if(!isfullScreen){_this2.isfullScreen=false;}});});}//iOS设备全屏
if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){this.$refs.rtcVideo.addEventListener("webkitendfullscreen",function(e){setTimeout(function(){_this2.$emit("toStop");_this2.$emit("unAutoPlay",{message:'当前浏览器不支持自动播放，请点击播放按钮观看直播',type:511});},300);});}},data:function data(){return{rotateRunBox:false,rtcClient:null,mediaStreamList:[],mainMediaStream:null,videoStream:null,audioStream:null,playStatus:1,//1 未播放  2正在播放
localStream:null,isJoin:false,showControns:false,isMuted:false,isShuaxing:false,isfullScreen:false,showXianLuBox:false,timer:null,playTimer:null,isPc:false,isShowHud:false,boxLeft:10,// 初始左边距离
boxTop:10,// 初始顶部距离
winMax:10,// 设置最大视觉差
sx:0,// x轴移动状态，0表示正向移动，1表示返回
sy:0,// y轴移动状态，0表示正向移动，1表示返回
intervalID:null,showLoading:false,showWatermarkTimer:null,isPad:/iPad/i.test(window.navigator.userAgent)||window.navigator.platform==='MacIntel'&&window.navigator.maxTouchPoints>1};},beforeDestroy:function beforeDestroy(){this.stopPlayerTime();clearInterval(this.intervalID);},methods:{moveBox:function moveBox(){// 获取 runBox 的宽度和高度
var runBox=this.$refs.runBoxRef;if(runBox&&runBox.offsetWidth){var runBoxWidth=runBox.offsetWidth;var runBoxHeight=runBox.offsetHeight;// 计算盒子在x轴上最远达到的距离
var winx=runBoxWidth-42-this.winMax;// 100 是盒子的宽度
// 计算盒子在y轴上最远达到的距离
var winy=runBoxHeight-24-this.winMax;// 100 是盒子的高度
// x轴移动
if(this.sx===0){this.boxLeft++;}else{this.boxLeft--;}if(this.boxLeft<=0){this.sx=0;}else if(this.boxLeft>=winx){this.sx=1;}// y轴移动
if(this.sy===0){this.boxTop++;}else{this.boxTop--;}if(this.boxTop<=0){this.sy=0;}else if(this.boxTop>=winy){this.sy=1;}}},isAndroidLowerVersion:function isAndroidLowerVersion(){var isWexin=navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=="micromessenger";var isAndroid=navigator.userAgent.indexOf("Android")>0;var android_ver=navigator.userAgent.toLowerCase().match(/android (.*?);/i);var number=10;if(android_ver){try{number=parseInt(android_ver[1].split(".")[0]);}catch(error){number=10;}}if(!isWexin&&isAndroid&&number<9){console.error("[播放器日志] 不支持快直播");return true;}return false;},startPlayerTime:function startPlayerTime(){var _this3=this;if(this.playTimer){clearInterval(this.playTimer);this.playTimer=null;}this.playTimer=setInterval(function(){if(_this3.shouldReportLiveInfo){var videoElement=_this3.$refs.rtcVideo;var data={};data['video_volume']=videoElement.volume;data['video_mute']=videoElement.muted;data['play_type']='RTC';data['error_code']='50000';_this3.$emit('errorReport',data);}},5000);},stopPlayerTime:function stopPlayerTime(){if(this.playTimer){clearInterval(this.playTimer);this.playTimer=null;}},changePlayType:function changePlayType(type){this.$emit('changePlayType',type);},mouseOver:function mouseOver(){var _this4=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this4.showControns=false;_this4.showXianLuBox=false;},5000);},mousemove:function mousemove(){var _this5=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this5.showControns=false;_this5.showXianLuBox=false;},5000);},mouseLeave:function mouseLeave(){var _this6=this;this.timer=setTimeout(function(){_this6.showControns=false;_this6.showXianLuBox=false;},5000);},shuaxingCliked:function shuaxingCliked(){var _this7=this;if(!this.isShuaxing){this.isShuaxing=true;this.rtcLiveLeave(function(){setTimeout(function(){_this7.playRtc();_this7.isShuaxing=false;},500);});}},jingyingClicked:function jingyingClicked(){if(this.isMuted){this.isMuted=false;this.$refs.rtcVideo.muted=false;}else{this.isMuted=true;this.$refs.rtcVideo.muted=true;}},quanpingCliked:function quanpingCliked(){var livePlayer=this.$refs.rtcPlayer;var fastVideo=this.$refs.rtcVideo;if(!this.isfullScreen){if(livePlayer.requestFullscreen){livePlayer.requestFullscreen();this.isfullScreen=true;return;}else if(livePlayer.mozRequestFullScreen){livePlayer.mozRequestFullScreen();this.isfullScreen=true;return;}else if(livePlayer.webkitRequestFullscreen){livePlayer.webkitRequestFullscreen();this.isfullScreen=true;return;}else if(fastVideo.webkitEnterFullscreen){fastVideo.webkitEnterFullscreen();return;}else if(fastVideo.webkitEnterFullScreen){fastVideo.webkitEnterFullScreen();return;}else if(livePlayer.msRequestFullscreen){this.isfullScreen=true;livePlayer.msRequestFullscreen();return;}this.$emit("unAutoPlay",{message:'全屏播放失败',type:'error'});}else{if(document.exitFullscreen){this.isfullScreen=false;return document.exitFullscreen();}else if(document.cancelFullScreen){this.isfullScreen=false;document.cancelFullScreen();}else if(document.mozCancelFullScreen){this.isfullScreen=false;return document.mozCancelFullScreen();}else if(document.webkitCancelFullScreen){this.isfullScreen=false;return document.webkitCancelFullScreen();}else if(document.webkitCancelFullscreen){this.isfullScreen=false;return document.webkitCancelFullscreen();}else if(document.msCancelFullScreen){this.isfullScreen=false;return document.msCancelFullScreen();}else if(document.msExitFullscreen){this.isfullScreen=false;return document.msExitFullscreen();}this.$emit("unAutoPlay",{message:'退出全屏失败',type:'error'});}//  var u = navigator.userAgent;
//   if (
//     !(u.indexOf("Android") < 0 &&
//     u.indexOf("Linux") < 0 &&
//     u.indexOf("iPhone") < 0 &&
//     u.indexOf("Windows Phone") < 0 &&
//     u.indexOf("MiniProgram") < 0)&&this.isfullScreen
//   ) {
//       console.log('shoujishoujishoujishoujishoujishoujishoujishoujishoujishoujishouji');
//       this.rotateRunBox = true;
//                 // 获取视口的宽度和高度
//       const viewportWidth = window.innerWidth;
//       const viewportHeight = window.innerHeight;
//       // 将盒子的宽度设置为视口的高度
//       const copyright =  document.querySelector('#copyrightFour');
//       console.log(copyright,'copyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyright');
//       copyright.style.width = `${viewportHeight}px`;
//        copyright.style.transformOrigin = 'top left';
//       // 平移盒子的效果
//       const translateXValue = viewportWidth;
//       copyright.style.transform = `rotate(90deg) translateY(-${translateXValue}px)`;
//       console.log(copyright,'copyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyright');
//   }else{
//     this.rotateRunBox = false;
//     // 还原盒子样式
//     const copyright = document.querySelector('#copyrightFour');
//     copyright.style.width = ''; // 还原宽度
//     copyright.style.transformOrigin = ''; // 还原变换原点
//     copyright.style.transform = ''; // 还原变换
//   }
},playRtc:function playRtc(){this.startPlayerTime();this.rtcLivePlay();},rtcLivePlay:function rtcLivePlay(){var _this8=this;console.log("rtcLivePlay");var roomId=this.ds_id;// 以观众角色进房收看
this.rtcClient.join({roomId:roomId,role:"audience"}).then(function(){_this8.isJoin=true;console.log("进房成功");}).catch(function(error){console.error("进房失败 "+error);});try{this.$refs.rtcVideo.play();}catch(error){console.log("自动播放rtcLivePlay===",error);}},initWebRtc:function initWebRtc(){var _this9=this;return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var that,sdkAppId,userSig,userId,param,data,data2,rtcClient;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:that=_this9;sdkAppId=0;userSig="";userId=_this9.fans_id+"";param='ds_id='+_this9.ds_id+'&fans_id='+_this9.fans_id;_context2.prev=5;_context2.next=8;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://live.shanhuketang.com/liveapi/api/user/getRtcSign',param);case 8:data=_context2.sent;sdkAppId=parseInt(data.data.data.app_id);userSig=data.data.data.userSig;console.error("RtcSign",data.data.data);_context2.next=27;break;case 14:_context2.prev=14;_context2.t0=_context2['catch'](5);_context2.prev=16;_context2.next=19;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://service-jmibg8h4-1317978474.gz.apigw.tencentcs.com/release/api/login/getRtcSign',param);case 19:data2=_context2.sent;console.error("data2=====",data2);sdkAppId=parseInt(data2.data.data.app_id);userSig=data2.data.data.userSig;_context2.next=27;break;case 25:_context2.prev=25;_context2.t1=_context2['catch'](16);case 27:if(!_this9.rtcClient){_context2.next=29;break;}return _context2.abrupt('return');case 29://创建 Client 对象
rtcClient=__WEBPACK_IMPORTED_MODULE_0_trtc_js_sdk___default.a.createClient({mode:"live",sdkAppId:sdkAppId,userId:userId,userSig:userSig});_this9.rtcClient=rtcClient;rtcClient.on("stream-added",function(event){that.rtcRemoteStream=event.stream;console.log("远端流增加: "+that.rtcRemoteStream.getId());//订阅远端流
rtcClient.subscribe(that.rtcRemoteStream);});rtcClient.on("stream-subscribed",function(event){console.log("远端流订阅成功："+event.stream.getId(),event.stream.getUserId(),event.stream.getType(),event.stream.hasVideo(),event.stream.hasAudio());if(event.stream.getUserId().indexOf(''+that.ds_id)!=-1){//老师的流
if(!that.mainMediaStream){that.mainMediaStream=new MediaStream();}if(event.stream.hasVideo()){if(that.videoStream&&that.videoStream.getVideoTrack()){that.mainMediaStream.removeTrack(that.videoStream.getVideoTrack());}that.videoStream=event.stream;that.mainMediaStream.addTrack(event.stream.getVideoTrack());}if(event.stream.hasAudio()){if(that.audioStream&&that.audioStream.getAudioTrack()){that.mainMediaStream.removeTrack(that.audioStream.getAudioTrack());}that.audioStream=event.stream;that.mainMediaStream.addTrack(event.stream.getAudioTrack());}that.$refs.rtcVideo.srcObject=that.mainMediaStream;}else{that.mediaStreamList.push(event.stream);event.stream.play('webRtcVideoBoxAudio'+that.playerid).then(function(){// autoplay success
console.log("播放成功了");//需要设置声音
if(that.$refs.rtcVideo.muted){event.stream.setAudioVolume(0);}else{event.stream.setAudioVolume(that.$refs.rtcVideo.volume);}}).catch(function(e){var errorCode=e.getCode();if(errorCode===0x4043){// PLAY_NOT_ALLOWED,引导用户手势操作恢复音视频播放
_this9.$refs.rtcVideo.muted=true;_this9.isMuted=true;_this9.$emit("unAutoPlay",{message:'静音播放中,请手动开启声音',type:'info'});}});}});rtcClient.on("connection-state-changed",function(event){var prevState=event.prevState;var curState=event.state;console.log("RTC状态 == "+curState);// ‘DISCONNECTED’：连接断开
// ‘CONNECTING’：正在连接中
// ‘RECONNECTING’：自动重连中
// ‘CONNECTED’：已连接
});//退房通知
rtcClient.on("peer-leave",function(event){var userId=event.userId;that.mediaStreamList.forEach(function(item,index){if(item.getUserId()==userId){that.mediaStreamList.splice(index,1);}});console.log("退房通知=="+userId);});case 35:case'end':return _context2.stop();}}},_callee2,_this9,[[5,14],[16,25]]);}))();},rtcLiveLeave:function rtcLiveLeave(callback){var _this10=this;this.stopPlayerTime();var self=this;//退出房间
this.rtcClient.leave().then(function(){console.log("退房成功");if(self.rtcRemoteStream){self.rtcRemoteStream.stop();}self.rtcRemoteStream=null;self.mainMediaStream=null;self.playStatus=1;_this10.isJoin=false;console.log('rtc stopPlay');callback&&callback(true);}).catch(function(error){console.error("leaving room failed: "+error);callback&&callback(false);});},rtcLiveStop:function rtcLiveStop(){//退出房间
if(this.rtcRemoteStream){this.rtcRemoteStream.stop();}else{}},rtcLiveResume:function rtcLiveResume(){//退出房间
if(this.rtcRemoteStream){this.rtcRemoteStream.resume();}},rtcLink:function rtcLink(callBack){var _this11=this;callBack({isOK:true});if(this.isJoin){this.linkFlow();}else{var roomId=this.ds_id;// 以观众角色进房收看
this.rtcClient.join({roomId:roomId,role:"audience"}).then(function(){_this11.isJoin=true;console.log("进房成功");_this11.linkFlow();}).catch(function(error){console.error("进房失败 "+error);});try{this.$refs.rtcVideo.play();}catch(error){console.log("自动播放rtcLivePlay===",error);}}},linkFlow:function linkFlow(){var _this12=this;var localStream=__WEBPACK_IMPORTED_MODULE_0_trtc_js_sdk___default.a.createStream({audio:true,video:false});this.localStream=localStream;localStream.initialize().then(function(){console.log("初始化本地流成功");// live互动直播模式下，观众连麦推流
_this12.rtcClient.switchRole("anchor").then(function(){// 连麦观众角色切换为主播，开始推流
// 本地流初始化成功，可通过Client.publish(localStream)发布本地音视频流
console.log("切换角色成功");_this12.rtcClient.publish(localStream).then(function(){// 本地流发布成功
console.log("本地流发布成功");}).catch(function(err){console.error("连麦错误:",localStream,err);});}).catch(function(err){console.log("切换角色错误:",err);});}).catch(function(error){console.error("failed initialize localStream "+error);});},rtcLinkDown:function rtcLinkDown(){var _this13=this;if(this.localStream){this.rtcClient.unpublish(this.localStream).then(function(){// live互动直播模式下，观众连麦推流
_this13.rtcClient.switchRole("audience").then(function(){// 连麦观众角色切换为主播，开始推流
console.log("切换角色成功");});});}}}};/***/},/* 17 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__VodPlayer_vue__=__webpack_require__(62);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__canvasPlayer_vue__=__webpack_require__(66);//
//
//
//
//
//
//
//
//
/* harmony default export */__webpack_exports__["a"]={props:{videoPoster:{type:String,default:''},playerid:{type:String,default:''},isWhitebord:{type:Boolean,default:false},isVertical:{type:Boolean,default:false},isPc:{type:Boolean,default:false},runObj:{type:Object,default:function _default(){return{};}},copyrightObj:{type:Object,default:function _default(){return{};}},fans_id:{type:Number|String,default:0},nick:{type:String,default:''},remark:{type:String,default:''},isThird:{type:Boolean,default:true},isThreeScreen:{type:Boolean,default:false},canPlayH265:{type:Boolean,default:true}},components:{vodePlayer:__WEBPACK_IMPORTED_MODULE_0__VodPlayer_vue__["a"/* default */],canvasPlayer:__WEBPACK_IMPORTED_MODULE_1__canvasPlayer_vue__["a"/* default */]},data:function data(){return{isH265:false,isPad:/iPad/i.test(window.navigator.userAgent)||window.navigator.platform==='MacIntel'&&window.navigator.maxTouchPoints>1,iOS:/iPhone|iPod|iPad/.test(window.navigator.userAgent)||window.navigator.platform==='MacIntel'&&window.navigator.maxTouchPoints>1};},methods:{// 判断浏览器是否支持h265 
isSupportH265:function isSupportH265(){var isSupport=window.WebAssembly&&window.Worker&&!this.iOS&&this.canPlayH265&&(this.isThreeScreen&&this.isWhitebord||!this.isThreeScreen);return isSupport;},isIphoneBefore11:function isIphoneBefore11(){if(typeof window!=="undefined"&&window.navigator){return /iphone/gi.test(window.navigator.userAgent)&&(window.screen.height<=812||window.screen.height===896&&window.screen.width===414);}return false;},playVod:function playVod(videoPlayList,to){var _this=this;console.log("videoPlayList",videoPlayList,to);var playeData=videoPlayList[to?to:0];var new_video_wb=null;var new_video=null;this.isH265=false;var playeData_TMP={};if(this.isWhitebord){//白板
playeData_TMP={file_id:playeData.wb_file_id,playback:playeData.wb_playback//白板暂时屏蔽
};if(playeData.new_video_wb&&playeData.new_video_wb.length>0){new_video_wb=playeData.new_video_wb.filter(function(item){return item.vcodec==2&&item.container=='hls';}).sort(function(a,b){return parseInt(a.size)-parseInt(b.size);})[0];if(new_video_wb&&this.isSupportH265()){this.isH265=true;playeData_TMP={file_id:playeData.wb_file_id,new_file_id:new_video_wb.cloud_file_id,playback:new_video_wb.url};}}}else{playeData_TMP={file_id:playeData.file_id,playback:playeData.playback};if(playeData.new_video&&playeData.new_video.length>0){var _new_video=playeData.new_video.filter(function(item){return item.vcodec==2&&item.container=='hls';}).sort(function(a,b){return parseInt(a.size)-parseInt(b.size);})[0];if(_new_video&&this.isSupportH265()){this.isH265=true;playeData_TMP={file_id:playeData.file_id,new_file_id:_new_video.cloud_file_id,playback:_new_video.url};}}}// this.playeData.playback = 'https://tengface-project.oss-cn-shenzhen.aliyuncs.com/videotmp/h265hls/index.m3u8'
this.$nextTick(function(){_this.$refs.vodPlayer.playVod(playeData_TMP);});var data={playType:'vod',type:"report",data:{info:"【直播-导航条】初始化播放器",playType:''+(this.isH265?'cPlayer播放器':'TCPlayer播放器')}};this.$emit('playerListener',data);},pause:function pause(){this.$refs.vodPlayer.pause();},playerListener:function playerListener(data){this.$emit('playerListener',data);},getCurrentTime:function getCurrentTime(){if(this.$refs.vodPlayer){return this.$refs.vodPlayer.getCurrentTime();}return 0;},getDuration:function getDuration(){if(this.$refs.vodPlayer){return this.$refs.vodPlayer.getDuration();}return 0;},setCurrentTime:function setCurrentTime(time){if(this.$refs.vodPlayer){this.$refs.vodPlayer.setCurrentTime(time);}},play:function play(){if(this.$refs.vodPlayer){this.$refs.vodPlayer.play();}},changePlaySpeed:function changePlaySpeed(value){if(this.$refs.vodPlayer){this.$refs.vodPlayer.changePlaySpeed(value);}}}};/***/},/* 18 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */__webpack_exports__["a"]={props:{videoPoster:{type:String,default:''},playerid:{type:String,default:''},isWhitebord:{type:Boolean,default:false},isVertical:{type:Boolean,default:false},isPc:{type:Boolean,default:false},runObj:{type:Object,default:function _default(){return{};}},copyrightObj:{type:Object,default:function _default(){return{};}},fans_id:{type:Number|String,default:0},nick:{type:String,default:''},remark:{type:String,default:''},isThird:{type:Boolean,default:true},isThreeScreen:{type:Boolean,default:false}},mounted:function mounted(){this.addPlayerListener();// this.pcOnKeyUp()
this.intervalID=setInterval(this.moveBox,80);},computed:{objectFit:function objectFit(){if(this.isVertical){if(!this.isPc){return'cover';}}return'contain';}},watch:{showControns:function showControns(to){if(!to){this.timesListViewShow=false;}}},data:function data(){return{playSpeed:1,isMuted:false,showControns:false,isAutoPlay:false,vodPlayType:'default',mp4Url:'',playerStatus:'init',// 播放状态 'init' 初始化   'load 加载中'  'playing 播放中'  pause 暂停
currentPlayTime:0,videoDuration:0,timesListViewShow:false,fastForwardTimer:null,isFastForward:false,fastBackTimer:null,isFastBack:false,startFastBackTimer:null,posi:0,scheduledAnimationFrame:false,box:null,clientWidth:0,bodyTouchEndNum:0,bodyTouchCurrentTimer:0,isSwifeMove:false,isMove:false,hls:null,playeData:{},rotateRunBox:false,boxLeft:10,// 初始左边距离
boxTop:10,// 初始顶部距离
winMax:10,// 设置最大视觉差
sx:0,// x轴移动状态，0表示正向移动，1表示返回
sy:0,// y轴移动状态，0表示正向移动，1表示返回
intervalID:null,// setInterval 的 ID
isfullScreen:false,iOS:/iPhone|iPad|iPod/.test(navigator.userAgent)||navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1};},methods:{moveBox:function moveBox(){// 获取 runBox 的宽度和高度
var runBox=this.$refs.runBoxRef;if(runBox&&runBox.offsetWidth){var runBoxWidth=runBox.offsetWidth;var runBoxHeight=runBox.offsetHeight;// 计算盒子在x轴上最远达到的距离
var winx=runBoxWidth-42-this.winMax;// 100 是盒子的宽度
// 计算盒子在y轴上最远达到的距离
var winy=runBoxHeight-24-this.winMax;// 100 是盒子的高度
// x轴移动
if(this.sx===0){this.boxLeft++;}else{this.boxLeft--;}if(this.boxLeft<=0){this.sx=0;}else if(this.boxLeft>=winx){this.sx=1;}// y轴移动
if(this.sy===0){this.boxTop++;}else{this.boxTop--;}if(this.boxTop<=0){this.sy=0;}else if(this.boxTop>=winy){this.sy=1;}}},playVod:function playVod(playeData){this.mp4Url=playeData.playback;this.playeData=playeData;this.vodLoad();this.play();},onTouchStart:function onTouchStart(event){event.preventDefault();console.log('开始拖拽',event);this.isMove=true;if(event.cancelable){event.preventDefault();}},onTouchMove:function onTouchMove(event){event.preventDefault();if(event.cancelable){event.preventDefault();}var evt=event.touches[0];var box=this.$refs.tf_vod_progress_view;var boxLeft=box.getBoundingClientRect().left;this.clientWidth=box.clientWidth;var pageScrollLeft=document.documentElement.scrollLeft||document.body.scrollLeft;var posi=evt.pageX-boxLeft-pageScrollLeft;if(posi<0||posi>this.clientWidth||isNaN(posi)||isNaN(this.clientWidth)){return;}this.posi=posi;},onTouchEnd:function onTouchEnd(event){event.preventDefault();console.log('拖拽结束',event);this.isMove=false;if(event.cancelable){event.preventDefault();}var progress=this.posi/this.clientWidth;if(!isNaN(progress)){this.$refs.videoVodTengface.currentTime=this.$refs.videoVodTengface.duration*progress;}},pcOnKeyUp:function pcOnKeyUp(){var _this=this,_arguments=arguments;document.onkeyup=function(event){//键盘事件
var time=5;var videoElement=_this.$refs.videoVodTengface;var e=event||window.event||_arguments.callee.caller.arguments[0];if(e&&e.keyCode===37){// 按 向左键
if(videoElement.currentTime!==0){videoElement.currentTime-=time;}return false;}else if(e&&e.keyCode===39){// 按 向右键
videoElement.currentTime+=time;return false;}};document.body.onkeydown=function(event){var e=event||window.event||_arguments.callee.caller.arguments[0];if(e&&e.keyCode===32){// 按 空格键
_this.shuaxingCliked();return false;}};},bodyTouchStart:function bodyTouchStart(event){// const bottomView = document.getElementById("tengface_vod_bottomView");
// const tengface_vod_mainView = document.getElementById("tengface_vod_mainView");
// console.log("bodyTouchStart",event,event.target,bottomView.contains(event.target));
// if(!bottomView.contains(event.target)){
// 	if(event.touches[0].clientX * 2 > tengface_vod_mainView.clientWidth){
// 		this.fastForwardTimer = setTimeout(()=>{
// 			this.isFastForward = true
// 			this.$refs.videoVodTengface.playbackRate = 4
// 		},700)
// 	}else{
// 		this.fastForwardTimer = setTimeout(()=>{
// 			this.isFastBack = true
// 			this.$refs.videoVodTengface.pause();
// 			this.startFastBack()
// 		},700)
// 	}
// }
this.bodyTouchCurrentTimer=this.currentPlayTime;},bodyTouchMove:function bodyTouchMove(event){var endTmp=event.touches[0].clientX;if(endTmp<this.bodyTouchEndNum){//向左
this.bodyTouchCurrentTimer=this.bodyTouchCurrentTimer-1;}else if(endTmp>this.bodyTouchEndNum){//向右
this.bodyTouchCurrentTimer=this.bodyTouchCurrentTimer+1;}this.bodyTouchEndNum=endTmp;if(this.bodyTouchCurrentTimer<0){this.bodyTouchCurrentTimer=0;}else if(this.bodyTouchCurrentTimer>this.videoDuration){this.bodyTouchCurrentTimer=this.videoDuration;}this.isSwifeMove=true;//是移动
//  if(this.fastForwardTimer){
// 		clearTimeout(this.fastForwardTimer)
// 		this.fastForwardTimer = null
// 	}
// 	if(this.isFastForward){
// 		this.isFastForward = false
// 		this.$refs.videoVodTengface.playbackRate = 1
// 	}
// 	if(this.isFastBack){
// 		this.isFastBack = false
// 		this.endFastBack()
// 	}
console.log("bodyTouchCurrentTimer",this.bodyTouchCurrentTimer);},bodyTouchEnd:function bodyTouchEnd(event){if(this.isSwifeMove){this.isSwifeMove=false;console.log("bodyTouchEnd",event);if(!isNaN(this.bodyTouchCurrentTimer)){this.$refs.videoVodTengface.currentTime=this.bodyTouchCurrentTimer;}}// if(this.fastForwardTimer){
// 	clearTimeout(this.fastForwardTimer)
// 	this.fastForwardTimer = null
// }
// if(this.isFastForward){
// 	this.isFastForward = false
// 	this.$refs.videoVodTengface.playbackRate = 1
// }
// if(this.isFastBack){
// 	this.isFastBack = false
// }
},startFastBack:function startFastBack(){var _this2=this;this.startFastBackTimer=setInterval(function(){_this2.$refs.videoVodTengface.currentTime=_this2.$refs.videoVodTengface.currentTime-2;},300);},endFastBack:function endFastBack(){if(this.startFastBackTimer){clearInterval(this.startFastBackTimer);this.startFastBackTimer=null;}this.$refs.videoVodTengface.play();},mouseOver:function mouseOver(){var _this3=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this3.showControns=false;},5000);},mousemove:function mousemove(){var _this4=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this4.showControns=false;},5000);},mouseLeave:function mouseLeave(){var _this5=this;this.timer=setTimeout(function(){_this5.showControns=false;},5000);},addPlayerListener:function addPlayerListener(){this.$refs.videoVodTengface.addEventListener('canplay',this.onPlayerCanplay);this.$refs.videoVodTengface.addEventListener('timeupdate',this.onPlayerTimeupdate);this.$refs.videoVodTengface.addEventListener('play',this.onPlayerPlay);this.$refs.videoVodTengface.addEventListener('pause',this.onPlayerPause);this.$refs.videoVodTengface.addEventListener('seeking',this.onPlayerSeeking);this.$refs.videoVodTengface.addEventListener('seeked',this.onPlayerSeeked);this.$refs.videoVodTengface.addEventListener('waiting',this.onPlayerWaiting);this.$refs.videoVodTengface.addEventListener('loadedmetadata',this.onLoadedmetadata);},removePlayerListener:function removePlayerListener(){this.$refs.videoVodTengface.removeEventListener('canplay',this.onPlayerCanplay);this.$refs.videoVodTengface.removeEventListener('timeupdate',this.onPlayerTimeupdate);this.$refs.videoVodTengface.removeEventListener('play',this.onPlayerPlay);this.$refs.videoVodTengface.removeEventListener('pause',this.onPlayerPause);this.$refs.videoVodTengface.removeEventListener('seeking',this.onPlayerSeeking);this.$refs.videoVodTengface.removeEventListener('seeked',this.onPlayerSeeked);this.$refs.videoVodTengface.removeEventListener('waiting',this.onPlayerWaiting);this.$refs.videoVodTengface.removeEventListener('loadedmetadata',this.onLoadedmetadata);},onLoadedmetadata:function onLoadedmetadata(event){console.log('视频信息加载完毕',this.$refs.videoVodTengface.duration);this.videoDuration=Math.floor(this.$refs.videoVodTengface.duration);},onPlayerWaiting:function onPlayerWaiting(event){console.log('等待加载',event);this.playerStatus='load';},onPlayerSeeked:function onPlayerSeeked(event){console.log('进度完成',event);},onPlayerSeeking:function onPlayerSeeking(event){console.log('进度',event);},onPlayerCanplay:function onPlayerCanplay(event){console.log("可以播放",event);if(this.$refs.videoVodTengface.paused){this.playerStatus='pause';if(this.isAutoPlay){this.$refs.videoVodTengface.play();}}else{this.playerStatus='playing';}},onPlayerPlay:function onPlayerPlay(event){console.log("播放",event);this.playerStatus='playing';},onPlayerTimeupdate:function onPlayerTimeupdate(event){this.currentPlayTime=Math.floor(this.$refs.videoVodTengface.currentTime);var data={playType:'vod',type:"timeupdate",playData:this.playeData,currentPlayTime:this.currentPlayTime,playSpeed:this.playSpeed};this.$emit('playerListener',data);if(this.isMove)return;var progress=this.currentPlayTime/this.videoDuration;var point=this.$refs.tf_progress_point;point.style.left=progress*100+'%';var view=this.$refs.tf_progress_view;view.style.width=progress*100+'%';},onPlayerPause:function onPlayerPause(event){console.log("暂停",event);this.playerStatus='pause';},playClicked:function playClicked(){this.play();},onProgressClicked:function onProgressClicked(event){var progress=event.offsetX/event.target.clientWidth;this.$refs.videoVodTengface.currentTime=this.$refs.videoVodTengface.duration*progress;var point=this.$refs.tf_progress_point;point.style.left=progress*100+'%';var view=this.$refs.tf_progress_view;view.style.width=progress*100+'%';},shuaxingCliked:function shuaxingCliked(){console.log("双击");if(this.playerStatus=='playing'){this.pause();}else{this.playClicked();}},changePlaySpeed:function changePlaySpeed(speed){this.playSpeed=speed;this.$refs.videoVodTengface.playbackRate=speed;this.timesListViewShow=false;this.$emit("playerListener",{type:'speed',playType:'vod',value:speed});},quanpingCliked:function quanpingCliked(){var livePlayer=this.$refs.vodPlayer;var fastVideo=this.$refs.videoVodTengface;if(!this.isfullScreen){if(livePlayer.requestFullscreen){livePlayer.requestFullscreen();this.isfullScreen=true;return;}else if(livePlayer.mozRequestFullScreen){livePlayer.mozRequestFullScreen();this.isfullScreen=true;return;}else if(livePlayer.webkitRequestFullscreen){livePlayer.webkitRequestFullscreen();this.isfullScreen=true;return;}else if(fastVideo.webkitEnterFullscreen){fastVideo.webkitEnterFullscreen();return;}else if(fastVideo.webkitEnterFullScreen){fastVideo.webkitEnterFullScreen();return;}else if(livePlayer.msRequestFullscreen){this.isfullScreen=true;livePlayer.msRequestFullscreen();return;}this.$emit("unAutoPlay",{message:'全屏播放失败',type:'error'});}else{if(document.exitFullscreen){this.isfullScreen=false;return document.exitFullscreen();}else if(document.cancelFullScreen){this.isfullScreen=false;document.cancelFullScreen();}else if(document.mozCancelFullScreen){this.isfullScreen=false;return document.mozCancelFullScreen();}else if(document.webkitCancelFullScreen){this.isfullScreen=false;return document.webkitCancelFullScreen();}else if(document.webkitCancelFullscreen){this.isfullScreen=false;return document.webkitCancelFullscreen();}else if(document.msCancelFullScreen){this.isfullScreen=false;return document.msCancelFullScreen();}else if(document.msExitFullscreen){this.isfullScreen=false;return document.msExitFullscreen();}this.$emit("unAutoPlay",{message:'退出全屏失败',type:'error'});}//  var u = navigator.userAgent;
// 	if (
// 	!(u.indexOf("Android") < 0 &&
// 	u.indexOf("Linux") < 0 &&
// 	u.indexOf("iPhone") < 0 &&
// 	u.indexOf("Windows Phone") < 0 &&
// 	u.indexOf("MiniProgram") < 0)&&this.isfullScreen
// 	) {
// 		console.log('shoujishoujishoujishoujishoujishoujishoujishoujishoujishoujishouji');
// 		this.rotateRunBox = true;
// 				// 获取视口的宽度和高度
// 		const viewportWidth = window.innerWidth;
// 		const viewportHeight = window.innerHeight;
// 		// 将盒子的宽度设置为视口的高度
// 		const copyright =  document.querySelector('#copyrightONE');
// 		console.log(copyright,'copyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyright');
// 		copyright.style.width = `${viewportHeight}px`;
// 		copyright.style.transformOrigin = 'top left';
// 		// 平移盒子的效果
// 		const translateXValue = viewportWidth;
// 		copyright.style.transform = `rotate(90deg) translateY(-${translateXValue}px)`;
// 		console.log(copyright,'copyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyrightcopyright');
// 	}else{
// 	this.rotateRunBox = false;
// 	// 还原盒子样式
// 	const copyright = document.querySelector('#copyrightONE');
// 	copyright.style.width = ''; // 还原宽度
// 	copyright.style.transformOrigin = ''; // 还原变换原点
// 	copyright.style.transform = ''; // 还原变换
// 	}
},jingyingClicked:function jingyingClicked(){if(this.isMuted){this.isMuted=false;this.$refs.videoVodTengface.muted=false;}else{this.isMuted=true;this.$refs.videoVodTengface.muted=true;}},vodLoad:function vodLoad(){if(this.vodPlayType=='default'){if(this.mp4Url!=''){if(this.hls){this.hls.destroy();this.hls=null;}if(Hls.isSupported()){// eslint-disable-next-line no-undef
this.hls=new Hls();this.hls.attachMedia(this.$refs.videoVodTengface);}var isM3u8=this.mp4Url.indexOf('.m3u8')>-1;if(this.hls&&isM3u8){this.hls.loadSource(this.mp4Url);}else{this.$refs.videoVodTengface.src=this.mp4Url;}this.playSpeed=1;this.$refs.videoVodTengface.playbackRate=1;}}},play:function play(){var _this6=this;return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return _this6.$refs.videoVodTengface.play();case 3:_this6.$emit("playerListener",{type:'play',playType:'vod'});_context.next=10;break;case 6:_context.prev=6;_context.t0=_context['catch'](0);console.log("自动播放失败");_this6.$emit("playerListener",{type:'pause',playType:'vod'});case 10:case'end':return _context.stop();}}},_callee,_this6,[[0,6]]);}))();},stop:function stop(){},pause:function pause(){this.playerStatus='pause';this.$refs.videoVodTengface.pause();this.$emit("playerListener",{type:'pause',playType:'vod'});},time2String:function time2String(time){var m=parseInt(time/60);var s=parseInt(time%60);if(m<=9){m='0'+m;}if(s<=9){s='0'+s;}return m+':'+s;},getCurrentTime:function getCurrentTime(){if(this.$refs.videoVodTengface){return this.$refs.videoVodTengface.currentTime;}return 0;},getDuration:function getDuration(){if(this.$refs.videoVodTengface){return this.$refs.videoVodTengface.duration;}return 0;},setCurrentTime:function setCurrentTime(time){if(this.$refs.videoVodTengface){this.$refs.videoVodTengface.currentTime=time;}}},beforeDestroy:function beforeDestroy(){this.removePlayerListener();clearInterval(this.intervalID);}};/***/},/* 19 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__h265_h265Player_h265_css__=__webpack_require__(69);/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__h265_h265Player_h265_css___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__h265_h265Player_h265_css__);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__h265_h265Player_h265_sdk__=__webpack_require__(71);/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__h265_h265Player_h265_sdk___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__h265_h265Player_h265_sdk__);//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */__webpack_exports__["a"]={props:{videoPoster:{type:String,default:''},playerid:{type:String,default:''},isWhitebord:{type:Boolean,default:false},isVertical:{type:Boolean,default:false},isPc:{type:Boolean,default:false},runObj:{type:Object,default:function _default(){return{};}},copyrightObj:{type:Object,default:function _default(){return{};}},fans_id:{type:Number|String,default:0},nick:{type:String,default:''},remark:{type:String,default:''},isThird:{type:Boolean,default:true},isThreeScreen:{type:Boolean,default:false}},mounted:function mounted(){// this.pcOnKeyUp()
this.intervalID=setInterval(this.moveBox,80);// 监听窗口大小变化
window.addEventListener('resize',this.windowRezie);},computed:{objectFit:function objectFit(){if(this.isVertical){if(!this.isPc){return'cover';}}return'contain';}},watch:{showControns:function showControns(to){if(!to){this.timesListViewShow=false;}}},data:function data(){return{playSpeed:1,isMuted:false,showControns:false,isAutoPlay:false,vodPlayType:'default',mp4Url:'',playerStatus:'init',// 播放状态 'init' 初始化   'load 加载中'  'playing 播放中'  pause 暂停
currentPlayTime:0,videoDuration:0,timesListViewShow:false,fastForwardTimer:null,isFastForward:false,fastBackTimer:null,isFastBack:false,startFastBackTimer:null,posi:0,scheduledAnimationFrame:false,box:null,clientWidth:0,bodyTouchEndNum:0,bodyTouchCurrentTimer:0,isSwifeMove:false,isMove:false,hls:null,playeData:{},rotateRunBox:false,boxLeft:10,// 初始左边距离
boxTop:10,// 初始顶部距离
winMax:10,// 设置最大视觉差
sx:0,// x轴移动状态，0表示正向移动，1表示返回
sy:0,// y轴移动状态，0表示正向移动，1表示返回
intervalID:null,// setInterval 的 ID
isfullScreen:false,isPad:/iPad/i.test(window.navigator.userAgent)||window.navigator.platform==='MacIntel'&&window.navigator.maxTouchPoints>1,h265player:null,isShowIOSFullScreen:false,isAndroid:/Android/i.test(window.navigator.userAgent),isWeChat:/MicroMessenger/i.test(window.navigator.userAgent),LandscapeStyle:{},Landscape:false,iOS:/iPhone|iPod/.test(navigator.userAgent)||navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1};},methods:{windowRezie:function windowRezie(){var _this=this;var conW=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;var conH=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;console.log('设备大小改变',"conW=",conW,"conH=",conH);if(conW>conH&&this.Landscape&&this.isAndroid&&this.isWeChat){//横屏
console.error('android横屏');this.Landscape=false;this.LandscapeStyle={};this.$nextTick(function(){setTimeout(function(){_this.h265player&&_this.h265player.resizeScreen();},300);});}else if(this.isShowIOSFullScreen||conW>conH){console.error('IOSFullScreen横屏');this.$nextTick(function(){console.error('IOSFullScreen横屏2');setTimeout(function(){_this.h265player&&_this.h265player.resizeScreen();},300);});}},LandscapeTap:function LandscapeTap(){var _this2=this;if(this.Landscape){var conW=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;var conH=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;// transform: rotate(90deg); width: 667px; height: 375px;transform-origin:28% 50%;
this.LandscapeStyle={transform:"rotate(90deg) translate("+(conH-conW)/2+"px,"+(conH-conW)/2+"px)",height:"100vw",width:"100vh",'transform-origin':"45% 50%"};}else{this.LandscapeStyle={};}this.$nextTick(function(){// this.h265player && this.h265player.resizeScreen()
_this2.h265player.requestFullscreen();});},moveBox:function moveBox(){// 获取 runBox 的宽度和高度
var runBox=this.$refs.runBoxRef;if(runBox&&runBox.offsetWidth){var runBoxWidth=runBox.offsetWidth;var runBoxHeight=runBox.offsetHeight;// 计算盒子在x轴上最远达到的距离
var winx=runBoxWidth-42-this.winMax;// 100 是盒子的宽度
// 计算盒子在y轴上最远达到的距离
var winy=runBoxHeight-24-this.winMax;// 100 是盒子的高度
// x轴移动
if(this.sx===0){this.boxLeft++;}else{this.boxLeft--;}if(this.boxLeft<=0){this.sx=0;}else if(this.boxLeft>=winx){this.sx=1;}// y轴移动
if(this.sy===0){this.boxTop++;}else{this.boxTop--;}if(this.boxTop<=0){this.sy=0;}else if(this.boxTop>=winy){this.sy=1;}}},playVod:function playVod(playeData){var _this3=this;this.playeData=playeData;this.playSpeed=1;if(this.h265player){this.removePlayerListener();}this.$nextTick(function(){_this3.h265player=new __WEBPACK_IMPORTED_MODULE_1__h265_h265Player_h265_sdk___default.a('id_video_vod_tengface2'+_this3.playerid,{sourceURL:playeData.playback,maxBufferLength:10000,//缓冲时长10s
type:'HLS',libPath:"https://wanzibook-res-1317978474.cos.accelerate.myqcloud.com/web/ffmpeglib/",playBackRate:1,autoPlay:true,controls:false,debug:true});_this3.addPlayerListener();});},onTouchStart:function onTouchStart(event){event.preventDefault();console.log('开始拖拽',event);this.isMove=true;if(event.cancelable){event.preventDefault();}},onTouchMove:function onTouchMove(event){event.preventDefault();if(event.cancelable){event.preventDefault();}var evt=event.touches[0];var box=this.$refs.tf_vod_progress_view;var boxLeft=box.getBoundingClientRect().left;this.clientWidth=box.clientWidth;var pageScrollLeft=document.documentElement.scrollLeft||document.body.scrollLeft;var posi=evt.pageX-boxLeft-pageScrollLeft;if(posi<0||posi>this.clientWidth||isNaN(posi)||isNaN(this.clientWidth)){return;}this.posi=posi;},onTouchEnd:function onTouchEnd(event){event.preventDefault();console.log('拖拽结束',event);this.isMove=false;if(event.cancelable){event.preventDefault();}var progress=this.posi/this.clientWidth;if(!isNaN(progress)){this.$refs.videoVodTengface.currentTime=this.$refs.videoVodTengface.duration*progress;}},pcOnKeyUp:function pcOnKeyUp(){var _this4=this,_arguments=arguments;document.onkeyup=function(event){//键盘事件
var time=5;var videoElement=_this4.$refs.videoVodTengface;var e=event||window.event||_arguments.callee.caller.arguments[0];if(e&&e.keyCode===37){// 按 向左键
if(videoElement.currentTime!==0){videoElement.currentTime-=time;}return false;}else if(e&&e.keyCode===39){// 按 向右键
videoElement.currentTime+=time;return false;}};document.body.onkeydown=function(event){var e=event||window.event||_arguments.callee.caller.arguments[0];if(e&&e.keyCode===32){// 按 空格键
_this4.shuaxingCliked();return false;}};},bodyTouchStart:function bodyTouchStart(event){// const bottomView = document.getElementById("tengface_vod_bottomView");
// const tengface_vod_mainView = document.getElementById("tengface_vod_mainView");
// console.log("bodyTouchStart",event,event.target,bottomView.contains(event.target));
// if(!bottomView.contains(event.target)){
// 	if(event.touches[0].clientX * 2 > tengface_vod_mainView.clientWidth){
// 		this.fastForwardTimer = setTimeout(()=>{
// 			this.isFastForward = true
// 			this.$refs.videoVodTengface.playbackRate = 4
// 		},700)
// 	}else{
// 		this.fastForwardTimer = setTimeout(()=>{
// 			this.isFastBack = true
// 			this.$refs.videoVodTengface.pause();
// 			this.startFastBack()
// 		},700)
// 	}
// }
this.bodyTouchCurrentTimer=this.currentPlayTime;},bodyTouchMove:function bodyTouchMove(event){var endTmp=event.touches[0].clientX;if(endTmp<this.bodyTouchEndNum){//向左
this.bodyTouchCurrentTimer=this.bodyTouchCurrentTimer-1;}else if(endTmp>this.bodyTouchEndNum){//向右
this.bodyTouchCurrentTimer=this.bodyTouchCurrentTimer+1;}this.bodyTouchEndNum=endTmp;if(this.bodyTouchCurrentTimer<0){this.bodyTouchCurrentTimer=0;}else if(this.bodyTouchCurrentTimer>this.videoDuration){this.bodyTouchCurrentTimer=this.videoDuration;}this.isSwifeMove=true;//是移动
//  if(this.fastForwardTimer){
// 		clearTimeout(this.fastForwardTimer)
// 		this.fastForwardTimer = null
// 	}
// 	if(this.isFastForward){
// 		this.isFastForward = false
// 		this.$refs.videoVodTengface.playbackRate = 1
// 	}
// 	if(this.isFastBack){
// 		this.isFastBack = false
// 		this.endFastBack()
// 	}
console.log("bodyTouchCurrentTimer",this.bodyTouchCurrentTimer);},bodyTouchEnd:function bodyTouchEnd(event){if(this.isSwifeMove){this.isSwifeMove=false;console.log("bodyTouchEnd",event);if(!isNaN(this.bodyTouchCurrentTimer)){this.h265player.currentTimeSec(this.bodyTouchCurrentTimer);}}// if(this.fastForwardTimer){
// 	clearTimeout(this.fastForwardTimer)
// 	this.fastForwardTimer = null
// }
// if(this.isFastForward){
// 	this.isFastForward = false
// 	this.$refs.videoVodTengface.playbackRate = 1
// }
// if(this.isFastBack){
// 	this.isFastBack = false
// }
},startFastBack:function startFastBack(){var _this5=this;this.startFastBackTimer=setInterval(function(){_this5.$refs.videoVodTengface.currentTime=_this5.$refs.videoVodTengface.currentTime-2;},300);},endFastBack:function endFastBack(){if(this.startFastBackTimer){clearInterval(this.startFastBackTimer);this.startFastBackTimer=null;}this.$refs.videoVodTengface.play();},mouseOver:function mouseOver(){var _this6=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this6.showControns=false;},5000);},mousemove:function mousemove(){var _this7=this;this.showControns=true;if(this.timer){clearTimeout(this.timer);this.timer=null;}this.timer=setTimeout(function(){_this7.showControns=false;},5000);},mouseLeave:function mouseLeave(){var _this8=this;this.timer=setTimeout(function(){_this8.showControns=false;},5000);},addPlayerListener:function addPlayerListener(){this.h265player.on('mouseOver',this.onPlayerCanplay);this.h265player.on('timeupdate',this.onPlayerTimeupdate);this.h265player.on('play',this.onPlayerPlay);this.h265player.on('pause',this.onPlayerPause);this.h265player.on('seeking',this.onPlayerSeeking);this.h265player.on('seeked',this.onPlayerSeeked);this.h265player.on('waiting',this.onPlayerWaiting);this.h265player.on('durationchange',this.onLoadedmetadata);this.h265player.on('error',this.onPlayerError);},removePlayerListener:function removePlayerListener(){this.h265player.off('canplay',this.onPlayerCanplay);this.h265player.off('timeupdate',this.onPlayerTimeupdate);this.h265player.off('play',this.onPlayerPlay);this.h265player.off('pause',this.onPlayerPause);this.h265player.off('seeking',this.onPlayerSeeking);this.h265player.off('seeked',this.onPlayerSeeked);this.h265player.off('waiting',this.onPlayerWaiting);this.h265player.off('durationchange',this.onLoadedmetadata);this.h265player.off('error',this.onPlayerError);this.h265player.destroy();this.h265player=null;},onPlayerError:function onPlayerError(event){if(event==="autoplayFail"){console.error("自动播放错误===========");this.$emit("playerListener",{type:'pause',playType:'vod'});}else{var data={playType:'vod',type:"report",data:{info:event,playType:'cPlayer播放器Error'}};this.$emit('playerListener',data);}},onLoadedmetadata:function onLoadedmetadata(event){console.log('视频信息加载完毕',event);this.videoDuration=this.h265player.duration().toFixed(2);},onPlayerWaiting:function onPlayerWaiting(event){console.log('等待加载',event);this.playerStatus='load';},onPlayerSeeked:function onPlayerSeeked(event){// this.playerStatus = 'load'
console.log('进度完成',event);},onPlayerSeeking:function onPlayerSeeking(event){console.log('进度',event);},onPlayerCanplay:function onPlayerCanplay(event){console.log("可以播放",event);// if (this.$refs.videoVodTengface.paused) {
// 	this.playerStatus = 'pause'
// 	if (this.isAutoPlay) {
// 		this.$refs.videoVodTengface.play();
// 	}
// } else {
// 	this.playerStatus = 'playing'
// }
},onPlayerPlay:function onPlayerPlay(event){console.log("播放",event);this.playerStatus='playing';},onPlayerTimeupdate:function onPlayerTimeupdate(time){this.currentPlayTime=Math.floor(time/1000);var data={playType:'vod',type:"timeupdate",playData:this.playeData,playSpeed:this.playSpeed,currentPlayTime:this.currentPlayTime};this.$emit('playerListener',data);if(this.isMove)return;var progress=this.currentPlayTime/this.videoDuration;var point=this.$refs.tf_progress_point;point.style.left=progress*100+'%';var view=this.$refs.tf_progress_view;view.style.width=progress*100+'%';},onPlayerPause:function onPlayerPause(event){this.playerStatus='pause';console.log("暂停",event);},playClicked:function playClicked(){this.play();},onProgressClicked:function onProgressClicked(event){var progress=event.offsetX/event.target.clientWidth;this.h265player.currentTimeSec(this.h265player.duration()*progress);var point=this.$refs.tf_progress_point;point.style.left=progress*100+'%';var view=this.$refs.tf_progress_view;view.style.width=progress*100+'%';},shuaxingCliked:function shuaxingCliked(){console.log("双击");if(this.playerStatus=='playing'){this.pause();}else{this.playClicked();}},changePlaySpeed:function changePlaySpeed(speed){this.playSpeed=speed;this.h265player.changeSpeed({value:speed});this.timesListViewShow=false;this.$emit("playerListener",{type:'speed',playType:'vod',value:speed});},quanpingCliked:function quanpingCliked(){var _this9=this;var u=navigator.userAgent;if(u.indexOf("iPhone")>0||u.indexOf("iPad")>0||this.isAndroid&&!this.isWeChat){this.isfullScreen=!this.isfullScreen;if(this.isfullScreen){//显示全屏
this.isShowIOSFullScreen=true;}else{//退出全屏
this.isShowIOSFullScreen=false;}// 全屏
this.$nextTick(function(){_this9.h265player&&_this9.h265player.resizeScreen();});}else{var livePlayer=this.$refs.vodPlayer;var video=this.$refs.internalVideo;var conW=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;var conH=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;if(!this.isfullScreen){if(this.isAndroid&&this.isWeChat&&conH>conW){this.Landscape=true;this.LandscapeTap();}else{this.h265player.requestFullscreen();}if(livePlayer.requestFullscreen){livePlayer.requestFullscreen();this.isfullScreen=true;return;}else if(livePlayer.mozRequestFullScreen){livePlayer.mozRequestFullScreen();this.isfullScreen=true;return;}else if(livePlayer.webkitRequestFullscreen){video.style.width='100vw';video.style.height='100vh';livePlayer.webkitRequestFullscreen();this.isfullScreen=true;return;}this.$emit("unAutoPlay",{message:'全屏播放失败',type:'error'});}else{if(this.isAndroid&&this.isWeChat){this.Landscape=false;this.LandscapeTap();}this.h265player.exitFullscreen();if(document.exitFullscreen){this.isfullScreen=false;return document.exitFullscreen();}else if(document.cancelFullScreen){this.isfullScreen=false;document.cancelFullScreen();}else if(document.mozCancelFullScreen){this.isfullScreen=false;return document.mozCancelFullScreen();}else if(document.webkitCancelFullScreen){this.isfullScreen=false;return document.webkitCancelFullScreen();}else if(document.webkitCancelFullscreen){this.isfullScreen=false;return document.webkitCancelFullscreen();}else if(document.msCancelFullScreen){this.isfullScreen=false;return document.msCancelFullScreen();}else if(document.msExitFullscreen){this.isfullScreen=false;return document.msExitFullscreen();}this.$emit("unAutoPlay",{message:'退出全屏失败',type:'error'});}}},jingyingClicked:function jingyingClicked(){if(this.isMuted){this.isMuted=false;}else{this.isMuted=true;}this.h265player.muted(this.isMuted);},play:function play(){this.h265player.play();this.$emit("playerListener",{type:'play',playType:'vod'});},stop:function stop(){},pause:function pause(){this.playerStatus='pause';this.h265player.pause();this.$emit("playerListener",{type:'pause',playType:'vod'});},time2String:function time2String(time){var m=parseInt(time/60);var s=parseInt(time%60);if(m<=9){m='0'+m;}if(s<=9){s='0'+s;}return m+':'+s;},getCurrentTime:function getCurrentTime(){if(this.h265player.currentTimeSec()){return Number(this.h265player.currentTimeSec().toFixed(0));}return 0;},getDuration:function getDuration(){if(this.h265player){return Math.floor(this.h265player.duration());}return 0;},setCurrentTime:function setCurrentTime(time){if(this.h265player){this.h265player.currentTimeSec(time);}}},beforeDestroy:function beforeDestroy(){this.removePlayerListener();clearInterval(this.intervalID);window.removeEventListener('resize',this.windowRezie);}};/***/},/* 20 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:true});/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_TFPlayer__=__webpack_require__(21);/* harmony default export */__webpack_exports__["default"]=__WEBPACK_IMPORTED_MODULE_0__components_TFPlayer__["a"/* default */];/***/},/* 21 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__=__webpack_require__(5);/* unused harmony namespace reexport *//* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d9b2203_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__=__webpack_require__(76);function injectStyle(ssrContext){__webpack_require__(22);}var normalizeComponent=__webpack_require__(3);/* script *//* template *//* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-2d9b2203";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a"/* default */],__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d9b2203_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a"/* default */],__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */__webpack_exports__["a"]=Component.exports;/***/},/* 22 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(23);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("fd82646e",content,true,{});/***/},/* 23 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,".tf-player[data-v-2d9b2203]{height:100%;width:100%;background-color:#000;position:relative}.tf-player .bigplayimg[data-v-2d9b2203]{position:absolute;height:100%;width:100%;top:0;overflow:hidden;z-index:100;text-align:center}.tf-player .bigplayimg img[data-v-2d9b2203]{width:100%;height:100%}.tf-player .bigplayimg .VerticalImg[data-v-2d9b2203]{width:auto!important}.player-icon[data-v-2d9b2203]{width:10%;left:50%;top:50%;transform:translate(-50%,-50%);position:absolute;z-index:101}.tfmarginLeft[data-v-2d9b2203]{margin-left:-65px}.tf-player .player-text[data-v-2d9b2203]{left:50%;top:50%;transform:translate(-50%,-50%);position:absolute;z-index:101;background-color:rgba(0,0,0,.5);color:#fff;padding:10px 23px;font-size:16px;border-radius:30px;display:flex;align-items:center}",""]);// exports
/***/},/* 24 *//***/function(module,exports){/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */module.exports=function listToStyles(parentId,list){var styles=[];var newStyles={};for(var i=0;i<list.length;i++){var item=list[i];var id=item[0];var css=item[1];var media=item[2];var sourceMap=item[3];var part={id:parentId+':'+i,css:css,media:media,sourceMap:sourceMap};if(!newStyles[id]){styles.push(newStyles[id]={id:id,parts:[part]});}else{newStyles[id].parts.push(part);}}return styles;};/***/},/* 25 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastLivePlayer_vue__=__webpack_require__(6);/* unused harmony namespace reexport *//* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f52ea00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastLivePlayer_vue__=__webpack_require__(48);function injectStyle(ssrContext){__webpack_require__(26);}var normalizeComponent=__webpack_require__(3);/* script *//* template *//* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-1f52ea00";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastLivePlayer_vue__["a"/* default */],__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f52ea00_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastLivePlayer_vue__["a"/* default */],__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */__webpack_exports__["a"]=Component.exports;/***/},/* 26 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(27);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("1900e782",content,true,{});/***/},/* 27 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,".runboxChild[data-v-1f52ea00]{position:absolute}.runBox[data-v-1f52ea00]{height:100%}.copyright[data-v-1f52ea00],.runBox[data-v-1f52ea00]{position:absolute;top:0;left:0;width:100%;overflow:hidden}.copyright[data-v-1f52ea00]{background-color:#000;color:#fff;line-height:50px;height:50px;white-space:nowrap}.banquanText[data-v-1f52ea00]{font-size:24px;position:absolute;animation:slideText-data-v-1f52ea00 25s linear infinite;width:100%}@keyframes slideText-data-v-1f52ea00{0%{transform:translateX(100%)}to{transform:translateX(-100%)}}.rotate[data-v-1f52ea00]{transform:rotate(90deg)}.livePlayer[data-v-1f52ea00]{width:100%;height:100%;position:relative}.controns[data-v-1f52ea00]{width:100%;height:100%;position:absolute;top:0;left:0;z-index:1}.controns .main[data-v-1f52ea00]{width:100%;height:100%;position:relative}.controns .main .bottomView[data-v-1f52ea00]{position:absolute;bottom:0;left:0;width:100%;height:32px;background:linear-gradient(180deg,rgba(0,0,0,.34),rgba(0,0,0,.7) 100%)}.controns .main .loading-box[data-v-1f52ea00]{display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;color:#fff;background-color:rgba(51,51,51,.67)}.controns .main .loading-box .loading-image[data-v-1f52ea00]{width:32px;height:32px;margin-bottom:8px}.main .bottomView .shuaxing[data-v-1f52ea00]{float:left;width:20px;margin-top:6px;margin-left:16px}.main .bottomView .quanping[data-v-1f52ea00]{float:right;margin-right:16px;margin-top:6px;width:20px}.main .bottomView .xianlu[data-v-1f52ea00]{display:block;float:right;margin-right:16px;margin-top:6px;color:#fff;border-radius:8px;cursor:pointer;margin-right:20px;position:relative}.main .bottomView .xianluBox[data-v-1f52ea00]{position:absolute;bottom:38px;right:-22px;width:114px;font-size:16px;border:1px solid #fff;color:#fff;border-radius:10px;background-color:rgba(0,0,0,.7)}.main .bottomView .xianluBox p[data-v-1f52ea00]{padding:10px;cursor:pointer}.main .bottomView .voiceBox[data-v-1f52ea00]{float:right;position:relative;margin-right:20px;width:21px;margin-top:6px;display:inline-block}.main .bottomView .voiceBox .jingying[data-v-1f52ea00]{width:21px}.main .bottomView .voiceBox .voiceBoxTip[data-v-1f52ea00]{display:none}.main .bottomView .voiceBox:hover .voiceBoxTip[data-v-1f52ea00]{display:inline-block}",""]);// exports
/***/},/* 28 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);var bind=__webpack_require__(7);var Axios=__webpack_require__(29);var mergeConfig=__webpack_require__(13);var defaults=__webpack_require__(10);/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */function createInstance(defaultConfig){var context=new Axios(defaultConfig);var instance=bind(Axios.prototype.request,context);// Copy axios.prototype to instance
utils.extend(instance,Axios.prototype,context);// Copy context to instance
utils.extend(instance,context);return instance;}// Create the default instance to be exported
var axios=createInstance(defaults);// Expose Axios class to allow class inheritance
axios.Axios=Axios;// Factory for creating new instances
axios.create=function create(instanceConfig){return createInstance(mergeConfig(axios.defaults,instanceConfig));};// Expose Cancel & CancelToken
axios.Cancel=__webpack_require__(14);axios.CancelToken=__webpack_require__(43);axios.isCancel=__webpack_require__(9);// Expose all/spread
axios.all=function all(promises){return Promise.all(promises);};axios.spread=__webpack_require__(44);// Expose isAxiosError
axios.isAxiosError=__webpack_require__(45);module.exports=axios;// Allow use of default import syntax in TypeScript
module.exports.default=axios;/***/},/* 29 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);var buildURL=__webpack_require__(8);var InterceptorManager=__webpack_require__(30);var dispatchRequest=__webpack_require__(31);var mergeConfig=__webpack_require__(13);/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */function Axios(instanceConfig){this.defaults=instanceConfig;this.interceptors={request:new InterceptorManager(),response:new InterceptorManager()};}/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */Axios.prototype.request=function request(config){/*eslint no-param-reassign:0*/// Allow for axios('example/url'[, config]) a la fetch API
if(typeof config==='string'){config=arguments[1]||{};config.url=arguments[0];}else{config=config||{};}config=mergeConfig(this.defaults,config);// Set config.method
if(config.method){config.method=config.method.toLowerCase();}else if(this.defaults.method){config.method=this.defaults.method.toLowerCase();}else{config.method='get';}// Hook up interceptors middleware
var chain=[dispatchRequest,undefined];var promise=Promise.resolve(config);this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor){chain.unshift(interceptor.fulfilled,interceptor.rejected);});this.interceptors.response.forEach(function pushResponseInterceptors(interceptor){chain.push(interceptor.fulfilled,interceptor.rejected);});while(chain.length){promise=promise.then(chain.shift(),chain.shift());}return promise;};Axios.prototype.getUri=function getUri(config){config=mergeConfig(this.defaults,config);return buildURL(config.url,config.params,config.paramsSerializer).replace(/^\?/,'');};// Provide aliases for supported request methods
utils.forEach(['delete','get','head','options'],function forEachMethodNoData(method){/*eslint func-names:0*/Axios.prototype[method]=function(url,config){return this.request(mergeConfig(config||{},{method:method,url:url,data:(config||{}).data}));};});utils.forEach(['post','put','patch'],function forEachMethodWithData(method){/*eslint func-names:0*/Axios.prototype[method]=function(url,data,config){return this.request(mergeConfig(config||{},{method:method,url:url,data:data}));};});module.exports=Axios;/***/},/* 30 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);function InterceptorManager(){this.handlers=[];}/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */InterceptorManager.prototype.use=function use(fulfilled,rejected){this.handlers.push({fulfilled:fulfilled,rejected:rejected});return this.handlers.length-1;};/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */InterceptorManager.prototype.eject=function eject(id){if(this.handlers[id]){this.handlers[id]=null;}};/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */InterceptorManager.prototype.forEach=function forEach(fn){utils.forEach(this.handlers,function forEachHandler(h){if(h!==null){fn(h);}});};module.exports=InterceptorManager;/***/},/* 31 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);var transformData=__webpack_require__(32);var isCancel=__webpack_require__(9);var defaults=__webpack_require__(10);/**
 * Throws a `Cancel` if cancellation has been requested.
 */function throwIfCancellationRequested(config){if(config.cancelToken){config.cancelToken.throwIfRequested();}}/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */module.exports=function dispatchRequest(config){throwIfCancellationRequested(config);// Ensure headers exist
config.headers=config.headers||{};// Transform request data
config.data=transformData(config.data,config.headers,config.transformRequest);// Flatten headers
config.headers=utils.merge(config.headers.common||{},config.headers[config.method]||{},config.headers);utils.forEach(['delete','get','head','post','put','patch','common'],function cleanHeaderConfig(method){delete config.headers[method];});var adapter=config.adapter||defaults.adapter;return adapter(config).then(function onAdapterResolution(response){throwIfCancellationRequested(config);// Transform response data
response.data=transformData(response.data,response.headers,config.transformResponse);return response;},function onAdapterRejection(reason){if(!isCancel(reason)){throwIfCancellationRequested(config);// Transform response data
if(reason&&reason.response){reason.response.data=transformData(reason.response.data,reason.response.headers,config.transformResponse);}}return Promise.reject(reason);});};/***/},/* 32 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */module.exports=function transformData(data,headers,fns){/*eslint no-param-reassign:0*/utils.forEach(fns,function transform(fn){data=fn(data,headers);});return data;};/***/},/* 33 *//***/function(module,exports){// shim for using process in browser
var process=module.exports={};// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;var cachedClearTimeout;function defaultSetTimout(){throw new Error('setTimeout has not been defined');}function defaultClearTimeout(){throw new Error('clearTimeout has not been defined');}(function(){try{if(typeof setTimeout==='function'){cachedSetTimeout=setTimeout;}else{cachedSetTimeout=defaultSetTimout;}}catch(e){cachedSetTimeout=defaultSetTimout;}try{if(typeof clearTimeout==='function'){cachedClearTimeout=clearTimeout;}else{cachedClearTimeout=defaultClearTimeout;}}catch(e){cachedClearTimeout=defaultClearTimeout;}})();function runTimeout(fun){if(cachedSetTimeout===setTimeout){//normal enviroments in sane situations
return setTimeout(fun,0);}// if setTimeout wasn't available but was latter defined
if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout){cachedSetTimeout=setTimeout;return setTimeout(fun,0);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
return cachedSetTimeout(fun,0);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
return cachedSetTimeout.call(null,fun,0);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
return cachedSetTimeout.call(this,fun,0);}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout){//normal enviroments in sane situations
return clearTimeout(marker);}// if clearTimeout wasn't available but was latter defined
if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout){cachedClearTimeout=clearTimeout;return clearTimeout(marker);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
return cachedClearTimeout(marker);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
return cachedClearTimeout.call(null,marker);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
// Some versions of I.E. have different rules for clearTimeout vs setTimeout
return cachedClearTimeout.call(this,marker);}}}var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){if(!draining||!currentQueue){return;}draining=false;if(currentQueue.length){queue=currentQueue.concat(queue);}else{queueIndex=-1;}if(queue.length){drainQueue();}}function drainQueue(){if(draining){return;}var timeout=runTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run();}}queueIndex=-1;len=queue.length;}currentQueue=null;draining=false;runClearTimeout(timeout);}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){runTimeout(drainQueue);}};// v8 likes predictible objects
function Item(fun,array){this.fun=fun;this.array=array;}Item.prototype.run=function(){this.fun.apply(null,this.array);};process.title='browser';process.browser=true;process.env={};process.argv=[];process.version='';// empty string to avoid regexp issues
process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.prependListener=noop;process.prependOnceListener=noop;process.listeners=function(name){return[];};process.binding=function(name){throw new Error('process.binding is not supported');};process.cwd=function(){return'/';};process.chdir=function(dir){throw new Error('process.chdir is not supported');};process.umask=function(){return 0;};/***/},/* 34 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);module.exports=function normalizeHeaderName(headers,normalizedName){utils.forEach(headers,function processHeader(value,name){if(name!==normalizedName&&name.toUpperCase()===normalizedName.toUpperCase()){headers[normalizedName]=value;delete headers[name];}});};/***/},/* 35 *//***/function(module,exports,__webpack_require__){"use strict";var createError=__webpack_require__(12);/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */module.exports=function settle(resolve,reject,response){var validateStatus=response.config.validateStatus;if(!response.status||!validateStatus||validateStatus(response.status)){resolve(response);}else{reject(createError('Request failed with status code '+response.status,response.config,null,response.request,response));}};/***/},/* 36 *//***/function(module,exports,__webpack_require__){"use strict";/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */module.exports=function enhanceError(error,config,code,request,response){error.config=config;if(code){error.code=code;}error.request=request;error.response=response;error.isAxiosError=true;error.toJSON=function toJSON(){return{// Standard
message:this.message,name:this.name,// Microsoft
description:this.description,number:this.number,// Mozilla
fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,// Axios
config:this.config,code:this.code};};return error;};/***/},/* 37 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);module.exports=utils.isStandardBrowserEnv()?// Standard browser envs support document.cookie
function standardBrowserEnv(){return{write:function write(name,value,expires,path,domain,secure){var cookie=[];cookie.push(name+'='+encodeURIComponent(value));if(utils.isNumber(expires)){cookie.push('expires='+new Date(expires).toGMTString());}if(utils.isString(path)){cookie.push('path='+path);}if(utils.isString(domain)){cookie.push('domain='+domain);}if(secure===true){cookie.push('secure');}document.cookie=cookie.join('; ');},read:function read(name){var match=document.cookie.match(new RegExp('(^|;\\s*)('+name+')=([^;]*)'));return match?decodeURIComponent(match[3]):null;},remove:function remove(name){this.write(name,'',Date.now()-86400000);}};}():// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv(){return{write:function write(){},read:function read(){return null;},remove:function remove(){}};}();/***/},/* 38 *//***/function(module,exports,__webpack_require__){"use strict";var isAbsoluteURL=__webpack_require__(39);var combineURLs=__webpack_require__(40);/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */module.exports=function buildFullPath(baseURL,requestedURL){if(baseURL&&!isAbsoluteURL(requestedURL)){return combineURLs(baseURL,requestedURL);}return requestedURL;};/***/},/* 39 *//***/function(module,exports,__webpack_require__){"use strict";/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */module.exports=function isAbsoluteURL(url){// A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
// RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
// by any combination of letters, digits, plus, period, or hyphen.
return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);};/***/},/* 40 *//***/function(module,exports,__webpack_require__){"use strict";/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */module.exports=function combineURLs(baseURL,relativeURL){return relativeURL?baseURL.replace(/\/+$/,'')+'/'+relativeURL.replace(/^\/+/,''):baseURL;};/***/},/* 41 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf=['age','authorization','content-length','content-type','etag','expires','from','host','if-modified-since','if-unmodified-since','last-modified','location','max-forwards','proxy-authorization','referer','retry-after','user-agent'];/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */module.exports=function parseHeaders(headers){var parsed={};var key;var val;var i;if(!headers){return parsed;}utils.forEach(headers.split('\n'),function parser(line){i=line.indexOf(':');key=utils.trim(line.substr(0,i)).toLowerCase();val=utils.trim(line.substr(i+1));if(key){if(parsed[key]&&ignoreDuplicateOf.indexOf(key)>=0){return;}if(key==='set-cookie'){parsed[key]=(parsed[key]?parsed[key]:[]).concat([val]);}else{parsed[key]=parsed[key]?parsed[key]+', '+val:val;}}});return parsed;};/***/},/* 42 *//***/function(module,exports,__webpack_require__){"use strict";var utils=__webpack_require__(0);module.exports=utils.isStandardBrowserEnv()?// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv(){var msie=/(msie|trident)/i.test(navigator.userAgent);var urlParsingNode=document.createElement('a');var originURL;/**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */function resolveURL(url){var href=url;if(msie){// IE needs attribute set twice to normalize properties
urlParsingNode.setAttribute('href',href);href=urlParsingNode.href;}urlParsingNode.setAttribute('href',href);// urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
return{href:urlParsingNode.href,protocol:urlParsingNode.protocol?urlParsingNode.protocol.replace(/:$/,''):'',host:urlParsingNode.host,search:urlParsingNode.search?urlParsingNode.search.replace(/^\?/,''):'',hash:urlParsingNode.hash?urlParsingNode.hash.replace(/^#/,''):'',hostname:urlParsingNode.hostname,port:urlParsingNode.port,pathname:urlParsingNode.pathname.charAt(0)==='/'?urlParsingNode.pathname:'/'+urlParsingNode.pathname};}originURL=resolveURL(window.location.href);/**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */return function isURLSameOrigin(requestURL){var parsed=utils.isString(requestURL)?resolveURL(requestURL):requestURL;return parsed.protocol===originURL.protocol&&parsed.host===originURL.host;};}():// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv(){return function isURLSameOrigin(){return true;};}();/***/},/* 43 *//***/function(module,exports,__webpack_require__){"use strict";var Cancel=__webpack_require__(14);/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */function CancelToken(executor){if(typeof executor!=='function'){throw new TypeError('executor must be a function.');}var resolvePromise;this.promise=new Promise(function promiseExecutor(resolve){resolvePromise=resolve;});var token=this;executor(function cancel(message){if(token.reason){// Cancellation has already been requested
return;}token.reason=new Cancel(message);resolvePromise(token.reason);});}/**
 * Throws a `Cancel` if cancellation has been requested.
 */CancelToken.prototype.throwIfRequested=function throwIfRequested(){if(this.reason){throw this.reason;}};/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */CancelToken.source=function source(){var cancel;var token=new CancelToken(function executor(c){cancel=c;});return{token:token,cancel:cancel};};module.exports=CancelToken;/***/},/* 44 *//***/function(module,exports,__webpack_require__){"use strict";/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */module.exports=function spread(callback){return function wrap(arr){return callback.apply(null,arr);};};/***/},/* 45 *//***/function(module,exports,__webpack_require__){"use strict";/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */module.exports=function isAxiosError(payload){return(typeof payload==='undefined'?'undefined':_typeof2(payload))==='object'&&payload.isAxiosError===true;};/***/},/* 46 *//***/function(module,exports,__webpack_require__){__webpack_require__(47);var DectectRTC={TBS_MIN_VERSION:43600,h264Support:false,checkTBSVersion:function checkTBSVersion(){var list=navigator.userAgent.split(" ");var isTBS=false;var TBSVersion=0;for(var i=0;i<list.length;i++){var item=list[i];if(item.indexOf("TBS")!==-1||item.indexOf("tbs")!==-1){isTBS=true;var versionStr=item.split("/")[1];var version=parseInt(versionStr)||0;TBSVersion=version;}}return{isTBS:isTBS,TBSversion:TBSVersion,isTBSValid:TBSVersion>=this.TBS_MIN_VERSION};},checkH264Support:function checkH264Support(callback){if(window.RTCPeerConnection){var peer=new RTCPeerConnection(null);peer.createOffer({offerToReceiveAudio:1,offerToReceiveVideo:1}).then(function(data){if(data.sdp.toLowerCase().indexOf("h264")===-1){callback(false);}else{callback(true);}peer.close();},function(data){callback(false);});}else{callback(false);}},support:function support(opts,callback){if(typeof opts==='function'){this.doCheck({screenshare:false},opts);}else{this.doCheck(opts,callback);}},doCheck:function doCheck(opts,callback){var isWebRTCSupported=false;['RTCPeerConnection','webkitRTCPeerConnection','RTCIceGatherer'].forEach(function(item){if(isWebRTCSupported){return;}if(item in window){isWebRTCSupported=true;}});var TBSInfo=this.checkTBSVersion();if(!TBSInfo.isTBS){if(this.isFF()){isWebRTCSupported=false;}else if(this.isSafari()&&navigator.platform.indexOf("Mac")===-1){var iOSVersion=this.iOSVersion();if(iOSVersion&&(iOSVersion[0]>=11&&iOSVersion[1]>=1||iOSVersion[0]>=12)){//console.log("doCheck, support webrtc, iOSVersion: " + iOSVersion);
}else{//console.log("doCheck, no support webrtc, iOSVersion: " + iOSVersion);
isWebRTCSupported=false;}}}var ret={support:isWebRTCSupported,isTBS:TBSInfo.isTBS,isTBSValid:TBSInfo.isTBSValid,TBSversion:TBSInfo.TBSversion,isSafari:this.isSafari(),iOSVersion:this.iOSVersion(),screenshare:false,isFF:this.isFF(),userAgent:Browser.client};if(!isWebRTCSupported){ret.h264Support=false;callback(ret);return;}this.checkH264Support(function(support){ret.h264Support=support;if(!support){ret.support=false;}if(!opts.screenshare&&callback){delete ret.screenshare;callback(ret);return;}// chrome 70 版本以后无需安装插件
if(parseFloat(Browser.client.version)>=70&&Browser.client.type==='chrome'){console.debug('[DetectRTC]: chrome 70 版本以后无需安装插件');ret.screenshare=true;callback(ret);return;}var extensionId=opts.extensionId||null;ScreenChromeExtensionUtil.getChromeExtensionStatus(extensionId,function(extensionResult){if(extensionResult==='installed-enabled'){ScreenChromeExtensionUtil.isChromeExtensionAvailable(function(isAvailable){if(!isAvailable){// alert('检测没有通过，请先安装chrome屏幕分享插件');
}else{// alert('检测通过，可以进入Demo');
ret.screenshare=true;}if(callback){callback(ret);}});}else{if(callback){callback(ret);}}});});return ret;},isTBS:function isTBS(){var result=this.checkTBSVersion();return result.isTBS;},isSafari:function isSafari(){return navigator.userAgent.toLowerCase().indexOf('safari/')>-1&&navigator.userAgent.toLowerCase().indexOf('chrome/')===-1;},iOSVersion:function iOSVersion(){var matches=navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);return matches&&[parseInt(matches[1]),parseInt(matches[2]),parseInt(matches[3]||0)]||false;},isFF:function isFF(){return navigator.userAgent.toLowerCase().indexOf("firefox")!==-1;},isChrome:function isChrome(){return /Chrome/.test(navigator.userAgent)&&/Google Inc/.test(navigator.vendor);},detectMediaDevice:function detectMediaDevice(callback){var hasAudio=false;var hasVideo=false;navigator.mediaDevices.enumerateDevices().then(function(devices){devices.forEach(function(device){if(device&&device.kind==="videoinput"){hasVideo=true;}else if(device&&device.kind==="audioinput"){hasAudio=true;}});if(callback){callback({hasAudio:hasAudio,hasVideo:hasVideo});}}).catch(function(err){if(callback){callback({hasAudio:hasAudio,hasVideo:hasVideo});}});}};module.exports=DectectRTC;/***/},/* 47 *//***/function(module,exports){var document=window.document,navigator=window.navigator,agent=navigator.userAgent.toLowerCase(),//IE8+支持.返回浏览器渲染当前文档所用的模式
//IE6,IE7:undefined.IE8:8(兼容模式返回7).IE9:9(兼容模式返回7||8)
//IE10:10(兼容模式7||8||9)
IEMode=document.documentMode,//chorme
chrome=window.chrome||false,System={//user-agent
agent:agent,//是否为IE
isIE:/msie/.test(agent),//是否为IE
isIPhone:/iphone/.test(agent),//Gecko内核
isGecko:agent.indexOf("gecko")>0&&agent.indexOf("like gecko")<0,//webkit内核
isWebkit:agent.indexOf("webkit")>0,//是否为标准模式
isStrict:document.compatMode==="CSS1Compat",//是否支持subtitle
supportSubTitle:function supportSubTitle(){return"track"in document.createElement("track");},//是否支持scoped
supportScope:function supportScope(){return"scoped"in document.createElement("style");},//获取IE的版本号
ieVersion:function ieVersion(){try{return agent.match(/msie ([\d.]+)/)[1]||0;}catch(e){return IEMode;}},//Opera版本号
operaVersion:function operaVersion(){try{if(window.opera){return agent.match(/opera.([\d.]+)/)[1];}else if(agent.indexOf("opr")>0){return agent.match(/opr\/([\d.]+)/)[1];}}catch(e){return 0;}},//描述:version过滤.如31.0.252.152 只保留31.0
versionFilter:function versionFilter(){if(arguments.length===1&&typeof arguments[0]==="string"){var version=arguments[0];start=version.indexOf(".");if(start>0){end=version.indexOf(".",start+1);if(end!==-1){return version.substr(0,end);}}return version;}else if(arguments.length===1){return arguments[0];}return 0;}};try{//浏览器类型(IE、Opera、Chrome、Safari、Firefox)
System.type=System.isIE?"ie":window.opera||agent.indexOf("opr")>0?"opera":agent.indexOf("chrome")>0?"chrome"://safari也提供了专门的判定方式
window.openDatabase?"safari":agent.indexOf("firefox")>0?"firefox":'unknow';//版本号
System.version=System.type==="ie"?System.ieVersion():System.type==="firefox"?agent.match(/firefox\/([\d.]+)/)[1]:System.type==="chrome"?agent.match(/chrome\/([\d.]+)/)[1]:System.type==="opera"?System.operaVersion():System.type==="safari"?agent.match(/version\/([\d.]+)/)[1]:"0";//浏览器外壳
System.shell=function(){//遨游浏览器
if(agent.indexOf("maxthon")>0){System.version=agent.match(/maxthon\/([\d.]+)/)[1]||System.version;return"maxthon";}//QQ浏览器
if(agent.indexOf("qqbrowser")>0){System.version=agent.match(/qqbrowser\/([\d.]+)/)[1]||System.version;return"qqbrowser";}//搜狗浏览器
if(agent.indexOf("se 2.x")>0){return'sougou';}//Chrome:也可以使用window.chrome && window.chrome.webstore判断
if(chrome&&System.type!=="opera"){var external=window.external,clientInfo=window.clientInformation,//客户端语言:zh-cn,zh.360下面会返回undefined
clientLanguage=clientInfo.languages;//猎豹浏览器:或者agent.indexOf("lbbrowser")>0
if(external&&'LiebaoGetVersion'in external){return'liebao';}//百度浏览器
if(agent.indexOf("bidubrowser")>0){System.version=agent.match(/bidubrowser\/([\d.]+)/)[1]||agent.match(/chrome\/([\d.]+)/)[1];return"baidu";}//360极速浏览器和360安全浏览器
if(System.supportSubTitle()&&typeof clientLanguage==="undefined"){//object.key()返回一个数组.包含可枚举属性和方法名称
var storeKeyLen=Object.keys(chrome.webstore).length,v8Locale="v8Locale"in window;return storeKeyLen>1?'360qucik':'360secure';}return"chrome";}return System.type;};//浏览器名称(如果是壳浏览器,则返回壳名称)
System.name=System.shell();//对版本号进行过滤过处理
System.version=System.versionFilter(System.version);}catch(e){}window.Browser={client:System};//module.exports = {
//    client: System
//};
/***/},/* 48 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"livePlayer",staticClass:"livePlayer"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showWatermark,expression:"showWatermark"}],staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)","text-align":"center","font-size":"89px","color":"black","white-space":"nowrap","min-width":"300px","min-height":"100px","background-color":"red","word-break":"break-word"},style:{fontSize:_vm.isfullScreen?'200px':'89px'},attrs:{"id":"id_fast_video_watermark"}},[_vm._v("助教ID:"+_vm._s(_vm.staff_id))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMiniWindow,expression:"!isMiniWindow"}],ref:"controns",staticClass:"controns",on:{"mouseover":_vm.mouseOver,"mousemove":_vm.mousemove,"mouseleave":_vm.mouseLeave}},[_c('div',{staticClass:"main"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showLoading,expression:"showLoading"}],staticClass:"loading-box"},[_c('img',{staticClass:"loading-image",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/loading2.gif"}}),_vm._v(" "),_c('div',[_vm._v("网络加载中，请稍后")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showControns,expression:"showControns"}],staticClass:"bottomView"},[_c('img',{staticClass:"shuaxing",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_refresh.png"},on:{"click":_vm.shuaxingCliked}}),_vm._v(" "),_vm.showH5Xianlu&&!_vm.isfullScreen?_c('span',{staticClass:"xianlu",staticStyle:{"float":"left","margin-left":"20px"},on:{"click":function click($event){return _vm.$emit('showH5XianluAlert');}}},[_vm._v("线路")]):_vm._e(),_vm._v(" "),_vm.isPc&&_vm.isThreeScreen?_c('img',{staticClass:"quanping",staticStyle:{"margin-right":"20px"},attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_pop_window.png"},on:{"click":function click($event){return _vm.$emit('cutSwitch');}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_fullscreen.png"},on:{"click":_vm.quanpingCliked}}),_vm._v(" "),!_vm.isWhitebord?_c('div',{staticClass:"voiceBox"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.isMuted,expression:"isMuted"}],staticClass:"jingying",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_voice_mute.png"},on:{"click":_vm.jingyingClicked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMuted,expression:"!isMuted"}],staticClass:"jingying",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_voice.png"},on:{"click":_vm.jingyingClicked}})]):_vm._e(),_vm._v(" "),!_vm.isPc&&_vm.isShowMiniWindowIcon&&!_vm.isfullScreen?_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/cutscreen.png"},on:{"click":function click($event){$event.stopPropagation();return _vm.$emit('miniWidowsClick');}}}):_vm._e(),_vm._v(" "),_vm.isPc?_c('span',{staticClass:"xianlu",on:{"click":function click($event){_vm.showXianLuBox=!_vm.showXianLuBox;}}},[_vm._v("\n          线路\n          "),_vm.showXianLuBox?_c('div',{staticClass:"xianluBox"},[_c('p',{on:{"click":function click($event){return _vm.changePlayType(2);}}},[_vm._v("普通直播")]),_vm._v(" "),!_vm.fakeLive&&!_vm.isWhitebord?_c('p',{on:{"click":function click($event){return _vm.changePlayType(1);}}},[_vm._v("低延迟线路1")]):_vm._e(),_vm._v(" "),_c('p',{on:{"click":function click($event){return _vm.changePlayType(3);}}},[_vm._v("低延迟线路2")])]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('video',{ref:"fastVideo",staticClass:"id_fast_video_live_tengface",staticStyle:{"width":"100%","height":"100%"},style:{'object-fit':_vm.objectFit},attrs:{"id":"id_fast_video_live_tengface"+_vm.playerid,"x5-video-player-type":"h5","x5-video-player-fullscreen":"true","preload":"auto","autoplay":_vm.isWhitebord,"controlslist":"nodownload","playsinline":"","webkit-inline":"","webkit-playsinline":"","x-webkit-airplay":"allow"},domProps:{"muted":_vm.isWhitebord}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.copyrightObj&&_vm.copyrightObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.copyrightObj&&_vm.copyrightObj.open,expression:"(copyrightObj&&copyrightObj.open&&isThird)||(isfullScreen&&copyrightObj&&copyrightObj.open)"}],staticClass:"copyright",style:{opacity:_vm.copyrightObj.copyrightTrans}},[_c('div',{staticClass:"banquanText"},[_vm._v("\n        "+_vm._s(_vm.copyrightObj.inputValue)+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.runObj&&_vm.runObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.runObj&&_vm.runObj.open,expression:"(runObj&&runObj.open&&isThird)||(isfullScreen&&runObj&&runObj.open)"}],ref:"runBoxRef",staticClass:"runBox"},[_c('div',{staticClass:"runboxChild",class:{'rotate':_vm.rotateRunBox},style:{left:_vm.boxLeft+'px',top:_vm.boxTop+'px'},attrs:{"id":"runChilder"}},[_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_c('span',[_vm._v(_vm._s(_vm.nick))]),_vm.runObj.remark?_c('span',[_vm._v("("+_vm._s(_vm.remark)+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_vm._v(_vm._s(_vm.fans_id))])])])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};__webpack_exports__["a"]=esExports;/***/},/* 49 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LivePlayer_vue__=__webpack_require__(15);/* unused harmony namespace reexport *//* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67fe3590_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LivePlayer_vue__=__webpack_require__(52);function injectStyle(ssrContext){__webpack_require__(50);}var normalizeComponent=__webpack_require__(3);/* script *//* template *//* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-67fe3590";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LivePlayer_vue__["a"/* default */],__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67fe3590_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LivePlayer_vue__["a"/* default */],__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */__webpack_exports__["a"]=Component.exports;/***/},/* 50 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(51);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("3da0b6aa",content,true,{});/***/},/* 51 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,".rotate[data-v-67fe3590]{transform:rotate(90deg)}.runboxChild[data-v-67fe3590]{position:absolute}.runBox[data-v-67fe3590]{height:100%}.copyright[data-v-67fe3590],.runBox[data-v-67fe3590]{position:absolute;top:0;left:0;width:100%;overflow:hidden}.copyright[data-v-67fe3590]{background-color:#000;color:#fff;line-height:50px;height:50px;z-index:99;white-space:nowrap}.banquanText[data-v-67fe3590]{font-size:24px;width:100%;position:absolute;animation:slideText-data-v-67fe3590 25s linear infinite}@keyframes slideText-data-v-67fe3590{0%{transform:translateX(100%)}to{transform:translateX(-100%)}}.live-player[data-v-67fe3590]{width:100%;height:100%}.controns[data-v-67fe3590]{width:100%;height:100%;position:absolute;top:0;left:0;z-index:1}.controns .main[data-v-67fe3590]{width:100%;height:100%;position:relative}.controns .main .bottomView[data-v-67fe3590]{position:absolute;bottom:0;left:0;width:100%;height:32px;background:linear-gradient(180deg,rgba(0,0,0,.34),rgba(0,0,0,.7) 100%)}.controns .main .loading-box[data-v-67fe3590]{display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;color:#fff;background-color:rgba(51,51,51,.67)}.controns .main .loading-box .loading-image[data-v-67fe3590]{width:32px;height:32px;margin-bottom:8px}.main .bottomView .shuaxing[data-v-67fe3590]{float:left;width:20px;margin-top:6px;margin-left:16px}.main .bottomView .quanping[data-v-67fe3590]{float:right;margin-right:16px;margin-top:6px;width:20px}.main .bottomView .xianlu[data-v-67fe3590]{display:block;float:right;margin-right:16px;margin-top:6px;color:#fff;border-radius:8px;cursor:pointer;margin-right:20px;position:relative}.main .bottomView .xianluBox[data-v-67fe3590]{position:absolute;bottom:38px;right:-22px;width:114px;font-size:16px;border:1px solid #fff;color:#fff;border-radius:10px;background-color:rgba(0,0,0,.7)}.main .bottomView .xianluBox p[data-v-67fe3590]{padding:10px;cursor:pointer}.main .bottomView .voiceBox[data-v-67fe3590]{float:right;position:relative;margin-right:20px;width:21px;margin-top:6px;display:inline-block}.main .bottomView .voiceBox .jingying[data-v-67fe3590]{width:21px}",""]);// exports
/***/},/* 52 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"livePlayer",staticClass:"live-player"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showWatermark,expression:"showWatermark"}],staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)","text-align":"center","font-size":"89px","color":"black","white-space":"nowrap","min-width":"300px","min-height":"100px","background-color":"red","word-break":"break-word"},style:{fontSize:_vm.isfullScreen?'200px':'89px'},attrs:{"id":"id_live_video_watermark"}},[_vm._v("助教ID:"+_vm._s(_vm.staff_id))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMiniWindow,expression:"!isMiniWindow"}],staticClass:"controns",on:{"mouseover":_vm.mouseOver,"mousemove":_vm.mousemove,"mouseleave":_vm.mouseLeave}},[_c('div',{staticClass:"main"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showLoading,expression:"showLoading"}],staticClass:"loading-box"},[_c('img',{staticClass:"loading-image",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/loading.gif"}}),_vm._v(" "),_c('div',[_vm._v("网络加载中，请稍后")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showControns,expression:"showControns"}],staticClass:"bottomView"},[_c('img',{staticClass:"shuaxing",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_refresh.png"},on:{"click":_vm.shuaxingCliked}}),_vm._v(" "),_vm.showH5Xianlu&&!_vm.isfullScreen?_c('span',{staticClass:"xianlu",staticStyle:{"float":"left","margin-left":"20px"},on:{"click":function click($event){return _vm.$emit('showH5XianluAlert');}}},[_vm._v("线路")]):_vm._e(),_vm._v(" "),_vm.isPc&&_vm.isThreeScreen?_c('img',{staticClass:"quanping",staticStyle:{"margin-right":"20px"},attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_pop_window.png"},on:{"click":function click($event){return _vm.$emit('cutSwitch');}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_fullscreen.png"},on:{"click":_vm.quanpingCliked}}),_vm._v(" "),!_vm.isWhitebord?_c('div',{staticClass:"voiceBox"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.isMuted,expression:"isMuted"}],staticClass:"jingying",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_voice_mute.png"},on:{"click":_vm.jingyingClicked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMuted,expression:"!isMuted"}],staticClass:"yingliang",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_voice.png","width":"21px"},on:{"click":_vm.jingyingClicked}})]):_vm._e(),_vm._v(" "),!_vm.isPc&&_vm.isShowMiniWindowIcon&&!_vm.isfullScreen?_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/cutscreen.png"},on:{"click":function click($event){$event.stopPropagation();return _vm.$emit('miniWidowsClick');}}}):_vm._e(),_vm._v(" "),_vm.isPc&&_vm.isRTC?_c('span',{staticClass:"xianlu",on:{"click":function click($event){_vm.showXianLuBox=!_vm.showXianLuBox;}}},[_vm._v("线路\n          "),_vm.showXianLuBox?_c('div',{staticClass:"xianluBox"},[_c('p',{on:{"click":function click($event){return _vm.changePlayType(2);}}},[_vm._v("普通直播")]),_vm._v(" "),!_vm.fakeLive&&!_vm.isWhitebord?_c('p',{on:{"click":function click($event){return _vm.changePlayType(1);}}},[_vm._v("低延迟线路1")]):_vm._e(),_vm._v(" "),_c('p',{on:{"click":function click($event){return _vm.changePlayType(3);}}},[_vm._v("低延迟线路2")])]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('video',{ref:"liveVideo",staticStyle:{"width":"100%","height":"100%"},style:{'object-fit':_vm.objectFit},attrs:{"id":"id_video_live_tengface"+_vm.playerid,"x5-video-player-type":"h5","x5-video-player-fullscreen":"true","preload":"auto","autoplay":_vm.isWhitebord,"controlslist":"nodownload","playsinline":"","webkit-inline":"","webkit-playsinline":"","x-webkit-airplay":"allow"},domProps:{"muted":_vm.isWhitebord}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.copyrightObj&&_vm.copyrightObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.copyrightObj&&_vm.copyrightObj.open,expression:"(copyrightObj&&copyrightObj.open&&isThird)||(isfullScreen&&copyrightObj&&copyrightObj.open)"}],staticClass:"copyright",style:{opacity:_vm.copyrightObj.copyrightTrans},attrs:{"id":"copyrightThree"}},[_c('div',{staticClass:"banquanText"},[_vm._v("\n          "+_vm._s(_vm.copyrightObj.inputValue)+"\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.runObj&&_vm.runObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.runObj&&_vm.runObj.open,expression:"(runObj&&runObj.open&&isThird)||(isfullScreen&&runObj&&runObj.open)"}],ref:"runBoxRef",staticClass:"runBox"},[_c('div',{staticClass:"runboxChild",class:{'rotate':_vm.rotateRunBox},style:{left:_vm.boxLeft+'px',top:_vm.boxTop+'px'},attrs:{"id":"runChilder"}},[_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_c('span',[_vm._v(_vm._s(_vm.nick))]),_vm.runObj.remark?_c('span',[_vm._v("("+_vm._s(_vm.remark)+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_vm._v(_vm._s(_vm.fans_id))])])])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};__webpack_exports__["a"]=esExports;/***/},/* 53 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RtcPlayer_vue__=__webpack_require__(16);/* unused harmony namespace reexport *//* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96610d0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RtcPlayer_vue__=__webpack_require__(58);function injectStyle(ssrContext){__webpack_require__(54);}var normalizeComponent=__webpack_require__(3);/* script *//* template *//* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-96610d0e";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RtcPlayer_vue__["a"/* default */],__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96610d0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RtcPlayer_vue__["a"/* default */],__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */__webpack_exports__["a"]=Component.exports;/***/},/* 54 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(55);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("53ba3d6c",content,true,{});/***/},/* 55 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,".rotate[data-v-96610d0e]{transform:rotate(90deg)}.runboxChild[data-v-96610d0e]{position:absolute}.runBox[data-v-96610d0e]{height:100%}.copyright[data-v-96610d0e],.runBox[data-v-96610d0e]{position:absolute;top:0;left:0;width:100%;overflow:hidden}.copyright[data-v-96610d0e]{background-color:#000;color:#fff;line-height:50px;height:50px;z-index:99;white-space:nowrap}.banquanText[data-v-96610d0e]{font-size:24px;position:absolute;width:100%;animation:slideText-data-v-96610d0e 25s linear infinite}@keyframes slideText-data-v-96610d0e{0%{transform:translateX(100%)}to{transform:translateX(-100%)}}.rtc-player .webRtcVideoBox[data-v-96610d0e],.rtc-player .webRtcVideoBox video[data-v-96610d0e],.rtc-player[data-v-96610d0e]{width:100%;height:100%}.controns[data-v-96610d0e]{width:100%;height:100%;position:absolute;top:0;left:0;z-index:1}.controns .main[data-v-96610d0e]{width:100%;height:100%;position:relative}.controns .main .bottomView[data-v-96610d0e]{position:absolute;bottom:0;left:0;width:100%;height:32px;background:linear-gradient(180deg,rgba(0,0,0,.34),rgba(0,0,0,.7) 100%)}.controns .main .loading-box[data-v-96610d0e]{display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;color:#fff;background-color:rgba(51,51,51,.67)}.controns .main .loading-box .loading-image[data-v-96610d0e]{width:32px;height:32px;margin-bottom:8px}.main .bottomView .shuaxing[data-v-96610d0e]{float:left;width:20px;margin-top:6px;margin-left:16px}.main .bottomView .quanping[data-v-96610d0e]{float:right;margin-right:16px;margin-top:6px;width:20px}.main .bottomView .xianlu[data-v-96610d0e]{display:block;float:right;margin-right:16px;margin-top:6px;color:#fff;border-radius:8px;cursor:pointer;margin-right:20px;position:relative}.main .bottomView .xianluBox[data-v-96610d0e]{position:absolute;top:-98px;right:90px;border:1px solid #fff;color:#fff;border-radius:10px;background-color:rgba(0,0,0,.7)}.main .bottomView .xianluBox p[data-v-96610d0e]{padding:10px;cursor:pointer}.main .bottomView .voiceBox[data-v-96610d0e]{float:right;position:relative;margin-right:20px;width:21px;margin-top:6px;display:inline-block}.main .bottomView .voiceBox .jingying[data-v-96610d0e]{width:21px}",""]);// exports
/***/},/* 56 *//***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(global){!function(e,t){true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).TRTC=t();}(this,function(){function e(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable;})),n.push.apply(n,i);}return n;}function t(t){for(var n=1;n<arguments.length;n++){var i=null!=arguments[n]?arguments[n]:{};n%2?e(Object(i),!0).forEach(function(e){u(t,e,i[e]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):e(Object(i)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e));});}return t;}function n(){n=function n(){return e;};var e={},t=Object.prototype,i=t.hasOwnProperty,r="function"==typeof Symbol?Symbol:{},a=r.iterator||"@@iterator",o=r.asyncIterator||"@@asyncIterator",s=r.toStringTag||"@@toStringTag";function c(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t];}try{c({},"");}catch(R){c=function c(e,t,n){return e[t]=n;};}function u(e,t,n,i){var r=t&&t.prototype instanceof h?t:h,a=Object.create(r.prototype),o=new I(i||[]);return a._invoke=function(e,t,n){var i="suspendedStart";return function(r,a){if("executing"===i)throw new Error("Generator is already running");if("completed"===i){if("throw"===r)throw a;return w();}for(n.method=r,n.arg=a;;){var o=n.delegate;if(o){var s=k(o,n);if(s){if(s===l)continue;return s;}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===i)throw i="completed",n.arg;n.dispatchException(n.arg);}else"return"===n.method&&n.abrupt("return",n.arg);i="executing";var c=d(e,t,n);if("normal"===c.type){if(i=n.done?"completed":"suspendedYield",c.arg===l)continue;return{value:c.arg,done:n.done};}"throw"===c.type&&(i="completed",n.method="throw",n.arg=c.arg);}};}(e,n,o),a;}function d(e,t,n){try{return{type:"normal",arg:e.call(t,n)};}catch(R){return{type:"throw",arg:R};}}e.wrap=u;var l={};function h(){}function p(){}function f(){}var m={};c(m,a,function(){return this;});var _=Object.getPrototypeOf,v=_&&_(_(E([])));v&&v!==t&&i.call(v,a)&&(m=v);var g=f.prototype=h.prototype=Object.create(m);function y(e){["next","throw","return"].forEach(function(t){c(e,t,function(e){return this._invoke(t,e);});});}function S(e,t){function n(r,a,o,s){var c=d(e[r],e,a);if("throw"!==c.type){var u=c.arg,l=u.value;return l&&"object"==(typeof l==='undefined'?'undefined':_typeof2(l))&&i.call(l,"__await")?t.resolve(l.__await).then(function(e){n("next",e,o,s);},function(e){n("throw",e,o,s);}):t.resolve(l).then(function(e){u.value=e,o(u);},function(e){return n("throw",e,o,s);});}s(c.arg);}var r;this._invoke=function(e,i){function a(){return new t(function(t,r){n(e,i,t,r);});}return r=r?r.then(a,a):a();};}function k(e,t){var n=e.iterator[t.method];if(void 0===n){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=void 0,k(e,t),"throw"===t.method))return l;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method");}return l;}var i=d(n,e.iterator,t.arg);if("throw"===i.type)return t.method="throw",t.arg=i.arg,t.delegate=null,l;var r=i.arg;return r?r.done?(t[e.resultName]=r.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,l):r:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,l);}function b(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t);}function T(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t;}function I(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(b,this),this.reset(!0);}function E(e){if(e){var t=e[a];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function t(){for(;++n<e.length;){if(i.call(e,n))return t.value=e[n],t.done=!1,t;}return t.value=void 0,t.done=!0,t;};return r.next=r;}}return{next:w};}function w(){return{value:void 0,done:!0};}return p.prototype=f,c(g,"constructor",f),c(f,"constructor",p),p.displayName=c(f,s,"GeneratorFunction"),e.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===p||"GeneratorFunction"===(t.displayName||t.name));},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,f):(e.__proto__=f,c(e,s,"GeneratorFunction")),e.prototype=Object.create(g),e;},e.awrap=function(e){return{__await:e};},y(S.prototype),c(S.prototype,o,function(){return this;}),e.AsyncIterator=S,e.async=function(t,n,i,r,a){void 0===a&&(a=Promise);var o=new S(u(t,n,i,r),a);return e.isGeneratorFunction(n)?o:o.next().then(function(e){return e.done?e.value:o.next();});},y(g),c(g,s,"Generator"),c(g,a,function(){return this;}),c(g,"toString",function(){return"[object Generator]";}),e.keys=function(e){var t=[];for(var n in e){t.push(n);}return t.reverse(),function n(){for(;t.length;){var i=t.pop();if(i in e)return n.value=i,n.done=!1,n;}return n.done=!0,n;};},e.values=E,I.prototype={constructor:I,reset:function reset(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(T),!e)for(var t in this){"t"===t.charAt(0)&&i.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0);}},stop:function stop(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval;},dispatchException:function dispatchException(e){if(this.done)throw e;var t=this;function n(n,i){return o.type="throw",o.arg=e,t.next=n,i&&(t.method="next",t.arg=void 0),!!i;}for(var r=this.tryEntries.length-1;r>=0;--r){var a=this.tryEntries[r],o=a.completion;if("root"===a.tryLoc)return n("end");if(a.tryLoc<=this.prev){var s=i.call(a,"catchLoc"),c=i.call(a,"finallyLoc");if(s&&c){if(this.prev<a.catchLoc)return n(a.catchLoc,!0);if(this.prev<a.finallyLoc)return n(a.finallyLoc);}else if(s){if(this.prev<a.catchLoc)return n(a.catchLoc,!0);}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return n(a.finallyLoc);}}}},abrupt:function abrupt(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&i.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var a=r;break;}}a&&("break"===e||"continue"===e)&&a.tryLoc<=t&&t<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=e,o.arg=t,a?(this.method="next",this.next=a.finallyLoc,l):this.complete(o);},complete:function complete(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),l;},finish:function finish(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),T(n),l;}},catch:function _catch(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var i=n.completion;if("throw"===i.type){var r=i.arg;T(n);}return r;}}throw new Error("illegal catch attempt");},delegateYield:function delegateYield(e,t,n){return this.delegate={iterator:E(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),l;}},e;}function i(e){return i="function"==typeof Symbol&&"symbol"==_typeof2(Symbol.iterator)?function(e){return typeof e==='undefined'?'undefined':_typeof2(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e==='undefined'?'undefined':_typeof2(e);},i(e);}function r(e,t,n,i,r,a,o){try{var s=e[a](o),c=s.value;}catch(u){return void n(u);}s.done?t(c):Promise.resolve(c).then(i,r);}function a(e){return function(){var t=this,n=arguments;return new Promise(function(i,a){var o=e.apply(t,n);function s(e){r(o,i,a,s,c,"next",e);}function c(e){r(o,i,a,s,c,"throw",e);}s(void 0);});};}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}function s(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i);}}function c(e,t,n){return t&&s(e.prototype,t),n&&s(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e;}function u(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e;}function d(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&h(e,t);}function l(e){return l=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e);},l(e);}function h(e,t){return h=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e;},h(e,t);}function p(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0;}catch(e){return!1;}}function f(e,t,n){return f=p()?Reflect.construct.bind():function(e,t,n){var i=[null];i.push.apply(i,t);var r=new(Function.bind.apply(e,i))();return n&&h(r,n.prototype),r;},f.apply(null,arguments);}function m(e){var t="function"==typeof Map?new Map():void 0;return m=function m(e){if(null===e||(n=e,-1===Function.toString.call(n).indexOf("[native code]")))return e;var n;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,i);}function i(){return f(e,arguments,l(this).constructor);}return i.prototype=Object.create(e.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),h(i,e);},m(e);}function _(e,t){if(t&&("object"==(typeof t==='undefined'?'undefined':_typeof2(t))||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;}(e);}function v(e){var t=p();return function(){var n,i=l(e);if(t){var r=l(this).constructor;n=Reflect.construct(i,arguments,r);}else n=i.apply(this,arguments);return _(this,n);};}function g(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=l(e));){}return e;}function y(){return y="undefined"!=typeof Reflect&&Reflect.get?Reflect.get.bind():function(e,t,n){var i=g(e,t);if(i){var r=Object.getOwnPropertyDescriptor(i,t);return r.get?r.get.call(arguments.length<3?e:n):r.value;}},y.apply(this,arguments);}function S(e,t){return function(e){if(Array.isArray(e))return e;}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null==n)return;var i,r,a=[],o=!0,s=!1;try{for(n=n.call(e);!(o=(i=n.next()).done)&&(a.push(i.value),!t||a.length!==t);o=!0){}}catch(c){s=!0,r=c;}finally{try{o||null==n.return||n.return();}finally{if(s)throw r;}}return a;}(e,t)||b(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}();}function k(e){return function(e){if(Array.isArray(e))return T(e);}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e);}(e)||b(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}();}function b(e,t){if(e){if("string"==typeof e)return T(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?T(e,t):void 0;}}function T(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,i=new Array(t);n<t;n++){i[n]=e[n];}return i;}function I(e,t){var _n2="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!_n2){if(Array.isArray(e)||(_n2=b(e))||t&&e&&"number"==typeof e.length){_n2&&(e=_n2);var i=0,r=function r(){};return{s:r,n:function n(){return i>=e.length?{done:!0}:{done:!1,value:e[i++]};},e:function e(_e2){throw _e2;},f:r};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var a,o=!0,s=!1;return{s:function s(){_n2=_n2.call(e);},n:function n(){var e=_n2.next();return o=e.done,e;},e:function e(_e3){s=!0,a=_e3;},f:function f(){try{o||null==_n2.return||_n2.return();}finally{if(s)throw a;}}};}function E(e,t,n,i,r){var a={};return Object.keys(i).forEach(function(e){a[e]=i[e];}),a.enumerable=!!a.enumerable,a.configurable=!!a.configurable,("value"in a||a.initializer)&&(a.writable=!0),a=n.slice().reverse().reduce(function(n,i){return i(e,t,n)||n;},a),r&&void 0!==a.initializer&&(a.value=a.initializer?a.initializer.call(r):void 0,a.initializer=void 0),void 0===a.initializer&&(Object.defineProperty(e,t,a),a=null),a;}var w="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},R=function R(e){return e&&e.Math==Math&&e;},C=R("object"==(typeof globalThis==='undefined'?'undefined':_typeof2(globalThis))&&globalThis)||R("object"==(typeof window==='undefined'?'undefined':_typeof2(window))&&window)||R("object"==(typeof self==='undefined'?'undefined':_typeof2(self))&&self)||R("object"==(typeof w==='undefined'?'undefined':_typeof2(w))&&w)||function(){return this;}()||Function("return this")(),A={},x=function x(e){try{return!!e();}catch(t){return!0;}},P=!x(function(){return 7!=Object.defineProperty({},1,{get:function get(){return 7;}})[1];}),D=!x(function(){var e=function(){}.bind();return"function"!=typeof e||e.hasOwnProperty("prototype");}),O=D,N=Function.prototype.call,M=O?N.bind(N):function(){return N.apply(N,arguments);},L={},U={}.propertyIsEnumerable,V=Object.getOwnPropertyDescriptor,F=V&&!U.call({1:2},1);L.f=F?function(e){var t=V(this,e);return!!t&&t.enumerable;}:U;var j,B,H=function H(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t};},G=D,W=Function.prototype,z=W.call,J=G&&W.bind.bind(z,z),q=function q(e){return G?J(e):function(){return z.apply(e,arguments);};},K=q,Q=K({}.toString),X=K("".slice),Y=function Y(e){return X(Q(e),8,-1);},$=Y,Z=q,ee=function ee(e){if("Function"===$(e))return Z(e);},te=x,ne=Y,ie=Object,re=ee("".split),ae=te(function(){return!ie("z").propertyIsEnumerable(0);})?function(e){return"String"==ne(e)?re(e,""):ie(e);}:ie,oe=function oe(e){return null==e;},se=oe,ce=TypeError,ue=function ue(e){if(se(e))throw ce("Can't call method on "+e);return e;},de=ae,le=ue,he=function he(e){return de(le(e));},pe="object"==(typeof document==='undefined'?'undefined':_typeof2(document))&&document.all,fe={all:pe,IS_HTMLDDA:void 0===pe&&void 0!==pe},me=fe.all,_e=fe.IS_HTMLDDA?function(e){return"function"==typeof e||e===me;}:function(e){return"function"==typeof e;},ve=_e,ge=fe.all,ye=fe.IS_HTMLDDA?function(e){return"object"==(typeof e==='undefined'?'undefined':_typeof2(e))?null!==e:ve(e)||e===ge;}:function(e){return"object"==(typeof e==='undefined'?'undefined':_typeof2(e))?null!==e:ve(e);},Se=C,ke=_e,be=function be(e){return ke(e)?e:void 0;},Te=function Te(e,t){return arguments.length<2?be(Se[e]):Se[e]&&Se[e][t];},Ie=ee({}.isPrototypeOf),Ee=Te("navigator","userAgent")||"",we=C,Re=Ee,Ce=we.process,Ae=we.Deno,xe=Ce&&Ce.versions||Ae&&Ae.version,Pe=xe&&xe.v8;Pe&&(B=(j=Pe.split("."))[0]>0&&j[0]<4?1:+(j[0]+j[1])),!B&&Re&&(!(j=Re.match(/Edge\/(\d+)/))||j[1]>=74)&&(j=Re.match(/Chrome\/(\d+)/))&&(B=+j[1]);var De=B,Oe=De,Ne=x,Me=!!Object.getOwnPropertySymbols&&!Ne(function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&Oe&&Oe<41;}),Le=Me&&!Symbol.sham&&"symbol"==_typeof2(Symbol.iterator),Ue=Te,Ve=_e,Fe=Ie,je=Object,Be=Le?function(e){return"symbol"==(typeof e==='undefined'?'undefined':_typeof2(e));}:function(e){var t=Ue("Symbol");return Ve(t)&&Fe(t.prototype,je(e));},He=String,Ge=function Ge(e){try{return He(e);}catch(t){return"Object";}},We=_e,ze=Ge,Je=TypeError,qe=function qe(e){if(We(e))return e;throw Je(ze(e)+" is not a function");},Ke=qe,Qe=oe,Xe=function Xe(e,t){var n=e[t];return Qe(n)?void 0:Ke(n);},Ye=M,$e=_e,Ze=ye,et=TypeError,tt={exports:{}},nt=C,it=Object.defineProperty,rt=function rt(e,t){try{it(nt,e,{value:t,configurable:!0,writable:!0});}catch(n){nt[e]=t;}return t;},at=rt,ot="__core-js_shared__",st=C[ot]||at(ot,{}),ct=st;(tt.exports=function(e,t){return ct[e]||(ct[e]=void 0!==t?t:{});})("versions",[]).push({version:"3.25.5",mode:"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",source:"https://github.com/zloirock/core-js"});var ut=ue,dt=Object,lt=function lt(e){return dt(ut(e));},ht=lt,pt=ee({}.hasOwnProperty),ft=Object.hasOwn||function(e,t){return pt(ht(e),t);},mt=ee,_t=0,vt=Math.random(),gt=mt(1..toString),yt=function yt(e){return"Symbol("+(void 0===e?"":e)+")_"+gt(++_t+vt,36);},St=C,kt=tt.exports,bt=ft,Tt=yt,It=Me,Et=Le,wt=kt("wks"),Rt=St.Symbol,Ct=Rt&&Rt.for,At=Et?Rt:Rt&&Rt.withoutSetter||Tt,xt=function xt(e){if(!bt(wt,e)||!It&&"string"!=typeof wt[e]){var t="Symbol."+e;It&&bt(Rt,e)?wt[e]=Rt[e]:wt[e]=Et&&Ct?Ct(t):At(t);}return wt[e];},Pt=M,Dt=ye,Ot=Be,Nt=Xe,Mt=function Mt(e,t){var n,i;if("string"===t&&$e(n=e.toString)&&!Ze(i=Ye(n,e)))return i;if($e(n=e.valueOf)&&!Ze(i=Ye(n,e)))return i;if("string"!==t&&$e(n=e.toString)&&!Ze(i=Ye(n,e)))return i;throw et("Can't convert object to primitive value");},Lt=TypeError,Ut=xt("toPrimitive"),Vt=function Vt(e,t){if(!Dt(e)||Ot(e))return e;var n,i=Nt(e,Ut);if(i){if(void 0===t&&(t="default"),n=Pt(i,e,t),!Dt(n)||Ot(n))return n;throw Lt("Can't convert object to primitive value");}return void 0===t&&(t="number"),Mt(e,t);},Ft=Vt,jt=Be,Bt=function Bt(e){var t=Ft(e,"string");return jt(t)?t:t+"";},Ht=ye,Gt=C.document,Wt=Ht(Gt)&&Ht(Gt.createElement),zt=function zt(e){return Wt?Gt.createElement(e):{};},Jt=zt,qt=!P&&!x(function(){return 7!=Object.defineProperty(Jt("div"),"a",{get:function get(){return 7;}}).a;}),Kt=P,Qt=M,Xt=L,Yt=H,$t=he,Zt=Bt,en=ft,tn=qt,nn=Object.getOwnPropertyDescriptor;A.f=Kt?nn:function(e,t){if(e=$t(e),t=Zt(t),tn)try{return nn(e,t);}catch(n){}if(en(e,t))return Yt(!Qt(Xt.f,e,t),e[t]);};var rn={},an=P&&x(function(){return 42!=Object.defineProperty(function(){},"prototype",{value:42,writable:!1}).prototype;}),on=ye,sn=String,cn=TypeError,un=function un(e){if(on(e))return e;throw cn(sn(e)+" is not an object");},dn=P,ln=qt,hn=an,pn=un,fn=Bt,mn=TypeError,_n=Object.defineProperty,vn=Object.getOwnPropertyDescriptor,gn="enumerable",yn="configurable",Sn="writable";rn.f=dn?hn?function(e,t,n){if(pn(e),t=fn(t),pn(n),"function"==typeof e&&"prototype"===t&&"value"in n&&Sn in n&&!n.writable){var i=vn(e,t);i&&i.writable&&(e[t]=n.value,n={configurable:yn in n?n.configurable:i.configurable,enumerable:gn in n?n.enumerable:i.enumerable,writable:!1});}return _n(e,t,n);}:_n:function(e,t,n){if(pn(e),t=fn(t),pn(n),ln)try{return _n(e,t,n);}catch(i){}if("get"in n||"set"in n)throw mn("Accessors not supported");return"value"in n&&(e[t]=n.value),e;};var kn=rn,bn=H,Tn=P?function(e,t,n){return kn.f(e,t,bn(1,n));}:function(e,t,n){return e[t]=n,e;},In={exports:{}},En=P,wn=ft,Rn=Function.prototype,Cn=En&&Object.getOwnPropertyDescriptor,An=wn(Rn,"name"),xn={EXISTS:An,PROPER:An&&"something"===function(){}.name,CONFIGURABLE:An&&(!En||En&&Cn(Rn,"name").configurable)},Pn=_e,Dn=st,On=ee(Function.toString);Pn(Dn.inspectSource)||(Dn.inspectSource=function(e){return On(e);});var Nn,Mn,Ln,Un=Dn.inspectSource,Vn=_e,Fn=C.WeakMap,jn=Vn(Fn)&&/native code/.test(String(Fn)),Bn=tt.exports,Hn=yt,Gn=Bn("keys"),Wn=function Wn(e){return Gn[e]||(Gn[e]=Hn(e));},zn={},Jn=jn,qn=C,Kn=ye,Qn=Tn,Xn=ft,Yn=st,$n=Wn,Zn=zn,ei="Object already initialized",ti=qn.TypeError,ni=qn.WeakMap;if(Jn||Yn.state){var ii=Yn.state||(Yn.state=new ni());ii.get=ii.get,ii.has=ii.has,ii.set=ii.set,Nn=function Nn(e,t){if(ii.has(e))throw ti(ei);return t.facade=e,ii.set(e,t),t;},Mn=function Mn(e){return ii.get(e)||{};},Ln=function Ln(e){return ii.has(e);};}else{var ri=$n("state");Zn[ri]=!0,Nn=function Nn(e,t){if(Xn(e,ri))throw ti(ei);return t.facade=e,Qn(e,ri,t),t;},Mn=function Mn(e){return Xn(e,ri)?e[ri]:{};},Ln=function Ln(e){return Xn(e,ri);};}var ai={set:Nn,get:Mn,has:Ln,enforce:function enforce(e){return Ln(e)?Mn(e):Nn(e,{});},getterFor:function getterFor(e){return function(t){var n;if(!Kn(t)||(n=Mn(t)).type!==e)throw ti("Incompatible receiver, "+e+" required");return n;};}},oi=x,si=_e,ci=ft,ui=P,di=xn.CONFIGURABLE,li=Un,hi=ai.enforce,pi=ai.get,fi=Object.defineProperty,mi=ui&&!oi(function(){return 8!==fi(function(){},"length",{value:8}).length;}),_i=String(String).split("String"),vi=In.exports=function(e,t,n){"Symbol("===String(t).slice(0,7)&&(t="["+String(t).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),n&&n.getter&&(t="get "+t),n&&n.setter&&(t="set "+t),(!ci(e,"name")||di&&e.name!==t)&&(ui?fi(e,"name",{value:t,configurable:!0}):e.name=t),mi&&n&&ci(n,"arity")&&e.length!==n.arity&&fi(e,"length",{value:n.arity});try{n&&ci(n,"constructor")&&n.constructor?ui&&fi(e,"prototype",{writable:!1}):e.prototype&&(e.prototype=void 0);}catch(r){}var i=hi(e);return ci(i,"source")||(i.source=_i.join("string"==typeof t?t:"")),e;};Function.prototype.toString=vi(function(){return si(this)&&pi(this).source||li(this);},"toString");var gi=_e,yi=rn,Si=In.exports,ki=rt,bi=function bi(e,t,n,i){i||(i={});var r=i.enumerable,a=void 0!==i.name?i.name:t;if(gi(n)&&Si(n,a,i),i.global)r?e[t]=n:ki(t,n);else{try{i.unsafe?e[t]&&(r=!0):delete e[t];}catch(o){}r?e[t]=n:yi.f(e,t,{value:n,enumerable:!1,configurable:!i.nonConfigurable,writable:!i.nonWritable});}return e;},Ti={},Ii=Math.ceil,Ei=Math.floor,wi=Math.trunc||function(e){var t=+e;return(t>0?Ei:Ii)(t);},Ri=function Ri(e){var t=+e;return t!=t||0===t?0:wi(t);},Ci=Ri,Ai=Math.max,xi=Math.min,Pi=function Pi(e,t){var n=Ci(e);return n<0?Ai(n+t,0):xi(n,t);},Di=Ri,Oi=Math.min,Ni=function Ni(e){return e>0?Oi(Di(e),9007199254740991):0;},Mi=Ni,Li=function Li(e){return Mi(e.length);},Ui=he,Vi=Pi,Fi=Li,ji=function ji(e){return function(t,n,i){var r,a=Ui(t),o=Fi(a),s=Vi(i,o);if(e&&n!=n){for(;o>s;){if((r=a[s++])!=r)return!0;}}else for(;o>s;s++){if((e||s in a)&&a[s]===n)return e||s||0;}return!e&&-1;};},Bi={includes:ji(!0),indexOf:ji(!1)},Hi=ft,Gi=he,Wi=Bi.indexOf,zi=zn,Ji=ee([].push),qi=function qi(e,t){var n,i=Gi(e),r=0,a=[];for(n in i){!Hi(zi,n)&&Hi(i,n)&&Ji(a,n);}for(;t.length>r;){Hi(i,n=t[r++])&&(~Wi(a,n)||Ji(a,n));}return a;},Ki=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],Qi=qi,Xi=Ki.concat("length","prototype");Ti.f=Object.getOwnPropertyNames||function(e){return Qi(e,Xi);};var Yi={};Yi.f=Object.getOwnPropertySymbols;var $i=Te,Zi=Ti,er=Yi,tr=un,nr=ee([].concat),ir=$i("Reflect","ownKeys")||function(e){var t=Zi.f(tr(e)),n=er.f;return n?nr(t,n(e)):t;},rr=ft,ar=ir,or=A,sr=rn,cr=x,ur=_e,dr=/#|\.prototype\./,lr=function lr(e,t){var n=pr[hr(e)];return n==mr||n!=fr&&(ur(t)?cr(t):!!t);},hr=lr.normalize=function(e){return String(e).replace(dr,".").toLowerCase();},pr=lr.data={},fr=lr.NATIVE="N",mr=lr.POLYFILL="P",_r=lr,vr=C,gr=A.f,yr=Tn,Sr=bi,kr=rt,br=function br(e,t,n){for(var i=ar(t),r=sr.f,a=or.f,o=0;o<i.length;o++){var s=i[o];rr(e,s)||n&&rr(n,s)||r(e,s,a(t,s));}},Tr=_r,Ir=function Ir(e,t){var n,i,r,a,o,s=e.target,c=e.global,u=e.stat;if(n=c?vr:u?vr[s]||kr(s,{}):(vr[s]||{}).prototype)for(i in t){if(a=t[i],r=e.dontCallGetSet?(o=gr(n,i))&&o.value:n[i],!Tr(c?i:s+(u?".":"#")+i,e.forced)&&void 0!==r){if((typeof a==='undefined'?'undefined':_typeof2(a))==(typeof r==='undefined'?'undefined':_typeof2(r)))continue;br(a,r);}(e.sham||r&&r.sham)&&yr(a,"sham",!0),Sr(n,i,a,e);}},Er=qe,wr=D,Rr=ee(ee.bind),Cr=function Cr(e,t){return Er(e),void 0===t?e:wr?Rr(e,t):function(){return e.apply(t,arguments);};},Ar=Y,xr=Array.isArray||function(e){return"Array"==Ar(e);},Pr={};Pr[xt("toStringTag")]="z";var Dr="[object z]"===String(Pr),Or=Dr,Nr=_e,Mr=Y,Lr=xt("toStringTag"),Ur=Object,Vr="Arguments"==Mr(function(){return arguments;}()),Fr=Or?Mr:function(e){var t,n,i;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=function(e,t){try{return e[t];}catch(n){}}(t=Ur(e),Lr))?n:Vr?Mr(t):"Object"==(i=Mr(t))&&Nr(t.callee)?"Arguments":i;},jr=ee,Br=x,Hr=_e,Gr=Fr,Wr=Un,zr=function zr(){},Jr=[],qr=Te("Reflect","construct"),Kr=/^\s*(?:class|function)\b/,Qr=jr(Kr.exec),Xr=!Kr.exec(zr),Yr=function Yr(e){if(!Hr(e))return!1;try{return qr(zr,Jr,e),!0;}catch(t){return!1;}},$r=function $r(e){if(!Hr(e))return!1;switch(Gr(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1;}try{return Xr||!!Qr(Kr,Wr(e));}catch(t){return!0;}};$r.sham=!0;var Zr=!qr||Br(function(){var e;return Yr(Yr.call)||!Yr(Object)||!Yr(function(){e=!0;})||e;})?$r:Yr,ea=xr,ta=Zr,na=ye,ia=xt("species"),ra=Array,aa=function aa(e){var t;return ea(e)&&(t=e.constructor,(ta(t)&&(t===ra||ea(t.prototype))||na(t)&&null===(t=t[ia]))&&(t=void 0)),void 0===t?ra:t;},oa=function oa(e,t){return new(aa(e))(0===t?0:t);},sa=Cr,ca=ae,ua=lt,da=Li,la=oa,ha=ee([].push),pa=function pa(e){var t=1==e,n=2==e,i=3==e,r=4==e,a=6==e,o=7==e,s=5==e||a;return function(c,u,d,l){for(var h,p,f=ua(c),m=ca(f),_=sa(u,d),v=da(m),g=0,y=l||la,S=t?y(c,v):n||o?y(c,0):void 0;v>g;g++){if((s||g in m)&&(p=_(h=m[g],g,f),e))if(t)S[g]=p;else if(p)switch(e){case 3:return!0;case 5:return h;case 6:return g;case 2:ha(S,h);}else switch(e){case 4:return!1;case 7:ha(S,h);}}return a?-1:i||r?r:S;};},fa={forEach:pa(0),map:pa(1),filter:pa(2),some:pa(3),every:pa(4),find:pa(5),findIndex:pa(6),filterReject:pa(7)},ma=x,_a=De,va=xt("species"),ga=function ga(e){return _a>=51||!ma(function(){var t=[];return(t.constructor={})[va]=function(){return{foo:1};},1!==t[e](Boolean).foo;});},ya=fa.map;Ir({target:"Array",proto:!0,forced:!ga("map")},{map:function map(e){return ya(this,e,arguments.length>1?arguments[1]:void 0);}});var Sa=fa.filter;Ir({target:"Array",proto:!0,forced:!ga("filter")},{filter:function filter(e){return Sa(this,e,arguments.length>1?arguments[1]:void 0);}});var ka=Fr,ba=Dr?{}.toString:function(){return"[object "+ka(this)+"]";};Dr||bi(Object.prototype,"toString",ba,{unsafe:!0});var Ta=Ir,Ia=x,Ea=he,wa=A.f,Ra=P,Ca=Ia(function(){wa(1);});Ta({target:"Object",stat:!0,forced:!Ra||Ca,sham:!Ra},{getOwnPropertyDescriptor:function getOwnPropertyDescriptor(e,t){return wa(Ea(e),t);}});var Aa=!0,xa=!0;function Pa(e,t,n){var i=e.match(t);return i&&i.length>=n&&parseInt(i[n],10);}function Da(e,t,n){if(!e.RTCPeerConnection)return;var i=e.RTCPeerConnection.prototype,r=i.addEventListener;i.addEventListener=function(e,i){if(e!==t)return r.apply(this,arguments);var a=function a(e){var t=n(e);t&&(i.handleEvent?i.handleEvent(t):i(t));};return this._eventMap=this._eventMap||{},this._eventMap[t]||(this._eventMap[t]=new Map()),this._eventMap[t].set(i,a),r.apply(this,[e,a]);};var a=i.removeEventListener;i.removeEventListener=function(e,n){if(e!==t||!this._eventMap||!this._eventMap[t])return a.apply(this,arguments);if(!this._eventMap[t].has(n))return a.apply(this,arguments);var i=this._eventMap[t].get(n);return this._eventMap[t].delete(n),0===this._eventMap[t].size&&delete this._eventMap[t],0===Object.keys(this._eventMap).length&&delete this._eventMap,a.apply(this,[e,i]);},Object.defineProperty(i,"on"+t,{get:function get(){return this["_on"+t];},set:function set(e){this["_on"+t]&&(this.removeEventListener(t,this["_on"+t]),delete this["_on"+t]),e&&this.addEventListener(t,this["_on"+t]=e);},enumerable:!0,configurable:!0});}function Oa(e){return"boolean"!=typeof e?new Error("Argument type: "+(typeof e==='undefined'?'undefined':_typeof2(e))+". Please use a boolean."):(Aa=e,e?"adapter.js logging disabled":"adapter.js logging enabled");}function Na(e){return"boolean"!=typeof e?new Error("Argument type: "+(typeof e==='undefined'?'undefined':_typeof2(e))+". Please use a boolean."):(xa=!e,"adapter.js deprecation warnings "+(e?"disabled":"enabled"));}function Ma(){if("object"==(typeof window==='undefined'?'undefined':_typeof2(window))){if(Aa)return;"undefined"!=typeof console&&"function"==typeof console.log&&console.log.apply(console,arguments);}}function La(e,t){xa&&console.warn(e+" is deprecated, please use "+t+" instead.");}function Ua(e){return"[object Object]"===Object.prototype.toString.call(e);}function Va(e){return Ua(e)?Object.keys(e).reduce(function(t,n){var i=Ua(e[n]),r=i?Va(e[n]):e[n],a=i&&!Object.keys(r).length;return void 0===r||a?t:Object.assign(t,_defineProperty2({},n,r));},{}):e;}function Fa(e,t,n){t&&!n.has(t.id)&&(n.set(t.id,t),Object.keys(t).forEach(function(i){i.endsWith("Id")?Fa(e,e.get(t[i]),n):i.endsWith("Ids")&&t[i].forEach(function(t){Fa(e,e.get(t),n);});}));}function ja(e,t,n){var i=n?"outbound-rtp":"inbound-rtp",r=new Map();if(null===t)return r;var a=[];return e.forEach(function(e){"track"===e.type&&e.trackIdentifier===t.id&&a.push(e);}),a.forEach(function(t){e.forEach(function(n){n.type===i&&n.trackId===t.id&&Fa(e,n,r);});}),r;}var Ba=Ma;function Ha(e,t){var n=e&&e.navigator;if(!n.mediaDevices)return;var i=function i(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||e.mandatory||e.optional)return e;var t={};return Object.keys(e).forEach(function(n){if("require"===n||"advanced"===n||"mediaSource"===n)return;var i="object"==_typeof2(e[n])?e[n]:{ideal:e[n]};void 0!==i.exact&&"number"==typeof i.exact&&(i.min=i.max=i.exact);var r=function r(e,t){return e?e+t.charAt(0).toUpperCase()+t.slice(1):"deviceId"===t?"sourceId":t;};if(void 0!==i.ideal){t.optional=t.optional||[];var _e4={};"number"==typeof i.ideal?(_e4[r("min",n)]=i.ideal,t.optional.push(_e4),_e4={},_e4[r("max",n)]=i.ideal,t.optional.push(_e4)):(_e4[r("",n)]=i.ideal,t.optional.push(_e4));}void 0!==i.exact&&"number"!=typeof i.exact?(t.mandatory=t.mandatory||{},t.mandatory[r("",n)]=i.exact):["min","max"].forEach(function(e){void 0!==i[e]&&(t.mandatory=t.mandatory||{},t.mandatory[r(e,n)]=i[e]);});}),e.advanced&&(t.optional=(t.optional||[]).concat(e.advanced)),t;},r=function r(e,_r2){if(t.version>=61)return _r2(e);if((e=JSON.parse(JSON.stringify(e)))&&"object"==_typeof2(e.audio)){var _t2=function _t2(e,t,n){t in e&&!(n in e)&&(e[n]=e[t],delete e[t]);};_t2((e=JSON.parse(JSON.stringify(e))).audio,"autoGainControl","googAutoGainControl"),_t2(e.audio,"noiseSuppression","googNoiseSuppression"),e.audio=i(e.audio);}if(e&&"object"==_typeof2(e.video)){var _a2=e.video.facingMode;_a2=_a2&&("object"==(typeof _a2==='undefined'?'undefined':_typeof2(_a2))?_a2:{ideal:_a2});var _o2=t.version<66;if(_a2&&("user"===_a2.exact||"environment"===_a2.exact||"user"===_a2.ideal||"environment"===_a2.ideal)&&(!n.mediaDevices.getSupportedConstraints||!n.mediaDevices.getSupportedConstraints().facingMode||_o2)){var _t3=void 0;if(delete e.video.facingMode,"environment"===_a2.exact||"environment"===_a2.ideal?_t3=["back","rear"]:"user"!==_a2.exact&&"user"!==_a2.ideal||(_t3=["front"]),_t3)return n.mediaDevices.enumerateDevices().then(function(n){var o=(n=n.filter(function(e){return"videoinput"===e.kind;})).find(function(e){return _t3.some(function(t){return e.label.toLowerCase().includes(t);});});return!o&&n.length&&_t3.includes("back")&&(o=n[n.length-1]),o&&(e.video.deviceId=_a2.exact?{exact:o.deviceId}:{ideal:o.deviceId}),e.video=i(e.video),Ba("chrome: "+JSON.stringify(e)),_r2(e);});}e.video=i(e.video);}return Ba("chrome: "+JSON.stringify(e)),_r2(e);},a=function a(e){return t.version>=64?e:{name:{PermissionDeniedError:"NotAllowedError",PermissionDismissedError:"NotAllowedError",InvalidStateError:"NotAllowedError",DevicesNotFoundError:"NotFoundError",ConstraintNotSatisfiedError:"OverconstrainedError",TrackStartError:"NotReadableError",MediaDeviceFailedDueToShutdown:"NotAllowedError",MediaDeviceKillSwitchOn:"NotAllowedError",TabCaptureError:"AbortError",ScreenCaptureError:"AbortError",DeviceCaptureError:"AbortError"}[e.name]||e.name,message:e.message,constraint:e.constraint||e.constraintName,toString:function toString(){return this.name+(this.message&&": ")+this.message;}};};if(n.getUserMedia=function(e,t,i){r(e,function(e){n.webkitGetUserMedia(e,t,function(e){i&&i(a(e));});});}.bind(n),n.mediaDevices.getUserMedia){var _e5=n.mediaDevices.getUserMedia.bind(n.mediaDevices);n.mediaDevices.getUserMedia=function(t){return r(t,function(t){return _e5(t).then(function(e){if(t.audio&&!e.getAudioTracks().length||t.video&&!e.getVideoTracks().length)throw e.getTracks().forEach(function(e){e.stop();}),new DOMException("","NotFoundError");return e;},function(e){return Promise.reject(a(e));});});};}}function Ga(e){e.MediaStream=e.MediaStream||e.webkitMediaStream;}function Wa(e){if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCPeerConnection&&!("ontrack"in e.RTCPeerConnection.prototype)){Object.defineProperty(e.RTCPeerConnection.prototype,"ontrack",{get:function get(){return this._ontrack;},set:function set(e){this._ontrack&&this.removeEventListener("track",this._ontrack),this.addEventListener("track",this._ontrack=e);},enumerable:!0,configurable:!0});var _t4=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){var _this14=this;return this._ontrackpoly||(this._ontrackpoly=function(t){t.stream.addEventListener("addtrack",function(n){var i=void 0;i=e.RTCPeerConnection.prototype.getReceivers?_this14.getReceivers().find(function(e){return e.track&&e.track.id===n.track.id;}):{track:n.track};var r=new Event("track");r.track=n.track,r.receiver=i,r.transceiver={receiver:i},r.streams=[t.stream],_this14.dispatchEvent(r);}),t.stream.getTracks().forEach(function(n){var i=void 0;i=e.RTCPeerConnection.prototype.getReceivers?_this14.getReceivers().find(function(e){return e.track&&e.track.id===n.id;}):{track:n};var r=new Event("track");r.track=n,r.receiver=i,r.transceiver={receiver:i},r.streams=[t.stream],_this14.dispatchEvent(r);});},this.addEventListener("addstream",this._ontrackpoly)),_t4.apply(this,arguments);};}else Da(e,"track",function(e){return e.transceiver||Object.defineProperty(e,"transceiver",{value:{receiver:e.receiver}}),e;});}function za(e){if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCPeerConnection&&!("getSenders"in e.RTCPeerConnection.prototype)&&"createDTMFSender"in e.RTCPeerConnection.prototype){var _t5=function _t5(e,t){return{track:t,get dtmf(){return void 0===this._dtmf&&("audio"===t.kind?this._dtmf=e.createDTMFSender(t):this._dtmf=null),this._dtmf;},_pc:e};};if(!e.RTCPeerConnection.prototype.getSenders){e.RTCPeerConnection.prototype.getSenders=function(){return this._senders=this._senders||[],this._senders.slice();};var _n4=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addTrack=function(e,i){var r=_n4.apply(this,arguments);return r||(r=_t5(this,e),this._senders.push(r)),r;};var _i3=e.RTCPeerConnection.prototype.removeTrack;e.RTCPeerConnection.prototype.removeTrack=function(e){_i3.apply(this,arguments);var t=this._senders.indexOf(e);-1!==t&&this._senders.splice(t,1);};}var _n3=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(e){var _this15=this;this._senders=this._senders||[],_n3.apply(this,[e]),e.getTracks().forEach(function(e){_this15._senders.push(_t5(_this15,e));});};var _i2=e.RTCPeerConnection.prototype.removeStream;e.RTCPeerConnection.prototype.removeStream=function(e){var _this16=this;this._senders=this._senders||[],_i2.apply(this,[e]),e.getTracks().forEach(function(e){var t=_this16._senders.find(function(t){return t.track===e;});t&&_this16._senders.splice(_this16._senders.indexOf(t),1);});};}else if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCPeerConnection&&"getSenders"in e.RTCPeerConnection.prototype&&"createDTMFSender"in e.RTCPeerConnection.prototype&&e.RTCRtpSender&&!("dtmf"in e.RTCRtpSender.prototype)){var _t6=e.RTCPeerConnection.prototype.getSenders;e.RTCPeerConnection.prototype.getSenders=function(){var _this17=this;var e=_t6.apply(this,[]);return e.forEach(function(e){return e._pc=_this17;}),e;},Object.defineProperty(e.RTCRtpSender.prototype,"dtmf",{get:function get(){return void 0===this._dtmf&&("audio"===this.track.kind?this._dtmf=this._pc.createDTMFSender(this.track):this._dtmf=null),this._dtmf;}});}}function Ja(e){if(!e.RTCPeerConnection)return;var t=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){var _this18=this;var _arguments2=Array.prototype.slice.call(arguments),e=_arguments2[0],n=_arguments2[1],i=_arguments2[2];if(arguments.length>0&&"function"==typeof e)return t.apply(this,arguments);if(0===t.length&&(0===arguments.length||"function"!=typeof e))return t.apply(this,[]);var r=function r(e){var t={};return e.result().forEach(function(e){var n={id:e.id,timestamp:e.timestamp,type:{localcandidate:"local-candidate",remotecandidate:"remote-candidate"}[e.type]||e.type};e.names().forEach(function(t){n[t]=e.stat(t);}),t[n.id]=n;}),t;},a=function a(e){return new Map(Object.keys(e).map(function(t){return[t,e[t]];}));};if(arguments.length>=2){var _i4=function _i4(e){n(a(r(e)));};return t.apply(this,[_i4,e]);}return new Promise(function(e,n){t.apply(_this18,[function(t){e(a(r(t)));},n]);}).then(n,i);};}function qa(e){if(!("object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCPeerConnection&&e.RTCRtpSender&&e.RTCRtpReceiver))return;if(!("getStats"in e.RTCRtpSender.prototype)){var _t7=e.RTCPeerConnection.prototype.getSenders;_t7&&(e.RTCPeerConnection.prototype.getSenders=function(){var _this19=this;var e=_t7.apply(this,[]);return e.forEach(function(e){return e._pc=_this19;}),e;});var _n5=e.RTCPeerConnection.prototype.addTrack;_n5&&(e.RTCPeerConnection.prototype.addTrack=function(){var e=_n5.apply(this,arguments);return e._pc=this,e;}),e.RTCRtpSender.prototype.getStats=function(){var e=this;return this._pc.getStats().then(function(t){return ja(t,e.track,!0);});};}if(!("getStats"in e.RTCRtpReceiver.prototype)){var _t8=e.RTCPeerConnection.prototype.getReceivers;_t8&&(e.RTCPeerConnection.prototype.getReceivers=function(){var _this20=this;var e=_t8.apply(this,[]);return e.forEach(function(e){return e._pc=_this20;}),e;}),Da(e,"track",function(e){return e.receiver._pc=e.srcElement,e;}),e.RTCRtpReceiver.prototype.getStats=function(){var e=this;return this._pc.getStats().then(function(t){return ja(t,e.track,!1);});};}if(!("getStats"in e.RTCRtpSender.prototype)||!("getStats"in e.RTCRtpReceiver.prototype))return;var t=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){if(arguments.length>0&&arguments[0]instanceof e.MediaStreamTrack){var _e6=arguments[0];var _t9=void 0,_n6=void 0,_i5=void 0;return this.getSenders().forEach(function(n){n.track===_e6&&(_t9?_i5=!0:_t9=n);}),this.getReceivers().forEach(function(t){return t.track===_e6&&(_n6?_i5=!0:_n6=t),t.track===_e6;}),_i5||_t9&&_n6?Promise.reject(new DOMException("There are more than one sender or receiver for the track.","InvalidAccessError")):_t9?_t9.getStats():_n6?_n6.getStats():Promise.reject(new DOMException("There is no sender or receiver for the track.","InvalidAccessError"));}return t.apply(this,arguments);};}function Ka(e){e.RTCPeerConnection.prototype.getLocalStreams=function(){var _this21=this;return this._shimmedLocalStreams=this._shimmedLocalStreams||{},Object.keys(this._shimmedLocalStreams).map(function(e){return _this21._shimmedLocalStreams[e][0];});};var t=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addTrack=function(e,n){if(!n)return t.apply(this,arguments);this._shimmedLocalStreams=this._shimmedLocalStreams||{};var i=t.apply(this,arguments);return this._shimmedLocalStreams[n.id]?-1===this._shimmedLocalStreams[n.id].indexOf(i)&&this._shimmedLocalStreams[n.id].push(i):this._shimmedLocalStreams[n.id]=[n,i],i;};var n=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(e){var _this22=this;this._shimmedLocalStreams=this._shimmedLocalStreams||{},e.getTracks().forEach(function(e){if(_this22.getSenders().find(function(t){return t.track===e;}))throw new DOMException("Track already exists.","InvalidAccessError");});var t=this.getSenders();n.apply(this,arguments);var i=this.getSenders().filter(function(e){return-1===t.indexOf(e);});this._shimmedLocalStreams[e.id]=[e].concat(i);};var i=e.RTCPeerConnection.prototype.removeStream;e.RTCPeerConnection.prototype.removeStream=function(e){return this._shimmedLocalStreams=this._shimmedLocalStreams||{},delete this._shimmedLocalStreams[e.id],i.apply(this,arguments);};var r=e.RTCPeerConnection.prototype.removeTrack;e.RTCPeerConnection.prototype.removeTrack=function(e){var _this23=this;return this._shimmedLocalStreams=this._shimmedLocalStreams||{},e&&Object.keys(this._shimmedLocalStreams).forEach(function(t){var n=_this23._shimmedLocalStreams[t].indexOf(e);-1!==n&&_this23._shimmedLocalStreams[t].splice(n,1),1===_this23._shimmedLocalStreams[t].length&&delete _this23._shimmedLocalStreams[t];}),r.apply(this,arguments);};}function Qa(e,t){if(!e.RTCPeerConnection)return;if(e.RTCPeerConnection.prototype.addTrack&&t.version>=65)return Ka(e);var n=e.RTCPeerConnection.prototype.getLocalStreams;e.RTCPeerConnection.prototype.getLocalStreams=function(){var _this24=this;var e=n.apply(this);return this._reverseStreams=this._reverseStreams||{},e.map(function(e){return _this24._reverseStreams[e.id];});};var i=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(t){var _this25=this;if(this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{},t.getTracks().forEach(function(e){if(_this25.getSenders().find(function(t){return t.track===e;}))throw new DOMException("Track already exists.","InvalidAccessError");}),!this._reverseStreams[t.id]){var _n7=new e.MediaStream(t.getTracks());this._streams[t.id]=_n7,this._reverseStreams[_n7.id]=t,t=_n7;}i.apply(this,[t]);};var r=e.RTCPeerConnection.prototype.removeStream;function a(e,t){var n=t.sdp;return Object.keys(e._reverseStreams||[]).forEach(function(t){var i=e._reverseStreams[t],r=e._streams[i.id];n=n.replace(new RegExp(r.id,"g"),i.id);}),new RTCSessionDescription({type:t.type,sdp:n});}function o(e,t){var n=t.sdp;return Object.keys(e._reverseStreams||[]).forEach(function(t){var i=e._reverseStreams[t],r=e._streams[i.id];n=n.replace(new RegExp(i.id,"g"),r.id);}),new RTCSessionDescription({type:t.type,sdp:n});}e.RTCPeerConnection.prototype.removeStream=function(e){this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{},r.apply(this,[this._streams[e.id]||e]),delete this._reverseStreams[this._streams[e.id]?this._streams[e.id].id:e.id],delete this._streams[e.id];},e.RTCPeerConnection.prototype.addTrack=function(t,n){var _this26=this;if("closed"===this.signalingState)throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.","InvalidStateError");var i=[].slice.call(arguments,1);if(1!==i.length||!i[0].getTracks().find(function(e){return e===t;}))throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.","NotSupportedError");var r=this.getSenders().find(function(e){return e.track===t;});if(r)throw new DOMException("Track already exists.","InvalidAccessError");this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{};var a=this._streams[n.id];if(a)a.addTrack(t),Promise.resolve().then(function(){_this26.dispatchEvent(new Event("negotiationneeded"));});else{var _i6=new e.MediaStream([t]);this._streams[n.id]=_i6,this._reverseStreams[_i6.id]=n,this.addStream(_i6);}return this.getSenders().find(function(e){return e.track===t;});},["createOffer","createAnswer"].forEach(function(t){var n=e.RTCPeerConnection.prototype[t],i=_defineProperty2({},t,function(){var _this27=this;var e=arguments;return arguments.length&&"function"==typeof arguments[0]?n.apply(this,[function(t){var n=a(_this27,t);e[0].apply(null,[n]);},function(t){e[1]&&e[1].apply(null,t);},arguments[2]]):n.apply(this,arguments).then(function(e){return a(_this27,e);});});e.RTCPeerConnection.prototype[t]=i[t];});var s=e.RTCPeerConnection.prototype.setLocalDescription;e.RTCPeerConnection.prototype.setLocalDescription=function(){return arguments.length&&arguments[0].type?(arguments[0]=o(this,arguments[0]),s.apply(this,arguments)):s.apply(this,arguments);};var c=Object.getOwnPropertyDescriptor(e.RTCPeerConnection.prototype,"localDescription");Object.defineProperty(e.RTCPeerConnection.prototype,"localDescription",{get:function get(){var e=c.get.apply(this);return""===e.type?e:a(this,e);}}),e.RTCPeerConnection.prototype.removeTrack=function(e){var _this28=this;if("closed"===this.signalingState)throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.","InvalidStateError");if(!e._pc)throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.","TypeError");if(!(e._pc===this))throw new DOMException("Sender was not created by this connection.","InvalidAccessError");var t=void 0;this._streams=this._streams||{},Object.keys(this._streams).forEach(function(n){_this28._streams[n].getTracks().find(function(t){return e.track===t;})&&(t=_this28._streams[n]);}),t&&(1===t.getTracks().length?this.removeStream(this._reverseStreams[t.id]):t.removeTrack(e.track),this.dispatchEvent(new Event("negotiationneeded")));};}function Xa(e,t){!e.RTCPeerConnection&&e.webkitRTCPeerConnection&&(e.RTCPeerConnection=e.webkitRTCPeerConnection),e.RTCPeerConnection&&t.version<53&&["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach(function(t){var n=e.RTCPeerConnection.prototype[t],i=_defineProperty2({},t,function(){return arguments[0]=new("addIceCandidate"===t?e.RTCIceCandidate:e.RTCSessionDescription)(arguments[0]),n.apply(this,arguments);});e.RTCPeerConnection.prototype[t]=i[t];});}function Ya(e,t){Da(e,"negotiationneeded",function(e){var n=e.target;if(!(t.version<72||n.getConfiguration&&"plan-b"===n.getConfiguration().sdpSemantics)||"stable"===n.signalingState)return e;});}var $a=Object.freeze({__proto__:null,shimMediaStream:Ga,shimOnTrack:Wa,shimGetSendersWithDtmf:za,shimGetStats:Ja,shimSenderReceiverGetStats:qa,shimAddTrackRemoveTrackWithNative:Ka,shimAddTrackRemoveTrack:Qa,shimPeerConnection:Xa,fixNegotiationNeeded:Ya,shimGetUserMedia:Ha,shimGetDisplayMedia:function shimGetDisplayMedia(e,t){e.navigator.mediaDevices&&"getDisplayMedia"in e.navigator.mediaDevices||e.navigator.mediaDevices&&("function"==typeof t?e.navigator.mediaDevices.getDisplayMedia=function(n){return t(n).then(function(t){var i=n.video&&n.video.width,r=n.video&&n.video.height,a=n.video&&n.video.frameRate;return n.video={mandatory:{chromeMediaSource:"desktop",chromeMediaSourceId:t,maxFrameRate:a||3}},i&&(n.video.mandatory.maxWidth=i),r&&(n.video.mandatory.maxHeight=r),e.navigator.mediaDevices.getUserMedia(n);});}:console.error("shimGetDisplayMedia: getSourceId argument is not a function"));}});var Za={exports:{}};!function(e){var t={generateIdentifier:function generateIdentifier(){return Math.random().toString(36).substr(2,10);}};t.localCName=t.generateIdentifier(),t.splitLines=function(e){return e.trim().split("\n").map(function(e){return e.trim();});},t.splitSections=function(e){return e.split("\nm=").map(function(e,t){return(t>0?"m="+e:e).trim()+"\r\n";});},t.getDescription=function(e){var n=t.splitSections(e);return n&&n[0];},t.getMediaSections=function(e){var n=t.splitSections(e);return n.shift(),n;},t.matchPrefix=function(e,n){return t.splitLines(e).filter(function(e){return 0===e.indexOf(n);});},t.parseCandidate=function(e){for(var t,n={foundation:(t=0===e.indexOf("a=candidate:")?e.substring(12).split(" "):e.substring(10).split(" "))[0],component:parseInt(t[1],10),protocol:t[2].toLowerCase(),priority:parseInt(t[3],10),ip:t[4],address:t[4],port:parseInt(t[5],10),type:t[7]},i=8;i<t.length;i+=2){switch(t[i]){case"raddr":n.relatedAddress=t[i+1];break;case"rport":n.relatedPort=parseInt(t[i+1],10);break;case"tcptype":n.tcpType=t[i+1];break;case"ufrag":n.ufrag=t[i+1],n.usernameFragment=t[i+1];break;default:n[t[i]]=t[i+1];}}return n;},t.writeCandidate=function(e){var t=[];t.push(e.foundation),t.push(e.component),t.push(e.protocol.toUpperCase()),t.push(e.priority),t.push(e.address||e.ip),t.push(e.port);var n=e.type;return t.push("typ"),t.push(n),"host"!==n&&e.relatedAddress&&e.relatedPort&&(t.push("raddr"),t.push(e.relatedAddress),t.push("rport"),t.push(e.relatedPort)),e.tcpType&&"tcp"===e.protocol.toLowerCase()&&(t.push("tcptype"),t.push(e.tcpType)),(e.usernameFragment||e.ufrag)&&(t.push("ufrag"),t.push(e.usernameFragment||e.ufrag)),"candidate:"+t.join(" ");},t.parseIceOptions=function(e){return e.substr(14).split(" ");},t.parseRtpMap=function(e){var t=e.substr(9).split(" "),n={payloadType:parseInt(t.shift(),10)};return t=t[0].split("/"),n.name=t[0],n.clockRate=parseInt(t[1],10),n.channels=3===t.length?parseInt(t[2],10):1,n.numChannels=n.channels,n;},t.writeRtpMap=function(e){var t=e.payloadType;void 0!==e.preferredPayloadType&&(t=e.preferredPayloadType);var n=e.channels||e.numChannels||1;return"a=rtpmap:"+t+" "+e.name+"/"+e.clockRate+(1!==n?"/"+n:"")+"\r\n";},t.parseExtmap=function(e){var t=e.substr(9).split(" ");return{id:parseInt(t[0],10),direction:t[0].indexOf("/")>0?t[0].split("/")[1]:"sendrecv",uri:t[1]};},t.writeExtmap=function(e){return"a=extmap:"+(e.id||e.preferredId)+(e.direction&&"sendrecv"!==e.direction?"/"+e.direction:"")+" "+e.uri+"\r\n";},t.parseFmtp=function(e){for(var t,n={},i=e.substr(e.indexOf(" ")+1).split(";"),r=0;r<i.length;r++){n[(t=i[r].trim().split("="))[0].trim()]=t[1];}return n;},t.writeFmtp=function(e){var t="",n=e.payloadType;if(void 0!==e.preferredPayloadType&&(n=e.preferredPayloadType),e.parameters&&Object.keys(e.parameters).length){var i=[];Object.keys(e.parameters).forEach(function(t){e.parameters[t]?i.push(t+"="+e.parameters[t]):i.push(t);}),t+="a=fmtp:"+n+" "+i.join(";")+"\r\n";}return t;},t.parseRtcpFb=function(e){var t=e.substr(e.indexOf(" ")+1).split(" ");return{type:t.shift(),parameter:t.join(" ")};},t.writeRtcpFb=function(e){var t="",n=e.payloadType;return void 0!==e.preferredPayloadType&&(n=e.preferredPayloadType),e.rtcpFeedback&&e.rtcpFeedback.length&&e.rtcpFeedback.forEach(function(e){t+="a=rtcp-fb:"+n+" "+e.type+(e.parameter&&e.parameter.length?" "+e.parameter:"")+"\r\n";}),t;},t.parseSsrcMedia=function(e){var t=e.indexOf(" "),n={ssrc:parseInt(e.substr(7,t-7),10)},i=e.indexOf(":",t);return i>-1?(n.attribute=e.substr(t+1,i-t-1),n.value=e.substr(i+1)):n.attribute=e.substr(t+1),n;},t.parseSsrcGroup=function(e){var t=e.substr(13).split(" ");return{semantics:t.shift(),ssrcs:t.map(function(e){return parseInt(e,10);})};},t.getMid=function(e){var n=t.matchPrefix(e,"a=mid:")[0];if(n)return n.substr(6);},t.parseFingerprint=function(e){var t=e.substr(14).split(" ");return{algorithm:t[0].toLowerCase(),value:t[1]};},t.getDtlsParameters=function(e,n){return{role:"auto",fingerprints:t.matchPrefix(e+n,"a=fingerprint:").map(t.parseFingerprint)};},t.writeDtlsParameters=function(e,t){var n="a=setup:"+t+"\r\n";return e.fingerprints.forEach(function(e){n+="a=fingerprint:"+e.algorithm+" "+e.value+"\r\n";}),n;},t.parseCryptoLine=function(e){var t=e.substr(9).split(" ");return{tag:parseInt(t[0],10),cryptoSuite:t[1],keyParams:t[2],sessionParams:t.slice(3)};},t.writeCryptoLine=function(e){return"a=crypto:"+e.tag+" "+e.cryptoSuite+" "+("object"==_typeof2(e.keyParams)?t.writeCryptoKeyParams(e.keyParams):e.keyParams)+(e.sessionParams?" "+e.sessionParams.join(" "):"")+"\r\n";},t.parseCryptoKeyParams=function(e){if(0!==e.indexOf("inline:"))return null;var t=e.substr(7).split("|");return{keyMethod:"inline",keySalt:t[0],lifeTime:t[1],mkiValue:t[2]?t[2].split(":")[0]:void 0,mkiLength:t[2]?t[2].split(":")[1]:void 0};},t.writeCryptoKeyParams=function(e){return e.keyMethod+":"+e.keySalt+(e.lifeTime?"|"+e.lifeTime:"")+(e.mkiValue&&e.mkiLength?"|"+e.mkiValue+":"+e.mkiLength:"");},t.getCryptoParameters=function(e,n){return t.matchPrefix(e+n,"a=crypto:").map(t.parseCryptoLine);},t.getIceParameters=function(e,n){var i=t.matchPrefix(e+n,"a=ice-ufrag:")[0],r=t.matchPrefix(e+n,"a=ice-pwd:")[0];return i&&r?{usernameFragment:i.substr(12),password:r.substr(10)}:null;},t.writeIceParameters=function(e){return"a=ice-ufrag:"+e.usernameFragment+"\r\na=ice-pwd:"+e.password+"\r\n";},t.parseRtpParameters=function(e){for(var n={codecs:[],headerExtensions:[],fecMechanisms:[],rtcp:[]},i=t.splitLines(e)[0].split(" "),r=3;r<i.length;r++){var a=i[r],o=t.matchPrefix(e,"a=rtpmap:"+a+" ")[0];if(o){var s=t.parseRtpMap(o),c=t.matchPrefix(e,"a=fmtp:"+a+" ");switch(s.parameters=c.length?t.parseFmtp(c[0]):{},s.rtcpFeedback=t.matchPrefix(e,"a=rtcp-fb:"+a+" ").map(t.parseRtcpFb),n.codecs.push(s),s.name.toUpperCase()){case"RED":case"ULPFEC":n.fecMechanisms.push(s.name.toUpperCase());}}}return t.matchPrefix(e,"a=extmap:").forEach(function(e){n.headerExtensions.push(t.parseExtmap(e));}),n;},t.writeRtpDescription=function(e,n){var i="";i+="m="+e+" ",i+=n.codecs.length>0?"9":"0",i+=" UDP/TLS/RTP/SAVPF ",i+=n.codecs.map(function(e){return void 0!==e.preferredPayloadType?e.preferredPayloadType:e.payloadType;}).join(" ")+"\r\n",i+="c=IN IP4 0.0.0.0\r\n",i+="a=rtcp:9 IN IP4 0.0.0.0\r\n",n.codecs.forEach(function(e){i+=t.writeRtpMap(e),i+=t.writeFmtp(e),i+=t.writeRtcpFb(e);});var r=0;return n.codecs.forEach(function(e){e.maxptime>r&&(r=e.maxptime);}),r>0&&(i+="a=maxptime:"+r+"\r\n"),i+="a=rtcp-mux\r\n",n.headerExtensions&&n.headerExtensions.forEach(function(e){i+=t.writeExtmap(e);}),i;},t.parseRtpEncodingParameters=function(e){var n,i=[],r=t.parseRtpParameters(e),a=-1!==r.fecMechanisms.indexOf("RED"),o=-1!==r.fecMechanisms.indexOf("ULPFEC"),s=t.matchPrefix(e,"a=ssrc:").map(function(e){return t.parseSsrcMedia(e);}).filter(function(e){return"cname"===e.attribute;}),c=s.length>0&&s[0].ssrc,u=t.matchPrefix(e,"a=ssrc-group:FID").map(function(e){return e.substr(17).split(" ").map(function(e){return parseInt(e,10);});});u.length>0&&u[0].length>1&&u[0][0]===c&&(n=u[0][1]),r.codecs.forEach(function(e){if("RTX"===e.name.toUpperCase()&&e.parameters.apt){var t={ssrc:c,codecPayloadType:parseInt(e.parameters.apt,10)};c&&n&&(t.rtx={ssrc:n}),i.push(t),a&&((t=JSON.parse(JSON.stringify(t))).fec={ssrc:c,mechanism:o?"red+ulpfec":"red"},i.push(t));}}),0===i.length&&c&&i.push({ssrc:c});var d=t.matchPrefix(e,"b=");return d.length&&(d=0===d[0].indexOf("b=TIAS:")?parseInt(d[0].substr(7),10):0===d[0].indexOf("b=AS:")?1e3*parseInt(d[0].substr(5),10)*.95-16e3:void 0,i.forEach(function(e){e.maxBitrate=d;})),i;},t.parseRtcpParameters=function(e){var n={},i=t.matchPrefix(e,"a=ssrc:").map(function(e){return t.parseSsrcMedia(e);}).filter(function(e){return"cname"===e.attribute;})[0];i&&(n.cname=i.value,n.ssrc=i.ssrc);var r=t.matchPrefix(e,"a=rtcp-rsize");n.reducedSize=r.length>0,n.compound=0===r.length;var a=t.matchPrefix(e,"a=rtcp-mux");return n.mux=a.length>0,n;},t.parseMsid=function(e){var n,i=t.matchPrefix(e,"a=msid:");if(1===i.length)return{stream:(n=i[0].substr(7).split(" "))[0],track:n[1]};var r=t.matchPrefix(e,"a=ssrc:").map(function(e){return t.parseSsrcMedia(e);}).filter(function(e){return"msid"===e.attribute;});return r.length>0?{stream:(n=r[0].value.split(" "))[0],track:n[1]}:void 0;},t.parseSctpDescription=function(e){var n,i=t.parseMLine(e),r=t.matchPrefix(e,"a=max-message-size:");r.length>0&&(n=parseInt(r[0].substr(19),10)),isNaN(n)&&(n=65536);var a=t.matchPrefix(e,"a=sctp-port:");if(a.length>0)return{port:parseInt(a[0].substr(12),10),protocol:i.fmt,maxMessageSize:n};if(t.matchPrefix(e,"a=sctpmap:").length>0){var o=t.matchPrefix(e,"a=sctpmap:")[0].substr(10).split(" ");return{port:parseInt(o[0],10),protocol:o[1],maxMessageSize:n};}},t.writeSctpDescription=function(e,t){var n=[];return n="DTLS/SCTP"!==e.protocol?["m="+e.kind+" 9 "+e.protocol+" "+t.protocol+"\r\n","c=IN IP4 0.0.0.0\r\n","a=sctp-port:"+t.port+"\r\n"]:["m="+e.kind+" 9 "+e.protocol+" "+t.port+"\r\n","c=IN IP4 0.0.0.0\r\n","a=sctpmap:"+t.port+" "+t.protocol+" 65535\r\n"],void 0!==t.maxMessageSize&&n.push("a=max-message-size:"+t.maxMessageSize+"\r\n"),n.join("");},t.generateSessionId=function(){return Math.random().toString().substr(2,21);},t.writeSessionBoilerplate=function(e,n,i){var r=void 0!==n?n:2;return"v=0\r\no="+(i||"thisisadapterortc")+" "+(e||t.generateSessionId())+" "+r+" IN IP4 127.0.0.1\r\ns=-\r\nt=0 0\r\n";},t.writeMediaSection=function(e,n,i,r){var a=t.writeRtpDescription(e.kind,n);if(a+=t.writeIceParameters(e.iceGatherer.getLocalParameters()),a+=t.writeDtlsParameters(e.dtlsTransport.getLocalParameters(),"offer"===i?"actpass":"active"),a+="a=mid:"+e.mid+"\r\n",e.direction?a+="a="+e.direction+"\r\n":e.rtpSender&&e.rtpReceiver?a+="a=sendrecv\r\n":e.rtpSender?a+="a=sendonly\r\n":e.rtpReceiver?a+="a=recvonly\r\n":a+="a=inactive\r\n",e.rtpSender){var o="msid:"+r.id+" "+e.rtpSender.track.id+"\r\n";a+="a="+o,a+="a=ssrc:"+e.sendEncodingParameters[0].ssrc+" "+o,e.sendEncodingParameters[0].rtx&&(a+="a=ssrc:"+e.sendEncodingParameters[0].rtx.ssrc+" "+o,a+="a=ssrc-group:FID "+e.sendEncodingParameters[0].ssrc+" "+e.sendEncodingParameters[0].rtx.ssrc+"\r\n");}return a+="a=ssrc:"+e.sendEncodingParameters[0].ssrc+" cname:"+t.localCName+"\r\n",e.rtpSender&&e.sendEncodingParameters[0].rtx&&(a+="a=ssrc:"+e.sendEncodingParameters[0].rtx.ssrc+" cname:"+t.localCName+"\r\n"),a;},t.getDirection=function(e,n){for(var i=t.splitLines(e),r=0;r<i.length;r++){switch(i[r]){case"a=sendrecv":case"a=sendonly":case"a=recvonly":case"a=inactive":return i[r].substr(2);}}return n?t.getDirection(n):"sendrecv";},t.getKind=function(e){return t.splitLines(e)[0].split(" ")[0].substr(2);},t.isRejected=function(e){return"0"===e.split(" ",2)[1];},t.parseMLine=function(e){var n=t.splitLines(e)[0].substr(2).split(" ");return{kind:n[0],port:parseInt(n[1],10),protocol:n[2],fmt:n.slice(3).join(" ")};},t.parseOLine=function(e){var n=t.matchPrefix(e,"o=")[0].substr(2).split(" ");return{username:n[0],sessionId:n[1],sessionVersion:parseInt(n[2],10),netType:n[3],addressType:n[4],address:n[5]};},t.isValidSDP=function(e){if("string"!=typeof e||0===e.length)return!1;for(var n=t.splitLines(e),i=0;i<n.length;i++){if(n[i].length<2||"="!==n[i].charAt(1))return!1;}return!0;},e.exports=t;}(Za);var eo=Za.exports,to=Za.exports;function no(e,t,n,i,r){var a=to.writeRtpDescription(e.kind,t);if(a+=to.writeIceParameters(e.iceGatherer.getLocalParameters()),a+=to.writeDtlsParameters(e.dtlsTransport.getLocalParameters(),"offer"===n?"actpass":r||"active"),a+="a=mid:"+e.mid+"\r\n",e.rtpSender&&e.rtpReceiver?a+="a=sendrecv\r\n":e.rtpSender?a+="a=sendonly\r\n":e.rtpReceiver?a+="a=recvonly\r\n":a+="a=inactive\r\n",e.rtpSender){var o=e.rtpSender._initialTrackId||e.rtpSender.track.id;e.rtpSender._initialTrackId=o;var s="msid:"+(i?i.id:"-")+" "+o+"\r\n";a+="a="+s,a+="a=ssrc:"+e.sendEncodingParameters[0].ssrc+" "+s,e.sendEncodingParameters[0].rtx&&(a+="a=ssrc:"+e.sendEncodingParameters[0].rtx.ssrc+" "+s,a+="a=ssrc-group:FID "+e.sendEncodingParameters[0].ssrc+" "+e.sendEncodingParameters[0].rtx.ssrc+"\r\n");}return a+="a=ssrc:"+e.sendEncodingParameters[0].ssrc+" cname:"+to.localCName+"\r\n",e.rtpSender&&e.sendEncodingParameters[0].rtx&&(a+="a=ssrc:"+e.sendEncodingParameters[0].rtx.ssrc+" cname:"+to.localCName+"\r\n"),a;}function io(e,t){var n={codecs:[],headerExtensions:[],fecMechanisms:[]},i=function i(e,t){e=parseInt(e,10);for(var n=0;n<t.length;n++){if(t[n].payloadType===e||t[n].preferredPayloadType===e)return t[n];}},r=function r(e,t,n,_r3){var a=i(e.parameters.apt,n),o=i(t.parameters.apt,_r3);return a&&o&&a.name.toLowerCase()===o.name.toLowerCase();};return e.codecs.forEach(function(i){for(var a=0;a<t.codecs.length;a++){var o=t.codecs[a];if(i.name.toLowerCase()===o.name.toLowerCase()&&i.clockRate===o.clockRate){if("rtx"===i.name.toLowerCase()&&i.parameters&&o.parameters.apt&&!r(i,o,e.codecs,t.codecs))continue;(o=JSON.parse(JSON.stringify(o))).numChannels=Math.min(i.numChannels,o.numChannels),n.codecs.push(o),o.rtcpFeedback=o.rtcpFeedback.filter(function(e){for(var t=0;t<i.rtcpFeedback.length;t++){if(i.rtcpFeedback[t].type===e.type&&i.rtcpFeedback[t].parameter===e.parameter)return!0;}return!1;});break;}}}),e.headerExtensions.forEach(function(e){for(var i=0;i<t.headerExtensions.length;i++){var r=t.headerExtensions[i];if(e.uri===r.uri){n.headerExtensions.push(r);break;}}}),n;}function ro(e,t,n){return-1!=={offer:{setLocalDescription:["stable","have-local-offer"],setRemoteDescription:["stable","have-remote-offer"]},answer:{setLocalDescription:["have-remote-offer","have-local-pranswer"],setRemoteDescription:["have-local-offer","have-remote-pranswer"]}}[t][e].indexOf(n);}function ao(e,t){var n=e.getRemoteCandidates().find(function(e){return t.foundation===e.foundation&&t.ip===e.ip&&t.port===e.port&&t.priority===e.priority&&t.protocol===e.protocol&&t.type===e.type;});return n||e.addRemoteCandidate(t),!n;}function oo(e,t){var n=new Error(t);return n.name=e,n.code={NotSupportedError:9,InvalidStateError:11,InvalidAccessError:15,TypeError:void 0,OperationError:void 0}[e],n;}var so=function so(e,t){function n(t,n){n.addTrack(t),n.dispatchEvent(new e.MediaStreamTrackEvent("addtrack",{track:t}));}function i(t,n,i,r){var a=new Event("track");a.track=n,a.receiver=i,a.transceiver={receiver:i},a.streams=r,e.setTimeout(function(){t._dispatchEvent("track",a);});}var r=function r(n){var i=this,r=document.createDocumentFragment();if(["addEventListener","removeEventListener","dispatchEvent"].forEach(function(e){i[e]=r[e].bind(r);}),this.canTrickleIceCandidates=null,this.needNegotiation=!1,this.localStreams=[],this.remoteStreams=[],this._localDescription=null,this._remoteDescription=null,this.signalingState="stable",this.iceConnectionState="new",this.connectionState="new",this.iceGatheringState="new",n=JSON.parse(JSON.stringify(n||{})),this.usingBundle="max-bundle"===n.bundlePolicy,"negotiate"===n.rtcpMuxPolicy)throw oo("NotSupportedError","rtcpMuxPolicy 'negotiate' is not supported");switch(n.rtcpMuxPolicy||(n.rtcpMuxPolicy="require"),n.iceTransportPolicy){case"all":case"relay":break;default:n.iceTransportPolicy="all";}switch(n.bundlePolicy){case"balanced":case"max-compat":case"max-bundle":break;default:n.bundlePolicy="balanced";}if(n.iceServers=function(e,t){var n=!1;return(e=JSON.parse(JSON.stringify(e))).filter(function(e){if(e&&(e.urls||e.url)){var i=e.urls||e.url;e.url&&!e.urls&&console.warn("RTCIceServer.url is deprecated! Use urls instead.");var r="string"==typeof i;return r&&(i=[i]),i=i.filter(function(e){return 0!==e.indexOf("turn:")||-1===e.indexOf("transport=udp")||-1!==e.indexOf("turn:[")||n?0===e.indexOf("stun:")&&t>=14393&&-1===e.indexOf("?transport=udp"):(n=!0,!0);}),delete e.url,e.urls=r?i[0]:i,!!i.length;}});}(n.iceServers||[],t),this._iceGatherers=[],n.iceCandidatePoolSize)for(var a=n.iceCandidatePoolSize;a>0;a--){this._iceGatherers.push(new e.RTCIceGatherer({iceServers:n.iceServers,gatherPolicy:n.iceTransportPolicy}));}else n.iceCandidatePoolSize=0;this._config=n,this.transceivers=[],this._sdpSessionId=to.generateSessionId(),this._sdpSessionVersion=0,this._dtlsRole=void 0,this._isClosed=!1;};Object.defineProperty(r.prototype,"localDescription",{configurable:!0,get:function get(){return this._localDescription;}}),Object.defineProperty(r.prototype,"remoteDescription",{configurable:!0,get:function get(){return this._remoteDescription;}}),r.prototype.onicecandidate=null,r.prototype.onaddstream=null,r.prototype.ontrack=null,r.prototype.onremovestream=null,r.prototype.onsignalingstatechange=null,r.prototype.oniceconnectionstatechange=null,r.prototype.onconnectionstatechange=null,r.prototype.onicegatheringstatechange=null,r.prototype.onnegotiationneeded=null,r.prototype.ondatachannel=null,r.prototype._dispatchEvent=function(e,t){this._isClosed||(this.dispatchEvent(t),"function"==typeof this["on"+e]&&this["on"+e](t));},r.prototype._emitGatheringStateChange=function(){var e=new Event("icegatheringstatechange");this._dispatchEvent("icegatheringstatechange",e);},r.prototype.getConfiguration=function(){return this._config;},r.prototype.getLocalStreams=function(){return this.localStreams;},r.prototype.getRemoteStreams=function(){return this.remoteStreams;},r.prototype._createTransceiver=function(e,t){var n=this.transceivers.length>0,i={track:null,iceGatherer:null,iceTransport:null,dtlsTransport:null,localCapabilities:null,remoteCapabilities:null,rtpSender:null,rtpReceiver:null,kind:e,mid:null,sendEncodingParameters:null,recvEncodingParameters:null,stream:null,associatedRemoteMediaStreams:[],wantReceive:!0};if(this.usingBundle&&n)i.iceTransport=this.transceivers[0].iceTransport,i.dtlsTransport=this.transceivers[0].dtlsTransport;else{var r=this._createIceAndDtlsTransports();i.iceTransport=r.iceTransport,i.dtlsTransport=r.dtlsTransport;}return t||this.transceivers.push(i),i;},r.prototype.addTrack=function(t,n){if(this._isClosed)throw oo("InvalidStateError","Attempted to call addTrack on a closed peerconnection.");var i;if(this.transceivers.find(function(e){return e.track===t;}))throw oo("InvalidAccessError","Track already exists.");for(var r=0;r<this.transceivers.length;r++){this.transceivers[r].track||this.transceivers[r].kind!==t.kind||(i=this.transceivers[r]);}return i||(i=this._createTransceiver(t.kind)),this._maybeFireNegotiationNeeded(),-1===this.localStreams.indexOf(n)&&this.localStreams.push(n),i.track=t,i.stream=n,i.rtpSender=new e.RTCRtpSender(t,i.dtlsTransport),i.rtpSender;},r.prototype.addStream=function(e){var n=this;if(t>=15025)e.getTracks().forEach(function(t){n.addTrack(t,e);});else{var i=e.clone();e.getTracks().forEach(function(e,t){var n=i.getTracks()[t];e.addEventListener("enabled",function(e){n.enabled=e.enabled;});}),i.getTracks().forEach(function(e){n.addTrack(e,i);});}},r.prototype.removeTrack=function(t){if(this._isClosed)throw oo("InvalidStateError","Attempted to call removeTrack on a closed peerconnection.");if(!(t instanceof e.RTCRtpSender))throw new TypeError("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.");var n=this.transceivers.find(function(e){return e.rtpSender===t;});if(!n)throw oo("InvalidAccessError","Sender was not created by this connection.");var i=n.stream;n.rtpSender.stop(),n.rtpSender=null,n.track=null,n.stream=null,-1===this.transceivers.map(function(e){return e.stream;}).indexOf(i)&&this.localStreams.indexOf(i)>-1&&this.localStreams.splice(this.localStreams.indexOf(i),1),this._maybeFireNegotiationNeeded();},r.prototype.removeStream=function(e){var t=this;e.getTracks().forEach(function(e){var n=t.getSenders().find(function(t){return t.track===e;});n&&t.removeTrack(n);});},r.prototype.getSenders=function(){return this.transceivers.filter(function(e){return!!e.rtpSender;}).map(function(e){return e.rtpSender;});},r.prototype.getReceivers=function(){return this.transceivers.filter(function(e){return!!e.rtpReceiver;}).map(function(e){return e.rtpReceiver;});},r.prototype._createIceGatherer=function(t,n){var i=this;if(n&&t>0)return this.transceivers[0].iceGatherer;if(this._iceGatherers.length)return this._iceGatherers.shift();var r=new e.RTCIceGatherer({iceServers:this._config.iceServers,gatherPolicy:this._config.iceTransportPolicy});return Object.defineProperty(r,"state",{value:"new",writable:!0}),this.transceivers[t].bufferedCandidateEvents=[],this.transceivers[t].bufferCandidates=function(e){var n=!e.candidate||0===Object.keys(e.candidate).length;r.state=n?"completed":"gathering",null!==i.transceivers[t].bufferedCandidateEvents&&i.transceivers[t].bufferedCandidateEvents.push(e);},r.addEventListener("localcandidate",this.transceivers[t].bufferCandidates),r;},r.prototype._gather=function(t,n){var i=this,r=this.transceivers[n].iceGatherer;if(!r.onlocalcandidate){var a=this.transceivers[n].bufferedCandidateEvents;this.transceivers[n].bufferedCandidateEvents=null,r.removeEventListener("localcandidate",this.transceivers[n].bufferCandidates),r.onlocalcandidate=function(e){if(!(i.usingBundle&&n>0)){var a=new Event("icecandidate");a.candidate={sdpMid:t,sdpMLineIndex:n};var o=e.candidate,s=!o||0===Object.keys(o).length;if(s)"new"!==r.state&&"gathering"!==r.state||(r.state="completed");else{"new"===r.state&&(r.state="gathering"),o.component=1,o.ufrag=r.getLocalParameters().usernameFragment;var c=to.writeCandidate(o);a.candidate=Object.assign(a.candidate,to.parseCandidate(c)),a.candidate.candidate=c,a.candidate.toJSON=function(){return{candidate:a.candidate.candidate,sdpMid:a.candidate.sdpMid,sdpMLineIndex:a.candidate.sdpMLineIndex,usernameFragment:a.candidate.usernameFragment};};}var u=to.getMediaSections(i._localDescription.sdp);u[a.candidate.sdpMLineIndex]+=s?"a=end-of-candidates\r\n":"a="+a.candidate.candidate+"\r\n",i._localDescription.sdp=to.getDescription(i._localDescription.sdp)+u.join("");var d=i.transceivers.every(function(e){return e.iceGatherer&&"completed"===e.iceGatherer.state;});"gathering"!==i.iceGatheringState&&(i.iceGatheringState="gathering",i._emitGatheringStateChange()),s||i._dispatchEvent("icecandidate",a),d&&(i._dispatchEvent("icecandidate",new Event("icecandidate")),i.iceGatheringState="complete",i._emitGatheringStateChange());}},e.setTimeout(function(){a.forEach(function(e){r.onlocalcandidate(e);});},0);}},r.prototype._createIceAndDtlsTransports=function(){var t=this,n=new e.RTCIceTransport(null);n.onicestatechange=function(){t._updateIceConnectionState(),t._updateConnectionState();};var i=new e.RTCDtlsTransport(n);return i.ondtlsstatechange=function(){t._updateConnectionState();},i.onerror=function(){Object.defineProperty(i,"state",{value:"failed",writable:!0}),t._updateConnectionState();},{iceTransport:n,dtlsTransport:i};},r.prototype._disposeIceAndDtlsTransports=function(e){var t=this.transceivers[e].iceGatherer;t&&(delete t.onlocalcandidate,delete this.transceivers[e].iceGatherer);var n=this.transceivers[e].iceTransport;n&&(delete n.onicestatechange,delete this.transceivers[e].iceTransport);var i=this.transceivers[e].dtlsTransport;i&&(delete i.ondtlsstatechange,delete i.onerror,delete this.transceivers[e].dtlsTransport);},r.prototype._transceive=function(e,n,i){var r=io(e.localCapabilities,e.remoteCapabilities);n&&e.rtpSender&&(r.encodings=e.sendEncodingParameters,r.rtcp={cname:to.localCName,compound:e.rtcpParameters.compound},e.recvEncodingParameters.length&&(r.rtcp.ssrc=e.recvEncodingParameters[0].ssrc),e.rtpSender.send(r)),i&&e.rtpReceiver&&r.codecs.length>0&&("video"===e.kind&&e.recvEncodingParameters&&t<15019&&e.recvEncodingParameters.forEach(function(e){delete e.rtx;}),e.recvEncodingParameters.length?r.encodings=e.recvEncodingParameters:r.encodings=[{}],r.rtcp={compound:e.rtcpParameters.compound},e.rtcpParameters.cname&&(r.rtcp.cname=e.rtcpParameters.cname),e.sendEncodingParameters.length&&(r.rtcp.ssrc=e.sendEncodingParameters[0].ssrc),e.rtpReceiver.receive(r));},r.prototype.setLocalDescription=function(e){var t,n,i=this;if(-1===["offer","answer"].indexOf(e.type))return Promise.reject(oo("TypeError",'Unsupported type "'+e.type+'"'));if(!ro("setLocalDescription",e.type,i.signalingState)||i._isClosed)return Promise.reject(oo("InvalidStateError","Can not set local "+e.type+" in state "+i.signalingState));if("offer"===e.type)t=to.splitSections(e.sdp),n=t.shift(),t.forEach(function(e,t){var n=to.parseRtpParameters(e);i.transceivers[t].localCapabilities=n;}),i.transceivers.forEach(function(e,t){i._gather(e.mid,t);});else if("answer"===e.type){t=to.splitSections(i._remoteDescription.sdp),n=t.shift();var r=to.matchPrefix(n,"a=ice-lite").length>0;t.forEach(function(e,t){var a=i.transceivers[t],o=a.iceGatherer,s=a.iceTransport,c=a.dtlsTransport,u=a.localCapabilities,d=a.remoteCapabilities;if(!(to.isRejected(e)&&0===to.matchPrefix(e,"a=bundle-only").length)&&!a.rejected){var l=to.getIceParameters(e,n),h=to.getDtlsParameters(e,n);r&&(h.role="server"),i.usingBundle&&0!==t||(i._gather(a.mid,t),"new"===s.state&&s.start(o,l,r?"controlling":"controlled"),"new"===c.state&&c.start(h));var p=io(u,d);i._transceive(a,p.codecs.length>0,!1);}});}return i._localDescription={type:e.type,sdp:e.sdp},"offer"===e.type?i._updateSignalingState("have-local-offer"):i._updateSignalingState("stable"),Promise.resolve();},r.prototype.setRemoteDescription=function(r){var a=this;if(-1===["offer","answer"].indexOf(r.type))return Promise.reject(oo("TypeError",'Unsupported type "'+r.type+'"'));if(!ro("setRemoteDescription",r.type,a.signalingState)||a._isClosed)return Promise.reject(oo("InvalidStateError","Can not set remote "+r.type+" in state "+a.signalingState));var o={};a.remoteStreams.forEach(function(e){o[e.id]=e;});var s=[],c=to.splitSections(r.sdp),u=c.shift(),d=to.matchPrefix(u,"a=ice-lite").length>0,l=to.matchPrefix(u,"a=group:BUNDLE ").length>0;a.usingBundle=l;var h=to.matchPrefix(u,"a=ice-options:")[0];return a.canTrickleIceCandidates=!!h&&h.substr(14).split(" ").indexOf("trickle")>=0,c.forEach(function(i,c){var h=to.splitLines(i),p=to.getKind(i),f=to.isRejected(i)&&0===to.matchPrefix(i,"a=bundle-only").length,m=h[0].substr(2).split(" ")[2],_=to.getDirection(i,u),v=to.parseMsid(i),g=to.getMid(i)||to.generateIdentifier();if(f||"application"===p&&("DTLS/SCTP"===m||"UDP/DTLS/SCTP"===m))a.transceivers[c]={mid:g,kind:p,protocol:m,rejected:!0};else{var y,S,k,b,T,I,E,w,R;!f&&a.transceivers[c]&&a.transceivers[c].rejected&&(a.transceivers[c]=a._createTransceiver(p,!0));var C,A,x=to.parseRtpParameters(i);f||(C=to.getIceParameters(i,u),(A=to.getDtlsParameters(i,u)).role="client"),E=to.parseRtpEncodingParameters(i);var P=to.parseRtcpParameters(i),D=to.matchPrefix(i,"a=end-of-candidates",u).length>0,O=to.matchPrefix(i,"a=candidate:").map(function(e){return to.parseCandidate(e);}).filter(function(e){return 1===e.component;});if(("offer"===r.type||"answer"===r.type)&&!f&&l&&c>0&&a.transceivers[c]&&(a._disposeIceAndDtlsTransports(c),a.transceivers[c].iceGatherer=a.transceivers[0].iceGatherer,a.transceivers[c].iceTransport=a.transceivers[0].iceTransport,a.transceivers[c].dtlsTransport=a.transceivers[0].dtlsTransport,a.transceivers[c].rtpSender&&a.transceivers[c].rtpSender.setTransport(a.transceivers[0].dtlsTransport),a.transceivers[c].rtpReceiver&&a.transceivers[c].rtpReceiver.setTransport(a.transceivers[0].dtlsTransport)),"offer"!==r.type||f){if("answer"===r.type&&!f){S=(y=a.transceivers[c]).iceGatherer,k=y.iceTransport,b=y.dtlsTransport,T=y.rtpReceiver,I=y.sendEncodingParameters,w=y.localCapabilities,a.transceivers[c].recvEncodingParameters=E,a.transceivers[c].remoteCapabilities=x,a.transceivers[c].rtcpParameters=P,O.length&&"new"===k.state&&(!d&&!D||l&&0!==c?O.forEach(function(e){ao(y.iceTransport,e);}):k.setRemoteCandidates(O)),l&&0!==c||("new"===k.state&&k.start(S,C,"controlling"),"new"===b.state&&b.start(A)),!io(y.localCapabilities,y.remoteCapabilities).codecs.filter(function(e){return"rtx"===e.name.toLowerCase();}).length&&y.sendEncodingParameters[0].rtx&&delete y.sendEncodingParameters[0].rtx,a._transceive(y,"sendrecv"===_||"recvonly"===_,"sendrecv"===_||"sendonly"===_),!T||"sendrecv"!==_&&"sendonly"!==_?delete y.rtpReceiver:(R=T.track,v?(o[v.stream]||(o[v.stream]=new e.MediaStream()),n(R,o[v.stream]),s.push([R,T,o[v.stream]])):(o.default||(o.default=new e.MediaStream()),n(R,o.default),s.push([R,T,o.default])));}}else{(y=a.transceivers[c]||a._createTransceiver(p)).mid=g,y.iceGatherer||(y.iceGatherer=a._createIceGatherer(c,l)),O.length&&"new"===y.iceTransport.state&&(!D||l&&0!==c?O.forEach(function(e){ao(y.iceTransport,e);}):y.iceTransport.setRemoteCandidates(O)),w=e.RTCRtpReceiver.getCapabilities(p),t<15019&&(w.codecs=w.codecs.filter(function(e){return"rtx"!==e.name;})),I=y.sendEncodingParameters||[{ssrc:1001*(2*c+2)}];var N,M=!1;if("sendrecv"===_||"sendonly"===_){if(M=!y.rtpReceiver,T=y.rtpReceiver||new e.RTCRtpReceiver(y.dtlsTransport,p),M)R=T.track,v&&"-"===v.stream||(v?(o[v.stream]||(o[v.stream]=new e.MediaStream(),Object.defineProperty(o[v.stream],"id",{get:function get(){return v.stream;}})),Object.defineProperty(R,"id",{get:function get(){return v.track;}}),N=o[v.stream]):(o.default||(o.default=new e.MediaStream()),N=o.default)),N&&(n(R,N),y.associatedRemoteMediaStreams.push(N)),s.push([R,T,N]);}else y.rtpReceiver&&y.rtpReceiver.track&&(y.associatedRemoteMediaStreams.forEach(function(t){var n=t.getTracks().find(function(e){return e.id===y.rtpReceiver.track.id;});n&&function(t,n){n.removeTrack(t),n.dispatchEvent(new e.MediaStreamTrackEvent("removetrack",{track:t}));}(n,t);}),y.associatedRemoteMediaStreams=[]);y.localCapabilities=w,y.remoteCapabilities=x,y.rtpReceiver=T,y.rtcpParameters=P,y.sendEncodingParameters=I,y.recvEncodingParameters=E,a._transceive(a.transceivers[c],!1,M);}}}),void 0===a._dtlsRole&&(a._dtlsRole="offer"===r.type?"active":"passive"),a._remoteDescription={type:r.type,sdp:r.sdp},"offer"===r.type?a._updateSignalingState("have-remote-offer"):a._updateSignalingState("stable"),Object.keys(o).forEach(function(t){var n=o[t];if(n.getTracks().length){if(-1===a.remoteStreams.indexOf(n)){a.remoteStreams.push(n);var r=new Event("addstream");r.stream=n,e.setTimeout(function(){a._dispatchEvent("addstream",r);});}s.forEach(function(e){var t=e[0],r=e[1];n.id===e[2].id&&i(a,t,r,[n]);});}}),s.forEach(function(e){e[2]||i(a,e[0],e[1],[]);}),e.setTimeout(function(){a&&a.transceivers&&a.transceivers.forEach(function(e){e.iceTransport&&"new"===e.iceTransport.state&&e.iceTransport.getRemoteCandidates().length>0&&(console.warn("Timeout for addRemoteCandidate. Consider sending an end-of-candidates notification"),e.iceTransport.addRemoteCandidate({}));});},4e3),Promise.resolve();},r.prototype.close=function(){this.transceivers.forEach(function(e){e.iceTransport&&e.iceTransport.stop(),e.dtlsTransport&&e.dtlsTransport.stop(),e.rtpSender&&e.rtpSender.stop(),e.rtpReceiver&&e.rtpReceiver.stop();}),this._isClosed=!0,this._updateSignalingState("closed");},r.prototype._updateSignalingState=function(e){this.signalingState=e;var t=new Event("signalingstatechange");this._dispatchEvent("signalingstatechange",t);},r.prototype._maybeFireNegotiationNeeded=function(){var t=this;"stable"===this.signalingState&&!0!==this.needNegotiation&&(this.needNegotiation=!0,e.setTimeout(function(){if(t.needNegotiation){t.needNegotiation=!1;var e=new Event("negotiationneeded");t._dispatchEvent("negotiationneeded",e);}},0));},r.prototype._updateIceConnectionState=function(){var e,t={new:0,closed:0,checking:0,connected:0,completed:0,disconnected:0,failed:0};if(this.transceivers.forEach(function(e){e.iceTransport&&!e.rejected&&t[e.iceTransport.state]++;}),e="new",t.failed>0?e="failed":t.checking>0?e="checking":t.disconnected>0?e="disconnected":t.new>0?e="new":t.connected>0?e="connected":t.completed>0&&(e="completed"),e!==this.iceConnectionState){this.iceConnectionState=e;var n=new Event("iceconnectionstatechange");this._dispatchEvent("iceconnectionstatechange",n);}},r.prototype._updateConnectionState=function(){var e,t={new:0,closed:0,connecting:0,connected:0,completed:0,disconnected:0,failed:0};if(this.transceivers.forEach(function(e){e.iceTransport&&e.dtlsTransport&&!e.rejected&&(t[e.iceTransport.state]++,t[e.dtlsTransport.state]++);}),t.connected+=t.completed,e="new",t.failed>0?e="failed":t.connecting>0?e="connecting":t.disconnected>0?e="disconnected":t.new>0?e="new":t.connected>0&&(e="connected"),e!==this.connectionState){this.connectionState=e;var n=new Event("connectionstatechange");this._dispatchEvent("connectionstatechange",n);}},r.prototype.createOffer=function(){var n=this;if(n._isClosed)return Promise.reject(oo("InvalidStateError","Can not call createOffer after close"));var i=n.transceivers.filter(function(e){return"audio"===e.kind;}).length,r=n.transceivers.filter(function(e){return"video"===e.kind;}).length,a=arguments[0];if(a){if(a.mandatory||a.optional)throw new TypeError("Legacy mandatory/optional constraints not supported.");void 0!==a.offerToReceiveAudio&&(i=!0===a.offerToReceiveAudio?1:!1===a.offerToReceiveAudio?0:a.offerToReceiveAudio),void 0!==a.offerToReceiveVideo&&(r=!0===a.offerToReceiveVideo?1:!1===a.offerToReceiveVideo?0:a.offerToReceiveVideo);}for(n.transceivers.forEach(function(e){"audio"===e.kind?--i<0&&(e.wantReceive=!1):"video"===e.kind&&--r<0&&(e.wantReceive=!1);});i>0||r>0;){i>0&&(n._createTransceiver("audio"),i--),r>0&&(n._createTransceiver("video"),r--);}var o=to.writeSessionBoilerplate(n._sdpSessionId,n._sdpSessionVersion++);n.transceivers.forEach(function(i,r){var a=i.track,o=i.kind,s=i.mid||to.generateIdentifier();i.mid=s,i.iceGatherer||(i.iceGatherer=n._createIceGatherer(r,n.usingBundle));var c=e.RTCRtpSender.getCapabilities(o);t<15019&&(c.codecs=c.codecs.filter(function(e){return"rtx"!==e.name;})),c.codecs.forEach(function(e){"H264"===e.name&&void 0===e.parameters["level-asymmetry-allowed"]&&(e.parameters["level-asymmetry-allowed"]="1"),i.remoteCapabilities&&i.remoteCapabilities.codecs&&i.remoteCapabilities.codecs.forEach(function(t){e.name.toLowerCase()===t.name.toLowerCase()&&e.clockRate===t.clockRate&&(e.preferredPayloadType=t.payloadType);});}),c.headerExtensions.forEach(function(e){(i.remoteCapabilities&&i.remoteCapabilities.headerExtensions||[]).forEach(function(t){e.uri===t.uri&&(e.id=t.id);});});var u=i.sendEncodingParameters||[{ssrc:1001*(2*r+1)}];a&&t>=15019&&"video"===o&&!u[0].rtx&&(u[0].rtx={ssrc:u[0].ssrc+1}),i.wantReceive&&(i.rtpReceiver=new e.RTCRtpReceiver(i.dtlsTransport,o)),i.localCapabilities=c,i.sendEncodingParameters=u;}),"max-compat"!==n._config.bundlePolicy&&(o+="a=group:BUNDLE "+n.transceivers.map(function(e){return e.mid;}).join(" ")+"\r\n"),o+="a=ice-options:trickle\r\n",n.transceivers.forEach(function(e,t){o+=no(e,e.localCapabilities,"offer",e.stream,n._dtlsRole),o+="a=rtcp-rsize\r\n",!e.iceGatherer||"new"===n.iceGatheringState||0!==t&&n.usingBundle||(e.iceGatherer.getLocalCandidates().forEach(function(e){e.component=1,o+="a="+to.writeCandidate(e)+"\r\n";}),"completed"===e.iceGatherer.state&&(o+="a=end-of-candidates\r\n"));});var s=new e.RTCSessionDescription({type:"offer",sdp:o});return Promise.resolve(s);},r.prototype.createAnswer=function(){var n=this;if(n._isClosed)return Promise.reject(oo("InvalidStateError","Can not call createAnswer after close"));if("have-remote-offer"!==n.signalingState&&"have-local-pranswer"!==n.signalingState)return Promise.reject(oo("InvalidStateError","Can not call createAnswer in signalingState "+n.signalingState));var i=to.writeSessionBoilerplate(n._sdpSessionId,n._sdpSessionVersion++);n.usingBundle&&(i+="a=group:BUNDLE "+n.transceivers.map(function(e){return e.mid;}).join(" ")+"\r\n"),i+="a=ice-options:trickle\r\n";var r=to.getMediaSections(n._remoteDescription.sdp).length;n.transceivers.forEach(function(e,a){if(!(a+1>r)){if(e.rejected)return"application"===e.kind?"DTLS/SCTP"===e.protocol?i+="m=application 0 DTLS/SCTP 5000\r\n":i+="m=application 0 "+e.protocol+" webrtc-datachannel\r\n":"audio"===e.kind?i+="m=audio 0 UDP/TLS/RTP/SAVPF 0\r\na=rtpmap:0 PCMU/8000\r\n":"video"===e.kind&&(i+="m=video 0 UDP/TLS/RTP/SAVPF 120\r\na=rtpmap:120 VP8/90000\r\n"),void(i+="c=IN IP4 0.0.0.0\r\na=inactive\r\na=mid:"+e.mid+"\r\n");var o;if(e.stream)"audio"===e.kind?o=e.stream.getAudioTracks()[0]:"video"===e.kind&&(o=e.stream.getVideoTracks()[0]),o&&t>=15019&&"video"===e.kind&&!e.sendEncodingParameters[0].rtx&&(e.sendEncodingParameters[0].rtx={ssrc:e.sendEncodingParameters[0].ssrc+1});var s=io(e.localCapabilities,e.remoteCapabilities);!s.codecs.filter(function(e){return"rtx"===e.name.toLowerCase();}).length&&e.sendEncodingParameters[0].rtx&&delete e.sendEncodingParameters[0].rtx,i+=no(e,s,"answer",e.stream,n._dtlsRole),e.rtcpParameters&&e.rtcpParameters.reducedSize&&(i+="a=rtcp-rsize\r\n");}});var a=new e.RTCSessionDescription({type:"answer",sdp:i});return Promise.resolve(a);},r.prototype.addIceCandidate=function(e){var t,n=this;return e&&void 0===e.sdpMLineIndex&&!e.sdpMid?Promise.reject(new TypeError("sdpMLineIndex or sdpMid required")):new Promise(function(i,r){if(!n._remoteDescription)return r(oo("InvalidStateError","Can not add ICE candidate without a remote description"));if(e&&""!==e.candidate){var a=e.sdpMLineIndex;if(e.sdpMid)for(var o=0;o<n.transceivers.length;o++){if(n.transceivers[o].mid===e.sdpMid){a=o;break;}}var s=n.transceivers[a];if(!s)return r(oo("OperationError","Can not add ICE candidate"));if(s.rejected)return i();var c=Object.keys(e.candidate).length>0?to.parseCandidate(e.candidate):{};if("tcp"===c.protocol&&(0===c.port||9===c.port))return i();if(c.component&&1!==c.component)return i();if((0===a||a>0&&s.iceTransport!==n.transceivers[0].iceTransport)&&!ao(s.iceTransport,c))return r(oo("OperationError","Can not add ICE candidate"));var u=e.candidate.trim();0===u.indexOf("a=")&&(u=u.substr(2)),(t=to.getMediaSections(n._remoteDescription.sdp))[a]+="a="+(c.type?u:"end-of-candidates")+"\r\n",n._remoteDescription.sdp=to.getDescription(n._remoteDescription.sdp)+t.join("");}else for(var d=0;d<n.transceivers.length&&(n.transceivers[d].rejected||(n.transceivers[d].iceTransport.addRemoteCandidate({}),(t=to.getMediaSections(n._remoteDescription.sdp))[d]+="a=end-of-candidates\r\n",n._remoteDescription.sdp=to.getDescription(n._remoteDescription.sdp)+t.join(""),!n.usingBundle));d++){}i();});},r.prototype.getStats=function(t){if(t&&t instanceof e.MediaStreamTrack){var n=null;if(this.transceivers.forEach(function(e){e.rtpSender&&e.rtpSender.track===t?n=e.rtpSender:e.rtpReceiver&&e.rtpReceiver.track===t&&(n=e.rtpReceiver);}),!n)throw oo("InvalidAccessError","Invalid selector.");return n.getStats();}var i=[];return this.transceivers.forEach(function(e){["rtpSender","rtpReceiver","iceGatherer","iceTransport","dtlsTransport"].forEach(function(t){e[t]&&i.push(e[t].getStats());});}),Promise.all(i).then(function(e){var t=new Map();return e.forEach(function(e){e.forEach(function(e){t.set(e.id,e);});}),t;});};["RTCRtpSender","RTCRtpReceiver","RTCIceGatherer","RTCIceTransport","RTCDtlsTransport"].forEach(function(t){var n=e[t];if(n&&n.prototype&&n.prototype.getStats){var i=n.prototype.getStats;n.prototype.getStats=function(){return i.apply(this).then(function(e){var t=new Map();return Object.keys(e).forEach(function(n){var i;e[n].type={inboundrtp:"inbound-rtp",outboundrtp:"outbound-rtp",candidatepair:"candidate-pair",localcandidate:"local-candidate",remotecandidate:"remote-candidate"}[(i=e[n]).type]||i.type,t.set(n,e[n]);}),t;});};}});var a=["createOffer","createAnswer"];return a.forEach(function(e){var t=r.prototype[e];r.prototype[e]=function(){var e=arguments;return"function"==typeof e[0]||"function"==typeof e[1]?t.apply(this,[arguments[2]]).then(function(t){"function"==typeof e[0]&&e[0].apply(null,[t]);},function(t){"function"==typeof e[1]&&e[1].apply(null,[t]);}):t.apply(this,arguments);};}),(a=["setLocalDescription","setRemoteDescription","addIceCandidate"]).forEach(function(e){var t=r.prototype[e];r.prototype[e]=function(){var e=arguments;return"function"==typeof e[1]||"function"==typeof e[2]?t.apply(this,arguments).then(function(){"function"==typeof e[1]&&e[1].apply(null);},function(t){"function"==typeof e[2]&&e[2].apply(null,[t]);}):t.apply(this,arguments);};}),["getStats"].forEach(function(e){var t=r.prototype[e];r.prototype[e]=function(){var e=arguments;return"function"==typeof e[1]?t.apply(this,arguments).then(function(){"function"==typeof e[1]&&e[1].apply(null);}):t.apply(this,arguments);};}),r;};function co(e){var t=e&&e.navigator,n=t.mediaDevices.getUserMedia.bind(t.mediaDevices);t.mediaDevices.getUserMedia=function(e){return n(e).catch(function(e){return Promise.reject(function(e){return{name:{PermissionDeniedError:"NotAllowedError"}[e.name]||e.name,message:e.message,constraint:e.constraint,toString:function toString(){return this.name;}};}(e));});};}function uo(e){"getDisplayMedia"in e.navigator&&e.navigator.mediaDevices&&(e.navigator.mediaDevices&&"getDisplayMedia"in e.navigator.mediaDevices||(e.navigator.mediaDevices.getDisplayMedia=e.navigator.getDisplayMedia.bind(e.navigator)));}function lo(e,t){if(e.RTCIceGatherer&&(e.RTCIceCandidate||(e.RTCIceCandidate=function(e){return e;}),e.RTCSessionDescription||(e.RTCSessionDescription=function(e){return e;}),t.version<15025)){var _t10=Object.getOwnPropertyDescriptor(e.MediaStreamTrack.prototype,"enabled");Object.defineProperty(e.MediaStreamTrack.prototype,"enabled",{set:function set(e){_t10.set.call(this,e);var n=new Event("enabled");n.enabled=e,this.dispatchEvent(n);}});}e.RTCRtpSender&&!("dtmf"in e.RTCRtpSender.prototype)&&Object.defineProperty(e.RTCRtpSender.prototype,"dtmf",{get:function get(){return void 0===this._dtmf&&("audio"===this.track.kind?this._dtmf=new e.RTCDtmfSender(this):"video"===this.track.kind&&(this._dtmf=null)),this._dtmf;}}),e.RTCDtmfSender&&!e.RTCDTMFSender&&(e.RTCDTMFSender=e.RTCDtmfSender);var n=so(e,t.version);e.RTCPeerConnection=function(e){return e&&e.iceServers&&(e.iceServers=function(e,t){var n=!1;return(e=JSON.parse(JSON.stringify(e))).filter(function(e){if(e&&(e.urls||e.url)){var _t11=e.urls||e.url;e.url&&!e.urls&&La("RTCIceServer.url","RTCIceServer.urls");var _i9="string"==typeof _t11;return _i9&&(_t11=[_t11]),_t11=_t11.filter(function(e){if(0===e.indexOf("stun:"))return!1;var t=e.startsWith("turn")&&!e.startsWith("turn:[")&&e.includes("transport=udp");return t&&!n?(n=!0,!0):t&&!n;}),delete e.url,e.urls=_i9?_t11[0]:_t11,!!_t11.length;}});}(e.iceServers,t.version),Ma("ICE servers after filtering:",e.iceServers)),new n(e);},e.RTCPeerConnection.prototype=n.prototype;}function ho(e){e.RTCRtpSender&&!("replaceTrack"in e.RTCRtpSender.prototype)&&(e.RTCRtpSender.prototype.replaceTrack=e.RTCRtpSender.prototype.setTrack);}var po=Object.freeze({__proto__:null,shimPeerConnection:lo,shimReplaceTrack:ho,shimGetUserMedia:co,shimGetDisplayMedia:uo});function fo(e,t){var n=e&&e.navigator,i=e&&e.MediaStreamTrack;if(n.getUserMedia=function(e,t,i){La("navigator.getUserMedia","navigator.mediaDevices.getUserMedia"),n.mediaDevices.getUserMedia(e).then(t,i);},!(t.version>55&&"autoGainControl"in n.mediaDevices.getSupportedConstraints())){var _e7=function _e7(e,t,n){t in e&&!(n in e)&&(e[n]=e[t],delete e[t]);},_t12=n.mediaDevices.getUserMedia.bind(n.mediaDevices);if(n.mediaDevices.getUserMedia=function(n){return"object"==(typeof n==='undefined'?'undefined':_typeof2(n))&&"object"==_typeof2(n.audio)&&(n=JSON.parse(JSON.stringify(n)),_e7(n.audio,"autoGainControl","mozAutoGainControl"),_e7(n.audio,"noiseSuppression","mozNoiseSuppression")),_t12(n);},i&&i.prototype.getSettings){var _t13=i.prototype.getSettings;i.prototype.getSettings=function(){var n=_t13.apply(this,arguments);return _e7(n,"mozAutoGainControl","autoGainControl"),_e7(n,"mozNoiseSuppression","noiseSuppression"),n;};}if(i&&i.prototype.applyConstraints){var _t14=i.prototype.applyConstraints;i.prototype.applyConstraints=function(n){return"audio"===this.kind&&"object"==(typeof n==='undefined'?'undefined':_typeof2(n))&&(n=JSON.parse(JSON.stringify(n)),_e7(n,"autoGainControl","mozAutoGainControl"),_e7(n,"noiseSuppression","mozNoiseSuppression")),_t14.apply(this,[n]);};}}}function mo(e){"object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCTrackEvent&&"receiver"in e.RTCTrackEvent.prototype&&!("transceiver"in e.RTCTrackEvent.prototype)&&Object.defineProperty(e.RTCTrackEvent.prototype,"transceiver",{get:function get(){return{receiver:this.receiver};}});}function _o(e,t){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCPeerConnection&&!e.mozRTCPeerConnection)return;!e.RTCPeerConnection&&e.mozRTCPeerConnection&&(e.RTCPeerConnection=e.mozRTCPeerConnection),t.version<53&&["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach(function(t){var n=e.RTCPeerConnection.prototype[t],i=_defineProperty2({},t,function(){return arguments[0]=new("addIceCandidate"===t?e.RTCIceCandidate:e.RTCSessionDescription)(arguments[0]),n.apply(this,arguments);});e.RTCPeerConnection.prototype[t]=i[t];});var n={inboundrtp:"inbound-rtp",outboundrtp:"outbound-rtp",candidatepair:"candidate-pair",localcandidate:"local-candidate",remotecandidate:"remote-candidate"},i=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){var _arguments3=Array.prototype.slice.call(arguments),e=_arguments3[0],r=_arguments3[1],a=_arguments3[2];return i.apply(this,[e||null]).then(function(e){if(t.version<53&&!r)try{e.forEach(function(e){e.type=n[e.type]||e.type;});}catch(i){if("TypeError"!==i.name)throw i;e.forEach(function(t,i){e.set(i,Object.assign({},t,{type:n[t.type]||t.type}));});}return e;}).then(r,a);};}function vo(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCPeerConnection||!e.RTCRtpSender)return;if(e.RTCRtpSender&&"getStats"in e.RTCRtpSender.prototype)return;var t=e.RTCPeerConnection.prototype.getSenders;t&&(e.RTCPeerConnection.prototype.getSenders=function(){var _this29=this;var e=t.apply(this,[]);return e.forEach(function(e){return e._pc=_this29;}),e;});var n=e.RTCPeerConnection.prototype.addTrack;n&&(e.RTCPeerConnection.prototype.addTrack=function(){var e=n.apply(this,arguments);return e._pc=this,e;}),e.RTCRtpSender.prototype.getStats=function(){return this.track?this._pc.getStats(this.track):Promise.resolve(new Map());};}function go(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCPeerConnection||!e.RTCRtpSender)return;if(e.RTCRtpSender&&"getStats"in e.RTCRtpReceiver.prototype)return;var t=e.RTCPeerConnection.prototype.getReceivers;t&&(e.RTCPeerConnection.prototype.getReceivers=function(){var _this30=this;var e=t.apply(this,[]);return e.forEach(function(e){return e._pc=_this30;}),e;}),Da(e,"track",function(e){return e.receiver._pc=e.srcElement,e;}),e.RTCRtpReceiver.prototype.getStats=function(){return this._pc.getStats(this.track);};}function yo(e){e.RTCPeerConnection&&!("removeStream"in e.RTCPeerConnection.prototype)&&(e.RTCPeerConnection.prototype.removeStream=function(e){var _this31=this;La("removeStream","removeTrack"),this.getSenders().forEach(function(t){t.track&&e.getTracks().includes(t.track)&&_this31.removeTrack(t);});});}function So(e){e.DataChannel&&!e.RTCDataChannel&&(e.RTCDataChannel=e.DataChannel);}function ko(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCPeerConnection)return;var t=e.RTCPeerConnection.prototype.addTransceiver;t&&(e.RTCPeerConnection.prototype.addTransceiver=function(){this.setParametersPromises=[];var e=arguments[1],n=e&&"sendEncodings"in e;n&&e.sendEncodings.forEach(function(e){if("rid"in e){if(!/^[a-z0-9]{0,16}$/i.test(e.rid))throw new TypeError("Invalid RID value provided.");}if("scaleResolutionDownBy"in e&&!(parseFloat(e.scaleResolutionDownBy)>=1))throw new RangeError("scale_resolution_down_by must be >= 1.0");if("maxFramerate"in e&&!(parseFloat(e.maxFramerate)>=0))throw new RangeError("max_framerate must be >= 0.0");});var i=t.apply(this,arguments);if(n){var _t15=i.sender,_n8=_t15.getParameters();(!("encodings"in _n8)||1===_n8.encodings.length&&0===Object.keys(_n8.encodings[0]).length)&&(_n8.encodings=e.sendEncodings,_t15.sendEncodings=e.sendEncodings,this.setParametersPromises.push(_t15.setParameters(_n8).then(function(){delete _t15.sendEncodings;}).catch(function(){delete _t15.sendEncodings;})));}return i;});}function bo(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCRtpSender)return;var t=e.RTCRtpSender.prototype.getParameters;t&&(e.RTCRtpSender.prototype.getParameters=function(){var e=t.apply(this,arguments);return"encodings"in e||(e.encodings=[].concat(this.sendEncodings||[{}])),e;});}function To(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCPeerConnection)return;var t=e.RTCPeerConnection.prototype.createOffer;e.RTCPeerConnection.prototype.createOffer=function(){var _this32=this,_arguments4=arguments;return this.setParametersPromises&&this.setParametersPromises.length?Promise.all(this.setParametersPromises).then(function(){return t.apply(_this32,_arguments4);}).finally(function(){_this32.setParametersPromises=[];}):t.apply(this,arguments);};}function Io(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCPeerConnection)return;var t=e.RTCPeerConnection.prototype.createAnswer;e.RTCPeerConnection.prototype.createAnswer=function(){var _this33=this,_arguments5=arguments;return this.setParametersPromises&&this.setParametersPromises.length?Promise.all(this.setParametersPromises).then(function(){return t.apply(_this33,_arguments5);}).finally(function(){_this33.setParametersPromises=[];}):t.apply(this,arguments);};}var Eo=Object.freeze({__proto__:null,shimOnTrack:mo,shimPeerConnection:_o,shimSenderGetStats:vo,shimReceiverGetStats:go,shimRemoveStream:yo,shimRTCDataChannel:So,shimAddTransceiver:ko,shimGetParameters:bo,shimCreateOffer:To,shimCreateAnswer:Io,shimGetUserMedia:fo,shimGetDisplayMedia:function shimGetDisplayMedia(e,t){e.navigator.mediaDevices&&"getDisplayMedia"in e.navigator.mediaDevices||e.navigator.mediaDevices&&(e.navigator.mediaDevices.getDisplayMedia=function(n){if(!n||!n.video){var _e8=new DOMException("getDisplayMedia without video constraints is undefined");return _e8.name="NotFoundError",_e8.code=8,Promise.reject(_e8);}return!0===n.video?n.video={mediaSource:t}:n.video.mediaSource=t,e.navigator.mediaDevices.getUserMedia(n);});}});function shimLocalStreamsAPI(e){if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCPeerConnection){if("getLocalStreams"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.getLocalStreams=function(){return this._localStreams||(this._localStreams=[]),this._localStreams;}),!("addStream"in e.RTCPeerConnection.prototype)){var _t16=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addStream=function(e){var _this34=this;this._localStreams||(this._localStreams=[]),this._localStreams.includes(e)||this._localStreams.push(e),e.getAudioTracks().forEach(function(n){return _t16.call(_this34,n,e);}),e.getVideoTracks().forEach(function(n){return _t16.call(_this34,n,e);});},e.RTCPeerConnection.prototype.addTrack=function(e){var _this35=this;for(var _len=arguments.length,n=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){n[_key-1]=arguments[_key];}return n&&n.forEach(function(e){_this35._localStreams?_this35._localStreams.includes(e)||_this35._localStreams.push(e):_this35._localStreams=[e];}),_t16.apply(this,arguments);};}"removeStream"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.removeStream=function(e){var _this36=this;this._localStreams||(this._localStreams=[]);var t=this._localStreams.indexOf(e);if(-1===t)return;this._localStreams.splice(t,1);var n=e.getTracks();this.getSenders().forEach(function(e){n.includes(e.track)&&_this36.removeTrack(e);});});}}function shimRemoteStreamsAPI(e){if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCPeerConnection&&("getRemoteStreams"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.getRemoteStreams=function(){return this._remoteStreams?this._remoteStreams:[];}),!("onaddstream"in e.RTCPeerConnection.prototype))){Object.defineProperty(e.RTCPeerConnection.prototype,"onaddstream",{get:function get(){return this._onaddstream;},set:function set(e){var _this37=this;this._onaddstream&&(this.removeEventListener("addstream",this._onaddstream),this.removeEventListener("track",this._onaddstreampoly)),this.addEventListener("addstream",this._onaddstream=e),this.addEventListener("track",this._onaddstreampoly=function(e){e.streams.forEach(function(e){if(_this37._remoteStreams||(_this37._remoteStreams=[]),_this37._remoteStreams.includes(e))return;_this37._remoteStreams.push(e);var t=new Event("addstream");t.stream=e,_this37.dispatchEvent(t);});});}});var _t17=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){var e=this;return this._onaddstreampoly||this.addEventListener("track",this._onaddstreampoly=function(t){t.streams.forEach(function(t){if(e._remoteStreams||(e._remoteStreams=[]),e._remoteStreams.indexOf(t)>=0)return;e._remoteStreams.push(t);var n=new Event("addstream");n.stream=t,e.dispatchEvent(n);});}),_t17.apply(e,arguments);};}}function wo(e){if("object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||!e.RTCPeerConnection)return;var t=e.RTCPeerConnection.prototype,n=t.createOffer,i=t.createAnswer,r=t.setLocalDescription,a=t.setRemoteDescription,o=t.addIceCandidate;t.createOffer=function(e,t){var i=arguments.length>=2?arguments[2]:arguments[0],r=n.apply(this,[i]);return t?(r.then(e,t),Promise.resolve()):r;},t.createAnswer=function(e,t){var n=arguments.length>=2?arguments[2]:arguments[0],r=i.apply(this,[n]);return t?(r.then(e,t),Promise.resolve()):r;};var s=function s(e,t,n){var i=r.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i;};t.setLocalDescription=s,s=function s(e,t,n){var i=a.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i;},t.setRemoteDescription=s,s=function s(e,t,n){var i=o.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i;},t.addIceCandidate=s;}function Ro(e){var t=e&&e.navigator;if(t.mediaDevices&&t.mediaDevices.getUserMedia){var _e9=t.mediaDevices,_n9=_e9.getUserMedia.bind(_e9);t.mediaDevices.getUserMedia=function(e){return _n9(Co(e));};}!t.getUserMedia&&t.mediaDevices&&t.mediaDevices.getUserMedia&&(t.getUserMedia=function(e,n,i){t.mediaDevices.getUserMedia(e).then(n,i);}.bind(t));}function Co(e){return e&&void 0!==e.video?Object.assign({},e,{video:Va(e.video)}):e;}function Ao(e){if(!e.RTCPeerConnection)return;var t=e.RTCPeerConnection;e.RTCPeerConnection=function(e,n){if(e&&e.iceServers){var _t18=[];for(var _n10=0;_n10<e.iceServers.length;_n10++){var _i11=e.iceServers[_n10];!_i11.hasOwnProperty("urls")&&_i11.hasOwnProperty("url")?(La("RTCIceServer.url","RTCIceServer.urls"),_i11=JSON.parse(JSON.stringify(_i11)),_i11.urls=_i11.url,delete _i11.url,_t18.push(_i11)):_t18.push(e.iceServers[_n10]);}e.iceServers=_t18;}return new t(e,n);},e.RTCPeerConnection.prototype=t.prototype,"generateCertificate"in t&&Object.defineProperty(e.RTCPeerConnection,"generateCertificate",{get:function get(){return t.generateCertificate;}});}function xo(e){"object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.RTCTrackEvent&&"receiver"in e.RTCTrackEvent.prototype&&!("transceiver"in e.RTCTrackEvent.prototype)&&Object.defineProperty(e.RTCTrackEvent.prototype,"transceiver",{get:function get(){return{receiver:this.receiver};}});}function Po(e){var t=e.RTCPeerConnection.prototype.createOffer;e.RTCPeerConnection.prototype.createOffer=function(e){if(e){void 0!==e.offerToReceiveAudio&&(e.offerToReceiveAudio=!!e.offerToReceiveAudio);var _t19=this.getTransceivers().find(function(e){return"audio"===e.receiver.track.kind;});!1===e.offerToReceiveAudio&&_t19?"sendrecv"===_t19.direction?_t19.setDirection?_t19.setDirection("sendonly"):_t19.direction="sendonly":"recvonly"===_t19.direction&&(_t19.setDirection?_t19.setDirection("inactive"):_t19.direction="inactive"):!0!==e.offerToReceiveAudio||_t19||this.addTransceiver("audio"),void 0!==e.offerToReceiveVideo&&(e.offerToReceiveVideo=!!e.offerToReceiveVideo);var _n11=this.getTransceivers().find(function(e){return"video"===e.receiver.track.kind;});!1===e.offerToReceiveVideo&&_n11?"sendrecv"===_n11.direction?_n11.setDirection?_n11.setDirection("sendonly"):_n11.direction="sendonly":"recvonly"===_n11.direction&&(_n11.setDirection?_n11.setDirection("inactive"):_n11.direction="inactive"):!0!==e.offerToReceiveVideo||_n11||this.addTransceiver("video");}return t.apply(this,arguments);};}function Do(e){"object"!=(typeof e==='undefined'?'undefined':_typeof2(e))||e.AudioContext||(e.AudioContext=e.webkitAudioContext);}var Oo=Object.freeze({__proto__:null,shimLocalStreamsAPI:shimLocalStreamsAPI,shimRemoteStreamsAPI:shimRemoteStreamsAPI,shimCallbacksAPI:wo,shimGetUserMedia:Ro,shimConstraints:Co,shimRTCIceServerUrls:Ao,shimTrackEventTransceiver:xo,shimCreateOfferLegacy:Po,shimAudioContext:Do});function No(e){if(!e.RTCIceCandidate||e.RTCIceCandidate&&"foundation"in e.RTCIceCandidate.prototype)return;var t=e.RTCIceCandidate;e.RTCIceCandidate=function(e){if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))&&e.candidate&&0===e.candidate.indexOf("a=")&&((e=JSON.parse(JSON.stringify(e))).candidate=e.candidate.substr(2)),e.candidate&&e.candidate.length){var _n12=new t(e),_i12=eo.parseCandidate(e.candidate),_r4=Object.assign(_n12,_i12);return _r4.toJSON=function(){return{candidate:_r4.candidate,sdpMid:_r4.sdpMid,sdpMLineIndex:_r4.sdpMLineIndex,usernameFragment:_r4.usernameFragment};},_r4;}return new t(e);},e.RTCIceCandidate.prototype=t.prototype,Da(e,"icecandidate",function(t){return t.candidate&&Object.defineProperty(t,"candidate",{value:new e.RTCIceCandidate(t.candidate),writable:"false"}),t;});}function Mo(e,t){if(!e.RTCPeerConnection)return;"sctp"in e.RTCPeerConnection.prototype||Object.defineProperty(e.RTCPeerConnection.prototype,"sctp",{get:function get(){return void 0===this._sctp?null:this._sctp;}});var n=function n(e){if(!e||!e.sdp)return!1;var t=eo.splitSections(e.sdp);return t.shift(),t.some(function(e){var t=eo.parseMLine(e);return t&&"application"===t.kind&&-1!==t.protocol.indexOf("SCTP");});},i=function i(e){var t=e.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);if(null===t||t.length<2)return-1;var n=parseInt(t[1],10);return n!=n?-1:n;},r=function r(e){var n=65536;return"firefox"===t.browser&&(n=t.version<57?-1===e?16384:2147483637:t.version<60?57===t.version?65535:65536:2147483637),n;},a=function a(e,n){var i=65536;"firefox"===t.browser&&57===t.version&&(i=65535);var r=eo.matchPrefix(e.sdp,"a=max-message-size:");return r.length>0?i=parseInt(r[0].substr(19),10):"firefox"===t.browser&&-1!==n&&(i=2147483637),i;},o=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){if(this._sctp=null,"chrome"===t.browser&&t.version>=76){var _getConfiguration=this.getConfiguration(),_e10=_getConfiguration.sdpSemantics;"plan-b"===_e10&&Object.defineProperty(this,"sctp",{get:function get(){return void 0===this._sctp?null:this._sctp;},enumerable:!0,configurable:!0});}if(n(arguments[0])){var _e11=i(arguments[0]),_t20=r(_e11),_n13=a(arguments[0],_e11);var _o3=void 0;_o3=0===_t20&&0===_n13?Number.POSITIVE_INFINITY:0===_t20||0===_n13?Math.max(_t20,_n13):Math.min(_t20,_n13);var _s2={};Object.defineProperty(_s2,"maxMessageSize",{get:function get(){return _o3;}}),this._sctp=_s2;}return o.apply(this,arguments);};}function Lo(e){if(!e.RTCPeerConnection||!("createDataChannel"in e.RTCPeerConnection.prototype))return;function t(e,t){var n=e.send;e.send=function(){var i=arguments[0],r=i.length||i.size||i.byteLength;if("open"===e.readyState&&t.sctp&&r>t.sctp.maxMessageSize)throw new TypeError("Message too large (can send a maximum of "+t.sctp.maxMessageSize+" bytes)");return n.apply(e,arguments);};}var n=e.RTCPeerConnection.prototype.createDataChannel;e.RTCPeerConnection.prototype.createDataChannel=function(){var e=n.apply(this,arguments);return t(e,this),e;},Da(e,"datachannel",function(e){return t(e.channel,e.target),e;});}function Uo(e){if(!e.RTCPeerConnection||"connectionState"in e.RTCPeerConnection.prototype)return;var t=e.RTCPeerConnection.prototype;Object.defineProperty(t,"connectionState",{get:function get(){return{completed:"connected",checking:"connecting"}[this.iceConnectionState]||this.iceConnectionState;},enumerable:!0,configurable:!0}),Object.defineProperty(t,"onconnectionstatechange",{get:function get(){return this._onconnectionstatechange||null;},set:function set(e){this._onconnectionstatechange&&(this.removeEventListener("connectionstatechange",this._onconnectionstatechange),delete this._onconnectionstatechange),e&&this.addEventListener("connectionstatechange",this._onconnectionstatechange=e);},enumerable:!0,configurable:!0}),["setLocalDescription","setRemoteDescription"].forEach(function(e){var n=t[e];t[e]=function(){return this._connectionstatechangepoly||(this._connectionstatechangepoly=function(e){var t=e.target;if(t._lastConnectionState!==t.connectionState){t._lastConnectionState=t.connectionState;var _n14=new Event("connectionstatechange",e);t.dispatchEvent(_n14);}return e;},this.addEventListener("iceconnectionstatechange",this._connectionstatechangepoly)),n.apply(this,arguments);};});}function Vo(e,t){if(!e.RTCPeerConnection)return;if("chrome"===t.browser&&t.version>=71)return;if("safari"===t.browser&&t.version>=605)return;var n=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(t){if(t&&t.sdp&&-1!==t.sdp.indexOf("\na=extmap-allow-mixed")){var _n15=t.sdp.split("\n").filter(function(e){return"a=extmap-allow-mixed"!==e.trim();}).join("\n");e.RTCSessionDescription&&t instanceof e.RTCSessionDescription?arguments[0]=new e.RTCSessionDescription({type:t.type,sdp:_n15}):t.sdp=_n15;}return n.apply(this,arguments);};}function Fo(e,t){if(!e.RTCPeerConnection||!e.RTCPeerConnection.prototype)return;var n=e.RTCPeerConnection.prototype.addIceCandidate;n&&0!==n.length&&(e.RTCPeerConnection.prototype.addIceCandidate=function(){return arguments[0]?("chrome"===t.browser&&t.version<78||"firefox"===t.browser&&t.version<68||"safari"===t.browser)&&arguments[0]&&""===arguments[0].candidate?Promise.resolve():n.apply(this,arguments):(arguments[1]&&arguments[1].apply(null),Promise.resolve());});}var jo=Object.freeze({__proto__:null,shimRTCIceCandidate:No,shimMaxMessageSize:Mo,shimSendThrowTypeError:Lo,shimConnectionState:Uo,removeExtmapAllowMixed:Vo,shimAddIceCandidateNullOrEmpty:Fo});!function(){var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},e=_ref2.window;var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{shimChrome:!0,shimFirefox:!0,shimEdge:!0,shimSafari:!0};var n=Ma,i=function(e){var t={browser:null,version:null};if(void 0===e||!e.navigator)return t.browser="Not a browser.",t;var n=e.navigator;if(n.mozGetUserMedia)t.browser="firefox",t.version=Pa(n.userAgent,/Firefox\/(\d+)\./,1);else if(n.webkitGetUserMedia||!1===e.isSecureContext&&e.webkitRTCPeerConnection&&!e.RTCIceGatherer)t.browser="chrome",t.version=Pa(n.userAgent,/Chrom(e|ium)\/(\d+)\./,2);else if(n.mediaDevices&&n.userAgent.match(/Edge\/(\d+).(\d+)$/))t.browser="edge",t.version=Pa(n.userAgent,/Edge\/(\d+).(\d+)$/,2);else{if(!e.RTCPeerConnection||!n.userAgent.match(/AppleWebKit\/(\d+)\./))return t.browser="Not a supported browser.",t;t.browser="safari",t.version=Pa(n.userAgent,/AppleWebKit\/(\d+)\./,1),t.supportsUnifiedPlan=e.RTCRtpTransceiver&&"currentDirection"in e.RTCRtpTransceiver.prototype;}return t;}(e),r={browserDetails:i,commonShim:jo,extractVersion:Pa,disableLog:Oa,disableWarnings:Na};switch(i.browser){case"chrome":if(!$a||!Xa||!t.shimChrome)return n("Chrome shim is not included in this adapter release."),r;if(null===i.version)return n("Chrome shim can not determine version, not shimming."),r;n("adapter.js shimming chrome."),r.browserShim=$a,Fo(e,i),Ha(e,i),Ga(e),Xa(e,i),Wa(e),Qa(e,i),za(e),Ja(e),qa(e),Ya(e,i),No(e),Uo(e),Mo(e,i),Lo(e),Vo(e,i);break;case"firefox":if(!Eo||!_o||!t.shimFirefox)return n("Firefox shim is not included in this adapter release."),r;n("adapter.js shimming firefox."),r.browserShim=Eo,Fo(e,i),fo(e,i),_o(e,i),mo(e),yo(e),vo(e),go(e),So(e),ko(e),bo(e),To(e),Io(e),No(e),Uo(e),Mo(e,i),Lo(e);break;case"edge":if(!po||!lo||!t.shimEdge)return n("MS edge shim is not included in this adapter release."),r;n("adapter.js shimming edge."),r.browserShim=po,co(e),uo(e),lo(e,i),ho(e),Mo(e,i),Lo(e);break;case"safari":if(!Oo||!t.shimSafari)return n("Safari shim is not included in this adapter release."),r;n("adapter.js shimming safari."),r.browserShim=Oo,Fo(e,i),Ao(e),Po(e),wo(e),shimLocalStreamsAPI(e),shimRemoteStreamsAPI(e),xo(e),Ro(e),Do(e),No(e),Mo(e,i),Lo(e),Vo(e,i);break;default:n("Unsupported browser!");}}({window:"undefined"==typeof window?void 0:window});var Bo="4.15.5",Ho={},Go=qi,Wo=Ki,zo=Object.keys||function(e){return Go(e,Wo);},Jo=P,qo=an,Ko=rn,Qo=un,Xo=he,Yo=zo;Ho.f=Jo&&!qo?Object.defineProperties:function(e,t){Qo(e);for(var n,i=Xo(t),r=Yo(t),a=r.length,o=0;a>o;){Ko.f(e,n=r[o++],i[n]);}return e;};var $o,Zo=Te("document","documentElement"),es=un,ts=Ho,ns=Ki,is=zn,rs=Zo,as=zt,os=Wn("IE_PROTO"),ss=function ss(){},cs=function cs(e){return"<script>"+e+"</"+"script>";},us=function us(e){e.write(cs("")),e.close();var t=e.parentWindow.Object;return e=null,t;},_ds=function ds(){try{$o=new ActiveXObject("htmlfile");}catch(i){}var e,t;_ds="undefined"!=typeof document?document.domain&&$o?us($o):((t=as("iframe")).style.display="none",rs.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(cs("document.F=Object")),e.close(),e.F):us($o);for(var n=ns.length;n--;){delete _ds.prototype[ns[n]];}return _ds();};is[os]=!0;var ls=Object.create||function(e,t){var n;return null!==e?(ss.prototype=es(e),n=new ss(),ss.prototype=null,n[os]=e):n=_ds(),void 0===t?n:ts.f(n,t);},hs=xt,ps=ls,fs=rn.f,ms=hs("unscopables"),_s=Array.prototype;null==_s[ms]&&fs(_s,ms,{configurable:!0,value:ps(null)});var vs,gs,ys,Ss=function Ss(e){_s[ms][e]=!0;},ks={},bs=!x(function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e())!==e.prototype;}),Ts=ft,Is=_e,Es=lt,ws=bs,Rs=Wn("IE_PROTO"),Cs=Object,As=Cs.prototype,xs=ws?Cs.getPrototypeOf:function(e){var t=Es(e);if(Ts(t,Rs))return t[Rs];var n=t.constructor;return Is(n)&&t instanceof n?n.prototype:t instanceof Cs?As:null;},Ps=x,Ds=_e,Os=ye,Ns=xs,Ms=bi,Ls=xt("iterator"),Us=!1;[].keys&&("next"in(ys=[].keys())?(gs=Ns(Ns(ys)))!==Object.prototype&&(vs=gs):Us=!0);var Vs=!Os(vs)||Ps(function(){var e={};return vs[Ls].call(e)!==e;});Vs&&(vs={}),Ds(vs[Ls])||Ms(vs,Ls,function(){return this;});var Fs={IteratorPrototype:vs,BUGGY_SAFARI_ITERATORS:Us},js=rn.f,Bs=ft,Hs=xt("toStringTag"),Gs=function Gs(e,t,n){e&&!n&&(e=e.prototype),e&&!Bs(e,Hs)&&js(e,Hs,{configurable:!0,value:t});},Ws=Fs.IteratorPrototype,zs=ls,Js=H,qs=Gs,Ks=ks,Qs=function Qs(){return this;},Xs=function Xs(e,t,n,i){var r=t+" Iterator";return e.prototype=zs(Ws,{next:Js(+!i,n)}),qs(e,r,!1),Ks[r]=Qs,e;},Ys=_e,$s=String,Zs=TypeError,ec=ee,tc=un,nc=function nc(e){if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))||Ys(e))return e;throw Zs("Can't set "+$s(e)+" as a prototype");},ic=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,n={};try{(e=ec(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(n,[]),t=n instanceof Array;}catch(i){}return function(n,i){return tc(n),nc(i),t?e(n,i):n.__proto__=i,n;};}():void 0),rc=Ir,ac=M,oc=_e,sc=Xs,cc=xs,uc=ic,dc=Gs,lc=Tn,hc=bi,pc=ks,fc=xn.PROPER,mc=xn.CONFIGURABLE,_c=Fs.IteratorPrototype,vc=Fs.BUGGY_SAFARI_ITERATORS,gc=xt("iterator"),yc="keys",Sc="values",kc="entries",bc=function bc(){return this;},Tc=function Tc(e,t,n,i,r,a,o){sc(n,t,i);var s,c,u,d=function d(e){if(e===r&&m)return m;if(!vc&&e in p)return p[e];switch(e){case yc:case Sc:case kc:return function(){return new n(this,e);};}return function(){return new n(this);};},l=t+" Iterator",h=!1,p=e.prototype,f=p[gc]||p["@@iterator"]||r&&p[r],m=!vc&&f||d(r),_="Array"==t&&p.entries||f;if(_&&(s=cc(_.call(new e())))!==Object.prototype&&s.next&&(cc(s)!==_c&&(uc?uc(s,_c):oc(s[gc])||hc(s,gc,bc)),dc(s,l,!0)),fc&&r==Sc&&f&&f.name!==Sc&&(mc?lc(p,"name",Sc):(h=!0,m=function m(){return ac(f,this);})),r)if(c={values:d(Sc),keys:a?m:d(yc),entries:d(kc)},o)for(u in c){(vc||h||!(u in p))&&hc(p,u,c[u]);}else rc({target:t,proto:!0,forced:vc||h},c);return p[gc]!==m&&hc(p,gc,m,{name:r}),pc[t]=m,c;},Ic=function Ic(e,t){return{value:e,done:t};},Ec=he,wc=Ss,Rc=ks,Cc=ai,Ac=rn.f,xc=Tc,Pc=Ic,Dc=P,Oc="Array Iterator",Nc=Cc.set,Mc=Cc.getterFor(Oc),Lc=xc(Array,"Array",function(e,t){Nc(this,{type:Oc,target:Ec(e),index:0,kind:t});},function(){var e=Mc(this),t=e.target,n=e.kind,i=e.index++;return!t||i>=t.length?(e.target=void 0,Pc(void 0,!0)):Pc("keys"==n?i:"values"==n?t[i]:[i,t[i]],!1);},"values"),Uc=Rc.Arguments=Rc.Array;if(wc("keys"),wc("values"),wc("entries"),Dc&&"values"!==Uc.name)try{Ac(Uc,"name",{value:"values"});}catch(XJ){}var Vc={exports:{}},Fc={},jc=Bt,Bc=rn,Hc=H,Gc=function Gc(e,t,n){var i=jc(t);i in e?Bc.f(e,i,Hc(0,n)):e[i]=n;},Wc=Pi,zc=Li,Jc=Gc,qc=Array,Kc=Math.max,Qc=function Qc(e,t,n){for(var i=zc(e),r=Wc(t,i),a=Wc(void 0===n?i:n,i),o=qc(Kc(a-r,0)),s=0;r<a;r++,s++){Jc(o,s,e[r]);}return o.length=s,o;},Xc=Y,Yc=he,$c=Ti.f,Zc=Qc,eu="object"==(typeof window==='undefined'?'undefined':_typeof2(window))&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];Fc.f=function(e){return eu&&"Window"==Xc(e)?function(e){try{return $c(e);}catch(XJ){return Zc(eu);}}(e):$c(Yc(e));};var tu=x(function(){if("function"==typeof ArrayBuffer){var e=new ArrayBuffer(8);Object.isExtensible(e)&&Object.defineProperty(e,"a",{value:8});}}),nu=x,iu=ye,ru=Y,au=tu,ou=Object.isExtensible,su=nu(function(){ou(1);})||au?function(e){return!!iu(e)&&(!au||"ArrayBuffer"!=ru(e))&&(!ou||ou(e));}:ou,cu=!x(function(){return Object.isExtensible(Object.preventExtensions({}));}),uu=Ir,du=ee,lu=zn,hu=ye,pu=ft,fu=rn.f,mu=Ti,_u=Fc,vu=su,gu=cu,yu=!1,Su=yt("meta"),ku=0,bu=function bu(e){fu(e,Su,{value:{objectID:"O"+ku++,weakData:{}}});},Tu=Vc.exports={enable:function enable(){Tu.enable=function(){},yu=!0;var e=mu.f,t=du([].splice),n={};n[Su]=1,e(n).length&&(mu.f=function(n){for(var i=e(n),r=0,a=i.length;r<a;r++){if(i[r]===Su){t(i,r,1);break;}}return i;},uu({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:_u.f}));},fastKey:function fastKey(e,t){if(!hu(e))return"symbol"==(typeof e==='undefined'?'undefined':_typeof2(e))?e:("string"==typeof e?"S":"P")+e;if(!pu(e,Su)){if(!vu(e))return"F";if(!t)return"E";bu(e);}return e[Su].objectID;},getWeakData:function getWeakData(e,t){if(!pu(e,Su)){if(!vu(e))return!0;if(!t)return!1;bu(e);}return e[Su].weakData;},onFreeze:function onFreeze(e){return gu&&yu&&vu(e)&&!pu(e,Su)&&bu(e),e;}};lu[Su]=!0;var Iu=ks,Eu=xt("iterator"),wu=Array.prototype,Ru=function Ru(e){return void 0!==e&&(Iu.Array===e||wu[Eu]===e);},Cu=Fr,Au=Xe,xu=oe,Pu=ks,Du=xt("iterator"),Ou=function Ou(e){if(!xu(e))return Au(e,Du)||Au(e,"@@iterator")||Pu[Cu(e)];},Nu=M,Mu=qe,Lu=un,Uu=Ge,Vu=Ou,Fu=TypeError,ju=function ju(e,t){var n=arguments.length<2?Vu(e):t;if(Mu(n))return Lu(Nu(n,e));throw Fu(Uu(e)+" is not iterable");},Bu=M,Hu=un,Gu=Xe,Wu=function Wu(e,t,n){var i,r;Hu(e);try{if(!(i=Gu(e,"return"))){if("throw"===t)throw n;return n;}i=Bu(i,e);}catch(XJ){r=!0,i=XJ;}if("throw"===t)throw n;if(r)throw i;return Hu(i),n;},zu=Cr,Ju=M,qu=un,Ku=Ge,Qu=Ru,Xu=Li,Yu=Ie,$u=ju,Zu=Ou,ed=Wu,td=TypeError,nd=function nd(e,t){this.stopped=e,this.result=t;},id=nd.prototype,rd=function rd(e,t,n){var i,r,a,o,s,c,u,d=n&&n.that,l=!(!n||!n.AS_ENTRIES),h=!(!n||!n.IS_RECORD),p=!(!n||!n.IS_ITERATOR),f=!(!n||!n.INTERRUPTED),m=zu(t,d),_=function _(e){return i&&ed(i,"normal",e),new nd(!0,e);},v=function v(e){return l?(qu(e),f?m(e[0],e[1],_):m(e[0],e[1])):f?m(e,_):m(e);};if(h)i=e.iterator;else if(p)i=e;else{if(!(r=Zu(e)))throw td(Ku(e)+" is not iterable");if(Qu(r)){for(a=0,o=Xu(e);o>a;a++){if((s=v(e[a]))&&Yu(id,s))return s;}return new nd(!1);}i=$u(e,r);}for(c=h?e.next:i.next;!(u=Ju(c,i)).done;){try{s=v(u.value);}catch(XJ){ed(i,"throw",XJ);}if("object"==(typeof s==='undefined'?'undefined':_typeof2(s))&&s&&Yu(id,s))return s;}return new nd(!1);},ad=Ie,od=TypeError,sd=function sd(e,t){if(ad(t,e))return e;throw od("Incorrect invocation");},cd=xt("iterator"),ud=!1;try{var dd=0,ld={next:function next(){return{done:!!dd++};},return:function _return(){ud=!0;}};ld[cd]=function(){return this;},Array.from(ld,function(){throw 2;});}catch(XJ){}var hd=function hd(e,t){if(!t&&!ud)return!1;var n=!1;try{var i={};i[cd]=function(){return{next:function next(){return{done:n=!0};}};},e(i);}catch(XJ){}return n;},pd=_e,fd=ye,md=ic,_d=function _d(e,t,n){var i,r;return md&&pd(i=t.constructor)&&i!==n&&fd(r=i.prototype)&&r!==n.prototype&&md(e,r),e;},vd=Ir,gd=C,yd=ee,Sd=_r,kd=bi,bd=Vc.exports,Td=rd,Id=sd,Ed=_e,wd=oe,Rd=ye,Cd=x,Ad=hd,xd=Gs,Pd=_d,Dd=function Dd(e,t,n){var i=-1!==e.indexOf("Map"),r=-1!==e.indexOf("Weak"),a=i?"set":"add",o=gd[e],s=o&&o.prototype,c=o,u={},d=function d(e){var t=yd(s[e]);kd(s,e,"add"==e?function(e){return t(this,0===e?0:e),this;}:"delete"==e?function(e){return!(r&&!Rd(e))&&t(this,0===e?0:e);}:"get"==e?function(e){return r&&!Rd(e)?void 0:t(this,0===e?0:e);}:"has"==e?function(e){return!(r&&!Rd(e))&&t(this,0===e?0:e);}:function(e,n){return t(this,0===e?0:e,n),this;});};if(Sd(e,!Ed(o)||!(r||s.forEach&&!Cd(function(){new o().entries().next();}))))c=n.getConstructor(t,e,i,a),bd.enable();else if(Sd(e,!0)){var l=new c(),h=l[a](r?{}:-0,1)!=l,p=Cd(function(){l.has(1);}),f=Ad(function(e){new o(e);}),m=!r&&Cd(function(){for(var e=new o(),t=5;t--;){e[a](t,t);}return!e.has(-0);});f||((c=t(function(e,t){Id(e,s);var n=Pd(new o(),e,c);return wd(t)||Td(t,n[a],{that:n,AS_ENTRIES:i}),n;})).prototype=s,s.constructor=c),(p||m)&&(d("delete"),d("has"),i&&d("get")),(m||h)&&d(a),r&&s.clear&&delete s.clear;}return u[e]=c,vd({global:!0,constructor:!0,forced:c!=o},u),xd(c,e),r||n.setStrong(c,e,i),c;},Od=bi,Nd=function Nd(e,t,n){for(var i in t){Od(e,i,t[i],n);}return e;},Md=Te,Ld=rn,Ud=P,Vd=xt("species"),Fd=function Fd(e){var t=Md(e),n=Ld.f;Ud&&t&&!t[Vd]&&n(t,Vd,{configurable:!0,get:function get(){return this;}});},jd=rn.f,Bd=ls,Hd=Nd,Gd=Cr,Wd=sd,zd=oe,Jd=rd,qd=Tc,Kd=Ic,Qd=Fd,Xd=P,Yd=Vc.exports.fastKey,$d=ai.set,Zd=ai.getterFor,el={getConstructor:function getConstructor(e,t,n,i){var r=e(function(e,r){Wd(e,a),$d(e,{type:t,index:Bd(null),first:void 0,last:void 0,size:0}),Xd||(e.size=0),zd(r)||Jd(r,e[i],{that:e,AS_ENTRIES:n});}),a=r.prototype,o=Zd(t),s=function s(e,t,n){var i,r,a=o(e),s=c(e,t);return s?s.value=n:(a.last=s={index:r=Yd(t,!0),key:t,value:n,previous:i=a.last,next:void 0,removed:!1},a.first||(a.first=s),i&&(i.next=s),Xd?a.size++:e.size++,"F"!==r&&(a.index[r]=s)),e;},c=function c(e,t){var n,i=o(e),r=Yd(t);if("F"!==r)return i.index[r];for(n=i.first;n;n=n.next){if(n.key==t)return n;}};return Hd(a,{clear:function clear(){for(var e=o(this),t=e.index,n=e.first;n;){n.removed=!0,n.previous&&(n.previous=n.previous.next=void 0),delete t[n.index],n=n.next;}e.first=e.last=void 0,Xd?e.size=0:this.size=0;},delete:function _delete(e){var t=this,n=o(t),i=c(t,e);if(i){var r=i.next,a=i.previous;delete n.index[i.index],i.removed=!0,a&&(a.next=r),r&&(r.previous=a),n.first==i&&(n.first=r),n.last==i&&(n.last=a),Xd?n.size--:t.size--;}return!!i;},forEach:function forEach(e){for(var t,n=o(this),i=Gd(e,arguments.length>1?arguments[1]:void 0);t=t?t.next:n.first;){for(i(t.value,t.key,this);t&&t.removed;){t=t.previous;}}},has:function has(e){return!!c(this,e);}}),Hd(a,n?{get:function get(e){var t=c(this,e);return t&&t.value;},set:function set(e,t){return s(this,0===e?0:e,t);}}:{add:function add(e){return s(this,e=0===e?0:e,e);}}),Xd&&jd(a,"size",{get:function get(){return o(this).size;}}),r;},setStrong:function setStrong(e,t,n){var i=t+" Iterator",r=Zd(t),a=Zd(i);qd(e,t,function(e,t){$d(this,{type:i,target:e,state:r(e),kind:t,last:void 0});},function(){for(var e=a(this),t=e.kind,n=e.last;n&&n.removed;){n=n.previous;}return e.target&&(e.last=n=n?n.next:e.state.first)?Kd("keys"==t?n.key:"values"==t?n.value:[n.key,n.value],!1):(e.target=void 0,Kd(void 0,!0));},n?"entries":"values",!n,!0),Qd(t);}};Dd("Set",function(e){return function(){return e(this,arguments.length?arguments[0]:void 0);};},el);var tl=Fr,nl=String,il=function il(e){if("Symbol"===tl(e))throw TypeError("Cannot convert a Symbol value to a string");return nl(e);},rl=ee,al=Ri,ol=il,sl=ue,cl=rl("".charAt),ul=rl("".charCodeAt),dl=rl("".slice),ll=function ll(e){return function(t,n){var i,r,a=ol(sl(t)),o=al(n),s=a.length;return o<0||o>=s?e?"":void 0:(i=ul(a,o))<55296||i>56319||o+1===s||(r=ul(a,o+1))<56320||r>57343?e?cl(a,o):i:e?dl(a,o,o+2):r-56320+(i-55296<<10)+65536;};},hl={codeAt:ll(!1),charAt:ll(!0)},pl=hl.charAt,fl=il,ml=ai,_l=Tc,vl=Ic,gl="String Iterator",yl=ml.set,Sl=ml.getterFor(gl);_l(String,"String",function(e){yl(this,{type:gl,string:fl(e),index:0});},function(){var e,t=Sl(this),n=t.string,i=t.index;return i>=n.length?vl(void 0,!0):(e=pl(n,i),t.index+=e.length,vl(e,!1));});var kl={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},bl=zt("span").classList,Tl=bl&&bl.constructor&&bl.constructor.prototype,Il=Tl===Object.prototype?void 0:Tl,El=C,wl=kl,Rl=Il,Cl=Lc,Al=Tn,xl=xt,Pl=xl("iterator"),Dl=xl("toStringTag"),Ol=Cl.values,Nl=function Nl(e,t){if(e){if(e[Pl]!==Ol)try{Al(e,Pl,Ol);}catch(XJ){e[Pl]=Ol;}if(e[Dl]||Al(e,Dl,t),wl[t])for(var n in Cl){if(e[n]!==Cl[n])try{Al(e,n,Cl[n]);}catch(XJ){e[n]=Cl[n];}}}};for(var Ml in wl){Nl(El[Ml]&&El[Ml].prototype,Ml);}Nl(Rl,"DOMTokenList");var Ll=D,Ul=Function.prototype,Vl=Ul.apply,Fl=Ul.call,jl="object"==(typeof Reflect==='undefined'?'undefined':_typeof2(Reflect))&&Reflect.apply||(Ll?Fl.bind(Vl):function(){return Fl.apply(Vl,arguments);}),Bl=ee([].slice),Hl=TypeError,Gl=function Gl(e,t){if(e<t)throw Hl("Not enough arguments");return e;},Wl=C,zl=jl,Jl=_e,ql=Bl,Kl=Gl,Ql=/MSIE .\./.test(Ee),Xl=Wl.Function,Yl=function Yl(e){return Ql?function(t,n){var i=Kl(arguments.length,1)>2,r=Jl(t)?t:Xl(t),a=i?ql(arguments,2):void 0;return e(i?function(){zl(r,this,a);}:r,n);}:e;},$l={setTimeout:Yl(Wl.setTimeout),setInterval:Yl(Wl.setInterval)},Zl=$l.setInterval;Ir({global:!0,bind:!0,forced:C.setInterval!==Zl},{setInterval:Zl});var eh=$l.setTimeout;Ir({global:!0,bind:!0,forced:C.setTimeout!==eh},{setTimeout:eh}),Dd("Map",function(e){return function(){return e(this,arguments.length?arguments[0]:void 0);};},el);var th=P,nh=xr,ih=TypeError,rh=Object.getOwnPropertyDescriptor,ah=th&&!function(){if(void 0!==this)return!0;try{Object.defineProperty([],"length",{writable:!1}).length=1;}catch(XJ){return XJ instanceof TypeError;}}(),oh=TypeError,sh=function sh(e){if(e>9007199254740991)throw oh("Maximum allowed index exceeded");return e;},ch=Ge,uh=TypeError,dh=function dh(e,t){if(!delete e[t])throw uh("Cannot delete property "+ch(t)+" of "+ch(e));},lh=Ir,hh=lt,ph=Pi,fh=Ri,mh=Li,_h=ah?function(e,t){if(nh(e)&&!rh(e,"length").writable)throw ih("Cannot set read only .length");return e.length=t;}:function(e,t){return e.length=t;},vh=sh,gh=oa,yh=Gc,Sh=dh,kh=ga("splice"),bh=Math.max,Th=Math.min;lh({target:"Array",proto:!0,forced:!kh},{splice:function splice(e,t){var n,i,r,a,o,s,c=hh(this),u=mh(c),d=ph(e,u),l=arguments.length;for(0===l?n=i=0:1===l?(n=0,i=u-d):(n=l-2,i=Th(bh(fh(t),0),u-d)),vh(u+n-i),r=gh(c,i),a=0;a<i;a++){(o=d+a)in c&&yh(r,a,c[o]);}if(r.length=i,n<i){for(a=d;a<u-i;a++){s=a+n,(o=a+i)in c?c[s]=c[o]:Sh(c,s);}for(a=u;a>u-i+n;a--){Sh(c,a-1);}}else if(n>i)for(a=u-i;a>d;a--){s=a+n-1,(o=a+i-1)in c?c[s]=c[o]:Sh(c,s);}for(a=0;a<n;a++){c[a+d]=arguments[a+2];}return _h(c,u-i+n),r;}});var Ih=x,Eh=function Eh(e,t){var n=[][e];return!!n&&Ih(function(){n.call(null,t||function(){return 1;},1);});},wh=fa.forEach,Rh=Eh("forEach")?[].forEach:function(e){return wh(this,e,arguments.length>1?arguments[1]:void 0);};Ir({target:"Array",proto:!0,forced:[].forEach!=Rh},{forEach:Rh});var Ch=C,Ah=kl,xh=Il,Ph=Rh,Dh=Tn,Oh=function Oh(e){if(e&&e.forEach!==Ph)try{Dh(e,"forEach",Ph);}catch(XJ){e.forEach=Ph;}};for(var Nh in Ah){Ah[Nh]&&Oh(Ch[Nh]&&Ch[Nh].prototype);}Oh(xh);var Mh=Ir,Lh=ae,Uh=he,Vh=Eh,Fh=ee([].join),jh=Lh!=Object,Bh=Vh("join",",");Mh({target:"Array",proto:!0,forced:jh||!Bh},{join:function join(e){return Fh(Uh(this),void 0===e?",":e);}});var Hh=Ir,Gh=x,Wh=xr,zh=ye,Jh=lt,qh=Li,Kh=sh,Qh=Gc,Xh=oa,Yh=ga,$h=De,Zh=xt("isConcatSpreadable"),ep=$h>=51||!Gh(function(){var e=[];return e[Zh]=!1,e.concat()[0]!==e;}),tp=Yh("concat"),np=function np(e){if(!zh(e))return!1;var t=e[Zh];return void 0!==t?!!t:Wh(e);};Hh({target:"Array",proto:!0,arity:1,forced:!ep||!tp},{concat:function concat(e){var t,n,i,r,a,o=Jh(this),s=Xh(o,0),c=0;for(t=-1,i=arguments.length;t<i;t++){if(np(a=-1===t?o:arguments[t]))for(r=qh(a),Kh(c+r),n=0;n<r;n++,c++){n in a&&Qh(s,c,a[n]);}else Kh(c+1),Qh(s,c++,a);}return s.length=c,s;}});var ip=ee,rp=bi,ap=Date.prototype,op="Invalid Date",sp="toString",cp=ip(ap.toString),up=ip(ap.getTime);String(new Date(NaN))!=op&&rp(ap,sp,function(){var e=up(this);return e==e?cp(this):op;});var dp=Ri,lp=il,hp=ue,pp=RangeError,fp=function fp(e){var t=lp(hp(this)),n="",i=dp(e);if(i<0||Infinity==i)throw pp("Wrong number of repetitions");for(;i>0;(i>>>=1)&&(t+=t)){1&i&&(n+=t);}return n;},mp=ee,_p=Ni,vp=il,gp=ue,yp=mp(fp),Sp=mp("".slice),kp=Math.ceil,bp=function bp(e){return function(t,n,i){var r,a,o=vp(gp(t)),s=_p(n),c=o.length,u=void 0===i?" ":vp(i);return s<=c||""==u?o:((a=yp(u,kp((r=s-c)/u.length))).length>r&&(a=Sp(a,0,r)),e?o+a:a+o);};},Tp={start:bp(!1),end:bp(!0)},Ip=/Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(Ee),Ep=Tp.start;Ir({target:"String",proto:!0,forced:Ip},{padStart:function padStart(e){return Ep(this,e,arguments.length>1?arguments[1]:void 0);}});var wp=un,Rp=function Rp(){var e=wp(this),t="";return e.hasIndices&&(t+="d"),e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.dotAll&&(t+="s"),e.unicode&&(t+="u"),e.unicodeSets&&(t+="v"),e.sticky&&(t+="y"),t;},Cp=x,Ap=C.RegExp,xp=Cp(function(){var e=Ap("a","y");return e.lastIndex=2,null!=e.exec("abcd");}),Pp=xp||Cp(function(){return!Ap("a","y").sticky;}),Dp={BROKEN_CARET:xp||Cp(function(){var e=Ap("^r","gy");return e.lastIndex=2,null!=e.exec("str");}),MISSED_STICKY:Pp,UNSUPPORTED_Y:xp},Op=x,Np=C.RegExp,Mp=Op(function(){var e=Np(".","s");return!(e.dotAll&&e.exec("\n")&&"s"===e.flags);}),Lp=x,Up=C.RegExp,Vp=Lp(function(){var e=Up("(?<a>b)","g");return"b"!==e.exec("b").groups.a||"bc"!=="b".replace(e,"$<a>c");}),Fp=M,jp=ee,Bp=il,Hp=Rp,Gp=Dp,Wp=tt.exports,zp=ls,Jp=ai.get,qp=Mp,Kp=Vp,Qp=Wp("native-string-replace",String.prototype.replace),Xp=RegExp.prototype.exec,_Yp=Xp,$p=jp("".charAt),Zp=jp("".indexOf),ef=jp("".replace),tf=jp("".slice),nf=function(){var e=/a/,t=/b*/g;return Fp(Xp,e,"a"),Fp(Xp,t,"a"),0!==e.lastIndex||0!==t.lastIndex;}(),rf=Gp.BROKEN_CARET,af=void 0!==/()??/.exec("")[1];(nf||af||rf||qp||Kp)&&(_Yp=function Yp(e){var t,n,i,r,a,o,s,c=this,u=Jp(c),d=Bp(e),l=u.raw;if(l)return l.lastIndex=c.lastIndex,t=Fp(_Yp,l,d),c.lastIndex=l.lastIndex,t;var h=u.groups,p=rf&&c.sticky,f=Fp(Hp,c),m=c.source,_=0,v=d;if(p&&(f=ef(f,"y",""),-1===Zp(f,"g")&&(f+="g"),v=tf(d,c.lastIndex),c.lastIndex>0&&(!c.multiline||c.multiline&&"\n"!==$p(d,c.lastIndex-1))&&(m="(?: "+m+")",v=" "+v,_++),n=new RegExp("^(?:"+m+")",f)),af&&(n=new RegExp("^"+m+"$(?!\\s)",f)),nf&&(i=c.lastIndex),r=Fp(Xp,p?n:c,v),p?r?(r.input=tf(r.input,_),r[0]=tf(r[0],_),r.index=c.lastIndex,c.lastIndex+=r[0].length):c.lastIndex=0:nf&&r&&(c.lastIndex=c.global?r.index+r[0].length:i),af&&r&&r.length>1&&Fp(Qp,r[0],n,function(){for(a=1;a<arguments.length-2;a++){void 0===arguments[a]&&(r[a]=void 0);}}),r&&h)for(r.groups=o=zp(null),a=0;a<h.length;a++){o[(s=h[a])[0]]=r[s[1]];}return r;});var of=_Yp;Ir({target:"RegExp",proto:!0,forced:/./.exec!==of},{exec:of});var sf=ee,cf=bi,uf=of,df=x,lf=xt,hf=Tn,pf=lf("species"),ff=RegExp.prototype,mf=function mf(e,t,n,i){var r=lf(e),a=!df(function(){var t={};return t[r]=function(){return 7;},7!=""[e](t);}),o=a&&!df(function(){var t=!1,n=/a/;return"split"===e&&((n={}).constructor={},n.constructor[pf]=function(){return n;},n.flags="",n[r]=/./[r]),n.exec=function(){return t=!0,null;},n[r](""),!t;});if(!a||!o||n){var s=sf(/./[r]),c=t(r,""[e],function(e,t,n,i,r){var o=sf(e),c=t.exec;return c===uf||c===ff.exec?a&&!r?{done:!0,value:s(t,n,i)}:{done:!0,value:o(n,t,i)}:{done:!1};});cf(String.prototype,e,c[0]),cf(ff,r,c[1]);}i&&hf(ff[r],"sham",!0);},_f=hl.charAt,vf=function vf(e,t,n){return t+(n?_f(e,t).length:1);},gf=ee,yf=lt,Sf=Math.floor,kf=gf("".charAt),bf=gf("".replace),Tf=gf("".slice),If=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,Ef=/\$([$&'`]|\d{1,2})/g,wf=M,Rf=un,Cf=_e,Af=Y,xf=of,Pf=TypeError,Df=function Df(e,t){var n=e.exec;if(Cf(n)){var i=wf(n,e,t);return null!==i&&Rf(i),i;}if("RegExp"===Af(e))return wf(xf,e,t);throw Pf("RegExp#exec called on incompatible receiver");},Of=jl,Nf=M,Mf=ee,Lf=mf,Uf=x,Vf=un,Ff=_e,jf=oe,Bf=Ri,Hf=Ni,Gf=il,Wf=ue,zf=vf,Jf=Xe,qf=function qf(e,t,n,i,r,a){var o=n+e.length,s=i.length,c=Ef;return void 0!==r&&(r=yf(r),c=If),bf(a,c,function(a,c){var u;switch(kf(c,0)){case"$":return"$";case"&":return e;case"`":return Tf(t,0,n);case"'":return Tf(t,o);case"<":u=r[Tf(c,1,-1)];break;default:var d=+c;if(0===d)return a;if(d>s){var l=Sf(d/10);return 0===l?a:l<=s?void 0===i[l-1]?kf(c,1):i[l-1]+kf(c,1):a;}u=i[d-1];}return void 0===u?"":u;});},Kf=Df,Qf=xt("replace"),Xf=Math.max,Yf=Math.min,$f=Mf([].concat),Zf=Mf([].push),em=Mf("".indexOf),tm=Mf("".slice),nm="$0"==="a".replace(/./,"$0"),im=!!/./[Qf]&&""===/./[Qf]("a","$0"),rm=!Uf(function(){var e=/./;return e.exec=function(){var e=[];return e.groups={a:"7"},e;},"7"!=="".replace(e,"$<a>");});Lf("replace",function(e,t,n){var i=im?"$":"$0";return[function(e,n){var i=Wf(this),r=jf(e)?void 0:Jf(e,Qf);return r?Nf(r,e,i,n):Nf(t,Gf(i),e,n);},function(e,r){var a=Vf(this),o=Gf(e);if("string"==typeof r&&-1===em(r,i)&&-1===em(r,"$<")){var s=n(t,a,o,r);if(s.done)return s.value;}var c=Ff(r);c||(r=Gf(r));var u=a.global;if(u){var d=a.unicode;a.lastIndex=0;}for(var l=[];;){var h=Kf(a,o);if(null===h)break;if(Zf(l,h),!u)break;""===Gf(h[0])&&(a.lastIndex=zf(o,Hf(a.lastIndex),d));}for(var p,f="",m=0,_=0;_<l.length;_++){for(var v=Gf((h=l[_])[0]),g=Xf(Yf(Bf(h.index),o.length),0),y=[],S=1;S<h.length;S++){Zf(y,void 0===(p=h[S])?p:String(p));}var k=h.groups;if(c){var b=$f([v],y,g,o);void 0!==k&&Zf(b,k);var T=Gf(Of(r,void 0,b));}else T=qf(v,o,g,y,k,r);g>=m&&(f+=tm(o,m,g)+T,m=g+v.length);}return f+tm(o,m);}];},!rm||!nm||im);var am=M,om=ft,sm=Ie,cm=Rp,um=RegExp.prototype,dm=function dm(e){var t=e.flags;return void 0!==t||"flags"in um||om(e,"flags")||!sm(um,e)?t:am(cm,e);},lm=xn.PROPER,hm=bi,pm=un,fm=il,mm=x,_m=dm,vm="toString",gm=RegExp.prototype.toString,ym=mm(function(){return"/a/b"!=gm.call({source:"a",flags:"b"});}),Sm=lm&&gm.name!=vm;(ym||Sm)&&hm(RegExp.prototype,vm,function(){var e=pm(this);return"/"+fm(e.source)+"/"+fm(_m(e));},{unsafe:!0});var km=x,bm=xt("iterator"),Tm=!km(function(){var e=new URL("b?a=1&b=2&c=3","http://a"),t=e.searchParams,n="";return e.pathname="c%20d",t.forEach(function(e,i){t.delete("b"),n+=i+e;}),!t.sort||"http://a/c%20d?a=1&c=3"!==e.href||"3"!==t.get("c")||"a=1"!==String(new URLSearchParams("?a=1"))||!t[bm]||"a"!==new URL("https://a@b").username||"b"!==new URLSearchParams(new URLSearchParams("a=b")).get("a")||"xn--e1aybc"!==new URL("http://тест").host||"#%D0%B1"!==new URL("http://a#б").hash||"a1c3"!==n||"x"!==new URL("http://x",void 0).host;}),Im=Qc,Em=Math.floor,wm=function wm(e,t){var n=e.length,i=Em(n/2);return n<8?Rm(e,t):Cm(e,wm(Im(e,0,i),t),wm(Im(e,i),t),t);},Rm=function Rm(e,t){for(var n,i,r=e.length,a=1;a<r;){for(i=a,n=e[a];i&&t(e[i-1],n)>0;){e[i]=e[--i];}i!==a++&&(e[i]=n);}return e;},Cm=function Cm(e,t,n,i){for(var r=t.length,a=n.length,o=0,s=0;o<r||s<a;){e[o+s]=o<r&&s<a?i(t[o],n[s])<=0?t[o++]:n[s++]:o<r?t[o++]:n[s++];}return e;},Am=wm,xm=Ir,Pm=C,Dm=M,Om=ee,Nm=P,Mm=Tm,Lm=bi,Um=Nd,Vm=Gs,Fm=Xs,jm=ai,Bm=sd,Hm=_e,Gm=ft,Wm=Cr,zm=Fr,Jm=un,qm=ye,Km=il,Qm=ls,Xm=H,Ym=ju,$m=Ou,Zm=Gl,e_=Am,t_=xt("iterator"),n_="URLSearchParams",i_="URLSearchParamsIterator",r_=jm.set,a_=jm.getterFor(n_),o_=jm.getterFor(i_),s_=Object.getOwnPropertyDescriptor,c_=function c_(e){if(!Nm)return Pm[e];var t=s_(Pm,e);return t&&t.value;},u_=c_("fetch"),d_=c_("Request"),l_=c_("Headers"),h_=d_&&d_.prototype,p_=l_&&l_.prototype,f_=Pm.RegExp,m_=Pm.TypeError,__=Pm.decodeURIComponent,v_=Pm.encodeURIComponent,g_=Om("".charAt),y_=Om([].join),S_=Om([].push),k_=Om("".replace),b_=Om([].shift),T_=Om([].splice),I_=Om("".split),E_=Om("".slice),w_=/\+/g,R_=Array(4),C_=function C_(e){return R_[e-1]||(R_[e-1]=f_("((?:%[\\da-f]{2}){"+e+"})","gi"));},A_=function A_(e){try{return __(e);}catch(XJ){return e;}},x_=function x_(e){var t=k_(e,w_," "),n=4;try{return __(t);}catch(XJ){for(;n;){t=k_(t,C_(n--),A_);}return t;}},P_=/[!'()~]|%20/g,D_={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+"},O_=function O_(e){return D_[e];},N_=function N_(e){return k_(v_(e),P_,O_);},M_=Fm(function(e,t){r_(this,{type:i_,iterator:Ym(a_(e).entries),kind:t});},"Iterator",function(){var e=o_(this),t=e.kind,n=e.iterator.next(),i=n.value;return n.done||(n.value="keys"===t?i.key:"values"===t?i.value:[i.key,i.value]),n;},!0),L_=function L_(e){this.entries=[],this.url=null,void 0!==e&&(qm(e)?this.parseObject(e):this.parseQuery("string"==typeof e?"?"===g_(e,0)?E_(e,1):e:Km(e)));};L_.prototype={type:n_,bindURL:function bindURL(e){this.url=e,this.update();},parseObject:function parseObject(e){var t,n,i,r,a,o,s,c=$m(e);if(c)for(n=(t=Ym(e,c)).next;!(i=Dm(n,t)).done;){if(a=(r=Ym(Jm(i.value))).next,(o=Dm(a,r)).done||(s=Dm(a,r)).done||!Dm(a,r).done)throw m_("Expected sequence with length 2");S_(this.entries,{key:Km(o.value),value:Km(s.value)});}else for(var u in e){Gm(e,u)&&S_(this.entries,{key:u,value:Km(e[u])});}},parseQuery:function parseQuery(e){if(e)for(var t,n,i=I_(e,"&"),r=0;r<i.length;){(t=i[r++]).length&&(n=I_(t,"="),S_(this.entries,{key:x_(b_(n)),value:x_(y_(n,"="))}));}},serialize:function serialize(){for(var e,t=this.entries,n=[],i=0;i<t.length;){e=t[i++],S_(n,N_(e.key)+"="+N_(e.value));}return y_(n,"&");},update:function update(){this.entries.length=0,this.parseQuery(this.url.query);},updateURL:function updateURL(){this.url&&this.url.update();}};var U_=function U_(){Bm(this,V_);var e=arguments.length>0?arguments[0]:void 0;r_(this,new L_(e));},V_=U_.prototype;if(Um(V_,{append:function append(e,t){Zm(arguments.length,2);var n=a_(this);S_(n.entries,{key:Km(e),value:Km(t)}),n.updateURL();},delete:function _delete(e){Zm(arguments.length,1);for(var t=a_(this),n=t.entries,i=Km(e),r=0;r<n.length;){n[r].key===i?T_(n,r,1):r++;}t.updateURL();},get:function get(e){Zm(arguments.length,1);for(var t=a_(this).entries,n=Km(e),i=0;i<t.length;i++){if(t[i].key===n)return t[i].value;}return null;},getAll:function getAll(e){Zm(arguments.length,1);for(var t=a_(this).entries,n=Km(e),i=[],r=0;r<t.length;r++){t[r].key===n&&S_(i,t[r].value);}return i;},has:function has(e){Zm(arguments.length,1);for(var t=a_(this).entries,n=Km(e),i=0;i<t.length;){if(t[i++].key===n)return!0;}return!1;},set:function set(e,t){Zm(arguments.length,1);for(var n,i=a_(this),r=i.entries,a=!1,o=Km(e),s=Km(t),c=0;c<r.length;c++){(n=r[c]).key===o&&(a?T_(r,c--,1):(a=!0,n.value=s));}a||S_(r,{key:o,value:s}),i.updateURL();},sort:function sort(){var e=a_(this);e_(e.entries,function(e,t){return e.key>t.key?1:-1;}),e.updateURL();},forEach:function forEach(e){for(var t,n=a_(this).entries,i=Wm(e,arguments.length>1?arguments[1]:void 0),r=0;r<n.length;){i((t=n[r++]).value,t.key,this);}},keys:function keys(){return new M_(this,"keys");},values:function values(){return new M_(this,"values");},entries:function entries(){return new M_(this,"entries");}},{enumerable:!0}),Lm(V_,t_,V_.entries,{name:"entries"}),Lm(V_,"toString",function(){return a_(this).serialize();},{enumerable:!0}),Vm(U_,n_),xm({global:!0,constructor:!0,forced:!Mm},{URLSearchParams:U_}),!Mm&&Hm(l_)){var F_=Om(p_.has),j_=Om(p_.set),B_=function B_(e){if(qm(e)){var t,n=e.body;if(zm(n)===n_)return t=e.headers?new l_(e.headers):new l_(),F_(t,"content-type")||j_(t,"content-type","application/x-www-form-urlencoded;charset=UTF-8"),Qm(e,{body:Xm(0,Km(n)),headers:Xm(0,t)});}return e;};if(Hm(u_)&&xm({global:!0,enumerable:!0,dontCallGetSet:!0,forced:!0},{fetch:function fetch(e){return u_(e,arguments.length>1?B_(arguments[1]):{});}}),Hm(d_)){var H_=function H_(e){return Bm(this,h_),new d_(e,arguments.length>1?B_(arguments[1]):{});};h_.constructor=H_,H_.prototype=h_,xm({global:!0,constructor:!0,dontCallGetSet:!0,forced:!0},{Request:H_});}}var G_={URLSearchParams:U_,getState:a_},W_=Object.is||function(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t;},z_=M,J_=un,q_=oe,K_=ue,Q_=W_,X_=il,Y_=Xe,$_=Df;mf("search",function(e,t,n){return[function(t){var n=K_(this),i=q_(t)?void 0:Y_(t,e);return i?z_(i,t,n):new RegExp(t)[e](X_(n));},function(e){var i=J_(this),r=X_(e),a=n(t,i,r);if(a.done)return a.value;var o=i.lastIndex;Q_(o,0)||(i.lastIndex=0);var s=$_(i,r);return Q_(i.lastIndex,o)||(i.lastIndex=o),null===s?-1:s.index;}];});new Date().getTime();var Z_=0,ev=function ev(){return new Date().getTime()+Z_;},tv=function tv(){var e=new Date();return e.setTime(ev()),e.toLocaleString();},nv=M,iv=un,rv=oe,av=Ni,ov=il,sv=ue,cv=Xe,uv=vf,dv=Df;mf("match",function(e,t,n){return[function(t){var n=sv(this),i=rv(t)?void 0:cv(t,e);return i?nv(i,t,n):new RegExp(t)[e](ov(n));},function(e){var i=iv(this),r=ov(e),a=n(t,i,r);if(a.done)return a.value;if(!i.global)return dv(i,r);var o=i.unicode;i.lastIndex=0;for(var s,c=[],u=0;null!==(s=dv(i,r));){var d=ov(s[0]);c[u]=d,""===d&&(i.lastIndex=uv(r,av(i.lastIndex),o)),u++;}return 0===u?null:c;}];});var lv=ye,hv=Y,pv=xt("match"),fv=function fv(e){var t;return lv(e)&&(void 0!==(t=e[pv])?!!t:"RegExp"==hv(e));},mv=rn.f,_v=P,vv=C,gv=ee,yv=_r,Sv=_d,kv=Tn,bv=Ti.f,Tv=Ie,Iv=fv,Ev=il,wv=dm,Rv=Dp,Cv=function Cv(e,t,n){n in e||mv(e,n,{configurable:!0,get:function get(){return t[n];},set:function set(e){t[n]=e;}});},Av=bi,xv=x,Pv=ft,Dv=ai.enforce,Ov=Fd,Nv=Mp,Mv=Vp,Lv=xt("match"),Uv=vv.RegExp,Vv=Uv.prototype,Fv=vv.SyntaxError,jv=gv(Vv.exec),Bv=gv("".charAt),Hv=gv("".replace),Gv=gv("".indexOf),Wv=gv("".slice),zv=/^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/,Jv=/a/g,qv=/a/g,Kv=new Uv(Jv)!==Jv,Qv=Rv.MISSED_STICKY,Xv=Rv.UNSUPPORTED_Y,Yv=_v&&(!Kv||Qv||Nv||Mv||xv(function(){return qv[Lv]=!1,Uv(Jv)!=Jv||Uv(qv)==qv||"/a/i"!=Uv(Jv,"i");}));if(yv("RegExp",Yv)){for(var $v=function $v(e,t){var n,i,r,a,o,s,c=Tv(Vv,this),u=Iv(e),d=void 0===t,l=[],h=e;if(!c&&u&&d&&e.constructor===$v)return e;if((u||Tv(Vv,e))&&(e=e.source,d&&(t=wv(h))),e=void 0===e?"":Ev(e),t=void 0===t?"":Ev(t),h=e,Nv&&("dotAll"in Jv)&&(i=!!t&&Gv(t,"s")>-1)&&(t=Hv(t,/s/g,"")),n=t,Qv&&("sticky"in Jv)&&(r=!!t&&Gv(t,"y")>-1)&&Xv&&(t=Hv(t,/y/g,"")),Mv&&(a=function(e){for(var t,n=e.length,i=0,r="",a=[],o={},s=!1,c=!1,u=0,d="";i<=n;i++){if("\\"===(t=Bv(e,i)))t+=Bv(e,++i);else if("]"===t)s=!1;else if(!s)switch(!0){case"["===t:s=!0;break;case"("===t:jv(zv,Wv(e,i+1))&&(i+=2,c=!0),r+=t,u++;continue;case">"===t&&c:if(""===d||Pv(o,d))throw new Fv("Invalid capture group name");o[d]=!0,a[a.length]=[d,u],c=!1,d="";continue;}c?d+=t:r+=t;}return[r,a];}(e),e=a[0],l=a[1]),o=Sv(Uv(e,t),c?this:Vv,$v),(i||r||l.length)&&(s=Dv(o),i&&(s.dotAll=!0,s.raw=$v(function(e){for(var t,n=e.length,i=0,r="",a=!1;i<=n;i++){"\\"!==(t=Bv(e,i))?a||"."!==t?("["===t?a=!0:"]"===t&&(a=!1),r+=t):r+="[\\s\\S]":r+=t+Bv(e,++i);}return r;}(e),n)),r&&(s.sticky=!0),l.length&&(s.groups=l)),e!==h)try{kv(o,"source",""===h?"(?:)":h);}catch(XJ){}return o;},Zv=bv(Uv),eg=0;Zv.length>eg;){Cv($v,Uv,Zv[eg++]);}Vv.constructor=$v,$v.prototype=Vv,Av(vv,"RegExp",$v,{constructor:!0});}Ov("RegExp");var tg=ee(1..valueOf),ng='\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF',ig=ue,rg=il,ag=ee("".replace),og='[\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]',sg=RegExp("^"+og+og+"*"),cg=RegExp(og+og+"*$"),ug=function ug(e){return function(t){var n=rg(ig(t));return 1&e&&(n=ag(n,sg,"")),2&e&&(n=ag(n,cg,"")),n;};},dg={start:ug(1),end:ug(2),trim:ug(3)},lg=P,hg=C,pg=ee,fg=_r,mg=bi,_g=ft,vg=_d,gg=Ie,yg=Be,Sg=Vt,kg=x,bg=Ti.f,Tg=A.f,Ig=rn.f,Eg=tg,wg=dg.trim,Rg="Number",Cg=hg.Number,Ag=Cg.prototype,xg=hg.TypeError,Pg=pg("".slice),Dg=pg("".charCodeAt),Og=function Og(e){var t=Sg(e,"number");return"bigint"==typeof t?t:Ng(t);},Ng=function Ng(e){var t,n,i,r,a,o,s,c,u=Sg(e,"number");if(yg(u))throw xg("Cannot convert a Symbol value to a number");if("string"==typeof u&&u.length>2)if(u=wg(u),43===(t=Dg(u,0))||45===t){if(88===(n=Dg(u,2))||120===n)return NaN;}else if(48===t){switch(Dg(u,1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+u;}for(o=(a=Pg(u,2)).length,s=0;s<o;s++){if((c=Dg(a,s))<48||c>r)return NaN;}return parseInt(a,i);}return+u;};if(fg(Rg,!Cg(" 0o1")||!Cg("0b1")||Cg("+0x1"))){for(var Mg,Lg=function Lg(e){var t=arguments.length<1?0:Cg(Og(e)),n=this;return gg(Ag,n)&&kg(function(){Eg(n);})?vg(Object(t),n,Lg):t;},Ug=lg?bg(Cg):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","),Vg=0;Ug.length>Vg;Vg++){_g(Cg,Mg=Ug[Vg])&&!_g(Lg,Mg)&&Ig(Lg,Mg,Tg(Cg,Mg));}Lg.prototype=Ag,Ag.constructor=Lg,mg(hg,Rg,Lg,{constructor:!0});}var Fg=Ir,jg=Bi.indexOf,Bg=Eh,Hg=ee([].indexOf),Gg=!!Hg&&1/Hg([1],1,-0)<0,Wg=Bg("indexOf");Fg({target:"Array",proto:!0,forced:Gg||!Wg},{indexOf:function indexOf(e){var t=arguments.length>1?arguments[1]:void 0;return Gg?Hg(this,e,t)||0:jg(this,e,t);}});var zg=lt,Jg=xs,qg=bs;Ir({target:"Object",stat:!0,forced:x(function(){Jg(1);}),sham:!qg},{getPrototypeOf:function getPrototypeOf(e){return Jg(zg(e));}});var Kg=jl,Qg=qe,Xg=un;Ir({target:"Reflect",stat:!0,forced:!x(function(){Reflect.apply(function(){});})},{apply:function apply(e,t,n){return Kg(Qg(e),t,Xg(n));}});var Yg=P,$g=xn.EXISTS,Zg=ee,ey=rn.f,ty=Function.prototype,ny=Zg(ty.toString),iy=/function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,ry=Zg(iy.exec);Yg&&!$g&&ey(ty,"name",{configurable:!0,get:function get(){try{return ry(iy,ny(this))[1];}catch(XJ){return"";}}});var ay=Ir,oy=Date,sy=ee(oy.prototype.getTime);ay({target:"Date",stat:!0},{now:function now(){return sy(new oy());}});var cy,uy,dy,ly,hy="process"==Y(C.process),py=Zr,fy=Ge,my=TypeError,_y=function _y(e){if(py(e))return e;throw my(fy(e)+" is not a constructor");},vy=un,gy=_y,yy=oe,Sy=xt("species"),ky=function ky(e,t){var n,i=vy(e).constructor;return void 0===i||yy(n=vy(i)[Sy])?t:gy(n);},by=/(?:ipad|iphone|ipod).*applewebkit/i.test(Ee),Ty=C,Iy=jl,Ey=Cr,wy=_e,Ry=ft,Cy=x,Ay=Zo,xy=Bl,Py=zt,Dy=Gl,Oy=by,Ny=hy,My=Ty.setImmediate,Ly=Ty.clearImmediate,Uy=Ty.process,Vy=Ty.Dispatch,Fy=Ty.Function,jy=Ty.MessageChannel,By=Ty.String,Hy=0,Gy={},Wy="onreadystatechange";try{cy=Ty.location;}catch(XJ){}var zy=function zy(e){if(Ry(Gy,e)){var t=Gy[e];delete Gy[e],t();}},Jy=function Jy(e){return function(){zy(e);};},qy=function qy(e){zy(e.data);},Ky=function Ky(e){Ty.postMessage(By(e),cy.protocol+"//"+cy.host);};My&&Ly||(My=function My(e){Dy(arguments.length,1);var t=wy(e)?e:Fy(e),n=xy(arguments,1);return Gy[++Hy]=function(){Iy(t,void 0,n);},uy(Hy),Hy;},Ly=function Ly(e){delete Gy[e];},Ny?uy=function uy(e){Uy.nextTick(Jy(e));}:Vy&&Vy.now?uy=function uy(e){Vy.now(Jy(e));}:jy&&!Oy?(ly=(dy=new jy()).port2,dy.port1.onmessage=qy,uy=Ey(ly.postMessage,ly)):Ty.addEventListener&&wy(Ty.postMessage)&&!Ty.importScripts&&cy&&"file:"!==cy.protocol&&!Cy(Ky)?(uy=Ky,Ty.addEventListener("message",qy,!1)):uy=Wy in Py("script")?function(e){Ay.appendChild(Py("script")).onreadystatechange=function(){Ay.removeChild(this),zy(e);};}:function(e){setTimeout(Jy(e),0);});var Qy,Xy,Yy,$y,Zy,eS,tS,nS,iS={set:My,clear:Ly},rS=C,aS=/ipad|iphone|ipod/i.test(Ee)&&void 0!==rS.Pebble,oS=/web0s(?!.*chrome)/i.test(Ee),sS=C,cS=Cr,uS=A.f,dS=iS.set,lS=by,hS=aS,pS=oS,fS=hy,mS=sS.MutationObserver||sS.WebKitMutationObserver,_S=sS.document,vS=sS.process,gS=sS.Promise,yS=uS(sS,"queueMicrotask"),SS=yS&&yS.value;SS||(Qy=function Qy(){var e,t;for(fS&&(e=vS.domain)&&e.exit();Xy;){t=Xy.fn,Xy=Xy.next;try{t();}catch(XJ){throw Xy?$y():Yy=void 0,XJ;}}Yy=void 0,e&&e.enter();},lS||fS||pS||!mS||!_S?!hS&&gS&&gS.resolve?((tS=gS.resolve(void 0)).constructor=gS,nS=cS(tS.then,tS),$y=function $y(){nS(Qy);}):fS?$y=function $y(){vS.nextTick(Qy);}:(dS=cS(dS,sS),$y=function $y(){dS(Qy);}):(Zy=!0,eS=_S.createTextNode(""),new mS(Qy).observe(eS,{characterData:!0}),$y=function $y(){eS.data=Zy=!Zy;}));var kS=SS||function(e){var t={fn:e,next:void 0};Yy&&(Yy.next=t),Xy||(Xy=t,$y()),Yy=t;},bS=C,TS=function TS(e){try{return{error:!1,value:e()};}catch(XJ){return{error:!0,value:XJ};}},IS=function IS(){this.head=null,this.tail=null;};IS.prototype={add:function add(e){var t={item:e,next:null};this.head?this.tail.next=t:this.head=t,this.tail=t;},get:function get(){var e=this.head;if(e)return this.head=e.next,this.tail===e&&(this.tail=null),e.item;}};var ES=IS,wS=C.Promise,RS="object"==(typeof Deno==='undefined'?'undefined':_typeof2(Deno))&&Deno&&"object"==_typeof2(Deno.version),CS=!RS&&!hy&&"object"==(typeof window==='undefined'?'undefined':_typeof2(window))&&"object"==(typeof document==='undefined'?'undefined':_typeof2(document)),AS=C,xS=wS,PS=_e,DS=_r,OS=Un,NS=xt,MS=CS,LS=RS,US=De;xS&&xS.prototype;var VS=NS("species"),FS=!1,jS=PS(AS.PromiseRejectionEvent),BS=DS("Promise",function(){var e=OS(xS),t=e!==String(xS);if(!t&&66===US)return!0;if(!US||US<51||!/native code/.test(e)){var n=new xS(function(e){e(1);}),i=function i(e){e(function(){},function(){});};if((n.constructor={})[VS]=i,!(FS=n.then(function(){})instanceof i))return!0;}return!t&&(MS||LS)&&!jS;}),HS={CONSTRUCTOR:BS,REJECTION_EVENT:jS,SUBCLASSING:FS},GS={},WS=qe,zS=TypeError,JS=function JS(e){var t,n;this.promise=new e(function(e,i){if(void 0!==t||void 0!==n)throw zS("Bad Promise constructor");t=e,n=i;}),this.resolve=WS(t),this.reject=WS(n);};GS.f=function(e){return new JS(e);};var qS,KS,QS,XS=Ir,YS=hy,$S=C,ZS=M,ek=bi,tk=ic,nk=Gs,ik=Fd,rk=qe,ak=_e,ok=ye,sk=sd,ck=ky,uk=iS.set,dk=kS,lk=function lk(e,t){var n=bS.console;n&&n.error&&(1==arguments.length?n.error(e):n.error(e,t));},hk=TS,pk=ES,fk=ai,mk=wS,_k=GS,vk="Promise",gk=HS.CONSTRUCTOR,yk=HS.REJECTION_EVENT,Sk=HS.SUBCLASSING,kk=fk.getterFor(vk),bk=fk.set,Tk=mk&&mk.prototype,Ik=mk,Ek=Tk,wk=$S.TypeError,Rk=$S.document,Ck=$S.process,Ak=_k.f,xk=Ak,Pk=!!(Rk&&Rk.createEvent&&$S.dispatchEvent),Dk="unhandledrejection",Ok=function Ok(e){var t;return!(!ok(e)||!ak(t=e.then))&&t;},Nk=function Nk(e,t){var n,i,r,a=t.value,o=1==t.state,s=o?e.ok:e.fail,c=e.resolve,u=e.reject,d=e.domain;try{s?(o||(2===t.rejection&&Fk(t),t.rejection=1),!0===s?n=a:(d&&d.enter(),n=s(a),d&&(d.exit(),r=!0)),n===e.promise?u(wk("Promise-chain cycle")):(i=Ok(n))?ZS(i,n,c,u):c(n)):u(a);}catch(XJ){d&&!r&&d.exit(),u(XJ);}},Mk=function Mk(e,t){e.notified||(e.notified=!0,dk(function(){for(var n,i=e.reactions;n=i.get();){Nk(n,e);}e.notified=!1,t&&!e.rejection&&Uk(e);}));},Lk=function Lk(e,t,n){var i,r;Pk?((i=Rk.createEvent("Event")).promise=t,i.reason=n,i.initEvent(e,!1,!0),$S.dispatchEvent(i)):i={promise:t,reason:n},!yk&&(r=$S["on"+e])?r(i):e===Dk&&lk("Unhandled promise rejection",n);},Uk=function Uk(e){ZS(uk,$S,function(){var t,n=e.facade,i=e.value;if(Vk(e)&&(t=hk(function(){YS?Ck.emit("unhandledRejection",i,n):Lk(Dk,n,i);}),e.rejection=YS||Vk(e)?2:1,t.error))throw t.value;});},Vk=function Vk(e){return 1!==e.rejection&&!e.parent;},Fk=function Fk(e){ZS(uk,$S,function(){var t=e.facade;YS?Ck.emit("rejectionHandled",t):Lk("rejectionhandled",t,e.value);});},jk=function jk(e,t,n){return function(i){e(t,i,n);};},Bk=function Bk(e,t,n){e.done||(e.done=!0,n&&(e=n),e.value=t,e.state=2,Mk(e,!0));},Hk=function Hk(e,t,n){if(!e.done){e.done=!0,n&&(e=n);try{if(e.facade===t)throw wk("Promise can't be resolved itself");var i=Ok(t);i?dk(function(){var n={done:!1};try{ZS(i,t,jk(Hk,n,e),jk(Bk,n,e));}catch(XJ){Bk(n,XJ,e);}}):(e.value=t,e.state=1,Mk(e,!1));}catch(XJ){Bk({done:!1},XJ,e);}}};if(gk&&(Ek=(Ik=function Ik(e){sk(this,Ek),rk(e),ZS(qS,this);var t=kk(this);try{e(jk(Hk,t),jk(Bk,t));}catch(XJ){Bk(t,XJ);}}).prototype,(qS=function qS(e){bk(this,{type:vk,done:!1,notified:!1,parent:!1,reactions:new pk(),rejection:!1,state:0,value:void 0});}).prototype=ek(Ek,"then",function(e,t){var n=kk(this),i=Ak(ck(this,Ik));return n.parent=!0,i.ok=!ak(e)||e,i.fail=ak(t)&&t,i.domain=YS?Ck.domain:void 0,0==n.state?n.reactions.add(i):dk(function(){Nk(i,n);}),i.promise;}),KS=function KS(){var e=new qS(),t=kk(e);this.promise=e,this.resolve=jk(Hk,t),this.reject=jk(Bk,t);},_k.f=Ak=function Ak(e){return e===Ik||undefined===e?new KS(e):xk(e);},ak(mk)&&Tk!==Object.prototype)){QS=Tk.then,Sk||ek(Tk,"then",function(e,t){var n=this;return new Ik(function(e,t){ZS(QS,n,e,t);}).then(e,t);},{unsafe:!0});try{delete Tk.constructor;}catch(XJ){}tk&&tk(Tk,Ek);}XS({global:!0,constructor:!0,wrap:!0,forced:gk},{Promise:Ik}),nk(Ik,vk,!1),ik(vk);var Gk=wS,Wk=HS.CONSTRUCTOR||!hd(function(e){Gk.all(e).then(void 0,function(){});}),zk=M,Jk=qe,qk=GS,Kk=TS,Qk=rd;Ir({target:"Promise",stat:!0,forced:Wk},{all:function all(e){var t=this,n=qk.f(t),i=n.resolve,r=n.reject,a=Kk(function(){var n=Jk(t.resolve),a=[],o=0,s=1;Qk(e,function(e){var c=o++,u=!1;s++,zk(n,t,e).then(function(e){u||(u=!0,a[c]=e,--s||i(a));},r);}),--s||i(a);});return a.error&&r(a.value),n.promise;}});var Xk=Ir,Yk=HS.CONSTRUCTOR,$k=wS,Zk=Te,eb=_e,tb=bi,nb=$k&&$k.prototype;if(Xk({target:"Promise",proto:!0,forced:Yk,real:!0},{catch:function _catch(e){return this.then(void 0,e);}}),eb($k)){var ib=Zk("Promise").prototype.catch;nb.catch!==ib&&tb(nb,"catch",ib,{unsafe:!0});}var rb=M,ab=qe,ob=GS,sb=TS,cb=rd;Ir({target:"Promise",stat:!0,forced:Wk},{race:function race(e){var t=this,n=ob.f(t),i=n.reject,r=sb(function(){var r=ab(t.resolve);cb(e,function(e){rb(r,t,e).then(n.resolve,i);});});return r.error&&i(r.value),n.promise;}});var ub=M,db=GS;Ir({target:"Promise",stat:!0,forced:HS.CONSTRUCTOR},{reject:function reject(e){var t=db.f(this);return ub(t.reject,void 0,e),t.promise;}});var lb=un,hb=ye,pb=GS,fb=Ir,mb=HS.CONSTRUCTOR,_b=function _b(e,t){if(lb(e),hb(t)&&t.constructor===e)return t;var n=pb.f(e);return(0,n.resolve)(t),n.promise;};Te("Promise"),fb({target:"Promise",stat:!0,forced:mb},{resolve:function resolve(e){return _b(this,e);}});var vb=C,gb=x,yb=il,Sb=dg.trim,kb=ee("".charAt),bb=vb.parseFloat,Tb=vb.Symbol,Ib=Tb&&Tb.iterator,Eb=1/bb('\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF-0')!=-Infinity||Ib&&!gb(function(){bb(Object(Ib));})?function(e){var t=Sb(yb(e)),n=bb(t);return 0===n&&"-"==kb(t,0)?-0:n;}:bb;Ir({global:!0,forced:parseFloat!=Eb},{parseFloat:Eb});var wb=window.navigator&&window.navigator.userAgent||"",Rb=/AppleWebKit\/([\d.]+)/i.exec(wb);Rb&&parseFloat(Rb.pop());var Cb=/iPad/i.test(wb),Ab=navigator.maxTouchPoints&&navigator.maxTouchPoints>2&&/Macintosh/.test(wb),xb=/iPhone/i.test(wb)&&!Cb,Pb=/iPod/i.test(wb),Db=xb||Cb||Pb||Ab,Ob=/Android/i.test(wb);Ob&&function(){var e=wb.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);if(!e)return null;var t=e[1]&&parseFloat(e[1]),n=e[2]&&parseFloat(e[2]);t&&n&&parseFloat(e[1]+"."+e[2]);}();Ob&&/webkit/i.test(wb);var Nb=/Firefox/i.test(wb),Mb=Nb&&function(){var e=wb.match(/Firefox\/(\d+)/);return e&&e[1]?parseFloat(e[1]):null;}(),Lb=/Edge\//i.test(wb),Ub=Lb&&function(){var e=wb.match(/Edge\/(\d+)/i);if(e&&e[1])return e[1];}(),Vb=/Edg\//i.test(wb),Fb=Vb&&function(){var e=wb.match(/Edg\/(\d+)/);return e&&e[1]?parseFloat(e[1]):null;}(),jb=/SogouMobileBrowser\//i.test(wb),Bb=jb&&function(){var e=wb.match(/SogouMobileBrowser\/(\d+)/);return e&&e[1]?parseFloat(e[1]):null;}(),Hb=/MetaSr\s/i.test(wb),Gb=Hb&&function(){var e=wb.match(/MetaSr(\s\d+(\.\d+)+)/);return e&&e[1]?parseFloat(e[1]):null;}(),Wb=/TBS\/\d+/i.test(wb),zb=Wb&&function(){var e=wb.match(/TBS\/(\d+)/i);if(e&&e[1])return e[1];}(),Jb=/XWEB\/\d+/i.test(wb),qb=Jb&&function(){var e=wb.match(/XWEB\/(\d+)/i);if(e&&e[1])return e[1];}();/MSIE\s8\.0/.test(wb),/MSIE\/\d+/i.test(wb)&&function(){var e=/MSIE\s(\d+)\.\d/.exec(wb),t=e&&parseFloat(e[1]);!t&&/Trident\/7.0/i.test(wb)&&/rv:11.0/.test(wb)&&(t=11);}();var Kb=/(micromessenger|webbrowser)/i.test(wb),Qb=Kb&&function(){var e=wb.match(/MicroMessenger\/(\d+)/i);if(e&&e[1])return e[1];}(),Xb=!Wb&&/MQQBrowser\/\d+/i.test(wb)&&/COVC\/\d+/i.test(wb),Yb=!Wb&&/MQQBrowser\/\d+/i.test(wb)&&!/COVC\/\d+/i.test(wb),$b=(Yb||Xb)&&function(){var e=wb.match(/ MQQBrowser\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),Zb=!Wb&&/ QQBrowser\/\d+/i.test(wb),eT=Zb&&function(){var e=wb.match(/ QQBrowser\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),tT=!Wb&&/QQBrowserLite\/\d+/i.test(wb),nT=tT&&function(){var e=wb.match(/QQBrowserLite\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),iT=!Wb&&/MQBHD\/\d+/i.test(wb),rT=iT&&function(){var e=wb.match(/MQBHD\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),aT=/Windows/i.test(wb),oT=!Db&&/MAC OS X/i.test(wb),sT=!Ob&&/Linux/i.test(wb);/MicroMessenger/i.test(wb);var cT=/UCBrowser/i.test(wb);/Electron/i.test(wb);var uT,dT,lT=/MiuiBrowser/i.test(wb),hT=lT&&function(){var e=wb.match(/MiuiBrowser\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),pT=/HuaweiBrowser/i.test(wb),fT=/Huawei/i.test(wb),mT=pT&&function(){var e=wb.match(/HuaweiBrowser\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),_T=/SamsungBrowser/i.test(wb),vT=_T&&function(){var e=wb.match(/SamsungBrowser\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),gT=/HeyTapBrowser/i.test(wb),yT=gT&&function(){var e=wb.match(/HeyTapBrowser\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),ST=/VivoBrowser/i.test(wb),kT=ST&&function(){var e=wb.match(/VivoBrowser\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),bT=function bT(){var e=wb.match(/Chrome\/(\d+)/);return e&&e[1]?Number(e[1]):null;},TT=/Chrome/i.test(wb),IT=!Lb&&!Hb&&!jb&&!Wb&&!Jb&&!Vb&&!Zb&&!lT&&!pT&&!_T&&!gT&&!ST&&/Chrome/i.test(wb),ET=IT&&bT(),wT=IT&&function(){var e=wb.match(/Chrome\/([\d.]+)/);return e&&e[1]?e[1]:null;}(),RT=!TT&&!Yb&&!Xb&&!tT&&!iT&&/Safari/i.test(wb),CT=function(){if(RT){var e=wb.match(/Version\/([\d.]+)/);if(e&&e[1])return e[1];}return"";}(),AT=/Android.*(wv|.0.0.0)/.test(wb),xT=function(){if(Ab)return CT;if(Db){var e=wb.match(/OS (\d+)_(\d+)/i);if(e&&e[1]){var t=e[1];return e[2]&&(t+=".".concat(e[2])),t;}}return"";}(),PT="15.1"===CT,DT="15.1"===xT,OT=14===(uT=Number(xT.split(".")[0]))||13===uT,NT="file:"===location.protocol||"localhost"===location.hostname||"127.0.0.1"===location.hostname,MT=function MT(){if(cA(dT))try{dT=window.localStorage;}catch(XJ){xx.warn(XJ),dT=!1;}return dT;},LT=new Map([[Nb,["Firefox",Mb]],[Vb,["Edg",Fb]],[IT,["Chrome",wT]],[RT,["Safari",CT]],[Wb,["TBS",zb]],[Jb,["XWEB",qb]],[Kb&&xb,["WeChat",Qb]],[Zb,["QQ(Win)",eT]],[Yb,["QQ(Mobile)",$b]],[Xb,["QQ(Mobile X5)",$b]],[tT,["QQ(Mac)",nT]],[iT,["QQ(iPad)",rT]],[lT,["MI",hT]],[pT,["HW",mT]],[_T,["Samsung",vT]],[gT,["OPPO",yT]],[ST,["VIVO",kT]],[Lb,["EDGE",Ub]],[jb,["SogouMobile",Bb]],[Hb,["Sogou",Gb]]]);function UT(){var e="unknown",t="unknown";return LT.get(!0)&&(e=LT.get(!0)[0],t=LT.get(!0)[1]),{name:e,version:t};}var VT=lt,FT=zo;Ir({target:"Object",stat:!0,forced:x(function(){FT(1);})},{keys:function keys(e){return FT(VT(e));}});var jT="canvas",BT="audio",HT="video",GT="screen",WT="small",zT="big",JT="auxiliary",qT="aux",KT="smallVideo",QT="user",XT="environment",YT="mute",$T="unmute",ZT="ended",eI="playing",tI="pause",nI="error",iI="loadeddata",rI="audioinput",aI="videoinput",oI="detail",sI="text",cI="main",uI="backup",dI="banned",lI="kick",hI="user_time_out",pI="room_disband",fI="sei-message",mI="PLAYING",_I="PAUSED",vI="STOPPED",gI="inactive",yI="sendonly",SI="recvonly",kI="add",bI="remove",TI="replace",II="track",EI="wss://trtc.rtc.qq.com",wI="wss://webrtc.qq.com",RI="qcloud",CI="trtc",AI="webrtc",xI="",PI="jssdk_log",DI="jssdk_event",OI="jssdk_new_endreport",NI=function NI(e){return xI=e;},MI=1,LI=2,UI="live",VI=20,FI=21,jI="anchor",BI="audience",HI="5Y2wZK8nANNAoVw6dSAHVjNxrD1ObBM2kBPV",GI="224d130c-7b5c-415b-aaa2-79c2eb5a6df2",WI=2,zI=cI,JI=JT,qI="unknown",KI="DISCONNECTED",QI="CONNECTING",XI="RECONNECTING",YI="CONNECTED",$I="new",ZI="connecting",eE="failed",tE="closed",nE="disconnected",iE="connected",rE="completed",aE=30,oE="join",sE="delta-join",cE="rejoin",uE="leave",dE="delta-leave",lE="publish",hE="delta-publish",pE="unpublish",fE="subscribe",mE="unsubscribe",_E="uplink-connection",vE="uplink-reconnection",gE="downlink-connection",yE="downlink-reconnection",SE="setLocalDescription",kE="setRemoteDescription",bE="iceConnectionState",TE="stream-initialize",IE="websocketConnectionState",EE="websocketReconnectionState",wE="update-stream",RE="recover-subscription",CE="start-mix-transcode",AE="stop-mix-transcode",xE="player-error",PE="schedule",DE="unsubscribe",OE="subscribe_change",NE="unified-plan",ME="plan-b",LE={MANUAL:"manual",PRESET_LAYOUT:"preset-layout"},UE={REMOTE:"$PLACE_HOLDER_REMOTE$"},VE={IT_AUDIO_VIDEO:0,IT_PICTURE:2,IT_CANVAS:3,IT_PURE_AUDIO:4,IT_PURE_VIDEO:5},FE="string",jE="number",BE="boolean",HE="array",GE="object",WE={ADD:kI,REMOVE:bI},zE={unknown:0,wifi:1,"4g":2,"3g":3,"2g":4,wired:5},JE=-1,qE=0,KE=1,QE=zT,XE=WT,YE=6048e5,$E="schedule.rtc.qq.com",ZE="schedule.rtc.qcloud.com",ew="schedule.rtc.tencentcloud.com",tw="schedule-ecdn.rtc.tencentcloud.com",nw="TRTC",iw="Client",rw="LocalStream",aw="RemoteStream",ow="Stream",sw="web.sdk.qcloud.com",cw="web.sdk.tencent.cn",uw="web.sdk.cloud.tencent.cn",dw="https://console.cloud.tencent.com/trtc",lw="https://".concat(sw,"/trtc/webrtc/doc"),hw="".concat(lw,"/zh-cn/"),pw="trtc_error_assistance",fw="default",mw="communications",_w={TRACE:0,DEBUG:1,INFO:2,WARN:3,ERROR:4,NONE:5},vw=Object.keys(_w),gw=["normal leave","timeout leave","kick","role change"],yw=2e3,Sw="ric",kw="raf",bw="interval",Tw="timeout",Iw="Resolution reset to 1080p, need to upgrade ability here https://cloud.tencent.com/document/product/647/85386",Ew=ue,ww=il,Rw=/"/g,Cw=ee("".replace),Aw=function Aw(e,t,n,i){var r=ww(Ew(e)),a="<"+t;return""!==n&&(a+=" "+n+'="'+Cw(ww(i),Rw,"&quot;")+'"'),a+">"+r+"</"+t+">";},xw=x,Pw=function Pw(e){return xw(function(){var t=""[e]('"');return t!==t.toLowerCase()||t.split('"').length>3;});},Dw=Aw;Ir({target:"String",proto:!0,forced:Pw("link")},{link:function link(e){return Dw(this,"a","href",e);}}),Ir({target:"Array",stat:!0},{isArray:xr});var Ow=Bi.includes,Nw=Ss;Ir({target:"Array",proto:!0,forced:x(function(){return!Array(1).includes();})},{includes:function includes(e){return Ow(this,e,arguments.length>1?arguments[1]:void 0);}}),Nw("includes");var Mw=fv,Lw=TypeError,Uw=function Uw(e){if(Mw(e))throw Lw("The method doesn't accept regular expressions");return e;},Vw=xt("match"),Fw=function Fw(e){var t=/./;try{"/./"[e](t);}catch(n){try{return t[Vw]=!1,"/./"[e](t);}catch(i){}}return!1;},jw=Ir,Bw=Uw,Hw=ue,Gw=il,Ww=Fw,zw=ee("".indexOf);jw({target:"String",proto:!0,forced:!Ww("includes")},{includes:function includes(e){return!!~zw(Gw(Hw(this)),Gw(Bw(e)),arguments.length>1?arguments[1]:void 0);}});var Jw="AVOID_REPEATED_CALL",qw="INVALID_PARAMETER_REQUIRED",Kw="INVALID_PARAMETER_TYPE",Qw="INVALID_PARAMETER_EMPTY",Xw="INVALID_PARAMETER_INSTANCE",Yw="INVALID_PARAMETER_RANGE",$w="API_CALL_TIMEOUT",Zw="SIGNAL_CHANNEL_RECONNECTION_FAILED",eR="SIGNAL_CHANNEL_SETUP_FAILED",tR="ERROR_MESSAGE",nR="EXCHANGE_SDP_TIMEOUT",iR="DOWNLINK_RECONNECTION_FAILED",rR="EXCHANGE_SDP_FAILED",aR="UPLINK_RECONNECTION_FAILED",oR="INVALID_PURE_AUDIO",sR="INVALID_STREAMID",cR="INVALID_USER_DEFINE_RECORDID",uR="INVALID_USER_DEFINE_PUSH_ARGS",dR="INVALID_PROXY",lR="INVALID_JOIN",hR="INVALID_ROOMID_STRING",pR="INVALID_ROOMID_INTEGER",fR="JOIN_ROOM_TIMEOUT",mR="JOIN_ROOM_FAILED",_R="REJOIN_ROOM_FAILED",vR="INVALID_DESTROY",gR="INVALID_PUBLISH",yR="INVALID_UNPUBLISH",SR="INVALID_AUDIENCE",kR="INVALID_INITIALIZE",bR="INVALID_DUPLICATE_PUBLISHING",TR="INVALID_REMOTE_STREAM",IR="SUBSCRIBE_FAILED",ER="INVALID_ROLE",wR="INVALID_OPERATION_SWITCH_ROLE",RR="SWITCH_ROLE_TIMEOUT",CR="SWITCH_ROLE_FAILED",AR="CLIENT_BANNED",xR="INVALID_OPERATION_START_PUBLISH_CDN",PR="INVALID_OPERATION_STOP_PUBLISH_CDN",DR="INVALID_STREAM_ID",OR="START_PUBLISH_CDN_FAILED",NR="STOP_PUBLISH_CDN_FAILED",MR="START_MIX_TRANSCODE",LR="STOP_MIX_TRANSCODE",UR="INVALID_AUDIO_VOLUME",VR="ENABLE_SMALL_STREAM_PUBLISHED",FR="DISABLE_SMALL_STREAM_PUBLISHED",jR="NOT_SUPPORTED_SMALL_STREAM",BR="INVALID_SMALL_STREAM_PROFILE",HR="INVALID_PARAMETER_REMOTE_STREAM",GR="INVALID_SWITCH_DEVICE",WR="INVALID_SWITCH_DEVICE_PUBLISHING",zR="INVALID_REPLACE_TRACK",JR="INVALID_INITIALIZE_LOCAL_STREAM",qR="INVALID_ADD_TRACK_REPETITIVE",KR="INVALID_ADD_TRACK_REMOVING",QR="INVALID_ADD_TRACK_PUBLISHING",XR="INVALID_STREAM_INITIALIZED",YR="INVALID_ADD_TRACK_NUMBER",$R="INVALID_REMOVE_AUDIO_TRACK",ZR="INVALID_REMOVE_AUDIO_ADDING",eC="INVALID_REMOVE_AUDIO_ON",tC="INVALID_REMOVE_TRACK_PUBLISHING",nC="INVALID_REMOVE_TRACK_NOT_PUBLISHING",iC="INVALID_REMOVE_TRACK_NUMBER",rC="INVALID_REPLACE_TRACK_NO_TRACK",aC="REPEAT_JOIN",oC="CLIENT_DESTROYED",sC="START_MIX_TRANSCODE_FAILED",cC="STOP_MIX_TRANSCODE_FAILED",uC="MIX_TRANSCODE_NOT_STARTED",dC="CANNOT_LESS_THAN_ZERO",lC="MIX_PARAMS_VIDEO_FRAMERATE",hC="MIX_PARAMS_VIDEO_GOP",pC="MIX_PARAMS_AUDIO_BITRATE",fC="MIX_PARAMS_USER_Z_ORDER",mC="MIX_PARAMS_NOT_SELF",_C="MIX_PARAMS_USER_STREAM",vC="INVALID_ELEMENT_ID",gC="INVALID_ELEMENT_ID_TYPE",yC="PLAY_FAILED",SC="INVALID_CREATE_STREAM_SOURCE",kC="INVALID_CREATE_STREAM_SCREEN",bC="INVALID_CREATE_STREAM_AUDIO",TC="INVALID_CREATE_STREAM_SCREEN_AUDIO",IC="NOT_SUPPORTED_HTTP",EC="NOT_SUPPORTED_WEBRTC",wC="NOT_SUPPORTED_PROFILE",RC="NOT_SUPPORTED_H264ENCODE",CC="NOT_SUPPORTED_H264DECODE",AC="NOT_SUPPORTED_TRACK",xC="NOT_SUPPORTED_SWITCH_DEVICE",PC="NOT_SUPPORTED_CAPTURE",DC="NOT_SUPPORTED_AUX",OC="MICROPHONE_NOT_FOUND",NC="CAMERA_NOT_FOUND",MC="SIGNAL_RESPONSE_FAILED",LC="CATCH_HANDLER_ERROR",UC="API_NOT_EXIST",VC="CONNECTION_CLOSED",FC="SUBSCRIBE_ALL_FALSE",jC="SEI_NOT_SUPPORT",BC="SEI_DISABLED",HC="SEI_EMPTY",GC="SEI_OVERSIZE",WC="SEI_BEFORE_PUBLISH",zC="SEI_NOT_VIDEO",JC="CALL_FREQUENCY_LIMIT",qC="CONNECTION_ABORTED",KC="API_CALL_ABORTED",QC="DUPLICATE_AUX",XC={AVOID_REPEATED_CALL:function AVOID_REPEATED_CALL(e){return"previous ".concat(e.name,"() is ongoing, please avoid repeated calls.");},INVALID_PARAMETER_REQUIRED:function INVALID_PARAMETER_REQUIRED(e){var t=e.key,n=e.rule,i=e.fnName,r=e.value;return"'".concat(t||n.name,"' is a required param when calling ").concat(i,"(), received: ").concat(r,".");},INVALID_PARAMETER_TYPE:function INVALID_PARAMETER_TYPE(e){var t=e.key,n=e.rule,i=e.fnName,r=e.value,a="".concat(t||n.name),o="";return o=Array.isArray(n.type)?n.type.join("|"):n.type,"'".concat(a,"' must be type of ").concat(o," when calling ").concat(i,"(), received type: ").concat(mA(r),".");},INVALID_PARAMETER_EMPTY:function INVALID_PARAMETER_EMPTY(e){var t=e.key,n=e.rule,i=e.fnName,r=e.value;return"'".concat(t||n.name,"' cannot be '").concat(r,"' when calling ").concat(i,"().");},INVALID_PARAMETER_INSTANCE:function INVALID_PARAMETER_INSTANCE(e){var t=e.key,n=e.rule,i=e.fnName,r=e.value,a="".concat(t||n.name),o="".concat(n.instanceOf.name||n.instanceOf);return"'".concat(a,"' must be instanceof ").concat(o," when calling ").concat(i,"(), received type: ").concat(mA(r),".");},INVALID_PARAMETER_RANGE:function INVALID_PARAMETER_RANGE(e){var t=e.key,n=e.rule,i=e.fnName,r=e.value;return"'".concat(t||n.name,"' must be one of ").concat(n.values.join("|")," when calling ").concat(i,"(), received: ").concat(r,".");},API_CALL_TIMEOUT:function API_CALL_TIMEOUT(e){return"".concat(e.commandDesc||e.command," timeout observed.");},SIGNAL_CHANNEL_RECONNECTION_FAILED:"signal channel reconnection failed, please check your network.",SIGNAL_CHANNEL_SETUP_FAILED:function SIGNAL_CHANNEL_SETUP_FAILED(e){return"SignalChannel setup failure: (errorCode: ".concat(e.errorCode,", errorMsg: ").concat(e.errorMsg," }).");},ERROR_MESSAGE:function ERROR_MESSAGE(e){var t="".concat(e.type," failed");return e.message&&(t="".concat(t,": ").concat(e.message,".")),t;},EXCHANGE_SDP_TIMEOUT:"exchange sdp timeout.",DOWNLINK_RECONNECTION_FAILED:"downlink reconnection failed, please check your network and re-join room.",EXCHANGE_SDP_FAILED:function EXCHANGE_SDP_FAILED(e){return"exchange sdp failed ".concat(e.errMsg,".");},UPDATE_OFFER_TIMEOUT:"update offer timeout observed.",UPLINK_RECONNECTION_FAILED:"uplink reconnection failed, please check your network and publish again.",INVALID_RECORDID:"recordId must be an integer number.",INVALID_PURE_AUDIO:"pureAudioPushMode must be 1 or 2.",INVALID_STREAMID:"streamId must be a sting literal within 64 bytes, and not be empty.",INVALID_USER_DEFINE_RECORDID:"userDefineRecordId must be a sting literal contains (a-zA-Z),(0-9), underline and hyphen, within 64 bytes, and not be empty.",INVALID_USER_DEFINE_PUSH_ARGS:"userDefinePushArgs must be a sting literal within 256 bytes, and not be empty.",INVALID_PROXY:'proxy server url must start with "wss://".',INVALID_JOIN:"duplicate join() called.",INVALID_ROOMID_STRING:function INVALID_ROOMID_STRING(e){return"'".concat(e,"' must be validate string when useStringRoomId is true.");},INVALID_ROOMID_INTEGER:function INVALID_ROOMID_INTEGER(e){return"'".concat(e,"' must be an integer between [1, 4294967294] when useStringRoomId is false.");},INVALID_SIGNAL_CHANNEL:"SignalChannel is not ready yet.",JOIN_ROOM_TIMEOUT:"join room timeout.",JOIN_ROOM_FAILED:function JOIN_ROOM_FAILED(e){var t=e.error,n=e.code;return"Failed to join room - ".concat(t," code: ").concat(n);},REJOIN_ROOM_FAILED:function REJOIN_ROOM_FAILED(e){return"reJoin room: ".concat(e.roomId," failed, please check your network.");},INVALID_DESTROY:"please call leave() before destroy().",INVALID_PUBLISH:"please call join() before publish().",INVALID_UNPUBLISH:"stream has not been published yet.",INVALID_AUDIENCE:"no permission to publish() under live/".concat(BI,', please call switchRole("').concat(jI,'") firstly before publish().'),INVALID_INITIALIZE:"cannot publish stream because stream is not initialized, is switching device, or has been closed.",INVALID_DUPLICATE_PUBLISHING:function INVALID_DUPLICATE_PUBLISHING(e){return"duplicate ".concat(e," stream publishing, please unpublish your prev ").concat(e," stream and then re-publish.");},INVALID_SUBSCRIBE_UNDEFINED:"stream is undefined or null.",INVALID_SUBSCRIBE_LOCAL:"stream cannot be LocalStream.",INVALID_REMOTE_STREAM:"remoteStream does not exist because it has been unpublished by remote peer.",SUBSCRIBE_FAILED:function SUBSCRIBE_FAILED(e){var t=e.message,n=e.stream;return"failed to subscribe ".concat(n.getUserId()," ").concat(n.getType()," stream, reason: ").concat(t,".");},INVALID_ROLE:"switchRole can only be called in live mode.",INVALID_PARAMETER_SWITCH_ROLE:"role could only be set to a value as ".concat(jI," or ").concat(BI,"."),INVALID_OPERATION_SWITCH_ROLE:"please call join() before switchRole().",SWITCH_ROLE_TIMEOUT:"switchRole timeout.",SWITCH_ROLE_FAILED:function SWITCH_ROLE_FAILED(e){return"switchRole failed, errCode: ".concat(e.code," errMsg: ").concat(e.message,".");},CLIENT_BANNED:function CLIENT_BANNED(e){return"client was banned because of "+e.message+".";},INVALID_OPERATION_START_PUBLISH_CDN:"please call startPublishCDNStream() before client join the room or after client join the room and successfully publish the local stream.",INVALID_OPERATION_STOP_PUBLISH_CDN:"please call startPublishCDNStream() before stopPublishCDNStream().",START_PUBLISH_CDN_FAILED:function START_PUBLISH_CDN_FAILED(e){return"startPublishCDNStream failed, errMsg: ".concat(e.message,".");},STOP_PUBLISH_CDN_FAILED:function STOP_PUBLISH_CDN_FAILED(e){return"stopPublishCDNStream failed, errMsg: ".concat(e.message,".");},INVALID_STREAM_ID:function INVALID_STREAM_ID(e){return"'".concat(e,"' can only consist of uppercase and lowercase english letters (a-zA-Z), numbers (0-9), hyphens and underscores.");},START_MIX_TRANSCODE:"please call startMixTranscode() after join().",STOP_MIX_TRANSCODE:"please call stopMixTranscode() after startMixTranscode().",INVALID_AUDIO_VOLUME:"interval must be a number.",ENABLE_SMALL_STREAM_PUBLISHED:"Cannot enable small stream after localStream published.",DISABLE_SMALL_STREAM_PUBLISHED:"Cannot disable small stream after localStream published.",NOT_SUPPORTED_SMALL_STREAM:"your browser does not support opening small stream.",INVALID_SMALL_STREAM_PROFILE:"small stream profile is invalid.",INVALID_PARAMETER_REMOTE_STREAM:"remoteStream is invalid.",INVALID_OPERATION_CHANGE_SMALL:"cannot switch to the small stream without subscribing to the video of remoteStream.",REMOTE_NOT_PUBLISH_SMALL_STREAM:"remote peer does not publish small stream.",INVALID_SWITCH_DEVICE:"cannot switch device on current stream.",INVALID_SWITCH_DEVICE_PUBLISHING:"cannot switch device when publishing localStream.",INVALID_REPLACE_TRACK:"cannot replace track when publishing localStream.",INVALID_INITIALIZE_LOCAL_STREAM:"local stream has not initialized yet.",INVALID_ADD_TRACK_REPETITIVE:"previous addTrack is ongoing, please avoid repetitive execution.",INVALID_ADD_TRACK_REMOVING:"cannot add track when a track is removing.",INVALID_ADD_TRACK_PUBLISHING:"cannot add track when publishing localStream.",INVALID_STREAM_INITIALIZED:"your local stream haven't been initialized yet.",INVALID_ADD_TRACK_NUMBER:"a Stream has at most one audio track and one video track.",INVALID_REMOVE_AUDIO_TRACK:"remove audio track is not supported on your browser.",INVALID_REMOVE_AUDIO_ADDING:"cannot remove track when a track is adding.",INVALID_REMOVE_AUDIO_ON:"previous removeTrack is ongoing, please avoid repetitive execution.",INVALID_REMOVE_TRACK_PUBLISHING:"cannot remove track when publishing localStream.",INVALID_REMOVE_TRACK_NOT_PUBLISHING:"the track to be removed is not being publishing.",INVALID_REMOVE_TRACK_NUMBER:"remove the only video track is not supported, please use replaceTrack or muteVideo.",INVALID_REPLACE_TRACK_NO_TRACK:function INVALID_REPLACE_TRACK_NO_TRACK(e){return"cannot replace ".concat(e.kind," track because stream has not ").concat(e.kind," track");},START_MIX_TRANSCODE_FAILED:function START_MIX_TRANSCODE_FAILED(e){return"startMixTranscode failed, errMsg: ".concat(e.message,".");},STOP_MIX_TRANSCODE_FAILED:function STOP_MIX_TRANSCODE_FAILED(e){return"stopMixTranscode failed, errMsg: ".concat(e.message,".");},MIX_TRANSCODE_NOT_STARTED:"mixTranscode has not been started.",CANNOT_LESS_THAN_ZERO:function CANNOT_LESS_THAN_ZERO(e){var t=e.key,n=e.rule,i=e.fnName;return e.value,"'".concat(t||n.name,"' cannot be less than 0 when calling ").concat(i,"().");},MIX_PARAMS_VIDEO_FRAMERATE:"'config.videoFramerate' should be an integer between 0 and 30, excluding 0.",MIX_PARAMS_VIDEO_GOP:"'config.videoGOP' should be an integer between 1 and 8.",MIX_PARAMS_AUDIO_BITRATE:"'config.audioBitrate' should be an integer between 32 and 192.",MIX_PARAMS_USER_Z_ORDER:function MIX_PARAMS_USER_Z_ORDER(e){return"'".concat(e,"' is required and must be between 1 and 15.");},MIX_PARAMS_NOT_SELF:"'config.mixUsers' must contain self.",MIX_PARAMS_USER_STREAM:"'config.videoWidth' and 'config.videoHeight' of output stream should be contain all mix stream.",INVALID_PLAY:"duplicate play() call observed, please stop() firstly.",INVALID_ELEMENT_ID:function INVALID_ELEMENT_ID(e){var t=e.key,n=e.fnName;return"'".concat(t,"' is not found in the document object when calling ").concat(n,"().");},INVALID_ELEMENT_ID_TYPE:function INVALID_ELEMENT_ID_TYPE(e){var t=e.key,n=e.fnName,i=e.type;return"the element corresponding to '".concat(t,"' must be instanceof HTMLDivElement when calling ").concat(n,"(), received: ").concat(i,".");},PLAY_FAILED:function PLAY_FAILED(e){return"".concat(e.media," play failed，browser exception: ").concat(e.error.toString());},INVALID_USERID:"userId cannot be all spaces.",INVALID_CREATE_STREAM_SOURCE:"LocalStream must be created by createStream() with either audio/video or audioSource/videoSource, but can not be mixed with audio/video and audioSource/videoSource.",INVALID_CREATE_STREAM_SCREEN:"screen/video cannot be both true.",INVALID_CREATE_STREAM_AUDIO:"audio/screenAudio cannot be both true.",INVALID_CREATE_STREAM_SCREEN_AUDIO:"when screen is true, screenAudio can be configured.",NOT_SUPPORTED_HTTP:"http protocol does not support the ability to capture and publish streams, please use the https protocol.",NOT_SUPPORTED_WEBRTC:"your browser or environment does not support full WebRTC capabilities.",NOT_SUPPORTED_PROFILE:"your browser does not support setVideoProfile.",NOT_SUPPORTED_MEDIA:"your browser or environment does not support navigator.mediaDevices.",NOT_SUPPORTED_H264ENCODE:"your device does not support H.264 encoding.",NOT_SUPPORTED_H264DECODE:"your device does not support H.264 decoding.",NOT_SUPPORTED_TRACK:function NOT_SUPPORTED_TRACK(e){return"".concat(e,"Track is not supported on your browser.");},NOT_SUPPORTED_SWITCH_DEVICE:"switchDevice is not supported on your browser.",NOT_SUPPORTED_CAPTURE:"Your browser or environment does not support screen sharing, please check whether the browser version.",MICROPHONE_NOT_FOUND:"no microphone detected, please check your microphone and the configuration on TRTC.createStream.",CAMERA_NOT_FOUND:"no camera detected, please check your camera and the configuration on TRTC.createStream.",SIGNAL_RESPONSE_FAILED:function SIGNAL_RESPONSE_FAILED(e){return"".concat(e.signalResponse," failed, response code is ").concat(e.code," , errMsg: ").concat(e.message,".");},CATCH_HANDLER_ERROR:function CATCH_HANDLER_ERROR(e){var t=e.name,n=e.event;return"an error was caught on ".concat(t,".on('").concat(n,"', handler), please check your code on 'handler'.");},API_NOT_EXIST:function API_NOT_EXIST(e){var t=e.name;return"experimental api ".concat(t," does not exist.");},REPEAT_JOIN:function REPEAT_JOIN(e){return"[".concat(e,"] is calling client.join api or has already joined room, please avoid repeated join.");},CONNECTION_CLOSED:"remoteStream has been unsubscribed or unpublished by remote user.",SUBSCRIBE_ALL_FALSE:"cannot subscribe when both audio & video are false, use client.unsubscribe() instead",CLIENT_DESTROYED:function CLIENT_DESTROYED(e){var t=e.funName;return"failed to call ".concat(t,"() because client was destroyed.");},SEI_NOT_SUPPORT:function SEI_NOT_SUPPORT(e){return"not support to sendSEIMessage".concat(!1===e?" without using h264 codec":"");},SEI_DISABLED:"SEI is disabled, to enable SEI: TRTC.createClient({ enableSEI: true })",SEI_EMPTY:"buffer cannot be empty",SEI_OVERSIZE:function SEI_OVERSIZE(e){return"buffer size(".concat(e,") is over 1000 Bytes");},SEI_BEFORE_PUBLISH:"please call sendSEIMessage() after publish() success",SEI_NOT_VIDEO:"cannot send sei when localStream has not video.",CALL_FREQUENCY_LIMIT:function CALL_FREQUENCY_LIMIT(e){var t=e.isSize,n=e.name,i=e.timesInSecond,r=e.maxSizeInSecond;return"api ".concat(n," call ").concat(t?"size":"times"," is over ").concat(t?r+" bytes":i," in a second.");},CONNECTION_ABORTED:function CONNECTION_ABORTED(e){return"connection aborted due to: "+e;},API_CALL_ABORTED:function API_CALL_ABORTED(e){return e.message.includes("REMOTE_STREAM_NOT_EXIST")?"Subscribe ".concat(e.stream.getUserId()," ").concat(e.stream.getType()," stream aborted, reason: remote user ").concat(e.stream.getUserId()," unpublished stream."):"API aborted, reason: ".concat(e.message);},DUPLICATE_AUX:"only one auxiliary stream can be published in a room.",NOT_SUPPORTED_AUX:"publish auxiliary stream is not supported on your browser."},YC=function YC(e,t){return t?lw+"/"+e+"/"+t:lw+"/"+e+"/index.html";},$C=function $C(){if(!MT())return!1;var e=localStorage.getItem(pw);e&&!function(e){var t=e.saveTime&&new Date().getTime()-e.saveTime>=YE,n=!e.saveVersion||e.saveVersion!==Bo;return t||n;}(JSON.parse(e))||(xx.info("init debug info"),function(){var e=new XMLHttpRequest();if(e.open("GET","https://web.sdk.qcloud.com/trtc/webrtc/download/error-message/0.0.3/script.js",!1),e.send(null),4===e.readyState&&200===e.status){var t=document.createElement("script");t.type="text/javascript",t.text=e.responseText,document.body.appendChild(t),localStorage.setItem(pw,JSON.stringify({message:e.responseText,saveTime:new Date().getTime(),saveVersion:Bo})),document.body.removeChild(t);}}());};function ZC(e){var t=e.key,n=e.data,i=e.link,r=e.addDocLink,a=void 0===r||r,o="",s="",c="";sA(XC[t])?o=XC[t](n):uA(XC[t])&&(o=XC[t]);var u=function(){if(window.TRTC_ERROR_INFO&&window.TRTC_ERROR_LINK)return{TRTC_ERROR_INFO:window.TRTC_ERROR_INFO,TRTC_ERROR_LINK:window.TRTC_ERROR_LINK};var e=localStorage.getItem(pw);if(e){e=JSON.parse(e);var t=document.createElement("script");t.type="text/javascript",t.text=e.message,document.body.appendChild(t);var n=window.TRTC_ERROR_INFO,i=window.TRTC_ERROR_LINK;return document.body.removeChild(t),{TRTC_ERROR_INFO:n,TRTC_ERROR_LINK:i};}return{};}(),d=u.TRTC_ERROR_INFO,l=u.TRTC_ERROR_LINK;i?c="".concat(i.className,".html#").concat(i.fnName):l&&l[t]&&(sA(l[t])?c=l[t](n):uA(l[t])&&(c=l[t]));var h=o;return kA()&&(d&&d[t]&&(sA(d[t])?s=d[t](n):uA(d[t])&&(s=d[t])),s&&(h=a?s+"\n请查看文档: "+YC("zh-cn",c)+"\n\n":s+"\n\n",h+=o)),a&&(h+=" \nRefer to: "+YC("en",c)+"\n"),h;}var eA=function eA(){return function(e){var t=window.location.search.match(new RegExp("(\\?|&)"+e+"=([^&]*)(&|$)"));return t?decodeURIComponent(t[2]):"";}("trtc_env");},tA=function tA(e){return(e=Number(e))>0&&e<14e8;},nA=function nA(e,t){var n;n=xI||(tA(e)?"https://apisgp.my-imcloud.com":"https://yun.tim.qq.com");var i=Math.floor(Math.random()*Math.pow(2,31));return"".concat(n,"/v5/AVQualityReportSvc/C2S?random=").concat(i,"&sdkappid=").concat(e,"&cmdtype=").concat(t);};function iA(){var e=navigator.userAgent,t=navigator.connection,n=e.match(/NetType\/\w+/)?e.match(/NetType\/\w+/)[0]:"";"3gnet"===(n=n.toLowerCase().replace("nettype/",""))&&(n="3g");var i=t&&t.type&&t.type.toLowerCase(),r=t&&t.effectiveType&&t.effectiveType.toLowerCase();"slow-2"===r&&(r="2g");var a=n||"unknown";if(i)switch(i){case"cellular":case"wimax":a=r||"unknown";break;case"wifi":a="wifi";break;case"ethernet":a="wired";break;case"none":case"other":case"unknown":a="unknown";}return a;}var rA=function rA(e){if(!e||"object"!==i(e)||"[object Object]"!=Object.prototype.toString.call(e))return!1;var t=Object.getPrototypeOf(e);if(null===t)return!0;var n=Object.prototype.hasOwnProperty.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&Function.prototype.toString.call(n)===Function.prototype.toString.call(Object);};function aA(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;return e<=1?n:aA(e-1,n,t+n);}function oA(e){var t=Math.round(e/2)+1;return t>6?13e3:1e3*aA(t);}var sA=function sA(e){return"function"==typeof e;},cA=function cA(e){return void 0===e;},uA=function uA(e){return"string"==typeof e;},dA=function dA(e){return"number"==typeof e;},lA=function lA(e){return"boolean"==typeof e;},hA=function hA(e){return"object"===mA(e);},pA=function pA(e){return"array"===mA(e);},fA=function fA(e){return mA(e)==="MediaStreamTrack".toLowerCase();};function mA(e){return Reflect.apply(Object.prototype.toString,e,[]).replace(/^\[object\s(\w+)\]$/,"$1").toLowerCase();}function _A(e){var t={};return t.urls="turn:".concat(e.url),cA(e.username)||cA(e.credential)||(t.username=e.username,t.credential=e.credential,t.credentialType="password",cA(e.credentialType)||(t.credentialType=e.credentialType)),t;}function vA(){return performance&&performance.now?Math.floor(performance.now()):Date.now();}function gA(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"big";if(!uA(e))return 0;var n=e.split(".");return"big"===t?(Number(n[0])<<24|Number(n[1])<<16|Number(n[2])<<8|Number(n[3]))>>>0:(Number(n[3])<<24|Number(n[2])<<16|Number(n[1])<<8|Number(n[0]))>>>0;}var yA,SA,kA=function kA(){var e=navigator.language||navigator.userLanguage;return"zh"===(e=e.substr(0,2));},bA=(yA=!1,SA=document.visibilityState,function(){document.visibilityState!==SA&&xx.info("visibility change: ".concat(document.visibilityState)),yA||(document.addEventListener("visibilitychange",function(){xx.info("visibility change: "+document.visibilityState),SA=document.visibilityState;}),yA=!0);});window.AudioContext=window.AudioContext||window.webkitAudioContext||window.mozAudioContext;var TA=function TA(){return new window.AudioContext();},IA=function(){var e;return function(){if(e)return e;e=new window.AudioContext();return e.onstatechange=function(){xx.info("gain context state: ".concat(e.state)),"suspended"===e.state?(e.resume(),document.addEventListener("click",e.resume)):"interrupted"===e.state?e.resume():document.removeEventListener("click",e.resume);},e;};}(),EA=!!window.AudioWorkletNode,wA=function wA(e,t){var n=e.emit;return e.emit=function(){for(var i=arguments.length,r=new Array(i),a=0;a<i;a++){r[a]=arguments[a];}try{n.apply(e,r);}catch(XJ){var o=ZC({key:LC,data:{name:t,event:r[0]},addDocLink:!1});xx.warn(o+"\n\n"+XJ.stack);}},e;},RA=function RA(e){return+e<10?"0".concat(e):e;},CA=function CA(e){var t=e.match(/^\d+\.\d+\.\d+/)[0];if(!t)return e;var n=t.split("."),i=RA(n[1])+RA(n[2]);return n[1]-15>0&&(n[1]="15"),n[2]-15>0&&(n[2]="15"),n.join(".")+"."+i;};function AA(e){var t=e.url,n=e.body,i=e.method,r=e.timeout,a=new XMLHttpRequest();return new Promise(function(e,o){a.onload=function(t){if(a.status>=200&&a.status<300&&a.responseText.length>0)try{var n=JSON.parse(a.response);e({data:n});}catch(XJ){e({data:a.response});}else a.status>0&&o({code:a.status,message:"request failed, readyState:".concat(a.readyState," status:").concat(a.status," loaded size:").concat(t.loaded)});};var s=function s(e){o({code:a.readyState,message:"request ".concat(e.type,", readyState:").concat(a.readyState," status:").concat(a.status," loaded size:").concat(e.loaded)});};a.onerror=s,a.onabort=s,a.ontimeout=s,a.timeout=r||5e3,a.open(i||"POST",t,!0),a.send(n);});}var xA={exports:{}};!function(e){var t=Object.prototype.hasOwnProperty,n="~";function i(){}function r(e,t,n){this.fn=e,this.context=t,this.once=n||!1;}function a(e,t,i,a,o){if("function"!=typeof i)throw new TypeError("The listener must be a function");var s=new r(i,a||e,o),c=n?n+t:t;return e._events[c]?e._events[c].fn?e._events[c]=[e._events[c],s]:e._events[c].push(s):(e._events[c]=s,e._eventsCount++),e;}function o(e,t){0==--e._eventsCount?e._events=new i():delete e._events[t];}function s(){this._events=new i(),this._eventsCount=0;}Object.create&&(i.prototype=Object.create(null),new i().__proto__||(n=!1)),s.prototype.eventNames=function(){var e,i,r=[];if(0===this._eventsCount)return r;for(i in e=this._events){t.call(e,i)&&r.push(n?i.slice(1):i);}return Object.getOwnPropertySymbols?r.concat(Object.getOwnPropertySymbols(e)):r;},s.prototype.listeners=function(e){var t=n?n+e:e,i=this._events[t];if(!i)return[];if(i.fn)return[i.fn];for(var r=0,a=i.length,o=new Array(a);r<a;r++){o[r]=i[r].fn;}return o;},s.prototype.listenerCount=function(e){var t=n?n+e:e,i=this._events[t];return i?i.fn?1:i.length:0;},s.prototype.emit=function(e,t,i,r,a,o){var s=n?n+e:e;if(!this._events[s])return!1;var c,u,d=this._events[s],l=arguments.length;if(d.fn){switch(d.once&&this.removeListener(e,d.fn,void 0,!0),l){case 1:return d.fn.call(d.context),!0;case 2:return d.fn.call(d.context,t),!0;case 3:return d.fn.call(d.context,t,i),!0;case 4:return d.fn.call(d.context,t,i,r),!0;case 5:return d.fn.call(d.context,t,i,r,a),!0;case 6:return d.fn.call(d.context,t,i,r,a,o),!0;}for(u=1,c=new Array(l-1);u<l;u++){c[u-1]=arguments[u];}d.fn.apply(d.context,c);}else{var h,p=d.length;for(u=0;u<p;u++){switch(d[u].once&&this.removeListener(e,d[u].fn,void 0,!0),l){case 1:d[u].fn.call(d[u].context);break;case 2:d[u].fn.call(d[u].context,t);break;case 3:d[u].fn.call(d[u].context,t,i);break;case 4:d[u].fn.call(d[u].context,t,i,r);break;default:if(!c)for(h=1,c=new Array(l-1);h<l;h++){c[h-1]=arguments[h];}d[u].fn.apply(d[u].context,c);}}}return!0;},s.prototype.on=function(e,t,n){return a(this,e,t,n,!1);},s.prototype.once=function(e,t,n){return a(this,e,t,n,!0);},s.prototype.removeListener=function(e,t,i,r){var a=n?n+e:e;if(!this._events[a])return this;if(!t)return o(this,a),this;var s=this._events[a];if(s.fn)s.fn!==t||r&&!s.once||i&&s.context!==i||o(this,a);else{for(var c=0,u=[],d=s.length;c<d;c++){(s[c].fn!==t||r&&!s[c].once||i&&s[c].context!==i)&&u.push(s[c]);}u.length?this._events[a]=1===u.length?u[0]:u:o(this,a);}return this;},s.prototype.removeAllListeners=function(e){var t;return e?(t=n?n+e:e,this._events[t]&&o(this,t)):(this._events=new i(),this._eventsCount=0),this;},s.prototype.off=s.prototype.removeListener,s.prototype.addListener=s.prototype.on,s.prefixed=n,s.EventEmitter=s,e.exports=s;}(xA);var PA=xA.exports,DA=new PA(),OA=1,NA=2,MA=3,LA=4,UA=5,VA=20,FA=21,jA=22,BA=23,HA=24,GA=27,WA=28,zA=29,JA=30,qA=33,KA=31,QA=32,XA=100,YA=101,$A=102,ZA=103,ex=110,tx=111,nx=112,ix=113,rx=114,ax=115,ox=116,sx=120,cx=121,ux=122,dx=123,lx=130,hx=131,px=132,fx=133,mx=134,_x=135,vx=136,gx=137,yx=200,Sx=201,kx=300,bx=301,Tx=302,Ix=303;function Ex(e){var t=e.retryFunction,i=e.settings,r=e.onError,o=e.onRetrying,s=e.onRetryFailed,c=e.context;return function(){for(var e=this,u=arguments.length,d=new Array(u),l=0;l<u;l++){d[l]=arguments[l];}var h=i.retries||5,p=0,f=-1,m=0,_=function(){var u=a(n().mark(function a(u,l){var v,g,y,S;return n().wrap(function(n){for(;;){switch(n.prev=n.next){case 0:return v=c||e,n.prev=1,n.next=4,t.apply(v,d);case 4:g=n.sent,p=0,u(g),n.next=14;break;case 9:n.prev=9,n.t0=n.catch(1),y=function y(){clearTimeout(f),p=0,m=2,l(n.t0);},S=function S(){2!==m&&p<h?(p++,m=1,sA(o)&&o.call(v,p,y),f=setTimeout(function(){f=-1,_(u,l);},cA(i.timeout)?1e3:i.timeout)):(y(),sA(s)&&s.call(v,n.t0));},sA(r)?r.call(v,n.t0,S,l,d):S();case 14:case"end":return n.stop();}}},a,null,[[1,9]]);}));return function(e,t){return u.apply(this,arguments);};}();return new Promise(_);};}var wx=c(function e(t){o(this,e),this.log=t.log,this.level=t.level,this.userId=t.userId,this.sdkAppId=t.sdkAppId,this.forAllJoinedClients=t.forAllJoinedClients,this.uploaded=!1;}),Rx=function(){function e(t){o(this,e),this.id_=t.id,this.userId_=t.userId,this.sdkAppId_=t.sdkAppId,this.type_=t.type,this.isLocal_=!lA(t.isLocal)||t.isLocal;}return c(e,[{key:"setUserId",value:function value(e){this.userId_=e;}},{key:"setSdkAppId",value:function value(e){this.sdkAppId_=e;}},{key:"log",value:function value(e,t){xx.log({log:"[".concat(this.isLocal_?"↑":"↓").concat(this.id_,"] ").concat(this.type_?this.type_+" ":"").concat(t),level:e,forAllJoinedClients:cA(this.userId_),userId:this.userId_,sdkAppId:this.sdkAppId_});}},{key:"info",value:function value(e){this.log(_w.INFO,e);}},{key:"debug",value:function value(e){this.log(_w.DEBUG,e);}},{key:"warn",value:function value(e){this.log(_w.WARN,e);}},{key:"error",value:function value(e){this.log(_w.ERROR,e);}}]),e;}(),Cx=!(Db||Ob),Ax=function(){function e(){var t=this;o(this,e),this.clients_=new Set(),this.queue_=[],this.timeoutId_=-1,this.logLevel_=_w.DEBUG,this.logLevelToUpload_=_w.INFO,this.enableUploadLog_=!0,this.isAbleToUpload_=!1,this.checkURLParam(),DA.on(JA,function(e){var n=e.client;-1===t.timeoutId_&&t.startUpload(),t.clients_.add(n);}),DA.on(qA,function(e){var n=e.client;return t.clients_.delete(n);}),DA.on(KA,function(e){e&&rA(e.config)&&vw[e.config.logLevelToUpload]&&(t.logLevelToUpload_=e.config.logLevelToUpload);}),DA.on(LA,this.setIsAbleToUpload,this),DA.on(UA,this.setIsAbleToUpload,this);}var t,i;return c(e,[{key:"getIsAbleToUpload",value:function value(){return this.isAbleToUpload_;}},{key:"setIsAbleToUpload",value:function value(){this.isAbleToUpload_=!0,DA.off(LA,this.setIsAbleToUpload,this),DA.off(UA,this.setIsAbleToUpload,this);}},{key:"startUpload",value:(i=a(n().mark(function e(){var t=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.upload();case 3:e.next=7;break;case 5:e.prev=5,e.t0=e.catch(0);case 7:this.timeoutId_=setTimeout(function(){return t.startUpload();},2e3);case 8:case"end":return e.stop();}}},e,this,[[0,5]]);})),function(){return i.apply(this,arguments);})},{key:"getLogsToUpload",value:function value(){var e=this,t={map:new Map(),splicedQueue:[]};if(this.queue_[0].forAllJoinedClients&&0===this.clients_.size)return t;for(var n=0,i=function i(){if(50===n)return"break";var i=e.queue_[n];i.forAllJoinedClients?e.clients_.forEach(function(e){if(e.getIsJoined()){var n=e.getUserId(),r=e.getSDKAppId();if(t.map.has(n))t.map.get(n).logs.push(i);else t.map.set(n,{userId:n,sdkAppId:r,logs:[i]});}}):t.map.has(i.userId)?t.map.get(i.userId).logs.push(i):t.map.set(i.userId,{userId:i.userId,sdkAppId:i.sdkAppId,logs:[i]});};n<this.queue_.length;n++){if("break"===i())break;}return t.map.size>0&&(t.splicedQueue=this.queue_.splice(0,n)),t;}},{key:"upload",value:(t=a(n().mark(function e(){var t,i,r,a,o,s,c,u,d,l;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(0!==this.queue_.length&&this.isAbleToUpload_){e.next=2;break;}return e.abrupt("return");case 2:if(t=this.getLogsToUpload(),i=t.map,r=t.splicedQueue,0!==i.size){e.next=5;break;}return e.abrupt("return");case 5:e.prev=5,a=k(i.values()),o=0;case 8:if(!(o<a.length)){e.next=16;break;}return s=a[o],c=s.userId,u=s.sdkAppId,d=s.logs,e.next=12,this.uploadLogWithRetry(JSON.stringify({timestamp:tv(),sdkAppId:String(u),userId:c,version:Bo,log:d.map(function(e){return e.log;}).join("\n")}),u);case 12:d.forEach(function(e){return e.uploaded=!0;});case 13:o++,e.next=8;break;case 16:e.next=20;break;case 18:e.prev=18,e.t0=e.catch(5);case 20:l=r.filter(function(e){return!e.uploaded;}),l.length>0&&(this.queue_=l.concat(this.queue_));case 22:case"end":return e.stop();}}},e,this,[[5,18]]);})),function(){return t.apply(this,arguments);})},{key:"uploadLogWithRetry",value:function value(e,t){return Ex({retryFunction:function retryFunction(){return AA({url:nA(t,PI),body:e,timeout:5e3});},settings:{retries:3,timeout:1e3},onError:function onError(e,t){t();}})();}},{key:"getPrefix",value:function value(e){var t=new Date();return t.setTime(ev()),String.prototype.padStart?"[".concat(t.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/,"$1"),":").concat(t.getMilliseconds().toString().padStart(3,"0"),"] <").concat(vw[e],">"):"[".concat(t.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/,"$1"),":").concat(t.getMilliseconds(),"] <").concat(vw[e],">");}},{key:"getLogLevel",value:function value(){return this.logLevel_;}},{key:"setLogLevel",value:function value(e){cA(vw[e])||(this.logLevel_!==e&&this.info("setLogLevel ".concat(e)),this.logLevel_=e);}},{key:"enableUploadLog",value:function value(){this.enableUploadLog_=!0;}},{key:"disableUploadLog",value:function value(){this.enableUploadLog_=!1;}},{key:"log",value:function value(e){var t=e.log,n=e.level,i=e.forAllJoinedClients,r=void 0===i||i,a=e.userId,o=e.sdkAppId;if(t="".concat(this.getPrefix(n)," ").concat(t),this.enableUploadLog_&&n>=this.logLevelToUpload_&&this.queue_.push(new wx({log:t,level:n,userId:a,sdkAppId:o,forAllJoinedClients:r})),!(n<this.logLevel_)){var s=vw[n]?vw[n].toLowerCase():"info";Cx?console[s]("%cTRTC%c%s","padding: 1px 4px;border-radius: 3px;color: #fff;background: #1E88E5;","display: inline",t):console[s](t);}}},{key:"debug",value:function value(e){this.log({log:e,level:_w.DEBUG});}},{key:"info",value:function value(e){this.log({log:e,level:_w.INFO});}},{key:"warn",value:function value(e){this.log({log:e,level:_w.WARN});}},{key:"error",value:function value(e){this.log({log:e,level:_w.ERROR});}},{key:"createLogger",value:function value(e){return new Rx(e);}},{key:"checkURLParam",value:function value(){var e=new URLSearchParams(location.search).get("logLevelToUpload");vw[e]&&(this.logLevelToUpload_=e);}}]),e;}(),xx=new Ax(),Px=!0,Dx=ye,Ox=Math.floor,Nx=Number.isInteger||function(e){return!Dx(e)&&isFinite(e)&&Ox(e)===e;};Ir({target:"Number",stat:!0},{isInteger:Nx});var Mx,Lx=Ir,Ux=ee,Vx=A.f,Fx=Ni,jx=il,Bx=Uw,Hx=ue,Gx=Fw,Wx=Ux("".startsWith),zx=Ux("".slice),Jx=Math.min,qx=Gx("startsWith");Lx({target:"String",proto:!0,forced:!!(qx||(Mx=Vx(String.prototype,"startsWith"),!Mx||Mx.writable))&&!qx},{startsWith:function startsWith(e){var t=jx(Hx(this));Bx(e);var n=Fx(Jx(arguments.length>1?arguments[1]:void 0,t.length)),i=jx(e);return Wx?Wx(t,i,n):zx(t,n,n+i.length)===i;}});var Kx=P,Qx=ee,Xx=M,Yx=x,$x=zo,Zx=Yi,eP=L,tP=lt,nP=ae,iP=Object.assign,rP=Object.defineProperty,aP=Qx([].concat),oP=!iP||Yx(function(){if(Kx&&1!==iP({b:1},iP(rP({},"a",{enumerable:!0,get:function get(){rP(this,"b",{value:3,enumerable:!1});}}),{b:2})).b)return!0;var e={},t={},n=Symbol(),i="abcdefghijklmnopqrst";return e[n]=7,i.split("").forEach(function(e){t[e]=e;}),7!=iP({},e)[n]||$x(iP({},t)).join("")!=i;})?function(e,t){for(var n=tP(e),i=arguments.length,r=1,a=Zx.f,o=eP.f;i>r;){for(var s,c=nP(arguments[r++]),u=a?aP($x(c),a(c)):$x(c),d=u.length,l=0;d>l;){s=u[l++],Kx&&!Xx(o,c,s)||(n[s]=c[s]);}}return n;}:iP,sP=oP;Ir({target:"Object",stat:!0,arity:2,forced:Object.assign!==sP},{assign:sP});var cP=ee,uP=qe,dP=ye,lP=ft,hP=Bl,pP=D,fP=Function,mP=cP([].concat),_P=cP([].join),vP={},gP=function gP(e,t,n){if(!lP(vP,t)){for(var i=[],r=0;r<t;r++){i[r]="a["+r+"]";}vP[t]=fP("C,a","return new C("+_P(i,",")+")");}return vP[t](e,n);},yP=pP?fP.bind:function(e){var t=uP(this),n=t.prototype,i=hP(arguments,1),r=function r(){var n=mP(i,hP(arguments));return this instanceof r?gP(t,n.length,n):t.apply(e,n);};return dP(n)&&(r.prototype=n),r;},SP=yP;Ir({target:"Function",proto:!0,forced:Function.bind!==SP},{bind:SP});var kP=Ir,bP=fa.findIndex,TP=Ss,IP="findIndex",EP=!0;IP in[]&&Array(1).findIndex(function(){EP=!1;}),kP({target:"Array",proto:!0,forced:EP},{findIndex:function findIndex(e){return bP(this,e,arguments.length>1?arguments[1]:void 0);}}),TP(IP);var wP=P,RP=ee,CP=zo,AP=he,xP=RP(L.f),PP=RP([].push),DP=function DP(e){return function(t){for(var n,i=AP(t),r=CP(i),a=r.length,o=0,s=[];a>o;){n=r[o++],wP&&!xP(i,n)||PP(s,e?[n,i[n]]:i[n]);}return s;};},OP={entries:DP(!0),values:DP(!1)}.values;Ir({target:"Object",stat:!0},{values:function values(e){return OP(e);}});var NP=1,MP=5,LP=2,UP=3,VP=4,FP="DISCONNECTED",jP="CONNECTING",BP="RECONNECTING",HP="CONNECTED",GP={CLIENT_BANNED:9,CHANNEL_SETUP_RESULT:19,CHANNEL_RECONNECT_RESULT:514,JOIN_ROOM_RESULT:20,PEER_JOIN:4134,PEER_LEAVE:4135,STREAM_ADDED:16,STREAM_REMOVED:18,UPLINK_NETWORK_STATS:22,UPDATE_REMOTE_MUTE_STAT:23,PUBLISH_RESULT:4098,PUBLISH_STATE_CHANGE_RESULT:4112,UNPUBLISH_RESULT:4100,SUBSCRIBE_RESULT:4102,UNSUBSCRIBE_RESULT:4104,SUBSCRIBE_CHANGE_RESULT:4106,MUTE_RESULT:4108,UPDATE_OFFER_RESULT:4128,START_PUBLISH_TENCENT_CDN_RES:1286,STOP_PUBLISH_TENCENT_CDN_RES:1288,START_PUBLISH_GIVEN_CDN_RES:777,STOP_PUBLISH_GIVEN_CDN_RES:779,START_MIX_TRANSCODE_RES:781,STOP_MIX_TRANSCODE_RES:783,USER_LIST_RES:4137,SWITCH_ROLE_RES:4110,UPDATE_CONSTRAINT_CONFIG_RES:772},WP=[GP.UPDATE_REMOTE_MUTE_STAT,GP.UPLINK_NETWORK_STATS,GP.USER_LIST_RES,GP.MUTE_RESULT],zP={CLIENT_BANNED:"client-banned",CHANNEL_SETUP_RESULT:"channel-setup-result",CHANNEL_RECONNECT_RESULT:"channel-reconnect-result",JOIN_ROOM_RESULT:"join-room-result",PEER_JOIN:"peer-join",PEER_LEAVE:"peer-leave",STREAM_ADDED:"stream-added",STREAM_REMOVED:"stream-removed",UPLINK_NETWORK_STATS:"uplink-network-stats",UPDATE_REMOTE_MUTE_STAT:"update-remote-mute-stat",PUBLISH_RESULT:"publish-result",PUBLISH_STATE_CHANGE_RESULT:"publish-state-change-result",UNPUBLISH_RESULT:"unpublish-result",SUBSCRIBE_RESULT:"subscribe-result",SUBSCRIBE_CHANGE_RESULT:"subscribe-change-result",UNSUBSCRIBE_RESULT:"unsubscribe-result",UPDATE_OFFER_RESULT:"update-offer-result",START_PUBLISH_TENCENT_CDN_RES:"start-publish-tencent-cdn-res",STOP_PUBLISH_TENCENT_CDN_RES:"stop-publish-tencent-cdn-res",START_PUBLISH_GIVEN_CDN_RES:"start-publish-given-cdn-res",STOP_PUBLISH_GIVEN_CDN_RES:"stop-publish-given-cdn-res",START_MIX_TRANSCODE_RES:"start-mix-transcode-res",STOP_MIX_TRANSCODE_RES:"stop-mix-transcode-res",USER_LIST_RES:"user-list-res",SWITCH_ROLE_RES:"switch_role_res",MUTE_RESULT:"mute-result",UPDATE_CONSTRAINT_CONFIG_RES:"update-contraint-config-res"},JP="publish_change",qP="publish_state_change",KP="join",QP="leave",XP="quality_report",YP="mute_uplink",$P="publish",ZP="unpublish",eD="subscribe",tD="unsubscribe",nD="subscribe_change",iD="start_publishing",rD="stop_publishing",aD="start_push_user_cdn",oD="stop_push_user_cdn",sD="start_mcu_mix",cD="stop_mcu_mix",uD="get_user_list",dD="change_role",lD="update_constraint_config",hD={INVALID_PARAMETER:4096,INVALID_OPERATION:4097,NOT_SUPPORTED:4098,DEVICE_NOT_FOUND:4099,INITIALIZE_FAILED:4100,SIGNAL_CHANNEL_SETUP_FAILED:16385,SIGNAL_CHANNEL_ERROR:16386,ICE_TRANSPORT_ERROR:16387,JOIN_ROOM_FAILED:16388,CREATE_OFFER_FAILED:16389,SIGNAL_CHANNEL_RECONNECTION_FAILED:16390,UPLINK_RECONNECTION_FAILED:16391,DOWNLINK_RECONNECTION_FAILED:16392,REMOTE_STREAM_NOT_EXIST:16400,CLIENT_BANNED:16448,SERVER_TIMEOUT:16449,SUBSCRIPTION_TIMEOUT:16450,PLAY_NOT_ALLOWED:16451,DEVICE_AUTO_RECOVER_FAILED:16452,START_PUBLISH_CDN_FAILED:16453,STOP_PUBLISH_CDN_FAILED:16454,START_MIX_TRANSCODE_FAILED:16455,STOP_MIX_TRANSCODE_FAILED:16456,NOT_SUPPORTED_H264:16457,SWITCH_ROLE_FAILED:16458,API_CALL_TIMEOUT:16459,SCHEDULE_FAILED:16460,API_CALL_ABORTED:16461,UNKNOWN:65535},pD=function(e){d(n,e);var t=v(n);function n(e){var i,r=e.name,a=void 0===r?"RtcError":r,s=e.message,c=e.code,u=void 0===c?hD.UNKNOWN:c,d=e.extraCode,l=void 0===d?0:d,h=e.constraint;o(this,n);var p="<".concat(function(e){for(var t in hD){if(hD[t]===e)return t;}return"UNKNOWN";}(u)," 0x").concat(u.toString(16),">");return(i=t.call(this,s+"".concat(h?" constraint: ".concat(h):"")+"".concat(null!=s&&s.includes(p)?"":" "+p))).code_=u,i.extraCode_=l,i.name=a,i.message_=s,h&&(i.constraint=h),i;}return c(n,[{key:"getCode",value:function value(){return this.code_;}},{key:"getExtraCode",value:function value(){return this.extraCode_;}}]),n;}(m(Error)),fD=32768,mD=32769,_D=32770,vD=32771,gD=32772,yD=32773,SD=32774,kD=32775,bD=32777,TD=32778,ID=32779,ED=32780,wD=32781,RD=32782,CD=32783,AD=32784,xD=32785,PD=32786,DD=32787,OD=32788,ND=32789,MD=32790,LD=32791,UD=32792,VD=32793,FD=32794,jD=32795,BD=32796,HD=32797,GD=32798,WD=32799,zD=32800,JD=32801,qD=32802,KD=32803,QD=32804,XD=new Map(),YD=function YD(e,t){var n=XD.get(e);n||(XD.set(e,[]),n=XD.get(e)),n.push(t);},$D=function $D(e){var t=XD.get(e),n=[];return t?(XD.delete(e),n=t.map(function(e){return{uint32_event_id:e.eventId,uint64_date:e.timestamp,str_userid:e.remoteUserId,str_event_json:e.eventDesc};})):n=[],n;},ZD=Object.prototype.hasOwnProperty;function eO(e){if(null==e)return!0;if("boolean"==typeof e)return!1;if("number"==typeof e)return 0===e;if("string"==typeof e)return 0===e.length;if("function"==typeof e)return 0===e.length;if(Array.isArray(e))return 0===e.length;if(e instanceof Error)return""===e.message;if(rA(e))switch(Object.prototype.toString.call(e)){case"[object File]":case"[object Map]":case"[object Set]":return 0===e.size;case"[object Object]":for(var t in e){if(ZD.call(e,t))return!1;}return!0;}return!1;}var tO=function(){function e(){o(this,e);var t=UT(),n=t.name,i=t.version;this.roomIdMap_=new Map(),this.configs_={sdkAppId:"",userId:"",version:Bo,env:RI,browserVersion:n+i,ua:navigator.userAgent};}return c(e,[{key:"setConfig",value:function value(e){var t=e.sdkAppId,n=e.env,i=e.userId,r=e.roomId;t!==this.configs_.sdkAppId&&(this.configs_.sdkAppId=String(t)),this.configs_.env=n,this.configs_.userId=i,this.roomIdMap_.set(i,String(r));}},{key:"logEvent",value:function value(e){if(!NT){var n=t(t(t({},e),this.configs_),{},{userId:e.userId||this.configs_.userId});cA(n.code)&&(n.code="failed"===n.result?hD.UNKNOWN:0),this.sendRequest(nA(this.configs_.sdkAppId,DI),n);}}},{key:"logSuccessEvent",value:function value(e){NT||(this.logEvent(t(t({},e),{},{result:"success",roomId:this.roomIdMap_.get(e.userId)})),this.configs_.env===RI&&this.uploadEventToKibana(t(t({},e),{},{result:"success"})));}},{key:"logFailedEvent",value:function value(e){if(!NT){var n=e.eventType,i=e.code,r=e.error,a=e.userId,o={roomId:this.roomIdMap_.get(a),userId:a,eventType:n,result:"failed",code:i||(r instanceof pD?r.getExtraCode()||r.getCode():hD.UNKNOWN)};this.logEvent(o),this.configs_.env===RI&&this.uploadEventToKibana(t(t({},o),{},{error:r}));}}},{key:"uploadEventToKibana",value:function value(e){var t="stat-".concat(e.eventType,"-").concat(e.result);"delta-join"!==e.eventType&&"delta-leave"!==e.eventType&&"delta-publish"!==e.eventType||(t="".concat(e.eventType,":").concat(e.delta)),this.uploadEvent({log:t,userId:e.userId}),"failed"===e.result&&(t="stat-".concat(e.eventType,"-").concat(e.result,"-").concat(e.code),this.uploadEvent({log:t,userId:e.userId,error:e.error}));}},{key:"uploadEvent",value:function value(e){var t=e.log,n=e.userId,i=e.error,r={timestamp:tv(),sdkAppId:this.configs_.sdkAppId,userId:n||this.configs_.userId,version:this.configs_.version,log:t};i&&(r.errorInfo=i.message),this.sendRequest(nA(this.configs_.sdkAppId,PI),r);}},{key:"sendRequest",value:function value(e,t){var n=this;xx.getIsAbleToUpload()?AA({url:e,body:JSON.stringify(t)}).catch(function(){}):setTimeout(function(){n.sendRequest(e,t);},1e3);}}]),e;}(),nO=new tO(),iO=function(){function e(t){o(this,e),this.client_=t.client,this.sdkAppId_=t.sdkAppId,this.userId_=t.userId,this.userSig_=t.userSig,this.url_=t.url,this.backupUrl_=t.backupUrl;var n="?sdkAppId=".concat(encodeURIComponent(this.sdkAppId_),"&userId=").concat(encodeURIComponent(this.userId_),"&userSig=").concat(encodeURIComponent(this.userSig_));this.urlWithParam_="".concat(this.url_).concat(n),this.backupUrlWithParam_="".concat(this.backupUrl_).concat(n),this.isConnected_=!1,this.isConnecting_=!1,this.socketInUse_=null,this.socket_=null,this.backupSocket_=null,this.backupTimer_=-1,this.signalInfo_={},this.currentState_=FP,this.reconnectionCount_=0,this.reconnectionTimer_=-1,this.lastMessageTime_=-1,this.seq_=0,this.log_=xx.createLogger({id:"ws|"+this.userId_,userId:this.userId_,sdkAppId:this.sdkAppId_}),this.emitter_=new PA();}return c(e,[{key:"isOnline",get:function get(){return this.currentState_===HP&&Date.now()-this.lastMessageTime_<12e3;}},{key:"connect",value:function value(){var e=this;return new Promise(function(t,n){e.log_.info("connect to url: ".concat(e.urlWithParam_)),e.emitConnectionStateChanged(jP),e.socket_=new WebSocket(e.urlWithParam_),e.bindSocket(e.socket_),e.backupTimer_=setTimeout(function(){e.isConnected_||(e.log_.info("trying to connect to backupUrl"),e.tryConnectBackup());},5e3),e.once(UP,t),e.once(VP,n);});}},{key:"tryConnectBackup",value:function value(){this.backupSocket_||(this.unbindAndCloseSocket(cI),this.log_.debug("try to connect to url: ".concat(this.backupUrlWithParam_)),this.backupSocket_=new WebSocket(this.backupUrlWithParam_),this.bindSocket(this.backupSocket_));}},{key:"bindSocket",value:function value(e){e.onopen=this.onopen.bind(this),e.onclose=this.onclose.bind(this),e.onerror=this.onerror.bind(this),e.onmessage=this.onmessage.bind(this);}},{key:"unbindSocket",value:function value(e){e.onopen=function(){},e.onclose=function(){},e.onerror=function(){},e.onmessage=function(){};}},{key:"unbindAndCloseSocket",value:function value(e){if(e===cI){if(this.socket_){this.unbindSocket(this.socket_);try{this.socket_.close(1e3);}catch(XJ){}this.socket_=null;}}else if(this.backupSocket_){this.unbindSocket(this.backupSocket_);try{this.backupSocket_.close(1e3);}catch(XJ){}this.backupSocket_=null;}}},{key:"clearBackupTimer",value:function value(){-1!==this.backupTimer_&&(clearTimeout(this.backupTimer_),this.backupTimer_=-1);}},{key:"clearReconnectionTimer",value:function value(){-1!==this.reconnectionTimer_&&(clearTimeout(this.reconnectionTimer_),this.reconnectionTimer_=-1);}},{key:"onopen",value:function value(e){if(!this.isConnected_){this.isConnected_=!0,this.isConnecting_=!1,this.isReconnecting_&&eO(this.signalInfo_)&&this.stopReconnection(),this.clearBackupTimer(),e.target===this.socket_?(this.unbindAndCloseSocket(uI),this.socketInUse_=this.socket_):(this.unbindAndCloseSocket(cI),this.socketInUse_=this.backupSocket_);var t=e.target.url;this.log_.info("websocket[".concat(t,"] is connected")),this.currentState_===jP?this.addSignalEvent(LD,"signal channel is connected"):this.currentState_===BP&&this.addSignalEvent(jD,"signal channel reconnect success"),this.emitConnectionStateChanged(HP),this.emitter_.emit(UP);}}},{key:"onclose",value:function value(e){var t=e.target.url,n=e.target===this.socketInUse_;this.log_.info("websocket[".concat(t," InUse: ").concat(n,"] is closed with code: ").concat(e.code)),e.target===this.socketInUse_&&(this.isConnected_=!1,this.emitConnectionStateChanged(FP),this.addSignalEvent(MD,"signal channel is disconnected"),e.wasClean&&1e3===e.code||(this.log_.warn("onclose code:".concat(e.code," reason:").concat(e.reason)),this.log_.warn("close current websocket and schedule a reconnect timeout"),this.socketInUse_.onclose=function(){},this.socketInUse_.close(4011),this.socket_=this.backupSocket_=this.socketInUse_=null,this.reconnect(cI)));}},{key:"onerror",value:function value(e){var t=e.target.url;this.log_.error("websocket[".concat(t,"] error observed")),this.isConnected_?e.target===this.socketInUse_&&(this.isConnected_=!1,this.unbindAndCloseSocket(cI),this.unbindAndCloseSocket(uI),this.socketInUse_=null,this.reconnect(cI)):(this.isReconnecting_||nO.logFailedEvent({userId:this.client_.getUserId(),eventType:IE,code:hD.UNKNOWN}),e.target==this.socket_?(this.unbindAndCloseSocket(cI),this.reconnect(uI)):(this.unbindAndCloseSocket(uI),this.reconnect(cI))),this.isConnecting_=!1,this.isConnected_=!1;}},{key:"onmessage",value:function value(e){if(this.isConnected_){this.lastMessageTime_=Date.now();var t=JSON.parse(e.data),n=t.cmd,i=t.data,r=Object.values(GP),a=Object.keys(GP)[r.indexOf(n)],o=zP[a];switch(WP.includes(n)||(this.log_.debug("received msg: ".concat(e.data)),this.log_.info("Received event: [ ".concat(o||"unknown cmd: "+n," ]"))),n){case GP.CHANNEL_SETUP_RESULT:if(0===t.code)this.signalInfo_.clientIp=i.clientIp,this.signalInfo_.signalIp=i.signalInnerIp,this.signalInfo_.tinyId=t.tinyId,i.svrTime&&function(e){Z_=e-new Date().getTime();var t=new Date();t.setTime(e),xx.info("baseTime from server: "+t+" offset: "+Z_);}(i.svrTime),this.log_.info("ChannelSetup Success"),nO.logSuccessEvent({userId:this.userId_,eventType:IE}),this.emitter_.emit(NP,{signalInfo:this.signalInfo_});else{var s=new pD({code:hD.SIGNAL_CHANNEL_SETUP_FAILED,extraCode:t.code,message:ZC({key:eR,data:{errorCode:t.code,errorMsg:t.message}})});this.log_.error("".concat(t.code,", ").concat(t.message)),this.close(),nO.logFailedEvent({userId:this.userId_,eventType:IE,error:s}),this.emitter_.emit(MP,s);}break;case GP.JOIN_ROOM_RESULT:0===t.code&&(this.signalInfo_.relayIp=i.relayOuterIp,this.signalInfo_.relayInnerIp=i.relayInnerIp,this.signalInfo_.relayPort=i.relayPort,this.log_.info("signalIp:".concat(this.signalInfo_.signalIp," clientIp:").concat(this.signalInfo_.clientIp," relayIp: ").concat(this.signalInfo_.relayIp))),this.emitter_.emit(o,{data:t});break;case GP.CHANNEL_RECONNECT_RESULT:0===t.code?(this.log_.warn("reconnect success"),this.stopReconnection(),nO.logSuccessEvent({userId:this.userId_,eventType:EE}),this.client_.syncUserList(),this.client_.checkConnectionsToReconnect()):(this.log_.warn("reconnect failed, ".concat(t.code," ").concat(t.message)),this.client_.reJoin());break;default:this.emitter_.emit(o,{data:t});}}}},{key:"addSignalEvent",value:function value(e,t){YD(this.userId_,{eventId:e,eventDesc:t,timestamp:ev(),userId:this.userId_,tinyId:this.signalInfo_.tinyId});}},{key:"reconnect",value:function value(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:cI;if(this.isConnecting_||-1!==this.reconnectionTimer_)this.log_.info("signal channel is reconnecting, ignoring current reconnection");else{if(this.reconnectionCount_>=aE){this.log_.warn("SDK has tried reconnect signal channel for ".concat(aE," times, but all failed. please check your network"));var n=new pD({code:hD.SIGNAL_CHANNEL_RECONNECTION_FAILED,message:ZC({key:Zw})});return nO.logFailedEvent({userId:this.client_.getUserId(),eventType:EE,error:n}),this.addSignalEvent(BD,"signal channel reconnect fail"),void this.emitter_.emit(VP,n);}this.isConnecting_=!0,this.reconnectionCount_++,this.currentState_!==BP&&(this.emitConnectionStateChanged(BP),this.addSignalEvent(FD,"signal channel is reconnecting")),this.log_.warn("reconnecting to ".concat(t," signal channel [").concat(this.reconnectionCount_,"/").concat(aE,"]"));var i=this.getReconnectionUrl(t);t===cI?(this.socket_=new WebSocket(i),this.bindSocket(this.socket_)):(this.backupSocket_=new WebSocket(i),this.bindSocket(this.backupSocket_));var r=oA(this.reconnectionCount_);this.reconnectionTimer_=setTimeout(function(){e.log_.warn("reconnect ".concat(t," signal channel timeout(").concat(r/1e3,"s), close and try again")),e.isConnecting_=!1,e.clearReconnectionTimer(),e.unbindAndCloseSocket(t),e.reconnect(t===cI?uI:cI);},r);}}},{key:"isConnected",value:function value(){return this.isConnected_;}},{key:"isReconnecting_",get:function get(){return-1!==this.reconnectionTimer_;}},{key:"getReconnectionUrl",value:function value(e){var t=e===cI?this.urlWithParam_:this.backupUrlWithParam_;if(!eO(this.signalInfo_)&&-1===t.indexOf("&rc=1")){var n=this.client_.getRoomId(),i=this.client_.getUseStringRoomId();t+="&rc=1&relayInnerIp=".concat(this.signalInfo_.relayInnerIp,"&relayOuterIp=").concat(this.signalInfo_.relayIp,"&relayPort=").concat(this.signalInfo_.relayPort,"&roomId=").concat(n,"&useStringRoomId=").concat(i);}return t;}},{key:"send",value:function value(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(this.isConnected_){var n={cmd:e,data:t,userId:this.userId_,tinyId:this.signalInfo_.tinyId,seq:++this.seq_};return this.socketInUse_.send(JSON.stringify(n)),n.seq;}}},{key:"sendWaitForResponse",value:function value(e){var t=this,n=e.command,i=e.data,r=e.timeout,a=void 0===r?5e3:r,o=e.responseCommand,s=e.commandDesc,c=e.enableLog,u=void 0===c||c;return new Promise(function(e,r){var c=setTimeout(function(){t.off(o,d);var e=new pD({code:hD.API_CALL_TIMEOUT,message:ZC({key:$w,data:{commandDesc:s,command:n}})});u&&t.log_.warn(e),r(e);},a),d=function n(i){i.data.seq===l&&(clearTimeout(c),t.off(o,n),e(i));};t.on(o,d);var l=t.send(n,i);});}},{key:"sendWaitForResponseWithRetry",value:function value(){var e=this,t=arguments.length<=0?void 0:arguments[0],n=t.commandDesc,i=t.command,r=t.retries,a=void 0===r?0:r,o=t.retryTimeout,s=void 0===o?0:o;return Ex({retryFunction:this.sendWaitForResponse,onRetrying:function onRetrying(t){e.log_.warn("".concat(n||i," timeout observed, retrying [").concat(t,"/").concat(a,"]"));},settings:{retries:a,timeout:s},context:this}).apply(void 0,arguments);}},{key:"getCurrentState",value:function value(){return this.currentState_;}},{key:"getSignalInfo",value:function value(){return this.signalInfo_;}},{key:"stopReconnection",value:function value(){this.isReconnecting_&&(this.reconnectionCount_=0,this.clearReconnectionTimer());}},{key:"close",value:function value(){this.log_.info("close SignalChannel"),this.clearBackupTimer(),this.stopReconnection(),this.signalInfo_={},this.isConnecting_=!1,this.isConnected_=!1,this.socketInUse_=null,this.unbindAndCloseSocket(cI),this.unbindAndCloseSocket(uI),this.emitConnectionStateChanged(FP);}},{key:"on",value:function value(e,t,n){this.emitter_.on(e,t,n);}},{key:"removeListener",value:function value(e,t,n){this.emitter_.removeListener(e,t,n);}},{key:"once",value:function value(e,t,n){this.emitter_.once(e,t,n);}},{key:"off",value:function value(e,t,n){this.emitter_.off(e,t,n);}},{key:"emitConnectionStateChanged",value:function value(e){e!==this.currentState_&&(this.emitter_.emit(LP,{prevState:this.currentState_,state:e}),this.currentState_=e);}}]),e;}(),rO=Ir,aO=fa.find,oO=Ss,sO="find",cO=!0;sO in[]&&Array(1).find(function(){cO=!1;}),rO({target:"Array",proto:!0,forced:cO},{find:function find(e){return aO(this,e,arguments.length>1?arguments[1]:void 0);}}),oO(sO);var uO={},dO={},lO={exports:{}},hO=lO.exports={v:[{name:"version",reg:/^(\d*)$/}],o:[{name:"origin",reg:/^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,names:["username","sessionId","sessionVersion","netType","ipVer","address"],format:"%s %s %d %s IP%d %s"}],s:[{name:"name"}],i:[{name:"description"}],u:[{name:"uri"}],e:[{name:"email"}],p:[{name:"phone"}],z:[{name:"timezones"}],r:[{name:"repeats"}],t:[{name:"timing",reg:/^(\d*) (\d*)/,names:["start","stop"],format:"%d %d"}],c:[{name:"connection",reg:/^IN IP(\d) (\S*)/,names:["version","ip"],format:"IN IP%d %s"}],b:[{push:"bandwidth",reg:/^(TIAS|AS|CT|RR|RS):(\d*)/,names:["type","limit"],format:"%s:%s"}],m:[{reg:/^(\w*) (\d*) ([\w/]*)(?: (.*))?/,names:["type","port","protocol","payloads"],format:"%s %d %s %s"}],a:[{push:"rtp",reg:/^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,names:["payload","codec","rate","encoding"],format:function format(e){return e.encoding?"rtpmap:%d %s/%s/%s":e.rate?"rtpmap:%d %s/%s":"rtpmap:%d %s";}},{push:"fmtp",reg:/^fmtp:(\d*) ([\S| ]*)/,names:["payload","config"],format:"fmtp:%d %s"},{name:"control",reg:/^control:(.*)/,format:"control:%s"},{name:"rtcp",reg:/^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,names:["port","netType","ipVer","address"],format:function format(e){return null!=e.address?"rtcp:%d %s IP%d %s":"rtcp:%d";}},{push:"rtcpFbTrrInt",reg:/^rtcp-fb:(\*|\d*) trr-int (\d*)/,names:["payload","value"],format:"rtcp-fb:%s trr-int %d"},{push:"rtcpFb",reg:/^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,names:["payload","type","subtype"],format:function format(e){return null!=e.subtype?"rtcp-fb:%s %s %s":"rtcp-fb:%s %s";}},{push:"ext",reg:/^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,names:["value","direction","encrypt-uri","uri","config"],format:function format(e){return"extmap:%d"+(e.direction?"/%s":"%v")+(e["encrypt-uri"]?" %s":"%v")+" %s"+(e.config?" %s":"");}},{name:"extmapAllowMixed",reg:/^(extmap-allow-mixed)/},{push:"crypto",reg:/^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,names:["id","suite","config","sessionConfig"],format:function format(e){return null!=e.sessionConfig?"crypto:%d %s %s %s":"crypto:%d %s %s";}},{name:"setup",reg:/^setup:(\w*)/,format:"setup:%s"},{name:"connectionType",reg:/^connection:(new|existing)/,format:"connection:%s"},{name:"mid",reg:/^mid:([^\s]*)/,format:"mid:%s"},{name:"msid",reg:/^msid:(.*)/,format:"msid:%s"},{name:"ptime",reg:/^ptime:(\d*(?:\.\d*)*)/,format:"ptime:%d"},{name:"maxptime",reg:/^maxptime:(\d*(?:\.\d*)*)/,format:"maxptime:%d"},{name:"direction",reg:/^(sendrecv|recvonly|sendonly|inactive)/},{name:"icelite",reg:/^(ice-lite)/},{name:"iceUfrag",reg:/^ice-ufrag:(\S*)/,format:"ice-ufrag:%s"},{name:"icePwd",reg:/^ice-pwd:(\S*)/,format:"ice-pwd:%s"},{name:"fingerprint",reg:/^fingerprint:(\S*) (\S*)/,names:["type","hash"],format:"fingerprint:%s %s"},{push:"candidates",reg:/^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation","network-id","network-cost"],format:function format(e){var t="candidate:%s %d %s %d %s %d typ %s";return t+=null!=e.raddr?" raddr %s rport %d":"%v%v",t+=null!=e.tcptype?" tcptype %s":"%v",null!=e.generation&&(t+=" generation %d"),t+=null!=e["network-id"]?" network-id %d":"%v",t+=null!=e["network-cost"]?" network-cost %d":"%v";}},{name:"endOfCandidates",reg:/^(end-of-candidates)/},{name:"remoteCandidates",reg:/^remote-candidates:(.*)/,format:"remote-candidates:%s"},{name:"iceOptions",reg:/^ice-options:(\S*)/,format:"ice-options:%s"},{push:"ssrcs",reg:/^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,names:["id","attribute","value"],format:function format(e){var t="ssrc:%d";return null!=e.attribute&&(t+=" %s",null!=e.value&&(t+=":%s")),t;}},{push:"ssrcGroups",reg:/^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,names:["semantics","ssrcs"],format:"ssrc-group:%s %s"},{name:"msidSemantic",reg:/^msid-semantic:\s?(\w*) (\S*)/,names:["semantic","token"],format:"msid-semantic: %s %s"},{push:"groups",reg:/^group:(\w*) (.*)/,names:["type","mids"],format:"group:%s %s"},{name:"rtcpMux",reg:/^(rtcp-mux)/},{name:"rtcpRsize",reg:/^(rtcp-rsize)/},{name:"sctpmap",reg:/^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,names:["sctpmapNumber","app","maxMessageSize"],format:function format(e){return null!=e.maxMessageSize?"sctpmap:%s %s %s":"sctpmap:%s %s";}},{name:"xGoogleFlag",reg:/^x-google-flag:([^\s]*)/,format:"x-google-flag:%s"},{push:"rids",reg:/^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,names:["id","direction","params"],format:function format(e){return e.params?"rid:%s %s %s":"rid:%s %s";}},{push:"imageattrs",reg:new RegExp("^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),names:["pt","dir1","attrs1","dir2","attrs2"],format:function format(e){return"imageattr:%s %s %s"+(e.dir2?" %s %s":"");}},{name:"simulcast",reg:new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),names:["dir1","list1","dir2","list2"],format:function format(e){return"simulcast:%s %s"+(e.dir2?" %s %s":"");}},{name:"simulcast_03",reg:/^simulcast:[\s\t]+([\S+\s\t]+)$/,names:["value"],format:"simulcast: %s"},{name:"framerate",reg:/^framerate:(\d+(?:$|\.\d+))/,format:"framerate:%s"},{name:"sourceFilter",reg:/^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,names:["filterMode","netType","addressTypes","destAddress","srcList"],format:"source-filter: %s %s %s %s %s"},{name:"bundleOnly",reg:/^(bundle-only)/},{name:"label",reg:/^label:(.+)/,format:"label:%s"},{name:"sctpPort",reg:/^sctp-port:(\d+)$/,format:"sctp-port:%s"},{name:"maxMessageSize",reg:/^max-message-size:(\d+)$/,format:"max-message-size:%s"},{push:"tsRefClocks",reg:/^ts-refclk:([^\s=]*)(?:=(\S*))?/,names:["clksrc","clksrcExt"],format:function format(e){return"ts-refclk:%s"+(null!=e.clksrcExt?"=%s":"");}},{name:"mediaClk",reg:/^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,names:["id","mediaClockName","mediaClockValue","rateNumerator","rateDenominator"],format:function format(e){var t="mediaclk:";return t+=null!=e.id?"id=%s %s":"%v%s",t+=null!=e.mediaClockValue?"=%s":"",t+=null!=e.rateNumerator?" rate=%s":"",t+=null!=e.rateDenominator?"/%s":"";}},{name:"keywords",reg:/^keywds:(.+)$/,format:"keywds:%s"},{name:"content",reg:/^content:(.+)/,format:"content:%s"},{name:"bfcpFloorCtrl",reg:/^floorctrl:(c-only|s-only|c-s)/,format:"floorctrl:%s"},{name:"bfcpConfId",reg:/^confid:(\d+)/,format:"confid:%s"},{name:"bfcpUserId",reg:/^userid:(\d+)/,format:"userid:%s"},{name:"bfcpFloorId",reg:/^floorid:(.+) (?:m-stream|mstrm):(.+)/,names:["id","mStream"],format:"floorid:%s mstrm:%s"},{push:"invalid",names:["value"]}]};Object.keys(hO).forEach(function(e){hO[e].forEach(function(e){e.reg||(e.reg=/(.*)/),e.format||(e.format="%s");});}),function(e){var t=function t(e){return String(Number(e))===e?Number(e):e;},n=function n(e,_n16,i){var r=e.name&&e.names;e.push&&!_n16[e.push]?_n16[e.push]=[]:r&&!_n16[e.name]&&(_n16[e.name]={});var a=e.push?{}:r?_n16[e.name]:_n16;!function(e,n,i,r){if(r&&!i)n[r]=t(e[1]);else for(var a=0;a<i.length;a+=1){null!=e[a+1]&&(n[i[a]]=t(e[a+1]));}}(i.match(e.reg),a,e.names,e.name),e.push&&_n16[e.push].push(a);},i=lO.exports,r=RegExp.prototype.test.bind(/^([a-z])=(.*)/);e.parse=function(e){var t={},a=[],o=t;return e.split(/(\r\n|\r|\n)/).filter(r).forEach(function(e){var t=e[0],r=e.slice(2);"m"===t&&(a.push({rtp:[],fmtp:[]}),o=a[a.length-1]);for(var s=0;s<(i[t]||[]).length;s+=1){var c=i[t][s];if(c.reg.test(r))return n(c,o,r);}}),t.media=a,t;};var a=function a(e,n){var i=n.split(/=(.+)/,2);return 2===i.length?e[i[0]]=t(i[1]):1===i.length&&n.length>1&&(e[i[0]]=void 0),e;};e.parseParams=function(e){return e.split(/;\s?/).reduce(a,{});},e.parseFmtpConfig=e.parseParams,e.parsePayloads=function(e){return e.toString().split(" ").map(Number);},e.parseRemoteCandidates=function(e){for(var n=[],i=e.split(" ").map(t),r=0;r<i.length;r+=3){n.push({component:i[r],ip:i[r+1],port:i[r+2]});}return n;},e.parseImageAttributes=function(e){return e.split(" ").map(function(e){return e.substring(1,e.length-1).split(",").reduce(a,{});});},e.parseSimulcastStreamList=function(e){return e.split(";").map(function(e){return e.split(",").map(function(e){var n,i=!1;return"~"!==e[0]?n=t(e):(n=t(e.substring(1,e.length)),i=!0),{scid:n,paused:i};});});};}(dO);var pO=lO.exports,fO=/%[sdv%]/g,mO=function mO(e){var t=1,n=arguments,i=n.length;return e.replace(fO,function(e){if(t>=i)return e;var r=n[t];switch(t+=1,e){case"%%":return"%";case"%s":return String(r);case"%d":return Number(r);case"%v":return"";}});},_O=function _O(e,t,n){var i=[e+"="+(t.format instanceof Function?t.format(t.push?n:n[t.name]):t.format)];if(t.names)for(var r=0;r<t.names.length;r+=1){var a=t.names[r];t.name?i.push(n[t.name][a]):i.push(n[t.names[r]]);}else i.push(n[t.name]);return mO.apply(null,i);},vO=["v","o","s","i","u","e","p","c","b","t","r","z","a"],gO=["i","c","b","a"],yO=dO,SO=function SO(e,t){t=t||{},null==e.version&&(e.version=0),null==e.name&&(e.name=" "),e.media.forEach(function(e){null==e.payloads&&(e.payloads="");});var n=t.outerOrder||vO,i=t.innerOrder||gO,r=[];return n.forEach(function(t){pO[t].forEach(function(n){n.name in e&&null!=e[n.name]?r.push(_O(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach(function(e){r.push(_O(t,n,e));});});}),e.media.forEach(function(e){r.push(_O("m",pO.m[0],e)),i.forEach(function(t){pO[t].forEach(function(n){n.name in e&&null!=e[n.name]?r.push(_O(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach(function(e){r.push(_O(t,n,e));});});});}),r.join("\r\n")+"\r\n";};uO.write=SO,uO.parse=yO.parse,uO.parseParams=yO.parseParams,uO.parseFmtpConfig=yO.parseFmtpConfig,uO.parsePayloads=yO.parsePayloads,uO.parseRemoteCandidates=yO.parseRemoteCandidates,uO.parseImageAttributes=yO.parseImageAttributes,uO.parseSimulcastStreamList=yO.parseSimulcastStreamList;var kO=function kO(e){return uO.parse(e);},bO=function bO(e){return uO.write(e);},TO=function TO(e){var t=kO(e);return t.media.forEach(function(e){e.type===BT&&e.fmtp.forEach(function(e){e.config+=";sprop-stereo=1;stereo=1";});}),bO(t);};function IO(e){var t=kO(e);return t.media.forEach(function(e){if(e.type===HT){var t=new Set();e.rtp.forEach(function(e){var n=e.payload;return"H264"===e.codec&&t.add(n);}),e.fmtp.forEach(function(e){var n=e.payload,i=e.config.match(/apt=(\d+)/);i&&i[1]&&t.has(Number(i[1]))&&t.add(n);});var n=function n(e){var n=e.payload;return!t.has(n);};e.rtp=e.rtp.filter(n),e.rtcpFb=e.rtcpFb.filter(n),e.fmtp=e.fmtp.filter(n),e.payloads=e.payloads.split(" ").filter(function(e){return!t.has(Number(e));}).join(" ");}}),bO(t);}var EO,wO,RO,CO,AO=Ir,xO=ee,PO=Ri,DO=tg,OO=fp,NO=x,MO=RangeError,LO=String,UO=Math.floor,VO=xO(OO),FO=xO("".slice),jO=xO(1..toFixed),BO=function BO(e,t,n){return 0===t?n:t%2==1?BO(e,t-1,n*e):BO(e*e,t/2,n);},HO=function HO(e,t,n){for(var i=-1,r=n;++i<6;){r+=t*e[i],e[i]=r%1e7,r=UO(r/1e7);}},GO=function GO(e,t){for(var n=6,i=0;--n>=0;){i+=e[n],e[n]=UO(i/t),i=i%t*1e7;}},WO=function WO(e){for(var t=6,n="";--t>=0;){if(""!==n||0===t||0!==e[t]){var i=LO(e[t]);n=""===n?i:n+VO("0",7-i.length)+i;}}return n;};AO({target:"Number",proto:!0,forced:NO(function(){return"0.000"!==jO(8e-5,3)||"1"!==jO(.9,0)||"1.25"!==jO(1.255,2)||"1000000000000000128"!==jO(0xde0b6b3a7640080,0);})||!NO(function(){jO({});})},{toFixed:function toFixed(e){var t,n,i,r,a=DO(this),o=PO(e),s=[0,0,0,0,0,0],c="",u="0";if(o<0||o>20)throw MO("Incorrect fraction digits");if(a!=a)return"NaN";if(a<=-1e21||a>=1e21)return LO(a);if(a<0&&(c="-",a=-a),a>1e-21)if(n=(t=function(e){for(var t=0,n=e;n>=4096;){t+=12,n/=4096;}for(;n>=2;){t+=1,n/=2;}return t;}(a*BO(2,69,1))-69)<0?a*BO(2,-t,1):a/BO(2,t,1),n*=4503599627370496,(t=52-t)>0){for(HO(s,0,n),i=o;i>=7;){HO(s,1e7,0),i-=7;}for(HO(s,BO(10,i,1),0),i=t-1;i>=23;){GO(s,1<<23),i-=23;}GO(s,1<<i),HO(s,1,1),GO(s,2),u=WO(s);}else HO(s,0,n),HO(s,1<<-t,0),u=WO(s)+VO("0",o);return u=o>0?c+((r=u.length)<=o?"0."+VO("0",o-r)+u:FO(u,0,r-o)+"."+FO(u,r-o)):c+u;}});var zO=(null===(EO=window)||void 0===EO?void 0:EO.requestIdleCallback)||function(e){var t=Date.now();return setTimeout(function(){e({didTimeout:!1,timeRemaining:function timeRemaining(){return Math.max(0,50-(Date.now()-t));}});},1e3);},JO=(null===(wO=window)||void 0===wO?void 0:wO.cancelIdleCallback)||function(e){clearTimeout(e);},qO=(null===(RO=window)||void 0===RO?void 0:RO.cancelAnimationFrame)||(null===(CO=window)||void 0===CO?void 0:CO.mozCancelAnimationFrame),KO=function(){function e(){o(this,e);}return c(e,null,[{key:"generateTaskID",value:function value(){return this.currentTaskID++;}},{key:"run",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:Tw,n=arguments.length>1?arguments[1]:void 0,i=arguments.length>2?arguments[2]:void 0;i=t(t({},e===bw?{delay:2e3,count:0,backgroundTask:!0}:e===Sw?{delay:1e4,count:0}:e===kw?{fps:60,delay:16.6,count:0,backgroundTask:!0}:{delay:2e3,count:0,backgroundTask:!0}),i),hA(n)&&(i=t(t({},i),n)),sA(e)&&(n=e,e=Tw);var r=t({taskID:this.generateTaskID(),loopCount:0,intervalID:null,timeoutID:null,rafID:null,ricID:null,taskName:e,callback:n},i);return this.taskMap.set(r.taskID,r),this[e](r),r.taskID;}},{key:"interval",value:function value(e){var t=this;return e.intervalID=setInterval(function(){e.callback(),e.loopCount+=1,t.isBreakLoop(e);},e.delay);}},{key:"timeout",value:function value(e){var t=this;return e.timeoutID=setTimeout(function n(){if(e.callback(),e.loopCount+=1,!t.isBreakLoop(e))return e.timeoutID=setTimeout(n,e.delay);},e.delay);}},{key:"ric",value:function value(e){var t,n=this,i=vA();return e.ricID=zO(function r(){if((t=vA()-i)>=e.delay&&(i=vA()-Math.floor(t%e.delay),e.callback(),e.loopCount+=1),!n.isBreakLoop(e))return e.ricID=zO(r,{timeout:e.delay});},{timeout:e.delay});}},{key:"raf",value:function value(e){var t=this;e.delay=(1e3/e.fps).toFixed(2);var n,i=vA(),r=function r(){if(document.hidden&&e.backgroundTask){if(n=vA()-i,i=vA(),e.callback(),e.loopCount+=1,t.isBreakLoop(e))return;return e.timeoutID=setTimeout(r,e.delay-Math.floor(n%e.delay));}if((n=vA()-i)>=e.delay&&(i=vA()-Math.floor(n%e.delay),e.callback(),e.loopCount+=1),!t.isBreakLoop(e))return e.rafID=requestAnimationFrame(r);};if(e.rafID=requestAnimationFrame(r),e.backgroundTask){var a=function a(){if(document.hidden){var t=vA()-i;t>=e.delay?r():e.timeoutID=setTimeout(r,e.delay-t);}};document.addEventListener("visibilitychange",a),e.onVisibilitychange=a,document.hidden&&a();}return e.taskID;}},{key:"hasTask",value:function value(e){return this.taskMap.has(e);}},{key:"clearTask",value:function value(e){if(!this.taskMap.has(e))return!0;var t=this.taskMap.get(e),n=t.intervalID,i=t.timeoutID,r=t.rafID,a=t.ricID,o=t.onVisibilitychange;return n&&clearInterval(n),i&&clearTimeout(i),r&&qO(r),a&&JO(a),o&&document.removeEventListener("visibilitychange",o),this.taskMap.delete(e),!0;}},{key:"isBreakLoop",value:function value(e){return!this.taskMap.has(e.taskID)||0!==e.count&&e.loopCount>=e.count&&(this.clearTask(e.taskID),!0);}}]),e;}();u(KO,"taskMap",new Map()),u(KO,"currentTaskID",1);var QO=function(){function e(){o(this,e),this.prefix_="TRTC",this.queue_=new Map(),this.checkStorage();}return c(e,[{key:"getRealKey",value:function value(e){return"".concat(this.prefix_,"_").concat(e);}},{key:"checkStorage",value:function value(){var e=this;if(MT()){var t=Object.keys(localStorage).filter(function(t){if(t.startsWith(e.prefix_)){var n=JSON.parse(localStorage.getItem(t));if(n&&n.expiresIn<Date.now())return!0;}return!1;});t.forEach(function(e){return localStorage.removeItem(e);});}}},{key:"doFlush",value:function value(){if(MT())try{var e,t=I(this.queue_);try{for(t.s();!(e=t.n()).done;){var n=S(e.value,2),i=n[0],r=n[1];localStorage.setItem(i,JSON.stringify(r));}}catch(a){t.e(a);}finally{t.f();}}catch(XJ){xx.warn(XJ);}}},{key:"getItem",value:function value(e){if(!MT())return null;try{var t=JSON.parse(localStorage.getItem(this.getRealKey(e)));return t&&t.expiresIn>=Date.now()?t.value:null;}catch(XJ){xx.warn(XJ);}}},{key:"setItem",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(MT())try{var i={expiresIn:Date.now()+YE,value:t};n?localStorage.setItem(this.getRealKey(e),JSON.stringify(i)):(this.queue_.set(this.getRealKey(e),i),KO.hasTask(this.intervalId_)||(this.intervalId_=KO.run(Sw,this.doFlush.bind(this),{count:1})));}catch(XJ){xx.warn(XJ);}}},{key:"deleteItem",value:function value(e){if(!MT())return!1;try{return e=this.getRealKey(e),this.queue_.delete(e),localStorage.removeItem(e),!0;}catch(XJ){return xx.warn(XJ),!1;}}},{key:"clear",value:function value(){if(MT())try{localStorage.clear();}catch(XJ){xx.warn(XJ);}}}]),e;}(),XO=new QO(),YO={result:!1,detail:{isBrowserSupported:!1,isWebRTCSupported:!1,isMediaDevicesSupported:!1,isH264EncodeSupported:!1,isVp8EncodeSupported:!1,isH264DecodeSupported:!1,isVp8DecodeSupported:!1}},$O="checkResult";var ZO=function ZO(){return!cT&&!Lb&&!(Vb&&Fb<80)&&!(Nb&&Mb<56);},eN=function eN(){return["RTCPeerConnection","webkitRTCPeerConnection","RTCIceGatherer"].filter(function(e){return e in window;}).length>0;},tN=function tN(){if(!navigator.mediaDevices)return!1;var e=["getUserMedia","enumerateDevices"];return e.filter(function(e){return e in navigator.mediaDevices;}).length===e.length;},nN=function(){var e=a(n().mark(function e(){var t,i,r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!YO.detail.isH264EncodeSupported||!YO.detail.isVp8EncodeSupported){e.next=2;break;}return e.abrupt("return",{isH264EncodeSupported:YO.detail.isH264EncodeSupported,isVp8EncodeSupported:YO.detail.isVp8EncodeSupported});case 2:return t="",i=!1,r=!1,e.prev=5,a=new RTCPeerConnection(),(o=document.createElement(jT)).getContext("2d"),s=o.captureStream(0),a.addTrack(s.getVideoTracks()[0],s),e.next=13,a.createOffer();case 13:return-1!==(t=e.sent).sdp.toLowerCase().indexOf("h264")&&(i=!0),-1!==t.sdp.toLowerCase().indexOf("vp8")&&(r=!0),a.close(),YO.detail.isH264EncodeSupported=i,YO.detail.isVp8EncodeSupported=r,e.abrupt("return",{isH264EncodeSupported:YO.detail.isH264EncodeSupported,isVp8EncodeSupported:YO.detail.isVp8EncodeSupported});case 22:return e.prev=22,e.t0=e.catch(5),e.abrupt("return",{isH264EncodeSupported:!1,isVp8EncodeSupported:!1});case 25:case"end":return e.stop();}}},e,null,[[5,22]]);}));return function(){return e.apply(this,arguments);};}();function iN(){return rN.apply(this,arguments);}function rN(){return rN=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.abrupt("return",new Promise(function(){var e=a(n().mark(function e(t){var i,r,o,s,c,u,d,l,h,p,f,m,_,v;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i={encode:!1,decode:!1},r=null,e.prev=2,o=document.createElement("canvas"),s=o.getContext("2d"),o.width=640,o.height=480,c=setInterval(function(){s.fillText("test",Math.floor(640*Math.random()),Math.floor(480*Math.random()));},33),u=-1,d=-1,r=function r(){clearInterval(u),clearInterval(c),clearTimeout(d),h.close(),p.close(),l.getTracks().forEach(function(e){return e.stop();});},d=setTimeout(function(){r(),t(i);},3e3),l=o.captureStream(),h=new RTCPeerConnection({}),p=new RTCPeerConnection({offerToReceiveAudio:!0,offerToReceiveVideo:!0}),h.addEventListener("icecandidate",function(e){return p.addIceCandidate(e.candidate);}),p.addEventListener("icecandidate",function(e){return h.addIceCandidate(e.candidate);}),h.addTrack(l.getVideoTracks()[0],l),e.next=20,h.createOffer();case 20:return f=e.sent,e.next=23,h.setLocalDescription(f);case 23:return e.next=25,p.setRemoteDescription(f);case 25:return e.next=27,p.createAnswer();case 27:return m=e.sent,_=kO(m.sdp),v=_.media[0].rtp.findIndex(function(e){return"H264"===e.codec;}),_.media[0].rtp=[_.media[0].rtp[v]],_.media[0].fmtp=_.media[0].fmtp.filter(function(e){return e.payload===_.media[0].rtp[0].payload;}),_.media[0].rtcpFb=_.media[0].rtcpFb.filter(function(e){return e.payload===_.media[0].rtp[0].payload;}),m.sdp=bO(_),e.next=36,p.setLocalDescription(m);case 36:return e.next=38,h.setRemoteDescription(m);case 38:u=setInterval(a(n().mark(function e(){var a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i.encode&&i.decode&&(r(),t(i)),e.next=3,h.getStats();case 3:return a=e.sent,e.next=6,p.getStats();case 6:o=e.sent,i.encode||a.forEach(function(e){"outbound-rtp"===e.type&&e.mediaType===HT&&e.framesEncoded>0&&(i.encode=!0);}),i.decode||o.forEach(function(e){"inbound-rtp"===e.type&&e.mediaType===HT&&e.framesDecoded>0&&(i.decode=!0);});case 9:case"end":return e.stop();}}},e);})),500),e.next=46;break;case 41:e.prev=41,e.t0=e.catch(2),r(),xx.warn(e.t0),t(i);case 46:case"end":return e.stop();}}},e,null,[[2,41]]);}));return function(t){return e.apply(this,arguments);};}()));case 1:case"end":return e.stop();}}},e);})),rN.apply(this,arguments);}var aN=function(){var e=a(n().mark(function e(){var t,i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!YO.detail.isH264DecodeSupported||!YO.detail.isVp8DecodeSupported){e.next=2;break;}return e.abrupt("return",{isH264DecodeSupported:YO.detail.isH264DecodeSupported,isVp8DecodeSupported:YO.detail.isVp8DecodeSupported});case 2:return t="",i=!1,r=!1,e.prev=5,a=new RTCPeerConnection(),e.next=9,a.createOffer({offerToReceiveAudio:1,offerToReceiveVideo:1});case 9:return-1!==(t=e.sent).sdp.toLowerCase().indexOf("h264")&&(i=!0),-1!==t.sdp.toLowerCase().indexOf("vp8")&&(r=!0),a.close(),e.abrupt("return",{isH264DecodeSupported:i,isVp8DecodeSupported:r});case 16:return e.prev=16,e.t0=e.catch(5),e.abrupt("return",{isH264DecodeSupported:!1,isVp8DecodeSupported:!1});case 19:case"end":return e.stop();}}},e,null,[[5,16]]);}));return function(){return e.apply(this,arguments);};}(),oN=function(){var e=a(n().mark(function e(){var t,i,r,a,o,s,c,u,d,l,h,p,f;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(cN()){e.next=2;break;}return e.abrupt("return",YO);case 2:return t=ZO(),i=eN(),r=tN(),e.next=7,nN();case 7:return a=e.sent,o=a.isH264EncodeSupported,s=a.isVp8EncodeSupported,e.next=12,aN();case 12:if(c=e.sent,u=c.isH264DecodeSupported,d=c.isVp8DecodeSupported,o&&s){e.next=21;break;}return e.next=18,nN();case 18:l=e.sent,o=l.isH264EncodeSupported,s=l.isVp8EncodeSupported;case 21:if(!(o&&u&&(gT||ST||AT)&&!Wb&&bT()<79)){e.next=29;break;}return e.next=24,iN();case 24:h=e.sent,p=h.encode,f=h.decode,o=p,u=f;case 29:return YO.result=t&&i&&r&&(o||s)&&(u||d),YO.detail.isBrowserSupported=t,YO.detail.isWebRTCSupported=i,YO.detail.isMediaDevicesSupported=r,YO.detail.isH264EncodeSupported=o,YO.detail.isVp8EncodeSupported=s,YO.detail.isH264DecodeSupported=u,YO.detail.isVp8DecodeSupported=d,uN(),XO.setItem($O,{ua:navigator.userAgent,checkResult:YO},!0),e.abrupt("return",YO);case 40:case"end":return e.stop();}}},e);}));return function(){return e.apply(this,arguments);};}(),sN=function(e,t){var n=null;return function(){if(n)return n;for(var i=arguments.length,r=new Array(i),a=0;a<i;a++){r[a]=arguments[a];}return(n=e.apply(t||this,r)).then(function(e){return n=null,e;}).catch(function(e){throw n=null,e;}),n;};}(oN);function cN(){return Object.keys(YO.detail).findIndex(function(e){return!YO.detail[e];})>=0;}function uN(){cN()&&(xx.warn(ZC({key:EC})),xx.info("".concat(navigator.userAgent," ").concat(JSON.stringify(YO.detail))));}function dN(){return!(!navigator.mediaDevices||!navigator.mediaDevices.getDisplayMedia);}function lN(){return"RTCPeerConnection"in window&&"getReceivers"in window.RTCPeerConnection.prototype;}function hN(){return"RTCPeerConnection"in window&&"getSenders"in window.RTCPeerConnection.prototype;}function pN(){return"RTCPeerConnection"in window&&"getTransceivers"in window.RTCPeerConnection.prototype;}function fN(){return"RTCPeerConnection"in window&&"addTransceiver"in window.RTCPeerConnection.prototype;}function mN(){return"RTCRtpSender"in window&&"replaceTrack"in window.RTCRtpSender.prototype;}function _N(){return"RTCRtpSender"in window&&"setParameters"in window.RTCRtpSender.prototype&&hN();}function vN(){return!!cA(navigator.mediaDevices)&&(xx.error(XC.NOT_SUPPORTED_MEDIA),!0);}function gN(){return"http:"===location.protocol&&!NT&&(xx.warn(ZC({key:IC})),!0);}var yN="RTCRtpSender"in window&&"createEncodedStreams"in window.RTCRtpSender.prototype&&bT()>=86;function SN(e){return!("candidate-pair"!==e.type||!e.nominated||"in-progress"!==e.state&&"succeeded"!==e.state)&&!(lA(e.selected)&&!e.selected);}var kN=new Map([[Ob,"Android"],[Db,"iOS"],[aT,"Windows"],[oT,"MacOS"],[sT,"Linux"]]);function bN(){var e="unknown";return kN.get(!0)&&(e=kN.get(!0)),e;}function TN(){var e="";screen.width&&(e+=(screen.width?screen.width*window.devicePixelRatio:"")+" * "+(screen.height?screen.height*window.devicePixelRatio:""));return e;}function IN(){var e=!1;return(navigator.getUserMedia||navigator.mediaDevices&&navigator.mediaDevices.getUserMedia)&&(e=!0),e;}function EN(){for(var e={isSupported:!1},t=["AudioContext","webkitAudioContext","mozAudioContext","msAudioContext"],n=0;n<t.length;n++){if(t[n]in window){e.isSupported=!0;break;}}return e.isSupported;}function wN(){return!(Kb||Db||ET&&ET<63)&&!(!ZO()||!("captureStream"in HTMLCanvasElement.prototype));}var RN=window.MediaStreamTrack&&"getSettings"in MediaStreamTrack.prototype,CN=window.MediaStreamTrack&&"getCapabilities"in MediaStreamTrack.prototype;var AN=function AN(){var e,t,n;return(null===(e=window)||void 0===e?void 0:e.OffscreenCanvas)&&(null===(t=window)||void 0===t?void 0:t.MediaStreamTrackProcessor)&&(null===(n=window)||void 0===n?void 0:n.MediaStreamTrackGenerator);};!function(){gN();var e=XO.getItem($O);e&&e.ua===navigator.userAgent&&(YO=e.checkResult),sN();}();var xN={STREAM_ADDED:"stream-added",STREAM_REMOVED:"stream-removed",STREAM_UPDATED:"stream-updated",STREAM_PUBLISHED:"stream-published",STREAM_SUBSCRIBED:"stream-subscribed",STREAM_UNSUBSCRIBED:"stream-unsubscribed",STATE_CHANGED:"state-changed",ERROR:"error",CONNECTION_STATE_CHANGED:"connection-state-changed",SEI_MESSAGE:fI},PN={STREAM_ADDED:"stream-added",STREAM_REMOVED:"stream-removed",STREAM_UPDATED:"stream-updated",STREAM_SUBSCRIBED:"stream-subscribed",CONNECTION_STATE_CHANGED:"connection-state-changed",PEER_JOIN:"peer-join",PEER_LEAVE:"peer-leave",MUTE_AUDIO:"mute-audio",MUTE_VIDEO:"mute-video",UNMUTE_AUDIO:"unmute-audio",UNMUTE_VIDEO:"unmute-video",CLIENT_BANNED:"client-banned",NETWORK_QUALITY:"network-quality",AUDIO_VOLUME:"audio-volume",SEI_MESSAGE:fI,ERROR:"error"},DN="player-state-changed",ON="screen-sharing-stopped",NN="connection-state-changed",MN="device-auto-recovered",LN="error",UN="player-state-changed",VN=Aw;Ir({target:"String",proto:!0,forced:Pw("small")},{small:function small(){return VN(this,"small","","");}});var FN,jN=function(){function e(t){o(this,e);var n=t.getUserId();this.log_=xx.createLogger({id:n,userId:n,sdkAppId:t.getSDKAppId()}),this.prevReportTime_=0,this.prevReport_={},this.prevEncoderImplementation_="",this.prevQualityLimitationReason_="",this.prevDecoderImplementationMap_=new Map();}var t,i,r,s;return c(e,[{key:"statInterval",get:function get(){return 0===this.prevReportTime_?2:(Date.now()-this.prevReportTime_)/1e3;}},{key:"getSenderStats",value:(s=a(n().mark(function e(t){var i,r,a,o,s=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i={audio:{bytesSent:0,packetsSent:0,audioLevel:0,totalAudioEnergy:0},video:{bytesSent:0,packetsSent:0,framesEncoded:0,frameWidth:0,frameHeight:0,framesSent:0,fpsCapture:0},small:{bytesSent:0,packetsSent:0,framesEncoded:0,frameWidth:0,frameHeight:0,framesSent:0,fpsCapture:0},auxiliary:{bytesSent:0,packetsSent:0,framesEncoded:0,frameWidth:0,frameHeight:0,framesSent:0,fpsCapture:0},rtt:0},r=t.getPeerConnection(),a=t.getSSRC(),!r){e.next=15;break;}return e.prev=4,e.next=7,r.getStats();case 7:e.sent.forEach(function(e){if("outbound-rtp"===e.type){if(e.mediaType===HT){if(!Nb&&0===e.bytesSent)return;e.ssrc!==a.video||cA(e.encoderImplementation)||s.prevEncoderImplementation_===e.encoderImplementation||(s.log_.info("encoderImplementation change to ".concat(e.encoderImplementation)),s.prevEncoderImplementation_=e.encoderImplementation),e.ssrc!==a.video||cA(e.qualityLimitationReason)||s.prevQualityLimitationReason_===e.qualityLimitationReason||(s.log_.info("qualityLimitationReason change to ".concat(e.qualityLimitationReason)),s.prevQualityLimitationReason_=e.qualityLimitationReason);var n=HT;e.ssrc===a.small?n=WT:e.ssrc===a.auxiliary&&(n=JT),i[n].bytesSent=e.bytesSent,i[n].packetsSent=e.packetsSent,i[n].framesEncoded=e.framesEncoded;}else e.mediaType===BT&&(i.audio.bytesSent=e.bytesSent,i.audio.packetsSent=e.packetsSent);}else"candidate-pair"===e.type?SN(e)&&dA(e.currentRoundTripTime)&&(i.rtt=Math.floor(1e3*e.currentRoundTripTime)):"media-source"===e.type&&(e.kind===BT?(i.audio.audioLevel=e.audioLevel||0,i.audio.totalAudioEnergy=e.totalAudioEnergy||0):e.kind===HT&&(e.trackIdentifier===t.getVideoTrackId(HT)?i.video.fpsCapture=e.framesPerSecond:e.trackIdentifier===t.getVideoTrackId(JT)?i.auxiliary.fpsCapture=e.framesPerSecond:i.small.fpsCapture=e.framesPerSecond));var r;cA(e.audioLevel)||(i.audio.audioLevel=e.audioLevel||0,i.audio.totalAudioEnergy=e.totalAudioEnergy||0),cA(e.frameWidth)||(e.trackIdentifier===t.getVideoTrackId(HT)||e.ssrc===a.video?r=HT:e.trackIdentifier===t.getVideoTrackId(JT)||e.ssrc===a.auxiliary?r=JT:e.trackIdentifier!==t.getVideoTrackId(WT)&&e.ssrc!==a.small||(r=WT),r&&(i[r].frameWidth=e.frameWidth,i[r].frameHeight=e.frameHeight,i[r].framesSent=e.framesSent));}),0===i.audio.audioLevel&&(i.audio.audioLevel=(null===(o=t.getLocalStream())||void 0===o?void 0:o.getInternalAudioLevel())||0),e.next=15;break;case 12:e.prev=12,e.t0=e.catch(4),this.log_.warn("failed to getStats on sender connection "+e.t0);case 15:return e.abrupt("return",i);case 16:case"end":return e.stop();}}},e,this,[[4,12]]);})),function(e){return s.apply(this,arguments);})},{key:"getReceiverStats",value:(r=a(n().mark(function e(t){var i,r,a,o,s,c=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i={tinyId:t.getTinyId(),userId:t.getUserId(),rtt:0,hasAudio:!1,hasVideo:!1,hasAuxiliary:!1,audio:{bytesReceived:0,packetsReceived:0,packetsLost:0,jitter:0,audioLevel:0,totalAudioEnergy:0},video:{bytesReceived:0,packetsReceived:0,packetsLost:0,framesReceived:0,framesDecoded:0,frameWidth:0,frameHeight:0},auxiliary:{bytesReceived:0,packetsReceived:0,packetsLost:0,framesReceived:0,framesDecoded:0,frameWidth:0,frameHeight:0}},!(r=t.getPeerConnection())){e.next=16;break;}return e.prev=3,a=t.getSSRC(),o=t.getTrackState(),e.next=8,r.getStats();case 8:e.sent.forEach(function(e){if("inbound-rtp"===e.type){if(e.mediaType===BT&&e.ssrc===a.audio&&o.audio)i.audio.packetsReceived=e.packetsReceived,i.audio.bytesReceived=e.bytesReceived,i.audio.packetsLost=e.packetsLost,i.audio.jitter=e.jitter,i.hasAudio=!0;else if(e.mediaType===HT){if(Nb&&0===e.bytesReceived)return;e.ssrc===a.video&&o.video&&(i.video.packetsReceived=e.packetsReceived,i.video.bytesReceived=e.bytesReceived,i.video.packetsLost=e.packetsLost,i.video.framesReceived=e.framesReceived,i.video.framesDecoded=e.framesDecoded,i.video.fpsDecoded=e.framesPerSecond,i.hasVideo=!0,!e.decoderImplementation||c.prevDecoderImplementationMap_.has(i.userId)&&c.prevDecoderImplementationMap_.get(i.userId)===e.decoderImplementation||(c.log_.info("".concat(i.userId," decoderImplementation change to ").concat(e.decoderImplementation)),c.prevDecoderImplementationMap_.set(i.userId,e.decoderImplementation))),e.ssrc===a.auxiliary&&o.auxiliary&&(i.auxiliary.packetsReceived=e.packetsReceived,i.auxiliary.bytesReceived=e.bytesReceived,i.auxiliary.packetsLost=e.packetsLost,i.auxiliary.framesReceived=e.framesReceived,i.auxiliary.framesDecoded=e.framesDecoded,i.auxiliary.fpsDecoded=e.framesPerSecond,i.hasAuxiliary=!0);}}else"candidate-pair"===e.type&&SN(e)&&dA(e.currentRoundTripTime)&&(i.rtt=Math.floor(1e3*e.currentRoundTripTime));cA(e.frameWidth)||(e.trackIdentifier!==t.getMainStreamVideoTrackId()&&e.ssrc!==a.video||(i.video.frameWidth=e.frameWidth,i.video.frameHeight=e.frameHeight),e.trackIdentifier!==t.getAuxStreamVideoTrackId()&&e.ssrc!==a.auxiliary||(i.auxiliary.frameWidth=e.frameWidth,i.auxiliary.frameHeight=e.frameHeight)),cA(e.audioLevel)||(i.audio.audioLevel=e.audioLevel||0,i.audio.totalAudioEnergy=e.totalAudioEnergy||0);}),0===i.audio.audioLevel&&(i.audio.audioLevel=(null===(s=t.getMainStream())||void 0===s?void 0:s.getInternalAudioLevel())||0),e.next=16;break;case 13:e.prev=13,e.t0=e.catch(3),this.log_.warn("failed to getStats on receiver connection "+e.t0);case 16:return e.abrupt("return",i);case 17:case"end":return e.stop();}}},e,this,[[3,13]]);})),function(e){return r.apply(this,arguments);})},{key:"getStats",value:(i=a(n().mark(function e(t,i){var r,a,o,s,c,u,d;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r={},!t){e.next=5;break;}return e.next=4,this.getSenderStats(t);case 4:r=e.sent;case 5:a=[],o=I(i),e.prev=7,o.s();case 9:if((s=o.n()).done){e.next=17;break;}return(c=S(s.value,2))[0],u=c[1],e.next=13,this.getReceiverStats(u);case 13:d=e.sent,a.push(d);case 15:e.next=9;break;case 17:e.next=22;break;case 19:e.prev=19,e.t0=e.catch(7),o.e(e.t0);case 22:return e.prev=22,o.f(),e.finish(22);case 25:return e.abrupt("return",{senderStats:r,receiverStats:a});case 26:case"end":return e.stop();}}},e,this,[[7,19,22,25]]);})),function(e,t){return i.apply(this,arguments);})},{key:"getDifferenceValue",value:function value(e,t){if(eO(e))return t;var n=t-e;return n<0?0:n;}},{key:"prepareReport",value:function value(e){var t=this,n=e.stats,i=e.report,r=e.freezeMap;if(!eO(n.senderStats)){var a;a={uint32_audio_level:1e8*n.senderStats.audio.audioLevel,uint32_audio_energy:1e6*n.senderStats.audio.totalAudioEnergy,uint32_audio_codec_bitrate:n.senderStats.audio.bytesSent,audioLevel:n.senderStats.audio.audioLevel};var o=[],s={uint32_video_stream_type:2,uint32_video_codec_fps:n.senderStats.video.framesSent,uint32_video_capture_fps:n.senderStats.video.fpsCapture,uint32_video_width:n.senderStats.video.frameWidth,uint32_video_height:n.senderStats.video.frameHeight,uint32_video_codec_bitrate:n.senderStats.video.bytesSent,uint32_video_enc_fps:n.senderStats.video.framesEncoded};if(o.push(s),n.senderStats.small.bytesSent){var c={uint32_video_stream_type:3,uint32_video_codec_fps:n.senderStats.small.framesSent||0,uint32_video_capture_fps:n.senderStats.small.fpsCapture||0,uint32_video_width:n.senderStats.small.frameWidth||0,uint32_video_height:n.senderStats.small.frameHeight||0,uint32_video_codec_bitrate:n.senderStats.small.bytesSent,uint32_video_enc_fps:n.senderStats.small.framesEncoded||0};o.push(c);}if(n.senderStats.auxiliary.bytesSent){var u={uint32_video_stream_type:7,uint32_video_codec_fps:n.senderStats.auxiliary.framesSent||0,uint32_video_capture_fps:n.senderStats.auxiliary.fpsCapture||0,uint32_video_width:n.senderStats.auxiliary.frameWidth||0,uint32_video_height:n.senderStats.auxiliary.frameHeight||0,uint32_video_codec_bitrate:n.senderStats.auxiliary.bytesSent,uint32_video_enc_fps:n.senderStats.auxiliary.framesEncoded||0};o.push(u);}var d={uint32_bitrate:0,uint32_rtt:n.senderStats.rtt};i.msg_up_stream_info={msg_audio_status:a,msg_video_status:o,msg_network_status:d};}var l=this.statInterval;i.msg_down_stream_info=[],n.receiverStats.forEach(function(e){var t={};if(t.msg_user_info={str_identifier:e.userId,uint64_tinyid:e.tinyId},t.msg_network_status={uint32_rtt:e.rtt},t.msg_video_status={},e.hasAudio){var n={uint32_audio_codec_bitrate:e.audio.bytesReceived,uint32_audio_total_bitrate:e.audio.bytesReceived,uint32_audio_level:1e8*e.audio.audioLevel,uint32_audio_energy:1e6*e.audio.totalAudioEnergy,uint32_audio_receive:e.audio.packetsReceived,uint32_audio_origin_lost:e.audio.packetsLost,audioLevel:e.audio.audioLevel};t.msg_audio_status=n;}if(t.msg_video_status=[],e.hasVideo){var a=r.get(e.userId+"_"+zI),o=a?a.duration:0,s={uint32_video_stream_type:2,uint32_video_receive_fps:e.video.framesReceived,uint32_video_width:e.video.frameWidth,uint32_video_height:e.video.frameHeight,uint32_video_codec_bitrate:e.video.bytesReceived,uint32_video_receive:e.video.packetsReceived,uint32_video_origin_lost:e.video.packetsLost,uint32_video_block_time:o,uint32_video_dec_fps:e.video.framesDecoded};t.msg_video_status.push(s);}if(e.hasAuxiliary){var c=r.get(e.userId+"_"+JI),u=c?c.duration:0,d={uint32_video_stream_type:7,uint32_video_receive_fps:e.auxiliary.framesReceived,uint32_video_width:e.auxiliary.frameWidth,uint32_video_height:e.auxiliary.frameHeight,uint32_video_codec_bitrate:e.auxiliary.bytesReceived,uint32_video_receive:e.auxiliary.packetsReceived+e.auxiliary.packetsLost,uint32_video_origin_lost:e.auxiliary.packetsLost,uint32_video_block_time:u,uint32_video_dec_fps:e.auxiliary.framesDecoded};t.msg_video_status.push(d);}i.msg_down_stream_info.push(t);});var h=this.prevReport_;if(this.prevReport_=JSON.parse(JSON.stringify(i)),i.msg_up_stream_info.msg_audio_status&&h.msg_up_stream_info.msg_audio_status){var p=h.msg_up_stream_info.msg_audio_status,f=i.msg_up_stream_info.msg_audio_status,m=this.getDifferenceValue(p.uint32_audio_codec_bitrate,f.uint32_audio_codec_bitrate);f.uint32_audio_codec_bitrate=Math.round(8*m/l),i.msg_up_stream_info.msg_network_status.uint32_bitrate+=f.uint32_audio_codec_bitrate;}var _=h.msg_up_stream_info.msg_video_status;i.msg_up_stream_info.msg_video_status.forEach(function(e){var n=_.find(function(t){return t.uint32_video_stream_type===e.uint32_video_stream_type;});if(!n||0===n.uint32_video_codec_bitrate)return e.uint32_video_codec_bitrate=0,e.uint32_video_enc_fps=0,void(e.uint32_video_codec_fps=0);var r=n.uint32_video_codec_bitrate,a=n.uint32_video_enc_fps,o=n.uint32_video_codec_fps,s=t.getDifferenceValue(r,e.uint32_video_codec_bitrate);e.uint32_video_codec_bitrate=Math.round(8*s/l),i.msg_up_stream_info.msg_network_status.uint32_bitrate+=e.uint32_video_codec_bitrate,e.uint32_video_enc_fps=Math.round(t.getDifferenceValue(a,e.uint32_video_enc_fps)/l),e.uint32_video_codec_fps=Math.round(t.getDifferenceValue(o,e.uint32_video_codec_fps)/l);});var v=i.msg_down_stream_info,g=h.msg_down_stream_info;return v.forEach(function(e){var n=g.find(function(t){return t.msg_user_info.uint64_tinyid===e.msg_user_info.uint64_tinyid;});if(n){if(e.msg_audio_status&&n.msg_audio_status){var i=e.msg_audio_status,r=n.msg_audio_status;i.uint32_audio_origin_lost=t.getDifferenceValue(r.uint32_audio_origin_lost,i.uint32_audio_origin_lost),i.uint32_audio_receive=t.getDifferenceValue(r.uint32_audio_receive,i.uint32_audio_receive),i.uint32_audio_receive+=i.uint32_audio_origin_lost;var a=t.getDifferenceValue(r.uint32_audio_codec_bitrate,i.uint32_audio_codec_bitrate);i.uint32_audio_codec_bitrate=Math.round(8*a/l),i.uint32_audio_total_bitrate=Math.round(8*a/l);}if(e.msg_video_status&&n.msg_video_status){var o=e.msg_video_status,s=n.msg_video_status;o.forEach(function(e){var n=s.find(function(t){return t.uint32_video_stream_type===e.uint32_video_stream_type;});if(!n)return e.uint32_video_receive=0,e.uint32_video_origin_lost=0,e.uint32_video_codec_bitrate=0,e.uint32_video_receive_fps=0,void(e.uint32_video_dec_fps=0);var i=n.uint32_video_receive,r=n.uint32_video_origin_lost,a=n.uint32_video_codec_bitrate,o=n.uint32_video_receive_fps,c=n.uint32_video_dec_fps;e.uint32_video_origin_lost=t.getDifferenceValue(r,e.uint32_video_origin_lost),e.uint32_video_receive=t.getDifferenceValue(i,e.uint32_video_receive)+e.uint32_video_origin_lost;var u=t.getDifferenceValue(a,e.uint32_video_codec_bitrate);e.uint32_video_codec_bitrate=Math.round(8*u/l);var d=t.getDifferenceValue(o,e.uint32_video_receive_fps);e.uint32_video_receive_fps=Math.round(d/l),e.uint32_video_dec_fps=Math.round(t.getDifferenceValue(c,e.uint32_video_dec_fps)/l);});}}}),i;}},{key:"getStatsReport",value:(t=a(n().mark(function e(t){var i,r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i=t.uplinkConnection,r=t.downlinkConnections,a=t.freezeMap,o={msg_up_stream_info:{msg_audio_status:{uint32_audio_format:0,uint32_audio_sample_rate:0,uint32_audio_codec_bitrate:0,uint32_audio_receive:0,uint32_audio_origin_lost:0,uint32_audio_level:0,uint32_audio_energy:0,audioLevel:0},msg_video_status:[{uint32_video_stream_type:0,uint32_video_codec_fps:0,uint32_video_capture_fps:0,uint32_video_width:0,uint32_video_height:0,uint32_video_codec_bitrate:0,uint32_video_receive:0,uint32_video_origin_lost:0,uint32_video_final_lost:0,uint32_video_enc_fps:0}],msg_network_status:{uint32_bitrate:0,uint32_rtt:0,uint32_lost:0}},msg_down_stream_info:[{msg_user_info:{str_identifier:"",uint64_tinyid:""},msg_audio_status:{uint32_audio_format:0,uint32_audio_sample_rate:0,uint32_audio_codec_bitrate:0,uint32_audio_total_bitrate:0,uint32_audio_level:0,uint32_audio_energy:0,uint32_audio_receive:0,uint32_audio_origin_lost:0,uint32_audio_final_lost:0,audioLevel:0},msg_video_status:[{uint32_video_stream_type:0,uint32_video_receive_fps:0,uint32_video_width:0,uint32_video_height:0,uint32_video_codec_bitrate:0,uint32_video_receive:0,uint32_video_origin_lost:0,uint32_video_block_time:0,uint32_video_dec_fps:0}],msg_network_status:{uint32_bitrate:0,uint32_rtt:0,uint32_lost:0,uint32_jitter:0}}]},e.next=4,this.getStats(i,r);case 4:return s=e.sent,"{}"===JSON.stringify(this.prevReport_)&&(this.prevReport_=JSON.parse(JSON.stringify(o))),this.prepareReport({stats:s,report:o,freezeMap:a,uplinkConnection:i,downlinkConnections:r}),this.prevReportTime_=Date.now(),e.abrupt("return",o);case 9:case"end":return e.stop();}}},e,this);})),function(e){return t.apply(this,arguments);})},{key:"reset",value:function value(){this.prevReportTime_=0,this.prevReport_={},this.prevEncoderImplementation_="",this.prevQualityLimitationReason_="",this.prevDecoderImplementationMap_=new Map();}}]),e;}(),BN=function(){function e(t){var n=t.signalChannel,i=t.connections,r=t.client;o(this,e),this.client_=r,this.signalChannel_=n,this.connections_=i,this.client_=r,this.log_=xx.createLogger({id:"q|"+this.client_.getUserId(),userId:this.client_.getUserId(),sdkAppId:this.client_.getSDKAppId()}),this.uplinkConnection_=null,this.uplinkNetworkQuality_=0,this.uplinkRTT_=0,this.uplinkLoss_=0,this.downlinkNetworkQuality_=0,this.downlinkRTT_=0,this.downlinkLoss_=0,this.downlinkPrevStatMap_=new Map(),this.downlinkLossAndRTTMap_=new Map(),this.interval_=-1,this.emitter_=new PA(),this.initialize();}var t,i;return c(e,[{key:"uplinkNetworkQuality",get:function get(){return this.uplinkNetworkQuality_;},set:function set(e){e!==this.uplinkNetworkQuality_&&this.log_.info("uplink network quality change ".concat(this.uplinkNetworkQuality," -> ").concat(e,", rtt: ").concat(this.uplinkRTT_,", loss: ").concat(this.uplinkLoss_)),this.uplinkNetworkQuality_=e;}},{key:"downlinkNetworkQuality",get:function get(){return this.downlinkNetworkQuality_;},set:function set(e){if(e!==this.downlinkNetworkQuality_){var t=this.getAverageLossAndRTT(k(this.downlinkLossAndRTTMap_.values())),n=t.rtt,i=t.loss;this.log_.info("downlink network quality change ".concat(this.downlinkNetworkQuality," -> ").concat(e,", rtt: ").concat(n,", loss: ").concat(i));}this.downlinkNetworkQuality_=e;}},{key:"initialize",value:function value(){var e=this;this.signalChannel_.on(zP.UPLINK_NETWORK_STATS,function(t){e.handleUplinkNetworkQuality(t);}),this.signalChannel_.on(LP,this.handleSignalConnectionStateChange.bind(this)),this.start();}},{key:"handleUplinkNetworkQuality",value:function value(e){if(!this.uplinkConnection_)return this.uplinkNetworkQuality=0,this.uplinkLoss_=0,void(this.uplinkRTT_=0);var t=this.uplinkConnection_.getPeerConnection();if(t&&this.isPeerConnectionDisconnected(t))return this.uplinkNetworkQuality=6,this.uplinkLoss_=0,void(this.uplinkRTT_=0);if(0===e.data.code){var n=e.data.data,i=n.expectAudPkg+n.expectVidPkg,r=n.recvAudPkg+n.recvVidPkg,a=i-r,o=n.delay;if(o&&this.updateDelay(o),0===i&&0===r)return;this.uplinkLoss_=a<=0?0:Math.round(a/i*100),this.uplinkRTT_=n.rtt,this.uplinkNetworkQuality=this.getNetworkQuality(this.uplinkLoss_,this.uplinkRTT_);}}},{key:"handleDownlinkNetworkQuality",value:(i=a(n().mark(function e(){var t,i,r,a,o,s,c,u,d,l,h,p,f,m,_,v=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.connections_&&0!==this.connections_.size){e.next=3;break;}return this.downlinkNetworkQuality=0,e.abrupt("return");case 3:if(t=k(this.connections_.values()),i=t.filter(function(e){return e.getPeerConnection()&&e.getPeerConnection().connectionState===iE;}),t.filter(function(e){return e.getPeerConnection()&&v.isPeerConnectionDisconnected(e.getPeerConnection());}).length!==t.length){e.next=9;break;}return this.downlinkNetworkQuality=6,e.abrupt("return");case 9:r=0;case 10:if(!(r<i.length)){e.next=31;break;}return a=i[r].getPeerConnection(),e.next=14,this.getStat(a);case 14:if(o=e.sent,s=o.rtt,c=o.totalPacketsLost,u=o.totalPacketsReceived,this.downlinkPrevStatMap_.has(a)){e.next=21;break;}return this.downlinkPrevStatMap_.set(a,{totalPacketsLost:c,totalPacketsReceived:u}),e.abrupt("continue",28);case 21:d=0,l=this.downlinkPrevStatMap_.get(a),h=c-l.totalPacketsLost,p=u-l.totalPacketsReceived,d=h<=0||p<0?0:Math.round(h/(h+p)*100),this.downlinkPrevStatMap_.set(a,{totalPacketsLost:c,totalPacketsReceived:u}),this.downlinkLossAndRTTMap_.set(a,{rtt:s,loss:d,userId:i[r].getUserId()});case 28:r++,e.next=10;break;case 31:if(k(this.downlinkPrevStatMap_.keys()).forEach(function(e){v.isPeerConnectionDisconnected(e)&&(v.downlinkPrevStatMap_.delete(e),v.downlinkLossAndRTTMap_.delete(e));}),0!==this.downlinkLossAndRTTMap_.size){e.next=34;break;}return e.abrupt("return");case 34:f=this.getAverageLossAndRTT(k(this.downlinkLossAndRTTMap_.values())),m=f.rtt,_=f.loss,this.downlinkRTT_=m,this.downlinkLoss_=_,this.downlinkNetworkQuality=this.getNetworkQuality(_,m);case 38:case"end":return e.stop();}}},e,this);})),function(){return i.apply(this,arguments);})},{key:"getStat",value:(t=a(n().mark(function e(t){var i,r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i={rtt:0,totalPacketsLost:0,totalPacketsReceived:0},t&&lN()){e.next=3;break;}return e.abrupt("return",i);case 3:r=t.getReceivers(),e.prev=4,a=0;case 6:if(!(a<r.length)){e.next=15;break;}return o=r[a],e.next=10,o.getStats();case 10:e.sent.forEach(function(e){"candidate-pair"===e.type&&dA(e.currentRoundTripTime)&&(i.rtt=Math.round(1e3*e.currentRoundTripTime)),"inbound-rtp"!==e.type||e.mediaType!==BT&&e.mediaType!==HT||(i.totalPacketsLost+=e.packetsLost,i.totalPacketsReceived+=e.packetsReceived);});case 12:a++,e.next=6;break;case 15:return e.abrupt("return",i);case 18:return e.prev=18,e.t0=e.catch(4),e.abrupt("return",i);case 21:case"end":return e.stop();}}},e,null,[[4,18]]);})),function(e){return t.apply(this,arguments);})},{key:"getAverageLossAndRTT",value:function value(e){var t={rtt:0,loss:0};return Array.isArray(e)&&e.length>0&&(e.forEach(function(e){t.rtt+=e.rtt,t.loss+=e.loss;}),Object.keys(t).forEach(function(n){t[n]=Math.round(t[n]/e.length);})),t;}},{key:"getNetworkQuality",value:function value(e,t){return e>50||t>500?5:e>30||t>350?4:e>20||t>200?3:e>10||t>100?2:e>=0||t>=0?1:0;}},{key:"handleSignalConnectionStateChange",value:function value(e){e.state===FP?(this.uplinkRTT_=0,this.uplinkLoss_=0,this.uplinkNetworkQuality=6):e.state===HP&&6===this.uplinkNetworkQuality&&(this.uplinkNetworkQuality=5);}},{key:"handleUplinkConnectionStateChange",value:function value(e){var t=e.state;t===KI?(this.uplinkLoss_=0,this.uplinkRTT_=0,this.uplinkNetworkQuality=6):t===YI&&6===this.uplinkNetworkQuality&&(this.uplinkNetworkQuality=5);}},{key:"isPeerConnectionDisconnected",value:function value(e){return!(!e||e.connectionState!==nE&&e.connectionState!==eE&&e.connectionState!==tE);}},{key:"setUplinkConnection",value:function value(e){this.uplinkConnection_=e,this.uplinkConnection_?this.uplinkConnection_.on(xN.CONNECTION_STATE_CHANGED,this.handleUplinkConnectionStateChange.bind(this)):(this.uplinkNetworkQuality=0,this.uplinkRTT_=0,this.uplinkLoss_=0);}},{key:"start",value:function value(){var e=this;-1===this.interval_?(this.log_.info("start network quality calculating"),this.interval_=KO.run(Sw,function(){e.handleDownlinkNetworkQuality(),DA.emit(kx,{client:e.client_,uplinkNetworkQuality:e.uplinkNetworkQuality,downlinkNetworkQuality:e.downlinkNetworkQuality,uplinkRTT:e.uplinkRTT_,uplinkLoss:e.uplinkLoss_,downlinkRTT:e.downlinkRTT_,downlinkLoss:e.downlinkLoss_,downlinkLossAndRTTMap:e.downlinkLossAndRTTMap_}),e.emitter_.emit(PN.NETWORK_QUALITY,{uplinkNetworkQuality:e.uplinkNetworkQuality,downlinkNetworkQuality:e.downlinkNetworkQuality,uplinkRTT:e.uplinkRTT_,uplinkLoss:e.uplinkLoss_,downlinkRTT:e.downlinkRTT_,downlinkLoss:e.downlinkLoss_});},{delay:2e3})):this.log_.info("network quality calculating is already started");}},{key:"stop",value:function value(){this.log_.info("stop network quality calculating"),-1!==this.interval_&&(KO.clearTask(this.interval_),this.interval_=-1),this.downlinkLossAndRTTMap_.clear(),this.downlinkPrevStatMap_.clear();}},{key:"on",value:function value(e,t){this.emitter_.on(e,t);}},{key:"updateDelay",value:function value(e){var t=this;e.forEach(function(e){var n=e.srcTinyId,i=e.videoDelay,r=e.audioDelay,a=t.connections_.get(n);a&&a.setDelay({videoDelay:i,audioDelay:r});});}}]),e;}(),HN=function(){function e(t){o(this,e),this.log_=xx.createLogger({id:t.client.getUserId(),userId:t.client.getUserId(),sdkAppId:t.client.getSDKAppId()}),this.localStream_=null,this.prevDevices_=[],this.initialize();}var t,i;return c(e,[{key:"initialize",value:function value(){navigator.mediaDevices&&(this.onDeviceChange=this.onDeviceChange.bind(this),navigator.mediaDevices.addEventListener("devicechange",this.onDeviceChange));}},{key:"destroy",value:function value(){navigator.mediaDevices&&navigator.mediaDevices.removeEventListener("devicechange",this.onDeviceChange);}},{key:"onDeviceChange",value:(i=a(n().mark(function e(){var t,i,r,a=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.localStream_&&this.localStream_.getMediaStream()&&!this.localStream_.getScreen()){e.next=2;break;}return e.abrupt("return");case 2:return e.next=4,QJ.getDevices();case 4:t=e.sent,i=t.filter(function(e){return a.prevDevices_.findIndex(function(t){var n=t.deviceId;return e.deviceId===n;})<0;}),r=this.prevDevices_.filter(function(e){return t.findIndex(function(t){var n=t.deviceId;return e.deviceId===n;})<0;}),i.length>0&&this.handleDeviceAdded(this.prevDevices_,i),r.length>0&&this.handleDeviceRemoved(t,r),this.prevDevices_=t;case 10:case"end":return e.stop();}}},e,this);})),function(){return i.apply(this,arguments);})},{key:"setLocalStream",value:(t=a(n().mark(function e(t){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!t){e.next=4;break;}return e.next=3,QJ.getDevices();case 3:this.prevDevices_=e.sent;case 4:this.localStream_=t;case 5:case"end":return e.stop();}}},e,this);})),function(e){return t.apply(this,arguments);})},{key:"handleDeviceAdded",value:function value(e,t){var n,i;if(this.localStream_){this.log_.warn("devicesAdded: ".concat(JSON.stringify(t))),this.localStream_.updateDeviceIdInUse();var r=t.filter(function(e){return e.kind===aI;}),a=t.filter(function(e){return e.kind===rI;}),o=e.filter(function(e){return e.kind===aI;}),s=e.filter(function(e){return e.kind===rI;}),c=r.length>0&&0===o.length&&"live"!==(null===(n=this.localStream_.getVideoTrack())||void 0===n?void 0:n.readyState),u=a.length>0&&0===s.length&&"live"!==(null===(i=this.localStream_.getAudioTrack())||void 0===i?void 0:i.readyState);if(u&&c)return this.log_.info("new microphone and camera detected, but there was no device before."),void this.localStream_.recoverCapture({audio:!0,video:!0,cameraId:r[0].deviceId,microphoneId:a[0].deviceId});c&&(this.log_.info("new camera detected, but there was no camera before."),this.localStream_.recoverCapture({audio:!1,video:!0,cameraId:r[0].deviceId})),u&&(this.log_.info("new microphone detected, but there was no microphone before."),this.localStream_.recoverCapture({audio:!0,video:!1,microphoneId:a[0].deviceId}));}}},{key:"handleDeviceRemoved",value:function value(e,t){if(this.localStream_){this.log_.warn("devicesRemoved: ".concat(JSON.stringify(t))),this.localStream_.updateDeviceIdInUse();var n=!1,i=!1,r=this.localStream_.getCameraId(),a=this.localStream_.getMicrophoneId();if(a===fw){var o=this.localStream_.getMicrophoneGroupId(),s=e.filter(function(e){return e.deviceId===fw&&e.kind===rI;})[0];s&&s.groupId!==o&&(i=!0);}if(t.forEach(function(e){var t=e.deviceId;r.length>0&&t===r?n=!0:a.length>0&&t===a&&(i=!0);}),n&&i)return this.log_.warn("current camera and microphone in use is lost, cameraId: ".concat(r,", microphoneId: ").concat(a)),void((this.localStream_.getAudio()||this.localStream_.getVideo())&&this.localStream_.recoverCapture({video:!0,audio:!0}));n&&(this.log_.warn("current camera in use is lost, deviceId: ".concat(r)),this.localStream_.getVideo()&&this.localStream_.recoverCapture({video:!0,audio:!1})),i&&(this.log_.warn("current microphone in use is lost, deviceId: ".concat(a)),this.localStream_.getAudio()&&this.localStream_.recoverCapture({video:!1,audio:!0}));}}}]),e;}(),GN=In.exports,WN=rn,zN=un,JN=Wu,qN=Cr,KN=M,QN=lt,XN=function XN(e,t,n,i){try{return i?t(zN(n)[0],n[1]):t(n);}catch(XJ){JN(e,"throw",XJ);}},YN=Ru,$N=Zr,ZN=Li,eM=Gc,tM=ju,nM=Ou,iM=Array,rM=ee,aM=2147483647,oM=/[^\0-\u007E]/,sM=/[.\u3002\uFF0E\uFF61]/g,cM="Overflow: input needs wider integers to process",uM=RangeError,dM=rM(sM.exec),lM=Math.floor,hM=String.fromCharCode,pM=rM("".charCodeAt),fM=rM([].join),mM=rM([].push),_M=rM("".replace),vM=rM("".split),gM=rM("".toLowerCase),yM=function yM(e){return e+22+75*(e<26);},SM=function SM(e,t,n){var i=0;for(e=n?lM(e/700):e>>1,e+=lM(e/t);e>455;){e=lM(e/35),i+=36;}return lM(i+36*e/(e+38));},kM=function kM(e){var t=[];e=function(e){for(var t=[],n=0,i=e.length;n<i;){var r=pM(e,n++);if(r>=55296&&r<=56319&&n<i){var a=pM(e,n++);56320==(64512&a)?mM(t,((1023&r)<<10)+(1023&a)+65536):(mM(t,r),n--);}else mM(t,r);}return t;}(e);var n,i,r=e.length,a=128,o=0,s=72;for(n=0;n<e.length;n++){(i=e[n])<128&&mM(t,hM(i));}var c=t.length,u=c;for(c&&mM(t,"-");u<r;){var d=aM;for(n=0;n<e.length;n++){(i=e[n])>=a&&i<d&&(d=i);}var l=u+1;if(d-a>lM((aM-o)/l))throw uM(cM);for(o+=(d-a)*l,a=d,n=0;n<e.length;n++){if((i=e[n])<a&&++o>aM)throw uM(cM);if(i==a){for(var h=o,p=36;;){var f=p<=s?1:p>=s+26?26:p-s;if(h<f)break;var m=h-f,_=36-f;mM(t,hM(yM(f+m%_))),h=lM(m/_),p+=36;}mM(t,hM(yM(h))),s=SM(o,l,u==c),o=0,u++;}}o++,a++;}return fM(t,"");},bM=Ir,TM=P,IM=Tm,EM=C,wM=Cr,RM=ee,CM=bi,AM=function AM(e,t,n){return n.get&&GN(n.get,t,{getter:!0}),n.set&&GN(n.set,t,{setter:!0}),WN.f(e,t,n);},xM=sd,PM=ft,DM=oP,OM=function OM(e){var t=QN(e),n=$N(this),i=arguments.length,r=i>1?arguments[1]:void 0,a=void 0!==r;a&&(r=qN(r,i>2?arguments[2]:void 0));var o,s,c,u,d,l,h=nM(t),p=0;if(!h||this===iM&&YN(h))for(o=ZN(t),s=n?new this(o):iM(o);o>p;p++){l=a?r(t[p],p):t[p],eM(s,p,l);}else for(d=(u=tM(t,h)).next,s=n?new this():[];!(c=KN(d,u)).done;p++){l=a?XN(u,r,[c.value,p],!0):c.value,eM(s,p,l);}return s.length=p,s;},NM=Qc,MM=hl.codeAt,LM=function LM(e){var t,n,i=[],r=vM(_M(gM(e),sM,"."),".");for(t=0;t<r.length;t++){n=r[t],mM(i,dM(oM,n)?"xn--"+kM(n):n);}return fM(i,".");},UM=il,VM=Gs,FM=Gl,jM=G_,BM=ai,HM=BM.set,GM=BM.getterFor("URL"),WM=jM.URLSearchParams,zM=jM.getState,JM=EM.URL,qM=EM.TypeError,KM=EM.parseInt,QM=Math.floor,XM=Math.pow,YM=RM("".charAt),$M=RM(/./.exec),ZM=RM([].join),eL=RM(1..toString),tL=RM([].pop),nL=RM([].push),iL=RM("".replace),rL=RM([].shift),aL=RM("".split),oL=RM("".slice),sL=RM("".toLowerCase),cL=RM([].unshift),uL="Invalid scheme",dL="Invalid host",lL="Invalid port",hL=/[a-z]/i,pL=/[\d+-.a-z]/i,fL=/\d/,mL=/^0x/i,_L=/^[0-7]+$/,vL=/^\d+$/,gL=/^[\da-f]+$/i,yL=/[\0\t\n\r #%/:<>?@[\\\]^|]/,SL=/[\0\t\n\r #/:<>?@[\\\]^|]/,kL=/^[\u0000-\u0020]+|[\u0000-\u0020]+$/g,bL=/[\t\n\r]/g,TL=function TL(e){var t,n,i,r;if("number"==typeof e){for(t=[],n=0;n<4;n++){cL(t,e%256),e=QM(e/256);}return ZM(t,".");}if("object"==(typeof e==='undefined'?'undefined':_typeof2(e))){for(t="",i=function(e){for(var t=null,n=1,i=null,r=0,a=0;a<8;a++){0!==e[a]?(r>n&&(t=i,n=r),i=null,r=0):(null===i&&(i=a),++r);}return r>n&&(t=i,n=r),t;}(e),n=0;n<8;n++){r&&0===e[n]||(r&&(r=!1),i===n?(t+=n?":":"::",r=!0):(t+=eL(e[n],16),n<7&&(t+=":")));}return"["+t+"]";}return e;},IL={},EL=DM({},IL,{" ":1,'"':1,"<":1,">":1,"`":1}),wL=DM({},EL,{"#":1,"?":1,"{":1,"}":1}),RL=DM({},wL,{"/":1,":":1,";":1,"=":1,"@":1,"[":1,"\\":1,"]":1,"^":1,"|":1}),CL=function CL(e,t){var n=MM(e,0);return n>32&&n<127&&!PM(t,e)?e:encodeURIComponent(e);},AL={ftp:21,file:null,http:80,https:443,ws:80,wss:443},xL=function xL(e,t){var n;return 2==e.length&&$M(hL,YM(e,0))&&(":"==(n=YM(e,1))||!t&&"|"==n);},PL=function PL(e){var t;return e.length>1&&xL(oL(e,0,2))&&(2==e.length||"/"===(t=YM(e,2))||"\\"===t||"?"===t||"#"===t);},DL=function DL(e){return"."===e||"%2e"===sL(e);},OL={},NL={},ML={},LL={},UL={},VL={},FL={},jL={},BL={},HL={},GL={},WL={},zL={},JL={},qL={},KL={},QL={},XL={},YL={},$L={},ZL={},eU=function eU(e,t,n){var i,r,a,o=UM(e);if(t){if(r=this.parse(o))throw qM(r);this.searchParams=null;}else{if(void 0!==n&&(i=new eU(n,!0)),r=this.parse(o,null,i))throw qM(r);(a=zM(new WM())).bindURL(this),this.searchParams=a;}};eU.prototype={type:"URL",parse:function parse(e,t,n){var i,r,a,o,s,c=this,u=t||OL,d=0,l="",h=!1,p=!1,f=!1;for(e=UM(e),t||(c.scheme="",c.username="",c.password="",c.host=null,c.port=null,c.path=[],c.query=null,c.fragment=null,c.cannotBeABaseURL=!1,e=iL(e,kL,"")),e=iL(e,bL,""),i=OM(e);d<=i.length;){switch(r=i[d],u){case OL:if(!r||!$M(hL,r)){if(t)return uL;u=ML;continue;}l+=sL(r),u=NL;break;case NL:if(r&&($M(pL,r)||"+"==r||"-"==r||"."==r))l+=sL(r);else{if(":"!=r){if(t)return uL;l="",u=ML,d=0;continue;}if(t&&(c.isSpecial()!=PM(AL,l)||"file"==l&&(c.includesCredentials()||null!==c.port)||"file"==c.scheme&&!c.host))return;if(c.scheme=l,t)return void(c.isSpecial()&&AL[c.scheme]==c.port&&(c.port=null));l="","file"==c.scheme?u=JL:c.isSpecial()&&n&&n.scheme==c.scheme?u=LL:c.isSpecial()?u=jL:"/"==i[d+1]?(u=UL,d++):(c.cannotBeABaseURL=!0,nL(c.path,""),u=YL);}break;case ML:if(!n||n.cannotBeABaseURL&&"#"!=r)return uL;if(n.cannotBeABaseURL&&"#"==r){c.scheme=n.scheme,c.path=NM(n.path),c.query=n.query,c.fragment="",c.cannotBeABaseURL=!0,u=ZL;break;}u="file"==n.scheme?JL:VL;continue;case LL:if("/"!=r||"/"!=i[d+1]){u=VL;continue;}u=BL,d++;break;case UL:if("/"==r){u=HL;break;}u=XL;continue;case VL:if(c.scheme=n.scheme,r==FN)c.username=n.username,c.password=n.password,c.host=n.host,c.port=n.port,c.path=NM(n.path),c.query=n.query;else if("/"==r||"\\"==r&&c.isSpecial())u=FL;else if("?"==r)c.username=n.username,c.password=n.password,c.host=n.host,c.port=n.port,c.path=NM(n.path),c.query="",u=$L;else{if("#"!=r){c.username=n.username,c.password=n.password,c.host=n.host,c.port=n.port,c.path=NM(n.path),c.path.length--,u=XL;continue;}c.username=n.username,c.password=n.password,c.host=n.host,c.port=n.port,c.path=NM(n.path),c.query=n.query,c.fragment="",u=ZL;}break;case FL:if(!c.isSpecial()||"/"!=r&&"\\"!=r){if("/"!=r){c.username=n.username,c.password=n.password,c.host=n.host,c.port=n.port,u=XL;continue;}u=HL;}else u=BL;break;case jL:if(u=BL,"/"!=r||"/"!=YM(l,d+1))continue;d++;break;case BL:if("/"!=r&&"\\"!=r){u=HL;continue;}break;case HL:if("@"==r){h&&(l="%40"+l),h=!0,a=OM(l);for(var m=0;m<a.length;m++){var _=a[m];if(":"!=_||f){var v=CL(_,RL);f?c.password+=v:c.username+=v;}else f=!0;}l="";}else if(r==FN||"/"==r||"?"==r||"#"==r||"\\"==r&&c.isSpecial()){if(h&&""==l)return"Invalid authority";d-=OM(l).length+1,l="",u=GL;}else l+=r;break;case GL:case WL:if(t&&"file"==c.scheme){u=KL;continue;}if(":"!=r||p){if(r==FN||"/"==r||"?"==r||"#"==r||"\\"==r&&c.isSpecial()){if(c.isSpecial()&&""==l)return dL;if(t&&""==l&&(c.includesCredentials()||null!==c.port))return;if(o=c.parseHost(l))return o;if(l="",u=QL,t)return;continue;}"["==r?p=!0:"]"==r&&(p=!1),l+=r;}else{if(""==l)return dL;if(o=c.parseHost(l))return o;if(l="",u=zL,t==WL)return;}break;case zL:if(!$M(fL,r)){if(r==FN||"/"==r||"?"==r||"#"==r||"\\"==r&&c.isSpecial()||t){if(""!=l){var g=KM(l,10);if(g>65535)return lL;c.port=c.isSpecial()&&g===AL[c.scheme]?null:g,l="";}if(t)return;u=QL;continue;}return lL;}l+=r;break;case JL:if(c.scheme="file","/"==r||"\\"==r)u=qL;else{if(!n||"file"!=n.scheme){u=XL;continue;}if(r==FN)c.host=n.host,c.path=NM(n.path),c.query=n.query;else if("?"==r)c.host=n.host,c.path=NM(n.path),c.query="",u=$L;else{if("#"!=r){PL(ZM(NM(i,d),""))||(c.host=n.host,c.path=NM(n.path),c.shortenPath()),u=XL;continue;}c.host=n.host,c.path=NM(n.path),c.query=n.query,c.fragment="",u=ZL;}}break;case qL:if("/"==r||"\\"==r){u=KL;break;}n&&"file"==n.scheme&&!PL(ZM(NM(i,d),""))&&(xL(n.path[0],!0)?nL(c.path,n.path[0]):c.host=n.host),u=XL;continue;case KL:if(r==FN||"/"==r||"\\"==r||"?"==r||"#"==r){if(!t&&xL(l))u=XL;else if(""==l){if(c.host="",t)return;u=QL;}else{if(o=c.parseHost(l))return o;if("localhost"==c.host&&(c.host=""),t)return;l="",u=QL;}continue;}l+=r;break;case QL:if(c.isSpecial()){if(u=XL,"/"!=r&&"\\"!=r)continue;}else if(t||"?"!=r){if(t||"#"!=r){if(r!=FN&&(u=XL,"/"!=r))continue;}else c.fragment="",u=ZL;}else c.query="",u=$L;break;case XL:if(r==FN||"/"==r||"\\"==r&&c.isSpecial()||!t&&("?"==r||"#"==r)){if(".."===(s=sL(s=l))||"%2e."===s||".%2e"===s||"%2e%2e"===s?(c.shortenPath(),"/"==r||"\\"==r&&c.isSpecial()||nL(c.path,"")):DL(l)?"/"==r||"\\"==r&&c.isSpecial()||nL(c.path,""):("file"==c.scheme&&!c.path.length&&xL(l)&&(c.host&&(c.host=""),l=YM(l,0)+":"),nL(c.path,l)),l="","file"==c.scheme&&(r==FN||"?"==r||"#"==r))for(;c.path.length>1&&""===c.path[0];){rL(c.path);}"?"==r?(c.query="",u=$L):"#"==r&&(c.fragment="",u=ZL);}else l+=CL(r,wL);break;case YL:"?"==r?(c.query="",u=$L):"#"==r?(c.fragment="",u=ZL):r!=FN&&(c.path[0]+=CL(r,IL));break;case $L:t||"#"!=r?r!=FN&&("'"==r&&c.isSpecial()?c.query+="%27":c.query+="#"==r?"%23":CL(r,IL)):(c.fragment="",u=ZL);break;case ZL:r!=FN&&(c.fragment+=CL(r,EL));}d++;}},parseHost:function parseHost(e){var t,n,i;if("["==YM(e,0)){if("]"!=YM(e,e.length-1))return dL;if(t=function(e){var t,n,i,r,a,o,s,c=[0,0,0,0,0,0,0,0],u=0,d=null,l=0,h=function h(){return YM(e,l);};if(":"==h()){if(":"!=YM(e,1))return;l+=2,d=++u;}for(;h();){if(8==u)return;if(":"!=h()){for(t=n=0;n<4&&$M(gL,h());){t=16*t+KM(h(),16),l++,n++;}if("."==h()){if(0==n)return;if(l-=n,u>6)return;for(i=0;h();){if(r=null,i>0){if(!("."==h()&&i<4))return;l++;}if(!$M(fL,h()))return;for(;$M(fL,h());){if(a=KM(h(),10),null===r)r=a;else{if(0==r)return;r=10*r+a;}if(r>255)return;l++;}c[u]=256*c[u]+r,2!=++i&&4!=i||u++;}if(4!=i)return;break;}if(":"==h()){if(l++,!h())return;}else if(h())return;c[u++]=t;}else{if(null!==d)return;l++,d=++u;}}if(null!==d)for(o=u-d,u=7;0!=u&&o>0;){s=c[u],c[u--]=c[d+o-1],c[d+--o]=s;}else if(8!=u)return;return c;}(oL(e,1,-1)),!t)return dL;this.host=t;}else if(this.isSpecial()){if(e=LM(e),$M(yL,e))return dL;if(t=function(e){var t,n,i,r,a,o,s,c=aL(e,".");if(c.length&&""==c[c.length-1]&&c.length--,(t=c.length)>4)return e;for(n=[],i=0;i<t;i++){if(""==(r=c[i]))return e;if(a=10,r.length>1&&"0"==YM(r,0)&&(a=$M(mL,r)?16:8,r=oL(r,8==a?1:2)),""===r)o=0;else{if(!$M(10==a?vL:8==a?_L:gL,r))return e;o=KM(r,a);}nL(n,o);}for(i=0;i<t;i++){if(o=n[i],i==t-1){if(o>=XM(256,5-t))return null;}else if(o>255)return null;}for(s=tL(n),i=0;i<n.length;i++){s+=n[i]*XM(256,3-i);}return s;}(e),null===t)return dL;this.host=t;}else{if($M(SL,e))return dL;for(t="",n=OM(e),i=0;i<n.length;i++){t+=CL(n[i],IL);}this.host=t;}},cannotHaveUsernamePasswordPort:function cannotHaveUsernamePasswordPort(){return!this.host||this.cannotBeABaseURL||"file"==this.scheme;},includesCredentials:function includesCredentials(){return""!=this.username||""!=this.password;},isSpecial:function isSpecial(){return PM(AL,this.scheme);},shortenPath:function shortenPath(){var e=this.path,t=e.length;!t||"file"==this.scheme&&1==t&&xL(e[0],!0)||e.length--;},serialize:function serialize(){var e=this,t=e.scheme,n=e.username,i=e.password,r=e.host,a=e.port,o=e.path,s=e.query,c=e.fragment,u=t+":";return null!==r?(u+="//",e.includesCredentials()&&(u+=n+(i?":"+i:"")+"@"),u+=TL(r),null!==a&&(u+=":"+a)):"file"==t&&(u+="//"),u+=e.cannotBeABaseURL?o[0]:o.length?"/"+ZM(o,"/"):"",null!==s&&(u+="?"+s),null!==c&&(u+="#"+c),u;},setHref:function setHref(e){var t=this.parse(e);if(t)throw qM(t);this.searchParams.update();},getOrigin:function getOrigin(){var e=this.scheme,t=this.port;if("blob"==e)try{return new tU(e.path[0]).origin;}catch(XJ){return"null";}return"file"!=e&&this.isSpecial()?e+"://"+TL(this.host)+(null!==t?":"+t:""):"null";},getProtocol:function getProtocol(){return this.scheme+":";},setProtocol:function setProtocol(e){this.parse(UM(e)+":",OL);},getUsername:function getUsername(){return this.username;},setUsername:function setUsername(e){var t=OM(UM(e));if(!this.cannotHaveUsernamePasswordPort()){this.username="";for(var n=0;n<t.length;n++){this.username+=CL(t[n],RL);}}},getPassword:function getPassword(){return this.password;},setPassword:function setPassword(e){var t=OM(UM(e));if(!this.cannotHaveUsernamePasswordPort()){this.password="";for(var n=0;n<t.length;n++){this.password+=CL(t[n],RL);}}},getHost:function getHost(){var e=this.host,t=this.port;return null===e?"":null===t?TL(e):TL(e)+":"+t;},setHost:function setHost(e){this.cannotBeABaseURL||this.parse(e,GL);},getHostname:function getHostname(){var e=this.host;return null===e?"":TL(e);},setHostname:function setHostname(e){this.cannotBeABaseURL||this.parse(e,WL);},getPort:function getPort(){var e=this.port;return null===e?"":UM(e);},setPort:function setPort(e){this.cannotHaveUsernamePasswordPort()||(""==(e=UM(e))?this.port=null:this.parse(e,zL));},getPathname:function getPathname(){var e=this.path;return this.cannotBeABaseURL?e[0]:e.length?"/"+ZM(e,"/"):"";},setPathname:function setPathname(e){this.cannotBeABaseURL||(this.path=[],this.parse(e,QL));},getSearch:function getSearch(){var e=this.query;return e?"?"+e:"";},setSearch:function setSearch(e){""==(e=UM(e))?this.query=null:("?"==YM(e,0)&&(e=oL(e,1)),this.query="",this.parse(e,$L)),this.searchParams.update();},getSearchParams:function getSearchParams(){return this.searchParams.facade;},getHash:function getHash(){var e=this.fragment;return e?"#"+e:"";},setHash:function setHash(e){""!=(e=UM(e))?("#"==YM(e,0)&&(e=oL(e,1)),this.fragment="",this.parse(e,ZL)):this.fragment=null;},update:function update(){this.query=this.searchParams.serialize()||null;}};var tU=function tU(e){var t=xM(this,nU),n=FM(arguments.length,1)>1?arguments[1]:void 0,i=HM(t,new eU(e,!1,n));TM||(t.href=i.serialize(),t.origin=i.getOrigin(),t.protocol=i.getProtocol(),t.username=i.getUsername(),t.password=i.getPassword(),t.host=i.getHost(),t.hostname=i.getHostname(),t.port=i.getPort(),t.pathname=i.getPathname(),t.search=i.getSearch(),t.searchParams=i.getSearchParams(),t.hash=i.getHash());},nU=tU.prototype,iU=function iU(e,t){return{get:function get(){return GM(this)[e]();},set:t&&function(e){return GM(this)[t](e);},configurable:!0,enumerable:!0};};if(TM&&(AM(nU,"href",iU("serialize","setHref")),AM(nU,"origin",iU("getOrigin")),AM(nU,"protocol",iU("getProtocol","setProtocol")),AM(nU,"username",iU("getUsername","setUsername")),AM(nU,"password",iU("getPassword","setPassword")),AM(nU,"host",iU("getHost","setHost")),AM(nU,"hostname",iU("getHostname","setHostname")),AM(nU,"port",iU("getPort","setPort")),AM(nU,"pathname",iU("getPathname","setPathname")),AM(nU,"search",iU("getSearch","setSearch")),AM(nU,"searchParams",iU("getSearchParams")),AM(nU,"hash",iU("getHash","setHash"))),CM(nU,"toJSON",function(){return GM(this).serialize();},{enumerable:!0}),CM(nU,"toString",function(){return GM(this).serialize();},{enumerable:!0}),JM){var rU=JM.createObjectURL,aU=JM.revokeObjectURL;rU&&CM(tU,"createObjectURL",wM(rU,JM)),aU&&CM(tU,"revokeObjectURL",wM(aU,JM));}VM(tU,"URL"),bM({global:!0,constructor:!0,forced:!IM,sham:!TM},{URL:tU});var oU,sU,cU=new Blob(["class VolumeMeter extends AudioWorkletProcessor{constructor(){super();this.volume=0;this.intervalTime=200;this.tick=this.intervalTime;this.isStop=false;this.port.onmessage=event=>{const{data}=event;switch(data.name){case'setIntervalTime':this.intervalTime=data.intervalTime;break;case'stop':this.isStop=true;break}}}process(inputs){const input=inputs[0];if(this.isStop){return false}if(input.length>0){const firstChannel=input[0];let sum=0;let rms;for(let i=0;i<firstChannel.length;++i){sum+=firstChannel[i]*firstChannel[i]}rms=Math.sqrt(sum/firstChannel.length);this.volume=Math.max(rms,this.volume*0.95);this.tick-=firstChannel.length;if(this.tick<0){this.tick+=(this.intervalTime/1000)*sampleRate;this.port.postMessage({volume:this.volume})}}return true}}registerProcessor('volume-meter',VolumeMeter);"],{type:"application/javascript"}),uU=!1,dU=function(){function e(t){o(this,e),this.context_=t.context,this.addModuleToContext();}var t;return c(e,[{key:"addModuleToContext",value:(t=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.context_.audioWorklet.addModule(URL.createObjectURL(cU));case 3:xx.info("worklet addModule success"),DA.emit(Tx),uU=!0,e.next=12;break;case 8:e.prev=8,e.t0=e.catch(0),xx.info("worklet addModule catch error. ".concat(e.t0.message)),DA.emit(Ix);case 12:case"end":return e.stop();}}},e,this,[[0,8]]);})),function(){return t.apply(this,arguments);})},{key:"initWorkletSuccess",get:function get(){return uU;}}]),e;}(),lU=0,hU=function(){function e(t){o(this,e);var n=t.track,i=t.log,r=t.stream;this.volume_=0,this.log_=i,this.track_=n,this.stream_=r,oU||(oU=TA()),this.audioCtx_=oU,this.destination_=this.audioCtx_.destination;var a=new MediaStream();a.addTrack(this.track_),this.streamSource_=this.audioCtx_.createMediaStreamSource(a),this.audioWorkletNode_=null,this.scriptProcessorNode_=null,this.interval_=200,DA.on(bx,this.resume,this),DA.on(QA,this.handleAudioLevelInterval,this),EA?(DA.on(Tx,this.initAudioWorklet,this),DA.on(Ix,this.initScriptProcessor,this),this.preload()):this.initScriptProcessor(),lU+=1;}return c(e,[{key:"preload",value:function value(){sU?sU.initWorkletSuccess&&this.initAudioWorklet():sU=new dU({context:oU});}},{key:"initAudioWorklet",value:function value(){var e=this;if(!this.audioWorkletNode_)try{this.audioWorkletNode_=new AudioWorkletNode(this.audioCtx_,"volume-meter"),this.audioWorkletNode_.port.onmessage=function(t){e.volume_=t.data.volume||0;},this.streamSource_.connect(this.audioWorkletNode_).connect(this.destination_),this.handleAudioLevelInterval({interval:this.interval_});}catch(XJ){this.log_.warn("load volume meter failed, load again."),this.initScriptProcessor();}}},{key:"initScriptProcessor",value:function value(){var e=this;if(!this.scriptProcessorNode_)try{this.scriptProcessorNode_=this.audioCtx_.createScriptProcessor(2048,1,1),this.scriptProcessorNode_.onaudioprocess=function(t){for(var n=t.inputBuffer.getChannelData(0),i=0,r=0;r<n.length;++r){i+=n[r]*n[r];}e.volume_=Math.sqrt(i/n.length)||0;},this.streamSource_.connect(this.scriptProcessorNode_),this.scriptProcessorNode_.connect(this.destination_);}catch(XJ){this.log_.error("volumeMeter init script processor error: "+XJ);}}},{key:"destroy",value:function value(){var e;(this.streamSource_&&this.streamSource_.disconnect(),this.scriptProcessorNode_&&(this.scriptProcessorNode_.onaudioprocess=null,this.scriptProcessorNode_.disconnect()),this.audioWorkletNode_&&(this.audioWorkletNode_.port.postMessage({name:"stop"}),this.audioWorkletNode_.port.onmessage=null,this.audioWorkletNode_.disconnect()),this.audioWorkletNode_=null,this.scriptProcessorNode_=null,this.audioCtx_=null,DA.off(bx,this.resume,this),DA.off(QA,this.handleAudioLevelInterval,this),DA.off(Tx,this.initAudioWorklet,this),DA.off(Ix,this.initScriptProcessor,this),lU>0&&(lU-=1),0===lU)&&(null===(e=oU)||void 0===e||e.close(),oU=null,sU=null);}},{key:"resume",value:function value(){var e;null===(e=oU)||void 0===e||e.resume();}},{key:"getInternalAudioLevel",value:function value(){return this.volume_;}},{key:"getCalculatedVolume",value:function value(){return this.volume_.toFixed(2);}},{key:"handleAudioLevelInterval",value:function value(e){var t,n=e.interval;this.interval_=n,null===(t=this.audioWorkletNode_)||void 0===t||t.port.postMessage({name:"setIntervalTime",intervalTime:n});}}]),e;}(),pU=function(){function e(t){o(this,e),this.stream_=t.stream,this.userId_=t.stream.getUserId(),this.log_=this.stream_.getLogger(),this.track_=t.track,t.gainedTrack&&(this.gainedTrack_=t.gainedTrack),this.div_=t.div,this.muted_=t.muted,this.outputDeviceId_=t.outputDeviceId,this.volume_=t.volume,this.pausedRetryCount_=5,this.emitter_=new PA(),this.initializeElement(),this.state_="NONE",this.volumeMeter_=new hU({stream:this.stream_,track:this.gainedTrack_||this.track_,log:this.log_});}var t,i,r,s;return c(e,[{key:"isPlaying",get:function get(){return this.state_===mI;}},{key:"initializeElement",value:function value(){if(this.isAudioElementInit()){var e=new MediaStream();e.addTrack(this.gainedTrack_||this.track_);var t=document.createElement(BT);t.srcObject=e,t.muted=this.muted_,t.setAttribute("id","audio_".concat(this.stream_.getId())),t.setAttribute("autoplay","autoplay"),t.setAttribute("playsinline","playsinline"),this.div_.appendChild(t),this.element_=t;}this.handleEvents();}},{key:"setMuted",value:function value(e){this.element_&&(this.element_.muted=e,this.muted_=e);}},{key:"play",value:(s=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!this.outputDeviceId_||!this.element_){e.next=3;break;}return e.next=3,this.element_.setSinkId(this.outputDeviceId_);case 3:if(this.setVolume(this.volume_),e.prev=4,!this.element_){e.next=8;break;}return e.next=8,this.element_.play();case 8:e.next=16;break;case 10:if(e.prev=10,e.t0=e.catch(4),t=ZC({key:yC,data:{media:"Audio",error:e.t0}}),this.log_.warn(t),!t.includes("NotAllowedError")){e.next=16;break;}throw new pD({code:hD.PLAY_NOT_ALLOWED,message:t});case 16:case"end":return e.stop();}}},e,this,[[4,10]]);})),function(){return s.apply(this,arguments);})},{key:"handleEvents",value:function value(){this.handleElementEvent=this.handleElementEvent.bind(this),this.handleTrackEvent=this.handleTrackEvent.bind(this),this.element_&&(this.element_.addEventListener(eI,this.handleElementEvent),this.element_.addEventListener(ZT,this.handleElementEvent),this.element_.addEventListener(tI,this.handleElementEvent),this.element_.addEventListener(nI,this.handleElementEvent)),this.track_.addEventListener(ZT,this.handleTrackEvent),this.track_.addEventListener(YT,this.handleTrackEvent),this.track_.addEventListener($T,this.handleTrackEvent),this.track_.readyState===ZT&&this.handleTrackEvent({type:ZT}),this.track_.muted&&this.handleTrackEvent({type:YT});}},{key:"handleElementEvent",value:(r=a(n().mark(function e(t){var i,r,a,o,s,c,u,d=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:i=t.type,e.t0=i,e.next=e.t0===eI?4:e.t0===ZT?9:e.t0===tI?12:e.t0===nI?21:32;break;case 4:return this.log_.info("audio player is playing"),this.state_=mI,DA.emit(ZA,{stream:this.stream_}),this.emitter_.emit(UN,{state:this.state_,reason:eI}),e.abrupt("break",32);case 9:return this.log_.info("audio player is ended"),this.state_!==vI&&(this.state_=vI,this.emitter_.emit(UN,{state:this.state_,reason:ZT})),e.abrupt("break",32);case 12:return this.log_.info("audio player is paused"),this.state_=_I,this.emitter_.emit(UN,{state:this.state_,reason:tI}),(r=this.div_&&document.getElementById(this.div_.id))||this.log_.warn("audio player has been remove, element ID: ".concat(this.div_.id)),a=bT(),this.pausedRetryCount_>0&&(dA(a)&&a<=70||!r)&&(this.resume(),this.pausedRetryCount_--),Db&&(this.interval_=KO.run(function(){d.element_&&d.state_===_I&&d.resume();},{delay:3e3})),e.abrupt("break",32);case 21:if(!this.element_||!this.element_.error){e.next=31;break;}return o="".concat(bN(),"/").concat(UT().name,"/").concat(UT().version),e.next=25,QJ.getSpeakers();case 25:s=e.sent,c=s[0].label,(u=s.find(function(e){return e.deviceId===d.outputDeviceId_;}))&&(c=u.label),this.log_.error("audio player error observed. code: ".concat(this.element_.error.code," message: ").concat(this.element_.error.message," deviceInfo: ").concat(o," speaker: ").concat(c)),nO.uploadEvent("stat-".concat(this.stream_.getType(),"-audio-").concat(xE,"-").concat(this.element_.error.code,"-").concat(o,"-").concat(c),this.element_.error);case 31:return e.abrupt("break",32);case 32:case"end":return e.stop();}}},e,this);})),function(e){return r.apply(this,arguments);})},{key:"handleTrackEvent",value:function value(e){var t=e.type;switch(t){case ZT:this.log_.info("audio player track is ended"),this.state_!==vI&&(this.state_=vI,this.emitter_.emit(UN,{state:this.state_,reason:ZT})),DA.emit(gx,{stream:this.stream_,type:t});break;case YT:this.log_.info("audio track is unable to provide media output"),this.stream_.isRemote()||bA(),this.state_!==_I&&(this.state_=_I,this.emitter_.emit(UN,{state:this.state_,reason:YT})),DA.emit(vx,{stream:this.stream_,type:t});break;case $T:this.log_.info("audio track is able to provide media output"),this.state_===_I&&(this.state_=mI,this.emitter_.emit(UN,{state:this.state_,reason:$T}));}}},{key:"unbindEvents",value:function value(){this.element_&&(this.element_.removeEventListener(eI,this.handleElementEvent),this.element_.removeEventListener(ZT,this.handleElementEvent),this.element_.removeEventListener(tI,this.handleElementEvent),this.element_.removeEventListener(nI,this.handleElementEvent)),this.track_&&(this.track_.removeEventListener(ZT,this.handleTrackEvent),this.track_.removeEventListener(YT,this.handleTrackEvent),this.track_.removeEventListener($T,this.handleTrackEvent));}},{key:"setSinkId",value:(i=a(n().mark(function e(t){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.outputDeviceId_===t){e.next=5;break;}if(!this.element_){e.next=4;break;}return e.next=4,this.element_.setSinkId(t);case 4:this.outputDeviceId_=t;case 5:case"end":return e.stop();}}},e,this);})),function(e){return i.apply(this,arguments);})},{key:"setVolume",value:function value(e){this.element_&&(this.log_.info("audioElement setVolume to : ".concat(e)),this.element_.volume=e);}},{key:"getAudioLevel",value:function value(){return this.volumeMeter_.getCalculatedVolume();}},{key:"getInternalAudioLevel",value:function value(){return this.volumeMeter_.getInternalAudioLevel();}},{key:"stop",value:function value(){this.unbindEvents(),this.element_&&(this.div_.removeChild(this.element_),this.element_.srcObject=null,this.element_=null),this.volumeMeter_&&(this.volumeMeter_.destroy(),this.volumeMeter_=null),this.interval_>0&&KO.clearTask(this.interval_);}},{key:"resume",value:(t=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(e.prev=0,this.volumeMeter_&&this.volumeMeter_.resume(),!this.element_){e.next=5;break;}return e.next=5,this.element_.play();case 5:e.next=13;break;case 7:if(e.prev=7,e.t0=e.catch(0),t=ZC({key:yC,data:{media:"Audio",error:e.t0}}),this.log_.warn(t),!t.includes("NotAllowedError")){e.next=13;break;}throw new pD({code:hD.PLAY_NOT_ALLOWED,message:t});case 13:case"end":return e.stop();}}},e,this,[[0,7]]);})),function(){return t.apply(this,arguments);})},{key:"on",value:function value(e,t){this.emitter_.on(e,t);}},{key:"isAudioElementInit",value:function value(){return!("15.2"===xT||"15.3"===xT||"15.4"===xT)||"local"!==this.stream_.getType()||!this.muted_||(this.log_.info("audioElement is muted."),!1);}}]),e;}(),fU=xn.PROPER,mU=x,_U=ng,vU=dg.trim;Ir({target:"String",proto:!0,forced:function(e){return mU(function(){return!!_U[e]()||"​᠎"!=="​᠎"[e]()||fU&&_U[e].name!==e;});}("trim")},{trim:function trim(){return vU(this);}});var gU="trtc_autoplay",yU="".concat(gU,"_mask"),SU="".concat(gU,"_wrapper"),kU="".concat(gU,"_header"),bU="".concat(gU,"_content"),TU="".concat(gU,"_action_wrapper"),IU="".concat(gU,"_question"),EU="".concat(gU,"_collapse"),wU="".concat(gU,"_action_confirm"),RU="".concat(gU,"_detail"),CU="#2473E8",AU="dialog",xU="".concat(AU,"-show"),PU="".concat(AU,"-1"),DU="".concat(AU,"-2"),OU=!1,NU=function NU(){return!!document.querySelector(".".concat(SU));},MU="".concat(lw,"/").concat(kA()?"zh-cn":"en","/tutorial-21-advanced-auto-play-policy.html"),LU="<br><a href='".concat(MU,"' target='_blank'>").concat(kA()?"其他方案？":"Any other solution?","</a>"),UU="".concat(kA()?"浏览器自动播放策略：在用户与页面产生交互（点击、触摸）之前，浏览器禁止播放有声媒体。该弹窗用于帮助用户恢复音视频播放。".concat(LU):"Autoplay Policy: Before user interacts with the web page (clicking, touching), page will not be allowed to play media with sound. This Dialog is used to help users resume playback. ".concat(LU)),VU=function(){function e(){if(o(this,e),this.dialogNode_=null,this.bodyPosition_="",this.content="音视频播放被浏览器拦截，请点击“恢复播放”。",kA()||(this.content='Media playback failed. Click the "Resume" to resume playback.'),!OU){var t=document.createElement("style");t.innerHTML=".".concat(yU,"{position:fixed;top:0;left:0;right:0;bottom:0;width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;background:rgba(0,0,0,0.5);z-index:1500;}.").concat(yU," div:not(.").concat(TU,"){display:block !important;}.").concat(SU,"{padding:14px;background:#fff;border-radius:3px;box-shadow:0px 3px 15px #434343;border:1px solid #d1cfcf;max-width:500px;}.").concat(SU," a{color:").concat(CU,";}.").concat(kU,"{overflow:hidden;text-overflow:ellipsis;font-size:16px;font-weight:600;}.").concat(bU,"{margin:8px 0;}.").concat(TU,"{width:100%;display:flex !important;align-items:center;justify-content:right;float:right;}.").concat(EU,"{margin-right:auto;cursor:pointer}.").concat(IU,"{height:100%;line-height:16px;cursor:pointer;}.").concat(wU,"{margin-left:8px;color:#fff;background:").concat(CU,";padding:4px 12px;outline:none;border:1px solid;border-radius:3px;font-weight:bold;}.").concat(wU,":hover{opacity:0.9;}.").concat(EU,",.").concat(wU,",.").concat(bU,",.").concat(IU,"{font-size:14px;}@media screen and (max-width:750px){.").concat(SU,"{width:80vw;}}"),document.head.appendChild(t),OU=!0;}this.showDetail_=!1,this.isCollapseClicked_=!1,this.isQuestionClicked_=!1,this.addDiaLog();}return c(e,[{key:"createDiaLog",value:function value(){var e=document.createElement("template");e.innerHTML='<div class="'.concat(yU,"\"><div class='").concat(SU,"'><div class='").concat(kU,"'>").concat(location.host,"</div><div class='").concat(bU,"'>").concat(this.content,"</div><div class='").concat(RU,'\' style="visibility:hidden;width:100%;height:0;font-size:12px;color:gray;">').concat(UU,"</div><div class='").concat(TU,"'></div></div></div>").trim();var t=document.createElement("button");t.className=wU,t.innerText=kA()?"恢复播放":"Resume",t.onclick=this.onConfirm.bind(this);var n=document.createElement("div");n.className=IU,n.innerHTML='<?xml version="1.0" encoding="UTF-8"?>\n    <svg class="icon" width="18" height="18" p-id="2030" t="1639646523624" version="1.1" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">\n    <path d="m464 784.35c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z" p-id="2031"/>\n    <path d="m512 960c-247.04 0-448-200.96-448-448s200.96-448 448-448 448 200.96 448 448-200.96 448-448 448zm0-831.71c-211.58 0-383.71 172.13-383.71 383.71 0 211.55 172.13 383.71 383.71 383.71 211.55 0 383.71-172.16 383.71-383.71 0-211.58-172.16-383.71-383.71-383.71z" p-id="2032"/>\n    <path d="m512 673.7c-17.665 0-32.001-14.336-32.001-31.999v-54.112c0-52.353 40-92.352 75.328-127.65 25.887-25.92 52.672-52.672 52.672-74.017 0-53.343-43.072-96.735-95.999-96.735-53.823 0-95.999 41.536-95.999 94.559 0 17.665-14.336 31.999-32.001 31.999s-32.001-14.336-32.001-31.999c0-87.424 71.775-158.56 160-158.56s160 72.095 160 160.74c0 47.904-36.32 84.192-71.424 119.3-27.84 27.776-56.576 56.512-56.576 82.336v54.112c0 17.665-14.336 32.032-32.001 32.032z" p-id="2033"/>\n    </svg>\n    ',n.onclick=this.onQuestionClick.bind(this);var i=document.createElement("div");i.className=EU,i.innerText="".concat(kA()?"详情 >":"Detail >"),i.onclick=this.onCollapseClick.bind(this);var r=e.content.firstChild,a=r.querySelector(".".concat(TU));return a.appendChild(i),a.appendChild(n),a.appendChild(t),r;}},{key:"addDiaLog",value:function value(){NU()||(this.dialogNode_=this.createDiaLog(),document.body.appendChild(this.dialogNode_),this.dialogNode_.onclick=this.onConfirm.bind(this),this.dialogNode_.querySelector(".".concat(SU)).onclick=function(e){return e.stopPropagation();},this.bodyPosition_=document.body.style.position,document.body.style.position="fixed",xx.info("show autoplay dialog"),nO.uploadEvent({log:xU}));}},{key:"deleteDiaLog",value:function value(){this.dialogNode_&&(document.body.removeChild(this.dialogNode_),document.body.style.position=this.bodyPosition_,this.dialogNode_=null);}},{key:"onConfirm",value:function value(){xx.warn("confirm clicked, try resume stream"),DA.emit(bx),this.deleteDiaLog();}},{key:"onCollapseClick",value:function value(){var e=this.dialogNode_.querySelector(".".concat(RU));e.style.visibility="".concat(this.showDetail_?"hidden":"visible"),e.style.height="".concat(this.showDetail_?0:"fit-content"),this.showDetail_=!this.showDetail_,this.isCollapseClicked_||nO.uploadEvent({log:PU}),this.isCollapseClicked_=!0;}},{key:"onQuestionClick",value:function value(){window.open(MU,"_blank"),this.isQuestionClicked_||nO.uploadEvent({log:DU}),this.isQuestionClicked_=!0;}}]),e;}(),FU=function(){function e(t){o(this,e),this.stream_=t.stream,this.userId_=t.stream.getUserId(),this.log_=this.stream_.getLogger(),this.track_=t.track,this.div_=t.div,this.muted_=t.muted,this.objectFit_=t.objectFit,this.mirror_=t.mirror,this.emitter_=new PA(),this.initializeElement(),this.state_="NONE",this.pausedRetryCount_=5;}var t;return c(e,[{key:"isPlaying",get:function get(){return this.state_===mI;}},{key:"initializeElement",value:function value(){var e=new MediaStream();e.addTrack(this.track_);var t=document.createElement(HT);t.srcObject=e,t.muted=!0;var n="width: 100%; height: 100%; object-fit: ".concat(this.objectFit_,";");this.mirror_&&(n+="transform: scaleX(-1);"),t.setAttribute("id","video_".concat(this.stream_.getId())),t.setAttribute("style",n),t.setAttribute("autoplay","autoplay"),t.setAttribute("playsinline","playsinline"),this.div_&&this.div_.appendChild(t),this.element_=t,this.handleEvents();}},{key:"setRect",value:function value(e){var t=e.width,n=e.height;this.element_&&(this.element_.style.width=t+"px",this.element_.style.height=n+"px");}},{key:"setMirror",value:function value(e){this.element_&&(this.element_.style.transform=e?"scaleX(-1)":"",this.mirror_=e);}},{key:"setObjectFit",value:function value(e){this.element_&&(this.element_.style.objectFit="".concat(e),this.objectFit_=e);}},{key:"play",value:(t=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.element_.play();case 3:e.next=11;break;case 5:if(e.prev=5,e.t0=e.catch(0),t=ZC({key:yC,data:{media:"Video",error:e.t0}}),this.log_.warn(t),!t.includes("NotAllowedError")){e.next=11;break;}throw new pD({code:hD.PLAY_NOT_ALLOWED,message:t});case 11:case"end":return e.stop();}}},e,this,[[0,5]]);})),function(){return t.apply(this,arguments);})},{key:"handleEvents",value:function value(){this.handleElementEvent=this.handleElementEvent.bind(this),this.handleTrackEvent=this.handleTrackEvent.bind(this),this.element_.addEventListener(eI,this.handleElementEvent),this.element_.addEventListener(ZT,this.handleElementEvent),this.element_.addEventListener(tI,this.handleElementEvent),this.element_.addEventListener(nI,this.handleElementEvent),this.element_.addEventListener(iI,this.handleElementEvent),this.track_.addEventListener(ZT,this.handleTrackEvent),this.track_.addEventListener(YT,this.handleTrackEvent),this.track_.addEventListener($T,this.handleTrackEvent),this.track_.readyState===ZT&&this.handleTrackEvent({type:ZT}),this.track_.muted&&this.handleTrackEvent({type:YT});}},{key:"handleElementEvent",value:function value(e){var t=this;switch(e.type){case eI:this.log_.info("video player is playing"),this.state_=mI,DA.emit($A,{stream:this.stream_}),this.emitter_.emit(UN,{state:this.state_,reason:eI}),this.interval_&&(KO.clearTask(this.interval_),this.interval_=null);break;case ZT:this.log_.info("video player is ended"),this.state_!==vI&&(this.state_=vI,this.emitter_.emit(UN,{state:this.state_,reason:ZT}));break;case tI:this.log_.info("video player is paused"),this.div_&&!document.getElementById(this.div_.id)&&this.log_.warn("video player has been remove, element ID: ".concat(this.div_.id)),this.state_=_I,this.emitter_.emit(UN,{state:this.state_,reason:tI}),this.pausedRetryCount_>0&&!NU()&&(this.log_.info("video player auto resume when video paused"),this.resume(),this.pausedRetryCount_--),Db&&(this.interval_=KO.run(function(){t.element_&&t.state_===_I&&t.resume();},{delay:3e3}));break;case nI:if(this.element_&&this.element_.error){var n="".concat(bN(),"/").concat(UT().name,"/").concat(UT().version);this.log_.error("video player error observed. code: ".concat(this.element_.error.code," message: ").concat(this.element_.error.message," deviceInfo: ").concat(n)),nO.uploadEvent("stat-".concat(this.stream_.getType(),"-video-").concat(xE,"-").concat(this.element_.error.code,"-").concat(n),this.element_.error);}break;case iI:DA.emit(fx,{stream:this.stream_});}}},{key:"handleTrackEvent",value:function value(e){var t=e.type;switch(t){case ZT:this.log_.info("video track is ended"),DA.emit(_x,{stream:this.stream_,type:t}),this.state_!==vI&&(this.state_=vI,this.emitter_.emit(UN,{state:this.state_,reason:ZT}));break;case YT:this.log_.info("video track is unable to provide media output"),this.stream_.isRemote()||bA(),DA.emit(lx,{stream:this.stream_,type:t}),this.state_!==_I&&(this.state_=_I,this.emitter_.emit(UN,{state:this.state_,reason:YT}));break;case $T:this.log_.info("video track is able to provide media output"),DA.emit(hx,{stream:this.stream_}),this.state_===_I&&(this.state_=mI,this.emitter_.emit(UN,{state:this.state_,reason:$T}));}}},{key:"unbindEvents",value:function value(){this.element_&&(this.element_.removeEventListener(eI,this.handleElementEvent),this.element_.removeEventListener(ZT,this.handleElementEvent),this.element_.removeEventListener(tI,this.handleElementEvent),this.element_.removeEventListener(nI,this.handleElementEvent),this.element_.removeEventListener(iI,this.handleElementEvent)),this.track_&&(this.track_.removeEventListener(ZT,this.handleTrackEvent),this.track_.removeEventListener(YT,this.handleTrackEvent),this.track_.removeEventListener($T,this.handleTrackEvent));}},{key:"stop",value:function value(){this.unbindEvents(),this.div_&&this.div_.removeChild(this.element_),this.element_.srcObject=null,this.element_=null,this.interval_&&KO.clearTask(this.interval_);}},{key:"resume",value:function value(){return this.play();}},{key:"getVideoFrame",value:function value(){var e=document.createElement("canvas");return e.width=this.element_.videoWidth,e.height=this.element_.videoHeight,e.getContext("2d").drawImage(this.element_,0,0),e.toDataURL("image/png");}},{key:"on",value:function value(e,t){this.emitter_.on(e,t);}},{key:"getElement",value:function value(){return this.element_?this.element_:null;}}]),e;}(),jU="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof DataView,BU=Ri,HU=Ni,GU=RangeError,WU=function WU(e){if(void 0===e)return 0;var t=BU(e),n=HU(t);if(t!==n)throw GU("Wrong length or index");return n;},zU=Array,JU=Math.abs,qU=Math.pow,KU=Math.floor,QU=Math.log,XU=Math.LN2,YU={pack:function pack(e,t,n){var i,r,a,o=zU(n),s=8*n-t-1,c=(1<<s)-1,u=c>>1,d=23===t?qU(2,-24)-qU(2,-77):0,l=e<0||0===e&&1/e<0?1:0,h=0;for((e=JU(e))!=e||Infinity===e?(r=e!=e?1:0,i=c):(i=KU(QU(e)/XU),e*(a=qU(2,-i))<1&&(i--,a*=2),(e+=i+u>=1?d/a:d*qU(2,1-u))*a>=2&&(i++,a/=2),i+u>=c?(r=0,i=c):i+u>=1?(r=(e*a-1)*qU(2,t),i+=u):(r=e*qU(2,u-1)*qU(2,t),i=0));t>=8;){o[h++]=255&r,r/=256,t-=8;}for(i=i<<t|r,s+=t;s>0;){o[h++]=255&i,i/=256,s-=8;}return o[--h]|=128*l,o;},unpack:function unpack(e,t){var n,i=e.length,r=8*i-t-1,a=(1<<r)-1,o=a>>1,s=r-7,c=i-1,u=e[c--],d=127&u;for(u>>=7;s>0;){d=256*d+e[c--],s-=8;}for(n=d&(1<<-s)-1,d>>=-s,s+=t;s>0;){n=256*n+e[c--],s-=8;}if(0===d)d=1-o;else{if(d===a)return n?NaN:u?-Infinity:Infinity;n+=qU(2,t),d-=o;}return(u?-1:1)*n*qU(2,d-t);}},$U=lt,ZU=Pi,eV=Li,tV=function tV(e){for(var t=$U(this),n=eV(t),i=arguments.length,r=ZU(i>1?arguments[1]:void 0,n),a=i>2?arguments[2]:void 0,o=void 0===a?n:ZU(a,n);o>r;){t[r++]=e;}return t;},nV=C,iV=ee,rV=P,aV=jU,oV=xn,sV=Tn,cV=Nd,uV=x,dV=sd,lV=Ri,hV=Ni,pV=WU,fV=YU,mV=xs,_V=ic,vV=Ti.f,gV=rn.f,yV=tV,SV=Qc,kV=Gs,bV=oV.PROPER,TV=oV.CONFIGURABLE,IV=ai.get,EV=ai.set,wV="ArrayBuffer",RV="DataView",CV="Wrong index",AV=nV.ArrayBuffer,xV=AV,PV=xV&&xV.prototype,DV=nV.DataView,OV=DV&&DV.prototype,NV=Object.prototype,MV=nV.Array,LV=nV.RangeError,UV=iV(yV),VV=iV([].reverse),FV=fV.pack,jV=fV.unpack,BV=function BV(e){return[255&e];},HV=function HV(e){return[255&e,e>>8&255];},GV=function GV(e){return[255&e,e>>8&255,e>>16&255,e>>24&255];},WV=function WV(e){return e[3]<<24|e[2]<<16|e[1]<<8|e[0];},zV=function zV(e){return FV(e,23,4);},JV=function JV(e){return FV(e,52,8);},qV=function qV(e,t){gV(e.prototype,t,{get:function get(){return IV(this)[t];}});},KV=function KV(e,t,n,i){var r=pV(n),a=IV(e);if(r+t>a.byteLength)throw LV(CV);var o=IV(a.buffer).bytes,s=r+a.byteOffset,c=SV(o,s,s+t);return i?c:VV(c);},QV=function QV(e,t,n,i,r,a){var o=pV(n),s=IV(e);if(o+t>s.byteLength)throw LV(CV);for(var c=IV(s.buffer).bytes,u=o+s.byteOffset,d=i(+r),l=0;l<t;l++){c[u+l]=d[a?l:t-l-1];}};if(aV){var XV=bV&&AV.name!==wV;if(uV(function(){AV(1);})&&uV(function(){new AV(-1);})&&!uV(function(){return new AV(),new AV(1.5),new AV(NaN),1!=AV.length||XV&&!TV;}))XV&&TV&&sV(AV,"name",wV);else{(xV=function xV(e){return dV(this,PV),new AV(pV(e));}).prototype=PV;for(var YV,$V=vV(AV),ZV=0;$V.length>ZV;){(YV=$V[ZV++])in xV||sV(xV,YV,AV[YV]);}PV.constructor=xV;}_V&&mV(OV)!==NV&&_V(OV,NV);var eF=new DV(new xV(2)),tF=iV(OV.setInt8);eF.setInt8(0,2147483648),eF.setInt8(1,2147483649),!eF.getInt8(0)&&eF.getInt8(1)||cV(OV,{setInt8:function setInt8(e,t){tF(this,e,t<<24>>24);},setUint8:function setUint8(e,t){tF(this,e,t<<24>>24);}},{unsafe:!0});}else PV=(xV=function xV(e){dV(this,PV);var t=pV(e);EV(this,{bytes:UV(MV(t),0),byteLength:t}),rV||(this.byteLength=t);}).prototype,DV=function DV(e,t,n){dV(this,OV),dV(e,PV);var i=IV(e).byteLength,r=lV(t);if(r<0||r>i)throw LV("Wrong offset");if(r+(n=void 0===n?i-r:hV(n))>i)throw LV("Wrong length");EV(this,{buffer:e,byteLength:n,byteOffset:r}),rV||(this.buffer=e,this.byteLength=n,this.byteOffset=r);},OV=DV.prototype,rV&&(qV(xV,"byteLength"),qV(DV,"buffer"),qV(DV,"byteLength"),qV(DV,"byteOffset")),cV(OV,{getInt8:function getInt8(e){return KV(this,1,e)[0]<<24>>24;},getUint8:function getUint8(e){return KV(this,1,e)[0];},getInt16:function getInt16(e){var t=KV(this,2,e,arguments.length>1?arguments[1]:void 0);return(t[1]<<8|t[0])<<16>>16;},getUint16:function getUint16(e){var t=KV(this,2,e,arguments.length>1?arguments[1]:void 0);return t[1]<<8|t[0];},getInt32:function getInt32(e){return WV(KV(this,4,e,arguments.length>1?arguments[1]:void 0));},getUint32:function getUint32(e){return WV(KV(this,4,e,arguments.length>1?arguments[1]:void 0))>>>0;},getFloat32:function getFloat32(e){return jV(KV(this,4,e,arguments.length>1?arguments[1]:void 0),23);},getFloat64:function getFloat64(e){return jV(KV(this,8,e,arguments.length>1?arguments[1]:void 0),52);},setInt8:function setInt8(e,t){QV(this,1,e,BV,t);},setUint8:function setUint8(e,t){QV(this,1,e,BV,t);},setInt16:function setInt16(e,t){QV(this,2,e,HV,t,arguments.length>2?arguments[2]:void 0);},setUint16:function setUint16(e,t){QV(this,2,e,HV,t,arguments.length>2?arguments[2]:void 0);},setInt32:function setInt32(e,t){QV(this,4,e,GV,t,arguments.length>2?arguments[2]:void 0);},setUint32:function setUint32(e,t){QV(this,4,e,GV,t,arguments.length>2?arguments[2]:void 0);},setFloat32:function setFloat32(e,t){QV(this,4,e,zV,t,arguments.length>2?arguments[2]:void 0);},setFloat64:function setFloat64(e,t){QV(this,8,e,JV,t,arguments.length>2?arguments[2]:void 0);}});kV(xV,wV),kV(DV,RV);var nF={ArrayBuffer:xV,DataView:DV},iF=Ir,rF=ee,aF=x,oF=un,sF=Pi,cF=Ni,uF=ky,dF=nF.ArrayBuffer,lF=nF.DataView,hF=lF.prototype,pF=rF(dF.prototype.slice),fF=rF(hF.getUint8),mF=rF(hF.setUint8);iF({target:"ArrayBuffer",proto:!0,unsafe:!0,forced:aF(function(){return!new dF(2).slice(1,void 0).byteLength;})},{slice:function slice(e,t){if(pF&&void 0===t)return pF(oF(this),e);for(var n=oF(this).byteLength,i=sF(e,n),r=sF(void 0===t?n:t,n),a=new(uF(this,dF))(cF(r-i)),o=new lF(this),s=new lF(a),c=0;i<r;){mF(s,c++,fF(o,i++));}return a;}}),Ir({global:!0,constructor:!0,forced:!jU},{DataView:nF.DataView});var _F=Ir,vF=xr,gF=ee([].reverse),yF=[1,2];_F({target:"Array",proto:!0,forced:String(yF)===String(yF.reverse())},{reverse:function reverse(){return vF(this)&&(this.length=this.length),gF(this);}});var SF=qe,kF=lt,bF=ae,TF=Li,IF=TypeError,EF=function EF(e){return function(t,n,i,r){SF(n);var a=kF(t),o=bF(a),s=TF(a),c=e?s-1:0,u=e?-1:1;if(i<2)for(;;){if(c in o){r=o[c],c+=u;break;}if(c+=u,e?c<0:s<=c)throw IF("Reduce of empty array with no initial value");}for(;e?c>=0:s>c;c+=u){c in o&&(r=n(r,o[c],c,a));}return r;};},wF={left:EF(!1),right:EF(!0)},RF=wF.left,CF=De,AF=hy;Ir({target:"Array",proto:!0,forced:!Eh("reduce")||!AF&&CF>79&&CF<83},{reduce:function reduce(e){var t=arguments.length;return RF(this,e,t,t>1?arguments[1]:void 0);}});var xF=Fd,PF="ArrayBuffer",DF=nF.ArrayBuffer;Ir({global:!0,constructor:!0,forced:C.ArrayBuffer!==DF},{ArrayBuffer:DF}),xF(PF);var OF=Ir,NF=xr,MF=Zr,LF=ye,UF=Pi,VF=Li,FF=he,jF=Gc,BF=xt,HF=Bl,GF=ga("slice"),WF=BF("species"),zF=Array,JF=Math.max;OF({target:"Array",proto:!0,forced:!GF},{slice:function slice(e,t){var n,i,r,a=FF(this),o=VF(a),s=UF(e,o),c=UF(void 0===t?o:t,o);if(NF(a)&&(n=a.constructor,(MF(n)&&(n===zF||NF(n.prototype))||LF(n)&&null===(n=n[WF]))&&(n=void 0),n===zF||void 0===n))return HF(a,s,c);for(i=new(void 0===n?zF:n)(JF(c-s,0)),r=0;s<c;s++,r++){s in a&&jF(i,r,a[s]);}return i.length=r,i;}});var qF=C,KF=x,QF=ee,XF=il,YF=dg.trim,$F=ng,ZF=qF.parseInt,ej=qF.Symbol,tj=ej&&ej.iterator,nj=/^[+-]?0x/i,ij=QF(nj.exec),rj=8!==ZF($F+"08")||22!==ZF($F+"0x16")||tj&&!KF(function(){ZF(Object(tj));})?function(e,t){var n=YF(XF(e));return ZF(n,t>>>0||(ij(nj,n)?16:10));}:ZF;Ir({global:!0,forced:parseInt!=rj},{parseInt:rj});var aj,oj,sj,cj={exports:{}},uj=jU,dj=P,lj=C,hj=_e,pj=ye,fj=ft,mj=Fr,_j=Ge,vj=Tn,gj=bi,yj=rn.f,Sj=Ie,kj=xs,bj=ic,Tj=xt,Ij=yt,Ej=ai.enforce,wj=ai.get,Rj=lj.Int8Array,Cj=Rj&&Rj.prototype,Aj=lj.Uint8ClampedArray,xj=Aj&&Aj.prototype,Pj=Rj&&kj(Rj),Dj=Cj&&kj(Cj),Oj=Object.prototype,Nj=lj.TypeError,Mj=Tj("toStringTag"),Lj=Ij("TYPED_ARRAY_TAG"),Uj="TypedArrayConstructor",Vj=uj&&!!bj&&"Opera"!==mj(lj.opera),Fj=!1,jj={Int8Array:1,Uint8Array:1,Uint8ClampedArray:1,Int16Array:2,Uint16Array:2,Int32Array:4,Uint32Array:4,Float32Array:4,Float64Array:8},Bj={BigInt64Array:8,BigUint64Array:8},Hj=function Hj(e){var t=kj(e);if(pj(t)){var n=wj(t);return n&&fj(n,Uj)?n.TypedArrayConstructor:Hj(t);}},Gj=function Gj(e){if(!pj(e))return!1;var t=mj(e);return fj(jj,t)||fj(Bj,t);};for(aj in jj){(sj=(oj=lj[aj])&&oj.prototype)?Ej(sj).TypedArrayConstructor=oj:Vj=!1;}for(aj in Bj){(sj=(oj=lj[aj])&&oj.prototype)&&(Ej(sj).TypedArrayConstructor=oj);}if((!Vj||!hj(Pj)||Pj===Function.prototype)&&(Pj=function Pj(){throw Nj("Incorrect invocation");},Vj))for(aj in jj){lj[aj]&&bj(lj[aj],Pj);}if((!Vj||!Dj||Dj===Oj)&&(Dj=Pj.prototype,Vj))for(aj in jj){lj[aj]&&bj(lj[aj].prototype,Dj);}if(Vj&&kj(xj)!==Dj&&bj(xj,Dj),dj&&!fj(Dj,Mj))for(aj in Fj=!0,yj(Dj,Mj,{get:function get(){return pj(this)?this[Lj]:void 0;}}),jj){lj[aj]&&vj(lj[aj],Lj,aj);}var Wj={NATIVE_ARRAY_BUFFER_VIEWS:Vj,TYPED_ARRAY_TAG:Fj&&Lj,aTypedArray:function aTypedArray(e){if(Gj(e))return e;throw Nj("Target is not a typed array");},aTypedArrayConstructor:function aTypedArrayConstructor(e){if(hj(e)&&(!bj||Sj(Pj,e)))return e;throw Nj(_j(e)+" is not a typed array constructor");},exportTypedArrayMethod:function exportTypedArrayMethod(e,t,n,i){if(dj){if(n)for(var r in jj){var a=lj[r];if(a&&fj(a.prototype,e))try{delete a.prototype[e];}catch(XJ){try{a.prototype[e]=t;}catch(o){}}}Dj[e]&&!n||gj(Dj,e,n?t:Vj&&Cj[e]||t,i);}},exportTypedArrayStaticMethod:function exportTypedArrayStaticMethod(e,t,n){var i,r;if(dj){if(bj){if(n)for(i in jj){if((r=lj[i])&&fj(r,e))try{delete r[e];}catch(XJ){}}if(Pj[e]&&!n)return;try{return gj(Pj,e,n?t:Vj&&Pj[e]||t);}catch(XJ){}}for(i in jj){!(r=lj[i])||r[e]&&!n||gj(r,e,t);}}},getTypedArrayConstructor:Hj,isView:function isView(e){if(!pj(e))return!1;var t=mj(e);return"DataView"===t||fj(jj,t)||fj(Bj,t);},isTypedArray:Gj,TypedArray:Pj,TypedArrayPrototype:Dj},zj=C,Jj=x,qj=hd,Kj=Wj.NATIVE_ARRAY_BUFFER_VIEWS,Qj=zj.ArrayBuffer,Xj=zj.Int8Array,Yj=!Kj||!Jj(function(){Xj(1);})||!Jj(function(){new Xj(-1);})||!qj(function(e){new Xj(),new Xj(null),new Xj(1.5),new Xj(e);},!0)||Jj(function(){return 1!==new Xj(new Qj(2),1,void 0).length;}),$j=Ri,Zj=RangeError,eB=function eB(e){var t=$j(e);if(t<0)throw Zj("The argument can't be less than 0");return t;},tB=RangeError,nB=function nB(e,t){var n=eB(e);if(n%t)throw tB("Wrong offset");return n;},iB=Fr,rB=ee("".slice),aB=Vt,oB=TypeError,sB=function sB(e){var t=aB(e,"number");if("number"==typeof t)throw oB("Can't convert number to bigint");return BigInt(t);},cB=Cr,uB=M,dB=_y,lB=lt,hB=Li,pB=ju,fB=Ou,mB=Ru,_B=function _B(e){return"Big"===rB(iB(e),0,3);},vB=Wj.aTypedArrayConstructor,gB=sB,yB=Ir,SB=C,kB=M,bB=P,TB=Yj,IB=Wj,EB=nF,wB=sd,RB=H,CB=Tn,AB=Nx,xB=Ni,PB=WU,DB=nB,OB=Bt,NB=ft,MB=Fr,LB=ye,UB=Be,VB=ls,FB=Ie,jB=ic,BB=Ti.f,HB=function HB(e){var t,n,i,r,a,o,s,c,u=dB(this),d=lB(e),l=arguments.length,h=l>1?arguments[1]:void 0,p=void 0!==h,f=fB(d);if(f&&!mB(f))for(c=(s=pB(d,f)).next,d=[];!(o=uB(c,s)).done;){d.push(o.value);}for(p&&l>2&&(h=cB(h,arguments[2])),n=hB(d),i=new(vB(u))(n),r=_B(i),t=0;n>t;t++){a=p?h(d[t],t):d[t],i[t]=r?gB(a):+a;}return i;},GB=fa.forEach,WB=Fd,zB=rn,JB=A,qB=_d,KB=ai.get,QB=ai.set,XB=ai.enforce,YB=zB.f,$B=JB.f,ZB=Math.round,eH=SB.RangeError,tH=EB.ArrayBuffer,nH=tH.prototype,iH=EB.DataView,rH=IB.NATIVE_ARRAY_BUFFER_VIEWS,aH=IB.TYPED_ARRAY_TAG,oH=IB.TypedArray,sH=IB.TypedArrayPrototype,cH=IB.aTypedArrayConstructor,uH=IB.isTypedArray,dH="BYTES_PER_ELEMENT",lH="Wrong length",hH=function hH(e,t){cH(e);for(var n=0,i=t.length,r=new e(i);i>n;){r[n]=t[n++];}return r;},pH=function pH(e,t){YB(e,t,{get:function get(){return KB(this)[t];}});},fH=function fH(e){var t;return FB(nH,e)||"ArrayBuffer"==(t=MB(e))||"SharedArrayBuffer"==t;},mH=function mH(e,t){return uH(e)&&!UB(t)&&t in e&&AB(+t)&&t>=0;},_H=function _H(e,t){return t=OB(t),mH(e,t)?RB(2,e[t]):$B(e,t);},vH=function vH(e,t,n){return t=OB(t),!(mH(e,t)&&LB(n)&&NB(n,"value"))||NB(n,"get")||NB(n,"set")||n.configurable||NB(n,"writable")&&!n.writable||NB(n,"enumerable")&&!n.enumerable?YB(e,t,n):(e[t]=n.value,e);};bB?(rH||(JB.f=_H,zB.f=vH,pH(sH,"buffer"),pH(sH,"byteOffset"),pH(sH,"byteLength"),pH(sH,"length")),yB({target:"Object",stat:!0,forced:!rH},{getOwnPropertyDescriptor:_H,defineProperty:vH}),cj.exports=function(e,t,n){var i=e.match(/\d+$/)[0]/8,r=e+(n?"Clamped":"")+"Array",a="get"+e,o="set"+e,s=SB[r],c=s,u=c&&c.prototype,d={},l=function l(e,t){YB(e,t,{get:function get(){return function(e,t){var n=KB(e);return n.view[a](t*i+n.byteOffset,!0);}(this,t);},set:function set(e){return function(e,t,r){var a=KB(e);n&&(r=(r=ZB(r))<0?0:r>255?255:255&r),a.view[o](t*i+a.byteOffset,r,!0);}(this,t,e);},enumerable:!0});};rH?TB&&(c=t(function(e,t,n,r){return wB(e,u),qB(LB(t)?fH(t)?void 0!==r?new s(t,DB(n,i),r):void 0!==n?new s(t,DB(n,i)):new s(t):uH(t)?hH(c,t):kB(HB,c,t):new s(PB(t)),e,c);}),jB&&jB(c,oH),GB(BB(s),function(e){e in c||CB(c,e,s[e]);}),c.prototype=u):(c=t(function(e,t,n,r){wB(e,u);var a,o,s,d=0,h=0;if(LB(t)){if(!fH(t))return uH(t)?hH(c,t):kB(HB,c,t);a=t,h=DB(n,i);var p=t.byteLength;if(void 0===r){if(p%i)throw eH(lH);if((o=p-h)<0)throw eH(lH);}else if((o=xB(r)*i)+h>p)throw eH(lH);s=o/i;}else s=PB(t),a=new tH(o=s*i);for(QB(e,{buffer:a,byteOffset:h,byteLength:o,length:s,view:new iH(a)});d<s;){l(e,d++);}}),jB&&jB(c,oH),u=c.prototype=VB(sH)),u.constructor!==c&&CB(u,"constructor",c),XB(u).TypedArrayConstructor=c,aH&&CB(u,aH,r);var h=c!=s;d[r]=c,yB({global:!0,constructor:!0,forced:h,sham:!rH},d),dH in c||CB(c,dH,i),dH in u||CB(u,dH,i),WB(r);}):cj.exports=function(){},(0,cj.exports)("Uint8",function(e){return function(t,n,i){return e(this,t,n,i);};});var gH=lt,yH=Pi,SH=Li,kH=dh,bH=Math.min,TH=[].copyWithin||function(e,t){var n=gH(this),i=SH(n),r=yH(e,i),a=yH(t,i),o=arguments.length>2?arguments[2]:void 0,s=bH((void 0===o?i:yH(o,i))-a,i-r),c=1;for(a<r&&r<a+s&&(c=-1,a+=s-1,r+=s-1);s-->0;){a in n?n[r]=n[a]:kH(n,r),r+=c,a+=c;}return n;},IH=Wj,EH=ee(TH),wH=IH.aTypedArray;(0,IH.exportTypedArrayMethod)("copyWithin",function(e,t){return EH(wH(this),e,t,arguments.length>2?arguments[2]:void 0);});var RH=fa.every,CH=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("every",function(e){return RH(CH(this),e,arguments.length>1?arguments[1]:void 0);});var AH=tV,xH=sB,PH=Fr,DH=M,OH=x,NH=Wj.aTypedArray,MH=Wj.exportTypedArrayMethod,LH=ee("".slice);MH("fill",function(e){var t=arguments.length;NH(this);var n="Big"===LH(PH(this),0,3)?xH(e):+e;return DH(AH,this,n,t>1?arguments[1]:void 0,t>2?arguments[2]:void 0);},OH(function(){var e=0;return new Int8Array(2).fill({valueOf:function valueOf(){return e++;}}),1!==e;}));var UH=Li,VH=ky,FH=Wj.aTypedArrayConstructor,jH=Wj.getTypedArrayConstructor,BH=function BH(e){return FH(VH(e,jH(e)));},HH=function HH(e,t){for(var n=0,i=UH(t),r=new e(i);i>n;){r[n]=t[n++];}return r;},GH=BH,WH=fa.filter,zH=function zH(e,t){return HH(GH(e),t);},JH=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("filter",function(e){var t=WH(JH(this),e,arguments.length>1?arguments[1]:void 0);return zH(this,t);});var qH=fa.find,KH=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("find",function(e){return qH(KH(this),e,arguments.length>1?arguments[1]:void 0);});var QH=fa.findIndex,XH=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("findIndex",function(e){return QH(XH(this),e,arguments.length>1?arguments[1]:void 0);});var YH=fa.forEach,$H=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("forEach",function(e){YH($H(this),e,arguments.length>1?arguments[1]:void 0);});var ZH=Bi.includes,eG=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("includes",function(e){return ZH(eG(this),e,arguments.length>1?arguments[1]:void 0);});var tG=Bi.indexOf,nG=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("indexOf",function(e){return tG(nG(this),e,arguments.length>1?arguments[1]:void 0);});var iG=C,rG=x,aG=ee,oG=Wj,sG=Lc,cG=xt("iterator"),uG=iG.Uint8Array,dG=aG(sG.values),lG=aG(sG.keys),hG=aG(sG.entries),pG=oG.aTypedArray,fG=oG.exportTypedArrayMethod,mG=uG&&uG.prototype,_G=!rG(function(){mG[cG].call([1]);}),vG=!!mG&&mG.values&&mG[cG]===mG.values&&"values"===mG.values.name,gG=function gG(){return dG(pG(this));};fG("entries",function(){return hG(pG(this));},_G),fG("keys",function(){return lG(pG(this));},_G),fG("values",gG,_G||!vG,{name:"values"}),fG(cG,gG,_G||!vG,{name:"values"});var yG=Wj.aTypedArray,SG=Wj.exportTypedArrayMethod,kG=ee([].join);SG("join",function(e){return kG(yG(this),e);});var bG=jl,TG=he,IG=Ri,EG=Li,wG=Eh,RG=Math.min,CG=[].lastIndexOf,AG=!!CG&&1/[1].lastIndexOf(1,-0)<0,xG=wG("lastIndexOf"),PG=AG||!xG?function(e){if(AG)return bG(CG,this,arguments)||0;var t=TG(this),n=EG(t),i=n-1;for(arguments.length>1&&(i=RG(i,IG(arguments[1]))),i<0&&(i=n+i);i>=0;i--){if(i in t&&t[i]===e)return i||0;}return-1;}:CG,DG=jl,OG=PG,NG=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("lastIndexOf",function(e){var t=arguments.length;return DG(OG,NG(this),t>1?[e,arguments[1]]:[e]);});var MG=fa.map,LG=BH,UG=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("map",function(e){return MG(UG(this),e,arguments.length>1?arguments[1]:void 0,function(e,t){return new(LG(e))(t);});});var VG=wF.left,FG=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("reduce",function(e){var t=arguments.length;return VG(FG(this),e,t,t>1?arguments[1]:void 0);});var jG=wF.right,BG=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("reduceRight",function(e){var t=arguments.length;return jG(BG(this),e,t,t>1?arguments[1]:void 0);});var HG=Wj.aTypedArray,GG=Wj.exportTypedArrayMethod,WG=Math.floor;GG("reverse",function(){for(var e,t=this,n=HG(t).length,i=WG(n/2),r=0;r<i;){e=t[r],t[r++]=t[--n],t[n]=e;}return t;});var zG=C,JG=M,qG=Wj,KG=Li,QG=nB,XG=lt,YG=x,$G=zG.RangeError,ZG=zG.Int8Array,eW=ZG&&ZG.prototype,tW=eW&&eW.set,nW=qG.aTypedArray,iW=qG.exportTypedArrayMethod,rW=!YG(function(){var e=new Uint8ClampedArray(2);return JG(tW,e,{length:1,0:3},1),3!==e[1];}),aW=rW&&qG.NATIVE_ARRAY_BUFFER_VIEWS&&YG(function(){var e=new ZG(2);return e.set(1),e.set("2",1),0!==e[0]||2!==e[1];});iW("set",function(e){nW(this);var t=QG(arguments.length>1?arguments[1]:void 0,1),n=XG(e);if(rW)return JG(tW,this,n,t);var i=this.length,r=KG(n),a=0;if(r+t>i)throw $G("Wrong length");for(;a<r;){this[t+a]=n[a++];}},!rW||aW);var oW=BH,sW=Bl,cW=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("slice",function(e,t){for(var n=sW(cW(this),e,t),i=oW(this),r=0,a=n.length,o=new i(a);a>r;){o[r]=n[r++];}return o;},x(function(){new Int8Array(1).slice();}));var uW=fa.some,dW=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("some",function(e){return uW(dW(this),e,arguments.length>1?arguments[1]:void 0);});var lW=Ee.match(/firefox\/(\d+)/i),hW=!!lW&&+lW[1],pW=/MSIE|Trident/.test(Ee),fW=Ee.match(/AppleWebKit\/(\d+)\./),mW=!!fW&&+fW[1],_W=ee,vW=x,gW=qe,yW=Am,SW=hW,kW=pW,bW=De,TW=mW,IW=Wj.aTypedArray,EW=Wj.exportTypedArrayMethod,wW=C.Uint16Array,RW=wW&&_W(wW.prototype.sort),CW=!(!RW||vW(function(){RW(new wW(2),null);})&&vW(function(){RW(new wW(2),{});})),AW=!!RW&&!vW(function(){if(bW)return bW<74;if(SW)return SW<67;if(kW)return!0;if(TW)return TW<602;var e,t,n=new wW(516),i=Array(516);for(e=0;e<516;e++){t=e%4,n[e]=515-e,i[e]=e-2*t+3;}for(RW(n,function(e,t){return(e/4|0)-(t/4|0);}),e=0;e<516;e++){if(n[e]!==i[e])return!0;}});EW("sort",function(e){return void 0!==e&&gW(e),AW?RW(this,e):yW(IW(this),function(e){return function(t,n){return void 0!==e?+e(t,n)||0:n!=n?-1:t!=t?1:0===t&&0===n?1/t>0&&1/n<0?1:-1:t>n;};}(e));},!AW||CW);var xW=Ni,PW=Pi,DW=BH,OW=Wj.aTypedArray;(0,Wj.exportTypedArrayMethod)("subarray",function(e,t){var n=OW(this),i=n.length,r=PW(e,i);return new(DW(n))(n.buffer,n.byteOffset+r*n.BYTES_PER_ELEMENT,xW((void 0===t?i:PW(t,i))-r));});var NW=jl,MW=Wj,LW=x,UW=Bl,VW=C.Int8Array,FW=MW.aTypedArray,jW=MW.exportTypedArrayMethod,BW=[].toLocaleString,HW=!!VW&&LW(function(){BW.call(new VW(1));});jW("toLocaleString",function(){return NW(BW,HW?UW(FW(this)):FW(this),UW(arguments));},LW(function(){return[1,2].toLocaleString()!=new VW([1,2]).toLocaleString();})||!LW(function(){VW.prototype.toLocaleString.call([1,2]);}));var GW=Wj.exportTypedArrayMethod,WW=x,zW=ee,JW=C.Uint8Array,qW=JW&&JW.prototype||{},KW=[].toString,QW=zW([].join);WW(function(){KW.call({});})&&(KW=function KW(){return QW(this);});var XW=qW.toString!=KW;GW("toString",KW,XW);var YW=function(){function e(t,n,i){o(this,e),this.isUplink_=i,this.connection_=t,this.log_=n,this.seiMessageList_=[],this.seiPayloadType_=243,this.mainVideoSenderOrReceiver_=null,this.mainVideoAbortController_=null,this.abortMap_=new Map(),this.onSEIMessage=null;}return c(e,[{key:"isRunning",get:function get(){return!!this.mainVideoAbortController_;}},{key:"start",value:function value(e){this.mainVideoSenderOrReceiver_=e;var t=e.createEncodedStreams(),n=t.readable,i=t.writable,r=new TransformStream({transform:this.isUplink_?this.encodeVideoFrame.bind(this):this.decodeVideoFrame.bind(this)});this.mainVideoAbortController_=new AbortController(),n.pipeThrough(r).pipeTo(i,{signal:this.mainVideoAbortController_.signal}).catch(function(){});}},{key:"restart",value:function value(e){this.stop(),this.start(e);}},{key:"stop",value:function value(){var e;null===(e=this.mainVideoAbortController_)||void 0===e||e.abort(),this.mainVideoAbortController_=null;}},{key:"destroy",value:function value(){this.stop(),this.abortMap_.forEach(function(e){return e.abort();}),this.abortMap_.clear(),this.log_=null,this.onSEIMessage=null,this.mainVideoSenderOrReceiver_=null,this.connection_=null;}},{key:"handleEncodedStreams",value:function value(){var e=this;try{var t=this.connection_.getPeerConnection();this.clearUnusedSenderOrReceiver(t),this.isUplink_?t.getSenders().forEach(function(t,n){if(1===n){if(t===e.mainVideoSenderOrReceiver_)return;e.isRunning?e.restart(t):e.start(t);}else{if(e.abortMap_.has(t))return;e.pipeSenderOrReceiver(t);}}):t.getReceivers().forEach(function(t,n){var i;e.abortMap_.has(t)||t===e.mainVideoSenderOrReceiver_||(1===n&&(null===(i=t.track)||void 0===i?void 0:i.kind)===HT?e.isRunning?e.restart(t):e.start(t):e.pipeSenderOrReceiver(t));});}catch(XJ){this.log_.warn(XJ);}}},{key:"pipeSenderOrReceiver",value:function value(e){var t=e.createEncodedStreams(),n=t.readable,i=t.writable,r=new AbortController();this.abortMap_.set(e,r),n.pipeTo(i,{signal:r.signal}).catch(function(){});}},{key:"clearUnusedSenderOrReceiver",value:function value(e){var t=this;this.abortMap_.forEach(function(n,i){(t.isUplink_?e.getSenders():e.getReceivers()).find(function(e){return e===i;})||(n.abort(),t.abortMap_.delete(i));});}},{key:"push",value:function value(e,t){t&&t.seiPayloadType&&(this.seiPayloadType_=t.seiPayloadType),this.seiMessageList_.push(e);}},{key:"hasSEI",value:function value(e){var t=new DataView(e);return 1===t.getInt32(0)&&6===t.getInt8(4);}},{key:"isEmptyFrame",value:function value(e){return"empty"===e.type||0===e.data.byteLength;}},{key:"getNaluCount",value:function value(e){for(var t=0,n=0,i=new DataView(e),r=0;r<e.byteLength;r++){switch(i.getUint8(r)){case 0:t++;break;case 1:2!==t&&3!==t||n++,t=0;break;default:t=0;}}return n;}},{key:"encodeVideoFrame",value:function value(e,t){try{if(this.connection_.isH264&&this.seiMessageList_.length>0&&!this.isEmptyFrame(e)){var n=9-this.getNaluCount(e.data);if(n<=0)return;for(var i=this.seiMessageList_.splice(0,n).reverse().map(this.encodeSEINalu.bind(this)),r=i.reduce(function(e,t){return e+t.dataView.byteLength;},0),a=new ArrayBuffer(r+e.data.byteLength),o=new DataView(a),s=new DataView(e.data),c=0,u=0;u<i.length;u++){for(var d=0;d<i[u].dataView.byteLength;d++){o.setInt8(c++,i[u].dataView.getInt8(d));}}for(var l=0;l<e.data.byteLength;l++){o.setInt8(c++,s.getInt8(l));}e.data=a,this.log_.debug("".concat(i.length," sei sent"));}}catch(XJ){this.log_.warn(XJ);}t.enqueue(e);}},{key:"decodeVideoFrame",value:function value(e,t){var n=this;try{if(this.connection_.isH264&&!this.isEmptyFrame(e)&&this.hasSEI(e.data)){for(var i=[],r=new DataView(e.data),a=0,o=-1,s=-1,c=0;c<e.data.byteLength;c++){var u=r.getUint8(c);if(0===u)a++;else if(1===u){if(2===a||3===a){var d=c-a;if(-1===o?o=d:-1===s&&(s=d,i.push(new $W(new DataView(r.buffer.slice(o,s)))),o=d,s=-1),!(6===r.getUint8(c+1))){e.data=new DataView(r.buffer.slice(d)).buffer;break;}}a=0;}else a=0;}this.log_.debug("".concat(i.length," sei received")),sA(this.onSEIMessage)&&i.reverse().forEach(function(e){n.onSEIMessage({seiPayloadType:e.seiPayloadType,data:e.seiPayload.buffer});});}}catch(XJ){this.log_.warn(XJ);}t.enqueue(e);}},{key:"encodeSEINalu",value:function value(e){var t=e.byteLength,n=parseInt(t/255),i=t%255,r=[];r.push(0,0,0,1,6,this.seiPayloadType_);for(var a=0;a<n;a++){r.push(255);}r.push(i);var o=new DataView(e);return r.push.apply(r,k(new Uint8Array(o.buffer))),r.push(128),new $W(new DataView(new Uint8Array(r).buffer),!0);}}]),e;}(),$W=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];o(this,e),this.dataView=t,this.isSEI&&(n?this.addPreventionByte():this.removePreventionByte());}return c(e,[{key:"addPreventionByte",value:function value(){for(var e=this.seiPayloadStartIndex,t=this.dataView.byteLength-2,n=[],i=0,r=e;r<=t;r++){var a=this.dataView.getInt8(r);switch(a){case 0:case 1:case 2:case 3:2===i&&(n.push(3),i=0),0==a?i++:i=0,n.push(a);break;default:i=0,n.push(a);}}n.push(this.dataView.getInt8(this.dataView.byteLength-1));var o=new DataView(new Uint8Array([].concat(k(new Uint8Array(this.dataView.buffer).slice(0,e)),n)).buffer);this.dataView=o;}},{key:"removePreventionByte",value:function value(){for(var e=this.seiPayloadStartIndex,t=this.dataView.byteLength-1,n=[],i=0,r=e;r<=t;r++){switch(this.dataView.getInt8(r)){case 0:i++,n.push(this.dataView.getInt8(r));break;case 3:2!==i&&n.push(this.dataView.getInt8(r)),i=0;break;default:n.push(this.dataView.getInt8(r)),i=0;}}var a=new DataView(new Uint8Array([].concat(k(new Uint8Array(this.dataView.buffer).slice(0,e)),n)).buffer);this.dataView=a;}},{key:"isSEI",get:function get(){return 6===this.dataView.getUint8(4);}},{key:"seiPayloadStartIndex",get:function get(){for(var e=6,t=6;t<this.dataView.buffer.byteLength&&(e++,255===this.dataView.getUint8(t));t++){}return e;}},{key:"seiPayloadType",get:function get(){return this.isSEI?this.dataView.getUint8(5):null;}},{key:"seiPayload",get:function get(){if(!this.isSEI)return null;for(var e=0,t=6,n=6;n<this.dataView.buffer.byteLength;n++){var i=this.dataView.getUint8(n);if(t++,255!==i){e+=i;break;}e+=255;}for(var r=new ArrayBuffer(e),a=new DataView(r),o=0;o<r.byteLength;o++,t++){a.setInt8(o,this.dataView.getInt8(t));}return a;}}]),e;}(),ZW=function(){function e(t){o(this,e),this.userId_=t.userId,this.tinyId_=t.tinyId,this.client_=t.client,this.sdpSemantics_=t.client.getSdpSemantics(),this.isUplink_=t.isUplink,this.log_=xx.createLogger({id:"n|"+this.userId_,userId:this.client_.getUserId(),sdkAppId:this.client_.getSDKAppId(),isLocal:this.isUplink_}),this.signalChannel_=t.signalChannel,this.peerConnection_=null,this.isErrorObserved_=!1,this.emitter_=new PA(),this.currentState_=KI,this.waitForPeerConnectionConnectedPromise_=null,this.isReconnecting_=!1,this.reconnectionCount_=0,this.reconnectionTimer_=-1,this.isFirstConnection_=!0,this.delay_={audioDelay:0,videoDelay:0},this.enableSEI_=t.enableSEI,this.enableSEI_&&yN&&(this.sei_=new YW(this,this.log_,this.isUplink_));}var t;return c(e,[{key:"initialize",value:function value(){var e={encodedInsertableStreams:this.enableSEI_&&yN,iceServers:this.client_.getIceServers(),iceTransportPolicy:this.client_.getIceTransportPolicy(),sdpSemantics:this.sdpSemantics_,bundlePolicy:"max-bundle",rtcpMuxPolicy:"require",tcpCandidatePolicy:"disable",IceTransportsType:"nohost"};this.peerConnection_=new RTCPeerConnection(e),this.peerConnection_.onconnectionstatechange=this.onConnectionStateChange.bind(this);}},{key:"close",value:function value(){this.log_.info("closing connection"),this.closePeerConnection(),this.sei_&&(this.sei_.destroy(),this.sei_=null);}},{key:"closePeerConnection",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.peerConnection_&&(this.peerConnection_.onconnectionstatechange=function(){},this.peerConnection_.close(),this.peerConnection_=null,e&&this.emitConnectionStateChangedEvent(KI));}},{key:"getDTLSTransportState",value:function value(){if(!this.peerConnection_)return qI;var e=null;if(this.isUplink_){if(!hN()||0===this.peerConnection_.getSenders().length)return qI;e=this.peerConnection_.getSenders()[0].transport;}else{if(!lN()||0===this.peerConnection_.getReceivers().length)return qI;e=this.peerConnection_.getReceivers()[0].transport;}return e?e.state:qI;}},{key:"onConnectionStateChange",value:function value(e){var t=this.peerConnection_.iceConnectionState,n=this.getDTLSTransportState();if(this.log_.info("onConnectionStateChange() connectionState: "+e.target.connectionState),this.log_.info("ICE Transport state: ".concat(t,", DTLS Transport state: ").concat(n)),e.target.connectionState===ZI&&this.emitConnectionStateChangedEvent(QI),e.target.connectionState===eE||e.target.connectionState===tE){var i="".concat(this.isUplink_?"uplink":"downlink"," ICE/DTLS Transport connection ").concat(e.target.connectionState,". ICE Transport state: ").concat(t,", DTLS Transport state: ").concat(n),r=new pD({message:i,code:hD.ICE_TRANSPORT_ERROR});nO.logFailedEvent({userId:this.client_.getUserId(),eventType:bE,error:r}),this.emitConnectionStateChangedEvent(KI),this.isErrorObserved_||this.emitter_.emit(xN.ERROR,r);}e.target.connectionState!==iE&&e.target.connectionState!==rE||(this.logSelectedCandidate(),nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:bE}),this.emitConnectionStateChangedEvent(YI));}},{key:"emitConnectionStateChangedEvent",value:function value(e){e!==this.currentState_&&(this.currentState_===XI&&e===QI||(DA.emit(yx,{client:this.client_,connection:this,prevState:this.currentState_,state:e}),this.emitter_.emit(xN.CONNECTION_STATE_CHANGED,{prevState:this.currentState_,state:e}),this.currentState_=e));}},{key:"hitTest",value:function value(e){return(0===e||"0"===e)&&this.isUplink_||e===this.tinyId_;}},{key:"addEventInternal",value:function value(e,t){var n=this.client_.getUserId(),i={eventId:e,eventDesc:t,timestamp:ev(),userId:n,tinyId:this.client_.getTinyId()};this.isUplink_||(i.remoteUserId=this.userId_,i.remoteTinyId=this.tinyId_),YD(n,i);}},{key:"getPeerConnection",value:function value(){return this.peerConnection_;}},{key:"getClient",value:function value(){return this.client_;}},{key:"getUserId",value:function value(){return this.userId_;}},{key:"getTinyId",value:function value(){return this.tinyId_;}},{key:"logSelectedCandidate",value:(t=a(n().mark(function e(){var t,i,r,a,o,s,c;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.peerConnection_){e.next=2;break;}return e.abrupt("return");case 2:return e.next=4,this.peerConnection_.getStats();case 4:t=e.sent,i=I(t),e.prev=6,i.s();case 8:if((r=i.n()).done){e.next=18;break;}if((a=S(r.value,2))[0],!SN(o=a[1])){e.next=16;break;}return s=t.get(o.localCandidateId),c=t.get(o.remoteCandidateId),s&&this.log_.info("local candidate: ".concat(s.candidateType," ").concat(s.protocol,":").concat(s.ip||s.address,":").concat(s.port," ").concat(s.networkType||""," ").concat("relay"===s.candidateType?"relayProtocol:"+s.relayProtocol:"")),c&&this.log_.info("remote candidate: ".concat(c.candidateType," ").concat(c.protocol,":").concat(c.ip||c.address,":").concat(c.port)),e.abrupt("break",18);case 16:e.next=8;break;case 18:e.next=23;break;case 20:e.prev=20,e.t0=e.catch(6),i.e(e.t0);case 23:return e.prev=23,i.f(),e.finish(23);case 26:case"end":return e.stop();}}},e,this,[[6,20,23,26]]);})),function(){return t.apply(this,arguments);})},{key:"getCurrentState",value:function value(){return this.currentState_;}},{key:"waitForPeerConnectionConnected",value:function value(){var e=this;return this.waitForPeerConnectionConnectedPromise_||(this.waitForPeerConnectionConnectedPromise_=new Promise(function(t,n){if(e.currentState_===YI)return t();var i=-1,r=function r(e){e.state===YI&&(clearTimeout(i),s(),t());},a=function a(t){t.client===e.client_&&(clearTimeout(i),s(),n(new pD({code:hD.API_CALL_ABORTED,message:ZC({key:qC,data:"leave room"})})));},o=function o(t){var r=t.client,a=t.stream;!e.isUplink_&&r===e.client_&&a.getConnection()===e&&!e.peerConnection_&&(clearTimeout(i),s(),n(new pD({code:hD.API_CALL_ABORTED,message:ZC({key:qC,data:"unsubscribe stream"})})));},s=function s(){DA.off(jA,a,e),DA.off(rx,o,e),e.emitter_.off(xN.CONNECTION_STATE_CHANGED,r,e);};i=setTimeout(function(){s();var e=new pD({code:hD.API_CALL_TIMEOUT,message:"connection timeout"});n(e);},1e4),DA.on(jA,a,e),e.emitter_.on(xN.CONNECTION_STATE_CHANGED,r,e),e.isUplink_||DA.on(rx,o,e);}),this.waitForPeerConnectionConnectedPromise_=this.waitForPeerConnectionConnectedPromise_.then(function(t){return e.waitForPeerConnectionConnectedPromise_=null,t;}).catch(function(t){throw e.waitForPeerConnectionConnectedPromise_=null,t;})),this.waitForPeerConnectionConnectedPromise_;}},{key:"getReconnectionCount",value:function value(){return this.reconnectionCount_;}},{key:"startReconnection",value:function value(){this.isReconnecting_=!0,this.emitConnectionStateChangedEvent(XI),this.reconnect(),this.addEventInternal(this.isUplink_?HD:zD,"".concat(this.isUplink_?"uplink":"downlink","-connection is reconnecting"));}},{key:"stopReconnection",value:function value(){this.log_.info("stop reconnection"),this.isReconnecting_=!1,this.reconnectionCount_=0,this.clearReconnectionTimer(),this.signalChannel_.off(UP,this.reconnect,this);}},{key:"on",value:function value(e,t,n){this.emitter_.on(e,t,n);}},{key:"off",value:function value(e,t,n){this.emitter_.off(e,t,n);}},{key:"setDelay",value:function value(e){var t=e.audioDelay,n=e.videoDelay;this.delay_={audioDelay:t,videoDelay:n};}},{key:"getDelay",value:function value(){return this.delay_;}},{key:"isH264",get:function get(){var e,t;return!(null===(e=this.peerConnection_)||void 0===e||null===(t=e.remoteDescription)||void 0===t||!t.sdp.includes("H264"));}}]),e;}(),ez=function(){function ClientManager(){o(this,ClientManager),this.set_=new Set(),DA.on(OA,this.add,this),DA.on(LA,this.add,this),DA.on(UA,this.delete,this),DA.on(jA,this.delete,this);}return c(ClientManager,[{key:"add",value:function value(e){var t=e.client,n=e.roomId;if("rtc"!==t.getMode()){var i=this.getKey(t.getUserId(),n||t.getRoomId(),t.getSDKAppId(),t.getUseStringRoomId());this.set_.add(i);}}},{key:"delete",value:function value(e){var t=e.client;if("rtc"!==t.getMode()){var n=this.getKey(t.getUserId(),t.getRoomId(),t.getSDKAppId(),t.getUseStringRoomId());this.set_.delete(n);}}},{key:"getKey",value:function value(e,t,n,i){return"".concat(n,"_").concat(t,"_").concat(e,"_").concat(i);}},{key:"isJoined",value:function value(e){var t=e.userId,n=e.roomId,i=e.sdkAppId,r=e.client;return"rtc"!==r.getMode()&&this.set_.has(this.getKey(t,n,i,r.getUseStringRoomId()));}}]),ClientManager;}(),tz=new ez();function nz(e,t,n,i){if(this.useStringRoomId_){if(!(uA(e)&&/^[A-Za-z\d\s!#$%&()+\-:;<=.>?@[\]^_{}|~,]{1,64}$/.test(e)))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:hR,data:t,link:{className:i,fnName:n}})});}else if(!(dA(e)&&/^[1-9]\d*$/.test(String(e))&&e<4294967295))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:pR,data:t,link:{className:i,fnName:n}})});}function iz(e,t,n,i){if(!/^[A-Za-z\d_-]*$/.test(e))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:DR,data:t,link:{className:i,fnName:n}})});}var rz,az,oz={createClient:{name:"clientConfig",required:!0,type:GE,properties:{sdkAppId:{required:!0,type:jE,allowEmpty:!1},userId:{required:!0,type:FE,allowEmpty:!1},userSig:{required:!0,type:FE,allowEmpty:!1},mode:{required:!0,type:FE,values:["rtc",UI]},useStringRoomId:{type:BE},autoSubscribe:{type:BE},enableAutoPlayDialog:{type:BE},streamId:{type:FE},userDefineRecordId:{type:FE},pureAudioPushMode:{type:jE,values:[1,2]},enableSEI:{type:BE}}},createStream:{name:"streamConfig",required:!0,type:GE,properties:{userId:{type:FE},audio:{type:BE},video:{type:BE},screen:{type:BE},screenAudio:{type:BE},microphoneId:{type:FE},cameraId:{type:FE},facingMode:{type:[FE,GE]},audioSource:{instanceOf:window.MediaStreamTrack},videoSource:{instanceOf:window.MediaStreamTrack}},validate:function validate(e){if(!cA(e.screen)&&e.screen&&cA(e.audio)&&(e.audio=!1),!(cA(e.audio)&&cA(e.video)||cA(e.audioSource)&&cA(e.videoSource)))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:SC})});if(!cA(e.screen)&&!0===e.screen&&!0===e.video)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:kC})});if(e.audio&&e.screenAudio)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:bC})});if(!0!==e.screen&&!0===e.screenAudio)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:TC})});if(!cA(e.screen)&&!0===e.screen&&!this.isScreenShareSupported())throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:PC})});}}},sz={join:{name:"options",required:!0,type:GE,properties:{roomId:{required:!0,type:[jE,FE],allowEmpty:!1,validate:nz},role:{type:[FE],values:[jI,BI]},privateMapKey:{type:[FE]}},validate:function validate(e){if(this.isJoined_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:lR})});if(this.checkDestroy(),tz.isJoined({userId:this.userId_,roomId:e.roomId,sdkAppId:this.sdkAppId_,client:this}))throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:aC,data:this.userId_})});}},publish:[{name:"stream",required:!0,instanceOf:rw,validate:function validate(e){if(!this.isJoined_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:gR})});if(this.mode_===UI&&this.role_===BI)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:SR})});if(!e.getIsReadyToPublish())throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:kR})});if(this.notPublishWithoutH264Supported_)throw new pD({code:hD.NOT_SUPPORTED_H264,message:ZC({key:RC})});}},{name:"options",type:GE,defaultValue:{isAuxiliary:!1},properties:{isAuxiliary:{type:BE,defaultValue:!1,validate:function validate(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&!fN())throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:DC})});if(this.uplinkConnection_&&(e&&this.uplinkConnection_.isAuxStreamPublished||!e&&this.uplinkConnection_.isMainStreamPublished))throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:bR,data:e?JT:"local"})});var t=this.localScreenStream_||k(this.connections_.values()).findIndex(function(e){return e.getTrackState().auxiliary;})>=0;if(!this.enableMultiAuxStream_&&e&&t)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:QC})});}}}}],unpublish:{name:"stream",required:!0,instanceOf:rw,validate:function validate(e){if(e!==this.localStream_&&e!==this.localAuxStream_){if(this.localStream_||this.localAuxStream_)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:yR})});this.log_.warn("Client currently has no published stream, please call publish() first.");}}},subscribe:[{name:"stream",required:!0,instanceOf:aw,validate:function validate(e){if(!e.getConnection())throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:TR})});if(this.notSubscribeWithoutH264Supported_)throw new pD({code:hD.NOT_SUPPORTED_H264,message:ZC({key:CC})});}},{name:"options",type:GE,properties:{audio:{type:BE},video:{type:BE},smallVideo:{type:BE}},validate:function validate(e){var t=e.audio,n=e.video,i=e.smallVideo;if(!1===t&&!1===n&&(cA(i)||!1===i))throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:FC})});}}],unsubscribe:{name:"stream",required:!0,instanceOf:aw,validate:function validate(e){if(!e.getConnection())throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:TR})});}},switchRole:{name:"role",required:!0,values:[jI,BI],validate:function validate(){if(this.mode_!==UI)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:ER})});if(!this.isJoined_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:wR})});}},startPublishCDNStream:{name:"options",required:!1,properties:{streamId:{type:FE,validate:iz},streamType:{type:FE,values:["main","auxiliary"]},appId:{type:jE,allowEmpty:!1},bizId:{type:jE,allowEmpty:!1},url:{type:FE,allowEmpty:!1}},validate:function validate(){if(this.isDestroyed_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:oC,data:{funName:"startPublishCDNStream"}})});}},startMixTranscode:{name:"config",required:!0,type:GE,properties:{mode:{type:FE,values:["preset-layout","manual"]},streamId:{type:FE,validate:iz},videoWidth:{type:jE,notLessThanZero:!0},videoHeight:{type:jE,notLessThanZero:!0},videoBitrate:{type:jE,notLessThanZero:!0,allowEmpty:!1},videoFramerate:{type:jE,validate:function validate(e,t,n,i){if(e<=0||e>30)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:lC,link:{className:i,fnName:n}})});}},videoGop:{type:jE,validate:function validate(e,t,n,i){if(e<1||e>8)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:hC,link:{className:i,fnName:n}})});}},audioSampleRate:{type:jE,notLessThanZero:!0},audioBitrate:{type:jE,validate:function validate(e,t,n,i){if(e<32||e>192)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:pC,link:{className:i,fnName:n}})});}},audioChannels:{type:jE,values:[1,2]},backgroundColor:{type:jE},backgroundImage:{type:FE},mixUsers:{required:!0,type:HE,arrayItem:{require:!0,type:GE,properties:{userId:{required:!0,type:FE},roomId:{type:[FE,jE],validate:nz},pureAudio:{type:BE},width:{type:jE,notLessThanZero:!0},height:{type:jE,notLessThanZero:!0},locationX:{type:jE,notLessThanZero:!0},locationY:{type:jE,notLessThanZero:!0},zOrder:{type:jE},streamType:{type:FE,values:["main","auxiliary"]},renderMode:{type:jE,values:[0,1,2,4]}}}}},validate:function validate(e,t,n,i,r){var a=0,o=0,s=e.mixUsers,c=[];if(s.forEach(function(e,t){if(c.push(e.userId),!e.pureAudio){if(!e.zOrder||e.zOrder<1||e>15)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:fC,data:"config.mixUsers[".concat(t,"].zOrder"),link:{className:i,fnName:n}})});e.width+e.locationX>a&&(a=e.width+e.locationX),e.height+e.locationY>o&&(o=e.height+e.locationY);}}),c.indexOf(this.getUserId())<0)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:mC,link:{className:i,fnName:n}})});if(e.videoWidth<a||e.videoHeight<o)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:_C,link:{className:i,fnName:n}})});}},sendSEIMessage:[{name:"buffer",required:!0,instanceOf:ArrayBuffer,validate:function validate(e){if(!yN)throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:jC})});if(!this.enableSEI_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:BC})});if(e.byteLength>1e3)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:GC,data:e.byteLength})});if(0===e.byteLength)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:HC})});if(!this.uplinkConnection_||!this.localStream_)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:WC})});if(!this.localStream_.hasVideo())throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:zC})});var t=this.uplinkConnection_.isH264;if(!t)throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:jC,data:t})});}},{name:"options",type:GE,properties:{seiPayloadType:{type:jE,values:[5,243]}}}]},cz={play:[{name:"elementId",required:!0,type:[FE,"HTMLDivElement"],validate:function validate(e,t,n){if(uA(e)){var i=document.getElementById(e);if(!i)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:vC,data:{key:t,fnName:n}})});if(!(i instanceof HTMLDivElement))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:gC,data:{key:t,fnName:n,type:mA(i)}})});}}},{name:"options",type:GE,properties:{objectFit:{type:FE,values:["contain","cover","fill"]},muted:{type:BE},mirror:{type:BE}}}],addTrack:{name:II,instanceOf:MediaStreamTrack,validate:function validate(e){if(this.isAddingTrack_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:qR})});if(this.isRemovingTrack_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:KR})});if(this.publishState_===qE)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:QR})});var t=this.getMediaStream();if(!t)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:XR})});if(e.kind===BT&&t.getAudioTracks().length>0||e.kind===HT&&t.getVideoTracks().length>0)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:YR})});if(!pN()&&!hN())throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:AC,data:kI})});}},removeTrack:{name:II,instanceOf:MediaStreamTrack,validate:function validate(e){if(this.isAddingTrack_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:ZR})});if(this.isRemovingTrack_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:eC})});if(this.publishState_===qE)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:tC})});var t=this.getMediaStream();if(!t)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:XR})});if(-1===t.getTracks().indexOf(e))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:nC})});if(!pN()){if(1===t.getTracks().length)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:iC})});if(e.kind===BT)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:$R})});if(!hN())throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:AC,data:bI})});}}},replaceTrack:{name:II,instanceOf:MediaStreamTrack,validate:function validate(e){var t=this.getMediaStream();if(!t)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:JR})});if(this.publishState_===qE)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:zR})});if(e.kind===BT&&t.getAudioTracks().length<=0||e.kind===HT&&t.getVideoTracks().length<=0)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:rC,data:e})});if(!mN())throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:AC,data:TI})});}}},uz={TRTC:oz,CLIENT:sz,LOCAL_STREAM:{switchDevice:[{name:"type",required:!0,type:FE,values:[BT,HT]},{name:"deviceId",required:!0,type:FE,validate:function validate(){if(this.screen_&&!this.audio_||this.audioSource_||this.videoSource_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:GR})});if(this.publishState_===qE)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:WR})});if(!mN())throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:xC})});}}],setAudioCaptureVolume:{name:"volume",type:jE}},STREAM:cz};function dz(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++){t[n]=arguments[n];}return function(e,n,i){var r=i.value;return i.value=function(){for(var e=arguments.length,i=new Array(e),a=0;a<e;a++){i[a]=arguments[a];}return hz.call(this,t,i,n,this.name_),r.apply(this,i);},i;};}function lz(){for(var e=arguments.length,t=new Array(e),i=0;i<e;i++){t[i]=arguments[i];}return function(e,i,r){var o=r.value;return r.value=a(n().mark(function e(){var r,a,s,c=arguments;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:for(r=c.length,a=new Array(r),s=0;s<r;s++){a[s]=c[s];}return hz.call(this,t,a,i,this.name_),e.abrupt("return",o.apply(this,a));case 3:case"end":return e.stop();}}},e,this);})),r;};}function hz(e,t,n,i){try{for(var r=0;r<e.length;r++){pz.call(this,{rule:e[r],value:t[r],key:e[r].name,fnName:n,className:i});}}catch(XJ){throw xx.error(XJ),XJ;}}function pz(e){var t=this,n=e.rule,i=e.value,r=e.key,a=e.fnName,o=e.className;if(cA(i)){if(n.required)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:qw,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});if(cA(n.defaultValue))return;i=n.defaultValue;}if(Array.isArray(n.type)){if(!n.type.map(function(e){return e.toLowerCase();}).includes(mA(i)))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:Kw,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});}else if(!cA(n.type)&&mA(i)!==n.type)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:Kw,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});if(!1===n.allowEmpty){var s=dA(i)&&(0===i||Number.isNaN(i)),c=uA(i)&&""===i.trim();if(s||c)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:Qw,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});}if(n.notLessThanZero&&dA(i)&&i<0)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:dC,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});if(uA(n.instanceOf)){if(!i||i.name_!==n.instanceOf)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:Xw,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});}else if(sA(n.instanceOf)&&!(i instanceof n.instanceOf))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:Xw,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});if(n.values&&!n.values.includes(i))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:Yw,data:{key:r,rule:n,fnName:a,value:i},link:{className:o,fnName:a}})});var u=n.properties;rA(u)&&hA(i)&&Object.keys(u).forEach(function(e){pz.call(t,{rule:u[e],value:i&&i[e],key:"".concat(r,".").concat(e),fnName:a,className:o});});var d=n.arrayItem;rA(d)&&pA(i)&&i.forEach(function(e,n){pz.call(t,{rule:d,value:e,key:"".concat(r,"[").concat(n,"]"),fnName:a,className:o});}),sA(n.validate)&&n.validate.call(this,i,r,a,o,this);}Ir({target:"Number",stat:!0},{isNaN:function isNaN(e){return e!=e;}});var fz=(rz=lz.apply(void 0,k(uz.STREAM.play)),az=function(){function e(t){o(this,e),this.name_=ow,this.userId_=t.userId,this.isRemote_=t.isRemote,this.type_=t.type,this.log_=xx.createLogger({id:"s".concat(t.seq?t.seq:"","|").concat(this.userId_),userId:cA(t.client)?void 0:t.client.getUserId(),sdkAppId:cA(t.client)?void 0:t.client.getSDKAppId(),isLocal:!this.isRemote_,type:this.isRemote_?this.type_:""}),this.client_=null,cA(t.client)||(this.client_=t.client),this.mediaStream_=null,this.div_=null,this.isPlaying_=!1,this.connection_=null,this.audioPlayer_=null,this.videoPlayer_=null,this.muted_=!1,this.objectFit_="cover",this.mirror_=!1,this.id_="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0;return("x"==e?t:3&t|8).toString(16);}),this.audioOutputDeviceId_=0,this.audioVolume_=1,this.emitter_=wA(new PA(),this.name_),this.connectionState_=KI,this.installEvents(),cA(t.mirror)||this.log_.warn('TRTC.createStream "mirror" option was deprecated since v4.12.1，please use localStream.play to set up preview mirror. refer to '.concat(lw,"/en/LocalStream.html#play. TRTC.createStream 接口的 mirror 选项从 v4.12.1 开始被废弃，请使用 localStream.play 设置本地流预览镜像，参考文档：").concat(lw,"/zh-cn/LocalStream.html#play。"));}var i,r,s,u,d;return c(e,[{key:"installEvents",value:function value(){DA.on(bx,this.restartPlayback,this);}},{key:"uninstallEvents",value:function value(){DA.off(bx,this.restartPlayback,this);}},{key:"getType",value:function value(){return this.type_;}},{key:"getLogger",value:function value(){return this.log_;}},{key:"isSubscribed",get:function get(){return this.type_===zI&&this.connection_.isMainStreamSubscribed||this.type_===JI&&this.connection_.isAuxStreamSubscribed;}},{key:"isMainVideoSubscribed",get:function get(){var e=this.getSubscribedState();return this.type_===zI&&e&&e.video;}},{key:"isMainAudioSubscribed",get:function get(){var e=this.getSubscribedState();return this.type_===zI&&e&&e.audio;}},{key:"isAuxVideoSubscribed",get:function get(){var e=this.getSubscribedState();return this.type_===JI&&e&&e.auxiliary;}},{key:"isSmallVideoSubscribed",get:function get(){var e=this.getSubscribedState();return this.type_===zI&&e&&e.smallVideo;}},{key:"emitConnectionStateChanged",value:function value(e){e.state!==this.connectionState_&&(e.state!==KI&&this.isRemote_&&!this.isSubscribed||(this.emitter_.emit(NN,e),this.connectionState_=e.state));}},{key:"setConnection",value:function value(e){this.connection_!==e&&(e instanceof ZW?(null!==this.connection_&&this.connection_.off(xN.CONNECTION_STATE_CHANGED,this.emitConnectionStateChanged,this),e.on(xN.CONNECTION_STATE_CHANGED,this.emitConnectionStateChanged,this)):null===e&&this.connection_.off(xN.CONNECTION_STATE_CHANGED,this.emitConnectionStateChanged,this),this.connection_=e);}},{key:"getConnection",value:function value(){return this.connection_;}},{key:"play",value:(d=a(n().mark(function e(t,i){var r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.log_.info("stream ".concat(this.isPlaying_?"update":"start to"," play with elementId: ").concat(t," and options: ").concat(JSON.stringify(i),".")),!this.isPlaying_){e.next=9;break;}return i&&!cA(i.muted)&&(this.muted_=i.muted),i&&!cA(i.objectFit)&&(this.objectFit_=i.objectFit),this.isScreenShare()?this.mirror_=!1:i&&!cA(i.mirror)&&(this.mirror_=i.mirror),this.audioPlayer_&&this.audioPlayer_.setMuted(this.muted_),this.videoPlayer_&&(this.videoPlayer_.setObjectFit(this.objectFit_),this.videoPlayer_.setMirror(this.mirror_)),this.elementId_!==t&&(r=t,uA(t)&&(r=document.getElementById(t)),r.appendChild(this.div_),this.elementId_=t),e.abrupt("return");case 9:return this.isPlaying_=!0,(a=document.createElement("div")).setAttribute("id","player_".concat(this.id_)),a.setAttribute("style","width: 100%; height: 100%; position: relative; background-color: black; overflow: hidden;"),o=t,uA(t)&&(o=document.getElementById(t)),o.appendChild(a),this.elementId_=t,this.div_=a,this.isRemote_||(this.muted_=!0),i&&!cA(i.muted)&&(this.muted_=i.muted),this.isScreenShare()&&(this.objectFit_="contain"),i&&!cA(i.objectFit)&&(this.objectFit_=i.objectFit),this.isScreenShare()?this.mirror_=!1:(this.isRemote_||(this.mirror_=!0),i&&!cA(i.mirror)&&(this.mirror_=i.mirror)),DA.emit(px,{stream:this}),e.next=26,Promise.all([this.playAudio(),this.playVideo()]);case 26:DA.emit(XA,{stream:this});case 27:case"end":return e.stop();}}},e,this);})),function(e,t){return d.apply(this,arguments);})},{key:"playAudio",value:(u=a(n().mark(function e(){var i,r,a=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.hasAudio()&&(!this.isRemote_||this.isMainAudioSubscribed)){e.next=2;break;}return e.abrupt("return");case 2:if(i=this.getAudioTrack(),this.audioPlayer_||!i){e.next=17;break;}return this.log_.info("create AudioPlayer and play"),this.audioPlayer_=new pU({stream:this,track:i,gainedTrack:null===(r=this.gain_)||void 0===r?void 0:r.audioTrack,div:this.div_,muted:this.muted_,outputDeviceId:this.audioOutputDeviceId_,volume:this.audioVolume_}),this.audioPlayer_.on(UN,function(e){var n={type:BT,state:e.state,reason:e.reason};DA.emit(YA,t({stream:a},n)),a.emitter_.emit(DN,n);}),e.prev=7,e.next=10,this.audioPlayer_.play();case 10:e.next=17;break;case 12:throw e.prev=12,e.t0=e.catch(7),this.client_&&this.client_.getEnableAutoPlayDialog()&&new VU(),this.emitter_.emit(LN,e.t0),e.t0;case 17:case"end":return e.stop();}}},e,this,[[7,12]]);})),function(){return u.apply(this,arguments);})},{key:"playVideo",value:(s=a(n().mark(function e(){var i,r=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.hasVideo()&&(!this.isRemote_||this.isMainVideoSubscribed||this.isAuxVideoSubscribed||this.isSmallVideoSubscribed)){e.next=2;break;}return e.abrupt("return");case 2:if(i=this.getVideoTrack(),this.videoPlayer_||!i){e.next=18;break;}return DA.emit(mx,{stream:this}),this.log_.info("create VideoPlayer and play"),this.videoPlayer_=new FU({stream:this,track:i,div:this.div_,muted:this.muted_,objectFit:this.objectFit_,mirror:this.mirror_}),this.videoPlayer_.on(UN,function(e){var n={type:HT,state:e.state,reason:e.reason};DA.emit(YA,t({stream:r},n)),r.emitter_.emit(DN,n);}),e.prev=8,e.next=11,this.videoPlayer_.play();case 11:e.next=18;break;case 13:throw e.prev=13,e.t0=e.catch(8),this.client_&&this.client_.getEnableAutoPlayDialog()&&new VU(),this.emitter_.emit(LN,e.t0),e.t0;case 18:case"end":return e.stop();}}},e,this,[[8,13]]);})),function(){return s.apply(this,arguments);})},{key:"stopAudio",value:function value(){this.audioPlayer_&&(this.log_.info("stop AudioPlayer"),this.audioPlayer_.stop(),this.audioPlayer_=null);}},{key:"stopVideo",value:function value(){this.videoPlayer_&&(this.log_.info("stop VideoPlayer"),this.videoPlayer_.stop(),this.videoPlayer_=null);}},{key:"restartPlayback",value:function value(){this.audioPlayer_&&!this.audioPlayer_.isPlaying&&this.restartAudio(),this.videoPlayer_&&!this.videoPlayer_.isPlaying&&this.restartVideo();}},{key:"restartAudio",value:function value(){this.isPlaying_&&(this.stopAudio(),this.playAudio().catch(function(e){}));}},{key:"restartVideo",value:function value(){this.isPlaying_&&(this.stopVideo(),this.playVideo().catch(function(e){}));}},{key:"stop",value:function value(){this.isPlaying_&&(this.isPlaying_=!1,this.stopAudio(),this.stopVideo(),this.div_.parentNode.removeChild(this.div_));}},{key:"resume",value:(r=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.isPlaying_){e.next=2;break;}return e.abrupt("return");case 2:if(this.log_.info("resume"),!this.audioPlayer_){e.next=6;break;}return e.next=6,this.audioPlayer_.resume();case 6:if(!this.videoPlayer_){e.next=9;break;}return e.next=9,this.videoPlayer_.resume();case 9:case"end":return e.stop();}}},e,this);})),function(){return r.apply(this,arguments);})},{key:"close",value:function value(){this.log_.info("close stream"),this.isPlaying_&&this.stop(),this.isRemote_||(this.mediaStream_&&(this.mediaStream_.preventEvent=1,this.mediaStream_.getTracks().forEach(function(e){e.stop();}),this.mediaStream_=null),this.uninstallEvents());}},{key:"muteAudio",value:function value(){return this.addRemoteEvent(!0,BT),this.doEnableTrack(BT,!1);}},{key:"muteVideo",value:function value(){return this.addRemoteEvent(!0,HT),this.doEnableTrack(HT,!1);}},{key:"unmuteAudio",value:function value(){return this.addRemoteEvent(!1,BT),this.doEnableTrack(BT,!0);}},{key:"unmuteVideo",value:function value(){return this.addRemoteEvent(!1,HT),this.doEnableTrack(HT,!0);}},{key:"addRemoteEvent",value:function value(e,t){if(this.isRemote_&&this.client_){var n=this.client_.getUserId(),i="".concat(e?YT:$T," remote ").concat(t);YD(n,{eventId:t===BT?e?xD:DD:e?AD:PD,eventDesc:i,timestamp:new Date().getTime(),userId:n,tinyId:this.client_.getTinyId(),remoteUserId:this.userId_,remoteTinyId:this.connection_.getTinyId()});}}},{key:"doEnableTrack",value:function value(e,t){var n=!1;return e===BT?this.mediaStream_.getAudioTracks().forEach(function(e){n=!0,e.enabled=t;}):this.mediaStream_.getVideoTracks().forEach(function(e){n=!0,e.enabled=t;}),n;}},{key:"getId",value:function value(){return this.id_;}},{key:"getUserId",value:function value(){return this.userId_;}},{key:"getTinyId",value:function value(){return this.connection_?this.connection_.getTinyId():"";}},{key:"isPlaying",value:function value(){return this.isPlaying_;}},{key:"setAudioOutput",value:(i=a(n().mark(function e(t){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.audioOutputDeviceId_=t,!this.audioPlayer_){e.next=4;break;}return e.next=4,this.audioPlayer_.setSinkId(t);case 4:case"end":return e.stop();}}},e,this);})),function(e){return i.apply(this,arguments);})},{key:"setAudioVolume",value:function value(e){this.audioVolume_=e,this.log_.info("setAudioVolume to ".concat(e)),this.audioPlayer_&&this.audioPlayer_.setVolume(e);}},{key:"getAudioLevel",value:function value(){var e=0;return this.audioPlayer_&&(e=this.audioPlayer_.getAudioLevel()),e;}},{key:"getInternalAudioLevel",value:function value(){var e=0;return this.audioPlayer_&&(e=this.audioPlayer_.getInternalAudioLevel()),e;}},{key:"hasAudio",value:function value(){if(this.isRemote_){if(!this.connection_)return!1;var e=this.connection_.getTrackState();return this.type_===zI&&e.audio;}return!!this.getAudioTrack();}},{key:"hasVideo",value:function value(){if(this.isRemote_){if(!this.connection_)return!1;var e=this.connection_.getTrackState();return this.type_===JI?e.auxiliary:e.video;}return!!this.getVideoTrack();}},{key:"getSubscribedState",value:function value(){return this.isRemote_&&this.connection_?this.connection_.getSubscribeState():null;}},{key:"getAudioTrack",value:function value(){var e=null;if(this.mediaStream_){var t=this.mediaStream_.getAudioTracks();t.length>0&&(e=t[0]);}return e;}},{key:"getVideoTrack",value:function value(){var e=null;if(this.mediaStream_){var t=this.mediaStream_.getVideoTracks();t.length>0&&(e=t[0]);}return e;}},{key:"getVideoFrame",value:function value(){return this.videoPlayer_?this.videoPlayer_.getVideoFrame():null;}},{key:"getMediaStream",value:function value(){return this.mediaStream_;}},{key:"setMediaStream",value:function value(e){e!==this.mediaStream_&&(this.mediaStream_&&this.mediaStream_.getTracks().forEach(function(e){return e.stop();}),this.mediaStream_=e);}},{key:"updateVideoPlayingState",value:function value(e){this.isPlaying_&&(e?(this.log_.info("playing state updated, play video"),this.playVideo().catch(function(e){})):(this.log_.info("playing state updated, stop video"),this.stopVideo()));}},{key:"updateAudioPlayingState",value:function value(e){this.isPlaying_&&(e?(this.log_.info("playing state updated, play audio"),this.playAudio().catch(function(e){})):(this.log_.info("playing state updated, stop audio"),this.stopAudio()));}},{key:"on",value:function value(e,t,n){this.emitter_.on(e,t,n);}},{key:"off",value:function value(e,t,n){"*"===e?this.emitter_.removeAllListeners():this.emitter_.off(e,t,n);}},{key:"isRemote",value:function value(){return this.isRemote_;}},{key:"isScreenShare",value:function value(){return!this.isRemote_&&this.screen_||this.isRemote_&&this.getType()===JT;}},{key:"getDiv",value:function value(){return this.div_;}},{key:"getObjectFit",value:function value(){return this.objectFit_;}},{key:"getMuted",value:function value(){return this.muted_;}},{key:"getClient",value:function value(){return this.client_;}}]),e;}(),E(az.prototype,"play",[rz],Object.getOwnPropertyDescriptor(az.prototype,"play"),az.prototype),az),mz=function(e){d(RemoteStream,e);var n=v(RemoteStream);function RemoteStream(e){var i;o(this,RemoteStream);var r={isRemote:!0,type:e.type},a=t(t({},e),r);return(i=n.call(this,a)).name_=aw,i.isStreamAddedEventEmitted_=!1,i.isAbleToCallSubscription_=!0,i;}return c(RemoteStream,[{key:"installEvents",value:function value(){y(l(RemoteStream.prototype),"installEvents",this).call(this),DA.on(ix,this.handleStreamSubscribed,this),DA.on(rx,this.handleStreamUnsubscribed,this);}},{key:"uninstallEvents",value:function value(){y(l(RemoteStream.prototype),"uninstallEvents",this).call(this),DA.off(ix,this.handleStreamSubscribed,this),DA.off(rx,this.handleStreamUnsubscribed,this);}},{key:"handleStreamSubscribed",value:function value(e){e.client===this.client_&&e.stream===this&&this.connection_.getCurrentState()===YI&&this.emitConnectionStateChanged({prevState:KI,state:YI});}},{key:"handleStreamUnsubscribed",value:function value(e){e.client===this.client_&&e.stream===this&&this.emitConnectionStateChanged({prevState:YI,state:KI});}},{key:"getType",value:function value(){return y(l(RemoteStream.prototype),"getType",this).call(this);}},{key:"getIsAbleToCallSubscription",value:function value(){return this.isAbleToCallSubscription_;}},{key:"setIsAbleToCallSubscription",value:function value(e){this.isAbleToCallSubscription_=e;}},{key:"setIsStreamAddedEventEmitted",value:function value(e){this.isStreamAddedEventEmitted_=e;}},{key:"getIsStreamAddedEventEmitted",value:function value(){return this.isStreamAddedEventEmitted_;}},{key:"getAudioTrack",value:function value(){return this.connection_&&this.connection_.getTrackState().audio?y(l(RemoteStream.prototype),"getAudioTrack",this).call(this):null;}},{key:"getVideoTrack",value:function value(){if(!this.connection_)return null;var e=this.connection_.getTrackState();return(this.type_!==zI||e.video)&&(this.type_!==JI||e.auxiliary)?y(l(RemoteStream.prototype),"getVideoTrack",this).call(this):null;}},{key:"close",value:function value(){y(l(RemoteStream.prototype),"close",this).call(this);}}]),RemoteStream;}(fz),_z=function(){function e(t){o(this,e),this.client_=t.client,this.subscribedStreams_=new Map(),this.unsubscribedStreams_=new Map(),this.subscriptedOptions_=new Map(),this.autoRecoveryFlags_=new Map();}var t,i,r;return c(e,[{key:"isEnabled",get:function get(){return"webrtc"!==this.client_.getEnv();}},{key:"recover",value:(r=a(n().mark(function e(t){var i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i=t.getUserId(),r=t.getType(),this.hasAutoRecoveryFlag(i,r)){e.next=5;break;}return e.abrupt("return");case 5:if(a=this.getUnsubscribedStream(i,r)?"unsubscribe":"subscribe",e.prev=6,xx.warn("recover() try to recover subscription [".concat(a,"][").concat(i,"][").concat(r,"]")),"subscribe"!==a){e.next=13;break;}return e.next=11,this.recoverSubscription(i,t);case 11:e.next=15;break;case 13:return e.next=15,this.recoverUnsubscription(i,t);case 15:nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:RE}),xx.warn("recover() recover successfully [".concat(a,"][").concat(i,"][").concat(r,"]")),e.next=23;break;case 19:e.prev=19,e.t0=e.catch(6),xx.error("recover() recover failed [".concat(a,"][").concat(i,"][").concat(r,"]"),e.t0),nO.logFailedEvent({userId:this.client_.getUserId(),eventType:RE,error:e.t0});case 23:this.deleteAutoRecoveryFlag(i,r);case 24:case"end":return e.stop();}}},e,this,[[6,19]]);})),function(e){return r.apply(this,arguments);})},{key:"recoverSubscription",value:(i=a(n().mark(function e(t,i){var r,a,o,s,c;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r=this.getOptions(t,i.getType()),a=this.getSubscribedStream(t,i.getType()),r&&a){e.next=4;break;}return e.abrupt("return");case 4:o=this.getStreamMuteState(a),s=o.isAudioMuted,c=o.isVideoMuted,this.mergeStream(a,i),this.recoverPlayingState(a),s&&a.doEnableTrack(BT,!1),c&&a.doEnableTrack(HT,!1);case 9:case"end":return e.stop();}}},e,this);})),function(e,t){return i.apply(this,arguments);})},{key:"recoverUnsubscription",value:(t=a(n().mark(function e(t,i){var r;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r=this.getUnsubscribedStream(t,i.getType())){e.next=3;break;}return e.abrupt("return");case 3:this.mergeStream(r,i);case 4:case"end":return e.stop();}}},e,this);})),function(e,n){return t.apply(this,arguments);})},{key:"getStreamMuteState",value:function value(e){var t={isAudioMuted:!1,isVideoMuted:!1},n=e.getMediaStream();return n&&(t.isAudioMuted=n.getAudioTracks().map(function(e){return e.enabled;}).includes(!1),t.isVideoMuted=n.getVideoTracks().map(function(e){return e.enabled;}).includes(!1)),t;}},{key:"recoverPlayingState",value:function value(e){var t=e.isPlaying(),n=e.getDiv();if(t&&n){var i=n.parentNode;e.stop(),e.play(i,{objectFit:e.getObjectFit(),muted:e.getMuted()});}}},{key:"mergeStream",value:function value(e,t){var n=t.getConnection(),i=t.getMediaStream();e.setConnection(n),n.setRemoteStream(i.id,e),e.setMediaStream(i),e.updateAudioPlayingState(t.hasAudio()),e.updateVideoPlayingState(t.hasVideo());}},{key:"addSubscriptionRecord",value:function value(e,t,n){var i=t.getType();if(this.subscribedStreams_.has(e))this.subscribedStreams_.get(e).set(i,t);else{var r=new Map();r.set(t.getType(),t),this.subscribedStreams_.set(e,r);}if(this.subscriptedOptions_.has(e))this.subscriptedOptions_.get(e).set(i,n);else{var a=new Map();a.set(t.getType(),n),this.subscriptedOptions_.set(e,a);}this.deleteUnsubscriptionRecord(e,i);}},{key:"addUnsubscriptionRecord",value:function value(e,t){if(this.unsubscribedStreams_.has(e))this.unsubscribedStreams_.get(e).set(t.getType(),t);else{var n=new Map();n.set(t.getType(),t),this.unsubscribedStreams_.set(e,n);}this.deleteSubscriptionRecord(e,t.getType());}},{key:"getSubscribedStream",value:function value(e,t){return this.subscribedStreams_.has(e)&&this.subscribedStreams_.get(e).has(t)?this.subscribedStreams_.get(e).get(t):null;}},{key:"getOptions",value:function value(e,t){return this.subscriptedOptions_.has(e)&&this.subscriptedOptions_.get(e).has(t)?this.subscriptedOptions_.get(e).get(t):null;}},{key:"getUnsubscribedStream",value:function value(e,t){return this.unsubscribedStreams_.has(e)&&this.unsubscribedStreams_.get(e).has(t)?this.unsubscribedStreams_.get(e).get(t):null;}},{key:"deleteSubscriptionRecord",value:function value(e,t){this.subscribedStreams_.has(e)&&this.subscribedStreams_.get(e).delete(t),this.subscriptedOptions_.has(e)&&this.subscriptedOptions_.get(e).delete(t);}},{key:"deleteUnsubscriptionRecord",value:function value(e,t){this.unsubscribedStreams_.has(e)&&this.unsubscribedStreams_.get(e).delete(t);}},{key:"markAllStream",value:function value(){for(var e=0,t=k(this.subscribedStreams_.entries());e<t.length;e++){for(var n=S(t[e],2),i=n[0],r=0,a=k(n[1].entries());r<a.length;r++){var o=S(a[r],1)[0];this.setAutoRecoveryFlag(i,o);}}for(var s=0,c=k(this.unsubscribedStreams_.entries());s<c.length;s++){for(var u=S(c[s],2),d=u[0],l=0,h=k(u[1].entries());l<h.length;l++){var p=S(h[l],1)[0];this.setAutoRecoveryFlag(d,p);}}}},{key:"setAutoRecoveryFlag",value:function value(e,t){if(xx.info("setAutoRecoveryFlag() mark [".concat(e,"][").concat(t,"]")),this.autoRecoveryFlags_.has(e))this.autoRecoveryFlags_.get(e).set(t);else{var n=new Map();n.set(t),this.autoRecoveryFlags_.set(e,n);}}},{key:"hasAutoRecoveryFlag",value:function value(e,t){return!!this.isEnabled&&this.autoRecoveryFlags_.has(e)&&this.autoRecoveryFlags_.get(e).has(t);}},{key:"deleteAutoRecoveryFlag",value:function value(e,t){this.autoRecoveryFlags_.has(e)&&this.autoRecoveryFlags_.get(e).delete(t);}},{key:"delete",value:function value(e){this.unsubscribedStreams_.delete(e),this.subscribedStreams_.delete(e),this.subscriptedOptions_.delete(e),this.autoRecoveryFlags_.delete(e);}}]),e;}(),vz=function(){function e(t){o(this,e),this.player_=t,this.canvas_=document.createElement(jT),this.canvasCtx_=this.canvas_.getContext("2d");}return c(e,[{key:"setCanvasRect",value:function value(e,t){this.canvas_.width=e,this.canvas_.height=t;}},{key:"drawVideoToCanvas",value:function value(){var e=this.player_.getElement(),t=e.videoHeight,n=e.videoWidth,i=n*this.canvas_.height/(t*this.canvas_.width);if(i>1.05||i<.95){var r=n*t/(this.canvas_.width*this.canvas_.height);this.setCanvasRect(n/Math.sqrt(r),t/Math.sqrt(r));}this.canvasCtx_.drawImage(e,0,0,this.canvas_.width,this.canvas_.height);}},{key:"generateVideoTrackFromCanvasCapture",value:function value(e){return this.canvas_.captureStream(e).getVideoTracks()[0];}},{key:"generateStreamFromTrack",value:function value(e){var t=new MediaStream();return t.addTrack(e),t;}},{key:"destroy",value:function value(){this.player_.stop(),this.canvas_.width=0,this.canvas_.height=0,this.canvas_=null,this.canvasCtx_=null;}},{key:"canvas",get:function get(){return this.canvas_;}},{key:"canvasCtx",get:function get(){return this.canvasCtx_;}},{key:"canDrawVideoToCanvas",get:function get(){if(this.player_){var e=this.player_.getElement();if(e)return e.readyState===e.HAVE_ENOUGH_DATA;}return!1;}}]),e;}(),gz=new Blob(['let t,e,a,i;onmessage=function(n){const{action:h,data:s}=n.data;switch(h){case"render":a=s.canvas,t=a.width,e=a.height,i=a.getContext("2d"),function(t,e){const n=new TransformStream({async transform(t,e){const n=t.displayWidth,h=t.displayHeight,s=n*a.height/(h*a.width);if(s>1.05||s<.95){const t=n*h/(a.width*a.height);a.width=n/Math.sqrt(t),a.height=h/Math.sqrt(t)}i.drawImage(t,0,0,a.width,a.height);const o=new VideoFrame(a,{timestamp:t.timestamp});t.close(),e.enqueue(o)}});t.pipeThrough(n).pipeTo(e)}(s.readable,s.writable)}}'],{type:"application/javascript"}),yz=function(){function e(t){o(this,e);var n=t.videoTrack;this.width=void 0,this.height=void 0,this.canvas=document.createElement("canvas"),this.offscreen=null,this.smallGenerator=new MediaStreamTrackGenerator({kind:"video"}),this.smallWritable=this.smallGenerator.writable,this.bigProcessor=new MediaStreamTrackProcessor({track:n}),this.bigReadable=this.bigProcessor.readable,this.initWorker();}return c(e,[{key:"initWorker",value:function value(){try{this.worker=new Worker(URL.createObjectURL(gz)),xx.info("init worker processor success");}catch(e){xx.warn("init worker processor failed. ".concat(e.error));}}},{key:"setCanvasRect",value:function value(e,t){this.width=e,this.height=t,this.canvas.width=e,this.canvas.height=t,this.offscreen=this.canvas.transferControlToOffscreen(),this.worker.postMessage({action:"render",data:{canvas:this.offscreen,readable:this.bigReadable,writable:this.smallWritable}},[this.offscreen,this.bigReadable,this.smallWritable]);}},{key:"generatorVideoTrack",value:function value(){var e=new MediaStream([this.smallGenerator]);return null==e?void 0:e.getTracks()[0];}},{key:"destroy",value:function value(){this.worker.terminate();}}]),e;}(),Sz=function(){function e(t){o(this,e),this.localStream_=t,this.player_=null,this.processor_=null,this.initOffscreenSuccess_=!1;}var t;return c(e,[{key:"initialize",value:(t=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!(AN()&&(null===(t=navigator)||void 0===t?void 0:t.hardwareConcurrency)>=6)){e.next=13;break;}return e.prev=1,e.next=4,this.initOffscreen();case 4:this.initOffscreenSuccess_=!0,xx.info("Initialize VideoGenerator successfully!"),e.next=11;break;case 8:e.prev=8,e.t0=e.catch(1),this.initCanvas();case 11:e.next=14;break;case 13:this.initCanvas();case 14:case"end":return e.stop();}}},e,this,[[1,8]]);})),function(){return t.apply(this,arguments);})},{key:"generateSmallVideoTrack",value:function value(e){var t,n=e.height,i=e.width,r=e.frameRate,a=this.getSmallVideoProfile(i,n);return this.initOffscreenSuccess_?(this.processor_.setCanvasRect(a.width,a.height),t=this.processor_.generatorVideoTrack()):(this.processor_.setCanvasRect(a.width,a.height),this.player_.setRect({width:a.width,height:a.height}),t=this.processor_.generateVideoTrackFromCanvasCapture(r),this.interval_=KO.run(kw,this.render.bind(this),{fps:r})),t;}},{key:"render",value:function value(){this.processor_.canDrawVideoToCanvas&&this.processor_.drawVideoToCanvas();}},{key:"destroy",value:function value(){KO.clearTask(this.interval_),this.processor_&&this.processor_.destroy();}},{key:"initOffscreen",value:function value(){this.processor_=new yz({videoTrack:this.localStream_.getVideoTrack()});}},{key:"initCanvas",value:function value(){this.player_=new FU({stream:this.localStream_,track:this.localStream_.getVideoTrack(),muted:!0,objectFit:"cover",mirror:!1}),this.player_.play().then(function(){xx.info("VideoGenerator: play local video success");}).catch(function(){xx.error("VideoGenerator: Failed to play local video");}),this.processor_=new vz(this.player_);}},{key:"getSmallVideoProfile",value:function value(e,t){var n,i=this.localStream_.getVideoTrack(),r=this.localStream_.getVideoProfile();if(RN){var a=i.getSettings();a&&a.width&&a.height&&(r.width=a.width,r.height=a.height);}var o=r.width*r.height,s=e*t;return xx.info("big stream resolution: ".concat(r.width,"*").concat(r.height," small stream resolution: ").concat(e,"*").concat(t," ")),n=o>s?o/s:o/19200,{width:parseInt(r.width/Math.sqrt(n)),height:parseInt(r.height/Math.sqrt(n))};}}]),e;}();function kz(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{retries:5,timeout:2e3};return function(t,n,i){var r=Ex({retryFunction:i.value,settings:e,onError:e.onError,onRetrying:e.onRetrying,onRetryFailed:e.onRetryFailed});return i.value=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++){t[n]=arguments[n];}return r.apply(this,t);},i;};}var bz=new Map();var Tz=function(){var e=a(n().mark(function e(t){var i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!vN()){e.next=2;break;}return e.abrupt("return");case 2:return e.next=4,Ez(t);case 4:if(i=e.sent,xx.info("getUserMedia with constraints: "+JSON.stringify(i)),!i.audio){e.next=11;break;}return e.next=9,QJ.getMicrophones();case 9:r=e.sent,xx.info("microphones: ".concat(JSON.stringify(r)));case 11:if(!i.video){e.next=16;break;}return e.next=14,QJ.getCameras();case 14:a=e.sent,xx.info("cameras: ".concat(JSON.stringify(a)));case 16:return e.prev=16,e.next=19,navigator.mediaDevices.getUserMedia(i);case 19:return e.abrupt("return",e.sent);case 22:if(e.prev=22,e.t0=e.catch(16),"NotFoundError"!==e.t0.name){e.next=29;break;}if(!a||0!==a.length){e.next=27;break;}throw new pD({code:hD.DEVICE_NOT_FOUND,message:ZC({key:NC})});case 27:if(!r||0!==r.length){e.next=29;break;}throw new pD({code:hD.DEVICE_NOT_FOUND,message:ZC({key:OC})});case 29:throw new pD({code:hD.INITIALIZE_FAILED,name:e.t0.name,message:e.t0.message,constraint:e.t0.constraint});case 30:case"end":return e.stop();}}},e,null,[[16,22]]);}));return function(t){return e.apply(this,arguments);};}(),Iz=Ex({retryFunction:Tz,settings:{retries:3,timeout:500},onError:function onError(e,t,n,i){xx.warn("getUserMedia error: ".concat(e)),"NotReadableError"===e.name?t():e.message.includes("deviceId")&&i[0].retryWhenExactFailed?(i[0].useExact=!1,t()):n(e);},onRetrying:function onRetrying(e){xx.warn("getUserMedia retrying [".concat(e,"/3]"));}});function Ez(e){return wz.apply(this,arguments);}function wz(){return(wz=a(n().mark(function e(i){var r,a,o,s,c,u;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r={echoCancellation:i.echoCancellation,autoGainControl:i.autoGainControl,noiseSuppression:i.noiseSuppression},i.audio){e.next=5;break;}r=!1,e.next=15;break;case 5:if(eO(i.microphoneId)){e.next=9;break;}r=t({deviceId:i.useExact?{exact:i.microphoneId}:i.microphoneId,sampleRate:i.sampleRate,channelCount:i.channelCount},r),e.next=15;break;case 9:return r=t({sampleRate:i.sampleRate,channelCount:i.channelCount},r),e.next=12,QJ.getMicrophones();case 12:a=e.sent,(o=a.filter(function(e){return e.deviceId.length>0;})).length>0&&(r.deviceId={exact:o[0].deviceId});case 15:return s={},c={ideal:i.width,max:i.width},u={ideal:i.height,max:i.height},Nb&&oT&&i.width*i.height<101376&&(c=i.width,u=i.height),s=!cA(i.facingMode)&&i.video?{facingMode:i.facingMode,width:c,height:u,frameRate:i.frameRate}:!eO(i.cameraId)&&i.video?{deviceId:i.useExact?{exact:i.cameraId}:i.cameraId,width:c,height:u,frameRate:i.frameRate}:!!i.video&&(!!cA(i.width)||{width:c,height:u,frameRate:i.frameRate}),e.abrupt("return",{audio:r,video:s});case 21:case"end":return e.stop();}}},e);}))).apply(this,arguments);}var Rz=function(){var e=a(n().mark(function e(t){var i,r,a,o,s,c,u,d,l;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!vN()){e.next=2;break;}return e.abrupt("return");case 2:if(i=null,!(IT&&ET<74||RT)){e.next=27;break;}return r=Az(t),xx.info("getDisplayMedia with constraints: "+JSON.stringify(r)),e.next=8,navigator.mediaDevices.getDisplayMedia(r);case 8:if(a=e.sent,!t.screenAudio){e.next=14;break;}return xx.warn("Your browser not support capture system audio"),e.abrupt("return",a);case 14:if(!t.audio){e.next=24;break;}return o=Cz(t),xx.info("getUserMedia with constraints: "+JSON.stringify(o)),e.next=19,navigator.mediaDevices.getUserMedia(o);case 19:return i=e.sent,a.addTrack(i.getAudioTracks()[0]),e.abrupt("return",a);case 24:return e.abrupt("return",a);case 25:e.next=53;break;case 27:if(!t.screenAudio){e.next=37;break;}return t.audioConstraints={echoCancellation:!0,noiseSuppression:!0,sampleRate:44100},s=Az(t),xx.info("getDisplayMedia with constraints: "+JSON.stringify(s)),e.next=33,navigator.mediaDevices.getDisplayMedia(s);case 33:return c=e.sent,e.abrupt("return",c);case 37:return u=Az(t),xx.info("getDisplayMedia with constraints: "+JSON.stringify(u)),e.next=41,navigator.mediaDevices.getDisplayMedia(u);case 41:if(d=e.sent,!t.audio){e.next=52;break;}return l=Cz(t),xx.info("getUserMedia with constraints: "+JSON.stringify(l)),e.next=47,navigator.mediaDevices.getUserMedia(l);case 47:return i=e.sent,d.addTrack(i.getAudioTracks()[0]),e.abrupt("return",d);case 52:return e.abrupt("return",d);case 53:case"end":return e.stop();}}},e);}));return function(t){return e.apply(this,arguments);};}();function Cz(e){var t={echoCancellation:e.echoCancellation,autoGainControl:e.autoGainControl,noiseSuppression:e.noiseSuppression,sampleRate:e.sampleRate,channelCount:e.channelCount};return cA(e.microphoneId)||(t.deviceId=e.microphoneId),{audio:t,video:!1};}function Az(e){var t={systemAudio:"include",selfBrowserSurface:"include",surfaceSwitching:"include"},n={width:RT?{max:e.width}:{ideal:e.width,max:e.width},height:RT?{max:e.height}:{ideal:e.height,max:e.height},frameRate:e.frameRate,displaySurface:"monitor"};return t.video=n,cA(e.audioConstraints)||(t.audio=e.audioConstraints),t;}var xz,Pz,Dz,Oz,Nz,Mz,Lz,Uz,Vz,Fz,jz,Bz=new Map([["120p",{width:160,height:120,frameRate:15,bitrate:200}],["120p_2",{width:160,height:120,frameRate:15,bitrate:100}],["180p",{width:320,height:180,frameRate:15,bitrate:350}],["180p_2",{width:320,height:180,frameRate:15,bitrate:150}],["240p",{width:320,height:240,frameRate:15,bitrate:400}],["240p_2",{width:320,height:240,frameRate:15,bitrate:200}],["360p",{width:640,height:360,frameRate:15,bitrate:800}],["360p_2",{width:640,height:360,frameRate:15,bitrate:400}],["480p",{width:640,height:480,frameRate:15,bitrate:900}],["480p_2",{width:640,height:480,frameRate:15,bitrate:500}],["720p",{width:1280,height:720,frameRate:15,bitrate:1500}],["1080p",{width:1920,height:1080,frameRate:15,bitrate:2e3}],["1440p",{width:2560,height:1440,frameRate:30,bitrate:4860}],["4K",{width:3840,height:2160,frameRate:30,bitrate:9e3}]]),Hz=new Map([["480p",{width:640,height:480,frameRate:5,bitrate:900}],["480p_2",{width:640,height:480,frameRate:30,bitrate:1e3}],["720p",{width:1280,height:720,frameRate:5,bitrate:1200}],["720p_2",{width:1280,height:720,frameRate:30,bitrate:3e3}],["1080p",{width:1920,height:1080,frameRate:5,bitrate:1600}],["1080p_2",{width:1920,height:1080,frameRate:30,bitrate:4e3}]]),Gz=new Map([["standard",{sampleRate:48e3,channelCount:1,bitrate:40}],["standard-stereo",{sampleRate:48e3,channelCount:2,bitrate:64}],["high",{sampleRate:48e3,channelCount:1,bitrate:128}],["high-stereo",{sampleRate:48e3,channelCount:2,bitrate:192}]]),Wz=(xz=lz.apply(void 0,k(uz.LOCAL_STREAM.switchDevice)),Pz=lz(uz.STREAM.addTrack),Dz=lz(uz.STREAM.removeTrack),Oz=lz(uz.STREAM.replaceTrack),Nz=kz({retries:10,timeout:3e3,onRetryFailed:function onRetryFailed(e){nO.logFailedEvent({userId:this.client_?this.client_.getUserId():this.userId_,eventType:wE,error:e}),this.emitter_.emit(LN,new pD({code:hD.DEVICE_AUTO_RECOVER_FAILED,message:e.message}));}}),Mz=dz(uz.LOCAL_STREAM.setAudioCaptureVolume),Lz=function(e){d(LocalStream,e);var r,s,u,h,p,f,m,_,g,S=v(LocalStream);function LocalStream(e){var n;o(this,LocalStream);var i=t(t({},e),{isRemote:!1,type:"local"});return(n=S.call(this,i)).name_=rw,n.client_=null,n.video_=e.video,n.audio_=e.audio,n.cameraId_=e.cameraId,n.cameraGroupId_="",n.facingMode_=e.facingMode,n.microphoneId_=e.microphoneId,n.microphoneGroupId_="",n.videoSource_=e.videoSource,n.audioSource_=e.audioSource,n.screen_=e.screen,n.screenAudio_=e.screenAudio,n.audioProfile_={echoCancellation:!!cA(e.echoCancellation)||e.echoCancellation,autoGainControl:!!cA(e.autoGainControl)||e.autoGainControl,noiseSuppression:!!cA(e.noiseSuppression)||e.noiseSuppression,sampleRate:48e3,channelCount:1,bitrate:40},n.videoProfile_=Bz.get("480p_2"),n.screenProfile_=Hz.get("1080p"),n.videoSetting_=null,n.muteState_={video:!1,audio:!1,auxVideo:!1},n.beautyStatus_=!1,n.prevAudioRecoverTime_=0,n.prevVideoRecoverTime_=0,n.isAudioRecovering_=!1,n.isVideoRecovering_=!1,n.initState(),n.canvas_=null,n.canvasInterval_=null,n.canvasTrack_=null,n.gain_={audioTrack:null,source:null,gainNode:null},n.captureVolume_=100,n.log_.info("stream created: "+n.id_),n;}return c(LocalStream,[{key:"initState",value:function value(){this.isAddingTrack_=!1,this.isRemovingTrack_=!1,this.setIsReadyToPublish(!1),this.setPublishState(JE);}},{key:"installEvents",value:function value(){y(l(LocalStream.prototype),"installEvents",this).call(this),DA.on(_x,this.onVideoTrackStopped,this),DA.on(lx,this.onVideoTrackStopped,this),DA.on(gx,this.onAudioTrackStopped,this),DA.on(vx,this.onAudioTrackStopped,this);}},{key:"uninstallEvents",value:function value(){y(l(LocalStream.prototype),"uninstallEvents",this).call(this),DA.off(_x,this.onVideoTrackStopped,this),DA.off(lx,this.onVideoTrackStopped,this),DA.off(gx,this.onAudioTrackStopped,this),DA.off(vx,this.onAudioTrackStopped,this);}},{key:"initialize",value:function value(){var e=this;return new Promise(function(t,n){if(gN())n(new pD({code:hD.INVALID_OPERATION,message:ZC({key:IC})}));else{if(cA(e.audio_)){var i=new MediaStream();return cA(e.audioSource_)||(i.addTrack(e.audioSource_),e.updateAudioPlayingState(!0)),cA(e.videoSource_)||(i.addTrack(e.videoSource_),e.updateVideoPlayingState(!0)),e.setMediaStream(i),nO.logSuccessEvent({userId:e.client_?e.client_.getUserId():e.userId_,eventType:TE,kind:"custom"}),e.setIsReadyToPublish(!0),t();}e.screen_?(e.log_.info("initialize stream audio: "+e.audio_+" screenAudio: "+e.screenAudio_+" screen: "+e.screen_),Rz({audio:e.audio_,screenAudio:e.screenAudio_,microphoneId:e.microphoneId_,width:e.screenProfile_.width,height:e.screenProfile_.height,frameRate:e.screenProfile_.frameRate,sampleRate:e.audioProfile_.sampleRate,channelCount:e.audioProfile_.channelCount,autoGainControl:e.audioProfile_.autoGainControl,noiseSuppression:e.audioProfile_.noiseSuppression,echoCancellation:e.audioProfile_.echoCancellation}).then(function(n){e.setMediaStream(n),e.updateAudioPlayingState(e.audio_||e.screenAudio_),e.updateVideoPlayingState(!0);var i=e.getVideoTrack();return e.listenForScreenSharingStopped(i),e.setVideoContentHint(oI),e.updateDeviceIdInUse(),e.setIsReadyToPublish(!0),e.log_.info(JSON.stringify(i.getSettings())),nO.logSuccessEvent({userId:e.client_?e.client_.getUserId():e.userId_,eventType:TE,kind:"getDisplayMedia"}),t();}).catch(function(t){nO.logFailedEvent({userId:e.client_?e.client_.getUserId():e.userId_,eventType:TE,kind:"getDisplayMedia",error:t}),e.log_.error("getDisplayMedia error observed "+t),n(t instanceof pD?t:new pD({code:hD.INITIALIZE_FAILED,name:t.name,message:t.message}));})):(DA.emit(cx,{stream:e,audio:e.audio_,video:e.video_}),e.log_.info("initialize stream audio: "+e.audio_+" video: "+e.video_),Iz({audio:e.audio_,video:e.video_,facingMode:e.facingMode_,cameraId:e.cameraId_,microphoneId:e.microphoneId_,width:e.videoProfile_.width,height:e.videoProfile_.height,frameRate:e.videoProfile_.frameRate,sampleRate:e.audioProfile_.sampleRate,channelCount:e.audioProfile_.channelCount,autoGainControl:e.audioProfile_.autoGainControl,noiseSuppression:e.audioProfile_.noiseSuppression,echoCancellation:e.audioProfile_.echoCancellation,useExact:!0,retryWhenExactFailed:!0}).then(function(n){return DA.emit(ux,{stream:e,audio:e.audio_,video:e.video_}),e.setMediaStream(n),n.getTracks().forEach(function(t){t.kind===HT&&RN&&(e.videoSetting_=t.getSettings()),CN&&e.log_.info("".concat(t.kind," capabilities: ").concat(JSON.stringify(t.getCapabilities())));}),e.updateAudioPlayingState(e.audio_),e.updateVideoPlayingState(e.video_),e.updateDeviceIdInUse(),e.log_.info("gotStream hasAudio: "+e.hasAudio()+" hasVideo: "+e.hasVideo()),e.setIsReadyToPublish(!0),nO.logSuccessEvent({userId:e.client_?e.client_.getUserId():e.userId_,eventType:TE,kind:"getUserMedia"}),t();}).catch(function(t){DA.emit(dx,{stream:e,audio:e.audio_,video:e.video_,error:t}),nO.logFailedEvent({userId:e.client_?e.client_.getUserId():e.userId_,eventType:TE,kind:"getUserMedia",error:t}),e.log_.error("getUserMedia error observed "+t),n(t);}));}});}},{key:"listenForScreenSharingStopped",value:function value(e){var t=this;e.addEventListener("ended",function(e){t.log_.info("screen sharing was stopped because the video track is ended"),t.emitter_.emit(ON);});}},{key:"muteAudio",value:function value(){var e=y(l(LocalStream.prototype),"muteAudio",this).call(this);return e&&(this.log_.info("localStream mute audio"),this.sendMutedFlag(BT,!0)),e;}},{key:"muteVideo",value:function value(){var e=y(l(LocalStream.prototype),"muteVideo",this).call(this);return e&&(this.log_.info("localStream mute video"),this.sendMutedFlag(HT,!0)),e;}},{key:"unmuteAudio",value:function value(){var e=y(l(LocalStream.prototype),"unmuteAudio",this).call(this);return e&&(this.log_.info("localStream unmute audio"),this.sendMutedFlag(BT,!1)),e;}},{key:"unmuteVideo",value:function value(){var e=y(l(LocalStream.prototype),"unmuteVideo",this).call(this);return e&&(this.log_.info("localStream unmute video"),this.sendMutedFlag(HT,!1)),e;}},{key:"sendMutedFlag",value:function value(e,t){this.setMuteState(e,t);var n=this.getConnection();if(n){n.sendMutedFlag(this.muteState_,this);var i=n.getUserId(),r=n.getTinyId(),a="".concat(t?YT:$T," local ").concat(e," track");YD(i,{eventId:e===BT?t?gD:SD:t?yD:kD,eventDesc:a,timestamp:ev(),userId:i,tinyId:r});}}},{key:"setMuteState",value:function value(e,t){this.muteState_[e]=t,this.log_.info("set ".concat(e," muted state: [").concat(t?"mute":"unmute","]"));}},{key:"setAudioProfile",value:function value(e){var n;"object"===i(e)?n=e:void 0===(n=Gz.get(e))&&(n=Gz.get("standard")),this.log_.info("setAudioProfile: "+JSON.stringify(n)),this.audioProfile_=t(t({},this.audioProfile_),n);}},{key:"setVideoProfile",value:(g=a(n().mark(function e(i){var r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!this.connection_||_N()){e.next=2;break;}throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:wC})});case 2:if(rA(i)?a=t(t({},this.videoProfile_),i):uA(i)&&(a=Bz.get(i),cA(a)&&(a=Bz.get("480p_2"))),null!==(r=this.client_)&&void 0!==r&&r.get2k4kFlag()&&!(1===this.client_.get2k4kFlag())&&!this.screen_&&a.height*a.width>=3686400&&(a.width=1920,a.height=1080,this.log_.warn(Iw)),a&&a.width*a.height>921600&&OT&&(a.width=1280,a.height=720,this.log_.warn("reset to 1280 * 720 on iOS 13~14")),this.log_.info("setVideoProfile "+JSON.stringify(a)),!(o=this.getVideoTrack())){e.next=10;break;}return e.next=10,o.applyConstraints(a);case 10:if(s=this.videoProfile_.bitrate!==a.bitrate,this.videoProfile_=a,!s||!this.connection_){e.next=16;break;}return e.next=15,this.connection_.setBandwidth({bandwidth:a.bitrate,type:HT,videoType:zT});case 15:this.connection_.sendMediaSettings(this);case 16:case"end":return e.stop();}}},e,this);})),function(e){return g.apply(this,arguments);})},{key:"getVideoBitrate",value:function value(){return this.screen_?this.screenProfile_.bitrate:this.videoProfile_.bitrate;}},{key:"getAudioBitrate",value:function value(){return this.audioProfile_.bitrate;}},{key:"setScreenProfile",value:function value(e){var t=e;uA(e)&&(t=Hz.get(e)||Hz.get("1080p")),this.log_.info("setScreenProfile "+JSON.stringify(e)),this.screenProfile_=t;}},{key:"getVideoProfile",value:function value(){return this.screen_?this.screenProfile_:this.videoProfile_;}},{key:"getAudioProfile",value:function value(){return this.audioProfile_;}},{key:"setVideoContentHint",value:function value(e){var t=this.getVideoTrack();t&&"contentHint"in t&&(this.log_.info("set video track contentHint to: "+e),t.contentHint=e,t.contentHint!==e&&this.log_.warn("Invalid video track contentHint: "+e));}},{key:"switchDevice",value:(_=a(n().mark(function e(t,i){var r,a,o,s,c,u,d,l,h,p,f,m,_,v,g,y,S,k;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.mediaStream_&&this.microphoneId_!==i&&this.cameraId_!==i&&this.facingMode_!==i){e.next=2;break;}return e.abrupt("return");case 2:return r=t===BT,a=t===HT,this.setIsReadyToPublish(!1),this.log_.info("switchDevice "+t+" to: "+i),r&&(o=this.getAudioTrack(),s=this.getMicrophoneTrackMixed(),o&&o.stop(),s&&s.stop()),a&&((c=this.getVideoTrack())&&c.stop(),fT&&(u=this.getAudioTrack())&&(this.log_.info("stop audio track first in huawei env"),u.stop())),e.prev=8,e.next=11,Iz({audio:r||fT,video:a,facingMode:i===QT||i===XT?i:void 0,cameraId:a?i:this.cameraId_,microphoneId:r?i:this.microphoneId_,width:this.videoProfile_.width,height:this.videoProfile_.height,frameRate:this.videoProfile_.frameRate,sampleRate:this.audioProfile_.sampleRate,channelCount:this.audioProfile_.channelCount,useExact:!0,retryWhenExactFailed:!1});case 11:if(d=e.sent,l=null,!r){e.next=18;break;}(h=d.getAudioTracks()[0])&&this.isAudioTrackMixed()?(p=this.getAudioTrack(),f=QJ.AudioMixerPlugin.getAudioTrackMap(),m=QJ.AudioMixerPlugin.mix({targetTrack:h,sourceList:f.get(p.id).sourceList,trackList:f.get(p.id).trackList}),l=m):l=h,e.next=27;break;case 18:if(!(l=d.getVideoTracks()[0])||!this.isVideoTrackBeautified()){e.next=23;break;}return e.next=22,this.generateBeautyTrack(l);case 22:l=e.sent;case 23:if(!(_=d.getAudioTracks()[0])||!fT){e.next=27;break;}return e.next=27,this.replaceTrack(_);case 27:return e.next=29,this.replaceTrack(l);case 29:this.updateDeviceIdInUse(),(v=this.getConnection())&&(g=v.getUserId(),y=v.getTinyId(),S=ED,k="switch camera",r&&(S=wD,k="switch microphone"),YD(g,{eventId:S,eventDesc:k,timestamp:ev(),userId:g,tinyId:y})),this.log_.info("switch ".concat(r?"microphone":"camera"," success ")),r&&(this.audio_=!0),a&&(this.video_=!0,i!==XT&&i!==QT||(this.facingMode_=i)),this.setIsReadyToPublish(!0),e.next=43;break;case 38:throw e.prev=38,e.t0=e.catch(8),this.log_.error(e.t0),r?this.recoverCapture({audio:!0,video:!1,microphoneId:this.microphoneId_}):this.recoverCapture({audio:!1,video:!0,cameraId:this.cameraId_,facingMode:this.facingMode_}),e.t0;case 43:case"end":return e.stop();}}},e,this,[[8,38]]);})),function(e,t){return _.apply(this,arguments);})},{key:"addTrack",value:(m=a(n().mark(function e(t){var i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(e.prev=0,t.kind===HT&&RN&&(i=t.getSettings(),!this.videoSetting_||i.width===this.videoSetting_.width&&i.height===this.videoSetting_.height||this.log_.warn("video resolution of the track (".concat(i.width," x ").concat(i.height,") shall be kept the same as the previous: ").concat(this.videoSetting_.width," x ").concat(this.videoSetting_.height,". It may cause abnormal Cloud Recording."))),this.isAddingTrack_=!0,this.keepMuteState(t),this.mediaStream_.addTrack(t),!(r=this.getConnection())){e.next=11;break;}return a=null,t.kind===HT&&(DT||PT)&&fA(t)&&(a=this.getCanvasTrack()),e.next=11,r.addTrack(a||t,this);case 11:t.kind===BT?(this.audio_=!0,this.updateAudioPlayingState(!0)):(this.video_=!0,this.updateVideoPlayingState(!0)),this.isAddingTrack_=!1,e.next=20;break;case 15:throw e.prev=15,e.t0=e.catch(0),this.mediaStream_.removeTrack(t),this.isAddingTrack_=!1,e.t0;case 20:case"end":return e.stop();}}},e,this,[[0,15]]);})),function(e){return m.apply(this,arguments);})},{key:"removeTrack",value:(f=a(n().mark(function e(t){var i;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(e.prev=0,this.isRemovingTrack_=!0,!(i=this.getConnection())){e.next=12;break;}if(t.kind!==HT||!DT&&!PT||!this.canvasTrack_){e.next=10;break;}return e.next=7,i.removeTrack(this.canvasTrack_,this);case 7:this.clearCanvas(),e.next=12;break;case 10:return e.next=12,i.removeTrack(t,this);case 12:this.mediaStream_.removeTrack(t),t.kind===BT?(this.audio_=!1,this.updateAudioPlayingState(!1)):(this.video_=!1,this.updateVideoPlayingState(!1)),this.isRemovingTrack_=!1,e.next=21;break;case 17:throw e.prev=17,e.t0=e.catch(0),this.isRemovingTrack_=!1,e.t0;case 21:case"end":return e.stop();}}},e,this,[[0,17]]);})),function(e){return f.apply(this,arguments);})},{key:"replaceTrack",value:(p=a(n().mark(function e(t){var i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(t.kind===HT&&RN&&(i=t.getSettings(),!this.videoSetting_||i.width===this.videoSetting_.width&&i.height===this.videoSetting_.height||this.log_.warn("video resolution of the track (".concat(i.width," x ").concat(i.height,") shall be kept the same as the previous: ").concat(this.videoSetting_.width," x ").concat(this.videoSetting_.height,". It may cause abnormal Cloud Recording."))),this.keepMuteState(t),r=this.mediaStream_,t.kind!==BT){e.next=12;break;}if(r.removeTrack(r.getAudioTracks()[0]),r.addTrack(t),y(l(LocalStream.prototype),"restartAudio",this).call(this),!this.gain_.gainNode){e.next=10;break;}return this.reconnectGainNode(t),e.abrupt("return");case 10:e.next=15;break;case 12:r.removeTrack(r.getVideoTracks()[0]),r.addTrack(t),y(l(LocalStream.prototype),"restartVideo",this).call(this);case 15:if(!(a=this.getConnection())){e.next=21;break;}if(t.kind!==HT||!DT&&!PT||!this.canvasTrack_){e.next=19;break;}return e.abrupt("return");case 19:return e.next=21,a.replaceTrack(t,this);case 21:case"end":return e.stop();}}},e,this);})),function(e){return p.apply(this,arguments);})},{key:"recoverCapture",value:(h=a(n().mark(function e(t){var i,r,a,o,s,c,u,d,l,h,p,f,m,_,v,g,y;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.mediaStream_){e.next=2;break;}return e.abrupt("return");case 2:return this.log_.warn("recoverCapture() trying "+JSON.stringify(t)),i=this.audio_&&t.audio,r=this.video_&&t.video,e.prev=5,e.next=8,QJ.getCameras();case 8:return a=e.sent,e.next=11,QJ.getMicrophones();case 11:if(o=e.sent,r&&0===a.length&&(r=!1,this.log_.warn("recoverCapture() video flag is true, but no camera detected, set video to false")),i&&0===o.length&&(i=!1,this.log_.warn("recoverCapture() audio flag is true, but no microphone detected, set audio to false")),i||r){e.next=17;break;}return this.log_.warn("recoverCapture() both audio and video are false, aborted"),e.abrupt("return");case 17:return s=t&&a.findIndex(function(e){return e.deviceId===t.cameraId;})>=0,c=t&&o.findIndex(function(e){return e.deviceId===t.microphoneId;})>=0,i&&(null===(u=this.getAudioTrack())||void 0===u||u.stop()),r&&(null===(d=this.getVideoTrack())||void 0===d||d.stop()),e.next=23,Iz({audio:i,video:r,cameraId:s?t.cameraId:void 0,microphoneId:c?t.microphoneId:void 0,facingMode:this.facingMode_,width:this.videoProfile_.width,height:this.videoProfile_.height,frameRate:this.videoProfile_.frameRate,sampleRate:this.audioProfile_.sampleRate,channelCount:this.audioProfile_.channelCount});case 23:l=e.sent,h=l.getTracks(),p=0;case 26:if(!(p<h.length)){e.next=53;break;}if((f=h[p]).kind!==BT||!this.isAudioTrackMixed()){e.next=39;break;}if(m=this.getAudioTrack(),_=QJ.AudioMixerPlugin.getAudioTrackMap(),(v=_.get(m.id)).hasMicrophone){e.next=35;break;}return f.stop(),e.abrupt("continue",50);case 35:return g=QJ.AudioMixerPlugin.mix({targetTrack:f,sourceList:v.sourceList,trackList:v.trackList}),e.next=38,this.replaceTrack(g);case 38:return e.abrupt("continue",50);case 39:if(f.kind!==HT||!this.isVideoTrackBeautified()){e.next=46;break;}return e.next=42,this.generateBeautyTrack(f);case 42:return y=e.sent,e.next=45,this.replaceTrack(y);case 45:return e.abrupt("continue",50);case 46:return e.next=48,this.replaceTrack(f);case 48:if(!f.muted&&"ended"!==f.readyState){e.next=50;break;}throw new Error("new track is failed, muted ".concat(f.muted," readyState ").concat(f.readyState));case 50:p++,e.next=26;break;case 53:this.updateDeviceIdInUse(),nO.logSuccessEvent({userId:this.client_?this.client_.getUserId():this.userId_,eventType:wE}),this.log_.warn("recoverCapture() successfully"),this.emitter_.emit(MN,{isCamera:t.video,isMicrophone:t.audio,cameraId:this.cameraId_,microphoneId:this.microphoneId_}),e.next=63;break;case 59:throw e.prev=59,e.t0=e.catch(5),this.log_.warn("recoverCapture() failed, "+e.t0),e.t0;case 63:case"end":return e.stop();}}},e,this,[[5,59]]);})),function(e){return h.apply(this,arguments);})},{key:"updateDeviceIdInUse",value:function value(){var e=this;if(!this.mediaStream_)return this.cameraId_="",this.cameraGroupId_="",this.microphoneId_="",void(this.microphoneGroupId_="");RN&&this.mediaStream_.getTracks().forEach(function(t){if(t.kind===BT&&e.isAudioTrackMixed()){var n=e.getMicrophoneTrackMixed();if(n){var i=n.getSettings(),r=i.deviceId,a=i.groupId;r&&(e.microphoneId_=r,e.microphoneGroupId_=a);}}else if(t.kind===HT&&e.isVideoTrackBeautified()){var o=e.getBeautyOriginTrack();if(o){var s=o.getSettings(),c=s.deviceId,u=s.groupId;c&&(e.cameraId_=c,e.cameraGroupId_=u);}}else{var d=t.getSettings(),l=d.deviceId,h=d.groupId;l&&(t.kind===BT?(e.microphoneId_=l,e.microphoneGroupId_=h):t.kind!==HT||e.screen_||(e.cameraId_=l,e.cameraGroupId_=h));}});var t=this.mediaStream_.getAudioTracks(),n=this.mediaStream_.getVideoTracks();t&&0===t.length&&(this.microphoneId_="",this.microphoneGroupId_=""),n&&0===n.length&&(this.cameraId_="",this.cameraGroupId_="");}},{key:"isAudioTrackMixed",value:function value(){if(QJ.AudioMixerPlugin){var e=QJ.AudioMixerPlugin.getAudioTrackMap(),t=this.getAudioTrack();if(e&&t&&e.has(t.id))return!0;}return!1;}},{key:"getMicrophoneTrackMixed",value:function value(){if(QJ.AudioMixerPlugin){var e=QJ.AudioMixerPlugin.getAudioTrackMap(),t=this.getAudioTrack();if(e&&t&&e.has(t.id)){var n=e.get(t.id);return n.hasMicrophone?n.microphoneTrack:null;}}return null;}},{key:"isVideoTrackBeautified",value:function value(){if(QJ.beautyTrackMap){var e=QJ.beautyTrackMap,t=this.getVideoTrack();if(t&&e.has(t.id))return!0;}return!1;}},{key:"getBeautyOriginTrack",value:function value(){if(QJ.beautyTrackMap){var e=QJ.beautyTrackMap,t=this.getVideoTrack();if(t&&e.has(t.id)){var n=e.get(t.id);if(n.originTrack)return n.originTrack;}}return null;}},{key:"generateBeautyTrack",value:(u=a(n().mark(function e(t){var i,r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i=null,r=this.getVideoTrack(),a=QJ.beautyTrackMap.get(r.id),o=a.param,a.type){e.next=8;break;}i=a.pluginInstance.generateBeautyTrack(t),e.next=22;break;case 8:e.t0=a.type,e.next="beauty"===e.t0?11:"virtual"===e.t0?13:"mixed"===e.t0?17:21;break;case 11:return i=a.pluginInstance.generateBeautyTrack(t),e.abrupt("break",22);case 13:return e.next=15,a.pluginInstance.generateVirtualTrack({videoTrack:t,type:o.type,img:o.img});case 15:case 19:return i=e.sent,e.abrupt("break",22);case 17:return e.next=19,a.pluginInstance.generateMixedTrack({videoTrack:t,type:o.type,img:o.img});case 21:return e.abrupt("break",22);case 22:return a.pluginInstance.deleteSource(r.id),this.log_.info("regenerate beauty track, track id = ".concat(t.id)),e.abrupt("return",i);case 25:case"end":return e.stop();}}},e,this);})),function(e){return u.apply(this,arguments);})},{key:"getScreen",value:function value(){return this.screen_;}},{key:"hasScreenTrack",value:function value(){if(this.screen_)return!0;var e=this.getVideoTrack();return!!e&&(e.contentHint===oI||e.contentHint===sI);}},{key:"getVideo",value:function value(){return this.video_;}},{key:"getAudio",value:function value(){return this.audio_;}},{key:"getCameraId",value:function value(){return this.cameraId_;}},{key:"getMicrophoneId",value:function value(){return this.microphoneId_;}},{key:"getMicrophoneGroupId",value:function value(){return this.microphoneGroupId_;}},{key:"getIsReadyToPublish",value:function value(){return this.isReadyToPublish_;}},{key:"setIsReadyToPublish",value:function value(e){this.isReadyToPublish_=e;}},{key:"setPublishState",value:function value(e){this.publishState_=e;}},{key:"setBeautyStatus",value:function value(e){this.beautyStatus_=!!e;}},{key:"getBeautyStatus",value:function value(){return this.beautyStatus_;}},{key:"syncMuteState",value:function value(){var e=this.getAudioTrack(),t=this.getVideoTrack();if(e){var n=!e.enabled;this.setMuteState(BT,n);}if(t){var i=!t.enabled;this.setMuteState(HT,i);}this.connection_&&this.connection_.sendMutedFlag(this.muteState_,this);}},{key:"keepMuteState",value:function value(e){e instanceof MediaStreamTrack&&this.muteState_[e.kind]&&(e.enabled=!1,this.log_.warn("prev ".concat(e.kind," track is muted, keep mute state")));}},{key:"onVideoTrackStopped",value:(s=a(n().mark(function e(t){var i,r,a,o,s=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i=t.stream,r=t.type,i===this&&this.video_&&this.cameraId_&&!this.isVideoRecovering_&&(!(oT&&RT||Db&&Number(xT)>=15.1)||r!==YT)){e.next=3;break;}return e.abrupt("return");case 3:if(!(Date.now()-this.prevVideoRecoverTime_<yw)){e.next=6;break;}return setTimeout(function(){return s.onVideoTrackStopped({stream:i,type:r});},yw),e.abrupt("return");case 6:if(!(a=this.getVideoTrack())||this.publishState_!==KE){e.next=14;break;}return o=a.getSettings().deviceId,e.next=11,QJ.getCameras();case 11:if(!(e.sent.findIndex(function(e){return e.deviceId===o;})<0)){e.next=14;break;}return e.abrupt("return");case 14:r===YT?setTimeout(function(){var e=s.getVideoTrack();null!=e&&e.muted&&"visible"===document.visibilityState&&s.recoverVideoCapture(r);},1e3):this.recoverVideoCapture(r);case 15:case"end":return e.stop();}}},e,this);})),function(e){return s.apply(this,arguments);})},{key:"onAudioTrackStopped",value:(r=a(n().mark(function e(t){var i,r,a,o,s,c,u=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i=t.stream,r=t.type,i===this&&this.audio_&&this.microphoneId_&&!this.isAudioRecovering_&&(!(oT&&RT||Db&&Number(xT)>=15.1)||r!==YT)){e.next=3;break;}return e.abrupt("return");case 3:if(!(Date.now()-this.prevAudioRecoverTime_<yw)){e.next=6;break;}return setTimeout(function(){return u.onAudioTrackStopped({stream:i,type:r});},yw),e.abrupt("return");case 6:if(!(a=this.getAudioTrack())||this.publishState_!==KE){e.next=14;break;}return o=a.getSettings(),s=o.groupId,c=o.deviceId,e.next=11,QJ.getMicrophones();case 11:if(!(e.sent.findIndex(function(e){return e.deviceId===c&&(cA(s)||s===e.groupId);})<0)){e.next=14;break;}return e.abrupt("return");case 14:r===YT?setTimeout(function(){var e=u.getAudioTrack();null!=e&&e.muted&&"visible"===document.visibilityState&&u.recoverAudioCapture(r);},1e3):this.recoverAudioCapture(r);case 15:case"end":return e.stop();}}},e,this);})),function(e){return r.apply(this,arguments);})},{key:"recoverAudioCapture",value:function value(e){var t=this;this.prevAudioRecoverTime_=Date.now(),nO.uploadEvent({log:"stat-local-audio-".concat(e),userId:this.userId_}),this.isAudioRecovering_=!0,this.recoverCapture({audio:!0,video:!1,microphoneId:this.microphoneId_}).then(function(){t.isAudioRecovering_=!1;}).catch(function(){t.isAudioRecovering_=!1;});}},{key:"recoverVideoCapture",value:function value(e){var t=this;this.isVideoRecovering_||(this.prevVideoRecoverTime_=Date.now(),nO.uploadEvent({log:"stat-local-video-".concat(e),userId:this.userId_}),this.isVideoRecovering_=!0,this.recoverCapture({audio:!1,video:!0,cameraId:this.cameraId_}).then(function(){t.isVideoRecovering_=!1;}).catch(function(){t.isVideoRecovering_=!1;}));}},{key:"setAudioVolume",value:function value(e){y(l(LocalStream.prototype),"setAudioVolume",this).call(this,e);}},{key:"clearCanvas",value:function value(){this.canvasInterval_&&(KO.clearTask(this.canvasInterval_),this.canvasInterval_=null,this.canvas_=null,this.canvasTrack_=null);}},{key:"getCanvasTrack",value:function value(){var e=this;if(this.canvasTrack_)return this.canvasTrack_;this.log_.info("gen canvas track");var t=this.getVideoTrack().getSettings(),n=t.width,i=t.height,r=t.frameRate;this.canvas_=document.createElement("canvas");var a=this.canvas_.getContext("2d");this.canvas_.width=n,this.canvas_.height=i,this.canvasInterval_=KO.run(kw,function(){if(e.hasVideo()){var t=e.getVideoTrack().getSettings();t.width===e.canvas_.width&&t.height===e.canvas_.height||(e.canvas_.width=t.width,e.canvas_.height=t.height);}e.videoPlayer_&&e.videoPlayer_.element_&&a.drawImage(e.videoPlayer_.element_,0,0,e.canvas_.width,e.canvas_.height);},{fps:Math.max(15,r)});var o=this.canvas_.captureStream();return this.canvasTrack_=o.getVideoTracks()[0],this.canvasTrack_;}},{key:"setClient",value:function value(e,t){e&&(this.log_.setUserId(e.getUserId()),this.log_.setSdkAppId(e.getSDKAppId()),t||this.syncMuteState()),this.client_=e;}},{key:"setAudioCaptureVolume",value:function value(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:100;if(!this.hasAudio()||t<0||!mN())return!1;if(this.captureVolume_===t)return!0;this.captureVolume_=t,this.log_.info("setCaptureVolume "+t),t/=100;var n=IA();if(this.gain_.gainNode)this.gain_.gainNode.gain.value=t;else{var i,r=new MediaStream();r.addTrack(this.getAudioTrack());var a=n.createMediaStreamDestination(),o=n.createMediaStreamSource(r),s=n.createGain();s.gain.value=t,o.connect(s),s.connect(a);var c=a.stream.getAudioTracks()[0],u=function u(t){return e.log_.info("gained audio track ".concat(t));};c.onmute=function(){return u("muted");},c.onunmute=function(){return u("unmuted");},c.onended=function(){return u("ended");},this.gain_={source:o,audioTrack:c,gainNode:s},null===(i=this.connection_)||void 0===i||i.replaceTrack(c),y(l(LocalStream.prototype),"restartAudio",this).call(this);}return!0;}},{key:"getGainedTrack",value:function value(){return this.gain_.audioTrack;}},{key:"reconnectGainNode",value:function value(e){this.log_.warn("reconnect gain node");var t=new MediaStream();t.addTrack(e);var n=IA().createMediaStreamSource(t);n.connect(this.gain_.gainNode),this.gain_.source.disconnect(),this.gain_.source=n;}},{key:"close",value:function value(){this.setIsReadyToPublish(!1);var e=this.gain_,t=e.audioTrack,n=e.source,i=e.gainNode;i&&(n.disconnect(),i.disconnect(),t.onmute=null,t.onunmute=null,t.onended=null,t.stop(),this.gain_={source:null,gainNode:null,audioTrack:null}),y(l(LocalStream.prototype),"close",this).call(this);}}]),LocalStream;}(fz),E(Lz.prototype,"switchDevice",[xz],Object.getOwnPropertyDescriptor(Lz.prototype,"switchDevice"),Lz.prototype),E(Lz.prototype,"addTrack",[Pz],Object.getOwnPropertyDescriptor(Lz.prototype,"addTrack"),Lz.prototype),E(Lz.prototype,"removeTrack",[Dz],Object.getOwnPropertyDescriptor(Lz.prototype,"removeTrack"),Lz.prototype),E(Lz.prototype,"replaceTrack",[Oz],Object.getOwnPropertyDescriptor(Lz.prototype,"replaceTrack"),Lz.prototype),E(Lz.prototype,"recoverCapture",[Nz],Object.getOwnPropertyDescriptor(Lz.prototype,"recoverCapture"),Lz.prototype),E(Lz.prototype,"setAudioCaptureVolume",[Mz],Object.getOwnPropertyDescriptor(Lz.prototype,"setAudioCaptureVolume"),Lz.prototype),Lz),zz={voiceActivityDetection:!1},Jz=(Uz=kz({retries:1,timeout:0,onRetrying:function onRetrying(e){this.log_.warn("connection timeout, retrying [".concat(e,"]"));},onError:function onError(e,t,n){e.message.includes("timeout")?(this.reset(),this.initialize(),t()):n(e);}}),Vz=function(e){d(P,e);var i,r,s,u,h,p,f,m,_,g,S,k,b,T,I,E,w,R,C,A,x=v(P);function P(e){var t;return o(this,P),(t=x.call(this,e)).localStream_=null,t.exchangeSDPTimeout_=-1,t.localAuxStream_=null,t.publishingStream_=null,t.isPublishingAuxStream_=!1,t.smallGenerator_=null,t.isSDPExchanging_=!1,t.ssrc_={audio:0,video:0,small:0,auxiliary:0},t.mediaSettings_={videoCodec:"",videoWidth:0,videoHeight:0,videoBps:0,videoFps:0,audioCodec:"opus",audioFs:0,audioChannel:0,audioBps:0,smallVideoWidth:0,smallVideoHeight:0,smallVideoFps:0,smallVideoBps:0,auxVideoWidth:0,auxVideoHeight:0,auxVideoFps:0,auxVideoBps:0},t.mixedAudioTrack_=null,t;}return c(P,[{key:"isMainStreamPublished",get:function get(){return!!this.localStream_;}},{key:"isAuxStreamPublished",get:function get(){return!!this.localAuxStream_;}},{key:"publishState",get:function get(){var e=this,t={audio:!1,bigVideo:!1,smallVideo:!1,auxVideo:!1};if(this.peerConnection_){var n,i,r,a,o=this.peerConnection_.getSenders();if(o)if(pN())t.audio=!(null===(n=o[0])||void 0===n||!n.track),t.bigVideo=!(null===(i=o[1])||void 0===i||!i.track),t.smallVideo=!(null===(r=o[2])||void 0===r||!r.track),t.auxVideo=!(null===(a=o[3])||void 0===a||!a.track);else o.forEach(function(n){n.track&&(n.track.kind===BT?t.audio=!0:(t.bigVideo=!0,e.smallGenerator_&&(t.smallVideo=!0)));});}return t;}},{key:"initialize",value:function value(){y(l(P.prototype),"initialize",this).call(this),this.installEvents();}},{key:"reset",value:function value(){this.isReconnecting_&&this.stopReconnection(),this.closePeerConnection(),this.uninstallEvents(),this.clearExchangeSDPTimeout(),this.localStream_&&this.localStream_.clearCanvas();}},{key:"close",value:function value(){y(l(P.prototype),"close",this).call(this),this.reset(),this.emitConnectionStateChangedEvent(KI),this.smallGenerator_&&(this.smallGenerator_.destroy(),this.smallGenerator_=null);}},{key:"installEvents",value:function value(){this.emitter_.on(xN.ERROR,this.handleError,this),this.emitter_.on(xN.CONNECTION_STATE_CHANGED,this.handleConnectionStateChange,this);}},{key:"uninstallEvents",value:function value(){this.emitter_.off(xN.ERROR,this.handleError,this),this.emitter_.off(xN.CONNECTION_STATE_CHANGED,this.handleConnectionStateChange,this);}},{key:"publish",value:(A=a(n().mark(function e(t,i){var r,a,o,s,c,u;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.publishingStream_=t,this.isPublishingAuxStream_=i,o=t.getVideoTrack(),s=null,!o||i||!this.client_.getIsEnableSmallStream()){e.next=9;break;}return this.smallGenerator_=new Sz(t),e.next=8,this.smallGenerator_.initialize();case 8:s=this.smallGenerator_.generateSmallVideoTrack(this.client_.smallStreamConfig_);case 9:if(null===(r=this.client_)||void 0===r||!r.get2k4kFlag()){e.next=18;break;}if(c=1===this.client_.get2k4kFlag(),u=t.getVideoProfile(),c||t.getScreen()||!(u.height*u.width>=3686400)){e.next=18;break;}return u.width=1920,u.height=1080,this.log_.warn(Iw),e.next=18,t.setVideoProfile(u);case 18:if(this.updateMediaSettings(t,i),!fN()){e.next=24;break;}return e.next=22,this.publishByTransceiver(t,s,i);case 22:e.next=26;break;case 24:return e.next=26,this.publishByAddTrack(t,s);case 26:return this.publishingStream_=null,this.isPublishingAuxStream_=!1,i?this.localAuxStream_=t:this.localStream_=t,null===(a=this.sei_)||void 0===a||a.handleEncodedStreams(),e.abrupt("return",t);case 31:case"end":return e.stop();}}},e,this);})),function(e,t){return A.apply(this,arguments);})},{key:"publishByTransceiver",value:(C=a(n().mark(function e(t,i,r){var a,o,s,c,u,d,l;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.log_.info("publish by transceiver"),a=t.getMediaStream(),o=t.getAudioTrack(),s=t.getVideoTrack(),c=null,(DT||PT)&&fA(s)&&(c=t.getCanvasTrack()),0!==(u=this.peerConnection_.getTransceivers()).length){e.next=16;break;}return this.peerConnection_.addTransceiver(o||BT,{direction:yI,streams:[a]}),this.peerConnection_.addTransceiver(r?HT:c||s||HT,{direction:yI,streams:[a]}),this.peerConnection_.addTransceiver(i||HT,{direction:yI,streams:[a]}),this.peerConnection_.addTransceiver(r?c||s:HT,{direction:yI,streams:[a]}),e.next=14,this.connect();case 14:e.next=46;break;case 16:if(d=[],!o){e.next=29;break;}if(!u[0].sender.track){e.next=24;break;}return this.mixAudioTrack(u[0].sender.track,o),e.next=22,u[0].sender.replaceTrack(this.mixedAudioTrack_);case 22:e.next=27;break;case 24:return e.next=26,u[0].sender.replaceTrack(o);case 26:d.push(0);case 27:return e.next=29,this.setBandwidth({bandwidth:t.getAudioBitrate(),type:BT});case 29:if(!s){e.next=42;break;}return l=r?3:1,e.next=33,u[l].sender.replaceTrack(c||s);case 33:return e.next=35,this.setBandwidth({bandwidth:t.getVideoBitrate(),type:HT,videoType:r?JT:zT});case 35:if(d.push(l),!i){e.next=42;break;}return e.next=39,u[2].sender.replaceTrack(i);case 39:return e.next=41,this.setBandwidth({bandwidth:this.client_.smallStreamConfig.bitrate,type:HT,videoType:WT});case 41:d.push(2);case 42:return e.next=44,this.setTransceiverDirection(yI,d);case 44:return e.next=46,this.doPublishChange();case 46:case"end":return e.stop();}}},e,this);})),function(e,t,n){return C.apply(this,arguments);})},{key:"publishByAddTrack",value:(R=a(n().mark(function e(t,i){var r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return this.log_.info("publish by addtrack"),r=t.getMediaStream(),a=t.getAudioTrack(),o=t.getVideoTrack(),a&&this.peerConnection_.addTrack(a,r),o&&(this.peerConnection_.addTrack(o,r),i&&((s=new MediaStream()).addTrack(i),this.peerConnection_.addTrack(i,s))),e.next=8,this.connect();case 8:case"end":return e.stop();}}},e,this);})),function(e,t){return R.apply(this,arguments);})},{key:"unpublish",value:(w=a(n().mark(function e(i){var r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(pN()){e.next=2;break;}return e.abrupt("return",this.doUnpublish());case 2:if(r=i.getAudioTrack(),a=i===this.localAuxStream_,o=this.peerConnection_.getSenders(),s=[],!r){e.next=17;break;}if(!this.mixedAudioTrack_){e.next=14;break;}return this.log_.info("has mixed audioTrack, use another audioTrack"),e.next=11,o[0].replaceTrack(a?this.localStream_.getAudioTrack():this.localAuxStream_.getAudioTrack());case 11:this.destroyMixedAudioTrack(),e.next=17;break;case 14:return e.next=16,o[0].replaceTrack(null);case 16:s.push(0);case 17:if(!a){e.next=25;break;}return e.next=20,o[3].replaceTrack(null);case 20:this.localAuxStream_=null,this.mediaSettings_=t(t({},this.mediaSettings_),{},{auxVideoBps:0,auxVideoFps:0,auxVideoWidth:0,auxVideoHeight:0}),s.push(3),e.next=32;break;case 25:return e.next=27,o[1].replaceTrack(null);case 27:return e.next=29,o[2].replaceTrack(null);case 29:this.localStream_=null,this.mediaSettings_=t(t({},this.mediaSettings_),{},{videoWidth:0,videoHeight:0,videoBps:0,videoFps:0,audioFs:0,audioChannel:0,audioBps:0,smallVideoWidth:0,smallVideoHeight:0,smallVideoFps:0,smallVideoBps:0}),s.push(1,2);case 32:if(!this.localStream_&&!this.localAuxStream_){e.next=39;break;}return e.next=35,this.setTransceiverDirection(gI,s);case 35:return e.next=37,this.doPublishChange();case 37:e.next=41;break;case 39:return e.next=41,this.doUnpublish();case 41:case"end":return e.stop();}}},e,this);})),function(e){return w.apply(this,arguments);})},{key:"doPublishChange",value:(E=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return t={state:this.publishState,constraintConfig:this.mediaSettings_},e.next=3,this.signalChannel_.sendWaitForResponse({command:qP,data:t,responseCommand:zP.PUBLISH_STATE_CHANGE_RESULT});case 3:case"end":return e.stop();}}},e,this);})),function(){return E.apply(this,arguments);})},{key:"doUnpublish",value:function value(){var e=this;return this.signalChannel_.sendWaitForResponse({command:ZP,commandDesc:"unpublish",responseCommand:zP.UNPUBLISH_RESULT}).then(function(){e.close();}).catch(function(){e.close();});}},{key:"updateMediaSettings",value:function value(e,t){var n=this;this.localAuxStream_&&e===this.localAuxStream_&&(t=!0);var i=this.client_.getSystemResult().detail,r=i.isH264EncodeSupported,a=i.isVp8EncodeSupported;(r?this.mediaSettings_.videoCodec="H264":a&&(this.mediaSettings_.videoCodec="VP8"),RN)?e.getMediaStream().getTracks().forEach(function(i){var r=i.getSettings();if(i.kind===BT){var a=1;r.channelCount&&(a=r.channelCount),n.mediaSettings_.audioChannel=a,n.mediaSettings_.audioBps=1e3*e.getAudioBitrate(),n.mediaSettings_.audioFs=r.sampleRate;}else if(i.kind===HT){if(t)return n.mediaSettings_.auxVideoWidth=r.width,n.mediaSettings_.auxVideoHeight=r.height,n.mediaSettings_.auxVideoFps=r.frameRate,void(n.mediaSettings_.auxVideoBps=1e3*e.getVideoBitrate());n.client_.getIsEnableSmallStream()&&(n.mediaSettings_.smallVideoWidth=n.client_.smallStreamConfig.width,n.mediaSettings_.smallVideoHeight=n.client_.smallStreamConfig.height,n.mediaSettings_.smallVideoFps=n.client_.smallStreamConfig.frameRate,n.mediaSettings_.smallVideoBps=1e3*n.client_.smallStreamConfig.bitrate),n.mediaSettings_.videoWidth=r.width,n.mediaSettings_.videoHeight=r.height,n.mediaSettings_.videoFps=r.frameRate,n.mediaSettings_.videoBps=1e3*e.getVideoBitrate();}}):this.updateMediaSettingsFromProfile(e);this.log_.info("updateMediaSettings: "+JSON.stringify(this.mediaSettings_));}},{key:"updateMediaSettingsFromProfile",value:function value(e){if(e){if(e.hasAudio()){var t=e.getAudioProfile();this.mediaSettings_.audioChannel=t.channelCount,this.mediaSettings_.audioBps=1e3*t.bitrate,this.mediaSettings_.audioFs=t.sampleRate;}if(e.hasVideo()){var n=e.getVideoProfile();this.mediaSettings_.videoWidth=n.width,this.mediaSettings_.videoHeight=n.height,this.mediaSettings_.videoFps=n.frameRate,this.mediaSettings_.videoBps=1e3*n.bitrate;}}}},{key:"sendMediaSettings",value:function value(e){var t=this;this.updateMediaSettings(e),this.signalChannel_.sendWaitForResponse({command:lD,data:this.mediaSettings_,responseCommand:zP.UPDATE_CONSTRAINT_CONFIG_RES}).then(function(e){0!==e.data.code&&t.log_.warn(e.data.message);}).catch(this.log_.warn);}},{key:"addTrack",value:(I=a(n().mark(function e(t,i){var r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.peerConnection_){e.next=2;break;}return e.abrupt("return");case 2:if(a=i===this.localAuxStream_,this.log_.info("is adding ".concat(t.kind," track to current published local ").concat(a?JT:cI," stream")),null===(r=this.sei_)||void 0===r||r.handleEncodedStreams(),!pN()){e.next=10;break;}return e.next=8,this.addTrackByTransceiver(t,i);case 8:e.next=12;break;case 10:return e.next=12,this.addTrackBySender(t);case 12:YD(this.userId_,{eventId:t.kind===BT?mD:fD,eventDesc:"add ".concat(t.kind," track to current published stream"),timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_});case 13:case"end":return e.stop();}}},e,this);})),function(e,t){return I.apply(this,arguments);})},{key:"addTrackByTransceiver",value:(T=a(n().mark(function e(t,i){var r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r=i===this.localAuxStream_,a=this.peerConnection_.getTransceivers(),t.kind!==BT){e.next=13;break;}if(!a[0].sender.track){e.next=9;break;}return this.mixAudioTrack(a[0].sender.track,t),e.next=7,a[0].sender.replaceTrack(this.mixedAudioTrack_);case 7:e.next=11;break;case 9:return e.next=11,a[0].sender.replaceTrack(t);case 11:e.next=26;break;case 13:return o=r?3:1,e.next=16,a[o].sender.replaceTrack(t);case 16:if(1!==o||!this.client_.getIsEnableSmallStream()){e.next=23;break;}return this.smallGenerator_=new Sz(this.localStream_),e.next=20,this.smallGenerator_.initialize();case 20:return s=this.smallGenerator_.generateSmallVideoTrack(this.client_.smallStreamConfig_),e.next=23,a[2].sender.replaceTrack(s);case 23:if(a[o].direction!==gI){e.next=26;break;}return e.next=26,this.setTransceiverDirection(yI,[o]);case 26:return this.updateMediaSettings(i,r),e.next=29,this.doPublishChange();case 29:case"end":return e.stop();}}},e,this);})),function(e,t){return T.apply(this,arguments);})},{key:"addTrackBySender",value:(b=a(n().mark(function e(t){var i,r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!(pN()&&this.peerConnection_.getTransceivers().findIndex(function(e){return"stopped"===e.direction;})>=0)){e.next=4;break;}return this.log_.warn("transceiver is stopping, negotiate sdp first"),e.next=4,this.updateOffer(WE.REMOVE,t);case 4:if(!(i=this.peerConnection_.getSenders().find(function(e){return e.track&&e.track.kind===t.kind;}))){e.next=11;break;}return this.log_.warn("sender already exists, remove sender first"),r=i.track,this.removeSender(i),e.next=11,this.updateOffer(WE.REMOVE,r);case 11:if(a=this.localStream_.getMediaStream(),this.peerConnection_.addTrack(t,a),t.kind!==HT||!this.client_.getIsEnableSmallStream()){e.next=21;break;}return this.smallGenerator_=new Sz(this.localStream_),e.next=17,this.smallGenerator_.initialize();case 17:o=this.smallGenerator_.generateSmallVideoTrack(this.client_.smallStreamConfig_),(s=new MediaStream()).addTrack(o),this.peerConnection_.addTrack(o,s);case 21:return e.next=23,this.updateOffer(WE.ADD,t);case 23:case"end":return e.stop();}}},e,this);})),function(e){return b.apply(this,arguments);})},{key:"isNeedToResetOfferOrder",value:function value(){if(this.sdpSemantics_===ME||!this.peerConnection_||!this.peerConnection_.localDescription)return!1;for(var e=this.peerConnection_.localDescription.sdp,t=kO(e),n=0;n<t.media.length;n++){if(0===t.media[n].mid&&t.media[n].type===HT)return!0;}return!1;}},{key:"removeSender",value:function value(e){var t=null;pN()&&(t=this.peerConnection_.getTransceivers().find(function(t){return t.sender&&t.sender.track===e.track;})),this.peerConnection_.removeTrack(e),t&&sA(t.stop)&&(this.log_.info("stop transceiver"),t.stop());}},{key:"removeTrack",value:(k=a(n().mark(function e(t,i){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.peerConnection_){e.next=2;break;}return e.abrupt("return");case 2:if(this.log_.info("is removing ".concat(t.kind," track from current published local ").concat(i===this.localAuxStream_?JT:cI," stream")),!pN()){e.next=8;break;}return e.next=6,this.removeTrackByTransceiver(t,i);case 6:e.next=10;break;case 8:return e.next=10,this.removeTrackBySender(t);case 10:YD(this.userId_,{eventId:t.kind===BT?vD:_D,eventDesc:"remove ".concat(t.kind," track from current published stream"),timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_});case 11:case"end":return e.stop();}}},e,this);})),function(e,t){return k.apply(this,arguments);})},{key:"removeTrackByTransceiver",value:(S=a(n().mark(function e(t,i){var r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r=i===this.localAuxStream_,a=this.peerConnection_.getTransceivers(),t.kind!==BT){e.next=13;break;}if(!this.mixedAudioTrack_){e.next=9;break;}return e.next=6,a[0].sender.replaceTrack(r?this.localStream_.getAudioTrack():this.localAuxStream_.getAudioTrack());case 6:this.destroyMixedAudioTrack(),e.next=11;break;case 9:return e.next=11,a[0].sender.replaceTrack(null);case 11:e.next=23;break;case 13:return o=r?3:1,e.next=16,a[o].sender.replaceTrack(null);case 16:if(1!==o||!this.smallGenerator_){e.next=21;break;}return this.smallGenerator_.destroy(),this.smallGenerator_=null,e.next=21,a[2].sender.replaceTrack(null);case 21:return e.next=23,this.setTransceiverDirection(gI,[o]);case 23:return this.updateMediaSettings(i,r),e.next=26,this.doPublishChange();case 26:case"end":return e.stop();}}},e,this);})),function(e,t){return S.apply(this,arguments);})},{key:"setTransceiverDirection",value:(g=a(n().mark(function e(t,i){var r,a,o,s,c,u;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(Nb){e.next=2;break;}return e.abrupt("return");case 2:if(r=!1,a=!1,this.log_.info("setting transceiver ".concat(i.join(",")," direction to ").concat(t)),o=this.peerConnection_.getTransceivers(),i.forEach(function(e){o[e].direction!==t&&(o[e].direction=t,r=!0);}),!r){e.next=14;break;}return this.log_.info("updating offer"),e.next=11,this.peerConnection_.createOffer();case 11:return s=e.sent,e.next=14,this.peerConnection_.setLocalDescription(s);case 14:if(c=-1,u=this.peerConnection_.remoteDescription.sdp.split("\r\n").map(function(e){if(e.match(new RegExp("a=(".concat(gI,"|").concat(SI,"|").concat(yI,")")))&&c++,i.includes(c)){if(t===gI&&e.includes("a=".concat(SI)))return a=!0,"a=".concat(t);if(t===yI&&e.includes("a=".concat(gI)))return a=!0,"a=".concat(SI);}return e;}).join("\r\n"),!a){e.next=20;break;}return this.log_.info("updating answer"),e.next=20,this.peerConnection_.setRemoteDescription({type:"answer",sdp:u});case 20:case"end":return e.stop();}}},e,this);})),function(e,t){return g.apply(this,arguments);})},{key:"removeTrackBySender",value:(_=a(n().mark(function e(t){var i,r,a=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(t.kind!==HT||!this.isNeedToResetOfferOrder()){e.next=7;break;}return this.reset(),this.initialize(),null===(i=this.localStream_.getMediaStream())||void 0===i||i.removeTrack(t),e.next=6,this.publish(this.localStream_);case 6:return e.abrupt("return");case 7:return(r=this.peerConnection_.getSenders().find(function(e){return e.track===t;}))&&(this.removeSender(r),t.kind===HT&&this.smallGenerator_&&(this.smallGenerator_.destroy(),this.smallGenerator_=null,this.peerConnection_.getSenders().forEach(function(e){e.track&&e.track.kind===HT&&a.removeSender(e);}))),e.next=11,this.updateOffer(WE.REMOVE,t);case 11:case"end":return e.stop();}}},e,this);})),function(e){return _.apply(this,arguments);})},{key:"replaceTrack",value:(m=a(n().mark(function e(t,i){var r,a,o,s,c,u,d;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if((a=null===(r=this.peerConnection_)||void 0===r?void 0:r.getSenders())&&0!==a.length){e.next=3;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:zR})});case 3:if(o=i===this.localAuxStream_,this.log_.info("is replacing ".concat(t.kind," track to current published local ").concat(o?JT:cI," stream")),t.kind!==BT||!a[0]){e.next=16;break;}if(!(this.mixedAudioTrack_&&null!==(s=this.localStream_)&&void 0!==s&&s.hasAudio()&&null!==(c=this.localAuxStream_)&&void 0!==c&&c.hasAudio())){e.next=14;break;}return this.destroyMixedAudioTrack(),u=o?this.localStream_.getAudioTrack():this.localAuxStream_.getAudioTrack(),this.mixAudioTrack(t,u),e.next=12,a[0].replaceTrack(this.mixedAudioTrack_);case 12:e.next=16;break;case 14:return e.next=16,a[0].replaceTrack(t);case 16:if(t.kind!==HT){e.next=32;break;}if(i!==this.localStream_||!a[1]){e.next=29;break;}return e.next=20,a[1].replaceTrack(t);case 20:if(!this.smallGenerator_||!a[2]){e.next=29;break;}return this.log_.info("replacing smallVideo"),this.smallGenerator_.destroy(),this.smallGenerator_=new Sz(this.localStream_),e.next=26,this.smallGenerator_.initialize();case 26:return d=this.smallGenerator_.generateSmallVideoTrack(this.client_.smallStreamConfig_),e.next=29,a[2].replaceTrack(d);case 29:if(i!==this.localAuxStream_||!a[3]){e.next=32;break;}return e.next=32,a[3].replaceTrack(t);case 32:YD(this.userId_,{eventId:t.kind===BT?CD:RD,eventDesc:"replace ".concat(t.kind," track from current published stream"),timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_});case 33:case"end":return e.stop();}}},e,this);})),function(e,t){return m.apply(this,arguments);})},{key:"updateOffer",value:(f=a(n().mark(function e(t,i){var r,a,o,s,c,u,d;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.peerConnection_.createOffer(zz);case 3:return r=e.sent,Nb&&(r.sdp=this.setSDPDirection(r.sdp,"sendrecv")),e.next=7,this.peerConnection_.setLocalDescription(r);case 7:return a=this.updateMediaSettings(this.localStream_||this.localAuxStream_),o={action:t,trackId:i.id,kind:i.kind===HT?"bigVideo":i.kind,type:"offer",sdp:this.peerConnection_.localDescription.sdp,constraintConfig:a,state:this.publishState},this.log_.info("createOffer success, sending updated offer to remote server"),this.log_.debug("updatedOffer: "+o.sdp),e.next=13,this.signalChannel_.sendWaitForResponse({command:JP,data:o,responseCommand:zP.UPDATE_OFFER_RESULT,timeout:1e4,commandDesc:"update offer"});case 13:return s=e.sent,c=s.data,u=c.code,d=c.message,0!==u&&this.checkPublishResultCode(u,d),e.next=18,this.acceptAnswer(s.data.data);case 18:this.updateSSRC(r.sdp),nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:SE,kind:"offer"}),e.next=27;break;case 22:throw e.prev=22,e.t0=e.catch(0),this.log_.error(e.t0),nO.logFailedEvent({userId:this.client_.getUserId(),eventType:SE,kind:"offer",error:e.t0}),e.t0;case 27:case"end":return e.stop();}}},e,this,[[0,22]]);})),function(e,t){return f.apply(this,arguments);})},{key:"setBandwidth",value:(p=a(n().mark(function e(t){var i,r,a,o,s,c,u,d;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i=t.bandwidth,r=t.type,a=t.videoType,o=void 0===a?"":a,s=t.sdp,_N()||!s){e.next=3;break;}return e.abrupt("return",r===HT?this.updateVideoBandwidthRestriction(s,i,o):this.updateAudioBandwidthRestriction(s,i));case 3:if(c=0,r===HT&&(c=o===WT?2:o===JT?3:1),!(u=this.peerConnection_.getSenders()[c])){e.next=22;break;}return(d=u.getParameters()).encodings&&0!==d.encodings.length||(d.encodings=[{}]),"unlimited"===i?delete d.encodings[0].maxBitrate:d.encodings[0].maxBitrate=1e3*i,e.prev=10,e.next=13,u.setParameters(d);case 13:return this.log_.info(o+r+" bandwidth was set to "+i+" kbps"),e.abrupt("return",s);case 17:if(e.prev=17,e.t0=e.catch(10),this.log_.info("failed to set bandwidth by setting maxBitrate: "+e.t0),!s){e.next=22;break;}return e.abrupt("return",r===HT?this.updateVideoBandwidthRestriction(s,i,o):this.updateAudioBandwidthRestriction(s,i));case 22:return e.abrupt("return",s);case 23:case"end":return e.stop();}}},e,this,[[10,17]]);})),function(e){return p.apply(this,arguments);})},{key:"updateVideoBandwidthRestriction",value:function value(e,t,n){var i="AS";Nb&&(i="TIAS",t*=1e3);var r=0,a=-1;return n===WT?r=1:n===JT&&(r=2),e=e.replace(/m=video (.*)\r\nc=IN (.*)\r\n/g,function(e){return++a===r?"".concat(e,"b=").concat(i,":").concat(t,"\r\n"):e;}),e;}},{key:"updateAudioBandwidthRestriction",value:function value(e,t){var n="AS";return Nb&&(n="TIAS",t*=1e3),e=e.replace(/m=audio (.*)\r\nc=IN (.*)\r\n/,"m=audio $1\r\nc=IN $2\r\nb="+n+":"+t+"\r\n");}},{key:"removeBandwidthRestriction",value:function value(e){return e.replace(/b=AS:.*\r\n/,"").replace(/b=TIAS:.*\r\n/,"");}},{key:"removeVideoOrientation",value:function value(e){return e.replace(/urn:3gpp:video-orientation/,"");}},{key:"connect",value:(h=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.exchangeSDP();case 3:return e.next=5,this.waitForPeerConnectionConnected();case 5:e.next=11;break;case 7:throw e.prev=7,e.t0=e.catch(0),this.closePeerConnection(!0),e.t0;case 11:case"end":return e.stop();}}},e,this,[[0,7]]);})),function(){return h.apply(this,arguments);})},{key:"exchangeSDP",value:(u=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,this.isSDPExchanging_=!0,e.next=4,this.createOffer();case 4:return this.log_.info("createOffer success, sending offer to remote server"),e.next=7,this.doExchangeSDP();case 7:this.isSDPExchanging_=!1,e.next=14;break;case 10:throw e.prev=10,e.t0=e.catch(0),this.isSDPExchanging_=!1,e.t0;case 14:case"end":return e.stop();}}},e,this,[[0,10]]);})),function(){return u.apply(this,arguments);})},{key:"createOffer",value:(s=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.peerConnection_.createOffer(zz);case 3:return t=e.sent,e.next=6,this.peerConnection_.setLocalDescription(t);case 6:this.updateSSRC(t.sdp),nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:SE,kind:"offer"}),e.next=14;break;case 10:throw e.prev=10,e.t0=e.catch(0),nO.logFailedEvent({userId:this.client_.getUserId(),eventType:SE,kind:"offer",error:e.t0}),e.t0;case 14:case"end":return e.stop();}}},e,this,[[0,10]]);})),function(){return s.apply(this,arguments);})},{key:"doExchangeSDP",value:function value(){var e=this;return new Promise(function(t,i){e.exchangeSDPTimeout_=setTimeout(function(){e.signalChannel_.off(zP.PUBLISH_RESULT,r),e.clearExchangeSDPTimeout();var t=new pD({code:hD.API_CALL_TIMEOUT,message:ZC({key:nR})});i(t);},1e4);var r=function(){var r=a(n().mark(function r(a){var o,s,c;return n().wrap(function(n){for(;;){switch(n.prev=n.next){case 0:if(n.prev=0,e.clearExchangeSDPTimeout(),o=a.data,s=o.code,c=o.message,0!==s){n.next=9;break;}return n.next=6,e.acceptAnswer(a.data.data);case 6:t(),n.next=10;break;case 9:e.checkPublishResultCode(s,c);case 10:n.next=15;break;case 12:n.prev=12,n.t0=n.catch(0),i(n.t0);case 15:case"end":return n.stop();}}},r,null,[[0,12]]);}));return function(e){return r.apply(this,arguments);};}(),o={type:e.peerConnection_.localDescription.type,sdp:e.removeVideoOrientation(e.peerConnection_.localDescription.sdp),screen:(e.publishingStream_||e.localStream_).hasScreenTrack(),state:e.publishState,constraintConfig:e.mediaSettings_};e.signalChannel_.once(zP.PUBLISH_RESULT,r),e.log_.debug("sending sdp offer: "+o.sdp),e.signalChannel_.send($P,o);});}},{key:"setSDPDirection",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"all",i=kO(e);return i.media.forEach(function(e){"all"!==n&&e.type!==n||(e.direction=t);}),bO(i);}},{key:"acceptAnswer",value:(r=a(n().mark(function e(t){var i,r,a,o,s,c,u;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(e.prev=0,i=this.removeVideoOrientation(t.sdp),!(r=this.publishingStream_||this.localStream_)){e.next=15;break;}if(a=r.getVideoBitrate(),o=r.getAudioBitrate(),!a){e.next=11;break;}return s=this.isPublishingAuxStream_?JT:zT,e.next=10,this.setBandwidth({bandwidth:a,type:HT,sdp:i,videoType:s});case 10:i=e.sent;case 11:if(!o){e.next=15;break;}return e.next=14,this.setBandwidth({bandwidth:o,type:BT,sdp:i});case 14:i=e.sent;case 15:if(!this.client_.getIsEnableSmallStream()){e.next=20;break;}return c=this.client_.smallStreamConfig,e.next=19,this.setBandwidth({bandwidth:c.bitrate,type:HT,videoType:WT,sdp:i});case 19:i=e.sent;case 20:return u={type:t.type,sdp:i},e.next=23,this.peerConnection_.setRemoteDescription(u);case 23:this.log_.debug("accepted answer: "+i),nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:kE,kind:"answer"}),e.next=32;break;case 27:throw e.prev=27,e.t0=e.catch(0),nO.logFailedEvent({userId:this.client_.getUserId(),eventType:kE,kind:"answer",error:e.t0}),this.log_.error("failed to accept remote answer "+e.t0),e.t0;case 32:case"end":return e.stop();}}},e,this,[[0,27]]);})),function(e){return r.apply(this,arguments);})},{key:"sendMutedFlag",value:function value(e,t){if(t!==this.localAuxStream_){var n={audio:e.audio,bigVideo:e.video,auxVideo:e.auxVideo};this.log_.info("send muted state: ".concat(JSON.stringify(n))),this.signalChannel_.send(YP,n);}}},{key:"getIsReconnecting",value:function value(){return this.isReconnecting_;}},{key:"reconnect",value:(i=a(n().mark(function e(){var t,i,r=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(-1===this.reconnectionTimer_){e.next=3;break;}return this.log_.warn("reconnect() uplink is reconnecting, ignore current reconnection"),e.abrupt("return");case 3:if(!(this.reconnectionCount_>=30)){e.next=12;break;}return this.log_.warn("SDK has tried reconnect uplink for ".concat(30," times, but all failed, please check your network")),this.stopReconnection(),t=new pD({code:hD.UPLINK_RECONNECTION_FAILED,message:ZC({key:aR})}),nO.logFailedEvent({userId:this.client_.getUserId(),eventType:vE,error:t}),this.addEventInternal(WD,"uplink-connection reconnect fail"),this.emitConnectionStateChangedEvent(KI),this.emitter_.emit(xN.ERROR,t),e.abrupt("return");case 12:if(this.signalChannel_.getCurrentState()===HP){e.next=16;break;}return this.log_.warn("reconnect() signal channel is not connected, suspend reconnection until signal is connected"),this.signalChannel_.once(UP,this.reconnect,this),e.abrupt("return");case 16:if(this.reconnectionCount_++,e.prev=17,this.log_.warn("reconnect() try to reconnect uplink [".concat(this.reconnectionCount_,"/").concat(30,"]")),i=oA(this.reconnectionCount_),this.reconnectionTimer_=setTimeout(function(){r.log_.warn("reconnect() uplink reconnect timeout(".concat(i/1e3,"s), try again")),r.clearReconnectionTimer(),r.reconnect();},i),!(this.isSDPExchanging_||this.peerConnection_&&this.peerConnection_.connectionState===ZI)){e.next=23;break;}return e.abrupt("return");case 23:return e.next=25,this.signalChannel_.sendWaitForResponse({command:ZP,responseCommand:zP.UNPUBLISH_RESULT,enableLog:!1});case 25:if(this.reset(),this.initialize(),!this.localStream_){e.next=30;break;}return e.next=30,this.publish(this.localStream_);case 30:if(!this.localAuxStream_){e.next=33;break;}return e.next=33,this.publish(this.localAuxStream_,!0);case 33:nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:vE}),this.log_.warn("reconnect() uplink reconnect successfully"),this.addEventInternal(GD,"uplink-connection reconnect success"),this.stopReconnection(),this.localStream_.syncMuteState(),e.next=42;break;case 40:e.prev=40,e.t0=e.catch(17);case 42:case"end":return e.stop();}}},e,this,[[17,40]]);})),function(){return i.apply(this,arguments);})},{key:"clearExchangeSDPTimeout",value:function value(){-1!==this.exchangeSDPTimeout_&&(clearTimeout(this.exchangeSDPTimeout_),this.exchangeSDPTimeout_=-1);}},{key:"clearReconnectionTimer",value:function value(){-1!==this.reconnectionTimer_&&(clearTimeout(this.reconnectionTimer_),this.reconnectionTimer_=-1);}},{key:"handleError",value:function value(e){e.getCode()===hD.ICE_TRANSPORT_ERROR&&(this.isFirstConnection_&&(this.isFirstConnection_=!1,nO.logFailedEvent({userId:this.client_.getUserId(),eventType:_E,error:e})),this.isReconnecting_||this.startReconnection());}},{key:"handleConnectionStateChange",value:function value(e){e.state===YI&&this.isFirstConnection_&&(this.isFirstConnection_=!1,nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:_E}),this.addEventInternal(UD,"uplink-connection is connected"));}},{key:"updateSSRC",value:function value(e){var t=this;try{kO(e).media.forEach(function(e,n){if(e.type===BT){var i=e.ssrcs[0];i&&(t.ssrc_.audio=i.id);}else{if(t.sdpSemantics_===ME)return void e.ssrcGroups.forEach(function(e,n){var i=Number(e.ssrcs.split(" ")[0]);0===n?t.ssrc_.video=i:1===n&&(t.ssrc_.small=i);});var r=e.ssrcs[0];if(!r)return;switch(n){case 1:t.ssrc_.video=r.id;break;case 2:t.ssrc_.small=r.id;break;case 3:t.ssrc_.auxiliary=r.id;}}});}catch(XJ){}}},{key:"getVideoTrackId",value:function value(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:HT;if(this.peerConnection_){var t=this.peerConnection_.getSenders();if(e===HT&&t[1]&&t[1].track)return t[1].track.id;if(e===WT&&t[2]&&t[2].track)return t[2].track.id;if(e===JT&&t[3]&&t[3].track)return t[3].track.id;}if(this.localStream_&&e===HT){var n=this.localStream_.getVideoTrack();if(n)return n.id;}if(this.localAuxStream_&&e===JT){var i=this.localAuxStream_.getVideoTrack();if(i)return i.id;}return"";}},{key:"getSSRC",value:function value(){return this.ssrc_;}},{key:"checkPublishResultCode",value:function value(e,t){if(0!==e)throw 1028===e?(this.log_.error(XC.NOT_SUPPORTED_H264ENCODE),new pD({code:hD.NOT_SUPPORTED_H264,message:ZC({key:RC})})):new pD({code:hD.UNKNOWN,message:ZC({key:MC,data:{signalResponse:zP.PUBLISH_RESULT,code:e,message:t}})});}},{key:"getLocalStream",value:function value(){return this.localStream_;}},{key:"sendSEI",value:function value(e,t){this.sei_.push(e,t);}},{key:"mixAudioTrack",value:function value(e,t){this.log_.info("mix audio track"),this.mixedAudioTrack_=function(e){var t=TA(),n=t.createMediaStreamDestination(),i=[];e.forEach(function(e){var r=new MediaStream();r.addTrack(e);var a=t.createMediaStreamSource(r);a.connect(n),i.push(a);});var r=n.stream.getAudioTracks()[0];return bz.set(r,{destination:n,track:r,mediaStreamSourceList:i}),r;}([e,t]);}},{key:"destroyMixedAudioTrack",value:function value(){this.mixedAudioTrack_&&(this.log_.info("destroy audio track"),function(e){if(bz.has(e)){var t=bz.get(e),n=t.destination,i=t.track,r=t.mediaStreamSourceList;i.stop(),n.disconnect(),r.forEach(function(e){e.disconnect();}),bz.delete(e);}}(this.mixedAudioTrack_),this.mixedAudioTrack_=null);}}]),P;}(ZW),E(Vz.prototype,"publish",[Uz],Object.getOwnPropertyDescriptor(Vz.prototype,"publish"),Vz.prototype),Vz),qz=(Fz=kz({retries:1,timeout:0,onRetrying:function onRetrying(e){this.log_.warn("connection timeout, retrying [".concat(e,"]"));},onError:function onError(e,t,n){e.message.includes("timeout")?t():n(e);}}),jz=function(e){d(_,e);var i,r,s,u,h,p,f,m=v(_);function _(e){var t;return o(this,_),(t=m.call(this,e)).remoteStreams_=new Map(),t.autoSubscribe=e.autoSubscribe,t.trackState_={audio:e.trackState.audio,video:e.trackState.video,auxiliary:e.trackState.auxiliary,smallVideo:e.trackState.smallVideo},t.ssrc_={audio:0,video:0,auxiliary:0},t.subscribeState_={audio:e.autoSubscribe,video:e.autoSubscribe,auxiliary:e.autoSubscribe,smallVideo:!1},t.isSDPExchanging_=!1,t.installEvents(),t;}return c(_,[{key:"isMainStreamSubscribed",get:function get(){return(this.subscribeState_.audio||this.subscribeState_.video||this.subscribeState_.smallVideo)&&(this.trackState_.audio||this.trackState_.video||this.trackState_.smallVideo);}},{key:"isAuxStreamSubscribed",get:function get(){return this.subscribeState_.auxiliary&&this.trackState_.auxiliary;}},{key:"isSmallStreamSubscribed",get:function get(){return this.subscribeState_.smallVideo&&this.trackState_.smallVideo;}},{key:"isBigStreamSubscribed",get:function get(){return this.subscribeState_.video&&this.trackState_.video;}},{key:"isStreamUnpublished",value:function value(e){return e.getType()===cI?!this.trackState_.audio&&!this.trackState_.video:!this.trackState_.auxiliary;}},{key:"initialize",value:function value(){y(l(_.prototype),"initialize",this).call(this),this.peerConnection_.ontrack=this.onTrack.bind(this);}},{key:"close",value:function value(){var e=this;y(l(_.prototype),"close",this).call(this),this.trackState_.audio=!1,this.trackState_.video=!1,this.trackState_.smallVideo=!1,this.trackState_.auxiliary=!1,this.emitConnectionStateChangedEvent(KI),this.remoteStreams_.forEach(function(t){var n=t;n.setConnection(null),n.uninstallEvents(),n.getIsStreamAddedEventEmitted()&&e.emitter_.emit(xN.STREAM_REMOVED,{stream:n});}),this.remoteStreams_.clear(),this.uninstallEvents();}},{key:"installEvents",value:function value(){var e=this;DA.on(ex,this.onRemoteStreamUpdate,this),this.emitter_.on(xN.ERROR,function(t){t.getCode()===hD.ICE_TRANSPORT_ERROR&&(e.isFirstConnection_&&(e.isFirstConnection_=!1,nO.logFailedEvent({userId:e.client_.getUserId(),eventType:gE,error:t})),e.isReconnecting_||e.startReconnection());}),this.emitter_.on(xN.CONNECTION_STATE_CHANGED,function(t){t.state===YI&&e.isFirstConnection_&&(e.isFirstConnection_=!1,nO.logSuccessEvent({userId:e.client_.getUserId(),eventType:gE}),e.addEventInternal(VD,"downlink-connection is connected"));});}},{key:"uninstallEvents",value:function value(){DA.removeListener(ex,this.onRemoteStreamUpdate,this);}},{key:"onRemoteStreamUpdate",value:function value(e){if(this.hitTest(e.tinyId)&&e.client===this.client_){this.updateTrackState(e.action,e.kind);var t=e.kind===JT?GI:HI,n=this.remoteStreams_.get(t);if(!n)return;e.action===WE.ADD?this.handleRemoteAddTrack(e.kind,n):this.handleRemoteRemoveTrack(e.kind,n);}}},{key:"handleRemoteAddTrack",value:function value(e,t){this.log_.info("remote add ".concat(e," track")),e===BT?t.updateAudioPlayingState(this.subscribeState_.audio):t.updateVideoPlayingState(e===JT?this.subscribeState_.auxiliary:this.subscribeState_.video||this.subscribeState_.smallVideo),t.getIsStreamAddedEventEmitted()?this.emitter_.emit(xN.STREAM_UPDATED,{stream:t}):(this.emitter_.emit(xN.STREAM_ADDED,{stream:t}),this.currentState_===YI&&t.emitConnectionStateChanged({prevState:KI,state:YI}));}},{key:"handleRemoteRemoveTrack",value:function value(e,t){t.getIsStreamAddedEventEmitted()&&(this.log_.info("remote remove ".concat(e," track")),e===JT||!this.trackState_.audio&&!this.trackState_.video?(this.log_.info("remote stream ".concat(t.getType()," removed")),this.currentState_===YI&&t.emitConnectionStateChanged({prevState:YI,state:KI}),this.emitter_.emit(xN.STREAM_REMOVED,{stream:t})):(e===BT?t.updateAudioPlayingState(!1):(e!==KT||this.isSmallStreamSubscribed)&&t.updateVideoPlayingState(!1),this.emitter_.emit(xN.STREAM_UPDATED,{stream:t})));}},{key:"updateTrackState",value:function value(e,t){var n=e===WE.ADD;switch(t){case BT:this.trackState_.audio=n;break;case HT:this.trackState_.video=n;break;case JT:this.trackState_.auxiliary=n;break;case KT:this.trackState_.smallVideo=n;}this.log_.info("trackState updated: ".concat(JSON.stringify(this.trackState_)));}},{key:"onTrack",value:function value(e){var t=e.streams[0],n=e.track;if(this.log_.info("ontrack() kind: ".concat(n.kind," id: ").concat(n.id," streamId: ").concat(t.id)),this.sdpSemantics_===NE){var i=function(e){var t=uO.parse(e),n={audio:[],video:[]};return t.media.forEach(function(e){if(e.ssrcs){var t=e.ssrcs[0].id>>16&255;if(e.type===BT)n.audio.push(HI);else if(e.type==HT){var i=t===WI?HI:GI;n.video.push(i);}}}),n;}(this.peerConnection_.remoteDescription.sdp);if(n.kind===BT){if(0===i.audio.length||t.id!==HI)return void this.log_.debug("skip this invalid audio track");}else if(-1===i.video.indexOf(t.id))return void this.log_.debug("skip this invalid video track: ".concat(n.id,"  msid: ").concat(t.id));}nO.logEvent({eventType:"ontrack",kind:n.kind});var r=!1,a=this.remoteStreams_.get(t.id),o=t.id===HI?zI:JI;if(cA(a)&&((a=new mz({type:o,userId:this.userId_,client:this.client_})).setConnection(this),this.remoteStreams_.set(t.id,a),r=!0),a.setMediaStream(t),n.kind===BT?a.updateAudioPlayingState(this.subscribeState_.audio):o===zI?a.updateVideoPlayingState(this.subscribeState_.video||this.subscribeState_.smallVideo):a.updateVideoPlayingState(this.subscribeState_.auxiliary),(o!==JI||this.trackState_.auxiliary)&&(o!==zI||this.trackState_.audio||this.trackState_.video)){var s=this.client_.getSubscriptionManager();s&&s.hasAutoRecoveryFlag(this.userId_,o)||(r?this.emitter_.emit(xN.STREAM_ADDED,{stream:a}):this.emitter_.emit(xN.STREAM_UPDATED,{stream:a}));}}},{key:"addRRTRLine",value:function value(e){var t=e.split("\r\n"),n=new Map();t.forEach(function(e,i){/^a=rtcp-fb:/.test(e)&&t[i+1]&&!/^a=rtcp-fb:/.test(t[i+1])&&n.set(i+1,e.match(/^a=rtcp-fb:\d+/)[0]+" rrtr");});for(var i=k(n),r=0;r<i.length;r++){var a=S(i[r],2),o=a[0],s=a[1];t.splice(o+r,0,s);}return t.join("\r\n");}},{key:"addSPSDescription",value:function value(e){var t=kO(e);return t.media.forEach(function(e){e.type===HT&&e.fmtp.forEach(function(e){e.config+=";sps-pps-idr-in-keyframe=1";});}),bO(t);}},{key:"removeSDESDescription",value:function value(e){var t=["urn:ietf:params:rtp-hdrext:sdes:mid","urn:ietf:params:rtp-hdrext:sdes:rtp-stream-id","urn:ietf:params:rtp-hdrext:sdes:repaired-rtp-stream-id"],n=kO(e);return n.media.forEach(function(e){e.ext=e.ext.filter(function(e){return!t.includes(e.uri);});}),bO(n);}},{key:"isSubscriptionStateNotChanged",value:function value(e,t){return e.getType()===zI?(null==t?void 0:t.audio)===this.subscribeState_.audio&&(null==t?void 0:t.video)===this.subscribeState_.video&&this.isSubscribeSmall(t):e.getType()===JI?!cA(t.video)&&this.subscribeState_.auxiliary===t.video:void 0;}},{key:"isSubscribeSmall",value:function value(e){return cA(e.smallVideo)&&!this.subscribeState_.smallVideo;}},{key:"subscribe",value:(f=a(n().mark(function e(t,i){var r,a,o,s,c,u;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(e.prev=0,o=i.emitEvent,s=void 0===o||o,c=t.getType(),(null===(r=this.peerConnection_)||void 0===r?void 0:r.connectionState)!==$I&&(null===(a=this.peerConnection_)||void 0===a?void 0:a.connectionState)!==ZI){e.next=6;break;}return e.next=6,this.waitForPeerConnectionConnected();case 6:if(!this.isSubscriptionStateNotChanged(t,i)){e.next=13;break;}if(this.peerConnection_){e.next=11;break;}return this.initialize(),e.next=11,this.connect();case 11:return s&&cA(i.smallVideo)&&this.emitter_.emit(xN.STREAM_SUBSCRIBED,{stream:t,result:!0}),e.abrupt("return",t);case 13:if(c===cI?(cA(i.audio)||(this.subscribeState_.audio=i.audio),cA(i.video)||(this.subscribeState_.video=i.video),this.subscribeState_.smallVideo=(null==i?void 0:i.smallVideo)||!1,this.addEventInternal(this.subscribeState_.audio?bD:ID,this.subscribeState_.audio?"subscribe audio":"unsubscribe audio"),this.addEventInternal(this.subscribeState_.video?bD:ID,this.subscribeState_.video?"subscribe video":"unsubscribe video"),this.addEventInternal(this.subscribeState_.smallVideo?KD:QD,this.subscribeState_.smallVideo?"subscribe smallVideo":"unsubscribe smallVideo")):cA(i.video)||(this.subscribeState_.auxiliary=i.video),this.log_.info("subscribe ".concat(c," stream with options ").concat(JSON.stringify(i)," current state: ").concat(JSON.stringify(this.subscribeState_))),!this.peerConnection_&&!this.isSDPExchanging_){e.next=23;break;}return u=OE,this.isMainStreamSubscribed||this.isAuxStreamSubscribed||(u=DE),e.next=20,this.sendSubscription(u);case 20:c===cI?(t.updateAudioPlayingState(this.subscribeState_.audio),t.updateVideoPlayingState(this.subscribeState_.video||this.subscribeState_.smallVideo)):t.updateVideoPlayingState(this.subscribeState_.auxiliary),e.next=26;break;case 23:return this.initialize(),e.next=26,this.connect();case 26:return s&&this.emitter_.emit(xN.STREAM_SUBSCRIBED,{stream:t,result:!0}),e.abrupt("return",t);case 30:if(e.prev=30,e.t0=e.catch(0),!this.client_.getIsJoined()||!this.isStreamUnpublished(t)){e.next=35;break;}throw this.log_.warn("".concat(e.t0.message," ").concat(JSON.stringify(this.trackState_))),new pD({code:hD.REMOTE_STREAM_NOT_EXIST,message:"remote user ".concat(this.userId_," unpublished stream")});case 35:throw e.t0;case 36:case"end":return e.stop();}}},e,this,[[0,30]]);})),function(e,t){return f.apply(this,arguments);})},{key:"unsubscribe",value:(p=a(n().mark(function e(t){var i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if((i=t.getType())!==cI){e.next=10;break;}if(this.isMainStreamSubscribed){e.next=5;break;}return this.log_.info("main stream already unsubscribed"),e.abrupt("return",t);case 5:this.subscribeState_.audio=!1,this.subscribeState_.video=!1,this.subscribeState_.smallVideo=!1,e.next=14;break;case 10:if(this.isAuxStreamSubscribed){e.next=13;break;}return this.log_.info("auxiliary stream already unsubscribed"),e.abrupt("return",t);case 13:this.subscribeState_.auxiliary=!1;case 14:return r=DE,(i===zI&&this.isAuxStreamSubscribed||i===JI&&this.isMainStreamSubscribed)&&(r=OE),this.log_.info("unsubscribe ".concat(i," stream with ").concat(JSON.stringify(this.subscribeState_))),e.next=19,this.sendSubscription(r);case 19:return t.updateVideoPlayingState(!1),t.updateAudioPlayingState(!1),r===DE&&((a=t.getMediaStream())&&a.getTracks().forEach(function(e){return a.removeTrack(e);}),this.closePeerConnection(),this.emitConnectionStateChangedEvent(KI)),this.addEventInternal(ID,"unsubscribe audio"),this.addEventInternal(TD,"unsubscribe video"),e.abrupt("return",t);case 25:case"end":return e.stop();}}},e,this);})),function(e){return p.apply(this,arguments);})},{key:"sendSubscription",value:function value(e){var t=this,n={srcTinyId:this.tinyId_,srcUserId:this.userId_},i=tD,r=zP.UNSUBSCRIBE_RESULT;return e===OE&&(n={audio:this.subscribeState_.audio,bigVideo:this.subscribeState_.video,auxVideo:this.subscribeState_.auxiliary,smallVideo:this.subscribeState_.smallVideo,srcTinyId:this.tinyId_},i=nD,r=zP.SUBSCRIBE_CHANGE_RESULT),this.signalChannel_.sendWaitForResponse({command:i,data:n,responseCommand:r,timeout:1e4}).then(function(n){var i=n.data;if(0!==i.code){var r=new pD({code:i.code,message:ZC({key:tR,data:{type:e,message:i.message}})});throw t.log_.error(r),r;}});}},{key:"connect",value:(h=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.exchangeSDP();case 3:return e.next=5,this.waitForPeerConnectionConnected();case 5:e.next=11;break;case 7:throw e.prev=7,e.t0=e.catch(0),this.closePeerConnection(!0),e.t0;case 11:case"end":return e.stop();}}},e,this,[[0,7]]);})),function(){return h.apply(this,arguments);})},{key:"exchangeSDP",value:(u=a(n().mark(function e(){var t,i,r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,this.isSDPExchanging_=!0,e.next=4,this.createOffer();case 4:return this.log_.info("createOffer success, sending offer to remote server"),t=this.peerConnection_.localDescription,i=t.type,r=t.sdp,a={type:i,sdp:r,srcUserId:this.userId_,srcTinyId:this.tinyId_,audio:this.subscribeState_.audio,bigVideo:this.subscribeState_.video,auxVideo:this.subscribeState_.auxiliary,smallVideo:this.subscribeState_.smallVideo},DA.emit(Sx,{client:this.client_,connection:this,userId:this.userId_,tinyId:this.tinyId_,role:VI,subscribeState:this.subscribeState_,trackState:this.trackState_}),e.next=10,this.signalChannel_.sendWaitForResponse({command:eD,commandDesc:"exchange sdp",data:a,responseCommand:zP.SUBSCRIBE_RESULT,timeout:1e4});case 10:if(o=e.sent,this.peerConnection_){e.next=15;break;}throw s=new pD({code:hD.INVALID_OPERATION,message:ZC({key:VC})}),this.log_.warn(s),s;case 15:return e.next=17,this.onSubscribeResult(o);case 17:this.isSDPExchanging_=!1,e.next=24;break;case 20:throw e.prev=20,e.t0=e.catch(0),this.isSDPExchanging_=!1,e.t0;case 24:case"end":return e.stop();}}},e,this,[[0,20]]);})),function(){return u.apply(this,arguments);})},{key:"createOffer",value:(s=a(n().mark(function e(){var t,i;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return t={voiceActivityDetection:!1},fN()&&this.sdpSemantics_===NE?(this.peerConnection_.addTransceiver(BT,{direction:"recvonly"}),this.peerConnection_.addTransceiver(HT,{direction:"recvonly"}),this.peerConnection_.addTransceiver(HT,{direction:"recvonly"})):(t.offerToReceiveAudio=!0,t.offerToReceiveVideo=!0),e.next=4,this.peerConnection_.createOffer(t);case 4:return i=e.sent,e.next=7,aN();case 7:return e.sent.isH264DecodeSupported||(this.log_.warn("remove h264 desc from sdp"),i.sdp=IO(i.sdp)),i.sdp=this.addRRTRLine(i.sdp),i.sdp=this.addSPSDescription(i.sdp),i.sdp=TO(i.sdp),this.sdpSemantics_===NE&&(i.sdp=this.removeSDESDescription(i.sdp)),e.next=16,this.peerConnection_.setLocalDescription(i);case 16:case"end":return e.stop();}}},e,this);})),function(){return s.apply(this,arguments);})},{key:"onSubscribeResult",value:(r=a(n().mark(function e(i){var r,a,o,s,c,u,d,l=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r=i&&i.data||{},a=r.code,o=r.message,s=void 0===o?"":o,c=i&&i.data&&i.data.data||{},u=c.type,d=c.sdp,77393!==a){e.next=5;break;}throw this.log_.error(XC.NOT_SUPPORTED_H264DECODE),new pD({code:hD.NOT_SUPPORTED_H264,message:ZC({key:CC})});case 5:if(e.prev=5,0===a){e.next=8;break;}throw new pD({code:a,message:ZC({key:rR,data:{errMsg:s}})});case 8:return this.log_.debug("accept remote answer: "+d),e.next=11,this.peerConnection_.setRemoteDescription({type:u,sdp:d});case 11:this.sei_&&(this.sei_.handleEncodedStreams(),this.sei_.onSEIMessage=function(e){l.emitter_.emit(xN.SEI_MESSAGE,t(t({},e),{},{userId:l.userId_}));}),this.updateSSRC(d),e.next=19;break;case 15:throw e.prev=15,e.t0=e.catch(5),this.log_.error(e.t0),e.t0;case 19:case"end":return e.stop();}}},e,this,[[5,15]]);})),function(e){return r.apply(this,arguments);})},{key:"updateSSRC",value:function value(e){var t=this;try{kO(e).media.forEach(function(e){if(e.type===BT){var n=e.ssrcs.find(function(e){return e.value.includes(HI);});n&&(t.ssrc_.audio=n.id);}else{var i=e.ssrcs.find(function(e){return e.value.includes(HI);}),r=e.ssrcs.find(function(e){return e.value.includes(GI);});i&&(t.ssrc_.video=i.id),r&&(t.ssrc_.auxiliary=r.id);}});}catch(XJ){}}},{key:"setRemoteStream",value:function value(e,t){this.remoteStreams_.set(e,t);}},{key:"getSubscribeState",value:function value(){return this.subscribeState_;}},{key:"getTrackState",value:function value(){return this.trackState_;}},{key:"getSSRC",value:function value(){return this.ssrc_;}},{key:"getMainStream",value:function value(){return this.remoteStreams_.get(HI);}},{key:"getAuxStream",value:function value(){return this.remoteStreams_.get(GI);}},{key:"getMainStreamVideoTrackId",value:function value(){var e=this.getMainStream();if(e){var t=e.getVideoTrack();if(t)return t.id;}return"";}},{key:"getAuxStreamVideoTrackId",value:function value(){var e=this.getAuxStream();if(e){var t=e.getVideoTrack();if(t)return t.id;}return"";}},{key:"reconnect",value:(i=a(n().mark(function e(){var t,i,r=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(-1===this.reconnectionTimer_){e.next=3;break;}return this.log_.warn("reconnect() downlink is reconnecting, ignore current reconnection"),e.abrupt("return");case 3:if(!(this.reconnectionCount_>=30)){e.next=12;break;}return this.log_.warn("SDK has tried reconnect downlink [".concat(this.userId_,"] for ").concat(30," times, but all failed, please check your network")),this.stopReconnection(),t=new pD({code:hD.DOWNLINK_RECONNECTION_FAILED,message:ZC({key:iR})}),nO.logFailedEvent({userId:this.client_.getUserId(),eventType:yE,error:t}),this.addEventInternal(qD,"downlink-connection reconnect fail"),this.emitConnectionStateChangedEvent(KI),this.emitter_.emit(xN.ERROR,t),e.abrupt("return");case 12:if(this.signalChannel_.getCurrentState()===HP){e.next=16;break;}return this.log_.warn("reconnect() signal channel is not connected, suspend reconnection until signal is connected"),this.signalChannel_.once(UP,this.reconnect,this),e.abrupt("return");case 16:if(this.reconnectionCount_++,this.log_.warn("reconnect() try to reconnect downlink [".concat(this.reconnectionCount_,"/").concat(30,"]")),i=oA(this.reconnectionCount_),this.reconnectionTimer_=setTimeout(function(){r.log_.warn("reconnect() downlink [".concat(r.userId_,"] reconnect timeout(").concat(i/1e3,"s), try again")),r.clearReconnectionTimer(),r.reconnect();},i),!(this.isSDPExchanging_||this.peerConnection_&&this.peerConnection_.connectionState===ZI)){e.next=22;break;}return e.abrupt("return");case 22:return e.prev=22,this.closePeerConnection(),this.initialize(),e.next=27,this.connect();case 27:this.stopReconnection(),this.log_.warn("reconnect() downlink reconnect successfully"),nO.logSuccessEvent({userId:this.client_.getUserId(),eventType:yE}),this.addEventInternal(JD,"downlink-connection reconnect success"),this.recoverSubscription(),e.next=36;break;case 34:e.prev=34,e.t0=e.catch(22);case 36:case"end":return e.stop();}}},e,this,[[22,34]]);})),function(){return i.apply(this,arguments);})},{key:"recoverSubscription",value:function value(){var e=this,t=this.client_.getSubscriptionManager();t&&k(this.remoteStreams_.values()).forEach(function(n){t.hasAutoRecoveryFlag(e.userId_,n.getType())&&t.recover(n);});}},{key:"getIsReconnecting",value:function value(){return this.isReconnecting_;}},{key:"getSubscribedMainStream",value:function value(){var e=null;return this.isMainStreamSubscribed&&(e=this.remoteStreams_.get(HI)),e;}},{key:"clearReconnectionTimer",value:function value(){-1!==this.reconnectionTimer_&&(clearTimeout(this.reconnectionTimer_),this.reconnectionTimer_=-1);}},{key:"startReconnection",value:function value(){var e=this.client_.getSubscriptionManager();if(e){var t,n=I(this.remoteStreams_.values());try{for(n.s();!(t=n.n()).done;){var i=t.value,r=i.getType();(r===zI&&(this.trackState_.audio||this.trackState_.video)||r===JI&&this.trackState_.auxiliary)&&e.setAutoRecoveryFlag(this.userId_,i.getType());}}catch(a){n.e(a);}finally{n.f();}}y(l(_.prototype),"startReconnection",this).call(this);}},{key:"getCurrentState",value:function value(){return this.currentState_;}},{key:"hasMainStream",value:function value(){return this.trackState_.video||this.trackState_.audio||this.trackState_.smallVideo;}},{key:"hasAuxStream",value:function value(){return this.trackState_.auxiliary;}}]),_;}(ZW),E(jz.prototype,"subscribe",[Fz],Object.getOwnPropertyDescriptor(jz.prototype,"subscribe"),jz.prototype),jz),Kz=function(){function e(){o(this,e),this.startTime=0,this.endTime=0,this.start();}return c(e,[{key:"start",value:function value(){0===this.startTime&&(this.startTime=vA());}},{key:"stop",value:function value(){0===this.endTime&&(this.endTime=vA());}},{key:"getDuration",value:function value(){return 0===this.endTime?vA()-this.startTime:this.endTime-this.startTime;}}]),e;}(),Qz=function(){function e(t){o(this,e),this.client_=t.client,this.intervalId_=-1,this.statsCalculator_=t.stats,this.prevStats_=null,this.renderFreezeMap_=new Map(),this.remoteStreamMap_=new Map(),this.dataFreezeMap_=new Map(),this.monitorFreezeData_=new Map();}var t,i,r;return c(e,[{key:"installEvents",value:function value(){DA.on(mx,this.handlePlayVideoStart,this),DA.on(lx,this.onVideoTrackMuted,this),DA.on(hx,this.onVideoTrackUnmuted,this),DA.on(ox,this.handleStreamStopped,this),DA.on(rx,this.handleStreamStopped,this),DA.on($A,this.handleVideoPlaying,this);}},{key:"uninstallEvents",value:function value(){DA.off(mx,this.handlePlayVideoStart,this),DA.off(lx,this.onVideoTrackMuted,this),DA.off(hx,this.onVideoTrackUnmuted,this),DA.off(ox,this.handleStreamStopped,this),DA.off(rx,this.handleStreamStopped,this),DA.off($A,this.handleVideoPlaying,this);}},{key:"start",value:function value(){var e=this;-1===this.intervalId_&&(this.installEvents(),this.intervalId_=KO.run(a(n().mark(function t(){return n().wrap(function(t){for(;;){switch(t.prev=t.next){case 0:return t.prev=0,t.next=3,e.detectFPS();case 3:t.next=7;break;case 5:t.prev=5,t.t0=t.catch(0);case 7:case"end":return t.stop();}}},t,null,[[0,5]]);})),{delay:1e3}));}},{key:"stop",value:function value(){-1!==this.intervalId_&&(this.uninstallEvents(),KO.clearTask(this.intervalId_),this.intervalId_=-1,this.renderFreezeMap_.clear(),this.dataFreezeMap_.clear(),this.remoteStreamMap_.clear());}},{key:"onVideoTrackMuted",value:function value(e){var t=e.stream;if(t.getClient()===this.client_&&t.isRemote()){var n=t.userId_,i=t.type_,r="".concat(n,"_").concat(i),a=this.dataFreezeMap_.get(r),o=new Kz();a?a.durationItemList.push(o):this.dataFreezeMap_.set(r,{userId:n,type:i,durationItemList:[o],isFreezing:function isFreezing(){var e=this.durationItemList[this.durationItemList.length-1];return e&&0===e.endTime;}});}}},{key:"onVideoTrackUnmuted",value:function value(e){var t=e.stream;if(t.getClient()===this.client_&&t.isRemote()){var n=t.userId_,i=t.type_,r="".concat(n,"_").concat(i);this.stopDataFreeze({key:r,userId:n,type:i});}}},{key:"handleStreamStopped",value:function value(e){var t=e.client,n=e.stream;if(t===this.client_){var i=n.getUserId(),r=n.getType(),a="".concat(i,"_").concat(r);this.stopDataFreeze({key:a,userId:i,type:r});}}},{key:"stopDataFreeze",value:function value(e){var t=e.key,n=e.userId,i=e.type,r=this.dataFreezeMap_.get(t);if(r&&r.isFreezing()){var a=r.durationItemList[r.durationItemList.length-1];a.stop();var o=a.getDuration();o>500?(nO.logEvent({eventType:"videoFrozenCount",delta:o}),this.monitorFreezeData_.set(t,{userId:n,type:i,duration:o})):r.durationItemList.pop();}}},{key:"getTotalDuration",value:function value(e){return e.reduce(function(e,t){var n=t.getDuration();return e+Math.min(n,5e3);},0);}},{key:"getStats",value:(r=a(n().mark(function e(){var t,i,r,a,o,s,c,u,d,l,h;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:t=this.client_.getConnections(),i={},r=I(t),e.prev=3,r.s();case 5:if((a=r.n()).done){e.next=20;break;}if(o=S(a.value,2),s=o[0],(c=o[1]).getPeerConnection()){e.next=9;break;}return e.abrupt("continue",18);case 9:return u=c.getSubscribeState(),d=c.getTrackState(),e.next=13,this.statsCalculator_.getReceiverStats(c);case 13:l=e.sent,(h={userId:l.userId,tinyId:s,hasVideo:d.video&&u.video,hasAuxiliary:d.auxiliary&&u.auxiliary,video:{framesDecoded:0},auxiliary:{framesDecoded:0}}).hasVideo&&(h.video.framesDecoded=l.video.framesDecoded),h.hasAuxiliary&&(h.auxiliary.framesDecoded=l.auxiliary.framesDecoded),i[l.userId]=h;case 18:e.next=5;break;case 20:e.next=25;break;case 22:e.prev=22,e.t0=e.catch(3),r.e(e.t0);case 25:return e.prev=25,r.f(),e.finish(25);case 28:return e.abrupt("return",i);case 29:case"end":return e.stop();}}},e,this,[[3,22,25,28]]);})),function(){return r.apply(this,arguments);})},{key:"detectFPS",value:(i=a(n().mark(function e(){var t,i,r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.next=2,this.getStats();case 2:if(t=e.sent,this.prevStats_){e.next=6;break;}return this.prevStats_=t,e.abrupt("return");case 6:e.t0=n().keys(t);case 7:if((e.t1=e.t0()).done){e.next=17;break;}if(i=e.t1.value,this.prevStats_[i]){e.next=11;break;}return e.abrupt("continue",7);case 11:r=t[i].tinyId,a=this.client_.getMutedStates(),t[i].hasVideo&&this.prevStats_[i].hasVideo&&a.has(r)&&!a.get(r).videoMuted&&(o=t[i].video.framesDecoded-this.prevStats_[i].video.framesDecoded,this.handleRenderFreeze({userId:i,type:zI,fps:o})),t[i].hasAuxiliary&&this.prevStats_[i].hasAuxiliary&&(s=t[i].auxiliary.framesDecoded-this.prevStats_[i].auxiliary.framesDecoded,this.handleRenderFreeze({userId:i,type:JI,fps:s})),e.next=7;break;case 17:this.prevStats_=t;case 18:case"end":return e.stop();}}},e,this);})),function(){return i.apply(this,arguments);})},{key:"handleRenderFreeze",value:(t=a(n().mark(function e(t){var i,r,a,o,s,c,u,d;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:i=t.userId,r=t.fps,a=t.type,o="".concat(i,"_").concat(a),s=this.renderFreezeMap_.get(o),r<=2?(c=vA(),s&&!s.isFreeze&&(s.freezeTimeline.push({startTime:c,endTime:void 0}),s.isFreeze=!0),s||this.renderFreezeMap_.set(o,{userId:i,type:a,isFreeze:!0,freezeTimeline:[{startTime:c,endTime:void 0}],renderFreezeTotal:0})):s&&s.isFreeze&&(s.isFreeze=!1,(u=s.freezeTimeline.pop()).endTime=vA(),d=u.endTime-u.startTime,s.freezeTimeline.push(u),s.renderFreezeTotal+=Math.min(5e3,d));case 4:case"end":return e.stop();}}},e,this);})),function(e){return t.apply(this,arguments);})},{key:"handlePlayVideoStart",value:function value(e){var t=e.stream;if(t.getClient()===this.client_&&t.isRemote()&&t.hasVideo()){var n="".concat(t.getUserId(),"_").concat(t.getType());this.remoteStreamMap_.has(n)||this.remoteStreamMap_.set(n,{isPlayingFired:!1});}}},{key:"handleVideoPlaying",value:function value(e){var t=e.stream;if(t.isRemote()&&t.getClient()===this.client_){var n="".concat(t.getUserId(),"_").concat(t.getType());if(this.remoteStreamMap_.has(n))this.remoteStreamMap_.get(n).isPlayingFired=!0;}}},{key:"getDataFreezeDuration",value:function value(e){var t={dataFreeze:0,count:0},n=this.dataFreezeMap_.get(e);if(n){if(n.isFreezing()){var i=n.durationItemList[n.durationItemList.length-1];i.stop(),i.getDuration()<500&&n.durationItemList.pop();}t.dataFreeze=this.getTotalDuration(n.durationItemList),t.count=n.durationItemList.length;}return t;}},{key:"getRenderFreezeDuration",value:function value(e){var t=this.renderFreezeMap_.get(e),n=0,i=0;if(t)if(t.isFreeze){var r=vA()-t.freezeTimeline[t.freezeTimeline.length-1].startTime;n=t.renderFreezeTotal+Math.min(r,5e3),i=t.freezeTimeline.length;}else n=t.renderFreezeTotal;return{renderFreeze:n,count:i};}},{key:"getMonitorFreeze",value:function value(){return this.monitorFreezeData_;}},{key:"isBlackStream",value:function value(e){return!!this.remoteStreamMap_.has(e)&&!this.remoteStreamMap_.get(e).isPlayingFired;}},{key:"resetMonitor",value:function value(){this.monitorFreezeData_.clear();}}]),e;}(),Xz=c(function e(t){o(this,e),this.userId=t.userId,this.tinyId=t.tinyId,this.role=t.role===VI?jI:BI;}),Yz={exports:{}};!function(e){!function(t){function n(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n;}function i(e,t,i,r,a,o){return n((s=n(n(t,e),n(r,o)))<<(c=a)|s>>>32-c,i);var s,c;}function r(e,t,n,r,a,o,s){return i(t&n|~t&r,e,t,a,o,s);}function a(e,t,n,r,a,o,s){return i(t&r|n&~r,e,t,a,o,s);}function o(e,t,n,r,a,o,s){return i(t^n^r,e,t,a,o,s);}function s(e,t,n,r,a,o,s){return i(n^(t|~r),e,t,a,o,s);}function c(e,t){var i,c,u,d,l;e[t>>5]|=128<<t%32,e[14+(t+64>>>9<<4)]=t;var h=1732584193,p=-271733879,f=-1732584194,m=271733878;for(i=0;i<e.length;i+=16){c=h,u=p,d=f,l=m,h=r(h,p,f,m,e[i],7,-680876936),m=r(m,h,p,f,e[i+1],12,-389564586),f=r(f,m,h,p,e[i+2],17,606105819),p=r(p,f,m,h,e[i+3],22,-1044525330),h=r(h,p,f,m,e[i+4],7,-176418897),m=r(m,h,p,f,e[i+5],12,1200080426),f=r(f,m,h,p,e[i+6],17,-1473231341),p=r(p,f,m,h,e[i+7],22,-45705983),h=r(h,p,f,m,e[i+8],7,1770035416),m=r(m,h,p,f,e[i+9],12,-1958414417),f=r(f,m,h,p,e[i+10],17,-42063),p=r(p,f,m,h,e[i+11],22,-1990404162),h=r(h,p,f,m,e[i+12],7,1804603682),m=r(m,h,p,f,e[i+13],12,-40341101),f=r(f,m,h,p,e[i+14],17,-1502002290),h=a(h,p=r(p,f,m,h,e[i+15],22,1236535329),f,m,e[i+1],5,-165796510),m=a(m,h,p,f,e[i+6],9,-1069501632),f=a(f,m,h,p,e[i+11],14,643717713),p=a(p,f,m,h,e[i],20,-373897302),h=a(h,p,f,m,e[i+5],5,-701558691),m=a(m,h,p,f,e[i+10],9,38016083),f=a(f,m,h,p,e[i+15],14,-660478335),p=a(p,f,m,h,e[i+4],20,-405537848),h=a(h,p,f,m,e[i+9],5,568446438),m=a(m,h,p,f,e[i+14],9,-1019803690),f=a(f,m,h,p,e[i+3],14,-187363961),p=a(p,f,m,h,e[i+8],20,1163531501),h=a(h,p,f,m,e[i+13],5,-1444681467),m=a(m,h,p,f,e[i+2],9,-51403784),f=a(f,m,h,p,e[i+7],14,1735328473),h=o(h,p=a(p,f,m,h,e[i+12],20,-1926607734),f,m,e[i+5],4,-378558),m=o(m,h,p,f,e[i+8],11,-2022574463),f=o(f,m,h,p,e[i+11],16,1839030562),p=o(p,f,m,h,e[i+14],23,-35309556),h=o(h,p,f,m,e[i+1],4,-1530992060),m=o(m,h,p,f,e[i+4],11,1272893353),f=o(f,m,h,p,e[i+7],16,-155497632),p=o(p,f,m,h,e[i+10],23,-1094730640),h=o(h,p,f,m,e[i+13],4,681279174),m=o(m,h,p,f,e[i],11,-358537222),f=o(f,m,h,p,e[i+3],16,-722521979),p=o(p,f,m,h,e[i+6],23,76029189),h=o(h,p,f,m,e[i+9],4,-640364487),m=o(m,h,p,f,e[i+12],11,-421815835),f=o(f,m,h,p,e[i+15],16,530742520),h=s(h,p=o(p,f,m,h,e[i+2],23,-995338651),f,m,e[i],6,-198630844),m=s(m,h,p,f,e[i+7],10,1126891415),f=s(f,m,h,p,e[i+14],15,-1416354905),p=s(p,f,m,h,e[i+5],21,-57434055),h=s(h,p,f,m,e[i+12],6,1700485571),m=s(m,h,p,f,e[i+3],10,-1894986606),f=s(f,m,h,p,e[i+10],15,-1051523),p=s(p,f,m,h,e[i+1],21,-2054922799),h=s(h,p,f,m,e[i+8],6,1873313359),m=s(m,h,p,f,e[i+15],10,-30611744),f=s(f,m,h,p,e[i+6],15,-1560198380),p=s(p,f,m,h,e[i+13],21,1309151649),h=s(h,p,f,m,e[i+4],6,-145523070),m=s(m,h,p,f,e[i+11],10,-1120210379),f=s(f,m,h,p,e[i+2],15,718787259),p=s(p,f,m,h,e[i+9],21,-343485551),h=n(h,c),p=n(p,u),f=n(f,d),m=n(m,l);}return[h,p,f,m];}function u(e){var t,n="",i=32*e.length;for(t=0;t<i;t+=8){n+=String.fromCharCode(e[t>>5]>>>t%32&255);}return n;}function d(e){var t,n=[];for(n[(e.length>>2)-1]=void 0,t=0;t<n.length;t+=1){n[t]=0;}var i=8*e.length;for(t=0;t<i;t+=8){n[t>>5]|=(255&e.charCodeAt(t/8))<<t%32;}return n;}function l(e){var t,n,i="0123456789abcdef",r="";for(n=0;n<e.length;n+=1){t=e.charCodeAt(n),r+=i.charAt(t>>>4&15)+i.charAt(15&t);}return r;}function h(e){return unescape(encodeURIComponent(e));}function p(e){return function(e){return u(c(d(e),8*e.length));}(h(e));}function f(e,t){return function(e,t){var n,i,r=d(e),a=[],o=[];for(a[15]=o[15]=void 0,r.length>16&&(r=c(r,8*e.length)),n=0;n<16;n+=1){a[n]=909522486^r[n],o[n]=1549556828^r[n];}return i=c(a.concat(d(t)),512+8*t.length),u(c(o.concat(i),640));}(h(e),h(t));}function m(e,t,n){return t?n?f(t,e):l(f(t,e)):n?p(e):l(p(e));}e.exports?e.exports=m:t.md5=m;}(w);}(Yz);var $z,Zz,eJ=Yz.exports,tJ=function(){function e(t){o(this,e),this.client_=t.client,this.signalChannel_=t.signalChannel,this.log_=xx.createLogger({id:"mix|"+this.client_.getUserId(),userId:t.client.getUserId(),sdkAppId:t.client.getSDKAppId()}),this.isMixing_=!1,this.config_=null,this.data_=null,this.remoteStreamMap_=new Map(),this.installEvents();}var t,i,r,s;return c(e,[{key:"isPresetLayoutMode",get:function get(){return this.config_&&this.config_.mode===LE.PRESET_LAYOUT;}},{key:"installEvents",value:function value(){DA.on(ix,this.onStreamSubscribed,this),DA.on(rx,this.onStreamUnsubscribed,this),this.client_.on("stream-removed",this.onStreamRemoved,this);}},{key:"uninstallEvents",value:function value(){DA.off(ix,this.onStreamSubscribed,this),DA.off(rx,this.onStreamUnsubscribed,this),this.client_.off("stream-removed",this.onStreamRemoved,this);}},{key:"reset",value:function value(){this.uninstallEvents(),this.isMixing_=!1,this.config_=null;}},{key:"onStreamSubscribed",value:function value(e){var t=e.client,n=e.stream;t===this.client_&&(this.remoteStreamMap_.set(n.getId(),{remoteStream:n,isUsed:!1}),this.isMixing_&&this.hasAvailablePlaceHolder()&&this.startMixTranscode(this.config_));}},{key:"onStreamUnsubscribed",value:function value(e){var t=e.client,n=e.stream;t===this.client_&&this.onStreamRemoved({stream:n});}},{key:"onStreamRemoved",value:function value(e){var t=e.stream;if(this.remoteStreamMap_.has(t.getId())){var n=this.remoteStreamMap_.get(t.getId()).isUsed;this.remoteStreamMap_.delete(t.getId()),this.isMixing_&&this.isPresetLayoutMode&&n&&this.startMixTranscode(this.config_);}}},{key:"startMixTranscode",value:(s=a(n().mark(function e(t){var i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(e.prev=0,this.resetIsUsedFlag(),this.config_=t,i=this.getInputParam(t,this.remoteStreamMap_),r=this.getOutputParam(t),a=this.getOutputSessionId({config:t,roomId:this.client_.getRoomId(),userId:this.client_.getUserId()}),!this.isMixing_||!this.data_||a===this.data_.outputSessionId){e.next=10;break;}return this.log_.info("startMixTranscode() streamId changed, stop mixing before start"),e.next=10,this.doStopMixTranscode();case 10:return e.next=12,this.doStartMixTranscode({outputSessionId:a,inputParam:i,outputParam:r});case 12:e.next=18;break;case 14:throw e.prev=14,e.t0=e.catch(0),this.resetIsUsedFlag(),e.t0;case 18:case"end":return e.stop();}}},e,this,[[0,14]]);})),function(e){return s.apply(this,arguments);})},{key:"doStartMixTranscode",value:(r=a(n().mark(function e(t){var i,r,a,o,s,c,u,d;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i=t.outputSessionId,r=t.inputParam,a=t.outputParam,o={roomId:String(this.client_.getRoomId()),mcuRequestTime:Date.now(),outputSessionId:i,inputParam:r,outputParam:a},this.data_=o,this.log_.info("startMixTranscode: ".concat(JSON.stringify(o))),this.isMixing_=!0,e.prev=5,e.next=8,this.signalChannel_.sendWaitForResponse({command:sD,data:o,timeout:5e3,responseCommand:zP.START_MIX_TRANSCODE_RES,commandDesc:"startMixTranscode"});case 8:if(s=e.sent,c=s.data,u=c.code,d=c.message,0===u){e.next=15;break;}throw-102083===u&&(d="Please enable relayed-push in ".concat(dw," and try later, refer to ").concat(hw,"tutorial-26-advanced-publish-cdn-stream.html")),this.log_.error("startMixTranscode failed, errCode: ".concat(u," errMsg: ").concat(d)),this.isMixing_=!1,new pD({code:hD.START_MIX_TRANSCODE_FAILED,message:ZC({key:sC,data:{message:d},link:{className:"Client",fnName:"startMixTranscode"}})});case 15:e.next=21;break;case 17:throw e.prev=17,e.t0=e.catch(5),this.isMixing_=!1,e.t0;case 21:case"end":return e.stop();}}},e,this,[[5,17]]);})),function(e){return r.apply(this,arguments);})},{key:"reStartMixTranscode",value:function value(){this.isMixing_&&this.startMixTranscode(this.config_);}},{key:"stopMixTranscode",value:(i=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.isMixing_){e.next=2;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:uC})});case 2:return e.next=4,this.doStopMixTranscode();case 4:this.resetIsUsedFlag();case 5:case"end":return e.stop();}}},e,this);})),function(){return i.apply(this,arguments);})},{key:"doStopMixTranscode",value:(t=a(n().mark(function e(){var t,i,r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return t={mcuRequestTime:Date.now(),outputSessionId:this.data_.outputSessionId,streamType:this.data_.outputParam.streamType},this.log_.info("stopMixTranscode: ".concat(JSON.stringify(t))),e.next=4,this.signalChannel_.sendWaitForResponse({command:cD,data:t,timeout:5e3,responseCommand:zP.STOP_MIX_TRANSCODE_RES,commandDesc:"stopMixTranscode"});case 4:if(i=e.sent,r=i.data,a=r.code,o=r.message,0!==a){e.next=10;break;}this.isMixing_=!1,e.next=12;break;case 10:throw this.log_.error("stopMixTranscode failed, errCode: ".concat(a," errMsg: ").concat(o)),new pD({code:hD.STOP_MIX_TRANSCODE_FAILED,message:ZC({key:cC,data:{message:o},link:{className:"Client",fnName:"stopMixTranscode"}})});case 12:case"end":return e.stop();}}},e,this);})),function(){return t.apply(this,arguments);})},{key:"getOutputSessionId",value:function value(e){var t=e.config,n=e.userId,i=e.roomId;return uA(t.streamId)&&t.streamId.length>0?t.streamId:eJ("".concat(i,"_").concat(n,"_main"));}},{key:"getInputParam",value:function value(e,t){var n=this,i=e.mixUsers.map(function(e){return{userId:e.userId,roomId:String(e.roomId||n.client_.getRoomId()),width:e.width||0,height:e.height||0,locationX:e.locationX||0,locationY:e.locationY||0,zOrder:e.zOrder,streamType:cA(e.streamType)||e.streamType!==JI?0:1,inputType:e.pureAudio?VE.IT_PURE_AUDIO:VE.IT_AUDIO_VIDEO,renderMode:e.renderMode||0};});return e.mode===LE.PRESET_LAYOUT&&(i.forEach(function(e){if(e.userId===UE.REMOTE){var n=k(t.values()).find(function(e){return!e.isUsed;});n&&(e.userId=n.remoteStream.getUserId(),e.streamType=n.remoteStream.getType()===JI?1:0,n.isUsed=!0);}}),i=i.filter(function(e){return e.userId!==UE.REMOTE;})),i;}},{key:"getOutputParam",value:function value(e){var t=e.streamId||"";return{streamId:t,streamType:t.length>0?1:0,width:cA(e.videoWidth)?640:e.videoWidth,height:cA(e.videoHeight)?480:e.videoHeight,videoBps:e.videoBitrate||0,fps:e.videoFramerate||15,gop:e.videoGOP||2,audioSampleRate:e.audioSampleRate||48e3,audioBps:e.audioBitrate||64,audioChannels:e.audioChannels||1,backgroundColor:e.backgroundColor||0,backgroundImg:e.backgroundImage||"",extraInfo:"",videoCodec:2,audioCodec:0};}},{key:"hasAvailablePlaceHolder",value:function value(){return!!this.isPresetLayoutMode&&this.data_.inputParam.length!==this.config_.mixUsers.length;}},{key:"resetIsUsedFlag",value:function value(){this.remoteStreamMap_.forEach(function(e){return e.isUsed=!1;});}}]),e;}(),nJ=function(){function e(t){o(this,e),this.client_=t.client,this.signalChannel_=t.signalChannel,this.publishTencentMainStreamObj_={params_:null,streamId_:void 0,isPublishing_:!1},this.publishTencentAuxStreamObj_={params_:null,streamId_:void 0,isPublishing_:!1},this.publishGivenCDNData_=null,this.isPublishingGivenCDN_=!1;}var t,i,r,s,u,d;return c(e,[{key:"setSignalChannel",value:function value(e){this.signalChannel_=e.signalChannel;}},{key:"getIsPublishingTencentCDN",value:function value(){return this.publishTencentMainStreamObj_.isPublishing_||this.publishTencentAuxStreamObj_.isPublishing_;}},{key:"getIsPublishingGivenCDN",value:function value(){return this.isPublishingGivenCDN_;}},{key:"generatePublishCDNStreamId",value:function value(e,t){if(!e){var n="".concat(this.client_.getRoomId(),"_").concat(this.client_.getUserId(),"_").concat(t);return /^[A-Za-z\d_-]*$/.test(n)||(n=eJ(n)),"".concat(this.client_.getSDKAppId(),"_").concat(n);}return e;}},{key:"generatePublishCDNSessionId",value:function value(e){return eJ("".concat(this.client_.getRoomId(),"_").concat(this.client_.getUserId(),"_").concat(e));}},{key:"startPublishTencentCDN",value:(d=a(n().mark(function e(t){var i,r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(t.streamType===qT?(this.publishTencentAuxStreamObj_.params_=t,this.publishTencentAuxStreamObj_.isPublishing_=!0):(this.publishTencentMainStreamObj_.params_=t,this.publishTencentMainStreamObj_.isPublishing_=!0),this.client_.isJoined_){e.next=3;break;}return e.abrupt("return");case 3:return i=this.generatePublishCDNStreamId(t.streamId,t.streamType),r=this.generatePublishCDNSessionId(t.streamType),a=t.streamType===qT?1:0,o={requestTime:Date.now(),sessionId:r,streamId:i,streamType:a},e.next=9,this.doStartPublishTencentCDN(o,t.streamType);case 9:case"end":return e.stop();}}},e,this);})),function(e){return d.apply(this,arguments);})},{key:"doStartPublishTencentCDN",value:(u=a(n().mark(function e(t,i){var r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,xx.info("startPublishTencentCDN: "+JSON.stringify(t)),e.next=4,this.signalChannel_.sendWaitForResponseWithRetry({command:iD,data:t,timeout:2e3,responseCommand:zP.START_PUBLISH_TENCENT_CDN_RES,commandDesc:"startPublishCDNStream",retries:2});case 4:if(r=e.sent,a=r.data,o=a.code,s=a.message,0!==o){e.next=10;break;}i===qT?this.publishTencentAuxStreamObj_.streamId_=t.streamId:this.publishTencentMainStreamObj_.streamId_=t.streamId,e.next=14;break;case 10:throw i===qT?this.publishTencentAuxStreamObj_.isPublishing_=!1:this.publishTencentMainStreamObj_.isPublishing_=!1,-102083===o&&(s="Please enable relayed-push in ".concat(dw," and try later, refer to ").concat(hw,"tutorial-26-advanced-publish-cdn-stream.html")),xx.error("startPublishTencentCDN failed, errCode: ".concat(o,", errMsg: ").concat(s)),new pD({code:hD.START_PUBLISH_CDN_FAILED,message:ZC({key:OR,data:{message:s},link:{className:"Client",fnName:"startPublishCDNStream"}})});case 14:e.next=20;break;case 16:throw e.prev=16,e.t0=e.catch(0),i===qT?this.publishTencentAuxStreamObj_.isPublishing_=!1:this.publishTencentMainStreamObj_.isPublishing_=!1,e.t0;case 20:case"end":return e.stop();}}},e,this,[[0,16]]);})),function(e,t){return u.apply(this,arguments);})},{key:"resetPublishTencentParam",value:function value(e){e===cI&&(this.publishTencentMainStreamObj_={params_:null,streamId_:void 0,isPublishing_:!1}),e===qT&&(this.publishTencentAuxStreamObj_={params_:null,streamId_:void 0,isPublishing_:!1});}},{key:"stopPublishTencentCDN",value:(s=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.client_.isJoined_){e.next=4;break;}return this.resetPublishTencentParam(cI),this.resetPublishTencentParam(qT),e.abrupt("return");case 4:if(!this.publishTencentMainStreamObj_.isPublishing_){e.next=7;break;}return e.next=7,this.doStopPublishTencentCDN(cI);case 7:if(!this.publishTencentAuxStreamObj_.isPublishing_){e.next=10;break;}return e.next=10,this.doStopPublishTencentCDN(qT);case 10:case"end":return e.stop();}}},e,this);})),function(){return s.apply(this,arguments);})},{key:"doStopPublishTencentCDN",value:(r=a(n().mark(function e(t){var i,r,a,o,s;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i={requestTime:Date.now(),sessionId:eJ("".concat(this.client_.getRoomId(),"_").concat(this.client_.getUserId(),"_").concat(t))},xx.info("stopPublishTencentCDN: "+JSON.stringify(i)),e.next=4,this.signalChannel_.sendWaitForResponse({command:rD,data:i,timeout:5e3,responseCommand:zP.STOP_PUBLISH_TENCENT_CDN_RES,commandDesc:"stopPublishCDNStream"});case 4:if(r=e.sent,a=r.data,o=a.code,s=a.message,0!==o){e.next=10;break;}this.resetPublishTencentParam(t),e.next=17;break;case 10:if(-102069!==o){e.next=15;break;}xx.warn("stopPublishTencentCDN failed, can not stopPublishTencentCDN in auto relayed-push mode"),this.resetPublishTencentParam(t),e.next=17;break;case 15:throw xx.error("stopPublishTencentCDN failed, errCode: ".concat(o," errMsg: ").concat(s)),new pD({code:hD.STOP_PUBLISH_CDN_FAILED,message:ZC({key:NR,data:{message:s},link:{className:"Client",fnName:"stopPublishCDNStream"}})});case 17:case"end":return e.stop();}}},e,this);})),function(e){return r.apply(this,arguments);})},{key:"startPublishGivenCDN",value:(i=a(n().mark(function e(t){var i,r,a,o,s,c;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(i=t.streamType===cI?this.publishTencentMainStreamObj_.streamId_:this.publishTencentAuxStreamObj_.streamId_,r={pushRequestTime:Date.now(),pushAppId:t.appId,pushBizId:t.bizId,pushCdnUrl:t.url,pushStreamType:t.streamType,pushStreamId:i},xx.info("startPublishGivenCDN: "+JSON.stringify(r)),this.publishGivenCDNData_=r,this.isPublishingGivenCDN_=!0,this.client_.isJoined_){e.next=7;break;}return e.abrupt("return");case 7:return e.prev=7,e.next=10,this.signalChannel_.sendWaitForResponse({command:aD,data:r,timeout:5e3,responseCommand:zP.START_PUBLISH_GIVEN_CDN_RES,commandDesc:"startPublishCDNStream"});case 10:if(a=e.sent,o=a.data,s=o.code,c=o.message,0===s){e.next=17;break;}throw xx.error("startPublishGivenCDN failed, errCode: ".concat(s,", errMsg: ").concat(c)),this.publishGivenCDNData_=null,this.isPublishingGivenCDN_=!1,new pD({code:hD.START_PUBLISH_CDN_FAILED,message:ZC({key:OR,data:{message:c},link:{className:"Client",fnName:"startPublishCDNStream"}})});case 17:e.next=24;break;case 19:throw e.prev=19,e.t0=e.catch(7),this.publishGivenCDNData_=null,this.isPublishingGivenCDN_=!1,e.t0;case 24:case"end":return e.stop();}}},e,this,[[7,19]]);})),function(e){return i.apply(this,arguments);})},{key:"stopPublishGivenCDN",value:(t=a(n().mark(function e(){var t,i,r,a,o,s,c,u,d,l;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.client_.isJoined_){e.next=4;break;}return this.publishGivenCDNData_=null,this.isPublishingGivenCDN_=!1,e.abrupt("return");case 4:return t=this.publishGivenCDNData_,i=t.pushAppId,r=t.pushBizId,a=t.pushCdnUrl,o=t.pushStreamType,s={pushRequestTime:Date.now(),pushAppId:i,pushBizId:r,pushCdnUrl:a,pushStreamType:o},xx.info("stopPublishGivenCDN: "+JSON.stringify(s)),e.next=9,this.signalChannel_.sendWaitForResponse({command:oD,data:s,timeout:5e3,responseCommand:zP.STOP_PUBLISH_GIVEN_CDN_RES,commandDesc:"stopPublishCDNStream"});case 9:if(c=e.sent,u=c.data,d=u.code,l=u.message,0!==d){e.next=16;break;}this.publishGivenCDNData_=null,this.isPublishingGivenCDN_=!1,e.next=18;break;case 16:throw xx.error("stopPublishGivenCDN failed, errCode: ".concat(d," errMsg: ").concat(l)),new pD({code:hD.STOP_PUBLISH_CDN_FAILED,message:ZC({key:NR,data:{message:l},link:{className:"Client",fnName:"stopPublishCDNStream"}})});case 18:case"end":return e.stop();}}},e,this);})),function(){return t.apply(this,arguments);})},{key:"handleCDNConfigForJoinData",value:function value(e){var t,n=e;if(this.publishTencentMainStreamObj_.isPublishing_||this.publishTencentAuxStreamObj_.isPublishing_){var i={};uA(n)&&(i=JSON.parse(n)),i.Str_uc_params||(i.Str_uc_params={}),this.publishTencentMainStreamObj_.isPublishing_&&(this.publishTencentMainStreamObj_.streamId_?i.Str_uc_params.userdefine_streamid_main=this.publishTencentMainStreamObj_.streamId_:this.publishTencentMainStreamObj_.params_&&(i.Str_uc_params.userdefine_streamid_main=this.generatePublishCDNStreamId(this.publishTencentMainStreamObj_.params_.streamId,cI))),this.publishTencentAuxStreamObj_.isPublishing_&&(this.publishTencentAuxStreamObj_.streamId_?i.Str_uc_params.userdefine_streamid_aux=this.publishTencentAuxStreamObj_.streamId_:this.publishTencentAuxStreamObj_.params_&&(i.Str_uc_params.userdefine_streamid_aux=this.generatePublishCDNStreamId(this.publishTencentAuxStreamObj_.params_.streamId,qT))),n=JSON.stringify(i);}if(this.isPublishingGivenCDN_){var r=this.publishGivenCDNData_,a=r.pushAppId,o=r.pushBizId,s=r.pushCdnUrl,c=r.pushStreamType,u=r.pushStreamId;t={pushRequestTime:Date.now(),pushAppId:a,pushBizId:o,pushCdnUrl:s,pushStreamType:c,pushStreamId:u};}return{bussinessInfo:n,pushUserCdnInfo:t};}},{key:"reset",value:function value(){this.resetPublishTencentParam(cI),this.resetPublishTencentParam(qT),this.publishGivenCDNData_=null,this.isPublishingGivenCDN_=!1;}}]),e;}(),iJ=function(){function e(t){o(this,e),this.client_=t.client,this.durationMap_=new Map(),this.installEvents();}return c(e,[{key:"installEvents",value:function value(){DA.on(ix,this.handleSubscribed,this),DA.on(ex,this.handleStreamTrackUpdated,this),DA.on(rx,this.handleStreamStopped,this),DA.on(ox,this.handleStreamStopped,this);}},{key:"uninstallEvents",value:function value(){DA.off(ix,this.handleSubscribed,this),DA.off(ex,this.handleStreamTrackUpdated,this),DA.off(rx,this.handleStreamStopped,this),DA.off(ox,this.handleStreamStopped,this);}},{key:"handleSubscribed",value:function value(e){var t=e.client,n=e.stream;if(t===this.client_){var i=n.getUserId(),r=n.getType(),a="".concat(i,"_").concat(r);if(n.hasAudio())if(n.isMainAudioSubscribed){var o=new Kz(),s=this.durationMap_.get(a);s?this.isRecording(s.audio)||s.audio.push(o):this.durationMap_.set(a,{userId:i,type:r,audio:[o],video:[]});}else this.stopDurationItem(a,BT);if(n.hasVideo())if(r===zI&&n.isMainVideoSubscribed||r===JI&&n.isAuxVideoSubscribed){var c=new Kz(),u=this.durationMap_.get(a);u?this.isRecording(u.video)||u.video.push(c):this.durationMap_.set(a,{userId:i,type:r,audio:[],video:[c]});}else this.stopDurationItem(a,HT);}}},{key:"handleStreamStopped",value:function value(e){var t=e.client,n=e.stream;if(this.clientHitTest(t)){var i=n.getUserId(),r=n.getType(),a="".concat(i,"_").concat(r);this.stopDurationItem(a,BT),this.stopDurationItem(a,HT);}}},{key:"handleStreamTrackUpdated",value:function value(e){var t=e.client,n=e.userId,i=e.tinyId,r=e.kind,a=e.action;if(this.clientHitTest(t)&&this.client_.getConnections().has(i)){var o=r===JT?r:zI,s="".concat(n,"_").concat(o);if(a===WE.ADD){var c=this.client_.getConnections().get(i).getSubscribeState();if(r===BT&&!c.audio||r===HT&&!c.video||r===JT&&!c.auxiliary)return;var u=new Kz(),d=this.durationMap_.get(s);d?(r!==BT||this.isRecording(d.audio)||d.audio.push(u),r===BT||this.isRecording(d.video)||d.video.push(u)):this.durationMap_.set(s,{userId:n,type:o,audio:r===BT?[u]:[],video:r===BT?[]:[u]});}else this.stopDurationItem(s,r===BT?BT:HT);}}},{key:"isRecording",value:function value(e){return e.findIndex(function(e){return 0===e.endTime;})>=0;}},{key:"stopDurationItem",value:function value(e,t){if(this.durationMap_.has(e)){var n=this.durationMap_.get(e)[t].find(function(e){return 0===e.endTime;});n&&n.stop();}}},{key:"clientHitTest",value:function value(e){return this.client_===e;}},{key:"getDuration",value:function value(e,t){return this.durationMap_.has(e)?this.durationMap_.get(e)[t].reduce(function(e,t){return e+t.getDuration();},0):0;}},{key:"getDurationMap",value:function value(){return this.durationMap_;}},{key:"reset",value:function value(){this.durationMap_.clear();}},{key:"destroy",value:function value(){this.client_=null,this.uninstallEvents();}}]),e;}(),rJ=Ir,aJ=x,oJ=Fc.f;rJ({target:"Object",stat:!0,forced:aJ(function(){return!Object.getOwnPropertyNames(1);})},{getOwnPropertyNames:oJ});var sJ=5e3,cJ={msg_user_info:0,uint32_video_avg_fps:0,uint32_video_width:0,uint32_video_height:0,uint32_video_avg_bitrate:0,uint32_video_block_time:0,uint32_video_play_time:0,uint32_audio_block_time:0,uint32_audio_play_time:0,uint32_audio_play_db:0,uint32_avg_down_loss:0,uint32_stream_type:0,uint32_video_render_first:0,uint32_video_block_count:0,uint32_audio_block_count:0,uint32_audio_bitrate:0,uint32_video_black_screen_subjective:0,uint32_audio_recv_bitrate:0,uint32_video_external_block_time:0},uJ=c(function e(t){o(this,e),this.str_identifier=String(t.userId),this.uint64_tinyid=Number(t.tinyId),this.uint32_role=t.role;}),dJ=($z=kz({timeout:500,retries:3}),Zz=function(){function e(t){var i=this;o(this,e),this.frameWorkType_=t.frameWorkType||30,this.component_=t.component||0,this.client_=t.client,this.keyPrefix_="key_point",this.storageKey_="".concat(this.keyPrefix_,"_").concat(this.client_.getUserId()),this.log_=xx.createLogger({id:"kpm|"+this.client_.getUserId(),userId:this.client_.getUserId(),sdkAppId:this.client_.getSDKAppId()}),Object.getOwnPropertyNames(this.__proto__).forEach(function(e){e.startsWith("handle")&&sA(i[e])&&(i[e]=function(e){var t=e.fn,i=e.context;return a(n().mark(function e(){var r,a,o,s=arguments;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:for(e.prev=0,r=s.length,a=new Array(r),o=0;o<r;o++){a[o]=s[o];}return e.next=4,t.apply(i||this,a);case 4:return e.abrupt("return",e.sent);case 7:e.prev=7,e.t0=e.catch(0),xx.error("".concat(t.name,"() error observed ")+e.t0);case 10:case"end":return e.stop();}}},e,this,[[0,7]]);}));}({fn:i[e],context:i}));}),this.initData(),this.installEvents(),this.intervalId_=KO.run(Sw,this.setStorage.bind(this),{delay:2e4});}var i,r,s;return c(e,[{key:"initData",value:function value(){this.firstPublishedUserList_=[],this.networkQuality_={totalUplinkRTT:0,totalUplinkLoss:0,count:0,totalDownlinkRTTAndLossMap:new Map()},this.basicInfo={string_sdk_version:Bo,uint32_os_type:15,string_device_name:"",string_http_user_agent:navigator.userAgent,string_os_version:"",uint32_avg_rtt:0,uint32_avg_up_loss:0,uint32_scene:"live"===this.client_.getMode()?1:0,uint32_joining_duration:0,uint32_networkType:zE[iA()],uint32_framework:this.frameWorkType_,uint32_component:this.component_},this.pathJoinRoom_={uint64_start_time:0,uint64_init_audio_start_time:0,uint64_init_audio_end_time:0,uint64_init_camera_start_time:0,uint64_init_camera_end_time:0,uint64_send_request_acc_ip_cmd_start_time:0,uint64_send_request_acc_ip_cmd_end_time:0,uint64_send_request_enter_room_cmd_start_time:0,uint64_send_request_enter_room_cmd_end_time:0,uint64_send_first_video_frame_time:0,uint64_recv_userlist_time:0,uint64_end_time:0,int32_init_audio_ret:0,int32_init_camera_ret:0,int32_send_request_acc_ip_cmd_ret:0,int32_send_request_enter_room_cmd_ret:0,int32_end_ret:0},this.pathLeaveRoom_={uint64_start_time:0,uint64_send_request_exit_room_cmd_start_time:0,uint64_send_request_exit_room_cmd_end_time:0,uint64_end_time:0,int32_send_request_exit_room_cmd_ret:0,int32_end_ret:0},this.pathMainVideoMap_=new Map(),this.pathMainAudioMap_=new Map(),this.pathAuxiliaryMap_=new Map(),this.localStreamStats_={totalVideoBitrate:0,totalVideoFPS:0,totalVideoHeight:0,totalVideoWidth:0,totalAudioLevel:0,videoCount:0,audioLevelCount:0,publishStartTime:0,statsToReport:{uint32_audio_capture_db:0,uint32_video_big_capture_fps:0,uint32_video_big_bitrate:0,uint32_video_big_resolution:0}},this.remoteStreamStatsMap_=new Map();}},{key:"installEvents",value:function value(){DA.on(OA,this.handleJoinStart,this),DA.on(WA,this.handleWSStart,this),DA.on(zA,this.handleWSEnd,this),DA.on(NA,this.handleJoinSendCMD,this),DA.on(MA,this.handleJoinReceivedCMDResponce,this),DA.on(LA,this.handleJoinSuccess,this),DA.on(UA,this.handleJoinFailed,this),DA.on(HA,this.handleReceivedPublishUserList,this),DA.on(yx,this.handleConnectionStateChanged,this),DA.on(VA,this.handleLeaveStart,this),DA.on(jA,this.handleLeaveSuccess,this),DA.on(FA,this.handleLeaveSendCMD,this),DA.on(Sx,this.handleSendSubscribeCMD,this),DA.on($A,this.handleVideoPlaying,this),DA.on(ZA,this.handleAudioPlaying,this),DA.on(kx,this.handleNetworkQuality,this),DA.on(BA,this.handleHeartbeatStats,this),DA.on(tx,this.handleRemoteStreamAdded,this),DA.on(nx,this.handleRemoteStreamSubscribeStart,this),DA.on(ix,this.handleRemoteStreamSubscribed,this),DA.on(ox,this.handleRemoteStreamRemoved,this),DA.on(fx,this.handleVideoLoadedData,this),DA.on(px,this.handlePlayStream,this),DA.on(GA,this.handlePublishStart,this),DA.on(cx,this.handleLocalStreamInitStart,this),DA.on(ux,this.handleLocalStreamInitEnd,this),DA.on(dx,this.handleLocalStreamInitFailed,this);}},{key:"uninstallEvents",value:function value(){DA.off(OA,this.handleJoinStart,this),DA.off(WA,this.handleWSStart,this),DA.off(zA,this.handleWSEnd,this),DA.off(NA,this.handleJoinSendCMD,this),DA.off(MA,this.handleJoinReceivedCMDResponce,this),DA.off(HA,this.handleReceivedPublishUserList,this),DA.off(yx,this.handleConnectionStateChanged,this),DA.off(VA,this.handleLeaveStart,this),DA.off(jA,this.handleLeaveSuccess,this),DA.off(LA,this.handleJoinSuccess,this),DA.off(UA,this.handleJoinFailed,this),DA.off(FA,this.handleLeaveSendCMD,this),DA.off(Sx,this.handleSendSubscribeCMD,this),DA.off($A,this.handleVideoPlaying,this),DA.off(ZA,this.handleAudioPlaying,this),DA.off(kx,this.handleNetworkQuality,this),DA.off(BA,this.handleHeartbeatStats,this),DA.off(tx,this.handleRemoteStreamAdded,this),DA.off(nx,this.handleRemoteStreamSubscribeStart,this),DA.off(ix,this.handleRemoteStreamSubscribed,this),DA.off(ox,this.handleRemoteStreamRemoved,this),DA.off(fx,this.handleVideoLoadedData,this),DA.off(px,this.handlePlayStream,this),DA.off(GA,this.handlePublishStart,this),DA.off(cx,this.handleLocalStreamInitStart,this),DA.off(ux,this.handleLocalStreamInitEnd,this),DA.off(dx,this.handleLocalStreamInitFailed,this);}},{key:"destroy",value:function value(){this.uninstallEvents(),KO.clearTask(this.intervalId_),this.client_=null;}},{key:"handleJoinStart",value:function value(e){this.hitTest(e.client)&&0===this.pathJoinRoom_.uint64_start_time&&(this.pathJoinRoom_.uint64_start_time=Date.now(),this.checkStorage());}},{key:"handleWSStart",value:function value(e){var t=e.client;this.hitTest(t)&&0===this.pathJoinRoom_.uint64_send_request_acc_ip_cmd_start_time&&(this.pathJoinRoom_.uint64_send_request_acc_ip_cmd_start_time=Date.now());}},{key:"handleWSEnd",value:function value(e){var t=e.client,n=e.error;this.hitTest(t)&&0===this.pathJoinRoom_.uint64_send_request_acc_ip_cmd_end_time&&(this.pathJoinRoom_.uint64_send_request_acc_ip_cmd_end_time=Date.now(),n&&(this.pathJoinRoom_.int32_send_request_acc_ip_cmd_ret=n instanceof pD?Number(n.getExtraCode()||n.getCode()):hD.UNKNOWN,this.pathJoinRoom_.int32_end_ret=2));}},{key:"handleJoinSendCMD",value:function value(e){this.hitTest(e.client)&&0===this.pathJoinRoom_.uint64_send_request_enter_room_cmd_start_time&&(this.pathJoinRoom_.uint64_send_request_enter_room_cmd_start_time=Date.now());}},{key:"handleJoinReceivedCMDResponce",value:function value(e){this.hitTest(e.client)&&0===this.pathJoinRoom_.uint64_send_request_enter_room_cmd_end_time&&(this.pathJoinRoom_.uint64_send_request_enter_room_cmd_end_time=Date.now(),this.pathJoinRoom_.int32_send_request_enter_room_cmd_ret=e.code,0!==e.code&&(this.pathJoinRoom_.int32_end_ret=3));}},{key:"handleJoinSuccess",value:function value(e){this.hitTest(e.client)&&0===this.pathJoinRoom_.uint64_end_time&&(this.pathJoinRoom_.uint64_end_time=Date.now(),this.pathJoinRoom_.int32_end_ret=0);}},{key:"handleJoinFailed",value:function value(e){var t=e.client;this.hitTest(t)&&(this.pathJoinRoom_.uint64_end_time=Date.now(),0===this.pathJoinRoom_.int32_end_ret&&(this.pathJoinRoom_.int32_end_ret=3),this.prepareReport(),this.report());}},{key:"handleReceivedPublishUserList",value:function value(e){this.hitTest(e.client)&&0===this.pathJoinRoom_.uint64_recv_userlist_time&&(this.pathJoinRoom_.uint64_recv_userlist_time=Date.now(),this.firstPublishedUserList_=e.data.data&&e.data.data.userList||[]);}},{key:"handleConnectionStateChanged",value:function value(e){var t=e.client,n=e.state,i=e.connection;if(this.hitTest(t)&&n===YI){this.client_.getUplinkConnection()===i&&0===this.pathJoinRoom_.uint64_send_first_video_frame_time&&this.localStreamStats_.publishStartTime>this.pathJoinRoom_.uint64_end_time&&this.localStreamStats_.publishStartTime-this.pathJoinRoom_.uint64_end_time<=100&&(this.pathJoinRoom_.uint64_send_first_video_frame_time=Date.now());var r=this.pathMainVideoMap_.get("".concat(i.getUserId(),"_").concat(zI));r&&0===r.statsToReport.uint64_pc_connected_time&&(r.statsToReport.uint64_pc_connected_time=Date.now());}}},{key:"handleLeaveStart",value:function value(e){this.hitTest(e.client)&&(this.pathLeaveRoom_.uint64_start_time=Date.now());}},{key:"handleLeaveSuccess",value:function value(e){this.hitTest(e.client)&&0===this.pathLeaveRoom_.uint64_end_time&&(this.pathLeaveRoom_.uint64_end_time=Date.now(),0!==this.pathJoinRoom_.uint64_end_time?this.basicInfo.uint32_joining_duration=this.pathLeaveRoom_.uint64_end_time-this.pathJoinRoom_.uint64_end_time:this.log_.warn("pathJoinRoom endTime is 0"),this.report());}},{key:"handleLeaveSendCMD",value:function value(e){this.hitTest(e.client)&&(this.pathLeaveRoom_.uint64_send_request_exit_room_cmd_start_time=Date.now(),this.pathLeaveRoom_.uint64_send_request_exit_room_cmd_end_time=Date.now());}},{key:"handleRemoteStreamAdded",value:function value(e){var n=e.client,i=e.stream;if(this.hitTest(n)){var r=i.getUserId(),a=i.getType(),o="".concat(r,"_").concat(a),s=this.remoteStreamStatsMap_.get(o);if(s)s.stream=i;else{var c={userId:r,totalVideoFPS:0,totalVideoBitrate:0,totalAudioLevel:0,totalAudioBitrate:0,totalLoss:0,audioCount:0,audioLevelCount:0,videoCount:0,networkQualityCount:0,streamAddedTime:Date.now(),subscribeStartTime:0,subscribedTime:0,playStreamTime:0,statsToReport:t({},cJ),stream:i};c.statsToReport.msg_user_info=new uJ({userId:r,tinyId:i.getTinyId(),role:VI}),c.statsToReport.uint32_stream_type=a===zI?2:7,this.remoteStreamStatsMap_.set(o,c);}}}},{key:"handleRemoteStreamSubscribeStart",value:function value(e){var t=e.client,n=e.stream;if(this.hitTest(t)){var i=n.getUserId(),r=n.getType(),a="".concat(i,"_").concat(r),o=this.remoteStreamStatsMap_.get(a);o&&0===o.subscribeStartTime&&(o.subscribeStartTime=Date.now());}}},{key:"handleSendSubscribeCMD",value:function value(e){if(this.hitTest(e.client)){var t=new uJ(e),n=Date.now(),i="".concat(e.userId,"_").concat(zI);e.trackState.video&&e.subscribeState.video&&!this.pathMainVideoMap_.has(i)&&this.pathMainVideoMap_.set(i,{statsToReport:{msg_user_info:t,uint64_start_enter_time:this.pathJoinRoom_.uint64_start_time,uint64_render_first_frame_time:0,uint64_combine_first_frame_time:0,uint64_pc_connected_time:0},userId:e.userId,sendSubscribeCMDTime:n}),e.trackState.audio&&e.subscribeState.audio&&!this.pathMainAudioMap_.has(i)&&this.pathMainAudioMap_.set(i,{statsToReport:{msg_user_info:t,uint64_start_enter_time:this.pathJoinRoom_.uint64_start_time,uint64_play_first_frame_time:0},userId:e.userId,sendSubscribeCMDTime:n});var r="".concat(e.userId,"_").concat(JI);e.trackState.auxiliary&&e.subscribeState.auxiliary&&!this.pathAuxiliaryMap_.has(r)&&this.pathAuxiliaryMap_.set(r,{sendSubscribeCMDTime:n});}}},{key:"handleRemoteStreamSubscribed",value:function value(e){var t=e.client,n=e.stream;if(this.hitTest(t)){var i=n.getUserId(),r=n.getType(),a="".concat(i,"_").concat(r),o=this.remoteStreamStatsMap_.get(a);o&&0===o.subscribedTime&&(o.subscribedTime=Date.now(),o.stream=n);}}},{key:"handleRemoteStreamRemoved",value:function value(e){var t=e.client,n=e.stream;if(this.hitTest(t)){var i=n.getUserId(),r=n.getType(),a=this.remoteStreamStatsMap_.get("".concat(i,"_").concat(r));a&&(a.stream=null);}}},{key:"handlePlayStream",value:function value(e){var t=e.stream;if(t.isRemote()&&t.getConnection()&&this.hitTest(t.getConnection().getClient())){var n=t.getConnection().getUserId(),i="".concat(n,"_").concat(t.getType());if(this.remoteStreamStatsMap_.has(i)){var r=this.remoteStreamStatsMap_.get(i);0===r.playStreamTime&&(r.playStreamTime=Date.now());}}}},{key:"handleVideoLoadedData",value:function value(e){var t=e.stream;if(t.isRemote()&&t.getConnection()&&this.hitTest(t.getConnection().getClient())){var n=t.getConnection().getUserId(),i="".concat(n,"_").concat(t.getType());if(this.pathMainVideoMap_.has(i)){var r=this.pathMainVideoMap_.get(i);0===r.statsToReport.uint64_combine_first_frame_time&&(r.statsToReport.uint64_combine_first_frame_time=Date.now());}}}},{key:"handleVideoPlaying",value:function value(e){var t=e.stream;if(t.isRemote()&&t.getConnection()&&this.hitTest(t.getConnection().getClient())){var n=t.getConnection().getUserId(),i="".concat(n,"_").concat(t.getType()),r=Date.now();if(this.pathMainVideoMap_.has(i)){var a=this.pathMainVideoMap_.get(i);if(0===a.statsToReport.uint64_render_first_frame_time&&(a.statsToReport.uint64_render_first_frame_time=r),this.remoteStreamStatsMap_.has(i)){var o=this.remoteStreamStatsMap_.get(i),s=o.statsToReport,c=o.playStreamTime,u=o.subscribedTime;0===s.uint32_video_render_first&&c-u<=100&&(s.uint32_video_render_first=r-a.sendSubscribeCMDTime);}}if(t.getType()===JI&&this.pathAuxiliaryMap_.has(i)&&this.remoteStreamStatsMap_.has(i)){var d=this.remoteStreamStatsMap_.get(i),l=d.statsToReport,h=d.playStreamTime,p=d.subscribedTime;0===l.uint32_video_render_first&&h-p<=100&&(l.uint32_video_render_first=r-this.pathAuxiliaryMap_.get(i).sendSubscribeCMDTime);}}}},{key:"handleAudioPlaying",value:function value(e){if(e.stream.isRemote()&&e.stream.getConnection()&&this.hitTest(e.stream.getConnection().getClient())){var t=e.stream.getConnection().getUserId(),n="".concat(t,"_").concat(e.stream.getType());if(this.pathMainAudioMap_.has(n)){var i=this.pathMainAudioMap_.get(n);0===i.statsToReport.uint64_play_first_frame_time&&(i.statsToReport.uint64_play_first_frame_time=Date.now());}}}},{key:"handleNetworkQuality",value:function value(e){var t=this;this.hitTest(e.client)&&(this.networkQuality_.totalUplinkLoss+=e.uplinkLoss,this.networkQuality_.totalUplinkRTT+=e.uplinkRTT,this.networkQuality_.count++,e.downlinkLossAndRTTMap.forEach(function(e){var n=e.rtt,i=e.loss,r=e.userId,a=t.networkQuality_.totalDownlinkRTTAndLossMap.get(r);a?(a.totalRTT+=n,a.totalLoss+=i,a.count++):t.networkQuality_.totalDownlinkRTTAndLossMap.set(r,{totalRTT:n,totalLoss:i,count:1});}));}},{key:"handleHeartbeatStats",value:function value(e){var t=this;if(this.hitTest(e.client)){var n=e.stats,i=n.msg_up_stream_info,r=n.msg_down_stream_info;if(i.msg_video_status[0]){var a=i.msg_video_status[0],o=a.uint32_video_codec_bitrate,s=a.uint32_video_enc_fps,c=a.uint32_video_width,u=a.uint32_video_height;this.localStreamStats_.totalVideoBitrate+=o,this.localStreamStats_.totalVideoFPS+=s,this.localStreamStats_.totalVideoWidth+=c,this.localStreamStats_.totalVideoHeight+=u,this.localStreamStats_.videoCount++;}if(i.msg_audio_status){var d=i.msg_audio_status.audioLevel;Math.floor(100*d)>0&&(this.localStreamStats_.totalAudioLevel+=d,this.localStreamStats_.audioLevelCount++);}r.forEach(function(e){var n=e.msg_user_info,i=e.msg_audio_status,r=e.msg_video_status,a=n.str_identifier;if(r.forEach(function(e){var n=2===e.uint32_video_stream_type,i=7===e.uint32_video_stream_type,r="".concat(a,"_").concat(n?zI:JI);if(t.remoteStreamStatsMap_.has(r)){var o,s,c=t.remoteStreamStatsMap_.get(r);(n&&null!==(o=c.stream)&&void 0!==o&&o.isMainVideoSubscribed||i&&null!==(s=c.stream)&&void 0!==s&&s.isAuxVideoSubscribed)&&(c.totalVideoFPS+=e.uint32_video_receive_fps,c.totalVideoBitrate+=e.uint32_video_codec_bitrate,c.videoCount++,0===c.statsToReport.uint32_video_width&&(c.statsToReport.uint32_video_width=e.uint32_video_width),0===c.statsToReport.uint32_video_height&&(c.statsToReport.uint32_video_height=e.uint32_video_height));}}),i){var o="".concat(a,"_").concat(zI);if(t.remoteStreamStatsMap_.has(o)){var s,c=t.remoteStreamStatsMap_.get(o);null!==(s=c.stream)&&void 0!==s&&s.isMainAudioSubscribed&&(c.totalAudioBitrate+=i.uint32_audio_codec_bitrate,c.audioCount++,Math.floor(100*i.audioLevel)>0&&(c.totalAudioLevel+=i.audioLevel,c.audioLevelCount++));}}});}}},{key:"handlePublishStart",value:function value(e){var t=e.client;this.hitTest(t)&&0===this.localStreamStats_.publishStartTime&&(this.localStreamStats_.publishStartTime=Date.now());}},{key:"handleLocalStreamInitStart",value:function value(e){var t=e.audio,n=e.video;t&&0===this.pathJoinRoom_.uint64_init_audio_start_time&&(this.pathJoinRoom_.uint64_init_audio_start_time=Date.now()),n&&0===this.pathJoinRoom_.uint64_init_camera_start_time&&(this.pathJoinRoom_.uint64_init_camera_start_time=Date.now());}},{key:"handleLocalStreamInitEnd",value:function value(e){var t=e.audio,n=e.video;t&&0===this.pathJoinRoom_.uint64_init_audio_end_time&&(this.pathJoinRoom_.uint64_init_audio_end_time=Date.now()),n&&0===this.pathJoinRoom_.uint64_init_camera_end_time&&(this.pathJoinRoom_.uint64_init_camera_end_time=Date.now());}},{key:"handleLocalStreamInitFailed",value:function value(e){var t=e.audio,n=e.video,i=e.error,r=i instanceof pD?i.getExtraCode()||i.getCode():{NotFoundError:1,NotAllowedError:2,NotReadableError:3,OverConstrainedError:4,AbortError:5}[i.name]||hD.UNKNOWN;t&&0===this.pathJoinRoom_.uint64_init_audio_end_time&&(this.pathJoinRoom_.int32_init_audio_ret=r,this.pathJoinRoom_.uint64_init_audio_end_time=Date.now()),n&&0===this.pathJoinRoom_.uint64_init_camera_end_time&&(this.pathJoinRoom_.int32_init_camera_ret=r,this.pathJoinRoom_.uint64_init_camera_end_time=Date.now());}},{key:"hasVideoFlag",value:function value(e){return this.firstPublishedUserList_.findIndex(function(t){return t.userId===e&&1&t.flag;})>=0;}},{key:"hasAudioFlag",value:function value(e){return this.firstPublishedUserList_.findIndex(function(t){return t.userId===e&&8&t.flag;})>=0;}},{key:"hasAuxFlag",value:function value(e){return this.firstPublishedUserList_.findIndex(function(t){return t.userId===e&&4&t.flag;})>=0;}},{key:"hitTest",value:function value(e){return e===this.client_;}},{key:"checkStorage",value:(s=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(e.prev=0,!(t=XO.getItem(this.storageKey_))){e.next=6;break;}return e.next=5,this.upload(t);case 5:XO.deleteItem(this.storageKey_);case 6:e.next=11;break;case 8:e.prev=8,e.t0=e.catch(0),this.log_.warn(e.t0);case 11:case"end":return e.stop();}}},e,this,[[0,8]]);})),function(){return s.apply(this,arguments);})},{key:"setStorage",value:function value(){this.prepareReport();var e=this.getReportData();0!==e.msg_path_enter_room.uint64_start_time&&XO.setItem(this.storageKey_,e);}},{key:"prepareReport",value:function value(){var e=this;if(this.networkQuality_.count>0&&(this.basicInfo.uint32_avg_rtt=Math.floor(this.networkQuality_.totalUplinkRTT/this.networkQuality_.count),this.basicInfo.uint32_avg_up_loss=Math.floor(this.networkQuality_.totalUplinkLoss/this.networkQuality_.count)),this.localStreamStats_.videoCount>0){this.localStreamStats_.statsToReport.uint32_video_big_capture_fps=Math.floor(this.localStreamStats_.totalVideoFPS/this.localStreamStats_.videoCount),this.localStreamStats_.statsToReport.uint32_video_big_bitrate=Math.floor(this.localStreamStats_.totalVideoBitrate/this.localStreamStats_.videoCount);var t=Math.floor(this.localStreamStats_.totalVideoWidth/this.localStreamStats_.videoCount),n=Math.floor(this.localStreamStats_.totalVideoHeight/this.localStreamStats_.videoCount);this.localStreamStats_.statsToReport.uint32_video_big_resolution=t<<16|n;}this.localStreamStats_.audioLevelCount>0&&(this.localStreamStats_.statsToReport.uint32_audio_capture_db=Math.floor(this.localStreamStats_.totalAudioLevel/this.localStreamStats_.audioLevelCount*100)),this.remoteStreamStatsMap_.forEach(function(t,n){var i=t.userId;if(e.networkQuality_.totalDownlinkRTTAndLossMap.has(i)){var r=e.networkQuality_.totalDownlinkRTTAndLossMap.get(i),a=r.totalLoss,o=r.count;t.statsToReport.uint32_avg_down_loss=Math.floor(a/o);}t.videoCount>0&&(t.statsToReport.uint32_video_avg_fps=Math.floor(t.totalVideoFPS/t.videoCount),t.statsToReport.uint32_video_avg_bitrate=Math.floor(t.totalVideoBitrate/t.videoCount)),t.audioCount>0&&(t.statsToReport.uint32_audio_recv_bitrate=t.statsToReport.uint32_audio_bitrate=Math.floor(t.totalAudioBitrate/t.audioCount)),t.audioLevelCount>0&&(t.statsToReport.uint32_audio_play_db=Math.floor(t.totalAudioLevel/t.audioLevelCount*100));var s=e.client_.getCallDurationCalculator();s&&(t.statsToReport.uint32_audio_play_time=s.getDuration(n,BT),t.statsToReport.uint32_video_play_time=s.getDuration(n,HT)),t.statsToReport.uint32_video_render_first=Math.min(t.statsToReport.uint32_video_render_first,sJ);var c=e.client_.getBadCaseDetector();if(c){var u=c.getDataFreezeDuration(n),d=u.dataFreeze,l=u.count,h=c.getRenderFreezeDuration(n).renderFreeze;t.statsToReport.uint32_video_block_count=l,t.statsToReport.uint32_video_block_time=Math.min(d,t.statsToReport.uint32_video_play_time),t.statsToReport.uint32_video_external_block_time=Math.min(h,t.statsToReport.uint32_video_play_time),c.isBlackStream(n)&&0===t.statsToReport.uint32_video_avg_fps?t.statsToReport.uint32_video_black_screen_subjective=1:t.statsToReport.uint32_video_black_screen_subjective=0;}(0===t.subscribeStartTime||t.subscribeStartTime-t.streamAddedTime>100||0===t.playStreamTime)&&(e.pathMainAudioMap_.delete(n),e.pathMainVideoMap_.delete(n),t.statsToReport.uint32_video_render_first=0);}),this.pathMainAudioMap_.forEach(function(t,n){e.hasAudioFlag(t.userId)?t.statsToReport.uint64_play_first_frame_time-t.statsToReport.uint64_start_enter_time>sJ&&(t.statsToReport.uint64_play_first_frame_time=t.statsToReport.uint64_start_enter_time+sJ):e.pathMainAudioMap_.delete(n);}),this.pathMainVideoMap_.forEach(function(t,n){e.hasVideoFlag(t.userId)?t.statsToReport.uint64_render_first_frame_time-t.statsToReport.uint64_start_enter_time>sJ&&(t.statsToReport.uint64_render_first_frame_time=t.statsToReport.uint64_start_enter_time+sJ):e.pathMainVideoMap_.delete(n);}),this.pathJoinRoom_.uint64_end_time-this.pathJoinRoom_.uint64_start_time>sJ&&(this.pathJoinRoom_.uint64_end_time=this.pathJoinRoom_.uint64_start_time+sJ);}},{key:"getReportData",value:function value(){var e=this.client_.getSignalInfo();return{uint32_sdk_app_id:Number(this.client_.getSDKAppId()),msg_user_info:new uJ({userId:this.client_.getUserId(),tinyId:this.client_.getTinyId(),role:this.client_.getRole()===jI?VI:FI}),msg_basic_info:this.basicInfo,uint32_acc_ip:gA(e.relayIp),uint32_client_ip:gA(e.clientIp,"small"),uint32_acc_port:0,uint64_timestamp:Date.now(),uint32_seq:Math.floor(Math.random()*Math.pow(2,31)),msg_path_enter_room:this.pathJoinRoom_,msg_path_exit_room:this.pathLeaveRoom_,msg_path_recv_video:k(this.pathMainVideoMap_.values()).map(function(e){return e.statsToReport;}),msg_quality_statistics:k(this.remoteStreamStatsMap_.values()).map(function(e){return e.statsToReport;}),str_room_name:String(this.client_.getRoomId()),msg_path_recv_audio:k(this.pathMainAudioMap_.values()).map(function(e){return e.statsToReport;}),uint32_info_client_ip:gA(e.clientIp,"small"),error_code:[],msg_local_statistics:this.localStreamStats_.statsToReport};}},{key:"report",value:(r=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,t=this.getReportData(),e.next=4,this.upload(t);case 4:XO.deleteItem(this.storageKey_),this.initData(),e.next=11;break;case 8:e.prev=8,e.t0=e.catch(0),this.log_.warn(e.t0);case 11:case"end":return e.stop();}}},e,this,[[0,8]]);})),function(){return r.apply(this,arguments);})},{key:"upload",value:(i=a(n().mark(function e(t){var i,r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!(NT||0===t.msg_path_enter_room.uint64_start_time||[sw,cw,uw].findIndex(function(e){return e===location.host;})>=0)){e.next=2;break;}return e.abrupt("return");case 2:return i=Number(this.client_.getSDKAppId()),r=nA(i,OI),e.next=6,AA({url:r,body:JSON.stringify(t)});case 6:if("ok"===(a=e.sent).data){e.next=9;break;}throw"key point upload failed: ".concat(a.data);case 9:case"end":return e.stop();}}},e,this);})),function(e){return i.apply(this,arguments);})}]),e;}(),E(Zz.prototype,"upload",[$z],Object.getOwnPropertyDescriptor(Zz.prototype,"upload"),Zz.prototype),Zz);function lJ(){return function(e,t,i){var r=i.value,o=new Set();return i.value=a(n().mark(function e(){var i,a,s,c,u=arguments;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!o.has(this)){e.next=2;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:Jw,data:{name:t}})});case 2:for(e.prev=2,o.add(this),i=u.length,a=new Array(i),s=0;s<i;s++){a[s]=u[s];}return e.next=7,r.apply(this,a);case 7:return c=e.sent,o.delete(this),e.abrupt("return",c);case 12:throw e.prev=12,e.t0=e.catch(2),o.delete(this),e.t0;case 16:case"end":return e.stop();}}},e,this,[[2,12]]);})),i;};}function hJ(e){return pJ.apply(this,arguments);}function pJ(){return pJ=a(n().mark(function e(t){var i,r,a,o,s,c,u,d,l,h,p,f,m;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i=t.userId,r=t.sdkAppId,a=t.useStringRoomId,o=t.roomId,s=t.userSig,c={delta:0,count:[1,1],msg:[]},e.prev=2,(u=new FormData()).append("userId",String(i)),u.append("sdkAppId",String(r)),u.append("isStrGroupId",a),u.append("groupId",String(o)),u.append("sdkVersion",Bo),u.append("userSig",String(s)),d=vA(),e.next=13,gJ(u,c,r);case 13:return l=e.sent,c.delta=vA()-d,fJ({stat:c,userId:i}),e.abrupt("return",l);case 19:throw e.prev=19,e.t0=e.catch(2),h=pA(e.t0)?e.t0[0]:e.t0,p=dA(h.code)?h.code:0,f="get websocket url failed: ".concat(h.message.includes("timeout")?"timeout":h.message),m=new pD({code:hD.SCHEDULE_FAILED,extraCode:p,message:ZC({key:mR,data:{error:f,code:p}})}),xx.error(m),fJ({stat:c,userId:i,roomId:o,error:m}),m;case 28:case"end":return e.stop();}}},e,null,[[2,19]]);})),pJ.apply(this,arguments);}function fJ(e){var t=e.stat,n=e.userId,i=e.error;i?nO.logFailedEvent({eventType:PE,error:i,userId:n}):nO.logSuccessEvent({eventType:PE,delta:t.delta,userId:n}),nO.uploadEvent({log:"stat-schedule:"+JSON.stringify(t),userId:n});}function mJ(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:cI;return t=tA(e)?n===cI?ew:tw:n===cI?$E:ZE,"https://".concat(t,"/api/v1/config");}function _J(e,t,n){return new Promise(function(i,r){AA({url:e,body:t,timeout:n.timeout}).then(function(e){0===e.data.code?i(e.data.data):r({code:e.data.code,message:e.data.msg});}).catch(r);});}var vJ=function vJ(e,t){return Ex({retryFunction:_J,settings:{retries:3,timeout:0},onError:t,onRetrying:e});};function gJ(e,t,n){return new Promise(function(i,r){var a,o=null;(a=[vJ(function(e){return t.count[0]=e+1;},function(e,n){t.msg[0]=e.message,o||n();})(mJ(n,cI),e,{get timeout(){return 1e3*aA(2+t.count[0]);}}),vJ(function(e){return t.count[1]=e+1;},function(e,n){t.msg[1]=e.message,o||n();})(mJ(n,uI),e,{get timeout(){return 1e3*aA(2+t.count[1]);}})],new Promise(function(e,t){var n=[];a.forEach(function(i){i.then(e).catch(function(e){n.push(e),n.length===a.length&&t(n);});});})).then(function(e){i(o=e);}).catch(r);});}var yJ,SJ,kJ,bJ,TJ,IJ,EJ,wJ,RJ,CJ,AJ,xJ,PJ,DJ,OJ,NJ,MJ,LJ=function(){function e(){o(this,e);}return c(e,[{key:"call",value:function value(e,t){return sA(this[e])?this[e](t):Promise.reject(new pD({code:hD.INVALID_PARAMETER,message:ZC({key:UC,data:{name:e}})}));}},{key:"updatePrivateMapKey",value:function value(e){var t=e.privateMapKey;return e.client.setProperty("privateMapKey",t),Promise.resolve();}}]),e;}(),UJ=new LJ();var VJ,FJ,jJ,BJ,HJ,GJ,WJ,zJ=(yJ=lJ(),SJ=lz(uz.CLIENT.join),kJ=lJ(),bJ=kz({retries:3}),TJ=lJ(),IJ=lz.apply(void 0,k(uz.CLIENT.publish)),EJ=lJ(),wJ=lz(uz.CLIENT.unpublish),RJ=lz.apply(void 0,k(uz.CLIENT.subscribe)),CJ=lz(uz.CLIENT.unsubscribe),AJ=lJ(),xJ=lz(uz.CLIENT.switchRole),PJ=lz(uz.CLIENT.startPublishCDNStream),DJ=lz(uz.CLIENT.startMixTranscode),OJ=dz.apply(void 0,k(uz.CLIENT.sendSEIMessage)),VJ={timesInSecond:30,maxSizeInSecond:8e3,getSize:function getSize(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++){t[n]=arguments[n];}return t[0].byteLength;}},FJ=VJ.timesInSecond,jJ=VJ.maxSizeInSecond,BJ=VJ.getSize,NJ=function NJ(e,t,n){var i=n.value,r=new Map();return DA.on(qA,function(e){var t=e.client;return r.delete(t);}),n.value=function(){var e=r.get(this);e||(e={callCountInSecond:0,timestamp:0,totalSizeInSecond:0},r.set(this,e)),0===e.timestamp?e.timestamp=Date.now():Date.now()-e.timestamp>1e3&&(e.timestamp=Date.now(),e.callCountInSecond=0,e.totalSizeInSecond=0);for(var n=arguments.length,a=new Array(n),o=0;o<n;o++){a[o]=arguments[o];}if(BJ&&(e.totalSizeInSecond+=BJ.apply(void 0,a)),0!==e.timestamp&&Date.now()-e.timestamp<1e3&&(e.callCountInSecond>=FJ||e.totalSizeInSecond>jJ))throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:JC,data:{isTimes:e.callCountInSecond>=FJ,isSize:e.totalSizeInSecond>jJ,name:t,timesInSecond:FJ,maxSizeInSecond:jJ}})});return e.callCountInSecond++,i.apply(this,a);},n;},MJ=function(){function Client(e){var t,n;o(this,Client),this.name_=iw,this.mode_=e.mode,this.sdpSemantics_=ME,cA(e.sdpSemantics)?function(){var e;if(cA(window.RTCRtpTransceiver))return!1;if(!("currentDirection"in RTCRtpTransceiver.prototype))return!1;var t=null,n=!1;try{(t=new RTCPeerConnection({sdpSemantics:NE})).addTransceiver(BT),n=!0;}catch(XJ){}return null===(e=t)||void 0===e||e.close(),n;}()&&(this.sdpSemantics_=NE):this.sdpSemantics_=e.sdpSemantics,this.sdkAppId_=e.sdkAppId,this.userId_=e.userId,this.log_=xx.createLogger({id:"c".concat(e.seq,"|").concat(this.userId_),userId:this.userId_,sdkAppId:this.sdkAppId_}),this.userSig_=e.userSig,this.roomId_=0,this.useStringRoomId_=e.useStringRoomId||!1,this.pureAudioPushMode_=null,this.version_=e.version,this.log_.info("using sdpSemantics: "+this.sdpSemantics_),this.signalChannel_=null,this.role_=jI,this.privateMapKey_="",this.tinyId_=0,this.env_="",this.proxy_=null,this.connections_=new Map(),this.mutedStates_=new Map(),this.userMap_=new Map(),this.syncUserListInterval_=-1,this.localStream_=null,this.localAuxStream_=null,this.uplinkConnection_=null,this.emitter_=wA(new PA(),this.name_),this.isJoined_=!1,this.heartbeat_=-1,this.lastHeartBeatTime_=-1,this.stats_=new jN(this),this.joinTimeout_=-1,this.changeBigSmallRecords_=new Map(),this.networkQuality_=null,this.badCaseDetector_=null,this.networkType_=iA(),this.autoSubscribe_=!!cA(e.autoSubscribe)||e.autoSubscribe,this.joinedTimestamp_=0,this.joinOptions_={},this.basis_=(n={browser:UT().name+"/"+UT().version,os:bN(),displayResolution:TN(),isScreenShareSupported:dN(),isWebRTCSupported:eN(),isGetUserMediaSupported:IN(),isWebAudioSupported:EN(),isWebSocketsSupported:"WebSocket"in window&&2===window.WebSocket.CLOSING,isWebCodecSupported:(t={AudioDecoder:!1,AudioEncoder:!1,VideoDecoder:!1,VideoEncoder:!1,ImageDecoder:!1},cA(window.AudioDecoder)||(t.AudioDecoder=!0),cA(window.AudioEncoder)||(t.AudioEncoder=!0),cA(window.VideoDecoder)||(t.VideoDecoder=!0),cA(window.VideoEncoder)||(t.VideoEncoder=!0),cA(window.ImageDecoder)||(t.ImageDecoder=!0),t),isMediaSessionSupported:"mediaSession"in navigator&&!cA(navigator.mediaSession.setActionHandler),isWebTransportSupported:!cA(window.WebTransport)},navigator.userAgent.includes("miniProgram")&&(n.browser="mini/".concat(n.browser)),n),this.initBussinessInfo_(e),this.publishedCDN_=!1,this.publishCDNData_=null,this.mixedMCU_=!1,this.mixTranscodeData_=null,this.checkSystemResult_=null,this.enableAudioVolumeEvaluation_=!1,this.audioVolumeIntervalId_=null,this.mixTranscodeManager_=null,this.publishCDNManager_=new nJ({client:this}),this.keyPointManager_=new dJ({client:this,frameWorkType:e.frameWorkType,component:e.component}),this.isPublishing_=!1,this.isEnableSmallStream_=!1,this.smallStreamConfig_={bitrate:100,frameRate:15,height:120,width:160},this.turnServers_=[],this.iceTransportPolicy_=e.iceTransportPolicy,this.schedule_={domains:null,iceServers:null,iceTransportPolicy:null,trtcCapability:null},this.enableAutoPlayDialog_=!!cA(e.enableAutoPlayDialog)||e.enableAutoPlayDialog,this.enableMultiAuxStream_=!cA(e.enableMultiAuxStream)&&e.enableMultiAuxStream,this.signalInfo_={},this.enableSEI_=!cA(e.enableSEI)&&e.enableSEI,this.isDestroyed_=!1;}var e,i,r,s,u,d,l,h,p,f,m,_,v,g,y,b,T,E,w,R,C,A,x,P,D,O,N;return c(Client,[{key:"initBussinessInfo_",value:function value(e){this.bussinessInfo_=e.bussinessInfo;var t={};if(uA(e.bussinessInfo)&&(t=JSON.parse(e.bussinessInfo)),!cA(e.pureAudioPushMode)){if(!Number.isInteger(Number(e.pureAudioPushMode)))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:oR})});this.pureAudioPushMode_=e.pureAudioPushMode,t.Str_uc_params||(t.Str_uc_params={}),t.Str_uc_params.pure_audio_push_mod=this.pureAudioPushMode_;}if(!cA(e.streamId)){if(!(uA(e.streamId)&&String(e.streamId)&&String(e.streamId).length<=64))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:sR})});t.Str_uc_params||(t.Str_uc_params={}),t.Str_uc_params.userdefine_streamid_main=e.streamId;}if(!cA(e.userDefineRecordId)){if(null===e.userDefineRecordId.match(/^[A-Za-z0-9_-]{1,64}$/gi))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:cR})});t.Str_uc_params||(t.Str_uc_params={}),t.Str_uc_params.userdefine_record_id=e.userDefineRecordId;}if(!cA(e.userDefinePushArgs)){if(!(uA(e.userDefinePushArgs)&&String(e.userDefinePushArgs)&&String(e.userDefinePushArgs).length<=256))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:uR})});t.Str_uc_params||(t.Str_uc_params={}),t.Str_uc_params.userdefine_push_args=e.userDefinePushArgs;}eO(t)||(this.bussinessInfo_=JSON.stringify(t));}},{key:"schedule",value:(N=a(n().mark(function e(i){var r;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.next=2,hJ({userId:this.userId_,sdkAppId:this.sdkAppId_,roomId:i,useStringRoomId:this.useStringRoomId_,version:this.version_,userSig:this.userSig_});case 2:(r=e.sent)&&(this.log_.info("schedule: ".concat(JSON.stringify(r))),r.trtcCapability=null==r?void 0:r.trtcAutoConf,this.schedule_=t(t({},this.schedule_),r),DA.emit(KA,this.schedule_));case 4:case"end":return e.stop();}}},e,this);})),function(e){return N.apply(this,arguments);})},{key:"getSignalChannelUrl",value:function value(){var e={mainUrl:"",backupUrl:""},t=eA();return t?e.mainUrl=e.backupUrl="wss://".concat(t,".rtc.qq.com"):this.proxy_?e.mainUrl=e.backupUrl=this.proxy_:Array.isArray(this.schedule_.domains)&&this.schedule_.domains.length>0&&(e.mainUrl=e.backupUrl="wss://".concat(this.schedule_.domains[0]),this.schedule_.domains[1]&&(e.backupUrl="wss://".concat(this.schedule_.domains[1]))),e;}},{key:"getUserId",value:function value(){return this.userId_;}},{key:"getUserSig",value:function value(){return this.userSig_;}},{key:"getRole",value:function value(){return this.role_;}},{key:"getSignalInfo",value:function value(){return this.signalInfo_;}},{key:"getRoomId",value:function value(){return this.roomId_;}},{key:"getSDKAppId",value:function value(){return this.sdkAppId_;}},{key:"getTinyId",value:function value(){return this.tinyId_;}},{key:"getIceTransportPolicy",value:function value(){return this.iceTransportPolicy_||this.schedule_.iceTransportPolicy||"all";}},{key:"initialize",value:function value(){var e=this;this.log_.info("setup signal channel");var t=this.getSignalChannelUrl(),n=t.mainUrl,i=t.backupUrl;return this.signalChannel_=new iO({sdkAppId:this.sdkAppId_,userId:this.userId_,userSig:this.userSig_,url:n,backupUrl:i,client:this}),this.networkQuality_||(this.networkQuality_=new BN({connections:this.connections_,signalChannel:this.signalChannel_,userId:this.userId_,client:this}),this.networkQuality_.on(PN.NETWORK_QUALITY,function(t){e.emitter_.emit(PN.NETWORK_QUALITY,t);})),this.deviceDetector_||(this.deviceDetector_=new HN({client:this})),this.subscriptionManager_||(this.subscriptionManager_=new _z({client:this})),this.badCaseDetector_||(this.badCaseDetector_=new Qz({client:this,stats:this.stats_})),this.callDurationCalculator_||(this.callDurationCalculator_=new iJ({client:this})),this.mixTranscodeManager_||(this.mixTranscodeManager_=new tJ({client:this,signalChannel:this.signalChannel_})),this.publishCDNManager_&&this.publishCDNManager_.setSignalChannel({signalChannel:this.signalChannel_}),this.signalChannel_.on(LP,function(t){e.log_.info("SignalChannel state changed from ".concat(t.prevState," to ").concat(t.state)),e.emitter_.emit(PN.CONNECTION_STATE_CHANGED,t);}),this.signalChannel_.on(VP,function(t){e.reset(),e.emitter_.emit(PN.ERROR,t);}),this.signalChannel_.once(NP,function(t){e.tinyId_=t.signalInfo.tinyId,DA.emit(zA,{client:e});}),this.signalChannel_.on(zP.PEER_JOIN,this.onPeerJoin,this),this.signalChannel_.on(zP.PEER_LEAVE,this.onPeerLeave,this),this.signalChannel_.on(zP.UPDATE_REMOTE_MUTE_STAT,function(t){Date.now()-e.lastHeartBeatTime_>=1e4&&e.doHeartbeat(),DA.emit(HA,{client:e,data:t.data}),e.onPublishedUserList(t.data),e.onUpdateRemoteMuteStat(t.data);}),this.signalChannel_.on(zP.CLIENT_BANNED,function(t){var n,i=t.data.data.reason;if(nO.uploadEvent({log:"stat-banned:".concat(i),userId:e.userId_}),i===dI)n="you got banned by the admin";else if(i===lI)n="duplicated userId joining the room";else if(i===pI)n="the room has been disbanded by the admin",i=i.replace("_","-");else if(i===hI)return e.log_.warn("".concat(i," last heart beat time: ").concat(e.lastHeartBeatTime_," interval: ").concat(Date.now()-e.lastHeartBeatTime_,", visibility: ").concat(document.visibilityState)),void e.reJoin();e.log_["kick"===i?"error":"info"]("user was banned because of [".concat(i,"]")),e.reset(),e.emitter_.emit(PN.CLIENT_BANNED,{reason:i,message:ZC({key:AR,data:{message:n,reason:i}})||i});}),DA.emit(WA,{client:this}),this.signalChannel_.connect();}},{key:"preJoin",value:(O=a(n().mark(function e(t){var i,r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return this.joinOptions_=t,e.next=3,sN();case 3:if(this.checkSystemResult_=e.sent,this.checkDestroy(),(i=eA())||(i=RI,this.proxy_&&(this.proxy_.startsWith(EI)?i=CI:this.proxy_.startsWith(wI)&&(i=AI))),this.env_=i,nO.setConfig({env:i,sdkAppId:this.sdkAppId_,userId:this.userId_,roomId:t.roomId}),this.uploadTrtcStats(),r=this.checkSystemResult_.detail,a=r.isH264EncodeSupported,o=r.isVp8EncodeSupported,eN()&&(a||o)){e.next=13;break;}throw new pD({code:hD.NOT_SUPPORTED,message:ZC({key:EC})});case 13:case"end":return e.stop();}}},e,this);})),function(e){return O.apply(this,arguments);})},{key:"join",value:(D=a(n().mark(function e(t){var i,r=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return this.roomId_=t.roomId,cA(t.role)||(this.role_=t.role),cA(t.privateMapKey)||(this.privateMapKey_=t.privateMapKey),i=vA(),DA.emit(OA,{client:this}),YD(this.userId_,{eventId:OD,eventDesc:"joining room",timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_}),e.next=8,this.preJoin(t);case 8:return e.abrupt("return",new Promise(function(){var e=a(n().mark(function e(a,o){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(r.joinReject_=o,e.prev=1,r.proxy_||r.schedule_.domains){e.next=5;break;}return e.next=5,r.schedule(t.roomId);case 5:return r.checkDestroy(),e.next=8,r.initialize(t);case 8:return e.next=10,r.doJoin(t);case 10:r.signalInfo_=r.signalChannel_.getSignalInfo(),DA.emit(LA,{client:r}),r.joinedTimestamp_=vA(),nO.logSuccessEvent({userId:r.userId_,eventType:sE,delta:r.joinedTimestamp_-i}),nO.logSuccessEvent({userId:r.userId_,eventType:oE}),nO.uploadEvent({log:"stat-autoplay-dialog:".concat(r.enableAutoPlayDialog_),userId:r.userId_}),nO.uploadEvent({log:"stat-conv-".concat(NT,"-").concat(location.hostname),userId:r.userId_}),a(),e.next=26;break;case 20:e.prev=20,e.t0=e.catch(1),DA.emit(UA,{client:r,error:e.t0}),nO.logFailedEvent({userId:r.userId_,eventType:oE,error:e.t0}),r.reset(),o(e.t0);case 26:r.joinReject_=null;case 27:case"end":return e.stop();}}},e,null,[[1,20]]);}));return function(t,n){return e.apply(this,arguments);};}()));case 9:case"end":return e.stop();}}},e,this);})),function(e){return D.apply(this,arguments);})},{key:"checkDestroy",value:function value(){if(this.isDestroyed_)throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:oC,data:{funName:"join"}})});}},{key:"uploadTrtcStats",value:(P=a(n().mark(function e(){var t,i,r,a,o,s,c,u,d,l,h,p,f;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,QJ.getMicrophones();case 3:r=e.sent,t=r&&r.length,e.next=9;break;case 7:e.prev=7,e.t0=e.catch(0);case 9:return e.prev=9,e.next=12,QJ.getCameras();case 12:a=e.sent,i=a&&a.length,e.next=18;break;case 16:e.prev=16,e.t1=e.catch(9);case 18:o={microphone:t,camera:i},s=this.checkSystemResult_.detail,c=s.isH264EncodeSupported,u=s.isVp8EncodeSupported,d=s.isH264DecodeSupported,l=s.isVp8DecodeSupported,h={webRTC:this.basis_.isWebRTCSupported,getUserMedia:this.basis_.isGetUserMediaSupported,webSocket:this.basis_.isWebSocketsSupported,screenShare:this.basis_.isScreenShareSupported,webAudio:this.basis_.isWebAudioSupported,h264Encode:c,h264Decode:d,vp8Encode:u,vp8Decode:l},p={browser:this.basis_.browser,os:this.basis_.os,trtc:h,devices:o},f={isWebCodecSupported:this.basis_.isWebCodecSupported,isMediaSessionSupported:this.basis_.isMediaSessionSupported,isWebTransportSupported:this.basis_.isWebTransportSupported},nO.uploadEvent({log:"trtcstats-"+JSON.stringify(p),userId:this.userId_}),this.log_.info("TrtcStats-"+JSON.stringify(p)),nO.uploadEvent({log:"trtcadvancedstats-"+JSON.stringify(f),userId:this.userId_});case 26:case"end":return e.stop();}}},e,this,[[0,7],[9,16]]);})),function(){return P.apply(this,arguments);})},{key:"doJoin",value:function value(e){var t=this;return new Promise(function(e,n){t.log_.info("Join() => joining room: ".concat(t.roomId_," useStringRoomId: ").concat(t.useStringRoomId_," mode: ").concat(t.mode_," role: ").concat(t.role_));var i={roomId:String(t.roomId_),useStringRoomId:t.useStringRoomId_,privateMapKey:t.privateMapKey_,trtcRole:t.role_===jI?VI:FI,trtcScene:t.mode_===UI?LI:MI,sdpSemantics:t.sdpSemantics_,version:CA(t.version_),ua:navigator&&navigator.userAgent||"",autoSubscribe:t.autoSubscribe_,terminalType:Ob?4:xb?2:Cb?3:oT?12:aT?5:sT?13:1,netType:zE[iA()],bussinessInfo:t.bussinessInfo_};if(t.publishCDNManager_){var r=t.publishCDNManager_.handleCDNConfigForJoinData(t.bussinessInfo_),a=r.bussinessInfo,o=r.pushUserCdnInfo;Object.assign(i,{bussinessInfo:a,pushUserCdnInfo:o});}t.log_.debug("join room signal data: ".concat(JSON.stringify(i))),t.joinTimeout_=setTimeout(function(){t.log_.error("join room timeout observed"),n(new pD({code:hD.JOIN_ROOM_FAILED,message:ZC({key:fR})}));},5e3),DA.emit(NA,{client:t}),t.signalChannel_.once(MP,function(e){t.clearJoinTimeout(),DA.emit(zA,{client:t,error:e}),n(e);}),t.signalChannel_.send(KP,i),t.signalChannel_.once(zP.JOIN_ROOM_RESULT,function(i){t.clearJoinTimeout();var r=i.data,a=r.code,o=r.message,s=r.data;t.onPublishedUserList({data:{userList:s.publishers}}),DA.emit(MA,{client:t,code:a}),0===a?(t.isJoined_=!0,t.log_.info("Join room success, start heartbeat"),t.startHeartbeat(),t.badCaseDetector_&&t.badCaseDetector_.start(),t.syncUserList(),t.startSyncUserListInterval(),e()):(t.log_.error("Join room failed result: "+a+" error: "+o),n(new pD({code:hD.JOIN_ROOM_FAILED,extraCode:a,message:ZC({key:mR,data:{error:o,code:a}})})));});});}},{key:"reJoin",value:(x=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.isJoined_){e.next=3;break;}return this.log_.warn("reJoin abort"),e.abrupt("return");case 3:return this.isJoined_=!1,e.prev=4,this.log_.warn("reJoin pending: ".concat(this.joinOptions_.roomId)),this.subscriptionManager_&&this.subscriptionManager_.markAllStream(),this.signalChannel_.close(),e.next=10,this.signalChannel_.connect();case 10:return e.next=12,this.doJoin(t(t({},this.joinOptions_),{},{role:this.role_,privateMapKey:this.privateMapKey_}));case 12:this.log_.warn("reJoin success"),nO.logSuccessEvent({userId:this.userId_,eventType:cE}),this.checkConnectionsToReconnect(),this.uplinkConnection_&&!this.uplinkConnection_.getIsReconnecting()&&this.uplinkConnection_.startReconnection(),this.mixTranscodeManager_&&this.mixTranscodeManager_.reStartMixTranscode(),e.next=25;break;case 19:e.prev=19,e.t0=e.catch(4),this.log_.warn("reJoin fail "+e.t0),this.reset(),nO.logFailedEvent({userId:this.userId_,eventType:cE,error:e.t0}),this.emitter_.emit(PN.ERROR,new pD({code:hD.JOIN_ROOM_FAILED,message:ZC({key:_R,data:{roomId:this.joinOptions_.roomId}})}));case 25:case"end":return e.stop();}}},e,this,[[4,19]]);})),function(){return x.apply(this,arguments);})},{key:"leave",value:(A=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return DA.emit(VA,{client:this}),YD(this.userId_,{eventId:ND,eventDesc:"leaving room",timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_}),e.prev=2,e.next=5,this.doHeartbeat();case 5:e.next=9;break;case 7:e.prev=7,e.t0=e.catch(2);case 9:this.doLeave(),DA.emit(jA,{client:this}),nO.logSuccessEvent({userId:this.userId_,eventType:uE}),t=Math.floor((vA()-this.joinedTimestamp_)/1e3),nO.logSuccessEvent({userId:this.userId_,eventType:dE,delta:t});case 14:case"end":return e.stop();}}},e,this,[[2,7]]);})),function(){return A.apply(this,arguments);})},{key:"doLeave",value:function value(){this.isJoined_&&(DA.emit(FA,{client:this}),this.log_.info("leave() => leaving room"),this.signalChannel_.send(QP),this.reset());}},{key:"clearNetworkQuality",value:function value(){this.networkQuality_&&(this.networkQuality_.stop(),this.networkQuality_=null);}},{key:"closeConnections",value:function value(){var e=this;this.connections_.forEach(function(t){e.closeDownLink(t.getTinyId());});}},{key:"clearJoinTimeout",value:function value(){clearTimeout(this.joinTimeout_),this.joinTimeout_=-1;}},{key:"destroy",value:function value(){var e,t,n;if(this.isJoined_)throw this.log_.warn(XC.INVALID_DESTROY),new pD({code:hD.INVALID_OPERATION,message:ZC({key:vR})});this.isDestroyed_||(this.log_.info("destroy client"),this.joinReject_&&(this.joinReject_(new pD({code:hD.INVALID_OPERATION,message:ZC({key:oC,data:{funName:"join"}})})),this.clearJoinTimeout(),this.reset()),this.off("*"),null===(e=this.callDurationCalculator_)||void 0===e||e.destroy(),null===(t=this.keyPointManager_)||void 0===t||t.destroy(),null===(n=this.deviceDetector_)||void 0===n||n.destroy(),this.callDurationCalculator_=null,this.keyPointManager_=null,this.deviceDetector_=null,this.badCaseDetector_=null,this.publishCDNManager_=null,this.isDestroyed_=!0,DA.emit(qA,{client:this}));}},{key:"reset",value:function value(){this.keyPointManager_&&this.keyPointManager_.prepareReport(),this.mixTranscodeManager_&&(this.mixTranscodeManager_.reset(),this.mixTranscodeManager_=null),this.publishCDNManager_&&this.publishCDNManager_.reset(),this.userMap_.clear(),this.stopSyncUserListInterval(),this.stopHeartbeat(),this.closeConnections(),this.mutedStates_.clear(),this.clearNetworkQuality(),this.badCaseDetector_&&this.callDurationCalculator_&&this.uploadAllCallStats(),this.closeUplink(),this.isJoined_=!1,this.signalChannel_&&(this.log_.info("destroying SignalChannel"),this.signalChannel_.close(),this.signalChannel_=null),this.stats_.reset();}},{key:"startSyncUserListInterval",value:function value(){-1===this.syncUserListInterval_&&(this.syncUserListInterval_=KO.run(Sw,this.syncUserList.bind(this)));}},{key:"stopSyncUserListInterval",value:function value(){KO.clearTask(this.syncUserListInterval_),this.syncUserListInterval_=-1;}},{key:"syncUserList",value:(C=a(n().mark(function e(){var t,i=this;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,this.getUserList();case 3:t=e.sent,0!==this.userMap_.size&&this.userMap_.forEach(function(e){t.findIndex(function(t){return t.userId===e.userId;})<0&&(i.log_.info("peer leave detected: ".concat(e.userId)),i.cleanUser({userId:e.userId,tinyId:e.tinyId}));}),t.forEach(function(e){var t=e.userId;i.userMap_.has(t)||t===i.userId_||(i.userMap_.set(t,e),i.emitter_.emit(PN.PEER_JOIN,{userId:t}));}),e.next=11;break;case 8:e.prev=8,e.t0=e.catch(0),this.log_.warn("sync user list failed: "+e.t0);case 11:case"end":return e.stop();}}},e,this,[[0,8]]);})),function(){return C.apply(this,arguments);})},{key:"getUserList",value:function value(){return this.signalChannel_?this.signalChannel_.sendWaitForResponse({command:uD,responseCommand:zP.USER_LIST_RES,enableLog:!1,timeout:2e3}).then(function(e){var t=e.data,n=t.code,i=t.message;if(0===n)return(t.data&&t.data.userList||[]).map(function(e){var t=e.userId,n=e.srcTinyId,i=e.role;return new Xz({userId:t,tinyId:n,role:i});});throw ZC({key:MC,data:{signalResponse:zP.USER_LIST_RES,code:n,message:i}});}):[];}},{key:"publish",value:(R=a(n().mark(function e(t){var i,r,a,o,s,c,u,d,l=this,h=arguments;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i=h.length>1&&void 0!==h[1]?h[1]:{isAuxiliary:!1},t.setPublishState(qE),this.isPublishing_=!0,r=vA(),DA.emit(GA,{client:this,stream:t}),a=i.isAuxiliary,o=a?JT:cI,s=t.getScreen(),this.log_.info("publish() => publishing ".concat(s?GT+" ":"").concat(o," stream ").concat(t.getId())),c=this.uplinkConnection_,e.prev=10,c||((c=new Jz({userId:this.userId_,tinyId:this.tinyId_,client:this,isUplink:!0,signalChannel:this.signalChannel_,enableSEI:this.enableSEI_})).initialize(),c.on(xN.ERROR,function(e){var t=e.getCode();t!==hD.ICE_TRANSPORT_ERROR&&(t===hD.UPLINK_RECONNECTION_FAILED&&l.closeUplink(),l.emitter_.emit(PN.ERROR,e));})),t.setConnection(c),e.next=15,c.publish(t,a);case 15:this.log_.info("local ".concat(s?GT+" ":"").concat(o," stream is published")),this.isPublishing_=!1,a?this.localAuxStream_=t:(this.localStream_=t,this.deviceDetector_&&this.deviceDetector_.setLocalStream(this.localStream_),this.localStream_.getBeautyStatus()&&this.log_.info("beauty stream is published successfully")),t.setPublishState(KE),t.setClient(this,a),this.uplinkConnection_=c,u=vA(),d=u-r,nO.logSuccessEvent({userId:this.userId_,eventType:lE}),nO.logSuccessEvent({userId:this.userId_,eventType:hE,delta:d}),t.hasAudio()&&YD(this.userId_,{eventId:mD,eventDesc:"publish audio track",timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_}),t.hasVideo()&&YD(this.userId_,{eventId:fD,eventDesc:"publish video track",timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_}),this.networkQuality_&&this.networkQuality_.setUplinkConnection(this.uplinkConnection_),DA.emit(sx,{localStream:t,isAuxiliary:a,client:this}),this.notPublishWithoutH264Supported_=!1,e.next=41;break;case 32:throw e.prev=32,e.t0=e.catch(10),e.t0 instanceof pD&&e.t0.getCode()===hD.NOT_SUPPORTED_H264&&(this.notPublishWithoutH264Supported_=!0),t.setPublishState(JE),c.close(),this.log_.error("failed to publish stream "+e.t0),this.isPublishing_=!1,nO.logFailedEvent({userId:this.userId_,eventType:lE,error:e.t0}),e.t0;case 41:case"end":return e.stop();}}},e,this,[[10,32]]);})),function(e){return R.apply(this,arguments);})},{key:"unpublish",value:(w=a(n().mark(function e(t){var i,r;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.uplinkConnection_){e.next=2;break;}return e.abrupt("return");case 2:return i=t===this.localAuxStream_,r=t.getScreen(),this.log_.info("unpublish() => unpublishing local ".concat(r?GT+" ":"").concat(i?JT:cI," stream")),e.prev=5,e.next=8,this.uplinkConnection_.unpublish(t);case 8:t.setClient(null),t.setConnection(null),i?this.localAuxStream_=null:(this.localStream_=null,t.hasAudio()&&YD(this.userId_,{eventId:vD,eventDesc:"unpublish audio track",timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_}),t.hasVideo()&&YD(this.userId_,{eventId:_D,eventDesc:"unpublish video track",timestamp:ev(),userId:this.userId_,tinyId:this.tinyId_})),this.localStream_||this.localAuxStream_||this.closeUplink(),nO.logSuccessEvent({userId:this.userId_,eventType:pE}),e.next=19;break;case 15:throw e.prev=15,e.t0=e.catch(5),nO.logFailedEvent({userId:this.userId_,eventType:pE,error:e.t0}),e.t0;case 19:case"end":return e.stop();}}},e,this,[[5,15]]);})),function(e){return w.apply(this,arguments);})},{key:"closeUplink",value:function value(){this.uplinkConnection_&&(this.uplinkConnection_.close(),this.uplinkConnection_=null,this.networkQuality_&&this.networkQuality_.setUplinkConnection(null),this.localStream_&&(this.localStream_.setClient(null),this.localStream_.setConnection(null),this.localStream_=null),this.localAuxStream_&&(this.localAuxStream_.setClient(null),this.localAuxStream_.setConnection(null),this.localAuxStream_=null),this.deviceDetector_&&this.deviceDetector_.setLocalStream(null));}},{key:"closeDownLink",value:function value(e){var t=this.connections_.get(e);t&&(t.getIsReconnecting()&&t.stopReconnection(),this.subscriptionManager_&&this.subscriptionManager_.delete(t.getUserId()),t.close(),this.connections_.delete(e),this.mutedStates_.delete(e));}},{key:"subscribe",value:(E=a(n().mark(function e(t,i){var r,a,o;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return this.log_.info("subscribe() => subscribe to [".concat(t.getUserId(),"] ").concat(t.getType()," stream with options: ").concat(JSON.stringify(i))),cA(i)&&(i={audio:!0,video:!0}),cA(i.audio)&&(i.audio=!0),cA(i.smallVideo)?cA(i.video)&&(i.video=!0):i.smallVideo?cA(i.video)?(i.video=!1,i.smallVideo=!0):i.video&&(i.video=!0,delete i.smallVideo,this.log_.warn("options.video and options.smallVideo can't be both true")):cA(i.video)&&(i.video=!0,delete i.smallVideo),e.prev=4,r=t.getConnection(),DA.emit(nx,{client:this,stream:t}),e.next=9,r.subscribe(t,i);case 9:this.subscriptionManager_&&this.subscriptionManager_.addSubscriptionRecord(t.getUserId(),t,i),this.notSubscribeWithoutH264Supported_=!1,nO.logSuccessEvent({userId:this.userId_,eventType:fE}),e.next=21;break;case 14:throw e.prev=14,e.t0=e.catch(4),(a=e.t0 instanceof pD?e.t0.getCode():hD.UNKNOWN)===hD.NOT_SUPPORTED_H264&&(this.notSubscribeWithoutH264Supported_=!0),a===hD.REMOTE_STREAM_NOT_EXIST?(o=new pD({code:hD.API_CALL_ABORTED,message:ZC({key:KC,data:{message:e.t0.message,stream:t}})}),this.log_.warn(o)):(o=new pD({code:a,message:ZC({key:IR,data:{message:e.t0.message,stream:t}})}),this.log_.error(o)),nO.logFailedEvent({userId:this.userId_,eventType:fE,error:o}),o;case 21:case"end":return e.stop();}}},e,this,[[4,14]]);})),function(e,t){return E.apply(this,arguments);})},{key:"unsubscribe",value:(T=a(n().mark(function e(t){var i;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return this.log_.info("unsubscribe() => unsubscribe to [".concat(t.getUserId(),"] ").concat(t.getType()," stream")),e.prev=1,i=t.getConnection(),e.next=5,i.unsubscribe(t);case 5:this.subscriptionManager_&&this.subscriptionManager_.addUnsubscriptionRecord(t.getUserId(),t),DA.emit(rx,{client:this,stream:t}),nO.logSuccessEvent({userId:this.userId_,eventType:mE}),e.next=14;break;case 10:throw e.prev=10,e.t0=e.catch(1),nO.logFailedEvent({userId:this.userId_,eventType:mE,error:e.t0}),e.t0;case 14:case"end":return e.stop();}}},e,this,[[1,10]]);})),function(e){return T.apply(this,arguments);})},{key:"switchRole",value:(b=a(n().mark(function e(t){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.role_!==t){e.next=2;break;}return e.abrupt("return");case 2:return t===BI&&this.uplinkConnection_&&this.closeUplink(),this.log_.info("switchRole() => switch role to: "+t),e.next=6,this.doSwitchRole(t);case 6:case"end":return e.stop();}}},e,this);})),function(e){return b.apply(this,arguments);})},{key:"doSwitchRole",value:function value(e){var t,n,i=this,r={command:dD,data:{role:e===jI?VI:FI,privateMapKey:this.privateMapKey_},responseCommand:zP.SWITCH_ROLE_RES,retries:(null===(t=this.schedule_.config)||void 0===t||null===(n=t.retries)||void 0===n?void 0:n.switchRole)||1};return this.log_.info("switchRole signal data: "+JSON.stringify(r.data)),this.signalChannel_.sendWaitForResponseWithRetry(r).then(function(t){var n=t.data,r=n.code,a=n.message;if(0!==r)throw new pD({code:hD.SWITCH_ROLE_FAILED,message:ZC({key:CR,data:{errMsg:a,errCode:r}})});i.role_=e;}).catch(function(e){throw e instanceof pD&&e.getCode()===hD.API_CALL_TIMEOUT&&(e=new pD({code:hD.SWITCH_ROLE_FAILED,message:ZC({key:RR})})),i.log_.error(e),e;});}},{key:"on",value:function value(e,t,n){this.emitter_.on(e,t,n);}},{key:"off",value:function value(e,t,n){"*"===e?this.emitter_.removeAllListeners():this.emitter_.off(e,t,n);}},{key:"getRemoteMutedState",value:function value(){var e=this,n=[];return this.mutedStates_.forEach(function(i,r,a){var o=e.connections_.get(r);o&&n.push(t({userId:o.getUserId()},i));}),n;}},{key:"getTransportStats",value:(y=a(n().mark(function e(){var t,i,r,a,o,s,c;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(t={rtt:0,downlinksRTT:{}},!this.uplinkConnection_){e.next=6;break;}return e.next=4,this.stats_.getSenderStats(this.uplinkConnection_);case 4:i=e.sent,t.rtt=i.rtt;case 6:r=I(this.connections_),e.prev=7,r.s();case 9:if((a=r.n()).done){e.next=17;break;}return(o=S(a.value,2))[0],s=o[1],e.next=13,this.stats_.getReceiverStats(s);case 13:c=e.sent,t.downlinksRTT[c.userId]=c.rtt;case 15:e.next=9;break;case 17:e.next=22;break;case 19:e.prev=19,e.t0=e.catch(7),r.e(e.t0);case 22:return e.prev=22,r.f(),e.finish(22);case 25:return e.abrupt("return",t);case 26:case"end":return e.stop();}}},e,this,[[7,19,22,25]]);})),function(){return y.apply(this,arguments);})},{key:"getLocalAudioStats",value:(g=a(n().mark(function e(){var t,i;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if((t={})[this.userId_]={bytesSent:0,packetsSent:0},!this.uplinkConnection_){e.next=7;break;}return e.next=5,this.stats_.getSenderStats(this.uplinkConnection_);case 5:i=e.sent,t[this.userId_]={bytesSent:i.audio.bytesSent,packetsSent:i.audio.packetsSent};case 7:return e.abrupt("return",t);case 8:case"end":return e.stop();}}},e,this);})),function(){return g.apply(this,arguments);})},{key:"getLocalVideoStats",value:(v=a(n().mark(function e(){var t,i;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if((t={})[this.userId_]={bytesSent:0,packetsSent:0,framesEncoded:0,framesSent:0,frameWidth:0,frameHeight:0},!this.uplinkConnection_){e.next=7;break;}return e.next=5,this.stats_.getSenderStats(this.uplinkConnection_);case 5:i=e.sent,t[this.userId_]={bytesSent:i.video.bytesSent,packetsSent:i.video.packetsSent,framesEncoded:i.video.framesEncoded,framesSent:i.video.framesSent,frameWidth:i.video.frameWidth,frameHeight:i.video.frameHeight};case 7:return e.abrupt("return",t);case 8:case"end":return e.stop();}}},e,this);})),function(){return v.apply(this,arguments);})},{key:"getRemoteAudioStats",value:(_=a(n().mark(function e(){var t,i,r,a,o,s,c,u;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:t={},i=I(this.connections_),e.prev=2,i.s();case 4:if((r=i.n()).done){e.next=13;break;}return(a=S(r.value,2))[0],o=a[1],s=o.getDelay(),c=s.audioDelay,e.next=9,this.stats_.getReceiverStats(o);case 9:(u=e.sent).hasAudio&&(t[u.userId]={bytesReceived:u.audio.bytesReceived,packetsReceived:u.audio.packetsReceived,packetsLost:u.audio.packetsLost,end2EndDelay:c});case 11:e.next=4;break;case 13:e.next=18;break;case 15:e.prev=15,e.t0=e.catch(2),i.e(e.t0);case 18:return e.prev=18,i.f(),e.finish(18);case 21:return e.abrupt("return",t);case 22:case"end":return e.stop();}}},e,this,[[2,15,18,21]]);})),function(){return _.apply(this,arguments);})},{key:"getRemoteVideoStats",value:(m=a(n().mark(function e(){var t,i,r,a,o,s,c,u,d,l=arguments;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:t=l.length>0&&void 0!==l[0]?l[0]:zI,i={},r=I(this.connections_),e.prev=3,r.s();case 5:if((a=r.n()).done){e.next=15;break;}return(o=S(a.value,2))[0],s=o[1],e.next=9,this.stats_.getReceiverStats(s);case 9:c=e.sent,u=s.getDelay(),d=u.videoDelay,t===zI&&c.hasVideo&&(i[c.userId]={bytesReceived:c.video.bytesReceived,packetsReceived:c.video.packetsReceived,packetsLost:c.video.packetsLost,framesDecoded:c.video.framesDecoded,frameWidth:c.video.frameWidth,frameHeight:c.video.frameHeight,end2EndDelay:d}),t===JI&&c.hasAuxiliary&&(i[c.userId]={bytesReceived:c.auxiliary.bytesReceived,packetsReceived:c.auxiliary.packetsReceived,packetsLost:c.auxiliary.packetsLost,framesDecoded:c.auxiliary.framesDecoded,frameWidth:c.auxiliary.frameWidth,frameHeight:c.auxiliary.frameHeight,end2EndDelay:d});case 13:e.next=5;break;case 15:e.next=20;break;case 17:e.prev=17,e.t0=e.catch(3),r.e(e.t0);case 20:return e.prev=20,r.f(),e.finish(20);case 23:return e.abrupt("return",i);case 24:case"end":return e.stop();}}},e,this,[[3,17,20,23]]);})),function(){return m.apply(this,arguments);})},{key:"getSdpSemantics",value:function value(){return this.sdpSemantics_;}},{key:"getIceServers",value:function value(){return 0===this.turnServers_.length&&this.schedule_.iceServers?this.schedule_.iceServers:this.turnServers_;}},{key:"getConnections",value:function value(){return this.connections_;}},{key:"getMutedStates",value:function value(){return this.mutedStates_;}},{key:"startHeartbeat",value:function value(){-1===this.heartbeat_&&(this.log_.info("startHeartbeat..."),this.heartbeat_=KO.run(Sw,this.doHeartbeat.bind(this),{delay:2e3}));}},{key:"stopHeartbeat",value:function value(){-1!==this.heartbeat_&&(this.log_.info("stopHeartbeat"),KO.clearTask(this.heartbeat_),this.heartbeat_=-1,this.lastHeartBeatTime_=-1);}},{key:"doHeartbeat",value:(f=a(n().mark(function e(){var i,r,a,o,s,c;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return r=this.badCaseDetector_.getMonitorFreeze(),e.next=3,this.stats_.getStatsReport({uplinkConnection:this.uplinkConnection_,downlinkConnections:this.connections_,freezeMap:r});case 3:if(a=e.sent,DA.emit(BA,{client:this,stats:a}),null===(i=this.badCaseDetector_)||void 0===i||i.resetMonitor(),this.signalChannel_){e.next=8;break;}return e.abrupt("return");case 8:o=this.signalChannel_.isConnected()?$D(this.userId_):[],s=t(t({str_sdk_version:this.version_,uint64_datetime:new Date().getTime(),msg_user_info:{str_identifier:this.userId_,uint64_tinyid:this.tinyId_},msg_device_info:{uint32_terminal_type:15,str_device_name:navigator.platform,str_os_version:"",uint32_net_type:zE[this.networkType_]}},a),{},{msg_event_msg:o}),this.signalChannel_.send(XP,s),c=Date.now(),this.lastHeartBeatTime_>0&&c-this.lastHeartBeatTime_>1e4&&this.log_.warn("heartbeat took ".concat(c-this.lastHeartBeatTime_)),this.lastHeartBeatTime_=c,!this.isRelayChanged_&&this.isRelayMaybeFailed()&&(this.reJoin(),this.isRelayChanged_=!0);case 15:case"end":return e.stop();}}},e,this);})),function(){return f.apply(this,arguments);})},{key:"onRemoteStreamAdded",value:function value(e){var t=e.content,n=t.userId,i=t.tinyId,r=t.audio,a=t.bigVideo,o=t.auxVideo,s=t.smallVideo;if(null!==n){this.userMap_.has(n)||(this.userMap_.set(n,new Xz({userId:n,tinyId:i,role:jI})),this.emitter_.emit(PN.PEER_JOIN,{userId:n}));var c=this.connections_.get(i);if(c){if(c.getIsReconnecting())return;this.log_.warn("duplicated stream-added observed, rebuild the connection"),c.close(),this.connections_.delete(i);}var u={audio:r,video:a,auxiliary:o,smallVideo:s};this.log_.info("remote peer [".concat(n,"] published stream. trackState: ").concat(JSON.stringify(u))),this.createDownlinkConnection({userId:n,tinyId:i,trackState:u});}else this.log_.warn("received null userId on stream added");}},{key:"createDownlinkConnection",value:function value(e){var t=this,n=e.userId,i=e.tinyId,r=e.trackState,a=new qz({userId:n,tinyId:i,client:this,isUplink:!1,signalChannel:this.signalChannel_,autoSubscribe:this.autoSubscribe_,trackState:r,enableSEI:this.enableSEI_});this.connections_.set(i,a),this.installDownlinkEvents(a,n,i),this.autoSubscribe_?(a.initialize(),a.connect().catch(function(){!a.getMainStream()&&a.hasMainStream()&&t.initRemoteStream({type:zI,userId:n,downlinkConnection:a}),!a.getAuxStream()&&a.hasAuxStream()&&t.initRemoteStream({type:JI,userId:n,downlinkConnection:a});})):(a.hasMainStream()&&this.initRemoteStream({type:zI,userId:n,downlinkConnection:a}),a.hasAuxStream()&&this.initRemoteStream({type:JI,userId:n,downlinkConnection:a}));}},{key:"initRemoteStream",value:function value(e){var t=e.type,n=e.userId,i=e.downlinkConnection,r=new mz({type:t,userId:n,client:this});r.setConnection(i),i.setRemoteStream(t===zI?HI:GI,r),r.setIsStreamAddedEventEmitted(!0),DA.emit(tx,{client:this,stream:r}),this.emitter_.emit(PN.STREAM_ADDED,{stream:r});}},{key:"installDownlinkEvents",value:function value(e,t,n){var i=this;e.on(xN.SEI_MESSAGE,function(e){i.emitter_.emit(PN.SEI_MESSAGE,e);}),e.on(xN.STREAM_ADDED,function(e){e.stream.setIsStreamAddedEventEmitted(!0),DA.emit(tx,{client:i,stream:e.stream}),i.emitter_.emit(PN.STREAM_ADDED,{stream:e.stream});}),e.on(xN.STREAM_REMOVED,function(e){i.changeBigSmallRecords_.delete(e.stream.getUserId()),e.stream.stop(),e.stream.setIsStreamAddedEventEmitted(!1),i.subscriptionManager_&&i.subscriptionManager_.deleteAutoRecoveryFlag(e.stream.getUserId(),e.stream.getType()),DA.emit(ox,{client:i,stream:e.stream}),i.emitter_.emit(PN.STREAM_REMOVED,{stream:e.stream});}),e.on(xN.STREAM_UPDATED,function(e){DA.emit(ax,{client:i,stream:e.stream}),i.emitter_.emit(PN.STREAM_UPDATED,{stream:e.stream});}),e.on(xN.STREAM_SUBSCRIBED,function(e){DA.emit(ix,{client:i,stream:e.stream}),i.emitter_.emit(PN.STREAM_SUBSCRIBED,{stream:e.stream});}),e.on(xN.ERROR,function(e){var t=e.getCode();t!==hD.ICE_TRANSPORT_ERROR&&(t===hD.DOWNLINK_RECONNECTION_FAILED&&i.closeDownLink(n),i.emitter_.emit(PN.ERROR,e));});}},{key:"onPeerJoin",value:function value(e){var t=e.data.data,n=t.srcTinyId,i=t.userId,r=t.role;this.userMap_.has(i)||(this.userMap_.set(i,new Xz({userId:i,tinyId:n,role:r})),this.emitter_.emit(PN.PEER_JOIN,{userId:i}));}},{key:"onPeerLeave",value:function value(e){var t=e.data.data,n=t.srcTinyId,i=t.userId,r=t.reason,a=void 0===r?0:r;this.log_.info("peer leave [".concat(i,"]: ").concat(gw[a])),this.cleanUser({userId:i,tinyId:n});}},{key:"cleanUser",value:function value(e){var t=e.userId,n=e.tinyId;this.userMap_.delete(t),this.closeDownLink(n),this.emitter_.emit(PN.PEER_LEAVE,{userId:t});}},{key:"onPublishedUserList",value:function value(e){var t=this;try{var n=e.data.userList.map(function(e){return e.userId;});this.connections_.forEach(function(e){var i=e.getUserId(),r=e.getTinyId();n.findIndex(function(e){return e===i;})<0&&(t.log_.info("peer unpublished detected [".concat(i,"]")),t.closeDownLink(r));}),e.data.userList.forEach(function(e){var n=e.userId,i=e.srcTinyId,r=e.flag;if(n!==t.userId_){var a=!!(1&r),o=!!(8&r),s=!!(4&r),c=!!(2&r),u=t.connections_.get(i);if((c||a)&&t.checkSubscribeBigSmallVideo(u,c),u){var d=u.getTrackState(),l=d.audio,h=d.video,p=d.auxiliary,f=d.smallVideo;!h&&a&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.ADD,kind:HT}),!l&&o&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.ADD,kind:BT}),!p&&s&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.ADD,kind:JT}),!f&&c&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.ADD,kind:KT}),h&&!a&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.REMOVE,kind:HT}),l&&!o&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.REMOVE,kind:BT}),p&&!s&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.REMOVE,kind:JT}),f&&!c&&DA.emit(ex,{client:t,tinyId:i,userId:n,action:WE.REMOVE,kind:KT});}else t.log_.info("peer published detected [".concat(n,"]")),t.onRemoteStreamAdded({content:{audio:o,bigVideo:a,auxVideo:s,smallVideo:c,userId:n,tinyId:i}});}});}catch(XJ){}}},{key:"onUpdateRemoteMuteStat",value:function value(e){var t=this,n=e.data;(n&&n.userList||[]).forEach(function(e){var n=e.srcTinyId,i=e.userId;if(0!==n&&n!==t.tinyId_){var r=t.connections_.get(n);if(r){var a=r.getMainStream();if(a&&a.getIsStreamAddedEventEmitted()){var o=!!(1&e.flag),s=!!(8&e.flag),c=!!(2&e.flag),u=!!(64&e.flag),d=!!(16&e.flag),l=t.mutedStates_.get(n);if(void 0===l)return t.mutedStates_.set(n,{hasAudio:s,hasVideo:o,hasSmall:c,audioMuted:u,videoMuted:d}),o?d?t.emitter_.emit(PN.MUTE_VIDEO,{userId:i}):t.emitter_.emit(PN.UNMUTE_VIDEO,{userId:i}):t.emitter_.emit(PN.MUTE_VIDEO,{userId:i}),void(s?u?t.emitter_.emit(PN.MUTE_AUDIO,{userId:i}):t.emitter_.emit(PN.UNMUTE_AUDIO,{userId:i}):t.emitter_.emit(PN.MUTE_AUDIO,{userId:i}));var h=!u&&s;(!l.audioMuted&&l.hasAudio)!==h&&(h?t.emitter_.emit(PN.UNMUTE_AUDIO,{userId:i}):t.emitter_.emit(PN.MUTE_AUDIO,{userId:i}));var p=!d&&o;(!l.videoMuted&&l.hasVideo)!==p&&(p?t.emitter_.emit(PN.UNMUTE_VIDEO,{userId:i}):t.emitter_.emit(PN.MUTE_VIDEO,{userId:i})),t.mutedStates_.set(n,{hasAudio:s,hasVideo:o,hasSmall:c,audioMuted:u,videoMuted:d});}}else t.mutedStates_.delete(n);}});}},{key:"getEnv",value:function value(){return this.env_;}},{key:"getSubscriptionManager",value:function value(){return this.subscriptionManager_;}},{key:"startPublishCDNStream",value:(p=a(n().mark(function e(){var t,i=arguments;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(t=i.length>0&&void 0!==i[0]?i[0]:{},this.log_.info("startPublishCDNStream with params: ".concat(JSON.stringify(t),"; isJoined: ").concat(this.isJoined_,"; hasMainStream: ").concat(!!this.localStream_,"; hasAuxStream: ").concat(!!this.localAuxStream_,";")),t.streamType=t.streamType||cI,t.streamType===JT&&(t.streamType=qT),t.streamId=t.streamId||"",!this.isJoined_){e.next=10;break;}if(t.streamType!==cI||this.localStream_){e.next=8;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:xR})});case 8:if(t.streamType!==qT||this.localAuxStream_){e.next=10;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:xR})});case 10:return e.next=12,this.publishCDNManager_.startPublishTencentCDN(t);case 12:if(!(t.appId&&t.bizId&&t.url)){e.next=15;break;}return e.next=15,this.publishCDNManager_.startPublishGivenCDN(t);case 15:case"end":return e.stop();}}},e,this);})),function(){return p.apply(this,arguments);})},{key:"stopPublishCDNStream",value:(h=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.publishCDNManager_.getIsPublishingTencentCDN()){e.next=2;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:PR})});case 2:return this.log_.info("stopPublishCDNStream"),e.next=5,this.publishCDNManager_.stopPublishTencentCDN();case 5:if(!this.publishCDNManager_.getIsPublishingGivenCDN()){e.next=8;break;}return e.next=8,this.publishCDNManager_.stopPublishGivenCDN();case 8:case"end":return e.stop();}}},e,this);})),function(){return h.apply(this,arguments);})},{key:"startMixTranscode",value:(l=a(n().mark(function e(t){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.isJoined_&&this.mixTranscodeManager_){e.next=2;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:MR})});case 2:return cA(t.mode)&&(t.mode=LE.MANUAL),e.prev=3,this.log_.info("startMixTranscode with config ".concat(JSON.stringify(t))),nO.uploadEvent({log:"mix-transcode-mode:".concat(t.mode),userId:this.userId_}),e.next=8,this.mixTranscodeManager_.startMixTranscode(t);case 8:nO.logSuccessEvent({userId:this.userId_,eventType:CE}),e.next=15;break;case 11:throw e.prev=11,e.t0=e.catch(3),nO.logFailedEvent({userId:this.userId_,eventType:CE,error:e.t0}),e.t0;case 15:case"end":return e.stop();}}},e,this,[[3,11]]);})),function(e){return l.apply(this,arguments);})},{key:"stopMixTranscode",value:(d=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(this.isJoined_&&this.mixTranscodeManager_){e.next=2;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:LR})});case 2:return e.prev=2,e.next=5,this.mixTranscodeManager_.stopMixTranscode();case 5:nO.logSuccessEvent({userId:this.userId_,eventType:AE}),e.next=12;break;case 8:throw e.prev=8,e.t0=e.catch(2),nO.logFailedEvent({userId:this.userId_,eventType:AE,error:e.t0}),e.t0;case 12:case"end":return e.stop();}}},e,this,[[2,8]]);})),function(){return d.apply(this,arguments);})},{key:"getSystemResult",value:function value(){return this.checkSystemResult_;}},{key:"enableAudioVolumeEvaluation",value:function value(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:2e3,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!dA(t))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:UR})});if(this.log_.info("enableAudioVolumeEvaluation with interval: "+t),t<=0)return this.enableAudioVolumeEvaluation_=!1,KO.clearTask(this.audioVolumeIntervalId_),void(this.audioVolumeIntervalId_=null);t=Math.floor(Math.max(t,16)),DA.emit(QA,{interval:t}),this.audioVolumeIntervalId_&&(KO.clearTask(this.audioVolumeIntervalId_),this.audioVolumeIntervalId_=null),this.enableAudioVolumeEvaluation_=!0,this.audioVolumeIntervalId_=KO.run(kw,function(){var t=[];if(e.localStream_){var n=Math.floor(100*e.localStream_.getAudioLevel());t.push({userId:e.userId_,audioVolume:n,stream:e.localStream_});}e.connections_.forEach(function(e){var n=e.getSubscribedMainStream();if(n){var i=Math.floor(100*n.getAudioLevel());t.push({userId:e.getUserId(),audioVolume:i,stream:n});}}),e.emitter_.emit(PN.AUDIO_VOLUME,{result:t});},{fps:1e3/t,backgroundTask:n});}},{key:"callExperimentalAPI",value:function value(e,n){return UJ.call(e,t({client:this},n));}},{key:"setProperty",value:function value(e,t){var n="".concat(e,"_");cA(this[n])||(this[n]=t);}},{key:"uploadAllCallStats",value:function value(){var e=this;this.callDurationCalculator_.getDurationMap().forEach(function(t,n){var i={userId:t.userId,type:t.type,duration:e.callDurationCalculator_.getDuration(n,HT),dataFreeze:e.badCaseDetector_.getDataFreezeDuration(n).dataFreeze,renderFreeze:e.badCaseDetector_.getRenderFreezeDuration(n).renderFreeze};nO.uploadEvent({log:"callStats-"+JSON.stringify(i),userId:e.userId_});}),this.badCaseDetector_.stop(),this.callDurationCalculator_.reset();}},{key:"enableSmallStream",value:(u=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!this.isPublished()&&!this.isPublishing_){e.next=2;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:VR})});case 2:if(!wN()){e.next=7;break;}this.setIsEnableSmallStream(!0),this.log_.info("SmallStream successfully enabled"),e.next=8;break;case 7:throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:jR})});case 8:case"end":return e.stop();}}},e,this);})),function(){return u.apply(this,arguments);})},{key:"disableSmallStream",value:(s=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!this.isPublished()&&!this.isPublishing_){e.next=2;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:FR})});case 2:this.setIsEnableSmallStream(!1),this.log_.info("SmallStream successfully disabled");case 4:case"end":return e.stop();}}},e,this);})),function(){return s.apply(this,arguments);})},{key:"setSmallStreamProfile",value:function value(e){var t=this;e&&e.framerate&&(e.frameRate=e.framerate),e.width*e.height>307200&&(e.width=320,e.height=240,this.log_.info("Small stream resolution is beyond limitation, which is invalid. Reset to 320 * 240")),Object.keys(this.smallStreamConfig_).forEach(function(n){e[n]&&(t.smallStreamConfig_[n]=e[n]);});var n=this.smallStreamConfig_,i=n.width,r=n.height,a=n.bitrate,o=n.frameRate;if(this.log_.info("setSmallStreamProfile: bitrate=".concat(a,", frameRate=").concat(o,", height=").concat(r,", width=").concat(i)),i<0||r<0||a<0||o<0)throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:BR})});}},{key:"setRemoteVideoStreamType",value:(r=a(n().mark(function e(t,i){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(t instanceof mz){e.next=2;break;}throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:HR})});case 2:if(t.getConnection()){e.next=4;break;}throw new pD({code:hD.INVALID_OPERATION,message:ZC({key:TR})});case 4:if(t.getType()!==JI){e.next=6;break;}return e.abrupt("return");case 6:e.t0=i,e.next=e.t0===QE||e.t0===XE?9:12;break;case 9:return e.next=11,this.changeVideoType(t,i);case 11:case 12:return e.abrupt("break",13);case 13:case"end":return e.stop();}}},e,this);})),function(e,t){return r.apply(this,arguments);})},{key:"changeVideoType",value:(i=a(n().mark(function e(t,i){var r,a;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:r=t.getUserId(),a={stream:t,options:{video:i===QE,smallVideo:i===XE},isSubscribing:!1,reSubscribeCount:10},this.changeBigSmallRecords_.set(r,a),this.log_.info("set [".concat(r,"] ").concat(t.getType()," stream video prefer type: ").concat(i));case 5:case"end":return e.stop();}}},e,this);})),function(e,t){return i.apply(this,arguments);})},{key:"checkSubscribeBigSmallVideo",value:(e=a(n().mark(function e(t,i){var r,a,o,s,c,u,d,l,h,p,f;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(null!=t&&t.isBigStreamSubscribed||null!=t&&t.isSmallStreamSubscribed){e.next=2;break;}return e.abrupt("return");case 2:if(r=t.getUserId(),this.changeBigSmallRecords_.has(r)){e.next=5;break;}return e.abrupt("return");case 5:if(a=this.changeBigSmallRecords_.get(r),o=t.getSubscribeState(),s=o.video,c=o.smallVideo,u=a.stream,d=a.options,l=a.isSubscribing,h=a.reSubscribeCount,!(d.video&&s||d.smallVideo&&c&&i)){e.next=10;break;}return e.abrupt("return");case 10:if(p={video:d.video,smallVideo:d.smallVideo},!(i&&t.isBigStreamSubscribed||t.isSmallStreamSubscribed)){e.next=31;break;}if(e.prev=12,!(d&&u&&!l&&h>=1)){e.next=24;break;}return a.isSubscribing=!0,a.reSubscribeCount=h-1,f=u.getConnection(),!i&&f.isSmallStreamSubscribed&&(p={video:!0,smallVideo:!1}),p.emitEvent=!1,e.next=21,null==f?void 0:f.subscribe(u,p);case 21:this.log_.info("change [".concat(r,"] to ").concat(p.smallVideo?"small":"big"," video successfully. count ").concat(10-a.reSubscribeCount,".")),a.isSubscribing=!1,a.reSubscribeCount=10;case 24:e.next=31;break;case 26:e.prev=26,e.t0=e.catch(12),this.log_.info("change [".concat(r,"] to ").concat(p.smallVideo?"small":"big"," video failed. count ").concat(10-a.reSubscribeCount,".")),a.isSubscribing=!1,0===h&&this.changeBigSmallRecords_.delete(r);case 31:case"end":return e.stop();}}},e,this,[[12,26]]);})),function(t,n){return e.apply(this,arguments);})},{key:"setIsEnableSmallStream",value:function value(e){this.isEnableSmallStream_=e;}},{key:"getIsEnableSmallStream",value:function value(){return this.isEnableSmallStream_;}},{key:"smallStreamConfig",get:function get(){return this.smallStreamConfig_;}},{key:"isPublished",value:function value(){return!!this.localStream_;}},{key:"getUplinkConnection",value:function value(){return this.uplinkConnection_;}},{key:"getLocalStream",value:function value(){return this.localStream_;}},{key:"getMode",value:function value(){return this.mode_;}},{key:"getBadCaseDetector",value:function value(){return this.badCaseDetector_;}},{key:"getCallDurationCalculator",value:function value(){return this.callDurationCalculator_;}},{key:"getIsJoined",value:function value(){return this.isJoined_;}},{key:"getAllConnections",value:function value(){var e=k(this.connections_.values());return this.uplinkConnection_&&e.push(this.uplinkConnection_),e;}},{key:"isRelayMaybeFailed",value:function value(){if(!this.signalChannel_.isOnline)return!1;var e=this.getAllConnections();if(0===e.length)return!1;for(var t=0;t<e.length;t++){if(e[t].getReconnectionCount()<6)return!1;}return!0;}},{key:"getUseStringRoomId",value:function value(){return this.useStringRoomId_;}},{key:"checkConnectionsToReconnect",value:function value(){var e=this;this.getAllConnections().forEach(function(t){if(!t.getIsReconnecting()){var n=t.getPeerConnection();n&&n.connectionState===tE&&(e.log_.warn("[".concat(t.getUserId(),"] pc is closed but not reconnect")),t.startReconnection());}});}},{key:"getEnableAutoPlayDialog",value:function value(){return this.enableAutoPlayDialog_;}},{key:"sendSEIMessage",value:function value(e,t){this.uplinkConnection_.sendSEI(e,t);}},{key:"setProxyServer",value:function value(e){if(this.log_.info("set proxy server: ".concat(JSON.stringify(e))),uA(e)){if(!e.startsWith("wss://"))throw new pD({code:hD.INVALID_PARAMETER,message:ZC({key:dR})});this.proxy_=e;}else if(rA(e)){var t=e.websocketProxy,n=e.loggerProxy;t&&(this.proxy_=t),n&&NI(n);}}},{key:"setTurnServer",value:function value(e){this.log_.info("set turn server: "+JSON.stringify(e));var t=[];Array.isArray(e)?e.forEach(function(e){return t.push(_A(e));}):rA(e)&&t.push(_A(e)),this.turnServers_=t;}},{key:"get2k4kFlag",value:function value(){var e,t;return null===(e=this.schedule_)||void 0===e||null===(t=e.trtcCapability)||void 0===t?void 0:t["2k4k"];}}]),Client;}(),E(MJ.prototype,"join",[yJ,SJ],Object.getOwnPropertyDescriptor(MJ.prototype,"join"),MJ.prototype),E(MJ.prototype,"leave",[kJ],Object.getOwnPropertyDescriptor(MJ.prototype,"leave"),MJ.prototype),E(MJ.prototype,"getUserList",[bJ],Object.getOwnPropertyDescriptor(MJ.prototype,"getUserList"),MJ.prototype),E(MJ.prototype,"publish",[TJ,IJ],Object.getOwnPropertyDescriptor(MJ.prototype,"publish"),MJ.prototype),E(MJ.prototype,"unpublish",[EJ,wJ],Object.getOwnPropertyDescriptor(MJ.prototype,"unpublish"),MJ.prototype),E(MJ.prototype,"subscribe",[RJ],Object.getOwnPropertyDescriptor(MJ.prototype,"subscribe"),MJ.prototype),E(MJ.prototype,"unsubscribe",[CJ],Object.getOwnPropertyDescriptor(MJ.prototype,"unsubscribe"),MJ.prototype),E(MJ.prototype,"switchRole",[AJ,xJ],Object.getOwnPropertyDescriptor(MJ.prototype,"switchRole"),MJ.prototype),E(MJ.prototype,"startPublishCDNStream",[PJ],Object.getOwnPropertyDescriptor(MJ.prototype,"startPublishCDNStream"),MJ.prototype),E(MJ.prototype,"startMixTranscode",[DJ],Object.getOwnPropertyDescriptor(MJ.prototype,"startMixTranscode"),MJ.prototype),E(MJ.prototype,"sendSEIMessage",[OJ,NJ],Object.getOwnPropertyDescriptor(MJ.prototype,"sendSEIMessage"),MJ.prototype),MJ),JJ=0,qJ=0,KJ=(HJ=dz(uz.TRTC.createClient),GJ=dz(uz.TRTC.createStream),WJ=function(){function e(){o(this,e),this.name_=nw,this.VERSION=Bo,this.Logger={loggerManager:xx,LogLevel:_w,setLogLevel:function setLogLevel(e){xx.setLogLevel(e),e<=1&&$C();},enableUploadLog:function enableUploadLog(){xx.enableUploadLog();},disableUploadLog:function disableUploadLog(){xx.warn("disableUploadLog"),xx.disableUploadLog();}};}var i,r,s,u,d;return c(e,[{key:"checkSystemRequirements",value:(d=a(n().mark(function e(){return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.next=2,sN();case 2:return e.abrupt("return",e.sent);case 3:case"end":return e.stop();}}},e);})),function(){return d.apply(this,arguments);})},{key:"isScreenShareSupported",value:function value(){return dN();}},{key:"isSmallStreamSupported",value:function value(){return wN();}},{key:"getDevices",value:(u=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!gN()&&!vN()){e.next=2;break;}return e.abrupt("return",[]);case 2:return e.next=4,navigator.mediaDevices.enumerateDevices();case 4:return t=e.sent,e.abrupt("return",t.filter(function(e){return e.kind!==rI||e.deviceId!=mw;}).map(function(e,t){var n=e.label;e.label||(n=e.kind+"_"+t);var i={label:n,deviceId:e.deviceId,kind:e.kind};return e.groupId&&(i.groupId=e.groupId),e.getCapabilities&&(i.getCapabilities=function(){return e.getCapabilities();}),i;}));case 6:case"end":return e.stop();}}},e);})),function(){return u.apply(this,arguments);})},{key:"getCameras",value:(s=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!gN()&&!vN()){e.next=2;break;}return e.abrupt("return",[]);case 2:return e.next=4,navigator.mediaDevices.enumerateDevices();case 4:return t=e.sent,e.abrupt("return",t.filter(function(e){return e.kind===aI;}).map(function(e,t){var n=e.label;e.label||(n="camera_"+t);var i={label:n,deviceId:e.deviceId,kind:e.kind};return e.groupId&&(i.groupId=e.groupId),e.getCapabilities&&(i.getCapabilities=function(){return e.getCapabilities();}),i;}));case 6:case"end":return e.stop();}}},e);})),function(){return s.apply(this,arguments);})},{key:"getMicrophones",value:(r=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!gN()&&!vN()){e.next=2;break;}return e.abrupt("return",[]);case 2:return e.next=4,navigator.mediaDevices.enumerateDevices();case 4:return t=e.sent,e.abrupt("return",t.filter(function(e){return e.kind===rI&&e.deviceId!==mw;}).map(function(e,t){var n=e.label;e.label||(n="microphone_"+t);var i={label:n,deviceId:e.deviceId,kind:e.kind};return e.groupId&&(i.groupId=e.groupId),e.getCapabilities&&(i.getCapabilities=function(){return e.getCapabilities();}),i;}));case 6:case"end":return e.stop();}}},e);})),function(){return r.apply(this,arguments);})},{key:"getSpeakers",value:(i=a(n().mark(function e(){var t;return n().wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!gN()&&!vN()){e.next=2;break;}return e.abrupt("return",[]);case 2:return e.next=4,navigator.mediaDevices.enumerateDevices();case 4:return t=e.sent,e.abrupt("return",t.filter(function(e){return"audiooutput"===e.kind;}).map(function(e,t){var n=e.label;e.label||(n="speaker_"+t);var i={label:n,deviceId:e.deviceId,kind:e.kind};return e.groupId&&(i.groupId=e.groupId),i;}));case 6:case"end":return e.stop();}}},e);})),function(){return i.apply(this,arguments);})},{key:"createClient",value:function value(e){Px&&(Px=!1,xx.getLogLevel()!=QJ.Logger.LogLevel.NONE&&(console.info("******************************************************************************"),console.info("*   TRTC Web SDK"),console.info("*   API Document: "+"".concat(hw,"index.html")),console.info("*   Changelog: https://cloud.tencent.com/document/product/647/38958"),console.info("*   Report issues: https://github.com/LiteAVSDK/TRTC_Web/issues"),console.info("******************************************************************************")),xx.info("TRTC Web SDK Version: 4.15.5"),xx.info("UserAgent: "+navigator.userAgent),xx.info("URL of current page: "+location.href));var n={version:this.VERSION},i=new zJ(t(t(t({},n),e),{},{seq:++JJ}));return DA.emit(JA,{client:i}),i;}},{key:"createStream",value:function value(e){return new Wz(t(t({},e),{},{seq:++qJ}));}}]),e;}(),E(WJ.prototype,"createClient",[HJ],Object.getOwnPropertyDescriptor(WJ.prototype,"createClient"),WJ.prototype),E(WJ.prototype,"createStream",[GJ],Object.getOwnPropertyDescriptor(WJ.prototype,"createStream"),WJ.prototype),WJ),QJ=new KJ();return QJ;});/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(57));/***/},/* 57 *//***/function(module,exports){var g;// This works in non-strict mode
g=function(){return this;}();try{// This works if eval is allowed (see CSP)
g=g||Function("return this")()||(1,eval)("this");}catch(e){// This works if the window reference is available
if((typeof window==='undefined'?'undefined':_typeof2(window))==="object")g=window;}// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}
module.exports=g;/***/},/* 58 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rtcPlayer",staticClass:"rtc-player"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showWatermark,expression:"showWatermark"}],staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)","text-align":"center","font-size":"89px","color":"black","white-space":"nowrap","min-width":"300px","min-height":"100px","background-color":"red","word-break":"break-word"},style:{fontSize:_vm.isfullScreen?'200px':'89px'},attrs:{"id":"id_rtc_video_watermark"}},[_vm._v("助教ID:"+_vm._s(_vm.staff_id))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMiniWindow,expression:"!isMiniWindow"}],staticClass:"controns",on:{"mouseover":_vm.mouseOver,"mousemove":_vm.mousemove,"mouseleave":_vm.mouseLeave}},[_c('div',{staticClass:"main"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showLoading,expression:"showLoading"}],staticClass:"loading-box"},[_c('img',{staticClass:"loading-image",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/loading2.gif"}}),_vm._v(" "),_c('div',[_vm._v("网络加载中，请稍后")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showControns,expression:"showControns"}],staticClass:"bottomView"},[_c('img',{staticClass:"shuaxing",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_refresh.png"},on:{"click":_vm.shuaxingCliked}}),_vm._v(" "),_vm.showH5Xianlu&&!_vm.isfullScreen?_c('span',{staticClass:"xianlu",staticStyle:{"float":"left","margin-left":"20px"},on:{"click":function click($event){return _vm.$emit('showH5XianluAlert');}}},[_vm._v("线路")]):_vm._e(),_vm._v(" "),_vm.isPc&&_vm.isThreeScreen?_c('img',{staticClass:"quanping",staticStyle:{"margin-right":"20px"},attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_pop_window.png"},on:{"click":function click($event){return _vm.$emit('cutSwitch');}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_fullscreen.png"},on:{"click":_vm.quanpingCliked}}),_vm._v(" "),_c('div',{staticClass:"voiceBox"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.isMuted,expression:"isMuted"}],staticClass:"jingying",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_voice_mute.png"},on:{"click":_vm.jingyingClicked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMuted,expression:"!isMuted"}],staticClass:"yingliang",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/sh_voice.png","width":"21px"},on:{"click":_vm.jingyingClicked}})]),_vm._v(" "),!_vm.isPc&&_vm.isShowMiniWindowIcon&&!_vm.isfullScreen?_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/cutscreen.png"},on:{"click":function click($event){$event.stopPropagation();return _vm.$emit('miniWidowsClick');}}}):_vm._e(),_vm._v(" "),_vm.isPc?_c('span',{staticClass:"xianlu",on:{"click":function click($event){_vm.showXianLuBox=!_vm.showXianLuBox;}}},[_vm._v("线路")]):_vm._e(),_vm._v(" "),_vm.showXianLuBox?_c('div',{staticClass:"xianluBox"},[_c('p',{on:{"click":function click($event){return _vm.changePlayType(2);}}},[_vm._v("普通直播")]),_vm._v(" "),_c('p',{on:{"click":function click($event){return _vm.changePlayType(1);}}},[_vm._v("低延迟线路1")]),_vm._v(" "),_c('p',{on:{"click":function click($event){return _vm.changePlayType(3);}}},[_vm._v("低延迟线路2")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"webRtcVideoBox"},[_c('video',{ref:"rtcVideo",style:{'object-fit':_vm.objectFit},attrs:{"id":"rtcVideo"+_vm.playerid,"x5-video-player-type":"h5","x5-video-player-fullscreen":"true","preload":"auto","controlslist":"nodownload","playsinline":"","webkit-inline":"","webkit-playsinline":"","x-webkit-airplay":"allow"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.copyrightObj&&_vm.copyrightObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.copyrightObj&&_vm.copyrightObj.open,expression:"(copyrightObj&&copyrightObj.open&&isThird)||(isfullScreen&&copyrightObj&&copyrightObj.open)"}],staticClass:"copyright",style:{opacity:_vm.copyrightObj.copyrightTrans},attrs:{"id":"copyrightFour"}},[_c('div',{staticClass:"banquanText"},[_vm._v("\n          "+_vm._s(_vm.copyrightObj.inputValue)+"\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.runObj&&_vm.runObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.runObj&&_vm.runObj.open,expression:"(runObj&&runObj.open&&isThird)||(isfullScreen&&runObj&&runObj.open)"}],ref:"runBoxRef",staticClass:"runBox"},[_c('div',{staticClass:"runboxChild",class:{'rotate':_vm.rotateRunBox},style:{left:_vm.boxLeft+'px',top:_vm.boxTop+'px'},attrs:{"id":"runChilder"}},[_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_c('span',[_vm._v(_vm._s(_vm.nick))]),_vm.runObj.remark?_c('span',[_vm._v("("+_vm._s(_vm.remark)+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_vm._v(_vm._s(_vm.fans_id))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"webRtcVideoBoxAudio"+_vm.playerid}})])]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};__webpack_exports__["a"]=esExports;/***/},/* 59 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__=__webpack_require__(17);/* unused harmony namespace reexport *//* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb2345b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__=__webpack_require__(74);function injectStyle(ssrContext){__webpack_require__(60);}var normalizeComponent=__webpack_require__(3);/* script *//* template *//* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-6cb2345b";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a"/* default */],__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb2345b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a"/* default */],__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */__webpack_exports__["a"]=Component.exports;/***/},/* 60 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(61);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("0069f40f",content,true,{});/***/},/* 61 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,"",""]);// exports
/***/},/* 62 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VodPlayer_vue__=__webpack_require__(18);/* unused harmony namespace reexport *//* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db745880_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VodPlayer_vue__=__webpack_require__(65);function injectStyle(ssrContext){__webpack_require__(63);}var normalizeComponent=__webpack_require__(3);/* script *//* template *//* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-db745880";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VodPlayer_vue__["a"/* default */],__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db745880_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VodPlayer_vue__["a"/* default */],__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */__webpack_exports__["a"]=Component.exports;/***/},/* 63 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(64);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("f50f0550",content,true,{});/***/},/* 64 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,".rotate[data-v-db745880]{transform:rotate(90deg)}.runboxChild[data-v-db745880]{position:absolute}.runBox[data-v-db745880]{height:100%}.copyright[data-v-db745880],.runBox[data-v-db745880]{position:absolute;top:0;left:0;width:100%;overflow:hidden}.copyright[data-v-db745880]{background-color:#000;color:#fff;line-height:50px;height:50px;white-space:nowrap}.banquanText[data-v-db745880]{font-size:24px;width:100%;position:absolute;animation:slideText-data-v-db745880 25s linear infinite}@keyframes slideText-data-v-db745880{0%{transform:translateX(100%)}to{transform:translateX(-100%)}}.vod-player[data-v-db745880]{width:100%;height:100%;position:relative}.vod-player .coverImg[data-v-db745880]{z-index:89;position:absolute;top:0;left:0;width:100%;height:100%}.vod-player .playBtn[data-v-db745880]{z-index:91;width:10%}.vod-player .loadingHud[data-v-db745880],.vod-player .playBtn[data-v-db745880]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer}.vod-player .loadingHud[data-v-db745880]{z-index:90}.vod-player .id_video_vod_tengface[data-v-db745880]{z-index:1;width:100%;height:100%;position:absolute;top:0;left:0}.vod-player .controns[data-v-db745880]{width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden;z-index:88}.vod-player .controns .main[data-v-db745880]{width:100%;height:100%;position:relative}.vod-player .controns .main .bottomView[data-v-db745880]{position:absolute;bottom:0;left:0;width:100%;height:50px;background-color:rgba(0,0,0,.6)}.vod-player .main .bottomView .shuaxing[data-v-db745880]{float:left;margin-top:13px;margin-left:16px;width:24px;cursor:pointer}.vod-player .main .bottomView .quanping[data-v-db745880]{float:right;margin-right:16px;margin-top:14px;width:22px;cursor:pointer}.vod-player .main .bottomView .timesSpeed[data-v-db745880]{float:right;margin-right:16px;margin-top:10px;width:48px;text-align:center;line-height:28px;cursor:pointer;color:#fff;font-size:14px;border-radius:10px}.vod-player .main .bottomView .timesSpeed[data-v-db745880]:hover{background-color:#1872ed}.vod-player .main .timesListView[data-v-db745880]{width:68px;background:rgba(0,0,0,.7);position:absolute;bottom:10px;right:94px;font-size:14px;z-index:100;text-align:center}.vod-player .main .timesListView p[data-v-db745880]{margin-top:0;cursor:pointer;margin-bottom:0;color:#fff;line-height:26px}.vod-player .main .speedSelect[data-v-db745880],.vod-player .main .timesListView p[data-v-db745880]:hover{background-color:#1872ed}.jingying[data-v-db745880],.vod-player .main .bottomView .yingliang[data-v-db745880]{float:right;margin-right:20px;margin-top:12px;width:26px;cursor:pointer}.vod-player .main .progress[data-v-db745880]{background-color:#e2e2dc;height:6px;width:100%;position:relative;cursor:pointer}.vod-player .main .progress .tf_progress_point[data-v-db745880]{width:12px;height:12px;background-color:#fff;position:absolute;border-radius:6px;transform:translateY(-50%);top:50%;left:0;z-index:1}.vod-player .main .progress .tf_progress_view[data-v-db745880]{width:0;height:6px;background-color:#1872ed;position:absolute;top:0;left:0;pointer-events:none}.vod-player .videoTimeBox[data-v-db745880]{color:#fff;float:left;font-size:12px;margin-top:18px;margin-left:20px}.vod-player .videoTimeTips[data-v-db745880]{position:absolute;left:50%;transform:translateX(-50%);top:10px;background:#000;color:#fff;font-size:13px}.vod-player .controns .main .topView[data-v-db745880]{position:absolute;top:0;left:0;width:100%;height:calc(100% - 65px)}",""]);// exports
/***/},/* 65 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vodPlayer",staticClass:"vod-player"},[!_vm.isWhitebord?[_vm.playerStatus=='init'||_vm.playerStatus=='pause'?_c('img',{staticClass:"playBtn",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/shanhu_play.png"},on:{"click":_vm.playClicked}}):_vm._e(),_vm._v(" "),_vm.playerStatus=='init'&&_vm.videoPoster!=''?_c('img',{staticClass:"coverImg",attrs:{"src":_vm.videoPoster},on:{"click":_vm.playClicked}}):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.playerStatus=='load',expression:"playerStatus == 'load'"}],staticClass:"loadingHud"},[_c('img',{staticStyle:{"width":"40px"},attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/loading.gif"}}),_vm._v(" "),_c('div',[_vm._v("加载中....")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:!_vm.isWhitebord,expression:"!isWhitebord"}],staticClass:"controns",on:{"mouseover":_vm.mouseOver,"mousemove":_vm.mousemove,"mouseleave":_vm.mouseLeave}},[_c('div',{ref:"tengface_vod_mainView",staticClass:"main",on:{"dblclick":_vm.shuaxingCliked}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.isSwifeMove,expression:"isSwifeMove"}],staticClass:"videoTimeTips"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.time2String(_vm.bodyTouchCurrentTimer))+"/"+_vm._s(_vm.time2String(_vm.videoDuration))+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"topView",style:{height:_vm.showControns?'calc(100% - 65px)':'100%'},on:{"touchstart":_vm.bodyTouchStart,"touchmove":_vm.bodyTouchMove,"touchend":_vm.bodyTouchEnd}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showControns,expression:"showControns"}],ref:"tengface_vod_bottomView",staticClass:"bottomView"},[_c('div',{ref:"tf_vod_progress_view",staticClass:"progress",on:{"click":_vm.onProgressClicked}},[_c('div',{ref:"tf_progress_point",staticClass:"tf_progress_point",style:{left:_vm.posi+'px'},on:{"touchstart":_vm.onTouchStart,"touchmove":_vm.onTouchMove,"touchend":_vm.onTouchEnd,"touchcancel":_vm.onTouchEnd}}),_vm._v(" "),_c('div',{ref:"tf_progress_view",staticClass:"tf_progress_view"})]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.playerStatus!='playing',expression:"playerStatus != 'playing'"}],staticClass:"shuaxing",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/shanhu_pause.png"},on:{"click":_vm.shuaxingCliked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.playerStatus=='playing',expression:"playerStatus == 'playing'"}],staticClass:"shuaxing",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/player_pause.png"},on:{"click":_vm.shuaxingCliked}}),_vm._v(" "),_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/quanping.png"},on:{"click":_vm.quanpingCliked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.isMuted,expression:"isMuted"}],staticClass:"jingying",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/jingyin.png"},on:{"click":_vm.jingyingClicked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMuted,expression:"!isMuted"}],staticClass:"yingliang",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/yinliang.png"},on:{"click":_vm.jingyingClicked}}),_vm._v(" "),_c('div',{staticClass:"timesSpeed",on:{"click":function click($event){_vm.timesListViewShow=!_vm.timesListViewShow;}}},[_vm._v(_vm._s(_vm.playSpeed)+"x")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.timesListViewShow,expression:"timesListViewShow"}],staticClass:"timesListView"},[!_vm.iOS?[_c('p',{class:{'speedSelect':_vm.playSpeed==3},on:{"click":function click($event){return _vm.changePlaySpeed(3);}}},[_vm._v("3x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==2.5},on:{"click":function click($event){return _vm.changePlaySpeed(2.5);}}},[_vm._v("2.5x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==2.25},on:{"click":function click($event){return _vm.changePlaySpeed(2.25);}}},[_vm._v("2.25x")])]:_vm._e(),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==2},on:{"click":function click($event){return _vm.changePlaySpeed(2);}}},[_vm._v("2x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==1.5},on:{"click":function click($event){return _vm.changePlaySpeed(1.5);}}},[_vm._v("1.5x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==1.25},on:{"click":function click($event){return _vm.changePlaySpeed(1.25);}}},[_vm._v("1.25x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==1},on:{"click":function click($event){return _vm.changePlaySpeed(1);}}},[_vm._v("1x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==0.75},on:{"click":function click($event){return _vm.changePlaySpeed(0.75);}}},[_vm._v("0.75x")])],2),_vm._v(" "),_vm.videoDuration>0?_c('div',{staticClass:"videoTimeBox"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.time2String(_vm.currentPlayTime))+"/"+_vm._s(_vm.time2String(_vm.videoDuration))+"\n\t\t\t\t\t")]):_vm._e()])])]),_vm._v(" "),_c('video',{ref:"videoVodTengface",staticClass:"id_video_vod_tengface",staticStyle:{"width":"100%","height":"100%"},style:{'object-fit':_vm.objectFit},attrs:{"id":"id_video_vod_tengface"+_vm.playerid,"x5-video-player-type":"h5","x5-video-player-fullscreen":"true","playsinline":"","webkit-inline":"","webkit-playsinline":"","x-webkit-airplay":"allow"},domProps:{"muted":_vm.isWhitebord}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.copyrightObj&&_vm.copyrightObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.copyrightObj&&_vm.copyrightObj.open,expression:"(copyrightObj&&copyrightObj.open&&isThird)||(isfullScreen&&copyrightObj&&copyrightObj.open)"}],staticClass:"copyright",style:{opacity:_vm.copyrightObj.copyrightTrans},attrs:{"id":"copyrightONE"}},[_c('div',{staticClass:"banquanText"},[_vm._v("\n          "+_vm._s(_vm.copyrightObj.inputValue)+"\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.runObj&&_vm.runObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.runObj&&_vm.runObj.open,expression:"(runObj&&runObj.open&&isThird)||(isfullScreen&&runObj&&runObj.open)"}],ref:"runBoxRef",staticClass:"runBox"},[_c('div',{staticClass:"runboxChild",class:{'rotate':_vm.rotateRunBox},style:{left:_vm.boxLeft+'px',top:_vm.boxTop+'px'},attrs:{"id":"runChilder"}},[_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_c('span',[_vm._v(_vm._s(_vm.nick))]),_vm.runObj.remark?_c('span',[_vm._v("("+_vm._s(_vm.remark)+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_vm._v(_vm._s(_vm.fans_id))])])])],2);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};__webpack_exports__["a"]=esExports;/***/},/* 66 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canvasPlayer_vue__=__webpack_require__(19);/* unused harmony namespace reexport *//* harmony import */var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1a6b86_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canvasPlayer_vue__=__webpack_require__(73);function injectStyle(ssrContext){__webpack_require__(67);}var normalizeComponent=__webpack_require__(3);/* script *//* template *//* template functional */var __vue_template_functional__=false;/* styles */var __vue_styles__=injectStyle;/* scopeId */var __vue_scopeId__="data-v-0c1a6b86";/* moduleIdentifier (server only) */var __vue_module_identifier__=null;var Component=normalizeComponent(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canvasPlayer_vue__["a"/* default */],__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1a6b86_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canvasPlayer_vue__["a"/* default */],__vue_template_functional__,__vue_styles__,__vue_scopeId__,__vue_module_identifier__);/* harmony default export */__webpack_exports__["a"]=Component.exports;/***/},/* 67 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(68);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("8509c65a",content,true,{});/***/},/* 68 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,".rotate[data-v-0c1a6b86]{transform:rotate(90deg)}.runboxChild[data-v-0c1a6b86]{position:absolute}.runBox[data-v-0c1a6b86]{height:100%}.copyright[data-v-0c1a6b86],.runBox[data-v-0c1a6b86]{position:absolute;top:0;left:0;width:100%;overflow:hidden}.copyright[data-v-0c1a6b86]{background-color:#000;color:#fff;line-height:50px;height:50px;white-space:nowrap}.banquanText[data-v-0c1a6b86]{font-size:24px;width:100%;position:absolute;animation:slideText-data-v-0c1a6b86 25s linear infinite}@keyframes slideText-data-v-0c1a6b86{0%{transform:translateX(100%)}to{transform:translateX(-100%)}}.vod-player[data-v-0c1a6b86]{width:100%;height:100%;position:relative}.vod-player .coverImg[data-v-0c1a6b86]{z-index:89;position:absolute;top:0;left:0;width:100%;height:100%}.vod-player .playBtn[data-v-0c1a6b86]{z-index:91;width:10%}.vod-player .loadingHud[data-v-0c1a6b86],.vod-player .playBtn[data-v-0c1a6b86]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer}.vod-player .loadingHud[data-v-0c1a6b86]{z-index:90}.vod-player .id_video_vod_tengface[data-v-0c1a6b86]{z-index:1;width:100%;height:100%;position:absolute;top:0;left:0}.vod-player .controns[data-v-0c1a6b86]{width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden;z-index:88}.vod-player .controns .main[data-v-0c1a6b86]{width:100%;height:100%;position:relative}.vod-player .controns .main .bottomView[data-v-0c1a6b86]{position:absolute;bottom:0;left:0;width:100%;height:50px;background-color:rgba(0,0,0,.6)}.vod-player .main .bottomView .shuaxing[data-v-0c1a6b86]{float:left;margin-top:13px;margin-left:16px;width:24px;cursor:pointer}.vod-player .main .bottomView .quanping[data-v-0c1a6b86]{float:right;margin-right:16px;margin-top:14px;width:22px;cursor:pointer}.vod-player .main .bottomView .timesSpeed[data-v-0c1a6b86]{float:right;margin-right:16px;margin-top:10px;width:48px;text-align:center;line-height:28px;cursor:pointer;color:#fff;font-size:14px;border-radius:10px}.vod-player .main .bottomView .timesSpeed[data-v-0c1a6b86]:hover{background-color:#1872ed}.vod-player .main .timesListView[data-v-0c1a6b86]{width:68px;background:rgba(0,0,0,.7);position:absolute;bottom:10px;right:94px;font-size:14px;z-index:100;text-align:center}.vod-player .main .timesListView p[data-v-0c1a6b86]{margin-top:0;cursor:pointer;margin-bottom:0;color:#fff;line-height:26px}.vod-player .main .speedSelect[data-v-0c1a6b86],.vod-player .main .timesListView p[data-v-0c1a6b86]:hover{background-color:#1872ed}.jingying[data-v-0c1a6b86],.vod-player .main .bottomView .yingliang[data-v-0c1a6b86]{float:right;margin-right:20px;margin-top:12px;width:26px;cursor:pointer}.vod-player .main .progress[data-v-0c1a6b86]{background-color:#e2e2dc;height:6px;width:100%;position:relative;cursor:pointer}.vod-player .main .progress .tf_progress_point[data-v-0c1a6b86]{width:12px;height:12px;background-color:#fff;position:absolute;border-radius:6px;transform:translateY(-50%);top:50%;left:0;z-index:1}.vod-player .main .progress .tf_progress_view[data-v-0c1a6b86]{width:0;height:6px;background-color:#1872ed;position:absolute;top:0;left:0;pointer-events:none}.vod-player .videoTimeBox[data-v-0c1a6b86]{color:#fff;float:left;font-size:12px;margin-top:18px;margin-left:20px}.vod-player .videoTimeTips[data-v-0c1a6b86]{position:absolute;left:50%;transform:translateX(-50%);top:10px;background:#000;color:#fff;font-size:13px}.vod-player .controns .main .topView[data-v-0c1a6b86]{position:absolute;top:0;left:0;width:100%;height:calc(100% - 65px)}.tcp-loading-spinner[data-v-0c1a6b86]{box-sizing:border-box;background-clip:padding-box;width:50px;height:50px;position:absolute;z-index:90;top:50%;left:50%;margin:-25px 0 0 -25px;display:block}.tcp-loading-spinner[data-v-0c1a6b86]:before{content:\"\";display:block;width:100%;height:100%;margin-bottom:5px;border-radius:50%;border:3px solid hsla(0,0%,100%,0);border-left-color:#fff;border-right-color:#fff;transform:translateZ(0);animation:load8-data-v-0c1a6b86 1.1s infinite linear}@keyframes load8-data-v-0c1a6b86{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.IOSFullScreen[data-v-0c1a6b86]{position:fixed;width:100%;height:100%;left:0;top:0;bottom:0;right:0;z-index:999999;background-color:#000}.vodInnerPlayer[data-v-0c1a6b86]{position:absolute;width:100%;height:100%;left:0;top:0}",""]);// exports
/***/},/* 69 *//***/function(module,exports,__webpack_require__){// style-loader: Adds some css to the DOM by adding a <style> tag
// load the styles
var content=__webpack_require__(70);if(typeof content==='string')content=[[module.i,content,'']];if(content.locals)module.exports=content.locals;// add the styles to the DOM
var update=__webpack_require__(2)("e178a0f2",content,true,{});/***/},/* 70 *//***/function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(1)(false);// imports
// module
exports.push([module.i,"/*! H265Play built @2024/8/5 下午3:58:31 */\r\n.goldplay{background:transparent}gp-button{cursor:pointer;font-size:14px}@-webkit-keyframes goldplay-rotate-360{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes goldplay-rotate-360{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.goldplay-btn{border:1px outset;text-align:center;display:inline-block;cursor:pointer}.goldplay-hoverbox{background:rgba(70,70,70,.8);border-radius:3px;visibility:hidden;display:inline-block;position:absolute;font-size:14px}.goldplay-hoverbox ul li{height:24px}.goldplay-hoverbox .gp-selected{color:#f60}.goldplay__container{display:block;position:relative;font-family:Arial,Helvetica,sans-serif;background:#000}.goldplay__container-fullpage,.goldplay__container-fullscreen{position:absolute;width:100%;height:100%;line-height:100%;left:0;top:0}.goldplay__container *{-webkit-box-sizing:border-box;box-sizing:border-box}.goldplay__container svg{overflow:auto;-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto;display:inline-block;width:auto;height:auto}.goldplay__container li,.goldplay__container ul{list-style:none}.goldplay__screen--bigplay{position:absolute;z-index:299;opacity:0;-webkit-transition:opacity 1s;transition:opacity 1s}.goldplay__screen--bigplay,.goldplay__screen--poster{color:#fff;text-align:center;font-family:Arial,Helvetica,sans-serif;display:inline-block}.goldplay__screen--poster{position:absolute;vertical-align:middle;z-index:399;opacity:1;-webkit-transition:opacity 2s;transition:opacity 2s;width:100%;height:100%;position:relative}.goldplay__screen--poster-image{margin:auto;text-align:center;vertical-align:middle;-webkit-filter:\"\";filter:\"\";width:100%;height:100%}.goldplay__screen--poster-speed{display:block}.goldplay__control--container{width:auto;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 5px;background:transparent;opacity:0;-webkit-transition:opacity 1s;transition:opacity 1s;display:block;position:absolute;bottom:0;left:0;right:0}.goldplay__control--container-float{position:absolute;margin-top:-50px}.goldplay__control--nearside{padding-top:4px;margin-left:10px;display:block}.goldplay__control--sidebar{padding-top:4px;float:right;display:block}.goldplay__control--container.canvas{position:absolute}.goldplay__screen--container{width:100%;display:block}.goldplay__progress-bar{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;background:hsla(0,15%,90%,.4);height:3px;border-radius:5px;line-height:3px;margin:6px 0;display:inline-block}.goldplay__progress-bar:hover{height:5px;line-height:5px;margin:5px 0;border-top:1px solid transparent}.goldplay__progress-bar:hover .goldplay__progressbar--play{height:5px;line-height:5px;margin-top:-1px}.goldplay__progress-bar:hover .goldplay__progressbar--load{height:5px;line-height:5px;margin-top:-1px}.goldplay__progress-bar-hover{height:5px;line-height:5px;margin:5px 0;border-radius:5px}.goldplay__progressbar--load-hover,.goldplay__progressbar--play-hover{height:5px!important;line-height:5px!important}.goldplay__control--button-block{display:inline-block}.goldplay__control--play{display:none;width:20px}.goldplay__control--replay{display:none;margin:-4px 0 0 -4px}.goldplay__control--pause{display:none;width:20px}.goldplay__control--pause-loading{margin:-5px 0 0 -5px}.goldplay__waiting-bar{position:absolute;text-align:center;color:#fff;z-index:98;display:none;opacity:.7}.goldplay__waiting-bar--icon{width:120px;text-align:center;display:block}.goldplay__waiting-bar img{opacity:.3}.goldplay__waiting-bar--speed{display:block}.goldplay__progressbar--play{height:3px;border-radius:5px;background-color:rgba(255,80,0,.8);position:absolute}.goldplay__progressbar--load{height:3px;border-radius:5px;background-color:hsla(0,0%,100%,.8);position:absolute}.goldplay__progressbar--dot{position:absolute}.goldplay__progressbar--dot:before{content:\"\";display:inline-block;width:12px;height:12px;background:#fff;margin-top:-5px;border-radius:50%;border:1px solid #f1f1f1;background-image:-webkit-radial-gradient(circle arthest-corner at 45px 45px,#b0b9be,#191611);-webkit-box-shadow:0 0 2px 0 rgba(0,0,0,.26);box-shadow:0 0 2px 0 rgba(0,0,0,.26);cursor:-webkit-grab;cursor:grab}.goldplay__progressbar--dot:hover:before{background:#f60;border:1px solid #f60;-webkit-box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);-webkit-transform:scale(1);transform:scale(1);-webkit-transition:-webkit-transform .15s ease-in-out;transition:-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out;transition:transform .15s ease-in-out,-webkit-transform .15s ease-in-out}.goldplay__progressbar--dot-hover:before{background:#f60;border:1px solid #f60;-webkit-box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);-webkit-transform:scale(1);transform:scale(1);-webkit-transition:-webkit-transform .15s ease-in-out;transition:-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out;transition:transform .15s ease-in-out,-webkit-transform .15s ease-in-out}.goldplay__control--timer{font-size:.9em;color:#ccc;margin:3px 5px 0;display:inline-block;-webkit-transform:translateY(-5px);transform:translateY(-5px)}.goldplay__control--timer-total{color:#999}.goldplay__volume-bar--handle{height:100px;width:20px;margin:-122px 0 0;cursor:default}.goldplay__volume-bar--column{background:hsla(0,14%,92%,.5);width:4px;top:15px;left:8px;height:80px;position:absolute}.goldplay__volume-bar--precent{position:absolute;top:2px;width:100%;text-align:center;color:#f1f1f1;font-size:10px;cursor:text}.goldplay__volume-bar--size{background:#f60;left:8px;z-index:2;position:absolute}.goldplay__volume-bar--rod{position:absolute;left:5px;z-index:3}.goldplay__volume-bar--rod:before{content:\"\";display:table;width:12px;height:12px;background:#fff;margin-top:0;margin-left:-2px;border-radius:50%;border:1px solid #f1f1f1;background-image:radial-gradient(circle arthest-corner at 45px,at 45px,#b0b9be,#191611);background-image:radial-gradient(circle arthest-corner at 45px 45px,#b0b9be,#191611);-webkit-box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);cursor:-webkit-grab;cursor:grab}.goldplay__volume-bar--rod:hover:before{background:#f60;border:1px solid #f60;-webkit-box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);-webkit-transform:scale(1);transform:scale(1);-webkit-transition:-webkit-transform .15s ease-in-out;transition:-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out;transition:transform .15s ease-in-out,-webkit-transform .15s ease-in-out}.goldplay__volume-bar--rod-hover:before{background:#f60;border:1px solid #f60;-webkit-box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);-webkit-transform:scale(1);transform:scale(1);-webkit-transition:-webkit-transform .15s ease-in-out;transition:-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out;transition:transform .15s ease-in-out,-webkit-transform .15s ease-in-out}.goldplay__control--fullpage{margin:0 0 0 5px}.goldplay__control--fullscreen{margin:0 12px 0 10px}.goldplay__alter-box{z-index:999;padding:20px;border-radius:10px;color:#fff;position:absolute;word-break:break-word;overflow:auto;-webkit-box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);box-shadow:0 0 6px 2px hsla(0,10%,100%,.5);background:rgba(0,0,0,.6);min-width:50px;min-height:20px;max-width:400px;max-height:300px;opacity:0;-webkit-transition:opacity .3s;transition:opacity .3s}.goldplay__alter--close{margin:5px;display:block;position:absolute;right:0;top:0;cursor:pointer}.goldplay__alter--warn{float:left;margin:-5px 10px 5px 0}.goldplay__rate-bar,.goldplay__speed-bar{display:inline-block;color:#ccc;vertical-align:middle;margin:-14px 10px 0 0}.goldplay__rate-bar--box,.goldplay__speed-bar--box{cursor:default}.goldplay__speed-bar--box ul{margin:6px 0;padding:0;text-align:right}.goldplay__speed-bar--box ul li{height:2em;line-height:2em;padding:0 15px}.goldplay__rate-bar--box ul li:hover,.goldplay__speed-bar--box ul li:hover{background:rgba(0,0,0,.4)}.goldplay__rate-bar--box ul{margin:6px 0;padding:0;text-align:right}.goldplay__rate-bar--box ul li{height:2em;line-height:2em;padding:0 15px}\r\n",""]);// exports
/***/},/* 71 *//***/function(module,exports,__webpack_require__){/* WEBPACK VAR INJECTION */(function(module){var __WEBPACK_AMD_DEFINE_FACTORY__,__WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};/*! H265Play built @2024/8/5 下午3:58:31 */(function webpackUniversalModuleDefinition(root,factory){if((false?'undefined':_typeof(exports))==='object'&&(false?'undefined':_typeof(module))==='object')module.exports=factory();else if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__=[],__WEBPACK_AMD_DEFINE_FACTORY__=factory,__WEBPACK_AMD_DEFINE_RESULT__=typeof __WEBPACK_AMD_DEFINE_FACTORY__==='function'?__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__):__WEBPACK_AMD_DEFINE_FACTORY__,__WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));else if((typeof exports==='undefined'?'undefined':_typeof(exports))==='object')exports["H265Player"]=factory();else root["H265Player"]=factory();})(window,function(){return(/******/function(modules){// webpackBootstrap
/******/// The module cache
/******/var installedModules={};/******//******/// The require function
/******/function __webpack_require__(moduleId){/******//******/// Check if module is in cache
/******/if(installedModules[moduleId]){/******/return installedModules[moduleId].exports;/******/}/******/// Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/i:moduleId,/******/l:false,/******/exports:{}/******/};/******//******/// Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******//******/// Flag the module as loaded
/******/module.l=true;/******//******/// Return the exports of the module
/******/return module.exports;/******/}/******//******//******/// expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******//******/// expose the module cache
/******/__webpack_require__.c=installedModules;/******//******/// define getter function for harmony exports
/******/__webpack_require__.d=function(exports,name,getter){/******/if(!__webpack_require__.o(exports,name)){/******/Object.defineProperty(exports,name,{enumerable:true,get:getter});/******/}/******/};/******//******/// define __esModule on exports
/******/__webpack_require__.r=function(exports){/******/if(typeof Symbol!=='undefined'&&Symbol.toStringTag){/******/Object.defineProperty(exports,Symbol.toStringTag,{value:'Module'});/******/}/******/Object.defineProperty(exports,'__esModule',{value:true});/******/};/******//******/// create a fake namespace object
/******/// mode & 1: value is a module id, require it
/******/// mode & 2: merge all properties of value into the ns
/******/// mode & 4: return value when already ns object
/******/// mode & 8|1: behave like require
/******/__webpack_require__.t=function(value,mode){/******/if(mode&1)value=__webpack_require__(value);/******/if(mode&8)return value;/******/if(mode&4&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'&&value&&value.__esModule)return value;/******/var ns=Object.create(null);/******/__webpack_require__.r(ns);/******/Object.defineProperty(ns,'default',{enumerable:true,value:value});/******/if(mode&2&&typeof value!='string')for(var key in value){__webpack_require__.d(ns,key,function(key){return value[key];}.bind(null,key));}/******/return ns;/******/};/******//******/// getDefaultExport function for compatibility with non-harmony modules
/******/__webpack_require__.n=function(module){/******/var getter=module&&module.__esModule?/******/function getDefault(){return module['default'];}:/******/function getModuleExports(){return module;};/******/__webpack_require__.d(getter,'a',getter);/******/return getter;/******/};/******//******/// Object.prototype.hasOwnProperty.call
/******/__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property);};/******//******/// __webpack_public_path__
/******/__webpack_require__.p="";/******//******//******/// Load entry module and return exports
/******/return __webpack_require__(__webpack_require__.s=163);/******/}(/************************************************************************//******/[/* 0 *//***/function(module,exports,__webpack_require__){eval("var toPropertyKey = __webpack_require__(66);\nfunction _defineProperty(e, r, t) {\n  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {\n    value: t,\n    enumerable: !0,\n    configurable: !0,\n    writable: !0\n  }) : e[r] = t, e;\n}\nmodule.exports = _defineProperty, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/defineProperty.js?");/***/},/* 1 *//***/function(module,exports){eval("function _getPrototypeOf(t) {\n  return (module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {\n    return t.__proto__ || Object.getPrototypeOf(t);\n  }, module.exports.__esModule = true, module.exports[\"default\"] = module.exports), _getPrototypeOf(t);\n}\nmodule.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/getPrototypeOf.js?");/***/},/* 2 *//***/function(module,exports){eval("function _classCallCheck(a, n) {\n  if (!(a instanceof n)) throw new TypeError(\"Cannot call a class as a function\");\n}\nmodule.exports = _classCallCheck, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/classCallCheck.js?");/***/},/* 3 *//***/function(module,exports,__webpack_require__){eval("var toPropertyKey = __webpack_require__(66);\nfunction _defineProperties(e, r) {\n  for (var t = 0; t < r.length; t++) {\n    var o = r[t];\n    o.enumerable = o.enumerable || !1, o.configurable = !0, \"value\" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);\n  }\n}\nfunction _createClass(e, r, t) {\n  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, \"prototype\", {\n    writable: !1\n  }), e;\n}\nmodule.exports = _createClass, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/createClass.js?");/***/},/* 4 *//***/function(module,exports,__webpack_require__){eval("var setPrototypeOf = __webpack_require__(46);\nfunction _inherits(t, e) {\n  if (\"function\" != typeof e && null !== e) throw new TypeError(\"Super expression must either be null or a function\");\n  t.prototype = Object.create(e && e.prototype, {\n    constructor: {\n      value: t,\n      writable: !0,\n      configurable: !0\n    }\n  }), Object.defineProperty(t, \"prototype\", {\n    writable: !1\n  }), e && setPrototypeOf(t, e);\n}\nmodule.exports = _inherits, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/inherits.js?");/***/},/* 5 *//***/function(module,exports,__webpack_require__){eval("var _typeof = __webpack_require__(9)[\"default\"];\nvar assertThisInitialized = __webpack_require__(86);\nfunction _possibleConstructorReturn(t, e) {\n  if (e && (\"object\" == _typeof(e) || \"function\" == typeof e)) return e;\n  if (void 0 !== e) throw new TypeError(\"Derived constructors may only return object or undefined\");\n  return assertThisInitialized(t);\n}\nmodule.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js?");/***/},,/* 6 *//* 7 *//***/function(module,exports){eval("function _taggedTemplateLiteral(e, t) {\n  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {\n    raw: {\n      value: Object.freeze(t)\n    }\n  }));\n}\nmodule.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js?");/***/},/* 8 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";eval("/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"c\", function() { return Config; });\n/* unused harmony export MP4_CONFIG */\n/* unused harmony export ERROR_STATE */\n/* unused harmony export ERROR_TYPE */\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"b\", function() { return BUFFER; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"a\", function() { return AV_TIME_BASE_Q; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"d\", function() { return READY; });\n/* unused harmony export LIBFILES */\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file Config.js\r\n * @desc\r\n * common config\r\n * @author Jarry\r\n */\n\n// from webpack global variable \n// __ENV_MODEL__: \"production\" | \"development\" | \"test\"\nvar mode =  true ? \"production\" : undefined;\nvar Config = {\n  projectName: 'GOLDPLAY',\n  projectAbbreviation: 'GP',\n  mode: mode,\n  basePath: './',\n  get distPath() {\n    var path = '';\n    if (this.mode == 'development') {\n      path = '/dist/';\n    } else if (this.mode == 'test') {\n      path = '/dist/';\n    }\n    return path;\n  },\n  get libPath() {\n    return this.distPath + 'lib/';\n  },\n  hideBarBoxTime: 300,\n  speedList: [{\n    name: '0.5X',\n    value: 0.5\n  }, {\n    name: '1.0X',\n    value: 1.0\n  }, {\n    name: '1.5X',\n    value: 1.5\n  }, {\n    name: '2.0X',\n    value: 2.0\n  }, {\n    name: '3.0X',\n    value: 3.0\n  }]\n};\nvar BUFFER = {\n  //单位秒，loader加载ts片段缓存\n  maxDuration: 30,\n  maxSize: 1024 * 1000 * 1000,\n  maxRetryCount: 3\n};\nvar ERROR_STATE = {\n  success: 100,\n  fail: 200,\n  pending: 300,\n  reject: 400\n};\nvar MP4_CONFIG = {\n  // 1024 * 1024 * 2\n  sliceSize: 2097152\n};\nvar ERROR_TYPE = {\n  /** Errors from the net util. */\n  NETWORK: 1,\n  /** Errors parsing the Manifest. */\n  MANIFEST: 2,\n  /** Errors parsing or processing audio or video streams. */\n  MEDIA: 3,\n  /** Errors parsing or processing data source. */\n  DATA: 4,\n  /** Errors while Mux encounter unexpected error.  */\n  MUX: 5,\n  /** Errors processing drm system. */\n  DRM: 6\n};\nvar AV_TIME_BASE_Q = 1 / 90000;\nvar READY = {\n  READYBUFFERLENGTH: 1000,\n  //the buffer max length, unit is millisecond\n  MAXBUFFERLENGTH: 5000\n};\nvar LIBFILES = ['ADTS.js', 'mux.js'];\n\n\n//# sourceURL=webpack://H265Player/../src/config/Config.js?");/***/},/* 9 *//***/function(module,exports){eval("function _typeof(o) {\n  \"@babel/helpers - typeof\";\n\n  return (module.exports = _typeof = \"function\" == typeof Symbol && \"symbol\" == typeof Symbol.iterator ? function (o) {\n    return typeof o;\n  } : function (o) {\n    return o && \"function\" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? \"symbol\" : typeof o;\n  }, module.exports.__esModule = true, module.exports[\"default\"] = module.exports), _typeof(o);\n}\nmodule.exports = _typeof, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/typeof.js?");/***/},/* 10 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";eval("/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);\n/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);\n/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);\n/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _config_Config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);\n\n\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Logger.js\r\n * @desc\r\n * logger tool\r\n * level: 3(error), 2(debug, warn, >2), 1(log, >1), 0(info, >0). the default is 0.\r\n * @author Jarry\r\n */\n\nvar _console = console || {};\nvar methodList = ['info', 'log', 'debug', 'warn', 'error'];\n// const methodList = Object.keys(_console)\n\nfunction echo(fn, message) {\n  if (_console[fn]) {\n    if (this.disabled || this.level < 0) {\n      return;\n    }\n    if (_config_Config_js__WEBPACK_IMPORTED_MODULE_3__[/* Config */ \"c\"].mode === 'production' && (fn !== 'error' || fn !== 'warn')) {\n      return;\n    }\n    if (this.level === 1 && ['info'].includes(fn)) {\n      return;\n    }\n    if (this.level === 2 && ['log', 'info'].includes(fn)) {\n      return;\n    }\n    if (this.level > 2 && fn !== 'error') {\n      return;\n    }\n    var time = new Date().toLocaleString();\n    for (var _len = arguments.length, data = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {\n      data[_key - 2] = arguments[_key];\n    }\n    var arr = [\"\\x1B[32m\".concat(message, \"\\x1B[39m\")].concat(data, [time]);\n    if (fn === 'error' || fn === 'warn') {\n      arr = [message].concat(data, [time]);\n    }\n    if (typeof _console[fn] === 'function') {\n      _console[fn].apply(_console, arr);\n    }\n  }\n}\n/**\r\n * 日志处理类\r\n * @usage\r\n * let logger = new Logger('文件名.js')\r\n * logger.log[info|error|warn]('方法', '动作', '数据1:', '数据结果1', '数据2:', '数据结果2', ...)\r\n */\nvar Logger = /*#__PURE__*/function () {\n  function Logger(file) {\n    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Logger);\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"prefix\", _config_Config_js__WEBPACK_IMPORTED_MODULE_3__[/* Config */ \"c\"].projectName);\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"joiner\", '>');\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"left\", '[');\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"right\", ']');\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"disabled\", false);\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"level\", 0);\n    Object.assign(this, options);\n    if (typeof file == 'string') {\n      this.file = file;\n    } else if (file && file.constructor) {\n      this.file = file.constructor.name;\n    }\n  }\n  return _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Logger, [{\n    key: \"setDisabled\",\n    value: function setDisabled(isDisabled) {\n      this.disabled = isDisabled;\n    }\n  }, {\n    key: \"setLevel\",\n    value: function setLevel(level) {\n      this.level = level;\n    }\n  }], [{\n    key: \"get\",\n    value: function get(file, options) {\n      return new Logger(file, options);\n    }\n  }]);\n}();\nmethodList.forEach(function (item) {\n  Logger.prototype[item] = function (method, action) {\n    action = action === undefined ? '' : this.joiner + action;\n    var methodAction = this.left + method + action + this.right;\n    var message = this.left + this.prefix + ' ' + this.file + this.right + methodAction;\n    for (var _len2 = arguments.length, data = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {\n      data[_key2 - 2] = arguments[_key2];\n    }\n    echo.apply(this, [item, message].concat(data));\n  };\n});\n/* harmony default export */ __webpack_exports__[\"a\"] = (Logger);\n\n//# sourceURL=webpack://H265Player/../src/toolkit/Logger.js?");/***/},,,,,,,/* 11 *//* 12 *//* 13 *//* 14 *//* 15 *//* 16 *//* 17 *//***/function(module,exports,__webpack_require__){eval("// TODO(Babel 8): Remove this file.\n\nvar runtime = __webpack_require__(89)();\nmodule.exports = runtime;\n\n// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=\ntry {\n  regeneratorRuntime = runtime;\n} catch (accidentalStrictMode) {\n  if (typeof globalThis === \"object\") {\n    globalThis.regeneratorRuntime = runtime;\n  } else {\n    Function(\"r\", \"regeneratorRuntime = r\")(runtime);\n  }\n}\n\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/regenerator/index.js?");/***/},,,,/* 18 *//* 19 *//* 20 *//* 21 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";eval("/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"a\", function() { return Events; });\n/* unused harmony export FLVDemux */\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"b\", function() { return MP4Demux; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"c\", function() { return TSDemux; });\n/**\n * @file= events.js, created at Monday, 23rd December 2019 3=47=23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nvar Events;\n(function (Events) {\n    Events[\"ERROR\"] = \"ERROR\";\n    Events[\"INFO\"] = \"INFO\";\n    Events[\"DATA\"] = \"DATA\";\n    Events[\"DEMUX_DATA\"] = \"DEMUX_DATA\";\n    Events[\"DONE\"] = \"DONE\";\n})(Events || (Events = {}));\n\n/**\n * @copyright https://github.com/nodejs/node/blob/master/lib/events.js\n */\n/* eslint-disable */\n// Copyright Joyent, Inc. and other Node contributors.\n//\n// Permission is hereby granted, free of charge, to any person obtaining a\n// copy of this software and associated documentation files (the\n// \"Software\"), to deal in the Software without restriction, including\n// without limitation the rights to use, copy, modify, merge, publish,\n// distribute, sublicense, and/or sell copies of the Software, and to permit\n// persons to whom the Software is furnished to do so, subject to the\n// following conditions:\n//\n// The above copyright notice and this permission notice shall be included\n// in all copies or substantial portions of the Software.\n//\n// THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS\n// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF\n// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN\n// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,\n// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR\n// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE\n// USE OR OTHER DEALINGS IN THE SOFTWARE.\nvar objectCreate = Object.create || objectCreatePolyfill;\nvar objectKeys = Object.keys || objectKeysPolyfill;\nvar bind = Function.prototype.bind || functionBindPolyfill;\n// By default Dispatchers will print a warning if more than 10 listeners are\n// added to it. This is a useful default which helps finding memory leaks.\nlet defaultMaxListeners = 10;\nclass EventEmitter {\n    constructor() {\n        if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {\n            this._events = objectCreate(null);\n            this._eventsCount = 0;\n        }\n        this._maxListeners = this._maxListeners || undefined;\n    }\n    static listenerCount(emitter, type) {\n        if (typeof emitter.listenerCount === 'function') {\n            return emitter.listenerCount(type);\n        }\n        else {\n            return listenerCount.call(emitter, type);\n        }\n    }\n    // // Obviously not all Emitters should be limited to 10. This function allows\n    // // that to be increased. Set to zero for unlimited.\n    // setMaxListeners(n) {\n    //     if (typeof n !== 'number' || n < 0 || isNaN(n))\n    //         throw new TypeError('\"n\" argument must be a positive number');\n    //     this._maxListeners = n;\n    //     return this;\n    // }\n    //\n    // getMaxListeners() {\n    //     return $getMaxListeners(this);\n    // }\n    emit(type, ...rest) {\n        var er, handler, len, args, i, events;\n        var doError = type === 'error';\n        events = this._events;\n        if (events)\n            doError = doError && events.error == null;\n        else if (!doError)\n            return false;\n        // If there is no 'error' event listener then throw.\n        if (doError) {\n            if (arguments.length > 1)\n                er = arguments[1];\n            if (er instanceof Error) {\n                throw er; // Unhandled 'error' event\n            }\n            else {\n                // At least give some kind of context to the user\n                var err = new Error('Unhandled \"error\" event. (' + er + ')');\n                err['context'] = er;\n                throw err;\n            }\n        }\n        handler = events[type];\n        if (!handler)\n            return false;\n        var isFn = typeof handler === 'function';\n        len = arguments.length;\n        switch (len) {\n            // fast cases\n            case 1:\n                emitNone(handler, isFn, this);\n                break;\n            case 2:\n                emitOne(handler, isFn, this, arguments[1]);\n                break;\n            case 3:\n                emitTwo(handler, isFn, this, arguments[1], arguments[2]);\n                break;\n            case 4:\n                emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);\n                break;\n            // slower\n            default:\n                args = new Array(len - 1);\n                for (i = 1; i < len; i++)\n                    args[i - 1] = arguments[i];\n                emitMany(handler, isFn, this, args);\n        }\n        return true;\n    }\n    on(type, listener) {\n        return _addListener(this, type, listener);\n    }\n    once(type, listener) {\n        if (typeof listener !== 'function')\n            throw new TypeError('\"listener\" argument must be a function');\n        this.on(type, _onceWrap(this, type, listener));\n        return this;\n    }\n    off(type, listener) {\n        return _removeListener.call(this, type, listener);\n    }\n    removeAllListeners(type) {\n        var listeners, events, i;\n        events = this._events;\n        if (!events)\n            return this;\n        // not listening for off, no need to emit\n        if (!events.off) {\n            if (arguments.length === 0) {\n                this._events = objectCreate(null);\n                this._eventsCount = 0;\n            }\n            else if (events[type]) {\n                if (--this._eventsCount === 0)\n                    this._events = objectCreate(null);\n                else\n                    delete events[type];\n            }\n            return this;\n        }\n        // emit off for all listeners on all events\n        if (arguments.length === 0) {\n            var keys = objectKeys(events);\n            var key;\n            for (i = 0; i < keys.length; ++i) {\n                key = keys[i];\n                if (key === 'off')\n                    continue;\n                this.removeAllListeners(key);\n            }\n            this.removeAllListeners('off');\n            this._events = objectCreate(null);\n            this._eventsCount = 0;\n            return this;\n        }\n        listeners = events[type];\n        if (typeof listeners === 'function') {\n            this.off(type, listeners);\n        }\n        else if (listeners) {\n            // LIFO order\n            for (i = listeners.length - 1; i >= 0; i--) {\n                this.off(type, listeners[i]);\n            }\n        }\n        return this;\n    }\n    listeners(type) {\n        return _listeners(this, type, true);\n    }\n    rawListeners(type) {\n        return _listeners(this, type, false);\n    }\n    listenerCount() {\n        return EventEmitter.listenerCount.apply(this, arguments);\n    }\n}\nlet hasDefineProperty;\ntry {\n    var o = {};\n    if (Object.defineProperty)\n        Object.defineProperty(o, 'x', { value: 0 });\n    hasDefineProperty = o['x'] === 0;\n}\ncatch (err) {\n    hasDefineProperty = false;\n}\nif (hasDefineProperty) {\n    Object.defineProperty(EventEmitter, 'defaultMaxListeners', {\n        enumerable: true,\n        get: function () {\n            return defaultMaxListeners;\n        },\n        set: function (arg) {\n            // check whether the input is a positive number (whose value is zero or\n            // greater and not a NaN).\n            if (typeof arg !== 'number' || arg < 0 || arg !== arg)\n                throw new TypeError('\"defaultMaxListeners\" must be a positive number');\n            defaultMaxListeners = arg;\n        }\n    });\n}\nelse {\n    EventEmitter.defaultMaxListeners = defaultMaxListeners;\n}\nfunction $getMaxListeners(that) {\n    if (that._maxListeners === undefined)\n        return EventEmitter.defaultMaxListeners;\n    return that._maxListeners;\n}\n// These standalone emit* functions are used to optimize calling of event\n// handlers for fast cases because emit() itself often has a variable number of\n// arguments and can be deoptimized because of that. These functions always have\n// the same number of arguments and thus do not get deoptimized, so the code\n// inside them can execute faster.\nfunction emitNone(handler, isFn, self) {\n    if (isFn)\n        handler.call(self);\n    else {\n        var len = handler.length;\n        var listeners = arrayClone(handler, len);\n        for (var i = 0; i < len; ++i) {\n            try {\n                listeners[i].call(self);\n            }\n            catch (e) {\n                console.error(e);\n            }\n        }\n    }\n}\nfunction emitOne(handler, isFn, self, arg1) {\n    if (isFn)\n        handler.call(self, arg1);\n    else {\n        var len = handler.length;\n        var listeners = arrayClone(handler, len);\n        for (var i = 0; i < len; ++i) {\n            try {\n                listeners[i].call(self, arg1);\n            }\n            catch (e) {\n                console.error(e);\n            }\n        }\n    }\n}\nfunction emitTwo(handler, isFn, self, arg1, arg2) {\n    if (isFn)\n        handler.call(self, arg1, arg2);\n    else {\n        var len = handler.length;\n        var listeners = arrayClone(handler, len);\n        for (var i = 0; i < len; ++i) {\n            try {\n                listeners[i].call(self, arg1, arg2);\n            }\n            catch (e) {\n                console.error(e);\n            }\n        }\n    }\n}\nfunction emitThree(handler, isFn, self, arg1, arg2, arg3) {\n    if (isFn)\n        handler.call(self, arg1, arg2, arg3);\n    else {\n        var len = handler.length;\n        var listeners = arrayClone(handler, len);\n        for (var i = 0; i < len; ++i) {\n            try {\n                listeners[i].call(self, arg1, arg2, arg3);\n            }\n            catch (e) {\n                console.error(e);\n            }\n        }\n    }\n}\nfunction emitMany(handler, isFn, self, args) {\n    if (isFn)\n        handler.apply(self, args);\n    else {\n        var len = handler.length;\n        var listeners = arrayClone(handler, len);\n        for (var i = 0; i < len; ++i) {\n            try {\n                listeners[i].apply(self, args);\n            }\n            catch (e) {\n                console.error(e);\n            }\n        }\n    }\n}\nfunction _addListener(target, type, listener) {\n    var m;\n    var events;\n    var existing;\n    if (typeof listener !== 'function')\n        throw new TypeError('\"listener\" argument must be a function');\n    events = target._events;\n    if (!events) {\n        events = target._events = objectCreate(null);\n        target._eventsCount = 0;\n    }\n    else {\n        // To avoid recursion in the case that type === \"newListener\"! Before\n        // adding it to the listeners, first emit \"newListener\".\n        if (events.newListener) {\n            target.emit('newListener', type, listener['listener'] ? listener['listener'] : listener);\n            // Re-assign `events` because a newListener handler could have caused the\n            // this._events to be assigned to a new object\n            events = target._events;\n        }\n        existing = events[type];\n    }\n    if (!existing) {\n        // Optimize the case of one listener. Don't need the extra array object.\n        existing = events[type] = listener;\n        ++target._eventsCount;\n    }\n    else {\n        if (typeof existing === 'function') {\n            // Adding the second element, need to change to array.\n            existing = events[type] = [existing, listener];\n        }\n        else {\n            existing.push(listener);\n        }\n        // Check for listener leak\n        if (!existing.warned) {\n            m = $getMaxListeners(target);\n            if (m && m > 0 && existing.length > m) {\n                existing.warned = true;\n                class CustomError extends Error {\n                }\n                let w = new CustomError('Possible Dispatcher memory leak detected. ' +\n                    existing.length +\n                    ' \"' +\n                    String(type) +\n                    '\" listeners ' +\n                    'added. Use emitter.setMaxListeners() to ' +\n                    'increase limit.');\n                w.name = 'MaxListenersExceededWarning';\n                w.emitter = target;\n                w.type = type;\n                w.count = existing.length;\n                if (typeof console === 'object' && console.warn) {\n                    console.warn('%s: %s', w.name, w.message);\n                }\n            }\n        }\n    }\n    return target;\n}\nfunction _removeListener(type, listener) {\n    var list, events, position, i, originalListener;\n    if (typeof listener !== 'function')\n        throw new TypeError('\"listener\" argument must be a function');\n    events = this._events;\n    if (!events)\n        return this;\n    list = events[type];\n    if (!list)\n        return this;\n    if (list === listener || list.listener === listener) {\n        if (--this._eventsCount === 0)\n            this._events = objectCreate(null);\n        else {\n            delete events[type];\n            if (events.off)\n                this.emit('off', type, list.listener || listener);\n        }\n    }\n    else if (typeof list !== 'function') {\n        position = -1;\n        for (i = list.length - 1; i >= 0; i--) {\n            if (list[i] === listener || list[i].listener === listener) {\n                originalListener = list[i].listener;\n                position = i;\n                break;\n            }\n        }\n        if (position < 0)\n            return this;\n        if (position === 0)\n            list.shift();\n        else\n            spliceOne(list, position);\n        if (list.length === 1)\n            events[type] = list[0];\n        if (events.off)\n            this.emit('off', type, originalListener || listener);\n    }\n    return this;\n}\nfunction onceWrapper() {\n    if (!this.fired) {\n        this.target.off(this.type, this.wrapFn);\n        this.fired = true;\n        switch (arguments.length) {\n            case 0:\n                return this.listener.call(this.target);\n            case 1:\n                return this.listener.call(this.target, arguments[0]);\n            case 2:\n                return this.listener.call(this.target, arguments[0], arguments[1]);\n            case 3:\n                return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);\n            default:\n                var args = new Array(arguments.length);\n                for (var i = 0; i < args.length; ++i)\n                    args[i] = arguments[i];\n                this.listener.apply(this.target, args);\n        }\n    }\n}\nfunction _onceWrap(target, type, listener) {\n    var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };\n    var wrapped = bind.call(onceWrapper, state);\n    wrapped.listener = listener;\n    state.wrapFn = wrapped;\n    return wrapped;\n}\nfunction _listeners(target, type, unwrap) {\n    var events = target._events;\n    if (!events)\n        return [];\n    var evlistener = events[type];\n    if (!evlistener)\n        return [];\n    if (typeof evlistener === 'function')\n        return unwrap ? [evlistener.listener || evlistener] : [evlistener];\n    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);\n}\nfunction listenerCount(type) {\n    var events = this._events;\n    if (events) {\n        var evlistener = events[type];\n        if (typeof evlistener === 'function') {\n            return 1;\n        }\n        else if (evlistener) {\n            return evlistener.length;\n        }\n    }\n    return 0;\n}\n// About 1.5x faster than the two-arg version of Array#splice().\nfunction spliceOne(list, index) {\n    for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)\n        list[i] = list[k];\n    list.pop();\n}\nfunction arrayClone(arr, n) {\n    var copy = new Array(n);\n    for (var i = 0; i < n; ++i)\n        copy[i] = arr[i];\n    return copy;\n}\nfunction unwrapListeners(arr) {\n    var ret = new Array(arr.length);\n    for (var i = 0; i < ret.length; ++i) {\n        ret[i] = arr[i].listener || arr[i];\n    }\n    return ret;\n}\nfunction objectCreatePolyfill(proto) {\n    var F = function () { };\n    F.prototype = proto;\n    return new F();\n}\nfunction objectKeysPolyfill(obj) {\n    for (var k in obj)\n        if (Object.prototype.hasOwnProperty.call(obj, k)) ;\n    return k;\n}\nfunction functionBindPolyfill(context) {\n    var fn = this;\n    return function () {\n        return fn.apply(context, arguments);\n    };\n}\n\nclass Context extends EventEmitter {\n}\n\n/**\n * @file: is.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * Used to resolve the\n * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)\n * of values.\n */\nvar objectToString = Object.prototype.toString;\n/**\n * Checks if `value` is object-like. A value is object-like if it's not `null`\n * and has a `typeof` result of \"object\".\n *\n * @param {*} value The value to check.\n * @returns {boolean} Returns `true` if `value` is object-like, else `false`.\n * @example\n *\n * _.isObjectLike({});\n * // => true\n *\n * _.isObjectLike([1, 2, 3]);\n * // => true\n *\n * _.isObjectLike(_.noop);\n * // => false\n *\n * _.isObjectLike(null);\n * // => false\n */\nfunction isObjectLike(value) {\n    return !!value && typeof value == 'object';\n}\n/**\n * @param num\n */\nfunction isNumber(num) {\n    return typeof num === 'number' && !isNaN(num);\n}\n/**\n * @param value\n */\nfunction isArrayBuffer(value) {\n    return isObjectLike(value) && objectToString.call(value).toLowerCase() === '[object arraybuffer]';\n}\n/**\n * @param value\n */\nfunction isUint8Array(value) {\n    return isObjectLike(value) && objectToString.call(value).toLowerCase() === '[object uint8array]';\n}\n\n/**\n * @file: cache-buffer.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * Cache Buffer util.\n * It's applicable for streaming data cutting and retaining the data,\n * the algorithm minimizes memory application as much as possible.\n */\nclass CacheBuffer {\n    constructor() {\n        this.list_ = [];\n    }\n    get byteLength() {\n        if (!isNumber(this.byteLength_)) {\n            let len = 0;\n            for (let i = 0, item; i < this.list_.length; i++) {\n                item = this.list_[i];\n                len += item.byteLength;\n            }\n            this.byteLength_ = len;\n        }\n        return this.byteLength_;\n    }\n    /**\n     * maybe return new allocated memory or original memory\n     */\n    get bytes() {\n        const { bufferList } = this;\n        let bytes = null;\n        if (bufferList.length > 0) {\n            if (bufferList.length === 0) {\n                bytes = bufferList[0];\n            }\n            else {\n                bytes = this.toNewBytes();\n            }\n        }\n        return bytes;\n    }\n    get empty() {\n        return this.list_.length === 0;\n    }\n    get bufferList() {\n        return this.list_;\n    }\n    clear() {\n        let len = this.list_.length;\n        if (len > 0) {\n            this.list_.splice(0, len);\n        }\n        this.byteLength_ = null;\n    }\n    toNewBytes() {\n        let bytes = null;\n        let tryCount = 0;\n        let maxTryCount = 50;\n        // The following retry strategies are provided for failed memory applications\n        // In terms of a better strategy, a failed memory application retry should be\n        // an asynchronous process, which does not return until the application succeeds.\n        // But the original design of the library is synchronous.\n        while (bytes === null) {\n            try {\n                tryCount++;\n                bytes = new Uint8Array(this.byteLength);\n            }\n            catch (e) {\n                if (tryCount > maxTryCount) {\n                    throw e;\n                }\n            }\n        }\n        for (let i = 0, offset = 0; i < this.list_.length; i++) {\n            let payload = this.list_[i];\n            bytes.set(payload, offset);\n            offset += payload.byteLength;\n        }\n        return bytes;\n    }\n    append(newBuffer) {\n        if (newBuffer instanceof CacheBuffer) {\n            this.list_ = this.list_.concat(newBuffer.bufferList);\n        }\n        else {\n            this.list_.push(newBuffer);\n        }\n        this.byteLength_ = null;\n    }\n    /**\n     * This function cuts a complete TypedArray from CacheBuffer and retains the remainder of CacheBuffer.\n     * The following points should be noted when using this function:\n     * 1. If the cut needs to return the cut-out part, the cut length should be as small as possible to reduce the errors in memory application.\n     * 2. If the cutting is only to preserve the remaining parts, the cutting size is within the total number of bytes, without considering memory applications.\n     * @param {number} fixedLength\n     * @param {boolean} [needCutResult] - If not, just retain the remaining parts after cutting.\n     */\n    cut(fixedLength, needCutResult = true) {\n        let chunk = null;\n        if (fixedLength > 0 && !this.empty) {\n            let list = this.list_;\n            let offset = 0;\n            let loopIndex = 0;\n            while (list.length > 0) {\n                let cur = list.shift();\n                if (loopIndex === 0) {\n                    if (cur.byteLength >= fixedLength) {\n                        if (needCutResult) {\n                            // Here is the key point for optimize memory alloc\n                            chunk = cur.subarray(0, fixedLength);\n                        }\n                        if (cur.byteLength > fixedLength) {\n                            cur = cur.subarray(fixedLength);\n                            list.unshift(cur);\n                        }\n                        break;\n                    }\n                    else {\n                        if (needCutResult) {\n                            try {\n                                chunk = new Uint8Array(fixedLength);\n                            }\n                            catch (e) {\n                                throw `alloc_memory_error@ cache buffer: ${fixedLength} ${e.message}`;\n                            }\n                            chunk.set(cur, 0);\n                        }\n                        offset += cur.byteLength;\n                    }\n                }\n                else {\n                    let subLen = fixedLength - offset;\n                    if (cur.byteLength >= subLen) {\n                        if (needCutResult) {\n                            chunk.set(cur.subarray(0, subLen), offset);\n                        }\n                        cur = cur.subarray(subLen);\n                        if (cur.byteLength > 0) {\n                            list.unshift(cur);\n                        }\n                        break;\n                    }\n                    else {\n                        if (needCutResult) {\n                            chunk.set(cur, offset);\n                        }\n                        offset += cur.byteLength;\n                        break;\n                    }\n                }\n                loopIndex++;\n            }\n            this.byteLength_ = null;\n        }\n        return chunk;\n    }\n}\n\n/**\n * @fileOverview A simple multimap template.\n */\nclass MultiMap {\n    constructor() {\n        this.map_ = {};\n    }\n    /**\n     * Add a key, value pair to the map.\n     * @param key\n     * @param value\n     */\n    push(key, value) {\n        if (Object.prototype.hasOwnProperty.call(this.map_, key)) {\n            this.map_[key].push(value);\n        }\n        else {\n            this.map_[key] = [value];\n        }\n    }\n    /**\n     * Get a list of values by key.\n     * @param key\n     */\n    get(key) {\n        let list = this.map_[key];\n        // slice() clones the list so that it and the map can each be modified\n        // without affecting the other.\n        return list ? list.slice() : null;\n    }\n    /**\n     * Get a list of all values.\n     */\n    getAll() {\n        let list = [];\n        for (let key in this.map_) {\n            list.push.apply(list, this.map_[key]);\n        }\n        return list;\n    }\n    /**\n     * Remove a specific value, if it exists.\n     * @param key\n     * @param value\n     */\n    remove(key, value) {\n        let list = this.map_[key];\n        if (list) {\n            for (let i = 0; i < list.length; ++i) {\n                if (list[i] == value) {\n                    list.splice(i, 1);\n                    --i;\n                }\n            }\n        }\n    }\n    /**\n     * Clear all keys and values from the multimap.\n     */\n    clear() {\n        this.map_ = {};\n    }\n    /**\n     * @param callback\n     */\n    forEach(callback) {\n        for (let key in this.map_) {\n            callback(key, this.map_[key]);\n        }\n    }\n}\n\n/**\n * Creates a new Binding_ and attaches the event listener to the event target.\n */\nclass Binding_ {\n    /**\n     * @param target - The event target.\n     * @param type - The event type.\n     * @param listener - The event listener.\n     */\n    constructor(target, type, listener) {\n        this.target = target;\n        this.type = type;\n        this.listener = listener;\n        if (this.target.addEventListener) {\n            this.target.addEventListener(type, listener, false);\n        }\n        else if (this.target.on) {\n            this.target.on(type, listener, false);\n        }\n    }\n    /**\n     * Detaches the event listener from the event target.\n     * This does nothing if the event listener is already detached.\n     */\n    off() {\n        if (this.target.removeEventListener) {\n            this.target.removeEventListener(this.type, this.listener, false);\n        }\n        else if (this.target.off) {\n            this.target.off(this.type, this.listener, false);\n        }\n        this.target = null;\n        this.listener = null;\n    }\n}\n/**\n * Creates a new EventManager.\n * An EventManager maintains a collection of \"event bindings\" between event targets and event listeners.\n */\nclass EventManager {\n    // static Binding_: Binding;\n    constructor() {\n        /**\n         * Maps an event type to an array of event bindings.\n         */\n        this.bindingMap_ = new MultiMap();\n    }\n    /**\n     * Detaches all event listeners.\n     * @override\n     */\n    destroy() {\n        this.removeAll();\n        this.bindingMap_ = null;\n    }\n    /**\n     * Attaches an event listener to an event target.\n     * @param target - The event target.\n     * @param type  - The event type.\n     * @param listener  - The event listener.\n     */\n    on(target, type, listener) {\n        if (!this.bindingMap_)\n            return;\n        let binding = new Binding_(target, type, listener);\n        this.bindingMap_.push(type, binding);\n        return this;\n    }\n    /**\n     * Attaches an event listener to an event target.\n     * The listener will be removed when the first instance of the event is fired.\n     * @param {EventTarget} target The event target.\n     * @param {string} type The event type.\n     * @param {function} listener The event listener.\n     */\n    once(target, type, listener) {\n        // Install a shim listener that will stop listening after the first event.\n        this.on(target, type, function (event) {\n            // Stop listening to this event.\n            this.off(target, type);\n            // Call the original listener.\n            listener(event);\n        }.bind(this));\n    }\n    /**\n     * Detaches an event listener from an event target.\n     * @param {EventTarget} target The event target.\n     * @param {string} type The event type.\n     */\n    off(target, type) {\n        if (!this.bindingMap_)\n            return;\n        let list = this.bindingMap_.get(type) || [];\n        for (let i = 0; i < list.length; ++i) {\n            let binding = list[i];\n            if (binding.target == target) {\n                binding.off();\n                this.bindingMap_.remove(type, binding);\n            }\n        }\n    }\n    /**\n     * Detaches all event listeners from all targets.\n     */\n    removeAll() {\n        if (!this.bindingMap_)\n            return;\n        let list = this.bindingMap_.getAll();\n        for (let i = 0; i < list.length; ++i) {\n            list[i].off();\n        }\n        this.bindingMap_.clear();\n    }\n}\n// EventManager.Binding_ = Binding;\n\n/**\n * @file: global.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * @description provide global scope.\n */\nlet global;\n// see https://stackoverflow.com/a/11237259/589493\nif (typeof window === 'undefined') {\n    /* eslint-disable-next-line no-undef */\n    global = self;\n}\nelse {\n    global = window;\n}\nvar global$1 = global;\n\n/**\n * @file: logger.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nlet console$1 = global$1.console;\nconst isWorker = typeof WorkerGlobalScope !== 'undefined' &&\n    self instanceof WorkerGlobalScope &&\n    typeof importScripts != 'undefined';\nconst prefix = '>>>';\nclass Logger extends EventEmitter {\n    constructor() {\n        super();\n        this._enable = false;\n    }\n    get enable() {\n        return this._enable;\n    }\n    set enable(value) {\n        this._enable = value;\n        this.MSG_NAME = '__log__';\n    }\n    log(...restArgs) {\n        if (isWorker) {\n            logger.emit(this.MSG_NAME, 'log', [...restArgs].join(''));\n        }\n        else {\n            if (this._enable) {\n                console$1.log.call(console$1, prefix, ...restArgs);\n            }\n        }\n    }\n    debug(...restArgs) {\n        if (isWorker) {\n            logger.emit(this.MSG_NAME, 'debug', [...restArgs].join(''));\n        }\n        else {\n            if (this._enable && console$1.debug) {\n                console$1.debug.call(console$1, prefix, ...restArgs);\n            }\n        }\n    }\n    assert(...restArgs) {\n        if (this._enable && console$1.assert) {\n            let condition = restArgs[0];\n            let sliceArgs = Array.prototype.slice.call(restArgs, 1);\n            sliceArgs.unshift(prefix);\n            console$1.assert.call(console$1, condition, ...sliceArgs);\n        }\n    }\n    warn(...restArgs) {\n        if (isWorker) {\n            logger.emit(this.MSG_NAME, 'warn', [...restArgs].join(''));\n        }\n        else {\n            if (this._enable) {\n                console$1.warn.call(console$1, prefix, ...restArgs);\n            }\n        }\n    }\n    error(...restArgs) {\n        if (isWorker) {\n            logger.emit(this.MSG_NAME, 'error', [...restArgs].join(''));\n        }\n        else {\n            if (this._enable) {\n                console$1.error.call(console$1, prefix, ...restArgs);\n            }\n        }\n    }\n}\nlet logger = new Logger();\n\n/**\n * @file: stream.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass Stream extends EventEmitter {\n    constructor() {\n        super();\n    }\n    /**\n     * connect to the next pipeline stream.\n     * @param destination\n     */\n    pipe(destination) {\n        this.on('reset', function () {\n            destination.reset();\n        });\n        this.on('data', function (data) {\n            destination.push(data);\n        });\n        this.on('done', function (flushSource) {\n            destination.flush(flushSource);\n        });\n        return destination;\n    }\n    /**\n     * detaches the next pipeline stream previously attached.\n     */\n    unpipe() {\n        this.removeAllListeners('reset');\n        this.removeAllListeners('data');\n        this.removeAllListeners('done');\n        return this;\n    }\n    /**\n     * push data to current pipeline.\n     * @param data\n     */\n    push(data, conf) {\n        this.emit('data', data);\n    }\n    /**\n     * flush current pipeline.\n     * @param flushSource\n     */\n    flush(flushSource) {\n        this.emit('done', flushSource);\n    }\n    reset() {\n        this.emit('reset');\n    }\n}\n\n/**\n * @file: demuxer.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass DemuxFacade extends Stream {\n    constructor(options = {}) {\n        super();\n        if (options.debug) {\n            logger.enable = true;\n        }\n        this.ctx_ = new Context();\n        this.options_ = options;\n        this.cache_buffer_ = new CacheBuffer();\n    }\n    listenEndStream_() {\n        this.eventManager_ = new EventManager();\n        this.eventManager_\n            .on(this.endStream, 'data', (data) => {\n            this.emit(Events.DEMUX_DATA, data);\n        })\n            .on(this.endStream, 'done', (data) => {\n            this.emit(Events.DONE, data);\n        })\n            .on(this.ctx_, 'error', (data) => {\n            this.emit(Events.ERROR, data);\n        });\n    }\n    /**\n     * transfer data to Uint8Array\n     * @param buf\n     */\n    constraintPushData_(buf) {\n        let newBuf = null;\n        if (!isArrayBuffer(buf) && !isUint8Array(buf)) {\n            logger.error(`Data pushed is not an ArrayBuffer or Uint8Array: ${buf}`);\n            return newBuf;\n        }\n        if (isArrayBuffer(buf)) {\n            newBuf = new Uint8Array(buf);\n        }\n        else {\n            newBuf = buf;\n        }\n        return newBuf;\n    }\n    reset() { }\n    destroy() {\n        this.unpipe();\n        this.endStream.unpipe();\n        this.eventManager_.removeAll();\n    }\n}\n\n/**\n * @file: mux-error-code.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * @readonly\n * @enum {Number}\n */\nvar codes;\n(function (codes) {\n    codes[codes[\"WORKER_EXCEPTION\"] = 0] = \"WORKER_EXCEPTION\";\n    codes[codes[\"WORKER_MSG_EXCEPTION\"] = 1] = \"WORKER_MSG_EXCEPTION\";\n    codes[codes[\"TS_SYNC_BYTE\"] = 2] = \"TS_SYNC_BYTE\";\n    codes[codes[\"FLV_HEAD_SIGNATURE\"] = 3] = \"FLV_HEAD_SIGNATURE\";\n    codes[codes[\"FLV_NOT_EXPECTED_ADJACENT_DATA\"] = 4] = \"FLV_NOT_EXPECTED_ADJACENT_DATA\";\n})(codes || (codes = {}));\nvar muxErrorCode = codes;\n\n/**\n * @file: patSection.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * Structure for pat.\n */\nclass PATSection {\n    // CRC_32: number;\n    constructor(buffer) {\n        // program_association_section 0x00\n        // this.table_id = buffer[0];\n        // this.section_syntax_indicator = buffer[1] >> 7;\n        // this.zero = (buffer[1] >> 6) & 0x1;\n        // this.reserved_0 = (buffer[1] >> 4) & 0x3;\n        // the number of bytes of the section\n        // starting immediately following the section_length field, and including the CRC.\n        let section_length = ((buffer[1] & 0x0f) << 8) | buffer[2];\n        // this.transport_stream_id = (buffer[3] << 8) | buffer[4];\n        // this.reserved_1 = buffer[5] >> 6;\n        // this.version_number = (buffer[5] >> 1) & 0x1f;\n        // this.current_next_indicator = buffer[5] && 0x01;\n        // The section_number of the first section in the Program Association Table shall be 0x00.\n        // It shall be incremented by 1 with each additional section in the PAT.\n        // this.section_number = buffer[6];\n        // The number of the last section (that is, the section with the highest section_number) of the complete PAT.\n        // this.last_section_number = buffer[7];\n        // this.network_PID = 0x00;\n        var n = 0, program_num;\n        // reserved_3;\n        var len = section_length - 4 - 5; // 4: crc32, 5: bytes followed by section_length\n        this.pmtTable = [];\n        /* loop by 4 bytes, during  */\n        for (; n < len; n += 4) {\n            program_num = (buffer[n + 8] << 8) | buffer[n + 9];\n            // reserved_3 = buffer[10 + n] >> 5;\n            if (program_num == 0x00) {\n                let network_PID = ((buffer[10 + n] & 0x1f) << 8) | buffer[11 + n];\n                // 记录该TS流的网络PID\n                // TS_network_Pid = this.network_PID;\n                logger.log('packet->network_PID %0x /n/n', network_PID);\n            }\n            else {\n                this.pmtTable.push({\n                    programNum: program_num,\n                    program_map_PID: ((buffer[10 + n] & 0x1f) << 8) | buffer[11 + n]\n                });\n                // TS_PAT_Program\n                // PAT_program;\n                // PAT_program.program_map_PID = (buffer[10 + n] & 0x1F) << 8 | buffer[11 + n];\n                // PAT_program.program_number = program_num;\n                // this.program.push_back(PAT_program);\n                // TS_program.push_back(PAT_program);//向全局PAT节目数组中添加PAT节目信息\n            }\n        }\n        // var crcLength = this.section_length + 3;\n        // this.CRC_32 =\n        //     ((buffer[crcLength - 4] & 0x000000ff) << 24) |\n        //     ((buffer[crcLength - 3] & 0x000000ff) << 16) |\n        //     ((buffer[crcLength - 2] & 0x000000ff) << 8) |\n        //     (buffer[crcLength - 1] & 0x000000ff);\n    }\n}\n\n/**\n * @file: pmtSection.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * Structure for PMT.\n */\nclass PMTSection {\n    // CRC_32: number;\n    constructor(buffer) {\n        // program_map_section  0x02\n        // this.table_id = buffer[0];\n        // this.section_syntax_indicator = buffer[1] >> 7;\n        // this.zero = (buffer[1] >> 6) & 0x1;\n        // this.reserved_0 = (buffer[1] >> 4) & 0x3;\n        // the number of bytes of the section\n        // starting immediately following the section_length field, and including the CRC.\n        let section_length = ((buffer[1] & 0x0f) << 8) | buffer[2];\n        // It specifies the program to which the program_map_PID is applicable.\n        // this.program_number = (buffer[3] << 8) | buffer[4];\n        // this.reserved_1 = buffer[5] >> 6;\n        // this.version_number = (buffer[5] >> 1) & 0x1f;\n        // this.current_next_indicator = buffer[5] && 0x01;\n        // The section_number of the first section in the Program Association Table shall be 0x00.\n        // It shall be incremented by 1 with each additional section in the PAT.\n        // this.section_number = buffer[6];\n        // The number of the last section (that is, the section with the highest section_number) of the complete PAT.\n        // this.last_section_number = buffer[7];\n        // contain the PCR fields valid for the program specified by program_number.\n        // this.PCR_PID = ((buffer[8] & 0x1f) << 8) | buffer[9];\n        // this.reserved_2 = buffer[10] >> 4;\n        // The number of bytes of the descriptors immediately following the program_info_length field.\n        const program_info_length = ((buffer[10] & 0x0f) << 8) | buffer[11];\n        if (program_info_length < 0) {\n            return;\n        }\n        else if (program_info_length > 2) {\n            let i = 0;\n            while (i < program_info_length) {\n                // let descriptor_tag = buffer[12 + i];\n                let descriptor_length = buffer[13 + i];\n                // \tlogger.log('descriptor_tag', descriptor_tag, descriptor_length);\n                i += descriptor_length;\n            }\n        }\n        var es_section_pos = 12 + program_info_length;\n        var es_section_len = section_length - program_info_length - 9 - 4; // 9: bytes followed by section_length, 4: crc32\n        var es_section_end = es_section_pos + es_section_len;\n        if (es_section_pos >= es_section_end) {\n            logger.warn(`es_section_pos < es_section_end ${es_section_pos}, ${es_section_end}`);\n            return;\n        }\n        this.pes_table = [];\n        let j = 0;\n        while (j < es_section_len) {\n            let basePos = es_section_pos + j;\n            let stream_type = buffer[basePos];\n            let elementary_PID = ((buffer[basePos + 1] << 8) | buffer[basePos + 2]) & 0x1fff;\n            let ES_info_length = ((buffer[basePos + 3] << 8) | buffer[basePos + 4]) & 0x0fff;\n            this.pes_table.push({\n                streamType: stream_type,\n                PID: elementary_PID\n            });\n            // if (ES_info_length > 2) {\n            //     let k = 0;\n            //     let es_pos = basePos + 5;\n            //     while (k < ES_info_length) {\n            //         // let descriptor_tag = buffer[es_pos + k];\n            //         let descriptor_length = buffer[es_pos + k];\n            //         // if (descriptor_tag === )\n            //         k += descriptor_length;\n            //     }\n            // }\n            j += ES_info_length + 5;\n        }\n        // var crcLength = this.section_length + 3;\n        // this.CRC_32 =\n        //     ((buffer[crcLength - 4] & 0x000000ff) << 24) |\n        //     ((buffer[crcLength - 3] & 0x000000ff) << 16) |\n        //     ((buffer[crcLength - 2] & 0x000000ff) << 8) |\n        //     (buffer[crcLength - 1] & 0x000000ff);\n    }\n}\n\n/**\n * @file: m2t-pid.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * @overview Program and program element descriptors.\n * @see ISO/IEC 13818-1: Table 2-3 – PID table\n * @see DVB SI: 5.1.3 Coding of PID and table_id fields\n */\n/**\n * @readonly\n * @enum {number}\n * @export\n */\nconst PAT_PID = 0x0000;\nconst CAT_PID = 0x0001;\nconst TSDT_PID = 0x0002;\n/* reserved 0x0003 to 0x000F */\nconst SDT_PID = 0x0011;\n\n/**\n * @file: psi.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n// class Metadata {\n//     service_name: string;\n//     service_provider: string;\n// }\nclass PSI {\n    constructor() {\n        // this.metadata = new Metadata();\n        this.pat_table = [];\n        this.pes_streams = [];\n    }\n    /**\n     * program PID\n     */\n    get currentProgramPID() {\n        let _pmtIds = [];\n        for (let i = 0; i < this.pat_table.length; i++) {\n            _pmtIds.push(this.pat_table[i].pid);\n        }\n        return _pmtIds.length > 0 ? _pmtIds[0] : -1;\n    }\n    get tracks() {\n        return this.pes_streams;\n    }\n    // get pmtTable() {\n    //     return this.pat_table;\n    // }\n    /**\n     * 目前对于PSI的信息，持久化保留在内存中\n     * 对于同一个片子，HLS规范会规定只能有一个 PMT/PAT 表\n     * 所以一部片子的PSI信息应该是保持不变的，换片子后PSI信息的销毁通过 mux 重新实例化产生新的信息，不需要调用reset\n     * 有些 TS 文件在HLS切片器切割的时候，没有带上PAT/PMT等表，需要相邻 TS 给定的表信息\n     */\n    reset() {\n        // this.metadata = new Metadata();\n        this.pat_table.splice(0, this.pat_table.length);\n        this.pes_streams.splice(0, this.pes_streams.length);\n    }\n    /**\n     * @param packet\n     */\n    parse(packet) {\n        const self = this;\n        // ISO13818-1: Table 2-3 – PID table\n        if (PAT_PID === packet.PID) {\n            /* PAT PID */\n            this._parsePat(packet);\n        }\n        else if (CAT_PID === packet.PID) ;\n        else if (TSDT_PID === packet.PID) ;\n        else if (0x0003 <= packet.PID && packet.PID <= 0x000f) ;\n        else if (SDT_PID === packet.PID) ;\n        else if (packet.PID === self.currentProgramPID) {\n            /* PMT PID */\n            this._parsePmt(packet);\n        }\n        // else if (this.findTrack(packet.PID)) {\n        // \t/* Reserved */\n        // } else {\n        // \tlogger.warn(`psi unknown packet PID ${packet.PID}`);\n        // }\n    }\n    // findPmtProgram(PID) {\n    // \tlet program = null;\n    //\n    // \tfor (let i = 0; i < this.pat_table.length; i++) {\n    // \t\tif (this.pat_table[i].pid === PID) {\n    // \t\t\tprogram = this.pat_table[i].id;\n    // \t\t\tbreak;\n    // \t\t}\n    // \t}\n    //\n    // \treturn program;\n    // }\n    /**\n     * @param PID\n     */\n    findTrack(PID) {\n        let program = null;\n        let streams = this.pes_streams;\n        for (let i = 0; i < streams.length; i++) {\n            if (streams[i].id === PID) {\n                program = streams[i];\n                break;\n            }\n        }\n        return program;\n    }\n    /**\n     * Parse PAT Packet\n     * @param pack\n     */\n    _parsePat(pack) {\n        let data;\n        if (pack.payload_unit_start_indicator) {\n            // psi has pointer_field\n            let pointer = pack.payload[0];\n            data = pack.payload.subarray(pointer + 1);\n        }\n        else {\n            data = pack.payload;\n        }\n        let pat = new PATSection(data);\n        // https://tools.ietf.org/html/rfc8216#section-3.2\n        // Transport Stream Segments MUST contain a single MPEG-2 Program;\n        for (var i = 0; i < pat.pmtTable.length; i++) {\n            this._add_pid_to_pmt(pat.pmtTable[i].programNum, pat.pmtTable[i].program_map_PID);\n        }\n        return pat;\n    }\n    /**\n     * Associates Program Number and Program Map Table(PMT) PID\n     * @param programId\n     * @param pid\n     */\n    _add_pid_to_pmt(programId, pid) {\n        let table = this.pat_table;\n        function get_pmt(id) {\n            for (let i = 0, item; i < table.length; i++) {\n                item = table[i];\n                if (item.id === id) {\n                    return {\n                        idx: i,\n                        item\n                    };\n                }\n            }\n            return null;\n        }\n        let p = get_pmt(programId);\n        if (!p) {\n            table.push({\n                id: programId,\n                pid: pid\n            });\n        }\n    }\n    /**\n     * Parse PMT Packet\n     * @param pack\n     */\n    _parsePmt(pack) {\n        let data;\n        if (pack.payload_unit_start_indicator) {\n            // psi has pointer_field\n            let pointer = pack.payload[0];\n            data = pack.payload.subarray(pointer + 1);\n        }\n        else {\n            data = pack.payload;\n        }\n        let pmt = new PMTSection(data);\n        for (var i = 0; i < pmt.pes_table.length; i++) {\n            this._add_pes_stream(pmt.pes_table[i]);\n        }\n        return pmt;\n    }\n    /**\n     * @param stream\n     * @param pmt\n     */\n    _add_pes_stream(stream /*, pmt?: PMTSection*/) {\n        let streams = this.pes_streams;\n        function get_program(id) {\n            for (let i = 0, item; i < streams.length; i++) {\n                item = streams[i];\n                if (item.id === id) {\n                    return {\n                        idx: i,\n                        item\n                    };\n                }\n            }\n            return null;\n        }\n        let p = get_program(stream.PID);\n        if (!p) {\n            streams.push({\n                id: stream.PID,\n                stream_type: stream.streamType,\n                duration: 0,\n                sps: [],\n                pps: [],\n                pixelRatio: [1, 1],\n                timescale: 90000,\n                width: 0,\n                height: 0\n            });\n        }\n    }\n}\n\n/**\n * @file: complex.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n\nclass M2TSComplexStream extends Stream {\n    constructor(ctx, psi) {\n        super();\n\n        /** @private */\n        this.context = ctx;\n\n        /** @private {PSI} */\n        this.PSI = psi;\n\n        /** @private {Object} */\n        this.videoTrack = null;\n\n        /** @private {Object} */\n        this.audioTrack = null;\n\n        /** @private {Object} */\n        this.captionTrack = null;\n\n        // pipe specified by outside.\n    }\n\n    push(data) {\n        let tracks = data;\n\n        for (let i = 0, track; i < tracks.length; i++) {\n            track = tracks[i];\n\n            switch (track.type) {\n                case 'video':\n                    // data -> GOPs\n                    this._complexVideo(track);\n                    break;\n                case 'audio':\n                    this._complexAudio(track);\n                    break;\n                case 'caption':\n                    this._complexCaption(track);\n                    break;\n            }\n        }\n    }\n\n    flush() {\n        this.emit('done');\n\n        this._clearStream();\n    }\n\n    reset() {\n        this._clearStream();\n\n        // This is demux end stream, so don't emit reset.\n        // this.emit('reset');\n    }\n\n    _clearStream() {\n        this.videoTrack = null;\n        this.audioTrack = null;\n        this.captionTrack = null;\n    }\n\n    _complexVideo(gops) {\n        let track = this.PSI.findTrack(gops.trackId);\n\n        if (track) {\n            track.type = 'video';\n            track.gops = gops;\n            track.firstDTS = gops[0][0].dts;\n            track.firstPTS = gops[0][0].pts;\n            // set duration to Infinity(POSITIVE_INFINITY) can be useful for live.\n            // If Infinity it will loose the ability to seek.\n            track.duration = Number.POSITIVE_INFINITY;\n\n            this.videoTrack = track;\n\n            this.emit('data', {\n                videoTrack: this.videoTrack\n            });\n        }\n    }\n\n    _complexAudio(frames) {\n        let track = this.PSI.findTrack(frames.trackId);\n\n        if (track) {\n            track.type = 'audio';\n            track.frames = frames;\n            track.firstPTS = track.firstDTS = frames[0].dts;\n\n            // set duration to Infinity(POSITIVE_INFINITY) can be useful for live.\n            // If Infinity it will loose the ability to seek.\n            track.duration = Number.POSITIVE_INFINITY;\n\n            this.audioTrack = track;\n\n            this.emit('data', {\n                audioTrack: this.audioTrack\n            });\n        }\n    }\n\n    _complexCaption() {}\n}\n\n/**\n * @file: platform.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * @description device\n */\nconst os = {\n    mac: false,\n    iphone: false,\n    android: false\n};\nconst browser = {\n    version: false,\n    CHROME: false,\n    SAFARI: false,\n    FIREFOX: false,\n    IE11: false,\n    IE: false,\n    EDGE: false,\n    WECHAT: false\n};\nlet nav = navigator;\n// let platform = nav.platform;\nlet ua = nav.userAgent.toLowerCase();\nvar match = /(edge)\\/([\\w.]+)/.exec(ua) ||\n    /(opr)[/]([\\w.]+)/.exec(ua) ||\n    /(chrome)[ /]([\\w.]+)/.exec(ua) ||\n    /(firefox)[ /]([\\w.]+)/.exec(ua) ||\n    /(iemobile)[/]([\\w.]+)/.exec(ua) ||\n    /(version)(applewebkit)[ /]([\\w.]+).*(safari)[ /]([\\w.]+)/.exec(ua) ||\n    /(webkit)[ /]([\\w.]+).*(version)[ /]([\\w.]+).*(safari)[ /]([\\w.]+)/.exec(ua) ||\n    /(webkit)[ /]([\\w.]+)/.exec(ua) ||\n    /(opera)(?:.*version|)[ /]([\\w.]+)/.exec(ua) ||\n    /(msie) ([\\w.]+)/.exec(ua) ||\n    (ua.indexOf('trident') >= 0 && /(rv)(?::| )([\\w.]+)/.exec(ua)) ||\n    (ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\\w.]+)|)/.exec(ua)) ||\n    [];\nvar platform_match = /(ipad)/.exec(ua) ||\n    /(ipod)/.exec(ua) ||\n    /(windows phone)/.exec(ua) ||\n    /(iphone)/.exec(ua) ||\n    /(kindle)/.exec(ua) ||\n    /(silk)/.exec(ua) ||\n    /(android)/.exec(ua) ||\n    /(win)/.exec(ua) ||\n    /(mac)/.exec(ua) ||\n    /(linux)/.exec(ua) ||\n    /(cros)/.exec(ua) ||\n    /(playbook)/.exec(ua) ||\n    /(bb)/.exec(ua) ||\n    /(blackberry)/.exec(ua) ||\n    [];\nvar result = {\n    version: undefined\n};\nvar matched = {\n    browser: match[5] || match[3] || match[1] || '',\n    version: match[2] || match[4] || '0',\n    versionNumber: match[4] || match[2] || '0',\n    platform: platform_match[0] || ''\n};\nif (matched.browser) {\n    result[matched.browser] = true;\n    // result.version = matched.version;\n    // result.versionNumber = parseInt(matched.versionNumber, 10);\n    let versionArray = matched.versionNumber.split('.');\n    result.version = {\n        major: parseInt(matched.versionNumber, 10),\n        string: matched.version\n    };\n    if (versionArray.length > 1) {\n        result.version.minor = parseInt(versionArray[1], 10);\n    }\n    if (versionArray.length > 2) {\n        result.version.build = parseInt(versionArray[2], 10);\n    }\n}\n// -------------------------------------- browser --------------------------------------\nbrowser.version = result.version;\nbrowser.CHROME = !!result['chrome'];\nbrowser.SAFARI = !!result['safari'] && !browser.CHROME;\nbrowser.FIREFOX = !!result['firefox'];\nbrowser.IE11 = /rv:11/.test(ua);\nbrowser.IE = !!result['msie'] || browser.IE11;\nbrowser.EDGE = !!result['edge'];\nbrowser.WECHAT = /(wechat)|(micromessenger)/.test(ua);\n// -------------------------------------- os --------------------------------------\nos.mac = !!matched.platform['mac'];\nos.iphone = !!matched.platform['iphone'];\nos.android = !!matched.platform['android'];\nvar platform = {\n    browser: browser,\n    os: os\n};\n\n/**\n * @file: aac-config.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/*\n    sampling freq,\n    0: 96000 Hz\n    1: 88200 Hz\n    2: 64000 Hz\n    3: 48000 Hz\n    4: 44100 Hz\n    5: 32000 Hz\n    6: 24000 Hz\n    7: 22050 Hz\n    8: 16000 Hz\n    9: 12000 Hz\n    10: 11025 Hz\n    11: 8000 Hz\n    12: 7350 Hz\n    13: Reserved\n    14: Reserved\n    15: frequency is written explictly\n */\nconst samplingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];\nvar getAudioConfig = (audioObjectType, samplingFrequencyIndex, channelCount) => {\n    let adtsExtensionSamplingIndex;\n    let realAudioObjectType = audioObjectType;\n    let config;\n    if (samplingFrequencyIndex > samplingRates.length - 1) {\n        logger.error(`invalid sampling index:${samplingFrequencyIndex}`);\n        return;\n    }\n    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)\n    if (platform.browser.FIREFOX) {\n        if (samplingFrequencyIndex >= 6) {\n            audioObjectType = 5;\n            config = new Array(4);\n            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies\n            // there is a factor 2 between frame sample rate and output sample rate\n            // multiply frequency by 2 (see table below, equivalent to substract 3)\n            adtsExtensionSamplingIndex = samplingFrequencyIndex - 3;\n        }\n        else {\n            audioObjectType = 2;\n            config = new Array(2);\n            adtsExtensionSamplingIndex = samplingFrequencyIndex;\n        }\n        // Android : always use AAC\n    }\n    else if (platform.os.android) {\n        audioObjectType = 2;\n        config = new Array(2);\n        adtsExtensionSamplingIndex = samplingFrequencyIndex;\n    }\n    else {\n        /*  for other browsers (Chrome/Vivaldi/Opera ...)\n                always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)\n            */\n        audioObjectType = 5;\n        config = new Array(4);\n        // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)\n        if (samplingFrequencyIndex >= 6) {\n            // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies\n            // there is a factor 2 between frame sample rate and output sample rate\n            // multiply frequency by 2 (see table below, equivalent to substract 3)\n            adtsExtensionSamplingIndex = samplingFrequencyIndex - 3;\n        }\n        else {\n            // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)\n            // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.\n            if (channelCount === 1) {\n                audioObjectType = 2;\n                config = new Array(2);\n            }\n            adtsExtensionSamplingIndex = samplingFrequencyIndex;\n        }\n    }\n    /*\n        refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config ISO 14496-3 (AAC).pdf\n            - Table 1.13 — Syntax of AudioSpecificConfig()\n          Audio Profile / Audio Object Type\n          0: Null\n          1: AAC Main\n          2: AAC LC (Low Complexity)\n          3: AAC SSR (Scalable Sample Rate)\n          4: AAC LTP (Long Term Prediction)\n          5: SBR (Spectral Band Replication)\n          6: AAC Scalable\n\n          Channel Configurations\n          These are the channel configurations:\n          0: Defined in AOT Specifc Config\n          1: 1 channel: front-center\n          2: 2 channels: front-left, front-right\n        */\n    // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1\n    config[0] = audioObjectType << 3;\n    // samplingFrequencyIndex\n    config[0] |= (samplingFrequencyIndex & 0x0e) >> 1;\n    config[1] |= (samplingFrequencyIndex & 0x01) << 7;\n    // channelConfiguration\n    config[1] |= channelCount << 3;\n    if (audioObjectType === 5) {\n        // adtsExtensionSamplingIndex\n        config[1] |= (adtsExtensionSamplingIndex & 0x0e) >> 1;\n        config[2] = (adtsExtensionSamplingIndex & 0x01) << 7;\n        // audioObjectType (force to 2, chrome is checking that object type is less than 5 ???\n        //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc\n        config[2] |= 2 << 2;\n        config[3] = 0;\n    }\n    return {\n        config: config,\n        sampleRate: samplingRates[samplingFrequencyIndex],\n        channelCount: channelCount,\n        codec: 'mp4a.40.' + audioObjectType,\n        realCodec: 'mp4a.40.' + realAudioObjectType\n    };\n};\n\n/**\n * @file: created at Saturday, 9th May 2020 11:13:19 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nconst AAC_SAMPLING_FREQUENCIES = [\n    96000,\n    88200,\n    64000,\n    48000,\n    44100,\n    32000,\n    24000,\n    22050,\n    16000,\n    12000,\n    11025,\n    8000,\n    7350\n];\n\n/**\n * @file: adts.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * @extends EventEmitter\n */\nclass ADTSCodec extends EventEmitter {\n    constructor() {\n        super();\n    }\n    push(data) {\n        let { pts, dts, payload } = data;\n        let data_byte = payload;\n        let i = 0, frameNum = 0, frameLength, protectionSkipBytes, frameEnd, sampleCount, adtsFrameDuration;\n        while (i + 5 < data_byte.length) {\n            // Look for the start of an ADTS header..\n            if (data_byte[i] !== 0xff || (data_byte[i + 1] & 0xf6) !== 0xf0) {\n                // If a valid header was not found,  jump one forward and attempt to\n                // find a valid ADTS header starting at the next byte\n                i++;\n                continue;\n            }\n            // The protection skip bit tells us if we have 2 bytes of CRC data at the\n            // end of the ADTS header\n            protectionSkipBytes = (~data_byte[i + 1] & 0x01) * 2;\n            // Frame length is a 13 bit integer starting 16 bits from the\n            // end of the sync sequence\n            frameLength =\n                ((data_byte[i + 3] & 0x03) << 11) | (data_byte[i + 4] << 3) | ((data_byte[i + 5] & 0xe0) >> 5);\n            sampleCount = ((data_byte[i + 6] & 0x03) + 1) * 1024;\n            adtsFrameDuration = (sampleCount * 90000) / AAC_SAMPLING_FREQUENCIES[(data_byte[i + 2] & 0x3c) >>> 2];\n            frameEnd = i + frameLength;\n            // If we don't have enough data to actually finish this ADTS frame, return\n            // and wait for more data\n            if (data_byte.byteLength < frameEnd) {\n                return;\n            }\n            let aacFrame = {\n                pts: pts + frameNum * adtsFrameDuration,\n                dts: dts + frameNum * adtsFrameDuration,\n                sampleCount: sampleCount,\n                audioObjectType: ((data_byte[i + 2] >>> 6) & 0x03) + 1,\n                channelCount: ((data_byte[i + 2] & 1) << 2) | ((data_byte[i + 3] & 0xc0) >>> 6),\n                sampleRate: AAC_SAMPLING_FREQUENCIES[(data_byte[i + 2] & 0x3c) >>> 2],\n                samplingFrequencyIndex: (data_byte[i + 2] & 0x3c) >>> 2,\n                // assume ISO/IEC 14496-12 AudioSampleEntry default of 16\n                sampleSize: 16,\n                data: data_byte.subarray(i + 7 + protectionSkipBytes, frameEnd)\n            };\n            // Otherwise, deliver the complete AAC frame\n            this.emit('frame', aacFrame);\n            // If the data_byte is empty, clear it and return\n            if (data_byte.byteLength === frameEnd) {\n                data_byte = undefined;\n                this.emit('done');\n                return;\n            }\n            frameNum++;\n            // Remove the finished frame from the data_byte and start the process again\n            data_byte = data_byte.subarray(frameEnd);\n        }\n    }\n}\n\n/**\n * @file: adts.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass ADTSStream extends Stream {\n    constructor(psi) {\n        super();\n        this.PSI = psi;\n        this.trackId = null;\n        /** @private {ADTSCodec} */\n        this.codec = new ADTSCodec();\n        this.codec.on('frame', (frame) => {\n            this.frames.push(frame);\n            this.frames.byteLength += frame.data.byteLength;\n            this.frames.trackId = this.trackId;\n        });\n        this._newFrames();\n    }\n    push(data) {\n        if (data.stream_type === 15 /* ADTS */) {\n            this.trackId = data.pid;\n            this.codec.push({\n                dts: data.pes.DTS,\n                pts: data.pes.PTS,\n                payload: data.pes.data_byte\n            });\n        }\n    }\n    flush() {\n        if (this.frames.length > 0) {\n            let count = this.frames.length;\n            let firstFrame = this.frames[0];\n            let lastFrame = this.frames[count - 1];\n            let lastDuration = (lastFrame.sampleRate * lastFrame.sampleCount) / 90000;\n            this.frames.firstDTS = firstFrame.dts;\n            this.frames.firstPTS = firstFrame.pts;\n            if (count === 1) {\n                this.frames.duration = lastDuration;\n            }\n            else {\n                this.frames.duration = lastDuration + (lastFrame.pts - firstFrame.pts);\n            }\n            // To prevent information mismatch leading to next pipeline decoding errors\n            // Every audio frame list assembly needs to update track meta.\n            this._updateTrackMeta(firstFrame);\n            this.emit('data', this.frames);\n            this.reset();\n            this.emit('done');\n        }\n    }\n    reset() {\n        this.trackId = null;\n        this._newFrames();\n    }\n    _newFrames() {\n        this.frames = []; // aac frames\n        this.frames.type = 'audio';\n        this.frames.byteLength = 0;\n        this.frames.duration = 0;\n        this.frames.firstDTS = 0;\n        this.frames.firstPTS = 0;\n    }\n    /**\n     * @param {Object} frame\n     */\n    _updateTrackMeta(frame) {\n        let track = this.PSI.findTrack(this.trackId);\n        let config = getAudioConfig(frame.audioObjectType, frame.samplingFrequencyIndex, frame.channelCount);\n        track.config = config.config;\n        track.sampleRate = config.sampleRate;\n        track.inputTimeScale = track.inputTimeScale || track.timescale;\n        track.timescale = config.sampleRate;\n        track.channelCount = config.channelCount;\n        track.codec = config.codec;\n        track.realCodec = config.realCodec;\n        track.isAAC = true;\n    }\n}\n\n/**\n * @file: dv.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * Bit buffer reader like DataView.\n */\nfunction read(buf) {\n    let byteOffset = 0;\n    if (ArrayBuffer.isView(buf)) {\n        byteOffset = buf.byteOffset;\n        buf = buf.buffer;\n    }\n    return new DataView(buf, byteOffset);\n}\nclass DataViewReader {\n    constructor() { }\n    /**\n     * Gets an unsigned 8-bit integer (unsigned byte).\n     * @param buffer\n     * @param byteOffset    The offset, in byte, from the start of the view where to read the data.\n     * @returns {number}    An unsigned 8-bit integer number.\n     */\n    readUint8(buffer, byteOffset) {\n        return read(buffer).getUint8(byteOffset);\n    }\n    /**\n     * Gets an unsigned 16-bit integer (unsigned long).\n     * @param buffer\n     * @param byteOffset     The offset, in byte, from the start of the view where to read the data.\n     * @param littleEndian   Indicates whether the 16-bit int is stored in little- or big-endian format.\n     * @returns {number}     An unsigned 16-bit integer number.\n     */\n    readUint16(buffer, byteOffset, littleEndian = false) {\n        return read(buffer).getUint16(byteOffset, littleEndian);\n    }\n    /**\n     * Gets an unsigned 32-bit integer (unsigned long).\n     * @param buffer\n     * @param byteOffset        The offset, in byte, from the start of the view where to read the data.\n     * @param littleEndian      Indicates whether the 32-bit int is stored in little- or big-endian format.\n     * @returns {number}        An unsigned 32-bit integer number.\n     */\n    readUint32(buffer, byteOffset, littleEndian = false) {\n        return read(buffer).getUint32(byteOffset, littleEndian);\n    }\n}\n\n/**\n * @file: ep3b.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * discard the emulation_prevention_three_byte\n * @param data\n */\nfunction discardEP3B(data) {\n    let length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData = new Uint8Array(0);\n    // Find all `Emulation Prevention Bytes`\n    while (i < length - 2) {\n        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {\n            emulationPreventionBytesPositions.push(i + 2);\n            i += 2;\n        }\n        else {\n            i++;\n        }\n    }\n    // If no Emulation Prevention Bytes were found just return the original\n    // array\n    if (emulationPreventionBytesPositions.length === 0) {\n        return data;\n    }\n    // Create a new array to hold the NAL unit data\n    newLength = length - emulationPreventionBytesPositions.length;\n    try {\n        newData = new Uint8Array(newLength);\n    }\n    catch (e) {\n        throw `epsb alloc mem error ${newLength}`;\n    }\n    let sourceIndex = 0;\n    for (i = 0; i < newLength; sourceIndex++, i++) {\n        if (sourceIndex === emulationPreventionBytesPositions[0]) {\n            // Skip this byte\n            sourceIndex++;\n            // Remove this position index\n            emulationPreventionBytesPositions.shift();\n        }\n        newData[i] = data[sourceIndex];\n    }\n    return newData;\n}\n\n/**\n * @file: exp-golumb.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * exp golumb algorithm.\n * codeNum = 2leadingZeroBits – 1 + read_bits( leadingZeroBits )\n * @see https://en.wikipedia.org/wiki/Exponential-Golomb_coding\n */\n/**\n * read n bit.\n * @param buffer\n * @param bitOffset\n * @param length\n * @private\n */\nfunction readBit(buffer, bitOffset = 0, length = 1) {\n    let startByte = 0;\n    let startByteBitPos = 0;\n    let val = 0;\n    let bitStr = '', bitVal = 0;\n    for (let j = bitOffset; j < bitOffset + length; j++) {\n        startByte = Math.floor(j / 8);\n        startByteBitPos = 7 - (j % 8);\n        bitVal = (buffer[startByte] >> startByteBitPos) & 0x01;\n        bitStr += bitVal;\n    }\n    val = parseInt(bitStr, 2);\n    return val;\n}\n/**\n * read 1 byte.\n * @param buffer\n * @param bitOffset\n */\nfunction readByte(buffer, bitOffset = 0) {\n    return readBit(buffer, bitOffset, 8);\n}\n/**\n * Unsigned Integer Exp-Golomb Coded.\n * @param buffer\n * @param bitOffset\n */\nfunction readUEV(buffer, bitOffset = 0) {\n    let leadingZeros = [];\n    let bitLength = buffer.byteLength * 8;\n    let readBit1 = false;\n    let startByte = 0;\n    let startByteBitPos = 0;\n    let bitVal = 0;\n    let value = '';\n    // 1. 计算 leadingZeros\n    for (let i = bitOffset; i < bitLength; i++) {\n        startByte = Math.floor(i / 8);\n        startByteBitPos = 7 - (i % 8);\n        bitVal = (buffer[startByte] >> startByteBitPos) & 0x01;\n        if (!readBit1) {\n            if (bitVal === 0) {\n                leadingZeros.push(0);\n            }\n            else {\n                readBit1 = true;\n                bitOffset = i;\n                break;\n            }\n        }\n    }\n    let codeNumLength = leadingZeros.length + 1;\n    // 2. 计算有效位数值\n    for (let j = bitOffset; j < bitOffset + codeNumLength; j++) {\n        startByte = Math.floor(j / 8);\n        startByteBitPos = 7 - (j % 8);\n        bitVal = (buffer[startByte] >> startByteBitPos) & 0x01;\n        value += bitVal;\n    }\n    return {\n        bitLength: leadingZeros.length + codeNumLength,\n        value: parseInt(value, 2) - 1\n    };\n}\n/**\n * Signed Integer Exp-Golomb Coded.\n * @param buffer\n * @param bitOffset\n */\nfunction readSEV(buffer, bitOffset = 0) {\n    let uev = readUEV(buffer, bitOffset);\n    let codeNum = uev.value;\n    let signedValue = Math.pow(-1, codeNum + 1) * Math.ceil(codeNum / 2);\n    return {\n        bitLength: uev.bitLength,\n        value: signedValue\n    };\n}\nvar ExpGolomb = {\n    readUEV,\n    readSEV,\n    readBit,\n    readByte\n};\n\n/**\n * @file: sps.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nlet bitOffset = 0;\n/**\n * 7.3.2.1.1.1 Scaling list syntax\n * @param scalingList\n * @param size\n */\nfunction scaling_list(scalingList, size) {\n    let lastScale = 8;\n    let nextScale = 8;\n    let delta_scale;\n    for (var j = 0; j < size; j++) {\n        if (nextScale != 0) {\n            delta_scale = ExpGolomb.readUEV(scalingList, bitOffset);\n            bitOffset += delta_scale.bitLength;\n            nextScale = (lastScale + delta_scale.value + 256) % 256;\n        }\n        lastScale = scalingList[j];\n    }\n}\n/**\n * decode (SPS)Sequence parameter set\n * @param payload\n */\nfunction decodeSPS(payload) {\n    bitOffset = 0;\n    let profile_idc = payload[0];\n    let profile_compatibility = payload[1];\n    let level_idc = payload[2];\n    let golombBuffer = payload.subarray(3);\n    let //separate_colour_plane_flag = 0,\n    // qpprime_y_zero_transform_bypass_flag = 0,\n    seq_scaling_matrix_present_flag = 0;\n    let lmpoclmUEV;\n    let //delta_pic_order_always_zero_flag = 0,\n    ofnrpSEV, ofttbfSEV, nrfipoccUEV;\n    let pixelRatio = [1, 1], pixelScale = 1;\n    let video_format;\n    let fps = 0, num_units_in_tick, time_scale, fixed_frame_rate_flag = true;\n    // seq_parameter_set_id\n    let spsUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += spsUEV.bitLength;\n    if (profile_idc == 100 ||\n        profile_idc == 110 ||\n        profile_idc == 122 ||\n        profile_idc == 244 ||\n        profile_idc == 44 ||\n        profile_idc == 83 ||\n        profile_idc == 86 ||\n        profile_idc == 118 ||\n        profile_idc == 128) {\n        // chroma_format_idc\n        let chromaFIUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += chromaFIUEV.bitLength;\n        if (chromaFIUEV.value == 3) {\n            // separate_colour_plane_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n            bitOffset += 1;\n        }\n        // bit_depth_luma_minus8\n        let bitdlmUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += bitdlmUEV.bitLength;\n        // bit_depth_chroma_minus8\n        let bitdcmUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += bitdcmUEV.bitLength;\n        // qpprime_y_zero_transform_bypass_flag\n        // qpprime_y_zero_transform_bypass_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        // seq_scaling_matrix_present_flag\n        seq_scaling_matrix_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        if (seq_scaling_matrix_present_flag) {\n            for (let i = 0; i < (chromaFIUEV.value != 3 ? 8 : 12); i++) {\n                let seq_scaling_list_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n                bitOffset += 1;\n                if (seq_scaling_list_present_flag) {\n                    if (i < 6) {\n                        scaling_list(golombBuffer, 16);\n                    }\n                    else {\n                        scaling_list(golombBuffer, 64);\n                    }\n                }\n            }\n        }\n    }\n    // log2_max_frame_num_minus4\n    let lmfnmUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += lmfnmUEV.bitLength;\n    // pic_order_cnt_type\n    let poctUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    let pic_order_cnt_type = poctUEV.value;\n    bitOffset += poctUEV.bitLength;\n    if (pic_order_cnt_type === 0) {\n        // log2_max_pic_order_cnt_lsb_minus4\n        lmpoclmUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += lmpoclmUEV.bitLength;\n    }\n    else if (pic_order_cnt_type === 1) {\n        // delta_pic_order_always_zero_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        // offset_for_non_ref_pic\n        ofnrpSEV = ExpGolomb.readSEV(golombBuffer, bitOffset);\n        bitOffset += ofnrpSEV.bitLength;\n        // offset_for_top_to_bottom_field\n        ofttbfSEV = ExpGolomb.readSEV(golombBuffer, bitOffset);\n        bitOffset += ofttbfSEV.bitLength;\n        // num_ref_frames_in_pic_order_cnt_cycle\n        nrfipoccUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += nrfipoccUEV.bitLength;\n        // let offset_for_ref_frames = [];\n        for (let i = 0, item; i < nrfipoccUEV.value; i++) {\n            item = ExpGolomb.readSEV(golombBuffer, bitOffset);\n            bitOffset += item.bitLength;\n            // offset_for_ref_frames.push(item);\n        }\n    }\n    // max_num_ref_frames\n    // 指定参考帧队列可能达到的最大长度，解码器依照这个句法元素的值开辟存储区，这个存储区用于存放已解码的参考帧，\n    // H.264 规定最多可用 16 个参考帧，本句法元素的值最大为 16。值得注意的是这个长度以帧为单位，如果在场模式下，应该相应地扩展一倍\n    let mnrfUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += mnrfUEV.bitLength;\n    // gaps_in_frame_num_value_allowed_flag\n    // let gaps_in_frame_num_value_allowed_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // pic_width_in_mbs_minus1\n    let picWidthUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += picWidthUEV.bitLength;\n    // pic_height_in_map_units_minus1\n    let picHeightUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += picHeightUEV.bitLength;\n    // frame_mbs_only_flag\n    // 本句法元素等于 1 时, 表示本序列中所有图像的编码模式都是帧编码；\n    // 本句法元素等于 0 时, 表示本序列中图像的编码模式可能是帧，也可能是场或帧场自适应，某个图像具体是哪一种要由其他句法元素决定。\n    let frame_mbs_only_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    if (!frame_mbs_only_flag) {\n        // mb_adaptive_frame_field_flag (Unused, Unnecessary to read it.)\n        // ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n    }\n    // direct_8x8_inference_flag,  用于指明 B 片的直接 和 skip 模式下运动矢量的预测方法\n    // let direct_8x8_inference_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // frame_cropping_flag, 用于指明解码器是否要将图像裁剪后输出，如果是的话，后面紧跟着的四个句法元素分别指出左右、上下裁剪的宽度\n    let frame_cropping_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    let cropLeft = 0, cropRight = 0, cropTop = 0, cropBottom = 0;\n    if (frame_cropping_flag) {\n        let fcloUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += fcloUEV.bitLength;\n        cropLeft = fcloUEV.value;\n        let fcroUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += fcroUEV.bitLength;\n        cropRight = fcroUEV.value;\n        let fctoUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += fctoUEV.bitLength;\n        cropTop = fctoUEV.value;\n        let fcboUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += fcboUEV.bitLength;\n        cropBottom = fcboUEV.value;\n    }\n    // vui_parameters_present_flag\n    let vui_parameters_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    if (vui_parameters_present_flag) {\n        // Annex E, E.1.1 VUI parameters syntax\n        // VUI 用以表征视频格式等额外信息\n        // aspect_ratio, video_format\n        let aspect_ratio_info_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        if (aspect_ratio_info_present_flag) {\n            const aspectRatioIdc = ExpGolomb.readByte(golombBuffer, bitOffset);\n            bitOffset += 8;\n            switch (aspectRatioIdc) {\n                case 1:\n                    pixelRatio = [1, 1];\n                    break;\n                case 2:\n                    pixelRatio = [12, 11];\n                    break;\n                case 3:\n                    pixelRatio = [10, 11];\n                    break;\n                case 4:\n                    pixelRatio = [16, 11];\n                    break;\n                case 5:\n                    pixelRatio = [40, 33];\n                    break;\n                case 6:\n                    pixelRatio = [24, 11];\n                    break;\n                case 7:\n                    pixelRatio = [20, 11];\n                    break;\n                case 8:\n                    pixelRatio = [32, 11];\n                    break;\n                case 9:\n                    pixelRatio = [80, 33];\n                    break;\n                case 10:\n                    pixelRatio = [18, 11];\n                    break;\n                case 11:\n                    pixelRatio = [15, 11];\n                    break;\n                case 12:\n                    pixelRatio = [64, 33];\n                    break;\n                case 13:\n                    pixelRatio = [160, 99];\n                    break;\n                case 14:\n                    pixelRatio = [4, 3];\n                    break;\n                case 15:\n                    pixelRatio = [3, 2];\n                    break;\n                case 16:\n                    pixelRatio = [2, 1];\n                    break;\n                case 255: {\n                    let width0 = ExpGolomb.readByte(golombBuffer, bitOffset);\n                    bitOffset += 8;\n                    let width1 = ExpGolomb.readByte(golombBuffer, bitOffset);\n                    bitOffset += 8;\n                    let height0 = ExpGolomb.readByte(golombBuffer, bitOffset);\n                    bitOffset += 8;\n                    let height1 = ExpGolomb.readByte(golombBuffer, bitOffset);\n                    bitOffset += 8;\n                    pixelRatio = [(width0 << 8) | width1, (height0 << 8) | height1];\n                    break;\n                }\n            }\n            if (pixelRatio) {\n                pixelScale = pixelRatio[0] / pixelRatio[1];\n            }\n            if (aspectRatioIdc === 255) {\n                // sar_width\n                bitOffset += 16;\n                // sar_height\n                bitOffset += 16;\n            }\n        }\n        let overscan_info_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        if (overscan_info_present_flag) {\n            bitOffset += 1;\n            // overscan_appropriate_flag;\n        }\n        let video_signal_type_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        if (video_signal_type_present_flag) {\n            /*\n                Table E-2 – Meaning of video_format\n                video_format    Meaning\n                0               Component\n                1               PAL\n                2               NTSC\n                3               SECAM\n                4               MAC\n                5               Unspecified video format\n                6               Reserved\n                7               Reserved\n             */\n            video_format = ExpGolomb.readBit(golombBuffer, bitOffset, 3);\n            bitOffset += 3;\n            // switch (video_format) {\n            // }\n            // let video_full_range_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n            bitOffset += 1;\n            let colour_description_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n            bitOffset += 1;\n            if (colour_description_present_flag) {\n                // colour_primaries            u(8)\n                // transfer_characteristics    u(8)\n                // matrix_coefficients         u(8)\n                bitOffset += 24;\n            }\n        }\n        let chroma_loc_info_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        if (chroma_loc_info_present_flag) {\n            let chroma_sample_loc_type_top_field = ExpGolomb.readUEV(golombBuffer, bitOffset);\n            bitOffset += chroma_sample_loc_type_top_field.bitLength;\n            let chroma_sample_loc_type_bottom_field = ExpGolomb.readUEV(golombBuffer, bitOffset);\n            bitOffset += chroma_sample_loc_type_bottom_field.bitLength;\n        }\n        let timing_info_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n        bitOffset += 1;\n        if (timing_info_present_flag) {\n            num_units_in_tick = ExpGolomb.readBit(golombBuffer, bitOffset, 32);\n            bitOffset += 32;\n            time_scale = ExpGolomb.readBit(golombBuffer, bitOffset, 32);\n            bitOffset += 32;\n            fixed_frame_rate_flag = !!ExpGolomb.readBit(golombBuffer, bitOffset);\n            bitOffset += 1;\n            fps = time_scale / (num_units_in_tick * 2);\n        }\n        // There is left VUI other's parameters to be decoded ...\n        // For now, it is useless, so don't pass them.\n    }\n    // let FrameHeightInMbs = (2 - frame_mbs_only_flag) * (picHeightUEV.value + 1);\n    // PicSizeInMapUnits = PicWidthInMbs * PicHeightInMapUnits\n    return {\n        payload: golombBuffer,\n        profile_idc,\n        profile_compatibility,\n        level_idc,\n        sps_id: spsUEV.value,\n        log2_max_frame_num_minus4: poctUEV.value,\n        pic_order_cnt_type,\n        log2_max_pic_order_cnt_lsb_minus4: lmpoclmUEV ? lmpoclmUEV.value : 0,\n        width: Math.ceil(((picWidthUEV.value + 1) * 16 - cropLeft * 2 - cropRight * 2) * pixelScale),\n        height: (2 - frame_mbs_only_flag) * (picHeightUEV.value + 1) * 16 - cropTop * 2 - cropBottom * 2,\n        pixelRatio,\n        video_format,\n        fps,\n        fixedFPS: fixed_frame_rate_flag\n    };\n}\n\n/**\n * @file: pps.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * decode (PPS)Picture parameter set\n * @param payload\n */\nfunction decodePPS(payload) {\n    let bitOffset = 0;\n    let golombBuffer = payload;\n    let //slice_group_change_direction_flag = 0,\n    sliceGroupIds = [];\n    let sgcdfUEV, picSizeUEV;\n    let i = 0;\n    // pic_parameter_set_id\n    let ppsUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += ppsUEV.bitLength;\n    // seq_parameter_set_id\n    let spsUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += spsUEV.bitLength;\n    // entropy_coding_mode_flag\n    // 0: Exp-Golomb coded, see subclause 9.1 or CAVLC, see subclause 9.2\n    // 1: CABAC, see subclause 9.3\n    // let entropy_coding_mode_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // bottom_field_pic_order_in_frame_present_flag\n    // let bottom_field_pic_order_in_frame_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // num_slice_groups_minus1,\n    let sliceGroupUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += sliceGroupUEV.bitLength;\n    if (sliceGroupUEV.value > 0) {\n        // slice_group_map_type\n        let sgmtUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n        bitOffset += sgmtUEV.bitLength;\n        let iGroup = 0, itemUev;\n        switch (sgmtUEV.value) {\n            case 0:\n                for (iGroup = 0; iGroup <= sgmtUEV.value; iGroup++) {\n                    // run_length_minus1\n                    itemUev = ExpGolomb.readUEV(golombBuffer, bitOffset);\n                    bitOffset += itemUev.bitLength;\n                }\n                break;\n            case 2:\n                for (iGroup = 0; iGroup <= sgmtUEV.value; iGroup++) {\n                    // top_left\n                    itemUev = ExpGolomb.readUEV(golombBuffer, bitOffset);\n                    bitOffset += itemUev.bitLength;\n                    // bottom_right\n                    itemUev = ExpGolomb.readUEV(golombBuffer, bitOffset);\n                    bitOffset += itemUev.bitLength;\n                }\n                break;\n            case 3:\n            case 4:\n            case 5:\n                // slice_group_change_direction_flag\n                // slice_group_change_direction_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n                bitOffset += 1;\n                // slice_group_change_rate_minus1\n                sgcdfUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n                bitOffset += sgcdfUEV.bitLength;\n                break;\n            case 6:\n                {\n                    // pic_size_in_map_units_minus1\n                    picSizeUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n                    bitOffset += picSizeUEV.bitLength;\n                    let length = Math.ceil(Math.log2(sliceGroupUEV.value + 1));\n                    for (i = 0; i <= picSizeUEV.value; i++) {\n                        // pic_size_in_map_units_minus1\n                        sliceGroupIds.push(ExpGolomb.readBit(golombBuffer, bitOffset, length));\n                        bitOffset += length;\n                    }\n                }\n                break;\n        }\n    }\n    // num_ref_idx_l0_default_active_minus1\n    let nril0dcmUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += nril0dcmUEV.bitLength;\n    // num_ref_idx_l1_default_active_minus1\n    let nril1dcmUEV = ExpGolomb.readUEV(golombBuffer, bitOffset);\n    bitOffset += nril1dcmUEV.bitLength;\n    // weighted_pred_flag\n    // let weighted_pred_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // weighted_bipred_idc\n    // let weighted_bipred_idc = ExpGolomb.readBit(golombBuffer, bitOffset, 2);\n    bitOffset += 1;\n    // pic_init_qp_minus26\n    let piqpSEV = ExpGolomb.readSEV(golombBuffer, bitOffset);\n    bitOffset += piqpSEV.bitLength;\n    // pic_init_qs_minus26\n    let piqsSEV = ExpGolomb.readSEV(golombBuffer, bitOffset);\n    bitOffset += piqsSEV.bitLength;\n    // chroma_qp_index_offset\n    let cqioSEV = ExpGolomb.readSEV(golombBuffer, bitOffset);\n    bitOffset += cqioSEV.bitLength;\n    // let deblocking_filter_control_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // let constrained_intra_pred_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // let redundant_pic_cnt_present_flag = ExpGolomb.readBit(golombBuffer, bitOffset);\n    bitOffset += 1;\n    // if( more_rbsp_data( ) ) {\n    //     // Unused data...\n    // }\n    return {\n        sliceGroupNum: sliceGroupUEV.value + 1\n    };\n}\n\n/**\n * @file: pps.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * decode (SEI)Supplemental enhancement information\n * @param payload\n */\nfunction decodeSEI(payload) {\n    return {};\n}\n\n/**\n * @file: nalu.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * decode (AUD)Access unit delimiter\n * @param payload\n * @private\n */\nfunction _decodeAUD(payload) {\n    // var primary_pic_type_table = {\n    //     0x084, // 2, 7\n    //     0x0a5, // 0, 2, 5, 7\n    //     0x0e7, // 0, 1, 2, 5, 6, 7\n    //     0x210, // 4, 9\n    //     0x318, // 3, 4, 8, 9\n    //     0x294, // 2, 4, 7, 9\n    //     0x3bd, // 0, 2, 3, 4, 5, 7, 8, 9\n    //     0x3ff, // 0, 1, 2, 3, 4, 5, 6, 7, 8, 9\n    // }\n    return payload[0] >> 5;\n}\nclass NALU extends DataViewReader {\n    constructor(buffer) {\n        super();\n        this.forbidden_zero_bit = buffer[0] >> 7;\n        // nalu priority.\n        this.ref_idc = (buffer[0] >> 5) & 0x03;\n        // specifies the type of RBSP data structure. see in mux-nalu-types.js\n        this.unit_type = buffer[0] & 0x1f;\n        this.data = discardEP3B(buffer.subarray(1));\n        this.rawData = buffer;\n        switch (this.unit_type) {\n            case 1 /* NON_IDR_SLICE */:\n                break;\n            case 2 /* DPA_SLICE */:\n            case 3 /* DPB_SLICE */:\n            case 4 /* DPC_SLICE */:\n                // TODO decode A/B/C Partition Slice.\n                break;\n            case 5 /* IDR_SLICE */:\n                // this.data = decodeSlice(this.data).data;\n                break;\n            case 7 /* SPS */:\n                this.sps = decodeSPS(this.data);\n                break;\n            case 8 /* PPS */:\n                this.pps = decodePPS(this.data);\n                break;\n            case 6 /* SEI */:\n                this.sei = decodeSEI(this.data);\n                break;\n            case 9 /* AUD */:\n                this.primary_pic_type = _decodeAUD(this.data);\n                break;\n        }\n    }\n}\n\n/**\n * @file: avc.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass AVCCodec extends EventEmitter {\n    constructor() {\n        super(...arguments);\n        this.lastState = null;\n        this.lastNALu = null;\n        this.lastNALuState = null;\n    }\n    spitNalu_(bytes, pts, dts) {\n        let nalu = new NALU(bytes);\n        nalu.pts = pts;\n        nalu.dts = dts;\n        this.lastNALu = nalu;\n        this.emit('nalu', nalu);\n    }\n    push(data) {\n        const { lastState, lastNALuState } = this;\n        let i = 0, lastNALuOffset = -1, { pts, dts, payload, naluSizeLength } = data;\n        if (!naluSizeLength) {\n            // Start parse Annex-B Byte stream format\n            let j = payload.byteLength - 1;\n            let dropZerosLength = 0;\n            // Collect tailing zeros.\n            // end with 0x000000 and more...\n            do {\n                if (payload[j] === 0x00) {\n                    dropZerosLength++;\n                }\n                else {\n                    break;\n                }\n                j--;\n            } while (j > 0);\n            if (dropZerosLength >= 3) {\n                // drop tailing zeros.\n                payload = payload.subarray(0, j + 1);\n            }\n            const len = payload.length;\n            let state = 0;\n            do {\n                let value = payload[i++];\n                // loop optimization.\n                if (state === 0) {\n                    state = value ? 0 : 1;\n                    continue;\n                }\n                else if (state === 1) {\n                    state = value ? 0 : 2;\n                    continue;\n                }\n                // value will be 2 or 3\n                if (!value) {\n                    state = 3;\n                }\n                else if (value === 1) {\n                    if (lastNALuOffset >= 0) {\n                        this.lastNALuState = state;\n                        this.spitNalu_(payload.subarray(lastNALuOffset, i - 1 - state), pts, dts);\n                    }\n                    else {\n                        // naluOffset is undefined => this is the first start code found in this PES packet\n                        // first check if start code delimiter is overlapping between 2 PES packets,\n                        // ie it started in last packet (lastState not zero)\n                        // and ended at the beginning of this PES packet (i <= 4 - lastState)\n                        const lastUnit = this.lastNALu;\n                        if (lastUnit) {\n                            if (lastState && i <= 4 - lastState) {\n                                // start delimiter overlapping between PES packets\n                                // strip start delimiter bytes from the end of last NAL unit\n                                // check if lastUnit had a state different from zero\n                                if (lastNALuState) {\n                                    // strip last bytes\n                                    lastUnit.rawData = lastUnit.rawData.subarray(0, lastUnit.rawData.byteLength - lastState);\n                                }\n                            }\n                            // If NAL units are not starting right at the\n                            // beginning of the PES packet, push preceding data\n                            // into previous NAL unit.\n                            let overflow = i - state - 1;\n                            if (overflow > 0) {\n                                logger.log(`overflow NALU found: ${overflow}/${pts}/${dts}`);\n                                let cb = new CacheBuffer();\n                                cb.append(lastUnit.rawData);\n                                cb.append(payload.subarray(0, overflow));\n                                let bytes = cb.toNewBytes();\n                                cb.clear(); // gc\n                                lastUnit.rawData = bytes;\n                            }\n                        }\n                    }\n                    // reset state & record last unit start byte offset.\n                    if (i < len) {\n                        // console.log(`'find NALU @ offset: ${i}`);\n                        lastNALuOffset = i;\n                        state = 0;\n                    }\n                }\n                else {\n                    state = 0;\n                }\n            } while (i < len);\n            if (lastNALuOffset >= 0 && state >= 0) {\n                this.lastNALuState = state;\n                this.spitNalu_(payload.subarray(lastNALuOffset, len), pts, dts);\n            }\n            this.lastState = state;\n        }\n        else {\n            let startPos = 0, size = 0, endPos = 0, byteLength = payload.length;\n            do {\n                size = 0;\n                for (let k = 0; k < naluSizeLength; k++) {\n                    size = size | (payload[startPos + k] << ((naluSizeLength - k - 1) * 8));\n                }\n                // size = (data_byte[i] << 24) | (data_byte[i + 1] << 16) | (data_byte[i + 2] << 8) | data_byte[i + 3];\n                startPos += naluSizeLength;\n                endPos = startPos + size;\n                if (endPos > byteLength) {\n                    endPos = byteLength;\n                }\n                this.spitNalu_(payload.subarray(startPos, endPos), pts, dts);\n                startPos = endPos;\n            } while (startPos < byteLength);\n        }\n        this.emit('done');\n    }\n    reset() {\n        this.lastState = null;\n        this.lastNALu = null;\n        this.lastNALuState = null;\n    }\n}\n\n/**\n * @file: avc-config.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n// import { PPSProps } from './pps';\n/**\n * AVC Config Helper\n * Accord sps/pps, generate mimeType info.\n */\nvar getAVCConfig = (sps /*, pps?: PPSProps*/) => {\n    let profile_idc = sps.profile_idc;\n    let profile_compatibility = sps.profile_compatibility;\n    let level_idc = sps.level_idc;\n    let codecString = 'avc1.';\n    let arr = [profile_idc, profile_compatibility, level_idc];\n    for (let j = 0; j < arr.length; j++) {\n        let h = arr[j].toString(16);\n        if (h.length < 2) {\n            h = '0' + h;\n        }\n        codecString += h;\n    }\n    return {\n        codec: codecString\n    };\n};\n\n/**\n * @file: avc.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass H264Stream extends Stream {\n    constructor(psi) {\n        super();\n        this.PSI = psi;\n        this.trackId = null;\n        /** @private {Array} */\n        this.currentFrame = []; // a group of nalu\n        /** @private {AVCCodec} */\n        this.codec = new AVCCodec();\n        this._newGop();\n        this._newGops();\n        this.codec.on('nalu', (nalu) => {\n            if (nalu.unit_type === 7 /* SPS */) {\n                let track = this.PSI.findTrack(this.trackId);\n                let config = getAVCConfig(nalu.sps);\n                // write sps info to video track.\n                track.codec = config.codec;\n                track.width = nalu.sps.width;\n                track.height = nalu.sps.height;\n                track.profileIdc = nalu.sps.profile_idc;\n                track.profileCompatibility = nalu.sps.profile_compatibility;\n                track.levelIdc = nalu.sps.level_idc;\n                track.pixelRatio = nalu.sps.pixelRatio;\n                track.sps = [nalu.rawData];\n            }\n            else if (nalu.unit_type === 8 /* PPS */) {\n                let track = this.PSI.findTrack(this.trackId);\n                track.pps = [nalu.rawData];\n            }\n            this._grouping(nalu);\n        });\n    }\n    /**\n     * Push a complete pes\n     * @param data\n     */\n    push(data) {\n        const { stream_type, pes, pid } = data;\n        if (stream_type === 27 /* H264 */ || stream_type === 36 /* HEVC */) {\n            this.trackId = pid;\n            let rawData = {\n                pts: pes.PTS,\n                dts: pes.DTS,\n                payload: pes.data_byte\n            };\n            this.codec.push(rawData);\n        }\n    }\n    flush() {\n        // Push last frame into gop.\n        if (this.currentFrame.length > 0) {\n            // If the last frame has valid duration, use the duration of the previous frame\n            if (!this.currentFrame.duration || this.currentFrame.duration <= 0) {\n                this.currentFrame.duration = this.prevFrame.duration || 0;\n            }\n            this._pushFrameIntoGop();\n            this.currentFrame = [];\n        }\n        // Push last gop.\n        if (this.gop.length > 0) {\n            this._pushGopIntoGroup();\n        }\n    }\n    reset() {\n        this.codec.reset();\n        this.currentFrame = [];\n        this._newGop();\n        this._newGops();\n    }\n    /**\n     * Group nalu into frame & gop.\n     * @param currentNal\n     * @private\n     */\n    _grouping(currentNal) {\n        if (currentNal.unit_type === 9 /* AUD */) {\n            if (this.currentFrame.length > 0) {\n                this.currentFrame.duration = currentNal.dts - this.currentFrame.dts;\n                if (this.gop.length > 0 && this.currentFrame.keyframe) {\n                    this.gop.trackId = this.trackId;\n                    this._pushGopIntoGroup();\n                }\n                // the gop should commence with a key frame,\n                // or the frame will be dropped until finding one that contains a key frame.\n                if (this.currentFrame.keyframe || this.gop.length > 0) {\n                    this._pushFrameIntoGop();\n                }\n                else {\n                    logger.warn(`h264 codec drop frame`);\n                }\n            }\n            this.prevFrame = this.currentFrame;\n            // end a frame.\n            this.currentFrame = [];\n            this.currentFrame.keyframe = false;\n            this.currentFrame.byteLength = 0;\n            this.currentFrame.naluCount = 0;\n            this.currentFrame.pts = currentNal.pts;\n            this.currentFrame.dts = currentNal.dts;\n        }\n        else {\n            if (currentNal.unit_type === 5 /* IDR_SLICE */) {\n                this.currentFrame.keyframe = true;\n            }\n            this.currentFrame.byteLength += currentNal.rawData.byteLength;\n            this.currentFrame.naluCount++;\n            this.currentFrame.push(currentNal);\n        }\n        this.currentFrame.duration = currentNal.dts - this.currentFrame.dts;\n    }\n    _newGop() {\n        this.gop = []; // a group of idr-start-frame sequence\n        this.gop.duration = 0;\n        this.gop.naluCount = 0;\n        this.gop.byteLength = 0;\n    }\n    _pushFrameIntoGop() {\n        // Gop\n        this.gop.push(this.currentFrame);\n        this.gop.duration += this.currentFrame.duration;\n        this.gop.byteLength += this.currentFrame.byteLength;\n        this.gop.naluCount += this.currentFrame.naluCount;\n    }\n    _newGops() {\n        this.gops = []; // a group of gop\n        this.gops.type = 'video';\n        this.gops.duration = 0;\n        this.gops.naluCount = 0;\n        this.gops.byteLength = 0;\n        this.gops.frameLength = 0;\n        this.gops.firstDTS = 0;\n    }\n    _pushGopIntoGroup() {\n        let firstFrame = this.gop[0];\n        // GOPs\n        this.gops.trackId = this.trackId;\n        this.gops.duration += this.gop.duration;\n        this.gops.byteLength += this.gop.byteLength;\n        this.gops.naluCount += this.gop.naluCount;\n        this.gops.frameLength += this.gop.length;\n        this.gops.firstDTS = firstFrame.dts;\n        this.gops.firstPTS = firstFrame.pts;\n        this.gops.push(this.gop);\n        this.emit('data', this.gops);\n        this._newGop();\n        this._newGops();\n        this.emit('done');\n    }\n}\n\n/**\n * @file: elementary.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass ElementaryStream extends Stream {\n    constructor(ctx, psi, options = {}) {\n        super();\n        this.context = ctx;\n        this.PSI = psi;\n        this.options = options;\n        this.tracks = [];\n        this.adtsStream = new ADTSStream(psi);\n        this.avcStream = new H264Stream(psi);\n        this.streams = [this.adtsStream, this.avcStream];\n        if (options.decodeCodec) {\n            this.avcStream.on('data', (data) => {\n                let stubTime = options.config.stubTime;\n                if (isNumber(stubTime)) {\n                    let end = (data.firstPTS + data.duration) / 90000;\n                    if (end < stubTime) {\n                        logger.warn(`drop avc gop, start/end/stubTime(${data.firstPTS}/${end}/${stubTime})`);\n                        return;\n                    }\n                }\n                this.tracks.push(data);\n                this.emit('data', this.tracks);\n                this.tracks = [];\n                this.adtsStream.flush();\n            });\n            this.adtsStream.on('data', (data) => {\n                let stubTime = options.config.stubTime;\n                if (isNumber(stubTime)) {\n                    let end = (data.firstPTS + data.duration) / 90000;\n                    if (end < stubTime) {\n                        logger.warn(`drop adts, start/end/stubTime(${data.firstPTS}/${end}/${stubTime})`);\n                        return;\n                    }\n                }\n                this.tracks.push(data);\n                this.emit('data', this.tracks);\n                this.tracks = [];\n            });\n        }\n    }\n    /**\n     * Push a complete pes\n     * @param data\n     */\n    push(data) {\n        const { options, adtsStream, avcStream } = this;\n        let { stream_type } = data;\n        if (options.decodeCodec) {\n            switch (stream_type) {\n                case 27 /* H264 */:\n                case 36 /* HEVC */:\n                    avcStream.push(data);\n                    break;\n                case 15 /* ADTS */:\n                    adtsStream.push(data);\n                    break;\n                default:\n                    logger.warn(`ts elementary encounter unknown stream type ${stream_type}`);\n            }\n        }\n        else {\n            this.emit('data', data);\n        }\n    }\n    flush() {\n        let { streams, tracks } = this;\n        for (let i = 0; i < this.streams.length; i++) {\n            let stream = streams[i];\n            stream.flush();\n        }\n        if (tracks.length > 0) {\n            this.emit('data', tracks);\n        }\n        this.emit('done');\n        tracks.splice(0, tracks.length);\n    }\n    reset() {\n        this.tracks = [];\n        for (let i = 0; i < this.streams.length; i++) {\n            let stream = this.streams[i];\n            stream.reset();\n        }\n        this.emit('reset');\n    }\n}\n\n/**\n * @file: pes.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * Structure for Pes.\n */\nclass Pes {\n    constructor(buffer) {\n        // The packet_start_code_prefix is a 24-bit code.\n        // this.start_code_prefix = (buffer[0] << 16) | (buffer[1] << 8) | buffer[2];\n        // In Transport Streams,\n        // the stream_id may be set to any valid value which correctly describes the elementary stream type.\n        // the elementary stream type is specified in the PSI(Program Specific Information).\n        // this.stream_id = buffer[3];\n        // A 16-bit field specifying the number of bytes in the PES packet.\n        // this.packet_length = (buffer[4] << 8) | buffer[5];\n        // this.data_alignment_indicator = buffer[6] & 0x04;\n        // this.copyright = buffer[6] & 0x02;\n        // PTS (presentation time stamp)\n        // DTS (decoding time stamp)\n        let PTS_DTS_flags = buffer[7] >> 6;\n        // ESCR (Elementary Stream Clock Reference system):\n        // A time stamp in the PES Stream from which decoders of PES streams may derive timing.\n        // this.ESCR_flag = buffer[7] & 0x20;\n        // this.ES_rate_flag = buffer[7] & 0x10;\n        // this.trick_mode_flag = buffer[7] & 0x08;\n        // this.additional_copy_info_flag = buffer[7] & 0x04;\n        // this.CRC_flag = buffer[7] & 0x02;\n        // this.extension_flag = buffer[7] & 0x01;\n        let header_data_length = buffer[8];\n        this.PTS = 0;\n        if ((PTS_DTS_flags & 0x02) == 0x02) {\n            this.PTS = this.calcTimestamp_(buffer, 9);\n        }\n        // if there is no dts, let DTS=PTS\n        // See Annex D - D.0.2 Audio and Video Presentation Synchronization\n        this.DTS = this.PTS;\n        if ((PTS_DTS_flags & 0x01) == 0x01) {\n            this.DTS = this.calcTimestamp_(buffer, 14);\n        }\n        // if (this.ESCR_flag === 1) {\n        // }\n        //\n        // if (this.ES_rate_flag === 1) {\n        // }\n        //\n        //\n        // if (this.trick_mode_flag === 1) {\n        //\n        // }\n        //\n        // if (this.ESCR_flag === 1) {\n        // }\n        this.data_byte = buffer.subarray(9 + header_data_length);\n        // this.isStartPes = (buffer[0] << 16 | buffer[1] << 8 | buffer[2]) & 0xffffff === 0x000001;\n    }\n    /**\n     * @param buffer\n     * @param start\n     */\n    calcTimestamp_(buffer, start) {\n        // PTS / DTS is 33 bit\n        return (\n        // JS Bitwise operators treat their operands as a sequence of 32 bits,\n        // We cannot use bitwise operator in JS beyond 32bits\n        (buffer[start] & 0x0e) * 536870912 + // Math.pow(2, 29) === 536870912\n            (buffer[start + 1] << 22) +\n            ((buffer[start + 2] >> 1) << 15) +\n            (buffer[start + 3] << 7) +\n            (buffer[start + 4] >> 1));\n    }\n}\n\n/**\n * @file: pes.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass PesStream extends Stream {\n    constructor(ctx, psi) {\n        super();\n        this.context = ctx;\n        this.PSI = psi;\n        this.PID = null;\n        this.cache_buffer = new CacheBuffer();\n    }\n    /**\n     * @param packet\n     */\n    push(packet) {\n        const self = this;\n        // PES PID\n        // 0x20 - 0xff is reserved for dvb etc. (https://en.wikipedia.org/wiki/Program-specific_information#PSI_labels)\n        // but this is not strict restriction.\n        if (packet.PID > 0x001f && packet.PID < 0x1fff) {\n            if (this.PSI.currentProgramPID == -1) {\n                self._pushPacket(packet);\n            }\n            else if (this.PSI.currentProgramPID !== packet.PID) {\n                if (packet.payload_unit_start_indicator === 1) {\n                    self._assembleOnePES();\n                }\n                self._pushPacket(packet);\n            }\n        }\n    }\n    flush() {\n        const self = this;\n        // 组装最后一个PES\n        self._assembleOnePES();\n        self.emit('done');\n    }\n    reset() {\n        this._clearCached();\n        this.emit('reset');\n    }\n    _clearCached() {\n        this.PID = null;\n        this.cache_buffer.clear();\n    }\n    _pushPacket(p) {\n        let empty = this.cache_buffer.empty;\n        // Make first packet in cache is start unit.\n        if (empty && p.payload_unit_start_indicator === 0) {\n            return;\n        }\n        if (empty) {\n            this.PID = p.PID;\n        }\n        this.cache_buffer.append(p.payload);\n    }\n    _assembleOnePES() {\n        const self = this;\n        if (!this.cache_buffer.empty) {\n            let bytes;\n            try {\n                bytes = this.cache_buffer.toNewBytes();\n            }\n            catch (e) {\n                throw `pes alloc mem err ${this.cache_buffer.byteLength}`;\n            }\n            let pesData = new Pes(bytes);\n            let track = this.PSI.findTrack(this.PID);\n            // console.log(`stream_id: ${pesData.stream_id}, PTS: ${pesData.PTS}, DTS: ${pesData.DTS}`);\n            if (track) {\n                let data = {\n                    pid: track.id,\n                    stream_type: track.stream_type,\n                    // pcr_pid: track.pcr_pid,\n                    pes: pesData\n                };\n                // Assemble one pes packet, emit it to next stream.\n                self.emit('data', data);\n            }\n            self._clearCached();\n        }\n    }\n}\n\n/**\n * @file: packet.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nconst SYNC_BYTE = 0x47; // The sync_byte is a fixed 8-bit field whose value is '0100 0111' (0x47).\n/**\n * packet structure.\n */\nclass Packet {\n    /**\n     * @param buffer\n     */\n    constructor(buffer) {\n        this.sync_byte = buffer[0];\n        // this.transport_error_indicator = buffer[1] >> 7;\n        // Indicating transport stream packets carry PES packets or PSI data\n        // PES: 1 -> commence with the first byte of a PES packet,  0 -> no PES packet shall start in this packet.\n        // PSI: 1 -> carries the first byte of a PSI section, 0 -> no pointer_field in the payload.\n        this.payload_unit_start_indicator = (buffer[1] >> 6) & 1;\n        // this.transport_priority = (buffer[1] >>> 5) & 1;\n        // The PID(Packet ID) is a 13-bit field, indicating the type of the data stored in the packet payload.\n        // NOTE – The transport packets with PID values 0x0000, 0x0001, and 0x0010-0x1FFE are allowed to carry a PCR.\n        // ISO/IEC 13818-1 : 2000 (E)\n        // Value                  Description\n        // 0x0000                 Program Association Table\n        // 0x0001                 Conditional Access Table\n        // 0x0002                 Transport Stream Description Table\n        // 0x0003-0x000F          Reserved\n        // 0x0010 ... 0x1FFE      May be assigned as network_PID, Program_map_PID, elementary_PID, or for other purposes\n        // https://www.dvb.org/resources/public/standards/a38_dvb-si_specification.pdf\n        // 0x0040                 Network_information_section-actual_network\n        // 0x0041                 Network_information_section-other_network\n        // 0x0042                 Service_description_section-actual_transport_stream\n        // 0x0043                 TO 0x45 Reserved for future use\n        // 0x0046                 Service_description_section-other_transport_stream\n        // 0x0047                 TO 0x49 Reserved for future use\n        // 0x004A                 Bouquet_association_section\n        // 0x004B                 TO 0x4D Reserved for future use\n        // 0x004E                 Event_information_section-actual_transport_stream,P/F\n        // 0x004F                 Event_information_section-other_transport_stream,P/F\n        // 0x0050                 TO 0x5F Event_information_section-actual_transport_stream,schedule\n        // 0x0060                 TO 0x6F Event_information_section-other_transport_stream,schedule\n        // 0x0070                 Time_data_section\n        // 0x0071                 Running_status_section\n        // 0x0072                 Stuffing_section\n        // 0x0073                 Time_offset_section\n        // 0x0074                 TO 0x007D Reserved for future use\n        // 0x007E                 Discontinuity_information_section\n        // 0x007F                 Selection_information_section\n        // 0x0080                 TO 0x00FE User defined\n        // 0x00FF                 Reserved\n        // 0x1FFF                 Null packet\n        this.PID = ((buffer[1] << 8) | buffer[2]) & 0x1fff;\n        // transport_scrambling_control\n        // this.tsc = buffer[3] >> 6;\n        // adaptation_field_control\n        // Value  Description\n        // 00     Reserved for future use by ISO/IEC\n        // 01     No adaptation_field, payload only\n        // 10     Adaptation_field only, no payload\n        // 11     Adaptation_field followed by payload\n        this.afc = (buffer[3] >> 4) & 3;\n        // '1' indicates that the discontinuity state is true for the current Transport Stream packet.\n        // this.continuity_counter = buffer[3] & 0xf;\n        // self defines.\n        this.has_payload = this.afc & 1;\n        this.has_adaptation = this.afc & 2;\n        // this.is_discontinuity = this.has_adaptation && buffer[4] != 0 /* with length > 0 */ && buffer[5] & 0x80;\n        /* and discontinuity indicated */\n        if (this.has_payload) {\n            if (this.has_adaptation) {\n                let adaptation_field_length = buffer[4];\n                this.payload = buffer.subarray(5 + adaptation_field_length);\n            }\n            else {\n                this.payload = buffer.subarray(4);\n            }\n        }\n    }\n    valid() {\n        return this.sync_byte === SYNC_BYTE && this.has_payload === 1;\n    }\n}\n\n/**\n * @file: demux.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nconst CHUNK_BYTE_LENGTH = 188; // Transport Stream chunks shall be 188 bytes long.\nclass TSDemux extends DemuxFacade {\n    constructor(options = {}) {\n        super(options);\n        this.psi_ = new PSI(this.ctx_);\n        this.pesStream_ = new PesStream(this.ctx_, this.psi_);\n        this.elementaryStream_ = new ElementaryStream(this.ctx_, this.psi_, options);\n        this.complexStream_ = new M2TSComplexStream(this.ctx_, this.psi_);\n        // Compose pipeline\n        this.pipe(this.pesStream_);\n        this.pesStream_.pipe(this.elementaryStream_);\n        this.elementaryStream_.pipe(this.complexStream_);\n        super.listenEndStream_();\n    }\n    /**\n     * This is end pipeline stream\n     */\n    get endStream() {\n        let stream = this.elementaryStream_;\n        if (this.options_.decodeCodec) {\n            stream = this.complexStream_;\n        }\n        return stream;\n    }\n    /**\n     * TS push support streaming incomplete data push.\n     * @param buffer\n     * @param conf\n     * @param conf.done - If you need the done event, this boolean needs to be set\n     */\n    push(buffer, conf) {\n        const { done } = conf;\n        const { options_, ctx_, cache_buffer_, psi_ } = this;\n        let newBuf = super.constraintPushData_(buffer);\n        let cacheByteLength = cache_buffer_.byteLength;\n        let byteOffset = null;\n        options_.config = conf;\n        logger.log(`hls demux received ${newBuf.byteLength} bytes, cache ${cacheByteLength} bytes. ${done ? 'chunk done' : ''}`);\n        cache_buffer_.append(newBuf);\n        while (cache_buffer_.byteLength >= CHUNK_BYTE_LENGTH) {\n            let chunk = cache_buffer_.cut(CHUNK_BYTE_LENGTH);\n            // The pushed buffer may be so small that can't cut a ts chunk.\n            if (chunk) {\n                let packet = new Packet(chunk);\n                if (packet.valid()) {\n                    psi_.parse(packet);\n                    this.emit('data', packet);\n                }\n                else {\n                    let errMsg = `Encounter invalid ts packet, packet_length(${chunk.length}), cache_length(${this.cache_buffer_.byteLength}), has_payload(${packet.has_payload}), data(${chunk})`;\n                    logger.error(errMsg);\n                    this.reset();\n                    ctx_.emit('error', muxErrorCode.TS_SYNC_BYTE, errMsg, {\n                        startByte: byteOffset,\n                        endByte: byteOffset + chunk.byteLength\n                    });\n                    break;\n                }\n                byteOffset += chunk.byteLength;\n            }\n        }\n        if (cache_buffer_.empty && done) {\n            // logger.log('mux packet done!');\n            this.emit('done');\n        }\n    }\n    reset() {\n        this.cache_buffer_.clear();\n        this.emit('reset');\n    }\n}\n\n/**\n * @file: mp4-inspector.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/* eslint-disable */\nlet /**\n     * Returns the string representation of an ASCII encoded four byte buffer.\n     * @param buffer - a four-byte buffer to translate\n     * @return the corresponding string\n     */ parseType = function (buffer) {\n    let result = '';\n    result += String.fromCharCode(buffer[0]);\n    result += String.fromCharCode(buffer[1]);\n    result += String.fromCharCode(buffer[2]);\n    result += String.fromCharCode(buffer[3]);\n    return result;\n}, parseMp4Date = function (seconds) {\n    return new Date(seconds * 1000 - 2082844800000);\n}, parseSampleFlags = function (flags) {\n    return {\n        isLeading: (flags[0] & 0x0c) >>> 2,\n        dependsOn: flags[0] & 0x03,\n        isDependedOn: (flags[1] & 0xc0) >>> 6,\n        hasRedundancy: (flags[1] & 0x30) >>> 4,\n        paddingValue: (flags[1] & 0x0e) >>> 1,\n        isNonSyncSample: flags[1] & 0x01,\n        degradationPriority: (flags[2] << 8) | flags[3]\n    };\n}, // registry of handlers for individual mp4 box types\nparse = {\n    // codingname, not a first-class box type. stsd entries share the\n    // same format as real boxes so the parsing infrastructure can be\n    // shared\n    avc1: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength);\n        return {\n            dataReferenceIndex: view.getUint16(6),\n            width: view.getUint16(24),\n            height: view.getUint16(26),\n            horizresolution: view.getUint16(28) + view.getUint16(30) / 16,\n            vertresolution: view.getUint16(32) + view.getUint16(34) / 16,\n            frameCount: view.getUint16(40),\n            depth: view.getUint16(74),\n            config: mp4toJSON(data.subarray(78, data.byteLength))\n        };\n    },\n    avcC: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            configurationVersion: data[0],\n            avcProfileIndication: data[1],\n            profileCompatibility: data[2],\n            avcLevelIndication: data[3],\n            lengthSizeMinusOne: data[4] & 0x03,\n            sps: [],\n            pps: []\n        }, numOfSequenceParameterSets = data[5] & 0x1f, numOfPictureParameterSets, nalSize, offset, i;\n        // iterate past any SPSs\n        offset = 6;\n        for (i = 0; i < numOfSequenceParameterSets; i++) {\n            nalSize = view.getUint16(offset);\n            offset += 2;\n            result.sps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));\n            offset += nalSize;\n        }\n        // iterate past any PPSs\n        numOfPictureParameterSets = data[offset];\n        offset++;\n        for (i = 0; i < numOfPictureParameterSets; i++) {\n            nalSize = view.getUint16(offset);\n            offset += 2;\n            result.pps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));\n            offset += nalSize;\n        }\n        return result;\n    },\n    btrt: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength);\n        return {\n            bufferSizeDB: view.getUint32(0),\n            maxBitrate: view.getUint32(4),\n            avgBitrate: view.getUint32(8)\n        };\n    },\n    esds: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength);\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            esId: (data[6] << 8) | data[7],\n            streamPriority: data[8] & 0x1f,\n            decoderConfig: {\n                objectProfileIndication: data[11],\n                streamType: (data[12] >>> 2) & 0x3f,\n                bufferSize: (data[13] << 16) | (data[14] << 8) | data[15],\n                maxBitrate: (data[16] << 24) | (data[17] << 16) | (data[18] << 8) | data[19],\n                avgBitrate: (data[20] << 24) | (data[21] << 16) | (data[22] << 8) | data[23],\n                decoderConfigDescriptor: {\n                    tag: data[24],\n                    length: data[25],\n                    // audioObjectType: (data[26] >>> 3) & 0x1f,\n                    // samplingFrequencyIndex: ((data[26] & 0x07) << 1) |\n                    //   ((data[27] >>> 7) & 0x01),\n                    // channelConfiguration: (data[27] >>> 3) & 0x0f,\n                    // FIXME\n                    audioObjectType: (data[35] >>> 3) & 0x1f,\n                    samplingFrequencyIndex: ((data[35] & 0x07) << (8 + (data[36] & 0x80))) >> 7,\n                    channelConfiguration: (data[36] & 0x78) >> 3\n                }\n            }\n        };\n    },\n    ftyp: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            majorBrand: parseType(data.subarray(0, 4)),\n            minorVersion: view.getUint32(4),\n            compatibleBrands: []\n        }, i = 8;\n        while (i < data.byteLength) {\n            result.compatibleBrands.push(parseType(data.subarray(i, i + 4)));\n            i += 4;\n        }\n        return result;\n    },\n    dinf: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    dref: function (data) {\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            dataReferences: mp4toJSON(data.subarray(8))\n        };\n    },\n    hdlr: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            version: view.getUint8(0),\n            flags: new Uint8Array(data.subarray(1, 4)),\n            handlerType: parseType(data.subarray(8, 12)),\n            name: ''\n        }, i = 8;\n        // parse out the name field\n        for (i = 24; i < data.byteLength; i++) {\n            if (data[i] === 0x00) {\n                // the name field is null-terminated\n                i++;\n                break;\n            }\n            result.name += String.fromCharCode(data[i]);\n        }\n        // decode UTF-8 to javascript's internal representation\n        // see http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html\n        result.name = decodeURIComponent(decodeURIComponent(result.name));\n        return result;\n    },\n    // mdat: function(data) {\n    // \treturn {\n    // \t\tbyteLength: data.byteLength,\n    // \t\tnals: nalParse(data),\n    // \t\trealData: data\n    // \t};\n    // },\n    mdhd: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, language, result = {\n            version: view.getUint8(0),\n            flags: new Uint8Array(data.subarray(1, 4)),\n            language: '',\n            creationTime: new Date(),\n            modificationTime: new Date(),\n            timescale: 0,\n            duration: 0\n        };\n        if (result.version === 1) {\n            i += 4;\n            result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes\n            i += 8;\n            result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes\n            i += 4;\n            result.timescale = view.getUint32(i);\n            i += 8;\n            result.duration = view.getUint32(i); // truncating top 4 bytes\n        }\n        else {\n            result.creationTime = parseMp4Date(view.getUint32(i));\n            i += 4;\n            result.modificationTime = parseMp4Date(view.getUint32(i));\n            i += 4;\n            result.timescale = view.getUint32(i);\n            i += 4;\n            result.duration = view.getUint32(i);\n        }\n        i += 4;\n        // language is stored as an ISO-639-2/T code in an array of three 5-bit fields\n        // each field is the packed difference between its ASCII value and 0x60\n        language = view.getUint16(i);\n        result.language += String.fromCharCode((language >> 10) + 0x60);\n        result.language += String.fromCharCode(((language & 0x03c0) >> 5) + 0x60);\n        result.language += String.fromCharCode((language & 0x1f) + 0x60);\n        return result;\n    },\n    mdia: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    mfhd: function (data) {\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            sequenceNumber: (data[4] << 24) | (data[5] << 16) | (data[6] << 8) | data[7]\n        };\n    },\n    minf: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    // codingname, not a first-class box type. stsd entries share the\n    // same format as real boxes so the parsing infrastructure can be\n    // shared\n    mp4a: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            // 6 bytes reserved\n            dataReferenceIndex: view.getUint16(6),\n            // 4 + 4 bytes reserved\n            channelcount: view.getUint16(16),\n            samplesize: view.getUint16(18),\n            // 2 bytes pre_defined\n            // 2 bytes reserved\n            samplerate: view.getUint16(24) + view.getUint16(26) / 65536,\n            streamDescriptor: undefined\n        };\n        // if there are more bytes to process, assume this is an ISO/IEC\n        // 14496-14 MP4AudioSampleEntry and parse the ESDBox\n        if (data.byteLength > 28) {\n            result.streamDescriptor = mp4toJSON(data.subarray(28))[0];\n        }\n        return result;\n    },\n    moof: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    moov: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    mvex: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    mvhd: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, result = {\n            version: view.getUint8(0),\n            flags: new Uint8Array(data.subarray(1, 4)),\n            creationTime: new Date(),\n            modificationTime: new Date(),\n            timescale: 0,\n            duration: 0,\n            rate: 0,\n            volume: 0,\n            matrix: new Uint32Array(0),\n            nextTrackId: 0\n        };\n        if (result.version === 1) {\n            i += 4;\n            result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes\n            i += 8;\n            result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes\n            i += 4;\n            result.timescale = view.getUint32(i);\n            i += 8;\n            result.duration = view.getUint32(i); // truncating top 4 bytes\n        }\n        else {\n            result.creationTime = parseMp4Date(view.getUint32(i));\n            i += 4;\n            result.modificationTime = parseMp4Date(view.getUint32(i));\n            i += 4;\n            result.timescale = view.getUint32(i);\n            i += 4;\n            result.duration = view.getUint32(i);\n        }\n        i += 4;\n        // convert fixed-point, base 16 back to a number\n        result.rate = view.getUint16(i) + view.getUint16(i + 2) / 16;\n        i += 4;\n        result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;\n        i += 2;\n        i += 2;\n        i += 2 * 4;\n        result.matrix = new Uint32Array(data.subarray(i, i + 9 * 4));\n        i += 9 * 4;\n        i += 6 * 4;\n        result.nextTrackId = view.getUint32(i);\n        return result;\n    },\n    pdin: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength);\n        return {\n            version: view.getUint8(0),\n            flags: new Uint8Array(data.subarray(1, 4)),\n            rate: view.getUint32(4),\n            initialDelay: view.getUint32(8)\n        };\n    },\n    sdtp: function (data) {\n        let result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            samples: []\n        }, i;\n        for (i = 4; i < data.byteLength; i++) {\n            result.samples.push({\n                dependsOn: (data[i] & 0x30) >> 4,\n                isDependedOn: (data[i] & 0x0c) >> 2,\n                hasRedundancy: data[i] & 0x03\n            });\n        }\n        return result;\n    },\n    sidx: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            references: [],\n            referenceId: view.getUint32(4),\n            timescale: view.getUint32(8),\n            earliestPresentationTime: view.getUint32(12),\n            firstOffset: view.getUint32(16)\n        }, referenceCount = view.getUint16(22), i;\n        for (i = 24; referenceCount; i += 12, referenceCount--) {\n            result.references.push({\n                referenceType: (data[i] & 0x80) >>> 7,\n                referencedSize: view.getUint32(i) & 0x7fffffff,\n                subsegmentDuration: view.getUint32(i + 4),\n                startsWithSap: !!(data[i + 8] & 0x80),\n                sapType: (data[i + 8] & 0x70) >>> 4,\n                sapDeltaTime: view.getUint32(i + 8) & 0x0fffffff\n            });\n        }\n        return result;\n    },\n    stbl: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    stco: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength);\n        let entryCount = view.getUint32(4);\n        let result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            entryCount: entryCount,\n            chunkOffsets: []\n        };\n        for (let i = 8; entryCount; i += 4, entryCount--) {\n            result.chunkOffsets.push(view.getUint32(i));\n        }\n        return result;\n    },\n    stsc: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), entryCount = view.getUint32(4), result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            sampleToChunks: []\n        }, i;\n        for (i = 8; entryCount; i += 12, entryCount--) {\n            result.sampleToChunks.push({\n                firstChunk: view.getUint32(i),\n                samplesPerChunk: view.getUint32(i + 4),\n                sampleDescriptionIndex: view.getUint32(i + 8)\n            });\n        }\n        return result;\n    },\n    stsd: function (data) {\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            boxes: mp4toJSON(data.subarray(8))\n        };\n    },\n    stsz: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            sampleSize: view.getUint32(4),\n            entries: []\n        }, i;\n        for (i = 12; i < data.byteLength; i += 4) {\n            result.entries.push(view.getUint32(i));\n        }\n        return result;\n    },\n    stts: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            timeToSamples: []\n        }, entryCount = view.getUint32(4), i;\n        for (i = 8; entryCount; i += 8, entryCount--) {\n            result.timeToSamples.push({\n                sampleCount: view.getUint32(i),\n                sampleDelta: view.getUint32(i + 4)\n            });\n        }\n        return result;\n    },\n    styp: function (data) {\n        return parse.ftyp(data);\n    },\n    tfdt: function (data) {\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            baseMediaDecodeTime: (data[4] << 24) | (data[5] << 16) | (data[6] << 8) | data[7]\n        };\n    },\n    tfhd: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            trackId: view.getUint32(4)\n        }, baseDataOffsetPresent = result.flags[2] & 0x01, sampleDescriptionIndexPresent = result.flags[2] & 0x02, defaultSampleDurationPresent = result.flags[2] & 0x08, defaultSampleSizePresent = result.flags[2] & 0x10, defaultSampleFlagsPresent = result.flags[2] & 0x20, i;\n        i = 8;\n        if (baseDataOffsetPresent) {\n            i += 4; // truncate top 4 bytes\n            result.baseDataOffset = view.getUint32(12);\n            i += 4;\n        }\n        if (sampleDescriptionIndexPresent) {\n            result.sampleDescriptionIndex = view.getUint32(i);\n            i += 4;\n        }\n        if (defaultSampleDurationPresent) {\n            result.defaultSampleDuration = view.getUint32(i);\n            i += 4;\n        }\n        if (defaultSampleSizePresent) {\n            result.defaultSampleSize = view.getUint32(i);\n            i += 4;\n        }\n        if (defaultSampleFlagsPresent) {\n            result.defaultSampleFlags = view.getUint32(i);\n        }\n        return result;\n    },\n    tkhd: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength), i = 4, result = {\n            version: view.getUint8(0),\n            flags: new Uint8Array(data.subarray(1, 4)),\n            creationTime: new Date(),\n            modificationTime: new Date(),\n            trackId: 0,\n            duration: 0,\n            layer: 0,\n            alternateGroup: 0,\n            volume: 0,\n            width: 0,\n            height: 0,\n            matrix: new Uint32Array(0)\n        };\n        if (result.version === 1) {\n            i += 4;\n            result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes\n            i += 8;\n            result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes\n            i += 4;\n            result.trackId = view.getUint32(i);\n            i += 4;\n            i += 8;\n            result.duration = view.getUint32(i); // truncating top 4 bytes\n        }\n        else {\n            result.creationTime = parseMp4Date(view.getUint32(i));\n            i += 4;\n            result.modificationTime = parseMp4Date(view.getUint32(i));\n            i += 4;\n            result.trackId = view.getUint32(i);\n            i += 4;\n            i += 4;\n            result.duration = view.getUint32(i);\n        }\n        i += 4;\n        i += 2 * 4;\n        result.layer = view.getUint16(i);\n        i += 2;\n        result.alternateGroup = view.getUint16(i);\n        i += 2;\n        // convert fixed-point, base 16 back to a number\n        result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;\n        i += 2;\n        i += 2;\n        result.matrix = new Uint32Array(data.subarray(i, i + 9 * 4));\n        i += 9 * 4;\n        result.width = view.getUint16(i) + view.getUint16(i + 2) / 16;\n        i += 4;\n        result.height = view.getUint16(i) + view.getUint16(i + 2) / 16;\n        return result;\n    },\n    traf: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    trak: function (data) {\n        return {\n            boxes: mp4toJSON(data)\n        };\n    },\n    trex: function (data) {\n        let view = new DataView(data.buffer, data.byteOffset, data.byteLength);\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            trackId: view.getUint32(4),\n            defaultSampleDescriptionIndex: view.getUint32(8),\n            defaultSampleDuration: view.getUint32(12),\n            defaultSampleSize: view.getUint32(16),\n            sampleDependsOn: data[20] & 0x03,\n            sampleIsDependedOn: (data[21] & 0xc0) >> 6,\n            sampleHasRedundancy: (data[21] & 0x30) >> 4,\n            samplePaddingValue: (data[21] & 0x0e) >> 1,\n            sampleIsDifferenceSample: !!(data[21] & 0x01),\n            sampleDegradationPriority: view.getUint16(22)\n        };\n    },\n    trun: function (data) {\n        let result = {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4)),\n            samples: []\n        }, view = new DataView(data.buffer, data.byteOffset, data.byteLength), dataOffsetPresent = result.flags[2] & 0x01, firstSampleFlagsPresent = result.flags[2] & 0x04, sampleDurationPresent = result.flags[1] & 0x01, sampleSizePresent = result.flags[1] & 0x02, sampleFlagsPresent = result.flags[1] & 0x04, sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08, sampleCount = view.getUint32(4), offset = 8, sample;\n        if (dataOffsetPresent) {\n            result.dataOffset = view.getUint32(offset);\n            offset += 4;\n        }\n        if (firstSampleFlagsPresent && sampleCount) {\n            sample = {\n                flags: parseSampleFlags(data.subarray(offset, offset + 4))\n            };\n            offset += 4;\n            if (sampleDurationPresent) {\n                sample.duration = view.getUint32(offset);\n                offset += 4;\n            }\n            if (sampleSizePresent) {\n                sample.size = view.getUint32(offset);\n                offset += 4;\n            }\n            if (sampleCompositionTimeOffsetPresent) {\n                sample.compositionTimeOffset = view.getUint32(offset);\n                offset += 4;\n            }\n            result.samples.push(sample);\n            sampleCount--;\n        }\n        while (sampleCount--) {\n            sample = {};\n            if (sampleDurationPresent) {\n                sample.duration = view.getUint32(offset);\n                offset += 4;\n            }\n            if (sampleSizePresent) {\n                sample.size = view.getUint32(offset);\n                offset += 4;\n            }\n            if (sampleFlagsPresent) {\n                sample.flags = parseSampleFlags(data.subarray(offset, offset + 4));\n                offset += 4;\n            }\n            if (sampleCompositionTimeOffsetPresent) {\n                sample.compositionTimeOffset = view.getUint32(offset);\n                offset += 4;\n            }\n            result.samples.push(sample);\n        }\n        return result;\n    },\n    'url ': function (data) {\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4))\n        };\n    },\n    vmhd: function (data) {\n        //let view = new DataView(data.buffer, data.byteOffset, data.byteLength);\n        return {\n            version: data[0],\n            flags: new Uint8Array(data.subarray(1, 4))\n            //graphicsmode: view.getUint16(4),\n            //opcolor: new Uint16Array([view.getUint16(6),\n            //                          view.getUint16(8),\n            //                          view.getUint16(10)])\n        };\n    }\n};\n/**\n * Return a javascript array of box objects parsed from an ISO base media file.\n * @param data - the binary data of the media to be inspected\n * @return a javascript array of potentially nested box objects\n */\nlet mp4toJSON = function (data) {\n    let i = 0, result = [], view = new DataView(data.buffer, data.byteOffset, data.byteLength), size, type, end, box;\n    while (i < data.byteLength) {\n        // parse box data\n        (size = view.getUint32(i)), (type = parseType(data.subarray(i + 4, i + 8)));\n        end = size > 1 ? i + size : data.byteLength;\n        // parse type-specific data\n        box = (parse[type] ||\n            function (data) {\n                return {\n                    data: data\n                };\n            })(data.subarray(i + 8, end));\n        box.size = size;\n        box.type = type;\n        // store this box and move to the next\n        result.push(box);\n        i = end;\n    }\n    return result;\n};\nconst MP4Inspect = {\n    mp4toJSON: mp4toJSON\n};\n\n/**\n * @file: demux.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * mp4.\n */\nclass MP4Demux extends DemuxFacade {\n    constructor(options = {}) {\n        super(options);\n        super.listenEndStream_();\n    }\n    /**\n     * This is end pipeline stream\n     */\n    get endStream() {\n        return this;\n    }\n    /**\n     * The MP4 data pushed into stream should be complete data.\n     * @param buffer\n     */\n    push(buffer) {\n        let newBuf = super.constraintPushData_(buffer);\n        logger.log(`mp4 demux received ${newBuf.byteLength} bytes`);\n        let result = MP4Inspect.mp4toJSON(newBuf);\n        this.emit('data', result);\n    }\n}\n\n/**\n * @file: created at Wednesday, 13th May 2020 4:15:40 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nconst HEAD_LEN = 9;\nconst MIN_BODY_LEN = 4;\nconst PREVIOUS_TAG_SIZE = 4;\nconst MIN_TAG_LEN = PREVIOUS_TAG_SIZE;\nvar FLVParseStage;\n(function (FLVParseStage) {\n    FLVParseStage[FLVParseStage[\"HEAD\"] = 0] = \"HEAD\";\n    FLVParseStage[FLVParseStage[\"BODY\"] = 1] = \"BODY\";\n})(FLVParseStage || (FLVParseStage = {}));\n\n/**\n * @file: created at Saturday, 23rd May 2020 11:46:18 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nvar FlvTagTypes;\n(function (FlvTagTypes) {\n    FlvTagTypes[FlvTagTypes[\"SCRIPT_DATA\"] = 18] = \"SCRIPT_DATA\";\n    FlvTagTypes[FlvTagTypes[\"VIDEO\"] = 9] = \"VIDEO\";\n    FlvTagTypes[FlvTagTypes[\"AUDIO\"] = 8] = \"AUDIO\";\n})(FlvTagTypes || (FlvTagTypes = {}));\nvar FlvTagTypes$1 = FlvTagTypes;\n\n/**\n * @file: tag.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * @extends DataViewReader\n */\nclass FlvTag extends DataViewReader {\n    /**\n     * @param buffer\n     */\n    constructor(buffer) {\n        super();\n        this.tagType = buffer[0];\n        this.dataSize = this.readUint32(buffer, 0) & 0x00ffffff;\n        let timestamp = this.readUint32(buffer, 3) & 0x00ffffff; // the lower 24 bits of the timestamp\n        let timestampExtended = buffer[7]; // This field represents the upper 8 bits of timestamp\n        this.timestamp = (timestampExtended << 24) + timestamp;\n        this.streamId = this.readUint32(buffer, 8) & 0x00ffffff; // Always 0\n        this.payload = buffer.subarray(11, 11 + this.dataSize);\n        this.previousTagSize = this.readUint32(buffer, 11 + this.dataSize);\n        this.totalSize = this.previousTagSize + 4;\n    }\n    valid() {\n        let { tagType, dataSize, previousTagSize } = this;\n        return (previousTagSize === 11 + dataSize &&\n            (tagType === FlvTagTypes$1.SCRIPT_DATA || tagType === FlvTagTypes$1.VIDEO || tagType === FlvTagTypes$1.AUDIO));\n    }\n}\n\n/**\n * @file: elementary.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass BodyStream extends Stream {\n    constructor(ctx, flvCtx, options = {}) {\n        super();\n        this.ctx_ = ctx;\n        this.flv_ = flvCtx;\n        this.options_ = options;\n        this.cache_buffer_ = new CacheBuffer();\n    }\n    /**\n     * Push a body buffer\n     */\n    push(bodyBuffer) {\n        const { ctx_, flv_, cache_buffer_ } = this;\n        let buffer;\n        cache_buffer_.append(bodyBuffer);\n        if (flv_.pos === HEAD_LEN) {\n            if (cache_buffer_.byteLength > PREVIOUS_TAG_SIZE + MIN_TAG_LEN) {\n                // drop PreviousTagSize0\n                cache_buffer_.cut(PREVIOUS_TAG_SIZE);\n                flv_.pos += PREVIOUS_TAG_SIZE;\n            }\n        }\n        while (cache_buffer_.byteLength > 0) {\n            // buffer start with tag\n            buffer = cache_buffer_.bytes;\n            if (buffer.length >= MIN_TAG_LEN) {\n                let tagHeadSize = 11; // 10 is tag header\n                let tagPayloadSize = (buffer[1] << 16) + (buffer[2] << 8) + buffer[3];\n                let previousTagSize = 4;\n                let tagSize = tagHeadSize + tagPayloadSize + previousTagSize;\n                if (buffer.length >= tagSize) {\n                    let tagBuffer = cache_buffer_.cut(tagSize);\n                    let tag = new FlvTag(tagBuffer);\n                    if (tag.valid()) {\n                        this.emit('data', tag);\n                        flv_.pos += tag.totalSize;\n                    }\n                    else {\n                        let errMsg = `Encounter invalid flv tag, tag_length(${tag.previousTagSize}), cache_length(${cache_buffer_.byteLength}), data(${tagBuffer})`;\n                        logger.error(errMsg);\n                        this.reset();\n                        ctx_.emit('error', muxErrorCode.TS_SYNC_BYTE, errMsg);\n                    }\n                }\n                else {\n                    break;\n                }\n            }\n            else {\n                break;\n            }\n        }\n    }\n    reset() {\n        const { cache_buffer_ } = this;\n        cache_buffer_.clear();\n        this.emit('reset');\n    }\n}\n\n/**\n * @file: created at Sunday, 24th May 2020 2:21:46 am\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nfunction AMFdeSerialize(data) {\n    let result = {};\n    let item = parseData_(data);\n    result[item.key] = item.value;\n    return result;\n}\nfunction parseData_(source, isString = false) {\n    let key = null, value = null, data = null;\n    if (isString) {\n        try {\n            data = new Uint8Array(source.length + 1);\n        }\n        catch (e) {\n            logger.error(`flv parseData failed: ${e.message}`);\n        }\n        data[0] = 2;\n        data.set(source, 1, source.length);\n    }\n    else {\n        data = source;\n    }\n    key = deSerialize_(data);\n    if (isString) {\n        key.valueLength -= 1;\n    }\n    let temp = source.subarray(key.valueLength, source.byteLength);\n    value = deSerialize_(temp);\n    return {\n        key: key.value,\n        value: value.value,\n        valueLength: key.valueLength + value.valueLength\n    };\n}\nfunction deSerialize_(data) {\n    let result = {};\n    let valueLength = 0;\n    let a = new DataViewReader();\n    switch (data[0]) {\n        case 0:\n            valueLength = 8;\n            result.value = uint8ToDouble_(data.subarray(1, 9));\n            result.valueLength = 1 + valueLength;\n            break;\n        case 1:\n            valueLength = 1;\n            result.value = data[1] !== 0;\n            result.valueLength = 1 + valueLength;\n            break;\n        case 2:\n            valueLength = (data[1] << 8) | data[2];\n            result.value = uint8ToStr_(data.subarray(3, 3 + valueLength));\n            result.valueLength = 1 + 2 + valueLength;\n            break;\n        case 3:\n            valueLength = 1;\n            result.value = {};\n            while (data[valueLength] != 0x00 || data[valueLength + 1] != 0x00 || data[valueLength + 2] != 0x09) {\n                let objData = data.subarray(valueLength, data.byteLength);\n                let item = parseData_(objData, true);\n                result.value[item.key] = item.value;\n                valueLength += item.valueLength;\n                objData = null;\n            }\n            valueLength += 3;\n            result.valueLength = valueLength;\n            break;\n        case 4:\n            valueLength = (data[1] << 8) | data[2];\n            result.value = uint8ToStr_(data.subarray(3, 3 + valueLength));\n            result.valueLength = 1 + 2 + valueLength;\n            break;\n        case 5:\n            result.value = null;\n            valueLength = 1;\n            result.valueLength = valueLength;\n            break;\n        case 6:\n            result.value = undefined;\n            valueLength = 1;\n            result.valueLength = valueLength;\n            break;\n        case 7:\n            result.value = a.readUint16(data, 1);\n            valueLength = 2 + 1;\n            result.valueLength = valueLength;\n            break;\n        case 8:\n            {\n                let arrLength = (data[1] << 24) | (data[2] << 16) | (data[3] << 8) | data[4];\n                valueLength = 1 + 4;\n                result.value = {};\n                for (let count = 0; count < arrLength; count++) {\n                    let itemData = data.subarray(valueLength, data.byteLength);\n                    let item2 = parseData_(itemData, true);\n                    result.value[item2.key] = item2.value;\n                    valueLength += item2.valueLength;\n                }\n                valueLength += 3;\n                result.valueLength = valueLength;\n            }\n            break;\n        case 9:\n            break;\n        case 10:\n            {\n                let arr = [];\n                let arrLength2 = a.readUint32(data, 1);\n                for (let i = 0; i < arrLength2; i++) {\n                    let objData2 = data.subarray(i * 9 + 4 + 1, data.byteLength);\n                    arr.push(deSerialize_(objData2).value);\n                }\n                result.value = arr;\n                valueLength = arr.length * 9 + 4 + 1;\n                result.valueLength = valueLength;\n            }\n            break;\n        case 11:\n            result.value = uint8ToDouble_(data.subarray(0, 8));\n            valueLength = 8 + 1 + 2;\n            result.valueLength = valueLength;\n            break;\n        case 12:\n            valueLength = (data[1] << 24) | (data[2] << 16) | (data[3] << 8) | data[4];\n            result.value = uint8ToStr_(data.subarray(5, 5 + valueLength));\n            result.valueLength = 1 + 4 + valueLength;\n            break;\n        default:\n            return null;\n    }\n    a = null;\n    return result;\n}\nfunction uint8ToStr_(data) {\n    return String.fromCharCode.apply(null, data);\n}\nfunction uint8ToDouble_(data) {\n    let temp = new Uint8Array(data);\n    let dv = new DataView(temp.buffer);\n    let str = dv.getFloat64(0);\n    dv = null;\n    temp = null;\n    return str;\n}\n\n/**\n * @file: created at Saturday, 9th May 2020 4:38:35 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nvar AudioSoundFormat;\n(function (AudioSoundFormat) {\n    AudioSoundFormat[AudioSoundFormat[\"AAC\"] = 10] = \"AAC\";\n})(AudioSoundFormat || (AudioSoundFormat = {}));\nvar AudioSoundType;\n(function (AudioSoundType) {\n    AudioSoundType[AudioSoundType[\"MONO\"] = 0] = \"MONO\";\n    AudioSoundType[AudioSoundType[\"STEREO\"] = 1] = \"STEREO\"; // For AAC: always 1\n})(AudioSoundType || (AudioSoundType = {}));\nclass AVContext extends Stream {\n    constructor() {\n        super(...arguments);\n        this.pos = 0; // parse byte position relative to flv first byte;\n    }\n}\n\n/**\n * @file: created at Monday, 25th May 2020 12:36:52 am\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n// 0: AAC sequence header\n// 1: AAC raw\nvar AACPacketType;\n(function (AACPacketType) {\n    AACPacketType[AACPacketType[\"SEQUENCE_HEAD\"] = 0] = \"SEQUENCE_HEAD\";\n    AACPacketType[AACPacketType[\"AAC_RAW\"] = 1] = \"AAC_RAW\"; // 1 : One or more NALUs (Full frames are required)\n})(AACPacketType || (AACPacketType = {}));\n/**\n * ISO/IEC 14496-3 1.6.2.1 AudioSpecificConfig\n * @param buffer\n */\nfunction parseAudioSpecificConfig(buffer) {\n    let LOG = 'AudioSpecificConfig';\n    // ISO/IEC 14496-3 Table 1.16 – Syntax of GetAudioObjectType()\n    let audioObjectType = buffer[0] >> 3;\n    if (audioObjectType == 31) {\n        logger.error(`${LOG} unsupported audioObjectType`);\n        // audioObjectType = 32 + audioObjectTypeExt;\n    }\n    let samplingFrequencyIndex = ((buffer[0] & 0x7) << 1) | (buffer[1] >> 7);\n    if (samplingFrequencyIndex === 0xf) {\n        logger.error(`${LOG} unsupported samplingFrequencyIndex`);\n    }\n    let channelConfiguration = (buffer[1] >> 3) & 0x0f;\n    if (channelConfiguration < 0 || channelConfiguration >= 8) {\n        logger.error('${LOG} unsupported channel configuration');\n    }\n    let sampleCount = ((buffer[1] >> 2) & 0x01) == 0 ? 1024 : 1024;\n    let sampleRate = AAC_SAMPLING_FREQUENCIES[samplingFrequencyIndex];\n    return {\n        audioObjectType,\n        samplingFrequencyIndex,\n        channelConfiguration,\n        sampleCount,\n        sampleRate\n    };\n}\n/**\n * @extends DataViewReader\n */\nclass AACAudioData extends DataViewReader {\n    /**\n     * @param buffer\n     */\n    constructor(buffer, timestamp) {\n        super();\n        this.dts = timestamp;\n        this.pts = timestamp;\n        this.aacPacketType = buffer[0];\n        this.payload = buffer.subarray(1);\n        if (this.aacPacketType === 0) {\n            this.audioSpecificConfig = parseAudioSpecificConfig(this.payload);\n        }\n    }\n}\n\n/**\n * @file: created at Monday, 25th May 2020 2:51:52 am\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n// 0 = Linear PCM, platform endian\n// 1 = ADPCM\n// 2 = MP3\n// 3 = Linear PCM, little endian\n// 4 = Nellymoser 16-kHz mono\n// 5 = Nellymoser 8-kHz mono\n// 6 = Nellymoser\n// 7 = G.711 A-law logarithmic PCM 8 = G.711 mu-law logarithmic PCM 9 = reserved\n// 10 = AAC\n// 11 = Speex\n// 14 = MP3 8-Khz\n// 15 = Device-specific sound\n/**\n * @extends DataViewReader\n */\nclass FlvTagAudioData extends DataViewReader {\n    /**\n     * @param buffer\n     */\n    constructor(buffer, timestamp) {\n        super();\n        this.soundFormat = (buffer[0] & 0xf0) >> 4;\n        this.soundRate = (buffer[0] & 0x0c) >> 2;\n        let soundSize = (buffer[0] & 0x02) >> 1;\n        switch (soundSize) {\n            case 0:\n                this.sampleSize = 8; // bit\n                break;\n            case 1:\n                this.sampleSize = 16; // bit\n                break;\n        }\n        this.soundType = buffer[0] & 1;\n        switch (this.soundFormat) {\n            case AudioSoundFormat.AAC:\n                this.soundData = new AACAudioData(buffer.subarray(1), timestamp);\n                break;\n            default:\n                logger.error(`flv tag audioData encounter unknown soundFormat ${this.soundFormat}`);\n        }\n    }\n}\n\n/**\n * @file: created at Monday, 25th May 2020 12:36:52 am\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n// 0 : AVCDecoderConfigurationRecord（AVC sequence header）\n// 1 : One or more NALUs (Full frames are required)\n// 2 : AVC end of sequence\nvar AVCPacketTypes;\n(function (AVCPacketTypes) {\n    AVCPacketTypes[AVCPacketTypes[\"SEQUENCE_HEAD\"] = 0] = \"SEQUENCE_HEAD\";\n    AVCPacketTypes[AVCPacketTypes[\"NALU\"] = 1] = \"NALU\";\n    AVCPacketTypes[AVCPacketTypes[\"SEQUENCE_END\"] = 2] = \"SEQUENCE_END\"; // 2 : AVC end of sequence\n})(AVCPacketTypes || (AVCPacketTypes = {}));\n/**\n * ISO/IEC 14496-15  5.2.4.1.1 Syntax\n * @param data\n */\nfunction parseAVCDecoderConfigurationRecord(data) {\n    let version = data[0];\n    let profile = data[1];\n    let profileCompatibility = data[2];\n    let level = data[3];\n    let naluSizeLength = 1 + (data[4] & 0x03);\n    let ppsNalus = [], spsNalus = [];\n    let pos = 5;\n    let numOfSPS = data[pos] & 0x1f;\n    if (numOfSPS === 0) {\n        logger.error(`Flv: Invalid AVCDecoderConfigurationRecord: No SPS`);\n    }\n    else if (numOfSPS > 0) {\n        if (numOfSPS > 1) {\n            logger.warn(`Flv: Strange AVCDecoderConfigurationRecord: SPS Count = ${numOfSPS}`);\n        }\n        pos++;\n        for (let i = 0; i < numOfSPS; i++) {\n            let spsDataLength = (data[pos] << 8) | data[pos + 1];\n            pos += 2;\n            spsNalus.push(data.subarray(pos, pos + spsDataLength));\n            pos += spsDataLength;\n        }\n    }\n    let numOfPPS = data[pos];\n    if (numOfPPS === 0) {\n        logger.error(`Flv: Invalid AVCDecoderConfigurationRecord: No PPS`);\n    }\n    else if (numOfPPS > 0) {\n        if (numOfPPS > 1) {\n            logger.warn(`Flv: Strange AVCDecoderConfigurationRecord: PPS Count = ${numOfPPS}`);\n        }\n        pos++;\n        for (let i = 0; i < numOfPPS; i++) {\n            let ppsDataLength = (data[pos] << 8) | data[pos + 1];\n            pos += 2;\n            ppsNalus.push(data.subarray(pos, pos + ppsDataLength));\n            pos += ppsDataLength;\n        }\n    }\n    return {\n        version,\n        profile,\n        profileCompatibility,\n        level,\n        naluSizeLength,\n        spsNalus,\n        ppsNalus\n    };\n}\nconst avcCodec = new AVCCodec();\nconst naluList_ = [];\navcCodec.on('nalu', (nalu) => {\n    naluList_.push(nalu);\n});\n/**\n * @extends DataViewReader\n */\nclass AVCVideoPacket extends DataViewReader {\n    /**\n     * @param buffer\n     */\n    constructor(pipeCtx, buffer, timestamp) {\n        super();\n        const { flv, options } = pipeCtx;\n        this.avcPacketType = buffer[0];\n        if (this.avcPacketType === 1) {\n            let cts_uint32 = this.readUint32(buffer, 0) & 0x00ffffff;\n            this.cts = (cts_uint32 << 8) >> 8; // convert to 24-bit signed int\n        }\n        else {\n            this.cts = 0;\n        }\n        this.dts = timestamp;\n        this.pts = this.dts + this.cts;\n        this.payload = buffer.subarray(4);\n        if (this.avcPacketType === 0) {\n            this.decoderConfigurationRecord = parseAVCDecoderConfigurationRecord(this.payload);\n            flv.decoderConfigurationRecord = this.decoderConfigurationRecord;\n        }\n        else {\n            if (options.decodeCodec) {\n                this.naluList = [];\n                let raw = {\n                    pts: this.pts,\n                    dts: this.dts,\n                    payload: this.payload\n                };\n                if (!this.decoderConfigurationRecord) {\n                    if (flv.decoderConfigurationRecord) {\n                        raw.naluSizeLength = flv.decoderConfigurationRecord.naluSizeLength;\n                    }\n                    avcCodec.push(raw);\n                    // Clone nalu to videoData\n                    for (let i = 0; i < naluList_.length; i++) {\n                        this.naluList.push(naluList_[i]);\n                    }\n                    // empty cache\n                    naluList_.splice(0, naluList_.length);\n                }\n            }\n        }\n    }\n}\n\n/**\n * @file: tag.js, created at Monday, 23rd December 2019 3:47:23 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n// If CodecID == 2 H263VIDEOPACKET\n// If CodecID == 3 SCREENVIDEOPACKET\n// If CodecID == 4 VP6FLVVIDEOPACKET\n// If CodecID == 5 VP6FLVALPHAVIDEOPACKET\n// If CodecID == 6 SCREENV2VIDEOPACKET\n// if CodecID == 7 AVCVIDEOPACKET\n// Video frame payload or UI8 (see note following table)\nvar VideoCodecIDs;\n(function (VideoCodecIDs) {\n    VideoCodecIDs[VideoCodecIDs[\"AVC\"] = 7] = \"AVC\"; // AVC_VIDEO_PACKET\n})(VideoCodecIDs || (VideoCodecIDs = {}));\n/**\n * @extends DataViewReader\n */\nclass FlvTagVideoData extends DataViewReader {\n    /**\n     * @param buffer\n     */\n    constructor(pipeCtx, buffer, timestamp) {\n        super();\n        this.frameType = (buffer[0] >> 4) & 0x0f;\n        this.isKeyframe = this.frameType === 1;\n        this.codecId = buffer[0] & 0x0f;\n        switch (this.codecId) {\n            case VideoCodecIDs.AVC:\n                this.videoData = new AVCVideoPacket(pipeCtx, buffer.subarray(1), timestamp);\n                break;\n            default:\n                logger.error(`flv tag videoData encounter unknown codecId ${this.codecId}`);\n        }\n    }\n}\n\n/**\n * @file: created at Saturday, 9th May 2020 3:49:22 pm\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\nclass TagsStream extends Stream {\n    constructor(ctx, flv, options = {}) {\n        super();\n        this.flv_ = flv;\n        this.options_ = options;\n        this.pipeCtx = {\n            ctx,\n            flv,\n            options\n        };\n    }\n    push(tag) {\n        switch (tag.tagType) {\n            case FlvTagTypes$1.SCRIPT_DATA:\n                this.parseScriptData_(tag.payload);\n                break;\n            case FlvTagTypes$1.VIDEO:\n                this.parseVideoData_(tag);\n                break;\n            case FlvTagTypes$1.AUDIO:\n                this.parseAudioData_(tag);\n                break;\n            default:\n                logger.error(`still not supported flv tag type ${tag.tagType}`);\n        }\n    }\n    flush() {\n        const self = this;\n        self.emit('done');\n    }\n    reset() {\n        this.emit('reset');\n    }\n    parseScriptData_(buffer) {\n        const { flv_ } = this;\n        let result = AMFdeSerialize(buffer);\n        flv_.emit('data', {\n            type: 'tag',\n            tagType: FlvTagTypes$1.SCRIPT_DATA,\n            ...result\n        });\n    }\n    parseVideoData_(tag) {\n        const { flv_ } = this;\n        const data = new FlvTagVideoData(this.pipeCtx, tag.payload, tag.timestamp);\n        let ret = {\n            type: 'tag',\n            tagType: FlvTagTypes$1.VIDEO,\n            timestamp: tag.timestamp,\n            ...data\n        };\n        flv_.emit('data', ret);\n    }\n    parseAudioData_(tag) {\n        const { /*options_,*/ flv_ } = this;\n        const data = new FlvTagAudioData(tag.payload, tag.timestamp);\n        const { /*sampleSize,*/ soundData } = data;\n        if (soundData.audioSpecificConfig) {\n            flv_.audioSpecificConfig = soundData.audioSpecificConfig;\n        }\n        let ret = {\n            type: 'tag',\n            tagType: FlvTagTypes$1.AUDIO,\n            timestamp: tag.timestamp,\n            ...data\n        };\n        flv_.emit('data', ret);\n    }\n}\n\n/**\n * @file: created at Thursday, 14th May 2020 10:18:11 am\n * @copyright Copyright (c) 2020\n * @author gem <gems.xu@gmail.com>\n */\n/**\n * @extends DataViewReader\n */\nclass FlvHead extends DataViewReader {\n    /**\n     * @param buffer\n     */\n    constructor(buffer) {\n        super();\n        this.signature =\n            String.fromCharCode(buffer[0]) + // F\n                String.fromCharCode(buffer[1]) + // L\n                String.fromCharCode(buffer[2]); //V\n        this.version = buffer[3];\n        this.hasAudio = (buffer[4] & 4) >>> 2 == 1;\n        this.hasVideo = (buffer[4] & 1) == 1;\n        this.offset = this.readUint32(buffer, 5);\n    }\n    valid() {\n        return this.signature === 'FLV';\n    }\n}\n\n/**\n * flv demuxer.\n */\n/**\n * flv\n */\nclass FLVDemux extends DemuxFacade {\n    constructor(options = {}) {\n        super(options);\n        this.flv_ = new AVContext();\n        this.flv_.stage = FLVParseStage.HEAD;\n        // this. = 0;\n        this.body_ = new BodyStream(this.ctx_, this.flv_, options);\n        this.tags_ = new TagsStream(this.ctx_, this.flv_, options);\n        // Compose pipeline\n        this.pipe(this.body_);\n        this.body_.pipe(this.tags_);\n        super.listenEndStream_();\n    }\n    get endStream() {\n        return this.flv_;\n    }\n    /**\n     * @param buffer\n     * @param conf\n     * @param conf.offsetByte\n     */\n    push(buffer, conf = {}) {\n        const { options_, ctx_, flv_, cache_buffer_ } = this;\n        const data = super.constraintPushData_(buffer);\n        let cacheByteLength = this.cache_buffer_.byteLength;\n        logger.log(`flv demux received ${data.byteLength} bytes, cache ${cacheByteLength} bytes.`);\n        options_.config = conf;\n        if (isNumber(conf.offsetPos)) {\n            if (cacheByteLength === 0) {\n                if (flv_.pos !== conf.offsetPos) {\n                    ctx_.emit('error', muxErrorCode.FLV_NOT_EXPECTED_ADJACENT_DATA);\n                }\n                flv_.pos = conf.offsetPos;\n            }\n        }\n        cache_buffer_.append(data);\n        // if file byteOffset is provided, then specify the stage of parser.\n        if (flv_.pos < HEAD_LEN) {\n            flv_.stage === FLVParseStage.HEAD;\n        }\n        else {\n            flv_.stage === FLVParseStage.BODY;\n        }\n        while (true) {\n            if (flv_.stage === FLVParseStage.HEAD) {\n                if (cache_buffer_.byteLength >= HEAD_LEN) {\n                    // has enough header\n                    let chunk = cache_buffer_.cut(HEAD_LEN);\n                    let head = new FlvHead(chunk);\n                    if (head.valid()) {\n                        flv_.emit('data', {\n                            type: 'head',\n                            signature: head.signature,\n                            version: head.version,\n                            hasAudio: head.hasAudio,\n                            hasVideo: head.hasVideo,\n                            offset: head.offset\n                        });\n                        // Change parse state -> body\n                        flv_.stage = FLVParseStage.BODY;\n                        flv_.pos = HEAD_LEN;\n                    }\n                    else {\n                        ctx_.emit('error', muxErrorCode.FLV_HEAD_SIGNATURE);\n                        break;\n                    }\n                }\n                else {\n                    break;\n                }\n            }\n            else if (flv_.stage === FLVParseStage.BODY) {\n                // At least has 4 body byte to parse\n                if (cache_buffer_.byteLength >= MIN_BODY_LEN) {\n                    let cbLen = cache_buffer_.byteLength;\n                    let nextBytes = cache_buffer_.bytes;\n                    cache_buffer_.clear();\n                    if (nextBytes) {\n                        this.emit('data', nextBytes);\n                    }\n                    flv_.pos += cbLen;\n                }\n                break;\n            }\n        }\n    }\n}\n\n\n\n\n//# sourceURL=webpack://H265Player/../node_modules/demuxer/dist/demuxer.all.esm.js?");/***/},,/* 22 *//* 23 *//***/function(module,exports,__webpack_require__){eval("var isNativeReflectConstruct = __webpack_require__(87);\nvar setPrototypeOf = __webpack_require__(46);\nfunction _construct(t, e, r) {\n  if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);\n  var o = [null];\n  o.push.apply(o, e);\n  var p = new (t.bind.apply(t, o))();\n  return r && setPrototypeOf(p, r.prototype), p;\n}\nmodule.exports = _construct, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/construct.js?");/***/},/* 24 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";eval("/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"a\", function() { return throwError; });\n/* unused harmony export ThrowError */\n/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);\n/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);\n/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);\n/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _config_Config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);\n\n\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file ThrowError.js\r\n * @desc\r\n * display error with throw\r\n * @author Jarry\r\n */\n\n\nvar ERROR_TYPE = {\n  eval: EvalError,\n  range: RangeError,\n  reference: ReferenceError,\n  syntax: SyntaxError,\n  type: TypeError,\n  uri: URIError,\n  default: Error\n};\nvar ThrowError = /*#__PURE__*/function () {\n  function ThrowError() {\n    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';\n    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1001;\n    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ThrowError);\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"type\", '');\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"errorName\", 'DefaultError');\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"code\", null);\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"message\", '');\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"stack\", '');\n    this.type = type;\n    this.code = code;\n    return this.throws.bind(this);\n  }\n  /**\r\n   * throw error by type\r\n   * @param {Error|string} e | message\r\n   * @param  {...any} args \r\n   */\n  return _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ThrowError, [{\n    key: \"throws\",\n    value: function throws(e) {\n      var message = '';\n      var Instance = Error;\n      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n        args[_key - 1] = arguments[_key];\n      }\n      if (e instanceof Error) {\n        for (var type in ERROR_TYPE) {\n          if (e instanceof ERROR_TYPE[type]) {\n            this.errorName = ERROR_TYPE[type].name;\n            Instance = e.constructor;\n            break;\n          }\n        }\n        this.stack = e.stack;\n        if (args && args.splice) {\n          message = args[0];\n          args.splice(0, 1);\n        }\n      } else {\n        message = e.toString();\n      }\n      this.message = \"[\".concat(_config_Config_js__WEBPACK_IMPORTED_MODULE_3__[/* Config */ \"c\"].projectName, \" ERROR:\") + this.type + \"-\" + this.code + \"]\" + message;\n      try {\n        throw new Instance(this.message, '[args]:', args);\n      } catch (e) {\n        this.stack = this.stack || e.stack;\n        console.error(e, '[message]:', message, '[args]:', args);\n      }\n    }\n  }]);\n}();\nvar instance = null;\nvar throwError = function () {\n  if (!instance) {\n    instance = new ThrowError();\n  }\n  return instance;\n}();\n\n\n//# sourceURL=webpack://H265Player/../src/error/ThrowError.js?");/***/},,,/* 25 *//* 26 *//* 27 *//***/function(module,exports){eval("function asyncGeneratorStep(n, t, e, r, o, a, c) {\n  try {\n    var i = n[a](c),\n      u = i.value;\n  } catch (n) {\n    return void e(n);\n  }\n  i.done ? t(u) : Promise.resolve(u).then(r, o);\n}\nfunction _asyncToGenerator(n) {\n  return function () {\n    var t = this,\n      e = arguments;\n    return new Promise(function (r, o) {\n      var a = n.apply(t, e);\n      function _next(n) {\n        asyncGeneratorStep(a, r, o, _next, _throw, \"next\", n);\n      }\n      function _throw(n) {\n        asyncGeneratorStep(a, r, o, _next, _throw, \"throw\", n);\n      }\n      _next(void 0);\n    });\n  };\n}\nmodule.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/asyncToGenerator.js?");/***/},,,,,/* 28 *//* 29 *//* 30 *//* 31 *//* 32 *//***/function(module,exports,__webpack_require__){eval("var getPrototypeOf = __webpack_require__(1);\nvar setPrototypeOf = __webpack_require__(46);\nvar isNativeFunction = __webpack_require__(88);\nvar construct = __webpack_require__(23);\nfunction _wrapNativeSuper(t) {\n  var r = \"function\" == typeof Map ? new Map() : void 0;\n  return (module.exports = _wrapNativeSuper = function _wrapNativeSuper(t) {\n    if (null === t || !isNativeFunction(t)) return t;\n    if (\"function\" != typeof t) throw new TypeError(\"Super expression must either be null or a function\");\n    if (void 0 !== r) {\n      if (r.has(t)) return r.get(t);\n      r.set(t, Wrapper);\n    }\n    function Wrapper() {\n      return construct(t, arguments, getPrototypeOf(this).constructor);\n    }\n    return Wrapper.prototype = Object.create(t.prototype, {\n      constructor: {\n        value: Wrapper,\n        enumerable: !1,\n        writable: !0,\n        configurable: !0\n      }\n    }), setPrototypeOf(Wrapper, t);\n  }, module.exports.__esModule = true, module.exports[\"default\"] = module.exports), _wrapNativeSuper(t);\n}\nmodule.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/wrapNativeSuper.js?");/***/},,,,,,,,,,/* 33 *//* 34 *//* 35 *//* 36 *//* 37 *//* 38 *//* 39 *//* 40 *//* 41 *//* 42 *//***/function(module,exports,__webpack_require__){eval("function webpackBootstrapFunc (modules) {\n/******/  // The module cache\n/******/  var installedModules = {};\n\n/******/  // The require function\n/******/  function __webpack_require__(moduleId) {\n\n/******/    // Check if module is in cache\n/******/    if(installedModules[moduleId])\n/******/      return installedModules[moduleId].exports;\n\n/******/    // Create a new module (and put it into the cache)\n/******/    var module = installedModules[moduleId] = {\n/******/      i: moduleId,\n/******/      l: false,\n/******/      exports: {}\n/******/    };\n\n/******/    // Execute the module function\n/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);\n\n/******/    // Flag the module as loaded\n/******/    module.l = true;\n\n/******/    // Return the exports of the module\n/******/    return module.exports;\n/******/  }\n\n/******/  // expose the modules object (__webpack_modules__)\n/******/  __webpack_require__.m = modules;\n\n/******/  // expose the module cache\n/******/  __webpack_require__.c = installedModules;\n\n/******/  // identity function for calling harmony imports with the correct context\n/******/  __webpack_require__.i = function(value) { return value; };\n\n/******/  // define getter function for harmony exports\n/******/  __webpack_require__.d = function(exports, name, getter) {\n/******/    if(!__webpack_require__.o(exports, name)) {\n/******/      Object.defineProperty(exports, name, {\n/******/        configurable: false,\n/******/        enumerable: true,\n/******/        get: getter\n/******/      });\n/******/    }\n/******/  };\n\n/******/  // define __esModule on exports\n/******/  __webpack_require__.r = function(exports) {\n/******/    Object.defineProperty(exports, '__esModule', { value: true });\n/******/  };\n\n/******/  // getDefaultExport function for compatibility with non-harmony modules\n/******/  __webpack_require__.n = function(module) {\n/******/    var getter = module && module.__esModule ?\n/******/      function getDefault() { return module['default']; } :\n/******/      function getModuleExports() { return module; };\n/******/    __webpack_require__.d(getter, 'a', getter);\n/******/    return getter;\n/******/  };\n\n/******/  // Object.prototype.hasOwnProperty.call\n/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };\n\n/******/  // __webpack_public_path__\n/******/  __webpack_require__.p = \"/\";\n\n/******/  // on error function for async loading\n/******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };\n\n  var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE)\n  return f.default || f // try to call default if defined to also support babel esmodule exports\n}\n\nvar moduleNameReqExp = '[\\\\.|\\\\-|\\\\+|\\\\w|\\/|@]+'\nvar dependencyRegExp = '\\\\(\\\\s*(\\/\\\\*.*?\\\\*\\/)?\\\\s*.*?(' + moduleNameReqExp + ').*?\\\\)' // additional chars when output.pathinfo is true\n\n// http://stackoverflow.com/a/2593661/130442\nfunction quoteRegExp (str) {\n  return (str + '').replace(/[.?*+^$[\\]\\\\(){}|-]/g, '\\\\$&')\n}\n\nfunction isNumeric(n) {\n  return !isNaN(1 * n); // 1 * n converts integers, integers as string (\"123\"), 1e3 and \"1e3\" to integers and strings to NaN\n}\n\nfunction getModuleDependencies (sources, module, queueName) {\n  var retval = {}\n  retval[queueName] = []\n\n  var fnString = module.toString()\n  var wrapperSignature = fnString.match(/^function\\s?\\w*\\(\\w+,\\s*\\w+,\\s*(\\w+)\\)/)\n  if (!wrapperSignature) return retval\n  var webpackRequireName = wrapperSignature[1]\n\n  // main bundle deps\n  var re = new RegExp('(\\\\\\\\n|\\\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g')\n  var match\n  while ((match = re.exec(fnString))) {\n    if (match[3] === 'dll-reference') continue\n    retval[queueName].push(match[3])\n  }\n\n  // dll deps\n  re = new RegExp('\\\\(' + quoteRegExp(webpackRequireName) + '\\\\(\"(dll-reference\\\\s(' + moduleNameReqExp + '))\"\\\\)\\\\)' + dependencyRegExp, 'g')\n  while ((match = re.exec(fnString))) {\n    if (!sources[match[2]]) {\n      retval[queueName].push(match[1])\n      sources[match[2]] = __webpack_require__(match[1]).m\n    }\n    retval[match[2]] = retval[match[2]] || []\n    retval[match[2]].push(match[4])\n  }\n\n  // convert 1e3 back to 1000 - this can be important after uglify-js converted 1000 to 1e3\n  var keys = Object.keys(retval);\n  for (var i = 0; i < keys.length; i++) {\n    for (var j = 0; j < retval[keys[i]].length; j++) {\n      if (isNumeric(retval[keys[i]][j])) {\n        retval[keys[i]][j] = 1 * retval[keys[i]][j];\n      }\n    }\n  }\n\n  return retval\n}\n\nfunction hasValuesInQueues (queues) {\n  var keys = Object.keys(queues)\n  return keys.reduce(function (hasValues, key) {\n    return hasValues || queues[key].length > 0\n  }, false)\n}\n\nfunction getRequiredModules (sources, moduleId) {\n  var modulesQueue = {\n    main: [moduleId]\n  }\n  var requiredModules = {\n    main: []\n  }\n  var seenModules = {\n    main: {}\n  }\n\n  while (hasValuesInQueues(modulesQueue)) {\n    var queues = Object.keys(modulesQueue)\n    for (var i = 0; i < queues.length; i++) {\n      var queueName = queues[i]\n      var queue = modulesQueue[queueName]\n      var moduleToCheck = queue.pop()\n      seenModules[queueName] = seenModules[queueName] || {}\n      if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue\n      seenModules[queueName][moduleToCheck] = true\n      requiredModules[queueName] = requiredModules[queueName] || []\n      requiredModules[queueName].push(moduleToCheck)\n      var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName)\n      var newModulesKeys = Object.keys(newModules)\n      for (var j = 0; j < newModulesKeys.length; j++) {\n        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || []\n        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]])\n      }\n    }\n  }\n\n  return requiredModules\n}\n\nmodule.exports = function (moduleId, options) {\n  options = options || {}\n  var sources = {\n    main: __webpack_require__.m\n  }\n\n  var requiredModules = options.all ? { main: Object.keys(sources.main) } : getRequiredModules(sources, moduleId)\n\n  var src = ''\n\n  Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {\n    var entryModule = 0\n    while (requiredModules[module][entryModule]) {\n      entryModule++\n    }\n    requiredModules[module].push(entryModule)\n    sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'\n    src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\\n'\n  })\n\n  src = src + 'new ((' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '}))(self);'\n\n  var blob = new window.Blob([src], { type: 'text/javascript' })\n  if (options.bare) { return blob }\n\n  var URL = window.URL || window.webkitURL || window.mozURL || window.msURL\n\n  var workerUrl = URL.createObjectURL(blob)\n  var worker = new window.Worker(workerUrl)\n  worker.objectURL = workerUrl\n\n  return worker\n}\n\n\n//# sourceURL=webpack://H265Player/../node_modules/webworkify-webpack/index.js?");/***/},/* 43 *//***/function(module,exports,__webpack_require__){eval("var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {\n  if (true) {\n    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),\n\t\t\t\t__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?\n\t\t\t\t(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),\n\t\t\t\t__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));\n  } else {}\n}(this, function() {\n/**\n * Global dependencies.\n * @global {Object} document - DOM\n */\n\nvar devnull = function() {},\n    bundleIdCache = {},\n    bundleResultCache = {},\n    bundleCallbackQueue = {};\n\n\n/**\n * Subscribe to bundle load event.\n * @param {string[]} bundleIds - Bundle ids\n * @param {Function} callbackFn - The callback function\n */\nfunction subscribe(bundleIds, callbackFn) {\n  // listify\n  bundleIds = bundleIds.push ? bundleIds : [bundleIds];\n\n  var depsNotFound = [],\n      i = bundleIds.length,\n      numWaiting = i,\n      fn,\n      bundleId,\n      r,\n      q;\n\n  // define callback function\n  fn = function (bundleId, pathsNotFound) {\n    if (pathsNotFound.length) depsNotFound.push(bundleId);\n\n    numWaiting--;\n    if (!numWaiting) callbackFn(depsNotFound);\n  };\n\n  // register callback\n  while (i--) {\n    bundleId = bundleIds[i];\n\n    // execute callback if in result cache\n    r = bundleResultCache[bundleId];\n    if (r) {\n      fn(bundleId, r);\n      continue;\n    }\n\n    // add to callback queue\n    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];\n    q.push(fn);\n  }\n}\n\n\n/**\n * Publish bundle load event.\n * @param {string} bundleId - Bundle id\n * @param {string[]} pathsNotFound - List of files not found\n */\nfunction publish(bundleId, pathsNotFound) {\n  // exit if id isn't defined\n  if (!bundleId) return;\n\n  var q = bundleCallbackQueue[bundleId];\n\n  // cache result\n  bundleResultCache[bundleId] = pathsNotFound;\n\n  // exit if queue is empty\n  if (!q) return;\n\n  // empty callback queue\n  while (q.length) {\n    q[0](bundleId, pathsNotFound);\n    q.splice(0, 1);\n  }\n}\n\n\n/**\n * Execute callbacks.\n * @param {Object or Function} args - The callback args\n * @param {string[]} depsNotFound - List of dependencies not found\n */\nfunction executeCallbacks(args, depsNotFound) {\n  // accept function as argument\n  if (args.call) args = {success: args};\n\n  // success and error callbacks\n  if (depsNotFound.length) (args.error || devnull)(depsNotFound);\n  else (args.success || devnull)(args);\n}\n\n\n/**\n * Load individual file.\n * @param {string} path - The file path\n * @param {Function} callbackFn - The callback function\n */\nfunction loadFile(path, callbackFn, args, numTries) {\n  var doc = document,\n      async = args.async,\n      maxTries = (args.numRetries || 0) + 1,\n      beforeCallbackFn = args.before || devnull,\n      pathname = path.replace(/[\\?|#].*$/, ''),\n      pathStripped = path.replace(/^(css|img|module|nomodule)!/, ''),\n      isLegacyIECss,\n      hasModuleSupport,\n      e;\n\n  numTries = numTries || 0;\n\n  if (/(^css!|\\.css$)/.test(pathname)) {\n    // css\n    e = doc.createElement('link');\n    e.rel = 'stylesheet';\n    e.href = pathStripped;\n\n    // tag IE9+\n    isLegacyIECss = 'hideFocus' in e;\n\n    // use preload in IE Edge (to detect load errors)\n    if (isLegacyIECss && e.relList) {\n      isLegacyIECss = 0;\n      e.rel = 'preload';\n      e.as = 'style';\n    }\n  } else if (/(^img!|\\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {\n    // image\n    e = doc.createElement('img');\n    e.src = pathStripped;    \n  } else {\n    // javascript\n    e = doc.createElement('script');\n    e.src = pathStripped;\n    e.async = async === undefined ? true : async;\n\n    // handle es modules\n    // modern browsers:\n    //   module: add to dom with type=\"module\"\n    //   nomodule: call success() callback without adding to dom\n    // legacy browsers:\n    //   module: call success() callback without adding to dom\n    //   nomodule: add to dom with default type (\"text/javascript\")\n    hasModuleSupport = 'noModule' in e;\n    if (/^module!/.test(pathname)) {\n      if (!hasModuleSupport) return callbackFn(path, 'l');\n      e.type = \"module\";\n    } else if (/^nomodule!/.test(pathname) && hasModuleSupport) return callbackFn(path, 'l');\n  }\n\n  e.onload = e.onerror = e.onbeforeload = function (ev) {\n    var result = ev.type[0];\n\n    // treat empty stylesheets as failures to get around lack of onerror\n    // support in IE9-11\n    if (isLegacyIECss) {\n      try {\n        if (!e.sheet.cssText.length) result = 'e';\n      } catch (x) {\n        // sheets objects created from load errors don't allow access to\n        // `cssText` (unless error is Code:18 SecurityError)\n        if (x.code != 18) result = 'e';\n      }\n    }\n\n    // handle retries in case of load failure\n    if (result == 'e') {\n      // increment counter\n      numTries += 1;\n\n      // exit function and try again\n      if (numTries < maxTries) {\n        return loadFile(path, callbackFn, args, numTries);\n      }\n    } else if (e.rel == 'preload' && e.as == 'style') {\n      // activate preloaded stylesheets\n      return e.rel = 'stylesheet'; // jshint ignore:line\n    }\n    \n    // execute callback\n    callbackFn(path, result, ev.defaultPrevented);\n  };\n\n  // add to document (unless callback returns `false`)\n  if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);\n}\n\n\n/**\n * Load multiple files.\n * @param {string[]} paths - The file paths\n * @param {Function} callbackFn - The callback function\n */\nfunction loadFiles(paths, callbackFn, args) {\n  // listify paths\n  paths = paths.push ? paths : [paths];\n\n  var numWaiting = paths.length,\n      x = numWaiting,\n      pathsNotFound = [],\n      fn,\n      i;\n\n  // define callback function\n  fn = function(path, result, defaultPrevented) {\n    // handle error\n    if (result == 'e') pathsNotFound.push(path);\n\n    // handle beforeload event. If defaultPrevented then that means the load\n    // will be blocked (ex. Ghostery/ABP on Safari)\n    if (result == 'b') {\n      if (defaultPrevented) pathsNotFound.push(path);\n      else return;\n    }\n\n    numWaiting--;\n    if (!numWaiting) callbackFn(pathsNotFound);\n  };\n\n  // load scripts\n  for (i=0; i < x; i++) loadFile(paths[i], fn, args);\n}\n\n\n/**\n * Initiate script load and register bundle.\n * @param {(string|string[])} paths - The file paths\n * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success\n *   callback or (3) object literal with success/error arguments, numRetries,\n *   etc.\n * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object\n *   literal with success/error arguments, numRetries, etc.\n */\nfunction loadjs(paths, arg1, arg2) {\n  var bundleId,\n      args;\n\n  // bundleId (if string)\n  if (arg1 && arg1.trim) bundleId = arg1;\n\n  // args (default is {})\n  args = (bundleId ? arg2 : arg1) || {};\n\n  // throw error if bundle is already defined\n  if (bundleId) {\n    if (bundleId in bundleIdCache) {\n      throw \"LoadJS\";\n    } else {\n      bundleIdCache[bundleId] = true;\n    }\n  }\n\n  function loadFn(resolve, reject) {\n    loadFiles(paths, function (pathsNotFound) {\n      // execute callbacks\n      executeCallbacks(args, pathsNotFound);\n      \n      // resolve Promise\n      if (resolve) {\n        executeCallbacks({success: resolve, error: reject}, pathsNotFound);\n      }\n\n      // publish bundle load event\n      publish(bundleId, pathsNotFound);\n    }, args);\n  }\n  \n  if (args.returnPromise) return new Promise(loadFn);\n  else loadFn();\n}\n\n\n/**\n * Execute callbacks when dependencies have been satisfied.\n * @param {(string|string[])} deps - List of bundle ids\n * @param {Object} args - success/error arguments\n */\nloadjs.ready = function ready(deps, args) {\n  // subscribe to bundle load event\n  subscribe(deps, function (depsNotFound) {\n    // execute callbacks\n    executeCallbacks(args, depsNotFound);\n  });\n\n  return loadjs;\n};\n\n\n/**\n * Manually satisfy bundle dependencies.\n * @param {string} bundleId - The bundle id\n */\nloadjs.done = function done(bundleId) {\n  publish(bundleId, []);\n};\n\n\n/**\n * Reset loadjs dependencies statuses\n */\nloadjs.reset = function reset() {\n  bundleIdCache = {};\n  bundleResultCache = {};\n  bundleCallbackQueue = {};\n};\n\n\n/**\n * Determine if bundle has already been defined\n * @param String} bundleId - The bundle id\n */\nloadjs.isDefined = function isDefined(bundleId) {\n  return bundleId in bundleIdCache;\n};\n\n\n// export\nreturn loadjs;\n\n}));\n\n\n//# sourceURL=webpack://H265Player/../node_modules/loadjs/dist/loadjs.umd.js?");/***/},,,/* 44 *//* 45 *//* 46 *//***/function(module,exports){eval("function _setPrototypeOf(t, e) {\n  return (module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {\n    return t.__proto__ = e, t;\n  }, module.exports.__esModule = true, module.exports[\"default\"] = module.exports), _setPrototypeOf(t, e);\n}\nmodule.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/setPrototypeOf.js?");/***/},/* 47 *//***/function(module,exports){eval("(function() {\n  \"use strict\";\n\n  /**\n   * Create a YUVCanvas and attach it to an HTML5 canvas element.\n   *\n   * This will take over the drawing context of the canvas and may turn\n   * it into a WebGL 3d canvas if possible. Do not attempt to use the\n   * drawing context directly after this.\n   *\n   * @param {HTMLCanvasElement} canvas - HTML canvas element to attach to\n   * @param {YUVCanvasOptions} options - map of options\n   * @throws exception if WebGL requested but unavailable\n   * @constructor\n   * @abstract\n   */\n  function FrameSink(canvas, options) {\n    throw new Error('abstract');\n  }\n\n  /**\n   * Draw a single YUV frame on the underlying canvas, converting to RGB.\n   * If necessary the canvas will be resized to the optimal pixel size\n   * for the given buffer's format.\n   *\n   * @param {YUVBuffer} buffer - the YUV buffer to draw\n   * @see {@link https://www.npmjs.com/package/yuv-buffer|yuv-buffer} for format\n   */\n  FrameSink.prototype.drawFrame = function(buffer) {\n    throw new Error('abstract');\n  };\n\n  /**\n   * Clear the canvas using appropriate underlying 2d or 3d context.\n   */\n  FrameSink.prototype.clear = function() {\n    throw new Error('abstract');\n  };\n\n  module.exports = FrameSink;\n\n})();\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-canvas/src/FrameSink.js?");/***/},,,,,,,,,,,/* 48 *//* 49 *//* 50 *//* 51 *//* 52 *//* 53 *//* 54 *//* 55 *//* 56 *//* 57 *//* 58 *//***/function(module,exports){eval("/*\nCopyright (c) 2014-2016 Brion Vibber <brion@pobox.com>\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of\nthis software and associated documentation files (the \"Software\"), to deal in\nthe Software without restriction, including without limitation the rights to\nuse, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\nthe Software, and to permit persons to whom the Software is furnished to do so,\nsubject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\nFOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\nCOPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\nIN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\nONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n*/\n\n/**\n * Represents metadata about a YUV frame format.\n * @typedef {Object} YUVFormat\n * @property {number} width - width of encoded frame in luma pixels\n * @property {number} height - height of encoded frame in luma pixels\n * @property {number} chromaWidth - width of encoded frame in chroma pixels\n * @property {number} chromaHeight - height of encoded frame in chroma pixels\n * @property {number} cropLeft - upper-left X coordinate of visible crop region, in luma pixels\n * @property {number} cropTop - upper-left Y coordinate of visible crop region, in luma pixels\n * @property {number} cropWidth - width of visible crop region, in luma pixels\n * @property {number} cropHeight - height of visible crop region, in luma pixels\n * @property {number} displayWidth - final display width of visible region, in luma pixels\n * @property {number} displayHeight - final display height of visible region, in luma pixels\n */\n\n/**\n * Represents underlying image data for a single luma or chroma plane.\n * Cannot be interpreted without the format data from a frame buffer.\n * @typedef {Object} YUVPlane\n * @property {Uint8Array} bytes - typed array containing image data bytes\n * @property {number} stride - byte distance between rows in data\n */\n\n/**\n * Represents a YUV image frame buffer, with enough format information\n * to interpret the data usefully. Buffer objects use generic objects\n * under the hood and can be transferred between worker threads using\n * the structured clone algorithm.\n *\n * @typedef {Object} YUVFrame\n * @property {YUVFormat} format\n * @property {YUVPlane} y\n * @property {YUVPlane} u\n * @property {YUVPlane} v\n */\n\n/**\n * Holder namespace for utility functions and constants related to\n * YUV frame and plane buffers.\n *\n * @namespace\n */\nvar YUVBuffer = {\n  /**\n   * Validate a plane dimension\n   * @param {number} dim - vertical or horizontal dimension\n   * @throws exception on zero, negative, or non-integer value\n   */\n  validateDimension: function(dim) {\n    if (dim <= 0 || dim !== (dim | 0)) {\n      throw 'YUV plane dimensions must be a positive integer';\n    }\n  },\n\n  /**\n   * Validate a plane offset\n   * @param {number} dim - vertical or horizontal dimension\n   * @throws exception on negative or non-integer value\n   */\n  validateOffset: function(dim) {\n    if (dim < 0 || dim !== (dim | 0)) {\n      throw 'YUV plane offsets must be a non-negative integer';\n    }\n  },\n\n  /**\n   * Validate and fill out a YUVFormat object structure.\n   *\n   * At least width and height fields are required; other fields will be\n   * derived if left missing or empty:\n   * - chromaWidth and chromaHeight will be copied from width and height as for a 4:4:4 layout\n   * - cropLeft and cropTop will be 0\n   * - cropWidth and cropHeight will be set to whatever of the frame is visible after cropTop and cropLeft are applied\n   * - displayWidth and displayHeight will be set to cropWidth and cropHeight.\n   *\n   * @param {YUVFormat} fields - input fields, must include width and height.\n   * @returns {YUVFormat} - validated structure, with all derivable fields filled out.\n   * @throws exception on invalid fields or missing width/height\n   */\n  format: function(fields) {\n    var width = fields.width,\n      height = fields.height,\n      chromaWidth = fields.chromaWidth || width,\n      chromaHeight = fields.chromaHeight || height,\n      cropLeft = fields.cropLeft || 0,\n      cropTop = fields.cropTop || 0,\n      cropWidth = fields.cropWidth || width - cropLeft,\n      cropHeight = fields.cropHeight || height - cropTop,\n      displayWidth = fields.displayWidth || cropWidth,\n      displayHeight = fields.displayHeight || cropHeight;\n    this.validateDimension(width);\n    this.validateDimension(height);\n    this.validateDimension(chromaWidth);\n    this.validateDimension(chromaHeight);\n    this.validateOffset(cropLeft);\n    this.validateOffset(cropTop);\n    this.validateDimension(cropWidth);\n    this.validateDimension(cropHeight);\n    this.validateDimension(displayWidth);\n    this.validateDimension(displayHeight);\n    return {\n      width: width,\n      height: height,\n      chromaWidth: chromaWidth,\n      chromaHeight: chromaHeight,\n      cropLeft: cropLeft,\n      cropTop: cropTop,\n      cropWidth: cropWidth,\n      cropHeight: cropHeight,\n      displayWidth: displayWidth,\n      displayHeight: displayHeight\n    };\n  },\n\n  /**\n   * Allocate a new YUVPlane object of the given size.\n   * @param {number} stride - byte distance between rows\n   * @param {number} rows - number of rows to allocate\n   * @returns {YUVPlane} - freshly allocated planar buffer\n   */\n  allocPlane: function(stride, rows) {\n    YUVBuffer.validateDimension(stride);\n    YUVBuffer.validateDimension(rows);\n    return {\n      bytes: new Uint8Array(stride * rows),\n      stride: stride\n    }\n  },\n\n  /**\n   * Pick a suitable stride for a custom-allocated thingy\n   * @param {number} width - width in bytes\n   * @returns {number} - new width in bytes at least as large\n   * @throws exception on invalid input width\n   */\n  suitableStride: function(width) {\n    YUVBuffer.validateDimension(width);\n    var alignment = 4,\n      remainder = width % alignment;\n    if (remainder == 0) {\n      return width;\n    } else {\n      return width + (alignment - remainder);\n    }\n  },\n\n  /**\n   * Allocate or extract a YUVPlane object from given dimensions/source.\n   * @param {number} width - width in pixels\n   * @param {number} height - height in pixels\n   * @param {Uint8Array} source - input byte array; optional (will create empty buffer if missing)\n   * @param {number} stride - row length in bytes; optional (will create a default if missing)\n   * @param {number} offset - offset into source array to extract; optional (will start at 0 if missing)\n   * @returns {YUVPlane} - freshly allocated planar buffer\n   */\n  allocPlane: function(width, height, source, stride, offset) {\n    var size, bytes;\n\n    this.validateDimension(width);\n    this.validateDimension(height);\n\n    offset = offset || 0;\n\n    stride = stride || this.suitableStride(width);\n    this.validateDimension(stride);\n    if (stride < width) {\n      throw \"Invalid input stride for YUV plane; must be larger than width\";\n    }\n\n    size = stride * height;\n\n    if (source) {\n      if (source.length - offset < size) {\n        throw \"Invalid input buffer for YUV plane; must be large enough for stride times height\";\n      }\n      bytes = source.slice(offset, offset + size);\n    } else {\n      bytes = new Uint8Array(size);\n      stride = stride || this.suitableStride(width);\n    }\n\n    return {\n      bytes: bytes,\n      stride: stride\n    };\n  },\n\n  /**\n   * Allocate a new YUVPlane object big enough for a luma plane in the given format\n   * @param {YUVFormat} format - target frame format\n   * @param {Uint8Array} source - input byte array; optional (will create empty buffer if missing)\n   * @param {number} stride - row length in bytes; optional (will create a default if missing)\n   * @param {number} offset - offset into source array to extract; optional (will start at 0 if missing)\n   * @returns {YUVPlane} - freshly allocated planar buffer\n   */\n  lumaPlane: function(format, source, stride, offset) {\n    return this.allocPlane(format.width, format.height, source, stride, offset);\n  },\n\n  /**\n   * Allocate a new YUVPlane object big enough for a chroma plane in the given format,\n   * optionally copying data from an existing buffer.\n   *\n   * @param {YUVFormat} format - target frame format\n   * @param {Uint8Array} source - input byte array; optional (will create empty buffer if missing)\n   * @param {number} stride - row length in bytes; optional (will create a default if missing)\n   * @param {number} offset - offset into source array to extract; optional (will start at 0 if missing)\n   * @returns {YUVPlane} - freshly allocated planar buffer\n   */\n  chromaPlane: function(format, source, stride, offset) {\n    return this.allocPlane(format.chromaWidth, format.chromaHeight, source, stride, offset);\n  },\n\n  /**\n   * Allocate a new YUVFrame object big enough for the given format\n   * @param {YUVFormat} format - target frame format\n   * @param {YUVPlane} y - optional Y plane; if missing, fresh one will be allocated\n   * @param {YUVPlane} u - optional U plane; if missing, fresh one will be allocated\n   * @param {YUVPlane} v - optional V plane; if missing, fresh one will be allocated\n   * @returns {YUVFrame} - freshly allocated frame buffer\n   */\n  frame: function(format, y, u, v) {\n    y = y || this.lumaPlane(format);\n    u = u || this.chromaPlane(format);\n    v = v || this.chromaPlane(format);\n    return {\n      format: format,\n      y: y,\n      u: u,\n      v: v\n    }\n  },\n\n  /**\n   * Duplicate a plane using new buffer memory.\n   * @param {YUVPlane} plane - input plane to copy\n   * @returns {YUVPlane} - freshly allocated and filled planar buffer\n   */\n  copyPlane: function(plane) {\n    return {\n      bytes: plane.bytes.slice(),\n      stride: plane.stride\n    };\n  },\n\n  /**\n   * Duplicate a frame using new buffer memory.\n   * @param {YUVFrame} frame - input frame to copyFrame\n   * @returns {YUVFrame} - freshly allocated and filled frame buffer\n   */\n  copyFrame: function(frame) {\n    return {\n      format: frame.format,\n      y: this.copyPlane(frame.y),\n      u: this.copyPlane(frame.u),\n      v: this.copyPlane(frame.v)\n    }\n  },\n\n  /**\n   * List the backing buffers for the frame's planes for transfer between\n   * threads via Worker.postMessage.\n   * @param {YUVFrame} frame - input frame\n   * @returns {Array} - list of transferable objects\n   */\n  transferables: function(frame) {\n    return [frame.y.bytes.buffer, frame.u.bytes.buffer, frame.v.bytes.buffer];\n  }\n};\n\nmodule.exports = YUVBuffer;\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-buffer/yuv-buffer.js?");/***/},/* 59 *//***/function(module,exports,__webpack_require__){eval("var arrayWithHoles = __webpack_require__(96);\nvar iterableToArrayLimit = __webpack_require__(97);\nvar unsupportedIterableToArray = __webpack_require__(98);\nvar nonIterableRest = __webpack_require__(100);\nfunction _slicedToArray(r, e) {\n  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();\n}\nmodule.exports = _slicedToArray, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/slicedToArray.js?");/***/},,,,,,,/* 60 *//* 61 *//* 62 *//* 63 *//* 64 *//* 65 *//* 66 *//***/function(module,exports,__webpack_require__){eval("var _typeof = __webpack_require__(9)[\"default\"];\nvar toPrimitive = __webpack_require__(85);\nfunction toPropertyKey(t) {\n  var i = toPrimitive(t, \"string\");\n  return \"symbol\" == _typeof(i) ? i : i + \"\";\n}\nmodule.exports = toPropertyKey, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/toPropertyKey.js?");/***/},,,,,/* 67 *//* 68 *//* 69 *//* 70 *//* 71 *//***/function(module,exports,__webpack_require__){eval("/*\nCopyright (c) 2014-2016 Brion Vibber <brion@pobox.com>\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of\nthis software and associated documentation files (the \"Software\"), to deal in\nthe Software without restriction, including without limitation the rights to\nuse, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\nthe Software, and to permit persons to whom the Software is furnished to do so,\nsubject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\nFOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\nCOPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\nIN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\nCONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n*/\n(function() {\n  \"use strict\";\n\n  var FrameSink = __webpack_require__(47),\n    SoftwareFrameSink = __webpack_require__(90),\n    WebGLFrameSink = __webpack_require__(93);\n\n  /**\n   * @typedef {Object} YUVCanvasOptions\n   * @property {boolean} webGL - Whether to use WebGL to draw to the canvas and accelerate color space conversion. If left out, defaults to auto-detect.\n   */\n\n  var YUVCanvas = {\n    FrameSink: FrameSink,\n\n    SoftwareFrameSink: SoftwareFrameSink,\n\n    WebGLFrameSink: WebGLFrameSink,\n\n    /**\n     * Attach a suitable FrameSink instance to an HTML5 canvas element.\n     *\n     * This will take over the drawing context of the canvas and may turn\n     * it into a WebGL 3d canvas if possible. Do not attempt to use the\n     * drawing context directly after this.\n     *\n     * @param {HTMLCanvasElement} canvas - HTML canvas element to attach to\n     * @param {YUVCanvasOptions} options - map of options\n     * @returns {FrameSink} - instance of suitable subclass.\n     */\n    attach: function(canvas, options) {\n      options = options || {};\n      var webGL = ('webGL' in options) ? options.webGL : WebGLFrameSink.isAvailable();\n      if (webGL) {\n        return new WebGLFrameSink(canvas, options);\n      } else {\n        return new SoftwareFrameSink(canvas, options);\n      }\n    }\n  };\n\n  module.exports = YUVCanvas;\n})();\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-canvas/src/yuv-canvas.js?");/***/},,,,,,,,,,,,,/* 72 *//* 73 *//* 74 *//* 75 *//* 76 *//* 77 *//* 78 *//* 79 *//* 80 *//* 81 *//* 82 *//* 83 *//* 84 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";eval("// ESM COMPAT FLAG\n__webpack_require__.r(__webpack_exports__);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/classCallCheck.js\nvar classCallCheck = __webpack_require__(2);\nvar classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/createClass.js\nvar createClass = __webpack_require__(3);\nvar createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js\nvar possibleConstructorReturn = __webpack_require__(5);\nvar possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/getPrototypeOf.js\nvar getPrototypeOf = __webpack_require__(1);\nvar getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/inherits.js\nvar inherits = __webpack_require__(4);\nvar inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/defineProperty.js\nvar defineProperty = __webpack_require__(0);\nvar defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);\n\n// EXTERNAL MODULE: ../src/toolkit/Logger.js\nvar Logger = __webpack_require__(10);\n\n// CONCATENATED MODULE: ../src/toolkit/Events.js\n\n\n\nfunction _createForOfIteratorHelper(r, e) { var t = \"undefined\" != typeof Symbol && r[Symbol.iterator] || r[\"@@iterator\"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && \"number\" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError(\"Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.\"); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }\nfunction _unsupportedIterableToArray(r, a) { if (r) { if (\"string\" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return \"Object\" === t && r.constructor && (t = r.constructor.name), \"Map\" === t || \"Set\" === t ? Array.from(r) : \"Arguments\" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }\nfunction _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Events.js\r\n * @desc\r\n * events observer for invoking between classes object\r\n * @see\r\n * https://github.com/Olical/EventEmitter\r\n * @author Jarry\r\n */\n\nvar logger = Logger[\"a\" /* default */].get('Events.js');\nvar Events_Events = /*#__PURE__*/function () {\n  function Events(target) {\n    classCallCheck_default()(this, Events);\n    defineProperty_default()(this, \"eventsQueue\", {});\n    defineProperty_default()(this, \"target\", {});\n    defineProperty_default()(this, \"disallowRepeat\", false);\n    this.target = target;\n  }\n  return createClass_default()(Events, [{\n    key: \"add\",\n    value: function add() {\n      var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];\n      var fn = arguments.length > 1 ? arguments[1] : undefined;\n      var once = arguments.length > 2 ? arguments[2] : undefined;\n      var _iterator = _createForOfIteratorHelper(types),\n        _step;\n      try {\n        for (_iterator.s(); !(_step = _iterator.n()).done;) {\n          var type = _step.value;\n          this.on(type, fn, once);\n        }\n      } catch (err) {\n        _iterator.e(err);\n      } finally {\n        _iterator.f();\n      }\n    }\n  }, {\n    key: \"on\",\n    value: function on(type, fn, once) {\n      if (this.eventsQueue[type] === undefined) {\n        this.eventsQueue[type] = {\n          methods: [],\n          once: false\n        };\n      }\n      if (typeof fn !== 'function') {\n        logger.error('on', 'the argument is not function.', fn);\n        return;\n      }\n      // disallow repeat bind\n      if (this.disallowRepeat && this.eventsQueue[type]['methods'].includes(fn)) {\n        return;\n      }\n      this.eventsQueue[type].methods.push(fn);\n      if (once !== undefined) {\n        this.eventsQueue[type].once = once;\n      }\n      return this.target;\n    }\n  }, {\n    key: \"once\",\n    value: function once(type, fn) {\n      this.on(type, fn, true);\n    }\n    /**\r\n     * \r\n     * @param {string} type \r\n     * @param {Function} [fn] be removed function, default all\r\n     */\n  }, {\n    key: \"off\",\n    value: function off(type, fn) {\n      var event = this.eventsQueue[type];\n      if (!event) {\n        return;\n      }\n      var methods = event.methods;\n      if (!fn) {\n        delete this.eventsQueue[type];\n      } else {\n        var len = methods.length;\n        while (len--) {\n          if (methods[len] === fn) {\n            methods.splice(len, 1);\n          }\n        }\n      }\n      return this.target;\n    }\n  }, {\n    key: \"emit\",\n    value: function emit(type) {\n      var _this = this;\n      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n        args[_key - 1] = arguments[_key];\n      }\n      var event = this.eventsQueue[type];\n      if (!event) {\n        return;\n      }\n      var methods = event.methods;\n      methods.forEach(function (method) {\n        method.apply(_this.target, args);\n      });\n      // remove the event after first called\n      if (event.once) {\n        this.off(type);\n      }\n      return this.target;\n    }\n  }, {\n    key: \"clear\",\n    value: function clear(type) {\n      delete this.eventsQueue[type];\n    }\n  }, {\n    key: \"clearAll\",\n    value: function clearAll() {\n      this.eventsQueue = {};\n    }\n  }]);\n}();\nvar events = function events(obj) {\n  return new Events_Events(obj);\n};\nvar getEvents = function getEvents(obj) {\n  var instance = new Events_Events(obj);\n  /**\r\n   * @usage\r\n   * events(this).on('loaddata.run', () => {})\r\n   * events(this).off('audioData.execute', fn)\r\n   * @example\r\n    var a = {\r\n      name: 'a',\r\n      bind: function() {\r\n        events(this).on('a.run', this.run)\r\n      },\r\n      run: function() {\r\n      console.log('a.run:', this.name, arguments)\r\n      }\r\n    }\r\n    var b = {\r\n      name: 'b',\r\n      bind: function() {\r\n        events(this).on('b.run', () => {\r\n          console.log('b.run:on', this.name, arguments)\r\n          this.run()\r\n        })\r\n      },\r\n      run: function() {\r\n        console.log('b.run:', this.name, arguments)\r\n      }\r\n    }\r\n    a.bind() // on(a.run)\r\n    b.bind() // on(b.run)\r\n    events(a).emit('a.run') // emit a\r\n    events(b).emit('b.run') // emit b\r\n    events(a).off('a.run', a.run) // off a.run\r\n    events(a).emit('a.run')// off same function\r\n    events(b).off('b.run', () => {}) // off b.run\r\n    events(a).emit('b.run') // off different function\r\n   */\n  return function (obj) {\n    instance.target = obj;\n    return instance;\n  };\n};\n/* harmony default export */ var toolkit_Events = (getEvents);\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/typeof.js\nvar helpers_typeof = __webpack_require__(9);\nvar typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);\n\n// CONCATENATED MODULE: ../src/toolkit/Element.js\n\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: methods of operation dom \r\n * @author: liuliguo \r\n * @file: Element.js\r\n */\n\n\nvar Element_logger = Logger[\"a\" /* default */].get('Element.js');\nvar Element_Element = /*#__PURE__*/function () {\n  function Element() {\n    classCallCheck_default()(this, Element);\n  }\n  return createClass_default()(Element, null, [{\n    key: \"createEl\",\n    value: function createEl() {\n      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';\n      var options = arguments.length > 1 ? arguments[1] : undefined;\n      if (typeof tagName != 'string') {\n        Element_logger.error('please input element name');\n        return null;\n      }\n      var el = document.createElement(tagName, options);\n      return el;\n    }\n\n    /**\r\n     * \r\n     * @param {string} tagName \r\n     * @param {HTMLElement} [extendEle] \r\n     * @param {string} [extendEle] \r\n     */\n  }, {\n    key: \"registerElement\",\n    value: function registerElement(tagName) {\n      var extendEle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HTMLElement;\n      var extendName = arguments.length > 2 ? arguments[2] : undefined;\n      var el = document.registerElement(tagName, {\n        prototype: Object.create(extendEle.prototype),\n        extends: extendName\n      });\n      return el;\n    }\n  }, {\n    key: \"addEl\",\n    value: function addEl(el, parent) {\n      if (el && parent) {\n        try {\n          parent.appendChild(el);\n        } catch (error) {\n          Element_logger.error(error);\n        }\n      } else {}\n    }\n  }, {\n    key: \"removeEl\",\n    value: function removeEl(el) {\n      try {\n        var parent = el.parentNode;\n        if (parent) {\n          parent.removeChild(el);\n        }\n      } catch (error) {\n        Element_logger.error(error);\n      }\n    }\n  }, {\n    key: \"addClass\",\n    value: function addClass(el) {\n      try {\n        var _el$classList;\n        for (var _len = arguments.length, classNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n          classNames[_key - 1] = arguments[_key];\n        }\n        (_el$classList = el.classList).add.apply(_el$classList, classNames);\n      } catch (error) {\n        Element_logger.error(error);\n      }\n    }\n  }, {\n    key: \"removeClass\",\n    value: function removeClass() {}\n  }, {\n    key: \"hasClass\",\n    value: function hasClass() {}\n  }, {\n    key: \"isElement\",\n    value: function isElement(obj) {\n      try {\n        return obj instanceof HTMLElement;\n      } catch (e) {\n        return typeof_default()(obj) === 'object' && obj.nodeType === 1 && typeof_default()(obj.style) === 'object' && typeof_default()(obj.ownerDocument) === 'object';\n      }\n    }\n  }, {\n    key: \"setAttributes\",\n    value: function setAttributes(node, attrs) {\n      if (!Element.isElement(node)) {\n        return;\n      }\n      for (var i = 0, l = attrs.length; i < l; i++) {\n        var attr = attrs[i];\n        var name = attr.name;\n        name = attr.name.replace(/[\"|']/g, '');\n        node.setAttribute(name, attr.value);\n      }\n    }\n  }, {\n    key: \"syncAttributes\",\n    value: function syncAttributes(oldNode, newNode) {\n      var newAttrs = newNode.attributes;\n      Element.setAttributes(oldNode, newAttrs);\n      var oldAttrs = oldNode.attributes;\n      Element.setAttributes(newNode, oldAttrs);\n    }\n  }, {\n    key: \"getClientWidth\",\n    value: function getClientWidth() {\n      return document.documentElement.clientWidth ? document.documentElement.clientWidth : document.body.clientWidth;\n    }\n  }, {\n    key: \"getClientHeight\",\n    value: function getClientHeight() {\n      return document.documentElement.clientHeight ? document.documentElement.clientHeight : document.body.clientHeight;\n    }\n  }, {\n    key: \"adaptSizeElement\",\n    value: function adaptSizeElement(width, height, $container, $element) {\n      var $box = $container;\n      var $canvas = $element;\n      $canvas.width = width || $canvas.width || $box.offsetWidth;\n      $canvas.height = height || $canvas.height || $box.offsetHeight;\n      var canvasWidth = $canvas.width;\n      var canvasHeight = $canvas.height;\n      var proportion = 0;\n      $canvas.style.position = 'absolute';\n      if ($box.offsetWidth <= 0) {\n        $box.style.width = canvasWidth + 'px';\n      }\n      if ($box.offsetHeight <= 0) {\n        $box.style.height = canvasHeight + 'px';\n      }\n      var widthProportion = $box.offsetWidth / canvasWidth;\n      var heightProportion = $box.offsetHeight / canvasHeight;\n      if (heightProportion > widthProportion) {\n        proportion = widthProportion;\n      } else {\n        proportion = heightProportion;\n      }\n      $canvas.style.top = $box.offsetTop + ($box.offsetHeight - canvasHeight * proportion) / 2 + 'px';\n      $canvas.style.left = $box.offsetLeft + ($box.offsetWidth - canvasWidth * proportion) / 2 + 'px';\n      $canvas.style.transform = \"scale(\".concat(proportion, \", \").concat(proportion, \")\");\n      $canvas.style['transform-origin'] = \"top left\";\n      $canvas.style.display = 'inline-block';\n    }\n  }]);\n}();\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/construct.js\nvar construct = __webpack_require__(23);\nvar construct_default = /*#__PURE__*/__webpack_require__.n(construct);\n\n// CONCATENATED MODULE: ../src/base/BaseController.js\n\n\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: entry and dispatch of module\r\n * @author: Jarry\r\n * @file: BaseController.js\r\n */\n\n\n\nvar BaseController_BaseController = /*#__PURE__*/function () {\n  function BaseController() {\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, BaseController);\n    defineProperty_default()(this, \"logger\", null);\n    defineProperty_default()(this, \"__instance__\", null);\n    defineProperty_default()(this, \"__singleton__\", null);\n    this.options = options;\n    this.setLogger(this.constructor.name + '.js');\n  }\n  return createClass_default()(BaseController, [{\n    key: \"setLogger\",\n    value: function setLogger(file) {\n      this.logger = new Logger[\"a\" /* default */](file);\n    }\n  }, {\n    key: \"getLogger\",\n    value: function getLogger() {\n      return this.logger;\n    }\n  }, {\n    key: \"setOptions\",\n    value: function setOptions(options) {\n      Object.assign(this.options, options);\n    }\n  }, {\n    key: \"events\",\n    get: function get() {\n      if (this.options && this.options.events) {\n        return this.options.events(this);\n      }\n      return toolkit_Events(this);\n    }\n  }, {\n    key: \"toString\",\n    value: function toString() {\n      return JSON.stringify(this);\n    }\n  }], [{\n    key: \"getInstance\",\n    value: function getInstance() {\n      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {\n        args[_key] = arguments[_key];\n      }\n      this.__instance__ = construct_default()(this, args);\n      return this.__instance__;\n    }\n  }, {\n    key: \"getSingleton\",\n    value: function getSingleton() {\n      if (!this.__singleton__) {\n        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {\n          args[_key2] = arguments[_key2];\n        }\n        this.__singleton__ = construct_default()(this, args);\n      }\n      return this.__singleton__;\n    }\n  }]);\n}();\n/* harmony default export */ var base_BaseController = (BaseController_BaseController);\n// CONCATENATED MODULE: ../src/error/AlertError.js\n\n\n\n\n\n\nfunction _callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file AlertError.js\r\n * @desc\r\n * display error with alert\r\n * @author Jarry\r\n */\n\n// import Logger from '../toolkit/Logger.js'\n\nvar AlertError_AlertError = /*#__PURE__*/function (_BaseController) {\n  function AlertError(options) {\n    var _this;\n    classCallCheck_default()(this, AlertError);\n    _this = _callSuper(this, AlertError);\n    defineProperty_default()(_this, \"component\", null);\n    _this.component = options.component;\n    return _this;\n  }\n  inherits_default()(AlertError, _BaseController);\n  return createClass_default()(AlertError, [{\n    key: \"confirm\",\n    value: function confirm() {}\n  }, {\n    key: \"show\",\n    value: function show() {\n      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';\n      this.component.data.content = msg;\n      if (this.component.data.display === 'default' || this.component.data.display === '') {\n        this.component.showBox();\n      }\n      if (this.component.data.display !== 'show') {\n        this.component.show();\n      }\n    }\n  }, {\n    key: \"hide\",\n    value: function hide() {\n      this.component.hide();\n    }\n  }]);\n}(base_BaseController);\n/* harmony default export */ var error_AlertError = (AlertError_AlertError);\n// EXTERNAL MODULE: ../src/error/ThrowError.js\nvar ThrowError = __webpack_require__(24);\n\n// CONCATENATED MODULE: ../src/base/BaseClass.js\n\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: base class of all service\r\n * @author: Jarry\r\n * @file: BaseClass.js\r\n */\n\n\n\nvar BaseClass_BaseClass = /*#__PURE__*/function () {\n  function BaseClass() {\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, BaseClass);\n    defineProperty_default()(this, \"logger\", null);\n    this.options = options;\n    this.debug = options.debug || false;\n    this.setLogger(this.constructor.name + '.js');\n  }\n  return createClass_default()(BaseClass, [{\n    key: \"setLogger\",\n    value: function setLogger(file) {\n      this.logger = new Logger[\"a\" /* default */](file);\n    }\n  }, {\n    key: \"getLogger\",\n    value: function getLogger() {\n      return this.logger;\n    }\n  }, {\n    key: \"setOptions\",\n    value: function setOptions(options) {\n      Object.assign(this.options, options);\n    }\n  }, {\n    key: \"events\",\n    get: function get() {\n      if (this.options && this.options.events) {\n        return this.options.events(this);\n      }\n      return toolkit_Events(this);\n    }\n  }, {\n    key: \"alert\",\n    get: function get() {\n      var res = '';\n      if (this.options && this.options.alertError) {\n        res = this.options.alertError;\n      }\n      return res;\n    }\n  }, {\n    key: \"toString\",\n    value: function toString() {\n      return JSON.stringify(this);\n    }\n  }]);\n}();\n/* harmony default export */ var base_BaseClass = (BaseClass_BaseClass);\n// EXTERNAL MODULE: ../src/config/Config.js\nvar Config = __webpack_require__(8);\n\n// CONCATENATED MODULE: ../src/loader/BaseLoader.js\n\n\n\n\n\n\nfunction BaseLoader_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, BaseLoader_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction BaseLoader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BaseLoader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Loader.js\r\n * @desc\r\n * base module of load data\r\n * @author Jarry\r\n */\n\n\nvar BaseLoader_BaseLoader = /*#__PURE__*/function (_BaseClass) {\n  function BaseLoader() {\n    var _this;\n    classCallCheck_default()(this, BaseLoader);\n    _this = BaseLoader_callSuper(this, BaseLoader);\n    defineProperty_default()(_this, \"dataManage\", null);\n    defineProperty_default()(_this, \"sourceURL\", '');\n    return _this;\n  }\n  inherits_default()(BaseLoader, _BaseClass);\n  return createClass_default()(BaseLoader, [{\n    key: \"init\",\n    value: function init() {}\n  }, {\n    key: \"setDataManage\",\n    value: function setDataManage(dataManage) {\n      this.dataManage = dataManage;\n    }\n  }, {\n    key: \"setSourceURL\",\n    value: function setSourceURL(url) {\n      this.sourceURL = url;\n    }\n  }, {\n    key: \"getDataManage\",\n    value: function getDataManage() {\n      return this.getDataManage;\n    }\n  }, {\n    key: \"getSourceURL\",\n    value: function getSourceURL() {\n      return this.sourceURL;\n    }\n  }]);\n}(base_BaseClass);\n/* harmony default export */ var loader_BaseLoader = (BaseLoader_BaseLoader);\n// CONCATENATED MODULE: ../src/config/LoaderConfig.js\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file LoaderConfig.js\r\n * @desc\r\n * loader config\r\n * @author Jarry\r\n */\n\nvar LoaderConfig_error = {\n  dispatch: function dispatch() {},\n  load: function load() {},\n  read: function read() {},\n  memory: function memory() {}\n};\nvar state = {\n  LOAD_PLAYLIST: 10,\n  get '10'() {\n    return 'loading playlist';\n  },\n  LOADED_PLAYLIST: 11,\n  get '11'() {\n    return 'playlist is loaded';\n  },\n  IDLE: 0,\n  get '0'() {\n    return 'is free';\n  },\n  LOADING: 1,\n  get '1'() {\n    return 'loading segment';\n  },\n  DONE: 2,\n  get '2'() {\n    return 'segment is loaded';\n  },\n  ERROR: 3,\n  get '3'() {\n    return 'load get error';\n  }\n};\n\n// CONCATENATED MODULE: ../src/toolkit/M3U8Parser.js\n\n\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file M3U8Parser.js\r\n * @desc\r\n * m3u8 parse tool\r\n * @see\r\n * https://github.com/videojs/m3u8-parser/\r\n * https://github.com/mixer/m3u8-js/blob/master/parser.js\r\n * https://github.com/uupaa/M3U8.js/blob/master/lib/M3U8.js\r\n * @author Jarry\r\n */\n\n\n\nvar M3U8Parser_logger = Logger[\"a\" /* default */].get('M3U8Parser.js', {\n  level: 2\n});\nvar matchers = {\n  lineDelimiter: /\\r?\\n/,\n  extensionHeader: '#EXTM3U',\n  tagPrefix: '#EXT',\n  segmentPrefix: '#EXTINF',\n  segmentParse: /^#EXTINF: *([0-9.]+)(, *(.+?)?)?$/,\n  tagParse: /^#EXT-X-([A-Z-]+)(:(.+))?$/,\n  version: 'VERSION',\n  allowCache: 'ALLOW-CACHE',\n  combined: 'COMBINED',\n  endList: 'ENDLIST',\n  targetDuration: 'TARGETDURATION',\n  mediaSequence: 'MEDIA-SEQUENCE',\n  discontinuity: 'DISCONTINUITY',\n  streamInf: 'STREAM-INF',\n  isComment: function isComment(line) {\n    return line && line[0] === '#' && !line.startsWith(matchers.tagPrefix);\n  },\n  isBlank: function isBlank(line) {\n    return line === '';\n  },\n  canStrip: function canStrip(line) {\n    return matchers.isBlank(line) || matchers.isComment(line);\n  }\n};\nvar STATE = {\n  READING: 0,\n  ADD_FILE: 1\n};\nvar M3U8Parser_segment = {\n  file: undefined,\n  name: undefined,\n  start: 0,\n  end: 0,\n  discontinuity: undefined,\n  duration: undefined\n};\nvar M3U8Parser_M3U8Parser = /*#__PURE__*/function () {\n  function M3U8Parser(source) {\n    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    classCallCheck_default()(this, M3U8Parser);\n    defineProperty_default()(this, \"source\", '');\n    defineProperty_default()(this, \"segments\", []);\n    defineProperty_default()(this, \"_currentSegment\", null);\n    defineProperty_default()(this, \"discontinuous\", null);\n    defineProperty_default()(this, \"tags\", {\n      VERSION: undefined,\n      TARGETDURATION: undefined\n    });\n    defineProperty_default()(this, \"_state\", null);\n    this.source = source;\n    this.options = options;\n    this.parse(this.source);\n  }\n  return createClass_default()(M3U8Parser, [{\n    key: \"readSegment\",\n    value: function readSegment(line) {\n      var parsed = matchers.segmentParse.exec(line);\n      if (parsed === null) {\n        M3U8Parser_logger.warn('readsegment', 'read segment failed', 'line:', line);\n        return;\n      }\n      var duration = parseFloat(parsed[1], 10);\n      var name = parsed[3];\n      if (duration % 1 !== 0) {\n        if (this.tags.VERSION >= 3) {\n          M3U8Parser_logger.info('readsegment', 'Version must be 3 or higher to support floating.', 'duration:', duration);\n        }\n      }\n      if (duration < this.tags.TARGETDURATION) {\n        M3U8Parser_logger.info('readsegment', 'Segment duration must be less than the TARGETDURATION', 'duration:', duration);\n      }\n      duration = duration * 1000;\n      this._currentSegment = Object.assign({}, M3U8Parser_segment, {\n        duration: duration,\n        name: name,\n        discontinuity: this.discontinuous\n      });\n      var lastSegement = this.segments[this.segments.length - 1] || {\n        start: 0,\n        end: 0\n      };\n      this._currentSegment.start = lastSegement.end;\n      this._currentSegment.end = lastSegement.end + duration;\n      this.discontinuous = false;\n      this._state = STATE.ADD_FILE;\n    }\n  }, {\n    key: \"readTag\",\n    value: function readTag(line) {\n      var parsed = matchers.tagParse.exec(line);\n      if (parsed !== null) {\n        return {\n          name: parsed[1],\n          value: parsed[3]\n        };\n      }\n    }\n  }, {\n    key: \"readLine\",\n    value: function readLine(line) {\n      if (line.startsWith(matchers.segmentPrefix)) {\n        return this.readSegment(line);\n      }\n      var tag = this.readTag(line);\n      if (!tag) {\n        return;\n      }\n      switch (tag.name) {\n        case matchers.version:\n          this.tags.VERSION = parseFloat(tag.value, 10);\n          break;\n        case matchers.mediaSequence:\n          this.tags.MEDIA_SEQUENCE = parseFloat(tag.value, 10);\n          break;\n        case matchers.allowCache:\n          this.tags.ALLOW_CACHE = /\\s*(YES|yes)\\s*/.test(tag.value) ? true : false;\n          break;\n        case matchers.discontinuity:\n          this.tags.DISCONTINUITY = true;\n          this.discontinuous = true;\n          break;\n        case matchers.targetDuration:\n          this.tags.TARGETDURATION = parseFloat(tag.value, 10);\n          break;\n        case matchers.combined:\n          this.tags.COMBINED = tag.value;\n          break;\n        case matchers.streamInf:\n          this.tags.STREAM_INF = tag.value;\n          break;\n        case matchers.endList:\n          this.tags.ENDLIST = 'EOF';\n          break;\n        default:\n          M3U8Parser_logger.warn('readLine', 'unknow line', 'line:', line);\n      }\n    }\n  }, {\n    key: \"addFile\",\n    value: function addFile(line) {\n      if (line[0] === '#') {\n        var tag = this.readTag(line);\n        switch (tag.name) {\n          case 'PROGRAM-DATE-TIME':\n            {\n              var time = new Date(tag.value);\n              this._currentSegment.time = time;\n              break;\n            }\n          default:\n            M3U8Parser_logger.warn('addFile', 'Invalid tag.', 'tag.name:', tag.name);\n        }\n        return;\n      }\n      this._currentSegment.file = line;\n      var sd = this.parseSDParam(line);\n      if (sd >= 0) {\n        // 根据sd的数据（本段起始毫秒数）修正 start,duration,end, 本段duration待下段修正\n        this._currentSegment.start = sd;\n        this._currentSegment.end = sd + this._currentSegment.duration;\n        var lastSegement = this.segments[this.segments.length - 1] || {\n          sd: 0,\n          start: 0,\n          end: 0\n        };\n        lastSegement.duration = sd - lastSegement.start;\n        lastSegement.end = sd;\n      }\n      if (!this._currentSegment.name) {\n        this._currentSegment.name = line.substr(Math.max(0, line.lastIndexOf('/')), line.lastIndexOf('.'));\n      }\n      this.segments.push(this._currentSegment);\n      this._state = STATE.READING;\n    }\n  }, {\n    key: \"parseSDParam\",\n    value: function parseSDParam(line) {\n      var result = -1;\n      var url;\n      try {\n        url = new URL(line);\n        var sd = url.searchParams.get('sd');\n        if (sd) {\n          result = parseInt(sd, 10);\n        }\n      } catch (e) {\n        // Fail to parse url\n      }\n      return result;\n    }\n  }, {\n    key: \"parse\",\n    value: function parse(source) {\n      var _this = this;\n      source = source || this.source;\n      if (typeof source !== 'string') {\n        Object(ThrowError[\"a\" /* throwError */])('m3u8 file is not text.', source);\n        return;\n      }\n      this._state = STATE.READING;\n      this.discontinuous = false;\n      var lines = source.split(matchers.lineDelimiter);\n      if (lines[0] != matchers.extensionHeader) {\n        M3U8Parser_logger.error('parse', 'it is not a valid  m3u8 header', 'header:', lines[0]);\n        return;\n      }\n      lines.forEach(function (line) {\n        if (matchers.canStrip(line)) {\n          return;\n        }\n        switch (_this._state) {\n          case STATE.READING:\n            _this.readLine(line);\n            break;\n          case STATE.ADD_FILE:\n            _this.addFile(line);\n            break;\n          default:\n            Object(ThrowError[\"a\" /* throwError */])('parsing m3u8 get an error, it is unknow state.');\n        }\n      });\n      return this;\n    }\n  }, {\n    key: \"version\",\n    get: function get() {\n      return this.tags.VERSION;\n    }\n  }, {\n    key: \"duration\",\n    get: function get() {\n      if (!this.segments.length) {\n        return 0;\n      }\n      return this.segments.reduce(function () {\n        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n        var current = arguments.length > 1 ? arguments[1] : undefined;\n        var total = typeof acc == 'number' ? acc : acc.duration;\n        return total + current.duration;\n      });\n    }\n  }, {\n    key: \"targetDuration\",\n    get: function get() {\n      return this.tags.TARGETDURATION;\n    }\n  }, {\n    key: \"mediaSequence\",\n    get: function get() {\n      return this.tags.MEDIA_SEQUENCE;\n    }\n  }, {\n    key: \"allowCache\",\n    get: function get() {\n      return this.tags.ALLOW_CACHE;\n    }\n  }, {\n    key: \"length\",\n    get: function get() {\n      return this.segments.length;\n    }\n  }]);\n}();\n\n/**\r\n * output from Parser\r\n * @usage\r\n * m3u8parse(source).segments\r\n */\nvar instance = null;\nvar m3u8parse = function m3u8parse(source, options) {\n  if (!instance) {\n    return new M3U8Parser_M3U8Parser(source, options);\n  }\n};\n/* harmony default export */ var toolkit_M3U8Parser = (m3u8parse);\n// EXTERNAL MODULE: ../node_modules/loadjs/dist/loadjs.umd.js\nvar loadjs_umd = __webpack_require__(43);\nvar loadjs_umd_default = /*#__PURE__*/__webpack_require__.n(loadjs_umd);\n\n// CONCATENATED MODULE: ../src/utils/Utils.js\n\n\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Utils.js\r\n * @desc\r\n * global public tool utils\r\n * @author Jarry\r\n */\n\nfunction is() {\n  var clazz = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Object';\n  return function (obj) {\n    var type = '[object ' + clazz + ']';\n    return Object.prototype.toString.call(obj) == type;\n  };\n}\nvar Utils_Utils = /*#__PURE__*/function () {\n  function Utils() {\n    classCallCheck_default()(this, Utils);\n  }\n  return createClass_default()(Utils, null, [{\n    key: \"importScripts\",\n    value:\n    /**\r\n     * load script dynamic\r\n     * @param {String} urls \r\n     * @param {Function} callback \r\n     * @param {Object} error \r\n     */\n    function importScripts(urls, callback, error) {\n      var name = 'ready' + Date.now();\n      if (urls instanceof Array) {\n        loadjs_umd_default()(urls, name);\n      } else {\n        loadjs_umd_default()([urls], name);\n      }\n      loadjs_umd_default.a.ready(name, {\n        success: callback,\n        error: error\n      });\n    }\n  }, {\n    key: \"blobData\",\n    value: function blobData(str) {\n      var blob = new Blob([str], {\n        type: 'application/javascript'\n      });\n      return URL.createObjectURL(blob);\n    }\n  }, {\n    key: \"escapeHTML\",\n    value: function escapeHTML(str) {\n      if (!Utils.isString(str)) {\n        return;\n      }\n      return str.replace(/&/g, \"&amp;\").replace(/</g, \"&lt;\").replace(/>/g, \"&gt;\").replace(/\"/g, \"&quot;\").replace(/'/g, \"&#039;\");\n    }\n  }, {\n    key: \"getInnerWidthHeight\",\n    value: function getInnerWidthHeight() {\n      return {\n        width: window.innerWidth,\n        height: window.innerHeight\n      };\n    }\n  }, {\n    key: \"Fullscreen\",\n    value: function Fullscreen($ele) {\n      var ele = $ele;\n      if (ele.requestFullscreen) {\n        ele.requestFullscreen();\n      } else if (ele.mozRequestFullScreen) {\n        ele.mozRequestFullScreen();\n      } else if (ele.webkitRequestFullScreen) {\n        ele.webkitRequestFullScreen();\n        setTimeout(function () {\n          // console.error('fullscreen success')\n          document.dispatchEvent(new Event('fullscreenchange'));\n        }, 0);\n      }\n    }\n  }, {\n    key: \"exitFullscreen\",\n    value: function exitFullscreen() {\n      var doc = document;\n      if (doc.exitFullscreen) {\n        doc.exitFullscreen();\n      } else if (doc.mozCancelFullScreen) {\n        doc.mozCancelFullScreen();\n      } else if (doc.webkitExitFullscreen) {\n        doc.webkitExitFullscreen();\n        setTimeout(function () {\n          // console.error('exitfullscreen success')\n          document.dispatchEvent(new Event('fullscreenchange'));\n        }, 0);\n      }\n    }\n  }, {\n    key: \"buildFilePath\",\n    value: function buildFilePath(files, path) {\n      return files.map(function (value) {\n        return path + value;\n      });\n    }\n  }, {\n    key: \"insertSort\",\n    value: function insertSort(array, target, filter) {\n      var length = array.length;\n      var key, value;\n      if (length === 0) {\n        array.push(target);\n        return;\n      }\n      if (filter) {\n        var _filter = filter(target);\n        key = _filter.key;\n        value = _filter.value;\n        for (var i = 0; i < length; i++) {\n          if (value < array[i][key]) {\n            var j = length;\n            while (j > i) {\n              array[j] = array[j - 1];\n              j--;\n            }\n            array[i] = target;\n            return;\n          }\n        }\n        array.push(target);\n        return;\n      } else {\n        value = target;\n        for (var _i = 0; _i < length; _i++) {\n          if (value < array[_i]) {\n            var _j = length;\n            while (_j > _i) {\n              array[_j] = array[_j - 1];\n              _j--;\n            }\n            array[_i] = value;\n            return;\n          }\n        }\n      }\n      array.push(value);\n    }\n  }, {\n    key: \"isSafari\",\n    value: function isSafari() {\n      var ua = navigator.userAgent;\n      return /Safari/.test(ua) && !/Chrome/.test(ua);\n    }\n  }, {\n    key: \"msec2sec\",\n    value: function msec2sec(msec) {\n      var sec = (msec / 1000).toFixed(3);\n      return parseFloat(sec, 10);\n    }\n  }]);\n}();\ndefineProperty_default()(Utils_Utils, \"isObject\", function () {\n  return is('Object');\n});\ndefineProperty_default()(Utils_Utils, \"isString\", function () {\n  return is('String');\n});\ndefineProperty_default()(Utils_Utils, \"isFunction\", function () {\n  return is('Function');\n});\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/wrapNativeSuper.js\nvar wrapNativeSuper = __webpack_require__(32);\nvar wrapNativeSuper_default = /*#__PURE__*/__webpack_require__.n(wrapNativeSuper);\n\n// CONCATENATED MODULE: ../src/base/BasePool.js\n\n\n\n\n\n\nfunction BasePool_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, BasePool_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction BasePool_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BasePool_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: base pool for data\r\n * @author: Jarry\r\n * @file: BasePool.js\r\n */\nvar BasePool_BasePool = /*#__PURE__*/function (_Array) {\n  function BasePool() {\n    classCallCheck_default()(this, BasePool);\n    return BasePool_callSuper(this, BasePool);\n  }\n  inherits_default()(BasePool, _Array);\n  return createClass_default()(BasePool, [{\n    key: \"size\",\n    get: function get() {\n      return this.length;\n    }\n  }, {\n    key: \"add\",\n    value: function add(data) {\n      this.push(Object.freeze(data));\n    }\n  }, {\n    key: \"addAll\",\n    value: function addAll(dataList) {\n      var _this = this;\n      dataList.forEach(function (data) {\n        _this.add(data);\n      });\n    }\n  }, {\n    key: \"get\",\n    value: function get(index) {\n      return this[index];\n    }\n  }, {\n    key: \"getLast\",\n    value: function getLast() {\n      return this[this.length - 1];\n    }\n  }, {\n    key: \"getBy\",\n    value: function getBy(func) {\n      var _this2 = this;\n      if (typeof func !== 'function') return;\n      var result = new this.constructor();\n      this.every(function (model, idx) {\n        if (func.call(_this2, model, idx, _this2) === true) {\n          result.add(model);\n        }\n        return true;\n      });\n      return result;\n    }\n\n    /**\r\n     * find item by range time between start and end\r\n     * @param {number} time start-end time\r\n     * @param {Function} match [option] comparison time function\r\n     */\n  }, {\n    key: \"indexOfByTime\",\n    value: function indexOfByTime(time, match) {\n      if (!match) {\n        // (start, end]\n        match = function match(item) {\n          return time >= item.start && time < item.end;\n        };\n      }\n      var len = this.length - 1;\n      for (var i = 0; i <= len;) {\n        var mid = Math.floor((len + i) / 2);\n        var item = this[mid];\n        if (match(item)) {\n          return mid;\n        } else if (item.start > time) {\n          len = mid - 1;\n        } else {\n          i = mid + 1;\n        }\n      }\n      return -1;\n    }\n  }, {\n    key: \"getByTime\",\n    value: function getByTime(time) {\n      var idx = this.indexOfByTime(time);\n      if (idx >= 0) {\n        return this[idx];\n      }\n    }\n  }, {\n    key: \"getByKey\",\n    value: function getByKey() {\n      for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {\n        keys[_key] = arguments[_key];\n      }\n      if (Array.isArray(keys[0])) {\n        keys = keys[0];\n      }\n      return this.getBy(function (model) {\n        var result = false;\n        keys.every(function (key) {\n          if (Object.prototype.hasOwnProperty.call(model, key)) {\n            result = true;\n            return false;\n          }\n          return true;\n        });\n        return result;\n      });\n    }\n  }, {\n    key: \"getByValue\",\n    value: function getByValue() {\n      for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {\n        values[_key2] = arguments[_key2];\n      }\n      if (Array.isArray(values[0])) {\n        values = values[0];\n      }\n      return this.getBy(function (model) {\n        var result = false;\n        model.each(function (key, value) {\n          if (values.includes(value)) {\n            result = true;\n            // if have any same value, break current each\n            return false;\n          }\n        });\n        return result;\n      });\n    }\n  }, {\n    key: \"getByKeyValue\",\n    value: function getByKeyValue(key, value) {\n      return this.getBy(function (model) {\n        return model[key] === value;\n      });\n    }\n  }, {\n    key: \"getValues\",\n    value: function getValues() {\n      for (var _len3 = arguments.length, keys = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {\n        keys[_key3] = arguments[_key3];\n      }\n      if (Array.isArray(keys[0])) {\n        keys = keys[0];\n      }\n      return this.map(function (model) {\n        if (keys.length) {\n          return model.get(model, keys);\n        } else {\n          return model.getValues(model);\n        }\n      });\n    }\n  }, {\n    key: \"indexOfBy\",\n    value: function indexOfBy(func) {\n      var i = 0,\n        l = this.length;\n      func = func || function () {\n        return false;\n      };\n      while (i < l) {\n        if (func.call(this, this[i], i, this) === true) {\n          return i;\n        }\n        i++;\n      }\n      return -1;\n    }\n  }, {\n    key: \"indexOfByKey\",\n    value: function indexOfByKey(key, value) {\n      return this.indexOfBy(function (model) {\n        return model[key] === value;\n      });\n    }\n  }, {\n    key: \"indexOfByKeyValue\",\n    value: function indexOfByKeyValue(key, value) {\n      return this.indexOfByKey(key, value);\n    }\n\n    /** alias of forEach */\n  }, {\n    key: \"each\",\n    value: function each(func) {\n      if (typeof func !== 'function') return;\n      this.forEach(func);\n      return this;\n    }\n\n    /**\r\n     * remove member from List\r\n     * [start, end), interval to be left-closed and right-open\r\n     * @param {number} start\r\n     * @param {number} end [optional]\r\n     */\n  }, {\n    key: \"remove\",\n    value: function remove(start, end) {\n      if (this.length <= 0) {\n        return this;\n      }\n      start = start < 0 ? 0 : start;\n      end = end || start + 1;\n      this.splice(start, end - start);\n      return this;\n    }\n  }, {\n    key: \"removeItem\",\n    value: function removeItem() {\n      for (var _len4 = arguments.length, items = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {\n        items[_key4] = arguments[_key4];\n      }\n      if (Array.isArray(items[0])) {\n        items = items[0];\n      }\n      return this.removeBy(function (model) {\n        return items.includes(model);\n      });\n    }\n\n    /** remove item by condition */\n  }, {\n    key: \"removeBy\",\n    value: function removeBy(func) {\n      for (var i = 0, l = this.length; i < l; i++) {\n        if (func.call(this, this[i], i, this) === true) {\n          this.splice(i, 1);\n          l--;\n          i--;\n        }\n      }\n      return this;\n    }\n  }, {\n    key: \"removeByKeyValue\",\n    value: function removeByKeyValue(key, value) {\n      return this.removeBy(function (model) {\n        return model[key] === value;\n      });\n    }\n  }, {\n    key: \"toJSON\",\n    value: function toJSON() {\n      var list = Array.from(this);\n      list.forEach(function (model, i) {\n        list[i] = model && typeof model.toJSON === 'function' ? model.toJSON() : model;\n      });\n      return list;\n    }\n  }, {\n    key: \"toArray\",\n    value: function toArray() {\n      return Array.from(this);\n    }\n  }]);\n}( /*#__PURE__*/wrapNativeSuper_default()(Array));\n/* harmony default export */ var base_BasePool = (BasePool_BasePool);\n// CONCATENATED MODULE: ../src/base/BaseModel.js\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: base model, provide some common methods\r\n * @author: Jarry\r\n * @file: BaseModel.js\r\n */\nvar BaseModel_BaseModel = /*#__PURE__*/function () {\n  function BaseModel() {\n    classCallCheck_default()(this, BaseModel);\n  }\n  return createClass_default()(BaseModel, [{\n    key: \"pair\",\n    value: function pair() {\n      return Object.entries(this);\n    }\n  }, {\n    key: \"keys\",\n    value: function keys() {\n      return Object.keys(this);\n    }\n  }, {\n    key: \"set\",\n    value: function set(key, value) {\n      this[key] = value;\n      return this;\n    }\n  }, {\n    key: \"get\",\n    value: function get(key) {\n      return this[key];\n    }\n  }, {\n    key: \"add\",\n    value: function add(key, value) {\n      if (!Object.prototype.hasOwnProperty.call(this, key)) {\n        this.set(key, value);\n      }\n      return this;\n    }\n  }, {\n    key: \"addAll\",\n    value: function addAll(obj) {\n      for (var key in obj) {\n        this.add(key, obj[key]);\n      }\n      return this;\n    }\n  }, {\n    key: \"toJSON\",\n    value: function toJSON() {\n      var result = {};\n      for (var item in this) {\n        if (Object.prototype.hasOwnProperty.call(this, item)) {\n          result[item] = this[item];\n        }\n      }\n      return result;\n    }\n  }]);\n}();\n/* harmony default export */ var base_BaseModel = (BaseModel_BaseModel);\n// CONCATENATED MODULE: ../src/model/SegmentModel.js\n\n\n\n\n\n\nfunction SegmentModel_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, SegmentModel_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction SegmentModel_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SegmentModel_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: Model ofr segment from TS/MP4\r\n * @author: liuliguo \r\n * @file: SegmentModel.js\r\n */\n\nvar SegmentModel_SegmentModel = /*#__PURE__*/function (_BaseModel) {\n  function SegmentModel(data) {\n    var _this;\n    classCallCheck_default()(this, SegmentModel);\n    _this = SegmentModel_callSuper(this, SegmentModel, [data]);\n    defineProperty_default()(_this, \"no\", 0);\n    defineProperty_default()(_this, \"name\", null);\n    defineProperty_default()(_this, \"duration\", 0);\n    defineProperty_default()(_this, \"file\", null);\n    defineProperty_default()(_this, \"start\", 0);\n    defineProperty_default()(_this, \"end\", 0);\n    Object.assign(_this, data);\n    return _this;\n  }\n  inherits_default()(SegmentModel, _BaseModel);\n  return createClass_default()(SegmentModel);\n}(base_BaseModel);\n/* harmony default export */ var model_SegmentModel = (SegmentModel_SegmentModel);\n// CONCATENATED MODULE: ../src/data/SegmentPool.js\n\n\n\n\n\nfunction SegmentPool_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, SegmentPool_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction SegmentPool_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SegmentPool_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: segment pool\r\n * @author: Jarry\r\n * @file: SegmentPool.js\r\n */\n\n\n\n\nvar SegmentPool_SegmentPool = /*#__PURE__*/function (_BasePool) {\n  function SegmentPool(data) {\n    classCallCheck_default()(this, SegmentPool);\n    return SegmentPool_callSuper(this, SegmentPool, [data]);\n  }\n  inherits_default()(SegmentPool, _BasePool);\n  return createClass_default()(SegmentPool, [{\n    key: \"add\",\n    value: function add(data) {\n      if (!(data instanceof model_SegmentModel)) {\n        data = new model_SegmentModel(data);\n      }\n      // the number begin in 1\n      data.no = this.length + 1;\n      if (Utils_Utils.isObject(data)) {\n        this.push(data);\n      }\n    }\n  }]);\n}(base_BasePool);\n/* harmony default export */ var data_SegmentPool = (SegmentPool_SegmentPool);\n// CONCATENATED MODULE: ../src/config/EventsConfig.js\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: events object\r\n * @author: liuliguo \r\n * @file: EventsConfig.js\r\n */\n\nvar EventsConfig_Events = {\n  ProcessorResetEnd: 'DataProcessorController.processorResetEnd',\n  DataProcessorReady: 'DataProcessorController.dataProcessorReady',\n  // DecodeResetEnd: 'DecodeController.resetEnd',\n  DecodeStartDecode: 'DecodeController.startDecode',\n  DecodeFlush: 'DecodeController.flush',\n  DecodeDecoded: 'DecodeController.decoded',\n  DecodeApppendEnd: 'DecodeController.appendEnd',\n  DecodeFlushEnd: 'DecodeController.flushEnd',\n  DecodeReady: 'DecodeController.ready',\n  DemuxResetEnd: 'DemuxController.resetEnd',\n  DemuxStartDemux: 'DemuxController.startDemux',\n  DemuxLast: 'DemuxController.last',\n  DemuxVideo: 'DemuxController.video',\n  DemuxAAC: 'DemuxController.AAC',\n  DemuxReady: 'DemuxController.ready',\n  ImagePlayerRenderEnd: 'ImagePlayer.renderEnd',\n  ImagePlayerWait: 'ImagePlayer.wait',\n  ImagePlayerReady: 'ImagePlayer.ready',\n  ImagePlayerEnd: 'ImagePlayer.end',\n  ImagePlayerBuffeUpdate: 'ImagePlayer.bufferUpdate',\n  ControlBarPlay: 'ControlBar.onPlay',\n  ControlBarPause: 'ControlBar.onPause',\n  ControlBarPauseLoading: 'ControlBar.onPauseLoading',\n  DataManageReadBufferByNo: 'DataManage.readBufferByNo',\n  DataManageReadBuffer: 'DataManage.readBuffer',\n  DataManageRead: 'DataManage.onRead',\n  DataManageSeek: 'DataManage.onSeek',\n  DataManageFirstLoaded: 'DataManage.onFirstLoaded',\n  LoaderPlayListStart: 'Loader.playlistStart',\n  LoaderLoading: 'Loader.onLoading',\n  LoaderError: 'Loader.onError',\n  LoaderLoaded: 'Loader.onLoaded',\n  LoaderUpdateSpeed: 'Loader.updateSpeed',\n  LoaderLoadFile: 'Loader.loadFile',\n  LoaderPlayListLoaded: 'Loader.playlistLoaded',\n  LoaderMP4Loaded: 'loader.mp4Loaded',\n  AudioPlayerReady: 'AudioPlayer.MSEReady',\n  AudioPlayerDataReady: 'AudioPlayer.dataReady',\n  AudioPlayerWait: 'AudioPlayer.wait',\n  AudioPlayerEnd: 'AudioPlayer.end',\n  AudioPlayerPlaySuccess: 'AudioPlayer.playSuccess',\n  AudioPlayerPlayFail: 'AudioPlayer.playFail',\n  AutoPlayerPlayFail: 'AudioPlayer.autoplayFail',\n  PlayerMaxPTS: 'DemuxController.maxpts',\n  PlayerSeekEnd: 'Player.seekend',\n  PlayerSpeedTo: 'Player.speedTo',\n  PlayerChangeRate: 'Player.changeRate',\n  PlayerChangeSrc: 'Player.changeSrc',\n  PlayerPlaying: 'Player.playing',\n  PlayerTimeUpdate: 'Player.timeUpdate',\n  PlayerbufferUpdate: 'Player.bufferupdate',\n  PlayerResetReady: 'Player.resetReady',\n  PlayerWait: 'Player.wait',\n  PlayerLoadNext: 'Player.loadNext',\n  PlayerOnPlay: 'Player.onPlay',\n  PlayerOnPause: 'Player.onPause',\n  PlayerOnSeek: 'Player.onSeek',\n  PlayerOnVolume: 'Player.onVolume',\n  PlayerReady: 'Player.ready',\n  /**\r\n   * Event handling during player playing\r\n   * @event Player#play\r\n   * @type {Player}\r\n   * \r\n  */\n  PlayerPlay: 'Player.play',\n  PlayerReset: 'Player.reset',\n  PlayerLoadedMetaData: 'Player.loadedMetaData',\n  /**\r\n   * Event handling after playing ends\r\n   * @event Player#end\r\n   * @type {Player}\r\n   * \r\n  */\n  PlayerEnd: 'Player.end',\n  /**\r\n   * Event handling when playing pauses\r\n   * @event Player#pause\r\n   * @type {Player}\r\n   * \r\n  */\n  PlayerPause: 'Player.pause',\n  /**\r\n   * Event handling when player seeking data\r\n   * @event Player#seeking\r\n   * @type {Player}\r\n   * \r\n  */\n  PlayerSeeking: 'Player.seeking',\n  PlayerAlert: 'Player.alert',\n  PlayerThrowError: 'Player.throwError',\n  StreamDataReady: 'StreamController.dataReady'\n};\n/* harmony default export */ var EventsConfig = (EventsConfig_Events);\n// CONCATENATED MODULE: ../src/loader/HLSLoader.js\n\n\n\n\n\n\nfunction HLSLoader_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, HLSLoader_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction HLSLoader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (HLSLoader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\nfunction _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }\nfunction _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError(\"Cannot initialize the same private elements twice on an object\"); }\nfunction _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }\nfunction _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }\nfunction _assertClassBrand(e, t, n) { if (\"function\" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError(\"Private element is not present on this object\"); }\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file HLSLoader\r\n * @desc\r\n * hls load module\r\n * @author Jarry\r\n */\n\n\n\n\n\n\n\n\n\nvar _segmentPool = /*#__PURE__*/new WeakMap();\nvar HLSLoader_HLSLoader = /*#__PURE__*/function (_BaseLoader) {\n  function HLSLoader(options) {\n    var _this;\n    classCallCheck_default()(this, HLSLoader);\n    _this = HLSLoader_callSuper(this, HLSLoader);\n    defineProperty_default()(_this, \"state\", state.IDLE);\n    defineProperty_default()(_this, \"maxBufferDuration\", Config[\"b\" /* BUFFER */].maxDuration);\n    defineProperty_default()(_this, \"maxBufferSize\", Config[\"b\" /* BUFFER */].maxSize);\n    defineProperty_default()(_this, \"baseUrl\", '');\n    defineProperty_default()(_this, \"options\", null);\n    defineProperty_default()(_this, \"httpWorker\", null);\n    defineProperty_default()(_this, \"sourceData\", null);\n    // segmentPool should be immutability\n    _classPrivateFieldInitSpec(_this, _segmentPool, []);\n    defineProperty_default()(_this, \"currentNo\", null);\n    defineProperty_default()(_this, \"maxRetryCount\", Config[\"b\" /* BUFFER */].maxRetryCount);\n    _this.options = options;\n    _this.loaderController = _this.options.loaderController;\n    _this.dataController = _this.loaderController.dataController;\n    _this.httpWorker = options.httpWorker;\n    _this.setSegmentPool(new data_SegmentPool());\n    return _this;\n  }\n  inherits_default()(HLSLoader, _BaseLoader);\n  return createClass_default()(HLSLoader, [{\n    key: \"loadPlaylist\",\n    value: function loadPlaylist(callback) {\n      var _this2 = this;\n      console.log('hls load playlist');\n      this.httpWorker.postMessage({\n        type: 'invoke',\n        fileType: 'm3u8',\n        method: 'get',\n        name: 'playlist',\n        url: this.sourceURL\n      });\n      this.httpWorker.onmessage = function (event) {\n        var data = event.data;\n        var body = event.data.data;\n        if (!body) {\n          var content = \"Get the \".concat(data.fileType, \" file error. URL: \").concat(data.url);\n          _this2.events.emit(EventsConfig.PlayerAlert, content);\n          _this2.events.emit(EventsConfig.LoaderError, content, data);\n          var errors = [_this2.state, 'request playlist error.', 'data:', data, content];\n          _this2.events.emit(EventsConfig.PlayerThrowError, errors);\n          return;\n        }\n        if (data.name == 'playlist') {\n          _this2.parsePlaylist(body, callback);\n        }\n      };\n    }\n  }, {\n    key: \"parsePlaylist\",\n    value: function parsePlaylist(source, callback) {\n      var data = new M3U8Parser_M3U8Parser(source);\n      if (!data.segments || !data.segments.length) {\n        this.events.emit(EventsConfig.LoaderError, data);\n        this.events.emit(EventsConfig.PlayerAlert, 'Parse playlist file error.');\n        var errors = [this.state, 'Parse playlist error.', 'data:', data];\n        this.events.emit(EventsConfig.PlayerThrowError, errors);\n        return;\n      }\n      var segments = data.segments;\n      segments.forEach(function (item) {\n        item.start = Utils_Utils.msec2sec(item.start);\n        item.end = Utils_Utils.msec2sec(item.end);\n        item.duration = Utils_Utils.msec2sec(item.duration);\n      });\n      this.setSourceData(Object.freeze(data));\n      _classPrivateFieldGet(_segmentPool, this).addAll(data.segments);\n      callback.call(this, data);\n    }\n  }, {\n    key: \"setSourceData\",\n    value: function setSourceData(sourceData) {\n      this.sourceData = sourceData;\n    }\n  }, {\n    key: \"getSourceData\",\n    value: function getSourceData() {\n      return this.sourceData;\n    }\n  }, {\n    key: \"setSegmentPool\",\n    value: function setSegmentPool(segmentPool) {\n      _classPrivateFieldSet(_segmentPool, this, segmentPool);\n    }\n  }, {\n    key: \"getSegmentPool\",\n    value: function getSegmentPool() {\n      return _classPrivateFieldGet(_segmentPool, this);\n    }\n  }, {\n    key: \"isNotFree\",\n    value: function isNotFree() {\n      var notice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';\n      notice = '[' + notice + ']loader is not free. please wait.';\n      if (this.state !== state.IDLE && this.state !== state.DONE) {\n        this.logger.warn('isNotFree', 'check status for loader', 'notice:', notice);\n        return true;\n      }\n      return false;\n    }\n  }, {\n    key: \"getBaseUrl\",\n    value: function getBaseUrl(file) {\n      var sourceURL = this.getSourceURL();\n      var isAbsolute = file.indexOf('//') > -1;\n      if (!isAbsolute) {\n        var lastSlash = sourceURL.lastIndexOf('/');\n        return sourceURL.substr(0, lastSlash + 1);\n      }\n      return '';\n    }\n  }, {\n    key: \"checkLoadCondition\",\n    value: function checkLoadCondition(segment) {\n      // over the pool range\n      if (segment.no > _classPrivateFieldGet(_segmentPool, this).length) {\n        return false;\n      }\n      // max duration limit\n      if (this.dataController.getHLSBufferPool().bufferDuration > this.maxBufferDuration) {\n        this.logger.info('checkLoadCondition', 'stop load next segment.', 'bufferDuration:', this.dataController.getHLSBufferPool().bufferDuration, 'maxBufferDuration:', this.maxBufferDuration);\n        return false;\n      }\n      return true;\n    }\n\n    /**\r\n     * load ts file by segment\r\n     * @param {Segment} segment \r\n     * @param {String} type [optional] 'seek' or 'play'\r\n     * @param {Number} time [optional] millisecond\r\n     */\n  }, {\n    key: \"loadFile\",\n    value: function loadFile(segment, type, time) {\n      var _this3 = this;\n      if (!(segment instanceof model_SegmentModel)) {\n        return;\n      }\n\n      // only single load process\n      if (this.isNotFree() && type !== 'seek' && type !== 'start') {\n        this.logger.warn('loadFile', 'is loading', 'segment:', segment, 'type:', type);\n        return;\n      }\n      if (!this.checkLoadCondition(segment)) {\n        this.state = state.IDLE;\n        this.logger.warn('loadFile', 'checkLoadCondition failed', 'segment:', segment, 'type:', type);\n        return;\n      }\n      this.currentNo = segment.no;\n      var baseUrl = this.getBaseUrl(segment.file);\n      var url = baseUrl + segment.file;\n      var retryCount = 1;\n      var _getRequestURL = function _getRequestURL(url, segment) {\n        if (typeof _this3.options.processURL == 'function') {\n          return _this3.options.processURL(url, segment);\n        }\n        return url;\n      };\n      var _send = function _send() {\n        var currUrl = _getRequestURL(url, segment);\n        console.log(\"ts_url\", currUrl);\n        _this3.httpWorker.postMessage({\n          type: 'invoke',\n          fileType: 'ts',\n          method: 'get',\n          name: segment.no,\n          url: currUrl\n        });\n      };\n      this.state = state.LOADING;\n      this.events.emit(EventsConfig.LoaderLoading, segment, type, time);\n      this.httpWorker.onmessage = function (event) {\n        _this3.state = state.DONE;\n        var data = event.data;\n        _this3.logger.info('loadfile', 'httpWorker', 'onmessage get data');\n        if (!data || data.type === 'error') {\n          _this3.state = state.ERROR;\n          if (retryCount <= _this3.maxRetryCount) {\n            _this3.logger.warn('loadFile', 'retry to load', 'count:', retryCount, 'segment:', segment);\n            _send();\n            retryCount += 1;\n          } else {\n            _this3.events.emit(EventsConfig.LoaderError, segment, type, time);\n            var content = 'Load file error, please concat administrator.';\n            _this3.events.emit(EventsConfig.PlayerAlert, content);\n            var errors = [_this3.state, 'Load File error.', 'load count:', retryCount, 'segment:', segment];\n            _this3.events.emit(EventsConfig.PlayerThrowError, errors);\n          }\n        } else if (data.type === 'notice') {\n          if (data.noticeType === 'speed') {\n            _this3.events.emit(EventsConfig.LoaderUpdateSpeed, data.data);\n          }\n        } else if (data.fileType === 'ts' && data.name === segment.no) {\n          _this3.logger.info('loadFile', 'read success', 'data no:', data.name);\n          _this3.state = state.IDLE;\n          _this3.events.emit(EventsConfig.LoaderLoaded, data, segment, type, time);\n        } else {\n          var _errors = [_this3.state, 'loadFile', 'is not ts file or the segment\\'no is not equal.'];\n          _this3.events.emit(EventsConfig.PlayerThrowError, _errors);\n          _this3.logger.warn('loadFile', 'is not ts file or the segment\\'no is not equal.', 'fileType:', data.fileType, 'data:', data);\n        }\n      };\n      _send();\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      if (this.httpWorker) {\n        this.httpWorker.terminate();\n      }\n    }\n  }]);\n}(loader_BaseLoader);\n/* harmony default export */ var loader_HLSLoader = (HLSLoader_HLSLoader);\n// EXTERNAL MODULE: ../node_modules/demuxer/dist/demuxer.all.esm.js\nvar demuxer_all_esm = __webpack_require__(21);\n\n// CONCATENATED MODULE: ../src/loader/MP4Loader.js\n\n\n\n\n\n\nfunction MP4Loader_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, MP4Loader_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction MP4Loader_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (MP4Loader_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * Copyright (C) 2021.\r\n * All Rights Reserved.\r\n * @file MP4Loader\r\n * @desc\r\n * hls load module\r\n * @author Jarry\r\n */\n\n\n\n\n\n\n\n\n\n\nvar MP4Loader_MP4Loader = /*#__PURE__*/function (_BaseLoader) {\n  function MP4Loader(options) {\n    var _this;\n    classCallCheck_default()(this, MP4Loader);\n    _this = MP4Loader_callSuper(this, MP4Loader);\n    defineProperty_default()(_this, \"state\", state.IDLE);\n    defineProperty_default()(_this, \"maxBufferDuration\", Config[\"b\" /* BUFFER */].maxDuration);\n    defineProperty_default()(_this, \"maxBufferSize\", Config[\"b\" /* BUFFER */].maxSize);\n    defineProperty_default()(_this, \"baseUrl\", '');\n    defineProperty_default()(_this, \"options\", null);\n    defineProperty_default()(_this, \"httpWorker\", null);\n    defineProperty_default()(_this, \"mp4Meta\", null);\n    // segmentPool should be immutability\n    defineProperty_default()(_this, \"segmentPool\", [/* new SegmentModel */]);\n    defineProperty_default()(_this, \"currentNo\", null);\n    defineProperty_default()(_this, \"maxRetryCount\", Config[\"b\" /* BUFFER */].maxRetryCount);\n    _this.options = options;\n    _this.loaderController = _this.options.loaderController;\n    _this.dataController = _this.loaderController.dataController;\n    _this.httpWorker = options.httpWorker;\n    // this.setSegmentPool(new SegmentPool())\n    return _this;\n  }\n  inherits_default()(MP4Loader, _BaseLoader);\n  return createClass_default()(MP4Loader, [{\n    key: \"loadRange\",\n    value: function loadRange(callback) {}\n  }, {\n    key: \"preload\",\n    value: function preload(callback) {\n      var _this2 = this;\n      this.httpWorker.postMessage({\n        type: 'invoke',\n        fileType: 'mp4',\n        method: 'get',\n        name: 'preloadmp4',\n        url: this.sourceURL,\n        options: {\n          headers: {\n            withCredentials: false,\n            cache: 'no-cache',\n            mode: 'cors',\n            responseType: 'arraybuffer',\n            Pragma: 'no-cache',\n            fileTpe: 'mp4'\n            // Range: `bytes=0-200`\n          }\n        }\n      });\n      this.httpWorker.onmessage = function (event) {\n        var data = event.data;\n        var body = event.data.data;\n        if (!body) {\n          var content = \"Get the \".concat(data.fileType, \" file error. URL: \").concat(data.url);\n          _this2.events.emit(EventsConfig.PlayerAlert, content);\n          _this2.events.emit(EventsConfig.LoaderError, content, data);\n          var errors = [_this2.state, 'preload mp4 error.', 'data:', data, content];\n          _this2.events.emit(EventsConfig.PlayerThrowError, errors);\n          return;\n        }\n        if (data.name == 'preloadmp4') {\n          console.log('mp4 event:', event);\n          // TODO: 构建playlist，根据时间划分range，确定分片个数，并根据总时长确定进度条\n          event.data.data.arrayBuffer().then(function (bytes) {\n            console.error('mp4 arrayBuffer first done:', bytes);\n            _this2.events.emit(EventsConfig.LoaderMP4Loaded, bytes);\n            var demux = new demuxer_all_esm[\"b\" /* MP4Demux */]({\n              debug: true\n            });\n            demux.on(demuxer_all_esm[\"a\" /* Events */].DEMUX_DATA, function (e) {\n              console.log('MP4Demux on:', e);\n            });\n            demux.on(demuxer_all_esm[\"a\" /* Events */].DONE, function (e) {\n              console.log('MP4Demux done:', e);\n            });\n            demux.push(bytes);\n          });\n          _this2.loadFragment({\n            start: 0,\n            end: 100\n          }, '');\n        }\n      };\n    }\n  }, {\n    key: \"isNotFree\",\n    value: function isNotFree() {\n      var notice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';\n      notice = '[' + notice + ']loader is not free. please wait.';\n      if (this.state !== state.IDLE && this.state !== state.DONE) {\n        this.logger.warn('isNotFree', 'check status for loader', 'notice:', notice);\n        return true;\n      }\n      return false;\n    }\n  }, {\n    key: \"getBaseUrl\",\n    value: function getBaseUrl(file) {\n      var sourceURL = this.options.sourceURL;\n      var isAbsolute = file.indexOf('//') > -1;\n      if (!isAbsolute) {\n        var lastSlash = sourceURL.lastIndexOf('/');\n        return sourceURL.substr(0, lastSlash + 1);\n      }\n      return '';\n    }\n  }, {\n    key: \"checkLoadCondition\",\n    value: function checkLoadCondition(segment) {\n      // over the pool range\n      if (segment.no > this.segmentPool.length) {\n        return false;\n      }\n      // max duration limit\n      if (this.dataController.getMP4BufferPool().bufferDuration > this.maxBufferDuration) {\n        this.logger.info('checkLoadCondition', 'stop load next segment.', 'bufferDuration:', this.dataController.getMP4BufferPool().bufferDuration, 'maxBufferDuration:', this.maxBufferDuration);\n        return false;\n      }\n      return true;\n    }\n\n    /**\r\n     * load file by range\r\n     * @param {Range} rage \r\n     * @param {String} type [optional] 'seek' or 'play'\r\n     * @param {Number} time [optional] millisecond\r\n     */\n  }, {\n    key: \"loadFragment\",\n    value: function loadFragment() {\n      var _this3 = this;\n      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {\n        start: 0,\n        end: 1048576\n      };\n      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'play';\n      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;\n      var segment = range;\n      // only single load process\n      if (this.isNotFree() && type !== 'seek' && type !== 'start') {\n        this.logger.warn('loadFile', 'is loading', 'segment:', segment, 'type:', type);\n        return;\n      }\n      if (!this.checkLoadCondition(segment)) {\n        this.state = state.IDLE;\n        this.logger.warn('loadFile', 'checkLoadCondition failed', 'segment:', segment, 'type:', type);\n        return;\n      }\n\n      // this.currentNo = segment.no\n\n      // const baseUrl = this.getBaseUrl(segment.file)\n      // let url = baseUrl + segment.file\n      var retryCount = 1;\n      var _getRequestURL = function _getRequestURL(url, segment) {\n        if (typeof _this3.options.processURL == 'function') {\n          return _this3.options.processURL(url, segment);\n        }\n        return url;\n      };\n      var _send = function _send() {\n        _this3.httpWorker.postMessage({\n          type: 'invoke',\n          fileType: 'mp4',\n          method: 'get',\n          name: segment.no,\n          url: _getRequestURL(url, segment)\n        });\n      };\n      this.state = state.LOADING;\n      this.events.emit(EventsConfig.LoaderLoading, segment, type, time);\n      this.httpWorker.onmessage = function (event) {\n        _this3.state = state.DONE;\n        var data = event.data;\n        _this3.logger.info('loadfile', 'httpWorker', 'onmessage get data');\n        if (!data || data.type === 'error') {\n          _this3.state = state.ERROR;\n          if (retryCount <= _this3.maxRetryCount) {\n            _this3.logger.warn('loadFile', 'retry to load', 'count:', retryCount, 'segment:', segment);\n            _send();\n            retryCount += 1;\n          } else {\n            _this3.events.emit(EventsConfig.LoaderError, segment, type, time);\n            var content = 'Load file error, please concat administrator.';\n            _this3.events.emit(EventsConfig.PlayerAlert, content);\n            var errors = [_this3.state, 'Load File error.', 'load count:', retryCount, 'segment:', segment];\n            _this3.events.emit(EventsConfig.PlayerThrowError, errors);\n          }\n        } else if (data.type === 'notice') {\n          if (data.noticeType === 'speed') {\n            _this3.events.emit(EventsConfig.LoaderUpdateSpeed, data.data);\n          }\n        } else if (data.fileType === 'mp4' && data.name === segment.no) {\n          _this3.logger.info('loadFile', 'read success', 'data no:', data.name);\n          _this3.state = state.IDLE;\n          _this3.events.emit(EventsConfig.LoaderLoaded, data, segment, type, time);\n        } else {\n          _this3.logger.warn('loadFile', 'is not mp4 file or the segment\\'no is not equal.', 'fileType:', data.fileType, 'data:', data);\n        }\n      };\n      _send();\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      if (this.httpWorker) {\n        this.httpWorker.terminate();\n      }\n    }\n  }]);\n}(loader_BaseLoader);\n/* harmony default export */ var loader_MP4Loader = (MP4Loader_MP4Loader);\n// CONCATENATED MODULE: ../src/loader/LoaderController.js\n\n\n\n\n\n\nfunction ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }\nfunction _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }\nfunction LoaderController_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, LoaderController_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction LoaderController_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (LoaderController_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Loader.js\r\n * @desc\r\n * loader proxy\r\n * @author Jarry\r\n */\n\n\n\n\n\n\nvar LoadersEnum = {\n  // HLS, MP4, DASH\n  'HLS': loader_HLSLoader,\n  'MP4': loader_MP4Loader\n};\nvar LoaderController_LoaderController = /*#__PURE__*/function (_BaseController) {\n  function LoaderController(type, options) {\n    var _this;\n    classCallCheck_default()(this, LoaderController);\n    _this = LoaderController_callSuper(this, LoaderController);\n    defineProperty_default()(_this, \"state\", null);\n    defineProperty_default()(_this, \"exeLoader\", null);\n    defineProperty_default()(_this, \"dataManage\", null);\n    defineProperty_default()(_this, \"type\", 'HLS');\n    defineProperty_default()(_this, \"options\", null);\n    defineProperty_default()(_this, \"dataController\", null);\n    _this.type = type || _this.type;\n    _this.player = options.player;\n    _this.options = options.player.options;\n    _this.dataController = _this.player.dataController;\n    _this.init(_this.type, _this.options);\n    return _this;\n  }\n  inherits_default()(LoaderController, _BaseController);\n  return createClass_default()(LoaderController, [{\n    key: \"init\",\n    value: function init(type, options) {\n      this.bindEvent();\n      this.setExeLoader(new LoadersEnum[type](_objectSpread(_objectSpread({}, options), {}, {\n        player: this.player,\n        loaderController: this\n      })));\n      this.setSourceURL(options.sourceURL);\n      if (this.player.dataManage) {\n        this.setDataManage(this.player.dataManage);\n      } else {\n        this.setDataManage(this.dataController.getDataManage(type, options));\n      }\n      this.exeLoader.setDataManage(this.dataManage);\n    }\n  }, {\n    key: \"run\",\n    value: function run() {\n      this.state = state.LOAD_PLAYLIST;\n      this.events.emit(EventsConfig.LoaderPlayListStart, this);\n      this.logger.info('run', state[this.state], 'url:', this.options.sourceURL);\n      switch (this.type.toUpperCase()) {\n        case 'HLS':\n          this.loadHLS();\n          break;\n        case 'MP4':\n          this.loadMP4();\n          break;\n        default:\n          this.logger.erro('run', \"this \".concat(this.type, \" is not valid.\"), this.type);\n      }\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.LoaderLoadFile, function (segment, type, time) {\n        _this2.exeLoader.loadFile(segment, type, time);\n      });\n    }\n  }, {\n    key: \"loadMP4\",\n    value: function loadMP4(callback) {\n      var _this3 = this;\n      this.exeLoader.preload(function (data) {\n        if (!data) {\n          _this3.logger.error('run', 'start preload mp4', 'data:', data);\n          return;\n        }\n        if (typeof callback === 'function') {\n          console.info('mp4Preload data:', data);\n          callback.call(_this3, data);\n        }\n        // this.dataController.setDataManageSourceData(this.exeLoader.getSourceData())\n        // this.dataController.setDataManageSegmentPool(this.exeLoader.getSegmentPool())\n        _this3.state = state.PRELOADED_MP4;\n        _this3.events.emit(EventsConfig.LoaderMP4Loaded, _this3);\n        if (typeof callback === 'function') {\n          callback.call(_this3, data);\n        }\n      });\n    }\n  }, {\n    key: \"loadHLS\",\n    value: function loadHLS(callback) {\n      var _this4 = this;\n      this.exeLoader.loadPlaylist(function (data) {\n        console.log(\"data=====\", data);\n        if (!data) {\n          _this4.logger.error('run', 'start load m3u8', 'data:', data);\n          return;\n        }\n        _this4.dataController.setHLSSourceData(_this4.exeLoader.getSourceData());\n        _this4.dataController.setHLSSegmentPool(_this4.exeLoader.getSegmentPool());\n        _this4.state = state.LOADED_PLAYLIST;\n        _this4.events.emit(EventsConfig.LoaderPlayListLoaded, _this4);\n        if (typeof callback === 'function') {\n          callback.call(_this4, data);\n        }\n      });\n    }\n  }, {\n    key: \"switchPlaylist\",\n    value: function switchPlaylist(sourceURL, callback) {\n      this.setSourceURL(sourceURL);\n      this.dataController.clearDataManage();\n      this.state = state.LOAD_PLAYLIST;\n      this.events.emit(EventsConfig.LoaderPlayListStart, this);\n      this.logger.info('switchPlaylist', state[this.state], 'url:', sourceURL);\n      this.loadHLS(callback);\n    }\n  }, {\n    key: \"setExeLoader\",\n    value: function setExeLoader(exeLoader) {\n      this.exeLoader = exeLoader;\n    }\n  }, {\n    key: \"getExeLoader\",\n    value: function getExeLoader() {\n      return this.exeLoader;\n    }\n  }, {\n    key: \"setSourceURL\",\n    value: function setSourceURL(url) {\n      this.exeLoader.setSourceURL(url);\n    }\n  }, {\n    key: \"getSourceURL\",\n    value: function getSourceURL() {\n      return this.exeLoader.getSourceURL();\n    }\n  }, {\n    key: \"setDataManage\",\n    value: function setDataManage(dataManage) {\n      this.dataManage = dataManage;\n    }\n  }, {\n    key: \"getDataManage\",\n    value: function getDataManage() {\n      return this.dataManage;\n    }\n  }, {\n    key: \"getSourceData\",\n    value: function getSourceData() {\n      return this.exeLoader.getSourceData();\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      this.exeLoader.destroy();\n    }\n  }]);\n}(base_BaseController);\n/* harmony default export */ var loader_LoaderController = (LoaderController_LoaderController);\n// CONCATENATED MODULE: ../src/model/BufferModel.js\n\n\n\n\n\n\nfunction BufferModel_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, BufferModel_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction BufferModel_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BufferModel_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: arraybuffer Model from segment\r\n * @author: liuliguo \r\n * @file: BufferModel.js\r\n */\n\nvar BufferModel_BufferModel = /*#__PURE__*/function (_BaseModel) {\n  function BufferModel(data) {\n    var _this;\n    classCallCheck_default()(this, BufferModel);\n    _this = BufferModel_callSuper(this, BufferModel, [data]);\n    defineProperty_default()(_this, \"no\", 0);\n    defineProperty_default()(_this, \"start\", 0);\n    defineProperty_default()(_this, \"end\", 0);\n    defineProperty_default()(_this, \"blob\", null);\n    defineProperty_default()(_this, \"arrayBuffer\", null);\n    defineProperty_default()(_this, \"duration\", 0);\n    Object.assign(_this, data);\n    return _this;\n  }\n  inherits_default()(BufferModel, _BaseModel);\n  return createClass_default()(BufferModel, [{\n    key: \"size\",\n    get: function get() {\n      return this.blob.size;\n    }\n  }]);\n}(base_BaseModel);\n/* harmony default export */ var model_BufferModel = (BufferModel_BufferModel);\n// CONCATENATED MODULE: ../src/data/BufferPool.js\n\n\n\n\n\nfunction BufferPool_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, BufferPool_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction BufferPool_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BufferPool_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file BufferPool.js\r\n * @desc buffer pool\r\n * @see\r\n * @author Jarry\r\n */\n\n\n\nvar BufferPool_BufferPool = /*#__PURE__*/function (_BasePool) {\n  // bufferDuration = 0\n  // bufferSize = 0\n  function BufferPool(data) {\n    classCallCheck_default()(this, BufferPool);\n    return BufferPool_callSuper(this, BufferPool, [data]);\n  }\n  inherits_default()(BufferPool, _BasePool);\n  return createClass_default()(BufferPool, [{\n    key: \"add\",\n    value: function add(data) {\n      if (!(data instanceof model_BufferModel)) {\n        data = new model_BufferModel(data);\n      }\n      // keep the ASC order\n      var len = this.length;\n      if (len === 0) {\n        this.push(data);\n        return;\n      }\n      while (len--) {\n        if (data.no <= this[len].no) {\n          this.splice(len, 1, data);\n          return;\n        }\n      }\n      this.push(data);\n      return this;\n    }\n  }, {\n    key: \"getBufferSize\",\n    value: function getBufferSize() {\n      if (this.length <= 0) return 0;\n      return this.reduce(function (acc, item) {\n        if (isNaN(acc)) {\n          acc = acc.blob.size;\n        }\n        return acc + item.blob.size;\n      });\n    }\n  }, {\n    key: \"bufferSize\",\n    get: function get() {\n      return this.getBufferSize();\n    }\n  }, {\n    key: \"getBufferDuration\",\n    value: function getBufferDuration() {\n      if (this.length <= 0) return 0;\n      return this.reduce(function (acc, item) {\n        if (isNaN(acc)) {\n          acc = acc.end - acc.start;\n        }\n        return acc + (item.end - item.start);\n      });\n    }\n  }, {\n    key: \"bufferDuration\",\n    get: function get() {\n      return this.getBufferDuration();\n    }\n  }]);\n}(base_BasePool);\n/* harmony default export */ var data_BufferPool = (BufferPool_BufferPool);\n// CONCATENATED MODULE: ../src/data/HLSDataManage.js\n\n\n\n\n\n\nfunction HLSDataManage_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, HLSDataManage_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction HLSDataManage_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (HLSDataManage_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\nfunction HLSDataManage_classPrivateFieldInitSpec(e, t, a) { HLSDataManage_checkPrivateRedeclaration(e, t), t.set(e, a); }\nfunction HLSDataManage_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError(\"Cannot initialize the same private elements twice on an object\"); }\nfunction HLSDataManage_classPrivateFieldSet(s, a, r) { return s.set(HLSDataManage_assertClassBrand(s, a), r), r; }\nfunction HLSDataManage_classPrivateFieldGet(s, a) { return s.get(HLSDataManage_assertClassBrand(s, a)); }\nfunction HLSDataManage_assertClassBrand(e, t, n) { if (\"function\" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError(\"Private element is not present on this object\"); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file DataManage\r\n * @desc\r\n * ts load and data format \r\n * @author Jarry\r\n */\n\n\n\n\n\nvar _bufferPool = /*#__PURE__*/new WeakMap();\nvar HLSDataManage_segmentPool = /*#__PURE__*/new WeakMap();\nvar HLSDataManage_HLSDataManage = /*#__PURE__*/function (_BaseClass) {\n  function HLSDataManage() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, HLSDataManage);\n    _this = HLSDataManage_callSuper(this, HLSDataManage);\n    HLSDataManage_classPrivateFieldInitSpec(_this, _bufferPool, [/* new BufferModel */]);\n    defineProperty_default()(_this, \"sourceData\", {});\n    defineProperty_default()(_this, \"options\", {});\n    HLSDataManage_classPrivateFieldInitSpec(_this, HLSDataManage_segmentPool, [/* new SegmentModel */]);\n    defineProperty_default()(_this, \"readBufferNo\", null);\n    defineProperty_default()(_this, \"startLoadTime\", null);\n    defineProperty_default()(_this, \"currentSeekTime\", null);\n    _this.options = options;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(HLSDataManage, _BaseClass);\n  return createClass_default()(HLSDataManage, [{\n    key: \"init\",\n    value: function init() {\n      var _this2 = this;\n      this.setBufferPool(new data_BufferPool());\n      this.events.on(EventsConfig.DataManageReadBufferByNo, function (no, callback) {\n        _this2.readBufferByNo(no, callback);\n      });\n      this.events.on(EventsConfig.DataManageReadBuffer, function (time, callback) {\n        _this2.readBuffer(time, callback);\n      });\n      this.events.on(EventsConfig.LoaderLoaded, function (data, segment, type, time) {\n        // console.error('Events.LoaderLoaded', data, segment, time, this)\n        var buffer = _this2.createBuffer({\n          arrayBuffer: data.arrayBuffer\n        }, segment);\n        _this2.segmentLoaded(segment, buffer);\n        if (type === 'seek' && time === _this2.currentSeekTime) {\n          _this2.events.emit(EventsConfig.DataManageSeek, buffer, time);\n          _this2.removeBufferByNo(buffer.no);\n          return;\n        }\n        if (time === _this2.startLoadTime) {\n          _this2.events.emit(EventsConfig.DataManageFirstLoaded, buffer, time);\n        }\n      });\n    }\n  }, {\n    key: \"setOptions\",\n    value: function setOptions(options) {\n      Object.assign(this.options, options);\n    }\n  }, {\n    key: \"startLoad\",\n    value: function startLoad() {\n      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      this.logger.info('startLoad', 'begin to load ts data', 'time:', time);\n      if (isNaN(time)) {\n        this.logger.error('seekTime', 'seek', 'time:', time);\n        return;\n      }\n      this.startLoadTime = time;\n      this.loadSegmentByTime(time, 'start');\n    }\n  }, {\n    key: \"readBuffer\",\n    value: function readBuffer(time, callback) {\n      var segment = this.getSegmentByTime(time);\n      if (segment) {\n        this.readBufferByNo(segment.no, callback);\n      }\n    }\n  }, {\n    key: \"segmentLoaded\",\n    value: function segmentLoaded(segment, buffer) {\n      if (buffer) {\n        this.addBufferPool(buffer);\n      }\n      if (segment.no === this.options.player.currentIndex) {\n        this.readBufferByNo(segment.no);\n      }\n      if (segment.no < HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).getLast().no) {\n        this.loadSegmentByNo(segment.no + 1);\n      }\n    }\n  }, {\n    key: \"seekTime\",\n    value: function seekTime(time) {\n      if (isNaN(time)) {\n        this.logger.error('seekTime', 'seek', 'time:', time);\n        return;\n      }\n      this.currentSeekTime = time;\n      var buffer;\n      var idx = HLSDataManage_classPrivateFieldGet(_bufferPool, this).indexOfByTime(time);\n      if (idx > -1) {\n        buffer = HLSDataManage_classPrivateFieldGet(_bufferPool, this)[idx];\n        this.events.emit(EventsConfig.DataManageSeek, buffer, time);\n      } else {\n        this.removeBufferPool(HLSDataManage_classPrivateFieldGet(_bufferPool, this).length);\n        this.loadSegmentByTime(time, 'seek');\n      }\n    }\n  }, {\n    key: \"loadSegmentByTime\",\n    value: function loadSegmentByTime(time, type) {\n      if (isNaN(time)) {\n        return;\n      }\n      var idx = HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).indexOfByTime(time);\n      if (idx >= 0) {\n        var segment = HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this)[idx];\n        this.events.emit(EventsConfig.LoaderLoadFile, segment, type, time);\n      } else {\n        this.logger.error('loadSegmentByTime', 'time over', 'time:', time, 'type:', type);\n      }\n    }\n  }, {\n    key: \"createBuffer\",\n    value: function createBuffer(data, segment) {\n      if (!data) {\n        return;\n      }\n      var buffer = {\n        start: segment.start,\n        end: segment.end,\n        no: segment.no,\n        duration: segment.end - segment.start,\n        // blob: data.blob,\n        arrayBuffer: data.arrayBuffer\n      };\n      return new model_BufferModel(buffer);\n    }\n  }, {\n    key: \"isValidSegmentNo\",\n    value: function isValidSegmentNo(no) {\n      return !isNaN(no) && no > 0 && no <= HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).length;\n    }\n  }, {\n    key: \"loadSegmentByNo\",\n    value: function loadSegmentByNo(no) {\n      var idx = no - 1;\n      var segment = HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).get(idx);\n      if (!segment) {\n        return;\n      }\n      this.events.emit(EventsConfig.LoaderLoadFile, segment, 'play');\n    }\n\n    /**\r\n     * get buffer from bufferPool and the blob will convert to arrayBuffer\r\n     * @param {number} time \r\n     * @param {Function} callback [optional] \r\n     */\n  }, {\n    key: \"readBufferByNo\",\n    value: function readBufferByNo(no, callback) {\n      if (!this.isValidSegmentNo(no)) {\n        this.logger.error('readBufferByNo', 'check buffer no', 'is not valid no', no);\n        return;\n      }\n      this.readBufferNo = no;\n      callback = callback || function (buffer) {\n        this.events.emit(EventsConfig.DataManageRead, buffer);\n      };\n      this.getBlobByNo(no, callback);\n    }\n\n    /**\r\n     * get segment from segment by time\r\n     * @param {number} time \r\n     */\n  }, {\n    key: \"getSegmentByTime\",\n    value: function getSegmentByTime(time) {\n      var idx = HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).indexOfByTime(time);\n      var segment = HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this)[idx];\n      return segment;\n    }\n  }, {\n    key: \"getBlobByNo\",\n    value: function getBlobByNo(no, callback) {\n      if (isNaN(no)) {\n        this.logger.error('getBlobByNo', 'isNaN', 'no:', no);\n        return;\n      }\n      if (this.isBufferReading) {\n        this.logger.warn('getBlobByNo', 'isBufferReading', 'no:', no);\n        return;\n      }\n      var buffer;\n      this.isBufferReading = true;\n      buffer = HLSDataManage_classPrivateFieldGet(_bufferPool, this).getByKeyValue('no', no)[0];\n      if (typeof callback == 'function') {\n        callback.call(this, buffer);\n        if (buffer) {\n          this.removeBufferByNo(buffer.no);\n        }\n      }\n      this.isBufferReading = false;\n      return buffer;\n    }\n  }, {\n    key: \"addBufferPool\",\n    value: function addBufferPool(buffer) {\n      if (HLSDataManage_classPrivateFieldGet(_bufferPool, this).length) {\n        if (HLSDataManage_classPrivateFieldGet(_bufferPool, this)[0].no === buffer.no + 1) {\n          HLSDataManage_classPrivateFieldGet(_bufferPool, this).unshift(buffer);\n          return true;\n        }\n        var last = HLSDataManage_classPrivateFieldGet(_bufferPool, this).getLast();\n        if (buffer.no - last.no === 1) {\n          HLSDataManage_classPrivateFieldGet(_bufferPool, this).push(buffer);\n          return true;\n        }\n        if (HLSDataManage_classPrivateFieldGet(_bufferPool, this).indexOfByKey('no', buffer.no)) {\n          return true;\n        }\n        HLSDataManage_classPrivateFieldGet(_bufferPool, this).splice(0, HLSDataManage_classPrivateFieldGet(_bufferPool, this).length);\n      }\n      HLSDataManage_classPrivateFieldGet(_bufferPool, this).push(buffer);\n    }\n  }, {\n    key: \"removeBufferPool\",\n    value: function removeBufferPool(idx) {\n      // let buffer = this.#bufferPool.get(idx)\n      // remove all segment before the time\n      HLSDataManage_classPrivateFieldGet(_bufferPool, this).splice(0, idx + 1);\n    }\n  }, {\n    key: \"removeBufferByNo\",\n    value: function removeBufferByNo(no) {\n      var idx = HLSDataManage_classPrivateFieldGet(_bufferPool, this).indexOfByKey('no', no);\n      if (idx <= -1) {\n        return;\n      }\n      this.removeBufferPool(idx);\n      if (HLSDataManage_classPrivateFieldGet(_bufferPool, this).length) {\n        // while buffer pool is full to read, load next one after last\n        if (HLSDataManage_classPrivateFieldGet(_bufferPool, this).getLast().no < HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).getLast().no) {\n          this.loadSegmentByNo(HLSDataManage_classPrivateFieldGet(_bufferPool, this).getLast().no + 1);\n        }\n      } else if (no < HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).getLast().no) {\n        this.loadSegmentByNo(no + 1);\n      }\n      return true;\n    }\n  }, {\n    key: \"clear\",\n    value: function clear() {\n      this.sourceData = {};\n      this.readBufferNo = null;\n      this.currentSeekTime = null;\n      HLSDataManage_classPrivateFieldGet(_bufferPool, this).length = 0;\n      HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).length = 0;\n    }\n  }, {\n    key: \"getSegmentByNo\",\n    value: function getSegmentByNo(no) {\n      // segmentPool is readonly data\n      return HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).get(no - 1);\n    }\n  }, {\n    key: \"getSegment\",\n    value: function getSegment(time) {\n      return HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this).getByTime(time);\n    }\n  }, {\n    key: \"setSourceData\",\n    value: function setSourceData(sourceData) {\n      this.sourceData = sourceData;\n    }\n  }, {\n    key: \"getSourceData\",\n    value: function getSourceData() {\n      return this.sourceData;\n    }\n  }, {\n    key: \"setBufferPool\",\n    value: function setBufferPool(bufferPool) {\n      HLSDataManage_classPrivateFieldSet(_bufferPool, this, bufferPool);\n    }\n  }, {\n    key: \"getBufferPool\",\n    value: function getBufferPool() {\n      return HLSDataManage_classPrivateFieldGet(_bufferPool, this);\n    }\n  }, {\n    key: \"setSegmentPool\",\n    value: function setSegmentPool(segmentPool) {\n      HLSDataManage_classPrivateFieldSet(HLSDataManage_segmentPool, this, segmentPool);\n    }\n  }, {\n    key: \"getSegmentPool\",\n    value: function getSegmentPool() {\n      return HLSDataManage_classPrivateFieldGet(HLSDataManage_segmentPool, this);\n    }\n  }]);\n}(base_BaseClass);\n/* harmony default export */ var data_HLSDataManage = (HLSDataManage_HLSDataManage);\n// CONCATENATED MODULE: ../src/data/MP4DataManage.js\n\n\n\n\n\n\nfunction MP4DataManage_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, MP4DataManage_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction MP4DataManage_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (MP4DataManage_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file DataManage\r\n * @desc\r\n * ts load and data format \r\n * @author Jarry\r\n */\n\n\n\n\n\nvar MP4DataManage_MP4DataManage = /*#__PURE__*/function (_BaseClass) {\n  function MP4DataManage() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, MP4DataManage);\n    _this = MP4DataManage_callSuper(this, MP4DataManage);\n    defineProperty_default()(_this, \"bufferPool\", [/* new BufferModel */]);\n    defineProperty_default()(_this, \"sourceData\", {});\n    defineProperty_default()(_this, \"options\", {});\n    defineProperty_default()(_this, \"segmentPool\", [/* new SegmentModel */]);\n    defineProperty_default()(_this, \"readBufferNo\", null);\n    defineProperty_default()(_this, \"startLoadTime\", null);\n    defineProperty_default()(_this, \"currentSeekTime\", null);\n    _this.options = options;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(MP4DataManage, _BaseClass);\n  return createClass_default()(MP4DataManage, [{\n    key: \"init\",\n    value: function init() {\n      var _this2 = this;\n      this.setBufferPool(new data_BufferPool());\n      this.events.on(EventsConfig.DataManageReadBufferByNo, function (no, callback) {\n        _this2.readBufferByNo(no, callback);\n      });\n      this.events.on(EventsConfig.DataManageReadBuffer, function (time, callback) {\n        _this2.readBuffer(time, callback);\n      });\n      this.events.on(EventsConfig.LoaderLoaded, function (data, segment, type, time) {\n        // console.error('Events.LoaderLoaded', data, segment, time, this)\n        var buffer = _this2.createBuffer({\n          arrayBuffer: data.arrayBuffer\n        }, segment);\n        _this2.segmentLoaded(segment, buffer);\n        if (type === 'seek' && time === _this2.currentSeekTime) {\n          _this2.events.emit(EventsConfig.DataManageSeek, buffer, time);\n          _this2.removeBufferByNo(buffer.no);\n          return;\n        }\n        if (time === _this2.startLoadTime) {\n          _this2.events.emit(EventsConfig.DataManageFirstLoaded, buffer, time);\n        }\n      });\n    }\n  }, {\n    key: \"setOptions\",\n    value: function setOptions(options) {\n      Object.assign(this.options, options);\n    }\n  }, {\n    key: \"startLoad\",\n    value: function startLoad() {\n      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      this.logger.info('startLoad', 'begin to load ts data', 'time:', time);\n      if (isNaN(time)) {\n        this.logger.error('seekTime', 'seek', 'time:', time);\n        return;\n      }\n      this.startLoadTime = time;\n      this.loadSegmentByTime(time, 'start');\n    }\n  }, {\n    key: \"readBuffer\",\n    value: function readBuffer(time, callback) {\n      var segment = this.getSegmentByTime(time);\n      if (segment) {\n        this.readBufferByNo(segment.no, callback);\n      }\n    }\n  }, {\n    key: \"segmentLoaded\",\n    value: function segmentLoaded(segment, buffer) {\n      if (buffer) {\n        this.addBufferPool(buffer);\n      }\n      if (segment.no === this.options.player.currentIndex) {\n        this.readBufferByNo(segment.no);\n      }\n      if (segment.no < this.segmentPool.getLast().no) {\n        this.loadSegmentByNo(segment.no + 1);\n      }\n    }\n  }, {\n    key: \"seekTime\",\n    value: function seekTime(time) {\n      if (isNaN(time)) {\n        this.logger.error('seekTime', 'seek', 'time:', time);\n        return;\n      }\n      this.currentSeekTime = time;\n      var buffer;\n      var idx = this.bufferPool.indexOfByTime(time);\n      if (idx > -1) {\n        buffer = this.bufferPool[idx];\n        this.events.emit(EventsConfig.DataManageSeek, buffer, time);\n      } else {\n        this.removeBufferPool(this.bufferPool.length);\n        this.loadSegmentByTime(time, 'seek');\n      }\n    }\n  }, {\n    key: \"loadSegmentByTime\",\n    value: function loadSegmentByTime(time, type) {\n      if (isNaN(time)) {\n        return;\n      }\n      var idx = this.segmentPool.indexOfByTime(time);\n      if (idx >= 0) {\n        var segment = this.segmentPool[idx];\n        this.events.emit(EventsConfig.LoaderLoadFile, segment, type, time);\n      } else {\n        this.logger.error('loadSegmentByTime', 'time over', 'time:', time, 'type:', type);\n      }\n    }\n  }, {\n    key: \"createBuffer\",\n    value: function createBuffer(data, segment) {\n      if (!data) {\n        return;\n      }\n      var buffer = {\n        start: segment.start,\n        end: segment.end,\n        no: segment.no,\n        duration: segment.end - segment.start,\n        // blob: data.blob,\n        arrayBuffer: data.arrayBuffer\n      };\n      return new model_BufferModel(buffer);\n    }\n  }, {\n    key: \"isValidSegmentNo\",\n    value: function isValidSegmentNo(no) {\n      return !isNaN(no) && no > 0 && no <= this.segmentPool.length;\n    }\n  }, {\n    key: \"loadSegmentByNo\",\n    value: function loadSegmentByNo(no) {\n      var idx = no - 1;\n      var segment = this.segmentPool.get(idx);\n      if (!segment) {\n        return;\n      }\n      this.events.emit(EventsConfig.LoaderLoadFile, segment, 'play');\n    }\n\n    /**\r\n     * get buffer from bufferPool and the blob will convert to arrayBuffer\r\n     * @param {number} time \r\n     * @param {Function} callback [optional] \r\n     */\n  }, {\n    key: \"readBufferByNo\",\n    value: function readBufferByNo(no, callback) {\n      if (!this.isValidSegmentNo(no)) {\n        this.logger.error('readBufferByNo', 'check buffer no', 'is not valid no', no);\n        return;\n      }\n      this.readBufferNo = no;\n      callback = callback || function (buffer) {\n        this.events.emit(EventsConfig.DataManageRead, buffer);\n      };\n      this.getBlobByNo(no, callback);\n    }\n\n    /**\r\n     * get segment from segment by time\r\n     * @param {number} time \r\n     */\n  }, {\n    key: \"getSegmentByTime\",\n    value: function getSegmentByTime(time) {\n      var idx = this.segmentPool.indexOfByTime(time);\n      var segment = this.segmentPool[idx];\n      return segment;\n    }\n  }, {\n    key: \"getBlobByNo\",\n    value: function getBlobByNo(no, callback) {\n      if (isNaN(no)) {\n        this.logger.error('getBlobByNo', 'isNaN', 'no:', no);\n        return;\n      }\n      if (this.isBufferReading) {\n        this.logger.warn('getBlobByNo', 'isBufferReading', 'no:', no);\n        return;\n      }\n      var buffer;\n      this.isBufferReading = true;\n      buffer = this.bufferPool.getByKeyValue('no', no)[0];\n      if (typeof callback == 'function') {\n        callback.call(this, buffer);\n        if (buffer) {\n          this.removeBufferByNo(buffer.no);\n        }\n      }\n      this.isBufferReading = false;\n      return buffer;\n    }\n  }, {\n    key: \"addBufferPool\",\n    value: function addBufferPool(buffer) {\n      if (this.bufferPool.length) {\n        if (this.bufferPool[0].no === buffer.no + 1) {\n          this.bufferPool.unshift(buffer);\n          return true;\n        }\n        var last = this.bufferPool.getLast();\n        if (buffer.no - last.no === 1) {\n          this.bufferPool.push(buffer);\n          return true;\n        }\n        if (this.bufferPool.indexOfByKey('no', buffer.no)) {\n          return true;\n        }\n        this.bufferPool.splice(0, this.bufferPool.length);\n      }\n      this.bufferPool.push(buffer);\n    }\n  }, {\n    key: \"removeBufferPool\",\n    value: function removeBufferPool(idx) {\n      // let buffer = this.bufferPool.get(idx)\n      // remove all segment before the time\n      this.bufferPool.splice(0, idx + 1);\n    }\n  }, {\n    key: \"removeBufferByNo\",\n    value: function removeBufferByNo(no) {\n      var idx = this.bufferPool.indexOfByKey('no', no);\n      if (idx <= -1) {\n        return;\n      }\n      this.removeBufferPool(idx);\n      if (this.bufferPool.length) {\n        // while buffer pool is full to read, load next one after last\n        if (this.bufferPool.getLast().no < this.segmentPool.getLast().no) {\n          this.loadSegmentByNo(this.bufferPool.getLast().no + 1);\n        }\n      } else if (no < this.segmentPool.getLast().no) {\n        this.loadSegmentByNo(no + 1);\n      }\n      return true;\n    }\n  }, {\n    key: \"clear\",\n    value: function clear() {\n      this.sourceData = {};\n      this.readBufferNo = null;\n      this.currentSeekTime = null;\n      this.bufferPool.length = 0;\n      this.segmentPool.length = 0;\n    }\n  }, {\n    key: \"getSegmentByNo\",\n    value: function getSegmentByNo(no) {\n      // segmentPool is readonly data\n      return this.segmentPool.get(no - 1);\n    }\n  }, {\n    key: \"getSegment\",\n    value: function getSegment(time) {\n      return this.segmentPool.getByTime(time);\n    }\n  }, {\n    key: \"setSourceData\",\n    value: function setSourceData(sourceData) {\n      this.sourceData = sourceData;\n    }\n  }, {\n    key: \"getSourceData\",\n    value: function getSourceData() {\n      return this.sourceData;\n    }\n  }, {\n    key: \"setBufferPool\",\n    value: function setBufferPool(bufferPool) {\n      this.bufferPool = bufferPool;\n    }\n  }, {\n    key: \"getBufferPool\",\n    value: function getBufferPool() {\n      return this.bufferPool;\n    }\n  }, {\n    key: \"setSegmentPool\",\n    value: function setSegmentPool(segmentPool) {\n      this.segmentPool = segmentPool;\n    }\n  }, {\n    key: \"getSegmentPool\",\n    value: function getSegmentPool() {\n      return this.segmentPool;\n    }\n  }]);\n}(base_BaseClass);\n/* harmony default export */ var data_MP4DataManage = (MP4DataManage_MP4DataManage);\n// CONCATENATED MODULE: ../src/data/DataController.js\n\n\n\n\n\n\n\nfunction DataController_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, DataController_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction DataController_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (DataController_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file DataController.js\r\n * @desc data controller\r\n * @see\r\n * @author Jarry\r\n */\n\n\n\n\nvar DataController_DataController = /*#__PURE__*/function (_BaseController) {\n  function DataController(options) {\n    var _this;\n    classCallCheck_default()(this, DataController);\n    _this = DataController_callSuper(this, DataController);\n    defineProperty_default()(_this, \"type\", null);\n    defineProperty_default()(_this, \"dataManage\", null);\n    defineProperty_default()(_this, \"hlsDataManage\", null);\n    defineProperty_default()(_this, \"mp4DataManage\", null);\n    _this.options = options;\n    _this.type = _this.options.type || 'HLS';\n    return _this;\n  }\n  inherits_default()(DataController, _BaseController);\n  return createClass_default()(DataController, [{\n    key: \"setDataManage\",\n    value: function setDataManage(options) {\n      switch (options.type.toUpperCase()) {\n        case 'HLS':\n          this.setHLSDataManage(options);\n          this.dataManage = this.hlsDataManage;\n          break;\n        case 'MP4':\n          this.setMP4DataManage(options);\n          this.dataManage = this.mp4DataManage;\n          break;\n      }\n    }\n  }, {\n    key: \"setHLSDataManage\",\n    value: function setHLSDataManage() {\n      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {\n        args[_key] = arguments[_key];\n      }\n      this.hlsDataManage = construct_default()(data_HLSDataManage, args);\n    }\n  }, {\n    key: \"setMP4DataManage\",\n    value: function setMP4DataManage() {\n      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {\n        args[_key2] = arguments[_key2];\n      }\n      this.mp4DataManage = construct_default()(data_MP4DataManage, args);\n    }\n  }, {\n    key: \"getHLSDataManage\",\n    value: function getHLSDataManage() {\n      if (this.hlsDataManage == null) {\n        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {\n          args[_key3] = arguments[_key3];\n        }\n        this.setHLSDataManage(args);\n      }\n      return this.hlsDataManage;\n    }\n  }, {\n    key: \"getMP4DataManage\",\n    value: function getMP4DataManage() {\n      if (this.mp4DataManage == null) {\n        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {\n          args[_key4] = arguments[_key4];\n        }\n        this.mp4DataManage(args);\n      }\n      return this.mp4DataManage;\n    }\n  }, {\n    key: \"getMP4BufferPool\",\n    value: function getMP4BufferPool() {\n      return this.mp4DataManage.bufferPool;\n    }\n  }, {\n    key: \"getHLSBufferPool\",\n    value: function getHLSBufferPool() {\n      return this.hlsDataManage.getBufferPool();\n    }\n  }, {\n    key: \"setHLSSourceData\",\n    value: function setHLSSourceData(sourceData) {\n      this.hlsDataManage.setSourceData(sourceData);\n    }\n  }, {\n    key: \"setHLSSegmentPool\",\n    value: function setHLSSegmentPool(segmentPool) {\n      this.hlsDataManage.setSegmentPool(segmentPool);\n    }\n  }, {\n    key: \"startLoad\",\n    value: function startLoad(startTime) {\n      startTime = Math.max(startTime, 0);\n      switch (this.type.toUpperCase()) {\n        case 'HLS':\n          this.hlsDataManage.startLoad(startTime);\n          break;\n        case 'MP4':\n          this.mp4DataManage.startLoad(startTime);\n          break;\n        default:\n          this.logger.error('startLoad', 'type error', this.type);\n      }\n    }\n  }, {\n    key: \"clearDataManage\",\n    value: function clearDataManage() {\n      this.dataManage.clear();\n    }\n  }, {\n    key: \"getDataManage\",\n    value: function getDataManage(type) {\n      if (!type) {\n        return;\n      }\n      switch (type.toUpperCase()) {\n        case 'HLS':\n          return this.getHLSDataManage();\n        case 'MP4':\n          return this.getMP4DataManage();\n      }\n    }\n  }]);\n}(base_BaseController);\n/* harmony default export */ var data_DataController = (DataController_DataController);\n// CONCATENATED MODULE: ../src/action/Action.js\n\n\n\n\n\n\nfunction Action_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, Action_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction Action_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Action_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: include some operation, for example play, seek , pause\r\n * @author: liuliguo \r\n * @file: Action.js\r\n */\n\n\n\nvar Action_Action = /*#__PURE__*/function (_BaseClass) {\n  function Action(options) {\n    var _this;\n    classCallCheck_default()(this, Action);\n    _this = Action_callSuper(this, Action, [options]);\n    defineProperty_default()(_this, \"checkHanlder\", null);\n    defineProperty_default()(_this, \"resetStatus\", {\n      processor: false,\n      audioPlayer: false\n    });\n    _this.player = options.player;\n    if (!_this.player) {\n      return possibleConstructorReturn_default()(_this);\n    }\n    _this.audioPlayer = options.audioPlayer;\n    _this.imagePlayer = options.imagePlayer;\n    _this.dataManage = options.dataManage;\n    _this.bindEvent();\n    return _this;\n  }\n  inherits_default()(Action, _BaseClass);\n  return createClass_default()(Action, [{\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.ProcessorResetEnd, function () {\n        _this2.checkResetReady('processor');\n      });\n      this.events.on(EventsConfig.AudioPlayerReady, function () {\n        _this2.checkResetReady('audioPlayer');\n      });\n      this.events.on(EventsConfig.PlayerResetReady, function () {\n        _this2.onResetReady();\n      });\n      this.events.on(EventsConfig.DataManageSeek, function (data, timer) {\n        _this2.onSeek(data, timer);\n      });\n      this.events.on(EventsConfig.ImagePlayerRenderEnd, function (time, gap) {\n        _this2.onRenderEnd(time, gap);\n      });\n      this.events.on(EventsConfig.ImagePlayerWait, function () {\n        _this2.audioPlayer.pause();\n      });\n    }\n  }, {\n    key: \"play\",\n    value: function play(currentTime) {\n      this.logger.warn('play', 'play start');\n      this.sync(currentTime);\n    }\n  }, {\n    key: \"sync\",\n    value: function sync(time) {\n      var player = this.player;\n      var audioPlayer = this.audioPlayer;\n      if (player.duration() > 0 && player.currentTime / 1000 >= player.duration()) {\n        console.error(\"视频结束了\");\n        if (!audioPlayer.paused) {\n          audioPlayer.pause();\n        }\n        this.events.emit(EventsConfig.PlayerEnd);\n        return;\n      }\n      var imagePlayer = this.imagePlayer;\n      var aOffset = audioPlayer.offset;\n      var vOffset = imagePlayer.offset;\n      var minTime = Math.min(aOffset, vOffset);\n      var maxTime = Math.max(aOffset, vOffset);\n      if (!audioPlayer.need) {\n        minTime = vOffset;\n        maxTime = vOffset;\n      }\n      var playbackRate = player.playbackRate;\n      if (player.seeking) {\n        player.seeking = false;\n      }\n      if (player.reseting) {\n        return;\n      }\n      if (player.status === 'pause') {\n        return;\n      }\n      if (audioPlayer.status === 'waiting' || imagePlayer.status === 'wait') {\n        return;\n      }\n      if (player.status === 'end') {\n        if (!audioPlayer.paused) {\n          audioPlayer.pause();\n        }\n        return;\n      }\n      this.setCurrentTime(time);\n      if (time < minTime) {\n        this.sync(minTime);\n        return;\n      }\n      //only play audio\n      if (audioPlayer.need && time >= aOffset && time <= vOffset) {\n        this.events.once(EventsConfig.AudioPlayerPlaySuccess, function () {\n          imagePlayer.render(vOffset);\n        });\n        audioPlayer.playbackRate = playbackRate;\n        audioPlayer.play();\n        return;\n      }\n      //only play image\n      if (time >= vOffset && (!audioPlayer.need || time <= aOffset)) {\n        imagePlayer.render(time);\n        return;\n      }\n      //audio and image start play\n      if (time > maxTime) {\n        this.audioPlayer.playbackRate = playbackRate;\n        this.audioPlayer.play();\n        imagePlayer.render(time);\n      }\n    }\n  }, {\n    key: \"setCurrentTime\",\n    value: function setCurrentTime(time) {\n      this.player.currentTime = time;\n      this.events.emit(EventsConfig.PlayerTimeUpdate, time);\n    }\n  }, {\n    key: \"pause\",\n    value: function pause() {\n      this.audioPlayer.pause();\n      this.clearDrawHanlder();\n    }\n  }, {\n    key: \"seek\",\n    value: function seek(time) {\n      var _this3 = this;\n      var videoBuffered = this.imagePlayer.isBuffered(time);\n      var audioBuffered = this.audioPlayer.isBuffered(time);\n      this.player.pause();\n      //video and audio have the same time period\n      if (videoBuffered && audioBuffered) {\n        this.logger.warn('seek', \"seek in buffer, time: \".concat(time, \", buffer: \").concat(this.player.buffer()[0], \", \").concat(this.player.buffer()[1]));\n        this.audioPlayer.onSeekedHandler = function () {\n          _this3.player.play();\n        };\n        this.audioPlayer.currentTime = time;\n      } else {\n        this.reset();\n      }\n    }\n  }, {\n    key: \"reset\",\n    value: function reset(value) {\n      this.logger.info('reset', 'reset start');\n      this.player.reseting = true;\n      this.events.emit(EventsConfig.PlayerReset, value);\n      this.resetStatus = {\n        processor: false,\n        audioPlayer: false\n      };\n      this.player.processController.reset();\n      this.player.streamController.reset();\n      this.player.audioPlayer.reset(value);\n      this.player.imagePlayer.reset();\n      this.player.currentIndex = null;\n    }\n  }, {\n    key: \"checkResetReady\",\n    value: function checkResetReady(type) {\n      var resetStatus = this.resetStatus;\n      if (type && typeof type === 'string') {\n        resetStatus[type] = true;\n        var keys = Object.keys(resetStatus);\n        for (var i = 0; i < keys.length; i++) {\n          if (!resetStatus[keys[i]]) {\n            return false;\n          }\n        }\n        this.logger.warn('checkResetReady', 'reset ready');\n        this.events.emit(EventsConfig.PlayerResetReady);\n      }\n    }\n  }, {\n    key: \"onResetReady\",\n    value: function onResetReady() {\n      this.player.reseting = false;\n      this.logger.info('onResetReady', 'reset Ready');\n      if (this.player.changing) {\n        this.events.emit(EventsConfig.DataProcessorReady);\n      }\n      if (this.player.seeking) {\n        this.player.dataManage.seekTime(this.player.currentTime / 1000);\n      }\n    }\n  }, {\n    key: \"onSeek\",\n    value: function onSeek(data, timer) {\n      var currentTime = this.player.currentTime;\n      this.logger.info('onseek', currentTime, data, data.no, timer);\n      if (data && data.no && Math.abs(currentTime - Math.floor(timer * 1000)) < 2) {\n        this.player.currentIndex = data.no;\n        this.logger.info('seektime:', data.no, timer, this.player.currentTime);\n        this.player.seekSegmentNo = data.no;\n        this.player.streamController.startLoad(data.no);\n      } else {\n        this.logger.warn('seek failue, not found data', currentTime, data, timer);\n      }\n    }\n  }, {\n    key: \"clearDrawHanlder\",\n    value: function clearDrawHanlder() {\n      clearTimeout(this.drawFrameHanlder);\n      this.drawFrameHanlder = null;\n    }\n  }, {\n    key: \"onRenderEnd\",\n    value: function onRenderEnd(time, gap) {\n      if (this.player.seekTime) {\n        this.logger.info('onRenderEnd', 'seektoRenderTime:', Date.now() - this.player.seekTime);\n        this.player.seekTime = null;\n      }\n      var imagePlayer = this.imagePlayer;\n      var audioPlayer = this.audioPlayer;\n      var player = this.player;\n      var playbackRate = player.playbackRate;\n      var aCurrentTime = audioPlayer.currentTime;\n      var vCurrentTime = imagePlayer.currentTime;\n      var aOffset = audioPlayer.offset;\n      var fragDuration = imagePlayer.fragDuration;\n      var delay = aCurrentTime - vCurrentTime;\n      var nextTime = 0;\n      //no audio\n      if (!audioPlayer.need) {\n        this.drawNext(time + gap, Math.ceil(gap / playbackRate));\n        return;\n      }\n      //only play image\n      if (vCurrentTime < aOffset) {\n        this.drawNext(vCurrentTime + fragDuration * playbackRate, fragDuration);\n        return;\n      }\n      if (delay > 0) {\n        if (delay > fragDuration) {\n          nextTime = vCurrentTime + Math.ceil(delay / fragDuration + playbackRate) * fragDuration;\n          fragDuration = nextTime - aCurrentTime;\n        } else {\n          nextTime = vCurrentTime + fragDuration * playbackRate;\n          fragDuration = fragDuration - delay;\n        }\n      } else {\n        nextTime = vCurrentTime + fragDuration * playbackRate;\n        fragDuration = fragDuration - delay;\n      }\n      this.drawNext(nextTime, fragDuration);\n    }\n  }, {\n    key: \"drawNext\",\n    value: function drawNext(time, spanTime) {\n      var _this4 = this;\n      if (this.drawFrameHanlder) {\n        this.clearDrawHanlder();\n      }\n      this.drawFrameHanlder = setTimeout(function () {\n        _this4.sync(time);\n      }, spanTime);\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/lib/jmuxer.js\n\n\n\n\n\n\nfunction jmuxer_createForOfIteratorHelper(r, e) { var t = \"undefined\" != typeof Symbol && r[Symbol.iterator] || r[\"@@iterator\"]; if (!t) { if (Array.isArray(r) || (t = jmuxer_unsupportedIterableToArray(r)) || e && r && \"number\" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError(\"Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.\"); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }\nfunction jmuxer_unsupportedIterableToArray(r, a) { if (r) { if (\"string\" == typeof r) return jmuxer_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return \"Object\" === t && r.constructor && (t = r.constructor.name), \"Map\" === t || \"Set\" === t ? Array.from(r) : \"Arguments\" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? jmuxer_arrayLikeToArray(r, a) : void 0; } }\nfunction jmuxer_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }\nfunction jmuxer_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, jmuxer_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction jmuxer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (jmuxer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\nvar jmuxer_logger;\nvar errorLogger;\nfunction jmuxer_setLogger() {\n  /*eslint-disable */\n  jmuxer_logger = console.log;\n  errorLogger = console.error;\n  /*eslint-enable */\n}\nfunction log(message) {\n  if (jmuxer_logger) {\n    for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n      optionalParams[_key - 1] = arguments[_key];\n    }\n    jmuxer_logger.apply(void 0, [message].concat(optionalParams));\n  }\n}\nfunction jmuxer_error(message) {\n  if (errorLogger) {\n    for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {\n      optionalParams[_key2 - 1] = arguments[_key2];\n    }\n    errorLogger.apply(void 0, [message].concat(optionalParams));\n  }\n}\nvar jmuxer_NALU = /*#__PURE__*/function () {\n  function NALU(data) {\n    classCallCheck_default()(this, NALU);\n    this.payload = data;\n    this.nri = (this.payload[0] & 0x60) >> 5;\n    this.ntype = this.payload[0] & 0x1f;\n  }\n  return createClass_default()(NALU, [{\n    key: \"toString\",\n    value: function toString() {\n      return \"\".concat(NALU.type(this), \": NRI: \").concat(this.getNri());\n    }\n  }, {\n    key: \"getNri\",\n    value: function getNri() {\n      return this.nri >> 6;\n    }\n  }, {\n    key: \"type\",\n    value: function type() {\n      return this.ntype;\n    }\n  }, {\n    key: \"isKeyframe\",\n    value: function isKeyframe() {\n      return this.ntype == NALU.IDR;\n    }\n  }, {\n    key: \"getSize\",\n    value: function getSize() {\n      return 4 + this.payload.byteLength;\n    }\n  }, {\n    key: \"getData\",\n    value: function getData() {\n      var result = new Uint8Array(this.getSize());\n      var view = new DataView(result.buffer);\n      view.setUint32(0, this.getSize() - 4);\n      result.set(this.payload, 4);\n      return result;\n    }\n  }], [{\n    key: \"NDR\",\n    get: function get() {\n      return 1;\n    }\n  }, {\n    key: \"IDR\",\n    get: function get() {\n      return 5;\n    }\n  }, {\n    key: \"SEI\",\n    get: function get() {\n      return 6;\n    }\n  }, {\n    key: \"SPS\",\n    get: function get() {\n      return 7;\n    }\n  }, {\n    key: \"PPS\",\n    get: function get() {\n      return 8;\n    }\n  }, {\n    key: \"AUD\",\n    get: function get() {\n      return 9;\n    }\n  }, {\n    key: \"TYPES\",\n    get: function get() {\n      return defineProperty_default()(defineProperty_default()(defineProperty_default()(defineProperty_default()(defineProperty_default()(defineProperty_default()({}, NALU.IDR, 'IDR'), NALU.SEI, 'SEI'), NALU.SPS, 'SPS'), NALU.PPS, 'PPS'), NALU.NDR, 'NDR'), NALU.AUD, 'AUD');\n    }\n  }, {\n    key: \"type\",\n    value: function type(nalu) {\n      if (nalu.ntype in NALU.TYPES) {\n        return NALU.TYPES[nalu.ntype];\n      } else {\n        return 'UNKNOWN';\n      }\n    }\n  }]);\n}();\n/**\r\n * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.\r\n*/\nvar jmuxer_ExpGolomb = /*#__PURE__*/function () {\n  function ExpGolomb(data) {\n    classCallCheck_default()(this, ExpGolomb);\n    this.data = data;\n    this.index = 0;\n    this.bitLength = data.byteLength * 8;\n  }\n  return createClass_default()(ExpGolomb, [{\n    key: \"bitsAvailable\",\n    get: function get() {\n      return this.bitLength - this.index;\n    }\n  }, {\n    key: \"skipBits\",\n    value: function skipBits(size) {\n      // console.log(`  skip bits: size=${size}, ${this.index}.`);\n      if (this.bitsAvailable < size) {\n        //throw new Error('no bytes available');\n        return false;\n      }\n      this.index += size;\n    }\n  }, {\n    key: \"readBits\",\n    value: function readBits(size) {\n      var moveIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;\n      // console.log(`  read bits: size=${size}, ${this.index}.`);\n      var result = this.getBits(size, this.index, moveIndex);\n      // console.log(`    read bits: result=${result}`);\n      return result;\n    }\n  }, {\n    key: \"getBits\",\n    value: function getBits(size, offsetBits) {\n      var moveIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;\n      if (this.bitsAvailable < size) {\n        //throw new Error('no bytes available');\n        return 0;\n      }\n      var offset = offsetBits % 8;\n      var byte = this.data[offsetBits / 8 | 0] & 0xff >>> offset;\n      var bits = 8 - offset;\n      if (bits >= size) {\n        if (moveIndex) {\n          this.index += size;\n        }\n        return byte >> bits - size;\n      } else {\n        if (moveIndex) {\n          this.index += bits;\n        }\n        var nextSize = size - bits;\n        return byte << nextSize | this.getBits(nextSize, offsetBits + bits, moveIndex);\n      }\n    }\n  }, {\n    key: \"skipLZ\",\n    value: function skipLZ() {\n      var leadingZeroCount;\n      for (leadingZeroCount = 0; leadingZeroCount < this.bitLength - this.index; ++leadingZeroCount) {\n        if (this.getBits(1, this.index + leadingZeroCount, false) !== 0) {\n          // console.log(`  skip LZ  : size=${leadingZeroCount}, ${this.index}.`);\n          this.index += leadingZeroCount;\n          return leadingZeroCount;\n        }\n      }\n      return leadingZeroCount;\n    }\n  }, {\n    key: \"skipUEG\",\n    value: function skipUEG() {\n      this.skipBits(1 + this.skipLZ());\n    }\n  }, {\n    key: \"skipEG\",\n    value: function skipEG() {\n      this.skipBits(1 + this.skipLZ());\n    }\n  }, {\n    key: \"readUEG\",\n    value: function readUEG() {\n      var prefix = this.skipLZ();\n      return this.readBits(prefix + 1) - 1;\n    }\n  }, {\n    key: \"readEG\",\n    value: function readEG() {\n      var value = this.readUEG();\n      if (0x01 & value) {\n        // the number is odd if the low order bit is set\n        return 1 + value >>> 1; // add 1 to make it even, and divide by 2\n      } else {\n        return -1 * (value >>> 1); // divide by two then make it negative\n      }\n    }\n  }, {\n    key: \"readBoolean\",\n    value: function readBoolean() {\n      return this.readBits(1) === 1;\n    }\n  }, {\n    key: \"readUByte\",\n    value: function readUByte() {\n      var numberOfBytes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;\n      return this.readBits(numberOfBytes * 8);\n    }\n  }, {\n    key: \"readUShort\",\n    value: function readUShort() {\n      return this.readBits(16);\n    }\n  }, {\n    key: \"readUInt\",\n    value: function readUInt() {\n      return this.readBits(32);\n    }\n  }]);\n}();\nvar jmuxer_H264Parser = /*#__PURE__*/function () {\n  function H264Parser(remuxer) {\n    classCallCheck_default()(this, H264Parser);\n    this.remuxer = remuxer;\n    this.track = remuxer.mp4track;\n  }\n  return createClass_default()(H264Parser, [{\n    key: \"parseSPS\",\n    value: function parseSPS(sps) {\n      var config = H264Parser.readSPS(new Uint8Array(sps));\n      this.track.width = config.width;\n      this.track.height = config.height;\n      this.track.sps = [new Uint8Array(sps)];\n      this.track.codec = 'avc1.';\n      var codecarray = new DataView(sps.buffer, sps.byteOffset + 1, 4);\n      for (var i = 0; i < 3; ++i) {\n        var h = codecarray.getUint8(i).toString(16);\n        if (h.length < 2) {\n          h = '0' + h;\n        }\n        this.track.codec += h;\n      }\n    }\n  }, {\n    key: \"parsePPS\",\n    value: function parsePPS(pps) {\n      this.track.pps = [new Uint8Array(pps)];\n    }\n  }, {\n    key: \"parseNAL\",\n    value: function parseNAL(unit) {\n      if (!unit) return false;\n      var push = false;\n      switch (unit.type()) {\n        case jmuxer_NALU.NDR:\n          push = true;\n          break;\n        case jmuxer_NALU.IDR:\n          push = true;\n          break;\n        case jmuxer_NALU.PPS:\n          if (!this.track.pps) {\n            this.parsePPS(unit.getData().subarray(4));\n            if (!this.remuxer.readyToDecode && this.track.pps && this.track.sps) {\n              this.remuxer.readyToDecode = true;\n            }\n          }\n          push = true;\n          break;\n        case jmuxer_NALU.SPS:\n          if (!this.track.sps) {\n            this.parseSPS(unit.getData().subarray(4));\n            if (!this.remuxer.readyToDecode && this.track.pps && this.track.sps) {\n              this.remuxer.readyToDecode = true;\n            }\n          }\n          push = true;\n          break;\n        case jmuxer_NALU.AUD:\n          log('AUD - ignoing and disable HD mode for live channel');\n          if (this.remuxer.isHDAvail) {\n            this.remuxer.isHDAvail = false;\n          }\n          break;\n        case jmuxer_NALU.SEI:\n          log('SEI - ignoing');\n          break;\n        default:\n      }\n      return push;\n    }\n  }], [{\n    key: \"extractNALu\",\n    value: function extractNALu(buffer) {\n      var i = 0,\n        length = buffer.byteLength,\n        value,\n        state = 0,\n        result = [],\n        lastIndex;\n      while (i < length) {\n        value = buffer[i++];\n        // finding 3 or 4-byte start codes (00 00 01 OR 00 00 00 01)\n        switch (state) {\n          case 0:\n            if (value === 0) {\n              state = 1;\n            }\n            break;\n          case 1:\n            if (value === 0) {\n              state = 2;\n            } else {\n              state = 0;\n            }\n            break;\n          case 2:\n          case 3:\n            if (value === 0) {\n              state = 3;\n            } else if (value === 1 && i < length) {\n              if (lastIndex) {\n                result.push(buffer.subarray(lastIndex, i - state - 1));\n              }\n              lastIndex = i;\n              state = 0;\n            } else {\n              state = 0;\n            }\n            break;\n          default:\n            break;\n        }\n      }\n      if (lastIndex) {\n        result.push(buffer.subarray(lastIndex, length));\n      }\n      return result;\n    }\n\n    /**\r\n     * Advance the ExpGolomb decoder past a scaling list. The scaling\r\n     * list is optionally transmitted as part of a sequence parameter\r\n     * set and is not relevant to transmuxing.\r\n     * @param decoder {ExpGolomb} exp golomb decoder\r\n     * @param count {number} the number of entries in this scaling list\r\n     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1\r\n     */\n  }, {\n    key: \"skipScalingList\",\n    value: function skipScalingList(decoder, count) {\n      var lastScale = 8,\n        nextScale = 8,\n        deltaScale;\n      for (var j = 0; j < count; j++) {\n        if (nextScale !== 0) {\n          deltaScale = decoder.readEG();\n          nextScale = (lastScale + deltaScale + 256) % 256;\n        }\n        lastScale = nextScale === 0 ? lastScale : nextScale;\n      }\n    }\n\n    /**\r\n     * Read a sequence parameter set and return some interesting video\r\n     * properties. A sequence parameter set is the H264 metadata that\r\n     * describes the properties of upcoming video frames.\r\n     * @param data {Uint8Array} the bytes of a sequence parameter set\r\n     * @return {object} an object with configuration parsed from the\r\n     * sequence parameter set, including the dimensions of the\r\n     * associated video frames.\r\n     */\n  }, {\n    key: \"readSPS\",\n    value: function readSPS(data) {\n      var decoder = new jmuxer_ExpGolomb(data);\n      var frameCropLeftOffset = 0,\n        frameCropRightOffset = 0,\n        frameCropTopOffset = 0,\n        frameCropBottomOffset = 0,\n        sarScale = 1,\n        profileIdc,\n        profileCompat,\n        levelIdc,\n        numRefFramesInPicOrderCntCycle,\n        picWidthInMbsMinus1,\n        picHeightInMapUnitsMinus1,\n        frameMbsOnlyFlag,\n        scalingListCount;\n      decoder.readUByte();\n      profileIdc = decoder.readUByte(); // profile_idc\n      profileCompat = decoder.readBits(5); // constraint_set[0-4]_flag, u(5)\n      decoder.skipBits(3); // reserved_zero_3bits u(3),\n      levelIdc = decoder.readUByte(); // level_idc u(8)\n      decoder.skipUEG(); // seq_parameter_set_id\n      // some profiles have more optional data we don't need\n      if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {\n        var chromaFormatIdc = decoder.readUEG();\n        if (chromaFormatIdc === 3) {\n          decoder.skipBits(1); // separate_colour_plane_flag\n        }\n        decoder.skipUEG(); // bit_depth_luma_minus8\n        decoder.skipUEG(); // bit_depth_chroma_minus8\n        decoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag\n        if (decoder.readBoolean()) {\n          // seq_scaling_matrix_present_flag\n          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;\n          for (var i = 0; i < scalingListCount; ++i) {\n            if (decoder.readBoolean()) {\n              // seq_scaling_list_present_flag[ i ]\n              if (i < 6) {\n                H264Parser.skipScalingList(decoder, 16);\n              } else {\n                H264Parser.skipScalingList(decoder, 64);\n              }\n            }\n          }\n        }\n      }\n      decoder.skipUEG(); // log2_max_frame_num_minus4\n      var picOrderCntType = decoder.readUEG();\n      if (picOrderCntType === 0) {\n        decoder.readUEG(); // log2_max_pic_order_cnt_lsb_minus4\n      } else if (picOrderCntType === 1) {\n        decoder.skipBits(1); // delta_pic_order_always_zero_flag\n        decoder.skipEG(); // offset_for_non_ref_pic\n        decoder.skipEG(); // offset_for_top_to_bottom_field\n        numRefFramesInPicOrderCntCycle = decoder.readUEG();\n        for (var _i = 0; _i < numRefFramesInPicOrderCntCycle; ++_i) {\n          decoder.skipEG(); // offset_for_ref_frame[ i ]\n        }\n      }\n      decoder.skipUEG(); // max_num_ref_frames\n      decoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag\n      picWidthInMbsMinus1 = decoder.readUEG();\n      picHeightInMapUnitsMinus1 = decoder.readUEG();\n      frameMbsOnlyFlag = decoder.readBits(1);\n      if (frameMbsOnlyFlag === 0) {\n        decoder.skipBits(1); // mb_adaptive_frame_field_flag\n      }\n      decoder.skipBits(1); // direct_8x8_inference_flag\n      if (decoder.readBoolean()) {\n        // frame_cropping_flag\n        frameCropLeftOffset = decoder.readUEG();\n        frameCropRightOffset = decoder.readUEG();\n        frameCropTopOffset = decoder.readUEG();\n        frameCropBottomOffset = decoder.readUEG();\n      }\n      if (decoder.readBoolean()) {\n        // vui_parameters_present_flag\n        if (decoder.readBoolean()) {\n          // aspect_ratio_info_present_flag\n          var sarRatio;\n          var aspectRatioIdc = decoder.readUByte();\n          switch (aspectRatioIdc) {\n            case 1:\n              sarRatio = [1, 1];\n              break;\n            case 2:\n              sarRatio = [12, 11];\n              break;\n            case 3:\n              sarRatio = [10, 11];\n              break;\n            case 4:\n              sarRatio = [16, 11];\n              break;\n            case 5:\n              sarRatio = [40, 33];\n              break;\n            case 6:\n              sarRatio = [24, 11];\n              break;\n            case 7:\n              sarRatio = [20, 11];\n              break;\n            case 8:\n              sarRatio = [32, 11];\n              break;\n            case 9:\n              sarRatio = [80, 33];\n              break;\n            case 10:\n              sarRatio = [18, 11];\n              break;\n            case 11:\n              sarRatio = [15, 11];\n              break;\n            case 12:\n              sarRatio = [64, 33];\n              break;\n            case 13:\n              sarRatio = [160, 99];\n              break;\n            case 14:\n              sarRatio = [4, 3];\n              break;\n            case 15:\n              sarRatio = [3, 2];\n              break;\n            case 16:\n              sarRatio = [2, 1];\n              break;\n            case 255:\n              {\n                sarRatio = [decoder.readUByte() << 8 | decoder.readUByte(), decoder.readUByte() << 8 | decoder.readUByte()];\n                break;\n              }\n          }\n          if (sarRatio) {\n            sarScale = sarRatio[0] / sarRatio[1];\n          }\n        }\n        if (decoder.readBoolean()) {\n          decoder.skipBits(1);\n        }\n        if (decoder.readBoolean()) {\n          decoder.skipBits(4);\n          if (decoder.readBoolean()) {\n            decoder.skipBits(24);\n          }\n        }\n        if (decoder.readBoolean()) {\n          decoder.skipUEG();\n          decoder.skipUEG();\n        }\n        if (decoder.readBoolean()) {\n          var unitsInTick = decoder.readUInt();\n          var timeScale = decoder.readUInt();\n          var fixedFrameRate = decoder.readBoolean();\n        }\n      }\n      return {\n        width: Math.ceil(((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2) * sarScale),\n        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset)\n      };\n    }\n  }]);\n}();\nvar jmuxer_Event = /*#__PURE__*/function () {\n  function Event(type) {\n    classCallCheck_default()(this, Event);\n    this.listener = {};\n    this.type = type | '';\n  }\n  return createClass_default()(Event, [{\n    key: \"on\",\n    value: function on(event, fn) {\n      if (!this.listener[event]) {\n        this.listener[event] = [];\n      }\n      this.listener[event].push(fn);\n      return true;\n    }\n  }, {\n    key: \"off\",\n    value: function off(event, fn) {\n      if (this.listener[event]) {\n        var index = this.listener[event].indexOf(fn);\n        if (index > -1) {\n          this.listener[event].splice(index, 1);\n        }\n        return true;\n      }\n      return false;\n    }\n  }, {\n    key: \"offAll\",\n    value: function offAll() {\n      this.listener = {};\n    }\n  }, {\n    key: \"dispatch\",\n    value: function dispatch(event, data) {\n      if (this.listener[event]) {\n        this.listener[event].map(function (each) {\n          each.apply(null, [data]);\n        });\n        return true;\n      }\n      return false;\n    }\n  }]);\n}();\n/**\r\n * Generate MP4 Box\r\n * taken from: https://github.com/dailymotion/hls.js\r\n */\nvar UINT32_MAX = Math.pow(2, 32) - 1;\nvar jmuxer_MP4 = /*#__PURE__*/function () {\n  function MP4() {\n    classCallCheck_default()(this, MP4);\n  }\n  return createClass_default()(MP4, null, [{\n    key: \"init\",\n    value: function init() {\n      MP4.types = {\n        avc1: [],\n        // codingname\n        avcC: [],\n        btrt: [],\n        dinf: [],\n        dref: [],\n        esds: [],\n        ftyp: [],\n        hdlr: [],\n        mdat: [],\n        mdhd: [],\n        mdia: [],\n        mfhd: [],\n        minf: [],\n        moof: [],\n        moov: [],\n        mp4a: [],\n        mvex: [],\n        mvhd: [],\n        sdtp: [],\n        stbl: [],\n        stco: [],\n        stsc: [],\n        stsd: [],\n        stsz: [],\n        stts: [],\n        tfdt: [],\n        tfhd: [],\n        traf: [],\n        trak: [],\n        trun: [],\n        trex: [],\n        tkhd: [],\n        vmhd: [],\n        smhd: []\n      };\n      var i;\n      for (i in MP4.types) {\n        if (MP4.types.hasOwnProperty(i)) {\n          MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];\n        }\n      }\n      var videoHdlr = new Uint8Array([0x00,\n      // version 0\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x00,\n      // pre_defined\n      0x76, 0x69, 0x64, 0x65,\n      // handler_type: 'vide'\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'\n      ]);\n      var audioHdlr = new Uint8Array([0x00,\n      // version 0\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x00,\n      // pre_defined\n      0x73, 0x6f, 0x75, 0x6e,\n      // handler_type: 'soun'\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'\n      ]);\n      MP4.HDLR_TYPES = {\n        video: videoHdlr,\n        audio: audioHdlr\n      };\n      var dref = new Uint8Array([0x00,\n      // version 0\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x01,\n      // entry_count\n      0x00, 0x00, 0x00, 0x0c,\n      // entry_size\n      0x75, 0x72, 0x6c, 0x20,\n      // 'url' type\n      0x00,\n      // version 0\n      0x00, 0x00, 0x01 // entry_flags\n      ]);\n      var stco = new Uint8Array([0x00,\n      // version\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x00 // entry_count\n      ]);\n      MP4.STTS = MP4.STSC = MP4.STCO = stco;\n      MP4.STSZ = new Uint8Array([0x00,\n      // version\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x00,\n      // sample_size\n      0x00, 0x00, 0x00, 0x00 // sample_count\n      ]);\n      MP4.VMHD = new Uint8Array([0x00,\n      // version\n      0x00, 0x00, 0x01,\n      // flags\n      0x00, 0x00,\n      // graphicsmode\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor\n      ]);\n      MP4.SMHD = new Uint8Array([0x00,\n      // version\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00,\n      // balance\n      0x00, 0x00 // reserved\n      ]);\n      MP4.STSD = new Uint8Array([0x00,\n      // version 0\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x01]); // entry_count\n\n      var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom\n      var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1\n      var minorVersion = new Uint8Array([0, 0, 0, 1]);\n      MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);\n      MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));\n    }\n  }, {\n    key: \"box\",\n    value: function box(type) {\n      for (var _len3 = arguments.length, payload = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {\n        payload[_key3 - 1] = arguments[_key3];\n      }\n      var size = 8,\n        i = payload.length,\n        len = i,\n        result;\n      // calculate the total size we need to allocate\n      while (i--) {\n        size += payload[i].byteLength;\n      }\n      result = new Uint8Array(size);\n      result[0] = size >> 24 & 0xff;\n      result[1] = size >> 16 & 0xff;\n      result[2] = size >> 8 & 0xff;\n      result[3] = size & 0xff;\n      result.set(type, 4);\n      // copy the payload into the result\n      for (i = 0, size = 8; i < len; ++i) {\n        // copy payload[i] array @ offset size\n        result.set(payload[i], size);\n        size += payload[i].byteLength;\n      }\n      return result;\n    }\n  }, {\n    key: \"hdlr\",\n    value: function hdlr(type) {\n      return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);\n    }\n  }, {\n    key: \"mdat\",\n    value: function mdat(data) {\n      return MP4.box(MP4.types.mdat, data);\n    }\n  }, {\n    key: \"mdhd\",\n    value: function mdhd(timescale, duration) {\n      duration *= timescale;\n      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));\n      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));\n      return MP4.box(MP4.types.mdhd, new Uint8Array([0x01,\n      // version 1\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,\n      // creation_time\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,\n      // modification_time\n      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF,\n      // timescale\n      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x55, 0xc4,\n      // 'und' language (undetermined)\n      0x00, 0x00]));\n    }\n  }, {\n    key: \"mdia\",\n    value: function mdia(track) {\n      return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));\n    }\n  }, {\n    key: \"mfhd\",\n    value: function mfhd(sequenceNumber) {\n      return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00,\n      // flags\n      sequenceNumber >> 24, sequenceNumber >> 16 & 0xFF, sequenceNumber >> 8 & 0xFF, sequenceNumber & 0xFF // sequence_number\n      ]));\n    }\n  }, {\n    key: \"minf\",\n    value: function minf(track) {\n      if (track.type === 'audio') {\n        return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));\n      } else {\n        return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));\n      }\n    }\n  }, {\n    key: \"moof\",\n    value: function moof(sn, baseMediaDecodeTime, track) {\n      return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));\n    }\n    /**\r\n     * @param tracks... (optional) {array} the tracks associated with this movie\r\n     */\n  }, {\n    key: \"moov\",\n    value: function moov(tracks, duration, timescale) {\n      var i = tracks.length,\n        boxes = [];\n      while (i--) {\n        boxes[i] = MP4.trak(tracks[i]);\n      }\n      return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(timescale, duration)].concat(boxes).concat(MP4.mvex(tracks)));\n    }\n  }, {\n    key: \"mvex\",\n    value: function mvex(tracks) {\n      var i = tracks.length,\n        boxes = [];\n      while (i--) {\n        boxes[i] = MP4.trex(tracks[i]);\n      }\n      return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));\n    }\n  }, {\n    key: \"mvhd\",\n    value: function mvhd(timescale, duration) {\n      duration *= timescale;\n      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));\n      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));\n      var bytes = new Uint8Array([0x01,\n      // version 1\n      0x00, 0x00, 0x00,\n      // flags\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,\n      // creation_time\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,\n      // modification_time\n      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF,\n      // timescale\n      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x01, 0x00, 0x00,\n      // 1.0 rate\n      0x01, 0x00,\n      // 1.0 volume\n      0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,\n      // transformation: unity matrix\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\n      // pre_defined\n      0xff, 0xff, 0xff, 0xff // next_track_ID\n      ]);\n      return MP4.box(MP4.types.mvhd, bytes);\n    }\n  }, {\n    key: \"sdtp\",\n    value: function sdtp(track) {\n      var samples = track.samples || [],\n        bytes = new Uint8Array(4 + samples.length),\n        flags,\n        i;\n      // leave the full box header (4 bytes) all zero\n      // write the sample table\n      for (i = 0; i < samples.length; i++) {\n        flags = samples[i].flags;\n        bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;\n      }\n      return MP4.box(MP4.types.sdtp, bytes);\n    }\n  }, {\n    key: \"stbl\",\n    value: function stbl(track) {\n      return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));\n    }\n  }, {\n    key: \"avc1\",\n    value: function avc1(track) {\n      var sps = [],\n        pps = [],\n        i,\n        data,\n        len;\n      // assemble the SPSs\n\n      for (i = 0; i < track.sps.length; i++) {\n        data = track.sps[i];\n        len = data.byteLength;\n        sps.push(len >>> 8 & 0xFF);\n        sps.push(len & 0xFF);\n        sps = sps.concat(Array.prototype.slice.call(data)); // SPS\n      }\n\n      // assemble the PPSs\n      for (i = 0; i < track.pps.length; i++) {\n        data = track.pps[i];\n        len = data.byteLength;\n        pps.push(len >>> 8 & 0xFF);\n        pps.push(len & 0xFF);\n        pps = pps.concat(Array.prototype.slice.call(data));\n      }\n      var avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01,\n        // version\n        sps[3],\n        // profile\n        sps[4],\n        // profile compat\n        sps[5],\n        // level\n        0xfc | 3,\n        // lengthSizeMinusOne, hard-coded to 4 bytes\n        0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets\n        ].concat(sps).concat([track.pps.length // numOfPictureParameterSets\n        ]).concat(pps))),\n        // \"PPS\"\n        width = track.width,\n        height = track.height;\n      // console.log('avcc:' + Hex.hexDump(avcc));\n      return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x01,\n      // data_reference_index\n      0x00, 0x00,\n      // pre_defined\n      0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\n      // pre_defined\n      width >> 8 & 0xFF, width & 0xff,\n      // width\n      height >> 8 & 0xFF, height & 0xff,\n      // height\n      0x00, 0x48, 0x00, 0x00,\n      // horizresolution\n      0x00, 0x48, 0x00, 0x00,\n      // vertresolution\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x01,\n      // frame_count\n      0x12, 0x62, 0x69, 0x6E, 0x65,\n      // binelpro.ru\n      0x6C, 0x70, 0x72, 0x6F, 0x2E, 0x72, 0x75, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\n      // compressorname\n      0x00, 0x18,\n      // depth = 24\n      0x11, 0x11]),\n      // pre_defined = -1\n      avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80,\n      // bufferSizeDB\n      0x00, 0x2d, 0xc6, 0xc0,\n      // maxBitrate\n      0x00, 0x2d, 0xc6, 0xc0])) // avgBitrate\n      );\n    }\n  }, {\n    key: \"esds\",\n    value: function esds(track) {\n      var configlen = track.config.byteLength;\n      var data = new Uint8Array(26 + configlen + 3);\n      data.set([0x00,\n      // version 0\n      0x00, 0x00, 0x00,\n      // flags\n\n      0x03,\n      // descriptor_type\n      0x17 + configlen,\n      // length\n      0x00, 0x01,\n      // es_id\n      0x00,\n      // stream_priority\n\n      0x04,\n      // descriptor_type\n      0x0f + configlen,\n      // length\n      0x40,\n      // codec : mpeg4_audio\n      0x15,\n      // stream_type\n      0x00, 0x00, 0x00,\n      // buffer_size\n      0x00, 0x00, 0x00, 0x00,\n      // maxBitrate\n      0x00, 0x00, 0x00, 0x00,\n      // avgBitrate\n\n      0x05,\n      // descriptor_type\n      configlen]);\n      data.set(track.config, 26);\n      data.set([0x06, 0x01, 0x02], 26 + configlen);\n      // return new Uint8Array([\n      //     0x00, // version 0\n      //     0x00, 0x00, 0x00, // flags\n      //\n      //     0x03, // descriptor_type\n      //     0x17+configlen, // length\n      //     0x00, 0x01, //es_id\n      //     0x00, // stream_priority\n      //\n      //     0x04, // descriptor_type\n      //     0x0f+configlen, // length\n      //     0x40, //codec : mpeg4_audio\n      //     0x15, // stream_type\n      //     0x00, 0x00, 0x00, // buffer_size\n      //     0x00, 0x00, 0x00, 0x00, // maxBitrate\n      //     0x00, 0x00, 0x00, 0x00, // avgBitrate\n      //\n      //     0x05 // descriptor_type\n      // ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor\n      return data;\n    }\n  }, {\n    key: \"mp4a\",\n    value: function mp4a(track) {\n      var audiosamplerate = track.audiosamplerate;\n      return MP4.box(MP4.types.mp4a, new Uint8Array([0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x01,\n      // data_reference_index\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, track.channelCount,\n      // channelcount\n      0x00, 0x10,\n      // sampleSize:16bits\n      0x00, 0x00,\n      // pre_defined\n      0x00, 0x00,\n      // reserved2\n      audiosamplerate >> 8 & 0xFF, audiosamplerate & 0xff,\n      //\n      0x00, 0x00]), MP4.box(MP4.types.esds, MP4.esds(track)));\n    }\n  }, {\n    key: \"stsd\",\n    value: function stsd(track) {\n      if (track.type === 'audio') {\n        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));\n      } else {\n        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));\n      }\n    }\n  }, {\n    key: \"tkhd\",\n    value: function tkhd(track) {\n      var id = track.id,\n        duration = track.duration * track.timescale,\n        width = track.width,\n        height = track.height,\n        upperWordDuration = Math.floor(duration / (UINT32_MAX + 1)),\n        lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));\n      return MP4.box(MP4.types.tkhd, new Uint8Array([0x01,\n      // version 1\n      0x00, 0x00, 0x07,\n      // flags\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,\n      // creation_time\n      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,\n      // modification_time\n      id >> 24 & 0xFF, id >> 16 & 0xFF, id >> 8 & 0xFF, id & 0xFF,\n      // track_ID\n      0x00, 0x00, 0x00, 0x00,\n      // reserved\n      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\n      // reserved\n      0x00, 0x00,\n      // layer\n      0x00, 0x00,\n      // alternate_group\n      0x00, 0x00,\n      // non-audio track volume\n      0x00, 0x00,\n      // reserved\n      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,\n      // transformation: unity matrix\n      width >> 8 & 0xFF, width & 0xFF, 0x00, 0x00,\n      // width\n      height >> 8 & 0xFF, height & 0xFF, 0x00, 0x00 // height\n      ]));\n    }\n  }, {\n    key: \"traf\",\n    value: function traf(track, baseMediaDecodeTime) {\n      var sampleDependencyTable = MP4.sdtp(track),\n        id = track.id,\n        upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1)),\n        lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));\n      return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00,\n      // version 0\n      0x00, 0x00, 0x00,\n      // flags\n      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF // track_ID\n      ])), MP4.box(MP4.types.tfdt, new Uint8Array([0x01,\n      // version 1\n      0x00, 0x00, 0x00,\n      // flags\n      upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0XFF, upperWordBaseMediaDecodeTime >> 8 & 0XFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0XFF, lowerWordBaseMediaDecodeTime >> 8 & 0XFF, lowerWordBaseMediaDecodeTime & 0xFF])), MP4.trun(track, sampleDependencyTable.length + 16 +\n      // tfhd\n      20 +\n      // tfdt\n      8 +\n      // traf header\n      16 +\n      // mfhd\n      8 +\n      // moof header\n      8),\n      // mdat header\n      sampleDependencyTable);\n    }\n\n    /**\r\n     * Generate a track box.\r\n     * @param track {object} a track definition\r\n     * @return {Uint8Array} the track box\r\n     */\n  }, {\n    key: \"trak\",\n    value: function trak(track) {\n      track.duration = track.duration || 0xffffffff;\n      return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));\n    }\n  }, {\n    key: \"trex\",\n    value: function trex(track) {\n      var id = track.id;\n      return MP4.box(MP4.types.trex, new Uint8Array([0x00,\n      // version 0\n      0x00, 0x00, 0x00,\n      // flags\n      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF,\n      // track_ID\n      0x00, 0x00, 0x00, 0x01,\n      // default_sample_description_index\n      0x00, 0x00, 0x00, 0x00,\n      // default_sample_duration\n      0x00, 0x00, 0x00, 0x00,\n      // default_sample_size\n      0x00, 0x01, 0x00, 0x01 // default_sample_flags\n      ]));\n    }\n  }, {\n    key: \"trun\",\n    value: function trun(track, offset) {\n      var samples = track.samples || [],\n        len = samples.length,\n        arraylen = 12 + 16 * len,\n        array = new Uint8Array(arraylen),\n        i,\n        sample,\n        duration,\n        size,\n        flags,\n        cts;\n      offset += 8 + arraylen;\n      array.set([0x00,\n      // version 0\n      0x00, 0x0f, 0x01,\n      // flags\n      len >>> 24 & 0xFF, len >>> 16 & 0xFF, len >>> 8 & 0xFF, len & 0xFF,\n      // sample_count\n      offset >>> 24 & 0xFF, offset >>> 16 & 0xFF, offset >>> 8 & 0xFF, offset & 0xFF // data_offset\n      ], 0);\n      for (i = 0; i < len; i++) {\n        sample = samples[i];\n        duration = sample.duration;\n        size = sample.size;\n        flags = sample.flags;\n        cts = sample.cts;\n        array.set([duration >>> 24 & 0xFF, duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF,\n        // sample_duration\n        size >>> 24 & 0xFF, size >>> 16 & 0xFF, size >>> 8 & 0xFF, size & 0xFF,\n        // sample_size\n        flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xF0 << 8, flags.degradPrio & 0x0F,\n        // sample_flags\n        cts >>> 24 & 0xFF, cts >>> 16 & 0xFF, cts >>> 8 & 0xFF, cts & 0xFF // sample_composition_time_offset\n        ], 12 + 16 * i);\n      }\n      return MP4.box(MP4.types.trun, array);\n    }\n  }, {\n    key: \"initSegment\",\n    value: function initSegment(tracks, duration, timescale) {\n      if (!MP4.types) {\n        MP4.init();\n      }\n      var movie = MP4.moov(tracks, duration, timescale),\n        result;\n      result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);\n      result.set(MP4.FTYP);\n      result.set(movie, MP4.FTYP.byteLength);\n      return result;\n    }\n  }]);\n}();\nvar jmuxer_AACParser = /*#__PURE__*/function () {\n  function AACParser(remuxer) {\n    classCallCheck_default()(this, AACParser);\n    this.remuxer = remuxer;\n    this.track = remuxer.mp4track;\n    this.aacHeader = null;\n  }\n  return createClass_default()(AACParser, [{\n    key: \"samplingRateMap\",\n    get: function get() {\n      return [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];\n    }\n  }, {\n    key: \"getAACHeaderData\",\n    get: function get() {\n      return this.aacHeader;\n    }\n  }, {\n    key: \"setAACHeaderData\",\n    set: function set() {\n      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;\n      this.aacHeader = data;\n    }\n  }, {\n    key: \"getHeaderLength\",\n    value: function getHeaderLength(data) {\n      return data[1] & 0x01 ? 7 : 9; // without CRC 7 and with CRC 9 Refs: https://wiki.multimedia.cx/index.php?title=ADTS\n    }\n  }, {\n    key: \"getFrameLength\",\n    value: function getFrameLength(data) {\n      return (data[3] & 0x03) << 11 | data[4] << 3 | (data[5] & 0xE0) >>> 5; // 13 bits length ref: https://wiki.multimedia.cx/index.php?title=ADTS\n    }\n  }, {\n    key: \"isAACPattern\",\n    value: function isAACPattern(data) {\n      return data[0] === 0xff && (data[1] & 0xf0) === 0xf0 && (data[1] & 0x06) === 0x00;\n    }\n  }, {\n    key: \"extractAAC\",\n    value: function extractAAC(buffer) {\n      var i = 0,\n        length = buffer.byteLength,\n        result = [],\n        headerLength,\n        frameLength;\n      if (!this.isAACPattern(buffer)) {\n        jmuxer_error('Invalid ADTS audio format');\n        return result;\n      }\n      headerLength = this.getHeaderLength(buffer);\n      if (!this.aacHeader) {\n        this.aacHeader = buffer.subarray(0, headerLength);\n      }\n      while (i < length) {\n        frameLength = this.getFrameLength(buffer);\n        result.push(buffer.subarray(headerLength, frameLength));\n        buffer = buffer.slice(frameLength);\n        i += frameLength;\n      }\n      return result;\n    }\n  }, {\n    key: \"setAACConfig\",\n    value: function setAACConfig() {\n      var objectType,\n        sampleIndex,\n        channelCount,\n        config = new Uint8Array(2),\n        headerData = this.getAACHeaderData;\n      if (!headerData) return;\n      objectType = ((headerData[2] & 0xC0) >>> 6) + 1;\n      sampleIndex = (headerData[2] & 0x3C) >>> 2;\n      channelCount = (headerData[2] & 0x01) << 2;\n      channelCount |= (headerData[3] & 0xC0) >>> 6;\n\n      /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config */\n      config[0] = objectType << 3;\n      config[0] |= (sampleIndex & 0x0E) >> 1;\n      config[1] |= (sampleIndex & 0x01) << 7;\n      config[1] |= channelCount << 3;\n      this.track.codec = 'mp4a.40.' + objectType;\n      this.track.channelCount = channelCount;\n      this.track.config = config;\n      this.remuxer.readyToDecode = true;\n    }\n  }]);\n}();\nvar track_id = 1;\nvar jmuxer_BaseRemuxer = /*#__PURE__*/function () {\n  function BaseRemuxer() {\n    classCallCheck_default()(this, BaseRemuxer);\n    this.seq = 1;\n  }\n  return createClass_default()(BaseRemuxer, [{\n    key: \"flush\",\n    value: function flush() {\n      this.seq++;\n      this.mp4track.len = 0;\n      this.mp4track.samples = [];\n    }\n  }, {\n    key: \"isReady\",\n    value: function isReady() {\n      if (!this.readyToDecode || !this.samples.length) return null;\n      return true;\n    }\n  }], [{\n    key: \"getTrackID\",\n    value: function getTrackID() {\n      return track_id++;\n    }\n  }]);\n}();\nvar jmuxer_AACRemuxer = /*#__PURE__*/function (_BaseRemuxer) {\n  function AACRemuxer() {\n    var _this;\n    classCallCheck_default()(this, AACRemuxer);\n    _this = jmuxer_callSuper(this, AACRemuxer);\n    _this.readyToDecode = false;\n    _this.nextDts = 0;\n    _this.dts = 0;\n    _this.timescale = 1000;\n    _this.mp4track = {\n      id: jmuxer_BaseRemuxer.getTrackID(),\n      type: 'audio',\n      channelCount: 0,\n      len: 0,\n      fragmented: true,\n      timescale: _this.timescale,\n      duration: _this.timescale,\n      samples: [],\n      config: '',\n      codec: ''\n    };\n    _this.samples = [];\n    _this.aac = new jmuxer_AACParser(_this);\n    return _this;\n  }\n  inherits_default()(AACRemuxer, _BaseRemuxer);\n  return createClass_default()(AACRemuxer, [{\n    key: \"resetTrack\",\n    value: function resetTrack() {\n      this.readyToDecode = false;\n      this.mp4track.codec = '';\n      this.mp4track.channelCount = '';\n      this.mp4track.config = '';\n      this.mp4track.timescale = this.timescale;\n    }\n  }, {\n    key: \"remux\",\n    value: function remux(samples) {\n      var config, sample, size, payload;\n      var _iterator = jmuxer_createForOfIteratorHelper(samples),\n        _step;\n      try {\n        for (_iterator.s(); !(_step = _iterator.n()).done;) {\n          var _sample = _step.value;\n          payload = _sample.units;\n          size = payload.byteLength;\n          this.samples.push({\n            units: payload,\n            size: size,\n            duration: _sample.duration\n          });\n          this.mp4track.len += size;\n          if (!this.readyToDecode) {\n            this.aac.setAACConfig();\n          }\n        }\n      } catch (err) {\n        _iterator.e(err);\n      } finally {\n        _iterator.f();\n      }\n    }\n  }, {\n    key: \"getPayload\",\n    value: function getPayload() {\n      if (!this.isReady()) {\n        return null;\n      }\n      var payload = new Uint8Array(this.mp4track.len);\n      var offset = 0;\n      var samples = this.mp4track.samples;\n      var mp4Sample, duration;\n      this.dts = this.nextDts;\n      while (this.samples.length) {\n        var sample = this.samples.shift();\n        duration = sample.duration;\n        if (duration <= 0) {\n          log(\"remuxer: invalid sample duration at DTS: \".concat(this.nextDts, \" :\").concat(duration));\n          this.mp4track.len -= sample.size;\n          continue;\n        }\n        this.nextDts += duration;\n        mp4Sample = {\n          size: sample.size,\n          duration: duration,\n          cts: 0,\n          flags: {\n            isLeading: 0,\n            isDependedOn: 0,\n            hasRedundancy: 0,\n            degradPrio: 0,\n            dependsOn: 1\n          }\n        };\n        payload.set(sample.units, offset);\n        offset += sample.size;\n        samples.push(mp4Sample);\n      }\n      if (!samples.length) return null;\n      return new Uint8Array(payload.buffer, 0, this.mp4track.len);\n    }\n  }]);\n}(jmuxer_BaseRemuxer);\nvar jmuxer_H264Remuxer = /*#__PURE__*/function (_BaseRemuxer2) {\n  function H264Remuxer() {\n    var _this2;\n    classCallCheck_default()(this, H264Remuxer);\n    _this2 = jmuxer_callSuper(this, H264Remuxer);\n    _this2.readyToDecode = false;\n    _this2.nextDts = 0;\n    _this2.dts = 0;\n    _this2.timescale = 1000;\n    _this2.mp4track = {\n      id: jmuxer_BaseRemuxer.getTrackID(),\n      type: 'video',\n      len: 0,\n      fragmented: true,\n      sps: '',\n      pps: '',\n      width: 0,\n      height: 0,\n      timescale: _this2.timescale,\n      duration: _this2.timescale,\n      samples: []\n    };\n    _this2.samples = [];\n    _this2.h264 = new jmuxer_H264Parser(_this2);\n    return _this2;\n  }\n  inherits_default()(H264Remuxer, _BaseRemuxer2);\n  return createClass_default()(H264Remuxer, [{\n    key: \"resetTrack\",\n    value: function resetTrack() {\n      this.readyToDecode = false;\n      this.mp4track.sps = '';\n      this.mp4track.pps = '';\n    }\n  }, {\n    key: \"remux\",\n    value: function remux(samples) {\n      var sample, units, unit, size, keyFrame;\n      var _iterator2 = jmuxer_createForOfIteratorHelper(samples),\n        _step2;\n      try {\n        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {\n          sample = _step2.value;\n          units = [];\n          size = 0;\n          keyFrame = false;\n          var _iterator3 = jmuxer_createForOfIteratorHelper(sample.units),\n            _step3;\n          try {\n            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {\n              unit = _step3.value;\n              if (this.h264.parseNAL(unit)) {\n                units.push(unit);\n                size += unit.getSize();\n                if (!keyFrame) {\n                  keyFrame = unit.isKeyframe();\n                }\n              }\n            }\n          } catch (err) {\n            _iterator3.e(err);\n          } finally {\n            _iterator3.f();\n          }\n          if (units.length > 0 && this.readyToDecode) {\n            this.mp4track.len += size;\n            this.samples.push({\n              units: units,\n              size: size,\n              keyFrame: keyFrame,\n              duration: sample.duration\n            });\n          }\n        }\n      } catch (err) {\n        _iterator2.e(err);\n      } finally {\n        _iterator2.f();\n      }\n    }\n  }, {\n    key: \"getPayload\",\n    value: function getPayload() {\n      if (!this.isReady()) {\n        return null;\n      }\n      var payload = new Uint8Array(this.mp4track.len);\n      var offset = 0;\n      var samples = this.mp4track.samples;\n      var mp4Sample, duration;\n      this.dts = this.nextDts;\n      while (this.samples.length) {\n        var sample = this.samples.shift(),\n          units = sample.units;\n        duration = sample.duration;\n        if (duration <= 0) {\n          log(\"remuxer: invalid sample duration at DTS: \".concat(this.nextDts, \" :\").concat(duration));\n          this.mp4track.len -= sample.size;\n          continue;\n        }\n        this.nextDts += duration;\n        mp4Sample = {\n          size: sample.size,\n          duration: duration,\n          cts: 0,\n          flags: {\n            isLeading: 0,\n            isDependedOn: 0,\n            hasRedundancy: 0,\n            degradPrio: 0,\n            isNonSync: sample.keyFrame ? 0 : 1,\n            dependsOn: sample.keyFrame ? 2 : 1\n          }\n        };\n        var _iterator4 = jmuxer_createForOfIteratorHelper(units),\n          _step4;\n        try {\n          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {\n            var unit = _step4.value;\n            payload.set(unit.getData(), offset);\n            offset += unit.getSize();\n          }\n        } catch (err) {\n          _iterator4.e(err);\n        } finally {\n          _iterator4.f();\n        }\n        samples.push(mp4Sample);\n      }\n      if (!samples.length) return null;\n      return new Uint8Array(payload.buffer, 0, this.mp4track.len);\n    }\n  }]);\n}(jmuxer_BaseRemuxer);\nfunction appendByteArray(buffer1, buffer2) {\n  var tmp = new Uint8Array((buffer1.byteLength | 0) + (buffer2.byteLength | 0));\n  tmp.set(buffer1, 0);\n  tmp.set(buffer2, buffer1.byteLength | 0);\n  return tmp;\n}\nfunction secToTime(sec) {\n  var seconds,\n    hours,\n    minutes,\n    result = '';\n  seconds = Math.floor(sec);\n  hours = parseInt(seconds / 3600, 10) % 24;\n  minutes = parseInt(seconds / 60, 10) % 60;\n  seconds = seconds < 0 ? 0 : seconds % 60;\n  if (hours > 0) {\n    result += (hours < 10 ? '0' + hours : hours) + ':';\n  }\n  result += (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);\n  return result;\n}\nvar jmuxer_RemuxController = /*#__PURE__*/function (_Event) {\n  function RemuxController(streaming) {\n    var _this3;\n    classCallCheck_default()(this, RemuxController);\n    _this3 = jmuxer_callSuper(this, RemuxController, ['remuxer']);\n    _this3.initialized = false;\n    _this3.trackTypes = [];\n    _this3.tracks = {};\n    _this3.mediaDuration = streaming ? Infinity : 1000;\n    return _this3;\n  }\n  inherits_default()(RemuxController, _Event);\n  return createClass_default()(RemuxController, [{\n    key: \"addTrack\",\n    value: function addTrack(type) {\n      if (type === 'video' || type === 'both') {\n        this.tracks.video = new jmuxer_H264Remuxer();\n        this.trackTypes.push('video');\n      }\n      if (type === 'audio' || type === 'both') {\n        this.tracks.audio = new jmuxer_AACRemuxer();\n        this.trackTypes.push('audio');\n      }\n    }\n  }, {\n    key: \"reset\",\n    value: function reset() {\n      var _iterator5 = jmuxer_createForOfIteratorHelper(this.trackTypes),\n        _step5;\n      try {\n        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {\n          var type = _step5.value;\n          this.tracks[type].resetTrack();\n        }\n      } catch (err) {\n        _iterator5.e(err);\n      } finally {\n        _iterator5.f();\n      }\n      this.initialized = false;\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      this.tracks = {};\n      this.offAll();\n    }\n  }, {\n    key: \"flush\",\n    value: function flush() {\n      if (!this.initialized) {\n        if (this.isReady()) {\n          this.dispatch('ready');\n          var _iterator6 = jmuxer_createForOfIteratorHelper(this.trackTypes),\n            _step6;\n          try {\n            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {\n              var type = _step6.value;\n              var track = this.tracks[type];\n              var data = {\n                type: type,\n                payload: jmuxer_MP4.initSegment([track.mp4track], this.mediaDuration, track.mp4track.timescale)\n              };\n              this.dispatch('buffer', data);\n            }\n          } catch (err) {\n            _iterator6.e(err);\n          } finally {\n            _iterator6.f();\n          }\n          log('Initial segment generated.');\n          this.initialized = true;\n        }\n      } else {\n        var _iterator7 = jmuxer_createForOfIteratorHelper(this.trackTypes),\n          _step7;\n        try {\n          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {\n            var _type = _step7.value;\n            var _track = this.tracks[_type];\n            var pay = _track.getPayload();\n            if (pay && pay.byteLength) {\n              var moof = jmuxer_MP4.moof(_track.seq, _track.dts, _track.mp4track);\n              var mdat = jmuxer_MP4.mdat(pay);\n              var payload = appendByteArray(moof, mdat);\n              var _data = {\n                type: _type,\n                payload: payload,\n                dts: _track.dts\n              };\n              this.dispatch('buffer', _data);\n              var duration = secToTime(_track.dts / 1000);\n              log(\"put segment (\".concat(_type, \"): \").concat(_track.seq, \" dts: \").concat(_track.dts, \" samples: \").concat(_track.mp4track.samples.length, \" second: \").concat(duration));\n              _track.flush();\n            }\n          }\n        } catch (err) {\n          _iterator7.e(err);\n        } finally {\n          _iterator7.f();\n        }\n      }\n    }\n  }, {\n    key: \"isReady\",\n    value: function isReady() {\n      var _iterator8 = jmuxer_createForOfIteratorHelper(this.trackTypes),\n        _step8;\n      try {\n        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {\n          var type = _step8.value;\n          if (!this.tracks[type].readyToDecode || !this.tracks[type].samples.length) return false;\n        }\n      } catch (err) {\n        _iterator8.e(err);\n      } finally {\n        _iterator8.f();\n      }\n      return true;\n    }\n  }, {\n    key: \"remux\",\n    value: function remux(data) {\n      var _iterator9 = jmuxer_createForOfIteratorHelper(this.trackTypes),\n        _step9;\n      try {\n        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {\n          var type = _step9.value;\n          var samples = data[type];\n          if (type === 'audio' && this.tracks.video && !this.tracks.video.readyToDecode) continue; /* if video is present, don't add audio until video get ready */\n          if (samples.length > 0) {\n            this.tracks[type].remux(samples);\n          }\n        }\n      } catch (err) {\n        _iterator9.e(err);\n      } finally {\n        _iterator9.f();\n      }\n      this.flush();\n    }\n  }]);\n}(jmuxer_Event);\nvar jmuxer_BufferController = /*#__PURE__*/function (_Event2) {\n  function BufferController(sourceBuffer, type) {\n    var _this4;\n    classCallCheck_default()(this, BufferController);\n    _this4 = jmuxer_callSuper(this, BufferController, ['buffer']);\n    _this4.type = type;\n    _this4.queue = new Uint8Array();\n    _this4.cleaning = false;\n    _this4.pendingCleaning = 0;\n    _this4.cleanOffset = 30;\n    _this4.cleanRanges = [];\n    _this4.sourceBuffer = sourceBuffer;\n    _this4.sourceBuffer.addEventListener('updateend', function () {\n      _this4.dispatch('updateend', Date.now());\n      if (_this4.pendingCleaning > 0) {\n        _this4.initCleanup(_this4.pendingCleaning);\n        _this4.pendingCleaning = 0;\n      }\n      _this4.cleaning = false;\n      if (_this4.cleanRanges.length) {\n        _this4.doCleanup();\n        return;\n      }\n    });\n    _this4.sourceBuffer.addEventListener('error', function (event) {\n      _this4.dispatch('error', {\n        type: _this4.type,\n        name: 'buffer',\n        error: event\n      });\n    });\n    return _this4;\n  }\n  inherits_default()(BufferController, _Event2);\n  return createClass_default()(BufferController, [{\n    key: \"destroy\",\n    value: function destroy() {\n      // this.cleanBuffers();\n      this.queue = null;\n      this.sourceBuffer = null;\n      this.offAll();\n    }\n  }, {\n    key: \"doCleanup\",\n    value: function doCleanup() {\n      if (!this.cleanRanges.length) {\n        this.cleaning = false;\n        return;\n      }\n      var range = this.cleanRanges.shift();\n      log(\"\".concat(this.type, \" remove range [\").concat(range[0], \" - \").concat(range[1], \")\"));\n      this.cleaning = true;\n      this.sourceBuffer.remove(range[0], range[1]);\n      this.dispatch('clearBuffer');\n    }\n    // cleanBuffers() {\n    //     if (this.sourceBuffer) {\n    //         let buffers = this.sourceBuffer.buffered;\n    //         let length = buffers.length;\n    //         for (let i = 0; i < length; i++){\n    //             this.sourceBuffer.remove(buffers.start(i), buffers.end(i));\n    //         }\n\n    //     }\n    // }\n  }, {\n    key: \"initCleanup\",\n    value: function initCleanup(cleanMaxLimit) {\n      if (this.sourceBuffer.updating) {\n        this.pendingCleaning = cleanMaxLimit;\n        return;\n      }\n      if (this.sourceBuffer.buffered && this.sourceBuffer.buffered.length && !this.cleaning) {\n        for (var i = 0; i < this.sourceBuffer.buffered.length; ++i) {\n          var start = this.sourceBuffer.buffered.start(i);\n          var end = this.sourceBuffer.buffered.end(i);\n          if (cleanMaxLimit - start > this.cleanOffset) {\n            end = cleanMaxLimit - this.cleanOffset;\n            if (start < end) {\n              this.cleanRanges.push([start, end]);\n            }\n          }\n        }\n        this.doCleanup();\n      }\n    }\n  }, {\n    key: \"doAppend\",\n    value: function doAppend() {\n      if (!this.queue.length) return;\n      if (this.sourceBuffer.updating) {\n        return;\n      }\n      try {\n        this.sourceBuffer.appendBuffer(this.queue);\n        this.queue = new Uint8Array();\n      } catch (e) {\n        if (e.name === 'QuotaExceededError') {\n          log(\"\".concat(this.type, \" buffer quota full\"));\n          this.dispatch('error', {\n            type: this.type,\n            name: 'QuotaExceeded',\n            error: 'buffer error'\n          });\n          return;\n        }\n        jmuxer_error(\"Error occured while appending \".concat(this.type, \" buffer -  \").concat(e.name, \": \").concat(e.message));\n        this.dispatch('error', {\n          type: this.type,\n          name: 'unexpectedError',\n          error: 'buffer error'\n        });\n      }\n    }\n  }, {\n    key: \"feed\",\n    value: function feed(data) {\n      this.queue = appendByteArray(this.queue, data);\n    }\n  }]);\n}(jmuxer_Event); // import { AACParser } from './parsers/aac.js';\nwindow.MediaSource = window.MediaSource || window.WebKitMediaSource;\nvar jmuxer_JMuxmer = /*#__PURE__*/function (_Event3) {\n  function JMuxmer(options) {\n    var _this5;\n    classCallCheck_default()(this, JMuxmer);\n    _this5 = jmuxer_callSuper(this, JMuxmer, ['jmuxer']);\n    window.MediaSource = window.MediaSource || window.WebKitMediaSource;\n    var defaults = {\n      node: '',\n      mode: 'both',\n      // both, audio, video\n      flushingTime: 1500,\n      clearBuffer: true,\n      onReady: null,\n      // function called when MSE is ready to accept frames\n      fps: 30,\n      debug: false,\n      onClearBuffer: null\n    };\n    _this5.options = Object.assign({}, defaults, options);\n    if (_this5.options.debug) {\n      jmuxer_setLogger();\n    }\n    if (typeof _this5.options.node === 'string' && _this5.options.node == '') {\n      jmuxer_error('no video element were found to render, provide a valid video element');\n    }\n    if (!_this5.options.fps) {\n      _this5.options.fps = 30;\n    }\n    _this5.frameDuration = 1000 / _this5.options.fps | 0;\n    _this5.node = typeof _this5.options.node === 'string' ? document.getElementById(_this5.options.node) : _this5.options.node;\n    _this5.sourceBuffers = {};\n    _this5.isMSESupported = !!window.MediaSource;\n    if (!_this5.isMSESupported) {\n      throw 'Oops! Browser does not support media source extension.';\n    }\n    _this5.setupMSE();\n    _this5.remuxController = new jmuxer_RemuxController(_this5.options.clearBuffer);\n    _this5.remuxController.addTrack(_this5.options.mode);\n    if (_this5.options.mode === 'audio') {\n      _this5.aacParser = _this5.remuxController.tracks.audio.aac;\n    }\n    _this5.mseReady = false;\n    _this5.lastCleaningTime = Date.now();\n    _this5.keyframeCache = [];\n    _this5.frameCounter = 0;\n\n    /* events callback */\n    _this5.remuxController.on('buffer', _this5.onBuffer.bind(_this5));\n    _this5.remuxController.on('ready', _this5.createBuffer.bind(_this5));\n    _this5.startInterval();\n    return _this5;\n  }\n  inherits_default()(JMuxmer, _Event3);\n  return createClass_default()(JMuxmer, [{\n    key: \"setupMSE\",\n    value: function setupMSE() {\n      this.mediaSource = new MediaSource();\n      this.node.src = URL.createObjectURL(this.mediaSource);\n      this.mediaSource.addEventListener('sourceopen', this.onMSEOpen.bind(this));\n      this.mediaSource.addEventListener('sourceclose', this.onMSEClose.bind(this));\n      this.mediaSource.addEventListener('webkitsourceopen', this.onMSEOpen.bind(this));\n      this.mediaSource.addEventListener('webkitsourceclose', this.onMSEClose.bind(this));\n    }\n  }, {\n    key: \"feed\",\n    value: function feed(data) {\n      var remux = false,\n        nalus,\n        aacFrames,\n        duration,\n        chunks = {\n          video: [],\n          audio: []\n        };\n      if (!data || !this.remuxController) return;\n      duration = data.duration ? parseInt(data.duration) : 0;\n      if (data.video) {\n        nalus = jmuxer_H264Parser.extractNALu(data.video);\n        if (nalus.length > 0) {\n          chunks.video = this.getVideoFrames(nalus, duration);\n          remux = true;\n        }\n      }\n      if (data.audio) {\n        aacFrames = this.aacParser.extractAAC(data.audio);\n        if (aacFrames.length > 0) {\n          chunks.audio = this.getAudioFrames(aacFrames, duration);\n          remux = true;\n        }\n      }\n      if (!remux) {\n        jmuxer_error('Input object must have video and/or audio property. Make sure it is not empty and valid typed array');\n        return;\n      }\n      this.remuxController.remux(chunks);\n    }\n  }, {\n    key: \"getVideoFrames\",\n    value: function getVideoFrames(nalus, duration) {\n      var nalu,\n        units = [],\n        samples = [],\n        naluObj,\n        sampleDuration,\n        adjustDuration = 0,\n        numberOfFrames = [];\n      var _iterator10 = jmuxer_createForOfIteratorHelper(nalus),\n        _step10;\n      try {\n        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {\n          nalu = _step10.value;\n          naluObj = new jmuxer_NALU(nalu);\n          units.push(naluObj);\n          if (naluObj.type() === jmuxer_NALU.IDR || naluObj.type() === jmuxer_NALU.NDR) {\n            samples.push({\n              units: units\n            });\n            units = [];\n            if (this.options.clearBuffer) {\n              if (naluObj.type() === jmuxer_NALU.IDR) {\n                numberOfFrames.push(this.frameCounter);\n              }\n              this.frameCounter++;\n            }\n          }\n        }\n      } catch (err) {\n        _iterator10.e(err);\n      } finally {\n        _iterator10.f();\n      }\n      if (duration) {\n        sampleDuration = duration / samples.length | 0;\n        adjustDuration = duration - sampleDuration * samples.length;\n      } else {\n        sampleDuration = this.frameDuration;\n      }\n      samples.map(function (sample) {\n        sample.duration = adjustDuration > 0 ? sampleDuration + 1 : sampleDuration;\n        if (adjustDuration !== 0) {\n          adjustDuration--;\n        }\n      });\n\n      /* cache keyframe times if clearBuffer set true */\n      if (this.options.clearBuffer) {\n        numberOfFrames = numberOfFrames.map(function (total) {\n          return total * sampleDuration / 1000;\n        });\n        this.keyframeCache = this.keyframeCache.concat(numberOfFrames);\n      }\n      return samples;\n    }\n  }, {\n    key: \"getAudioFrames\",\n    value: function getAudioFrames(aacFrames, duration) {\n      var samples = [],\n        units,\n        sampleDuration,\n        adjustDuration = 0;\n      var _iterator11 = jmuxer_createForOfIteratorHelper(aacFrames),\n        _step11;\n      try {\n        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {\n          units = _step11.value;\n          samples.push({\n            units: units\n          });\n        }\n      } catch (err) {\n        _iterator11.e(err);\n      } finally {\n        _iterator11.f();\n      }\n      if (duration) {\n        sampleDuration = duration / samples.length | 0;\n        adjustDuration = duration - sampleDuration * samples.length;\n      } else {\n        sampleDuration = this.frameDuration;\n      }\n      samples.map(function (sample) {\n        sample.duration = adjustDuration > 0 ? sampleDuration + 1 : sampleDuration;\n        if (adjustDuration !== 0) {\n          adjustDuration--;\n        }\n      });\n      return samples;\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      this.aacParser = null;\n      this.stopInterval();\n      if (this.mediaSource) {\n        try {\n          if (this.bufferControllers) {\n            this.mediaSource.endOfStream();\n            this.removeSourceBuffer();\n          }\n        } catch (e) {\n          jmuxer_error(\"mediasource is not available to end \".concat(e.message));\n        }\n        this.mediaSource = null;\n      }\n      if (this.remuxController) {\n        this.remuxController.destroy();\n        this.remuxController = null;\n      }\n      if (this.bufferControllers) {\n        for (var type in this.bufferControllers) {\n          this.bufferControllers[type].destroy();\n        }\n        this.bufferControllers = null;\n      }\n      this.node = false;\n      this.mseReady = false;\n      this.videoStarted = false;\n    }\n  }, {\n    key: \"createBuffer\",\n    value: function createBuffer() {\n      if (!this.mseReady || !this.remuxController || !this.remuxController.isReady() || this.bufferControllers) return;\n      this.bufferControllers = {};\n      for (var type in this.remuxController.tracks) {\n        var track = this.remuxController.tracks[type];\n        if (!JMuxmer.isSupported(\"\".concat(type, \"/mp4; codecs=\\\"\").concat(track.mp4track.codec, \"\\\"\"))) {\n          jmuxer_error('Browser does not support codec');\n          return false;\n        }\n        var sb = this.mediaSource.addSourceBuffer(\"\".concat(type, \"/mp4; codecs=\\\"\").concat(track.mp4track.codec, \"\\\"\"));\n        this.bufferControllers[type] = new jmuxer_BufferController(sb, type);\n        this.sourceBuffers[type] = sb;\n        this.bufferControllers[type].on('error', this.onBufferError.bind(this));\n        this.bufferControllers[type].on('clearBuffer', this.onClearBuffer.bind(this));\n        this.bufferControllers[type].on('updateend', this.onUpdateEnd.bind(this));\n      }\n    }\n  }, {\n    key: \"onUpdateEnd\",\n    value: function onUpdateEnd(data) {\n      if (typeof this.options.onUpdateEnd === 'function') {\n        this.options.onUpdateEnd(data);\n      }\n    }\n  }, {\n    key: \"startInterval\",\n    value: function startInterval() {\n      var _this6 = this;\n      this.interval = setInterval(function () {\n        if (_this6.bufferControllers) {\n          _this6.releaseBuffer();\n          _this6.clearBuffer();\n        }\n      }, this.options.flushingTime);\n    }\n  }, {\n    key: \"stopInterval\",\n    value: function stopInterval() {\n      if (this.interval) {\n        clearInterval(this.interval);\n      }\n    }\n  }, {\n    key: \"releaseBuffer\",\n    value: function releaseBuffer() {\n      for (var type in this.bufferControllers) {\n        this.bufferControllers[type].doAppend();\n      }\n    }\n  }, {\n    key: \"getSafeBufferClearLimit\",\n    value: function getSafeBufferClearLimit(offset) {\n      var maxLimit = this.options.mode === 'audio' && offset || 0,\n        adjacentOffset;\n      for (var i = 0; i < this.keyframeCache.length; i++) {\n        if (this.keyframeCache[i] >= offset) {\n          break;\n        }\n        adjacentOffset = this.keyframeCache[i];\n      }\n      if (adjacentOffset) {\n        this.keyframeCache = this.keyframeCache.filter(function (keyframePoint) {\n          if (keyframePoint < adjacentOffset) {\n            maxLimit = keyframePoint;\n          }\n          return keyframePoint >= adjacentOffset;\n        });\n      }\n      return maxLimit;\n    }\n  }, {\n    key: \"clearBuffer\",\n    value: function clearBuffer() {\n      if (this.options.clearBuffer && Date.now() - this.lastCleaningTime > 10000) {\n        for (var type in this.bufferControllers) {\n          var cleanMaxLimit = this.getSafeBufferClearLimit(this.node.currentTime);\n          this.bufferControllers[type].initCleanup(cleanMaxLimit);\n        }\n        this.lastCleaningTime = Date.now();\n      }\n    }\n  }, {\n    key: \"onBuffer\",\n    value: function onBuffer(data) {\n      if (this.bufferControllers && this.bufferControllers[data.type]) {\n        this.bufferControllers[data.type].feed(data.payload);\n      }\n    }\n  }, {\n    key: \"onClearBuffer\",\n    value: function onClearBuffer() {\n      if (typeof this.options.onClearBuffer === 'function') {\n        this.options.onClearBuffer();\n      }\n    }\n  }, {\n    key: \"removeSourceBuffer\",\n    value: function removeSourceBuffer() {\n      if (this.mediaSource) {\n        var sourceBuffers = this.sourceBuffers;\n        for (var type in sourceBuffers) {\n          this.mediaSource.removeSourceBuffer(sourceBuffers[type]);\n        }\n      }\n    }\n    /* Events on MSE */\n  }, {\n    key: \"onMSEOpen\",\n    value: function onMSEOpen() {\n      this.mseReady = true;\n      this.createBuffer();\n      if (typeof this.options.onReady === 'function') {\n        this.options.onReady();\n        this.options.onReady = null;\n      }\n    }\n  }, {\n    key: \"onMSEClose\",\n    value: function onMSEClose() {\n      this.mseReady = false;\n      this.videoStarted = false;\n    }\n  }, {\n    key: \"onBufferError\",\n    value: function onBufferError(data) {\n      if (data.name == 'QuotaExceeded') {\n        this.bufferControllers[data.type].initCleanup(this.node.currentTime);\n        return;\n      }\n      if (this.mediaSource.sourceBuffers.length > 0 && this.sourceBuffers[data.type]) {\n        this.mediaSource.removeSourceBuffer(this.sourceBuffers[data.type]);\n      }\n      if (this.mediaSource.sourceBuffers.length == 0) {\n        try {\n          this.mediaSource.endOfStream();\n        } catch (e) {\n          jmuxer_error('mediasource is not available to end');\n        }\n      }\n    }\n  }], [{\n    key: \"isSupported\",\n    value: function isSupported(codec) {\n      return window.MediaSource && window.MediaSource.isTypeSupported(codec);\n    }\n  }]);\n}(jmuxer_Event);\n/* harmony default export */ var jmuxer = (jmuxer_JMuxmer);\n// CONCATENATED MODULE: ../src/audio/CommonProcessor.js\n\n\n\n\n\n\nfunction CommonProcessor_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, CommonProcessor_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction CommonProcessor_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (CommonProcessor_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: process audio data of normal speed \r\n * @author: xuluying \r\n * @file: CommonProcessor.js\r\n */\n\n\nvar CommonProcessor_CommonProcessor = /*#__PURE__*/function (_BaseClass) {\n  function CommonProcessor(options) {\n    var _this;\n    classCallCheck_default()(this, CommonProcessor);\n    _this = CommonProcessor_callSuper(this, CommonProcessor, [options]);\n    defineProperty_default()(_this, \"source\", []);\n    defineProperty_default()(_this, \"onPlay\", void 0);\n    _this.source = options.source;\n    _this.onPlay = options.onPlay;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(CommonProcessor, _BaseClass);\n  return createClass_default()(CommonProcessor, [{\n    key: \"init\",\n    value: function init() {}\n  }, {\n    key: \"extract\",\n    value: function extract(target, numFrames) {\n      var data = this.provide(numFrames);\n      // console.error('[Common] buffer size = %d, request size = %d, response size = %d,  ',this.source.length, numFrames, data.size)\n      for (var i = 0; i < data.size; i++) {\n        target[i * 2] = data.left[i];\n        target[i * 2 + 1] = data.right[i];\n      }\n      return data.size;\n    }\n  }, {\n    key: \"provide\",\n    value: function provide(size) {\n      var sourceSize = size;\n      var leftSource = new Float32Array(sourceSize);\n      var rightSource = new Float32Array(sourceSize);\n      var sourcePosition = 0;\n      var audioTime = 0;\n      var copySize = 0;\n      while (this.source.length > 0) {\n        var tmpBuffer = this.source.shift();\n        var loadedPosition = tmpBuffer.loadedPosition || 0;\n        audioTime = tmpBuffer.startTime + tmpBuffer.duration * loadedPosition / tmpBuffer.length;\n        var copyLength = Math.min(tmpBuffer.length - loadedPosition, sourceSize - sourcePosition);\n        var leftBuffer = tmpBuffer.getChannelData(0);\n        var rightBuffer = tmpBuffer.numberOfChannels > 1 ? tmpBuffer.getChannelData(1) : tmpBuffer.getChannelData(0);\n        //fill channel data with buffer\n        leftSource.set(leftBuffer.slice(loadedPosition, loadedPosition + copyLength), sourcePosition);\n        rightSource.set(rightBuffer.slice(loadedPosition, loadedPosition + copyLength), sourcePosition);\n        copySize += copyLength;\n        loadedPosition += copyLength;\n        sourcePosition += copyLength;\n        if (loadedPosition < tmpBuffer.length) {\n          tmpBuffer.loadedPosition = loadedPosition;\n          this.source.unshift(tmpBuffer);\n          break;\n        }\n      }\n      if (this.onPlay) {\n        this.onPlay(audioTime);\n      }\n      return {\n        left: leftSource,\n        right: rightSource,\n        size: copySize\n      };\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/lib/soundtouch.js\n\n/*\r\n * SoundTouch JS v0.1.7 audio processing library\r\n * Copyright (c) Olli Parviainen\r\n * Copyright (c) Ryan Berdeen\r\n * Copyright (c) Jakub Fiala\r\n * Copyright (c) Steve 'Cutter' Blades\r\n *\r\n * This library is free software; you can redistribute it and/or\r\n * modify it under the terms of the GNU Lesser General Public\r\n * License as published by the Free Software Foundation; either\r\n * version 2.1 of the License, or (at your option) any later version.\r\n *\r\n * This library is distributed in the hope that it will be useful,\r\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\r\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU\r\n * Lesser General Public License for more details.\r\n *\r\n * You should have received a copy of the GNU Lesser General Public\r\n * License along with this library; if not, write to the Free Software\r\n * Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA\r\n */\n\nfunction _classCallCheck(instance, Constructor) {\n  if (!(instance instanceof Constructor)) {\n    throw new TypeError(\"Cannot call a class as a function\");\n  }\n}\nfunction _defineProperties(target, props) {\n  for (var i = 0; i < props.length; i++) {\n    var descriptor = props[i];\n    descriptor.enumerable = descriptor.enumerable || false;\n    descriptor.configurable = true;\n    if (\"value\" in descriptor) descriptor.writable = true;\n    Object.defineProperty(target, descriptor.key, descriptor);\n  }\n}\nfunction _createClass(Constructor, protoProps, staticProps) {\n  if (protoProps) _defineProperties(Constructor.prototype, protoProps);\n  if (staticProps) _defineProperties(Constructor, staticProps);\n  return Constructor;\n}\nfunction _inherits(subClass, superClass) {\n  if (typeof superClass !== \"function\" && superClass !== null) {\n    throw new TypeError(\"Super expression must either be null or a function\");\n  }\n  subClass.prototype = Object.create(superClass && superClass.prototype, {\n    constructor: {\n      value: subClass,\n      writable: true,\n      configurable: true\n    }\n  });\n  if (superClass) _setPrototypeOf(subClass, superClass);\n}\nfunction _getPrototypeOf(o) {\n  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {\n    return o.__proto__ || Object.getPrototypeOf(o);\n  };\n  return _getPrototypeOf(o);\n}\nfunction _setPrototypeOf(o, p) {\n  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {\n    o.__proto__ = p;\n    return o;\n  };\n  return _setPrototypeOf(o, p);\n}\nfunction _assertThisInitialized(self) {\n  if (self === void 0) {\n    throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");\n  }\n  return self;\n}\nfunction _possibleConstructorReturn(self, call) {\n  if (call && (typeof_default()(call) === \"object\" || typeof call === \"function\")) {\n    return call;\n  }\n  return _assertThisInitialized(self);\n}\nfunction _superPropBase(object, property) {\n  while (!Object.prototype.hasOwnProperty.call(object, property)) {\n    object = _getPrototypeOf(object);\n    if (object === null) break;\n  }\n  return object;\n}\nfunction soundtouch_get(target, property, receiver) {\n  if (typeof Reflect !== \"undefined\" && Reflect.get) {\n    soundtouch_get = Reflect.get;\n  } else {\n    soundtouch_get = function _get(target, property, receiver) {\n      var base = _superPropBase(target, property);\n      if (!base) return;\n      var desc = Object.getOwnPropertyDescriptor(base, property);\n      if (desc.get) {\n        return desc.get.call(receiver);\n      }\n      return desc.value;\n    };\n  }\n  return soundtouch_get(target, property, receiver || target);\n}\nvar FifoSampleBuffer = function () {\n  function FifoSampleBuffer() {\n    _classCallCheck(this, FifoSampleBuffer);\n    this._vector = new Float32Array();\n    this._position = 0;\n    this._frameCount = 0;\n  }\n  _createClass(FifoSampleBuffer, [{\n    key: \"clear\",\n    value: function clear() {\n      this.receive(this._frameCount);\n      this.rewind();\n    }\n  }, {\n    key: \"put\",\n    value: function put(numFrames) {\n      this._frameCount += numFrames;\n    }\n  }, {\n    key: \"putSamples\",\n    value: function putSamples(samples, position) {\n      var numFrames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;\n      position = position || 0;\n      var sourceOffset = position * 2;\n      if (!(numFrames >= 0)) {\n        numFrames = (samples.length - sourceOffset) / 2;\n      }\n      var numSamples = numFrames * 2;\n      this.ensureCapacity(numFrames + this._frameCount);\n      var destOffset = this.endIndex;\n      this.vector.set(samples.subarray(sourceOffset, sourceOffset + numSamples), destOffset);\n      this._frameCount += numFrames;\n    }\n  }, {\n    key: \"putBuffer\",\n    value: function putBuffer(buffer, position) {\n      var numFrames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;\n      position = position || 0;\n      if (!(numFrames >= 0)) {\n        numFrames = buffer.frameCount - position;\n      }\n      this.putSamples(buffer.vector, buffer.position + position, numFrames);\n    }\n  }, {\n    key: \"receive\",\n    value: function receive(numFrames) {\n      if (!(numFrames >= 0) || numFrames > this._frameCount) {\n        numFrames = this.frameCount;\n      }\n      this._frameCount -= numFrames;\n      this._position += numFrames;\n    }\n  }, {\n    key: \"receiveSamples\",\n    value: function receiveSamples(output) {\n      var numFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n      var numSamples = numFrames * 2;\n      var sourceOffset = this.startIndex;\n      output.set(this._vector.subarray(sourceOffset, sourceOffset + numSamples));\n      this.receive(numFrames);\n    }\n  }, {\n    key: \"extract\",\n    value: function extract(output) {\n      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n      var numFrames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;\n      var sourceOffset = this.startIndex + position * 2;\n      var numSamples = numFrames * 2;\n      output.set(this._vector.subarray(sourceOffset, sourceOffset + numSamples));\n    }\n  }, {\n    key: \"ensureCapacity\",\n    value: function ensureCapacity() {\n      var numFrames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      var minLength = parseInt(numFrames * 2);\n      if (this._vector.length < minLength) {\n        var newVector = new Float32Array(minLength);\n        newVector.set(this._vector.subarray(this.startIndex, this.endIndex));\n        this._vector = newVector;\n        this._position = 0;\n      } else {\n        this.rewind();\n      }\n    }\n  }, {\n    key: \"ensureAdditionalCapacity\",\n    value: function ensureAdditionalCapacity() {\n      var numFrames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      this.ensureCapacity(this._frameCount + numFrames);\n    }\n  }, {\n    key: \"rewind\",\n    value: function rewind() {\n      if (this._position > 0) {\n        this._vector.set(this._vector.subarray(this.startIndex, this.endIndex));\n        this._position = 0;\n      }\n    }\n  }, {\n    key: \"vector\",\n    get: function get() {\n      return this._vector;\n    }\n  }, {\n    key: \"position\",\n    get: function get() {\n      return this._position;\n    }\n  }, {\n    key: \"startIndex\",\n    get: function get() {\n      return this._position * 2;\n    }\n  }, {\n    key: \"frameCount\",\n    get: function get() {\n      return this._frameCount;\n    }\n  }, {\n    key: \"endIndex\",\n    get: function get() {\n      return (this._position + this._frameCount) * 2;\n    }\n  }]);\n  return FifoSampleBuffer;\n}();\nvar AbstractFifoSamplePipe = function () {\n  function AbstractFifoSamplePipe(createBuffers) {\n    _classCallCheck(this, AbstractFifoSamplePipe);\n    if (createBuffers) {\n      this._inputBuffer = new FifoSampleBuffer();\n      this._outputBuffer = new FifoSampleBuffer();\n    } else {\n      this._inputBuffer = this._outputBuffer = null;\n    }\n  }\n  _createClass(AbstractFifoSamplePipe, [{\n    key: \"clear\",\n    value: function clear() {\n      this._inputBuffer.clear();\n      this._outputBuffer.clear();\n    }\n  }, {\n    key: \"inputBuffer\",\n    get: function get() {\n      return this._inputBuffer;\n    },\n    set: function set(inputBuffer) {\n      this._inputBuffer = inputBuffer;\n    }\n  }, {\n    key: \"outputBuffer\",\n    get: function get() {\n      return this._outputBuffer;\n    },\n    set: function set(outputBuffer) {\n      this._outputBuffer = outputBuffer;\n    }\n  }]);\n  return AbstractFifoSamplePipe;\n}();\nvar RateTransposer = function (_AbstractFifoSamplePi) {\n  _inherits(RateTransposer, _AbstractFifoSamplePi);\n  function RateTransposer(createBuffers) {\n    var _this;\n    _classCallCheck(this, RateTransposer);\n    _this = _possibleConstructorReturn(this, _getPrototypeOf(RateTransposer).call(this, createBuffers));\n    _this.reset();\n    _this._rate = 1;\n    return _this;\n  }\n  _createClass(RateTransposer, [{\n    key: \"reset\",\n    value: function reset() {\n      this.slopeCount = 0;\n      this.prevSampleL = 0;\n      this.prevSampleR = 0;\n    }\n  }, {\n    key: \"clone\",\n    value: function clone() {\n      var result = new RateTransposer();\n      result.rate = this._rate;\n      return result;\n    }\n  }, {\n    key: \"process\",\n    value: function process() {\n      var numFrames = this._inputBuffer.frameCount;\n      this._outputBuffer.ensureAdditionalCapacity(numFrames / this._rate + 1);\n      var numFramesOutput = this.transpose(numFrames);\n      this._inputBuffer.receive();\n      this._outputBuffer.put(numFramesOutput);\n    }\n  }, {\n    key: \"transpose\",\n    value: function transpose() {\n      var numFrames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      if (numFrames === 0) {\n        return 0;\n      }\n      var src = this._inputBuffer.vector;\n      var srcOffset = this._inputBuffer.startIndex;\n      var dest = this._outputBuffer.vector;\n      var destOffset = this._outputBuffer.endIndex;\n      var used = 0;\n      var i = 0;\n      while (this.slopeCount < 1.0) {\n        dest[destOffset + 2 * i] = (1.0 - this.slopeCount) * this.prevSampleL + this.slopeCount * src[srcOffset];\n        dest[destOffset + 2 * i + 1] = (1.0 - this.slopeCount) * this.prevSampleR + this.slopeCount * src[srcOffset + 1];\n        i = i + 1;\n        this.slopeCount += this._rate;\n      }\n      this.slopeCount -= 1.0;\n      if (numFrames !== 1) {\n        out: while (true) {\n          while (this.slopeCount > 1.0) {\n            this.slopeCount -= 1.0;\n            used = used + 1;\n            if (used >= numFrames - 1) {\n              break out;\n            }\n          }\n          var srcIndex = srcOffset + 2 * used;\n          dest[destOffset + 2 * i] = (1.0 - this.slopeCount) * src[srcIndex] + this.slopeCount * src[srcIndex + 2];\n          dest[destOffset + 2 * i + 1] = (1.0 - this.slopeCount) * src[srcIndex + 1] + this.slopeCount * src[srcIndex + 3];\n          i = i + 1;\n          this.slopeCount += this._rate;\n        }\n      }\n      this.prevSampleL = src[srcOffset + 2 * numFrames - 2];\n      this.prevSampleR = src[srcOffset + 2 * numFrames - 1];\n      return i;\n    }\n  }, {\n    key: \"rate\",\n    set: function set(rate) {\n      this._rate = rate;\n    }\n  }]);\n  return RateTransposer;\n}(AbstractFifoSamplePipe);\nvar FilterSupport = function () {\n  function FilterSupport(pipe) {\n    var inputSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1024;\n    _classCallCheck(this, FilterSupport);\n    this._pipe = pipe;\n    this.inputSize = inputSize;\n  }\n  _createClass(FilterSupport, [{\n    key: \"fillInputBuffer\",\n    value: function fillInputBuffer() {\n      throw new Error('fillInputBuffer() not overridden');\n    }\n  }, {\n    key: \"fillOutputBuffer\",\n    value: function fillOutputBuffer() {\n      var numFrames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      var inputSize = this.inputSize;\n      while (this.outputBuffer.frameCount < numFrames) {\n        var numInputFrames = inputSize - this.inputBuffer.frameCount;\n        this.fillInputBuffer(numInputFrames);\n        if (this.inputBuffer.frameCount < inputSize) {\n          break;\n        }\n        this._pipe.process();\n      }\n    }\n  }, {\n    key: \"clear\",\n    value: function clear() {\n      this._pipe.clear();\n    }\n  }, {\n    key: \"pipe\",\n    get: function get() {\n      return this._pipe;\n    }\n  }, {\n    key: \"inputBuffer\",\n    get: function get() {\n      return this._pipe.inputBuffer;\n    }\n  }, {\n    key: \"outputBuffer\",\n    get: function get() {\n      return this._pipe.outputBuffer;\n    }\n  }]);\n  return FilterSupport;\n}();\nvar noop = function noop() {\n  return;\n};\nvar SimpleFilter = function (_FilterSupport) {\n  _inherits(SimpleFilter, _FilterSupport);\n  function SimpleFilter(sourceSound, pipe) {\n    var _this;\n    var inputsize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1024;\n    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;\n    _classCallCheck(this, SimpleFilter);\n    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleFilter).call(this, pipe, inputsize));\n    _this.callback = callback;\n    _this.sourceSound = sourceSound;\n    _this.historyBufferSize = 22050;\n    _this._sourcePosition = 0;\n    _this.outputBufferPosition = 0;\n    _this._position = 0;\n    return _this;\n  }\n  _createClass(SimpleFilter, [{\n    key: \"onEnd\",\n    value: function onEnd() {\n      this.callback();\n    }\n  }, {\n    key: \"fillInputBuffer\",\n    value: function fillInputBuffer() {\n      var numFrames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      var samples = new Float32Array(numFrames * 2);\n      var numFramesExtracted = this.sourceSound.extract(samples, numFrames, this._sourcePosition);\n      this._sourcePosition += numFramesExtracted;\n      this.inputBuffer.putSamples(samples, 0, numFramesExtracted);\n    }\n  }, {\n    key: \"extract\",\n    value: function extract(target) {\n      var numFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n      this.fillOutputBuffer(this.outputBufferPosition + numFrames);\n      var numFramesExtracted = Math.min(numFrames, this.outputBuffer.frameCount - this.outputBufferPosition);\n      this.outputBuffer.extract(target, this.outputBufferPosition, numFramesExtracted);\n      var currentFrames = this.outputBufferPosition + numFramesExtracted;\n      this.outputBufferPosition = Math.min(this.historyBufferSize, currentFrames);\n      this.outputBuffer.receive(Math.max(currentFrames - this.historyBufferSize, 0));\n      this._position += numFramesExtracted;\n      return numFramesExtracted;\n    }\n  }, {\n    key: \"handleSampleData\",\n    value: function handleSampleData(event) {\n      this.extract(event.data, 4096);\n    }\n  }, {\n    key: \"clear\",\n    value: function clear() {\n      soundtouch_get(_getPrototypeOf(SimpleFilter.prototype), \"clear\", this).call(this);\n      this.outputBufferPosition = 0;\n    }\n  }, {\n    key: \"position\",\n    get: function get() {\n      return this._position;\n    },\n    set: function set(position) {\n      if (position > this._position) {\n        throw new RangeError('New position may not be greater than current position');\n      }\n      var newOutputBufferPosition = this.outputBufferPosition - (this._position - position);\n      if (newOutputBufferPosition < 0) {\n        throw new RangeError('New position falls outside of history buffer');\n      }\n      this.outputBufferPosition = newOutputBufferPosition;\n      this._position = position;\n    }\n  }, {\n    key: \"sourcePosition\",\n    get: function get() {\n      return this._sourcePosition;\n    },\n    set: function set(sourcePosition) {\n      this.clear();\n      this._sourcePosition = sourcePosition;\n    }\n  }]);\n  return SimpleFilter;\n}(FilterSupport);\nvar USE_AUTO_SEQUENCE_LEN = 0;\nvar DEFAULT_SEQUENCE_MS = USE_AUTO_SEQUENCE_LEN;\nvar USE_AUTO_SEEKWINDOW_LEN = 0;\nvar DEFAULT_SEEKWINDOW_MS = USE_AUTO_SEEKWINDOW_LEN;\nvar DEFAULT_OVERLAP_MS = 8;\nvar _SCAN_OFFSETS = [[124, 186, 248, 310, 372, 434, 496, 558, 620, 682, 744, 806, 868, 930, 992, 1054, 1116, 1178, 1240, 1302, 1364, 1426, 1488, 0], [-100, -75, -50, -25, 25, 50, 75, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [-20, -15, -10, -5, 5, 10, 15, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [-4, -3, -2, -1, 1, 2, 3, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];\nvar AUTOSEQ_TEMPO_LOW = 0.5;\nvar AUTOSEQ_TEMPO_TOP = 2.0;\nvar AUTOSEQ_AT_MIN = 125.0;\nvar AUTOSEQ_AT_MAX = 50.0;\nvar AUTOSEQ_K = (AUTOSEQ_AT_MAX - AUTOSEQ_AT_MIN) / (AUTOSEQ_TEMPO_TOP - AUTOSEQ_TEMPO_LOW);\nvar AUTOSEQ_C = AUTOSEQ_AT_MIN - AUTOSEQ_K * AUTOSEQ_TEMPO_LOW;\nvar AUTOSEEK_AT_MIN = 25.0;\nvar AUTOSEEK_AT_MAX = 15.0;\nvar AUTOSEEK_K = (AUTOSEEK_AT_MAX - AUTOSEEK_AT_MIN) / (AUTOSEQ_TEMPO_TOP - AUTOSEQ_TEMPO_LOW);\nvar AUTOSEEK_C = AUTOSEEK_AT_MIN - AUTOSEEK_K * AUTOSEQ_TEMPO_LOW;\nvar Stretch = function (_AbstractFifoSamplePi) {\n  _inherits(Stretch, _AbstractFifoSamplePi);\n  function Stretch(createBuffers) {\n    var _this;\n    _classCallCheck(this, Stretch);\n    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stretch).call(this, createBuffers));\n    _this._quickSeek = true;\n    _this.midBufferDirty = false;\n    _this.midBuffer = null;\n    _this.overlapLength = 0;\n    _this.autoSeqSetting = true;\n    _this.autoSeekSetting = true;\n    _this._tempo = 1;\n    _this.setParameters(44100, DEFAULT_SEQUENCE_MS, DEFAULT_SEEKWINDOW_MS, DEFAULT_OVERLAP_MS);\n    return _this;\n  }\n  _createClass(Stretch, [{\n    key: \"clear\",\n    value: function clear() {\n      soundtouch_get(_getPrototypeOf(Stretch.prototype), \"clear\", this).call(this);\n      this.clearMidBuffer();\n    }\n  }, {\n    key: \"clearMidBuffer\",\n    value: function clearMidBuffer() {\n      if (this.midBufferDirty) {\n        this.midBufferDirty = false;\n        this.midBuffer = null;\n      }\n    }\n  }, {\n    key: \"setParameters\",\n    value: function setParameters(sampleRate, sequenceMs, seekWindowMs, overlapMs) {\n      if (sampleRate > 0) {\n        this.sampleRate = sampleRate;\n      }\n      if (overlapMs > 0) {\n        this.overlapMs = overlapMs;\n      }\n      if (sequenceMs > 0) {\n        this.sequenceMs = sequenceMs;\n        this.autoSeqSetting = false;\n      } else {\n        this.autoSeqSetting = true;\n      }\n      if (seekWindowMs > 0) {\n        this.seekWindowMs = seekWindowMs;\n        this.autoSeekSetting = false;\n      } else {\n        this.autoSeekSetting = true;\n      }\n      this.calculateSequenceParameters();\n      this.calculateOverlapLength(this.overlapMs);\n      this.tempo = this._tempo;\n    }\n  }, {\n    key: \"calculateOverlapLength\",\n    value: function calculateOverlapLength() {\n      var overlapInMsec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;\n      var newOvl;\n      newOvl = this.sampleRate * overlapInMsec / 1000;\n      newOvl = newOvl < 16 ? 16 : newOvl;\n      newOvl -= newOvl % 8;\n      this.overlapLength = newOvl;\n      this.refMidBuffer = new Float32Array(this.overlapLength * 2);\n      this.midBuffer = new Float32Array(this.overlapLength * 2);\n    }\n  }, {\n    key: \"checkLimits\",\n    value: function checkLimits(x, mi, ma) {\n      return x < mi ? mi : x > ma ? ma : x;\n    }\n  }, {\n    key: \"calculateSequenceParameters\",\n    value: function calculateSequenceParameters() {\n      var seq;\n      var seek;\n      if (this.autoSeqSetting) {\n        seq = AUTOSEQ_C + AUTOSEQ_K * this._tempo;\n        seq = this.checkLimits(seq, AUTOSEQ_AT_MAX, AUTOSEQ_AT_MIN);\n        this.sequenceMs = Math.floor(seq + 0.5);\n      }\n      if (this.autoSeekSetting) {\n        seek = AUTOSEEK_C + AUTOSEEK_K * this._tempo;\n        seek = this.checkLimits(seek, AUTOSEEK_AT_MAX, AUTOSEEK_AT_MIN);\n        this.seekWindowMs = Math.floor(seek + 0.5);\n      }\n      this.seekWindowLength = Math.floor(this.sampleRate * this.sequenceMs / 1000);\n      this.seekLength = Math.floor(this.sampleRate * this.seekWindowMs / 1000);\n    }\n  }, {\n    key: \"clone\",\n    value: function clone() {\n      var result = new Stretch();\n      result.tempo = this._tempo;\n      result.setParameters(this.sampleRate, this.sequenceMs, this.seekWindowMs, this.overlapMs);\n      return result;\n    }\n  }, {\n    key: \"seekBestOverlapPosition\",\n    value: function seekBestOverlapPosition() {\n      return this._quickSeek ? this.seekBestOverlapPositionStereoQuick() : this.seekBestOverlapPositionStereo();\n    }\n  }, {\n    key: \"seekBestOverlapPositionStereo\",\n    value: function seekBestOverlapPositionStereo() {\n      var bestOffset;\n      var bestCorrelation;\n      var correlation;\n      var i = 0;\n      this.preCalculateCorrelationReferenceStereo();\n      bestOffset = 0;\n      bestCorrelation = Number.MIN_VALUE;\n      for (; i < this.seekLength; i = i + 1) {\n        correlation = this.calculateCrossCorrelationStereo(2 * i, this.refMidBuffer);\n        if (correlation > bestCorrelation) {\n          bestCorrelation = correlation;\n          bestOffset = i;\n        }\n      }\n      return bestOffset;\n    }\n  }, {\n    key: \"seekBestOverlapPositionStereoQuick\",\n    value: function seekBestOverlapPositionStereoQuick() {\n      var bestOffset;\n      var bestCorrelation;\n      var correlation;\n      var scanCount = 0;\n      var correlationOffset;\n      var tempOffset;\n      this.preCalculateCorrelationReferenceStereo();\n      bestCorrelation = Number.MIN_VALUE;\n      bestOffset = 0;\n      correlationOffset = 0;\n      tempOffset = 0;\n      for (; scanCount < 4; scanCount = scanCount + 1) {\n        var j = 0;\n        while (_SCAN_OFFSETS[scanCount][j]) {\n          tempOffset = correlationOffset + _SCAN_OFFSETS[scanCount][j];\n          if (tempOffset >= this.seekLength) {\n            break;\n          }\n          correlation = this.calculateCrossCorrelationStereo(2 * tempOffset, this.refMidBuffer);\n          if (correlation > bestCorrelation) {\n            bestCorrelation = correlation;\n            bestOffset = tempOffset;\n          }\n          j = j + 1;\n        }\n        correlationOffset = bestOffset;\n      }\n      return bestOffset;\n    }\n  }, {\n    key: \"preCalculateCorrelationReferenceStereo\",\n    value: function preCalculateCorrelationReferenceStereo() {\n      var i = 0;\n      var context;\n      var temp;\n      for (; i < this.overlapLength; i = i + 1) {\n        temp = i * (this.overlapLength - i);\n        context = i * 2;\n        this.refMidBuffer[context] = this.midBuffer[context] * temp;\n        this.refMidBuffer[context + 1] = this.midBuffer[context + 1] * temp;\n      }\n    }\n  }, {\n    key: \"calculateCrossCorrelationStereo\",\n    value: function calculateCrossCorrelationStereo(mixingPosition, compare) {\n      var mixing = this._inputBuffer.vector;\n      mixingPosition += this._inputBuffer.startIndex;\n      var correlation = 0;\n      var i = 2;\n      var calcLength = 2 * this.overlapLength;\n      var mixingOffset;\n      for (; i < calcLength; i = i + 2) {\n        mixingOffset = i + mixingPosition;\n        correlation += mixing[mixingOffset] * compare[i] + mixing[mixingOffset + 1] * compare[i + 1];\n      }\n      return correlation;\n    }\n  }, {\n    key: \"overlap\",\n    value: function overlap(overlapPosition) {\n      this.overlapStereo(2 * overlapPosition);\n    }\n  }, {\n    key: \"overlapStereo\",\n    value: function overlapStereo(inputPosition) {\n      var input = this._inputBuffer.vector;\n      inputPosition += this._inputBuffer.startIndex;\n      var output = this._outputBuffer.vector;\n      var outputPosition = this._outputBuffer.endIndex;\n      var i = 0;\n      var context;\n      var tempFrame;\n      var frameScale = 1 / this.overlapLength;\n      var fi;\n      var inputOffset;\n      var outputOffset;\n      for (; i < this.overlapLength; i = i + 1) {\n        tempFrame = (this.overlapLength - i) * frameScale;\n        fi = i * frameScale;\n        context = 2 * i;\n        inputOffset = context + inputPosition;\n        outputOffset = context + outputPosition;\n        output[outputOffset + 0] = input[inputOffset + 0] * fi + this.midBuffer[context + 0] * tempFrame;\n        output[outputOffset + 1] = input[inputOffset + 1] * fi + this.midBuffer[context + 1] * tempFrame;\n      }\n    }\n  }, {\n    key: \"process\",\n    value: function process() {\n      var offset;\n      var temp;\n      var overlapSkip;\n      if (this.midBuffer === null) {\n        if (this._inputBuffer.frameCount < this.overlapLength) {\n          return;\n        }\n        this.midBuffer = new Float32Array(this.overlapLength * 2);\n        this._inputBuffer.receiveSamples(this.midBuffer, this.overlapLength);\n      }\n      while (this._inputBuffer.frameCount >= this.sampleReq) {\n        offset = this.seekBestOverlapPosition();\n        this._outputBuffer.ensureAdditionalCapacity(this.overlapLength);\n        this.overlap(Math.floor(offset));\n        this._outputBuffer.put(this.overlapLength);\n        temp = this.seekWindowLength - 2 * this.overlapLength;\n        if (temp > 0) {\n          this._outputBuffer.putBuffer(this._inputBuffer, offset + this.overlapLength, temp);\n        }\n        var start = this._inputBuffer.startIndex + 2 * (offset + this.seekWindowLength - this.overlapLength);\n        this.midBuffer.set(this._inputBuffer.vector.subarray(start, start + 2 * this.overlapLength));\n        this.skipFract += this.nominalSkip;\n        overlapSkip = Math.floor(this.skipFract);\n        this.skipFract -= overlapSkip;\n        this._inputBuffer.receive(overlapSkip);\n      }\n    }\n  }, {\n    key: \"tempo\",\n    set: function set(newTempo) {\n      var intskip;\n      this._tempo = newTempo;\n      this.calculateSequenceParameters();\n      this.nominalSkip = this._tempo * (this.seekWindowLength - this.overlapLength);\n      this.skipFract = 0;\n      intskip = Math.floor(this.nominalSkip + 0.5);\n      this.sampleReq = Math.max(intskip + this.overlapLength, this.seekWindowLength) + this.seekLength;\n    },\n    get: function get() {\n      return this._tempo;\n    }\n  }, {\n    key: \"inputChunkSize\",\n    get: function get() {\n      return this.sampleReq;\n    }\n  }, {\n    key: \"outputChunkSize\",\n    get: function get() {\n      return this.overlapLength + Math.max(0, this.seekWindowLength - 2 * this.overlapLength);\n    }\n  }, {\n    key: \"quickSeek\",\n    set: function set(enable) {\n      this._quickSeek = enable;\n    }\n  }]);\n  return Stretch;\n}(AbstractFifoSamplePipe);\nvar testFloatEqual = function testFloatEqual(a, b) {\n  return (a > b ? a - b : b - a) > 1e-10;\n};\nvar SoundTouch = function () {\n  function SoundTouch() {\n    _classCallCheck(this, SoundTouch);\n    this.transposer = new RateTransposer(false);\n    this.stretch = new Stretch(false);\n    this._inputBuffer = new FifoSampleBuffer();\n    this._intermediateBuffer = new FifoSampleBuffer();\n    this._outputBuffer = new FifoSampleBuffer();\n    this._rate = 0;\n    this._tempo = 0;\n    this.virtualPitch = 1.0;\n    this.virtualRate = 1.0;\n    this.virtualTempo = 1.0;\n    this.calculateEffectiveRateAndTempo();\n  }\n  _createClass(SoundTouch, [{\n    key: \"clear\",\n    value: function clear() {\n      this.transposer.clear();\n      this.stretch.clear();\n    }\n  }, {\n    key: \"clone\",\n    value: function clone() {\n      var result = new SoundTouch();\n      result.rate = this.rate;\n      result.tempo = this.tempo;\n      return result;\n    }\n  }, {\n    key: \"calculateEffectiveRateAndTempo\",\n    value: function calculateEffectiveRateAndTempo() {\n      var previousTempo = this._tempo;\n      var previousRate = this._rate;\n      this._tempo = this.virtualTempo / this.virtualPitch;\n      this._rate = this.virtualRate * this.virtualPitch;\n      if (testFloatEqual(this._tempo, previousTempo)) {\n        this.stretch.tempo = this._tempo;\n      }\n      if (testFloatEqual(this._rate, previousRate)) {\n        this.transposer.rate = this._rate;\n      }\n      if (this._rate > 1.0) {\n        if (this._outputBuffer != this.transposer.outputBuffer) {\n          this.stretch.inputBuffer = this._inputBuffer;\n          this.stretch.outputBuffer = this._intermediateBuffer;\n          this.transposer.inputBuffer = this._intermediateBuffer;\n          this.transposer.outputBuffer = this._outputBuffer;\n        }\n      } else {\n        if (this._outputBuffer != this.stretch.outputBuffer) {\n          this.transposer.inputBuffer = this._inputBuffer;\n          this.transposer.outputBuffer = this._intermediateBuffer;\n          this.stretch.inputBuffer = this._intermediateBuffer;\n          this.stretch.outputBuffer = this._outputBuffer;\n        }\n      }\n    }\n  }, {\n    key: \"process\",\n    value: function process() {\n      if (this._rate > 1.0) {\n        this.stretch.process();\n        this.transposer.process();\n      } else {\n        this.transposer.process();\n        this.stretch.process();\n      }\n    }\n  }, {\n    key: \"rate\",\n    get: function get() {\n      return this._rate;\n    },\n    set: function set(rate) {\n      this.virtualRate = rate;\n      this.calculateEffectiveRateAndTempo();\n    }\n  }, {\n    key: \"rateChange\",\n    set: function set(rateChange) {\n      this._rate = 1.0 + 0.01 * rateChange;\n    }\n  }, {\n    key: \"tempo\",\n    get: function get() {\n      return this._tempo;\n    },\n    set: function set(tempo) {\n      this.virtualTempo = tempo;\n      this.calculateEffectiveRateAndTempo();\n    }\n  }, {\n    key: \"tempoChange\",\n    set: function set(tempoChange) {\n      this.tempo = 1.0 + 0.01 * tempoChange;\n    }\n  }, {\n    key: \"pitch\",\n    set: function set(pitch) {\n      this.virtualPitch = pitch;\n      this.calculateEffectiveRateAndTempo();\n    }\n  }, {\n    key: \"pitchOctaves\",\n    set: function set(pitchOctaves) {\n      this.pitch = Math.exp(0.69314718056 * pitchOctaves);\n      this.calculateEffectiveRateAndTempo();\n    }\n  }, {\n    key: \"pitchSemitones\",\n    set: function set(pitchSemitones) {\n      this.pitchOctaves = pitchSemitones / 12.0;\n    }\n  }, {\n    key: \"inputBuffer\",\n    get: function get() {\n      return this._inputBuffer;\n    }\n  }, {\n    key: \"outputBuffer\",\n    get: function get() {\n      return this._outputBuffer;\n    }\n  }]);\n  return SoundTouch;\n}();\nvar WebAudioBufferSource = function () {\n  function WebAudioBufferSource(buffer) {\n    _classCallCheck(this, WebAudioBufferSource);\n    this.buffer = buffer;\n    this._position = 0;\n  }\n  _createClass(WebAudioBufferSource, [{\n    key: \"extract\",\n    value: function extract(target) {\n      var numFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;\n      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;\n      this.position = position;\n      var left = this.buffer.getChannelData(0);\n      var right = this.dualChannel ? this.buffer.getChannelData(1) : this.buffer.getChannelData(0);\n      var i = 0;\n      for (; i < numFrames; i++) {\n        target[i * 2] = left[i + position];\n        target[i * 2 + 1] = right[i + position];\n      }\n      return Math.min(numFrames, left.length - position);\n    }\n  }, {\n    key: \"dualChannel\",\n    get: function get() {\n      return this.buffer.numberOfChannels > 1;\n    }\n  }, {\n    key: \"position\",\n    get: function get() {\n      return this._position;\n    },\n    set: function set(value) {\n      this._position = value;\n    }\n  }]);\n  return WebAudioBufferSource;\n}();\nvar getWebAudioNode = function getWebAudioNode(context, filter) {\n  var sourcePositionCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;\n  var bufferSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4096;\n  var node = context.createScriptProcessor(bufferSize, 2, 2);\n  var samples = new Float32Array(bufferSize * 2);\n  node.onaudioprocess = function (event) {\n    var left = event.outputBuffer.getChannelData(0);\n    var right = event.outputBuffer.getChannelData(1);\n    var framesExtracted = filter.extract(samples, bufferSize);\n    sourcePositionCallback(filter.sourcePosition);\n    if (framesExtracted === 0) {\n      filter.onEnd();\n    }\n    var i = 0;\n    for (; i < framesExtracted; i++) {\n      left[i] = samples[i * 2];\n      right[i] = samples[i * 2 + 1];\n    }\n  };\n  return node;\n};\nvar pad = function pad(n, width, z) {\n  z = z || '0';\n  n = n + '';\n  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;\n};\nvar minsSecs = function minsSecs(secs) {\n  var mins = Math.floor(secs / 60);\n  var seconds = secs - mins * 60;\n  return \"\".concat(mins, \":\").concat(pad(parseInt(seconds), 2));\n};\nvar onUpdate = function onUpdate(sourcePosition) {\n  var currentTimePlayed = this.timePlayed;\n  var sampleRate = this.sampleRate;\n  this.sourcePosition = sourcePosition;\n  this.timePlayed = sourcePosition / sampleRate;\n  if (currentTimePlayed !== this.timePlayed) {\n    var timePlayed = new CustomEvent('play', {\n      detail: {\n        timePlayed: this.timePlayed,\n        formattedTimePlayed: this.formattedTimePlayed,\n        percentagePlayed: this.percentagePlayed\n      }\n    });\n    this._node.dispatchEvent(timePlayed);\n  }\n};\nvar PitchShifter = function () {\n  function PitchShifter(context, buffer, bufferSize) {\n    var _this = this;\n    var onEnd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;\n    _classCallCheck(this, PitchShifter);\n    this._soundtouch = new SoundTouch();\n    var source = new WebAudioBufferSource(buffer);\n    this.timePlayed = 0;\n    this.sourcePosition = 0;\n    this._filter = new SimpleFilter(source, this._soundtouch, onEnd);\n    this._node = getWebAudioNode(context, this._filter, function (sourcePostion) {\n      return onUpdate.call(_this, sourcePostion);\n    });\n    this.tempo = 1;\n    this.rate = 1;\n    this.duration = buffer.duration;\n    this.sampleRate = context.sampleRate;\n    this.listeners = [];\n  }\n  _createClass(PitchShifter, [{\n    key: \"connect\",\n    value: function connect(toNode) {\n      this._node.connect(toNode);\n    }\n  }, {\n    key: \"disconnect\",\n    value: function disconnect() {\n      this._node.disconnect();\n    }\n  }, {\n    key: \"on\",\n    value: function on(eventName, cb) {\n      this.listeners.push({\n        name: eventName,\n        cb: cb\n      });\n      this._node.addEventListener(eventName, function (event) {\n        return cb(event.detail);\n      });\n    }\n  }, {\n    key: \"off\",\n    value: function off() {\n      var _this2 = this;\n      var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;\n      var listeners = this.listeners;\n      if (eventName) {\n        listeners = listeners.filter(function (e) {\n          return e.name === eventName;\n        });\n      }\n      listeners.forEach(function (e) {\n        _this2._node.removeEventListener(e.name, function (event) {\n          return e.cb(event.detail);\n        });\n      });\n    }\n  }, {\n    key: \"formattedDuration\",\n    get: function get() {\n      return minsSecs(this.duration);\n    }\n  }, {\n    key: \"formattedTimePlayed\",\n    get: function get() {\n      return minsSecs(this.timePlayed);\n    }\n  }, {\n    key: \"percentagePlayed\",\n    get: function get() {\n      return 100 * this._filter.sourcePosition / (this.duration * this.sampleRate);\n    },\n    set: function set(perc) {\n      this._filter.sourcePosition = parseInt(perc * this.duration * this.sampleRate);\n    }\n  }, {\n    key: \"node\",\n    get: function get() {\n      return this._node;\n    }\n  }, {\n    key: \"pitch\",\n    set: function set(pitch) {\n      this._soundtouch.pitch = pitch;\n    }\n  }, {\n    key: \"pitchSemitones\",\n    set: function set(semitone) {\n      this._soundtouch.pitchSemitones = semitone;\n    }\n  }, {\n    key: \"rate\",\n    set: function set(rate) {\n      this._soundtouch.rate = rate;\n    }\n  }, {\n    key: \"tempo\",\n    set: function set(tempo) {\n      this._soundtouch.tempo = tempo;\n    }\n  }]);\n  return PitchShifter;\n}();\n\n// CONCATENATED MODULE: ../src/audio/RateProcessor.js\n\n\n\n\n\n\nfunction RateProcessor_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, RateProcessor_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction RateProcessor_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (RateProcessor_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: process audio data of rate speed\r\n * @author: xuluying \r\n * @file: RateProcessor.js\r\n */\n\n\n\nvar RateProcessor_RateProcessor = /*#__PURE__*/function (_BaseClass) {\n  function RateProcessor(options) {\n    var _this;\n    classCallCheck_default()(this, RateProcessor);\n    _this = RateProcessor_callSuper(this, RateProcessor, [options]);\n    defineProperty_default()(_this, \"soundTouch\", void 0);\n    defineProperty_default()(_this, \"filter\", void 0);\n    _this.init(options.source);\n    return _this;\n  }\n  inherits_default()(RateProcessor, _BaseClass);\n  return createClass_default()(RateProcessor, [{\n    key: \"init\",\n    value: function init(source) {\n      this.soundTouch = new SoundTouch();\n      this.soundTouch.tempo = 1;\n      this.soundTouch.rate = 1;\n      this.filter = new SimpleFilter(source, this.soundTouch, 2048);\n    }\n  }, {\n    key: \"rate\",\n    set: function set(value) {\n      this.soundTouch.tempo = value;\n    }\n  }, {\n    key: \"provide\",\n    value: function provide(size) {\n      var target = new Float32Array(size * 2);\n      var framesExtracted = this.filter.extract(target, size);\n      // console.error('[Rate] request size = %d, response size = %d', size, framesExtracted)\n      var left = new Float32Array(framesExtracted);\n      var right = new Float32Array(framesExtracted);\n      for (var i = 0; i < framesExtracted; i++) {\n        left[i] = target[i * 2];\n        right[i] = target[i * 2 + 1];\n      }\n      return {\n        size: framesExtracted,\n        left: left,\n        right: right\n      };\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/audio/AudioProvider.js\n\n\n\n\n\n\nfunction AudioProvider_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, AudioProvider_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction AudioProvider_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (AudioProvider_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: manage pcm data\r\n * @author: xuluying \r\n * @file: AudioProvider.js\r\n */\n\n\n\n\nvar AudioProvider_AudioProvider = /*#__PURE__*/function (_BaseClass) {\n  function AudioProvider(options) {\n    var _this;\n    classCallCheck_default()(this, AudioProvider);\n    _this = AudioProvider_callSuper(this, AudioProvider, [options]);\n    defineProperty_default()(_this, \"currentRate\", 1);\n    defineProperty_default()(_this, \"source\", []);\n    defineProperty_default()(_this, \"commonProcessor\", void 0);\n    defineProperty_default()(_this, \"rateProcessor\", void 0);\n    defineProperty_default()(_this, \"audioTime\", 0);\n    _this.source = options.source;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(AudioProvider, _BaseClass);\n  return createClass_default()(AudioProvider, [{\n    key: \"init\",\n    value: function init() {\n      var _this2 = this;\n      this.commonProcessor = new CommonProcessor_CommonProcessor({\n        source: this.source,\n        onPlay: function onPlay(time) {\n          _this2.audioTime = time;\n        }\n      });\n      this.rateProcessor = new RateProcessor_RateProcessor({\n        source: this.commonProcessor\n      });\n    }\n  }, {\n    key: \"rate\",\n    set: function set(value) {\n      this.currentRate = value;\n      this.rateProcessor.rate = value;\n    }\n  }, {\n    key: \"provide\",\n    value: function provide(size) {\n      var provider = this.currentRate === 1 ? this.commonProcessor : this.rateProcessor;\n      var audioData = provider.provide(size);\n      audioData.audioTime = this.audioTime;\n      return audioData;\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/audio/AudioContextPlayer.js\n\n\n\n\n\n\nfunction AudioContextPlayer_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, AudioContextPlayer_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction AudioContextPlayer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (AudioContextPlayer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: audioContext play audio data\r\n * @author: xuluying \r\n * @file: AudioContextPlayer.js\r\n */\n\n\n\n\nvar EVENTS = {\n  CANPLAY: 'canplaythrough',\n  SEEKED: 'seeked',\n  WAIT: 'waiting'\n};\nvar AudioContextPlayer_AudioContextPlayer = /*#__PURE__*/function (_BaseClass) {\n  function AudioContextPlayer(options) {\n    var _this;\n    classCallCheck_default()(this, AudioContextPlayer);\n    _this = AudioContextPlayer_callSuper(this, AudioContextPlayer, [options]);\n    defineProperty_default()(_this, \"audioContext\", null);\n    defineProperty_default()(_this, \"scriptNode\", null);\n    defineProperty_default()(_this, \"gainNode\", null);\n    defineProperty_default()(_this, \"delay\", 0);\n    defineProperty_default()(_this, \"audioBuffer\", new ArrayBuffer(0));\n    defineProperty_default()(_this, \"decodedBuffer\", []);\n    defineProperty_default()(_this, \"isFirstPlay\", true);\n    defineProperty_default()(_this, \"defaultVolume\", 1);\n    defineProperty_default()(_this, \"currentRate\", 1);\n    defineProperty_default()(_this, \"eventListeners\", {});\n    defineProperty_default()(_this, \"canPlay\", false);\n    defineProperty_default()(_this, \"interval\", void 0);\n    defineProperty_default()(_this, \"seekTimeDelta\", 0);\n    defineProperty_default()(_this, \"audioTime\", 0);\n    defineProperty_default()(_this, \"audioProvider\", void 0);\n    defineProperty_default()(_this, \"isWaiting\", false);\n    options = Object.assign({}, options);\n    _this.flushTime = options.flushTime || 1000;\n    _this.onReady = options.onReady;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(AudioContextPlayer, _BaseClass);\n  return createClass_default()(AudioContextPlayer, [{\n    key: \"init\",\n    value: function init() {\n      this.audioProvider = new AudioProvider_AudioProvider({\n        source: this.decodedBuffer\n      });\n      if (typeof this.onReady == 'function') {\n        setTimeout(this.onReady, 0);\n      }\n    }\n  }, {\n    key: \"feed\",\n    value: function feed(_ref) {\n      var audio = _ref.audio;\n      this.audioBuffer = this.appendByteArray(this.audioBuffer, audio);\n      if (!this.canPlay) {\n        this.canPlay = true;\n        this.triggerEvent(EVENTS.CANPLAY);\n      }\n    }\n  }, {\n    key: \"appendByteArray\",\n    value: function appendByteArray(buffer1, buffer2) {\n      var tmp = new Uint8Array((buffer1.byteLength | 0) + (buffer2.byteLength | 0));\n      tmp.set(new Uint8Array(buffer1), 0);\n      tmp.set(new Uint8Array(buffer2), buffer1.byteLength | 0);\n      var res = tmp.buffer;\n      return res;\n    }\n  }, {\n    key: \"decodeAudioData\",\n    value: function decodeAudioData(callback) {\n      var _this2 = this;\n      if (this.audioBuffer && this.audioBuffer.byteLength > 0) {\n        this.audioContext.decodeAudioData(this.audioBuffer, function (buffer) {\n          buffer.startTime = _this2.delay;\n          _this2.delay += buffer.duration;\n          _this2.decodedBuffer.push(buffer);\n          if (callback) {\n            callback.call();\n          }\n        }, function (err) {\n          _this2.logger.error('decodeAudioData', err);\n        });\n        this.audioBuffer = new ArrayBuffer(0);\n      }\n    }\n  }, {\n    key: \"play\",\n    value: function play() {\n      var _this3 = this;\n      return new Promise(function (resolve, reject) {\n        if (_this3.isFirstPlay) {\n          _this3.isFirstPlay = false;\n          _this3.logger.info('startPlay');\n          _this3.audioContext = new (window.AudioContext || window.webkitAudioContext)();\n          _this3.gainNode = _this3.audioContext.createGain();\n          _this3.gainNode.gain.value = _this3.defaultVolume;\n          _this3.scriptNode = _this3.audioContext.createScriptProcessor(2048, 2, 2);\n          _this3.scriptNode.onaudioprocess = function (audioProcessingEvent) {\n            var outputBuffer = audioProcessingEvent.outputBuffer;\n            var sourceSize = outputBuffer.length;\n            var audioData = _this3.audioProvider.provide(sourceSize);\n            if (audioData.size === 0) {\n              if (!_this3.isWaiting) {\n                _this3.isWaiting = true;\n                _this3.triggerEvent(EVENTS.WAIT);\n              }\n              return;\n            } else {\n              if (_this3.isWaiting) {\n                _this3.isWaiting = false;\n                _this3.triggerEvent(EVENTS.CANPLAY);\n              }\n            }\n            var leftDst = outputBuffer.getChannelData(0);\n            var rightDst = outputBuffer.getChannelData(1);\n            if (audioData.audioTime != 0) {\n              _this3.audioTime = audioData.audioTime;\n            }\n            leftDst.set(audioData.left);\n            rightDst.set(audioData.right);\n            if (audioData.size < sourceSize) {\n              var emptyArray = new Float32Array(sourceSize - audioData.size);\n              leftDst.set(emptyArray, audioData.size);\n              rightDst.set(emptyArray, audioData.size);\n            }\n          };\n          _this3.scriptNode.connect(_this3.gainNode);\n          _this3.gainNode.connect(_this3.audioContext.destination);\n          console.error(\"到了这里了\");\n          _this3.decodeAudioData.call(_this3, _this3.testAutoplay.bind(_this3, resolve, reject));\n          _this3.interval = setInterval(_this3.decodeAudioData.bind(_this3), _this3.flushTime);\n        } else {\n          if (_this3.audioContext.state === 'suspended') {\n            _this3.audioContext.resume().then(function () {\n              _this3.logger.info('play', 'Audio is resumed');\n              resolve();\n            });\n          } else {\n            // resumed from wait\n            _this3.logger.info('Audio resumed from waiting');\n            resolve();\n          }\n        }\n      });\n    }\n  }, {\n    key: \"currentTime\",\n    get: function get() {\n      return this.audioTime;\n    },\n    set: function set(time) {\n      var _this4 = this;\n      this.audioTime = time;\n      while (this.decodedBuffer.length > 0) {\n        var tmpBuffer = this.decodedBuffer.shift();\n        if (tmpBuffer.startTime <= time && tmpBuffer.startTime + tmpBuffer.duration > time) {\n          tmpBuffer.loadedPosition = parseInt(tmpBuffer.length * (time - tmpBuffer.startTime) / tmpBuffer.duration);\n          this.decodedBuffer.unshift(tmpBuffer);\n          break;\n        }\n      }\n      //sync trigger seeked event\n      setTimeout(function () {\n        _this4.triggerEvent(EVENTS.SEEKED);\n      }, 0);\n    }\n  }, {\n    key: \"pause\",\n    value: function pause() {\n      var _this5 = this;\n      if (this.audioContext) {\n        this.audioContext.suspend().then(function () {\n          _this5.logger.info('pause', 'Audio is paused');\n        });\n      }\n    }\n  }, {\n    key: \"addEventListener\",\n    value: function addEventListener(type, handler) {\n      this.eventListeners[type] = handler;\n    }\n  }, {\n    key: \"triggerEvent\",\n    value: function triggerEvent(type) {\n      var handler = this.eventListeners[type];\n      if (handler) {\n        handler.call();\n      }\n    }\n  }, {\n    key: \"buffer\",\n    value: function buffer() {\n      var start = 0;\n      if (this.decodedBuffer.length > 0) {\n        var tmp = this.decodedBuffer[0];\n        start = tmp.startTime;\n      }\n      return {\n        start: start * 1000,\n        end: parseInt(this.delay * 1000)\n      };\n    }\n  }, {\n    key: \"volume\",\n    get: function get() {\n      return this.gainNode.gain.value;\n    },\n    set: function set(value) {\n      if (this.gainNode) {\n        this.gainNode.gain.value = value;\n      } else {\n        this.defaultVolume = value;\n      }\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      this.delay = 0;\n      if (this.audioContext) {\n        clearInterval(this.interval);\n        // Fix get currentTime after reset\n        this.scriptNode.disconnect();\n        this.scriptNode = null;\n        this.audioContext.close();\n        this.audioContext = null;\n      }\n      this.gainNode = null;\n      this.audioBuffer = new ArrayBuffer(0);\n      this.canPlay = false;\n      this.isFirstPlay = true;\n      this.decodedBuffer.length = 0;\n      this.seekTimeDelta = 0;\n      this.audioTime = 0;\n    }\n  }, {\n    key: \"playbackRate\",\n    set: function set(value) {\n      if (value !== this.currentRate) {\n        this.currentRate = value;\n        this.audioProvider.rate = value;\n      }\n    }\n  }, {\n    key: \"testAutoplay\",\n    value: function testAutoplay(resolve, reject) {\n      var audio = Element_Element.createEl('audio');\n      var promise = audio.play();\n      audio = null;\n      var isRejected = false;\n      if (promise !== undefined) {\n        promise.catch(function () {\n          isRejected = true;\n        });\n        setTimeout(function () {\n          promise = null;\n          if (isRejected) {\n            reject('Autoplay is prevented');\n          } else {\n            resolve();\n          }\n        }, 100);\n      } else {\n        reject('Promise is undefined');\n      }\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/audio/AudioPlayer.js\n\n\n\n\n\n\nfunction AudioPlayer_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, AudioPlayer_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction AudioPlayer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (AudioPlayer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: audioPlayer entry file, inclue audio data decode and play\r\n * @author: liuliguo \r\n * @file: AudioPlayer.js\r\n */\n\n\n\n\n\nvar AudioPlayer_AudioPlayer = /*#__PURE__*/function (_BaseClass) {\n  function AudioPlayer() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, AudioPlayer);\n    _this = AudioPlayer_callSuper(this, AudioPlayer, [options]);\n    defineProperty_default()(_this, \"need\", true);\n    defineProperty_default()(_this, \"first\", false);\n    defineProperty_default()(_this, \"offset\", 0);\n    defineProperty_default()(_this, \"currentPTS\", 0);\n    defineProperty_default()(_this, \"ready\", false);\n    defineProperty_default()(_this, \"end\", false);\n    defineProperty_default()(_this, \"lastData\", null);\n    defineProperty_default()(_this, \"nodeParent\", null);\n    defineProperty_default()(_this, \"useJMuxer\", false);\n    _this.player = options.audioNode;\n    _this.createAudioMuxer();\n    _this.bindEvent();\n    _this.logger.info('audioDecoder', _this.useJMuxer ? 'JMuxer' : 'AudioContext');\n    return _this;\n  }\n  inherits_default()(AudioPlayer, _BaseClass);\n  return createClass_default()(AudioPlayer, [{\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.bindNodeEvent();\n      this.events.on(EventsConfig.PlayerMaxPTS, function (maxAudioPts) {\n        if (_this2.currentPTS === maxAudioPts) {\n          _this2.end = true;\n        }\n      });\n    }\n  }, {\n    key: \"bindNodeEvent\",\n    value: function bindNodeEvent() {\n      var _this3 = this;\n      this.addEventListener('seeked', function () {\n        if (_this3.onSeekedHandler) {\n          _this3.onSeekedHandler();\n        }\n        _this3.events.emit('AudioPlayer.seeked');\n      });\n      this.addEventListener('canplaythrough', function () {\n        _this3.logger.info('canplaythrough');\n        if (!_this3.ready) {\n          _this3.ready = true;\n          _this3.status = 'ready';\n          _this3.logger.info('constructor', 'canplaythrough', 'ready');\n          _this3.events.emit(EventsConfig.AudioPlayerDataReady);\n        }\n      });\n      this.addEventListener('waiting', function () {\n        _this3.ready = false;\n        if (!_this3.end) {\n          _this3.logger.warn('audioPlayer waiting', _this3.player.currentTime, _this3.currentPTS);\n          _this3.status = 'waiting';\n          _this3.events.emit(EventsConfig.AudioPlayerWait, 'audio');\n        } else {\n          if (!_this3.useJMuxer) {\n            _this3.player.destroy();\n          }\n          _this3.status = 'end';\n          _this3.events.emit(EventsConfig.AudioPlayerEnd, 'audio');\n          _this3.logger.info('audioPlayer end');\n        }\n      });\n    }\n  }, {\n    key: \"reset\",\n    value: function reset() {\n      this.lastData = null;\n      this.first = false;\n      this.offset = 0;\n      this.currentPTS = 0;\n      this.ready = false;\n      this.end = false;\n      this.clear();\n      this.createAudioMuxer();\n      this.bindNodeEvent();\n      this.stime = null;\n    }\n  }, {\n    key: \"createNode\",\n    value: function createNode() {\n      this.player = document.createElement('audio');\n      this.player.classList.add('goldplay__audio--player');\n      this.parentNode.appendChild(this.player);\n    }\n  }, {\n    key: \"createAudioMuxer\",\n    value: function createAudioMuxer() {\n      if (this.useJMuxer) {\n        this.audioDecoder = new jmuxer({\n          node: this.player,\n          mode: 'audio',\n          debug: false,\n          clearBuffer: true,\n          flushingTime: 10,\n          onReady: this.onMSEReady.bind(this)\n        });\n      } else {\n        this.audioDecoder = new AudioContextPlayer_AudioContextPlayer({\n          flushTime: 100,\n          onReady: this.onMSEReady.bind(this)\n        });\n        this.player = this.audioDecoder;\n      }\n    }\n  }, {\n    key: \"onMSEReady\",\n    value: function onMSEReady() {\n      this.logger.info('onMSEReady', 'AudioPlayerReady');\n      this.events.emit(EventsConfig.AudioPlayerReady);\n    }\n  }, {\n    key: \"clear\",\n    value: function clear() {\n      this.audioDecoder.destroy();\n      this.audioDecoder = null;\n    }\n  }, {\n    key: \"play\",\n    value: function play() {\n      var _this4 = this;\n      if (this.status !== 'playing') {\n        this.status = 'playing';\n        this.player.play().then(function () {\n          _this4.events.emit(EventsConfig.AudioPlayerPlaySuccess);\n        }).catch(function (error) {\n          _this4.logger.error('play', 'errorInfo:', error);\n          _this4.events.emit(EventsConfig.AudioPlayerPlayFail);\n          if (error === 'Autoplay is prevented') {\n            _this4.events.emit(EventsConfig.AutoPlayerPlayFail);\n          }\n        });\n      }\n    }\n  }, {\n    key: \"muted\",\n    set: function set(value) {\n      this.player.muted = !!value;\n    }\n  }, {\n    key: \"playbackRate\",\n    set: function set(value) {\n      this.player.playbackRate = value;\n    }\n  }, {\n    key: \"pause\",\n    value: function pause() {\n      if (this.status !== 'pause') {\n        this.status = 'pause';\n        this.player.pause();\n      }\n    }\n  }, {\n    key: \"volume\",\n    get: function get() {\n      return this.player.volume;\n    },\n    set: function set(value) {\n      this.player.volume = value;\n      if (value === 0) {\n        this.muted = true;\n      } else {\n        this.muted = false;\n      }\n    }\n  }, {\n    key: \"currentTime\",\n    get: function get() {\n      return parseInt(this.player.currentTime * 1000 + this.offset);\n    },\n    set: function set(time) {\n      this.player.currentTime = (time - this.offset) / 1000;\n    }\n  }, {\n    key: \"paused\",\n    get: function get() {\n      return this.player.paused;\n    }\n  }, {\n    key: \"send\",\n    value: function send(data) {\n      if (!data.PTS) {\n        this.need = false;\n        this.events.emit(EventsConfig.AudioPlayerDataReady);\n        return;\n      }\n      this.need = true;\n      if (!this.audioDecoder) {\n        this.logger.error('send', 'audioDecoder is:', this.audioDecoder);\n        return;\n      }\n      if (!this.stime) {\n        this.stime = Date.now();\n      }\n      data = this.format(data);\n      if (data.audioEnd) {\n        this.logger.info('push', 'audioEnd');\n        this.feed(this.lastData);\n        this.lastData = null;\n        return;\n      }\n      if (!this.first) {\n        this.first = true;\n        this.offset = data.start;\n      }\n      if (data.PTS > this.currentPTS) {\n        if (!this.lastData) {\n          this.lastData = data;\n          return;\n        } else {\n          //get the audio packekt duration\n          this.lastData.duration = data.PTS - this.lastData.PTS;\n        }\n        this.feed(this.lastData);\n        //record the previous audio duration\n        data.duration = this.lastData.duration;\n        this.lastData = data;\n      }\n    }\n  }, {\n    key: \"feed\",\n    value: function feed(data) {\n      this.audioDecoder.feed({\n        audio: data.data_byte,\n        duration: data.duration\n      });\n      this.currentPTS = data.PTS;\n    }\n  }, {\n    key: \"format\",\n    value: function format(data) {\n      if (data && data.data_byte) {\n        data.start = data.PTS;\n      }\n      return data;\n    }\n  }, {\n    key: \"addEventListener\",\n    value: function addEventListener(type, handler) {\n      this.player.addEventListener(type, handler);\n    }\n  }, {\n    key: \"isBuffered\",\n    value: function isBuffered(time) {\n      var bufferList = [this.buffer()];\n      var index = bufferList.findIndex(function (item) {\n        return time >= item.start && time < item.end;\n      });\n      return index !== -1;\n    }\n  }, {\n    key: \"buffer\",\n    value: function buffer() {\n      if (this.useJMuxer) {\n        var buffer = this.player.buffered;\n        var length = buffer.length;\n        var bufferInfo = {};\n        while (length > 0) {\n          bufferInfo.start = buffer.start(length - 1) * 1000 + this.offset;\n          bufferInfo.end = buffer.end(length - 1) * 1000 + this.offset;\n          length--;\n        }\n        return bufferInfo;\n      } else {\n        var _buffer = this.player.buffer();\n        return {\n          start: _buffer.start + this.offset,\n          end: _buffer.end + this.offset\n        };\n      }\n    }\n  }, {\n    key: \"offset\",\n    set: function set(value) {\n      this.offset = value;\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/config/CSSConfig.js\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file CSSConfig.js\r\n * @desc\r\n * css config\r\n * @author Jarry\r\n */\n\nvar CSSConfig = {\n  playerContainer: 'goldplay__container',\n  screenContainer: 'goldplay__screen--container',\n  screenCanvas: 'goldplay__screen--canvas',\n  audioContainer: 'goldplay__audio--container',\n  audioPlayer: 'goldplay__audio--player',\n  controlContainer: 'goldplay__control--container',\n  containerFullPage: 'goldplay__container-fullpage',\n  containerFullScreen: 'goldplay__container-fullscreen',\n  controlContainerFloat: 'goldplay__control--container-float',\n  bigPlayButton: 'goldplay__screen--bigplay',\n  poster: 'goldplay__screen--poster',\n  nearside: 'goldplay__control--nearside',\n  sidebar: 'goldplay__control--sidebar',\n  buttonBlock: 'goldplay__control--button-block',\n  playButton: 'goldplay__control--play',\n  pauseButton: 'goldplay__control--pause',\n  replayButton: 'goldplay__control--replay',\n  speedBar: 'goldplay__speed-bar',\n  speedBarBox: 'goldplay__speed-bar--box',\n  rateBar: 'goldplay__rate-bar',\n  rateBarBox: 'goldplay__rate-bar--box',\n  fullPage: 'goldplay__control--fullpage',\n  fullScreen: 'goldplay__control--fullscreen',\n  waitingBar: 'goldplay__waiting-bar',\n  progressBar: 'goldplay__progress-bar',\n  progressBarHover: 'goldplay__progress-bar-hover',\n  progressBarPlay: 'goldplay__progressbar--play',\n  progressBarPlayHover: 'goldplay__progressbar--play-hover',\n  progressBarLoad: 'goldplay__progressbar--load',\n  progressBarLoadHover: 'goldplay__progressbar--load-hover',\n  progressBarDot: 'goldplay__progressbar--dot',\n  progressBarDotHover: 'goldplay__progressbar--dot-hover',\n  volumeBar: 'goldplay__volume-bar',\n  volumeBarAudio: 'goldplay__volume-bar--audio',\n  volumeBarAudioOn: 'goldplay__volume-bar--audio-on',\n  volumeBarAudioOff: 'goldplay__volume-bar--audio-off',\n  volumeBarHandle: 'goldplay__volume-bar--handle',\n  volumeBarRod: 'goldplay__volume-bar--rod',\n  volumeBarRodHover: 'goldplay__volume-bar--rod-hover',\n  volumeBarSize: 'goldplay__volume-bar--size',\n  volumeBarColumn: 'goldplay__volume-bar--column',\n  alertBox: 'goldplay__alter-box',\n  alertClose: 'goldplay__alter--close'\n};\n\n// CONCATENATED MODULE: ../src/utils/PlayerUtil.js\n\n\n\n\n\n\n\nfunction PlayerUtil_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, PlayerUtil_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction PlayerUtil_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (PlayerUtil_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file PlayerUtil.js\r\n * @desc\r\n * common utils function from Player\r\n * @author Jarry\r\n */\n\n\nvar PlayerUtil_cssName = CSSConfig;\nvar PlayerUtil_PlayerUtil = /*#__PURE__*/function () {\n  function PlayerUtil() {\n    classCallCheck_default()(this, PlayerUtil);\n  }\n  return createClass_default()(PlayerUtil, null, [{\n    key: \"createContainer\",\n    value: function createContainer() {\n      var ContainerElement = /*#__PURE__*/function (_HTMLDivElement) {\n        function ContainerElement() {\n          classCallCheck_default()(this, ContainerElement);\n          return PlayerUtil_callSuper(this, ContainerElement, arguments);\n        }\n        inherits_default()(ContainerElement, _HTMLDivElement);\n        return createClass_default()(ContainerElement);\n      }( /*#__PURE__*/wrapNativeSuper_default()(HTMLDivElement));\n      var tagName = 'gp-container';\n      if (!customElements.get(tagName)) {\n        customElements.define(tagName, ContainerElement, {\n          extends: 'div'\n        });\n      }\n      var $ele = Element_Element.createEl(tagName, 'div');\n      $ele.className = PlayerUtil_cssName.playerContainer;\n      $ele.style.width = '100%'; //(player.options.width ? player.options.width : player.el.offsetWidth) + 'px'\n      $ele.style.height = '100%'; //(player.options.height  ? player.options.height : player.el.offsetHeight) + 'px'\n      return $ele;\n    }\n  }, {\n    key: \"createScreenContainer\",\n    value: function createScreenContainer() {\n      // const $container = player.$container\n      var ScreenElement = /*#__PURE__*/function (_HTMLDivElement2) {\n        function ScreenElement() {\n          classCallCheck_default()(this, ScreenElement);\n          return PlayerUtil_callSuper(this, ScreenElement, arguments);\n        }\n        inherits_default()(ScreenElement, _HTMLDivElement2);\n        return createClass_default()(ScreenElement);\n      }( /*#__PURE__*/wrapNativeSuper_default()(HTMLDivElement));\n      var tagName = 'gp-screen';\n      if (!customElements.get(tagName)) {\n        customElements.define(tagName, ScreenElement, {\n          extends: 'div'\n        });\n      }\n      var $ele = Element_Element.createEl(tagName, 'div');\n      $ele.classList.add(PlayerUtil_cssName.screenContainer);\n      // let screenHeight\n      // if (player.controlBarAutoHide) {\n      //   screenHeight = $container.offsetHeight\n      // } else {\n      //   screenHeight = $container.offsetHeight - player.controlBarHeight\n      // }\n      // $ele.style.height = screenHeight + 'px'\n      $ele.style.height = '100%'; //screenHeight + 'px'\n      return $ele;\n    }\n  }, {\n    key: \"createAudioContainer\",\n    value: function createAudioContainer() {\n      var $ele = Element_Element.createEl('gp-audio');\n      $ele.classList.add(PlayerUtil_cssName.audioContainer);\n      $ele.style.display = 'none';\n      return $ele;\n    }\n  }, {\n    key: \"createAudio\",\n    value: function createAudio() {\n      var $ele = Element_Element.createEl('audio');\n      $ele.classList.add(PlayerUtil_cssName.audioPlayer);\n      $ele.controls = true;\n      return $ele;\n    }\n  }, {\n    key: \"clearCavans\",\n    value: function clearCavans($canvas) {\n      var context = $canvas.getContext('webgl');\n      context.clear(context.COLOR_BUFFER_BIT);\n    }\n  }]);\n}();\ndefineProperty_default()(PlayerUtil_PlayerUtil, \"createCanvas\", function (player) {\n  var $ele = Element_Element.createEl('canvas');\n  $ele.style.display = 'none';\n  $ele.classList.add(PlayerUtil_cssName.screenCanvas);\n  $ele.width = player.options.screenWidth || player.screenWidth;\n  $ele.height = player.options.screenHeight || player.screenHeight;\n  return $ele;\n});\n\n// CONCATENATED MODULE: ../src/toolkit/Template.js\n\n\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Template.js\r\n * @desc\r\n * Simple template engine based on string substitution processing\r\n * Support `slot` and `function` from extract pip separator\r\n * @author Jarry\r\n */\n\nvar Template_logger = Logger[\"a\" /* default */].get('Template.js');\nvar Template_Template = /*#__PURE__*/function () {\n  function Template() {\n    classCallCheck_default()(this, Template);\n  }\n  return createClass_default()(Template, null, [{\n    key: \"mergeVar\",\n    value: function mergeVar(tpl) {\n      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n      if (typeof tpl !== 'string' || tpl === '') {\n        return tpl;\n      }\n      try {\n        var str = '';\n        var reg = new RegExp('\\\\${\\'?\"?\\\\s*' + '([.:a-z0-9_s]+?)' + '\\\\s*\\'?\"?}', 'ig');\n        str = tpl.replace(reg, function (tpl, name) {\n          name = name.trim();\n          var value = data[name];\n          value = value === null ? '' : value;\n          value = value === undefined ? '' : value;\n          value = !value ? '' : value;\n          return value;\n        });\n        return str;\n      } catch (e) {\n        Template_logger.error('mergeVar', 'replace variable', 'error:', e);\n        return tpl;\n      }\n    }\n  }, {\n    key: \"makeValue\",\n    value: function makeValue(key, value, keyType) {\n      if (typeof value !== 'string' && typeof value !== 'function') {\n        return value;\n      }\n      // the value using Template.create`` declaration will returns a function\n      if (typeof value === 'function') {\n        value = value.call(this, this.data);\n      }\n      // Normal variable will returns text\n      if (!keyType) {\n        return Template.escapeHTML.call(this, value);\n      }\n      var _getSlot = function _getSlot(componentName) {\n        var replacelotFlag = '';\n        if (componentName) {\n          replacelotFlag = \" \".concat(Template.slotReplaceName, \"=\\\"true\\\"\");\n        }\n        return \"<gp-slot style=\\\"display:none\\\"\".concat(replacelotFlag, \"></gp-slot>\");\n      };\n      var componetName;\n      // markup the slot flag for slotType(html|component)\n      if (Template.isSoltType(keyType)) {\n        if (typeof this.getComponent !== 'function') {\n          Template_logger.error('makeValue', 'the object is not support slot mode.', this.getComponent, value);\n          return value;\n        }\n        switch (keyType) {\n          case Template.slotTypeMap.component:\n            {\n              componetName = value;\n              var component = this.getComponent(componetName);\n              if (typeof_default()(component) === 'object' && component.element) {\n                component.element.setAttribute(Template.slotReplaceName, 'true');\n                value = component.element.outerHTML;\n              } else {\n                value = _getSlot(componetName);\n              }\n              break;\n            }\n          case Template.slotTypeMap.html:\n            // the value is declared by String directly\n            value = Template.mergeVar.call(this, value, this.data);\n            break;\n          default:\n            break;\n        }\n        // append slot flag to template\n        var slotComNameStr = '';\n        if (componetName !== undefined) {\n          slotComNameStr = \" \".concat(Template.slotComName, \"=\\\"\").concat(componetName, \"\\\" \");\n        }\n        var replaced = '$1 ' + Template.slotTypeName + '=\"' + keyType + '\" ' + Template.slotKeyName + '=\"' + key + '\"' + slotComNameStr + '$2';\n        if (typeof value === 'string') {\n          value = value === '' ? _getSlot() : value;\n          value = value.replace(/^\\s*(<\\s?[\\w-]*)(.*[\\r|\\n|>])/, replaced);\n        }\n        return value;\n      } else if (typeof keyType === 'string') {\n        // extract method and convert the value\n        var method = TemplateUtil[keyType];\n        if (typeof method === 'function') {\n          value = method.call(this, value);\n        }\n        return value;\n      }\n      return Template.escapeHTML.call(this, value);\n    }\n  }, {\n    key: \"escapeHTML\",\n    value: function escapeHTML(str) {\n      if (typeof str !== 'string') {\n        return str;\n      }\n      return str.replace(/&/g, \"&amp;\").replace(/</g, \"&lt;\").replace(/>/g, \"&gt;\").replace(/\"/g, \"&quot;\").replace(/'/g, \"&#039;\");\n    }\n  }, {\n    key: \"generate\",\n    value: function generate(strings, keys, values) {\n      var _this = this;\n      var dict = values[values.length - 1] || {};\n      var result = [strings[0]];\n      keys.forEach(function (key, i) {\n        if (!key) {\n          return;\n        }\n        // extract the keyType by pip separator\n        var keyName = key.split(Template.pipSeparator);\n        var value, keyType;\n        if (keyName.length > 1) {\n          key = keyName[0];\n          keyType = keyName[1];\n        }\n        value = Number.isInteger(key) ? values[key] : dict[key];\n        var makeValue = Template.makeValue.bind(_this);\n        value = makeValue(key, value, keyType);\n        if (value !== undefined) {\n          result.push(value);\n        }\n        if (strings[i + 1] !== undefined) {\n          result.push(strings[i + 1]);\n        }\n      });\n      return result.join('');\n    }\n\n    /**\r\n     * @usage\r\n     * const obj = { data: Object, getComponent: Function }\r\n     * obj.createTemplate = Template.create.bind(obj)\r\n     * 1. pass template string, support html|component slot\r\n     * obj.template = obj.createTemplate`<div>this is ${'key'}, ${icon|html'} ${'speedBarName|component'} </div>`\r\n     * const result = obj.template({ key: '<b>keyValue</b>', icon: '<img src=\"xxx\">', speedBarName: 'speed' })\r\n     * output: <div>this is &lt;b&gt;keyValue&lt;/b&gt; <img src=\"xxx\"> speedComponetContent </div>\r\n     * \r\n     * the value have three types: \r\n     * - string, default value no pipe charater\r\n     * - slot type from pipe character, includes html or component(the value must be component name)\r\n     * - util function from pipe character, use function to process data value\r\n     * \r\n     * 2. pass string, not support html|component slot\r\n     * obj.template = obj.createTemplate('<div>this is ${'key'}</div>')\r\n     * const result = obj.template({ key: 'keyValue' })\r\n     * output: <div>this is keyValue</div>\r\n     * \r\n     * 3. pass function, support html|component slot\r\n     * obj.template = obj.createTemplate(\r\n     *  (data, create, obj) => create`<div>this is ${data.key}, ${'key'}, ${obj.data.key}</div>`\r\n     * )\r\n     * const result = obj.template({ key: 'keyValue' })\r\n     * output: <div>this is keyValue, keyValue, keyValue</div>\r\n     * @param {Array|String|Function} tplObj\r\n     * @param  {...any} keys\r\n     * @returns Function\r\n     */\n  }, {\n    key: \"create\",\n    value: function create(tplObj) {\n      for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {\n        keys[_key - 1] = arguments[_key];\n      }\n      var tplType;\n      if (Array.isArray(tplObj)) {\n        tplType = 'array';\n      } else if (typeof tplObj === 'function') {\n        tplType = 'function';\n      } else {\n        tplType = 'string';\n      }\n      var self = this;\n      if (typeof_default()(self) !== 'object' && typeof self !== 'function') {\n        Template_logger.error('create', 'this is not an object.', self);\n        return;\n      }\n      if (tplObj === undefined || tplObj === '') {\n        Template_logger.error('create', 'have not give tplObj parameter.', tplObj);\n        return;\n      }\n      if (self.data === undefined || self.data === null) {\n        Template_logger.info('create', 'this object.data is undefined or null', self);\n        self.data = {};\n      }\n      switch (tplType) {\n        case 'array':\n          return function () {\n            for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {\n              values[_key2] = arguments[_key2];\n            }\n            var dict = values[values.length - 1] || {};\n            if (typeof_default()(self) === 'object') {\n              self.__template__ = {\n                tplObj: tplObj,\n                keys: keys,\n                dict: dict\n              };\n            }\n            var generate = Template.generate.bind(self);\n            return generate(tplObj, keys, values);\n          };\n        case 'function':\n          {\n            var create = Template.create.bind(self);\n            return tplObj.call(self, self.data, create, self);\n          }\n        default:\n          return function (data) {\n            data = data !== undefined ? data : self.data;\n            return Template.mergeVar(tplObj, data);\n          };\n      }\n    }\n  }, {\n    key: \"isSoltType\",\n    value: function isSoltType(type) {\n      type = String(type).toLowerCase();\n      return Template.slotTypeMap[type];\n    }\n  }]);\n}();\nTemplate_Template.pipSeparator = '|';\nTemplate_Template.slotTypeName = 'gp-slot-type';\nTemplate_Template.slotKeyName = 'gp-slot-key';\nTemplate_Template.slotComName = 'gp-slot-com';\nTemplate_Template.slotReplaceName = 'gp-slot-replace';\nTemplate_Template.slotTypeMap = {\n  html: 'html',\n  component: 'component'\n};\nvar TemplateUtil = {\n  trim: function trim(str) {\n    return str.trim();\n  },\n  upperCase: function upperCase(str) {\n    return str.toUpperCase();\n  },\n  lowerCase: function lowerCase(str) {\n    return str.toLowerCase();\n  }\n};\n/* harmony default export */ var toolkit_Template = (Template_Template);\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/asyncToGenerator.js\nvar asyncToGenerator = __webpack_require__(27);\nvar asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/regenerator/index.js\nvar regenerator = __webpack_require__(17);\nvar regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);\n\n// CONCATENATED MODULE: ../src/toolkit/Observer.js\n\n\n\n\n\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Observer.js\r\n * @desc\r\n * Watching and listening data changing, trigger render event immediately\r\n * @author Jarry\r\n */\n\nvar Observer_logger = Logger[\"a\" /* default */].get('Observer.js');\nvar Observer_Observer = /*#__PURE__*/function () {\n  function Observer(object) {\n    classCallCheck_default()(this, Observer);\n    defineProperty_default()(this, \"object\", null);\n    this.setObject(object);\n  }\n  return createClass_default()(Observer, [{\n    key: \"setObject\",\n    value: function setObject(object) {\n      this.object = object;\n    }\n  }, {\n    key: \"watch\",\n    value: function () {\n      var _watch = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(obj, prop, value) {\n        var object, result;\n        return regenerator_default.a.wrap(function _callee$(_context) {\n          while (1) switch (_context.prev = _context.next) {\n            case 0:\n              object = this.object;\n              if (!(typeof object.watch !== 'function')) {\n                _context.next = 3;\n                break;\n              }\n              return _context.abrupt(\"return\");\n            case 3:\n              _context.next = 5;\n              return object.watch(obj, prop, value);\n            case 5:\n              result = _context.sent;\n              if (result !== false && typeof object.render === 'function') {\n                object.render(obj, prop, value);\n              }\n              if (typeof object.afterWatch === 'function') {\n                object.afterWatch(obj, prop, value);\n              }\n            case 8:\n            case \"end\":\n              return _context.stop();\n          }\n        }, _callee, this);\n      }));\n      function watch(_x, _x2, _x3) {\n        return _watch.apply(this, arguments);\n      }\n      return watch;\n    }()\n    /**\r\n     * create a watcher by proxy for object\r\n     * @param {Object} [target] listen data object\r\n     * @param {Object} [{ set, get }] \r\n     */\n  }, {\n    key: \"create\",\n    value: function create(target) {\n      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n      var self = this;\n      var _set = options.set;\n      var _get = options.get;\n      target = target || self.data;\n      var object = self.object;\n      var handle = {\n        set: function set(obj, prop, value) {\n          if (typeof _set === 'function') {\n            return _set.call(self, obj, prop, value);\n          }\n          if (obj[prop] !== value) {\n            obj[prop] = value;\n            if (object.__template__ && Object.prototype.hasOwnProperty.call(object.__template__.dict, prop)) {\n              self.watch(obj, prop, value);\n            }\n          }\n          // return Reflect.set(obj, prop, value)\n          return true;\n        },\n        get: function get(obj, prop) {\n          if (typeof _get === 'function') {\n            return _get.call(self, obj, prop);\n          }\n          if (typeof_default()(obj[prop]) === 'object' && obj[prop] !== null) {\n            return new Proxy(obj[prop], handle);\n          } else {\n            return Reflect.get(obj, prop);\n          }\n          // return obj[prop]\n        }\n      };\n      return new Proxy(target, handle);\n    }\n  }]);\n}();\n\n/**\r\n * @usage\r\n * observer(this).create(data)\r\n */\nvar Observer_observer = function observer(object) {\n  if (typeof_default()(object) !== 'object') {\n    Observer_logger.error('observer', 'this is not an object.');\n  }\n  return new Observer_Observer(object);\n};\n/* harmony default export */ var toolkit_Observer = (Observer_observer);\n// CONCATENATED MODULE: ../src/base/BaseComponent.js\n\n\n\n\n\n\nfunction BaseComponent_createForOfIteratorHelper(r, e) { var t = \"undefined\" != typeof Symbol && r[Symbol.iterator] || r[\"@@iterator\"]; if (!t) { if (Array.isArray(r) || (t = BaseComponent_unsupportedIterableToArray(r)) || e && r && \"number\" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError(\"Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.\"); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }\nfunction BaseComponent_unsupportedIterableToArray(r, a) { if (r) { if (\"string\" == typeof r) return BaseComponent_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return \"Object\" === t && r.constructor && (t = r.constructor.name), \"Map\" === t || \"Set\" === t ? Array.from(r) : \"Arguments\" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? BaseComponent_arrayLikeToArray(r, a) : void 0; } }\nfunction BaseComponent_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }\nfunction BaseComponent_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, BaseComponent_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction BaseComponent_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BaseComponent_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: the base component for control bar or video pannel\r\n * @author: Jarry\r\n * @file: BaseComponent.js\r\n */\n\n\n\n\n\nfunction getAllChildren(node) {\n  if (!node) {\n    return;\n  }\n  var result = [],\n    stack = [];\n  stack.push(node);\n  while (stack.length) {\n    var _node = stack.shift();\n    var slotType = _node.getAttribute(toolkit_Template.slotTypeName);\n    // if the template is slot will be ignored\n    if (toolkit_Template.isSoltType(slotType)) {\n      continue;\n    }\n    result.push(_node);\n    var children = _node.children;\n    for (var i = 0, l = children.length; i < l; i++) {\n      stack.push(children[i]);\n    }\n  }\n  return result;\n}\nvar BaseComponent_isHTMLSlot = function isHTMLSlot(node) {\n  return node.getAttribute && node.getAttribute(toolkit_Template.slotTypeName) === toolkit_Template.slotTypeMap.html;\n};\nvar BaseComponent_isComponentSlot = function isComponentSlot(node) {\n  return node.getAttribute && node.getAttribute(toolkit_Template.slotTypeName) === toolkit_Template.slotTypeMap.component;\n};\nvar needReplaceHTMLSlot = function needReplaceHTMLSlot(oldNode, newNode) {\n  if (BaseComponent_isHTMLSlot(oldNode) && BaseComponent_isHTMLSlot(newNode)) {\n    return true;\n  }\n  return false;\n};\nvar BaseComponent_needReplaceComponentSlot = function needReplaceComponentSlot(oldNode, newNode) {\n  if (BaseComponent_isComponentSlot(oldNode)) {\n    if (oldNode.getAttribute(toolkit_Template.slotComName) !== newNode.getAttribute(toolkit_Template.slotComName)) {\n      return true;\n    }\n  }\n  return false;\n};\nvar BaseComponent_updateNode = function updateNode(oldChild, newChild, oldParentNode) {\n  if (!oldChild && !newChild) {\n    return;\n  }\n  if (!oldChild && newChild) {\n    oldParentNode.appendChild(newChild);\n  } else if (!newChild && oldChild) {\n    oldParentNode.removeChild(oldChild);\n  } else if (oldChild.tagName !== newChild.tagName || needReplaceHTMLSlot(oldChild, newChild) || BaseComponent_needReplaceComponentSlot(oldChild, newChild)) {\n    // replace should be cloneNode for keeping the childNodes.length\n    oldChild.replaceWith(newChild.cloneNode(true));\n  } else if (oldChild.nodeType === Node.TEXT_NODE && oldChild.nodeValue !== newChild.nodeValue) {\n    oldChild.nodeValue = newChild.nodeValue;\n  } else if (oldChild.setAttribute) {\n    Element_Element.setAttributes(oldChild, newChild);\n  }\n};\nvar BaseComponent_BaseComponent = /*#__PURE__*/function (_BaseClass) {\n  function BaseComponent() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, BaseComponent);\n    _this = BaseComponent_callSuper(this, BaseComponent, [options]);\n    defineProperty_default()(_this, \"createTemplate\", null);\n    defineProperty_default()(_this, \"template\", \"\");\n    defineProperty_default()(_this, \"element\", null);\n    defineProperty_default()(_this, \"eventsList\", {});\n    defineProperty_default()(_this, \"data\", {});\n    defineProperty_default()(_this, \"id\", '');\n    _this.id = options.id || _this.constructor.name;\n    _this.options = options;\n    _this.createTemplate = toolkit_Template.create.bind(_this);\n    return _this;\n  }\n  inherits_default()(BaseComponent, _BaseClass);\n  return createClass_default()(BaseComponent, [{\n    key: \"getTemplate\",\n    value: function getTemplate() {\n      return this.template;\n    }\n  }, {\n    key: \"setTemplate\",\n    value: function setTemplate(tpl) {\n      this.template = tpl;\n    }\n  }, {\n    key: \"init\",\n    value: function init() {\n      this.data = toolkit_Observer(this).create(this.data);\n      this.render();\n      if (typeof this.afterInit === 'function') {\n        this.afterInit();\n      }\n    }\n  }, {\n    key: \"afterInit\",\n    value: function afterInit() {}\n  }, {\n    key: \"initProps\",\n    value: function initProps() {}\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {}\n  }, {\n    key: \"watch\",\n    value: function watch() {}\n  }, {\n    key: \"render\",\n    value: function render() {\n      var html = '';\n      if (typeof this.template === 'function') {\n        html = this.template(this.data);\n      } else {\n        html = this.template;\n      }\n      var div = Element_Element.createEl('div');\n      if (typeof html !== 'string') {\n        this.logger.error('render:', 'this template is not html string', 'html:', html);\n        return;\n      }\n      div.innerHTML = html;\n      var node = div.firstElementChild;\n      // replace the blank slot components of template\n      var slotList = node.querySelectorAll('[' + toolkit_Template.slotReplaceName + ']');\n      var _iterator = BaseComponent_createForOfIteratorHelper(slotList),\n        _step;\n      try {\n        for (_iterator.s(); !(_step = _iterator.n()).done;) {\n          var slot = _step.value;\n          if (slot.getAttribute(toolkit_Template.slotReplaceName) === 'true') {\n            var componentName = slot.getAttribute(toolkit_Template.slotComName);\n            var component = this.getComponent(componentName);\n            if (!component) {\n              continue;\n            }\n            var ele = component.element;\n            if (Element_Element.isElement(this.element)) {\n              // replacing slot again should clone\n              slot.replaceWith(ele.cloneNode(true));\n            } else {\n              slot.replaceWith(ele);\n            }\n            component.element.removeAttribute(toolkit_Template.slotReplaceName);\n          }\n        }\n        // assign or replace the template element\n      } catch (err) {\n        _iterator.e(err);\n      } finally {\n        _iterator.f();\n      }\n      if (Element_Element.isElement(this.element)) {\n        this.replaceNode(this.element, node);\n      } else {\n        this.element = node;\n      }\n    }\n\n    /**\r\n     * replace some node after comparison\r\n     * @param {Element} oldNode orgin DOM\r\n     * @param {Element} newNode replace DOM\r\n     */\n  }, {\n    key: \"replaceNode\",\n    value: function replaceNode(oldNode, newNode) {\n      if (!oldNode || !newNode) {\n        return;\n      }\n      var oldNodeArr = getAllChildren(oldNode);\n      var newNodeArr = getAllChildren(newNode);\n      var oldNodeLen = oldNodeArr.length;\n      var newNodeLen = newNodeArr.length;\n      var nodeArrLen = Math.max(oldNodeLen, newNodeLen);\n      if (nodeArrLen <= 0 || oldNode.tagName !== newNode.tagName) {\n        oldNode.replaceWith(newNode);\n        this.element = newNode;\n        return;\n      }\n      // console.error('oldNodeArr:newNodeArr', oldNodeLen, newNodeLen, oldNodeArr, newNodeArr)\n      while (nodeArrLen--) {\n        var currentNode = oldNodeArr[nodeArrLen];\n        var replaceNode = newNodeArr[nodeArrLen];\n        // console.error('currentNode:replaceNode', nodeArrLen, currentNode, replaceNode, oldNodeArr, newNodeArr)\n        if (!currentNode) {\n          oldNode.appendChild(replaceNode);\n          continue;\n        }\n        if (!replaceNode) {\n          currentNode.parentNode.removeChild(currentNode);\n          continue;\n        }\n        if (currentNode.tagName === replaceNode.tagName) {\n          Element_Element.syncAttributes(currentNode, replaceNode);\n        }\n        if (!currentNode.isEqualNode(replaceNode)) {\n          // console.error('currentNode and replaceNode innerHTML:', currentNode, replaceNode, currentNode.innerHTML, replaceNode.innerHTML)\n          var childNodesLength = Math.max(currentNode.childNodes.length, replaceNode.childNodes.length);\n          if (childNodesLength <= 0) {\n            BaseComponent_updateNode(currentNode, replaceNode, currentNode.parentNode);\n          } else {\n            for (var i = 0, l = childNodesLength; i < l; i++) {\n              var oldChild = currentNode.childNodes[i];\n              var newChild = replaceNode.childNodes[i];\n              if (!oldChild && !newChild) {\n                continue;\n              }\n              BaseComponent_updateNode(oldChild, newChild, currentNode);\n            }\n          }\n        }\n      }\n    }\n  }, {\n    key: \"show\",\n    value: function show() {\n      this.data.display = 'show';\n      if (this.element) {\n        this.element.style.display = 'inline-block';\n      }\n    }\n  }, {\n    key: \"hide\",\n    value: function hide() {\n      this.data.display = 'hide';\n      if (this.element) {\n        this.element.style.display = 'none';\n      }\n    }\n  }, {\n    key: \"resetPosition\",\n    value: function resetPosition() {\n      var $box = this.element.parentNode;\n      var containerWidth = $box.offsetWidth;\n      var containerHeight = $box.offsetHeight;\n      this.element.style.marginTop = (containerHeight - this.element.offsetHeight) / 2 + 'px';\n      this.element.style.marginLeft = (containerWidth - this.element.offsetWidth) / 2 + 'px';\n    }\n  }, {\n    key: \"replace\",\n    value: function replace(node) {\n      this.element.replaceWith(node);\n      this.element = node;\n    }\n  }, {\n    key: \"update\",\n    value: function update(content) {\n      this.element.innerHTML = content;\n    }\n  }, {\n    key: \"addEventListener\",\n    value: function addEventListener(ele, type, callback) {\n      var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;\n      ele.addEventListener(type, callback, useCapture);\n      return {\n        destroy: function destroy() {\n          ele.removeEventListener(type, callback);\n        }\n      };\n    }\n  }, {\n    key: \"removeEventListenerAll\",\n    value: function removeEventListenerAll() {\n      var _this2 = this;\n      Object.keys(this.eventsList).forEach(function (item) {\n        _this2.eventsList[item].destroy();\n      });\n    }\n  }, {\n    key: \"getComponent\",\n    value: function getComponent(name) {\n      if (name === undefined) {\n        return;\n      }\n      if (this.options.componentsController) {\n        return this.options.componentsController.getComponent(name);\n      }\n    }\n  }, {\n    key: \"getHTMLString\",\n    value: function getHTMLString() {\n      return this.element.outerHTML;\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      if (this.element.parentNode) {\n        this.element.parentNode.removeChild(this.element);\n      }\n      this.events.emit('Component_' + this.id + '.destroy', this);\n      this.removeEventListenerAll();\n    }\n  }]);\n}(base_BaseClass);\n/* harmony default export */ var base_BaseComponent = (BaseComponent_BaseComponent);\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js\nvar taggedTemplateLiteral = __webpack_require__(7);\nvar taggedTemplateLiteral_default = /*#__PURE__*/__webpack_require__.n(taggedTemplateLiteral);\n\n// CONCATENATED MODULE: ../src/utils/Format.js\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Format.js\r\n * @desc\r\n * common format utils\r\n * @author Jarry\r\n */\nvar timeFormat = {\n  formatHHMMSS: function formatHHMMSS(second) {\n    var secondNum = parseInt(second, 10);\n    var hours = Math.floor(secondNum / 3600);\n    var minutes = Math.floor((secondNum - hours * 3600) / 60);\n    var seconds = secondNum - hours * 3600 - minutes * 60;\n    if (hours < 10) {\n      hours = '0' + hours;\n    }\n    if (minutes < 10) {\n      minutes = '0' + minutes;\n    }\n    if (seconds < 10) {\n      seconds = '0' + seconds;\n    }\n    var hoursStr = '';\n    if (hours !== '00') {\n      hoursStr = hours + ':';\n    }\n    return hoursStr + minutes + ':' + seconds;\n  }\n};\nvar sizeFormat = {\n  formatBytes: function formatBytes(bytes, decimals) {\n    if (bytes == 0) return '0 Bytes';\n    var k = 1024;\n    var dm = decimals <= 0 ? 0 : decimals || 2;\n    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];\n    var i = Math.floor(Math.log(bytes) / Math.log(k));\n    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];\n  }\n};\n/* harmony default export */ var Format = ({\n  timeFormat: timeFormat,\n  sizeFormat: sizeFormat\n});\n// CONCATENATED MODULE: ../src/components/screen/Poster.js\n\n\n\n\n\n\n\nvar _templateObject;\nfunction Poster_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, Poster_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction Poster_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Poster_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: loading poster image\r\n * @author: Jarry\r\n * @file: Poster.js\r\n */\n\n\n\n\nvar GOLDPLAY_LEGO_BASE64 = \"data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAA+CAYAAABuk1SaAAAZ2ElEQVR4nO2de1wV1fbA157ZcyTe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\\nrkJggg==\";\nvar Poster_Poster = /*#__PURE__*/function (_BaseComponent) {\n  function Poster() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, Poster);\n    _this = Poster_callSuper(this, Poster, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(_templateObject || (_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-poster class=\\\"goldplay__screen--poster\\\">\\n  <img src=\\\"\", \"\\\" width=\\\"\", \"\\\" data-display=\\\"\", \"\\\" heigth=\\\"\", \"\\\" class=\\\"goldplay__screen--poster-image\\\">\\n  <gp-speed class=\\\"goldplay__screen--poster-speed\\\">\", \"</gp-speed>\\n  </gp-poster>\\n  \"])), 'poster', 'width', 'display', 'height', 'speed'));\n    defineProperty_default()(_this, \"data\", {\n      poster: '',\n      status: '',\n      display: 'show',\n      speed: '',\n      width: '',\n      height: ''\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    if (!options.player.poster) {\n      _this.data.poster = GOLDPLAY_LEGO_BASE64;\n    } else {\n      _this.data.poster = options.player.poster;\n    }\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(Poster, _BaseComponent);\n  return createClass_default()(Poster, [{\n    key: \"resetPosition\",\n    value: function resetPosition() {\n      if (!this.element) {\n        return;\n      }\n      var width = this.element.parentNode.offsetWidth;\n      var height = this.element.parentNode.offsetHeight;\n      // this.element.style.width = width + 'px'\n      // this.element.style.width = '100%'\n      // this.element.style.position = 'relative'\n      // this.element.style.marginTop = (height - this.element.offsetHeight - 20) / 2 + 'px'\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.LoaderUpdateSpeed, function (data) {\n        if (_this2.data.display === 'show') {\n          _this2.data.speed = sizeFormat.formatBytes(data.speed) + ' /s';\n        }\n      });\n    }\n  }, {\n    key: \"hide\",\n    value: function hide() {\n      if (this.data.display !== 'hide') {\n        // let value = 1\n        // let timer = setInterval(() => {\n        //   if (value <= 0) {\n        //     this.element.style.display = 'none'\n        //     clearInterval(timer)\n        //     return\n        //   }\n        //   value = (value - 0.1).toFixed(2)\n        //   this.element.style.opacity = value\n        // }, 50)\n        this.element.style.opacity = 0;\n        this.element.style.display = 'none';\n        this.data.display = 'hide';\n      }\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var screen_Poster = (Poster_Poster);\n// CONCATENATED MODULE: ../src/control-bar/Container.js\n\n\n\n\n\n\n\nvar Container_templateObject;\nfunction Container_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, Container_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction Container_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Container_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file Container.js\r\n * @desc\r\n * progress bar container\r\n * @see\r\n * @author Jarry\r\n */\n\n\nvar Container_Container = /*#__PURE__*/function (_BaseComponent) {\n  function Container() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, Container);\n    _this = Container_callSuper(this, Container, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(Container_templateObject || (Container_templateObject = taggedTemplateLiteral_default()([\"\\n    <gp-control class=\\\"goldplay__control--container \", \"\\\" style=\\\"height:\", \"px;opacity:\", \"\\\" data-status=\\\"\", \"\\\">\\n      \", \"\\n      \", \"\\n      \", \"\\n    </gp-control>\\n  \"])), 'containerFloatCss', 'height', 'opacity', 'status', 'progressBarName|component', 'sideControlBarName|component', 'nearControlBarName|component'));\n    defineProperty_default()(_this, \"hideDelayTime\", void 0);\n    defineProperty_default()(_this, \"hideTimeCount\", void 0);\n    defineProperty_default()(_this, \"data\", {\n      progressBarName: 'progressBar',\n      sideControlBarName: 'sideControlBar',\n      nearControlBarName: 'nearControlBar',\n      width: '',\n      height: '',\n      opacity: 1,\n      containerFloatCss: '',\n      display: 'show',\n      status: ''\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    _this.data.height = options.player.controlBarHeight;\n    _this.hideDelayTime = _this.options.player.controlBarAutoHideTime || 3;\n    if (options.player.controlBarAutoHide) {\n      _this.data.containerFloatCss = _this.options.cssName.controlContainerFloat;\n      _this.resetPosition();\n    }\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(Container, _BaseComponent);\n  return createClass_default()(Container, [{\n    key: \"initProps\",\n    value: function initProps() {\n      this.hideTimeCount = this.hideDelayTime;\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var options = this.options;\n      if (options.player.controlBarAutoHide) {\n        options.$container.addEventListener('mousemove', function () {\n          if (_this2.hideTimeCount <= 0) {\n            _this2.data.display = 'show';\n            _this2.show();\n          }\n          _this2.hideTimeCount = _this2.hideDelayTime;\n        });\n        setInterval(function () {\n          if (_this2.hideTimeCount > 0) {\n            _this2.hideTimeCount -= 1;\n          } else {\n            if (_this2.data.display !== 'hide') {\n              _this2.data.display = 'hide';\n              _this2.hide();\n            }\n          }\n        }, 100);\n      }\n    }\n  }, {\n    key: \"setSize\",\n    value: function setSize(width, height) {\n      if (width !== undefined) {\n        this.data.width = width;\n      }\n      if (height !== undefined) {\n        this.data.height = height;\n      }\n    }\n  }, {\n    key: \"show\",\n    value: function show() {\n      var _this3 = this;\n      var timer;\n      if (this.options.player.controlBarAutoHide) {\n        clearTimeout(timer);\n        timer = setTimeout(function () {\n          _this3.data.opacity = 1;\n        }, 1);\n      } else {\n        this.data.opacity = 1;\n      }\n    }\n  }, {\n    key: \"hide\",\n    value: function hide() {\n      this.data.opacity = 0;\n    }\n  }, {\n    key: \"resetPosition\",\n    value: function resetPosition() {\n      this.setSize(this.options.$container.offsetWidth, this.options.controlBarHeight);\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var control_bar_Container = (Container_Container);\n// CONCATENATED MODULE: ../src/toolkit/Delegator.js\n\n\n\n\n/**\r\n * @Copyright(C) 2019.\r\n * All Rights Reserved.\r\n * @file Delegator.js\r\n * @desc delegator for event of DOM，includes on,off,once etc.\r\n * @see\r\n * https://github.com/dgraham/delegated-events\r\n * https://craig.is/riding/gators\r\n * @author Jarry\r\n */\n\nvar Delegator_logger = Logger[\"a\" /* default */].get('Delegator.js');\nfunction Delegator_isElement(node) {\n  if (typeof HTMLElement !== 'undefined') {\n    return node instanceof HTMLElement;\n  } else if (typeof_default()(node) === 'object') {\n    return node.nodeType === 1 && typeof node.nodeName === 'string';\n  }\n  return false;\n}\nfunction addEvent(ele, event, handler, capture) {\n  if (capture === undefined) {\n    capture = event === 'blur' || event === 'focus';\n  }\n  if (Delegator_isElement(ele)) {\n    ele.addEventListener(event, handler, capture);\n  }\n}\nfunction cancelEvent(e) {\n  e.preventDefault();\n  e.stopPropagation();\n}\nfunction getMatcheSelector(ele, target, selector) {\n  if (target === ele) {\n    return null;\n  }\n  if (target.matches && target.matches(selector)) {\n    return target;\n  }\n  if (target.parentNode) {\n    return getMatcheSelector(ele, target.parentNode, selector);\n  }\n}\nfunction matchesSelector(ele, target, selector) {\n  while (target && target !== ele) {\n    if (target.matches(selector)) {\n      return true;\n    }\n    target = target.parentElement;\n  }\n  return false;\n}\n/**\r\n * @desc delegate main method\r\n * @param {Element} ele \r\n * @param {string} event \r\n * @param {string|Array} selector \r\n * @param {function} fn \r\n * @param {boolean} [capture]\r\n * @returns {boolean} is matched selector\r\n */\nfunction delegate(ele, event, selector, fn, capture) {\n  var matches = function matches(target, selector) {\n    if (target && target.matches) {\n      if (!Array.isArray(selector)) {\n        return target.matches(selector);\n      }\n      for (var i = 0, l = selector.length; i < l; i++) {\n        if (target.matches(selector[i])) {\n          return true;\n        }\n      }\n    }\n    return false;\n  };\n  function fnWrapper(e) {\n    e = e || window.event;\n    var target = e.target || e.srcElement;\n    // currentTarget is ele\n    var current = e.currentTarget;\n    var bubble = true;\n    var result;\n    while (bubble && target !== current && target) {\n      if (matches(target, selector)) {\n        // prevent event while return false\n        result = fn.call(target, e);\n        bubble = result === false ? false : true;\n      }\n      if (!bubble) {\n        cancelEvent(e);\n        return;\n      }\n      target = target.parentNode;\n    }\n  }\n  fn.__delegateWrapper = fnWrapper;\n  addEvent(ele, event, fnWrapper, capture);\n}\n/**\r\n * delegator class\r\n * @usage\r\n * let delegator = new Delegator(element)\r\n * delegator.on('click', '#id', () => {})\r\n */\nvar Delegator_Delegator = /*#__PURE__*/function () {\n  function Delegator(ele) {\n    classCallCheck_default()(this, Delegator);\n    defineProperty_default()(this, \"element\", null);\n    if (Delegator_isElement(ele)) {\n      this.element = ele;\n    } else {\n      Delegator_logger.error('constructor', 'new instance', 'element:', this.element);\n    }\n    return this;\n  }\n  return createClass_default()(Delegator, [{\n    key: \"off\",\n    value: function off(event, fn, capture) {\n      // mount delegateWrapper property for remove the anonymous function \n      if (fn.__delegateWrapper) {\n        fn = fn.__delegateWrapper;\n        delete fn.__delegateWrapper;\n      }\n      this.element.removeEventListener(event, fn, capture);\n      return this;\n    }\n  }, {\n    key: \"on\",\n    value: function on(event, selector, fn, capture) {\n      var _this = this;\n      if (Array.isArray(selector)) {\n        selector.forEach(function (item) {\n          delegate(_this.element, event, item, fn, capture);\n        });\n      } else {\n        delegate(this.element, event, selector, fn, capture);\n      }\n      return this;\n    }\n  }, {\n    key: \"once\",\n    value: function once(event, selector, fn, capture) {\n      this.on(event, selector, fn, {\n        capture: capture,\n        once: true\n      });\n      return this;\n    }\n  }]);\n}();\n/**\r\n * output static object from delegator\r\n * @usage\r\n * delegator('#id').on('click', '#id', () => {})\r\n * delegator(element).on('mouseout', '.className', () => {})\r\n */\nvar Delegator_instance = null;\nvar delegator = function delegator(ele) {\n  if (typeof ele === 'string') {\n    ele = document.querySelector(ele);\n  }\n  if (!Delegator_instance) {\n    Delegator_instance = new Delegator_Delegator(ele);\n  } else {\n    Delegator_instance.element = ele;\n  }\n  return Delegator_instance;\n};\n/* harmony default export */ var toolkit_Delegator = (delegator);\n// CONCATENATED MODULE: ../src/toolkit/Dragger.js\n\n\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Dragger.js\r\n * @desc\r\n * drag tool，set element, container and coordinate scope\r\n * @author Jarry\r\n */\n\nvar Dragger_Dragger = /*#__PURE__*/function () {\n  function Dragger($ele, _ref) {\n    var $container = _ref.$container,\n      type = _ref.type,\n      scope = _ref.scope,\n      onStart = _ref.onStart,\n      onDrag = _ref.onDrag,\n      onRelease = _ref.onRelease;\n    classCallCheck_default()(this, Dragger);\n    defineProperty_default()(this, \"$container\", null);\n    defineProperty_default()(this, \"$ele\", null);\n    defineProperty_default()(this, \"active\", false);\n    defineProperty_default()(this, \"offsetX\", 0);\n    defineProperty_default()(this, \"offsetY\", 0);\n    defineProperty_default()(this, \"offsetLeft\", 0);\n    defineProperty_default()(this, \"offsetTop\", 0);\n    defineProperty_default()(this, \"orginOffsetLeft\", 0);\n    defineProperty_default()(this, \"orginOffsetTop\", 0);\n    defineProperty_default()(this, \"orginOffsetWidth\", 0);\n    defineProperty_default()(this, \"orginOffsetHeight\", 0);\n    defineProperty_default()(this, \"initialX\", 0);\n    defineProperty_default()(this, \"initialY\", 0);\n    defineProperty_default()(this, \"type\", 'default');\n    defineProperty_default()(this, \"scope\", {\n      // left,\n      // right,\n      // top,\n      // bottom\n    });\n    this.$container = $container || document.body;\n    this.$ele = $ele;\n    this.type = type; // vertical | level | default\n    this.scope = scope;\n    this.eventsList = {};\n    this.onStart = onStart;\n    this.onDrag = onDrag;\n    this.onRelease = onRelease;\n    this.bindEvent();\n  }\n  return createClass_default()(Dragger, [{\n    key: \"addEventListener\",\n    value: function addEventListener(ele, type, callback) {\n      var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;\n      ele.addEventListener(type, callback, useCapture);\n      return {\n        destroy: function destroy() {\n          ele.removeEventListener(type, callback);\n        }\n      };\n    }\n  }, {\n    key: \"removeEventListenerAll\",\n    value: function removeEventListenerAll() {\n      var _this = this;\n      Object.keys(this.eventsList).forEach(function (item) {\n        _this.eventsList[item].destroy();\n      });\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.eventsList.mousedown = this.addEventListener(this.$container, 'mousedown', function (evt) {\n        _this2.start(evt);\n      }, false);\n      this.eventsList.mouseup = this.addEventListener(this.$container, 'mouseup', function (evt) {\n        _this2.release(evt);\n      }, false);\n      this.eventsList.mousemove = this.addEventListener(this.$container, 'mousemove', function (evt) {\n        _this2.drag(evt);\n      }, false);\n    }\n  }, {\n    key: \"start\",\n    value: function start(evt) {\n      if (evt.target !== this.$ele) {\n        return;\n      }\n      if (this.scope === undefined && this.$container !== undefined) {\n        this.scope = {\n          left: this.$container.offsetLeft,\n          right: this.$container.offsetLeft + this.$container.offsetWidth,\n          top: this.$container.offsetTop,\n          bottom: this.$container.offsetTop + this.$container.offsetHeight\n        };\n      }\n      this.offsetLeft = this.$ele.offsetLeft;\n      this.offsetTop = this.$ele.offsetTop;\n      this.active = true;\n      this.initialX = evt.clientX;\n      this.initialY = evt.clientY;\n      this.orginOffsetLeft = this.$ele.offsetLeft;\n      this.orginOffsetTop = this.$ele.offsetTop;\n      this.orginOffsetWidth = this.$ele.offsetWidth;\n      this.orginOffsetHeight = this.$ele.offsetHeight;\n      if (typeof this.onStart === 'function') {\n        this.onStart.call(this, this.offsetX, this.offsetY, evt, this);\n      }\n    }\n  }, {\n    key: \"release\",\n    value: function release(evt) {\n      this.active = false;\n      if (typeof this.onRelease === 'function') {\n        this.onRelease.call(this, this.offsetX, this.offsetY, evt, this);\n      }\n    }\n  }, {\n    key: \"drag\",\n    value: function drag(evt) {\n      // console.error('before drag position:', this.offsetLeft, this.offsetTop, this.scope, evt.clientX, evt.clientY, this.initialX, this.initialY)\n      if (this.active) {\n        evt.preventDefault();\n        evt.stopPropagation();\n        this.offsetX = evt.clientX - this.initialX + this.offsetLeft;\n        this.offsetY = evt.clientY - this.initialY + this.offsetTop;\n        this.setPosition(evt);\n      }\n    }\n  }, {\n    key: \"setPosition\",\n    value: function setPosition(evt) {\n      switch (this.type) {\n        case 'vertical':\n          this.offsetX = this.orginOffsetLeft;\n          if (this.offsetY < this.scope.top) {\n            this.offsetY = this.scope.top;\n          }\n          if (this.offsetY > this.scope.bottom - this.orginOffsetHeight) {\n            this.offsetY = this.scope.bottom - this.orginOffsetHeight;\n          }\n          // console.error('vertial:', this.offsetX, this.offsetY)\n          break;\n        case 'level':\n          this.offsetY = this.orginOffsetTop;\n          if (this.offsetX > this.scope.right - this.orginOffsetWidth) {\n            this.offsetX = this.scope.right - this.orginOffsetWidth;\n          }\n          if (this.offsetX < this.scope.left) {\n            this.offsetX = this.scope.left;\n          }\n          break;\n        default:\n          if (!isNaN(this.scope.right)) {\n            if (this.offsetX > this.scope.right - this.orginOffsetWidth) {\n              this.offsetX = this.scope.right - this.orginOffsetWidth;\n            }\n          }\n          if (!isNaN(this.scope.left)) {\n            if (this.offsetX < this.scope.left) {\n              this.offsetX = this.scope.left;\n            }\n          }\n          if (!isNaN(this.scope.top)) {\n            if (this.offsetY < this.scope.top) {\n              this.offsetY = this.scope.top;\n            }\n          }\n          if (!isNaN(this.scope.bottom)) {\n            if (this.offsetY > this.scope.bottom - this.orginOffsetHeight) {\n              this.offsetY = this.scope.bottom - this.orginOffsetHeight;\n            }\n          }\n      }\n      this.$ele.style.left = this.offsetX + 'px';\n      this.$ele.style.top = this.offsetY + 'px';\n      if (typeof this.onDrag === 'function') {\n        this.onDrag.call(this, this.offsetX, this.offsetY, evt, this);\n      }\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      this.$ele.parentNode.removeChild(this.$ele);\n      this.removeEventListenerAll();\n    }\n  }]);\n}();\nvar dragger = function dragger($ele, options) {\n  return new Dragger_Dragger($ele, options);\n};\n/* harmony default export */ var toolkit_Dragger = (dragger);\n// CONCATENATED MODULE: ../src/components/progress/ProgressBar.js\n\n\n\n\n\n\n\nvar ProgressBar_templateObject;\nfunction ProgressBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, ProgressBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction ProgressBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ProgressBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: Progress bar\r\n * @author: Jarry\r\n * @file: ProgressContainer.js\r\n */\n\n\n\n\n\n\nvar ProgressBar_ProgressBar = /*#__PURE__*/function (_BaseComponent) {\n  function ProgressBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, ProgressBar);\n    _this = ProgressBar_callSuper(this, ProgressBar, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(ProgressBar_templateObject || (ProgressBar_templateObject = taggedTemplateLiteral_default()([\"\\n    <gp-control-progressbar class=\\\"goldplay__progress-bar \", \"\\\" data-status=\\\"\", \"\\\">\\n      <div class=\\\"goldplay__progressbar--load \", \"\\\">\\n      </div>\\n      <div class=\\\"goldplay__progressbar--play \", \"\\\">\\n      </div>\\n      <span class=\\\"goldplay__progressbar--dot \", \"\\\" title=\\\"\", \"\\\"></span>\\n    </gp-control-progressbar>\\n  \"])), 'progressBarHoverCss', 'status', 'progressBarLoadHoverCss', 'progressBarPlayHoverCss', 'progressBarDotHoverCss', 'time'));\n    defineProperty_default()(_this, \"options\", {});\n    defineProperty_default()(_this, \"data\", {\n      playWidth: '',\n      dot: '',\n      time: '',\n      status: ''\n    });\n    defineProperty_default()(_this, \"setProgressBarSize\", function (width) {\n      _this.$progressBarPlay.style.width = width + 'px';\n    });\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(ProgressBar, _BaseComponent);\n  return createClass_default()(ProgressBar, [{\n    key: \"watch\",\n    value: function watch() {\n      var cssName = this.options.cssName;\n      if (this.data.status === 'dragstart') {\n        this.data.progressBarHoverCss = cssName.progressBarHover;\n        this.data.progressBarLoadHoverCss = cssName.progressBarLoadHover;\n        this.data.progressBarPlayHoverCss = cssName.progressBarPlayHover;\n        this.data.progressBarDotHoverCss = cssName.progressBarDotHover;\n      } else if (this.data.status === 'dragend') {\n        this.data.progressBarHoverCss = '';\n        this.data.progressBarLoadHoverCss = '';\n        this.data.progressBarPlayHoverCss = '';\n        this.data.progressBarDotHoverCss = '';\n      }\n    }\n  }, {\n    key: \"afterInit\",\n    value: function afterInit() {}\n  }, {\n    key: \"initProps\",\n    value: function initProps() {\n      var $progressBar = this.element;\n      var cssName = this.options.cssName;\n      this.$progressDragDot = $progressBar.querySelector('.' + cssName.progressBarDot);\n      this.$progressBarPlay = $progressBar.querySelector('.' + cssName.progressBarPlay);\n      this.$progressBarLoad = $progressBar.querySelector('.' + cssName.progressBarLoad);\n      this.timer = this.getComponent('timer');\n      this.pauseButton = this.getComponent('pauseButton');\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var cssName = this.options.cssName;\n      var isDraging = false;\n      this.events.on(EventsConfig.PlayerTimeUpdate, function (time) {\n        var duration = _this2.options.dataManage.sourceData.duration;\n        if (isDraging || !time || !duration) {\n          return;\n        }\n        var width = time / 1000 / duration * _this2.progressBarWidth;\n        _this2.setProgressPosition(width);\n        _this2.timer.data.time = timeFormat.formatHHMMSS(time / 1000);\n      });\n      this.events.on(EventsConfig.PlayerbufferUpdate, function (bufferInfo) {\n        if (isDraging || !bufferInfo) {\n          return;\n        }\n        _this2.updateProgressLoad(bufferInfo);\n      });\n      toolkit_Delegator(this.options.$controlBarContainer).on('click', '.' + cssName.progressBar, function (evt) {\n        if (evt.target === _this2.$progressDragDot) {\n          return;\n        }\n        var duration = _this2.options.dataManage.sourceData.duration || 0;\n        var pixelTime = duration / _this2.progressBarWidth;\n        var targetLeft = 0;\n        if (evt.target.classList.contains(cssName.progressBarLoad)) {\n          targetLeft = evt.target.offsetLeft - evt.target.parentNode.offsetLeft;\n        }\n        var offsetX = targetLeft + evt.offsetX;\n        var seekTime = offsetX * pixelTime * 1000;\n        _this2.setProgressPosition(offsetX);\n        _this2.logger.info('bindEvent', 'click to seek', 'seekTime:', seekTime, 'offsetX:', offsetX);\n        if (evt.target !== _this2.$progressBarLoad) {\n          _this2.clearLoadBar(evt.offsetX);\n        }\n        _this2.timer.data.time = timeFormat.formatHHMMSS(seekTime / 1000);\n        _this2.events.emit(EventsConfig.PlayerOnSeek, seekTime);\n        return false;\n      });\n      this.progressDragEvent = toolkit_Dragger(this.$progressDragDot, {\n        // $container: this.options.$controlBarContainer,\n        $container: document.body,\n        type: 'level',\n        scope: {\n          left: this.progressBarLeft,\n          right: this.progressBarLeft + this.progressBarWidth,\n          top: this.$progressDragDot.offsetTop,\n          bottom: this.$progressDragDot.offsetTop + this.$progressDragDot.offsetHeight\n        },\n        onStart: function onStart() {\n          isDraging = true;\n          _this2.data.status = 'dragstart';\n        },\n        onDrag: function onDrag(offsetX) {\n          var width;\n          if (_this2.options.player.controlBarAutoHide) {\n            width = offsetX;\n          } else {\n            width = offsetX - _this2.options.$controlBarContainer.offsetLeft;\n          }\n          var gap = 0;\n          var gapValue = _this2.$progressDragDot.offsetWidth;\n          if (_this2.progressBarWidth - width <= gapValue) {\n            gap = gapValue;\n          }\n          _this2.setProgressBarSize(width);\n          _this2.data.status = 'draging';\n          var seekTime = _this2.getSeekTime(_this2.progressBarWidth - gap);\n          _this2.timer.data.time = timeFormat.formatHHMMSS(seekTime / 1000);\n          _this2.data.time = _this2.timer.data.time;\n        },\n        onRelease: function onRelease(offsetX, offsetY, evt) {\n          if (!isDraging) {\n            return;\n          }\n          var seekTime = _this2.getSeekTime();\n          if (evt.target !== _this2.$progressBarLoad) {\n            _this2.clearLoadBar(offsetX);\n          }\n          _this2.events.emit(EventsConfig.PlayerOnSeek, seekTime);\n          _this2.logger.info('bindEvent', 'onDrag release seek', 'seekTime:', seekTime);\n          _this2.data.status = 'dragend';\n          isDraging = false;\n        }\n      });\n    }\n  }, {\n    key: \"setProgressPosition\",\n    value: function setProgressPosition(width) {\n      var offsetX = Math.min(width, this.progressBarWidth);\n      var $progressDragDot = this.$progressDragDot;\n      var progressBarWidth = this.progressBarWidth;\n      var gap = 0;\n      var gapValue = $progressDragDot.offsetWidth / 2;\n      if (offsetX > progressBarWidth || progressBarWidth - offsetX <= gapValue) {\n        gap = gapValue - (progressBarWidth - offsetX);\n      } else if (offsetX <= gapValue) {\n        gap = -(gapValue - offsetX);\n      }\n      var left = offsetX - gap - $progressDragDot.offsetWidth / 2;\n      this.setProgressPlayWidth(offsetX);\n      this.setProgressDragDotLeft(left + this.progressBarLeft);\n    }\n  }, {\n    key: \"setProgressPlayWidth\",\n    value: function setProgressPlayWidth(width) {\n      this.$progressBarPlay.style.width = width + 'px';\n    }\n  }, {\n    key: \"setProgressDragDotLeft\",\n    value: function setProgressDragDotLeft(left) {\n      this.$progressDragDot.style.left = left + 'px';\n    }\n  }, {\n    key: \"getProgressPlayLeftWidth\",\n    value: function getProgressPlayLeftWidth() {\n      return {\n        offsetLeft: this.$progressBarPlay.offsetLeft,\n        offsetWidth: this.$progressBarPlay.offsetWidth\n      };\n    }\n  }, {\n    key: \"getProgressLoadLeftWidth\",\n    value: function getProgressLoadLeftWidth() {\n      return {\n        offsetLeft: this.$progressBarLoad.offsetLeft,\n        offsetWidth: this.$progressBarLoad.offsetWidth\n      };\n    }\n  }, {\n    key: \"setProgressLoadLeftWidth\",\n    value: function setProgressLoadLeftWidth(left, width) {\n      var maxWidth = this.progressBarLeft + this.progressBarWidth;\n      left = Math.min(left, maxWidth);\n      var newWidth = left + width;\n      if (newWidth > maxWidth) {\n        width = maxWidth - left;\n      }\n      this.$progressBarLoad.style.left = left + 'px';\n      this.$progressBarLoad.style.width = width + 'px';\n    }\n  }, {\n    key: \"updateProgressLoad\",\n    value: function updateProgressLoad(bufferInfo) {\n      var duration = this.options.dataManage.sourceData.duration;\n      if (!duration) {\n        return;\n      }\n      var progressBarWidth = this.progressBarWidth;\n      var progressBarLeft = this.progressBarLeft;\n      var loadLeft = bufferInfo[0] / 1000 / duration * progressBarWidth;\n      var loadRight = bufferInfo[1] / 1000 / duration * progressBarWidth;\n      var left = Math.floor(progressBarLeft + loadLeft);\n      var width = Math.floor(loadRight - loadLeft);\n      this.setProgressLoadLeftWidth(left, width);\n    }\n  }, {\n    key: \"getSeekTime\",\n    value: function getSeekTime(width, duration) {\n      var progressBarWidth = this.progressBarWidth;\n      duration = duration || this.options.dataManage.sourceData.duration || 0;\n      var pixelTime = duration / (width || progressBarWidth);\n      var seekTime = this.$progressBarPlay.offsetWidth * pixelTime * 1000;\n      return seekTime;\n    }\n  }, {\n    key: \"clearLoadBar\",\n    value: function clearLoadBar(offsetX) {\n      if (offsetX < this.$progressBarLoad.offsetLeft - this.progressBarLeft) {\n        this.$progressBarLoad.style.width = '0px';\n      }\n    }\n  }, {\n    key: \"getDragDotPosition\",\n    value: function getDragDotPosition() {\n      return {\n        offsetLeft: this.$progressDragDot.offsetLeft,\n        offsetTop: this.$progressDragDot.offsetTop,\n        left: this.$progressDragDot.style.left,\n        top: this.$progressDragDot.style.top\n      };\n    }\n  }, {\n    key: \"progressBarWidth\",\n    get: function get() {\n      return this.element.offsetWidth;\n    }\n  }, {\n    key: \"progressBarLeft\",\n    get: function get() {\n      return this.element.offsetLeft;\n    }\n  }, {\n    key: \"clearDragDotTop\",\n    value: function clearDragDotTop() {\n      this.$progressDragDot.style.top = '';\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var progress_ProgressBar = (ProgressBar_ProgressBar);\n// CONCATENATED MODULE: ../src/components/control/PlayButton.js\n\n\n\n\n\n\n\nvar PlayButton_templateObject;\nfunction PlayButton_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, PlayButton_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction PlayButton_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (PlayButton_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: Play Button\r\n * @author: Jarry\r\n * @file: PlayButton.js\r\n */\n\n\nvar PlayButton_PlayButton = /*#__PURE__*/function (_BaseComponent) {\n  function PlayButton() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, PlayButton);\n    _this = PlayButton_callSuper(this, PlayButton, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(PlayButton_templateObject || (PlayButton_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-button class=\\\"goldplay__control--play\\\" data-status=\\\"\", \"\\\" title=\\\"\", \"\\\">\\n  <svg version=\\\"1.1\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" xmlns:xlink=\\\"http://www.w3.org/1999/xlink\\\" x=\\\"0px\\\" y=\\\"0px\\\"\\n  viewBox=\\\"0 0 232.153 232.153\\\" width=\\\"20\\\" height=\\\"20\\\" style=\\\"enable-background:new 0 0 232.153 232.153;\\\" xml:space=\\\"preserve\\\">\\n  <g >\\n  <path style=\\\"fill-rule:evenodd;clip-rule:evenodd;\\\" d=\\\"M203.791,99.628L49.307,2.294c-4.567-2.719-10.238-2.266-14.521-2.266\\n    c-17.132,0-17.056,13.227-17.056,16.578v198.94c0,2.833-0.075,16.579,17.056,16.579c4.283,0,9.955,0.451,14.521-2.267\\n    l154.483-97.333c12.68-7.545,10.489-16.449,10.489-16.449S216.471,107.172,203.791,99.628z\\\" fill=\\\"#f1f1f1\\\"/>\\n  </g>\\n  </svg>\\n  </gp-button>\\n  \"])), 'status', 'title'));\n    defineProperty_default()(_this, \"data\", {\n      title: 'play',\n      play: '>'\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(PlayButton, _BaseComponent);\n  return createClass_default()(PlayButton);\n}(base_BaseComponent);\n/* harmony default export */ var control_PlayButton = (PlayButton_PlayButton);\n// CONCATENATED MODULE: ../src/components/control/PauseButton.js\n\n\n\n\n\n\n\nvar PauseButton_templateObject, _templateObject2;\nfunction PauseButton_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, PauseButton_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction PauseButton_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (PauseButton_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: PauseButton\r\n * @author: Jarry\r\n * @file: PauseButton.js\r\n */\n\n\n\n\n// template = this.createTemplate`\n// <gp-button class=\"goldplay__control--pause\" title=\"${'title'}\">\n// <svg id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n// width=\"20px\" height=\"20px\" viewBox=\"0 0 535.578 535.578\" style=\"enable-background:new 0 0 535.578 535.578;\" xml:space=\"preserve\">\n// <g>\n// <path d=\"M231.6,516.278c0,10.658-8.641,19.3-19.3,19.3H106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3\n//   c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z\" fill=\"#f1f1f1\"/>\n// <path d=\"M468.728,516.278c0,10.658-8.641,19.3-19.3,19.3h-106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3\n//   c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z\" fill=\"#f1f1f1\"/>\n// </g>\n// </svg>\n// </gp-button>`\n\nvar PAUSE_ICON = toolkit_Template.create(PauseButton_templateObject || (PauseButton_templateObject = taggedTemplateLiteral_default()([\"\\n<svg style=\\\"display:\", \"\\\" class=\\\"goldplay__control--pausing\\\" version=\\\"1.1\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" xmlns:xlink=\\\"http://www.w3.org/1999/xlink\\\" x=\\\"0px\\\" y=\\\"0px\\\" width=\\\"20px\\\" height=\\\"20px\\\" viewBox=\\\"0 0 26 26\\\" style=\\\"background:none\\\" xml:space=\\\"preserve\\\">\\n<g>\\n<path d=\\\"M2.667,0h6v26h-6V0z M15.333,0v26h6V0H15.333z\\\" fill=\\\"#f1f1f1\\\"/>\\n</g>\\n</svg>\\n\"])), 'pauseHide');\nvar PAUSE_LOADING_ICON = \"\\n<svg version=\\\"1.1\\\" class=\\\"goldplay__control--pause-loading\\\" style=\\\"display:${'pauseLoadingHide'}\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" xmlns:xlink=\\\"http://www.w3.org/1999/xlink\\\" x=\\\"0px\\\" y=\\\"0px\\\" width=\\\"25px\\\" height=\\\"25px\\\" viewBox=\\\"0 0 612 792\\\" style=\\\"background:none;margin: -4px 0 0 -5px;\\\" xml:space=\\\"preserve\\\">\\n<linearGradient id=\\\"goldplay-pause-loading-gradient\\\" gradientUnits=\\\"userSpaceOnUse\\\" x1=\\\"1.98\\\" y1=\\\"784.6123\\\" x2=\\\"26.2101\\\" y2=\\\"770.623\\\" gradientTransform=\\\"matrix(21.8571 0 0 21.8571 -2.0895 -16600.5293)\\\">\\n    <stop offset=\\\"0.1682\\\" style=\\\"stop-color:#f1f1f1;stop-opacity:0\\\"></stop>\\n    <stop offset=\\\"0.7502\\\" style=\\\"stop-color:#f1f1f1\\\"></stop>\\n    <stop offset=\\\"1\\\" style=\\\"stop-color:#f1f1f1\\\"></stop>\\n</linearGradient>\\n<path style=\\\"transform-origin: center center;animation: goldplay-rotate-360 .8s linear infinite;\\\" fill=\\\"url(#goldplay-pause-loading-gradient)\\\" d=\\\"M306,133.714c144.257,0,262.286,118.028,262.286,262.286c0,144.257-118.029,262.286-262.286,262.286\\n  C161.743,658.286,43.714,540.257,43.714,396C43.714,251.743,161.743,133.714,306,133.714 M306,90C137.7,90,0,227.7,0,396\\n  s137.7,306,306,306s306-137.7,306-306S474.3,90,306,90L306,90z\\\">\\n    <animateTransform attributeName=\\\"transform\\\" attributeType=\\\"XML\\\" type=\\\"rotate\\\" from=\\\"0\\\" to=\\\"360\\\" dur=\\\".8s\\\" repeatCount=\\\"indefinite\\\" />\\n</path>\\n<g>\\n    <g>\\n        <path fill=\\\"#f1f1f1\\\" d=\\\"M229.5,514.028L229.5,514.028c-13.114,0-21.857-8.742-21.857-21.856V295.457\\n        c0-10.929,8.743-21.857,21.857-21.857l0,0c10.929,0,21.857,8.743,21.857,21.857v196.715\\n        C251.357,503.1,242.614,514.028,229.5,514.028z\\\"></path>\\n        <path fill=\\\"#f1f1f1\\\" d=\\\"M229.5,273.6c-13.114,0-21.857,8.743-21.857,21.857v196.715c0,10.928,8.743,21.856,21.857,21.856\\n        s21.857-10.929,21.857-21.856V295.457C251.357,282.343,242.614,273.6,229.5,273.6L229.5,273.6z\\\"></path>\\n    </g>\\n    <g>\\n        <path fill=\\\"#f1f1f1\\\" d=\\\"M382.5,518.4L382.5,518.4c-13.114,0-21.857-8.743-21.857-21.857V299.829\\n        c0-10.929,8.743-21.857,21.857-21.857l0,0c10.929,0,21.857,8.743,21.857,21.857v196.714\\n        C404.357,509.657,395.614,518.4,382.5,518.4z\\\"></path>\\n        <path fill=\\\"#f1f1f1\\\" d=\\\"M382.5,277.972c-10.929,0-21.857,8.743-21.857,21.857v196.714c0,10.929,10.929,21.857,21.857,21.857\\n        s21.857-10.929,21.857-21.857V299.829C404.357,288.9,393.429,277.972,382.5,277.972L382.5,277.972z\\\"></path>\\n    </g>\\n</g>\\n</svg>\\n\";\nvar PauseButton_PauseButton = /*#__PURE__*/function (_BaseComponent) {\n  function PauseButton() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, PauseButton);\n    _this = PauseButton_callSuper(this, PauseButton, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(function (data, create) {\n      return create(_templateObject2 || (_templateObject2 = taggedTemplateLiteral_default()([\"\\n  <gp-button class=\\\"goldplay__control--pause\\\" title=\\\"\", \"\\\" status=\\\"\", \"\\\">\\n  \", \"\\n  </gp-button>\\n  \"])), 'title', 'status', 'icon|html');\n    }));\n    /* all button pre-reserved in DOM */\n    // template = this.createTemplate`\n    // <gp-button class=\"goldplay__control--pause\" title=\"${'title'}\" status=\"${'status'}\">\n    // <svg style=\"display:${'pauseHide'}\" class=\"goldplay__control--pausing\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 26 26\" style=\"background:none\" xml:space=\"preserve\">\n    // <g>\n    // <path d=\"M2.667,0h6v26h-6V0z M15.333,0v26h6V0H15.333z\" fill=\"#f1f1f1\"/>\n    // </g>\n    // </svg>\n    // <svg version=\"1.1\" class=\"goldplay__control--pause-loading\" style=\"display:${'pauseLoadingHide'}\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"30px\" height=\"30px\" viewBox=\"0 0 612 792\" style=\"background:none;margin: -4px 0 0 -5px;\" xml:space=\"preserve\">\n    //     <linearGradient id=\"goldplay-pause-loading-gradient\" gradientUnits=\"userSpaceOnUse\" x1=\"1.98\" y1=\"784.6123\" x2=\"26.2101\" y2=\"770.623\" gradientTransform=\"matrix(21.8571 0 0 21.8571 -2.0895 -16600.5293)\">\n    //         <stop offset=\"0.1682\" style=\"stop-color:#f1f1f1;stop-opacity:0\"></stop>\n    //         <stop offset=\"0.7502\" style=\"stop-color:#f1f1f1\"></stop>\n    //         <stop offset=\"1\" style=\"stop-color:#f1f1f1\"></stop>\n    //     </linearGradient>\n    //     <path style=\"transform-origin: center center;\" fill=\"url(#goldplay-pause-loading-gradient)\" d=\"M306,133.714c144.257,0,262.286,118.028,262.286,262.286c0,144.257-118.029,262.286-262.286,262.286\n    //       C161.743,658.286,43.714,540.257,43.714,396C43.714,251.743,161.743,133.714,306,133.714 M306,90C137.7,90,0,227.7,0,396\n    //       s137.7,306,306,306s306-137.7,306-306S474.3,90,306,90L306,90z\">\n    //         <animateTransform attributeName=\"transform\" attributeType=\"XML\" type=\"rotate\" from=\"0\" to=\"360\" dur=\".8s\" repeatCount=\"indefinite\" />\n    //     </path>\n    //     <g>\n    //         <g>\n    //             <path fill=\"#f1f1f1\" d=\"M229.5,514.028L229.5,514.028c-13.114,0-21.857-8.742-21.857-21.856V295.457\n    //             c0-10.929,8.743-21.857,21.857-21.857l0,0c10.929,0,21.857,8.743,21.857,21.857v196.715\n    //             C251.357,503.1,242.614,514.028,229.5,514.028z\"></path>\n    //             <path fill=\"#f1f1f1\" d=\"M229.5,273.6c-13.114,0-21.857,8.743-21.857,21.857v196.715c0,10.928,8.743,21.856,21.857,21.856\n    //             s21.857-10.929,21.857-21.856V295.457C251.357,282.343,242.614,273.6,229.5,273.6L229.5,273.6z\"></path>\n    //         </g>\n    //         <g>\n    //             <path fill=\"#f1f1f1\" d=\"M382.5,518.4L382.5,518.4c-13.114,0-21.857-8.743-21.857-21.857V299.829\n    //             c0-10.929,8.743-21.857,21.857-21.857l0,0c10.929,0,21.857,8.743,21.857,21.857v196.714\n    //             C404.357,509.657,395.614,518.4,382.5,518.4z\"></path>\n    //             <path fill=\"#f1f1f1\" d=\"M382.5,277.972c-10.929,0-21.857,8.743-21.857,21.857v196.714c0,10.929,10.929,21.857,21.857,21.857\n    //             s21.857-10.929,21.857-21.857V299.829C404.357,288.9,393.429,277.972,382.5,277.972L382.5,277.972z\"></path>\n    //         </g>\n    //     </g>\n    // </svg>\n    // </gp-button>\n    // `\n    defineProperty_default()(_this, \"data\", {\n      title: 'pause',\n      pauseHide: '',\n      pauseLoadingHide: 'none',\n      icon: PAUSE_ICON,\n      // pause | pauseloading | ''\n      status: '',\n      display: ''\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(PauseButton, _BaseComponent);\n  return createClass_default()(PauseButton, [{\n    key: \"watch\",\n    value: function watch() {\n      if (this.data.status === 'pauseloading') {\n        this.data.pauseHide = 'none';\n        this.data.pauseLoadingHide = 'inline-block';\n        this.data.title = 'loading';\n        this.data.icon = PAUSE_LOADING_ICON;\n      } else if (this.data.status === 'pause') {\n        this.data.pauseHide = 'inline-block';\n        this.data.pauseLoadingHide = 'none';\n        this.data.title = 'pause';\n        this.data.icon = PAUSE_ICON;\n      }\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var control_PauseButton = (PauseButton_PauseButton);\n// CONCATENATED MODULE: ../src/components/control/ReplayButton.js\n\n\n\n\n\n\n\nvar ReplayButton_templateObject;\nfunction ReplayButton_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, ReplayButton_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction ReplayButton_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ReplayButton_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: ReplayButton\r\n * @author: Jarry\r\n * @file: ReplayButton.js\r\n */\n\n\nvar ReplayButton_ReplayButton = /*#__PURE__*/function (_BaseComponent) {\n  function ReplayButton() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, ReplayButton);\n    _this = ReplayButton_callSuper(this, ReplayButton, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(ReplayButton_templateObject || (ReplayButton_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-button class=\\\"goldplay__control--replay\\\" title=\\\"\", \"\\\" data-display=\\\"\", \"\\\">\\n  <svg version=\\\"1.0\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\"\\n  width=\\\"24px\\\" height=\\\"24px\\\" viewBox=\\\"0 0 245.000000 206.000000\\\"\\n  preserveAspectRatio=\\\"xMidYMid meet\\\">\\n <g transform=\\\"translate(0.000000,206.000000) scale(0.100000,-0.100000)\\\"\\n fill=\\\"#f1f1f1\\\" stroke=\\\"1\\\">\\n <path d=\\\"M1250 2046 c-286 -55 -525 -211 -681 -445 -91 -136 -152 -302 -167\\n -453 -12 -119 3 -108 -143 -109 -70 -1 -156 -4 -192 -8 l-65 -6 262 -265 262\\n -265 266 265 265 265 -62 6 c-35 4 -123 7 -197 8 l-134 1 7 69 c26 284 232\\n 543 504 635 201 69 404 53 596 -47 62 -32 103 -63 177 -137 83 -83 102 -108\\n 142 -190 63 -130 77 -193 77 -340 0 -178 -37 -298 -134 -435 -91 -126 -220\\n -224 -369 -278 -72 -26 -99 -31 -218 -35 -117 -4 -146 -1 -215 17 -104 29\\n -205 79 -283 142 l-63 52 -89 -89 c-49 -49 -89 -96 -89 -106 0 -24 154 -136\\n 253 -185 89 -44 177 -74 272 -95 84 -17 303 -15 391 5 403 91 691 371 795 772\\n 19 76 23 114 22 240 0 129 -4 164 -27 249 -99 377 -406 673 -778 751 -104 22\\n -297 28 -385 11z\\\"/>\\n <path d=\\\"M1227 1418 c-9 -68 -7 -695 2 -770 l6 -57 240 200 c132 110 251 210\\n 264 223 l23 24 -257 213 c-141 118 -260 215 -264 217 -5 1 -11 -21 -14 -50z\\\"/>\\n </g>\\n </svg>\\n  </gp-button>\\n  \"])), 'title', 'display'));\n    defineProperty_default()(_this, \"data\", {\n      title: 'replay',\n      display: '',\n      replay: '->'\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(ReplayButton, _BaseComponent);\n  return createClass_default()(ReplayButton);\n}(base_BaseComponent);\n/* harmony default export */ var control_ReplayButton = (ReplayButton_ReplayButton);\n// CONCATENATED MODULE: ../src/components/volume/VolumeBar.js\n\n\n\n\n\n\n\nvar VolumeBar_templateObject, VolumeBar_templateObject2, _templateObject3;\nfunction VolumeBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, VolumeBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction VolumeBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (VolumeBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file VolumeBar.js\r\n * @desc\r\n * VolumeBar\r\n * @see\r\n * @author Jarry\r\n */\n\n\n\n\n\n\n\nvar AUDIO_ON_ICON = toolkit_Template.create(VolumeBar_templateObject || (VolumeBar_templateObject = taggedTemplateLiteral_default()([\"\\n<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" style=\\\"display:\", \"\\\" width=\\\"20px\\\" height=\\\"20px\\\" viewBox=\\\"0 0 24 24\\\" style=\\\"margin-left: -5px;\\\">\\n<path d=\\\"M5.2 7.68l6.175-5.293a.5.5 0 0 1 .825.38v17.825a.5.5 0 0 1-.825.38L5.2 15.679H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h2.2zm9 13.35v-2.375l.007-.003C16.852 17.493 19 14.897 19 11.479s-2.148-6.014-4.793-7.173a4.11 4.11 0 0 0-.007-.003V2c.027.006.054.012.082.02.852.221 1.274.453 1.436.535A10 10 0 0 1 21.2 11.48c0 4.106-2.474 7.633-6.013 9.174-.526.229-.583.284-.987.377zm0-13.973c1.5.925 2.5 2.582 2.5 4.473 0 1.892-1 3.55-2.5 4.473V7.057z\\\" fill=\\\"#f1f1f1\\\"></path>\\n</svg>\\n\"])), 'audioOnHide');\nvar AUDIO_OFF_ICON = toolkit_Template.create(VolumeBar_templateObject2 || (VolumeBar_templateObject2 = taggedTemplateLiteral_default()([\"\\n<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" style=\\\"display:\", \"\\\" width=\\\"20px\\\" height=\\\"20px\\\" viewBox=\\\"0 0 24 24\\\" style=\\\"margin-left: -5px;\\\">\\n<path d=\\\"M12.2 13.914v6.678a.5.5 0 0 1-.825.38L5.2 15.679H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h2.2l.412-.353-2.558-2.558a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0l16.849 16.849a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0l-2.386-2.386a10 10 0 0 1-2.33 1.422c-.526.229-.583.284-.987.377v-2.375l.007-.003a8.332 8.332 0 0 0 1.717-1.014l-1.67-1.669a5.251 5.251 0 0 1-.054.034v-.089l-2-2zM8.373 4.96l3.002-2.572a.5.5 0 0 1 .825.38v6.019L8.373 4.959zm9.867 9.867c.48-.99.76-2.115.76-3.347 0-3.418-2.148-6.014-4.793-7.173a4.11 4.11 0 0 0-.007-.003V2c.027.006.054.012.082.02.852.221 1.274.453 1.436.535A10 10 0 0 1 21.2 11.48a9.954 9.954 0 0 1-1.326 4.98l-1.634-1.633zm-1.766-1.766L14.2 10.786V7.057a5.247 5.247 0 0 1 2.274 6.003z\\\" fill=\\\"#f1f1f1\\\"></path>\\n</svg>\\n\"])), 'audioOffHide');\nvar VolumeBar_VolumeBar = /*#__PURE__*/function (_BaseComponent) {\n  function VolumeBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, VolumeBar);\n    _this = VolumeBar_callSuper(this, VolumeBar, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(_templateObject3 || (_templateObject3 = taggedTemplateLiteral_default()([\"\\n  <gp-volume class=\\\"goldplay__volume-bar\\\">\\n    <gp-overbox class=\\\"goldplay-hoverbox goldplay__volume-bar--handle\\\">\\n      <span class=\\\"goldplay__volume-bar--precent\\\">\", \"</span>\\n      <span class=\\\"goldplay__volume-bar--rod \", \"\\\" title=\\\"adjust volume\\\"></span>\\n      <span class=\\\"goldplay__volume-bar--size\\\">&nbsp;</span>\\n      <span class=\\\"goldplay__volume-bar--column\\\">&nbsp;</span>\\n    </gp-overbox>\\n    <gp-button class=\\\"goldplay__volume-bar--audio \", \"\\\" title=\\\"\", \"\\\" data-mute=\\\"\", \"\\\" data-volume-size=\\\"\", \"\\\"  data-last-volume=\\\"\", \"\\\">\\n    \", \"\\n    </gp-button>\\n  </gp-volume>\\n  \"])), 'dataPrecent', 'volumeBarRodHoverCss', 'audioOffClass', 'title', 'dataMute', 'dataVolumeSize', 'dataLastVolume', 'icon|html'));\n    defineProperty_default()(_this, \"options\", {});\n    defineProperty_default()(_this, \"data\", {\n      audioONHide: '',\n      audioOffHide: '',\n      audioOffClass: '',\n      dataVolumeSize: '',\n      dataPrecent: '',\n      dataLastVolume: '',\n      dataMute: '',\n      volumeBarRodHoverCss: '',\n      icon: AUDIO_ON_ICON,\n      title: 'turn off'\n    });\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(VolumeBar, _BaseComponent);\n  return createClass_default()(VolumeBar, [{\n    key: \"watch\",\n    value: function watch() {\n      this.data.dataPrecent = Math.floor(this.data.dataVolumeSize * 100);\n      if (this.data.audioOffClass !== '') {\n        this.data.dataMute = 'true';\n        this.data.audioOffHide = 'inline-block';\n        this.data.audioOnHide = 'none';\n        this.data.icon = AUDIO_OFF_ICON;\n        this.data.title = 'turn on';\n      } else {\n        this.data.dataMute = '';\n        this.data.audioOffHide = 'none';\n        this.data.audioOnHide = 'inline-block';\n        this.data.icon = AUDIO_ON_ICON;\n        this.data.title = 'turn off';\n      }\n    }\n  }, {\n    key: \"initProps\",\n    value: function initProps() {\n      var $volumeBar = this.element;\n      var cssName = this.options.cssName;\n      this.INIT_VOLUME_SIZE = this.options.player.defaultVolumeSize === undefined ? 0.50 : this.options.player.defaultVolumeSize;\n      this.$volumeBarHandle = $volumeBar.querySelector('.' + cssName.volumeBarHandle);\n      this.$volumeBarRod = $volumeBar.querySelector('.' + cssName.volumeBarRod);\n      this.$volumeBarAudio = $volumeBar.querySelector('.' + cssName.volumeBarAudio);\n      this.$volumeBarSize = $volumeBar.querySelector('.' + cssName.volumeBarSize);\n      this.$volumeBarColumn = $volumeBar.querySelector('.' + cssName.volumeBarColumn);\n      this.volumeBarColumnHeight = this.$volumeBarColumn.offsetHeight;\n      this.volumeBarColumnTop = this.$volumeBarColumn.offsetTop;\n      this.volumeBarRodHeight = this.$volumeBarRod.offsetHeight;\n      this.volumeBarRodHeightHalf = this.volumeBarRodHeight / 2;\n      this.volumeBarColumnRealTop = this.volumeBarColumnTop + this.volumeBarRodHeightHalf;\n      this.volumeBarColumnMaxHeight = this.volumeBarColumnHeight - this.volumeBarRodHeight;\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var $container = this.options.$controlBarContainer;\n      var cssName = this.options.cssName;\n      toolkit_Delegator($container).on('mouseover', '.' + cssName.volumeBar, function () {\n        clearTimeout(volumeBarHidetimer);\n        _this2.showVolumeBarHandle();\n      });\n      toolkit_Delegator($container).on('mousewheel', '.' + cssName.volumeBarHandle, function (evt) {\n        var volumeSize = evt.wheelDelta / 500;\n        volumeSize = _this2.data.dataVolumeSize + volumeSize;\n        _this2.setVolumeSize(volumeSize);\n        evt.preventDefault();\n        evt.stopPropagation();\n        return;\n      });\n      toolkit_Delegator($container).on('click', ['.' + cssName.volumeBarColumn, '.' + cssName.volumeBarSize], function (evt) {\n        var volumeSize = 0;\n        if (evt.target === _this2.$volumeBarColumn) {\n          volumeSize = (_this2.$volumeBarColumn.offsetHeight - evt.offsetY) / evt.target.offsetHeight;\n        } else if (evt.target === _this2.$volumeBarSize) {\n          volumeSize = _this2.$volumeBarColumn.offsetHeight - evt.target.offsetHeight + evt.offsetY;\n          volumeSize = _this2.$volumeBarColumn.offsetHeight - volumeSize;\n          volumeSize = volumeSize / _this2.$volumeBarColumn.offsetHeight;\n        }\n        _this2.setVolumeSize(volumeSize);\n        return false;\n      });\n      toolkit_Delegator($container).on('click', '.' + cssName.volumeBarAudio, function (evt) {\n        if (_this2.$volumeBarAudio.classList.contains(cssName.volumeBarAudioOff)) {\n          _this2.setAudioOn(evt.offsetY);\n        } else {\n          _this2.setAudioOff(evt.offsetY);\n        }\n        return false;\n      });\n      var volumeBarHidetimer;\n      var _inHandleScope = function _inHandleScope(evt) {\n        var $bar = _this2.element;\n        var scope = {\n          y: $bar.offsetTop + _this2.$volumeBarHandle.offsetTop,\n          x: $bar.offsetLeft\n        };\n        scope.width = $bar.offsetWidth;\n        scope.height = _this2.$volumeBarHandle.offsetHeight;\n        if (evt.pageX > scope.x && evt.pageX < scope.x + scope.width && evt.pageY > scope.y && evt.pageY < scope.y + scope.height) {\n          return true;\n        } else {\n          return false;\n        }\n      };\n      toolkit_Delegator($container).on('mouseout', '.' + cssName.volumeBar, function (evt) {\n        volumeBarHidetimer = setTimeout(function () {\n          if (!_inHandleScope(evt)) {\n            _this2.hideVolumeBarHandle();\n          } else {\n            clearTimeout(volumeBarHidetimer);\n          }\n        }, Config[\"c\" /* Config */].hideBarBoxTime);\n      });\n      this.volumeDragEvent = toolkit_Dragger(this.$volumeBarRod, {\n        $container: this.element,\n        type: 'vertical',\n        scope: {\n          top: this.volumeBarColumnTop,\n          right: 0,\n          bottom: this.volumeBarColumnTop + this.volumeBarColumnHeight,\n          left: 0\n        },\n        onStart: function onStart() {\n          _this2.data.volumeBarRodHoverCss = _this2.options.cssName.volumeBarRodHover;\n        },\n        onDrag: function onDrag(offsetX, offsetY) {\n          offsetY -= 1;\n          _this2.dragHandle(offsetY);\n        },\n        onRelease: function onRelease() {\n          _this2.data.volumeBarRodHoverCss = '';\n        }\n      });\n    }\n  }, {\n    key: \"hideVolumeBarHandle\",\n    value: function hideVolumeBarHandle() {\n      this.$volumeBarHandle.style.visibility = 'hidden';\n    }\n  }, {\n    key: \"showVolumeBarHandle\",\n    value: function showVolumeBarHandle() {\n      this.$volumeBarHandle.style.visibility = 'visible';\n    }\n  }, {\n    key: \"getVolume\",\n    value: function getVolume() {\n      var volumeSize = (this.$volumeBarSize.offsetHeight - this.volumeBarRodHeight) / this.volumeBarColumnMaxHeight;\n      volumeSize = Math.min(volumeSize, 1);\n      volumeSize = Math.max(volumeSize, 0);\n      return volumeSize.toFixed(2);\n    }\n  }, {\n    key: \"setVolume\",\n    value: function setVolume(value) {\n      this.data.dataVolumeSize = Number(value);\n      this.events.emit(EventsConfig.PlayerOnVolume, value);\n    }\n  }, {\n    key: \"initVolumeSize\",\n    value: function initVolumeSize() {\n      this.data.dataLastVolume = this.INIT_VOLUME_SIZE;\n      this.setAudioOn();\n    }\n  }, {\n    key: \"setAudioOn\",\n    value: function setAudioOn() {\n      var volume = this.data.dataLastVolume || 0;\n      this.setVolume(volume);\n      var volumeSize = parseFloat(volume, 10);\n      var volumeHeight = Math.floor(volumeSize * this.volumeBarColumnMaxHeight);\n      var volumeSizeTop = this.volumeBarColumnTop + (this.volumeBarColumnMaxHeight - volumeHeight);\n      this.$volumeBarSize.style.marginTop = volumeSizeTop + 'px';\n      this.$volumeBarSize.style.height = volumeHeight + this.volumeBarRodHeight + 'px';\n      this.$volumeBarRod.style.top = volumeSizeTop + 'px';\n      this.data.audioOffClass = '';\n    }\n  }, {\n    key: \"setAudioOff\",\n    value: function setAudioOff() {\n      this.setVolume(0);\n      this.data.audioOffClass = this.options.cssName.volumeBarAudioOff;\n      var volumeSize = this.getVolume();\n      if (volumeSize > 0) {\n        this.data.dataLastVolume = volumeSize;\n      }\n      this.$volumeBarSize.style.height = this.volumeBarRodHeight + 'px';\n      this.$volumeBarSize.style.marginTop = this.volumeBarColumnRealTop - this.volumeBarRodHeightHalf + this.volumeBarColumnMaxHeight + 'px';\n      this.$volumeBarRod.style.top = this.volumeBarColumnRealTop + this.volumeBarColumnMaxHeight - this.volumeBarRodHeightHalf + 'px';\n    }\n  }, {\n    key: \"dragHandle\",\n    value: function dragHandle(offsetY) {\n      this.$volumeBarSize.style.marginTop = offsetY + 1 + 'px';\n      this.$volumeBarSize.style.height = this.volumeBarColumnHeight - offsetY + this.volumeBarRodHeight + 'px';\n      var volumeSize = this.getVolume();\n      if (volumeSize <= 0) {\n        this.setAudioOff(offsetY);\n      } else if (this.data.dataMute == 'true') {\n        this.setAudioOn(offsetY);\n      }\n      this.setVolume(volumeSize);\n    }\n  }, {\n    key: \"setVolumeSize\",\n    value: function setVolumeSize(volumeSize) {\n      volumeSize = volumeSize.toFixed(2);\n      if (volumeSize >= 1) {\n        volumeSize = 1;\n      } else if (volumeSize < 0.001) {\n        volumeSize = 0;\n      }\n      if (volumeSize !== this.data.dataVolumeSize) {\n        this.setVolume(volumeSize);\n        var totalSize = this.volumeBarColumnMaxHeight;\n        var offsetY = totalSize - volumeSize * totalSize;\n        var marginTop = offsetY + this.volumeBarColumnTop;\n        this.$volumeBarSize.style.marginTop = marginTop + 'px';\n        this.$volumeBarSize.style.height = volumeSize * totalSize + this.volumeBarRodHeight + 'px';\n        this.$volumeBarRod.style.top = marginTop + 'px';\n        if (volumeSize <= 0) {\n          this.data.audioOffClass = this.options.cssName.volumeBarAudioOff;\n        } else if (this.data.dataMute == 'true') {\n          this.data.audioOffClass = '';\n        }\n      }\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var volume_VolumeBar = (VolumeBar_VolumeBar);\n// CONCATENATED MODULE: ../src/components/tips/WaitingBar.js\n\n\n\n\n\n\n\nvar WaitingBar_templateObject;\nfunction WaitingBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, WaitingBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction WaitingBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (WaitingBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file WaitingBar.js\r\n * @desc\r\n * WaitingBar\r\n * @see\r\n * @author Jarry\r\n */\n\n\n\n\n\n/* spinner loading */\n// template = this.createTemplate`\n//   <gp-wait class=\"goldplay-tip goldplay__waiting-bar\" title=\"${'title'}\" data-display=\"${'display'}\">\n//   <svg width=\"80px\"  height=\"80px\"  xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" style=\"background: none;\"><g transform=\"rotate(0 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.9166666666666666s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(30 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.8333333333333334s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(60 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.75s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(90 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.6666666666666666s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(120 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.5833333333333334s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(150 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.5s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(180 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.4166666666666667s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(210 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.3333333333333333s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(240 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.25s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(270 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.16666666666666666s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(300 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.08333333333333333s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g><g transform=\"rotate(330 50 50)\">\n//   <rect x=\"47\" y=\"24\" rx=\"9.4\" ry=\"4.8\" width=\"6\" height=\"12\" fill=\"#f9f9f9\">\n//     <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n//   </rect>\n// </g></svg>\n//   </gp-wait>\n//   `\n\n/* rolling loading */\n// template = this.createTemplate`\n// <gp-wait class=\"goldplay-tip goldplay__waiting-bar\" title=\"${'title'}\" data-display=\"${'display'}\">\n// <svg width=\"50px\"  height=\"50px\"  xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" style=\"background: none;\"><circle cx=\"50\" cy=\"50\" fill=\"none\" stroke=\"#f9f9f9\" stroke-width=\"10\" r=\"35\" stroke-dasharray=\"164.93361431346415 56.97787143782138\" transform=\"rotate(257.903 50 50)\"><animateTransform attributeName=\"transform\" type=\"rotate\" calcMode=\"linear\" values=\"0 50 50;360 50 50\" keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"></animateTransform></circle></svg>\n// </gp-wait>\n// `\nvar WaitingBar_WaitingBar = /*#__PURE__*/function (_BaseComponent) {\n  function WaitingBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, WaitingBar);\n    _this = WaitingBar_callSuper(this, WaitingBar, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(WaitingBar_templateObject || (WaitingBar_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-wait class=\\\"goldplay-tip goldplay__waiting-bar\\\" title=\\\"\", \"\\\" data-status=\\\"\", \"\\\">\\n    <span class=\\\"goldplay__waiting-bar--icon\\\">\\n    <svg width=\\\"60px\\\" height=\\\"60px\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 100 100\\\" preserveAspectRatio=\\\"xMidYMid\\\" style=\\\"background: none;opacity:0.8\\\">\\n    <circle cx=\\\"50\\\" cy=\\\"50\\\" fill=\\\"none\\\" stroke-linecap=\\\"round\\\" r=\\\"40\\\" stroke-width=\\\"8\\\" stroke=\\\"#f6f6f6\\\" stroke-dasharray=\\\"62.83185307179586 62.83185307179586\\\" transform=\\\"rotate(17.8841 50 50)\\\">\\n    <animateTransform attributeName=\\\"transform\\\" type=\\\"rotate\\\" calcMode=\\\"linear\\\" values=\\\"0 50 50;360 50 50\\\" keyTimes=\\\"0;1\\\" dur=\\\"0.7s\\\" begin=\\\"0s\\\" repeatCount=\\\"indefinite\\\">\\n    </animateTransform>\\n    </circle>\\n    </svg>\\n  </span>\\n  <gp-speed class=\\\"goldplay__waiting-bar--speed\\\">\", \"</gp-speed>\\n  </gp-wait>\\n  \"])), 'title', 'status', 'speed'));\n    defineProperty_default()(_this, \"data\", {\n      title: 'waiting',\n      speed: '',\n      status: '',\n      display: 'show'\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(WaitingBar, _BaseComponent);\n  return createClass_default()(WaitingBar, [{\n    key: \"initProps\",\n    value: function initProps() {}\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.LoaderUpdateSpeed, function (data) {\n        if (_this2.data.display === 'show') {\n          _this2.data.speed = sizeFormat.formatBytes(data.speed) + ' /s';\n        }\n      });\n    }\n  }, {\n    key: \"showWaiting\",\n    value: function showWaiting() {\n      var cssName = this.options.cssName;\n      var $box = this.options.$screenContainer;\n      if (!$box.querySelector('.' + cssName.waitingBar)) {\n        $box.prepend(this.element);\n      }\n      this.data.display = 'show';\n      this.show();\n      this.resetPosition();\n    }\n  }, {\n    key: \"hideWaiting\",\n    value: function hideWaiting() {\n      var cssName = this.options.cssName;\n      var $box = this.options.$screenContainer;\n      if ($box.querySelector('.' + cssName.waitingBar)) {\n        this.data.display = 'hide';\n        this.data.speed = 'Loading...';\n        this.hide();\n      }\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var tips_WaitingBar = (WaitingBar_WaitingBar);\n// CONCATENATED MODULE: ../src/components/tips/AlertBox.js\n\n\n\n\n\n\n\nvar AlertBox_templateObject;\nfunction AlertBox_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, AlertBox_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction AlertBox_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (AlertBox_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: AlertBox.js\r\n * @author: Jarry\r\n * @file: AlertBox\r\n */\n\n\n\nvar AlertBox_AlertBox = /*#__PURE__*/function (_BaseComponent) {\n  function AlertBox() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, AlertBox);\n    _this = AlertBox_callSuper(this, AlertBox, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(AlertBox_templateObject || (AlertBox_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-alert class=\\\"goldplay-tip goldplay__alter-box\\\" title=\\\"\", \"\\\" data-display=\\\"\", \"\\\">\\n  <em title=\\\"close\\\" class=\\\"goldplay__alter--close\\\">\\n    <svg version=\\\"1.1\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" xmlns:xlink=\\\"http://www.w3.org/1999/xlink\\\" style=\\\"background:none;opacity:0.6\\\" xml:space=\\\"preserve\\\" width=\\\"20px\\\" height=\\\"20px\\\" viewBox=\\\"0 0 496.158 496.158\\\">\\n    <path style=\\\"fill:#ff3300;\\\" d=\\\"M496.158,248.085c0-137.021-111.07-248.082-248.076-248.082C111.07,0.003,0,111.063,0,248.085\\n    c0,137.002,111.07,248.07,248.082,248.07C385.088,496.155,496.158,385.087,496.158,248.085z\\\"/>\\n    <path style=\\\"fill:#FFFFFF;\\\" d=\\\"M277.042,248.082l72.528-84.196c7.91-9.182,6.876-23.041-2.31-30.951\\n    c-9.172-7.904-23.032-6.876-30.947,2.306l-68.236,79.212l-68.229-79.212c-7.91-9.188-21.771-10.216-30.954-2.306\\n    c-9.186,7.91-10.214,21.77-2.304,30.951l72.522,84.196l-72.522,84.192c-7.91,9.182-6.882,23.041,2.304,30.951\\n    c4.143,3.569,9.241,5.318,14.316,5.318c6.161,0,12.294-2.586,16.638-7.624l68.229-79.212l68.236,79.212\\n    c4.338,5.041,10.47,7.624,16.637,7.624c5.069,0,10.168-1.749,14.311-5.318c9.186-7.91,10.22-21.77,2.31-30.951L277.042,248.082z\\\"/>\\n    </svg>\\n  </em>\\n  <span class=\\\"goldplay__alter--warn\\\">\\n    <svg version=\\\"1.1\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" xmlns:xlink=\\\"http://www.w3.org/1999/xlink\\\" x=\\\"0px\\\" y=\\\"0px\\\"\\n    width=\\\"30\\\" height=\\\"30\\\" viewBox=\\\"0 0 512 512\\\" style=\\\"enable-background:new 0 0 512 512;\\\" xml:space=\\\"preserve\\\">\\n    <path style=\\\"fill:#495A79;\\\" d=\\\"M501.461,383.799L320.501,51.401C306.7,28.6,282.7,14.8,256,14.8s-50.7,13.8-64.501,36.601\\n      L10.539,383.799C-3.259,407.501-3.56,435.701,9.941,459.4c13.499,23.699,37.798,37.8,65.099,37.8h361.92\\n      c27.301,0,51.601-14.101,65.099-37.8C515.56,435.701,515.259,407.501,501.461,383.799z\\\"/>\\n    <path style=\\\"fill:#42516D;\\\" d=\\\"M502.059,459.4c-13.499,23.699-37.798,37.8-65.099,37.8H256V14.8c26.7,0,50.7,13.801,64.501,36.601\\n      L501.461,383.8C515.259,407.501,515.56,435.701,502.059,459.4z\\\"/>\\n    <path style=\\\"fill:#FFDE33;\\\" d=\\\"M475.661,399.1L294.699,66.699C286.601,52.9,271.901,44.8,256,44.8s-30.601,8.101-38.699,21.899\\n      L36.339,399.1c-8.399,14.101-8.399,31.199-0.298,45.3c8.099,14.399,22.798,22.8,39,22.8h361.92c16.201,0,30.901-8.401,39-22.8\\n      C484.06,430.299,484.06,413.201,475.661,399.1z\\\"/>\\n    <path style=\\\"fill:#FFBC33;\\\" d=\\\"M475.96,444.4c-8.099,14.399-22.798,22.8-39,22.8H256V44.8c15.901,0,30.601,8.101,38.699,21.899\\n      L475.661,399.1C484.06,413.201,484.06,430.299,475.96,444.4z\\\"/>\\n    <g>\\n      <path style=\\\"fill:#495A79;\\\" d=\\\"M256,437.2c-16.538,0-30-13.462-30-30s13.462-30,30-30s30,13.462,30,30S272.538,437.2,256,437.2z\\\"/>\\n      <path style=\\\"fill:#495A79;\\\" d=\\\"M286,317.2c0,16.538-13.462,30-30,30s-30-13.462-30-30v-150c0-16.538,13.462-30,30-30\\n        s30,13.462,30,30V317.2z\\\"/>\\n    </g>\\n    <g>\\n      <path style=\\\"fill:#42516D;\\\" d=\\\"M286,407.2c0-16.538-13.462-30-30-30v60C272.538,437.2,286,423.738,286,407.2z\\\"/>\\n      <path style=\\\"fill:#42516D;\\\" d=\\\"M286,317.2v-150c0-16.538-13.462-30-30-30v210C272.538,347.2,286,333.738,286,317.2z\\\"/>\\n    </g>\\n    </svg>\\n  </span>\\n  <gp-content class=\\\"goldplay__alter--content\\\">\", \"</gp-content>\\n  </gp-alert>\\n  \"])), 'title', 'display', 'content|trim'));\n    defineProperty_default()(_this, \"data\", {\n      title: 'alert',\n      display: 'default',\n      content: \"\"\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(AlertBox, _BaseComponent);\n  return createClass_default()(AlertBox, [{\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var $container = this.options.$screenContainer;\n      var cssName = this.options.cssName;\n      toolkit_Delegator($container).on('click', '.' + cssName.alertClose, function () {\n        _this2.hide();\n      });\n    }\n  }, {\n    key: \"afterWatch\",\n    value: function afterWatch() {\n      if (this.data.display === 'show') {\n        this.resetPosition();\n      }\n    }\n  }, {\n    key: \"showBox\",\n    value: function showBox() {\n      var cssName = this.options.cssName;\n      var $box = this.options.$screenContainer;\n      if (!$box.querySelector('.' + cssName.alertBox)) {\n        $box.prepend(this.element);\n      }\n      this.data.display = 'show';\n      this.show();\n    }\n  }, {\n    key: \"hideBox\",\n    value: function hideBox() {\n      var cssName = this.options.cssName;\n      var $box = this.options.$screenContainer;\n      if ($box.querySelector('.' + cssName.alertBox)) {\n        this.data.display = 'hide';\n        this.hide();\n      }\n    }\n  }, {\n    key: \"show\",\n    value: function show() {\n      this.element.style.opacity = 1;\n      this.element.style.display = 'inline-block';\n      this.resetPosition();\n    }\n  }, {\n    key: \"hide\",\n    value: function hide() {\n      this.element.style.opacity = 0;\n      this.element.style.display = 'none';\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var tips_AlertBox = (AlertBox_AlertBox);\n// CONCATENATED MODULE: ../src/components/timer/Timer.js\n\n\n\n\n\n\n\nvar Timer_templateObject;\nfunction Timer_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, Timer_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction Timer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Timer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: Timer\r\n * @author: Jarry\r\n * @file: Timer.js\r\n */\n\n\n\n\nvar Timer_Timer = /*#__PURE__*/function (_BaseComponent) {\n  function Timer() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, Timer);\n    _this = Timer_callSuper(this, Timer, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(Timer_templateObject || (Timer_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-time class=\\\"goldplay__control--timer\\\">\\n  <span gid=\\\"time\\\" class=\\\"goldplay__control--timer-play\\\">\", \"</span>\\n  <span gid=\\\"slash\\\">\", \"</span>\\n  <span gid=\\\"total-time\\\" class=\\\"goldplay__control--timer-total\\\">\", \"</span>\\n  </gp-time>\\n  \"])), 'time', 'slash', 'totalTime'));\n    defineProperty_default()(_this, \"data\", {\n      time: '00:00',\n      totalTime: '',\n      slash: '/'\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(Timer, _BaseComponent);\n  return createClass_default()(Timer, [{\n    key: \"setTotalTime\",\n    value: function setTotalTime(data) {\n      var source = data.sourceData;\n      this.data.totalTime = timeFormat.formatHHMMSS(source.duration);\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.LoaderPlayListLoaded, function (loader) {\n        _this2.setTotalTime(loader.dataManage);\n      });\n    }\n  }, {\n    key: \"updateTime\",\n    value: function updateTime(second) {\n      this.element.querySelector('[gid=\"time\"]').innerHTML = second;\n    }\n  }, {\n    key: \"updateTotalTime\",\n    value: function updateTotalTime(second) {\n      this.element.querySelector('[gid=\"total-time\"]').innerHTML = second;\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var timer_Timer = (Timer_Timer);\n// CONCATENATED MODULE: ../src/components/speed/SpeedBar.js\n\n\n\n\n\n\n\nvar SpeedBar_templateObject;\nfunction SpeedBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, SpeedBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction SpeedBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SpeedBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\nfunction SpeedBar_createForOfIteratorHelper(r, e) { var t = \"undefined\" != typeof Symbol && r[Symbol.iterator] || r[\"@@iterator\"]; if (!t) { if (Array.isArray(r) || (t = SpeedBar_unsupportedIterableToArray(r)) || e && r && \"number\" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError(\"Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.\"); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }\nfunction SpeedBar_unsupportedIterableToArray(r, a) { if (r) { if (\"string\" == typeof r) return SpeedBar_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return \"Object\" === t && r.constructor && (t = r.constructor.name), \"Map\" === t || \"Set\" === t ? Array.from(r) : \"Arguments\" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? SpeedBar_arrayLikeToArray(r, a) : void 0; } }\nfunction SpeedBar_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: SpeedBar\r\n * @author: Jarry\r\n * @file: SpeedBar.js\r\n */\n\n\n\n\n\nvar makeSpeedListHTML = function makeSpeedListHTML(data) {\n  if (!data) {\n    return;\n  }\n  var html = ['<ul>'];\n  var _iterator = SpeedBar_createForOfIteratorHelper(data),\n    _step;\n  try {\n    for (_iterator.s(); !(_step = _iterator.n()).done;) {\n      var item = _step.value;\n      var selectedClass = '';\n      var selectedHTML = '';\n      if (item.selected) {\n        selectedClass = 'gp-selected';\n        selectedHTML = \" selected=\".concat(item.selected);\n      }\n      html.push(\"\\n    <li class=\\\"\".concat(selectedClass, \"\\\" gp-node-li value=\\\"\").concat(item.value, \"\\\" \").concat(selectedHTML, \">\").concat(item.name, \"</li>\\n    \"));\n    }\n  } catch (err) {\n    _iterator.e(err);\n  } finally {\n    _iterator.f();\n  }\n  html.push('</ul>');\n  return html.join('');\n};\nvar SpeedBar_SpeedBar = /*#__PURE__*/function (_BaseComponent) {\n  function SpeedBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, SpeedBar);\n    _this = SpeedBar_callSuper(this, SpeedBar, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(SpeedBar_templateObject || (SpeedBar_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-speed class=\\\"goldplay__speed-bar\\\" title=\\\"\", \"\\\">\\n  <gp-overbox class=\\\"goldplay-hoverbox goldplay__speed-bar--box\\\">\\n  \", \"\\n  </gp-overbox>\\n  <gp-button class=\\\"goldplay__speed-bar--link\\\">\\n  \", \"\\n  </gp-button>\\n  </gp-speed>\\n  \"])), 'title', 'speedListHTML|html', 'currentSpeedName'));\n    defineProperty_default()(_this, \"data\", {\n      title: 'speed',\n      currentSpeed: 1.0,\n      speedList: null,\n      currentSpeedName: '倍速',\n      speedListHTML: ''\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    _this.speedList = _this.options.player.options.speedList || Config[\"c\" /* Config */].speedList;\n    _this.updateSpeedListHTML();\n    Object.assign(_this.data, options.data);\n    _this.init();\n    _this.initProps();\n    _this.showHideBar();\n    return _this;\n  }\n  inherits_default()(SpeedBar, _BaseComponent);\n  return createClass_default()(SpeedBar, [{\n    key: \"initProps\",\n    value: function initProps() {\n      var cssName = this.options.cssName;\n      this.$barBox = this.element.querySelector('.' + cssName.speedBarBox);\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var cssName = this.options.cssName;\n      var $container = this.options.$controlBarContainer;\n      toolkit_Delegator($container).on('mouseover', '.' + cssName.speedBar, function () {\n        clearTimeout(boxHidetimer);\n        _this2.showBarBoxHandle();\n      });\n      var _inBoxScope = function _inBoxScope(evt) {\n        var $bar = _this2.element;\n        var scope = {\n          y: _this2.$barBox.offsetTop,\n          x: $bar.offsetLeft\n        };\n        scope.width = $bar.offsetWidth;\n        scope.height = _this2.$barBox.offsetHeight;\n        if (evt.pageX > scope.x && evt.pageX < scope.x + scope.width && evt.pageY > scope.y && evt.pageY < scope.y + scope.height) {\n          return true;\n        } else {\n          return false;\n        }\n      };\n      var boxHidetimer;\n      toolkit_Delegator($container).on('mouseout', '.' + cssName.speedBar, function (evt) {\n        boxHidetimer = setTimeout(function () {\n          if (!_inBoxScope(evt)) {\n            _this2.hideBarBoxHandle();\n          } else {\n            clearTimeout(boxHidetimer);\n          }\n        }, Config[\"c\" /* Config */].hideBarBoxTime);\n      });\n      toolkit_Delegator(this.element).on('click', '[gp-node-li]', function (evt) {\n        var ele = evt.target;\n        var value = parseFloat(ele.getAttribute('value'), 10);\n        if (value === _this2.data.currentSpeed) {\n          return;\n        }\n        _this2.data.currentSpeed = value;\n        var selected = _this2.speedList.filter(function (item) {\n          return item.value === value;\n        });\n        _this2.events.emit(EventsConfig.PlayerSpeedTo, selected[0]);\n        _this2.updateSpeedListHTML();\n      });\n    }\n  }, {\n    key: \"showHideBar\",\n    value: function showHideBar() {\n      var speedList = this.speedList;\n      if (speedList.length <= 0) {\n        this.hide();\n        return;\n      }\n    }\n  }, {\n    key: \"resetBoxPosition\",\n    value: function resetBoxPosition() {\n      var marginTop = 33 + this.speedList.length * 28;\n      var marginLeft = (this.$barBox.offsetWidth - this.element.offsetWidth) / 2;\n      this.$barBox.style.marginTop = -marginTop + 'px';\n      this.$barBox.style.marginLeft = -marginLeft + 'px';\n    }\n  }, {\n    key: \"hideBarBoxHandle\",\n    value: function hideBarBoxHandle() {\n      this.$barBox.style.visibility = 'hidden';\n    }\n  }, {\n    key: \"showBarBoxHandle\",\n    value: function showBarBoxHandle() {\n      this.$barBox.style.visibility = 'visible';\n    }\n  }, {\n    key: \"updateSpeedListHTML\",\n    value: function updateSpeedListHTML(speedValue) {\n      var speedList = this.speedList;\n      if (speedList.length <= 0) {\n        return;\n      }\n      if (speedValue === undefined) {\n        speedValue = this.data.currentSpeed;\n      }\n      var list = speedList.slice(0, speedList.length).reverse();\n      var _iterator2 = SpeedBar_createForOfIteratorHelper(list),\n        _step2;\n      try {\n        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {\n          var item = _step2.value;\n          if (item.value === speedValue) {\n            item.selected = true;\n          } else {\n            delete item.selected;\n          }\n        }\n      } catch (err) {\n        _iterator2.e(err);\n      } finally {\n        _iterator2.f();\n      }\n      return this.data.speedListHTML = makeSpeedListHTML(list);\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var speed_SpeedBar = (SpeedBar_SpeedBar);\n// CONCATENATED MODULE: ../src/components/subtitle/Subtitle.js\n\n\n\n\n\n\n\nvar Subtitle_templateObject;\nfunction Subtitle_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, Subtitle_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction Subtitle_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Subtitle_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: SubtitleBar\r\n * @author: Jarry\r\n * @file: Subtitle.js\r\n */\n\n\nvar Subtitle_Subtitle = /*#__PURE__*/function (_BaseComponent) {\n  function Subtitle() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, Subtitle);\n    _this = Subtitle_callSuper(this, Subtitle, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(Subtitle_templateObject || (Subtitle_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-subtitle class=\\\"goldplay__subtitle\\\">\\n  </gp-subtitle>\\n  \"]))));\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(Subtitle, _BaseComponent);\n  return createClass_default()(Subtitle);\n}(base_BaseComponent);\n/* harmony default export */ var subtitle_Subtitle = (Subtitle_Subtitle);\n// CONCATENATED MODULE: ../src/components/rate/RateBar.js\n\n\n\n\n\n\n\nvar RateBar_templateObject;\nfunction RateBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, RateBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction RateBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (RateBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\nfunction RateBar_createForOfIteratorHelper(r, e) { var t = \"undefined\" != typeof Symbol && r[Symbol.iterator] || r[\"@@iterator\"]; if (!t) { if (Array.isArray(r) || (t = RateBar_unsupportedIterableToArray(r)) || e && r && \"number\" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError(\"Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.\"); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }\nfunction RateBar_unsupportedIterableToArray(r, a) { if (r) { if (\"string\" == typeof r) return RateBar_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return \"Object\" === t && r.constructor && (t = r.constructor.name), \"Map\" === t || \"Set\" === t ? Array.from(r) : \"Arguments\" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? RateBar_arrayLikeToArray(r, a) : void 0; } }\nfunction RateBar_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: RateBar\r\n * @author: Jarry\r\n * @file: RateBar.js\r\n */\n\n\n\n\n\nvar makeRateListHTML = function makeRateListHTML(data) {\n  if (!data) {\n    return;\n  }\n  var html = ['<ul>'];\n  var _iterator = RateBar_createForOfIteratorHelper(data),\n    _step;\n  try {\n    for (_iterator.s(); !(_step = _iterator.n()).done;) {\n      var item = _step.value;\n      var selectedClass = '';\n      var selectedHTML = '';\n      if (item.selected) {\n        selectedClass = 'gp-selected';\n        selectedHTML = \" selected=\".concat(item.selected);\n      }\n      html.push(\"\\n    <li class=\\\"\".concat(selectedClass, \"\\\" gp-node-li value=\\\"\").concat(item.value, \"\\\" \").concat(selectedHTML, \">\").concat(item.name, \"</li>\\n    \"));\n    }\n  } catch (err) {\n    _iterator.e(err);\n  } finally {\n    _iterator.f();\n  }\n  html.push('</ul>');\n  return html.join('');\n};\nvar RateBar_RateBar = /*#__PURE__*/function (_BaseComponent) {\n  function RateBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, RateBar);\n    _this = RateBar_callSuper(this, RateBar, [options]);\n    defineProperty_default()(_this, \"rateList\", []);\n    defineProperty_default()(_this, \"defaultRate\", {\n      value: '600',\n      name: '高清'\n    });\n    defineProperty_default()(_this, \"template\", _this.createTemplate(RateBar_templateObject || (RateBar_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-rate class=\\\"goldplay__rate-bar\\\" title=\\\"\", \"\\\">\\n  <gp-overbox class=\\\"goldplay-hoverbox goldplay__rate-bar--box\\\">\\n  \", \"\\n  </gp-overbox>\\n  <gp-button class=\\\"goldplay__rate-bar--link\\\">\\n  \", \"\\n  </gp-button>\\n  </gp-rate>\\n  \"])), 'title', 'rateListHTML|html', 'currentRateName'));\n    defineProperty_default()(_this, \"data\", {\n      title: 'stream rate',\n      currentRate: '600',\n      currentRateName: '高清',\n      rateListHTML: ''\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.rateList = _this.options.player.options.rateList || _this.rateList;\n    _this.defaultRate = _this.options.player.options.defaultRate || _this.defaultRate;\n    _this.setDefaultRate();\n    _this.updateRateListHTML();\n    _this.init();\n    _this.initProps();\n    _this.showHideBar();\n    return _this;\n  }\n  inherits_default()(RateBar, _BaseComponent);\n  return createClass_default()(RateBar, [{\n    key: \"initProps\",\n    value: function initProps() {\n      var cssName = this.options.cssName;\n      this.$barBox = this.element.querySelector('.' + cssName.rateBarBox);\n    }\n  }, {\n    key: \"setDefaultRate\",\n    value: function setDefaultRate() {\n      var _this2 = this;\n      if (this.rateList.length <= 0) {\n        return;\n      }\n      var currentRate = this.rateList.find(function (item) {\n        return String(item.value) === String(_this2.defaultRate.value);\n      });\n      if (currentRate) {\n        this.data.currentRateName = currentRate.name;\n        this.data.currentRate = currentRate.value;\n      } else {\n        this.data.currentRateName = this.rateList[0].name;\n        this.data.currentRate = this.rateList[0].value;\n      }\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this3 = this;\n      var cssName = this.options.cssName;\n      var $container = this.options.$controlBarContainer;\n      toolkit_Delegator($container).on('mouseover', '.' + cssName.rateBar, function () {\n        clearTimeout(boxHidetimer);\n        _this3.showBarBoxHandle();\n      });\n      var _inBoxScope = function _inBoxScope(evt) {\n        var $bar = _this3.element;\n        var scope = {\n          y: _this3.$barBox.offsetTop,\n          x: $bar.offsetLeft\n        };\n        scope.width = $bar.offsetWidth;\n        scope.height = _this3.$barBox.offsetHeight;\n        if (evt.pageX > scope.x && evt.pageX < scope.x + scope.width && evt.pageY > scope.y && evt.pageY < scope.y + scope.height) {\n          return true;\n        } else {\n          return false;\n        }\n      };\n      var boxHidetimer;\n      toolkit_Delegator($container).on('mouseout', '.' + cssName.rateBar, function (evt) {\n        boxHidetimer = setTimeout(function () {\n          if (!_inBoxScope(evt)) {\n            _this3.hideBarBoxHandle();\n          } else {\n            clearTimeout(boxHidetimer);\n          }\n        }, Config[\"c\" /* Config */].hideBarBoxTime);\n      });\n      toolkit_Delegator(this.element).on('click', '[gp-node-li]', function (evt) {\n        var ele = evt.target;\n        var value = ele.getAttribute('value');\n        if (value === _this3.data.currentRate) {\n          return;\n        }\n        _this3.data.currentRate = value;\n        var selected = _this3.rateList.filter(function (item) {\n          return item.value === value;\n        });\n        _this3.events.emit(EventsConfig.PlayerChangeRate, selected[0]);\n        _this3.data.currentRateName = selected[0].name;\n        _this3.updateRateListHTML();\n        _this3.hideBarBoxHandle();\n      });\n    }\n  }, {\n    key: \"showHideBar\",\n    value: function showHideBar() {\n      var rateList = this.rateList;\n      if (rateList && rateList.length <= 0) {\n        this.hide();\n        return;\n      }\n    }\n  }, {\n    key: \"resetBoxPosition\",\n    value: function resetBoxPosition() {\n      var marginTop = 33 + this.rateList.length * 28;\n      var marginLeft = (this.$barBox.offsetWidth - this.element.offsetWidth) / 2;\n      this.$barBox.style.marginTop = -marginTop + 'px';\n      this.$barBox.style.marginLeft = -marginLeft + 'px';\n    }\n  }, {\n    key: \"hideBarBoxHandle\",\n    value: function hideBarBoxHandle() {\n      this.$barBox.style.visibility = 'hidden';\n    }\n  }, {\n    key: \"showBarBoxHandle\",\n    value: function showBarBoxHandle() {\n      this.$barBox.style.visibility = 'visible';\n    }\n  }, {\n    key: \"updateRateListHTML\",\n    value: function updateRateListHTML(rateValue) {\n      var rateList = this.rateList;\n      if (rateList.length <= 0) {\n        return;\n      }\n      if (rateValue === undefined) {\n        rateValue = this.data.currentRate;\n      }\n      var list = rateList.slice(0, rateList.length).reverse();\n      var _iterator2 = RateBar_createForOfIteratorHelper(list),\n        _step2;\n      try {\n        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {\n          var item = _step2.value;\n          if (item.value === rateValue) {\n            item.selected = true;\n          } else {\n            delete item.selected;\n          }\n        }\n      } catch (err) {\n        _iterator2.e(err);\n      } finally {\n        _iterator2.f();\n      }\n      return this.data.rateListHTML = makeRateListHTML(list);\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var rate_RateBar = (RateBar_RateBar);\n// CONCATENATED MODULE: ../src/components/setting/SettingBar.js\n\n\n\n\n\n\n\nvar SettingBar_templateObject;\nfunction SettingBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, SettingBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction SettingBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SettingBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: SettingBar\r\n * @author: Jarry\r\n * @file: SettingBar.js\r\n */\n\n\nvar SettingBar_SettingBar = /*#__PURE__*/function (_BaseComponent) {\n  function SettingBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, SettingBar);\n    _this = SettingBar_callSuper(this, SettingBar, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(SettingBar_templateObject || (SettingBar_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-setting class=\\\"goldplay__setting-bar\\\">\\n  </gp-setting>\\n  \"]))));\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(SettingBar, _BaseComponent);\n  return createClass_default()(SettingBar);\n}(base_BaseComponent);\n/* harmony default export */ var setting_SettingBar = (SettingBar_SettingBar);\n// CONCATENATED MODULE: ../src/components/fullscreen/FullPage.js\n\n\n\n\n\n\n\nvar FullPage_templateObject, FullPage_templateObject2, FullPage_templateObject3;\nfunction FullPage_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, FullPage_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction FullPage_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (FullPage_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: FullPageBar\r\n * @author: Jarry\r\n * @file: FullPage.js\r\n */\n\n\n\n\n\nvar FULLPAGE_ICON = toolkit_Template.create(FullPage_templateObject || (FullPage_templateObject = taggedTemplateLiteral_default()([\"\\n<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" style=\\\"display:\", \"\\\" width=\\\"20\\\" height=\\\"20\\\" viewBox=\\\"0 0 24 24\\\">\\n  <path d=\\\"M2.5 4h19a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5zM5 7v10h14V7H5z\\\" fill=\\\"#f1f1f1\\\"></path>\\n</svg>\\n\"])), 'fullpageHide');\nvar FULLPAGE_EXIT_ICON = toolkit_Template.create(FullPage_templateObject2 || (FullPage_templateObject2 = taggedTemplateLiteral_default()([\"\\n<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" style=\\\"display:\", \"\\\" width=\\\"20\\\" height=\\\"20\\\" viewBox=\\\"0 0 24 24\\\">\\n<path d=\\\"M3.5 6h17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5zM6 9v6h12V9H6z\\\" fill=\\\"#f1f1f1\\\"></path>\\n</svg>\\n\"])), 'fullpageExitHide');\nvar FullPage_FullPage = /*#__PURE__*/function (_BaseComponent) {\n  function FullPage() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, FullPage);\n    _this = FullPage_callSuper(this, FullPage, [options]);\n    defineProperty_default()(_this, \"containerOriginStyle\", '');\n    defineProperty_default()(_this, \"template\", _this.createTemplate(FullPage_templateObject3 || (FullPage_templateObject3 = taggedTemplateLiteral_default()([\"\\n  <gp-button class=\\\"goldplay__control--fullpage\\\" title=\\\"\", \"\\\" data-status=\\\"\", \"\\\">\\n  \", \"\\n  </gp-button>\\n  \"])), 'title', 'status', 'icon|html'));\n    // template = this.createTemplate`\n    // <gp-button class=\"goldplay__control--fullpage\" title=\"${'title'}\" data-status=\"${'status'}\">\n    // <svg xmlns=\"http://www.w3.org/2000/svg\" style=\"display:${'fullpageHide'}\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\">\n    //   <path d=\"M2.5 4h19a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5zM5 7v10h14V7H5z\" fill=\"#f1f1f1\"></path>\n    // </svg>\n    // <svg xmlns=\"http://www.w3.org/2000/svg\" style=\"display:${'fullpageExitHide'}\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\">\n    //   <path d=\"M3.5 6h17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5zM6 9v6h12V9H6z\" fill=\"#f1f1f1\"></path>\n    // </svg>\n    // </gp-button>\n    // `\n    defineProperty_default()(_this, \"data\", {\n      fullpageHide: '',\n      fullpageExitHide: 'none',\n      // '' | fullpage | exitfullpage\n      status: '',\n      icon: FULLPAGE_ICON,\n      title: 'fullpage'\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(FullPage, _BaseComponent);\n  return createClass_default()(FullPage, [{\n    key: \"watch\",\n    value: function watch() {\n      if (this.data.status === 'fullpage') {\n        this.data.fullpageHide = 'none';\n        this.data.fullpageExitHide = 'inline-block';\n        this.data.title = 'exit fullspage';\n        this.data.icon = FULLPAGE_EXIT_ICON;\n      } else {\n        this.data.fullpageHide = 'inline-block';\n        this.data.fullpageExitHide = 'none';\n        this.data.title = 'fullpage';\n        this.data.icon = FULLPAGE_ICON;\n      }\n    }\n  }, {\n    key: \"initProps\",\n    value: function initProps() {\n      var options = this.options;\n      this.$container = this.options.$container;\n      this.$screenContainer = options.$screenContainer;\n      this.$controlBarContainer = this.getComponent('controlBarContainer').element;\n      this.originWidth = options.$container.offsetWidth;\n      this.originHeight = options.$container.offsetHeight;\n      this.containerOriginStyle = options.$container.getAttribute('style');\n      this.screenContainerOrginStyle = this.$screenContainer.getAttribute('style');\n      this.controlContainerOrginWidth = this.$controlBarContainer.style.width;\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var cssName = this.options.cssName;\n      var doc = document;\n      var win = window;\n      toolkit_Delegator(this.$controlBarContainer).on('click', '.' + cssName.fullPage, function () {\n        var status = _this2.data.status;\n        var fullScreen = _this2.getComponent('fullScreen');\n        if (fullScreen.data.status === 'fullscreen') {\n          Utils_Utils.exitFullscreen();\n        }\n        if (status === 'fullpage') {\n          _this2.exitFullPage();\n        } else {\n          _this2.fullPage();\n        }\n      });\n      this.eventsList.esckeyup = this.addEventListener(doc, 'keyup', function (evt) {\n        if (evt.keyCode === 27 && _this2.data.status === 'fullpage') {\n          _this2.exitFullPage();\n        }\n      });\n      this.eventsList.windowresize = this.addEventListener(win, 'resize', function () {\n        if (_this2.data.status === 'fullpage') {\n          var size = Utils_Utils.getInnerWidthHeight();\n          _this2.resizeTo(size.width, size.height);\n          _this2.resetPosition();\n        }\n      });\n\n      /* delay resize */\n      // let resizing = false\n      // addEventListener('resize', (evt) => {\n      //   const INTERVAL = 200\n      //   if (this.data.status === 'fullpage') {\n      //     if (!resizing) {\n      //       setTimeout( () => {\n      //         const size = Utils.getInnerWidthHeight()\n      //         this.resizeTo(size.width, size.height)\n      //         resizing = false\n      //       }, INTERVAL)\n      //     }\n      //     resizing = true\n      //   }\n      // })\n    }\n  }, {\n    key: \"fullPage\",\n    value: function fullPage() {\n      this.data.status = 'fullpage';\n      var options = this.options;\n      var cssName = this.options.cssName;\n      var size = Utils_Utils.getInnerWidthHeight();\n      this.saveOriginPosition();\n      options.$container.classList.add(cssName.containerFullPage);\n      this.resizeTo(size.width, size.height);\n      this.resetPosition();\n      scrollTo(0, 0);\n    }\n  }, {\n    key: \"saveOriginPosition\",\n    value: function saveOriginPosition() {\n      var progressBar = this.getComponent('progressBar');\n      this.posterOriginStyle = this.getComponent('poster').element.getAttribute('style');\n      this.originScroll = {\n        scrollX: scrollX,\n        scrollY: scrollY\n      };\n      this.progressBarOriginLeft = progressBar.progressBarLeft;\n      this.progressBarOriginWidth = progressBar.progressBarWidth;\n      this.progressBarPlayWidthRate = progressBar.getProgressPlayLeftWidth().offsetWidth / this.progressBarOriginWidth;\n      this.progressBarLoadWidthRate = progressBar.getProgressLoadLeftWidth().offsetWidth / this.progressBarOriginWidth;\n      this.progressBarLoadLeftRate = (progressBar.getProgressLoadLeftWidth().offsetLeft - this.progressBarOriginLeft) / this.progressBarOriginWidth;\n    }\n  }, {\n    key: \"setProgressBarPosition\",\n    value: function setProgressBarPosition() {\n      var progressBar = this.getComponent('progressBar');\n      var progressBarWidth = progressBar.progressBarWidth;\n      var progressBarLeft = progressBar.progressBarLeft;\n      var playWidth = progressBarWidth * this.progressBarPlayWidthRate;\n      var loadWidth = progressBarWidth * this.progressBarLoadWidthRate;\n      var loadRelativeLeft = progressBarWidth * this.progressBarLoadLeftRate;\n      progressBar.setProgressPosition(playWidth);\n      progressBar.setProgressLoadLeftWidth(loadRelativeLeft + progressBarLeft, loadWidth);\n      this.getComponent('progressBar').clearDragDotTop();\n    }\n  }, {\n    key: \"resizeTo\",\n    value: function resizeTo(width, height) {\n      var options = this.options;\n      var player = options.player;\n      var screenHeight = player.controlBarAutoHide ? height : height - player.controlBarHeight;\n      player.$screenContainer.style.width = width + 'px';\n      player.$screenContainer.style.height = screenHeight + 'px';\n      options.$container.style.width = width + 'px';\n      options.$container.style.height = height + 'px';\n    }\n  }, {\n    key: \"resetPosition\",\n    value: function resetPosition() {\n      var options = this.options;\n      this.setProgressBarPosition();\n      options.player.resizeScreen();\n      this.getComponent('bigPlayButton').resetPosition();\n      this.getComponent('poster').resetPosition();\n      this.getComponent('waitingBar').resetPosition();\n      this.getComponent('controlBarContainer').resetPosition();\n    }\n  }, {\n    key: \"exitFullPage\",\n    value: function exitFullPage() {\n      this.data.status = 'exitfullpage';\n      var cssName = this.options.cssName;\n      this.saveOriginPosition();\n      this.$container.classList.remove(cssName.containerFullPage);\n      this.resetScreen();\n    }\n  }, {\n    key: \"resetScreen\",\n    value: function resetScreen() {\n      this.$container.setAttribute('style', this.containerOriginStyle);\n      this.$screenContainer.setAttribute('style', this.screenContainerOrginStyle);\n      this.$controlBarContainer.style.width = this.controlContainerOrginWidth;\n      this.getComponent('poster').element.setAttribute('style', this.posterOriginStyle);\n      scrollTo(this.originScroll.scrollX, this.originScroll.scrollY);\n      this.resetPosition();\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var fullscreen_FullPage = (FullPage_FullPage);\n// CONCATENATED MODULE: ../src/components/fullscreen/FullScreen.js\n\n\n\n\n\n\n\nvar FullScreen_templateObject;\nfunction FullScreen_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, FullScreen_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction FullScreen_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (FullScreen_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: FullScreenBar\r\n * @author: Jarry\r\n * @file: FullScreenBar.js\r\n */\n\n\n\n\nvar FULLSCREEN_ICON = \"\\n<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" gid=\\\"fullscreen\\\" style=\\\"display:${'fullscreenHide'}\\\" width=\\\"20\\\" height=\\\"20\\\" viewBox=\\\"0 0 24 24\\\">\\n<path d=\\\"M15 5.057V2h6.5a.5.5 0 0 1 .5.5V9h-2.943V5.057H15zm-6 0H5.057V9H2V2.5a.5.5 0 0 1 .5-.5H9v3.057zM15 22v-2.943h4.057V15H22v6.5a.5.5 0 0 1-.5.5H15zm-6 0H2.5a.5.5 0 0 1-.5-.5V15h3.057v4.057H9V22z\\\" fill=\\\"#f1f1f1\\\"></path>\\n</svg>\\n\";\nvar FULLSCREEN_EXIT_ICON = \"\\n<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" gid=\\\"fullscreenExit\\\" style=\\\"display:${'fullscreenExitHide'}\\\"  width=\\\"20\\\" height=\\\"20\\\" viewBox=\\\"0 0 24 24\\\">\\n<path d=\\\"M22 5.943V9h-6.5a.5.5 0 0 1-.5-.5V2h2.943v3.943H22zm-20 0h3.943V2H9v6.5a.5.5 0 0 1-.5.5H2V5.943zM22 15v2.943h-4.057V22H15v-6.5a.5.5 0 0 1 .5-.5H22zM2 15h6.5a.5.5 0 0 1 .5.5V22H5.943v-4.057H2V15z\\\" fill=\\\"#f1f1f1\\\"></path>\\n</svg>\\n\";\nvar FullScreen_FullScreen = /*#__PURE__*/function (_BaseComponent) {\n  function FullScreen() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, FullScreen);\n    _this = FullScreen_callSuper(this, FullScreen, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(FullScreen_templateObject || (FullScreen_templateObject = taggedTemplateLiteral_default()([\"\\n  <gp-button class=\\\"goldplay__control--fullscreen\\\" title=\\\"\", \"\\\" data-status=\\\"\", \"\\\">\\n  \", \"\\n  </gp-button>\\n  \"])), 'title', 'status', 'icon|html'));\n    defineProperty_default()(_this, \"data\", {\n      fullscreenHide: 'inline-block',\n      fullscreenExitHide: 'none',\n      // '' | fullscreen | exitfullscreen\n      status: '',\n      icon: FULLSCREEN_ICON,\n      title: 'fullscreen'\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(FullScreen, _BaseComponent);\n  return createClass_default()(FullScreen, [{\n    key: \"watch\",\n    value: function watch() {\n      if (this.data.status === 'fullscreen') {\n        this.data.fullscreenHide = 'none';\n        this.data.fullscreenExitHide = 'inline-block';\n        this.data.title = 'exit fullscreen';\n        this.data.icon = FULLSCREEN_EXIT_ICON;\n      } else {\n        this.data.fullscreenHide = 'inline-block';\n        this.data.fullscreenExitHide = 'none';\n        this.data.title = 'fullscreen';\n        this.data.icon = FULLSCREEN_ICON;\n      }\n    }\n  }, {\n    key: \"initProps\",\n    value: function initProps() {\n      this.getComponent('fullPage').initProps.call(this);\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var $container = this.options.$container;\n      var cssName = this.options.cssName;\n      // const doc = document\n      // const win = window\n      // this.eventsList.fullscreenchange = this.addEventListener(doc, 'fullscreenchange',  () => {\n      //   if (document.fullscreenElement || document.webkitFullscreenElement) {\n      //     this.fullScreen()\n      //   } else {\n      //     const fullPage = this.getComponent('fullPage')\n      //     if (fullPage.data.status === 'fullpage') {\n      //       $container.classList.remove(cssName.containerFullScreen)\n      //       this.data.status = 'exitfullscreen'\n      //       fullPage.fullPage()\n      //     } else {\n      //       this.exitFullScreen()\n      //     }\n      //   }\n      // })\n\n      // this.eventsList.windowresize = this.addEventListener(win, 'resize', () => {\n      //   if (document.fullscreenElement) {\n      //     this.resizeTo(screen.width, screen.height - (window.outerHeight - window.innerHeight))\n      //     this.resetPosition()\n      //   }\n      // })\n\n      toolkit_Delegator(this.$controlBarContainer).on('click', '.' + cssName.fullScreen, function () {\n        var status = _this2.data.status;\n        console.error(\"fullscreen =====>\", status);\n        // this.saveOriginPosition()\n        if (status === 'fullscreen') {\n          _this2.data.status = 'exitfullscreen';\n          Utils_Utils.exitFullscreen();\n        } else {\n          _this2.data.status = 'fullscreen';\n          Utils_Utils.Fullscreen($container);\n        }\n      });\n    }\n  }, {\n    key: \"fullScreen\",\n    value: function fullScreen() {\n      this.data.status = 'fullscreen';\n      // const options = this.options\n      // const cssName = this.options.cssName\n      // const size = {\n      //   width: screen.width,\n      //   height: screen.height - (outerHeight - innerHeight)\n      // }\n      // // trick for safari (title bar height)\n      // if(Utils.isSafari()) {\n      //   size.height = size.height + 38\n      // }\n      // options.$container.classList.add(cssName.containerFullScreen)\n      // this.resizeTo(size.width, size.height)\n      // this.resetPosition()\n      // scrollTo(0, 0)\n    }\n  }, {\n    key: \"saveOriginPosition\",\n    value: function saveOriginPosition() {\n      // this.getComponent('fullPage').saveOriginPosition.call(this)\n    }\n  }, {\n    key: \"resizeTo\",\n    value: function resizeTo(width, height) {\n      // this.getComponent('fullPage').resizeTo.call(this, width, height)\n    }\n  }, {\n    key: \"resetPosition\",\n    value: function resetPosition() {\n      // this.getComponent('fullPage').resetPosition.call(this)\n    }\n  }, {\n    key: \"setProgressBarPosition\",\n    value: function setProgressBarPosition() {\n      // this.getComponent('fullPage').setProgressBarPosition.call(this)\n    }\n  }, {\n    key: \"exitFullScreen\",\n    value: function exitFullScreen() {\n      this.data.status = 'exitfullscreen';\n      // const cssName = this.options.cssName\n      // this.saveOriginPosition()\n      // this.options.$container.classList.remove(cssName.containerFullScreen)\n      // this.resetScreen()\n      // this.saveOriginPosition()\n    }\n  }, {\n    key: \"resetScreen\",\n    value: function resetScreen() {\n      // this.getComponent('fullPage').resetScreen.call(this)\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var fullscreen_FullScreen = (FullScreen_FullScreen);\n// CONCATENATED MODULE: ../src/components/control/BigPlayButton.js\n\n\n\n\n\n\n\nvar BigPlayButton_templateObject, BigPlayButton_templateObject2;\nfunction BigPlayButton_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, BigPlayButton_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction BigPlayButton_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (BigPlayButton_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: First Play Button\r\n * @author: Jarry\r\n * @file: BigPlayButton.js\r\n */\n\n\n\n\n\nvar BIGPLAY_ICON = toolkit_Template.create(BigPlayButton_templateObject || (BigPlayButton_templateObject = taggedTemplateLiteral_default()([\"<svg version=\\\"1.1\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" xmlns:xlink=\\\"http://www.w3.org/1999/xlink\\\" x=\\\"0px\\\" y=\\\"0px\\\"\\nwidth=\\\"\", \"\\\" height=\\\"\", \"\\\" viewBox=\\\"0 0 438.533 438.533\\\" style=\\\"\", \"\\\" xml:space=\\\"preserve\\\">\\n<g>\\n<path d=\\\"M409.133,109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736,9.801,259.058,0,219.273,0\\n c-39.781,0-76.466,9.801-110.063,29.407c-33.595,19.604-60.192,46.201-79.8,79.796C9.801,142.8,0,179.489,0,219.267\\n s9.804,76.463,29.407,110.062c19.607,33.585,46.204,60.189,79.799,79.798c33.597,19.605,70.283,29.407,110.063,29.407\\n s76.47-9.802,110.065-29.407c33.593-19.602,60.189-46.206,79.795-79.798c19.603-33.599,29.403-70.287,29.403-110.062\\n C438.533,179.489,428.732,142.795,409.133,109.203z M328.904,234.966L173.588,326.33c-2.856,1.711-5.902,2.567-9.136,2.567\\n c-3.045,0-6.09-0.764-9.135-2.286c-6.09-3.614-9.136-8.939-9.136-15.985V127.907c0-7.041,3.046-12.371,9.136-15.987\\n c6.28-3.427,12.369-3.333,18.271,0.284l155.316,91.36c6.088,3.424,9.134,8.663,9.134,15.703\\n C338.038,226.308,334.992,231.537,328.904,234.966z\\\" fill=\\\"\", \"\\\">\\n</g>\\n</svg>\\n\"])), 'width', 'height', 'iconStyle', 'fillColor');\nvar PLAY_BUTTON_COLOR = '#999';\nvar BigPlayButton_BigPlayButton = /*#__PURE__*/function (_BaseComponent) {\n  function BigPlayButton() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, BigPlayButton);\n    _this = BigPlayButton_callSuper(this, BigPlayButton, [options]);\n    defineProperty_default()(_this, \"template\", _this.createTemplate(BigPlayButton_templateObject2 || (BigPlayButton_templateObject2 = taggedTemplateLiteral_default()([\"\\n  <gp-button class=\\\"goldplay__screen--bigplay\\\" title=\\\"\", \"\\\" data-status=\\\"\", \"\\\">\\n  \", \"\\n  </gp-button>\\n  \"])), 'title', 'status', 'icon|html'));\n    defineProperty_default()(_this, \"data\", {\n      titie: 'click to play',\n      iconStyle: 'opacity:0.5',\n      display: 'hide',\n      status: '',\n      width: 100,\n      height: 100,\n      fillColor: PLAY_BUTTON_COLOR,\n      icon: BIGPLAY_ICON\n    });\n    defineProperty_default()(_this, \"options\", {});\n    _this.options = options;\n    Object.assign(_this.data, options.data);\n    _this.init();\n    return _this;\n  }\n  inherits_default()(BigPlayButton, _BaseComponent);\n  return createClass_default()(BigPlayButton, [{\n    key: \"watch\",\n    value: function watch() {\n      if (this.data.display === 'show') {\n        var height = this.element.parentNode.offsetHeight;\n        var marginTop = (height - this.data.height) / 2;\n        this.data.iconStyle = \"opacity:0.7;margin-top:\".concat(marginTop, \"px\");\n      }\n    }\n  }, {\n    key: \"resetPosition\",\n    value: function resetPosition() {\n      if (this.data.display === 'show') {\n        var parentNode = this.element.parentNode;\n        var width = parentNode.offsetWidth;\n        var height = parentNode.offsetHeight;\n        if (this.options.player.controlBarAutoHide === true) {\n          height -= this.options.player.controlBarHeight;\n        }\n        var top = parentNode.offsetTop;\n        var left = parentNode.offsetLeft;\n        this.element.style.width = width + 'px';\n        this.element.style.height = height + 'px';\n        this.element.style.top = top + 'px';\n        this.element.style.left = left + 'px';\n      }\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      var $container = this.options.$screenContainer;\n      var cssName = this.options.cssName;\n      toolkit_Delegator($container).on('click', '.' + cssName.bigPlayButton, function () {\n        _this2.events.emit(EventsConfig.PlayerOnPlay, _this2);\n        _this2.events.emit(EventsConfig.ControlBarPlay, _this2);\n        _this2.hide();\n      });\n      toolkit_Delegator($container).on('mouseover', '.' + cssName.bigPlayButton, function () {\n        _this2.data.fillColor = _this2.options.bigPlayButtonColor || '#fff';\n      });\n      toolkit_Delegator($container).on('mouseout', '.' + cssName.bigPlayButton, function (evt) {\n        var $ele = _this2.element;\n        var scope = {\n          y: $ele.offsetTop,\n          x: $ele.offsetLeft\n        };\n        scope.width = $ele.offsetWidth;\n        scope.height = $ele.offsetHeight;\n        if (evt.pageX > scope.x && evt.pageX < scope.x + scope.width && evt.pageY > scope.y && evt.pageY < scope.y + scope.height) {\n          return;\n        } else {\n          _this2.data.fillColor = PLAY_BUTTON_COLOR;\n        }\n      });\n    }\n  }, {\n    key: \"show\",\n    value: function show() {\n      var _this3 = this;\n      if (this.data.display !== 'show') {\n        this.data.display = 'show';\n        this.element.style.opacity = '1';\n        setTimeout(function () {\n          _this3.element.style.display = 'inline-block';\n        }, 1);\n      }\n    }\n  }, {\n    key: \"hide\",\n    value: function hide() {\n      if (this.data.display !== 'hide') {\n        this.element.style.opacity = '0';\n        this.data.display = 'hide';\n        this.element.style.display = 'none';\n      }\n    }\n  }]);\n}(base_BaseComponent);\n/* harmony default export */ var control_BigPlayButton = (BigPlayButton_BigPlayButton);\n// CONCATENATED MODULE: ../src/components/control/PlayControl.js\n\n\n\n\n\n\nfunction PlayControl_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, PlayControl_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction PlayControl_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (PlayControl_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n\n\nvar PlayControl_PlayControl = /*#__PURE__*/function (_BaseComponent) {\n  function PlayControl() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, PlayControl);\n    _this = PlayControl_callSuper(this, PlayControl, [options]);\n    _this.options = Object.assign(_this.options, options);\n    _this.componentsController = _this.options.componentsController;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(PlayControl, _BaseComponent);\n  return createClass_default()(PlayControl, [{\n    key: \"render\",\n    value: function render() {\n      var _this2 = this;\n      var el = Element_Element.createEl('gp-button-block');\n      el.classList.add('goldplay__control--button-block');\n      PlayControl.componentList.forEach(function (item) {\n        var com = _this2.componentsController.getComponent(item);\n        el.appendChild(com.element);\n      });\n      this.element = el;\n    }\n  }], [{\n    key: \"addCustomControl\",\n    value: function addCustomControl(name) {\n      PlayControl.componentList.push(name);\n    }\n  }]);\n}(base_BaseComponent);\ndefineProperty_default()(PlayControl_PlayControl, \"componentList\", ['playButton', 'pauseButton', 'replayButton']);\n/* harmony default export */ var control_PlayControl = (PlayControl_PlayControl);\n// CONCATENATED MODULE: ../src/control-bar/SideControlBar.js\n\n\n\n\n\n\nfunction SideControlBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, SideControlBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction SideControlBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (SideControlBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n\n\nvar SideControlBar_SideControlBar = /*#__PURE__*/function (_BaseComponent) {\n  function SideControlBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, SideControlBar);\n    _this = SideControlBar_callSuper(this, SideControlBar, [options]);\n    _this.options = Object.assign(_this.options, options);\n    _this.componentsController = _this.options.componentsController;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(SideControlBar, _BaseComponent);\n  return createClass_default()(SideControlBar, [{\n    key: \"render\",\n    value: function render() {\n      var _this2 = this;\n      var el = Element_Element.createEl('gp-control-sidebar');\n      el.classList.add('goldplay__control--sidebar');\n      SideControlBar.componentList.forEach(function (item) {\n        var com = _this2.componentsController.getComponent(item);\n        el.appendChild(com.element);\n      });\n      this.element = el;\n    }\n  }], [{\n    key: \"addCustomControl\",\n    value: function addCustomControl(name, index) {\n      if (index < 0 || index > SideControlBar.componentList.length) {\n        index = SideControlBar.componentList.length;\n      }\n      SideControlBar.componentList.splice(index, 0, name);\n    }\n  }]);\n}(base_BaseComponent);\ndefineProperty_default()(SideControlBar_SideControlBar, \"componentList\", ['speedBar', 'rateBar', 'volumeBar', 'fullPage', 'fullScreen']);\n/* harmony default export */ var control_bar_SideControlBar = (SideControlBar_SideControlBar);\n// CONCATENATED MODULE: ../src/control-bar/NearControlBar.js\n\n\n\n\n\n\nfunction NearControlBar_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, NearControlBar_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction NearControlBar_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (NearControlBar_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n\n\nvar NearControlBar_NearControlBar = /*#__PURE__*/function (_BaseComponent) {\n  function NearControlBar() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, NearControlBar);\n    _this = NearControlBar_callSuper(this, NearControlBar, [options]);\n    _this.options = Object.assign(_this.options, options);\n    _this.componentsController = _this.options.componentsController;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(NearControlBar, _BaseComponent);\n  return createClass_default()(NearControlBar, [{\n    key: \"render\",\n    value: function render() {\n      var _this2 = this;\n      var el = Element_Element.createEl('gp-control-nearside');\n      el.classList.add('goldplay__control--button-block');\n      NearControlBar.componentList.forEach(function (item) {\n        var com = _this2.componentsController.getComponent(item);\n        el.appendChild(com.element);\n      });\n      this.element = el;\n    }\n  }], [{\n    key: \"addCustomControl\",\n    value: function addCustomControl(name, index) {\n      if (index < 0 || index > NearControlBar.componentList.length) {\n        index = NearControlBar.componentList.length;\n      }\n      NearControlBar.componentList.splice(index, 0, name);\n    }\n  }]);\n}(base_BaseComponent);\ndefineProperty_default()(NearControlBar_NearControlBar, \"componentList\", ['playControl', 'timer']);\n/* harmony default export */ var control_bar_NearControlBar = (NearControlBar_NearControlBar);\n// CONCATENATED MODULE: ../src/config/ComponentConfig.js\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file ComponentConfig.js\r\n * @desc\r\n * component config\r\n * @author Jarry\r\n */\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nvar CONPONENTS_MAP = {\n  BaseComponent: base_BaseComponent,\n  controlBarContainer: control_bar_Container,\n  bigPlayButton: control_BigPlayButton,\n  poster: screen_Poster,\n  progressBar: progress_ProgressBar,\n  playButton: control_PlayButton,\n  pauseButton: control_PauseButton,\n  replayButton: control_ReplayButton,\n  volumeBar: volume_VolumeBar,\n  waitingBar: tips_WaitingBar,\n  alertBox: tips_AlertBox,\n  timer: timer_Timer,\n  speedBar: speed_SpeedBar,\n  subtitle: subtitle_Subtitle,\n  rateBar: rate_RateBar,\n  settingBar: setting_SettingBar,\n  fullPage: fullscreen_FullPage,\n  fullScreen: fullscreen_FullScreen,\n  playControl: control_PlayControl,\n  sideControlBar: control_bar_SideControlBar,\n  nearControlBar: control_bar_NearControlBar\n};\n\n// CONCATENATED MODULE: ../src/components/ComponentsController.js\n\n\n\n\n\n\nfunction ComponentsController_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, ComponentsController_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction ComponentsController_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ComponentsController_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file ComponentsController.js\r\n * @desc\r\n * components controller\r\n * @see\r\n * @author Jarry\r\n */\n\n\n\n\n\nvar ComponentsController_cssName = CSSConfig;\nvar covertFirstUpperCase = function covertFirstUpperCase(str) {\n  var first = str.substr(0, 1);\n  return first.toUpperCase() + str.substr(1);\n};\nvar ComponentsController_ComponentsController = /*#__PURE__*/function (_BaseController) {\n  function ComponentsController() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, ComponentsController);\n    _this = ComponentsController_callSuper(this, ComponentsController, [options]);\n    defineProperty_default()(_this, \"allComponents\", {});\n    defineProperty_default()(_this, \"controlBarController\", null);\n    defineProperty_default()(_this, \"options\", {\n      cssName: ComponentsController_cssName\n    });\n    _this.options = Object.assign(_this.options, options);\n    _this.options.componentsController = _this;\n    _this.initComponents();\n    _this.$container = _this.options.$container, _this.$screenContainer = _this.options.$screenContainer, _this.$canvas = _this.options.$canvas, _this.$audioContainer = _this.options.$audioContainer, _this.$audio = _this.options.$audio, _this.options.$controlBarContainer = _this.controlBarContainer.element;\n    _this.bindEvent();\n    return _this;\n  }\n  inherits_default()(ComponentsController, _BaseController);\n  return createClass_default()(ComponentsController, [{\n    key: \"run\",\n    value: function run() {\n      var that = this;\n      this.controlBarController && this.controlBarController.run();\n      // add to register new component method\n      for (var key in CONPONENTS_MAP) {\n        if (that[key] && typeof that[key].registerMethod === 'function') {\n          that[key].registerMethod();\n        }\n      }\n    }\n  }, {\n    key: \"initComponents\",\n    value: function initComponents() {\n      for (var componentName in CONPONENTS_MAP) {\n        var Clazz = CONPONENTS_MAP[componentName];\n        if (!this.allComponents[componentName]) {\n          this.createComponent(Clazz, componentName);\n        }\n      }\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.PlayerLoadedMetaData, function () {\n        _this2.poster.hide();\n      });\n      this.events.on(EventsConfig.AudioPlayerPlayFail, function () {\n        if (_this2.options.isShowControl == undefined || _this2.options.isShowControl) {\n          _this2.drawBigPlayButton();\n        }\n        _this2.getComponent('poster').hide();\n        console.error(\"bindEvent===>\");\n        _this2.events.emit(EventsConfig.PlayerOnPause, _this2);\n        _this2.events.emit(EventsConfig.ControlBarPause, _this2);\n      });\n      this.bindAlertBoxEvent();\n      this.bindWaitingBarEvent();\n    }\n  }, {\n    key: \"bindWaitingBarEvent\",\n    value: function bindWaitingBarEvent() {\n      this.waitingBar.initProps();\n      this.waitingBar.bindEvent();\n    }\n  }, {\n    key: \"drawBigPlayButton\",\n    value: function drawBigPlayButton() {\n      this.$screenContainer.prepend(this.bigPlayButton.element);\n      this.bigPlayButton.show();\n      this.bigPlayButton.bindEvent();\n      this.bigPlayButton.resetPosition();\n    }\n  }, {\n    key: \"setControlBarController\",\n    value: function setControlBarController(controller) {\n      this.controlBarController = controller;\n    }\n  }, {\n    key: \"getControlBarController\",\n    value: function getControlBarController() {\n      return this.controlBarController || this.options.player.controlBarContainer;\n    }\n  }, {\n    key: \"bindAlertBoxEvent\",\n    value: function bindAlertBoxEvent() {\n      this.alertBox.initProps();\n      this.alertBox.bindEvent();\n    }\n  }, {\n    key: \"drawPoster\",\n    value: function drawPoster() {\n      this.$screenContainer.prepend(this.poster.element);\n      this.poster.data.display = 'show';\n      this.poster.bindEvent();\n      this.poster.resetPosition();\n    }\n  }, {\n    key: \"createComponent\",\n    value: function createComponent(Clazz, componentName) {\n      var upperCaseName = covertFirstUpperCase(componentName);\n      this['set' + upperCaseName](new Clazz(this.options));\n      this[componentName] = this['get' + upperCaseName]();\n      if (!this.allComponents[componentName]) {\n        this.allComponents[componentName] = this[componentName];\n      }\n    }\n  }, {\n    key: \"getComponent\",\n    value: function getComponent(name) {\n      if (!this.allComponents[name]) {\n        if (CONPONENTS_MAP[name]) {\n          this.createComponent(CONPONENTS_MAP[name], name);\n        }\n      }\n      return this.allComponents[name];\n    }\n  }, {\n    key: \"resetAllComponents\",\n    value: function resetAllComponents() {\n      var _this3 = this;\n      var keys = Object.getOwnPropertyNames(this);\n      var result = {};\n      keys.forEach(function (key) {\n        if (CONPONENTS_MAP[key]) {\n          result[key] = _this3[key];\n        }\n      });\n      this.allComponents = result;\n    }\n  }, {\n    key: \"getAllComponents\",\n    value: function getAllComponents() {\n      return this.allComponents;\n    }\n  }]);\n}(base_BaseController);\nComponentsController_ComponentsController.addComponet = function (componentName) {\n  var upperCaseName = covertFirstUpperCase(componentName);\n  ComponentsController_ComponentsController.prototype['set' + upperCaseName] = function (component) {\n    this[componentName] = component;\n  };\n  ComponentsController_ComponentsController.prototype['get' + upperCaseName] = function () {\n    return this[componentName];\n  };\n};\nfor (var ComponentsController_componentName in CONPONENTS_MAP) {\n  ComponentsController_ComponentsController.addComponet(ComponentsController_componentName);\n}\n/* harmony default export */ var components_ComponentsController = (ComponentsController_ComponentsController);\n// CONCATENATED MODULE: ../src/control-bar/ControlBarController.js\n\n\n\n\n\n\nfunction ControlBarController_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, ControlBarController_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction ControlBarController_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ControlBarController_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @file ControlBar.js\r\n * @desc\r\n * the player pannel and control's facade\r\n * @see\r\n * @author Jarry\r\n */\n\n\n\n\n\nvar ControlBarController_cssName = CSSConfig;\nvar ControlBarController_ControlBarController = /*#__PURE__*/function (_BaseController) {\n  function ControlBarController() {\n    var _this;\n    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n    classCallCheck_default()(this, ControlBarController);\n    _this = ControlBarController_callSuper(this, ControlBarController, [options]);\n    defineProperty_default()(_this, \"player\", null);\n    defineProperty_default()(_this, \"dataManage\", null);\n    defineProperty_default()(_this, \"options\", {\n      cssName: ControlBarController_cssName\n    });\n    _this.options = Object.assign(_this.options, options);\n    _this.player = _this.options.player;\n    _this.dataManage = _this.player.dataManage;\n    _this.componentsController = _this.player.componentsController;\n    _this.$screenContainer = _this.player.$screenContainer;\n    _this.initComponents();\n    return _this;\n  }\n  inherits_default()(ControlBarController, _BaseController);\n  return createClass_default()(ControlBarController, [{\n    key: \"initComponents\",\n    value: function initComponents() {\n      var componentsController = this.componentsController;\n      Object.assign(this, componentsController.getAllComponents());\n      this.container = this.controlBarContainer;\n    }\n  }, {\n    key: \"run\",\n    value: function run() {\n      this.timer.setTotalTime(this.dataManage);\n      this.drawLayout();\n      this.bindEvent();\n      if (!this.player.autoPlay) {\n        this.events.emit(EventsConfig.ControlBarPause);\n      } else {\n        this.events.emit(EventsConfig.ControlBarPlay);\n      }\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      this.bindContainerEvent();\n      this.bindTimerEvent();\n      this.bindPlayEvent();\n      this.bindProgressEvent();\n      this.bindSpeedEvent();\n      this.bindRateEvent();\n      this.bindVolumeEvent();\n      this.bindFullPage();\n      this.bindFullScreen();\n    }\n  }, {\n    key: \"bindContainerEvent\",\n    value: function bindContainerEvent() {\n      this.container.initProps();\n      this.container.bindEvent();\n    }\n  }, {\n    key: \"bindTimerEvent\",\n    value: function bindTimerEvent() {\n      this.timer.initProps();\n      this.timer.bindEvent();\n    }\n  }, {\n    key: \"bindSpeedEvent\",\n    value: function bindSpeedEvent() {\n      this.speedBar.bindEvent();\n      this.speedBar.resetBoxPosition();\n    }\n  }, {\n    key: \"bindRateEvent\",\n    value: function bindRateEvent() {\n      this.rateBar.bindEvent();\n      this.rateBar.resetBoxPosition();\n    }\n  }, {\n    key: \"bindFullPage\",\n    value: function bindFullPage() {\n      this.fullPage.initProps();\n      this.fullPage.bindEvent();\n    }\n  }, {\n    key: \"bindFullScreen\",\n    value: function bindFullScreen() {\n      this.fullScreen.initProps();\n      this.fullScreen.bindEvent();\n    }\n  }, {\n    key: \"bindPlayEvent\",\n    value: function bindPlayEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.ControlBarPlay, function () {\n        if (_this2.pauseButton.data.status !== 'pause') {\n          _this2.pauseButton.data.status = 'pause';\n        }\n        _this2.replayButton.hide();\n        _this2.playButton.hide();\n        _this2.pauseButton.show();\n        _this2.bigPlayButton.hide();\n      });\n      this.events.on(EventsConfig.ControlBarPause, function () {\n        if (_this2.player.status !== 'pause') {\n          _this2.pauseButton.data.status = 'pause';\n        }\n        _this2.playButton.show();\n        _this2.pauseButton.hide();\n      });\n      this.events.on(EventsConfig.PlayerEnd, function () {\n        _this2.replayButton.show();\n        _this2.pauseButton.hide();\n        _this2.playButton.hide();\n      });\n      var eventsArr = [EventsConfig.PlayerWait, EventsConfig.PlayerSeeking, EventsConfig.PlayerReset, EventsConfig.PlayerChangeRate, EventsConfig.PlayerChangeSrc];\n      eventsArr.forEach(function (item) {\n        _this2.events.on(item, function () {\n          _this2.waitingBar.showWaiting();\n        });\n      });\n      this.events.on(EventsConfig.PlayerSeekEnd, function () {\n        _this2.waitingBar.hideWaiting();\n      });\n      this.events.on(EventsConfig.PlayerPlay, function () {\n        _this2.waitingBar.hideWaiting();\n        _this2.events.emit(EventsConfig.ControlBarPlay, _this2);\n      });\n      this.events.on(EventsConfig.PlayerPause, function () {\n        _this2.events.emit(EventsConfig.ControlBarPause, _this2);\n      });\n      this.events.on(EventsConfig.PlayerPlaying, function () {\n        _this2.waitingBar.hideWaiting();\n      });\n      this.events.on(EventsConfig.PlayerOnSeek, function (time) {\n        var duration = _this2.dataManage.sourceData.duration;\n        if (time < duration * 1000) {\n          _this2.events.emit(EventsConfig.ControlBarPauseLoading);\n        }\n      });\n      this.events.on(EventsConfig.ControlBarPauseLoading, function () {\n        if (_this2.pauseButton.data.status !== 'pauseloading') {\n          _this2.pauseButton.data.status = 'pauseloading';\n        }\n        _this2.replayButton.hide();\n        _this2.playButton.hide();\n        _this2.pauseButton.show();\n      });\n      toolkit_Delegator(this.options.$container).on('click', '.' + ControlBarController_cssName.playButton, function () {\n        if (_this2.player.status !== 'play') {\n          _this2.events.emit(EventsConfig.PlayerOnPlay, _this2);\n        }\n      });\n      toolkit_Delegator(this.options.$container).on('click', '.' + ControlBarController_cssName.pauseButton, function () {\n        if (_this2.player.status !== 'pause') {\n          _this2.events.emit(EventsConfig.PlayerOnPause, _this2);\n        }\n      });\n      toolkit_Delegator(this.options.$container).on('click', '.' + ControlBarController_cssName.replayButton, function () {\n        _this2.events.emit(EventsConfig.PlayerOnSeek, _this2.player.startTime);\n      });\n    }\n  }, {\n    key: \"bindProgressEvent\",\n    value: function bindProgressEvent() {\n      this.progressBar.initProps();\n      this.progressBar.bindEvent();\n    }\n  }, {\n    key: \"bindVolumeEvent\",\n    value: function bindVolumeEvent() {\n      this.volumeBar.initProps();\n      this.volumeBar.initVolumeSize();\n      this.volumeBar.bindEvent();\n    }\n  }, {\n    key: \"drawLayout\",\n    value: function drawLayout() {\n      var $container = this.options.$container;\n      var $box = this.container.element;\n      $container.append($box);\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      this.removeEventListenerGlobal();\n      this.container.destroy();\n    }\n  }, {\n    key: \"removeEventListenerGlobal\",\n    value: function removeEventListenerGlobal() {\n      if (this.progressBar.progressDragEvent) {\n        this.progressBar.progressDragEvent.removeEventListenerAll();\n      }\n      if (this.volumeBar.volumeDragEvent) {\n        this.volumeBar.volumeDragEvent.removeEventListenerAll();\n      }\n      this.fullPage.removeEventListenerAll();\n      this.fullScreen.removeEventListenerAll();\n    }\n  }]);\n}(base_BaseController);\n/* harmony default export */ var control_bar_ControlBarController = (ControlBarController_ControlBarController);\n// EXTERNAL MODULE: ../node_modules/webworkify-webpack/index.js\nvar webworkify_webpack = __webpack_require__(42);\nvar webworkify_webpack_default = /*#__PURE__*/__webpack_require__.n(webworkify_webpack);\n\n// CONCATENATED MODULE: ../src/data-processor/dataProcessorController.js\n\n\n\n\n\n\nfunction dataProcessorController_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, dataProcessorController_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction dataProcessorController_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (dataProcessorController_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: demux and decode \r\n * @author: liuliguo \r\n * @file: dataProcessorController.js\r\n */\n\n\n\nvar dataProcessorController_DataProcessorController = /*#__PURE__*/function (_BaseClass) {\n  function DataProcessorController(options) {\n    var _this;\n    classCallCheck_default()(this, DataProcessorController);\n    _this = dataProcessorController_callSuper(this, DataProcessorController, [options]);\n    defineProperty_default()(_this, \"isLast\", false);\n    _this.type = options.type;\n    _this.libPath = options.libPath;\n    _this.player = options.player;\n    _this.init();\n    return _this;\n  }\n  inherits_default()(DataProcessorController, _BaseClass);\n  return createClass_default()(DataProcessorController, [{\n    key: \"init\",\n    value: function init() {\n      var type = this.type;\n      if (type == 'ts') {\n        this.initNornalWorker();\n      }\n      this.bindEvent();\n      this.loadjs();\n    }\n  }, {\n    key: \"initNornalWorker\",\n    value: function initNornalWorker() {\n      this.processor = this.initWorker();\n    }\n  }, {\n    key: \"initWorker\",\n    value: function initWorker() {\n      var _this2 = this;\n      var processor = webworkify_webpack_default()(/*require.resolve*/(129));\n      processor.onmessage = function (event) {\n        var workerData = event.data;\n        var type = workerData.type;\n        var data = workerData.data;\n        switch (type) {\n          case 'dataProcessorReady':\n            _this2.onDataProcessorReady();\n            break;\n          case 'decoded':\n            _this2.onDecoded(data);\n            break;\n          case 'demuxedAAC':\n            _this2.onDemuxedAAC(data);\n            break;\n          case 'partEnd':\n            _this2.onPartEnd(data);\n            break;\n          case 'resetEnd':\n            _this2.onResetEnd();\n            break;\n          case 'maxPTS':\n            _this2.onMaxPTS(data);\n            break;\n          case 'flushEnd':\n            _this2.onFlushEnd(data);\n            break;\n        }\n      };\n      return processor;\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this3 = this;\n      this.events.on(EventsConfig.DemuxStartDemux, this.onStartDemux.bind(this));\n      this.events.on(EventsConfig.DemuxLast, function () {\n        _this3.isLast = true;\n      });\n      this.events.on(EventsConfig.DecodeFlush, function () {\n        _this3.flush();\n      });\n    }\n  }, {\n    key: \"flush\",\n    value: function flush() {\n      this.processor.postMessage({\n        type: 'flush'\n      });\n    }\n  }, {\n    key: \"loadjs\",\n    value: function loadjs() {\n      this.processor.postMessage({\n        type: 'loadwasm',\n        libPath: this.libPath\n      });\n    }\n  }, {\n    key: \"reset\",\n    value: function reset() {\n      this.isLast = false;\n      this.processor.terminate();\n      this.initNornalWorker();\n      this.loadjs();\n    }\n  }, {\n    key: \"onFlushEnd\",\n    value: function onFlushEnd(data) {\n      this.events.emit(EventsConfig.DecodeFlushEnd, data);\n    }\n  }, {\n    key: \"onMaxPTS\",\n    value: function onMaxPTS(data) {\n      this.events.emit(EventsConfig.PlayerMaxPTS, data.maxAudioPTS, data.maxVideoPTS);\n    }\n  }, {\n    key: \"onDemuxedAAC\",\n    value: function onDemuxedAAC(pes) {\n      this.events.emit(EventsConfig.DemuxAAC, pes);\n    }\n  }, {\n    key: \"onDataProcessorReady\",\n    value: function onDataProcessorReady() {\n      if (this.player.seeking || this.player.reseting) {\n        this.events.emit(EventsConfig.ProcessorResetEnd);\n      } else {\n        this.events.emit(EventsConfig.DataProcessorReady);\n      }\n    }\n  }, {\n    key: \"onStartDemux\",\n    value: function onStartDemux(data) {\n      if (this.player.reseting) {\n        return;\n      }\n      this.logger.info('onStartDemux', 'postMessage to demux');\n      if (data && data.arrayBuffer) {\n        this.processor.postMessage({\n          type: 'startDemux',\n          data: data.arrayBuffer,\n          isLast: this.isLast\n        }, [data.arrayBuffer.buffer]);\n      } else {\n        this.logger.error('onStartDemux', 'data is null', 'data:', data);\n      }\n    }\n  }, {\n    key: \"onDecoded\",\n    value: function onDecoded(data) {\n      if (this.player.reseting) {\n        return;\n      }\n      this.events.emit(EventsConfig.DecodeDecoded, data);\n    }\n  }, {\n    key: \"onPartEnd\",\n    value: function onPartEnd(data) {\n      this.events.emit(EventsConfig.DecodeApppendEnd, data);\n    }\n  }, {\n    key: \"onResetEnd\",\n    value: function onResetEnd() {\n      this.events.emit(EventsConfig.ProcessorResetEnd);\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      if (this.processor) {\n        this.processor.terminate();\n      }\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/action/StreamController.js\n\n\n\n\n\n\nfunction StreamController_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, StreamController_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction StreamController_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (StreamController_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: the player main stream controller, start demux and decode, load next ts packet\r\n * @author: liuliguo \r\n * @file: StreamController.js\r\n */\n\n\n\nvar StreamController_StreamController = /*#__PURE__*/function (_BaseClass) {\n  function StreamController(options) {\n    var _this;\n    classCallCheck_default()(this, StreamController);\n    _this = StreamController_callSuper(this, StreamController, [options]);\n    defineProperty_default()(_this, \"currentIndex\", null);\n    defineProperty_default()(_this, \"retryTime\", 0);\n    defineProperty_default()(_this, \"dataReady\", {\n      audioReady: false,\n      imageReady: false\n    });\n    defineProperty_default()(_this, \"hasInit\", false);\n    defineProperty_default()(_this, \"dataManageStatus\", 'loading');\n    defineProperty_default()(_this, \"duration\", 0);\n    defineProperty_default()(_this, \"tsNumber\", 0);\n    _this.dataManage = options.dataManage;\n    _this.imagePlayer = options.imagePlayer;\n    _this.audioPlayer = options.audioPlayer;\n    _this.player = options.player;\n    _this.bindEvent();\n    return _this;\n  }\n  inherits_default()(StreamController, _BaseClass);\n  return createClass_default()(StreamController, [{\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.DataManageRead, function (data) {\n        _this2.onRead(data);\n      });\n      this.events.on(EventsConfig.DemuxVideo, function (data, isLast) {\n        _this2.onVideoDemuxed(data, isLast);\n      });\n      this.events.on(EventsConfig.DemuxAAC, function (data) {\n        _this2.onAACDemuxed(data);\n      });\n      this.events.on(EventsConfig.DecodeDecoded, function (data) {\n        _this2.onDecoded(data);\n      });\n      this.events.on(EventsConfig.DecodeApppendEnd, function (data) {\n        _this2.onAppendEnd(data);\n      });\n      this.events.on(EventsConfig.ImagePlayerReady, function () {\n        _this2.logger.info('bindevent', 'Events.ImagePlayerReady');\n        _this2.checkDataReady('imageReady');\n      });\n      this.events.on(EventsConfig.AudioPlayerDataReady, function () {\n        _this2.logger.info('bindevent', 'Events.AudioPlayerDataReady');\n        _this2.player.receiveAACTime = null;\n        _this2.checkDataReady('audioReady');\n      });\n      this.events.on(EventsConfig.AudioPlayerWait, function () {\n        _this2.dataReady.audioReady = false;\n        _this2.events.emit(EventsConfig.PlayerWait, 'audioPlayer');\n      });\n      this.events.on(EventsConfig.ImagePlayerWait, function () {\n        _this2.dataReady.imageReady = false;\n        _this2.events.emit(EventsConfig.PlayerWait, 'imagePlayer');\n      });\n      this.events.on(EventsConfig.ImagePlayerEnd, function () {\n        _this2.logger.info('bindevent', '........imageplayer end');\n        _this2.events.emit(EventsConfig.PlayerEnd);\n      });\n      this.events.on(EventsConfig.PlayerWait, function () {\n        _this2.logger.warn('player status wait');\n        _this2.player.status = 'wait';\n        if (_this2.dataManageStatus === 'loadend') {\n          _this2.dataManageStatus = 'loading';\n          _this2.loadNext();\n        }\n      });\n      this.events.on(EventsConfig.PlayerLoadNext, function () {\n        if (_this2.dataManageStatus === 'loadend') {\n          _this2.dataManageStatus = 'loading';\n          _this2.loadNext();\n        }\n      });\n      this.events.on(EventsConfig.DecodeFlushEnd, function (data) {\n        _this2.logger.info('flushend>>>>>>>>>>>>>>>', data);\n        _this2.imagePlayer.maxPTS = data;\n      });\n    }\n  }, {\n    key: \"checkDataReady\",\n    value: function checkDataReady(type) {\n      var dataReady = this.dataReady;\n      dataReady[type] = true;\n      var keys = Object.keys(dataReady);\n      var num = 0;\n      for (var i = 0; i < keys.length; i++) {\n        if (!dataReady[keys[i]]) {\n          break;\n        } else {\n          num++;\n        }\n      }\n      if (num == keys.length) {\n        this.events.emit(EventsConfig.StreamDataReady);\n      }\n    }\n  }, {\n    key: \"setBaseInfo\",\n    value: function setBaseInfo(info) {\n      this.duration = info.duration;\n      this.tsNumber = info.tsNumber;\n    }\n  }, {\n    key: \"reset\",\n    value: function reset() {\n      this.dataReady = {\n        audioReady: false,\n        imageReady: false\n      };\n      this.currentIndex = null;\n      this.dataManageStatus = 'loading';\n    }\n  }, {\n    key: \"startLoad\",\n    value: function startLoad(index) {\n      this.logger.info('startLoad', 'index:', index);\n      this.currentIndex = index;\n      this.player.currentIndex = index;\n      this.events.emit(EventsConfig.DataManageReadBufferByNo, index);\n    }\n  }, {\n    key: \"loadNext\",\n    value: function loadNext() {\n      if (this.player.reseting) {\n        return;\n      }\n      if (this.currentIndex >= this.tsNumber) {\n        this.logger.info('loadNext', 'load end', 'currentIndex', this.currentIndex, 'tsNumber:', this.tsNumber);\n        return;\n      }\n      this.currentIndex += 1;\n      this.player.currentIndex = this.currentIndex;\n      this.logger.info('loadNext', 'load next ts', 'tsno:', this.currentIndex);\n      this.events.emit(EventsConfig.DataManageReadBufferByNo, this.currentIndex);\n    }\n  }, {\n    key: \"onDecoded\",\n    value: function onDecoded(dataArray) {\n      var _this3 = this;\n      dataArray.forEach(function (data) {\n        if (_this3.player.reseting) {\n          return;\n        }\n        if (data.pts >= _this3.player.currentTime) {\n          _this3.imagePlayer.push(data);\n        }\n      });\n    }\n  }, {\n    key: \"onAppendEnd\",\n    value: function onAppendEnd(data) {\n      if (data) {\n        this.logger.info('onAppendEnd', 'events.decodeFlush', data);\n        this.events.emit(EventsConfig.DecodeFlush);\n        return;\n      }\n      this.logger.info('onAppendEnd', 'start load next ts condition', this.checkBuffer(), this.currentIndex);\n      if (this.checkBuffer() && this.currentIndex !== null) {\n        this.logger.info('onAppendEnd', 'load next ts. currentIndex:', this.currentIndex);\n        this.loadNext();\n        return;\n      }\n      this.dataManageStatus = 'loadend';\n      this.logger.info('onAppendEnd', 'load ts stop');\n    }\n  }, {\n    key: \"onAACDemuxed\",\n    value: function onAACDemuxed(dataArray) {\n      var _this4 = this;\n      if (this.player.reseting) {\n        return;\n      }\n      //no audio data\n      if (!dataArray.length) {\n        this.audioPlayer.send({});\n      }\n      dataArray.forEach(function (data) {\n        if (data.PTS >= _this4.player.currentTime || data.audioEnd) {\n          if (!_this4.player.receiveAACTime && _this4.player.seeking) {\n            _this4.player.receiveAACTime = Date.now();\n          }\n          _this4.audioPlayer.send(data);\n        }\n      });\n    }\n  }, {\n    key: \"onVideoDemuxed\",\n    value: function onVideoDemuxed(data) {\n      if (this.player.reseting) {\n        return;\n      }\n      this.events.emit(EventsConfig.DecodeStartDecode, data);\n    }\n  }, {\n    key: \"checkBuffer\",\n    value: function checkBuffer() {\n      var player = this.player;\n      var time = player.currentTime;\n      var buffer = player.buffer();\n      var maxTime = buffer[1] || 0;\n      var bufferLength = maxTime - time;\n      if (bufferLength >= player.maxBufferLength) {\n        return false;\n      } else {\n        return true;\n      }\n    }\n  }, {\n    key: \"onRead\",\n    value: function onRead(data) {\n      if (this.player.reseting) {\n        console.error('onRead reseting');\n        return;\n      }\n      if (data && data.arrayBuffer && data.no === this.currentIndex) {\n        this.retryTime = 0;\n        this.logger.warn('onRead', 'get stream data');\n        //start demux, get the video and audio\n        if (data.no === this.tsNumber) {\n          //the last one ts packet\n          this.logger.info('onRead', 'the last ts');\n          this.events.emit(EventsConfig.DemuxLast);\n        }\n        this.events.emit(EventsConfig.DemuxStartDemux, data);\n      } else {\n        this.logger.error('onRead', 'load ts failred', 'tsno:', this.currentIndex);\n      }\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/imageplayer/ImageData.js\n\n\n\n\n\n\nfunction ImageData_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, ImageData_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction ImageData_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ImageData_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: yuv data module\r\n * @author: liuliguo \r\n * @file: ImageData.js\r\n */\n\n\nvar ImageData_ImageData = /*#__PURE__*/function (_BaseClass) {\n  function ImageData(options) {\n    var _this;\n    classCallCheck_default()(this, ImageData);\n    _this = ImageData_callSuper(this, ImageData, [options]);\n    defineProperty_default()(_this, \"maxBufferLength\", 0);\n    defineProperty_default()(_this, \"duration\", 0);\n    defineProperty_default()(_this, \"pool\", []);\n    defineProperty_default()(_this, \"start\", 0);\n    defineProperty_default()(_this, \"end\", 0);\n    defineProperty_default()(_this, \"offset\", 0);\n    defineProperty_default()(_this, \"fps\", 25);\n    _this.maxBufferLength = options.maxBufferLength;\n    return _this;\n  }\n  inherits_default()(ImageData, _BaseClass);\n  return createClass_default()(ImageData, [{\n    key: \"push\",\n    value: function push(data) {\n      var pool = this.pool;\n      var length = pool.length;\n      if (length === 0) {\n        this.offset = data.pts;\n        this.start = data.pts;\n        this.fps = data.fps;\n      }\n      var index = this.insertSort(pool, data);\n      if (pool[index - 1]) {\n        pool[index - 1].duration = pool[index].pts - pool[index - 1].pts;\n      }\n      if (pool[index + 1]) {\n        pool[index].duration = pool[index + 1].pts - pool[index].pts;\n      }\n      this.end = this.pool[length].pts + this.pool[length].duration;\n      this.duration = this.end - this.start;\n    }\n  }, {\n    key: \"insertSort\",\n    value: function insertSort(array, value) {\n      var length = array.length;\n      if (length === 0) {\n        array.push(value);\n        return 0;\n      }\n      for (var i = 0; i < length; i++) {\n        if (value.pts < array[i].pts) {\n          var j = length;\n          while (j > i) {\n            array[j] = array[j - 1];\n            j--;\n          }\n          array[i] = value;\n          return i;\n        }\n      }\n      array.push(value);\n      return array.length - 1;\n    }\n  }, {\n    key: \"reset\",\n    value: function reset() {\n      this.duration = 0;\n      this.pool = [];\n      this.start = 0;\n      this.end = 0;\n      this.offset = 0;\n    }\n  }, {\n    key: \"findByIndex\",\n    value: function findByIndex(index) {\n      var length = this.buffer.length;\n      if (index < length) {\n        this.currentIndex = index;\n        return this.buffer[index];\n      } else {\n        this.logger.error(\"input index \".concat(index, \"is not found, current maxIndex is \").concat(length - 1));\n        return null;\n      }\n    }\n  }, {\n    key: \"find\",\n    value: function find(time) {\n      var pool = this.pool;\n      var length = pool.length;\n      if (!this.isBuffered(time)) {\n        return;\n      }\n      if (length === 0) {\n        return;\n      }\n      var index = this.findIndex(time);\n      if (index !== -1) {\n        var image = pool[index];\n        this.checkBuffer(time);\n        return image;\n      }\n      return;\n    }\n  }, {\n    key: \"findIndex\",\n    value: function findIndex(time) {\n      var pool = this.pool;\n      var index = pool.findIndex(function (value) {\n        var pts = parseInt(value.pts);\n        return time >= pts && time < pts + value.duration;\n      });\n      return index;\n    }\n  }, {\n    key: \"isBuffered\",\n    value: function isBuffered(time) {\n      return time >= this.start && time < this.end;\n    }\n  }, {\n    key: \"checkBuffer\",\n    value: function checkBuffer(time) {\n      var duration = this.duration;\n      var maxBufferLength = this.maxBufferLength;\n      if (duration > maxBufferLength) {\n        if (time > this.start) {\n          var index = this.findIndex(time);\n          var reduceBuffer = this.pool.splice(0, index);\n          reduceBuffer.forEach(function (item) {\n            item = null;\n          });\n          reduceBuffer = null;\n          this.start = this.pool[0].pts;\n          this.duration = this.end - this.start;\n        }\n        return false;\n      } else {\n        this.events.emit(EventsConfig.PlayerLoadNext);\n      }\n      return true;\n    }\n  }, {\n    key: \"buffer\",\n    value: function buffer() {\n      return {\n        start: this.start,\n        end: this.end\n      };\n    }\n  }]);\n}(base_BaseClass);\n\n// EXTERNAL MODULE: ../node_modules/yuv-canvas/src/yuv-canvas.js\nvar yuv_canvas = __webpack_require__(71);\nvar yuv_canvas_default = /*#__PURE__*/__webpack_require__.n(yuv_canvas);\n\n// EXTERNAL MODULE: ../node_modules/yuv-buffer/yuv-buffer.js\nvar yuv_buffer = __webpack_require__(58);\nvar yuv_buffer_default = /*#__PURE__*/__webpack_require__.n(yuv_buffer);\n\n// CONCATENATED MODULE: ../src/imageplayer/Screen.js\n\n\n\n\n\n\nfunction Screen_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, Screen_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction Screen_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Screen_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: render yuv on canvas\r\n * @author: liuliguo \r\n * @file: Screen.js\r\n */\n\n\n\nvar Screen_Screen = /*#__PURE__*/function (_BaseClass) {\n  function Screen(options) {\n    var _this;\n    classCallCheck_default()(this, Screen);\n    _this = Screen_callSuper(this, Screen);\n    defineProperty_default()(_this, \"canvas\", null);\n    _this.setCanvas(options.canvas);\n    _this.setRender();\n    return _this;\n  }\n  inherits_default()(Screen, _BaseClass);\n  return createClass_default()(Screen, [{\n    key: \"setCanvas\",\n    value: function setCanvas(canvas) {\n      this.canvas = canvas;\n    }\n  }, {\n    key: \"setRender\",\n    value: function setRender(canvas) {\n      this.render = yuv_canvas_default.a.attach(canvas || this.canvas);\n    }\n  }, {\n    key: \"clear\",\n    value: function clear() {\n      this.render.clear();\n    }\n  }, {\n    key: \"drawFrame\",\n    value: function drawFrame(data) {\n      var st = Date.now();\n      var buf_y = data.buf_y,\n        buf_u = data.buf_u,\n        buf_v = data.buf_v,\n        width = data.width,\n        height = data.height,\n        stride_y = data.stride_y,\n        stride_u = data.stride_u,\n        stride_v = data.stride_v;\n      var y, u, v, format, frameDisplay;\n      var width_y = width;\n      var height_y = height;\n      var width_u = width_y / 2;\n      var height_u = height_y / 2;\n      y = {\n        bytes: buf_y,\n        stride: stride_y\n      };\n      u = {\n        bytes: buf_u,\n        stride: stride_u\n      };\n      v = {\n        bytes: buf_v,\n        stride: stride_v\n      };\n      format = yuv_buffer_default.a.format({\n        width: width_y,\n        height: height_y,\n        chromaWidth: width_u,\n        chromaHeight: height_u\n      });\n      frameDisplay = yuv_buffer_default.a.frame(format, y, u, v);\n      this.render.drawFrame(frameDisplay);\n      var endt = Date.now();\n      if (endt - st > 10) {\n        this.logger.warn('drawFrame', 'reandertime:', endt - st);\n      }\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/imageplayer/ImagePlayer.js\n\n\n\n\n\n\nfunction ImagePlayer_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, ImagePlayer_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction ImagePlayer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ImagePlayer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: play yuv data\r\n * @author: liuliguo \r\n * @file: ImagePlayer.js\r\n */\n\n\n\n\n\nvar ImagePlayer_ImagePlayer = /*#__PURE__*/function (_BaseClass) {\n  function ImagePlayer(options) {\n    var _this;\n    classCallCheck_default()(this, ImagePlayer);\n    _this = ImagePlayer_callSuper(this, ImagePlayer, [options]);\n    defineProperty_default()(_this, \"status\", 'pause');\n    defineProperty_default()(_this, \"_currentTime\", 0);\n    defineProperty_default()(_this, \"maxPTS\", null);\n    defineProperty_default()(_this, \"ready\", false);\n    defineProperty_default()(_this, \"firstRender\", false);\n    _this.imageData = new ImageData_ImageData({\n      events: options.events,\n      maxBufferLength: options.maxBufferLength\n    });\n    _this.screen = new Screen_Screen({\n      canvas: options.canvas\n    });\n    _this.playHandler = null;\n    _this.player = options.player;\n    _this.debug = options.debug || false;\n    return _this;\n  }\n  inherits_default()(ImagePlayer, _BaseClass);\n  return createClass_default()(ImagePlayer, [{\n    key: \"setScreenRender\",\n    value: function setScreenRender(canvas) {\n      this.screen.setCanvas(canvas);\n      this.screen.setRender(canvas);\n    }\n  }, {\n    key: \"clear\",\n    value: function clear() {\n      this.screen.clear();\n    }\n  }, {\n    key: \"play\",\n    value: function play(time) {\n      if (this.status !== 'play') {\n        this.status = 'play';\n        this.render(time);\n      }\n    }\n  }, {\n    key: \"pause\",\n    value: function pause() {\n      if (this.status !== 'pause') {\n        this.status = 'pause';\n        clearTimeout(this.playHandler);\n        this.playHandler = null;\n      }\n    }\n  }, {\n    key: \"checkBuffer\",\n    value: function checkBuffer() {\n      return this.imageData.checkBuffer(this.currentTime);\n    }\n  }, {\n    key: \"push\",\n    value: function push(data) {\n      if (this.player.reseting) {\n        return;\n      }\n      this.imageData.push(data);\n      var end = this.end;\n      var duration = end - this.player.currentTime;\n      if (duration > Config[\"d\" /* READY */].READYBUFFERLENGTH && !this.ready) {\n        this.ready = true;\n        this.status = 'ready';\n        this.events.emit(EventsConfig.ImagePlayerReady);\n      }\n      this.events.emit(EventsConfig.ImagePlayerBuffeUpdate);\n    }\n  }, {\n    key: \"find\",\n    value: function find(time) {\n      return this.imageData.find(time);\n    }\n  }, {\n    key: \"buffer\",\n    value: function buffer() {\n      return this.imageData.buffer();\n    }\n  }, {\n    key: \"isBuffered\",\n    value: function isBuffered(time) {\n      return this.imageData.isBuffered(time);\n    }\n  }, {\n    key: \"render\",\n    value: function render(time) {\n      if (time < this.imageData.offset) {\n        console.error(\"到这里了=====1\");\n        return;\n      }\n      var image = this.find(time);\n      if (image) {\n        if (!this.firstRender) {\n          this.firstRender = true;\n          this.events.emit(EventsConfig.PlayerLoadedMetaData, image.width, image.height);\n        }\n        this.screen.drawFrame(image);\n        this.currentTime = image.pts;\n        this.events.emit(EventsConfig.ImagePlayerRenderEnd, time, image.duration);\n        return image;\n      } else {\n        if (this.maxPTS && time >= this.maxPTS + this.fragDuration) {\n          this.status = 'end';\n          console.error(\"===视频结束===\");\n          this.events.emit(EventsConfig.ImagePlayerEnd, this.maxPTS);\n          return;\n        }\n        console.error(\"===到这里了==2=\");\n        this.logger.warn('Events.ImagePlayerWait', time, this.start, this.end, this.maxPTS);\n        this.logger.warn('render', 'not yuv data');\n        this.status = 'wait';\n        this.ready = false;\n        this.events.emit(EventsConfig.ImagePlayerWait, 'image', 'this');\n        return false;\n      }\n    }\n  }, {\n    key: \"reset\",\n    value: function reset() {\n      this.status = 'pause';\n      this.ready = false;\n      this.imageData.reset();\n      this.maxPTS = null;\n      this.currentTime = 0;\n    }\n  }, {\n    key: \"currentTime\",\n    get: function get() {\n      return this._currentTime;\n    },\n    set: function set(time) {\n      this._currentTime = time;\n    }\n  }, {\n    key: \"offset\",\n    get: function get() {\n      return this.imageData.offset;\n    }\n  }, {\n    key: \"fragDuration\",\n    get: function get() {\n      return Math.ceil(1000 / this.imageData.fps);\n    }\n  }, {\n    key: \"start\",\n    get: function get() {\n      return this.imageData.start;\n    }\n  }, {\n    key: \"end\",\n    get: function get() {\n      return this.imageData.end;\n    }\n  }, {\n    key: \"duration\",\n    get: function get() {\n      return this.imageData.duration;\n    }\n  }]);\n}(base_BaseClass);\n\n// CONCATENATED MODULE: ../src/Player.js\n\n\n\n\n\n\nfunction Player_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, Player_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction Player_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Player_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\nfunction Player_classPrivateFieldInitSpec(e, t, a) { Player_checkPrivateRedeclaration(e, t), t.set(e, a); }\nfunction Player_checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError(\"Cannot initialize the same private elements twice on an object\"); }\nfunction Player_classPrivateFieldGet(s, a) { return s.get(Player_assertClassBrand(s, a)); }\nfunction Player_classPrivateFieldSet(s, a, r) { return s.set(Player_assertClassBrand(s, a), r), r; }\nfunction Player_assertClassBrand(e, t, n) { if (\"function\" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError(\"Private element is not present on this object\"); }\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file Player.js\r\n * @desc\r\n * the player main stream\r\n * load data by url -> get the data -> ts demux -> get h265 data -> Webassmebly decode -> YUV data -> draw yuv to Canvas -> image and audio synv -> audio stream -> AudioContext decode and play\r\n * @author Jarry\r\n */\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nvar _libPath = /*#__PURE__*/new WeakMap();\nvar _currentTime = /*#__PURE__*/new WeakMap();\nvar _seek = /*#__PURE__*/new WeakMap();\nvar _playbackRate = /*#__PURE__*/new WeakMap();\nvar _muted = /*#__PURE__*/new WeakMap();\nvar _duration = /*#__PURE__*/new WeakMap();\nvar _lastVolume = /*#__PURE__*/new WeakMap();\nvar _containerOriginStyle = /*#__PURE__*/new WeakMap();\nvar _screenContainerOrginStyle = /*#__PURE__*/new WeakMap();\nvar _isCanPlay = /*#__PURE__*/new WeakMap();\nvar Player_Player = /*#__PURE__*/function (_BaseClass) {\n  /**\r\n   * @property {string} sourceURL - The url of the video to play\r\n   * @property {string} source - The url of the video to play\r\n   * @property {Object} defaultRate - The default value of playing rate\r\n   * @property {string} type - The type of the video, such as HLS\r\n   * @property {Object[]} rateList - The rate list of the player\r\n   * @example <caption>Example of rateList.</caption>\r\n   * // let options = {\r\n  *        rateList:[\r\n            {\"url\":\"http://localhost/20190902/01/a5/029f8fad8868a7116f20d8ae5b075996.m3u8\",\"id\":51,\"name\":\"720P\",\"value\":\"720\"},\r\n            {\"url\":\"http://localhost/20190902/f0/db/ee545466ced38973a9d60fe7f24ed409.m3u8\",\"id\":51,\"name\":\"高清\",\"value\":\"600\"},\r\n            {\"url\":\"http://localhost/20190902/78/6c/5a5a99476f4f792e2e7a701ba1f6d5ad.m3u8\",\"id\":264,\"name\":\"极速\",\"value\":\"jisu\"},\r\n            {\"url\":\"http://localhost/20190902/54/05/7e714a321d9e7d92c937582b2e439833.m3u8\",\"id\":265,\"name\":\"流畅\",\"value\":\"300\"}]\r\n        }\r\n   * @property {Function} processURL - process the url of video source \r\n   * @property {Number} maxBufferLength - The maximum value of the buffer, its default value is 5000(ms)\r\n   * @property {Boolean} autoPlay - If auto play after initializing the Player\r\n   * @property {string} libPath - The path of decoder\r\n   * @property {Boolean} preload - If pre load video before playing\r\n   * @property {Number} startTime - Start time to play the video\r\n   * @property {string} playbackRate - Playback speed\r\n   * @property {Number} controlBarHeight - The height of the control bar\r\n   * @property {AlertError} alertError - The alert info when error happens\r\n   * @property {Worker} httpWorker - set User's web worker\r\n   * @property {Function} afterLoadPlaylist - To handle operations after playlist is loaded\r\n  */\n  function Player(containerid) {\n    var _this;\n    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n    classCallCheck_default()(this, Player);\n    _this = Player_callSuper(this, Player);\n    defineProperty_default()(_this, \"mode\", Config[\"c\" /* Config */].mode);\n    defineProperty_default()(_this, \"$container\", null);\n    defineProperty_default()(_this, \"containerid\", '');\n    defineProperty_default()(_this, \"componentsController\", null);\n    defineProperty_default()(_this, \"controlBarController\", null);\n    defineProperty_default()(_this, \"controlBarHeight\", 50);\n    defineProperty_default()(_this, \"alertError\", null);\n    defineProperty_default()(_this, \"dataController\", null);\n    defineProperty_default()(_this, \"demuxer\", null);\n    defineProperty_default()(_this, \"decoder\", null);\n    defineProperty_default()(_this, \"preload\", true);\n    defineProperty_default()(_this, \"startTime\", 0);\n    defineProperty_default()(_this, \"screenWidth\", null);\n    defineProperty_default()(_this, \"screenHeight\", null);\n    defineProperty_default()(_this, \"options\", {});\n    Player_classPrivateFieldInitSpec(_this, _libPath, Config[\"c\" /* Config */].libPath);\n    defineProperty_default()(_this, \"readyStatus\", {\n      dataProcessor: false,\n      firstData: false,\n      audioPlayer: false\n    });\n    defineProperty_default()(_this, \"reseting\", false);\n    Player_classPrivateFieldInitSpec(_this, _currentTime, 0);\n    Player_classPrivateFieldInitSpec(_this, _seek, false);\n    Player_classPrivateFieldInitSpec(_this, _playbackRate, 1);\n    Player_classPrivateFieldInitSpec(_this, _muted, false);\n    defineProperty_default()(_this, \"maxBufferLength\", Config[\"d\" /* READY */].MAXBUFFERLENGTH);\n    defineProperty_default()(_this, \"seekSegmentNo\", -1);\n    defineProperty_default()(_this, \"status\", 'init');\n    defineProperty_default()(_this, \"loader\", null);\n    defineProperty_default()(_this, \"currentIndex\", null);\n    defineProperty_default()(_this, \"startIndex\", 1);\n    defineProperty_default()(_this, \"dataManage\", null);\n    defineProperty_default()(_this, \"paused\", false);\n    defineProperty_default()(_this, \"autoPlay\", true);\n    Player_classPrivateFieldInitSpec(_this, _duration, 0);\n    defineProperty_default()(_this, \"tsNumber\", 0);\n    Player_classPrivateFieldInitSpec(_this, _lastVolume, 0);\n    Player_classPrivateFieldInitSpec(_this, _containerOriginStyle, '');\n    Player_classPrivateFieldInitSpec(_this, _screenContainerOrginStyle, '');\n    Player_classPrivateFieldInitSpec(_this, _isCanPlay, false);\n    if (!containerid) {\n      _this.logger.error('Please pass in a dom object as the display container');\n    }\n    var elTmp = document.querySelector(\"#\" + containerid);\n    if (!elTmp) {\n      _this.logger.error('Please pass in a dom object as the display container');\n    }\n    _this.el = elTmp;\n    _this.containerid = containerid;\n    Object.assign(_this.options, options);\n    _this.options.sourceURL = _this.options.sourceURL || _this.options.source;\n    _this.options.controlBarHeight = _this.options.controlBarHeight || _this.controlBarHeight;\n    _this.options.streamList = _this.options.streamList || [];\n    _this.options.events = toolkit_Events();\n    _this.maxBufferLength = options.maxBufferLength !== undefined ? options.maxBufferLength : _this.maxBufferLength;\n    _this.autoPlay = options.autoPlay !== undefined ? options.autoPlay : _this.autoPlay;\n    _this.controlBarAutoHide = options.controlBarAutoHide !== undefined ? options.controlBarAutoHide : _this.controlBarAutoHide;\n    Player_classPrivateFieldSet(_libPath, _this, options.libPath !== undefined ? options.libPath : Player_classPrivateFieldGet(_libPath, _this));\n    _this.preload = options.preload === undefined ? _this.preload : options.preload;\n    _this.startTime = options.startTime === undefined ? _this.startTime : options.startTime;\n    _this.originStartTime = _this.startTime;\n    _this.playbackRate = options.playbackRate === undefined ? _this.playbackRate : options.playbackRate;\n    return _this;\n  }\n  inherits_default()(Player, _BaseClass);\n  return createClass_default()(Player, [{\n    key: \"setAlertError\",\n    value: function setAlertError() {\n      this.options.alertError = this.alertError = error_AlertError.getInstance({\n        player: this,\n        component: this.componentsController.alertBox,\n        events: this.options.events\n      });\n    }\n  }, {\n    key: \"setDataController\",\n    value: function setDataController() {\n      this.dataController = data_DataController.getInstance({\n        player: this,\n        events: this.options.events\n      });\n    }\n  }, {\n    key: \"setDataManage\",\n    value: function setDataManage() {\n      this.dataController.setDataManage({\n        player: this,\n        type: this.options.type,\n        events: this.options.events\n      });\n      this.dataManage = this.dataController.dataManage;\n    }\n  }, {\n    key: \"setComponentsController\",\n    value: function setComponentsController() {\n      this.componentsController = components_ComponentsController.getInstance({\n        $container: this.$container,\n        $screenContainer: this.$screenContainer,\n        $canvas: this.$canvas,\n        $audioContainer: this.$audioContainer,\n        $audio: this.$audio,\n        dataManage: this.dataManage,\n        bigPlayButtonColor: this.bigPlayButtonColor,\n        player: this,\n        events: this.options.events,\n        isShowControl: this.options.controls\n      });\n    }\n  }, {\n    key: \"setControlBarController\",\n    value: function setControlBarController() {\n      var options = Object.assign({}, this.options, {\n        $container: this.$container,\n        $screenContainer: this.$screenContainer,\n        controlBarAutoHide: this.controlBarAutoHide,\n        player: this\n      });\n      this.controlBarController = control_bar_ControlBarController.getInstance(options);\n    }\n  }, {\n    key: \"setLoadController\",\n    value: function setLoadController() {\n      this.loaderController = loader_LoaderController.getInstance(this.options.type, {\n        player: this,\n        events: this.options.events\n      });\n    }\n  }, {\n    key: \"setProcessorController\",\n    value: function setProcessorController() {\n      this.processController = new dataProcessorController_DataProcessorController({\n        type: 'ts',\n        libPath: Player_classPrivateFieldGet(_libPath, this),\n        events: this.options.events,\n        player: this\n      });\n    }\n  }, {\n    key: \"setStreamController\",\n    value: function setStreamController() {\n      this.streamController = new StreamController_StreamController({\n        events: this.options.events,\n        dataManage: this.dataManage,\n        imagePlayer: this.imagePlayer,\n        audioPlayer: this.audioPlayer,\n        player: this\n      });\n    }\n  }, {\n    key: \"setImagerPlayer\",\n    value: function setImagerPlayer() {\n      this.imagePlayer = new ImagePlayer_ImagePlayer({\n        events: this.options.events,\n        canvas: this.$canvas,\n        maxBufferLength: this.maxBufferLength,\n        player: this\n      });\n    }\n  }, {\n    key: \"setAudioPlayer\",\n    value: function setAudioPlayer() {\n      this.audioPlayer = new AudioPlayer_AudioPlayer({\n        player: this,\n        events: this.options.events,\n        audioNode: this.$audio\n      });\n    }\n  }, {\n    key: \"setAction\",\n    value: function setAction() {\n      this.action = new Action_Action({\n        player: this,\n        screen: this.screen,\n        imagePlayer: this.imagePlayer,\n        dataManage: this.dataManage,\n        audioPlayer: this.audioPlayer,\n        events: this.options.events\n      });\n    }\n  }, {\n    key: \"init\",\n    value: function init() {\n      this.controlBarHeight = this.options.controlBarHeight || this.controlBarHeight;\n      this.options.httpWorker = webworkify_webpack_default()(/*require.resolve*/(95), {\n        name: 'httpWorker'\n      });\n      this.currentTime = this.startTime;\n      this.addEl();\n      this.setDataController();\n      this.setDataManage();\n      this.setComponentsController();\n      this.setLoadController();\n      //不显示控制栏\n      if (this.options.controls == undefined || this.options.controls == true) {\n        this.setControlBarController();\n        this.componentsController.setControlBarController(this.controlBarController);\n      }\n      this.setAlertError();\n      this.setProcessorController();\n      this.setImagerPlayer();\n      this.setAudioPlayer();\n      this.setAction();\n      this.setStreamController();\n      // this.componentsController.drawPoster()\n      if (this.preload) {\n        this.run();\n      }\n      this.bindEvent();\n    }\n  }, {\n    key: \"bindEvent\",\n    value: function bindEvent() {\n      var _this2 = this;\n      this.events.on(EventsConfig.PlayerOnPlay, function () {\n        _this2.play();\n      });\n      this.events.on(EventsConfig.PlayerOnPause, function () {\n        _this2.pause();\n      });\n      this.events.on(EventsConfig.PlayerOnVolume, function (value) {\n        console.log('PlayerOnVolume', value);\n        _this2.volume = value;\n      });\n      this.events.on(EventsConfig.DataProcessorReady, function () {\n        _this2.logger.info('bindEvent', 'decoder ready');\n        _this2.checkReady('dataProcessor');\n      });\n      this.events.on(EventsConfig.AudioPlayerReady, function () {\n        _this2.logger.info('bindEvent', 'audioPlayer ready');\n        if (!_this2.seeking) {\n          _this2.checkReady('audioPlayer');\n        }\n      });\n      this.events.on(EventsConfig.PlayerReady, function () {\n        _this2.logger.info('bindEvent', 'player ready');\n        _this2.onReady();\n      });\n      this.events.on(EventsConfig.PlayerSpeedTo, function (data) {\n        _this2.changeSpeed(data);\n      });\n      this.events.on(EventsConfig.PlayerChangeRate, function (data) {\n        _this2.events.emit(\"Player.waiting\", _this2);\n        _this2.changeRate(data);\n      });\n      this.events.on(EventsConfig.PlayerPlay, function () {});\n      this.events.on(EventsConfig.LoaderPlayListLoaded, function (data) {\n        if (typeof _this2.options.afterLoadPlaylist == 'function') {\n          _this2.options.afterLoadPlaylist(_this2.laodData.sourceData);\n        }\n        var sourceData = data.dataManage.sourceData;\n        Player_classPrivateFieldSet(_duration, _this2, sourceData.duration);\n        console.log('视频时长====', Player_classPrivateFieldGet(_duration, _this2));\n        _this2.tsNumber = sourceData.length;\n        _this2.streamController.setBaseInfo({\n          duration: Player_classPrivateFieldGet(_duration, _this2),\n          tsNumber: _this2.tsNumber\n        });\n        _this2.dataController.startLoad(_this2.startTime);\n        _this2.setStartTime(_this2.originStartTime);\n        _this2.events.emit(\"Player.loadstart\", _this2);\n        _this2.events.emit(\"Player.durationchange\", _this2);\n      });\n      this.events.on(EventsConfig.DataManageFirstLoaded, function (buffer) {\n        _this2.logger.info('bindEvent', 'first data ready');\n        _this2.startIndex = buffer.no;\n        _this2.streamController.currentIndex = buffer.no;\n        _this2.checkReady('firstData');\n      });\n      this.events.on(EventsConfig.StreamDataReady, function () {\n        _this2.logger.info('bindEvent', 'dataReady');\n        _this2.onDataReady();\n        _this2.events.emit(\"Player.canplay\", _this2);\n      });\n      this.events.on(EventsConfig.PlayerLoadedMetaData, function (width, height) {\n        _this2.setCanvas();\n        _this2.resizeScreen(width, height);\n        _this2.events.emit(\"Player.loadedmetadata\", _this2);\n        _this2.events.emit(\"Player.loadeddata\", _this2);\n      });\n      this.events.on(EventsConfig.PlayerEnd, function () {\n        console.log(\"==============Events.PlayerEnd\");\n        _this2.events.emit(\"Player.ended\", _this2);\n        _this2.pause();\n        _this2.status = 'end';\n      });\n      this.events.on(EventsConfig.ImagePlayerBuffeUpdate, function () {\n        var buffer = _this2.buffer();\n        _this2.events.emit(EventsConfig.PlayerbufferUpdate, buffer);\n      });\n      this.events.on(EventsConfig.PlayerOnSeek, function (time) {\n        console.log('PlayerOnSeek', time);\n        _this2.seek(Math.floor(time));\n        _this2.events.emit(\"Player.seeking\", time);\n      });\n      this.events.on(EventsConfig.PlayerAlert, function (content) {\n        _this2.alertError.show(content);\n      });\n      this.events.on(EventsConfig.PlayerThrowError, function (errors) {\n        _this2.events.emit(\"Player.error\", errors);\n        ThrowError[\"a\" /* throwError */].apply(_this2, errors);\n      });\n      this.events.on(EventsConfig.PlayerTimeUpdate, function (time) {\n        _this2.events.emit(\"Player.timeupdate\", time);\n      });\n      this.events.on(\"AudioPlayer.seeked\", function () {\n        _this2.events.emit(\"Player.seeked\", _this2);\n      });\n\n      //自动播放失败了\n      this.events.on(EventsConfig.AutoPlayerPlayFail, function () {\n        _this2.events.emit(\"Player.error\", \"autoplayFail\");\n      });\n      var eventsArr = [EventsConfig.PlayerWait, EventsConfig.PlayerSeeking, EventsConfig.PlayerReset, EventsConfig.PlayerChangeSrc];\n      eventsArr.forEach(function (item) {\n        _this2.events.on(item, function () {\n          console.log('触发waitPlayerWait=========');\n          _this2.events.emit(\"Player.waiting\", _this2);\n        });\n      });\n    }\n  }, {\n    key: \"reset\",\n    value: function reset(value) {\n      if (this.action) {\n        this.action.reset(value);\n      }\n    }\n  }, {\n    key: \"switchPlaylist\",\n    value: function switchPlaylist(url, callback) {\n      this.loaderController.switchPlaylist(url, callback);\n    }\n  }, {\n    key: \"setStartTime\",\n    value: function setStartTime(time) {\n      this.startTime = time;\n    }\n    /**\r\n     * @method\r\n     * @name changeRate\r\n     * @param {Object} data - The url of the video source\r\n     * @param {function} callback - Function to handle after changing the video source \r\n     * @description Change the rate of the video source, such as 720P, HD...*/\n  }, {\n    key: \"changeRate\",\n    value: function changeRate(data) {\n      this.pause();\n      this.events.emit(EventsConfig.ControlBarPauseLoading, this);\n      this.setStartTime((this.currentTime - 5000) / 1000);\n      this.changing = true;\n      this.seeking = false;\n      this.imagePlayer.firstRender = false;\n      this.readyStatus = {\n        dataProcessor: false,\n        firstData: false,\n        audioPlayer: false\n      };\n      this.reset(true);\n      this.switchPlaylist(data.url);\n    }\n    /**\r\n     * @method\r\n     * @name changeSrc\r\n     * @param {string} url - The url of the video source\r\n     * @param {function} callback - Function to handle after changing the video source \r\n     * @description Change the source of the video to play*/\n  }, {\n    key: \"changeSrc\",\n    value: function changeSrc(url, callback) {\n      this.pause();\n      this.events.emit(EventsConfig.ControlBarPauseLoading, this);\n      this.events.emit(EventsConfig.PlayerChangeSrc, this);\n      this.changing = true;\n      this.seeking = false;\n      this.imagePlayer.firstRender = false;\n      this.readyStatus = {\n        dataProcessor: false,\n        firstData: false,\n        audioPlayer: false\n      };\n      this.currentTime = this.startTime;\n      this.imagePlayer.clear();\n      this.reset(true);\n      this.options.sourceURL = url;\n      Player_classPrivateFieldSet(_isCanPlay, this, false);\n      this.switchPlaylist(url, callback);\n    }\n  }, {\n    key: \"setCanvas\",\n    value: function setCanvas() {\n      var $canvas = PlayerUtil_PlayerUtil.createCanvas(this);\n      if (Element_Element.isElement(this.$canvas)) {\n        if (this.$canvas.width && this.$canvas.height) {\n          this.imagePlayer.setScreenRender($canvas);\n          this.$canvas.replaceWith($canvas);\n          this.$canvas = $canvas;\n          return;\n        }\n      } else {\n        this.$screen.appendChild($canvas);\n        this.$canvas = $canvas;\n      }\n    }\n    /**\r\n     * @method\r\n     * @name destroy\r\n     * @description destroy the instance of Class Player*/\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      if (this.controlBarController) {\n        this.controlBarController.destroy();\n        delete this.controlBarController;\n      }\n      this.reset(true);\n      if (this.$container) {\n        this.el.removeChild(this.$container);\n        delete this.$container;\n      }\n      this.processController.destroy();\n      this.loaderController.destroy();\n    }\n  }, {\n    key: \"run\",\n    value: function run() {\n      this.loaderController.run();\n    }\n  }, {\n    key: \"checkReady\",\n    value: function checkReady(type) {\n      var readyStatus = this.readyStatus;\n      if (type && typeof type === 'string') {\n        readyStatus[type] = true;\n        var keys = Object.keys(readyStatus);\n        for (var i = 0; i < keys.length; i++) {\n          if (!readyStatus[keys[i]]) {\n            return false;\n          }\n        }\n        this.logger.info('checkReady', 'player ready');\n        this.events.emit(EventsConfig.PlayerReady);\n        return true;\n      } else {\n        this.logger.error('checkReady', 'check ready', 'type is no correct, type:', type);\n        return false;\n      }\n    }\n  }, {\n    key: \"addEl\",\n    value: function addEl() {\n      var _this3 = this;\n      var $container, $screen, $audioContainer, $audio;\n      if (!this.el) {\n        this.logger.error('addEl', 'not found el.', 'el:', this.options.el);\n        return;\n      }\n      $container = PlayerUtil_PlayerUtil.createContainer(this);\n      this.el.appendChild($container);\n      this.$container = $container;\n      $screen = PlayerUtil_PlayerUtil.createScreenContainer(this);\n      this.$screen = $screen;\n      $container.appendChild($screen);\n      this.$screenContainer = $screen;\n      this.setCanvas();\n      $audio = PlayerUtil_PlayerUtil.createAudio(this);\n      this.$audio = $audio;\n      $audioContainer = PlayerUtil_PlayerUtil.createAudioContainer(this);\n      $audioContainer.appendChild($audio);\n      this.$audioContainer = $audioContainer;\n      $container.appendChild($audioContainer);\n      Player_classPrivateFieldSet(_containerOriginStyle, this, $container.getAttribute('style'));\n      Player_classPrivateFieldSet(_screenContainerOrginStyle, this, this.$screenContainer.getAttribute('style'));\n      var screenWidth = this.$screenContainer.clientWidth;\n      var screenHeight = this.$screenContainer.clientHeight;\n      //监听resize变化\n      window.addEventListener('resize', function () {\n        var screenWidthTmp = _this3.$screenContainer.clientWidth;\n        var screenHeightTmp = _this3.$screenContainer.clientHeight;\n        if (screenWidthTmp !== screenWidth || screenHeightTmp !== screenHeight) {\n          screenWidth = screenWidthTmp;\n          screenHeight = screenHeightTmp;\n          _this3.resizeScreen();\n        }\n      });\n    }\n  }, {\n    key: \"onPlay\",\n    value: function onPlay() {\n      this.logger.info('onPlay', 'play, play, play');\n    }\n  }, {\n    key: \"onReady\",\n    value: function onReady() {\n      if (!this.changing) {\n        this.componentsController.run();\n      }\n      if (this.changing) {\n        this.logger.info('onReady', 'change ready', 'startIndex:', this.startIndex);\n      }\n      this.streamController.startLoad(this.startIndex);\n    }\n  }, {\n    key: \"onDataReady\",\n    value: function onDataReady() {\n      Player_classPrivateFieldSet(_isCanPlay, this, true);\n      if (this.changing) {\n        this.changing = false;\n        this.play();\n      }\n      if (this.seeking || this.autoPlay && !this.paused) {\n        this.play();\n      }\n    }\n  }, {\n    key: \"buffer\",\n    value: function buffer() {\n      var videoBuffered = this.imagePlayer.buffer();\n      var audioPlayerBuffered = this.audioPlayer.buffer();\n      var sTime = Math.max(videoBuffered.start, audioPlayerBuffered.start);\n      var eTime = Math.min(videoBuffered.end, audioPlayerBuffered.end);\n      if (sTime < eTime) {\n        return [sTime, eTime];\n      }\n      return [0, 0];\n    }\n\n    /**\r\n     * @method\r\n     * @name changeSpeed\r\n     * @param {Object} data - data.value, The value of playback speed\r\n     * @description 对外接口倍数 Change the playback speed, such as 1, 0.5, 1.5, 2...*/\n  }, {\n    key: \"changeSpeed\",\n    value: function changeSpeed() {\n      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};\n      this.playbackRate = data.value || 1;\n    }\n    /**\r\n     * @method\r\n     * @name play\r\n     * @description 对外接口播放以及恢复播放。\r\n     * */\n  }, {\n    key: \"play\",\n    value: function play() {\n      this.logger.info('play', this.status);\n      if (Player_classPrivateFieldGet(_isCanPlay, this)) {\n        if (this.status == 'end') {\n          //结束了 重播\n          this.seek(0);\n        } else {\n          if (this.status !== 'playing') {\n            this.logger.info('start play');\n            this.status = 'playing';\n            this.paused = false;\n            this.action.play(this.currentTime);\n            this.events.emit(EventsConfig.PlayerPlay, this);\n            this.events.emit('Player.play', this);\n            this.events.emit('Player.playing', this);\n          }\n        }\n      }\n    }\n    /**\r\n    * @method\r\n    * @name pause\r\n    * @description 对外接口监听事件。\r\n    * */\n  }, {\n    key: \"on\",\n    value: function on(name, callback) {\n      this.events.on('Player.' + name, callback);\n    }\n\n    /**\r\n    * @method\r\n    * @name pause\r\n    * @description 对外接口取消监听事件。\r\n    * */\n  }, {\n    key: \"off\",\n    value: function off(name, callback) {\n      this.events.off('Player.' + name, callback);\n    }\n    /**\r\n    * @method\r\n    * @name pause\r\n    * @description 对外接口监听事件一次。\r\n    * */\n  }, {\n    key: \"once\",\n    value: function once(name, callback) {\n      this.events.once('Player.' + name, callback);\n    }\n    /**\r\n     * @method\r\n     * @name pause\r\n     * @description 对外接口暂停播放。\r\n     * */\n  }, {\n    key: \"pause\",\n    value: function pause() {\n      if (this.status != 'pause') {\n        console.error(\"在那天-暂停\");\n        this.logger.info('pause');\n        this.status = 'pause';\n        this.action.pause();\n        this.paused = true;\n        this.events.emit(EventsConfig.PlayerPause, this);\n        this.events.emit('Player.pause', this);\n      }\n    }\n    /**\r\n     * @method\r\n     * @name seek\r\n     * @param {number} time - the duration of seeking\r\n     * @description seek time to play*/\n  }, {\n    key: \"seek\",\n    value: function seek(time) {\n      if (time < this.startTime) {\n        return;\n      }\n      if (time >= Player_classPrivateFieldGet(_duration, this) * 1000) {\n        this.logger.info('seek', 'seek to time:', time);\n        return;\n      }\n      this.seekTime = Date.now();\n      this.seeking = true;\n      this.currentTime = time;\n      this.action.seek(time);\n    }\n    /**\r\n    * @method\r\n    * @description 对外接口获取视频时长。\r\n    * */\n  }, {\n    key: \"duration\",\n    value: function duration() {\n      return Player_classPrivateFieldGet(_duration, this);\n    }\n    /**\r\n     * @method\r\n     * @description 对外接口获取当前时长和设置当前时间。\r\n     * */\n  }, {\n    key: \"currentTimeSec\",\n    value: function currentTimeSec(time) {\n      if (time !== undefined) {\n        this.seek(time * 1000);\n      }\n      return this.currentTime / 1000;\n    }\n\n    /**\r\n     * \r\n     * @param {*} value \r\n     * @returns 对外接口获取或设置播放器是否静音\r\n     */\n  }, {\n    key: \"muted\",\n    value: function muted(value) {\n      if (value !== undefined) {\n        Player_classPrivateFieldSet(_muted, this, value);\n        if (value) {\n          Player_classPrivateFieldSet(_lastVolume, this, this.volume);\n          this.volume = 0;\n        } else {\n          this.volume = Player_classPrivateFieldGet(_lastVolume, this);\n        }\n      }\n      return Player_classPrivateFieldGet(_muted, this);\n    }\n    /**\r\n     * @description 对外接口进入全屏模式。\r\n     */\n  }, {\n    key: \"requestFullscreen\",\n    value: function requestFullscreen() {\n      console.log(\"对外接口进入全屏模式1\");\n      this.resizeScreen();\n    }\n\n    /**\r\n     * @description 对外接口退出全屏模式。\r\n     */\n  }, {\n    key: \"exitFullscreen\",\n    value: function exitFullscreen() {\n      var _this4 = this;\n      console.log(\"对外接口退出全屏模式。\");\n      setTimeout(function () {\n        _this4.resizeScreen();\n      }, 500);\n    }\n  }, {\n    key: \"playbackRate\",\n    get: function get() {\n      return Player_classPrivateFieldGet(_playbackRate, this);\n    },\n    set: function set(value) {\n      Player_classPrivateFieldSet(_playbackRate, this, value);\n    }\n  }, {\n    key: \"seeking\",\n    get: function get() {\n      return Player_classPrivateFieldGet(_seek, this);\n    },\n    set: function set(value) {\n      Player_classPrivateFieldSet(_seek, this, value);\n      if (value) {\n        this.events.emit(EventsConfig.PlayerSeeking);\n      } else {\n        this.events.emit(EventsConfig.PlayerSeekEnd);\n      }\n    }\n  }, {\n    key: \"currentTime\",\n    get: function get() {\n      return Player_classPrivateFieldGet(_currentTime, this);\n    },\n    set: function set(time) {\n      Player_classPrivateFieldSet(_currentTime, this, time);\n    }\n  }, {\n    key: \"volume\",\n    get: function get() {\n      return this.audioPlayer.volume;\n    },\n    set: function set(value) {\n      this.audioPlayer.volume = value;\n    }\n  }, {\n    key: \"resizeScreen\",\n    value: function resizeScreen(width, height) {\n      Element_Element.adaptSizeElement(width, height, this.$screenContainer, this.$canvas);\n    }\n  }]);\n}(base_BaseClass);\n/* harmony default export */ var src_Player = (Player_Player);\n// CONCATENATED MODULE: ../src/h265Player.js\n\n\n\n\n\n\nfunction h265Player_callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, h265Player_isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }\nfunction h265Player_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (h265Player_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: \r\n * @author: liuliguo \r\n * @file: h265Player.js\r\n */\n\n\n\n\n\n\n\nvar h265Player_h265Player = /*#__PURE__*/function (_Player) {\n  /**\r\n   * GoldPlay is the class exposed to user and inherited from Player\r\n   * @constructs\r\n   * @param {Elemnent} el - The container of rendering player\r\n   * @param {Object} options - The setting of the player\r\n   */\n  function h265Player(el, options) {\n    var _this;\n    classCallCheck_default()(this, h265Player);\n    _this = h265Player_callSuper(this, h265Player, [el, options]);\n    // poster = ''\n    // startTime = 1000\n    // controlBarAutoHide = true\n    // controlBarAutoHideTime = 1\n    defineProperty_default()(_this, \"libPath\", null);\n    _this.options.processURL = options.processURL;\n    _this.libPath = options.libPath;\n    _this.poster = options.poster;\n    if (_this.options.needInit !== false) {\n      _this.init();\n    }\n    return _this;\n  }\n\n  /**\r\n   * @method\r\n   * @name getComponent\r\n   * @param {String} name - component name\r\n   * @description get the component registered in components map\r\n   */\n  inherits_default()(h265Player, _Player);\n  return createClass_default()(h265Player, null, [{\n    key: \"getComponent\",\n    value: function getComponent(name) {\n      return CONPONENTS_MAP[name];\n    }\n    /**\r\n     * @method\r\n     * @name registerComponent\r\n     * @param {String} name - component name\r\n     * @param {Class} componentToAdd - The component class defined by user\r\n     * @param {String} [pos=right] - Which side of control bar\r\n     * @param {number} [index=-1] - Display index, last by default\r\n     * @description register the new component to components map and it will be instantiated and rendered when player is inited\r\n     */\n  }, {\n    key: \"registerComponent\",\n    value: function registerComponent(name, componentToAdd) {\n      var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'right';\n      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;\n      if (typeof name !== 'string' || !name) {\n        throw new Error(\"Illegal component name, \\\"\".concat(name, \"\\\"; must be a non-empty string.\"));\n      }\n      var isComp = Object.prototype.isPrototypeOf.call(base_BaseComponent, componentToAdd.prototype);\n      if (!isComp) {\n        throw new Error(\"Illegal component, \\\"\".concat(name, \"\\\"; must be a BaseComponent subclass.\"));\n      }\n      CONPONENTS_MAP[name] = componentToAdd;\n      components_ComponentsController.addComponet(name);\n      if (pos === 'left') {\n        control_bar_NearControlBar.addCustomControl(name, index);\n      } else {\n        control_bar_SideControlBar.addCustomControl(name, index);\n      }\n    }\n  }]);\n}(src_Player);\n/* harmony default export */ var src_h265Player = __webpack_exports__[\"default\"] = (h265Player_h265Player);\n\n//# sourceURL=webpack://H265Player/../src/h265Player.js_+_67_modules?");/***/},/* 85 *//***/function(module,exports,__webpack_require__){eval("var _typeof = __webpack_require__(9)[\"default\"];\nfunction toPrimitive(t, r) {\n  if (\"object\" != _typeof(t) || !t) return t;\n  var e = t[Symbol.toPrimitive];\n  if (void 0 !== e) {\n    var i = e.call(t, r || \"default\");\n    if (\"object\" != _typeof(i)) return i;\n    throw new TypeError(\"@@toPrimitive must return a primitive value.\");\n  }\n  return (\"string\" === r ? String : Number)(t);\n}\nmodule.exports = toPrimitive, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/toPrimitive.js?");/***/},/* 86 *//***/function(module,exports){eval("function _assertThisInitialized(e) {\n  if (void 0 === e) throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");\n  return e;\n}\nmodule.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/assertThisInitialized.js?");/***/},/* 87 *//***/function(module,exports){eval("function _isNativeReflectConstruct() {\n  try {\n    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));\n  } catch (t) {}\n  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {\n    return !!t;\n  }, module.exports.__esModule = true, module.exports[\"default\"] = module.exports)();\n}\nmodule.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/isNativeReflectConstruct.js?");/***/},/* 88 *//***/function(module,exports){eval("function _isNativeFunction(t) {\n  try {\n    return -1 !== Function.toString.call(t).indexOf(\"[native code]\");\n  } catch (n) {\n    return \"function\" == typeof t;\n  }\n}\nmodule.exports = _isNativeFunction, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/isNativeFunction.js?");/***/},/* 89 *//***/function(module,exports,__webpack_require__){eval("var _typeof = __webpack_require__(9)[\"default\"];\nfunction _regeneratorRuntime() {\n  \"use strict\"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */\n  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {\n    return e;\n  }, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n  var t,\n    e = {},\n    r = Object.prototype,\n    n = r.hasOwnProperty,\n    o = Object.defineProperty || function (t, e, r) {\n      t[e] = r.value;\n    },\n    i = \"function\" == typeof Symbol ? Symbol : {},\n    a = i.iterator || \"@@iterator\",\n    c = i.asyncIterator || \"@@asyncIterator\",\n    u = i.toStringTag || \"@@toStringTag\";\n  function define(t, e, r) {\n    return Object.defineProperty(t, e, {\n      value: r,\n      enumerable: !0,\n      configurable: !0,\n      writable: !0\n    }), t[e];\n  }\n  try {\n    define({}, \"\");\n  } catch (t) {\n    define = function define(t, e, r) {\n      return t[e] = r;\n    };\n  }\n  function wrap(t, e, r, n) {\n    var i = e && e.prototype instanceof Generator ? e : Generator,\n      a = Object.create(i.prototype),\n      c = new Context(n || []);\n    return o(a, \"_invoke\", {\n      value: makeInvokeMethod(t, r, c)\n    }), a;\n  }\n  function tryCatch(t, e, r) {\n    try {\n      return {\n        type: \"normal\",\n        arg: t.call(e, r)\n      };\n    } catch (t) {\n      return {\n        type: \"throw\",\n        arg: t\n      };\n    }\n  }\n  e.wrap = wrap;\n  var h = \"suspendedStart\",\n    l = \"suspendedYield\",\n    f = \"executing\",\n    s = \"completed\",\n    y = {};\n  function Generator() {}\n  function GeneratorFunction() {}\n  function GeneratorFunctionPrototype() {}\n  var p = {};\n  define(p, a, function () {\n    return this;\n  });\n  var d = Object.getPrototypeOf,\n    v = d && d(d(values([])));\n  v && v !== r && n.call(v, a) && (p = v);\n  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);\n  function defineIteratorMethods(t) {\n    [\"next\", \"throw\", \"return\"].forEach(function (e) {\n      define(t, e, function (t) {\n        return this._invoke(e, t);\n      });\n    });\n  }\n  function AsyncIterator(t, e) {\n    function invoke(r, o, i, a) {\n      var c = tryCatch(t[r], t, o);\n      if (\"throw\" !== c.type) {\n        var u = c.arg,\n          h = u.value;\n        return h && \"object\" == _typeof(h) && n.call(h, \"__await\") ? e.resolve(h.__await).then(function (t) {\n          invoke(\"next\", t, i, a);\n        }, function (t) {\n          invoke(\"throw\", t, i, a);\n        }) : e.resolve(h).then(function (t) {\n          u.value = t, i(u);\n        }, function (t) {\n          return invoke(\"throw\", t, i, a);\n        });\n      }\n      a(c.arg);\n    }\n    var r;\n    o(this, \"_invoke\", {\n      value: function value(t, n) {\n        function callInvokeWithMethodAndArg() {\n          return new e(function (e, r) {\n            invoke(t, n, e, r);\n          });\n        }\n        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();\n      }\n    });\n  }\n  function makeInvokeMethod(e, r, n) {\n    var o = h;\n    return function (i, a) {\n      if (o === f) throw Error(\"Generator is already running\");\n      if (o === s) {\n        if (\"throw\" === i) throw a;\n        return {\n          value: t,\n          done: !0\n        };\n      }\n      for (n.method = i, n.arg = a;;) {\n        var c = n.delegate;\n        if (c) {\n          var u = maybeInvokeDelegate(c, n);\n          if (u) {\n            if (u === y) continue;\n            return u;\n          }\n        }\n        if (\"next\" === n.method) n.sent = n._sent = n.arg;else if (\"throw\" === n.method) {\n          if (o === h) throw o = s, n.arg;\n          n.dispatchException(n.arg);\n        } else \"return\" === n.method && n.abrupt(\"return\", n.arg);\n        o = f;\n        var p = tryCatch(e, r, n);\n        if (\"normal\" === p.type) {\n          if (o = n.done ? s : l, p.arg === y) continue;\n          return {\n            value: p.arg,\n            done: n.done\n          };\n        }\n        \"throw\" === p.type && (o = s, n.method = \"throw\", n.arg = p.arg);\n      }\n    };\n  }\n  function maybeInvokeDelegate(e, r) {\n    var n = r.method,\n      o = e.iterator[n];\n    if (o === t) return r.delegate = null, \"throw\" === n && e.iterator[\"return\"] && (r.method = \"return\", r.arg = t, maybeInvokeDelegate(e, r), \"throw\" === r.method) || \"return\" !== n && (r.method = \"throw\", r.arg = new TypeError(\"The iterator does not provide a '\" + n + \"' method\")), y;\n    var i = tryCatch(o, e.iterator, r.arg);\n    if (\"throw\" === i.type) return r.method = \"throw\", r.arg = i.arg, r.delegate = null, y;\n    var a = i.arg;\n    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, \"return\" !== r.method && (r.method = \"next\", r.arg = t), r.delegate = null, y) : a : (r.method = \"throw\", r.arg = new TypeError(\"iterator result is not an object\"), r.delegate = null, y);\n  }\n  function pushTryEntry(t) {\n    var e = {\n      tryLoc: t[0]\n    };\n    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);\n  }\n  function resetTryEntry(t) {\n    var e = t.completion || {};\n    e.type = \"normal\", delete e.arg, t.completion = e;\n  }\n  function Context(t) {\n    this.tryEntries = [{\n      tryLoc: \"root\"\n    }], t.forEach(pushTryEntry, this), this.reset(!0);\n  }\n  function values(e) {\n    if (e || \"\" === e) {\n      var r = e[a];\n      if (r) return r.call(e);\n      if (\"function\" == typeof e.next) return e;\n      if (!isNaN(e.length)) {\n        var o = -1,\n          i = function next() {\n            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;\n            return next.value = t, next.done = !0, next;\n          };\n        return i.next = i;\n      }\n    }\n    throw new TypeError(_typeof(e) + \" is not iterable\");\n  }\n  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, \"constructor\", {\n    value: GeneratorFunctionPrototype,\n    configurable: !0\n  }), o(GeneratorFunctionPrototype, \"constructor\", {\n    value: GeneratorFunction,\n    configurable: !0\n  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, \"GeneratorFunction\"), e.isGeneratorFunction = function (t) {\n    var e = \"function\" == typeof t && t.constructor;\n    return !!e && (e === GeneratorFunction || \"GeneratorFunction\" === (e.displayName || e.name));\n  }, e.mark = function (t) {\n    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, \"GeneratorFunction\")), t.prototype = Object.create(g), t;\n  }, e.awrap = function (t) {\n    return {\n      __await: t\n    };\n  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {\n    return this;\n  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {\n    void 0 === i && (i = Promise);\n    var a = new AsyncIterator(wrap(t, r, n, o), i);\n    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {\n      return t.done ? t.value : a.next();\n    });\n  }, defineIteratorMethods(g), define(g, u, \"Generator\"), define(g, a, function () {\n    return this;\n  }), define(g, \"toString\", function () {\n    return \"[object Generator]\";\n  }), e.keys = function (t) {\n    var e = Object(t),\n      r = [];\n    for (var n in e) r.push(n);\n    return r.reverse(), function next() {\n      for (; r.length;) {\n        var t = r.pop();\n        if (t in e) return next.value = t, next.done = !1, next;\n      }\n      return next.done = !0, next;\n    };\n  }, e.values = values, Context.prototype = {\n    constructor: Context,\n    reset: function reset(e) {\n      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = \"next\", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) \"t\" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);\n    },\n    stop: function stop() {\n      this.done = !0;\n      var t = this.tryEntries[0].completion;\n      if (\"throw\" === t.type) throw t.arg;\n      return this.rval;\n    },\n    dispatchException: function dispatchException(e) {\n      if (this.done) throw e;\n      var r = this;\n      function handle(n, o) {\n        return a.type = \"throw\", a.arg = e, r.next = n, o && (r.method = \"next\", r.arg = t), !!o;\n      }\n      for (var o = this.tryEntries.length - 1; o >= 0; --o) {\n        var i = this.tryEntries[o],\n          a = i.completion;\n        if (\"root\" === i.tryLoc) return handle(\"end\");\n        if (i.tryLoc <= this.prev) {\n          var c = n.call(i, \"catchLoc\"),\n            u = n.call(i, \"finallyLoc\");\n          if (c && u) {\n            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);\n            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);\n          } else if (c) {\n            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);\n          } else {\n            if (!u) throw Error(\"try statement without catch or finally\");\n            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);\n          }\n        }\n      }\n    },\n    abrupt: function abrupt(t, e) {\n      for (var r = this.tryEntries.length - 1; r >= 0; --r) {\n        var o = this.tryEntries[r];\n        if (o.tryLoc <= this.prev && n.call(o, \"finallyLoc\") && this.prev < o.finallyLoc) {\n          var i = o;\n          break;\n        }\n      }\n      i && (\"break\" === t || \"continue\" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);\n      var a = i ? i.completion : {};\n      return a.type = t, a.arg = e, i ? (this.method = \"next\", this.next = i.finallyLoc, y) : this.complete(a);\n    },\n    complete: function complete(t, e) {\n      if (\"throw\" === t.type) throw t.arg;\n      return \"break\" === t.type || \"continue\" === t.type ? this.next = t.arg : \"return\" === t.type ? (this.rval = this.arg = t.arg, this.method = \"return\", this.next = \"end\") : \"normal\" === t.type && e && (this.next = e), y;\n    },\n    finish: function finish(t) {\n      for (var e = this.tryEntries.length - 1; e >= 0; --e) {\n        var r = this.tryEntries[e];\n        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;\n      }\n    },\n    \"catch\": function _catch(t) {\n      for (var e = this.tryEntries.length - 1; e >= 0; --e) {\n        var r = this.tryEntries[e];\n        if (r.tryLoc === t) {\n          var n = r.completion;\n          if (\"throw\" === n.type) {\n            var o = n.arg;\n            resetTryEntry(r);\n          }\n          return o;\n        }\n      }\n      throw Error(\"illegal catch attempt\");\n    },\n    delegateYield: function delegateYield(e, r, n) {\n      return this.delegate = {\n        iterator: values(e),\n        resultName: r,\n        nextLoc: n\n      }, \"next\" === this.method && (this.arg = t), y;\n    }\n  }, e;\n}\nmodule.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/regeneratorRuntime.js?");/***/},/* 90 *//***/function(module,exports,__webpack_require__){eval("/*\nCopyright (c) 2014-2016 Brion Vibber <brion@pobox.com>\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of\nthis software and associated documentation files (the \"Software\"), to deal in\nthe Software without restriction, including without limitation the rights to\nuse, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\nthe Software, and to permit persons to whom the Software is furnished to do so,\nsubject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\nFOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\nCOPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\nIN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\nCONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n*/\n(function() {\n\t\"use strict\";\n\n\tvar FrameSink = __webpack_require__(47),\n\t\tYCbCr = __webpack_require__(91);\n\n\t/**\n\t * @param {HTMLCanvasElement} canvas - HTML canvas eledment to attach to\n\t * @constructor\n\t */\n\tfunction SoftwareFrameSink(canvas) {\n\t\tvar self = this,\n\t\t\tctx = canvas.getContext('2d'),\n\t\t\timageData = null,\n\t\t\tresampleCanvas = null,\n\t\t\tresampleContext = null;\n\n\n\n\t\tfunction initImageData(width, height) {\n\t\t\timageData = ctx.createImageData(width, height);\n\n\t\t\t// Prefill the alpha to opaque\n\t\t\tvar data = imageData.data,\n\t\t\t\tpixelCount = width * height * 4;\n\t\t\tfor (var i = 0; i < pixelCount; i += 4) {\n\t\t\t\tdata[i + 3] = 255;\n\t\t\t}\n\t\t}\n\n\t\tfunction initResampleCanvas(cropWidth, cropHeight) {\n\t\t\tresampleCanvas = document.createElement('canvas');\n\t\t\tresampleCanvas.width = cropWidth;\n\t\t\tresampleCanvas.height = cropHeight;\n\t\t\tresampleContext = resampleCanvas.getContext('2d');\n\t\t}\n\n\t\t/**\n\t\t * Actually draw a frame into the canvas.\n\t\t * @param {YUVFrame} buffer - YUV frame buffer object to draw\n\t\t */\n\t\tself.drawFrame = function drawFrame(buffer) {\n\t\t\tvar format = buffer.format;\n\n\t\t\tif (canvas.width !== format.displayWidth || canvas.height !== format.displayHeight) {\n\t\t\t\t// Keep the canvas at the right size...\n\t\t\t\tcanvas.width = format.displayWidth;\n\t\t\t\tcanvas.height = format.displayHeight;\n\t\t\t}\n\n\t\t\tif (imageData === null ||\n\t\t\t\t\timageData.width != format.width ||\n\t\t\t\t\timageData.height != format.height) {\n\t\t\t\tinitImageData(format.width, format.height);\n\t\t\t}\n\n\t\t\t// YUV -> RGB over the entire encoded frame\n\t\t\tYCbCr.convertYCbCr(buffer, imageData.data);\n\n\t\t\tvar resample = (format.cropWidth != format.displayWidth || format.cropHeight != format.displayHeight);\n\t\t\tvar drawContext;\n\t\t\tif (resample) {\n\t\t\t\t// hack for non-square aspect-ratio\n\t\t\t\t// putImageData doesn't resample, so we have to draw in two steps.\n\t\t\t\tif (!resampleCanvas) {\n\t\t\t\t\tinitResampleCanvas(format.cropWidth, format.cropHeight);\n\t\t\t\t}\n\t\t\t\tdrawContext = resampleContext;\n\t\t\t} else {\n\t\t\t\tdrawContext = ctx;\n\t\t\t}\n\n\t\t\t// Draw cropped frame to either the final or temporary canvas\n\t\t\tdrawContext.putImageData(imageData,\n\t\t\t\t-format.cropLeft, -format.cropTop, // must offset the offset\n\t\t\t\tformat.cropLeft, format.cropTop,\n\t\t\t\tformat.cropWidth, format.cropHeight);\n\n\t\t\tif (resample) {\n\t\t\t\tctx.drawImage(resampleCanvas, 0, 0, format.displayWidth, format.displayHeight);\n\t\t\t}\n\t\t};\n\n\t\tself.clear = function() {\n\t\t\tctx.clearRect(0, 0, canvas.width, canvas.height);\n\t\t};\n\n\t\treturn self;\n\t}\n\n\tSoftwareFrameSink.prototype = Object.create(FrameSink.prototype);\n\n\tmodule.exports = SoftwareFrameSink;\n})();\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-canvas/src/SoftwareFrameSink.js?");/***/},/* 91 *//***/function(module,exports,__webpack_require__){eval("/*\nCopyright (c) 2014-2019 Brion Vibber <brion@pobox.com>\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of\nthis software and associated documentation files (the \"Software\"), to deal in\nthe Software without restriction, including without limitation the rights to\nuse, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\nthe Software, and to permit persons to whom the Software is furnished to do so,\nsubject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\nFOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\nCOPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\nIN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\nCONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n*/\n(function() {\n\t\"use strict\";\n\n\tvar depower = __webpack_require__(92);\n\n\t/**\n\t * Basic YCbCr->RGB conversion\n\t *\n\t * @author Brion Vibber <brion@pobox.com>\n\t * @copyright 2014-2019\n\t * @license MIT-style\n\t *\n\t * @param {YUVFrame} buffer - input frame buffer\n\t * @param {Uint8ClampedArray} output - array to draw RGBA into\n\t * Assumes that the output array already has alpha channel set to opaque.\n\t */\n\tfunction convertYCbCr(buffer, output) {\n\t\tvar width = buffer.format.width | 0,\n\t\t\theight = buffer.format.height | 0,\n\t\t\thdec = depower(buffer.format.width / buffer.format.chromaWidth) | 0,\n\t\t\tvdec = depower(buffer.format.height / buffer.format.chromaHeight) | 0,\n\t\t\tbytesY = buffer.y.bytes,\n\t\t\tbytesCb = buffer.u.bytes,\n\t\t\tbytesCr = buffer.v.bytes,\n\t\t\tstrideY = buffer.y.stride | 0,\n\t\t\tstrideCb = buffer.u.stride | 0,\n\t\t\tstrideCr = buffer.v.stride | 0,\n\t\t\toutStride = width << 2,\n\t\t\tYPtr = 0, Y0Ptr = 0, Y1Ptr = 0,\n\t\t\tCbPtr = 0, CrPtr = 0,\n\t\t\toutPtr = 0, outPtr0 = 0, outPtr1 = 0,\n\t\t\tcolorCb = 0, colorCr = 0,\n\t\t\tmultY = 0, multCrR = 0, multCbCrG = 0, multCbB = 0,\n\t\t\tx = 0, y = 0, xdec = 0, ydec = 0;\n\n\t\tif (hdec == 1 && vdec == 1) {\n\t\t\t// Optimize for 4:2:0, which is most common\n\t\t\toutPtr0 = 0;\n\t\t\toutPtr1 = outStride;\n\t\t\tydec = 0;\n\t\t\tfor (y = 0; y < height; y += 2) {\n\t\t\t\tY0Ptr = y * strideY | 0;\n\t\t\t\tY1Ptr = Y0Ptr + strideY | 0;\n\t\t\t\tCbPtr = ydec * strideCb | 0;\n\t\t\t\tCrPtr = ydec * strideCr | 0;\n\t\t\t\tfor (x = 0; x < width; x += 2) {\n\t\t\t\t\tcolorCb = bytesCb[CbPtr++] | 0;\n\t\t\t\t\tcolorCr = bytesCr[CrPtr++] | 0;\n\n\t\t\t\t\t// Quickie YUV conversion\n\t\t\t\t\t// https://en.wikipedia.org/wiki/YCbCr#ITU-R_BT.2020_conversion\n\t\t\t\t\t// multiplied by 256 for integer-friendliness\n\t\t\t\t\tmultCrR   = (409 * colorCr | 0) - 57088 | 0;\n\t\t\t\t\tmultCbCrG = (100 * colorCb | 0) + (208 * colorCr | 0) - 34816 | 0;\n\t\t\t\t\tmultCbB   = (516 * colorCb | 0) - 70912 | 0;\n\n\t\t\t\t\tmultY = 298 * bytesY[Y0Ptr++] | 0;\n\t\t\t\t\toutput[outPtr0    ] = (multY + multCrR) >> 8;\n\t\t\t\t\toutput[outPtr0 + 1] = (multY - multCbCrG) >> 8;\n\t\t\t\t\toutput[outPtr0 + 2] = (multY + multCbB) >> 8;\n\t\t\t\t\toutPtr0 += 4;\n\n\t\t\t\t\tmultY = 298 * bytesY[Y0Ptr++] | 0;\n\t\t\t\t\toutput[outPtr0    ] = (multY + multCrR) >> 8;\n\t\t\t\t\toutput[outPtr0 + 1] = (multY - multCbCrG) >> 8;\n\t\t\t\t\toutput[outPtr0 + 2] = (multY + multCbB) >> 8;\n\t\t\t\t\toutPtr0 += 4;\n\n\t\t\t\t\tmultY = 298 * bytesY[Y1Ptr++] | 0;\n\t\t\t\t\toutput[outPtr1    ] = (multY + multCrR) >> 8;\n\t\t\t\t\toutput[outPtr1 + 1] = (multY - multCbCrG) >> 8;\n\t\t\t\t\toutput[outPtr1 + 2] = (multY + multCbB) >> 8;\n\t\t\t\t\toutPtr1 += 4;\n\n\t\t\t\t\tmultY = 298 * bytesY[Y1Ptr++] | 0;\n\t\t\t\t\toutput[outPtr1    ] = (multY + multCrR) >> 8;\n\t\t\t\t\toutput[outPtr1 + 1] = (multY - multCbCrG) >> 8;\n\t\t\t\t\toutput[outPtr1 + 2] = (multY + multCbB) >> 8;\n\t\t\t\t\toutPtr1 += 4;\n\t\t\t\t}\n\t\t\t\toutPtr0 += outStride;\n\t\t\t\toutPtr1 += outStride;\n\t\t\t\tydec++;\n\t\t\t}\n\t\t} else {\n\t\t\toutPtr = 0;\n\t\t\tfor (y = 0; y < height; y++) {\n\t\t\t\txdec = 0;\n\t\t\t\tydec = y >> vdec;\n\t\t\t\tYPtr = y * strideY | 0;\n\t\t\t\tCbPtr = ydec * strideCb | 0;\n\t\t\t\tCrPtr = ydec * strideCr | 0;\n\n\t\t\t\tfor (x = 0; x < width; x++) {\n\t\t\t\t\txdec = x >> hdec;\n\t\t\t\t\tcolorCb = bytesCb[CbPtr + xdec] | 0;\n\t\t\t\t\tcolorCr = bytesCr[CrPtr + xdec] | 0;\n\n\t\t\t\t\t// Quickie YUV conversion\n\t\t\t\t\t// https://en.wikipedia.org/wiki/YCbCr#ITU-R_BT.2020_conversion\n\t\t\t\t\t// multiplied by 256 for integer-friendliness\n\t\t\t\t\tmultCrR   = (409 * colorCr | 0) - 57088 | 0;\n\t\t\t\t\tmultCbCrG = (100 * colorCb | 0) + (208 * colorCr | 0) - 34816 | 0;\n\t\t\t\t\tmultCbB   = (516 * colorCb | 0) - 70912 | 0;\n\n\t\t\t\t\tmultY = 298 * bytesY[YPtr++] | 0;\n\t\t\t\t\toutput[outPtr    ] = (multY + multCrR) >> 8;\n\t\t\t\t\toutput[outPtr + 1] = (multY - multCbCrG) >> 8;\n\t\t\t\t\toutput[outPtr + 2] = (multY + multCbB) >> 8;\n\t\t\t\t\toutPtr += 4;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\tmodule.exports = {\n\t\tconvertYCbCr: convertYCbCr\n\t};\n})();\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-canvas/src/YCbCr.js?");/***/},/* 92 *//***/function(module,exports){eval("/*\nCopyright (c) 2014-2016 Brion Vibber <brion@pobox.com>\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of\nthis software and associated documentation files (the \"Software\"), to deal in\nthe Software without restriction, including without limitation the rights to\nuse, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\nthe Software, and to permit persons to whom the Software is furnished to do so,\nsubject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\nFOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\nCOPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\nIN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\nCONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n*/\n(function() {\n  \"use strict\";\n\n  /**\n   * Convert a ratio into a bit-shift count; for instance a ratio of 2\n   * becomes a bit-shift of 1, while a ratio of 1 is a bit-shift of 0.\n   *\n   * @author Brion Vibber <brion@pobox.com>\n   * @copyright 2016\n   * @license MIT-style\n   *\n   * @param {number} ratio - the integer ratio to convert.\n   * @returns {number} - number of bits to shift to multiply/divide by the ratio.\n   * @throws exception if given a non-power-of-two\n   */\n  function depower(ratio) {\n    var shiftCount = 0,\n      n = ratio >> 1;\n    while (n != 0) {\n      n = n >> 1;\n      shiftCount++\n    }\n    if (ratio !== (1 << shiftCount)) {\n      throw 'chroma plane dimensions must be power of 2 ratio to luma plane dimensions; got ' + ratio;\n    }\n    return shiftCount;\n  }\n\n  module.exports = depower;\n})();\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-canvas/src/depower.js?");/***/},/* 93 *//***/function(module,exports,__webpack_require__){eval("/*\nCopyright (c) 2014-2016 Brion Vibber <brion@pobox.com>\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of\nthis software and associated documentation files (the \"Software\"), to deal in\nthe Software without restriction, including without limitation the rights to\nuse, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\nthe Software, and to permit persons to whom the Software is furnished to do so,\nsubject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\nFOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\nCOPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\nIN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\nCONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n*/\n(function() {\n\t\"use strict\";\n\n\tvar FrameSink = __webpack_require__(47),\n\t\tshaders = __webpack_require__(94);\n\n\t/**\n\t * Warning: canvas must not have been used for 2d drawing prior!\n\t *\n\t * @param {HTMLCanvasElement} canvas - HTML canvas element to attach to\n\t * @constructor\n\t */\n\tfunction WebGLFrameSink(canvas) {\n\t\tvar self = this,\n\t\t\tgl = WebGLFrameSink.contextForCanvas(canvas),\n\t\t\tdebug = false; // swap this to enable more error checks, which can slow down rendering\n\n\t\tif (gl === null) {\n\t\t\tthrow new Error('WebGL unavailable');\n\t\t}\n\n\t\t// GL!\n\t\tfunction checkError() {\n\t\t\tif (debug) {\n\t\t\t\terr = gl.getError();\n\t\t\t\tif (err !== 0) {\n\t\t\t\t\tthrow new Error(\"GL error \" + err);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tfunction compileShader(type, source) {\n\t\t\tvar shader = gl.createShader(type);\n\t\t\tgl.shaderSource(shader, source);\n\t\t\tgl.compileShader(shader);\n\n\t\t\tif (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {\n\t\t\t\tvar err = gl.getShaderInfoLog(shader);\n\t\t\t\tgl.deleteShader(shader);\n\t\t\t\tthrow new Error('GL shader compilation for ' + type + ' failed: ' + err);\n\t\t\t}\n\n\t\t\treturn shader;\n\t\t}\n\n\n\t\tvar program,\n\t\t\tunpackProgram,\n\t\t\terr;\n\n\t\t// In the world of GL there are no rectangles.\n\t\t// There are only triangles.\n\t\t// THERE IS NO SPOON.\n\t\tvar rectangle = new Float32Array([\n\t\t\t// First triangle (top left, clockwise)\n\t\t\t-1.0, -1.0,\n\t\t\t+1.0, -1.0,\n\t\t\t-1.0, +1.0,\n\n\t\t\t// Second triangle (bottom right, clockwise)\n\t\t\t-1.0, +1.0,\n\t\t\t+1.0, -1.0,\n\t\t\t+1.0, +1.0\n\t\t]);\n\n\t\tvar textures = {};\n\t\tvar framebuffers = {};\n\t\tvar stripes = {};\n\t\tvar buf, positionLocation, unpackPositionLocation;\n\t\tvar unpackTexturePositionBuffer, unpackTexturePositionLocation;\n\t\tvar stripeLocation, unpackTextureLocation;\n\t\tvar lumaPositionBuffer, lumaPositionLocation;\n\t\tvar chromaPositionBuffer, chromaPositionLocation;\n\n\t\tfunction createOrReuseTexture(name, formatUpdate) {\n\t\t\tif (!textures[name] || formatUpdate) {\n\t\t\t\ttextures[name] = gl.createTexture();\n\t\t\t}\n\t\t\treturn textures[name];\n\t\t}\n\n\t\tfunction uploadTexture(name, formatUpdate, width, height, data) {\n\t\t\tvar create = !textures[name] || formatUpdate;\n\t\t\tvar texture = createOrReuseTexture(name, formatUpdate);\n\t\t\tgl.activeTexture(gl.TEXTURE0);\n\n\t\t\tif (WebGLFrameSink.stripe) {\n\t\t\t\tvar uploadTemp = !textures[name + '_temp'] || formatUpdate;\n\t\t\t\tvar tempTexture = createOrReuseTexture(name + '_temp', formatUpdate);\n\t\t\t\tgl.bindTexture(gl.TEXTURE_2D, tempTexture);\n\t\t\t\tif (uploadTemp) {\n\t\t\t\t\t// new texture\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);\n\t\t\t\t\tgl.texImage2D(\n\t\t\t\t\t\tgl.TEXTURE_2D,\n\t\t\t\t\t\t0, // mip level\n\t\t\t\t\t\tgl.RGBA, // internal format\n\t\t\t\t\t\twidth / 4,\n\t\t\t\t\t\theight,\n\t\t\t\t\t\t0, // border\n\t\t\t\t\t\tgl.RGBA, // format\n\t\t\t\t\t\tgl.UNSIGNED_BYTE, // type\n\t\t\t\t\t\tdata // data!\n\t\t\t\t\t);\n\t\t\t\t} else {\n\t\t\t\t\t// update texture\n\t\t\t\t\tgl.texSubImage2D(\n\t\t\t\t\t\tgl.TEXTURE_2D,\n\t\t\t\t\t\t0, // mip level\n\t\t\t\t\t\t0, // x offset\n\t\t\t\t\t\t0, // y offset\n\t\t\t\t\t\twidth / 4,\n\t\t\t\t\t\theight,\n\t\t\t\t\t\tgl.RGBA, // format\n\t\t\t\t\t\tgl.UNSIGNED_BYTE, // type\n\t\t\t\t\t\tdata // data!\n\t\t\t\t\t);\n\t\t\t\t}\n\n\t\t\t\tvar stripeTexture = textures[name + '_stripe'];\n\t\t\t\tvar uploadStripe = !stripeTexture || formatUpdate;\n\t\t\t\tif (uploadStripe) {\n\t\t\t\t\tstripeTexture = createOrReuseTexture(name + '_stripe', formatUpdate);\n\t\t\t\t}\n\t\t\t\tgl.bindTexture(gl.TEXTURE_2D, stripeTexture);\n\t\t\t\tif (uploadStripe) {\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);\n\t\t\t\t\tgl.texImage2D(\n\t\t\t\t\t\tgl.TEXTURE_2D,\n\t\t\t\t\t\t0, // mip level\n\t\t\t\t\t\tgl.RGBA, // internal format\n\t\t\t\t\t\twidth,\n\t\t\t\t\t\t1,\n\t\t\t\t\t\t0, // border\n\t\t\t\t\t\tgl.RGBA, // format\n\t\t\t\t\t\tgl.UNSIGNED_BYTE, //type\n\t\t\t\t\t\tbuildStripe(width, 1) // data!\n\t\t\t\t\t);\n\t\t\t\t}\n\n\t\t\t} else {\n\t\t\t\tgl.bindTexture(gl.TEXTURE_2D, texture);\n\t\t\t\tif (create) {\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);\n\t\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);\n\t\t\t\t\tgl.texImage2D(\n\t\t\t\t\t\tgl.TEXTURE_2D,\n\t\t\t\t\t\t0, // mip level\n\t\t\t\t\t\tgl.ALPHA, // internal format\n\t\t\t\t\t\twidth,\n\t\t\t\t\t\theight,\n\t\t\t\t\t\t0, // border\n\t\t\t\t\t\tgl.ALPHA, // format\n\t\t\t\t\t\tgl.UNSIGNED_BYTE, //type\n\t\t\t\t\t\tdata // data!\n\t\t\t\t\t);\n\t\t\t\t} else {\n\t\t\t\t\tgl.texSubImage2D(\n\t\t\t\t\t\tgl.TEXTURE_2D,\n\t\t\t\t\t\t0, // mip level\n\t\t\t\t\t\t0, // x\n\t\t\t\t\t\t0, // y\n\t\t\t\t\t\twidth,\n\t\t\t\t\t\theight,\n\t\t\t\t\t\tgl.ALPHA, // internal format\n\t\t\t\t\t\tgl.UNSIGNED_BYTE, //type\n\t\t\t\t\t\tdata // data!\n\t\t\t\t\t);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tfunction unpackTexture(name, formatUpdate, width, height) {\n\t\t\tvar texture = textures[name];\n\n\t\t\t// Upload to a temporary RGBA texture, then unpack it.\n\t\t\t// This is faster than CPU-side swizzling in ANGLE on Windows.\n\t\t\tgl.useProgram(unpackProgram);\n\n\t\t\tvar fb = framebuffers[name];\n\t\t\tif (!fb || formatUpdate) {\n\t\t\t\t// Create a framebuffer and an empty target size\n\t\t\t\tgl.activeTexture(gl.TEXTURE0);\n\t\t\t\tgl.bindTexture(gl.TEXTURE_2D, texture);\n\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);\n\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);\n\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);\n\t\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);\n\t\t\t\tgl.texImage2D(\n\t\t\t\t\tgl.TEXTURE_2D,\n\t\t\t\t\t0, // mip level\n\t\t\t\t\tgl.RGBA, // internal format\n\t\t\t\t\twidth,\n\t\t\t\t\theight,\n\t\t\t\t\t0, // border\n\t\t\t\t\tgl.RGBA, // format\n\t\t\t\t\tgl.UNSIGNED_BYTE, //type\n\t\t\t\t\tnull // data!\n\t\t\t\t);\n\n\t\t\t\tfb = framebuffers[name] = gl.createFramebuffer();\n\t\t\t}\n\n\t\t\tgl.bindFramebuffer(gl.FRAMEBUFFER, fb);\n\t\t\tgl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);\n\n\t\t\tvar tempTexture = textures[name + '_temp'];\n\t\t\tgl.activeTexture(gl.TEXTURE1);\n\t\t\tgl.bindTexture(gl.TEXTURE_2D, tempTexture);\n\t\t\tgl.uniform1i(unpackTextureLocation, 1);\n\n\t\t\tvar stripeTexture = textures[name + '_stripe'];\n\t\t\tgl.activeTexture(gl.TEXTURE2);\n\t\t\tgl.bindTexture(gl.TEXTURE_2D, stripeTexture);\n\t\t\tgl.uniform1i(stripeLocation, 2);\n\n\t\t\t// Rectangle geometry\n\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, buf);\n\t\t\tgl.enableVertexAttribArray(positionLocation);\n\t\t\tgl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);\n\n\t\t\t// Set up the texture geometry...\n\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, unpackTexturePositionBuffer);\n\t\t\tgl.enableVertexAttribArray(unpackTexturePositionLocation);\n\t\t\tgl.vertexAttribPointer(unpackTexturePositionLocation, 2, gl.FLOAT, false, 0, 0);\n\n\t\t\t// Draw into the target texture...\n\t\t\tgl.viewport(0, 0, width, height);\n\n\t\t\tgl.drawArrays(gl.TRIANGLES, 0, rectangle.length / 2);\n\n\t\t\tgl.bindFramebuffer(gl.FRAMEBUFFER, null);\n\n\t\t}\n\n\t\tfunction attachTexture(name, register, index) {\n\t\t\tgl.activeTexture(register);\n\t\t\tgl.bindTexture(gl.TEXTURE_2D, textures[name]);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);\n\n\t\t\tgl.uniform1i(gl.getUniformLocation(program, name), index);\n\t\t}\n\n\t\tfunction buildStripe(width) {\n\t\t\tif (stripes[width]) {\n\t\t\t\treturn stripes[width];\n\t\t\t}\n\t\t\tvar len = width,\n\t\t\t\tout = new Uint32Array(len);\n\t\t\tfor (var i = 0; i < len; i += 4) {\n\t\t\t\tout[i    ] = 0x000000ff;\n\t\t\t\tout[i + 1] = 0x0000ff00;\n\t\t\t\tout[i + 2] = 0x00ff0000;\n\t\t\t\tout[i + 3] = 0xff000000;\n\t\t\t}\n\t\t\treturn stripes[width] = new Uint8Array(out.buffer);\n\t\t}\n\n\t\tfunction initProgram(vertexShaderSource, fragmentShaderSource) {\n\t\t\tvar vertexShader = compileShader(gl.VERTEX_SHADER, vertexShaderSource);\n\t\t\tvar fragmentShader = compileShader(gl.FRAGMENT_SHADER, fragmentShaderSource);\n\n\t\t\tvar program = gl.createProgram();\n\t\t\tgl.attachShader(program, vertexShader);\n\t\t\tgl.attachShader(program, fragmentShader);\n\n\t\t\tgl.linkProgram(program);\n\t\t\tif (!gl.getProgramParameter(program, gl.LINK_STATUS)) {\n\t\t\t\tvar err = gl.getProgramInfoLog(program);\n\t\t\t\tgl.deleteProgram(program);\n\t\t\t\tthrow new Error('GL program linking failed: ' + err);\n\t\t\t}\n\n\t\t\treturn program;\n\t\t}\n\n\t\tfunction init() {\n\t\t\tif (WebGLFrameSink.stripe) {\n\t\t\t\tunpackProgram = initProgram(shaders.vertexStripe, shaders.fragmentStripe);\n\t\t\t\tunpackPositionLocation = gl.getAttribLocation(unpackProgram, 'aPosition');\n\n\t\t\t\tunpackTexturePositionBuffer = gl.createBuffer();\n\t\t\t\tvar textureRectangle = new Float32Array([\n\t\t\t\t\t0, 0,\n\t\t\t\t\t1, 0,\n\t\t\t\t\t0, 1,\n\t\t\t\t\t0, 1,\n\t\t\t\t\t1, 0,\n\t\t\t\t\t1, 1\n\t\t\t\t]);\n\t\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, unpackTexturePositionBuffer);\n\t\t\t\tgl.bufferData(gl.ARRAY_BUFFER, textureRectangle, gl.STATIC_DRAW);\n\n\t\t\t\tunpackTexturePositionLocation = gl.getAttribLocation(unpackProgram, 'aTexturePosition');\n\t\t\t\tstripeLocation = gl.getUniformLocation(unpackProgram, 'uStripe');\n\t\t\t\tunpackTextureLocation = gl.getUniformLocation(unpackProgram, 'uTexture');\n\t\t\t}\n\t\t\tprogram = initProgram(shaders.vertex, shaders.fragment);\n\n\t\t\tbuf = gl.createBuffer();\n\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, buf);\n\t\t\tgl.bufferData(gl.ARRAY_BUFFER, rectangle, gl.STATIC_DRAW);\n\n\t\t\tpositionLocation = gl.getAttribLocation(program, 'aPosition');\n\t\t\tlumaPositionBuffer = gl.createBuffer();\n\t\t\tlumaPositionLocation = gl.getAttribLocation(program, 'aLumaPosition');\n\t\t\tchromaPositionBuffer = gl.createBuffer();\n\t\t\tchromaPositionLocation = gl.getAttribLocation(program, 'aChromaPosition');\n\t\t}\n\n\t\t/**\n\t\t * Actually draw a frame.\n\t\t * @param {YUVFrame} buffer - YUV frame buffer object\n\t\t */\n\t\tself.drawFrame = function(buffer) {\n\t\t\tvar format = buffer.format;\n\n\t\t\tvar formatUpdate = (!program || canvas.width !== format.displayWidth || canvas.height !== format.displayHeight);\n\t\t\tif (formatUpdate) {\n\t\t\t\t// Keep the canvas at the right size...\n\t\t\t\tcanvas.width = format.displayWidth;\n\t\t\t\tcanvas.height = format.displayHeight;\n\t\t\t\tself.clear();\n\t\t\t}\n\n\t\t\tif (!program) {\n\t\t\t\tinit();\n\t\t\t}\n\n\t\t\tif (formatUpdate) {\n\t\t\t\tvar setupTexturePosition = function(buffer, location, texWidth) {\n\t\t\t\t\t// Warning: assumes that the stride for Cb and Cr is the same size in output pixels\n\t\t\t\t\tvar textureX0 = format.cropLeft / texWidth;\n\t\t\t\t\tvar textureX1 = (format.cropLeft + format.cropWidth) / texWidth;\n\t\t\t\t\tvar textureY0 = (format.cropTop + format.cropHeight) / format.height;\n\t\t\t\t\tvar textureY1 = format.cropTop / format.height;\n\t\t\t\t\tvar textureRectangle = new Float32Array([\n\t\t\t\t\t\ttextureX0, textureY0,\n\t\t\t\t\t\ttextureX1, textureY0,\n\t\t\t\t\t\ttextureX0, textureY1,\n\t\t\t\t\t\ttextureX0, textureY1,\n\t\t\t\t\t\ttextureX1, textureY0,\n\t\t\t\t\t\ttextureX1, textureY1\n\t\t\t\t\t]);\n\n\t\t\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, buffer);\n\t\t\t\t\tgl.bufferData(gl.ARRAY_BUFFER, textureRectangle, gl.STATIC_DRAW);\n\t\t\t\t};\n\t\t\t\tsetupTexturePosition(\n\t\t\t\t\tlumaPositionBuffer,\n\t\t\t\t\tlumaPositionLocation,\n\t\t\t\t\tbuffer.y.stride);\n\t\t\t\tsetupTexturePosition(\n\t\t\t\t\tchromaPositionBuffer,\n\t\t\t\t\tchromaPositionLocation,\n\t\t\t\t\tbuffer.u.stride * format.width / format.chromaWidth);\n\t\t\t}\n\n\t\t\t// Create or update the textures...\n\t\t\tuploadTexture('uTextureY', formatUpdate, buffer.y.stride, format.height, buffer.y.bytes);\n\t\t\tuploadTexture('uTextureCb', formatUpdate, buffer.u.stride, format.chromaHeight, buffer.u.bytes);\n\t\t\tuploadTexture('uTextureCr', formatUpdate, buffer.v.stride, format.chromaHeight, buffer.v.bytes);\n\n\t\t\tif (WebGLFrameSink.stripe) {\n\t\t\t\t// Unpack the textures after upload to avoid blocking on GPU\n\t\t\t\tunpackTexture('uTextureY', formatUpdate, buffer.y.stride, format.height);\n\t\t\t\tunpackTexture('uTextureCb', formatUpdate, buffer.u.stride, format.chromaHeight);\n\t\t\t\tunpackTexture('uTextureCr', formatUpdate, buffer.v.stride, format.chromaHeight);\n\t\t\t}\n\n\t\t\t// Set up the rectangle and draw it\n\t\t\tgl.useProgram(program);\n\t\t\tgl.viewport(0, 0, canvas.width, canvas.height);\n\n\t\t\tattachTexture('uTextureY', gl.TEXTURE0, 0);\n\t\t\tattachTexture('uTextureCb', gl.TEXTURE1, 1);\n\t\t\tattachTexture('uTextureCr', gl.TEXTURE2, 2);\n\n\t\t\t// Set up geometry\n\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, buf);\n\t\t\tgl.enableVertexAttribArray(positionLocation);\n\t\t\tgl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);\n\n\t\t\t// Set up the texture geometry...\n\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, lumaPositionBuffer);\n\t\t\tgl.enableVertexAttribArray(lumaPositionLocation);\n\t\t\tgl.vertexAttribPointer(lumaPositionLocation, 2, gl.FLOAT, false, 0, 0);\n\n\t\t\tgl.bindBuffer(gl.ARRAY_BUFFER, chromaPositionBuffer);\n\t\t\tgl.enableVertexAttribArray(chromaPositionLocation);\n\t\t\tgl.vertexAttribPointer(chromaPositionLocation, 2, gl.FLOAT, false, 0, 0);\n\n\t\t\t// Aaaaand draw stuff.\n\t\t\tgl.drawArrays(gl.TRIANGLES, 0, rectangle.length / 2);\n\t\t};\n\n\t\tself.clear = function() {\n\t\t\tgl.viewport(0, 0, canvas.width, canvas.height);\n\t\t\tgl.clearColor(0.0, 0.0, 0.0, 0.0);\n\t\t\tgl.clear(gl.COLOR_BUFFER_BIT);\n\t\t};\n\n\t\tself.clear();\n\n\t\treturn self;\n\t}\n\n\t// Optional performance hack for Windows; luminance and alpha textures are\n\t// ssllooww to upload on some machines, so we pack into RGBA and unpack in\n\t// the shaders.\n\t//\n\t// Some browsers / GPUs seem to have no problem with this, others have\n\t// a huge impact in CPU doing the texture uploads.\n\t//\n\t// For instance on macOS 12.2 on a MacBook Pro 2018 with AMD GPU it\n\t// can real down at high res. This is partially compensated for by\n\t// improving the upload-vs-update behavior for the alpha textures.\n\t//\n\t// Currently keeping it off as of April 2022, but leaving it in so it\n\t// can be enabled if desired.\n\tWebGLFrameSink.stripe = false;\n\n\tWebGLFrameSink.contextForCanvas = function(canvas) {\n\t\tvar options = {\n\t\t\t// Don't trigger discrete GPU in multi-GPU systems\n\t\t\tpreferLowPowerToHighPerformance: true,\n\t\t\tpowerPreference: 'low-power',\n\t\t\t// Don't try to use software GL rendering!\n\t\t\tfailIfMajorPerformanceCaveat: true,\n\t\t\t// In case we need to capture the resulting output.\n\t\t\tpreserveDrawingBuffer: true\n\t\t};\n\t\treturn canvas.getContext('webgl', options) || canvas.getContext('experimental-webgl', options);\n\t};\n\n\t/**\n\t * Static function to check if WebGL will be available with appropriate features.\n\t *\n\t * @returns {boolean} - true if available\n\t */\n\tWebGLFrameSink.isAvailable = function() {\n\t\tvar canvas = document.createElement('canvas'),\n\t\t\tgl;\n\t\tcanvas.width = 1;\n\t\tcanvas.height = 1;\n\t\ttry {\n\t\t\tgl = WebGLFrameSink.contextForCanvas(canvas);\n\t\t} catch (e) {\n\t\t\treturn false;\n\t\t}\n\t\tif (gl) {\n\t\t\tvar register = gl.TEXTURE0,\n\t\t\t\twidth = 4,\n\t\t\t\theight = 4,\n\t\t\t\ttexture = gl.createTexture(),\n\t\t\t\tdata = new Uint8Array(width * height),\n\t\t\t\ttexWidth = WebGLFrameSink.stripe ? (width / 4) : width,\n\t\t\t\tformat = WebGLFrameSink.stripe ? gl.RGBA : gl.ALPHA,\n\t\t\t\tfilter = WebGLFrameSink.stripe ? gl.NEAREST : gl.LINEAR;\n\n\t\t\tgl.activeTexture(register);\n\t\t\tgl.bindTexture(gl.TEXTURE_2D, texture);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);\n\t\t\tgl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);\n\t\t\tgl.texImage2D(\n\t\t\t\tgl.TEXTURE_2D,\n\t\t\t\t0, // mip level\n\t\t\t\tformat, // internal format\n\t\t\t\ttexWidth,\n\t\t\t\theight,\n\t\t\t\t0, // border\n\t\t\t\tformat, // format\n\t\t\t\tgl.UNSIGNED_BYTE, //type\n\t\t\t\tdata // data!\n\t\t\t);\n\n\t\t\tvar err = gl.getError();\n\t\t\tif (err) {\n\t\t\t\t// Doesn't support alpha textures?\n\t\t\t\treturn false;\n\t\t\t} else {\n\t\t\t\treturn true;\n\t\t\t}\n\t\t} else {\n\t\t\treturn false;\n\t\t}\n\t};\n\n\tWebGLFrameSink.prototype = Object.create(FrameSink.prototype);\n\n\tmodule.exports = WebGLFrameSink;\n})();\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-canvas/src/WebGLFrameSink.js?");/***/},/* 94 *//***/function(module,exports){eval("module.exports = {\n  vertex: \"precision mediump float;\\n\\nattribute vec2 aPosition;\\nattribute vec2 aLumaPosition;\\nattribute vec2 aChromaPosition;\\nvarying vec2 vLumaPosition;\\nvarying vec2 vChromaPosition;\\nvoid main() {\\n    gl_Position = vec4(aPosition, 0, 1);\\n    vLumaPosition = aLumaPosition;\\n    vChromaPosition = aChromaPosition;\\n}\\n\",\n  fragment: \"// inspired by https://github.com/mbebenita/Broadway/blob/master/Player/canvas.js\\n\\nprecision mediump float;\\n\\nuniform sampler2D uTextureY;\\nuniform sampler2D uTextureCb;\\nuniform sampler2D uTextureCr;\\nvarying vec2 vLumaPosition;\\nvarying vec2 vChromaPosition;\\nvoid main() {\\n   // Y, Cb, and Cr planes are uploaded as ALPHA textures.\\n   float fY = texture2D(uTextureY, vLumaPosition).w;\\n   float fCb = texture2D(uTextureCb, vChromaPosition).w;\\n   float fCr = texture2D(uTextureCr, vChromaPosition).w;\\n\\n   // Premultipy the Y...\\n   float fYmul = fY * 1.1643828125;\\n\\n   // And convert that to RGB!\\n   gl_FragColor = vec4(\\n     fYmul + 1.59602734375 * fCr - 0.87078515625,\\n     fYmul - 0.39176171875 * fCb - 0.81296875 * fCr + 0.52959375,\\n     fYmul + 2.017234375   * fCb - 1.081390625,\\n     1\\n   );\\n}\\n\",\n  vertexStripe: \"precision mediump float;\\n\\nattribute vec2 aPosition;\\nattribute vec2 aTexturePosition;\\nvarying vec2 vTexturePosition;\\n\\nvoid main() {\\n    gl_Position = vec4(aPosition, 0, 1);\\n    vTexturePosition = aTexturePosition;\\n}\\n\",\n  fragmentStripe: \"// extra 'stripe' texture fiddling to work around IE 11's poor performance on gl.LUMINANCE and gl.ALPHA textures\\n\\nprecision mediump float;\\n\\nuniform sampler2D uStripe;\\nuniform sampler2D uTexture;\\nvarying vec2 vTexturePosition;\\nvoid main() {\\n   // Y, Cb, and Cr planes are mapped into a pseudo-RGBA texture\\n   // so we can upload them without expanding the bytes on IE 11\\n   // which doesn't allow LUMINANCE or ALPHA textures\\n   // The stripe textures mark which channel to keep for each pixel.\\n   // Each texture extraction will contain the relevant value in one\\n   // channel only.\\n\\n   float fLuminance = dot(\\n      texture2D(uStripe, vTexturePosition),\\n      texture2D(uTexture, vTexturePosition)\\n   );\\n\\n   gl_FragColor = vec4(0, 0, 0, fLuminance);\\n}\\n\"\n};\n\n\n//# sourceURL=webpack://H265Player/../node_modules/yuv-canvas/build/shaders.js?");/***/},/* 95 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);\n/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);\n/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);\n/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);\n/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59);\n/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__);\n/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);\n/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__);\n/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27);\n/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);\n/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17);\n/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__);\n/* harmony import */ var _Logger_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10);\n/* harmony import */ var _error_ThrowError_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24);\n\n\n\n\n\n\nfunction _createForOfIteratorHelper(r, e) { var t = \"undefined\" != typeof Symbol && r[Symbol.iterator] || r[\"@@iterator\"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && \"number\" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError(\"Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.\"); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }\nfunction _unsupportedIterableToArray(r, a) { if (r) { if (\"string\" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return \"Object\" === t && r.constructor && (t = r.constructor.name), \"Map\" === t || \"Set\" === t ? Array.from(r) : \"Arguments\" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }\nfunction _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }\n\n/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file HTTP.js\r\n * @desc\r\n * HTTP request tool by fetch API\r\n * @author Jarry\r\n * @see\r\n * https://github.github.io/fetch/\r\n */\n\n\nvar logger = _Logger_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ \"a\"].get('HTTP.js', {\n  level: 2\n});\nvar blob2ArrayBuffer = /*#__PURE__*/function () {\n  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee(blob) {\n    var arrayBuffer;\n    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee$(_context) {\n      while (1) switch (_context.prev = _context.next) {\n        case 0:\n          if (!(blob instanceof Blob)) {\n            _context.next = 5;\n            break;\n          }\n          _context.next = 3;\n          return new Response(blob).arrayBuffer();\n        case 3:\n          arrayBuffer = _context.sent;\n          return _context.abrupt(\"return\", new Uint8Array(arrayBuffer, 0));\n        case 5:\n        case \"end\":\n          return _context.stop();\n      }\n    }, _callee);\n  }));\n  return function blob2ArrayBuffer(_x) {\n    return _ref.apply(this, arguments);\n  };\n}();\nfunction setHeaders() {\n  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},\n    _ref2$headers = _ref2.headers,\n    headers = _ref2$headers === void 0 ? {} : _ref2$headers,\n    _ref2$method = _ref2.method,\n    method = _ref2$method === void 0 ? 'get' : _ref2$method,\n    username = _ref2.username,\n    password = _ref2.password,\n    token = _ref2.token;\n  var header = new Headers(headers);\n  if (username || password) {\n    if (!username) throw new TypeError('username required for basic authentication');\n    if (!password) throw new TypeError('password required for basic authentication');\n    var encode = (typeof win === \"undefined\" ? \"undefined\" : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default()(win)) === 'object' && win.btoa ? btoa : function (str) {\n      return str;\n    };\n    header.set('Authorization', 'Basic ' + encode(username + ':' + password));\n  }\n  if (token) header.set('Authorization', 'Bearer ' + token);\n  if (method !== 'get' && !header.get('content-type')) {\n    header.set('content-type', 'application/json');\n  }\n  return header;\n}\nvar queryStringify = function queryStringify(params) {\n  if (!params) {\n    return;\n  }\n  return Object.entries(params).reduce(function (acc, entry, index) {\n    var _entry = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(entry, 2),\n      param = _entry[0],\n      value = _entry[1];\n    var encoded = index === 0 ? param + '=' + encodeURIComponent(value) : '&' + param + '=' + encodeURIComponent(value);\n    return acc + encoded;\n  }, '');\n};\nvar makeURL = function makeURL(opts) {\n  var url = opts.url,\n    params = opts.params;\n  if (!params) {\n    return url;\n  }\n  return url + '?' + queryStringify(params);\n};\nfunction formatBody(opts) {\n  var type = opts.headers.get('content-type');\n  if (!type) {\n    return;\n  }\n  if (type.includes('json')) {\n    return JSON.stringify(opts.body);\n  }\n  if (type.includes('x-www-form-urlencoded')) {\n    return queryStringify(opts.body);\n  }\n  return opts.body;\n}\nfunction getHeaders(response) {\n  var getBrowserFetchHeaders = function getBrowserFetchHeaders(response) {\n    var headers = Object.create(Object.getPrototypeOf(response.headers));\n    var _iterator = _createForOfIteratorHelper(response.headers.entries()),\n      _step;\n    try {\n      for (_iterator.s(); !(_step = _iterator.n()).done;) {\n        var _step$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(_step.value, 2),\n          header = _step$value[0],\n          value = _step$value[1];\n        headers[header] = value;\n      }\n    } catch (err) {\n      _iterator.e(err);\n    } finally {\n      _iterator.f();\n    }\n    return headers;\n  };\n  var getNodeFetchHeaders = function getNodeFetchHeaders(response) {\n    var headers = {};\n    var h = response.headers.__headers__;\n    for (var header in h) {\n      headers[header] = h[header].join('');\n    }\n    return headers;\n  };\n  return response.headers.entries ? getBrowserFetchHeaders(response) : getNodeFetchHeaders(response);\n}\nfunction parseResponse(response, type) {\n  // Response object can only be used once.\n  // We clone the response object here so users can use it again if they want to.\n  // Checks required because browser support isn't solid.\n  // https://developer.mozilla.org/en-US/docs/Web/API/Response/clone\n\n  var clone = typeof response.clone === 'function' ? response.clone() : undefined;\n  var passedResponse = clone || response;\n  var formatOutput = function formatOutput(response, body) {\n    var headers = getHeaders(response);\n    // const headers = response.headers\n    var returnValue = {\n      body: body,\n      headers: headers,\n      response: response,\n      status: response.status,\n      statusText: response.statusText\n    };\n    return response.ok ? Promise.resolve(returnValue) : Promise.reject(returnValue);\n  };\n\n  // This will do response.json(), response.text(), etc.\n  // We use bracket notation to allow multiple types to be parsed at the same time.\n  return response[type]().then(function (body) {\n    return formatOutput(passedResponse, body);\n  });\n}\nfunction handleResponse(response, fileType) {\n  var type = response.headers.get('content-type');\n  var clone = response.clone();\n  var reader = clone.body.getReader();\n  var bytesReceived = 0;\n  var fetchDone = function fetchDone() {\n    if (fileType === 'ts' || fileType === 'video') {\n      return parseResponse(response, 'blob');\n    }\n    if (type.includes('json')) return parseResponse(response, 'json');\n    if (type.includes('text')) return parseResponse(response, 'text');\n    if (type.includes('form')) return parseResponse(response, 'formData');\n    if (type.includes('video') || type.includes('image') || type.includes('octet-stream')) {\n      return parseResponse(response, 'blob');\n    }\n    try {\n      return parseResponse(response, 'text');\n    } catch (e) {\n      // Need to check Blob and ArrayBuffer content types\n      Object(_error_ThrowError_js__WEBPACK_IMPORTED_MODULE_8__[/* throwError */ \"a\"])(e, '[HTTP>handleResponse:unknow content-type]', type, response);\n      return Promise.resolve(response);\n    }\n  };\n  var lastReceived = bytesReceived;\n  var intervalValue = 20;\n  var speedRatio = 1000 / intervalValue;\n  var loadedInterval = setInterval(function () {\n    var speed = (bytesReceived - lastReceived) * speedRatio;\n    if (speed <= 1) {\n      return;\n    }\n    logger.info('HTTP>handleResponse', \"\".concat(lastReceived, \" | \").concat(bytesReceived), \"\".concat(speed.toFixed(2), \" Bytes/s\"));\n    self.postMessage({\n      type: 'notice',\n      method: 'fetch',\n      noticeType: 'speed',\n      data: {\n        speed: speed,\n        intervalValue: intervalValue,\n        lastReceived: lastReceived,\n        bytesReceived: bytesReceived\n      }\n    });\n    lastReceived = bytesReceived;\n  }, intervalValue);\n  return reader.read().then(function processResult(result) {\n    if (result.done) {\n      // console.error(\"Fetch complete\")\n      clearInterval(loadedInterval);\n      return fetchDone();\n    }\n    bytesReceived += result.value.length;\n    return reader.read().then(processResult);\n  });\n}\nvar HTTP = /*#__PURE__*/function () {\n  function HTTP(options) {\n    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, HTTP);\n    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, \"options\", {\n      // 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',\n      'content-type': 'application/json;charset=UTF-8',\n      // cache: 'no-cache',\n      // credentials: 'same-origin',\n      // credentials: 'include',\n      mode: 'cors',\n      referrer: \"about:client\",\n      referrerPolicy: \"no-referrer-when-downgrade\"\n      // redirect: 'follow',\n      // referrer: 'no-referrer',\n    });\n    Object.assign(this.options, options);\n  }\n  return _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(HTTP, [{\n    key: \"setOptions\",\n    value: function setOptions(options) {\n      var opts = Object.assign(this.options, options);\n      opts.url = makeURL(opts);\n      opts.method = opts.method || 'get';\n      opts.headers = setHeaders(opts);\n      opts.body = formatBody(opts);\n      delete opts.username;\n      delete opts.password;\n      delete opts.token;\n      this.options = opts;\n    }\n  }, {\n    key: \"request\",\n    value: function request(url) {\n      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};\n      var fileType = arguments.length > 2 ? arguments[2] : undefined;\n      if (!url) {\n        logger.error('[HTTP>request]', 'url is undefined', 'url:', url, 'options:', options);\n        return;\n      }\n      this.setOptions(Object.assign({\n        url: url\n      }, options));\n      // console.error('request', this.options)\n      return fetch(this.options.url, this.options).then(function (response) {\n        return handleResponse(response, fileType);\n      });\n    }\n  }, {\n    key: \"fetch\",\n    value: function (_fetch) {\n      function fetch(_x2) {\n        return _fetch.apply(this, arguments);\n      }\n      fetch.toString = function () {\n        return _fetch.toString();\n      };\n      return fetch;\n    }( /*#__PURE__*/function () {\n      var _ref3 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee2(url) {\n        var options,\n          name,\n          fileType,\n          data,\n          _args2 = arguments;\n        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee2$(_context2) {\n          while (1) switch (_context2.prev = _context2.next) {\n            case 0:\n              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};\n              name = _args2.length > 2 ? _args2[2] : undefined;\n              fileType = _args2.length > 3 ? _args2[3] : undefined;\n              if (url) {\n                _context2.next = 6;\n                break;\n              }\n              logger.wran('[HTTP>fetch]', 'url is undefined', 'url:', url, 'options:', options);\n              return _context2.abrupt(\"return\");\n            case 6:\n              this.setOptions(Object.assign({\n                url: url\n              }, options));\n              logger.info('[HTTP>fetch]', 'http fetch', 'url:', url, 'options:', options);\n              _context2.next = 10;\n              return fetch(url, options);\n            case 10:\n              data = _context2.sent;\n              if (data.ok) {\n                data.text().then(function (body) {\n                  self.postMessage({\n                    type: 'invoke',\n                    method: 'fetch',\n                    fileType: fileType,\n                    name: name,\n                    data: body\n                  });\n                });\n              } else {\n                self.postMessage({\n                  result: 'failed'\n                });\n              }\n            case 12:\n            case \"end\":\n              return _context2.stop();\n          }\n        }, _callee2, this);\n      }));\n      return function (_x3) {\n        return _ref3.apply(this, arguments);\n      };\n    }())\n  }, {\n    key: \"get\",\n    value: function () {\n      var _get = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee3(url) {\n        var options,\n          name,\n          fileType,\n          data,\n          postData,\n          _args3 = arguments;\n        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee3$(_context3) {\n          while (1) switch (_context3.prev = _context3.next) {\n            case 0:\n              options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};\n              name = _args3.length > 2 ? _args3[2] : undefined;\n              fileType = _args3.length > 3 ? _args3[3] : undefined;\n              options.method = 'get';\n              logger.info('[HTTP>get]', 'http get', 'url:', url, 'options:', options, 'name:', name, 'fileType:', fileType);\n              postData = {\n                type: 'invoke',\n                method: 'get',\n                fileType: fileType,\n                name: name,\n                url: url\n              };\n              _context3.prev = 6;\n              _context3.next = 9;\n              return this.request.call(this, url, options, fileType);\n            case 9:\n              data = _context3.sent;\n              _context3.next = 15;\n              break;\n            case 12:\n              _context3.prev = 12;\n              _context3.t0 = _context3[\"catch\"](6);\n              logger.error('[HTTP>get]', 'networks error', 'url:', url, 'options:', options, 'name:', name, 'fileType:', fileType, 'ex:', _context3.t0);\n            case 15:\n              if (!(data && data.body)) {\n                _context3.next = 24;\n                break;\n              }\n              postData.data = data.body;\n              if (!(fileType === 'ts' || fileType === 'video')) {\n                _context3.next = 21;\n                break;\n              }\n              _context3.next = 20;\n              return blob2ArrayBuffer(postData.data);\n            case 20:\n              postData.arrayBuffer = _context3.sent;\n            case 21:\n              if (postData.arrayBuffer) {\n                self.postMessage(postData, [postData.arrayBuffer.buffer]);\n              } else {\n                self.postMessage(postData);\n              }\n              _context3.next = 27;\n              break;\n            case 24:\n              postData.type = 'error';\n              postData.data = data;\n              self.postMessage(postData);\n            case 27:\n            case \"end\":\n              return _context3.stop();\n          }\n        }, _callee3, this, [[6, 12]]);\n      }));\n      function get(_x4) {\n        return _get.apply(this, arguments);\n      }\n      return get;\n    }()\n  }]);\n}();\n/**\r\n * output object of HTTP\r\n * @usage\r\n * http.get('url', {})\r\n * http.post('url', {})\r\n */\nvar instance = null;\nvar http = function () {\n  if (!instance) {\n    instance = new HTTP({});\n  }\n  return instance;\n}();\n/* harmony default export */ __webpack_exports__[\"default\"] = (function (self) {\n  self.onmessage = function (event) {\n    var data = event.data;\n    var type = data.type;\n    var method = data.method;\n    switch (type) {\n      case 'invoke':\n        http[method].call(http, data.url, data.options, data.name, data.fileType);\n        break;\n      case 'notice':\n        break;\n      default:\n        break;\n    }\n  };\n});\n\n// export {\n//   http,\n//   HTTP\n// }\n\n//# sourceURL=webpack://H265Player/../src/toolkit/HTTP.js?");/***/},/* 96 *//***/function(module,exports){eval("function _arrayWithHoles(r) {\n  if (Array.isArray(r)) return r;\n}\nmodule.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/arrayWithHoles.js?");/***/},/* 97 *//***/function(module,exports){eval("function _iterableToArrayLimit(r, l) {\n  var t = null == r ? null : \"undefined\" != typeof Symbol && r[Symbol.iterator] || r[\"@@iterator\"];\n  if (null != t) {\n    var e,\n      n,\n      i,\n      u,\n      a = [],\n      f = !0,\n      o = !1;\n    try {\n      if (i = (t = t.call(r)).next, 0 === l) {\n        if (Object(t) !== t) return;\n        f = !1;\n      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);\n    } catch (r) {\n      o = !0, n = r;\n    } finally {\n      try {\n        if (!f && null != t[\"return\"] && (u = t[\"return\"](), Object(u) !== u)) return;\n      } finally {\n        if (o) throw n;\n      }\n    }\n    return a;\n  }\n}\nmodule.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/iterableToArrayLimit.js?");/***/},/* 98 *//***/function(module,exports,__webpack_require__){eval("var arrayLikeToArray = __webpack_require__(99);\nfunction _unsupportedIterableToArray(r, a) {\n  if (r) {\n    if (\"string\" == typeof r) return arrayLikeToArray(r, a);\n    var t = {}.toString.call(r).slice(8, -1);\n    return \"Object\" === t && r.constructor && (t = r.constructor.name), \"Map\" === t || \"Set\" === t ? Array.from(r) : \"Arguments\" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;\n  }\n}\nmodule.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js?");/***/},/* 99 *//***/function(module,exports){eval("function _arrayLikeToArray(r, a) {\n  (null == a || a > r.length) && (a = r.length);\n  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];\n  return n;\n}\nmodule.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/arrayLikeToArray.js?");/***/},/* 100 *//***/function(module,exports){eval("function _nonIterableRest() {\n  throw new TypeError(\"Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.\");\n}\nmodule.exports = _nonIterableRest, module.exports.__esModule = true, module.exports[\"default\"] = module.exports;\n\n//# sourceURL=webpack://H265Player/../node_modules/@babel/runtime/helpers/nonIterableRest.js?");/***/},,,,,,,,,,,,,,,,,,,,,,,,,,,,,/* 101 *//* 102 *//* 103 *//* 104 *//* 105 *//* 106 *//* 107 *//* 108 *//* 109 *//* 110 *//* 111 *//* 112 *//* 113 *//* 114 *//* 115 *//* 116 *//* 117 *//* 118 *//* 119 *//* 120 *//* 121 *//* 122 *//* 123 *//* 124 *//* 125 *//* 126 *//* 127 *//* 128 *//* 129 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";eval("// ESM COMPAT FLAG\n__webpack_require__.r(__webpack_exports__);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/classCallCheck.js\nvar classCallCheck = __webpack_require__(2);\nvar classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);\n\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/createClass.js\nvar createClass = __webpack_require__(3);\nvar createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);\n\n// EXTERNAL MODULE: ../src/config/Config.js\nvar Config = __webpack_require__(8);\n\n// CONCATENATED MODULE: ../src/decode/FFmpegDecode.js\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: wasm methods to decode\r\n * @author: liuliguo \r\n * @file: FFmpegDecode.js\r\n */\nvar FFmpegDecode_FFmpegDecode = /*#__PURE__*/function () {\n  function FFmpegDecode(decode) {\n    classCallCheck_default()(this, FFmpegDecode);\n    this.decode = decode;\n    // In case multiple frames are decoded (flush)\n    this.result = [];\n  }\n  return createClass_default()(FFmpegDecode, [{\n    key: \"openDecode\",\n    value: function openDecode() {\n      var that = this;\n      var videoCallback = Module.addFunction(function (addr_y, addr_u, addr_v, stride_y, stride_u, stride_v, width, height, pts) {\n        var out_y = HEAPU8.subarray(addr_y, addr_y + stride_y * height);\n        var out_u = HEAPU8.subarray(addr_u, addr_u + stride_u * height / 2);\n        var out_v = HEAPU8.subarray(addr_v, addr_v + stride_v * height / 2);\n        var obj = {\n          stride_y: stride_y,\n          stride_u: stride_u,\n          stride_v: stride_v,\n          width: width,\n          height: height,\n          buf_y: new Uint8Array(out_y),\n          buf_u: new Uint8Array(out_u),\n          buf_v: new Uint8Array(out_v),\n          pts: pts\n        };\n        that.result.push(obj);\n      });\n      Module._openDecoder(videoCallback, 1);\n    }\n  }, {\n    key: \"decodeData\",\n    value: function decodeData(pes, pts) {\n      var fileSize = pes.length;\n      var cacheBuffer = Module._malloc(fileSize);\n      Module.HEAPU8.set(pes, cacheBuffer);\n      Module._decodeData(cacheBuffer, fileSize, pts);\n      Module._free(cacheBuffer);\n    }\n  }, {\n    key: \"flush\",\n    value: function flush() {\n      Module._flushDecoder();\n      while (this.checkData()) {\n        this.decode.getDecodeYUV();\n      }\n    }\n  }, {\n    key: \"closeDecode\",\n    value: function closeDecode() {\n      Module._closeDecoder();\n    }\n  }, {\n    key: \"getYUV\",\n    value: function getYUV() {\n      var res = null;\n      if (this.result.length > 0) {\n        res = this.result.shift();\n      }\n      return res;\n    }\n  }, {\n    key: \"checkData\",\n    value: function checkData() {\n      var length = this.result.length;\n      return length > 0;\n    }\n  }]);\n}();\n\n// CONCATENATED MODULE: ../src/decode/PCWDecode.js\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: decode methods in wasm\r\n * @author: liuliguo \r\n * @file: PCWDecode.js\r\n */\n\nvar PCWDecode_PCWDecode = /*#__PURE__*/function () {\n  function PCWDecode(decode) {\n    classCallCheck_default()(this, PCWDecode);\n    this.decode = decode;\n  }\n  return createClass_default()(PCWDecode, [{\n    key: \"openDecode\",\n    value: function openDecode() {\n      return _web_decoder_open();\n    }\n  }, {\n    key: \"closeDecode\",\n    value: function closeDecode(p) {\n      _web_decoder_close(p);\n    }\n  }, {\n    key: \"decodeData\",\n    value: function decodeData(pes, pts, p) {\n      var fileSize = pes.length || 0;\n      Module.ccall('web_decoder_decode_frame', 'number', ['number', 'array', 'number', 'number'], [p, pes, fileSize, pts]);\n    }\n  }, {\n    key: \"flush\",\n    value: function flush(p) {\n      var decode = this.decode;\n      if (_web_decoder_decode_frame) {\n        while (true) {\n          var ret = 0;\n          ret = _web_decoder_decode_frame(p, null, 0, 0);\n          if (ret < 0 || !_web_got_frame(p)) {\n            break;\n          } else {\n            decode.getDecodeYUV(p);\n          }\n        }\n      }\n    }\n  }, {\n    key: \"getYUV\",\n    value: function getYUV(p) {\n      var stride_y = _web_get_stride_y(p);\n      var stride_u = _web_get_stride_u(p);\n      var stride_v = _web_get_stride_v(p);\n      var width = _web_get_width(p);\n      var height = _web_get_height(p);\n      var addr_y = _web_get_frame_y(p);\n      var addr_u = _web_get_frame_u(p);\n      var addr_v = _web_get_frame_v(p);\n      var pts = parseInt(_web_got_frame_pts(p) * Config[\"a\" /* AV_TIME_BASE_Q */] * 1000);\n      var out_y = HEAPU8.subarray(addr_y, addr_y + stride_y * height);\n      var out_u = HEAPU8.subarray(addr_u, addr_u + stride_u * height / 2);\n      var out_v = HEAPU8.subarray(addr_v, addr_v + stride_v * height / 2);\n      return {\n        stride_y: stride_y,\n        stride_u: stride_u,\n        stride_v: stride_v,\n        width: width,\n        height: height,\n        buf_y: new Uint8Array(out_y),\n        buf_u: new Uint8Array(out_u),\n        buf_v: new Uint8Array(out_v),\n        pts: pts\n      };\n    }\n  }, {\n    key: \"checkData\",\n    value: function checkData(p) {\n      return _web_got_frame(p);\n    }\n  }]);\n}();\n\n// CONCATENATED MODULE: ../src/decode/Decode.js\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: decode h265 data\r\n * @author: liuliguo \r\n * @file: Decode.js\r\n */\n\n\n\nvar Decode_Decode = /*#__PURE__*/function () {\n  function Decode() {\n    classCallCheck_default()(this, Decode);\n    this.p = null;\n    this.ptsList = [];\n    this.ptsOffset = 0;\n    this.fps = 0;\n    this.lastDuration = 0;\n    this.previousPTS = 0;\n    this.status = false;\n    this.yuvArray = [];\n    this.decodeTool = null;\n  }\n  return createClass_default()(Decode, [{\n    key: \"loadWASM\",\n    value: function loadWASM(event) {\n      var libPath = event.data.libPath;\n      self.Module = {\n        locateFile: function locateFile(wasm) {\n          return libPath + wasm;\n        }\n      };\n      // self.importScripts(libPath + 'TAppDecoderStatic.js')\n      self.importScripts(libPath + 'libffmpeg.js');\n      self.Module.onRuntimeInitialized = function () {\n        console.log('wasm loaded');\n        if (!Module._web_decoder_open) {\n          self.decode.decodeTool = new FFmpegDecode_FFmpegDecode(self.decode, this.event);\n        } else {\n          self.decode.decodeTool = new PCWDecode_PCWDecode(self.decode, this.event);\n        }\n        self.decode.openDecode();\n        self.decode.onWasmLoaded();\n      };\n    }\n  }, {\n    key: \"openDecode\",\n    value: function openDecode() {\n      try {\n        if (!this.status) {\n          this.p = this.decodeTool.openDecode();\n          this.status = true;\n        }\n        console.log('opendecode');\n      } catch (e) {\n        console.error(e);\n      }\n    }\n  }, {\n    key: \"closeDecode\",\n    value: function closeDecode() {\n      if (this.status) {\n        this.decodeTool.closeDecode(this.p);\n        this.status = false;\n      }\n    }\n    //receive data and start decode\n  }, {\n    key: \"push\",\n    value: function push(dataArray) {\n      var _this = this;\n      dataArray.forEach(function (data) {\n        var pts = data.PTS;\n        var pes = data.data_byte;\n        var partEnd = data.partEnd;\n        var lastTS = data.lastTS;\n        var ptsList = _this.ptsList;\n        _this.insertSort(ptsList, parseInt(pts * Config[\"a\" /* AV_TIME_BASE_Q */] * 1000));\n        _this.decodeTool.decodeData(pes, pts, _this.p);\n        if (_this.decodeTool.checkData(_this.p)) {\n          _this.getDecodeYUV(_this.p, partEnd, lastTS);\n        }\n      });\n    }\n  }, {\n    key: \"getDecodeYUV\",\n    value: function getDecodeYUV(p, partEnd, lastTS) {\n      if (this.reseting) {\n        return;\n      }\n      var duration = 0;\n      if (!this.fps) {\n        this.fps = this.getFPS();\n      }\n      var yuv = this.decodeTool.getYUV(p);\n      var pts = this.ptsList.shift();\n      yuv.pts = pts;\n      if (this.previousPTS && pts) {\n        duration = parseInt(pts - this.previousPTS);\n        this.lastDuration = duration;\n      } else {\n        duration = this.lastDuration;\n      }\n      yuv.duration = duration;\n      yuv.fps = this.fps;\n      if (pts) {\n        this.previousPTS = pts;\n        this.yuvArray.push(yuv);\n        var length = this.yuvArray.length;\n        if (length > 10) {\n          self.postMessage({\n            type: 'decoded',\n            data: this.yuvArray\n          });\n          this.yuvArray = [];\n        }\n      }\n      if (partEnd) {\n        if (this.yuvArray.length) {\n          self.postMessage({\n            type: 'decoded',\n            data: this.yuvArray\n          });\n          this.yuvArray = [];\n        }\n        self.postMessage({\n          type: 'partEnd',\n          data: lastTS\n        });\n      }\n    }\n  }, {\n    key: \"reset\",\n    value: function reset() {\n      this.reseting = true;\n      this.ptsList = [];\n      this.ptsOffset = 0;\n      this.previousPTS = 0;\n      this.fps = 0;\n      this.yuvArray = [];\n      this.closeDecode();\n      this.openDecode();\n      self.postMessage({\n        type: 'resetEnd',\n        data: Date.now()\n      });\n      this.reseting = false;\n    }\n  }, {\n    key: \"flush\",\n    value: function flush() {\n      this.decodeTool.flush(this.p);\n      if (this.yuvArray.length) {\n        self.postMessage({\n          type: 'decoded',\n          data: this.yuvArray\n        });\n        this.yuvArray = [];\n      }\n      this.closeDecode();\n      self.postMessage({\n        type: 'flushEnd',\n        data: this.previousPTS\n      });\n    }\n  }, {\n    key: \"getFPS\",\n    value: function getFPS() {\n      var ptsList = this.ptsList;\n      var length = ptsList.length;\n      if (length >= 2) {\n        return Math.round(1000 / (ptsList[1] - ptsList[0]));\n      }\n      return null;\n    }\n  }, {\n    key: \"onWasmLoaded\",\n    value: function onWasmLoaded() {\n      self.postMessage({\n        type: 'dataProcessorReady'\n      });\n    }\n  }, {\n    key: \"insertSort\",\n    value: function insertSort(array, value) {\n      var length = array.length;\n      if (length === 0) {\n        array.push(value);\n        return;\n      }\n      for (var i = 0; i < length; i++) {\n        if (value < array[i]) {\n          var j = length;\n          while (j > i) {\n            array[j] = array[j - 1];\n            j--;\n          }\n          array[i] = value;\n          return;\n        }\n      }\n      array.push(value);\n    }\n  }]);\n}();\n/* harmony default export */ var decode_Decode = (Decode_Decode);\n// EXTERNAL MODULE: ../node_modules/@babel/runtime/helpers/defineProperty.js\nvar defineProperty = __webpack_require__(0);\nvar defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);\n\n// EXTERNAL MODULE: ../node_modules/demuxer/dist/demuxer.all.esm.js\nvar demuxer_all_esm = __webpack_require__(21);\n\n// CONCATENATED MODULE: ../src/demux/TsDemux.js\n\n\n\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: ts packet demux\r\n * @author: liuliguo \r\n * @file: TsDemux.js\r\n */\n\n\n\nvar TsDemux_TsDemux = /*#__PURE__*/function () {\n  function TsDemux(decode) {\n    classCallCheck_default()(this, TsDemux);\n    defineProperty_default()(this, \"previousPes\", {});\n    defineProperty_default()(this, \"maxAudioPTS\", 0);\n    defineProperty_default()(this, \"maxVideoPTS\", 0);\n    defineProperty_default()(this, \"offset\", 0);\n    if (!decode) {\n      console.error('class TsDemux need pass decode parmas');\n      return;\n    }\n    this.init();\n    this.dataArray = [];\n    this.videoArray = [];\n    this.audioArray = [];\n    this.decode = decode;\n  }\n  return createClass_default()(TsDemux, [{\n    key: \"init\",\n    value: function init() {\n      var _this = this;\n      try {\n        this.demuxer = new demuxer_all_esm[\"c\" /* TSDemux */]({\n          enableWorker: false,\n          debug: false,\n          onlyDemuxElementary: true\n        });\n        this.demuxer.on(demuxer_all_esm[\"a\" /* Events */].DEMUX_DATA, function (event) {\n          if (event instanceof Array) {\n            console.log('data');\n            _this.dataArray.push(event);\n            _this.demuxed(_this.dataArray);\n            _this.dataArray = [];\n          } else {\n            _this.dataArray.push(event);\n          }\n        });\n        this.demuxer.on(demuxer_all_esm[\"a\" /* Events */].DONE, function (event) {\n          var pes = {};\n          _this.demuxed(_this.dataArray);\n          _this.dataArray = [];\n          //one ts demux finished\n          _this.previousPes.partEnd = true;\n          //the last ts packet demux finished\n          _this.previousPes.lastTS = _this.isLast;\n          if (_this.isLast) {\n            _this.maxPTS = Math.min(_this.maxAudioPTS, _this.maxVideoPTS);\n            //the audio has finished\n            pes.audioEnd = true;\n            _this.audioQueue(pes);\n            self.postMessage({\n              type: 'demuxedAAC',\n              data: _this.audioArray\n            });\n            _this.audioArray = [];\n            self.postMessage({\n              type: 'maxPTS',\n              data: {\n                maxAudioPTS: _this.maxAudioPTS,\n                maxVideoPTS: _this.maxVideoPTS\n              }\n            });\n          } else {\n            self.postMessage({\n              type: 'demuxedAAC',\n              data: _this.audioArray\n            });\n            _this.audioArray = [];\n          }\n          //start decode H265\n          _this.decode.push(_this.videoArray);\n          _this.videoArray = [];\n          _this.previousPes = null;\n        });\n      } catch (error) {\n        console.error('init demuxer failed.');\n      }\n    }\n  }, {\n    key: \"push\",\n    value: function push(data) {\n      this.demuxer.push(data, {\n        done: true\n      });\n    }\n  }, {\n    key: \"demuxed\",\n    value: function demuxed(dataArray) {\n      var _this2 = this;\n      dataArray.forEach(function (data) {\n        _this2.tsDemuxed(data);\n      });\n    }\n  }, {\n    key: \"tsDemuxed\",\n    value: function tsDemuxed(data) {\n      var streamType = data.stream_type;\n      var pes = data.pes || {};\n      switch (streamType) {\n        //h265\n        case 36:\n          this.videoQueue(pes);\n          break;\n        case 3:\n        case 15:\n        case 17:\n          pes.PTS = Math.round(pes.PTS * Config[\"a\" /* AV_TIME_BASE_Q */] * 1000);\n          this.maxAudioPTS = Math.max(pes.PTS, this.maxAudioPTS);\n          this.audioQueue(pes);\n          break;\n        default:\n          break;\n      }\n    }\n  }, {\n    key: \"audioQueue\",\n    value: function audioQueue(pes) {\n      this.audioArray.push(pes);\n    }\n  }, {\n    key: \"videoQueue\",\n    value: function videoQueue(pes) {\n      this.previousPes = pes;\n      this.maxVideoPTS = Math.max(this.maxVideoPTS, pes.PTS);\n      this.videoArray.push(pes);\n    }\n  }, {\n    key: \"destroy\",\n    value: function destroy() {\n      this.demuxer.destroy();\n    }\n  }]);\n}();\n/* harmony default export */ var demux_TsDemux = (TsDemux_TsDemux);\n// CONCATENATED MODULE: ../src/data-processor/dataProcessor.js\n/**\r\n * @copyright: Copyright (C) 2019\r\n * @desc: demux and decode ts packet\r\n * @author: liuliguo \r\n * @file: dataProcessor.js\r\n */\n\n\n\nself.decode = new decode_Decode();\nself.demuxer = new demux_TsDemux(self.decode);\n/* harmony default export */ var dataProcessor = __webpack_exports__[\"default\"] = (function (self) {\n  self.onmessage = function (event) {\n    var data = event.data;\n    var type = data.type;\n    var buffer = data.data;\n    var isLast = data.isLast;\n    switch (type) {\n      case 'startDemux':\n        self.demuxer.isLast = isLast;\n        self.demuxer.push(buffer);\n        break;\n      case 'loadwasm':\n        self.decode.loadWASM(event);\n        break;\n      case 'flush':\n        self.decode.flush();\n        break;\n    }\n  };\n});\n\n//# sourceURL=webpack://H265Player/../src/data-processor/dataProcessor.js_+_4_modules?");/***/},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,/* 130 *//* 131 *//* 132 *//* 133 *//* 134 *//* 135 *//* 136 *//* 137 *//* 138 *//* 139 *//* 140 *//* 141 *//* 142 *//* 143 *//* 144 *//* 145 *//* 146 *//* 147 *//* 148 *//* 149 *//* 150 *//* 151 *//* 152 *//* 153 *//* 154 *//* 155 *//* 156 *//* 157 *//* 158 *//* 159 *//* 160 *//* 161 *//* 162 *//* 163 *//***/function(module,exports,__webpack_require__){eval("module.exports = __webpack_require__(164);\n\n\n//# sourceURL=webpack://H265Player/multi_../src/entry?");/***/},/* 164 *//***/function(module,exports,__webpack_require__){eval("/**\r\n * Copyright (C) 2019.\r\n * All Rights Reserved.\r\n * @file entry.js\r\n * @desc\r\n * entry file\r\n * @author Jarry\r\n */\n\nmodule.exports = __webpack_require__(84).default;\n\n//# sourceURL=webpack://H265Player/../src/entry.js?");/***/}]/******/));});/* WEBPACK VAR INJECTION */}).call(exports,__webpack_require__(72)(module));/***/},/* 72 *//***/function(module,exports){module.exports=function(module){if(!module.webpackPolyfill){module.deprecate=function(){};module.paths=[];// module.parent = undefined by default
if(!module.children)module.children=[];Object.defineProperty(module,"loaded",{enumerable:true,get:function get(){return module.l;}});Object.defineProperty(module,"id",{enumerable:true,get:function get(){return module.i;}});module.webpackPolyfill=1;}return module;};/***/},/* 73 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vodPlayer",staticClass:"vod-player",class:{'IOSFullScreen':_vm.isShowIOSFullScreen}},[_c('div',{staticClass:"vodInnerPlayer",style:_vm.LandscapeStyle},[!_vm.isWhitebord?[_vm.playerStatus=='init'||_vm.playerStatus=='pause'?_c('img',{staticClass:"playBtn",attrs:{"src":"https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/shanhu_play.png"},on:{"click":_vm.playClicked}}):_vm._e(),_vm._v(" "),_vm.playerStatus=='init'&&_vm.videoPoster!=''?_c('img',{staticClass:"coverImg",attrs:{"src":_vm.videoPoster},on:{"click":_vm.playClicked}}):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.playerStatus=='load',expression:"playerStatus == 'load'"}],staticClass:"tcp-loading-spinner"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:!_vm.isWhitebord,expression:"!isWhitebord"}],staticClass:"controns",on:{"mouseover":_vm.mouseOver,"mousemove":_vm.mousemove,"mouseleave":_vm.mouseLeave}},[_c('div',{ref:"tengface_vod_mainView",staticClass:"main",on:{"dblclick":_vm.shuaxingCliked}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.isSwifeMove,expression:"isSwifeMove"}],staticClass:"videoTimeTips"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.time2String(_vm.bodyTouchCurrentTimer))+"/"+_vm._s(_vm.time2String(_vm.videoDuration))+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"topView",style:{height:_vm.showControns?'calc(100% - 65px)':'100%'},on:{"touchstart":_vm.bodyTouchStart,"touchmove":_vm.bodyTouchMove,"touchend":_vm.bodyTouchEnd}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showControns,expression:"showControns"}],ref:"tengface_vod_bottomView",staticClass:"bottomView"},[_c('div',{ref:"tf_vod_progress_view",staticClass:"progress",on:{"click":_vm.onProgressClicked}},[_c('div',{ref:"tf_progress_point",staticClass:"tf_progress_point",style:{left:_vm.posi+'px'},on:{"touchstart":_vm.onTouchStart,"touchmove":_vm.onTouchMove,"touchend":_vm.onTouchEnd,"touchcancel":_vm.onTouchEnd}}),_vm._v(" "),_c('div',{ref:"tf_progress_view",staticClass:"tf_progress_view"})]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.playerStatus!='playing',expression:"playerStatus != 'playing'"}],staticClass:"shuaxing",attrs:{"src":"https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/shanhu_pause.png"},on:{"click":function click($event){return _vm.play();}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.playerStatus=='playing',expression:"playerStatus == 'playing'"}],staticClass:"shuaxing",attrs:{"src":"https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/player_pause.png"},on:{"click":function click($event){return _vm.pause();}}}),_vm._v(" "),_c('img',{staticClass:"quanping",attrs:{"src":"https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/quanping.png"},on:{"click":_vm.quanpingCliked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:_vm.isMuted,expression:"isMuted"}],staticClass:"jingying",attrs:{"src":"https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/jingyin.png"},on:{"click":_vm.jingyingClicked}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:!_vm.isMuted,expression:"!isMuted"}],staticClass:"yingliang",attrs:{"src":"https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/yinliang.png"},on:{"click":_vm.jingyingClicked}}),_vm._v(" "),_c('div',{staticClass:"timesSpeed",on:{"click":function click($event){_vm.timesListViewShow=!_vm.timesListViewShow;}}},[_vm._v(_vm._s(_vm.playSpeed)+"x")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.timesListViewShow,expression:"timesListViewShow"}],staticClass:"timesListView"},[!_vm.iOS&&!_vm.isPad?[_c('p',{class:{'speedSelect':_vm.playSpeed==3},on:{"click":function click($event){return _vm.changePlaySpeed(3);}}},[_vm._v("3x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==2.5},on:{"click":function click($event){return _vm.changePlaySpeed(2.5);}}},[_vm._v("2.5x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==2.25},on:{"click":function click($event){return _vm.changePlaySpeed(2.25);}}},[_vm._v("2.25x")])]:_vm._e(),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==2},on:{"click":function click($event){return _vm.changePlaySpeed(2);}}},[_vm._v("2x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==1.5},on:{"click":function click($event){return _vm.changePlaySpeed(1.5);}}},[_vm._v("1.5x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==1.25},on:{"click":function click($event){return _vm.changePlaySpeed(1.25);}}},[_vm._v("1.25x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==1},on:{"click":function click($event){return _vm.changePlaySpeed(1);}}},[_vm._v("1x")]),_vm._v(" "),_c('p',{class:{'speedSelect':_vm.playSpeed==0.75},on:{"click":function click($event){return _vm.changePlaySpeed(0.75);}}},[_vm._v("0.75x")])],2),_vm._v(" "),_vm.videoDuration>0?_c('div',{staticClass:"videoTimeBox"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.time2String(_vm.currentPlayTime))+"/"+_vm._s(_vm.time2String(_vm.videoDuration))+"\n\t\t\t\t")]):_vm._e()])])]),_vm._v(" "),_c('div',{ref:"internalVideo",staticClass:"player-container",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"id_video_vod_tengface2"+_vm.playerid}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.copyrightObj&&_vm.copyrightObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.copyrightObj&&_vm.copyrightObj.open,expression:"(copyrightObj && copyrightObj.open && isThird) || (isfullScreen && copyrightObj && copyrightObj.open)"}],staticClass:"copyright",style:{opacity:_vm.copyrightObj.copyrightTrans},attrs:{"id":"copyrightONE"}},[_c('div',{staticClass:"banquanText"},[_vm._v("\n\t\t\t"+_vm._s(_vm.copyrightObj.inputValue)+"\n\t\t")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.runObj&&_vm.runObj.open&&_vm.isThird||_vm.isfullScreen&&_vm.runObj&&_vm.runObj.open,expression:"(runObj && runObj.open && isThird) || (isfullScreen && runObj && runObj.open)"}],ref:"runBoxRef",staticClass:"runBox"},[_c('div',{staticClass:"runboxChild",class:{'rotate':_vm.rotateRunBox},style:{left:_vm.boxLeft+'px',top:_vm.boxTop+'px'},attrs:{"id":"runChilder"}},[_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_c('span',[_vm._v(_vm._s(_vm.nick))]),_vm.runObj.remark?_c('span',[_vm._v("("+_vm._s(_vm.remark)+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fName",style:{opacity:_vm.runObj.fontTrans,color:_vm.runObj.fontColor,fontSize:_vm.runObj.fontSize+'px'}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.fans_id))])])])],2)]);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};__webpack_exports__["a"]=esExports;/***/},/* 74 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm.isH265?_c('canvasPlayer',{ref:"vodPlayer",attrs:{"playerid":_vm.playerid,"isVertical":_vm.isVertical,"isPc":_vm.isPc,"isWhitebord":_vm.isWhitebord,"isThreeScreen":_vm.isThreeScreen,"runObj":_vm.runObj,"copyrightObj":_vm.copyrightObj,"fans_id":_vm.fans_id,"nick":_vm.nick,"remark":_vm.remark,"isThird":_vm.isThird},on:{"playerListener":_vm.playerListener}}):_c('vodePlayer',{ref:"vodPlayer",attrs:{"playerid":_vm.playerid,"isVertical":_vm.isVertical,"isPc":_vm.isPc,"isWhitebord":_vm.isWhitebord,"isThreeScreen":_vm.isThreeScreen,"runObj":_vm.runObj,"copyrightObj":_vm.copyrightObj,"fans_id":_vm.fans_id,"nick":_vm.nick,"remark":_vm.remark,"isThird":_vm.isThird},on:{"playerListener":_vm.playerListener}});};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};__webpack_exports__["a"]=esExports;/***/},/* 75 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";/* unused harmony export base64_encode *//* harmony export (immutable) */__webpack_exports__["a"]=base64_decode;// 定义 base64 编码表
var base64Table="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";// 编码函数
function base64_encode(data){var encoded="";var chr1=void 0,chr2=void 0,chr3=void 0,enc1=void 0,enc2=void 0,enc3=void 0,enc4=void 0;var i=0;while(i<data.length){chr1=data.charCodeAt(i++);chr2=data.charCodeAt(i++);chr3=data.charCodeAt(i++);enc1=chr1>>2;enc2=(chr1&3)<<4|chr2>>4;enc3=(chr2&15)<<2|chr3>>6;enc4=chr3&63;if(isNaN(chr2)){enc3=enc4=64;}else if(isNaN(chr3)){enc4=64;}encoded+=base64Table.charAt(enc1)+base64Table.charAt(enc2)+base64Table.charAt(enc3)+base64Table.charAt(enc4);}return encoded;}// 解码函数
function base64_decode(data){var decoded="";var chr1=void 0,chr2=void 0,chr3=void 0;var enc1=void 0,enc2=void 0,enc3=void 0,enc4=void 0;var i=0;while(i<data.length){enc1=base64Table.indexOf(data.charAt(i++));enc2=base64Table.indexOf(data.charAt(i++));enc3=base64Table.indexOf(data.charAt(i++));enc4=base64Table.indexOf(data.charAt(i++));chr1=enc1<<2|enc2>>4;chr2=(enc2&15)<<4|enc3>>2;chr3=(enc3&3)<<6|enc4;decoded+=String.fromCharCode(chr1);if(enc3!=64){decoded+=String.fromCharCode(chr2);}if(enc4!=64){decoded+=String.fromCharCode(chr3);}}return decoded;}/***/},/* 76 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";var render=function render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tf-player"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.showCover,expression:"showCover"}],staticClass:"bigplayimg"},[_c('img',{staticClass:"stop",class:{'VerticalImg':_vm.isVertical&&_vm.isPc},attrs:{"src":_vm.videoImg}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:_vm.initData&&_vm.initData.direct_seeding.direct_status=='running'&&(_vm.videoStatus==1||_vm.videoStatus==3)&&!_vm.isPc,expression:"initData && initData.direct_seeding.direct_status == 'running' && (videoStatus == 1 || videoStatus == 3) && !isPc"}],staticClass:"player-text",on:{"click":_vm.playVideoClickedBtn}},[_c('img',{staticStyle:{"width":"12px","height":"16px"},attrs:{"src":"https://shanhu-live-user-1317978474.cos.accelerate.myqcloud.com/web/common/playicon@2x.png"}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"7px"}},[_vm._v("点击观看")])]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoStatus==1||_vm.videoStatus==3)&&(_vm.isPc||!_vm.isPc&&_vm.initData&&_vm.initData.direct_seeding.direct_status!='running'),expression:"(videoStatus == 1 || videoStatus == 3) && (isPc || (!isPc && initData && initData.direct_seeding.direct_status != 'running'))"}],staticClass:"player-icon",attrs:{"src":"https://shanhu-live-1317978474.cos.accelerate.myqcloud.com/web/common/shanhu_play.png"},on:{"click":_vm.playVideoClickedBtn}}),_vm._v(" "),_c('VodePlayer',{directives:[{name:"show",rawName:"v-show",value:_vm.playType==4,expression:"playType == 4"}],ref:"vodPlayer",attrs:{"canPlayH265":_vm.canPlayH265,"playerid":_vm.playerid,"isVertical":_vm.isVertical,"isPc":_vm.isPc,"isWhitebord":_vm.isWhitebord,"isThreeScreen":_vm.isThreeScreen,"runObj":_vm.runObj,"copyrightObj":_vm.copyrightObj,"fans_id":_vm.fans_id,"nick":_vm.nick,"remark":_vm.remark,"isThird":_vm.isThird},on:{"playerListener":_vm.playerListener}}),_vm._v(" "),_c('LivePlayer',{directives:[{name:"show",rawName:"v-show",value:_vm.playType==2,expression:"playType == 2"}],ref:"livePlayer",attrs:{"isVertical":_vm.isVertical,"isWhitebord":_vm.isWhitebord,"playerid":_vm.playerid,"fakeLive":_vm.fakeLive,"isRTC":_vm.isRTC,"showWatermark":_vm.showWatermark,"isThreeScreen":_vm.isThreeScreen,"staff_id":_vm.staff_id,"isMiniWindow":_vm.isMiniWindow,"isShowMiniWindowIcon":_vm.isShowMiniWindowIcon,"shouldReportLiveInfo":_vm.shouldReportLiveInfo,"showH5Xianlu":_vm.showH5Xianlu,"runObj":_vm.runObj,"copyrightObj":_vm.copyrightObj,"fans_id":_vm.fans_id,"nick":_vm.nick,"remark":_vm.remark,"isThird":_vm.isThird},on:{"statusChange":_vm.statusChange,"changePlayType":_vm.changePlayType,"toStop":_vm.toStop,"unAutoPlay":_vm.unAutoPlay,"errorReport":_vm.errorReport,"showH5XianluAlert":function showH5XianluAlert($event){return _vm.$emit('showH5XianluAlert',_vm.playerid);},"cutSwitch":function cutSwitch($event){return _vm.$emit('cutSwitch');},"miniWidowsClick":function miniWidowsClick($event){return _vm.$emit('miniWidowsClick',_vm.playerid);}}}),_vm._v(" "),_c('FastLivePlayer',{directives:[{name:"show",rawName:"v-show",value:_vm.playType==3,expression:"playType == 3"}],ref:"fastLivePlayer",attrs:{"isVertical":_vm.isVertical,"isWhitebord":_vm.isWhitebord,"isThreeScreen":_vm.isThreeScreen,"playerid":_vm.playerid,"fakeLive":_vm.fakeLive,"ds_id":_vm.ds_id,"showWatermark":_vm.showWatermark,"staff_id":_vm.staff_id,"isMiniWindow":_vm.isMiniWindow,"isShowMiniWindowIcon":_vm.isShowMiniWindowIcon,"shouldReportLiveInfo":_vm.shouldReportLiveInfo,"showH5Xianlu":_vm.showH5Xianlu,"runObj":_vm.runObj,"copyrightObj":_vm.copyrightObj,"fans_id":_vm.fans_id,"nick":_vm.nick,"remark":_vm.remark,"isThird":_vm.isThird},on:{"changePlayType":_vm.changePlayType,"isSupportFastLive":_vm.isSupportFastLiveCallback,"statusChange":_vm.statusChange,"toStop":_vm.toStop,"unAutoPlay":_vm.unAutoPlay,"playFailed":_vm.playFailed,"errorReport":_vm.errorReport,"showH5XianluAlert":function showH5XianluAlert($event){return _vm.$emit('showH5XianluAlert',_vm.playerid);},"cutSwitch":function cutSwitch($event){return _vm.$emit('cutSwitch');},"miniWidowsClick":function miniWidowsClick($event){return _vm.$emit('miniWidowsClick',_vm.playerid);}}}),_vm._v(" "),_c('RtcPlayer',{directives:[{name:"show",rawName:"v-show",value:_vm.playType==1,expression:"playType == 1"}],ref:"rtcPlayer",attrs:{"isVertical":_vm.isVertical,"isWhitebord":_vm.isWhitebord,"isThreeScreen":_vm.isThreeScreen,"playerid":_vm.playerid,"ds_id":_vm.ds_id,"showWatermark":_vm.showWatermark,"staff_id":_vm.staff_id,"push_user":_vm.push_user,"isMiniWindow":_vm.isMiniWindow,"isShowMiniWindowIcon":_vm.isShowMiniWindowIcon,"isshanhu":_vm.initData&&_vm.initData.direct_seeding.im_type==2,"shouldReportLiveInfo":_vm.shouldReportLiveInfo,"showH5Xianlu":_vm.showH5Xianlu,"runObj":_vm.runObj,"copyrightObj":_vm.copyrightObj,"fans_id":_vm.fans_id,"nick":_vm.nick,"remark":_vm.remark,"isThird":_vm.isThird},on:{"changePlayType":_vm.changePlayType,"isSupportRTCCallback":_vm.isSupportRTCCallback,"statusChange":_vm.statusChange,"toStop":_vm.toStop,"unAutoPlay":_vm.unAutoPlay,"errorReport":_vm.errorReport,"showH5XianluAlert":function showH5XianluAlert($event){return _vm.$emit('showH5XianluAlert',_vm.playerid);},"cutSwitch":function cutSwitch($event){return _vm.$emit('cutSwitch');},"miniWidowsClick":function miniWidowsClick($event){return _vm.$emit('miniWidowsClick',_vm.playerid);}}})],1);};var staticRenderFns=[];var esExports={render:render,staticRenderFns:staticRenderFns/* harmony default export */};__webpack_exports__["a"]=esExports;/***/}]/******/)["default"]);});//# sourceMappingURL=TFPlayer.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(223),
  /* scopeId */
  "data-v-66572c50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  "data-v-0e265ae4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _loading = __webpack_require__(24);

var _loading2 = _interopRequireDefault(_loading);

var _event = __webpack_require__(12);

var _scroll = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('list'),
    sfc = _use[0],
    bem = _use[1],
    t = _use[2];

exports.default = sfc({
  model: {
    prop: 'loading'
  },
  props: {
    error: Boolean,
    loading: Boolean,
    finished: Boolean,
    errorText: String,
    loadingText: String,
    finishedText: String,
    immediateCheck: {
      type: Boolean,
      "default": true
    },
    offset: {
      type: Number,
      "default": 300
    },
    direction: {
      type: String,
      "default": 'down'
    }
  },
  mounted: function mounted() {
    this.scroller = (0, _scroll.getScrollEventTarget)(this.$el);
    this.handler(true);

    if (this.immediateCheck) {
      this.$nextTick(this.check);
    }
  },
  destroyed: function destroyed() {
    this.handler(false);
  },
  activated: function activated() {
    this.handler(true);
  },
  deactivated: function deactivated() {
    this.handler(false);
  },
  watch: {
    loading: function loading() {
      this.$nextTick(this.check);
    },
    finished: function finished() {
      this.$nextTick(this.check);
    }
  },
  methods: {
    check: function check() {
      if (this.loading || this.finished || this.error) {
        return;
      }

      var el = this.$el;
      var scroller = this.scroller;
      var scrollerHeight = (0, _scroll.getVisibleHeight)(scroller);
      /* istanbul ignore next */

      if (!scrollerHeight || window.getComputedStyle(el).display === 'none' || el.offsetParent === null) {
        return;
      }

      var offset = this.offset,
          direction = this.direction;

      function isReachEdge() {
        if (el === scroller) {
          var scrollTop = (0, _scroll.getScrollTop)(el);

          if (direction === 'up') {
            return scrollTop <= offset;
          }

          var targetBottom = scrollTop + scrollerHeight;
          return scroller.scrollHeight - targetBottom <= offset;
        }

        if (direction === 'up') {
          return (0, _scroll.getScrollTop)(scroller) - (0, _scroll.getElementTop)(el) <= offset;
        }

        var elBottom = (0, _scroll.getElementTop)(el) + (0, _scroll.getVisibleHeight)(el) - (0, _scroll.getElementTop)(scroller);
        return elBottom - scrollerHeight <= offset;
      }

      if (isReachEdge()) {
        this.$emit('input', true);
        this.$emit('load');
      }
    },
    clickErrorText: function clickErrorText() {
      this.$emit('update:error', false);
      this.$nextTick(this.check);
    },
    handler: function handler(bind) {
      /* istanbul ignore else */
      if (this.binded !== bind) {
        this.binded = bind;
        (bind ? _event.on : _event.off)(this.scroller, 'scroll', this.check);
      }
    }
  },
  render: function render(h) {
    return h("div", {
      "class": bem()
    }, [this.direction === 'down' && this.slots(), this.loading && h("div", {
      "class": bem('loading'),
      "key": "loading"
    }, [this.slots('loading') || [h(_loading2.default, {
      "class": bem('loading-icon')
    }), h("span", {
      "class": bem('loading-text')
    }, [this.loadingText || t('loading')])]]), this.finished && this.finishedText && h("div", {
      "class": bem('finished-text')
    }, [this.finishedText]), this.error && this.errorText && h("div", {
      "on": {
        "click": this.clickErrorText
      },
      "class": bem('error-text')
    }, [this.errorText]), this.direction === 'up' && this.slots()]);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(227);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _vue2.default();

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  "data-v-298085ff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(236)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  "data-v-933c8e94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  "data-v-335ee9f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  "data-v-c5cf5a4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var _touch = __webpack_require__(31);

var _scroll = __webpack_require__(27);

var _loading = __webpack_require__(24);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('pull-refresh'),
    sfc = _use[0],
    bem = _use[1],
    t = _use[2];

var TEXT_STATUS = ['pulling', 'loosing', 'success'];
exports.default = sfc({
  mixins: [_touch.TouchMixin],
  props: {
    disabled: Boolean,
    successText: String,
    pullingText: String,
    loosingText: String,
    loadingText: String,
    value: {
      type: Boolean,
      required: true
    },
    successDuration: {
      type: Number,
      "default": 500
    },
    animationDuration: {
      type: Number,
      "default": 300
    },
    headHeight: {
      type: Number,
      "default": 50
    }
  },
  data: function data() {
    return {
      status: 'normal',
      height: 0,
      duration: 0
    };
  },
  computed: {
    untouchable: function untouchable() {
      return this.status === 'loading' || this.status === 'success' || this.disabled;
    }
  },
  watch: {
    value: function value(loading) {
      var _this = this;

      this.duration = this.animationDuration;

      if (!loading && this.successText) {
        this.status = 'success';
        setTimeout(function () {
          _this.setStatus(0);
        }, this.successDuration);
      } else {
        this.setStatus(loading ? this.headHeight : 0, loading);
      }
    }
  },
  mounted: function mounted() {
    this.scrollEl = (0, _scroll.getScrollEventTarget)(this.$el);
  },
  methods: {
    onTouchStart: function onTouchStart(event) {
      if (!this.untouchable && this.getCeiling()) {
        this.duration = 0;
        this.touchStart(event);
      }
    },
    onTouchMove: function onTouchMove(event) {
      if (this.untouchable) {
        return;
      }

      this.touchMove(event);

      if (!this.ceiling && this.getCeiling()) {
        this.duration = 0;
        this.startY = event.touches[0].clientY;
        this.deltaY = 0;
      }

      if (this.ceiling && this.deltaY >= 0) {
        if (this.direction === 'vertical') {
          this.setStatus(this.ease(this.deltaY));
          (0, _event.preventDefault)(event);
        }
      }
    },
    onTouchEnd: function onTouchEnd() {
      if (!this.untouchable && this.ceiling && this.deltaY) {
        this.duration = this.animationDuration;

        if (this.status === 'loosing') {
          this.setStatus(this.headHeight, true);
          this.$emit('input', true);
          this.$emit('refresh');
        } else {
          this.setStatus(0);
        }
      }
    },
    getCeiling: function getCeiling() {
      this.ceiling = (0, _scroll.getScrollTop)(this.scrollEl) === 0;
      return this.ceiling;
    },
    ease: function ease(height) {
      var headHeight = this.headHeight;
      return height < headHeight ? height : height < headHeight * 2 ? Math.round(headHeight + (height - headHeight) / 2) : Math.round(headHeight * 1.5 + (height - headHeight * 2) / 4);
    },
    setStatus: function setStatus(height, isLoading) {
      this.height = height;
      var status = isLoading ? 'loading' : height === 0 ? 'normal' : height < this.headHeight ? 'pulling' : 'loosing';

      if (status !== this.status) {
        this.status = status;
      }
    }
  },
  render: function render(h) {
    var status = this.status;
    var text = this[status + "Text"] || t(status);
    var style = {
      transition: this.duration + "ms",
      transform: this.height ? "translate3d(0," + this.height + "px, 0)" : ''
    };
    var Status = this.slots(status) || [TEXT_STATUS.indexOf(status) !== -1 && h("div", {
      "class": bem('text')
    }, [text]), status === 'loading' && h("div", {
      "class": bem('loading')
    }, [h(_loading2.default), h("span", [text])])];
    return h("div", {
      "class": bem()
    }, [h("div", {
      "class": bem('track'),
      "style": style,
      "on": {
        "touchstart": this.onTouchStart,
        "touchmove": this.onTouchMove,
        "touchend": this.onTouchEnd,
        "touchcancel": this.onTouchEnd
      }
    }, [h("div", {
      "class": bem('head')
    }, [Status]), this.slots()])]);
  }
});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(251);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  "data-v-da03d81e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  "data-v-8b5a4e30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-8d479d24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('password-input'),
    sfc = _use[0],
    bem = _use[1];

function PasswordInput(h, props, slots, ctx) {
  var info = props.errorInfo || props.info;
  var Points = [];

  for (var i = 0; i < props.length; i++) {
    var _char = props.value[i];
    Points.push(h("li", {
      "class": "van-hairline"
    }, [props.mask ? h("i", {
      "style": {
        visibility: _char ? 'visible' : 'hidden'
      }
    }) : _char]));
  }

  return h("div", {
    "class": bem()
  }, [h("ul", (0, _babelHelperVueJsxMergeProps2.default)([{
    "class": [bem('security'), 'van-hairline--surround'],
    "on": {
      "touchstart": function touchstart(event) {
        event.stopPropagation();
        (0, _functional.emit)(ctx, 'focus', event);
      }
    }
  }, (0, _functional.inherit)(ctx, true)]), [Points]), info && h("div", {
    "class": bem(props.errorInfo ? 'error-info' : 'info')
  }, [info])]);
}

PasswordInput.props = {
  info: String,
  errorInfo: String,
  mask: {
    type: Boolean,
    "default": true
  },
  value: {
    type: String,
    "default": ''
  },
  length: {
    type: Number,
    "default": 6
  }
};
exports.default = sfc(PasswordInput);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(275);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(320),
  /* scopeId */
  "data-v-4b88013c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(319),
  /* scopeId */
  "data-v-71c958ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(329),
  /* scopeId */
  "data-v-f7bdc892",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(335)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(342),
  /* scopeId */
  "data-v-4b0693c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  "data-v-05ab0426",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  "data-v-6f42bad8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  "data-v-ad5dd668",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Notify = __webpack_require__(384);

var _Notify2 = _interopRequireDefault(_Notify);

var _color = __webpack_require__(120);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timer;
var instance;

function parseOptions(message) {
  return (0, _utils.isObj)(message) ? message : {
    message: message
  };
}

function Notify(options) {
  /* istanbul ignore if */
  if (_utils.isServer) {
    return;
  }

  if (!instance) {
    instance = (0, _functional.mount)(_Notify2.default);
  }

  options = (0, _extends3.default)({}, Notify.currentOptions, parseOptions(options));

  (0, _extends3.default)(instance, options);

  clearTimeout(timer);

  if (options.duration && options.duration > 0) {
    timer = setTimeout(Notify.clear, options.duration);
  }

  return instance;
}

function defaultOptions() {
  return {
    value: true,
    message: '',
    color: _color.WHITE,
    background: _color.RED,
    duration: 3000,
    className: ''
  };
}

Notify.clear = function () {
  if (instance) {
    instance.value = false;
  }
};

Notify.currentOptions = defaultOptions();

Notify.setDefaultOptions = function (options) {
  (0, _extends3.default)(Notify.currentOptions, options);
};

Notify.resetDefaultOptions = function () {
  Notify.currentOptions = defaultOptions();
};

Notify.install = function () {
  _vue2.default.use(_Notify2.default);
};

_vue2.default.prototype.$notify = Notify;
exports.default = Notify;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RED = exports.RED = '#f44';
var BLUE = exports.BLUE = '#1989fa';
var GREEN = exports.GREEN = '#07c160';
var WHITE = exports.WHITE = '#fff';
var GRAY_DARK = exports.GRAY_DARK = '#969799';

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(32);

__webpack_require__(385);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  "data-v-3a3aa7e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA0BJREFUWEfFl0uIj1EYxn9PRjbITiyUSxRZkUJizMIl1zAWFjYuxYbcYoONiSE2lMtKKbdyzaDcyi2ZhUQZlym5ZCNhodCrV+ebvv835/u+/39mak6d+vrO5X3O+z7ve54jermpl+1TNQAzGwhMBqaHPhjw7u1L6PcA748kfa/mcFUBMLN1wDZgWDWbAu+BvZKOlM0vBGBmdcBlYE7YqA24AlwFPgGfw/8hwFBgHjAfGB3+twALJP3JA5ILwMwagTNhYStwTNKxshP5uJmtAbxPCPOXSzobWxsFYGYzgVthwTlJDqbmZmZudFlY2CDpdnaTTgDMrA+QuGy3pF01W04tMDNfvzP8qpP0N71fDMA+YAvQJGlHd4wna81sD7AdaJa0NRdAKu6tkib2hPEUiKeBExV86PCAmQ0CnGwjgLVZwpnZHaAfsFLS6xg4MxsFnAZ+SKpPzwnEPAq8cyCSvvl4GsAi4ALQLslBVDQzexgKkYNcKOljxoCn4SXAPRf1oJm58eHAYkkXswAOAhuAE5JWRwCMBZzV44D7nu/JKYL3vF5MA14AjZJeRvY4DqwCDknamAXwAJgC1Eu6m+PiNIibofD4VC9Os4qM+yQzmwF4KB9KmpoF8AYYCYyR5BUv2swsDeK/GwEPX+7JU0T0CvkKeCvJ+VLBgR9Af2CgJP/ObRkQPq/UePDAAMAvqZ+S/LvHADwLcc/1XDUAuhICP7k3J+ZjL7uSPhSErzAEtZLwv9uDsSQ7nGBLJX3NIXEhCZNyeUDS5pI0rIh5hhPXgCWSfkX22A9sSpf5dCHyNLoOtEkaE1mcFKIo4TIgzktKbsGOrczMM8DDMFvSjSwJXXI9D6qnqBSvihWZQDJP0ZMlpdjV0vhEslXchkF6Hc4rpUWpWTZmZslltD4t1WLXscfQJViXhUgkfIkwaZE0Nz0eA+A68HeY1NOCpG9WH+ZJsrQe7LIwSQkRP09UFxaJ0rQu7K4ojerBiizIKRyuD5uCRPMp7UGsnsqR5SuAhnDn+/xml2JZHVjIgRwgHhIH0kmo5LDfhYcbjkrxmgGEHHfJ5qXUn2aTwrMs+zR7Ep5mdxOxUpaeVT3NyjbpznivA/gH3LSAMLz/CYQAAAAASUVORK5CYII="

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAA4CAYAAABE814IAAAAAXNSR0IArs4c6QAABVlJREFUaEPtmk2IHEUUx/+vZxGFhVnJIYeAGwQXEXQnhwgiSaaXePEQV8hZV8w5iZBrMJKrkKxng5qz4CZXZXvWeNvD7irksEIyI3gIEjILe1jE6SdV/THdM/XRM9PVCcMUBBKmUh+//r+PelWEWcsRoBmPPIEZkAFFzIAUBcIBrgL0UdSfmv3/x4fo8Yd0Hg+m0dy0CuHAY/2Gw0MAZ8jH7rRBMQG5AearANoAuvHG3wThePz3LsD+tEEZ2Ydw4H0P4NMICk8dlJGBSAxTDGUsINMMZWwg0wplQiBYAFMLRMvT4lMmAhKpZLqgTAxEAyWOzKUMX3Kqw22Ab5OPddXApa1YoZQXGIpc2lfkhzcGoZQGJKOUZ6BkWJHsljrF5GphRrQ+7pLPrzoFIqFs4jcQvQ8IGN7kGyh9hOxHCl8hH0fZKUr/fBx4QoZflr6P0gbMAGmGNSKEjoGgCXhBHIaNJsP1s8D8MujJXeC/A/OW55fBxy6Ant4HDvfMfefq4BOXrX3JD4cEUbpC4oTNcFLu76V35l/5D/r7G3iPrhk32Xv7Z2DhHHDURm17ydg3fOtHCc/Yl3mLVjhT1oiGdASENqJaitmpJkBwuIvazrvFgACoPXjJ3DcGjaMOattv5PsmTrVaIKK45N2ymX3v1LY0GdGsm0wUYus7vww5rvjaT+/De3hxYBnpR3IfdpOZOUAD8HZsfiRc+hZ8/BPZzfv9POjgVy3D1GQsQMR4Ylw55qNr0hzVLfyCfNwe/M2JyUg/skldENVNKim+eKAokPD1r6VDtUMORXGrVR2QoIAfsco744ALmkxxMwxPqap97hQii9QF/Mh7/wBzdWv0KKqQvqPeQ23ntFagqpDrLMpIkwlwEvAe2/xIbqMiIhx1lJsoAkTkNeE7v0QO9cldePuX1ECYO7TCJ1U/OlNI7EfaIFpEen4YXkL42nXw4vXI5h9ejJIpRSsE5MRlCB+idaiWkOtUIZFKsgVpzcc6dgEikZKL6dyE99fNsYFko5Y0l6GMNg256+SH4kZhqLlVSIA1wPtOa8jih7k6esKPiNbdQu2PD8YGUtyhqo/+FSgk60f0WHqn/wReXpQddAma1WQKgo1WEX5MPjYqV4g0m03ajWqu+jTeLnV7HpJzqNazkToHca6Q2I+IbPCKyWxEImV0hrADyTnn/UvRCTrX+h9EF3IrAoJVwPspWptaJbmvq3GsNpNJT7jC7JQOtU/neQNZALxnRseaKGC+AW//c2XoTcxKl1+I4364dAfy5KxxzNE3UR/7k/U5jTLJJEX8iA2Y3Ev9rPEAaB4jUSffI59XdX2rARJ4GT/yvAvP6lNutQrJlQOKaMFRH+YDEDfIl088lK0ShRSNNo4wxP6cOyBetb1nqQxIBEUkavJP1a1tUkV2MU6BxCfeK4Ao5lID4F1A1EnCdfLTV0mlw1HM2wKoVWReZ0CiMiIFAC0M79jdyyPLvOJeV6Tt2rdxToDIe17QYzWMNBiLxYmqVfJ+bWKllDGvKyD9apmsQYi9yvvUOFlNpjWHwFEJRU9J4yrdmPO6AbIpH9Gci937wPVPJg+xZI0jAyk6L/TJWQVADNtyCmS8ed0ASSvuMtjqFWL4UqOqIwrrSaXfNi9+ID9cU83hCEi2UpZc88Y+RK4i9SGfkQ/x7rWUxrkKnXFe5Z1MdmWlLCg7SP9ApxmaeY9WuFH2xAXmVV5yJ+twopBIvvIx3kbfuWa2zrwVp9Glhdw0mJvmBd8DeM0U6p0BySxQvBdpgrkJktliS3WFWLpSAvlOZeR5nQMpe6Oux5sBGSA8AzIDYja6mUIG+PwPvZGTV4x9vKUAAAAASUVORK5CYII="

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _shared = __webpack_require__(127);

var _functional = __webpack_require__(15);

var _router = __webpack_require__(78);

var _icon = __webpack_require__(23);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('cell'),
    sfc = _use[0],
    bem = _use[1];

function Cell(h, props, slots, ctx) {
  var icon = props.icon,
      size = props.size,
      title = props.title,
      label = props.label,
      value = props.value,
      isLink = props.isLink,
      arrowDirection = props.arrowDirection;
  var showTitle = slots.title || (0, _utils.isDef)(title);
  var showValue = slots["default"] || (0, _utils.isDef)(value);
  var showLabel = slots.label || (0, _utils.isDef)(label);
  var Label = showLabel && h("div", {
    "class": [bem('label'), props.labelClass]
  }, [slots.label ? slots.label() : label]);
  var Title = showTitle && h("div", {
    "class": [bem('title'), props.titleClass],
    "style": props.titleStyle
  }, [slots.title ? slots.title() : h("span", [title]), Label]);
  var Value = showValue && h("div", {
    "class": [bem('value', {
      alone: !slots.title && !title
    }), props.valueClass]
  }, [slots["default"] ? slots["default"]() : h("span", [value])]);
  var LeftIcon = slots.icon ? slots.icon() : icon && h(_icon2.default, {
    "class": bem('left-icon'),
    "attrs": {
      "name": icon
    }
  });
  var rightIconSlot = slots['right-icon'];
  var RightIcon = rightIconSlot ? rightIconSlot() : isLink && h(_icon2.default, {
    "class": bem('right-icon'),
    "attrs": {
      "name": arrowDirection ? "arrow-" + arrowDirection : 'arrow'
    }
  });

  var onClick = function onClick(event) {
    (0, _functional.emit)(ctx, 'click', event);
    (0, _router.functionalRoute)(ctx);
  };

  var classes = {
    center: props.center,
    required: props.required,
    borderless: !props.border,
    clickable: isLink || props.clickable
  };

  if (size) {
    classes[size] = size;
  }

  return h("div", (0, _babelHelperVueJsxMergeProps2.default)([{
    "class": bem(classes),
    "on": {
      "click": onClick
    }
  }, (0, _functional.inherit)(ctx)]), [LeftIcon, Title, Value, RightIcon, slots.extra && slots.extra()]);
}

Cell.props = (0, _extends3.default)({}, _shared.cellProps, _router.routeProps, {
  clickable: Boolean,
  arrowDirection: String
});
exports.default = sfc(Cell);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cellProps = exports.cellProps = {
  icon: String,
  size: String,
  center: Boolean,
  isLink: Boolean,
  required: Boolean,
  titleStyle: null,
  titleClass: null,
  valueClass: null,
  labelClass: null,
  title: [String, Number],
  value: [String, Number],
  label: [String, Number],
  border: {
    type: Boolean,
    "default": true
  }
};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAASdJREFUSEvF1jsOwjAMBuDfOQATJ+Aq3IW1ndoOSBSJIekEK3eDC8DEARoUBFXpI3ZKVBi6EOWTndgxGWPW1tozgAWAQ1EUJ0T8aa0TAFsADyLakNb6AmD1MYiozPN8H8M0xuystWVrr6sDbwCWbSAGOoA54k5VVSV1XR+7Ef2CjmCOSMl9xxZMQbm9XmAslMOc04C/ohKsB05FpdggGIqGYKOgFA3FvCCHuv87Rf26fNzN/ro0Q93FU1O95RzGRsiVzJTuxEYoQSWRNb1a2qR9qY0OSs5RirIplWBNugRPmxf01Vn0spAUtWRN79kLqb2hcwpFeykN3YDrSN1x5X/P05TIusch2WP+EWPOIUoplc4/Js4+CLdHfaXUIcuyqKP++8iaUf8JeZJs7DHuV2cAAAAASUVORK5CYII="

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAzFJREFUWEfVmT9ME1Ecx7+/1/ZKCbK0IYV6NL0LURI3Nbo6u5ioCYOTkxjcYXBywF0jTEwmxsDg4uxqok6YoMBdAye0wXZBAu2V3jO/y11zAbEUCnn8tqZ5v/e53//3HuEEIqUUKysrNxOJxB0p5XUAV6SUgwAuBer+EFEJwE8i+tZoND6NjIx8ISKv0+2okwWO4+Rc150A8AjA5U7WAvgF4K2maa91Xd847tpjAS4tLaU1TXsB4DGAJCuPx+Po7e1FT08PEomE/1sI4e/reR729/fRaDRQq9Wwu7vr/w6kDmDOdd3no6Oj1XagbQFXV1fHiOgVgAwr6+vrQ39/vw/WiTDo9vY2dnZ2wmUVIcREoVB4/z89RwJKKeO2bTPYE1aQSqWQyWR8a51G2KqVSgV7e3uhmlnDMJ4RUcvEUf3/BHQcJ+W67jyAu0SEdDrtW62bwtasVquQUrLaj5qmPdR1vUUd7nUIMLDcB4aLxWLIZrNIJv2w67rU63WUy2U0m00f0jCMewcteQjQsqwZdivDDQ0Nndql7b6KXb65uRlCzpqmOX6ki4OEeMduZbizstxBaLYkQ7K7hRBj0cRpWTAoJT84WzkZuh1z7SzJMcnJA6Diuu7VsAS1AC3LegNgnLN1cJCbwvlLqVQKs3vGNM2nTOADBh3C4iKs6/qZx91Rn87x6DgO/13XNM3kjuMDWpY1DWCSi/DAwMD5my6y49bWVljMX5qmOUXc+G3bXuPeyonRaYfo9tdwx+GE4d5tGEaelpeXb8Visc/cS4eHh7u934n0ra+v+7272WzepmKxOOl53jRnLWevCsLZzFkthJgiy7IWANzn2OMYVEF4oOBYJKIFBlwEcC2Xy51bYW5nBC7cGxv+yPidAX9zcc7n8+D2poJwb15b47xFhQFrXP8KhQKbVAU+v+UVi0W/Hl4IQOVdrGySENEi2bY9L6V8oGyZUb5QK9/qlB8WlB+3LsTAGlhR3ZGfAZU/NDGk0sfOcEpQ+uDOkMpffQRZre7lUehqpa/folOrsheYUUilr4CjoMpeoh88qESfITzPu8HPEACy0WcIAGV+hhBCfD3NM8RfmbxFe0u8h5wAAAAASUVORK5CYII="

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABG1JREFUWEfNmW1oW2UUx//nJmmerBSFKegU7BijgoqgmxuzJo2dCuqkoIUhdr3th+HL+kFB3AQhOETZF8HObl9skyqKpIg63zY289IR1EXYqOKGTFeYOlzEDyPNvU1yj9ybpEuaNvclceT5EMi95+V37/M855znXIKTEQpJvv7zmxmuIDPfC6YeAt0McFfJHF1h8F8gPkdEPxKKsdyJDacQCml23ZEdBV9q1y2cl/YA/AxAt9rRBfgiQB+QRzuY2zb9h1Vda4DHd60VbtoPolEAXqvGV5FTwTypFPg1bJ/+x8yWKaAvKe9k5nGAbjAzZu8+ZwjSnlxg6uNGeqsDxvrcQuoeB/CsPce2pQ8r2oUxBOOFlTRXBkwN+nyFzigzHrPtzoECEb7MubOD2BbNLVevB4z1uX2u7k+vFVwFyIAsXhhY/ibrAEVCPnQNpnW193xYCYSfq75ZA1jaEPjIwSy1TIVAO6s3zlVAPZR46Gzrd6tdds4oeb69EoKWAEVyeAJMNa/XrumWyTMfUvoizxs5Sf8pZ4jzLQjCpowM/oUYUSZ6kYByaqxTU8mjbdAzjgEoEvKbAPaaWm9e4DeXhvuzwfAlb1KeIcaTDUy+pQTC+wihkCSCv8/bz622af9moFcNhH/1JuSNIJwmxprVrfBFJbb+NvLNDm1hzfWdbXc2FBi44tKkBxeCk2mkd3tENp8CeJOZCZKKW0nMynuhQZ/i/2cQFpl5hxqIHNMdeOPyASK8bMmZhH3kTcgzhIZrwZKtFYUIGjGGcoHwh8Zanx3dDtaOgiFZMcrEM+RNDM8R6E5zBU6XY2S3uWxJgoleUv1Tbxt/kiM3CtbOwChsrQ0G/0QiLmdAWNtIhYHTqj98D04+fb3QvMesrB8mPqD6I69U7PqSI0eY+XFraBUpypBIyIp5/ON/FZJ64J+6jPTu60R28RsAWxvswGnFH5FBYGPdJeUxYrxjD86QVi0CAkT0Rc4/tcNQOznaJbTiV2DqrXfKXyva+icQDBn1XUdKvovy+IEA4RBw5DLAlqplJhpT/VMHDUdHhzqFcB8BOFjl+HtFKfbjkfezxrXUoE8UOk+BcYcDOD3RZWxsEujzpTBw32IgPLcEkO/8DMBDAM4qQuvFlqvnDJEcmQCz4/zOwBx5k8NRYnrK6hMy42e1I7t5qfqNyUJIeBcF1+tK/3vzFTtrkvKABnwCLuV7J8MIM04CNQETuUD4hdWclouPM0Dj6GAKrQdqh6mOJfDAQiDyeZ0TI7fPH1+2Nk1ZVhIwUp3zYoEzkuq6e+HhyT+rjYu4/CoIbzgiqlEqFwv6tSbKrW+VdV2PYuO4atiJyw+AcAKAp3lAlMutJgtWY6cRogDWgSHrnC2Aqy1YS08/PAFq05LfeOJ2PzTpjO197CwvnLY+uBuM7d76qOTY9m0eVWJEW7ffqgJZ+zYwq6OtHoI6aD+4RS1g4kllsUUt4GrO9m2iL89d1Z8hNGwCuIcg3VT7GUK7BNA5kpBu5jPEf3a9Alex0Qp3AAAAAElFTkSuQmCC"

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(134);

var _App2 = _interopRequireDefault(_App);

var _vueRouter = __webpack_require__(174);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

__webpack_require__(175);

var _vueClipboard = __webpack_require__(177);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

var _vueDompurifyHtml = __webpack_require__(179);

var _vueDompurifyHtml2 = _interopRequireDefault(_vueDompurifyHtml);

var _tf_web_log = __webpack_require__(67);

var _tf_web_log2 = _interopRequireDefault(_tf_web_log);

var _Home = __webpack_require__(181);

var _Home2 = _interopRequireDefault(_Home);

var _UserInfo = __webpack_require__(418);

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _InviteCard = __webpack_require__(423);

var _InviteCard2 = _interopRequireDefault(_InviteCard);

var _rewardRedBag = __webpack_require__(111);

var _rewardRedBag2 = _interopRequireDefault(_rewardRedBag);

var _Setting = __webpack_require__(428);

var _Setting2 = _interopRequireDefault(_Setting);

var _income = __webpack_require__(433);

var _income2 = _interopRequireDefault(_income);

var _passWord = __webpack_require__(438);

var _passWord2 = _interopRequireDefault(_passWord);

var _expend = __webpack_require__(443);

var _expend2 = _interopRequireDefault(_expend);

var _prizes = __webpack_require__(54);

var _prizes2 = _interopRequireDefault(_prizes);

var _winning = __webpack_require__(448);

var _winning2 = _interopRequireDefault(_winning);

var _cash = __webpack_require__(456);

var _cash2 = _interopRequireDefault(_cash);

var _cards = __webpack_require__(461);

var _cards2 = _interopRequireDefault(_cards);

var _quan = __webpack_require__(467);

var _quan2 = _interopRequireDefault(_quan);

var _payWatch = __webpack_require__(55);

var _payWatch2 = _interopRequireDefault(_payWatch);

var _historys = __webpack_require__(472);

var _historys2 = _interopRequireDefault(_historys);

var _signIn = __webpack_require__(477);

var _signIn2 = _interopRequireDefault(_signIn);

var _login = __webpack_require__(485);

var _login2 = _interopRequireDefault(_login);

var _scan = __webpack_require__(496);

var _scan2 = _interopRequireDefault(_scan);

var _check = __webpack_require__(501);

var _check2 = _interopRequireDefault(_check);

var _vertical = __webpack_require__(506);

var _vertical2 = _interopRequireDefault(_vertical);

var _telTest = __webpack_require__(41);

var _telTest2 = _interopRequireDefault(_telTest);

var _goWechat = __webpack_require__(525);

var _goWechat2 = _interopRequireDefault(_goWechat);

var _goodsDetail = __webpack_require__(530);

var _goodsDetail2 = _interopRequireDefault(_goodsDetail);

var _livestop = __webpack_require__(541);

var _livestop2 = _interopRequireDefault(_livestop);

var _Companyinformation = __webpack_require__(546);

var _Companyinformation2 = _interopRequireDefault(_Companyinformation);

var _Informationpage = __webpack_require__(554);

var _Informationpage2 = _interopRequireDefault(_Informationpage);

var _MyPage = __webpack_require__(562);

var _MyPage2 = _interopRequireDefault(_MyPage);

var _Learningrecord = __webpack_require__(567);

var _Learningrecord2 = _interopRequireDefault(_Learningrecord);

var _MyPurchased = __webpack_require__(572);

var _MyPurchased2 = _interopRequireDefault(_MyPurchased);

var _axios = __webpack_require__(28);

var _axios2 = _interopRequireDefault(_axios);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _store = __webpack_require__(68);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 3.0.1 将vueRouter对象绑定到Vue对象上


// 2.0 导入App.vue的vue对象
_vue2.default.use(_vueRouter2.default);

//导入一个全局的scss
// import "../statics/css/comment.scss";

//导入Vant
// import Vant from 'vant';
// import 'vant/lib/vant-css/index.css';


// 3.0 将vue-router集成到这个项目中来
// 1.0 导入vue核心包

// Vue.use(Vant);

//引入复制插件

_vue2.default.use(_vueClipboard2.default);
// import { Toast } from 'vant'
// Vue.use(Toast);

_vue2.default.use(_vueDompurifyHtml2.default);

var tfWebLog = _tf_web_log2.default.getInstance();
// 1H5  2web  3老师端windows  4跟进页  5小程序 6安卓 7ios 8学员端PC端  9老师端Mac
tfWebLog.init(1);
_vue2.default.prototype.$TFWebLog = tfWebLog;

// 3.0.2 导入路由规则对应的组件对象


// 3.0.2 定义路由规则
var router = new _vueRouter2.default({
  linkActiveClass: "mui-active", //改变路由激活时的class名称
  routes: [{
    path: "/",
    redirect: "/home"
  }, {
    path: "/home/",
    component: _Home2.default,
    name: "home"
  }, {
    path: "/home/:user",
    component: _Home2.default,
    name: "home"
  }, {
    path: "/invite",
    component: _InviteCard2.default,
    name: "InviteCard",
    meta: {
      title: "邀请卡"
    }
  }, {
    path: "/user",
    component: _UserInfo2.default,
    name: "UserInfo",
    meta: {
      title: "个人中心"
    }
  }, {
    path: "/set",
    component: _Setting2.default,
    name: "Setting",
    meta: {
      title: "设置"
    }
  }, {
    path: "/sendredbag",
    component: _rewardRedBag2.default,
    name: "redbag"
  }, {
    path: "/income",
    component: _income2.default,
    name: "income",
    meta: {
      title: "收入"
    }
  }, {
    path: "/passWord",
    component: _passWord2.default,
    name: "passWord"
  }, {
    path: "/expend",
    component: _expend2.default,
    name: "expend",
    meta: {
      title: "消费"
    }
  }, {
    path: "/prizes",
    component: _prizes2.default,
    name: "prizes"
  }, {
    path: "/winning",
    component: _winning2.default,
    name: "winning",
    meta: {
      title: "奖品中心"
    }
  }, {
    path: "/cash/:type",
    component: _cash2.default,
    name: "cash",
    meta: {
      title: "奖品列表"
    }
  }, {
    path: "/cards",
    component: _cards2.default,
    name: "cards",
    meta: {
      title: "我的卡包"
    }
  }, {
    path: "/quan/:id",
    component: _quan2.default,
    name: "quan",
    meta: {
      title: "我的消费券"
    }
  }, {
    path: "/payWatch/:type",
    component: _payWatch2.default,
    name: "payWatch"
  }, {
    path: "/payWatch/:type/:user",
    component: _payWatch2.default,
    name: "payWatch"
  }, {
    path: "/telTest",
    component: _telTest2.default,
    name: "telTest"
  }, {
    path: "/historys",
    component: _historys2.default,
    name: "historys",
    meta: {
      title: "观看记录"
    }
  }, {
    path: "/signIn",
    component: _signIn2.default,
    name: "signIn",
    meta: {
      title: "签到"
    }
  }, {
    path: "/login",
    component: _login2.default,
    name: "login",
    meta: {
      title: "登录"
    }
  }, {
    path: "/scan",
    component: _scan2.default,
    name: "scan",
    meta: {
      title: "扫码核销"
    }
  }, {
    path: "/check",
    component: _check2.default,
    name: "check",
    meta: {
      title: "核销信息"
    }
  }, {
    path: "/vertical",
    component: _vertical2.default,
    name: "vertical",
    meta: {
      title: "个人直播"
    }
  }, {
    path: "/vertical/:user",
    component: _vertical2.default,
    name: "vertical",
    meta: {
      title: "个人直播"
    }
  }, {
    path: "/goWechat",
    component: _goWechat2.default,
    name: "vertical",
    meta: {
      title: "跳微信小程序"
    }
  }, {
    path: "/goodsDetail",
    component: _goodsDetail2.default,
    name: "goodsDetail",
    meta: {
      title: "商品详情"
    }
  }, {
    path: "/livestop",
    component: _livestop2.default,
    name: "livestop",
    meta: {
      title: "视频暂停"
    }
  }, {
    path: "/Companyinformation",
    component: _Companyinformation2.default,
    name: "Companyinformation",
    meta: {
      title: "公司信息"
    }
  }, {
    path: "/Informationpage",
    component: _Informationpage2.default,
    name: "Informationpage",
    meta: {
      title: "店铺信息"
    }
  }, {
    path: "/MyPage",
    component: _MyPage2.default,
    name: "MyPage",
    meta: {
      title: "我的"
    }
  }, {
    path: "/Learningrecord",
    component: _Learningrecord2.default,
    name: "Learningrecord",
    meta: {
      title: "学习记录"
    }
  }, {
    path: "/MyPurchased",
    component: _MyPurchased2.default,
    name: "MyPurchased",
    meta: {
      title: "我的已购"
    }
  }]
});

router.beforeEach(function (to, from, next) {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

// 添加请求拦截器
_axios2.default.interceptors.request.use(function (config) {

  // 不需要拦截的请求
  if (config.url == 'https://webrtc.liveplay.myqcloud.com/webrtc/v1/pullstream') {
    return config;
  }
  if (config.url && config.url.indexOf("/user/index/checkToken") > -1) {
    var msmk_token1 = _Tools2.default.getCookie('netschool_token');
    config.data = 'token=' + msmk_token1;
    return config;
  }

  if (config.url && config.url.indexOf("/app/report/errorReport") > -1) {
    return config;
  }
  //增加token
  var users = JSON.parse(localStorage.getItem(_Tools.app_Id));
  if (users) {
    var msmk_token = users.token;
    config.data = "token=" + msmk_token + "&" + config.data;
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
_axios2.default.interceptors.response.use(function (response) {
  if (response.data.code == 100068 || response.data.code == 100067) {
    if (_Tools2.default.getIsDeveloper()) {
      alert("测试环境token无效：" + JSON.stringify(response.data));
    } else {
      //这里是正式环境需要重新登入
      console.log("response=appId=====" + _Tools.app_Id);
      if (_Tools.app_Id) {
        localStorage.removeItem(_Tools.app_Id);
        localStorage.removeItem("current_app_Id");
        _Tools2.default.delCookie('netschool_token');
      }
      // tools.login(app_Id, function(res) {
      //   console.log("需要重新登入",res);
      // });
      window.location.reload();
    }
  }

  if (response.data.token && _Tools.app_Id) {
    var users = JSON.parse(localStorage.getItem(_Tools.app_Id));
    if (users) {
      users.token = response.data.token;
      localStorage.setItem(_Tools.app_Id, JSON.stringify(users));
    }
  }

  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

_vue2.default.config.ignoredElements = ['wx-open-launch-weapp'];
_vue2.default.prototype.axios = _axios2.default;
// 5.0 利用Vue对象进行解析渲染


window.app = new _vue2.default({
  el: "#app",
  router: router,
  store: _store2.default,
  render: function render(c) {
    return c(_App2.default);
  } // es6的函数写法 =>：goes to
});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(133);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(58)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  "data-v-7cf3f2f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4094f706", content, true);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles(parentId, list) {
  var styles = [];
  var newStyles = {};
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] });
    } else {
      newStyles[id].parts.push(part);
    }
  }
  return styles;
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//

exports.default = {
	data: function data() {
		return {
			token: ""
		};
	},
	created: function created() {
		var _this = this;

		return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							console.log("p22222", Object({"NODE_ENV":"production"}));

						case 1:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	}
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _popup = __webpack_require__(30);

var _icon = __webpack_require__(23);

var _icon2 = _interopRequireDefault(_icon);

var _loading = __webpack_require__(24);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('toast'),
    sfc = _use[0],
    bem = _use[1];

var STYLE = ['success', 'fail', 'loading'];
exports.default = sfc({
  mixins: [_popup.PopupMixin],
  props: {
    className: null,
    forbidClick: Boolean,
    message: [String, Number],
    type: {
      type: String,
      "default": 'text'
    },
    loadingType: {
      type: String,
      "default": 'circular'
    },
    position: {
      type: String,
      "default": 'middle'
    },
    lockScroll: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      clickable: false
    };
  },
  mounted: function mounted() {
    this.toggleClickale();
  },
  destroyed: function destroyed() {
    this.toggleClickale();
  },
  watch: {
    value: function value() {
      this.toggleClickale();
    },
    forbidClick: function forbidClick() {
      this.toggleClickale();
    }
  },
  methods: {
    toggleClickale: function toggleClickale() {
      var clickable = this.value && this.forbidClick;

      if (this.clickable !== clickable) {
        this.clickable = clickable;
        var action = clickable ? 'add' : 'remove';
        document.body.classList[action]('van-toast--unclickable');
      }
    }
  },
  render: function render(h) {
    var _this = this;

    var type = this.type,
        message = this.message;
    var style = STYLE.indexOf(type) !== -1 ? 'default' : type;

    var Content = function Content() {
      switch (style) {
        case 'text':
          return h("div", [message]);

        case 'html':
          return h("div", {
            "domProps": {
              "innerHTML": message
            }
          });

        default:
          return [type === 'loading' ? h(_loading2.default, {
            "attrs": {
              "color": "white",
              "type": _this.loadingType
            }
          }) : h(_icon2.default, {
            "class": bem('icon'),
            "attrs": {
              "name": type
            }
          }), (0, _utils.isDef)(message) && h("div", {
            "class": bem('text')
          }, [message])];
      }
    };

    return h("transition", {
      "attrs": {
        "name": "van-fade"
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "class": [bem([style, this.position]), this.className]
    }, [Content()])]);
  }
});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.use = use;

var _bem = __webpack_require__(141);

var _sfc = __webpack_require__(142);

var _i18n = __webpack_require__(145);

function use(name) {
  name = 'van-' + name;
  return [(0, _sfc.useSFC)(name), (0, _bem.useBEM)(name), (0, _i18n.useI18N)(name)];
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * bem helper
 * b() // 'button'
 * b('text') // 'button__text'
 * b({ disabled }) // 'button button--disabled'
 * b('text', { disabled }) // 'button__text button__text--disabled'
 * b(['disabled', 'primary']) // 'button button--disabled button--primary'
 */
var ELEMENT = '__';
var MODS = '--';

function join(name, el, symbol) {
  return el ? name + symbol + el : name;
}

function prefix(name, mods) {
  if (typeof mods === 'string') {
    return join(name, mods, MODS);
  }

  if (Array.isArray(mods)) {
    return mods.map(function (item) {
      return prefix(name, item);
    });
  }

  var ret = {};

  if (mods) {
    Object.keys(mods).forEach(function (key) {
      ret[name + MODS + key] = mods[key];
    });
  }

  return ret;
}

var useBEM = exports.useBEM = function useBEM(name) {
  return function (el, mods) {
    if (el && typeof el !== 'string') {
      mods = el;
      el = '';
    }

    el = join(name, el, ELEMENT);
    return mods ? [el, prefix(el, mods)] : el;
  };
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSFC = undefined;
exports.unifySlots = unifySlots;

__webpack_require__(59);

var _ = __webpack_require__(5);

var _slots = __webpack_require__(144);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a basic component with common options
 */
var arrayProp = {
  type: Array,
  "default": function _default() {
    return [];
  }
};
var numberProp = {
  type: Number,
  "default": 0
};

function defaultProps(props) {
  Object.keys(props).forEach(function (key) {
    if (props[key] === Array) {
      props[key] = arrayProp;
    } else if (props[key] === Number) {
      props[key] = numberProp;
    }
  });
}

function install(Vue) {
  var name = this.name;
  Vue.component(name, this);
  Vue.component((0, _.camelize)("-" + name), this);
} // unify slots & scopedSlots


function unifySlots(context) {
  // use data.scopedSlots in lower Vue version
  var scopedSlots = context.scopedSlots || context.data.scopedSlots || {};
  var slots = context.slots();
  Object.keys(slots).forEach(function (key) {
    if (!scopedSlots[key]) {
      scopedSlots[key] = function () {
        return slots[key];
      };
    }
  });
  return scopedSlots;
} // should be removed after Vue 3

function transformFunctionComponent(pure) {
  return {
    functional: true,
    props: pure.props,
    model: pure.model,
    render: function render(h, context) {
      return pure(h, context.props, unifySlots(context), context);
    }
  };
}

var useSFC = exports.useSFC = function useSFC(name) {
  return function (sfc) {
    if (typeof sfc === 'function') {
      sfc = transformFunctionComponent(sfc);
    }

    if (!sfc.functional) {
      sfc.mixins = sfc.mixins || [];
      sfc.mixins.push(_slots.SlotsMixin);
    }

    if (sfc.props) {
      defaultProps(sfc.props);
    }

    sfc.name = name;
    sfc.install = install;
    return sfc;
  };
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: '姓名',
  tel: '电话',
  save: '保存',
  confirm: '确认',
  cancel: '取消',
  "delete": '删除',
  complete: '完成',
  loading: '加载中...',
  telEmpty: '请填写电话',
  nameEmpty: '请填写姓名',
  confirmDelete: '确定要删除么',
  telInvalid: '请填写正确的电话',
  vanContactCard: {
    addText: '添加联系人'
  },
  vanContactList: {
    addText: '新建联系人'
  },
  vanPagination: {
    prev: '上一页',
    next: '下一页'
  },
  vanPullRefresh: {
    pulling: '下拉即可刷新...',
    loosing: '释放即可刷新...'
  },
  vanSubmitBar: {
    label: '合计：'
  },
  vanCoupon: {
    valid: '有效期',
    unlimited: '无使用门槛',
    discount: function discount(_discount) {
      return _discount + '\u6298';
    },
    condition: function condition(_condition) {
      return '\u6EE1' + _condition + '\u5143\u53EF\u7528';
    }
  },
  vanCouponCell: {
    title: '优惠券',
    tips: '使用优惠',
    count: function count(_count) {
      return _count + '\u5F20\u53EF\u7528';
    }
  },
  vanCouponList: {
    empty: '暂无优惠券',
    exchange: '兑换',
    close: '不使用优惠',
    enable: '可使用优惠券',
    disabled: '不可使用优惠券',
    placeholder: '请输入优惠码'
  },
  vanAddressEdit: {
    area: '地区',
    postal: '邮政编码',
    areaEmpty: '请选择地区',
    addressEmpty: '请填写详细地址',
    postalEmpty: '邮政编码格式不正确',
    defaultAddress: '设为默认收货地址',
    telPlaceholder: '收货人手机号',
    namePlaceholder: '收货人姓名',
    areaPlaceholder: '选择省 / 市 / 区'
  },
  vanAddressEditDetail: {
    label: '详细地址',
    placeholder: '街道门牌、楼层房间号等信息'
  },
  vanAddressList: {
    add: '新增地址'
  }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Use scopedSlots in Vue 2.6+
 * downgrade to slots in lower version
 */
var SlotsMixin = exports.SlotsMixin = {
  methods: {
    slots: function slots(name, props) {
      if (name === void 0) {
        name = 'default';
      }

      var $slots = this.$slots,
          $scopedSlots = this.$scopedSlots;

      if ($scopedSlots[name]) {
        return $scopedSlots[name](props);
      }

      return $slots[name];
    }
  }
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useI18N = undefined;

var _ = __webpack_require__(5);

var _locale = __webpack_require__(59);

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useI18N = exports.useI18N = function useI18N(name) {
  var prefix = (0, _.camelize)(name) + '.';
  return function (path) {
    var message = (0, _.get)(_locale2.default.messages(), prefix + path) || (0, _.get)(_locale2.default.messages(), path);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return typeof message === 'function' ? message.apply(void 0, args) : message;
  };
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOverlay = updateOverlay;
exports.openOverlay = openOverlay;
exports.closeOverlay = closeOverlay;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _overlay = __webpack_require__(147);

var _overlay2 = _interopRequireDefault(_overlay);

var _context = __webpack_require__(61);

var _functional = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultConfig = {
  className: '',
  customStyle: {}
};
var overlay; // close popup when click overlay && closeOnClickOverlay is true

function onClickOverlay() {
  if (_context.context.top) {
    var vm = _context.context.top.vm;
    vm.$emit('click-overlay');

    if (vm.closeOnClickOverlay) {
      if (vm.onClickOverlay) {
        vm.onClickOverlay();
      } else {
        vm.close();
      }
    }
  }
}

function updateOverlay() {
  if (!overlay) {
    overlay = (0, _functional.mount)(_overlay2.default, {
      on: {
        click: onClickOverlay
      }
    });
  }

  if (_context.context.top) {
    var _context$top = _context.context.top,
        vm = _context$top.vm,
        config = _context$top.config;
    var el = vm.$el;
    var target = el && el.parentNode ? el.parentNode : document.body;

    if (target) {
      target.appendChild(overlay.$el);
    }

    (0, _extends3.default)(overlay, defaultConfig, config, {
      visible: true
    });
  } else {
    overlay.visible = false;
  }
}
function openOverlay(vm, config) {
  if (!_context.context.stack.some(function (item) {
    return item.vm === vm;
  })) {
    _context.context.stack.push({
      vm: vm,
      config: config
    });
    updateOverlay();
  }
}
function closeOverlay(vm) {
  var stack = _context.context.stack;

  if (stack.length) {
    if (_context.context.top.vm === vm) {
      stack.pop();
      updateOverlay();
    } else {
      _context.context.stack = stack.filter(function (item) {
        return item.vm !== vm;
      });
    }
  }
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

var _event = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('overlay'),
    sfc = _use[0],
    bem = _use[1];

function Overlay(h, props, slots, ctx) {
  var style = (0, _extends3.default)({
    zIndex: props.zIndex
  }, props.customStyle);

  return h("transition", {
    "attrs": {
      "name": "van-fade"
    }
  }, [h("div", (0, _babelHelperVueJsxMergeProps2.default)([{
    "directives": [{
      name: "show",
      value: props.visible
    }],
    "style": style,
    "class": [bem(), props.className],
    "on": {
      "touchmove": function touchmove(event) {
        (0, _event.preventDefault)(event, true);
      }
    }
  }, (0, _functional.inherit)(ctx, true)]))]);
}

Overlay.props = {
  zIndex: Number,
  className: null,
  visible: Boolean,
  customStyle: Object
};
exports.default = sfc(Overlay);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('info'),
    sfc = _use[0],
    bem = _use[1];

function Info(h, props, slots, ctx) {
  if (!(0, _utils.isDef)(props.info) || props.info === '') {
    return;
  }

  return h("div", (0, _babelHelperVueJsxMergeProps2.default)([{
    "class": bem()
  }, (0, _functional.inherit)(ctx, true)]), [props.info]);
}

Info.props = {
  info: [String, Number]
};
exports.default = sfc(Info);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes van-slide-up-enter{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes van-slide-up-enter{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@-webkit-keyframes van-slide-up-leave{to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes van-slide-up-leave{to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@-webkit-keyframes van-slide-down-enter{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes van-slide-down-enter{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@-webkit-keyframes van-slide-down-leave{to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes van-slide-down-leave{to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@-webkit-keyframes van-slide-left-enter{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-slide-left-enter{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes van-slide-left-leave{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-slide-left-leave{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes van-slide-right-enter{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes van-slide-right-enter{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@-webkit-keyframes van-slide-right-leave{to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes van-slide-right-leave{to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@-webkit-keyframes van-fade-in{0%{opacity:0}to{opacity:1}}@keyframes van-fade-in{0%{opacity:0}to{opacity:1}}@-webkit-keyframes van-fade-out{0%{opacity:1}to{opacity:0}}@keyframes van-fade-out{0%{opacity:1}to{opacity:0}}@-webkit-keyframes van-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes van-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes van-circular{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40}to{stroke-dasharray:90,150;stroke-dashoffset:-120}}@keyframes van-circular{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40}to{stroke-dasharray:90,150;stroke-dashoffset:-120}}html{-webkit-tap-highlight-color:transparent}body{margin:0}a{text-decoration:none}a:focus,button:focus,input:focus,textarea:focus{outline:0}ol,ul{margin:0;padding:0;list-style:none}button,input,textarea{font:inherit;color:inherit}.van-ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.van-clearfix:after{content:\"\";display:table;clear:both}[class*=van-hairline]{position:relative}[class*=van-hairline]:after{content:\" \";position:absolute;pointer-events:none;box-sizing:border-box;top:-50%;left:-50%;right:-50%;bottom:-50%;-webkit-transform:scale(.5);transform:scale(.5);border:0 solid #ebedf0}.van-hairline--top:after{border-top-width:1px}.van-hairline--left:after{border-left-width:1px}.van-hairline--right:after{border-right-width:1px}.van-hairline--bottom:after{border-bottom-width:1px}.van-hairline--top-bottom:after{border-width:1px 0}.van-hairline--surround:after{border-width:1px}.van-fade-enter-active{-webkit-animation:.3s van-fade-in;animation:.3s van-fade-in}.van-fade-leave-active{-webkit-animation:.3s van-fade-out;animation:.3s van-fade-out}.van-slide-up-enter-active{-webkit-animation:van-slide-up-enter .3s both ease;animation:van-slide-up-enter .3s both ease}.van-slide-up-leave-active{-webkit-animation:van-slide-up-leave .3s both ease;animation:van-slide-up-leave .3s both ease}.van-slide-down-enter-active{-webkit-animation:van-slide-down-enter .3s both ease;animation:van-slide-down-enter .3s both ease}.van-slide-down-leave-active{-webkit-animation:van-slide-down-leave .3s both ease;animation:van-slide-down-leave .3s both ease}.van-slide-left-enter-active{-webkit-animation:van-slide-left-enter .3s both ease;animation:van-slide-left-enter .3s both ease}.van-slide-left-leave-active{-webkit-animation:van-slide-left-leave .3s both ease;animation:van-slide-left-leave .3s both ease}.van-slide-right-enter-active{-webkit-animation:van-slide-right-enter .3s both ease;animation:van-slide-right-enter .3s both ease}.van-slide-right-leave-active{-webkit-animation:van-slide-right-leave .3s both ease;animation:van-slide-right-leave .3s both ease}.van-info{position:absolute;right:0;top:-8px;color:#fff;font-size:12px;font-weight:500;font-family:PingFang SC,Helvetica Neue,Arial,sans-serif;text-align:center;box-sizing:border-box;padding:0 3px;min-width:16px;line-height:14px;border:1px solid #fff;border-radius:16px;background-color:#f44;-webkit-transform:translateX(50%);transform:translateX(50%);-webkit-transform-origin:100%;transform-origin:100%}@font-face{font-style:normal;font-weight:400;font-family:vant-icon;src:url(https://img.yzcdn.cn/vant/vant-icon-839a51.woff2) format(\"woff2\"),url(https://img.yzcdn.cn/vant/vant-icon-839a51.woff) format(\"woff\"),url(https://img.yzcdn.cn/vant/vant-icon-839a51.ttf) format(\"truetype\")}.van-icon{position:relative;font:14px/1 vant-icon;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased}.van-icon,.van-icon:before{display:inline-block}.van-icon-add-o:before{content:\"\\F000\"}.van-icon-add-square:before{content:\"\\F001\"}.van-icon-add:before{content:\"\\F002\"}.van-icon-after-sale:before{content:\"\\F003\"}.van-icon-aim:before{content:\"\\F004\"}.van-icon-alipay:before{content:\"\\F005\"}.van-icon-apps-o:before{content:\"\\F006\"}.van-icon-arrow-down:before{content:\"\\F007\"}.van-icon-arrow-left:before{content:\"\\F008\"}.van-icon-arrow-up:before{content:\"\\F009\"}.van-icon-arrow:before{content:\"\\F00A\"}.van-icon-ascending:before{content:\"\\F00B\"}.van-icon-audio:before{content:\"\\F00C\"}.van-icon-award-o:before{content:\"\\F00D\"}.van-icon-award:before{content:\"\\F00E\"}.van-icon-bag-o:before{content:\"\\F00F\"}.van-icon-bag:before{content:\"\\F010\"}.van-icon-balance-list-o:before{content:\"\\F011\"}.van-icon-balance-list:before{content:\"\\F012\"}.van-icon-balance-o:before{content:\"\\F013\"}.van-icon-balance-pay:before{content:\"\\F014\"}.van-icon-bar-chart-o:before{content:\"\\F015\"}.van-icon-bars:before{content:\"\\F016\"}.van-icon-bell:before{content:\"\\F017\"}.van-icon-bill-o:before{content:\"\\F018\"}.van-icon-bill:before{content:\"\\F019\"}.van-icon-birthday-cake-o:before{content:\"\\F01A\"}.van-icon-bookmark-o:before{content:\"\\F01B\"}.van-icon-bookmark:before{content:\"\\F01C\"}.van-icon-browsing-history-o:before{content:\"\\F01D\"}.van-icon-browsing-history:before{content:\"\\F01E\"}.van-icon-brush-o:before{content:\"\\F01F\"}.van-icon-bulb-o:before{content:\"\\F020\"}.van-icon-bullhorn-o:before{content:\"\\F021\"}.van-icon-calender-o:before{content:\"\\F022\"}.van-icon-card:before{content:\"\\F023\"}.van-icon-cart-circle-o:before{content:\"\\F024\"}.van-icon-cart-circle:before{content:\"\\F025\"}.van-icon-cart-o:before{content:\"\\F026\"}.van-icon-cart:before{content:\"\\F027\"}.van-icon-cash-back-record:before{content:\"\\F028\"}.van-icon-cash-on-deliver:before{content:\"\\F029\"}.van-icon-cashier-o:before{content:\"\\F02A\"}.van-icon-certificate:before{content:\"\\F02B\"}.van-icon-chart-trending-o:before{content:\"\\F02C\"}.van-icon-chat-o:before{content:\"\\F02D\"}.van-icon-chat:before{content:\"\\F02E\"}.van-icon-checked:before{content:\"\\F02F\"}.van-icon-circle:before{content:\"\\F030\"}.van-icon-clear:before{content:\"\\F031\"}.van-icon-clock-o:before{content:\"\\F032\"}.van-icon-clock:before{content:\"\\F033\"}.van-icon-close:before{content:\"\\F034\"}.van-icon-closed-eye:before{content:\"\\F035\"}.van-icon-cluster-o:before{content:\"\\F036\"}.van-icon-cluster:before{content:\"\\F037\"}.van-icon-column:before{content:\"\\F038\"}.van-icon-comment-circle-o:before{content:\"\\F039\"}.van-icon-comment-o:before{content:\"\\F03A\"}.van-icon-comment:before{content:\"\\F03B\"}.van-icon-completed:before{content:\"\\F03C\"}.van-icon-contact:before{content:\"\\F03D\"}.van-icon-coupon-o:before{content:\"\\F03E\"}.van-icon-coupon:before{content:\"\\F03F\"}.van-icon-credit-pay:before{content:\"\\F040\"}.van-icon-cross:before{content:\"\\F041\"}.van-icon-debit-pay:before{content:\"\\F042\"}.van-icon-delete:before{content:\"\\F043\"}.van-icon-descending:before{content:\"\\F044\"}.van-icon-description:before{content:\"\\F045\"}.van-icon-desktop-o:before{content:\"\\F046\"}.van-icon-diamond-o:before{content:\"\\F047\"}.van-icon-diamond:before{content:\"\\F048\"}.van-icon-discount:before{content:\"\\F049\"}.van-icon-ecard-pay:before{content:\"\\F04A\"}.van-icon-edit:before{content:\"\\F04B\"}.van-icon-ellipsis:before{content:\"\\F04C\"}.van-icon-empty:before{content:\"\\F04D\"}.van-icon-envelop-o:before{content:\"\\F04E\"}.van-icon-exchange:before{content:\"\\F04F\"}.van-icon-expand-o:before{content:\"\\F050\"}.van-icon-expand:before{content:\"\\F051\"}.van-icon-eye-o:before{content:\"\\F052\"}.van-icon-eye:before{content:\"\\F053\"}.van-icon-fail:before{content:\"\\F054\"}.van-icon-failure:before{content:\"\\F055\"}.van-icon-filter-o:before{content:\"\\F056\"}.van-icon-fire-o:before{content:\"\\F057\"}.van-icon-fire:before{content:\"\\F058\"}.van-icon-flag-o:before{content:\"\\F059\"}.van-icon-flower-o:before{content:\"\\F05A\"}.van-icon-free-postage:before{content:\"\\F05B\"}.van-icon-friends-o:before{content:\"\\F05C\"}.van-icon-friends:before{content:\"\\F05D\"}.van-icon-gem-o:before{content:\"\\F05E\"}.van-icon-gem:before{content:\"\\F05F\"}.van-icon-gift-card-o:before{content:\"\\F060\"}.van-icon-gift-card:before{content:\"\\F061\"}.van-icon-gift-o:before{content:\"\\F062\"}.van-icon-gift:before{content:\"\\F063\"}.van-icon-gold-coin-o:before{content:\"\\F064\"}.van-icon-gold-coin:before{content:\"\\F065\"}.van-icon-goods-collect-o:before{content:\"\\F066\"}.van-icon-goods-collect:before{content:\"\\F067\"}.van-icon-graphic:before{content:\"\\F068\"}.van-icon-home-o:before{content:\"\\F069\"}.van-icon-hot-o:before{content:\"\\F06A\"}.van-icon-hot-sale-o:before{content:\"\\F06B\"}.van-icon-hot-sale:before{content:\"\\F06C\"}.van-icon-hot:before{content:\"\\F06D\"}.van-icon-hotel-o:before{content:\"\\F06E\"}.van-icon-idcard:before{content:\"\\F06F\"}.van-icon-info-o:before{content:\"\\F070\"}.van-icon-info:before{content:\"\\F071\"}.van-icon-invition:before{content:\"\\F072\"}.van-icon-label-o:before{content:\"\\F073\"}.van-icon-label:before{content:\"\\F074\"}.van-icon-like-o:before{content:\"\\F075\"}.van-icon-like:before{content:\"\\F076\"}.van-icon-live:before{content:\"\\F077\"}.van-icon-location-o:before{content:\"\\F078\"}.van-icon-location:before{content:\"\\F079\"}.van-icon-lock:before{content:\"\\F07A\"}.van-icon-logistics:before{content:\"\\F07B\"}.van-icon-manager-o:before{content:\"\\F07C\"}.van-icon-manager:before{content:\"\\F07D\"}.van-icon-map-marked:before{content:\"\\F07E\"}.van-icon-medel-o:before{content:\"\\F07F\"}.van-icon-medel:before{content:\"\\F080\"}.van-icon-more-o:before{content:\"\\F081\"}.van-icon-more:before{content:\"\\F082\"}.van-icon-music-o:before{content:\"\\F083\"}.van-icon-new-arrival-o:before{content:\"\\F084\"}.van-icon-new-arrival:before{content:\"\\F085\"}.van-icon-new-o:before{content:\"\\F086\"}.van-icon-new:before{content:\"\\F087\"}.van-icon-newspaper-o:before{content:\"\\F088\"}.van-icon-notes-o:before{content:\"\\F089\"}.van-icon-orders-o:before{content:\"\\F08A\"}.van-icon-other-pay:before{content:\"\\F08B\"}.van-icon-paid:before{content:\"\\F08C\"}.van-icon-passed:before{content:\"\\F08D\"}.van-icon-pause-circle-o:before{content:\"\\F08E\"}.van-icon-pause-circle:before{content:\"\\F08F\"}.van-icon-pause:before{content:\"\\F090\"}.van-icon-peer-pay:before{content:\"\\F091\"}.van-icon-pending-payment:before{content:\"\\F092\"}.van-icon-phone-circle-o:before{content:\"\\F093\"}.van-icon-phone-o:before{content:\"\\F094\"}.van-icon-phone:before{content:\"\\F095\"}.van-icon-photo-o:before{content:\"\\F096\"}.van-icon-photo:before{content:\"\\F097\"}.van-icon-photograph:before{content:\"\\F098\"}.van-icon-play-circle-o:before{content:\"\\F099\"}.van-icon-play-circle:before{content:\"\\F09A\"}.van-icon-play:before{content:\"\\F09B\"}.van-icon-plus:before{content:\"\\F09C\"}.van-icon-point-gift-o:before{content:\"\\F09D\"}.van-icon-point-gift:before{content:\"\\F09E\"}.van-icon-points:before{content:\"\\F09F\"}.van-icon-printer:before{content:\"\\F0A0\"}.van-icon-qr-invalid:before{content:\"\\F0A1\"}.van-icon-qr:before{content:\"\\F0A2\"}.van-icon-question-o:before{content:\"\\F0A3\"}.van-icon-question:before{content:\"\\F0A4\"}.van-icon-records:before{content:\"\\F0A5\"}.van-icon-refund-o:before{content:\"\\F0A6\"}.van-icon-replay:before{content:\"\\F0A7\"}.van-icon-scan:before{content:\"\\F0A8\"}.van-icon-search:before{content:\"\\F0A9\"}.van-icon-send-gift-o:before{content:\"\\F0AA\"}.van-icon-send-gift:before{content:\"\\F0AB\"}.van-icon-service-o:before{content:\"\\F0AC\"}.van-icon-service:before{content:\"\\F0AD\"}.van-icon-setting-o:before{content:\"\\F0AE\"}.van-icon-setting:before{content:\"\\F0AF\"}.van-icon-share:before{content:\"\\F0B0\"}.van-icon-shop-collect-o:before{content:\"\\F0B1\"}.van-icon-shop-collect:before{content:\"\\F0B2\"}.van-icon-shop-o:before{content:\"\\F0B3\"}.van-icon-shop:before{content:\"\\F0B4\"}.van-icon-shopping-cart-o:before{content:\"\\F0B5\"}.van-icon-shopping-cart:before{content:\"\\F0B6\"}.van-icon-shrink:before{content:\"\\F0B7\"}.van-icon-sign:before{content:\"\\F0B8\"}.van-icon-smile-comment-o:before{content:\"\\F0B9\"}.van-icon-smile-comment:before{content:\"\\F0BA\"}.van-icon-smile-o:before{content:\"\\F0BB\"}.van-icon-star-o:before{content:\"\\F0BC\"}.van-icon-star:before{content:\"\\F0BD\"}.van-icon-stop-circle-o:before{content:\"\\F0BE\"}.van-icon-stop-circle:before{content:\"\\F0BF\"}.van-icon-stop:before{content:\"\\F0C0\"}.van-icon-success:before{content:\"\\F0C1\"}.van-icon-thumb-circle-o:before{content:\"\\F0C2\"}.van-icon-todo-list-o:before{content:\"\\F0C3\"}.van-icon-todo-list:before{content:\"\\F0C4\"}.van-icon-tosend:before{content:\"\\F0C5\"}.van-icon-tv-o:before{content:\"\\F0C6\"}.van-icon-umbrella-circle:before{content:\"\\F0C7\"}.van-icon-underway-o:before{content:\"\\F0C8\"}.van-icon-underway:before{content:\"\\F0C9\"}.van-icon-upgrade:before{content:\"\\F0CA\"}.van-icon-user-circle-o:before{content:\"\\F0CB\"}.van-icon-user-o:before{content:\"\\F0CC\"}.van-icon-video-o:before{content:\"\\F0CD\"}.van-icon-video:before{content:\"\\F0CE\"}.van-icon-vip-card-o:before{content:\"\\F0CF\"}.van-icon-vip-card:before{content:\"\\F0D0\"}.van-icon-volume-o:before{content:\"\\F0D1\"}.van-icon-volume:before{content:\"\\F0D2\"}.van-icon-wap-home:before{content:\"\\F0D3\"}.van-icon-wap-nav:before{content:\"\\F0D4\"}.van-icon-warn-o:before{content:\"\\F0D5\"}.van-icon-warning-o:before{content:\"\\F0D6\"}.van-icon-weapp-nav:before{content:\"\\F0D7\"}.van-icon-wechat:before{content:\"\\F0D8\"}.van-icon-youzan-shield:before{content:\"\\F0D9\"}.van-icon--image{width:1em;height:1em}.van-icon--image img{top:0;left:0;right:0;bottom:0;margin:auto;max-width:100%;max-height:100%;position:absolute}.van-loading{width:30px;height:30px;z-index:0;font-size:0;line-height:0;position:relative;vertical-align:middle}.van-loading--circle{width:16px;height:16px}.van-loading__spinner{z-index:-1;width:100%;height:100%;position:relative;display:inline-block;box-sizing:border-box;-webkit-animation:van-rotate .8s linear infinite;animation:van-rotate .8s linear infinite}.van-loading__spinner--circle{border-radius:100%;border:3px solid transparent;border-color:#7d7e80 #c8c9cc #c8c9cc}.van-loading__spinner--gradient-circle{background-size:contain;background-image:url(https://img.yzcdn.cn/vant/gradient-circle-black.png)}.van-loading__spinner--spinner{-webkit-animation-timing-function:steps(12);animation-timing-function:steps(12)}.van-loading__spinner--spinner i{top:0;left:0;width:100%;height:100%;position:absolute}.van-loading__spinner--spinner i:before{width:2px;height:25%;content:\" \";display:block;margin:0 auto;border-radius:40%;background-color:currentColor}.van-loading__spinner--circular{-webkit-animation-duration:2s;animation-duration:2s}.van-loading__circular{width:100%;height:100%}.van-loading__circular circle{stroke:currentColor;stroke-width:3;stroke-linecap:round;-webkit-animation:van-circular 1.5s ease-in-out infinite;animation:van-circular 1.5s ease-in-out infinite}.van-loading--white .van-loading__spinner--circle{border-color:hsla(0,0%,100%,.7) rgba(0,0,0,.1) rgba(0,0,0,.1)}.van-loading--white .van-loading__spinner--gradient-circle{background-image:url(https://img.yzcdn.cn/vant/gradient-circle-white.png)}.van-loading__spinner--spinner i:first-of-type{opacity:1;-webkit-transform:rotate(30deg);transform:rotate(30deg)}.van-loading__spinner--spinner i:nth-of-type(2){opacity:.9375;-webkit-transform:rotate(60deg);transform:rotate(60deg)}.van-loading__spinner--spinner i:nth-of-type(3){opacity:.875;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.van-loading__spinner--spinner i:nth-of-type(4){opacity:.8125;-webkit-transform:rotate(120deg);transform:rotate(120deg)}.van-loading__spinner--spinner i:nth-of-type(5){opacity:.75;-webkit-transform:rotate(150deg);transform:rotate(150deg)}.van-loading__spinner--spinner i:nth-of-type(6){opacity:.6875;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.van-loading__spinner--spinner i:nth-of-type(7){opacity:.625;-webkit-transform:rotate(210deg);transform:rotate(210deg)}.van-loading__spinner--spinner i:nth-of-type(8){opacity:.5625;-webkit-transform:rotate(240deg);transform:rotate(240deg)}.van-loading__spinner--spinner i:nth-of-type(9){opacity:.5;-webkit-transform:rotate(270deg);transform:rotate(270deg)}.van-loading__spinner--spinner i:nth-of-type(10){opacity:.4375;-webkit-transform:rotate(300deg);transform:rotate(300deg)}.van-loading__spinner--spinner i:nth-of-type(11){opacity:.375;-webkit-transform:rotate(330deg);transform:rotate(330deg)}.van-loading__spinner--spinner i:nth-of-type(12){opacity:.3125;-webkit-transform:rotate(1turn);transform:rotate(1turn)}.van-button{display:inline-block;position:relative;padding:0;height:44px;line-height:42px;font-size:16px;border-radius:2px;text-align:center;box-sizing:border-box;-webkit-appearance:none;-webkit-text-size-adjust:100%}.van-button:before{content:\" \";position:absolute;top:50%;left:50%;opacity:0;width:100%;height:100%;border:inherit;border-color:#000;background-color:#000;border-radius:inherit;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.van-button:active:before{opacity:.1}.van-button--disabled:before,.van-button--loading:before{display:none}.van-button--default{color:#323233;background-color:#fff;border:1px solid #ebedf0}.van-button--primary{color:#fff;background-color:#07c160;border:1px solid #07c160}.van-button--info{color:#fff;background-color:#1989fa;border:1px solid #1989fa}.van-button--danger{color:#fff;background-color:#f44;border:1px solid #f44}.van-button--warning{color:#fff;background-color:#ff976a;border:1px solid #ff976a}.van-button--plain{background-color:#fff}.van-button--plain.van-button--primary{color:#07c160}.van-button--plain.van-button--info{color:#1989fa}.van-button--plain.van-button--danger{color:#f44}.van-button--plain.van-button--warning{color:#ff976a}.van-button--large{width:100%;height:50px;line-height:48px}.van-button--normal{padding:0 15px;font-size:14px}.van-button--small{padding:0 8px;height:30px;min-width:60px;font-size:12px;line-height:28px}.van-button--loading .van-loading,.van-button--mini{display:inline-block}.van-button--mini{height:22px;min-width:50px;font-size:10px;line-height:20px}.van-button--mini+.van-button--mini{margin-left:5px}.van-button--block{width:100%;display:block}.van-button--bottom-action{border:0;width:100%;height:50px;font-size:16px;line-height:50px;border-radius:0;color:#fff;background-color:#ff976a}.van-button--bottom-action.van-button--primary{background-color:#f44}.van-button--disabled{opacity:.5}.van-button--hairline.van-button--round:after,.van-button--round{border-radius:10em}.van-button--hairline.van-button--square:after,.van-button--square{border-radius:0}.van-button__loading-text{margin-left:5px;display:inline-block;vertical-align:middle}.van-button--hairline{border-width:0}.van-button--hairline:after{border-color:inherit;border-radius:4px}.van-cell{position:relative;display:-webkit-box;display:-webkit-flex;display:flex;width:100%;overflow:hidden;box-sizing:border-box;color:#323233;font-size:14px;line-height:24px;background-color:#fff;padding:10px 15px}.van-cell:not(:last-child):after{content:\" \";position:absolute;pointer-events:none;box-sizing:border-box;left:15px;right:0;bottom:0;-webkit-transform:scaleY(.5);transform:scaleY(.5);border-bottom:1px solid #ebedf0}.van-cell--borderless:after{display:none}.van-cell__label{color:#969799;font-size:12px;margin-top:3px;line-height:18px}.van-cell__title,.van-cell__value{-webkit-box-flex:1;-webkit-flex:1;flex:1}.van-cell__value{color:#969799;overflow:hidden;text-align:right;position:relative;vertical-align:middle}.van-cell__value--alone{color:#323233;text-align:left}.van-cell__left-icon,.van-cell__right-icon{min-width:1em;height:24px;font-size:16px;line-height:24px}.van-cell__left-icon{margin-right:5px}.van-cell__right-icon{margin-left:5px;color:#969799}.van-cell--clickable:active{background-color:#f2f3f5}.van-cell--required{overflow:visible}.van-cell--required:before{content:\"*\";position:absolute;left:7px;font-size:14px;color:#f44}.van-cell--center{-webkit-box-align:center;-webkit-align-items:center;align-items:center}.van-cell--large{padding-top:12px;padding-bottom:12px}.van-cell--large .van-cell__title{font-size:16px}.van-cell--large .van-cell__label{font-size:14px}.van-cell-group{background-color:#fff}.van-cell-group__title{color:#969799;padding:15px 15px 5px;font-size:14px;line-height:16px}.van-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7)}", ""]);

// exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-overflow-hidden{overflow:hidden!important}.van-popup{position:fixed;top:50%;left:50%;max-height:100%;overflow-y:auto;background-color:#fff;-webkit-transition:.3s ease-out;transition:.3s ease-out;-webkit-overflow-scrolling:touch;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.van-popup--top{width:100%;top:0;right:auto;bottom:auto;left:50%;-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0)}.van-popup--right{top:50%;right:0;bottom:auto;left:auto;-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.van-popup--bottom{width:100%;top:auto;bottom:0;right:auto;left:50%;-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0)}.van-popup--left{top:50%;right:auto;bottom:auto;left:0;-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.van-popup-slide-top-enter,.van-popup-slide-top-leave-active{-webkit-transform:translate3d(-50%,-100%,0);transform:translate3d(-50%,-100%,0)}.van-popup-slide-right-enter,.van-popup-slide-right-leave-active{-webkit-transform:translate3d(100%,-50%,0);transform:translate3d(100%,-50%,0)}.van-popup-slide-bottom-enter,.van-popup-slide-bottom-leave-active{-webkit-transform:translate3d(-50%,100%,0);transform:translate3d(-50%,100%,0)}.van-popup-slide-left-enter,.van-popup-slide-left-leave-active{-webkit-transform:translate3d(-100%,-50%,0);transform:translate3d(-100%,-50%,0)}", ""]);

// exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(153);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-toast{position:fixed;top:50%;left:50%;display:-webkit-box;display:-webkit-flex;display:flex;color:#fff;max-width:70%;font-size:14px;line-height:20px;border-radius:4px;word-break:break-all;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;box-sizing:content-box;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);background-color:rgba(50,50,51,.88);width:-webkit-fit-content;width:fit-content;white-space:pre-wrap}.van-toast--unclickable *{pointer-events:none}.van-toast--text{padding:8px 12px;min-width:96px}.van-toast--default{width:90px;padding:15px;min-height:90px}.van-toast--default .van-toast__icon{font-size:48px}.van-toast--default .van-loading{margin:10px 0}.van-toast--default .van-toast__text{padding-top:5px}.van-toast--top{top:50px}.van-toast--bottom{top:auto;bottom:50px}", ""]);

// exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var bind = __webpack_require__(62);
var Axios = __webpack_require__(156);
var defaults = __webpack_require__(42);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(66);
axios.CancelToken = __webpack_require__(170);
axios.isCancel = __webpack_require__(65);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(171);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(42);
var utils = __webpack_require__(13);
var InterceptorManager = __webpack_require__(165);
var dispatchRequest = __webpack_require__(166);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(64);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error();
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
  // initialize result and counter
  var block, charCode, idx = 0, map = chars;
  // if the next str index does not exist:
  //   change the mapping table to "="
  //   check if d has no fractional digits
  str.charAt(idx | 0) || (map = '=', idx % 1);
  // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
  output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var transformData = __webpack_require__(167);
var isCancel = __webpack_require__(65);
var defaults = __webpack_require__(42);
var isAbsoluteURL = __webpack_require__(168);
var combineURLs = __webpack_require__(169);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(66);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _axios = __webpack_require__(28);

var _axios2 = _interopRequireDefault(_axios);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
	dsInfo: null,
	userConfig: null,
	businessConfigs: {},
	miniConfig: {
		mp_1v1_orgin_id: 'gh_1cc817b85e19',
		mp_1v1_appid: 'wxa9458d482da70248',
		shop_login_mp_appid: 'wx9dd18086e544c524',
		login_mp_appid: 'wx308cba4bdeb1b6c7'
	},
	Sendflowers: 'true',
	wechat_mp_url: ''
};

var getters = {
	getDsFuncInfo: function getDsFuncInfo() {
		if (state.dsInfo) {
			return state.dsInfo.ds_func;
		} else {
			return null;
		}
	},
	getDsInfo: function getDsInfo(state) {
		if (state.dsInfo) {
			return state.dsInfo.direct_seeding;
		} else {
			return null;
		}
	},
	getDsId: function getDsId(state) {
		if (state.dsInfo) {
			return state.dsInfo.direct_seeding;
		} else {
			return null;
		}
	},
	getUid: function getUid(state) {
		if (state.dsInfo) {
			return state.dsInfo.direct_seeding.uid;
		} else {
			return null;
		}
	},
	getRoomId: function getRoomId(state) {
		if (state.dsInfo) {
			return state.dsInfo.direct_seeding.room_id;
		} else {
			return null;
		}
	},
	getUserConfig: function getUserConfig(state) {
		return state.userConfig;
	},
	getBusinessConfigs: function getBusinessConfigs(state) {
		return state.businessConfigs;
	},
	getSendflowers: function getSendflowers(state) {
		return state.Sendflowers;
	},
	getMiniConfig: function getMiniConfig(state) {
		return state.miniConfig;
	},
	getWechat_mp_url: function getWechat_mp_url(state) {
		return state.wechat_mp_url;
	}
};

var mutations = {
	setDsInfo: function setDsInfo(state, value) {
		state.dsInfo = value;
	},
	setUserConfig: function setUserConfig(state, value) {
		state.userConfig = value;
	},
	setBusinessConfigs: function setBusinessConfigs(state, value) {
		state.businessConfigs = value;
	},
	setSendflowers: function setSendflowers(state, value) {
		state.Sendflowers = value;
	},
	setMiniConfig: function setMiniConfig(state, value) {
		state.miniConfig = value;
	},
	setWechat_mp_url: function setWechat_mp_url(state, value) {
		state.wechat_mp_url = value;
	}
};

var actions = {
	getDsInfo: function getDsInfo(_ref, dsInfo) {
		var commit = _ref.commit,
		    dispatch = _ref.dispatch;

		commit('setDsInfo', dsInfo);
		var uid = dsInfo.direct_seeding.uid;
		dispatch('getDsConfig', { uid: uid });
	},
	getDsConfig: function getDsConfig(_ref2, _ref3) {
		var commit = _ref2.commit;
		var uid = _ref3.uid;


		_axios2.default.get("https://tengfaceliveuser.tengface.net/web/config/miniConfig.json?ran=" + new Date().valueOf()).then(function (resdata) {
			if (resdata.status == 200) {
				commit('setMiniConfig', resdata.data || {});
				if (resdata.data.wx_qrcode_webview_url) {
					commit("setWechat_mp_url", resdata.data.wx_qrcode_webview_url);
				}
				_axios2.default.get("https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/config/userConfig/" + uid + ".json?ran=" + new Date().valueOf()).then(function (data) {
					if (data.status == 200) {
						commit('setUserConfig', data.data);
						if (data.data.wechat_mini_url) {
							commit("setWechat_mp_url", data.data.wechat_mini_url);
						}
					}
				}).catch(function () {});
			}
		}).catch(function () {
			_axios2.default.get("https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/config/userConfig/" + uid + ".json?ran=" + new Date().valueOf()).then(function (data) {
				if (data.status == 200) {
					commit('setUserConfig', data.data);
					if (data.data.wechat_mini_url) {
						commit("setWechat_mp_url", data.data.wechat_mini_url);
					}
				}
			}).catch(function () {});
		});

		_axios2.default.get(_Tools2.default.baseUrl1() + "/customer/index/qryUserConfigs?uid=" + uid).then(function (data) {
			console.log("data,====", data);
			if (data.data.code == 200) {
				if (Array.isArray(data.data.data)) {
					var businessConfigs = {};
					data.data.data.forEach(function (element) {
						businessConfigs[element.key] = element.value == 'true';
						if (element.key == 'show_likes_and_flowers') {
							commit('setSendflowers', element.value);
						}
					});
					commit('setBusinessConfigs', businessConfigs);
				}
			}
		}).catch(function () {});
	}
};

exports.default = {
	state: state,
	getters: getters,
	mutations: mutations,
	actions: actions,
	namespaced: true
};

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert(condition, message) {
  if (!condition) {
    throw new Error("[vue-router] " + message);
  }
}

function warn(condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn("[vue-router] " + message);
  }
}

function isError(err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1;
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render(_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children);
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h();
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (val && current !== vm || !val && current === vm) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children);
  }
};

function resolveProps(route, config) {
  switch (typeof config === 'undefined' ? 'undefined' : _typeof(config)) {
    case 'undefined':
      return;
    case 'object':
      return config;
    case 'function':
      return config(route);
    case 'boolean':
      return config ? route.params : undefined;
    default:
      if (false) {
        warn(false, "props in \"" + route.path + "\" is a " + (typeof config === 'undefined' ? 'undefined' : _typeof(config)) + ", " + "expecting an object, function or boolean.");
      }
  }
}

function extend(to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to;
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function encodeReserveReplacer(c) {
  return '%' + c.charCodeAt(0).toString(16);
};
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function encode(str) {
  return encodeURIComponent(str).replace(encodeReserveRE, encodeReserveReplacer).replace(commaRE, ',');
};

var decode = decodeURIComponent;

function resolveQuery(query, extraQuery, _parseQuery) {
  if (extraQuery === void 0) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery;
}

function parseQuery(query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res;
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

function stringifyQuery(obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&');
    }

    return encode(key) + '=' + encode(val);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? "?" + res : '';
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute(record, location, redirectedFrom, router) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || record && record.name,
    meta: record && record.meta || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route);
}

function clone(value) {
  if (Array.isArray(value)) {
    return value.map(clone);
  } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res;
  } else {
    return value;
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch(record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res;
}

function getFullPath(ref, _stringifyQuery) {
  var path = ref.path;
  var query = ref.query;if (query === void 0) query = {};
  var hash = ref.hash;if (hash === void 0) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash;
}

function isSameRoute(a, b) {
  if (b === START) {
    return a === b;
  } else if (!b) {
    return false;
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && a.hash === b.hash && isObjectEqual(a.query, b.query);
  } else if (a.name && b.name) {
    return a.name === b.name && a.hash === b.hash && isObjectEqual(a.query, b.query) && isObjectEqual(a.params, b.params);
  } else {
    return false;
  }
}

function isObjectEqual(a, b) {
  if (a === void 0) a = {};
  if (b === void 0) b = {};

  // handle null value #1566
  if (!a || !b) {
    return a === b;
  }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if ((typeof aVal === 'undefined' ? 'undefined' : _typeof(aVal)) === 'object' && (typeof bVal === 'undefined' ? 'undefined' : _typeof(bVal)) === 'object') {
      return isObjectEqual(aVal, bVal);
    }
    return String(aVal) === String(bVal);
  });
}

function isIncludedRoute(current, target) {
  return current.path.replace(trailingSlashRE, '/').indexOf(target.path.replace(trailingSlashRE, '/')) === 0 && (!target.hash || current.hash === target.hash) && queryIncludes(current.query, target.query);
}

function queryIncludes(current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false;
    }
  }
  return true;
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render(h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null ? 'router-link-exact-active' : globalExactActiveClass;
    var activeClass = this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null ? exactActiveClassFallback : this.exactActiveClass;
    var compareTarget = location.path ? createRoute(null, location, null, router) : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact ? classes[exactActiveClass] : isIncludedRoute(current, compareTarget);

    var handler = function handler(e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default);
  }
};

function guardEvent(e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return;
  }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) {
    return;
  }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) {
    return;
  }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) {
      return;
    }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true;
}

function findAnchor(children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child;
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child;
      }
    }
  }
}

var _Vue;

function install(Vue) {
  if (install.installed && _Vue === Vue) {
    return;
  }
  install.installed = true;

  _Vue = Vue;

  var isDef = function isDef(v) {
    return v !== undefined;
  };

  var registerInstance = function registerInstance(vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = this.$parent && this.$parent._routerRoot || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed() {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get() {
      return this._routerRoot._router;
    }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get() {
      return this._routerRoot._route;
    }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath(relative, base, append) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative;
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative;
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/');
}

function parsePath(path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  };
}

function cleanPath(path) {
  return path.replace(/\/\//g, '/');
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options));
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (_typeof(tokens[i]) === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams(path, params, routeMsg) {
  try {
    var filler = regexpCompileCache[path] || (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true });
  } catch (e) {
    if (false) {
      warn(false, "missing param for " + routeMsg + ": " + e.message);
    }
    return '';
  }
}

/*  */

function createRouteMap(routes, oldPathList, oldPathMap, oldNameMap) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  };
}

function addRouteRecord(pathList, pathMap, nameMap, route, parent, matchAs) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(typeof route.component !== 'string', "route config \"component\" for path: " + String(path || name) + " cannot be a " + "string id. Use an actual component instead.");
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null ? {} : route.components ? route.props : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) {
        return (/^\/?$/.test(child.path)
        );
      })) {
        warn(false, "Named Route '" + route.name + "' has a default child route. " + "When navigating to this named route (:to=\"{name: '" + route.name + "'\"), " + "the default child route will not be rendered. Remove the name from " + "this route and use the name of the default child route for named " + "links instead.");
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs ? cleanPath(matchAs + "/" + child.path) : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(pathList, pathMap, nameMap, aliasRoute, parent, record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(false, "Duplicate named routes definition: " + "{ name: \"" + name + "\", path: \"" + record.path + "\" }");
    }
  }
}

function compileRouteRegex(path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], "Duplicate param keys in route with path: \"" + path + "\"");
      keys[key.name] = true;
    });
  }
  return regex;
}

function normalizePath(path, parent, strict) {
  if (!strict) {
    path = path.replace(/\/$/, '');
  }
  if (path[0] === '/') {
    return path;
  }
  if (parent == null) {
    return path;
  }
  return cleanPath(parent.path + "/" + path);
}

/*  */

function normalizeLocation(raw, current, append, router) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next;
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, "path " + current.path);
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next;
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = current && current.path || '/';
  var path = parsedPath.path ? resolvePath(parsedPath.path, basePath, append || next.append) : basePath;

  var query = resolveQuery(parsedPath.query, next.query, router && router.options.parseQuery);

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  };
}

function assign(a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a;
}

/*  */

function createMatcher(routes, router) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes(routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match(raw, currentRoute, redirectedFrom) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, "Route with name '" + name + "' does not exist");
      }
      if (!record) {
        return _createRoute(null, location);
      }
      var paramNames = record.regex.keys.filter(function (key) {
        return !key.optional;
      }).map(function (key) {
        return key.name;
      });

      if (_typeof(location.params) !== 'object') {
        location.params = {};
      }

      if (currentRoute && _typeof(currentRoute.params) === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, "named route \"" + name + "\"");
        return _createRoute(record, location, redirectedFrom);
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom);
        }
      }
    }
    // no match
    return _createRoute(null, location);
  }

  function redirect(record, location) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function' ? originalRedirect(createRoute(record, location, null, router)) : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || (typeof redirect === 'undefined' ? 'undefined' : _typeof(redirect)) !== 'object') {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, "redirect failed: named route \"" + name + "\" not found.");
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location);
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, "redirect route with path \"" + rawPath + "\"");
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location);
    } else {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }
  }

  function alias(record, location, matchAs) {
    var aliasedPath = fillParams(matchAs, location.params, "aliased route with path \"" + matchAs + "\"");
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location);
    }
    return _createRoute(null, location);
  }

  function _createRoute(record, location, redirectedFrom) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location);
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs);
    }
    return createRoute(record, location, redirectedFrom, router);
  }

  return {
    match: match,
    addRoutes: addRoutes
  };
}

function matchRoute(regex, path, params) {
  var m = path.match(regex);

  if (!m) {
    return false;
  } else if (!params) {
    return true;
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true;
}

function resolveRecordPath(path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true);
}

/*  */

var positionStore = Object.create(null);

function setupScroll() {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll(router, to, from, isPop) {
  if (!router.app) {
    return;
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return;
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return;
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition(shouldScroll, position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition() {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition() {
  var key = getStateKey();
  if (key) {
    return positionStore[key];
  }
}

function getElementPosition(el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  };
}

function isValidPosition(obj) {
  return isNumber(obj.x) || isNumber(obj.y);
}

function normalizePosition(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  };
}

function normalizeOffset(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  };
}

function isNumber(v) {
  return typeof v === 'number';
}

function scrollToPosition(shouldScroll, position) {
  var isObject = (typeof shouldScroll === 'undefined' ? 'undefined' : _typeof(shouldScroll)) === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && _typeof(shouldScroll.offset) === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && function () {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }

  return window.history && 'pushState' in window.history;
}();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now ? window.performance : Date;

var _key = genKey();

function genKey() {
  return Time.now().toFixed(3);
}

function getStateKey() {
  return _key;
}

function setStateKey(key) {
  _key = key;
}

function pushState(url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState(url) {
  pushState(url, true);
}

/*  */

function runQueue(queue, fn, cb) {
  var step = function step(index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents(matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function' ? resolvedDef : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason) ? reason : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) {
      next();
    }
  };
}

function flatMapComponents(matched, fn) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return fn(m.components[key], m.instances[key], m, key);
    });
  }));
}

function flatten(arr) {
  return Array.prototype.concat.apply([], arr);
}

var hasSymbol = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

function isESModule(obj) {
  return obj.__esModule || hasSymbol && obj[Symbol.toStringTag] === 'Module';
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once(fn) {
  var called = false;
  return function () {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }if (called) {
      return;
    }
    called = true;
    return fn.apply(this, args);
  };
}

/*  */

var History = function History(router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen(cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady(cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError(errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo(location, onComplete, onAbort) {
  var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) {
        cb(route);
      });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) {
        cb(err);
      });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition(route, onComplete, onAbort) {
  var this$1 = this;

  var current = this.current;
  var abort = function abort(err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (isSameRoute(route, current) &&
  // in the case the route map has been dynamically appended to
  route.matched.length === current.matched.length) {
    this.ensureURL();
    return abort();
  }

  var ref = resolveQueue(this.current.matched, route.matched);
  var updated = ref.updated;
  var deactivated = ref.deactivated;
  var activated = ref.activated;

  var queue = [].concat(
  // in-component leave guards
  extractLeaveGuards(deactivated),
  // global before hooks
  this.router.beforeHooks,
  // in-component update hooks
  extractUpdateHooks(updated),
  // in-config enter guards
  activated.map(function (m) {
    return m.beforeEnter;
  }),
  // async components
  resolveAsyncComponents(activated));

  this.pending = route;
  var iterator = function iterator(hook, next) {
    if (this$1.pending !== route) {
      return abort();
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (typeof to === 'string' || (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' && (typeof to.path === 'string' || typeof to.name === 'string')) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function isValid() {
      return this$1.current === route;
    };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort();
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute(route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase(base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = baseEl && baseEl.getAttribute('href') || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '');
}

function resolveQueue(current, next) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break;
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  };
}

function extractGuards(records, name, bind, reverse) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard) ? guard.map(function (guard) {
        return bind(guard, instance, match, key);
      }) : bind(guard, instance, match, key);
    }
  });
  return flatten(reverse ? guards.reverse() : guards);
}

function extractGuard(def, key) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key];
}

function extractLeaveGuards(deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true);
}

function extractUpdateHooks(updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard);
}

function bindGuard(guard, instance) {
  if (instance) {
    return function boundRouteGuard() {
      return guard.apply(instance, arguments);
    };
  }
}

function extractEnterGuards(activated, cbs, isValid) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid);
  });
}

function bindEnterGuard(guard, match, key, cbs, isValid) {
  return function routeEnterGuard(to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    });
  };
}

function poll(cb, // somehow flow cannot infer this is a function
instances, key, isValid) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = function (History$$1) {
  function HTML5History(router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return;
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if (History$$1) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create(History$$1 && History$$1.prototype);
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go(n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL(push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation() {
    return getLocation(this.base);
  };

  return HTML5History;
}(History);

function getLocation(base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash;
}

/*  */

var HashHistory = function (History$$1) {
  function HashHistory(router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return;
    }
    ensureSlash();
  }

  if (History$$1) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create(History$$1 && History$$1.prototype);
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners() {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return;
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go(n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL(push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    return getHash();
  };

  return HashHistory;
}(History);

function checkFallback(base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true;
  }
}

function ensureSlash() {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true;
  }
  replaceHash('/' + path);
  return false;
}

function getHash() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1);
}

function getUrl(path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return base + "#" + path;
}

function pushHash(path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash(path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = function (History$$1) {
  function AbstractHistory(router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if (History$$1) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create(History$$1 && History$$1.prototype);
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go(n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return;
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/';
  };

  AbstractHistory.prototype.ensureURL = function ensureURL() {
    // noop
  };

  return AbstractHistory;
}(History);

/*  */

var VueRouter = function VueRouter(options) {
  if (options === void 0) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break;
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break;
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break;
    default:
      if (false) {
        assert(false, "invalid mode: " + mode);
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match(raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom);
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current;
};

VueRouter.prototype.init = function init(app /* Vue component instance */) {
  var this$1 = this;

  "production" !== 'production' && assert(install.installed, "not installed. Make sure to call `Vue.use(VueRouter)` " + "before creating root instance.");

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return;
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function setupHashListener() {
      history.setupListeners();
    };
    history.transitionTo(history.getCurrentLocation(), setupHashListener, setupHashListener);
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach(fn) {
  return registerHook(this.beforeHooks, fn);
};

VueRouter.prototype.beforeResolve = function beforeResolve(fn) {
  return registerHook(this.resolveHooks, fn);
};

VueRouter.prototype.afterEach = function afterEach(fn) {
  return registerHook(this.afterHooks, fn);
};

VueRouter.prototype.onReady = function onReady(cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError(errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go(n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back() {
  this.go(-1);
};

VueRouter.prototype.forward = function forward() {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents(to) {
  var route = to ? to.matched ? to : this.resolve(to).route : this.currentRoute;
  if (!route) {
    return [];
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key];
    });
  }));
};

VueRouter.prototype.resolve = function resolve(to, current, append) {
  var location = normalizeLocation(to, current || this.history.current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  };
};

VueRouter.prototype.addRoutes = function addRoutes(routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties(VueRouter.prototype, prototypeAccessors);

function registerHook(list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) {
      list.splice(i, 1);
    }
  };
}

function createHref(base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path;
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

exports.default = VueRouter;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(176);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes van-slide-up-enter{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes van-slide-up-enter{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@-webkit-keyframes van-slide-up-leave{to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes van-slide-up-leave{to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@-webkit-keyframes van-slide-down-enter{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes van-slide-down-enter{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@-webkit-keyframes van-slide-down-leave{to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes van-slide-down-leave{to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@-webkit-keyframes van-slide-left-enter{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-slide-left-enter{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes van-slide-left-leave{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-slide-left-leave{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes van-slide-right-enter{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes van-slide-right-enter{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@-webkit-keyframes van-slide-right-leave{to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes van-slide-right-leave{to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@-webkit-keyframes van-fade-in{0%{opacity:0}to{opacity:1}}@keyframes van-fade-in{0%{opacity:0}to{opacity:1}}@-webkit-keyframes van-fade-out{0%{opacity:1}to{opacity:0}}@keyframes van-fade-out{0%{opacity:1}to{opacity:0}}@-webkit-keyframes van-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes van-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes van-circular{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40}to{stroke-dasharray:90,150;stroke-dashoffset:-120}}@keyframes van-circular{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40}to{stroke-dasharray:90,150;stroke-dashoffset:-120}}@-webkit-keyframes van-notice-bar-play{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-notice-bar-play{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes van-notice-bar-play-infinite{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-notice-bar-play-infinite{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}html{-webkit-tap-highlight-color:transparent}body{margin:0}a{text-decoration:none}a:focus,button:focus,input:focus,textarea:focus{outline:0}ol,ul{margin:0;padding:0;list-style:none}button,input,textarea{font:inherit;color:inherit}.van-ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.van-clearfix:after{content:\"\";display:table;clear:both}[class*=van-hairline]{position:relative}[class*=van-hairline]:after{content:\" \";position:absolute;pointer-events:none;box-sizing:border-box;top:-50%;left:-50%;right:-50%;bottom:-50%;-webkit-transform:scale(.5);transform:scale(.5);border:0 solid #ebedf0}.van-hairline--top:after{border-top-width:1px}.van-hairline--left:after{border-left-width:1px}.van-hairline--right:after{border-right-width:1px}.van-hairline--bottom:after{border-bottom-width:1px}.van-hairline--top-bottom:after{border-width:1px 0}.van-hairline--surround:after{border-width:1px}.van-fade-enter-active{-webkit-animation:.3s van-fade-in;animation:.3s van-fade-in}.van-fade-leave-active{-webkit-animation:.3s van-fade-out;animation:.3s van-fade-out}.van-slide-up-enter-active{-webkit-animation:van-slide-up-enter .3s both ease;animation:van-slide-up-enter .3s both ease}.van-slide-up-leave-active{-webkit-animation:van-slide-up-leave .3s both ease;animation:van-slide-up-leave .3s both ease}.van-slide-down-enter-active{-webkit-animation:van-slide-down-enter .3s both ease;animation:van-slide-down-enter .3s both ease}.van-slide-down-leave-active{-webkit-animation:van-slide-down-leave .3s both ease;animation:van-slide-down-leave .3s both ease}.van-slide-left-enter-active{-webkit-animation:van-slide-left-enter .3s both ease;animation:van-slide-left-enter .3s both ease}.van-slide-left-leave-active{-webkit-animation:van-slide-left-leave .3s both ease;animation:van-slide-left-leave .3s both ease}.van-slide-right-enter-active{-webkit-animation:van-slide-right-enter .3s both ease;animation:van-slide-right-enter .3s both ease}.van-slide-right-leave-active{-webkit-animation:van-slide-right-leave .3s both ease;animation:van-slide-right-leave .3s both ease}.van-info{position:absolute;right:0;top:-8px;color:#fff;font-size:12px;font-weight:500;font-family:PingFang SC,Helvetica Neue,Arial,sans-serif;text-align:center;box-sizing:border-box;padding:0 3px;min-width:16px;line-height:14px;border:1px solid #fff;border-radius:16px;background-color:#f44;-webkit-transform:translateX(50%);transform:translateX(50%);-webkit-transform-origin:100%;transform-origin:100%}@font-face{font-style:normal;font-weight:400;font-family:vant-icon;src:url(https://img.yzcdn.cn/vant/vant-icon-839a51.woff2) format(\"woff2\"),url(https://img.yzcdn.cn/vant/vant-icon-839a51.woff) format(\"woff\"),url(https://img.yzcdn.cn/vant/vant-icon-839a51.ttf) format(\"truetype\")}.van-icon{position:relative;font:14px/1 vant-icon;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased}.van-icon,.van-icon:before{display:inline-block}.van-icon-add-o:before{content:\"\\F000\"}.van-icon-add-square:before{content:\"\\F001\"}.van-icon-add:before{content:\"\\F002\"}.van-icon-after-sale:before{content:\"\\F003\"}.van-icon-aim:before{content:\"\\F004\"}.van-icon-alipay:before{content:\"\\F005\"}.van-icon-apps-o:before{content:\"\\F006\"}.van-icon-arrow-down:before{content:\"\\F007\"}.van-icon-arrow-left:before{content:\"\\F008\"}.van-icon-arrow-up:before{content:\"\\F009\"}.van-icon-arrow:before{content:\"\\F00A\"}.van-icon-ascending:before{content:\"\\F00B\"}.van-icon-audio:before{content:\"\\F00C\"}.van-icon-award-o:before{content:\"\\F00D\"}.van-icon-award:before{content:\"\\F00E\"}.van-icon-bag-o:before{content:\"\\F00F\"}.van-icon-bag:before{content:\"\\F010\"}.van-icon-balance-list-o:before{content:\"\\F011\"}.van-icon-balance-list:before{content:\"\\F012\"}.van-icon-balance-o:before{content:\"\\F013\"}.van-icon-balance-pay:before{content:\"\\F014\"}.van-icon-bar-chart-o:before{content:\"\\F015\"}.van-icon-bars:before{content:\"\\F016\"}.van-icon-bell:before{content:\"\\F017\"}.van-icon-bill-o:before{content:\"\\F018\"}.van-icon-bill:before{content:\"\\F019\"}.van-icon-birthday-cake-o:before{content:\"\\F01A\"}.van-icon-bookmark-o:before{content:\"\\F01B\"}.van-icon-bookmark:before{content:\"\\F01C\"}.van-icon-browsing-history-o:before{content:\"\\F01D\"}.van-icon-browsing-history:before{content:\"\\F01E\"}.van-icon-brush-o:before{content:\"\\F01F\"}.van-icon-bulb-o:before{content:\"\\F020\"}.van-icon-bullhorn-o:before{content:\"\\F021\"}.van-icon-calender-o:before{content:\"\\F022\"}.van-icon-card:before{content:\"\\F023\"}.van-icon-cart-circle-o:before{content:\"\\F024\"}.van-icon-cart-circle:before{content:\"\\F025\"}.van-icon-cart-o:before{content:\"\\F026\"}.van-icon-cart:before{content:\"\\F027\"}.van-icon-cash-back-record:before{content:\"\\F028\"}.van-icon-cash-on-deliver:before{content:\"\\F029\"}.van-icon-cashier-o:before{content:\"\\F02A\"}.van-icon-certificate:before{content:\"\\F02B\"}.van-icon-chart-trending-o:before{content:\"\\F02C\"}.van-icon-chat-o:before{content:\"\\F02D\"}.van-icon-chat:before{content:\"\\F02E\"}.van-icon-checked:before{content:\"\\F02F\"}.van-icon-circle:before{content:\"\\F030\"}.van-icon-clear:before{content:\"\\F031\"}.van-icon-clock-o:before{content:\"\\F032\"}.van-icon-clock:before{content:\"\\F033\"}.van-icon-close:before{content:\"\\F034\"}.van-icon-closed-eye:before{content:\"\\F035\"}.van-icon-cluster-o:before{content:\"\\F036\"}.van-icon-cluster:before{content:\"\\F037\"}.van-icon-column:before{content:\"\\F038\"}.van-icon-comment-circle-o:before{content:\"\\F039\"}.van-icon-comment-o:before{content:\"\\F03A\"}.van-icon-comment:before{content:\"\\F03B\"}.van-icon-completed:before{content:\"\\F03C\"}.van-icon-contact:before{content:\"\\F03D\"}.van-icon-coupon-o:before{content:\"\\F03E\"}.van-icon-coupon:before{content:\"\\F03F\"}.van-icon-credit-pay:before{content:\"\\F040\"}.van-icon-cross:before{content:\"\\F041\"}.van-icon-debit-pay:before{content:\"\\F042\"}.van-icon-delete:before{content:\"\\F043\"}.van-icon-descending:before{content:\"\\F044\"}.van-icon-description:before{content:\"\\F045\"}.van-icon-desktop-o:before{content:\"\\F046\"}.van-icon-diamond-o:before{content:\"\\F047\"}.van-icon-diamond:before{content:\"\\F048\"}.van-icon-discount:before{content:\"\\F049\"}.van-icon-ecard-pay:before{content:\"\\F04A\"}.van-icon-edit:before{content:\"\\F04B\"}.van-icon-ellipsis:before{content:\"\\F04C\"}.van-icon-empty:before{content:\"\\F04D\"}.van-icon-envelop-o:before{content:\"\\F04E\"}.van-icon-exchange:before{content:\"\\F04F\"}.van-icon-expand-o:before{content:\"\\F050\"}.van-icon-expand:before{content:\"\\F051\"}.van-icon-eye-o:before{content:\"\\F052\"}.van-icon-eye:before{content:\"\\F053\"}.van-icon-fail:before{content:\"\\F054\"}.van-icon-failure:before{content:\"\\F055\"}.van-icon-filter-o:before{content:\"\\F056\"}.van-icon-fire-o:before{content:\"\\F057\"}.van-icon-fire:before{content:\"\\F058\"}.van-icon-flag-o:before{content:\"\\F059\"}.van-icon-flower-o:before{content:\"\\F05A\"}.van-icon-free-postage:before{content:\"\\F05B\"}.van-icon-friends-o:before{content:\"\\F05C\"}.van-icon-friends:before{content:\"\\F05D\"}.van-icon-gem-o:before{content:\"\\F05E\"}.van-icon-gem:before{content:\"\\F05F\"}.van-icon-gift-card-o:before{content:\"\\F060\"}.van-icon-gift-card:before{content:\"\\F061\"}.van-icon-gift-o:before{content:\"\\F062\"}.van-icon-gift:before{content:\"\\F063\"}.van-icon-gold-coin-o:before{content:\"\\F064\"}.van-icon-gold-coin:before{content:\"\\F065\"}.van-icon-goods-collect-o:before{content:\"\\F066\"}.van-icon-goods-collect:before{content:\"\\F067\"}.van-icon-graphic:before{content:\"\\F068\"}.van-icon-home-o:before{content:\"\\F069\"}.van-icon-hot-o:before{content:\"\\F06A\"}.van-icon-hot-sale-o:before{content:\"\\F06B\"}.van-icon-hot-sale:before{content:\"\\F06C\"}.van-icon-hot:before{content:\"\\F06D\"}.van-icon-hotel-o:before{content:\"\\F06E\"}.van-icon-idcard:before{content:\"\\F06F\"}.van-icon-info-o:before{content:\"\\F070\"}.van-icon-info:before{content:\"\\F071\"}.van-icon-invition:before{content:\"\\F072\"}.van-icon-label-o:before{content:\"\\F073\"}.van-icon-label:before{content:\"\\F074\"}.van-icon-like-o:before{content:\"\\F075\"}.van-icon-like:before{content:\"\\F076\"}.van-icon-live:before{content:\"\\F077\"}.van-icon-location-o:before{content:\"\\F078\"}.van-icon-location:before{content:\"\\F079\"}.van-icon-lock:before{content:\"\\F07A\"}.van-icon-logistics:before{content:\"\\F07B\"}.van-icon-manager-o:before{content:\"\\F07C\"}.van-icon-manager:before{content:\"\\F07D\"}.van-icon-map-marked:before{content:\"\\F07E\"}.van-icon-medel-o:before{content:\"\\F07F\"}.van-icon-medel:before{content:\"\\F080\"}.van-icon-more-o:before{content:\"\\F081\"}.van-icon-more:before{content:\"\\F082\"}.van-icon-music-o:before{content:\"\\F083\"}.van-icon-new-arrival-o:before{content:\"\\F084\"}.van-icon-new-arrival:before{content:\"\\F085\"}.van-icon-new-o:before{content:\"\\F086\"}.van-icon-new:before{content:\"\\F087\"}.van-icon-newspaper-o:before{content:\"\\F088\"}.van-icon-notes-o:before{content:\"\\F089\"}.van-icon-orders-o:before{content:\"\\F08A\"}.van-icon-other-pay:before{content:\"\\F08B\"}.van-icon-paid:before{content:\"\\F08C\"}.van-icon-passed:before{content:\"\\F08D\"}.van-icon-pause-circle-o:before{content:\"\\F08E\"}.van-icon-pause-circle:before{content:\"\\F08F\"}.van-icon-pause:before{content:\"\\F090\"}.van-icon-peer-pay:before{content:\"\\F091\"}.van-icon-pending-payment:before{content:\"\\F092\"}.van-icon-phone-circle-o:before{content:\"\\F093\"}.van-icon-phone-o:before{content:\"\\F094\"}.van-icon-phone:before{content:\"\\F095\"}.van-icon-photo-o:before{content:\"\\F096\"}.van-icon-photo:before{content:\"\\F097\"}.van-icon-photograph:before{content:\"\\F098\"}.van-icon-play-circle-o:before{content:\"\\F099\"}.van-icon-play-circle:before{content:\"\\F09A\"}.van-icon-play:before{content:\"\\F09B\"}.van-icon-plus:before{content:\"\\F09C\"}.van-icon-point-gift-o:before{content:\"\\F09D\"}.van-icon-point-gift:before{content:\"\\F09E\"}.van-icon-points:before{content:\"\\F09F\"}.van-icon-printer:before{content:\"\\F0A0\"}.van-icon-qr-invalid:before{content:\"\\F0A1\"}.van-icon-qr:before{content:\"\\F0A2\"}.van-icon-question-o:before{content:\"\\F0A3\"}.van-icon-question:before{content:\"\\F0A4\"}.van-icon-records:before{content:\"\\F0A5\"}.van-icon-refund-o:before{content:\"\\F0A6\"}.van-icon-replay:before{content:\"\\F0A7\"}.van-icon-scan:before{content:\"\\F0A8\"}.van-icon-search:before{content:\"\\F0A9\"}.van-icon-send-gift-o:before{content:\"\\F0AA\"}.van-icon-send-gift:before{content:\"\\F0AB\"}.van-icon-service-o:before{content:\"\\F0AC\"}.van-icon-service:before{content:\"\\F0AD\"}.van-icon-setting-o:before{content:\"\\F0AE\"}.van-icon-setting:before{content:\"\\F0AF\"}.van-icon-share:before{content:\"\\F0B0\"}.van-icon-shop-collect-o:before{content:\"\\F0B1\"}.van-icon-shop-collect:before{content:\"\\F0B2\"}.van-icon-shop-o:before{content:\"\\F0B3\"}.van-icon-shop:before{content:\"\\F0B4\"}.van-icon-shopping-cart-o:before{content:\"\\F0B5\"}.van-icon-shopping-cart:before{content:\"\\F0B6\"}.van-icon-shrink:before{content:\"\\F0B7\"}.van-icon-sign:before{content:\"\\F0B8\"}.van-icon-smile-comment-o:before{content:\"\\F0B9\"}.van-icon-smile-comment:before{content:\"\\F0BA\"}.van-icon-smile-o:before{content:\"\\F0BB\"}.van-icon-star-o:before{content:\"\\F0BC\"}.van-icon-star:before{content:\"\\F0BD\"}.van-icon-stop-circle-o:before{content:\"\\F0BE\"}.van-icon-stop-circle:before{content:\"\\F0BF\"}.van-icon-stop:before{content:\"\\F0C0\"}.van-icon-success:before{content:\"\\F0C1\"}.van-icon-thumb-circle-o:before{content:\"\\F0C2\"}.van-icon-todo-list-o:before{content:\"\\F0C3\"}.van-icon-todo-list:before{content:\"\\F0C4\"}.van-icon-tosend:before{content:\"\\F0C5\"}.van-icon-tv-o:before{content:\"\\F0C6\"}.van-icon-umbrella-circle:before{content:\"\\F0C7\"}.van-icon-underway-o:before{content:\"\\F0C8\"}.van-icon-underway:before{content:\"\\F0C9\"}.van-icon-upgrade:before{content:\"\\F0CA\"}.van-icon-user-circle-o:before{content:\"\\F0CB\"}.van-icon-user-o:before{content:\"\\F0CC\"}.van-icon-video-o:before{content:\"\\F0CD\"}.van-icon-video:before{content:\"\\F0CE\"}.van-icon-vip-card-o:before{content:\"\\F0CF\"}.van-icon-vip-card:before{content:\"\\F0D0\"}.van-icon-volume-o:before{content:\"\\F0D1\"}.van-icon-volume:before{content:\"\\F0D2\"}.van-icon-wap-home:before{content:\"\\F0D3\"}.van-icon-wap-nav:before{content:\"\\F0D4\"}.van-icon-warn-o:before{content:\"\\F0D5\"}.van-icon-warning-o:before{content:\"\\F0D6\"}.van-icon-weapp-nav:before{content:\"\\F0D7\"}.van-icon-wechat:before{content:\"\\F0D8\"}.van-icon-youzan-shield:before{content:\"\\F0D9\"}.van-icon--image{width:1em;height:1em}.van-icon--image img{top:0;left:0;right:0;bottom:0;margin:auto;max-width:100%;max-height:100%;position:absolute}.van-loading{width:30px;height:30px;z-index:0;font-size:0;line-height:0;position:relative;vertical-align:middle}.van-loading--circle{width:16px;height:16px}.van-loading__spinner{z-index:-1;width:100%;height:100%;position:relative;display:inline-block;box-sizing:border-box;-webkit-animation:van-rotate .8s linear infinite;animation:van-rotate .8s linear infinite}.van-loading__spinner--circle{border-radius:100%;border:3px solid transparent;border-color:#7d7e80 #c8c9cc #c8c9cc}.van-loading__spinner--gradient-circle{background-size:contain;background-image:url(https://img.yzcdn.cn/vant/gradient-circle-black.png)}.van-loading__spinner--spinner{-webkit-animation-timing-function:steps(12);animation-timing-function:steps(12)}.van-circle svg,.van-loading__spinner--spinner i{top:0;left:0;width:100%;height:100%;position:absolute}.van-loading__spinner--spinner i:before{width:2px;height:25%;content:\" \";display:block;margin:0 auto;border-radius:40%;background-color:currentColor}.van-loading__spinner--circular{-webkit-animation-duration:2s;animation-duration:2s}.van-loading__circular{width:100%;height:100%}.van-loading__circular circle{stroke:currentColor;stroke-width:3;stroke-linecap:round;-webkit-animation:van-circular 1.5s ease-in-out infinite;animation:van-circular 1.5s ease-in-out infinite}.van-loading--white .van-loading__spinner--circle{border-color:hsla(0,0%,100%,.7) rgba(0,0,0,.1) rgba(0,0,0,.1)}.van-loading--white .van-loading__spinner--gradient-circle{background-image:url(https://img.yzcdn.cn/vant/gradient-circle-white.png)}.van-loading__spinner--spinner i:first-of-type{opacity:1;-webkit-transform:rotate(30deg);transform:rotate(30deg)}.van-loading__spinner--spinner i:nth-of-type(2){opacity:.9375;-webkit-transform:rotate(60deg);transform:rotate(60deg)}.van-loading__spinner--spinner i:nth-of-type(3){opacity:.875;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.van-loading__spinner--spinner i:nth-of-type(4){opacity:.8125;-webkit-transform:rotate(120deg);transform:rotate(120deg)}.van-loading__spinner--spinner i:nth-of-type(5){opacity:.75;-webkit-transform:rotate(150deg);transform:rotate(150deg)}.van-loading__spinner--spinner i:nth-of-type(6){opacity:.6875;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.van-loading__spinner--spinner i:nth-of-type(7){opacity:.625;-webkit-transform:rotate(210deg);transform:rotate(210deg)}.van-loading__spinner--spinner i:nth-of-type(8){opacity:.5625;-webkit-transform:rotate(240deg);transform:rotate(240deg)}.van-loading__spinner--spinner i:nth-of-type(9){opacity:.5;-webkit-transform:rotate(270deg);transform:rotate(270deg)}.van-loading__spinner--spinner i:nth-of-type(10){opacity:.4375;-webkit-transform:rotate(300deg);transform:rotate(300deg)}.van-loading__spinner--spinner i:nth-of-type(11){opacity:.375;-webkit-transform:rotate(330deg);transform:rotate(330deg)}.van-loading__spinner--spinner i:nth-of-type(12){opacity:.3125;-webkit-transform:rotate(1turn);transform:rotate(1turn)}.van-button{display:inline-block;position:relative;padding:0;height:44px;line-height:42px;font-size:16px;border-radius:2px;text-align:center;box-sizing:border-box;-webkit-appearance:none;-webkit-text-size-adjust:100%}.van-button:before{content:\" \";position:absolute;top:50%;left:50%;opacity:0;width:100%;height:100%;border:inherit;border-color:#000;background-color:#000;border-radius:inherit;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.van-button:active:before{opacity:.1}.van-button--disabled:before,.van-button--loading:before{display:none}.van-button--default{color:#323233;background-color:#fff;border:1px solid #ebedf0}.van-button--primary{color:#fff;background-color:#07c160;border:1px solid #07c160}.van-button--info{color:#fff;background-color:#1989fa;border:1px solid #1989fa}.van-button--danger{color:#fff;background-color:#f44;border:1px solid #f44}.van-button--warning{color:#fff;background-color:#ff976a;border:1px solid #ff976a}.van-button--plain{background-color:#fff}.van-button--plain.van-button--primary{color:#07c160}.van-button--plain.van-button--info{color:#1989fa}.van-button--plain.van-button--danger{color:#f44}.van-button--plain.van-button--warning{color:#ff976a}.van-button--large{width:100%;height:50px;line-height:48px}.van-button--normal{padding:0 15px;font-size:14px}.van-button--small{padding:0 8px;height:30px;min-width:60px;font-size:12px;line-height:28px}.van-button--loading .van-loading,.van-button--mini{display:inline-block}.van-button--mini{height:22px;min-width:50px;font-size:10px;line-height:20px}.van-button--mini+.van-button--mini{margin-left:5px}.van-button--block{width:100%;display:block}.van-button--bottom-action{border:0;width:100%;height:50px;font-size:16px;line-height:50px;border-radius:0;color:#fff;background-color:#ff976a}.van-button--bottom-action.van-button--primary{background-color:#f44}.van-button--disabled{opacity:.5}.van-button--hairline.van-button--round:after,.van-button--round{border-radius:10em}.van-button--hairline.van-button--square:after,.van-button--square{border-radius:0}.van-button__loading-text{margin-left:5px;display:inline-block;vertical-align:middle}.van-button--hairline{border-width:0}.van-button--hairline:after{border-color:inherit;border-radius:4px}.van-cell{position:relative;display:-webkit-box;display:-webkit-flex;display:flex;width:100%;overflow:hidden;box-sizing:border-box;color:#323233;font-size:14px;line-height:24px;background-color:#fff;padding:10px 15px}.van-cell:not(:last-child):after{content:\" \";position:absolute;pointer-events:none;box-sizing:border-box;left:15px;right:0;bottom:0;-webkit-transform:scaleY(.5);transform:scaleY(.5);border-bottom:1px solid #ebedf0}.van-cell--borderless:after{display:none}.van-cell__label{color:#969799;font-size:12px;margin-top:3px;line-height:18px}.van-cell__title,.van-cell__value{-webkit-box-flex:1;-webkit-flex:1;flex:1}.van-cell__value{color:#969799;overflow:hidden;text-align:right;position:relative;vertical-align:middle}.van-cell__value--alone{color:#323233;text-align:left}.van-cell__left-icon,.van-cell__right-icon{min-width:1em;height:24px;font-size:16px;line-height:24px}.van-cell__left-icon{margin-right:5px}.van-cell__right-icon{margin-left:5px;color:#969799}.van-cell--clickable:active{background-color:#f2f3f5}.van-cell--required{overflow:visible}.van-cell--required:before{content:\"*\";position:absolute;left:7px;font-size:14px;color:#f44}.van-cell--center{-webkit-box-align:center;-webkit-align-items:center;align-items:center}.van-cell--large{padding-top:12px;padding-bottom:12px}.van-cell--large .van-cell__title{font-size:16px}.van-cell--large .van-cell__label{font-size:14px}.van-cell-group{background-color:#fff}.van-cell-group__title{color:#969799;padding:15px 15px 5px;font-size:14px;line-height:16px}.van-col{float:left;min-height:1px;box-sizing:border-box}.van-col--1{width:4.16666667%}.van-col--offset-1{margin-left:4.16666667%}.van-col--2{width:8.33333333%}.van-col--offset-2{margin-left:8.33333333%}.van-col--3{width:12.5%}.van-col--offset-3{margin-left:12.5%}.van-col--4{width:16.66666667%}.van-col--offset-4{margin-left:16.66666667%}.van-col--5{width:20.83333333%}.van-col--offset-5{margin-left:20.83333333%}.van-col--6{width:25%}.van-col--offset-6{margin-left:25%}.van-col--7{width:29.16666667%}.van-col--offset-7{margin-left:29.16666667%}.van-col--8{width:33.33333333%}.van-col--offset-8{margin-left:33.33333333%}.van-col--9{width:37.5%}.van-col--offset-9{margin-left:37.5%}.van-col--10{width:41.66666667%}.van-col--offset-10{margin-left:41.66666667%}.van-col--11{width:45.83333333%}.van-col--offset-11{margin-left:45.83333333%}.van-col--12{width:50%}.van-col--offset-12{margin-left:50%}.van-col--13{width:54.16666667%}.van-col--offset-13{margin-left:54.16666667%}.van-col--14{width:58.33333333%}.van-col--offset-14{margin-left:58.33333333%}.van-col--15{width:62.5%}.van-col--offset-15{margin-left:62.5%}.van-col--16{width:66.66666667%}.van-col--offset-16{margin-left:66.66666667%}.van-col--17{width:70.83333333%}.van-col--offset-17{margin-left:70.83333333%}.van-col--18{width:75%}.van-col--offset-18{margin-left:75%}.van-col--19{width:79.16666667%}.van-col--offset-19{margin-left:79.16666667%}.van-col--20{width:83.33333333%}.van-col--offset-20{margin-left:83.33333333%}.van-col--21{width:87.5%}.van-col--offset-21{margin-left:87.5%}.van-col--22{width:91.66666667%}.van-col--offset-22{margin-left:91.66666667%}.van-col--23{width:95.83333333%}.van-col--offset-23{margin-left:95.83333333%}.van-col--24{width:100%}.van-col--offset-24{margin-left:100%}.van-row:after{content:\"\";display:table;clear:both}.van-row--flex{display:-webkit-box;display:-webkit-flex;display:flex}.van-row--flex:after{display:none}.van-row--justify-center{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.van-row--justify-end{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.van-row--justify-space-between{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.van-row--justify-space-around{-webkit-justify-content:space-around;justify-content:space-around}.van-row--align-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center}.van-row--align-bottom{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end}.van-badge{display:block;overflow:hidden;-webkit-user-select:none;user-select:none;word-break:break-all;box-sizing:border-box;color:#7d7e80;padding:20px 12px 20px 9px;font-size:14px;line-height:1.4;background-color:#f8f8f8;border-left:3px solid transparent}.van-badge__text{position:relative}.van-badge:active{background-color:#f2f3f5}.van-badge:not(:last-child):after{border-bottom-width:1px}.van-badge--select{color:#323233;font-weight:500;border-color:#f44}.van-badge--select:after{border-right-width:1px}.van-badge--select,.van-badge--select:active{background-color:#fff}.van-badge .van-info{right:4px}.badge-group{width:85px}.van-circle{position:relative;text-align:center;display:inline-block}.van-circle__layer{fill:none;stroke-linecap:round;stroke-dasharray:3140;stroke-dashoffset:3140;-webkit-transform:rotate(90deg);transform:rotate(90deg);-webkit-transform-origin:530px 530px;transform-origin:530px 530px}.van-circle__text{top:50%;left:0;width:100%;color:#323233;position:absolute;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-collapse-item__title .van-cell__right-icon:before{-webkit-transform:rotate(90deg);transform:rotate(90deg);-webkit-transition:.3s;transition:.3s}.van-collapse-item__title:after{visibility:hidden}.van-collapse-item__title--expanded .van-cell__right-icon:before{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.van-collapse-item__title--expanded:after{visibility:visible}.van-collapse-item__title--disabled,.van-collapse-item__title--disabled .van-cell__right-icon{color:#c8c9cc}.van-collapse-item__title--disabled:active{background-color:#fff}.van-collapse-item__wrapper{overflow:hidden;will-change:height;-webkit-transition:height .3s ease-in-out;transition:height .3s ease-in-out}.van-collapse-item__content{color:#969799;padding:15px;font-size:13px;line-height:1.5;background-color:#fff}.van-list__error-text,.van-list__finished-text,.van-list__loading-text{color:#969799;font-size:13px;line-height:50px;text-align:center}.van-list__loading{text-align:center}.van-list__loading-icon,.van-list__loading-text{display:inline-block;vertical-align:middle}.van-list__loading-icon{width:16px;height:16px;margin-right:5px}.van-nav-bar{position:relative;-webkit-user-select:none;user-select:none;text-align:center;height:46px;line-height:46px;background-color:#fff}.van-nav-bar .van-icon{color:#1989fa;vertical-align:middle}.van-nav-bar__arrow{min-width:1em;font-size:16px}.van-nav-bar__arrow+.van-nav-bar__text{margin-left:-20px;padding-left:25px}.van-nav-bar--fixed{top:0;left:0;width:100%;position:fixed}.van-nav-bar__title{margin:0 auto;max-width:60%;color:#323233;font-size:16px;font-weight:500}.van-nav-bar__left,.van-nav-bar__right{bottom:0;font-size:14px;position:absolute}.van-nav-bar__left{left:15px}.van-nav-bar__right{right:15px}.van-nav-bar__text{color:#1989fa;margin:0 -15px;padding:0 15px;display:inline-block;vertical-align:middle}.van-nav-bar__text:active{background-color:#f2f3f5}.van-notice-bar{display:-webkit-box;display:-webkit-flex;display:flex;height:40px;padding:0 15px;font-size:14px;line-height:24px;position:relative;-webkit-box-align:center;-webkit-align-items:center;align-items:center;color:#ed6a0c;background-color:#fffbe8}.van-notice-bar__left-icon{font-size:16px;min-width:22px}.van-notice-bar__right-icon{top:50%;right:15px;font-size:16px;position:absolute;margin-top:-.5em}.van-notice-bar__wrap{-webkit-box-flex:1;-webkit-flex:1;flex:1;height:24px;overflow:hidden;position:relative}.van-notice-bar__content{position:absolute;white-space:nowrap}.van-notice-bar__content.van-ellipsis{max-width:100%}.van-notice-bar__play{-webkit-animation:van-notice-bar-play linear both;animation:van-notice-bar-play linear both}.van-notice-bar__play--infinite{-webkit-animation:van-notice-bar-play-infinite linear infinite both;animation:van-notice-bar-play-infinite linear infinite both}.van-notice-bar--wrapable{height:auto;padding:8px 15px}.van-notice-bar--wrapable .van-notice-bar__wrap{height:auto}.van-notice-bar--wrapable .van-notice-bar__content{position:relative;white-space:normal}.van-notice-bar--withicon{position:relative;padding-right:40px}.van-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7)}.van-overflow-hidden{overflow:hidden!important}.van-popup{position:fixed;top:50%;left:50%;max-height:100%;overflow-y:auto;background-color:#fff;-webkit-transition:.3s ease-out;transition:.3s ease-out;-webkit-overflow-scrolling:touch;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.van-popup--top{width:100%;top:0;right:auto;bottom:auto;left:50%;-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0)}.van-popup--right{top:50%;right:0;bottom:auto;left:auto;-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.van-popup--bottom{width:100%;top:auto;bottom:0;right:auto;left:50%;-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0)}.van-popup--left{top:50%;right:auto;bottom:auto;left:0;-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.van-popup-slide-top-enter,.van-popup-slide-top-leave-active{-webkit-transform:translate3d(-50%,-100%,0);transform:translate3d(-50%,-100%,0)}.van-popup-slide-right-enter,.van-popup-slide-right-leave-active{-webkit-transform:translate3d(100%,-50%,0);transform:translate3d(100%,-50%,0)}.van-popup-slide-bottom-enter,.van-popup-slide-bottom-leave-active{-webkit-transform:translate3d(-50%,100%,0);transform:translate3d(-50%,100%,0)}.van-popup-slide-left-enter,.van-popup-slide-left-leave-active{-webkit-transform:translate3d(-100%,-50%,0);transform:translate3d(-100%,-50%,0)}.van-search,.van-search__content{display:-webkit-box;display:-webkit-flex;display:flex}.van-search{padding:10px 16px;-webkit-box-align:center;-webkit-align-items:center;align-items:center;box-sizing:border-box}.van-search__content{-webkit-box-flex:1;-webkit-flex:1;flex:1;background-color:#f7f8fa;border-radius:2px;padding-left:10px}.van-search__content--round{border-radius:17px}.van-search__label{font-size:14px;color:#323233;line-height:34px;padding:0 5px}.van-search .van-cell{-webkit-box-flex:1;-webkit-flex:1;flex:1;padding:5px 10px 5px 0;background-color:transparent}.van-search .van-cell__left-icon{color:#969799}.van-search--show-action{padding-right:0}.van-search input::-webkit-search-cancel-button,.van-search input::-webkit-search-decoration,.van-search input::-webkit-search-results-button,.van-search input::-webkit-search-results-decoration{display:none}.van-search__action{padding:0 10px;font-size:14px;line-height:34px;color:#323233}.van-search__action:active{background-color:#f2f3f5}.van-pagination{display:-webkit-box;display:-webkit-flex;display:flex;text-align:center;line-height:40px;font-size:14px}.van-pagination__item{-webkit-box-flex:1;-webkit-flex:1;flex:1;color:#1989fa;height:40px;min-width:36px;background-color:#fff;box-sizing:border-box;-webkit-user-select:none;user-select:none}.van-pagination__item:active{color:#fff;background-color:#1989fa}.van-pagination__item:after{border-width:1px 0 1px 1px}.van-pagination__item:last-child:after{border-right-width:1px}.van-pagination__item--disabled,.van-pagination__item--disabled:active{background-color:#f8f8f8;color:#7d7e80;opacity:.6}.van-pagination__item--active{color:#fff;background-color:#1989fa}.van-pagination__next,.van-pagination__prev{padding:0 5px}.van-pagination__page{-webkit-box-flex:0;-webkit-flex-grow:0;flex-grow:0}.van-pagination__page-desc{-webkit-box-flex:1;-webkit-flex:1;flex:1;height:40px;color:#7d7e80}.van-pagination--simple .van-pagination__next:after,.van-pagination--simple .van-pagination__prev:after{border-width:1px}.van-panel{background:#fff}.van-panel__header-value{color:#f44}.van-panel__footer{padding:10px 15px}.van-rate{-webkit-user-select:none;user-select:none}.van-rate__item{display:inline-block;position:relative;padding:0 2px}.van-rate__icon{width:1em}.van-rate__icon--half{position:absolute;top:0;left:2px;width:.5em;overflow:hidden}.van-steps{overflow:hidden;background-color:#fff}.van-steps--horizontal{padding:0 10px}.van-steps--horizontal .van-steps__items{display:-webkit-box;display:-webkit-flex;display:flex;margin:0 0 10px;position:relative;padding-bottom:22px}.van-steps--horizontal .van-steps__items.van-steps__items--alone{padding-top:10px}.van-steps--vertical{padding:0 0 0 35px}.van-steps__icon{float:left;margin-right:10px}.van-steps .van-icon{font-size:40px}.van-steps__message{height:40px;margin:15px 0}.van-steps__title{font-size:14px;color:#323233;padding-top:4px}.van-steps__desc{font-size:12px;line-height:1.5;color:#969799}.van-step{-webkit-box-flex:1;-webkit-flex:1;flex:1;font-size:14px;position:relative;color:#969799}.van-step__circle{display:block;width:5px;height:5px;border-radius:50%;background-color:#969799}.van-step--horizontal{float:left}.van-step--horizontal:first-child .van-step__title{-webkit-transform:none;transform:none;margin-left:0}.van-step--horizontal:last-child{position:absolute;right:1px;width:auto}.van-step--horizontal:last-child .van-step__title{-webkit-transform:none;transform:none;margin-left:0}.van-step--horizontal:last-child .van-step__circle-container{left:auto;right:-9px}.van-step--horizontal .van-step__circle-container{position:absolute;top:28px;left:-8px;padding:0 8px;background-color:#fff;z-index:1}.van-step--horizontal .van-step__title{font-size:12px;-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0);display:inline-block;margin-left:3px}@media (max-width:321px){.van-step--horizontal .van-step__title{font-size:11px}}.van-step--horizontal .van-step__line{position:absolute;left:0;top:30px;width:100%;height:1px;background-color:#ebedf0}.van-step--horizontal.van-step--process{color:#323233}.van-step--horizontal.van-step--process .van-step__circle-container{top:24px}.van-step--horizontal.van-step--process .van-icon{font-size:12px;color:#07c160;display:block}.van-step--vertical{float:none;display:block;font-size:14px;line-height:18px;padding:10px 10px 10px 0}.van-step--vertical:not(:last-child):after{border-bottom-width:1px}.van-step--vertical:first-child:before{content:\"\";position:absolute;width:1px;height:20px;background-color:#fff;top:0;left:-15px;z-index:1}.van-step--vertical .van-step__circle-container>i{position:absolute;z-index:2}.van-step--vertical .van-step__circle{top:16px;left:-17px}.van-step--vertical .van-step__line{position:absolute;top:16px;left:-15px;width:1px;height:100%;background-color:#ebedf0}.van-step--vertical.van-step--process .van-icon{top:12px;left:-20px;line-height:1;font-size:12px}.van-step:last-child .van-step__line{width:0}.van-step--finish{color:#323233}.van-step--finish .van-step__circle,.van-step--finish .van-step__line{background-color:#07c160}.van-tag{color:#fff;font-size:10px;padding:.2em .5em;line-height:normal;border-radius:.2em;display:inline-block}.van-tag:after{border-color:currentColor;border-radius:.4em}.van-tag--mark{padding-right:.6em;border-radius:0 .8em .8em 0}.van-tag--mark:after{border-radius:0 1.6em 1.6em 0}.van-tag--round{border-radius:.8em}.van-tag--round:after{border-radius:1.6em}.van-tag--medium{font-size:12px}.van-tab,.van-tag--large{font-size:14px}.van-tab{-webkit-box-flex:1;-webkit-flex:1;flex:1;cursor:pointer;min-width:0;padding:0 5px;position:relative;color:#7d7e80;line-height:44px;text-align:center;box-sizing:border-box}.van-tab span{display:block}.van-tab--active{font-weight:500;color:#323233}.van-tab--disabled{color:#c8c9cc}.van-tabs{position:relative}.van-tabs__wrap{top:0;left:0;right:0;z-index:99;overflow:hidden;position:absolute}.van-tabs__wrap--page-top{position:fixed}.van-tabs__wrap--content-bottom{top:auto;bottom:0}.van-tabs__wrap--scrollable .van-tab{-webkit-box-flex:0;-webkit-flex:0 0 22%;flex:0 0 22%}.van-tabs__wrap--scrollable .van-tab--complete{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto}.van-tabs__wrap--scrollable .van-tabs__nav{overflow:hidden;overflow-x:auto;-webkit-overflow-scrolling:touch}.van-tabs__wrap--scrollable .van-tabs__nav::-webkit-scrollbar{display:none}.van-tabs__nav{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-user-select:none;user-select:none;position:relative;background-color:#fff}.van-tabs__nav--line{height:100%;padding-bottom:15px;box-sizing:content-box}.van-tabs__nav--card{margin:0 15px;border-radius:2px;box-sizing:border-box;border:1px solid #f44;height:30px}.van-tabs__nav--card .van-tab{color:#f44;border-right:1px solid #f44;line-height:28px}.van-tabs__nav--card .van-tab:last-child{border-right:none}.van-tabs__nav--card .van-tab.van-tab--active{color:#fff;background-color:#f44}.van-tabs__nav--card .van-tab--disabled{color:#c8c9cc}.van-tabs__line{z-index:1;left:0;bottom:15px;height:3px;position:absolute;border-radius:3px;background-color:#f44}.van-tabs__content--animated{overflow:hidden}.van-tabs__track{position:relative;display:-webkit-box;display:-webkit-flex;display:flex;width:100%;height:100%;will-change:left}.van-tabs--line{padding-top:44px}.van-tabs--line .van-tabs__wrap{height:44px}.van-tabs--card{padding-top:30px}.van-tabs--card>.van-tabs__wrap{height:30px}.van-tabs .van-tab__pane{width:100%;-webkit-flex-shrink:0;flex-shrink:0;box-sizing:border-box}.van-tabbar{display:-webkit-box;display:-webkit-flex;display:flex;width:100%;height:50px;background-color:#fff}.van-tabbar--fixed{left:0;bottom:0;position:fixed}.van-tabbar--safe-area-inset-bottom{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}.van-tabbar-item{-webkit-box-flex:1;-webkit-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:flex;color:#7d7e80;font-size:12px;line-height:1;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.van-tabbar-item__icon{position:relative;font-size:18px;margin-bottom:5px}.van-tabbar-item__icon .van-icon{display:block;min-width:1em}.van-tabbar-item__icon--dot:after{top:0;right:-8px;width:8px;height:8px;content:\" \";position:absolute;border-radius:100%;background-color:#f44}.van-tabbar-item__icon img{display:block;height:18px}.van-tabbar-item--active{color:#1989fa}.van-tabbar-item .van-info{margin-top:2px}.van-image-preview{top:0;left:0;width:100%;height:100%;position:fixed}.van-image-preview__image{top:0;left:0;right:0;bottom:0;margin:auto;max-width:100%;max-height:100%;position:absolute}.van-image-preview__index{position:absolute;top:10px;left:50%;color:#fff;font-size:14px;letter-spacing:2px;-webkit-transform:translate(-50%);transform:translate(-50%)}.van-image-preview__overlay{background-color:rgba(0,0,0,.9)}.van-image-preview .van-swipe{height:100%}.van-stepper{font-size:0}.van-stepper__minus,.van-stepper__plus{width:28px;height:28px;box-sizing:border-box;background-color:#f2f3f5;border:0;margin:1px;position:relative;padding:5px;vertical-align:middle}.van-stepper__minus:before,.van-stepper__plus:before{width:9px;height:1px}.van-stepper__minus:after,.van-stepper__plus:after{width:1px;height:9px}.van-stepper__minus:after,.van-stepper__minus:before,.van-stepper__plus:after,.van-stepper__plus:before{content:\"\";position:absolute;margin:auto;top:0;left:0;right:0;bottom:0;background-color:#323233}.van-stepper__minus:active,.van-stepper__plus:active{background-color:#e8e8e8}.van-stepper__minus--disabled,.van-stepper__minus--disabled:active,.van-stepper__plus--disabled,.van-stepper__plus--disabled:active{background-color:#f7f8fa}.van-stepper__minus--disabled:after,.van-stepper__minus--disabled:before,.van-stepper__plus--disabled:after,.van-stepper__plus--disabled:before{background-color:#c8c9cc}.van-stepper__minus{border-radius:4px 0 0 4px}.van-stepper__minus:after{display:none}.van-stepper__plus{border-radius:0 4px 4px 0}.van-stepper__input{width:30px;height:26px;padding:1px;border:0;margin:1px;background-color:#f2f3f5;border-width:1px 0;border-radius:0;box-sizing:content-box;color:#323233;font-size:14px;vertical-align:middle;text-align:center;-webkit-appearance:none}.van-stepper__input[disabled]{color:#c8c9cc;background-color:#f2f3f5}.van-stepper input[type=number]::-webkit-inner-spin-button,.van-stepper input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.van-progress{height:4px;position:relative;border-radius:4px;background:#e5e5e5}.van-progress__portion{left:0;height:100%;position:absolute;border-radius:inherit}.van-progress__portion--with-pivot{border-top-right-radius:0;border-bottom-right-radius:0}.van-progress__pivot{top:50%;right:0;min-width:2em;padding:0 5px;font-size:10px;position:absolute;line-height:1.6;text-align:center;border-radius:1em;word-break:keep-all;box-sizing:border-box;background-color:#e5e5e5;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}.van-swipe{overflow:hidden;position:relative;-webkit-user-select:none;user-select:none}.van-swipe__track{height:100%}.van-swipe__indicators{display:-webkit-box;display:-webkit-flex;display:flex;position:absolute;left:50%;bottom:10px;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.van-swipe__indicators--vertical{left:10px;top:50%;bottom:auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-swipe__indicators--vertical .van-swipe__indicator:not(:last-child){margin-bottom:6px}.van-swipe__indicator{border-radius:100%;opacity:.3;width:6px;height:6px;background-color:#ebedf0;-webkit-transition:opacity .2s;transition:opacity .2s}.van-swipe__indicator:not(:last-child){margin-right:6px}.van-swipe__indicator--active{opacity:1;background-color:#1989fa}.van-swipe-item{float:left;height:100%}.van-slider,.van-slider__bar{position:relative;border-radius:999px;background-color:#e5e5e5}.van-slider__bar{border-radius:inherit;background-color:#1989fa}.van-slider__button{width:20px;height:20px;box-shadow:0 1px 2px rgba(0,0,0,.5);border-radius:50%;background-color:#fff}.van-slider__button-wrapper{position:absolute;top:50%;right:0;-webkit-transform:translate3d(50%,-50%,0);transform:translate3d(50%,-50%,0)}.van-slider__button-wrapper:after{content:\"\";position:absolute;width:200%;height:200%;top:-50%;left:-50%}.van-slider--disabled{opacity:.3}.van-slider--vertical{height:100%;display:inline-block}.van-slider--vertical .van-slider__button-wrapper{top:auto;bottom:0;-webkit-transform:translate3d(50%,50%,0);transform:translate3d(50%,50%,0)}.van-checkbox{overflow:hidden;-webkit-user-select:none;user-select:none}.van-checkbox__icon,.van-checkbox__label{display:inline-block;vertical-align:middle;line-height:20px}.van-checkbox__icon{height:20px}.van-checkbox__icon .van-icon{font-size:14px;color:transparent;text-align:center;line-height:inherit;width:20px;height:20px;box-sizing:border-box;border:1px solid #e5e5e5;-webkit-transition:.2s;transition:.2s}.van-checkbox__icon--round .van-icon{border-radius:100%}.van-checkbox__icon--checked .van-icon{color:#fff;border-color:#1989fa;background-color:#1989fa}.van-checkbox__icon--disabled .van-icon{border-color:#c8c9cc;background-color:#ebedf0}.van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{color:#c8c9cc}.van-checkbox__label{color:#323233;margin-left:10px}.van-checkbox__label--left{float:left;margin:0 10px 0 0}.van-checkbox__label--disabled,.van-radio__icon--disabled.van-radio__icon--checked .van-icon{color:#c8c9cc}.van-field__label{max-width:90px}.van-field__label--center{text-align:center}.van-field__label--right{text-align:right}.van-field__body{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center}.van-field__control{border:0;margin:0;padding:0;width:100%;resize:none;display:block;color:#323233;box-sizing:border-box;background-color:transparent}.van-field__control::-webkit-input-placeholder{color:#969799}.van-field__control::placeholder{color:#969799}.van-field__control:disabled{opacity:1;color:#969799;background-color:transparent}.van-field__control--center{text-align:center}.van-field__control--right{text-align:right}.van-field__control[type=date],.van-field__control[type=datetime-local],.van-field__control[type=time]{min-height:24px}.van-field__button,.van-field__clear,.van-field__icon,.van-field__right-icon{-webkit-flex-shrink:0;flex-shrink:0}.van-field__clear,.van-field__right-icon{padding:0 10px;line-height:inherit;margin-right:-10px}.van-field__clear{color:#c8c9cc;font-size:16px}.van-field__left-icon .van-icon,.van-field__right-icon .van-icon{display:block;min-width:1em;font-size:16px;line-height:inherit}.van-field__left-icon{margin-right:5px}.van-field--disabled .van-field__control,.van-field__right-icon{color:#969799}.van-field__button{padding-left:10px}.van-field__error-message{color:#f44;font-size:12px;text-align:left}.van-field__error-message--center{text-align:center}.van-field__error-message--right{text-align:right}.van-field--error .van-field__control,.van-field--error .van-field__control::-webkit-input-placeholder{color:#f44}.van-field--error .van-field__control,.van-field--error .van-field__control::placeholder{color:#f44}.van-field--min-height .van-field__control{min-height:60px}.van-radio{overflow:hidden;-webkit-user-select:none;user-select:none}.van-radio__icon,.van-radio__label{display:inline-block;vertical-align:middle;line-height:20px}.van-radio__icon{height:20px}.van-radio__icon .van-icon{font-size:14px;color:transparent;text-align:center;line-height:inherit;width:20px;height:20px;box-sizing:border-box;border:1px solid #e5e5e5;-webkit-transition:.2s;transition:.2s}.van-radio__icon--round .van-icon{border-radius:100%}.van-radio__icon--checked .van-icon{color:#fff;border-color:#1989fa;background-color:#1989fa}.van-radio__icon--disabled .van-icon{border-color:#c8c9cc;background-color:#ebedf0}.van-radio__label{color:#323233;margin-left:10px}.van-radio__label--left{float:left;margin:0 10px 0 0}.van-radio__label--disabled{color:#c8c9cc}.van-switch,.van-switch__node{height:1em;background-color:#fff}.van-switch{display:inline-block;border:1px solid rgba(0,0,0,.1);box-sizing:content-box;position:relative;width:2em;border-radius:1em;-webkit-transition:background-color .3s;transition:background-color .3s}.van-switch__node{top:0;left:0;position:absolute;border-radius:100%;width:1em;z-index:1;-webkit-transition:.3s;transition:.3s;box-shadow:0 3px 1px 0 rgba(0,0,0,.05),0 2px 2px 0 rgba(0,0,0,.1),0 3px 3px 0 rgba(0,0,0,.05)}.van-switch__loading{top:25%;left:25%;width:50%;height:50%}.van-switch--on{background-color:#1989fa}.van-switch--on .van-switch__node{-webkit-transform:translateX(1em);transform:translateX(1em)}.van-switch--disabled{opacity:.4}.van-uploader{position:relative;display:inline-block}.van-uploader__input{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;overflow:hidden}.van-password-input{margin:0 15px;-webkit-user-select:none;user-select:none;position:relative}.van-password-input:focus{outline:0}.van-password-input__error-info,.van-password-input__info{font-size:14px;margin-top:15px;text-align:center}.van-password-input__info{color:#969799}.van-password-input__error-info{color:#f44}.van-password-input__security{width:100%;height:50px;display:-webkit-box;display:-webkit-flex;display:flex;background-color:#fff}.van-password-input__security:after{border-radius:6px}.van-password-input__security li{-webkit-box-flex:1;-webkit-flex:1;flex:1;height:100%;position:relative;font-size:20px;line-height:50px;text-align:center}.van-password-input__security li:not(:first-of-type):after{border-left-width:1px}.van-password-input__security i{position:absolute;left:50%;top:50%;width:10px;height:10px;margin:-5px 0 0 -5px;visibility:hidden;border-radius:100%;background-color:#000}.van-number-keyboard{left:0;bottom:0;width:100%;position:fixed;-webkit-user-select:none;user-select:none;background-color:#fff;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}.van-number-keyboard__title{height:30px;font-size:14px;line-height:30px;text-align:center;position:relative;color:#7d7e80}.van-number-keyboard__title-left{left:0;position:absolute}.van-number-keyboard__body{box-sizing:border-box}.van-number-keyboard__close{right:0;color:#1989fa;font-size:14px;padding:0 15px;position:absolute}.van-number-keyboard__close:active{background-color:#f2f3f5}.van-number-keyboard__sidebar{top:0;right:0;width:25%;position:absolute;height:216px}.van-number-keyboard--custom .van-number-keyboard__body{padding-right:25%}.van-number-keyboard--safe-area-inset-bottom{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}.van-key{width:33.33333333%;font-size:24px;font-style:normal;text-align:center;display:inline-block;vertical-align:middle;height:54px;line-height:54px}.van-key:after{border-width:1px 1px 0 0}.van-key--middle{width:66.66666667%}.van-key--big{width:100%;height:108px;line-height:108px}.van-key--blue,.van-key--delete{font-size:16px}.van-key--blue{color:#fff}.van-key--blue,.van-key--blue.van-key--active{background-color:#1989fa}.van-key--blue:after{border-color:#1989fa}.van-key--gray{background-color:#ebedf0}.van-actionsheet__cancel:active,.van-actionsheet__item:active,.van-key--active{background-color:#f2f3f5}.van-actionsheet{color:#323233;max-height:90%}.van-actionsheet__cancel,.van-actionsheet__item{text-align:center;font-size:16px;line-height:50px;background-color:#fff}.van-actionsheet__item{height:50px}.van-actionsheet__item--disabled{color:#c8c9cc}.van-actionsheet__item--disabled:active{background-color:#fff}.van-actionsheet__subname{color:#7d7e80;font-size:12px;margin-left:5px}.van-actionsheet__loading{display:inline-block}.van-actionsheet__cancel:before{content:\" \";display:block;height:10px;background-color:#f8f8f8}.van-actionsheet__header{font-size:16px;line-height:44px;text-align:center}.van-actionsheet__close{top:0;right:0;padding:0 15px;position:absolute;line-height:inherit;color:#969799;font-size:18px}.van-actionsheet--safe-area-inset-bottom{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}.van-dialog{position:fixed;top:50%;left:50%;overflow:hidden;width:85%;font-size:16px;-webkit-transition:.3s;transition:.3s;border-radius:4px;background-color:#fff;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.van-dialog__header{text-align:center;font-weight:500;padding-top:25px}.van-dialog__header--isolated{padding:25px 0}.van-dialog__message{padding:25px;font-size:14px;line-height:1.5;max-height:60vh;overflow-y:auto;text-align:center;-webkit-overflow-scrolling:touch;white-space:pre-wrap}.van-dialog__message--has-title{color:#7d7e80;padding-top:12px}.van-dialog__message--left{text-align:left}.van-dialog__message--right{text-align:right}.van-dialog__footer{overflow:hidden;-webkit-user-select:none;user-select:none}.van-dialog__footer--buttons{display:-webkit-box;display:-webkit-flex;display:flex}.van-dialog__footer--buttons .van-button{-webkit-box-flex:1;-webkit-flex:1;flex:1}.van-dialog .van-button{border:0}.van-dialog__confirm,.van-dialog__confirm:active{color:#1989fa}.van-dialog-bounce-enter{opacity:0;-webkit-transform:translate3d(-50%,-50%,0) scale(.7);transform:translate3d(-50%,-50%,0) scale(.7)}.van-dialog-bounce-leave-active{opacity:0;-webkit-transform:translate3d(-50%,-50%,0) scale(.9);transform:translate3d(-50%,-50%,0) scale(.9)}.van-picker{overflow:hidden;-webkit-user-select:none;user-select:none;position:relative;background-color:#fff;-webkit-text-size-adjust:100%}.van-picker__toolbar{display:-webkit-box;display:-webkit-flex;display:flex;height:44px;line-height:44px;-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.van-picker__cancel,.van-picker__confirm{color:#1989fa;padding:0 15px;font-size:14px}.van-picker__cancel:active,.van-picker__confirm:active{background-color:#f2f3f5}.van-picker__title{max-width:50%;font-size:16px;font-weight:500;text-align:center}.van-picker__columns{display:-webkit-box;display:-webkit-flex;display:flex;position:relative}.van-picker__loading{top:0;left:0;right:0;bottom:0;z-index:2;position:absolute;background-color:hsla(0,0%,100%,.9)}.van-picker__loading circle{stroke:#1989fa}.van-picker__frame,.van-picker__loading .van-loading{top:50%;left:0;width:100%;z-index:1;position:absolute;pointer-events:none;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-picker-column{-webkit-box-flex:1;-webkit-flex:1;flex:1;overflow:hidden;font-size:16px;text-align:center}.van-picker-column__item{padding:0 5px;color:#969799}.van-picker-column__item--selected{font-weight:500;color:#323233}.van-picker-column__item--disabled{opacity:.3}.van-pull-refresh{-webkit-user-select:none;user-select:none;overflow:hidden}.van-pull-refresh__track{position:relative}.van-pull-refresh__head{width:100%;height:50px;left:0;overflow:hidden;position:absolute;text-align:center;top:-50px;font-size:14px;color:#969799;line-height:50px}.van-pull-refresh__loading .van-loading{width:16px;height:16px;margin-right:5px}.van-pull-refresh__loading .van-loading,.van-pull-refresh__loading span{vertical-align:middle;display:inline-block}.van-notify,.van-toast{font-size:14px;line-height:20px;white-space:pre-wrap}.van-notify{text-align:center;padding:6px 15px;box-sizing:border-box}.van-toast{position:fixed;top:50%;left:50%;display:-webkit-box;display:-webkit-flex;display:flex;color:#fff;max-width:70%;border-radius:4px;word-break:break-all;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;box-sizing:content-box;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);background-color:rgba(50,50,51,.88);width:-webkit-fit-content;width:fit-content}.van-toast--unclickable *{pointer-events:none}.van-toast--text{padding:8px 12px;min-width:96px}.van-toast--default{width:90px;padding:15px;min-height:90px}.van-toast--default .van-toast__icon{font-size:48px}.van-toast--default .van-loading{margin:10px 0}.van-toast--default .van-toast__text{padding-top:5px}.van-toast--top{top:50px}.van-toast--bottom{top:auto;bottom:50px}.van-swipe-cell{overflow:hidden;position:relative}.van-swipe-cell__left,.van-swipe-cell__right{top:0;height:100%;position:absolute}.van-swipe-cell__left{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.van-swipe-cell__right{right:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.van-switch-cell{padding-top:9px;padding-bottom:9px}.van-switch-cell .van-switch{float:right}.van-tree-select{-webkit-user-select:none;user-select:none;font-size:14px;position:relative}.van-tree-select__nav{width:35%;position:absolute;left:0;top:0;bottom:0;min-width:120px;overflow:scroll;background-color:#fafafa;-webkit-overflow-scrolling:touch}.van-tree-select__nitem{position:relative;line-height:44px;padding:0 9px 0 15px}.van-tree-select__nitem--active:after{position:absolute;top:0;bottom:0;left:0;width:3.6px;background-color:#f44;content:\"\"}.van-tree-select__nitem--active{font-weight:700;background-color:#fff}.van-tree-select__nitem--disabled{color:#969799}.van-tree-select__nitem--disabled:active:after{display:none}.van-tree-select__content{width:65%;height:100%;padding-left:15px;margin-left:35%;overflow:scroll;-webkit-overflow-scrolling:touch;background-color:#fff;box-sizing:border-box}.van-tree-select__item{position:relative;font-weight:700;line-height:44px}.van-tree-select__item--active{color:#f44}.van-tree-select__item--disabled,.van-tree-select__item--disabled:active{color:#c8c9cc}.van-tree-select__selected{position:absolute;top:0;right:15px;bottom:0;height:24px;margin:auto 0;line-height:24px}.van-address-edit__buttons{padding:30px 15px}.van-address-edit__buttons .van-button{margin-bottom:15px}.van-address-edit-detail{padding:0}.van-address-edit-detail__finish{color:#1989fa;font-size:12px}.van-address-list{height:100%;padding-bottom:100px;box-sizing:border-box}.van-address-list__add{position:fixed;left:0;bottom:0;z-index:9999}.van-address-list__disabled-text{color:#969799;padding:0 15px;font-size:12px;line-height:30px}.van-address-item{padding:15px}.van-address-item__value{color:#323233;padding-right:34px;position:relative}.van-address-item .van-radio__label{width:100%;margin-left:0;padding-left:27px;box-sizing:border-box}.van-address-item .van-radio__icon{top:50%;left:0;height:16px;position:absolute;line-height:16px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-address-item .van-radio__icon .van-icon{width:16px;height:16px;font-size:12px}.van-address-item .van-radio__icon--checked .van-icon{border-color:#f44;background-color:#f44}.van-address-item__name{font-size:14px;font-weight:500;line-height:20px;margin-bottom:5px}.van-address-item__address{font-size:12px;line-height:16px;color:#7d7e80}.van-address-item--unswitchable .van-radio__label{padding-left:0}.van-address-item--disabled .van-address-item__address,.van-address-item--disabled .van-address-item__name{color:#969799}.van-address-item__edit{position:absolute;top:50%;right:15px;font-size:16px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-card{position:relative;color:#323233;padding:5px 15px;font-size:12px;box-sizing:border-box;background-color:#fafafa}.van-card:not(:first-child){margin-top:10px}.van-card__content,.van-card__header,.van-card__thumb{display:-webkit-box;display:-webkit-flex;display:flex}.van-card__content,.van-card__thumb{position:relative}.van-card__thumb{width:90px;height:90px;margin-right:10px;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;-webkit-box-flex:0;-webkit-flex:none;flex:none}.van-card__thumb img{border:0;max-width:100%;max-height:100%}.van-card__content{-webkit-box-flex:1;-webkit-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;min-width:0;min-height:90px}.van-card__content--centered{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.van-card__desc,.van-card__title{word-break:break-all}.van-card__title{line-height:16px;max-height:32px;font-weight:500;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.van-card__desc{color:#7d7e80;max-height:20px}.van-card__bottom,.van-card__desc{line-height:20px}.van-card__price{display:inline-block;color:#f44;font-weight:500}.van-card__origin-price{display:inline-block;margin-left:5px;color:#7d7e80;font-size:10px;text-decoration:line-through}.van-card__num{float:right}.van-card__tag{position:absolute;top:2px;left:0}.van-card__footer{text-align:right;-webkit-box-flex:0;-webkit-flex:none;flex:none}.van-card__footer .van-button{margin-left:5px}.van-contact-card{padding:15px}.van-contact-card__value{margin-left:5px;line-height:20px;display:inline-block;vertical-align:middle}.van-contact-card--add .van-contact-card__value{line-height:40px}.van-contact-card--add .van-cell__left-icon{color:#1989fa;font-size:40px}.van-contact-card:before{content:\"\";left:0;right:0;bottom:0;height:2px;position:absolute;background:-webkit-repeating-linear-gradient(135deg,#ff6c6c,#ff6c6c 20%,transparent 0,transparent 25%,#1989fa 0,#1989fa 45%,transparent 0,transparent 50%);background:repeating-linear-gradient(-45deg,#ff6c6c,#ff6c6c 20%,transparent 0,transparent 25%,#1989fa 0,#1989fa 45%,transparent 0,transparent 50%);background-size:80px}.van-contact-list{height:100%;padding-bottom:50px;box-sizing:border-box}.van-contact-list__item{padding:15px}.van-contact-list__item-value{color:#323233;padding-right:34px;position:relative}.van-contact-list .van-radio__label{margin-left:27px}.van-contact-list .van-radio__icon{top:50%;left:0;height:16px;position:absolute;line-height:16px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-contact-list .van-radio__icon .van-icon{width:16px;height:16px;font-size:12px}.van-contact-list .van-radio__icon--checked .van-icon{border-color:#f44;background-color:#f44}.van-contact-list__group{height:100%;overflow-y:scroll;box-sizing:border-box;-webkit-overflow-scrolling:touch}.van-contact-list__name{font-size:14px;font-weight:500;line-height:20px}.van-contact-list__edit{position:absolute;top:50%;right:15px;font-size:16px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-contact-list__add{position:fixed;left:0;bottom:0;z-index:9999}.van-contact-edit__buttons{padding:30px 15px}.van-contact-edit .van-cell__title{max-width:65px}.van-contact-edit .van-button{margin-bottom:15px}.van-coupon{overflow:hidden;border-radius:4px;margin:0 15px 15px;background-color:#fff;box-shadow:0 0 4px rgba(0,0,0,.1)}.van-coupon:active{background-color:#f2f3f5}.van-coupon__content{display:-webkit-box;display:-webkit-flex;display:flex;height:100px;padding:24px 0 0 15px;box-sizing:border-box}.van-coupon h2,.van-coupon p{margin:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.van-coupon h2{height:34px;font-weight:500;line-height:34px}.van-coupon p{font-size:12px;line-height:16px;color:#969799}.van-coupon__head{position:relative;min-width:85px;padding-right:10px}.van-coupon__head h2{color:#f44;font-size:24px}.van-coupon__head h2 span{font-size:50%}.van-coupon__head h2 span:not(:empty){margin-left:2px}.van-coupon__head p{white-space:pre-wrap}.van-coupon__body{-webkit-box-flex:1;-webkit-flex:1;flex:1;position:relative;border-radius:0 4px 4px 0}.van-coupon__body h2{font-size:16px}.van-coupon__corner{top:16px;right:15px;position:absolute}.van-coupon__corner .van-icon{border-color:#f44;background-color:#f44}.van-coupon__description{padding:7px 15px;border-top:1px dashed #ebedf0;background-color:#fafafa}.van-coupon--disabled:active{background-color:#fff}.van-coupon--disabled .van-coupon-item__content{height:90px}.van-coupon--disabled h2,.van-coupon--disabled p,.van-coupon--disabled span{color:#969799}.van-coupon-cell--selected{color:#323233}.van-coupon-list{height:100%;position:relative;background-color:#f8f8f8}.van-coupon-list__field{padding:7px 15px}.van-coupon-list__exchange{height:32px;line-height:30px}.van-coupon-list__list{overflow-y:auto;padding:15px 0;box-sizing:border-box;-webkit-overflow-scrolling:touch}.van-coupon-list__close{left:0;bottom:0;position:absolute;font-weight:500}.van-coupon-list__empty{padding-top:60px;text-align:center}.van-coupon-list__empty p{color:#969799;margin:15px 0;font-size:14px;line-height:20px}.van-coupon-list__empty img{width:200px;height:200px}.van-goods-action{left:0;right:0;bottom:0;display:-webkit-box;display:-webkit-flex;display:flex;position:fixed;background-color:#fff}.van-goods-action--safe-area-inset-bottom{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}.van-goods-action-big-btn{-webkit-box-flex:1;-webkit-flex:1;flex:1;padding:0}@media (max-width:321px){.van-goods-action-big-btn{font-size:15px}}.van-goods-action-mini-btn{color:#7d7e80;display:-webkit-box;display:-webkit-flex;display:flex;height:50px;font-size:10px;min-width:15%;line-height:1;text-align:center;background-color:#fff;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.van-goods-action-mini-btn:not(:first-child):after{border-left-width:1px}.van-goods-action-mini-btn:active{background-color:#f2f3f5}.van-goods-action-mini-btn__icon{width:1em;font-size:20px;margin:0 auto 5px}.van-submit-bar{left:0;bottom:0;width:100%;z-index:100;position:fixed;-webkit-user-select:none;user-select:none;background-color:#fff}.van-submit-bar__tip{color:#f56723;padding:10px;font-size:12px;line-height:18px;background-color:#fff7cc}.van-submit-bar__bar{height:50px;display:-webkit-box;display:-webkit-flex;display:flex;font-size:14px;-webkit-box-align:center;-webkit-align-items:center;align-items:center}.van-submit-bar__text{-webkit-box-flex:1;-webkit-flex:1;flex:1;font-weight:500;text-align:right;color:#323233;padding-right:12px}.van-submit-bar__text span{display:inline-block}.van-submit-bar__price{color:#f44;font-size:18px}.van-submit-bar__price:first-letter{font-size:14px}.van-submit-bar .van-button{width:110px}.van-submit-bar--safe-area-inset-bottom{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}.van-sku-container{font-size:14px;background:#fff;overflow-y:visible;max-height:-webkit-max-content;max-height:max-content}.van-sku-body{max-height:350px;overflow-y:scroll;-webkit-overflow-scrolling:touch}.van-sku-body::-webkit-scrollbar{display:none}.van-sku-header{margin-left:15px}.van-sku-header__img-wrap{position:relative;float:left;margin-top:-10px;width:80px;height:80px;background:#f8f8f8;border-radius:2px}.van-sku-header__img-wrap img{position:absolute;margin:auto;top:0;left:0;right:0;bottom:0;max-width:100%;max-height:100%}.van-sku-header__goods-info{padding:10px 60px 10px 10px;min-height:82px;overflow:hidden;box-sizing:border-box}.van-sku__goods-name{font-size:12px}.van-sku__price-num,.van-sku__price-symbol{vertical-align:middle}.van-sku__price-num{font-size:16px}.van-sku__goods-price{color:#f44;margin-top:10px;vertical-align:middle}.van-sku__close-icon{top:10px;right:15px;font-size:20px;color:#969799;position:absolute;text-align:center}.van-sku-group-container{margin-left:15px;padding:12px 0 2px}.van-sku-group-container--hide-soldout .van-sku-row__item--disabled{display:none}.van-sku-row{margin:0 15px 10px 0}.van-sku-row:last-child{margin-bottom:0}.van-sku-row__title{padding-bottom:10px}.van-sku-row__item{display:inline-block;padding:5px 9px;margin:0 10px 10px 0;height:28px;min-width:52px;line-height:16px;font-size:12px;color:#323233;text-align:center;border:1px solid #969799;border-radius:3px;box-sizing:border-box}.van-sku-row__item--active{color:#fff;border-color:#f44;background:#f44}.van-sku-row__item--disabled{background:#f2f3f5;border-color:#ebedf0;color:#c8c9cc}.van-sku-stepper-stock{padding:12px 0;margin-left:15px}.van-sku-stepper-container{height:30px;margin-right:20px}.van-sku__stepper{float:right}.van-sku__stepper-title{float:left;line-height:30px}.van-sku__quota,.van-sku__stock{display:inline-block;font-size:12px}.van-sku__stock{margin-right:10px;color:#969799}.van-sku__quota{color:#f44}.van-sku-messages{padding-bottom:10px;background:#f8f8f8}.van-sku-messages__image-cell .van-cell__title{max-width:90px}.van-sku-messages__image-cell .van-cell__value{text-align:left}.van-sku-img-uploader{display:inline-block}.van-sku-img-uploader__header{color:#323233;padding:0 10px;font-size:12px;line-height:24px;border-radius:3px;border:1px solid #ebedf0}.van-sku-img-uploader__header .van-icon{top:3px;margin-right:5px;font-size:14px}.van-sku-img-uploader__img{height:60px;width:60px;float:left;margin:10px 10px 0 0;position:relative;border:1px solid #ebedf0}.van-sku-img-uploader__img img{max-width:100%;max-height:100%;top:50%;position:relative;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-sku-img-uploader__delete{position:absolute;color:#f44;top:-12px;right:-14px;z-index:1;padding:6px}.van-sku-img-uploader__delete:before{border-radius:14px;background-color:#fff}.van-sku-img-uploader__uploading{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;width:20px;height:20px}.van-sku-actions{display:-webkit-box;display:-webkit-flex;display:flex}", ""]);

// exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Clipboard = __webpack_require__(178); // FIXME: workaround for browserify

var VueClipboardConfig = {
  autoSetContainer: false,
  appendToBody: true // This fixes IE, see #50
};

var VueClipboard = {
  install: function install(Vue) {
    var globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype;
    globalPrototype.$clipboardConfig = VueClipboardConfig;
    globalPrototype.$copyText = function (_text, container) {
      return new Promise(function (resolve, reject) {
        var fakeElement = document.createElement('button');
        var clipboard = new Clipboard(fakeElement, {
          text: function text() {
            return _text;
          },
          action: function action() {
            return 'copy';
          },
          container: (typeof container === 'undefined' ? 'undefined' : _typeof(container)) === 'object' ? container : document.body
        });
        clipboard.on('success', function (e) {
          clipboard.destroy();
          resolve(e);
        });
        clipboard.on('error', function (e) {
          clipboard.destroy();
          reject(e);
        });
        if (VueClipboardConfig.appendToBody) document.body.appendChild(fakeElement);
        fakeElement.click();
        if (VueClipboardConfig.appendToBody) document.body.removeChild(fakeElement);
      });
    };

    Vue.directive('clipboard', {
      bind: function bind(el, binding, vnode) {
        if (binding.arg === 'success') {
          el._vClipboard_success = binding.value;
        } else if (binding.arg === 'error') {
          el._vClipboard_error = binding.value;
        } else {
          var clipboard = new Clipboard(el, {
            text: function text() {
              return binding.value;
            },
            action: function action() {
              return binding.arg === 'cut' ? 'cut' : 'copy';
            },
            container: VueClipboardConfig.autoSetContainer ? el : undefined
          });
          clipboard.on('success', function (e) {
            var callback = el._vClipboard_success;
            callback && callback(e);
          });
          clipboard.on('error', function (e) {
            var callback = el._vClipboard_error;
            callback && callback(e);
          });
          el._vClipboard = clipboard;
        }
      },
      update: function update(el, binding) {
        if (binding.arg === 'success') {
          el._vClipboard_success = binding.value;
        } else if (binding.arg === 'error') {
          el._vClipboard_error = binding.value;
        } else {
          el._vClipboard.text = function () {
            return binding.value;
          };
          el._vClipboard.action = function () {
            return binding.arg === 'cut' ? 'cut' : 'copy';
          };
        }
      },
      unbind: function unbind(el, binding) {
        // FIXME: investigate why $element._vClipboard was missing
        if (!el._vClipboard) return;
        if (binding.arg === 'success') {
          delete el._vClipboard_success;
        } else if (binding.arg === 'error') {
          delete el._vClipboard_error;
        } else {
          el._vClipboard.destroy();
          delete el._vClipboard;
        }
      }
    });
  },
  config: VueClipboardConfig
};

if (( false ? 'undefined' : _typeof(exports)) === 'object') {
  module.exports = VueClipboard;
} else if (true) {
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return VueClipboard;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ClipboardJS = e() : t.ClipboardJS = e();
}(undefined, function () {
  return n = { 686: function _(t, e, n) {
      "use strict";
      n.d(e, { default: function _default() {
          return b;
        } });var e = n(279),
          i = n.n(e),
          e = n(370),
          u = n.n(e),
          e = n(817),
          r = n.n(e);function c(t) {
        try {
          return document.execCommand(t);
        } catch (t) {
          return;
        }
      }var a = function a(t) {
        t = r()(t);return c("cut"), t;
      };function o(t, e) {
        var n,
            o,
            t = (n = t, o = "rtl" === document.documentElement.getAttribute("dir"), (t = document.createElement("textarea")).style.fontSize = "12pt", t.style.border = "0", t.style.padding = "0", t.style.margin = "0", t.style.position = "absolute", t.style[o ? "right" : "left"] = "-9999px", o = window.pageYOffset || document.documentElement.scrollTop, t.style.top = "".concat(o, "px"), t.setAttribute("readonly", ""), t.value = n, t);return e.container.appendChild(t), e = r()(t), c("copy"), t.remove(), e;
      }var f = function f(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : { container: document.body },
            n = "";return "string" == typeof t ? n = o(t, e) : t instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(null == t ? void 0 : t.type) ? n = o(t.value, e) : (n = r()(t), c("copy")), n;
      };function l(t) {
        return (l = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
          return typeof t === "undefined" ? "undefined" : _typeof(t);
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
        })(t);
      }var s = function s() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.action,
            n = void 0 === e ? "copy" : e,
            o = t.container,
            e = t.target,
            t = t.text;if ("copy" !== n && "cut" !== n) throw new Error('Invalid "action" value, use either "copy" or "cut"');if (void 0 !== e) {
          if (!e || "object" !== l(e) || 1 !== e.nodeType) throw new Error('Invalid "target" value, use a valid Element');if ("copy" === n && e.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if ("cut" === n && (e.hasAttribute("readonly") || e.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
        }return t ? f(t, { container: o }) : e ? "cut" === n ? a(e) : f(e, { container: o }) : void 0;
      };function p(t) {
        return (p = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
          return typeof t === "undefined" ? "undefined" : _typeof(t);
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
        })(t);
      }function d(t, e) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
        }
      }function y(t, e) {
        return (y = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        })(t, e);
      }function h(n) {
        var o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;if (Reflect.construct.sham) return !1;if ("function" == typeof Proxy) return !0;try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }();return function () {
          var t,
              e = v(n);return t = o ? (t = v(this).constructor, Reflect.construct(e, arguments, t)) : e.apply(this, arguments), e = this, !(t = t) || "object" !== p(t) && "function" != typeof t ? function (t) {
            if (void 0 !== t) return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(e) : t;
        };
      }function v(t) {
        return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
      }function m(t, e) {
        t = "data-clipboard-".concat(t);if (e.hasAttribute(t)) return e.getAttribute(t);
      }var b = function () {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && y(t, e);
        }(r, i());var t,
            e,
            n,
            o = h(r);function r(t, e) {
          var n;return function (t) {
            if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
          }(this), (n = o.call(this)).resolveOptions(e), n.listenClick(t), n;
        }return t = r, n = [{ key: "copy", value: function value(t) {
            var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : { container: document.body };return f(t, e);
          } }, { key: "cut", value: function value(t) {
            return a(t);
          } }, { key: "isSupported", value: function value() {
            var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : ["copy", "cut"],
                t = "string" == typeof t ? [t] : t,
                e = !!document.queryCommandSupported;return t.forEach(function (t) {
              e = e && !!document.queryCommandSupported(t);
            }), e;
          } }], (e = [{ key: "resolveOptions", value: function value() {
            var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};this.action = "function" == typeof t.action ? t.action : this.defaultAction, this.target = "function" == typeof t.target ? t.target : this.defaultTarget, this.text = "function" == typeof t.text ? t.text : this.defaultText, this.container = "object" === p(t.container) ? t.container : document.body;
          } }, { key: "listenClick", value: function value(t) {
            var e = this;this.listener = u()(t, "click", function (t) {
              return e.onClick(t);
            });
          } }, { key: "onClick", value: function value(t) {
            var e = t.delegateTarget || t.currentTarget,
                n = this.action(e) || "copy",
                t = s({ action: n, container: this.container, target: this.target(e), text: this.text(e) });this.emit(t ? "success" : "error", { action: n, text: t, trigger: e, clearSelection: function clearSelection() {
                e && e.focus(), window.getSelection().removeAllRanges();
              } });
          } }, { key: "defaultAction", value: function value(t) {
            return m("action", t);
          } }, { key: "defaultTarget", value: function value(t) {
            t = m("target", t);if (t) return document.querySelector(t);
          } }, { key: "defaultText", value: function value(t) {
            return m("text", t);
          } }, { key: "destroy", value: function value() {
            this.listener.destroy();
          } }]) && d(t.prototype, e), n && d(t, n), r;
      }();
    }, 828: function _(t) {
      var e;"undefined" == typeof Element || Element.prototype.matches || ((e = Element.prototype).matches = e.matchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector || e.webkitMatchesSelector), t.exports = function (t, e) {
        for (; t && 9 !== t.nodeType;) {
          if ("function" == typeof t.matches && t.matches(e)) return t;t = t.parentNode;
        }
      };
    }, 438: function _(t, e, n) {
      var u = n(828);function i(t, e, n, o, r) {
        var i = function (e, n, t, o) {
          return function (t) {
            t.delegateTarget = u(t.target, n), t.delegateTarget && o.call(e, t);
          };
        }.apply(this, arguments);return t.addEventListener(n, i, r), { destroy: function destroy() {
            t.removeEventListener(n, i, r);
          } };
      }t.exports = function (t, e, n, o, r) {
        return "function" == typeof t.addEventListener ? i.apply(null, arguments) : "function" == typeof n ? i.bind(null, document).apply(null, arguments) : ("string" == typeof t && (t = document.querySelectorAll(t)), Array.prototype.map.call(t, function (t) {
          return i(t, e, n, o, r);
        }));
      };
    }, 879: function _(t, n) {
      n.node = function (t) {
        return void 0 !== t && t instanceof HTMLElement && 1 === t.nodeType;
      }, n.nodeList = function (t) {
        var e = Object.prototype.toString.call(t);return void 0 !== t && ("[object NodeList]" === e || "[object HTMLCollection]" === e) && "length" in t && (0 === t.length || n.node(t[0]));
      }, n.string = function (t) {
        return "string" == typeof t || t instanceof String;
      }, n.fn = function (t) {
        return "[object Function]" === Object.prototype.toString.call(t);
      };
    }, 370: function _(t, e, n) {
      var f = n(879),
          l = n(438);t.exports = function (t, e, n) {
        if (!t && !e && !n) throw new Error("Missing required arguments");if (!f.string(e)) throw new TypeError("Second argument must be a String");if (!f.fn(n)) throw new TypeError("Third argument must be a Function");if (f.node(t)) return c = e, a = n, (u = t).addEventListener(c, a), { destroy: function destroy() {
            u.removeEventListener(c, a);
          } };if (f.nodeList(t)) return o = t, r = e, i = n, Array.prototype.forEach.call(o, function (t) {
          t.addEventListener(r, i);
        }), { destroy: function destroy() {
            Array.prototype.forEach.call(o, function (t) {
              t.removeEventListener(r, i);
            });
          } };if (f.string(t)) return t = t, e = e, n = n, l(document.body, t, e, n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");var o, r, i, u, c, a;
      };
    }, 817: function _(t) {
      t.exports = function (t) {
        var e,
            n = "SELECT" === t.nodeName ? (t.focus(), t.value) : "INPUT" === t.nodeName || "TEXTAREA" === t.nodeName ? ((e = t.hasAttribute("readonly")) || t.setAttribute("readonly", ""), t.select(), t.setSelectionRange(0, t.value.length), e || t.removeAttribute("readonly"), t.value) : (t.hasAttribute("contenteditable") && t.focus(), n = window.getSelection(), (e = document.createRange()).selectNodeContents(t), n.removeAllRanges(), n.addRange(e), n.toString());return n;
      };
    }, 279: function _(t) {
      function e() {}e.prototype = { on: function on(t, e, n) {
          var o = this.e || (this.e = {});return (o[t] || (o[t] = [])).push({ fn: e, ctx: n }), this;
        }, once: function once(t, e, n) {
          var o = this;function r() {
            o.off(t, r), e.apply(n, arguments);
          }return r._ = e, this.on(t, r, n);
        }, emit: function emit(t) {
          for (var e = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[t] || []).slice(), o = 0, r = n.length; o < r; o++) {
            n[o].fn.apply(n[o].ctx, e);
          }return this;
        }, off: function off(t, e) {
          var n = this.e || (this.e = {}),
              o = n[t],
              r = [];if (o && e) for (var i = 0, u = o.length; i < u; i++) {
            o[i].fn !== e && o[i].fn._ !== e && r.push(o[i]);
          }return r.length ? n[t] = r : delete n[t], this;
        } }, t.exports = e, t.exports.TinyEmitter = e;
    } }, r = {}, o.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return o.d(e, { a: e }), e;
  }, o.d = function (t, e) {
    for (var n in e) {
      o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
    }
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o(686).default;function o(t) {
    if (r[t]) return r[t].exports;var e = r[t] = { exports: {} };return n[t](e, e.exports, o), e.exports;
  }var n, r;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.buildVueDompurifyHTMLDirective = void 0;
var dompurify_html_1 = __webpack_require__(69);
var dompurify_html_2 = __webpack_require__(69);
Object.defineProperty(exports, "buildVueDompurifyHTMLDirective", { enumerable: true, get: function get() {
        return dompurify_html_2.buildDirective;
    } });
exports.default = {
    install: function install(Vue, config, buildDOMPurifyInstance) {
        if (config === void 0) {
            config = {};
        }
        if (buildDOMPurifyInstance === void 0) {
            buildDOMPurifyInstance = dompurify_html_1.defaultDOMPurifyInstanceBuilder;
        }
        Vue.directive('dompurify-html', (0, dompurify_html_1.buildDirective)(config, buildDOMPurifyInstance));
    }
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! @license DOMPurify 2.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.5/LICENSE */

(function (global, factory) {
  ( false ? 'undefined' : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.DOMPurify = factory());
})(undefined, function () {
  'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */

  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */

    DOMPurify.version = '2.4.5';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */

    var ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */

      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */

      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */

      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */

      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */

      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */

      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */

      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */

    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */

    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */

    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */

      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */

      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */

    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */

    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */

    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */

    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */

    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */

      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */

      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */

      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */

      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */

      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */

      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */

        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */

      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */

      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */

      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */

      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ;else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if (!value) ;else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */

    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */

    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */

        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */

        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */

        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */

        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */

        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */

        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */

        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ;else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */

        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */

      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */

    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */

      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */

        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */

        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */

        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */

      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */

      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */

      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */

      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */

      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */

        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */

      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */

      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */

      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */

        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */

        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */

        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */

      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */

      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */

    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */

    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */

    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */

    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */

    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */

    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */

    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;
});
//# sourceMappingURL=purify.js.map

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(182)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(417),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(183);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5d1924a8", content, true);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(70);
exports = module.exports = __webpack_require__(0)(false);
// imports
exports.i(__webpack_require__(71), "");

// module
exports.push([module.i, ".tosafari{position:fixed;top:0;left:0;height:100%;width:100%;z-index:3000}.tosafari .content{width:100%;height:100%;display:flex;flex-direction:column}.tosafari .content img{width:100%;flex:1;height:0}.tosafari .content .bottom{height:50px;width:100%;background-color:#d3d3d3;text-align:center}.tosafari .content .bottom button{width:100%;line-height:50px;border:none}.van-popup.iosPosition{position:absolute}.player{width:100%;height:56vw;display:block}.height25{height:25px}.menu .van-tab--active{color:#1483ff;position:relative}.menu .van-tabs__line{background-color:#1483ff;color:#1483ff;height:2px}.van-tabs--line .van-tabs__wrap{height:44px;margin-left:44px}.hidefouce .van-tabs--line .van-tabs__wrap{margin-right:0!important}.noline .van-tabs--line .van-tabs__wrap{height:44px;margin-left:0}.menu2 .van-tab--active{color:#e5bc4b}.menu2 .van-tabs__line{background:#e5bc4b;color:#e5bc4b}.menu3 .van-tab--active{color:#ec1a1a}.menu3 .van-tabs__line{background:#ec1a1a;color:#ec1a1a}.Vote .van-tabs__wrap{border-radius:5px;overflow:hidden}.Vote .van-tab--active{background:#dcb45a;color:#fff}.Vote .van-tabs__line{background:none}.Vote .van-tabs__line:after{border-width:0}.view_num{position:absolute;left:10px;top:26px;border-radius:10px;padding:0 10px;height:20px;line-height:21px;color:#fff;font-size:13px;background-color:hsla(0,3%,8%,.67);z-index:1000}.view_num img{width:16px;vertical-align:middle}.scrollbar{position:absolute;left:0;top:0;width:100%;z-index:1250;background:rgba(0,0,0,.2);overflow:hidden;height:20px;line-height:20px}.scrollbar p{animation:scroll 24s linear infinite;white-space:nowrap;display:inline-block}@keyframes scroll{0%{transform:translateX(100vw)}to{transform:translateX(-100%)}}.scrollbar a{color:#0dff0a}.headtitle{position:absolute;height:54px;width:100%;background:#212126;top:0}.headtitle p{margin:auto;text-align:center;padding:0 15%;height:54px;color:#fff;line-height:54px}.home-content{background:#eee;width:100%;position:absolute;z-index:1400}.home-content>div{-webkit-overflow-scrolling:touch;overflow-scrolling:touch;height:100%;scroll-behavior:smooth}.control{width:100%;height:40px;line-height:40px;background-color:rgba(0,0,0,.5);position:absolute;bottom:0;z-index:1200}#midControl,.control{display:-webkit-box;display:-moz-box;display:flex}#midControl{flex:1}#midControl span{color:#fff;font-size:10px;line-height:42px}#progressWrap{position:relative;flex:1;margin:0 16px 0 4px}#playLine{width:100%;background-color:#f5f5f5}#playLine,#playSchedule{position:absolute;height:2px;top:19px;margin-left:6px}#playSchedule{width:20%;background-color:#1296db}#playPoint{position:absolute;background-color:#fff;width:0;height:0;border-radius:6px;top:14px;left:0;border:6px solid #fff}.fullSrceenBtn,.playpause{width:40px;text-align:center;line-height:40px}.fullSrceenBtn img,.playpause img{vertical-align:middle;width:20px}.shareRed{position:absolute;top:45vw;background:#ff2a00;color:#fff;text-align:center;padding:0 10px;line-height:20px;right:10px;border-radius:10px;font-size:12px;z-index:1200}.sharebao{margin:-10px;background:#fff;border-radius:10px;position:relative}.sharebao .gold{position:absolute;width:56px;height:56px;border-radius:50%;box-shadow:0 0 10px 1px #fff;top:-28px;left:50%;margin-left:-28px}.sharehead{padding:15px 10px;overflow:hidden;border-radius:10px;line-height:24px;background-color:#de3041;background-repeat:no-repeat;background-position:bottom;text-align:center;color:#fff;background-size:100% auto}.sharehead .loll{color:#f8be41}.sharebody{padding:10px;color:#7a7a7a;text-align:center;line-height:30px}.sharebody .money{color:#c32938;font-size:24px}.sharebody .money span{font-size:14px;color:#333}.sharebody .button{line-height:32px;background:#de3041;color:#fff;border-radius:16px;margin:10px auto;width:160px;display:block}.sharebody .button,.talktext{font-size:16px;text-align:center}.talktext{width:80%;border:1px dashed #c32938;border-radius:5px;margin:20px auto 10px;padding:10px;color:#c32938}.playPause{position:absolute;width:80px;left:50%;transform:translate(-40px,-40px);top:28vw;z-index:1300;opacity:.7}.music{position:absolute;right:20px;top:20px;width:32px;height:32px;border-radius:20px;z-index:1030}.musicPlay{animation:swing 1s ease-in-out infinite}.music img{display:block}@keyframes swing{0%{transform:rotate(10deg)}50%{transform:rotate(-10deg)}to{transform:rotate(10deg)}}.talkred{position:absolute;top:20vw;right:0;z-index:1200;height:50px;width:50px}.talkred img{width:100%}.controlbox{z-index:200;height:56vw;top:0;left:0}.controlbox,.menu{position:absolute;width:100%}.menu{z-index:1000;height:44px;top:56vw}.close{position:absolute;top:15px;right:15px;height:20px;width:20px}.close img,.fullBox{width:100%}.fullBox{height:100%;background:rgba(0,0,0,.5);position:absolute;top:0;left:0;z-index:2000}a.bigTable img{width:100%}.clarity{width:40px;position:relative;text-align:center;color:#fff;font-size:12px}.clarity .cur{display:block;height:20px;width:80%;line-height:20px;border:1px solid #eee;border-radius:3px;margin:10px auto}.clarity ul{position:absolute;bottom:40px;left:0;width:100%;background:rgba(0,0,0,.5)}.clarity li{height:30px;line-height:30px;border-bottom:1px solid #eee}.clarity li:last-child{border:none}.clarity li.active{color:#ff0}.clarity.ios{position:absolute;top:6px;right:70px;z-index:1300;height:30px;background:rgba(51,51,51,.67);line-height:30px;border-radius:5px}.clarity.ios a{margin:0 auto}.clarity.ios .cur{width:100%;height:30px;line-height:30px;border:none}.clarity.ios ul{bottom:auto;top:32px;border-radius:5px;overflow:hidden}.iosfull{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:10000}.videoMusk{position:fixed;z-index:9000;background:#333;height:100%;width:100%}.window{position:absolute;top:36vw;right:0;padding:5px 7px;background:rgba(30,30,30,.4);z-index:1200;border-top-left-radius:5px;border-bottom-left-radius:5px}.window img{width:30px}.msg_conent p img,.window img{vertical-align:middle}.floatBox{width:100%;top:0;left:0;position:absolute;z-index:600}.ripple{background:#e94c69 url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/ripple_5.gif) no-repeat 50%!important;-webkit-background-size:100% auto!important;background-size:100% auto!important;color:#fff!important}.comment-text p img{vertical-align:middle}.tabs_title .btn{display:inline-block;width:48%;text-align:center}.tabs_title .btn a{line-height:30px;font-size:15px;padding-bottom:5px}.tabs_title .btn.cur a{color:#fa4053;border-bottom:1px solid #fa4053}.trySee{top:0;left:0;width:100%;line-height:20px;text-align:center;background:rgba(0,0,0,.5);transition:.5s;opacity:0}.tryPay,.trySee{position:absolute;height:20px;color:#fff;z-index:1020}.tryPay{right:45px;top:7px;padding:0 10px;background:#ff2a00;border-radius:10px}.tryBox{text-align:center}.tryBox .money{color:#ff2a00;font-size:28px}.tryBox .moneyIcon{color:#ff2a00}.tryBox .oldMoney{color:#999;text-decoration:line-through;margin-left:5px}.paydialog .title{color:#2c2c2c;font-size:16px;line-height:50px;text-align:center}.coupons{padding:10px 10px 10px 100px;line-height:30px;max-height:180px;overflow:scroll}.coupons li i{width:16px;height:16px;border:1px solid #999;border-radius:50%;position:relative;margin-right:5px}.coupons li i,.coupons li span{display:inline-block;vertical-align:middle}.coupons li.cur{color:#3e78fb}.coupons li.cur i{background:#3e78fb;border-color:#3e78fb}.coupons li.cur i:after{position:absolute;content:\"\";display:block;width:12px;height:12px;background:#3e78fb;border:2px solid #fff;top:0;left:0;border-radius:50%}.twobtn{height:50px;line-height:50px;display:flex;border-top:1px solid #eee}.twobtn a{flex:1;text-align:center;color:#2c2c2c;font-size:16px}.twobtn .cancel{border-right:1px solid #eee}.twobtn .sure{color:#3e78fb}.explain{text-align:center;color:#999;line-height:40px}.occupy .addimg .container .moxie-shim{width:100px!important;height:100px!important}.allot_btn{position:absolute;top:42px;right:0;height:22px;line-height:22px;padding:4px;border-top-left-radius:15px;border-bottom-left-radius:15px;background:#ad935c;color:#fff;z-index:1300;text-align:center}.allot_btn span:first-child{border:1px solid #fff;height:20px;border-radius:50%;display:inline-block;width:20px}.shareCard{padding:18px;background:linear-gradient(#dfd0bd,#fff);border-radius:10px;overflow:hidden}.boxCloseBtn{position:absolute;top:10px;right:14px;font-size:30px}#LiveHotel .showTeacherBtnTop{position:absolute;top:10px;right:10px;z-index:1001}#LiveHotel .showTeacherBtnTop img{width:30px}.allot_pic{box-shadow:0 4px 10px #efd6af}.allot_title{font-size:15px;color:#191919;font-weight:700;line-height:24px;margin-top:10px;max-height:48px;overflow:hidden}.allot_title span{display:inline-block;background:#c49c5f;color:#fff;height:16px;line-height:17px;text-align:center;border-radius:8px;vertical-align:middle;padding:0 8px;font-size:10px;word-break:keep-all;margin-left:5px}.allot_price{color:#c49c5f;font-size:25px;margin-left:-2px}.allot_price span{font-size:18px}.allot_ul{font-size:12px}.allot_ul span{display:inline-block;width:1px;height:13px;background:#666;vertical-align:middle;margin:0 10px}.allot_dashed{text-align:center;margin-top:30px;position:relative;height:20px;line-height:20px}.allot_dasheds{height:20px;width:100%;overflow:hidden}.allot_dashed span{display:inline-block;width:5px;height:5px;border-radius:50%;background:#dcc9b0;margin:0 5px;vertical-align:middle}.allot_dashed:after,.allot_dashed:before{position:absolute;content:\"\";display:block;top:0;width:20px;height:20px;border-radius:50%;background:linear-gradient(90deg,#303030,#303030)}.allot_dashed:before{left:-32px}.allot_dashed:after{right:-32px}.allot .userInfo{padding:15px 0}.allot .userInfo .userImg{width:44px;height:44px;border-radius:50%;overflow:hidden;margin-right:8px;margin-top:7px}.allot .userInfo .name{font-size:12px;line-height:16px;margin-top:4px;color:#666}.allot .userInfo .colors{color:#c49c5f}.allot .code{width:60px;height:60px;margin-right:6px;overflow:hidden}.allot .copyRight{text-align:center;color:#c49c5f;font-size:10px;height:20px;line-height:20px}.allot .copyRight span{position:relative;display:inline-block}.allot .copyRight span:after,.allot .copyRight span:before{position:absolute;display:block;content:\"\";top:8px;width:40px;height:1px;background:#c49c5f}.allot .copyRight span:before{left:-50px}.allot .copyRight span:after{right:-50px}.allot_tip{position:absolute;top:50%;margin-top:240px;color:#fff;text-align:center;width:100%;font-size:16px}.schooldialog{background:#fff;border-radius:16px;padding:0 21px;padding-bottom:37px}.schooldialog .title{font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:#666;padding:0 0 0 20px}.el-input__inner{margin-top:16px;-webkit-appearance:none;background-color:#fff;background-image:none;border-radius:20px;border:1px solid #bfbfbf;box-sizing:border-box;color:#606266;display:inline-block;font-size:inherit;height:40px;line-height:40px;outline:none;padding:0 15px;transition:border-color .2s cubic-bezier(.645,.045,.355,1);width:100%}.select-down{position:absolute;top:80px;left:10px;right:10px;z-index:1000;background:#fff;box-shadow:0 3px 15px 0 rgba(136,148,189,.31);border-radius:16px;max-height:250px;overflow:scroll}.select-down li{padding:10px 19px;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:#333}.select-down li:active{background:#f2f4fb}.shoolsureBtn{margin-top:33px;background:linear-gradient(104deg,#00cefc,#008af9);box-shadow:0 4px 11px 0 rgba(0,127,204,.31);border-radius:20px;text-indent:none;border:none;display:block;width:100%;color:#fff;height:40px}.banner{overflow:hidden;position:absolute;z-index:1000;width:100%;top:56vw}.banner a,.banner img{width:100%;height:100%;display:block}.rightFocus{right:0;width:62.5px}.leftFocus,.rightFocus{position:absolute;top:0;height:44px;line-height:44px;background:#0084ff;z-index:100;text-align:center;color:#fff;cursor:pointer}.leftFocus{left:0;width:44px}.weixincode .van-popup{padding:0}.popup-head{padding:12px 10px;border-bottom:1px solid #eee;text-align:center}.popup-head .pp-title-top{display:flex;border-bottom:0;justify-content:center}img{vertical-align:middle;border:none}.popup .popup-head>div>img{width:13px;height:7px;align-self:center;margin:0 9px}.popup-title{margin:0;padding:0;font-size:15px}.popup-body{padding:10px;text-align:center}.live-way .van-button{width:200px;margin-bottom:10px;height:34px;line-height:34px}.popup .popup-body{padding-bottom:10px;padding-top:10px}.popup .popup-end{font-size:15px;font-weight:500;color:#747474;height:50px;line-height:50px;text-align:center;border-top:1px solid #f0f0f0}.teacherQr{position:absolute;top:7px;right:10px;width:45px;height:45px;z-index:2002}.loginWay{padding:10%}.loginWay .qqtitle{color:#000;font-size:16px;text-align:center}.loginWay .qqBox{display:block;font-size:12px;color:#000;text-decoration:none;margin:25px 8px 15px;text-align:center}.loginWay .qqlogoImg{display:block;width:60px;height:60px;margin:0 auto 5px}.qqLogin{z-index:2002!important}.onlineSchoolLogin{z-index:2003!important}.onlineSchoolLoginWay{height:100vh;background:linear-gradient(0deg,#fff 70%,#78d4b6)}.onlineSchoolLoginWay .title{font-size:24px;font-weight:600;color:#303133;line-height:33px;padding-top:77px;margin-left:7%}.onlineSchoolLoginWay .desc{font-size:14px;font-weight:400;color:#888;line-height:20px;margin-top:10px;margin-left:7%}.onlineSchoolLoginWay .loginContent .loginOnlineBtn{width:100%;margin-left:7%;width:86%;height:44px;margin-top:46px;border-radius:22px;background:linear-gradient(95deg,#78d4b6 4%,#0bb67e 95%);font-size:15px}.onlineSchoolLoginWay .loginContent .loginInput{border:none;background-color:transparent;width:100%;margin-left:10px;flex:1}.onlineSchoolLoginWay .loginContent .passwordInput{padding-left:8px}.onlineSchoolLoginWay .loginContent .account{display:flex;margin-top:20px;margin-bottom:10px;height:44px;line-height:44px;margin-left:7%;width:86%;background-color:#f6f6f6;border-radius:22px}.onlineSchoolLoginWay .loginContent .account .area{font-size:14px;font-weight:550;color:#101010;line-height:44px;margin-left:16px}.onlineSchoolLoginWay .loginContent .sendBtn{float:right}.onlineSchoolLoginWay .loginContent .password{margin-top:20px;margin-bottom:10px;height:44px;line-height:44px;margin-left:7%;width:86%;background-color:#f6f6f6;border-radius:22px}.weixincode .van-popup{border-radius:0}.onlineSchoolLoginWay .loginContent .password .van-button--primary{background-color:transparent;border:none;color:#10a675;font-size:14px;margin-top:7px;margin-right:10px}.shopping-dialog{width:auto;padding:0;background:transparent}.shopping-dialog-content{width:360px;height:360px;background:url(" + escape(__webpack_require__(184)) + ") no-repeat;background-size:100% 100%}.shopping-dialog-content .wrapper{padding-top:95px}.shopping-dialog-content .goods-content{display:flex;width:330px;height:170px;margin:auto;padding:26px 40px 48px;box-sizing:border-box;background:url(" + escape(__webpack_require__(185)) + ") no-repeat;background-size:100% 100%}.shopping-dialog-content .goods-content .goods-pic{width:96px;height:96px;flex-shrink:0;margin-right:10px}.shopping-dialog-content .goods-content .goods-info{display:flex;flex-direction:column;justify-content:space-between;width:100%}.shopping-dialog-content .goods-content .goods-info .title{font-size:14px;color:#202020;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}.shopping-dialog-content .goods-content .goods-info .price{color:#ee4359;text-align:right}.shopping-dialog-content .shopping-btn{width:158px;height:60px;color:#fff;margin:auto;background:url(" + escape(__webpack_require__(186)) + ") no-repeat;background-size:100% 100%;text-align:center;line-height:54px;margin-top:-10px}.bug-tips{display:flex;align-items:center;position:fixed;left:-226px;width:226px;height:36px;z-index:99999;border-radius:20px;transition:all .3s}.bug-tips.show{left:0}.bug-tips.user-buy-goods.hide{opacity:0}.bug-tips.user-buy-goods{top:60%;background:rgba(158,76,253,.5)}.bug-tips.buy-goods-success{width:fit-content;top:68%;background:rgba(251,29,58,.35)}.bug-tips.buy-goods-success.hide{opacity:0}.bug-tips img{width:34px;height:28px;margin-left:10px}.bug-tips .tips{display:flex;align-items:center;margin:0 8px;color:#fff;font-size:14px}.bug-tips .tips .username{width:40px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.shopping-cart{position:absolute;right:15px;bottom:145px;z-index:99999}.shopping-cart img{width:123px;height:80px}.shopping-cart .close{position:absolute;right:-4px;bottom:0;z-index:9999;margin-top:-8px;color:#fff}.shopping-cart .title{width:115px;color:#202020;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;background:#fff;padding:6px 4px;font-size:12px}.shopping-cart .pirce{display:flex;justify-content:space-between;padding:2px;color:#fff;background:url(" + escape(__webpack_require__(187)) + ") no-repeat;background-size:100% 100%}.shopping-cart .pirce .go{margin-right:8px}", ""]);

// exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de0f896a770f3b9af7983cd6fd9c1655.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "52f42842e43a8a705c6452aa0103f6f1.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "271f2b53994cc2c2639f162f976f92d6.png";

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

var _swipe = __webpack_require__(35);

var _swipe2 = _interopRequireDefault(_swipe);

var _swipeItem = __webpack_require__(36);

var _swipeItem2 = _interopRequireDefault(_swipeItem);

var _picker = __webpack_require__(72);

var _picker2 = _interopRequireDefault(_picker);

var _radio = __webpack_require__(74);

var _radio2 = _interopRequireDefault(_radio);

var _radioGroup = __webpack_require__(77);

var _radioGroup2 = _interopRequireDefault(_radioGroup);

var _tab = __webpack_require__(43);

var _tab2 = _interopRequireDefault(_tab);

var _tabs = __webpack_require__(44);

var _tabs2 = _interopRequireDefault(_tabs);

var _noticeBar = __webpack_require__(45);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

var _dialog = __webpack_require__(46);

var _dialog2 = _interopRequireDefault(_dialog);

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(7);

__webpack_require__(17);

__webpack_require__(38);

__webpack_require__(39);

__webpack_require__(81);

__webpack_require__(82);

__webpack_require__(83);

__webpack_require__(47);

__webpack_require__(48);

__webpack_require__(49);

__webpack_require__(50);

__webpack_require__(21);

__webpack_require__(25);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _handleim = __webpack_require__(40);

var _handleim2 = _interopRequireDefault(_handleim);

var _data3 = __webpack_require__(10);

var _data4 = _interopRequireDefault(_data3);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _FakeIm = __webpack_require__(86);

var _FakeIm2 = _interopRequireDefault(_FakeIm);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

var _qrcoder = __webpack_require__(26);

var _qrcoder2 = _interopRequireDefault(_qrcoder);

var _html2canvas = __webpack_require__(88);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _tfplayer = __webpack_require__(89);

var _tfplayer2 = _interopRequireDefault(_tfplayer);

var _launch = __webpack_require__(90);

var _launch2 = _interopRequireDefault(_launch);

var _ChatRoom = __webpack_require__(91);

var _ChatRoom2 = _interopRequireDefault(_ChatRoom);

var _EmbeddedWeb = __webpack_require__(97);

var _EmbeddedWeb2 = _interopRequireDefault(_EmbeddedWeb);

var _Store = __webpack_require__(98);

var _Store2 = _interopRequireDefault(_Store);

var _ImgText = __webpack_require__(99);

var _ImgText2 = _interopRequireDefault(_ImgText);

var _vote = __webpack_require__(100);

var _vote2 = _interopRequireDefault(_vote);

var _List = __webpack_require__(102);

var _List2 = _interopRequireDefault(_List);

var _shake = __webpack_require__(105);

var _shake2 = _interopRequireDefault(_shake);

var _VideoReView = __webpack_require__(106);

var _VideoReView2 = _interopRequireDefault(_VideoReView);

var _special = __webpack_require__(107);

var _special2 = _interopRequireDefault(_special);

var _payWatch = __webpack_require__(55);

var _payWatch2 = _interopRequireDefault(_payWatch);

var _Top = __webpack_require__(281);

var _Top2 = _interopRequireDefault(_Top);

var _toolbar = __webpack_require__(286);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _rightBar = __webpack_require__(110);

var _rightBar2 = _interopRequireDefault(_rightBar);

var _leftBar = __webpack_require__(112);

var _leftBar2 = _interopRequireDefault(_leftBar);

var _topAd = __webpack_require__(330);

var _topAd2 = _interopRequireDefault(_topAd);

var _proGress = __webpack_require__(113);

var _proGress2 = _interopRequireDefault(_proGress);

var _pieceWise = __webpack_require__(114);

var _pieceWise2 = _interopRequireDefault(_pieceWise);

var _buyList = __webpack_require__(343);

var _buyList2 = _interopRequireDefault(_buyList);

var _redRain = __webpack_require__(348);

var _redRain2 = _interopRequireDefault(_redRain);

var _salesList = __webpack_require__(353);

var _salesList2 = _interopRequireDefault(_salesList);

var _RobRedBagList = __webpack_require__(358);

var _RobRedBagList2 = _interopRequireDefault(_RobRedBagList);

var _RegisterView = __webpack_require__(115);

var _RegisterView2 = _interopRequireDefault(_RegisterView);

var _telTest = __webpack_require__(41);

var _telTest2 = _interopRequireDefault(_telTest);

var _LinkPopup = __webpack_require__(116);

var _LinkPopup2 = _interopRequireDefault(_LinkPopup);

var _index = __webpack_require__(117);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(118);

var _index4 = _interopRequireDefault(_index3);

var _tipsView = __webpack_require__(122);

var _tipsView2 = _interopRequireDefault(_tipsView);

var _noWatchTips = __webpack_require__(392);

var _noWatchTips2 = _interopRequireDefault(_noWatchTips);

var _whiteboard = __webpack_require__(397);

var _whiteboard2 = _interopRequireDefault(_whiteboard);

var _liveanser = __webpack_require__(406);

var _liveanser2 = _interopRequireDefault(_liveanser);

var _vuex = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

_vue2.default.use(_button2.default);

_vue2.default.use(_popup2.default);

_vue2.default.use(_dialog2.default);

_vue2.default.use(_noticeBar2.default);

_vue2.default.use(_tab2.default).use(_tabs2.default);

_vue2.default.use(_radioGroup2.default);
_vue2.default.use(_radio2.default);

_vue2.default.use(_picker2.default);

_vue2.default.use(_swipe2.default).use(_swipeItem2.default);

exports.default = {
  directives: {
    WaterfallLower: (0, _waterfall2.default)("lower"),
    WaterfallUpper: (0, _waterfall2.default)("upper")
  },
  data: function data() {
    return {
      tid: 0,
      tosafariShow: false,
      isCanMucsic: true,
      TelTestShow: false,
      registerViewShow: false,
      fans: null,
      user: "",
      loading: false,
      showControl: true,
      isShowControl: true,
      orientation: "portraint",
      initData: null,
      openRolling: false,
      isRolling: false,
      MerryGoRound: "", //走马灯内容
      videoLinkno: "", //mp4第一个视频
      videoImg: "",
      videoDuration: "00:00:00",
      videoCurrentTime: "00:00:00",
      dsMenu: [], //导航栏
      isPlay: false,
      styleType: 1,
      view_num: 0,
      playerStyle: {},
      showCover: true,
      contentStyle: {}, //内容布局
      showhead: false,
      headtitleBg: "#212126",
      showView: true,
      screenH: 0,
      noPlayH: 0,
      before_ad: [], //广告视频
      directStatus: "not_started", //直播状态
      dispark: false,
      titleName: "",
      isshowgift: false,
      controlTimer: null,
      isShowMidControl: false,
      startTime: "",
      bottomSider: true,
      shareData: {},
      fans_id: "",
      ds_id: "",
      shareRedexist: false,
      shareType: 0,
      shareRed: true,
      musicStatusexist: true,
      musicStatus: true,
      musicPlay: true,
      musicList: [],
      musicIndex: 0,
      musicUrl: "",
      talkredexist: false,
      talkred: true,
      talkredstatus: false,
      talktext: "",
      rewardMoney: 0,
      talkType: 0,
      isShowProgress: false,
      playHeight: 0,
      showMenu: true,
      controlStyle: {},
      rainProbab: 0,
      rainId: "",
      isWeixin: true,
      marqueeheight: 0,
      marqueeStyle: "",
      adIndex: -1,
      haveMenu: true,
      toplist: [],
      showBigTable: false,
      scrollDir: "up",
      shareLimit: true,
      breakPoint: [],
      limitText: "",
      desc: "",
      ds_func: {},
      voteList: "",
      TstartTime: "",
      Tend_time: "",
      loaded: false,
      currentMid: "",
      curCid: 1,
      fullscr: false,
      pieceHeight: 0,
      haveNav: false,
      clarityList: [],
      curClarity: "原画",
      showClarity: false,
      videoIndex: 0,
      isIOS: false,
      barHeight: 0,
      currentTime: 0,
      timeupdate: "",
      myPlayer: "",
      wall_id: "",
      share: {
        title: "",
        dec: "",
        image: "",
        url: ""
      },
      passwordID: "",
      forbid: false,
      totalLike: 0,
      dynamicData: "",
      quanData: null,
      rewardQuan: false,
      rewardredpack: false,
      rewardType: 1,
      imgPath: "",
      vid: "",
      uid: "",
      canBack: true,
      playtimer: null,
      playStart: false,
      picComment: false,
      hot: true,
      topAD: false,
      topObj: {},
      StoreUrl: "",
      storeActive: "",
      pic_url: "",
      uploader: "",
      accessid: "",
      accesskey: "",
      host: "",
      policyBase64: "",
      signature: "",
      callbackbody: "",
      entered: true,
      imIsLogin: false,
      shopIndex: -1,
      openShop: false,
      buyList: [],
      buyListIndex: -1,
      salesHeight: 0,
      bannerHeight: 0,
      commentList: [],
      isMaster: 0,
      giftList: null,
      inviting: false,
      wallSign: false,
      payPrice: 1,
      tryOpacity: 0,
      tryTime: 5,
      tryPayBtn: false,
      isTrySee: false,
      tryPrice: 1,
      is_pay: false,
      reload: false,
      showPay: false,
      payIndex: -1,
      coupons: [],
      coupon_id: 0,
      ticket_switch: false,
      couponText: "",
      isGradRedStart: false,
      redBagData: {},
      showrobRedlist: false,
      redBaglistData: {},
      ds_pwd: null,
      allot_sale: false,
      allot: {},
      showAllot: false,
      headerUrl: "",
      code: "",
      headerData: "",
      isPlayUI: false,
      canvas: null,
      base64Img: "",
      IMtimer: null,
      showSchool: false,
      showSchoolSuc: false,
      isShowSchoolSure: false,
      showSchoolTip: false,
      isShowAddressList: false,
      isShowAgeList: false,
      isShowClassList: false,
      userClassName: "",
      navitemWidth: 47,
      isFirstPlay: true,
      currLiveDic: null, //直播时的链接
      loginErrroStyle: {},
      isShowLoginErr: false,
      adImages: [],
      isShowAd: false,
      isShowQRimg: false,
      weixincodeUrl: "https://tengfaceliveuser.tengface.net/web/wx-user/img/tengface.jpg",
      weixintopText: "关注后可收到直播最新动态哦",
      weixinbottomText: "长按关注公众号接收最新动态",
      isNotShowWebRTC: true,
      rtcClient: null,
      rtcRemoteStream: null,
      playerStatus: 1,
      linkDialogVisible: false,
      linkType: 1, // 1 没有连麦  2 用户申请了连麦  3 正在连麦
      heardTimer: null,
      heardVodTimer: null,
      isSupportRTC: true,
      outOfTime: false,
      showConsultTeacher: false,
      showLiveWay: false,
      selectPlayType: 0,
      verify_comment: false,
      channel_id: "",
      isBlack: false,
      openWx_follow: false, //开启微信
      isShowGift: false, //显示点赞送花
      showTeacherBtn: false,
      playerType: "live",
      currentPlayerData: null,
      show_type: 2, //2手机号短信验证码 3账号密码
      is_all_users_muted: false,
      heart_time: 30,
      need_check_bool: true,
      isShowTeacherQrCode: false,
      isShowTeacherBtnTop: false,
      teacher_qrcode_title: "",
      teacher_qrcode_url: "",
      liveType: "open",
      classUserId: null,
      say_self: {
        enabled: false,
        type: "2",
        all: "2"
      },
      showQQPopUp: false,
      showLineSchoolPopUp: false,
      onlineSendMsgNum: 0,
      onlineSednMsgText: "获取验证码",
      onlineSchoolAccount: "",
      onlineSchoolPassword: "",
      onLIneSchoolSMSCode: "",
      loginType: 1, //1账户密码 2 验证码
      noticeObj: {
        open: false,
        content: "",
        time: 0
      },
      checkNetSchoolTokenTimmer: null,
      showWxPopUp: false,
      channelGroupID: "",
      channel_REL_ID: "",
      businessConfigs: {},
      showGoods: false,
      gid: '',
      isshowCart: false,
      isWeixinMP: false,
      isLoadHistory: false,
      isyxinImLoginOut: false,
      isShowNoWatchQrCode: false,
      HeartMode: "",
      isShowMPJumpAlert: false,
      link_mic_jump: "",
      weappPathData: "",
      isThreeScreen: false,
      threeScreenDirection: "column",
      pageUUID: _Tools2.default.guid(),
      isShowLiveAnser: false,
      LiveanserObj: {
        qpid: '',
        lqid: ''
      },
      showShoppingDialog: false,
      showBuyTipsState: false,
      showShoppingType: false,
      goodsInfo: {},
      goodsIdsList: [],
      inventoryNum: 0,
      // 正在购买
      showBuyGoodsTips: false,
      tipsBuyTimer: null,
      tipsBuyText: "",
      tipsBuyUsername: "",
      saveUserBuyList: [],
      // 购买成功
      showBuySuccessGoodsTips: false,
      tipsBuySuccessTimer: null,
      tipsBuySuccessText: '',
      tipsBuySuccessUsername: '',
      saveUserBuySuccessList: [],
      im_type: "",
      runObj: {
        open: false,
        fontSize: "",
        fontColor: "",
        fontTrans: 1
      },
      copyrightObj: {
        open: false,
        inputValue: "",
        copyrightTrans: 1
      }

    };
  },

  watch: {},
  computed: _extends({}, (0, _vuex.mapGetters)({
    userConfig: "dsInfo/getUserConfig",
    miniConfig: "dsInfo/getMiniConfig"
  }), {
    blackMessage: function blackMessage() {
      return this.fans_id ? "\u4F60\u65E0\u6743\u89C2\u770B\u6B64\u76F4\u64AD\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458 \u5B66\u5458ID:" + this.fans_id : "你无权观看此直播，请联系管理员";
    },
    showLivePlayer: function showLivePlayer() {
      return !this.isBlack && !this.isyxinImLoginOut && !this.isShowMPJumpAlert && !this.TelTestShow;
    }
  }),
  components: {
    launch: _launch2.default,
    ChatRoom: _ChatRoom2.default,
    ImgText: _ImgText2.default,
    Vote: _vote2.default,
    List: _List2.default,
    EmbeddedWeb: _EmbeddedWeb2.default,
    Store: _Store2.default,
    shake: _shake2.default,
    VideoReView: _VideoReView2.default,
    special: _special2.default,
    Top: _Top2.default,
    toolBar: _toolbar2.default,
    rightBar: _rightBar2.default,
    leftBar: _leftBar2.default,
    topAd: _topAd2.default,
    proGress: _proGress2.default,
    pieceWise: _pieceWise2.default,
    buyList: _buyList2.default,
    redRain: _redRain2.default,
    salesList: _salesList2.default,
    robRedBaglist: _RobRedBagList2.default,
    RegisterView: _RegisterView2.default,
    TelTest: _telTest2.default,
    payWatch: _payWatch2.default,
    TFPlayer: _tfplayer2.default,
    LinkPopup: _LinkPopup2.default,
    ConsultTeacher: _index2.default,
    tipsView: _tipsView2.default,
    goodsList: _index4.default,
    noWatchTips: _noWatchTips2.default,
    whiteboard: _whiteboard2.default,
    liveanserPopup: _liveanser2.default
  },
  beforeDestroy: function beforeDestroy() {
    var that = this;
    if (this.heardTimer) {
      clearInterval(this.heardTimer);
      this.heardTimer = null;
    }
    if (this.heardVodTimer) {
      clearInterval(this.heardVodTimer);
      this.heardVodTimer = null;
    }
    _handleim2.default.logout(function (status) {
      if (that.IMtimer) {
        clearTimeout(that.IMtimer);
      }
    });
    // this.fans_id && this.errorReport({msg:"页面被关闭了",userinfo:this.fans})   
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var that, data, _data, _data2;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // setTimeout(() => {
              //   this.saveUserBuyList.push(Math.random())
              //   if(!this.tipsBuyTimer) {
              //     this.showTipsByUserBuy()
              //   }
              // }, 1000)

              that = _this;

              _this.limitText = _Tools2.default.getQueryString("text");
              _this.tid = _Tools2.default.getQueryString("tid");
              _this.user = _Tools2.default.getQueryString("fromuser");
              _this.link_mic_jump = _Tools2.default.getQueryString("link_mic_jump");
              _this.ds_id = _Tools2.default.getQueryDsId();
              _this.reload = sessionStorage.getItem("reload");
              _this.channel_id = _Tools2.default.getQueryChannelId();
              _this.gid = _Tools2.default.getQueryString("gid");
              _context.prev = 9;

              if (!(!_this.ds_id && _this.channel_id)) {
                _context.next = 21;
                break;
              }

              _context.next = 13;
              return _this.axios.post(_Tools2.default.baseUrl1() + "/customer/channel/getDsIdByChannelId", "channel_code=" + _this.channel_id, { timeout: 6000 });

            case 13:
              data = _context.sent;

              if (!(data.data.code == 200)) {
                _context.next = 19;
                break;
              }

              _this.ds_id = data.data.data.ds_id;
              _Tools2.default.setDs_id(_this.ds_id);
              _context.next = 21;
              break;

            case 19:
              (0, _toast2.default)({ message: data.data.message, duration: 0 });
              return _context.abrupt("return");

            case 21:
              _context.next = 38;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](9);
              _context.prev = 25;
              _context.next = 28;
              return _this.axios.get(_Tools2.default.tencentOssUrl() + "/ds/channel_cache/channel_" + _this.channel_id + ".json?" + new Date().getTime() + parseInt(Math.random() * 10e4), { timeout: 2000 });

            case 28:
              _data = _context.sent;

              if (_data) {
                _this.ds_id = _data.data.ds_id;
                _Tools2.default.setDs_id(_this.ds_id);
              } else {}
              _context.next = 38;
              break;

            case 32:
              _context.prev = 32;
              _context.t1 = _context["catch"](25);
              _context.next = 36;
              return _this.axios.get(_Tools2.default.aliOssUrl() + "/ds/channel_cache/channel_" + _this.channel_id + ".json?" + new Date().getTime() + parseInt(Math.random() * 10e4), { timeout: 1000 });

            case 36:
              _data2 = _context.sent;

              if (_data2) {
                _this.ds_id = _data2.data.ds_id;
                _Tools2.default.setDs_id(_this.ds_id);
              } else {}

            case 38:

              if (_this.ds_id) {
                _Tools2.default.setDs_id(_this.ds_id);
              }

              if (!(_this.ds_id && parseInt(_this.ds_id) != _this.ds_id)) {
                _context.next = 42;
                break;
              }

              alert("直播间ID错误，请检查链接");
              return _context.abrupt("return");

            case 42:

              _this.$TFWebLog.setCommonKeyValue("ds_id", _this.ds_id);
              _this.$TFWebLog.setCommonKeyValue("channel_id", _this.channel_id);

              _this.key += _this.ds_id + "/";
              _this.imgPath = _Tools2.default.imgPath();

              sessionStorage.setItem("sid", _this.user);

              _this.isWeixin = _Tools2.default.isWeixin();
              _this.isWeixinMp = _Tools2.default.isWeixinMP();

              //强制关注参数
              if (_this.limitText) {
                _Tools2.default.setCookie(_this.limitText, true, 30);
                location.href = location.href.split("&text")[0];
              }

              //断点视频参数
              if (_Tools2.default.getQueryString("videoIndex")) {
                _this.videoIndex = _Tools2.default.getQueryString("videoIndex");
              }

              if (localStorage.getItem("forbid") == "true") {
                _this.forbid = true;
              } else {
                _this.forbid = false;
              }

              if (_Tools2.default.checkPhoneType() == 2) {
                _this.isIOS = true;
              }

              if (_this.tid) {
                //这里说明是伪直播
                _Tools2.default.getFakeLiveInfo(_this.tid, function (isOk, fakeInfo) {
                  if (isOk) {
                    _Tools2.default.getDsInfo(function (dsInFo) {
                      that.liveType = dsInFo.direct_seeding.type;
                      _Tools2.default.login(dsInFo.direct_seeding.appid, dsInFo.direct_seeding.uid, function (userInfo) {
                        that.personDataInit(userInfo, dsInFo);
                      });
                    }, fakeInfo);
                  } else {
                    alert("网络错误请稍后重试");
                  }
                });
              } else {
                //获取直播间信息
                _Tools2.default.getDsInfo(function (dsInFo) {
                  console.log(window.location.href + " ", dsInFo);
                  //判断是否是珊瑚课堂
                  if (dsInFo.direct_seeding.is_shanhu == 2 && !location.host.includes('shkt.online') && !location.host.includes('shanhuketang.com')) {
                    location.href = "https://u.shkt.online/" + location.search;
                    return;
                  }
                  that.liveType = dsInFo.direct_seeding.type;
                  that.uid = dsInFo.direct_seeding.uid;
                  that.im_type = dsInFo.direct_seeding.im_type;
                  that.initData = dsInFo;
                  //直播状态
                  that.directStatus = dsInFo.direct_seeding.direct_status;
                  if (dsInFo.direct_seeding.play_style == 2) {
                    that.$router.replace("/vertical");
                    return;
                  }
                  //加载静态数据
                  that.classRoomCheckAccess(function () {
                    //处理小程序PC打开
                    if (that.liveType != "class" && _Tools2.default.isWeixinMPInPC() && that.businessConfigs && that.businessConfigs.open_class_pc_no_watch) {
                      // this.loaded = true;
                      _this.isShowNoWatchQrCode = true;
                      return;
                    }
                    //处理微信并且不在打开小程序
                    if (that.businessConfigs && that.businessConfigs.student_enter_mp_classroom && !_Tools2.default.isWeixinMP()) {
                      // 加载微信分享参数
                      _this.shareToWeChat();
                      _this.loaded = true;
                      var navigateToUrl = "";
                      if (_this.channel_id) {
                        navigateToUrl = "/pages/webview/webview?channel_id=" + (_this.channel_id || '') + "&link_mic_jump=1";
                      } else {
                        navigateToUrl = "/pages/webview/webview?ds_id=" + (_this.ds_id || '') + "&link_mic_jump=1";
                        if (that.liveType == "class") {
                          //班课处理
                          var queryData = _Tools2.default.getQueryData(location.href);
                          if (queryData.other == 1) {
                            navigateToUrl = navigateToUrl + "&token=" + (_Tools2.default.getCookie("user_token") || "") + "&other=" + queryData.other + "&shool_token=" + (_Tools2.default.getCookie("netschool_token") || "");
                          }
                        }
                      }
                      _this.weappPathData = navigateToUrl;
                      _this.isShowMPJumpAlert = true;
                      return;
                    }

                    if (that.liveType == "class" && that.businessConfigs && that.businessConfigs.classroom_check_access) {
                      //需要网课登录
                      that.checkClassLiveUserInfo(dsInFo.direct_seeding.appid, function (userInfo) {
                        that.personDataInit(userInfo, dsInFo);
                      });
                    } else {
                      // 微信授权登录
                      _Tools2.default.login(dsInFo.direct_seeding.appid, dsInFo.direct_seeding.uid, function (userInfo) {
                        if (userInfo && userInfo.showQQPopUp) {
                          that.showQQPopUp = true;
                        } else if (userInfo && userInfo.showWxPopUp) {
                          that.showWxPopUp = true;
                          _Tools2.default.LoginJumpWx(that.initData.direct_seeding.name);
                        }
                        that.personDataInit(userInfo, dsInFo);
                      }, dsInFo.direct_seeding.name);
                    }
                  });
                });
              }
              if (_Tools2.default.checkPhoneType() == 2 && _this.isWeixin) {
                _this.isSupportRTC = false;
              }
              // 页面关闭事件
              // if (this.isIOS) {
              //   window.addEventListener("pagehide",()=>{
              //     this.fans_id && this.errorReport({msg:"iOS-pagehide",userinfo:this.fans})
              //   })
              // }else {
              //   window.addEventListener("onunload",()=>{
              //     this.fans_id && this.errorReport({msg:"android-onunload",userinfo:this.fans})   
              //   })
              // }

            case 55:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[9, 23], [25, 32]]);
    }))();
  },

  methods: {
    getLastques: function getLastques() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var postData, data, liveanserTmp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                postData = {
                  dsid: _this2.ds_id,
                  org_id: _this2.uid,
                  fans_id: _this2.fans_id
                };
                _context2.next = 4;
                return _this2.axios.post(_Tools2.default.baseUrlSchool() + "/ds/user/lastques", _qs2.default.stringify(postData));

              case 4:
                data = _context2.sent;

                if (data.data && data.data.code == 200) {
                  console.log("直播答题信息");
                  liveanserTmp = data.data.data;

                  liveanserTmp.qpid = liveanserTmp.id;
                  _this2.LiveanserObj = liveanserTmp;
                }
                _context2.next = 10;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    hideliveAnser: function hideliveAnser(value) {
      this.isShowLiveAnser = value;
    },
    changeScreenPostion: function changeScreenPostion() {
      this.threeScreenDirection = this.threeScreenDirection == 'column' ? 'column-reverse' : 'column';
    },
    mploginJump: function mploginJump() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var query, queryData, postData, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                query = "";

                if (_this3.channel_id) {
                  query = "channel_id=" + _this3.channel_id + "&link_mic_jump=1";
                } else {
                  query = "ds_id=" + _this3.ds_id + "&link_mic_jump=1";
                  if (_this3.liveType == "class") {
                    //班课处理
                    queryData = _Tools2.default.getQueryData(location.href);

                    if (queryData.other == 1) {
                      query = query + "&token=" + (_Tools2.default.getCookie("user_token") || "") + "&other=" + queryData.other + "&shool_token=" + (_Tools2.default.getCookie("netschool_token") || "");
                    }
                  }
                }
                postData = {
                  appid: _this3.miniConfig.mp_1v1_appid,
                  path: "/pages/webview/webview",
                  query: query
                };
                _context3.next = 6;
                return _this3.axios.post(_Tools2.default.baseUrl2() + "/user/applet_url_link", _qs2.default.stringify(postData));

              case 6:
                data = _context3.sent;

                if (data.data && data.data.code == 200) {
                  location.href = data.data.data.url_link;
                } else {
                  (0, _toast2.default)("跳转失败");
                }
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                (0, _toast2.default)("网络错误");

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    adJumpItemTap: function adJumpItemTap(item) {
      console.log("账号不能为空", _Tools2.default.isWeixinMP(), "item.isJumpMP=", item.isJumpMP);
      if (_Tools2.default.isWeixinMP() && item.isJumpMP) {
        //小程序分享
        wx.miniProgram.navigateTo({ url: "/pages/share/share?ds_id=" + this.ds_id + "\n            &channel_id=" + (this.channel_id || '') + "&title=" + this.initData.direct_seeding.name + "&cover=" + this.initData.direct_seeding.pic_url });
      } else {
        item.link && (location.href = item.link);
      }
    },
    onlineSchoolLoginClick: function onlineSchoolLoginClick() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var postData, data, postData2, data2;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.onlineSchoolAccount == "")) {
                  _context4.next = 3;
                  break;
                }

                (0, _toast2.default)("账号不能为空");
                return _context4.abrupt("return");

              case 3:
                if (!(_this4.onLIneSchoolSMSCode == "")) {
                  _context4.next = 6;
                  break;
                }

                (0, _toast2.default)("验证码不能为空");
                return _context4.abrupt("return");

              case 6:
                _context4.prev = 6;
                postData = {
                  area: 86,
                  phone: _this4.onlineSchoolAccount,
                  code: _this4.onLIneSchoolSMSCode,
                  org_id: _this4.uid
                };
                // this.showLineSchoolPopUp = false;

                _context4.next = 10;
                return _this4.axios.post(_Tools2.default.baseUrlSchool() + "/user/index/phoneLogin", _qs2.default.stringify(postData));

              case 10:
                data = _context4.sent;

                console.log("data", data);

                if (!(data.data.code == 200)) {
                  _context4.next = 22;
                  break;
                }

                _Tools2.default.setCookie("netschool_token", data.data.data.token, 30);
                postData2 = {
                  fans_id: data.data.data.fansId,
                  ds_id: _this4.ds_id
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData2));
                _context4.next = 18;
                return _this4.axios.post(_Tools2.default.baseUrlSchool() + "/stu/course/dsAuth", _qs2.default.stringify(postData2));

              case 18:
                data2 = _context4.sent;

                if (data2.data.code == 200) {
                  if (data2.data.data.result) {
                    _Tools2.default.getUserInfoReloadByToken(data2.data.data.liveToken);
                  } else {
                    (0, _toast2.default)("此账号无权限观看此课程请联系管理员开通");
                  }
                } else {
                  (0, _toast2.default)(data2.data.message);
                }
                _context4.next = 23;
                break;

              case 22:
                (0, _toast2.default)(data.data.message);

              case 23:
                _context4.next = 28;
                break;

              case 25:
                _context4.prev = 25;
                _context4.t0 = _context4["catch"](6);

                console.error("onlineSchoolLoginClick", _context4.t0);

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[6, 25]]);
      }))();
    },
    onlineSchoolPWDLoginClick: function onlineSchoolPWDLoginClick() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var postData, data, postData2, data2;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this5.onlineSchoolAccount == "")) {
                  _context5.next = 3;
                  break;
                }

                (0, _toast2.default)("账号不能为空");
                return _context5.abrupt("return");

              case 3:
                if (!(_this5.onlineSchoolPassword == "")) {
                  _context5.next = 6;
                  break;
                }

                (0, _toast2.default)("密码不能为空");
                return _context5.abrupt("return");

              case 6:
                _context5.prev = 6;
                postData = {
                  account: _this5.onlineSchoolAccount,
                  password: _this5.onlineSchoolPassword,
                  org_id: _this5.uid
                };
                _context5.next = 10;
                return _this5.axios.post(_Tools2.default.baseUrlSchool() + "/user/index/login", _qs2.default.stringify(postData));

              case 10:
                data = _context5.sent;

                console.log("data", data);

                if (!(data.data.code == 200)) {
                  _context5.next = 22;
                  break;
                }

                _Tools2.default.setCookie("netschool_token", data.data.data.token, 30);
                postData2 = {
                  fans_id: data.data.data.fansId,
                  ds_id: _this5.ds_id
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData2));
                _context5.next = 18;
                return _this5.axios.post(_Tools2.default.baseUrlSchool() + "/stu/course/dsAuth", _qs2.default.stringify(postData2));

              case 18:
                data2 = _context5.sent;

                if (data2.data.code == 200) {
                  if (data2.data.data.result) {
                    _Tools2.default.getUserInfoReloadByToken(data2.data.data.liveToken);
                  } else {
                    (0, _toast2.default)("此账号无权限观看此课程请联系管理员开通");
                  }
                } else {
                  (0, _toast2.default)(data2.data.message);
                }
                _context5.next = 23;
                break;

              case 22:
                (0, _toast2.default)(data.data.message);

              case 23:
                _context5.next = 28;
                break;

              case 25:
                _context5.prev = 25;
                _context5.t0 = _context5["catch"](6);

                console.error("onlineSchoolLoginClick", _context5.t0);

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[6, 25]]);
      }))();
    },
    checkNetSchoolTokenValid: function checkNetSchoolTokenValid() {
      this.axios.post(_Tools2.default.baseUrlSchool() + "/user/index/checkToken").then(function (res) {}).catch(function (error) {
        console.log(error);
      });
    },
    mploginTap: function mploginTap() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var shoppingcart, query, postData, data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                shoppingcart = false;

                if (_this6.userConfig && _this6.userConfig.shoppingcart == 1) {
                  shoppingcart = true;
                }

                _context6.prev = 2;
                query = "";

                if (_this6.channel_id) {
                  query = "channel_id=" + _this6.channel_id;
                } else {
                  query = "ds_id=" + _this6.ds_id;
                }
                postData = {
                  appid: shoppingcart ? _this6.miniConfig.shop_login_mp_appid : _this6.miniConfig.login_mp_appid,
                  path: "/pages/webview/webview",
                  query: query
                };
                _context6.next = 8;
                return _this6.axios.post(_Tools2.default.baseUrl2() + "/user/applet_url_link", _qs2.default.stringify(postData));

              case 8:
                data = _context6.sent;

                if (data.data && data.data.code == 200) {
                  location.href = data.data.data.url_link;
                } else {
                  (0, _toast2.default)("跳转失败");
                }
                _context6.next = 16;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](2);

                (0, _toast2.default)("网络错误");
                console.error("checkClassLiveUserInfo", _context6.t0);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[2, 12]]);
      }))();
    },
    qqloginTap: function qqloginTap() {
      _Tools2.default.LoginJumpQQ(this.initData.direct_seeding.name);
    },
    wxloginTap: function wxloginTap() {
      _Tools2.default.LoginJumpWx(this.initData.direct_seeding.name);
    },
    closeWindow: function closeWindow() {
      wx.closeWindow();
    },
    onlineLineSchoolSendMsg: function onlineLineSchoolSendMsg() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var postData, data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                postData = {
                  area: 86,
                  phone: _this7.onlineSchoolAccount,
                  org_id: _this7.uid
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData));
                _context7.next = 5;
                return _this7.axios.post(_Tools2.default.baseUrlSchool() + "/common/index/sendSms", _qs2.default.stringify(postData));

              case 5:
                data = _context7.sent;

                console.log("data", data);
                if (data.data.code == 200) {
                  _this7.sendMsgStartTimer();
                } else {
                  (0, _toast2.default)(data.data.message);
                }
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);

                console.error("checkClassLiveUserInfo", _context7.t0);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 10]]);
      }))();
    },
    sendMsgStartTimer: function sendMsgStartTimer() {
      var _this8 = this;

      this.onlineSednMsgText = "59S";
      this.onlineSendMsgNum = 59;
      this.onlineSchoolTimer = setInterval(function () {
        _this8.onlineSendMsgNum = _this8.onlineSendMsgNum - 1;
        if (_this8.onlineSendMsgNum <= 0) {
          _this8.onlineSendMsgNum = 0;
          _this8.onlineSednMsgText = "获取验证码";
          clearInterval(_this8.onlineSchoolTimer);
          return;
        }
        _this8.onlineSednMsgText = _this8.onlineSendMsgNum + "S";
      }, 1000);
    },
    showTeacherQrCodeCliced: function showTeacherQrCodeCliced() {
      this.isShowTeacherQrCode = false;
      this.isShowTeacherBtnTop = true;
    },
    showTeacherBtnTopClicked: function showTeacherBtnTopClicked() {
      this.isShowTeacherQrCode = true;
      this.isShowTeacherBtnTop = false;
    },
    playFailed: function playFailed(playType, data) {
      if (playType != 2) {
        (0, _toast2.default)("加载视频失败,正在切换备选线路");
        this.$refs.tfPlayer.changePlayType(2);
      } else {
        (0, _toast2.default)("加载视频失败,请检查网络");
      }
    },
    onShowFouceAlert: function onShowFouceAlert() {
      this.isShowQRimg = true;
    },
    changePlayType: function changePlayType(type) {
      this.showLiveWay = false;
      this.$refs.tfPlayer.changePlayType(type);
      //走结束连麦流程
      this.$refs.tfPlayer.rtcLinkDown();
      this.linkType = 1;
    },
    isSupportRTCCallBack: function isSupportRTCCallBack(value) {
      console.log("isSupportRTCCallBack", value);
    },
    unAutoPlay: function unAutoPlay(message) {
      var _this9 = this;

      if (message.type == 511) {
        _dialog2.default.alert({
          message: "正在直播，点击观看精彩直播",
          confirmButtonText: "点击观看"
        }).then(function () {
          _this9.$refs.tfPlayer.playVideoClicked();
        });
      } else {
        console.error("1371", message.message);
        (0, _toast2.default)(message.message);
      }
    },
    consultTeacherCloseBtnClicked: function consultTeacherCloseBtnClicked() {
      this.showConsultTeacher = false;
    },
    goodsListCloseBtnClicked: function goodsListCloseBtnClicked() {
      this.showGoods = false;
    },
    onShowTeacherList: function onShowTeacherList() {
      this.showConsultTeacher = true;
      this.$refs.consultTeacher.switchTimeList();
    },
    onShowGoodsList: function onShowGoodsList() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this10.$refs.goodsList.getGoodsList();

              case 2:
                _this10.showGoods = true;

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },
    sendApplyLink: function sendApplyLink() {
      var canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
      if (_Tools2.default.isWeixin() && this.isIOS && !canLink) {
        this.tosafariShow = true;
        return;
      }
      this.linkType = 1;
      this.linkDialogVisible = true;
    },
    sendEndLink: function sendEndLink() {
      this.linkDialogVisible = true;
    },
    playerStatusChange: function playerStatusChange(to, playType) {
      this.playerStatus = to;
      this.selectPlayType = playType;
      console.log("播放状态变化了", to, playType);
      if (to == 2) {
        this.hideMusicAndStop();
      } else if (to == 1 || to == 3) {
        this.showMusic();
      }
    },
    linkTypeChange: function linkTypeChange(to) {
      this.linkType = to;
      console.log("连麦状态变化了");
    },
    tryLogin: function tryLogin() {
      location.reload();
    },
    loadAll: function loadAll(data) {
      var that = this;
      if (data.direct_seeding.play_style == 5) {
        //三分屏
        this.isThreeScreen = true;
        data.direct_seeding.play_style = 3;
      }
      //this.isRegisterData();
      this.loaded = true;
      this.init();
      //获取动态数据接口
      if (that.fans_id) {
        //有token
        this.getDynamicData();

        if (this.channel_id) {
          //有渠道
          this.getGroupIdByChannelID();
        } else {
          //加载评论
          this.isLoadHistory = true;
        }
        this.getLastques();
        this.isShowLoginErr = false;
        _toast2.default.clear();
      } else {
        //没有token
        // this.isShowLoginErr = true;
        if (!this.showQQPopUp && !this.showWxPopUp) {
          //如果不是QQ弹窗或者微信弹窗
          _toast2.default.clear();
          _Tools2.default.clearFansInfo();
          (0, _toast2.default)("登录失败！");
          setTimeout(function () {
            location.reload();
          }, 1000);
        }
      }

      this.initUI();

      setTimeout(function () {
        that.handleTabClick(0);
      }, 300);

      setTimeout(function () {
        that.setControl();
        var clarity = localStorage.getItem("clarity");
        if (clarity == "hls_fhd") {
          that.curClarity = "超清";
        } else if (clarity == "hls_hd") {
          that.curClarity = "高清";
        } else if (clarity == "hls_standard") {
          that.curClarity = "标清";
        } else if (clarity == "hls_smooth") {
          that.curClarity = "流畅";
        } else if (clarity == "playback" || !clarity) {
          that.curClarity = "原画";
        }
      }, 300);

      this.playBack();
      //数据统计上报接口
      this.resize();
    },
    personDataInit: function personDataInit(fans, dsInfo) {
      //获取用户信息
      var that = this;
      //重缓存中获取数据
      this.fans = fans;
      this.fans_id = this.fans.fans_id;
      this.headerUrl = this.fans.header;

      this.$TFWebLog.fans_id = this.fans_id;
      this.$TFWebLog.setCommonKeyValue("token", this.fans.token);

      var queryData = _Tools2.default.getQueryData(location.href);
      var hasToken = false;
      if (queryData.token !== "" && queryData.token) {
        hasToken = true;
      }
      var otherLogin = getQueryString("other");
      //替换邀请码
      if (this.user != this.fans_id && this.fans_id && this.fans.token || this.isIOS && this.isWeixin && !hasToken && !otherLogin) {
        var data = _Tools2.default.getQueryData(location.href);
        data.fromuser = this.fans_id;
        if (this.isIOS && this.isWeixin && !otherLogin) {
          data.token = this.fans.token;
        }
      }

      // 上报邀请数据
      if (this.user && this.fans_id) {
        this.invite();
      }

      // 加载微信分享参数
      that.shareToWeChat();
      //获取直播间信息
      this.loadAll(dsInfo);
    },
    classRoomCheckAccess: function classRoomCheckAccess(callback) {
      var _this11 = this;

      this.axios.post(_Tools2.default.baseUrl1() + "/customer/index/qryUserConfigs", _qs2.default.stringify({ uid: this.uid })).then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(res) {
          var data1;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  data1 = res.data.data;

                  if (res.data.code == "200") {
                    if (data1) {
                      data1.forEach(function (item) {
                        _this11.businessConfigs[item.key] = item.value == "true";
                      });
                    }
                  }
                  callback && callback();

                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, _this11);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        callback && callback();
        console.log(error);
      });
    },
    checkClassLiveUserInfo: function checkClassLiveUserInfo(appid, callback) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var userInfo, postData, data;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                userInfo = _Tools2.default.getCacheUserInfo(appid);

                if (!userInfo) {
                  _context10.next = 16;
                  break;
                }

                _context10.prev = 2;
                postData = {
                  fans_id: userInfo.fans_id,
                  ds_id: _this12.ds_id
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData));
                _context10.next = 7;
                return _this12.axios.post(_Tools2.default.baseUrlSchool() + "/stu/course/dsAuth", _qs2.default.stringify(postData));

              case 7:
                data = _context10.sent;

                if (data.data.code == 222222) {
                  _this12.showLineSchoolPopUp = true;
                  _this12.loaded = true;
                } else if (data.data.code == 200) {
                  console.log("有权限,可以看");
                  callback && callback(userInfo);
                  _this12.checkNetSchoolTokenValid();
                  setInterval(function () {
                    _this12.checkNetSchoolTokenValid();
                  }, 10000);
                } else {
                  console.log("1519", data);
                  (0, _toast2.default)(data.data.message);
                  _this12.showLineSchoolPopUp = true;
                  _this12.loaded = true;
                }
                _context10.next = 14;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10["catch"](2);

                console.error("checkClassLiveUserInfo", _context10.t0);

              case 14:
                _context10.next = 19;
                break;

              case 16:
                console.error("checkClassLiveUserInfo-showLineSchoolPopUp");
                _this12.showLineSchoolPopUp = true;
                _this12.loaded = true;

              case 19:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[2, 11]]);
      }))();
    },
    isRegisterData: function isRegisterData() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios.post(_Tools2.default.baseUrl3() + "/infoCollection/isRegister", option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          if (data.data.isRegister == 0) {
            var dateStr = "2019-03-31 22:00:00";
            dateStr = dateStr.substring(0, 19);
            dateStr = dateStr.replace(/-/g, "/");
            var timestamp = new Date(dateStr).getTime();
            if (timestamp > new Date().getTime()) {
              that.showSchool = true;
            }
          } else {
            that.userClassName = data.data.where.area + data.data.where.school + data.data.where.grade + data.data.where.class;
            that.showSchoolTip = true;
          }
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    getGroupIdByChannelID: function getGroupIdByChannelID() {
      var that = this;
      var option = "channel_code=" + this.channel_id;
      this.axios.post(_Tools2.default.baseUrl1() + "/customer/channel/query", option).then(function (data) {
        var data = data.data;
        if (data.code == 200 && data.data) {
          that.channelGroupID = data.data.grouping || "";
          that.channel_REL_ID = data.data.id || "";
          that.isLoadHistory = true;
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    getDynamicData: function getDynamicData() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios.post(_Tools2.default.baseUrl2() + "/init/getDynamicData", option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          that.dynamicData = data.data;
          // that.view_num = data.data.view_num;
          that.totalLike = data.data.like_num;

          if (data.data.share_red_chance > 0) {
            //开启分享得红包
            that.shareRedexist = true;
            that.shareType = 0;
          } else if (data.data.share_coupon_chance > 0) {
            //开启分享得卡券
            that.shareRedexist = true;
            that.shareType = 1;
          }

          if (data.data.pwd_red_chance > 0) {
            //口令的红包
            // that.talkredexist = true;
            // that.talkType = 0;
          } else if (data.data.pwd_coupon_chance > 0) {
            //口令的卡券
            that.talkredexist = true;
            that.talkType = 1;
          }

          if (data.data.red_rain != null) {
            that.rainProbab = data.data.red_rain.percent;
            that.rainId = data.data.red_rain.msgid;
            that.$refs.redrain.redbagRain();
          }
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    switchVideo: function switchVideo(item, index) {
      //切换视频信息
      if (index == this.videoIndex) {
        return;
      }
      this.videoIndex = index;
    },
    getISBack: function getISBack(callBack) {
      var _this13 = this;

      var that = this;
      var option = "ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl2() + "/ds/getIsBlack", option, {
        credentials: false,
        emulateJSON: true,
        timeout: 6000
      }).then(function (data) {
        if (data.data.code == 200) {
          if (data.data.data.in_black == "yes") {
            that.isBlack = true;
            callBack && callBack(true);
          } else {
            callBack && callBack(false);
          }
        } else if (data.data.code != 100068 && data.data.code != 100067) {
          callBack && callBack(false);
          _this13.errorReport({ msg: "黑名单异常", userinfo: _this13.fans, error: data });
        }
      }).catch(function (data) {
        callBack && callBack(false);
        _this13.errorReport({ msg: "黑名单网络异常", userinfo: _this13.fans, error: data });
        console.log("错误" + data);
      });
    },
    invite: function invite() {
      if (this.user && this.fans_id != this.user) {
        var that = this;
        var option = "invite_id=" + this.user + "&ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;

        if (this.tid) {
          option = option + "&tid=" + this.tid;
        }
        this.axios.post(_Tools2.default.baseUrl3() + "/invite/index", option, {
          credentials: false,
          emulateJSON: true
        }).then(function (data) {
          var data = data.data;
        }).catch(function (data) {
          console.log("错误" + data);
        });
      }
    },
    sedTalk: function sedTalk() {
      this.$refs.toolbar.sendTalk(this.talktext, this.passwordID, this.talkType);
      this.talkredstatus = false;
    },
    showtalkredpoup: function showtalkredpoup() {
      this.talkredstatus = !this.talkredstatus;
    },
    colsetalkred: function colsetalkred() {
      this.talkred = false;
    },
    showtalk: function showtalk(data) {
      this.rewardType = 1;
      if (this.talkType == 0) {
        this.rewardredpack = true;
        this.rewardMoney = data.money;
        this.talkred = false;
      } else {
        this.rewardQuan = true;
        this.quanData = data;
      }
    },
    closeRedpack: function closeRedpack() {
      this.rewardredpack = false;
    },
    closeQuan: function closeQuan() {
      this.rewardQuan = false;
    },
    getMusic: function getMusic() {
      if (this.initData.music_list) {
        this.musicList = this.initData.music_list;
        var self = this;
        setTimeout(function () {
          self.initMusic();
        }, 500);
      }
    },
    setMusic: function setMusic() {
      var audio = document.getElementById("audio");
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    stopMusic: function stopMusic() {
      //如果有音乐关闭音乐
      var audio = document.getElementById("audio");
      if (audio) {
        audio.pause();
      }
      // 移除音乐监听
      document.body.removeEventListener("click", this.playmusic);
    },
    hideMusicAndStop: function hideMusicAndStop() {
      this.stopMusic();
      this.musicStatus = false;
    },
    showMusic: function showMusic() {
      this.musicStatus = true;
    },
    initMusic: function initMusic() {
      var that = this;
      var audio = document.getElementById("audio");
      this.musicUrl = this.musicList[0].url;
      audio.addEventListener("play", function () {
        that.musicPlay = true;
      });
      audio.addEventListener("pause", function () {
        that.musicPlay = false;
      });
      audio.addEventListener("ended", function () {
        if (that.musicList.length > 0) {
          that.musicIndex++;
          if (that.musicIndex == that.musicList.length) {
            that.musicIndex = 0;
          }
          that.musicUrl = that.musicList[that.musicIndex].url;
          audio.load();
          setTimeout(function () {
            audio.play();
          }, 300);
        }
      });
      this.triggerAudio();
    },
    resize: function resize() {
      var that = this;
      window.onresize = function (e) {
        if (that.isIOS) {
          return false;
        }
        //页面大小改变了
        var clientH = document.documentElement.clientHeight;
        var screenH = window.screen.height;
        var w = window.screen.width;
        //判断是否进入播放模式但是没有横屏  全屏
        that.fullscr = false;
        if (that.orientation == "portraint") {
          if (clientH != that.noPlayH) {
            if (clientH > that.noPlayH) {
              that.playUI();
            }
          } else {
            that.initUI();
          }
        } else {
          if (that.screenH != screenH && that.noPlayH != clientH) {
            //进入横屏状态
            that.fullScreenUI();
          } else {
            //退出横屏状态
            that.orientation = "portraint";
            that.initUI();
          }
        }
      };
    },
    triggerAudio: function triggerAudio() {
      document.body.addEventListener("click", this.playmusic);
    },
    playmusic: function playmusic() {
      var audio = document.getElementById("audio");
      audio.play();
      document.body.removeEventListener("click", this.playmusic);
    },
    cash: function cash() {
      this.$router.push({
        name: "UserInfo"
      });
    },
    cards: function cards() {
      this.$router.push({
        name: "cards"
      });
    },
    closeload: function closeload() {
      var _this14 = this;

      if (!this.loading) {
        setTimeout(function () {
          if (!_this14.showQQPopUp && !_this14.showWxPopUp) {
            _this14.$refs.tfPlayer && _this14.$refs.tfPlayer.playVideoClicked();
          }
        }, 200);
      }
      this.loading = true;
    },
    registerViewClose: function registerViewClose() {},
    limit: function limit() {
      var passwd = this.ds_pwd.params.http_url;
      var today = new Date().toLocaleDateString();

      if (this.ds_pwd.params.view_type == "password_view") {
        console.log(localStorage.getItem("passwordDay"));
        if (localStorage.getItem("passwordDay") == null || localStorage.getItem("passwordDay") != today) {
          this.$router.push({
            name: "payWatch",
            params: {
              type: 1
            }
          });
        } else {
          this.shareLimit = true;
        }
      } else if (this.ds_pwd.params.view_type == "allot_sale_view") {
        this.allot_sale = true;
        this.allot = this.initData.ds_pwd.params;
        this.allot.title = this.initData.direct_seeding.name;
        //需要付费观看
        // this.ispay();
      } else {
          //需要付费观看
          // this.ispay();
        }
    },
    ispay: function ispay() {
      var that = this;
      var url = _Tools2.default.baseUrl() + "/directSeeding/ticket/isPayed";
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          if (data.data.is_pay == 0) {
            if (that.ds_pwd.params.view_type == "allot_sale_view") {
              setTimeout(function () {
                that.$router.push({
                  path: "/payWatch/3/" + that.fans_id
                });
              }, 2000);
            } else {
              if (that.isTrySee) {
                that.is_pay = false;
              } else {
                that.$router.push({
                  name: "payWatch",
                  params: {
                    type: 2
                  }
                });
              }
            }
          } else {
            if (that.isTrySee) {
              that.is_pay = true;
            } else {
              that.shareLimit = true;
            }
          }
        }
      }).catch(function (res) {
        (0, _toast2.default)("请求错误" + res.data.message);
      });
    },
    hidefunc: function hidefunc() {
      var audio = document.getElementById("audio");
      console.log(audio);
      if (audio) {
        if (this.shareRedexist) {
          this.shareRed = false;
        }
        if (this.musicStatusexist) {
          audio.pause();
          this.musicStatus = false;
        }
      }
    },
    playerListener: function playerListener(data) {
      if (data.playType == "vod") {
        this.playerType = "vod";
        if (data.type == "timeupdate") {
          this.currentPlayerData = data;
        } else if (data.type == "report") {
          //上报
          this.$TFWebLog.setCommonKeyValue("player_type", data.data.playType);
          this.$TFWebLog.putLogs(10009, 1, { responseData: data.data.info });
        }
      }
    },
    showfunc: function showfunc() {
      if (this.talkredexist) {
        this.talkred = true;
      }
      if (this.shareRedexist) {
        this.shareRed = true;
      }
      if (this.musicStatusexist) {
        this.musicStatus = true;
      }
    },
    talkredend: function talkredend() {
      this.talkredexist = false;
    },
    shareredend: function shareredend() {
      this.shareRedexist = false;
    },
    errorReport: function errorReport(data) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (data) {
                  data.sessionID = _this15.pageUUID;
                }
                _this15.$TFWebLog.setCommonKeyValue("player_type", "腾慧直播上报数据");
                _this15.$TFWebLog.putLogs(70000, 1, { responseData: data });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this15);
      }))();
    },
    init: function init() {
      var _this16 = this;

      var that = this;
      this.myPlayer = document.getElementById("myVideo");

      this.titleName = this.initData.direct_seeding.name;
      if (this.initData.direct_seeding.style != 0) {
        this.styleType = this.initData.direct_seeding.style;
      }
      if (this.initData.comment_list) {
        this.commentList = this.initData.comment_list;
      }

      document.title = this.initData.direct_seeding.name;
      this.uid = this.initData.direct_seeding.uid;
      this.$TFWebLog.org_id = this.uid;
      this.giftList = this.initData.gift_list;
      this.ds_pwd = this.initData.ds_pwd;
      this.noPlayH = document.documentElement.clientHeight;
      this.screenH = window.screen.height;

      this.dsMenu = this.initData.ds_menu;

      for (var i = 0; i < this.dsMenu.length; i++) {
        if (this.dsMenu[i].cid == 9) {
          this.shopIndex = i;
          this.openShop = true;
          this.salesHeight = 24;
        }
      }

      this.navitemWidth = (window.screen.width - 62.5 - 44) / this.dsMenu.length;

      this.breakPoint = this.initData.direct_seeding.break_point ? this.initData.direct_seeding.break_point : [];
      console.error("断点数据", this.breakPoint);
      this.voteList = this.initData.vote_list;

      if (this.initData.wall_sign_conf != null && this.initData.wall_sign_conf.is_open != 0) {
        this.wall_id = this.initData.wall_sign_conf.wall_id;
        this.payPrice = this.initData.wall_sign_conf.price;
        this.wallSign = true;
      }

      _data4.default.verifyCode = this.initData.verifyCode;

      if (this.dsMenu.length == 0 || this.isThreeScreen) {
        this.haveMenu = false;
      }

      this.is_all_users_muted = this.initData.direct_seeding.comment_on_off == 0;

      this.fullscr = false;
      //功能解析
      var Obj = this.ds_func;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.initData.ds_func[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var j = _step.value;

          Obj[j.module] = j.params || true;
          if (j.module == "red_password" || j.module == "coupon_password") {
            this.passwordID = j.module.id;
          } else if (j.module == "master") {
            //主持人功能
            if (this.fans_id == j.params.fans_id) {
              this.isMaster = 1;
            }
            console.log(this.isMaster + "////");
          }

          if (j.module == "say_self") {
            //自嗨
            this.say_self = {
              enabled: true,
              type: j.params.type,
              all: j.params.all
            };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var obj2 = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.initData.ds_func[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _j = _step2.value;

          obj2[_j.module] = _j;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.ds_func = Obj;

      if (!this.fans.unReal) {
        //不是虚拟用户
        //判断是否是黑名单
        this.fans_id && this.getISBack(function (isBlack) {
          _this16.channel_id && _this16.channelInfoUpload();
          if (!isBlack) {
            _this16.loginIM();
            if (obj2.view_auth && (obj2.view_auth.params.view_type == "white_num_view" || obj2.view_auth.params.view_type == "account_white_list")) {
              console.log("account_white_list", obj2.view_auth.params);
              //白名单
              if (obj2.view_auth.params.view_type == "white_num_view") {
                that.need_check_bool = obj2.view_auth.params.need_check == 1;
              }
              //开启了手机号密码或者账号密码
              var option = "ds_id=" + _this16.ds_id + "&fans_id=" + _this16.fans_id;
              _this16.axios.post(_Tools2.default.baseUrl1() + "/wap/index/whiteLoginCheck", option, {
                fans_id: _this16.fans_id,
                credentials: false,
                emulateJSON: true
              }).then(function (res) {
                if (res.data.code == 200) {
                  if (res.data.data.is_white_checked == "true") {
                    that.TelTestShow = false;
                    console.log("用户已验证");
                    //心跳
                    that.isWeixinUserCheck(function (isSuccess) {
                      isSuccess && that.getHeartMode();
                    });
                  } else {
                    if (obj2.view_auth.params.view_type == "account_white_list") {
                      //账号白名单
                      that.show_type = 3;
                    } else {
                      that.show_type = 2;
                    }

                    that.TelTestShow = true;
                    console.log("用户未验证");
                  }
                } else {
                  this.$message.error(res.data.message);
                }
              }).catch(function (res) {

                (0, _toast2.default)("请求错误" + res.data.message);
              });
            } else {
              //没有开启白名单 / 地理位置上报
              _this16.isWeixinUserCheck(function (isSuccess) {
                isSuccess && _this16.getHeartMode();
              });
            }
          }
        });
      } else {
        this.loginIM();
        this.errorReport({ msg: "虚拟用户登录", userinfo: this.fans });
      }

      if (obj2.check_play && obj2.check_play.enabled == "yes") {
        //开启了登记观看
        var _that = this;
        var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
        if (this.fans_id) {
          this.registerViewShow = true;
          this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/isRegist", option, {
            ds_id: this.dsId,
            fans_id: this.fans_id,
            credentials: false,
            emulateJSON: true
          }).then(function (res) {
            if (res.data.code == 200) {
              if (res.data.data.isRegist == "yes") {
                _that.registerViewShow = false;
                console.log("用户已登记");
              } else {
                _that.registerViewShow = true;
                console.log("用户未登记");
              }
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(function (res) {
            (0, _toast2.default)("请求错误" + res.data.message);
          });
          console.log("用户开启了登记观看");
        }
      }

      if (Obj.rolling) {
        //跑马灯
        this.openRolling = true;
        this.isRolling = true;
        this.MerryGoRound = Obj.rolling.text.replace(/\d{11}/g, function (data) {
          return '<a href="tel:' + data + '">' + data + "</a>";
        });
        this.scrollDir = Obj.rolling.position;
        this.marqueeStyle = ";color:" + Obj.rolling.color + ";font-size:" + Obj.rolling.fontsize + "px;";
        if (this.scrollDir == "down") {
          this.marqueeheight = -20;
          this.marqueeStyle += "top:56vw";
        } else {
          this.barHeight = 20;
        }
      }

      if (Obj.bg_music) {
        //开启背景音乐
        this.getMusic();
      } else {
        this.musicStatusexist = false;
      }

      if (Obj.before_ad) {
        //广告视频
        if (Obj.before_ad.user_type == 1) {
          this.before_ad = [{
            url: Obj.before_ad.ad_url
          }];
        } else {
          this.before_ad = JSON.parse(Obj.before_ad.video_list);
        }
      }

      if (Obj.gift) {
        //开启礼物
        this.isshowgift = true;
      }

      if (Obj.shopping_cart) {
        //开启购物车
        this.isshowCart = true;
        if (Obj.shopping_cart.length > 0) {
          var _Obj$shopping_cart$ = Obj.shopping_cart[0],
              type = _Obj$shopping_cart$.type,
              shangpingID = _Obj$shopping_cart$.shangpingID;
          // 如果已经显示过了，再次返回到首页则不再显示购物车弹框

          var isFirstShow = localStorage.getItem('IS_SHOW_ShOPPING_CART');
          if (isFirstShow !== '1') {
            if (type === '3') {
              this.showShoppingDialog = true;
            } else if (type === '2') {
              this.showShoppingType = true;
            }
            // 标记已显示
            localStorage.setItem('IS_SHOW_ShOPPING_CART', '1');
          }
          if (type !== '1') {
            // 二、三购物车样式只会有一个商品信息
            this.goodsInfo = shangpingID[0];
            this.goodsIdsList = [this.goodsInfo.id];
          } else {
            // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
            this.goodsInfo = {};
            this.goodsIdsList = shangpingID;
          }
        }
      } else {
        localStorage.removeItem('IS_SHOW_ShOPPING_CART');
      }

      if (Obj.consulting_teacher) {
        this.showTeacherBtn = true;
      }

      if (!Obj.boot_pic) {
        //关闭大图
        this.loading = true;
        //播放
        setTimeout(function () {
          if (!_this16.showQQPopUp && !_this16.showWxPopUp) {
            _this16.$refs.tfPlayer && _this16.$refs.tfPlayer.playVideoClicked();
          }
        }, 200);
      }

      if (Obj.share) {
        //自定义分享功能
        this.shareData = Obj.share;
      }

      if (Obj.top_list) {
        //开启榜单
        this.toplist = Obj.top_list.type;
      }

      if (Obj.verify_comment) {
        //开启评论审核
        this.verify_comment = true;
      }
      console.log("开启榜单", Obj);

      if (Obj.big_turn_table && this.initData.big_turn_table) {
        //大转盘
        if (this.isWeixin) {
          this.showBigTable = true;
          this.TstartTime = this.initData.big_turn_table.start_time;
          this.Tend_time = this.initData.big_turn_table.end_time;
          this.$refs.left.timeSwitch(this.TstartTime, this.Tend_time);
        }
      }

      if (Obj.nav && !this.isThreeScreen) {
        //开启导航条
        this.haveNav = true;
        this.pieceHeight = 40;
      }

      if (Obj.pic_comment) {
        //图文评论
        this.picComment = true;
      }

      if (Obj.top_ad) {
        //顶部广告
        this.topAD = true;
        this.topObj = Obj.top_ad;
      }

      if (Obj.hot) {
        //热度
        this.hot = true;
      } else {
        this.hot = false;
      }

      if (Obj.wx_follow) {
        this.openWx_follow = true;
        this.weixincodeUrl = Obj.wx_follow.pic_url;
        this.weixintopText = Obj.wx_follow.remark;
        this.weixinbottomText = Obj.wx_follow.wx_under_des;
        this.isShowQRimg = Obj.wx_follow.float == "yes";
        // this.isShowQRimg = Obj.wx_follow.wx_show_now == "yes";
      }

      if (Obj.ad && !this.isThreeScreen) {
        this.isShowAd = true;
        this.adImages = Obj.ad;
        // 北京星巢文化传媒 big传媒banner图特殊处理
        if (this.uid == 27633009) {
          this.bannerHeight = 111;
        } else {
          this.bannerHeight = 67;
        }
      }

      if (Obj.screen_image) {
        this.isShowTeacherQrCode = true;
        this.isShowTeacherBtnTop = false;
        this.teacher_qrcode_title = Obj.screen_image.title || "";
        this.teacher_qrcode_url = Obj.screen_image.image || "";
      }
      // 公告
      if (Obj.notice) {
        this.noticeObj = {
          open: true,
          content: Obj.notice.content,
          time: Obj.notice.time
        };
      }
      // 是否开启购买提示
      if (Obj.purchase_prompt) {
        this.showBuyTipsState = true;
      }

      if (this.isWeixin) {
        this.$refs.right.dsFunc(Obj);
      }

      if (this.ds_pwd.enabled == "yes") {
        //开启观看权限
        this.couponText = this.ds_pwd.params.text;
        if (this.ds_pwd.params.is_try_see == 1) {
          this.tryTime = this.ds_pwd.params.watch_time;
          this.tryPrice = this.ds_pwd.params.price;
          this.isTrySee = true;
        } else {
          this.shareLimit = false;
        }
        this.ticket_switch = this.ds_pwd.params.ticket_switch == 1 ? true : false;
        setTimeout(function () {
          that.limit();
        }, 500);
      }

      //视频开屏图片
      this.videoImg = this.initData.direct_seeding.pic_url;

      var clarity = localStorage.getItem("clarity");
      //解析播放地址
      if (this.directStatus == "end") {
        if (this.breakPoint.length > 0) {
          if (clarity) {
            if (this.breakPoint[0][clarity]) {
              this.videoLinkno = this.breakPoint[0][clarity];
            } else {
              if (this.breakPoint[0].hls_hd) {
                this.videoLinkno = this.breakPoint[0].hls_hd;
              } else {
                this.videoLinkno = this.breakPoint[0].playback;
              }
            }
          } else {
            if (this.breakPoint[0].hls_hd) {
              this.videoLinkno = this.breakPoint[0].hls_hd;
            } else {
              this.videoLinkno = this.breakPoint[0].playback;
            }
          }
          this.videoImg = this.breakPoint[0].pic_url;
          this.getClarity(this.breakPoint[0]);
        }
      } else if (this.directStatus == "running") {
        this.videoLinkno = this.initData.pull_url.m3u8_url;
        var live = {};
        live.pic_url = this.initData.direct_seeding.pic_url;
        live.title = this.initData.direct_seeding.name;
        live.playback = this.initData.pull_url.m3u8_url;
        live.create_time = this.initData.direct_seeding.start_time;

        this.currLiveDic = live;
        this.breakPoint.unshift(live);
      } else {
        if (this.before_ad.length > 0) {
          this.videoLinkno = this.before_ad[0].url;
          var live = {};
          live.pic_url = this.initData.direct_seeding.pic_url;
          live.title = this.initData.direct_seeding.name;
          live.create_time = this.initData.direct_seeding.start_time;
          live.playback = this.before_ad[0].url;
          this.currLiveDic = live;
          this.breakPoint.unshift(live);
        } else {
          this.videoIndex = -1;
        }
      }
      if (this.videoIndex > 0) {
        document.title = this.breakPoint[this.videoIndex].title;
        this.titleName = this.breakPoint[this.videoIndex].title;
        this.getClarity(this.breakPoint[this.videoIndex]);
      }
      if (this.directStatus != "running" && this.haveNav && !this.isThreeScreen && this.breakPoint.length > 0) {
        this.videoIndex = 0;
      }

      this.startTime = this.initData.direct_seeding.start_time;
      // this.myPlayer.load();
    },
    getClarity: function getClarity(obj) {
      var hls_fhd = {},
          hls_hd = {},
          hls_standard = {},
          hls_smooth = {},
          playback = {};
      this.clarityList = [];
      if (obj.hls_fhd) {
        hls_fhd.clarity = "超清";
        hls_fhd.url = obj.hls_fhd;
        hls_fhd.clarityMode = "hls_fhd";
        this.clarityList.push(hls_fhd);
      }
      if (obj.hls_hd) {
        hls_hd.clarity = "高清";
        hls_hd.url = obj.hls_hd;
        hls_hd.clarityMode = "hls_hd";
        this.clarityList.push(hls_hd);
      }
      if (obj.hls_standard) {
        hls_standard.clarity = "标清";
        hls_standard.url = obj.hls_standard;
        hls_standard.clarityMode = "hls_standard";
        this.clarityList.push(hls_standard);
      }
      if (obj.hls_smooth) {
        hls_smooth.clarity = "流畅";
        hls_smooth.url = obj.hls_smooth;
        hls_smooth.clarityMode = "hls_smooth";
        this.clarityList.push(hls_smooth);
      }
      if (obj.playback) {
        playback.clarity = "原画";
        playback.url = obj.playback;
        playback.clarityMode = "playback";
        this.clarityList.push(playback);
      }

      var clarity = localStorage.getItem("clarity");

      //默认画质
      if (obj.hls_hd) {
        this.videoLinkno = obj.hls_hd;
        this.curClarity = "高清";
        localStorage.setItem("clarity", "hls_hd");
      } else {
        this.curClarity = "原画";
        localStorage.setItem("clarity", "playback");
        this.videoLinkno = obj.playback;
      }
    },
    channelInfoUpload: function channelInfoUpload() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + "&uid=" + this.uid + "&channel_code=" + this.channel_id;
      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }
      that.axios.post(_Tools2.default.baseUrl1() + "/customer/channel/channelInfoUpload", option).then(function (data) {}).catch(function (data) {
        console.log(data);
      });
    },
    isWeixinUserCheck: function isWeixinUserCheck(callback) {
      if (this.fans && this.fans.nick == "微信用户" && this.isWeixin) {
        var isSuccess = false;
        wx.getNetworkType({
          success: function success(res) {
            isSuccess = true;
            console.error("isWeixinUserCheck---success");
          },
          fail: function fail() {
            isSuccess = false;
            console.error("isWeixinUserCheck---fail");
          },
          complete: function complete(res) {
            callback(isSuccess);
            console.error("isWeixinUserCheck---complete", isSuccess);
          }
        });
      } else {
        callback(true);
      }
    },
    addPageViewDatas: function addPageViewDatas() {
      var _this17 = this;

      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + "&cip=" + returnCitySN["cip"] + "&cname=" + returnCitySN["cname"] + "&cid=" + returnCitySN["cid"] + "&uid=" + this.uid + "&channel_ds_code=" + this.channel_id + "&terminal_type=1" + "&interval=" + this.heart_time;

      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }

      that.axios.post(_Tools2.default.baseUrlUser() + "/app/index/come_in", option).then(function (data) {
        //心跳
      }).catch(function (error) {
        _this17.errorReport({ msg: "come_in网络异常", userinfo: _this17.fans, error: error });
        that.axios.post(_Tools2.default.baseUrlUserBak() + "/app/index/come_in", option).then(function (data) {}).catch(function (error2) {
          _this17.errorReport({ msg: "come_in2网络异常", userinfo: _this17.fans, error: error2 });
          console.log(error2);
        });
        console.log(error);
      });
      //心跳
      this.heard(5000);
    },
    loginYunXinIM: function loginYunXinIM(type) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var param, yxInfo, imDataNet, UserType, channelInfoStr, userparam, userDataInfo, firstUser, newUser, channelInfo, marktags, param1, _imDataNet, marktagsTmp, loginParams;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // 1 im  2 心跳
                param = "fans_id=" + _this18.fans_id + "&chatroomId=" + _this18.initData.direct_seeding.chatroom_id;

                _this18.errorReport({ search: "\u4E91\u4FE1\u65E5\u5FD7" + _this18.fans_id, msg: "获取云信token2", error: param });

                yxInfo = null;
                _context12.prev = 3;
                _context12.next = 6;
                return _this18.axios.post(_Tools2.default.baseUrl2() + "/init/getYxToken", param);

              case 6:
                imDataNet = _context12.sent;

                yxInfo = imDataNet.data.data;
                console.error("imDataNet", imDataNet);
                _context12.next = 13;
                break;

              case 11:
                _context12.prev = 11;
                _context12.t0 = _context12["catch"](3);

              case 13:
                UserType = 'old';
                channelInfoStr = "";

                if (!_this18.channel_id) {
                  _context12.next = 29;
                  break;
                }

                _context12.prev = 16;
                userparam = "ds_id=" + _this18.ds_id + "&terminal_type=1" + "&channel_ds_code=" + _this18.channel_id;
                _context12.next = 20;
                return _this18.axios.post(_Tools2.default.baseUrlUser() + "/app/index/getUserDataInfo", userparam, { timeout: 3000 });

              case 20:
                userDataInfo = _context12.sent;
                firstUser = userDataInfo.data.data.first;
                newUser = userDataInfo.data.data.new;

                if (firstUser == 1) {
                  UserType = 'first';
                } else if (newUser == 1) {
                  UserType = "new";
                }
                if (userDataInfo.data.data.channel_id) {
                  channelInfo = {
                    channel_name: userDataInfo.data.data.channelName,
                    channel_id: userDataInfo.data.data.channel_id,
                    grouping: userDataInfo.data.data.groupId
                  };

                  channelInfoStr = JSON.stringify(channelInfo);
                }

                _context12.next = 29;
                break;

              case 27:
                _context12.prev = 27;
                _context12.t1 = _context12["catch"](16);

              case 29:
                //标签
                marktags = "";
                _context12.prev = 30;
                param1 = "fansId=" + _this18.fans_id;
                _context12.next = 34;
                return _this18.axios.post(_Tools2.default.baseUrl1() + "/tags/getFromFansId", param1, { timeout: 3000 });

              case 34:
                _imDataNet = _context12.sent;
                marktagsTmp = _imDataNet.data.data[_this18.fans_id];

                if (marktagsTmp && marktagsTmp.length > 0) {
                  marktags = JSON.stringify(_imDataNet.data.data[_this18.fans_id]);
                }
                console.log("标签===", marktags);
                _context12.next = 42;
                break;

              case 40:
                _context12.prev = 40;
                _context12.t2 = _context12["catch"](30);

              case 42:

                if (yxInfo) {
                  loginParams = {
                    appKey: yxInfo.appKey,
                    yxToken: yxInfo.yxToken,
                    fans_id: _this18.fans_id,
                    token: yxInfo.token,
                    address: yxInfo.addr,
                    uid: _this18.uid,
                    ds_id: _this18.ds_id,
                    sessionID: _this18.pageUUID,
                    identifier: _this18.fans_id,
                    identifierNick: _this18.fans.nick,
                    header: _this18.fans.header,
                    headurl: _this18.fans.header,
                    chatroomId: _this18.initData.direct_seeding.chatroom_id,
                    tags: [_this18.fans_id || '0', _this18.ds_id || '0', '0', _this18.channel_id || '0', '1', '0', UserType],
                    custom: [_this18.fans_id || '0', _this18.ds_id || '0', '0', _this18.channel_id || '0', '1', '0', UserType, channelInfoStr, marktags]
                  };

                  if (type == 1) {
                    //im登录
                    _handleim2.default.loginIM(loginParams, 2, {
                      setMsgListener: _this18.onReceivedMsgCallBack,
                      setMemberMsgListener: _this18.onReceivedP2PMsgCallback,
                      setImStatusListener: function setImStatusListener(data) {
                        if (data.error == "kicked") {
                          _this18.yxImChatRoomStatusListener("kicked");
                        }
                      }
                    });
                  } else {
                    _handleim2.default.loginYunXinChatRoom(loginParams, {
                      setImStatusListener: function setImStatusListener(data) {
                        if (data.error == "kicked") {
                          _this18.yxImChatRoomStatusListener("kicked");
                        } else if (data.error == "noconnect") {
                          _this18.yxImNoConnectListener();
                        }
                      }
                    });
                  }
                }

              case 43:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this18, [[3, 11], [16, 27], [30, 40]]);
      }))();
    },
    yxImLogListenerCB: function yxImLogListenerCB(message, error) {
      this.errorReport({ search: "\u4E91\u4FE1\u65E5\u5FD7" + this.fans_id, msg: message, error: error });
    },
    yxImChatRoomStatusListener: function yxImChatRoomStatusListener(status) {
      //云信聊天室回调
      if (status == "kicked") {
        this.isyxinImLoginOut = true;
        if (this.heardTimer) {
          clearInterval(this.heardTimer);
          this.heardTimer = null;
        }
        _handleim2.default.logout(function () {});
      }
    },
    yxImNoConnectListener: function yxImNoConnectListener() {
      if (this.HeartMode == '3' && !this.isBlack) {
        this.addPageViewDatas();
      }
    },
    getHeartMode: function getHeartMode() {
      var _this19 = this;

      if (this.initData.direct_seeding.im_type == 2) {
        //1 腾讯IM 2网易IM
        return;
      }
      //开启了手机号密码或者账号密码
      this.errorReport({ msg: "获取心跳模式" });
      var option = "ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl2() + "/init/getHeartMode", option).then(function (res) {
        _this19.errorReport({ msg: "心跳模式", HeartMode: res });
        if (res.data.code == 200) {
          _this19.HeartMode = res.data.data.mode;
          if (res.data.data.mode == '2') {
            _this19.addPageViewDatas();
          } else if (res.data.data.mode == '3') {
            //  this.addPageViewDatas()
            _this19.loginYunXinIM(2);
          } else if (res.data.data.mode == '4') {
            _this19.loginYunXinIM(2);
          } else if (res.data.data.mode == '5') {
            _this19.loginYunXinIM(2);
            _this19.addPageViewDatas();
          } else {
            _this19.addPageViewDatas();
          }
        } else {
          _this19.errorReport({ msg: "getHeartMode调用异常", userinfo: _this19.fans });
          _this19.addPageViewDatas();
        }
      }).catch(function (error) {
        _this19.addPageViewDatas();
        _this19.errorReport({ msg: "getHeartMode调用异常", userinfo: _this19.fans });
      });

      this.getVideoHeart();
    },
    getVideoHeart: function getVideoHeart() {
      var _this20 = this;

      if (this.heardVodTimer) {
        clearInterval(this.heardVodTimer);
        this.heardVodTimer = null;
      }

      this.heardVodTimer = setInterval(function () {
        if (_this20.playerType == "vod" && _this20.currentPlayerData) {
          var videoData = {
            file_id: _this20.currentPlayerData.playData.file_id,
            fans_id: _this20.fans_id,
            uid: _this20.uid,
            ds_id: _this20.ds_id,
            progress: parseInt(_this20.currentPlayerData.currentPlayTime)
          };
          _this20.axios.post(_Tools2.default.baseUrlUser() + "/app/index/videoHeart", _qs2.default.stringify(videoData)).then(function (data) {}).catch(function (data) {});
        }
      }, 5000);
    },
    heard: function heard(time) {
      var _this21 = this;

      var that = this;
      if (this.heardTimer) {
        return;
      }
      this.heardTimer = setInterval(function () {
        var option = "ds_id=" + _this21.ds_id + "&fans_id=" + _this21.fans_id + "&cip=" + returnCitySN["cip"] + "&cname=" + returnCitySN["cname"] + "&cid=" + returnCitySN["cid"] + "&uid=" + _this21.uid + "&channel_ds_code=" + _this21.channel_id + "&terminal_type=1" + "&interval=" + _this21.heart_time;
        if (_this21.tid) {
          option = option + "&tid=" + _this21.tid;
        }
        that.axios.post(_Tools2.default.baseUrlUser() + "/app/index/heart", option).then(function (data) {
          if (data.data.code == 2000) {
            if (_this21.heart_time != data.data.data.interval) {
              _this21.heart_time = data.data.data.interval || 30;
              clearInterval(_this21.heardTimer);
              _this21.heardTimer = null;
              _this21.heard(_this21.heart_time * 1000);
            }
          } else {
            _this21.errorReport({ msg: "heart调用异常", userinfo: _this21.fans, error: data });
          }
        }).catch(function (error) {
          //失败重试
          _this21.errorReport({ msg: "heart网络异常", userinfo: _this21.fans, error: error });
          that.axios.post(_Tools2.default.baseUrlUserBak() + "/app/index/heart", option).then(function (data) {
            if (data.data.code == 2000) {
              if (_this21.heart_time != data.data.data.interval) {
                _this21.heart_time = data.data.data.interval || 30;
              }
            } else {
              _this21.errorReport({ msg: "heart2调用异常", userinfo: _this21.fans, error: data });
            }
          }).catch(function (error2) {
            _this21.errorReport({ msg: "heart2网络异常", userinfo: _this21.fans, error: error2 });
          });
        });
      }, this.heart_time * 1000);
    },
    cutClarity: function cutClarity(item) {
      var that = this;
      this.currentTime = this.myPlayer.currentTime;
      this.videoLinkno = item.url;
      this.curClarity = item.clarity;
      this.switchClarity();
      localStorage.setItem("clarity", item.clarityMode);
      this.isShowControl = false;
      // this.myPlayer.load();
      setTimeout(function () {
        that.videoPlay();
      }, 200);
    },
    switchClarity: function switchClarity() {
      this.showClarity = !this.showClarity;
    },
    setControl: function setControl() {},
    update: function update() {
      var playSchedule = document.getElementById("playSchedule");
      var playPoint = document.getElementById("playPoint");
      this.videoCurrentTime = _Tools2.default.changeTime(this.myPlayer.currentTime);
      var percent = this.myPlayer.currentTime / this.myPlayer.duration;
      playSchedule.style.width = percent * 100 + "%";
      playPoint.style.left = percent * 100 + "%";
    },
    onControlClicked: function onControlClicked() {
      var that = this;
      that.showClarity = false;
      clearTimeout(this.controlTimer);
      if (this.isShowControl) {
        this.isShowControl = false;
        if (this.scrollDir == "down") {
          this.isRolling = true;
        }
      } else {
        if (this.scrollDir == "down") {
          this.isRolling = false;
        }
        this.isShowControl = true;
        this.controlTimer = setTimeout(function () {
          that.onControlClicked();
        }, 5000);
      }
    },
    onPlayBtnClicked: function onPlayBtnClicked() {
      if (this.myPlayer.paused) {
        this.myPlayer.play();
      } else {
        this.myPlayer.pause();
        this.currentTime = this.myPlayer.currentTime;
      }
    },
    videoPlay: function videoPlay() {
      var that = this;
      if (this.videoIndex == 0 && this.directStatus == "end" || this.videoIndex > 0) {
        if (!this.canBack) {
          (0, _toast2.default)("直播已结束");
          return false;
        }
      }
      //如果有音乐关闭音乐
      var audio = document.getElementById("audio");
      if (audio) {
        audio.pause();
      }
      // 移除音乐监听
      document.body.removeEventListener("click", this.playmusic);
      that.myPlayer.currentTime = that.currentTime;
      that.myPlayer.play();

      if (this.isIOS) {} else {
        if (this.isFirstPlay) {
          //历史播放记录加载
          if (this.currentTime == 0) {
            var time = window.localStorage.getItem(this.videoLinkno);
            if (time > 0) {
              this.currentTime = time;
            }
          }
          //播放
          this.playtimer = setInterval(function () {
            that.myPlayer.play();
            that.myPlayer.currentTime = that.currentTime;
          }, 200);

          var s = this.currentTime;
          if (s != 0) {
            var timer = setInterval(function () {
              that.myPlayer.currentTime = s;
              if (that.myPlayer.currentTime != 0) {
                that.isFirstPlay = false;
                clearInterval(timer);
              }
            }, 500);
          }
        }
      }

      return true;
    },
    initUI: function initUI() {
      //初始化页面
      var w = document.body.clientWidth;
      var screenH = this.screenH;
      var h = this.noPlayH;
      var contentHeight = 0;
      if (!this.isIOS) {
        this.playerStyle = {
          display: "none"
        };
      }
      if (this.topAD) {
        contentHeight = h - w * 0.56 - 44 - this.pieceHeight - 38 - this.salesHeight - this.bannerHeight;
      } else {
        if (this.isThreeScreen) {
          contentHeight = h - w * 0.56 - w * 0.56 - 44;
        } else {
          contentHeight = h - w * 0.56 - 44 - this.pieceHeight - this.salesHeight - this.bannerHeight;
        }
      }

      this.contentStyle = {
        height: contentHeight + "px"
      };

      this.isPlayUI = false;
      clearTimeout(this.controlTimer);
      this.isShowControl = true;
      this.showhead = false;
      this.showControl = true;
      this.headtitleBg = "#212126";
      this.showCover = true;
      this.showMenu = true;
      if (this.topAD) {
        this.playHeight = 38;
      } else {
        this.playHeight = 0;
      }
      this.bottomSider = true;
      this.showView = true;
      this.showfunc();
      if (this.ds_func.rolling) {
        this.openRolling = true;
        this.isRolling = true;
      }

      this.loginErrroStyle = {
        display: "block",
        height: h - w * 0.56 - (this.playHeight + this.pieceHeight + this.salesHeight + this.bannerHeight) + "px"
      };
    },
    playUI: function playUI() {
      var w = document.body.clientWidth;
      var screenH = this.screenH;
      var h = this.noPlayH;
      var headerH = 54;
      var that = this;
      this.orientation = "portraint";
      if (!this.isIOS) {
        this.playerStyle = {
          height: screenH + "px",
          width: w + "px",
          objectFit: "contain",
          objectPosition: "top " + headerH + "px left 0px",
          display: "block"
        };
      }

      this.isPlayUI = true;
      //影藏遮盖层
      this.showCover = false;
      if (this.topAD) {
        this.playHeight = 0;
      }
      this.hidefunc();
      this.showControl = true;
      this.isShowControl = false;
      this.onControlClicked();
      this.fullscr = false;
      this.talkred = true;
      this.showView = true;
      this.showMenu = true;
      this.bottomSider = true;
      if (this.isIOS) {
        this.playerStyle = {};
        this.controlStyle = {};
        return false;
      }

      this.controlStyle = {
        height: w * 0.56 + "px",
        top: headerH + "px"
      };
      this.contentStyle = {
        height: screenH - w * 0.56 - 98 - this.pieceHeight + "px",
        display: "block"
      };

      this.playHeight = 54;
      this.showhead = true;
      this.headtitleBg = "#212126";

      this.loginErrroStyle = {
        display: "block",
        height: screenH - w * 0.56 - (this.playHeight + this.pieceHeight + this.salesHeight + this.bannerHeight) + "px",
        bottom: 0
      };
    },
    fullScreenUI: function fullScreenUI() {
      var screenH = window.screen.height;
      var screenW = window.screen.width;
      var that = this;
      this.orientation = "landscape";
      this.fullscr = true;
      this.bottomSider = false;
      this.showView = false;
      this.openRolling = false;
      this.talkred = false;
      this.showMenu = false;
      if (this.isIOS) {
        this.controlStyle = {
          height: "100%",
          width: "100%"
        };
        return false;
      }
      this.playerStyle = {
        height: "100%",
        width: "100%",
        display: "block",
        objectFit: "fill"
      };
      this.controlStyle = {
        height: "100%",
        width: "100%",
        top: "0px"
      };
      this.playHeight = 0;
      this.headtitleBg = "none";
      this.contentStyle = {
        display: "none"
      };
      this.loginErrroStyle = {
        display: "none"
      };
    },
    handleTabClick: function handleTabClick(item) {
      if (!this.initData.ds_menu.length) {
        return;
      }
      this.curCid = this.initData.ds_menu[item].cid;
      this.currentMid = this.initData.ds_menu[item].mid;
      if (this.curCid == 6) {
        this.dispark = true;
      } else if (this.curCid == 5) {
        if (this.initData.ds_menu[item].config == 1) {
          location.href = this.initData.ds_menu[item].content;
        }
      } else if (this.curCid == 2) {
        this.vid = this.initData.ds_menu[item].config;
      } else if (this.curCid == 9) {
        if (!this.storeActive) {
          this.storeActive = this.initData.ds_menu[item].config;
          this.StoreUrl = "http://ph.shikee.tv/store/?ds_id=" + this.ds_id + "&active=" + this.storeActive + "#/index";
          console.log(this.StoreUrl);
        }
      } else {
        this.dispark = false;
        this.ripple(100);
      }
    },
    playPause: function playPause() {
      // rtc播放
      if (!this.isNotShowWebRTC) {
        if (this.rtcRemoteStream) {
          this.rtcLiveResume();
          this.isShowProgress = true;
          this.isPlay = true;
          this.showCover = false;
          this.play = true;
          this.topAD = false;
        } else {
          (0, _toast2.default)("老师还没上课，请稍后!");
        }
        return;
      }

      var that = this;
      if (this.playStart) {
        this.myPlayer.play();
        return;
      }
      var start = new Date(this.startTime.replace(/-/g, "/"));
      if (this.directStatus == "not_started" && this.before_ad.length == 0) {
        (0, _toast2.default)("直播时间：" + (1 + start.getMonth()) + "月" + start.getDate() + "日 " + start.getHours() + "时" + start.getMinutes() + "分");
        return;
      }

      if (this.directStatus == "end" && this.canBack) {
        if (this.breakPoint.length < 1) {
          (0, _toast2.default)("回放视频正在生成!");
          return;
        } else {
          if (!this.myPlayer.currentTime) {
            (0, _toast2.default)("直播已结束，开始播放回放视频");
          }
        }
      }

      if (!this.videoPlay()) {
        return;
      }
      if (!this.fullscr && this.isIOS) {
        this.playUI();
      }
      this.tryUi();
      this.playStart = true;

      console.log("播放方法被执行了:" + this.videoLinkno);
    },
    tryUi: function tryUi() {
      var that = this;
      this.tryOpacity = 1;
      setTimeout(function () {
        if (that.directStatus == "end" || that.videoIndex != 0) {
          that.tryOpacity = 0;
          that.tryPayBtn = true;
        }
      }, 5000);
    },
    shareToWeChat: function shareToWeChat() {
      var that = this;
      var option = "url=" + encodeURIComponent(location.href);
      this.axios.post(_Tools2.default.baseUrl2() + "/init/getWechatShareData", option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          that.wxReady(data.data.shareData);
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    wxReady: function wxReady(params) {
      var that = this;

      //配置分享
      wx.config({
        debug: false,
        appId: params.appid, // 必填
        timestamp: params.timestamp, // 必填，生成签名的时间戳
        nonceStr: params.noncestr, // 必填，生成签名的随机串
        signature: params.signature, // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: ['wx-open-launch-weapp']
      });

      console.log("直播间数据", that.initData);

      this.share.url = params.url;
      this.share.dec = that.initData.direct_seeding.desc;
      this.share.title = that.initData.direct_seeding.name;
      this.share.image = that.initData.direct_seeding.pic_url;
      this.share.groupImage = that.initData.direct_seeding.pic_url;
      this.share.groupDesc = that.initData.direct_seeding.name;

      var funcList = this.initData.ds_func;

      var shareItem = funcList.find(function (item) {
        return item.module == "share";
      });

      if (shareItem) {
        this.share.dec = shareItem.params.friend_des;
        this.share.title = shareItem.params.friend_title;
        this.share.image = shareItem.params.friend_pic_url;
        this.share.groupImage = shareItem.params.moment_pic_url;
        this.share.groupDesc = shareItem.params.moment_des;
      }

      console.log("分享参数", this.share, params);

      wx.ready(function () {
        //微信好友分享
        wx.updateAppMessageShareData({
          title: that.share.title, // 分享标题
          desc: that.share.dec, // 分享描述
          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
          imgUrl: that.share.image, // 分享图标
          success: function success() {
            console.log("设置分享微信好友分享参数成功");
          }
        });

        //微信朋友圈分享
        wx.updateTimelineShareData({
          title: that.share.groupDesc, // 分享标题
          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
          imgUrl: that.share.groupImage, // 分享图标
          success: function success() {
            console.log("设置分享微信朋友圈分享参数成功");
          }
        });
      });
      wx.error(function (data) {
        console.log("错误");
        console.log(data);
      });
    },
    getshare: function getshare() {
      var that = this;
      var url = _Tools2.default.baseUrl() + "/fans/share/index";

      var option = {
        fans_id: that.fans_id,
        ds_id: that.ds_id
      };

      option = _Tools2.default.encrypt(option);
      that.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          that.rewardType = 2;
          that.rewardredpack = true;
          that.shareRedexist = false;
          that.rewardMoney = data.data.money;
        } else {
          (0, _toast2.default)(data.message);
          that.shareRedexist = false;
        }
      }).catch(function (res) {
        console.log("获取分享数据失败失败" + res);
      });
    },
    getshareQuan: function getshareQuan() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + "/share/coupon";

      var option = {
        fans_id: that.fans_id,
        ds_id: that.ds_id
      };

      option = _Tools2.default.encrypt(option);
      that.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          that.rewardType = 2;
          that.rewardQuan = true;
          that.shareRedexist = false;
          that.quanData = data.data;
        } else {
          (0, _toast2.default)(data.message);
          that.shareRedexist = false;
        }
      }).catch(function (res) {
        console.log("获取分享数据失败失败" + res);
      });
    },

    /**
     * 描述：判断是否有重复的开播消息
     * @param   : json {object}， msg {object}
    **/
    checkShowLiveStartDialog: function checkShowLiveStartDialog(json, msg) {
      if (msg) {
        switch (json.module) {
          case 'ds_start':
            var startMsgId = localStorage.getItem('tengface_start_live_msg_id', msg.idClient);
            if (startMsgId === msg.idClient) {
              return false;
            }
            localStorage.setItem('tengface_start_live_msg_id', msg.idClient);
            break;
          case 'ds_end':
            var endMsgId = localStorage.getItem('tengface_end_live_msg_id', msg.idClient);
            if (endMsgId === msg.idClient) {
              return false;
            }
            localStorage.setItem('tengface_end_live_msg_id', msg.idClient);
            break;
          default:
            break;
        }
        return true;
      }
      return true;
    },
    livestart: function livestart(json, element) {
      if (!this.checkShowLiveStartDialog(json, element)) {
        return;
      }
      var message;
      if (json.module == "ds_start") {
        var timesecond = 0;
        if (json.delay_status) {
          timesecond = json.delay_time * 1000;
        } else {
          timesecond = 0;
        }

        setTimeout(function () {
          message = "直播已经开始，点击播放";
          _dialog2.default.alert({
            title: "温馨提示",
            message: message
          }).then(function () {
            window.location.reload();
          });
        }, timesecond);
      } else {
        if (this.isThreeScreen && this.$refs.whiteboard) {
          this.$refs.whiteboard.exitFullScreen();
        }
        message = "直播已经结束";
        _dialog2.default.alert({
          title: "温馨提示",
          message: message
        }).then(function () {
          window.location.reload();
        });
      }
    },
    personnum: function personnum(numValue) {
      //增加观看人数
      // if (numValue == "0") {
      //   this.view_num++;
      // } else {
      //   if (this.view_num < numValue) {
      //     this.view_num = numValue;
      //   }
      // }
    },
    timestamps: function timestamps() {
      var time = new Date();
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();

      return "" + y + _Tools2.default.two(m) + _Tools2.default.two(d) + _Tools2.default.two(h) + _Tools2.default.two(mm) + _Tools2.default.two(s);
    },
    swichWindow: function swichWindow() {
      this.forbid = !this.forbid;
      localStorage.setItem("forbid", this.forbid);
    },
    playBack: function playBack() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + "/playback/index";
      var option = "uid=" + this.uid + "&ds_id=" + this.ds_id;
      this.axios.post(url, option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          that.canBack = true;
        } else {
          that.canBack = false;
          console.log(data.message);
        }
      }).catch(function (data) {
        //Toast(data);
      });
    },
    closeAD: function closeAD() {
      this.topAD = false;
      this.initUI();
    },
    loginIM: function loginIM(noShowToast) {
      var _this22 = this;

      if (this.initData.direct_seeding.im_type == 2) {
        //网易IM
        this.loginYunXinIM(1);
      } else {
        if (!noShowToast) {
          _toast2.default.loading();
        }
        var option = "fans_id=" + this.fans_id;
        this.axios.post(_Tools2.default.baseUrl1() + "/api/im/getUserSign", option).then(function (res) {
          localStorage.setItem("tl_sign", res.data.data.tl_sign);
          _this22.loginIMToDo(res.data.data.tl_sign);
        }).catch(function (error) {
          _this22.axios.post("https://service-r0p4y9rc-1258158934.gz.apigw.tencentcs.com/release/api/login/getImUserSign", option).then(function (res) {
            localStorage.setItem("tl_sign", res.data.data);
            _this22.loginIMToDo(res.data.data);
          }).catch(function (error) {});
        });
      }
    },
    loginIMToDo: function loginIMToDo(tl_sign) {
      var that = this;
      var obj = {};
      obj["currentGroupId"] = that.initData.direct_seeding.room_id;
      // obj["currentGroupId"] = '@TGS#aOYDEPXMX'
      obj["identifier"] = this.fans_id;
      obj["identifierNick"] = that.fans.nick;
      obj["headurl"] = that.fans.header;
      obj["userSig"] = tl_sign;
      //腾讯IM登录
      _handleim2.default.loginIM(obj, 1, {
        setMsgListener: this.onReceivedMsgCallBack,
        setMemberMsgListener: this.onReceivedP2PMsgCallback,
        setImStatusListener: this.imStatusListener
      });
    },
    onReceivedP2PMsgCallback: function onReceivedP2PMsgCallback(json) {
      this.$refs.consultTeacher.receivedMsg(json);
      if (!this.showConsultTeacher) {
        this.$refs.chat[0].receivedMsg(json);
        this.$refs.chat[0].showUnReadViewFunc(json);
      }
    },
    loadFakeComment: function loadFakeComment() {
      var self = this;
      // 获取服务器时间校准
      var url = _Tools2.default.baseUrl1() + "/wap/live/getServerTime";
      var option = "";
      this.axios.post(url, option).then(function (data) {
        if (data.data.code == 200) {
          var time = data.data.data.time;
          var real_start_time = self.initData.direct_seeding.real_start_time && self.initData.direct_seeding.real_start_time.replace(/-/g, "/") || self.initData.direct_seeding.start_time;
          var tempTime = new Date(real_start_time).valueOf() + new Date().valueOf() - new Date(time.replace(/-/g, "/")).valueOf();
          var startTime = self.getTimes(tempTime);
          console.log("时间校准", data.data.data.time, self.getTimes(new Date().valueOf()));
          var tid = self.initData.fakeTemplateId;
          _FakeIm2.default.setCommentCallback(self.onReceivedMsgCallBack);
          console.log("校准后时间:", startTime);
          _FakeIm2.default.startLoad(startTime, tid, function (isOK) {
            if (isOK) {
              _FakeIm2.default.startCommentRun();
            } else {
              (0, _toast2.default)("获取评论失败，请刷新重试");
            }
          });
        } else {
          (0, _toast2.default)("网络错误" + data.data.message);
        }
      }).catch(function (data) {
        console.log("时间校准错误", data);
        (0, _toast2.default)("网络错误" + data);
      });
    },
    getNot: function getNot() {
      // var that = this;
      // im.getNotification(function(data) {
      //   if (data != false && data != null) {
      //     console.log("动态秘钥：" + data.Notification);
      //     vxxData.verifyCode = data.Notification;
      //   } else {
      //     var flag = confirm("获取聊天动态秘钥失败");
      //     if (flag) {
      //       that.getNot();
      //     } else {
      //       that.getNot();
      //     }
      //   }
      // });
    },
    ripple: function ripple(num) {
      var that = this;
      if (that.shopIndex < 0) {
        return;
      }
      setTimeout(function () {
        document.querySelectorAll(".van-tab")[that.shopIndex].className = "van-tab ripple";
      }, num);
    },
    robRedBagAction: function robRedBagAction(item) {
      //抢红包
      var that = this;
      if (!this.isWeixin) {
        return;
      }
      if (this.isGradRedStart) {
        return;
      }
      this.redBagData = item;
      this.isGradRedStart = true;
      var url = _Tools2.default.baseUrl() + "/redPacket/Grab/index";
      var option = {
        fans_id: this.fans_id,
        msg_id: item._id
      };

      option = _Tools2.default.encrypt(option);

      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          that.redBaglistData = data.data;
          if (data.data.status == "is_open") {
            that.showrobRedlist = true;
          } else if (data.data.status == "is_close") {
            that.showrobRedlist = true;
          } else {
            (0, _toast2.default)("抢红包失败！稍后再试！");
          }
        }
        that.isGradRedStart = false;
      }).catch(function (res) {
        that.isGradRedStart = false;
        (0, _toast2.default)("抢红包失败！稍后再试！");
        console.log(res);
      });
    },
    closeRodRedList: function closeRodRedList() {
      this.showrobRedlist = false;
    },
    switchSider: function switchSider() {
      this.bottomSider = !this.bottomSider;
      this.shareRed = !this.shareRed;
      this.talkred = !this.talkred;
    },
    getTimes: function getTimes(timeStr) {
      var time = new Date();
      if (timeStr) {
        time = new Date(timeStr);
      }
      var year = time.getFullYear();
      var month = _Tools2.default.two(time.getMonth() + 1);
      var date = _Tools2.default.two(time.getDate());
      var hours = _Tools2.default.two(time.getHours());
      var minutes = _Tools2.default.two(time.getMinutes());
      var seconds = _Tools2.default.two(time.getSeconds());

      return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
    },
    onReceivedMsgCallBack: function onReceivedMsgCallBack(json, element) {
      var _this23 = this;

      console.log("收到的消息json", json);

      var that = this;
      // console.log(JSON.stringify(json));
      if (!json.create_time) {
        json.create_time = this.getTimes();
      }
      switch (json["module"]) {
        case "red_rain_close":
          //红包雨结束
          that.$refs.redrain.redbagRain(json);
          break;
        case "rain_random":
          //红包雨随机
          this.rainProbab = json.percent;
          this.rainId = json.id;
          setTimeout(function () {
            that.$refs.redrain.redbagRain(json);
          }, 300);
          break;
        case "rain_normal":
          //红包雨
          this.rainProbab = json.percent;
          this.rainId = json.id;
          setTimeout(function () {
            that.$refs.redrain.redbagRain(json);
          }, 300);
          break;
        case "enterPerson":
          //用户进入
          if (this.$refs.chat) {
            if (this.$refs.chat[0]) {
              this.$refs.chat[0].personenter(json.nick);
            }
            this.personnum(0);
          }
          break;
        case "buy_product_msg":
          //购买商品
          this.$refs.chat[0].productEnter(json.nick, json.shop_num);
          this.$refs.right.buyProduct(json);
          this.buyProduct(json);
          break;
        case "get_money_msg":
          //用户获得收益
          this.$refs.chat[0].moneyEnter(json.nick, json.money);
          this.$refs.top.moneyEnter(json.nick, json.money);
          break;
        case "ds_start":
          //直播开始了
          this.livestart(json, element);
          break;
        case "ds_end":
          //直播结束了
          this.livestart(json, element);
          break;
        case "grab_redpacket":
          //打赏红包
          this.$refs.chat[0].redpacket(json);
          break;
        case "addLikeNum":
          //增加点赞
          this.$refs.chat[0].addLikeNumIm(json);
          break;
        case "delete_comment":
          //删除评论
          this.$refs.chat[0].deleteComment(json);
          break;
        case "channel_text_comment":
          //渠道文字评论
          if (json.channel_code && (json.channel_code.indexOf(this.channel_REL_ID) > -1 || json.channel_code.indexOf(this.channelGroupID) > -1)) {
            json.module = "text_comment";
            this.$refs.chat[0].textComment(json);
          }
          break;
        case "teacher_reply_comment":
          //渠道文字评论
          if (json.to_fans_id == this.fans_id) {
            json.module = "text_comment";
            this.$refs.chat[0].textComment(json);
          }
          break;
        case "text_comment":
          //文字评论
          if (this.initData.direct_seeding.bind && this.businessConfigs.ds_bind_in_one_room && this.businessConfigs.ds_bind_in_one_room_alone_message && json.terminal_type != 3 && json.ds_id != this.ds_id && !(json.bind == 1 && json.terminal_type == 4)) {
            //主从直播间
            return;
          }
          this.$refs.chat[0].textComment(json);
          break;
        case "gift_comment":
          //礼物打赏
          this.$refs.toolbar.gift(json);
          this.$refs.chat[0].giftComment(json);
          break;
        case "riseData":
          //人数增加
          this.$refs.chat[0].riseData(json);
          break;
        case "share_red_pack_end":
          //分享红包结束
          this.shareredend();
          break;
        case "red_password_end":
          //口令红包结束
          this.talkredend();
          break;
        case "update_verify_code":
          //更新秘钥
          _data4.default.verifyCode = json.content.verify;
          break;
        case "share_comment":
          //分享得红包
          this.$refs.chat[0].addReviewWrap(json);
          break;
        case "wall_comment":
          //霸屏信息
          this.$refs.chat[0].addReviewWrap(json);
          break;
        case "coupon_comment":
          //得卡券
          this.$refs.chat[0].addReviewWrap(json);
          break;
        case "invite_comment":
          //邀请得红包
          this.$refs.chat[0].addReviewWrap(json);
          break;
        case "reward_redpacket_comment":
          //打赏主办方红包
          this.$refs.chat[0].addReviewWrap(json);
          break;
        case "redpack_comment":
          //随机红包
          this.$refs.chat[0].addReviewWrap(json);
          break;
        case "big_table_turn_running":
          //开启大转盘
          this.$refs.left.getStatus(0);
          break;
        case "big_table_turn_end":
          //结束大转盘
          this.$refs.left.getStatus(1);
          break;
        case "agreeLink":
          //老师邀请连麦
          this.linkLive(json);
          break;
        case "linkDown":
          this.linkDown(json);
          break;
        case "teacherOneKeyLinkMic":
          //老师一键连麦
          {
            this.onkeyLinkMic(json);
            break;
          }
        case "studentOneKeyLinkMicCB":
          //学生一键连麦
          {
            this.studentOneKeyLinkMicCB(json);
            break;
          }
        case "system_message_group_introduction":
          //群公告
          {
            if (json.content && json.content.online_num != undefined) {
              this.view_num = json.content.online_num;
            }
          }
          break;
        case "system_message_group_notification":
          //群通知
          // let content = JSON.parse(json.content);
          // if (content.showConsultTeacher != undefined) {
          //   //咨询老师
          //   this.$refs.chat[0].showConsultTeacher(content);
          // }
          break;
        case "wx_follow_change":
          //是否显示二维码
          this.isShowQRimg = json.params.wx_show_now == "yes";
          this.openWx_follow = json.params.wx_show_now == "yes";

          if (this.isShowQRimg) {
            setTimeout(function () {
              _this23.isShowQRimg = false;
            }, 5000);
          }

          break;
        case "shopping_cart":
          //是否显示购物车
          if (json.status == "yes") {
            this.isshowCart = true;
            var data = JSON.parse(json.params);
            if (data.length > 0) {
              var _data$ = data[0],
                  type = _data$.type,
                  shangpingID = _data$.shangpingID;

              if (type === '3') {
                this.showShoppingType = false;
                this.showShoppingDialog = true;
              } else if (type === '2') {
                this.showShoppingType = true;
                this.showShoppingDialog = false;
              }
              if (type !== '1') {
                // 二、三购物车样式只会有一个商品信息
                this.goodsInfo = shangpingID[0];
                this.goodsIdsList = [this.goodsInfo.id];
              } else {
                // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
                this.goodsInfo = {};
                this.goodsIdsList = shangpingID;
              }
            }
          } else {
            this.isshowCart = false;
            this.goodsIdsList = [];
            this.showShoppingType = false;
            this.showShoppingDialog = false;
          }
          break;
        case "PERSON_IN_BLACK":
          console.log(json.fans_id_list, this.fans_id, "黑名单");
          if (json.fans_id_list.indexOf("" + this.fans_id) > -1) {
            if (json.in_black == "yes") {
              this.isBlack = true;
              if (this.heardTimer) {
                clearInterval(this.heardTimer);
                this.heardTimer = null;
              }
              location.reload();
            } else {
              this.isBlack = false;
              location.reload();
            }
          }
          break;
        case "PERSON_KICK_OUT":
          if (json.fans_id == this.fans_id) {
            window.location.href = json.to_web;
          }
          break;
        case "screenCaptureChange":
          console.log("需要刷新播放器");
          setTimeout(function () {
            _this23.$refs.tfPlayer.playVideoClicked();
          }, 500);
          break;
        case "GIFT_CHANGE_STATUS":
          //送花点赞
          if (json.status == "yes") {
            this.isshowgift = true;
          } else {
            this.isshowgift = false;
          }
          break;
        case "CONSULTING_TEACHER_STATUS":
          //是否显示联系老师
          if (json.status == "yes") {
            this.showTeacherBtn = true;
          } else {
            this.showTeacherBtn = false;
          }
          break;
        case "comment_on_off":
          //全员静言
          {
            this.is_all_users_muted = json.status == "0";
          }
          break;
        case "show_teacher_qrcode":
          //是否显示老师二维码
          {

            if (this.initData.direct_seeding.bind && this.businessConfigs.ds_bind_in_one_room && json.ds_id != this.ds_id) {
              //主从直播间消息隔离
              return;
            }

            if (json.open == 1) {
              this.isShowTeacherQrCode = true;
              this.isShowTeacherBtnTop = false;
              if (this.$refs.tfPlayer.getPlayerIsfullScreen()) {
                if (this.isIOS) {
                  window.location.reload();
                } else {
                  this.$refs.tfPlayer.exitFullScreen();
                }
              }
            } else {
              this.isShowTeacherQrCode = false;
              this.isShowTeacherBtnTop = false;
            }
            this.teacher_qrcode_title = json.title || "";
            this.teacher_qrcode_url = json.image || "";
          }
          break;
        case "say_self":
          //自嗨消息
          {
            this.say_self = {
              enabled: json.status == "yes",
              type: json.params.type,
              all: json.params.all
            };
          }
          break;
        case "notice":
          //公告
          {
            this.noticeObj = {
              open: json.status == "yes",
              content: json.params.content,
              time: json.params.time
            };
          }
          break;
        case "verify_comment":
          //评论审核
          {
            this.verify_comment = json.status == "yes";
          }
          break;
        case "ds_change_rtc":
          {
            console.log("ds_change_rtc");
            if (this.linkType != 3) {
              setTimeout(function () {
                console.log("切换rtc播放");
                _this23.$refs.tfPlayer && _this23.$refs.tfPlayer.changePlayType(1);
              }, 500);
            }
          }
          break;
        case "TXWhiteBoardExt":
          //画板消息
          {
            if (this.$refs.whiteboard) {
              this.$refs.whiteboard.addMessageSyncData(json.content);
            }
          }
          break;
        case "ds_refresh":
          //刷新直播间
          {
            setTimeout(function () {
              location.reload();
            }, Math.round(Math.random() * 10) * 1000);
          }
          break;
        case "live_question_publish":
          //老师发布答题
          {
            if (this.$refs.tfPlayer && this.$refs.tfPlayer.getPlayerIsfullScreen()) {
              if (this.isIOS) {
                window.location.reload();
              } else {
                this.$refs.tfPlayer.exitFullScreen();
              }
            }
            this.LiveanserObj = json;
            this.isShowLiveAnser = true;
          }
          break;
        case "live_question_end":
          //老师结束答题
          {
            // if (this.LiveanserObj.qpid == json.qpid) {
            this.isShowLiveAnser = false;
            // }
          }
          break;
        // 正在购买
        case 'shopping_purchase':
          this.saveUserBuyList.push(json.nick);
          if (!this.tipsBuyTimer) {
            this.showTipsByUserBuy();
          }
          break;
        // 购买成功
        case 'shopping_success':
          this.saveUserBuySuccessList.push(json.nick_name);
          this.inventoryNum = json.num;
          if (!this.tipsBuySuccessTimer) {
            this.showTipsByUserBuySuccess();
          }
          break;
        // 购买提示
        case 'purchase_prompt':
          this.showBuyTipsState = json.status === 'yes';
          break;
        default:
          //this.$refs.chat[0].addReviewWrap(json);
          break;
      }
    },
    imStatusListener: function imStatusListener(resp) {
      var _this24 = this;

      if (resp.ErrorCode == 1) {
        //网络恢复，需要重新连接
        (0, _toast2.default)("网络恢复正在重新连接聊天室...");
        //重新加载视频
        if (this.playerStatus == 2 && this.initData.direct_seeding.play_style == "3") {
          if (this.outOfTime == 2 && this.linkType == 3) {
            // 连麦操作
            this.$refs.tfPlayer.rtcLiveLeave(function () {
              _this24.$refs.tfPlayer.rtcLink();
            });
          } else {
            this.linkType = 1;
            this.$refs.tfPlayer.rtcLiveLeave(function () {
              _this24.$refs.tfPlayer.playVideoClicked();
            });
          }
        }
        return;
      }

      if (resp.ErrorCode == 9999) {
        //网络断开了
        (0, _toast2.default)("聊天室网络中断，将无法收到消息，请检查网络或刷新页面");
      }
    },
    buyProduct: function buyProduct(json) {
      var that = this;
      this.buyList.push(json);
      setTimeout(function () {
        that.buyListIndex++;
      }, 6000);
    },
    tryPay: function tryPay() {
      _Tools2.default.bugTicket(this.coupon_id, this.payLoad);
    },
    select: function select(index, id) {
      this.payIndex = index;
      this.coupon_id = id;
    },
    payCancel: function payCancel() {
      this.showPay = false;
      this.myPlayer.play();
    },
    onShowPay: function onShowPay() {
      if (this.ticket_switch) {
        _toast2.default.loading();
        _Tools2.default.getCoupon(this.getCoupon);
      } else {
        this.showPay = true;
      }
      console.log(this.coupons);
    },
    getCoupon: function getCoupon(coupons) {
      _toast2.default.clear();
      this.coupons = coupons;
      console.log(this.coupons.length);
      this.showPay = true;
    },
    payLoad: function payLoad() {
      var that = this;
      sessionStorage.setItem("initData", null);
      setTimeout(function () {
        that.$router.replace("/home");
        window.location.reload();
      }, 2000);
    },
    onShowAllot: function onShowAllot() {
      var that = this;
      this.showAllot = true;
      if (!this.headerData) {
        this.getHeadImg();
      }
      if (!this.code) {
        var qrcodeurl = "http://u.tenghuiwangxiao.cn/?ds_id=" + this.ds_id + "#/home/" + this.fans_id;
        var qrcoder = new _qrcoder2.default({
          data: qrcodeurl,
          size: 240
        });
        this.code = qrcoder.getDataURL();
      }
      if (!this.base64Img) {
        this.getBase64(this.initData.direct_seeding.pic_url);
      }
      console.log(this.canvas);
      if (!this.canvas) {
        var timer = setInterval(function () {
          if (that.headerData && that.code && that.base64Img) {
            clearInterval(timer);
            (0, _html2canvas2.default)(document.querySelector("#shareCard"), {
              useCORS: true,
              allowTaint: true,
              taintTest: true,
              backgroundColor: "transparent"
            }).then(function (canvas) {
              console.log(canvas);
              that.canvas = canvas.toDataURL("image/png");
              _toast2.default.clear();
            });
          }
        }, 100);
      }
    },
    onCloseAllot: function onCloseAllot() {
      this.showAllot = false;
    },
    getHeadImg: function getHeadImg() {
      var that = this;
      var option;
      _toast2.default.loading();
      option = "fans_id=" + this.fans_id;
      this.axios.post(_Tools2.default.baseUrl() + "/fans/invite/getImg", option).then(function (res) {
        that.headerData = res.data;
        console.log(that.headerData);
      }).catch(function (res) {
        console.log(res);
      });
    },
    getBase64: function getBase64(url) {
      var that = this;
      this.axios.post("http://plive.shikee.tv/fans/invite/shareCardImage", "url=" + encodeURIComponent(url)).then(function (data) {
        that.base64Img = data.data;
        console.log(that.base64Img);
        console.log(data.data);
      }).catch(function (res) {
        console.log(res);
      });
    },
    registerOk: function registerOk() {
      this.registerViewShow = false;
    },
    whiteNumOk: function whiteNumOk() {
      var _this25 = this;

      console.log("执行成功！！！！！！！！！！");
      this.TelTestShow = false;
      location.reload();
      //开启白名单 //地理位置上报
      this.isWeixinUserCheck(function (isSuccess) {
        isSuccess && _this25.getHeartMode();
      });
    },
    linkAccept: function linkAccept() {
      if (this.linkType === 1) {
        //申请连麦
        if (this.userConfig && this.userConfig.student_onekey_linkMic == 1) {
          _handleim2.default.studentOneKeyLinkMic(); //一键连麦
        } else {
          _handleim2.default.sendApplyLink();
        }
      } else if (this.linkType === 2) {
        //同意连麦
        if (this.businessConfigs && this.businessConfigs.student_enter_mp_classroom && _Tools2.default.isWeixinMP() && this.link_mic_jump == 1) {
          //在小程序小程序并且是开启进入小程序
          var navigateToUrl = "";

          if (this.channel_id) {
            navigateToUrl = "/pages/liveRoom/liveRoom?channel_id=" + (this.channel_id || '') + "&token=" + (this.fans.token || '') + "&autoLinkMic=1";
          } else {
            navigateToUrl = "/pages/liveRoom/liveRoom?ds_id=" + (this.ds_id || '') + "&token=" + (this.fans.token || '') + "&autoLinkMic=1";
          }
          console.log("navigateToUrl===", navigateToUrl);
          wx.miniProgram.redirectTo({ url: navigateToUrl });
          this.linkDialogVisible = false;
          return;
        }
        _handleim2.default.sendSureLink();
        //开始走连麦流程了
        this.$refs.tfPlayer.rtcLink();
      } else if (this.linkType === 3) {
        //结束连麦
        //走结束连麦流程
        this.$refs.tfPlayer.rtcLinkDown();
        this.linkType = 1;
      }
      this.linkDialogVisible = false;
    },
    linkRefuse: function linkRefuse() {
      console.log("拒绝连麦");
      if (this.linkType === 2) {
        _handleim2.default.sendRefuseLink();
      }
      this.linkDialogVisible = false;
    },
    linkLive: function linkLive(data) {
      if (this.initData.direct_seeding.play_style != 3) {
        return;
      }

      if (data.content == this.fans_id) {
        var canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
        if (!canLink) {
          _handleim2.default.sendCannotLink("1");
          return;
        }
        this.linkType = 2;
        this.linkDialogVisible = true;
      }
    },
    linkDown: function linkDown(data) {
      if (data.content == this.fans_id) {
        //需要下麦操作
        this.$refs.tfPlayer.rtcLinkDown();
      }
    },
    studentOneKeyLinkMicCB: function studentOneKeyLinkMicCB(data) {
      // 开始走连麦流程了
      if (this.initData.direct_seeding.play_style != 3) {
        return;
      }

      if (data.content == this.fans_id) {
        var canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
        if (!canLink) {
          //设备不支持
          return;
        }

        if (this.playerStatus != 2) {
          //没有播放视频
          return;
        }
        this.linkType = 2;
        //开始走连麦流程了
        this.$refs.tfPlayer.rtcLink();
      }
    },
    onkeyLinkMic: function onkeyLinkMic(data) {
      // 开始走连麦流程了
      if (this.initData.direct_seeding.play_style != 3) {
        return;
      }

      if (data.content == this.fans_id) {
        var canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
        if (!canLink) {
          //设备不支持
          _handleim2.default.sendCannotLink("1");
          return;
        }

        if (this.playerStatus != 2) {
          //没有播放视频
          _handleim2.default.sendCannotLink("2");
          return;
        }
        this.linkType = 2;
        //开始走连麦流程了
        this.$refs.tfPlayer.rtcLink();
      }
    },

    /**
     * 描述：展示“正在购买”提示
    **/
    showTipsByUserBuy: function showTipsByUserBuy() {
      var _this26 = this;

      if (this.saveUserBuyList.length > 0) {
        this.showBuyGoodsTips = true;
        var text = this.saveUserBuyList.length > 1 ? "\u7B49" + this.saveUserBuyList.length + "\u4EBA" : '';
        this.tipsBuyText = text + " \u6B63\u5728\u53BB\u8D2D\u4E70";
        this.tipsBuyUsername = this.saveUserBuyList[0];
        this.saveUserBuyList = [];
        this.tipsBuyTimer = setTimeout(function () {
          _this26.showBuyGoodsTips = false;
          if (_this26.tipsBuyTimer) {
            clearTimeout(_this26.tipsBuyTimer);
          }
          _this26.tipsBuyTimer = setTimeout(function () {
            _this26.showTipsByUserBuy();
          }, 300);
        }, 5000);
      } else {
        clearTimeout(this.tipsBuyTimer);
        this.tipsBuyTimer = null;
      }
    },

    /**
     * 描述：展示“购买成功”提示
    **/
    showTipsByUserBuySuccess: function showTipsByUserBuySuccess() {
      var _this27 = this;

      if (this.saveUserBuySuccessList.length > 0) {
        this.showBuySuccessGoodsTips = true;
        var text = this.saveUserBuySuccessList.length > 1 ? "\u7B49" + this.saveUserBuySuccessList.length + "\u4EBA" : '';
        this.tipsBuySuccessText = text + " \u8D2D\u4E70\u6210\u529F";
        this.tipsBuySuccessUsername = this.saveUserBuySuccessList[0];
        this.saveUserBuySuccessList = [];
        this.tipsBuySuccessTimer = setTimeout(function () {
          _this27.showBuySuccessGoodsTips = false;
          if (_this27.tipsBuySuccessTimer) {
            clearTimeout(_this27.tipsBuySuccessTimer);
          }
          _this27.tipsBuySuccessTimer = setTimeout(function () {
            _this27.showTipsByUserBuySuccess();
          }, 300);
        }, 5000);
      } else {
        clearTimeout(this.tipsBuySuccessTimer);
        this.tipsBuySuccessTimer = null;
      }
    },
    toGoodsDetailPage: function toGoodsDetailPage() {
      var _goodsInfo = this.goodsInfo,
          id = _goodsInfo.id,
          jump = _goodsInfo.jump,
          payurl = _goodsInfo.payurl;

      if (jump === 1) {
        window.open(payurl);
        return;
      }
      this.$router.push({ path: "/goodsDetail?id=" + id + "&uid=" + this.uid + "&channel_id=" + this.channel_id + "&dsId=" + this.ds_id });
    },
    hideShoppingPop: function hideShoppingPop() {
      localStorage.setItem('IS_SHOW_ShOPPING_CART', '1');
      this.showShoppingDialog = false;
    }
  }
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (type) {
  return {
    bind: function bind(el, binding, vnode) {
      if (!el[CONTEXT]) {
        el[CONTEXT] = {
          el: el,
          vm: vnode.context,
          cb: {}
        };
      }

      el[CONTEXT].cb[type] = binding.value;
      doCheckStartBind(el);
    },
    update: function update(el) {
      var context = el[CONTEXT];
      context.scrollEventListener && context.scrollEventListener();
    },
    unbind: function unbind(el) {
      var context = el[CONTEXT];

      if (context.scrollEventTarget) {
        (0, _event.off)(context.scrollEventTarget, 'scroll', context.scrollEventListener);
      }
    }
  };
};

var _event = __webpack_require__(12);

var _scroll = __webpack_require__(27);

/* eslint-disable no-underscore-dangle */
var CONTEXT = '@@Waterfall';
var OFFSET = 300; // 处理滚动函数

function handleScrollEvent() {
  var element = this.el;
  var scrollEventTarget = this.scrollEventTarget; // 已被禁止的滚动处理

  if (this.disabled) return;
  var targetScrollTop = (0, _scroll.getScrollTop)(scrollEventTarget);
  var targetVisibleHeight = (0, _scroll.getVisibleHeight)(scrollEventTarget); // 滚动元素可视区域下边沿到滚动元素元素最顶上 距离

  var targetBottom = targetScrollTop + targetVisibleHeight; // 如果无元素高度，考虑为元素隐藏，直接返回

  if (!targetVisibleHeight) return; // 判断是否到了底

  var needLoadMoreToLower = false;

  if (element === scrollEventTarget) {
    needLoadMoreToLower = scrollEventTarget.scrollHeight - targetBottom < this.offset;
  } else {
    var elementBottom = (0, _scroll.getElementTop)(element) - (0, _scroll.getElementTop)(scrollEventTarget) + (0, _scroll.getVisibleHeight)(element);
    needLoadMoreToLower = elementBottom - targetVisibleHeight < this.offset;
  }

  if (needLoadMoreToLower) {
    this.cb.lower && this.cb.lower({
      target: scrollEventTarget,
      top: targetScrollTop
    });
  } // 判断是否到了顶


  var needLoadMoreToUpper = false;

  if (element === scrollEventTarget) {
    needLoadMoreToUpper = targetScrollTop < this.offset;
  } else {
    var elementTop = (0, _scroll.getElementTop)(element) - (0, _scroll.getElementTop)(scrollEventTarget);
    needLoadMoreToUpper = elementTop + this.offset > 0;
  }

  if (needLoadMoreToUpper) {
    this.cb.upper && this.cb.upper({
      target: scrollEventTarget,
      top: targetScrollTop
    });
  }
} // 绑定事件到元素上
// 读取基本的控制变量


function doBindEvent() {
  var _this = this;

  if (this.el[CONTEXT].binded) {
    return;
  }

  this.el[CONTEXT].binded = true;
  this.scrollEventListener = handleScrollEvent.bind(this);
  this.scrollEventTarget = (0, _scroll.getScrollEventTarget)(this.el);
  var disabledExpr = this.el.getAttribute('waterfall-disabled');
  var disabled = false;

  if (disabledExpr) {
    this.vm.$watch(disabledExpr, function (value) {
      _this.disabled = value;

      _this.scrollEventListener();
    });
    disabled = Boolean(this.vm[disabledExpr]);
  }

  this.disabled = disabled;
  var offset = this.el.getAttribute('waterfall-offset');
  this.offset = Number(offset) || OFFSET;
  (0, _event.on)(this.scrollEventTarget, 'scroll', this.scrollEventListener, true);
  this.scrollEventListener();
} // 绑定事件


function startBind(el) {
  var context = el[CONTEXT];
  context.vm.$nextTick(function () {
    doBindEvent.call(el[CONTEXT]);
  });
} // 确认何时绑事件监听函数


function doCheckStartBind(el) {
  var context = el[CONTEXT];

  if (context.vm._isMounted) {
    startBind(el);
  } else {
    context.vm.$on('hook:mounted', function () {
      startBind(el);
    });
  }
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pickerProps = exports.pickerProps = {
  title: String,
  loading: Boolean,
  showToolbar: Boolean,
  cancelButtonText: String,
  confirmButtonText: String,
  visibleItemCount: {
    type: Number,
    "default": 5
  },
  itemHeight: {
    type: Number,
    "default": 44
  }
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deepClone = __webpack_require__(73);

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var DEFAULT_DURATION = 200;

var _use = (0, _utils.use)('picker-column'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    valueKey: String,
    className: String,
    itemHeight: Number,
    defaultIndex: Number,
    initialOptions: Array,
    visibleItemCount: Number
  },
  data: function data() {
    return {
      startY: 0,
      offset: 0,
      duration: 0,
      startOffset: 0,
      options: (0, _deepClone.deepClone)(this.initialOptions),
      currentIndex: this.defaultIndex
    };
  },
  created: function created() {
    this.$parent.children && this.$parent.children.push(this);
    this.setIndex(this.currentIndex);
  },
  destroyed: function destroyed() {
    var children = this.$parent.children;
    children && children.splice(children.indexOf(this), 1);
  },
  watch: {
    defaultIndex: function defaultIndex() {
      this.setIndex(this.defaultIndex);
    }
  },
  computed: {
    count: function count() {
      return this.options.length;
    }
  },
  methods: {
    onTouchStart: function onTouchStart(event) {
      this.startY = event.touches[0].clientY;
      this.startOffset = this.offset;
      this.duration = 0;
    },
    onTouchMove: function onTouchMove(event) {
      (0, _event.preventDefault)(event);
      var deltaY = event.touches[0].clientY - this.startY;
      this.offset = (0, _utils.range)(this.startOffset + deltaY, -(this.count * this.itemHeight), this.itemHeight);
    },
    onTouchEnd: function onTouchEnd() {
      if (this.offset !== this.startOffset) {
        this.duration = DEFAULT_DURATION;
        var index = (0, _utils.range)(Math.round(-this.offset / this.itemHeight), 0, this.count - 1);
        this.setIndex(index, true);
      }
    },
    adjustIndex: function adjustIndex(index) {
      index = (0, _utils.range)(index, 0, this.count);

      for (var i = index; i < this.count; i++) {
        if (!this.isDisabled(this.options[i])) return i;
      }

      for (var _i = index - 1; _i >= 0; _i--) {
        if (!this.isDisabled(this.options[_i])) return _i;
      }
    },
    isDisabled: function isDisabled(option) {
      return (0, _utils.isObj)(option) && option.disabled;
    },
    getOptionText: function getOptionText(option) {
      return (0, _utils.isObj)(option) && this.valueKey in option ? option[this.valueKey] : option;
    },
    setIndex: function setIndex(index, userAction) {
      index = this.adjustIndex(index) || 0;
      this.offset = -index * this.itemHeight;

      if (index !== this.currentIndex) {
        this.currentIndex = index;
        userAction && this.$emit('change', index);
      }
    },
    setValue: function setValue(value) {
      var options = this.options;

      for (var i = 0; i < options.length; i++) {
        if (this.getOptionText(options[i]) === value) {
          return this.setIndex(i);
        }
      }
    },
    getValue: function getValue() {
      return this.options[this.currentIndex];
    }
  },
  render: function render(h) {
    var _this = this;

    var itemHeight = this.itemHeight,
        visibleItemCount = this.visibleItemCount;
    var columnStyle = {
      height: itemHeight * visibleItemCount + 'px'
    };
    var baseOffset = itemHeight * (visibleItemCount - 1) / 2;
    var wrapperStyle = {
      transition: this.duration + "ms",
      transform: "translate3d(0, " + (this.offset + baseOffset) + "px, 0)",
      lineHeight: itemHeight + "px"
    };
    var optionStyle = {
      height: itemHeight + "px"
    };
    return h("div", {
      "style": columnStyle,
      "class": [bem(), this.className],
      "on": {
        "touchstart": this.onTouchStart,
        "touchmove": this.onTouchMove,
        "touchend": this.onTouchEnd,
        "touchcancel": this.onTouchEnd
      }
    }, [h("ul", {
      "style": wrapperStyle
    }, [this.options.map(function (option, index) {
      return h("li", {
        "style": optionStyle,
        "class": ['van-ellipsis', bem('item', {
          disabled: _this.isDisabled(option),
          selected: index === _this.currentIndex
        })],
        "domProps": {
          "innerHTML": _this.getOptionText(option)
        },
        "on": {
          "click": function click() {
            _this.setIndex(index, true);
          }
        }
      });
    })])]);
  }
});

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.raf = raf;
exports.cancel = cancel;

var _index = __webpack_require__(5);

var prev = Date.now();
/* istanbul ignore next */

/**
 * requestAnimationFrame polyfill
 */
function fallback(fn) {
  var curr = Date.now();
  var ms = Math.max(0, 16 - (curr - prev));
  var id = setTimeout(fn, ms);
  prev = curr + ms;
  return id;
}
/* istanbul ignore next */

var root = _index.isServer ? global : window;
/* istanbul ignore next */

var iRaf = root.requestAnimationFrame || fallback;
/* istanbul ignore next */

var iCancel = root.cancelAnimationFrame || root.clearTimeout;
function raf(fn) {
  return iRaf.call(root, fn);
}
function cancel(id) {
  iCancel.call(root, id);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _popup = __webpack_require__(30);

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('dialog'),
    sfc = _use[0],
    bem = _use[1],
    t = _use[2];

exports.default = sfc({
  mixins: [_popup.PopupMixin],
  props: {
    title: String,
    message: String,
    className: null,
    callback: Function,
    beforeClose: Function,
    messageAlign: String,
    cancelButtonText: String,
    cancelButtonColor: String,
    confirmButtonText: String,
    confirmButtonColor: String,
    showCancelButton: Boolean,
    showConfirmButton: {
      type: Boolean,
      "default": true
    },
    overlay: {
      type: Boolean,
      "default": true
    },
    closeOnClickOverlay: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      loading: {
        confirm: false,
        cancel: false
      }
    };
  },
  methods: {
    onClickOverlay: function onClickOverlay() {
      this.handleAction('overlay');
    },
    handleAction: function handleAction(action) {
      var _this = this;

      this.$emit(action);

      if (this.beforeClose) {
        this.loading[action] = true;
        this.beforeClose(action, function (state) {
          if (state !== false) {
            _this.onClose(action);
          }

          _this.loading[action] = false;
        });
      } else {
        this.onClose(action);
      }
    },
    onClose: function onClose(action) {
      this.close();

      if (this.callback) {
        this.callback(action);
      }
    }
  },
  render: function render(h) {
    var _bem,
        _this2 = this;

    if (!this.shouldRender) {
      return;
    }

    var title = this.title,
        message = this.message,
        messageAlign = this.messageAlign;
    var children = this.slots();
    var Title = title && h("div", {
      "class": bem('header', {
        isolated: !message && !children
      })
    }, [title]);
    var Content = (children || message) && h("div", {
      "class": bem('content')
    }, [children || h("div", {
      "domProps": {
        "innerHTML": message
      },
      "class": bem('message', (_bem = {
        'has-title': title
      }, _bem[messageAlign] = messageAlign, _bem))
    })]);
    var hasButtons = this.showCancelButton && this.showConfirmButton;
    var ButtonGroup = h("div", {
      "class": ['van-hairline--top', bem('footer', {
        buttons: hasButtons
      })]
    }, [this.showCancelButton && h(_button2.default, {
      "attrs": {
        "size": "large",
        "loading": this.loading.cancel,
        "text": this.cancelButtonText || t('cancel')
      },
      "class": bem('cancel'),
      "style": {
        color: this.cancelButtonColor
      },
      "on": {
        "click": function click() {
          _this2.handleAction('cancel');
        }
      }
    }), this.showConfirmButton && h(_button2.default, {
      "attrs": {
        "size": "large",
        "loading": this.loading.confirm,
        "text": this.confirmButtonText || t('confirm')
      },
      "class": [bem('confirm'), {
        'van-hairline--left': hasButtons
      }],
      "style": {
        color: this.confirmButtonColor
      },
      "on": {
        "click": function click() {
          _this2.handleAction('confirm');
        }
      }
    })]);
    return h("transition", {
      "attrs": {
        "name": "van-dialog-bounce"
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.value
      }],
      "class": [bem(), this.className]
    }, [Title, Content, ButtonGroup])]);
  }
});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-swipe{overflow:hidden;position:relative;-webkit-user-select:none;user-select:none}.van-swipe__track{height:100%}.van-swipe__indicators{display:-webkit-box;display:-webkit-flex;display:flex;position:absolute;left:50%;bottom:10px;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.van-swipe__indicators--vertical{left:10px;top:50%;bottom:auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-swipe__indicators--vertical .van-swipe__indicator:not(:last-child){margin-bottom:6px}.van-swipe__indicator{border-radius:100%;opacity:.3;width:6px;height:6px;background-color:#ebedf0;-webkit-transition:opacity .2s;transition:opacity .2s}.van-swipe__indicator:not(:last-child){margin-right:6px}.van-swipe__indicator--active{opacity:1;background-color:#1989fa}", ""]);

// exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-swipe-item{float:left;height:100%}", ""]);

// exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(197);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-picker{overflow:hidden;-webkit-user-select:none;user-select:none;position:relative;background-color:#fff;-webkit-text-size-adjust:100%}.van-picker__toolbar{display:-webkit-box;display:-webkit-flex;display:flex;height:44px;line-height:44px;-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.van-picker__cancel,.van-picker__confirm{color:#1989fa;padding:0 15px;font-size:14px}.van-picker__cancel:active,.van-picker__confirm:active{background-color:#f2f3f5}.van-picker__title{max-width:50%;font-size:16px;font-weight:500;text-align:center}.van-picker__columns{display:-webkit-box;display:-webkit-flex;display:flex;position:relative}.van-picker__loading{top:0;left:0;right:0;bottom:0;z-index:2;position:absolute;background-color:hsla(0,0%,100%,.9)}.van-picker__loading circle{stroke:#1989fa}.van-picker__frame,.van-picker__loading .van-loading{top:50%;left:0;width:100%;z-index:1;position:absolute;pointer-events:none;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.van-picker-column{-webkit-box-flex:1;-webkit-flex:1;flex:1;overflow:hidden;font-size:16px;text-align:center}.van-picker-column__item{padding:0 5px;color:#969799}.van-picker-column__item--selected{font-weight:500;color:#323233}.van-picker-column__item--disabled{opacity:.3}", ""]);

// exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(199);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-radio{overflow:hidden;-webkit-user-select:none;user-select:none}.van-radio__icon,.van-radio__label{display:inline-block;vertical-align:middle;line-height:20px}.van-radio__icon{height:20px}.van-radio__icon .van-icon{font-size:14px;color:transparent;text-align:center;line-height:inherit;width:20px;height:20px;box-sizing:border-box;border:1px solid #e5e5e5;-webkit-transition:.2s;transition:.2s}.van-radio__icon--round .van-icon{border-radius:100%}.van-radio__icon--checked .van-icon{color:#fff;border-color:#1989fa;background-color:#1989fa}.van-radio__icon--disabled .van-icon{border-color:#c8c9cc;background-color:#ebedf0}.van-radio__icon--disabled.van-radio__icon--checked .van-icon{color:#c8c9cc}.van-radio__label{color:#323233;margin-left:10px}.van-radio__label--left{float:left;margin:0 10px 0 0}.van-radio__label--disabled{color:#c8c9cc}", ""]);

// exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(201);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-tab{-webkit-box-flex:1;-webkit-flex:1;flex:1;cursor:pointer;min-width:0;padding:0 5px;font-size:14px;position:relative;color:#7d7e80;line-height:44px;text-align:center;box-sizing:border-box}.van-tab span{display:block}.van-tab--active{font-weight:500;color:#323233}.van-tab--disabled{color:#c8c9cc}.van-tabs{position:relative}.van-tabs__wrap{top:0;left:0;right:0;z-index:99;overflow:hidden;position:absolute}.van-tabs__wrap--page-top{position:fixed}.van-tabs__wrap--content-bottom{top:auto;bottom:0}.van-tabs__wrap--scrollable .van-tab{-webkit-box-flex:0;-webkit-flex:0 0 22%;flex:0 0 22%}.van-tabs__wrap--scrollable .van-tab--complete{-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto}.van-tabs__wrap--scrollable .van-tabs__nav{overflow:hidden;overflow-x:auto;-webkit-overflow-scrolling:touch}.van-tabs__wrap--scrollable .van-tabs__nav::-webkit-scrollbar{display:none}.van-tabs__nav{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-user-select:none;user-select:none;position:relative;background-color:#fff}.van-tabs__nav--line{height:100%;padding-bottom:15px;box-sizing:content-box}.van-tabs__nav--card{margin:0 15px;border-radius:2px;box-sizing:border-box;border:1px solid #f44;height:30px}.van-tabs__nav--card .van-tab{color:#f44;border-right:1px solid #f44;line-height:28px}.van-tabs__nav--card .van-tab:last-child{border-right:none}.van-tabs__nav--card .van-tab.van-tab--active{color:#fff;background-color:#f44}.van-tabs__nav--card .van-tab--disabled{color:#c8c9cc}.van-tabs__line{z-index:1;left:0;bottom:15px;height:3px;position:absolute;border-radius:3px;background-color:#f44}.van-tabs__content--animated{overflow:hidden}.van-tabs__track{position:relative;display:-webkit-box;display:-webkit-flex;display:flex;width:100%;height:100%;will-change:left}.van-tabs--line{padding-top:44px}.van-tabs--line .van-tabs__wrap{height:44px}.van-tabs--card{padding-top:30px}.van-tabs--card>.van-tabs__wrap{height:30px}.van-tabs .van-tab__pane{width:100%;-webkit-flex-shrink:0;flex-shrink:0;box-sizing:border-box}", ""]);

// exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(203);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes van-notice-bar-play{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-notice-bar-play{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes van-notice-bar-play-infinite{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes van-notice-bar-play-infinite{to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.van-notice-bar{display:-webkit-box;display:-webkit-flex;display:flex;height:40px;padding:0 15px;font-size:14px;line-height:24px;position:relative;-webkit-box-align:center;-webkit-align-items:center;align-items:center;color:#ed6a0c;background-color:#fffbe8}.van-notice-bar__left-icon{font-size:16px;min-width:22px}.van-notice-bar__right-icon{top:50%;right:15px;font-size:16px;position:absolute;margin-top:-.5em}.van-notice-bar__wrap{-webkit-box-flex:1;-webkit-flex:1;flex:1;height:24px;overflow:hidden;position:relative}.van-notice-bar__content{position:absolute;white-space:nowrap}.van-notice-bar__content.van-ellipsis{max-width:100%}.van-notice-bar__play{-webkit-animation:van-notice-bar-play linear both;animation:van-notice-bar-play linear both}.van-notice-bar__play--infinite{-webkit-animation:van-notice-bar-play-infinite linear infinite both;animation:van-notice-bar-play-infinite linear infinite both}.van-notice-bar--wrapable{height:auto;padding:8px 15px}.van-notice-bar--wrapable .van-notice-bar__wrap{height:auto}.van-notice-bar--wrapable .van-notice-bar__content{position:relative;white-space:normal}.van-notice-bar--withicon{position:relative;padding-right:40px}", ""]);

// exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(205);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-dialog{position:fixed;top:50%;left:50%;overflow:hidden;width:85%;font-size:16px;-webkit-transition:.3s;transition:.3s;border-radius:4px;background-color:#fff;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.van-dialog__header{text-align:center;font-weight:500;padding-top:25px}.van-dialog__header--isolated{padding:25px 0}.van-dialog__message{padding:25px;font-size:14px;line-height:1.5;max-height:60vh;overflow-y:auto;text-align:center;-webkit-overflow-scrolling:touch;white-space:pre-wrap}.van-dialog__message--has-title{color:#7d7e80;padding-top:12px}.van-dialog__message--left{text-align:left}.van-dialog__message--right{text-align:right}.van-dialog__footer{overflow:hidden;-webkit-user-select:none;user-select:none}.van-dialog__footer--buttons{display:-webkit-box;display:-webkit-flex;display:flex}.van-dialog__footer--buttons .van-button{-webkit-box-flex:1;-webkit-flex:1;flex:1}.van-dialog .van-button{border:0}.van-dialog__confirm,.van-dialog__confirm:active{color:#1989fa}.van-dialog-bounce-enter{opacity:0;-webkit-transform:translate3d(-50%,-50%,0) scale(.7);transform:translate3d(-50%,-50%,0) scale(.7)}.van-dialog-bounce-leave-active{opacity:0;-webkit-transform:translate3d(-50%,-50%,0) scale(.9);transform:translate3d(-50%,-50%,0) scale(.9)}", ""]);

// exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nimWebSdk = __webpack_require__(207);

var _nimWebSdk2 = _interopRequireDefault(_nimWebSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  loginIM: loginIM,
  logout: logout,
  loginYunXinChatRoom: loginYunXinChatRoom,
  sendTextMsg: sendTextMsg,
  onSendP2PMsg: onSendP2PMsg,
  setMsgListener: setMsgListener,
  setImStatusListener: setImStatusListener,
  setMemberMsgListener: setMemberMsgListener
};


var nim = null;
var chatroom = null;
var loginUserInfo = {};

// 设置监听
var imStatusListener;
function setImStatusListener(cb) {
  imStatusListener = cb;
}

var imMsgListener;
function setMsgListener(cb) {
  imMsgListener = cb;
}

var memberMsgListener;
function setMemberMsgListener(cb) {
  memberMsgListener = cb;
}
// appKey: data.appKey,
// account: data.fans_id,
// token: data.token,
// chatroomId: data.chatroomId,
// chatroomAddresses: data.address,
// quickReconnect: true,
// tags: data.tags,

function loginIM(data) {
  console.error('loginIM2222=', data);
  loginUserInfo = data;
  nim = _nimWebSdk2.default.NIM.getInstance({
    debug: false, // 是否开启日志，将其打印到console。集成开发阶段建议打开。
    appKey: data.appKey,
    account: data.fans_id,
    token: data.yxToken,
    authType: 1,
    db: true, // 若不要开启数据库请设置false。SDK默认为true。
    // privateConf: {}, // 私有化部署方案所需的配置
    onconnect: onConnect,
    onwillreconnect: onWillReconnect,
    ondisconnect: onDisconnect,
    onsyncdone: onSyncdone,
    onerror: onError,
    onmsg: function onmsg(msg) {
      console.error('私聊消息', msg);
      if (msg.text) {
        memberMsgListener && memberMsgListener(JSON.parse(msg.text));
      }
    }
  });
  // nim.setOptions({token:data.yxToken})
}

function logout() {
  if (nim) {
    nim.logout();
  }
  if (chatroom) {
    chatroom.logout();
  }
}

// IM 回调
function getChatroomAddressDone(error, obj) {
  console.log('获取聊天室地址' + (!error ? '成功' : '失败'), error, obj);

  // 非匿名方式登录
  if (!error) {
    console.error('loginUserInfo', loginUserInfo);
    chatroom = _nimWebSdk2.default.Chatroom.getInstance({
      appKey: loginUserInfo.appKey,
      account: loginUserInfo.fans_id,
      token: loginUserInfo.yxToken,
      loginAuthType: 1,
      chatroomId: loginUserInfo.chatroomId,
      chatroomAddresses: obj.address,
      tags: loginUserInfo.tags,
      chatroomEnterCustom: '{"header":"' + loginUserInfo.header + '"}',
      notifyTargetTags: '{"tag": ".*", "matchType": "regex"}',
      chatroomCustom: JSON.stringify(loginUserInfo.custom),
      onconnect: function onconnect(obj) {
        console.log('进入聊天室', obj);
        try {
          imMsgListener && imMsgListener({
            module: 'system_message_group_introduction',
            content: JSON.parse(obj.chatroom.custom)
          });
        } catch (error) {}
      },
      onerror: function onerror(error1) {
        console.log('发生错误', error1);
      },
      onwillreconnect: function onwillreconnect(error1) {
        console.log('即将重连', error1);
      },
      ondisconnect: function ondisconnect(error1) {
        if (error1) {
          switch (error1.code) {
            // 账号或者密码错误, 请跳转到登录页面并提示错误
            case 302:
              break;
            // 被踢, 请提示错误后跳转到登录页面
            case 'kicked':
              if (imStatusListener) {
                imStatusListener({ 'error': 'kicked' });
              }
              break;
            default:
              break;
          }
        }
      },
      // 消息
      onmsgs: function onmsgs(msgs) {
        console.log('收到聊天室消息', msgs);
        for (var index = 0; index < msgs.length; index++) {
          var element = msgs[index];
          if (element.type === 'text' && element.text) {
            imMsgListener && imMsgListener(JSON.parse(element.text), element);
          } else if (element.type === 'notification') {
            if (element.attach.type === 'updateChatroom') {
              getChatroomInfo();
            }
          }
        }
      },
      // 用户标签更新
      onTagsUpdate: function onTagsUpdate(Tags) {
        console.log('收到更新的标签', Tags);
      }
    });
    // chatroom.setOptions({
    //   token: loginUserInfo.yxToken
    // });
  }
}

// 获取聊天室信息
function getChatroomInfo() {
  if (chatroom) {
    chatroom.getChatroom({
      done: function done(error, obj) {
        console.log('获取聊天室信息' + (!error ? '成功' : '失败'), error, obj);
        if (!error) {
          try {
            imMsgListener && imMsgListener({
              module: 'system_message_group_introduction',
              content: JSON.parse(obj.chatroom.custom)
            });
          } catch (error) {}
        }
      }
    });
  }
}

function loginYunXinChatRoom(data) {
  chatroom = _nimWebSdk2.default.Chatroom.getInstance({
    debug: false,
    appKey: data.appKey,
    account: data.fans_id,
    token: data.yxToken,
    loginAuthType: 1,
    chatroomId: data.chatroomId,
    chatroomAddresses: data.address,
    quickReconnect: true,
    notifyTargetTags: '{"tag": ".*", "matchType": "regex"}',
    tags: data.tags,
    chatroomEnterCustom: '{"header":"' + data.header + '"}',
    chatroomCustom: JSON.stringify(data.custom),
    onconnect: function onconnect(obj) {
      console.log('================ 进入聊天室', obj);
      // if (ImLogListener) {
      //   ImLogListener('云信进入聊天室', obj)
      // }
    },
    onerror: function onerror(error, obj) {
      console.log('================ 聊天室发生错误', error, obj);
      // if (ImLogListener) {
      //   ImLogListener('云信聊天室发生错误', error)
      // }
      // if (ImNoConnectListener) {
      //   ImNoConnectListener()
      // }
    },
    onwillreconnect: function onwillreconnect(obj) {
      // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
      console.log('================= 聊天室即将重连', obj);
      // if (ImLogListener) {
      //   netChecker()
      //   ImLogListener('云信聊天室即将重连', obj)
      // }
    },
    ondisconnect: function ondisconnect(error) {
      console.log('================== 聊天室连接断开', error);
      // if (ImLogListener) {
      //   netChecker()
      //   ImLogListener('云信聊天室连接断开', error)
      // }

      if (error) {
        switch (error.code) {
          // 账号或者密码错误, 请跳转到登录页面并提示错误
          // case 302:
          //   break
          // 被踢, 请提示错误后跳转到登录页面
          case 'kicked':
            if (imStatusListener) {
              imStatusListener({ 'error': 'kicked' });
            }
            break;
          default:
            if (imStatusListener) {
              imStatusListener({ 'error': 'noconnect' });
            }
            break;
        }
      }
    },
    // 消息
    onmsgs: function onmsgs(msgs) {
      console.log('================= 收到聊天室消息', msgs);
    }
  });

  // chatroom.setOptions({
  //   token: data.yxToken
  // });
}

// function getChatroomMembersDone (error, obj) { // 获取聊天室列表
//   console.log('获取聊天室成员' + (!error ? '成功' : '失败'), error, obj.members)
// }

// function getChatroomMembers () {
//   chatroom.getChatroomMembers({
//     guest: true,
//     limit: 100,
//     done: getChatroomMembersDone
//   })
// }

function onConnect() {
  console.log('连接成功');
}

function onSyncdone() {
  console.log('初始化同步完成的回调');
  nim.getChatroomAddress({
    chatroomId: loginUserInfo.chatroomId,
    done: getChatroomAddressDone
  });
}

function onWillReconnect(obj) {
  // 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
  console.log('即将重连');
  console.log(obj.retryCount);
  console.log(obj.duration);
}

function onDisconnect(error) {
  // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
  console.log('丢失连接');
  console.log(error);
  if (error) {
    switch (error.code) {
      // 账号或者密码错误, 请跳转到登录页面并提示错误
      case 302:
        break;
      // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
      case 417:
        break;
      // 被踢, 请提示错误后跳转到登录页面
      case 'kicked':
        if (imStatusListener) {
          imStatusListener({ 'error': 'kicked' });
        }
        break;
      default:
        break;
    }
  }
}
function onError(error) {
  console.log('错误IM', error);
}
// 发送私聊消息
function onSendP2PMsg(text, fansId) {
  nim.sendText({
    scene: 'p2p',
    to: '' + fansId,
    text: text,
    done: function done() {
      console.log('发送私聊消息成功');
    }
  });
}

// 发送消息
function sendTextMsg(text) {
  var text = JSON.stringify(text);
  chatroom.sendText({
    text: text,
    done: function done() {
      console.log('发送陈宫');
    }
  });
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*!
 * 
 * VERSION: 9.11.0
 * Git Hash: a84f700ec8976b6d2b9dbf8fe2912c258aff0916
 * 
 * Create At: 2023/5/26 下午3:40:38
 * 
 * Target: NIM_Web_SDK
 */!function(e,t){"object"==( false?"undefined":_typeof(exports))&&"object"==( false?"undefined":_typeof(module))?module.exports=t(): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==(typeof exports==="undefined"?"undefined":_typeof(exports))?exports.SDK=t():e.SDK=t();}(window,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports;}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e){n.d(r,o,function(t){return e[t];}.bind(null,o));}return r;},n.n=function(e){var t=e&&e.__esModule?function(){return e.default;}:function(){return e;};return n.d(t,"a",t),t;},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t);},n.p="",n(n.s=832);}([function(e,t,n){var r=n(58),o=n(2),i=n(4),s=n(16),a=n(5),c=n(158),u=n(88),l=n(127),m=n(30),p=n(9),d=n(7),f=n(10),g=n(180),h=n(128),y=n(27),v=n(17),b=n(445),T=n(3),S=n(102),M=n(103),k=n(72),x=n(59),C=n(60),I=n(61),_=n(62),w=n(46),P=n(22);function A(e,t){var n=a(e);if(x){var r=x(e);t&&(r=v(r).call(r,function(t){return C(e,t).enumerable;})),n.push.apply(n,r);}return n;}function O(e,t){var _n=void 0!==M&&k(e)||e["@@iterator"];if(!_n){if(m(e)||(_n=function(e,t){var n;if(!e)return;if("string"==typeof e)return E(e,t);var r=s(n=Object.prototype.toString.call(e)).call(n,8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return S(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return E(e,t);}(e))||t&&e&&"number"==typeof e.length){_n&&(e=_n);var r=0,o=function o(){};return{s:o,n:function n(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]};},e:function e(_e){throw _e;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var i,a=!0,c=!1;return{s:function s(){_n=_n.call(e);},n:function n(){var e=_n.next();return a=e.done,e;},e:function e(_e2){c=!0,i=_e2;},f:function f(){try{a||null==_n.return||_n.return();}finally{if(c)throw i;}}};}function E(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++){r[n]=e[n];}return r;}var R=n(242),j=n(181);function N(e){"object"===P(e)?(this.callFunc=e.callFunc||null,this.message=e.message||"UNKNOW ERROR"):this.message=e,this.time=new Date(),this.timetag=+this.time;}n(468);var U,D,L=n(47),F=L.getGlobal(),B=/\s+/;L.deduplicate=function(e){var t=[];return o(e).call(e,function(e){-1===i(t).call(t,e)&&t.push(e);}),t;},L.capFirstLetter=function(e){return e?s(e=""+e).call(e,0,1).toUpperCase()+s(e).call(e,1):"";},L.guid=(U=function U(){return(65536*(1+Math.random())|0).toString(16).substring(1);},function(){return U()+U()+U()+U()+U()+U()+U()+U();}),L.extend=function(e,t,n){for(var r in t){void 0!==e[r]&&!0!==n||(e[r]=t[r]);}},L.filterObj=function(e,t){var n={};return L.isString(t)&&(t=t.split(B)),o(t).call(t,function(t){e.hasOwnProperty(t)&&(n[t]=e[t]);}),n;},L.copy=function(e,t){var n;return t=t||{},e?(o(n=a(e)).call(n,function(n){L.exist(e[n])&&(t[n]=e[n]);}),t):t;},L.copyWithNull=function(e,t){var n;return t=t||{},e?(o(n=a(e)).call(n,function(n){(L.exist(e[n])||L.isnull(e[n]))&&(t[n]=e[n]);}),t):t;},L.findObjIndexInArray=function(e,t){e=e||[];var n=t.keyPath||"id",r=-1;return c(e).call(e,function(e,o){if(j(e,n)===t.value)return r=o,!0;}),r;},L.findObjInArray=function(e,t){var n=L.findObjIndexInArray(e,t);return-1===n?null:e[n];},L.mergeObjArray=function(){var e=[],t=s([]).call(arguments,0,-1),n=arguments[arguments.length-1];L.isArray(n)&&(t.push(n),n={});var r,i=n.keyPath=n.keyPath||"id";for(n.sortPath=n.sortPath||i;!e.length&&t.length;){e=t.shift()||[],e=s(e).call(e,0);}return o(t).call(t,function(t){t&&o(t).call(t,function(t){-1!==(r=L.findObjIndexInArray(e,{keyPath:i,value:j(t,i)}))?e[r]=L.merge({},e[r],t):e.push(t);});}),n.notSort||(e=L.sortObjArray(e,n)),e;},L.cutObjArray=function(e){var t=s(e).call(e,0),n=arguments.length,r=s([]).call(arguments,1,n-1),i=arguments[n-1];L.isObject(i)||(r.push(i),i={});var a,c=i.keyPath=i.keyPath||"id";return o(r).call(r,function(e){L.isArray(e)||(e=[e]),o(e).call(e,function(e){e&&(i.value=j(e,c),-1!==(a=L.findObjIndexInArray(t,i))&&u(t).call(t,a,1));});}),t;},L.sortObjArray=function(e,t){var n=(t=t||{}).sortPath||"id";R.insensitive=!!t.insensitive;var r,o,i,s=!!t.desc;return i=L.isFunction(t.compare)?t.compare:function(e,t){return r=j(e,n),o=j(t,n),s?R(o,r):R(r,o);},l(e).call(e,i);},L.emptyFunc=function(){},L.isEmptyFunc=function(e){return e===L.emptyFunc;},L.notEmptyFunc=function(e){return e!==L.emptyFunc;},L.splice=function(e,t,n){return u([]).call(e,t,n);},L.reshape2d=function(e,t){if(m(e)){L.verifyParamType("type",t,"number","util::reshape2d");var n=e.length;if(n<=t)return[e];for(var r=Math.ceil(n/t),o=[],i=0;i<r;i++){o.push(s(e).call(e,i*t,(i+1)*t));}return o;}return e;},L.flatten2d=function(e){if(m(e)){var t=[];return o(e).call(e,function(e){t=p(t).call(t,e);}),t;}return e;},L.dropArrayDuplicates=function(e){if(m(e)){for(var t={},n=[];e.length>0;){t[e.shift()]=!0;}for(var r in t){!0===t[r]&&n.push(r);}return n;}return e;},L.onError=function(e){throw new N(e);},L.verifyParamPresent=function(e,t,n,r){n=n||"";var o=!1;switch(L.typeOf(t)){case"undefined":case"null":o=!0;break;case"string":""===t&&(o=!0);break;case"StrStrMap":case"object":a(t).length||(o=!0);break;case"array":t.length?c(t).call(t,function(e){if(L.notexist(e))return o=!0,!0;}):o=!0;}o&&L.onParamAbsent(n+e,r);},L.onParamAbsent=function(e,t){L.onParamError("缺少参数 ".concat(e,", 请确保参数不是 空字符串、空对象、空数组、null或undefined, 或数组的内容不是 null/undefined"),t);},L.verifyParamAbsent=function(e,t,n,r){n=n||"",void 0!==t&&L.onParamPresent(n+e,r);},L.onParamPresent=function(e,t){L.onParamError("多余的参数 ".concat(e),t);},L.verifyParamType=function(e,t,n,r){var o=L.typeOf(t).toLowerCase();L.isArray(n)||(n=[n]),n=d(n).call(n,function(e){return e.toLowerCase();});var s=!0;switch(-1===i(n).call(n,o)&&(s=!1),o){case"number":isNaN(t)&&(s=!1);break;case"string":"numeric or numeric string"===n.join("")&&(s=!!/^[0-9]+$/.test(t));}s||L.onParamInvalidType(e,n,"",r);},L.onParamInvalidType=function(e,t,n,r){n=n||"",t=L.isArray(t)?(t=d(t).call(t,function(e){return'"'+e+'"';})).join(", "):'"'+t+'"',L.onParamError('参数"'+n+e+'"类型错误, 合法的类型包括: ['+t+"]",r);},L.verifyParamValid=function(e,t,n,r){L.isArray(n)||(n=[n]),-1===i(n).call(n,t)&&L.onParamInvalidValue(e,n,r);},L.onParamInvalidValue=function(e,t,n){var r;L.isArray(t)||(t=[t]),t=d(t).call(t,function(e){return'"'+e+'"';}),L.isArray(t)&&(t=t.join(", ")),L.onParamError(p(r="参数 ".concat(e,"值错误, 合法的值包括: [")).call(r,f(t),"]"),n);},L.verifyParamMin=function(e,t,n,r){t<n&&L.onParamError("参数"+e+"的值不能小于"+n,r);},L.verifyParamMax=function(e,t,n,r){t>n&&L.onParamError("参数"+e+"的值不能大于"+n,r);},L.verifyArrayMax=function(e,t,n,r){t.length>n&&L.onParamError("参数"+e+"的长度不能大于"+n,r);},L.verifyEmail=(D=/^\S+@\S+$/,function(e,t,n){D.test(t)||L.onParamError("参数"+e+"邮箱格式错误, 合法格式必须包含@符号, @符号前后至少要各有一个字符",n);}),L.verifyTel=function(){var e=/^[+\-()\d]+$/;return function(t,n,r){e.test(n)||L.onParamError("参数"+t+"电话号码格式错误, 合法字符包括+、-、英文括号和数字",r);};}(),L.verifyBirth=function(){var e=/^(\d{4})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;return function(t,n,r){e.test(n)||L.onParamError("参数"+t+'生日格式错误, 合法为"yyyy-MM-dd"',r);};}(),L.onParamError=function(e,t){L.onError({message:e,callFunc:t});},L.verifyOptions=function(e,t,n,r,i){if(e=e||{},t&&(L.isString(t)&&(t=t.split(B)),L.isArray(t))){"boolean"!=typeof n&&(i=n||null,n=!0,r="");var s=n?L.verifyParamPresent:L.verifyParamAbsent;o(t).call(t,function(t){s.call(L,t,e[t],r,i);});}return e;},L.verifyParamAtLeastPresentOne=function(e,t,n){t&&(L.isString(t)&&(t=t.split(B)),L.isArray(t)&&(c(t).call(t,function(t){return L.exist(e[t]);})||L.onParamError("以下参数["+t.join(", ")+"]至少需要传入一个",n)));},L.verifyParamPresentJustOne=function(e,t,n){t&&(L.isString(t)&&(t=t.split(B)),L.isArray(t)&&1!==g(t).call(t,function(t,n){return L.exist(e[n])&&t++,t;},0)&&L.onParamError("以下参数["+t.join(", ")+"]必须且只能传入一个",n));},L.verifyBooleanWithDefault=function(e,t,n,r,i){L.undef(n)&&(n=!0),B.test(t)&&(t=t.split(B)),L.isArray(t)?o(t).call(t,function(t){L.verifyBooleanWithDefault(e,t,n,r,i);}):void 0===e[t]?e[t]=n:L.isBoolean(e[t])||L.onParamInvalidType(t,"boolean",r,i);},L.verifyFileInput=function(e,t){var n;(L.verifyParamPresent("fileInput",e,"",t),L.isString(e)&&((e="undefined"==typeof document?void 0:document.getElementById(e))||L.onParamError("找不到要上传的文件对应的input, 请检查fileInput id ".concat(e),t)),e.tagName&&"input"===e.tagName.toLowerCase()&&"file"===e.type.toLowerCase())||L.onParamError(p(n="请提供正确的 fileInput, 必须为 file 类型的 input 节点 tagname:".concat(e.tagName,", filetype:")).call(n,e.type),t);return e;},L.verifyFileType=function(e,t){L.verifyParamValid("type",e,L.validFileTypes,t);},L.verifyCallback=function(e,t,n){B.test(t)&&(t=t.split(B)),L.isArray(t)?o(t).call(t,function(t){L.verifyCallback(e,t,n);}):e[t]?L.isFunction(e[t])||L.onParamInvalidType(t,"function","",n):e[t]=L.emptyFunc;},L.verifyFileUploadCallback=function(e,t){L.verifyCallback(e,"uploadprogress uploaddone uploaderror uploadcancel",t);},L.validFileTypes=["image","audio","video","file"],L.validFileExts={image:["bmp","gif","jpg","jpeg","jng","png","webp"],audio:["mp3","wav","aac","wma","wmv","amr","mp2","flac","vorbis","ac3"],video:["mp4","rm","rmvb","wmv","avi","mpg","mpeg","mov"]},L.filterFiles=function(e,t){var n,r,a="file"===(t=t.toLowerCase()),c=[];return o([]).call(e,function(e){var o,u;if(a)c.push(e);else if(n=s(o=e.name).call(o,h(u=e.name).call(u,".")+1),(r=e.type.split("/"))[0]&&r[1]){var l,m=!1;if(r[0].toLowerCase()===t)m=!0;else m=-1!==i(l=L.validFileExts[t]).call(l,n);m&&c.push(e);}}),c;};var q,H,z=L.supportFormData=L.notundef(F.FormData);L.getFileName=function(e){return e=L.verifyFileInput(e),z?e.files[0].name:s(t=e.value).call(t,h(n=e.value).call(n,"\\")+1);var t,n;},L.getFileInfo=(q={ppt:1,pptx:2,pdf:3,doc:6,docx:7},function(e){var t={};if(!(e=L.verifyFileInput(e)).files)return t;var n=e.files[0];return z&&(t.name=n.name,t.size=n.size,t.type=n.name.match(/\.(\w+)$/),t.type=t.type&&t.type[1].toLowerCase(),t.transcodeType=q[t.type]||0),t;}),L.sizeText=(H=["B","KB","MB","GB","TB","PB","EB","ZB","BB"],function(e){var t,n=0;do{t=(e=Math.floor(100*e)/100)+H[n],e/=1024,n++;}while(e>1);return t;}),L.promises2cmds=function(e){return d(e).call(e,function(e){return e.cmd;});},L.objs2accounts=function(e){return d(e).call(e,function(e){return e.account;});},L.teams2ids=function(e){return d(e).call(e,function(e){return e.teamId;});},L.objs2ids=function(e){return d(e).call(e,function(e){return e.id;});},L.getMaxUpdateTime=function(e){var t=d(e).call(e,function(e){return+e.updateTime;});return Math.max.apply(Math,t);},L.genCheckUniqueFunc=function(e){return e=e||"id",function(t){this.uniqueSet=this.uniqueSet||{},this.uniqueSet[e]=this.uniqueSet[e]||{};var n=this.uniqueSet[e],r=t[e];return!n[r]&&(n[r]=!0,!0);};},L.fillPropertyWithDefault=function(e,t,n){return!!L.undef(e[t])&&(e[t]=n,!0);},L.throttle=function(e,t,n,r){var o,i,s=null,a=0;n||(n={});var c=function c(){a=!1===n.leading?0:new Date().getTime(),s=null,e.apply(o,i),s||(o=i=null);};return function(){var u=new Date().getTime();a||!1!==n.leading||(a=u);var l=t-(u-a);return o=this,i=arguments,l<=0||l>t?(clearTimeout(s),s=null,a=u,e.apply(o,i),s||(o=i=null)):s||!1===n.trailing?s&&r&&r.apply(o,i):(s=y(c,l),r&&r.apply(o,i)),s;};},L.get=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;if("object"!==P(e))return n;var r,o=t.replace(/\[(\d+)\]/g,".$1").split("."),i=e,s=O(o);try{for(s.s();!(r=s.n()).done;){var a=r.value;if(void 0===(i=Object(i)[a]))return n;}}catch(e){s.e(e);}finally{s.f();}return i;},L.pickAsString=function(e,t){var n;return e?d(n=v(t).call(t,function(t){return void 0!==e[t];})).call(n,function(t){var n;return p(n="".concat(t,"=")).call(n,e[t]);}).join(","):"";},L.omitAsString=function(e,t){var n,r;if(!e)return"";var i={};return o(t).call(t,function(e){i[e]=!0;}),d(n=v(r=a(e)).call(r,function(e){return!i[e];})).call(n,function(t){var n;return p(n="".concat(t,"=")).call(n,e[t]);}).join(",");};var W={session:function session(e){var t=function(e){for(var t=1;t<arguments.length;t++){var n,i,s=null!=arguments[t]?arguments[t]:{};t%2?o(n=A(Object(s),!0)).call(n,function(t){r(e,t,s[t]);}):I?_(e,I(s)):o(i=A(Object(s))).call(i,function(t){w(e,t,C(s,t));});}return e;}({},e),n=["topCustom","localCustom","extra"];return o(n).call(n,function(e){t[e]&&(t[e]="***");}),t.lastMsg&&(t.lastMsg={idServer:t.lastMsg.idServer,idClient:t.lastMsg.idClient}),t;}};L.secureOutput=function(e,t){m(t)||(t=[t]);var n=W[e];return 1===(t=d(t).call(t,function(e){return n(e);})).length?t[0]:t;};var V={string:function string(e,t,n){var r=n.required,o=n.allowEmpty,i=e[t];return!1===r&&void 0===i||"string"==typeof i&&!(!o&&""===i);},number:function number(e,t,n){var r=n.required,o=n.min,i=e[t];return!1===r&&void 0===i||"number"==typeof i&&!(i<o);},enum:function _enum(e,t,n){var r=n.required,o=b(n),s=e[t];return!1===r&&void 0===s||i(o).call(o,s)>-1;},array:function array(e,t,n){var r=n.required,o=e[t];return!1===r&&void 0===o||!!m(o);}};L.validate=function(e,t,n){var r,i={};return o(r=a(e)).call(r,function(r){var o,s=e[r].type,a=V[s];a&&!a(t,r,e[r])?L.onError({message:p(o="Error in parameter verification, ".concat(r," expected value is ")).call(o,f(e[r])),callFunc:n}):i[r]=t[r];}),i;},L.asyncPool=function(e,t,n){if("number"!=typeof e||"function"!=typeof n||!t||!t.length)return T.resolve();var r=0,o=[],s=[];return function a(){if(r===t.length)return T.resolve();var c=t[r++],l=T.resolve().then(function(){return n(c,t);});o.push(l);var m=T.resolve();if(e<=t.length){var p=l.then(function(){return u(s).call(s,i(s).call(s,p),1);});s.push(p),s.length>=e&&(m=T.race(s));}return m.then(function(){return a();});}().then(function(){return T.all(o);});},L.getIdArray=function(e){if(!e||"string"!=typeof e)throw new Error("id type error");var t=i(e).call(e,"-");if(t<0||t===e.length-1)throw new Error("id format error");return[s(e).call(e,0,t),s(e).call(e,t+1)];},e.exports=L;},function(e,t,n){"use strict";var r=n(12),o=n(64),i=n(146),s=n(20),a=n(75).f,c=n(194),u=n(11),l=n(79),m=n(51),p=n(26),d=function d(e){var t=function t(n,r,i){if(this instanceof t){switch(arguments.length){case 0:return new e();case 1:return new e(n);case 2:return new e(n,r);}return new e(n,r,i);}return o(e,this,arguments);};return t.prototype=e.prototype,t;};e.exports=function(e,t){var n,o,f,g,h,y,v,b,T,S=e.target,M=e.global,k=e.stat,x=e.proto,C=M?r:k?r[S]:(r[S]||{}).prototype,I=M?u:u[S]||m(u,S,{})[S],_=I.prototype;for(g in t){o=!(n=c(M?g:S+(k?".":"#")+g,e.forced))&&C&&p(C,g),y=I[g],o&&(v=e.dontCallGetSet?(T=a(C,g))&&T.value:C[g]),h=o&&v?v:t[g],o&&(typeof y==="undefined"?"undefined":_typeof(y))==(typeof h==="undefined"?"undefined":_typeof(h))||(b=e.bind&&o?l(h,r):e.wrap&&o?d(h):x&&s(h)?i(h):h,(e.sham||h&&h.sham||y&&y.sham)&&m(b,"sham",!0),m(I,g,b),x&&(p(u,f=S+"Prototype")||m(u,f,{}),m(u[f],g,h),e.real&&_&&(n||!_[g])&&m(_,g,h)));}};},function(e,t,n){e.exports=n(216);},function(e,t,n){e.exports=n(217);},function(e,t,n){e.exports=n(190);},function(e,t,n){e.exports=n(237);},function(e,t,n){e.exports=n(262);},function(e,t,n){e.exports=n(423);},function(e,t){e.exports=function(e){try{return!!e();}catch(e){return!0;}};},function(e,t,n){e.exports=n(304);},function(e,t,n){e.exports=n(363);},function(e,t){e.exports={};},function(e,t,n){(function(t){var n=function n(e){return e&&e.Math==Math&&e;};e.exports=n("object"==(typeof globalThis==="undefined"?"undefined":_typeof(globalThis))&&globalThis)||n("object"==(typeof window==="undefined"?"undefined":_typeof(window))&&window)||n("object"==(typeof self==="undefined"?"undefined":_typeof(self))&&self)||n("object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t)||function(){return this;}()||Function("return this")();}).call(this,n(49));},function(e,t,n){var r=n(92),o=Function.prototype,i=o.call,s=r&&o.bind.bind(i,i);e.exports=r?s:function(e){return function(){return i.apply(e,arguments);};};},function(e,t,n){var r=n(4),o=n(9),i=!1;try{"function"==typeof localStorage.setItem&&"function"==typeof localStorage.getItem&&(localStorage.setItem("nim_localstorage_exist_test","1"),i="1"===localStorage.getItem("nim_localstorage_exist_test"),localStorage.removeItem("nim_localstorage_exist_test"));}catch(e){i=!1;}var s={nodeEnv:"production",info:{hash:"a84f700ec8976b6d2b9dbf8fe2912c258aff0916",shortHash:"a84f700e",version:"9.11.0",sdkVersion:"91100",sdkHumanVersion:"9.11.0",protocolVersion:1},lbsUrl:"https://lbs.netease.im/lbs/webconf.jsp",connectTimeout:8e3,xhrTimeout:8e3,socketTimeout:8e3,reconnectionDelay:1600,reconnectionDelayMax:8e3,reconnectionJitter:.01,reconnectiontimer:null,heartbeatInterval:3e4,cmdTimeout:8e3,hbCmdTimeout:5e3,isWeixinApp:!1,isNodejs:!1,isRN:!1,ipVersion:0,PUSHTOKEN:"",PUSHCONFIG:{},CLIENTTYPE:16,PushPermissionAsked:!1,iosPushConfig:null,androidPushConfig:null,optionDefaultLinkUrl:"",defaultLinkUrl:"weblink.netease.im",ipv6DefaultLinkUrl:"weblink.netease.im",optionIpv6DefaultLinkUrl:"",wxDefaultLinkUrl:"wlnimsc0.netease.im",serverNosConfig:i?{cdnDomain:localStorage.getItem("nim_cdn_domain")||"",objectPrefix:localStorage.getItem("nim_object_prefix")||""}:{},hasLocalStorage:i,privateConf:{isABTestEnable:!0,isDataReportEnable:!0,isMixStoreEnable:!0},getDefaultLinkUrl:function getDefaultLinkUrl(e){var t,n;1===s.ipVersion?(t=s.optionIpv6DefaultLinkUrl,n=s.ipv6DefaultLinkUrl):(t=s.optionDefaultLinkUrl,n=s.defaultLinkUrl);var o=t||(s.isWeixinApp?s.wxDefaultLinkUrl:n);if(!o)return!1;var i=e?"https":"http",a=e?"443":"80",c=o;return-1===r(o).call(o,"http")&&(c=i+"://"+c),-1===r(o).call(o,":")&&(c=c+":"+a),c;},ipProbeAddr:{ipv4:"https://check-ipv4.netease.im/test/",ipv6:"https://check-ipv6.netease.im/test/"},formatSocketUrl:function formatSocketUrl(e){var t=e.url,n=e.secure?"https":"http";return-1===r(t).call(t,"http")?n+"://"+t:t;},uploadUrl:"https://nos.netease.com",chunkUploadUrl:"https://wanproxy-web.127.net",commonMaxSize:104857600,chunkSize:4194304,chunkMaxSize:4194304e4,replaceUrl:"https://{bucket}-nosdn.netease.im/{object}",downloadHost:"nos.netease.com",downloadHostList:["nos.netease.com"],downloadUrl:"https://{bucket}-nosdn.netease.im/{object}",nosCdnEnable:!0,httpsEnabled:!1,threshold:0,nosLbsUrls:[],edgeList:["https://wanproxy-web.127.net","https://nosup-hz1.127.net"],genUploadUrl:function genUploadUrl(e){return s.uploadUrl+"/"+e;},genChunkUploadUrl:function genChunkUploadUrl(e){return s.chunkUploadUrl?s.chunkUploadUrl+"/"+e.bucket+"/"+e.objectName:"";},genDownloadUrl:function genDownloadUrl(e,t,n){var r,i,a,c,u,l=e.bucket,m=e.expireSec,p=+new Date(),d=m?"&survivalTime=".concat(m):"";if(n)return o(a=o(c=o(u="https://".concat(n,"/")).call(u,t,"?createTime=")).call(c,p)).call(a,d);var f=o(r=o(i="".concat(s.replaceUrl,"?createTime=")).call(i,p)).call(r,d);return(f=s.genNosProtocolUrl(f)).replace("{bucket}",l).replace("{object}",t);},genFileUrl:function genFileUrl(e){var t=e.bucket,n=e.objectName;return s.genNosProtocolUrl(s.replaceUrl).replace("{bucket}",t).replace("{object}",n);},genNosProtocolUrl:function genNosProtocolUrl(e){return /^http/.test(e)?s.httpsEnabled&&0!==r(e).call(e,"https://")&&(e=e.replace("http","https")):e=s.httpsEnabled?"https://".concat(e):"http://".concat(e),e;}};e.exports=s;},function(e,t,n){e.exports=n(199);},function(e,t,n){e.exports=n(236);},function(e,t,n){e.exports=n(441);},function(e,t,n){var r=n(12),o=n(94),i=n(26),s=n(149),a=n(76),c=n(192),u=o("wks"),l=r.Symbol,m=l&&l.for,p=c?l:l&&l.withoutSetter||s;e.exports=function(e){if(!i(u,e)||!a&&"string"!=typeof u[e]){var t="Symbol."+e;a&&i(l,e)?u[e]=l[e]:u[e]=c&&m?m(t):p(t);}return u[e];};},function(e,t,n){var r=n(13);e.exports=r({}.isPrototypeOf);},function(e,t,n){var r=n(191),o=r.all;e.exports=r.IS_HTMLDDA?function(e){return"function"==typeof e||e===o;}:function(e){return"function"==typeof e;};},function(e,t,n){var r=n(11),o=n(26),i=n(120),s=n(43).f;e.exports=function(e){var t=r.Symbol||(r.Symbol={});o(t,e)||s(t,e,{value:i.f(e)});};},function(e,t,n){var r=n(142),o=n(346);function i(t){return e.exports=i="function"==typeof r&&"symbol"==(typeof o==="undefined"?"undefined":_typeof(o))?function(e){return typeof e==="undefined"?"undefined":_typeof(e);}:function(e){return e&&"function"==typeof r&&e.constructor===r&&e!==r.prototype?"symbol":typeof e==="undefined"?"undefined":_typeof(e);},e.exports.__esModule=!0,e.exports.default=e.exports,i(t);}e.exports=i,e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(259);},function(e,t,n){var r=n(11);e.exports=function(e){return r[e+"Prototype"];};},function(e,t,n){var r=n(92),o=Function.prototype.call;e.exports=r?o.bind(o):function(){return o.apply(o,arguments);};},function(e,t,n){var r=n(13),o=n(37),i=r({}.hasOwnProperty);e.exports=Object.hasOwn||function(e,t){return i(o(e),t);};},function(e,t,n){e.exports=n(437);},function(e,t,n){var r=n(8);e.exports=!r(function(){return 7!=Object.defineProperty({},1,{get:function get(){return 7;}})[1];});},function(e,t,n){var r=n(20),o=n(191),i=o.all;e.exports=o.IS_HTMLDDA?function(e){return"object"==(typeof e==="undefined"?"undefined":_typeof(e))?null!==e:r(e)||e===i;}:function(e){return"object"==(typeof e==="undefined"?"undefined":_typeof(e))?null!==e:r(e);};},function(e,t,n){e.exports=n(280);},function(e,t,n){var r=n(11),o=n(12),i=n(20),s=function s(e){return i(e)?e:void 0;};e.exports=function(e,t){return arguments.length<2?s(r[e])||s(o[e]):r[e]&&r[e][t]||o[e]&&o[e][t];};},function(e,t,n){var r=n(15),o=n(23),i=n(3),s=n(55),a=n(63),c=n(14),u=n(0),l=n(273),m=u.undef,p=n(288),d=n(137),f=n(140),g=n(710);function h(e){var t,n=this;u.verifyOptions(e,"appKey account token","protocol::IMProtocol"),u.verifyCallback(e,["onconnect","onerror","onwillreconnect","ondisconnect","onloginportschange","onmyinfo","onblacklist","onmutelist","onfriends","onusers","onrobots","onteams","onSuperTeams","onsessions","onSessionsWithMoreRoaming","onStickTopSessions","onroamingmsgs","onofflinemsgs","onofflinefiltermsgs","onroamingsysmsgs","onofflinesysmsgs","onofflinefiltersysmsgs","onofflinecustomsysmsgs","onofflinefiltercustomsysmsgs","onbroadcastmsg","onbroadcastmsgs","onsysmsgunread","onsyncdone","onteammembers","onsyncteammembersdone","onmsg","onsysmsg","oncustomsysmsg","onupdatemyinfo","onupdateuser","onSyncUpdateServerSession","onUpdateSuperTeamMember","onMySuperTeamMembers","onCreateSuperTeam","onUpdateSuperTeam","onAddSuperTeamMembers","onRemoveSuperTeamMembers","onUpdateSuperTeamManagers","onDismissSuperTeam","onTransferSuperTeam","onUpdateSuperTeamMembersMute","onupdateteammember","onMyTeamMembers","onMsgReceipts","onCreateTeam","onUpdateTeam","onAddTeamMembers","onRemoveTeamMembers","onUpdateTeamManagers","onDismissTeam","onTransferTeam","onUpdateTeamMembersMute","onTeamMsgReceipt","onupdatesession","onQuickComment","onDeleteQuickComment","onPinMsgChange","onupdatesysmsgunread","onupdatesysmsg","onsynccreateteam","onsyncsupercreateteam","onsyncmarkinblacklist","onsyncmarkinmutelist","onsyncfriendaction","shouldIgnoreNotification","shouldIgnoreMsg","onDeleteMsgSelf","shouldCountNotifyUnread","onPushNotificationMultiportConfig","onPushNotificationMultiportConfigUpdate","onpushevents"],"protocol::IMProtocol"),t="boolean"==typeof u.get(e,"privateConf.isDataReportEnable")?e.privateConf.isDataReportEnable:c.privateConf.isDataReportEnable,n.reporter=l.initReporter({appKey:e.appKey,logger:n.logger},t),n.db=e.api.db=new s({logger:e.logger,reporter:n.reporter,account:e.account,core:n,notifyError:function notifyError(e){n.notifyError&&n.notifyError("DB error",e);}}),a.call(n,e);}var y=a.fn,v=h.fn=h.prototype=r(y);v.init=function(){var e,t;y.init.call(this),d.IM.setProtocol(this),this.parser=d.IM,o(e=this.sendCmd).call(e,this),this.socketUrls=[],this.syncing=!0,this.hasSynced=!1,this.hasSyncedTeamMembers=!1,this.syncPromiseArray=[],this.syncResult={},this.syncTeamMembersPromiseArray=[],this.syncSuperTeamMembersPromiseArray=[],this.syncTeamMembersResult={},this.timetags={},this.superTeamMembersData={},this.saveAck={},this.sysMsgUnread=f.completeUnread({}),this.resetUnsettledMsgs(),this.resetUnsettledSysMsgs(),this.msgPromise=i.resolve(),this.sysMsgPromise=i.resolve(),this.msgDelayArr=[],this.msgDelayTimer=null,this.msgStatEnable=!1,this.nosCdnHostTimer=null,this.relativeServerTime=0,this.sessionSet={},this.msgReceiptTasks={},this.userSet={},this.pushNotificationMultiportConfig=p.getDefaultConfig(),this.msgAckBufferManager=new g({processFn:o(t=this.handleMsgsAck).call(t,this),throttleTime:500});},v.reset=function(){y.reset.call(this);var e=this.options;this.db.reset(e.db),m(e.lbsUrl)&&(e.lbsUrl=c.lbsUrl),this.autoconnect=!!e.autoconnect,this.resetAutoMarkRead();},v.resetAutoMarkRead=function(){var e=this.options;u.verifyBooleanWithDefault(e,"autoMarkRead",!0,"","protocol::resetAutoMarkRead");},v.resetUnsettledMsgs=function(){this.unhandledMsgs=[],this.unupdatedMsgs=[];},v.resetUnsettledSysMsgs=function(){this.unhandledSysMsgs=[],this.unupdatedSysMsgs=[];},v.packetFromSync=function(e){return!e.obj||!!e.obj.sync;},e.exports=h,n(711),n(712),n(713),n(733),n(735),n(736),n(737),n(738),n(739),n(740),n(741),n(746),n(747),n(748),n(749),n(753),n(754),n(755),n(756),n(757),n(758);},function(e,t,n){var r=n(29),o=String,i=TypeError;e.exports=function(e){if(r(e))return e;throw i(o(e)+" is not an object");};},function(e,t,n){var r=n(15),o=n(57),i=n(32),s=n(14),a=n(759),c=n(137).IM;function u(e){return this.subType="im",this.nosScene=e.nosScene||"im",this.nosSurvivalTime=e.nosSurvivalTime,e.Protocol=i,e.Message=a,e.constructor=u,this.init(e);}u.Protocol=i,u.parser=c,u.use=o.use,u.getInstance=o.getInstance,u.rmAllInstances=o.rmAllInstances,u.genInstanceName=function(e){return"NIM-account-"+e.account;};var l=u.fn=u.prototype=r(o.prototype);u.info=l.info=s.info,e.exports=u,n(770),n(771),n(772),n(773),n(774),n(775),n(776),n(777),n(778),n(779),n(790),n(791),n(792),n(793),n(794),n(795),n(796),n(797),n(798),n(801),n(802);},function(e,t,n){e.exports=n(284);},function(e,t,n){var r=n(20),o=n(78),i=TypeError;e.exports=function(e){if(r(e))return e;throw i(o(e)+" is not a function");};},function(e,t,n){var r=n(93),o=Object;e.exports=function(e){return o(r(e));};},function(e,t,n){var r=n(111),o=n(93);e.exports=function(e){return r(o(e));};},function(e,t,n){var r=n(15),o=n(2),i=n(22);function s(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=this;r.message=e||n.message||"","object"===i(t)?(r.event=t,r.code="Other_Error"):void 0!==t&&(r.code=t),r.timetag=+new Date(),void 0!==n&&(r.event=n),r.event&&(r.callFunc=r.event.callFunc||null,delete r.event.callFunc);}s.prototype=r(Error.prototype),s.prototype.name="NIMError";var a={201:"客户端版本不对, 需升级sdk",302:"用户名或密码错误, 请检查appKey和token是否有效, account和token是否匹配",403:"非法操作或没有权限",404:"对象(用户/群/聊天室)不存在",405:"参数长度过长",408:"客户端请求超时",414:"参数错误",415:"服务不可用/没有聊天室服务器可分配",416:"频率控制",417:"重复操作",422:"帐号被禁用",500:"服务器内部错误",501:"数据库操作失败",503:"服务器繁忙",508:"删除有效期过了",509:"已失效",7101:"被拉黑",700:"批量操作部分失败",801:"群人数达到上限",802:"没有权限",803:"群不存在或未发生变化",804:"用户不在群里面",805:"群类型不匹配",806:"创建群数量达到限制",807:"群成员状态不对",809:"已经在群里",811:"强推列表中帐号数量超限",812:"群被禁言",813:"因群数量限制，部分拉人成功",814:"禁止使用群组消息已读服务",815:"群管理员人数上限",816:"批量操作部分失败",997:"协议已失效",998:"解包错误",999:"打包错误",9102:"通道失效",9103:"已经在其他端接听/拒绝过这通电话",11001:"对方离线, 通话不可送达",13002:"聊天室状态异常",13003:"在黑名单中",13004:"在禁言名单中",13006:"聊天室处于整体禁言状态,只有管理员能发言",Connect_Failed:"无法建立连接, 请确保能 ping/telnet 到云信服务器; 如果是IE8/9, 请确保项目部署在 HTTPS 环境下",Error_Internet_Disconnected:"网断了",Error_Connection_is_not_Established:"连接未建立",Error_Connection_Socket_State_not_Match:"socket状态不对",Error_Timeout:"超时",Param_Error:"参数错误",No_File_Selected:"请选择文件",Wrong_File_Type:"文件类型错误",File_Too_Large:"文件过大",Cross_Origin_Iframe:"不能获取跨域Iframe的内容",Not_Support:"不支持",NO_DB:"无数据库",DB:"数据库错误",Still_In_Team:"还在群里",Session_Exist:"会话已存在",Session_Not_Exist:"会话不存在",Error_Unknown:"未知错误",Operation_Canceled:"操作取消"},c=[200,406,808,810];o(c).call(c,function(e){a[e]=null;}),s.genError=function(e){var t=a[e];return void 0===t&&(t="操作失败"),null===t?null:new s(t,e);},s.multiInstance=function(e){return new s("不允许初始化多个实例","Not_Allow_Multi_Instance",e);},s.newNetworkError=function(e){var t="Error_Internet_Disconnected";return new s(a[t],t,e);},s.newConnectError=function(e){var t="Connect_Failed";return new s(a[t]||null,t,e);},s.newConnectionError=function(e){var t="Error_Connection_is_not_Established";return new s(a[t],t,e);},s.newSocketStateError=function(e){var t="Error_Connection_Socket_State_not_Match";return new s(a[t],t,e);},s.newTimeoutError=function(e){var t="Error_Timeout";return new s(a[t],t,e);},s.newFrequencyControlError=function(e){var t=new s(a[416],416,e);return t.from="local",t;},s.newParamError=function(e,t){return new s(e||a.Param_Error,"Param_Error",t);},s.newNoFileError=function(e,t){var n="No_File_Selected";return new s(e||a[n],n,t);},s.newWrongFileTypeError=function(e,t){var n="Wrong_File_Type";return new s(e||a[n],n,t);},s.newFileTooLargeError=function(e,t){var n="File_Too_Large";return new s(e||a[n],n,t);},s.newCORSIframeError=function(e){var t="Cross_Origin_Iframe";return new s(a[t],t,e);},s.newSupportError=function(e,t,n){return new s("不支持"+e,"Not_Support_"+t,n);},s.newSupportDBError=function(e){return s.newSupportError("数据库","DB",e);},s.noDBError=function(e){return new s(a.NO_DB,"NO_DB",e);},s.newDBError=function(e){return new s(a.DB,"DB",e);},s.newUnknownError=function(e){var t="Error_Unknown";return new s(a[t],t,e);},s.stillInTeamError=function(e){var t="Still_In_Team";return new s(a[t],t,e);},s.sessionExist=function(e){var t="Session_Exist";return new s(a[t],t,e);},s.sessionNotExist=function(e){var t="Session_Not_Exist";return new s(a[t],t,e);},s.cancel=function(e){var t="Operation_Canceled";return new s(a[t],t,e);},s.customError=function(e,t){e=e||"Other_Error";var n="";return(t=t||{}).message||(n=a[e]||e),"object"!==i(e)?new s(n,e,t):new s(n,"Other_Error",void 0===t?e:t);},e.exports=s;},function(e,t,n){var r=n(303);e.exports=function(e){return r(e.length);};},function(e,t,n){var r=n(0),o={init:function init(){o.deviceId=r.guid();}};o.init(),o.clientTypeMap={1:"Android",2:"iOS",4:"PC",8:"WindowsPhone",16:"Web",32:"Server",64:"Mac"},o.db={open:function open(){}},o.rnfs=null,e.exports=o;},function(e,t){e.exports=!0;},function(e,t,n){var r=n(28),o=n(193),i=n(195),s=n(33),a=n(113),c=TypeError,u=Object.defineProperty,l=Object.getOwnPropertyDescriptor;t.f=r?i?function(e,t,n){if(s(e),t=a(t),s(n),"function"==typeof e&&"prototype"===t&&"value"in n&&"writable"in n&&!n.writable){var r=l(e,t);r&&r.writable&&(e[t]=n.value,n={configurable:"configurable"in n?n.configurable:r.configurable,enumerable:"enumerable"in n?n.enumerable:r.enumerable,writable:!1});}return u(e,t,n);}:u:function(e,t,n){if(s(e),t=a(t),s(n),o)try{return u(e,t,n);}catch(e){}if("get"in n||"set"in n)throw c("Accessors not supported");return"value"in n&&(e[t]=n.value),e;};},function(e,t,n){var r=n(52),o=String;e.exports=function(e){if("Symbol"===r(e))throw TypeError("Cannot convert a Symbol value to a string");return o(e);};},function(e,t,n){var r=n(245),o="object"==(typeof self==="undefined"?"undefined":_typeof(self))&&self&&self.Object===Object&&self,i=r||o||Function("return this")();e.exports=i;},function(e,t,n){e.exports=n(234);},function(e,t,n){(function(t){var r=n(16),o=n(27),i=n(4),s=n(128),a=n(2),c=n(10),u=n(5),l=n(127),m=n(3),p=n(102),d=n(103),f=n(72),g=n(30);function h(e,t){var _n2=void 0!==d&&f(e)||e["@@iterator"];if(!_n2){if(g(e)||(_n2=function(e,t){var n;if(!e)return;if("string"==typeof e)return y(e,t);var o=r(n=Object.prototype.toString.call(e)).call(n,8,-1);"Object"===o&&e.constructor&&(o=e.constructor.name);if("Map"===o||"Set"===o)return p(e);if("Arguments"===o||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))return y(e,t);}(e))||t&&e&&"number"==typeof e.length){_n2&&(e=_n2);var o=0,i=function i(){};return{s:i,n:function n(){return o>=e.length?{done:!0}:{done:!1,value:e[o++]};},e:function e(_e3){throw _e3;},f:i};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var s,a=!0,c=!1;return{s:function s(){_n2=_n2.call(e);},n:function n(){var e=_n2.next();return a=e.done,e;},e:function e(_e4){c=!0,s=_e4;},f:function f(){try{a||null==_n2.return||_n2.return();}finally{if(c)throw s;}}};}function y(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++){r[n]=e[n];}return r;}var v=n(469);function b(){return"undefined"!=typeof window?window:void 0!==t?t:"undefined"!=typeof self?self:{};}function T(e){var t;return r(t=Object.prototype.toString.call(e)).call(t,8,-1);}function S(e){return T(e).toLowerCase();}function M(e){return"string"===S(e);}function k(e){return"number"===S(e);}function x(e){return"array"===S(e);}function C(e){return"function"==typeof e;}function I(e){return"date"===S(e);}function _(e){return null===e;}function w(e){return null!==e;}function P(e){return void 0===e;}function A(e){return void 0!==e;}function O(e){return A(e)&&w(e);}function E(e){return P(e)||_(e);}function R(e){return O(e)&&"object"===S(e);}var j=function j(e,t,n){e.addEventListener?e.addEventListener(t,n,!1):e.attachEvent&&e.attachEvent("on"+t,n);},N=j,U=function U(e,t,n){e.removeEventListener?e.removeEventListener(t,n,!1):e.detachEvent&&e.detachEvent("on"+t,n);},D=U;function L(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){},n=arguments.length>2?arguments[2]:void 0;for(var r in e){e.hasOwnProperty(r)&&t.call(n,r,e[r]);}}function F(e,t){L(t,function(t,n){e[t]=n;});}var B,q=(B=0,function(){return""+B++;});function H(e){return M(e)&&0===i(e).call(e,"{")&&s(e).call(e,"}")===e.length-1;}function z(e,t,n){if(!e)return"";var r=[];return L(e,function(e,t){C(t)||(I(t)?t=t.getTime():x(t)?t=t.join(","):R(t)&&(t=c(t)),n&&(t=encodeURIComponent(t)),r.push(encodeURIComponent(e)+"="+t));}),r.join(t||",");}var W,V=(W=/^([\w]+?:\/\/.*?(?=\/|$))/i,function(e){return W.test(e||"")?RegExp.$1.toLowerCase():"";});function G(e){var t=b();return e.tagName&&"INPUT"===e.tagName.toUpperCase()||t.Blob&&e instanceof t.Blob;}e.exports={o:{},emptyObj:{},f:function f(){},emptyFunc:function emptyFunc(){},regBlank:/\s+/gi,regWhiteSpace:/\s+/gi,getGlobal:b,getClass:T,typeOf:S,isString:M,isNumber:k,isInt:function isInt(e){return k(e)&&e%1==0;},isBoolean:function isBoolean(e){return"boolean"===S(e);},isArray:x,isFunction:C,isDate:I,isRegExp:function isRegExp(e){return"regexp"===S(e);},isError:function isError(e){return"error"===S(e);},isnull:_,notnull:w,undef:P,notundef:A,exist:O,notexist:E,isObject:R,isEmpty:function isEmpty(e){return E(e)||(M(e)||x(e))&&0===e.length;},remove:function remove(e){e.parentNode&&e.parentNode.removeChild(e);},dataset:function dataset(e,t,n){if(!O(n))return e.getAttribute("data-"+t);e.setAttribute("data-"+t,n);},addEventListener:j,on:N,removeEventListener:U,off:D,target:function target(e){return e.target||e.srcElement;},createIframe:function createIframe(e){if("undefined"!=typeof document){var t;if((e=e||{}).name)try{(t=document.createElement('<iframe name="'+e.name+'"></iframe>')).frameBorder=0;}catch(n){(t=document.createElement("iframe")).name=e.name;}else t=document.createElement("iframe");e.visible||(t.style.display="none"),C(e.onload)&&N(t,"load",function n(r){t.src&&(e.multi||D(t,"load",n),e.onload(r));}),(e.parent||document.body).appendChild(t);var n=e.src||"about:blank";return o(function(){t.src=n;},0),t;}},html2node:function html2node(e){if("undefined"!=typeof document){var t=document.createElement("div");t.innerHTML=e;var n,r,o=[];if(t.children)for(n=0,r=t.children.length;n<r;n++){o.push(t.children[n]);}else for(n=0,r=t.childNodes.length;n<r;n++){var i=t.childNodes[n];1===i.nodeType&&o.push(i);}return o.length>1?t:o[0];}},forOwn:L,mixin:F,uniqueID:q,isJSON:H,parseJSON:function e(t){try{H(t)&&(t=JSON.parse(t)),R(t)&&L(t,function(n,r){switch(S(r)){case"string":case"object":t[n]=e(r);}});}catch(e){}return t;},simpleClone:function simpleClone(e){return v(e);},merge:function merge(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++){n[r-1]=arguments[r];}return a(n).call(n,function(t){F(e,t);}),e;},fillUndef:function fillUndef(e,t){return L(t,function(t,n){P(e[t])&&(e[t]=n);}),e;},checkWithDefault:function checkWithDefault(e,t,n){var r=e[t]||e[t.toLowerCase()];return E(r)&&(r=n,e[t]=r),r;},fetch:function fetch(e,t){return L(e,function(n){O(t[n])&&(e[n]=t[n]);}),e;},string2object:function string2object(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:",",r={};return a(e=t.split(n)).call(e,function(e){var t=e.split("="),n=t.shift();n&&(r[decodeURIComponent(n)]=decodeURIComponent(t.join("=")));}),r;},object2string:z,genUrlSep:function genUrlSep(e){return i(e).call(e,"?")<0?"?":"&";},object2query:function object2query(e){return z(e,"&",!0);},url2origin:V,isFileInput:G,getKeys:function getKeys(e,t){var n=u(e);return t&&l(n).call(n,function(t,n){var r=G(e[t]);return r===G(e[n])?0:r?1:-1;}),n;},_get:function _get(e,t){var n,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,o=t.replace(/\[(\d+)\]/g,".$1").split("."),i=e,s=h(o);try{for(s.s();!(n=s.n()).done;){var a=n.value;if(void 0===(i=Object(i)[a]))return r;}}catch(e){s.e(e);}finally{s.f();}return i;},getPromiseWithAbort:function getPromiseWithAbort(e){var t={},n=new m(function(e,n){t.abort=n;});return t.promise=m.race([e,n]),t;}};}).call(this,n(49));},function(e,t,n){e.exports=n(545);},function(e,t){var n;n=function(){return this;}();try{n=n||new Function("return this")();}catch(e){"object"==(typeof window==="undefined"?"undefined":_typeof(window))&&(n=window);}e.exports=n;},function(e,t,n){var r=n(31);e.exports=r("navigator","userAgent")||"";},function(e,t,n){var r=n(28),o=n(43),i=n(66);e.exports=r?function(e,t,n){return o.f(e,t,i(1,n));}:function(e,t,n){return e[t]=n,e;};},function(e,t,n){var r=n(153),o=n(20),i=n(65),s=n(18)("toStringTag"),a=Object,c="Arguments"==i(function(){return arguments;}());e.exports=r?i:function(e){var t,n,r;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=function(e,t){try{return e[t];}catch(e){}}(t=a(e),s))?n:c?i(t):"Object"==(r=i(t))&&o(t.callee)?"Arguments":r;};},function(e,t,n){"use strict";var r=n(36),o=TypeError,i=function i(e){var t,n;this.promise=new e(function(e,r){if(void 0!==t||void 0!==n)throw o("Bad Promise constructor");t=e,n=r;}),this.resolve=r(t),this.reject=r(n);};e.exports.f=function(e){return new i(e);};},function(e,t,n){e.exports=n(588);},function(e,t,n){var r=n(697);r.fn=r.prototype,e.exports=r,n(699),n(700),n(701),n(702),n(703),n(704),n(705),n(706),n(707),n(708),n(709);},function(e,t,n){var r=n(22),o=n(5),i=n(10),s=n(17),a=n(2),c=n(7),u=n(16),l=n(102),m=n(103),p=n(72),d=n(30);function f(e,t){var _n3=void 0!==m&&p(e)||e["@@iterator"];if(!_n3){if(d(e)||(_n3=function(e,t){var n;if(!e)return;if("string"==typeof e)return g(e,t);var r=u(n=Object.prototype.toString.call(e)).call(n,8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return l(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return g(e,t);}(e))||t&&e&&"number"==typeof e.length){_n3&&(e=_n3);var r=0,o=function o(){};return{s:o,n:function n(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]};},e:function e(_e5){throw _e5;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var i,s=!0,a=!1;return{s:function s(){_n3=_n3.call(e);},n:function n(){var e=_n3.next();return s=e.done,e;},e:function e(_e6){a=!0,i=_e6;},f:function f(){try{s||null==_n3.return||_n3.return();}finally{if(a)throw i;}}};}function g(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++){r[n]=e[n];}return r;}var h=n(0),y=h.undef,v=h.notundef,b=h.exist,T=n(176),S=n(277),M={p2p:0,team:1,superTeam:5},k={0:"p2p",1:"team",5:"superTeam"},x=o(M),C=S.typeMap,I=S.validTypes;function _(e){h.verifyOptions(e,"scene to type","msg::Message"),h.verifyParamValid("scene",e.scene,x,"msg::Message");this.scene=M[e.scene],this.to=""+e.to,this.type=C[e.type],this.resend=e.resend?1:0,e.resend?(h.verifyOptions(e,"idClient","msg::Message"),this.idClient=e.idClient):this.idClient=h.guid(),v(e.subType)&&(h.isInt(+e.subType)&&+e.subType>0?this.subType=+e.subType:h.onParamError("subType只能是大于0的整数","msg::Message"));var t=e.replyMsg;t&&t.idServer&&t.from&&t.to&&t.time&&(this.replyMsgFromAccount=t.from,this.replyMsgToAccount=t.to,this.replyMsgTime=t.time,this.replyMsgIdServer=t.idServer,this.replyMsgIdClient=t.idClient,t.threadMsgFromAccount&&t.threadMsgIdServer&&t.threadMsgTime&&t.threadMsgToAccount?(this.threadMsgFromAccount=t.threadMsgFromAccount,this.threadMsgToAccount=t.threadMsgToAccount,this.threadMsgTime=t.threadMsgTime,this.threadMsgIdServer=t.threadMsgIdServer,this.threadMsgIdClient=t.threadMsgIdClient):(this.threadMsgFromAccount=t.from,this.threadMsgToAccount=t.to,this.threadMsgTime=t.time,this.threadMsgIdServer=t.idServer,this.threadMsgIdClient=t.idClient)),v(e.text)&&(this.body=""+e.text),v(e.custom)&&("object"===r(e.custom)?this.custom=i(e.custom):this.custom=""+e.custom),v(e.body)&&(this.body=""+e.body),v(e.pushContent)&&(this.pushContent=""+e.pushContent),v(e.pushPayload)&&(this.pushPayload=""+e.pushPayload);var n=e.apns;if(v(n)&&"team"===e.scene){var o=n.accounts;v(o)&&h.verifyParamType("apns.accounts",o,"array","msg::Message"),this.apnsAccounts=o?i(o):"#%@all@%#",this.apnsContent=n.content||e.pushContent||"",h.verifyBooleanWithDefault(n,"forcePush",!0,"options.apns","msg::Message"),this.apnsForcePush=n.forcePush?1:0;}var s=e.robotInfo;v(s)&&("team"===e.scene&&h.verifyOptions(e.robotInfo,"account","msg::Message::robotInfo scene === team"),s.function&&(this.robotInfoFunction=s.function),s.topic&&(this.robotInfoTopic=s.topic),s.customContent&&(this.robotInfoCustomContent=s.customContent),s.account&&(this.robotInfoAccount=s.account)),v(e.isHistoryable)&&(this.isHistoryable=e.isHistoryable?1:0),v(e.isRoamingable)&&(this.isRoamingable=e.isRoamingable?1:0),v(e.isSyncable)&&(this.isSyncable=e.isSyncable?1:0),v(e.cc)&&(this.cc=e.cc?1:0),v(e.env)&&(this.env=e.env),v(e.isPushable)&&(this.isPushable=e.isPushable?1:0),v(e.isOfflinable)&&(this.isOfflinable=e.isOfflinable?1:0),v(e.isUnreadable)&&(this.isUnreadable=e.isUnreadable?1:0),v(e.needPushNick)&&(this.needPushNick=e.needPushNick?1:0),v(e.needMsgReceipt)&&(this.needMsgReceipt=e.needMsgReceipt?1:0),v(e.yidunEnable)&&(this.yidunEnable=e.yidunEnable?1:0),this.needUpdateSession=!1===e.needUpdateSession?0:1,v(e.antiSpamUsingYidun)&&(this.antiSpamUsingYidun=e.antiSpamUsingYidun?1:0),v(e.clientAntiSpam)&&(this.clientAntiSpam=e.clientAntiSpam?1:0),v(e.antiSpamContent)&&("object"===r(e.antiSpamContent)?this.antiSpamContent=i(e.antiSpamContent):this.antiSpamContent=""+e.antiSpamContent),v(e.antiSpamBusinessId)&&("object"===r(e.antiSpamBusinessId)?this.antiSpamBusinessId=i(e.antiSpamBusinessId):this.antiSpamBusinessId=""+e.antiSpamBusinessId),v(e.yidunAntiCheating)&&(this.yidunAntiCheating=e.yidunAntiCheating),v(e.yidunAntiSpamExt)&&(this.yidunAntiSpamExt=e.yidunAntiSpamExt);}h.merge(_.prototype,S.prototype),_.prototype.getScene=function(){return k[this.scene];},_.getType=S.getType,_.reverse=function(e){var t,n=k[e.scene];if(t="1"===e.delete?{delete:!0,scene:n||e.scene,from:e.from,time:+e.time,to:""+e.to}:{scene:n||e.scene,from:e.from,fromNick:e.fromNick,fromClientType:T.reverseType(e.fromClientType),fromDeviceId:e.fromDeviceId,to:""+e.to,time:+e.time,type:_.getType(e),text:b(e.body)?e.body:e.text||"",isHistoryable:y(e.isHistoryable)||1==+e.isHistoryable,isRoamingable:y(e.isRoamingable)||1==+e.isRoamingable,isSyncable:y(e.isSyncable)||1==+e.isSyncable,cc:y(e.cc)||1==+e.cc,isPushable:y(e.isPushable)||1==+e.isPushable,isOfflinable:y(e.isOfflinable)||1==+e.isOfflinable,isUnreadable:y(e.isUnreadable)||1==+e.isUnreadable,isReplyMsg:y(e.isReplyMsg)||1==+e.isReplyMsg,needPushNick:y(e.needPushNick)||1==+e.needPushNick,needMsgReceipt:1==+e.needMsgReceipt,isLocal:!1},e.isInBlackList&&(t.isInBlackList=1==+e.isInBlackList,t.isInBlackList&&(e.status="fail")),v(e.isMuted)&&(t.isMuted=1==+e.isMuted),v(e.resend)&&(t.resend=1==+e.resend),v(e.idClient)&&(t.idClient=e.idClient),v(e.idServer)&&(t.idServer=""+e.idServer),v(e.userUpdateTime)&&(t.userUpdateTime=+e.userUpdateTime),v(e.custom)&&(t.custom=e.custom),v(e.callbackExt)&&(t.callbackExt=e.callbackExt),v(e.subType)&&(t.subType=+e.subType),v(e.pushContent)&&(t.pushContent=e.pushContent),v(e.pushPayload)&&(t.pushPayload=e.pushPayload),v(e.tempTeamMemberCount)&&(t.tempTeamMemberCount=+e.tempTeamMemberCount),v(e.yidunAntiSpamRes)&&(t.yidunAntiSpamRes=e.yidunAntiSpamRes),v(e.apnsAccounts)){if(t.apns={},"#%@all@%#"!==e.apnsAccounts){var r=e.apnsAccounts;try{t.apns.accounts=JSON.parse(r);}catch(e){t.apns.accounts=[];}}t.apns.content=e.apnsContent||"",t.apns.forcePush=1==+e.apnsForcePush;}if(v(e.robotInfoFunction)&&(t.robotInfo=t.robotInfo||{},e.robotInfoFunction&&(t.robotInfo.function=e.robotInfoFunction)),v(e.robotInfoCustomContent)&&(t.robotInfo=t.robotInfo||{},e.robotInfoCustomContent&&(t.robotInfo.customContent=e.robotInfoCustomContent)),v(e.robotInfoTopic)&&(t.robotInfo=t.robotInfo||{},e.robotInfoTopic&&(t.robotInfo.topic=e.robotInfoTopic)),v(e.robotInfoAccount)&&(t.robotInfo=t.robotInfo||{},e.robotInfoAccount&&(t.robotInfo.account=e.robotInfoAccount)),v(e.needUpdateSession)&&(t.needUpdateSession=1==+e.needUpdateSession),t.status=e.status||"success",v(s(e))&&(t.filter=s(e)),e.replyMsgIdServer&&e.threadMsgIdServer){var o=["replyMsgFromAccount","replyMsgToAccount","replyMsgTime","replyMsgIdServer","replyMsgIdClient","threadMsgFromAccount","threadMsgToAccount","threadMsgTime","threadMsgIdServer","threadMsgIdClient"];a(o).call(o,function(n){t[n]=e[n];}),t.replyMsgTime=+t.replyMsgTime,t.threadMsgTime=+t.threadMsgTime;}return t;},_.setExtra=function(e,t){e.target=_.getMsgTarget(e,t),e.sessionId=e.scene+"-"+e.target,S.setFlow(e,t);},_.getMsgTarget=function(e,t){return"p2p"===e.scene?e.to===t?e.from:e.to:"team"===e.scene||"superTeam"===e.scene?e.to:void 0;},_.deduplication=function(e){var t,n,r={},i=f(e);try{for(i.s();!(n=i.n()).done;){var s=n.value,a=r[s.idClient];a&&a.time>s.time||(r[s.idClient]=s);}}catch(e){i.e(e);}finally{i.f();}return c(t=o(r)).call(t,function(e){return r[e];});},_.sortMsgs=function(e){return e=u(e).call(e,0),h.sortObjArray(e,{sortPath:"time"}),e;},_.getLastMsg=function(e){return(e=_.sortMsgs(e))[e.length-1];},_.getLastNotIgnoredMsg=function(e){for(var t=null,n=(e=_.sortMsgs(e)).length-1;n>=0;n--){if(!(t=e[n]).ignore)return t;}return null;},_.getMaxTimetag=function(e){return _.getLastMsg(e).time;},_.validScenes=x,_.validTypes=I,_.sceneMap=M,_.sceneReverseMap=k,e.exports=_;},function(e,t,n){var r=n(22),o=n(15),i=n(30),s=n(2),a=n(359),c=n(4),u=n(10),l=n(3),m=n(157),p=n(0),d=p.notundef,f=n(540),g=n(14),h=n(171),y=n(41),v=n(566).wrapSafeCallback;function b(){}var T={};b.getInstance=function(e){e=M(e),p.verifyOptions(e,"account","api::Base.getInstance");var t=this.genInstanceName(e),n=T[t];return n?b.updateInstance(n,e):n=T[t]=new this(e),n;},b.updateInstance=function(e,t){e.setOptions(t),e.connect();};var S=b.fn=b.prototype=o(new m()),M=function M(e){return e.nosSurvivalTime?(p.verifyParamType("nosSurvivalTime",e.nosSurvivalTime,"number","api::Base.getInstance"),p.verifyParamMin("nosSurvivalTime",e.nosSurvivalTime,86400,"api::Base.getInstance")):e.nosSurvivalTime=1/0,e;};S.updatePrivateConf=function(e){if(e&&"object"===r(e.privateConf)){var t=e.privateConf;"string"==typeof t.lbs_web&&(e.lbsUrl=t.lbs_web),"boolean"==typeof t.link_ssl_web&&(e.secure=t.link_ssl_web),"boolean"==typeof t.https_enabled&&(e.httpsEnabled=t.https_enabled),e.uploadUrl=t.nos_uploader_web?t.nos_uploader_web:null,e.chunkUploadUrl=t.nos_uploader_web?t.nos_uploader_web:null,e.replaceUrl=t.nos_downloader?t.nos_downloader:null,e.downloadUrl=t.nos_accelerate?t.nos_accelerate:null,e.downloadHost=t.nos_accelerate_host?t.nos_accelerate_host:null,e.downloadHostList=t.nos_accelerate_host_list||[],e.downloadHost&&e.downloadHostList.push(e.downloadHost),e.nosCdnEnable=!1!==t.nos_cdn_enable,e.ntServerAddress=t.nt_server||null,e.kibanaServer=t.kibana_server,e.statisticServer=t.statistic_server,e.reportGlobalServer=t.report_global_server,e.ipVersion=t.ip_protocol_version||e.ipVersion,e.defaultLink=t.link_web||e.defaultLink,e.ipv6DefaultLink=t.link_ipv6_web||e.ipv6DefaultLink,"string"==typeof t.nos_lbs?e.nosLbsUrls=[t.nos_lbs]:e.nosLbsUrls=[],i(t.nos_edge_list)&&(e.edgeList=t.nos_edge_list);}return null===e.ntServerAddress||""===e.ntServerAddress?g.ntServerAddress=null:g.ntServerAddress=e.ntServerAddress,g.uploadUrl=e.uploadUrl||g.uploadUrl,g.chunkUploadUrl=e.chunkUploadUrl||g.chunkUploadUrl,g.downloadUrl=e.downloadUrl||g.downloadUrl,g.downloadHost=e.downloadHost||g.downloadHost,g.downloadHostList=e.downloadHostList&&e.downloadHostList.length>0?e.downloadHostList:g.downloadHostList,g.nosCdnEnable=!1!==e.nosCdnEnable,g.replaceUrl=e.replaceUrl||g.replaceUrl,g.httpsEnabled=e.httpsEnabled||g.httpsEnabled,e.probe_ipv4_url&&(g.ipProbeAddr.ipv4=e.probe_ipv4_url),e.probe_ipv6_url&&(g.ipProbeAddr.ipv6=e.probe_ipv6_url),e;},S.init=function(e){p.verifyOptions(e,"account","api::Base.init"),e=this.updatePrivateConf(e),p.verifyBooleanWithDefault(e,"exifOrientation",!0,"","api::Base.init"),e.lbsBackup=void 0===e.lbsBackup||e.lbsBackup;var t=this.account=e.account=e.account+"",n=e.constructor.genInstanceName(e),r=T[n];if(e._disableSingleton&&(r=null),r)return b.updateInstance(r,e),r;this.logger=e.logger=new f({debug:e.debug,logFunc:e.logFunc,prefix:this.subType,dbLog:!1!==e.dbLog,account:e.account,expire:e.expire,logLevel:e.logLevel}),this.options=v(e,this),e.api=this;var o=this.protocol=new e.Protocol(e);return o.name="Protocol-"+n,o.account=t,o.api=this,o.message=this.message=new e.Message({account:t}),this.reporter=o.reporter,this.statusProtector=o.statusProtector,this.reporterHook=o.reporterHook,this.abtInfo={},("boolean"==typeof p.get(e,"privateConf.isABTestEnable")?e.privateConf.isABTestEnable:g.privateConf.isABTestEnable)&&this.abTestConfigRequset(),this.name=n,T[n]=this,this;},S.destroy=function(e){var t=this,n=this;if(!n.__beginDestroy){var r;n.__beginDestroy=!0,e=e||{};var o,i=this.name;if(this.logger.warn("destroy::start"),!i)return this.logger&&this.logger.warn&&this.logger.warn("destroy::no instanceName"),void(n.__beginDestroy=void 0);if(this.protocol&&(r=this.protocol.connectTimer),this.protocol&&this.protocol.resetPush&&this.protocol.resetPush(),this.eventNames&&"function"==typeof this.eventNames)s(o=this.eventNames()).call(o,function(e){delete t._events[e];});this.disconnect({done:function done(t){var o,u;n.logger.warn("ApiBase::destroy: instance destroyed ..."),n.__beginDestroy=void 0,n.reporter.destroy(),n.statusProtector.destroy(),n.reporterHook.destroy(),s(o=a(n.options)).call(o,function(e){0===c(e).call(e,"on")&&(n.options[e]=function(){},n.protocol.options[e]=function(){},n.protocol.api.options[e]=function(){});}),n.logger.setLogDisabled(),s(u=a(n)).call(u,function(e){n[e]=void 0;}),T&&(T[i]=null,clearTimeout(r)),e.done instanceof Function&&e.done(t);}});}},S.setOptions=function(e){e=v(e,this),this.protocol.setOptions(e);},S.abTestConfigRequset=function(){var e=this,t=e.options.abTestUrl||"https://abt-online.netease.im/v1/api/abt/client/getExperimentInfo",n={projectKey:"im1_sdk_abtest_web",appKey:e.options.appKey,osType:"Web",sdkVersion:e.info.version,deviceId:y.deviceId},r=u({clientInfo:n});h(t,{method:"POST",timeout:5e3,headers:{"Content-Type":"application/json"},data:r,onload:function onload(t){var n=JSON.parse(t);e.abtInfo=n.data.abtInfo||{},e.logger.info("abTestConfigRequset::success",e.abtInfo);},onerror:function onerror(){e.logger.info("abTestConfigRequset::fail");}});},S.processCallback=function(e,t){k(e,t);},S.processCallbackPromise=function(e,t){return new l(function(n,r){k(e,t,!0,n,r);});};var k=function k(e,t,n,r,o){var i="api::processCallback";n&&(i="api::processCallbackPromise"),p.verifyCallback(e,"done",i),e.callback=function(s,a,c){var u=e.callback.options;if(a=a||u,t&&(a=u),p.isFunction(e.cbaop)){var l=e.cbaop(s,a);d(l)&&(a=l);}var m=e.done;p.isObject(a)&&(delete a.done,delete a.cb,delete a.callback),n?s?o({message:"生成接口回调错误",callFunc:i,event:s}):r(a):m(s,a,c);},e.callback.options=p.copy(e);};S.processPs=function(e){p.notexist(e.ps)&&(e.ps=""),p.verifyArrayMax("ps",e.ps,5e3);},S.processCustom=function(e){p.notexist(e.custom)&&(e.custom="");},S.sendCmd=function(){this.protocol.sendCmd.apply(this.protocol,arguments);},S.sendCmdWithResp=function(e,t,n){this.sendCmd(e,t,function(e,t,r){p.isFunction(n)&&(e?n(e,t):n(null,r));});},S.cbAndSendCmd=function(e,t){var n=this.processCallbackPromise(t);return this.sendCmd(e,t),n;},S.sendCmdUsePromise=function(e,t){var n=this;return new l(function(r,o){n.sendCmd(e,t,function(e,t,n){if(e)o(e);else{var i=p.merge({},t,n);r(i);}});});},b.use=function(e,t){e&&e.install&&p.isFunction(e.install)&&e.install(this,t);},b.rmAllInstances=function(){for(var e in T){T[e].destroy();}T={};},S.logout=function(e){e=e||{},this.protocol.shouldReconnect=!1,this.protocol.doLogout=!0,this.processCallback(e),this.sendCmd("logout",e,e.callback),this.protocol.statusProtector.emit("auth/loginLifeCycleLogout");},e.exports=b,n(567),n(568),n(619),n(620),n(630),n(634);},function(e,t,n){var r=n(126),o=n(235);e.exports=function(e,t,n){return(t=o(t))in e?r(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e;},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(241);},function(e,t,n){e.exports=n(459);},function(e,t,n){e.exports=n(462);},function(e,t,n){e.exports=n(465);},function(e,t,n){var r=n(71),o=n(30),i=n(5),s=n(17),a=n(185),c=n(4),u=n(88),l=n(9),m=n(2),p=n(10),d=n(27),f=n(54),g=n(23),h=n(0),y=h.undef,v=n(14),b=n(39),T=n(110).StatusProtector,S=n(90),M=S.ReporterHook,k=S.EMSyncType,x=n(635);function C(e){h.undef(e.secure)&&(e.secure=!0),this.options=e,this.keepNosSafeUrl=this.options.keepNosSafeUrl||!1;var t=e.defaultLink||e.defaultLinkUrl;h.notundef(t)&&h.isString(t)&&(v.optionDefaultLinkUrl=r(t).call(t)),h.notundef(e.ipv6DefaultLink)&&h.isString(e.ipv6DefaultLink)&&(v.optionIpv6DefaultLinkUrl=e.ipv6DefaultLink),"number"==typeof e.heartbeatInterval&&(v.heartbeatInterval=e.heartbeatInterval),o(e.nosLbsUrls)&&(v.nosLbsUrls=e.nosLbsUrls),this.init(),this.connect();}var I=C.fn=C.prototype;I.init=function(){var e=this;this.logger=this.options.logger,this.getNosOriginUrlReqNum=0,this.checkNosReqNum=0,this.cmdTaskArray=[],this.timerMap={},this.cmdCallbackMap={},this.cmdContentMap={},this.initConnect(),this.reset(),this.statusProtector=new T(this),this.reporterHook=new M(this,this.options.reporterHookConfig),this.promiseAbortManager=new x(),this.statusProtector.on("auth/loginLifeCycleLogout",function(){e.promiseAbortManager.clear();}),this.statusProtector.on("auth/loginLifeCycleLoginSucc",function(){e.reporterHook.reset(),e.reporterHook.setOriginTimetick();});},I.reset=function(){y(this.options.thumbnailToStatic)&&(this.options.thumbnailToStatic=!0),this.resetConnect();},I.setOptions=function(e){var t=this.options,n=i(t),r=i(e),o=["onconnect","onerror","onwillreconnect","ondisconnect","onloginportschange","onmyinfo","onblacklist","onmutelist","onfriends","onusers","onrobots","onteams","onSuperTeams","onsessions","onSessionsWithMoreRoaming","onStickTopSessions","onroamingmsgs","onofflinemsgs","onofflinefiltermsgs","onroamingsysmsgs","onofflinesysmsgs","onofflinefiltersysmsgs","onofflinecustomsysmsgs","onofflinefiltercustomsysmsgs","onbroadcastmsg","onbroadcastmsgs","onsysmsgunread","onsyncdone","onteammembers","onsyncteammembersdone","onmsg","onsysmsg","oncustomsysmsg","onupdatemyinfo","onupdateuser","onSyncUpdateServerSession","onUpdateSuperTeamMember","onMySuperTeamMembers","onCreateSuperTeam","onUpdateSuperTeam","onAddSuperTeamMembers","onRemoveSuperTeamMembers","onUpdateSuperTeamManagers","onDismissSuperTeam","onTransferSuperTeam","onUpdateSuperTeamMembersMute","onupdateteammember","onMyTeamMembers","onMsgReceipts","onCreateTeam","onUpdateTeam","onAddTeamMembers","onRemoveTeamMembers","onUpdateTeamManagers","onDismissTeam","onTransferTeam","onUpdateTeamMembersMute","onTeamMsgReceipt","onupdatesession","onQuickComment","onDeleteQuickComment","onPinMsgChange","onupdatesysmsgunread","onupdatesysmsg","onsynccreateteam","onsyncsupercreateteam","onsyncmarkinblacklist","onsyncmarkinmutelist","onsyncfriendaction","shouldIgnoreNotification","shouldIgnoreMsg","onDeleteMsgSelf","shouldCountNotifyUnread","onPushNotificationMultiportConfig","onPushNotificationMultiportConfigUpdate","onpushevents"],l=s(r).call(r,function(e){return a(o).call(o,e);}),m=c(n).call(n,"account");h.verifyCallback(e,l,"protocol::IMProtocol"),this.logger.info("setOptions::",h.omitAsString(e,["appKey","token","loginExt","customTag"])),-1!==m&&u(n).call(n,m,1),e=h.filterObj(e,n),this.options=h.merge(t,e),this.reset();},I.sendCmd=function(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",r=arguments.length>2?arguments[2]:void 0,o=this;o.heartbeat();var s,a=e,c=(e=o.parser.createCmd(e,n)).SER;n=n||{},o.cmdContentMap[c]=n,n.single&&(delete n.single,1===(s=i(n)).length&&(o.cmdContentMap[c]=n[s[0]])),n.__exceptionInfo={target:l(t="".concat(e.SID,"-")).call(t,e.CID),context:c,startTime:o.reporterHook.getSafeClock()},n.NOTSTORE&&(s=n.NOTSTORE.split(" "),m(s).call(s,function(e){delete n[e];}),delete n.NOTSTORE),(r=r||n.callback)&&(o.cmdCallbackMap[c]=r),o.cmdTaskArray.push({cmdName:a,cmd:p(e)}),o.startCmdTaskTimer();},I.startCmdTaskTimer=function(){var e=this;e.cmdTaskTimer||(e.cmdTaskTimer=d(function(){var t=e.cmdTaskArray.shift();e.cmdTaskTimer=null,t&&e.executeCmdTask(t),e.cmdTaskArray.length&&e.startCmdTaskTimer();},0));},I.executeCmdTask=function(e){var t=e.cmdName,n=e.cmd,r=(n=JSON.parse(n)).SER;this.isFrequencyControlled(t)?(this.logger.warn("protocol::executeCmdTask: ".concat(t," hit freq control")),this.markCallbackInvalid(r,b.newFrequencyControlError({callFunc:"protocol::executeCmdTask",message:"".concat(t," hit freq control")}))):this.hasLogin?("heartbeat"!==t&&(this.logger.debugEnable?this.logger.debug("protocol::sendCmd: ".concat(e.cmd)):this.logger.info("protocol::sendCmd: ".concat(t))),this.doSendCmd(n)):"login"===t&&this.isConnected()?(this.logger.debugEnable?this.logger.debug("protocol::sendCmd: ".concat(e.cmd)):this.logger.info("protocol::sendCmd: ".concat(t)),this.doSendCmd(n)):(this.logger.warn("protocol::executeCmdTask: ".concat(t," not connected or login")),this.markCallbackInvalid(r,b.newSocketStateError({callFunc:"protocol::executeCmdTask",message:"".concat(t," not connected or not login")})));},I.isFrequencyControlled=function(e){var t=this.frequencyControlMap&&this.frequencyControlMap[e];if(t){if(f()<t.from+t.duration)return!0;delete this.frequencyControlMap[e];}},I.doSendCmd=function(e){var t=this,n=e.SER,r=0===n?v.hbCmdTimeout:v.cmdTimeout,o=new Date().getTime(),i=t.cmdContentMap[n];function s(){t.markCallbackInvalid(n,b.newSocketStateError({callFunc:"protocol::doSendCmd",message:"ser ".concat(n," socketSendJson Error")})),t.onDisconnect("protocol::doSendCmd:socketSendJson","broken");}i&&i.__exceptionInfo&&(i.__exceptionInfo.startTime=f()),e.isAwaitable&&(t.timerMap[n]=d(function(){var r;t.markCallbackInvalid(n,b.newTimeoutError({callFunc:"protocol::doSendCmd",message:"ser ".concat(n," Timeout Error")})),t.reporter.reportTraceStart("exceptions",{user_id:h.get(t,"options.account")||"",trace_id:h.get(t,"socket.socket.sessionid"),start_time:o,action:2}),t.reporter.reportTraceUpdateV2("exceptions",{code:408,description:"Packet timeout",operation_type:1,target:l(r="".concat(e.SID,"-")).call(r,e.CID),context:"".concat(e.SER),net_connect:t.checkNetworkAvailable()}),t.reporter.reportTraceEnd("exceptions",1);},r));try{t.socket&&t.socket.send?t.socket.send(p(e)):s();}catch(e){s();}},I.getObjWithSer=function(e){var t=this.cmdContentMap[e];return t&&!t.isImSyncDataObj&&delete this.cmdContentMap[e],t&&h.copy(t);},I.getCallbackWithSer=function(e){var t=this.cmdCallbackMap[e];return t&&!t.isImSyncDataCb&&delete this.cmdCallbackMap[e],t;},I.getTimerWithSer=function(e){var t=this.timerMap[e];return delete this.timerMap[e],t;},I.clearTimerWithSer=function(e){var t=this.getTimerWithSer(e);t&&clearTimeout(t);},I.markCallbackInvalid=function(e,t){this.getObjWithSer(e),this.clearTimerWithSer(e);var n=this.getCallbackWithSer(e);if(n){var r=n.options;d(function(){n(t||b.newUnknownError({ser:e}),r);},0);}},I.markAllCallbackInvalid=function(e){var t,n,r=this;m(t=i(this.cmdCallbackMap)).call(t,function(t){var n=r.getObjWithSer(t);if(n.__exceptionInfo){var o=n.__exceptionInfo.target,i=n.__exceptionInfo.context,s=h.get(e,"event.uploadCode")||e&&e.code;s="number"!=typeof s?415:s;var a=h.get(e,"event.disconnectReason"),c=a?p({disconnect_reason:a}):e&&e.message||"send cmd failed";r.reporter.reportTraceStart("exceptions",{user_id:h.get(r,"options.account")||"",trace_id:h.get(r,"socket.socket.sessionid"),start_time:r.reporterHook.getNTPTime(n.__exceptionInfo.startTime),action:2}),r.reporter.reportTraceUpdateV2("exceptions",{code:s,description:c,operation_type:1,target:o,context:i,net_connect:r.checkNetworkAvailable()}),r.reporter.reportTraceEnd("exceptions",1),delete n.__exceptionInfo;}}),m(n=i(this.cmdCallbackMap)).call(n,function(t){r.markCallbackInvalid(t,e);}),r.cmdTaskArray=[];},I.getPacketObj=function(e){var t=null;if(e&&e.raw){var n=e.raw.ser;h.notundef(n)&&(t=this.getObjWithSer(n));}return t;},I.callPacketAckCallback=function(e){var t=this;if(e&&e.raw){var n=e.raw.ser;if(h.notundef(n)){t.clearTimerWithSer(n);var r=t.getCallbackWithSer(n);if(r){var o;if(r.originUrl&&e.obj&&e.obj.file)if(e.obj.file._url_safe=e.obj.file.url,e.obj.file.url=r.originUrl,"audio"===e.obj.type)e.obj.file.mp3Url=r.originUrl+(~c(o=r.originUrl).call(o,"?")?"&":"?")+"audioTrans&type=mp3";e.promise?e.promise.then(function(){r(e.error,e.obj);},function(o){var i,s;o.callFunc="protocol::callPacketAckCallback",o.message=l(i=l(s="Resp Promoise Error: cmd: ".concat(e.cmd,", ser: ")).call(s,n,", reason: ")).call(i,o.message);var a=b.customError("CALLBACK_ACK_ERR",o);t.logger.error("protocol::callPacketAckCallback error stack: \n".concat(o.stack||o.event&&o.event.stack)),r(a,e.obj,e.content);}):r(e.error,e.obj,e.content);}}}},I.onMessage=function(e){var t=this;t.heartbeat(),t.parser.parseResponse(e).then(function(e){var n;if(e.notFound&&t.logger.warn("protocol::onMessage: packet not found ".concat(p(e))),e.error){var r,i;e.error.message=l(r="".concat(e.cmd," error: ")).call(r,e.error.message),t.logger.error(l(i="protocol::onMessage: packet error ".concat(p(e.error),"，raw cmd ")).call(i,e.rawStr));var a=e.raw||{};408!==a.code&&415!==a.code&&500!==a.code||t.reporter.report("nimErrEvent",{code:a.code,module:e.cmd,accid:t.account});}e.__receiveTime=t.reporterHook.getSafeClock();var c=k[l(n="kSyncType".concat(e.raw.sid,"_")).call(n,e.raw.cid)];if(c){var u=h.get(e,"raw.r"),m=1;if(u&&u.length>0){var f=s(u).call(u,function(e){return o(e);}),y=h.get(f,"0.length");m="number"==typeof y?y:1;}t.reporterHook.emit("reporter/syncItem",c,m);}e.frequencyControlDuration&&(t.logger.error("protocol::onMessage: server freq control ".concat(p(e.cmd))),t.frequencyControlMap=t.frequencyControlMap||{},t.frequencyControlMap[e.cmd]={from:+new Date(),duration:e.frequencyControlDuration}),e.obj=t.getPacketObj(e),e.obj&&e.obj.__exceptionInfo&&delete e.obj.__exceptionInfo,"heartbeat"!==e.cmd&&(t.logger.debugEnable?t.logger.debug("protocol::recvCmd: ".concat(e.rawStr)):t.logger.log("protocol::recvCmd: ".concat(e.cmd)));var v="process"+h.capFirstLetter(e.service);if(t[v]){if("syncDone"===e.cmd){if(t.cmdCallbackMap[e.raw.ser]&&t.cmdCallbackMap[e.raw.ser].isImSyncDataCb){var b;t.cmdCallbackMap[e.raw.ser].isImSyncDataCb=!1;var T=g(b=function b(e,t){this.checkNosReqNum++,this.getNosOriginUrlReqNum<=0||this.checkNosReqNum>=20?this[e](t):d(T,300);}).call(b,t,v,e);d(function(){T.call(t,v,e);},10);}}else try{t[v](e);}catch(n){var S,M;t.logger.warn(l(S=l(M="protocol::onMessage: ".concat(v,".")).call(M,e.cmd," excute failed ")).call(S,e.obj?"":", maybe the packet timed out",": "),n.message);}}else t.logger.warn("protocol::onMessage: ".concat(v," not found"));t.callPacketAckCallback(e);});},I.onMiscError=function(e,t,n){t&&this.notifyError(e,t,n);},I.onCustomError=function(e,t){var n=b.customError(e,t),r=t.message||"未知错误";this.onMiscError(r,n);},I.notifyError=function(e,t,n){var r;this.isConnected()&&(this.logger.error(l(r="".concat(e||""," ")).call(r,this.name),t,n),this.options.onerror(t,n));},I.emitAPI=function(e){var t=e.type,n=e.obj;this.api.emit(t,n);},e.exports=C,n(636),n(638),n(639),n(640),n(641),n(642);},function(e,t,n){var r=n(92),o=Function.prototype,i=o.apply,s=o.call;e.exports="object"==(typeof Reflect==="undefined"?"undefined":_typeof(Reflect))&&Reflect.apply||(r?s.bind(i):function(){return s.apply(i,arguments);});},function(e,t,n){var r=n(13),o=r({}.toString),i=r("".slice);e.exports=function(e){return i(o(e),8,-1);};},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t};};},function(e,t,n){var r=n(65);e.exports=Array.isArray||function(e){return"Array"==r(e);};},function(e,t,n){var r=n(51);e.exports=function(e,t,n,o){return o&&o.enumerable?e[t]=n:r(e,t,n),e;};},function(e,t,n){n(84);var r=n(337),o=n(12),i=n(52),s=n(51),a=n(85),c=n(18)("toStringTag");for(var u in r){var l=o[u],m=l&&l.prototype;m&&i(m)!==c&&s(m,c,u),a[u]=a.Array;}},function(e,t,n){var r=n(482),o=n(487);e.exports=function(e,t){var n=o(e,t);return r(n)?n:void 0;};},function(e,t,n){e.exports=n(558);},function(e,t,n){e.exports=n(453);},function(e,t,n){(function(t){var r=n(16),o=n(4),i=n(282),s=n(48),a=n(22);var c=function(){"use strict";var e="object"===(void 0===t?"undefined":a(t))?t:window,n=Math.pow(2,53)-1,c=/\bOpera/,u=Object.prototype,l=u.hasOwnProperty,m=u.toString;function p(e){return(e=String(e)).charAt(0).toUpperCase()+r(e).call(e,1);}function d(e){return e=v(e),/^(?:webOS|i(?:OS|P))/.test(e)?e:p(e);}function f(e,t){for(var n in e){l.call(e,n)&&t(e[n],n,e);}}function g(e){var t;return null==e?p(e):r(t=m.call(e)).call(t,8,-1);}function h(e){return String(e).replace(/([ -])(?!$)/g,"$1?");}function y(e,t){var r=null;return function(e,t){var r=-1,o=e?e.length:0;if("number"==typeof o&&o>-1&&o<=n)for(;++r<o;){t(e[r],r,e);}else f(e,t);}(e,function(n,o){r=t(r,n,o,e);}),r;}function v(e){return String(e).replace(/^ +| +$/g,"");}return function t(n){var u=e,l=n&&"object"===a(n)&&"String"!=g(n);l&&(u=n,n=null);var p=u.navigator||{},b=p.userAgent||"";n||(n=b);var T,S,M,k,x,C=l?!!p.likeChrome:/\bChrome\b/.test(n)&&!/internal|\n/i.test(m.toString()),I=l?"Object":"ScriptBridgingProxyObject",_=l?"Object":"Environment",w=l&&u.java?"JavaPackage":g(u.java),P=l?"Object":"RuntimeObject",A=/\bJava/.test(w)&&u.java,O=A&&g(u.environment)==_,E=A?"a":"α",R=A?"b":"β",j=u.document||{},N=u.operamini||u.opera,U=c.test(U=l&&N?N["[[Class]]"]:g(N))?U:N=null,D=n,L=[],F=null,B=n==b,q=B&&N&&"function"==typeof N.version&&N.version(),H=y([{label:"EdgeHTML",pattern:"Edge"},"Trident",{label:"WebKit",pattern:"AppleWebKit"},"iCab","Presto","NetFront","Tasman","KHTML","Gecko"],function(e,t){return e||RegExp("\\b"+(t.pattern||h(t))+"\\b","i").exec(n)&&(t.label||t);}),z=function(e){return y(e,function(e,t){return e||RegExp("\\b"+(t.pattern||h(t))+"\\b","i").exec(n)&&(t.label||t);});}(["Adobe AIR","Arora","Avant Browser","Breach","Camino","Electron","Epiphany","Fennec","Flock","Galeon","GreenBrowser","iCab","Iceweasel","K-Meleon","Konqueror","Lunascape","Maxthon",{label:"Microsoft Edge",pattern:"Edge"},"Midori","Nook Browser","PaleMoon","PhantomJS","Raven","Rekonq","RockMelt",{label:"Samsung Internet",pattern:"SamsungBrowser"},"SeaMonkey",{label:"Silk",pattern:"(?:Cloud9|Silk-Accelerated)"},"Sleipnir","SlimBrowser",{label:"SRWare Iron",pattern:"Iron"},"Sunrise","Swiftfox","Waterfox","WebPositive","Opera Mini",{label:"Opera Mini",pattern:"OPiOS"},"Opera",{label:"Opera",pattern:"OPR"},"Chrome",{label:"Chrome",pattern:"(?:HeadlessChrome)"},{label:"Chrome Mobile",pattern:"(?:CriOS|CrMo)"},{label:"Firefox",pattern:"(?:Firefox|Minefield)"},{label:"Firefox for iOS",pattern:"FxiOS"},{label:"IE",pattern:"IEMobile"},{label:"IE",pattern:"MSIE"},"Safari"]),W=J([{label:"BlackBerry",pattern:"BB10"},"BlackBerry",{label:"Galaxy S",pattern:"GT-I9000"},{label:"Galaxy S2",pattern:"GT-I9100"},{label:"Galaxy S3",pattern:"GT-I9300"},{label:"Galaxy S4",pattern:"GT-I9500"},{label:"Galaxy S5",pattern:"SM-G900"},{label:"Galaxy S6",pattern:"SM-G920"},{label:"Galaxy S6 Edge",pattern:"SM-G925"},{label:"Galaxy S7",pattern:"SM-G930"},{label:"Galaxy S7 Edge",pattern:"SM-G935"},"Google TV","Lumia","iPad","iPod","iPhone","Kindle",{label:"Kindle Fire",pattern:"(?:Cloud9|Silk-Accelerated)"},"Nexus","Nook","PlayBook","PlayStation Vita","PlayStation","TouchPad","Transformer",{label:"Wii U",pattern:"WiiU"},"Wii","Xbox One",{label:"Xbox 360",pattern:"Xbox"},"Xoom"]),V=function(e){return y(e,function(e,t,r){return e||(t[W]||t[/^[a-z]+(?: +[a-z]+\b)*/i.exec(W)]||RegExp("\\b"+h(r)+"(?:\\b|\\w*\\d)","i").exec(n))&&r;});}({Apple:{iPad:1,iPhone:1,iPod:1},Archos:{},Amazon:{Kindle:1,"Kindle Fire":1},Asus:{Transformer:1},"Barnes & Noble":{Nook:1},BlackBerry:{PlayBook:1},Google:{"Google TV":1,Nexus:1},HP:{TouchPad:1},HTC:{},LG:{},Microsoft:{Xbox:1,"Xbox One":1},Motorola:{Xoom:1},Nintendo:{"Wii U":1,Wii:1},Nokia:{Lumia:1},Samsung:{"Galaxy S":1,"Galaxy S2":1,"Galaxy S3":1,"Galaxy S4":1},Sony:{PlayStation:1,"PlayStation Vita":1}}),G=function(e){return y(e,function(e,t){var r=t.pattern||h(t);return!e&&(e=RegExp("\\b"+r+"(?:/[\\d.]+|[ \\w.]*)","i").exec(n))&&(e=function(e,t,n){var r={"10.0":"10",6.4:"10 Technical Preview",6.3:"8.1",6.2:"8",6.1:"Server 2008 R2 / 7","6.0":"Server 2008 / Vista",5.2:"Server 2003 / XP 64-bit",5.1:"XP",5.01:"2000 SP1","5.0":"2000","4.0":"NT","4.90":"ME"};return t&&n&&/^Win/i.test(e)&&!/^Windows Phone /i.test(e)&&(r=r[/[\d.]+$/.exec(e)])&&(e="Windows "+r),e=String(e),t&&n&&(e=e.replace(RegExp(t,"i"),n)),e=d(e.replace(/ ce$/i," CE").replace(/\bhpw/i,"web").replace(/\bMacintosh\b/,"Mac OS").replace(/_PowerPC\b/i," OS").replace(/\b(OS X) [^ \d]+/i,"$1").replace(/\bMac (OS X)\b/,"$1").replace(/\/(\d)/," $1").replace(/_/g,".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i,"").replace(/\bx86\.64\b/gi,"x86_64").replace(/\b(Windows Phone) OS\b/,"$1").replace(/\b(Chrome OS \w+) [\d.]+\b/,"$1").split(" on ")[0]);}(e,r,t.label||t)),e;});}(["Windows Phone","Android","CentOS",{label:"Chrome OS",pattern:"CrOS"},"Debian","Fedora","FreeBSD","Gentoo","Haiku","Kubuntu","Linux Mint","OpenBSD","Red Hat","SuSE","Ubuntu","Xubuntu","Cygwin","Symbian OS","hpwOS","webOS ","webOS","Tablet OS","Tizen","Linux","Mac OS X","Macintosh","Mac","Windows 98;","Windows "]);function J(e){return y(e,function(e,t){var r=t.pattern||h(t);return!e&&(e=RegExp("\\b"+r+" *\\d+[.\\w_]*","i").exec(n)||RegExp("\\b"+r+" *\\w+-[\\w]*","i").exec(n)||RegExp("\\b"+r+"(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)","i").exec(n))&&((e=String(t.label&&!RegExp(r,"i").test(t.label)?t.label:e).split("/"))[1]&&!/[\d.]+/.test(e[0])&&(e[0]+=" "+e[1]),t=t.label||t,e=d(e[0].replace(RegExp(r,"i"),t).replace(RegExp("; *(?:"+t+"[_-])?","i")," ").replace(RegExp("("+t+")[-_.]?(\\w)","i"),"$1 $2"))),e;});}if(H&&(H=[H]),V&&!W&&(W=J([V])),(T=/\bGoogle TV\b/.exec(W))&&(W=T[0]),/\bSimulator\b/i.test(n)&&(W=(W?W+" ":"")+"Simulator"),"Opera Mini"==z&&/\bOPiOS\b/.test(n)&&L.push("running in Turbo/Uncompressed mode"),"IE"==z&&/\blike iPhone OS\b/.test(n)?(V=(T=t(n.replace(/like iPhone OS/,""))).manufacturer,W=T.product):/^iP/.test(W)?(z||(z="Safari"),G="iOS"+((T=/ OS ([\d_]+)/i.exec(n))?" "+T[1].replace(/_/g,"."):"")):"Konqueror"!=z||/buntu/i.test(G)?V&&"Google"!=V&&(/Chrome/.test(z)&&!/\bMobile Safari\b/i.test(n)||/\bVita\b/.test(W))||/\bAndroid\b/.test(G)&&/^Chrome/.test(z)&&/\bVersion\//i.test(n)?(z="Android Browser",G=/\bAndroid\b/.test(G)?G:"Android"):"Silk"==z?(/\bMobi/i.test(n)||(G="Android",L.unshift("desktop mode")),/Accelerated *= *true/i.test(n)&&L.unshift("accelerated")):"PaleMoon"==z&&(T=/\bFirefox\/([\d.]+)\b/.exec(n))?L.push("identifying as Firefox "+T[1]):"Firefox"==z&&(T=/\b(Mobile|Tablet|TV)\b/i.exec(n))?(G||(G="Firefox OS"),W||(W=T[1])):!z||(T=!/\bMinefield\b/i.test(n)&&/\b(?:Firefox|Safari)\b/.exec(z))?(z&&!W&&/[\/,]|^[^(]+?\)/.test(r(n).call(n,o(n).call(n,T+"/")+8))&&(z=null),(T=W||V||G)&&(W||V||/\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(G))&&(z=/[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(G)?G:T)+" Browser")):"Electron"==z&&(T=(/\bChrome\/([\d.]+)\b/.exec(n)||0)[1])&&L.push("Chromium "+T):G="Kubuntu",q||(q=y(["(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$))","Version","HeadlessChrome",h(z),"(?:Firefox|Minefield|NetFront)"],function(e,t){return e||(RegExp(t+"(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)","i").exec(n)||0)[1]||null;})),(T=("iCab"==H&&i(q)>3?"WebKit":/\bOpera\b/.test(z)&&(/\bOPR\b/.test(n)?"Blink":"Presto"))||/\b(?:Midori|Nook|Safari)\b/i.test(n)&&!/^(?:Trident|EdgeHTML)$/.test(H)&&"WebKit"||!H&&/\bMSIE\b/i.test(n)&&("Mac OS"==G?"Tasman":"Trident")||"WebKit"==H&&/\bPlayStation\b(?! Vita\b)/i.test(z)&&"NetFront")&&(H=[T]),"IE"==z&&(T=(/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(n)||0)[1])?(z+=" Mobile",G="Windows Phone "+(/\+$/.test(T)?T:T+".x"),L.unshift("desktop mode")):/\bWPDesktop\b/i.test(n)?(z="IE Mobile",G="Windows Phone 8.x",L.unshift("desktop mode"),q||(q=(/\brv:([\d.]+)/.exec(n)||0)[1])):"IE"!=z&&"Trident"==H&&(T=/\brv:([\d.]+)/.exec(n))&&(z&&L.push("identifying as "+z+(q?" "+q:"")),z="IE",q=T[1]),B){if(k="global",x=null!=(M=u)?a(M[k]):"number",/^(?:boolean|number|string|undefined)$/.test(x)||"object"==x&&!M[k])g(T=u.runtime)==I?(z="Adobe AIR",G=T.flash.system.Capabilities.os):g(T=u.phantom)==P?(z="PhantomJS",q=(T=T.version||null)&&T.major+"."+T.minor+"."+T.patch):"number"==typeof j.documentMode&&(T=/\bTrident\/(\d+)/i.exec(n))?(q=[q,j.documentMode],(T=+T[1]+4)!=q[1]&&(L.push("IE "+q[1]+" mode"),H&&(H[1]=""),q[1]=T),q="IE"==z?String(q[1].toFixed(1)):q[0]):"number"==typeof j.documentMode&&/^(?:Chrome|Firefox)\b/.test(z)&&(L.push("masking as "+z+" "+q),z="IE",q="11.0",H=["Trident"],G="Windows");else if(A&&(D=(T=A.lang.System).getProperty("os.arch"),G=G||T.getProperty("os.name")+" "+T.getProperty("os.version")),O){try{q=u.require("ringo/engine").version.join("."),z="RingoJS";}catch(e){(T=u.system)&&T.global.system==u.system&&(z="Narwhal",G||(G=T[0].os||null));}z||(z="Rhino");}else"object"===a(u.process)&&!u.process.browser&&(T=u.process)&&("object"===a(T.versions)&&("string"==typeof T.versions.electron?(L.push("Node "+T.versions.node),z="Electron",q=T.versions.electron):"string"==typeof T.versions.nw&&(L.push("Chromium "+q,"Node "+T.versions.node),z="NW.js",q=T.versions.nw)),z||(z="Node.js",D=T.arch,G=T.platform,q=(q=/[\d.]+/.exec(T.version))?q[0]:null));G=G&&d(G);}if(q&&(T=/(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(q)||/(?:alpha|beta)(?: ?\d)?/i.exec(n+";"+(B&&p.appMinorVersion))||/\bMinefield\b/i.test(n)&&"a")&&(F=/b/i.test(T)?"beta":"alpha",q=q.replace(RegExp(T+"\\+?$"),"")+("beta"==F?R:E)+(/\d+\+?/.exec(T)||"")),"Fennec"==z||"Firefox"==z&&/\b(?:Android|Firefox OS)\b/.test(G))z="Firefox Mobile";else if("Maxthon"==z&&q)q=q.replace(/\.[\d.]+/,".x");else if(/\bXbox\b/i.test(W))"Xbox 360"==W&&(G=null),"Xbox 360"==W&&/\bIEMobile\b/.test(n)&&L.unshift("mobile mode");else if(!/^(?:Chrome|IE|Opera)$/.test(z)&&(!z||W||/Browser|Mobi/.test(z))||"Windows CE"!=G&&!/Mobi/i.test(n)){if("IE"==z&&B)try{null===u.external&&L.unshift("platform preview");}catch(e){L.unshift("embedded");}else(/\bBlackBerry\b/.test(W)||/\bBB10\b/.test(n))&&(T=(RegExp(W.replace(/ +/g," *")+"/([.\\d]+)","i").exec(n)||0)[1]||q)?(G=((T=[T,/BB10/.test(n)])[1]?(W=null,V="BlackBerry"):"Device Software")+" "+T[0],q=null):this!=f&&"Wii"!=W&&(B&&N||/Opera/.test(z)&&/\b(?:MSIE|Firefox)\b/i.test(n)||"Firefox"==z&&/\bOS X (?:\d+\.){2,}/.test(G)||"IE"==z&&(G&&!/^Win/.test(G)&&q>5.5||/\bWindows XP\b/.test(G)&&q>8||8==q&&!/\bTrident\b/.test(n)))&&!c.test(T=t.call(f,n.replace(c,"")+";"))&&T.name&&(T="ing as "+T.name+((T=T.version)?" "+T:""),c.test(z)?(/\bIE\b/.test(T)&&"Mac OS"==G&&(G=null),T="identify"+T):(T="mask"+T,z=U?d(U.replace(/([a-z])([A-Z])/g,"$1 $2")):"Opera",/\bIE\b/.test(T)&&(G=null),B||(q=null)),H=["Presto"],L.push(T));}else z+=" Mobile";if(T=(/\bAppleWebKit\/([\d.]+\+?)/i.exec(n)||0)[1]){var Q,K;if(T=[i(T.replace(/\.(\d)$/,".0$1")),T],"Safari"==z&&"+"==r(Q=T[1]).call(Q,-1))z="WebKit Nightly",F="alpha",q=r(K=T[1]).call(K,0,-1);else q!=T[1]&&q!=(T[2]=(/\bSafari\/([\d.]+\+?)/i.exec(n)||0)[1])||(q=null);T[1]=(/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(n)||0)[1],537.36==T[0]&&537.36==T[2]&&i(T[1])>=28&&"WebKit"==H&&(H=["Blink"]),B&&(C||T[1])?(H&&(H[1]="like Chrome"),T=T[1]||((T=T[0])<530?1:T<532?2:T<532.05?3:T<533?4:T<534.03?5:T<534.07?6:T<534.1?7:T<534.13?8:T<534.16?9:T<534.24?10:T<534.3?11:T<535.01?12:T<535.02?"13+":T<535.07?15:T<535.11?16:T<535.19?17:T<536.05?18:T<536.1?19:T<537.01?20:T<537.11?"21+":T<537.13?23:T<537.18?24:T<537.24?25:T<537.36?26:"Blink"!=H?"27":"28")):(H&&(H[1]="like Safari"),T=(T=T[0])<400?1:T<500?2:T<526?3:T<533?4:T<534?"4+":T<535?5:T<537?6:T<538?7:T<601?8:"8"),H&&(H[1]+=" "+(T+="number"==typeof T?".x":/[.+]/.test(T)?"":"+")),"Safari"==z&&(!q||s(q)>45)&&(q=T);}"Opera"==z&&(T=/\bzbov|zvav$/.exec(G))?(z+=" ",L.unshift("desktop mode"),"zvav"==T?(z+="Mini",q=null):z+="Mobile",G=G.replace(RegExp(" *"+T+"$"),"")):"Safari"==z&&/\bChrome\b/.exec(H&&H[1])&&(L.unshift("desktop mode"),z="Chrome Mobile",q=null,/\bOS X\b/.test(G)?(V="Apple",G="iOS 4.3+"):G=null),q&&0==o(q).call(q,T=/[\d.]+$/.exec(G))&&o(n).call(n,"/"+T+"-")>-1&&(G=v(G.replace(T,""))),H&&!/\b(?:Avant|Nook)\b/.test(z)&&(/Browser|Lunascape|Maxthon/.test(z)||"Safari"!=z&&/^iOS/.test(G)&&/\bSafari\b/.test(H[1])||/^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|Web)/.test(z)&&H[1])&&(T=H[H.length-1])&&L.push(T),L.length&&(L=["("+L.join("; ")+")"]),V&&W&&o(W).call(W,V)<0&&L.push("on "+V),W&&L.push((/^on /.test(L[L.length-1])?"":"on ")+W),G&&(T=/ ([\d.+]+)$/.exec(G),S=T&&"/"==G.charAt(G.length-T[0].length-1),G={architecture:32,family:T&&!S?G.replace(T[0],""):G,version:T?T[1]:null,toString:function toString(){var e=this.version;return this.family+(e&&!S?" "+e:"")+(64==this.architecture?" 64-bit":"");}}),(T=/\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(D))&&!/\bi686\b/i.test(D)?(G&&(G.architecture=64,G.family=G.family.replace(RegExp(" *"+T),"")),z&&(/\bWOW64\b/i.test(n)||B&&/\w(?:86|32)$/.test(p.cpuClass||p.platform)&&!/\bWin64; x64\b/i.test(n))&&L.unshift("32-bit")):G&&/^OS X/.test(G.family)&&"Chrome"==z&&i(q)>=39&&(G.architecture=64),n||(n=null);var $={};return $.description=n,$.layout=H&&H[0],$.manufacturer=V,$.name=z,$.prerelease=F,$.product=W,$.ua=n,$.version=z&&q,$.os=G||{architecture:null,family:null,version:null,toString:function toString(){return"null";}},$.parse=t,$.toString=function(){return this.description||"";},$.version&&L.unshift(q),$.name&&L.unshift(z),G&&z&&(G!=String(G).split(" ")[0]||G!=z.split(" ")[0]&&!W)&&L.push(W?"("+G+")":"on "+G),L.length&&($.description=L.join(" ")),$;}();}();e.exports=c;}).call(this,n(49));},function(e,t,n){(function(t){var r;e.exports=(r=r||function(e,r){var o;if("undefined"!=typeof window&&window.crypto&&(o=window.crypto),"undefined"!=typeof self&&self.crypto&&(o=self.crypto),"undefined"!=typeof globalThis&&globalThis.crypto&&(o=globalThis.crypto),!o&&"undefined"!=typeof window&&window.msCrypto&&(o=window.msCrypto),!o&&void 0!==t&&t.crypto&&(o=t.crypto),!o)try{o=n(808);}catch(e){}var i=function i(){if(o){if("function"==typeof o.getRandomValues)try{return o.getRandomValues(new Uint32Array(1))[0];}catch(e){}if("function"==typeof o.randomBytes)try{return o.randomBytes(4).readInt32LE();}catch(e){}}throw new Error("Native crypto module could not be used to get secure random number.");},s=Object.create||function(){function e(){}return function(t){var n;return e.prototype=t,n=new e(),e.prototype=null,n;};}(),a={},c=a.lib={},u=c.Base={extend:function extend(e){var t=s(this);return e&&t.mixIn(e),t.hasOwnProperty("init")&&this.init!==t.init||(t.init=function(){t.$super.init.apply(this,arguments);}),t.init.prototype=t,t.$super=this,t;},create:function create(){var e=this.extend();return e.init.apply(e,arguments),e;},init:function init(){},mixIn:function mixIn(e){for(var t in e){e.hasOwnProperty(t)&&(this[t]=e[t]);}e.hasOwnProperty("toString")&&(this.toString=e.toString);},clone:function clone(){return this.init.prototype.extend(this);}},l=c.WordArray=u.extend({init:function init(e,t){e=this.words=e||[],this.sigBytes=null!=t?t:4*e.length;},toString:function toString(e){return(e||p).stringify(this);},concat:function concat(e){var t=this.words,n=e.words,r=this.sigBytes,o=e.sigBytes;if(this.clamp(),r%4)for(var i=0;i<o;i++){var s=n[i>>>2]>>>24-i%4*8&255;t[r+i>>>2]|=s<<24-(r+i)%4*8;}else for(var a=0;a<o;a+=4){t[r+a>>>2]=n[a>>>2];}return this.sigBytes+=o,this;},clamp:function clamp(){var t=this.words,n=this.sigBytes;t[n>>>2]&=4294967295<<32-n%4*8,t.length=e.ceil(n/4);},clone:function clone(){var e=u.clone.call(this);return e.words=this.words.slice(0),e;},random:function random(e){for(var t=[],n=0;n<e;n+=4){t.push(i());}return new l.init(t,e);}}),m=a.enc={},p=m.Hex={stringify:function stringify(e){for(var t=e.words,n=e.sigBytes,r=[],o=0;o<n;o++){var i=t[o>>>2]>>>24-o%4*8&255;r.push((i>>>4).toString(16)),r.push((15&i).toString(16));}return r.join("");},parse:function parse(e){for(var t=e.length,n=[],r=0;r<t;r+=2){n[r>>>3]|=parseInt(e.substr(r,2),16)<<24-r%8*4;}return new l.init(n,t/2);}},d=m.Latin1={stringify:function stringify(e){for(var t=e.words,n=e.sigBytes,r=[],o=0;o<n;o++){var i=t[o>>>2]>>>24-o%4*8&255;r.push(String.fromCharCode(i));}return r.join("");},parse:function parse(e){for(var t=e.length,n=[],r=0;r<t;r++){n[r>>>2]|=(255&e.charCodeAt(r))<<24-r%4*8;}return new l.init(n,t);}},f=m.Utf8={stringify:function stringify(e){try{return decodeURIComponent(escape(d.stringify(e)));}catch(e){throw new Error("Malformed UTF-8 data");}},parse:function parse(e){return d.parse(unescape(encodeURIComponent(e)));}},g=c.BufferedBlockAlgorithm=u.extend({reset:function reset(){this._data=new l.init(),this._nDataBytes=0;},_append:function _append(e){"string"==typeof e&&(e=f.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes;},_process:function _process(t){var n,r=this._data,o=r.words,i=r.sigBytes,s=this.blockSize,a=i/(4*s),c=(a=t?e.ceil(a):e.max((0|a)-this._minBufferSize,0))*s,u=e.min(4*c,i);if(c){for(var m=0;m<c;m+=s){this._doProcessBlock(o,m);}n=o.splice(0,c),r.sigBytes-=u;}return new l.init(n,u);},clone:function clone(){var e=u.clone.call(this);return e._data=this._data.clone(),e;},_minBufferSize:0}),h=(c.Hasher=g.extend({cfg:u.extend(),init:function init(e){this.cfg=this.cfg.extend(e),this.reset();},reset:function reset(){g.reset.call(this),this._doReset();},update:function update(e){return this._append(e),this._process(),this;},finalize:function finalize(e){return e&&this._append(e),this._doFinalize();},blockSize:16,_createHelper:function _createHelper(e){return function(t,n){return new e.init(n).finalize(t);};},_createHmacHelper:function _createHmacHelper(e){return function(t,n){return new h.HMAC.init(e,n).finalize(t);};}}),a.algo={});return a;}(Math),r);}).call(this,n(49));},function(e,t,n){var r=n(28),o=n(25),i=n(138),s=n(66),a=n(38),c=n(113),u=n(26),l=n(193),m=Object.getOwnPropertyDescriptor;t.f=r?m:function(e,t){if(e=a(e),t=c(t),l)try{return m(e,t);}catch(e){}if(u(e,t))return s(!o(i.f,e,t),e[t]);};},function(e,t,n){var r=n(77),o=n(8);e.exports=!!Object.getOwnPropertySymbols&&!o(function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&r&&r<41;});},function(e,t,n){var r,o,i=n(12),s=n(50),a=i.process,c=i.Deno,u=a&&a.versions||c&&c.version,l=u&&u.v8;l&&(o=(r=l.split("."))[0]>0&&r[0]<4?1:+(r[0]+r[1])),!o&&s&&(!(r=s.match(/Edge\/(\d+)/))||r[1]>=74)&&(r=s.match(/Chrome\/(\d+)/))&&(o=+r[1]),e.exports=o;},function(e,t){var n=String;e.exports=function(e){try{return n(e);}catch(e){return"Object";}};},function(e,t,n){var r=n(146),o=n(36),i=n(92),s=r(r.bind);e.exports=function(e,t){return o(e),void 0===t?e:i?s(e,t):function(){return e.apply(t,arguments);};};},function(e,t,n){"use strict";var r=n(8);e.exports=function(e,t){var n=[][e];return!!n&&r(function(){n.call(null,t||function(){return 1;},1);});};},function(e,t,n){"use strict";var r=n(113),o=n(43),i=n(66);e.exports=function(e,t,n){var s=r(t);s in e?o.f(e,s,i(0,n)):e[s]=n;};},function(e,t,n){var r,o=n(33),i=n(154),s=n(155),a=n(117),c=n(201),u=n(150),l=n(118),m=l("IE_PROTO"),p=function p(){},d=function d(e){return"<script>"+e+"<\/script>";},f=function f(e){e.write(d("")),e.close();var t=e.parentWindow.Object;return e=null,t;},_g=function g(){try{r=new ActiveXObject("htmlfile");}catch(e){}var e,t;_g="undefined"!=typeof document?document.domain&&r?f(r):((t=u("iframe")).style.display="none",c.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(d("document.F=Object")),e.close(),e.F):f(r);for(var n=s.length;n--;){delete _g.prototype[s[n]];}return _g();};a[m]=!0,e.exports=Object.create||function(e,t){var n;return null!==e?(p.prototype=o(e),n=new p(),p.prototype=null,n[m]=e):n=_g(),void 0===t?n:i.f(n,t);};},function(e,t,n){var r=n(153),o=n(43).f,i=n(51),s=n(26),a=n(315),c=n(18)("toStringTag");e.exports=function(e,t,n,u){if(e){var l=n?e:e.prototype;s(l,c)||o(l,c,{configurable:!0,value:t}),u&&!r&&i(l,"toString",a);}};},function(e,t,n){"use strict";var r=n(38),o=n(179),i=n(85),s=n(121),a=n(43).f,c=n(211),u=n(215),l=n(42),m=n(28),p=s.set,d=s.getterFor("Array Iterator");e.exports=c(Array,"Array",function(e,t){p(this,{type:"Array Iterator",target:r(e),index:0,kind:t});},function(){var e=d(this),t=e.target,n=e.kind,r=e.index++;return!t||r>=t.length?(e.target=void 0,u(void 0,!0)):u("keys"==n?r:"values"==n?t[r]:[r,t[r]],!1);},"values");var f=i.Arguments=i.Array;if(o("keys"),o("values"),o("entries"),!l&&m&&"values"!==f.name)try{a(f,"name",{value:"values"});}catch(e){}},function(e,t){e.exports={};},function(e,t){e.exports=function(e){try{return{error:!1,value:e()};}catch(e){return{error:!0,value:e};}};},function(e,t,n){var r=n(12);e.exports=r.Promise;},function(e,t,n){e.exports=n(410);},function(e,t,n){var r=n(79),o=n(13),i=n(111),s=n(37),a=n(40),c=n(152),u=o([].push),l=function l(e){var t=1==e,n=2==e,o=3==e,l=4==e,m=6==e,p=7==e,d=5==e||m;return function(f,g,h,y){for(var v,b,T=s(f),S=i(T),M=r(g,h),k=a(S),x=0,C=y||c,I=t?C(f,k):n||p?C(f,0):void 0;k>x;x++){if((d||x in S)&&(b=M(v=S[x],x,T),e))if(t)I[x]=b;else if(b)switch(e){case 3:return!0;case 5:return v;case 6:return x;case 2:u(I,v);}else switch(e){case 4:return!1;case 7:u(I,v);}}return m?-1:o||l?l:I;};};e.exports={forEach:l(0),map:l(1),filter:l(2),some:l(3),every:l(4),find:l(5),findIndex:l(6),filterReject:l(7)};},function(e,t,n){var r=n(593),o=n(54),i=n(3),s=n(27),a=n(23),c=n(9),u=n(48),l=n(17),m=n(2),p=n(5),d=n(7),f=n(180),g=n(35),h=n(182),y=n(183),v=n(597),b=n(611),T=n(613);function S(e){var t=function(){if("undefined"==typeof Reflect||!r)return!1;if(r.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(r(Boolean,[],function(){})),!0;}catch(e){return!1;}}();return function(){var n,o=T(e);if(t){var i=T(this).constructor;n=r(o,arguments,i);}else n=o.apply(this,arguments);return b(this,n);};}var M=n(157),k=n(0),x=n(14).heartbeatInterval,C=n(110).V2NIMLoginStatus,I=n(14),_={kSyncAction5_1:0,kSyncAction5_2:1,kSyncAction5_3:2},w={kKnown:-1,kSucceed:0,kFailed:1,kAborted:2,kCanceled:3},P=function(e){"use strict";v(n,e);var t=S(n);function n(e){var r,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return h(this,n),(r=t.call(this)).clientProto=e,r.logger=e.logger,r.reporter=e.reporter,r.timer=null,r.setClientOrigin(),r.serverOrigin={timeStamp:null,rtt:null,baseTimeStamp:null},r.tolerantRTT=o.tolerantRTT||3e3,r.bestRTT=o.bestRTT||100,r.maxChances=o.maxChances||10,r.isSettingNTP=!1,r.currentChance=0,r.syncTraceData={},r.syncTraceMap={},r.syncTraceLastItem={},r.uploadTraceData={},r.setMonitorForSync(),r.setMonitorForResources(),r;}return y(n,[{key:"hasOriginTimetick",value:function value(){return!!this.serverOrigin.timeStamp;}},{key:"setOriginTimetick",value:function value(){var e=this,t=this.clientProto.options;if(("boolean"==typeof k.get(t,"privateConf.isDataReportEnable")?t.privateConf.isDataReportEnable:I.privateConf.isDataReportEnable)&&I.isBrowser&&performance&&performance.now&&!(this.isSettingNTP||this.currentChance>=this.maxChances)){this.isSettingNTP=!0,this.currentChance++,clearTimeout(this.timer),this.timer=null;var n="ReporterHook::setOriginTimetick:",r=o();return this.logger.info("".concat(n," getServerTime start, times ").concat(this.currentChance)),new i(function(t){e.clientProto.sendCmd("getServerTime",{},function(i,u){if(e.isSettingNTP=!1,i){var l;e.logger.warn("".concat(n," Calculate Delay time, getServerTime error"),i),e.clientProto.statusProtector.getLoginStatus()===C.V2NIM_LOGIN_STATUS_LOGINED&&(e.timer=s(a(l=e.setOriginTimetick).call(l,e),x)),t();}else{if(!u)return e.logger.warn("".concat(n," Calculate Delay time, getServerTime not correct")),void t();var m,p=o()-r;if(p>e.tolerantRTT)e.logger.warn("".concat(n," Denied, cause of exceeding the maximum tolerance range of RTT: ").concat(p)),e.timer=s(a(m=e.setOriginTimetick).call(m,e),x);else if(p>e.bestRTT){var d,f,g;if(e.serverOrigin.rtt&&p>=e.serverOrigin.rtt)e.logger.info("".concat(n," Denied, cause of current.RTT >= serverOrigin.RTT: ").concat(p));else e.setServerOrigin(p,u),e.logger.info(c(f=c(g="".concat(n," Accept within maximum tolerance range of RTT: ").concat(p,", ntpTimestamp: ")).call(g,e.serverOrigin.timeStamp,", localClock: ")).call(f,e.serverOrigin.baseTimeStamp));e.timer=s(a(d=e.setOriginTimetick).call(d,e),x);}else{var h,y;e.setServerOrigin(p,u),e.logger.info(c(h=c(y="".concat(n," Accept within best RTT: ").concat(p,", ntpTimestamp: ")).call(y,e.serverOrigin.timeStamp,", localClock: ")).call(h,e.serverOrigin.baseTimeStamp));}t();}});});}}},{key:"getNTPTime",value:function value(e){if("number"!=typeof e&&(e=this.getSafeClock()),this.serverOrigin.timeStamp){var t=u(e-this.serverOrigin.baseTimeStamp);return this.serverOrigin.timeStamp+t;}var n=u(e-this.clientOrigin.baseTimeStamp);return this.clientOrigin.timeStamp+n;}},{key:"getSafeClock",value:function value(){return I.isBrowser&&performance&&performance.now?performance.now():o();}},{key:"setMonitorForSync",value:function value(){var e=this,t="ReporterHook::setMonitorForSync:";this.on("reporter/syncStart",function(){e.logger.info("".concat(t," sync start")),e.syncTraceData={user_id:e.clientProto.account,trace_id:k.get(e.clientProto,"socket.socket.sessionid"),action:_.kSyncAction5_1,sync_begin_time:e.getSafeClock(),sync_end_time:0,sync_duration:0,overall_duration:0,extension:[]};}),this.on("reporter/syncRecv",function(){e.syncTraceData.user_id&&(e.logger.info("".concat(t," sync receive packet")),e.syncTraceData.sync_end_time=e.getSafeClock(),e.syncTraceData.sync_duration=u(e.syncTraceData.sync_end_time-e.syncTraceData.sync_begin_time));}),this.on("reporter/syncItem",function(n,r){var o;if("number"==typeof n&&e.syncTraceData.user_id){e.logger.info(c(o="".concat(t," receive sync item: ").concat(n,", total: ")).call(o,r));var i=e.getSafeClock();e.syncTraceMap[n]=e.syncTraceMap[n]?e.syncTraceMap[n]:{sync_type:n,times:0,total:0,sync_duration:0,proc_duration:0,description:"",items:[]};var s={total:r,pre_item_recv_time:e.syncTraceLastItem.cur_item_recv_time?e.syncTraceLastItem.cur_item_recv_time:e.syncTraceData.sync_begin_time,cur_item_recv_time:i};e.syncTraceMap[n].items.push(s),e.syncTraceLastItem=s;}}),this.on("reporter/syncItemComplete",function(n){var r;if("number"==typeof n&&e.syncTraceData.user_id){var o=e.syncTraceMap[n];if(o){e.logger.info("".concat(t," sync item ").concat(n," callback done"));var i=l(r=o.items).call(r,function(e){return!e.callback_time;});if(0!==i.length)i[0].callback_time=e.getSafeClock();}}}),this.on("reporter/syncComplete",function(){var n;e.syncTraceData.user_id&&(e.logger.info("".concat(t," sync complete")),m(n=p(e.syncTraceMap)).call(n,function(t){var n,r=d(n=e.syncTraceMap[t].items).call(n,function(t){return{total:t.total,pre_item_recv_time:e.getNTPTime(t.pre_item_recv_time),cur_item_recv_time:e.getNTPTime(t.cur_item_recv_time),callback_time:e.getNTPTime(t.callback_time)};}),o=f(r).call(r,function(e,t){return e.times+=1,e.total+=t.total,e.sync_duration+=t.cur_item_recv_time-t.pre_item_recv_time,e.proc_duration+=t.callback_time-t.cur_item_recv_time,e;},{times:0,total:0,sync_duration:0,proc_duration:0});e.syncTraceMap[t].items=r,g(e.syncTraceMap[t],o),e.syncTraceData.extension.push(e.syncTraceMap[t]);}),e.syncTraceData.sync_begin_time=e.getNTPTime(e.syncTraceData.sync_begin_time),e.syncTraceData.sync_end_time=e.getNTPTime(e.syncTraceData.sync_end_time),e.syncTraceData.overall_duration=e.getNTPTime()-e.syncTraceData.sync_begin_time,e.reporter.report("nim_sdk_sync",e.syncTraceData),e.syncTraceData={},e.syncTraceMap={});});}},{key:"setMonitorForResources",value:function value(){var e=this,t="ReporterHook::setMonitorForResources:";this.on("reporter/uploadStart",function(){e.logger.info("".concat(t," upload start")),e.uploadTraceData={user_id:e.clientProto.account,trace_id:k.get(e.clientProto,"socket.socket.sessionid"),action:0,duration:0,start_time:e.getSafeClock(),offset:0,full_size:0,transferred_size:0};}),this.on("reporter/uploadUpdate",function(){var n,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e.uploadTraceData.user_id&&(e.logger.info("".concat(t," upload update"),r),m(n=p(r)).call(n,function(t){e.uploadTraceData[t]=r[t];}));}),this.on("reporter/uploadEnd",function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:w.kKnown;e.uploadTraceData.user_id&&(e.logger.info("".concat(t," upload end cause of ").concat(n)),e.uploadTraceData.state=n,e.uploadTraceData.start_time=e.getNTPTime(e.uploadTraceData.start_time),e.uploadTraceData.duration=e.getNTPTime(e.getSafeClock())-e.uploadTraceData.start_time,e.reporter.report("nim_sdk_resources",e.uploadTraceData),e.uploadTraceData={});});}},{key:"destroy",value:function value(){this.reset(),this.removeAllListeners(),this.logger.info("ReporterHook::destroy: complete");}},{key:"reset",value:function value(){this.logger.info("ReporterHook::reset"),this.serverOrigin={},this.setClientOrigin(),this.currentChance=0,this.timer&&clearTimeout(this.timer),this.syncTraceData={},this.syncTraceMap={},this.syncTraceLastItem={},this.uploadTraceData={};}},{key:"setClientOrigin",value:function value(){this.clientOrigin={timeStamp:o(),baseTimeStamp:this.getSafeClock()};}},{key:"setServerOrigin",value:function value(e,t){this.serverOrigin={timeStamp:t+u(e/2),rtt:e,baseTimeStamp:this.getSafeClock()};}}]),n;}(M);e.exports={EMSyncAction:_,EMSyncType:{kSyncType3_8:30008,kSyncType3_109:30109,kSyncType4_4:40004,kSyncType4_6:40006,kSyncType4_9:40009,kSyncType4_12:40012,kSyncType4_13:40013,kSyncType4_14:40014,kSyncType4_16:40016,kSyncType4_17:40017,kSyncType4_18:40018,kSyncType4_19:40019,kSyncType4_20:40020,kSyncType4_21:40021,kSyncType4_23:40023,kSyncType4_24:40024,kSyncType4_100:40100,kSyncType4_101:40101,kSyncType7_15:70015,kSyncType8_109:80109,kSyncType8_126:80126,kSyncType12_5:12005,kSyncType12_6:12006,kSyncType15_13:15013,kSyncType21_109:21109,kSyncType21_111:21111},ReporterHook:P,EMExceptionState:w,EMResourceUploadWay:{kResourceUploadWayNOS:0,kResourceUploadWayAWSPlugin:1,kResourceUploadWayNOSPlugin:2}};},function(e,t,n){var r=n(4),o=n(16),i=n(2),s=n(9),a=n(185),c=n(17),u=n(102),l=n(103),m=n(72),p=n(30);function d(e,t){var _n4=void 0!==l&&m(e)||e["@@iterator"];if(!_n4){if(p(e)||(_n4=function(e,t){var n;if(!e)return;if("string"==typeof e)return f(e,t);var r=o(n=Object.prototype.toString.call(e)).call(n,8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return u(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return f(e,t);}(e))||t&&e&&"number"==typeof e.length){_n4&&(e=_n4);var r=0,i=function i(){};return{s:i,n:function n(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]};},e:function e(_e7){throw _e7;},f:i};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var s,a=!0,c=!1;return{s:function s(){_n4=_n4.call(e);},n:function n(){var e=_n4.next();return a=e.done,e;},e:function e(_e8){c=!0,s=_e8;},f:function f(){try{a||null==_n4.return||_n4.return();}finally{if(c)throw s;}}};}function f(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++){r[n]=e[n];}return r;}var g=n(14),h={genUrlSep:function genUrlSep(e){return-1===r(e=""+e).call(e,"?")?"?imageView&":"&";},urlQuery2Object:function urlQuery2Object(e){if("[object String]"!==Object.prototype.toString.call(e)||""===e)return{};var t=r(e).call(e,"?");if(-1!==t){var n=o(e).call(e,t+1).split("&"),s={};return i(n).call(n,function(e){if(~r(e).call(e,"=")){var t=e.split("=");s[t[0]]=decodeURIComponent(t[1]);}else s[e]="";}),s;}},url2object:function url2object(e){"[object String]"!==Object.prototype.toString.call(e)&&(e="");var t=r(e=e||"").call(e,"https")>=0?"https://":"http://",n=e.replace(t,"");r(n).call(n,"?")>=0&&(n=n.substring(0,r(n).call(n,"?")));var s=n.split("/");n=s[0];var a="";if(s.length>0&&(a=o(s).call(s,1).join("/")),-1===r(e).call(e,"?"))return{protocol:t,hostname:n,path:a,query:{}};var c=e.substr(r(e).call(e,"?")+1).split("&"),u={};return i(c).call(c,function(e){if(r(e).call(e,"=")>0){var t=e.split("=");u[t[0]]=decodeURIComponent(t[1]);}else u[e]="";}),{protocol:t,hostname:n,path:a,query:u};},object2url:function object2url(e){var t,n=e.protocol,r=e.hostname,o=e.path,i=e.query;(n=n||"http://",r=r||"",o)&&(r=s(t="".concat(r,"/")).call(t,o));i=i||{};var a,c,u,l=[];for(var m in i){var p;if("imageView"!==m)l.push(s(p="".concat(m,"=")).call(p,encodeURIComponent(i[m])));}return l.length>0?s(a=s(c="".concat(n)).call(c,r,"?imageView&")).call(a,l.join("&")):s(u="".concat(n)).call(u,r);},genPrivateUrl:function genPrivateUrl(e,t,n){if(t&&t.length){var i,u=d(t);try{for(u.s();!(i=u.n()).done;){var l=i.value;if(r(e).call(e,l)>=0)return l!==n&&(e=e.replace(l,n)),e;if(r(e).call(e,l)>=0&&l===n)return e;}}catch(e){u.e(e);}finally{u.f();}}var m,p,f=h.url2object(e),y=f.hostname,v=f.path,b=g.downloadUrl,T=g.downloadHostList,S=g.nosCdnEnable,M=g.serverNosConfig.cdnDomain,k=decodeURIComponent(g.serverNosConfig.objectPrefix),x=decodeURIComponent(v),C=r(x).call(x,k);if(M&&C>-1&&S)return s(m=s(p="".concat(f.protocol)).call(p,M,"/")).call(m,o(x).call(x,C));if(a(T).call(T,y)&&a(v).call(v,"/")){var I=r(v).call(v,"/"),_=v.substring(0,I),w=v.substring(I+1);return b.replace("{bucket}",_).replace("{object}",w);}var P=c(T).call(T,function(e){return"string"==typeof y&&a(y).call(y,e);})[0],A=P?y.replace(P,"").replace(/\W/g,""):null;return A?b.replace("{bucket}",A).replace("{object}",v):e;}};e.exports=h;},function(e,t,n){var r=n(8);e.exports=!r(function(){var e=function(){}.bind();return"function"!=typeof e||e.hasOwnProperty("prototype");});},function(e,t,n){var r=n(112),o=TypeError;e.exports=function(e){if(r(e))throw o("Can't call method on "+e);return e;};},function(e,t,n){var r=n(42),o=n(148);(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{});})("versions",[]).push({version:"3.27.1",mode:r?"pure":"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.27.1/LICENSE",source:"https://github.com/zloirock/core-js"});},function(e,t,n){var r=n(302);e.exports=function(e){var t=+e;return t!=t||0===t?0:r(t);};},function(e,t,n){var r=n(8),o=n(18),i=n(77),s=o("species");e.exports=function(e){return i>=51||!r(function(){var t=[];return(t.constructor={})[s]=function(){return{foo:1};},1!==t[e](Boolean).foo;});};},function(e,t){},function(e,t,n){var r=n(13);e.exports=r([].slice);},function(e,t,n){var r=n(79),o=n(25),i=n(33),s=n(78),a=n(220),c=n(40),u=n(19),l=n(221),m=n(125),p=n(222),d=TypeError,f=function f(e,t){this.stopped=e,this.result=t;},g=f.prototype;e.exports=function(e,t,n){var h,y,v,b,T,S,M,k=n&&n.that,x=!(!n||!n.AS_ENTRIES),C=!(!n||!n.IS_RECORD),I=!(!n||!n.IS_ITERATOR),_=!(!n||!n.INTERRUPTED),w=r(t,k),P=function P(e){return h&&p(h,"normal",e),new f(!0,e);},A=function A(e){return x?(i(e),_?w(e[0],e[1],P):w(e[0],e[1])):_?w(e,P):w(e);};if(C)h=e.iterator;else if(I)h=e;else{if(!(y=m(e)))throw d(s(e)+" is not iterable");if(a(y)){for(v=0,b=c(e);b>v;v++){if((T=A(e[v]))&&u(g,T))return T;}return new f(!1);}h=l(e,y);}for(S=C?e.next:h.next;!(M=o(S,h)).done;){try{T=A(M.value);}catch(e){p(h,"throw",e);}if("object"==(typeof T==="undefined"?"undefined":_typeof(T))&&T&&u(g,T))return T;}return new f(!1);};},function(e,t,n){var r=n(65),o=n(12);e.exports="process"==r(o.process);},function(e,t,n){var r=n(12),o=n(87),i=n(20),s=n(194),a=n(198),c=n(18),u=n(381),l=n(228),m=n(42),p=n(77),d=o&&o.prototype,f=c("species"),g=!1,h=i(r.PromiseRejectionEvent),y=s("Promise",function(){var e=a(o),t=e!==String(o);if(!t&&66===p)return!0;if(m&&(!d.catch||!d.finally))return!0;if(!p||p<51||!/native code/.test(e)){var n=new o(function(e){e(1);}),r=function r(e){e(function(){},function(){});};if((n.constructor={})[f]=r,!(g=n.then(function(){})instanceof r))return!0;}return!t&&(u||l)&&!h;});e.exports={CONSTRUCTOR:y,REJECTION_EVENT:h,SUBCLASSING:g};},function(e,t,n){e.exports=n(281);},function(e,t,n){e.exports=n(202);},function(e,t){e.exports=function(e){var t=typeof e==="undefined"?"undefined":_typeof(e);return null!=e&&("object"==t||"function"==t);};},function(e,t){e.exports=function(e){return null!=e&&"object"==(typeof e==="undefined"?"undefined":_typeof(e));};},function(e,t,n){var r=n(23),o=n(47),i=n(555),s=n(557),a=n(564),c={},u=o.f;function l(e){var t=e.upload="multipart/form-data"===(e.headers||o.o)["Content-Type"],n=!1;try{n=(location.protocol+"//"+location.host).toLowerCase()!==o.url2origin(e.url);}catch(e){}return e.cors=n,t||n||e.mode?function(e){var t=e.mode,n=i,r=o.getGlobal();return!r.FormData&&r.document&&(t="iframe"),"iframe"===t&&(n=e.upload?s:a),new n(e);}(e):new i(e);}function m(e,t,n){var r=c[e];if(r){"onload"===t&&r.result&&(n=function(e,t){t={data:t};var n=e.result.headers;return n&&(t.headers=e.req.header(n)),t;}(r,n)),function(e){var t=c[e];t&&(t.req.destroy(),delete c[e]);}(e);var o={type:t,result:n};u(o),o.stopped||r[t](o.result);}}function p(e,t){m(e,"onload",t);}function d(e,t){m(e,"onerror",t);}function f(e,t){var n=o.genUrlSep(e);return t=t||"",o.isObject(t)&&(t=o.object2query(t)),t&&(e+=n+t),e;}function g(e,t){t=t||{};var n=o.uniqueID(),i={result:t.result,onload:t.onload||o.f,onerror:t.onerror||o.f};c[n]=i,t.onload=r(p).call(p,null,n),t.onerror=r(d).call(d,null,n),t.query&&(e=f(e,t.query));var s=t.method||"";return s&&!/get/i.test(s)||!t.data||(e=f(e,t.data),t.data=null),t.url=e,i.req=l(t),n;}g.filter=function(e){o.isFunction(e)&&(u=e);},g.abort=function(e){var t=c[e];t&&t.req&&t.req.abort();},e.exports=g;},function(e,t,n){var r=n(10),o=n(282),i=n(22),s=n(91).genPrivateUrl,a=n(0),c=a.notundef,u=a.exist,l=n(176),m=n(277),p=m.typeMap;function d(e){e.resend?(a.verifyOptions(e,"idClient","msg::Message"),this.idClient=e.idClient):this.idClient=a.guid(),this.type=p[e.type],this.resend=e.resend?1:0,c(e.subType)&&(a.isInt(+e.subType)&&+e.subType>0?this.subType=+e.subType:a.onParamError("subType只能是大于0的整数","msg::Message")),c(e.custom)&&("object"===i(e.custom)?this.custom=r(e.custom):this.custom=""+e.custom),c(e.text)&&(this.body=""+e.text),c(e.body)&&(this.body=""+e.body),c(e.yidunEnable)&&(this.yidunEnable=e.yidunEnable?1:0),c(e.antiSpamUsingYidun)&&(this.antiSpamUsingYidun=e.antiSpamUsingYidun?1:0),c(e.antiSpamContent)&&("object"===i(e.antiSpamContent)?this.antiSpamContent=r(e.antiSpamContent):this.antiSpamContent=""+e.antiSpamContent),c(e.antiSpamBusinessId)&&("object"===i(e.antiSpamBusinessId)?this.antiSpamBusinessId=r(e.antiSpamBusinessId):this.antiSpamBusinessId=""+e.antiSpamBusinessId),c(e.yidunAntiCheating)&&(this.yidunAntiCheating=e.yidunAntiCheating+""),c(e.skipHistory)&&(this.skipHistory=e.skipHistory?1:0),c(e.highPriority)&&(this.highPriority=e.highPriority?1:0),c(e.clientAntiSpam)&&(this.clientAntiSpam=e.clientAntiSpam?1:0),c(e.env)&&(this.env=e.env),c(e.notifyTargetTags)&&(this.notifyTargetTags=e.notifyTargetTags),c(e.yidunAntiSpamExt)&&(this.yidunAntiSpamExt=e.yidunAntiSpamExt),(c(e.loc_x)||c(e.loc_y)||c(e.loc_z))&&(this.loc_x=e.loc_x,this.loc_y=e.loc_y,this.loc_z=e.loc_z);}d.validTypes=m.validTypes,a.merge(d.prototype,m.prototype),d.getType=m.getType,d.reverse=function(e){var t=a.filterObj(e,"chatroomId idClient from fromNick fromAvatar _fromAvatar_safe fromCustom userUpdateTime custom status notifyTargetTags");return c(t.fromAvatar)&&(t.fromAvatar=s(t.fromAvatar)),t=a.merge(t,{fromClientType:l.reverseType(e.fromClientType),time:+e.time,type:d.getType(e),text:u(e.body)?e.body:e.text||"",resend:1==+e.resend}),c(t.userUpdateTime)&&(t.userUpdateTime=+t.userUpdateTime),c(e.callbackExt)&&(t.callbackExt=e.callbackExt),c(e.subType)&&(t.subType=+e.subType),c(e.yidunAntiSpamRes)&&(t.yidunAntiSpamRes=e.yidunAntiSpamRes),c(e.loc_x)&&(t.x=o(e.loc_x),t.y=o(e.loc_y),t.z=o(e.loc_z)),c(e.toAccids)&&(t.toAccids=e.toAccids),t.status=t.status||"success",t;},d.setExtra=function(e,t){m.setFlow(e,t);},e.exports=d;},function(e,t,n){var r=n(200),o=n(155);e.exports=Object.keys||function(e){return r(e,o);};},function(e,t,n){var r=n(575),o=n(263),i=n(582);e.exports=function(e,t){if(null==e)return{};var n,s,a=i(e,t);if(r){var c=r(e);for(s=0;s<c.length;s++){n=c[s],o(t).call(t,n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n]);}}return a;},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(15),o=n(157),i={V2NIM_LOGIN_STATUS_LOGOUT:0,V2NIM_LOGIN_STATUS_LOGINED:1,V2NIM_LOGIN_STATUS_LOGINING:2},s={V2NIM_CONNECT_STATUS_DISCONNECTED:0,V2NIM_CONNECT_STATUS_CONNECTED:1,V2NIM_CONNECT_STATUS_CONNECTING:2,V2NIM_CONNECT_STATUS_WAITING:3};function a(e){this.loginStatus=i.V2NIM_LOGIN_STATUS_LOGOUT,this.connectStatus=s.V2NIM_CONNECT_STATUS_DISCONNECTED,this.logger=e.logger,this.setMonitor();}a.prototype=r(new o()),a.prototype.setMonitor=function(){var e=this;this.on("auth/loginLifeCycleAddressing",function(){e.logger.log("auth::life cycle addressing"),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGINING),e.setConnectStatus(s.V2NIM_CONNECT_STATUS_CONNECTING);}),this.on("auth/loginLifeCycleConnect",function(){e.logger.log("auth::life cycle connecting"),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGINING),e.setConnectStatus(s.V2NIM_CONNECT_STATUS_CONNECTING);}),this.on("auth/loginLifeCycleConnectSucc",function(){e.logger.log("auth::life cycle connect success"),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGINING),e.setConnectStatus(s.V2NIM_CONNECT_STATUS_CONNECTED);}),this.on("auth/loginLifeCycleConnectFail",function(t){e.logger.log("auth::life cycle connect fail"),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGOUT),e.setConnectStatus(s.V2NIM_CONNECT_STATUS_DISCONNECTED,t);}),this.on("auth/loginLifeCycleDisconnected",function(t){e.logger.log("auth::life cycle disconnected:",t&&t.message),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGOUT),e.setConnectStatus(s.V2NIM_CONNECT_STATUS_DISCONNECTED,t);}),this.on("auth/loginLifeCycleLoginSucc",function(){e.logger.log("auth::life cycle login success, verify authentication success"),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGINED);}),this.on("auth/loginLifeCycleLoginFail",function(t){e.logger.log("auth::life cycle login fail due to verify authentication failed:",t),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGOUT,t);}),this.on("auth/loginLifeCycleLogout",function(){e.logger.log("auth::life cycle logout"),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGOUT);}),this.on("auth/loginLifeCycleKicked",function(t){e.logger.log("auth::life cycle kicked",t),e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGOUT);}),this.on("auth/loginLifeCycleWaiting",function(){e.logger.log("auth::life cycle waiting to reconnect");e.getConnectStatus();e.setLoginStatus(i.V2NIM_LOGIN_STATUS_LOGOUT),e.setConnectStatus(s.V2NIM_CONNECT_STATUS_WAITING);});},a.prototype.getConnectStatus=function(){return this.connectStatus;},a.prototype.getLoginStatus=function(){return this.loginStatus;},a.prototype.setLoginStatus=function(e,t){if(e!==this.loginStatus){var n=this.loginStatus;this.loginStatus=e,this.emit("loginStatus",e),this.delegateLoginEvent(n,e,t);}},a.prototype.delegateLoginEvent=function(e,t,n){e===i.V2NIM_LOGIN_STATUS_LOGINING&&t===i.V2NIM_LOGIN_STATUS_LOGOUT&&this.emit("loginFailed",n);},a.prototype.setConnectStatus=function(e,t){if(e!==this.connectStatus){var n=this.connectStatus;this.connectStatus=e,this.emit("connectStatus",e),this.delegateConnectEvent(n,e,t);}},a.prototype.delegateConnectEvent=function(e,t,n){e===s.V2NIM_CONNECT_STATUS_CONNECTED&&t===s.V2NIM_CONNECT_STATUS_DISCONNECTED&&this.emit("disconnected",n),e===s.V2NIM_CONNECT_STATUS_CONNECTING&&t===s.V2NIM_CONNECT_STATUS_CONNECTED&&this.emit("connectSuccess"),e===s.V2NIM_CONNECT_STATUS_CONNECTING&&t===s.V2NIM_CONNECT_STATUS_DISCONNECTED&&this.emit("connectFailed",n),e!==s.V2NIM_CONNECT_STATUS_DISCONNECTED&&this.connectStatus!==s.V2NIM_CONNECT_STATUS_WAITING||t!==s.V2NIM_CONNECT_STATUS_CONNECTING||this.emit("connecting");},a.prototype.destroy=function(){this.removeAllListeners();},e.exports={V2NIMLoginStatus:i,V2NIMConnectStatus:s,StatusProtector:a};},function(e,t,n){var r=n(13),o=n(8),i=n(65),s=Object,a=r("".split);e.exports=o(function(){return!s("z").propertyIsEnumerable(0);})?function(e){return"String"==i(e)?a(e,""):s(e);}:s;},function(e,t){e.exports=function(e){return null==e;};},function(e,t,n){var r=n(299),o=n(114);e.exports=function(e){var t=r(e,"string");return o(t)?t:t+"";};},function(e,t,n){var r=n(31),o=n(20),i=n(19),s=n(192),a=Object;e.exports=s?function(e){return"symbol"==(typeof e==="undefined"?"undefined":_typeof(e));}:function(e){var t=r("Symbol");return o(t)&&i(t.prototype,a(e));};},function(e,t,n){var r=n(95),o=Math.max,i=Math.min;e.exports=function(e,t){var n=r(e);return n<0?o(n+t,0):i(n,t);};},function(e,t,n){var r=n(13),o=n(8),i=n(20),s=n(52),a=n(31),c=n(198),u=function u(){},l=[],m=a("Reflect","construct"),p=/^\s*(?:class|function)\b/,d=r(p.exec),f=!p.exec(u),g=function g(e){if(!i(e))return!1;try{return m(u,l,e),!0;}catch(e){return!1;}},h=function h(e){if(!i(e))return!1;switch(s(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1;}try{return f||!!d(p,c(e));}catch(e){return!0;}};h.sham=!0,e.exports=!m||o(function(){var e;return g(g.call)||!g(Object)||!g(function(){e=!0;})||e;})?h:g;},function(e,t){e.exports={};},function(e,t,n){var r=n(94),o=n(149),i=r("keys");e.exports=function(e){return i[e]||(i[e]=o(e));};},function(e,t){t.f=Object.getOwnPropertySymbols;},function(e,t,n){var r=n(18);t.f=r;},function(e,t,n){var r,o,i,s=n(316),a=n(12),c=n(29),u=n(51),l=n(26),m=n(148),p=n(118),d=n(117),f=a.TypeError,g=a.WeakMap;if(s||m.state){var h=m.state||(m.state=new g());h.get=h.get,h.has=h.has,h.set=h.set,r=function r(e,t){if(h.has(e))throw f("Object already initialized");return t.facade=e,h.set(e,t),t;},o=function o(e){return h.get(e)||{};},i=function i(e){return h.has(e);};}else{var y=p("state");d[y]=!0,r=function r(e,t){if(l(e,y))throw f("Object already initialized");return t.facade=e,u(e,y,t),t;},o=function o(e){return l(e,y)?e[y]:{};},i=function i(e){return l(e,y);};}e.exports={set:r,get:o,has:i,enforce:function enforce(e){return i(e)?o(e):r(e,{});},getterFor:function getterFor(e){return function(t){var n;if(!c(t)||(n=o(t)).type!==e)throw f("Incompatible receiver, "+e+" required");return n;};}};},function(e,t,n){var r=n(26),o=n(20),i=n(37),s=n(118),a=n(214),c=s("IE_PROTO"),u=Object,l=u.prototype;e.exports=a?u.getPrototypeOf:function(e){var t=i(e);if(r(t,c))return t[c];var n=t.constructor;return o(n)&&t instanceof n?n.prototype:t instanceof u?l:null;};},function(e,t,n){var r=n(13),o=n(33),i=n(336);e.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,n={};try{(e=r(Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set))(n,[]),t=n instanceof Array;}catch(e){}return function(n,r){return o(n),i(r),t?e(n,r):n.__proto__=r,n;};}():void 0);},function(e,t,n){"use strict";var r=n(352).charAt,o=n(44),i=n(121),s=n(211),a=n(215),c=i.set,u=i.getterFor("String Iterator");s(String,"String",function(e){c(this,{type:"String Iterator",string:o(e),index:0});},function(){var e,t=u(this),n=t.string,o=t.index;return o>=n.length?a(void 0,!0):(e=r(n,o),t.index+=e.length,a(e,!1));});},function(e,t,n){var r=n(52),o=n(147),i=n(112),s=n(85),a=n(18)("iterator");e.exports=function(e){if(!i(e))return o(e,a)||o(e,"@@iterator")||s[r(e)];};},function(e,t,n){e.exports=n(388);},function(e,t,n){e.exports=n(415);},function(e,t,n){e.exports=n(432);},function(e,t,n){var r=n(472),o=n(473),i=n(474),s=n(475),a=n(476);function c(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1]);}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=s,c.prototype.set=a,e.exports=c;},function(e,t,n){var r=n(243);e.exports=function(e,t){for(var n=e.length;n--;){if(r(e[n][0],t))return n;}return-1;};},function(e,t,n){var r=n(160),o=n(483),i=n(484),s=r?r.toStringTag:void 0;e.exports=function(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":s&&s in Object(e)?o(e):i(e);};},function(e,t,n){var r=n(70)(Object,"create");e.exports=r;},function(e,t,n){var r=n(497);e.exports=function(e,t){var n=e.__data__;return r(t)?n["string"==typeof t?"string":"hash"]:n.map;};},function(e,t,n){var r=n(247),o=n(248);e.exports=function(e,t,n,i){var s=!n;n||(n={});for(var a=-1,c=t.length;++a<c;){var u=t[a],l=i?i(n[u],e[u],u,n,e):void 0;void 0===l&&(l=e[u]),s?o(n,u,l):r(n,u,l);}return n;};},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function get(){return e.l;}}),Object.defineProperty(e,"id",{enumerable:!0,get:function get(){return e.i;}}),e.webpackPolyfill=1),e;};},function(e,t){e.exports="\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";},function(e,t,n){var r,o=n(15),i=n(2),s=n(7),a=n(3),c=n(9),u=n(4),l=n(23),m=n(10),p=n(91).urlQuery2Object,d=n(0),f=n(39),g=n(651),h=n(652),y=n(653),v=n(654),b=n(655),T=n(656);function S(e){this.mixin(e);}S.prototype=o(function(){}.prototype,{protocol:{value:null,writable:!0,enumerable:!0,configurable:!0}}),S.prototype.setProtocol=function(e){this.protocol=e;},S.prototype.mixin=function(e){var t,n,r=this;this.configMap=this.configMap||{},i(t=["idMap","cmdConfig","packetConfig"]).call(t,function(t){r.configMap[t]=d.merge({},r.configMap[t],e.configMap&&e.configMap[t]);}),i(n=["serializeMap","unserializeMap"]).call(n,function(t){r[t]=d.merge({},r[t],e[t]);});},S.prototype.createCmd=(r=1,function(e,t){var n,o=this,a=this.configMap.cmdConfig[e],c=this.configMap.packetConfig[a.sid+"_"+a.cid],u="heartbeat"===e?0:r++;return u>32767&&(u=1,r=2),e={SID:a.sid,CID:a.cid,SER:u,isAwaitable:"boolean"==typeof a.isAwaitable?a.isAwaitable:!(!c||!c.response)},a.params&&(e.Q=[],i(n=a.params).call(n,function(n){var r=n.type,i=n.name,a=n.entity,c=t[i];if(!d.undef(c)){switch(r){case"PropertyArray":r="ArrayMable",c=s(c).call(c,function(e){return{t:"Property",v:o.serialize(e,a)};});break;case"Property":c=o.serialize(c,i);break;case"bool":c=c?"true":"false";}e.Q.push({t:r,v:c});}})),e;}),S.prototype.parseResponse=function(e){var t=this;return new a(function(n){var r=JSON.parse(e),o={raw:r,rawStr:e,error:f.genError(r.code)},s=t.configMap.packetConfig[r.sid+"_"+r.cid];if(!s)return o.notFound={sid:r.sid,cid:r.cid},void n(o);var m=r.r,p="notify"===s.service&&!s.cmd;if(o.isNotify=p,p){var g=r.r[1].headerPacket;if(s=t.configMap.packetConfig[g.sid+"_"+g.cid],m=r.r[1].body,!s)return o.notFound={sid:g.sid,cid:g.cid},void n(o);}if(o.service=s.service,o.cmd=s.cmd,o.error){var h,y,v=c(h="".concat(r.sid,"_")).call(h,r.cid);if(p)v=c(y="".concat(g.sid,"_")).call(y,g.cid);if(o.error.cmd=o.cmd,o.error.callFunc="protocol::parseResponse: ".concat(v),416===o.error.code){var b=m[0];b&&(o.frequencyControlDuration=1e3*b);}}var T,S=!1;o.error&&s.trivialErrorCodes&&(S=-1!==u(T=s.trivialErrorCodes).call(T,o.error.code));var M=[];if((!o.error||S)&&s.response){var k;o.content={};var x=function x(e,t,n,r){if(e&&"msg"===r||"sysMsg"===r){var o=n.content[r];d.isObject(o)&&!o.idServer&&(o.idServer=""+t.r[0]);}};i(k=s.response).call(k,function(e,n){var s,a=m[n];if(!d.undef(a)){var c=e.type,u=e.name,f=e.entity||u;switch(c){case"Property":M.push(t.unserialize(a,f).then(l(s=function s(e,t,n,r,o){n.content[r]=o,x(e,t,n,r);}).call(s,this,p,r,o,u)));break;case"PropertyArray":o.content[u]=[],i(a).call(a,function(e,n){var r;M.push(t.unserialize(e,f).then(l(r=function r(e,t,_r){e.content[t][n]=_r;}).call(r,this,o,u)));});break;case"KVArray":o.content[u]=a,x(p,r,o,u);break;case"long":case"Long":case"byte":case"Byte":case"Number":o.content[u]=+a;break;default:o.content[u]=a,x(p,r,o,u);}}});}a.all(M).then(function(){n(o);});});},S.prototype.serialize=function(e,t){var n=this.serializeMap[t],r={};for(var o in n){e.hasOwnProperty(o)&&(r[n[o]]=e[o]);}return r;},S.prototype.matchNosSafeUrl=function(e){if(!d.isString(e)||!~u(e).call(e,"_im_url=1"))return!1;var t=p(e);return!(!t||!t._im_url||1!=t._im_url);},S.prototype.getOneNosOriginUrl=function(e,t,n){var r=this;return new a(function(o){r.protocol.getNosOriginUrlReqNum++,r.protocol.sendCmd("getNosOriginUrl",{nosFileUrlTag:{safeUrl:e}},function(e,i,s){r.protocol.getNosOriginUrlReqNum--,e?r.protocol.logger.warn("error: get nos originUrl failed",e):(t["_"+n+"_safe"]=t[n],t[n]=s.nosFileUrlTag&&s.nosFileUrlTag.originUrl),o();});});},S.prototype.checkObjSafeUrl=function(e,t,n){var r=this;for(var o in e){if(e.hasOwnProperty(o)){var s=e[o];if(d.isString(s)){if(this.matchNosSafeUrl(s)){var a=this.getOneNosOriginUrl(s,e,o);t.push(a),n.push(a);}}else d.isObject(s)?this.checkObjSafeUrl(s,t,n):d.isArray(s)&&i(s).call(s,function(e){d.isObject(e)&&r.checkObjSafeUrl(e,t,n);});}}};var M=["url","avatar","fromAvatar","chatroomAvatar"];S.prototype.unserialize=function(e,t){var n=this;return new a(function(r){var o=n.unserializeMap[t],i={},s=[];if(e)for(var c in o){var p,d=[];if(e.hasOwnProperty(c))if(i[o[c]]=e[c],n.protocol.hasLogin&&!n.protocol.keepNosSafeUrl)if("attach"===o[c]&&e[c]&&u(e[c])&&~u(p=e[c]).call(p,"_im_url=1"))try{var f,g=JSON.parse(e[c]);g.isS3||n.checkObjSafeUrl(g,d,s),a.all(d).then(l(f=function f(e,t){e.attach=m(t);}).call(f,n,i,g));}catch(e){n.logger.warn("unserialize",e&&e.message);}else~u(M).call(M,o[c])&&e[c]&&n.matchNosSafeUrl(e[c])&&s.push(n.getOneNosOriginUrl(e[c],i,o[c]));}a.all(s).then(function(){r(i);});});},S.prototype.syncUnserialize=function(e,t){var n=this.unserializeMap[t],r={};if(e)for(var o in n){e.hasOwnProperty(o)&&(r[n[o]]=e[o]);}return r;};var k=new S({configMap:g,serializeMap:h,unserializeMap:y}),x=new S({configMap:v,serializeMap:b,unserializeMap:T});e.exports={IM:k,Chatroom:x};},function(e,t,n){"use strict";var r={}.propertyIsEnumerable,o=Object.getOwnPropertyDescriptor,i=o&&!r.call({1:2},1);t.f=i?function(e){var t=o(this,e);return!!t&&t.enumerable;}:r;},function(e,t,n){var r=n(7),o=n(6),i=n(0),s=i.notundef,a=i.fillPropertyWithDefault,c={0:"normal",1:"owner",2:"manager"};function u(e){i.verifyOptions(e,"teamId","team::TeamMember"),i.verifyParamAtLeastPresentOne(e,"nickInTeam muteTeam muteNotiType custom","team::TeamMember"),this.teamId=e.teamId,s(e.account)&&(this.account=e.account),s(e.nickInTeam)&&(this.nickInTeam=e.nickInTeam),s(e.muteNotiType)?this.bits=e.muteNotiType:s(e.muteTeam)&&(this.bits=0,e.muteTeam&&(this.bits+=1)),s(e.mute)&&(this.mute=e.mute?1:0),s(e.custom)&&(this.custom=""+e.custom);}u.reverse=function(e){var t=i.copy(e);if(s(t.teamId)&&(t.teamId=""+t.teamId),s(t.type)&&(t.type=c[t.type]),s(t.active)&&(t.active=1==+t.active),s(t.valid)&&(t.valid=1==+t.valid),s(t.mute)&&(t.mute=1==+t.mute),s(t.joinTime)&&(t.joinTime=+t.joinTime),s(t.updateTime)&&(t.updateTime=+t.updateTime),s(t.bits)){var n=t.bits;delete t.bits,t.muteTeam=!!(1&n),t.muteNotiType=n;}return s(t.teamId)&&s(t.account)&&(t.id=u.genId(t.teamId,t.account)),t;},u.reverseMembers=function(e){return r(e).call(e,function(e){return o(u).call(u,e);});},u.fillProperties=function(e){var t=a(e,"mute",!1),n=a(e,"custom","");return t||n;},u.genId=function(e,t){return e+"-"+t;},u.accounts2ids=function(e,t){return r(t).call(t,function(t){return u.genId(e,t);});},u.assembleMembers=function(e,t){return i.isArray(t)||(t=[t]),r(t).call(t,function(t){return u.assembleMember(e,t);});},u.assembleMember=function(e,t){return{id:u.genId(e.teamId,t),account:t,teamId:e.teamId,type:"normal",nickInTeam:"",muteTeam:!1,mute:!1,joinTime:e.memberUpdateTime,updateTime:e.memberUpdateTime,active:!0,valid:!0,invitorAccid:""};},u.assembleOwner=function(e){var t=u.assembleMember(e,e.owner);return t.type="owner",t;},e.exports=u;},function(e,t,n){var r,o=n(22),i=n(4),s=n(10),a=n(9),c=n(5),u=n(16),l=n(6),m=n(17),p=n(7),d=n(2),f=n(0),g=f.undef,h=f.notundef,y=n(137).IM,v=n(175),b=n(139),T={customP2p:100,customTeam:101,customSuperTeam:103,deleteMsgP2p:7,deleteMsgTeam:8,deleteMsgSuperTeam:12,deleteOnewayMsgP2p:13,deleteOnewayMsgTeam:14},S={0:"applyTeam",1:"rejectTeamApply",2:"teamInvite",3:"rejectTeamInvite",5:"friendRequest",6:"deleteFriend",7:"deleteMsgP2p",8:"deleteMsgTeam",12:"deleteMsgSuperTeam",13:"deleteMsgP2pOneWay",14:"deleteMsgTeamOneWay",15:"applySuperTeam",16:"rejectSuperTeamApply",17:"superTeamInvite",18:"rejectSuperTeamInvite",100:"customP2p",101:"customTeam",103:"customSuperTeam",102:"customP2p"},M={1:"addFriend",2:"applyFriend",3:"passFriendApply",4:"rejectFriendApply"},k=["team","superTeam","friend","msg"],x={applyTeam:"team",rejectTeamApply:"team",teamInvite:"team",rejectTeamInvite:"team",applySuperTeam:"superTeam",rejectSuperTeamApply:"superTeam",superTeamInvite:"superTeam",rejectSuperTeamInvite:"superTeam",addFriend:"friend",applyFriend:"friend",passFriendApply:"friend",rejectFriendApply:"friend",deleteFriend:"friend",deleteMsg:"msg"};function C(e){var t,n;f.verifyOptions(e,"type to","sysmsg::SystemMessage"),f.verifyParamValid("type",e.type,C.validTypes,"sysmsg::SystemMessage"),-1!==i(t=e.type).call(t,"custom")&&(f.verifyOptions(e,"content","sysmsg::SystemMessage"),this.attach=e.content,h(e.apnsText)&&(this.apnsText=""+e.apnsText),h(e.pushPayload)&&("object"===o(e.pushPayload)?this.pushPayload=s(e.pushPayload):this.pushPayload=""+e.pushPayload),h(e.sendToOnlineUsersOnly)&&(this.sendToOnlineUsersOnly=e.sendToOnlineUsersOnly?0:1),h(e.cc)&&(this.cc=e.cc?1:0),h(e.isPushable)&&(this.isPushable=e.isPushable?1:0),h(e.isUnreadable)&&(this.isUnreadable=e.isUnreadable?1:0),h(e.needPushNick)&&(this.needPushNick=e.needPushNick?1:0)),0===i(n=e.type).call(n,"deleteMsg")&&(e.apnsText&&(this.apnsText=e.apnsText),e.pushPayload&&(this.pushPayload=e.pushPayload),e.attach&&(this.attach=e.attach)),this.time=e.time||+new Date(),this.type=T[e.type],this.to=e.to,h(e.from)&&(this.from=e.from),h(e.ps)&&(this.ps=e.ps),h(e.deletedIdClient)&&(this.deletedIdClient=e.deletedIdClient),h(e.deletedIdServer)&&(this.deletedIdServer=e.deletedIdServer),h(e.opeAccount)&&(this.opeAccount=e.opeAccount),h(e.yidunEnable)&&(this.yidunEnable=e.yidunEnable?1:0),h(e.antiSpamContent)&&("object"===o(e.antiSpamContent)?this.antiSpamContent=s(e.antiSpamContent):this.antiSpamContent=""+e.antiSpamContent),h(e.antiSpamBusinessId)&&("object"===o(e.antiSpamBusinessId)?this.antiSpamBusinessId=s(e.antiSpamBusinessId):this.antiSpamBusinessId=""+e.antiSpamBusinessId),h(e.env)&&(this.env=e.env),this.idClient=e.idClient||f.guid();}C.validTypes=a(r=c(T)).call(r,c(x)),C.validCategories=["team","friend"],C.isCustom=function(e){return"custom"===e.type;},C.reverse=function(e){var t,n,r={time:+e.time,to:e.to,type:S[e.type]};if(h(e.from)&&(r.from=e.from),h(e.idServer)&&(r.idServer=""+e.idServer),h(e.deletedIdClient)&&(r.deletedIdClient=e.deletedIdClient),h(e.deletedIdServer)&&(r.deletedIdServer=""+e.deletedIdServer),h(e.deletedMsgTime)&&(r.deletedMsgTime=+e.deletedMsgTime),h(e.deletedMsgFromNick)&&(r.deletedMsgFromNick=""+e.deletedMsgFromNick),h(e.opeAccount)&&(r.opeAccount=e.opeAccount),h(e.ps)&&(r.ps=e.ps),h(e.callbackExt)&&(r.callbackExt=e.callbackExt),e.attach=e.attach?""+e.attach:"","customP2p"===r.type||"customTeam"===r.type||"customSuperTeam"===r.type)r.content=e.attach,h(e.apnsText)&&(r.apnsText=e.apnsText),h(e.pushPayload)&&(r.pushPayload=e.pushPayload),f.merge(r,{sendToOnlineUsersOnly:g(e.sendToOnlineUsersOnly)||0==+e.sendToOnlineUsersOnly,cc:g(e.cc)||1==+e.cc,isPushable:g(e.isPushable)||1==+e.isPushable,isUnreadable:g(e.isUnreadable)||1==+e.isUnreadable,needPushNick:h(e.needPushNick)&&1==+e.needPushNick}),r.scene=u(n=r.type).call(n,6).toLowerCase(),r.type="custom";else if(0===i(t=r.type).call(t,"deleteMsg")){e.apnsText&&(r.apnsText=e.apnsText),e.pushPayload&&(r.pushPayload=e.pushPayload),e.attach&&(r.attach=e.attach);var o=r.type.toLowerCase();i(o).call(o,"p2p")>-1?r.scene="p2p":i(o).call(o,"superteam")>-1?r.scene="superTeam":i(o).call(o,"team")>-1&&(r.scene="team"),r.type="deleteMsg";}else{if(e.attach){r.attach={};var s=JSON.parse(e.attach);h(s.vt)?(r.type=M[s.vt],s.serverex&&1===s.serverex[0]&&(r.serverex=s.serverex[1]),delete r.attach):(h(s.tinfo)&&(r.attach.team=l(v).call(v,y.syncUnserialize(s.tinfo,"team"))),h(s.tlist)&&(r.attach.member=l(b).call(b,y.syncUnserialize(s.tlist,"teamMember"))),h(s.attach)&&(r.attach.custom=s.attach));}r.category=x[r.type],r.read=!1,r.state="init";}return h(e.cc)&&(r.cc=1==+e.cc),r.status=e.status||"success",h(m(e))&&(r.filter=m(e)),r;},C.reverseSysMsgs=function(e,t){var n=(t=t||{}).mapper,r=f.isFunction(n);return p(e).call(e,function(e){return e=l(C).call(C,e),r&&(e=n(e)),e;});},C.completeUnread=function(e){var t,n;return e=e||{},d(k).call(k,function(t){delete e[t];}),d(t=c(x)).call(t,function(t){e[t]=e[t]||0,e[t]<0&&(e[t]=0),e[n=x[t]]=e[n]||0,e[n]=e[n]+e[t];}),e.total=0,d(k).call(k,function(t){e.total+=e[t];}),e;},e.exports=C;},function(e,t,n){var r=n(109),o=["unreadMsgs"],i=n(0);function s(){}s.parse=function(e){var t=e.split("|");return{scene:t[0],to:t[1]};},s.genSessionByMsg=function(e){return{id:e.sessionId,scene:e.scene,to:e.target,updateTime:e.time,lastMsg:e};},s.appendLastMsg=function(e){var t=e.lastMsg;e["last"+i.capFirstLetter(t.type)+"Msg"]=t,e["last"+i.capFirstLetter(t.flow)+"Msg"]=t;},s.genSessionByMsgs=function(e,t){var n=e.getLastNotIgnoredMsg(t);return n?s.genSessionByMsg(n):null;},s.trim=function(e){var t=e=i.simpleClone(e);t.unreadMsgs;return r(t,o);},s.isComplete=function(e){return e.id&&e.scene&&e.to;},e.exports=s;},function(e,t,n){e.exports=n(310);},function(e,t,n){e.exports=n(563);},function(e,t,n){var r=n(657)();e.exports=r;try{regeneratorRuntime=r;}catch(e){"object"==(typeof globalThis==="undefined"?"undefined":_typeof(globalThis))?globalThis.regeneratorRuntime=r:Function("r","regeneratorRuntime = r")(r);}},function(e,t,n){var r=n(276);function o(e,t,n,o,i,s,a){try{var c=e[s](a),u=c.value;}catch(e){return void n(e);}c.done?t(u):r.resolve(u).then(o,i);}e.exports=function(e){return function(){var t=this,n=arguments;return new r(function(r,i){var s=e.apply(t,n);function a(e){o(s,r,i,a,c,"next",e);}function c(e){o(s,r,i,a,c,"throw",e);}a(void 0);});};},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(65),o=n(13);e.exports=function(e){if("Function"===r(e))return o(e);};},function(e,t,n){var r=n(36),o=n(112);e.exports=function(e,t){var n=e[t];return o(n)?void 0:r(n);};},function(e,t,n){var r=n(12),o=n(301),i=r["__core-js_shared__"]||o("__core-js_shared__",{});e.exports=i;},function(e,t,n){var r=n(13),o=0,i=Math.random(),s=r(1..toString);e.exports=function(e){return"Symbol("+(void 0===e?"":e)+")_"+s(++o+i,36);};},function(e,t,n){var r=n(12),o=n(29),i=r.document,s=o(i)&&o(i.createElement);e.exports=function(e){return s?i.createElement(e):{};};},function(e,t,n){var r=n(38),o=n(115),i=n(40),s=function s(e){return function(t,n,s){var a,c=r(t),u=i(c),l=o(s,u);if(e&&n!=n){for(;u>l;){if((a=c[l++])!=a)return!0;}}else for(;u>l;l++){if((e||l in c)&&c[l]===n)return e||l||0;}return!e&&-1;};};e.exports={includes:s(!0),indexOf:s(!1)};},function(e,t,n){var r=n(307);e.exports=function(e,t){return new(r(e))(0===t?0:t);};},function(e,t,n){var r={};r[n(18)("toStringTag")]="z",e.exports="[object z]"===String(r);},function(e,t,n){var r=n(28),o=n(195),i=n(43),s=n(33),a=n(38),c=n(108);t.f=r&&!o?Object.defineProperties:function(e,t){s(e);for(var n,r=a(t),o=c(t),u=o.length,l=0;u>l;){i.f(e,n=o[l++],r[n]);}return e;};},function(e,t){e.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"];},function(e,t,n){var r=n(200),o=n(155).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,o);};},function(e,t,n){"use strict";var r=Object.prototype.hasOwnProperty,o="~";function i(){}function s(e,t,n){this.fn=e,this.context=t,this.once=n||!1;}function a(e,t,n,r,i){if("function"!=typeof n)throw new TypeError("The listener must be a function");var a=new s(n,r||e,i),c=o?o+t:t;return e._events[c]?e._events[c].fn?e._events[c]=[e._events[c],a]:e._events[c].push(a):(e._events[c]=a,e._eventsCount++),e;}function c(e,t){0==--e._eventsCount?e._events=new i():delete e._events[t];}function u(){this._events=new i(),this._eventsCount=0;}Object.create&&(i.prototype=Object.create(null),new i().__proto__||(o=!1)),u.prototype.eventNames=function(){var e,t,n=[];if(0===this._eventsCount)return n;for(t in e=this._events){r.call(e,t)&&n.push(o?t.slice(1):t);}return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(e)):n;},u.prototype.listeners=function(e){var t=o?o+e:e,n=this._events[t];if(!n)return[];if(n.fn)return[n.fn];for(var r=0,i=n.length,s=new Array(i);r<i;r++){s[r]=n[r].fn;}return s;},u.prototype.listenerCount=function(e){var t=o?o+e:e,n=this._events[t];return n?n.fn?1:n.length:0;},u.prototype.emit=function(e,t,n,r,i,s){var a=o?o+e:e;if(!this._events[a])return!1;var c,u,l=this._events[a],m=arguments.length;if(l.fn){switch(l.once&&this.removeListener(e,l.fn,void 0,!0),m){case 1:return l.fn.call(l.context),!0;case 2:return l.fn.call(l.context,t),!0;case 3:return l.fn.call(l.context,t,n),!0;case 4:return l.fn.call(l.context,t,n,r),!0;case 5:return l.fn.call(l.context,t,n,r,i),!0;case 6:return l.fn.call(l.context,t,n,r,i,s),!0;}for(u=1,c=new Array(m-1);u<m;u++){c[u-1]=arguments[u];}l.fn.apply(l.context,c);}else{var p,d=l.length;for(u=0;u<d;u++){switch(l[u].once&&this.removeListener(e,l[u].fn,void 0,!0),m){case 1:l[u].fn.call(l[u].context);break;case 2:l[u].fn.call(l[u].context,t);break;case 3:l[u].fn.call(l[u].context,t,n);break;case 4:l[u].fn.call(l[u].context,t,n,r);break;default:if(!c)for(p=1,c=new Array(m-1);p<m;p++){c[p-1]=arguments[p];}l[u].fn.apply(l[u].context,c);}}}return!0;},u.prototype.on=function(e,t,n){return a(this,e,t,n,!1);},u.prototype.once=function(e,t,n){return a(this,e,t,n,!0);},u.prototype.removeListener=function(e,t,n,r){var i=o?o+e:e;if(!this._events[i])return this;if(!t)return c(this,i),this;var s=this._events[i];if(s.fn)s.fn!==t||r&&!s.once||n&&s.context!==n||c(this,i);else{for(var a=0,u=[],l=s.length;a<l;a++){(s[a].fn!==t||r&&!s[a].once||n&&s[a].context!==n)&&u.push(s[a]);}u.length?this._events[i]=1===u.length?u[0]:u:c(this,i);}return this;},u.prototype.removeAllListeners=function(e){var t;return e?(t=o?o+e:e,this._events[t]&&c(this,t)):(this._events=new i(),this._eventsCount=0),this;},u.prototype.off=u.prototype.removeListener,u.prototype.addListener=u.prototype.on,u.prefixed=o,u.EventEmitter=u,e.exports=u;},function(e,t,n){e.exports=n(406);},function(e,t,n){var r=n(70)(n(45),"Map");e.exports=r;},function(e,t,n){var r=n(45).Symbol;e.exports=r;},function(e,t,n){var r=n(249),o=n(511),i=n(253);e.exports=function(e){return i(e)?r(e):o(e);};},function(e,t){var n=Array.isArray;e.exports=n;},function(e,t){e.exports=function(e){return function(t){return e(t);};};},function(e,t,n){(function(e){var r=n(245),o=t&&!t.nodeType&&t,i=o&&"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e&&!e.nodeType&&e,s=i&&i.exports===o&&r.process,a=function(){try{var e=i&&i.require&&i.require("util").types;return e||s&&s.binding&&s.binding("util");}catch(e){}}();e.exports=a;}).call(this,n(135)(e));},function(e,t){var n=Object.prototype;e.exports=function(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||n);};},function(e,t,n){var r=n(249),o=n(514),i=n(253);e.exports=function(e){return i(e)?r(e,!0):o(e);};},function(e,t,n){var r=n(519),o=n(254),i=Object.prototype.propertyIsEnumerable,s=Object.getOwnPropertySymbols,a=s?function(e){return null==e?[]:(e=Object(e),r(s(e),function(t){return i.call(e,t);}));}:o;e.exports=a;},function(e,t,n){var r=n(523),o=n(159),i=n(524),s=n(525),a=n(526),c=n(131),u=n(246),l=u(r),m=u(o),p=u(i),d=u(s),f=u(a),g=c;(r&&"[object DataView]"!=g(new r(new ArrayBuffer(1)))||o&&"[object Map]"!=g(new o())||i&&"[object Promise]"!=g(i.resolve())||s&&"[object Set]"!=g(new s())||a&&"[object WeakMap]"!=g(new a()))&&(g=function g(e){var t=c(e),n="[object Object]"==t?e.constructor:void 0,r=n?u(n):"";if(r)switch(r){case l:return"[object DataView]";case m:return"[object Map]";case p:return"[object Promise]";case d:return"[object Set]";case f:return"[object WeakMap]";}return t;}),e.exports=g;},function(e,t,n){var r=n(529);e.exports=function(e){var t=new e.constructor(e.byteLength);return new r(t).set(new r(e)),t;};},function(e,t,n){var r=n(13),o=n(93),i=n(44),s=n(136),a=r("".replace),c="["+s+"]",u=RegExp("^"+c+c+"*"),l=RegExp(c+c+"*$"),m=function m(e){return function(t){var n=i(o(t));return 1&e&&(n=a(n,u,"")),2&e&&(n=a(n,l,"")),n;};};e.exports={start:m(1),end:m(2),trim:m(3)};},function(e,t,n){var r=n(106),o=n(565);r.json=o,e.exports=r;},function(e,t,n){var r=n(15),o=n(27),i=n(4),s=n(2),a=n(47),c=a.f,u=n(556);function l(e){e.onload&&this.once("load",e.onload),e.onerror&&this.once("error",e.onerror),e.onbeforesend&&this.once("beforesend",e.onbeforesend),e.onaftersend&&this.once("aftersend",e.onaftersend);var t=(e=this.options=a.fetch({method:"GET",url:"",sync:!1,data:null,headers:{},cookie:!1,timeout:6e4,type:"text",form:null,input:null,putFileAtEnd:!1,proxyUrl:""},e)).headers;a.notexist(t["Content-Type"])&&(t["Content-Type"]="application/x-www-form-urlencoded"),this.send();}var m=l.prototype=r(u.prototype);m.send=function(){var e=this,t=e.options;o(function(){try{try{e.emit("beforesend",t);}catch(e){}e.doSend();}catch(t){e.onError("serverError","请求失败:"+t.message);}},0);},m.doSend=c,m.afterSend=function(){var e=this;o(function(){e.emit("aftersend",e.options);},0);},m.onLoad=function(e){var t,n=this.options,r=e.status,o=e.result;if("number"!=typeof r||0!==r){if(0===i(t=""+r).call(t,"2")){if("json"===n.type)try{o=JSON.parse(o);}catch(e){return void this.onError("parseError",o);}this.emit("load",o);}else this.onError("serverError","服务器返回异常状态",{status:r,result:o,date:e.date});}else this.onError("netError","网络错误",{status:408});},m.onError=function(e,t,n){var r=a.isObject(n)?n:{};r.code=e||"error",r.message=t||"发生错误",this.emit("error",r);},m.onTimeout=function(){this.onError("timeout","请求超时");},m.abort=function(){this.onError("abort","客户端中止");},m.header=function(e){var t=this;if(!a.isArray(e))return t.getResponseHeader(e||"");var n={};return s(e).call(e,function(e){n[e]=t.header(e);}),n;},m.getResponseHeader=c,m.destroy=c,e.exports=l;},function(e,t,n){e.exports=n(602);},function(e,t){var n={link:{id:1,heartbeat:2,negotiateTransport:5,initTransport:6},sync:{id:5,sync:1,syncTeamMembers:2},misc:{id:6,getSimpleNosToken:1,getNosToken:2,notifyUploadLog:3,uploadSdkLogUrl:4,audioToText:5,processImage:6,getNosTokenTrans:7,notifyTransLog:8,fetchFile:9,fetchFileList:10,removeFile:11,getClientAntispam:17,fileQuickTransfer:18,getNosOriginUrl:22,getServerTime:23,getNosAccessToken:24,deleteNosAccessToken:25,getNosCdnHost:26,getGrayscaleConfig:27,getMixStorePolicy:28,getMixStoreToken:29,getBackSourceToken:30,uploadDetect:32},avSignal:{id:15,signalingCreate:1,signalingDelay:2,signalingClose:3,signalingJoin:4,signalingLeave:5,signalingInvite:6,signalingCancel:7,signalingReject:8,signalingAccept:9,signalingControl:10,signalingNotify:11,signalingMutilClientSyncNotify:12,signalingUnreadMessageSyncNotify:13,signalingChannelsSyncNotify:14,signalingGetChannelInfo:15,signalingCallEx:16,signalingJoinAndAccept:17}},r={heartbeat:{sid:n.link.id,cid:n.link.heartbeat},negotiateTransport:{sid:n.link.id,cid:n.link.negotiateTransport,params:[{type:"int",name:"sdkVersion"},{type:"Property",name:"negotiateTransportTag"}]},initTransport:{sid:n.link.id,cid:n.link.initTransport,params:[{type:"Property",name:"initTransportTag"}]},getGrayscaleConfig:{sid:n.misc.id,cid:n.misc.getGrayscaleConfig,params:[{type:"Property",name:"providers"}]},getMixStorePolicy:{sid:n.misc.id,cid:n.misc.getMixStorePolicy,params:[{type:"LongArray",name:"providers"}]},getMixStoreToken:{sid:n.misc.id,cid:n.misc.getMixStoreToken,params:[{type:"Property",name:"mixTokenReq"}]},getBackSourceToken:{sid:n.misc.id,cid:n.misc.getBackSourceToken,params:[{type:"Property",name:"mixAuthTokenReq"}]},uploadDetect:{sid:n.misc.id,cid:n.misc.uploadDetect,isAwaitable:!1,params:[{type:"Property",name:"notifyDetectTag"}]},getSimpleNosToken:{sid:n.misc.id,cid:n.misc.getSimpleNosToken,params:[{type:"int",name:"num"}]},getNosToken:{sid:n.misc.id,cid:n.misc.getNosToken,params:[{type:"String",name:"responseBody"},{type:"Property",name:"nosToken",entity:"nosToken"}]},uploadSdkLogUrl:{sid:n.misc.id,cid:n.misc.uploadSdkLogUrl,params:[{type:"string",name:"url"}]},audioToText:{sid:n.misc.id,cid:n.misc.audioToText,params:[{type:"Property",name:"audioToText"}]},processImage:{sid:n.misc.id,cid:n.misc.processImage,params:[{type:"String",name:"url"},{type:"PropertyArray",name:"imageOps",entity:"imageOp"}]},getClientAntispam:{sid:n.misc.id,cid:n.misc.getClientAntispam,params:[{type:"Property",name:"clientAntispam"}]},fileQuickTransfer:{sid:n.misc.id,cid:n.misc.fileQuickTransfer,params:[{type:"Property",name:"fileQuickTransfer"}]},getNosOriginUrl:{sid:n.misc.id,cid:n.misc.getNosOriginUrl,params:[{type:"Property",name:"nosFileUrlTag"}]},getServerTime:{sid:n.misc.id,cid:n.misc.getServerTime,params:[]},getNosAccessToken:{sid:n.misc.id,cid:n.misc.getNosAccessToken,params:[{type:"Property",name:"nosAccessTokenTag"}]},deleteNosAccessToken:{sid:n.misc.id,cid:n.misc.deleteNosAccessToken,params:[{type:"Property",name:"nosAccessTokenTag"}]},getNosTokenTrans:{sid:n.misc.id,cid:n.misc.getNosTokenTrans,params:[{type:"Property",name:"transToken"}]},fetchFile:{sid:n.misc.id,cid:n.misc.fetchFile,params:[{type:"String",name:"docId"}]},fetchFileList:{sid:n.misc.id,cid:n.misc.fetchFileList,params:[{type:"Property",name:"fileListParam"}]},removeFile:{sid:n.misc.id,cid:n.misc.removeFile,params:[{type:"String",name:"docId"}]},getNosCdnHost:{sid:n.misc.id,cid:n.misc.getNosCdnHost,params:[]},signalingCreate:{sid:n.avSignal.id,cid:n.avSignal.signalingCreate,params:[{type:"Property",name:"avSignalTag"}]},signalingDelay:{sid:n.avSignal.id,cid:n.avSignal.signalingDelay,params:[{type:"Property",name:"avSignalTag"}]},signalingClose:{sid:n.avSignal.id,cid:n.avSignal.signalingClose,params:[{type:"Property",name:"avSignalTag"}]},signalingJoin:{sid:n.avSignal.id,cid:n.avSignal.signalingJoin,params:[{type:"Property",name:"avSignalTag"}]},signalingLeave:{sid:n.avSignal.id,cid:n.avSignal.signalingLeave,params:[{type:"Property",name:"avSignalTag"}]},signalingInvite:{sid:n.avSignal.id,cid:n.avSignal.signalingInvite,params:[{type:"Property",name:"avSignalTag"}]},signalingCancel:{sid:n.avSignal.id,cid:n.avSignal.signalingCancel,params:[{type:"Property",name:"avSignalTag"}]},signalingReject:{sid:n.avSignal.id,cid:n.avSignal.signalingReject,params:[{type:"Property",name:"avSignalTag"}]},signalingAccept:{sid:n.avSignal.id,cid:n.avSignal.signalingAccept,params:[{type:"Property",name:"avSignalTag"}]},signalingControl:{sid:n.avSignal.id,cid:n.avSignal.signalingControl,params:[{type:"Property",name:"avSignalTag"}]},signalingGetChannelInfo:{sid:n.avSignal.id,cid:n.avSignal.signalingGetChannelInfo,params:[{type:"Property",name:"avSignalTag"}]},signalingCallEx:{sid:n.avSignal.id,cid:n.avSignal.signalingCallEx,params:[{type:"Property",name:"avSignalTag"}]},signalingJoinAndAccept:{sid:n.avSignal.id,cid:n.avSignal.signalingJoinAndAccept,params:[{type:"Property",name:"avSignalTag"}]}};e.exports={idMap:n,cmdConfig:r,packetConfig:{"1_2":{service:"link",cmd:"heartbeat"},"1_5":{service:"link",cmd:"negotiateTransport",response:[{type:"Property",name:"negotiateTransportTag"}]},"1_6":{service:"link",cmd:"initTransport",response:[{type:"Property",name:"initTransportTag"}]},"6_1":{service:"misc",cmd:"getSimpleNosToken",response:[{type:"PropertyArray",name:"nosTokens",entity:"nosToken"}]},"6_2":{service:"misc",cmd:"getNosToken",response:[{type:"Property",name:"nosToken"}]},"6_3":{service:"misc",cmd:"notifyUploadLog"},"6_4":{service:"misc",cmd:"uploadSdkLogUrl"},"6_5":{service:"misc",cmd:"audioToText",response:[{type:"String",name:"text"}]},"6_6":{service:"misc",cmd:"processImage",response:[{type:"String",name:"url"}]},"6_7":{service:"misc",cmd:"getNosTokenTrans",response:[{type:"Property",name:"nosToken"},{type:"String",name:"docId"}]},"6_8":{service:"misc",cmd:"notifyTransLog",response:[{type:"Property",name:"transInfo"}]},"6_9":{service:"misc",cmd:"fetchFile",response:[{type:"Property",name:"info",entity:"transInfo"}]},"6_10":{service:"misc",cmd:"fetchFileList",response:[{type:"PropertyArray",name:"list",entity:"transInfo"},{type:"Number",name:"totalCount"}]},"6_11":{service:"misc",cmd:"removeFile",response:[{type:"String",name:"res"}]},"6_17":{service:"misc",cmd:"getClientAntispam",response:[{type:"Property",name:"clientAntispam"}]},"6_18":{service:"misc",cmd:"fileQuickTransfer",response:[{type:"Property",name:"fileQuickTransfer"}]},"6_22":{service:"misc",cmd:"getNosOriginUrl",response:[{type:"Property",name:"nosFileUrlTag"}]},"6_23":{service:"misc",cmd:"getServerTime",response:[{type:"Number",name:"time"}]},"6_24":{service:"misc",cmd:"getNosAccessToken",response:[{type:"Property",name:"nosAccessTokenTag"}]},"6_25":{service:"misc",cmd:"deleteNosAccessToken"},"6_26":{service:"misc",cmd:"getNosCdnHost",response:[{type:"Property",name:"nosConfigTag"}]},"6_27":{service:"misc",cmd:"getGrayscaleConfig",response:[{type:"Property",name:"appGrayConfigTag"}]},"6_28":{service:"misc",cmd:"getMixStorePolicy",response:[{type:"Property",name:"mixStorePolicyTag"}]},"6_29":{service:"misc",cmd:"getMixStoreToken",response:[{type:"Property",name:"mixStoreTokenTag"}]},"6_30":{service:"misc",cmd:"getBackSourceToken",response:[{type:"Property",name:"backSourceTokenTag"}]},"6_31":{service:"link",cmd:"notifyDetect",response:[{type:"Property",name:"notifyDetectTag"}]},"6_32":{service:"link",cmd:"uploadDetect",response:[]},"15_1":{service:"avSignal",cmd:"signalingCreate",response:[{type:"Property",name:"avSignalTag"}]},"15_2":{service:"avSignal",cmd:"signalingDelay",response:[{type:"Property",name:"avSignalTag"}]},"15_3":{service:"avSignal",cmd:"signalingClose",response:[{type:"Property",name:"avSignalTag"}]},"15_4":{service:"avSignal",cmd:"signalingJoin",response:[{type:"Property",name:"avSignalTag"}]},"15_5":{service:"avSignal",cmd:"signalingLeave",response:[]},"15_6":{service:"avSignal",cmd:"signalingInvite",response:[]},"15_7":{service:"avSignal",cmd:"signalingCancel",response:[]},"15_8":{service:"avSignal",cmd:"signalingReject",response:[]},"15_9":{service:"avSignal",cmd:"signalingAccept",response:[]},"15_10":{service:"avSignal",cmd:"signalingControl",response:[]},"15_11":{service:"avSignal",cmd:"signalingNotify",response:[{type:"Property",name:"avSignalTag"}]},"15_12":{service:"avSignal",cmd:"signalingMutilClientSyncNotify",response:[{type:"Property",name:"avSignalTag"}]},"15_13":{service:"avSignal",cmd:"signalingUnreadMessageSyncNotify",response:[{type:"PropertyArray",name:"avSignalTag"}]},"15_14":{service:"avSignal",cmd:"signalingChannelsSyncNotify",response:[{type:"PropertyArray",name:"avSignalTag"}]},"15_15":{service:"avSignal",cmd:"signalingGetChannelInfo",response:[{type:"Property",name:"avSignalTag"}]},"15_16":{service:"avSignal",cmd:"signalingCallEx",response:[{type:"Property",name:"avSignalTag"}]},"15_17":{service:"avSignal",cmd:"signalingJoinAndAccept",response:[{type:"Property",name:"avSignalTag"}]}}};},function(e,t,n){var r=n(5),o=n(2),i=n(23),s=n(0),a=s.notundef,c=s.fillPropertyWithDefault,u=r,l={},m={},p=[],d={},f={normal:0,advanced:1},g={0:"normal",1:"advanced"},h=u(f),y=l.joinMode={noVerify:0,needVerify:1,rejectAll:2};m.joinMode={0:"noVerify",1:"needVerify",2:"rejectAll"},p.push("join"),d.joinMode=u(y);var v=l.beInviteMode={needVerify:0,noVerify:1};m.beInviteMode={0:"needVerify",1:"noVerify"},p.push("beInvite"),d.beInviteMode=u(v);var b=l.inviteMode={manager:0,all:1};m.inviteMode={0:"manager",1:"all"},p.push("invite"),d.inviteMode=u(b);var T=l.updateTeamMode={manager:0,all:1};m.updateTeamMode={0:"manager",1:"all"},p.push("updateTeam"),d.updateTeamMode=u(T);var S=l.updateCustomMode={manager:0,all:1};function M(e){var t;switch(s.verifyOptions(e,"action","team::Team"),e.action){case"create":s.verifyOptions(e,"teamId",!1,"team::Team"),s.verifyOptions(e,"type name","team::Team"),s.verifyParamValid("type",e.type,h,"team::Team"),a(e.level)&&(s.verifyParamType("level",e.level,"number","team::Team"),this.level=e.level);break;case"update":s.verifyOptions(e,"teamId","team::Team"),s.verifyOptions(e,"type",!1,"team::Team");}a(e.teamId)&&(this.teamId=e.teamId),a(e.type)&&(this.type=f[e.type]),a(e.avatar)&&(this.avatar=""+e.avatar),a(e.name)&&(this.name=""+e.name),a(e.intro)&&(this.intro=""+e.intro),a(e.announcement)&&(this.announcement=""+e.announcement),o(p).call(p,i(t=this.setMode).call(t,this,e)),a(e.custom)&&(this.custom=""+e.custom);}function k(e,t){a(e[t+="Mode"])&&(e[t]=m[t][e[t]]);}m.updateCustomMode={0:"manager",1:"all"},p.push("updateCustom"),d.updateCustomMode=u(S),M.prototype.setMode=function(e,t){a(e[t+="Mode"])&&(s.verifyParamValid(t,e[t],d[t],"team::Team"),this[t]=l[t][e[t]]);},M.reverse=function(e,t){var n=s.copy(e);if(a(n.teamId)&&(n.teamId=""+n.teamId),a(n.type)&&(n.type=g[n.type]),a(n.level)&&(n.level=+n.level),a(n.valid)&&(n.valid=1==+n.valid),a(n.memberNum)&&(n.memberNum=+n.memberNum),a(n.memberUpdateTime)&&(n.memberUpdateTime=+n.memberUpdateTime),a(n.createTime)&&(n.createTime=+n.createTime),a(n.updateTime)&&(n.updateTime=+n.updateTime),a(n.validToCurrentUser)&&(n.validToCurrentUser="1"===n.validToCurrentUser),a(n.mute)&&(n.mute="1"===n.mute),a(n.muteType))switch(n.muteType){case"0":n.mute=!1,n.muteType="none";break;case"1":n.mute=!0,n.muteType="normal";break;case"3":n.mute=!0,n.muteType="all";}else a(n.mute)&&(1===n.mute?(n.mute=!0,n.muteType="normal"):(n.mute=!1,n.muteType="none"));return o(p).call(p,i(k).call(k,null,n)),delete n.bits,t||M.fillProperties(n),n;},M.fillProperties=function(e){var t=c(e,"beInviteMode","needVerify"),n=c(e,"inviteMode","manager"),r=c(e,"updateTeamMode","manager"),o=c(e,"updateCustomMode","manager"),i=c(e,"avatar","");return t||n||r||o||i;},e.exports=M;},function(e,t,n){var r=n(41).clientTypeMap;function o(){}o.reverse=function(e){var t=e;return t.type=r[t.type],t;},o.reverseType=function(e){return r[e]||e;},e.exports=o;},function(e,t,n){var r=n(15),o=n(35),i=n(10),s=n(57),a=n(178),c=n(14),u=n(693),l=n(816),m=n(0),p=m.verifyOptions,d=m.verifyParamType,f=n(137).Chatroom;function g(e){return this.subType="chatroom",this.nosScene=e.nosScene||"chatroom",this.nosSurvivalTime=e.nosSurvivalTime,e.Protocol=a,e.Message=l,e.constructor=g,e.isAnonymous&&(e.account=e.account||"nimanon_".concat(m.guid()),e.isAnonymous=1,m.verifyOptions(e,"chatroomNick","api::Chatroom"),e.chatroomAvatar=e.chatroomAvatar||" "),this.init(e);}g.Protocol=a,g.parser=f,g.use=s.use,g.getInstance=function(e){return e.isAnonymous&&(e.account=e.account||"nimanon_".concat(m.guid()),e.isAnonymous=1,m.verifyOptions(e,"chatroomNick","api::Chatroom.getInstance"),e.chatroomAvatar=e.chatroomAvatar||" "),s.getInstance.call(this,e);},g.genInstanceName=function(e){return m.verifyOptions(e,"chatroomId","api::Chatroom.genInstanceName"),"Chatroom-account-"+e.account+"-chatroomId-"+e.chatroomId;};var h=g.fn=g.prototype=r(s.prototype);g.info=h.info=c.info,h.getChatroom=function(e){this.processCallback(e),this.sendCmd("getChatroom",e);},h.updateChatroom=function(e){p(e,"chatroom needNotify","api::updateChatroom"),d("needNotify",e.needNotify,"boolean"),this.processCustom(e),this.processCallback(e),e.chatroom=new u(e.chatroom),e.antispamTag={antiSpamBusinessId:e.antiSpamBusinessId},this.sendCmd("updateChatroom",e);},h.closeChatroom=function(e){this.processCustom(e),this.processCallback(e),this.sendCmd("closeChatroom",e);},h.updateTags=function(e){m.validate({tags:{type:"array",required:!1},notifyTargetTags:{type:"string",allowEmpty:!0,required:!1},needNotify:{type:"boolean",required:!1}},e,"chatroom::updateTags");var t=o({},e);this.processCallback(t),t.tags&&(t.tags=i(t.tags)),t.needNotify&&(t.needNotify=t.needNotify?1:0),this.sendCmd("updateChatroomTags",{chatRoomTagsUpdateTag:t},t.done);},e.exports=g,n(826),n(827),n(828),n(829);},function(e,t,n){var r=n(15),o=n(23),i=n(7),s=n(16),a=n(6),c=n(63),u=n(0),l=u.undef,m=u.notundef,p=n(273),d=n(14),f=n(137),g=n(693),h=n(291);function y(e){var t;u.verifyOptions(e,"appKey account chatroomId chatroomAddresses","protocol::ChatroomProtocol"),e.isAnonymous||u.verifyOptions(e,"token","protocol::ChatroomProtocol"),u.verifyParamType("chatroomAddresses",e.chatroomAddresses,"array","protocol::ChatroomProtocol"),u.verifyCallback(e,"onconnect onerror onwillreconnect ondisconnect onmsg onmsgs onrobots","protocol::ChatroomProtocol"),t="boolean"==typeof u.get(e,"privateConf.isDataReportEnable")?e.privateConf.isDataReportEnable:d.privateConf.isDataReportEnable,this.reporter=p.initReporter({appKey:e.appKey,logger:this.logger},t),c.call(this,e);}var v=c.fn,b=y.fn=y.prototype=r(v);b.init=function(){var e;v.init.call(this),f.Chatroom.setProtocol(this),this.parser=f.Chatroom,o(e=this.sendCmd).call(e,this),this.syncResult={},this.timetags={},this.msgBuffer=[];},b.reset=function(){var e=this;v.reset.call(e);var t,n,r=e.options;(e.autoconnect=!!r.autoconnect,l(r.msgBufferInterval)&&(r.msgBufferInterval=300),u.verifyParamType("msgBufferInterval",r.msgBufferInterval,"number","protocol::ChatroomProtocol.reset"),l(r.msgBufferSize)&&(r.msgBufferSize=500),u.verifyParamType("msgBufferSize",r.msgBufferSize,"number","protocol::ChatroomProtocol.reset"),m(r.chatroomAddresses))&&(e.socketUrls=i(t=r.chatroomAddresses).call(t,function(t){return d.formatSocketUrl({url:t,secure:e.options.secure});}),e.socketUrlsBackup=s(n=e.socketUrls).call(n,0));},b.processChatroom=function(e){switch(e.cmd){case"login":e.error||(e.obj={chatroom:a(g).call(g,e.content.chatroom),member:a(h).call(h,e.content.chatroomMember)},this.cdnInfo={},this.initCdnData(),clearTimeout(this.queryCdnTimer),this.onCdnMsgInfo(e.content.chatroomCdnInfo));break;case"kicked":this.onKicked(e);break;case"logout":break;case"sendMsg":this.onSendMsg(e);break;case"msg":this.onMsg(e),this.cdnInfo&&this.cdnInfo.enable&&this.correctCdnTime(+e.content.msg.time);break;case"getChatroomMembers":case"getChatroomMembersByTag":this.onChatroomMembers(e);break;case"getChatroomMemberCountByTag":this.onGetChatroomMemberCountByTag(e);break;case"getHistoryMsgs":case"getHistoryMsgsByTags":this.onHistoryMsgs(e);break;case"markChatroomMember":this.onMarkChatroomMember(e);break;case"closeChatroom":break;case"getChatroom":this.onChatroom(e);break;case"updateChatroom":break;case"updateMyChatroomMemberInfo":delete e.obj.chatroomMember;break;case"getChatroomMembersInfo":this.onChatroomMembersInfo(e);break;case"kickChatroomMember":case"updateChatroomMemberTempMute":break;case"queueList":e.error||(e.obj=e.content);break;case"syncRobot":this.onSyncRobot(e);break;case"notifyCdnInfo":this.onCdnMsgInfo(e.content&&e.content.chatroomCdnInfo);break;case"updateChatroomTag":this.onTagsUpdate(e.content);}},b.onChatroom=function(e){e.error||(e.obj.chatroom=a(g).call(g,e.content.chatroom));},b.onTagsUpdate=function(e){if(this.logger.info("onTagsUpdate:: ",e),this.options.onTagsUpdate&&"function"==typeof this.options.onTagsUpdate){var t=e.updateTags&&e.updateTags.currentTags;try{t=JSON.parse(t);}catch(e){this.logger.error("onTagsUpdate:: parse tags failed",e);}this.options.onTagsUpdate(t);}},e.exports=y,n(804),n(805),n(806),n(815);},function(e,t){e.exports=function(){};},function(e,t,n){e.exports=n(427);},function(e,t){e.exports=function(e,t){var n=t.split(".");for(;n.length;){var r=n.shift(),o=!1;if("?"==r[r.length-1]&&(r=r.slice(0,-1),o=!0),!(e=e[r])&&o)return e;}return e;};},function(e,t){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(126),o=n(235);function i(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),r(e,o(i.key),i);}}e.exports=function(e,t,n){return t&&i(e.prototype,t),n&&i(e,n),r(e,"prototype",{writable:!1}),e;},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(608);},function(e,t,n){e.exports=n(621);},function(e,t,n){var r=n(7),o=n(6),i=n(0),s=i.notundef,a=i.fillPropertyWithDefault,c={0:"normal",1:"owner",2:"manager"};function u(e){i.verifyOptions(e,"teamId","superTeam::TeamMember"),i.verifyParamAtLeastPresentOne(e,"nickInTeam muteTeam custom muteNotiType","superTeam::SuperTeamMember"),this.teamId=e.teamId,s(e.account)&&(this.account=e.account),s(e.nickInTeam)&&(this.nickInTeam=e.nickInTeam),s(e.muteNotiType)?this.bits=e.muteNotiType:s(e.muteTeam)&&(this.bits=0,e.muteTeam&&(this.bits+=1)),s(e.mute)&&(this.mute=e.mute?1:0),s(e.custom)&&(this.custom=""+e.custom);}u.reverse=function(e){var t=i.copy(e);if(s(t.teamId)&&(t.teamId=""+t.teamId),s(t.type)&&(t.type=c[t.type]),s(t.active)&&(t.active=1==+t.active),s(t.valid)&&(t.valid=1==+t.valid),s(t.mute)&&(t.mute=1==+t.mute),s(t.joinTime)&&(t.joinTime=+t.joinTime),s(t.updateTime)&&(t.updateTime=+t.updateTime),s(t.bits)){var n=t.bits;delete t.bits,t.muteTeam=!!(1&n),t.muteNotiType=n;}return s(t.teamId)&&s(t.account)&&(t.id=u.genId(t.teamId,t.account)),t;},u.reverseMembers=function(e){return r(e).call(e,function(e){return o(u).call(u,e);});},u.fillProperties=function(e){var t=a(e,"mute",!1),n=a(e,"custom","");return t||n;},u.genId=function(e,t){return e+"-"+t;},u.accounts2ids=function(e,t){return r(t).call(t,function(t){return u.genId(e,t);});},u.assembleMembers=function(e,t){return i.isArray(t)||(t=[t]),r(t).call(t,function(t){return u.assembleMember(e,t);});},u.assembleMember=function(e,t){return{id:u.genId(e.teamId,t),account:t,teamId:e.teamId,type:"normal",nickInTeam:"",muteTeam:!1,mute:!1,joinTime:e.memberUpdateTime,updateTime:e.memberUpdateTime,active:!0,valid:!0};},u.assembleOwner=function(e){var t=u.assembleMember(e,e.owner);return t.type="owner",t;},e.exports=u;},function(e,t,n){var r=n(7),o=n(6),i=n(5),s=n(91).genPrivateUrl,a=n(0),c={unknown:0,male:1,female:2},u={0:"unknown",1:"male",2:"female"};function l(e){a.merge(this,e),a.notundef(this.gender)&&(a.verifyParamValid("gender",this.gender,l.validGenders,"user::User"),this.gender=c[this.gender]),a.notundef(this.email)&&""!==this.email&&a.verifyEmail("email",this.email,"user::User"),a.notundef(this.birth)&&""!==this.birth&&a.verifyBirth("birth",this.birth,"user::User"),a.notundef(this.tel)&&""!==this.tel&&a.verifyTel("tel",this.tel,"user::User");}l.reverse=function(e,t,n){var r=a.filterObj(e,"account nick avatar _avatar_safe sign gender email birth tel custom createTime updateTime");return a.notundef(r.avatar)&&(r.avatar=s(r.avatar,t,n)),a.notundef(r.gender)&&(r.gender=u[r.gender]),a.notundef(r.createTime)&&(r.createTime=+r.createTime),a.notundef(r.updateTime)&&(r.updateTime=+r.updateTime),r;},l.reverseUsers=function(e){return r(e).call(e,function(e){return o(l).call(l,e);});},l.validGenders=i(c),e.exports=l;},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(4),a=n(91).genPrivateUrl,c=n(56),u=n(0),l=n(14);function m(e,t){switch(u.notundef(e.type)?u.verifyFileType(e.type,"msg::FileMessage"):e.type="file",u.verifyOptions(e,"file","msg::FileMessage"),u.verifyOptions(e.file,"url ext size",!0,"file.","msg::FileMessage"),e.type){case"image":p.verifyFile(e.file,"msg::FileMessage");break;case"audio":d.verifyFile(e.file,"msg::FileMessage");break;case"video":f.verifyFile(e.file,"msg::FileMessage");}c.call(this,e),t&&(this.idClient=t),this.attach=r(e.file);}m.prototype=o(c.prototype),m.reverse=function(e){var t=i(c).call(c,e);if(e.attach=e.attach?""+e.attach:"",e.attach&&(t.file=JSON.parse(e.attach),!t.file.isS3)){var n,r;if(t.file.url=a(t.file.url)||"","audio"===t.type&&t.file.url&&!t.file.mp3Url)t.file.mp3Url=t.file.url+(~s(r=t.file.url).call(r,"?")?"&":"?")+"audioTrans&type=mp3";l.httpsEnabled&&0!==s(n=t.file.url).call(n,"https://")&&(t.file.url=t.file.url.replace("http","https"));}return t;},e.exports=m;var p=n(761),d=n(762),f=n(763);},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(4),a=n(91).genPrivateUrl,c=n(107),u=n(0),l=n(14);function m(e,t){switch(u.notundef(e.type)?u.verifyFileType(e.type,"msg::FileMessage"):e.type="file",u.verifyOptions(e,"file","msg::FileMessage"),u.verifyOptions(e.file,"url ext size",!0,"file.","msg::FileMessage"),e.type){case"image":p.verifyFile(e.file,"msg::FileMessage");break;case"audio":d.verifyFile(e.file,"msg::FileMessage");break;case"video":f.verifyFile(e.file,"msg::FileMessage");}c.call(this,e),t&&(this.idClient=t),this.attach=r(e.file);}m.prototype=o(c.prototype),m.reverse=function(e){var t=i(c).call(c,e);if(e.attach=e.attach?""+e.attach:"",e.attach&&(t.file=JSON.parse(e.attach),!t.file.isS3)){var n,r;if(t.file.url=a(t.file.url)||"","audio"===t.type&&t.file.url&&!t.file.mp3Url)t.file.mp3Url=t.file.url+(~s(r=t.file.url).call(r,"?")?"&":"?")+"audioTrans&type=mp3";l.httpsEnabled&&0!==s(n=t.file.url).call(n,"https://")&&(t.file.url=t.file.url.replace("http","https"));}return t;},e.exports=m;var p=n(818),d=n(819),f=n(820);},function(e,t,n){var r=n(296);e.exports=r;},function(e,t){var n="object"==(typeof document==="undefined"?"undefined":_typeof(document))&&document.all,r=void 0===n&&void 0!==n;e.exports={all:n,IS_HTMLDDA:r};},function(e,t,n){var r=n(76);e.exports=r&&!Symbol.sham&&"symbol"==_typeof(Symbol.iterator);},function(e,t,n){var r=n(28),o=n(8),i=n(150);e.exports=!r&&!o(function(){return 7!=Object.defineProperty(i("div"),"a",{get:function get(){return 7;}}).a;});},function(e,t,n){var r=n(8),o=n(20),i=/#|\.prototype\./,s=function s(e,t){var n=c[a(e)];return n==l||n!=u&&(o(t)?r(t):!!t);},a=s.normalize=function(e){return String(e).replace(i,".").toLowerCase();},c=s.data={},u=s.NATIVE="N",l=s.POLYFILL="P";e.exports=s;},function(e,t,n){var r=n(28),o=n(8);e.exports=r&&o(function(){return 42!=Object.defineProperty(function(){},"prototype",{value:42,writable:!1}).prototype;});},function(e,t,n){"use strict";var r=n(1),o=n(8),i=n(67),s=n(29),a=n(37),c=n(40),u=n(197),l=n(81),m=n(152),p=n(96),d=n(18),f=n(77),g=d("isConcatSpreadable"),h=f>=51||!o(function(){var e=[];return e[g]=!1,e.concat()[0]!==e;}),y=p("concat"),v=function v(e){if(!s(e))return!1;var t=e[g];return void 0!==t?!!t:i(e);};r({target:"Array",proto:!0,arity:1,forced:!h||!y},{concat:function concat(e){var t,n,r,o,i,s=a(this),p=m(s,0),d=0;for(t=-1,r=arguments.length;t<r;t++){if(v(i=-1===t?s:arguments[t]))for(o=c(i),u(d+o),n=0;n<o;n++,d++){n in i&&l(p,d,i[n]);}else u(d+1),l(p,d++,i);}return p.length=d,p;}});},function(e,t){var n=TypeError;e.exports=function(e){if(e>9007199254740991)throw n("Maximum allowed index exceeded");return e;};},function(e,t,n){var r=n(13),o=n(20),i=n(148),s=r(Function.toString);o(i.inspectSource)||(i.inspectSource=function(e){return s(e);}),e.exports=i.inspectSource;},function(e,t,n){var r=n(308);e.exports=r;},function(e,t,n){var r=n(13),o=n(26),i=n(38),s=n(151).indexOf,a=n(117),c=r([].push);e.exports=function(e,t){var n,r=i(e),u=0,l=[];for(n in r){!o(a,n)&&o(r,n)&&c(l,n);}for(;t.length>u;){o(r,n=t[u++])&&(~s(l,n)||c(l,n));}return l;};},function(e,t,n){var r=n(31);e.exports=r("document","documentElement");},function(e,t,n){var r=n(313);n(69),e.exports=r;},function(e,t,n){n(314),n(317),n(318),n(208),n(319);},function(e,t,n){var r=n(65),o=n(38),i=n(156).f,s=n(205),a="object"==(typeof window==="undefined"?"undefined":_typeof(window))&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];e.exports.f=function(e){return a&&"Window"==r(e)?function(e){try{return i(e);}catch(e){return s(a);}}(e):i(o(e));};},function(e,t,n){var r=n(115),o=n(40),i=n(81),s=Array,a=Math.max;e.exports=function(e,t,n){for(var c=o(e),u=r(t,c),l=r(void 0===n?c:n,c),m=s(a(l-u,0)),p=0;u<l;u++,p++){i(m,p,e[u]);}return m.length=p,m;};},function(e,t,n){var r=n(25),o=n(31),i=n(18),s=n(68);e.exports=function(){var e=o("Symbol"),t=e&&e.prototype,n=t&&t.valueOf,a=i("toPrimitive");t&&!t[a]&&s(t,a,function(e){return r(n,this);},{arity:1});};},function(e,t,n){var r=n(76);e.exports=r&&!!Symbol.for&&!!Symbol.keyFor;},function(e,t,n){var r=n(1),o=n(31),i=n(64),s=n(25),a=n(13),c=n(8),u=n(67),l=n(20),m=n(29),p=n(114),d=n(98),f=n(76),g=o("JSON","stringify"),h=a(/./.exec),y=a("".charAt),v=a("".charCodeAt),b=a("".replace),T=a(1..toString),S=/[\uD800-\uDFFF]/g,M=/^[\uD800-\uDBFF]$/,k=/^[\uDC00-\uDFFF]$/,x=!f||c(function(){var e=o("Symbol")();return"[null]"!=g([e])||"{}"!=g({a:e})||"{}"!=g(Object(e));}),C=c(function(){return"\"\\udf06\\ud834\""!==g("\uDF06\uD834")||"\"\\udead\""!==g("\uDEAD");}),I=function I(e,t){var n=d(arguments),r=t;if((m(t)||void 0!==e)&&!p(e))return u(t)||(t=function t(e,_t){if(l(r)&&(_t=s(r,this,e,_t)),!p(_t))return _t;}),n[1]=t,i(g,null,n);},_=function _(e,t,n){var r=y(n,t-1),o=y(n,t+1);return h(M,e)&&!h(k,o)||h(k,e)&&!h(M,r)?"\\u"+T(v(e,0),16):e;};g&&r({target:"JSON",stat:!0,arity:3,forced:x||C},{stringify:function stringify(e,t,n){var r=d(arguments),o=i(x?I:g,null,r);return C&&"string"==typeof o?b(o,S,_):o;}});},function(e,t,n){n(21)("iterator");},function(e,t,n){var r=n(21),o=n(206);r("toPrimitive"),o();},function(e,t,n){"use strict";var r=n(1),o=n(25),i=n(42),s=n(212),a=n(20),c=n(335),u=n(122),l=n(123),m=n(83),p=n(51),d=n(68),f=n(18),g=n(85),h=n(213),y=s.PROPER,v=s.CONFIGURABLE,b=h.IteratorPrototype,T=h.BUGGY_SAFARI_ITERATORS,S=f("iterator"),M=function M(){return this;};e.exports=function(e,t,n,s,f,h,k){c(n,t,s);var x,C,I,_=function _(e){if(e===f&&E)return E;if(!T&&e in A)return A[e];switch(e){case"keys":case"values":case"entries":return function(){return new n(this,e);};}return function(){return new n(this);};},w=t+" Iterator",P=!1,A=e.prototype,O=A[S]||A["@@iterator"]||f&&A[f],E=!T&&O||_(f),R="Array"==t&&A.entries||O;if(R&&(x=u(R.call(new e())))!==Object.prototype&&x.next&&(i||u(x)===b||(l?l(x,b):a(x[S])||d(x,S,M)),m(x,w,!0,!0),i&&(g[w]=M)),y&&"values"==f&&O&&"values"!==O.name&&(!i&&v?p(A,"name","values"):(P=!0,E=function E(){return o(O,this);})),f)if(C={values:_("values"),keys:h?E:_("keys"),entries:_("entries")},k)for(I in C){(T||P||!(I in A))&&d(A,I,C[I]);}else r({target:t,proto:!0,forced:T||P},C);return i&&!k||A[S]===E||d(A,S,E,{name:f}),g[t]=E,C;};},function(e,t,n){var r=n(28),o=n(26),i=Function.prototype,s=r&&Object.getOwnPropertyDescriptor,a=o(i,"name"),c=a&&"something"===function(){}.name,u=a&&(!r||r&&s(i,"name").configurable);e.exports={EXISTS:a,PROPER:c,CONFIGURABLE:u};},function(e,t,n){"use strict";var r,o,i,s=n(8),a=n(20),c=n(29),u=n(82),l=n(122),m=n(68),p=n(18),d=n(42),f=p("iterator"),g=!1;[].keys&&("next"in(i=[].keys())?(o=l(l(i)))!==Object.prototype&&(r=o):g=!0),!c(r)||s(function(){var e={};return r[f].call(e)!==e;})?r={}:d&&(r=u(r)),a(r[f])||m(r,f,function(){return this;}),e.exports={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:g};},function(e,t,n){var r=n(8);e.exports=!r(function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e())!==e.prototype;});},function(e,t){e.exports=function(e,t){return{value:e,done:t};};},function(e,t,n){n(69);var r=n(52),o=n(26),i=n(19),s=n(355),a=Array.prototype,c={DOMTokenList:!0,NodeList:!0};e.exports=function(e){var t=e.forEach;return e===a||i(a,e)&&t===a.forEach||o(c,r(e))?s:t;};},function(e,t,n){var r=n(365);n(69),e.exports=r;},function(e,t,n){n(366);},function(e,t,n){var r=n(31),o=n(13),i=n(156),s=n(119),a=n(33),c=o([].concat);e.exports=r("Reflect","ownKeys")||function(e){var t=i.f(a(e)),n=s.f;return n?c(t,n(e)):t;};},function(e,t,n){var r=n(18),o=n(85),i=r("iterator"),s=Array.prototype;e.exports=function(e){return void 0!==e&&(o.Array===e||s[i]===e);};},function(e,t,n){var r=n(25),o=n(36),i=n(33),s=n(78),a=n(125),c=TypeError;e.exports=function(e,t){var n=arguments.length<2?a(e):t;if(o(n))return i(r(n,e));throw c(s(e)+" is not iterable");};},function(e,t,n){var r=n(25),o=n(33),i=n(147);e.exports=function(e,t,n){var s,a;o(e);try{if(!(s=i(e,"return"))){if("throw"===t)throw n;return n;}s=r(s,e);}catch(e){a=!0,s=e;}if("throw"===t)throw n;if(a)throw s;return o(s),n;};},function(e,t,n){var r=n(33),o=n(224),i=n(112),s=n(18)("species");e.exports=function(e,t){var n,a=r(e).constructor;return void 0===a||i(n=r(a)[s])?t:o(n);};},function(e,t,n){var r=n(116),o=n(78),i=TypeError;e.exports=function(e){if(r(e))return e;throw i(o(e)+" is not a constructor");};},function(e,t,n){var r,o,i,s,a=n(12),c=n(64),u=n(79),l=n(20),m=n(26),p=n(8),d=n(201),f=n(98),g=n(150),h=n(226),y=n(227),v=n(100),b=a.setImmediate,T=a.clearImmediate,S=a.process,M=a.Dispatch,k=a.Function,x=a.MessageChannel,C=a.String,I=0,_={};try{r=a.location;}catch(e){}var w=function w(e){if(m(_,e)){var t=_[e];delete _[e],t();}},P=function P(e){return function(){w(e);};},A=function A(e){w(e.data);},O=function O(e){a.postMessage(C(e),r.protocol+"//"+r.host);};b&&T||(b=function b(e){h(arguments.length,1);var t=l(e)?e:k(e),n=f(arguments,1);return _[++I]=function(){c(t,void 0,n);},o(I),I;},T=function T(e){delete _[e];},v?o=function o(e){S.nextTick(P(e));}:M&&M.now?o=function o(e){M.now(P(e));}:x&&!y?(s=(i=new x()).port2,i.port1.onmessage=A,o=u(s.postMessage,s)):a.addEventListener&&l(a.postMessage)&&!a.importScripts&&r&&"file:"!==r.protocol&&!p(O)?(o=O,a.addEventListener("message",A,!1)):o="onreadystatechange"in g("script")?function(e){d.appendChild(g("script")).onreadystatechange=function(){d.removeChild(this),w(e);};}:function(e){setTimeout(P(e),0);}),e.exports={set:b,clear:T};},function(e,t){var n=TypeError;e.exports=function(e,t){if(e<t)throw n("Not enough arguments");return e;};},function(e,t,n){var r=n(50);e.exports=/(?:ipad|iphone|ipod).*applewebkit/i.test(r);},function(e,t){e.exports="object"==(typeof Deno==="undefined"?"undefined":_typeof(Deno))&&Deno&&"object"==_typeof(Deno.version);},function(e,t,n){var r=n(87),o=n(230),i=n(101).CONSTRUCTOR;e.exports=i||!o(function(e){r.all(e).then(void 0,function(){});});},function(e,t,n){var r=n(18)("iterator"),o=!1;try{var i=0,s={next:function next(){return{done:!!i++};},return:function _return(){o=!0;}};s[r]=function(){return this;},Array.from(s,function(){throw 2;});}catch(e){}e.exports=function(e,t){if(!t&&!o)return!1;var n=!1;try{var i={};i[r]=function(){return{next:function next(){return{done:n=!0};}};},e(i);}catch(e){}return n;};},function(e,t,n){var r=n(33),o=n(29),i=n(53);e.exports=function(e,t){if(r(e),o(t)&&t.constructor===e)return t;var n=i.f(e);return(0,n.resolve)(t),n.promise;};},function(e,t,n){"use strict";var r=n(1),o=n(25),i=n(36),s=n(53),a=n(86),c=n(99);r({target:"Promise",stat:!0},{allSettled:function allSettled(e){var t=this,n=s.f(t),r=n.resolve,u=n.reject,l=a(function(){var n=i(t.resolve),s=[],a=0,u=1;c(e,function(e){var i=a++,c=!1;u++,o(n,t,e).then(function(e){c||(c=!0,s[i]={status:"fulfilled",value:e},--u||r(s));},function(e){c||(c=!0,s[i]={status:"rejected",reason:e},--u||r(s));});}),--u||r(s);});return l.error&&u(l.value),n.promise;}});},function(e,t,n){"use strict";var r=n(1),o=n(25),i=n(36),s=n(31),a=n(53),c=n(86),u=n(99);r({target:"Promise",stat:!0},{any:function any(e){var t=this,n=s("AggregateError"),r=a.f(t),l=r.resolve,m=r.reject,p=c(function(){var r=i(t.resolve),s=[],a=0,c=1,p=!1;u(e,function(e){var i=a++,u=!1;c++,o(r,t,e).then(function(e){u||p||(p=!0,l(e));},function(e){u||p||(u=!0,s[i]=e,--c||m(new n(s,"No one promise resolved")));});}),--c||m(new n(s,"No one promise resolved"));});return p.error&&m(p.value),r.promise;}});},function(e,t,n){var r=n(391);e.exports=r;},function(e,t,n){var r=n(22).default,o=n(393);e.exports=function(e){var t=o(e,"string");return"symbol"===r(t)?t:String(t);},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(401);e.exports=r;},function(e,t,n){var r=n(404);e.exports=r;},function(e,t,n){"use strict";var r=n(78),o=TypeError;e.exports=function(e,t){if(!delete e[t])throw o("Cannot delete property "+r(t)+" of "+r(e));};},function(e,t,n){n(438),n(440);},function(e,t,n){"use strict";var r,o=n(12),i=n(64),s=n(20),a=n(439),c=n(50),u=n(98),l=n(226),m=o.Function,p=/MSIE .\./.test(c)||a&&((r=o.Bun.version.split(".")).length<3||0==r[0]&&(r[1]<3||3==r[1]&&0==r[2]));e.exports=function(e,t){var n=t?2:1;return p?function(r,o){var a=l(arguments.length,1)>n,c=s(r)?r:m(r),p=a?u(arguments,n):[],d=a?function(){i(c,this,p);}:c;return t?e(d,o):e(d);}:e;};},function(e,t,n){var r=n(458);e.exports=r;},function(e,t){e.exports=function e(t,n){"use strict";var r,o,i=/(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,s=/(^[ ]*|[ ]*$)/g,a=/(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,c=/^0x[0-9a-f]+$/i,u=/^0/,l=function l(t){return e.insensitive&&(""+t).toLowerCase()||""+t;},m=l(t).replace(s,"")||"",p=l(n).replace(s,"")||"",d=m.replace(i,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),f=p.replace(i,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),g=parseInt(m.match(c),16)||1!==d.length&&m.match(a)&&Date.parse(m),h=parseInt(p.match(c),16)||g&&p.match(a)&&Date.parse(p)||null;if(h){if(g<h)return-1;if(g>h)return 1;}for(var y=0,v=Math.max(d.length,f.length);y<v;y++){if(r=!(d[y]||"").match(u)&&parseFloat(d[y])||d[y]||0,o=!(f[y]||"").match(u)&&parseFloat(f[y])||f[y]||0,isNaN(r)!==isNaN(o))return isNaN(r)?1:-1;if((typeof r==="undefined"?"undefined":_typeof(r))!=(typeof o==="undefined"?"undefined":_typeof(o))&&(r+="",o+=""),r<o)return-1;if(r>o)return 1;}return 0;};},function(e,t){e.exports=function(e,t){return e===t||e!=e&&t!=t;};},function(e,t,n){var r=n(131),o=n(104);e.exports=function(e){if(!o(e))return!1;var t=r(e);return"[object Function]"==t||"[object GeneratorFunction]"==t||"[object AsyncFunction]"==t||"[object Proxy]"==t;};},function(e,t,n){(function(t){var n="object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t&&t.Object===Object&&t;e.exports=n;}).call(this,n(49));},function(e,t){var n=Function.prototype.toString;e.exports=function(e){if(null!=e){try{return n.call(e);}catch(e){}try{return e+"";}catch(e){}}return"";};},function(e,t,n){var r=n(248),o=n(243),i=Object.prototype.hasOwnProperty;e.exports=function(e,t,n){var s=e[t];i.call(e,t)&&o(s,n)&&(void 0!==n||t in e)||r(e,t,n);};},function(e,t,n){var r=n(502);e.exports=function(e,t,n){"__proto__"==t&&r?r(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n;};},function(e,t,n){var r=n(504),o=n(505),i=n(162),s=n(250),a=n(508),c=n(509),u=Object.prototype.hasOwnProperty;e.exports=function(e,t){var n=i(e),l=!n&&o(e),m=!n&&!l&&s(e),p=!n&&!l&&!m&&c(e),d=n||l||m||p,f=d?r(e.length,String):[],g=f.length;for(var h in e){!t&&!u.call(e,h)||d&&("length"==h||m&&("offset"==h||"parent"==h)||p&&("buffer"==h||"byteLength"==h||"byteOffset"==h)||a(h,g))||f.push(h);}return f;};},function(e,t,n){(function(e){var r=n(45),o=n(507),i=t&&!t.nodeType&&t,s=i&&"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e&&!e.nodeType&&e,a=s&&s.exports===i?r.Buffer:void 0,c=(a?a.isBuffer:void 0)||o;e.exports=c;}).call(this,n(135)(e));},function(e,t){e.exports=function(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=9007199254740991;};},function(e,t){e.exports=function(e,t){return function(n){return e(t(n));};};},function(e,t,n){var r=n(244),o=n(251);e.exports=function(e){return null!=e&&o(e.length)&&!r(e);};},function(e,t){e.exports=function(){return[];};},function(e,t,n){var r=n(256),o=n(257),i=n(167),s=n(254),a=Object.getOwnPropertySymbols?function(e){for(var t=[];e;){r(t,i(e)),e=o(e);}return t;}:s;e.exports=a;},function(e,t){e.exports=function(e,t){for(var n=-1,r=t.length,o=e.length;++n<r;){e[o+n]=t[n];}return e;};},function(e,t,n){var r=n(252)(Object.getPrototypeOf,Object);e.exports=r;},function(e,t,n){var r=n(256),o=n(162);e.exports=function(e,t,n){var i=t(e);return o(e)?i:r(i,n(e));};},function(e,t,n){var r=n(552);e.exports=r;},function(e,t,n){"use strict";var r=n(13),o=n(36),i=n(29),s=n(26),a=n(98),c=n(92),u=Function,l=r([].concat),m=r([].join),p={},d=function d(e,t,n){if(!s(p,t)){for(var r=[],o=0;o<t;o++){r[o]="a["+o+"]";}p[t]=u("C,a","return new C("+m(r,",")+")");}return p[t](e,n);};e.exports=c?u.bind:function(e){var t=o(this),n=t.prototype,r=a(arguments,1),s=function s(){var n=l(r,a(arguments));return this instanceof s?d(t,n.length,n):t.apply(e,n);};return i(n)&&(s.prototype=n),s;};},function(e,t,n){var r=n(71),o=n(4),i=n(88),s=n(143),a=n(10),c=n(47),u=c.getGlobal(),l={},m=u.name||"_parent",p=[],d=[];l.addMsgListener=function(e){p.push(e);};var f,g,h,y,v=(f=/^([\w]+?:\/\/.*?(?=\/|$))/i,function(e){return e=e||"",f.test(e)?RegExp.$1:"*";}),b=function b(){var e,t,n=r(e=unescape(u.name||"")).call(e);if(n&&0===o(n).call(n,"MSG|")){u.name="";var i=c.string2object(n.replace("MSG|",""),"|"),s=(i.origin||"").toLowerCase();s&&"*"!==s&&0!==o(t=location.href.toLowerCase()).call(t,s)||function(e){for(var t=0,n=p.length;t<n;t++){try{p[t].call(null,e);}catch(e){}}}({data:JSON.parse(i.data||"null"),source:u.frames[i.self]||i.self,origin:v(i.ref||("undefined"==typeof document?"":document.referrer))});}},T=(h=function h(e,t){for(var n=0,r=e.length;n<r;n++){if(e[n]===t)return!0;}return!1;},function(){if(d.length){g=[];for(var e,t=d.length-1;t>=0;t--){e=d[t],h(g,e.w)||(g.push(e.w),i(d).call(d,t,1),e.w.name=e.d);}g=null;}}),S=l.startTimer=(y=!1,function(){y||(y=!0,u.postMessage||(s(T,100),s(b,20)));});l.postMessage=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(c.fillUndef(t,{origin:"*",source:m}),u.postMessage){var n=t.data;u.FormData||(n=a(n)),e.postMessage(n,t.origin);}else{if(S(),c.isObject(t)){var r={};r.origin=t.origin||"",r.ref=location.href,r.self=t.source,r.data=a(t.data),t="MSG|"+c.object2string(r,"|",!0);}d.unshift({w:e,d:escape(t)});}},e.exports=l;},function(e,t,n){var r=n(572);e.exports=r;},function(e,t,n){e.exports=n(579);},function(e,t,n){var r=n(0),o={file:{md5:"$(Etag)",size:"$(ObjectSize)"},image:{md5:"$(Etag)",size:"$(ObjectSize)",w:"$(ImageInfo.Width)",h:"$(ImageInfo.Height)",orientation:"$(ImageInfo.Orientation)"},audio:{md5:"$(Etag)",size:"$(ObjectSize)",dur:"$(AVinfo.Audio.Duration)"},video:{md5:"$(Etag)",size:"$(ObjectSize)",dur:"$(AVinfo.Video.Duration)",w:"$(AVinfo.Video.Width)",h:"$(AVinfo.Video.Height)"}},i={genResponseBody:function genResponseBody(e){return o[e=e||"file"];},parseResponse:function parseResponse(e,t){r.notundef(e.size)&&(e.size=+e.size),r.notundef(e.w)&&(e.w=+e.w),r.notundef(e.h)&&(e.h=+e.h),r.notundef(e.dur)&&(e.dur=+e.dur);var n=e.orientation;if(r.notundef(n)&&(delete e.orientation,t&&("right, top"===n||"left, bottom"===n))){var o=e.w;e.w=e.h,e.h=o;}return e;}};e.exports=i;},function(e,t,n){var r=n(109),o=n(16),i=n(4),s=n(54),a=n(27),c=["Code","code","Message","message"],u=n(14),l=n(0),m=n(39),p=n(591),d=n(592),f=n(90),g=f.EMResourceUploadWay,h=f.EMExceptionState,y=n(171).abort,v=l.supportFormData;function b(e,t){var n=this,r=e.uploadprogress,o=e.uploaddone,i=e.beginupload;return{beginupload:"function"==typeof i?function(e){try{i(e,t);}catch(e){n.logger.error("Upload::options.beginupload execute error",e);}}:function(){},uploadprogress:"function"==typeof r?function(e){n.reporterHook.emit("reporter/uploadUpdate",{transferred_size:e.loaded});try{r(e,t);}catch(e){n.logger.error("Upload::options.uploadprogress execute error",e);}}:function(e){n.reporterHook.emit("reporter/uploadUpdate",{transferred_size:e.loaded});},uploaddone:function uploaddone(e,r){e?n.reporterHook.emit("reporter/uploadEnd","RequestAbortedError"===e.code||"abort"===e.code?h.kCanceled:h.kFailed):n.reporterHook.emit("reporter/uploadEnd",h.kSucceed);try{o(e,r,null,t);}catch(e){n.logger.error("Upload::options.uploaddone execute error",e);}}};}function T(e,t,n){var r=this;r.options=l.copy(e),e=r.options,l.verifyOptions(e,"url fileName"),l.verifyParamPresentJustOne(e,"blob fileInput"),l.verifyCallback(e,"beginupload uploadprogress uploaddone"),r.reporterHook=t.reporterHook,r.logger=t.logger,r.message=n;var a=b.call(this,e,n),c=a.beginupload,f=a.uploadprogress,h=a.uploaddone;r.options.beginupload=c,r.options.uploadprogress=f,r.options.uploaddone=h,e.fileInput&&(e.fileInput=l.verifyFileInput(e.fileInput)),e.type&&l.verifyFileType(e.type),e.timeout?l.verifyParamType("timeout",e.timeout,"number"):e.timeout=6e5,l.verifyFileUploadCallback(e),e.data={},e.params&&l.merge(e.data,e.params);var y,T,S=e.fileName,M=e.fileInput;if(v){if(M){if(!(T=e.type?l.filterFiles(M.files,e.type):o([]).call(M.files,0))||!T.length)return void e.uploaddone(m.newWrongFileTypeError("未读取到"+e.type+"类型的文件, 请确保文件选择节点的文件不为空, 并且请确保选择了"+e.type+"类型的文件"));e.data[S]=T[0],y=M.files[0].size;}else if(e.blob){var k;if(e.data[S]=e.blob,"file"!==e.type&&e.blob.type&&-1===i(k=e.blob.type).call(k,e.type))return void e.uploaddone(m.newWrongFileTypeError("未读取到"+e.type+"类型的文件, 请确保选择了"+e.type+"类型的文件"));y=e.blob.size;}if(r.reporterHook.emit("reporter/uploadUpdate",{full_size:y}),e.maxSize&&y>e.maxSize)return void e.uploaddone(m.newFileTooLargeError("上传文件大小超过".concat(e.maxSize,"限制")));}function x(){if(r.logger.info("Upload:enter aws upload"),y){if(y>u.chunkMaxSize)e.uploaddone(m.newFileTooLargeError("直传文件大小超过".concat(u.commonMaxSize,"限制")));else if(e.s3Policy&&e.s3Policy.uploadConfig&&e.s3Policy.uploadConfig.retryPolicy){var t=e.s3Policy.uploadConfig.retryPolicy,n={accessKeyId:e.mixStoreToken.accessKeyId,secretAccessKey:e.mixStoreToken.secretAccessKey,sessionToken:e.mixStoreToken.sessionToken,region:e.mixStoreToken.region,maxRetries:t.retry},o=new(0,e.s3)();o.config.update(n);var a=r.reporterHook.getNTPTime();o.config.systemClockOffset=a-s();var c=decodeURIComponent(e.mixStoreToken.bucket),l=decodeURIComponent(e.mixStoreToken.objectName),p=e.data[S],d=o.upload({Bucket:c,Key:l,Body:p,Metadata:{token:e.mixStoreToken.token},ContentType:p.type||"application/octet-stream"});d.on("httpUploadProgress",function(t){var n=Math.floor(1e4*t.loaded/t.total)/100,r={docId:e.docId,total:t.total,loaded:t.loaded,percentage:n,percentageText:n+"%"};e.fileInput&&(r.fileInput=e.fileInput),e.blob&&(r.blob=e.blob),e.uploadprogress(r);}),d.send(function(n,o){if(e.docId&&(o.docId=e.docId),n&&"RequestAbortedError"===n.code)r.logger.error("uploadFile:","api::s3:upload file abort",n),r.onError(n);else if(n){var s;e.logger.error("error:","api::s3:upload file failed",n);var a=e.providers[(i(s=e.providers).call(s,e.curProvider)+1)%e.providers.length];t.retryNext&&a?(r.addCircuitTimer(e,a),1===a&&e.getMixStoreToken(1,function(t){e.mixStoreToken=t,C();})):r.onError(o),e.errorHook(n);}else{var c=r.options.s3Policy.cdnSchema;c=(c=c.replace("{cdnDomain}",r.options.s3Policy.dlcdn)).replace("{objectName}",o.Key),e.uploaddone(null,{size:p.size,name:p.name,url:c,ext:p.name.split(".")[1]||"unknown",_url_safe:e.mixStoreToken.shortUrl,isS3:!0}),e.logger.info("s3 Upload done: fileObj is",{size:p.size,name:p.name,url:c,ext:p.name.split(".")[1]||"unknown",_url_safe:e.mixStoreToken.shortUrl,isS3:!0});}}),"function"==typeof e.beginupload&&e.beginupload(d);}}else e.uploaddone(m.newFileTooLargeError("Browser version is too low"));}function C(){if(r.logger.info("Upload:enter nos upload"),y&&!e.commonUpload)return r.logger.info("Upload:use chunk upload, url ".concat(e.url)),y>u.chunkMaxSize?void e.uploaddone(m.newFileTooLargeError("直传文件大小超过".concat(u.chunkMaxSize,"限制"))):void(r.sn=d(e,S,r,-1));if(r.logger.info("Upload:use common upload, url ".concat(e.url)),y&&y>u.commonMaxSize)e.uploaddone(m.newFileTooLargeError("普通上传文件大小超过".concat(u.commonMaxSize,"限制")));else{y||(l.dataset(M,"name",S),e.data.input=M);var t={data:e.data,onaftersend:function onaftersend(){e.beginupload(r,r.message);},onuploading:function onuploading(t){var n=Math.floor(1e4*t.loaded/t.total)/100,r={docId:e.docId,total:t.total,loaded:t.loaded,percentage:n,percentageText:n+"%"};e.fileInput&&(r.fileInput=e.fileInput),e.blob&&(r.blob=e.blob),e.uploadprogress(r);},onload:function onload(t){var n;if(e.docId&&(t.docId=e.docId),!t.Error)return e.uploaddone(null,t),void e.logger.info("nos Upload done: fileObj is",t);if(e.mixEnable&&1===e.curProvider){var o=e.nosPolicy.uploadConfig.retryPolicy,s=e.providers[(i(n=e.providers).call(n,e.curProvider)+1)%e.providers.length];o.retryNext&&s?(r.addCircuitTimer(e,s),2===s&&e.getMixStoreToken(2,function(t){e.mixStoreToken=t,x();})):r.onError(t);}else r.onError(t);},onerror:function onerror(t){var n;if(e.mixEnable&&1===e.curProvider){var o,s=e.nosPolicy.uploadConfig.retryPolicy,a=e.providers[(i(o=e.providers).call(o,e.curProvider)+1)%e.providers.length];if(s.retryNext&&a)r.addCircuitTimer(e,a),2===a&&e.getMixStoreToken(2,function(t){e.mixStoreToken=t,x();});else try{n=t.result?JSON.parse(t.result):t,r.onError(n);}catch(n){e.uploaddone(new m(t.message,t.code),r.options);}}else try{n=t.result?JSON.parse(t.result):t,r.onError(n);}catch(n){e.uploaddone(new m(t.message,t.code),r.options);}e.errorHook(t);}};v||(t.mode="iframe"),t.putFileAtEnd=!0,r.sn=p(e.url,t);}}if(e.mixEnable&&2===e.curProvider){var I=r.options.s3Policy.cdnSchema;I=I.replace("{cdnDomain}",r.options.s3Policy.dlcdn),r.reporterHook.emit("reporter/uploadUpdate",{remote_addr:I,operation_type:g.kResourceUploadWayAWSPlugin}),x();}else e.mixEnable&&1===e.curProvider?(r.reporterHook.emit("reporter/uploadUpdate",{remote_addr:e.url,operation_type:g.kResourceUploadWayNOSPlugin}),C()):(r.reporterHook.emit("reporter/uploadUpdate",{remote_addr:e.url,operation_type:g.kResourceUploadWayNOS}),C());}T.prototype.addCircuitTimer=function(e,t){var n=this;if(e.curProvider=t,e.s3Policy&&e.nosPolicy){var r=e[1===e.curProvider?"nosPolicy":"s3Policy"].uploadConfig.retryPolicy.circuit;if(!r||0===r)return;n.circuitTimer&&clearTimeout(n.circuitTimer),n.circuitTimer=a(function(){e.curProvider=e.providers[0],n.circuitTimer=void 0;},1e3*r);}},T.prototype.onError=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this,n=t.options,o=e.Error||e||{},i=o.Code,s=o.code,a=o.Message,u=o.message,l=r(o,c),p=i||s||"unknown",d=a||u||"未知错误";n.uploaddone(new m(p+"("+d+")",p,l));},T.prototype.abort=function(){y(this.sn);},e.exports=T;},function(e,t,n){e.exports=n(598);},function(e,t,n){e.exports=n(614);},function(e,t,n){var r=n(617);e.exports=r;},function(e,t,n){var r=n(4),o=n(0),i={fromDataURL:function fromDataURL(e){var t,n,i=o.getGlobal();n=r(t=e.split(",")[0]).call(t,"base64")>=0?i.atob(e.split(",")[1]):i.decodeURIComponent(e.split(",")[1]);for(var s=e.split(",")[0].split(":")[1].split(";")[0],a=new Uint8Array(n.length),c=0;c<n.length;c++){a[c]=n.charCodeAt(c);}return new i.Blob([a],{type:s});}};e.exports=i;},function(e,t,n){var r=n(5),o=n(7),i=n(6),s=n(0),a={stripmeta:0,blur:2,quality:3,crop:4,rotate:5,thumbnail:7,interlace:9},c={0:"stripmeta",1:"type",2:"blur",3:"quality",4:"crop",5:"rotate",6:"pixel",7:"thumbnail",8:"watermark",9:"interlace",10:"tmp"};function u(e){s.verifyOptions(e,"type","image::ImageOp"),s.verifyParamValid("type",e.type,u.validTypes,"image::ImageOp"),s.merge(this,e),this.type=a[e.type];}u.validTypes=r(a),u.reverse=function(e){var t=s.copy(e);return t.type=c[t.type],t;},u.reverseImageOps=function(e){return o(e).call(e,function(e){return i(u).call(u,e);});},e.exports=u;},function(e,t,n){var r=n(2),o=n(5),i={1:"ROOM_CLOSE",2:"ROOM_JOIN",3:"INVITE",4:"CANCEL_INVITE",5:"REJECT",6:"ACCEPT",7:"LEAVE",8:"CONTROL"},s={1:"accid",2:"uid",3:"createTime",4:"expireTime",5:"web_uid"},a={10404:"ROOM_NOT_EXISTS",10405:"ROOM_HAS_EXISTS",10406:"ROOM_MEMBER_NOT_EXISTS",10407:"ROOM_MEMBER_HAS_EXISTS",10408:"INVITE_NOT_EXISTS",10409:"INVITE_HAS_REJECT",10410:"INVITE_HAS_ACCEPT",10201:"PEER_NIM_OFFLINE",10202:"PEER_PUSH_OFFLINE",10419:"ROOM_MEMBER_EXCEED",10420:"ROOM_MEMBER_HAS_EXISTS_OTHER_CLIENT",10417:"UID_CONFLICT"};e.exports={parseAvSignalType:function parseAvSignalType(e){return i[e]||e;},parseAvSignalMember:function parseAvSignalMember(e){var t,n={};return r(t=o(e)).call(t,function(t){n[s[t]]=e[t];}),n;},parseAvSignalError:function parseAvSignalError(e){return e.message=a[e.code]||e.message||e,e;}};},function(module,exports,__webpack_require__){(function(global,module){var __WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;/*! Socket.IO.js build:0.9.11, development. Copyright(c) 2011 LearnBoost <dev@learnboost.com> MIT Licensed */function getGlobal(){return"undefined"!=typeof window?window:"undefined"!=typeof self?self:void 0!==global?global:{};}var root=getGlobal(),io=module.exports;void 0===root.location&&(root.location=null),root.io?module&&(module.exports=io=root.io):root.io=io,function(){!function(e,t){var n=e;n.version="0.9.11",n.protocol=1,n.transports=[],n.j=[],n.sockets={},n.connect=function(e,r){var o,i,s=n.util.parseUri(e);t&&t.location&&(s.protocol=s.protocol||t.location.protocol.slice(0,-1),s.host=s.host||(t.document?t.document.domain:t.location.hostname),s.port=s.port||t.location.port),o=n.util.uniqueUri(s);var a={host:s.ipv6uri?"["+s.host+"]":s.host,secure:"https"===s.protocol,port:s.port||("https"===s.protocol?443:80),query:s.query||""};return n.util.merge(a,r),!a["force new connection"]&&n.sockets[o]||(i=new n.Socket(a)),!a["force new connection"]&&i&&(n.sockets[o]=i),(i=i||n.sockets[o]).of(s.path.length>1?s.path:"");};}(module.exports,root),function(e,t){var n=e.util={},r=/^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,o=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];n.parseUri=function(e){var t=e,n=e.indexOf("["),i=e.indexOf("]");-1!=n&&-1!=i&&(e=e.substring(0,n)+e.substring(n,i).replace(/:/g,";")+e.substring(i,e.length));for(var s=r.exec(e||""),a={},c=14;c--;){a[o[c]]=s[c]||"";}return-1!=n&&-1!=i&&(a.source=t,a.host=a.host.substring(1,a.host.length-1).replace(/;/g,":"),a.authority=a.authority.replace("[","").replace("]","").replace(/;/g,":"),a.ipv6uri=!0),a;},n.uniqueUri=function(e){var n=e.protocol,r=e.host,o=e.port;return"document"in t&&t.document?(r=r||document.domain,o=o||("https"==n&&"https:"!==document.location.protocol?443:document.location.port)):(r=r||"localhost",o||"https"!=n||(o=443)),(n||"http")+"://"+r+":"+(o||80);},n.query=function(e,t){var r=n.chunkQuery(e||""),o=[];for(var i in n.merge(r,n.chunkQuery(t||"")),r){r.hasOwnProperty(i)&&o.push(i+"="+r[i]);}return o.length?"?"+o.join("&"):"";},n.chunkQuery=function(e){for(var t,n={},r=e.split("&"),o=0,i=r.length;o<i;++o){(t=r[o].split("="))[0]&&(n[t[0]]=t[1]);}return n;};var i=!1;n.load=function(e){if("undefined"!=typeof document&&document&&"complete"===document.readyState||i)return e();n.on(t,"load",e,!1);},n.on=function(e,t,n,r){e.attachEvent?e.attachEvent("on"+t,n):e.addEventListener&&e.addEventListener(t,n,r);},n.request=function(e){if(e&&"undefined"!=typeof XDomainRequest&&!n.ua.hasCORS)return new XDomainRequest();if("undefined"!=typeof XMLHttpRequest&&(!e||n.ua.hasCORS))return new XMLHttpRequest();if(!e)try{return new root[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");}catch(e){}return null;},void 0!==root&&n.load(function(){i=!0;}),n.defer=function(e){if(!n.ua.webkit||"undefined"!=typeof importScripts)return e();n.load(function(){setTimeout(e,100);});},n.merge=function(e,t,r,o){var i,s=o||[],a=void 0===r?2:r;for(i in t){t.hasOwnProperty(i)&&n.indexOf(s,i)<0&&("object"==_typeof(e[i])&&a?n.merge(e[i],t[i],a-1,s):(e[i]=t[i],s.push(t[i])));}return e;},n.mixin=function(e,t){n.merge(e.prototype,t.prototype);},n.inherit=function(e,t){function n(){}n.prototype=t.prototype,e.prototype=new n();},n.isArray=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e);},n.intersect=function(e,t){for(var r=[],o=e.length>t.length?e:t,i=e.length>t.length?t:e,s=0,a=i.length;s<a;s++){~n.indexOf(o,i[s])&&r.push(i[s]);}return r;},n.indexOf=function(e,t,n){var r=e.length;for(n=n<0?n+r<0?0:n+r:n||0;n<r&&e[n]!==t;n++){}return r<=n?-1:n;},n.toArray=function(e){for(var t=[],n=0,r=e.length;n<r;n++){t.push(e[n]);}return t;},n.ua={},n.ua.hasCORS="undefined"!=typeof XMLHttpRequest&&function(){try{var e=new XMLHttpRequest();}catch(e){return!1;}return null!=e.withCredentials;}(),n.ua.webkit="undefined"!=typeof navigator&&/webkit/i.test(navigator.userAgent),n.ua.iDevice="undefined"!=typeof navigator&&/iPad|iPhone|iPod/i.test(navigator.userAgent);}(void 0!==io?io:module.exports,root),function(e,t){function n(){}e.EventEmitter=n,n.prototype.on=function(e,n){return this.$events||(this.$events={}),this.$events[e]?t.util.isArray(this.$events[e])?this.$events[e].push(n):this.$events[e]=[this.$events[e],n]:this.$events[e]=n,this;},n.prototype.addListener=n.prototype.on,n.prototype.once=function(e,t){var n=this;function r(){n.removeListener(e,r),t.apply(this,arguments);}return r.listener=t,this.on(e,r),this;},n.prototype.removeListener=function(e,n){if(this.$events&&this.$events[e]){var r=this.$events[e];if(t.util.isArray(r)){for(var o=-1,i=0,s=r.length;i<s;i++){if(r[i]===n||r[i].listener&&r[i].listener===n){o=i;break;}}if(o<0)return this;r.splice(o,1),r.length||delete this.$events[e];}else(r===n||r.listener&&r.listener===n)&&delete this.$events[e];}return this;},n.prototype.removeAllListeners=function(e){return void 0===e?(this.$events={},this):(this.$events&&this.$events[e]&&(this.$events[e]=null),this);},n.prototype.listeners=function(e){return this.$events||(this.$events={}),this.$events[e]||(this.$events[e]=[]),t.util.isArray(this.$events[e])||(this.$events[e]=[this.$events[e]]),this.$events[e];},n.prototype.emit=function(e){if(!this.$events)return!1;var n=this.$events[e];if(!n)return!1;var r=Array.prototype.slice.call(arguments,1);if("function"==typeof n)n.apply(this,r);else{if(!t.util.isArray(n))return!1;for(var o=n.slice(),i=0,s=o.length;i<s;i++){o[i].apply(this,r);}}return!0;};}(void 0!==io?io:module.exports,void 0!==io?io:module.parent.exports),function(exports,nativeJSON){"use strict";if(nativeJSON&&nativeJSON.parse)return exports.JSON={parse:nativeJSON.parse,stringify:nativeJSON.stringify};var JSON=exports.JSON={};function f(e){return e<10?"0"+e:e;}function date(e,t){return isFinite(e.valueOf())?e.getUTCFullYear()+"-"+f(e.getUTCMonth()+1)+"-"+f(e.getUTCDate())+"T"+f(e.getUTCHours())+":"+f(e.getUTCMinutes())+":"+f(e.getUTCSeconds())+"Z":null;}var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;function quote(e){return escapable.lastIndex=0,escapable.test(e)?'"'+e.replace(escapable,function(e){var t=meta[e];return"string"==typeof t?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4);})+'"':'"'+e+'"';}function str(e,t){var n,r,o,i,s,a=gap,c=t[e];switch(c instanceof Date&&(c=date(e)),"function"==typeof rep&&(c=rep.call(t,e,c)),typeof c==="undefined"?"undefined":_typeof(c)){case"string":return quote(c);case"number":return isFinite(c)?String(c):"null";case"boolean":case"null":return String(c);case"object":if(!c)return"null";if(gap+=indent,s=[],"[object Array]"===Object.prototype.toString.apply(c)){for(i=c.length,n=0;n<i;n+=1){s[n]=str(n,c)||"null";}return o=0===s.length?"[]":gap?"[\n"+gap+s.join(",\n"+gap)+"\n"+a+"]":"["+s.join(",")+"]",gap=a,o;}if(rep&&"object"==(typeof rep==="undefined"?"undefined":_typeof(rep)))for(i=rep.length,n=0;n<i;n+=1){"string"==typeof rep[n]&&(o=str(r=rep[n],c))&&s.push(quote(r)+(gap?": ":":")+o);}else for(r in c){Object.prototype.hasOwnProperty.call(c,r)&&(o=str(r,c))&&s.push(quote(r)+(gap?": ":":")+o);}return o=0===s.length?"{}":gap?"{\n"+gap+s.join(",\n"+gap)+"\n"+a+"}":"{"+s.join(",")+"}",gap=a,o;}}JSON.stringify=function(e,t,n){var r;if(gap="",indent="","number"==typeof n)for(r=0;r<n;r+=1){indent+=" ";}else"string"==typeof n&&(indent=n);if(rep=t,t&&"function"!=typeof t&&("object"!=(typeof t==="undefined"?"undefined":_typeof(t))||"number"!=typeof t.length))throw new Error("socket.io:: replacer cannot JSON.stringify");return str("",{"":e});},JSON.parse=function(text,reviver){var j;function walk(e,t){var n,r,o=e[t];if(o&&"object"==(typeof o==="undefined"?"undefined":_typeof(o)))for(n in o){Object.prototype.hasOwnProperty.call(o,n)&&(void 0!==(r=walk(o,n))?o[n]=r:delete o[n]);}return reviver.call(e,t,o);}if(text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(e){return"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4);})),/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),"function"==typeof reviver?walk({"":j},""):j;throw new SyntaxError("socket.io:: reviver cannot JSON.parse");};}(void 0!==io?io:module.exports,"undefined"!=typeof JSON?JSON:void 0),function(e,t){var n=e.parser={},r=n.packets=["disconnect","connect","heartbeat","message","json","event","ack","error","noop"],o=n.reasons=["transport not supported","client not handshaken","unauthorized"],i=n.advice=["reconnect"],s=t.JSON,a=t.util.indexOf;n.encodePacket=function(e){var t=a(r,e.type),n=e.id||"",c=e.endpoint||"",u=e.ack,l=null;switch(e.type){case"error":var m=e.reason?a(o,e.reason):"",p=e.advice?a(i,e.advice):"";""===m&&""===p||(l=m+(""!==p?"+"+p:""));break;case"message":""!==e.data&&(l=e.data);break;case"event":var d={name:e.name};e.args&&e.args.length&&(d.args=e.args),l=s.stringify(d);break;case"json":l=s.stringify(e.data);break;case"connect":e.qs&&(l=e.qs);break;case"ack":l=e.ackId+(e.args&&e.args.length?"+"+s.stringify(e.args):"");}var f=[t,n+("data"==u?"+":""),c];return null!=l&&f.push(l),f.join(":");},n.encodePayload=function(e){var t="";if(1==e.length)return e[0];for(var n=0,r=e.length;n<r;n++){t+="�"+e[n].length+"�"+e[n];}return t;};var c=/([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;n.decodePacket=function(e){if(!(a=e.match(c)))return{};var t=a[2]||"",n=(e=a[5]||"",{type:r[a[1]],endpoint:a[4]||""});switch(t&&(n.id=t,a[3]?n.ack="data":n.ack=!0),n.type){case"error":var a=e.split("+");n.reason=o[a[0]]||"",n.advice=i[a[1]]||"";break;case"message":n.data=e||"";break;case"event":try{var u=s.parse(e);n.name=u.name,n.args=u.args;}catch(e){}n.args=n.args||[];break;case"json":try{n.data=s.parse(e);}catch(e){}break;case"connect":n.qs=e||"";break;case"ack":if((a=e.match(/^([0-9]+)(\+)?(.*)/))&&(n.ackId=a[1],n.args=[],a[3]))try{n.args=a[3]?s.parse(a[3]):[];}catch(e){}}return n;},n.decodePayload=function(e){var t=function t(e,_t2){for(var n=0,r=e;r<_t2.length;r++){if("�"==_t2.charAt(r))return n;n++;}return n;};if("�"==e.charAt(0)){for(var r=[],o=1,i="";o<e.length;o++){if("�"==e.charAt(o)){var s=e.substr(o+1).substr(0,i);if("�"!=e.charAt(o+1+Number(i))&&o+1+Number(i)!=e.length){var a=Number(i);l=t(o+a+1,e),s=e.substr(o+1).substr(0,a+l),o+=l;}r.push(n.decodePacket(s)),o+=Number(i)+1,i="";}else i+=e.charAt(o);}return r;}return[n.decodePacket(e)];};}(void 0!==io?io:module.exports,void 0!==io?io:module.parent.exports),function(e,t){function n(e,t){this.socket=e,this.sessid=t;}e.Transport=n,t.util.mixin(n,t.EventEmitter),n.prototype.heartbeats=function(){return!0;},n.prototype.onData=function(e){if(this!==this.socket.transport)return this;if(this.clearCloseTimeout(),(this.socket.connected||this.socket.connecting||this.socket.reconnecting)&&this.setCloseTimeout(),""!==e){var n=t.parser.decodePayload(e);if(n&&n.length)for(var r=0,o=n.length;r<o;r++){this.onPacket(n[r]);}}return this;},n.prototype.onPacket=function(e){return this.socket.setHeartbeatTimeout(),"heartbeat"==e.type?this.onHeartbeat():("connect"==e.type&&""==e.endpoint&&this.onConnect(),"error"==e.type&&"reconnect"==e.advice&&(this.isOpen=!1),this.socket.onPacket(e),this);},n.prototype.setCloseTimeout=function(){if(!this.closeTimeout){var e=this;this.closeTimeout=setTimeout(function(){e.onDisconnect();},this.socket.closeTimeout);}},n.prototype.onDisconnect=function(){return this.isOpen&&this.close(),this.clearTimeouts(),this.socket?(this.socket.transport===this?this.socket.onDisconnect():this.socket.setBuffer(!1),this):this;},n.prototype.onConnect=function(){return this.socket.onConnect(),this;},n.prototype.clearCloseTimeout=function(){this.closeTimeout&&(clearTimeout(this.closeTimeout),this.closeTimeout=null);},n.prototype.clearTimeouts=function(){this.clearCloseTimeout(),this.reopenTimeout&&clearTimeout(this.reopenTimeout);},n.prototype.packet=function(e){this.send(t.parser.encodePacket(e));},n.prototype.onHeartbeat=function(e){this.packet({type:"heartbeat"});},n.prototype.onOpen=function(){this.isOpen=!0,this.clearCloseTimeout(),this.socket.onOpen();},n.prototype.onClose=function(){this.isOpen=!1,this.socket.transport===this?this.socket.onClose():this.socket.setBuffer(!1),this.onDisconnect(),this.onDisconnectDone instanceof Function&&this.onDisconnectDone(null),this.onConnectionOver instanceof Function&&this.onConnectionOver(null);},n.prototype.onDisconnectDone=function(){},n.prototype.onConnectionOver=function(){},n.prototype.prepareUrl=function(){var e=this.socket.options;return this.scheme()+"://"+e.host+":"+e.port+"/"+e.resource+"/"+t.protocol+"/"+this.name+"/"+this.sessid;},n.prototype.ready=function(e,t){t.call(this);};}(void 0!==io?io:module.exports,void 0!==io?io:module.parent.exports),function(e,t,n){function r(e){if(this.options={port:80,secure:!1,document:"document"in n&&document,resource:"socket.io",transports:e.transports||t.transports,"connect timeout":1e4,"try multiple transports":!0,reconnect:!0,"reconnection delay":500,"reconnection limit":1/0,"reopen delay":3e3,"max reconnection attempts":10,"sync disconnect on unload":!1,"auto connect":!0,"flash policy port":10843,manualFlush:!1},t.util.merge(this.options,e),this.connected=!1,this.open=!1,this.connecting=!1,this.reconnecting=!1,this.namespaces={},this.buffer=[],this.doBuffer=!1,this.options["sync disconnect on unload"]&&(!this.isXDomain()||t.util.ua.hasCORS)){var r=this;t.util.on(n,"beforeunload",function(){r.disconnectSync();},!1);}this.options["auto connect"]&&this.connect();}function o(){}e.Socket=r,t.util.mixin(r,t.EventEmitter),r.prototype.of=function(e){return this.namespaces[e]||(this.namespaces[e]=new t.SocketNamespace(this,e),""!==e&&this.namespaces[e].packet({type:"connect"})),this.namespaces[e];},r.prototype.publish=function(){var e;for(var t in this.emit.apply(this,arguments),this.namespaces){this.namespaces.hasOwnProperty(t)&&(e=this.of(t)).$emit.apply(e,arguments);}},r.prototype.handshake=function(e){var n=this,r=this.options;function i(t){t instanceof Error?(n.connecting=!1,n.publish("info","status:200, but got error:",t),n.onError(t.message)):e.apply(null,t.split(":"));}var s=["http"+(r.secure?"s":"")+":/",r.host+":"+r.port,r.resource,t.protocol,t.util.query(this.options.query,"t="+ +new Date())].join("/");if(this.isXDomain()&&!t.util.ua.hasCORS&&"undefined"!=typeof document&&document){var a=document.getElementsByTagName("script")[0],c=document.createElement("script");c.src=s+"&jsonp="+t.j.length,c.onreadystatechange=function(){"loaded"==this.readyState&&c.parentNode&&(c.parentNode.removeChild(c),n.connecting=!1,n.publish("info","xhr, jsonp:Server down or port not open"),!n.reconnecting&&n.onError("Server down or port not open"),n.publish("handshake_failed"));},a.parentNode.insertBefore(c,a),t.j.push(function(e){i(e),c.parentNode.removeChild(c);});}else{var u=t.util.request();u.open("GET",s,!0),u.timeout=8e3,this.isXDomain()&&(u.withCredentials=!0),u.onreadystatechange=function(){n.publish("info","xhr, readyState:"+u.readyState+" status:"+u.status),4==u.readyState&&(u.onreadystatechange=o,200==u.status?i(u.responseText):403==u.status?(n.connecting=!1,n.onError(u.responseText),n.publish("handshake_failed")):(n.connecting=!1,!n.reconnecting&&n.onError(u.responseText),n.publish("handshake_failed")));},u.ontimeout=function(e){n.publish("info","xhr, timeout status:408"),n.connecting=!1,!n.reconnecting&&n.onError(u.responseText),n.publish("handshake_failed");},u.send(null);}},r.prototype.connect=function(e){if(this.connecting)return this;var n=this;return n.connecting=!0,this.handshake(function(r,o,i,s){n.sessionid=r,n.closeTimeout=1e3*i,n.heartbeatTimeout=1e3*o,n.transports||(n.transports=n.origTransports=s?t.util.intersect(s.split(","),n.options.transports):n.options.transports),n.setHeartbeatTimeout(),n.once("connect",function(){n.publish("info","tcp, recv connect event"),clearTimeout(n.connectTimeoutTimer),n.connectTimeoutTimer=null,e&&"function"==typeof e&&e();}),n.doConnect();}),this;},r.prototype.doConnect=function(){var e=this;if(e.transport&&e.transport.clearTimeouts(),e.transport=e.getTransport(e.transports),!e.transport)return e.publish("connect_failed");e.transport.ready(e,function(){e.connecting=!0,e.publish("info","tcp, connecting, transport ready in "+e.transport.name),e.publish("connecting",e.transport.name),e.transport.open(),e.options["connect timeout"]&&(e.connectTimeoutTimer&&clearTimeout(e.connectTimeoutTimer),e.connectTimeoutTimer=setTimeout(e.tryNextTransport.bind(e),e.options["connect timeout"]));});},r.prototype.getTransport=function(e){for(var n,r=e||this.transports,o=0;n=r[o];o++){if(t.Transport[n]&&t.Transport[n].check(this)&&(!this.isXDomain()||t.Transport[n].xdomainCheck(this)))return new t.Transport[n](this,this.sessionid);}return null;},r.prototype.tryNextTransport=function(){if(!this.connected&&(this.connecting=!1,this.options["try multiple transports"])){for(var e=this.transports;e.length>0&&e.splice(0,1)[0]!=this.transport.name;){}e.length?this.doConnect():this.publish("connect_failed");}},r.prototype.setHeartbeatTimeout=function(){if(clearTimeout(this.heartbeatTimeoutTimer),!this.transport||this.transport.heartbeats()){var e=this;this.heartbeatTimeoutTimer=setTimeout(function(){e.transport&&e.transport.onClose();},this.heartbeatTimeout);}},r.prototype.packet=function(e){return this.connected&&!this.doBuffer?this.transport.packet(e):this.buffer.push(e),this;},r.prototype.setBuffer=function(e){this.doBuffer=e,!e&&this.connected&&this.buffer.length&&(this.options.manualFlush||this.flushBuffer());},r.prototype.flushBuffer=function(){this.transport.payload(this.buffer),this.buffer=[];},r.prototype.disconnect=function(){return(this.connected||this.connecting)&&(this.open&&this.of("").packet({type:"disconnect"}),this.onDisconnect("booted")),this;},r.prototype.disconnectSync=function(){var e=t.util.request(),n=["http"+(this.options.secure?"s":"")+":/",this.options.host+":"+this.options.port,this.options.resource,t.protocol,"",this.sessionid].join("/")+"/?disconnect=1";e.open("GET",n,!1),e.send(null),this.onDisconnect("booted");},r.prototype.isXDomain=function(){var e=n&&n.location||{},t=e.port||("https:"==e.protocol?443:80);return this.options.host!==e.hostname||this.options.port!=t;},r.prototype.onConnect=function(){this.connected||(this.connected=!0,this.connecting=!1,this.doBuffer||this.setBuffer(!1),this.emit("connect"));},r.prototype.onOpen=function(){this.publish("info","tcp, socket onOpen"),this.open=!0;},r.prototype.onClose=function(){this.publish("info","tcp, socket onClose"),this.open=!1,clearTimeout(this.heartbeatTimeoutTimer);},r.prototype.onPacket=function(e){this.of(e.endpoint).onPacket(e);},r.prototype.onError=function(e){e&&e.advice&&"reconnect"===e.advice&&(this.connected||this.connecting)&&(this.disconnect(),this.options.reconnect&&this.reconnect()),this.publish("error",e&&e.reason?e.reason:e);},r.prototype.onDisconnect=function(e){var t=this.connected,n=this.connecting;this.publish("info",e?"tcp, onDisconnect reson:"+e:"tcp, onDisconnect"),this.connected=!1,this.connecting=!1,this.open=!1,(t||n)&&(this.transport.close(),this.transport.clearTimeouts(),t&&(this.publish("disconnect",e),"booted"!=e&&this.options.reconnect&&!this.reconnecting&&this.reconnect()),n&&(this.connectTimeoutTimer&&clearTimeout(this.connectTimeoutTimer),this.tryNextTransport()));},r.prototype.reconnect=function(){this.reconnecting=!0,this.reconnectionAttempts=0,this.reconnectionDelay=this.options["reconnection delay"];var e=this,t=this.options["max reconnection attempts"],n=this.options["try multiple transports"],r=this.options["reconnection limit"];function o(){if(e.connected){for(var t in e.namespaces){e.namespaces.hasOwnProperty(t)&&""!==t&&e.namespaces[t].packet({type:"connect"});}e.publish("reconnect",e.transport.name,e.reconnectionAttempts);}clearTimeout(e.reconnectionTimer),e.removeListener("connect_failed",i),e.removeListener("connect",i),e.reconnecting=!1,delete e.reconnectionAttempts,delete e.reconnectionDelay,delete e.reconnectionTimer,delete e.redoTransports,e.options["try multiple transports"]=n;}function i(){if(e.reconnecting)return e.connected?o():e.connecting&&e.reconnecting?e.reconnectionTimer=setTimeout(i,1e3):void(e.reconnectionAttempts++>=t?e.redoTransports?(e.publish("reconnect_failed"),o()):(e.on("connect_failed",i),e.options["try multiple transports"]=!0,e.transports=e.origTransports,e.transport=e.getTransport(),e.redoTransports=!0,e.connect()):(e.reconnectionDelay<r&&(e.reconnectionDelay*=2),e.connect(),e.publish("reconnecting",e.reconnectionDelay,e.reconnectionAttempts),e.reconnectionTimer=setTimeout(i,e.reconnectionDelay)));}this.options["try multiple transports"]=!1,this.reconnectionTimer=setTimeout(i,this.reconnectionDelay),this.on("connect",i);};}(void 0!==io?io:module.exports,void 0!==io?io:module.parent.exports,root),function(e,t){function n(e,t){this.socket=e,this.name=t||"",this.flags={},this.json=new r(this,"json"),this.ackPackets=0,this.acks={};}function r(e,t){this.namespace=e,this.name=t;}e.SocketNamespace=n,t.util.mixin(n,t.EventEmitter),n.prototype.$emit=t.EventEmitter.prototype.emit,n.prototype.of=function(){return this.socket.of.apply(this.socket,arguments);},n.prototype.packet=function(e){return e.endpoint=this.name,this.socket.packet(e),this.flags={},this;},n.prototype.send=function(e,t){var n={type:this.flags.json?"json":"message",data:e};return"function"==typeof t&&(n.id=++this.ackPackets,n.ack=!0,this.acks[n.id]=t),this.packet(n);},n.prototype.emit=function(e){var t=Array.prototype.slice.call(arguments,1),n=t[t.length-1],r={type:"event",name:e};return"function"==typeof n&&(r.id=++this.ackPackets,r.ack="data",this.acks[r.id]=n,t=t.slice(0,t.length-1)),r.args=t,this.packet(r);},n.prototype.disconnect=function(){return""===this.name?this.socket.disconnect():(this.packet({type:"disconnect"}),this.$emit("disconnect")),this;},n.prototype.onPacket=function(e){var n=this;function r(){n.packet({type:"ack",args:t.util.toArray(arguments),ackId:e.id});}switch(e.type){case"connect":this.$emit("connect");break;case"disconnect":""===this.name?this.socket.onDisconnect(e.reason||"booted"):this.$emit("disconnect",e.reason);break;case"message":case"json":var o=["message",e.data];"data"==e.ack?o.push(r):e.ack&&this.packet({type:"ack",ackId:e.id}),this.$emit.apply(this,o);break;case"event":o=[e.name].concat(e.args);"data"==e.ack&&o.push(r),this.$emit.apply(this,o);break;case"ack":this.acks[e.ackId]&&(this.acks[e.ackId].apply(this,e.args),delete this.acks[e.ackId]);break;case"error":this.socket.publish("info","Packet, type:error",e),e.advice?this.socket.onError(e):"unauthorized"===e.reason?this.$emit("connect_failed",e.reason):this.$emit("error",e.reason);}},r.prototype.send=function(){this.namespace.flags[this.name]=!0,this.namespace.send.apply(this.namespace,arguments);},r.prototype.emit=function(){this.namespace.flags[this.name]=!0,this.namespace.emit.apply(this.namespace,arguments);};}(void 0!==io?io:module.exports,void 0!==io?io:module.parent.exports),function(e,t,n){function r(e){t.Transport.apply(this,arguments);}e.websocket=r,t.util.inherit(r,t.Transport),r.prototype.name="websocket",r.prototype.open=function(){var e,r=t.util.query(this.socket.options.query),o=this;return e||(e=n.MozWebSocket||n.WebSocket),this.websocket=new e(this.prepareUrl()+r),this.websocket.onopen=function(){o.onOpen(),o.socket.setBuffer(!1);},this.websocket.onmessage=function(e){o.onData(e.data);},this.websocket.onclose=function(){o.socket.setBuffer(!0),o.onClose();},this.websocket.onerror=function(e){o.onError(e);},this;},t.util.ua.iDevice?r.prototype.send=function(e){var t=this;return setTimeout(function(){t.websocket.send(e);},0),this;}:r.prototype.send=function(e){return this.websocket.send(e),this;},r.prototype.payload=function(e){for(var t=0,n=e.length;t<n;t++){this.packet(e[t]);}return this;},r.prototype.close=function(){return this.websocket.close(),this;},r.prototype.onError=function(e){this.socket.publish("info","tcp, onError",e),this.socket.onError(e);},r.prototype.scheme=function(){return this.socket.options.secure?"wss":"ws";},r.check=function(){return"WebSocket"in n&&!("__addTask"in WebSocket)||"MozWebSocket"in n;},r.xdomainCheck=function(){return!0;},t.transports.push("websocket");}(void 0!==io?io.Transport:module.exports,void 0!==io?io:module.parent.exports,root),function(e,t,n){function r(e){e&&(t.Transport.apply(this,arguments),this.sendBuffer=[]);}function o(){}e.XHR=r,t.util.inherit(r,t.Transport),r.prototype.open=function(){return this.socket.setBuffer(!1),this.onOpen(),this.get(),this.setCloseTimeout(),this;},r.prototype.payload=function(e){for(var n=[],r=0,o=e.length;r<o;r++){n.push(t.parser.encodePacket(e[r]));}this.send(t.parser.encodePayload(n));},r.prototype.send=function(e){return this.post(e),this;},r.prototype.post=function(e){var t=this;this.socket.setBuffer(!0),this.sendXHR=this.request("POST"),n.XDomainRequest&&this.sendXHR instanceof XDomainRequest?this.sendXHR.onload=this.sendXHR.onerror=function(){this.onload=o,t.socket.setBuffer(!1);}:this.sendXHR.onreadystatechange=function(){4==this.readyState&&(this.onreadystatechange=o,t.posting=!1,200==this.status?t.socket.setBuffer(!1):t.onClose());},this.sendXHR.send(e);},r.prototype.close=function(){return this.onClose(),this;},r.prototype.request=function(e){var n=t.util.request(this.socket.isXDomain()),r=t.util.query(this.socket.options.query,"t="+ +new Date());if(n.open(e||"GET",this.prepareUrl()+r,!0),"POST"==e)try{n.setRequestHeader?n.setRequestHeader("Content-type","text/plain;charset=UTF-8"):n.contentType="text/plain";}catch(e){}return n;},r.prototype.scheme=function(){return this.socket.options.secure?"https":"http";},r.check=function(e,r){try{var o=t.util.request(r),i=n.XDomainRequest&&o instanceof XDomainRequest,s=e&&e.options&&e.options.secure?"https:":"http:",a=n.location&&s!=n.location.protocol;if(o&&(!i||!a))return!0;}catch(e){}return!1;},r.xdomainCheck=function(e){return r.check(e,!0);};}(void 0!==io?io.Transport:module.exports,void 0!==io?io:module.parent.exports,root),function(e,t,n){function r(){t.Transport.XHR.apply(this,arguments);}function o(){}e["xhr-polling"]=r,t.util.inherit(r,t.Transport.XHR),t.util.merge(r,t.Transport.XHR),r.prototype.name="xhr-polling",r.prototype.heartbeats=function(){return!1;},r.prototype.open=function(){return t.Transport.XHR.prototype.open.call(this),!1;},r.prototype.get=function(){if(this.isOpen){var e=this;this.xhr=this.request(),n.XDomainRequest&&this.xhr instanceof XDomainRequest?(this.xhr.onload=function(){this.onload=o,this.onerror=o,e.retryCounter=1,e.onData(this.responseText),e.get();},this.xhr.onerror=function(){e.retryCounter++,!e.retryCounter||e.retryCounter>3?e.onClose():e.get();}):this.xhr.onreadystatechange=function(){4==this.readyState&&(this.onreadystatechange=o,200==this.status?(e.onData(this.responseText),e.get()):e.onClose());},this.xhr.send(null);}},r.prototype.onClose=function(){if(t.Transport.XHR.prototype.onClose.call(this),this.xhr){this.xhr.onreadystatechange=this.xhr.onload=this.xhr.onerror=o;try{this.xhr.abort();}catch(e){}this.xhr=null;}},r.prototype.ready=function(e,n){var r=this;t.util.defer(function(){n.call(r);});},t.transports.push("xhr-polling");}(void 0!==io?io.Transport:module.exports,void 0!==io?io:module.parent.exports,root),__WEBPACK_AMD_DEFINE_ARRAY__=[],__WEBPACK_AMD_DEFINE_RESULT__=function(){return io;}.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__),void 0===__WEBPACK_AMD_DEFINE_RESULT__||(module.exports=__WEBPACK_AMD_DEFINE_RESULT__);}();}).call(this,__webpack_require__(49),__webpack_require__(135)(module));},function(e,t,n){var r,o=n(23),i=n(41),s=n(14),a=n(73),c=n(643),u=n(650),l={},m="BROWSER";l.initReporter=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n={app_key:e.appKey,platform:"Web",dev_id:i.deviceId,sdk_ver:s.info.version,env:"online",os_name:a.os?a.os.family:"",os_ver:a.os?a.os.version:"",model:a.version,manufactor:m,host_env:m,host_info:a.ua,host_env_ver:a.version};s.isBrowser||(t=!1);var r=new c({common:n,request:u,logger:e.logger,autoStart:s.isBrowser},t);return r;};l.sendBeacon=navigator&&navigator.sendBeacon&&o(r=navigator.sendBeacon).call(r,navigator)||function(e,t){var n=new XMLHttpRequest();n.open("POST",e,!0),n.send(t);},e.exports=l;},function(e,t,n){e.exports=n(644);},function(e,t,n){var r=n(1),o=n(12);r({global:!0,forced:o.globalThis!==o},{globalThis:o});},function(e,t,n){e.exports=n(662);},function(e,t,n){var r=n(5);n(41);function o(){}o.typeMap={text:0,image:1,audio:2,video:3,geo:4,notification:5,file:6,tip:10,robot:11,g2:12,custom:100};var i=o.typeReverseMap={0:"text",1:"image",2:"audio",3:"video",4:"geo",5:"notification",6:"file",10:"tip",11:"robot",12:"g2",100:"custom"};o.validTypes=r(o.typeMap),o.setFlow=function(e,t){e.flow=e.from===t?e.to===t?"in":"out":"in","robot"===e.type&&e.content&&e.content.msgOut&&(e.flow="in");},o.getType=function(e){var t=e.type;return i[t]||t;},e.exports=o;},function(e,t,n){"use strict";e.exports=function(e,t,n,r){var o=self||window;try{try{var i;try{i=new o.Blob([e]);}catch(t){(i=new(o.BlobBuilder||o.WebKitBlobBuilder||o.MozBlobBuilder||o.MSBlobBuilder)()).append(e),i=i.getBlob();}var s=o.URL||o.webkitURL,a=s.createObjectURL(i),c=new o[t](a,n);return s.revokeObjectURL(a),c;}catch(r){return new o[t]("data:application/javascript,".concat(encodeURIComponent(e)),n);}}catch(e){if(!r)throw Error("Inline worker is not supported");return new o[t](r,n);}};},function(e,t,n){n(294).polyfill(),n(14).isBrowser=!0;},function(e,t,n){var r=n(353);e.exports=r;},function(e,t,n){var r=n(449);e.exports=r;},function(e,t,n){e.exports=n(541);},function(e,t,n){(function(r){var o,i=n(22),s=n(16),a=n(30),c=n(3),u=n(2),l=n(46),m=n(9),p=n(5),d=n(17);!function(f,g){"use strict";var h,y=(f=void 0!==f?f:"undefined"!=typeof self?self:void 0!==r?r:{}).IDBKeyRange||f.webkitIDBKeyRange,v="readonly",b="readwrite",T=Object.prototype.hasOwnProperty,S=function S(){if(!h&&!(h=f.indexedDB||f.webkitIndexedDB||f.mozIndexedDB||f.oIndexedDB||f.msIndexedDB||(null===f.indexedDB&&f.shimIndexedDB?f.shimIndexedDB:void 0)))throw"IndexedDB required";return h;},M=function M(e){return e;},k=function k(e){var t;return s(t=Object.prototype.toString.call(e)).call(t,8,-1).toLowerCase();},x=function x(e){return"function"==typeof e;},C=function C(e){return"number"===k(e);},I=function I(e){return"array"===k(e);},_=function _(e){return void 0===e;},w=function w(e,t){var n=this,r=!1;this.name=t,this.getIndexedDB=function(){return e;},this.add=function(t){if(r)throw"Database has been closed";for(var o=[],i=0,s=0;s<arguments.length-1;s++){if(a(arguments[s+1]))for(var m=0;m<arguments[s+1].length;m++){o[i]=arguments[s+1][m],i++;}else o[i]=arguments[s+1],i++;}var p=e.transaction(t,b),d=p.objectStore(t);return new c(function(e,t){u(o).call(o,function(e){var t;if(e.item&&e.key){var n=e.key;e=e.item,t=d.add(e,n);}else t=d.add(e);t.onsuccess=function(t){var n=t.target,r=n.source.keyPath;null===r&&(r="__id__"),l(e,r,{value:n.result,enumerable:!0});};}),p.oncomplete=function(){e(o,n);},p.onerror=function(e){e.preventDefault(),t(e);},p.onabort=function(e){t(e);};});},this.updateAndDelete=function(t,n,o){if(r)throw"Database has been closed";var i=e.transaction(t,b),s=i.objectStore(t),a=s.keyPath;return new c(function(e,t){u(n).call(n,function(e){if(e.item&&e.key){var t=e.key;e=e.item,s.put(e,t);}else s.put(e);}),u(o).call(o,function(e){s.delete(e[a]);}),i.oncomplete=function(){e([n,o]);},i.onerror=function(e){t(e);};});},this.update=function(t){if(r)throw"Database has been closed";for(var o,i=[],s=1;s<arguments.length;s++){a(o=arguments[s])?i=m(i).call(i,o):i.push(o);}var l=e.transaction(t,b),p=l.objectStore(t);p.keyPath;return new c(function(e,t){u(i).call(i,function(e){var t;if(e.item&&e.key){var n=e.key;e=e.item,t=p.put(e,n);}else t=p.put(e);t.onsuccess=function(e){},t.onerror=function(e){};}),l.oncomplete=function(){e(i,n);},l.onerror=function(e){t(e);},l.onabort=function(e){t(e);};});},this.remove=function(t,n,o,i,s,l,m){if(r)throw"Database has been closed";var p=e.transaction(t,b),d=p.objectStore(t);return new c(function(e,t){function r(e){return null==e;}var c;(r(i)&&(i=-1/0),r(s)&&(s=1/0),null===n||a(n)||(n=[n]),r(o))?null!==n?u(n).call(n,function(e){d.delete(e);}):d.delete(range=y.bound(i,s,l,m)):(c=null!==n?y.only(n[0]):y.bound(i,s,l,m),d.index(o).openCursor(c).onsuccess=function(e){var t=e.target.result;t&&(t.delete(),t.continue());});p.oncomplete=function(){e();},p.onerror=function(e){t(e);},p.onabort=function(e){t(e);};});},this.clear=function(t){if(r)throw"Database has been closed";var n=e.transaction(t,b);n.objectStore(t).clear();return new c(function(e,t){n.oncomplete=function(){e();},n.onerror=function(e){t(e);};});},this.close=function(){r||(e.close(),r=!0,delete O[t]);},this.get=function(t,n){if(r)throw"Database has been closed";var o=e.transaction(t),i=o.objectStore(t).get(n);return new c(function(e,t){i.onsuccess=function(t){e(t.target.result);},o.onerror=function(e){t(e);};});},this.query=function(t,n){if(r)throw"Database has been closed";return new P(t,e,n);},this.count=function(t,n){if(r)throw"Database has been closed";e.transaction(t).objectStore(t);};for(var o=0,i=e.objectStoreNames.length;o<i;o++){!function(e){for(var t in n[e]={},n){T.call(n,t)&&"close"!==t&&(n[e][t]=function(t){return function(){var r,o=m(r=[e]).call(r,s([]).call(arguments,0));return n[t].apply(n,o);};}(t));}}(e.objectStoreNames[o]);}},P=function P(e,t,n){var r,o=this,a=!1,l=!1,m=function m(r,o,s,_m,d,f,g){return new c(function(c,h){var T=a||l?b:v,S=t.transaction(e,T),M=S.objectStore(e),k=n?M.index(n):M,C=r?y[r].apply(null,o):null,I=[],_=[C],w=0;d=d||null,f=f||[],"count"!==s&&_.push(_m||"next");var P=!!a&&p(a);k[s].apply(k,_).onsuccess=function(e){var t=e.target.result;if(i(t)===i(0))I=t;else if(t)if(null!==d&&d[0]>w)w=d[0],t.advance(d[0]);else if(null!==d&&w>=d[0]+d[1]);else{var n=!0,r="value"in t?t.value:t.key;u(f).call(f,function(e){e&&e.length&&(2===e.length?n=n&&r[e[0]]===e[1]:x(e[0])&&(n=n&&e[0].apply(void 0,[r])));}),n&&(w++,I.push(g(r)),l?t.delete():a&&(r=function(e){for(var t=0;t<P.length;t++){var n=P[t],r=a[n];r instanceof Function&&(r=r(e)),e[n]=r;}return e;}(r),t.update(r))),t.continue();}},S.oncomplete=function(){c(I);},S.onerror=function(e){h(e);},S.onabort=function(e){h(e);};});},f=function f(e,t){var n="next",r="openCursor",o=[],i=null,c=M,u=!1,p=function p(){return m(e,t,r,u?n+"unique":n,i,o,c);},d=function d(){return n=null,r="count",{execute:p};},f=function e(){return 1==(i=I(arguments[0])?arguments[0]:s(Array.prototype).call(arguments,0,2)).length&&i.unshift(0),C(i[1])||(i=null),{execute:p,count:d,keys:g,filter:h,asc:y,desc:v,distinct:b,modify:T,limit:e,map:S,remove:k};},g=function e(t){return(t=!!_(t)||!!t)&&(r="openKeyCursor"),{execute:p,keys:e,filter:h,asc:y,desc:v,distinct:b,modify:T,limit:f,map:S,remove:k};},h=function e(){return o.push(s(Array.prototype).call(arguments,0,2)),{execute:p,count:d,keys:g,filter:e,asc:y,desc:v,distinct:b,modify:T,limit:f,map:S,remove:k};},y=function e(t){return t=!!_(t)||!!t,n=t?"next":"prev",{execute:p,count:d,keys:g,filter:h,asc:e,desc:v,distinct:b,modify:T,limit:f,map:S,remove:k};},v=function e(t){return t=!!_(t)||!!t,n=t?"prev":"next",{execute:p,count:d,keys:g,filter:h,asc:y,desc:e,distinct:b,modify:T,limit:f,map:S,remove:k};},b=function e(t){return t=!!_(t)||!!t,u=t,{execute:p,count:d,keys:g,filter:h,asc:y,desc:v,distinct:e,modify:T,limit:f,map:S,remove:k};},T=function e(t){return a=t,{execute:p,count:d,keys:g,filter:h,asc:y,desc:v,distinct:b,modify:e,limit:f,map:S,remove:k};},S=function e(t){return x(t)&&(c=t),{execute:p,count:d,keys:g,filter:h,asc:y,desc:v,distinct:b,modify:T,limit:f,map:e,remove:k};},k=function e(t){return t=!!_(t)||!!t,l=t,{execute:p,count:d,keys:g,filter:h,asc:y,desc:v,distinct:b,modify:T,limit:f,map:S,remove:e};};return{execute:p,count:d,keys:g,filter:h,asc:y,desc:v,distinct:b,modify:T,limit:f,map:S,remove:k};};u(r="only bound upperBound lowerBound".split(" ")).call(r,function(e){o[e]=function(){return new f(e,arguments);};}),this.filter=function(){var e=new f(null,null);return d(e).apply(e,arguments);},this.all=function(){var e;return d(e=this).call(e);};},A=function A(e,t,n,r){var o=e.target.result,i=new w(o,t);return O[t]=o,c.resolve(i);},O={},E={version:"0.10.2",open:function open(e){var t;return new c(function(n,r){if(O[e.server])A({target:{result:O[e.server]}},e.server,e.version,e.schema).then(n,r);else{try{t=S().open(e.server,e.version);}catch(e){r(e);}t.onsuccess=function(t){A(t,e.server,e.version,e.schema).then(n,r);},t.onupgradeneeded=function(t){!function(e,t,n){for(var r in"function"==typeof t&&(t=t()),t){var o,i=t[r];for(var s in o=!T.call(t,r)||n.objectStoreNames.contains(r)?e.currentTarget.transaction.objectStore(r):n.createObjectStore(r,i.key),i.indexes){var a=i.indexes[s];try{o.index(s);}catch(e){o.createIndex(s,a.key||s,p(a).length?a:{unique:!1});}}}}(t,e.schema,t.target.result);},t.onerror=function(e){r(e);};}});},remove:function remove(e){return new c(function(t,n){if(!e)return t();var r,o;i(e)===w&&(e=e.name),"string"==typeof e&&(r=O[e]),r&&"function"==typeof r.close&&r.close();try{o=S().deleteDatabase(e);}catch(e){n(e);}o.onsuccess=function(n){delete O[e],t(e);},o.onerror=function(e){n(e);},o.onblocked=function(e){n(e);};});}};void 0!==e.exports?e.exports=E:void 0===(o=function(){return E;}.call(t,n,t,e))||(e.exports=o);}(void 0);}).call(this,n(49));},function(e,t,n){var r=n(569);e.exports=r;},function(e,t,n){e.exports=n(631);},function(e,t){var n={set:function set(e,t,r){n[e]=t,r&&(r.support=t);}};e.exports=n;},function(e,t,n){var r=n(5),o=n(2),i=n(23),s=n(0),a=s.notundef,c=s.fillPropertyWithDefault,u=r,l={},m={},p={},d=[],f={normal:0,advanced:1},g={manager:0,all:1};l.inviteMode=l.updateCustomMode=l.updateTeamMode=g;var h={0:"normal",1:"advanced"},y=l.joinMode={noVerify:0,needVerify:1,rejectAll:2};m.joinMode={0:"noVerify",1:"needVerify",2:"rejectAll"},p.joinMode=u(y),d.push("join");var v=l.beInviteMode={needVerify:0,noVerify:1};function b(e){var t;s.verifyOptions(e,"action","superTeam::SuperTeam"),s.verifyOptions(e,"teamId","superTeam::SuperTeam"),a(e.teamId)&&(this.teamId=e.teamId),a(e.type)&&(this.type=f[e.type]),a(e.avatar)&&(this.avatar=""+e.avatar),a(e.name)&&(this.name=""+e.name),a(e.intro)&&(this.intro=""+e.intro),a(e.announcement)&&(this.announcement=""+e.announcement),a(e.custom)&&(this.custom=""+e.custom),a(e.inviteMode)&&(this.inviteMode=g[e.inviteMode]),a(e.updateCustomMode)&&(this.updateCustomMode=g[e.updateCustomMode]),a(e.updateTeamMode)&&(this.updateTeamMode=g[e.updateTeamMode]),o(d).call(d,i(t=this.setMode).call(t,this,e));}function T(e,t){a(e[t+="Mode"])&&(e[t]=m[t][e[t]]);}m.beInviteMode={0:"needVerify",1:"noVerify"},d.push("beInvite"),m.inviteMode=m.updateCustomMode=m.updateTeamMode={0:"manager",1:"all"},d.push("invite"),d.push("updateCustom"),d.push("updateTeam"),p.inviteMode=p.updateCustomMode=p.updateTeamMode=u(g),p.beInviteMode=u(v),b.prototype.setMode=function(e,t){a(e[t+="Mode"])&&(s.verifyParamValid(t,e[t],p[t],"Superteam::Team"),this[t]=l[t][e[t]]);},b.reverse=function(e,t){var n=s.copy(e);if(a(n.teamId)&&(n.teamId=""+n.teamId),a(n.type)&&(n.type=h[n.type]),a(n.level)&&(n.level=+n.level),a(n.valid)&&(n.valid=1==+n.valid),a(n.memberNum)&&(n.memberNum=+n.memberNum),a(n.memberUpdateTime)&&(n.memberUpdateTime=+n.memberUpdateTime),a(n.createTime)&&(n.createTime=+n.createTime),a(n.updateTime)&&(n.updateTime=+n.updateTime),a(n.validToCurrentUser)&&(n.validToCurrentUser="1"===n.validToCurrentUser),a(n.mute)&&(n.mute="1"===n.mute),a(n.muteType))switch(n.muteType){case"0":n.mute=!1,n.muteType="none";break;case"1":n.mute=!0,n.muteType="normal";break;case"3":n.mute=!0,n.muteType="all";}else a(n.mute)&&(1===n.mute?(n.mute=!0,n.muteType="normal"):(n.mute=!1,n.muteType="none"));return o(d).call(d,i(T).call(T,null,n)),delete n.bits,t||b.fillProperties(n),n;},b.fillProperties=function(e){return c(e,"avatar","");},e.exports=b;},function(e,t,n){var r=n(0).notundef;function o(e){r(e.shouldPushNotificationWhenPCOnline)&&(this.open=e.shouldPushNotificationWhenPCOnline?2:1);}o.getDefaultConfig=function(){return{shouldPushNotificationWhenPCOnline:!0};},o.reverse=function(e){return{shouldPushNotificationWhenPCOnline:1!=+e.open};},e.exports=o;},function(e,t,n){e.exports=n(673);},function(e,t,n){var r=n(73),o=n(686),i=n(272),s=n(242),a=n(181),c=n(0),u=n(286),l=n(269),m=n(171),p=n(691),d=n(692);e.exports=function(e){c.merge(e,{platform:r,xhr:o,io:i,naturalSort:s,deepAccess:a,util:c,support:u,blob:l,ajax:m,LoggerPlugin:p,usePlugin:d});};},function(e,t,n){var r=n(7),o=n(6),i=n(5),s=n(91).genPrivateUrl,a=n(0),c=a.notundef,u={"-2":"unset","-1":"restricted",0:"common",1:"owner",2:"manager",3:"guest",4:"anonymous"};function l(e){c(e.nick)&&(this.nick=""+e.nick),c(e.avatar)&&(this.avatar=""+e.avatar),c(e.custom)&&(this.custom=""+e.custom);}l.reverse=function(e){var t=a.copy(e);return c(t.chatroomId)&&(t.chatroomId=""+t.chatroomId),c(t.avatar)&&(t.avatar=s(t.avatar)),c(t.type)&&(t.type=u[t.type]),c(t.level)&&(t.level=+t.level),c(t.online)&&(t.online=1==+t.online),c(t.enterTime)&&(t.enterTime=+t.enterTime),c(t.guest)&&(t.guest=1==+t.guest),c(t.blacked)&&(t.blacked=1==+t.blacked),c(t.gaged)&&(t.gaged=1==+t.gaged),c(t.valid)&&(t.valid=1==+t.valid),c(t.updateTime)&&(t.updateTime=+t.updateTime),c(t.tempMuted)?t.tempMuted=1==+t.tempMuted:t.tempMuted=!1,c(t.tempMuteDuration)?t.tempMuteDuration=+t.tempMuteDuration:t.tempMuteDuration=0,t.online||delete t.enterTime,t.guest&&(t.type="guest",delete t.valid),"common"!==t.type&&delete t.level,delete t.guest,t;},l.reverseMembers=function(e){return r(e).call(e,function(e){return o(l).call(l,e);});},l.validTypes=i(u),l.typeReverseMap=u,e.exports=l;},function(e,t,n){var r,o,i,s,a,c,u,l,m,p,d,f,g,h,y,v,b,T,S;e.exports=(r=n(74),n(695),void(r.lib.Cipher||(o=r,i=o.lib,s=i.Base,a=i.WordArray,c=i.BufferedBlockAlgorithm,u=o.enc,u.Utf8,l=u.Base64,m=o.algo.EvpKDF,p=i.Cipher=c.extend({cfg:s.extend(),createEncryptor:function createEncryptor(e,t){return this.create(this._ENC_XFORM_MODE,e,t);},createDecryptor:function createDecryptor(e,t){return this.create(this._DEC_XFORM_MODE,e,t);},init:function init(e,t,n){this.cfg=this.cfg.extend(n),this._xformMode=e,this._key=t,this.reset();},reset:function reset(){c.reset.call(this),this._doReset();},process:function process(e){return this._append(e),this._process();},finalize:function finalize(e){return e&&this._append(e),this._doFinalize();},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(){function e(e){return"string"==typeof e?S:b;}return function(t){return{encrypt:function encrypt(n,r,o){return e(r).encrypt(t,n,r,o);},decrypt:function decrypt(n,r,o){return e(r).decrypt(t,n,r,o);}};};}()}),i.StreamCipher=p.extend({_doFinalize:function _doFinalize(){return this._process(!0);},blockSize:1}),d=o.mode={},f=i.BlockCipherMode=s.extend({createEncryptor:function createEncryptor(e,t){return this.Encryptor.create(e,t);},createDecryptor:function createDecryptor(e,t){return this.Decryptor.create(e,t);},init:function init(e,t){this._cipher=e,this._iv=t;}}),g=d.CBC=function(){var e=f.extend();function t(e,t,n){var r,o=this._iv;o?(r=o,this._iv=void 0):r=this._prevBlock;for(var i=0;i<n;i++){e[t+i]^=r[i];}}return e.Encryptor=e.extend({processBlock:function processBlock(e,n){var r=this._cipher,o=r.blockSize;t.call(this,e,n,o),r.encryptBlock(e,n),this._prevBlock=e.slice(n,n+o);}}),e.Decryptor=e.extend({processBlock:function processBlock(e,n){var r=this._cipher,o=r.blockSize,i=e.slice(n,n+o);r.decryptBlock(e,n),t.call(this,e,n,o),this._prevBlock=i;}}),e;}(),h=(o.pad={}).Pkcs7={pad:function pad(e,t){for(var n=4*t,r=n-e.sigBytes%n,o=r<<24|r<<16|r<<8|r,i=[],s=0;s<r;s+=4){i.push(o);}var c=a.create(i,r);e.concat(c);},unpad:function unpad(e){var t=255&e.words[e.sigBytes-1>>>2];e.sigBytes-=t;}},i.BlockCipher=p.extend({cfg:p.cfg.extend({mode:g,padding:h}),reset:function reset(){var e;p.reset.call(this);var t=this.cfg,n=t.iv,r=t.mode;this._xformMode==this._ENC_XFORM_MODE?e=r.createEncryptor:(e=r.createDecryptor,this._minBufferSize=1),this._mode&&this._mode.__creator==e?this._mode.init(this,n&&n.words):(this._mode=e.call(r,this,n&&n.words),this._mode.__creator=e);},_doProcessBlock:function _doProcessBlock(e,t){this._mode.processBlock(e,t);},_doFinalize:function _doFinalize(){var e,t=this.cfg.padding;return this._xformMode==this._ENC_XFORM_MODE?(t.pad(this._data,this.blockSize),e=this._process(!0)):(e=this._process(!0),t.unpad(e)),e;},blockSize:4}),y=i.CipherParams=s.extend({init:function init(e){this.mixIn(e);},toString:function toString(e){return(e||this.formatter).stringify(this);}}),v=(o.format={}).OpenSSL={stringify:function stringify(e){var t=e.ciphertext,n=e.salt;return(n?a.create([1398893684,1701076831]).concat(n).concat(t):t).toString(l);},parse:function parse(e){var t,n=l.parse(e),r=n.words;return 1398893684==r[0]&&1701076831==r[1]&&(t=a.create(r.slice(2,4)),r.splice(0,4),n.sigBytes-=16),y.create({ciphertext:n,salt:t});}},b=i.SerializableCipher=s.extend({cfg:s.extend({format:v}),encrypt:function encrypt(e,t,n,r){r=this.cfg.extend(r);var o=e.createEncryptor(n,r),i=o.finalize(t),s=o.cfg;return y.create({ciphertext:i,key:n,iv:s.iv,algorithm:e,mode:s.mode,padding:s.padding,blockSize:e.blockSize,formatter:r.format});},decrypt:function decrypt(e,t,n,r){return r=this.cfg.extend(r),t=this._parse(t,r.format),e.createDecryptor(n,r).finalize(t.ciphertext);},_parse:function _parse(e,t){return"string"==typeof e?t.parse(e,this):e;}}),T=(o.kdf={}).OpenSSL={execute:function execute(e,t,n,r){r||(r=a.random(8));var o=m.create({keySize:t+n}).compute(e,r),i=a.create(o.words.slice(t),4*n);return o.sigBytes=4*t,y.create({key:o,iv:i,salt:r});}},S=i.PasswordBasedCipher=b.extend({cfg:b.cfg.extend({kdf:T}),encrypt:function encrypt(e,t,n,r){var o=(r=this.cfg.extend(r)).kdf.execute(n,e.keySize,e.ivSize);r.iv=o.iv;var i=b.encrypt.call(this,e,t,o.key,r);return i.mixIn(o),i;},decrypt:function decrypt(e,t,n,r){r=this.cfg.extend(r),t=this._parse(t,r.format);var o=r.kdf.execute(n,e.keySize,e.ivSize,t.salt);return r.iv=o.iv,b.decrypt.call(this,e,t,o.key,r);}}))));},function(e,t,n){e.exports=n(268);},function(e,t,n){(function(t,n){/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */var r;r=function r(){"use strict";function e(e){return"function"==typeof e;}var r=Array.isArray?Array.isArray:function(e){return"[object Array]"===Object.prototype.toString.call(e);},o=0,i=void 0,s=void 0,a=function a(e,t){f[o]=e,f[o+1]=t,2===(o+=2)&&(s?s(g):T());},c="undefined"!=typeof window?window:void 0,u=c||{},l=u.MutationObserver||u.WebKitMutationObserver,m="undefined"==typeof self&&void 0!==t&&"[object process]"==={}.toString.call(t),p="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel;function d(){var e=setTimeout;return function(){return e(g,1);};}var f=new Array(1e3);function g(){for(var e=0;e<o;e+=2){(0,f[e])(f[e+1]),f[e]=void 0,f[e+1]=void 0;}o=0;}var h,y,v,b,T=void 0;function S(e,t){var n=this,r=new this.constructor(x);void 0===r[k]&&j(r);var o=n._state;if(o){var i=arguments[o-1];a(function(){return E(o,r,i,n._result);});}else A(n,r,e,t);return r;}function M(e){if(e&&"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e.constructor===this)return e;var t=new this(x);return I(t,e),t;}m?T=function T(){return t.nextTick(g);}:l?(y=0,v=new l(g),b=document.createTextNode(""),v.observe(b,{characterData:!0}),T=function T(){b.data=y=++y%2;}):p?((h=new MessageChannel()).port1.onmessage=g,T=function T(){return h.port2.postMessage(0);}):T=void 0===c?function(){try{var e=Function("return this")().require("vertx");return void 0!==(i=e.runOnLoop||e.runOnContext)?function(){i(g);}:d();}catch(e){return d();}}():d();var k=Math.random().toString(36).substring(2);function x(){}function C(t,n,r){n.constructor===t.constructor&&r===S&&n.constructor.resolve===M?function(e,t){1===t._state?w(e,t._result):2===t._state?P(e,t._result):A(t,void 0,function(t){return I(e,t);},function(t){return P(e,t);});}(t,n):void 0===r?w(t,n):e(r)?function(e,t,n){a(function(e){var r=!1,o=function(e,t,n,r){try{e.call(t,n,r);}catch(e){return e;}}(n,t,function(n){r||(r=!0,t!==n?I(e,n):w(e,n));},function(t){r||(r=!0,P(e,t));},e._label);!r&&o&&(r=!0,P(e,o));},e);}(t,n,r):w(t,n);}function I(e,t){if(e===t)P(e,new TypeError("You cannot resolve a promise with itself"));else if(o=_typeof(r=t),null===r||"object"!==o&&"function"!==o)w(e,t);else{var n=void 0;try{n=t.then;}catch(t){return void P(e,t);}C(e,t,n);}var r,o;}function _(e){e._onerror&&e._onerror(e._result),O(e);}function w(e,t){void 0===e._state&&(e._result=t,e._state=1,0!==e._subscribers.length&&a(O,e));}function P(e,t){void 0===e._state&&(e._state=2,e._result=t,a(_,e));}function A(e,t,n,r){var o=e._subscribers,i=o.length;e._onerror=null,o[i]=t,o[i+1]=n,o[i+2]=r,0===i&&e._state&&a(O,e);}function O(e){var t=e._subscribers,n=e._state;if(0!==t.length){for(var r=void 0,o=void 0,i=e._result,s=0;s<t.length;s+=3){r=t[s],o=t[s+n],r?E(n,r,o,i):o(i);}e._subscribers.length=0;}}function E(t,n,r,o){var i=e(r),s=void 0,a=void 0,c=!0;if(i){try{s=r(o);}catch(e){c=!1,a=e;}if(n===s)return void P(n,new TypeError("A promises callback cannot return that same promise."));}else s=o;void 0!==n._state||(i&&c?I(n,s):!1===c?P(n,a):1===t?w(n,s):2===t&&P(n,s));}var R=0;function j(e){e[k]=R++,e._state=void 0,e._result=void 0,e._subscribers=[];}var N=function(){function e(e,t){this._instanceConstructor=e,this.promise=new e(x),this.promise[k]||j(this.promise),r(t)?(this.length=t.length,this._remaining=t.length,this._result=new Array(this.length),0===this.length?w(this.promise,this._result):(this.length=this.length||0,this._enumerate(t),0===this._remaining&&w(this.promise,this._result))):P(this.promise,new Error("Array Methods must be provided an Array"));}return e.prototype._enumerate=function(e){for(var t=0;void 0===this._state&&t<e.length;t++){this._eachEntry(e[t],t);}},e.prototype._eachEntry=function(e,t){var n=this._instanceConstructor,r=n.resolve;if(r===M){var o=void 0,i=void 0,s=!1;try{o=e.then;}catch(e){s=!0,i=e;}if(o===S&&void 0!==e._state)this._settledAt(e._state,t,e._result);else if("function"!=typeof o)this._remaining--,this._result[t]=e;else if(n===U){var a=new n(x);s?P(a,i):C(a,e,o),this._willSettleAt(a,t);}else this._willSettleAt(new n(function(t){return t(e);}),t);}else this._willSettleAt(r(e),t);},e.prototype._settledAt=function(e,t,n){var r=this.promise;void 0===r._state&&(this._remaining--,2===e?P(r,n):this._result[t]=n),0===this._remaining&&w(r,this._result);},e.prototype._willSettleAt=function(e,t){var n=this;A(e,void 0,function(e){return n._settledAt(1,t,e);},function(e){return n._settledAt(2,t,e);});},e;}(),U=function(){function t(e){this[k]=R++,this._result=this._state=void 0,this._subscribers=[],x!==e&&("function"!=typeof e&&function(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");}(),this instanceof t?function(e,t){try{t(function(t){I(e,t);},function(t){P(e,t);});}catch(t){P(e,t);}}(this,e):function(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");}());}return t.prototype.catch=function(e){return this.then(null,e);},t.prototype.finally=function(t){var n=this.constructor;return e(t)?this.then(function(e){return n.resolve(t()).then(function(){return e;});},function(e){return n.resolve(t()).then(function(){throw e;});}):this.then(t,t);},t;}();return U.prototype.then=S,U.all=function(e){return new N(this,e).promise;},U.race=function(e){var t=this;return r(e)?new t(function(n,r){for(var o=e.length,i=0;i<o;i++){t.resolve(e[i]).then(n,r);}}):new t(function(e,t){return t(new TypeError("You must pass an array to race."));});},U.resolve=M,U.reject=function(e){var t=new this(x);return P(t,e),t;},U._setScheduler=function(e){s=e;},U._setAsap=function(e){a=e;},U._asap=a,U.polyfill=function(){var e=void 0;if(void 0!==n)e=n;else if("undefined"!=typeof self)e=self;else try{e=Function("return this")();}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment");}var t=e.Promise;if(t){var r=null;try{r=Object.prototype.toString.call(t.resolve());}catch(e){}if("[object Promise]"===r&&!t.cast)return;}e.Promise=U;},U.Promise=U,U;},e.exports=r();}).call(this,n(295),n(49));},function(e,t){var n,r,o=e.exports={};function i(){throw new Error("setTimeout has not been defined");}function s(){throw new Error("clearTimeout has not been defined");}function a(e){if(n===setTimeout)return setTimeout(e,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0);}catch(t){try{return n.call(null,e,0);}catch(t){return n.call(this,e,0);}}}!function(){try{n="function"==typeof setTimeout?setTimeout:i;}catch(e){n=i;}try{r="function"==typeof clearTimeout?clearTimeout:s;}catch(e){r=s;}}();var c,u=[],l=!1,m=-1;function p(){l&&c&&(l=!1,c.length?u=c.concat(u):m=-1,u.length&&d());}function d(){if(!l){var e=a(p);l=!0;for(var t=u.length;t;){for(c=u,u=[];++m<t;){c&&c[m].run();}m=-1,t=u.length;}c=null,l=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===s||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e);}catch(t){try{return r.call(null,e);}catch(t){return r.call(this,e);}}}(e);}}function f(e,t){this.fun=e,this.array=t;}function g(){}o.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++){t[n-1]=arguments[n];}u.push(new f(e,t)),1!==u.length||l||a(d);},f.prototype.run=function(){this.fun.apply(null,this.array);},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=g,o.addListener=g,o.once=g,o.off=g,o.removeListener=g,o.removeAllListeners=g,o.emit=g,o.prependListener=g,o.prependOnceListener=g,o.listeners=function(e){return[];},o.binding=function(e){throw new Error("process.binding is not supported");},o.cwd=function(){return"/";},o.chdir=function(e){throw new Error("process.chdir is not supported");},o.umask=function(){return 0;};},function(e,t,n){var r=n(19),o=n(297),i=Array.prototype;e.exports=function(e){var t=e.indexOf;return e===i||r(i,e)&&t===i.indexOf?o:t;};},function(e,t,n){n(298);var r=n(24);e.exports=r("Array").indexOf;},function(e,t,n){"use strict";var r=n(1),o=n(146),i=n(151).indexOf,s=n(80),a=o([].indexOf),c=!!a&&1/a([1],1,-0)<0,u=s("indexOf");r({target:"Array",proto:!0,forced:c||!u},{indexOf:function indexOf(e){var t=arguments.length>1?arguments[1]:void 0;return c?a(this,e,t)||0:i(this,e,t);}});},function(e,t,n){var r=n(25),o=n(29),i=n(114),s=n(147),a=n(300),c=n(18),u=TypeError,l=c("toPrimitive");e.exports=function(e,t){if(!o(e)||i(e))return e;var n,c=s(e,l);if(c){if(void 0===t&&(t="default"),n=r(c,e,t),!o(n)||i(n))return n;throw u("Can't convert object to primitive value");}return void 0===t&&(t="number"),a(e,t);};},function(e,t,n){var r=n(25),o=n(20),i=n(29),s=TypeError;e.exports=function(e,t){var n,a;if("string"===t&&o(n=e.toString)&&!i(a=r(n,e)))return a;if(o(n=e.valueOf)&&!i(a=r(n,e)))return a;if("string"!==t&&o(n=e.toString)&&!i(a=r(n,e)))return a;throw s("Can't convert object to primitive value");};},function(e,t,n){var r=n(12),o=Object.defineProperty;e.exports=function(e,t){try{o(r,e,{value:t,configurable:!0,writable:!0});}catch(n){r[e]=t;}return t;};},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=Math.trunc||function(e){var t=+e;return(t>0?r:n)(t);};},function(e,t,n){var r=n(95),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0;};},function(e,t,n){var r=n(305);e.exports=r;},function(e,t,n){var r=n(19),o=n(306),i=Array.prototype;e.exports=function(e){var t=e.concat;return e===i||r(i,e)&&t===i.concat?o:t;};},function(e,t,n){n(196);var r=n(24);e.exports=r("Array").concat;},function(e,t,n){var r=n(67),o=n(116),i=n(29),s=n(18)("species"),a=Array;e.exports=function(e){var t;return r(e)&&(t=e.constructor,(o(t)&&(t===a||r(t.prototype))||i(t)&&null===(t=t[s]))&&(t=void 0)),void 0===t?a:t;};},function(e,t,n){n(309);var r=n(11).Object;e.exports=function(e,t){return r.create(e,t);};},function(e,t,n){n(1)({target:"Object",stat:!0,sham:!n(28)},{create:n(82)});},function(e,t,n){e.exports=n(311);},function(e,t,n){var r=n(312);n(339),n(340),n(341),n(342),n(343),n(344),n(345),e.exports=r;},function(e,t,n){var r=n(202);n(338),e.exports=r;},function(e,t,n){n(196),n(97),n(203),n(320),n(321),n(322),n(323),n(209),n(324),n(325),n(326),n(327),n(328),n(329),n(210),n(330),n(331),n(332),n(333),n(334);var r=n(11);e.exports=r.Symbol;},function(e,t,n){"use strict";var r=n(1),o=n(12),i=n(25),s=n(13),a=n(42),c=n(28),u=n(76),l=n(8),m=n(26),p=n(19),d=n(33),f=n(38),g=n(113),h=n(44),y=n(66),v=n(82),b=n(108),T=n(156),S=n(204),M=n(119),k=n(75),x=n(43),C=n(154),I=n(138),_=n(68),w=n(94),P=n(118),A=n(117),O=n(149),E=n(18),R=n(120),j=n(21),N=n(206),U=n(83),D=n(121),L=n(89).forEach,F=P("hidden"),B=D.set,q=D.getterFor("Symbol"),H=Object.prototype,z=o.Symbol,W=z&&z.prototype,V=o.TypeError,G=o.QObject,J=k.f,Q=x.f,K=S.f,$=I.f,X=s([].push),Y=w("symbols"),Z=w("op-symbols"),ee=w("wks"),te=!G||!G.prototype||!G.prototype.findChild,ne=c&&l(function(){return 7!=v(Q({},"a",{get:function get(){return Q(this,"a",{value:7}).a;}})).a;})?function(e,t,n){var r=J(H,t);r&&delete H[t],Q(e,t,n),r&&e!==H&&Q(H,t,r);}:Q,re=function re(e,t){var n=Y[e]=v(W);return B(n,{type:"Symbol",tag:e,description:t}),c||(n.description=t),n;},oe=function oe(e,t,n){e===H&&oe(Z,t,n),d(e);var r=g(t);return d(n),m(Y,r)?(n.enumerable?(m(e,F)&&e[F][r]&&(e[F][r]=!1),n=v(n,{enumerable:y(0,!1)})):(m(e,F)||Q(e,F,y(1,{})),e[F][r]=!0),ne(e,r,n)):Q(e,r,n);},ie=function ie(e,t){d(e);var n=f(t),r=b(n).concat(ue(n));return L(r,function(t){c&&!i(se,n,t)||oe(e,t,n[t]);}),e;},se=function se(e){var t=g(e),n=i($,this,t);return!(this===H&&m(Y,t)&&!m(Z,t))&&(!(n||!m(this,t)||!m(Y,t)||m(this,F)&&this[F][t])||n);},ae=function ae(e,t){var n=f(e),r=g(t);if(n!==H||!m(Y,r)||m(Z,r)){var o=J(n,r);return!o||!m(Y,r)||m(n,F)&&n[F][r]||(o.enumerable=!0),o;}},ce=function ce(e){var t=K(f(e)),n=[];return L(t,function(e){m(Y,e)||m(A,e)||X(n,e);}),n;},ue=function ue(e){var t=e===H,n=K(t?Z:f(e)),r=[];return L(n,function(e){!m(Y,e)||t&&!m(H,e)||X(r,Y[e]);}),r;};u||(_(W=(z=function z(){if(p(W,this))throw V("Symbol is not a constructor");var e=arguments.length&&void 0!==arguments[0]?h(arguments[0]):void 0,t=O(e),n=function n(e){this===H&&i(n,Z,e),m(this,F)&&m(this[F],t)&&(this[F][t]=!1),ne(this,t,y(1,e));};return c&&te&&ne(H,t,{configurable:!0,set:n}),re(t,e);}).prototype,"toString",function(){return q(this).tag;}),_(z,"withoutSetter",function(e){return re(O(e),e);}),I.f=se,x.f=oe,C.f=ie,k.f=ae,T.f=S.f=ce,M.f=ue,R.f=function(e){return re(E(e),e);},c&&(Q(W,"description",{configurable:!0,get:function get(){return q(this).description;}}),a||_(H,"propertyIsEnumerable",se,{unsafe:!0}))),r({global:!0,constructor:!0,wrap:!0,forced:!u,sham:!u},{Symbol:z}),L(b(ee),function(e){j(e);}),r({target:"Symbol",stat:!0,forced:!u},{useSetter:function useSetter(){te=!0;},useSimple:function useSimple(){te=!1;}}),r({target:"Object",stat:!0,forced:!u,sham:!c},{create:function create(e,t){return void 0===t?v(e):ie(v(e),t);},defineProperty:oe,defineProperties:ie,getOwnPropertyDescriptor:ae}),r({target:"Object",stat:!0,forced:!u},{getOwnPropertyNames:ce}),N(),U(z,"Symbol"),A[F]=!0;},function(e,t,n){"use strict";var r=n(153),o=n(52);e.exports=r?{}.toString:function(){return"[object "+o(this)+"]";};},function(e,t,n){var r=n(12),o=n(20),i=r.WeakMap;e.exports=o(i)&&/native code/.test(String(i));},function(e,t,n){var r=n(1),o=n(31),i=n(26),s=n(44),a=n(94),c=n(207),u=a("string-to-symbol-registry"),l=a("symbol-to-string-registry");r({target:"Symbol",stat:!0,forced:!c},{for:function _for(e){var t=s(e);if(i(u,t))return u[t];var n=o("Symbol")(t);return u[t]=n,l[n]=t,n;}});},function(e,t,n){var r=n(1),o=n(26),i=n(114),s=n(78),a=n(94),c=n(207),u=a("symbol-to-string-registry");r({target:"Symbol",stat:!0,forced:!c},{keyFor:function keyFor(e){if(!i(e))throw TypeError(s(e)+" is not a symbol");if(o(u,e))return u[e];}});},function(e,t,n){var r=n(1),o=n(76),i=n(8),s=n(119),a=n(37);r({target:"Object",stat:!0,forced:!o||i(function(){s.f(1);})},{getOwnPropertySymbols:function getOwnPropertySymbols(e){var t=s.f;return t?t(a(e)):[];}});},function(e,t,n){n(21)("asyncIterator");},function(e,t){},function(e,t,n){n(21)("hasInstance");},function(e,t,n){n(21)("isConcatSpreadable");},function(e,t,n){n(21)("match");},function(e,t,n){n(21)("matchAll");},function(e,t,n){n(21)("replace");},function(e,t,n){n(21)("search");},function(e,t,n){n(21)("species");},function(e,t,n){n(21)("split");},function(e,t,n){var r=n(31),o=n(21),i=n(83);o("toStringTag"),i(r("Symbol"),"Symbol");},function(e,t,n){n(21)("unscopables");},function(e,t,n){var r=n(12);n(83)(r.JSON,"JSON",!0);},function(e,t){},function(e,t){},function(e,t,n){"use strict";var r=n(213).IteratorPrototype,o=n(82),i=n(66),s=n(83),a=n(85),c=function c(){return this;};e.exports=function(e,t,n,u){var l=t+" Iterator";return e.prototype=o(r,{next:i(+!u,n)}),s(e,l,!1,!0),a[l]=c,e;};},function(e,t,n){var r=n(20),o=String,i=TypeError;e.exports=function(e){if("object"==(typeof e==="undefined"?"undefined":_typeof(e))||r(e))return e;throw i("Can't set "+o(e)+" as a prototype");};},function(e,t){e.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0};},function(e,t,n){n(21)("dispose");},function(e,t,n){n(21)("asyncDispose");},function(e,t,n){n(21)("matcher");},function(e,t,n){n(21)("metadataKey");},function(e,t,n){n(21)("observable");},function(e,t,n){n(21)("metadata");},function(e,t,n){n(21)("patternMatch");},function(e,t,n){n(21)("replaceAll");},function(e,t,n){e.exports=n(347);},function(e,t,n){e.exports=n(348);},function(e,t,n){var r=n(349);e.exports=r;},function(e,t,n){var r=n(350);e.exports=r;},function(e,t,n){var r=n(351);n(69),e.exports=r;},function(e,t,n){n(84),n(97),n(124),n(209);var r=n(120);e.exports=r.f("iterator");},function(e,t,n){var r=n(13),o=n(95),i=n(44),s=n(93),a=r("".charAt),c=r("".charCodeAt),u=r("".slice),l=function l(e){return function(t,n){var r,l,m=i(s(t)),p=o(n),d=m.length;return p<0||p>=d?e?"":void 0:(r=c(m,p))<55296||r>56319||p+1===d||(l=c(m,p+1))<56320||l>57343?e?a(m,p):r:e?u(m,p,p+2):l-56320+(r-55296<<10)+65536;};};e.exports={codeAt:l(!1),charAt:l(!0)};},function(e,t,n){n(354);var r=n(11);e.exports=r.Array.isArray;},function(e,t,n){n(1)({target:"Array",stat:!0},{isArray:n(67)});},function(e,t,n){var r=n(356);e.exports=r;},function(e,t,n){n(357);var r=n(24);e.exports=r("Array").forEach;},function(e,t,n){"use strict";var r=n(1),o=n(358);r({target:"Array",proto:!0,forced:[].forEach!=o},{forEach:o});},function(e,t,n){"use strict";var r=n(89).forEach,o=n(80)("forEach");e.exports=o?[].forEach:function(e){return r(this,e,arguments.length>1?arguments[1]:void 0);};},function(e,t,n){e.exports=n(360);},function(e,t,n){var r=n(361);e.exports=r;},function(e,t,n){n(362);var r=n(11).Object;e.exports=function(e){return r.getOwnPropertyNames(e);};},function(e,t,n){var r=n(1),o=n(8),i=n(204).f;r({target:"Object",stat:!0,forced:o(function(){return!Object.getOwnPropertyNames(1);})},{getOwnPropertyNames:i});},function(e,t,n){var r=n(364);e.exports=r;},function(e,t,n){n(208);var r=n(11),o=n(64);r.JSON||(r.JSON={stringify:JSON.stringify}),e.exports=function(e,t,n){return o(r.JSON.stringify,null,arguments);};},function(e,t,n){n(218),n(84),n(97),n(372),n(232),n(233),n(387),n(124);var r=n(11);e.exports=r.Promise;},function(e,t,n){"use strict";var r=n(1),o=n(19),i=n(122),s=n(123),a=n(367),c=n(82),u=n(51),l=n(66),m=n(368),p=n(369),d=n(99),f=n(370),g=n(18),h=n(371),y=g("toStringTag"),v=Error,b=[].push,T=function T(e,t){var n,r=arguments.length>2?arguments[2]:void 0,a=o(S,this);s?n=s(v(),a?i(this):S):(n=a?this:c(S),u(n,y,"Error")),void 0!==t&&u(n,"message",f(t)),h&&u(n,"stack",m(n.stack,1)),p(n,r);var l=[];return d(e,b,{that:l}),u(n,"errors",l),n;};s?s(T,v):a(T,v,{name:!0});var S=T.prototype=c(v.prototype,{constructor:l(1,T),message:l(1,""),name:l(1,"AggregateError")});r({global:!0,constructor:!0,arity:2},{AggregateError:T});},function(e,t,n){var r=n(26),o=n(219),i=n(75),s=n(43);e.exports=function(e,t,n){for(var a=o(t),c=s.f,u=i.f,l=0;l<a.length;l++){var m=a[l];r(e,m)||n&&r(n,m)||c(e,m,u(t,m));}};},function(e,t,n){var r=n(13),o=Error,i=r("".replace),s=String(o("zxcasd").stack),a=/\n\s*at [^:]*:[^\n]*/,c=a.test(s);e.exports=function(e,t){if(c&&"string"==typeof e&&!o.prepareStackTrace)for(;t--;){e=i(e,a,"");}return e;};},function(e,t,n){var r=n(29),o=n(51);e.exports=function(e,t){r(t)&&"cause"in t&&o(e,"cause",t.cause);};},function(e,t,n){var r=n(44);e.exports=function(e,t){return void 0===e?arguments.length<2?"":t:r(e);};},function(e,t,n){var r=n(8),o=n(66);e.exports=!r(function(){var e=Error("a");return!("stack"in e)||(Object.defineProperty(e,"stack",o(1,7)),7!==e.stack);});},function(e,t,n){n(373),n(382),n(383),n(384),n(385),n(386);},function(e,t,n){"use strict";var r,o,i,s=n(1),a=n(42),c=n(100),u=n(12),l=n(25),m=n(68),p=n(123),d=n(83),f=n(374),g=n(36),h=n(20),y=n(29),v=n(375),b=n(223),T=n(225).set,S=n(376),M=n(379),k=n(86),x=n(380),C=n(121),I=n(87),_=n(101),w=n(53),P=_.CONSTRUCTOR,A=_.REJECTION_EVENT,O=_.SUBCLASSING,E=C.getterFor("Promise"),R=C.set,j=I&&I.prototype,N=I,U=j,D=u.TypeError,L=u.document,F=u.process,B=w.f,q=B,H=!!(L&&L.createEvent&&u.dispatchEvent),z=function z(e){var t;return!(!y(e)||!h(t=e.then))&&t;},W=function W(e,t){var n,r,o,i=t.value,s=1==t.state,a=s?e.ok:e.fail,c=e.resolve,u=e.reject,m=e.domain;try{a?(s||(2===t.rejection&&K(t),t.rejection=1),!0===a?n=i:(m&&m.enter(),n=a(i),m&&(m.exit(),o=!0)),n===e.promise?u(D("Promise-chain cycle")):(r=z(n))?l(r,n,c,u):c(n)):u(i);}catch(e){m&&!o&&m.exit(),u(e);}},V=function V(e,t){e.notified||(e.notified=!0,S(function(){for(var n,r=e.reactions;n=r.get();){W(n,e);}e.notified=!1,t&&!e.rejection&&J(e);}));},G=function G(e,t,n){var r,o;H?((r=L.createEvent("Event")).promise=t,r.reason=n,r.initEvent(e,!1,!0),u.dispatchEvent(r)):r={promise:t,reason:n},!A&&(o=u["on"+e])?o(r):"unhandledrejection"===e&&M("Unhandled promise rejection",n);},J=function J(e){l(T,u,function(){var t,n=e.facade,r=e.value;if(Q(e)&&(t=k(function(){c?F.emit("unhandledRejection",r,n):G("unhandledrejection",n,r);}),e.rejection=c||Q(e)?2:1,t.error))throw t.value;});},Q=function Q(e){return 1!==e.rejection&&!e.parent;},K=function K(e){l(T,u,function(){var t=e.facade;c?F.emit("rejectionHandled",t):G("rejectionhandled",t,e.value);});},$=function $(e,t,n){return function(r){e(t,r,n);};},X=function X(e,t,n){e.done||(e.done=!0,n&&(e=n),e.value=t,e.state=2,V(e,!0));},Y=function Y(e,t,n){if(!e.done){e.done=!0,n&&(e=n);try{if(e.facade===t)throw D("Promise can't be resolved itself");var r=z(t);r?S(function(){var n={done:!1};try{l(r,t,$(Y,n,e),$(X,n,e));}catch(t){X(n,t,e);}}):(e.value=t,e.state=1,V(e,!1));}catch(t){X({done:!1},t,e);}}};if(P&&(U=(N=function N(e){v(this,U),g(e),l(r,this);var t=E(this);try{e($(Y,t),$(X,t));}catch(e){X(t,e);}}).prototype,(r=function r(e){R(this,{type:"Promise",done:!1,notified:!1,parent:!1,reactions:new x(),rejection:!1,state:0,value:void 0});}).prototype=m(U,"then",function(e,t){var n=E(this),r=B(b(this,N));return n.parent=!0,r.ok=!h(e)||e,r.fail=h(t)&&t,r.domain=c?F.domain:void 0,0==n.state?n.reactions.add(r):S(function(){W(r,n);}),r.promise;}),o=function o(){var e=new r(),t=E(e);this.promise=e,this.resolve=$(Y,t),this.reject=$(X,t);},w.f=B=function B(e){return e===N||void 0===e?new o(e):q(e);},!a&&h(I)&&j!==Object.prototype)){i=j.then,O||m(j,"then",function(e,t){var n=this;return new N(function(e,t){l(i,n,e,t);}).then(e,t);},{unsafe:!0});try{delete j.constructor;}catch(e){}p&&p(j,U);}s({global:!0,constructor:!0,wrap:!0,forced:P},{Promise:N}),d(N,"Promise",!1,!0),f("Promise");},function(e,t,n){"use strict";var r=n(31),o=n(43),i=n(18),s=n(28),a=i("species");e.exports=function(e){var t=r(e),n=o.f;s&&t&&!t[a]&&n(t,a,{configurable:!0,get:function get(){return this;}});};},function(e,t,n){var r=n(19),o=TypeError;e.exports=function(e,t){if(r(t,e))return e;throw o("Incorrect invocation");};},function(e,t,n){var r,o,i,s,a,c,u,l,m=n(12),p=n(79),d=n(75).f,f=n(225).set,g=n(227),h=n(377),y=n(378),v=n(100),b=m.MutationObserver||m.WebKitMutationObserver,T=m.document,S=m.process,M=m.Promise,k=d(m,"queueMicrotask"),x=k&&k.value;x||(r=function r(){var e,t;for(v&&(e=S.domain)&&e.exit();o;){t=o.fn,o=o.next;try{t();}catch(e){throw o?s():i=void 0,e;}}i=void 0,e&&e.enter();},g||v||y||!b||!T?!h&&M&&M.resolve?((u=M.resolve(void 0)).constructor=M,l=p(u.then,u),s=function s(){l(r);}):v?s=function s(){S.nextTick(r);}:(f=p(f,m),s=function s(){f(r);}):(a=!0,c=T.createTextNode(""),new b(r).observe(c,{characterData:!0}),s=function s(){c.data=a=!a;})),e.exports=x||function(e){var t={fn:e,next:void 0};i&&(i.next=t),o||(o=t,s()),i=t;};},function(e,t,n){var r=n(50),o=n(12);e.exports=/ipad|iphone|ipod/i.test(r)&&void 0!==o.Pebble;},function(e,t,n){var r=n(50);e.exports=/web0s(?!.*chrome)/i.test(r);},function(e,t,n){var r=n(12);e.exports=function(e,t){var n=r.console;n&&n.error&&(1==arguments.length?n.error(e):n.error(e,t));};},function(e,t){var n=function n(){this.head=null,this.tail=null;};n.prototype={add:function add(e){var t={item:e,next:null};this.head?this.tail.next=t:this.head=t,this.tail=t;},get:function get(){var e=this.head;if(e)return this.head=e.next,this.tail===e&&(this.tail=null),e.item;}},e.exports=n;},function(e,t,n){var r=n(228),o=n(100);e.exports=!r&&!o&&"object"==(typeof window==="undefined"?"undefined":_typeof(window))&&"object"==(typeof document==="undefined"?"undefined":_typeof(document));},function(e,t,n){"use strict";var r=n(1),o=n(25),i=n(36),s=n(53),a=n(86),c=n(99);r({target:"Promise",stat:!0,forced:n(229)},{all:function all(e){var t=this,n=s.f(t),r=n.resolve,u=n.reject,l=a(function(){var n=i(t.resolve),s=[],a=0,l=1;c(e,function(e){var i=a++,c=!1;l++,o(n,t,e).then(function(e){c||(c=!0,s[i]=e,--l||r(s));},u);}),--l||r(s);});return l.error&&u(l.value),n.promise;}});},function(e,t,n){"use strict";var r=n(1),o=n(42),i=n(101).CONSTRUCTOR,s=n(87),a=n(31),c=n(20),u=n(68),l=s&&s.prototype;if(r({target:"Promise",proto:!0,forced:i,real:!0},{catch:function _catch(e){return this.then(void 0,e);}}),!o&&c(s)){var m=a("Promise").prototype.catch;l.catch!==m&&u(l,"catch",m,{unsafe:!0});}},function(e,t,n){"use strict";var r=n(1),o=n(25),i=n(36),s=n(53),a=n(86),c=n(99);r({target:"Promise",stat:!0,forced:n(229)},{race:function race(e){var t=this,n=s.f(t),r=n.reject,u=a(function(){var s=i(t.resolve);c(e,function(e){o(s,t,e).then(n.resolve,r);});});return u.error&&r(u.value),n.promise;}});},function(e,t,n){"use strict";var r=n(1),o=n(25),i=n(53);r({target:"Promise",stat:!0,forced:n(101).CONSTRUCTOR},{reject:function reject(e){var t=i.f(this);return o(t.reject,void 0,e),t.promise;}});},function(e,t,n){"use strict";var r=n(1),o=n(31),i=n(42),s=n(87),a=n(101).CONSTRUCTOR,c=n(231),u=o("Promise"),l=i&&!a;r({target:"Promise",stat:!0,forced:i||a},{resolve:function resolve(e){return c(l&&this===u?s:this,e);}});},function(e,t,n){"use strict";var r=n(1),o=n(42),i=n(87),s=n(8),a=n(31),c=n(20),u=n(223),l=n(231),m=n(68),p=i&&i.prototype;if(r({target:"Promise",proto:!0,real:!0,forced:!!i&&s(function(){p.finally.call({then:function then(){}},function(){});})},{finally:function _finally(e){var t=u(this,a("Promise")),n=c(e);return this.then(n?function(n){return l(t,e()).then(function(){return n;});}:e,n?function(n){return l(t,e()).then(function(){throw n;});}:e);}}),!o&&c(i)){var d=a("Promise").prototype.finally;p.finally!==d&&m(p,"finally",d,{unsafe:!0});}},function(e,t,n){e.exports=n(389);},function(e,t,n){var r=n(390);e.exports=r;},function(e,t,n){var r=n(234);e.exports=r;},function(e,t,n){n(392);var r=n(11).Object,o=e.exports=function(e,t,n){return r.defineProperty(e,t,n);};r.defineProperty.sham&&(o.sham=!0);},function(e,t,n){var r=n(1),o=n(28),i=n(43).f;r({target:"Object",stat:!0,forced:Object.defineProperty!==i,sham:!o},{defineProperty:i});},function(e,t,n){var r=n(394),o=n(22).default;e.exports=function(e,t){if("object"!==o(e)||null===e)return e;var n=e[r];if(void 0!==n){var i=n.call(e,t||"default");if("object"!==o(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return("string"===t?String:Number)(e);},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(395);},function(e,t,n){e.exports=n(396);},function(e,t,n){var r=n(397);e.exports=r;},function(e,t,n){var r=n(398);e.exports=r;},function(e,t,n){var r=n(399);e.exports=r;},function(e,t,n){n(400),n(210);var r=n(120);e.exports=r.f("toPrimitive");},function(e,t){},function(e,t,n){var r=n(19),o=n(402),i=Array.prototype;e.exports=function(e){var t=e.slice;return e===i||r(i,e)&&t===i.slice?o:t;};},function(e,t,n){n(403);var r=n(24);e.exports=r("Array").slice;},function(e,t,n){"use strict";var r=n(1),o=n(67),i=n(116),s=n(29),a=n(115),c=n(40),u=n(38),l=n(81),m=n(18),p=n(96),d=n(98),f=p("slice"),g=m("species"),h=Array,y=Math.max;r({target:"Array",proto:!0,forced:!f},{slice:function slice(e,t){var n,r,m,p=u(this),f=c(p),v=a(e,f),b=a(void 0===t?f:t,f);if(o(p)&&(n=p.constructor,(i(n)&&(n===h||o(n.prototype))||s(n)&&null===(n=n[g]))&&(n=void 0),n===h||void 0===n))return d(p,v,b);for(r=new(void 0===n?h:n)(y(b-v,0)),m=0;v<b;v++,m++){v in p&&l(r,m,p[v]);}return r.length=m,r;}});},function(e,t,n){n(405);var r=n(11);e.exports=r.Object.keys;},function(e,t,n){var r=n(1),o=n(37),i=n(108);r({target:"Object",stat:!0,forced:n(8)(function(){i(1);})},{keys:function keys(e){return i(o(e));}});},function(e,t,n){var r=n(407);e.exports=r;},function(e,t,n){var r=n(19),o=n(408),i=Array.prototype;e.exports=function(e){var t=e.some;return e===i||r(i,e)&&t===i.some?o:t;};},function(e,t,n){n(409);var r=n(24);e.exports=r("Array").some;},function(e,t,n){"use strict";var r=n(1),o=n(89).some;r({target:"Array",proto:!0,forced:!n(80)("some")},{some:function some(e){return o(this,e,arguments.length>1?arguments[1]:void 0);}});},function(e,t,n){var r=n(411);e.exports=r;},function(e,t,n){var r=n(19),o=n(412),i=Array.prototype;e.exports=function(e){var t=e.splice;return e===i||r(i,e)&&t===i.splice?o:t;};},function(e,t,n){n(413);var r=n(24);e.exports=r("Array").splice;},function(e,t,n){"use strict";var r=n(1),o=n(37),i=n(115),s=n(95),a=n(40),c=n(414),u=n(197),l=n(152),m=n(81),p=n(238),d=n(96)("splice"),f=Math.max,g=Math.min;r({target:"Array",proto:!0,forced:!d},{splice:function splice(e,t){var n,r,d,h,y,v,b=o(this),T=a(b),S=i(e,T),M=arguments.length;for(0===M?n=r=0:1===M?(n=0,r=T-S):(n=M-2,r=g(f(s(t),0),T-S)),u(T+n-r),d=l(b,r),h=0;h<r;h++){(y=S+h)in b&&m(d,h,b[y]);}if(d.length=r,n<r){for(h=S;h<T-r;h++){v=h+n,(y=h+r)in b?b[v]=b[y]:p(b,v);}for(h=T;h>T-r+n;h--){p(b,h-1);}}else if(n>r)for(h=T-r;h>S;h--){v=h+n-1,(y=h+r-1)in b?b[v]=b[y]:p(b,v);}for(h=0;h<n;h++){b[h+S]=arguments[h+2];}return c(b,T-r+n),d;}});},function(e,t,n){"use strict";var r=n(28),o=n(67),i=TypeError,s=Object.getOwnPropertyDescriptor,a=r&&!function(){if(void 0!==this)return!0;try{Object.defineProperty([],"length",{writable:!1}).length=1;}catch(e){return e instanceof TypeError;}}();e.exports=a?function(e,t){if(o(e)&&!s(e,"length").writable)throw i("Cannot set read only .length");return e.length=t;}:function(e,t){return e.length=t;};},function(e,t,n){var r=n(416);e.exports=r;},function(e,t,n){var r=n(19),o=n(417),i=Array.prototype;e.exports=function(e){var t=e.sort;return e===i||r(i,e)&&t===i.sort?o:t;};},function(e,t,n){n(418);var r=n(24);e.exports=r("Array").sort;},function(e,t,n){"use strict";var r=n(1),o=n(13),i=n(36),s=n(37),a=n(40),c=n(238),u=n(44),l=n(8),m=n(419),p=n(80),d=n(420),f=n(421),g=n(77),h=n(422),y=[],v=o(y.sort),b=o(y.push),T=l(function(){y.sort(void 0);}),S=l(function(){y.sort(null);}),M=p("sort"),k=!l(function(){if(g)return g<70;if(!(d&&d>3)){if(f)return!0;if(h)return h<603;var e,t,n,r,o="";for(e=65;e<76;e++){switch(t=String.fromCharCode(e),e){case 66:case 69:case 70:case 72:n=3;break;case 68:case 71:n=4;break;default:n=2;}for(r=0;r<47;r++){y.push({k:t+r,v:n});}}for(y.sort(function(e,t){return t.v-e.v;}),r=0;r<y.length;r++){t=y[r].k.charAt(0),o.charAt(o.length-1)!==t&&(o+=t);}return"DGBEFHACIJK"!==o;}});r({target:"Array",proto:!0,forced:T||!S||!M||!k},{sort:function sort(e){void 0!==e&&i(e);var t=s(this);if(k)return void 0===e?v(t):v(t,e);var n,r,o=[],l=a(t);for(r=0;r<l;r++){r in t&&b(o,t[r]);}for(m(o,function(e){return function(t,n){return void 0===n?-1:void 0===t?1:void 0!==e?+e(t,n)||0:u(t)>u(n)?1:-1;};}(e)),n=a(o),r=0;r<n;){t[r]=o[r++];}for(;r<l;){c(t,r++);}return t;}});},function(e,t,n){var r=n(205),o=Math.floor,i=function i(e,t){var n=e.length,c=o(n/2);return n<8?s(e,t):a(e,i(r(e,0,c),t),i(r(e,c),t),t);},s=function s(e,t){for(var n,r,o=e.length,i=1;i<o;){for(r=i,n=e[i];r&&t(e[r-1],n)>0;){e[r]=e[--r];}r!==i++&&(e[r]=n);}return e;},a=function a(e,t,n,r){for(var o=t.length,i=n.length,s=0,a=0;s<o||a<i;){e[s+a]=s<o&&a<i?r(t[s],n[a])<=0?t[s++]:n[a++]:s<o?t[s++]:n[a++];}return e;};e.exports=i;},function(e,t,n){var r=n(50).match(/firefox\/(\d+)/i);e.exports=!!r&&+r[1];},function(e,t,n){var r=n(50);e.exports=/MSIE|Trident/.test(r);},function(e,t,n){var r=n(50).match(/AppleWebKit\/(\d+)\./);e.exports=!!r&&+r[1];},function(e,t,n){var r=n(424);e.exports=r;},function(e,t,n){var r=n(19),o=n(425),i=Array.prototype;e.exports=function(e){var t=e.map;return e===i||r(i,e)&&t===i.map?o:t;};},function(e,t,n){n(426);var r=n(24);e.exports=r("Array").map;},function(e,t,n){"use strict";var r=n(1),o=n(89).map;r({target:"Array",proto:!0,forced:!n(96)("map")},{map:function map(e){return o(this,e,arguments.length>1?arguments[1]:void 0);}});},function(e,t,n){var r=n(428);e.exports=r;},function(e,t,n){var r=n(19),o=n(429),i=Array.prototype;e.exports=function(e){var t=e.reduce;return e===i||r(i,e)&&t===i.reduce?o:t;};},function(e,t,n){n(430);var r=n(24);e.exports=r("Array").reduce;},function(e,t,n){"use strict";var r=n(1),o=n(431).left,i=n(80),s=n(77),a=n(100);r({target:"Array",proto:!0,forced:!i("reduce")||!a&&s>79&&s<83},{reduce:function reduce(e){var t=arguments.length;return o(this,e,t,t>1?arguments[1]:void 0);}});},function(e,t,n){var r=n(36),o=n(37),i=n(111),s=n(40),a=TypeError,c=function c(e){return function(t,n,c,u){r(n);var l=o(t),m=i(l),p=s(l),d=e?p-1:0,f=e?-1:1;if(c<2)for(;;){if(d in m){u=m[d],d+=f;break;}if(d+=f,e?d<0:p<=d)throw a("Reduce of empty array with no initial value");}for(;e?d>=0:p>d;d+=f){d in m&&(u=n(u,m[d],d,l));}return u;};};e.exports={left:c(!1),right:c(!0)};},function(e,t,n){var r=n(433);e.exports=r;},function(e,t,n){var r=n(19),o=n(434),i=Array.prototype;e.exports=function(e){var t=e.lastIndexOf;return e===i||r(i,e)&&t===i.lastIndexOf?o:t;};},function(e,t,n){n(435);var r=n(24);e.exports=r("Array").lastIndexOf;},function(e,t,n){var r=n(1),o=n(436);r({target:"Array",proto:!0,forced:o!==[].lastIndexOf},{lastIndexOf:o});},function(e,t,n){"use strict";var r=n(64),o=n(38),i=n(95),s=n(40),a=n(80),c=Math.min,u=[].lastIndexOf,l=!!u&&1/[1].lastIndexOf(1,-0)<0,m=a("lastIndexOf"),p=l||!m;e.exports=p?function(e){if(l)return r(u,this,arguments)||0;var t=o(this),n=s(t),a=n-1;for(arguments.length>1&&(a=c(a,i(arguments[1]))),a<0&&(a=n+a);a>=0;a--){if(a in t&&t[a]===e)return a||0;}return-1;}:u;},function(e,t,n){n(239);var r=n(11);e.exports=r.setTimeout;},function(e,t,n){var r=n(1),o=n(12),i=n(240)(o.setInterval,!0);r({global:!0,bind:!0,forced:o.setInterval!==i},{setInterval:i});},function(e,t){e.exports="function"==typeof Bun&&Bun&&"string"==typeof Bun.version;},function(e,t,n){var r=n(1),o=n(12),i=n(240)(o.setTimeout,!0);r({global:!0,bind:!0,forced:o.setTimeout!==i},{setTimeout:i});},function(e,t,n){var r=n(442);e.exports=r;},function(e,t,n){var r=n(19),o=n(443),i=Array.prototype;e.exports=function(e){var t=e.filter;return e===i||r(i,e)&&t===i.filter?o:t;};},function(e,t,n){n(444);var r=n(24);e.exports=r("Array").filter;},function(e,t,n){"use strict";var r=n(1),o=n(89).filter;r({target:"Array",proto:!0,forced:!n(96)("filter")},{filter:function filter(e){return o(this,e,arguments.length>1?arguments[1]:void 0);}});},function(e,t,n){e.exports=n(446);},function(e,t,n){n(69);var r=n(52),o=n(26),i=n(19),s=n(447),a=Array.prototype,c={DOMTokenList:!0,NodeList:!0};e.exports=function(e){var t=e.values;return e===a||i(a,e)&&t===a.values||o(c,r(e))?s:t;};},function(e,t,n){var r=n(448);e.exports=r;},function(e,t,n){n(84),n(97);var r=n(24);e.exports=r("Array").values;},function(e,t,n){n(124),n(450);var r=n(11);e.exports=r.Array.from;},function(e,t,n){var r=n(1),o=n(451);r({target:"Array",stat:!0,forced:!n(230)(function(e){Array.from(e);})},{from:o});},function(e,t,n){"use strict";var r=n(79),o=n(25),i=n(37),s=n(452),a=n(220),c=n(116),u=n(40),l=n(81),m=n(221),p=n(125),d=Array;e.exports=function(e){var t=i(e),n=c(this),f=arguments.length,g=f>1?arguments[1]:void 0,h=void 0!==g;h&&(g=r(g,f>2?arguments[2]:void 0));var y,v,b,T,S,M,k=p(t),x=0;if(!k||this===d&&a(k))for(y=u(t),v=n?new this(y):d(y);y>x;x++){M=h?g(t[x],x):t[x],l(v,x,M);}else for(S=(T=m(t,k)).next,v=n?new this():[];!(b=o(S,T)).done;x++){M=h?s(T,g,[b.value,x],!0):b.value,l(v,x,M);}return v.length=x,v;};},function(e,t,n){var r=n(33),o=n(222);e.exports=function(e,t,n,i){try{return i?t(r(n)[0],n[1]):t(n);}catch(t){o(e,"throw",t);}};},function(e,t,n){e.exports=n(454);},function(e,t,n){var r=n(455);e.exports=r;},function(e,t,n){var r=n(456);e.exports=r;},function(e,t,n){var r=n(457);n(69),e.exports=r;},function(e,t,n){n(84),n(124);var r=n(125);e.exports=r;},function(e,t,n){n(203);var r=n(11);e.exports=r.Object.getOwnPropertySymbols;},function(e,t,n){var r=n(460);e.exports=r;},function(e,t,n){n(461);var r=n(11).Object,o=e.exports=function(e,t){return r.getOwnPropertyDescriptor(e,t);};r.getOwnPropertyDescriptor.sham&&(o.sham=!0);},function(e,t,n){var r=n(1),o=n(8),i=n(38),s=n(75).f,a=n(28),c=o(function(){s(1);});r({target:"Object",stat:!0,forced:!a||c,sham:!a},{getOwnPropertyDescriptor:function getOwnPropertyDescriptor(e,t){return s(i(e),t);}});},function(e,t,n){var r=n(463);e.exports=r;},function(e,t,n){n(464);var r=n(11);e.exports=r.Object.getOwnPropertyDescriptors;},function(e,t,n){var r=n(1),o=n(28),i=n(219),s=n(38),a=n(75),c=n(81);r({target:"Object",stat:!0,sham:!o},{getOwnPropertyDescriptors:function getOwnPropertyDescriptors(e){for(var t,n,r=s(e),o=a.f,u=i(r),l={},m=0;u.length>m;){void 0!==(n=o(r,t=u[m++]))&&c(l,t,n);}return l;}});},function(e,t,n){var r=n(466);e.exports=r;},function(e,t,n){n(467);var r=n(11).Object,o=e.exports=function(e,t){return r.defineProperties(e,t);};r.defineProperties.sham&&(o.sham=!0);},function(e,t,n){var r=n(1),o=n(28),i=n(154).f;r({target:"Object",stat:!0,forced:Object.defineProperties!==i,sham:!o},{defineProperties:i});},function(e,t,n){var r=n(14);"undefined"!=typeof window&&(window.console||r.isWeixinApp||(window.console={log:function log(){},info:function info(){},warn:function warn(){},error:function error(){}}));},function(e,t,n){var r=n(470);e.exports=function(e){return r(e,5);};},function(e,t,n){var r=n(471),o=n(501),i=n(247),s=n(503),a=n(513),c=n(516),u=n(517),l=n(518),m=n(520),p=n(521),d=n(522),f=n(168),g=n(527),h=n(528),y=n(534),v=n(162),b=n(250),T=n(536),S=n(104),M=n(538),k=n(161),x=n(166),C={};C["[object Arguments]"]=C["[object Array]"]=C["[object ArrayBuffer]"]=C["[object DataView]"]=C["[object Boolean]"]=C["[object Date]"]=C["[object Float32Array]"]=C["[object Float64Array]"]=C["[object Int8Array]"]=C["[object Int16Array]"]=C["[object Int32Array]"]=C["[object Map]"]=C["[object Number]"]=C["[object Object]"]=C["[object RegExp]"]=C["[object Set]"]=C["[object String]"]=C["[object Symbol]"]=C["[object Uint8Array]"]=C["[object Uint8ClampedArray]"]=C["[object Uint16Array]"]=C["[object Uint32Array]"]=!0,C["[object Error]"]=C["[object Function]"]=C["[object WeakMap]"]=!1,e.exports=function e(t,n,I,_,w,P){var A,O=1&n,E=2&n,R=4&n;if(I&&(A=w?I(t,_,w,P):I(t)),void 0!==A)return A;if(!S(t))return t;var j=v(t);if(j){if(A=g(t),!O)return u(t,A);}else{var N=f(t),U="[object Function]"==N||"[object GeneratorFunction]"==N;if(b(t))return c(t,O);if("[object Object]"==N||"[object Arguments]"==N||U&&!w){if(A=E||U?{}:y(t),!O)return E?m(t,a(A,t)):l(t,s(A,t));}else{if(!C[N])return w?t:{};A=h(t,N,O);}}P||(P=new r());var D=P.get(t);if(D)return D;P.set(t,A),M(t)?t.forEach(function(r){A.add(e(r,n,I,r,t,P));}):T(t)&&t.forEach(function(r,o){A.set(o,e(r,n,I,o,t,P));});var L=j?void 0:(R?E?d:p:E?x:k)(t);return o(L||t,function(r,o){L&&(r=t[o=r]),i(A,o,e(r,n,I,o,t,P));}),A;};},function(e,t,n){var r=n(129),o=n(477),i=n(478),s=n(479),a=n(480),c=n(481);function u(e){var t=this.__data__=new r(e);this.size=t.size;}u.prototype.clear=o,u.prototype.delete=i,u.prototype.get=s,u.prototype.has=a,u.prototype.set=c,e.exports=u;},function(e,t){e.exports=function(){this.__data__=[],this.size=0;};},function(e,t,n){var r=n(130),o=Array.prototype.splice;e.exports=function(e){var t=this.__data__,n=r(t,e);return!(n<0)&&(n==t.length-1?t.pop():o.call(t,n,1),--this.size,!0);};},function(e,t,n){var r=n(130);e.exports=function(e){var t=this.__data__,n=r(t,e);return n<0?void 0:t[n][1];};},function(e,t,n){var r=n(130);e.exports=function(e){return r(this.__data__,e)>-1;};},function(e,t,n){var r=n(130);e.exports=function(e,t){var n=this.__data__,o=r(n,e);return o<0?(++this.size,n.push([e,t])):n[o][1]=t,this;};},function(e,t,n){var r=n(129);e.exports=function(){this.__data__=new r(),this.size=0;};},function(e,t){e.exports=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n;};},function(e,t){e.exports=function(e){return this.__data__.get(e);};},function(e,t){e.exports=function(e){return this.__data__.has(e);};},function(e,t,n){var r=n(129),o=n(159),i=n(488);e.exports=function(e,t){var n=this.__data__;if(n instanceof r){var s=n.__data__;if(!o||s.length<199)return s.push([e,t]),this.size=++n.size,this;n=this.__data__=new i(s);}return n.set(e,t),this.size=n.size,this;};},function(e,t,n){var r=n(244),o=n(485),i=n(104),s=n(246),a=/^\[object .+?Constructor\]$/,c=Function.prototype,u=Object.prototype,l=c.toString,m=u.hasOwnProperty,p=RegExp("^"+l.call(m).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");e.exports=function(e){return!(!i(e)||o(e))&&(r(e)?p:a).test(s(e));};},function(e,t,n){var r=n(160),o=Object.prototype,i=o.hasOwnProperty,s=o.toString,a=r?r.toStringTag:void 0;e.exports=function(e){var t=i.call(e,a),n=e[a];try{e[a]=void 0;var r=!0;}catch(e){}var o=s.call(e);return r&&(t?e[a]=n:delete e[a]),o;};},function(e,t){var n=Object.prototype.toString;e.exports=function(e){return n.call(e);};},function(e,t,n){var r,o=n(486),i=(r=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||""))?"Symbol(src)_1."+r:"";e.exports=function(e){return!!i&&i in e;};},function(e,t,n){var r=n(45)["__core-js_shared__"];e.exports=r;},function(e,t){e.exports=function(e,t){return null==e?void 0:e[t];};},function(e,t,n){var r=n(489),o=n(496),i=n(498),s=n(499),a=n(500);function c(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1]);}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=s,c.prototype.set=a,e.exports=c;},function(e,t,n){var r=n(490),o=n(129),i=n(159);e.exports=function(){this.size=0,this.__data__={hash:new r(),map:new(i||o)(),string:new r()};};},function(e,t,n){var r=n(491),o=n(492),i=n(493),s=n(494),a=n(495);function c(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var r=e[t];this.set(r[0],r[1]);}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=s,c.prototype.set=a,e.exports=c;},function(e,t,n){var r=n(132);e.exports=function(){this.__data__=r?r(null):{},this.size=0;};},function(e,t){e.exports=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t;};},function(e,t,n){var r=n(132),o=Object.prototype.hasOwnProperty;e.exports=function(e){var t=this.__data__;if(r){var n=t[e];return"__lodash_hash_undefined__"===n?void 0:n;}return o.call(t,e)?t[e]:void 0;};},function(e,t,n){var r=n(132),o=Object.prototype.hasOwnProperty;e.exports=function(e){var t=this.__data__;return r?void 0!==t[e]:o.call(t,e);};},function(e,t,n){var r=n(132);e.exports=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=r&&void 0===t?"__lodash_hash_undefined__":t,this;};},function(e,t,n){var r=n(133);e.exports=function(e){var t=r(this,e).delete(e);return this.size-=t?1:0,t;};},function(e,t){e.exports=function(e){var t=typeof e==="undefined"?"undefined":_typeof(e);return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e;};},function(e,t,n){var r=n(133);e.exports=function(e){return r(this,e).get(e);};},function(e,t,n){var r=n(133);e.exports=function(e){return r(this,e).has(e);};},function(e,t,n){var r=n(133);e.exports=function(e,t){var n=r(this,e),o=n.size;return n.set(e,t),this.size+=n.size==o?0:1,this;};},function(e,t){e.exports=function(e,t){for(var n=-1,r=null==e?0:e.length;++n<r&&!1!==t(e[n],n,e);){}return e;};},function(e,t,n){var r=n(70),o=function(){try{var e=r(Object,"defineProperty");return e({},"",{}),e;}catch(e){}}();e.exports=o;},function(e,t,n){var r=n(134),o=n(161);e.exports=function(e,t){return e&&r(t,o(t),e);};},function(e,t){e.exports=function(e,t){for(var n=-1,r=Array(e);++n<e;){r[n]=t(n);}return r;};},function(e,t,n){var r=n(506),o=n(105),i=Object.prototype,s=i.hasOwnProperty,a=i.propertyIsEnumerable,c=r(function(){return arguments;}())?r:function(e){return o(e)&&s.call(e,"callee")&&!a.call(e,"callee");};e.exports=c;},function(e,t,n){var r=n(131),o=n(105);e.exports=function(e){return o(e)&&"[object Arguments]"==r(e);};},function(e,t){e.exports=function(){return!1;};},function(e,t){var n=/^(?:0|[1-9]\d*)$/;e.exports=function(e,t){var r=typeof e==="undefined"?"undefined":_typeof(e);return!!(t=null==t?9007199254740991:t)&&("number"==r||"symbol"!=r&&n.test(e))&&e>-1&&e%1==0&&e<t;};},function(e,t,n){var r=n(510),o=n(163),i=n(164),s=i&&i.isTypedArray,a=s?o(s):r;e.exports=a;},function(e,t,n){var r=n(131),o=n(251),i=n(105),s={};s["[object Float32Array]"]=s["[object Float64Array]"]=s["[object Int8Array]"]=s["[object Int16Array]"]=s["[object Int32Array]"]=s["[object Uint8Array]"]=s["[object Uint8ClampedArray]"]=s["[object Uint16Array]"]=s["[object Uint32Array]"]=!0,s["[object Arguments]"]=s["[object Array]"]=s["[object ArrayBuffer]"]=s["[object Boolean]"]=s["[object DataView]"]=s["[object Date]"]=s["[object Error]"]=s["[object Function]"]=s["[object Map]"]=s["[object Number]"]=s["[object Object]"]=s["[object RegExp]"]=s["[object Set]"]=s["[object String]"]=s["[object WeakMap]"]=!1,e.exports=function(e){return i(e)&&o(e.length)&&!!s[r(e)];};},function(e,t,n){var r=n(165),o=n(512),i=Object.prototype.hasOwnProperty;e.exports=function(e){if(!r(e))return o(e);var t=[];for(var n in Object(e)){i.call(e,n)&&"constructor"!=n&&t.push(n);}return t;};},function(e,t,n){var r=n(252)(Object.keys,Object);e.exports=r;},function(e,t,n){var r=n(134),o=n(166);e.exports=function(e,t){return e&&r(t,o(t),e);};},function(e,t,n){var r=n(104),o=n(165),i=n(515),s=Object.prototype.hasOwnProperty;e.exports=function(e){if(!r(e))return i(e);var t=o(e),n=[];for(var a in e){("constructor"!=a||!t&&s.call(e,a))&&n.push(a);}return n;};},function(e,t){e.exports=function(e){var t=[];if(null!=e)for(var n in Object(e)){t.push(n);}return t;};},function(e,t,n){(function(e){var r=n(45),o=t&&!t.nodeType&&t,i=o&&"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e&&!e.nodeType&&e,s=i&&i.exports===o?r.Buffer:void 0,a=s?s.allocUnsafe:void 0;e.exports=function(e,t){if(t)return e.slice();var n=e.length,r=a?a(n):new e.constructor(n);return e.copy(r),r;};}).call(this,n(135)(e));},function(e,t){e.exports=function(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;){t[n]=e[n];}return t;};},function(e,t,n){var r=n(134),o=n(167);e.exports=function(e,t){return r(e,o(e),t);};},function(e,t){e.exports=function(e,t){for(var n=-1,r=null==e?0:e.length,o=0,i=[];++n<r;){var s=e[n];t(s,n,e)&&(i[o++]=s);}return i;};},function(e,t,n){var r=n(134),o=n(255);e.exports=function(e,t){return r(e,o(e),t);};},function(e,t,n){var r=n(258),o=n(167),i=n(161);e.exports=function(e){return r(e,i,o);};},function(e,t,n){var r=n(258),o=n(255),i=n(166);e.exports=function(e){return r(e,i,o);};},function(e,t,n){var r=n(70)(n(45),"DataView");e.exports=r;},function(e,t,n){var r=n(70)(n(45),"Promise");e.exports=r;},function(e,t,n){var r=n(70)(n(45),"Set");e.exports=r;},function(e,t,n){var r=n(70)(n(45),"WeakMap");e.exports=r;},function(e,t){var n=Object.prototype.hasOwnProperty;e.exports=function(e){var t=e.length,r=new e.constructor(t);return t&&"string"==typeof e[0]&&n.call(e,"index")&&(r.index=e.index,r.input=e.input),r;};},function(e,t,n){var r=n(169),o=n(530),i=n(531),s=n(532),a=n(533);e.exports=function(e,t,n){var c=e.constructor;switch(t){case"[object ArrayBuffer]":return r(e);case"[object Boolean]":case"[object Date]":return new c(+e);case"[object DataView]":return o(e,n);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return a(e,n);case"[object Map]":return new c();case"[object Number]":case"[object String]":return new c(e);case"[object RegExp]":return i(e);case"[object Set]":return new c();case"[object Symbol]":return s(e);}};},function(e,t,n){var r=n(45).Uint8Array;e.exports=r;},function(e,t,n){var r=n(169);e.exports=function(e,t){var n=t?r(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength);};},function(e,t){var n=/\w*$/;e.exports=function(e){var t=new e.constructor(e.source,n.exec(e));return t.lastIndex=e.lastIndex,t;};},function(e,t,n){var r=n(160),o=r?r.prototype:void 0,i=o?o.valueOf:void 0;e.exports=function(e){return i?Object(i.call(e)):{};};},function(e,t,n){var r=n(169);e.exports=function(e,t){var n=t?r(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length);};},function(e,t,n){var r=n(535),o=n(257),i=n(165);e.exports=function(e){return"function"!=typeof e.constructor||i(e)?{}:r(o(e));};},function(e,t,n){var r=n(104),o=Object.create,i=function(){function e(){}return function(t){if(!r(t))return{};if(o)return o(t);e.prototype=t;var n=new e();return e.prototype=void 0,n;};}();e.exports=i;},function(e,t,n){var r=n(537),o=n(163),i=n(164),s=i&&i.isMap,a=s?o(s):r;e.exports=a;},function(e,t,n){var r=n(168),o=n(105);e.exports=function(e){return o(e)&&"[object Map]"==r(e);};},function(e,t,n){var r=n(539),o=n(163),i=n(164),s=i&&i.isSet,a=s?o(s):r;e.exports=a;},function(e,t,n){var r=n(168),o=n(105);e.exports=function(e){return o(e)&&"[object Set]"==r(e);};},function(e,t,n){var r=n(2),o=n(5),i=n(4),s=n(88),a=n(10),c=n(16),u=n(9),l=n(3),m=n(73),p=n(0),d=n(14),f=n(41),g={};function h(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};!e.logLevel&&e.debug&&(e.logLevel="debug"),p.merge(this,{options:e,debugEnable:!1,api:"log",style:"color:blue;",logLevel:e.logLevel&&e.logLevel.toLowerCase()||"off",debug:p.emptyFunc,log:p.emptyFunc,info:p.emptyFunc,warn:p.emptyFunc,error:p.emptyFunc}),this.prefix=e.prefix||"",this.localEnable=g.enable&&e.dbLog&&e.account,this.setDebug(e.debug),this.localEnable&&(this._local=new g(e.account,e.expire),this._local.logError=this.error);}g=n(549);var y=h.prototype,v=["Chrome","Safari","Firefox"],b={debug:1e3,log:2e3,info:3e3,warn:4e3,error:5e3,off:6e3};function T(e){var t,n=[];return r(t=o(b)).call(t,function(t){b[t]>=b[e]&&n.push(t);}),n;}y.setDebug=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this;if(t.debugEnable=e||"debug"===t.logLevel,e.style&&(t.style=e.style),p.exist(console))if("off"!==t.logLevel){var n=console,o=T(t.logLevel);r(o).call(o,function(e){t[e]=function(){var n=t.formatArgsAndSave(arguments,e);-1!==i(v).call(v,m.name)&&p.isString(n[0])&&(n[0]="%c"+n[0],s(n).call(n,1,0,t.style)),t._log(e,n);};}),t.options.logFunc?t._log=function(){}:t._log=function(e,r){if("debug"===e&&(e="log"),n[e])try{n[e].apply?t.chrome(e,r):t.ie(e,r);}catch(e){}},t.chrome=function(e,r){-1!==i(v).call(v,m.name)?n[e].apply(n,r):t.ie(e,r);},t.ie=function(e,t){r(t).call(t,function(t){n[e](a(t,null,4));});};}else if(d.isRN||this.localEnable||this.options.logFunc){var c=!d.isRN&&!this.localEnable;t.log=function(){t.formatArgsAndSave(arguments,"log",c);},t.info=function(){t.formatArgsAndSave(arguments,"info",c);},t.warn=function(){t.formatArgsAndSave(arguments,"warn",c);},t.error=function(){t.formatArgsAndSave(arguments,"error",c);},t.debug=function(){t.formatArgsAndSave(arguments,"error",c);};}},y.setLogDisabled=function(){this.localEnable=!1,this.log=function(){},this.info=function(){},this.warn=function(){},this.error=function(){},this.debug=function(){};},y.formatArgsAndSave=function(e,t,n){var o,i;e=c([]).call(e,0);var l=new Date(),m=S(l.getMonth()+1)+"-"+S(l.getDate())+" "+S(l.getHours())+":"+S(l.getMinutes())+":"+S(l.getSeconds())+":"+S(l.getMilliseconds(),3),d=u(o=u(i="[NIM ".concat(t.toUpperCase()," ")).call(i,m," ")).call(o,this.prefix.toUpperCase(),"]  "),f="";p.isString(e[0])?e[0]=d+e[0]:s(e).call(e,0,0,d),r(e).call(e,function(t,n){p.isArray(t)||p.isObject(t)?(e[n]=p.simpleClone(t),f+=a(e[n])+" "):f+=t+" ";});var g=this.options.logFunc;return g&&p.isFunction(g[t])&&g[t].apply(g,e),!n&&this.writeLocalLog(f,t,+l),e;},y.writeLocalLog=d.isRN?function(e,t){if(!(f.rnfs&&f.rnfs.writeFile&&f.rnfs.appendFile&&f.rnfs.DocumentDirectoryPath))return;if(!/error|warn|info/.test(t))return;var n,r=f.rnfs,o=r.size/2-256;function i(e){return f.rnfs.DocumentDirectoryPath+"/nimlog_"+e+".log";}e+="\r\n",r.nimPromise=r.nimPromise.then(function(){return n=i(r.nimIndex),r.exists(n);}).then(function(t){return t?r.appendFile(n,e):r.writeFile(n,e);}).then(function(){return r.stat(n);}).then(function(e){if(e.size>o)return r.nimIndex++,r.nimIndex>1&&(r.nimIndex=r.nimIndex%2),r.unlink(i(r.nimIndex)).catch(function(){return l.resolve();});}).catch(function(){});}:d.isBrowser?function(e,t,n){this._local&&this._local.saveLog({log:e,level:t,time:n});}:function(){};var S=function S(e,t){t=t||2;for(var n=""+e;n.length<t;){n="0"+n;}return n;};e.exports=h;},function(e,t,n){var r=n(542);e.exports=r;},function(e,t,n){n(543);var r=n(11);e.exports=r.parseFloat;},function(e,t,n){var r=n(1),o=n(544);r({global:!0,forced:parseFloat!=o},{parseFloat:o});},function(e,t,n){var r=n(12),o=n(8),i=n(13),s=n(44),a=n(170).trim,c=n(136),u=i("".charAt),l=r.parseFloat,m=r.Symbol,p=m&&m.iterator,d=1/l(c+"-0")!=-1/0||p&&!o(function(){l(Object(p));});e.exports=d?function(e){var t=a(s(e)),n=l(t);return 0===n&&"-"==u(t,0)?-0:n;}:l;},function(e,t,n){var r=n(546);e.exports=r;},function(e,t,n){n(547);var r=n(11);e.exports=r.parseInt;},function(e,t,n){var r=n(1),o=n(548);r({global:!0,forced:parseInt!=o},{parseInt:o});},function(e,t,n){var r=n(12),o=n(8),i=n(13),s=n(44),a=n(170).trim,c=n(136),u=r.parseInt,l=r.Symbol,m=l&&l.iterator,p=/^[+-]?0x/i,d=i(p.exec),f=8!==u(c+"08")||22!==u(c+"0x16")||m&&!o(function(){u(Object(m));});e.exports=f?function(e,t){var n=a(s(e));return u(n,t>>>0||(d(p,n)?16:10));}:u;},function(e,t,n){var r=n(16),o=n(3),i=n(550),s=n(551),a=n(0).getGlobal(),c=n(73).name,u="function"==typeof i,l=a.indexedDB&&!/^(IE)$/.test(c);function m(e,t){this.logWorker=null,this.db=null,this.logQueue=[],this.callbackList=[],this.preTime=null,this.lastTime=+new Date(),this.initLogLocal({name:e,expire:t});}var p=m.prototype;m.enable=!0,p.saveLog=function(e){var t,n=this.logQueue.length,o=this.logQueue[n-1];e.time!==this.preTime?((this.logQueue.length>50||e.time-this.lastTime>6e4&&this.logQueue.length>0)&&(this.doSaveLog(r(t=this.logQueue).call(t,0)),this.lastTime=o.time,this.logQueue=[]),this.logQueue.push(e),this.preTime=e.time):o.log+="\r\n"+e.log;},p.doSaveLog=function(){},p.initLogLocal=function(){},p.fetchLog=function(){},p.deleteLogs=function(){},p.logError=function(){},l?u?(p.doSaveLog=function(e){this.logWorker.postMessage(e);},p.initLogLocal=function(e){var t=this;this.logWorker=new i({}),this.logWorker.onmessage=function(e){var n=e.data||{};switch(n.type){case"fetchDone":t.fetchLogDone(n.code,n.msg);break;case"error":t.logError(n.msg);}},this.logWorker.postMessage({type:"init",msg:e});},p.fetchLog=function(){var e=this;return new o(function(t,n){0===e.callbackList.length&&e.logWorker.postMessage({type:"fetch"}),e.callbackList.push(t),e.callbackList.push(n);});},p.fetchLogDone=function(e,t){for(var n=200===e?0:1,r=0;r<this.callbackList.length/2;r++){this.callbackList[2*r+n](t);}this.callbackList=[];},p.deleteLogs=function(e){return this.logWorker.postMessage({type:"delete",msg:e}),o.resolve();}):(p.doSaveLog=function(e){var t=this;this.db.putLog(e).catch(function(e){t.logError({msg:"putLog error",error:e});});},p.initLogLocal=function(e){var t=this;this.db=new s(e),this.db.init().catch(function(e){t.logError({msg:"dbLog init error",error:e});});},p.fetchLog=function(){return this.db.getAllLogs();},p.deleteLogs=function(e){return this.db.deleteLogs(e);}):m.enable=!1,e.exports=m;},function(e,t,n){"use strict";n.r(t),n.d(t,"default",function(){return i;});var r=n(278),o=n.n(r);function i(){return o()("/*!\n * \n * VERSION: 9.11.0\n * Git Hash: a84f700ec8976b6d2b9dbf8fe2912c258aff0916\n * \n * Create At: 2023/5/26 \u4E0B\u53483:40:38\n * \n * Target: NIM_Web_log.worker\n */!function(t){var n={};function r(e){if(n[e])return n[e].exports;var o=n[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,r),o.l=!0,o.exports}r.m=t,r.c=n,r.d=function(t,n,e){r.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:e})},r.r=function(t){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(t,\"__esModule\",{value:!0})},r.t=function(t,n){if(1&n&&(t=r(t)),8&n)return t;if(4&n&&\"object\"==typeof t&&t&&t.__esModule)return t;var e=Object.create(null);if(r.r(e),Object.defineProperty(e,\"default\",{enumerable:!0,value:t}),2&n&&\"string\"!=typeof t)for(var o in t)r.d(e,o,function(n){return t[n]}.bind(null,o));return e},r.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(n,\"a\",n),n},r.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},r.p=\"\",r(r.s=107)}([function(t,n,r){\"use strict\";var e=r(4),o=r(55),i=r(78),c=r(2),u=r(41).f,a=r(84),f=r(16),s=r(33),p=r(19),l=r(8),v=function(t){var n=function(r,e,i){if(this instanceof n){switch(arguments.length){case 0:return new t;case 1:return new t(r);case 2:return new t(r,e)}return new t(r,e,i)}return o(t,this,arguments)};return n.prototype=t.prototype,n};t.exports=function(t,n){var r,o,d,y,h,m,g,x,b,w=t.target,S=t.global,j=t.stat,O=t.proto,P=S?e:j?e[w]:(e[w]||{}).prototype,E=S?f:f[w]||p(f,w,{})[w],T=E.prototype;for(y in n)o=!(r=a(S?y:w+(j?\".\":\"#\")+y,t.forced))&&P&&l(P,y),m=E[y],o&&(g=t.dontCallGetSet?(b=u(P,y))&&b.value:P[y]),h=o&&g?g:n[y],o&&typeof m==typeof h||(x=t.bind&&o?s(h,e):t.wrap&&o?v(h):O&&c(h)?i(h):h,(t.sham||h&&h.sham||m&&m.sham)&&p(x,\"sham\",!0),p(E,y,x),O&&(l(f,d=w+\"Prototype\")||p(f,d,{}),p(f[d],y,h),t.real&&T&&(r||!T[y])&&p(T,y,h)))}},function(t,n,r){var e=r(16),o=r(8),i=r(75),c=r(15).f;t.exports=function(t){var n=e.Symbol||(e.Symbol={});o(n,t)||c(n,t,{value:i.f(t)})}},function(t,n,r){var e=r(79),o=e.all;t.exports=e.IS_HTMLDDA?function(t){return\"function\"==typeof t||t===o}:function(t){return\"function\"==typeof t}},function(t,n,r){var e=r(4),o=r(32),i=r(8),c=r(59),u=r(24),a=r(82),f=o(\"wks\"),s=e.Symbol,p=s&&s.for,l=a?s:s&&s.withoutSetter||c;t.exports=function(t){if(!i(f,t)||!u&&\"string\"!=typeof f[t]){var n=\"Symbol.\"+t;u&&i(s,t)?f[t]=s[t]:f[t]=a&&p?p(n):l(n)}return f[t]}},function(t,n,r){(function(n){var r=function(t){return t&&t.Math==Math&&t};t.exports=r(\"object\"==typeof globalThis&&globalThis)||r(\"object\"==typeof window&&window)||r(\"object\"==typeof self&&self)||r(\"object\"==typeof n&&n)||function(){return this}()||Function(\"return this\")()}).call(this,r(77))},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n,r){var e=r(40),o=Function.prototype,i=o.call,c=e&&o.bind.bind(i,i);t.exports=e?c:function(t){return function(){return i.apply(t,arguments)}}},function(t,n,r){var e=r(40),o=Function.prototype.call;t.exports=e?o.bind(o):function(){return o.apply(o,arguments)}},function(t,n,r){var e=r(6),o=r(25),i=e({}.hasOwnProperty);t.exports=Object.hasOwn||function(t,n){return i(o(t),n)}},function(t,n,r){var e=r(16),o=r(4),i=r(2),c=function(t){return i(t)?t:void 0};t.exports=function(t,n){return arguments.length<2?c(e[t])||c(o[t]):e[t]&&e[t][n]||o[t]&&o[t][n]}},function(t,n,r){var e=r(2),o=r(79),i=o.all;t.exports=o.IS_HTMLDDA?function(t){return\"object\"==typeof t?null!==t:e(t)||t===i}:function(t){return\"object\"==typeof t?null!==t:e(t)}},function(t,n,r){var e=r(5);t.exports=!e((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},function(t,n,r){var e=r(10),o=String,i=TypeError;t.exports=function(t){if(e(t))return t;throw i(o(t)+\" is not an object\")}},function(t,n,r){var e=r(6);t.exports=e({}.isPrototypeOf)},function(t,n){t.exports=!0},function(t,n,r){var e=r(11),o=r(83),i=r(85),c=r(12),u=r(43),a=TypeError,f=Object.defineProperty,s=Object.getOwnPropertyDescriptor;n.f=e?i?function(t,n,r){if(c(t),n=u(n),c(r),\"function\"==typeof t&&\"prototype\"===n&&\"value\"in r&&\"writable\"in r&&!r.writable){var e=s(t,n);e&&e.writable&&(t[n]=r.value,r={configurable:\"configurable\"in r?r.configurable:e.configurable,enumerable:\"enumerable\"in r?r.enumerable:e.enumerable,writable:!1})}return f(t,n,r)}:f:function(t,n,r){if(c(t),n=u(n),c(r),o)try{return f(t,n,r)}catch(t){}if(\"get\"in r||\"set\"in r)throw a(\"Accessors not supported\");return\"value\"in r&&(t[n]=r.value),t}},function(t,n){t.exports={}},function(t,n,r){var e=r(2),o=r(31),i=TypeError;t.exports=function(t){if(e(t))return t;throw i(o(t)+\" is not a function\")}},function(t,n,r){var e=r(81),o=r(56);t.exports=function(t){return e(o(t))}},function(t,n,r){var e=r(11),o=r(15),i=r(20);t.exports=e?function(t,n,r){return o.f(t,n,i(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(19);t.exports=function(t,n,r,o){return o&&o.enumerable?t[n]=r:e(t,n,r),t}},function(t,n,r){\"use strict\";var e=r(17),o=TypeError,i=function(t){var n,r;this.promise=new t((function(t,e){if(void 0!==n||void 0!==r)throw o(\"Bad Promise constructor\");n=t,r=e})),this.resolve=e(n),this.reject=e(r)};t.exports.f=function(t){return new i(t)}},function(t,n,r){var e=r(6),o=e({}.toString),i=e(\"\".slice);t.exports=function(t){return i(o(t),8,-1)}},function(t,n,r){var e=r(45),o=r(5);t.exports=!!Object.getOwnPropertySymbols&&!o((function(){var t=Symbol();return!String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&e&&e<41}))},function(t,n,r){var e=r(56),o=Object;t.exports=function(t){return o(e(t))}},function(t,n,r){var e=r(122);t.exports=function(t){return e(t.length)}},function(t,n){t.exports={}},function(t,n,r){var e=r(69),o=r(2),i=r(23),c=r(3)(\"toStringTag\"),u=Object,a=\"Arguments\"==i(function(){return arguments}());t.exports=e?i:function(t){var n,r,e;return void 0===t?\"Undefined\":null===t?\"Null\":\"string\"==typeof(r=function(t,n){try{return t[n]}catch(t){}}(n=u(t),c))?r:a?i(n):\"Object\"==(e=i(n))&&o(n.callee)?\"Arguments\":e}},function(t,n,r){var e=r(69),o=r(15).f,i=r(19),c=r(8),u=r(134),a=r(3)(\"toStringTag\");t.exports=function(t,n,r,f){if(t){var s=r?t:t.prototype;c(s,a)||o(s,a,{configurable:!0,value:n}),f&&!e&&i(s,\"toString\",u)}}},function(t,n,r){var e=r(4);t.exports=e.Promise},function(t,n){var r=String;t.exports=function(t){try{return r(t)}catch(t){return\"Object\"}}},function(t,n,r){var e=r(14),o=r(58);(t.exports=function(t,n){return o[t]||(o[t]=void 0!==n?n:{})})(\"versions\",[]).push({version:\"3.27.1\",mode:e?\"pure\":\"global\",copyright:\"\xA9 2014-2022 Denis Pushkarev (zloirock.ru)\",license:\"https://github.com/zloirock/core-js/blob/v3.27.1/LICENSE\",source:\"https://github.com/zloirock/core-js\"})},function(t,n,r){var e=r(78),o=r(17),i=r(40),c=e(e.bind);t.exports=function(t,n){return o(t),void 0===n?t:i?c(t,n):function(){return t.apply(n,arguments)}}},function(t,n,r){var e=r(33),o=r(7),i=r(12),c=r(31),u=r(125),a=r(26),f=r(13),s=r(126),p=r(89),l=r(127),v=TypeError,d=function(t,n){this.stopped=t,this.result=n},y=d.prototype;t.exports=function(t,n,r){var h,m,g,x,b,w,S,j=r&&r.that,O=!(!r||!r.AS_ENTRIES),P=!(!r||!r.IS_RECORD),E=!(!r||!r.IS_ITERATOR),T=!(!r||!r.INTERRUPTED),A=e(n,j),k=function(t){return h&&l(h,\"normal\",t),new d(!0,t)},D=function(t){return O?(i(t),T?A(t[0],t[1],k):A(t[0],t[1])):T?A(t,k):A(t)};if(P)h=t.iterator;else if(E)h=t;else{if(!(m=p(t)))throw v(c(t)+\" is not iterable\");if(u(m)){for(g=0,x=a(t);x>g;g++)if((b=D(t[g]))&&f(y,b))return b;return new d(!1)}h=s(t,m)}for(w=P?t.next:h.next;!(S=o(w,h)).done;){try{b=D(S.value)}catch(t){l(h,\"throw\",t)}if(\"object\"==typeof b&&b&&f(y,b))return b}return new d(!1)}},function(t,n,r){var e=r(28),o=String;t.exports=function(t){if(\"Symbol\"===e(t))throw TypeError(\"Cannot convert a Symbol value to a string\");return o(t)}},function(t,n){t.exports=function(t){try{return{error:!1,value:t()}}catch(t){return{error:!0,value:t}}}},function(t,n,r){var e=r(4),o=r(30),i=r(2),c=r(84),u=r(94),a=r(3),f=r(146),s=r(97),p=r(14),l=r(45),v=o&&o.prototype,d=a(\"species\"),y=!1,h=i(e.PromiseRejectionEvent),m=c(\"Promise\",(function(){var t=u(o),n=t!==String(o);if(!n&&66===l)return!0;if(p&&(!v.catch||!v.finally))return!0;if(!l||l<51||!/native code/.test(t)){var r=new o((function(t){t(1)})),e=function(t){t((function(){}),(function(){}))};if((r.constructor={})[d]=e,!(y=r.then((function(){}))instanceof e))return!0}return!n&&(f||s)&&!h}));t.exports={CONSTRUCTOR:m,REJECTION_EVENT:h,SUBCLASSING:y}},function(t,n,r){var e=r(23);t.exports=Array.isArray||function(t){return\"Array\"==e(t)}},function(t,n,r){var e=r(16);t.exports=function(t){return e[t+\"Prototype\"]}},function(t,n,r){var e=r(5);t.exports=!e((function(){var t=function(){}.bind();return\"function\"!=typeof t||t.hasOwnProperty(\"prototype\")}))},function(t,n,r){var e=r(11),o=r(7),i=r(80),c=r(20),u=r(18),a=r(43),f=r(8),s=r(83),p=Object.getOwnPropertyDescriptor;n.f=e?p:function(t,n){if(t=u(t),n=a(n),s)try{return p(t,n)}catch(t){}if(f(t,n))return c(!o(i.f,t,n),t[n])}},function(t,n){t.exports=function(t){return null==t}},function(t,n,r){var e=r(113),o=r(44);t.exports=function(t){var n=e(t,\"string\");return o(n)?n:n+\"\"}},function(t,n,r){var e=r(9),o=r(2),i=r(13),c=r(82),u=Object;t.exports=c?function(t){return\"symbol\"==typeof t}:function(t){var n=e(\"Symbol\");return o(n)&&i(n.prototype,u(t))}},function(t,n,r){var e,o,i=r(4),c=r(46),u=i.process,a=i.Deno,f=u&&u.versions||a&&a.version,s=f&&f.v8;s&&(o=(e=s.split(\".\"))[0]>0&&e[0]<4?1:+(e[0]+e[1])),!o&&c&&(!(e=c.match(/Edge\\/(\\d+)/))||e[1]>=74)&&(e=c.match(/Chrome\\/(\\d+)/))&&(o=+e[1]),t.exports=o},function(t,n,r){var e=r(9);t.exports=e(\"navigator\",\"userAgent\")||\"\"},function(t,n,r){var e=r(32),o=r(59),i=e(\"keys\");t.exports=function(t){return i[t]||(i[t]=o(t))}},function(t,n){t.exports={}},function(t,n,r){var e,o=r(12),i=r(87),c=r(66),u=r(48),a=r(88),f=r(60),s=r(47),p=s(\"IE_PROTO\"),l=function(){},v=function(t){return\"<script>\"+t+\"<\\/script>\"},d=function(t){t.write(v(\"\")),t.close();var n=t.parentWindow.Object;return t=null,n},y=function(){try{e=new ActiveXObject(\"htmlfile\")}catch(t){}var t,n;y=\"undefined\"!=typeof document?document.domain&&e?d(e):((n=f(\"iframe\")).style.display=\"none\",a.appendChild(n),n.src=String(\"javascript:\"),(t=n.contentWindow.document).open(),t.write(v(\"document.F=Object\")),t.close(),t.F):d(e);for(var r=c.length;r--;)delete y.prototype[c[r]];return y()};u[p]=!0,t.exports=Object.create||function(t,n){var r;return null!==t?(l.prototype=o(t),r=new l,l.prototype=null,r[p]=t):r=y(),void 0===n?r:i.f(r,n)}},function(t,n,r){var e,o,i,c=r(131),u=r(4),a=r(10),f=r(19),s=r(8),p=r(58),l=r(47),v=r(48),d=u.TypeError,y=u.WeakMap;if(c||p.state){var h=p.state||(p.state=new y);h.get=h.get,h.has=h.has,h.set=h.set,e=function(t,n){if(h.has(t))throw d(\"Object already initialized\");return n.facade=t,h.set(t,n),n},o=function(t){return h.get(t)||{}},i=function(t){return h.has(t)}}else{var m=l(\"state\");v[m]=!0,e=function(t,n){if(s(t,m))throw d(\"Object already initialized\");return n.facade=t,f(t,m,n),n},o=function(t){return s(t,m)?t[m]:{}},i=function(t){return s(t,m)}}t.exports={set:e,get:o,has:i,enforce:function(t){return i(t)?o(t):e(t,{})},getterFor:function(t){return function(n){var r;if(!a(n)||(r=o(n)).type!==t)throw d(\"Incompatible receiver, \"+t+\" required\");return r}}}},function(t,n,r){var e=r(23),o=r(4);t.exports=\"process\"==e(o.process)},function(t,n,r){r(70);var e=r(157),o=r(4),i=r(28),c=r(19),u=r(27),a=r(3)(\"toStringTag\");for(var f in e){var s=o[f],p=s&&s.prototype;p&&i(p)!==a&&c(p,a,f),u[f]=u.Array}},function(t,n,r){var e=r(5),o=r(3),i=r(45),c=o(\"species\");t.exports=function(t){return i>=51||!e((function(){var n=[];return(n.constructor={})[c]=function(){return{foo:1}},1!==n[t](Boolean).foo}))}},function(t,n,r){var e=r(33),o=r(6),i=r(81),c=r(25),u=r(26),a=r(102),f=o([].push),s=function(t){var n=1==t,r=2==t,o=3==t,s=4==t,p=6==t,l=7==t,v=5==t||p;return function(d,y,h,m){for(var g,x,b=c(d),w=i(b),S=e(y,h),j=u(w),O=0,P=m||a,E=n?P(d,j):r||l?P(d,0):void 0;j>O;O++)if((v||O in w)&&(x=S(g=w[O],O,b),t))if(n)E[O]=x;else if(x)switch(t){case 3:return!0;case 5:return g;case 6:return O;case 2:f(E,g)}else switch(t){case 4:return!1;case 7:f(E,g)}return p?-1:o||s?s:E}};t.exports={forEach:s(0),map:s(1),filter:s(2),some:s(3),every:s(4),find:s(5),findIndex:s(6),filterReject:s(7)}},function(t,n,r){var e=r(40),o=Function.prototype,i=o.apply,c=o.call;t.exports=\"object\"==typeof Reflect&&Reflect.apply||(e?c.bind(i):function(){return c.apply(i,arguments)})},function(t,n,r){var e=r(42),o=TypeError;t.exports=function(t){if(e(t))throw o(\"Can't call method on \"+t);return t}},function(t,n,r){var e=r(17),o=r(42);t.exports=function(t,n){var r=t[n];return o(r)?void 0:e(r)}},function(t,n,r){var e=r(4),o=r(115),i=e[\"__core-js_shared__\"]||o(\"__core-js_shared__\",{});t.exports=i},function(t,n,r){var e=r(6),o=0,i=Math.random(),c=e(1..toString);t.exports=function(t){return\"Symbol(\"+(void 0===t?\"\":t)+\")_\"+c(++o+i,36)}},function(t,n,r){var e=r(4),o=r(10),i=e.document,c=o(i)&&o(i.createElement);t.exports=function(t){return c?i.createElement(t):{}}},function(t,n,r){var e=r(8),o=r(2),i=r(25),c=r(47),u=r(116),a=c(\"IE_PROTO\"),f=Object,s=f.prototype;t.exports=u?f.getPrototypeOf:function(t){var n=i(t);if(e(n,a))return n[a];var r=n.constructor;return o(r)&&n instanceof r?r.prototype:n instanceof f?s:null}},function(t,n,r){var e=r(6),o=r(12),i=r(117);t.exports=Object.setPrototypeOf||(\"__proto__\"in{}?function(){var t,n=!1,r={};try{(t=e(Object.getOwnPropertyDescriptor(Object.prototype,\"__proto__\").set))(r,[]),n=r instanceof Array}catch(t){}return function(r,e){return o(r),i(e),n?t(r,e):r.__proto__=e,r}}():void 0)},function(t,n,r){var e=r(86),o=r(66).concat(\"length\",\"prototype\");n.f=Object.getOwnPropertyNames||function(t){return e(t,o)}},function(t,n,r){var e=r(65),o=Math.max,i=Math.min;t.exports=function(t,n){var r=e(t);return r<0?o(r+n,0):i(r,n)}},function(t,n,r){var e=r(121);t.exports=function(t){var n=+t;return n!=n||0===n?0:e(n)}},function(t,n){t.exports=[\"constructor\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"toLocaleString\",\"toString\",\"valueOf\"]},function(t,n){n.f=Object.getOwnPropertySymbols},function(t,n,r){var e=r(86),o=r(66);t.exports=Object.keys||function(t){return e(t,o)}},function(t,n,r){var e={};e[r(3)(\"toStringTag\")]=\"z\",t.exports=\"[object z]\"===String(e)},function(t,n,r){\"use strict\";var e=r(18),o=r(130),i=r(27),c=r(50),u=r(15).f,a=r(90),f=r(92),s=r(14),p=r(11),l=c.set,v=c.getterFor(\"Array Iterator\");t.exports=a(Array,\"Array\",(function(t,n){l(this,{type:\"Array Iterator\",target:e(t),index:0,kind:n})}),(function(){var t=v(this),n=t.target,r=t.kind,e=t.index++;return!n||e>=n.length?(t.target=void 0,f(void 0,!0)):f(\"keys\"==r?e:\"values\"==r?n[e]:[e,n[e]],!1)}),\"values\");var d=i.Arguments=i.Array;if(o(\"keys\"),o(\"values\"),o(\"entries\"),!s&&p&&\"values\"!==d.name)try{u(d,\"name\",{value:\"values\"})}catch(t){}},function(t,n){},function(t,n,r){var e=r(6),o=r(5),i=r(2),c=r(28),u=r(9),a=r(94),f=function(){},s=[],p=u(\"Reflect\",\"construct\"),l=/^\\s*(?:class|function)\\b/,v=e(l.exec),d=!l.exec(f),y=function(t){if(!i(t))return!1;try{return p(f,s,t),!0}catch(t){return!1}},h=function(t){if(!i(t))return!1;switch(c(t)){case\"AsyncFunction\":case\"GeneratorFunction\":case\"AsyncGeneratorFunction\":return!1}try{return d||!!v(l,a(t))}catch(t){return!0}};h.sham=!0,t.exports=!p||o((function(){var t;return y(y.call)||!y(Object)||!y((function(){t=!0}))||t}))?h:y},function(t,n,r){var e=r(6);t.exports=e([].slice)},function(t,n,r){\"use strict\";var e=r(43),o=r(15),i=r(20);t.exports=function(t,n,r){var c=e(n);c in t?o.f(t,c,i(0,r)):t[c]=r}},function(t,n,r){var e=r(3);n.f=e},function(t,n,r){t.exports=r(109)},function(t,n){var r;r=function(){return this}();try{r=r||new Function(\"return this\")()}catch(t){\"object\"==typeof window&&(r=window)}t.exports=r},function(t,n,r){var e=r(23),o=r(6);t.exports=function(t){if(\"Function\"===e(t))return o(t)}},function(t,n){var r=\"object\"==typeof document&&document.all,e=void 0===r&&void 0!==r;t.exports={all:r,IS_HTMLDDA:e}},function(t,n,r){\"use strict\";var e={}.propertyIsEnumerable,o=Object.getOwnPropertyDescriptor,i=o&&!e.call({1:2},1);n.f=i?function(t){var n=o(this,t);return!!n&&n.enumerable}:e},function(t,n,r){var e=r(6),o=r(5),i=r(23),c=Object,u=e(\"\".split);t.exports=o((function(){return!c(\"z\").propertyIsEnumerable(0)}))?function(t){return\"String\"==i(t)?u(t,\"\"):c(t)}:c},function(t,n,r){var e=r(24);t.exports=e&&!Symbol.sham&&\"symbol\"==typeof Symbol.iterator},function(t,n,r){var e=r(11),o=r(5),i=r(60);t.exports=!e&&!o((function(){return 7!=Object.defineProperty(i(\"div\"),\"a\",{get:function(){return 7}}).a}))},function(t,n,r){var e=r(5),o=r(2),i=/#|\\.prototype\\./,c=function(t,n){var r=a[u(t)];return r==s||r!=f&&(o(n)?e(n):!!n)},u=c.normalize=function(t){return String(t).replace(i,\".\").toLowerCase()},a=c.data={},f=c.NATIVE=\"N\",s=c.POLYFILL=\"P\";t.exports=c},function(t,n,r){var e=r(11),o=r(5);t.exports=e&&o((function(){return 42!=Object.defineProperty((function(){}),\"prototype\",{value:42,writable:!1}).prototype}))},function(t,n,r){var e=r(6),o=r(8),i=r(18),c=r(120).indexOf,u=r(48),a=e([].push);t.exports=function(t,n){var r,e=i(t),f=0,s=[];for(r in e)!o(u,r)&&o(e,r)&&a(s,r);for(;n.length>f;)o(e,r=n[f++])&&(~c(s,r)||a(s,r));return s}},function(t,n,r){var e=r(11),o=r(85),i=r(15),c=r(12),u=r(18),a=r(68);n.f=e&&!o?Object.defineProperties:function(t,n){c(t);for(var r,e=u(n),o=a(n),f=o.length,s=0;f>s;)i.f(t,r=o[s++],e[r]);return t}},function(t,n,r){var e=r(9);t.exports=e(\"document\",\"documentElement\")},function(t,n,r){var e=r(28),o=r(57),i=r(42),c=r(27),u=r(3)(\"iterator\");t.exports=function(t){if(!i(t))return o(t,u)||o(t,\"@@iterator\")||c[e(t)]}},function(t,n,r){\"use strict\";var e=r(0),o=r(7),i=r(14),c=r(132),u=r(2),a=r(133),f=r(61),s=r(62),p=r(29),l=r(19),v=r(21),d=r(3),y=r(27),h=r(91),m=c.PROPER,g=c.CONFIGURABLE,x=h.IteratorPrototype,b=h.BUGGY_SAFARI_ITERATORS,w=d(\"iterator\"),S=function(){return this};t.exports=function(t,n,r,c,d,h,j){a(r,n,c);var O,P,E,T=function(t){if(t===d&&L)return L;if(!b&&t in D)return D[t];switch(t){case\"keys\":case\"values\":case\"entries\":return function(){return new r(this,t)}}return function(){return new r(this)}},A=n+\" Iterator\",k=!1,D=t.prototype,I=D[w]||D[\"@@iterator\"]||d&&D[d],L=!b&&I||T(d),_=\"Array\"==n&&D.entries||I;if(_&&(O=f(_.call(new t)))!==Object.prototype&&O.next&&(i||f(O)===x||(s?s(O,x):u(O[w])||v(O,w,S)),p(O,A,!0,!0),i&&(y[A]=S)),m&&\"values\"==d&&I&&\"values\"!==I.name&&(!i&&g?l(D,\"name\",\"values\"):(k=!0,L=function(){return o(I,this)})),d)if(P={values:T(\"values\"),keys:h?L:T(\"keys\"),entries:T(\"entries\")},j)for(E in P)(b||k||!(E in D))&&v(D,E,P[E]);else e({target:n,proto:!0,forced:b||k},P);return i&&!j||D[w]===L||v(D,w,L,{name:d}),y[n]=L,P}},function(t,n,r){\"use strict\";var e,o,i,c=r(5),u=r(2),a=r(10),f=r(49),s=r(61),p=r(21),l=r(3),v=r(14),d=l(\"iterator\"),y=!1;[].keys&&(\"next\"in(i=[].keys())?(o=s(s(i)))!==Object.prototype&&(e=o):y=!0),!a(e)||c((function(){var t={};return e[d].call(t)!==t}))?e={}:v&&(e=f(e)),u(e[d])||p(e,d,(function(){return this})),t.exports={IteratorPrototype:e,BUGGY_SAFARI_ITERATORS:y}},function(t,n){t.exports=function(t,n){return{value:t,done:n}}},function(t,n,r){var e=r(12),o=r(139),i=r(42),c=r(3)(\"species\");t.exports=function(t,n){var r,u=e(t).constructor;return void 0===u||i(r=e(u)[c])?n:o(r)}},function(t,n,r){var e=r(6),o=r(2),i=r(58),c=e(Function.toString);o(i.inspectSource)||(i.inspectSource=function(t){return c(t)}),t.exports=i.inspectSource},function(t,n,r){var e,o,i,c,u=r(4),a=r(55),f=r(33),s=r(2),p=r(8),l=r(5),v=r(88),d=r(73),y=r(60),h=r(140),m=r(96),g=r(51),x=u.setImmediate,b=u.clearImmediate,w=u.process,S=u.Dispatch,j=u.Function,O=u.MessageChannel,P=u.String,E=0,T={};try{e=u.location}catch(t){}var A=function(t){if(p(T,t)){var n=T[t];delete T[t],n()}},k=function(t){return function(){A(t)}},D=function(t){A(t.data)},I=function(t){u.postMessage(P(t),e.protocol+\"//\"+e.host)};x&&b||(x=function(t){h(arguments.length,1);var n=s(t)?t:j(t),r=d(arguments,1);return T[++E]=function(){a(n,void 0,r)},o(E),E},b=function(t){delete T[t]},g?o=function(t){w.nextTick(k(t))}:S&&S.now?o=function(t){S.now(k(t))}:O&&!m?(c=(i=new O).port2,i.port1.onmessage=D,o=f(c.postMessage,c)):u.addEventListener&&s(u.postMessage)&&!u.importScripts&&e&&\"file:\"!==e.protocol&&!l(I)?(o=I,u.addEventListener(\"message\",D,!1)):o=\"onreadystatechange\"in y(\"script\")?function(t){v.appendChild(y(\"script\")).onreadystatechange=function(){v.removeChild(this),A(t)}}:function(t){setTimeout(k(t),0)}),t.exports={set:x,clear:b}},function(t,n,r){var e=r(46);t.exports=/(?:ipad|iphone|ipod).*applewebkit/i.test(e)},function(t,n){t.exports=\"object\"==typeof Deno&&Deno&&\"object\"==typeof Deno.version},function(t,n,r){var e=r(30),o=r(148),i=r(37).CONSTRUCTOR;t.exports=i||!o((function(t){e.all(t).then(void 0,(function(){}))}))},function(t,n,r){var e=r(12),o=r(10),i=r(22);t.exports=function(t,n){if(e(t),o(n)&&n.constructor===t)return n;var r=i.f(t);return(0,r.resolve)(n),r.promise}},function(t,n,r){\"use strict\";var e=r(156).charAt,o=r(35),i=r(50),c=r(90),u=r(92),a=i.set,f=i.getterFor(\"String Iterator\");c(String,\"String\",(function(t){a(this,{type:\"String Iterator\",string:o(t),index:0})}),(function(){var t,n=f(this),r=n.string,o=n.index;return o>=r.length?u(void 0,!0):(t=e(r,o),n.index+=t.length,u(t,!1))}))},function(t,n,r){t.exports=r(158)},function(t,n,r){var e=r(167);t.exports=function(t,n){return new(e(t))(0===n?0:n)}},function(t,n,r){\"use strict\";var e=r(0),o=r(5),i=r(38),c=r(10),u=r(25),a=r(26),f=r(176),s=r(74),p=r(102),l=r(53),v=r(3),d=r(45),y=v(\"isConcatSpreadable\"),h=d>=51||!o((function(){var t=[];return t[y]=!1,t.concat()[0]!==t})),m=l(\"concat\"),g=function(t){if(!c(t))return!1;var n=t[y];return void 0!==n?!!n:i(t)};e({target:\"Array\",proto:!0,arity:1,forced:!h||!m},{concat:function(t){var n,r,e,o,i,c=u(this),l=p(c,0),v=0;for(n=-1,e=arguments.length;n<e;n++)if(g(i=-1===n?c:arguments[n]))for(o=a(i),f(v+o),r=0;r<o;r++,v++)r in i&&s(l,v,i[r]);else f(v+1),s(l,v++,i);return l.length=v,l}})},function(t,n,r){var e=r(7),o=r(9),i=r(3),c=r(21);t.exports=function(){var t=o(\"Symbol\"),n=t&&t.prototype,r=n&&n.valueOf,u=i(\"toPrimitive\");n&&!n[u]&&c(n,u,(function(t){return e(r,this)}),{arity:1})}},function(t,n,r){var e=r(24);t.exports=e&&!!Symbol.for&&!!Symbol.keyFor},function(t,n,r){r(1)(\"iterator\")},function(t,n,r){var e=r(108),o=null;function i(t){return t&&\"string\"!=typeof t?t.message?t.message:t.target&&t.target.error?t.target.error.message:\"unknown error\":t}self.onmessage=function(t){switch(t.data.type){case\"init\":r=t.data.msg,(o=new e(r)).init().catch((function(t){postMessage({type:\"error\",msg:{msg:\"dbLog init error\",error:i(t)}})}));break;case\"fetch\":o.getAllLogs().then((function(t){postMessage({type:\"fetchDone\",code:200,msg:t})})).catch((function(t){postMessage({type:\"fetchDone\",code:500,msg:i(t)})}));break;case\"delete\":o.deleteLogs(n).catch((function(t){postMessage({type:\"deleteLogs\",code:500,msg:i(t)})}));break;default:!function(t){if(!o)return;o.putLog(t).then((function(){postMessage(200)})).catch((function(t){postMessage({type:\"error\",msg:{msg:\"putLog error\",error:i(t)}})}))}(t.data)}var n,r}},function(t,n,r){var e=r(76),o=r(101),i=r(162),c=r(168),u={log:{key:{keyPath:\"time\"},indexes:{level:{unique:!1},time:{unique:!0}}}};function a(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.server=null,this.expire=t.expire||72,this.name=t.name}var f=a.prototype;f.init=function(){var t=this;if(!this.server)return c.open({server:\"nim-log-\"+this.name,version:1,schema:u}).then((function(n){t.server=n}))},f.putLog=function(t){var n=this;if(!this.server)return e.reject(\"no db server\");var r=o(t).call(t,-1)[0].time-36e5*this.expire;return this.deleteLogs(r).then((function(){return n.server.add(\"log\",t)}))},f.getAllLogs=function(){return this.server?this.server.query(\"log\",\"time\").all().execute().then((function(t){var n={},r=o(t).call(t,-1)[0];return n.logs=i(t).call(t,(function(t){return t.log})).join(\"\\r\\n\"),n.time=r&&r.time,n})):e.reject(\"no db server\")},f.deleteLogs=function(t){return this.server?this.server.remove(\"log\",null,\"time\",0,t):e.reject(\"no db server\")},t.exports=a},function(t,n,r){var e=r(110);r(52),t.exports=e},function(t,n,r){r(111),r(70),r(71),r(135),r(153),r(154),r(155),r(100);var e=r(16);t.exports=e.Promise},function(t,n,r){r(112)},function(t,n,r){\"use strict\";var e=r(0),o=r(13),i=r(61),c=r(62),u=r(118),a=r(49),f=r(19),s=r(20),p=r(123),l=r(124),v=r(34),d=r(128),y=r(3),h=r(129),m=y(\"toStringTag\"),g=Error,x=[].push,b=function(t,n){var r,e=arguments.length>2?arguments[2]:void 0,u=o(w,this);c?r=c(g(),u?i(this):w):(r=u?this:a(w),f(r,m,\"Error\")),void 0!==n&&f(r,\"message\",d(n)),h&&f(r,\"stack\",p(r.stack,1)),l(r,e);var s=[];return v(t,x,{that:s}),f(r,\"errors\",s),r};c?c(b,g):u(b,g,{name:!0});var w=b.prototype=a(g.prototype,{constructor:s(1,b),message:s(1,\"\"),name:s(1,\"AggregateError\")});e({global:!0,constructor:!0,arity:2},{AggregateError:b})},function(t,n,r){var e=r(7),o=r(10),i=r(44),c=r(57),u=r(114),a=r(3),f=TypeError,s=a(\"toPrimitive\");t.exports=function(t,n){if(!o(t)||i(t))return t;var r,a=c(t,s);if(a){if(void 0===n&&(n=\"default\"),r=e(a,t,n),!o(r)||i(r))return r;throw f(\"Can't convert object to primitive value\")}return void 0===n&&(n=\"number\"),u(t,n)}},function(t,n,r){var e=r(7),o=r(2),i=r(10),c=TypeError;t.exports=function(t,n){var r,u;if(\"string\"===n&&o(r=t.toString)&&!i(u=e(r,t)))return u;if(o(r=t.valueOf)&&!i(u=e(r,t)))return u;if(\"string\"!==n&&o(r=t.toString)&&!i(u=e(r,t)))return u;throw c(\"Can't convert object to primitive value\")}},function(t,n,r){var e=r(4),o=Object.defineProperty;t.exports=function(t,n){try{o(e,t,{value:n,configurable:!0,writable:!0})}catch(r){e[t]=n}return n}},function(t,n,r){var e=r(5);t.exports=!e((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype}))},function(t,n,r){var e=r(2),o=String,i=TypeError;t.exports=function(t){if(\"object\"==typeof t||e(t))return t;throw i(\"Can't set \"+o(t)+\" as a prototype\")}},function(t,n,r){var e=r(8),o=r(119),i=r(41),c=r(15);t.exports=function(t,n,r){for(var u=o(n),a=c.f,f=i.f,s=0;s<u.length;s++){var p=u[s];e(t,p)||r&&e(r,p)||a(t,p,f(n,p))}}},function(t,n,r){var e=r(9),o=r(6),i=r(63),c=r(67),u=r(12),a=o([].concat);t.exports=e(\"Reflect\",\"ownKeys\")||function(t){var n=i.f(u(t)),r=c.f;return r?a(n,r(t)):n}},function(t,n,r){var e=r(18),o=r(64),i=r(26),c=function(t){return function(n,r,c){var u,a=e(n),f=i(a),s=o(c,f);if(t&&r!=r){for(;f>s;)if((u=a[s++])!=u)return!0}else for(;f>s;s++)if((t||s in a)&&a[s]===r)return t||s||0;return!t&&-1}};t.exports={includes:c(!0),indexOf:c(!1)}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=Math.trunc||function(t){var n=+t;return(n>0?e:r)(n)}},function(t,n,r){var e=r(65),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){var e=r(6),o=Error,i=e(\"\".replace),c=String(o(\"zxcasd\").stack),u=/\\n\\s*at [^:]*:[^\\n]*/,a=u.test(c);t.exports=function(t,n){if(a&&\"string\"==typeof t&&!o.prepareStackTrace)for(;n--;)t=i(t,u,\"\");return t}},function(t,n,r){var e=r(10),o=r(19);t.exports=function(t,n){e(n)&&\"cause\"in n&&o(t,\"cause\",n.cause)}},function(t,n,r){var e=r(3),o=r(27),i=e(\"iterator\"),c=Array.prototype;t.exports=function(t){return void 0!==t&&(o.Array===t||c[i]===t)}},function(t,n,r){var e=r(7),o=r(17),i=r(12),c=r(31),u=r(89),a=TypeError;t.exports=function(t,n){var r=arguments.length<2?u(t):n;if(o(r))return i(e(r,t));throw a(c(t)+\" is not iterable\")}},function(t,n,r){var e=r(7),o=r(12),i=r(57);t.exports=function(t,n,r){var c,u;o(t);try{if(!(c=i(t,\"return\"))){if(\"throw\"===n)throw r;return r}c=e(c,t)}catch(t){u=!0,c=t}if(\"throw\"===n)throw r;if(u)throw c;return o(c),r}},function(t,n,r){var e=r(35);t.exports=function(t,n){return void 0===t?arguments.length<2?\"\":n:e(t)}},function(t,n,r){var e=r(5),o=r(20);t.exports=!e((function(){var t=Error(\"a\");return!(\"stack\"in t)||(Object.defineProperty(t,\"stack\",o(1,7)),7!==t.stack)}))},function(t,n){t.exports=function(){}},function(t,n,r){var e=r(4),o=r(2),i=e.WeakMap;t.exports=o(i)&&/native code/.test(String(i))},function(t,n,r){var e=r(11),o=r(8),i=Function.prototype,c=e&&Object.getOwnPropertyDescriptor,u=o(i,\"name\"),a=u&&\"something\"===function(){}.name,f=u&&(!e||e&&c(i,\"name\").configurable);t.exports={EXISTS:u,PROPER:a,CONFIGURABLE:f}},function(t,n,r){\"use strict\";var e=r(91).IteratorPrototype,o=r(49),i=r(20),c=r(29),u=r(27),a=function(){return this};t.exports=function(t,n,r,f){var s=n+\" Iterator\";return t.prototype=o(e,{next:i(+!f,r)}),c(t,s,!1,!0),u[s]=a,t}},function(t,n,r){\"use strict\";var e=r(69),o=r(28);t.exports=e?{}.toString:function(){return\"[object \"+o(this)+\"]\"}},function(t,n,r){r(136),r(147),r(149),r(150),r(151),r(152)},function(t,n,r){\"use strict\";var e,o,i,c=r(0),u=r(14),a=r(51),f=r(4),s=r(7),p=r(21),l=r(62),v=r(29),d=r(137),y=r(17),h=r(2),m=r(10),g=r(138),x=r(93),b=r(95).set,w=r(141),S=r(144),j=r(36),O=r(145),P=r(50),E=r(30),T=r(37),A=r(22),k=T.CONSTRUCTOR,D=T.REJECTION_EVENT,I=T.SUBCLASSING,L=P.getterFor(\"Promise\"),_=P.set,C=E&&E.prototype,M=E,R=C,N=f.TypeError,F=f.document,B=f.process,G=A.f,U=G,z=!!(F&&F.createEvent&&f.dispatchEvent),q=function(t){var n;return!(!m(t)||!h(n=t.then))&&n},V=function(t,n){var r,e,o,i=n.value,c=1==n.state,u=c?t.ok:t.fail,a=t.resolve,f=t.reject,p=t.domain;try{u?(c||(2===n.rejection&&Y(n),n.rejection=1),!0===u?r=i:(p&&p.enter(),r=u(i),p&&(p.exit(),o=!0)),r===t.promise?f(N(\"Promise-chain cycle\")):(e=q(r))?s(e,r,a,f):a(r)):f(i)}catch(t){p&&!o&&p.exit(),f(t)}},H=function(t,n){t.notified||(t.notified=!0,w((function(){for(var r,e=t.reactions;r=e.get();)V(r,t);t.notified=!1,n&&!t.rejection&&K(t)})))},J=function(t,n,r){var e,o;z?((e=F.createEvent(\"Event\")).promise=n,e.reason=r,e.initEvent(t,!1,!0),f.dispatchEvent(e)):e={promise:n,reason:r},!D&&(o=f[\"on\"+t])?o(e):\"unhandledrejection\"===t&&S(\"Unhandled promise rejection\",r)},K=function(t){s(b,f,(function(){var n,r=t.facade,e=t.value;if(W(t)&&(n=j((function(){a?B.emit(\"unhandledRejection\",e,r):J(\"unhandledrejection\",r,e)})),t.rejection=a||W(t)?2:1,n.error))throw n.value}))},W=function(t){return 1!==t.rejection&&!t.parent},Y=function(t){s(b,f,(function(){var n=t.facade;a?B.emit(\"rejectionHandled\",n):J(\"rejectionhandled\",n,t.value)}))},X=function(t,n,r){return function(e){t(n,e,r)}},$=function(t,n,r){t.done||(t.done=!0,r&&(t=r),t.value=n,t.state=2,H(t,!0))},Q=function(t,n,r){if(!t.done){t.done=!0,r&&(t=r);try{if(t.facade===n)throw N(\"Promise can't be resolved itself\");var e=q(n);e?w((function(){var r={done:!1};try{s(e,n,X(Q,r,t),X($,r,t))}catch(n){$(r,n,t)}})):(t.value=n,t.state=1,H(t,!1))}catch(n){$({done:!1},n,t)}}};if(k&&(R=(M=function(t){g(this,R),y(t),s(e,this);var n=L(this);try{t(X(Q,n),X($,n))}catch(t){$(n,t)}}).prototype,(e=function(t){_(this,{type:\"Promise\",done:!1,notified:!1,parent:!1,reactions:new O,rejection:!1,state:0,value:void 0})}).prototype=p(R,\"then\",(function(t,n){var r=L(this),e=G(x(this,M));return r.parent=!0,e.ok=!h(t)||t,e.fail=h(n)&&n,e.domain=a?B.domain:void 0,0==r.state?r.reactions.add(e):w((function(){V(e,r)})),e.promise})),o=function(){var t=new e,n=L(t);this.promise=t,this.resolve=X(Q,n),this.reject=X($,n)},A.f=G=function(t){return t===M||void 0===t?new o(t):U(t)},!u&&h(E)&&C!==Object.prototype)){i=C.then,I||p(C,\"then\",(function(t,n){var r=this;return new M((function(t,n){s(i,r,t,n)})).then(t,n)}),{unsafe:!0});try{delete C.constructor}catch(t){}l&&l(C,R)}c({global:!0,constructor:!0,wrap:!0,forced:k},{Promise:M}),v(M,\"Promise\",!1,!0),d(\"Promise\")},function(t,n,r){\"use strict\";var e=r(9),o=r(15),i=r(3),c=r(11),u=i(\"species\");t.exports=function(t){var n=e(t),r=o.f;c&&n&&!n[u]&&r(n,u,{configurable:!0,get:function(){return this}})}},function(t,n,r){var e=r(13),o=TypeError;t.exports=function(t,n){if(e(n,t))return t;throw o(\"Incorrect invocation\")}},function(t,n,r){var e=r(72),o=r(31),i=TypeError;t.exports=function(t){if(e(t))return t;throw i(o(t)+\" is not a constructor\")}},function(t,n){var r=TypeError;t.exports=function(t,n){if(t<n)throw r(\"Not enough arguments\");return t}},function(t,n,r){var e,o,i,c,u,a,f,s,p=r(4),l=r(33),v=r(41).f,d=r(95).set,y=r(96),h=r(142),m=r(143),g=r(51),x=p.MutationObserver||p.WebKitMutationObserver,b=p.document,w=p.process,S=p.Promise,j=v(p,\"queueMicrotask\"),O=j&&j.value;O||(e=function(){var t,n;for(g&&(t=w.domain)&&t.exit();o;){n=o.fn,o=o.next;try{n()}catch(t){throw o?c():i=void 0,t}}i=void 0,t&&t.enter()},y||g||m||!x||!b?!h&&S&&S.resolve?((f=S.resolve(void 0)).constructor=S,s=l(f.then,f),c=function(){s(e)}):g?c=function(){w.nextTick(e)}:(d=l(d,p),c=function(){d(e)}):(u=!0,a=b.createTextNode(\"\"),new x(e).observe(a,{characterData:!0}),c=function(){a.data=u=!u})),t.exports=O||function(t){var n={fn:t,next:void 0};i&&(i.next=n),o||(o=n,c()),i=n}},function(t,n,r){var e=r(46),o=r(4);t.exports=/ipad|iphone|ipod/i.test(e)&&void 0!==o.Pebble},function(t,n,r){var e=r(46);t.exports=/web0s(?!.*chrome)/i.test(e)},function(t,n,r){var e=r(4);t.exports=function(t,n){var r=e.console;r&&r.error&&(1==arguments.length?r.error(t):r.error(t,n))}},function(t,n){var r=function(){this.head=null,this.tail=null};r.prototype={add:function(t){var n={item:t,next:null};this.head?this.tail.next=n:this.head=n,this.tail=n},get:function(){var t=this.head;if(t)return this.head=t.next,this.tail===t&&(this.tail=null),t.item}},t.exports=r},function(t,n,r){var e=r(97),o=r(51);t.exports=!e&&!o&&\"object\"==typeof window&&\"object\"==typeof document},function(t,n,r){\"use strict\";var e=r(0),o=r(7),i=r(17),c=r(22),u=r(36),a=r(34);e({target:\"Promise\",stat:!0,forced:r(98)},{all:function(t){var n=this,r=c.f(n),e=r.resolve,f=r.reject,s=u((function(){var r=i(n.resolve),c=[],u=0,s=1;a(t,(function(t){var i=u++,a=!1;s++,o(r,n,t).then((function(t){a||(a=!0,c[i]=t,--s||e(c))}),f)})),--s||e(c)}));return s.error&&f(s.value),r.promise}})},function(t,n,r){var e=r(3)(\"iterator\"),o=!1;try{var i=0,c={next:function(){return{done:!!i++}},return:function(){o=!0}};c[e]=function(){return this},Array.from(c,(function(){throw 2}))}catch(t){}t.exports=function(t,n){if(!n&&!o)return!1;var r=!1;try{var i={};i[e]=function(){return{next:function(){return{done:r=!0}}}},t(i)}catch(t){}return r}},function(t,n,r){\"use strict\";var e=r(0),o=r(14),i=r(37).CONSTRUCTOR,c=r(30),u=r(9),a=r(2),f=r(21),s=c&&c.prototype;if(e({target:\"Promise\",proto:!0,forced:i,real:!0},{catch:function(t){return this.then(void 0,t)}}),!o&&a(c)){var p=u(\"Promise\").prototype.catch;s.catch!==p&&f(s,\"catch\",p,{unsafe:!0})}},function(t,n,r){\"use strict\";var e=r(0),o=r(7),i=r(17),c=r(22),u=r(36),a=r(34);e({target:\"Promise\",stat:!0,forced:r(98)},{race:function(t){var n=this,r=c.f(n),e=r.reject,f=u((function(){var c=i(n.resolve);a(t,(function(t){o(c,n,t).then(r.resolve,e)}))}));return f.error&&e(f.value),r.promise}})},function(t,n,r){\"use strict\";var e=r(0),o=r(7),i=r(22);e({target:\"Promise\",stat:!0,forced:r(37).CONSTRUCTOR},{reject:function(t){var n=i.f(this);return o(n.reject,void 0,t),n.promise}})},function(t,n,r){\"use strict\";var e=r(0),o=r(9),i=r(14),c=r(30),u=r(37).CONSTRUCTOR,a=r(99),f=o(\"Promise\"),s=i&&!u;e({target:\"Promise\",stat:!0,forced:i||u},{resolve:function(t){return a(s&&this===f?c:this,t)}})},function(t,n,r){\"use strict\";var e=r(0),o=r(7),i=r(17),c=r(22),u=r(36),a=r(34);e({target:\"Promise\",stat:!0},{allSettled:function(t){var n=this,r=c.f(n),e=r.resolve,f=r.reject,s=u((function(){var r=i(n.resolve),c=[],u=0,f=1;a(t,(function(t){var i=u++,a=!1;f++,o(r,n,t).then((function(t){a||(a=!0,c[i]={status:\"fulfilled\",value:t},--f||e(c))}),(function(t){a||(a=!0,c[i]={status:\"rejected\",reason:t},--f||e(c))}))})),--f||e(c)}));return s.error&&f(s.value),r.promise}})},function(t,n,r){\"use strict\";var e=r(0),o=r(7),i=r(17),c=r(9),u=r(22),a=r(36),f=r(34);e({target:\"Promise\",stat:!0},{any:function(t){var n=this,r=c(\"AggregateError\"),e=u.f(n),s=e.resolve,p=e.reject,l=a((function(){var e=i(n.resolve),c=[],u=0,a=1,l=!1;f(t,(function(t){var i=u++,f=!1;a++,o(e,n,t).then((function(t){f||l||(l=!0,s(t))}),(function(t){f||l||(f=!0,c[i]=t,--a||p(new r(c,\"No one promise resolved\")))}))})),--a||p(new r(c,\"No one promise resolved\"))}));return l.error&&p(l.value),e.promise}})},function(t,n,r){\"use strict\";var e=r(0),o=r(14),i=r(30),c=r(5),u=r(9),a=r(2),f=r(93),s=r(99),p=r(21),l=i&&i.prototype;if(e({target:\"Promise\",proto:!0,real:!0,forced:!!i&&c((function(){l.finally.call({then:function(){}},(function(){}))}))},{finally:function(t){var n=f(this,u(\"Promise\")),r=a(t);return this.then(r?function(r){return s(n,t()).then((function(){return r}))}:t,r?function(r){return s(n,t()).then((function(){throw r}))}:t)}}),!o&&a(i)){var v=u(\"Promise\").prototype.finally;l.finally!==v&&p(l,\"finally\",v,{unsafe:!0})}},function(t,n,r){var e=r(6),o=r(65),i=r(35),c=r(56),u=e(\"\".charAt),a=e(\"\".charCodeAt),f=e(\"\".slice),s=function(t){return function(n,r){var e,s,p=i(c(n)),l=o(r),v=p.length;return l<0||l>=v?t?\"\":void 0:(e=a(p,l))<55296||e>56319||l+1===v||(s=a(p,l+1))<56320||s>57343?t?u(p,l):e:t?f(p,l,l+2):s-56320+(e-55296<<10)+65536}};t.exports={codeAt:s(!1),charAt:s(!0)}},function(t,n){t.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},function(t,n,r){var e=r(159);t.exports=e},function(t,n,r){var e=r(13),o=r(160),i=Array.prototype;t.exports=function(t){var n=t.slice;return t===i||e(i,t)&&n===i.slice?o:n}},function(t,n,r){r(161);var e=r(39);t.exports=e(\"Array\").slice},function(t,n,r){\"use strict\";var e=r(0),o=r(38),i=r(72),c=r(10),u=r(64),a=r(26),f=r(18),s=r(74),p=r(3),l=r(53),v=r(73),d=l(\"slice\"),y=p(\"species\"),h=Array,m=Math.max;e({target:\"Array\",proto:!0,forced:!d},{slice:function(t,n){var r,e,p,l=f(this),d=a(l),g=u(t,d),x=u(void 0===n?d:n,d);if(o(l)&&(r=l.constructor,(i(r)&&(r===h||o(r.prototype))||c(r)&&null===(r=r[y]))&&(r=void 0),r===h||void 0===r))return v(l,g,x);for(e=new(void 0===r?h:r)(m(x-g,0)),p=0;g<x;g++,p++)g in l&&s(e,p,l[g]);return e.length=p,e}})},function(t,n,r){t.exports=r(163)},function(t,n,r){var e=r(164);t.exports=e},function(t,n,r){var e=r(13),o=r(165),i=Array.prototype;t.exports=function(t){var n=t.map;return t===i||e(i,t)&&n===i.map?o:n}},function(t,n,r){r(166);var e=r(39);t.exports=e(\"Array\").map},function(t,n,r){\"use strict\";var e=r(0),o=r(54).map;e({target:\"Array\",proto:!0,forced:!r(53)(\"map\")},{map:function(t){return o(this,t,arguments.length>1?arguments[1]:void 0)}})},function(t,n,r){var e=r(38),o=r(72),i=r(10),c=r(3)(\"species\"),u=Array;t.exports=function(t){var n;return e(t)&&(n=t.constructor,(o(n)&&(n===u||e(n.prototype))||i(n)&&null===(n=n[c]))&&(n=void 0)),void 0===n?u:n}},function(t,n,r){(function(e){var o,i=r(169),c=r(101),u=r(215),a=r(76),f=r(219),s=r(226),p=r(230),l=r(234),v=r(238);!function(d,y){\"use strict\";var h,m=(d=void 0!==d?d:\"undefined\"!=typeof self?self:void 0!==e?e:{}).IDBKeyRange||d.webkitIDBKeyRange,g=\"readonly\",x=\"readwrite\",b=Object.prototype.hasOwnProperty,w=function(){if(!h&&!(h=d.indexedDB||d.webkitIndexedDB||d.mozIndexedDB||d.oIndexedDB||d.msIndexedDB||(null===d.indexedDB&&d.shimIndexedDB?d.shimIndexedDB:void 0)))throw\"IndexedDB required\";return h},S=function(t){return t},j=function(t){var n;return c(n=Object.prototype.toString.call(t)).call(n,8,-1).toLowerCase()},O=function(t){return\"function\"==typeof t},P=function(t){return\"number\"===j(t)},E=function(t){return\"array\"===j(t)},T=function(t){return void 0===t},A=function(t,n){var r=this,e=!1;this.name=n,this.getIndexedDB=function(){return t},this.add=function(n){if(e)throw\"Database has been closed\";for(var o=[],i=0,c=0;c<arguments.length-1;c++)if(u(arguments[c+1]))for(var p=0;p<arguments[c+1].length;p++)o[i]=arguments[c+1][p],i++;else o[i]=arguments[c+1],i++;var l=t.transaction(n,x),v=l.objectStore(n);return new a((function(t,n){f(o).call(o,(function(t){var n;if(t.item&&t.key){var r=t.key;t=t.item,n=v.add(t,r)}else n=v.add(t);n.onsuccess=function(n){var r=n.target,e=r.source.keyPath;null===e&&(e=\"__id__\"),s(t,e,{value:r.result,enumerable:!0})}})),l.oncomplete=function(){t(o,r)},l.onerror=function(t){t.preventDefault(),n(t)},l.onabort=function(t){n(t)}}))},this.updateAndDelete=function(n,r,o){if(e)throw\"Database has been closed\";var i=t.transaction(n,x),c=i.objectStore(n),u=c.keyPath;return new a((function(t,n){f(r).call(r,(function(t){if(t.item&&t.key){var n=t.key;t=t.item,c.put(t,n)}else c.put(t)})),f(o).call(o,(function(t){c.delete(t[u])})),i.oncomplete=function(){t([r,o])},i.onerror=function(t){n(t)}}))},this.update=function(n){if(e)throw\"Database has been closed\";for(var o,i=[],c=1;c<arguments.length;c++)u(o=arguments[c])?i=p(i).call(i,o):i.push(o);var s=t.transaction(n,x),l=s.objectStore(n);l.keyPath;return new a((function(t,n){f(i).call(i,(function(t){var n;if(t.item&&t.key){var r=t.key;t=t.item,n=l.put(t,r)}else n=l.put(t);n.onsuccess=function(t){},n.onerror=function(t){}})),s.oncomplete=function(){t(i,r)},s.onerror=function(t){n(t)},s.onabort=function(t){n(t)}}))},this.remove=function(n,r,o,i,c,s,p){if(e)throw\"Database has been closed\";var l=t.transaction(n,x),v=l.objectStore(n);return new a((function(t,n){function e(t){return null==t}var a;(e(i)&&(i=-1/0),e(c)&&(c=1/0),null===r||u(r)||(r=[r]),e(o))?null!==r?f(r).call(r,(function(t){v.delete(t)})):v.delete(range=m.bound(i,c,s,p)):(a=null!==r?m.only(r[0]):m.bound(i,c,s,p),v.index(o).openCursor(a).onsuccess=function(t){var n=t.target.result;n&&(n.delete(),n.continue())});l.oncomplete=function(){t()},l.onerror=function(t){n(t)},l.onabort=function(t){n(t)}}))},this.clear=function(n){if(e)throw\"Database has been closed\";var r=t.transaction(n,x);r.objectStore(n).clear();return new a((function(t,n){r.oncomplete=function(){t()},r.onerror=function(t){n(t)}}))},this.close=function(){e||(t.close(),e=!0,delete I[n])},this.get=function(n,r){if(e)throw\"Database has been closed\";var o=t.transaction(n),i=o.objectStore(n).get(r);return new a((function(t,n){i.onsuccess=function(n){t(n.target.result)},o.onerror=function(t){n(t)}}))},this.query=function(n,r){if(e)throw\"Database has been closed\";return new k(n,t,r)},this.count=function(n,r){if(e)throw\"Database has been closed\";t.transaction(n).objectStore(n)};for(var o=0,i=t.objectStoreNames.length;o<i;o++)!function(t){for(var n in r[t]={},r)b.call(r,n)&&\"close\"!==n&&(r[t][n]=function(n){return function(){var e,o=p(e=[t]).call(e,c([]).call(arguments,0));return r[n].apply(r,o)}}(n))}(t.objectStoreNames[o])},k=function(t,n,r){var e,o=this,u=!1,s=!1,p=function(e,o,c,p,v,d,y){return new a((function(a,h){var b=u||s?x:g,w=n.transaction(t,b),S=w.objectStore(t),j=r?S.index(r):S,P=e?m[e].apply(null,o):null,E=[],T=[P],A=0;v=v||null,d=d||[],\"count\"!==c&&T.push(p||\"next\");var k=!!u&&l(u);j[c].apply(j,T).onsuccess=function(t){var n=t.target.result;if(i(n)===i(0))E=n;else if(n)if(null!==v&&v[0]>A)A=v[0],n.advance(v[0]);else if(null!==v&&A>=v[0]+v[1]);else{var r=!0,e=\"value\"in n?n.value:n.key;f(d).call(d,(function(t){t&&t.length&&(2===t.length?r=r&&e[t[0]]===t[1]:O(t[0])&&(r=r&&t[0].apply(void 0,[e])))})),r&&(A++,E.push(y(e)),s?n.delete():u&&(e=function(t){for(var n=0;n<k.length;n++){var r=k[n],e=u[r];e instanceof Function&&(e=e(t)),t[r]=e}return t}(e),n.update(e))),n.continue()}},w.oncomplete=function(){a(E)},w.onerror=function(t){h(t)},w.onabort=function(t){h(t)}}))},d=function(t,n){var r=\"next\",e=\"openCursor\",o=[],i=null,a=S,f=!1,l=function(){return p(t,n,e,f?r+\"unique\":r,i,o,a)},v=function(){return r=null,e=\"count\",{execute:l}},d=function t(){return 1==(i=E(arguments[0])?arguments[0]:c(Array.prototype).call(arguments,0,2)).length&&i.unshift(0),P(i[1])||(i=null),{execute:l,count:v,keys:y,filter:h,asc:m,desc:g,distinct:x,modify:b,limit:t,map:w,remove:j}},y=function t(n){return(n=!!T(n)||!!n)&&(e=\"openKeyCursor\"),{execute:l,keys:t,filter:h,asc:m,desc:g,distinct:x,modify:b,limit:d,map:w,remove:j}},h=function t(){return o.push(c(Array.prototype).call(arguments,0,2)),{execute:l,count:v,keys:y,filter:t,asc:m,desc:g,distinct:x,modify:b,limit:d,map:w,remove:j}},m=function t(n){return n=!!T(n)||!!n,r=n?\"next\":\"prev\",{execute:l,count:v,keys:y,filter:h,asc:t,desc:g,distinct:x,modify:b,limit:d,map:w,remove:j}},g=function t(n){return n=!!T(n)||!!n,r=n?\"prev\":\"next\",{execute:l,count:v,keys:y,filter:h,asc:m,desc:t,distinct:x,modify:b,limit:d,map:w,remove:j}},x=function t(n){return n=!!T(n)||!!n,f=n,{execute:l,count:v,keys:y,filter:h,asc:m,desc:g,distinct:t,modify:b,limit:d,map:w,remove:j}},b=function t(n){return u=n,{execute:l,count:v,keys:y,filter:h,asc:m,desc:g,distinct:x,modify:t,limit:d,map:w,remove:j}},w=function t(n){return O(n)&&(a=n),{execute:l,count:v,keys:y,filter:h,asc:m,desc:g,distinct:x,modify:b,limit:d,map:t,remove:j}},j=function t(n){return n=!!T(n)||!!n,s=n,{execute:l,count:v,keys:y,filter:h,asc:m,desc:g,distinct:x,modify:b,limit:d,map:w,remove:t}};return{execute:l,count:v,keys:y,filter:h,asc:m,desc:g,distinct:x,modify:b,limit:d,map:w,remove:j}};f(e=\"only bound upperBound lowerBound\".split(\" \")).call(e,(function(t){o[t]=function(){return new d(t,arguments)}})),this.filter=function(){var t=new d(null,null);return v(t).apply(t,arguments)},this.all=function(){var t;return v(t=this).call(t)}},D=function(t,n,r,e){var o=t.target.result,i=new A(o,n);return I[n]=o,a.resolve(i)},I={},L={version:\"0.10.2\",open:function(t){var n;return new a((function(r,e){if(I[t.server])D({target:{result:I[t.server]}},t.server,t.version,t.schema).then(r,e);else{try{n=w().open(t.server,t.version)}catch(t){e(t)}n.onsuccess=function(n){D(n,t.server,t.version,t.schema).then(r,e)},n.onupgradeneeded=function(n){!function(t,n,r){for(var e in\"function\"==typeof n&&(n=n()),n){var o,i=n[e];for(var c in o=!b.call(n,e)||r.objectStoreNames.contains(e)?t.currentTarget.transaction.objectStore(e):r.createObjectStore(e,i.key),i.indexes){var u=i.indexes[c];try{o.index(c)}catch(t){o.createIndex(c,u.key||c,l(u).length?u:{unique:!1})}}}}(n,t.schema,n.target.result)},n.onerror=function(t){e(t)}}}))},remove:function(t){return new a((function(n,r){if(!t)return n();var e,o;i(t)===A&&(t=t.name),\"string\"==typeof t&&(e=I[t]),e&&\"function\"==typeof e.close&&e.close();try{o=w().deleteDatabase(t)}catch(t){r(t)}o.onsuccess=function(r){delete I[t],n(t)},o.onerror=function(t){r(t)},o.onblocked=function(t){r(t)}}))}};void 0!==t.exports?t.exports=L:void 0===(o=function(){return L}.call(n,r,n,t))||(t.exports=o)}(void 0)}).call(this,r(77))},function(t,n,r){var e=r(170),o=r(209);function i(n){return t.exports=i=\"function\"==typeof e&&\"symbol\"==typeof o?function(t){return typeof t}:function(t){return t&&\"function\"==typeof e&&t.constructor===e&&t!==e.prototype?\"symbol\":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,i(n)}t.exports=i,t.exports.__esModule=!0,t.exports.default=t.exports},function(t,n,r){t.exports=r(171)},function(t,n,r){t.exports=r(172)},function(t,n,r){var e=r(173);r(202),r(203),r(204),r(205),r(206),r(207),r(208),t.exports=e},function(t,n,r){var e=r(174);r(201),t.exports=e},function(t,n,r){var e=r(175);r(52),t.exports=e},function(t,n,r){r(103),r(71),r(177),r(185),r(186),r(187),r(188),r(106),r(189),r(190),r(191),r(192),r(193),r(194),r(195),r(196),r(197),r(198),r(199),r(200);var e=r(16);t.exports=e.Symbol},function(t,n){var r=TypeError;t.exports=function(t){if(t>9007199254740991)throw r(\"Maximum allowed index exceeded\");return t}},function(t,n,r){r(178),r(181),r(182),r(183),r(184)},function(t,n,r){\"use strict\";var e=r(0),o=r(4),i=r(7),c=r(6),u=r(14),a=r(11),f=r(24),s=r(5),p=r(8),l=r(13),v=r(12),d=r(18),y=r(43),h=r(35),m=r(20),g=r(49),x=r(68),b=r(63),w=r(179),S=r(67),j=r(41),O=r(15),P=r(87),E=r(80),T=r(21),A=r(32),k=r(47),D=r(48),I=r(59),L=r(3),_=r(75),C=r(1),M=r(104),R=r(29),N=r(50),F=r(54).forEach,B=k(\"hidden\"),G=N.set,U=N.getterFor(\"Symbol\"),z=Object.prototype,q=o.Symbol,V=q&&q.prototype,H=o.TypeError,J=o.QObject,K=j.f,W=O.f,Y=w.f,X=E.f,$=c([].push),Q=A(\"symbols\"),Z=A(\"op-symbols\"),tt=A(\"wks\"),nt=!J||!J.prototype||!J.prototype.findChild,rt=a&&s((function(){return 7!=g(W({},\"a\",{get:function(){return W(this,\"a\",{value:7}).a}})).a}))?function(t,n,r){var e=K(z,n);e&&delete z[n],W(t,n,r),e&&t!==z&&W(z,n,e)}:W,et=function(t,n){var r=Q[t]=g(V);return G(r,{type:\"Symbol\",tag:t,description:n}),a||(r.description=n),r},ot=function(t,n,r){t===z&&ot(Z,n,r),v(t);var e=y(n);return v(r),p(Q,e)?(r.enumerable?(p(t,B)&&t[B][e]&&(t[B][e]=!1),r=g(r,{enumerable:m(0,!1)})):(p(t,B)||W(t,B,m(1,{})),t[B][e]=!0),rt(t,e,r)):W(t,e,r)},it=function(t,n){v(t);var r=d(n),e=x(r).concat(ft(r));return F(e,(function(n){a&&!i(ct,r,n)||ot(t,n,r[n])})),t},ct=function(t){var n=y(t),r=i(X,this,n);return!(this===z&&p(Q,n)&&!p(Z,n))&&(!(r||!p(this,n)||!p(Q,n)||p(this,B)&&this[B][n])||r)},ut=function(t,n){var r=d(t),e=y(n);if(r!==z||!p(Q,e)||p(Z,e)){var o=K(r,e);return!o||!p(Q,e)||p(r,B)&&r[B][e]||(o.enumerable=!0),o}},at=function(t){var n=Y(d(t)),r=[];return F(n,(function(t){p(Q,t)||p(D,t)||$(r,t)})),r},ft=function(t){var n=t===z,r=Y(n?Z:d(t)),e=[];return F(r,(function(t){!p(Q,t)||n&&!p(z,t)||$(e,Q[t])})),e};f||(T(V=(q=function(){if(l(V,this))throw H(\"Symbol is not a constructor\");var t=arguments.length&&void 0!==arguments[0]?h(arguments[0]):void 0,n=I(t),r=function(t){this===z&&i(r,Z,t),p(this,B)&&p(this[B],n)&&(this[B][n]=!1),rt(this,n,m(1,t))};return a&&nt&&rt(z,n,{configurable:!0,set:r}),et(n,t)}).prototype,\"toString\",(function(){return U(this).tag})),T(q,\"withoutSetter\",(function(t){return et(I(t),t)})),E.f=ct,O.f=ot,P.f=it,j.f=ut,b.f=w.f=at,S.f=ft,_.f=function(t){return et(L(t),t)},a&&(W(V,\"description\",{configurable:!0,get:function(){return U(this).description}}),u||T(z,\"propertyIsEnumerable\",ct,{unsafe:!0}))),e({global:!0,constructor:!0,wrap:!0,forced:!f,sham:!f},{Symbol:q}),F(x(tt),(function(t){C(t)})),e({target:\"Symbol\",stat:!0,forced:!f},{useSetter:function(){nt=!0},useSimple:function(){nt=!1}}),e({target:\"Object\",stat:!0,forced:!f,sham:!a},{create:function(t,n){return void 0===n?g(t):it(g(t),n)},defineProperty:ot,defineProperties:it,getOwnPropertyDescriptor:ut}),e({target:\"Object\",stat:!0,forced:!f},{getOwnPropertyNames:at}),M(),R(q,\"Symbol\"),D[B]=!0},function(t,n,r){var e=r(23),o=r(18),i=r(63).f,c=r(180),u=\"object\"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return u&&\"Window\"==e(t)?function(t){try{return i(t)}catch(t){return c(u)}}(t):i(o(t))}},function(t,n,r){var e=r(64),o=r(26),i=r(74),c=Array,u=Math.max;t.exports=function(t,n,r){for(var a=o(t),f=e(n,a),s=e(void 0===r?a:r,a),p=c(u(s-f,0)),l=0;f<s;f++,l++)i(p,l,t[f]);return p.length=l,p}},function(t,n,r){var e=r(0),o=r(9),i=r(8),c=r(35),u=r(32),a=r(105),f=u(\"string-to-symbol-registry\"),s=u(\"symbol-to-string-registry\");e({target:\"Symbol\",stat:!0,forced:!a},{for:function(t){var n=c(t);if(i(f,n))return f[n];var r=o(\"Symbol\")(n);return f[n]=r,s[r]=n,r}})},function(t,n,r){var e=r(0),o=r(8),i=r(44),c=r(31),u=r(32),a=r(105),f=u(\"symbol-to-string-registry\");e({target:\"Symbol\",stat:!0,forced:!a},{keyFor:function(t){if(!i(t))throw TypeError(c(t)+\" is not a symbol\");if(o(f,t))return f[t]}})},function(t,n,r){var e=r(0),o=r(9),i=r(55),c=r(7),u=r(6),a=r(5),f=r(38),s=r(2),p=r(10),l=r(44),v=r(73),d=r(24),y=o(\"JSON\",\"stringify\"),h=u(/./.exec),m=u(\"\".charAt),g=u(\"\".charCodeAt),x=u(\"\".replace),b=u(1..toString),w=/[\\uD800-\\uDFFF]/g,S=/^[\\uD800-\\uDBFF]$/,j=/^[\\uDC00-\\uDFFF]$/,O=!d||a((function(){var t=o(\"Symbol\")();return\"[null]\"!=y([t])||\"{}\"!=y({a:t})||\"{}\"!=y(Object(t))})),P=a((function(){return'\"\\\\udf06\\\\ud834\"'!==y(\"\\udf06\\ud834\")||'\"\\\\udead\"'!==y(\"\\udead\")})),E=function(t,n){var r=v(arguments),e=n;if((p(n)||void 0!==t)&&!l(t))return f(n)||(n=function(t,n){if(s(e)&&(n=c(e,this,t,n)),!l(n))return n}),r[1]=n,i(y,null,r)},T=function(t,n,r){var e=m(r,n-1),o=m(r,n+1);return h(S,t)&&!h(j,o)||h(j,t)&&!h(S,e)?\"\\\\u\"+b(g(t,0),16):t};y&&e({target:\"JSON\",stat:!0,arity:3,forced:O||P},{stringify:function(t,n,r){var e=v(arguments),o=i(O?E:y,null,e);return P&&\"string\"==typeof o?x(o,w,T):o}})},function(t,n,r){var e=r(0),o=r(24),i=r(5),c=r(67),u=r(25);e({target:\"Object\",stat:!0,forced:!o||i((function(){c.f(1)}))},{getOwnPropertySymbols:function(t){var n=c.f;return n?n(u(t)):[]}})},function(t,n,r){r(1)(\"asyncIterator\")},function(t,n){},function(t,n,r){r(1)(\"hasInstance\")},function(t,n,r){r(1)(\"isConcatSpreadable\")},function(t,n,r){r(1)(\"match\")},function(t,n,r){r(1)(\"matchAll\")},function(t,n,r){r(1)(\"replace\")},function(t,n,r){r(1)(\"search\")},function(t,n,r){r(1)(\"species\")},function(t,n,r){r(1)(\"split\")},function(t,n,r){var e=r(1),o=r(104);e(\"toPrimitive\"),o()},function(t,n,r){var e=r(9),o=r(1),i=r(29);o(\"toStringTag\"),i(e(\"Symbol\"),\"Symbol\")},function(t,n,r){r(1)(\"unscopables\")},function(t,n,r){var e=r(4);r(29)(e.JSON,\"JSON\",!0)},function(t,n){},function(t,n){},function(t,n,r){r(1)(\"dispose\")},function(t,n,r){r(1)(\"asyncDispose\")},function(t,n,r){r(1)(\"matcher\")},function(t,n,r){r(1)(\"metadataKey\")},function(t,n,r){r(1)(\"observable\")},function(t,n,r){r(1)(\"metadata\")},function(t,n,r){r(1)(\"patternMatch\")},function(t,n,r){r(1)(\"replaceAll\")},function(t,n,r){t.exports=r(210)},function(t,n,r){t.exports=r(211)},function(t,n,r){var e=r(212);t.exports=e},function(t,n,r){var e=r(213);t.exports=e},function(t,n,r){var e=r(214);r(52),t.exports=e},function(t,n,r){r(70),r(71),r(100),r(106);var e=r(75);t.exports=e.f(\"iterator\")},function(t,n,r){t.exports=r(216)},function(t,n,r){var e=r(217);t.exports=e},function(t,n,r){r(218);var e=r(16);t.exports=e.Array.isArray},function(t,n,r){r(0)({target:\"Array\",stat:!0},{isArray:r(38)})},function(t,n,r){t.exports=r(220)},function(t,n,r){r(52);var e=r(28),o=r(8),i=r(13),c=r(221),u=Array.prototype,a={DOMTokenList:!0,NodeList:!0};t.exports=function(t){var n=t.forEach;return t===u||i(u,t)&&n===u.forEach||o(a,e(t))?c:n}},function(t,n,r){var e=r(222);t.exports=e},function(t,n,r){r(223);var e=r(39);t.exports=e(\"Array\").forEach},function(t,n,r){\"use strict\";var e=r(0),o=r(224);e({target:\"Array\",proto:!0,forced:[].forEach!=o},{forEach:o})},function(t,n,r){\"use strict\";var e=r(54).forEach,o=r(225)(\"forEach\");t.exports=o?[].forEach:function(t){return e(this,t,arguments.length>1?arguments[1]:void 0)}},function(t,n,r){\"use strict\";var e=r(5);t.exports=function(t,n){var r=[][t];return!!r&&e((function(){r.call(null,n||function(){return 1},1)}))}},function(t,n,r){t.exports=r(227)},function(t,n,r){var e=r(228);t.exports=e},function(t,n,r){r(229);var e=r(16).Object,o=t.exports=function(t,n,r){return e.defineProperty(t,n,r)};e.defineProperty.sham&&(o.sham=!0)},function(t,n,r){var e=r(0),o=r(11),i=r(15).f;e({target:\"Object\",stat:!0,forced:Object.defineProperty!==i,sham:!o},{defineProperty:i})},function(t,n,r){t.exports=r(231)},function(t,n,r){var e=r(232);t.exports=e},function(t,n,r){var e=r(13),o=r(233),i=Array.prototype;t.exports=function(t){var n=t.concat;return t===i||e(i,t)&&n===i.concat?o:n}},function(t,n,r){r(103);var e=r(39);t.exports=e(\"Array\").concat},function(t,n,r){t.exports=r(235)},function(t,n,r){var e=r(236);t.exports=e},function(t,n,r){r(237);var e=r(16);t.exports=e.Object.keys},function(t,n,r){var e=r(0),o=r(25),i=r(68);e({target:\"Object\",stat:!0,forced:r(5)((function(){i(1)}))},{keys:function(t){return i(o(t))}})},function(t,n,r){t.exports=r(239)},function(t,n,r){var e=r(240);t.exports=e},function(t,n,r){var e=r(13),o=r(241),i=Array.prototype;t.exports=function(t){var n=t.filter;return t===i||e(i,t)&&n===i.filter?o:n}},function(t,n,r){r(242);var e=r(39);t.exports=e(\"Array\").filter},function(t,n,r){\"use strict\";var e=r(0),o=r(54).filter;e({target:\"Array\",proto:!0,forced:!r(53)(\"filter\")},{filter:function(t){return o(this,t,arguments.length>1?arguments[1]:void 0)}})}]);","Worker",void 0,void 0);}},function(e,t,n){var r=n(3),o=n(16),i=n(7),s=n(283),a={log:{key:{keyPath:"time"},indexes:{level:{unique:!1},time:{unique:!0}}}};function c(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.server=null,this.expire=e.expire||72,this.name=e.name;}var u=c.prototype;u.init=function(){var e=this;if(!this.server)return s.open({server:"nim-log-"+this.name,version:1,schema:a}).then(function(t){e.server=t;});},u.putLog=function(e){var t=this;if(!this.server)return r.reject("no db server");var n=o(e).call(e,-1)[0].time-36e5*this.expire;return this.deleteLogs(n).then(function(){return t.server.add("log",e);});},u.getAllLogs=function(){return this.server?this.server.query("log","time").all().execute().then(function(e){var t={},n=o(e).call(e,-1)[0];return t.logs=i(e).call(e,function(e){return e.log;}).join("\r\n"),t.time=n&&n.time,t;}):r.reject("no db server");},u.deleteLogs=function(e){return this.server?this.server.remove("log",null,"time",0,e):r.reject("no db server");},e.exports=c;},function(e,t,n){var r=n(19),o=n(553),i=Function.prototype;e.exports=function(e){var t=e.bind;return e===i||r(i,e)&&t===i.bind?o:t;};},function(e,t,n){n(554);var r=n(24);e.exports=r("Function").bind;},function(e,t,n){var r=n(1),o=n(260);r({target:"Function",proto:!0,forced:Function.bind!==o},{bind:o});},function(e,t,n){var r=n(15),o=n(23),i=n(2),s=n(27),a=n(5),c=n(47),u=n(172);function l(e){e.onuploading&&this.on("uploading",e.onuploading),u.call(this,e);}var m=u.prototype,p=l.prototype=r(m);p.doSend=function(){var e,t,n,r=this.options,u=r.headers,l=this.xhr=new XMLHttpRequest();if("multipart/form-data"===u["Content-Type"]){var m,p;delete u["Content-Type"],l.upload.onprogress=o(m=this.onProgress).call(m,this),l.upload.onload=o(p=this.onProgress).call(p,this);var d,f=r.data;if(r.data=new window.FormData(),f)i(d=c.getKeys(f,r.putFileAtEnd)).call(d,function(e){var t=f[e];t.tagName&&"INPUT"===t.tagName.toUpperCase()?"file"===t.type&&i([]).call(t.files,function(e){r.data.append(c.dataset(t,"name")||t.name||e.name||"file-"+c.uniqueID(),e);}):r.data.append(e,t);});}else if(u["x-nos-token"]){var g,h;l.upload.onprogress=o(g=this.onProgress).call(g,this),l.upload.onload=o(h=this.onProgress).call(h,this);}(l.onreadystatechange=o(e=this.onStateChange).call(e,this),0!==r.timeout)&&(this.timer=s(o(n=this.onTimeout).call(n,this),r.timeout));l.open(r.method,r.url,!r.sync),i(t=a(u)).call(t,function(e){l.setRequestHeader(e,u[e]);}),r.cookie&&"withCredentials"in l&&(l.withCredentials=!0),l.send(r.data),this.afterSend();},p.onProgress=function(e){e.lengthComputable&&e.loaded<=e.total&&this.emit("uploading",e);},p.onStateChange=function(){var e,t=this.xhr;4===t.readyState&&(e={status:t.status,result:t.responseText||""},this.onLoad(e));},p.getResponseHeader=function(e){var t=this.xhr;return t?t.getResponseHeader(e):"";},p.destroy=function(){clearTimeout(this.timer);try{this.xhr.onreadystatechange=c.f,this.xhr.abort();}catch(e){}m.destroy.call(this);},e.exports=l;},function(e,t,n){var r;/*!
 * EventEmitter v5.2.9 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - https://oli.me.uk/
 * @preserve
 */!function(t){"use strict";function o(){}var i=o.prototype,s=t.EventEmitter;function a(e,t){for(var n=e.length;n--;){if(e[n].listener===t)return n;}return-1;}function c(e){return function(){return this[e].apply(this,arguments);};}i.getListeners=function(e){var t,n,r=this._getEvents();if(e instanceof RegExp)for(n in t={},r){r.hasOwnProperty(n)&&e.test(n)&&(t[n]=r[n]);}else t=r[e]||(r[e]=[]);return t;},i.flattenListeners=function(e){var t,n=[];for(t=0;t<e.length;t+=1){n.push(e[t].listener);}return n;},i.getListenersAsObject=function(e){var t,n=this.getListeners(e);return n instanceof Array&&((t={})[e]=n),t||n;},i.addListener=function(e,t){if(!function e(t){return"function"==typeof t||t instanceof RegExp||!(!t||"object"!=(typeof t==="undefined"?"undefined":_typeof(t)))&&e(t.listener);}(t))throw new TypeError("listener must be a function");var n,r=this.getListenersAsObject(e),o="object"==(typeof t==="undefined"?"undefined":_typeof(t));for(n in r){r.hasOwnProperty(n)&&-1===a(r[n],t)&&r[n].push(o?t:{listener:t,once:!1});}return this;},i.on=c("addListener"),i.addOnceListener=function(e,t){return this.addListener(e,{listener:t,once:!0});},i.once=c("addOnceListener"),i.defineEvent=function(e){return this.getListeners(e),this;},i.defineEvents=function(e){for(var t=0;t<e.length;t+=1){this.defineEvent(e[t]);}return this;},i.removeListener=function(e,t){var n,r,o=this.getListenersAsObject(e);for(r in o){o.hasOwnProperty(r)&&-1!==(n=a(o[r],t))&&o[r].splice(n,1);}return this;},i.off=c("removeListener"),i.addListeners=function(e,t){return this.manipulateListeners(!1,e,t);},i.removeListeners=function(e,t){return this.manipulateListeners(!0,e,t);},i.manipulateListeners=function(e,t,n){var r,o,i=e?this.removeListener:this.addListener,s=e?this.removeListeners:this.addListeners;if("object"!=(typeof t==="undefined"?"undefined":_typeof(t))||t instanceof RegExp)for(r=n.length;r--;){i.call(this,t,n[r]);}else for(r in t){t.hasOwnProperty(r)&&(o=t[r])&&("function"==typeof o?i.call(this,r,o):s.call(this,r,o));}return this;},i.removeEvent=function(e){var t,n=typeof e==="undefined"?"undefined":_typeof(e),r=this._getEvents();if("string"===n)delete r[e];else if(e instanceof RegExp)for(t in r){r.hasOwnProperty(t)&&e.test(t)&&delete r[t];}else delete this._events;return this;},i.removeAllListeners=c("removeEvent"),i.emitEvent=function(e,t){var n,r,o,i,s=this.getListenersAsObject(e);for(i in s){if(s.hasOwnProperty(i))for(n=s[i].slice(0),o=0;o<n.length;o++){!0===(r=n[o]).once&&this.removeListener(e,r.listener),r.listener.apply(this,t||[])===this._getOnceReturnValue()&&this.removeListener(e,r.listener);}}return this;},i.trigger=c("emitEvent"),i.emit=function(e){var t=Array.prototype.slice.call(arguments,1);return this.emitEvent(e,t);},i.setOnceReturnValue=function(e){return this._onceReturnValue=e,this;},i._getOnceReturnValue=function(){return!this.hasOwnProperty("_onceReturnValue")||this._onceReturnValue;},i._getEvents=function(){return this._events||(this._events={});},o.noConflict=function(){return t.EventEmitter=s,o;},void 0===(r=function(){return o;}.call(t,n,t,e))||(e.exports=r);}("undefined"!=typeof window?window:this||{});},function(e,t,n){var r=n(15),o=n(4),i=n(2),s=n(23),a=n(71),c=n(47),u=n(172),l=n(261),m="NEJ-UPLOAD-RESULT:",p={};function d(e){this.init(),u.call(this,e);}var f=u.prototype,g=d.prototype=r(f);g.init=function(){var e=!1;function t(e){var t=e.data;if(0===o(t).call(t,m)){var n=(t=JSON.parse(t.replace(m,""))).key,r=p[n];r&&(delete p[n],t.result=decodeURIComponent(t.result||""),r.onLoad(t.result));}}return function(){!function(){if(!e){e=!0;var n=c.getGlobal();n.postMessage?c.on(n,"message",t):(l.addMsgListener(t),l.startTimer());}}();};}(),g.doSend=function(){var e=this,t=e.options,n=e.key="zoro-ajax-upload-iframe-"+c.uniqueID();p[n]=e;var r=e.form=c.html2node('<form style="display:none;"></form>');"undefined"==typeof document||document.body.appendChild(r),r.target=n,r.method="POST",r.enctype="multipart/form-data",r.encoding="multipart/form-data";var o=t.url,a=c.genUrlSep(o);r.action=o+a+"_proxy_=form";var u,l=t.data,m=[],d=[];l&&i(u=c.getKeys(l,t.putFileAtEnd)).call(u,function(e){var t=l[e];if(t.tagName&&"INPUT"===t.tagName.toUpperCase()){if("file"===t.type){var n=t,o=n.cloneNode(!0);n.parentNode.insertBefore(o,n);var i=c.dataset(n,"name");i&&(n.name=i),r.appendChild(n),c.isFunction(n.setAttribute)&&(n.setAttribute("form",""),n.removeAttribute("form")),m.push(t),d.push(o);}}else{var s=c.html2node('<input type="hidden"/>');s.name=e,s.value=t,r.appendChild(s);}});function f(){i(m).call(m,function(e,t){var n=d[t];n.parentNode&&(e.name=n.name,c.isFunction(e.setAttribute)&&e.setAttribute("form",n.getAttribute("form")),n.parentNode.replaceChild(e,n));});}var g=e.iframe=c.createIframe({name:n,onload:function onload(){var t;e.aborted?f():(c.on(g,"load",s(t=e.checkResult).call(t,e)),r.submit(),f(),e.afterSend());}});},g.checkResult=function(){var e,t;try{var n,r;if(e=this.iframe.contentWindow.document.body,t=a(n=e.innerText||e.textContent||"").call(n),o(t).call(t,m)>=0||o(r=e.innerHTML).call(r,m)>=0)return;}catch(e){return;}this.onLoad(t);},g.onLoad=function(e){f.onLoad.call(this,{status:200,result:e}),c.remove(this.form),c.remove(this.iframe),f.destroy.call(this);},g.destroy=function(){c.remove(this.iframe),c.remove(this.form);},g.abort=function(){this.aborted=!0,delete p[this.key],f.abort.call(this);},e.exports=d;},function(e,t,n){var r=n(559);e.exports=r;},function(e,t,n){var r=n(19),o=n(560),i=String.prototype;e.exports=function(e){var t=e.trim;return"string"==typeof e||e===i||r(i,e)&&t===i.trim?o:t;};},function(e,t,n){n(561);var r=n(24);e.exports=r("String").trim;},function(e,t,n){"use strict";var r=n(1),o=n(170).trim;r({target:"String",proto:!0,forced:n(562)("trim")},{trim:function trim(){return o(this);}});},function(e,t,n){var r=n(212).PROPER,o=n(8),i=n(136);e.exports=function(e){return o(function(){return!!i[e]()||"​᠎"!=="​᠎"[e]()||r&&i[e].name!==e;});};},function(e,t,n){n(239);var r=n(11);e.exports=r.setInterval;},function(e,t,n){var r=n(15),o=n(4),i=n(23),s=n(2),a=n(47),c=n(261),u=n(172),l={};function m(e){this.init(),u.call(this,e);}var p=u.prototype,d=m.prototype=r(p);d.init=function(){var e="NEJ-AJAX-DATA:",t=!1;function n(t){var n=t.data;if(0===o(n).call(n,e)){var r=(n=JSON.parse(n.replace(e,""))).key,i=l[r];i&&(delete l[r],n.result=decodeURIComponent(n.result||""),i.onLoad(n));}}return function(){!function(){if(!t){t=!0;var e=a.getGlobal();e.postMessage?a.on(e,"message",n):c.addMsgListener(n);}}();};}(),d.doSend=function(){var e=this.options,t=a.url2origin(e.url),n=e.proxyUrl||t+"/res/nej_proxy_frame.html",r=l[n];if(a.isArray(r)){var o;r.push(i(o=this.doSend).call(o,this,e));}else{var u;if(!r)return l[n]=[i(u=this.doSend).call(u,this,e)],void a.createIframe({src:n,onload:function onload(e){var t=l[n];l[n]=a.target(e).contentWindow,s(t).call(t,function(e){try{e();}catch(e){}});}});if(!this.aborted){var m=this.key=a.uniqueID();l[m]=this;var p=a.fetch({method:"GET",url:"",data:null,headers:{},timeout:0},e);p.key=m,c.postMessage(r,{data:p}),this.afterSend();}}},d.abort=function(){this.aborted=!0,delete l[this.key],p.abort.call(this);},e.exports=m;},function(e,t,n){var r,o,i=n(10),s=n(47),a=n(106),c=(r=/json/i,o=/post/i,function(e,t){var n=(t=t||{}).data=t.data||{},c=t.headers=t.headers||{},u=s.checkWithDefault(c,"Accept","application/json"),l=s.checkWithDefault(c,"Content-Type","application/json");return r.test(u)&&(t.type="json"),o.test(t.method)&&r.test(l)&&(t.data=i(n)),a(e,t);});e.exports=c;},function(e,t,n){var r=n(5),o=n(17),i=n(4),s=n(2),a=n(9),c=n(16);e.exports={wrapSafeCallback:function wrapSafeCallback(e,t){if(!e.__wrapSafeCallback__){e.__wrapSafeCallback__=!0;var n=r(e);return n=o(n).call(n,function(t){return 0===i(t).call(t,"on")&&"[object Function]"===Object.prototype.toString.call(e[t]);}),s(n).call(n,function(n){var r=e[n];e[n]=function(){try{var e;return r.call.apply(r,a(e=[this]).call(e,c(Array.prototype).call(arguments)));}catch(e){t.logger&&t.logger.error("userOption:".concat(n," function error"),e);}};}),e;}}};},function(e,t,n){var r=n(57).fn;r.isConnected=function(){return!!this.protocol&&this.protocol.isConnected();},r.connect=function(){this.protocol.connect();},r.disconnect=function(){};},function(e,t,n){var r=n(22),o=n(10),i=n(23),s=n(7),a=n(35),c=n(16),u=n(128),l=n(71),m=n(4),p=n(48),d=n(27),f=n(6),g=n(30),h=n(2),y=n(9),v=n(5),b=n(59),T=n(17),S=n(60),M=n(61),k=n(62),x=n(46),C=n(58),I=n(109),_=["loc_x","loc_y","loc_z"];function w(e,t){var n=v(e);if(b){var r=b(e);t&&(r=T(r).call(r,function(t){return S(e,t).enumerable;})),n.push.apply(n,r);}return n;}function P(e){for(var t=1;t<arguments.length;t++){var n,r,o=null!=arguments[t]?arguments[t]:{};t%2?h(n=w(Object(o),!0)).call(n,function(t){C(e,t,o[t]);}):M?k(e,M(o)):h(r=w(Object(o))).call(r,function(t){x(e,t,S(o,t));});}return e;}var A=n(57).fn,O=n(0),E=n(587),R=n(39),j=n(14),N=n(264),U=n(265),D=n(269),L=n(90).EMExceptionState;A.sendText=function(e){var t=e,n=t.loc_x,r=t.loc_y,o=t.loc_z,i=I(t,_);return void 0===n||void 0===r||void 0===o?e=P({},i):("number"!=typeof e.loc_x&&(e.loc_x=0),"number"!=typeof e.loc_y&&(e.loc_y=0),"number"!=typeof e.loc_z&&(e.loc_z=0)),this.processCallback(e),e.msg=new this.message.TextMessage(e),this.sendMsg(e);},A.previewFile=function(e,t){var n,r=this,a=r.protocol.appGrayConfig;if(a&&a.grayConfig&&a.grayConfig.mixStoreEnable&&(e.mixEnable=!0),O.verifyOptions(e,"done","msg::previewFile"),e.type||(e.type="file"),O.verifyParamPresentJustOne(e,"dataURL blob fileInput filePath wxFilePath fileObject","msg::previewFile"),O.exist(e.maxSize)&&O.verifyParamType("maxSize",e.maxSize,"number","api::previewFile"),O.exist(e.commonUpload)&&O.verifyParamType("commonUpload",e.commonUpload,"boolean","api::previewFile"),e.nosSurvivalTime?(O.verifyParamType("nosSurvivalTime",e.nosSurvivalTime,"number","api::Base.getInstance"),O.verifyParamMin("nosSurvivalTime",e.nosSurvivalTime,86400,"api::Base.getInstance")):e.nosSurvivalTime=this.nosSurvivalTime,e.filePath=e.filePath||e.wxFilePath,delete e.wxFilePath,e.dataURL)e.blob=D.fromDataURL(e.dataURL);else if(e.blob);else if(e.fileInput){if(e.fileInput=O.verifyFileInput(e.fileInput,"msg::previewFile"),e.fileInput.files){if(!e.fileInput.files.length)return void e.done(R.newNoFileError("请选择"+e.type+"文件",{callFunc:"msg::previewFile",fileInput:e.fileInput}),e);e.fileSize=e.fileInput.files[0].size;}e.fileInputName=O.getFileName(e.fileInput);}this.processCallback(e);var c=o(N.genResponseBody(e.type)||{}).replace(/"/gi,'\\"'),u=null,l=e.transcode?"getNosTokenTrans":"getNosToken";if(e.transcode){O.verifyOptions(e,"fileInput","msg::previewFile");var m=O.getFileInfo(e.fileInput);u={transToken:{name:m.name,type:m.transcodeType,transType:"png"===e.transcode?11:10,size:m.size,body:c}};}else u=c;this[l]({responseBody:u,nosToken:{nosScene:e.nosScene||this.nosScene,nosSurvivalTime:e.nosSurvivalTime},callback:i(n=function n(_n5,o){if(_n5)e.done(_n5);else if(e.transcode?(e.nosToken=o.nosToken,e.docId=o.docId):e.nosToken=o,e.logger=r.logger,e.mixEnable){var a,c;if(!this.protocol.mixStorePolicy)try{this.protocol.mixStorePolicy=JSON.parse(localStorage.getItem("NIM-AllMixStorePolicy"))[this.options.appKey];}catch(e){r.logger.error("error:","get last mixStorePolicy failed",e);}if(!this.protocol.mixStorePolicy)return void r.logger.error("error:","get mixStorePolicy failed");e.providers=s(a=this.protocol.mixStorePolicy.providers||[]).call(a,function(e){return Number(e);}),e.curProvider=e.providers[0]?Number(e.providers[0]):1,e.nosPolicy=this.protocol.mixStorePolicy.nosPolicy,e.s3Policy=this.protocol.mixStorePolicy.s3Policy,r.getMixStoreToken({curProvider:e.curProvider,responseBody:u,callback:i(c=function c(n,o){n?e.done(n):(e.mixStoreToken=o,e.getMixStoreToken=function(t,n){r.getMixStoreToken({curProvider:t,responseBody:u,callback:function callback(t,r){t?e.done(t):n(r);}});},1===e.curProvider&&(e.nosToken=o),r._doPreviewFile(e,t));}).call(c,r)});}else this._doPreviewFile(e,t);}).call(n,this)});},A._doPreviewFile=function(e,t){var n=this;e=O.merge(e,n.options.providers);var o=j.genUploadUrl(e.nosToken.bucket);e.mixEnable&&1===e.curProvider&&(o=j.genUploadUrl(e.mixStoreToken.bucket));var i,l=j.chunkUploadUrl;n.logger.info("_doPreviewFile: start upload"),e.commonUpload||!l||j.isWeixinApp||j.isNodejs||j.isRN?(e.commonUpload=!0,i=o):(i=l,e.nosLbsUrls=j.nosLbsUrls,n.options.edgeList?e.edgeList=n.options.edgeList:e.updateNosEdgeList=function(e){n.options.edgeList=e;}),n.protocol.reporterHook.emit("reporter/uploadStart");var m=this.assembleUploadParams(e.nosToken);e.mixEnable&&1===e.curProvider&&(m=this.assembleUploadParams(e.mixStoreToken));function p(r,o,i,s){if(r){var l=O.get(r,"msg.message")||O.get(r,"message")||"Unknown error message",p=O.get(r,"msg.code")||O.get(r,"code")||"Unknown error code";n.logger.warn("_doPreviewFile: upload done, failed ",p,l),n.protocol.reporterHook.emit("reporter/uploadEnd","RequestAbortedError"===r.code||"abort"===r.code?L.kCanceled:L.kFailed);var d=a({},s||t,{status:"fail"}),f=P(P({},e.callback.options),{},{msg:d});return e.uploaddone(r,f,d),void e.done(r,e.callback.options);}if(n.logger.info("_doPreviewFile: upload done, success"),n.protocol.reporterHook.emit("reporter/uploadEnd",L.kSucceed),e.uploaddone(null,O.copy(o),s||t),o=N.parseResponse(o,n.options.exifOrientation),i||o.isS3||(o.url=j.genDownloadUrl(e.nosToken,m.Object,j.serverNosConfig.cdnDomain),e.nosToken.shortUrl&&(o._url_safe=e.nosToken.shortUrl)),O.exist(e.fileInputName))o.name=e.fileInputName;else if(e.blob){var g=e.blob.name;if(o.name=g||"blob-"+o.md5,!g){var h=e.blob.type;o.ext=c(h).call(h,u(h).call(h,"/")+1);}}else e.filePath?o.name=e.filePath:e.fileObject&&(o.name=e.fileObject.fileName);if(!o.ext){var y,v,b=u(y=o.name).call(y,".");if(-1===b)o.ext="unknown";else o.ext=c(v=o.name).call(v,b+1);}o.size=o.size||0,o.isS3&&o._url_safe?n.getNosOriginUrl({safeShortUrl:o._url_safe,done:function done(t,r){t?n.logger.error("error:","getNosOriginUrl failed",t):(o.url=r,e.done(null,O.copy(o)));}}):e.done(null,O.copy(o));}if(j.isWeixinApp)O.verifyOptions(e,"filePath","msg::_doPreviewFile"),n.fileQuickTransfer(e,p,function(){var r=wx.uploadFile({url:i,filePath:e.filePath,name:"file",formData:m,fail:function fail(e){p({code:"FAILED",msg:e}),n.logger.error("error:","api::msg:upload file failed",e);},success:function success(e){if(200===e.statusCode)try{p(null,JSON.parse(e.data));}catch(t){n.logger.error("error:","parse wx upload file res error",t),p({code:"PARSE_WX_UPLOAD_FILE_RES_ERROR",str:e.data,msg:e.errMsg});}else p({code:e.statusCode,msg:e.errMsg});}});"function"==typeof e.uploadprogress&&r&&(e.beginupload(r,t),n.logger.info("_doPreviewFile::mini uploadprogress"),r.onProgressUpdate(function(n){e.uploadprogress({total:n.totalBytesExpectedToSend,loaded:n.totalBytesSent,percentage:n.progress,percentageText:n.progress+"%"},t);}));});else if(j.isNodejs){var d={url:i,name:"file",formData:m,success:function success(e){if(200===e.statusCode)try{p(null,JSON.parse(e.data));}catch(t){n.protocol.logger.error("error:","parse nodejs upload file res error",t),p({code:"PARSE_NODEJS_UPLOAD_FILE_RES_ERROR",str:e.data,msg:e.errMsg});}else p({code:e.statusCode,msg:e.errMsg});},fail:function fail(e){p({code:"FAILED",msg:e}),n.protocol.logger.error("error:","api::msg:upload file failed",e);}};if(e.filePath)d.filePath=e.filePath;else{if("object"!==r(e.fileObject))throw new R("Nodejs上传fileObject参数类型应如 {fileName:..,fileData:..} ");d.fileData=e.fileObject.fileData;}n.fileQuickTransfer(e,p,function(){U.uploadFile(d);});}else if(j.isRN){var f={url:i,name:"file",formData:m,filePath:e.filePath,success:function success(e){if(e.ok&&200===e.status)try{var t=s(e.headers)&&s(e.headers).etag;e.md5=t?"string"==typeof t?t:t[0]:"UNKNOWN",p(null,e);}catch(t){n.protocol.logger.error("error:","parse React Native upload file res error",t),p({code:"PARSE_React_Native_UPLOAD_FILE_RES_ERROR",res:e});}else p({code:e.status,msg:e.statusText});},fail:function fail(e){p({code:"FAILED",msg:e}),n.protocol.logger.error("error:","api::msg:upload file failed",e);}};n.fileQuickTransfer(e,p,function(){U.uploadFile(f);});}else e.url=i,e.params=m,e.fileName="file",n.fileQuickTransfer(e,p,function(){return n.protocol.adaptersUploadFile(a({},e,{uploaddone:p}),t);});},A.fileQuickTransfer=function(e,t,n){var r,o=this;e=e||{},t instanceof Function||(t=function t(){}),n instanceof Function||(n=function n(){});var i=e.fastPass;if(i)try{i=JSON.parse(i),e.fastPass=i;}catch(e){o.protocol.logger.error("快传参数解析失败");}var s=e.fileInputName||e.name||e.blob&&e.blob.name||"",a=e.fileSize||e.size||e.blob&&e.blob.size||0,m=i?l(r=(i.md5||e.digest||"")+"").call(r):"",p=e.type||e.blob&&e.blob.type;if(m&&a>=j.threshold){var d=!0,f={name:s,md5:m,ext:c(s).call(s,u(s).call(s,".")+1),type:p};switch(p){case"image":i&&i.w&&i.h?(f.w=i.w,f.h=i.h):(d=!1,o.protocol.logger.error("快传 image 文件缺少参数 w 或 h"));break;case"video":i&&i.w&&i.h&&i.dur?(f.w=i.w,f.h=i.h,f.dur=i.dur):(d=!1,o.protocol.logger.error("快传 video 文件缺少参数 w 或 h 或 dur"));break;case"audio":i&&i.dur?f.dur=i.dur:(d=!1,o.protocol.logger.error("快传 audio 文件缺少参数 dur"));}if(!d)return void n();var g={fileQuickTransfer:{md5:m}};return a&&(g.fileQuickTransfer.size=a),this.protocol.sendCmd("fileQuickTransfer",g,function(e,r,i){!e&&i&&i.fileQuickTransfer&&i.fileQuickTransfer.url||(o.protocol.logger.error("misc::fileQuickTransfer: not found",e,r),n()),i&&i.fileQuickTransfer&&i.fileQuickTransfer.threshold&&(j.threshold=i.fileQuickTransfer.threshold||0),i&&i.fileQuickTransfer&&i.fileQuickTransfer.url&&(f.size=a||i.fileQuickTransfer.size,f.url=i.fileQuickTransfer.url,i.fileQuickTransfer._url_safe&&(f._url_safe=i.fileQuickTransfer._url_safe),t(e,f,!0));});}n();},A.sendFile=function(e){if(e.type||(e.type="file"),e=O.merge(e,this.options.providers),O.verifyParamPresentJustOne(e,"dataURL blob fileInput file filePath wxFilePath fileObject","msg::sendFile"),O.exist(e.maxSize)&&O.verifyParamType("maxSize",e.maxSize,"number","api::previewFile"),O.exist(e.commonUpload)&&O.verifyParamType("commonUpload",e.commonUpload,"boolean","api::previewFile"),this.processCallback(e),e.filePath=e.filePath||e.wxFilePath,delete e.wxFilePath,e.dataURL)return this._previewAndSendFile(e);if(e.blob)return this._previewAndSendFile(e);if(e.fileInput)return e.fileInput=O.verifyFileInput(e.fileInput,"msg::sendFile"),e.fileInput.files&&!e.fileInput.files.length?void e.done(R.newNoFileError("请选择"+e.type+"文件",{callFunc:"msg::sendFile",fileInput:e.fileInput}),e.callback.options):this._previewAndSendFile(e);if(e.filePath||e.fileObject)return this._previewAndSendFile(e);if(e.file){var t,n=e.file._url_safe;return n&&(t=e.file.url,e.file.url=n,delete e.file._url_safe),e.msg=new this.message.FileMessage(e),this.sendMsg(e,t);}},A._previewAndSendFile=function(e){var t=this;O.verifyCallback(e,"uploaddone beforesend","msg::_previewAndSendFile");var n=P({},e),r=new t.message.Message(n);r.type=e.type;var o=t.formatReturnMsg(r),i=t.protocol.reporterHook.getSafeClock(),s={apiCallingTime:t.protocol.reporterHook.getNTPTime(i),attachUploadDuration:0},c=e.done;return e.done=function(n,u){if(e.done=c,n){var l=a({},o,{status:"fail"}),m=P(P({},e.callback.options),{},{msg:l});e.done(n,m);}else{if(s.attachUploadDuration=t.protocol.reporterHook.getSafeClock()-i,/chatroom/.test(e.scene))return;var p,d=u._url_safe;d&&!u.isS3&&(p=u.url,u.url=d,delete u._url_safe),e.file=u,e.msg=new t.message.FileMessage(e,r.idClient),e.beforesend(t.sendMsg(e,p,s));}},t.previewFile(e,o),o;},A.assembleUploadParams=function(e){return e?{Object:decodeURIComponent(e.objectName),"x-nos-token":e.token,"x-nos-entity-type":"json"}:null;},A.deleteFile=function(e){O.verifyParamPresentJustOne(e,"docId","msg::deleteFile"),this.removeFile({docId:e.docId,callback:function callback(t,n){t?e.error&&e.error(t,n):e.success&&e.success(n);}});},A.getFile=function(e){O.verifyParamPresentJustOne(e,"docId","msg::getFile"),this.fetchFile({docId:e.docId,callback:function callback(t,n){t?e.error&&e.error(t,n):e.success&&e.success(n.info);}});},A.getFileList=function(e){var t=e.fromDocId,n=void 0===t?"":t,r=e.limit,o=void 0===r?10:r,i={limit:o};n&&(i.fromDocId=n),this.fetchFileList({fileListParam:i,callback:function callback(t,n){t?(o>30&&(t.message=t.message+"::文档条数超过限制:30"),e.error&&e.error(t,n)):e.success&&e.success(n);}});},A.sendGeo=function(e){return this.processCallback(e),e.msg=new this.message.GeoMessage(e),this.sendMsg(e);},A.sendTipMsg=function(e){return this.processCallback(e),e.msg=new this.message.TipMessage(e),this.sendMsg(e);},A.sendCustomMsg=function(e){return this.processCallback(e),e.msg=new this.message.CustomMessage(e),this.sendMsg(e);},A.sendRobotMsg=function(e){this.logger.warn("this api will be abandon");return this.processCallback(e),e.msg=new this.message.RobotMessage(e),this.sendMsg(e);},A.sendMsg=function(e,t,n){var r=this,i=r.protocol,s=e.msg,a={};n=n||{apiCallingTime:i.reporterHook.getNTPTime(),attachUploadDuration:0};var c,u=!!e.isLocal;if(this.logger.warn("sendMsg::start: "+s.idClient),u&&(e.time&&(s.time=e.time),e.idClient&&(s.idClient=e.idClient),e.localFrom&&(c=e.localFrom+"")),e.resend&&("out"!==e.flow||"fail"!==e.status))return O.onError("只能重发发送失败的消息");e.callback.options.idClient=s.idClient,r.beforeSendMsg(e,a);var l=e.rtnMsg=r.formatReturnMsg(s,c);if(t&&!r.options.keepNosSafeUrl&&l.file&&(l.file._url_safe=l.file.url,l.file.url=t,"audio"===l.type&&(l.file.mp3Url=t+(~m(t).call(t,"?")?"&":"?")+"audioTrans&type=mp3")),l.hasOwnProperty("chatroomId")&&!l.chatroomId)return O.onError("聊天室未连接");if(u&&(l.status="success",l.isLocal=!0),i.storeSendMsg&&(a.promise=i.storeSendMsg(l)),e.cbaop=function(e,t){if(e)return 7101===e.code&&(l.isInBlackList=!0,l.idServer=t.idServer,l.time=t.time),"server"!==e.from?(l.status="fail",i.updateSendMsgError&&i.updateSendMsgError(l),l):void 0;},!u){t&&!r.options.keepNosSafeUrl&&e.callback&&(e.callback.originUrl=t),e.toAccids&&e.toAccids.length&&(s.toAccids=o(e.toAccids)),a.msg=s,n.sendTime=i.reporterHook.getNTPTime(),i.reporterHook.hasOriginTimetick()&&(a.msg.__clientExt=o({statistics:n}));var f=s;r.sendCmd(e.cmd,a,function(){if(j.isBrowser){var t=arguments[0],o=arguments[1]||{},s="chatroom"===r.subType,a=0===f.scene,c=i.reporterHook.getNTPTime(),u={msgId:o.idServer,clientId:f.idClient,msgTime:o.time||0,fromAccid:r.account,toAccid:a?f.to:"",type:s?4:f.scene,roomId:s?r.options.chatroomId:"",tid:s||a?"":f.to,result:t?t.code:200,failReason:t?t.message:"",rt:p(c-n.apiCallingTime),apiCallingTime:n.apiCallingTime,sendTime:n.sendTime,attachUploadDuration:n.attachUploadDuration,apiCallbackTime:c};r.reporter&&r.reporter.report("msgSend",u);}e.callback&&e.callback.apply(r,arguments);var l=arguments[0],m=arguments[1];!l&&m&&m.from===m.to&&r.protocol.markMsgRead(m);});}return r.afterSendMsg(e),u&&d(function(){l=O.simpleClone(l),e.done(null,l);},0),O.copy(l);},A.beforeSendMsg=function(){},A.afterSendMsg=function(){},A.formatReturnMsg=function(e,t){var n;return e=O.copy(e),this.protocol.completeMsg(e),e.status="sending",t&&(e.from=t),e=f(n=this.message).call(n,e),e=this.protocol.amendMsg(e);},A.resendMsg=function(e){return O.verifyOptions(e,"msg","msg::resendMsg"),this.trimMsgFlag(e),e.resend=!0,this._sendMsgByType(e);},A.forwardMsg=function(e){return O.verifyOptions(e,"msg","msg::forwardMsg"),this.trimMsgFlag(e),this.beforeForwardMsg(e),e.forward=!0,e.msg.idClient=O.guid(),this._sendMsgByType(e);},A.trimMsgFlag=function(e){e&&e.msg&&(e.msg=O.copy(e.msg),delete e.msg.resend,delete e.msg.forward);},A.beforeForwardMsg=function(){},A._sendMsgByType=function(e){switch(O.verifyOptions(e,"msg","msg::_sendMsgByType"),O.verifyParamValid("msg.type",e.msg.type,this.message.validTypes,"msg::_sendMsgByType"),O.merge(e,e.msg),e.type){case"text":return this.sendText(e);case"image":case"audio":case"video":case"file":return this.sendFile(e);case"geo":return this.sendGeo(e);case"custom":return this.sendCustomMsg(e);case"tip":return this.sendTipMsg(e);default:throw new R("不能发送类型为 "+e.type+" 的消息");}},A.parseRobotTemplate=function(e){if(this.logger.warn("this api will be abandon"),/<template[^>/]+\/>/.test(e))return{raw:e,json:[{type:"text",name:"",text:""}]};if(!/<template[^>/]+>/.test(e))return{raw:e,json:[{type:"text",name:"",text:e}]};var t=new E({escapeMode:!1});e=e.replace(/<template [^>]+>/,"<template>");var n=t.xml2js(e);n=n.template.LinearLayout,g(n)||(n=[n]);var r=[];return n=h(n).call(n,function(e){e.image&&(r=y(r).call(r,i(e))),e.text&&(r=y(r).call(r,o(e))),e.link&&(r=y(r).call(r,function(e){if(e.link){var t=e.link;g(t)||(t=[t]),t=s(t).call(t,function(e){return e.image&&(e.image=i(e)),e.text&&(e.text=o(e)),"url"===e._type?(e.type="url",e.style=e._style||"",e.target=e._target,delete e._target,delete e._style):"block"===e._type&&(e.type="block",e.style=e._style||"",e.params=e._params||"",e.target=e._target,delete e._params,delete e._target,delete e._style),delete e._type,e;}),e.link=t;}return e.link;}(e)));}),{raw:e,json:r};function o(e){var t;return g(e.text)||(e.text=[e.text]),e.text=s(t=e.text).call(t,function(e){return{type:"text",name:e._name,text:e.__text};}),e.text;}function i(e){var t;return g(e.image)||(e.image=[e.image]),e.image=s(t=e.image).call(t,function(e){return{type:"image",name:e._name,url:e._url};}),e.image;}};},function(e,t,n){n(570);var r=n(11);e.exports=r.Object.assign;},function(e,t,n){var r=n(1),o=n(571);r({target:"Object",stat:!0,arity:2,forced:Object.assign!==o},{assign:o});},function(e,t,n){"use strict";var r=n(28),o=n(13),i=n(25),s=n(8),a=n(108),c=n(119),u=n(138),l=n(37),m=n(111),p=Object.assign,d=Object.defineProperty,f=o([].concat);e.exports=!p||s(function(){if(r&&1!==p({b:1},p(d({},"a",{enumerable:!0,get:function get(){d(this,"b",{value:3,enumerable:!1});}}),{b:2})).b)return!0;var e={},t={},n=Symbol();return e[n]=7,"abcdefghijklmnopqrst".split("").forEach(function(e){t[e]=e;}),7!=p({},e)[n]||"abcdefghijklmnopqrst"!=a(p({},t)).join("");})?function(e,t){for(var n=l(e),o=arguments.length,s=1,p=c.f,d=u.f;o>s;){for(var g,h=m(arguments[s++]),y=p?f(a(h),p(h)):a(h),v=y.length,b=0;v>b;){g=y[b++],r&&!i(d,h,g)||(n[g]=h[g]);}}return n;}:p;},function(e,t,n){var r=n(19),o=n(573),i=Array.prototype;e.exports=function(e){var t=e.reverse;return e===i||r(i,e)&&t===i.reverse?o:t;};},function(e,t,n){n(574);var r=n(24);e.exports=r("Array").reverse;},function(e,t,n){"use strict";var r=n(1),o=n(13),i=n(67),s=o([].reverse),a=[1,2];r({target:"Array",proto:!0,forced:String(a)===String(a.reverse())},{reverse:function reverse(){return i(this)&&(this.length=this.length),s(this);}});},function(e,t,n){e.exports=n(576);},function(e,t,n){e.exports=n(577);},function(e,t,n){var r=n(578);e.exports=r;},function(e,t,n){var r=n(241);e.exports=r;},function(e,t,n){e.exports=n(580);},function(e,t,n){var r=n(581);e.exports=r;},function(e,t,n){var r=n(190);e.exports=r;},function(e,t,n){var r=n(583),o=n(263);e.exports=function(e,t){if(null==e)return{};var n,i,s={},a=r(e);for(i=0;i<a.length;i++){n=a[i],o(t).call(t,n)>=0||(s[n]=e[n]);}return s;},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(584);},function(e,t,n){e.exports=n(585);},function(e,t,n){var r=n(586);e.exports=r;},function(e,t,n){var r=n(237);e.exports=r;},function(e,t,n){var r,o,i;!function(n,s){"use strict";o=[],void 0===(i="function"==typeof(r=function r(e){return function(t){(t=t||{}).arrayAccessForm=t.arrayAccessForm||"none",t.emptyNodeForm=t.emptyNodeForm||"text",t.jsAttributeFilter=t.jsAttributeFilter,t.jsAttributeConverter=t.jsAttributeConverter,t.attributeConverters=t.attributeConverters||[],t.datetimeAccessFormPaths=t.datetimeAccessFormPaths||[],t.arrayAccessFormPaths=t.arrayAccessFormPaths||[],t.xmldomOptions=t.xmldomOptions||{},void 0===t.enableToStringFunc&&(t.enableToStringFunc=!0),void 0===t.skipEmptyTextNodesForObj&&(t.skipEmptyTextNodesForObj=!0),void 0===t.stripWhitespaces&&(t.stripWhitespaces=!0),void 0===t.useDoubleQuotes&&(t.useDoubleQuotes=!0),void 0===t.ignoreRoot&&(t.ignoreRoot=!1),void 0===t.escapeMode&&(t.escapeMode=!0),void 0===t.attributePrefix&&(t.attributePrefix="_"),void 0===t.selfClosingElements&&(t.selfClosingElements=!0),void 0===t.keepCData&&(t.keepCData=!1),void 0===t.keepText&&(t.keepText=!1),void 0===t.jsDateUTC&&(t.jsDateUTC=!1),function(){function e(e){var t=String(e);return 1===t.length&&(t="0"+t),t;}"function"!=typeof String.prototype.trim&&(String.prototype.trim=function(){return this.replace(/^\s+|^\n+|(\s|\n)+$/g,"");}),"function"!=typeof Date.prototype.toISOString&&(Date.prototype.toISOString=function(){return this.getUTCFullYear()+"-"+e(this.getUTCMonth()+1)+"-"+e(this.getUTCDate())+"T"+e(this.getUTCHours())+":"+e(this.getUTCMinutes())+":"+e(this.getUTCSeconds())+"."+String((this.getUTCMilliseconds()/1e3).toFixed(3)).slice(2,5)+"Z";});}();var n=1,r=3,o=4,i=8,s=9;function a(e){var t=e.localName;return null==t&&(t=e.baseName),null!=t&&""!==t||(t=e.nodeName),t;}function c(e){return"string"==typeof e?e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;"):e;}function u(e,n,r){switch(t.arrayAccessForm){case"property":e[n]instanceof Array?e[n+"_asArray"]=e[n]:e[n+"_asArray"]=[e[n]];}if(!(e[n]instanceof Array)&&t.arrayAccessFormPaths.length>0){for(var o=!1,i=0;i<t.arrayAccessFormPaths.length;i++){var s=t.arrayAccessFormPaths[i];if("string"==typeof s){if(s===r){o=!0;break;}}else if(s instanceof RegExp){if(s.test(r)){o=!0;break;}}else if("function"==typeof s&&s(n,r)){o=!0;break;}}o&&(e[n]=[e[n]]);}}function l(e){var t=e.split(/[-T:+Z]/g),n=new Date(t[0],t[1]-1,t[2]),r=t[5].split(".");if(n.setHours(t[3],t[4],r[0]),r.length>1&&n.setMilliseconds(r[1]),t[6]&&t[7]){var o=60*t[6]+Number(t[7]);o=0+("-"===(/\d\d-\d\d:\d\d$/.test(e)?"-":"+")?-1*o:o),n.setMinutes(n.getMinutes()-o-n.getTimezoneOffset());}else-1!==e.indexOf("Z",e.length-1)&&(n=new Date(Date.UTC(n.getFullYear(),n.getMonth(),n.getDate(),n.getHours(),n.getMinutes(),n.getSeconds(),n.getMilliseconds())));return n;}function m(e,n){for(var r={__cnt:0},o=e.childNodes,s=0;s<o.length;s++){var c=o.item(s),m=a(c);c.nodeType!==i&&(r.__cnt++,null==r[m]?(r[m]=p(c,n+"."+m),u(r,m,n+"."+m)):(r[m]instanceof Array||(r[m]=[r[m]],u(r,m,n+"."+m)),r[m][r[m].length]=p(c,n+"."+m)));}for(var d=0;d<e.attributes.length;d++){var f=e.attributes.item(d);r.__cnt++;for(var g=f.value,h=0;h<t.attributeConverters.length;h++){var y=t.attributeConverters[h];y.test.call(null,f.name,f.value)&&(g=y.convert.call(null,f.name,f.value));}r[t.attributePrefix+f.name]=g;}var v=e.prefix;return v&&(r.__cnt++,r.__prefix=v),r["#text"]&&(r.__text=r["#text"],r.__text instanceof Array&&(r.__text=r.__text.join("\n")),t.escapeMode&&(r.__text=r.__text.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"').replace(/&#x27;/g,"'").replace(/&amp;/g,"&")),t.stripWhitespaces&&(r.__text=r.__text.trim()),delete r["#text"],"property"===t.arrayAccessForm&&delete r["#text_asArray"],r.__text=function(e,n,r){if(t.datetimeAccessFormPaths.length>0)for(var o=r.split(".#")[0],i=0;i<t.datetimeAccessFormPaths.length;i++){var s=t.datetimeAccessFormPaths[i];if("string"==typeof s){if(s===o)return l(e);}else if(s instanceof RegExp){if(s.test(o))return l(e);}else if("function"==typeof s&&s(o))return l(e);}return e;}(r.__text,0,n+".#text")),r.hasOwnProperty("#cdata-section")&&(r.__cdata=r["#cdata-section"],delete r["#cdata-section"],"property"===t.arrayAccessForm&&delete r["#cdata-section_asArray"]),1===r.__cnt&&r.__text&&!t.keepText?r=r.__text:0===r.__cnt&&"text"===t.emptyNodeForm?r="":r.__cnt>1&&void 0!==r.__text&&t.skipEmptyTextNodesForObj&&(t.stripWhitespaces&&""===r.__text||""===r.__text.trim())&&delete r.__text,delete r.__cnt,t.keepCData||r.hasOwnProperty("__text")||!r.hasOwnProperty("__cdata")||1!==Object.keys(r).length?(t.enableToStringFunc&&(r.__text||r.__cdata)&&(r.toString=function(){return(this.__text?this.__text:"")+(this.__cdata?this.__cdata:"");}),r):r.__cdata?r.__cdata:"";}function p(e,i){return e.nodeType===s?function(e){for(var r={},o=e.childNodes,i=0;i<o.length;i++){var s=o.item(i);if(s.nodeType===n){var c=a(s);t.ignoreRoot?r=p(s,c):r[c]=p(s,c);}}return r;}(e):e.nodeType===n?m(e,i):e.nodeType===r||e.nodeType===o?e.nodeValue:null;}function d(e,n,r,o){var i="<"+(e&&e.__prefix?e.__prefix+":":"")+n;if(r)for(var s=0;s<r.length;s++){var a=r[s],u=e[a];t.escapeMode&&(u=c(u)),i+=" "+a.substr(t.attributePrefix.length)+"=",t.useDoubleQuotes?i+='"'+u+'"':i+="'"+u+"'";}return i+=o?" />":">";}function f(e,t){return"</"+(e&&e.__prefix?e.__prefix+":":"")+t+">";}function g(e,n){return"property"===t.arrayAccessForm&&(r=n.toString(),o="_asArray",-1!==r.indexOf(o,r.length-o.length))||0===n.toString().indexOf(t.attributePrefix)||0===n.toString().indexOf("__")||e[n]instanceof Function;var r,o;}function h(e){var t=0;if(e instanceof Object)for(var n in e){g(e,n)||t++;}return t;}function y(e){var n=[];if(e instanceof Object)for(var r in e){-1===r.toString().indexOf("__")&&0===r.toString().indexOf(t.attributePrefix)&&n.push(r);}return n;}function v(e){var n="";return e instanceof Object?n+=function(e){var n="";return e.__cdata&&(n+="<![CDATA["+e.__cdata+"]]>"),(e.__text||"number"==typeof e.__text||"boolean"==typeof e.__text)&&(t.escapeMode?n+=c(e.__text):n+=e.__text),n;}(e):null!==e&&(t.escapeMode?n+=c(e):n+=e),n;}function b(e,n,r){var o="";if(t.jsAttributeFilter&&t.jsAttributeFilter.call(null,n,e))return o;if(t.jsAttributeConverter&&(e=t.jsAttributeConverter.call(null,n,e)),null!=e&&""!==e||!t.selfClosingElements){if("object"==(typeof e==="undefined"?"undefined":_typeof(e))){if("[object Array]"===Object.prototype.toString.call(e))o+=function(e,t,n){var r="";if(0===e.length)r+=d(e,t,n,!0);else for(var o=0;o<e.length;o++){r+=b(e[o],t,y(e[o]));}return r;}(e,n,r);else if(e instanceof Date)o+=d(e,n,r,!1),o+=t.jsDateUTC?e.toUTCString():e.toISOString(),o+=f(e,n);else{h(e)>0||"number"==typeof e.__text||"boolean"==typeof e.__text||e.__text||e.__cdata?(o+=d(e,n,r,!1),o+=T(e),o+=f(e,n)):t.selfClosingElements?o+=d(e,n,r,!0):(o+=d(e,n,r,!1),o+=f(e,n));}}else o+=d(e,n,r,!1),o+=v(e),o+=f(e,n);}else o+=d(e,n,r,!0);return o;}function T(e){var t="";if(h(e)>0)for(var n in e){if(!g(e,n)){var r=e[n];t+=b(r,n,y(r));}}return t+=v(e);}function S(n){if(void 0===n)return null;if("string"!=typeof n)return null;var r=null,o=null;if(e)o=(r=new e(t.xmldomOptions)).parseFromString(n,"text/xml");else if(window&&window.DOMParser){r=new window.DOMParser();var i=null;if(!(window.ActiveXObject||"ActiveXObject"in window)&&document.all&&!document.addEventListener)try{i=r.parseFromString("INVALID","text/xml").childNodes[0].namespaceURI;}catch(e){i=null;}try{o=r.parseFromString(n,"text/xml"),null!==i&&o.getElementsByTagNameNS(i,"parsererror").length>0&&(o=null);}catch(e){o=null;}}else 0===n.indexOf("<?")&&(n=n.substr(n.indexOf("?>")+2)),(o=new ActiveXObject("Microsoft.XMLDOM")).async="false",o.loadXML(n);return o;}this.asArray=function(e){return null==e?[]:e instanceof Array?e:[e];},this.toXmlDateTime=function(e){return e instanceof Date?e.toISOString():"number"==typeof e?new Date(e).toISOString():null;},this.asDateTime=function(e){return"string"==typeof e?l(e):e;},this.xml2dom=function(e){return S(e);},this.dom2js=function(e){return p(e,null);},this.js2dom=function(e){return S(this.js2xml(e));},this.xml2js=function(e){var t=S(e);return null!=t?this.dom2js(t):null;},this.js2xml=function(e){return T(e);},this.getVersion=function(){return"3.4.4";};};})?r.apply(t,o):r)||(e.exports=i);}();},function(e,t,n){var r=n(589);e.exports=r;},function(e,t,n){n(590);var r=n(11);e.exports=r.Date.now;},function(e,t,n){var r=n(1),o=n(13),i=Date,s=o(i.prototype.getTime);r({target:"Date",stat:!0},{now:function now(){return s(new i());}});},function(e,t,n){var r=n(106);e.exports=function(e,t){return t.method="POST",t.headers=t.headers||{},t.headers["Content-Type"]="multipart/form-data",t.timeout=0,t.type=t.type||"json",r(e,t);};},function(e,t,n){var r=n(16),o=n(48),i=n(4),s=n(3),a=n(14),c=a.chunkSize,u=n(106),l={mp4:"video/mp4",avi:"video/x-msvideo",wmv:"video/x-ms-wmv",mpeg:"video/mpeg",mov:"video/quicktime",aac:"audio/x-aac",wma:"audio/x-ms-wma",wav:"audio/x-wav",mp3:"audio/mp3"};e.exports=function e(t,n,m,p){var d={file:t.data[n],fileSize:t.data[n].size,fileUploadedSize:0,percentage:0},f=t.url;function g(e){var n=d.fileUploadedSize+e.loaded,r=Math.floor(1e4*n/d.fileSize)/100;if(o(r)>=100&&(r=100,g=function g(){}),d.percentage!==r){d.percentage=r;var i={docId:t.docId,total:d.fileSize,loaded:n,percentage:r,percentageText:r+"%"};t.fileInput&&(i.fileInput=t.fileInput),t.blob&&(i.blob=t.blob),t.uploadprogress(i);}}function h(e){try{e=JSON.parse(e);}catch(e){return void m.onError(e);}if(e.errMsg||e.errCode)m.onError(e);else if(e.offset<d.fileSize)delete T.onaftersend,d.fileUploadedSize=e.offset,function(e,t,n,o){var i=e.offset,s=e.offset+c;if("undefined"!=typeof FileReader){var a,l=new FileReader();l.readAsArrayBuffer(r(a=o.file).call(a,i,s)),l.addEventListener("load",function(n){t.data=n.target.result,t.query.offset=e.offset,t.query.complete=s>=o.fileSize,t.query.context=e.context,t.onuploading=g,t.onload=h,t.onerror=y,m.sn=u(f,t);}),l.addEventListener("error",function(e){t.onerror(e.target.error);});}else{var p;t.data=r(p=o.file).call(p,i,s),t.query.offset=e.offset,t.query.complete=s>=o.fileSize,t.query.context=e.context,t.onuploading=g,t.onload=h,t.onerror=y,m.sn=u(f,t);}}(e,T,0,d);else{var n=a.genFileUrl(t.nosToken);"image"===t.type?u(n+"?imageInfo",{onload:function onload(n){try{n=JSON.parse(n),t.uploaddone(null,{docId:e.docId,w:n.Width,h:n.Height,orientation:n.Orientation||"",type:n.Type,size:n.Size||d.fileSize});}catch(e){o(e);}},onerror:function onerror(r){if("undefined"!=typeof Image){var i=new Image();i.src=n,i.onload=function(){t.uploaddone(null,{docId:e.docId,w:i.width,h:i.height,size:d.fileSize});},i.onerror=function(e){o(e);};}else o(r);}}):"video"===t.type||"audio"===t.type?u(n+"?vinfo",{onload:function onload(n){try{(n=JSON.parse(n)).GetVideoInfo&&n.GetVideoInfo.VideoInfo&&(n=n.GetVideoInfo.VideoInfo),t.uploaddone(null,{docId:e.docId,w:n.Width,h:n.Height,dur:n.Duration,orientation:n.Rotate,audioCodec:n.AudioCodec,videoCodec:n.VideoCodec,container:n.Container,size:n.Size||d.fileSize});}catch(e){o(e);}},onerror:o}):t.uploaddone(null,{docId:e.docId,size:d.fileSize});}function o(e){m.onError(e);}}function y(r){t.errorHook(r,{url:f});var o=r&&r.code;function i(){try{if(r.result)var e=JSON.parse(r.result);else e=r;m.onError(e);}catch(e){m.onError(e);}}0===d.fileUploadedSize&&"abort"!==o?t.edgeList?p<t.edgeList.length-1?e(t,n,m,p+1):i():t.nosLbsUrls&&t.nosLbsUrls.length>0?function(e,t,n,r,o){return new s(function(i){function s(){o.adaptersRequest(n[e],{query:{version:"1.0",bucketname:t},method:"GET",onerror:a,onload:function onload(e){try{(e=JSON.parse(e))&&e.upload&&e.upload.length?i(e.upload):a();}catch(e){a();}}});}function a(){r.onLbsUrlFail(n[e]),e<n.length-1?(e++,s()):i([]);}s();});}(0,t.nosToken.bucket,t.nosLbsUrls,m,t).then(function(r){r.length>0?(t.edgeList=r,t.updateNosEdgeList&&t.updateNosEdgeList(r),e(t,n,m,p+1)):i();}):(t.edgeList=a.edgeList,e(t,n,m,p+1)):i();}"number"!=typeof p&&(p=-1),t.edgeList&&t.edgeList.length&&(p=p>0?p:0,f=t.edgeList[p]),f+="/"+t.nosToken.bucket+"/"+t.nosToken.objectName;var v=t.data.file&&t.data.file.type;if(!v||i(v).call(v,"/")<0){var b=(t.fileInputName||"").split(".").pop();"image"===t.type?v="image/"+("jpg"===b?"jpeg":b):"audio"!==t.type&&"video"!==t.type||(v=l[b]);}var T={query:{offset:0,complete:c>=d.fileSize,version:"1.0"},headers:{"Content-Type":v||"application/octet-stream","x-nos-token":t.nosToken.token},method:"POST",timeout:0,onaftersend:function onaftersend(){t.beginupload(m);},onuploading:g,onload:h,onerror:y};if("undefined"!=typeof FileReader){var S,M=new FileReader();M.addEventListener("load",function(e){T.data=e.target.result,m.sn=u(f,T);}),M.addEventListener("error",function(e){T.onerror(e.target.error);}),M.readAsArrayBuffer(r(S=d.file).call(S,0,c));}else{var k;T.data=r(k=d.file).call(k,0,c),m.sn=u(f,T);}};},function(e,t,n){e.exports=n(594);},function(e,t,n){var r=n(595);e.exports=r;},function(e,t,n){n(596);var r=n(11);e.exports=r.Reflect.construct;},function(e,t,n){var r=n(1),o=n(31),i=n(64),s=n(260),a=n(224),c=n(33),u=n(29),l=n(82),m=n(8),p=o("Reflect","construct"),d=Object.prototype,f=[].push,g=m(function(){function e(){}return!(p(function(){},[],e)instanceof e);}),h=!m(function(){p(function(){});}),y=g||h;r({target:"Reflect",stat:!0,forced:y,sham:y},{construct:function construct(e,t){a(e),c(t);var n=arguments.length<3?e:a(arguments[2]);if(h&&!g)return p(e,t,n);if(e==n){switch(t.length){case 0:return new e();case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);}var r=[null];return i(f,r,t),new(i(s,e,r))();}var o=n.prototype,m=l(u(o)?o:d),y=i(e,m,t);return u(y)?y:m;}});},function(e,t,n){var r=n(266),o=n(126),i=n(601);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=r(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),o(e,"prototype",{writable:!1}),t&&i(e,t);},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(599);},function(e,t,n){var r=n(600);e.exports=r;},function(e,t,n){var r=n(199);e.exports=r;},function(e,t,n){var r=n(173),o=n(184);function i(t,n){var s;return e.exports=i=r?o(s=r).call(s):function(e,t){return e.__proto__=t,e;},e.exports.__esModule=!0,e.exports.default=e.exports,i(t,n);}e.exports=i,e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(603);},function(e,t,n){var r=n(604);e.exports=r;},function(e,t,n){var r=n(605);e.exports=r;},function(e,t,n){var r=n(606);e.exports=r;},function(e,t,n){n(607);var r=n(11);e.exports=r.Object.setPrototypeOf;},function(e,t,n){n(1)({target:"Object",stat:!0},{setPrototypeOf:n(123)});},function(e,t,n){e.exports=n(609);},function(e,t,n){var r=n(610);e.exports=r;},function(e,t,n){var r=n(259);e.exports=r;},function(e,t,n){var r=n(22).default,o=n(612);e.exports=function(e,t){if(t&&("object"===r(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return o(e);},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(173),o=n(184),i=n(267);function s(t){var n;return e.exports=s=r?o(n=i).call(n):function(e){return e.__proto__||i(e);},e.exports.__esModule=!0,e.exports.default=e.exports,s(t);}e.exports=s,e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(615);},function(e,t,n){var r=n(616);e.exports=r;},function(e,t,n){var r=n(268);e.exports=r;},function(e,t,n){n(618);var r=n(11);e.exports=r.Object.getPrototypeOf;},function(e,t,n){var r=n(1),o=n(8),i=n(37),s=n(122),a=n(214);r({target:"Object",stat:!0,forced:o(function(){s(1);}),sham:!a},{getPrototypeOf:function getPrototypeOf(e){return s(i(e));}});},function(e,t,n){var r,o=n(128),i=n(4),s=n(10),a=n(23),c=n(7),u=n(16),l=n(5),m=n(0),p=n(57).fn,d=n(270),f=n(264),g=n(39);p.transDoc=function(e){var t;m.verifyOptions(e,"fileInput done","nos::transDoc");try{var n=e.fileInput.files[0],r=["ppt","pdf","pptx","doc","docx"],c=e.fileInputName=n.name,u={ppt:1,pptx:2,pdf:3,doc:6,docx:7},l=c.substring(o(c).call(c,".")+1);if(i(r).call(r,l)<0)return void e.done(g.newNoFileError("请上传正确格式的文件【ppt, pptx, pdf, doc, docx】",{callFunc:"nos: transDoc",fileInput:e.fileInput}),e);}catch(t){return void e.done(g.newNoFileError("请上传正确的文件节点",{callFunc:"msg::previewFile",fileInput:e.fileInput}),e);}var p=s(f.genResponseBody("file")||{}).replace(/"/gi,'\\"'),d={transToken:{name:c,type:u[l],transType:"png"===e.transcode?11:10,size:n.size,body:p}};this.getNosTokenTrans({responseBody:d,nosToken:{nosScene:e.nosScene||this.nosScene,nosSurvivalTime:e.nosSurvivalTime},callback:a(t=function t(_t3,n){_t3?e.done(_t3):(e.nosToken=n.nosToken,e.docId=n.docId,this._doPreviewFile(e));}).call(t,this)});},p.getSimpleNosToken=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return e.num=1,m.verifyOptions(e),this.cbAndSendCmd("getSimpleNosToken",e);},p.getNosToken=function(e){var t=e.callback,n=e.nosToken,r=e.responseBody,o={tag:n.nosScene};n.nosSurvivalTime&&n.nosSurvivalTime!==1/0&&(o.expireSec=n.nosSurvivalTime),this.sendCmd("getNosToken",{responseBody:r,nosToken:o},t);},p.getNosTokenTrans=function(e){this.sendCmd("getNosTokenTrans",e.responseBody,e.callback);},p.getMixStoreToken=function(e){this.sendCmd("getMixStoreToken",{mixTokenReq:{provider:e.curProvider,tokenCount:e.tokenCount||1,tag:"im",returnBody:e.responseBody}},e.callback);},p.packFileDownloadName=function(e){m.verifyOptions(e,"url name",!0,"","nos::packFileDownloadName");var t=e.url;return t+m.genUrlSep(t)+"download="+encodeURIComponent(e.name);},p.audioToMp3=function(e){m.verifyOptions(e,"url","nos::audioToMp3");var t=e.url;return t+m.genUrlSep(t)+"audioTrans&type=mp3";},p.removeFile=function(e){this.sendCmd("removeFile",e,e.callback);},p.fetchFile=function(e){this.sendCmd("fetchFile",e,e.callback);},p.fetchFileList=function(e){this.sendCmd("fetchFileList",e,e.callback);},p.stripImageMeta=function(e){return this.beforeProcessImage(e,"stripmeta");},p.qualityImage=function(e){return this.beforeProcessImage(e,"quality");},p.interlaceImage=function(e){return this.beforeProcessImage(e,"interlace");},p.rotateImage=function(e){return this.beforeProcessImage(e,"rotate");},p.blurImage=function(e){return this.beforeProcessImage(e,"blur");},p.cropImage=function(e){return this.beforeProcessImage(e,"crop");},p.thumbnailImage=function(e){return this.beforeProcessImage(e,"thumbnail");},p.beforeProcessImage=function(e,t){var n=m.copy(e);return n.type=t,e.ops=[n],this.processImage(e);},p.processImage=function(e){var t,n=this;m.verifyOptions(e,"url ops",!0,"","nos::processImage"),m.verifyParamType("ops",e.ops,"array","nos::processImage");var r=c(t=e.ops).call(t,function(e){var t,r;return m.verifyOptions(e,"type",!0,"","nos::processImage"),m.verifyParamValid("type",e.type,d.validTypes,"nos::processImage"),n["gen"+u(t=e.type).call(t,0,1).toUpperCase()+u(r=e.type).call(r,1)+"Op"](e);});n.processCallback(e),n.sendCmd("processImage",{url:e.url,imageOps:r},e.callback);},p.genStripmetaOp=function(e){return new d({type:e.type,stripmeta:e.strip?1:0});},p.genQualityOp=function(e){m.verifyOptions(e,"quality",!0,"","nos::genQualityOp"),m.verifyParamType("quality",e.quality,"number","nos::genQualityOp"),m.verifyParamMin("quality",e.quality,0,"nos::genQualityOp"),m.verifyParamMax("quality",e.quality,100,"nos::genQualityOp");var t=Math.round(e.quality);return new d({type:e.type,qualityQuality:t});},p.genInterlaceOp=function(e){return new d({type:e.type});},p.genRotateOp=function(e){for(m.verifyOptions(e,"angle",!0,"","nos::genRotateOp"),m.verifyParamType("angle",e.angle,"number","nos::genRotateOp");e.angle<0;){e.angle=e.angle+360;}e.angle=e.angle%360;var t=Math.round(e.angle);return new d({type:e.type,rotateAngle:t});},p.genBlurOp=function(e){m.verifyOptions(e,"radius sigma","nos::genBlurOp"),m.verifyParamType("radius",e.radius,"number","nos::genBlurOp"),m.verifyParamMin("radius",e.radius,1,"nos::genBlurOp"),m.verifyParamMax("radius",e.radius,50,"nos::genBlurOp"),m.verifyParamType("sigma",e.sigma,"number","nos::genBlurOp"),m.verifyParamMin("sigma",e.sigma,0,"nos::genBlurOp");var t=Math.round(e.radius),n=Math.round(e.sigma);return new d({type:e.type,blurRadius:t,blurSigma:n});},p.genCropOp=function(e){m.verifyOptions(e,"x y width height","nos::genCropOp"),m.verifyParamType("x",e.x,"number","nos::genCropOp"),m.verifyParamMin("x",e.x,0,"nos::genCropOp"),m.verifyParamType("y",e.y,"number","nos::genCropOp"),m.verifyParamMin("y",e.y,0,"nos::genCropOp"),m.verifyParamType("width",e.width,"number","nos::genCropOp"),m.verifyParamMin("width",e.width,0,"nos::genCropOp"),m.verifyParamType("height",e.height,"number","nos::genCropOp"),m.verifyParamMin("height",e.height,0,"nos::genCropOp");var t=Math.round(e.x),n=Math.round(e.y),r=Math.round(e.width),o=Math.round(e.height);return new d({type:e.type,cropX:t,cropY:n,cropWidth:r,cropHeight:o});},p.genThumbnailOp=(r={cover:"z",contain:"x",crop:"y"},function(e){m.verifyOptions(e,"mode","nos::genThumbnailOp"),m.verifyParamValid("mode",e.mode,l(r),"nos::genThumbnailOp"),"contain"===e.mode?m.verifyParamAtLeastPresentOne(e,"width height","nos::genThumbnailOp"):m.verifyOptions(e,"width height","nos::genThumbnailOp"),m.undef(e.width)&&(e.width=0),m.undef(e.height)&&(e.height=0),m.verifyParamType("width",e.width,"number","nos::genThumbnailOp"),m.verifyParamMin("width",e.width,0,"nos::genThumbnailOp"),m.verifyParamType("height",e.height,"number","nos::genThumbnailOp"),m.verifyParamMin("height",e.height,0,"nos::genThumbnailOp");var t=Math.round(e.width),n=Math.round(e.height),o=new d({type:e.type,thumbnailMode:r[e.mode],thumbnailWidth:t,thumbnailHeight:n});if("crop"===e.mode&&m.notundef(e.axis)){m.undef(e.axis.x)&&(e.axis.x=5),m.undef(e.axis.y)&&(e.axis.y=5),m.verifyParamMin("axis.x",e.axis.x,0,"nos::genThumbnailOp"),m.verifyParamMax("axis.x",e.axis.x,10,"nos::genThumbnailOp"),m.verifyParamMin("axis.y",e.axis.y,0,"nos::genThumbnailOp"),m.verifyParamMax("axis.y",e.axis.y,10,"nos::genThumbnailOp");var i=Math.round(e.axis.x),s=Math.round(e.axis.y);o.thumbnailAxisX=i,o.thumbnailAxisY=s;}return m.notundef(e.enlarge)&&(m.verifyParamType("enlarge",e.enlarge,"boolean","nos::genThumbnailOp"),e.enlarge&&(o.thumbnailEnlarge=1)),o.thumbnailToStatic=this.options.thumbnailToStatic?1:0,o;}),p.getNosOriginUrl=function(e){var t;m.verifyOptions(e,"safeShortUrl",!0,"","nos::getNosOriginUrl"),m.verifyParamType("safeShortUrl",e.safeShortUrl,"string","nos::getNosOriginUrl"),/^http(s)?:/.test(e.safeShortUrl)&&~i(t=e.safeShortUrl).call(t,"im_url=1")?(this.processCallback(e),this.sendCmd("getNosOriginUrl",{nosFileUrlTag:{safeUrl:e.safeShortUrl}},e.callback)):e.done(new g("参数 “safeShortUrl” 内容非文件安全短链",{callFunc:"nos: getNosOriginUrl"}),e);};},function(e,t,n){var r,o=n(9),i=n(4),s=n(5),a=n(22),c=n(91),u=c.genUrlSep,l=c.url2object,m=c.object2url,p=n(0),d=n(57).fn;d.viewImageSync=function(e){var t=this.options;p.verifyOptions(e,"url","nos::viewImageSync");var n=e.url,r=l(n),s=r.protocol,c=r.hostname,u=r.path,d=r.query;if("boolean"==typeof e.strip&&(d.stripmeta=e.strip?1:0),"number"==typeof e.quality&&(p.verifyParamMin("quality",e.quality,0,"nos::viewImageSync"),p.verifyParamMax("quality",e.quality,100,"nos::viewImageSync"),d.quality=Math.round(e.quality)),"boolean"==typeof e.interlace&&(d.interlace=e.interlace?1:0),"number"==typeof e.rotate&&(d.rotate=Math.round(e.rotate)),"object"===a(e.thumbnail)){var f=e.thumbnail.mode||"crop",g=e.thumbnail.width,h=e.thumbnail.height;if(g>=0&&h>=0&&g<4096&&h<4096&&(g>0||h>0)){var y,v;switch(f){case"crop":f="y";break;case"contain":f="x";break;case"cover":f="z";break;default:f="x";}d.thumbnail=o(y=o(v="".concat(g)).call(v,f)).call(y,h);}}if(t.downloadUrl){var b=l(e.url),T=t.downloadUrl,S=b.path,M=i(S).call(S,"/");if(-1!==M){var k=S.substring(0,M),x=S.substring(M+1);T=T.replace("{bucket}",k).replace("{object}",x);}var C=l(T);return m({protocol:C.protocol,hostname:C.hostname,path:C.path,query:p.merge(C.query,d)});}return m({protocol:s,hostname:c,path:u,query:d});},d.viewImageStripMeta=function(e){p.verifyOptions(e,"url strip","nos::viewImageStripMeta"),p.verifyParamType("strip",e.strip,"boolean","nos::viewImageStripMeta");var t="stripmeta="+(e.strip?1:0),n=u(e.url);return e.url+n+t;},d.viewImageQuality=function(e){p.verifyOptions(e,"url quality","nos::viewImageQuality"),p.verifyParamType("quality",e.quality,"number","nos::viewImageQuality"),p.verifyParamMin("quality",e.quality,0,"nos::viewImageQuality"),p.verifyParamMax("quality",e.quality,100,"nos::viewImageQuality");var t="quality="+Math.round(e.quality),n=u(e.url);return e.url+n+t;},d.viewImageInterlace=function(e){p.verifyOptions(e,"url","nos::viewImageInterlace");var t=u(e.url);return e.url+t+"interlace=1";},d.viewImageRotate=function(e){for(p.verifyOptions(e,"url angle","nos::viewImageRotate"),p.verifyParamType("angle",e.angle,"number","nos::viewImageRotate");e.angle<0;){e.angle=e.angle+360;}e.angle=e.angle%360;var t="rotate="+Math.round(e.angle),n=u(e.url);return e.url+n+t;},d.viewImageBlur=function(e){p.verifyOptions(e,"url radius sigma","nos::viewImageBlur"),p.verifyParamType("radius",e.radius,"number","nos::viewImageBlur"),p.verifyParamMin("radius",e.radius,1,"nos::viewImageBlur"),p.verifyParamMax("radius",e.radius,50,"nos::viewImageBlur"),p.verifyParamType("sigma",e.sigma,"number","nos::viewImageBlur"),p.verifyParamMin("sigma",e.sigma,0,"nos::viewImageBlur");var t="blur="+Math.round(e.radius)+"x"+Math.round(e.sigma),n=u(e.url);return e.url+n+t;},d.viewImageCrop=function(e){p.verifyOptions(e,"url x y width height","nos::viewImageCrop"),p.verifyParamType("x",e.x,"number","nos::viewImageCrop"),p.verifyParamMin("x",e.x,0,"nos::viewImageCrop"),p.verifyParamType("y",e.y,"number","nos::viewImageCrop"),p.verifyParamMin("y",e.y,0,"nos::viewImageCrop"),p.verifyParamType("width",e.width,"number","nos::viewImageCrop"),p.verifyParamMin("width",e.width,0,"nos::viewImageCrop"),p.verifyParamType("height",e.height,"number","nos::viewImageCrop"),p.verifyParamMin("height",e.height,0,"nos::viewImageCrop");var t="crop="+Math.round(e.x)+"_"+Math.round(e.y)+"_"+Math.round(e.width)+"_"+Math.round(e.height),n=u(e.url);return e.url+n+t;},d.viewImageThumbnail=(r={cover:"z",contain:"x",crop:"y"},function(e){p.verifyOptions(e,"url mode","nos::viewImageThumbnail"),p.verifyParamValid("mode",e.mode,s(r),"nos::viewImageThumbnail"),"contain"===e.mode?p.verifyParamAtLeastPresentOne(e,"width height","nos::viewImageThumbnail"):p.verifyOptions(e,"width height","nos::viewImageThumbnail"),p.undef(e.width)&&(e.width=0),p.undef(e.height)&&(e.height=0),p.verifyParamType("width",e.width,"number","nos::viewImageThumbnail"),p.verifyParamMin("width",e.width,0,"nos::viewImageThumbnail"),p.verifyParamType("height",e.height,"number","nos::viewImageThumbnail"),p.verifyParamMin("height",e.height,0,"nos::viewImageThumbnail");var t=Math.round(e.width),n=Math.round(e.height),o="thumbnail="+t+r[e.mode]+n;"crop"===e.mode&&p.notundef(e.axis)&&(p.undef(e.axis.x)&&(e.axis.x=5),p.undef(e.axis.y)&&(e.axis.y=5),p.verifyParamMin("axis.x",e.axis.x,0,"nos::viewImageThumbnail"),p.verifyParamMax("axis.x",e.axis.x,10,"nos::viewImageThumbnail"),p.verifyParamMin("axis.y",e.axis.y,0,"nos::viewImageThumbnail"),p.verifyParamMax("axis.y",e.axis.y,10,"nos::viewImageThumbnail"),o=o+"&axis="+Math.round(e.axis.x)+"_"+Math.round(e.axis.y)),p.notundef(e.enlarge)&&(p.verifyParamType("enlarge",e.enlarge,"boolean","nos::viewImageThumbnail"),e.enlarge&&(o+="&enlarge=1"));var i=u(e.url);return e.url+i+o;});},function(e,t,n){var r=n(622);e.exports=r;},function(e,t,n){var r=n(19),o=n(623),i=n(625),s=Array.prototype,a=String.prototype;e.exports=function(e){var t=e.includes;return e===s||r(s,e)&&t===s.includes?o:"string"==typeof e||e===a||r(a,e)&&t===a.includes?i:t;};},function(e,t,n){n(624);var r=n(24);e.exports=r("Array").includes;},function(e,t,n){"use strict";var r=n(1),o=n(151).includes,i=n(8),s=n(179);r({target:"Array",proto:!0,forced:i(function(){return!Array(1).includes();})},{includes:function includes(e){return o(this,e,arguments.length>1?arguments[1]:void 0);}}),s("includes");},function(e,t,n){n(626);var r=n(24);e.exports=r("String").includes;},function(e,t,n){"use strict";var r=n(1),o=n(13),i=n(627),s=n(93),a=n(44),c=n(629),u=o("".indexOf);r({target:"String",proto:!0,forced:!c("includes")},{includes:function includes(e){return!!~u(a(s(this)),a(i(e)),arguments.length>1?arguments[1]:void 0);}});},function(e,t,n){var r=n(628),o=TypeError;e.exports=function(e){if(r(e))throw o("The method doesn't accept regular expressions");return e;};},function(e,t,n){var r=n(29),o=n(65),i=n(18)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[i])?!!t:"RegExp"==o(e));};},function(e,t,n){var r=n(18)("match");e.exports=function(e){var t=/./;try{"/./"[e](t);}catch(n){try{return t[r]=!1,"/./"[e](t);}catch(e){}}return!1;};},function(e,t,n){var r=n(22),o=n(10),i=n(4),s=n(285),a=n(0),c=n(57).fn,u=n(14);function l(e,t,n,r){var o=!1,s="";if(1===n?i(e).call(e,t)>=0&&(o=!0,s=t):2===n&&(s=new RegExp(t,"g")).test(e)&&(o=!0),o&&""!==s)switch(r){case 1:return e.replace(s,"**");case 2:return{code:2};case 3:return{code:3};}return e;}function m(e,t){for(var n=t.match,o=t.operate,i=e,a=0;a<s(t).length;a++){var c=s(t)[a],u=c.match||n,m=c.operate||o;try{if(i=l(i,c.key,u,m),"object"===r(i))return i;}catch(e){this.logger.warn("misc::filterContent: js cannot parse this regexp ",e);}}return i;}c.uploadSdkLogUrl=function(e){return a.verifyOptions(e,"url","misc::uploadSdkLogUrl"),this.cbAndSendCmd("uploadSdkLogUrl",e);},c.getClientAntispamLexicon=function(e){var t=this,n=(e=e||{}).done;n instanceof Function||(n=function n(){}),e={clientAntispam:{version:0}};var r=this;if(u.hasLocalStorage&&localStorage.getItem("antispamLexicon")&&"{}"!==localStorage.getItem("antispamLexicon"))try{r.antispamLexicon=JSON.parse(localStorage.getItem("antispamLexicon"));}catch(e){this.logger.error("JSON parse antispamLexicon error",e);}r.antispamLexicon&&n.call(this,null,{clientAntispam:r.antispamLexicon}),this.protocol.sendCmd("getClientAntispam",e,function(e,i,s){e?(r.protocol.logger.error("misc::getClientAntispamLexicon:",e),n.call(t,e,{})):(u.hasLocalStorage&&localStorage.setItem("antispamLexicon",o(s.clientAntispam)),r.antispamLexicon||n.call(t,null,s),r.antispamLexicon=s.clientAntispam||{});});},c.filterClientAntispam=function(e){var t=e.content;if(!t)return{code:404,errmsg:"待反垃圾文本content不存在"};var n=this.antispamLexicon&&this.antispamLexicon.thesaurus;if(!n)return{code:404,errmsg:"没有反垃圾词库或者词库格式不合法"};try{n=JSON.parse(n).thesaurus;}catch(e){return this.protocol.logger.error("misc::filterClientAntispam: parse thesaurus error"),{code:500,errmsg:"反垃圾词库格式不合法"};}for(var o=t,i=0;i<n.length;i++){if(o=m.call(this,o,n[i]),"object"===r(o)){if(2===o.code)return{code:200,type:2,errmsg:"建议拒绝发送",content:t,result:""};if(3===o.code)return{code:200,type:3,errmsg:"建议服务器处理反垃圾，发消息带上字段clientAntiSpam",content:t,result:t};}}return o===t?{code:200,type:0,errmsg:"",content:t,result:o}:{code:200,type:1,errmsg:"已对特殊字符做了过滤",content:t,result:o};},c.getServerTime=function(e){this.processCallback(e),this.sendCmd("getServerTime",{},e.callback);},c.getNosAccessToken=function(e){a.verifyOptions(e,"url","misc::getNosAccessToken"),this.processCallback(e);var t={url:e.url};e.userAgent&&(t.userAgent=e.userAgentv),e.ext&&(t.ext=e.ext),this.sendCmd("getNosAccessToken",{nosAccessTokenTag:t},function(t,n,r){var o=r&&r.nosAccessTokenTag&&r.nosAccessTokenTag.token,s=e.url,a=o?{token:o,resUrl:i(s).call(s,"?")?s+"&token="+o:s+"?token="+o}:{};e.done(t,a);});},c.deleteNosAccessToken=function(e){a.verifyOptions(e,"token","misc::deleteNosAccessToken"),this.processCallback(e),this.sendCmd("deleteNosAccessToken",{nosAccessTokenTag:{token:e.token}},e.callback);};},function(e,t,n){n(69);var r=n(52),o=n(26),i=n(19),s=n(632),a=Array.prototype,c={DOMTokenList:!0,NodeList:!0};e.exports=function(e){var t=e.keys;return e===a||i(a,e)&&t===a.keys||o(c,r(e))?s:t;};},function(e,t,n){var r=n(633);e.exports=r;},function(e,t,n){n(84),n(97);var r=n(24);e.exports=r("Array").keys;},function(e,t,n){var r=n(22),o=n(3),i=n(7),s=n(10),a=n(57).fn,c=n(0),u=n(174),l=n(271);a.signalingCreate=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.type,n=e.channelName,r=e.ext;return c.verifyOptions(e,"type","api::signalling"),this.sendCmdUsePromise("signalingCreate",{avSignalTag:{type:t,channelName:n,ext:r}}).then(function(e){var t=e.avSignalTag;return o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingDelay=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return c.verifyOptions(e,"channelId","api::signalling"),this.sendCmdUsePromise("signalingDelay",{avSignalTag:e}).then(function(e){var t=e.avSignalTag;return o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingClose=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.offlineEnabled;return c.verifyOptions(e,"channelId","api::signalling"),this.sendCmdUsePromise("signalingClose",{avSignalTag:c.merge(e,{isSave:!0===t?1:0})}).then(function(e){var t=e.avSignalTag;return t.offlineEnabled=1===t.isSave,delete t.isSave,o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingJoin=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.offlineEnabled;return c.verifyOptions(e,"channelId","api::signalling"),this.sendCmdUsePromise("signalingJoin",{avSignalTag:c.merge(e,{isSave:!0===t?1:0})}).then(function(e){var t,n=e.avSignalTag,r=n.members;"string"==typeof n.members&&(r=i(t=JSON.parse(n.members)).call(t,function(e){return l.parseAvSignalMember(e);}));return n.members=r,o.resolve(n);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingLeave=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.offlineEnabled;return c.verifyOptions(e,"channelId","api::signalling"),this.sendCmdUsePromise("signalingLeave",{avSignalTag:c.merge(e,{isSave:!0===t?1:0})}).then(function(e){var t=e.avSignalTag;return t.offlineEnabled=1===t.isSave,delete t.isSave,o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingGetChannelInfo=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.channelName;return c.verifyOptions(e,"channelName","api::signalling"),this.sendCmdUsePromise("signalingGetChannelInfo",{avSignalTag:{channelName:t}}).then(function(e){var t,n=e.avSignalTag,r=n.members;"string"==typeof n.members&&(r=i(t=JSON.parse(n.members)).call(t,function(e){return l.parseAvSignalMember(e);}));return n.members=r,o.resolve(n);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingInvite=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.account,n=e.offlineEnabled,i=e.pushInfo,a=void 0===i?{}:i;c.verifyOptions(e,"channelId requestId account","api::signalling"),"object"===r(a.pushPayload)&&(a.pushPayload=s(a.pushPayload));var u=c.merge(e,a,{to:t,isSave:!0===n?1:0,needPush:!0===a.needPush?1:0,needBadge:!1===a.needBadge?0:1});return this.sendCmdUsePromise("signalingInvite",{avSignalTag:u}).then(function(e){var t=e.avSignalTag;return t.offlineEnabled=1===t.isSave,t.needBadge=1===t.needBadge,t.needPush=1===t.needPush,delete t.isSave,o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingCancel=function(e){var t=e.account,n=e.offlineEnabled;return c.verifyOptions(e,"channelId requestId account","api::signalling"),this.sendCmdUsePromise("signalingCancel",{avSignalTag:c.merge(e,{to:t,isSave:!0===n?1:0})}).then(function(e){var t=e.avSignalTag;return t.offlineEnabled=1===t.isSave,delete t.isSave,o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingCreateAndJoin=function(e){var t=this,n=e.channelName,r=e.uid,i=void 0===r?0:r,s=e.offlineEnabled,a=void 0===s||s,u=e.attachExt,l=void 0===u?"":u;return this.signalingCreate(e).catch(function(e){return 10405===e.code?(t.logger.warn("api::avSignal:signalingCall room already exists:",e),t.signalingGetChannelInfo({channelName:n})):o.reject(e);}).then(function(n){var r={channelId:n.channelId,offlineEnabled:a,attachExt:l,nertcChannelName:e.nertcChannelName,nertcTokenTtl:e.nertcTokenTtl,nertcJoinRoomQueryParamMap:e.nertcJoinRoomQueryParamMap};return i&&c.merge(r,{uid:i}),t.signalingJoin(r);});},a.signalingCall=function(e){var t=this,n=e.account,r=e.offlineEnabled,o=e.requestId;c.verifyOptions(e,"type requestId account","api::signalling");var i="";return this.signalingCreateAndJoin(e).then(function(s){i=s.channelId||i,t.logger.info("api::avSignal:signalingCall join:",i);var a={channelId:i,account:n,requestId:o,offlineEnabled:r,attachExt:e.attachExt||"",pushInfo:e.pushInfo||{},nertcTokenTtl:s.nertcTokenTtl,nertcToken:s.nertcToken};return t.signalingInvite(a);});},a.signalingReject=function(e){var t=e.account,n=e.offlineEnabled;return c.verifyOptions(e,"channelId requestId account","api::signalling"),this.sendCmdUsePromise("signalingReject",{avSignalTag:c.merge(e,{to:t,isSave:!0===n?1:0})}).then(function(e){var t=e.avSignalTag;return t.offlineEnabled=1===t.isSave,delete t.isSave,o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingAccept=function(e){var t=this,n=e.account,r=e.offlineEnabled;return c.verifyOptions(e,"channelId requestId account","api::signalling"),this.sendCmdUsePromise("signalingAccept",{avSignalTag:c.merge(e,{to:n,isSave:!0===r?1:0})}).then(function(e){var t=e.avSignalTag;return t.offlineEnabled=1===t.isSave,delete t.isSave,o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));}).then(function(n){if(e.autoJoin){var r={channelId:e.channelId,offlineEnabled:e.offlineEnabled,attachExt:e.joinAttachExt,uid:e.uid,nertcChannelName:e.nertcChannelName,nertcTokenTtl:e.nertcTokenTtl,nertcJoinRoomQueryParamMap:e.nertcJoinRoomQueryParamMap};return t.signalingJoin(r);}return n;});},a.signalingControl=function(e){var t=e.account;return c.verifyOptions(e,"channelId","api::signalling"),this.sendCmdUsePromise("signalingControl",{avSignalTag:c.merge(e,t?{to:t}:{})}).then(function(e){var t=e.avSignalTag;return o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingSync=function(){return this.sendCmdUsePromise("sync",{sync:{avSignal:0}}).then(function(e){var t=e.avSignalTag;return o.resolve(t);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingMarkMsgRead=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};c.verifyOptions(e,"msgid","api::signalling");var t,n=u.idMap.avSignal;return t="string"==typeof e.msgid?[e.msgid]:e.msgid,this.sendCmd("batchMarkRead",{sid:n.id,cid:n.signalingNotify,ids:t});},a.signalingCallEx=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.account,n=e.offlineEnabled,a=e.pushInfo,u=void 0===a?{}:a;"object"===r(u.pushPayload)&&(u.pushPayload=s(u.pushPayload)),c.verifyOptions(e,"type","api::signalling"),c.verifyOptions(e,"account","api::signalling");var m=c.merge(e,u,{to:t,isSave:!0===n?1:0,needPush:!0===u.needPush?1:0,needBadge:!1===u.needBadge?0:1});return this.sendCmdUsePromise("signalingCallEx",{avSignalTag:m}).then(function(e){var t,n=e.avSignalTag,r=n.members;"string"==typeof n.members&&(r=i(t=JSON.parse(n.members)).call(t,function(e){return l.parseAvSignalMember(e);}));return n.members=r,o.resolve(n);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});},a.signalingJoinAndAccept=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.channelId,n=e.attachExt,r=e.offlineEnabled,s=e.uid,a=e.account,u=e.requestId,m=e.nertcChannelName,p=e.nertcTokenTtl,d=e.nertcJoinRoomQueryParamMap;return c.verifyOptions(e,"channelId","api::signalling"),c.verifyOptions(e,"account","api::signalling"),c.verifyOptions(e,"requestId","api::signalling"),this.sendCmdUsePromise("signalingJoinAndAccept",{avSignalTag:{channelId:t,attachExt:n,isSave:!0===r?1:0,uid:s,to:a,requestId:u,nertcChannelName:m,nertcTokenTtl:p,nertcJoinRoomQueryParamMap:d}}).then(function(e){var t,n=e.avSignalTag,r=n.members;"string"==typeof n.members&&(r=i(t=JSON.parse(n.members)).call(t,function(e){return l.parseAvSignalMember(e);}));return n.members=r,o.resolve(n);}).catch(function(e){return o.reject(l.parseAvSignalError(e));});};},function(e,t,n){var r=n(2),o=n(182),i=n(183),s=n(47).getPromiseWithAbort,a=function(){"use strict";function e(){o(this,e),this.abortFns=[];}return i(e,[{key:"add",value:function value(e){var t=s(e);return this.abortFns.push(t.abort),t.promise;}},{key:"clear",value:function value(){var e;r(e=this.abortFns).call(e,function(e){return e("Request aborted");}),this.abortFns=[];}},{key:"destroy",value:function value(){this.clear();}}]),e;}();e.exports=a;},function(e,t,n){var r=n(54),o=n(9),i=n(10),s=n(23),a=n(27),c=n(5),u=n(3),l=n(63).fn,m=n(39),p=n(637),d=n(272),f=n(14),g=n(0),h=n(110).V2NIMConnectStatus;function y(){this.logger.log("offlineListener enter"),this.forceDisconnect(),this.statusProtector.emit("auth/loginLifeCycleDisconnected",new Error("disconnect due to network offline")),this.options.ondisconnect&&this.options.ondisconnect({code:"offlineListener",callFunc:"link::offlineListener",message:"offlineListener disconnect"}),this.onDisconnect("link::offlineListener","broken");}function v(){var e=this;this.logger.log("onlineListener start"),this&&this.isConnected()&&!this.connecting?(this.stopHeartbeat(),this.sendCmd("heartbeat",null,function(t){if(t){e.logger.info("onlineListener heartbeat detect error",t);try{e.forceDisconnect(),e.onDisconnect("link::onHeartbeat","broken");}catch(t){e.logger.info("onlineListener heartbeat websocket.onclose",t);}}else e.logger.log("onlineListener heartbeat detect success");})):this.logger.log("onlineListener disconnected or connecting",this&&this.isConnected(),this.connecting);}l.initConnect=function(){this.socket=null,this.retryCount=0,this.connecting=!1,this.shouldReconnect=!0,this.hasNotifyDisconnected=!1,this.doLogout=!1;},l.resetConnect=function(){var e=this.options;g.notundef(e.needReconnect)?(g.verifyParamType("needReconnect",e.needReconnect,"boolean","link::resetConnect"),this.needReconnect=e.needReconnect):this.needReconnect=!0,this.logger.info("link::resetConnect: needReconnect ".concat(this.needReconnect)),g.notundef(e.reconnectionAttempts)&&g.verifyParamType("reconnectionAttempts",e.reconnectionAttempts,"number","link::resetConnect"),g.notundef(e.noCacheLinkUrl)&&g.verifyParamType("noCacheLinkUrl",e.noCacheLinkUrl,"boolean","link::resetConnect"),this.reconnectionAttempts="number"==typeof e.reconnectionAttempts?e.reconnectionAttempts:1/0,this.backoff=new p({min:f.reconnectionDelay,max:f.reconnectionDelayMax,jitter:f.reconnectionJitter});},l.connect=function(){var e=this;if(clearTimeout(e.connectTimer),e.isConnected())e.logger.warn("link::connect: already connected");else if(e.connecting)e.logger.warn("link::connect: already connecting");else{if(e.connecting=!0,e.hasNotifyDisconnected=!1,e.shouldReconnect=!0,e.socket&&e.forceDisconnect(),e.logger.info("link::connect: connect to new socket, autoconnect is "+e.autoconnect),"string"==typeof e.options.socketUrl)return e.logger.info("link::connect: try to options.socketUrl ",e.options.socketUrl),void e.connectToUrl(e.options.socketUrl);var t=e.getNextSocketUrl();if(t&&!e.options.noCacheLinkUrl)return e.logger.info("link::connect: try to next socket link ",t),void e.connectToUrl(t);e.logger.info("link::connect: no cached socket links or links had been used up"),e.refreshSocketUrl().then(function(){e.connectToUrl(e.getNextSocketUrl());}).catch(function(t){e.logger.warn("connect::refreshSocketUrl: catch exception,",t&&t.message),e.willReconnect()&&e.statusProtector.getConnectStatus()!==h.V2NIM_CONNECT_STATUS_DISCONNECTED&&e.onDisconnect("connect::refreshSocketUrl: failed to fetch lbs url and default socket link","broken");});}},l.getNextSocketUrl=function(){return this.socketUrls.shift();},l.isConnected=function(){return!!this.socket&&!!this.socket.socket&&this.socket.socket.connected;},l.connectToUrl=function(e){var t,n,a,c=this;if(e=e||"",c.url=e,"undefined"==typeof window){var u=g.getGlobal(),l=e.split(":");u&&!u.location&&l.length>1&&(u.location={protocol:l.shift(),port:l.pop(),hostname:l.join("")}),this.options.transports=["websocket"];}var m=this.options.transports||["websocket","xhr-polling"],p=r();c.statusProtector.emit("auth/loginLifeCycleConnect");try{c.socket=d.connect(e,{transports:m,reconnect:!1,"force new connection":!0,"connect timeout":f.connectTimeout});}catch(t){return c.logger.warn("link::connectToUrl: io.connect caught exception",t),void c.onHandshakeFailed(p,e);}c.logger.info(o(t="link::connectToUrl: socket url: ".concat(e,", transports: ")).call(t,i(m))),c.handshakeUrl=e,c.socket.on("connect",s(n=c.onConnect).call(n,c)),c.socket.on("handshake_failed",function(){c.onHandshakeFailed(p,c.handshakeUrl);}),c.socket.on("connect_failed",function(e){c.onConnectFailed(e,p,c.handshakeUrl);}),c.socket.on("error",function(e,t){c.logger.info("link::onSocketError:",t,"and the reason is ",e),c.onSocketError(e,p,c.handshakeUrl);}),c.socket.on("info",function(e,t){t?c.logger.info("link::onSocketInfo: ".concat(e,", extraInfo:"),t):c.logger.info("link::onSocketInfo: ".concat(e,"."));}),c.socket.on("message",s(a=c.onMessage).call(a,c)),c.socket.on("disconnect",function(t){c.logger.warn("link::onSocketDisconnect: socket url: ".concat(e,", disconnected"),t),c.hasLogin=!1,c.doLogout?c.logout():c.onDisconnect("link::socketDisconnect","broken"),c.statusProtector.emit("auth/loginLifeCycleDisconnected",new Error("disconnect due to internal reasons"));});},l.disconnect=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:function(){},t=this;function n(n){clearTimeout(t.disconnectCallbackTimer),t.msgAckBufferManager&&t.msgAckBufferManager.clear(),t.statusProtector.emit("auth/loginLifeCycleDisconnected",new Error("disconnect due to active action")),t.statusProtector.emit("auth/loginLifeCycleLogout"),a(function(){e(n);},0);}clearTimeout(t.connectTimer),t.disconnectCallbackTimer=a(function(){e.call(t,"mark disconnected due to timeout");},1e4),t.mixStorePolicy=null,t.appGrayConfig=null,t.resetReconnectStatus(),clearTimeout(t.mixStorePolicyClock),this.onlineListener&&"undefined"!=typeof window&&g.isFunction(window.removeEventListener)&&(window.removeEventListener("online",this.onlineListener),window.removeEventListener("offline",this.offlineListener),this.onlineListener=null,this.offlineListener=null),t.isConnected()?(t.logger.warn("link::disconnect: start disconnecting"),t.logout()):t.connecting?(t.logger.warn("link::disconnect: abort connecting"),t.disconnectSocket()):(t.logger.warn("link::disconnect: already disconnected"),t.connecting=!1,t.shouldReconnect=!1,t.socket=null,t.autoconnect=!1,t.options.ondisconnect({code:"alreadyDisconnected",callFunc:"link::disconnect",message:"manually disconnect status"})),t.socket&&t.socket.socket&&t.socket.socket.transport?t.socket.socket.transport.onDisconnectDone=function(e){t.logger.warn("link::disconnect: invoke [done] when socket closed",e),n(e);}:(t.logger.warn("link::disconnect: invoke [done]"),n(null));},l.resetReconnectStatus=function(){this.backoff&&(this.backoff.setMin(f.reconnectionDelay),this.backoff.setMax(f.reconnectionDelayMax),this.backoff.reset()),this.retryCount=0,this.autoconnect=!0,this.logger.info("link::resetReconnectStatus: reset retryCount and backoff");},l.onConnect=function(){this.connecting=!1,this.shouldReconnect=!0,this.hasNotifyDisconnected=!1,this.logger.info("link::onConnect success"),this.statusProtector.emit("auth/loginLifeCycleConnectSucc"),this.login();},l.onHandshakeFailed=function(e,t){var n;this.logger.warn(o(n="link::onHandshakeFailed: shandshake failed, startTime: ".concat(e,", targetUrl: ")).call(n,t)),this.onDisconnect("link::onHandshakeFailed","broken");},l.onConnectFailed=function(e,t,n){var r,i;this.logger.warn(o(r=o(i="link::onConnectFailed: connect failed due to ".concat(e,", startTime: ")).call(i,t,", targetUrl: ")).call(r,n)),this.onDisconnect("link::onConnectFailed","broken");},l.onSocketError=function(e,t,n){var r,i;if(this.logger.warn(o(r=o(i="link::onSocketError: due to ".concat(e,", startTime: ")).call(i,t,", targetUrl: ")).call(r,n)),e){if(void 0!==e.x5ImgDecodeStatus)return;if("[object Object]"===Object.prototype.toString.call(e)&&c(e).length<=0)return;this.onMiscError("连接错误",new m(e,"LINK_ERROR",{callFunc:"link::onError"}));}this.connecting=!1;},l.onDisconnect=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1?arguments[1]:void 0,n=this;this.logger.warn("socket::onDisconnect: "+e),n.connecting=!1,n.markAllCallbackInvalid(m.newNetworkError({callFunc:e,uploadCode:415,disconnectReason:t})),n.msgAckBufferManager&&n.msgAckBufferManager.clear(),n.stopHeartbeat(),n.reconnect();},l.willReconnect=function(){return this.shouldReconnect&&this.needReconnect&&this.retryCount<this.reconnectionAttempts;},l.reconnect=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(this.willReconnect()){if(this.socket&&(this.logger.info("link::reconnect: try to force disconnect"),this.forceDisconnect()),0===this.socketUrls.length&&!this.options.socketUrl&&"function"==typeof e.allFailedCB)return this.logger.log("reconnect: All socket links have been polled, trigger hooks"),void e.allFailedCB();this.doReconnect();}else this.notifyDisconnect({code:"allAttemptsFailed",message:"All attempts failed"});},l.doReconnect=function(){var e,t=this;t.socket=null,t.retryCount++,t.hasLogin=!1;var n,r=t.backoff.duration();t.logger.info(o(e="link::reconnect: will retry after ".concat(r,"ms, retryCount ")).call(e,t.retryCount)),n=t.options.onwillreconnect({retryCount:t.retryCount,duration:r}),t.statusProtector.emit("auth/loginLifeCycleWaiting"),clearTimeout(t.connectTimer),t.connectTimer=a(function(){1==+t.options.authType&&n instanceof u?(t.logger.info("link::reconnect: wait onwillreconnect promise"),n.finally(function(){return t.connect();})):t.connect();},r);},l.notifyConnectError=function(e){var t=m.newConnectError({message:e,callFunc:"link::notifyConnectError"});this.logger.error("link::notifyConnectError:",t),this.options.onerror(t);},l.notifyDisconnect=function(e){this.hasNotifyDisconnected?this.logger.warn("notifyDisconnect:: already notified"):(this.hasNotifyDisconnected=!0,this.disconnectSocket(),this.forceDisconnect(),(e=e||new m()).retryCount=this.retryCount,e.willReconnect=this.willReconnect(),this.backoff&&this.backoff.reset(),this.retryCount=0,this.autoconnect=!1,this.logger.info("link::notifyDisconnect: ondisconnected",e),this.options.ondisconnect(e),this.onWbNotifyHangup instanceof Function&&this.onWbNotifyHangup({content:{account:this.account,channelId:null,timetag:+Date()}}));},l.disconnectSocket=function(){if(this.isConnected()||this.connecting){this.connecting=!1,this.shouldReconnect=!1;try{this.socket&&this.socket.disconnect();}catch(e){this.socket&&"function"==typeof this.socket.removeAllListeners&&this.socket.removeAllListeners(),this.logger.info("link::disconnectSocket: disconnect failed, error ",e&&e.message);}}},l.initOnlineListener=function(){this.needReconnect&&this.options&&this.options.quickReconnect?"undefined"!=typeof window&&g.isFunction(window.addEventListener)?this.onlineListener||(this.onlineListener=s(v).call(v,this),this.offlineListener=s(y).call(y,this),this.logger.info("initOnlineListener success"),window.addEventListener("online",this.onlineListener),window.addEventListener("offline",this.offlineListener)):this.logger.warn("initOnlineListener no window.addEventListener"):this.logger.warn("initOnlineListener no quickReconnect");},l.forceDisconnect=function(){var e=this.socket||{};this.socket=null;try{"function"==typeof e.removeAllListeners&&e.removeAllListeners(),"function"==typeof e.disconnect&&e.disconnect();}catch(e){this.logger.error("forceDisconnect:: oldSocket error",e||e.message);}this.hasLogin=!1;};},function(e,t){function n(e){e=e||{},this.ms=e.min||100,this.max=e.max||1e4,this.factor=e.factor||2,this.jitter=e.jitter>0&&e.jitter<=1?e.jitter:0,this.attempts=0;}e.exports=n,n.prototype.duration=function(){var e=this.ms*Math.pow(this.factor,this.attempts++);if(this.jitter){var t=Math.random(),n=Math.floor(t*this.jitter*e);e=0==(1&Math.floor(10*t))?e-n:e+n;}return 0|Math.min(e,this.max);},n.prototype.reset=function(){this.attempts=0;},n.prototype.setMin=function(e){this.ms=e;},n.prototype.setMax=function(e){this.max=e;},n.prototype.setJitter=function(e){this.jitter=e;};},function(e,t,n){var r,o=n(63).fn,i=n(39),s=n(176),a=n(0),c=n(14),u=n(41),l=n(73),m=a.notundef;o.genSessionKey=(r={},function(){var e=this.name;return r[e]=r[e]||a.guid();}),o.afterLogin=a.emptyFunc;o.assembleIMLogin=function(){var e=this.options,t=e.account;this.sdkSession=this.genSessionKey();var n={appLogin:this.autoconnect?0:1,appKey:e.appKey,account:t,token:e.token,sdkVersion:c.info.sdkVersion,sdkHumanVersion:c.info.sdkHumanVersion,protocolVersion:c.info.protocolVersion,os:"[object Object]"===l.os.toString()?l.os.family:l.os.toString(),browser:l.name+" "+l.version,clientType:c.CLIENTTYPE||16,session:this.sdkSession,deviceId:u.deviceId,isReactNative:c.isRN?1:0,customTag:e.customTag||"",sdkType:0};return n.userAgent="Native/".concat(c.info.sdkHumanVersion),c.isBrowser?n.sdkType=0:c.isRN?n.sdkType=2:c.isWeixinApp&&(n.sdkType=6),e.customClientType&&(n.customClientType=+e.customClientType),e.authType&&(n.authType=+e.authType),e.loginExt&&(n.loginExt=e.loginExt),n;},o.notifyLogin=function(e){this.logger.info("link::notifyLogin: on connect",e),this.options.onconnect(e);},o.logout=function(){if(this.doLogout)return this.doLogout=!1,void this.onAuthError(new i("done logout","logout",{disconnectReason:"close",uploadCode:415}),"link::logout");this.isConnected()&&this.onAuthError(new i("done disconnect","logout",{disconnectReason:"close",uploadCode:415}),"link::logout");},o.onKicked=function(e){var t=e.content,n=t.from,r=t.reason,o=t.custom,c=t.customClientType,u={reason:this.kickedReasons[r]||"unknown",message:this.kickedMessages[r]||"未知原因"};if(m(n)&&(u.from=s.reverseType(n)),m(o)&&(u.custom=o),+c>0&&(u.customClientType=c),this.logger.warn("link::onKicked:",u),"silentlyKick"!==u.reason){var l=new i("被踢了","kicked",{disconnectReason:"kicked",uploadCode:415});a.merge(l,u),this.onAuthError(l,"link::onKicked");}else this.logger.warn("link::onKicked: silentlyKick"),this.forceDisconnect(),this.onDisconnect("link::onKicked","kicked");this.statusProtector.emit("auth/loginLifeCycleDisconnected",new Error("disconnect due to kicked")),this.statusProtector.emit("auth/loginLifeCycleKicked",u);},o.onAuthError=function(e,t){var n=e&&e.code;if(this.logger.error("onAuthError ",t,n),/^(Error_Internet_Disconnected|Error_Timeout|Error_Connection_Socket_State_not_Match)$/.test(n))return this.forceDisconnect(),void this.onDisconnect("link::onAuthError::"+n,"broken");(e=e||i.newConnectionError({callFunc:t,uploadCode:415,disconnectReason:"close"})).callFunc=e.callFunc||t||null,this.shouldReconnect=!1,this.markAllCallbackInvalid(e),this.notifyDisconnect(e);};},function(e,t,n){var r=n(27),o=n(23),i=n(22),s=n(63).fn,a=n(14),c=n(0);s.processLink=function(e){switch(e.cmd){case"heartbeat":this.startHeartbeat();break;case"notifyDetect":"object"===i(c._get(e,"content.notifyDetectTag"))&&(e.content.notifyDetectTag.t3=new Date().getTime(),this.startDetect(e));}},s.startHeartbeat=function(){var e=this;e.stopHeartbeat(),e.heartbeatTimer=r(function(){var t;e.sendCmd("heartbeat",null,o(t=e.onHeartbeat).call(t,e));},a.heartbeatInterval);},s.startDetect=function(e){var t=e.content.notifyDetectTag;t.t4=new Date().getTime(),this.sendCmd("uploadDetect",{notifyDetectTag:t});},s.stopHeartbeat=function(){this.heartbeatTimer&&(clearTimeout(this.heartbeatTimer),this.heartbeatTimer=null);},s.onHeartbeat=function(e){if(e){if(this.syncing)return this.logger.warn("onHeartbeat::ignore error in connecting"),void this.startHeartbeat();var t;if(e.callFunc="link::onHeartbeat",this.onCustomError("heartbeat error",e),this.heartbeatFail++,this.logger.warn("onHeartbeat::error ",e.code,e),"Error_Timeout"===e.code)if(!1!==this.checkNetworkAvailable()){if(this.heartbeatFail>1)this.forceDisconnect(),this.onDisconnect("link::onHeartbeat","broken");else this.sendCmd("heartbeat",null,o(t=this.onHeartbeat).call(t,this));}else this.startHeartbeat();}else this.heartbeatFail=0;},s.checkNetworkAvailable="undefined"!=typeof navigator&&"boolean"==typeof navigator.onLine?function(){return navigator.onLine;}:function(){},s.heartbeat=function(){};},function(e,t,n){var r=n(3),o=n(4),i=n(27),s=n(48),a=n(63).fn,c=n(270),u=n(14),l=n(41);a.processMisc=function(e){switch(e.cmd){case"getSimpleNosToken":e.error||(e.obj=e.content.nosTokens[0]);break;case"getNosToken":e.error||(e.obj=e.content.nosToken);break;case"getGrayscaleConfig":e.error||(e.obj=e.content.appGrayConfigTag);break;case"getMixStorePolicy":e.error||(e.obj=e.content.mixStorePolicyTag);break;case"getMixStoreToken":e.error||(e.obj=e.content.mixStoreTokenTag);break;case"getBackSourceToken":e.error||(e.obj=e.content.backSourceTokenTag);break;case"uploadSdkLogUrl":e.error?this.logger.error("uploadSdkLogUrl::error",e.error):this.logger.info("uploadSdkLogUrl::success",e.obj&&e.obj.url);break;case"notifyUploadLog":e.error||(u.isRN?this.uploadLocalLogRN():u.isBrowser&&this.uploadLocalLogWeb(),this.emitAPI({type:"notifyUploadLog"}));break;case"audioToText":e.error||(e.obj.text=e.content.text);break;case"processImage":e.obj.imageOps=c.reverseImageOps(e.obj.imageOps),e.error||(e.obj={url:e.content.url});break;case"getNosTokenTrans":e.error||(e.obj={nosToken:e.content.nosToken,docId:e.content.docId});break;case"getNosOriginUrl":e.error||(e.obj=e.content.nosFileUrlTag.originUrl);break;case"notifyTransLog":e.error||this.emitAPI({type:"notifyTransLog",obj:e.content.transInfo});break;case"fetchFile":case"fetchFileList":case"removeFile":e.error||(e.obj=e.content);break;case"getServerTime":e.obj=e.content&&e.content.time;break;case"getNosCdnHost":this.getNosCdnHost(e);}},a.uploadLocalLogRN=function(){if(u.isRN&&l.rnfs){var e=l.rnfs,t=this,n=e.nimIndex,i=(e.nimIndex+1)%2;e.nimPromise=e.nimPromise.then(function(){return r.all([e.exists(s(n)),e.exists(s(i))]);}).then(function(t){return t&&(t[0]||t[1])?t[0]&&t[1]?e.copyFile(s(i),s(2)).then(function(){return e.readFile(s(n));}).then(function(t){return e.appendFile(s(2),t);}):t[0]?e.copyFile(s(n),s(2)):void(t[1]&&e.copyFile(s(i),s(2))):r.reject();}).then(function(){return new r(function(n){t.api.previewFile({filePath:s(2),done:function done(i,a){if(r.all([e.unlink(s(2)),e.unlink(s(1)),e.unlink(s(0))]).finally(function(){n();}),i)t.logger.error("nim::uploadLocalLogRN:previewFile:error",i);else{var c=a.url;o(c).call(c,"?")>0?c+="&":c+="?",c+="download="+new Date().getTime()+"_rn.log",t.api.uploadSdkLogUrl({url:c});}}});});}).catch(function(n){e.unlink(s(2)).catch(function(){}),t.logger.error("nim::protocol::uploadLocalLogRN",n);});}function s(t){return e.DocumentDirectoryPath+"/nimlog_"+t+".log";}},a.uploadLocalLogWeb=function(){var e=this;!1!==this.options.dbLog&&this.logger._local?this.logger._local.fetchLog().then(function(t){e.api.previewFile({blob:new Blob([t.logs],{type:"text/plain"}),done:function done(n,r){if(n)e.logger.error("uploadLocalLogWeb::previewFile:error",n);else{e.logger.log("uploadLocalLogWeb::previewFile:success",r);var i=r.url;i+=(o(i).call(i,"?")>0?"&":"?")+"download="+new Date().getTime()+"_web.log",e.api.uploadSdkLogUrl({url:i}),e.logger._local.deleteLogs(t.time).then(function(){e.logger.log("uploadLocalLogWeb::deleteLogs success");}).catch(function(t){return e.logger.error("uploadLocalLogWeb::deleteLogs:error ,",t);});}}});}).catch(function(t){e.logger.error("uploadLocalLogWeb::fetchLog:error",t);}):this.logger.warn("uploadLocalLogWeb::no dbLog");},a.getNosCdnHost=function(e){var t=this,n=e.error;if(n&&(n.callFunc="events::getNosCdnHost",t.onCustomError("getNosCdnHost","EVENT_GET_NOS_CDN_HOST_ERROR",n)),e.content&&e.content.nosConfigTag){var r=e.content.nosConfigTag,o="",a="";0!==r.expire&&r.cdnDomain?-1===r.expire?(o=r.cdnDomain,a=r.objectNamePrefix):(o=r.cdnDomain,a=r.objectNamePrefix,t.nosCdnHostTimer&&clearTimeout(t.nosCdnHostTimer),t.nosCdnHostTimer=i(function(){t.sendCmd("getNosCdnHost",{});},800*s(r.expire))):(o="",a=""),u.serverNosConfig.cdnDomain=o,u.serverNosConfig.objectPrefix=a,u.hasLocalStorage&&(localStorage.setItem("nim_cdn_domain",o),localStorage.setItem("nim_object_prefix",a));}};},function(e,t,n){var r=n(7),o=n(30),i=n(63).fn,s=n(0),a=n(271),c=n(90).EMSyncType;i.processAvSignal=function(e){switch(e.cmd){case"signalingCreate":case"signalingDelay":case"signalingClose":case"signalingJoin":case"signalingLeave":case"signalingInvite":case"signalingCancel":case"signalingReject":case"signalingAccept":case"signalingControl":case"signalingSyncMsgRead":case"signalingGetChannelInfo":case"signalingCallEx":break;case"signalingNotify":this.onSignalingNotify(e);break;case"signalingMutilClientSyncNotify":this.onSignalingMutilClientSyncNotify(e);break;case"signalingUnreadMessageSyncNotify":this.onSignalingUnreadMessageSyncNotify(e);break;case"signalingChannelsSyncNotify":this.onSignalingMembersSyncNotify(e);break;default:this.logger.warn("avSignal::unhandled cmd:",e.cmd);}};var u=function u(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(e.needPush&&(e.needPush="1"===e.needPush),e.needBadge&&(e.needBadge="1"===e.needBadge),e.channelInValid&&(e.channelInValid="1"===e.channelInValid),e.attach){var t=JSON.parse(e.attach);e.eventType=a.parseAvSignalType(t.type);}if(e.members){var n=JSON.parse(e.members);e.members=r(n).call(n,function(e){return a.parseAvSignalMember(e);});}return e;};i.onSignalingNotify=function(e){if(e.error){var t=e.error;this.logger.error("protocal::avSignal:onSignalingNotify error",t),this.emitAPI({type:"error",error:t}),this.options.onerror(t);}else{e.raw&&e.raw.r&&e.raw.r.length&&e.content&&e.content.avSignalTag&&(e.content.avSignalTag.msgid=e.raw.r[0]);var n=e.content.avSignalTag;n=o(n)?r(n).call(n,function(e){return u(e);}):u(n),this.emitAPI({type:"signalingNotify",obj:n}),s.isFunction(this.options.onSignalingNotify)&&this.options.onSignalingNotify(n);}},i.onSignalingMutilClientSyncNotify=function(e){if(e.error){var t=e.error;this.logger.error("protocal::avSignal:onSignalingMutilClientSyncNotify error",t),this.emitAPI({type:"error",error:t}),this.options.onerror(t);}else{var n=e.content.avSignalTag;n=o(n)?r(n).call(n,function(e){return u(e);}):u(n),this.emitAPI({type:"signalingMutilClientSyncNotify",obj:n}),s.isFunction(this.options.onSignalingMutilClientSyncNotify)&&this.options.onSignalingMutilClientSyncNotify(n);}},i.onSignalingUnreadMessageSyncNotify=function(e){if(e.error){var t=e.error;this.logger.error("protocal::avSignal:onSignalingUnreadMessageSyncNotify error",t),this.emitAPI({type:"error",error:t}),this.options.onerror(t);}else{var n=e.content.avSignalTag;o(n)&&(n=r(n).call(n,function(e){return u(e);})),this.emitAPI({type:"signalingUnreadMessageSyncNotify",obj:n}),this.reporterHook.emit("reporter/syncItemComplete",c.kSyncType15_13),s.isFunction(this.options.onSignalingUnreadMessageSyncNotify)&&this.options.onSignalingUnreadMessageSyncNotify(n);}},i.onSignalingMembersSyncNotify=function(e){if(e.error){var t=e.error;this.logger.error("protocal::avSignal:onSignalingMembersSyncNotify error",t),this.emitAPI({type:"error",error:t}),this.options.onerror(t);}else{var n=e.content.avSignalTag;o(n)||(n=[n]),n=r(n).call(n,function(e){return u(e);}),this.emitAPI({type:"signalingChannelsSyncNotify",obj:n}),s.isFunction(this.options.onSignalingMembersSyncNotify)&&this.options.onSignalingMembersSyncNotify(n);}};},function(e,t,n){var r=n(10),o=n(23),i=n(0),s=n(63).fn,a=n(106),c=n(265);s.adaptersRequest=function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=n.onerror||function(){},s=new Date().getTime();return n.onerror=function(){o.apply(void 0,arguments);var a=arguments.length<=0?void 0:arguments[0];t.reporter.reportTraceStart("exceptions",{user_id:t.account,trace_id:i.get(self,"socket.socket.sessionid"),start_time:s,action:1}),t.reporter.reportTraceUpdateV2("exceptions",{code:"number"==typeof a.status?a.status:"number"==typeof a.code?a.code:0,description:a.message||"".concat(a.code),operation_type:0,target:e,context:n?r(n):"",net_connect:t.checkNetworkAvailable()}),t.reporter.reportTraceEnd("exceptions",1);},a(e,n);},s.adaptersUploadFile=function(e,t){var n,r=this;e.adaptersRequest=o(n=s.adaptersRequest).call(n,this);var a=new Date().getTime();return e.errorHook=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};t&&(r.reporter.reportTraceStart("exceptions",{user_id:r.account,trace_id:i.get(self,"socket.socket.sessionid"),start_time:a,action:1}),r.reporter.reportTraceUpdateV2("exceptions",{code:"number"==typeof t.status?t.status:"number"==typeof t.code?t.code:0,description:t.message||"".concat(t.code),operation_type:1,target:n.url||e.url,net_connect:r.checkNetworkAvailable()}),r.reporter.reportTraceEnd("exceptions",1));},new c(e,this,t);};},function(e,t,n){n(274);var r,o,i,s=n(46),a=n(54),c=n(35),u=n(2),l=n(3),m=n(5),p=n(27),d=n(17),f=n(16),g=n(9),h=n(22);i=function i(){"use strict";function e(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}function t(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),s(e,r.key,r);}}var n={reportUrl:"https://statistic.live.126.net/statics/report/common/form",maxSize:100,msgListMaxSize:1e3,cacheMaxSize:1e3,maxDelay:3e5,maxInterval:3e4,minInterval:1e4,timeout:5e3,autoStart:!0},r=function r(){};return function(){function o(t){var r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];e(this,o),this.isUploadEnable=!1,this.initConfigLoaded=!1,this.loading=!1,this.isDestroyed=!1,this.reportConfig=n,this.msgList=[],this.traceMsgCache={},this.lowPriorityMsgList=[],this.cacheMsgList=[],this.lastReportTime=a(),this.timer=null,this.isDataReportEnable=r,this.isDataReportEnable&&(this.setConfig(t),this.reportConfig.autoStart&&this.initUploadConfig());}var i,h,y;return i=o,(h=[{key:"setConfig",value:function value(e){this.isDataReportEnable&&(this.reportConfig=c({},this.reportConfig,e),this.reportConfig.common.sdk_type||(this.reportConfig.common.sdk_type="im"));}},{key:"reportImmediately",value:function value(e,t){var n=this;this.isDataReportEnable&&this.reportConfig.request(e,c({dataType:"json",method:"POST",timeout:this.reportConfig.timeout},t)).catch(function(e){var t,r;null===(r=null===(t=n.reportConfig)||void 0===t?void 0:t.logger)||void 0===r||r.warn("Reporter immediately upload failed",e);});}},{key:"report",value:function value(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(this.isDataReportEnable&&e){var r=a();n?this.lowPriorityMsgList.push({module:e,msg:t,createTime:r}):this.msgList.push({module:e,msg:t,createTime:r}),this.msgList.length>this.reportConfig.msgListMaxSize&&this.msgList.shift(),this.lowPriorityMsgList.length>this.reportConfig.msgListMaxSize&&this.lowPriorityMsgList.shift(),this.doReport();}}},{key:"reportTraceStart",value:function value(e,t){if(this.isDataReportEnable&&e&&!this.traceMsgCache[e]){var n=c(c({start_time:a()},t),{extension:[]});this.traceMsgCache[e]=n;}}},{key:"reportTraceUpdate",value:function value(e){}},{key:"reportTraceUpdateV2",value:function value(e,t,n){var r,o=this;if(this.isDataReportEnable&&this.traceMsgCache[e]){var i=this.traceMsgCache[e].extension.length,s=new Date().getTime();t.duration=0===i?s-this.traceMsgCache[e].start_time:s-this.traceMsgCache[e].extension[i-1].end_time,this.traceMsgCache[e].extension.push(c({end_time:s},t)),(null==n?void 0:n.asyncParams)&&((r=this.traceMsgCache[e]).asyncPromiseArray||(r.asyncPromiseArray=[]),this.traceMsgCache[e].asyncPromiseArray.push(n.asyncParams.then(function(t){var n=o.traceMsgCache[e].extension.length-1;c(o.traceMsgCache[e].extension[n],t);})));}}},{key:"reportTraceEnd",value:function value(e){var t,n=this,r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.isDataReportEnable&&this.traceMsgCache[e]&&("nos"!==e||!1===r?("boolean"==typeof r?this.traceMsgCache[e].succeed=!!r:this.traceMsgCache[e].state=r,this.traceMsgCache[e].duration=a()-this.traceMsgCache[e].start_time,u(t=this.traceMsgCache[e].extension).call(t,function(e){delete e.end_time;}),this.traceMsgCache[e].asyncPromiseArray?l.all(this.traceMsgCache[e].asyncPromiseArray).finally(function(){delete n.traceMsgCache[e].asyncPromiseArray,n.report(e,n.traceMsgCache[e]),n.traceMsgCache[e]=null;}):(this.report(e,this.traceMsgCache[e]),this.traceMsgCache[e]=null)):this.traceMsgCache[e]=null);}},{key:"reportTraceCancel",value:function value(e){this.isDataReportEnable&&(this.traceMsgCache[e]=null);}},{key:"pause",value:function value(){this.isDataReportEnable&&(this.isUploadEnable=!1);}},{key:"restore",value:function value(){this.isDataReportEnable&&(this.isUploadEnable=!0,this.initConfigLoaded||this.initUploadConfig());}},{key:"destroy",value:function value(){var e,t=this;this.isDataReportEnable&&(u(e=m(this.traceMsgCache)).call(e,function(e){t.reportTraceEnd(e,1);}),null!==this.timer&&clearTimeout(this.timer),this.setConfig=r,this.report=r,this.reportTraceStart=r,this.reportTraceUpdate=r,this.reportTraceEnd=r,this.pause=r,this.restore=r,this.destroy=r,this.cacheMsgList=[],this.traceMsgCache={},this.lowPriorityMsgList=[],this.msgList=[],this.reportConfig={},this.isDestroyed=!0);}},{key:"initUploadConfig",value:function value(){var e,t,n=this;if(!this.loading){this.loading=!0;var r=this.reportConfig.common||{};try{this.reportConfig.request("https://statistic.live.126.net/dispatcher/req",{method:"GET",dataType:"json",params:{deviceId:r.dev_id,sdkVer:r.sdk_ver,platform:r.platform,appkey:r.app_key},timeout:this.reportConfig.timeout}).then(function(e){var t,r;if(!n.isDestroyed){if(200===e.status&&e.data&&200===e.data.code){var o=e.data.data||{};n.reportConfig.maxSize=o.maxSize>1e3?1e3:o.maxSize,n.reportConfig.maxInterval=o.maxInterval>1e4?1e4:o.maxInterval,n.reportConfig.maxInterval=o.maxInterval<10?10:o.maxInterval,n.reportConfig.minInterval=o.minInterval<2?2:o.minInterval,n.reportConfig.maxDelay=o.maxDelay||300,n.reportConfig.maxInterval=1e3*n.reportConfig.maxInterval,n.reportConfig.minInterval=1e3*n.reportConfig.minInterval,n.reportConfig.maxDelay=1e3*n.reportConfig.maxDelay,n.isUploadEnable=!0,n.initConfigLoaded=!0,n.loading=!1,n.reportHeartBeat();}null===(r=null===(t=n.reportConfig)||void 0===t?void 0:t.logger)||void 0===r||r.log("Get reporter upload config success");}}).catch(function(e){var t,r;n.loading=!1,null===(r=null===(t=n.reportConfig)||void 0===t?void 0:t.logger)||void 0===r||r.error("Get reporter upload config failed",e);});}catch(n){this.loading=!1,null===(t=null===(e=this.reportConfig)||void 0===e?void 0:e.logger)||void 0===t||t.error("Exec reporter request failed",n);}}}},{key:"reportHeartBeat",value:function value(){var e=this;this.isDestroyed||(this.timer=p(function(){e.reportHeartBeat();},this.reportConfig.minInterval),this.doReport());}},{key:"doReport",value:function value(){if(!this.isDestroyed){var e=this.msgList.length+this.lowPriorityMsgList.length+this.cacheMsgList.length>2*this.reportConfig.maxSize?this.reportConfig.minInterval:this.reportConfig.maxInterval;a()-this.lastReportTime>=e&&this.upload();}}},{key:"getUploadMsg",value:function value(){var e,t,n,r,o,i=this,s={},c=a();this.msgList=d(e=this.msgList).call(e,function(e){return c-e.createTime<i.reportConfig.maxDelay;}),this.lowPriorityMsgList=d(t=this.lowPriorityMsgList).call(t,function(e){return c-e.createTime<i.reportConfig.maxDelay;}),this.cacheMsgList=d(n=this.cacheMsgList).call(n,function(e){return c-e.createTime<i.reportConfig.maxDelay;});var l=f(r=this.msgList).call(r,0,this.reportConfig.maxSize);if(this.msgList=f(o=this.msgList).call(o,l.length),l.length<this.reportConfig.maxSize){var m,p,h=this.reportConfig.maxSize-l.length;l=g(l).call(l,f(m=this.lowPriorityMsgList).call(m,0,h)),this.lowPriorityMsgList=f(p=this.lowPriorityMsgList).call(p,h);}if(l.length<this.reportConfig.maxSize){var y,v,b=this.reportConfig.maxSize-l.length;l=g(l).call(l,f(y=this.cacheMsgList).call(y,0,b)),this.cacheMsgList=f(v=this.cacheMsgList).call(v,b);}return u(l).call(l,function(e){s[e.module]?s[e.module].push(e.msg):s[e.module]=[e.msg];}),{uploadMsgArr:l,uploadMsg:s};}},{key:"upload",value:function value(){var e,t,n=this;if(this.isUploadEnable&&!(this.lastReportTime&&a()-this.lastReportTime<this.reportConfig.minInterval)){var r=this.getUploadMsg(),o=r.uploadMsgArr,i=r.uploadMsg;if(o.length){this.lastReportTime=a();try{this.reportConfig.request(this.reportConfig.reportUrl,{dataType:"json",method:"POST",data:{common:this.reportConfig.common,event:i},headers:{sdktype:"im"},timeout:this.reportConfig.timeout}).catch(function(e){var t,r,i,s;n.cacheMsgList=f(t=g(r=n.cacheMsgList).call(r,o)).call(t,0,n.reportConfig.cacheMaxSize),null===(s=null===(i=n.reportConfig)||void 0===i?void 0:i.logger)||void 0===s||s.warn("Reporter upload failed",e);});}catch(n){null===(t=null===(e=this.reportConfig)||void 0===e?void 0:e.logger)||void 0===t||t.warn("Exec reporter request failed",n);}clearTimeout(this.timer),this.reportHeartBeat();}}}}])&&t(i.prototype,h),y&&t(i,y),s(i,"prototype",{writable:!1}),o;}();},"object"===h(t)&&void 0!==e?e.exports=i():void 0===(o="function"==typeof(r=i)?r.call(t,n,t,e):r)||(e.exports=o);},function(e,t,n){e.exports=n(645);},function(e,t,n){n(646);var r=n(647);e.exports=r;},function(e,t,n){n(275);},function(e,t,n){var r=n(648);e.exports=r;},function(e,t,n){var r=n(649);e.exports=r;},function(e,t,n){n(275),e.exports=n(12);},function(e,t,n){n(274);var r,o,i,s=n(2),a=n(5),c=n(9),u=n(15),l=n(3),m=n(10),p=n(22);i=function i(){"use strict";function e(e){if(e){var t,n="";return s(t=a(e)).call(t,function(t,r){var o;n+=0===r?"?":"&",n+=c(o="".concat(t,"=")).call(o,e[t]);}),n;}return"";}function t(e,t,n,r){return Error.call(this,n),this.source=e,this.code=t,this.desc=n,this.detail=r||{},this;}var n,r,o;return n=t,r=Error,(o=u(r.prototype)).constructor=n,n.prototype=o,function(n){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{dataType:"json",method:"GET",timeout:5e3},o="text"===r.dataType?"text/plain; charset=UTF-8":"application/json; charset=UTF-8",i="GET"===r.method?e(r.params):"";return new l(function(e,s){if(window.XMLHttpRequest){var a,u,l=new XMLHttpRequest();if(l.onreadystatechange=function(){if(4===l.readyState)if(200===l.status){try{u=JSON.parse(l.response||"{}");}catch(e){u=l.response;}e({status:l.status,data:u});}else s(new t(1,l.status,l.statusText));},l.open(r.method,c(a="".concat(n)).call(a,i)),l.timeout=r.timeout||5e3,l.setRequestHeader("Content-Type",o),r.headers)for(var p in r.headers){l.setRequestHeader(p,r.headers[p]);}l.ontimeout=function(e){s(new t(1,408,e&&e.message?e.message:"request timeout"));},l.send(m(r.data));}else s(new t(2,10400,"request no suppout"));});};},"object"===p(t)&&void 0!==e?e.exports=i():void 0===(o="function"==typeof(r=i)?r.call(t,n,t,e):r)||(e.exports=o);},function(e,t,n){var r=n(17),o=n(0),i=n(174),s=o.merge({},i.idMap,{auth:{id:2,login:3,kicked:5,logout:6,multiPortLogin:7,kick:8},user:{id:3,updatePushToken:1,appBackground:2,markInBlacklist:3,getBlacklist:4,markInMutelist:5,getMutelist:6,getRelations:8,getUsers:7,updateMyInfo:10,updateDonnop:15,syncMyInfo:109,syncUpdateMyInfo:110},notify:{id:4,markRead:3,syncOfflineMsgs:4,batchMarkRead:5,syncOfflineSysMsgs:6,syncOfflineNetcallMsgs:8,syncRoamingMsgs:9,syncMsgReceipts:12,syncRobots:15,syncBroadcastMsgs:16,syncSuperTeamRoamingMsgs:17,syncOfflineSuperTeamSysMsgs:18,syncDeleteSuperTeamMsgOfflineRoaming:19,syncDeleteMsgSelf:21,syncSessionsWithMoreRoaming:22,syncStickTopSessions:23,syncSessionHistoryMsgsDelete:24,syncSessionReliableInfo:25},sync:{id:5,sync:1,syncTeamMembers:2,syncSuperTeamMembers:3},msg:{id:7,sendMsg:1,msg:2,sysMsg:3,getHistoryMsgs:6,sendCustomSysMsg:7,searchHistoryMsgs:8,deleteSessions:9,getSessions:10,syncSendMsg:101,sendMsgReceipt:11,msgReceipt:12,deleteMsg:13,msgDeleted:14,markSessionAck:16,markSessionAckBatch:25,broadcastMsg:17,clearServerHistoryMsgs:18,getServerSessions:19,getServerSession:20,updateServerSession:21,deleteServerSessions:22,deleteMsgSelf:23,deleteMsgSelfBatch:24,msgFtsInServer:26,msgFtsInServerByTiming:27,onClearServerHistoryMsgs:118,syncUpdateServerSession:121,onDeleteMsgSelf:123,onDeleteMsgSelfBatch:124},msgExtend:{id:23,getThreadMsgs:1,getMsgsByIdServer:2,addQuickComment:3,deleteQuickComment:4,onQuickComment:5,onDeleteQuickComment:6,getQuickComments:7,addCollect:8,deleteCollects:9,updateCollect:10,getCollects:11,addStickTopSession:12,deleteStickTopSession:13,updateStickTopSession:14,addMsgPin:15,updateMsgPin:16,deleteMsgPin:17,onAddMsgPin:18,onUpdateMsgPin:19,onDeleteMsgPin:20,getMsgPins:21,syncAddQuickComment:103,syncDeleteQuickComment:104,syncAddStickTopSession:112,syncDeleteStickTopSession:113,syncUpdateStickTopSession:114,syncAddMsgPin:115,syncUpdateMsgPin:116,syncDeleteMsgPin:117},team:{id:8,createTeam:1,sendTeamMsg:2,teamMsg:3,teamMsgs:4,addTeamMembers:5,removeTeamMembers:6,updateTeam:7,leaveTeam:8,getTeam:9,getTeams:10,getTeamMembers:11,dismissTeam:12,applyTeam:13,passTeamApply:14,rejectTeamApply:15,addTeamManagers:16,removeTeamManagers:17,transferTeam:18,updateInfoInTeam:19,updateNickInTeam:20,acceptTeamInvite:21,rejectTeamInvite:22,getTeamHistoryMsgs:23,searchTeamHistoryMsgs:24,updateMuteStateInTeam:25,getMyTeamMembers:26,getMutedTeamMembers:27,sendTeamMsgReceipt:28,getTeamMsgReads:29,getTeamMsgReadAccounts:30,notifyTeamMsgReads:31,muteTeamAll:32,getTeamMemberInvitorAccid:33,getTeamsById:34,syncMyTeamMembers:126,syncTeams:109,syncTeamMembers:111,syncCreateTeam:101,syncSendTeamMsg:102,syncUpdateTeamMember:119},superTeam:{id:21,sendSuperTeamMsg:2,superTeamMsg:3,addSuperTeamMembers:5,removeSuperTeamMembers:6,leaveSuperTeam:7,updateSuperTeam:8,getSuperTeam:9,getSuperTeams:12,updateInfoInSuperTeam:10,getMySuperTeamMembers:11,getSuperTeamMembers:13,getSuperTeamHistoryMsgs:14,getSuperTeamMembersByJoinTime:15,sendSuperTeamCustomSysMsg:16,deleteSuperTeamMsg:17,superTeamMsgDelete:18,superTeamCustomSysMsg:19,applySuperTeam:20,passSuperTeamApply:21,rejectSuperTeamApply:22,acceptSuperTeamInvite:23,rejectSuperTeamInvite:24,markSuperTeamSessionAck:25,addSuperTeamManagers:26,removeSuperTeamManagers:27,updateSuperTeamMute:28,updateSuperTeamMembersMute:29,updateNickInSuperTeam:30,transferSuperTeam:31,markSuperTeamSessionsAck:32,getSuperTeamMembersByAccounts:33,getMutedSuperTeamMembers:34,syncMySuperTeamMembers:111,syncSuperTeams:109,syncSuperTeamMembers:113,syncCreateSuperTeam:101,syncSendSuperTeamMsg:102,syncUpdateSuperTeamMember:110,syncDeleteSuperTeamMsg:117},friend:{id:12,friendRequest:1,syncFriendRequest:101,deleteFriend:2,syncDeleteFriend:102,updateFriend:3,syncUpdateFriend:103,getFriends:4},chatroom:{id:13,getChatroomAddress:1},filter:{id:101,sendFilterMsg:1,filterMsg:2,filterSysMsg:3,sendFilterCustomSysMsg:7},eventService:{id:14,publishEvent:1,pushEvent:2,subscribeEvent:3,unSubscribeEventsByAccounts:4,unSubscribeEventsByType:5,querySubscribeEventsByAccounts:6,querySubscribeEventsByType:7,pushEvents:9},proxyService:{id:22,httpProxy:1,onProxyMsg:2},qchat:{id:24,getQChatAddress:1}}),a=o.merge({},i.cmdConfig,{login:{sid:s.auth.id,cid:s.auth.login,params:[{type:"Property",name:"login"}]},logout:{sid:s.auth.id,cid:s.auth.logout},kick:{sid:s.auth.id,cid:s.auth.kick,params:[{type:"StrArray",name:"deviceIds"}]},updatePushToken:{sid:s.user.id,cid:s.user.updatePushToken,params:[{type:"String",name:"tokenName"},{type:"String",name:"token"},{type:"int",name:"pushkit"}]},appBackground:{sid:s.user.id,cid:s.user.appBackground,params:[{type:"bool",name:"isBackground"},{type:"Int",name:"badge"}]},markInBlacklist:{sid:s.user.id,cid:s.user.markInBlacklist,params:[{type:"String",name:"account"},{type:"bool",name:"isAdd"}]},getBlacklist:{sid:s.user.id,cid:s.user.getBlacklist,params:[{type:"long",name:"time"}]},markInMutelist:{sid:s.user.id,cid:s.user.markInMutelist,params:[{type:"String",name:"account"},{type:"bool",name:"isAdd"}]},getMutelist:{sid:s.user.id,cid:s.user.getMutelist,params:[{type:"long",name:"time"}]},getRelations:{sid:s.user.id,cid:s.user.getRelations,params:[{type:"long",name:"timetag"}]},getUsers:{sid:s.user.id,cid:s.user.getUsers,params:[{type:"StrArray",name:"accounts"}]},updateMyInfo:{sid:s.user.id,cid:s.user.updateMyInfo,params:[{type:"Property",name:"user"},{type:"Property",name:"antispamTag"}]},updateDonnop:{sid:s.user.id,cid:s.user.updateDonnop,params:[{type:"Property",name:"donnop"}]},markRead:{sid:s.notify.id,cid:s.notify.markRead,params:[{type:"long",name:"id"},{type:"ph",name:"ph"}]},batchMarkRead:{sid:s.notify.id,cid:s.notify.batchMarkRead,params:[{type:"byte",name:"sid"},{type:"byte",name:"cid"},{type:"LongArray",name:"ids"}]},sync:{sid:s.sync.id,cid:s.sync.sync,isAwaitable:!1,params:[{type:"Property",name:"sync"}]},syncTeamMembers:{sid:s.sync.id,cid:s.sync.syncTeamMembers,params:[{type:"LongLongMap",name:"sync"}]},syncSuperTeamMembers:{sid:s.sync.id,cid:s.sync.syncSuperTeamMembers,params:[{type:"LongLongMap",name:"sync"}]},sendMsg:{sid:s.msg.id,cid:s.msg.sendMsg,params:[{type:"Property",name:"msg"}]},getHistoryMsgs:{sid:s.msg.id,cid:s.msg.getHistoryMsgs,params:[{type:"String",name:"to"},{type:"long",name:"beginTime"},{type:"long",name:"endTime"},{type:"long",name:"lastMsgId"},{type:"int",name:"limit"},{type:"bool",name:"reverse"},{type:"LongArray",name:"msgTypes"}]},sendCustomSysMsg:{sid:s.msg.id,cid:s.msg.sendCustomSysMsg,params:[{type:"Property",name:"sysMsg"}]},searchHistoryMsgs:{sid:s.msg.id,cid:s.msg.searchHistoryMsgs,params:[{type:"String",name:"to"},{type:"long",name:"beginTime"},{type:"long",name:"endTime"},{type:"String",name:"keyword"},{type:"int",name:"limit"},{type:"bool",name:"reverse"}]},getSessions:{sid:s.msg.id,cid:s.msg.getSessions,params:[{type:"long",name:"time"}]},deleteSessions:{sid:s.msg.id,cid:s.msg.deleteSessions,params:[{type:"StrArray",name:"sessions"}]},sendMsgReceipt:{sid:s.msg.id,cid:s.msg.sendMsgReceipt,params:[{type:"Property",name:"msgReceipt"}]},deleteMsg:{sid:s.msg.id,cid:s.msg.deleteMsg,params:[{type:"Property",name:"sysMsg"}]},markSessionAck:{sid:s.msg.id,cid:s.msg.markSessionAck,params:[{type:"byte",name:"scene"},{type:"String",name:"to"},{type:"long",name:"timetag"}]},markSessionAckBatch:{sid:s.msg.id,cid:s.msg.markSessionAckBatch,params:[{type:"PropertyArray",name:"sessionAckTags",entity:"sessionAckTag"}]},clearServerHistoryMsgs:{sid:s.msg.id,cid:s.msg.clearServerHistoryMsgs,params:[{type:"Property",name:"clearMsgsParams"}]},clearServerHistoryMsgsWithSync:{sid:s.msg.id,cid:s.msg.clearServerHistoryMsgs,params:[{type:"Property",name:"clearMsgsParamsWithSync"}]},msgFtsInServer:{sid:s.msg.id,cid:s.msg.msgFtsInServer,params:[{type:"Property",name:"msgFullSearchRequestTag"}]},msgFtsInServerByTiming:{sid:s.msg.id,cid:s.msg.msgFtsInServerByTiming,params:[{type:"Property",name:"msgTimingFullSearchRequestTag"}]},onClearServerHistoryMsgs:{sid:s.msg.id,cid:s.msg.clearServerHistoryMsgs},getServerSessions:{sid:s.msg.id,cid:s.msg.getServerSessions,params:[{type:"Property",name:"sessionReqTag"}]},getServerSession:{sid:s.msg.id,cid:s.msg.getServerSession,params:[{type:"Property",name:"session"}]},updateServerSession:{sid:s.msg.id,cid:s.msg.updateServerSession,params:[{type:"Property",name:"session"}]},deleteServerSessions:{sid:s.msg.id,cid:s.msg.deleteServerSessions,params:[{type:"PropertyArray",name:"sessions",entity:"session"}]},deleteMsgSelf:{sid:s.msg.id,cid:s.msg.deleteMsgSelf,params:[{type:"Property",name:"deleteMsgSelfTag"}]},deleteMsgSelfBatch:{sid:s.msg.id,cid:s.msg.deleteMsgSelfBatch,params:[{type:"PropertyArray",name:"deleteMsgSelfTags",entity:"deleteMsgSelfTag"}]},onDeleteMsgSelf:{sid:s.msg.id,cid:s.msg.onDeleteMsgSelf},onDeleteMsgSelfBatch:{sid:s.msg.id,cid:s.msg.onDeleteMsgSelfBatch},sendSuperTeamMsg:{sid:s.superTeam.id,cid:s.superTeam.sendSuperTeamMsg,params:[{type:"Property",name:"msg"}]},addSuperTeamMembers:{sid:s.superTeam.id,cid:s.superTeam.addSuperTeamMembers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"},{type:"String",name:"ps"}]},removeSuperTeamMembers:{sid:s.superTeam.id,cid:s.superTeam.removeSuperTeamMembers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"}]},leaveSuperTeam:{sid:s.superTeam.id,cid:s.superTeam.leaveSuperTeam,params:[{type:"long",name:"teamId"}]},updateSuperTeam:{sid:s.superTeam.id,cid:s.superTeam.updateSuperTeam,params:[{type:"Property",name:"team"},{type:"Property",name:"antispamTag"}]},getSuperTeam:{sid:s.superTeam.id,cid:s.superTeam.getSuperTeam,params:[{type:"long",name:"teamId"}]},getSuperTeams:{sid:s.superTeam.id,cid:s.superTeam.getSuperTeams,params:[{type:"long",name:"timetag"}]},getSuperTeamMembers:{sid:s.superTeam.id,cid:s.superTeam.getSuperTeamMembers,params:[{type:"long",name:"teamId"},{type:"long",name:"timetag"}]},updateInfoInSuperTeam:{sid:s.superTeam.id,cid:s.superTeam.updateInfoInSuperTeam,params:[{type:"Property",name:"superTeamMember"}]},getSuperTeamHistoryMsgs:{sid:s.superTeam.id,cid:s.superTeam.getSuperTeamHistoryMsgs,params:[{type:"long",name:"to"},{type:"long",name:"beginTime"},{type:"long",name:"endTime"},{type:"long",name:"lastMsgId"},{type:"int",name:"limit"},{type:"bool",name:"reverse"},{type:"LongArray",name:"msgTypes"}]},applySuperTeam:{sid:s.superTeam.id,cid:s.superTeam.applySuperTeam,params:[{type:"long",name:"teamId"},{type:"String",name:"ps"}]},passSuperTeamApply:{sid:s.superTeam.id,cid:s.superTeam.passSuperTeamApply,params:[{type:"long",name:"teamId"},{type:"String",name:"from"}]},rejectSuperTeamApply:{sid:s.superTeam.id,cid:s.superTeam.rejectSuperTeamApply,params:[{type:"long",name:"teamId"},{type:"String",name:"from"},{type:"String",name:"ps"}]},acceptSuperTeamInvite:{sid:s.superTeam.id,cid:s.superTeam.acceptSuperTeamInvite,params:[{type:"long",name:"teamId"},{type:"String",name:"from"}]},rejectSuperTeamInvite:{sid:s.superTeam.id,cid:s.superTeam.rejectSuperTeamInvite,params:[{type:"long",name:"teamId"},{type:"String",name:"from"},{type:"String",name:"ps"}]},markSuperTeamSessionAck:{sid:s.superTeam.id,cid:s.superTeam.markSuperTeamSessionAck,params:[{type:"long",name:"to"},{type:"long",name:"timetag"}]},addSuperTeamManagers:{sid:s.superTeam.id,cid:s.superTeam.addSuperTeamManagers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"}]},removeSuperTeamManagers:{sid:s.superTeam.id,cid:s.superTeam.removeSuperTeamManagers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"}]},updateSuperTeamMute:{sid:s.superTeam.id,cid:s.superTeam.updateSuperTeamMute,params:[{type:"long",name:"teamId"},{type:"int",name:"mute"}]},updateSuperTeamMembersMute:{sid:s.superTeam.id,cid:s.superTeam.updateSuperTeamMembersMute,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"},{type:"int",name:"mute"}]},updateNickInSuperTeam:{sid:s.superTeam.id,cid:s.superTeam.updateNickInSuperTeam,params:[{type:"Property",name:"superTeamMember"}]},transferSuperTeam:{sid:s.superTeam.id,cid:s.superTeam.transferSuperTeam,params:[{type:"long",name:"teamId"},{type:"String",name:"account"},{type:"bool",name:"leave"}]},markSuperTeamSessionsAck:{sid:s.superTeam.id,cid:s.superTeam.markSuperTeamSessionsAck,params:[{type:"PropertyArray",name:"sessionAckTags",entity:"sessionAckTag"}]},getSuperTeamMembersByJoinTime:{sid:s.superTeam.id,cid:s.superTeam.getSuperTeamMembersByJoinTime,params:[{type:"long",name:"teamId"},{type:"long",name:"joinTime"},{type:"int",name:"limit"},{type:"bool",name:"reverse"}]},getSuperTeamMembersByAccounts:{sid:s.superTeam.id,cid:s.superTeam.getSuperTeamMembersByAccounts,params:[{type:"StrArray",name:"memberIds"}]},getMutedSuperTeamMembers:{sid:s.superTeam.id,cid:s.superTeam.getMutedSuperTeamMembers,params:[{type:"long",name:"teamId"},{type:"long",name:"joinTime"},{type:"int",name:"limit"},{type:"bool",name:"reverse"}]},sendSuperTeamCustomSysMsg:{sid:s.superTeam.id,cid:s.superTeam.sendSuperTeamCustomSysMsg,params:[{type:"Property",name:"sysMsg"}]},deleteSuperTeamMsg:{sid:s.superTeam.id,cid:s.superTeam.deleteSuperTeamMsg,params:[{type:"Property",name:"sysMsg"}]},getMySuperTeamMembers:{sid:s.superTeam.id,cid:s.superTeam.getMySuperTeamMembers,params:[{type:"LongArray",name:"teamIds"}]},createTeam:{sid:s.team.id,cid:s.team.createTeam,params:[{type:"Property",name:"team"},{type:"StrArray",name:"accounts"},{type:"String",name:"ps"},{type:"Property",name:"antispamTag"}]},sendTeamMsg:{sid:s.team.id,cid:s.team.sendTeamMsg,params:[{type:"Property",name:"msg"}]},addTeamMembers:{sid:s.team.id,cid:s.team.addTeamMembers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"},{type:"String",name:"ps"},{type:"String",name:"attach"}]},removeTeamMembers:{sid:s.team.id,cid:s.team.removeTeamMembers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"}]},updateTeam:{sid:s.team.id,cid:s.team.updateTeam,params:[{type:"Property",name:"team"},{type:"Property",name:"antispamTag"}]},leaveTeam:{sid:s.team.id,cid:s.team.leaveTeam,params:[{type:"long",name:"teamId"}]},getTeam:{sid:s.team.id,cid:s.team.getTeam,params:[{type:"long",name:"teamId"}]},getTeams:{sid:s.team.id,cid:s.team.getTeams,params:[{type:"long",name:"timetag"}]},getTeamsById:{sid:s.team.id,cid:s.team.getTeamsById,params:[{type:"longArray",name:"teamIds"}]},getTeamMembers:{sid:s.team.id,cid:s.team.getTeamMembers,params:[{type:"long",name:"teamId"},{type:"long",name:"timetag"}]},dismissTeam:{sid:s.team.id,cid:s.team.dismissTeam,params:[{type:"long",name:"teamId"}]},applyTeam:{sid:s.team.id,cid:s.team.applyTeam,params:[{type:"long",name:"teamId"},{type:"String",name:"ps"}]},passTeamApply:{sid:s.team.id,cid:s.team.passTeamApply,params:[{type:"long",name:"teamId"},{type:"String",name:"from"}]},rejectTeamApply:{sid:s.team.id,cid:s.team.rejectTeamApply,params:[{type:"long",name:"teamId"},{type:"String",name:"from"},{type:"String",name:"ps"}]},addTeamManagers:{sid:s.team.id,cid:s.team.addTeamManagers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"}]},removeTeamManagers:{sid:s.team.id,cid:s.team.removeTeamManagers,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"}]},transferTeam:{sid:s.team.id,cid:s.team.transferTeam,params:[{type:"long",name:"teamId"},{type:"String",name:"account"},{type:"bool",name:"leave"}]},updateInfoInTeam:{sid:s.team.id,cid:s.team.updateInfoInTeam,params:[{type:"Property",name:"teamMember"}]},updateNickInTeam:{sid:s.team.id,cid:s.team.updateNickInTeam,params:[{type:"Property",name:"teamMember"}]},acceptTeamInvite:{sid:s.team.id,cid:s.team.acceptTeamInvite,params:[{type:"long",name:"teamId"},{type:"String",name:"from"}]},rejectTeamInvite:{sid:s.team.id,cid:s.team.rejectTeamInvite,params:[{type:"long",name:"teamId"},{type:"String",name:"from"},{type:"String",name:"ps"}]},getTeamHistoryMsgs:{sid:s.team.id,cid:s.team.getTeamHistoryMsgs,params:[{type:"long",name:"to"},{type:"long",name:"beginTime"},{type:"long",name:"endTime"},{type:"long",name:"lastMsgId"},{type:"int",name:"limit"},{type:"bool",name:"reverse"},{type:"LongArray",name:"msgTypes"}]},searchTeamHistoryMsgs:{sid:s.team.id,cid:s.team.searchTeamHistoryMsgs,params:[{type:"long",name:"to"},{type:"long",name:"beginTime"},{type:"long",name:"endTime"},{type:"String",name:"keyword"},{type:"int",name:"limit"},{type:"bool",name:"reverse"}]},updateMuteStateInTeam:{sid:s.team.id,cid:s.team.updateMuteStateInTeam,params:[{type:"long",name:"teamId"},{type:"String",name:"account"},{type:"int",name:"mute"}]},getMyTeamMembers:{sid:s.team.id,cid:s.team.getMyTeamMembers,params:[{type:"LongArray",name:"teamIds"}]},getMutedTeamMembers:{sid:s.team.id,cid:s.team.getMutedTeamMembers,params:[{type:"long",name:"teamId"}]},sendTeamMsgReceipt:{sid:s.team.id,cid:s.team.sendTeamMsgReceipt,params:[{type:"PropertyArray",name:"teamMsgReceipts",entity:"teamMsgReceipt"}]},getTeamMsgReads:{sid:s.team.id,cid:s.team.getTeamMsgReads,params:[{type:"PropertyArray",name:"teamMsgReceipts",entity:"teamMsgReceipt"}]},getTeamMsgReadAccounts:{sid:s.team.id,cid:s.team.getTeamMsgReadAccounts,params:[{type:"Property",name:"teamMsgReceipt"}]},muteTeamAll:{sid:s.team.id,cid:s.team.muteTeamAll,params:[{type:"long",name:"teamId"},{type:"int",name:"mute"}]},getTeamMemberInvitorAccid:{sid:s.team.id,cid:s.team.getTeamMemberInvitorAccid,params:[{type:"long",name:"teamId"},{type:"StrArray",name:"accounts"}]},friendRequest:{sid:s.friend.id,cid:s.friend.friendRequest,params:[{type:"String",name:"account"},{type:"byte",name:"type"},{type:"String",name:"ps"}]},deleteFriend:{sid:s.friend.id,cid:s.friend.deleteFriend,params:[{type:"String",name:"account"},{type:"Property",name:"delFriendParams"}]},updateFriend:{sid:s.friend.id,cid:s.friend.updateFriend,params:[{type:"Property",name:"friend"}]},getFriends:{sid:s.friend.id,cid:s.friend.getFriends,params:[{type:"long",name:"timetag"}]},getChatroomAddress:{sid:s.chatroom.id,cid:s.chatroom.getChatroomAddress,params:[{type:"long",name:"chatroomId"},{type:"bool",name:"isWeixinApp"},{type:"number",name:"type"}]},sendFilterMsg:{sid:r(s).id,cid:r(s).sendFilterMsg,params:[{type:"Property",name:"msg"}]},sendFilterCustomSysMsg:{sid:r(s).id,cid:r(s).sendFilterCustomSysMsg,params:[{type:"Property",name:"sysMsg"}]},publishEvent:{sid:s.eventService.id,cid:s.eventService.publishEvent,params:[{type:"Property",name:"msgEvent"}]},pushEvent:{sid:s.eventService.id,cid:s.eventService.pushEvent},subscribeEvent:{sid:s.eventService.id,cid:s.eventService.subscribeEvent,params:[{type:"Property",name:"msgEventSubscribe"},{type:"StrArray",name:"accounts"}]},unSubscribeEventsByAccounts:{sid:s.eventService.id,cid:s.eventService.unSubscribeEventsByAccounts,params:[{type:"Property",name:"msgEventSubscribe"},{type:"StrArray",name:"accounts"}]},unSubscribeEventsByType:{sid:s.eventService.id,cid:s.eventService.unSubscribeEventsByType,params:[{type:"Property",name:"msgEventSubscribe"}]},querySubscribeEventsByAccounts:{sid:s.eventService.id,cid:s.eventService.querySubscribeEventsByAccounts,params:[{type:"Property",name:"msgEventSubscribe"},{type:"StrArray",name:"accounts"}]},querySubscribeEventsByType:{sid:s.eventService.id,cid:s.eventService.querySubscribeEventsByType,params:[{type:"Property",name:"msgEventSubscribe"}]},pushEvents:{sid:s.eventService.id,cid:s.eventService.pushEvents},getThreadMsgs:{sid:s.msgExtend.id,cid:s.msgExtend.getThreadMsgs,params:[{type:"Property",name:"msg"},{type:"Property",name:"threadMsgReq"}]},getMsgsByIdServer:{sid:s.msgExtend.id,cid:s.msgExtend.getMsgsByIdServer,params:[{type:"PropertyArray",name:"reqMsgs",entity:"msg"}]},addQuickComment:{sid:s.msgExtend.id,cid:s.msgExtend.addQuickComment,params:[{type:"Property",name:"msg"},{type:"Property",name:"comment"}]},deleteQuickComment:{sid:s.msgExtend.id,cid:s.msgExtend.deleteQuickComment,params:[{type:"Property",name:"msg"},{type:"Property",name:"comment"}]},getQuickComments:{sid:s.msgExtend.id,cid:s.msgExtend.getQuickComments,params:[{type:"PropertyArray",name:"commentReq",entity:"commentReq"}]},addCollect:{sid:s.msgExtend.id,cid:s.msgExtend.addCollect,params:[{type:"Property",name:"collect"}]},deleteCollects:{sid:s.msgExtend.id,cid:s.msgExtend.deleteCollects,params:[{type:"PropertyArray",name:"collectList",entity:"collect"}]},updateCollect:{sid:s.msgExtend.id,cid:s.msgExtend.updateCollect,params:[{type:"Property",name:"collect"}]},getCollects:{sid:s.msgExtend.id,cid:s.msgExtend.getCollects,params:[{type:"Property",name:"collectQuery"}]},addStickTopSession:{sid:s.msgExtend.id,cid:s.msgExtend.addStickTopSession,params:[{type:"Property",name:"stickTopSession"}]},updateStickTopSession:{sid:s.msgExtend.id,cid:s.msgExtend.updateStickTopSession,params:[{type:"Property",name:"stickTopSession"}]},deleteStickTopSession:{sid:s.msgExtend.id,cid:s.msgExtend.deleteStickTopSession,params:[{type:"Property",name:"stickTopSession"}]},addMsgPin:{sid:s.msgExtend.id,cid:s.msgExtend.addMsgPin,params:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"}]},updateMsgPin:{sid:s.msgExtend.id,cid:s.msgExtend.updateMsgPin,params:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"}]},deleteMsgPin:{sid:s.msgExtend.id,cid:s.msgExtend.deleteMsgPin,params:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"}]},getMsgPins:{sid:s.msgExtend.id,cid:s.msgExtend.getMsgPins,params:[{type:"Property",name:"msgPinReq"}]},httpProxy:{sid:s.proxyService.id,cid:s.proxyService.httpProxy,params:[{type:"Property",name:"proxyTag"}]},getQChatAddress:{sid:s.qchat.id,cid:s.qchat.getQChatAddress,params:[{type:"Property",name:"getQChatAddressTag"}]}}),c=o.merge({},i.packetConfig,{"2_3":{service:"auth",cmd:"login",response:[{type:"Property",name:"loginRes"},{type:"PropertyArray",name:"loginPorts",entity:"loginPort"},{type:"Property",name:"aosPushInfo"}]},"2_5":{service:"auth",cmd:"kicked",response:[{type:"Number",name:"from"},{type:"Number",name:"reason"},{type:"String",name:"custom"},{type:"Number",name:"customClientType"}]},"2_6":{service:"auth",cmd:"logout"},"2_7":{service:"auth",cmd:"multiPortLogin",response:[{type:"Number",name:"state"},{type:"PropertyArray",name:"loginPorts",entity:"loginPort"}]},"2_8":{service:"auth",cmd:"kick",response:[{type:"StrArray",name:"deviceIds"}]},"3_1":{service:"user",cmd:"updatePushToken"},"3_2":{service:"user",cmd:"appBackground"},"3_3":{service:"user",cmd:"markInBlacklist"},"3_103":{service:"user",cmd:"syncMarkInBlacklist",response:[{type:"String",name:"account"},{type:"Boolean",name:"isAdd"}]},"3_4":{service:"user",cmd:"getBlacklist",response:[{type:"StrArray",name:"blacklist"}]},"3_5":{service:"user",cmd:"markInMutelist"},"3_105":{service:"user",cmd:"syncMarkInMutelist",response:[{type:"String",name:"account"},{type:"Boolean",name:"isAdd"}]},"3_6":{service:"user",cmd:"getMutelist",response:[{type:"StrArray",name:"mutelist"}]},"3_8":{service:"user",cmd:"getRelations",response:[{type:"PropertyArray",name:"specialRelations",entity:"specialRelation"},{type:"Number",name:"timetag"}]},"3_7":{service:"user",cmd:"getUsers",response:[{type:"PropertyArray",name:"users",entity:"user"}]},"3_10":{service:"user",cmd:"updateMyInfo",response:[{type:"Number",name:"timetag"}]},"3_15":{service:"user",cmd:"updateDonnop",response:[{type:"Number",name:"timetag"}]},"3_115":{service:"user",cmd:"syncUpdateDonnop",response:[{type:"Property",name:"donnop"},{type:"Number",name:"timetag"}]},"3_109":{service:"user",cmd:"syncMyInfo",response:[{type:"Property",name:"user"},{type:"Number",name:"timetag"}]},"3_110":{service:"user",cmd:"syncUpdateMyInfo",response:[{type:"Property",name:"user"}]},"4_1":{service:"notify"},"4_2":{service:"notify"},"4_3":{service:"notify",cmd:"markRead"},"4_4":{service:"notify",cmd:"syncOfflineMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"4_5":{service:"notify",cmd:"batchMarkRead"},"4_6":{service:"notify",cmd:"syncOfflineSysMsgs",response:[{type:"PropertyArray",name:"sysMsgs",entity:"sysMsg"}]},"4_8":{service:"notify",cmd:"syncOfflineNetcallMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"4_9":{service:"notify",cmd:"syncRoamingMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"4_12":{service:"notify",cmd:"syncMsgReceipts",response:[{type:"PropertyArray",name:"msgReceipts",entity:"msgReceipt"},{type:"Number",name:"timetag"}]},"4_13":{service:"notify",cmd:"syncDonnop",response:[{type:"Property",name:"donnop"},{type:"Number",name:"timetag"}]},"4_14":{service:"notify",cmd:"syncSessionAck",response:[{type:"StrLongMap",name:"p2p"},{type:"LongLongMap",name:"team"},{type:"Number",name:"timetag"}]},"4_15":{service:"notify",cmd:"syncRobots",response:[{type:"PropertyArray",name:"robots",entity:"robot"}]},"4_16":{service:"notify",cmd:"syncBroadcastMsgs",response:[{type:"PropertyArray",name:"broadcastMsgs",entity:"broadcastMsg"}]},"4_17":{service:"notify",cmd:"syncSuperTeamRoamingMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"4_18":{service:"notify",cmd:"syncOfflineSuperTeamSysMsgs",response:[{type:"PropertyArray",name:"sysMsgs",entity:"sysMsg"}]},"4_19":{service:"notify",cmd:"syncDeleteSuperTeamMsgOfflineRoaming",response:[{type:"PropertyArray",name:"sysMsgs",entity:"sysMsg"},{type:"Number",name:"timetag"},{type:"Number",name:"type"}]},"4_20":{service:"notify",cmd:"syncSuperTeamSessionAck",response:[{type:"LongLongMap",name:"superTeam"},{type:"Number",name:"timetag"}]},"4_21":{service:"notify",cmd:"syncDeleteMsgSelf",response:[{type:"PropertyArray",name:"deletedMsgs",entity:"deleteMsgSelfTag"}]},"4_22":{service:"notify",cmd:"syncSessionsWithMoreRoaming",response:[{type:"PropertyArray",name:"sessions",entity:"msg"}]},"4_23":{service:"notify",cmd:"syncStickTopSessions",response:[{type:"Number",name:"timetag"},{type:"boolean",name:"modify"},{type:"PropertyArray",name:"sessions",entity:"stickTopSession"}]},"4_24":{service:"notify",cmd:"syncSessionHistoryMsgsDelete",response:[{type:"PropertyArray",name:"sessionHistoryMsgsDeleteTags",entity:"clearMsgsParamsWithSync"}]},"4_25":{service:"notify",cmd:"syncSessionReliableInfo",response:[{type:"Property",name:"context",entity:"sessionReliableSyncContextTag"},{type:"PropertyArray",name:"datas",entity:"sessionReliableSyncTag"}]},"4_100":{service:"notify",cmd:"syncOfflineFilterMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"4_101":{service:"notify",cmd:"syncOfflineFilterSysMsgs",response:[{type:"PropertyArray",name:"sysMsgs",entity:"sysMsg"}]},"5_1":{service:"sync",cmd:"syncDone",response:[{type:"Number",name:"timetag"}]},"5_2":{service:"sync",cmd:"syncTeamMembersDone",response:[{type:"Number",name:"timetag"}]},"5_3":{service:"sync",cmd:"syncSuperTeamMembersDone",response:[{type:"Number",name:"timetag"}]},"7_1":{service:"msg",cmd:"sendMsg",response:[{type:"Property",name:"msg"}],trivialErrorCodes:[7101]},"7_2":{service:"msg",cmd:"msg",response:[{type:"Property",name:"msg"}]},"7_3":{service:"msg",cmd:"sysMsg",response:[{type:"Property",name:"sysMsg"}]},"7_6":{service:"msg",cmd:"getHistoryMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"7_7":{service:"msg",cmd:"sendCustomSysMsg",trivialErrorCodes:[7101]},"7_8":{service:"msg",cmd:"searchHistoryMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"7_9":{service:"msg",cmd:"deleteSessions"},"7_10":{service:"msg",cmd:"getSessions",response:[{type:"StrArray",name:"sessions"}]},"7_101":{service:"msg",cmd:"syncSendMsg",response:[{type:"Property",name:"msg"}]},"7_11":{service:"msg",cmd:"sendMsgReceipt",response:[{type:"Property",name:"msgReceipt"}]},"7_12":{service:"msg",cmd:"msgReceipt",response:[{type:"Property",name:"msgReceipt"}]},"7_13":{service:"msg",cmd:"onDeleteMsg"},"7_14":{service:"msg",cmd:"onMsgDeleted",response:[{type:"Property",name:"sysMsg"}]},"7_15":{service:"msg",cmd:"onDeleteMsgOfflineRoaming",response:[{type:"PropertyArray",name:"sysMsgs",entity:"sysMsg"},{type:"Number",name:"timetag"},{type:"Number",name:"type"}]},"7_16":{service:"msg",cmd:"onMarkSessionAck"},"7_17":{service:"msg",cmd:"broadcastMsg",response:[{type:"Property",name:"broadcastMsg"}]},"7_18":{service:"msg",cmd:"clearServerHistoryMsgs",response:[{type:"Long",name:"timetag"}]},"7_19":{service:"session",cmd:"getServerSessions",response:[{type:"Property",name:"sessionReqTag"},{type:"PropertyArray",name:"sessionList",entity:"session"}]},"7_20":{service:"session",cmd:"getServerSession",response:[{type:"Property",name:"session"}]},"7_21":{service:"session",cmd:"updateServerSession"},"7_22":{service:"session",cmd:"deleteServerSessions"},"7_23":{service:"msg",cmd:"deleteMsgSelf",response:[{type:"Long",name:"timetag"}]},"7_24":{service:"msg",cmd:"deleteMsgSelfBatch",response:[{type:"Long",name:"timetag"}]},"7_25":{service:"msg",cmd:"onMarkSessionAckBatch"},"7_26":{service:"msg",cmd:"msgFtsInServer",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"7_27":{service:"msg",cmd:"msgFtsInServerByTiming",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"7_118":{service:"msg",cmd:"onClearServerHistoryMsgs",response:[{type:"Property",name:"sessionHistoryMsgsDeleteTag",entity:"clearMsgsParamsWithSync"}]},"7_123":{service:"msg",cmd:"onDeleteMsgSelf",response:[{type:"Property",name:"deleteMsgSelfTag"}]},"7_124":{service:"msg",cmd:"onDeleteMsgSelfBatch",response:[{type:"PropertyArray",name:"deleteMsgSelfTags",entity:"deleteMsgSelfTag"}]},"7_116":{service:"msg",cmd:"syncMarkSessionAck",response:[{type:"Number",name:"scene"},{type:"String",name:"to"},{type:"Number",name:"timetag"}]},"7_121":{service:"msg",cmd:"syncUpdateServerSession",response:[{type:"Property",name:"session"}]},"23_1":{service:"msgExtend",cmd:"getThreadMsgs",response:[{type:"Property",name:"threadMsg",entity:"msg"},{type:"Property",name:"threadMsgsMeta"},{type:"PropertyArray",name:"msgs",entity:"msg"}]},"23_2":{service:"msgExtend",cmd:"getMsgsByIdServer",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"23_3":{service:"msgExtend",cmd:"addQuickComment",response:[{type:"Number",name:"timetag"}]},"23_4":{service:"msgExtend",cmd:"deleteQuickComment",response:[{type:"Number",name:"timetag"}]},"23_5":{service:"msgExtend",cmd:"onQuickComment",response:[{type:"Property",name:"msg"},{type:"Property",name:"comment"}]},"23_6":{service:"msgExtend",cmd:"onDeleteQuickComment",response:[{type:"Property",name:"msg"},{type:"Property",name:"comment"}]},"23_7":{service:"msgExtend",cmd:"getQuickComments",response:[{type:"PropertyArray",name:"commentRes",entity:"commentRes"}]},"23_8":{service:"msgExtend",cmd:"addCollect",response:[{type:"Property",name:"collect"}]},"23_9":{service:"msgExtend",cmd:"deleteCollects",response:[{type:"Number",name:"deleteNum"}]},"23_10":{service:"msgExtend",cmd:"updateCollect",response:[{type:"Property",name:"collect"}]},"23_11":{service:"msgExtend",cmd:"getCollects",response:[{type:"Number",name:"total"},{type:"PropertyArray",name:"collectList",entity:"collect"}]},"23_12":{service:"msgExtend",cmd:"addStickTopSession",response:[{type:"Property",name:"stickTopSession"}]},"23_13":{service:"msgExtend",cmd:"deleteStickTopSession",response:[{type:"Number",name:"timetag"}]},"23_14":{service:"msgExtend",cmd:"updateStickTopSession",response:[{type:"Property",name:"stickTopSession"}]},"23_15":{service:"msgExtend",cmd:"addMsgPin",response:[{type:"Number",name:"timetag"}]},"23_16":{service:"msgExtend",cmd:"updateMsgPin",response:[{type:"Number",name:"timetag"}]},"23_17":{service:"msgExtend",cmd:"deleteMsgPin",response:[{type:"Number",name:"timetag"}]},"23_18":{service:"msgExtend",cmd:"onAddMsgPin",response:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"},{type:"Number",name:"timetag"}]},"23_19":{service:"msgExtend",cmd:"onUpdateMsgPin",response:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"},{type:"Number",name:"timetag"}]},"23_20":{service:"msgExtend",cmd:"onDeleteMsgPin",response:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"},{type:"Number",name:"timetag"}]},"23_21":{service:"msgExtend",cmd:"getMsgPins",response:[{type:"Number",name:"timetag"},{type:"Boolean",name:"modify"},{type:"PropertyArray",name:"pins",entity:"msgPinRes"}]},"23_103":{service:"msgExtend",cmd:"syncAddQuickComment",response:[{type:"Property",name:"msg"},{type:"Property",name:"comment"}]},"23_104":{service:"msgExtend",cmd:"syncDeleteQuickComment",response:[{type:"Property",name:"msg"},{type:"Property",name:"comment"}]},"23_112":{service:"msgExtend",cmd:"syncAddStickTopSession",response:[{type:"Property",name:"stickTopSession"}]},"23_113":{service:"msgExtend",cmd:"syncDeleteStickTopSession",response:[{type:"Number",name:"timetag"},{type:"Property",name:"stickTopSession"}]},"23_114":{service:"msgExtend",cmd:"syncUpdateStickTopSession",response:[{type:"Property",name:"stickTopSession"}]},"23_115":{service:"msgExtend",cmd:"syncAddMsgPin",response:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"},{type:"Number",name:"timetag"}]},"23_116":{service:"msgExtend",cmd:"syncUpdateMsgPin",response:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"},{type:"Number",name:"timetag"}]},"23_117":{service:"msgExtend",cmd:"syncDeleteMsgPin",response:[{type:"Property",name:"msg"},{type:"Property",name:"pinTag"},{type:"Number",name:"timetag"}]},"21_2":{service:"superTeam",cmd:"sendSuperTeamMsg",response:[{type:"Property",name:"msg"}]},"21_3":{service:"superTeam",cmd:"superTeamMsg",response:[{type:"Property",name:"msg"}]},"21_5":{service:"superTeam",cmd:"addSuperTeamMembers",response:[{type:"StrArray",name:"abortedAccidList"},{type:"long",name:"timetag"}]},"21_6":{service:"superTeam",cmd:"removeSuperTeamMembers"},"21_7":{service:"superTeam",cmd:"leaveSuperTeam"},"21_8":{service:"superTeam",cmd:"updateSuperTeam",response:[{type:"long",name:"timetag"}]},"21_9":{service:"superTeam",cmd:"getSuperTeam",response:[{type:"Property",name:"team"}]},"21_12":{service:"superTeam",cmd:"getSuperTeams",response:[{type:"PropertyArray",name:"teams",entity:"superTeam"},{type:"bool",name:"isAll"},{type:"long",name:"timetag"}]},"21_10":{service:"superTeam",cmd:"updateInfoInSuperTeam"},"21_13":{service:"superTeam",cmd:"getSuperTeamMembers",response:[{type:"long",name:"timetag"}]},"21_11":{service:"superTeam",cmd:"getMySuperTeamMembers",response:[{type:"PropertyArray",name:"members",entity:"superTeamMember"}]},"21_14":{service:"superTeam",cmd:"getSuperTeamHistoryMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"21_15":{service:"superTeam",cmd:"getSuperTeamMembersByJoinTime",response:[{type:"PropertyArray",name:"members",entity:"superTeamMember"}]},"21_16":{service:"superTeam",cmd:"sendSuperTeamCustomSysMsg",trivialErrorCodes:[7101]},"21_17":{service:"superTeam",cmd:"onDeleteSuperTeamMsg"},"21_18":{service:"superTeam",cmd:"onSuperTeamMsgDelete",response:[{type:"Property",name:"sysMsg"}]},"21_19":{service:"superTeam",cmd:"superTeamCustomSysMsg",response:[{type:"Property",name:"sysMsg"}]},"21_20":{service:"superTeam",cmd:"applySuperTeam",response:[{type:"Property",name:"team"}]},"21_21":{service:"superTeam",cmd:"passSuperTeamApply"},"21_22":{service:"superTeam",cmd:"rejectSuperTeamApply"},"21_23":{service:"superTeam",cmd:"acceptSuperTeamInvite",response:[{type:"Property",name:"team"}]},"21_24":{service:"superTeam",cmd:"rejectSuperTeamInvite"},"21_25":{service:"superTeam",cmd:"onMarkSuperTeamSessionAck"},"21_26":{service:"superTeam",cmd:"addSuperTeamManagers"},"21_27":{service:"superTeam",cmd:"removeSuperTeamManagers"},"21_28":{service:"superTeam",cmd:"updateSuperTeamMute"},"21_29":{service:"superTeam",cmd:"updateSuperTeamMembersMute",response:[{type:"long",name:"timetag"}]},"21_30":{service:"superTeam",cmd:"updateNickInSuperTeam"},"21_31":{service:"superTeam",cmd:"transferSuperTeam"},"21_32":{service:"superTeam",cmd:"onMarkSuperTeamSessionsAck"},"21_33":{service:"superTeam",cmd:"getSuperTeamMembersByAccounts",response:[{type:"PropertyArray",name:"members",entity:"superTeamMember"}]},"21_34":{service:"superTeam",cmd:"getMutedSuperTeamMembers",response:[{type:"PropertyArray",name:"members",entity:"superTeamMember"}]},"21_113":{service:"superTeam",cmd:"syncSuperTeamMembers",response:[{type:"Number",name:"teamId"},{type:"PropertyArray",name:"members",entity:"superTeamMember"},{type:"bool",name:"isAll"},{type:"long",name:"timetag"}]},"21_111":{service:"superTeam",cmd:"syncMySuperTeamMembers",response:[{type:"PropertyArray",name:"teamMembers",entity:"superTeamMember"},{type:"long",name:"timetag"}]},"21_109":{service:"superTeam",cmd:"syncSuperTeams",response:[{type:"PropertyArray",name:"teams",entity:"superTeam"},{type:"bool",name:"isAll"},{type:"long",name:"timetag"}]},"21_101":{service:"superTeam",cmd:"syncCreateSuperTeam",response:[{type:"Property",name:"team"}]},"21_102":{service:"superTeam",cmd:"syncSendSuperTeamMsg",response:[{type:"Property",name:"msg"}]},"21_110":{service:"superTeam",cmd:"syncUpdateSuperTeamMember",response:[{type:"Property",name:"teamMember",entity:"superTeamMember"}]},"21_117":{service:"superTeam",cmd:"syncDeleteSuperTeamMsg",response:[{type:"Property",name:"sysMsg"}]},"21_125":{service:"superTeam",cmd:"syncMarkSuperTeamSessionAck",response:[{type:"Long",name:"to"},{type:"Long",name:"timetag"}]},"8_1":{service:"team",cmd:"createTeam",response:[{type:"Property",name:"team"},{type:"StrArray",name:"abortedAccidList"}]},"8_2":{service:"team",cmd:"sendTeamMsg",response:[{type:"Property",name:"msg"}]},"8_3":{service:"team",cmd:"teamMsg",response:[{type:"Property",name:"msg"}]},"8_4":{service:"team",cmd:"teamMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"8_5":{service:"team",cmd:"addTeamMembers",response:[{type:"long",name:"time"},{type:"StrArray",name:"abortedAccidList"}]},"8_6":{service:"team",cmd:"removeTeamMembers"},"8_7":{service:"team",cmd:"updateTeam",response:[{type:"Number",name:"id"},{type:"Number",name:"time"}]},"8_8":{service:"team",cmd:"leaveTeam"},"8_9":{service:"team",cmd:"getTeam",response:[{type:"Property",name:"team"}]},"8_10":{service:"team",cmd:"getTeams",response:[{type:"PropertyArray",name:"teams",entity:"team"},{type:"Number",name:"timetag"}]},"8_11":{service:"team",cmd:"getTeamMembers",response:[{type:"Number",name:"teamId"},{type:"PropertyArray",name:"members",entity:"teamMember"},{type:"Number",name:"timetag"}]},"8_12":{service:"team",cmd:"dismissTeam"},"8_13":{service:"team",cmd:"applyTeam",response:[{type:"Property",name:"team"}]},"8_14":{service:"team",cmd:"passTeamApply"},"8_15":{service:"team",cmd:"rejectTeamApply"},"8_16":{service:"team",cmd:"addTeamManagers"},"8_17":{service:"team",cmd:"removeTeamManagers"},"8_18":{service:"team",cmd:"transferTeam"},"8_19":{service:"team",cmd:"updateInfoInTeam"},"8_20":{service:"team",cmd:"updateNickInTeam"},"8_21":{service:"team",cmd:"acceptTeamInvite",response:[{type:"Property",name:"team"}]},"8_22":{service:"team",cmd:"rejectTeamInvite"},"8_23":{service:"team",cmd:"getTeamHistoryMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"8_24":{service:"team",cmd:"searchTeamHistoryMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"8_25":{service:"team",cmd:"updateMuteStateInTeam"},"8_26":{service:"team",cmd:"getMyTeamMembers",response:[{type:"PropertyArray",name:"teamMembers",entity:"teamMember"}]},"8_27":{service:"team",cmd:"getMutedTeamMembers",response:[{type:"Number",name:"teamId"},{type:"PropertyArray",name:"teamMembers",entity:"teamMember"}]},"8_28":{service:"team",cmd:"sendTeamMsgReceipt",response:[{type:"PropertyArray",name:"teamMsgReceipts",entity:"teamMsgReceipt"}]},"8_29":{service:"team",cmd:"getTeamMsgReads",response:[{type:"PropertyArray",name:"teamMsgReceipts",entity:"teamMsgReceipt"}]},"8_30":{service:"team",cmd:"getTeamMsgReadAccounts",response:[{type:"Property",name:"teamMsgReceipt"},{type:"StrArray",name:"readAccounts"},{type:"StrArray",name:"unreadAccounts"}]},"8_31":{service:"team",cmd:"notifyTeamMsgReads",response:[{type:"PropertyArray",name:"teamMsgReceipts",entity:"teamMsgReceipt"}]},"8_32":{service:"team",cmd:"muteTeamAll",response:[]},"8_33":{service:"team",cmd:"getTeamMemberInvitorAccid",response:[{type:"object",name:"accountsMap"}]},"8_34":{service:"team",cmd:"getTeamsById",response:[{type:"PropertyArray",name:"teams",entity:"team"},{type:"StrArray",name:"tids"}],trivialErrorCodes:[816]},"8_126":{service:"team",cmd:"syncMyTeamMembers",response:[{type:"PropertyArray",name:"teamMembers",entity:"teamMember"},{type:"Number",name:"timetag"}]},"8_109":{service:"team",cmd:"syncTeams",response:[{type:"Number",name:"timetag"},{type:"PropertyArray",name:"teams",entity:"team"}]},"8_111":{service:"team",cmd:"syncTeamMembers",response:[{type:"Number",name:"teamId"},{type:"PropertyArray",name:"members",entity:"teamMember"},{type:"Number",name:"timetag"}]},"8_101":{service:"team",cmd:"syncCreateTeam",response:[{type:"Property",name:"team"}]},"8_102":{service:"team",cmd:"syncSendTeamMsg",response:[{type:"Property",name:"msg"}]},"8_119":{service:"team",cmd:"syncUpdateTeamMember",response:[{type:"Property",name:"teamMember"}]},"12_1":{service:"friend",cmd:"friendRequest"},"12_101":{service:"friend",cmd:"syncFriendRequest",response:[{type:"String",name:"account"},{type:"Number",name:"type"},{type:"String",name:"ps"}]},"12_2":{service:"friend",cmd:"deleteFriend"},"12_102":{service:"friend",cmd:"syncDeleteFriend",response:[{type:"String",name:"account"}]},"12_3":{service:"friend",cmd:"updateFriend"},"12_103":{service:"friend",cmd:"syncUpdateFriend",response:[{type:"Property",name:"friend"}]},"12_4":{service:"friend",cmd:"getFriends",response:[{type:"PropertyArray",name:"friends",entity:"friend"},{type:"Number",name:"timetag"}]},"12_5":{service:"friend",cmd:"syncFriends",response:[{type:"PropertyArray",name:"friends",entity:"friend"},{type:"Number",name:"timetag"}]},"12_6":{service:"friend",cmd:"syncFriendUsers",response:[{type:"PropertyArray",name:"users",entity:"user"},{type:"Number",name:"timetag"}]},"13_1":{service:"chatroom",cmd:"getChatroomAddress",response:[{type:"StrArray",name:"address"}]},"14_1":{service:"eventService",cmd:"publishEvent",response:[{type:"Property",name:"msgEvent"}]},"14_2":{service:"eventService",cmd:"pushEvent",response:[{type:"Property",name:"msgEvent"}]},"14_3":{service:"eventService",cmd:"subscribeEvent",response:[{type:"StrArray",name:"accounts"}]},"14_4":{service:"eventService",cmd:"unSubscribeEventsByAccounts",response:[{type:"StrArray",name:"accounts"}]},"14_5":{service:"eventService",cmd:"unSubscribeEventsByType"},"14_6":{service:"eventService",cmd:"querySubscribeEventsByAccounts",response:[{type:"PropertyArray",name:"msgEventSubscribes",entity:"msgEventSubscribe"}]},"14_7":{service:"eventService",cmd:"querySubscribeEventsByType",response:[{type:"PropertyArray",name:"msgEventSubscribes",entity:"msgEventSubscribe"}]},"14_9":{service:"eventService",cmd:"pushEvents",response:[{type:"PropertyArray",name:"msgEvents",entity:"msgEvent"}]},"22_1":{service:"proxyService",cmd:"httpProxy",response:[{type:"Property",name:"proxyTag"}]},"22_2":{service:"proxyService",cmd:"onProxyMsg",response:[{type:"Property",name:"proxyMsg",entity:"proxyMsgTag"}]},"24_1":{service:"qchat",cmd:"getQChatAddress",response:[{type:"StrArray",name:"address"}]},"101_1":{service:"filter",cmd:"sendFilterMsg",response:[{type:"Property",name:"msg"}]},"101_2":{service:"filter",cmd:"filterMsg",response:[{type:"Property",name:"msg"}]},"101_3":{service:"filter",cmd:"filterSysMsg",response:[{type:"Property",name:"sysMsg"}]},"101_7":{service:"filter",cmd:"sendFilterCustomSysMsg"}});e.exports={idMap:s,cmdConfig:a,packetConfig:c};},function(e,t){e.exports={negotiateTransportTag:{version:-1,serializeList:1,serialize:101},initTransportTag:{},nosToken:{objectName:1,token:2,bucket:3,expireTime:4,expireSec:7,tag:8,shortUrl:9},audioToText:{url:2},imageOp:{type:0,stripmeta:1,typeType:2,blurRadius:3,blurSigma:4,qualityQuality:5,cropX:6,cropY:7,cropWidth:8,cropHeight:9,rotateAngle:10,pixelPixel:11,thumbnailMode:12,thumbnailWidth:13,thumbnailHeight:14,thumbnailAxisX:15,thumbnailAxisY:16,thumbnailCenterX:17,thumbnailCenterY:18,thumbnailEnlarge:19,thumbnailToStatic:20,watermarkType:21,watermarkGravity:22,watermarkDissolve:23,watermarkDx:24,watermarkDy:25,watermarkImage:26,watermarkText:27,watermarkFont:28,watermarkFontSize:29,watermarkFontColor:30,interlace:31},robot:{account:4,nick:5,avatar:6,intro:7,config:8,valid:9,createTime:10,updateTime:11,custid:12,botid:13,bindTime:14},clientAntispam:{version:1,md5:2,nosurl:3,thesaurus:4},fileQuickTransfer:{md5:1,url:2,size:3,threshold:4},transToken:{name:1,type:2,transType:3,size:4,extra:5,body:6},transInfo:{docId:1,name:2,prefix:3,size:4,type:5,state:6,transType:7,transSize:8,pageCount:9,picInfo:10,extra:11,flag:12},nosFileUrlTag:{safeUrl:0,originUrl:1},nosAccessTokenTag:{token:0,url:1,userAgent:2,ext:3},fileListParam:{fromDocId:1,limit:2},avSignalTag:{type:1,channelName:2,channelId:3,channelCreateTime:4,channelExpireTime:5,creator:6,ext:7,channelInValid:8,from:10,to:11,requestId:12,needPush:13,pushTitle:14,pushContent:15,pushPayload:16,needBadge:17,members:18,attach:19,attachExt:20,isSave:21,msgid:22,uid:23,time:24,nertcChannelName:25,nertcTokenTtl:26,nertcToken:27,nertcJoinRoomQueryParamMap:28,nertcJoinRoomResponse:29,callStatus:30},login:{clientType:3,os:4,sdkVersion:6,appLogin:8,protocolVersion:9,pushTokenName:10,pushToken:11,deviceId:13,appKey:18,account:19,browser:24,session:26,deviceInfo:32,sdkType:41,userAgent:42,isReactNative:112,token:1e3,customTag:38,customClientType:39,sdkHumanVersion:40,authType:115,loginExt:116},loginRes:{lastLoginDeviceId:17,customTag:38,connectionId:102,ip:103,port:104,country:106,hasXMPush:111},loginPort:{type:3,os:4,mac:5,deviceId:13,account:19,deviceInfo:32,connectionId:102,ip:103,time:109,customTag:38,customClientType:39},aosPushInfo:{pushType:110,hasTokenPreviously:111},sync:{myInfo:1,offlineMsgs:2,teams:3,netcallMsgs:6,roamingMsgs:7,relations:9,friends:11,sessions:12,friendUsers:13,msgReceipts:14,myTeamMembers:15,donnop:16,deleteMsg:17,sessionAck:18,robots:19,broadcastMsgs:20,avSignal:21,superTeams:22,myInfoInSuperTeams:23,superTeamRoamingMsgs:24,deleteSuperTeamMsg:25,superTeamSessionAck:26,deleteMsgSelf:27,stickTopSessions:28,sessionHistoryMsgsDelete:29,filterMsgs:100},donnop:{open:1},sessionReqTag:{minTimestamp:1,maxTimestamp:2,needLastMsg:3,limit:4,hasMore:5},session:{id:1,updateTime:2,ext:3,lastMsg:4},superTeam:{teamId:1,name:3,type:4,owner:5,level:6,selfCustom:7,valid:8,memberNum:9,memberUpdateTime:10,createTime:11,updateTime:12,validToCurrentUser:13,intro:14,announcement:15,joinMode:16,bits:17,custom:18,serverCustom:19,avatar:20,beInviteMode:21,inviteMode:22,updateTeamMode:23,updateCustomMode:24,mute:100,muteType:101},superTeamMember:{teamId:1,account:3,type:4,nickInTeam:5,bits:7,active:8,valid:9,createTime:10,updateTime:11,custom:12,mute:13,invitoraccid:14,joinTime:15},team:{teamId:1,name:3,type:4,owner:5,level:6,selfCustom:7,valid:8,memberNum:9,memberUpdateTime:10,createTime:11,updateTime:12,validToCurrentUser:13,intro:14,announcement:15,joinMode:16,bits:17,custom:18,serverCustom:19,avatar:20,beInviteMode:21,inviteMode:22,updateTeamMode:23,updateCustomMode:24,mute:100,muteType:101},teamMember:{teamId:1,account:3,type:4,nickInTeam:5,bits:7,active:8,valid:9,joinTime:10,updateTime:11,custom:12,mute:13,invitorAccid:14},msg:{scene:0,to:1,from:2,fromClientType:4,fromDeviceId:5,fromNick:6,time:7,type:8,body:9,attach:10,idClient:11,idServer:12,resend:13,userUpdateTime:14,custom:15,pushPayload:16,pushContent:17,apnsAccounts:18,apnsContent:19,apnsForcePush:20,yidunEnable:21,antiSpamContent:22,antiSpamBusinessId:23,clientAntiSpam:24,antiSpamUsingYidun:25,needMsgReceipt:26,needUpdateSession:28,replyMsgFromAccount:29,replyMsgToAccount:30,replyMsgTime:31,replyMsgIdServer:32,replyMsgIdClient:33,threadMsgFromAccount:34,threadMsgToAccount:35,threadMsgTime:36,threadMsgIdServer:37,threadMsgIdClient:38,delete:39,callbackExt:40,subType:41,yidunAntiCheating:42,env:43,yidunAntiSpamExt:44,yidunAntiSpamRes:45,__clientExt:46,robotInfoFunction:47,robotInfoTopic:48,robotInfoCustomContent:49,robotInfoAccount:50,isHistoryable:100,isRoamingable:101,isSyncable:102,isMuted:104,cc:105,isInBlackList:106,isPushable:107,isOfflinable:108,isUnreadable:109,needPushNick:110,isReplyMsg:111,tempTeamMemberCount:112},threadMsgReq:{beginTime:1,endTime:2,lastMsgId:3,limit:4,reverse:5},threadMsgsMeta:{total:1,lastMsgTime:2},comment:{from:1,body:2,time:3,custom:4,needPush:5,needBadge:6,pushTitle:7,apnsText:8,pushPayload:9},commentReq:{scene:1,from:2,to:3,time:4,idServer:5,idClient:6,timestamp:100},commentRes:{scene:1,from:2,to:3,time:4,idServer:5,idClient:6,detail:7,modify:8,timestamp:100},collect:{id:1,type:2,data:3,custom:4,uniqueId:5,createTime:6,updateTime:7},collectQuery:{beginTime:1,endTime:2,lastMsgId:3,limit:4,reverse:5,type:6},stickTopSession:{id:1,topCustom:2,createTime:3,updateTime:4},pinTag:{pinFrom:1,pinCustom:2,createTime:3,updateTime:4},msgPinReq:{sessionId:1,timetag:2},msgPinRes:{scene:1,from:2,to:3,time:4,idServer:5,idClient:6,pinFrom:7,pinCustom:8},msgReceipt:{to:1,from:2,time:7,idClient:11},teamMsgReceipt:{teamId:0,idServer:1,read:100,unread:101,idClient:102,account:103},deleteMsgSelfTag:{scene:1,from:2,to:3,idServer:4,idClient:5,time:6,deletedTime:7,custom:8},sysMsg:{time:0,type:1,to:2,from:3,ps:4,attach:5,idServer:6,sendToOnlineUsersOnly:7,apnsText:8,pushPayload:9,deletedIdClient:10,deletedIdServer:11,yidunEnable:12,antiSpamContent:13,deletedMsgTime:14,deletedMsgFromNick:15,opeAccount:16,env:21,callbackExt:22,cc:105,isPushable:107,isUnreadable:109,needPushNick:110},broadcastMsg:{broadcastId:1,fromAccid:2,fromUid:3,timestamp:4,body:5},friend:{account:4,flag:5,beflag:6,source:7,alias:8,bits:9,custom:10,createTime:11,updateTime:12,serverex:13},user:{account:1,nick:3,avatar:4,sign:5,gender:6,email:7,birth:8,tel:9,custom:10,createTime:12,updateTime:13},antispamTag:{antiSpamBusinessId:1},specialRelation:{account:0,isMuted:1,isBlacked:2,createTime:3,updateTime:4},msgType:{text:0,picture:1,audio:2,video:3,location:4,notification:5,file:6,netcall_audio:7,netcall_vedio:8,datatunnel_new:9,tips:10,robot:11,custom:100},msgEvent:{type:1,value:2,idClient:3,custom:4,validTime:5,broadcastType:6,sync:7,validTimeType:8,durable:9,time:10,idServer:11,clientType:12,serverConfig:13,serverCustom:14,appid:101,account:103,enableMultiClient:104,consid:106},msgEventSubscribe:{type:1,subscribeTime:2,sync:3,to:102,from:104,time:105},clearMsgsParams:{account:1,delRoam:2},clearMsgsParamsWithSync:{type:0,otherAccid:1,isDeleteRoam:2,toTid:3,isSyncSelf:4,fromAccid:5,time:6,ext:7},msgFullSearchRequestTag:{keyword:1,fromTime:2,toTime:3,sessionLimit:4,msgLimit:5,order:6,p2pList:7,teamList:8,senderList:9,msgTypeList:10,msgSubTypeList:11},msgTimingFullSearchRequestTag:{keyword:1,fromTime:2,toTime:3,msgLimit:5,order:6,p2pList:7,teamList:8,senderList:9,msgTypeList:10,msgSubTypeList:11},delFriendParams:{delAlias:1},proxyTag:{zone:1,path:2,method:3,header:4,body:5},proxyMsgTag:{from:1,body:2,time:3},sessionAckTag:{scene:1,to:2,timetag:3},mixTokenReq:{provider:0,tokenCount:1,fileExpireSec:2,tag:3,returnBody:4},mixAuthTokenReq:{type:1,urls:2},notifyDetectTag:{type:1,params:2,result:3,t1:100,t2:101,t3:102,t4:103,t5:104,t6:105},getQChatAddressTag:{ipType:1}};},function(e,t){e.exports={negotiateTransportTag:{"-1":"version",1:"serializeList",101:"serialize"},initTransportTag:{},nosToken:{1:"objectName",2:"token",3:"bucket",4:"expireTime",7:"expireSec",8:"tag",9:"shortUrl"},audioToText:{2:"url"},imageOp:{0:"type",1:"stripmeta",2:"typeType",3:"blurRadius",4:"blurSigma",5:"qualityQuality",6:"cropX",7:"cropY",8:"cropWidth",9:"cropHeight",10:"rotateAngle",11:"pixelPixel",12:"thumbnailMode",13:"thumbnailWidth",14:"thumbnailHeight",15:"thumbnailAxisX",16:"thumbnailAxisY",17:"thumbnailCenterX",18:"thumbnailCenterY",19:"thumbnailEnlarge",20:"thumbnailToStatic",21:"watermarkType",22:"watermarkGravity",23:"watermarkDissolve",24:"watermarkDx",25:"watermarkDy",26:"watermarkImage",27:"watermarkText",28:"watermarkFont",29:"watermarkFontSize",30:"watermarkFontColor",31:"interlace"},robot:{4:"account",5:"nick",6:"avatar",7:"intro",8:"config",9:"valid",10:"createTime",11:"updateTime",12:"custid",13:"botid",14:"bindTime",_6_safe:"_avatar_safe"},clientAntispam:{1:"version",2:"md5",3:"nosurl",4:"thesaurus"},fileQuickTransfer:{1:"md5",2:"url",3:"size",4:"threshold",_2_safe:"_url_safe"},transToken:{1:"name",2:"type",3:"transType",4:"size",5:"extra",6:"body"},transInfo:{1:"docId",2:"name",3:"prefix",4:"size",5:"type",6:"state",7:"transType",8:"transSize",9:"pageCount",10:"picInfo",11:"extra",12:"flag"},nosFileUrlTag:{0:"safeUrl",1:"originUrl"},nosAccessTokenTag:{0:"token",1:"url",2:"userAgent",3:"ext"},nosConfigTag:{1:"bucket",2:"cdnDomain",3:"expire",4:"objectNamePrefix"},appGrayConfigTag:{0:"grayConfig",1:"ttl"},mixStorePolicyTag:{0:"providers",1:"ttl",2:"mixEnable",3:"nosPolicy",4:"s3Policy"},mixStoreTokenTag:{0:"provider",1:"accessKeyId",2:"secretAccessKey",3:"sessionToken",4:"token",5:"expireAt",6:"bucket",7:"objectName",8:"fileExpireSec",9:"tag",10:"shortUrl",11:"region"},notifyDetectTag:{1:"type",2:"params",3:"result",100:"t1",101:"t2",102:"t3",103:"t4",104:"t5",105:"t6"},backSourceTokenTag:{1:"type",2:"tokens",3:"token",4:"ttl"},fileListParam:{1:"fromDocId",2:"limit"},avSignalTag:{1:"type",2:"channelName",3:"channelId",4:"channelCreateTime",5:"channelExpireTime",6:"creator",7:"ext",8:"channelInValid",10:"from",11:"to",12:"requestId",13:"needPush",14:"pushTitle",15:"pushContent",16:"pushPayload",17:"needBadge",18:"members",19:"attach",20:"attachExt",21:"isSave",22:"msgid",23:"uid",24:"time",25:"nertcChannelName",26:"nertcTokenTtl",27:"nertcToken",28:"nertcJoinRoomQueryParamMap",29:"nertcJoinRoomResponse",30:"callStatus"},login:{3:"clientType",4:"os",6:"sdkVersion",8:"appLogin",9:"protocolVersion",10:"pushTokenName",11:"pushToken",13:"deviceId",18:"appKey",19:"account",24:"browser",26:"session",32:"deviceInfo",38:"customTag",39:"customClientType",40:"sdkHumanVersion",112:"isReactNative",115:"authType",116:"loginExt",1e3:"token"},loginRes:{17:"lastLoginDeviceId",38:"customTag",102:"connectionId",103:"ip",104:"port",106:"country",111:"hasXMPush"},loginPort:{3:"type",4:"os",5:"mac",13:"deviceId",19:"account",32:"deviceInfo",38:"customTag",39:"customClientType",102:"connectionId",103:"ip",109:"time"},aosPushInfo:{110:"pushType",111:"hasTokenPreviously"},sync:{1:"myInfo",2:"offlineMsgs",3:"teams",6:"netcallMsgs",7:"roamingMsgs",9:"relations",11:"friends",12:"sessions",13:"friendUsers",14:"msgReceipts",15:"myTeamMembers",16:"donnop",17:"deleteMsg",18:"sessionAck",19:"robots",20:"broadcastMsgs",21:"avSignal",22:"superTeams",23:"myInfoInSuperTeams",24:"superTeamRoamingMsgs",25:"deleteSuperTeamMsg",26:"superTeamSessionAck",27:"deleteMsgSelf",28:"stickTopSessions",29:"sessionHistoryMsgsDelete",100:"filterMsgs"},donnop:{1:"open"},sessionReqTag:{1:"minTimestamp",2:"maxTimestamp",3:"needLastMsg",4:"limit",5:"hasMore"},session:{1:"id",2:"updateTime",3:"ext",4:"lastMsg",5:"lastMsgType"},superTeam:{1:"teamId",3:"name",4:"type",5:"owner",6:"level",7:"selfCustom",8:"valid",9:"memberNum",10:"memberUpdateTime",11:"createTime",12:"updateTime",13:"validToCurrentUser",14:"intro",15:"announcement",16:"joinMode",17:"bits",18:"custom",19:"serverCustom",20:"avatar",21:"beInviteMode",22:"inviteMode",23:"updateTeamMode",24:"updateCustomMode",100:"mute",101:"muteType",_20_safe:"_avatar_safe"},superTeamMember:{1:"teamId",3:"account",4:"type",5:"nickInTeam",7:"bits",8:"active",9:"valid",10:"createTime",11:"updateTime",12:"custom",13:"mute",14:"invitoraccid",15:"joinTime"},team:{1:"teamId",3:"name",4:"type",5:"owner",6:"level",7:"selfCustom",8:"valid",9:"memberNum",10:"memberUpdateTime",11:"createTime",12:"updateTime",13:"validToCurrentUser",14:"intro",15:"announcement",16:"joinMode",17:"bits",18:"custom",19:"serverCustom",20:"avatar",21:"beInviteMode",22:"inviteMode",23:"updateTeamMode",24:"updateCustomMode",100:"mute",101:"muteType",_20_safe:"_avatar_safe"},teamMember:{1:"teamId",3:"account",4:"type",5:"nickInTeam",7:"bits",8:"active",9:"valid",10:"joinTime",11:"updateTime",12:"custom",13:"mute",14:"invitorAccid"},msg:{0:"scene",1:"to",2:"from",4:"fromClientType",5:"fromDeviceId",6:"fromNick",7:"time",8:"type",9:"body",10:"attach",11:"idClient",12:"idServer",13:"resend",14:"userUpdateTime",15:"custom",16:"pushPayload",17:"pushContent",18:"apnsAccounts",19:"apnsContent",20:"apnsForcePush",21:"yidunEnable",22:"antiSpamContent",23:"antiSpamBusinessId",24:"clientAntiSpam",25:"antiSpamUsingYidun",26:"needMsgReceipt",28:"needUpdateSession",29:"replyMsgFromAccount",30:"replyMsgToAccount",31:"replyMsgTime",32:"replyMsgIdServer",33:"replyMsgIdClient",34:"threadMsgFromAccount",35:"threadMsgToAccount",36:"threadMsgTime",37:"threadMsgIdServer",38:"threadMsgIdClient",39:"delete",40:"callbackExt",41:"subType",42:"yidunAntiCheating",43:"env",44:"yidunAntiSpamExt",45:"yidunAntiSpamRes",46:"__clientExt",47:"robotInfoFunction",48:"robotInfoTopic",49:"robotInfoCustomContent",50:"robotInfoAccount",100:"isHistoryable",101:"isRoamingable",102:"isSyncable",104:"isMuted",105:"cc",106:"isInBlackList",107:"isPushable",108:"isOfflinable",109:"isUnreadable",110:"needPushNick",111:"isReplyMsg",112:"tempTeamMemberCount"},threadMsgReq:{1:"beginTime",2:"endTime",3:"lastMsgId",4:"limit",5:"reverse"},threadMsgsMeta:{1:"total",2:"lastMsgTime"},comment:{1:"from",2:"body",3:"time",4:"custom",5:"needPush",6:"needBadge",7:"pushTitle",8:"apnsText",9:"pushPayload"},commentReq:{1:"scene",2:"from",3:"to",4:"time",5:"idServer",6:"idClient",100:"timestamp"},commentRes:{1:"scene",2:"from",3:"to",4:"time",5:"idServer",6:"idClient",7:"detail",8:"modify",100:"timestamp"},collect:{1:"id",2:"type",3:"data",4:"custom",5:"uniqueId",6:"createTime",7:"updateTime"},collectQuery:{1:"beginTime",2:"endTime",3:"lastMsgId",4:"limit",5:"reverse",6:"type"},stickTopSession:{1:"id",2:"topCustom",3:"createTime",4:"updateTime"},pinTag:{1:"pinFrom",2:"pinCustom",3:"createTime",4:"updateTime"},msgPinReq:{1:"sessionId",2:"timetag"},msgPinRes:{1:"scene",2:"from",3:"to",4:"time",5:"idServer",6:"idClient",7:"pinFrom",8:"pinCustom"},msgReceipt:{1:"to",2:"from",7:"time",11:"idClient"},teamMsgReceipt:{0:"teamId",1:"idServer",100:"read",101:"unread",102:"idClient",103:"account"},deleteMsgSelfTag:{1:"scene",2:"from",3:"to",4:"idServer",5:"idClient",6:"time",7:"deletedTime",8:"custom"},sysMsg:{0:"time",1:"type",2:"to",3:"from",4:"ps",5:"attach",6:"idServer",7:"sendToOnlineUsersOnly",8:"apnsText",9:"pushPayload",10:"deletedIdClient",11:"deletedIdServer",12:"yidunEnable",13:"antiSpamContent",14:"deletedMsgTime",15:"deletedMsgFromNick",16:"opeAccount",21:"env",22:"callbackExt",105:"cc",107:"isPushable",109:"isUnreadable",110:"needPushNick"},broadcastMsg:{1:"broadcastId",2:"fromAccid",3:"fromUid",4:"timestamp",5:"body"},friend:{4:"account",5:"flag",6:"beflag",7:"source",8:"alias",9:"bits",10:"custom",11:"createTime",12:"updateTime",13:"serverex"},user:{1:"account",3:"nick",4:"avatar",5:"sign",6:"gender",7:"email",8:"birth",9:"tel",10:"custom",12:"createTime",13:"updateTime",_4_safe:"_avatar_safe"},antispamTag:{antiSpamBusinessId:1},specialRelation:{0:"account",1:"isMuted",2:"isBlacked",3:"createTime",4:"updateTime"},msgType:{0:"text",1:"picture",2:"audio",3:"video",4:"location",5:"notification",6:"file",7:"netcall_audio",8:"netcall_vedio",9:"datatunnel_new",10:"tips",11:"robot",100:"custom"},msgEvent:{1:"type",2:"value",3:"idClient",4:"custom",5:"validTime",6:"broadcastType",7:"sync",8:"validTimeType",9:"durable",10:"time",11:"idServer",12:"clientType",13:"serverConfig",14:"serverCustom",101:"appid",103:"account",104:"enableMultiClient",106:"consid"},msgEventSubscribe:{1:"type",2:"subscribeTime",3:"sync",102:"to",104:"from",105:"time"},clearMsgsParams:{1:"account",2:"delRoam"},clearMsgsParamsWithSync:{0:"type",1:"otherAccid",2:"delRoam",3:"toTid",4:"isSyncSelf",5:"fromAccid",6:"time",7:"ext"},msgFullSearchRequestTag:{1:"keyword",2:"fromTime",3:"toTime",4:"sessionLimit",5:"msgLimit",6:"order",7:"p2pList",8:"teamList",9:"senderList",10:"msgTypeList",11:"msgSubTypeList"},delFriendParams:{1:"delAlias"},proxyTag:{1:"zone",2:"path",3:"method",4:"header",5:"body"},proxyMsgTag:{1:"from",2:"body",3:"time"},sessionReliableSyncTag:{1:"scene",2:"sessionId",3:"syncStatus",4:"syncEndMsgId",5:"syncEndMsgidClient",6:"syncEndMsgTime",7:"syncStartMsgid",8:"syncStartMsgidClient",9:"syncStartMsgTime",10:"nextMsgid",11:"nextMsgidClient",12:"nextMsgTime",13:"roamMsgSync",14:"offlineMsgSync",15:"netCallOfflineMsgSync"},sessionReliableSyncContextTag:{1:"timetag",2:"type"}};},function(e,t,n){var r=n(0),o=n(174),i=r.merge({},o.idMap,{chatroom:{id:13,login:2,kicked:3,logout:4,sendMsg:6,msg:7,getChatroomMembers:8,getHistoryMsgs:9,markChatroomMember:11,closeChatroom:12,getChatroom:13,updateChatroom:14,updateMyChatroomMemberInfo:15,getChatroomMembersInfo:16,kickChatroomMember:17,updateChatroomMemberTempMute:19,queueOffer:20,queuePoll:21,queueList:22,peak:23,queueDrop:24,queueInit:25,queueChange:26,updateTagMembersTempMute:30,getChatroomMembersByTag:31,getChatroomMemberCountByTag:32,updateCoordinate:33,updateChatroomTags:34,sendChatroomMsgAck:35,getHistoryMsgsByTags:36,notifyCdnInfo:99},user:{id:3,syncRobot:16}}),s=r.merge({},o.cmdConfig,{login:{sid:i.chatroom.id,cid:i.chatroom.login,params:[{type:"byte",name:"type"},{type:"Property",name:"login"},{type:"Property",name:"imLogin"}]},logout:{sid:i.chatroom.id,cid:i.chatroom.logout},sendMsg:{sid:i.chatroom.id,cid:i.chatroom.sendMsg,params:[{type:"Property",name:"msg"}]},getChatroomMembers:{sid:i.chatroom.id,cid:i.chatroom.getChatroomMembers,params:[{type:"byte",name:"type"},{type:"long",name:"time"},{type:"int",name:"limit"}]},getHistoryMsgs:{sid:i.chatroom.id,cid:i.chatroom.getHistoryMsgs,params:[{type:"long",name:"timetag"},{type:"int",name:"limit"},{type:"bool",name:"reverse"},{type:"LongArray",name:"msgTypes"}]},markChatroomMember:{sid:i.chatroom.id,cid:i.chatroom.markChatroomMember,params:[{type:"string",name:"account"},{type:"int",name:"type"},{type:"bool",name:"isAdd"},{type:"int",name:"level"},{type:"string",name:"custom"}]},closeChatroom:{sid:i.chatroom.id,cid:i.chatroom.closeChatroom,params:[{type:"string",name:"custom"}]},getChatroom:{sid:i.chatroom.id,cid:i.chatroom.getChatroom},updateChatroom:{sid:i.chatroom.id,cid:i.chatroom.updateChatroom,params:[{type:"Property",name:"chatroom"},{type:"bool",name:"needNotify"},{type:"String",name:"custom"},{type:"Property",name:"antispamTag"}]},updateMyChatroomMemberInfo:{sid:i.chatroom.id,cid:i.chatroom.updateMyChatroomMemberInfo,params:[{type:"Property",name:"chatroomMember"},{type:"bool",name:"needNotify"},{type:"String",name:"custom"},{type:"bool",name:"needSave"},{type:"Property",name:"antispamTag"}]},getChatroomMembersInfo:{sid:i.chatroom.id,cid:i.chatroom.getChatroomMembersInfo,params:[{type:"StrArray",name:"accounts"}]},kickChatroomMember:{sid:i.chatroom.id,cid:i.chatroom.kickChatroomMember,params:[{type:"string",name:"account"},{type:"string",name:"custom"}]},updateChatroomMemberTempMute:{sid:i.chatroom.id,cid:i.chatroom.updateChatroomMemberTempMute,params:[{type:"String",name:"account"},{type:"long",name:"duration"},{type:"bool",name:"needNotify"},{type:"String",name:"custom"}]},queueOffer:{sid:i.chatroom.id,cid:i.chatroom.queueOffer,params:[{type:"string",name:"elementKey"},{type:"string",name:"elementValue"},{type:"bool",name:"transient"},{type:"string",name:"elementAccount"}]},queuePoll:{sid:i.chatroom.id,cid:i.chatroom.queuePoll,params:[{type:"string",name:"elementKey"}]},queueList:{sid:i.chatroom.id,cid:i.chatroom.queueList},peak:{sid:i.chatroom.id,cid:i.chatroom.peak},queueDrop:{sid:i.chatroom.id,cid:i.chatroom.queueDrop},queueInit:{sid:i.chatroom.id,cid:i.chatroom.queueInit,params:[{type:"int",name:"limit"}]},queueChange:{sid:i.chatroom.id,cid:i.chatroom.queueChange,params:[{type:"StrStrMap",name:"elementMap"},{type:"bool",name:"needNotify"},{type:"string",name:"notifyExt"}]},updateTagMembersTempMute:{sid:i.chatroom.id,cid:i.chatroom.updateTagMembersTempMute,params:[{type:"Property",name:"tagMuteReq"}]},updateCoordinate:{sid:i.chatroom.id,cid:i.chatroom.updateCoordinate,params:[{type:"Property",name:"coordinateReq"}]},getChatroomMemberCountByTag:{sid:i.chatroom.id,cid:i.chatroom.getChatroomMemberCountByTag,params:[{type:"String",name:"tag"}]},getChatroomMembersByTag:{sid:i.chatroom.id,cid:i.chatroom.getChatroomMembersByTag,params:[{type:"Property",name:"tagMemberReq"}]},updateChatroomTags:{sid:i.chatroom.id,cid:i.chatroom.updateChatroomTags,params:[{type:"Property",name:"chatRoomTagsUpdateTag"}]},sendChatroomMsgAck:{sid:i.chatroom.id,cid:i.chatroom.sendChatroomMsgAck,params:[{type:"Property",name:"chatRoomMsgAckTag"}]},getHistoryMsgsByTags:{sid:i.chatroom.id,cid:i.chatroom.getHistoryMsgsByTags,params:[{type:"Property",name:"chatRoomTagHistoryMsgRequestTag"}]},notifyCdnInfo:{sid:i.chatroom.id,cid:i.chatroom.notifyCdnInfo},syncRobot:{sid:i.user.id,cid:i.user.syncRobot,params:[{type:"long",name:"timetag"}]}}),a=r.merge({},o.packetConfig,{"4_10":{service:"notify"},"4_11":{service:"notify"},"3_16":{service:"chatroom",cmd:"syncRobot",response:[{type:"PropertyArray",name:"robots",entity:"robot"}]},"13_2":{service:"chatroom",cmd:"login",response:[{type:"Property",name:"chatroom"},{type:"Property",name:"chatroomMember"},{type:"Property",name:"chatroomCdnInfo"}]},"13_3":{service:"chatroom",cmd:"kicked",response:[{type:"Number",name:"reason"},{type:"String",name:"custom"}]},"13_4":{service:"chatroom",cmd:"logout"},"13_6":{service:"chatroom",cmd:"sendMsg",response:[{type:"Property",name:"msg"}]},"13_7":{service:"chatroom",cmd:"msg",response:[{type:"Property",name:"msg"}]},"13_8":{service:"chatroom",cmd:"getChatroomMembers",response:[{type:"PropertyArray",name:"members",entity:"chatroomMember"}]},"13_9":{service:"chatroom",cmd:"getHistoryMsgs",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"13_11":{service:"chatroom",cmd:"markChatroomMember",response:[{type:"Property",name:"chatroomMember"}]},"13_12":{service:"chatroom",cmd:"closeChatroom"},"13_13":{service:"chatroom",cmd:"getChatroom",response:[{type:"Property",name:"chatroom"}]},"13_14":{service:"chatroom",cmd:"updateChatroom"},"13_15":{service:"chatroom",cmd:"updateMyChatroomMemberInfo"},"13_16":{service:"chatroom",cmd:"getChatroomMembersInfo",response:[{type:"PropertyArray",name:"members",entity:"chatroomMember"}]},"13_17":{service:"chatroom",cmd:"kickChatroomMember"},"13_19":{service:"chatroom",cmd:"updateChatroomMemberTempMute"},"13_20":{service:"chatroom",cmd:"queueOffer"},"13_21":{service:"chatroom",cmd:"queuePoll",response:[{type:"String",name:"elementKey"},{type:"String",name:"elementValue"}]},"13_22":{service:"chatroom",cmd:"queueList",response:[{type:"KVArray",name:"queueList"}]},"13_23":{service:"chatroom",cmd:"peak",response:[{type:"String",name:"elementKey"},{type:"String",name:"elementValue"}]},"13_24":{service:"chatroom",cmd:"queueDrop"},"13_25":{service:"chatroom",cmd:"queueInit"},"13_26":{service:"chatroom",cmd:"queueChange",response:[{type:"StrArray",name:"elementKeyArray"}]},"13_30":{service:"chatroom",cmd:"updateTagMembersTempMute"},"13_33":{service:"chatroom",cmd:"updateCoordinate"},"13_31":{service:"chatroom",cmd:"getChatroomMembersByTag",response:[{type:"PropertyArray",name:"members",entity:"chatroomMember"}]},"13_32":{service:"chatroom",cmd:"getChatroomMemberCountByTag",response:[{type:"long",name:"count"}]},"13_34":{service:"chatroom",cmd:"updateChatroomTags"},"13_36":{service:"chatroom",cmd:"getHistoryMsgsByTags",response:[{type:"PropertyArray",name:"msgs",entity:"msg"}]},"13_99":{service:"chatroom",cmd:"notifyCdnInfo",response:[{type:"Property",name:"chatroomCdnInfo"}]},"13_101":{service:"chatroom",cmd:"updateChatroomTag",response:[{type:"Property",name:"updateTags"}]}});e.exports={idMap:i,cmdConfig:s,packetConfig:a};},function(e,t){e.exports={imLogin:{clientType:3,os:4,sdkVersion:6,appLogin:8,protocolVersion:9,pushTokenName:10,pushToken:11,deviceId:13,appKey:18,account:19,browser:24,session:26,deviceInfo:32,sdkType:41,userAgent:42,isReactNative:112,authType:115,loginExt:116,token:1e3,customTag:38},nosToken:{objectName:1,token:2,bucket:3,expireTime:4,expireSec:7,tag:8,shortUrl:9},audioToText:{url:2},imageOp:{type:0,stripmeta:1,typeType:2,blurRadius:3,blurSigma:4,qualityQuality:5,cropX:6,cropY:7,cropWidth:8,cropHeight:9,rotateAngle:10,pixelPixel:11,thumbnailMode:12,thumbnailWidth:13,thumbnailHeight:14,thumbnailAxisX:15,thumbnailAxisY:16,thumbnailCenterX:17,thumbnailCenterY:18,thumbnailEnlarge:19,thumbnailToStatic:20,watermarkType:21,watermarkGravity:22,watermarkDissolve:23,watermarkDx:24,watermarkDy:25,watermarkImage:26,watermarkText:27,watermarkFont:28,watermarkFontSize:29,watermarkFontColor:30,interlace:31},robot:{account:4,nick:5,avatar:6,intro:7,config:8,valid:9,createTime:10,updateTime:11,custid:12,botid:13,bindTime:14},clientAntispam:{version:1,md5:2,nosurl:3,thesaurus:4},fileQuickTransfer:{md5:1,url:2,size:3,threshold:4},transToken:{name:1,type:2,transType:3,size:4,extra:5,body:6},transInfo:{docId:1,name:2,prefix:3,size:4,type:5,state:6,transType:7,transSize:8,pageCount:9,picInfo:10,extra:11,flag:12},nosFileUrlTag:{safeUrl:0,originUrl:1},nosAccessTokenTag:{token:0,url:1,userAgent:2,ext:3},fileListParam:{fromDocId:1,limit:2},avSignalTag:{type:1,channelName:2,channelId:3,channelCreateTime:4,channelExpireTime:5,creator:6,ext:7,channelInValid:8,from:10,to:11,requestId:12,needPush:13,pushTitle:14,pushContent:15,pushPayload:16,needBadge:17,members:18,attach:19,attachExt:20,isSave:21,msgid:22,uid:23,time:24,nertcChannelName:25,nertcTokenTtl:26,nertcToken:27,nertcJoinRoomQueryParamMap:28,nertcJoinRoomResponse:29,callStatus:30},login:{appKey:1,account:2,deviceId:3,chatroomId:5,appLogin:8,chatroomNick:20,chatroomAvatar:21,chatroomCustom:22,chatroomEnterCustom:23,session:26,isAnonymous:38,tags:39,notifyTargetTags:40,loginAuthType:41,loginExt:42,loc_x:43,loc_y:44,loc_z:45,distance:46,antiSpamBusinessId:47},chatroom:{id:1,name:3,announcement:4,broadcastUrl:5,custom:12,createTime:14,updateTime:15,queuelevel:16,creator:100,onlineMemberNum:101,mute:102},msg:{idClient:1,type:2,attach:3,custom:4,resend:5,userUpdateTime:6,fromNick:7,fromAvatar:8,fromCustom:9,yidunEnable:10,antiSpamContent:11,skipHistory:12,body:13,antiSpamBusinessId:14,clientAntiSpam:15,antiSpamUsingYidun:16,time:20,from:21,chatroomId:22,fromClientType:23,highPriority:25,callbackExt:27,subType:28,yidunAntiCheating:29,env:30,notifyTargetTags:31,yidunAntiSpamExt:32,yidunAntiSpamRes:33,loc_x:34,loc_y:35,loc_z:36,toAccids:37,needHighPriorityMsgAck:38,__clientExt:39},chatroomMember:{chatroomId:1,account:2,type:3,level:4,nick:5,avatar:6,custom:7,online:8,guest:9,enterTime:10,blacked:12,gaged:13,valid:14,updateTime:15,tempMuted:16,tempMuteDuration:17},antispamTag:{antiSpamBusinessId:1},chatroomCdnInfo:{enable:1,cdnUrls:2,timestamp:3,interval:4,decryptType:5,decryptKey:6,timeout:7},tagMemberReq:{tag:1,time:2,limit:3},tagMuteReq:{tag:1,duration:2,needNotify:3,custom:4,notifyTargetTags:5},coordinateReq:{x:1,y:2,z:3,distance:4},chatRoomTagsUpdateTag:{tags:1,notifyTargetTags:2,needNotify:3,ext:4},chatRoomMsgAckTag:{idClient:1,chatroomId:2},chatRoomTagHistoryMsgRequestTag:{tags:1,types:2,fromTime:3,toTime:4,limit:5,reverse:6}};},function(e,t){e.exports={imLogin:{3:"clientType",4:"os",6:"sdkVersion",8:"appLogin",9:"protocolVersion",10:"pushTokenName",11:"pushToken",13:"deviceId",18:"appKey",19:"account",24:"browser",26:"session",32:"deviceInfo",38:"customTag",41:"sdkType",42:"userAgent",112:"isReactNative",1e3:"token"},nosToken:{1:"objectName",2:"token",3:"bucket",4:"expireTime",7:"expireSec",8:"tag",9:"shortUrl"},audioToText:{2:"url"},imageOp:{0:"type",1:"stripmeta",2:"typeType",3:"blurRadius",4:"blurSigma",5:"qualityQuality",6:"cropX",7:"cropY",8:"cropWidth",9:"cropHeight",10:"rotateAngle",11:"pixelPixel",12:"thumbnailMode",13:"thumbnailWidth",14:"thumbnailHeight",15:"thumbnailAxisX",16:"thumbnailAxisY",17:"thumbnailCenterX",18:"thumbnailCenterY",19:"thumbnailEnlarge",20:"thumbnailToStatic",21:"watermarkType",22:"watermarkGravity",23:"watermarkDissolve",24:"watermarkDx",25:"watermarkDy",26:"watermarkImage",27:"watermarkText",28:"watermarkFont",29:"watermarkFontSize",30:"watermarkFontColor",31:"interlace"},robot:{4:"account",5:"nick",6:"avatar",7:"intro",8:"config",9:"valid",10:"createTime",11:"updateTime",12:"custid",13:"botid",14:"bindTime",_6_safe:"_avatar_safe"},clientAntispam:{1:"version",2:"md5",3:"nosurl",4:"thesaurus"},fileQuickTransfer:{1:"md5",2:"url",3:"size",4:"threshold",_2_safe:"_url_safe"},transToken:{1:"name",2:"type",3:"transType",4:"size",5:"extra",6:"body"},transInfo:{1:"docId",2:"name",3:"prefix",4:"size",5:"type",6:"state",7:"transType",8:"transSize",9:"pageCount",10:"picInfo",11:"extra",12:"flag"},nosFileUrlTag:{0:"safeUrl",1:"originUrl"},nosAccessTokenTag:{0:"token",1:"url",2:"userAgent",3:"ext"},fileListParam:{1:"fromDocId",2:"limit"},avSignalTag:{1:"type",2:"channelName",3:"channelId",4:"channelCreateTime",5:"channelExpireTime",6:"creator",7:"ext",8:"channelInValid",10:"from",11:"to",12:"requestId",13:"needPush",14:"pushTitle",15:"pushContent",16:"pushPayload",17:"needBadge",18:"members",19:"attach",20:"attachExt",21:"isSave",22:"msgid",23:"uid",24:"time",25:"nertcChannelName",26:"nertcTokenTtl",27:"nertcToken",28:"nertcJoinRoomQueryParamMap",29:"nertcJoinRoomResponse",30:"callStatus"},login:{1:"appKey",2:"account",3:"deviceId",5:"chatroomId",8:"appLogin",20:"chatroomNick",21:"chatroomAvatar",22:"chatroomCustom",23:"chatroomEnterCustom",26:"session",38:"isAnonymous",39:"tags",40:"notifyTargetTags",41:"loginAuthType",42:"loginExt",43:"loc_x",44:"loc_y",45:"loc_z",46:"distance",47:"antiSpamBusinessId",_21_safe:"_chatroomAvatar_safe"},chatroom:{1:"id",3:"name",4:"announcement",5:"broadcastUrl",12:"custom",14:"createTime",15:"updateTime",16:"queuelevel",100:"creator",101:"onlineMemberNum",102:"mute"},msg:{1:"idClient",2:"type",3:"attach",4:"custom",5:"resend",6:"userUpdateTime",7:"fromNick",8:"fromAvatar",9:"fromCustom",10:"yidunEnable",11:"antiSpamContent",12:"skipHistory",13:"body",14:"antiSpamBusinessId",15:"clientAntiSpam",16:"antiSpamUsingYidun",20:"time",21:"from",22:"chatroomId",23:"fromClientType",25:"highPriority",27:"callbackExt",28:"subType",29:"yidunAntiCheating",30:"env",31:"notifyTargetTags",32:"yidunAntiSpamExt",33:"yidunAntiSpamRes",34:"loc_x",35:"loc_y",36:"loc_z",37:"toAccids",38:"needHighPriorityMsgAck",39:"__clientExt",_8_safe:"_fromAvatar_safe"},chatroomMember:{1:"chatroomId",2:"account",3:"type",4:"level",5:"nick",6:"avatar",7:"custom",8:"online",9:"guest",10:"enterTime",12:"blacked",13:"gaged",14:"valid",15:"updateTime",16:"tempMuted",17:"tempMuteDuration",_6_safe:"_avatar_safe"},antispamTag:{antiSpamBusinessId:1},chatroomCdnInfo:{1:"enable",2:"cdnUrls",3:"timestamp",4:"interval",5:"decryptType",6:"decryptKey",7:"timeout"},nosConfigTag:{1:"bucket",2:"cdnDomain",3:"expire",4:"objectNamePrefix"},updateTags:{1:"currentTags"}};},function(e,t,n){var r=n(22).default,o=n(126),i=n(142),s=n(266),a=n(267),c=n(658),u=n(173),l=n(276),m=n(669),p=n(289);function d(){"use strict";/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */e.exports=d=function d(){return t;},e.exports.__esModule=!0,e.exports.default=e.exports;var t={},n=Object.prototype,f=n.hasOwnProperty,g=o||function(e,t,n){e[t]=n.value;},h="function"==typeof i?i:{},y=h.iterator||"@@iterator",v=h.asyncIterator||"@@asyncIterator",b=h.toStringTag||"@@toStringTag";function T(e,t,n){return o(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t];}try{T({},"");}catch(e){T=function T(e,t,n){return e[t]=n;};}function S(e,t,n,r){var o=t&&t.prototype instanceof x?t:x,i=s(o.prototype),a=new U(r||[]);return g(i,"_invoke",{value:E(e,n,a)}),i;}function M(e,t,n){try{return{type:"normal",arg:e.call(t,n)};}catch(e){return{type:"throw",arg:e};}}t.wrap=S;var k={};function x(){}function C(){}function I(){}var _={};T(_,y,function(){return this;});var w=a&&a(a(D([])));w&&w!==n&&f.call(w,y)&&(_=w);var P=I.prototype=x.prototype=s(_);function A(e){var t;c(t=["next","throw","return"]).call(t,function(t){T(e,t,function(e){return this._invoke(t,e);});});}function O(e,t){var n;g(this,"_invoke",{value:function value(o,i){function s(){return new t(function(n,s){!function n(o,i,s,a){var c=M(e[o],e,i);if("throw"!==c.type){var u=c.arg,l=u.value;return l&&"object"==r(l)&&f.call(l,"__await")?t.resolve(l.__await).then(function(e){n("next",e,s,a);},function(e){n("throw",e,s,a);}):t.resolve(l).then(function(e){u.value=e,s(u);},function(e){return n("throw",e,s,a);});}a(c.arg);}(o,i,n,s);});}return n=n?n.then(s,s):s();}});}function E(e,t,n){var r="suspendedStart";return function(o,i){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===o)throw i;return L();}for(n.method=o,n.arg=i;;){var s=n.delegate;if(s){var a=R(s,n);if(a){if(a===k)continue;return a;}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg);}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var c=M(e,t,n);if("normal"===c.type){if(r=n.done?"completed":"suspendedYield",c.arg===k)continue;return{value:c.arg,done:n.done};}"throw"===c.type&&(r="completed",n.method="throw",n.arg=c.arg);}};}function R(e,t){var n=t.method,r=e.iterator[n];if(void 0===r)return t.delegate=null,"throw"===n&&e.iterator.return&&(t.method="return",t.arg=void 0,R(e,t),"throw"===t.method)||"return"!==n&&(t.method="throw",t.arg=new TypeError("The iterator does not provide a '"+n+"' method")),k;var o=M(r,e.iterator,t.arg);if("throw"===o.type)return t.method="throw",t.arg=o.arg,t.delegate=null,k;var i=o.arg;return i?i.done?(t[e.resultName]=i.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,k):i:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,k);}function j(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t);}function N(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t;}function U(e){this.tryEntries=[{tryLoc:"root"}],c(e).call(e,j,this),this.reset(!0);}function D(e){if(e){var t=e[y];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function t(){for(;++n<e.length;){if(f.call(e,n))return t.value=e[n],t.done=!1,t;}return t.value=void 0,t.done=!0,t;};return r.next=r;}}return{next:L};}function L(){return{value:void 0,done:!0};}return C.prototype=I,g(P,"constructor",{value:I,configurable:!0}),g(I,"constructor",{value:C,configurable:!0}),C.displayName=T(I,b,"GeneratorFunction"),t.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===C||"GeneratorFunction"===(t.displayName||t.name));},t.mark=function(e){return u?u(e,I):(e.__proto__=I,T(e,b,"GeneratorFunction")),e.prototype=s(P),e;},t.awrap=function(e){return{__await:e};},A(O.prototype),T(O.prototype,v,function(){return this;}),t.AsyncIterator=O,t.async=function(e,n,r,o,i){void 0===i&&(i=l);var s=new O(S(e,n,r,o),i);return t.isGeneratorFunction(n)?s:s.next().then(function(e){return e.done?e.value:s.next();});},A(P),T(P,b,"Generator"),T(P,y,function(){return this;}),T(P,"toString",function(){return"[object Generator]";}),t.keys=function(e){var t=Object(e),n=[];for(var r in t){n.push(r);}return m(n).call(n),function e(){for(;n.length;){var r=n.pop();if(r in t)return e.value=r,e.done=!1,e;}return e.done=!0,e;};},t.values=D,U.prototype={constructor:U,reset:function reset(e){var t;if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,c(t=this.tryEntries).call(t,N),!e)for(var n in this){"t"===n.charAt(0)&&f.call(this,n)&&!isNaN(+p(n).call(n,1))&&(this[n]=void 0);}},stop:function stop(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval;},dispatchException:function dispatchException(e){if(this.done)throw e;var t=this;function n(n,r){return i.type="throw",i.arg=e,t.next=n,r&&(t.method="next",t.arg=void 0),!!r;}for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r],i=o.completion;if("root"===o.tryLoc)return n("end");if(o.tryLoc<=this.prev){var s=f.call(o,"catchLoc"),a=f.call(o,"finallyLoc");if(s&&a){if(this.prev<o.catchLoc)return n(o.catchLoc,!0);if(this.prev<o.finallyLoc)return n(o.finallyLoc);}else if(s){if(this.prev<o.catchLoc)return n(o.catchLoc,!0);}else{if(!a)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return n(o.finallyLoc);}}}},abrupt:function abrupt(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&f.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break;}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,k):this.complete(i);},complete:function complete(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),k;},finish:function finish(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),N(n),k;}},catch:function _catch(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;N(n);}return o;}}throw new Error("illegal catch attempt");},delegateYield:function delegateYield(e,t,n){return this.delegate={iterator:D(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),k;}},t;}e.exports=d,e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(659);},function(e,t,n){e.exports=n(660);},function(e,t,n){var r=n(661);e.exports=r;},function(e,t,n){var r=n(216);e.exports=r;},function(e,t,n){e.exports=n(663);},function(e,t,n){var r=n(664);n(665),n(666),n(667),n(668),e.exports=r;},function(e,t,n){var r=n(217);e.exports=r;},function(e,t,n){n(218);},function(e,t,n){n(232);},function(e,t,n){"use strict";var r=n(1),o=n(53),i=n(86);r({target:"Promise",stat:!0,forced:!0},{try:function _try(e){var t=o.f(this),n=i(e);return(n.error?t.reject:t.resolve)(n.value),t.promise;}});},function(e,t,n){n(233);},function(e,t,n){e.exports=n(670);},function(e,t,n){e.exports=n(671);},function(e,t,n){var r=n(672);e.exports=r;},function(e,t,n){var r=n(262);e.exports=r;},function(e,t,n){e.exports=n(674);},function(e,t,n){var r=n(675);e.exports=r;},function(e,t,n){var r=n(236);e.exports=r;},function(e,t,n){e.exports=n(716);},function(e,t){e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++){r[n]=e[n];}return r;},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(720);},function(e,t,n){var r=n(289),o=n(678),i=n(677);e.exports=function(e,t){var n;if(e){if("string"==typeof e)return i(e,t);var s=r(n=Object.prototype.toString.call(e)).call(n,8,-1);return"Object"===s&&e.constructor&&(s=e.constructor.name),"Map"===s||"Set"===s?o(e):"Arguments"===s||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s)?i(e,t):void 0;}},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(724);},function(e,t,n){var r=n(5),o=n(35),i=n(0),s=i.notundef,a={addFriend:1,applyFriend:2,passFriendApply:3,rejectFriendApply:4},c={1:"addFriend",2:"applyFriend",3:"passFriendApply",4:"rejectFriendApply"};function u(e){i.verifyOptions(e,"account","friend::Friend"),i.verifyParamAtLeastPresentOne(e,"alias custom","friend::Friend"),this.account=e.account,s(e.alias)&&(this.alias=e.alias),s(e.custom)&&(this.custom=e.custom);}u.reverse=function(e){var t=i.filterObj(e,"account alias custom createTime updateTime serverex");return s(e.flag)&&(t.valid="1"===e.flag),s(t.createTime)&&(t.createTime=+t.createTime),s(t.updateTime)&&(t.updateTime=+t.updateTime),t;},u.validTypes=function(){return r(a);},u.getByteFromType=function(e){return a[e];},u.getTypeFromByte=function(e){return c[e];},u.assembleFriend=function(e){var t=+new Date();return o({},e,{alias:"",createTime:t,custom:"",updateTime:t,valid:!0});},e.exports=u;},function(e,t,n){var r=n(683),o=n(35),i=n(0),s=i.notundef;function a(e,t){r(e.body)||i.onParamError("body只能是整数",t),this.body=e.body,this.from=e.from||"",this.custom=e.custom||"",s(e.pushTitle)&&(this.pushTitle=e.pushTitle),s(e.apnsText)&&(this.apnsText=e.apnsText),s(e.pushPayload)&&(this.pushPayload=e.pushPayload),s(e.needPush)&&(this.needPush=!0===e.needPush?1:0),s(e.needBadge)&&(this.needBadge=!0===e.needBadge?1:0);}a.reverse=function(e){var t=o({},e);return s(e.needBadge)&&(t.needBadge=1==+e.needBadge),s(e.needPush)&&(t.needPush=1==+e.needPush),t.body=+e.body,t.time=+e.time,t;},e.exports=a;},function(e,t,n){e.exports=n(742);},function(e,t,n){var r=n(683),o=n(35),i=n(0);function s(e,t){r(e.type)||i.onParamError("Collect.type只能是整数",t),i.notundef(e.uniqueId)&&(this.uniqueId=e.uniqueId),this.type=e.type,this.data=e.data||"",this.custom=e.custom||"";}s.reverse=function(e){var t=o({},e);return t.type=+t.type,t.createTime=+t.createTime,t.updateTime=+t.updateTime,t;},e.exports=s;},function(e,t,n){var r=n(750),o=n(751),i=n(679),s=n(752);e.exports=function(e,t){return r(e)||o(e,t)||i(e,t)||s();},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){"use strict";var r=n(687),o=n(688),i=n(689),s=n(690);function a(e,t,n){var r=e;return o(t)?(n=t,"string"==typeof e&&(r={uri:e})):r=s(t,{uri:e}),r.callback=n,r;}function c(e,t,n){return u(t=a(e,t,n));}function u(e){if(void 0===e.callback)throw new Error("callback argument missing");var t=!1,n=function n(_n6,r,o){t||(t=!0,e.callback(_n6,r,o));};function r(){var e=void 0;if(e=l.response?l.response:l.responseText||function(e){try{if("document"===e.responseType)return e.responseXML;var t=e.responseXML&&"parsererror"===e.responseXML.documentElement.nodeName;if(""===e.responseType&&!t)return e.responseXML;}catch(e){}return null;}(l),y)try{e=JSON.parse(e);}catch(e){}return e;}function o(e){return clearTimeout(m),e instanceof Error||(e=new Error(""+(e||"Unknown XMLHttpRequest Error"))),e.statusCode=0,n(e,v);}function s(){if(!u){var t;clearTimeout(m),t=e.useXDR&&void 0===l.status?200:1223===l.status?204:l.status;var o=v,s=null;return 0!==t?(o={body:r(),statusCode:t,method:d,headers:{},url:p,rawRequest:l},l.getAllResponseHeaders&&(o.headers=i(l.getAllResponseHeaders()))):s=new Error("Internal XMLHttpRequest Error"),n(s,o,o.body);}}var a,u,l=e.xhr||null;l||(l=e.cors||e.useXDR?new c.XDomainRequest():new c.XMLHttpRequest());var m,p=l.url=e.uri||e.url,d=l.method=e.method||"GET",f=e.body||e.data,g=l.headers=e.headers||{},h=!!e.sync,y=!1,v={body:void 0,headers:{},statusCode:0,method:d,url:p,rawRequest:l};if("json"in e&&!1!==e.json&&(y=!0,g.accept||g.Accept||(g.Accept="application/json"),"GET"!==d&&"HEAD"!==d&&(g["content-type"]||g["Content-Type"]||(g["Content-Type"]="application/json"),f=JSON.stringify(!0===e.json?f:e.json))),l.onreadystatechange=function(){4===l.readyState&&setTimeout(s,0);},l.onload=s,l.onerror=o,l.onprogress=function(){},l.onabort=function(){u=!0;},l.ontimeout=o,l.open(d,p,!h,e.username,e.password),h||(l.withCredentials=!!e.withCredentials),!h&&e.timeout>0&&(m=setTimeout(function(){if(!u){u=!0,l.abort("timeout");var e=new Error("XMLHttpRequest timeout");e.code="ETIMEDOUT",o(e);}},e.timeout)),l.setRequestHeader)for(a in g){g.hasOwnProperty(a)&&l.setRequestHeader(a,g[a]);}else if(e.headers&&!function(e){for(var t in e){if(e.hasOwnProperty(t))return!1;}return!0;}(e.headers))throw new Error("Headers cannot be set on an XDomainRequest object");return"responseType"in e&&(l.responseType=e.responseType),"beforeSend"in e&&"function"==typeof e.beforeSend&&e.beforeSend(l),l.send(f||null),l;}e.exports=c,e.exports.default=c,c.XMLHttpRequest=r.XMLHttpRequest||function(){},c.XDomainRequest="withCredentials"in new c.XMLHttpRequest()?c.XMLHttpRequest:r.XDomainRequest,function(e,t){for(var n=0;n<e.length;n++){t(e[n]);}}(["get","put","post","patch","head","delete"],function(e){c["delete"===e?"del":e]=function(t,n,r){return(n=a(t,n,r)).method=e.toUpperCase(),u(n);};});},function(e,t,n){(function(t){var n;n="undefined"!=typeof window?window:void 0!==t?t:"undefined"!=typeof self?self:{},e.exports=n;}).call(this,n(49));},function(e,t){e.exports=function(e){if(!e)return!1;var t=n.call(e);return"[object Function]"===t||"function"==typeof e&&"[object RegExp]"!==t||"undefined"!=typeof window&&(e===window.setTimeout||e===window.alert||e===window.confirm||e===window.prompt);};var n=Object.prototype.toString;},function(e,t){var n=function n(e){return e.replace(/^\s+|\s+$/g,"");};e.exports=function(e){if(!e)return{};for(var t,r={},o=n(e).split("\n"),i=0;i<o.length;i++){var s=o[i],a=s.indexOf(":"),c=n(s.slice(0,a)).toLowerCase(),u=n(s.slice(a+1));void 0===r[c]?r[c]=u:(t=r[c],"[object Array]"===Object.prototype.toString.call(t)?r[c].push(u):r[c]=[r[c],u]);}return r;};},function(e,t){e.exports=function(){for(var e={},t=0;t<arguments.length;t++){var r=arguments[t];for(var o in r){n.call(r,o)&&(e[o]=r[o]);}}return e;};var n=Object.prototype.hasOwnProperty;},function(e,t,n){var r=n(22),o=n(143),i=n(9),s=n(10);function a(e){var t=this,n=e.url||null;t.level={debug:0,log:1,info:2,warn:3,error:4}[e.level]||0,t.logCache=[],t.logNum=1,t.timeInterval=5e3,window.onerror=function(e,n,r,o,i){t.error(i);},o(function(){t.logCache.length>0&&n&&t.postLogs(n,t.logCache);},t.timeInterval);}a.prototype.debug=function(){var e;this.level>0||(console.debug.apply(this,arguments),this.cacheLogs.apply(this,i(e=["[degbug]"]).call(e,arguments)));},a.prototype.log=function(){var e;this.level>1||(console.log.apply(this,arguments),this.cacheLogs.apply(this,i(e=["[log]"]).call(e,arguments)));},a.prototype.info=function(){var e;this.level>2||(console.info.apply(this,arguments),this.cacheLogs.apply(this,i(e=["[info]"]).call(e,arguments)));},a.prototype.warn=function(){var e;this.level>3||(console.warn.apply(this,arguments),this.cacheLogs.apply(this,i(e=["[warn]"]).call(e,arguments)));},a.prototype.error=function(){var e;this.level>4||(console.error.apply(this,arguments),this.cacheLogs.apply(this,i(e=["[error]"]).call(e,arguments)));},a.prototype.cacheLogs=function(e,t){for(var n=[],o=0;o<t.length;o++){var i=t[o];"object"===r(i)?n.push(s(i)):n.push(i);}var a=this.logNum++ +" "+e+" "+n.join("; ");this.logCache.push(a.replace("%c",""));},a.prototype.postLogs=function(e,t){var n=this,r=new XMLHttpRequest();r.onreadystatechange=function(){4===r.readyState&&(200===r.status?(console.info("LoggerPlugin::日志上报完成"),n.logCache=[],n.timeInterval=5e3):n.timeInterval+=5e3);},r.open("POST",e),r.setRequestHeader("Content-Type","plain/text;charset=utf-8"),r.timeout=360,r.send(t.join("\n"));},e.exports=a;},function(e,t,n){var r=n(3),o=n(41);e.exports=function(e){var t,n,i,s;e.db&&(o.db=e.db),e.rnfs&&(o.rnfs=e.rnfs,o.rnfs.size||(o.rnfs.size=1048576),o.rnfs.nimPromise=(t=o.rnfs,n=t.size/2-256,s=0,i=o.rnfs.DocumentDirectoryPath+"/nimlog_"+s+".log",t.exists(i).then(function(e){return e?t.stat(i):r.reject(0);}).then(function(e){return e&&e.size>n?r.reject(1):r.reject(0);}).catch(function(e){return"number"==typeof e&&(t.nimIndex=e),r.resolve();})));};},function(e,t,n){var r=n(48),o=n(0),i=o.notundef,s=o.undef;function a(e){i(e.name)&&(this.name=""+e.name),i(e.announcement)&&(this.announcement=""+e.announcement),i(e.broadcastUrl)&&(this.broadcastUrl=""+e.broadcastUrl),i(e.custom)&&(this.custom=""+e.custom),i(e.queuelevel)&&(this.queuelevel=r(e.queuelevel));}a.reverse=function(e){var t=o.copy(e);return s(t.announcement)&&(t.announcement=""),s(t.broadcastUrl)&&(t.broadcastUrl=""),s(t.custom)&&(t.custom=""),i(t.createTime)&&(t.createTime=+t.createTime),i(t.updateTime)&&(t.updateTime=+t.updateTime),i(t.onlineMemberNum)&&(t.onlineMemberNum=+t.onlineMemberNum),i(t.mute)&&(t.mute="1"===t.mute),t;},e.exports=a;},function(e,t,n){var r,o,i;e.exports=(i=n(74),o=(r=i).lib.WordArray,r.enc.Base64={stringify:function stringify(e){var t=e.words,n=e.sigBytes,r=this._map;e.clamp();for(var o=[],i=0;i<n;i+=3){for(var s=(t[i>>>2]>>>24-i%4*8&255)<<16|(t[i+1>>>2]>>>24-(i+1)%4*8&255)<<8|t[i+2>>>2]>>>24-(i+2)%4*8&255,a=0;a<4&&i+.75*a<n;a++){o.push(r.charAt(s>>>6*(3-a)&63));}}var c=r.charAt(64);if(c)for(;o.length%4;){o.push(c);}return o.join("");},parse:function parse(e){var t=e.length,n=this._map,r=this._reverseMap;if(!r){r=this._reverseMap=[];for(var i=0;i<n.length;i++){r[n.charCodeAt(i)]=i;}}var s=n.charAt(64);if(s){var a=e.indexOf(s);-1!==a&&(t=a);}return function(e,t,n){for(var r=[],i=0,s=0;s<t;s++){if(s%4){var a=n[e.charCodeAt(s-1)]<<s%4*2,c=n[e.charCodeAt(s)]>>>6-s%4*2,u=a|c;r[i>>>2]|=u<<24-i%4*8,i++;}}return o.create(r,i);}(e,t,r);},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},i.enc.Base64);},function(e,t,n){var r,o,i,s,a,c,u,l;e.exports=(l=n(74),n(810),n(811),o=(r=l).lib,i=o.Base,s=o.WordArray,a=r.algo,c=a.MD5,u=a.EvpKDF=i.extend({cfg:i.extend({keySize:4,hasher:c,iterations:1}),init:function init(e){this.cfg=this.cfg.extend(e);},compute:function compute(e,t){for(var n,r=this.cfg,o=r.hasher.create(),i=s.create(),a=i.words,c=r.keySize,u=r.iterations;a.length<c;){n&&o.update(n),n=o.update(e).finalize(t),o.reset();for(var l=1;l<u;l++){n=o.finalize(n),o.reset();}i.concat(n);}return i.sigBytes=4*c,i;}}),r.EvpKDF=function(e,t,n){return u.create(n).compute(e,t);},l.EvpKDF);},function(e,t,n){n(279);var r=n(34);n(290)(r),e.exports=r;},function(e,t,n){var r=n(3),o=n(16),i=n(10),s=n(2),a=n(9),c=n(285),u=n(7),l=n(17),m=n(73),p=n(181),d=n(283),f=n(698),g=n(0),h=n(286),y=n(39),v=y.newSupportDBError,b=y.noDBError,T=!1;function S(e){T=e,h.set("db",e,d);}function M(e){this.concurrency=0,this.pendingTasks=[],this.queue=r.resolve(),this.logger=e.logger,this.reporter=e.reporter,this.core=e.core,this.account=e.account,this.notifyError=e.notifyError;}S(!!g.getGlobal().indexedDB),"IE"===m.name&&S(!1),"Microsoft Edge"===m.name&&S(!1),"Safari"===m.name&&S(!1);var k=M.prototype;k.reset=g.emptyFunc,T&&(k.reset=function(e){this.enable=!1!==e;}),k.addTask=function(e){var t=this;return new r(function(n,r){function o(e){t.concurrency--;var n=t.pendingTasks.shift();n&&t.addTask(n),e();}if(t.concurrency<100)return t.concurrency++,e().then(function(t){o(function(){n(t),e.resolve&&e.resolve(t);});},function(n){o(function(){var o,i=(n=n||{}).event||n,s={event:i,callFunc:n.callFunc||"db::addTask"};t.logger.error("db::error event is",i,null==i||null===(o=i.target)||void 0===o?void 0:o.error),r(s),e.reject&&e.reject(s);});});e.resolve||(e.resolve=n,e.reject=r),t.pendingTasks.push(e);});},k.reportError=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0;this.reporter.reportTraceStart("exceptions",{user_id:this.account,trace_id:g.get(this.core,"socket.socket.sessionid"),action:4});var r,s=t.context||"";if(n)try{var a;r=o(a=i(n)).call(a,0,100),s+=". ".concat(r);}catch(e){r="";}var c=g.get(e,"code")||g.get(e,"target.error.code")||0,u=g.get(e,"message")||g.get(e,"target.error.message")||"unknown";this.reporter.reportTraceUpdateV2("exceptions",{code:c,description:u,operation_type:t.operation_type,target:t.target||this.name,context:s}),this.reporter.reportTraceEnd("exceptions",1);},k.init=function(e){var t=this;return t.addTask(function(){return t.enable?t.server?r.resolve():(t.name="nim-"+e,d.open({server:t.name,version:f.version,schema:f.schema}).then(function(e){t.logger.info("db::init: ".concat(t.name)),t.server=e;},function(e){throw S(!1),t.server=null,t.name=null,e;}).catch(function(n){throw t.reportError(n,{operation_type:0,context:"version ".concat(f.version),target:"nim-"+e}),n;})):r.reject(v({callFunc:"db::init"}));});},k.destroy=function(){var e=this;return e.addTask(function(){if(!e.enable)return r.reject(v({callFunc:"db::destroy"}));if(!e.server)return r.resolve();try{return d.remove(e.name).then(function(){e.logger.info("db::destroy: ".concat(e.name)),e.server=null,e.name=null;}).catch(function(t){throw e.reportError(t,{operation_type:1,context:"remove database failed"}),t;});}catch(t){throw e.reportError(t,{operation_type:1,context:"remove database failed"}),t;}});},k.clear=function(){var e=this;return e.addTask(function(){return e.enable?e.server?e.server.clear("timetag").then(function(){var t=o([]).call(e.server.getIndexedDB().objectStoreNames),n=[];if(s(t).call(t,function(t){n.push(e.server.clear(t).catch(function(n){throw e.reportError(n,{operation_type:3,context:"tableName: ".concat(t,". clear table failed")}),n;}));}),n.length)return r.all(n).then(function(){e.logger.info("db::clear: ".concat(e.name));}).catch(function(t){return e.logger.error("db::clear: ",t),r.reject(t);});}):r.resolve():r.reject(v({callFunc:"db::clear"}));});},k.close=function(){this.server&&(this.server.close(),this.server=null,this.name=null);},k.remove=function(e,t,n,r,o,i,s){var c=this;return c.addTask(function(){c.checkDB();try{return c.server.remove(e,t,n,r,o,i,s).then(function(){var r;c.logger.info(a(r="db::delete: ".concat(e," ")).call(r,t||n));}).catch(function(a){throw c.reportError(a,{operation_type:3,context:"tableName: ".concat(e,", remove failed")},{name:e,keys:t,keyName:n,lowerBound:r,upperBound:o,lowerOpen:i,upperOpen:s}),c.logger.error("db::remove::server.remove error",a),a;});}catch(a){throw c.reportError(a,{operation_type:3,context:"tableName: ".concat(e,", remove failed")},{name:e,keys:t,keyName:n,lowerBound:r,upperBound:o,lowerOpen:i,upperOpen:s}),c.logger.error("db::remove::server.remove error",a),a;}});},k.put=function(e,t){var n=this;return n.addTask(function(){n.checkDB(),g.isArray(t)||(t=[t]);try{return n.server.update(e,t).then(function(t){var r=[e],o=f.keyPath(e),i=[];return o&&(s(t).call(t,function(e){i.push(p(e,o));}),r.push(1===i.length?i[0]:i)),r.unshift("db::put:"),"timetag"===e&&r.push(t[0]),n.logger.log.apply(n.logger.log,r),t;}).catch(function(r){throw n.reportError(r,{operation_type:3,context:"tableName: ".concat(e,". put failed")},t),r;});}catch(r){throw n.reportError(r,{operation_type:3,context:"tableName: ".concat(e,". put failed")},t),r;}});},k.get=function(e,t){var n=this;return n.addTask(function(){n.checkDB();try{return n.server.get(e,t).catch(function(r){var o;throw n.reportError(r,{operation_type:3,context:a(o="tableName: ".concat(e,". get failed with key ")).call(o,t)}),r;});}catch(o){var r;throw n.reportError(o,{operation_type:3,context:a(r="tableName: ".concat(e,". get failed with key ")).call(r,t)}),o;}});},k.modifyOrPut=function(e){var t=this,n=e.table,r=g.copy(e.obj),o=e.key,i=e.modifyObjWhenPut,s=g.copy(r);return delete s[o],t.getOne(n,null,r[o],{modifyObj:s}).then(function(e){return e?(s.idClient?s={idClient:s.idClient,server:s.server,pinFrom:s.pinFrom}:(s.lastMsg=s.lastMsg&&s.lastMsg.idServer+"_"+s.lastMsg.idClient,s.localCustom=s.localCustom&&"***",s.topCustom=s.topCustom&&"***"),t.logger.log("db::modifyOrPut: update table ".concat(n),s),e):(r=g.merge(r,i),t.put(n,r).then(function(e){return e[0];}));});},k.updateAndDelete=function(e,t,n){var r=this;return r.addTask(function(){r.checkDB();try{return r.server.updateAndDelete(e,t,n).catch(function(o){throw r.reportError(o,{operation_type:3,context:"tableName: ".concat(e,". updateAndDelete failed")},{updates:t,deletes:n}),o;});}catch(o){throw r.reportError(o,{operation_type:3,context:"tableName: ".concat(e,". updateAndDelete failed")},{updates:t,deletes:n}),o;}});},k.getAll=function(e,t){var n=this;return n.addTask(function(){n.checkDB(),(t=t||{}).keys=!0===c(t),t.desc=!0===t.desc,t.distinct=!0===t.distinct;try{var r,o,i;return u(r=c(o=l(i=n.server.query(e,t.index)).call(i,l(t))).call(o,c(t)).desc(t.desc).limit(t.limit).distinct(t.distinct)).call(r,t.mapper).modify(t.modifyObj).execute().catch(function(r){throw n.reportError(r,{operation_type:3,context:"tableName: ".concat(e,". getAll failed")},t),r;});}catch(r){throw n.reportError(r,{operation_type:3,context:"tableName: ".concat(e,". getAll failed")},t),r;}});},k.getOnly=function(e,t,n,r){var o=this;return o.addTask(function(){o.checkDB(),(r=r||{}).keys=!0===c(r),r.desc=!0===r.desc,r.distinct=!0===r.distinct,r.remove=!0===r.remove;try{var i,s,m;return u(i=c(s=l(m=o.server.query(e,t).only(n)).call(m,l(r))).call(s,c(r)).desc(r.desc).limit(r.limit).distinct(r.distinct)).call(i,r.mapper).modify(r.modifyObj).remove(r.remove).execute().catch(function(i){var s,c;throw o.reportError(i,{operation_type:3,context:a(s=a(c="tableName: ".concat(e,". getOnly failed with index: ")).call(c,t,", matchValue: ")).call(s,n)},r),i;});}catch(i){var p,d;throw o.reportError(i,{operation_type:3,context:a(p=a(d="tableName: ".concat(e,". getOnly failed with index: ")).call(d,t,", matchValue: ")).call(p,n)},r),i;}});},k.getOne=function(){var e=this;return e.getOnly.apply(e,arguments).then(function(e){return e[0];});},k.clearTable=function(e){var t=this;return t.addTask(function(){t.checkDB();try{return t.server.clear(e).catch(function(n){throw t.reportError(n,{operation_type:3,context:"tableName: ".concat(e,". clearTable failed")},options),n;});}catch(n){throw t.reportError(n,{operation_type:3,context:"tableName: ".concat(e,". clearTable failed")},options),n;}});},k.checkDB=function(){if(!this.enable)throw v({callFunc:"db::checkDB"});if(!this.server)throw b({callFunc:"db::checkDB"});},e.exports=M;},function(e,t){var n={version:12},r={kv:{key:{keyPath:"key"}},timetag:{key:{keyPath:"name"}},sessionsWithMoreRoaming:{key:{keyPath:"id"}},msgReadDetail:{key:{keyPath:"idClient"}},blacklist:{key:{keyPath:"account"}},mutelist:{key:{keyPath:"account"}},friend:{key:{keyPath:"account"}},user:{key:{keyPath:"account"}},team:{key:{keyPath:"teamId"}},teamMember:{key:{keyPath:"id"},indexes:{teamId:{unique:!1},account:{unique:!1}}},superTeam:{key:{keyPath:"teamId"}},superTeamMember:{key:{keyPath:"id"},indexes:{teamId:{unique:!1},account:{unique:!1},id:{unique:!1}}},msg:{key:{autoIncrement:!0},indexes:{idClient:{unique:!0},sessionId:{unique:!1},time:{unique:!1},type:{unique:!1},sessionType:{unique:!1},status:{unique:!1},sessionTime:{key:["sessionId","time"],unique:!1}}},msg1:{key:{keyPath:"idClient"},indexes:{sessionId:{unique:!1},time:{unique:!1},status:{unique:!1},sessionTime:{key:["sessionId","time"],unique:!1}}},msgPin:{key:{keyPath:"idClient"},indexes:{sessionId:{unique:!1}}},broadcastMsg:{key:{keyPath:"broadcastId"},indexes:{time:{unique:!1}}},sysMsg:{key:{autoIncrement:!0},indexes:{idServer:{unique:!0},category:{unique:!1},type:{unique:!1}}},sysMsgUnread:{key:{keyPath:"type"}},session:{key:{keyPath:"id"},indexes:{updateTime:{unique:!1}}}};n.keyPath=function(e){return r[e].key.keyPath;},n.schema=function(){return window._nimForceSyncIM=!0,r;},e.exports=n;},function(e,t,n){var r=n(55).fn;r.setKey=function(e,t){return this.put("kv",{key:e,value:t});},r.getKey=function(e){return this.get("kv",e).then(function(e){return e&&e.value;});},r.setDonnop=function(e){return this.setKey("donnop",e);},r.getDonnop=function(){return this.getKey("donnop");};},function(e,t,n){var r=n(4),o=n(48),i=n(55).fn;i.getTimetags=function(e){var t={};return this.getAll("timetag",{filter:e,mapper:function mapper(e){var n;return-1!==r(n=e.name).call(n,"team-")?t[e.name]=0:t[e.name]=e.value,e;}}).then(function(){return t;});},i.getTeamMemberTimetags=function(){return this.getTimetags(function(e){var t;return-1!==r(t=e.name).call(t,"team-");});},i.getTimetag=function(e){return this.getOne("timetag",null,e).then(function(e){return(e=e||{value:0}).value;});},i.getTeamMemberTimetag=function(){return 0;},i.updateTimetag=function(e,t){var n=this,r={name:e,value:t};return this.put("timetag",r).catch(function(e){n.notifyError&&n.notifyError(e);});},i.updateMyInfoTimetag=function(e){return this.updateTimetag("myInfo",e);},i.updateRelationTimetag=function(e){return this.updateTimetag("relations",e);},i.getRelationsTimetag=function(){return this.getTimetag("relations");},i.updateFriendTimetag=function(e){return this.updateTimetag("friends",e);},i.getFriendsTimetag=function(){return this.getTimetag("friends");},i.updateFriendUserTimetag=function(e){return this.updateTimetag("friendUsers",e);},i.updateTeamTimetag=function(e){return this.updateTimetag("teams",e);},i.getTeamsTimetag=function(){return this.getTimetag("teams");},i.updateSuperTeamTimetag=function(e){return this.updateTimetag("superTeams",e);},i.getSuperTeamsTimetag=function(){return this.getTimetag("superTeams");},i.updateTeamMemberTimetag=function(e,t){return this.updateTimetag("team-"+e,t);},i.getTeamMembersTimetag=function(e){return this.getTimetag("team-"+e);},i.updateSuperTeamMemberTimetag=function(e,t){return this.updateTimetag("superTeam-"+e,t);},i.getSuperTeamMembersTimetag=function(e){return this.getTimetag("superTeam-"+e);},i.updateMyTeamMembersTimetag=function(e){return this.updateTimetag("myTeamMembers",e);},i.updateMySuperTeamMembersTimetag=function(e){return this.updateTimetag("myInfoInSuperTeams",e);},i.getBroadcastMsgTimetag=function(){return this.getTimetag("broadcastMsg");},i.updateBroadcastMsgTimetag=function(e){return this.updateTimetag("broadcastMsg",o(e));},i.updateRoamingMsgTimetag=function(e){return this.updateTimetag("roamingMsgs",e);},i.updateSuperTeamRoamingMsgTimetag=function(e){return this.updateTimetag("superTeamRoamingMsgs",e);},i.updateMsgReceiptsTimetag=function(e){return this.updateTimetag("msgReceipts",e);},i.updateDonnopTimetag=function(e){return this.updateTimetag("donnop",e);},i.updateSessionAck=function(e){return this.updateTimetag("sessionAck",e);},i.updateDeleteMsgSelf=function(e){return this.updateTimetag("deleteMsgSelf",e);},i.updateSuperTeamSessionAck=function(e){return this.updateTimetag("superTeamSessionAck",e);},i.deleteTimetag=function(e){return this.remove("timetag",e);},i.deleteTeamMemberTimetag=function(e){return this.deleteTimetag("team-"+e);},i.deleteSuperTeamMemberTimetag=function(e){return this.deleteTimetag("superTeam-"+e);};},function(e,t,n){var r=n(3),o=n(55).fn,i=n(0);o.mergeRelations=function(e,t,n,o,i){var s=this,a=s.updateAndDelete("blacklist",e,t),c=s.updateAndDelete("mutelist",n,o);return r.all([a,c]).then(function(){return s.logger.info("db::mergeRelations: timetag ".concat(i)),s.updateRelationTimetag(i),[e,t,n,o,i];});},o.getRelations=function(){var e=this.getAll("blacklist"),t=this.getAll("mutelist");return r.all([e,t]);},o.markInBlacklist=function(e){if((e=i.copy(e)).isAdd){var t=e.record;return this.put("blacklist",t);}var n=e.account;return this.remove("blacklist",n);},o.markInMutelist=function(e){if((e=i.copy(e)).isAdd){var t=e.record;return this.put("mutelist",t);}var n=e.account;return this.remove("mutelist",n);};},function(e,t,n){var r=n(7),o=n(3),i=n(55).fn,s=n(0);i.mergeFriends=function(e,t,n){var o=this;return o.updateAndDelete("friend",e,t).then(function(){return o.logger.log("db::mergeFriends: updateAndDelete done",e&&r(e).call(e,function(e){return e.account;}).join(",")),n&&o.updateFriendTimetag(n),[e,t,n];});},i.putFriend=function(e){return this.put("friend",e);},i.updateFriend=function(e){var t=this,n=(e=s.copy(e)).account;return this.getOne("friend",null,n,{modifyObj:e}).then(function(e){return e?t.logger.log("db::updateFriend: ".concat(n)):t.logger.warn("db::updateFriend: no record ".concat(n)),e;});},i.deleteFriend=function(e){var t=this.remove("friend",e),n=this.deleteUser(e);return o.all([t,n]);},i.getFriends=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=function t(_t4){return void 0!==e.updateTime?_t4.valid&&_t4.updateTime>e.updateTime:_t4.valid;};return this.getAll("friend",{filter:t});},i.getFriend=function(e){return this.getOne("friend",null,e);},i.getUserFromBlackList=function(e){return this.getOne("blacklist",null,e);};},function(e,t,n){var r=n(3),o=n(2),i=n(9),s=n(7),a=n(55).fn,c=n(0),u=n(39),l=n(175),m=n(139);function p(e){return e.valid&&e.validToCurrentUser;}function d(e){return e&&e.valid;}function f(e){return e&&c.fillUndef(e,{mute:!1,custom:""}),e;}a.mergeTeams=function(e,t,n){var o=this,i=o.put("team",e),s=o.leaveTeams(t,n);return r.all([i,s]).then(function(){return o.logger.log("db::mergeTeams:"),o.updateTeamTimetag(n),[e,t,n];});},a.putTeam=function(e){if(e)return c.isArray(e)||(e=[e]),o(e).call(e,function(e){e.validToCurrentUser=!0;}),this.put("team",e);},a.updateTeam=function(e){var t=this,n=(e=c.copy(e)).teamId;return t.getOne("team",null,n,{modifyObj:e}).then(function(r){if(r)t.logger.log("db::updateTeam: ".concat(n));else if(t.logger.warn("db::updateTeam: no record ".concat(n)),e.validToCurrentUser)return t.putTeam(e);return r;});},a.transferTeam=function(e,t,n){var r=this,o=e.teamId,s=e.memberUpdateTime,a={teamId:o,account:t,type:"normal",updateTime:s},c={teamId:o,account:n,type:"owner",updateTime:s};return r.updateTeamMembers([a,c]).then(function(){return r.putTeam(e).then(function(){var o,s;return r.logger.info(i(o=i(s="db::transferTeam: ".concat(e.teamId," ")).call(s,t," -> ")).call(o,n)),[e,t,n];});});},a.leaveTeam=function(e){var t=this;return t.updateTeam({teamId:e,validToCurrentUser:!1}).then(function(){return t.removeAllTeamMembers(e);});},a.dismissTeam=function(e,t){var n=this,r={teamId:e,valid:!1,validToCurrentUser:!1,updateTime:t};return n.updateTeam(r).then(function(){return n.removeAllTeamMembers(e);});},a.leaveTeams=function(e,t){var n,i=this,s=[];return o(e).call(e,function(e){n=i.leaveTeam(e.teamId,t),s.push(n);}),r.all(s);},a.getTeamsByTeamIds=function(e){var t,n=this,i=[];return o(e).call(e,function(e){t=n.getTeam(e),i.push(t);}),r.all(i);},a.getTeam=function(e){e=""+e;var t=this;return t.getOne("team",null,e).then(function(e){return e?(t.updateTeamProperties([e]),e):null;});},a.getTeams=function(){var e=this;return e.getAll("team",{filter:p}).then(function(t){return e.updateTeamProperties(t),t;});},a.updateTeamProperties=function(e){o(e).call(e,function(e){e&&l.fillProperties(e);});},a.mergeTeamMembers=function(e,t,n,o){var i=this,s=i.putTeamMembers(t),a=i.updateTeamMembers(n);return r.all([s,a]).then(function(){return i.logger.log("db::mergeTeamMembers: ".concat(e)),i.updateTeamMemberTimetag(e,o);});},a.putTeamMembers=function(e){return this.put("teamMember",e);},a.getTeamMembersByAccount=function(e){return this.getOnly("teamMember","account",e,{filter:d,mapper:f}).then();},a.getTeamMembers=function(e){var t=this;e=""+e;return t.getOnly("teamMember","teamId",e,{filter:function filter(e){return e.valid;},mapper:f}).then(function(e){return t.updateTeamMemberProperties(e).then(function(){return e;});});},a.updateTeamMemberProperties=function(e){var t,n=this,i=[];return o(e).call(e,function(e){m.fillProperties(e)&&(t=n.updateTeamMember(e),i.push(t));}),r.all(i);},a.getInvalidTeamMembers=function(e,t){var n=this;e=""+e;var i,s=[];return o(t).call(t,function(t){i=n.getOne("teamMember",null,m.genId(e,t)).then(function(e){return f(e);}),s.push(i);}),r.all(s);},a.updateTeamMember=function(e){var t=this,n=e.teamId,r=e.account,o=m.genId(n,r),s=c.filterObj(e,"nickInTeam muteTeam mute custom updateTime type valid");return this.getOne("teamMember",null,o,{modifyObj:s,mapper:f}).then(function(e){var o,a;e?t.logger.log(i(o="db::updateTeamMember: ".concat(n," ")).call(o,r),c.pickAsString(s,["muteTeam","mute","updateTime","type","valid"])):t.logger.warn(i(a="db::updateTeam: no record ".concat(n," ")).call(a,r));return e;});},a.updateTeamMembers=function(e){var t=this;if(!e.length)return r.resolve();var n,i=[];return o(e).call(e,function(e){n=t.updateTeamMember(e),i.push(n);}),r.all(i);},a.updateTeamManagers=function(e,t,n,r){var o=s(t).call(t,function(t){return{teamId:e,account:t,type:n?"manager":"normal",updateTime:r};});return this.updateTeamMembers(o);},a.removeTeamMembersByAccounts=function(e,t){var n=s(t).call(t,function(t){return{teamId:e,account:t,valid:!1};});return this.updateTeamMembers(n);},a.removeAllTeamMembers=function(e){var t=this;return t.getOnly("teamMember","teamId",e,{modifyObj:{valid:!1}}).then(function(){return t.logger.warn("db::removeAllTeamMembers: ".concat(e)),t.deleteTeamMemberTimetag(e);});},a.deleteTeamMembers=function(e){var t=this;return t.getOnly("teamMember","teamId",e,{remove:!0}).then(function(){t.logger.warn("db::deleteTeamMembers: ".concat(e)),t.deleteTeamMemberTimetag(e);});},a.deleteTeam=function(e){var t,n=this,i=[];return c.isArray(e)||(e=[e]),o(e).call(e,function(e){e=""+e,t=n.get("team",e).then(function(t){if(t&&p(t))throw u.stillInTeamError({callFunc:"team::deleteTeam",team:t});var o=n.remove("team",e),i=n.deleteTeamMembers(e);return r.all([o,i]);}),i.push(t);}),1===i.length?i[0]:r.all(i);};},function(e,t,n){var r=n(3),o=n(2),i=n(6),s=n(9),a=n(7),c=n(55).fn,u=n(0),l=n(39),m=n(287),p=n(186);function d(e){return e.valid&&e.validToCurrentUser;}function f(e){return e&&e.valid;}function g(e){return e&&u.fillUndef(e,{mute:!1,custom:""}),e;}c.mergeSuperTeams=function(e,t,n){var o=this,i=o.put("superTeam",e),s=o.leaveTeams(t,n);return r.all([i,s]).then(function(){return o.logger.log("db::mergeSuperTeams:"),o.updateSuperTeamTimetag(n),[e,t,n];});},c.putSuperTeam=function(e){if(e)return u.isArray(e)||(e=[e]),o(e).call(e,function(e){e.validToCurrentUser=!0;}),this.put("superTeam",e);},c.updateSuperTeam=function(e){var t=this,n=(e=u.copy(e)).teamId;return t.getOne("superTeam",null,n,{modifyObj:e}).then(function(r){return r?(t.logger.info("db::updateSuperTeam: ".concat(n)),r):(t.logger.warn("db::updateSuperTeam: no record ".concat(n)),t.putSuperTeam(e));});},c.leaveSuperTeam=function(e){var t=this;return t.updateSuperTeam({teamId:e,validToCurrentUser:!1}).then(function(){return t.removeAllSuperTeamMembers(e);});},c.dismissSuperTeam=function(e,t){var n=this,r={teamId:e,valid:!1,validToCurrentUser:!1,updateTime:t};return n.updateSuperTeam(r).then(function(){return n.removeAllSuperTeamMembers(e);});},c.leaveSuperTeams=function(e,t){var n,i=this,s=[];return o(e).call(e,function(e){n=i.leaveSuperTeam(e.teamId,t),s.push(n);}),r.all(s);},c.getSuperTeamsByTeamIds=function(e){var t,n=this,i=[];return o(e).call(e,function(e){t=n.getSuperTeam(e),i.push(t);}),r.all(i);},c.getSuperTeam=function(e){e=""+e;var t=this;return t.getOne("superTeam",null,e).then(function(e){return e?(t.updateSuperTeamProperties([e]),e):null;});},c.getSuperTeams=function(){var e=this;return e.getAll("superTeam",{filter:d}).then(function(t){return e.updateSuperTeamProperties(t),t;});},c.updateSuperTeamProperties=function(e){o(e).call(e,function(e){e&&m.fillProperties(e);});},c.mergeSuperTeamMembers=function(e,t,n,o){var i=this,s=i.putSuperTeamMembers(t),a=i.updateSuperTeamMembers(n);return r.all([s,a]).then(function(){return i.logger.log("db::mergeSuperTeamMembers: ".concat(e)),null!=o?i.updateSuperTeamMemberTimetag(e,o):r.resolve();});},c.putSuperTeamMembers=function(e){return this.put("superTeamMember",e);},c.getSuperTeamMemberById=function(e){return this.get("superTeamMember",e);},c.getSuperTeamMembers=function(e,t){var n=this;e=""+e;var r={filter:function filter(e){return e.valid;},mapper:g};if(t){if("number"!=typeof t.joinTime)return void n.logger.error("db::getSuperTeamMembers::params.joinTime should be number, not ",t.joinTime);t.limit&&(r.limit=t.limit),i(t)?r.filter=function(e){return e.valid&&e.joinTime<=t.joinTime;}:r.filter=function(e){return e.valid&&e.joinTime>=t.joinTime;};}return n.getOnly("superTeamMember","teamId",e,r).then(function(e){return n.updateSuperTeamMemberProperties(e).then(function(){return e;});});},c.getSuperTeamMembersByAccount=function(e){return this.getOnly("superTeamMember","account",e,{filter:f,mapper:g}).then();},c.updateSuperTeamMemberProperties=function(e){var t,n=this,i=[];return o(e).call(e,function(e){p.fillProperties(e)&&(t=n.updateSuperTeamMember(e),i.push(t));}),r.all(i);},c.getInvalidSuperTeamMembers=function(e,t){var n=this;e=""+e;var i,s=[];return o(t).call(t,function(t){i=n.getOne("superTeamMember","id",p.genId(e,t)).then(function(e){return g(e);}),s.push(i);}),r.all(s);},c.updateSuperTeamMember=function(e){var t=this,n=e.teamId,r=e.account,o=p.genId(n,r),i=u.filterObj(e,"nickInTeam muteTeam mute custom updateTime type valid");return this.getOne("superTeamMember","id",o,{modifyObj:i,mapper:g}).then(function(e){var o,a;e?t.logger.log(s(o="db::updateSuperTeamMember: ".concat(n," ")).call(o,r),u.pickAsString(i,["muteTeam","mute","updateTime","type","valid"])):t.logger.warn(s(a="db::updateSuperTeam: no record ".concat(n," ")).call(a,r));return e;});},c.updateSuperTeamMembers=function(e){var t=this;if(!e.length)return r.resolve();var n,i=[];return o(e).call(e,function(e){n=t.updateSuperTeamMember(e),i.push(n);}),r.all(i);},c.removeSuperTeamMembersByAccounts=function(e,t){var n=a(t).call(t,function(t){return{teamId:e,account:t,valid:!1};});return this.updateSuperTeamMembers(n);},c.removeAllSuperTeamMembers=function(e){var t=this;return t.getOnly("superTeamMember","teamId",e,{modifyObj:{valid:!1}}).then(function(){return t.logger.warn("db::removeAllSuperTeamMembers: ".concat(e)),t.deleteSuperTeamMemberTimetag(e);});},c.deleteSuperTeamMembers=function(e){var t=this;return t.getOnly("superTeamMember","teamId",e,{remove:!0}).then(function(){t.logger.warn("db::deleteSuperTeamMembers: ".concat(e)),t.deleteSuperTeamMemberTimetag(e);});},c.deleteSuperTeam=function(e){var t,n=this,i=[];return u.isArray(e)||(e=[e]),o(e).call(e,function(e){e=""+e,t=n.get("superTeam",e).then(function(t){if(t&&d(t))throw l.stillInTeamError({callFunc:"team::deleteTeam",team:t});var o=n.remove("superTeam",e),i=n.deleteSuperTeamMembers(e);return r.all([o,i]);}),i.push(t);}),1===i.length?i[0]:r.all(i);},c.transferSuperTeam=function(e,t,n){var r=this;return r.updateSuperTeamMembers([t,n]).then(function(){return r.putSuperTeam(e).then(function(){var o,i;return r.logger.info(s(o=s(i="db::transferSuperTeam: ".concat(e.teamId," ")).call(i,t.account," -> ")).call(o,n.account)),[e,t,n];});});};},function(e,t,n){var r=n(2),o=n(3),i=n(4),s=n(55).fn,a=n(0);s.mergeMyInfo=function(e,t){var n=this;return n.put("user",e).then(function(){return t?n.updateMyInfoTimetag(e.updateTime):e;});},s.mergeFriendUsers=function(e,t){var n=this;return n.putUsers(e).then(function(){n.updateFriendUserTimetag(t);});},s.putUsers=function(e){return this.put("user",e);},s.putUser=function(e){return this.put("user",e);},s.updateUser=function(e){var t=this,n=(e=a.copy(e)).account;return this.getOne("user",null,n,{modifyObj:e}).then(function(e){return e?t.logger.log("db::updateUser: ".concat(n)):t.logger.warn("db::updateUser: no record ".concat(n)),e;});},s.putUsersIfIsFriend=function(e){var t,n=this,i=[],s=[];return r(e).call(e,function(e){t=n.getFriend(e.account).then(function(r){return r&&(t=n.putUser(e),s.push(t)),r;}),i.push(t);}),o.all(i).then(function(){return o.all(s).then(function(e){return e;});});},s.deleteUser=function(e){return this.remove("user",e);},s.getUser=function(e){return this.getOne("user",null,e);},s.getUsers=function(e){return this.getAll("user",{filter:function filter(t){return-1!==i(e).call(e,t.account);}});},s.getAllUsers=function(){return this.getAll("user");};},function(e,t,n){var r=n(17),o=n(3),i=n(9),s=n(2),a=n(35),c=n(30),u=n(4),l=n(7),m=n(55).fn,p=n(0),d=n(14);m.putMsg=function(e){var t=this;return p.isArray(e)||(e=[e]),!e.length||r(e[0])?o.resolve():(e=r(e).call(e,function(e){return!e.ignore;}),t.put("msg1",e).catch(function(n){return t.notifyError&&t.notifyError(n),o.resolve(e,n);}));},m.putMsgReadDetail=function(e){var t=this;if(e.idClient)return this.put("msgReadDetail",e).catch(function(e){t.logger.error("putMsgReadDetail error",e);});},m.getMsgReadDetail=function(e){return this.getOne("msgReadDetail",null,e);},m.updateMsg=function(e){var t=this;if(!r(e)){var n=e.idClient,s=p.filterObj(e,"resend status idServer time localCustom commentTimetag comments hasSendAck callbackExt");return t.getOne("msg1",null,n,{modifyObj:s}).then(function(e){var r,o,a;e?t.logger.info(i(r=i(o=i(a="db::updateMsg: ".concat(n,"，idServer: ")).call(a,s.idServer,"，status: ")).call(o,s.status,"，time: ")).call(r,s.time)):t.logger.warn("db::updateMsg: no record ".concat(n));return e;}).catch(function(n){return t.notifyError&&t.notifyError(n),o.resolve(e);});}},m.updateMsgBatch=function(e){var t=this;if(d.isRN)this.logger.warn("react native can not support updateMsgBatch");else{this.checkDB();var n=this.server.getIndexedDB().transaction(["msg1"],"readwrite").objectStore("msg1");s(e).call(e,function(e){if(e.idClient){var r=n.get(e.idClient);r.onerror=function(e){t.logger.error("updateMsgBatch::store.get:error",e);},r.onsuccess=function(){var o=r.result||e;n.put(a({},o,e)).onerror=function(e){t.logger.error("updateMsgBatch::store.put:error",e);};};}});}},m.getMsgs=function(e){return d.isBrowser?this.getMsgsIndexedDB(e):d.isRN?this.getMsgsRN(e):o.resolve();},m.getMsgsRN=function(e){var t={};return"number"==typeof e.start&&(t.lowerBound=["time",e.start]),"number"==typeof e.end&&e.end!==1/0&&(t.upperBound=["time",e.end]),t.desc=!1,t.index="time","boolean"==typeof e.desc&&(t.desc=e.desc),"number"==typeof e.limit&&(t.limit=e.limit),t.searchIndex=[],e.sessionId&&t.searchIndex.push(["sessionId",e.sessionId]),"string"==typeof e.type&&t.searchIndex.push(["type",e.type]),this.getAll("msg1",t);},m.getMsgsIndexedDB=function(e){var t,n=this;n.checkDB();var o="time",s=!1,a=!1,l=(e=e||{}).sessionId||[],m=e.sessionIds||[];p.isString(l)?l=[l]:c(l)||(l=[]),p.isString(m)?m=[m]:c(m)||(m=[]);var d=i(l).call(l,m);1===d.length?(s=!0,o="sessionTime",l=d[0]):d.length>1&&(s=!0,a=!0,m=d);var f=e.start||0,g=e.end||1/0,h=f,y=g;s&&!a&&(h=[l,f],y=[l,g]);var v=!1!==e.desc,b=e.limit||100,T=!1,S=!1,M=e.type||[],k=e.types||[];p.isString(M)?M=[M]:c(M)||(M=[]),p.isString(k)?k=[k]:c(k)||(k=[]);var x=i(M).call(M,k);1===x.length?(T=!0,M=x[0]):x.length>1&&(T=!0,S=!0,k=x);var C,I=e.subTypes&&e.subTypes.length,_=e.keyword||"",w=e.filterFunc;return(a||T||_||I||p.isFunction(w))&&(C=function C(t){var n;if(a&&-1===u(m).call(m,t.sessionId))return!1;if(T)if(S){if(-1===u(k).call(k,t.type))return!1;}else if(M!==t.type)return!1;if(I&&-1===u(n=e.subTypes).call(n,t.subType))return!1;if(_){var r=t.text||t.tip||"";if(-1===u(r).call(r,_))return!1;}return!w||w(t);}),r(t=n.server.query("msg1",o).bound(h,y,!0,!0).desc(v).limit(b)).call(t,C).execute().catch(function(t){throw n.reportError(t,{operation_type:3,context:"tableName: ".concat("msg1",", index ").concat(o,", getMsgsIndexedDB error")},e),t;});},m.getMsgCountAfterAck=function(e){return d.isBrowser?this.getMsgCountAfterAckIndexedDB(e):d.isRN?this.getMsgCountAfterAckRN(e):o.resolve();},m.getMsgCountAfterAckRN=function(e){var t=this,n=e=e||{},i=n.sessionId,s=n.ack;return t.checkDB(),t.getAll("msg1",{searchIndex:["sessionId",i],lowerBound:["time",s]}).then(function(n){var i=r(n).call(n,function(n){if("out"===n.flow||!1===n.isUnreadable)return!1;if("notification"===n.type)try{return e.shouldCountNotifyUnread(n);}catch(e){throw t.logger.error("userOption:shouldCountNotifyUnread function error",e),e;}return!0;});return o.resolve(i.length);});},m.getMsgCountAfterAckIndexedDB=function(e){var t=this,n=(e=e||{}).sessionId;return t.checkDB(),t.server.query("msg1","sessionTime").bound([n,e.ack],[n,1/0],!0,!0).execute().then(function(n){var i=r(n).call(n,function(n){if("out"===n.flow||!1===n.isUnreadable)return!1;if("notification"===n.type)try{return e.shouldCountNotifyUnread(n);}catch(e){throw t.logger.error("userOption:shouldCountNotifyUnread function error",e),e;}return!0;});return o.resolve(i.length);}).catch(function(n){throw t.reportError(n,{operation_type:3,context:"tableName: ".concat("msg1",", IndexSessionTime ").concat("sessionTime",", getMsgCountAfterAckIndexedDB error")},e),n;});},m.amendMsg=function(e){return e?(p.notexist(e.text)&&(e.text=""),e):null;},m.getMsgByIdClient=function(e){var t=this;return t.getOne("msg1",null,e).then(function(e){return t.amendMsg(e);});},m.getMsgsByIdClients=function(e){var t,n=this,r=[];return s(e).call(e,function(e){t=n.getMsgByIdClient(e),r.push(t);}),o.all(r);},m.clearSendingMsgs=function(){var e=this;return e.getOnly("msg1","status","sending",{modifyObj:{status:"fail"}}).then(function(t){e.logger.info("db::clearSendingMsgs: msgs send failed",t&&l(t).call(t,function(e){return e.idClient;}).join(","));});},m.deleteMsg=function(e){var t,n=this,r=[];return p.isArray(e)||(e=[e]),s(e).call(e,function(e){t=n.getOne("msg1",null,e,{remove:!0}).then(function(t){return n.logger.info("db::deleteMsg done",e,t&&t.idClient),t;}).catch(function(t){throw n.logger.error("db::deleteMsg failed",e,t),t;}),r.push(t);}),1===r.length?r[0]:o.all(r);},m.deleteMsgsBySessionId=function(e){var t=this,n=null,r=e.start,o=e.end;return void 0!==r&&void 0!==o?n=function n(e){return e>r&&e<o;}:void 0!==r?n=function n(e){return e>r;}:void 0!==o&&(n=function n(e){return e<o;}),n?t.getOnly("msg1","sessionId",e.sessionId).then(function(e){var r=[];return l(e=e||[]).call(e,function(e){n(e.time)&&r.push(e.idClient);}),t.logger.info("db::deleteMsgsBySessionId: session results",r),t.deleteMsg(r);}):t.getOnly("msg1","sessionId",e.sessionId,{remove:!0});},m.deleteMsgsByTime=function(e){return this.remove("msg1",null,"time",e.start,e.end,!0,!0);},m.deleteAllMsgs=function(){var e=this.clearTable("msg1"),t=this.clearTable("session");return o.all([e,t]);},m.getMsgPins=function(e){return this.getOnly("msgPin","sessionId",e);},m.deleteMsgPins=function(e){return this.getOnly("msgPin","sessionId",e,{remove:!0});},m.putMsgPin=function(e){var t=this;return this.modifyOrPut({table:"msgPin",obj:e,key:"idClient"}).catch(function(e){t.notifyError&&t.notifyError(e);});},m.putMsgPins=function(e){return this.put("msgPin",e);},m.deleteMsgPin=function(e){var t=this;return this.getOne("msgPin",null,e.idClient,{remove:!0}).then(function(e){return t.logger.info("db::deleteMsgPin:",e.idClient),e;});};},function(e,t,n){var r=n(3),o=n(17),i=n(2),s=n(6),a=n(5),c=n(55).fn,u=n(0),l=u.notundef;c.putSysMsg=function(e){var t=this;return new r(function(n){if(u.isArray(e)||(e=[e]),!o(e[0])){var r=[],s=e.length;i(e).call(e,function(e){e=u.copy(e),t.put("sysMsg",e).then(function(e){r.push(e[0]),a();},a);});}function a(){0===--s&&n(r);}});},c.getSysMsgs=function(e){var t=!s(e=e||{}),n=e.limit||100,r=null,o=null;e.category&&(r="category",o=e.category),e.type&&(r="type",o=e.type);var i,a=e.lastIdServer,c=!1,u=e.read;return(l(a)||l(u))&&(i=function i(e){return l(a)?(a=""+a,c?t():(e.idServer===a&&(c=!0),!1)):t();function t(){return!l(u)||e.read===u;}}),e={filter:i,desc:t,limit:n},r?this.getOnly("sysMsg",r,o,e):this.getAll("sysMsg",e);},c.getSysMsgByIdServer=function(e){return this.getOne("sysMsg","idServer",e);},c.updateSysMsg=function(e){var t=this;if(!o(e)){var n=""+e.idServer,r=u.filterObj(e,"read state error localCustom");return this.getOne("sysMsg","idServer",n,{modifyObj:r}).then(function(e){return e?t.logger.log("db::updateSysMsg: ".concat(n),u.pickAsString(r,["read","state","error"])):t.logger.warn("db::updateSession: ".concat(n)),e;});}},c.markSysMsgRead=function(e){var t=this;return new r(function(n,o){u.isArray(e)||(e=[e]);var s,a,c=[],l=[];i(e).call(e,function(e){s=t.getSysMsgByIdServer(e.idServer).then(function(e){e&&!e.read&&(a=t.updateSysMsg({idServer:e.idServer,read:!0}),l.push(a));},o),c.push(s);}),r.all(c).then(function(){r.all(l).then(function(e){n(e);},o);},o);});},c.deleteSysMsg=function(e){var t,n=this,o=[];return u.isArray(e)||(e=[e]),i(e).call(e,function(e){e=""+e,t=n.getOne("sysMsg","idServer",e,{remove:!0}),o.push(t);}),1===o.length?o[0]:r.all(o);},c.deleteAllSysMsgs=function(){var e=this.clearTable("sysMsg"),t=this.clearTable("sysMsgUnread");return r.all([e,t]);},c.getSysMsgUnread=function(){return this.getAll("sysMsgUnread").then(function(e){var t={};return i(e).call(e,function(e){t[e.type]=e.num;}),t;});},c.updateSysMsgUnread=function(e){var t,n=this;e=u.copy(e);var r=[];return i(t=a(e)).call(t,function(t){r.push({type:t,num:e[t]});}),this.put("sysMsgUnread",r).then(function(){return n.logger.info("db::updateSysMsgUnread: ",e),e;});};},function(e,t,n){var r=n(3),o=n(2),i=n(55).fn,s=n(0);i.putBroadcastMsg=function(e){var t=this;return new r(function(n){s.isArray(e)||(e=[e]);var r=[],i=e.length;function a(){0===--i&&n(r);}o(e).call(e,function(e){e=s.copy(e),t.put("broadcastMsg",e).then(function(e){r.push(e[0]),a();},a);});});},i.getBroadcastMsgs=function(e){return e=e||{},this.getAll("broadcastMsg",e);};},function(e,t,n){var r=n(3),o=n(6),i=n(9),s=n(30),a=n(2),c=n(55).fn,u=n(0),l=u.notundef;c.putSession=function(e){var t=this,n=e.unread;return void 0===(e=u.merge({},e)).updateTime&&e.lastMsg&&e.lastMsg.time&&(e.updateTime=e.lastMsg.time),(e.lastMsg||!e.ack&&!e.msgReceiptTime)&&(e.isDeleted=!1),delete e.unread,this.modifyOrPut({table:"session",obj:e,key:"id",modifyObjWhenPut:{unread:0}}).catch(function(o){return t.notifyError&&t.notifyError(o),e.unread=n,r.resolve(e);});},c.getAllSessions=function(){return this.getAll("session",{index:"updateTime",desc:!0}).catch(function(e){self.notifyError&&self.notifyError(e);});},c.getSessions=function(e){var t=!o(e=e||{}),n=e.limit||100,r=e.lastSessionId,i=e.sessionId,s=!1,a=this,c=function c(){return!0;},u=function u(){return!0;};return l(i)?this.getSession(i,e.isDeleted):(l(r)&&(c=function c(e){return e.id===r&&(s=!0),s;}),e.includeDeleted||(u=function u(e){return!e.isDeleted;}),this.getAll("session",{index:"updateTime",desc:t,limit:n,filter:function filter(e){return c(e)&&u(e);}}).catch(function(e){a.notifyError&&a.notifyError(e);}));},c.getSession=function(e,t){var n=this;return this.get("session",e).then(function(e){return r.resolve(!t&&e&&e.isDeleted?void 0:e);}).catch(function(e){throw n.notifyError&&n.notifyError(e),e;});},c.updateSession=function(e){var t=this,n=e.id,r=u.filterObj(e,"ack unread lastMsg localCustom msgReceiptTime msgReceiptServerTime isTop topCustom isDeleted");return e.lastMsg&&(r.lastMsg=e.lastMsg),this.getOne("session",null,n,{modifyObj:r}).then(function(e){if(e){var o,s=i(o="db::updateSession: ".concat(n," ")).call(o,u.pickAsString(r,["ack","unread","msgReceiptTime","msgReceiptServerTime","isTop","isDeleted"]));s+=r.lastMsg?" lastMsg.idClient:".concat(u.get(r,"lastMsg.idClient")):"",t.logger.info(s);}else t.logger.warn("db::updateSession: no record ".concat(n));return e;}).catch(function(e){t.notifyError&&t.notifyError(e);});},c.getStickTopSessions=function(){var e=this;return this.getAll("session",{filter:function filter(e){return e&&e.isTop;}}).catch(function(t){e.notifyError&&e.notifyError(t);});},c.deleteSession=function(e,t){var n=t&&t.scene||"";return"superTeam"===n?this.updateSuperTeamSessionAck(0):("p2p"===n||"team"===n||this.updateSuperTeamSessionAck(0),this.updateSessionAck(0)),this.updateMsgReceiptsTimetag(0),this.remove("session",e);},c.deleteSessionLogic=function(e){var t=this;if(!s(e))return this.getOne("session",null,e,{modifyObj:{isDeleted:!0}});var n=[];return a(e).call(e,function(e){n.push(t.getOne("session",null,e,{modifyObj:{isDeleted:!0}}));}),r.all(n);},c.putSessionsWithMoreRoaming=function(e){return this.put("sessionsWithMoreRoaming",e);},c.updateSessionsWithMoreRoaming=function(e){var t=e.id;return delete e.id,this.getOne("sessionsWithMoreRoaming",null,t,{modifyObj:e});},c.deleteSessionsWithMoreRoaming=function(e){return this.remove("sessionsWithMoreRoaming",e);},c.getSessionsWithMoreRoaming=function(e){return e?this.get("sessionsWithMoreRoaming",e):this.getAll("sessionsWithMoreRoaming");};},function(e,t,n){var r=n(9),o=n(182),i=n(183),s=n(0).throttle,a=function(){"use strict";function e(t){o(this,e),this.arr=[],this.timer=null,this.maxLength=t.maxLength||100,this.throttleTime=t.throttleTime||5e3,this.processFn=t.processFn||function(){},this.throttleFn=t.processFn||function(){},t.processFn&&(this.throttleFn=s(function(e){t.processFn(e),e.length=0;},this.throttleTime,{leading:!1}));}return i(e,[{key:"add",value:function value(e){var t;"[object Array]"===Object.prototype.toString.call(e)?this.arr=r(t=this.arr).call(t,e):this.arr.push(e);this.arr.length>=this.maxLength&&(this.processFn(this.arr),this.arr=[]),this.timer=this.throttleFn(this.arr);}},{key:"destroy",value:function value(){this.arr=[],this.timer&&clearTimeout(this.timer),this.processFn=function(){},this.throttleFn=function(){};}},{key:"clear",value:function value(){this.arr=[],this.timer&&clearTimeout(this.timer);}}]),e;}();e.exports=a;},function(e,t,n){var r=n(22),o=n(58),i=n(54),s=n(10),a=n(293),c=n(9),u=n(3),l=n(27),m=n(17),p=n(4),d=n(16),f=n(23),g=n(2),h=n(143),y=n(5),v=n(59),b=n(60),T=n(61),S=n(62),M=n(46);function k(e,t){var n=y(e);if(v){var r=v(e);t&&(r=m(r).call(r,function(t){return b(e,t).enumerable;})),n.push.apply(n,r);}return n;}function x(e){for(var t=1;t<arguments.length;t++){var n,r,i=null!=arguments[t]?arguments[t]:{};t%2?g(n=k(Object(i),!0)).call(n,function(t){o(e,t,i[t]);}):T?S(e,T(i)):g(r=k(Object(i))).call(r,function(t){M(e,t,b(i,t));});}return e;}var C=n(32).fn,I=n(0),_=n(14),w=n(110).V2NIMConnectStatus;function P(e,t){var n,r,o,i,a=this,u=_.getDefaultLinkUrl(a.options.secure);(a.socketUrls=[u],a.reporter.reportTraceUpdateV2("login",{operation_type:"HTTP",target:t,code:200,net_connect:a.checkNetworkAvailable(),succeed:!0}),a.msgStatEnable=!!e.common["msg.stat.enable"],a.msgStatEnable)&&(a.msgDelayTimer=l(f(r=a.doReportMsgDelay).call(r,a),1e4));e.common&&e.common.link&&g(o=e.common.link).call(o,function(e){a.socketUrls.unshift(_.formatSocketUrl({url:e,secure:a.options.secure}));});e.common&&e.common["link.default"]&&g(i=e.common["link.default"]).call(i,function(e){var t,n;(e=_.formatSocketUrl({url:e,secure:a.options.secure}),-1===p(t=a.socketUrls).call(t,e))&&(a.socketUrls=c(n=a.socketUrls).call(n,e));});a.socketUrls=m(n=a.socketUrls).call(n,function(e,t,n){return p(n).call(n,e)===t;});try{_.uploadUrl=e.nosup[0];}catch(e){}if(_.chunkUploadUrl=_.chunkUploadUrl||e["nos-chunk"]||"",a.logger.info("link::refreshSocketUrl: ".concat(t," ajax load , got socket urls "),a.socketUrls),_.hasLocalStorage){e.common["lbs.backup"]&&a.options.lbsBackup&&localStorage.setItem("nim_lbs_backup",s(e.common["lbs.backup"]));var d=I.get(e,"common.report.apierror.on");e.common.report&&localStorage.setItem("nim_lbs_fail_report_on",!1===d?"0":"1");}}function A(e,t){if(this.statusProtector.getConnectStatus()===w.V2NIM_CONNECT_STATUS_DISCONNECTED)return u.reject(new Error("already disconnected"));if(e>=t){this.logger.warn("doRequestBackupLbsUrls backup lbs all tried");var n=_.getDefaultLinkUrl(this.options.secure);return this.logger.warn("doRequestBackupLbsUrls: use default socket link",n),this.socketUrls=[n],u.resolve();}return this.logger.warn("doRequestBackupLbsUrls: wait for next lbs request"),u.reject(new Error("lbs request failed"));}function O(e,t){var n=t.status||10001,r="string"==typeof t?t:t&&t.message?t.message:"Unknown error";this.reporter.reportTraceUpdateV2("login",{operation_type:"HTTP",target:e,code:n,description:r,net_connect:this.checkNetworkAvailable(),succeed:!1});}function E(e){var t=this;if(!(e&&e.length>0))throw new Error("No  lbs url to try");var n=0,r=0,o=!1,i=null;t.logger.log("doRequestBackupLbsUrls: use lbs url in index ",n,e);var s=function s(){var s=e[n++],a=new Date().getTime();return t.promiseAbortManager.add(t.doRequestLbs(s)).then(function(e){if(i&&clearInterval(i),!1===o)return P.call(t,e,s),o=!0,u.resolve();}).catch(function(n){return r+=1,t.logger.warn("doRequestBackupLbsUrls: ".concat(s," ajax lbs error"),n),O.call(t,s,n,a),A.call(t,r,e.length);});};return new u(function(r,o){i=h(function(){if(!(n>=e.length))return t.statusProtector.getConnectStatus()===w.V2NIM_CONNECT_STATUS_DISCONNECTED?(i&&clearInterval(i),void o(new Error("already disconnected"))):void s().then(function(){i&&clearInterval(i),r();}).catch(function(){});i&&clearInterval(i);},2e3),s().then(function(){i&&clearInterval(i),r();}).catch(function(){});});}C.connect=function(){if(!1===this.checkNetworkAvailable()&&this.autoconnect)return this.logger.info("connect::skip this reconnection attempt because network is offline"),void this.reconnect();_.isBrowser&&this.reporter.restore(),this.createConnectTime=i(),this.reporter.reportTraceCancel("login"),this.reporter.reportTraceStart("login",{user_id:this.options.account,action:this.autoconnect?"auto_login":"manual_login"}),this.reporter.reportTraceUpdateV2("login",{code:0,description:s(x(x({},this.options),{},{account:"***",token:"***"}),function(e,t){return""===e||"function"!=typeof t&&"object"!==r(t)?t:void 0;}),operation_type:"conf_init",succeed:!0,target:""}),a(C).connect.call(this);},C.onConnect=function(){this.reporter.reportTraceUpdateV2("login",{operation_type:"TCP",target:this.url,code:200,net_connect:this.checkNetworkAvailable(),succeed:!0}),a(C).onConnect.call(this);},C.reportTCPException=function(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2?arguments[2]:void 0;this.reporter.reportTraceStart("exceptions",{user_id:this.options.account,start_time:r,action:0}),this.reporter.reportTraceUpdateV2("exceptions",{code:n,description:e,operation_type:0,target:this.handshakeUrl,net_connect:this.checkNetworkAvailable()}),this.reporter.reportTraceEnd("exceptions",1),this.statusProtector.emit("auth/loginLifeCycleConnectFail",new Error(c(t="".concat(e," ")).call(t,n)));},C.onHandshakeFailed=function(e,t){this.reportTCPException("handshake_failed",408,e),this.reporter.reportTraceUpdateV2("login",{operation_type:"TCP",target:t,code:408,succeed:!1,net_connect:this.checkNetworkAvailable(),description:"ws_handshake_failed"}),0===this.socketUrls.length&&this.reporter.reportTraceEnd("login",!1),a(C).onHandshakeFailed.call(this,e,t);},C.onConnectFailed=function(e,t,n){"string"==typeof e?this.reportTCPException("connect_failed:".concat(e),0,t):this.reportTCPException("connect_failed",0,t),this.reporter.reportTraceUpdateV2("login",{operation_type:"TCP",target:n,code:408,succeed:!1,net_connect:this.checkNetworkAvailable(),description:"ws_connect_failed"}),0===this.socketUrls.length&&this.reporter.reportTraceEnd("login",!1),a(C).onConnectFailed.call(this,e,t,n);},C.onSocketError=function(e,t,n){e&&("string"==typeof e?this.reportTCPException("socket.io error:".concat(e),0,t):this.reportTCPException("socket.io error",0,t),this.reporter.reportTraceUpdateV2("login",{operation_type:"TCP",target:n,description:"ws_onerror:"+e,code:0,net_connect:this.checkNetworkAvailable(),succeed:!1}),0===this.socketUrls.length&&this.reporter.reportTraceEnd("login",!1)),a(C).onSocketError.call(this,e,t,n);},C.probeIp=function(){var e=this,t=_.ipProbeAddr;return new u(function(n){var r=0,o=-1;function i(){2===++r&&(r=-1,n(o));}e.adaptersRequest(t.ipv4,{timeout:2e3,onerror:i,onload:function onload(e){o++,i();}}),e.adaptersRequest(t.ipv6,{timeout:2e3,onerror:i,onload:function onload(e){o+=2,i();}}),l(function(){r||-1===o||(r=-1,n(o));},100);});},C.refreshSocketUrl=function(){var e=this;return this.statusProtector.emit("auth/loginLifeCycleAddressing"),_.isWeixinApp?this.doRefreshSocketUrl(2):2===this.options.ipVersion?this.probeIp().then(function(t){return e.doRefreshSocketUrl(t);}):this.doRefreshSocketUrl(this.options.ipVersion);},C.doRefreshSocketUrl=function(e){var t,n,r=this.options.lbsUrl||_.lbsUrl;1!==e&&2!==e&&(e=0),_.ipVersion=e;var o=this.options.lbsBackupUrlsCustomer||[],i=[];this.options.lbsBackup&&_.hasLocalStorage&&(i=(i=localStorage.getItem("nim_lbs_backup"))?JSON.parse(i):[]);var s=c(t=c(n=[r]).call(n,i)).call(t,o);return s=m(s).call(s,function(e,t,n){return p(n).call(n,e)===t;}),E.call(this,s);},C.doRequestLbs=function(e){var t=this,n=this.options,r=_.info;return e=e+I.genUrlSep(e)+"id="+n.account+"&sv="+r.sdkVersion+"&pv="+r.protocolVersion+"&networkType="+_.ipVersion+"&k="+n.appKey,this.logger.info("doRequestLbs ".concat(d(e).call(e,0,-32))),new u(function(n,r){_.isWeixinApp?wx.request({url:e,success:function success(e){var t=e&&e.statusCode,o=e&&e.data;200===t?n(o):r(o);},fail:function fail(e){r(e);}}):t.adaptersRequest(e,{proxyUrl:I.url2origin(e)+"/lbs/res/cors/nej_proxy_frame.html",timeout:_.xhrTimeout,onload:function onload(e){n(JSON.parse(e));},onerror:function onerror(e){r(e);}});});},C.disconnect=function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:function(){};if(this.isConnected())return this.sendCmd("logout"),void l(function(){a(C).disconnect.call(e,t);},0);this.connecting?this.logger.warn("IMProtocolFn api disconnect:: connecting but exiting"):this.statusProtector.getConnectStatus()!==w.V2NIM_CONNECT_STATUS_DISCONNECTED?this.logger.warn("IMProtocolFn api disconnect:: has tried to disconnect"):this.logger.warn("IMProtocolFn api disconnect:: other logic entered");var n=a(C);n.disconnect.call(this,t);},C.notifyDisconnect=function(e){a(C).notifyDisconnect.call(this,e);};},function(e,t,n){var r=n(144),o=n(58),i=n(145),s=n(3),a=n(10),c=n(27),u=n(23),l=n(4),m=n(2),p=n(17),d=n(5),f=n(59),g=n(60),h=n(61),y=n(62),v=n(46);function b(e,t){var n=d(e);if(f){var r=f(e);t&&(r=p(r).call(r,function(t){return g(e,t).enumerable;})),n.push.apply(n,r);}return n;}function T(e){for(var t=1;t<arguments.length;t++){var n,r,i=null!=arguments[t]?arguments[t]:{};t%2?m(n=b(Object(i),!0)).call(n,function(t){o(e,t,i[t]);}):h?y(e,h(i)):m(r=b(Object(i))).call(r,function(t){v(e,t,g(i,t));});}return e;}var S=n(32).fn,M=n(176),k=n(14),x="NIM-AllGrayscaleConfig",C="NIM-AllMixStorePolicy",I=n(0);function _(){var e=this;if(k.hasLocalStorage&&localStorage.getItem(x)){var t=null;try{t=JSON.parse(localStorage.getItem(x))[e.options.appKey];}catch(t){e.logger.error("appGrayConfig error",t);}t&&(e.appGrayConfig=t.timeStamp+1e3*t.ttl>new Date().getTime()?t:null,e.appGrayConfig&&w.apply(e));}e.appGrayConfig||e.sendCmd("getGrayscaleConfig",{providers:""},function(t,n){if(t)e.logger.error("Calculate Delay time, getGrayscaleConfig error",t);else if(n){var r=n;if(r.grayConfig=JSON.parse(r.grayConfig),r.ttl=Number(r.ttl),r.timeStamp=new Date().getTime(),e.appGrayConfig=r,k.hasLocalStorage){var o=localStorage.getItem(x)?JSON.parse(localStorage.getItem(x)):{};o[e.options.appKey]=r,localStorage.setItem(x,a(o));}w.apply(e);}else e.logger.error("Calculate Delay time, getGrayscaleConfig error",n);});}function w(){var e=this;if(k.hasLocalStorage&&localStorage.getItem(C)){var t=null;try{t=JSON.parse(localStorage.getItem(C))[e.options.appKey];}catch(t){e.logger.error("mixStorePolicy error",t);}t&&(e.mixStorePolicy=t.timeStamp+1e3*t.ttl>new Date().getTime()?t:null,e.mixStorePolicy&&t.ttl&&0!==t.ttl&&(e.mixStorePolicyClock=c(u(w).call(w,e),1e3*t.ttl)));}e.mixStorePolicy||e.sendCmd("getMixStorePolicy",{providers:e.options.providers&&e.options.providers.s3?[1,2]:[1]},function(t,n){if(t){e.logger.error("Calculate Delay time, getMixStorePolicy error",t);try{n=JSON.parse(localStorage.getItem("NIM-AllMixStorePolicy"))[e.options.appKey];}catch(t){e.logger.error("error:","get last mixStorePolicy failed",t);}}else if(n){var r=n;if(r.ttl=Number(r.ttl),r.providers=r.providers.split(","),r.nosPolicy=r.nosPolicy?JSON.parse(r.nosPolicy):null,r.s3Policy=r.s3Policy?JSON.parse(r.s3Policy):null,r.timeStamp=new Date().getTime(),e.mixStorePolicy=r,r.ttl&&0!==r.ttl&&(e.mixStorePolicyClock=c(u(w).call(w,e),1e3*r.ttl)),k.hasLocalStorage){var o=localStorage.getItem(C)?JSON.parse(localStorage.getItem(C)):{};o[e.options.appKey]=r,localStorage.setItem(C,a(o));}}else e.logger.error("Calculate Delay time, mixStorePolicy error",n);});}function P(e){var t=this,n=this;399===e.code?(this.logger.warn("pendingLoginFailed:399, refresh LBS url and reconnecting"),n.forceDisconnect(),n.doRefreshSocketUrl(k.ipVersion).then(function(){n.reconnect();}).catch(function(){t.logger.warn("pendingLoginFailed:399, refresh LBS url failed");})):398===e.code?(this.logger.warn("pendingLoginFailed:398 try to reconnect socket link，backoff set min 5s"),n.backoff.setMin(5e3),n.reconnect()):(this.logger.error("pendingLoginFailed: ",e.code,e),n.onAuthError(e,"link::onLogin"));}S.assembleLogin=function(){var e=this.assembleIMLogin();return this.addPushInfo instanceof Function?this.addPushInfo(e):s.resolve({login:e});},S.login=i(r.mark(function e(){var t,n,o,i=this;return r.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return t=this,e.next=3,t.assembleLogin();case 3:if(n=e.sent,!(o=this.socket&&this.socket.socket&&this.socket.socket.sessionid)){e.next=13;break;}if(this.socketIds||(this.socketIds={}),!this.socketIds[o]){e.next=10;break;}return this.logger.warn("onConnect::repeat login",o),e.abrupt("return");case 10:this.socketIds[o]=!0,e.next=14;break;case 13:this.logger.warn("onConnect:: no socketId ",this.socket&&this.socket.socket);case 14:this.logger.warn("link::doLogin: "+o+" appLogin is "+n.login.appLogin),t.sendCmd("login",T({},n),function(e,n){if(e){var r=I.get(e,"event.uploadCode")||e&&e.code;r="number"!=typeof r?408:r;var o=I.get(e,"event.disconnectReason"),s=o?a({disconnect_reason:o}):e&&e.message||"login failed";t.reporter.reportTraceUpdateV2("login",{operation_type:"protocol",target:"2-3",code:r,description:s,net_connect:t.checkNetworkAvailable(),succeed:!1}),t.reporter.reportTraceEnd("login",!1),P.call(t,e),t.statusProtector.emit("auth/loginLifeCycleLoginFail",e);}else t.reporter.reportTraceUpdateV2("login",{operation_type:"protocol",target:"2-3",succeed:!0,net_connect:t.checkNetworkAvailable(),code:200}),t.reporter.reportTraceEnd("login",!0),t.resetReconnectStatus(),i.heartbeatFail=0,i.hasLogin=!0,i.autoconnect=!0,t.startHeartbeat(),t.initOnlineListener(),t.statusProtector.emit("auth/loginLifeCycleLoginSucc"),t.afterLogin(n);});case 16:case"end":return e.stop();}}},e,this);})),S.afterLogin=function(e){var t=this;this.sendCmd("getNosCdnHost",{}),("boolean"==typeof I.get(this.options,"privateConf.isMixStoreEnable")?this.options.privateConf.isMixStoreEnable:k.privateConf.isMixStoreEnable)&&_.apply(this),this.initPush instanceof Function&&this.initPush();var n=this.db;if(n.enable){var r=this.account;this.options.appendAppKeyForDBName&&(r+="-"+this.options.appKey),this.db.init(r).then(function(){t.notifyLogin(e),t.syncData();},function(r){t.logger.warn("link::afterLogin: no db",r),n.reset(!1),t.notifyLogin(e),t.syncData();});}else this.logger.info("link::afterLogin: no db"),this.notifyLogin(e),this.syncData();},S.getFileAuthToken=function(e){var t=this,n=t.mixStorePolicy.nosPolicy.authPolicy.policyType;-1!==n?l(n).call(n,e.type)<0?t.logger.error("this type Token error not support"):3!=e.type||e.urls&&e.urls.length?t.sendCmd("getBackSourceToken",{mixAuthTokenReq:e},function(n,r){if(n)return t.logger.error("getBackSourceToken error",n),n;e.done&&e.done(r);}):t.logger.error("urls is Required when type 3"):t.logger.error("don't need token");},S.processAuth=function(e){switch(e.cmd){case"login":e.error||(e.content=e.content||{},this.loginAndroidPush&&this.loginAndroidPush(e.content.aosPushInfo||{}),e.obj=e.content.loginRes,this.connectionId=e.content.loginRes.connectionId,this.onLoginPortsChange(e,2));break;case"kicked":return void this.onKicked(e);case"multiPortLogin":this.onLoginPortsChange(e,e.content.state);break;case"kick":e.error||(e.obj.deviceIds=e.content.deviceIds);}},S.onLoginPortsChange=function(e,t){var n=this,r=e.content.loginPorts;if(r&&r.length){var o=!0;switch(t){case 2:o=!0;break;case 3:o=!1;}m(r).call(r,function(e){e.type=M.reverseType(e.type),e.customClientType&&(e.customClientType=+e.customClientType),e.time=+e.time,e.online=o;}),(r=p(r).call(r,function(e){return e.connectionId!==n.connectionId;})).length&&(n.logger.info("link::onLoginPortsChange:",r),n.options.onloginportschange(r));}},S.kickedReasons=["","samePlatformKick","serverKick","otherPlatformKick","silentlyKick"],S.kickedMessages=["","不允许同一个帐号在多个地方同时登录","被服务器踢了","被其它端踢了","悄悄被踢"];},function(e,t,n){var r=n(714),o=n(3),i=n(23),s=n(680),a=n(35),c=n(2),u=n(5),l=n(127),m=n(9),p=n(17),d=n(4),f=n(7),g=n(728),h=n(88),y=n(27),v=n(30),b=n(71),T=n(32).fn,S=n(0),M=n(39),k=S.undef,x=S.objs2ids,C=S.objs2accounts,I=S.teams2ids,_=n(141),w=S.getGlobal(),P=n(90).EMSyncType;T.beforeSync=function(){var e=this.db;return e.enable?e.clearSendingMsgs():o.resolve();},T.syncData=function(){var e=this,t=e.db,n=e.options,r=t.enable;function o(t){var o;e.syncPromiseArray=[],e.syncResult={},e.syncTeamMembersPromiseArray=[],e.syncSuperTeamMembersPromiseArray=[],e.syncTeamMembersResult={},e.checkNosReqNum=0,e.getNosOriginUrlReqNum=0,S.verifyBooleanWithDefault(n,"syncRelations syncFriends syncFriendUsers syncTeams syncSuperTeams syncRoamingMsgs syncSuperTeamRoamingMsgs syncMsgReceipts syncExtraTeamInfo syncExtraSuperTeamInfo syncAvSignal",!0,"","sync::syncData"),S.verifyBooleanWithDefault(n,"syncFilter syncTeamMembers syncSuperTeamMembers",!1,"","sync::syncData");var s={};t=t||{},w._nimForceSyncIM&&(e.logger.warn("sync::syncData: nimForceSyncIM"),delete t.teams,w._nimForceSyncIM=!1),s.myInfo=t.myInfo||0,s.deleteMsgSelf=t.deleteMsgSelf||0,s.offlineMsgs=0,n.syncRelations&&(s.relations=t.relations||0),n.syncFriends&&(s.friends=t.friends||0),n.syncFriendUsers&&(s.friendUsers=t.friendUsers||0),n.syncRobots&&(s.robots=t.robots||0),n.syncTeams&&(s.teams=t.teams||0),n.syncSuperTeams&&(s.superTeams=t.superTeams||0),n.syncStickTopSessions&&(s.stickTopSessions=t.stickTopSessions||0),n.syncSessionUnread&&(s.sessionAck=r&&t.sessionAck||0,s.superTeamSessionAck=r&&t.superTeamSessionAck||0),n.syncRoamingMsgs&&(s.roamingMsgs=r&&t.roamingMsgs||t.roamingMsgs||0),n.syncSuperTeamRoamingMsgs&&(s.superTeamRoamingMsgs=r&&t.superTeamRoamingMsgs||0),n.syncMsgReceipts&&(s.msgReceipts=t.msgReceipts||0),n.syncExtraTeamInfo&&(s.myTeamMembers=t.myTeamMembers||0),n.syncExtraSuperTeamInfo&&(s.myInfoInSuperTeams=t.myInfoInSuperTeams||0),n.syncBroadcastMsgs&&(s.broadcastMsgs=t.broadcastMsg||0),s.donnop=t.donnop||0,s.deleteMsg=t.deleteMsg||0,s.deleteSuperTeamMsg=t.deleteSuperTeamMsg||0,s.sessionHistoryMsgsDelete=t.sessionHistoryMsgsDelete||0,s.netcallMsgs=0,n.syncFilter&&(s.filterMsgs=0),n.syncAvSignal&&(s.avSignal=0);var a=i(o=e.onSyncData).call(o,e);a.isImSyncDataCb=!0,e.logger.info("syncData:: start sync",s),e.reporterHook.emit("reporter/syncStart"),e.sendCmd("sync",{sync:s,isImSyncDataObj:!0},a);}e.syncing=!0,r?e.beforeSync().then(function(){return e.db.getTimetags();}).then(function(e){o(e);},function(){o();}):o(e.timetags);},T.onSyncData=function(e){e&&this.syncRetryTimes>3&&(this.syncRetryTimes=0,e.callFunc="sync::onSyncData",this.onCustomError("SYNC_DATA_ERROR",e));},T.processSync=function(e){switch(this.syncRetryTimes=this.syncRetryTimes||0,this.syncRetryTimes++,e.cmd){case"syncDone":e.error?this.syncRetryTimes>3||this.syncData():(this.timetags.sync=e.content.timetag,this.reporterHook.emit("reporter/syncRecv"),this.onSyncDone());break;case"syncTeamMembersDone":this.onSyncTeamMembersDone();}},T.onSyncDone=function(){var e,t,n,i,T,w,A,O,E,R,j,N,U,D,L,F,B,q,H,z,W,V,G,J,Q,K,$,X,Y,Z,ee=this,te=ee.db,ne=te.enable,re=ee.options,oe=ee.syncPromiseArray,ie=ee.syncResult;function se(){if(oe){ee.logger.info("sync::onSyncDone: after sync",S.promises2cmds(oe)),oe=[],t=ie.blacklist||[],n=ie.invalidBlacklist||[],i=ie.mutelist||[],T=ie.invalidMutelist||[],w=ie.friends,E=ie.myTeamMembers,R=ie.mySuperTeamMembers,A=ie.invalidFriends||[],O=ie.myInfo,j=ie.users,U=ie.superTeams,L=ie.invalidSuperTeams,N=ie.teams,D=ie.invalidTeams||[],F=ie.sessions||{},B=s(a({},ee.sessionSet)),q=ie.ackMap,ie.msgReceipts,H=ie.roamingMsgs,z=ie.offlineMsgs,W=ie.offlineFilterMsgs,G=ie.offlineSysMsgs,J=ie.offlineCustomSysMsgs,Q=ie.offlineFilterSysMsgs,K=ie.offlineFilterCustomSysMsgs,$=ie.sysMsgUnread,X=ie.sessionsWithMoreRoaming,Z=ie.clearServerHistoryMsgs||[];var g=o.resolve();!function(){if(ne){var e,t=[ae()];if(F)c(e=u(F)).call(e,function(e){t.push(te.putSession(F[e]));});g=o.all(t).then(function(){var e,t=m(e=[]).call(e,r(u(q||{})),r(u(F||{})));t=p(t).call(t,function(e,t,n){return d(n).call(n,e)===t;});var n=[];return c(t).call(t,function(e){var t,r=F[e];(r.lastMsg||r.ack)&&(t=(t=r.ack?o.resolve(r):te.getSession(r.id)).then(function(t){var n=t.ack||0;return te.getMsgCountAfterAck({shouldCountNotifyUnread:ee.options.shouldCountNotifyUnread,sessionId:e,ack:n}).then(function(n){return t.unread=n||0,F[e]=ee.mergeSession(t),te.updateSession(t);});}),n.push(t));}),o.all(n);}).then(function(){var e=[];return ee.saveAck.p2pTeam&&e.push(te.updateSessionAck(ee.saveAck.p2pTeam).catch(function(e){return ee.logger.error("sessionAck::syncSessionAck::updatetimetag db",e),o.reject(e);})),ee.saveAck.superTeam&&e.push(te.updateSuperTeamSessionAck(ee.saveAck.superTeam).catch(function(e){return ee.logger.error("sessionAck::syncSuperTeamSessionAck::updatetimetag db",e),o.reject(e);})),o.all(e);});}else if(F){var n,i,s;c(n=[H,z]).call(n,function(e){e&&c(e).call(e,function(e){var t;(i=F[e.sessionId]).unread=i.unread||0,i.unreadMsgs=i.unreadMsgs||[],s=i.ack||0,c(t=e.msgs).call(t,function(e){if(!(s>=e.time))if("notification"===e.type){var t;try{t=ee.options.shouldCountNotifyUnread(e);}catch(e){throw ee.logger.error("userOption:shouldCountNotifyUnread function error",e),e;}t&&i.unread++;}else"in"===e.flow&&!1!==e.isUnreadable&&(i.unread++,i.unreadMsgs.push(e));}),ee.mergeSession(i);});});}}(),g.then(function(){if(ne&&!ee.hasSynced)ee.hasSynced=!0,function(){re.syncRelations&&(e=te.getRelations().then(function(e){t=e[0],i=e[1],t.invalid=n,i.invalid=T;}).catch(function(e){return e._msg="on relations error",ee.logger.error("sync::syncRelation: ",e),o.reject(e);}),oe.push(e));re.syncFriends&&(e=te.getFriends().then(function(e){(w=e).invalid=A;}).catch(function(e){return e._msg="on friends error",ee.logger.error("sync::syncFriends: ",e),o.reject(e);}),oe.push(e));k(O)&&(e=te.getUser(ee.account).then(function(e){O=e;}).catch(function(e){return e._msg="on myInfo error",ee.logger.error("sync::syncMyInfo: ",e),o.reject(e);}),oe.push(e));re.syncFriendUsers&&(e=te.getFriends().then(function(e){return f(e).call(e,function(e){return e.account;});}).then(function(e){return te.getUsers(e);}).then(function(e){j=e;}).catch(function(e){return e._msg="on users error",ee.logger.error("sync::syncFriendUser: ",e),o.reject(e);}),oe.push(e));re.syncTeams&&(e=te.getTeams().then(function(e){(N=e).invalid=D;}).catch(function(e){return e._msg="on teams error",ee.logger.error("sync::syncTeams: ",e),o.reject(e);}),oe.push(e));re.syncSuperTeams&&(e=te.getSuperTeams().then(function(e){(U=e).invalid=L;}).catch(function(e){return e._msg="on superteams error",ee.logger.error("sync::syncSuperTeams: ",e),o.reject(e);}),oe.push(e));e=te.getTeamMembersByAccount(ee.account).then(function(e){E=e,ee.mergeMyTeamMembers(e);}).catch(function(e){return ee.logger.error("sync::getTeamMembersByAccount: ",e),o.reject(e);}),oe.push(e),e=te.getSuperTeamMembersByAccount(ee.account).then(function(e){R=e,ee.mergeMySuperTeamMembers(e);}).catch(function(e){return ee.logger.error("sync::getSuperTeamMembersByAccount: ",e),o.reject(e);}),oe.push(e),e=te.getDonnop().then(function(e){ee.mergeDonnop(e);}).catch(function(e){return ee.logger.error("sync::donnop: ",e),o.reject(e);}),oe.push(e),e=te.getAllSessions().then(function(e){F=e;}).catch(function(e){return ee.logger.error("sync::getSession: ",e),o.reject(e);}),oe.push(e),e=te.getSysMsgUnread().then(function(e){$=e;}).catch(function(e){return e._msg="on sysMsgUnread error",ee.logger.error("sync::getSysMsgUnread: ",e),o.reject(e);}),oe.push(e),oe.push(te.getSessionsWithMoreRoaming().then(function(e){X=e;}));}();else{var r,s,a=[];c(r=u(F)).call(r,function(e){(s=F[e]).lastMsg&&a.push(s);}),F=l(a).call(a,function(e,t){return t.updateTime-e.updateTime;});}o.all(oe).then(ce).then(ue,function(e){ee.logger.error("taskAfterSync syncDBDataPromise error:",e),e.callFunc="sync::onSyncDone",e.message="taskAfterSync syncDBDataPromise 出错",ee.onCustomError("SYNC_SESSION_ACK_ERROR",e);});});}else ee.logger.warn("sync::onSyncDone: after sync --no promiseArray");}function ae(){var e=[];return H&&c(H).call(H,function(t){var n;e=m(n=[]).call(n,r(e),r(t.msgs));}),z&&c(z).call(z,function(t){var n;e=m(n=[]).call(n,r(e),r(t.msgs));}),e.length?te.putMsg(e).then(function(){return e;}):o.resolve(e);}function ce(){ee.logger.info("sync::onSyncDone: taskAfterSync"),function(){if(ie.deleteMsgSysMsgs){var e,t={};H&&c(H).call(H,function(e){t[e.sessionId]=e;});var n={};z&&c(z).call(z,function(e){n[e.sessionId]=e;});var o=ee.api;if(c(e=ie.deleteMsgSysMsgs).call(e,function(e){var r;c(r=e.sysMsgs).call(r,function(r){var i=r.msg,s=i.sessionId;"roaming"===e.type&&t[s]?t[s].msgs=o.cutMsgs(t[s].msgs,i):n[s]&&(n[s].msgs=o.cutMsgs(n[s].msgs,i));});}),!te.enable){var i,a=m(i=[]).call(i,r(H||[]),r(z||[]));c(a).call(a,function(e){if(e.msgs.length){var t=ee.genSessionByMsgs(e.msgs);ee.cacheSyncedSession(t),F.unshift(t);}else{var n=g(F).call(F,function(t){return t.id===e.sessionId;});h(F).call(F,n,1);}});var u={};c(F).call(F,function(e){if(u[e.id]){var t=e.lastMsg.time>u[e.id].lastMsg.time?e.lastMsg:u[e.id].lastMsg;u[e.id]=e,u[e.id].lastMsg=t;}else u[e.id]=e;}),F=s(u),F=l(F).call(F,function(e,t){return t.updateTime-e.updateTime;});}}}(),Y=ee.syncResult.stickTopSessions||[],c(F).call(F,function(e){var t=ee.sessionSet[e.id];t&&t.isTop&&(e.isTop=!0);});var e=[ee.deleteMsgOfflineRoaming(ie.deleteMsgSysMsgs,F)];return Z&&c(Z).call(Z,function(t){e.push(function(e,t){var n;ee.logger.info("sync::taskAfterSync:sessionHistoryMsgsDelete ".concat(e)),t=t||new Date().getTime();var r=p(F).call(F,function(t){return t.id===e;}),i=ee.getSessionInCache(e);n=i||r[0];var s=!1!==re.rollbackClearMsgsUnread,a=[];te.enable&&a.push(te.deleteMsgsBySessionId({sessionId:e,end:t}));s&&n&&(n.lastMsg=null,n.unread=0,n=ee.mergeSession(n),te.enable&&a.push(te.updateSession(n)));return o.all(a);}(t.sessionId,t.time));}),o.all(e);}function ue(){y(le,0);}function le(){var e,n,r=[],s=[];if(t&&t.length&&(ee.logger.info("sync::notifyDataAsync: on blacklist",C(t)),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType3_8),re.onblacklist(t)),i&&i.length&&(ee.logger.info("sync::notifyDataAsync: on mutelist",C(i)),re.onmutelist(i)),w&&(ee.logger.info("sync::notifyDataAsync: on friends",C(w)),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType12_5),re.onfriends(w)),O&&(ee.logger.info("sync::notifyDataAsync: on myInfo"),ee.myInfo=O,ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType3_109),re.onmyinfo(S.copy(O))),E){ee.logger.info("sync::notifyDataAsync: on myTeamMembers",E),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType8_126);var a=S.simpleClone(E);v(a)||(a=[a]),re.onMyTeamMembers(a);}if(R){ee.logger.info("sync::notifyDataAsync: on mySuperTeamMembers",R),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType21_111);var u=S.simpleClone(R);v(u)||(u=[u]),re.onMySuperTeamMembers(u);}j&&(c(j).call(j,function(e){ee.mergeUser(e);}),ee.logger.info("sync::notifyDataAsync: on users",C(j)),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType12_6),re.onusers(j)),N&&(ee.logger.info("sync::notifyDataAsync: on teams",I(N)),re.onteams(N),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType8_109)),U&&(ee.logger.info("sync::notifyDataAsync: onSuperTeams",I(U)),re.onSuperTeams(U),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType21_109)),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_12),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_14),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_20),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_21),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType7_15),F&&F.length?(F=f(F).call(F,function(e){return ee.mergeSession(e),b(_).call(_,e);}),F=p(F).call(F,function(e){return!e.isDeleted;}),ee.logger.info("sync::notifyDataAsync: on sessions",x(F),S.secureOutput("session",F)),!ne&&ee.timetags&&ee.timetags.roamingMsgs?re.onsessions(p(B).call(B,function(e){return _.isComplete(e);})):re.onsessions(F)):!ne&&B.length&&(ee.logger.info("sync::notifyDataAsync: on sessions",x(F),S.secureOutput("session",F)),re.onsessions(p(B).call(B,function(e){return _.isComplete(e);}))),Y&&Y.length&&(Y=f(Y).call(Y,function(e){return e=ee.mergeSession(e),b(_).call(_,e);}),ee.logger.info("sync::notifyDataAsync: onStickTopSessions",x(Y),S.secureOutput("session",Y)),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_23),re.onStickTopSessions(Y)),H&&c(H).call(H,function(e){"superTeam"===e.scene?s.push(e.timetag):r.push(e.timetag),(n=e.msgs).length&&(ee.logger.info("sync::notifyDataAsync: on roaming msgs",e.sessionId,n.length),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_9),re.onroamingmsgs(e));}),z&&(ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_4),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_17),c(z).call(z,function(e){"superTeam"===e.scene?s.push(e.timetag):r.push(e.timetag),(n=e.msgs).length&&(ee.logger.info("sync::notifyDataAsync: on offline msgs",e.sessionId,n.length,f(n).call(n,function(e){return e.idServer;})),re.onofflinemsgs(e));})),W&&(ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_100),c(W).call(W,function(e){r.push(e.timetag),(n=e.msgs).length&&(ee.logger.info("sync::notifyDataAsync: on offline filter msgs",e.sessionId,n.length),re.onofflinefiltermsgs(n));})),X&&(ee.logger.info("sync::notifyDataAsync: on sessionsWithMoreRoaming",x(X),X),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_22),re.onSessionsWithMoreRoaming(X));var l,d=[],g=[];ie.deleteMsgSysMsgs&&c(l=ie.deleteMsgSysMsgs).call(l,function(e){"roaming"===e.type?d=m(d).call(d,e.sysMsgs):g=m(g).call(g,e.sysMsgs);});d.length&&(V=m(V=V||[]).call(V,d)),g.length&&(G=m(G=G||[]).call(G,g)),V&&(ee.logger.info("sync::notifyDataAsync: on roaming sys msgs",V.length),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_19),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_15),re.onroamingsysmsgs(V)),G&&(ee.logger.info("sync::notifyDataAsync: on offline sys msgs",G.length),re.onofflinesysmsgs(G)),Q&&(ee.logger.info("sync::notifyDataAsync: on offline filter sys msgs",Q.length),re.onofflinefiltersysmsgs(Q)),J&&(ee.logger.info("sync::notifyDataAsync: on offline custom sys msgs",J.length),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_6),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_18),re.onofflinecustomsysmsgs(J)),K&&(ee.logger.info("sync::notifyDataAsync: on offline filter custom sys msgs",K.length),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_101),re.onofflinefiltercustomsysmsgs(K)),$&&($=S.merge({},ee.sysMsgUnread,$),ee.sysMsgUnread=S.merge({},$),ee.logger.info("sync::notifyDataAsync: on sysMsgUnread",$),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_6),re.onsysmsgunread($));var h=ee.getPushNotificationMultiportConfig();ee.logger.info("sync::notifyDataAsync: on pushNotificationMultiportConfig",h),ee.reporterHook.emit("reporter/syncItemComplete",P.kSyncType4_13),re.onPushNotificationMultiportConfig(h);var y=s.length&&Math.max.apply(Math,s);if(e=r.length&&Math.max.apply(Math,r),te.enable){var T=[];y&&T.push(ee.db.updateSuperTeamRoamingMsgTimetag(y)),e&&T.push(ee.db.updateRoamingMsgTimetag(e)),o.all(T).then(me).catch(me);}else ee.timetags.superTeamRoamingMsgs=y,ee.timetags.roamingMsgs=e||ee.timetags.roamingMsgs,me();ee.syncPromiseArray=[],ee.syncResult={};}function me(){if(ee.processUnsettledMsgs(),ee.processUnsettledSysMsgs(),ee.syncing&&re.onsyncdone(),ee.syncing=!1,ee.reporterHook.emit("reporter/syncComplete"),re.syncTeamMembers&&N&&N.length)throw new M("sync team members api deprecated!");}oe&&oe.length?o.all(oe).then(se).catch(function(e){se(),ee.logger.error(e),e.callFunc="sync::onSyncDone",e.message="afterSync syncNormalPromise 出错",ee.onCustomError("SYNC_promiseArray_ERROR",e);}):se();},T.syncTeamMembers=function(e){var t,n,r=this;r.timetags,n={},c(e).call(e,function(e){n[e.teamId]=0;},r),r.sendCmd("syncTeamMembers",{sync:n},i(t=r.onSyncTeamMembers).call(t,r));},T.onSyncTeamMembers=function(e){e.callFunc="sync::onSyncTeamMembers",e.message="同步群成员错误",this.onCustomError("SYNC_TEAM_MEMBERS_ERROR",e);},T.onSyncTeamMembersDone=function(){var e,t=this,n=t.db,r=t.options,i=t.syncTeamMembersResult,s=t.syncTeamMembersPromiseArray;function a(){t.logger.log("sync::onSyncTeamMembersDone: afterSync",S.promises2cmds(s)),s=[],n.enable&&!t.hasSyncedTeamMembers?(t.hasSyncedTeamMembers=!0,function(){if(!r.syncTeams||!r.syncTeamMembers)return p();n.getTeams().then(function(n){c(n).call(n,function(n){var r=n.teamId;e=new o(function(e,n){t.api.getTeamMembers({teamId:r,done:function done(t,o){t&&n({callFunc:"sync::getTeamMembers: teamId-".concat(r),message:"sync team members error"}),i[r]=o.members||[],e();}});}),s.push(e);}),s.length?o.all(s).then(l,function(e){e.callFunc="sync::onSyncTeamMembersDone",e.message="pullFullData promiseArray notifyData 错误",t.onCustomError("SYNC_TEAM_MEMBERS_ERROR",e);}):l();},function(e){e.callFunc="sync::onSyncTeamMembersDone",e.message="pullFullData getTeams 错误",t.onCustomError("SYNC_TEAM_MEMBERS_ERROR",e);});}()):l();}function l(){y(m,0);}function m(){var e,n,o;c(e=u(i)).call(e,function(e){-1===d(e).call(e,"invalid")&&(n=i[e],o=i[e+"-invalid"]||[],n.invalid=o,function(e,n){t.logger.info("sync::onSyncTeamMembersDone: onTeamMembers",e,C(n),n),r.onteammembers({teamId:e,members:n});}(e,n));}),p();}function p(){t.logger.info("sync::onSyncTeamMembersDone: bingo"),r.onsyncteammembersdone(),t.syncTeamMembersResult=null,t.syncTeamMembersPromiseArray=null;}s.length?o.all(s).then(a,function(e){e.callFunc="sync::onSyncTeamMembersDone",e.message="同步群成员 syncTeamMembersPromiseArray 错误",t.onCustomError("SYNC_TEAM_MEMBERS_ERROR",e);}).catch(function(e){t.logger.log("sync::onSyncTeamMembersDone: syncTeamMembersPromiseArray promise ",e),a();}):a();};},function(e,t,n){var r=n(715),o=n(719),i=n(679),s=n(723);e.exports=function(e){return r(e)||o(e)||i(e)||s();},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(676),o=n(677);e.exports=function(e){if(r(e))return o(e);},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(717);},function(e,t,n){var r=n(718);e.exports=r;},function(e,t,n){var r=n(280);e.exports=r;},function(e,t,n){var r=n(142),o=n(72),i=n(678);e.exports=function(e){if(void 0!==r&&null!=o(e)||null!=e["@@iterator"])return i(e);},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(721);},function(e,t,n){var r=n(722);e.exports=r;},function(e,t,n){var r=n(281);e.exports=r;},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(725);e.exports=r;},function(e,t,n){n(726);var r=n(11);e.exports=r.Object.values;},function(e,t,n){var r=n(1),o=n(727).values;r({target:"Object",stat:!0},{values:function values(e){return o(e);}});},function(e,t,n){var r=n(28),o=n(13),i=n(108),s=n(38),a=o(n(138).f),c=o([].push),u=function u(e){return function(t){for(var n,o=s(t),u=i(o),l=u.length,m=0,p=[];l>m;){n=u[m++],r&&!a(o,n)||c(p,e?[n,o[n]]:o[n]);}return p;};};e.exports={entries:u(!0),values:u(!1)};},function(e,t,n){e.exports=n(729);},function(e,t,n){var r=n(730);e.exports=r;},function(e,t,n){var r=n(19),o=n(731),i=Array.prototype;e.exports=function(e){var t=e.findIndex;return e===i||r(i,e)&&t===i.findIndex?o:t;};},function(e,t,n){n(732);var r=n(24);e.exports=r("Array").findIndex;},function(e,t,n){"use strict";var r=n(1),o=n(89).findIndex,i=n(179),s=!0;"findIndex"in[]&&Array(1).findIndex(function(){s=!1;}),r({target:"Array",proto:!0,forced:s},{findIndex:function findIndex(e){return o(this,e,arguments.length>1?arguments[1]:void 0);}}),i("findIndex");},function(e,t,n){var r=n(7),o=n(6),i=n(3),s=n(2),a=n(32).fn,c=n(0),u=c.objs2accounts,l=n(734),m=n(187);a.processUser=function(e){var t,n=this,i=n.db,s=e.obj,a=e.error,c=e.content;switch(e.cmd){case"markInBlacklist":a||n.markInBlacklist(s);break;case"syncMarkInBlacklist":n.markInBlacklist(c,!0);break;case"markInMutelist":a||n.markInMutelist(s);break;case"syncMarkInMutelist":n.markInMutelist(c,!0);break;case"getRelations":a||n.onRelations(e);break;case"syncMyInfo":n.onMyInfo(e,!0);break;case"updateMyInfo":a||(s.user.updateTime=c.timetag,n.onUpdateMyInfo(e,s.user));break;case"syncUpdateMyInfo":n.onUpdateMyInfo(e,c.user,!0);break;case"getUsers":var u;if(!a)t=r(u=c.users).call(u,function(e){return e=o(m).call(m,e,n.mixStorePolicy&&n.mixStorePolicy.s3Policy?n.mixStorePolicy.s3Policy.dlcdns:[],n.mixStorePolicy&&n.mixStorePolicy.s3Policy?n.mixStorePolicy.s3Policy.dlcdn:""),n.mergeUser(e),e;}),e.obj=t,i.enable&&i.putUsers(t);break;case"updateDonnop":n.onUpdateDonnop(e);break;case"syncUpdateDonnop":n.onDonnop(e,!1);}},a.onMyInfo=function(e){var t,n=this,r=n.db,s=e.error,a=e.content,c=new i(function(e,i){var c,l;s?(s&&(s.callFunc="user::onMyInfo"),e(s),n.syncData()):(t=o(m).call(m,a.user),r.enable?(c=e,l=i,r.mergeMyInfo(t,!0).then(function(){u(),c();}).then(void 0,function(e){e.message="db.mergeMyInfo error",e.callFunc="user::onMyInfo",l(e);})):(u(),e()));}).catch(function(e){return n.logger.error("user::onMyInfo: ",e),i.reject(e);});function u(){n.timetags.myInfo=t.updateTime,n.syncResult.myInfo=t;}c.cmd="myInfo",n.syncPromiseArray.push(c);},a.onUpdateMyInfo=function(e,t,n){var r=this.db,i=o(m).call(m,t),s=c.merge(this.myInfo,i);this.myInfo=s,n?(this.logger.info("user::onUpdateMyInfo:",s&&s.account),this.options.onupdatemyinfo(s)):e.obj=s,r.enable&&(i.account=this.account,r.updateUser(i));},a.onRelations=function(e){var t,n=this,r=n.db,o=e.error,a=n.packetFromSync(e),c=e.content.specialRelations,m=!0,p=[],d=[],f=[],g=[],h=new i(function(h,v){var b,T;o?a&&(h(o),n.syncData()):(s(c).call(c,function(e){var t={account:(e=l.parse(e)).account,createTime:e.createTime,updateTime:e.updateTime};e.isBlacked?p.push(t):d.push(t),e.isMuted?f.push(t):g.push(t);}),n.logger.info("user::onRelations: parse blacklist",u(p),p,"delete",u(d),d),n.logger.info("user::onRelations: parse mutelist",u(f),f,"delete",u(g),g),c.length?(m=!0,t=e.content.timetag):m=!1,r.enable?(b=h,T=v,e.promise=new i(function(e,o){function i(){a?(y(),e(),b()):r.getRelations().then(function(t){p=t[0],f=t[1],y(),e(),b();}).then(void 0,function(e){e.message="db.getRelations error",e.callFunc="user::onRelations",o(e),T(e);});}m?r.mergeRelations(p,d,f,g,t).then(function(){i();}).then(void 0,function(e){e.message="db.mergeRelations error",e.callFunc="user::onRelations",o(e),T(e);}):(n.logger.warn("user::onRelations: no relations need merge"),i());}).then(void 0,function(e){throw e.message="merge relations data error",e.callFunc="user::onRelations",T(e),e;})):(y(),h()));}).catch(function(e){return n.logger.error("user::onRelations: ",e),i.reject(e);});function y(){n.timetags.relations=t,p.invalid=d,f.invalid=g,a?(n.syncResult.blacklist=p,n.syncResult.mutelist=f,n.syncResult.invalidBlacklist=d,n.syncResult.invalidMutelist=g):(n.logger.info("user::onRelations: get relations",p,f),e.obj.blacklist=p,e.obj.mutelist=f);}a&&(h.cmd="relations",n.syncPromiseArray.push(h));},a.markInBlacklist=function(e,t){var n=this.db;e.record={account:e.account,updateTime:+new Date()},n.enable&&n.markInBlacklist(e),t&&(this.logger.info("user::markInBlacklist:",e),this.options.onsyncmarkinblacklist(e));},a.markInMutelist=function(e,t){var n=this.db;e.record={account:e.account,updateTime:+new Date()},n.enable&&n.markInMutelist(e),t&&(this.logger.info("user::markInMutelist:",e),this.options.onsyncmarkinmutelist(e));},a.mergeUser=function(e){this.userSet[e.account]=e;};},function(e,t,n){var r=n(0);function o(){}o.parse=function(e){var t=r.copy(e);return t.isBlacked="1"===t.isBlacked,t.isMuted="1"===t.isMuted,t.createTime=+t.createTime,t.updateTime=+t.updateTime,t;},e.exports=o;},function(e,t,n){var r=n(109),o=n(2),i=n(6),s=n(3),a=n(9),c=n(7),u=["type"],l=n(32).fn,m=n(0),p=m.objs2accounts,d=n(681),f=n(187);l.processFriend=function(e){var t=e.obj,n=e.content,r=e.error;switch(e.cmd){case"friendRequest":this.updateFriendSysMsg(e),r||this.onFriendRequest(t);break;case"syncFriendRequest":this.onFriendRequest(n,!0);break;case"deleteFriend":r||this.onDeleteFriend(t);break;case"syncDeleteFriend":this.onDeleteFriend(n,!0);break;case"updateFriend":r||this.onUpdateFriend(t);break;case"syncUpdateFriend":this.onUpdateFriend(n.friend,!0);break;case"getFriends":this.getFriends(e);break;case"syncFriends":this.onFriends(e);break;case"syncFriendUsers":this.onFriendUsers(e);}},l.getFriends=function(e){var t=e.content.friends,n=[],r=[];o(t).call(t,function(e){(e=i(d).call(d,e)).valid?n.push(e):r.push(e);}),n.invalid=r,e.obj=n;},l.onFriends=function(e){var t,n=this,r=n.db,c=e.error,u=e.content.friends,l=!0,m=[],f=[],g=new s(function(a,g){var y,v;c?g(c):(!function(){l&&o(u).call(u,function(e){(e=i(d).call(d,e)).valid?m.push(e):f.push(e);});n.logger.info("friend::onFriends: parse friends",p(m),"delete",p(f)),u.length?(l=!0,t=e.content.timetag):l=!1;}(),r.enable?(y=a,v=g,e.promise=new s(function(e,o){function i(){h(),e(),y();}l?r.mergeFriends(m,f,t).then(function(){i();}).then(void 0,function(e){e._msg="merge friends error",o(e),v(e);}):(n.logger.info("friend::onFriends: no merge friends"),i());}).then(void 0,function(e){throw e._msg="merge friends data error",v(e),e;})):(h(),a()));}).catch(function(e){return n.logger.error("friend::onFriends: ",e),s.reject(e);});function h(){var e,r;n.timetags.friends=t,m.invalid=f,n.syncResult.friends=a(e=n.syncResult.friends||[]).call(e,m||[]),n.syncResult.invalidFriends=a(r=n.syncResult.invalidFriends||[]).call(r,f||[]);}g.cmd="friends",n.syncPromiseArray.push(g);},l.onFriendRequest=function(e,t){var n=s.resolve(),o=this.db,i=e.type,a=r(e,u);if("addFriend"===(i=e.type=d.getTypeFromByte(i)||i)||"passFriendApply"===i){var c=e.friend=d.assembleFriend(a);o.enable&&(n=o.putFriend(c));}return t&&this.onSyncFriendAction(e),n;},l.onSyncFriendAction=function(e){this.logger.info("friend::onSyncFriendActionon: ".concat(e.type,", "),e.account),this.options.onsyncfriendaction(e);},l.onDeleteFriend=function(e,t){var n=s.resolve(),r=this.db;return r.enable&&(n=r.deleteFriend(e.account)),t&&(e.type="deleteFriend",this.onSyncFriendAction(e)),n;},l.onUpdateFriend=function(e,t){var n=this.db,r=i(d).call(d,e);n.enable&&n.updateFriend(r),t&&this.onSyncFriendAction({type:"updateFriend",friend:r});},l.onFriendUsers=function(e){var t,n,r=this.db,o=e.content,u=c(t=o.users).call(t,function(e){return i(f).call(f,e);});this.logger.info("friend::onFriendUsers: parse users",p(u));var l=o.timetag,m=s.resolve();r.enable&&(m=r.mergeFriendUsers(u,l)),this.timetags.friendUsers=l,m.cmd="friendUsers",this.syncPromiseArray.push(m),this.syncResult.users=a(n=this.syncResult.users||[]).call(n,u||[]),this.syncing||this.onSyncDone();},l.updateFriendSysMsg=function(e){var t,n,r=e.obj,o=e.error;if(e.obj.idServer){if(o)t="error",o=m.filterObj(o,"code message");else{var i=r.type;switch(i=d.getTypeFromByte(i)||i){case"passFriendApply":t="passed";break;case"rejectFriendApply":t="rejected";}}n={idServer:r.idServer,state:t,from:r.account,type:"applyFriend"},o&&(n.error=o),this.updateSysMsg(n);}};},function(e,t,n){var r=n(30),o=n(17),i=n(32).fn,s=n(0);i.onRobots=function(e){var t=e.content;if(s.isFunction(this.options.onrobots)&&r(t.robots)){var n,i=o(n=t.robots).call(n,function(e){return!!e.botid;});i.length>0&&this.options.onrobots(i||[]);}};},function(e,t,n){var r=n(6),o=n(2),i=n(27),s=n(158),a=n(3),c=n(7),u=n(17),l=n(5),m=n(32).fn,p=n(0),d=p.objs2accounts,f=p.teams2ids,g=n(175),h=n(139);m.processTeam=function(e){var t,n,o,i=e.error;switch(void 0===e.obj&&(e.obj={}),e.cmd){case"createTeam":t=e.obj.team,i||(t=e.content.team),t=r(g).call(g,t),e.obj.team=t,o=h.assembleOwner(t),e.obj.owner=o,i||(this.logger.info("team::processTeam: create team ",t&&t.teamId,o&&o.account),this.onCreateTeam(t,o));break;case"syncCreateTeam":t=r(g).call(g,e.content.team),o=h.assembleOwner(t),this.logger.info("team::processTeam: sync createTeam",t&&t.teamId,o&&o.account),this.options.onsynccreateteam(t,o),this.onCreateTeam(t,o);break;case"sendSuperTeamMsg":case"sendTeamMsg":this.onSendMsg(e);break;case"teamMsg":this.onMsg(e);break;case"teamMsgs":this.onMsgs(e);break;case"addTeamMembers":case"removeTeamMembers":case"leaveTeam":case"dismissTeam":case"addTeamManagers":case"removeTeamManagers":case"transferTeam":break;case"updateInfoInTeam":i||((n=e.obj).account=this.account,n.id=h.genId(n.teamId,n.account),n=r(h).call(h,n),e.obj=n,this.mergeMyTeamMembers(n),this.onUpdateTeamMember(n));break;case"updateNickInTeam":e.obj=r(h).call(h,e.obj);break;case"updateTeam":e.obj=r(g).call(g,e.obj,!0);break;case"applyTeam":e.error||(e.obj=r(g).call(g,e.content.team));break;case"passTeamApply":this.updateTeamSysMsgState(e,"passed");break;case"rejectTeamApply":this.updateTeamSysMsgState(e,"rejected");break;case"acceptTeamInvite":this.updateTeamSysMsgState(e,"passed"),e.error||(e.obj=r(g).call(g,e.content.team));break;case"rejectTeamInvite":this.updateTeamSysMsgState(e,"rejected");break;case"getTeam":e.error||(e.obj=r(g).call(g,e.content.team));break;case"getTeams":this.onTeams(e);break;case"getTeamMembers":this.onTeamMembers(e);break;case"syncTeams":this.onTeams(e);break;case"syncTeamMembers":this.onTeamMembers(e);break;case"getTeamHistoryMsgs":case"searchTeamHistoryMsgs":this.onHistoryMsgs(e);break;case"syncSendTeamMsg":this.onMsg(e);break;case"notifyTeamMsgReads":this.onTeamMsgReceipt(e);break;case"syncUpdateTeamMember":(n=r(h).call(h,e.content.teamMember)).account===this.account&&this.mergeMyTeamMembers(n),this.onUpdateTeamMember(n);break;case"updateMuteStateInTeam":break;case"getMyTeamMembers":e.error||(e.obj=h.reverseMembers(e.content.teamMembers));break;case"getMutedTeamMembers":e.error||(e.obj={teamId:e.obj.teamId,members:h.reverseMembers(e.content.teamMembers)});break;case"syncMyTeamMembers":this.onSyncMyTeamMembers(e);break;case"sendTeamMsgReceipt":this.sendTeamMsgReceipt(e);break;case"getTeamMsgReads":this.getTeamMsgReads(e);break;case"getTeamMsgReadAccounts":this.getTeamMsgReadAccounts(e);break;case"getTeamsById":this.getTeamsById(e);}},m.getTeamMsgReads=function(e){var t=this;if(e.error)this.logger.error("team::sendTeamMsgReceipt: ",e.error);else{var n=p._get(e,"content.teamMsgReceipts")||[];if(this.db.enable){var r=[];o(n).call(n,function(e){e.idClient&&r.push({idClient:e.idClient,unread:+e.unread,read:+e.read});}),r.length>0&&i(function(){return t.db.updateMsgBatch(r);},0);}}},m.getTeamMsgReadAccounts=function(e){if(e.error)this.logger.error("team::getTeamMsgReadAccounts: ",e.error);else{var t=p._get(e,"content.readAccounts")||[],n=p._get(e,"content.unreadAccounts")||[],r=p._get(e,"content.teamMsgReceipt.idClient")||[];this.db.enable&&this.db.putMsgReadDetail({idClient:r,readAccounts:t,unreadAccounts:n});}},m.sendTeamMsgReceipt=function(e){var t=this;if(e.error)this.logger.error("team::sendTeamMsgReceipt: ",e.error);else{var n=p._get(e,"obj.teamMsgReceipts")||[],r=p._get(e,"content.teamMsgReceipts")||[];if(this.db.enable){var a=[];o(n).call(n,function(e){s(r).call(r,function(t){return e.idServer===t.idServer;})||a.push({idClient:e.idClient,hasRead:!0});}),a.length>0&&(this.logger.log("sendTeamMsgReceipt::updateMsgBatch"),i(function(){return t.db.updateMsgBatch(a);},0));}}},m.onCreateTeam=function(e,t){var n=this.db;n.enable&&(n.putTeam(e),n.putTeamMembers(t)),this.options.onCreateTeam(e,t);},m.onTeams=function(e){e.content=e.content||{};var t,n=this,i=n.db,s=n.packetFromSync(e),c=e.content.teams||[],u=!0,l=[],m=[];if(e.error)switch(e.error.code){case 803:e.error=null,u=!1;}var p=new a(function(p,f){var h,y;e.error?s&&f(e.error):(!function(){u&&o(c).call(c,function(e){(e=r(g).call(g,e)).validToCurrentUser?l.push(e):m.push(e);});c.length?(u=!0,t=e.content.timetag):u=!1;}(),i.enable?(h=p,y=f,e.promise=new a(function(e,r){function o(){s?(d(),e(),h()):i.getTeams().then(function(t){l=t,d(),e(),h();}).catch(function(e){e.message="db.getTeams error",e.callFunc="team::afterMergeData",r(e),y(e);});}u?i.mergeTeams(l,m,t).then(function(){o();}).catch(function(e){var t={callFunc:"team::onTeams:mergeData",message:"db.mergeTeams error",event:e};r(t),y(t);}):(n.logger.warn("team::onTeams:mergeData: no teams need merge"),o());}).then(void 0,function(e){throw e.message="merge teams data error",e.callFunc="team::mergeData",y(e),e;})):(d(),p()));}).catch(function(e){return n.logger.error("team::onTeams: ",e),a.reject(e);});function d(){n.timetags.teams=t,l.invalid=m,s?(n.syncResult.teams=l,n.syncResult.invalidTeams=m,n.syncing||n.onSyncDone()):(n.logger.info("team::onTeams: not in syncing, get teams",f(l)),e.obj=l);}s&&(p.cmd="teams",n.syncPromiseArray.push(p));},m.getTeamsById=function(e){var t;if(e.error){if(816!==e.error.code)return;this.logger.error("team::getTeamsById: ",e.error),e.error=null;}e.content.teams=c(t=e.content.teams).call(t,function(e){return r(g).call(g,e);}),e.obj=e.content;},m.onTeamMembers=function(e){e.content=e.content||{};var t,n,i=this,s=i.packetFromSync(e),c=e.content.members||[],u=!0,l=[],m=[];if(e.obj&&(n=e.obj.teamId),n||(n=e.content.teamId),n=""+n,e.error)switch(e.error.code){case 406:e.error=null,u=!1;}var p=new a(function(a,p){e.error?s&&(i.logger.error("team::onTeamMember: team error:",n,e.error),p({callFunc:"team::onTeamMembers",event:e.error,message:"teamId-".concat(n," 获取群成员错误")})):(!function(){u&&o(c).call(c,function(e){(e=r(h).call(h,e)).valid?l.push(e):m.push(e);});c.length?(u=!0,t=e.content.timetag):u=!1;}(),l.invalid=m,s?(i.syncTeamMembersResult[n]=l,i.syncTeamMembersResult[n+"-invalid"]=m,i.timetags["team-"+n]=t):(i.logger.info("team::onTeamMembers: not syncing, get members",n,d(l)),e.obj={teamId:n,members:l}),a());});s&&(p.cmd=n,i.syncTeamMembersPromiseArray.push(p));},m.onUpdateTeamMember=function(e){if(e.updateTime||(e.updateTime=+new Date()),this.logger.info("team::onUpdateTeamMember: ",e&&e.account),this.options.onupdateteammember(p.simpleClone(e)),this.account===e.account){var t=this.myTeamMembersMap[e.teamId];this.logger.info("team::onMyTeamMembers: ",[t]),this.options.onMyTeamMembers(p.simpleClone([t]));}var n={teamId:e.teamId,memberUpdateTime:e.updateTime};this.onUpdateTeam(n);var r=this.db;r.enable&&r.updateTeamMember(e);},m.onUpdateTeam=function(e){this.logger.info("team::onUpdateTeam:",e&&e.teamId),this.options.onUpdateTeam(p.simpleClone(e));var t=this.db;t.enable&&t.updateTeam(e);},m.onSyncMyTeamMembers=function(e){var t=this,n=t.db,r=h.reverseMembers(e.content.teamMembers);if(n.enable){var o=n.putTeamMembers(r).then(function(){return n.updateMyTeamMembersTimetag(e.content.timetag);}).catch(function(e){return t.logger.error("team::syncMyTeamMember: ",e),a.reject(e);});o.cmd="myTeamMembers",t.syncTeamMembersPromiseArray.push(o),t.syncPromiseArray.push(o);}else t.syncResult.myTeamMembers=r;t.mergeMyTeamMembers(r);},m.mergeMyTeamMembers=function(e){p.isArray(e)||(e=[e]);var t=this.myTeamMembersMap=this.myTeamMembersMap||{};o(e).call(e,function(e){var n=e.teamId;t[n]=p.merge(t[n],e);});},m.notifyForNewTeamMsg=function(e){p.isArray(e)||(e=[e]);var t=this,n=this.myTeamMembersMap||{},r={},i=[];o(e).call(e,function(e){p.exist(n[e])?r[e]=n[e].muteNotiType:i.push(e);});var s=a.resolve({map:r});return i.length&&(s=t.api.getMyTeamMembers({teamIds:i,promise:!0}).then(function(n){t.mergeMyTeamMembers(n),o(n).call(n,function(e){r[e.teamId]=e.muteNotiType;});var i=u(e).call(e,function(e){return!r[e];});return a.resolve({map:r,miss:i});}).catch(function(e){return l(r).length>0?a.resolve({map:r,miss:i,error:e}):a.reject(e);})),s;},m.updateTeamSysMsgState=function(e,t){var n,r=e.error;r&&(t="error",r=p.filterObj(r,"code message")),n={idServer:e.obj.idServer,state:t,from:e.obj.from,type:e.obj.type},r&&(n.error=r),this.updateSysMsg(n);},m.onTeamMsgReceipt=function(e){var t=e.content,n=e.error;n&&this.logger.error("team::onTeamMsgReceipt:",n),t&&t.teamMsgReceipts&&(this.options.onTeamMsgReceipt(t),this.options.onMsgReceipts(t.teamMsgReceipts));};},function(e,t,n){var r=n(6),o=n(3),i=n(2),s=n(32).fn,a=n(0),c=a.teams2ids,u=n(287),l=n(186);s.processSuperTeam=function(e){var t,n,o,i=e.error;switch(void 0===e.obj&&(e.obj={}),e.cmd){case"sendSuperTeamMsg":this.onSendMsg(e);break;case"superTeamMsg":this.onMsg(e);break;case"sendSuperTeamCustomSysMsg":this.onSendSysMsg(e);break;case"superTeamCustomSysMsg":this.onSysMsg(e);break;case"syncSuperTeams":this.onSuperTeams(e);break;case"syncCreateSuperTeam":t=r(u).call(u,e.content.team),o=l.assembleOwner(t),this.logger.info("team::processTeam: sync createTeam",t&&t.teamId,o&&o.account),this.options.onSyncCreateSuperTeam(t,o),this.onCreateSuperTeam(t,o);break;case"getSuperTeamHistoryMsgs":case"searchSuperTeamHistoryMsgs":this.onHistoryMsgs(e);break;case"syncSendSuperTeamMsg":this.onMsg(e);break;case"addSuperTeamMembers":case"removeSuperTeamMembers":case"leaveSuperTeam":case"addSuperTeamManagers":case"removeSuperTeamManagers":case"transferSuperTeam":break;case"updateInfoInSuperTeam":i||((n=e.obj).account=this.account,n.id=l.genId(n.teamId,n.account),n=r(l).call(l,n),e.obj=n,this.mergeMySuperTeamMembers(n),this.onUpdateSuperTeamMember(n));break;case"updateNickInTeam":e.obj=r(l).call(l,e.obj);break;case"syncUpdateSuperTeamMember":(n=r(l).call(l,e.content.teamMember)).account===this.account&&this.mergeMySuperTeamMembers(n),this.onUpdateSuperTeamMember(n);break;case"updateSuperTeam":e.obj=r(u).call(u,e.obj,!0);break;case"getSuperTeam":e.error||(e.obj=r(u).call(u,e.content.team));break;case"getSuperTeams":this.onSuperTeams(e);break;case"syncSuperTeamMembers":this.onSyncSuperTeamMembers(e);break;case"syncMySuperTeamMembers":this.onSyncMySuperTeamMembers(e);break;case"getSuperTeamMembers":e.error||this.onGetAllSuperTeamMembers(e);break;case"getSuperTeamMembersByJoinTime":case"getSuperTeamMembersByAccounts":case"getMutedSuperTeamMembers":e.error||this.onSuperTeamMembers(e);break;case"onDeleteSuperTeamMsg":this.onDeleteMsg(e);break;case"onSuperTeamMsgDelete":case"syncDeleteSuperTeamMsg":this.onMsgDeleted(e,!0);break;case"onMarkSuperTeamSessionAck":this.onMarkSessionAck(e);break;case"syncMarkSuperTeamSessionAck":this.syncMarkSessionAck(e);}},s.onSuperTeams=function(e){e.content=e.content||{};var t,n=this,s=n.db,a=n.packetFromSync(e),l=e.content.teams||[],m=!0,p=[],d=[];if(e.error)switch(e.error.code){case 803:e.error=null,m=!1;}var f=new o(function(c,f){var h,y;e.error?a&&f(e.error):(!function(){m&&i(l).call(l,function(e){(e=r(u).call(u,e)).validToCurrentUser?p.push(e):d.push(e);});l.length?(m=!0,t=e.content.timetag):m=!1;}(),s.enable?(h=c,y=f,e.promise=new o(function(e,r){function o(){a?(g(),e(),h()):s.getSuperTeams().then(function(t){p=t,g(),e(),h();}).then(void 0,function(e){e.message="db.getSuperTeams error",e.callFunc="superTeam::afterMergeData",r(e),y(e);});}m?s.mergeSuperTeams(p,d,t).then(function(){o();}).then(void 0,function(e){var t={callFunc:"superTeam::onSuperTeams:mergeData",message:"db.mergeSuperTeams error",event:e};r(t),y(t);}):(n.logger.warn("superTeam::onSuperTeams:mergeData: no teams need merge"),o());}).then(void 0,function(e){throw e.message="merge teams data error",e.callFunc="superTeam::mergeData",y(e),e;})):(g(),c()));}).catch(function(e){return n.logger.error("superTeam::onSuperTeams: ",e),o.reject(e);});function g(){n.timetags.superTeams=t,p.invalid=d,a?(n.syncResult.superTeams=p,n.syncResult.invalidSuperTeams=d):(n.logger.info("superTeam::onSuperTeams: not in syncing, get teams",c(p)),e.obj=p);}a&&(f.cmd="superteams",n.syncPromiseArray.push(f));},s.onCreateSuperTeam=function(e,t){var n=this.db;n.enable&&(n.putSuperTeam(e),n.putSuperTeamMembers(t));},s.onGetAllSuperTeamMembers=function(e){var t=this,n=this.db,r=e.raw.ser,i=this.superTeamMembersData[r]||{},s=i.teamId||e.obj&&e.obj.teamId;if(n.enable){var a=e.content&&e.content.timetag,c=200===e.raw.code?o.all(i.pArr):o.resolve();e.promise=c.then(function(){return n.getSuperTeamMembers(s).then(function(t){a&&n.updateSuperTeamMemberTimetag(s,a),e.obj={members:t,invalid:[],teamId:s};});}).catch(function(e){return t.logger.error(e);});}else e.obj={members:i.members,invalid:i.invalid,teamId:s};this.superTeamMembersData[r]=void 0;},s.onSyncSuperTeamMembers=function(e){var t,n=this.db,s=[],a=[],c=e.content.members||[],u=e.raw.ser;if(e.obj&&(t=e.obj.teamId),t||(t=e.content.teamId),i(c).call(c,function(e){(e=r(l).call(l,e)).valid?a.push(e):s.push(e);}),n.enable){this.superTeamMembersData[u]=this.superTeamMembersData[u]||{teamId:t,pArr:[]};var m=o.resolve();e.content&&e.content.isAll&&(m=n.deleteSuperTeamMembers(t));var p=m.then(function(){return n.mergeSuperTeamMembers(t,a,s);}).then(function(){return o.resolve();});this.superTeamMembersData[u].pArr.push(p);}else this.superTeamMembersData[u]=this.superTeamMembersData[u]||{teamId:t,members:[],invalid:[]},a.length&&(this.superTeamMembersData[u].members=this.api.mergeTeamMembers(this.superTeamMembersData[u].members,a)),s.length&&(this.superTeamMembersData[u].invalid=this.api.mergeTeamMembers(this.superTeamMembersData[u].invalid,s));e.raw=void 0;},s.onSyncMySuperTeamMembers=function(e){var t=this,n=t.db,r=l.reverseMembers(e.content.teamMembers);if(n.enable){var i=n.putSuperTeamMembers(r).then(function(){return n.updateMySuperTeamMembersTimetag(e.content.timetag);}).catch(function(e){return t.logger.error("superTeam::syncMySuperTeamMember: ",e),o.reject(e);});t.syncPromiseArray.push(i);}else t.syncResult.mySuperTeamMembers=r;t.mergeMySuperTeamMembers(r);},s.onSuperTeamMembers=function(e,t){var n,o=this.db,s=[],a=[],c=e.content.members||[];i(c).call(c,function(e){(e=r(l).call(l,e)).valid?a.push(e):s.push(e);}),e.obj&&(n=e.obj.teamId),n||(n=e.content.teamId||a[0]&&a[0].teamId),o.enable&&!t&&o.mergeSuperTeamMembers(n,a,s),e.obj={members:a,invalid:s,teamId:n};},s.onUpdateSuperTeamMember=function(e){if(e.updateTime||(e.updateTime=+new Date()),this.logger.info("superTeam::onUpdateSuperTeamMember: ",e&&e.account),this.options.onUpdateSuperTeamMember(a.simpleClone(e)),this.account===e.account){var t=this.mySuperTeamMembersMap[e.teamId];this.logger.info("superTeam::onMySuperTeamMembers: ",[t]),this.options.onMySuperTeamMembers(a.simpleClone([t]));}var n={teamId:e.teamId,memberUpdateTime:e.updateTime};this.onUpdateSuperTeam(n);var r=this.db;r.enable&&r.updateSuperTeamMember(e);},s.onUpdateSuperTeam=function(e){this.logger.info("superteam::onUpdateSuperTeam:",e&&e.teamId),this.options.onUpdateSuperTeam(a.simpleClone(e));var t=this.db;t.enable&&t.updateSuperTeam(e);},s.mergeMySuperTeamMembers=function(e){a.isArray(e)||(e=[e]);var t=this.mySuperTeamMembersMap=this.mySuperTeamMembersMap||{};i(e).call(e,function(e){var n=e.teamId;t[n]=a.merge(t[n],e);});};},function(e,t,n){var r=n(6),o=n(3),i=n(27),s=n(32).fn,a=n(0),c=n(288);s.processNotify=function(e){switch(e.cmd){case"syncOfflineNetcallMsgs":case"syncOfflineMsgs":this.onOfflineMsgs(e);break;case"batchMarkRead":break;case"syncOfflineSysMsgs":case"syncOfflineSuperTeamSysMsgs":this.onOfflineSysMsgs(e);break;case"syncRoamingMsgs":case"syncSuperTeamRoamingMsgs":this.onRoamingMsgs(e);break;case"syncOfflineFilterMsgs":this.onOfflineMsgs(e,!0);break;case"syncOfflineFilterSysMsgs":this.onOfflineSysMsgs(e,!0);break;case"syncMsgReceipts":this.onOfflineMsgReceipts(e);break;case"syncDonnop":this.onDonnop(e,!0);break;case"syncSessionAck":this.syncSessionAck(e);break;case"syncSuperTeamSessionAck":this.syncSuperTeamSessionAck(e);break;case"syncRobots":this.onRobots(e);break;case"syncBroadcastMsgs":this.onBroadcastMsgs(e);break;case"syncDeleteSuperTeamMsgOfflineRoaming":this.onDeleteMsgOfflineRoaming(e);break;case"syncDeleteMsgSelf":this.syncDeleteMsgSelf(e);break;case"syncSessionsWithMoreRoaming":this.syncSessionsWithMoreRoaming(e);break;case"syncStickTopSessions":this.syncStickTopSessions(e);break;case"syncSessionHistoryMsgsDelete":this.syncSessionHistoryMsgsDelete(e);}},s.onDonnop=function(e,t){if(!e.error){var n=this,i=n.db,s=r(c).call(c,e.content.donnop);n.mergeDonnop(s);var a=n.dbDonnop();if(t){var u=e.content.timetag;n.timetags.donnop=u,i.enable&&(a=a.then(function(){return n.db.updateDonnopTimetag(u);}).catch(function(e){return n.logger.error("notify::onDonnop: ",e),o.reject(e);})),a.cmd="donnop",n.syncPromiseArray.push(a);}else n.onPushNotificationMultiportConfigUpdate();}},s.onUpdateDonnop=function(e){if(!e.error){var t=e.obj;t&&(this.mergeDonnop(a.filterObj(t,["shouldPushNotificationWhenPCOnline"])),this.dbDonnop(),this.onPushNotificationMultiportConfigUpdate());}},s.getPushNotificationMultiportConfig=function(){return a.merge({},this.pushNotificationMultiportConfig);},s.mergeDonnop=function(e){this.pushNotificationMultiportConfig=a.merge({},this.pushNotificationMultiportConfig,e);},s.dbDonnop=function(){return this.db.enable?this.db.setDonnop(this.pushNotificationMultiportConfig):o.resolve();},s.onPushNotificationMultiportConfigUpdate=function(){var e=this;i(function(){var t=e.getPushNotificationMultiportConfig();e.logger.info("link::onPushNotificationMultiportConfigUpdate:",t),e.options.onPushNotificationMultiportConfigUpdate(t);});};},function(e,t,n){var r=n(58),o=n(2),i=n(17),s=n(3),a=n(7),c=n(5),u=n(4),l=n(10),m=n(6),p=n(127),d=n(9),f=n(27),g=n(23),h=n(48),y=n(35),v=n(59),b=n(60),T=n(61),S=n(62),M=n(46),k=n(16),x=n(102),C=n(103),I=n(72),_=n(30);function w(e,t){var _n7=void 0!==C&&I(e)||e["@@iterator"];if(!_n7){if(_(e)||(_n7=function(e,t){var n;if(!e)return;if("string"==typeof e)return P(e,t);var r=k(n=Object.prototype.toString.call(e)).call(n,8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return x(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return P(e,t);}(e))||t&&e&&"number"==typeof e.length){_n7&&(e=_n7);var r=0,o=function o(){};return{s:o,n:function n(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]};},e:function e(_e9){throw _e9;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var i,s=!0,a=!1;return{s:function s(){_n7=_n7.call(e);},n:function n(){var e=_n7.next();return s=e.done,e;},e:function e(_e10){a=!0,i=_e10;},f:function f(){try{s||null==_n7.return||_n7.return();}finally{if(a)throw i;}}};}function P(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++){r[n]=e[n];}return r;}function A(e,t){var n=c(e);if(v){var r=v(e);t&&(r=i(r).call(r,function(t){return b(e,t).enumerable;})),n.push.apply(n,r);}return n;}var O=n(32).fn,E=n(0),R=E.undef,j=n(41),N=n(139),U=n(186),D=n(141),L=n(273),F=n(14),B=n(73),q=n(56);function H(e,t,n){var r=this,o=r.message.Message,i=n?"offlineFilterMsgs":"offlineMsgs";if(!(t&&t.length>0))return s.resolve();var a=o.getMaxTimetag(t),c=t[0].scene,u=t[0].target;r.markMsgRead(t),t=o.deduplication(t),t=o.sortMsgs(t);var l=r.genSessionByMsgs(t);r.cacheSyncedSession(l);var m=r.putMsg(t,"offlineMsgs").then(function(t){var n=t;(n=r.filterIgnore(n)).length&&(r.logger.info("msg::onOfflineMsgs： toreLastSession",i,e,n.length),r.syncResult[i]=r.syncResult[i]||[],r.syncResult[i].push({sessionId:e,scene:c,to:u,msgs:n,timetag:a}));}).catch(function(e){return r.logger.error("msg::onOfflineMsgs: ",e),s.reject(e);});return m.cmd="offlineMsgs-"+e,m;}O.processMsg=function(e){switch(e.cmd){case"sendMsg":this.onSendMsg(e);break;case"msg":this.onMsg(e);break;case"sysMsg":this.onSysMsg(e);break;case"broadcastMsg":this.onBroadcastMsg(e);break;case"sendCustomSysMsg":this.onSendSysMsg(e);break;case"getHistoryMsgs":case"searchHistoryMsgs":this.onHistoryMsgs(e);break;case"msgFtsInServer":case"msgFtsInServerByTiming":this.onmsgFtsInServer(e);break;case"syncSendMsg":this.onMsg(e);break;case"deleteSessions":this.onDeleteSessions(e);break;case"sendMsgReceipt":this.onSendMsgReceipt(e);break;case"msgReceipt":this.onMsgReceipt(e);break;case"onDeleteMsg":this.onDeleteMsg(e);break;case"onMsgDeleted":this.onMsgDeleted(e);break;case"onDeleteMsgOfflineRoaming":this.onDeleteMsgOfflineRoaming(e);break;case"onMarkSessionAck":this.onMarkSessionAck(e);break;case"syncMarkSessionAck":this.syncMarkSessionAck(e);break;case"syncUpdateServerSession":this.onSyncUpdateServerSession(e);break;case"deleteMsgSelf":this.deleteMsgSelf(e);break;case"deleteMsgSelfBatch":this.deleteMsgSelfBatch(e);break;case"onDeleteMsgSelf":this.onDeleteMsgSelf(e);break;case"onDeleteMsgSelfBatch":this.onDeleteMsgSelfBatch(e);break;case"clearServerHistoryMsgs":this.clearServerHistoryMsgs(e);break;case"onClearServerHistoryMsgs":this.onClearServerHistoryMsgs(e);}},O.checkIgnore=function(e){var t=this;o(e).call(e,function(e){if(!e.ignore){try{t.options.shouldIgnoreMsg(e)&&(e.ignore=!0);}catch(e){throw t.logger.error("userOption:shouldIgnoreMsg function error",e),e;}var n;try{n=t.options.shouldIgnoreNotification(e);}catch(e){throw t.logger.error("userOption:shouldIgnoreNotification function error",e),e;}"notification"===e.type&&n&&(e.ignore=!0);}});},O.filterIgnore=function(e){return i(e).call(e,function(e){return!e.ignore;});},O.genSessionByMsgs=function(e){return this.checkIgnore(e),D.genSessionByMsgs(this.message.Message,e);},O.onRoamingMsgs=function(e){var t=this,n=t.message,r=n.Message,o=r.getMaxTimetag,i=n.reverseMsgs(e.content.msgs),a=o(i);i=r.deduplication(i);var c=(i=r.sortMsgs(i))[0],u=c.sessionId,l=t.genSessionByMsgs(i);t.cacheSyncedSession(l);var m=t.putMsg(i,"roamingMsgs").then(function(e){i=e,(i=t.filterIgnore(i)).length&&(t.logger.info("msg::onRoamingMsgs: putRoamingMsgs",u,i.length),t.syncResult.roamingMsgs=t.syncResult.roamingMsgs||[],t.syncResult.roamingMsgs.push({sessionId:u,scene:c.scene,to:c.target,msgs:i,timetag:a}),t.syncing||t.onSyncDone());}).catch(function(e){return t.logger.error("msg::onRoamingMsgs: ",e),s.reject(e);});m.cmd="roamingMsgs-"+u,t.syncPromiseArray.push(m);},O.onOfflineMsgs=function(e,t){var n,r=this,i=this.message,s=null;t&&(s={filter:!0});var u=i.reverseMsgs(e.content.msgs,{modifyObj:s});u=q.deduplication(u);var l={};o(u).call(u,function(e){l[e.sessionId]=l[e.sessionId]||[],l[e.sessionId].push(e);});var m=a(n=c(l)).call(n,function(e){return{sessionId:e,msgs:l[e]};}),p=E.asyncPool(50,m,function(e){return H.call(r,e.sessionId,e.msgs,t);});this.syncPromiseArray.push(p);},O.completeMsg=function(e){return e.from=this.account,e.fromNick=this.myInfo&&this.myInfo.nick,e.fromClientType="Web",e.fromDeviceId=j.deviceId,e.time||(e.time=+new Date()),e;},O.amendMsg=function(e){if("team"===e.scene){var t=E.get(this.myTeamMembersMap,e.to+".nickInTeam");t&&(e.fromNick=t);}else if("superTeam"===e.scene){var n=E.get(this.mySuperTeamMembersMap,e.to+".nickInTeam");n&&(e.fromNick=n);}return e;},O.onMsgs=function(e){var t=this,n=t.reporterHook.getSafeClock(),i=t.message.reverseMsgs(e.content.msgs,{mapper:function mapper(i){var s=function(e){for(var t=1;t<arguments.length;t++){var n,i,s=null!=arguments[t]?arguments[t]:{};t%2?o(n=A(Object(s),!0)).call(n,function(t){r(e,t,s[t]);}):T?S(e,T(s)):o(i=A(Object(s))).call(i,function(t){M(e,t,b(s,t));});}return e;}({},i);if(s.__receiveTime=e.__receiveTime,s.__handleTime=n,s.__clientExt)try{s.__clientExt=JSON.parse(s.__clientExt);}catch(e){t.logger.warn("IMProtocolFn:onMsg __clientExt parse failed ".concat(s.__clientExt));}return t.handleMsg(s),s;}});t.pushMsgDelay(i);},O.onMsg=function(e,t){var n;if(e.content.msg.attach){var r=null;try{r=JSON.parse(e.content.msg.attach);}catch(e){}if(!this.mixStorePolicy)try{this.mixStorePolicy=JSON.parse(localStorage.getItem("NIM-AllMixStorePolicy"))[this.options.appKey];}catch(e){this.logger.error("error:","get last mixStorePolicy failed",e);}if(r&&r.url&&this.mixStorePolicy.s3Policy&&this.mixStorePolicy.s3Policy.dlcdns&&this.mixStorePolicy.s3Policy.dlcdns.length){var o,i=w(this.mixStorePolicy.s3Policy.dlcdns);try{for(i.s();!(o=i.n()).done;){var s,a=o.value;u(s=r.url).call(s,a)>=0&&(r.isS3=!0,a!==this.mixStorePolicy.s3Policy.dlcdn&&(r.url=r.url.replace(a,this.mixStorePolicy.s3Policy.dlcdn)));}}catch(e){i.e(e);}finally{i.f();}}e.content.msg.attach=l(r);}var c=m(n=this.message).call(n,e.content.msg);if(c.__receiveTime=e.__receiveTime,c.__handleTime=this.reporterHook.getSafeClock(),E.get(e,"content.msg.__clientExt"))try{c.__clientExt=JSON.parse(e.content.msg.__clientExt);}catch(t){this.logger.warn("IMProtocolFn:onMsg __clientExt parse failed ".concat(e.content.msg.__clientExt));}t&&(c.filter=!0),"syncSendMsg"!==e.cmd||c.from!==c.to?(this.pushMsgDelay([c]),this.syncing?(this.logger.info("msg::onMsg:is in syncing ..."),this.unhandledMsgs.push({type:"onMsg",msg:c})):this.handleMsg(c)):this.logger.warn("onMsg::syncSendMsg to self, so ignore",c.idClient,c.idServer);},O.onBroadcastMsgs=function(e){var t=e.content.broadcastMsgs;t=p(t).call(t,function(e,t){return e.broadcastId-t.broadcastId;}),this.putBroadcastMsgs(t);},O.onBroadcastMsg=function(e){var t=e.content.broadcastMsg;t.time=t.timestamp,this.syncing?this.unhandledMsgs.push({type:"onBroadcastMsg",msg:t}):t&&this.putBroadcastMsg(t);},O.pushMsgTask=function(e){this.msgPromise=this.msgPromise.then(function(){return e();});},O.pushMsgDelay=function(e){if(e&&e.length>0){var t=this;if(t.msgStatEnable&&!F.isWeixinApp){var n,r=a(e).call(e,function(e){return{appkey:t.options.appKey,accid:e.to,fromAccid:e.from,msgId:e.idServer,serverTime:e.time,receiveTime:t.reporterHook.getNTPTime(),sessionId:t.sdkSession,platform:"web",sdk_ver:F.info.version,manufactor:B.name+" "+B.version};});t.msgDelayArr=d(n=t.msgDelayArr).call(n,r),t.msgDelayArr.length>5&&t.doReportMsgDelay();}}},O.doReportMsgDelay=function(){var e,t=l(this.msgDelayArr);(this.msgDelayArr&&this.msgDelayArr.length>0&&(L.sendBeacon("https://statistic.live.126.net/statics/report/im/sdk/msgreceived",t),this.msgDelayArr=[]),this.msgDelayTimer&&clearTimeout(this.msgDelayTimer),this.socket)&&(this.msgDelayTimer=f(g(e=this.doReportMsgDelay).call(e,this),1e4));},O.handleMsg=function(e){var t=this,n=t.db,r=e.time;t.markMsgRead(e),t.msgPromise=t.msgPromise.then(function(){return t.putMsg(e,"onMsg");}).then(function(){var o;return t.logger.info(d(o="msg::handleMsg:putMsg: done ".concat(e.idServer," ")).call(o,e.idClient)),n.enable?"superTeam"===e.scene?n.updateSuperTeamRoamingMsgTimetag(r):n.updateRoamingMsgTimetag(r):(t.timetags["superTeam"===e.scene?"superTeamRoamingMsgs":"roamingMsgs"]=r,s.resolve());}).then(function(){if(e)return t.checkUserUpdate(e);}).then(function(){if(e){var n=e.type;switch(t.logger.info("msg::handleMsg:checkUserUpdate: "+e.scene+" "+n+" msg"+("notification"===n?" "+e.attach.type:"")),n){case"notification":return t.onTeamNotificationMsg(e);}}}).then(function(){e&&!e.ignore&&(t.logger.info("msg::handleMsg:onmsg: ",e.idClient,e.idServer),f(function(){var n="p2p"===e.scene;if(F.isBrowser&&"out"!==e.flow){var r={msgId:e.idServer,clientId:e.idClient,receiveTime:t.reporterHook.getNTPTime(e.__receiveTime),serverTime:e.time,callbackTime:t.reporterHook.getNTPTime(),preHandleTime:t.reporterHook.getNTPTime(e.__handleTime),fromAccid:e.from,toAccid:t.options.account,type:t.message.sceneMap[e.scene],tid:n?"":e.to,result:200,failReason:"",rt:h(t.reporterHook.getSafeClock()-e.__receiveTime)},o=E.get(e,"__clientExt.statistics.apiCallingTime"),i=E.get(e,"__clientExt.statistics.sendTime");o&&i&&(r.apiCallingTime=o,r.sendTime=i,r.attachUploadDuration=E.get(e,"__clientExt.statistics.attachUploadDuration")||0),t.reporter&&t.reporter.report("msgReceive",r,!0);}delete e.__receiveTime,delete e.__handleTime,delete e.__clientExt,t.options.onmsg(E.copy(e));},0));}).catch(function(e){e.callFunc="msg::handleMsg",t.onCustomError("消息处理错误",e);});},O.putMsg=function(e,t){if(E.isArray(e)||(e=[e]),i(e[0]))return s.resolve(e);var n,r=this,c=r.db,u=c.enable,l=s.resolve(),m=r.message.Message.getLastMsg(e),p=m.flow,f=r.genSessionByMsgs(e);h(f);var g=[];function h(e){"roamingMsgs"!==t&&"offlineMsgs"!==t||r.cacheSyncedSession(e);}return l=(l=(l=l.then(function(){var n;u||r.options.autoMarkRead||"roamingMsgs"===t||!f||(r.sessionUnreadMsgs=r.sessionUnreadMsgs||{},r.sessionUnreadMsgs[f.id]=r.sessionUnreadMsgs[f.id]||[],r.sessionUnreadMsgs[f.id]=d(n=r.sessionUnreadMsgs[f.id]).call(n,i(e).call(e,function(e){try{return r.options.shouldCountNotifyUnread(e);}catch(e){throw r.logger.error("userOption:shouldCountNotifyUnread function error",e),e;}})));return"offlineMsgs"===t||"roamingMsgs"===t?s.reject(e):u?c.putMsg(e):e;}).then(function(t){var n=[];return o(e).call(e,function(e){r.checkMsgUnique(e)&&n.push(e);}),e=n,g=u?t:e,s.resolve(e);})).then(function(e){return e.length&&u&&f?new s(function(t){c.getSessions({sessionId:f.id}).then(function(n){if(n&&n.lastMsg){var r=n.lastMsg;f.lastMsg&&f.lastMsg.time<r.time&&(f.lastMsg=r);}g&&g.length?f?c.putSession(f).then(function(e){t(e);}):t(n):(g=e,t(n));});}):s.resolve(f);})).then(function(e){if(f&&g.length){n=m.sessionId!==r.currSessionId;var i="roamingMsgs"===t,s=r.options.syncSessionUnread,l=f.id,d=r.getSessionInCache(l,!0)||{},y=d.ack||0;if("offlineMsgs"===t||i&&s||"onMsg"===t&&"in"===p&&n){var v;if(u&&e){var b=d.unread||0;(f=e).unread=b,y=y||f.ack||0;}else(e=d)&&(f.unread=e.unread||0);h(f),f.unread=f.unread||0;var T=0;o(g).call(g,function(e){var t;try{t=r.options.shouldCountNotifyUnread(e);}catch(e){throw r.logger.error("userOption:shouldCountNotifyUnread function error",e),e;}var n=("notification"!==e.type||"notification"===e.type&&t)&&(R(e.isUnreadable)||e.isUnreadable);if(n&&s&&(n=e.time>y&&"out"!==e.flow),n&&(T++,s&&!u)){var o=d.unreadMsgs||[];o.push(e),f.unreadMsgs=o;}}),f.unread+=T;var S=E.secureOutput("session",f);if(S.unreadMsgs&&(S.unreadMsgs=a(v=S.unreadMsgs).call(v,function(e){return e&&e.idServer;})),r.logger.info("msg::putMsg:updateSession: ",S),h(f),u)return c.updateSession({id:f.id,unread:f.unread});}}}),"onMsg"===t&&(l=l.then(function(){e.length&&f&&(r.onUpdateSession(f),r.options.syncSessionUnread&&!n&&r.api.resetSessionUnread(r.currSessionId));})),l.then(function(){return s.resolve(e);}).catch(function(e){return e&&e.length?s.resolve(e):s.reject(e);});},O.putBroadcastMsgs=function(e){var t=this,n=t.db,r=e.length;if(r>0){if(t.doMarkBroadcastMsgsRead(e),n.enable){var o=e[r-1].broadcastId;return n.updateBroadcastMsgTimetag(o),n.putBroadcastMsg(e).then(function(){return f(function(){t.doMarkMsgsRead(),t.options.onbroadcastmsgs(E.copy(e));},0),s.resolve(e);});}f(function(){t.options.onbroadcastmsgs(E.copy(e));},0);}return e;},O.putBroadcastMsg=function(e){var t=this,n=t.db;return t.doMarkBroadcastMsgsRead([e]),n.enable?(e.broadcastId&&n.updateBroadcastMsgTimetag(e.broadcastId),n.putBroadcastMsg(e).then(function(){return f(function(){t.options.onbroadcastmsg(E.copy(e));},0),s.resolve(e);})):(f(function(){t.options.onbroadcastmsg(E.copy(e));},0),e);},O.doMarkBroadcastMsgsRead=function(e){e=a(e).call(e,function(e){return e.broadcastId;}),this.sendCmd("batchMarkRead",{sid:7,cid:17,ids:e});},O.cacheSyncedSession=function(e){if(e&&this.syncResult){e=y({},e),this.syncResult.sessions=this.syncResult.sessions||{};var t=e.id,n=this.syncResult.sessions[t]||{};n&&n.ack>e.ack&&(e.ack=void 0),n&&n.msgReceiptTime>e.msgReceiptTime&&(e.msgReceiptTime=void 0);var r=E.get(n,"lastMsg.time"),o=E.get(e,"lastMsg.time");r&&o&&r>o&&(e.lastMsg=n.lastMsg),this.syncResult.sessions[t]=y(n,e),this.syncResult.sessions[t]=y({},this.mergeSession(this.syncResult.sessions[t]));}},O.checkMsgUnique=E.genCheckUniqueFunc("idClient"),O.revokeMsgUniqueCheck=function(e){this.uniqueSet&&this.uniqueSet.idClient&&(this.uniqueSet.idClient[e]=!1);},O.storeSendMsg=function(e){if(!this.syncing){var t=this.putMsg(e,"sendMsg");return this.msgPromise=this.msgPromise.then(function(){return t;}),t;}this.unhandledMsgs.push({type:"sendMsg",msg:e});},O.updateSendMsgError=function(e){if(!this.syncing){var t=this.updateMsg(e);return this.msgPromise=this.msgPromise.then(function(){return t;}),t;}this.unupdatedMsgs.push(e);},O.onSendMsg=function(e,t){var n,r,o=this,i=e.content&&e.content.msg,a=e.obj&&e.obj.msg||i;if(a){if(this.logger.warn(d(n=d(r="sendMsg::end: ".concat(i&&i.idServer," ")).call(r,a.idClient," ")).call(n,e&&e.raw&&e.raw.ser)),e.obj)u();else{var c=o.db;c&&c.enable&&c.getMsgByIdClient(a.idClient).then(function(e){e&&(a=e,u(!1));}).catch(function(){return u();});}}else this.logger.error("sendMsg::error::get msg failed, msg empty");function u(){var n,r=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];o.completeMsg(a);var c=e.error&&7101===e.error.code;e.error&&!c||(a.idServer=i.idServer,a.time=+i.time,i.yidunAntiSpamRes&&(a.yidunAntiSpamRes=i.yidunAntiSpamRes),i.callbackExt&&(a.callbackExt=i.callbackExt)),c&&(a.isInBlackList=!0),e.error?a.status="fail":a.status="success",a=r?m(n=o.message).call(n,a):a,a=o.amendMsg(a),t&&(a.filter=!0),e.obj=a,o.syncing?o.unupdatedMsgs.push(a):o.msgPromise=s.all([o.msgPromise,e.obj.promise]).then(function(e){return e.length||(a.resend=!0),o.updateMsg(a).then(function(){return o.options.syncSessionUnread&&o.currSessionId===a.sessionId&&o.api.resetSessionUnread(o.currSessionId),o.resolveMsgReceiptTask(a),a;});}).catch(function(e){o.logger.error("onSendMsg::dealMsg error",e);});}},O.updateLocalMsg=function(e){var t=this.updateMsg(e);return this.msgPromise=this.msgPromise.then(function(){return t;}),t;},O.updateMsg=function(e){if(i(e)||this.options.shouldIgnoreMsg(e))return s.resolve(e);var t=this,n=t.db,r="success"===e.status,o=D.genSessionByMsg(e),a=!!e.isLocal;return t.onUpdateSession(o),n.enable?n.updateMsg(e).then(function(t){var i=n.updateSession(o),c=s.resolve();return r&&t&&!a&&(c="superTeam"===e.scene?n.updateSuperTeamRoamingMsgTimetag(t.time):n.updateRoamingMsgTimetag(t.time)),s.all([i,c]);}).catch(function(e){t.logger.error("updateMsg error",e);}):(r&&!a&&(t.timetags.roamingMsgs=e.time),s.resolve(e));},O.updateRoamingMsgTimetag=function(e){var t=this.db;return t.enable?t.updateRoamingMsgTimetag(e):(this.timetags.roamingMsgs=e,s.resolve(e));},O.checkUserUpdate=function(e){var t=this,n=e.from;return t.logger.info("handleMsg::checkUserUpdate: ",n,t.account),n===t.account?s.resolve():new s(function(r){var o=t.userSet[n];if(o){var i=+o.updateTime,s=+e.userUpdateTime;!isNaN(i)&&!isNaN(s)&&E.isNumber(i)&&E.isNumber(s)&&i<s?a():r();}else a();function a(){t.api.getUser({account:n,sync:!0,done:function done(e,n){e||f(function(){t.logger.log("user::checkUserUpdate: onupdateuser",n&&n.account),t.options.onupdateuser(n);},0),r();}});}});},O.processUnsettledMsgs=function(){var e,t,n=this;o(e=n.unhandledMsgs).call(e,function(e){var t=e.msg;switch(e.type){case"onMsg":n.handleMsg(t);break;case"sendMsg":n.msgPromise=n.msgPromise.then(function(){return n.putMsg(t);});break;case"onBroadcastMsg":n.msgPromise=n.msgPromise.then(function(){return n.putBroadcastMsg(t);});}}),o(t=n.unupdatedMsgs).call(t,function(e){n.msgPromise=n.msgPromise.then(function(){return n.updateMsg(e);});}),n.resetUnsettledMsgs();},O.onTeamNotificationMsg=function(e){var t=e.attach,n=t.type,r=e.from,o=e.to,i=e.time,s=t.team,a=t.account,c=t.accounts;switch(n){case"updateTeam":return s.updateTime=i,this.onUpdateTeam(s);case"addTeamMembers":return this.onAddTeamMembers(e,s,c);case"removeTeamMembers":return this.onRemoveTeamMembers(s,o,c);case"acceptTeamInvite":return this.onAddTeamMembers(e,s,[r]);case"passTeamApply":return this.onAddTeamMembers(e,s,[a]);case"addTeamManagers":return this.updateTeamManagers(e,o,c,!0,i);case"removeTeamManagers":return this.updateTeamManagers(e,o,c,!1,i);case"leaveTeam":return this.onRemoveTeamMembers(s,o,[r]);case"dismissTeam":return this.onDismissTeam(o,i);case"transferTeam":return this.transferTeam(e,s,r,a);case"updateTeamMute":return this.onUpdateTeamMembersMute(e,s,[a],t.mute);case"updateSuperTeam":return s.updateTime=i,this.onUpdateSuperTeam(s);case"addSuperTeamMembers":return this.onAddSuperTeamMembers(e,s,c);case"passSuperTeamApply":return this.onAddSuperTeamMembers(e,s,[a]);case"removeSuperTeamMembers":return this.onRemoveSuperTeamMembers(s,o,c);case"leaveSuperTeam":return this.onRemoveSuperTeamMembers(s,o,[r]);case"dismissSuperTeam":return this.onDismissSuperTeam(o,i);case"transferSuperTeam":return this.transferSuperTeam(e,s,r,a);case"addSuperTeamManagers":return this.updateSuperTeamManagers(e,o,c,!0,i);case"removeSuperTeamManagers":return this.updateSuperTeamManagers(e,o,c,!1,i);case"updateSuperTeamMembersMute":return this.onUpdateSuperTeamMembersMute(e,s,c,t.mute);}},O.onAddSuperTeamMembers=function(e,t,n){var r=this.db,o=U.assembleMembers(t,n);e.attach.members=o;var i={team:t,accounts:n,members:o};if(this.logger.info("team::onAddSuperTeamMembers: ".concat(i.team.teamId,", "),i.accounts),this.options.onAddSuperTeamMembers(E.simpleClone(i)),r.enable){var a=r.putSuperTeamMembers(o),c=r.putSuperTeam(t);return s.all([a,c]);}},O.onRemoveSuperTeamMembers=function(e,t,n){var r=this.db,o={team:e,teamId:t,accounts:n};if(this.logger.info("team::onRemoveSuperTeamMembers: ".concat(t,", "),o.accounts),this.options.onRemoveSuperTeamMembers&&this.options.onRemoveSuperTeamMembers(E.simpleClone(o)),e&&r.enable){if(-1===u(n).call(n,this.account)){var i=r.removeSuperTeamMembersByAccounts(t,n),a=s.resolve();return e&&(a=r.putSuperTeam(e)),s.all([i,a]);}return r.leaveSuperTeam(t);}},O.onDismissSuperTeam=function(e,t){var n=this.db,r={teamId:e};if(this.logger.info("team::onDismissSuperTeam:",e),this.options.onDismissSuperTeam(r),n.enable)return n.dismissSuperTeam(e,t);},O.onAddTeamMembers=function(e,t,n){var r=this,o=r.db,i=t.teamId,a=N.assembleMembers(t,n);e.attach.members=a;var c={team:t,accounts:n,members:a};if(r.logger.info("team::onAddTeamMembers: ",i,n),r.options.onAddTeamMembers(E.simpleClone(c)),o.enable){var l,m=o.putTeam(t);return-1===u(n).call(n,r.account)?l=o.putTeamMembers(a):(r.logger.log("team::onAddTeamMembers: user join team",i),m=new s(function(e){r.api.getTeamMembers({teamId:i,sync:!0,done:function done(){e();}});})),s.all([l,m]);}},O.onRemoveTeamMembers=function(e,t,n){var r=this.db,o={team:e,teamId:t,accounts:n};if(this.logger.info("team::onRemoveTeamMembers: ".concat(t),n),this.options.onRemoveTeamMembers(E.simpleClone(o)),e&&r.enable){if(-1===u(n).call(n,this.account)){var i=r.removeTeamMembersByAccounts(t,n),a=s.resolve();return e&&(a=r.putTeam(e)),s.all([i,a]);}return r.leaveTeam(t);}},O.updateTeamManagers=function(e,t,n,r,o){var i=this.db,c=e.attach.members=a(n).call(n,function(e){return{id:N.genId(t,e),type:r?"manager":"normal",updateTime:o};}),u={teamId:""+t,memberUpdateTime:o};e.attach.team=u;var l={team:u,accounts:n,isManager:r,members:c};if(this.logger.info("team::updateTeamManagers:",t,n,r),this.options.onUpdateTeamManagers(E.simpleClone(l)),i.enable){var m=i.updateTeam(u),p=i.updateTeamManagers(t,n,r,o);return s.all([m,p]);}},O.updateSuperTeamManagers=function(e,t,n,r,o){var i=this.db,c=e.attach.members=a(n).call(n,function(e){return{id:N.genId(t,e),teamId:t,account:e,type:r?"manager":"normal",updateTime:o};}),u={teamId:""+t,memberUpdateTime:o};e.attach.team=u;var l={team:u,accounts:n,isManager:r,members:c};if(this.logger.info("team::updateSuperTeamManagers:",t,n,r),this.options.onUpdateSuperTeamManagers(E.simpleClone(l)),i.enable){var m=i.updateSuperTeam(u),p=i.updateSuperTeamMembers(c);return s.all([m,p]);}},O.onDismissTeam=function(e,t){var n=this.db,r={teamId:e};if(this.logger.info("team::onDismissTeam:",e),this.options.onDismissTeam(r),n.enable)return n.dismissTeam(e,t);},O.transferTeam=function(e,t,n,r){var o=this.db,i=t.teamId,s=t.memberUpdateTime,a={id:N.genId(i,n),type:"normal",updateTime:s},c={id:N.genId(i,r),type:"owner",updateTime:s};e.attach.members=[a,c];var u={team:t,from:a,to:c};if(this.logger.info("team::transferTeam: from to",i,n,r),this.options.onTransferTeam(E.simpleClone(u)),o.enable)return o.transferTeam(t,n,r);},O.transferSuperTeam=function(e,t,n,r){var o=this.db,i=t.teamId,s=t.memberUpdateTime,a={teamId:i,type:"normal",account:n,updateTime:s},c={teamId:i,type:"owner",account:r,updateTime:s};e.attach.members=[a,c];var u={team:t,from:a,to:c};if(this.logger.info("team::transferSuperTeam: from to ",i,n,r),this.options.onTransferSuperTeam(E.simpleClone(u)),o.enable)return o.transferSuperTeam(t,a,c);},O.onUpdateTeamMembersMute=function(e,t,n,r){var o=this.db,i=a(n).call(n,function(e){return{id:N.genId(t.teamId,e),account:e,teamId:t.teamId,mute:r,updateTime:t.memberUpdateTime};});e.attach.members=i;var c={team:t,accounts:n,members:i,mute:r};if(this.logger.info("team::onUpdateTeamMembersMute:",t.teamId,n,r),this.options.onUpdateTeamMembersMute(E.simpleClone(c)),o.enable){var u=o.updateTeamMembers(i),l=o.putTeam(t);return s.all([u,l]);}},O.onUpdateSuperTeamMembersMute=function(e,t,n,r){var o=this.db,i=a(n).call(n,function(e){return{id:U.genId(t.teamId,e),account:e,teamId:t.teamId,mute:r,updateTime:t.memberUpdateTime};});e.attach.members=i;var c={team:t,accounts:n,members:i,mute:r};if(this.logger.info("team::onUpdateSuperTeamMembersMute:",t.teamId,n,r),this.options.onUpdateSuperTeamMembersMute(E.simpleClone(c)),o.enable){var u=o.updateSuperTeamMembers(i),l=o.putSuperTeam(t);return s.all([u,l]);}},O.onHistoryMsgs=function(e){e.error||(e.obj.msgs=this.message.reverseMsgs(e.content.msgs));},O.onmsgFtsInServer=function(e){if(!e.error){var t=this.message.reverseMsgs(e.content.msgs);e.obj.msgs=t,e.content.msgs=t;}},O.isFilterMsgs=function(e){return!!i(e[0]);},O.splitMsgs=function(e,t,n,r){o(e).call(e,function(e){if(i(e))r.push(e);else switch(e.scene){case"p2p":t.push(e);break;case"team":n.push(e);}});},O.markMsgRead=function(e,t){E.isArray(e)||(e=[e]);if(this.db.enable||this.options.autoMarkRead||t){var n=a(e).call(e,function(e){return{flag:"msg",idServer:e.idServer,scene:e.scene,filter:i(e),type:e.type,attachType:e.attach&&e.attach.type};});this.msgAckBufferManager.add(n);}},O.markSysMsgRead=function(e,t){E.isArray(e)||(e=[e]);if(this.db.enable||this.options.autoMarkRead||t){var n=a(e).call(e,function(e){return{flag:"systemMsg",idServer:e.idServer,scene:e.scene,filter:i(e),type:e.type};});this.msgAckBufferManager.add(n);}},O.handleMsgsAck=function(e){var t,n=this,r={p2pSysMsgs:{sid:7,cid:3,msgs:[]},p2pMsgs:{sid:7,cid:2,msgs:[]},superTeamSysMsgs:{sid:21,cid:19,msgs:[]},teamMsgs:{sid:8,cid:3,msgs:[]},filterSysMsgs:{sid:101,cid:3,msgs:[]},filterMsgs:{sid:101,cid:2,msgs:[]},netcallMsgs:{sid:9,cid:11,msgs:[]}};o(e).call(e,function(e){/^(netcallBill|netcallMiss|netcallReject)$/.test(e.attachType)?r.netcallMsgs.msgs.push(e):i(e)?"systemMsg"===e.flag?r.filterSysMsgs.msgs.push(e):r.filterMsgs.msgs.push(e):"systemMsg"!==e.flag?"p2p"===e.scene?r.p2pMsgs.msgs.push(e):"team"===e.scene&&r.teamMsgs.msgs.push(e):"superTeam"===e.scene?r.superTeamSysMsgs.msgs.push(e):r.p2pSysMsgs.msgs.push(e);}),o(t=c(r)).call(t,function(e){return n.doMarkMsgsRead(r[e].sid,r[e].cid,r[e].msgs);});},O.doMarkMsgsRead=function(e,t,n){n&&n.length&&(this.logger.log("markMsgRead::batchMarkRead",e,t,n),this.sendCmd("batchMarkRead",{sid:e,cid:t,ids:a(n).call(n,function(e){return e.idServer;})}));};},function(e,t,n){var r=n(58),o=n(6),i=n(2),s=n(5),a=n(17),c=n(3),u=n(35),l=n(59),m=n(60),p=n(61),d=n(62),f=n(46);function g(e,t){var n=s(e);if(l){var r=l(e);t&&(r=a(r).call(r,function(t){return m(e,t).enumerable;})),n.push.apply(n,r);}return n;}function h(e){for(var t=1;t<arguments.length;t++){var n,o,s=null!=arguments[t]?arguments[t]:{};t%2?i(n=g(Object(s),!0)).call(n,function(t){r(e,t,s[t]);}):p?d(e,p(s)):i(o=g(Object(s))).call(o,function(t){f(e,t,m(s,t));});}return e;}var y=n(32).fn,v=n(682),b=n(684);function T(e,t,n){var r=this,o=this.timetags&&this.timetags.sync;this.db.enable&&o&&t&&this.db.getMsgByIdClient(e).then(function(e){if(e&&!(e.commentTimetag&&e.commentTimetag<=o&&e.time<=o)){if(e.commentTimetag=t.time,e.comments=e.comments||[],n){var i;e.comments=a(i=e.comments).call(i,function(e){return e.body!==t.body||e.from!==t.from;});}else{for(var s,c=0;c<e.comments.length;c++){if(e.comments[c].from===t.from&&e.comments[c].body===t.body){e.comments[c]=t,s=!0;break;}}s||e.comments.push(t);}var u={idClient:e.idClient,comments:e.comments,commentTimetag:e.commentTimetag};r.db.updateMsg(u);}});}function S(e){e.scene=this.message.sceneReverseMap[+e.scene]||e.scene,e.time=+e.time;}y.processMsgExtend=function(e){switch(e.cmd){case"getThreadMsgs":this.onGetThreadMsgs(e);break;case"getMsgsByIdServer":this.onGetMsgsByIdServer(e);break;case"addQuickComment":this.changeQuickComment(e);break;case"deleteQuickComment":this.changeQuickComment(e,!0);break;case"onQuickComment":case"syncAddQuickComment":this.onQuickComment(e);break;case"onDeleteQuickComment":case"syncDeleteQuickComment":this.onQuickComment(e,!0);break;case"getQuickComments":this.getQuickComments(e);break;case"addCollect":case"updateCollect":this.addCollect(e);break;case"deleteCollects":this.deleteCollects(e);break;case"getCollects":this.getCollects(e);break;case"addStickTopSession":case"syncAddStickTopSession":this.onChangeStickTopSession(e,"add");break;case"updateStickTopSession":case"syncUpdateStickTopSession":this.onChangeStickTopSession(e,"update");break;case"deleteStickTopSession":case"syncDeleteStickTopSession":this.onChangeStickTopSession(e,"delete");break;case"addMsgPin":case"onAddMsgPin":case"syncAddMsgPin":this.pinMsgChange(e,"add");break;case"updateMsgPin":case"onUpdateMsgPin":case"syncUpdateMsgPin":this.pinMsgChange(e,"update");break;case"deleteMsgPin":case"onDeleteMsgPin":case"syncDeleteMsgPin":this.pinMsgChange(e,"delete");break;case"getMsgPins":this.getMsgPins(e);}},y.onGetThreadMsgs=function(e){if(!e.error){var t;e.obj.msgs=this.message.reverseMsgs(e.content.msgs),e.obj.threadMsg=o(t=this.message).call(t,e.content.threadMsg);var n=e.content.threadMsgsMeta||{};e.obj.total=n.total,e.obj.timetag=n.lastMsgTime;}},y.onGetMsgsByIdServer=function(e){e.error||(e.obj.msgs=this.message.reverseMsgs(e.content.msgs));},y.changeQuickComment=function(e,t){e.error||(e.obj.comment.time=e.content.timetag,e.obj.comment=o(v).call(v,e.obj.comment),S.call(this,e.obj.msg),T.call(this,e.obj.msg.idClient,e.obj.comment,t));},y.onQuickComment=function(e,t){if(e.content){var n=e.content,r=n.comment,i=n.msg;r&&i&&(S.call(this,i),r=o(v).call(v,r),t?this.options.onDeleteQuickComment(e.content.msg,r):this.options.onQuickComment(e.content.msg,r),T.call(this,i.idClient,r,t));}},y.getQuickComments=function(e){var t,n=this;if(!e.error){var r=e.obj.idMap,a=e.obj.indexMap,c=e.content&&e.content.commentRes||[];i(c).call(c,function(e){var t=[],a=n.parser.unserializeMap.comment;if(1==+e.modify)try{t=JSON.parse(e.detail);}catch(e){n.logger.warn("getQuickComments parse detail error",e);}if(i(t).call(t,function(e,n){var r,c={};i(r=s(e)).call(r,function(t){c[a[t]]=e[t];}),c=o(v).call(v,c),t[n]=c;}),e.timestamp=+e.timestamp,r[e.idClient]){var c={idClient:e.idClient,commentTimetag:e.timestamp};r[e.idClient].commentTimetag=e.timestamp,1==+e.modify&&(r[e.idClient].comments=t,c.comments=t),n.db.enable&&n.db.updateMsg(c);}else r[e.idClient]={idServer:e.idServer,idClient:e.idClient,comments:t,commentTimetag:e.timestamp,scene:n.message.sceneReverseMap[e.scene]||e.scene};}),e.obj=[],i(t=s(a)).call(t,function(t){e.obj[a[t]]=r[t];});}},y.addCollect=function(e){e.error||(e.obj.collect=o(b).call(b,e.content.collect));},y.deleteCollects=function(e){e.error||(e.obj.deleteNum=e.content.deleteNum);},y.getCollects=function(e){if(!e.error){var t=[],n=e.content.collectList||[];i(n).call(n,function(e){t.push(o(b).call(b,e));}),e.obj.collectList=t,e.obj.total=e.content.total;}},y.onChangeStickTopSession=function(e,t){var n=this;if(!e.error){var r=e.content.stickTopSession||e.obj.stickTopSession||{},o=e.content.timetag||+r.updateTime,i=r.id.split("|");"super_team"===i[0]&&(i[0]="superTeam"),r={id:i.join("-"),scene:i[0],to:i[1],topCustom:r.topCustom||""},"delete"===t?r.isTop=!1:"add"===t&&(r.isTop=!0),r=this.onUpdateSession(r),e.obj&&(e.obj.stickTopSession=r),this.db.enable&&(this.db.updateSession(r).then(function(e){e||n.db.putSession(r);}),this.db.updateTimetag("stickTopSessions",o));}},y.pinMsgChange=function(e,t){var n=this;if(!e.error){e.content=e.content||{};var r=this,o=this.db,i=e.obj&&e.obj.msg,s=e.content.msg||i||{},a=e.content.pinTag||e.obj.pinTag,u=e.content.timetag||+a.updateTime,l=c.resolve();S.call(this,s),o.enable&&(l=o.getMsgByIdClient(s.idClient)),a.createTime&&(a.createTime=+a.createTime),a.updateTime&&(a.updateTime=+a.updateTime),l.then(function(l){return s=l||s,l?s=l:s.sessionId=s.scene+"-"+n.message.Message.getMsgTarget(s,n.account),i?(e.obj.msg=s,e.obj.pinTag=a):n.options.onPinMsgChange({msg:s,pinTag:a},t),function(){if(!o.enable)return;o["delete"===t?"deleteMsgPin":"putMsgPin"](h(h({},s),{},{pinFrom:a.pinFrom,pinCustom:a.pinCustom})).then(function(){var e="pin-"+s.sessionId,t=r.timetags.sync;return o.getTimetag(e).then(function(n){return n>t?o.updateTimetag(e,u):c.resolve();});}).catch(function(e){r.logger.error("msgExtend::pinMsgChange:error",e);});}(),c.resolve;}).then(function(){}),e.promise=l;}},y.getMsgPins=function(e){var t=this;if(!e.error){var n=this.db,r=e.content||{};if(r.pins=r.pins||[],r.modify){var o,s=[];if(n.enable)n.updateTimetag("pin-"+e.obj.id,r.timetag),i(o=r.pins).call(o,function(t){t.sessionId=e.obj.id,s.push(n.getMsgByIdClient(t.idClient));});e.promise=c.all(s).then(function(o){var s;i(s=r.pins).call(s,function(n,r){o[r]?u(n,o[r]):(n.sessionId=e.obj.id,S.call(t,n));}),e.obj.pins=r.pins,n.enable&&n.deleteMsgPins(e.obj.id).then(function(){return n.putMsgPins(r.pins);}).catch(function(e){t.logger.error("msgExtend::getMsgPins:change db error",e);});});}else n.enable?(n.updateTimetag("pin-"+e.obj.id,r.timetag),e.promise=n.getMsgPins(e.obj.id).then(function(t){e.obj.pins=t||[];})):e.obj.pins=[];}};},function(e,t,n){var r=n(743);e.exports=r;},function(e,t,n){n(744);var r=n(11);e.exports=r.Number.isInteger;},function(e,t,n){n(1)({target:"Number",stat:!0},{isInteger:n(745)});},function(e,t,n){var r=n(29),o=Math.floor;e.exports=Number.isInteger||function(e){return!r(e)&&isFinite(e)&&o(e)===e;};},function(e,t,n){var r=n(109),o=n(3),i=n(2),s=n(9),a=["time","from"],c=n(32).fn,u=n(0);c.onOfflineMsgReceipts=function(e){var t,n=this,r=n.db,s=e.content.msgReceipts,a=[],c=o.resolve();this.logger.info("onOfflineMsgReceipts",s),i(s).call(s,function(e){t={id:"p2p-"+e.from,msgReceiptTime:+e.time},n.cacheSyncedSession(t);}),n.syncResult.msgReceipts=a,r.enable&&(c=r.updateMsgReceiptsTimetag(e.content.timetag)),c.cmd=a,n.syncPromiseArray.push(c);},c.shouldUpdateSessionFromMsgReceipt=function(e,t){return!e||!e.msgReceiptServerTime||t.time>e.msgReceiptServerTime;},c.genSessionFromMsgReceipt=function(e,t){var n=t.time,r={id:t.sessionId,msgReceiptTime:n,msgReceiptServerTime:n};return e&&e.id===t.sessionId&&(r=u.merge({},e,r)),e&&e.updateTime||(r.updateTime=n),r;},c.onMsgReceipt=function(e){var t=this,n=t.db,i=e.content.msgReceipt;i.time=+i.time;var s=i.idClient,c=o.resolve();n.enable&&s&&(c=n.getMsgByIdClient(s)),this.logger.info("onMsgReceipt::",i),c.then(function(e){if(e){if(!e.idServer)return void(t.msgReceiptTasks[s]=i);e.time;}else i.time;i.msgReceiptTime=i.time,i.sessionId="p2p-".concat(i.from),t.updateSessionMsgReceiptTime(i);i.time,i.from;var n=r(i,a);t.options.onMsgReceipts([n]);});},c.resolveMsgReceiptTask=function(e){var t=this.msgReceiptTasks[e.idClient];t&&(t.msgReceiptTime=e.time,this.updateSessionMsgReceiptTime(t));},c.updateSessionMsgReceiptTime=function(e){var t=this.db,n={id:"p2p-"+e.from,msgReceiptTime:e.msgReceiptTime,msgReceiptServerTime:e.time};(this.getSessionInCache(n.id)||{}).msgReceiptTime>=n.msgReceiptTime?this.logger.warn("receive old msgReceiptTime",e):(t.enable&&t.putSession(n),this.onUpdateSession(n));},c.onSendMsgReceipt=function(e){var t;if(!e.error)if(e.obj&&e.obj.msgReceipt){var n=e.obj.msgReceipt,r=+n.time,o=+e.content.msgReceipt.time,i=this.getSessionInCache("p2p-"+n.to);i?(this.logger.info(s(t="sendMsgReceipt on:: param time ".concat(r,", res time ")).call(t,o)),i.msgReceiptSendTime=Math.min(r,o)):this.logger.info("sendMsgReceipt on:: session is undefined or logically deleted, failed to send read receipt");}else this.logger.info("sendMsgReceipt on:: origin msg is missing, it maybe timeout");},c.shouldSendMsgReceipt=function(e){if(e&&"p2p"===e.scene&&"success"===e.status){var t=this.getSessionInCache(e.sessionId);if(t){var n=t.msgReceiptSendTime;return!n||n<e.time;}}return!1;},c.isMsgRemoteRead=function(e){if(e&&"p2p"===e.scene&&"out"===e.flow&&"success"===e.status){var t=this.getSessionInCache(e.sessionId);if(t&&t.msgReceiptTime)return e.time<=t.msgReceiptTime;}return!1;};},function(e,t,n){var r=n(144),o=n(145),i=n(54),s=n(6),a=n(2),c=n(9),u=n(7),l=n(3),m=n(71),p=n(180),d=n(5),f=n(17),g=n(48),h=n(16),y=n(23),v=n(185),b=n(32).fn,T=n(140),S=n(141),M=n(0),k=n(90).EMSyncType;function x(e,t){return C.apply(this,arguments);}function C(){return(C=o(r.mark(function e(t,n){var o,i,s,c,u,l,m,p,d,f,g,h,b,T=this;return r.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(s=(i=this).db,c=[],a(t).call(t,function(e){T.revokeMsgUniqueCheck(e.idClient),c.push(e.idClient);}),i.options.rollbackDelMsgUnread){e.next=14;break;}return e.next=7,s.deleteMsg(c);case 7:if(e.t0=e.sent,e.t0){e.next=10;break;}e.t0=[];case 10:return u=e.t0,u="[object Array]"===Object.prototype.toString.call(u)?u:[u],i.logger.info("msg::_deleteMsgSelfBatchInDb, rollback false, affect: ".concat(u.length," rows")),e.abrupt("return");case 14:return l=!1,m=i.options.cbUpdateSession||y(o=i.updateSessionInDbWithNotify).call(o,i),p=i.getSessionInCache(n)||{id:n},d=p.lastMsg||{},v(c).call(c,d.idClient)&&(l=!0),i.logger.info("msg::_deleteMsgSelfBatchInDb session change before:",n,l,p.unread),e.next=22,s.deleteMsg(c);case 22:if(e.t1=e.sent,e.t1){e.next=25;break;}e.t1=[];case 25:if(f=e.t1,f="[object Array]"===Object.prototype.toString.call(f)?f:[f],i.logger.info("msg::_deleteMsgSelfBatchInDb affect:",f.length," rows"),!l){e.next=34;break;}return e.next=31,s.getMsgs({sessionId:n,limit:1});case 31:g=e.sent,d=g&&g[0]?g[0]:d,p.lastMsg=d;case 34:if(h=!1,p&&p.unread&&(b=p&&p.ack||0,a(f).call(f,function(e){b<e.time&&"in"===e.flow&&(p.unread=p.unread-1,h=!0);})),!l&&!h){e.next=39;break;}return i.logger.info("msg::_deleteMsgSelfBatchInDb session change after:",n,p.unread),e.abrupt("return",m(p));case 39:case"end":return e.stop();}}},e,this);}))).apply(this,arguments);}function I(e,t){t=t||new Date().getTime();var n=this.db,r=this.getSessionInCache(e),o=!1!==this.options.rollbackClearMsgsUnread,i=[];return n.enable&&i.push(n.deleteMsgsBySessionId({sessionId:e,end:t})),o&&r&&(r=this.mergeSession({id:r.id,unread:0,lastMsg:null,unreadMsgs:[]}),r=this.onUpdateSession(r)),n.enable&&o&&r&&i.push(n.updateSession(r)),l.all(i);}b.onDeleteMsg=function(e){var t=this.db;if(delete e.obj.sysMsg,!e.error){var n=e.obj.msg;e.promise=this.deleteLocalMsg(n).then(function(){if(t.enable){var e="superTeam"===n.scene?"deleteSuperTeamMsg":"deleteMsg";t.getTimetag(e).then(function(n){n=n||0,i()+1>=n&&t.updateTimetag(e,i()+1);});}});}},b.onMsgDeleted=function(e,t){if(!e.error){var n=this,r=n.db,o=s(T).call(T,e.content.sysMsg);o=n.processDeleteMsgSysMsg(o),t||n.markSysMsgRead(o),n.deleteLocalMsg(o.msg).then(function(){if(r.enable){var e=t?"deleteSuperTeamMsg":"deleteMsg";r.updateTimetag(e,o.time+1);}n.handleSysMsg(o);});}},b.processDeleteMsgSysMsg=function(e){var t;return e.msg={},a(t=["scene","from","to"]).call(t,function(t){e.msg[t]=e[t];}),e.msg.idClient=e.deletedIdClient,e.msg.idServer=e.deletedIdServer,e.msg.time=e.deletedMsgTime,e.msg.fromNick=e.deletedMsgFromNick,e.opeAccount=e.opeAccount||e.from,e.msg.opeAccount=e.opeAccount,this.message.Message.setExtra(e.msg,this.account),e;},b.onDeleteMsgOfflineRoaming=function(e){if(!e.error){var t,n=this,r=1==+e.content.type?"offline":"roaming",o=T.reverseSysMsgs(e.content.sysMsgs,{mapper:function mapper(e){return n.processDeleteMsgSysMsg(e);}}),i=o&&o[0]&&"superTeam"===o[0].scene;n.logger.info(c(t="msg::onDeleteMsgOfflineRoaming: on delete ".concat(r," ")).call(t,i?"superTeam":""," idServer deletedIdClient deletedIdClient="),u(o).call(o,function(e){var t,n;return c(t=c(n="".concat(e.idServer,"-")).call(n,e.deletedIdServer,"-")).call(t,e.deletedIdClient);})),"offline"===r&&n.markSysMsgRead(o);var s=e.content.timetag;i?(n.timetags.deleteSuperTeamMsg=s,n.syncResult.deleteSuperTeamMsgTimetag=s):(n.timetags.deleteMsg=s,n.syncResult.deleteMsgTimetag=s);var a=n.putSysMsg(o,"offlineSysMsgs").catch(function(e){return n.logger.error("msgDelete::onDeleteMsgOfflineRoaming: ",e),l.reject(e);});a.cmd="deleteMsgSysMsgs "+r,n.syncPromiseArray.push(a),n.syncResult.deleteMsgSysMsgs=n.syncResult.deleteMsgSysMsgs||[],n.syncResult.deleteMsgSysMsgs.push({type:r,sysMsgs:o});}},b.deleteMsgOfflineRoaming=function(e,t){if(!e)return l.resolve();var n=this;n.logger.info("msg::deleteMsgOfflineRoaming: ",u(e).call(e,function(e){var t;return e.type+" "+u(t=e.sysMsgs).call(t,function(e){var t,n;return c(t=c(n="".concat(e.idServer,"-")).call(n,e.deletedIdServer,"-")).call(t,e.deletedIdClient);});}),M.secureOutput("session",t));var r=n.db,o=[];return a(e).call(e,function(e){var i;a(i=e.sysMsgs).call(i,function(e){var i=n.deleteLocalMsg(e.msg,{cbUpdateSession:function cbUpdateSession(e){e=n.mergeSession(e),e=m(S).call(S,e);var o=M.findObjIndexInArray(t,{value:e.id});if(-1!==o&&(t[o]=M.merge({},t[o],e)),r.enable)return r.updateSession(e);}});o.push(i);});}),l.all(o).then(function(){r.enable&&(n.syncResult.deleteMsgTimetag&&r.updateTimetag("deleteMsg",n.syncResult.deleteMsgTimetag),n.syncResult.deleteSuperTeamMsgTimetag&&r.updateTimetag("deleteSuperTeamMsg",n.syncResult.deleteSuperTeamMsgTimetag));});},b.deleteMsgSelf=function(e){if(!e.error){var t=this.db,n=e.obj&&e.obj.deleteMsgSelfTag;if(n){var r=e.content&&e.content.timetag;n.scene=n.scene+""=="1"?"p2p":"team";var o=[this.deleteLocalMsg(n)];r<=this.timetags.deleteMsgSelf||(this.timetags.deleteMsgSelf=r,t.enable&&o.push(t.updateDeleteMsgSelf(r))),e.promise=l.all(o);}}},b.deleteMsgSelfBatch=function(){var e=o(r.mark(function e(t){var n,o,i,s,c,m,g,h;return r.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!t.error){e.next=2;break;}return e.abrupt("return");case 2:if(o=this,i=this.db,(s=t.obj&&t.obj.deleteMsgSelfTags)&&s.length>0){e.next=7;break;}return e.abrupt("return");case 7:if(c=p(s).call(s,function(e,t){var n=t.sessionId;e[n]=e[n]||[],e[n].push(t);var r=o.getSessionInCache(n);return r&&r.lastMsg&&t&&r.lastMsg.idClient===t.idClient&&(r.lastMsg=null,o.onUpdateSession(r)),e;},{}),i.enable){e.next=11;break;}return a(m=d(c)).call(m,function(e){var t=c[e],n=o.getSessionInCache(e);if(o.options.rollbackDelMsgUnread&&n){var r=n.ack||0,i=f(t).call(t,function(e){return r<e.time&&"in"===e.flow;});i.length>0&&n.unread&&(n.unread=n.unread?n.unread-i.length:0,o.onUpdateSession(n));}}),e.abrupt("return",l.resolve());case 11:g=u(n=d(c)).call(n,function(e){var t=c[e];return x.call(o,t,e);}),(h=t.content&&t.content.timetag)<=o.timetags.deleteMsgSelf||(o.timetags.deleteMsgSelf=h,g.push(i.updateDeleteMsgSelf(h))),t.promise=l.all(g);case 15:case"end":return e.stop();}}},e,this);}));return function(t){return e.apply(this,arguments);};}(),b.onDeleteMsgSelf=function(e){var t=this,n=this.db,r=e.content.deleteMsgSelfTag;r.scene=r.scene+""=="1"?"p2p":"team",t.options.onDeleteMsgSelf([r]),t.deleteLocalMsg(r).then(function(){var e=r.deletedTime;return e<=t.timetags.deleteMsgSelf||!n.enable?l.resolve():(t.timetags.deleteMsgSelf=e,n.updateDeleteMsgSelf(e));}).catch(function(e){t.logger.error("onDeleteMsgSelf error",e);});},b.onDeleteMsgSelfBatch=function(e){var t=this;if(!e.error){var n={1:"p2p",2:"team"},r=M.get(e,"content.deleteMsgSelfTags")||[];a(r).call(r,function(e){var r;e.scene=n[e.scene],e.sessionId=c(r="".concat(e.scene,"-")).call(r,t.message.Message.getMsgTarget(e,t.account)),e.deletedTime=g(e.deletedTime),e.time=g(e.time);});var o=M.get(e,"content.deleteMsgSelfTags[0].deletedTime");o=g(o)||0,this.options.onDeleteMsgSelf(r),this.deleteMsgSelfBatch({obj:{deleteMsgSelfTags:r},content:{timetag:o}});}},b.clearServerHistoryMsgs=function(e){if(!e.error){var t=this.db,n=e.obj&&e.obj.clearMsgsParamsWithSync;if(n){var r="p2p"===(n.type&&"2"===n.type.toString()?"team":"p2p")?"p2p-".concat(n.otherAccid):"team-".concat(n.toTid),o=e.content&&g(e.content.timetag);o&&o>this.timetags.sessionHistoryMsgsDelete&&(this.timetags.sessionHistoryMsgsDelete=o,t.enable&&t.updateTimetag("sessionHistoryMsgsDelete",this.timetags.sessionHistoryMsgsDelete)),I.call(this,r,o);}}},b.onClearServerHistoryMsgs=function(e){if(!e.error){var t=this.db,n=e.content&&e.content.sessionHistoryMsgsDeleteTag;if(n){var r="p2p"===(n.type&&"2"===n.type.toString()?"team":"p2p")?"p2p-".concat(n.otherAccid):"team-".concat(n.toTid),o=n.ext,i=g(n.time);this.options.onClearServerHistoryMsgs&&this.options.onClearServerHistoryMsgs([{sessionId:r,time:i,ext:o}]),i<=this.timetags.sessionHistoryMsgsDelete||(this.timetags.sessionHistoryMsgsDelete=i,t.enable&&t.updateTimetag("sessionHistoryMsgsDelete",this.timetags.sessionHistoryMsgsDelete)),I.call(this,r,i);}}},b.syncSessionHistoryMsgsDelete=function(e){if(!e.error){var t=this.db,n=e.content&&e.content.sessionHistoryMsgsDeleteTags;if(n&&n.length>0){var r=u(n).call(n,function(e){return{sessionId:"p2p"===(e.type&&"2"===e.type.toString()?"team":"p2p")?"p2p-".concat(e.otherAccid):"team-".concat(e.toTid),time:g(e.time)};});this.reporterHook.emit("reporter/syncItemComplete",k.kSyncType4_24),this.options.onClearServerHistoryMsgs&&this.options.onClearServerHistoryMsgs(r),this.syncResult.clearServerHistoryMsgs=r;var o=0;a(r).call(r,function(e){e.time>o&&(o=e.time);}),t.enable&&t.updateTimetag("sessionHistoryMsgsDelete",o);}}},b.syncDeleteMsgSelf=function(e){var t=this,n=this.db,r=e.content.deletedMsgs;if(r&&0!==r.length){var o=[];a(r).call(r,function(e){e.scene="1"===e.scene?"p2p":"team",e.deletedTime=+e.deletedTime,e.time=+e.time,o.push(t.deleteLocalMsg(e));}),t.options.onDeleteMsgSelf(r),l.all(o).then(function(){var e=h(r).call(r,-1)[0].deletedTime;if(!(t.timetags.deleteMsgSelf>=e))return t.timetags.deleteMsgSelf=e,n.enable?n.updateDeleteMsgSelf(e):void 0;}).catch(function(e){t.logger.error("syncDeleteMsgSelf error",e);});}},b.deleteLocalMsg=function(){var e=o(r.mark(function e(t,n){var o,i,s,a,c,u,l,m,p,d,f;return r.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(t){e.next=2;break;}return e.abrupt("return");case 2:if(s=(i=this).db,a=(n=n||{}).cbUpdateSession||y(o=i.updateSessionInDbWithNotify).call(o,i),this.revokeMsgUniqueCheck(t&&t.idClient),c=t.sessionId||t.scene+"-"+this.message.Message.getMsgTarget(t,this.account),u=!1,l=i.getSessionInCache(c),i.options.rollbackDelMsgUnread&&l&&(m=l.ack||0,l&&m<t.time&&t.from!==i.account&&l.unread&&(i.logger.info("msgDelete::deleteLocalMsg:cache.getSessions: unread",l.id,l.unread),l.unread=l.unread-1,u=!0)),l&&l.lastMsg&&l.lastMsg.idClient==t.idClient&&(i.logger.info("msgDelete::deleteLocalMsg:cache.getSessions: lastMsg",l.id,l.unread),l.lastMsg=null,u=!0),!s.enable){e.next=39;break;}return p=null,e.next=16,s.getMsgByIdClient(t.idClient);case 16:return e.sent||(i.logger.info("msgDelete::deleteLocalMsg::db.deleteMsg no find in DB",t),t),i.logger.info("msgDelete::deleteLocalMsg::db.deleteMsg ",t.idClient),e.next=21,s.deleteMsg(t.idClient);case 21:if(!l||null!==l.lastMsg){e.next=26;break;}return e.next=24,s.getMsgs({sessionId:c,limit:1});case 24:(d=e.sent)&&d[0]&&(p=d[0]);case 26:if(l||!i.options.rollbackDelMsgUnread){e.next=36;break;}return i.logger.info("msgDelete::deleteLocalMsg::Can not find session in cache,will find in DB",c),e.next=30,s.getSession(c);case 30:if(f=e.sent){e.next=33;break;}return e.abrupt("return");case 33:m=(l=f).ack||0,l&&m<t.time&&"in"===t.flow&&l.unread&&(i.logger.info("msgDelete::deleteLocalMsg:db.getSessions: unread",f.id,f.unread),l.unread=l.unread-1,u=!0);case 36:if(l&&null===l.lastMsg&&p&&(i.logger.info("msgDelete::deleteLocalMsg:db.getSessions: lastMsg",c,p),l.lastMsg=p||null,u=!0),!u){e.next=39;break;}return e.abrupt("return",a(l));case 39:if(s.enable||!u){e.next=42;break;}return i.onUpdateSession(l),e.abrupt("return");case 42:case"end":return e.stop();}}},e,this);}));return function(t,n){return e.apply(this,arguments);};}(),b.deleteLocalMsgs=function(e){var t=this,n=t.db;return new l(function(r,o){if(function(r){var o=t.getSessionInCache(e.sessionId);if(o&&e.updateSession){var i=o.lastMsg;i&&(!e.start&&!e.end||i.time>e.start&&i.time<e.end)&&(o.lastMsg=null,t.logger.log("deleteLocalMsgs::delete cacheSession lastMsg done, options is",e),n.enable||(t.onUpdateSession(o),r()));}}(r),n.enable)return n.deleteMsgsBySessionId(e).then(function(){e.updateSession&&t.checkAndUpdateLocalSessionByMsg(e.sessionId),r();},function(e){return o(e);});});};},function(e,t,n){var r=n(88),o=n(7),i=n(6),s=n(9),a=n(3),c=n(27),u=n(17),l=n(2),m=n(32).fn,p=n(0),d=n(140);m.splitSysMsgs=function(e,t){for(var n,o=e.length-1;o>=0;o--){n=e[o],d.isCustom(n)&&(r(e).call(e,o,1),t.push(n));}},m.onOfflineSysMsgs=function(e,t){var n,r=this,c=o(n=e.content.sysMsgs).call(n,function(e){return e=i(d).call(d,e),t&&(e.filter=!0),e;});c=i(c).call(c),r.markSysMsgRead(c);var u=[];r.splitSysMsgs(c,u);var l,m=t?"offlineFilterSysMsgs":"offlineSysMsgs",p=t?"offlineFilterCustomSysMsgs":"offlineCustomSysMsgs";if(c.length){var f=r.putSysMsg(c,"offlineSysMsgs").then(function(e){var t;(c=e).length&&(r.logger.info("sysmsg::onOfflineSysMsgs: ",m,c.length,c&&o(c).call(c,function(e){return e.idServer;})),r.syncResult[m]=r.syncResult[m]||[],r.syncResult[m]=s(t=r.syncResult[m]).call(t,c));}).catch(function(e){return r.logger.error("sysMsg::onOfflineSysMsgs: ",e),a.reject(e);});f.cmd="sysMsgs",r.syncPromiseArray.push(f);}u.length&&(r.logger.info("sysmsg::onOfflineSysMsgs: ",p,o(u).call(u,function(e){return e.idServer;})),r.syncResult[p]=r.syncResult[p]||[],r.syncResult[p]=s(l=r.syncResult[p]).call(l,u));},m.onSendSysMsg=function(e,t){var n=e.obj||{};n?(this.completeSysMsg(n),e.error?n.status="fail":n.status="success",n=i(d).call(d,n),t&&(e.obj.filter=!0),e.obj=n):this.logger.warn("onSendSysMsg::no obj");},m.completeSysMsg=function(e){return e.from=this.account,e;},m.onSysMsg=function(e,t){var n=i(d).call(d,e.content.sysMsg);this.markSysMsgRead(n),t&&(n.filter=!0),d.isCustom(n)?(this.logger.info("sysmsg::onSysMsg: on customSysMsg"),this.options.oncustomsysmsg(n)):this.syncing?this.unhandledSysMsgs.push(n):this.handleSysMsg(n);},m.handleSysMsg=function(e){var t=this,n=e.type,r=e.from,o=e.serverex;t.sysMsgPromise=t.sysMsgPromise.then(function(){return t.putSysMsg(e,"onSysMsg");}).then(function(t){e=t[0];}).then(function(){if(e){var i,s=a.resolve();switch(n){case"addFriend":i={type:"addFriend",account:r},o&&(i.serverex=o),s=t.onFriendRequest(i);break;case"passFriendApply":i={type:"passFriendApply",account:r},s=t.onFriendRequest(i);break;case"deleteFriend":s=t.onDeleteFriend({account:r});}return i&&i.friend&&(e.friend=i.friend),s;}}).then(function(){e&&(t.logger.info("sysmsg::handleSysMsg: ",n,p.pickAsString(e,["idServer","deletedIdClient","deletedIdServer"])),c(function(){t.options.onsysmsg(e);},0));});},m.putSysMsg=function(e,t){if(p.isArray(e)||(e=[e]),u(e[0]))return a.resolve(e);var n=this,r=n.db,o=r.enable,i=a.resolve(),s=[];return(i=(i=i.then(function(){return o?r.putSysMsg(e):e;}).then(function(t){var r=[];l(e).call(e,function(e){n.checkSysMsgUnique(e)&&r.push(e);}),e=r,s=o?t:e;})).then(function(){return n.getSysMsgUnread().then(function(r){return s.length||((s=e).backward=!0),n.updateSysMsgUnread(s,r,1).then(function(e){"offlineSysMsgs"===t&&(n.syncResult.sysMsgUnread=e),"onSysMsg"===t&&n.onUpdateSysMsgUnread(e);});});})).then(function(){return e;});},m.checkSysMsgUnique=p.genCheckUniqueFunc("idServer"),m.getSysMsgUnread=function(){var e=this,t=e.db;return new a(function(n){t.enable?t.getSysMsgUnread().then(function(e){n(e);},function(){n(e.sysMsgUnread);}):n(e.sysMsgUnread);});},m.updateSysMsgUnread=function(e,t,n){if(p.isArray(e)||(e=[e]),!e.length)return a.resolve(t);t=t||{};var r,o=this.db;return l(e).call(e,function(e){(n>0&&!e.read||n<0&&e.read)&&(r=e.type,t[r]=(t[r]||0)+n);}),t=d.completeUnread(t),this.sysMsgUnread=t,o.enable&&!e.backward?o.updateSysMsgUnread(t):a.resolve(t);},m.reduceSysMsgUnread=function(e){var t=this;return t.getSysMsgUnread().then(function(n){return t.updateSysMsgUnread(e,n,-1);}).then(function(e){t.onUpdateSysMsgUnread(e);});},m.onUpdateSysMsgUnread=function(e){var t=this;c(function(){t.logger.info("sysmsg::onUpdateSysMsgUnread:",e),t.options.onupdatesysmsgunread(e);},0);},m.updateSysMsg=function(e){var t=this,n=t.db;(n.enable?n.updateSysMsg(e):a.resolve(e)).then(function(e){t.onUpdateSysMsg(e);});},m.onUpdateSysMsg=function(e){var t=this;c(function(){p.isArray(e)||(e=[e]),l(e).call(e,function(e){t.logger.info("sysmsg::onUpdateSysMsg:",e.idServer),t.options.onupdatesysmsg(e);});},0);},m.processUnsettledSysMsgs=function(){var e,t=this;l(e=t.unhandledSysMsgs).call(e,function(e){t.handleSysMsg(e);}),t.resetUnsettledSysMsgs();};},function(e,t,n){var r=n(685),o=n(58),i=n(2),s=n(4),a=n(16),c=n(6),u=n(3),l=n(7),m=n(71),p=n(17),d=n(35),f=n(5),g=n(9),h=n(59),y=n(60),v=n(61),b=n(62),T=n(46);function S(e,t){var n=f(e);if(h){var r=h(e);t&&(r=p(r).call(r,function(t){return y(e,t).enumerable;})),n.push.apply(n,r);}return n;}function M(e){for(var t=1;t<arguments.length;t++){var n,r,s=null!=arguments[t]?arguments[t]:{};t%2?i(n=S(Object(s),!0)).call(n,function(t){o(e,t,s[t]);}):v?b(e,v(s)):i(r=S(Object(s))).call(r,function(t){T(e,t,y(s,t));});}return e;}var k=n(32).fn,x=n(0),C=n(141),I=n(39),_=n(140);k.processSession=function(e){if(!e.error)switch(e.cmd){case"getServerSessions":this.onGetServerSessions(e);break;case"getServerSession":this.onGetServerSession(e);break;case"updateServerSession":this.onUpdateServerSession(e);}},k.onGetServerSessions=function(e){var t=this,n=e.content&&e.content.sessionReqTag,r=e.content&&e.content.sessionList,o=[];i(r).call(r,function(e){var n,r;(e.id=e.id.split("|").join("-"),0===s(n=e.id).call(n,"super_team"))&&(e.id="superTeam"+a(r=e.id).call(r,10));if(e.updateTime=+e.updateTime,e.lastMsg){var i="1"===e.lastMsgType?"sysMsg":"msg";o.push(t.parser.unserialize(JSON.parse(e.lastMsg),i).then(function(n){var r;e.lastMsg="msg"===i?c(r=t.message).call(r,n):c(_).call(_,n);}));}}),e.promise=u.all(o).then(function(){e.obj={sessionList:r,hasMore:"1"===n.hasMore},n.minTimestamp&&(e.obj.minTimestamp=+n.minTimestamp);});},k.onGetServerSession=function(e){var t,n=this,r=e.content&&e.content.session;if(r){var o;if(r.id=r.id.split("|").join("-"),0===s(t=r.id).call(t,"super_team"))r.id="superTeam"+a(o=r.id).call(o,10);if(r.updateTime=+r.updateTime,r.lastMsg){var i=e.content.session&&"1"===e.content.session.lastMsgType?"sysMsg":"msg";e.promise=n.parser.unserialize(JSON.parse(r.lastMsg),i).then(function(t){var o;r.lastMsg="msg"===i?c(o=n.message).call(o,t):c(_).call(_,t),e.obj=r;});}else e.obj=r;}},k.onUpdateServerSession=function(e){e.obj={};},k.onSyncUpdateServerSession=function(e){var t,n=this,r=this,o=e.content&&e.content.session;if(o){var i;if(o.id=o.id.split("|").join("-"),0===s(t=o.id).call(t,"super_team"))o.id="superTeam"+a(i=o.id).call(i,10);o.updateTime=+o.updateTime,o.lastMsg?r.parser.unserialize(JSON.parse(o.lastMsg),"msg").then(function(e){var t;o.lastMsg=c(t=r.message).call(t,e),n.options.onSyncUpdateServerSession(x.simpleClone(o));}):this.options.onSyncUpdateServerSession(x.simpleClone(o));}},k.mergeSession=function(e){e=x.copyWithNull(e);var t=this.sessionSet,n=e.id,r=t[n]||{},o=!1;return C.isComplete(e)?delete r.isDeleted:r.isDeleted&&(o=!0),t[n]=x.merge(r,e),e=o?e:t[n],x.undef(e.unread)&&(e.unread=0),e;},k.mergeSessions=function(e){var t=this;return l(e=e||[]).call(e,function(e){return t.mergeSession(e);});},k.onDeleteSessions=function(e){var t;e.obj=l(t=e.obj.sessions).call(t,function(e){return C.parse(e);});},k.onUpdateSession=function(e){if(e){if(e=this.mergeSession(e),e=m(C).call(C,e),C.isComplete(e))return this.logger.info("session::onUpdateSession: ".concat(e.id),e.id,x.secureOutput("session",e)),this.options.onupdatesessions?this.options.onupdatesessions([e]):this.options.onupdatesession(e),e;this.logger.warn("session::onUpdateSession::session is not complete",x.secureOutput("session",e));}},k.onUpdateSessions=function(e){var t=this;if(e){e=t.mergeSessions(e),e=l(e).call(e,function(e){return m(C).call(C,e);});var n=p(e).call(e,function(e){return C.isComplete(e);}),r=p(e).call(e,function(e){return!C.isComplete(e);});if(r&&r.length>0&&t.logger.warn("session::onUpdateSessions::sessions is not complete",l(r).call(r,function(e){return e.id;}),x.secureOutput("session",r)),0!==n.length)return t.logger.info("session::onUpdateSessions:",x.secureOutput("session",n)),t.options.onupdatesessions?t.options.onupdatesessions(n):i(n).call(n,function(e){t.options.onupdatesession(e);}),n;t.logger.warn("session::onUpdateSessions::completeSessions is empty");}},k.setCurrSession=function(e){e=""+e,this.currSessionId=e,this.logger.info("session::setCurrSession:",e);},k.resetSessionUnread=function(e){var t=e.id;this.db.enable&&this.db.updateSession({id:t,unread:0}),!this.options.autoMarkRead&&this.sessionUnreadMsgs&&this.sessionUnreadMsgs[t]&&(this.markMsgRead(this.sessionUnreadMsgs[t],!0),this.sessionUnreadMsgs[t]=[]),this.getSessionInCache(t)?this.onUpdateSession({id:t,unread:0}):this.onUpdateSession(M(M({},e),{},{unread:0}));},k.resetSessionsUnread=function(e){var t=this,n=this.db;n.enable&&l(e).call(e,function(e){n.updateSession({id:e.id,unread:0});});var r=!this.options.autoMarkRead&&this.sessionUnreadMsgs;e=l(e).call(e,function(e){return r&&t.sessionUnreadMsgs[e.id]&&(t.markMsgRead(t.sessionUnreadMsgs[e.id],!0),t.sessionUnreadMsgs[e.id]=[]),t.getSessionInCache(e.id)?{id:e.id,unread:0}:M(M({},e),{},{unread:0});}),this.onUpdateSessions(e);},k.insertLocalSession=function(e){var t=this,n=t.db,r=e.scene+"-"+e.to,o=t.getSessionInCache(r);return o&&C.isComplete(o)?u.reject(I.sessionExist({callFunc:"session::insertLocalSession",session:o})):(n.enable?n.getMsgs({sessionId:r,limit:1}):u.resolve()).then(function(i){if(x.isArray(i)&&1===i.length){var s=i[0];(o=C.genSessionByMsg(s)).updateTime=s.time;}else o={id:r,scene:e.scene,to:e.to,updateTime:+e.updateTime||+new Date(),lastMsg:null};return t.onUpdateSession(o),n.enable?n.putSession(o):u.resolve(o);});},k.checkAndUpdateLocalSessionByMsg=function(e){var t,n=this.db,o=this,s=this.options.syncSessionUnread&&e!==this.currSessionId,a=n.getMsgs({sessionId:e,limit:1}),c=n.getSession(e).then(function(r){if(r)return t=d({},r),r.ack=r.ack||0,s?n.getMsgs({sessionId:e,start:r.ack}):u.resolve();o.logger.error("can't find session that sessionId = ".concat(e));});return u.all([a,c]).then(function(s){var a,c,l=r(s,2),m=l[0],p=l[1],d={id:e};if(!t)return o.logger.error("checkAndUpdateLocalSessionByMsg:can not find session",e),u.resolve(200);if(a=t&&!t.lastMsg?null:t.lastMsg.idClient,m&&m[0]?c=(m=m[0]).idClient:(c=null,m=null),a!==c&&(d.lastMsg=m),void 0!==p){var g=0;i(p=p||[]).call(p,function(e){var t;try{t=o.options.shouldCountNotifyUnread(e);}catch(e){throw o.logger.error("userOption:shouldCountNotifyUnread function error",e),e;}e.isUnreadable&&"in"===e.flow&&("notification"!==e.type||t)&&g++;}),g!==t.unread&&(d.unread=g);}return f(d).length>1?(o.logger.info("session::checkAndUpdateLocalSessionByMsg::needUpdate newSession:",x.secureOutput("session",d)),n.updateSession(d).then(function(){return o.onUpdateSession(d);})):u.resolve(200);});},k.syncSessionsWithMoreRoaming=function(e){var t=this,n=e&&e.content&&e.content.sessions;if(n&&n.length){var r={0:"p2p",1:"team",5:"superTeam"};if(i(n).call(n,function(e){var n,o=e.to===t.options.account?e.from:e.to;e.scene=r[e.scene],e.id=g(n="".concat(e.scene,"-")).call(n,o),e.time=+e.time;}),this.db.enable){var o=this.db.putSessionsWithMoreRoaming(n);o.cmd="syncSessionsWithMoreRoaming",this.syncPromiseArray.push(o);}this.syncing&&this.syncResult?this.syncResult.sessionsWithMoreRoaming=n:this.logger.warn("syncSessionsWithMoreRoaming::not in syncing or no syncResult");}},k.syncStickTopSessions=function(e){var t=this,n=this.db,r=[],o=[],a=u.resolve(),c=e.content.sessions||[];this.syncing&&this.syncResult?(i(c).call(c,function(e){var t=e.id.split("|");"super_team"===t[0]&&(t[0]="superTeam"),e.id=t.join("-"),e.scene=t[0],e.to=t[1],e.isTop=!0,r.push(t.join("-")),delete e.createTime,delete e.updateTime,n.enable&&o.push(n.putSession(e));}),n.enable&&(a=n.updateTimetag("stickTopSessions",e.content.timetag)),a.then(function(){return n.enable?n.getStickTopSessions():[];}).then(function(a){if(e.content.modify){var c=[];i(a).call(a,function(e){s(r).call(r,e.id)>-1||(c.push(e.id),e.isTop=!1,e.topCustom="",o.push(n.putSession(e)));});}else t.syncResult.stickTopSessions=a;return u.all(o);}),this.syncResult.stickTopSessions=c,a.cmd="syncStickTopSessions",this.syncPromiseArray.push(a)):this.logger.warn("syncSessionsWithMoreRoaming::not in syncing or no syncResult");},k.getSessionInCache=function(e,t){var n=this.sessionSet[e];return!n||n.isDeleted&&!t?void 0:n;},k.deleteSessionInCache=function(e,t){var n=this;x.isArray(e)||(e=[e]),t?i(e).call(e,function(e){n.sessionSet[e]&&(n.sessionSet[e].isDeleted=!0);}):i(e).call(e,function(e){return delete n.sessionSet[e];}),this.logger.info("sessions::deleteSessionInCache::delete session done",e,t);},k.updateSessionInCache=function(e){return this.logger.info("session::updateSessionInCache: ".concat(e.id),e.id,e),this.getSessionInCache(e.id)?e=this.mergeSession(e):(this.logger.info("session::updateSessionInCache: can not find session in cache ".concat(e.id)),null);},k.updateSessionInDbWithNotify=function(e,t){var n=this;return new u(function(r,o){var i=n.db;if(n.getSessionInCache(e.id)){var s=u.resolve(),a=x.filterObj(e,"id lastMsg localCustom unread");i.enable&&(s=i.updateSession(a)),s.then(function(e){return n.onUpdateSession(e,t);}).then(r,function(e){o({callFunc:"session::updateLocalSession",event:e});});}else o(I.sessionNotExist({sessionId:e.id,callFunc:"session::updateLocalSession"}));});};},function(e,t,n){var r=n(676);e.exports=function(e){if(r(e))return e;},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(142),o=n(72);e.exports=function(e,t){var n=null==e?null:void 0!==r&&o(e)||e["@@iterator"];if(null!=n){var i,s,a,c,u=[],l=!0,m=!1;try{if(a=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;l=!1;}else for(;!(l=(i=a.call(n)).done)&&(u.push(i.value),u.length!==t);l=!0){}}catch(e){m=!0,s=e;}finally{try{if(!l&&null!=n.return&&(c=n.return(),Object(c)!==c))return;}finally{if(m)throw s;}}return u;}},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(2),o=n(5),i=n(9),s=n(35),a=n(32).fn,c=n(0);a.syncSessionAck=function(e){var t,n=this;if(this.logger.info("syncSessionAck::",e.content),n.syncing&&n.syncResult){n.saveAck.p2pTeam=e.content.timetag;var a={};r(t=[[e.content.p2p,"p2p"],[e.content.team.m_map,"team"]]).call(t,function(e){var t,s=e[0],c=e[1];r(t=o(s)).call(t,function(e){var t,r;a[i(t="".concat(c,"-")).call(t,e)]=s[e];var o={id:i(r="".concat(c,"-")).call(r,e),ack:s[e]};n.cacheSyncedSession(o);});}),n.syncResult.ackMap?n.syncResult.ackMap=s(n.syncResult.ackMap,a):n.syncResult.ackMap=a;}else n.logger.warn("syncSessionAck: not in syncing or no syncResult",n.syncing,!!n.syncResult);},a.syncSuperTeamSessionAck=function(e){var t,n=this;if(n.syncResult){n.saveAck.superTeam=e.content.timetag;var i={},a=e.content.superTeam.m_map;r(t=o(a)).call(t,function(e){i["superTeam-".concat(e)]=a[e];var t={id:"superTeam-".concat(e),ack:a[e]};n.cacheSyncedSession(t);}),n.syncResult.ackMap?n.syncResult.ackMap=s(n.syncResult.ackMap,i):n.syncResult.ackMap=i;}},a.onMarkSessionAck=function(e){e.error||this.storeSessionAck(e.obj);},a.syncMarkSessionAck=function(e){this.storeSessionAck(e.content,!0);},a.storeSessionAck=function(e,t){var n;if(this.options.syncSessionUnread&&e){var r;switch(e.scene){case 0:r="p2p";break;case 1:r="team";break;case void 0:default:r="superTeam";}var o=i(n="".concat(r,"-")).call(n,e.to),s=e.timetag;if(s<=((this.getSessionInCache(o)||{}).ack||0))this.logger.warn("session::storeSessionAck: ack <= ackInMemory",s);else{var a={id:o,ack:s};this.mergeSession(a),this.logger.info("session::storeSessionAck:",c.secureOutput("session",a)),this.markUnreadBySessionAck({sessionId:o,ack:a.ack},t);}}},a.markUnreadBySessionAck=function(e,t){var n=e.sessionId,r=e.ack,o=this,i=o.db;if(i.enable)o.pushMsgTask(function(){return i.getMsgCountAfterAck({shouldCountNotifyUnread:o.options.shouldCountNotifyUnread,sessionId:n,ack:r}).then(function(e){var s={id:n,unread:e,ack:r};return o.logger.info("session::markUnreadBySessionAck: db.getMsgCountAfterAck done",s),o.syncing?o.cacheSyncedSession(s):t&&o.onUpdateSession(s),i.updateSession(s);}).catch(function(e){o.logger.error("markUnreadBySessionAck::error",e);});});else{var s=o.getSessionInCache(n);if(s){var a=s.unreadMsgs;if(a&&a.length){for(var c=0,u=[],l=a.length-1;l>=0;l--){var m=a[l];if(!(m.time>r))break;c++,u.push(m);}s.unreadMsgs=u,s.unread=c,o.logger.info("session::markUnreadBySessionAck: unread ".concat(c)),o.syncing?o.cacheSyncedSession(s):t&&o.onUpdateSession(s);}}}};},function(e,t,n){var r=n(32).fn;r.processChatroom=function(e){switch(e.cmd){case"getChatroomAddress":this.onChatroomAddress(e);}},r.onChatroomAddress=function(e){e.error||(e.obj.address=e.content.address);};},function(e,t,n){var r=n(32).fn;r.processQchat=function(e){switch(e.cmd){case"getQChatAddress":this.onQChatAddress(e);}},r.onQChatAddress=function(e){e.error||(e.obj.address=e.content.address);};},function(e,t,n){n(32).fn.processFilter=function(e){switch(e.cmd){case"sendFilterMsg":this.onSendMsg(e,!0);break;case"filterMsg":this.onMsg(e,!0);break;case"filterSysMsg":this.onSysMsg(e,!0);break;case"sendFilterCustomSysMsg":this.onSendSysMsg(e,!0);}};},function(e,t,n){var r=n(7),o=n(41),i=n(32).fn,s=n(0),a=o.clientTypeMap;function c(e){e=e||{};var t=s.copy(e);return t.clientType&&(t.clientType=a[t.clientType]||""),t.serverCustom&&(t.custom=JSON.parse(t.serverCustom),"string"==typeof t.custom[0]&&(t.custom=t.custom[0]),delete t.serverCustom),t;}i.processEventService=function(e){var t=e.content,n=e.error,o=this.options||{};switch(n&&(n.callFunc="events::processsEventService",this.onCustomError("事件服务解包失败","EVENT_SERVICE_ERROR",n)),e.cmd){case"pushEvent":if(s.isFunction(o.onpushevents)){var i={msgEvents:[c(t.msgEvent)]};o.onpushevents(i);}break;case"pushEvents":if(s.isFunction(o.onpushevents)){var a=t.msgEvents;a={msgEvents:r(a).call(a,function(e){return c(e);})},o.onpushevents(a);}}};},function(e,t,n){var r=n(32).fn,o=n(0);r.processProxyService=function(e){var t=e.error;switch(t&&(t.callFunc="events::processProxyService",this.onCustomError("proxyService","EVENT_PROXY_SERVICE_ERROR",t)),e.cmd){case"onProxyMsg":if(o.isFunction(this.options.onProxyMsg)){var n=e.content.proxyMsg||{};n.time&&(n.time=+n.time),this.options.onProxyMsg(n);}break;case"httpProxy":e.obj=e.content&&e.content.proxyTag;}};},function(e,t,n){var r=n(6),o=n(7),i=n(0),s=function s(e){this.account=e.account;},a=s.prototype,c=a.Message=n(56),u=a.TextMessage=n(760),l=a.FileMessage=n(188),m=a.GeoMessage=n(764),p=a.NotificationMessage=n(765),d=a.CustomMessage=n(766),f=a.TipMessage=n(767),g=a.RobotMessage=n(768),h=a.G2Message=n(769);a.validScenes=c.validScenes,a.validTypes=c.validTypes,a.sceneMap=c.sceneMap,a.sceneReverseMap=c.sceneReverseMap,a.reverse=function(e){var t;switch(c.getType(e)){case"text":t=r(u).call(u,e);break;case"image":case"audio":case"video":case"file":t=r(l).call(l,e);break;case"geo":t=r(m).call(m,e);break;case"notification":t=r(p).call(p,e);break;case"custom":t=r(d).call(d,e);break;case"tip":t=r(f).call(f,e);break;case"g2":t=r(h).call(h,e);break;case"robot":t=r(g).call(g,e);break;default:t=r(c).call(c,e);}return c.setExtra(t,this.account),t;},a.reverseMsgs=function(e,t){var n,s,a=this;return o(e).call(e,function(e){return e=r(a).call(a,e),t&&((n=t.modifyObj)&&(e=i.merge(e,n)),s=t.mapper,i.isFunction(s)&&(e=s(e))),e;});},e.exports=s;},function(e,t,n){var r=n(15),o=n(6),i=n(56),s=n(0);function a(e){s.verifyOptions(e,"text","msg::TextMessage"),e.type="text",i.call(this,e);}a.prototype=r(i.prototype),a.reverse=function(e){return o(i).call(i,e);},e.exports=a;},function(e,t,n){var r=n(15),o=n(188);function i(){}i.prototype=r(o.prototype),i.verifyFile=function(e,t){return!0;},e.exports=i;},function(e,t,n){var r=n(15),o=n(188);function i(){}i.prototype=r(o.prototype),i.verifyFile=function(){},e.exports=i;},function(e,t,n){var r=n(15),o=n(188);function i(){}i.prototype=r(o.prototype),i.verifyFile=function(){},e.exports=i;},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(56),a=n(0);function c(e){e.type="geo",a.verifyOptions(e,"geo","msg::GeoMessage"),a.verifyOptions(e.geo,"lng lat title",!0,"geo.","msg::GeoMessage"),a.verifyParamType("geo.lng",e.geo.lng,"number","msg::GeoMessage"),a.verifyParamType("geo.lat",e.geo.lat,"number","msg::GeoMessage"),a.verifyParamType("geo.title",e.geo.title,"string","msg::GeoMessage"),s.call(this,e),this.attach=r(e.geo);}c.prototype=o(s.prototype),c.reverse=function(e){var t=i(s).call(s,e);return e.attach=e.attach?""+e.attach:"",t.geo=e.attach?JSON.parse(e.attach):{},t;},e.exports=c;},function(e,t,n){var r=n(15),o=n(6),i=n(7),s=n(158),a=n(0).notundef,c=n(56),u=n(137).IM,l=n(175),m=n(187),p={0:"addTeamMembers",1:"removeTeamMembers",2:"leaveTeam",3:"updateTeam",4:"dismissTeam",5:"passTeamApply",6:"transferTeam",7:"addTeamManagers",8:"removeTeamManagers",9:"acceptTeamInvite",10:"updateTeamMute",101:"netcallMiss",102:"netcallBill",103:"netcallReject",401:"addSuperTeamMembers",402:"removeSuperTeamMembers",403:"leaveSuperTeam",404:"updateSuperTeam",405:"dismissSuperTeam",406:"transferSuperTeam",407:"addSuperTeamManagers",408:"removeSuperTeamManagers",409:"updateSuperTeamMembersMute",410:"passSuperTeamApply",411:"acceptSuperTeamInvite"};function d(){}d.prototype=r(c.prototype),d.reverse=function(e){var t=o(c).call(c,e);if(e.attach=e.attach?""+e.attach:"",e.attach){var n=JSON.parse(e.attach);if(t.attach={type:p[n.id]||n.id},a(n.data)){var r,d,f=n.data;if(a(f.tinfo)&&(t.attach.team=o(l).call(l,u.syncUnserialize(f.tinfo,"team"),!0)),a(f.ids)&&(t.attach.accounts=f.ids),a(f.id)&&(t.attach.account=f.id),a(f.uinfos))t.attach.users=i(r=f.uinfos).call(r,function(e){return o(m).call(m,u.syncUnserialize(e,"user"));});if(a(f.mute)&&(t.attach.mute=1==+f.mute),a(f.attach)&&(t.attach.custom=f.attach),a(f.channel)&&(t.attach.channelId=f.channel),a(f.calltype)&&(t.attach.netcallType=f.calltype),a(f.duration)&&(t.attach.duration=f.duration),a(f.time)&&(t.attach.time=f.time),a(f.from)&&(t.attach.from=f.from),a(f.ext)&&(t.attach.ext=f.ext),t.attach.accounts&&t.attach.accounts.length<=2&&t.from===t.to)s(d=t.attach.accounts).call(d,function(e){if(e!==t.to)return t.to=e,!0;});}}else t.attach={};return t;},e.exports=d;},function(e,t,n){var r=n(15),o=n(6),i=n(56),s=n(0);function a(e){s.verifyOptions(e,"content","msg::CustomMessage"),e.type="custom",i.call(this,e),this.attach=e.content;}a.prototype=r(i.prototype),a.reverse=function(e){var t=o(i).call(i,e);return t.content=e.attach,t;},e.exports=a;},function(e,t,n){var r=n(15),o=n(6),i=n(56),s=n(0);function a(e){s.verifyOptions(e,"tip","msg::TipMessage"),e.type="tip",i.call(this,e),this.body=e.tip;}a.prototype=r(i.prototype),a.reverse=function(e){var t=o(i).call(i,e);return t.text="",t.tip=e.body,e.attach&&(t.attach=e.attach),t;},e.exports=a;},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(7),a=n(56),c=n(0),u={welcome:"00",text:"01",link:"03"},l={"01":"text","02":"image","03":"answer",11:"template"};function m(e){c.verifyOptions(e,"content","msg::RobotMessage"),c.undef(e.robotAccid)&&(e.robotAccid=e.to);var t=e.content;switch(t.type){case"welcome":c.undef(e.body)&&(this.body="欢迎消息");break;case"text":c.verifyOptions(t,"content","msg::RobotMessage"),c.undef(e.body)&&(this.body=t.content);break;case"link":c.verifyOptions(t,"target","msg::RobotMessage");}t.type&&(t.type=u[t.type]),t={param:t,robotAccid:e.robotAccid},this.attach=r(t),e.type="robot",a.call(this,e);}m.prototype=o(a.prototype),m.reverse=function(e){var t=i(a).call(a,e);if("robot"===t.type){var n=JSON.parse(e.attach);if(n.param&&(n.param.type=l[n.param.type]||"unknown"),n.robotMsg){var r=(n=c.merge(n,n.robotMsg)).message;"bot"===n.flag?n.message=s(r).call(r,function(e){return e.type=l[e.type]||"unknown",e;}):n.flag,delete n.robotMsg;}t.content=n;}return t;},e.exports=m;},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(56),a=n(0);function c(e){a.verifyOptions(e,"attach","msg::G2Message"),e.type="g2",s.call(this,e),this.attach=r(e.attach);}c.prototype=o(s.prototype),c.reverse=function(e){var t=i(s).call(s,e);return e.attach&&(t.attach=JSON.parse(e.attach)),t;},e.exports=c;},function(e,t,n){var r=n(58),o=n(144),i=n(22),s=n(145),a=n(7),c=n(17),u=n(4),l=n(3),m=n(2),p=n(35),d=n(5),f=n(59),g=n(60),h=n(61),y=n(62),v=n(46);function b(e,t){var n=d(e);if(f){var r=f(e);t&&(r=c(r).call(r,function(t){return g(e,t).enumerable;})),n.push.apply(n,r);}return n;}function T(e){for(var t=1;t<arguments.length;t++){var n,o,i=null!=arguments[t]?arguments[t]:{};t%2?m(n=b(Object(i),!0)).call(n,function(t){r(e,t,i[t]);}):h?y(e,h(i)):m(o=b(Object(i))).call(o,function(t){v(e,t,g(i,t));});}return e;}var S=n(34).fn,M=n(0),k=M.isArray,x=n(139);S.mergeObjArray=function(e,t,n){return e||(e=[]),t?(k(t)||(t=[t]),t.length?(n=n||{},M.mergeObjArray(e,t,n)):e):e;},S.cutObjArray=function(e,t,n){return e&&t?(k(t)||(t=[t]),t.length?(n=n||{},M.cutObjArray(e,t,n)):e):e;},S.mergeLoginPorts=function(e,t){return this.mergeObjArray(e,t,{keyPath:"deviceId"});},S.cutLoginPorts=function(e,t){return this.cutObjArray(e,t,{keyPath:"deviceId",sortPath:"type"});},S.mergeRelations=function(e,t){return this.mergeObjArray(e,t,{keyPath:"account"});},S.cutRelations=function(e,t){return this.cutObjArray(e,t,{keyPath:"account"});},S.findRelation=function(e,t){return M.findObjInArray(e,{keyPath:"account",value:t});},S.mergeFriends=function(e,t){return this.mergeObjArray(e,t,{keyPath:"account"});},S.cutFriends=function(e,t){return this.cutObjArray(e,t,{keyPath:"account"});},S.cutFriendsByAccounts=function(e,t){k(t)||(t=[t]);var n=a(t).call(t,function(e){return{account:e};});return this.cutFriends(e,n);},S.findFriend=function(e,t){return M.findObjInArray(e,{keyPath:"account",value:t});},S.mergeUsers=function(e,t){return this.mergeObjArray(e,t,{keyPath:"account"});},S.findUser=function(e,t){return M.findObjInArray(e,{keyPath:"account",value:t});},S.mergeTeams=function(e,t){return this.mergeObjArray(e,t,{keyPath:"teamId"});},S.cutTeams=function(e,t){return this.cutObjArray(e,t,{keyPath:"teamId"});},S.findTeam=function(e,t){return M.findObjInArray(e,{keyPath:"teamId",value:t});},S.assembleTeamOwner=x.assembleOwner,S.assembleTeamMembers=x.assembleMembers,S.genTeamMemberId=x.genId,S.mergeTeamMembers=function(e,t){return this.mergeObjArray(e,t);},S.cutTeamMembers=function(e,t){return this.cutObjArray(e,t);},S.cutTeamMembersByAccounts=function(e,t,n){k(n)||(n=[n]);var r=x.assembleMembers({teamId:t},n);return this.cutTeamMembers(e,r);},S.findTeamMember=function(e,t){return M.findObjInArray(e,{keyPath:"id",value:t});},S.mergeSessions=function(e,t){return this.mergeObjArray(e,t,{sortPath:"updateTime",desc:!0});},S.cutSessions=function(e,t){return this.cutObjArray(e,t);},S.cutSessionsByIds=function(e,t){k(t)||(t=[t]);var n=a(t).call(t,function(e){return{id:e};});return this.cutSessions(e,n);},S.findSession=function(e,t){return M.findObjInArray(e,{keyPath:"id",value:t});},S.mergeMsgs=function(e,t){return this.mergeObjArray(e,t,{keyPath:"idClient",sortPath:"time"});},S.cutMsgs=function(e,t){return this.cutObjArray(e,t,{keyPath:"idClient"});},S.cutMsgsByIdClients=function(e,t){k(t)||(t=[t]);var n=a(t).call(t,function(e){return{idClient:e};});return this.cutMsgs(e,n);},S.findMsg=function(e,t){return M.findObjInArray(e,{keyPath:"idClient",value:t});},S.mergeSysMsgs=function(e,t){return this.mergeObjArray(e,t,{keyPath:"idServer",desc:!0});},S.cutSysMsgs=function(e,t){return this.cutObjArray(e,t,{keyPath:"idServer"});},S.cutSysMsgsByIdServers=function(e,t){k(t)||(t=[t]);var n=a(t).call(t,function(e){return{idServer:e};});return this.cutSysMsgs(e,n);},S.findSysMsg=function(e,t){return M.findObjInArray(e,{keyPath:"idServer",value:t});},S.searchLocal=function(e){if(M.verifyOptions(e,"keyword","searchLocal"),this.db.enable){var t,n=this,r=this.db,f=e.keyword+"",g=["account","nick","alias"],h=["id","scene","lastMsg.type","lastMsg.text","localCustom","target.account","target.nick","target.alias","target.name"],y="",v=e.keyPath;switch(v?(y=(v=(v+"").split(".")).shift(),v=v.join(".")):y="all",y){case"user":v&&(g=c(g).call(g,function(e){return e===v||0===u(e).call(e,v+".");})),k(g).then(function(t){e.done(null,{sessions:[],users:t});});break;case"session":v&&(h=c(h).call(h,function(e){return e===v||0===u(e).call(e,v+".");})),b(h,!v||u(v).call(v,"target")>-1).then(function(t){e.done(null,{sessions:t,users:[]});});break;case"all":C().then(function(){l.all([b(h,!0),k(g)]).then(function(t){e.done(null,{sessions:t[0],users:t[1]});});});break;default:e.done(null,{sessions:[],users:[],msg:'keyPath must start with "user" or "session"'});}}else e.done(null,{sessions:[],users:[],msg:"no db"});function b(e,t){return S.apply(this,arguments);}function S(){return(S=s(o.mark(function e(t,n){var i;return o.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i=n?[r.getSessions(),C(),r.getTeams(),r.getSuperTeams()]:[r.getSessions()],e.abrupt("return",l.all(i).then(function(e){var r,o=e[0]||[],i={p2p:e[1]||[],team:e[2]||[],superTeam:e[3]||[]},s={};n&&(m(r=d(i)).call(r,function(e){var t;m(t=i[e]).call(t,function(t){var n=t.teamId||t.account;s[e+"-"+n]=t;});}),m(o).call(o,function(e){e.target=s[e.id];}));return _(t,o);}));case 2:case"end":return e.stop();}}},e);}))).apply(this,arguments);}function k(e){return x.apply(this,arguments);}function x(){return(x=s(o.mark(function e(t){var n;return o.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return e.next=2,C();case 2:return n=e.sent,e.abrupt("return",_(t,n));case 4:case"end":return e.stop();}}},e);}))).apply(this,arguments);}function C(){return I.apply(this,arguments);}function I(){return(I=s(o.mark(function e(){var r,i;return o.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:if(!t){e.next=2;break;}return e.abrupt("return",t);case 2:return e.next=4,n.db.getFriends();case 4:if(e.t0=e.sent,e.t0){e.next=7;break;}e.t0=[];case 7:return r=e.t0,i=n.protocol.userSet||{},t=a(r).call(r,function(e){return T(T({},e),i[e.account]);}),e.abrupt("return",t);case 11:case"end":return e.stop();}}},e);}))).apply(this,arguments);}function _(e,t){var n=[];return m(t).call(t,function(t){for(var r=0;r<e.length;r++){var o=w(t,e[r].split("."));if(o&&u(o).call(o,f)>-1){n.push(p({},t));break;}}}),n;}function w(e,t){if("object"===i(e)&&e)return 1===t.length?e[t[0]]:w(e[t.shift()],t);}};},function(e,t,n){var r=n(16),o=n(34).fn,i=n(0);o.kick=function(e){var t;i.verifyOptions(e,"deviceIds","link::kick"),this.processCallback(e),this.sendCmd("kick",{deviceIds:r(t=e.deviceIds).call(t,0)},e.callback);},o.disconnect=function(e){e=e||{},this.protocol.disconnect(e.done);};},function(e,t,n){var r=n(34).fn,o=n(0);r.markInBlacklist=function(e){o.verifyOptions(e,"account isAdd","relation::markInBlacklist"),o.verifyParamType("isAdd",e.isAdd,"boolean","relation::markInBlacklist"),this.processCallback(e),this.sendCmd("markInBlacklist",{account:e.account,isAdd:e.isAdd},e.callback);},r.addToBlacklist=function(e){return e.isAdd=!0,this.markInBlacklist(e);},r.removeFromBlacklist=function(e){return e.isAdd=!1,this.markInBlacklist(e);},r.markInMutelist=function(e){o.verifyOptions(e,"account","relation::markInMutelist"),o.verifyParamType("isAdd",e.isAdd,"boolean","relation::markInMutelist"),this.processCallback(e),this.sendCmd("markInMutelist",{account:e.account,isAdd:e.isAdd},e.callback);},r.addToMutelist=function(e){return e.isAdd=!0,this.markInMutelist(e);},r.removeFromMutelist=function(e){return e.isAdd=!1,this.markInMutelist(e);},r.getRelations=function(e){var t=this,n=t.db,r=0;function i(){t.sendCmd("getRelations",{timetag:r,NOTSTORE:"timetag"},e.callback);}e=o.verifyOptions(e),t.processCallback(e),n.enable?n.getRelationsTimetag().then(function(e){r=e,i();},i):i();};},function(e,t,n){var r=n(9),o=n(2),i=n(4),s=n(34).fn,a=n(0),c=a.objs2accounts,u=n(187);s.updateMyInfo=function(e){a.verifyOptions(e),this.processCallback(e),e.user=new u(e),delete e.user.account,this.sendCmd("updateMyInfo",{user:e.user,antispamTag:{antiSpamBusinessId:e.antiSpamBusinessId},single:!0},e.callback);},s.getMyInfo=function(e){return(e=e||{}).account=this.account,this.getUser(e);},s.getUser=function(e){var t,n=this,r=n.db;function o(){n.sendCmd("getUsers",{accounts:[t],single:!0},e.callback);}a.verifyOptions(e,"account","user::getUser"),n.processCallback(e),e.cbaop=function(e,r){if(!e)return r=r[0]||null,n.logger.info("api::getUser: cbaop ".concat(t)),r;},t=e.account,e.sync?o():r.enable?r.getUser(t).then(function(t){t?e.done(null,t):o();},o):o();},s.getUsers=function(e){var t,n=this,s=n.db,u=[];function l(){n.sendCmd("getUsers",{accounts:t,single:!0},e.callback);}a.verifyOptions(e,"accounts","user::getUsers"),a.verifyParamType("accounts",e.accounts,"array","user::getUsers"),n.processCallback(e),e.cbaop=function(e,o){if(!e)return o=r(o).call(o,u),n.logger.info("api::getUsers: cbaop ".concat(t)),o;},t=a.deduplicate(e.accounts),a.verifyArrayMax("accounts",e.accounts,150,"user::getUsers"),e.sync?l():s.enable?s.getUsers(t).then(function(n){if(n&&n.length===t.length)e.done(null,n);else{u=n;var r=c(n),s=[];o(t).call(t,function(e){-1===i(r).call(r,e)&&s.push(e);}),t=s,l();}},l):l();};},function(e,t,n){var r=n(127),o=n(34).fn,i=n(0),s=i.notundef,a=n(681);o.friendRequest=function(e){i.verifyOptions(e,"type account","friend::friendRequest"),i.verifyParamValid("type",e.type,a.validTypes(),"friend::friendRequest"),this.processPs(e),this.processCallback(e);var t={account:e.account,type:a.getByteFromType(e.type),ps:e.ps};s(e.idServer)&&(t.idServer=e.idServer),this.sendCmd("friendRequest",t,e.callback);},o.addFriend=function(e){e.type="addFriend",this.friendRequest(e);},o.applyFriend=function(e){e.type="applyFriend",this.friendRequest(e);},o.passFriendApply=function(e){i.verifyOptions(e,"idServer","friend::passFriendApply"),e.type="passFriendApply",this.friendRequest(e);},o.rejectFriendApply=function(e){i.verifyOptions(e,"idServer","friend::rejectFriendApply"),e.type="rejectFriendApply",this.friendRequest(e);},o.deleteFriend=function(e){i.verifyOptions(e,"account","friend::deleteFriend");var t=!0===e.delAlias;this.processCallback(e),this.sendCmd("deleteFriend",{account:e.account,delFriendParams:{delAlias:t?1:0}},e.callback);},o.updateFriend=function(e){this.processCallback(e);var t=new a(e);this.sendCmd("updateFriend",{friend:t,single:!0},e.callback);},o.getFriends=function(e){var t=this.db;i.validate({timetag:{type:"number",required:!1}},e,"friend::getFriends"),this.processCallback(e),t.enable?t.getFriends({updateTime:e.updateTime||0}).then(function(t){(t=r(t).call(t,function(e,t){return e.updateTime-t.updateTime;})).invalid=[],e.done(null,t);}):this.sendCmd("getFriends",{timetag:e.updateTime||0,NOTSTORE:"timetag"},e.callback);},o.isMyFriend=function(e){var t=this.db;i.validate({account:{type:"string",allowEmpty:!1,require:!0}},e),this.processCallback(e),t.enable||e.done(null,!1),t.getFriend(e.account).then(function(t){t&&!0===t.valid?e.done(null,!0):e.done(null,!1);});},o.isUserInBlackList=function(e){var t=this.db;i.validate({account:{type:"string",allowEmpty:!1,require:!0}},e),this.processCallback(e),t.enable||e.done(null,!1),t.getUserFromBlackList(e.account).then(function(t){t&&t.account?e.done(null,!0):e.done(null,!1);});};},function(e,t,n){n(34).fn.getRobots=function(e){this.logger.warn("this api will be abandon"),(e=e||{}).type="getRobots",this.processCallback(e),this.sendCmd("sync",{sync:{robots:0}},e.callback);};},function(e,t,n){var r=n(16),o=n(7),i=n(17),s=n(3),a=n(34).fn,c=n(0),u=c.undef,l=n(175),m=n(139);a.createTeam=function(e){var t;c.verifyOptions(e,"type name","team::createTeam"),u(e.accounts)?e.accounts=[]:c.verifyParamType("accounts",e.accounts,"array","team::createTeam"),e.action="create",this.processPs(e),this.processCallback(e),e.team=new l(e);var n={team:e.team,accounts:r(t=e.accounts).call(t,0),ps:e.ps,antispamTag:{antiSpamBusinessId:e.antiSpamBusinessId}};this.sendCmd("createTeam",n,e.callback);},a.updateTeam=function(e){c.verifyOptions(e,"teamId","team::updateTeam"),e.action="update",this.processCallback(e),e.team=new l(e),this.sendCmd("updateTeam",{team:e.team,antispamTag:{antiSpamBusinessId:e.antiSpamBusinessId},single:!0},e.callback);},a.addTeamMembers=function(e){var t;c.verifyOptions(e,"teamId accounts","team::addTeamMembers"),c.verifyParamType("accounts",e.accounts,"array","team::addTeamMembers"),this.processPs(e),c.notexist(e.custom)&&(e.custom=""),this.processCallback(e);var n={teamId:e.teamId,accounts:r(t=e.accounts).call(t,0),ps:e.ps,attach:e.custom};this.sendCmd("addTeamMembers",n,e.callback);},a.removeTeamMembers=function(e){var t;c.verifyOptions(e,"teamId accounts","team::removeTeamMembers"),c.verifyParamType("accounts",e.accounts,"array","team::removeTeamMembers"),this.processCallback(e);var n={teamId:e.teamId,accounts:r(t=e.accounts).call(t,0)};this.sendCmd("removeTeamMembers",n,e.callback);},a.acceptTeamInvite=function(e){c.verifyOptions(e,"idServer teamId from","team::acceptTeamInvite"),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from,type:"teamInvite"};this.sendCmd("acceptTeamInvite",t,e.callback);},a.rejectTeamInvite=function(e){c.verifyOptions(e,"idServer teamId from","team::rejectTeamInvite"),this.processPs(e),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from,ps:e.ps,type:"teamInvite"};this.sendCmd("rejectTeamInvite",t,e.callback);},a.applyTeam=function(e){c.verifyOptions(e,"teamId","team::applyTeam"),this.processPs(e),this.processCallback(e);var t={teamId:e.teamId,ps:e.ps};this.sendCmd("applyTeam",t,e.callback);},a.passTeamApply=function(e){c.verifyOptions(e,"idServer teamId from","team::passTeamApply"),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from,type:"applyTeam"};this.sendCmd("passTeamApply",t,e.callback);},a.rejectTeamApply=function(e){c.verifyOptions(e,"idServer teamId from","team::rejectTeamApply"),this.processPs(e),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from,ps:e.ps,type:"applyTeam"};this.sendCmd("rejectTeamApply",t,e.callback);},a.addTeamManagers=function(e){var t;c.verifyOptions(e,"teamId accounts","team::addTeamManagers"),c.verifyParamType("accounts",e.accounts,"array","team::addTeamManagers"),this.processCallback(e);var n={teamId:e.teamId,accounts:r(t=e.accounts).call(t,0)};this.sendCmd("addTeamManagers",n,e.callback);},a.removeTeamManagers=function(e){var t;c.verifyOptions(e,"teamId accounts","team::removeTeamManagers"),c.verifyParamType("accounts",e.accounts,"array","team::removeTeamManagers"),this.processCallback(e);var n={teamId:e.teamId,accounts:r(t=e.accounts).call(t,0)};this.sendCmd("removeTeamManagers",n,e.callback);},a.updateInfoInTeam=function(e){c.verifyOptions(e,"teamId","team::updateInfoInTeam"),this.processCallback(e),this.sendCmd("updateInfoInTeam",{teamMember:new m(e),single:!0},e.callback);},a.updateNickInTeam=function(e){c.verifyOptions(e,"teamId account","team::updateNickInTeam"),this.processCallback(e),this.sendCmd("updateNickInTeam",{teamMember:new m(e),single:!0},e.callback);},a.updateMuteStateInTeam=function(e){c.verifyOptions(e,"teamId account mute","team::updateMuteStateInTeam"),this.processCallback(e),e.mute=e.mute?1:0,this.sendCmd("updateMuteStateInTeam",e);},a.getMutedTeamMembers=function(e){c.verifyOptions(e,"teamId","team::getMutedTeamMembers"),this.processCallback(e),this.sendCmd("getMutedTeamMembers",e);},a.leaveTeam=function(e){c.verifyOptions(e,"teamId","team::leaveTeam"),this.processCallback(e);var t={teamId:e.teamId};this.sendCmd("leaveTeam",t,e.callback);},a.transferTeam=function(e){c.verifyOptions(e,"teamId account leave","team::transferTeam"),c.verifyParamType("leave",e.leave,"boolean","team::transferTeam"),this.processCallback(e);var t={teamId:e.teamId,account:e.account,leave:e.leave};this.sendCmd("transferTeam",t,e.callback);},a.dismissTeam=function(e){c.verifyOptions(e,"teamId","team::dismissTeam"),this.processCallback(e);var t={teamId:e.teamId};this.sendCmd("dismissTeam",t,e.callback);},a.getTeam=function(e){var t,n=this,r=n.db;function o(){n.sendCmd("getTeam",{teamId:e.teamId},e.callback);}c.verifyOptions(e,"teamId","team::getTeam"),n.processCallback(e),e.cbaop=function(e){e||n.logger.info("api::getTeam: cbaop ".concat(t));},t=e.teamId,r.enable&&!e.sync?r.getTeam(t).then(function(r){r&&r.validToCurrentUser?(n.logger.log("api::getTeam: db.getTeam ".concat(t)),e.done(null,r)):o();},o):o();},a.getTeams=function(e){var t=this,n=t.db,r=0;function o(){t.sendCmd("getTeams",{timetag:r,NOTSTORE:"timetag"},e.callback);}c.verifyOptions(e),t.processCallback(e),n.enable?n.getTeamsTimetag().then(function(e){r=e,o();},o):o();},a.getTeamsById=function(e){c.verifyOptions(e,"teamIds","teams::getTeamsById"),this.processCallback(e),this.sendCmd("getTeamsById",{teamIds:e.teamIds},e.callback);},a.getTeamMembers=function(e){var t=this;c.verifyOptions(e,"teamId","team::getTeamMembers"),t.processCallback(e),t.sendCmd("getTeamMembers",{teamId:e.teamId,timetag:0,NOTSTORE:"timetag"},e.callback);},a.getTeamMemberByTeamIdAndAccount=function(e){var t=this;c.verifyParamType("teamId",e.teamId,"numeric or numeric string","team::getTeamMemberByTeamIdAndAccount"),c.verifyOptions(e,"account","team::getTeamMemberByTeamIdAndAccount"),t.processCallback(e),t.sendCmd("getTeamMembers",{teamId:e.teamId,timetag:0,NOTSTORE:"timetag"},function(t,n,r){var o={};if(n&&n.members&&n.members.length)for(var i=0;i<n.members.length;i++){if(n.members[i].account===e.account){o[e.account]=n.members[i];break;}}e.callback(t,o,r);});},a.getTeamMemberInvitorAccid=function(e){c.verifyParamType("teamId",e.teamId,"numeric or numeric string","team::getTeamMemberInvitorAccid"),u(e.accounts)||(c.verifyParamType("accounts",e.accounts,"array","team::getTeamMemberInvitorAccid"),e.accounts.length>200&&c.onParamError("accounts 参数数组长度不能超过200","team::getTeamMemberInvitorAccid"));var t,n={teamId:e.teamId};e.accounts.length&&(n.accounts=r(t=e.accounts).call(t,0));this.processCallback(e),this.sendCmd("getTeamMemberInvitorAccid",n,function(t,n,r){e.callback(t,r&&r.accountsMap||{});});},a.notifyForNewTeamMsg=function(e){c.verifyOptions(e,"teamIds","team::notifyForNewTeamMsg"),this.protocol.notifyForNewTeamMsg(e.teamIds).then(function(t){e.done(t.error||null,o(t),t.miss);},function(t){e.done(t);});},a.getMyTeamMembers=function(e){c.verifyOptions(e,"teamIds","team::getMyTeamMembers");var t=this.processCallbackPromise(e);return this.sendCmd("getMyTeamMembers",e),t;},a.getLocalTeams=function(e){var t,n=this.db,r=[];function o(){e.teams=r,e.done(t,e);}c.verifyOptions(e,"teamIds","team::getLocalTeams"),c.verifyParamType("teamIds",e.teamIds,"array","team::getLocalTeams"),this.processCallback(e),n.enable?n.getTeamsByTeamIds(e.teamIds).then(function(e){r=i(e).call(e,function(e){return!!e;}),o();},function(e){t=e,o();}):o();},a.getLocalTeamMembers=function(e){var t,n=this.db,r=[];function o(){e.members=r,e.done(t,e);}c.verifyOptions(e,"teamId accounts","team::getLocalTeamMembers"),c.verifyParamType("accounts",e.accounts,"array","team::getLocalTeamMembers"),this.processCallback(e),n.enable?n.getInvalidTeamMembers(e.teamId,e.accounts).then(function(e){r=i(e).call(e,function(e){return!!e;}),o();},function(e){t=e,o();}):o();},a.deleteLocalTeam=function(e){var t,n=this.db;function r(){e.done(t,e);}c.verifyOptions(e,"teamId","team::deleteLocalTeam"),this.processCallback(e),n.enable?n.deleteTeam(e.teamId).then(function(){r();},function(e){t=e,r();}):r();},a.muteTeamAll=function(e){c.verifyOptions(e,"teamId mute","team::muteTeamAll"),e.mute=e.mute?1:0,this.processCallback(e),this.sendCmd("muteTeamAll",e);},a.sendTeamMsgReceipt=function(e){c.verifyOptions(e,"teamMsgReceipts","team::sendTeamMsgReceipt"),e.teamMsgReceipts.length>50?this.logger.error("team::sendTeamMsgReceipt：teamMsgReceipts length over 50"):(this.processCallback(e),this.sendCmd("sendTeamMsgReceipt",e));},a.getTeamMsgReads=function(e){c.verifyOptions(e,"teamMsgReceipts","team::getTeamMsgReads"),this.processCallback(e),this.sendCmd("getTeamMsgReads",e);},a.getTeamMsgReadAccounts=function(e){var t,n=this,r=this;c.verifyOptions(e,"teamMsgReceipt","team::getTeamMsgReadAccounts"),e.callback=function(n,r,o){n&&t?(r=r||{teamMsgReceipt:e.teamMsgReceipt},e.done(n,r,{teamMsgReceipt:e.teamMsgReceipt,unreadAccounts:t.unreadAccounts,readAccounts:t.readAccounts})):e.done(n,r,o);},this.db.enable&&e.teamMsgReceipt.idClient?this.db.getMsgReadDetail(e.teamMsgReceipt.idClient).then(function(n){if(t=n,!n)return s.reject("no record");if(n.unreadAccounts&&n.unreadAccounts.length>0)return s.reject("unreadAccounts.length > 0");var o={teamMsgReceipt:e.teamMsgReceipt,unreadAccounts:n.unreadAccounts,readAccounts:n.readAccounts};r.logger.info("getTeamMsgReadAccounts from db"),e.done(null,{teamMsgReceipt:e.teamMsgReceipt},o);}).catch(function(t){n.logger.warn("db.getMsgReadDetail invalid",t),r.sendCmd("getTeamMsgReadAccounts",e);}):r.sendCmd("getTeamMsgReadAccounts",e);};},function(e,t,n){var r=n(685),o=n(3),i=n(6),s=n(23),a=n(16),c=n(7),u=n(2),l=n(9),m=n(34).fn,p=n(0),d=p.undef,f=n(287),g=n(186);function h(e){var t=this.db;if(!t.enable)return o.resolve({valid:!1});var n=t.getSuperTeam(e),i=t.getSuperTeamMembersTimetag(e);return o.all([n,i]).then(function(e){var t=r(e,2),n=t[0],i=t[1],s=n&&n.memberUpdateTime,a={timetag:i=i||0};return s&&i>=s&&(a.valid=!0),o.resolve(a);}).catch(function(){return o.resolve({timetag:0});});}m.addSuperTeamMembers=function(e){p.verifyOptions(e,"teamId accounts","superTeam::addSuperTeamMembers"),p.verifyParamType("accounts",e.accounts,"array","superTeam::addSuperTeamMembers");var t=p.deduplicate(e.accounts);this.processPs(e),this.processCallback(e);var n={teamId:e.teamId,accounts:t,ps:e.ps};this.sendCmd("addSuperTeamMembers",n,e.callback);},m.removeSuperTeamMembers=function(e){p.verifyOptions(e,"teamId accounts","team::removeSuperTeamMembers"),p.verifyParamType("accounts",e.accounts,"array","team::removeSuperTeamMembers");var t=p.deduplicate(e.accounts);this.processCallback(e);var n={teamId:e.teamId,accounts:t};this.sendCmd("removeSuperTeamMembers",n,e.callback);},m.leaveSuperTeam=function(e){p.verifyOptions(e,"teamId","superTeam::leaveSuperTeam"),this.processCallback(e);var t={teamId:e.teamId};this.sendCmd("leaveSuperTeam",t,e.callback);},m.getSuperTeam=function(e){var t,n=this,r=n.db;function o(){n.sendCmd("getSuperTeam",{teamId:e.teamId},e.callback);}p.verifyOptions(e,"teamId","team::getSuperTeam"),n.processCallback(e),e.cbaop=function(e){e||n.logger.info("api::getSuperTeam: cbaop ".concat(t));},t=e.teamId,r.enable&&!e.sync?r.getSuperTeam(t).then(function(r){r&&r.validToCurrentUser?(n.logger.log("api::getSuperTeam: db.getSuperTeam ".concat(t)),e.done(null,r)):o();}).catch(function(){o();}):o();},m.getSuperTeams=function(e){var t=this,n=t.db,r=0;function o(){t.sendCmd("getSuperTeams",{timetag:r,NOTSTORE:"timetag"},e.callback);}p.verifyOptions(e),t.processCallback(e),n.enable?n.getSuperTeamsTimetag().then(function(e){r=e,o();},o):o();},m.updateSuperTeam=function(e){p.verifyOptions(e,"teamId","superTeam::updateSuperTeam"),e.action="update",this.processCallback(e),e.team=new f(e),this.sendCmd("updateSuperTeam",{team:e.team,antispamTag:{antiSpamBusinessId:e.antiSpamBusinessId},single:!0},e.callback);},m.updateInfoInSuperTeam=function(e){p.verifyOptions(e,"teamId","superTeam::updateInfoInSuperTeam"),this.processCallback(e),this.sendCmd("updateInfoInSuperTeam",{superTeamMember:new g(e),single:!0},e.callback);},m.getSuperTeamMembersByJoinTime=function(e){var t=this,n=e.joinTime,r=i(e),o=e.limit,s=e.teamId;r=!!r,d(n)&&(n=0),d(o)&&(o=100),p.verifyOptions(e,"teamId","superTeam::getSuperTeamMembersByJoinTime"),p.verifyParamType("joinTime",n,"number","api::superTeam::getSuperTeamMembersByJoinTime"),p.verifyParamType("limit",o,"number","api::superTeam::getSuperTeamMembersByJoinTime"),t.processCallback(e),t.sendCmd("getSuperTeamMembersByJoinTime",{teamId:s,limit:o,joinTime:n,reverse:r,timetag:0,NOTSTORE:"timetag"},e.callback);},m.getAllSuperTeamMembers=function(e){var t=this,n=this.db;function r(n){n=n||0,t.sendCmd("getSuperTeamMembers",{teamId:e.teamId,timetag:n,NOTSTORE:"timetag"},e.callback);}p.verifyOptions(e,"teamId","superTeam::getAllSuperTeamMembers"),t.processCallback(e),s(h).call(h,this)(e.teamId).then(function(o){var i=o.valid,s=o.timetag;i?(t.logger.info("getAllSuperTeamMembers from local db"),n.getSuperTeamMembers(e.teamId).then(function(t){var n={teamId:e.teamId,members:t};e.done(null,n);},function(){return r();})):r(s);});},m.applySuperTeam=function(e){p.verifyOptions(e,"teamId","team::applySuperTeam"),p.verifyOptions(e,"teamId","team::applySuperTeam"),this.processPs(e),this.processCallback(e);var t={teamId:e.teamId,ps:e.ps};this.sendCmd("applySuperTeam",t,e.callback);},m.passSuperTeamApply=function(e){p.verifyOptions(e,"idServer teamId from","team::passSuperTeamApply"),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from};this.sendCmd("passSuperTeamApply",t,e.callback);},m.rejectSuperTeamApply=function(e){p.verifyOptions(e,"idServer teamId from","team::rejectSuperTeamApply"),this.processPs(e),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from,ps:e.ps};this.sendCmd("rejectSuperTeamApply",t,e.callback);},m.acceptSuperTeamInvite=function(e){p.verifyOptions(e,"idServer teamId from","team::acceptSuperTeamInvite"),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from};this.sendCmd("acceptSuperTeamInvite",t,e.callback);},m.rejectSuperTeamInvite=function(e){p.verifyOptions(e,"idServer teamId from","team::rejectSuperTeamInvite"),this.processPs(e),this.processCallback(e);var t={idServer:e.idServer,teamId:e.teamId,from:e.from,ps:e.ps};this.sendCmd("rejectSuperTeamInvite",t,e.callback);},m.addSuperTeamManagers=function(e){var t;p.verifyOptions(e,"teamId accounts","team::addSuperTeamManagers"),p.verifyParamType("accounts",e.accounts,"array","team::addSuperTeamManagers"),this.processCallback(e);var n={teamId:e.teamId,accounts:a(t=e.accounts).call(t,0)};this.sendCmd("addSuperTeamManagers",n,e.callback);},m.removeSuperTeamManagers=function(e){var t;p.verifyOptions(e,"teamId accounts","team::removeSuperTeamManagers"),p.verifyParamType("accounts",e.accounts,"array","team::removeSuperTeamManagers"),this.processCallback(e);var n={teamId:e.teamId,accounts:a(t=e.accounts).call(t,0)};this.sendCmd("removeSuperTeamManagers",n,e.callback);},m.updateSuperTeamMembersMute=function(e){p.verifyOptions(e,"teamId accounts mute","team::updateSuperTeamMembersMute"),p.verifyParamType("accounts",e.accounts,"array","team::updateSuperTeamMembersMute"),p.verifyArrayMax("accounts",e.accounts,10),this.processCallback(e),e.mute=e.mute?1:0,this.sendCmd("updateSuperTeamMembersMute",e);},m.updateSuperTeamMute=function(e){p.verifyOptions(e,"teamId mute","team::updateSuperTeamMute"),e.mute=e.mute?1:0,this.processCallback(e),this.sendCmd("updateSuperTeamMute",e);},m.updateNickInSuperTeam=function(e){p.verifyOptions(e,"teamId account","team::updateNickInSuperTeam"),this.processCallback(e),this.sendCmd("updateNickInSuperTeam",{superTeamMember:new g(e),single:!0},e.callback);},m.transferSuperTeam=function(e){p.verifyOptions(e,"teamId account leave","team::transferSuperTeam"),p.verifyParamType("leave",e.leave,"boolean","team::transferSuperTeam"),this.processCallback(e);var t={teamId:e.teamId,account:e.account,leave:e.leave};this.sendCmd("transferSuperTeam",t,e.callback);},m.getSuperTeamMembersByAccounts=function(e){var t=this,n=this.db,r=e.teamId,i=e.accounts;if(p.verifyOptions(e,"teamId accounts","superTeam::getSuperTeamMembersByAccounts"),p.verifyParamType("accounts",i,"array","superTeam::getSuperTeamMembersByAccounts"),p.verifyArrayMax("accounts",i,20),i.length<=0)return p.onParamError("参数accounts不能为空数组","superTeam::getSuperTeamMembersByAccounts");function s(){var n=c(i).call(i,function(e){return r+"|"+e;});t.processCallback(e),t.sendCmd("getSuperTeamMembersByAccounts",{memberIds:n},function(t,n){e.done(null,{accounts:i,members:n.members,invaldAccounts:n.invalid});});}h.call(this,r).then(function(t){var a,c,m;return t.valid?(a=[],c=[],m=[],u(i).call(i,function(e){var t,o=n.getSuperTeamMemberById(l(t="".concat(r,"-")).call(t,e)).then(function(e){c.push(e);}).catch(function(){m.push(e);});a.push(o);}),void o.all(a).then(function(){e.done(null,{accounts:i,members:c,invaldAccounts:m});})):s();}).catch(function(){return s();});},m.getMutedSuperTeamMembers=function(e){var t=this,n=e.joinTime,r=i(e),o=e.limit,s=e.teamId;r=!!r,d(n)&&(n=0),d(o)&&(o=100),p.verifyOptions(e,"teamId","superTeam::getSuperTeamMembersByJoinTime"),p.verifyParamType("joinTime",n,"number","api::superTeam::getSuperTeamMembersByJoinTime"),p.verifyParamType("limit",o,"number","api::superTeam::getSuperTeamMembersByJoinTime"),this.processCallback(e),t.sendCmd("getMutedSuperTeamMembers",{teamId:s,limit:o,joinTime:n,reverse:r},e.callback);};},function(e,t,n){var r=n(7),o=n(2),i=n(3),s=n(9),a=n(6),c=n(680),u=n(35),l=n(16),m=n(71),p=n(30),d=n(17),f=n(4),g=n(102),h=n(103),y=n(72);function v(e,t){var _n8=void 0!==h&&y(e)||e["@@iterator"];if(!_n8){if(p(e)||(_n8=function(e,t){var n;if(!e)return;if("string"==typeof e)return b(e,t);var r=l(n=Object.prototype.toString.call(e)).call(n,8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return g(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return b(e,t);}(e))||t&&e&&"number"==typeof e.length){_n8&&(e=_n8);var r=0,o=function o(){};return{s:o,n:function n(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]};},e:function e(_e11){throw _e11;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var i,s=!0,a=!1;return{s:function s(){_n8=_n8.call(e);},n:function n(){var e=_n8.next();return s=e.done,e;},e:function e(_e12){a=!0,i=_e12;},f:function f(){try{s||null==_n8.return||_n8.return();}finally{if(a)throw i;}}};}function b(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++){r[n]=e[n];}return r;}var T=n(34).fn,S=n(0),M=S.undef,k=S.notundef,x=n(277),C=n(141);function I(e,t){var n=this,r=[],a=[],c=this.db,u=this;return c.enable?(o(e).call(e,function(e){var t=n.protocol.getSessionInCache(e);t?l(t,e):a.push(c.getSession(e).then(function(t){return l(t,e);}));}),i.all(a).then(function(){return r;})):(o(e).call(e,function(e){return l(n.protocol.getSessionInCache(e),e);}),i.resolve(r));function l(e,n){var o,i,a,c;e?e.lastMsg?e.scene&&e.to?e.ack>=e.lastMsg.time?u.logger.warn(s(o="".concat(t," not need ack ")).call(o,e.id)):r.push(e):u.logger.warn(s(i="".concat(t," session.scene|to undefined ")).call(i,e.id)):u.logger.warn(s(a="".concat(t," session.lastMsg undefined ")).call(a,e.id)):u.logger.warn(s(c="".concat(t," session undefined ")).call(c,n));}}T.setCurrSession=function(e){this.resetSessionUnread(e),this.protocol.setCurrSession(e);},T.resetAllSessionUnread=function(){for(var e in this.protocol.sessionSet){this.protocol.sessionSet[e].unread>0&&this.resetSessionUnread(e);}},T.resetSessionsUnread=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){},n=this;n.logger.info("resetSessionsUnread::",e),I.call(this,e,"api::resetSessionsUnread").then(function(e){if(n.protocol.resetSessionsUnread(e),n.options.syncSessionUnread&&0!==e.length){var o=r(e).call(e,function(e){return{scene:"p2p"===e.scene?0:1,to:e.to,timetag:e.lastMsg.time};});n.sendCmd("markSessionAckBatch",{sessionAckTags:o},function(e){t(e||null);});}else t();});},T.resetSuperTeamSessionsUnread=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){},n=this;n.logger.info("resetSuperTeamSessionsUnread::",e),I.call(this,e,"api::resetSuperTeamSessionsUnread").then(function(e){if(n.protocol.resetSessionsUnread(e),n.options.syncSessionUnread&&0!==e.length){var o=r(e).call(e,function(e){return{to:e.to,timetag:e.lastMsg.time};});n.sendCmd("markSuperTeamSessionsAck",{sessionAckTags:o},function(e){t(e||null);});}else t();});},T.resetSessionUnread=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){},n=this,r=!1!==n.options.resetUnreadMode,o=function o(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;n?t(n,e):t(null);};n.logger.info("resetSessionUnread::use reset mode",r);var s=n.protocol.getSessionInCache(e),a=!s&&this.db.enable?n.db.getSession(e):i.resolve(s);function c(t){if(!t.lastMsg&&!t.updateTime)return n.logger.warn("api::resetSessionUnread: session.lastMsg undefined ".concat(e)),o();if(!t.scene||!t.to)return n.logger.warn("api::resetSessionUnread: session.scene|to undefined ".concat(e)),o();var i;if(i=t.lastMsg?t.lastMsg.time:t.updateTime,t&&t.ack&&t.ack>=i)return n.logger.warn("api::resetSessionUnread: session ack not needs ".concat(e)),o();var s={done:function done(e){e?(n.logger.error({message:e||"mark ack failed",callFunc:"resetSessionUnread"}),o(e||"mark ack failed")):(r||n.protocol.resetSessionUnread(t),o());}};if(n.processCallback(s),"superTeam"===t.scene)n.sendCmd("markSuperTeamSessionAck",{to:t.to,timetag:i},s.callback);else{var a={scene:"p2p"===t.scene?0:1,to:t.to,timetag:i};n.sendCmd("markSessionAck",a,s.callback);}}a.then(function(t){return t?n.options.syncSessionUnread?(r&&n.protocol.resetSessionUnread(t),void c(t)):(n.protocol.resetSessionUnread(t),o()):(n.logger.warn("api::resetSessionUnread: session undefined ".concat(e)),o());});},T.resetCurrSession=function(){this.protocol.setCurrSession("");},T.insertLocalSession=function(e){var t,n;function r(){e.session=n,e.done(t,e);}S.verifyOptions(e,"scene to","scene::insertLocalSession"),S.verifyParamValid("scene",e.scene,this.message.validScenes,"scene::insertLocalSession"),this.protocol.insertLocalSession(e).then(function(e){n=e,r();},function(e){t=e,r();});},T.getLocalSessions=function(e){var t=[];S.verifyOptions(e),M(e.limit)&&(e.limit=100),S.verifyParamType("limit",e.limit,"number","scene::getLocalSessions"),k(a(e))?S.verifyParamType("reverse",a(e),"boolean","scene::getLocalSessions"):e.reverse=!1,this.processCallback(e);var n=c(this.protocol.sessionSet),o=0,i=e.lastSessionId;if(a(e)){var s,p=v(n);try{for(p.s();!(s=p.n()).done;){var d=s.value,f=d.id;if(i)f===i&&(i=void 0);else if(void 0!==d.lastMsg){if(++o>e.limit)break;t.push(u({},d));}}}catch(e){p.e(e);}finally{p.f();}}else{var g,h,y=v(n);try{for(y.s();!(h=y.n()).done;){var b=h.value;if(i===b.id)break;void 0!==b.lastMsg&&t.push(b);}}catch(e){y.e(e);}finally{y.f();}t=a(g=l(t).call(t,-e.limit)).call(g);}this.logger.debug("getLocalSessions::sessions is",t),t=r(t).call(t,function(e){return m(C).call(C,e);}),e.sessions=t,delete e.callback,e.done(void 0,e);},T.getLocalSession=function(e){var t=this,n=t.db,r=null;if(S.verifyOptions(e,"sessionId","scene::getLocalSession"),S.verifyParamType("sessionId",e.sessionId,"string","scene::getLocalSession"),r=t.protocol.getSessionInCache(e.sessionId),t.logger.debug("getLocalSession::cache session is",r),!r&&n.enable)return t.processCallback(e),void n.getSession(e.sessionId).then(function(n){n&&(r=n,t.logger.debug("getLocalSession::db session is",r)),e.done(null,r);}).catch(function(t){e.done(t);});e.done(null,m(C).call(C,r));},T.getLocalSessionsByMsgType=function(e){var t,n=this.db,s=e.exclude,a=[],c=l(t=x.validTypes).call(t,0);if(k(s)){if("string"==typeof s)s=[s];else if(!p(s))return void S.onParamInvalidType("exclude",["string","string array"],"","exclude::getLocalSessionsByMsgType");s=d(s).call(s,function(e){return f(c).call(c,e)>-1;}),c=d(c).call(c,function(e){return-1===f(s).call(s,e);});}this.processCallback(e),n.enable?n.getSessions().then(function(t){s&&0!==s.length?c&&0!==c.length?(o(t).call(t,function(e,r){var o,u,l;e.lastMsg&&f(s).call(s,e.lastMsg.type)>-1&&(o=r,u=e.id,l=n.getMsgs({sessionId:u,limit:1,types:c}).then(function(e){return e&&e[0]?t[o].lastMsg=e[0]:t[o].lastMsg=null,i.resolve();}),a.push(l));}),i.all(a).then(function(){e.done(null,{exclude:s,sessions:t});})):e.done(null,{exclude:s,sessions:r(t).call(t,function(e){e.lastMsg=null;})}):e.done(null,{exclude:s,sessions:t});}):e.done(null,{exclude:s,sessions:[]});},T.updateLocalSession=function(e){var t,n=this,r=n.db;S.verifyOptions(e,"id","scene::updateLocalSession"),n.processCallback(e);var o=S.filterObj(e,"id localCustom");function i(){!1!==e.needNotify&&n.protocol.onUpdateSession(o),e.session=o,e.done(t,e);}o=n.protocol.updateSessionInCache(e),r.enable&&o?r.updateSession(o).then(function(e){o=e,i();},function(e){t=e,i();}):i();},T.deleteLocalSession=function(e){var t,n=this,o=n.db;S.verifyOptions(e,"id","session::deleteLocalSession"),n.processCallback(e);var i=n.protocol.getSessionInCache(e.id);if(n.protocol.deleteSessionInCache(e.id,e.isLogic),o.enable?(e.isLogic?o.deleteSessionLogic(e.id):o.deleteSession(e.id,i)).then(function(){n.logger.info("sessions::deleteSessionInDb::delete session done",e.id),a();},function(e){t=e,a();}):a(),e.isDeleteRoaming){var s="string"==typeof e.id?[e.id]:e.id;s=r(s).call(s,function(e){return e.replace("-","|");}),this.sendCmd("deleteSessions",{sessions:s},function(){});}function a(){e.done(t,e);}},T.deleteSession=function(e,t){t||this.logger.warn("this api will be abandon,please use “deleteRoamingMsgBySession”"),S.verifyOptions(e,"scene to","session::deleteSession"),this.processCallback(e),e.sessions=[{scene:e.scene,to:e.to}],this.deleteSessions(e);},T.deleteRoamingMsgBySession=function(e){this.deleteSession(e,!0);},T.deleteSessions=function(e){var t,n;S.verifyOptions(e,"sessions","session::deleteSessions"),S.verifyParamType("sessions",e.sessions,"array","session::deleteSessions"),o(t=e.sessions).call(t,function(e,t){S.verifyOptions(e,"scene to",!0,"sessions["+t+"].","session::deleteSessions");}),this.processCallback(e),this.sendCmd("deleteSessions",{sessions:r(n=e.sessions).call(n,function(e){return e.scene+"|"+e.to;})},e.callback);},T.getServerSessions=function(e){k(e.minTimestamp)&&S.verifyParamType("minTimestamp",e.minTimestamp,"number","session::deleteSessions"),k(e.maxTimestamp)&&S.verifyParamType("maxTimestamp",e.maxTimestamp,"number","session::deleteSessions"),k(e.needLastMsg)&&(e.needLastMsg=!1===e.needLastMsg?0:1),k(e.limit)&&(S.verifyParamType("limit",e.limit,"number","session::deleteSessions"),S.verifyParamMax("limit",e.limit,100,"scene::getLocalSessions")),this.processCallback(e),this.sendCmd("getServerSessions",{sessionReqTag:e},e.callback);},T.getServerSession=function(e){S.verifyOptions(e,"scene to","scene::getServerSession"),S.verifyParamValid("scene",e.scene,this.message.validScenes,"scene::getServerSession"),S.verifyParamType("to",e.to,"string","to::getServerSession");var t=e.scene+"|"+e.to;"superTeam"===e.scene&&(t="super_team|"+e.to),this.processCallback(e),this.sendCmd("getServerSession",{session:{id:t}},e.callback);},T.updateServerSession=function(e){S.verifyOptions(e,"scene to","scene::updateServerSession"),S.verifyParamValid("scene",e.scene,this.message.validScenes,"scene::updateServerSession"),S.verifyParamType("to",e.to,"string","to::updateServerSession"),k(e.extra)&&S.verifyParamType("extra",e.extra,"string","extra::updateServerSession");var t=e.scene+"|"+e.to;"superTeam"===e.scene&&(t="super_team|"+e.to),this.processCallback(e),this.sendCmd("updateServerSession",{session:{id:t,ext:e.extra||""}},e.callback);},T.deleteServerSessions=function(e){var t,n=this;S.verifyOptions(e,"sessions","scene::deleteServerSessions"),S.verifyParamType("sessions",e.sessions,"array","sessions::deleteServerSessions");var r=[];o(t=e.sessions).call(t,function(e){S.verifyParamValid("scene",e.scene,n.message.validScenes,"scene::deleteServerSessions"),S.verifyParamType("to",e.to,"string","to::deleteServerSessions");var t=e.scene+"|"+e.to;"superTeam"===e.scene&&(t="super_team|"+e.to),r.push({id:t});}),this.processCallback(e),this.sendCmd("deleteServerSessions",{sessions:r},e.callback);},T.updateSessionsWithMoreRoaming=function(e){var t;if(S.verifyOptions(e,"msg","session::updateSessionsWithMoreRoaming"),S.verifyCallback(e,"done","session::updateSessionsWithMoreRoaming"),!this.db.enable)return e.done(null,"db is disable");var n={time:e.msg.time,idServer:e.msg.idServer,to:e.msg.to,from:e.msg.from};S.verifyParamType("msg.time",e.msg.time,"number","time::updateSessionsWithMoreRoaming"),S.verifyParamType("msg.idServer",e.msg.idServer,"string","idServer::updateSessionsWithMoreRoaming"),S.verifyParamType("msg.from",e.msg.from,"string","from::updateSessionsWithMoreRoaming"),S.verifyParamType("msg.to",e.msg.to,"string","to::updateSessionsWithMoreRoaming"),S.verifyParamValid("scene",e.msg.scene,this.message.validScenes,"scene::updateSessionsWithMoreRoaming");var r=n.to===this.account?n.from:n.to;n.id=s(t="".concat(e.msg.scene,"-")).call(t,r),this.db.updateSessionsWithMoreRoaming(n).then(function(t){e.done(null,t);}).catch(function(t){e.done(t);});},T.deleteSessionsWithMoreRoaming=function(e){if(S.verifyOptions(e,"id","session::deleteSessionsWithMoreRoaming"),S.verifyCallback(e,"done","session::deleteSessionsWithMoreRoaming"),!this.db.enable)return e.done(null,"db is disable");this.db.deleteSessionsWithMoreRoaming(e.id).then(function(t){e.done(null,t);}).catch(function(t){e.done(t);});},T.getSessionsWithMoreRoaming=function(e){if(S.verifyCallback(e,"done","session::getSessionsWithMoreRoaming"),!this.db.enable)return e.done(null,"db is disable");this.db.getSessionsWithMoreRoaming(e.id).then(function(t){e.done(null,t);}).catch(function(t){e.done(t);});};},function(e,t,n){var r=n(109),o=n(780),i=n(781),s=n(144),a=n(145),c=n(58),u=n(17),l=n(16),m=n(2),p=n(30),d=n(158),f=n(7),g=n(9),h=n(6),y=n(10),v=n(786),b=n(5),T=n(59),S=n(60),M=n(61),k=n(62),x=n(46),C=["callback","done"];function I(e,t){var n=b(e);if(T){var r=T(e);t&&(r=u(r).call(r,function(t){return S(e,t).enumerable;})),n.push.apply(n,r);}return n;}function _(e){for(var t=1;t<arguments.length;t++){var n,r,o=null!=arguments[t]?arguments[t]:{};t%2?m(n=I(Object(o),!0)).call(n,function(t){c(e,t,o[t]);}):M?k(e,M(o)):m(r=I(Object(o))).call(r,function(t){x(e,t,S(o,t));});}return e;}var w=n(34).fn,P=n(0),A=P.undef,O=P.notundef,E=n(41),R=n(141),j=n(140),N=n(39),U=n(56);w.sendG2Msg=function(e){return this.processCallback(e),e.msg=new this.message.G2Message(e),this.sendMsg(e);},w.beforeSendMsg=function(e){var t,n=this.protocol,r=e.msg;switch(r.to===this.account&&(r.fromDeviceId=E.deviceId),r.userUpdateTime=n.myInfo&&n.myInfo.updateTime,r.getScene()){case"p2p":t="sendMsg";break;case"team":t="sendTeamMsg";break;case"superTeam":t="sendSuperTeamMsg";}u(e)&&(t="sendFilterMsg",r.filter=!0),e.cmd=t;},w.afterSendMsg=function(e){var t=e.rtnMsg;if(!t||!t.ignore){var n=this.protocol.getSessionInCache(t.sessionId);e.isLocal&&n&&n.lastMsg&&t.time<n.lastMsg.time||this.protocol.onUpdateSession(R.genSessionByMsg(t));}},w.beforeForwardMsg=function(e){P.verifyOptions(e,"msg scene to","msg::beforeForwardMsg"),e.msg.scene=e.scene,e.msg.to=e.to;},w.markMsgRead=function(e){var t=this.protocol;!e||this.db.enable||t.options.autoMarkRead?this.logger.warn("api::markMsgRead: 不需要标记消息为已收到 (没有消息, 或者启用了数据库, 或者启用了自动标记已收到)"):t.markMsgRead(e,!0);},w.sendMsgReceipt=function(e){if(P.verifyOptions(e),this.processCallback(e),e.msg){P.verifyOptions(e,"msg","msg::sendMsgReceipt");var t=e.msg;P.verifyOptions(t,"target idClient time",!0,"msg.","msg::sendMsgReceipt"),this.protocol.shouldSendMsgReceipt(t)?this.sendCmd("sendMsgReceipt",{msgReceipt:{to:t.target,idClient:t.idClient,time:t.time}},e.callback):e.done();}else e.done();},w.isMsgRemoteRead=function(e){return this.protocol.isMsgRemoteRead(e);},w.recallMsg=function(e){this.deleteMsg(e,!0);},w.deleteMsg=function(e,t){var n;t||this.logger.warn("this api will be abandon,please use “recallMsg”");P.verifyOptions(e,"msg","msg::deleteMsg");var r=e.msg;if("team"!==r.scene&&r.from!==this.account||"success"!==r.status||r.isLocal)return e.done(N.newParamError("只能删除自己发的, 并且发送成功的消息，且不能是本地消息",{callFunc:"msg::deleteMsg"}),e);P.verifyOptions(r,["scene","to","from","time","idClient","idServer"],!0,"msg.","msg::deleteMsg"),P.verifyParamValid("msg.scene",r.scene,this.message.validScenes,"msg::deleteMsg"),this.processPs(e),this.processCallback(e);var o={deletedIdClient:r.idClient,deletedIdServer:r.idServer,time:r.time,from:r.from,to:r.to,opeAccount:r.from},i="superTeam"===r.scene?"deleteSuperTeamMsg":"deleteMsg";o.type="deleteMsg"+r.scene[0].toUpperCase()+l(n=r.scene).call(n,1);var s=["ps","apnsText","pushPayload","env","opeAccount","attach"];m(s).call(s,function(t){e[t]&&(o[t]=e[t]);}),o=new j(o),this.sendCmd(i,{sysMsg:o,msg:r},e.callback);},w.deleteMsgSelf=function(e){P.verifyOptions(e,"msg","msg::deleteMsgSelf");var t=e.msg;if("superTeam"===t.scene)return e.done(N.newParamError("单向删除暂不支持超大群场景",{callFunc:"msg::deleteMsgSelf"}),e);P.verifyOptions(t,["scene","to","from","time","idClient","idServer"],!0,"msg.","msg::deleteMsgSelf"),P.verifyParamValid("msg.scene",t.scene,this.message.validScenes,"msg::deleteMsgSelf"),this.processCallback(e);var n={scene:"p2p"===t.scene?1:2,from:t.from,to:t.to,time:t.time,idClient:t.idClient,idServer:t.idServer,custom:e.custom};this.sendCmd("deleteMsgSelf",{deleteMsgSelfTag:n},e.callback);},w.deleteMsgSelfBatch=function(e){var t,n,r,o=this;if(P.verifyOptions(e,"msgs","msg::deleteMsgSelfBatch"),(!p(e.msgs)||0===e.msgs.length||e.msgs.length>100)&&P.onParamError("msgs应该是数组且数据长度应大于0小于等于100","msg::deleteMsgSelfBatch"),d(t=e.msgs).call(t,function(e){return"superTeam"===e.scene;}))return e.done(N.newParamError("消息列表中存在超大群消息，单向删除暂不支持超大群场景",{callFunc:"msg::deleteMsgSelfBatch"}),e);m(n=e.msgs).call(n,function(e){P.verifyOptions(e,["scene","to","from","time","idClient","idServer"],!0,"msg.","msg::deleteMsgSelfBatch"),P.verifyParamValid("msg.scene",e.scene,o.message.validScenes,"msg::deleteMsgSelfBatch");}),this.processCallback(e);var i=f(r=e.msgs).call(r,function(t){var n;return{scene:"p2p"===t.scene?1:2,from:t.from,to:t.to,time:t.time,idClient:t.idClient,idServer:t.idServer,sessionId:t.sessionId||g(n="".concat(t.scene,"-")).call(n,t.to),custom:e.custom};});this.sendCmd("deleteMsgSelfBatch",{deleteMsgSelfTags:i},e.callback);};var D={text:0,image:1,audio:2,video:3,geo:4,notification:5,file:6,tip:10,robot:11,custom:100};w.getHistoryMsgs=function(e){this.protocol.syncing&&this.logger.warn("Please call getHistoryMsgs after onsyncdone callback"),P.verifyOptions(e,"scene to","msg::getHistoryMsgs"),P.verifyParamValid("scene",e.scene,this.message.validScenes,"msg::getHistoryMsgs"),void 0===e.beginTime&&(e.beginTime=0);var t,n=this.protocol.getSessionInCache(e.scene+"-"+e.to),r=n&&n.lastEmptyTime;if(r>e.beginTime&&(e.beginTime=r),P.verifyParamType("beginTime",e.beginTime,"number","msg::getHistoryMsgs"),void 0===e.endTime&&(e.endTime=0),P.verifyParamType("endTime",e.endTime,"number","msg::getHistoryMsgs"),e.lastMsgId=e.lastMsgId&&+e.lastMsgId?e.lastMsgId:"0",void 0===e.limit&&(e.limit=100),P.verifyParamType("limit",e.limit,"number","msg::getHistoryMsgs"),P.verifyParamMax("limit",e.limit,100,"msg::getHistoryMsgs"),O(h(e))?P.verifyParamType("reverse",h(e),"boolean","msg::getHistoryMsgs"):e.reverse=!1,O(e.asc)?P.verifyParamType("asc",e.asc,"boolean","msg::getHistoryMsgs"):e.asc=!1,A(e.msgTypes))e.msgTypes=[];else if(p(e.msgTypes)){var o,i;e.msgTypes=f(o=e.msgTypes).call(o,function(e){return D[e];}),e.msgTypes=u(i=e.msgTypes).call(i,function(e){return"number"==typeof e;});}else"number"==typeof D[e.msgTypes]?e.msgTypes=[D[e.msgTypes]]:e.msgTypes=[];switch(this.processCallback(e),e.cbaop=function(t,n){if(!t){var r;if(e.asc)n.msgs=h(r=n.msgs).call(r);n.msgs=U.deduplication(n.msgs);}},e.scene){case"p2p":t="getHistoryMsgs";break;case"team":t="getTeamHistoryMsgs";break;case"superTeam":t="getSuperTeamHistoryMsgs";}var s={scene:e.scene,to:e.to,beginTime:e.beginTime,endTime:e.endTime,lastMsgId:e.lastMsgId,limit:e.limit,reverse:h(e),msgTypes:e.msgTypes};this.sendCmd(t,s,e.callback);},w.searchHistoryMsgs=function(e){P.verifyOptions(e,"scene to keyword","msg::searchHistoryMsgs"),P.verifyParamValid("scene",e.scene,this.message.validScenes,"msg::searchHistoryMsgs"),void 0===e.beginTime&&(e.beginTime=0);var t,n=this.protocol.getSessionInCache(e.scene+"-"+e.to),r=n&&n.lastEmptyTime;switch(r>e.beginTime&&(e.beginTime=r),P.verifyParamType("beginTime",e.beginTime,"number","msg::searchHistoryMsgs"),void 0===e.endTime&&(e.endTime=0),P.verifyParamType("endTime",e.endTime,"number","msg::searchHistoryMsgs"),void 0===e.limit&&(e.limit=100),P.verifyParamType("limit",e.limit,"number","msg::searchHistoryMsgs"),P.verifyParamMax("limit",e.limit,100,"msg::searchHistoryMsgs"),O(h(e))?P.verifyParamType("reverse",h(e),"boolean","msg::searchHistoryMsgs"):e.reverse=!1,O(e.asc)?P.verifyParamType("asc",e.asc,"boolean","msg::searchHistoryMsgs"):e.asc=!1,this.processCallback(e),e.asc&&(e.cbaop=function(e,t){var n;e||(t.msgs=h(n=t.msgs).call(n));}),e.scene){case"p2p":t="searchHistoryMsgs";break;case"team":t="searchTeamHistoryMsgs";}var o=P.filterObj(e,"scene to beginTime endTime keyword limit reverse");this.sendCmd(t,o,e.callback);},w.getLocalMsgs=function(e){var t=this,n=t.db,r=[];P.verifyOptions(e);var o=!1;O(e.start)&&(o=!0,P.verifyParamType("start",e.start,"number","msg::getLocalMsgs"));var i=!1;if(O(e.end)&&(i=!0,P.verifyParamType("end",e.end,"number","msg::getLocalMsgs")),o&&i&&e.end<=e.start&&P.onParamError("参数 end 必须晚于 start"),O(e.subTypes)&&P.verifyParamType("subTypes",e.subTypes,"array","msg::getLocalMsgs"),A(e.limit)&&(e.limit=100),P.verifyParamType("limit",e.limit,"number","msg::getLocalMsgs"),P.verifyParamMin("limit",e.limit,1,"msg::getLocalMsgs"),t.processCallback(e),n.enable){var s=new Date().getTime();n.getMsgs(e).then(function(n){var o;r=n,t.logger.info(g(o="api::getLocalMsgs: query db cost ".concat(new Date().getTime()-s," ms and the conditions is ")).call(o,y(e))),a();},function(e){(e=e||{}).message=e.message||"msg::getLocalMsgs:db error",a();});}else a();function a(){var t=P.simpleClone(e);t.msgs=r,delete t.callback,delete t.done,e.done(null,t);}},w.getLocalMsgsInUnread=function(e){var t=this;P.validate({sessionId:{type:"string",allowEmpty:!1}},e),this.getLocalSession({sessionId:e.sessionId,done:function done(n,r){n?e.done&&e.done(n):r?(r.ack=r.ack||0,t.getLocalMsgs(_({sessionId:e.sessionId,start:r.ack,limit:v,filterFunc:function filterFunc(e){return"in"===e.flow&&!0===e.isUnreadable;},done:function done(){}},e))):e.done&&e.done(new Error("session ".concat(e.sessionId," not exist")));}});},w.getLocalMsgByIdClient=function(e){var t=this.db,n=null,r=null;function o(){e.msg=r,e.done(n,e);}P.verifyOptions(e,"idClient","msg::getLocalMsgByIdClient"),this.processCallback(e),t.enable?t.getMsgByIdClient(e.idClient).then(function(e){e&&(r=e),o();},function(e){n=e,o();}):(this.logger.warn("because db is false,error is null"),o());},w.getLocalMsgsByIdClients=function(e){var t,n=this.db,r=[];function o(){e.msgs=r,e.done(t,e);}P.verifyOptions(e,"idClients","msg::getLocalMsgByIdClients"),P.verifyParamType("idClients",e.idClients,"array","msg::getLocalMsgByIdClients"),this.processCallback(e),n.enable?n.getMsgsByIdClients(e.idClients).then(function(e){r=u(e).call(e,function(e){return!!e;}),o();},function(e){t=e,o();}):o();},w.updateLocalMsg=function(e){var t,n=this.db,r=null;if(P.verifyOptions(e,"idClient","msg::updateLocalMsg"),this.processCallback(e),n.enable){var o=P.filterObj(e,"idClient localCustom");n.updateMsg(o).then(function(e){r=e,i();},function(e){t=e,i();});}else i();function i(){e.msg=r,e.done(t,e);}},w.deleteLocalMsg=function(){var e=a(s.mark(function e(t){var n,r,o,i;return s.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return i=function i(){t.done(r,t);},n=this,P.verifyOptions(t,"msg","msg::deleteLocalMsg"),o=t.msg,P.verifyOptions(o,"idClient sessionId",!0,"msg.","msg::deleteLocalMsg"),n.processCallback(t),e.prev=6,e.next=9,n.protocol.deleteLocalMsg(o);case 9:i(),e.next=16;break;case 12:e.prev=12,e.t0=e.catch(6),r=e.t0,i();case 16:case"end":return e.stop();}}},e,this,[[6,12]]);}));return function(t){return e.apply(this,arguments);};}(),w.deleteLocalMsgsBySession=function(e){var t,n=this,r=n.db;P.verifyOptions(e,"scene to","msg::deleteLocalMsgsBySession"),P.verifyParamValid("scene",e.scene,n.message.validScenes,"msg::deleteLocalMsgsBySession"),e.sessionId=e.scene+"-"+e.to,e.delLastMsg=!0===e.delLastMsg,e.isTag=!0===e.isTag;var o=new Date().getTime();function i(){e.done(t,e);}n.processCallback(e);var s={id:e.sessionId};e.delLastMsg&&(s.lastMsg=null),e.isTag&&(s.lastEmptyTime=o),r.enable?r.deleteMsgsBySessionId(e).then(function(){e.delLastMsg||e.isTag?r.updateSession(s).then(function(t){n.protocol.onUpdateSession(t),e.session=t,i();}):i();}).catch(function(e){t=e,i();}):(this.logger.warn("because db is false,error is null"),i(),(e.delLastMsg||e.isTag)&&n.protocol.onUpdateSession(s));},w.deleteLocalMsgs=function(e){var t;function n(){e.done(t,e);}e.updateSession=!1!==e.updateSession,P.verifyOptions(e,"sessionId","msg::deleteLocalMsgsBySession"),O(e.start)&&P.verifyParamType("start",e.start,"number","msg::deleteLocalMsgs"),O(e.end)&&P.verifyParamType("end",e.end,"number","msg::deleteLocalMsgs"),O(e.end)&&O(e.start)&&e.end<=e.start&&P.onParamError("参数 end 必须大于 start"),this.processCallback(e),this.protocol.deleteLocalMsgs(e).then(function(){n();},function(e){t=e,n();});},w.deleteAllLocalMsgs=function(e){var t,n=this.db;function r(){e.done(t,e);}this.processCallback(e),this.protocol.sessionSet={},n.enable?n.deleteAllMsgs().then(function(){r();},function(e){t=e,r();}):(this.logger.warn("because db is false,error is null"),r());},w.saveMsgsToLocal=function(e){var t;this.db.enable||(this.logger.warn("because db is false,error is null"),e.done(null,[])),P.verifyOptions(e,"msgs done","msg::saveMsgsToLocal"),P.verifyParamType("msgs",e.msgs,"Array","msg::saveMsgsToLocal");var n=f(t=e.msgs).call(t,function(e){var t=_({},e);return t.hasOwnProperty("needUpdateSession")||(t.needUpdateSession=!0),t;});this.db.putMsg(n).then(function(t,n){n?e.done(n):e.done(null,t);});},w.clearServerHistoryMsgs=function(e){P.verifyOptions(e,"account","msg::clearServerHistoryMsgs");var t=!1!==e.delRoam;this.processCallback(e),this.sendCmd("clearServerHistoryMsgs",{clearMsgsParams:{account:e.account,delRoam:t?1:0}},e.callback);},w.clearServerHistoryMsgsWithSync=function(e){P.verifyOptions(e,"scene to","msg::clearServerHistoryMsgsWithSync");var t=void 0===e.isDeleteRoam||!0===e.isDeleteRoam,n={type:"team"===e.scene?2:1,isDeleteRoam:t?1:0,isSyncSelf:!0===e.isSyncSelf?1:0};n[2===n.type?"toTid":"otherAccid"]=e.to,void 0!==e.ext&&(n.ext=e.ext),this.processCallback(e),this.sendCmd("clearServerHistoryMsgsWithSync",{clearMsgsParamsWithSync:n},e.callback);},w.msgFtsInServer=function(e){this.processCallback(e);var t=i({},(o(e),e));P.validate({keyword:{type:"string"},fromTime:{type:"number",required:!1},toTime:{type:"number",required:!1},sessionLimit:{type:"number",min:0,required:!1},msgLimit:{type:"number",min:0,required:!1},order:{type:"enum",values:["ASC","DESC"],required:!1},p2pList:{type:"array",required:!1},teamList:{type:"array",required:!1},senderList:{type:"array",required:!1},msgTypeList:{type:"array",required:!1},msgSubTypeList:{type:"array",required:!1}},t,"msg::msgFtsInServer"),O(t.toTime)&&O(t.fromTime)&&t.toTime<t.fromTime&&P.onParamError("Options error: toTime should be greater than fromTime");var n,r={ASC:1,DESC:2};(t.order&&r[t.order]&&(t.order=r[t.order]),t.msgTypeList)&&(t.msgTypeList=f(n=t.msgTypeList).call(n,function(e){return D[e];}));var s=["p2pList","teamList","senderList","msgTypeList","msgSubTypeList"];m(s).call(s,function(e){p(t[e])&&(t[e]=t[e].join(","));}),this.sendCmd("msgFtsInServer",{msgFullSearchRequestTag:t},e.callback);},w.msgFtsInServerByTiming=function(e){this.processCallback(e);e.callback,e.done;var t=r(e,C);P.validate({keyword:{type:"string"},fromTime:{type:"number",required:!1},toTime:{type:"number",required:!1},msgLimit:{type:"number",min:0,required:!1},order:{type:"enum",values:["ASC","DESC"],required:!1},p2pList:{type:"array",required:!1},teamList:{type:"array",required:!1},senderList:{type:"array",required:!1},msgTypeList:{type:"array",required:!1},msgSubTypeList:{type:"array",required:!1}},t,"msg::msgFtsInServerByTimeSort"),O(t.toTime)&&O(t.fromTime)&&t.toTime<t.fromTime&&P.onParamError("Options error: toTime should be greater than fromTime");var n,o={ASC:1,DESC:2};(void 0===t.msgLimit&&(t.msgLimit=20),t.order&&o[t.order]&&(t.order=o[t.order]),t.msgTypeList)&&(t.msgTypeList=f(n=t.msgTypeList).call(n,function(e){return D[e];}));var i=["p2pList","teamList","senderList","msgTypeList","msgSubTypeList"];m(i).call(i,function(e){p(t[e])&&(t[e]=t[e].join(","));}),this.sendCmd("msgFtsInServerByTiming",{msgTimingFullSearchRequestTag:t},e.callback);};},function(e,t){e.exports=function(e){if(null==e)throw new TypeError("Cannot destructure "+e);},e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){var r=n(782),o=n(184);function i(){var t;return e.exports=i=r?o(t=r).call(t):function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n){Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}}return e;},e.exports.__esModule=!0,e.exports.default=e.exports,i.apply(this,arguments);}e.exports=i,e.exports.__esModule=!0,e.exports.default=e.exports;},function(e,t,n){e.exports=n(783);},function(e,t,n){e.exports=n(784);},function(e,t,n){var r=n(785);e.exports=r;},function(e,t,n){var r=n(284);e.exports=r;},function(e,t,n){e.exports=n(787);},function(e,t,n){var r=n(788);e.exports=r;},function(e,t,n){n(789),e.exports=9007199254740991;},function(e,t,n){n(1)({target:"Number",stat:!0,nonConfigurable:!0,nonWritable:!0},{MAX_SAFE_INTEGER:9007199254740991});},function(e,t,n){var r=n(6),o=n(30),i=n(16),s=n(2),a=n(10),c=n(5),u=n(17),l=n(34).fn,m=n(0),p=n(682),d=n(684),f=(n(56),m.notundef);function g(e,t,n,r){n=n||"",m.verifyParamType(n+"from",e.from,"string",t),m.verifyParamType(n+"to",e.to,"string",t),m.verifyParamType(n+"idServer",e.idServer,"string",t),m.verifyParamType(n+"time",e.time,"number",t),m.verifyParamValid(n+"scene",e.scene,this.message.validScenes,t),r||m.verifyParamType(n+"idClient",e.idClient,"string",t);}l.getThreadMsgs=function(e){m.verifyCallback(e,"done","msg::getThreadMsgs"),m.verifyOptions(e,"scene threadMsgFromAccount threadMsgToAccount threadMsgIdServer threadMsgTime","msg::getThreadMsgs"),m.verifyParamType("threadMsgFromAccount",e.threadMsgFromAccount,"string","msg::getThreadMsgs"),m.verifyParamType("threadMsgToAccount",e.threadMsgToAccount,"string","msg::getThreadMsgs"),m.verifyParamType("threadMsgIdServer",e.threadMsgIdServer,"string","msg::getThreadMsgs"),m.verifyParamType("threadMsgTime",e.threadMsgTime,"number","msg::getThreadMsgs"),m.verifyParamValid("scene",e.scene,this.message.validScenes,"msg::getThreadMsgs"),this.processCallback(e);var t={scene:this.message.sceneMap[e.scene],from:e.threadMsgFromAccount,to:e.threadMsgToAccount,time:e.threadMsgTime,idServer:e.threadMsgIdServer},n={limit:e.limit<100?e.limit:100,beginTime:"number"==typeof e.beginTime?e.beginTime:0,reverse:!0===r(e)?1:0};"number"==typeof e.endTime&&(n.endTime=e.endTime,n.endTime<=n.beginTime&&m.onParamError("endTime应该大于beginTime","msg::getThreadMsgs")),e.lastMsgId&&(n.lastMsgId=e.lastMsgId),this.sendCmd("getThreadMsgs",{msg:t,threadMsgReq:n,NOTSTORE:"msg threadMsgReq"},e.callback);},l.getMsgsByIdServer=function(e){var t,n,r=this,a=this,c="msg::getMsgsByIdServer";m.verifyCallback(e,"done",c),(!o(e.reqMsgs)||0===e.reqMsgs.length||e.reqMsgs.length>100)&&m.onParamError("reqMsgs应该是数组且数据长度应大于0小于等于100",c),e.reqMsgs=i(t=e.reqMsgs).call(t,0),s(n=e.reqMsgs).call(n,function(e,t){g.call(a,e,c,"reqMsgs[".concat(t,"]."),!0),e.scene=r.message.sceneMap[e.scene];}),this.processCallback(e),this.sendCmd("getMsgsByIdServer",{reqMsgs:e.reqMsgs},e.callback);},l.addQuickComment=function(e){m.verifyOptions(e,"msg body","msg::addQuickComment"),g.call(this,e.msg,"msg::addQuickComment");var t=new p(e,"msg::addQuickComment");t.from=this.account;var n={scene:this.message.sceneMap[e.msg.scene],from:e.msg.from,to:e.msg.to,time:e.msg.time,idServer:e.msg.idServer,idClient:e.msg.idClient};this.processCallback(e),this.sendCmd("addQuickComment",{msg:n,comment:t},e.callback);},l.deleteQuickComment=function(e){m.verifyOptions(e,"msg body","msg::deleteQuickComment"),g.call(this,e.msg,"msg::deleteQuickComment");var t=new p(e,"msg::addQuickComment");t.from=this.account;var n={scene:this.message.sceneMap[e.msg.scene],from:e.msg.from,to:e.msg.to,time:e.msg.time,idServer:e.msg.idServer,idClient:e.msg.idClient};this.processCallback(e),this.sendCmd("deleteQuickComment",{msg:n,comment:t},e.callback);},l.getQuickComments=function(e){var t=this,n="msg::getQuickComments",r=this,i={},l={};m.verifyOptions(e,"msgs","msg::getQuickComments"),(!o(e.msgs)||0===e.msgs.length||e.msgs.length>20)&&m.onParamError("msgs应该是数组且数据长度应大于0小于等于20",n);var p=[];try{p=JSON.parse(a(e.msgs));}catch(e){m.onParamError("msgs 不是合法的对象",n);}s(p).call(p,function(e,o){g.call(r,e,n,"msgs[".concat(o,"]."),!0),e.scene=t.message.sceneMap[e.scene],i[e.idClient]=null,l[e.idClient]=o;}),this.processCallback(e),this.getLocalMsgsByIdClients({idClients:c(i),done:function done(t,n){var o,a=r.protocol.timetags.sync;!t&&n.msgs&&n.msgs.length&&a&&(s(o=n.msgs).call(o,function(e){i[e.idClient]=e;}),p=u(p).call(p,function(e){var t=i[e.idClient];return!t||(t.commentTimetag&&(e.timestamp=t.commentTimetag),!(t.commentTimetag>a));}));r.sendCmd("getQuickComments",{commentReq:p,idMap:i,indexMap:l},e.callback);}});},l.addCollect=function(e){m.verifyOptions(e,"type data","msg::addCollect");var t=new d(e,"msg::addCollect");this.processCallback(e),this.sendCmd("addCollect",{collect:t},e.callback);},l.deleteCollects=function(e){var t;m.verifyOptions(e,"collectList","msg::deleteCollects"),(!o(e.collectList)||0===e.collectList.length||e.collectList.length>100)&&m.onParamError("collectList应该是数组且数据长度应大于0小于等于100","msg::deleteCollects"),s(t=e.collectList).call(t,function(e,t){m.verifyParamType("collectList[".concat(t,"].id"),e.id,"string","msg::deleteCollects"),m.verifyParamType("collectList[".concat(t,"].createTime"),e.createTime,"number","msg::deleteCollects");}),this.processCallback(e),this.sendCmd("deleteCollects",{collectList:e.collectList},e.callback);},l.updateCollect=function(e){m.verifyOptions(e,"collect","msg::updateCollect"),m.verifyParamType("collect.id",e.collect.id,"string","msg::updateCollect"),m.verifyParamType("collect.createTime",e.collect.createTime,"number","msg::updateCollect"),this.processCallback(e),this.sendCmd("updateCollect",{collect:e.collect},e.callback);},l.getCollects=function(e){m.verifyCallback(e,"done","msg::getCollects");var t={},n=["type","beginTime","endTime","limit"];s(n).call(n,function(n){f(e[n])&&(m.verifyParamType(n,e[n],"number","msg::getCollects"),t[n]=e[n]);}),e.limit>100&&m.onParamError("limit不能大于100","msg::getCollects"),e.beginTime>e.endTime&&m.onParamError("beginTime不能大于endTime","msg::getCollects"),f(e.lastId)&&(m.verifyParamType("lastId",e.lastId,"string","msg::getCollects"),t.lastMsgId=e.lastId),f(r(e))&&(t.reverse=!0===r(e)?1:0),this.processCallback(e),this.sendCmd("getCollects",{collectQuery:t,NOTSTORE:"collectQuery"},e.callback);},l.addStickTopSession=function(e){m.verifyOptions(e,"id","msg::addStickTopSession");var t=m.getIdArray(e.id);m.verifyParamValid("id的前半部分",t[0],this.message.validScenes,"msg::addStickTopSession"),m.verifyParamType("id的后半部分",t[1],"string","msg::addStickTopSession"),"superTeam"===t[0]&&(t[0]="super_team");var n={id:t=t.join("|")};e.topCustom&&(m.verifyParamType("topCustom",e.topCustom,"string","msg::addStickTopSession"),n.topCustom=e.topCustom),this.processCallback(e),this.sendCmd("addStickTopSession",{stickTopSession:n},e.callback);},l.deleteStickTopSession=function(e){m.verifyOptions(e,"id","msg::deleteStickTopSession");var t=m.getIdArray(e.id);m.verifyParamValid("id的前半部分",t[0],this.message.validScenes,"msg::deleteStickTopSession"),m.verifyParamType("id的后半部分",t[1],"string","msg::deleteStickTopSession"),"superTeam"===t[0]&&(t[0]="super_team"),t=t.join("|"),this.processCallback(e),this.sendCmd("deleteStickTopSession",{stickTopSession:{id:t}},e.callback);},l.updateStickTopSession=function(e){m.verifyOptions(e,"id","msg::updateStickTopSession");var t=m.getIdArray(e.id);m.verifyParamValid("id的前半部分",t[0],this.message.validScenes,"msg::updateStickTopSession"),m.verifyParamType("id的后半部分",t[1],"string","msg::updateStickTopSession"),"superTeam"===t[0]&&(t[0]="super_team");var n={id:t=t.join("|")};e.topCustom&&(m.verifyParamType("topCustom",e.topCustom,"string","msg::updateStickTopSession"),n.topCustom=e.topCustom),this.processCallback(e),this.sendCmd("updateStickTopSession",{stickTopSession:n},e.callback);},l.getStickTopSessions=function(e){m.verifyOptions(e,"done","msg::getStickTopSessions"),this.processCallback(e);var t,n=this.protocol.sessionSet,r=[];for(var o in n){(t=this.protocol.getSessionInCache(o,e.findDelete))&&t.isTop&&r.push(n[o]);}e.callback(null,r);},l.addMsgPin=function(e){m.verifyOptions(e,"msg","msg::addMsgPin"),g.call(this,e.msg,"msg::addMsgPin");var t={pinFrom:this.account};f(e.pinCustom)&&(m.verifyParamType("pinCustom",e.pinCustom,"string","msg::addMsgPin"),t.pinCustom=e.pinCustom);var n={scene:this.message.sceneMap[e.msg.scene],from:e.msg.from,to:e.msg.to,time:e.msg.time,idServer:e.msg.idServer,idClient:e.msg.idClient};this.processCallback(e),this.sendCmd("addMsgPin",{msg:n,pinTag:t},e.callback);},l.updateMsgPin=function(e){m.verifyOptions(e,"msg","msg::updateMsgPin"),g.call(this,e.msg,"msg::updateMsgPin");var t={pinFrom:this.account};f(e.pinCustom)&&(m.verifyParamType("pinCustom",e.pinCustom,"string","msg::updateMsgPin"),t.pinCustom=e.pinCustom);var n={scene:this.message.sceneMap[e.msg.scene],from:e.msg.from,to:e.msg.to,time:e.msg.time,idServer:e.msg.idServer,idClient:e.msg.idClient};this.processCallback(e),this.sendCmd("updateMsgPin",{msg:n,pinTag:t},e.callback);},l.deleteMsgPin=function(e){m.verifyOptions(e,"msg","msg::deleteMsgPin"),g.call(this,e.msg,"msg::deleteMsgPin");var t={pinFrom:this.account},n={scene:this.message.sceneMap[e.msg.scene],from:e.msg.from,to:e.msg.to,time:e.msg.time,idServer:e.msg.idServer,idClient:e.msg.idClient};this.processCallback(e),this.sendCmd("deleteMsgPin",{msg:n,pinTag:t},e.callback);},l.getMsgPins=function(e){var t=this;m.verifyOptions(e,"id","msg::getMsgPins");var n=this.db,r=m.getIdArray(e.id);m.verifyParamValid("id的前半部分",r[0],this.message.validScenes,"msg::getMsgPins"),m.verifyParamType("id的后半部分",r[1],"string","msg::getMsgPins"),"superTeam"===r[0]&&(r[0]="super_team");var o={sessionId:r=r.join("|"),timetag:0};if(this.processCallback(e),n.enable){var i=this.protocol.timetags.sync;n.getTimetag("pin-"+e.id).then(function(r){r>i?n.getMsgPins(e.id).then(function(t){return e.callback(null,{pins:t||[]});}).catch(function(t){return e.callback(t);}):(o.timetag=r,s.call(t));});}else s.call(this);function s(){this.sendCmd("getMsgPins",{msgPinReq:o,id:e.id,NOTSTORE:"msgPinReq"},e.callback);}};},function(e,t,n){var r=n(3),o=n(17),i=n(2),s=n(6),a=n(34).fn,c=n(0),u=c.undef,l=c.notundef,m=n(140);a.markSysMsgRead=function(e){var t,n=this.db,s=r.resolve(),a=this.protocol;c.verifyOptions(e,"sysMsgs","sysmsg::markSysMsgRead");var u=e.sysMsgs;function l(){e.done(t,e);}c.isArray(u)||(u=[u]),n.enable?s=n.markSysMsgRead(u).then(function(e){u=e,a.onUpdateSysMsg(e);}):(u=o(u).call(u,function(e){return!e.read;})).length&&(a.options.autoMarkRead||a.markSysMsgRead(u,!0),i(u).call(u,function(e){e.read=!0;}),a.onUpdateSysMsg(u)),s.then(function(){return a.reduceSysMsgUnread(u);}).then(l,function(e){t=e,l();});},a.sendCustomSysMsg=function(e){c.verifyOptions(e,"scene to content","sysmsg::sendCustomSysMsg"),c.verifyParamValid("scene",e.scene,this.message.validScenes,"sysmsg::sendCustomSysMsg"),this.processCallback(e);var t="sendCustomSysMsg";return"p2p"===e.scene?e.type="customP2p":"superTeam"===e.scene?(e.type="customSuperTeam",t="sendSuperTeamCustomSysMsg"):e.type="customTeam",e.sysMsg=new m(e),o(e)&&(t="sendFilterCustomSysMsg"),this.sendCmd(t,{sysMsg:e.sysMsg,single:!0},e.callback),this.formatReturnSysMsg(e.sysMsg);},a.formatReturnSysMsg=function(e){return e=c.copy(e),this.protocol.completeSysMsg(e),e.status="sending",e=s(m).call(m,e);},a.getLocalSysMsgs=function(e){var t,n=this.db,r=[];function o(){e.sysMsgs=r,e.done(t,e);}c.verifyOptions(e),e.category&&c.verifyParamValid("category",e.category,m.validCategories,"sysmsg::getLocalSysMsgs"),e.type&&c.verifyParamValid("type",e.type,m.validTypes,"sysmsg::getLocalSysMsgs"),u(e.limit)&&(e.limit=100),c.verifyParamType("limit",e.limit,"number","sysmsg::getLocalSysMsgs"),c.verifyParamMax("limit",e.limit,100,"sysmsg::getLocalSysMsgs"),l(s(e))?c.verifyParamType("reverse",s(e),"boolean","sysmsg::getLocalSysMsgs"):e.reverse=!1,this.processCallback(e),n.enable?n.getSysMsgs(e).then(function(e){r=e,o();},function(e){t=e,o();}):o();},a.updateLocalSysMsg=function(e){var t,n=this.db,r=null;if(c.verifyOptions(e,"idServer","sysmsg::updateLocalSysMsg"),this.processCallback(e),n.enable){var o=c.filterObj(e,"idServer state localCustom");n.updateSysMsg(o).then(function(e){r=e,i();},function(e){t=e,i();});}else i();function i(){e.sysMsg=r,e.done(t,e);}},a.deleteLocalSysMsg=function(e){var t,n=this.db;function r(){e.done(t,e);}c.verifyOptions(e,"idServer","sysmsg::deleteLocalSysMsg"),this.processCallback(e),n.enable?n.deleteSysMsg(e.idServer).then(function(){r();},function(e){t=e,r();}):r();},a.deleteAllLocalSysMsgs=function(e){var t,n=this,r=n.db;function o(){n.protocol.onUpdateSysMsgUnread({}),e.done(t,e);}n.processCallback(e),r.enable?r.deleteAllSysMsgs().then(function(){o();},function(e){t=e,o();}):o();};},function(e,t,n){var r=n(34).fn,o=n(0),i=n(14);r.getChatroomAddress=function(e){o.verifyOptions(e,"chatroomId","chatroom::getChatroomAddress");e.isWeixinApp=i.isWeixinApp,e.type=i.ipVersion,this.processCallback(e),this.sendCmd("getChatroomAddress",e);};},function(e,t){},function(e,t){},function(e,t,n){var r=n(34).fn,o=n(0);r.audioToText=function(e){o.verifyOptions(e,"url","audio::audioToText"),e.audioToText=o.filterObj(e,"url");this.processCallback(e),this.sendCmd("audioToText",e);};},function(e,t,n){var r=n(34).fn;r.clearDB=function(e){var t=this.db;this.processCallback(e);var n=e.done;t.enable?t.clear().then(n,n):n();},r.removeDB=function(e){var t=this.db;this.processCallback(e);var n=e.done;t.enable?t.destroy().then(n,n):n();},r.closeDB=function(e){var t=this.db;this.processCallback(e);var n=e.done;t.enable?t.close().then(n,n):n();};},function(e,t,n){var r=n(34).fn,o=n(288),i=n(0),s=i.undef;r.getPushNotificationMultiportConfig=function(){return this.protocol.getPushNotificationMultiportConfig();},r.updatePushNotificationMultiportConfig=function(e){i.verifyOptions(e),s(e.shouldPushNotificationWhenPCOnline)&&(e.shouldPushNotificationWhenPCOnline=!0),e.donnop=new o(e),this.processCallback(e),this.sendCmd("updateDonnop",e);};},function(e,t,n){var r=n(2),o=n(3),i=n(9),s=n(22),a=n(34).fn,c=n(0),u=n(799),l=n(800);function m(e){return"object"===s(e)&&(e.msgEventSubscribes?e=e.msgEventSubscribes:e.msgEventSubscribe?e=e.msgEventSubscribe:e.accounts?e=e.accounts:e.msgEvent&&(e=e.msgEvent).time&&(e.time=+e.time),1===e.sync?e.sync=!0:0===e.sync&&(e.sync=!1)),e;}a.batchSendEventsCmds=function(e,t,n){var s=this,a=c.dropArrayDuplicates(t.accounts);a=c.reshape2d(a,100);var u=[];r(a).call(a,function(n){u.push(new o(function(r,o){var i=c.simpleClone(t);i.accounts=n,s.sendCmdWithResp(e,i,function(e,t){e?o(e):r(m(t));});}));}),o.all(u).then(function(e){var t=null;if(e.length>0)if(e[0].msgEventSubscribe){var o=e[0].msgEventSubscribe;o=m(o);var s=[];r(e).call(e,function(e){s=i(s).call(s,e.accounts);}),t={accounts:s,msgEventSubscribe:o};}else t=[],r(e).call(e,function(e){t=i(t).call(t,e);});n(null,t);},function(e){n(e,null);});},a.publishEvent=function(e){var t=new u(e);t=t.assembleEvent(),this.processCallback(e),this.sendCmdWithResp("publishEvent",{msgEvent:t},function(t,n){t||(n=m(n)),e.callback(t,n);});},a.subscribeEvent=function(e){c.verifyOptions(e,"accounts","event::subscribeEvent");var t=new l(e);c.verifyParamType("accounts",e.accounts,"array","event::subscribeEvent"),this.processCallback(e),t=t.assembleEvent(),this.batchSendEventsCmds("subscribeEvent",{msgEventSubscribe:t,accounts:e.accounts},function(t,n){!t&&n&&(n={failedAccounts:n}),e.callback(t,n);});},a.unSubscribeEventsByAccounts=function(e){c.verifyOptions(e,"accounts","event::unSubscribeEventsByAccounts"),c.verifyParamType("accounts",e.accounts,"array","event::unSubscribeEventsByAccounts");var t=new l(e);t=t.assembleEvent(),this.processCallback(e),this.batchSendEventsCmds("unSubscribeEventsByAccounts",{msgEventSubscribe:t,accounts:e.accounts},function(t,n){!t&&n&&(n={failedAccounts:n}),e.callback(t,n);});},a.unSubscribeEventsByType=function(e){var t=new l(e);t=t.assembleEvent(),this.processCallback(e),this.sendCmdWithResp("unSubscribeEventsByType",{msgEventSubscribe:t},function(t,n){e.callback(t,n);});},a.querySubscribeEventsByAccounts=function(e){c.verifyOptions(e,"accounts","event::querySubscribeEventsByAccounts"),c.verifyParamType("accounts",e.accounts,"array","event::querySubscribeEventsByAccounts");var t=new l(e);t=t.assembleEvent(),this.processCallback(e),this.batchSendEventsCmds("querySubscribeEventsByAccounts",{msgEventSubscribe:t,accounts:e.accounts},function(t,n){!t&&n&&(n={msgEventSubscribes:n}),e.callback(t,n);});},a.querySubscribeEventsByType=function(e){var t=new l(e);t=t.assembleEvent(),this.processCallback(e),this.sendCmdWithResp("querySubscribeEventsByType",{msgEventSubscribe:t},function(t,n){t||(n={msgEventSubscribes:m(n)}),e.callback(t,n);});};},function(e,t,n){var r=n(4),o=n(0),i=o.notundef,s=n(39);function a(e){if(o.verifyOptions(e,"type value","event::MsgEvent"),o.verifyParamType("type",e.type,"number","event::MsgEvent"),o.verifyParamType("value",e.value,"number","event::MsgEvent"),this.type=e.type,this.value=e.value,this.idClient=o.guid(),i(e.custom)&&(this.custom=""+e.custom),this.validTime=e.validTime||604800,o.verifyParamType("validTime",this.validTime,"number","event::MsgEvent"),o.verifyParamMin("validTime",this.validTime,60,"event::MsgEvent"),o.verifyParamMax("validTime",this.validTime,604800,"event::MsgEvent"),i(e.broadcastType)){var t;if(o.verifyParamType("broadcastType",e.broadcastType,"number","event::MsgEvent"),r(t=[1,2]).call(t,e.broadcastType)<0)throw new s('参数错误"broadcastType":只能为1或2');this.broadcastType=e.broadcastType;}else this.broadcastType=2;i(e.sync)?(o.verifyParamType("sync",e.sync,"boolean","event::MsgEvent"),this.sync=e.sync):this.sync=!1;}a.prototype.assembleEvent=function(){return{type:this.type,value:this.value,idClient:this.idClient,custom:this.custom||"",validTime:this.validTime,broadcastType:this.broadcastType,sync:!0===this.sync?1:0};},e.exports=a;},function(e,t,n){var r=n(0),o=r.notundef;function i(e){r.verifyOptions(e,"type","event::MsgEventSubscribe"),r.verifyParamType("type",e.type,"number","event::MsgEventSubscribe"),r.findObjIndexInArray([1,2,3],e.type)<0&&r.verifyParamMin("type",e.type,1e5,"event::MsgEventSubscribe"),this.type=e.type,o(e.subscribeTime)?(r.verifyParamType("subscribeTime",e.subscribeTime,"number","event::MsgEventSubscribe"),r.verifyParamMin("subscribeTime",e.subscribeTime,60,"event::MsgEventSubscribe"),r.verifyParamMax("subscribeTime",e.subscribeTime,2592e3,"event::MsgEventSubscribe"),this.subscribeTime=e.subscribeTime):this.subscribeTime=2592e3,o(e.sync)?(r.verifyParamType("sync",e.sync,"boolean","event::MsgEventSubscribe"),this.sync=e.sync):this.sync=!0;}i.prototype.assembleEvent=function(){return{type:this.type,subscribeTime:this.subscribeTime,sync:!0===this.sync?1:0};},e.exports=i;},function(e,t,n){var r=n(35),o=n(34).fn,i=n(0);o.httpRequestProxy=function(e){i.verifyOptions(e,"path","misc::httpRequestProxy");var t=r({},e);delete t.done,this.processCallback(e),this.sendCmd("httpProxy",{proxyTag:t},e.callback);};},function(e,t,n){var r=n(34).fn,o=n(14);r.getQChatAddress=function(e){this.processCallback(e),this.sendCmd("getQChatAddress",{getQChatAddressTag:{ipType:o.ipVersion}},e.done);};},function(e,t,n){n(279);var r=n(177);n(290)(r),e.exports=r;},function(e,t,n){var r=n(293),o=n(16),i=n(3),s=n(9),a=n(54),c=n(27),u=n(178).fn,l=n(14),m=n(110).V2NIMConnectStatus;u.connect=function(){if(!1===this.checkNetworkAvailable()&&this.autoconnect)return this.logger.info("connect::skip this reconnection attempt because network is offline"),void this.reconnect();l.isBrowser&&this.reporter.restore(),r(u).connect.call(this);},u.refreshSocketUrl=function(){var e;return this.socketUrlsBackup=this.socketUrlsBackup||[],this.socketUrls=o(e=this.socketUrlsBackup).call(e,0),this.logger.info("link::refreshSocketUrl"),this.statusProtector.emit("auth/loginLifeCycleAddressing"),i.resolve();},u.reportTCPException=function(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2?arguments[2]:void 0;this.reporter.reportTraceStart("exceptions",{user_id:this.options.account,start_time:r,action:0}),this.reporter.reportTraceUpdateV2("exceptions",{code:n,description:e,operation_type:0,target:this.handshakeUrl,net_connect:this.checkNetworkAvailable()}),this.reporter.reportTraceEnd("exceptions",1),this.statusProtector.emit("auth/loginLifeCycleConnectFail",new Error(s(t="".concat(e," ")).call(t,n)));},u.onHandshakeFailed=function(e,t){this.reportTCPException("handshake_failed",408,e),0===this.socketUrls.length&&this.reporter.report("chatroomLogin",{accid:this.account,roomId:this.options&&this.options.chatroomId,serverIps:this.options&&this.options.chatroomAddresses&&this.options.chatroomAddresses.join(","),currentServerIp:t,rt:a()-e,result:408,failReason:"ws_handshake_failed",time:a()}),r(u).onHandshakeFailed.call(this,e,t);},u.onConnectFailed=function(e,t,n){var o="string"==typeof e?"connect_failed:".concat(e):"connect_failed";this.reportTCPException(o,0,t),0===this.socketUrls.length&&this.reporter.report("chatroomLogin",{accid:this.account,roomId:this.options&&this.options.chatroomId,serverIps:this.options&&this.options.chatroomAddresses&&this.options.chatroomAddresses.join(","),currentServerIp:n,rt:a()-t,result:408,failReason:"ws_".concat(o),time:a()}),r(u).onConnectFailed.call(this,e,t,n);},u.onSocketError=function(e,t,n){if(e){var o="string"==typeof e?"socket.io error:".concat(e):"socket.io error";this.reportTCPException(o,0,t),0===this.socketUrls.length&&this.reporter.report("chatroomLogin",{accid:this.account,roomId:this.options&&this.options.chatroomId,serverIps:this.options&&this.options.chatroomAddresses&&this.options.chatroomAddresses.join(","),currentServerIp:n,rt:a()-t,result:408,failReason:"ws_".concat(o),time:a()});}r(u).onSocketError.call(this,e,t,n);},u.notifyDisconnect=function(e){r(u).notifyDisconnect.call(this,e);},u.disconnect=function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:function(){};if(this.isConnected())return this.sendCmd("logout"),void c(function(){r(u).disconnect.call(e,t);},0);this.connecting?this.logger.warn("ChatroomProtocolFn api disconnect:: connecting but exiting"):this.statusProtector.getConnectStatus()!==m.V2NIM_CONNECT_STATUS_DISCONNECTED?this.logger.warn("ChatroomProtocolFn api disconnect:: has tried to disconnect actively"):this.logger.warn("ChatroomProtocolFn api disconnect:: other logic entered");var n=r(u);n.disconnect.call(this,t);};},function(e,t,n){var r=n(144),o=n(58),i=n(145),s=n(10),a=n(54),c=n(3),u=n(23),l=n(5),m=n(59),p=n(17),d=n(60),f=n(2),g=n(61),h=n(62),y=n(46);function v(e,t){var n=l(e);if(m){var r=m(e);t&&(r=p(r).call(r,function(t){return d(e,t).enumerable;})),n.push.apply(n,r);}return n;}function b(e){for(var t=1;t<arguments.length;t++){var n,r,i=null!=arguments[t]?arguments[t]:{};t%2?f(n=v(Object(i),!0)).call(n,function(t){o(e,t,i[t]);}):g?h(e,g(i)):f(r=v(Object(i))).call(r,function(t){y(e,t,d(i,t));});}return e;}var T=n(178).fn,S=n(41),M=n(0);function k(e){var t=this;if(398===e.code)return this.logger.warn("pendingLoginFailed:398 try to reconnect socket link，backoff set min 5s"),t.forceDisconnect(),t.backoff.setMin(5e3),void(0===t.retryCount?t.refreshSocketUrl():c.resolve()).then(function(){var n;t.reconnect({allFailedCB:u(n=function n(e){this.logger.error("pendingLoginFailed: ",e.code,e),this.onAuthError(e,"link::onLoginReconnectFailed");}).call(n,t,e)});});this.logger.error("pendingLoginFailed: ",e.code,e),t.onAuthError(e,"link::onLogin");}T.assembleLogin=function(){var e=this.options;this.sdkSession=this.genSessionKey();var t={appKey:e.appKey,account:e.account,deviceId:S.deviceId,chatroomId:e.chatroomId,session:this.sdkSession,appLogin:this.autoconnect?1:0},n=!0;if(void 0===e.loc_x||void 0===e.loc_y||void 0===e.loc_z?n=!1:("number"!=typeof e.loc_x&&(e.loc_x=0),"number"!=typeof e.loc_y&&(e.loc_y=0),"number"!=typeof e.loc_z&&(e.loc_z=0)),e.authType=e.loginAuthType,t=M.merge(t,M.filterObj(e,n?"chatroomNick chatroomAvatar chatroomCustom chatroomEnterCustom isAnonymous notifyTargetTags loginAuthType loginExt loc_x loc_y loc_z distance antiSpamBusinessId":"chatroomNick chatroomAvatar chatroomCustom chatroomEnterCustom isAnonymous notifyTargetTags loginAuthType loginExt distance antiSpamBusinessId")),e.tags&&e.tags.length>0)try{t.tags=s(e.tags);}catch(t){this.logger.error("assembleLogin::format tags error",e.tags,t);}return{type:1,login:t,imLogin:this.assembleIMLogin()};},T.login=i(r.mark(function e(){var t,n,o,i=this;return r.wrap(function(e){for(;;){switch(e.prev=e.next){case 0:return t=this,e.next=3,t.assembleLogin();case 3:if(n=e.sent,!(o=this.socket&&this.socket.socket&&this.socket.socket.sessionid)){e.next=13;break;}if(this.socketIds||(this.socketIds={}),!this.socketIds[o]){e.next=10;break;}return this.logger.warn("onConnect::repeat login",o),e.abrupt("return");case 10:this.socketIds[o]=!0,e.next=14;break;case 13:this.logger.warn("onConnect:: no socketId ",this.socket&&this.socket.socket);case 14:this.logger.warn("link::doLogin: "+o+" appLogin is "+n.login.appLogin),t.createLoginTime=a(),t.sendCmd("login",b({},n),function(e,n){if(e)t.reporter.report("chatroomLogin",{accid:t.account,roomId:t.options&&t.options.chatroomId,serverIps:t.options&&t.options.chatroomAddresses&&t.options.chatroomAddresses.join(","),currentServerIp:t.url,rt:a()-t.createLoginTime,result:e?e.code:408,failReason:e?e.message:"",time:a()}),k.call(t,e),t.statusProtector.emit("auth/loginLifeCycleLoginFail",e);else if(t.reporter.report("chatroomLogin",{accid:t.account,roomId:t.options&&t.options.chatroomId,serverIps:t.options&&t.options.chatroomAddresses&&t.options.chatroomAddresses.join(","),currentServerIp:t.url,rt:a()-t.createLoginTime,result:200,failReason:"",time:a()}),t.resetReconnectStatus(),i.heartbeatFail=0,i.hasLogin=!0,i.autoconnect=!0,t.startHeartbeat(),t.initOnlineListener(),t.statusProtector.emit("auth/loginLifeCycleLoginSucc"),t.keepNosSafeUrl)t.afterLogin(n);else{var r=[];t.parser.checkObjSafeUrl(n,r,[]),c.all(r).then(function(){t.afterLogin(n);}).catch(function(){t.afterLogin(n);});}});case 17:case"end":return e.stop();}}},e,this);})),T.afterLogin=function(e){var t=e.chatroom;this.sendCmd("getNosCdnHost",{}),this.chatroom=t,this.notifyLogin(e);},T.kickedReasons=["","chatroomClosed","managerKick","samePlatformKick","silentlyKick","blacked"],T.kickedMessages=["","聊天室关闭了","被房主或者管理员踢出","不允许同一个帐号在多个地方同时登录","悄悄被踢","被拉黑了"];},function(e,t,n){var r=n(6),o=n(27),i=n(88),s=n(2),a=n(48),c=n(35),u=n(16),l=n(30),m=n(143),p=n(5),d=n(178).fn,f=n(0),g=n(14),h=n(807),y=n(694),v=n(812),b=n(813),T=n(814);d.completeMsg=function(e){e.chatroomId=this.chatroom&&this.chatroom.id,e.from=this.options.account,e.fromClientType="Web",e.time||(e.time=+new Date());},d.amendMsg=function(e){return e;},d.onMsg=function(e){var t,n=r(t=this.message).call(t,e.content.msg);if(this.checkMsgUnique(n)){if(n.__handleTime=this.reporterHook.getSafeClock(),n.__receiveTime=e.__receiveTime,f.get(e,"content.msg.__clientExt"))try{n.__clientExt=JSON.parse(e.content.msg.__clientExt);}catch(t){this.logger.warn("ChatroomProtocolFn:onMsg __clientExt parse failed ".concat(e.content.msg.__clientExt));}this.msgBuffer.push(n),this.msgFlushTimer||this.startMsgFlushTimer(),e&&e.content&&e.content.msg&&"1"===e.content.msg.needHighPriorityMsgAck&&this.sendCmd("sendChatroomMsgAck",{chatRoomMsgAckTag:{idClient:n.idClient,chatroomId:n.chatroomId}});}else this.logger.warn("onMsg::msg::repeat",n.idClient);},d.startMsgFlushTimer=function(){var e=this,t=e.options;e.msgFlushTimer=o(function(){var n,r=i(n=e.msgBuffer).call(n,0,t.msgBufferSize);if(g.isBrowser){var o=e.reporterHook.getSafeClock();s(r).call(r,function(t){if("out"!==t.flow){var n={msgId:t.idServer,clientId:t.idClient,receiveTime:e.reporterHook.getNTPTime(t.__receiveTime),serverTime:t.time,callbackTime:e.reporterHook.getNTPTime(o),preHandleTime:e.reporterHook.getNTPTime(t.__handleTime),fromAccid:t.from,toAccid:e.options.account,type:4,tid:"",roomId:t.chatroomId,result:200,failReason:"",rt:a(o-t.__receiveTime)},r=f.get(t,"__clientExt.statistics.apiCallingTime"),i=f.get(t,"__clientExt.statistics.sendTime");r&&i&&(n.apiCallingTime=r,n.sendTime=i,n.attachUploadDuration=f.get(t,"__clientExt.statistics.attachUploadDuration")||0),e.reporter&&e.reporter.report("msgReceive",n,!0);}delete t.__handleTime,delete t.__receiveTime,delete t.__clientExt;});}e.options.onmsgs(r),e.msgBuffer.length?e.startMsgFlushTimer():delete e.msgFlushTimer;},t.msgBufferInterval);},d.checkMsgUnique=f.genCheckUniqueFunc("idClient"),d.onSendMsg=function(e){var t,n=e.obj.msg;e.error?n.status="fail":(n=e.content.msg).status="success",c(n,e.obj.msg),n=r(t=this.message).call(t,n),this.checkMsgUnique(n),e.obj=n;},d.onHistoryMsgs=function(e){e.error||(e.obj||(e.obj={}),e.obj.msgs=this.message.reverseMsgs(e.content.msgs));},d.onCdnMsgInfo=function(e){if(e){e.cdnUrls&&(e.cdnUrls=e.cdnUrls.split("|")),e.interval&&(e.interval=1e3*a(e.interval)),e.timeout&&(e.timeout=+e.timeout),e.enable&&(e.enable=+e.enable),e.timestamp&&(e.timestamp=+e.timestamp,this.correctCdnTime(e.timestamp));var t=!this.cdnInfo.enable&&e.enable;c(this.cdnInfo,e),t&&this.queryCdnMsgs();}},d.correctCdnTime=function(e){e&&"number"==typeof e&&(this.cdnInfo||(this.cdnInfo={}),this.cdnInfo.timestamp=e,this.cdnInfo.localTime=+new Date(),this.cdnInfo.lastNow=null,this.logger.info("correctCdnTime: timestamp, localTime",e,this.cdnInfo.localTime,new Date(e),new Date(this.cdnInfo.localTime)));},d.queryCdnMsgs=function(e){var t,n=this;if(this.cdnInfo&&this.cdnInfo.enable&&this.isConnected()){this.queryCdnTimer=o(function(){return n.queryCdnMsgs();},this.cdnInfo.interval);var r=+new Date();if(r=r-this.cdnInfo.localTime+this.cdnInfo.timestamp,r-=r%this.cdnInfo.interval,this.cdnInfo.lastNow!==r&&this.cdnInfo.cdnUrls&&this.cdnInfo.cdnUrls.length){this.cdnInfo.cdnUrls.push(this.cdnInfo.cdnUrls.shift());var i=this,s=this.cdnInfo.decryptKey,a=this.cdnInfo.timeout||Math.ceil(this.cdnInfo.interval/2),c=u(t=this.cdnInfo.cdnUrls).call(t,0);e=e||0,function t(){if(e>=3)return void i.finalFail++;if(!c.length)return;var n=c.shift().replace("#time",r),o=n.split("/")[2],u=+new Date();i.adaptersRequest(n,{timeout:a,onload:function onload(e){if(i.cdnInfo.lastNow>r)i.logger.warn("queryCdnMsgs::doQuery cdnInfo.lastNow > now, will throw data ",i.cdnInfo.lastNow,r,e);else{i.cdnInfo.lastNow=r,i.afterQueryCdn(o,+new Date()-u,!0);try{e=JSON.parse(e);}catch(e){i.logger.warn("queryCdnMsgs::doQuery::onload parse res error: ",e);}if(e&&e.data){e.ptm&&(i.cdnInfo.timeout=e.ptm),e.pis&&(i.cdnInfo.interval=1e3*e.pis);var t,n,a=!0===e.e?(t=e.data,n=s,h.decrypt(t,y.parse(n),{mode:v,padding:b}).toString(T)):e.data;i.onCdnMsgsSmoothly(a,r,1e3*e.c);}}},onerror:function onerror(n){if(e++,i.afterQueryCdn(o,+new Date()-u,!1),404===n.status){var r;try{var s=JSON.parse(n.result);404===s.code&&s.timestamp&&(r=s.timestamp);}catch(e){i.logger.warn("queryCdnMsgs::doQuery::parse 404 result error",e,n);}!r&&n.date&&(r=+new Date(n.date)),r&&(i.correctCdnTime(r),clearTimeout(i.queryCdnTimer),i.queryCdnMsgs(e));}else t();}});}();}}},d.onCdnMsgsSmoothly=function(e,t,n){try{e=JSON.parse(e);}catch(e){this.logger.warn("onCdnMsgsSmoothly::JSON.parse error",e);}if(this.logger.info("receive cdn msgs "+e.length+" and request time is "+new Date(t)),l(e)&&e.length){var r=this,o=this.options.msgBufferInterval,a=Math.ceil(e.length*o/n);c(),clearInterval(r.cdnSmoothTimer),r.cdnSmoothTimer=m(function(){return c();},o);}function c(){if(r.isConnected()){var t=i(e).call(e,0,a);s(t).call(t,function(e){var t=r.parser.syncUnserialize(e,"msg");r.onMsg({content:{msg:t}});}),e.length||clearInterval(r.cdnSmoothTimer);}}},d.resetCdnData=function(){this.cdnData={},this.finalFail=0,this.cdnDataTime=+new Date();},d.initCdnData=function(){this.resetCdnData(),f.isFunction(this.options.onCdnRequestData)?(this.options.cdnRequestDataInterval=this.options.cdnRequestDataInterval||3e4,this.afterQueryCdn=function(e,t,n){var r,o=this;this.cdnData[e]||(this.cdnData[e]={success:0,fail:0,sr:0,fr:0,smr:0,fmr:0}),n?(this.cdnData[e].success++,this.cdnData[e].sr+=t,t>this.cdnData[e].smr&&(this.cdnData[e].smr=t)):(this.cdnData[e].fail++,this.cdnData[e].fr+=t,t>this.cdnData[e].fmr&&(this.cdnData[e].fmr=t)),+new Date()-this.cdnDataTime<this.options.cdnRequestDataInterval||(s(r=p(this.cdnData)).call(r,function(e){o.cdnData[e].sr=o.cdnData[e].sr/o.cdnData[e].success||0,o.cdnData[e].fr=o.cdnData[e].fr/o.cdnData[e].fail||0;}),this.options.onCdnRequestData(c({},this.cdnData),this.finalFail),this.resetCdnData());}):this.afterQueryCdn=function(){};};},function(e,t,n){var r;e.exports=(r=n(74),n(694),n(809),n(695),n(292),function(){var e=r,t=e.lib.BlockCipher,n=e.algo,o=[],i=[],s=[],a=[],c=[],u=[],l=[],m=[],p=[],d=[];!function(){for(var e=[],t=0;t<256;t++){e[t]=t<128?t<<1:t<<1^283;}var n=0,r=0;for(t=0;t<256;t++){var f=r^r<<1^r<<2^r<<3^r<<4;f=f>>>8^255&f^99,o[n]=f,i[f]=n;var g=e[n],h=e[g],y=e[h],v=257*e[f]^16843008*f;s[n]=v<<24|v>>>8,a[n]=v<<16|v>>>16,c[n]=v<<8|v>>>24,u[n]=v,v=16843009*y^65537*h^257*g^16843008*n,l[f]=v<<24|v>>>8,m[f]=v<<16|v>>>16,p[f]=v<<8|v>>>24,d[f]=v,n?(n=g^e[e[e[y^g]]],r^=e[e[r]]):n=r=1;}}();var f=[0,1,2,4,8,16,32,64,128,27,54],g=n.AES=t.extend({_doReset:function _doReset(){if(!this._nRounds||this._keyPriorReset!==this._key){for(var e=this._keyPriorReset=this._key,t=e.words,n=e.sigBytes/4,r=4*((this._nRounds=n+6)+1),i=this._keySchedule=[],s=0;s<r;s++){s<n?i[s]=t[s]:(u=i[s-1],s%n?n>6&&s%n==4&&(u=o[u>>>24]<<24|o[u>>>16&255]<<16|o[u>>>8&255]<<8|o[255&u]):(u=o[(u=u<<8|u>>>24)>>>24]<<24|o[u>>>16&255]<<16|o[u>>>8&255]<<8|o[255&u],u^=f[s/n|0]<<24),i[s]=i[s-n]^u);}for(var a=this._invKeySchedule=[],c=0;c<r;c++){if(s=r-c,c%4)var u=i[s];else u=i[s-4];a[c]=c<4||s<=4?u:l[o[u>>>24]]^m[o[u>>>16&255]]^p[o[u>>>8&255]]^d[o[255&u]];}}},encryptBlock:function encryptBlock(e,t){this._doCryptBlock(e,t,this._keySchedule,s,a,c,u,o);},decryptBlock:function decryptBlock(e,t){var n=e[t+1];e[t+1]=e[t+3],e[t+3]=n,this._doCryptBlock(e,t,this._invKeySchedule,l,m,p,d,i),n=e[t+1],e[t+1]=e[t+3],e[t+3]=n;},_doCryptBlock:function _doCryptBlock(e,t,n,r,o,i,s,a){for(var c=this._nRounds,u=e[t]^n[0],l=e[t+1]^n[1],m=e[t+2]^n[2],p=e[t+3]^n[3],d=4,f=1;f<c;f++){var g=r[u>>>24]^o[l>>>16&255]^i[m>>>8&255]^s[255&p]^n[d++],h=r[l>>>24]^o[m>>>16&255]^i[p>>>8&255]^s[255&u]^n[d++],y=r[m>>>24]^o[p>>>16&255]^i[u>>>8&255]^s[255&l]^n[d++],v=r[p>>>24]^o[u>>>16&255]^i[l>>>8&255]^s[255&m]^n[d++];u=g,l=h,m=y,p=v;}g=(a[u>>>24]<<24|a[l>>>16&255]<<16|a[m>>>8&255]<<8|a[255&p])^n[d++],h=(a[l>>>24]<<24|a[m>>>16&255]<<16|a[p>>>8&255]<<8|a[255&u])^n[d++],y=(a[m>>>24]<<24|a[p>>>16&255]<<16|a[u>>>8&255]<<8|a[255&l])^n[d++],v=(a[p>>>24]<<24|a[u>>>16&255]<<16|a[l>>>8&255]<<8|a[255&m])^n[d++],e[t]=g,e[t+1]=h,e[t+2]=y,e[t+3]=v;},keySize:8});e.AES=t._createHelper(g);}(),r.AES);},function(e,t){},function(e,t,n){var r;e.exports=(r=n(74),function(e){var t=r,n=t.lib,o=n.WordArray,i=n.Hasher,s=t.algo,a=[];!function(){for(var t=0;t<64;t++){a[t]=4294967296*e.abs(e.sin(t+1))|0;}}();var c=s.MD5=i.extend({_doReset:function _doReset(){this._hash=new o.init([1732584193,4023233417,2562383102,271733878]);},_doProcessBlock:function _doProcessBlock(e,t){for(var n=0;n<16;n++){var r=t+n,o=e[r];e[r]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8);}var i=this._hash.words,s=e[t+0],c=e[t+1],d=e[t+2],f=e[t+3],g=e[t+4],h=e[t+5],y=e[t+6],v=e[t+7],b=e[t+8],T=e[t+9],S=e[t+10],M=e[t+11],k=e[t+12],x=e[t+13],C=e[t+14],I=e[t+15],_=i[0],w=i[1],P=i[2],A=i[3];_=u(_,w,P,A,s,7,a[0]),A=u(A,_,w,P,c,12,a[1]),P=u(P,A,_,w,d,17,a[2]),w=u(w,P,A,_,f,22,a[3]),_=u(_,w,P,A,g,7,a[4]),A=u(A,_,w,P,h,12,a[5]),P=u(P,A,_,w,y,17,a[6]),w=u(w,P,A,_,v,22,a[7]),_=u(_,w,P,A,b,7,a[8]),A=u(A,_,w,P,T,12,a[9]),P=u(P,A,_,w,S,17,a[10]),w=u(w,P,A,_,M,22,a[11]),_=u(_,w,P,A,k,7,a[12]),A=u(A,_,w,P,x,12,a[13]),P=u(P,A,_,w,C,17,a[14]),_=l(_,w=u(w,P,A,_,I,22,a[15]),P,A,c,5,a[16]),A=l(A,_,w,P,y,9,a[17]),P=l(P,A,_,w,M,14,a[18]),w=l(w,P,A,_,s,20,a[19]),_=l(_,w,P,A,h,5,a[20]),A=l(A,_,w,P,S,9,a[21]),P=l(P,A,_,w,I,14,a[22]),w=l(w,P,A,_,g,20,a[23]),_=l(_,w,P,A,T,5,a[24]),A=l(A,_,w,P,C,9,a[25]),P=l(P,A,_,w,f,14,a[26]),w=l(w,P,A,_,b,20,a[27]),_=l(_,w,P,A,x,5,a[28]),A=l(A,_,w,P,d,9,a[29]),P=l(P,A,_,w,v,14,a[30]),_=m(_,w=l(w,P,A,_,k,20,a[31]),P,A,h,4,a[32]),A=m(A,_,w,P,b,11,a[33]),P=m(P,A,_,w,M,16,a[34]),w=m(w,P,A,_,C,23,a[35]),_=m(_,w,P,A,c,4,a[36]),A=m(A,_,w,P,g,11,a[37]),P=m(P,A,_,w,v,16,a[38]),w=m(w,P,A,_,S,23,a[39]),_=m(_,w,P,A,x,4,a[40]),A=m(A,_,w,P,s,11,a[41]),P=m(P,A,_,w,f,16,a[42]),w=m(w,P,A,_,y,23,a[43]),_=m(_,w,P,A,T,4,a[44]),A=m(A,_,w,P,k,11,a[45]),P=m(P,A,_,w,I,16,a[46]),_=p(_,w=m(w,P,A,_,d,23,a[47]),P,A,s,6,a[48]),A=p(A,_,w,P,v,10,a[49]),P=p(P,A,_,w,C,15,a[50]),w=p(w,P,A,_,h,21,a[51]),_=p(_,w,P,A,k,6,a[52]),A=p(A,_,w,P,f,10,a[53]),P=p(P,A,_,w,S,15,a[54]),w=p(w,P,A,_,c,21,a[55]),_=p(_,w,P,A,b,6,a[56]),A=p(A,_,w,P,I,10,a[57]),P=p(P,A,_,w,y,15,a[58]),w=p(w,P,A,_,x,21,a[59]),_=p(_,w,P,A,g,6,a[60]),A=p(A,_,w,P,M,10,a[61]),P=p(P,A,_,w,d,15,a[62]),w=p(w,P,A,_,T,21,a[63]),i[0]=i[0]+_|0,i[1]=i[1]+w|0,i[2]=i[2]+P|0,i[3]=i[3]+A|0;},_doFinalize:function _doFinalize(){var t=this._data,n=t.words,r=8*this._nDataBytes,o=8*t.sigBytes;n[o>>>5]|=128<<24-o%32;var i=e.floor(r/4294967296),s=r;n[15+(o+64>>>9<<4)]=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8),n[14+(o+64>>>9<<4)]=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),t.sigBytes=4*(n.length+1),this._process();for(var a=this._hash,c=a.words,u=0;u<4;u++){var l=c[u];c[u]=16711935&(l<<8|l>>>24)|4278255360&(l<<24|l>>>8);}return a;},clone:function clone(){var e=i.clone.call(this);return e._hash=this._hash.clone(),e;}});function u(e,t,n,r,o,i,s){var a=e+(t&n|~t&r)+o+s;return(a<<i|a>>>32-i)+t;}function l(e,t,n,r,o,i,s){var a=e+(t&r|n&~r)+o+s;return(a<<i|a>>>32-i)+t;}function m(e,t,n,r,o,i,s){var a=e+(t^n^r)+o+s;return(a<<i|a>>>32-i)+t;}function p(e,t,n,r,o,i,s){var a=e+(n^(t|~r))+o+s;return(a<<i|a>>>32-i)+t;}t.MD5=i._createHelper(c),t.HmacMD5=i._createHmacHelper(c);}(Math),r.MD5);},function(e,t,n){var r,o,i,s,a,c,u,l;e.exports=(l=n(74),o=(r=l).lib,i=o.WordArray,s=o.Hasher,a=r.algo,c=[],u=a.SHA1=s.extend({_doReset:function _doReset(){this._hash=new i.init([1732584193,4023233417,2562383102,271733878,3285377520]);},_doProcessBlock:function _doProcessBlock(e,t){for(var n=this._hash.words,r=n[0],o=n[1],i=n[2],s=n[3],a=n[4],u=0;u<80;u++){if(u<16)c[u]=0|e[t+u];else{var l=c[u-3]^c[u-8]^c[u-14]^c[u-16];c[u]=l<<1|l>>>31;}var m=(r<<5|r>>>27)+a+c[u];m+=u<20?1518500249+(o&i|~o&s):u<40?1859775393+(o^i^s):u<60?(o&i|o&s|i&s)-1894007588:(o^i^s)-899497514,a=s,s=i,i=o<<30|o>>>2,o=r,r=m;}n[0]=n[0]+r|0,n[1]=n[1]+o|0,n[2]=n[2]+i|0,n[3]=n[3]+s|0,n[4]=n[4]+a|0;},_doFinalize:function _doFinalize(){var e=this._data,t=e.words,n=8*this._nDataBytes,r=8*e.sigBytes;return t[r>>>5]|=128<<24-r%32,t[14+(r+64>>>9<<4)]=Math.floor(n/4294967296),t[15+(r+64>>>9<<4)]=n,e.sigBytes=4*t.length,this._process(),this._hash;},clone:function clone(){var e=s.clone.call(this);return e._hash=this._hash.clone(),e;}}),r.SHA1=s._createHelper(u),r.HmacSHA1=s._createHmacHelper(u),l.SHA1);},function(e,t,n){var r,o,i,s;e.exports=(r=n(74),i=(o=r).lib.Base,s=o.enc.Utf8,void(o.algo.HMAC=i.extend({init:function init(e,t){e=this._hasher=new e.init(),"string"==typeof t&&(t=s.parse(t));var n=e.blockSize,r=4*n;t.sigBytes>r&&(t=e.finalize(t)),t.clamp();for(var o=this._oKey=t.clone(),i=this._iKey=t.clone(),a=o.words,c=i.words,u=0;u<n;u++){a[u]^=1549556828,c[u]^=909522486;}o.sigBytes=i.sigBytes=r,this.reset();},reset:function reset(){var e=this._hasher;e.reset(),e.update(this._iKey);},update:function update(e){return this._hasher.update(e),this;},finalize:function finalize(e){var t=this._hasher,n=t.finalize(e);return t.reset(),t.finalize(this._oKey.clone().concat(n));}})));},function(e,t,n){var r,o;e.exports=(o=n(74),n(292),o.mode.ECB=((r=o.lib.BlockCipherMode.extend()).Encryptor=r.extend({processBlock:function processBlock(e,t){this._cipher.encryptBlock(e,t);}}),r.Decryptor=r.extend({processBlock:function processBlock(e,t){this._cipher.decryptBlock(e,t);}}),r),o.mode.ECB);},function(e,t,n){var r;e.exports=(r=n(74),n(292),r.pad.Pkcs7);},function(e,t,n){var r;e.exports=(r=n(74),r.enc.Utf8);},function(e,t,n){var r=n(6),o=n(178).fn,i=n(291);o.onChatroomMembersInfo=o.onChatroomMembers=function(e){e.error||(e.obj.members=i.reverseMembers(e.content.members));},o.onGetChatroomMemberCountByTag=function(e){e.error||(e.obj=e.content);},o.onMarkChatroomMember=function(e){e.error||(e.obj.member=r(i).call(i,e.content.chatroomMember));},o.onSyncRobot=function(e){!e.error&&this.options.onrobots?this.options.onrobots(null,e.content):this.ontions.onrobots(e.error,{});};},function(e,t,n){var r=n(6),o=n(7),i=n(0),s=function s(e){this.account=e.account;},a=s.prototype,c=a.Message=n(107),u=a.TextMessage=n(817),l=a.FileMessage=n(189),m=a.GeoMessage=n(821),p=a.NotificationMessage=n(822),d=a.CustomMessage=n(823),f=a.TipMessage=n(824),g=a.RobotMessage=n(825);a.validTypes=c.validTypes,a.reverse=function(e){var t;switch(c.getType(e)){case"text":t=r(u).call(u,e);break;case"image":case"audio":case"video":case"file":t=r(l).call(l,e);break;case"geo":t=r(m).call(m,e);break;case"notification":t=r(p).call(p,e);break;case"custom":t=r(d).call(d,e);break;case"tip":t=r(f).call(f,e);break;case"robot":t=r(g).call(g,e);break;default:t=r(c).call(c,e);}return c.setExtra(t,this.account),t;},a.reverseMsgs=function(e,t){var n,s,a=this;return o(e).call(e,function(e){return e=r(a).call(a,e),t&&((n=t.modifyObj)&&(e=i.merge(e,n)),s=t.mapper,i.isFunction(s)&&(e=s(e))),e;});},e.exports=s;},function(e,t,n){var r=n(15),o=n(6),i=n(107),s=n(0);function a(e){s.verifyOptions(e,"text","msg::TextMessage"),e.type="text",i.call(this,e),this.attach=e.text,this.body="";}a.prototype=r(i.prototype),a.reverse=function(e){var t=o(i).call(i,e);return t.text=e.attach,t;},e.exports=a;},function(e,t,n){var r=n(15),o=n(0),i=n(189);function s(){}s.prototype=r(i.prototype),s.verifyFile=function(e,t){o.verifyOptions(e,"w h",!0,"file.",t);},e.exports=s;},function(e,t,n){var r=n(15),o=n(189),i=n(0);function s(){}s.prototype=r(o.prototype),s.verifyFile=function(e,t){i.verifyOptions(e,"dur",!0,"file.",t);},e.exports=s;},function(e,t,n){var r=n(15),o=n(189),i=n(0);function s(){}s.prototype=r(o.prototype),s.verifyFile=function(e,t){i.verifyOptions(e,"dur w h",!0,"file.",t);},e.exports=s;},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(107),a=n(0);function c(e){e.type="geo",a.verifyOptions(e,"geo","msg::GeoMessage"),a.verifyOptions(e.geo,"lng lat title",!0,"geo.","msg::GeoMessage"),a.verifyParamType("geo.lng",e.geo.lng,"number","msg::GeoMessage"),a.verifyParamType("geo.lat",e.geo.lat,"number","msg::GeoMessage"),a.verifyParamType("geo.title",e.geo.title,"string","msg::GeoMessage"),s.call(this,e),this.attach=r(e.geo);}c.prototype=o(s.prototype),c.reverse=function(e){var t=i(s).call(s,e);return e.attach=e.attach?""+e.attach:"",t.geo=e.attach?JSON.parse(e.attach):{},t;},e.exports=c;},function(e,t,n){var r=n(15),o=n(6),i=n(48),s=n(0).notundef,a=n(107),c={301:"memberEnter",302:"memberExit",303:"blackMember",304:"unblackMember",305:"gagMember",306:"ungagMember",307:"addManager",308:"removeManager",309:"addCommon",310:"removeCommon",311:"closeChatroom",312:"updateChatroom",313:"kickMember",314:"addTempMute",315:"removeTempMute",316:"updateMemberInfo",317:"updateQueue",318:"muteRoom",319:"unmuteRoom",320:"batchUpdateQueue",321:"addTempMuteTag",322:"removeTempMuteTag",324:"batchQueueOffer",323:"deleteChatroomMsg",325:"updateChatroomTags"};function u(){}u.prototype=r(a.prototype),u.reverse=function(e){var t=o(a).call(a,e);if(e.attach=e.attach?""+e.attach:"",e.attach){var n=JSON.parse(e.attach);if(t.attach={type:c[n.id]},s(n.data)){var r=n.data;if(s(r.operator)&&(t.attach.from=r.operator),s(r.opeNick)&&(t.attach.fromNick=r.opeNick),s(r.target)&&(t.attach.to=r.target),s(r.tarNick)&&(t.attach.toNick=r.tarNick),s(r.muteDuration)&&(t.attach.duration=i(r.muteDuration,10)),s(r.tags)&&(t.attach.tags=r.tags),"memberEnter"===t.attach.type&&(s(r.muted)?t.attach.gaged=1==+r.muted:t.attach.gaged=!1,s(r.tempMuted)?t.attach.tempMuted=1==+r.tempMuted:t.attach.tempMuted=!1,s(r.muteTtl)?t.attach.tempMuteDuration=+r.muteTtl:t.attach.tempMuteDuration=0),"deleteChatroomMsg"===t.attach.type&&(t.attach.msgId=r.msgId,t.attach.msgTime=r.msgTime),s(r.ext)&&(t.attach.custom=r.ext),s(r.queueChange)){var u=JSON.parse(r.queueChange);switch(u._e){case"OFFER":t.attach.queueChange={type:"OFFER",elementKey:u.key,elementValue:u.content};break;case"POLL":t.attach.queueChange={type:"POLL",elementKey:u.key,elementValue:u.content};break;case"DROP":t.attach.queueChange={type:"DROP"};break;case"PARTCLEAR":case"BATCH_UPDATE":t.attach.queueChange={type:u._e,elementKv:u.kvObject};break;case"BATCH_OFFER":t.attach.queueChange={type:u._e,elements:u.elements};}}}}else t.attach={};return t;},e.exports=u;},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(107),a=n(0);function c(e){a.verifyOptions(e,"content","msg::CustomMessage"),e.type="custom",s.call(this,e),"string"!=typeof e.content&&(e.content=r(e.content)),this.attach=e.content;}c.prototype=o(s.prototype),c.reverse=function(e){var t=i(s).call(s,e);return t.content=e.attach,t;},e.exports=c;},function(e,t,n){var r=n(15),o=n(6),i=n(107),s=n(0);function a(e){s.verifyOptions(e,"tip","msg::TipMessage"),e.type="tip",i.call(this,e),this.attach=e.tip;}a.prototype=r(i.prototype),a.reverse=function(e){var t=o(i).call(i,e);return t.tip=e.attach,t;},e.exports=a;},function(e,t,n){var r=n(10),o=n(15),i=n(6),s=n(7),a=n(107),c=n(0),u={welcome:"00",text:"01",link:"03"},l={"01":"text","02":"image","03":"answer",11:"template"};function m(e){c.verifyOptions(e,"content","msg::RobotMessage");var t=e.content;switch(t.type){case"welcome":c.undef(e.body)&&(this.body="欢迎消息");break;case"text":c.verifyOptions(t,"content","msg::RobotMessage"),c.undef(e.body)&&(this.body=t.content);break;case"link":c.verifyOptions(t,"target","msg::RobotMessage");}t.type&&(t.type=u[t.type]),t={param:t,robotAccid:e.robotAccid},this.attach=r(t),e.type="robot",a.call(this,e);}m.prototype=o(a.prototype),m.reverse=function(e){var t=i(a).call(a,e);if("robot"===t.type){var n=JSON.parse(e.attach);if(n.param&&(n.param.type=l[n.param.type]||"unknown"),n.robotMsg){var r=(n=c.merge(n,n.robotMsg)).message;"bot"===n.flag?n.message=s(r).call(r,function(e){return e.type=l[e.type]||"unknown",e;}):n.flag,delete n.robotMsg;}t.content=n;}return t;},e.exports=m;},function(e,t,n){var r=n(6),o=n(30),i=n(7),s=n(17),a=n(10),c=n(0),u=c.undef,l=n(177).fn;l.beforeSendMsg=function(e){e.cmd="sendMsg";};var m={text:0,image:1,audio:2,video:3,geo:4,notification:5,file:6,tip:10,robot:11,custom:100};l.getHistoryMsgs=function(e){if(c.verifyOptions(e),u(e.timetag)?e.timetag=0:c.verifyParamType("timetag",e.timetag,"number","msg::getHistoryMsgs"),u(e.limit)?e.limit=100:c.verifyParamType("limit",e.limit,"number","msg::getHistoryMsgs"),u(r(e))?e.reverse=!1:c.verifyParamType("reverse",r(e),"boolean","msg::getHistoryMsgs"),u(e.msgTypes))e.msgTypes=[];else if(o(e.msgTypes)){var t,n;e.msgTypes=i(t=e.msgTypes).call(t,function(e){return m[e];}),e.msgTypes=s(n=e.msgTypes).call(n,function(e){return"number"==typeof e;});}else"number"==typeof m[e.msgTypes]?e.msgTypes=[m[e.msgTypes]]:e.msgTypes=[];this.processCallback(e),this.sendCmd("getHistoryMsgs",e,function(t,n,r){o(r)&&(r=i(r).call(r,function(e){return m[e.type]&&(e.type=m[e.type]),e;})),e.callback(t,n,r);});},l.getHistoryMsgsByTags=function(e){if(c.verifyOptions(e,"tags","api::msg::getHistoryMsgsByTags"),c.verifyParamType("tags",e.tags,"array","api::msg::getHistoryMsgsByTags"),u(e.fromTime)?e.fromTime=0:c.verifyParamType("fromTime",e.fromTime,"number","api::msg::getHistoryMsgsByTags"),u(e.toTime)?e.toTime=0:c.verifyParamType("toTime",e.toTime,"number","api::msg::getHistoryMsgsByTags"),u(e.limit)?e.limit=100:c.verifyParamType("limit",e.limit,"number","msg::getHistoryMsgs"),u(r(e))?e.reverse=0:c.verifyParamType("reverse",r(e),"number","msg::getHistoryMsgs"),u(e.types))e.types=[];else if(o(e.types)){var t,n;e.types=i(t=e.types).call(t,function(e){return m[e];}),e.types=s(n=e.types).call(n,function(e){return"number"==typeof e;});}else"number"==typeof m[e.types]?e.types=[m[e.types]]:e.types=[];this.processCallback(e),e.types=a(e.types),e.tags=a(e.tags),this.sendCmd("getHistoryMsgsByTags",{chatRoomTagHistoryMsgRequestTag:e},e.callback);};},function(e,t,n){n(177).fn.disconnect=function(e){e=e||{},this.protocol.disconnect(e.done);};},function(e,t,n){var r=n(0),o=r.undef,i=r.verifyOptions,s=r.verifyParamType,a=n(291),c=n(177).fn;c.updateMyChatroomMemberInfo=function(e){i(e,"member needNotify","member::updateMyChatroomMemberInfo"),s("needNotify",e.needNotify,"boolean","member::updateMyChatroomMemberInfo"),e.needSave=e.needSave||!1,s("needSave",e.needSave,"boolean","member::updateMyChatroomMemberInfo"),this.processCustom(e),this.processCallback(e),e.chatroomMember=new a(e.member),e.antispamTag={antiSpamBusinessId:e.antiSpamBusinessId},this.sendCmd("updateMyChatroomMemberInfo",e);},c.getChatroomMembers=function(e){i(e,"guest","member::getChatroomMembers"),s("guest",e.guest,"boolean","member::getChatroomMembers"),o(e.time)?e.time=0:s("time",e.time,"number","member::getChatroomMembers"),o(e.limit)?e.limit=100:s("limit",e.limit,"number","member::getChatroomMembers"),this.processCallback(e),e.guest?e.type=!1===e.desc?3:1:e.type=e.onlyOnline?2:0,this.sendCmd("getChatroomMembers",e);},c.getChatroomMembersByTag=function(e){i(e,"tag","getChatroomMembersByTag::rag"),o(e.time)?e.time=0:s("time",e.time,"number","getChatroomMembersByTag::time"),o(e.limit)?e.limit=100:s("limit",e.limit,"number","getChatroomMembersByTag::limit"),this.processCallback(e),this.sendCmd("getChatroomMembersByTag",{tagMemberReq:r.filterObj(e,"tag limit time"),callback:e.callback});},c.getChatroomMemberCountByTag=function(e){i(e,"tag","getChatroomMemberCountByTag::rag"),this.processCallback(e),this.sendCmd("getChatroomMemberCountByTag",e);},c.getChatroomMembersInfo=function(e){i(e,"accounts","member::getChatroomMembersInfo"),s("accounts",e.accounts,"array","member::getChatroomMembersInfo"),this.processCallback(e),this.sendCmd("getChatroomMembersInfo",e);},c.markChatroomIdentity=function(e){i(e,"identity","member::markChatroomIdentity"),e.type={manager:1,common:2,black:-1,mute:-2}[e.identity],delete e.identity,isNaN(e.type)?i(e,"identity",'member::markChatroomIdentity. The valid value of the identity is "manager" or "common" or "black" or "mute".'):this.markChatroomMember(e);},c.markChatroomManager=function(e){e.type=1,this.markChatroomMember(e);},c.markChatroomCommonMember=function(e){e.type=2,this.markChatroomMember(e);},c.markChatroomBlacklist=function(e){e.type=-1,this.markChatroomMember(e);},c.markChatroomGaglist=function(e){e.type=-2,this.markChatroomMember(e);},c.markChatroomMember=function(e){i(e,"account type isAdd","member::markChatroomMember"),s("isAdd",e.isAdd,"boolean","member::markChatroomMember"),o(e.level)?e.level=0:s("level",e.level,"number","member::markChatroomMember");this.processCustom(e),this.processCallback(e),this.sendCmd("markChatroomMember",e);},c.kickChatroomMember=function(e){i(e,"account","member::kickChatroomMember"),this.processCustom(e),this.processCallback(e),this.sendCmd("kickChatroomMember",e);},c.updateChatroomMemberTempMute=function(e){i(e,"account duration needNotify","member::updateChatroomMemberTempMute"),s("duration",e.duration,"number","member::updateChatroomMemberTempMute"),s("needNotify",e.needNotify,"boolean","member::updateChatroomMemberTempMute"),this.processCustom(e),this.processCallback(e),this.sendCmd("updateChatroomMemberTempMute",e);},c.updateTagMembersTempMute=function(e){i(e,"tag duration needNotify","member::updateTagMembersTempMute"),s("duration",e.duration,"number","member::updateTagMembersTempMute"),s("needNotify",e.needNotify,"boolean","member::updateTagMembersTempMute"),this.processCustom(e),this.processCallback(e);var t=r.filterObj(e,"tag duration custom notifyTargetTags");t.needNotify=e.needNotify?1:0,this.sendCmd("updateTagMembersTempMute",{tagMuteReq:t,callback:e.callback});},c.updateCoordinate=r.throttle(function(e){var t=!0;void 0===e.x||void 0===e.y||void 0===e.z?t=!1:("number"!=typeof e.x&&(e.x=0),"number"!=typeof e.y&&(e.y=0),"number"!=typeof e.z&&(e.z=0)),this.processCallback(e);var n=r.filterObj(e,t?"x y z distance":"distance");this.sendCmd("updateCoordinate",{coordinateReq:n,callback:e.callback});},300,{},function(e){e&&e.done&&e.done({code:416,chatroomId:this.options.chatroomId});}),c.getRobotList=function(e){this.logger.warn("this api will be abandon");o(e.timetag)&&(e.timetag=0),this.processCallback(e),this.sendCmd("syncRobot",e);};},function(e,t,n){var r=n(177).fn,o=n(0);r.queueOffer=function(e){o.verifyOptions(e,"elementKey elementValue","msg::queueOffer");var t={elementKey:e.elementKey,elementValue:e.elementValue,transient:!!e.transient};e.elementAccount&&(t.elementAccount=e.elementAccount),this.processCallback(e),this.sendCmd("queueOffer",t,e.callback);},r.queuePoll=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e.elementKey=e.elementKey||"",this.processCallback(e),this.sendCmd("queuePoll",e,e.callback);},r.queueList=function(e){this.processCallback(e),this.sendCmd("queueList",e,e.callback);},r.peak=function(e){this.processCallback(e),this.sendCmd("peak",e,e.callback);},r.queueDrop=function(e){this.processCallback(e),this.sendCmd("queueDrop",e,e.callback);},r.queueChange=function(e){o.verifyOptions(e,"elementMap","msg::queueOffer"),e.needNotify?(e.needNotify=!0,o.verifyOptions(e,"notifyExt","msg::queueOffer")):e.needNotify=!1,this.processCallback(e),this.sendCmd("queueChange",e,e.callback);};},,,function(e,t,n){e.exports=n(833);},function(e,t,n){n(279);var r={NIM:n(696),Chatroom:n(803)};n(290)(r),e.exports=r;}]);});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var getSideChannel = __webpack_require__(209);
var utils = __webpack_require__(87);
var formats = __webpack_require__(53);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function pushToArray(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'symbol' || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var GetIntrinsic = __webpack_require__(51);
var callBound = __webpack_require__(215);
var inspect = __webpack_require__(217);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function listGetNode(list, key) {
	// eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function listGet(objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function listSet(objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function listHas(objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function assert(key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function get(key) {
			// eslint-disable-line consistent-return
			if ($WeakMap && key && ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) {
					// eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function has(key) {
			if ($WeakMap && key && ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) {
					// eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function set(key, value) {
			if ($WeakMap && key && ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
      * Initialize the linked list as an empty node, so that we don't have
      * to special-case handling of the first node: we can always refer to
      * it as (previous node).next, instead of something like (list).head
      */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(211);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') {
		return false;
	}
	if (typeof Symbol !== 'function') {
		return false;
	}
	if (_typeof(origSymbol('foo')) !== 'symbol') {
		return false;
	}
	if (_typeof(Symbol('bar')) !== 'symbol') {
		return false;
	}

	return hasSymbolSham();
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
		return false;
	}
	if (_typeof(Symbol.iterator) === 'symbol') {
		return true;
	}

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') {
		return false;
	}

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
		return false;
	}
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
		return false;
	}

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) {
		return false;
	} // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
		return false;
	}

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
		return false;
	}

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) {
		return false;
	}

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
		return false;
	}

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) {
			return false;
		}
	}

	return true;
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(that, args.concat(slice.call(arguments)));
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(52);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(51);

var callBind = __webpack_require__(216);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(52);
var GetIntrinsic = __webpack_require__(51);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(func, 'length', { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (_typeof(Symbol.toStringTag) === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
? function (O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);

function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(218);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') {
        depth = 0;
    }
    if (depth >= maxDepth && maxDepth > 0 && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) {
        // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) {
            s += '...';
        }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) {
            return '[]';
        }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) {
            return '[' + String(obj) + ']';
        }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) {
            return tag + '{}';
        }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) {
    return toStr(obj) === '[object Array]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === '[object Date]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === '[object RegExp]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === '[object Error]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === '[object String]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === '[object Number]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === '[object Boolean]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Symbol;
    }
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'symbol') {
        return true;
    }
    if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) {
        return f.name;
    }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) {
        return m[1];
    }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) {
        return xs.indexOf(x);
    }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) {
            return i;
        }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) {
        return '\\' + x;
    }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) {
        return '';
    }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) {
        // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) {
            continue;
        } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) {
            continue;
        } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function interpretNumericEntities(str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function parseArrayValue(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, 'value');
            });
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function parseObject(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(221);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3b2125d9", content, true);

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#Launch[data-v-66572c50]{height:100%;width:100%;position:fixed;z-index:11000;background:#f5f5f5;top:0;left:0}.img[data-v-66572c50]{width:100%;height:100%;background-size:cover;background-position:50%}.timeDown[data-v-66572c50]{position:absolute;right:15px;top:15px;background-color:rgba(0,0,0,.4);padding:6px 12px;border-radius:5px;font-size:12px;color:#fff}p[data-v-66572c50]{padding:100px 0;text-align:center;font-size:18px}", ""]);

// exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      currentCount: 3,
      timer: "",
      imgScr: "",
      ds_id: "",
      channel_id: '',
      timer2: ""
    };
  },

  props: ["loaded"],
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var that, data, _data, _data2;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this;


              _this.ds_id = _Tools2.default.getQueryDsId();
              _this.channel_id = _Tools2.default.getQueryChannelId();

              _context.prev = 3;

              if (!(!_this.ds_id && _this.channel_id)) {
                _context.next = 15;
                break;
              }

              _context.next = 7;
              return _this.axios.post(_Tools2.default.baseUrl1() + "/customer/channel/getDsIdByChannelId", 'channel_code=' + _this.channel_id, { timeout: 6000 });

            case 7:
              data = _context.sent;

              if (!(data.data.code == 200)) {
                _context.next = 13;
                break;
              }

              _this.ds_id = data.data.data.ds_id;
              _Tools2.default.setDs_id(_this.ds_id);
              _context.next = 15;
              break;

            case 13:
              (0, _toast2.default)({ message: data.data.message, duration: 0 });
              return _context.abrupt("return");

            case 15:
              _context.next = 38;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              _context.prev = 19;
              _context.next = 22;
              return _this.axios.get(_Tools2.default.tencentOssUrl() + "/ds/channel_cache/channel_" + _this.channel_id + ".json?" + new Date().getTime() + parseInt(Math.random() * 10e4), { timeout: 2000 });

            case 22:
              _data = _context.sent;

              if (_data) {
                _this.ds_id = _data.data.ds_id;
                _Tools2.default.setDs_id(_this.ds_id);
              }
              _context.next = 38;
              break;

            case 26:
              _context.prev = 26;
              _context.t1 = _context["catch"](19);
              _context.prev = 28;
              _context.next = 31;
              return _this.axios.get(_Tools2.default.aliOssUrl() + "/ds/channel_cache/channel_" + _this.channel_id + ".json?" + new Date().getTime() + parseInt(Math.random() * 10e4), { timeout: 1000 });

            case 31:
              _data2 = _context.sent;

              if (_data2) {
                _this.ds_id = _data2.data.ds_id;
                _Tools2.default.setDs_id(_this.ds_id);
              }
              _context.next = 38;
              break;

            case 35:
              _context.prev = 35;
              _context.t2 = _context["catch"](28);

              (0, _toast2.default)({ message: '网络存在问题,请刷新重试', duration: 0 });

            case 38:

              if (_this.ds_id) {
                _Tools2.default.setDs_id(_this.ds_id);
              }

              _this.imgScr = _Tools2.default.baseUrl1() + "/wap/index/dsImg/?ds_id=" + _this.ds_id;
              _this.timer = setInterval(function () {
                if (that.currentCount == 1) {
                  clearInterval(that.timer);
                  if (that.loaded) {
                    that.enterHome();
                  }
                  that.timer2 = setInterval(function () {
                    that.enterHome();
                  }, 300);
                } else {
                  that.currentCount -= 1;
                }
              }, 1000);

            case 41:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 17], [19, 26], [28, 35]]);
    }))();
  },

  methods: {
    enterHome: function enterHome() {
      if (this.loaded) {
        this.$emit("closeload");
        clearInterval(this.timer1);
        clearInterval(this.timer2);
        return false;
      }
    }
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Launch"
    },
    on: {
      "click": _vm.enterHome
    }
  }, [(_vm.ds_id || _vm.channel_id) ? [_c('div', {
    staticClass: "img",
    style: ('background-image:url(' + _vm.imgScr + ')')
  }), _vm._v(" "), (_vm.currentCount > 0) ? _c('span', {
    staticClass: "timeDown"
  }, [_vm._v(_vm._s(_vm.currentCount) + " 秒进入")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('p', [_vm._v("获取房间号失败，请检查链接")])], 2)
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(225);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("576eb4ae", content, true);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".right-func-box[data-v-0e265ae4]{position:absolute;bottom:60px}.link-btn[data-v-0e265ae4],.right-func-box[data-v-0e265ae4]{z-index:3000;right:10px;width:50px;border-radius:20px;text-align:center}.link-btn[data-v-0e265ae4]{bottom:140px;height:70px}.link-btn img[data-v-0e265ae4]{width:40px;height:40px}.link-btn span[data-v-0e265ae4],.zixun-btn span[data-v-0e265ae4]{font-size:12px}.zixun-btn[data-v-0e265ae4]{z-index:3000;bottom:60px;right:10px;width:50px;height:70px;border-radius:20px;text-align:center}.zixun-btn img[data-v-0e265ae4]{width:40px;height:40px}.zixun-btn .unReadMsgPoint[data-v-0e265ae4]{position:absolute;bottom:54px;right:2px;display:inline-block;width:16px;height:16px;background-color:red;border-radius:8px}.shopping-dialog[data-v-0e265ae4]{position:fixed;top:0;left:0;right:0;display:flex;align-items:center;justify-content:center;bottom:0;width:100vw;height:100vh;z-index:9999;background:rgba(0,0,0,.7)}.shopping-dialog img[data-v-0e265ae4]{width:300px;height:300px}#ChatRoomContent[data-v-0e265ae4]{height:100%;overflow:scroll;scroll-behavior:smooth}.ChatRoom-body[data-v-0e265ae4]{background:#eee}.header-img[data-v-0e265ae4]{height:34px;width:34px;margin-top:15px;margin-left:10px;float:left;border-radius:15px}.van-swipe__track[data-v-0e265ae4]{height:50px}.van-swipe__indicators .van-swipe__indicator--active[data-v-0e265ae4]{background-color:red}.van-swipe__indicators[data-v-0e265ae4]{bottom:4px}.none[data-v-0e265ae4]{display:none}.loading[data-v-0e265ae4]{height:30px;width:30px;margin:10px auto}.header[data-v-0e265ae4]{position:relative;padding:0 10px 0 60px}.msg_header[data-v-0e265ae4]{position:absolute;top:12px;left:12px;height:36px;width:36px}.msg_header .headimg[data-v-0e265ae4]{width:36px;height:36px;border-radius:30px;border-color:#ffeb12;position:absolute}.type .msg_header .headimg[data-v-0e265ae4]{border-color:red}.banner[data-v-0e265ae4]{height:50px;overflow:hidden;width:100%}.banner a[data-v-0e265ae4]{width:100%;height:100%;display:block}.banner img[data-v-0e265ae4]{width:100%;height:50px;display:block}.ChatRoom-header[data-v-0e265ae4]{background:#e8e8e8;height:44px;overflow:hidden;line-height:44px;color:#343434}.ChatRoom-header.fixed[data-v-0e265ae4]{position:absolute;top:0;left:0;width:100%;z-index:1300}.ChatRoom-header.type[data-v-0e265ae4]{color:red}.total_comment[data-v-0e265ae4]{margin-left:10px;float:left}.total_like img[data-v-0e265ae4]{height:25px;width:25px;vertical-align:middle}.total_like[data-v-0e265ae4]{margin-right:10px;float:right}.total-like-num[data-v-0e265ae4]{position:relative;vertical-align:middle;background:#343434;padding:4px;margin-right:4px;border-radius:5px;color:#fff;min-width:18px;display:inline-block;line-height:18px;text-align:center}.type .total-like-num[data-v-0e265ae4]{background:red}.jiantou[data-v-0e265ae4]{position:absolute;top:18px;height:10px;width:10px;right:28px;background:#343434;color:#fff;transform:rotate(45deg);z-index:0}.type .jiantou[data-v-0e265ae4]{background:red}.comment_cell[data-v-0e265ae4]{position:relative;padding-bottom:15px}.comment_cell .header img[data-v-0e265ae4]{max-width:300%}.span-name[data-v-0e265ae4]{float:left;margin-top:22px;margin-left:12px;font-size:14px;color:#666}.span-time[data-v-0e265ae4]{margin-top:22px;margin-left:12px;float:left;font-size:12px;color:#ccc}.span-like-num[data-v-0e265ae4]{margin-top:22px;float:right;font-size:12px;margin-right:15px;color:#ccc}.span-like-num img[data-v-0e265ae4]{margin-right:3px;height:15px;width:14px;vertical-align:bottom}.wall_comment[data-v-0e265ae4]{border:1px solid #e2b766}.wall_comment span[data-v-0e265ae4]{color:#d4aa51;font-weight:700}.comment-text[data-v-0e265ae4]{word-wrap:break-word;font-size:15px;margin:8px 30px 0 60px;color:#333;background-color:#fff;border-radius:5px;padding:5px;line-height:19px;display:inline-block;max-width:64%;position:relative}.comment-text p .gift[data-v-0e265ae4]{width:30px;vertical-align:middle}.comment-floor[data-v-0e265ae4]{position:absolute;right:0;bottom:0;font-size:13px;margin-right:15px}.red-pack[data-v-0e265ae4]{margin-left:52px;margin-top:5px;width:78%;overflow:hidden;border-radius:5px}.caption[data-v-0e265ae4]{background:#fff;padding:5px;line-height:20px;font-size:14px}.caption span[data-v-0e265ae4]{color:#f99c3a}.red-pack-header[data-v-0e265ae4]{background-color:#f99c3a;height:65px}.red-pack-header-radius[data-v-0e265ae4]{border-radius:4px 4px 0 0}.red-pack-img[data-v-0e265ae4]{float:left;height:40px;width:38px;margin-top:13px;margin-left:15px}.red-pack-title[data-v-0e265ae4]{margin-top:0;color:#fff;padding-top:15px;padding-right:10px;font-size:13px;margin-left:60px;white-space:nowrap}.red-pack-desc[data-v-0e265ae4]{font-size:10px;margin-top:3px;padding-right:5px}.red-pack-body[data-v-0e265ae4]{background-color:#f5f5f5;border-radius:0 0 4px 4px}.red-pack-item[data-v-0e265ae4]{height:38px;line-height:38px;font-size:12px;margin-left:15px}.red-pack-item-name[data-v-0e265ae4]{color:#999;font-size:12px;max-width:170px;overflow:hidden;height:38px}.red-pack-item-text[data-v-0e265ae4]{color:#555;font-size:12px}.red-pack-item-money[data-v-0e265ae4]{color:#f99c3a;font-size:12px}.red-pack-item-time[data-v-0e265ae4]{float:right;font-size:11px;color:#ccc;margin-right:10px}.share_red_content[data-v-0e265ae4]{padding-top:10px}.total-zan[data-v-0e265ae4]{position:relative;display:inline-block}.zan-box[data-v-0e265ae4]{position:fixed;z-index:10000;height:20px;width:20px}.zan-box .zan-img[data-v-0e265ae4]:nth-child(3n){position:absolute;opacity:0;height:20px;width:20px;animation:zanA 2s}.zan-img[data-v-0e265ae4]:nth-child(3n+1){position:absolute;opacity:0;height:20px;width:20px;animation:zanB 2s}.zan-img[data-v-0e265ae4]:nth-child(3n+2){position:absolute;opacity:0;height:20px;width:20px;animation:zanC 2s}@keyframes zanA{0%{top:0;left:0;width:25px;opacity:1}33%{top:-66px;left:20px}66%{top:-133px;left:-20px}to{top:-200px;left:20px;width:50px;opacity:0;display:none}}@keyframes zanB{0%{top:0;left:0;width:25px;opacity:1}to{top:-200px;left:0;width:50px;opacity:0;display:none}}@keyframes zanC{0%{top:0;left:0;width:25px;opacity:1}to{top:-300px;left:20px;width:50px;opacity:0;display:none}}.entenview[data-v-0e265ae4]{position:fixed;margin-left:100%;z-index:2000;background-repeat:no-repeat;background-position:0;height:44px;line-height:54px;color:#ffde00;width:100%;background-size:auto 44px;padding-left:70px;animation:float 1.5s linear;top:60vh}.entenview1[data-v-0e265ae4]{background-image:url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/room/feiru_03.png)}.entenview2[data-v-0e265ae4]{background-image:url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/room/feiru_01.png)}.entenview3[data-v-0e265ae4]{background-image:url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/room/feiru_02.png)}.entenview2[data-v-0e265ae4],.entenview3[data-v-0e265ae4]{animation:float 6s linear;line-height:40px;width:216px;padding-left:36px;color:#fff;font-size:11px}@keyframes float{0%{margin-left:100%}30%{margin-left:10px}70%{margin-left:10px}to{margin-left:-100%}}.van-button--normal[data-v-0e265ae4]{width:60px;padding:0;text-align:center}.hostman[data-v-0e265ae4]{background:#fff1d7}.hostman .headimg[data-v-0e265ae4]{border-width:1px;border-style:solid}.rank[data-v-0e265ae4]{position:absolute;top:28px;width:55px;left:-8.5px}.occupyRank[data-v-0e265ae4]{position:absolute;top:-1px;width:52px;left:-8px}.msg_conent[data-v-0e265ae4]{background-color:#fff;margin:15px 36px 15px 56px;padding:12px 15px;border:1px solid #a47214;border-radius:10px;word-wrap:break-word}.contImg[data-v-0e265ae4]{display:block}.nameTime[data-v-0e265ae4]{padding-top:12px}.floor_name[data-v-0e265ae4]{width:100%;height:20px}.floor_name span[data-v-0e265ae4]{float:left}.nickname[data-v-0e265ae4]{color:#222;padding-left:4px;display:inline-block}.time[data-v-0e265ae4]{font-size:12px;height:16px;display:block}.tools[data-v-0e265ae4]{position:absolute;top:12px;right:0}.zanbar[data-v-0e265ae4]{float:right;margin-right:12px;color:#343434}.type .zanbar[data-v-0e265ae4]{color:red}.zanbar img[data-v-0e265ae4]{width:14px;vertical-align:middle}.zanbar span[data-v-0e265ae4]{vertical-align:middle;font-size:12px}.xinxin1[data-v-0e265ae4]{position:absolute;top:58px;left:56px;width:30px}.xinxin2[data-v-0e265ae4]{position:absolute;right:18px;top:46px;width:20px}.xinxin3[data-v-0e265ae4]{position:absolute;bottom:10px;width:50px;right:20px}.sublist[data-v-0e265ae4]{border-top:1px solid #dbdbdb;font-size:15px;background:#f5f5f5;margin:10px -10px -10px;padding:10px}.sublist .title[data-v-0e265ae4]{color:#929292}.sublist .title .time[data-v-0e265ae4]{font-size:12px}.unreadMsg[data-v-0e265ae4]{position:absolute;bottom:60px;left:50%;transform:translate(-50%);color:#2e93ff;background-color:#fff;padding:0 15px;border-radius:15px;line-height:30px;height:30px}.zanBox[data-v-0e265ae4]{position:fixed;top:50%;left:0;width:80%;height:100px;text-align:center;z-index:1400}.zanBox .num[data-v-0e265ae4]{width:100%;animation:upover .75s linear;opacity:0;position:absolute;top:0}.zanBox .num img[data-v-0e265ae4]{max-width:100%}.zanBox .num:nth-child(10n) img[data-v-0e265ae4]{height:60px}@keyframes upover{0%{opacity:1}to{margin-top:-100px;opacity:0}}.quanBox[data-v-0e265ae4]{padding:0;background-color:transparent}.quan[data-v-0e265ae4],.quanBox .caption[data-v-0e265ae4]{border-radius:10px;position:relative}.quan[data-v-0e265ae4]{padding:0;background-color:#de3041;background-repeat:no-repeat;background-position:right 10px bottom;-webkit-background-size:44px;background-size:44px;color:#fff;height:46px;padding:10px}.quan[data-v-0e265ae4]:after,.quan[data-v-0e265ae4]:before{position:absolute;content:\"\";left:37px;width:15px;height:15px;border-radius:50%;background:#eee;top:-8px}.hostman .quan[data-v-0e265ae4]:after,.hostman .quan[data-v-0e265ae4]:before{background:#fff1d7}.quan[data-v-0e265ae4]:before{top:60px}.quan .quantype[data-v-0e265ae4]{display:table-cell;width:26px;padding:0 4px;line-height:16px;color:#fbea00;font-size:14px}.quan p[data-v-0e265ae4]{border-left:1px dashed #fff;padding:0 0 0 18px;vertical-align:middle;display:table-cell;height:46px}.quan p span[data-v-0e265ae4]{display:inline-block;max-height:46px;overflow:hidden}.countDown[data-v-0e265ae4]{position:absolute;left:0;right:0;z-index:2000;background:#fff;padding:0;padding-top:10px;text-align:center;color:#333}.countDown h4[data-v-0e265ae4]{line-height:36px;border-bottom:1px dashed #7d7d7d}.countDown p[data-v-0e265ae4]{line-height:36px}.countDown .times[data-v-0e265ae4]{margin:0 auto;width:215px;height:30px;padding:0 8px 8px;border-radius:5px;font-size:25px;color:#666;display:-webkit-box;display:-moz-box;display:flex;overflow:hidden;position:relative}.countDown .times[data-v-0e265ae4]:after{display:block;content:\"\";position:absolute;top:50%;left:0;width:100%;height:10px}.countDown li[data-v-0e265ae4]{border-left:1px solid #fff;flex:1;line-height:30px}.countDown li[data-v-0e265ae4]:first-child{border:none}.countDown li span[data-v-0e265ae4]{font-size:12px}.subscribe[data-v-0e265ae4]{height:30px;line-height:30px;border:1px solid #1483ff;border-radius:30px;color:#1483ff;width:100px;margin:5px auto;text-align:center}.unReadViewShowAni[data-v-0e265ae4]{animation:showUnReadView .5s ease-in,hiddenUnReadView 1s ease-out 3s;animation-fill-mode:forwards}@keyframes showUnReadView{0%{opacity:0}to{opacity:1}}@keyframes hiddenUnReadView{0%{opacity:1}to{opacity:0}}.unReadView[data-v-0e265ae4]{position:absolute;bottom:95px;right:66px;min-width:50px;max-width:200px;min-height:30px;background-color:#fff;z-index:3000;border-radius:5px;line-height:30px;padding-left:5px;padding-right:5px;word-wrap:break-word;word-break:normal}.unReadView .header[data-v-0e265ae4]{width:26px;height:26px;border-radius:13px;vertical-align:-8px;padding-left:0;padding-right:0}.unReadView .sanjiao[data-v-0e265ae4]{width:0;height:0;border-left:10px solid #fff;border-bottom:10px solid transparent;border-top:10px solid transparent;position:absolute;bottom:4px;right:-10px}.zhuTeacher[data-v-0e265ae4]{display:inline-block;text-align:center;color:#fff;background:red;font-size:10px;margin-left:2px;line-height:13px;padding:2px 3px;border-radius:3px}.copyText[data-v-0e265ae4]{position:absolute;right:-31px;top:6px;font-size:13px;color:#1483ff}.teacher_replay_text[data-v-0e265ae4]{color:#555;margin-left:3px;font-size:13px;line-height:20px}.noticeBox[data-v-0e265ae4]{position:absolute;left:0;right:0;z-index:2001}.noticeBar[data-v-0e265ae4]{background:#c6dbff;padding:0;height:36px;font-size:14px;text-align:center;color:#202020}", ""]);

// exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

var _swipe = __webpack_require__(35);

var _swipe2 = _interopRequireDefault(_swipe);

var _swipeItem = __webpack_require__(36);

var _swipeItem2 = _interopRequireDefault(_swipeItem);

var _loading = __webpack_require__(24);

var _loading2 = _interopRequireDefault(_loading);

var _noticeBar = __webpack_require__(45);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

var _list = __webpack_require__(92);

var _list2 = _interopRequireDefault(_list);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(7);

__webpack_require__(17);

__webpack_require__(38);

__webpack_require__(39);

__webpack_require__(93);

__webpack_require__(49);

__webpack_require__(21);

__webpack_require__(94);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _eventBus = __webpack_require__(95);

var _eventBus2 = _interopRequireDefault(_eventBus);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_list2.default);
_vue2.default.use(_popup2.default);
_vue2.default.use(_noticeBar2.default);
_vue2.default.use(_loading2.default);
_vue2.default.use(_swipe2.default).use(_swipeItem2.default);
exports.default = {
  directives: {
    WaterfallLower: (0, _waterfall2.default)("lower"),
    WaterfallUpper: (0, _waterfall2.default)("upper")
  },
  computed: _extends({}, (0, _vuex.mapGetters)({
    userConfig: "dsInfo/getUserConfig",
    businessConfigs: "dsInfo/getBusinessConfigs"
  })),
  data: function data() {
    var _ref;

    return _ref = {
      tid: 0,
      styleType: 1,
      chatRecord: [],
      adImages: [],
      unReadMsgNum: 0, //未读消息条数
      timer1: {},
      enterNames: [],
      enterSales: [],
      enterMoney: [],
      isLoading: false,
      loadingShow: false,
      hostId: "-1",
      isShowAd: false,
      timer: "",
      ds_id: "",
      isShowUnReadMsg: false,
      isOnscroll: false,
      homeRodRedBagStyle: {}, //抢红包
      homeRobRedBagListStyle: {}, //红包列表
      redBaglistData: {},
      robed: false,
      welcomeTimer: null,
      lovestyle: [[], [], [], [], [], [], [], [], []],
      personIndex: 0,
      productIndex: 0,
      moneyIndex: 0,
      isWeixin: true,
      numList: [],
      numTimer: "",
      zanIndex: 0,
      zanNum: [],
      zanimgIndex: 0,
      zanimg: [],
      chongbai: "",
      dianzan: "",
      lianji: "",
      lihai: "",
      haipi: "",
      kuai: "",
      hundred: "",
      bang: "",
      caicai: "",
      siyi: "",
      reviewWrap: [],
      reviewTimer: "",
      showH: false,
      fristMsgId: "",
      quick_id: "",
      total_like: 0,
      loaded: false,
      zanAmount: 0,
      likeTimer: "",
      IMlogin: false,
      imgPath: "",
      intervalTime: 0,
      prohibit: false,
      subscribed: false,
      showCode: false,
      subscribedText: "subscribed",
      days: "00",
      hours: "00",
      minites: "00",
      seconds: "00"
    }, _defineProperty(_ref, "timer", ""), _defineProperty(_ref, "livetimeend", false), _defineProperty(_ref, "scrollTop", 0), _defineProperty(_ref, "scrolltimer", null), _defineProperty(_ref, "loadCommenting", false), _defineProperty(_ref, "isIOS", false), _defineProperty(_ref, "unReadMsgPointShow", false), _defineProperty(_ref, "unReadMsgData", null), _defineProperty(_ref, "showUnReadView", false), _defineProperty(_ref, "diff", 0), _defineProperty(_ref, "startY", 0), _defineProperty(_ref, "isNoitceTopShow", true), _defineProperty(_ref, "noticetimer", null), _ref;
  },

  props: ["fans_id", "initData", "fullscr", "forbid", "totalLike", "currentMid", "mid", "dynamicData", "directStatus", "startTime", "playerStatus", "linkType", "openWx_follow", "showTeacherBtn", "noticeObj", "isshowCart", "channel_code", "isLoadHistory", "dsId", "isThreeScreen"],
  watch: {
    isLoadHistory: {
      handler: function handler(newVal, oldVal) {
        if (this.isLoadHistory) {
          this.initCommentData();
        }
      },
      immediate: true
    },
    currentMid: function currentMid() {
      if (!this.loaded && this.currentMid == this.mid) {
        this.beforeInit();
      }
      if (this.currentMid == this.mid) {
        this.openReview();
        this.prohibit = false;
      } else {
        clearInterval(this.reviewTimer);
        this.prohibit = true;
      }
    },
    fullscr: function fullscr(o, n) {
      if (n) {
        clearInterval(this.reviewTimer);
      } else {
        this.openReview();
      }
    },
    totalLike: function totalLike(curVal, oldVal) {
      this.total_like = curVal;
    },
    noticeObj: function noticeObj(newVal, oldVal) {
      var _this = this;

      if (newVal.open) {
        var index_tmp = this.reviewWrap.findIndex(function (item) {
          return item.module == "notice";
        });
        if (index_tmp != -1) {
          this.reviewWrap.splice(index_tmp, 1);
        }
        this.reviewWrap.unshift({
          module: "notice",
          content: newVal.content,
          nick: "公告",
          header: "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/wx-user/img/ico_gonggao%402x.png"
        });
        this.chatRecord = this.reviewWrap.concat().reverse();
        this.isNoitceTopShow = true;
        if (this.noticetimer) {
          clearTimeout(this.noticetimer);
          this.noticetimer = null;
        }
        if (newVal.time != -1) {
          this.noticetimer = setTimeout(function () {
            _this.isNoitceTopShow = false;
          }, parseInt(newVal.time || 0) * 1000);
        }
      } else {
        if (this.noticetimer) {
          clearTimeout(this.noticetimer);
          this.noticetimer = null;
        }
        var _index_tmp = this.reviewWrap.findIndex(function (item) {
          return item.module == "notice";
        });
        if (_index_tmp != -1) {
          this.reviewWrap.splice(_index_tmp, 1);
        }
        this.chatRecord = this.reviewWrap.concat().reverse();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.reviewTimer);
  },
  mounted: function mounted() {
    var that = this;
    this.isWeixin = _Tools2.default.isWeixin();
    this.ds_id = _Tools2.default.getDs_id();

    this.tid = _Tools2.default.getQueryString("tid");
    this.subscribedText += this.ds_id;
    this.subscribed = localStorage.getItem('"' + this.subscribedText + '"');
    console.log(this.subscribedText + "____" + this.subscribed);
    this.imgPath = _Tools2.default.imgPath();
    this.getImg();
    this.timeSwitch();
    this.isIOS = _Tools2.default.checkPhoneType() == 2;

    //监听消息
    _eventBus2.default.$on("messageisCheck", function (json) {
      that.textComment(json);
    });
  },

  methods: {
    copyTextTap: function copyTextTap(text) {
      var reg = /\<a(.*?)\>(\S*)\<\/a>/;
      var resultArr = text.match(reg);
      if (resultArr && resultArr[2]) {
        text = resultArr[2];
      }
      var oInput = document.createElement('input'); //创建一个隐藏input（重要！）
      oInput.value = text; //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.style.display = 'none';
      document.body.removeChild(oInput);
      (0, _toast2.default)("复制成功");
    },
    onLinkCLick: function onLinkCLick() {
      this.$emit("sendApplyLink");
    },
    onShowTeacherList: function onShowTeacherList() {
      this.unReadMsgPointShow = false;
      this.$emit("onShowTeacherList");
    },
    onShowGoodsList: function onShowGoodsList() {
      this.$emit("onShowGoodsList");
    },
    onLinkEndClick: function onLinkEndClick() {
      this.$emit("sendEndLink");
    },
    getImg: function getImg() {
      var path = this.imgPath;
      for (var i = 0; i < 10; i++) {
        this.zanNum.push(path + "zan/" + i + ".png");
        this.zanimg.push(path + "zan/zanimg" + i + ".png");
      }
      this.chongbai = path + "zan/chongbai.png";
      this.dianzan = path + "zan/dianzan.png";
      this.lianji = path + "zan/lianji.png";
      this.lihai = path + "zan/lihai.png";
      this.haipi = path + "zan/haipi.png";
      this.kuai = path + "zan/kuai.png";
      this.hundred = path + "zan/hundred.png";
      this.bang = path + "zan/bang.png";
      this.caicai = path + "zan/caicai.png";
      this.siyi = path + "zan/siyi.png";
    },
    chatScroll: function chatScroll() {//滚动到底部
      // var h = document.getElementById("ChatRoomContent").scrollHeight;
      // this.scrollTop = document.getElementById("ChatRoomContent").scrollTop;
      // if (h - this.scrollTop > 800) {
      //   this.isOnscroll = true;
      // } else {
      //   this.isOnscroll = false;
      //   this.isShowUnReadMsg = false;
      //   this.unReadMsgNum = 0;
      // }
    },
    chatTouchstart: function chatTouchstart(e) {
      this.diff = 0;
      var touch = e.touches[0];
      this.startY = touch.pageY;
    },
    chatTouchmove: function chatTouchmove(e) {
      var touch = e.touches[0];
      var endY = touch.pageY;
      this.diff = endY - this.startY;
    },
    chatTouchend: function chatTouchend(e) {
      if (Math.abs(this.diff) > 60 && !this.businessConfigs.student_message_auto_scroll) {
        console.log("====>", this.diff, "isOnscroll", this.isOnscroll);
        if (this.diff > 0) {
          this.isOnscroll = true;
        } else {
          var last_mouseWheel_scrollTop = document.getElementById("ChatRoomContent").scrollTop;
          var h = document.getElementById("ChatRoomContent").scrollHeight;
          var windowHeight = document.getElementById("ChatRoomContent").clientHeight;
          if (h <= last_mouseWheel_scrollTop + windowHeight + 10) {
            this.isOnscroll = false;
            this.isShowUnReadMsg = false;
            this.unReadMsgNum = 0;
          }
        }
      }
    },
    beforeInit: function beforeInit() {
      if (navigator.userAgent.indexOf("iPhone") > -1) {
        this.isIOS = true;
      }
      this.loaded = true;
      //this.inputblur();
      this.init();
    },
    removePL: function removePL() {
      var scrollTop;
      if (document.getElementById("ChatRoomContent")) {
        scrollTop = document.getElementById("ChatRoomContent").scrollTop;
      }
      if (scrollTop < 2000 && 160 >= this.reviewWrap.length && this.reviewWrap.length >= 60) {
        this.reviewWrap.splice(30, this.reviewWrap.length);
        this.fristMsgId = this.reviewWrap[this.reviewWrap.length - 1]._id;
      } else if (2000 < scrollTop && scrollTop < 5000 && this.reviewWrap.length >= 120) {
        this.reviewWrap.splice(60, this.reviewWrap.length);
        this.fristMsgId = this.reviewWrap[this.reviewWrap.length - 1]._id;
      } else {}
    },
    init: function init() {
      this.total_like = this.totalLike;
      //功能解析
      for (var i = 0; i < this.initData.ds_func.length; i++) {
        var j = this.initData.ds_func[i];

        // if(j.module == "ad" && j.enabled == "yes") { //广告功能
        // 	this.isShowAd = true;
        // 	this.adImages = this.adImages.concat(j.params);
        // 	console.log(this.adImages)
        // } else

        if (j.module == "master") {
          //主持人功能
          this.hostId = j.params.fans_id;
        }
      }
      if (this.initData.direct_seeding.style != 0) {
        this.styleType = this.initData.direct_seeding.style;
      }
    },
    initCommentData: function initCommentData() {
      var that = this;
      that.loadingShow = true;
      var url = _Tools2.default.baseUrl2() + "/comment/index/listsForStudent";
      var option = "ds_id=" + this.dsId + "&_id=" + this.fristMsgId;

      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }

      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          var dataClip = [];
          data.data.forEach(function (item) {
            if (item.module != "redrain_comment") {
              if (item.channel_code) {
                var channel_code_arr = JSON.parse(item.channel_code);
                if (channel_code_arr.indexOf(that.channel_code) > -1) {
                  dataClip.push(item);
                }
              } else {
                dataClip.push(item);
              }
            }
          });

          if (that.noticeObj.open) {
            dataClip.unshift({
              module: "notice",
              content: that.noticeObj.content,
              nick: "公告",
              header: "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/wx-user/img/ico_gonggao%402x.png"
            });
            if (that.noticeObj.time != -1) {
              that.noticetimer = setTimeout(function () {
                that.isNoitceTopShow = false;
              }, parseInt(that.noticeObj.time || 0) * 1000);
            }
          }

          that.reviewWrap = that.reviewWrap.concat(dataClip);
          that.chatRecord = that.reviewWrap.concat().reverse();

          setTimeout(function () {
            document.getElementById("ChatRoomContent").scrollTop = document.getElementById("ChatRoomContent").scrollHeight;
          }, 500);

          setTimeout(function () {
            that.loadingShow = false;
            if (!dataClip.length) {
              // that.isLoading = true;
            } else {
              that.fristMsgId = that.reviewWrap[that.reviewWrap.length - 1]._id;
              that.isLoading = false;
              console.log("数据还有加载中");
            }
            that.isLoading = false;
          }, 500);
        } else {
          console.log(data.message);
        }
      }).catch(function (res) {
        // that.waterfall_disabled = true;
        that.isLoading = false;
        that.loadingShow = false;
        console.log(res);
      });
    },
    loadMore: function loadMore() {
      var that = this;
      console.log("加载数据中loadMore");
      console.log(this.isLoading);
      // if(!this.waterfall_disabled){
      // 	return;
      // }
      console.log("加载数据中loadMore----bing");
      // that.loadCommenting = true;
      // this.waterfall_disabled = true;
      that.loadingShow = true;
      var url = _Tools2.default.baseUrl2() + "/comment/index/listsForStudent";
      var option = "ds_id=" + this.ds_id + "&_id=" + this.fristMsgId;

      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }

      this.axios.post(url, option).then(function (res) {
        that.loadingShow = false;
        that.loadCommenting = false;
        var data = res.data;
        if (data.code == "200") {
          if (data.data.length == 0) {
            that.isLoading = false;
            (0, _toast2.default)("没有数据了");
            return;
          }
          var dataClip = [];
          data.data.forEach(function (item) {
            if (item.module != "redrain_comment") {
              if (item.channel_code) {
                var channel_code_arr = JSON.parse(item.channel_code);
                if (channel_code_arr.indexOf(that.channel_code) > -1) {
                  dataClip.push(item);
                }
              } else {
                dataClip.push(item);
              }
            }
          });
          that.reviewWrap = that.reviewWrap.concat(dataClip);
          that.chatRecord = that.reviewWrap.concat().reverse();

          if (that.chatRecord.length > 300) {
            that.chatRecord.splice(0, 50);
          }

          if (!dataClip.length) {
            // that.waterfall_disabled = true;
            // return;
          } else {
            that.fristMsgId = that.reviewWrap[that.reviewWrap.length - 1]._id;
            console.log("还可以加载中");
          }
          that.isLoading = false;
        } else {
          console.log(data.message);
        }
        that.isLoading = false;
      }).catch(function (res) {
        that.loadingShow = false;
        that.isLoading = false;
        // that.loadCommenting = false;
        console.log(res);
      });
    },
    personenter: function personenter(name) {
      var that = this;
      if (this.prohibit || this.forbid) {
        return;
      }
      if (this.intervalTime == 0) {
        this.enterNames.push(name);
      } else {
        return false;
      }
      var time = Math.random() * 300 + 100;
      console.log("飘窗进入");
      this.intervalTime = 1;
      setTimeout(function () {
        that.intervalTime = 0;
      }, time);
      setTimeout(function () {
        that.personIndex++;
      }, 1500);
    },
    productEnter: function productEnter(name, num) {
      var that = this;
      if (this.prohibit || this.forbid) {
        return;
      }
      this.enterSales.push({ nick: name, num: num });
      setTimeout(function () {
        that.productIndex++;
      }, 6000);
    },
    moneyEnter: function moneyEnter(name, money) {
      var that = this;
      if (this.prohibit || this.forbid) {
        return;
      }
      this.enterMoney.push({ nick: name, money: money });
      setTimeout(function () {
        that.moneyIndex++;
      }, 6000);
    },
    openReview: function openReview() {
      console.log("openRe");
      var that = this;
      this.reviewTimer = setInterval(function () {
        that.removePL();
        that.chatRecord = that.reviewWrap.concat().reverse();
      }, 2000);
    },
    addLikeNum: function addLikeNum(item) {
      var url,
          option,
          that = this;
      if (item) {
        url = _Tools2.default.baseUrl2() + "/comment/index/addLikeNum";
        option = "&ds_id=" + this.ds_id + "&id=" + item._id;
        this.sendLike(url, option);
      } else {
        this.zanAmount++;
        this.total_like++;
        url = _Tools2.default.baseUrl2() + "/init/addAgree";
        option = "ds_id=" + this.ds_id + "&num=" + this.zanAmount;
        clearTimeout(this.likeTimer);
        this.likeTimer = setTimeout(function () {
          that.sendLike(url, option);
        }, 1000);
      }
    },
    sendLike: function sendLike(url, option) {
      var that = this;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        console.log(data);
        that.zanAmount = 0;
      }).catch(function (res) {
        console.log("错误" + res.data);
      });
    },
    reply: function reply(item) {
      //回复
      _eventBus2.default.$emit("replying", item);
    },
    robRedBagAction: function robRedBagAction(item) {
      //抢红包
      this.$emit("robRedBagAction", item);
    },
    onAdClicked: function onAdClicked(link) {
      if (link != "") {
        window.location.href = link;
      }
    },

    //未读消息滚动到顶部
    unReadMsgAction: function unReadMsgAction() {
      this.unReadMsgNum = 0;
      this.isOnscroll = false;
      this.isShowUnReadMsg = false;
      document.getElementById("ChatRoomContent").scrollTop = document.getElementById("ChatRoomContent").scrollHeight;
    },
    preview: function preview(url) {
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: [url] // 需要预览的图片http链接列表
      });
    },
    subscribe: function subscribe() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + "/api/ds/subscribe";
      var option = "subscribe_id=" + this.ds_id + "&fans_id=" + this.fans_id + "&type=ds_room";
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          (0, _toast2.default)(data.data);
          that.subscribed = true;
          localStorage.setItem('"' + that.subscribedText + '"', that.subscribed);
        } else if (data.code == "401") {
          (0, _toast2.default)(data.message);
          setTimeout(function () {
            that.showCode = true;
          }, 1000);
        } else {
          (0, _toast2.default)(data.message);
        }
      }).catch(function (res) {
        console.log(res);
      });
    },
    redpacket: function redpacket(json) {
      for (var i = 0, len = this.reviewWrap.length; i < len; i++) {
        var item = this.reviewWrap[i];
        if (item._id == json._id) {
          if (item.sublist) {
            item.sublist.push(json);
          } else {
            this.$set(item, "sublist", [json]);
          }
          break;
        }
      }
    },
    addLikeNumIm: function addLikeNumIm(json) {
      if (json._id) {
        for (var i = 0; i < this.reviewWrap.length; i++) {
          var item = this.reviewWrap[i];
          if (item._id == json._id) {
            item.like_num += 1;
            break;
          }
        }
      }
      this.total_like += json.like_num;
    },
    deleteComment: function deleteComment(json) {
      console.log(this.reviewWrap);
      for (var i = 0; i < this.reviewWrap.length; i++) {
        var item = this.reviewWrap[i];
        if (item._id == json._id) {
          this.reviewWrap.splice(i, 1);
          break;
        }
      }
    },
    textComment: function textComment(json) {
      //过滤重复消息
      if (json.business_id) {
        console.log("子评论");
        for (var i = 0, len = this.reviewWrap.length; i < len; i++) {
          var item = this.reviewWrap[i];
          if (item._id == json._id) {
            if (item.sublist) {
              if (json.content && json.content != "null") {
                json.content = json.content.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
              }
              item.sublist.push(json);
            } else {
              if (json.content && json.content != "null") {
                json.content = json.content.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
              }
              this.$set(item, "sublist", [json]);
            }
            break;
          }
        }
      } else {
        //先审后发处理
        var hasKey = this.reviewWrap.find(function (item1) {
          return item1.key == json.key && item1.key;
        });
        if (hasKey) {
          hasKey._id = json._id;
          return;
        }
        //未读消息处理
        if (this.isOnscroll) {
          this.isShowUnReadMsg = true;
          this.unReadMsgNum = this.unReadMsgNum + 1;
        } else {
          this.isShowUnReadMsg = false;
          this.unReadMsgNum = 0;
        }
        if (json.content && json.content != "null") {
          json.content = json.content.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }

        this.reviewWrap.unshift(json);

        //评论超过1千删除200
        if (this.reviewWrap.length > 400) {
          this.reviewWrap = this.reviewWrap.slice(0, 250);
        }
        this.chatRecord = this.reviewWrap.concat().reverse();

        //一秒内收到多条消息时，只刷新一次
        this.msgScrollBottom();
      }
    },
    msgScrollBottom: function msgScrollBottom() {
      // var h = document.getElementById("ChatRoomContent").scrollHeight;
      // var self = this;
      // if (this.scrolltimer == null) {
      //   this.scrolltimer = setTimeout(function() {
      //     if (h - self.scrollTop < 800) {
      //       document.getElementById(
      //         "ChatRoomContent"
      //       ).scrollTop = document.getElementById(
      //         "ChatRoomContent"
      //       ).scrollHeight;
      //     }
      //     self.scrolltimer = null;
      //   }, 500);
      // }

      if (!this.isOnscroll) {
        setTimeout(function () {
          document.getElementById("ChatRoomContent").scrollTop = document.getElementById("ChatRoomContent").scrollHeight;
        }, 0);
      }
    },
    giftComment: function giftComment(json) {
      this.reviewWrap.unshift(json);
    },
    riseData: function riseData(json) {
      var that = this;
      this.$emit("personnum", json.view_num);
      if (this.total_like < json.like_num) {
        this.total_like = json.like_num;
      }
      if (!this.welcomeTimer) {
        var count = json.personData.length;
        this.welcomeTimer = setInterval(function () {
          if (json.personData.length == 0) {
            clearInterval(that.welcomeTimer);
            that.welcomeTimer = null;
          } else {
            that.personenter(json.personData.shift().nick);
            that.$emit("personnum", 0);
          }
        }, 10000 / count);
      }
    },
    addReviewWrap: function addReviewWrap(json) {
      this.reviewWrap.unshift(json);
    },
    zan: function zan(ev, item) {
      var that = this,
          arr = [];
      clearTimeout(this.timer);
      clearTimeout(this.numTimer);
      if (item) {
        this.addLikeNum(item);
      } else {
        this.addLikeNum();
      }

      function zann(ev) {
        var index = Math.ceil(Math.random() * 9) - 1;
        that.lovestyle[index].push({
          left: ev.clientX - 10 + "px",
          top: ev.clientY - 30 + "px"
        });
        setTimeout(function () {
          that.lovestyle[index].shift();
        }, 3000);
      }
      zann(ev);
      this.zanIndex++;
      console.log(this.zanIndex);
      if (this.zanIndex < 10) {
        arr.push(this.zanNum[this.zanIndex]);
        if (this.zanIndex == 1) {
          arr.push(this.dianzan);
        } else {
          arr.push(this.lianji);
        }
      } else if (this.zanIndex >= 10 && this.zanIndex < 100) {
        if (this.zanIndex == 10) {
          arr.push(this.lihai);
        } else if (this.zanIndex == 20) {
          arr.push(this.chongbai);
        } else if (this.zanIndex == 30) {
          arr.push(this.siyi);
        } else if (this.zanIndex == 50) {
          arr.push(this.kuai);
        } else if (this.zanIndex == 80) {
          arr.push(this.caicai);
        } else {
          arr.push(this.zanNum[this.zanIndex.toString().substr(0, 1)]);
          arr.push(this.zanNum[this.zanIndex.toString().substr(1, 1)]);
          arr.push(this.lianji);
        }
      } else if (this.zanIndex >= 100 && this.zanIndex < 200) {
        if (this.zanIndex == 100) {
          arr.push(this.hundred);
        } else if (this.zanIndex == 150) {
          arr.push(this.haipi);
        } else {
          arr.push(this.zanNum[this.zanIndex.toString().substr(0, 1)]);
          arr.push(this.zanNum[this.zanIndex.toString().substr(1, 1)]);
          arr.push(this.zanNum[this.zanIndex.toString().substr(2, 1)]);
          arr.push(this.lianji);
        }
      } else {
        arr.push(this.bang);
      }
      this.numList.push(arr);
      this.numTimer = setTimeout(function () {
        that.zanIndex = 0;
        that.numList = [];
      }, 1000);

      this.zanimgIndex = parseInt(Math.random() * 10) - 1;
    },
    timeSwitch: function timeSwitch() {
      var now = new Date().getTime();
      if (!this.startTime) {
        return;
      }
      var start = new Date(this.startTime.replace(/-/g, "/")).getTime();
      if (now < start) {
        this.countDown(parseInt((start - now) / 1000));
        //console.log('未开始');
      } else {
        this.livetimeend = true;
      }
    },
    countDown: function countDown(times) {
      var that = this;
      clearInterval(this.timer);
      this.timer = setInterval(function () {
        if (times != 0) {
          times--;
          that.days = Math.floor(times / 86400);
          that.hours = _Tools2.default.two(Math.floor(times % 86400 / 3600));
          that.minites = _Tools2.default.two(Math.floor(times % 3600 / 60));
          that.seconds = _Tools2.default.two(Math.floor(times % 60));
        } else {
          that.livetimeend = true;
          clearInterval(that.timer);
        }
      }, 1000);
    },
    receivedMsg: function receivedMsg(json) {
      this.unReadMsgPointShow = true;
    },
    showUnReadViewFunc: function showUnReadViewFunc(json) {
      var _this2 = this;

      this.unReadMsgData = json;
      this.showUnReadView = true;
      setTimeout(function () {
        _this2.showUnReadView = false;
      }, 4500);
    },
    changeNick: function changeNick(nick) {
      if (nick) {
        // var value = nick.replace(/[^0-9]/gi, "");
        // if (value.length == 11) {
        //   //3.截取所有数字，并用*替换4，4
        //   var phNum = nick.replace(/[^0-9]/gi, "");
        //   var phnumAfter = phNum.substr(0, 3) + "****" + phNum.substr(7);
        //   return nick.replace(phNum, phnumAfter);
        // }
        return nick.replace(/(\d{3})\d{4}(\d{4})/g, "$1****$2");
      }
      return "";
    }
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-list__error-text,.van-list__finished-text,.van-list__loading-text{color:#969799;font-size:13px;line-height:50px;text-align:center}.van-list__loading{text-align:center}.van-list__loading-icon,.van-list__loading-text{display:inline-block;vertical-align:middle}.van-list__loading-icon{width:16px;height:16px;margin-right:5px}", ""]);

// exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ChatRoom"
    }
  }, [(!_vm.livetimeend && _vm.directStatus != 'running') ? _c('div', {
    staticStyle: {
      "height": "84px"
    }
  }, [_c('div', {
    staticClass: "countDown"
  }, [_c('p', [_vm._v("直播倒计时")]), _vm._v(" "), _c('ul', {
    staticClass: "times"
  }, [_c('li', [_vm._v("\n            " + _vm._s(_vm.days) + "\n            "), _c('span', [_vm._v("天")])]), _vm._v(" "), _c('li', [_vm._v("\n            " + _vm._s(_vm.hours) + "\n            "), _c('span', [_vm._v("时")])]), _vm._v(" "), _c('li', [_vm._v("\n            " + _vm._s(_vm.minites) + "\n            "), _c('span', [_vm._v("分")])]), _vm._v(" "), _c('li', [_vm._v("\n            " + _vm._s(_vm.seconds) + "\n            "), _c('span', [_vm._v("秒")])])])])]) : _vm._e(), _vm._v(" "), (_vm.noticeObj.open && _vm.isNoitceTopShow) ? _c('div', {
    staticStyle: {
      "height": "36px"
    }
  }, [_c('div', {
    staticClass: "noticeBox"
  }, [_c('van-notice-bar', {
    staticClass: "noticeBar",
    attrs: {
      "text": _vm.noticeObj.content
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-func-box"
  }, [((_vm.businessConfigs && (_vm.businessConfigs.student_room_link_mic_show || _vm.businessConfigs.student_room_link_mic_show == undefined)) &&
    _vm.initData.direct_seeding.play_style == 3 && _vm.initData.direct_seeding.direct_status == 'running' && _vm.playerStatus == 2) ? _c('div', {
    staticClass: "link-btn"
  }, [(_vm.linkType != 3) ? _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/lianmai.png"
    },
    on: {
      "click": _vm.onLinkCLick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.linkType == 3) ? _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/lianmaizhong.png"
    },
    on: {
      "click": _vm.onLinkEndClick
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onLinkEndClick
    }
  }, [_vm._v("连麦互动")])]) : _vm._e(), _vm._v(" "), (_vm.isshowCart) ? _c('div', {
    staticClass: "zixun-btn"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(96)
    },
    on: {
      "click": _vm.onShowGoodsList
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onShowGoodsList
    }
  }, [_vm._v("购物车")])]) : _vm._e(), _vm._v(" "), (_vm.showTeacherBtn && (!_vm.userConfig || (_vm.userConfig && _vm.userConfig.show_teacher != 0))) ? _c('div', {
    staticClass: "zixun-btn"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(230)
    },
    on: {
      "click": _vm.onShowTeacherList
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onShowTeacherList
    }
  }, [_vm._v("咨询老师")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unReadMsgPointShow),
      expression: "unReadMsgPointShow"
    }],
    staticClass: "unReadMsgPoint"
  })]) : _vm._e(), _vm._v(" "), (_vm.openWx_follow) ? _c('div', {
    staticClass: "zixun-btn"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(231)
    },
    on: {
      "click": function($event) {
        return _vm.$emit('onShowFouceAlert')
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.onShowTeacherList
    }
  }, [_vm._v("关注+")])]) : _vm._e()]), _vm._v(" "), (_vm.showUnReadView) ? _c('div', {
    ref: "unReadMessageView",
    staticClass: "unReadView unReadViewShowAni",
    on: {
      "click": _vm.onShowTeacherList
    }
  }, [(_vm.unReadMsgData) ? _c('img', {
    staticClass: "header",
    attrs: {
      "src": _vm.unReadMsgData.header
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.unReadMsgData ? _vm.unReadMsgData.content : "") + "\n    "), _c('i', {
    staticClass: "sanjiao"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ChatRoomContent"
    },
    on: {
      "scroll": _vm.chatScroll,
      "touchstart": _vm.chatTouchstart,
      "touchmove": _vm.chatTouchmove,
      "touchend": _vm.chatTouchend
    }
  }, [_c('van-pull-refresh', {
    staticClass: "ChatRoom-body",
    attrs: {
      "id": "ChatRoom-bodyId"
    },
    on: {
      "refresh": _vm.loadMore
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [(_vm.chatRecord.length) ? [_vm._l((_vm.chatRecord), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cell"
    }, [_c('div', {
      staticClass: "comment_cell",
      class: {
        hostman: item.fans_id == _vm.hostId && item.module != 'wall_comment',
        type: _vm.styleType == 3,
      }
    }, [_c('div', {
      staticClass: "header"
    }, [(item.module != 'wall_comment') ? [(item.fans_id == _vm.hostId) ? _c('div', {
      staticClass: "msg_header"
    }, [_c('img', {
      staticClass: "headimg",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (_vm.styleType != 3) ? _c('img', {
      staticClass: "rank",
      attrs: {
        "src": _vm.imgPath + 'room/zhuchiren1.png'
      }
    }) : _c('img', {
      staticClass: "rank",
      attrs: {
        "src": _vm.imgPath + 'room/zhuchiren3.png'
      }
    })]) : _c('div', {
      staticClass: "msg_header"
    }, [_c('img', {
      staticClass: "headimg",
      attrs: {
        "src": item.header
      }
    })])] : [_c('div', {
      staticClass: "msg_header"
    }, [_c('img', {
      staticClass: "occupyRank",
      attrs: {
        "src": _vm.imgPath + 'room/headImg-bg.png'
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "headimg",
      attrs: {
        "src": item.header
      }
    })])], _vm._v(" "), _c('div', {
      staticClass: "nameTime"
    }, [_c('div', {
      staticClass: "floor_name",
      staticStyle: {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px",
        "line-height": "20px",
        "max-width": "200px"
      },
      style: ({
        color: item.to_fans_id ? '#027DB4' : '#444444'
      })
    }, [_vm._v(_vm._s(_vm.changeNick(item.nick)))]), _vm._v(" "), (item.showzhu == 1) ? _c('span', {
      staticClass: "zhuTeacher"
    }, [_vm._v("老师")]) : _vm._e(), _vm._v(" "), (item.to_fans_id) ? _c('span', {
      staticClass: "teacher_replay_text"
    }, [_vm._v("回复你")]) : _vm._e(), _vm._v(" "), (!(_vm.userConfig && _vm.userConfig.showCommentTime === 0)) ? _c('span', {
      staticStyle: {
        "font-size": "10px",
        "line-height": "20px",
        "margin-left": "5px"
      }
    }, [_vm._v(_vm._s(item.create_time))]) : _vm._e()])])], 2), _vm._v(" "), (item.module == 'text_comment' && item.fans_id == _vm.hostId) ? _c('div', {
      staticClass: "msg_conent"
    }, [_c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }]
    }), _vm._v(" "), (item.pic_url && item.content) ? _c('div', {
      staticStyle: {
        "height": "10px"
      }
    }) : _vm._e(), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticClass: "contImg",
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "xinxin1",
      attrs: {
        "src": _vm.imgPath + 'room/xinxin1_03.png'
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "xinxin2",
      attrs: {
        "src": _vm.imgPath + 'room/xinxin2_03.png'
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "xinxin3",
      attrs: {
        "src": _vm.imgPath + 'room/fff_03.png'
      }
    })]) : (
      item.module == 'text_comment' && item.fans_id != _vm.hostId
    ) ? _c('div', {
      staticClass: "comment-text"
    }, [_c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticStyle: {
        "font-size": "13px",
        "word-break": "break-all",
        "white-space": "pre-line"
      }
    }), _vm._v(" "), (item.pic_url && item.content) ? _c('div', {
      staticStyle: {
        "height": "10px"
      }
    }) : _vm._e(), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticClass: "contImg",
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((item.sublist), function(sublist, index) {
      return _c('div', {
        key: index,
        staticClass: "sublist"
      }, [_c('div', {
        staticClass: "title clearfix"
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v(_vm._s(sublist.nick))]), _vm._v(" "), _c('span', {
        staticClass: "fr time"
      }, [_vm._v(_vm._s(sublist.create_time.substr(5, sublist.create_time.length)))])]), _vm._v(" "), _c('p', {
        directives: [{
          name: "dompurify-html",
          rawName: "v-dompurify-html",
          value: (sublist.content),
          expression: "sublist.content"
        }]
      })])
    }), _vm._v(" "), (item.showcopytext) ? _c('span', {
      staticClass: "copyText",
      on: {
        "click": function($event) {
          return _vm.copyTextTap(item.content)
        }
      }
    }, [_vm._v("复制")]) : _vm._e()], 2) : (item.module == 'notice') ? _c('div', {
      staticClass: "comment-text"
    }, [_c('p', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticStyle: {
        "font-size": "13px",
        "word-break": "break-all"
      }
    })]) : (item.module == 'redpack_comment') ? _c('div', {
      staticClass: "red-pack",
      on: {
        "click": function($event) {
          return _vm.robRedBagAction(item)
        }
      }
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [(item.content) ? _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")]) : _c('p', [_vm._v("恭喜发财，大吉大利")]), _vm._v(" "), _c('p', {
      staticClass: "red-pack-desc"
    }, [_vm._v("拼手气红包，先到先得")])])]), _vm._v(" "), _c('div', {
      staticClass: "red-pack-body"
    }, _vm._l((item.sublist), function(redpack, index) {
      return _c('div', {
        key: index,
        staticClass: "red-pack-item clearfix"
      }, [_c('span', {
        staticClass: "red-pack-item-name fl"
      }, [_vm._v(_vm._s(redpack.nick) + "：")]), _vm._v(" "), _c('span', {
        staticClass: "red-pack-item-money"
      }, [_vm._v("￥" + _vm._s(redpack.total_money / 100))]), _vm._v(" "), _c('span', {
        staticClass: "red-pack-item-time fr"
      }, [_vm._v(_vm._s(redpack.create_time.split(" ")[1]))])])
    }), 0)]) : (item.module == 'reward_redpacket_comment') ? _c('div', {
      staticClass: "red-pack"
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [(item.content) ? _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")]) : _c('p', [_vm._v("恭喜发财，大吉大利")]), _vm._v(" "), (_vm.ds_id != 194) ? _c('p', {
      staticClass: "red-pack-desc ellipsis"
    }, [_vm._v("\n                    向主办方打赏了一个" + _vm._s(item.total_money / 100) + "元的红包\n                  ")]) : _c('p', {
      staticClass: "red-pack-desc ellipsis"
    }, [_vm._v("\n                    向主演打赏了一个" + _vm._s(item.total_money / 100) + "元的红包\n                  ")])])])]) : (item.module == 'share_comment') ? _c('div', {
      staticClass: "red-pack"
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [_c('p', {
      staticClass: "share_red_content ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.nick) + "分享后得到" + _vm._s(item.money / 100) + "元的红包\n                  ")])])])]) : (item.module == 'invite_comment') ? _c('div', {
      staticClass: "red-pack"
    }, [_c('div', {
      staticClass: "red-pack-header"
    }, [_c('img', {
      staticClass: "red-pack-img",
      attrs: {
        "src": _vm.imgPath + 'room/redpack_03.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "red-pack-title"
    }, [_c('p', {
      staticClass: "share_red_content ellipsis"
    }, [_vm._v("\n                    " + _vm._s(item.nick) + "获得" + _vm._s(item.money / 100) + "元的红包\n                  ")])])]), _vm._v(" "), _c('p', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(item.invite_nick))]), _vm._v("通过 "), _c('span', [_vm._v(_vm._s(item.nick))]), _vm._v("分享的直播链接进入\n              ")])]) : (item.module == 'gift_comment') ? _c('div', {
      staticClass: "comment-text"
    }, [_c('p', [_vm._v("\n                赠送了：\n                "), _c('img', {
      staticClass: "gift",
      attrs: {
        "src": item.gift_pic_url
      }
    }), _vm._v("\n                x " + _vm._s(item.gift_num ? item.gift_num : 1) + "\n              ")])]) : (item.module == 'wall_comment') ? _c('div', {
      staticClass: "comment-text wall_comment"
    }, [(item.content) ? _c('p', [_c('span', [_vm._v("重金霸屏" + _vm._s(5 * item.pay_level) + "秒：")]), _vm._v("\n                " + _vm._s(item.content) + "\n              ")]) : _vm._e(), _vm._v(" "), (item.pic_url && item.content) ? _c('div', {
      staticStyle: {
        "height": "10px"
      }
    }) : _vm._e(), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticClass: "contImg",
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e()]) : (item.module == 'coupon_comment') ? _c('div', {
      staticClass: "comment-text quanBox",
      style: ('background-image:url(' + _vm.imgPath + 'room/quan-bg.png)')
    }, [_c('div', {
      staticClass: "quan"
    }, [(item.coupon_type == 'discount') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  折扣券\n                ")]) : (item.coupon_type == 'money') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  代金券\n                ")]) : (item.coupon_type == 'gift') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  礼品券\n                ")]) : (item.coupon_type == 'coupon') ? _c('div', {
      staticClass: "quantype"
    }, [_vm._v("\n                  优惠券\n                ")]) : _c('div', {
      staticClass: "quantype"
    }, [_vm._v("门票券")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(item.coupon_title))])])]), _vm._v(" "), (item.invite_nick) ? _c('p', {
      staticClass: "caption"
    }, [_c('span', [_vm._v(_vm._s(item.invite_nick))]), _vm._v("通过 "), _c('span', [_vm._v(_vm._s(item.nick))]), _vm._v("分享的直播链接进入\n              ")]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "loading"
  }, [_c('van-loading', {
    attrs: {
      "color": "black"
    }
  })], 1), _vm._v(" "), (!_vm.isThreeScreen) ? _c('div', {
    staticStyle: {
      "height": "40px",
      "width": "100%",
      "text-align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.livetimeend && _vm.directStatus != 'running') ? _c('div', {
    staticStyle: {
      "height": "84px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.noticeObj.open && _vm.isNoitceTopShow) ? _c('div', {
    staticStyle: {
      "height": "36px"
    }
  }) : _vm._e()], 2)], 1), _vm._v(" "), _vm._l((_vm.lovestyle[0]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[0]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[1]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[2]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[2]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[3]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[3]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[4]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[4]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[5]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[5]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[6]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[6]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[7]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[7]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[8]
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.lovestyle[8]), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "zan-box",
      style: (n)
    }, [_c('img', {
      staticClass: "zan-img",
      attrs: {
        "src": _vm.zanimg[9]
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUnReadMsg),
      expression: "isShowUnReadMsg"
    }],
    staticClass: "unreadMsg",
    on: {
      "click": function($event) {
        return _vm.unReadMsgAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/unreadMsg.png',
      "width": "8px",
      "height": "8px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0 0 5px"
    }
  }, [_vm._v(_vm._s(_vm.unReadMsgNum) + "条新消息")])]), _vm._v(" "), (_vm.numList.length) ? _c('div', {
    staticClass: "zanBox"
  }, _vm._l((_vm.numList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "num"
    }, [_vm._l((item), function(item1) {
      return [_c('img', {
        key: item1,
        attrs: {
          "src": item1,
          "alt": "index"
        }
      })]
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    model: {
      value: (_vm.showCode),
      callback: function($$v) {
        _vm.showCode = $$v
      },
      expression: "showCode"
    }
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("长按关注公众号")]), _vm._v(" "), _c('img', {
    staticClass: "code stop",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/code/code.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("关注二维码，了解最新直播信息")])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7dcaaff1", content, true);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#embeddedWeb[data-v-298085ff]{width:100%!important;overflow-x:auto}#iframe[data-v-298085ff]{width:100%!important;border:none;height:100%;overflow-x:hidden}", ""]);

// exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			loaded: false,
			resuouce: ""
		};
	},

	props: ['currentMid', 'mid'],
	watch: {
		currentMid: function currentMid() {
			if (!this.loaded && this.currentMid == this.mid) {

				this.loaded = true;
				_toast2.default.loading({
					mask: true,
					message: '加载中...'
				});

				var that = this;
				var option = 'ds_id=' + _Tools2.default.getQueryDsId() + '&mid=' + this.mid;
				this.axios.post(_Tools2.default.baseUrl3() + '/index/picText', option).then(function (data) {
					console.log(data);
					console.log("成功了");
					that.resuouce = data.data.data.content;
				}).catch(function (data) {
					console.log('错误' + data);
				});
			}
		}
	}
}; //
//
//
//
//

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "embeddedWeb"
    }
  }, [(_vm.loaded) ? _c('iframe', {
    attrs: {
      "id": "iframe",
      "src": _vm.resuouce
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(237);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7330bc60", content, true);

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#Store[data-v-933c8e94]{width:100%!important;overflow-x:auto}#iframe[data-v-933c8e94]{width:100%!important;border:none;height:100%;overflow-x:hidden}", ""]);

// exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//

exports.default = {
	data: function data() {
		return {};
	},

	props: ['resuouce']
};

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Store"
    }
  }, [(_vm.resuouce) ? _c('iframe', {
    attrs: {
      "id": "iframe",
      "src": _vm.resuouce
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(241);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0ae9996e", content, true);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".zizhilist{background:#fafafa;margin-top:20px;height:110px}.lianghezi{width:100px;height:30px;margin:0 auto;display:flex;padding-top:10px}.xinxi{width:100px;text-align:center;line-height:30px}.xinxi p{color:#646464;font-size:13px}.zhongxin{width:100px;text-align:center;line-height:30px;border-right:1px solid #000}.zhongxin p{color:#646464}.jishuzhichi{margin-top:10px;text-align:center}.jishuzhichi p{color:#8c8c8c;font-size:12px}.tiaoguanw{text-align:center;margin-top:10px}.tiaoguanw a{color:#8c8c8c;font-size:12px}.ImgIntroduction .nothing{margin-top:100px}#ImgIntroduction{height:100%;overflow-x:auto}.ImgIntroduction{padding:10px}.ImgIntroduction h1,.ImgIntroduction h2,.ImgIntroduction h3,.ImgIntroduction h4,.ImgIntroduction h5,.ImgIntroduction h6{text-align:center;padding-bottom:10px}.ImgIntroduction img{max-width:100%;margin:5px auto;display:block}.loading{height:30px;width:30px;margin:10px auto}#ImgIntroduction .ql-align-right{text-align:right}#ImgIntroduction .ql-size-huge{font-size:2.5em}#ImgIntroduction .ql-align-center{text-align:center}", ""]);

// exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _loading = __webpack_require__(24);

var _loading2 = _interopRequireDefault(_loading);

__webpack_require__(7);

__webpack_require__(93);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_loading2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	data: function data() {
		return {
			content: '',
			loading: true,
			have: true,
			loaded: false,
			imgPath: '',
			xianshilist: ''
		};
	},

	props: ['mid', 'currentMid', 'uid', 'fans_id'],
	created: function created() {
		this.xianshiyingc();
	},
	mounted: function mounted() {
		this.imgPath = _Tools2.default.imgPath();
	},

	watch: {
		currentMid: function currentMid() {
			if (!this.loaded && this.currentMid == this.mid) {
				this.getData();
			}
		}
	},
	methods: {
		xianshiyingc: function xianshiyingc() {
			var that = this;
			this.axios.post(_Tools2.default.baseUrl1() + '/api/store_msg', _qs2.default.stringify({ uid: this.uid })).then(function (data) {
				_toast2.default.clear();
				if (data.data.code == "200") {
					that.xianshilist = data.data.data.is_show;
				}
			});
		},
		tiaozhuangxin: function tiaozhuangxin() {
			this.$router.push({ 'path': '/Companyinformation', query: { uid: this.uid } });
		},
		tiaozhuangzhongxin: function tiaozhuangzhongxin() {
			this.$router.push({ 'path': '/MyPage', query: { uid: this.uid, fans_id: this.fans_id } });
		},
		getData: function getData() {
			var that = this;
			var option = 'ds_id=' + _Tools2.default.getQueryDsId() + '&mid=' + this.mid;
			_toast2.default.loading({
				mask: true,
				message: '加载中...'
			});
			this.axios.post(_Tools2.default.baseUrl3() + '/index/picText', option).then(function (data) {
				console.log(data.data);
				that.loading = false;
				_toast2.default.clear();
				if (data.data.code == "200") {
					if (!data.data.data.content) {
						that.have = false;
						return false;
					} else {
						that.content = data.data.data.content;
					}
					that.loaded = true;
				} else {
					(0, _toast2.default)("获取介绍失败");
				}
			}).catch(function () {
				//Toast("获取介绍失败");
			});
		}
	}
};

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ImgIntroduction"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "353px"
    }
  }, [(_vm.have) ? _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "ImgIntroduction"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.content) + "\n\t\t")]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('van-loading', {
    attrs: {
      "color": "black"
    }
  })], 1)]), _vm._v(" "), (_vm.xianshilist == '2') ? _c('div', {
    staticClass: "zizhilist"
  }, [_c('div', {
    staticClass: "lianghezi"
  }, [_c('div', {
    staticClass: "xinxi",
    on: {
      "click": _vm.tiaozhuangxin
    }
  }, [_c('p', [_vm._v("公司信息")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jishuzhichi"
  }, [_c('p', [_vm._v("腾慧云直播提供技术支持")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiaoguanw"
  }, [_c('a', {
    attrs: {
      "href": "https://www.tenghuiwangxiao.cn/"
    }
  }, [_vm._v("www.tenghuiwangxiao.cn")])])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(245);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("56f3f452", content, true);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#Vote[data-v-335ee9f6]{background:#2c2e35}.Vote[data-v-335ee9f6]{padding:15px;height:100%;overflow:scroll;box-sizing:border-box}.search[data-v-335ee9f6]{margin:0 16px;height:44px;line-height:44px;border-radius:5px;background:#fff;color:#767175;text-align:center;position:relative}.search input[data-v-335ee9f6]{display:block;border:none;background:none;width:100%;text-align:center}.search img[data-v-335ee9f6]{position:absolute;top:14px;left:50%;margin-left:-80px;width:16px}.search .clear[data-v-335ee9f6]{position:absolute;top:13px;right:10px;font-size:18px}.searched h4[data-v-335ee9f6]{height:40px;line-height:40px;text-align:center;color:#fff}.notice[data-v-335ee9f6]{color:#fff;height:30px;line-height:30px;margin-top:20px;font-size:11px}.notice img[data-v-335ee9f6]{vertical-align:middle;width:12px;margin-right:5px}.nums[data-v-335ee9f6]{margin:8px 0;background:#dcb45a;color:#272727;text-align:center;border-radius:5px;padding:20px 0}.nums .players[data-v-335ee9f6]{border-right:1px solid #a38137}.nums .players[data-v-335ee9f6],.nums .tickets[data-v-335ee9f6]{width:49.6%;height:40px}.nums h4[data-v-335ee9f6]{font-size:20px;line-height:25px}.nums p[data-v-335ee9f6]{font-size:11px;line-height:15px}.playerList[data-v-335ee9f6]{margin:10px -7px;min-height:240px}.playerList li[data-v-335ee9f6]{padding:0 7px;margin:7px 0;width:50%;box-sizing:border-box;overflow:hidden;position:relative}.playerList .img[data-v-335ee9f6]{width:100%;overflow:hidden;position:relative;padding-bottom:100%;background:#38393c}.playerList .img img[data-v-335ee9f6]{position:absolute;top:50%;left:0;width:100%;transform:translateY(-50%)}.playerList .title[data-v-335ee9f6]{background:#fff;line-height:36px;overflow:hidden;padding:0 10px 10px;color:#313131}.playerList .title .fr[data-v-335ee9f6]{color:#d4ae5a}.btn[data-v-335ee9f6]{display:block;border-radius:5px;height:30px;line-height:30px;text-align:center;background:linear-gradient(#f2ce7d,#c59934);font-size:15px;color:#fff}.btn.disabled[data-v-335ee9f6]{background:linear-gradient(#ccc,#999)}.playerList .tip[data-v-335ee9f6]{position:absolute;top:0;left:14px;width:28px;height:20px;line-height:20px;background:#aeadb1;color:#fff;text-align:center}.playerList .tip[data-v-335ee9f6]:after{content:\"\";display:block;position:absolute;width:0;height:0;bottom:-10px;left:0;border-left:14px solid #aeadb1;border-right:14px solid #aeadb1;border-bottom:10px solid transparent;border-top:10px solid transparent}.bestBox[data-v-335ee9f6]{padding-top:45px;position:relative}.bestBox .bestImg[data-v-335ee9f6]{position:absolute;width:85px;top:12px;left:50%;margin-left:-42px}.best[data-v-335ee9f6]{border-radius:10px;background:linear-gradient(#f3cf7f,#c49833);padding:3px}.best ul[data-v-335ee9f6]{background:#212226;border-radius:7px}.best li[data-v-335ee9f6]{width:50%;padding:8px 8px 18px;box-sizing:border-box;min-height:240px}.best li .nothing[data-v-335ee9f6]{margin-top:40px}.best .btn[data-v-335ee9f6]{color:#000}.best .user[data-v-335ee9f6]{margin-top:28px;margin-bottom:10px;height:42px;overflow:hidden}.best .img[data-v-335ee9f6]{width:40px;height:40px;border-radius:20px;overflow:hidden;border:1px solid #aa925e;margin-right:10px}.best .img img[data-v-335ee9f6]{width:100%}.best .user h4[data-v-335ee9f6]{font-size:16px;color:#f3cf7f;line-height:26px}.best .user p[data-v-335ee9f6]{font-size:11px;color:#fff}.best .user h3[data-v-335ee9f6]{line-height:40px;font-size:16px;color:#f3cf7f}.best p[data-v-335ee9f6]{line-height:32px;color:#fff}.best p span[data-v-335ee9f6]{color:#f3cf7f}.best p img[data-v-335ee9f6]{height:14px;vertical-align:middle}.best p .head[data-v-335ee9f6]{width:25px;height:25px;margin-right:5px;border-radius:50%;border:1px solid #d6ad50}.Ranking[data-v-335ee9f6]{padding:44px 0 20px;display:flex;align-items:flex-end;color:#fff;min-height:240px}.Ranking li[data-v-335ee9f6]{width:31.5%;padding:0 3px;text-align:center;box-sizing:border-box;line-height:20px}.Ranking li .img[data-v-335ee9f6]{width:100px;height:100px;padding:4px;position:relative;background:#f2ce7f;border-radius:50%;box-sizing:border-box;margin:0 auto 24px}.Ranking li .img .head[data-v-335ee9f6]{width:100%;height:100%;display:block;border-radius:50%}.Ranking .img .index[data-v-335ee9f6]{width:26px;height:26px;position:absolute;bottom:-14px;left:50%;margin-left:-13px}.Ranking li.one[data-v-335ee9f6]{width:37%}.Ranking li.one .img[data-v-335ee9f6]{transform:translateY(-5px);width:120px;height:120px}.Ranking li.one .index[data-v-335ee9f6]{width:33px;height:33px;margin-left:-16.5px}.Ranking li h4[data-v-335ee9f6]{font-size:13px}.Ranking li P[data-v-335ee9f6]{color:#f2ce7f;font-size:15px;line-height:30px}.Ranking li .btn[data-v-335ee9f6]{width:70px;margin:0 auto;border-radius:15px}.list[data-v-335ee9f6]{margin-top:15px}.list li[data-v-335ee9f6]{border:1px solid #eac470;padding:12px;position:relative;background:#36363a;height:118px;margin-bottom:20px;color:#fff;box-sizing:border-box}.list .btn[data-v-335ee9f6]{position:absolute;bottom:10px;right:12px;border-radius:15px;width:100px;height:30px;line-height:30px;font-size:15px}.list .img[data-v-335ee9f6]{width:94px;height:94px;line-height:94px;overflow:hidden;text-align:center;display:block;float:left}.list .img img[data-v-335ee9f6]{width:94px;height:94px}.list .content[data-v-335ee9f6]{padding-left:104px}.list h4[data-v-335ee9f6]{line-height:16px;padding:10px 0;height:52px;box-sizing:border-box}.list h4 p[data-v-335ee9f6]{overflow:hidden}.list h4 span[data-v-335ee9f6]{text-align:right;width:50px;float:right;font-size:12px;color:#d5d5d5}.list .number[data-v-335ee9f6]{line-height:22px}.list .number span[data-v-335ee9f6]{color:#d1b168;margin-left:4px}.rules[data-v-335ee9f6]{margin:10px auto;background:#fff;padding:20px 10px;border-radius:5px;color:#333;line-height:25px;min-height:300px}.voteingBox .title[data-v-335ee9f6]{height:38px;line-height:38px;background:#f0f0f0;color:#323232;text-align:center;font-size:15px}.voteing[data-v-335ee9f6]{padding:20px 30px}.voteing .ticktes[data-v-335ee9f6]{margin:0 -16px;display:flex;flex-wrap:wrap}.voteing li[data-v-335ee9f6]{flex:1;text-align:center;min-width:25%;max-width:25%;margin-bottom:10px}.voteing li .img[data-v-335ee9f6]{width:80%;line-height:76px;margin:0 auto;border:1px solid #e1e1e1;border-radius:3px;overflow:hidden}.voteing li.cur .img[data-v-335ee9f6]{border:1px solid #e5be68}.voteing li .img.cur[data-v-335ee9f6]{border:2px solid #eed49a}.voteing li .img img[data-v-335ee9f6]{max-width:80%;vertical-align:middle}.voteing li h4[data-v-335ee9f6]{font-size:13px;line-height:20px}.voteing li p[data-v-335ee9f6]{font-size:12px;color:#d4ae5a}.count[data-v-335ee9f6]{text-align:center;margin:15px auto;height:27px;width:150px}.count .add[data-v-335ee9f6],.count .cut[data-v-335ee9f6]{height:27px;width:27px;line-height:27px;color:#fff;background:#dcb45a;font-size:30px;display:inline-block;vertical-align:top;border-radius:3px}.count input[data-v-335ee9f6]{display:inline-block;width:65px;height:25px;line-height:25px;border:1px solid #d4d4d4;color:#656565;background:none;padding:0;border-radius:3px;text-align:center;padding:0 3px}.voteing .btn[data-v-335ee9f6]{height:42px;line-height:42px}.count .disabled[data-v-335ee9f6]{background:#d0d0d0}", ""]);

// exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

var _icon = __webpack_require__(23);

var _icon2 = _interopRequireDefault(_icon);

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

var _tab = __webpack_require__(43);

var _tab2 = _interopRequireDefault(_tab);

var _tabs = __webpack_require__(44);

var _tabs2 = _interopRequireDefault(_tabs);

__webpack_require__(7);

__webpack_require__(17);

__webpack_require__(101);

__webpack_require__(21);

__webpack_require__(47);

__webpack_require__(48);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _blueimpMd = __webpack_require__(37);

var _blueimpMd2 = _interopRequireDefault(_blueimpMd);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_tab2.default).use(_tabs2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


_vue2.default.use(_popup2.default);

_vue2.default.use(_icon2.default);

exports.default = {
	data: function data() {
		return {
			fans_id: '',
			initData: '',
			ended: false,
			imgPath: '',
			active: 0,
			show: false,
			giftId: 0,
			giftNum: 1,
			giftPrice: 0,
			giftType: -1,
			baseUrl: 'http://plive.shikee.tv/vote/',
			page: 1,
			page_nums: 8,
			disabled: false,
			end_time: '',
			setting: {},
			gifts: [],
			all_player: [],
			PlayerName: '',
			best_player: {},
			best_fanser: {},
			support_player: [],
			loadedOne: false,
			loaded1: false,
			loaded2: false,
			playerList: [],
			remark: '',
			keyword: '',
			searchList: [],
			page2: 1,
			page_nums2: 8,
			disabled2: false,
			uid: '',
			player_id: ''
		};
	},

	directives: {
		WaterfallLower: (0, _waterfall2.default)('lower'),
		WaterfallUpper: (0, _waterfall2.default)('upper')
	},
	props: ['mid', 'vid', 'currentMid'],
	mounted: function mounted() {
		if (/^(.missmakelive.)/.test(location.hostname)) {
			this.baseUrl = 'http://Plive.shikee.tv/vote/';
		}
		this.imgPath = _Tools2.default.imgPath() + 'vote/';

		var current_app_Id = window.localStorage.getItem("current_app_Id");
		var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
		this.fans_id = fans.fans_id;
	},

	watch: {
		currentMid: function currentMid() {
			if (!this.loaded && this.currentMid == this.mid) {
				this.getData();
			}
		},

		giftNum: function giftNum(val) {
			var that = this;
			if (val < 0) {
				(0, _toast2.default)("礼物数量不能小于0");
				setTimeout(function () {
					that.giftNum = 0;
				}, 1000);
				return;
			}
			if (!/^[0-9]*$/.test(val)) {
				(0, _toast2.default)("请输入正确的数字");
				setTimeout(function () {
					that.giftNum = 0;
				}, 1000);
				return;
			}
		},
		keyword: function keyword(val) {
			if (val) {
				this.search();
			}
		},
		show: function show(curVal, oldVal) {
			this.$emit('switchSider');
		}
	},
	computed: {
		price: function price() {
			return this.giftNum * this.giftPrice / 100;
		}
	},
	methods: {
		getData: function getData() {
			var that = this;
			var option = 'vid=' + this.vid + '&page_nums=' + this.page_nums + '&page=' + this.page;
			if (this.active != 0) {
				return;
			}
			if (this.loadedOne) {
				return;
			}
			this.loadedOne = true;
			_toast2.default.loading({
				mask: true,
				message: '加载中...'
			});
			this.axios.post(this.baseUrl + 'vote/init', option).then(function (data) {
				var data = data.data;
				_toast2.default.clear();
				if (data.code == 200) {
					if (that.page == 1) {
						that.initData = data.data;
						that.end_time = that.initData.vote.end_time;
						that.setting = that.initData.setting;
						that.gifts = that.initData.gift;
						that.uid = that.initData.vote.uid;
						that.remark = that.setting.remark;
						if (new Date(that.end_time).getTime() < new Date().getTime()) {
							that.ended = true;
						}
					}

					that.all_player = that.all_player.concat(data.data.all_player);
					that.page++;
					if (data.data.all_player.length < that.page_nums) {
						that.disabled = true;
					}
				} else {
					console.log("获取介绍失败" + data.message);
				}
				that.loadedOne = false;
			}).catch(function () {
				that.loadedOne = false;
				_toast2.default.clear();
				//Toast("获取介绍失败");
			});
		},
		search: function search() {
			var that = this;
			var option = 'vid=' + this.vid + '&page_nums=100&page=1&keyword=' + this.keyword;
			_toast2.default.loading({
				mask: true,
				message: '搜索中...'
			});
			this.axios.post(this.baseUrl + 'vote/init', option).then(function (data) {
				var data = data.data;
				_toast2.default.clear();
				if (data.code == 200) {
					that.searchList = data.data.all_player;
				} else {
					console.log("获取介绍失败");
				}
			}).catch(function () {
				_toast2.default.clear();
				//Toast("获取介绍失败");
			});
		},
		showPay: function showPay(item) {
			this.show = true;
			this.PlayerName = item.name;
			this.player_id = item.player_id;
		},
		add: function add() {
			this.giftNum++;
		},
		cut: function cut() {
			if (this.giftNum > 1) {
				this.giftNum--;
			}
		},
		checkType: function checkType(index, item) {
			this.giftType = index;
			if (index >= 0) {
				this.giftPrice = item.price;
				this.giftId = item.id;
			} else {
				this.giftPrice = 0;
				this.giftId = 0;
			}
		},
		loadData: function loadData(index, title) {
			this.active = index;
			console.log(this.active);
			if (index == 1 && !this.loaded1) {
				this.getBest();
			}
			if (index == 2 && !this.loaded2) {
				this.getRank();
			}
		},
		getBest: function getBest() {
			var that = this;
			var option = 'vid=' + this.vid;
			_toast2.default.loading({
				mask: true,
				message: '加载中...'
			});
			this.loaded1 = true;
			this.axios.post(this.baseUrl + 'vote/todayBest', option).then(function (data) {
				var data = data.data;
				_toast2.default.clear();
				if (data.code == 200) {
					that.loaded1 = false;
					that.best_player = data.data.best_player;
					that.best_fanser = data.data.best_fanser;
					that.support_player = data.data.support_player;
				}
			}).catch(function (data) {
				_toast2.default.clear();
				console.log(data);
			});
		},
		getRank: function getRank() {
			var that = this;
			var option = 'vid=' + this.vid + '&page_nums=' + this.page_nums2 + '&page=' + this.page2;
			if (this.active != 2) {
				return;
			}

			if (that.loaded2) {
				return;
			}

			_toast2.default.loading({
				mask: true,
				message: '加载中...'
			});

			that.loaded2 = true;
			this.axios.post(this.baseUrl + 'index/playerList', option).then(function (data) {
				var data = data.data;
				_toast2.default.clear();
				if (data.code == 200) {
					that.loaded2 = false;
					that.page2++;
					that.playerList = that.playerList.concat(data.data);
					if (data.data.length < that.page_nums2) {
						that.disabled2 = true;
					}
				} else {}
			}).catch(function (data) {
				_toast2.default.clear();
				console.log(data);
			});
		},
		clearSearch: function clearSearch() {
			this.keyword = '';
		},
		voteing: function voteing() {
			var Base64 = __webpack_require__(34).Base64;
			var that = this;
			var option = '';
			var data = {
				'vid': this.vid,
				'player_id': this.player_id,
				'fans_id': this.fans_id
			};

			console.log(data);

			option += 'key=' + (0, _blueimpMd2.default)(JSON.stringify(data) + "missmakelive@msmk") + "&data=" + Base64.encode(JSON.stringify(data));

			this.axios.post(this.baseUrl + 'index/play', option).then(function (data) {
				var data = data.data;
				if (data.code == 200) {
					(0, _toast2.default)('投票成功');
					setTimeout(function () {
						that.show = false;
						that.reload();
					}, 1500);
				} else {
					(0, _toast2.default)(data.message);
				}
			}).catch(function (data) {
				_toast2.default.clear();
				console.log(data);
			});
		},
		pay: function pay() {
			var that = this;
			var option = 'vid=' + this.vid + '&player_id=' + this.player_id + '&fans_id=' + this.fans_id + '&gift_num=' + this.giftNum + '&uid=' + this.uid + '&gift_id=' + this.giftId;
			if (this.giftNum == 0) {
				(0, _toast2.default)('礼物数不能为0');
				return;
			}
			this.axios.post(this.baseUrl + 'index/rewardGift', option).then(function (data) {
				var data = data.data;
				_toast2.default.clear();
				if (data.code == 200) {
					that.weixinPay(data.data);
				} else {
					(0, _toast2.default)(data.message);
				}
			}).catch(function (data) {
				_toast2.default.clear();
				console.log(data);
			});
		},
		weixinPay: function weixinPay(p) {
			var that = this;
			WeixinJSBridge.invoke('getBrandWCPayRequest', {
				"appId": p.appId, //公众号名称，由商户传入     
				"timeStamp": String(p.timeStamp), //时间戳，自1970年以来的秒数     
				"nonceStr": p.nonceStr, //随机串     
				"package": p.package,
				"signType": p.signType, //微信签名方式：
				"paySign": p.paySign //微信签名 
			}, function (res) {
				// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
				if (res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
					(0, _toast2.default)('赠送礼物成功');
					setTimeout(function () {
						that.show = false;
						that.reload();
					}, 1000);
				}
			});
		},
		reload: function reload() {
			if (this.active == 0) {
				this.page = 1;
				this.all_player = [];
				this.getData();
			} else if (this.active == 2) {
				this.page2 = 1;
				this.playerList = [];
				this.getRank();
			} else {
				this.page = 1;
				this.all_player = [];
				this.getData();

				this.page2 = 1;
				this.playerList = [];
				this.getRank();
			}
			if (this.keyword) {
				this.search();
			}
		}
	}
};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Vote"
    }
  }, [_c('div', {
    staticClass: "Vote"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名或编号",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.keyword),
      expression: "!keyword"
    }],
    attrs: {
      "src": _vm.imgPath + 'search.png'
    }
  }), _vm._v(" "), _c('van-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "clear",
    attrs: {
      "name": "clear"
    },
    on: {
      "click": _vm.clearSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.keyword),
      expression: "!keyword"
    }]
  }, [_c('div', {
    staticClass: "notice"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'notice.png',
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("本次投票有效截止时间至：" + _vm._s(_vm.end_time) + " "), (_vm.ended) ? _c('span', [_vm._v("(已结束)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "nums clearfix"
  }, [_c('div', {
    staticClass: "players fl"
  }, [_c('h4', [_vm._v(_vm._s(_vm.initData.player_num))]), _vm._v(" "), _c('p', [_vm._v("参赛选手")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets fr"
  }, [_c('h4', [_vm._v(_vm._s(_vm.initData.total_vote_num))]), _vm._v(" "), _c('p', [_vm._v("累积投票")])])]), _vm._v(" "), _c('van-tabs', {
    on: {
      "click": _vm.loadData
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部参赛"
    }
  }, [(_vm.all_player.length) ? _c('ul', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getData),
      expression: "getData"
    }],
    staticClass: "playerList clearfix",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "100"
    }
  }, _vm._l((_vm.all_player), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.total) + "票")])]), _vm._v(" "), (!_vm.ended) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.showPay(item)
        }
      }
    }, [_vm._v("投票")]) : _c('div', {
      staticClass: "btn disabled"
    }, [_vm._v("投票")])]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(item.code))])])
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "今日最佳"
    }
  }, [_c('div', {
    staticClass: "bestBox"
  }, [_c('img', {
    staticClass: "bestImg",
    attrs: {
      "src": _vm.imgPath + 'todayBest.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "best"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("最佳选手")]), _vm._v(" "), (_vm.best_player.player_id) ? [_c('div', {
    staticClass: "user clearfix"
  }, [_c('div', {
    staticClass: "img fl"
  }, [_c('img', {
    attrs: {
      "src": _vm.best_player.player_pic_url,
      "alt": _vm.best_player.player_name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('h4', [_vm._v(_vm._s(_vm.best_player.player_name))]), _vm._v(" "), _c('span', [_vm._v("NO." + _vm._s(_vm.best_player.player_code))])])]), _vm._v(" "), _c('p', [_vm._v("今日票数: "), _c('span', [_vm._v("+" + _vm._s(_vm.best_player.today_num))]), _vm._v(" 票"), _c('img', {
    attrs: {
      "src": _vm.imgPath + 'rise.png'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("总票数: "), _c('span', [_vm._v(_vm._s(_vm.best_player.total_num))]), _vm._v(" 票")])] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])], 2), _vm._v(" "), _c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("最佳观众")]), _vm._v(" "), (_vm.best_fanser.fans_id || _vm.best_fanser.nick) ? [_c('div', {
    staticClass: "user clearfix"
  }, [_c('div', {
    staticClass: "img fl"
  }, [_c('img', {
    attrs: {
      "src": _vm.best_fanser.header,
      "alt": _vm.best_fanser.nick
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('h3', [_vm._v(_vm._s(_vm.best_fanser.nick))])])]), _vm._v(" "), _c('p', [_vm._v("赠送礼物: "), _c('span', [_vm._v("+" + _vm._s(_vm.best_fanser.gift_num))]), _vm._v(" 个")]), _vm._v(" "), (_vm.support_player.length) ? _c('p', [_vm._v("支持选手: "), _vm._l((_vm.support_player), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "head",
      attrs: {
        "src": item.player_pic_url
      }
    })
  })], 2) : _vm._e()] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])], 2)])])])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "排名"
    }
  }, [(_vm.playerList.length) ? _c('div', [_c('ul', {
    staticClass: "Ranking clearfix"
  }, [_c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "head",
    attrs: {
      "src": _vm.playerList[1].imageUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "index",
    attrs: {
      "src": _vm.imgPath + 'index2.png'
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.playerList[1].name))]), _vm._v(" "), _c('h4', [_vm._v("NO." + _vm._s(_vm.playerList[1].code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playerList[1].total) + "票")]), _vm._v(" "), (!_vm.ended) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.showPay(_vm.playerList[1])
      }
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn disabled"
  }, [_vm._v("投票")])]), _vm._v(" "), _c('li', {
    staticClass: "one fl"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "head",
    attrs: {
      "src": _vm.playerList[0].imageUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "index",
    attrs: {
      "src": _vm.imgPath + 'index1.png'
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.playerList[0].name))]), _vm._v(" "), _c('h4', [_vm._v("NO." + _vm._s(_vm.playerList[0].code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playerList[0].total) + "票")]), _vm._v(" "), (!_vm.ended) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.showPay(_vm.playerList[0])
      }
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn disabled"
  }, [_vm._v("投票")])]), _vm._v(" "), _c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "head",
    attrs: {
      "src": _vm.playerList[2].imageUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "index",
    attrs: {
      "src": _vm.imgPath + 'index3.png'
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.playerList[2].name))]), _vm._v(" "), _c('h4', [_vm._v("NO." + _vm._s(_vm.playerList[2].code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playerList[2].total) + "票")]), _vm._v(" "), (!_vm.ended) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.showPay(_vm.playerList[2])
      }
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn disabled"
  }, [_vm._v("投票")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getRank),
      expression: "getRank"
    }],
    staticClass: "listBox",
    attrs: {
      "waterfall-disabled": "disabled2",
      "waterfall-offset": "100"
    }
  }, [_c('ul', {
    staticClass: "list",
    attrs: {
      "id": "lists"
    }
  }, _vm._l((_vm.playerList), function(item, index) {
    return (index > 2) ? _c('li', {
      key: index,
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h4', [_c('span', [_vm._v("NO." + _vm._s(item.code))]), _c('p', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('p', [_vm._v("礼物数："), _c('span', [_vm._v(_vm._s(item.pay_vote_num) + " 个")])]), _vm._v(" "), _c('p', [_vm._v("总票数："), _c('span', [_vm._v(_vm._s(item.total) + " 票")])])])]), _vm._v(" "), (!_vm.ended) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.showPay(item)
        }
      }
    }, [_vm._v("投票")]) : _c('div', {
      staticClass: "btn disabled"
    }, [_vm._v("投票")])]) : _vm._e()
  }), 0)])]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "活动规则"
    }
  }, [_c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.remark),
      expression: "remark"
    }],
    staticClass: "rules"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.remark) + "\n\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "searched"
  }, [_c('h4', [_vm._v("搜索结果")]), _vm._v(" "), (_vm.searchList.length) ? _c('ul', {
    staticClass: "playerList clearfix"
  }, _vm._l((_vm.searchList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.total) + "票")])]), _vm._v(" "), (!_vm.ended) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.showPay(item)
        }
      }
    }, [_vm._v("投票")]) : _c('div', {
      staticClass: "btn disabled"
    }, [_vm._v("投票")])]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(item.code))])])
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])])]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "voteingBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("支持" + _vm._s(_vm.PlayerName))]), _vm._v(" "), _c('div', {
    staticClass: "voteing"
  }, [_c('ul', {
    staticClass: "ticktes"
  }, [_c('li', {
    class: {
      cur: (_vm.giftType == -1)
    },
    on: {
      "click": function($event) {
        return _vm.checkType(-1)
      }
    }
  }, [(_vm.setting.free_gift_url) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.setting.free_gift_url
    }
  })]) : _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'ticket.png'
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("免费票")]), _vm._v(" "), _c('p', [_vm._v("(每天限投" + _vm._s(_vm.setting.limit) + "票)")])]), _vm._v(" "), _vm._l((_vm.gifts), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        cur: (_vm.giftType == index)
      },
      on: {
        "click": function($event) {
          return _vm.checkType(index, item)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.gift_pic_url
      }
    })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(item.rate) + "票/" + _vm._s(item.price / 100) + "元)")])])
  })], 2), _vm._v(" "), (_vm.giftType != -1) ? _c('div', {
    staticClass: "count"
  }, [(_vm.giftNum > 1) ? _c('div', {
    staticClass: "cut",
    on: {
      "click": _vm.cut
    }
  }, [_vm._v("-")]) : _c('div', {
    staticClass: "cut disabled"
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giftNum),
      expression: "giftNum"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.giftNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.giftNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("+")])]) : _c('div', {
    staticClass: "count"
  }), _vm._v(" "), (_vm.giftType == -1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.voteing
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("投票(" + _vm._s(_vm.price) + "元)")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(249);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("22425d36", content, true);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#ranking[data-v-c5cf5a4e]{overflow-x:hidden}.lists[data-v-c5cf5a4e]{height:100%;padding-top:64px;margin-top:-64px;box-sizing:border-box}.list[data-v-c5cf5a4e]{height:100%;overflow-y:scroll}.ranking[data-v-c5cf5a4e]{text-align:center;padding:20px 0;font-size:0}.ranking li[data-v-c5cf5a4e]{padding:6.5px 27px;font-size:15px;font-weight:700;color:#333;background:#fff;display:inline-block;box-shadow:0 2px 4px 0 #dadada}.ranking li.active[data-v-c5cf5a4e]{color:#fff;background:#fd9427}.headimg[data-v-c5cf5a4e]{position:relative;height:60px}.image-top[data-v-c5cf5a4e]{position:absolute;width:45px;margin-left:-22px;height:20px;left:50%;top:-10px}.image-bottom[data-v-c5cf5a4e]{position:absolute;width:66px;height:12px;left:50%;top:42px;margin-left:-33px}.leads .nick[data-v-c5cf5a4e]{font-size:16px;color:#333;max-height:42px;overflow:hidden}.leads[data-v-c5cf5a4e]{position:relative;text-align:center;height:152px;margin-bottom:20px;background:#fff;margin-top:40px}.leads li[data-v-c5cf5a4e]{position:absolute;width:33.3%;top:20px;padding:20px 0 10px;background:#fff}.leads li[data-v-c5cf5a4e]:first-child{top:-40px;left:33.3%}.leads li[data-v-c5cf5a4e]:nth-child(2){left:0;top:-20px}.leads li:nth-child(2) .image[data-v-c5cf5a4e]{border-color:#d5d5d5}.leads li[data-v-c5cf5a4e]:nth-child(3){top:0;left:66.6%}.leads li:nth-child(3) .image[data-v-c5cf5a4e]{border-color:#ffae99}.leads li p[data-v-c5cf5a4e]{color:#999}.leads li span[data-v-c5cf5a4e]{color:#ff9503}.leads .image[data-v-c5cf5a4e]{width:50px;height:50px;border:2px solid #fff042;border-radius:50%;box-sizing:border-box;position:absolute;top:0;left:50%;margin-left:-25px}.leftimg[data-v-c5cf5a4e]{top:-20px;left:33.3%;border-right:2px solid #eee;border-left:2px solid transparent;margin-left:-4px}.leftimg[data-v-c5cf5a4e],.rightimg[data-v-c5cf5a4e]{position:absolute;height:0;width:0;border-top:80px solid #eee;border-bottom:80px solid transparent}.rightimg[data-v-c5cf5a4e]{top:0;left:66.6%;border-left:2px solid #eee;border-right:2px solid transparent}.leadlist[data-v-c5cf5a4e]{display:flex;padding:15px 10px;height:40px;line-height:40px}.leadlist[data-v-c5cf5a4e]:nth-child(odd){background:#f7f7f7}.leadlist[data-v-c5cf5a4e]:nth-child(2n){background:#fff}.leadlist .shu[data-v-c5cf5a4e]{width:30px;text-align:center}.leadlist .shu span[data-v-c5cf5a4e]{display:inline-block;border-radius:50%;width:20px;height:20px;line-height:20px;background:#c7c7c7;font-size:12px;color:#fff;margin-top:10px}.leadlist .shu span.self[data-v-c5cf5a4e]{background:#ff9503}.leadlist .image[data-v-c5cf5a4e]{flex:3;text-align:center}.leadlist .image img[data-v-c5cf5a4e]{width:40px;height:40px;border-radius:20px}.leadlist .nick[data-v-c5cf5a4e]{flex:7}.leadlist p[data-v-c5cf5a4e]{flex:5;text-align:right;padding-right:10px}.leadlist p span[data-v-c5cf5a4e]{color:#ff9503}", ""]);

// exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _list = __webpack_require__(92);

var _list2 = _interopRequireDefault(_list);

var _pullRefresh = __webpack_require__(103);

var _pullRefresh2 = _interopRequireDefault(_pullRefresh);

__webpack_require__(7);

__webpack_require__(94);

__webpack_require__(104);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_pullRefresh2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_list2.default);

exports.default = {
	data: function data() {
		return {
			showInvit: false,
			showReward: false,
			showSale: false,
			ds_id: '',
			listIndex: -1,
			leads: [], //邀请榜
			leadsRe: [], //贡献榜
			leadsSa: [], //分销榜
			schoolData: [], //学校榜
			classData: [], //班级榜
			isLoading: false,
			isRewardLoading: false,
			isSaleLoading: false,
			isSchoolLoading: false,
			isClassLoading: false,
			loaded: false,
			imgPath: '',
			Invitloading: false,
			Invitfinished: false,
			InvitCurrPage: 1
		};
	},

	props: ['toplist', 'currentMid', 'mid', 'fans_id'],
	mounted: function mounted() {
		this.ds_id = _Tools2.default.getQueryDsId();
		this.imgPath = _Tools2.default.imgPath();
	},

	watch: {
		isLoading: function isLoading() {
			if (this.isLoading) {
				this.InvitCurrPage = 1;
				this.loadInvitation();
			}
		},
		isRewardLoading: function isRewardLoading() {
			if (this.isRewardLoading) {
				this.loadReward();
			}
		},
		isSchoolLoading: function isSchoolLoading() {
			if (this.isSchoolLoading) {
				// this.loadSchool();
			}
		},
		isClassLoading: function isClassLoading() {
			if (this.isClassLoading) {
				// this.loadSchool();
			}
		},
		currentMid: function currentMid() {
			var that = this;
			if (!this.loaded && this.currentMid == this.mid) {
				_toast2.default.loading({
					mask: true,
					message: '加载中...'
				});
				console.log(that.toplist);
				if (that.toplist != null) {
					for (var i = 0; i < that.toplist.length; i++) {
						if (that.toplist[i] == 'invite_top') {
							that.showInvit = true;
							this.listIndex = 0;
							that.loadInvitation();
						} else if (that.toplist[i] == 'reward_top') {
							that.showReward = true;
							if (this.listIndex != 0) {
								this.listIndex = 1;
							}
							that.loadReward();
						} else if (that.toplist[i] == 'sale_top') {
							that.showSale = true;
							if (this.listIndex != 1 && this.listIndex != 0) {
								this.listIndex = 2;
							}
							that.loadSale();
						} else {
							console.log('');
						}
					}
				}

				// if(this.listIndex == -1){
				//                   this.listIndex = 3;
				// }
				//curretn
				// that.loadSchool();
			}
			//current
		}
	},
	methods: {
		change: function change(num) {
			this.listIndex = num;
		},
		loadInvitation: function loadInvitation() {
			//获取邀请帮数据
			var that = this;
			var url = _Tools2.default.baseUrl1() + '/wap/index/invite';
			var option = 'ds_id=' + this.ds_id + '&page_nums=20' + '&page=' + this.InvitCurrPage;
			this.axios.post(url, option).then(function (res) {
				var data = res.data;
				_toast2.default.clear();
				if (data.code == "200") {
					that.isLoading = false;
					if (that.InvitCurrPage > 1) {
						that.leads = that.leads.concat(data.data);
					} else {
						that.leads = data.data;
					}

					that.loaded = true;
					console.log(data.data);
					that.InvitCurrPage++;
					that.Invitloading = false;
					if (data.data.length == 0) {
						that.Invitfinished = true;
					}
				} else {
					console.log(data.message);
				}
			}).catch(function (res) {
				console.log(res);
			});
		},
		loadReward: function loadReward() {
			//获取邀请帮数据
			var that = this;
			var url = _Tools2.default.baseUrl1() + '/wap/index/reward';
			var option = 'ds_id=' + this.ds_id + '&page_nums=1000';
			this.axios.post(url, option).then(function (res) {
				var data = res.data;
				_toast2.default.clear();
				if (data.code == "200") {
					that.isRewardLoading = false;
					that.leadsRe = data.data;
					that.loaded = true;
				} else {
					console.log(data.message);
				}
			}).catch(function (res) {
				console.log(res);
			});
		},
		loadSale: function loadSale() {
			//获取邀请帮数据
			var that = this;
			var url = _Tools2.default.baseUrl1() + '/shop/top/lists';
			var option = 'ds_id=' + this.ds_id + '&fans_id=' + this.fans_id;
			this.axios.post(url, option).then(function (res) {
				var data = res.data;
				_toast2.default.clear();
				if (data.code == "200") {
					that.isSaleLoading = false;
					that.leadsSa = data.data;
					that.loaded = true;
				} else {
					console.log(data.message);
				}
			}).catch(function (res) {
				console.log(res);
			});
		},
		loadSchool: function loadSchool() {
			var that = this;
			var url = _Tools2.default.baseUrl3() + '/infoCollection/rankList';
			var option = 'ds_id=' + this.ds_id + '&fans_id=' + this.fans_id;
			this.axios.post(url, option).then(function (res) {
				var data = res.data;
				_toast2.default.clear();
				if (data.code == "200") {
					that.isSchoolLoading = false;
					that.isClassLoading = false;
					that.schoolData = data.data.schoolList;
					that.classData = data.data.classList;
					that.loaded = true;
				} else {
					console.log(data.message);
				}
			}).catch(function (res) {
				console.log(res);
			});
		},
		onInvitLoad: function onInvitLoad() {
			console.log("onInvitLoad");
		}
	}
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(252);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-pull-refresh{-webkit-user-select:none;user-select:none;overflow:hidden}.van-pull-refresh__track{position:relative}.van-pull-refresh__head{width:100%;height:50px;left:0;overflow:hidden;position:absolute;text-align:center;top:-50px;font-size:14px;color:#969799;line-height:50px}.van-pull-refresh__loading .van-loading{width:16px;height:16px;margin-right:5px}.van-pull-refresh__loading .van-loading,.van-pull-refresh__loading span{vertical-align:middle;display:inline-block}", ""]);

// exports


/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ranking"
    }
  }, [_c('ul', {
    staticClass: "ranking"
  }, [(_vm.showInvit) ? _c('li', {
    class: {
      active: (_vm.listIndex == 0)
    },
    on: {
      "click": function($event) {
        return _vm.change(0)
      }
    }
  }, [_vm._v("邀请榜")]) : _vm._e(), _vm._v(" "), (_vm.showReward) ? _c('li', {
    class: {
      active: (_vm.listIndex == 1)
    },
    on: {
      "click": function($event) {
        return _vm.change(1)
      }
    }
  }, [_vm._v("打赏榜")]) : _vm._e(), _vm._v(" "), (_vm.showSale) ? _c('li', {
    class: {
      active: (_vm.listIndex == 2)
    },
    on: {
      "click": function($event) {
        return _vm.change(2)
      }
    }
  }, [_vm._v("分销榜")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lists"
  }, [(_vm.showInvit) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 0),
      expression: "listIndex == 0"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [(_vm.leads.length) ? [_c('van-list', {
    attrs: {
      "finished": _vm.Invitfinished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.loadInvitation
    },
    model: {
      value: (_vm.Invitloading),
      callback: function($$v) {
        _vm.Invitloading = $$v
      },
      expression: "Invitloading"
    }
  }, [_c('ul', {
    staticClass: "leads"
  }, [_vm._l((_vm.leads), function(item, index) {
    return (index < 3) ? _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "headimg"
    }, [(index == 0) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no1_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no2_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no3_top.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (index == 0) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no1_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no2_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no3_bottom.png'
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', [_vm._v("邀请"), _c('span', [_vm._v(" " + _vm._s(item.total) + " ")]), _vm._v("位好友")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "leftimg"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightimg"
  })], 2), _vm._v(" "), _vm._l((_vm.leads), function(item, index) {
    return (index > 2) ? _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [(item.fans_id == _vm.fans_id) ? _c('span', {
      staticClass: "self"
    }, [_vm._v(_vm._s(index + 1))]) : _c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.header,
        "alt": item.nick
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("邀请"), _c('span', [_vm._v(" " + _vm._s(item.total) + " ")]), _vm._v("位好友")])]) : _vm._e()
  })], 2)] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showReward) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 1),
      expression: "listIndex == 1"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isRewardLoading),
      callback: function($$v) {
        _vm.isRewardLoading = $$v
      },
      expression: "isRewardLoading"
    }
  }, [(_vm.leadsRe.length) ? [_c('ul', {
    staticClass: "leads"
  }, [_vm._l((_vm.leadsRe), function(item, index) {
    return (index < 3) ? _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "headimg"
    }, [(index == 0) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no1_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no2_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no3_top.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (index == 0) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no1_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no2_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no3_bottom.png'
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', [_vm._v("打赏"), _c('span', [_vm._v(" " + _vm._s(item.top_money / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "leftimg"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightimg"
  })], 2), _vm._v(" "), _vm._l((_vm.leadsRe), function(item, index) {
    return (index > 2) ? _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.header,
        "alt": item.nick
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("打赏"), _c('span', [_vm._v(" " + _vm._s(item.top_money / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  })] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showSale) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 2),
      expression: "listIndex == 2"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isSaleLoading),
      callback: function($$v) {
        _vm.isSaleLoading = $$v
      },
      expression: "isSaleLoading"
    }
  }, [(_vm.leadsSa.length) ? [_c('ul', {
    staticClass: "leads"
  }, [_vm._l((_vm.leadsSa), function(item, index) {
    return (index < 3) ? _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "headimg"
    }, [(index == 0) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no1_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no2_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no3_top.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (index == 0) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no1_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no2_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no3_bottom.png'
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', [_vm._v("累计获利"), _c('span', [_vm._v(" " + _vm._s(item.total / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "leftimg"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightimg"
  })], 2), _vm._v(" "), _vm._l((_vm.leadsSa), function(item, index) {
    return (index > 2) ? _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.header,
        "alt": item.nick
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("累计获利"), _c('span', [_vm._v(" " + _vm._s(item.total / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  })] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 3),
      expression: "listIndex == 3"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isSchoolLoading),
      callback: function($$v) {
        _vm.isSchoolLoading = $$v
      },
      expression: "isSchoolLoading"
    }
  }, [(_vm.schoolData.length) ? _vm._l((_vm.schoolData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [(index == 0) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/one1.png"
      }
    }) : (index == 1) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/two1.png"
      }
    }) : (index == 2) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/three1.png"
      }
    }) : (index > 2 && index < 5) ? _c('span', {
      staticStyle: {
        "background": "#ff9503"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_vm._v(_vm._s(item.school))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("进来"), _c('span', [_vm._v(" " + _vm._s(item.count) + " ")]), _vm._v("位学生")])])
  }) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 4),
      expression: "listIndex == 4"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isClassLoading),
      callback: function($$v) {
        _vm.isClassLoading = $$v
      },
      expression: "isClassLoading"
    }
  }, [(_vm.classData.length) ? _vm._l((_vm.classData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [(index == 0) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/one1.png"
      }
    }) : (index == 1) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/two1.png"
      }
    }) : (index == 2) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/three1.png"
      }
    }) : (index > 2 && index < 10) ? _c('span', {
      staticStyle: {
        "background": "#ff9503"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_vm._v(_vm._s(item.school + item.grade + item.class))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("进来"), _c('span', [_vm._v(" " + _vm._s(item.count) + " ")]), _vm._v("位学生")])])
  }) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(255);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("147d84e8", content, true);

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#shake[data-v-da03d81e]{height:100%;background:#f93d3e}.shakebox[data-v-da03d81e]{height:100%;overflow:scroll}.center[data-v-da03d81e]{text-align:center}img[data-v-da03d81e]{width:100%}.prize[data-v-da03d81e]{height:100%;width:100%;overflow:hidden;position:relative}.prizes[data-v-da03d81e]{position:absolute;height:65px;text-align:center;line-height:16px;width:65px;border-radius:50%;background:rgba(0,0,0,.3);top:10px;right:20px;animation:swing 2s ease-in-out infinite;font-size:12px;color:#fff}.prizes img[data-v-da03d81e]{width:70%;margin-top:5px}@keyframes swing{0%{transform:rotate(10deg)}50%{transform:rotate(-10deg)}to{transform:rotate(10deg)}}.radiation[data-v-da03d81e]{position:absolute;top:20px;left:50%;width:120%;margin-left:-60%;animation:circle 8s linear infinite}.radiation img[data-v-da03d81e]{width:100%}@keyframes circle{0%{transform:rotate(0deg)}50%{transform:rotate(180deg)}to{transform:rotate(1turn)}}.main[data-v-da03d81e]{background-repeat:no-repeat;background-position:bottom;-webkit-background-size:100%;background-size:100%;height:100%;position:absolute;bottom:0;left:0;width:100%}.main .shacks[data-v-da03d81e]{width:80%;text-align:center;margin:30px auto 20px}.main h4[data-v-da03d81e]{font-size:18px;color:#fff;font-weight:700;line-height:40px}.main p[data-v-da03d81e]{background:#fda513;width:200px;height:30px;line-height:30px;overflow:hidden;border-radius:15px;margin:0 auto;color:#fff}.timebox[data-v-da03d81e]{position:relative;height:0;width:100%;z-index:100}.time[data-v-da03d81e]{width:80%;position:absolute;bottom:13px;left:50%;margin-left:-40%;background:#fff;border-radius:3px;padding:20px 5px;text-align:center;line-height:20px;box-sizing:border-box}.time span[data-v-da03d81e]{display:inline-block;background:#f93d3e;color:#fff;padding:0 3px;border-radius:2px;margin:0 2px}.introduce[data-v-da03d81e]{width:100%;overflow:hidden;background-repeat:no-repeat;background-position:bottom;-webkit-background-size:100%;background-size:100%;line-height:26px;color:#9c9c9c;position:relative;padding-bottom:80px}.introduce .rules_box[data-v-da03d81e]{width:90%;border:4px dotted #f3f91f;border-radius:3px;margin:24px auto 0;box-sizing:border-box;padding:15px;background:#eb6861}.introduce .title[data-v-da03d81e]{background-repeat:no-repeat;background-position:50%;-webkit-background-size:100% auto;background-size:100% auto;line-height:36px;text-align:center;color:#f3f91f;font-size:16px;font-weight:700}.introduce p[data-v-da03d81e]{color:#fff}.copyright[data-v-da03d81e]{position:absolute;width:100%;bottom:0;text-align:center;color:#f93d3e}.prizeImg[data-v-da03d81e]{max-width:80%;margin:10px 0}.poup[data-v-da03d81e]{background:#fff;border-radius:10px;margin:-10px;overflow:hidden}.poup .title[data-v-da03d81e]{height:52px;line-height:52px;background:#ff601a;color:#fff;font-size:17px;position:relative}.poup .title span[data-v-da03d81e]{height:20px;width:20px;position:absolute;transform:rotate(45deg);top:16px;right:20px}.poup .title span[data-v-da03d81e]:after{content:\"\";height:2px;width:20px;background:#fff;position:absolute;left:0;top:9px}.poup .title span[data-v-da03d81e]:before{content:\"\";height:20px;width:2px;background:#fff;position:absolute;top:0;left:9px}.poup p[data-v-da03d81e]{margin-bottom:36px;font-size:17px}", ""]);

// exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

__webpack_require__(7);

__webpack_require__(21);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _prizes = __webpack_require__(54);

var _prizes2 = _interopRequireDefault(_prizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_popup2.default);
//保存数据

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    prizes: _prizes2.default
  },
  data: function data() {
    return {
      fans_id: '',
      aid: '1',
      dsId: '',
      days: '00',
      hours: '00',
      minites: '00',
      seconds: '00',
      end: false,
      show: false,
      show2: false,
      prizeImg: '',
      openType: false,
      start_time: '',
      end_time: '',
      shakeType: false,
      remark: '',
      prize_remark: '',
      activeState: -1,
      prizelist: [],
      chances: 1,
      page: 1,
      page_num: 1,
      shake_type: 'fixed',
      remain: 0,
      hours2: '00',
      minites2: '00',
      seconds2: '00',
      allow: false,
      isWeixin: true,
      loaded: false,
      imgPath: ''
    };
  },

  props: ['dispark', 'initData', 'currentMid', 'mid'],
  watch: {
    currentMid: function currentMid() {
      if (!this.loaded && this.currentMid == this.mid) {
        _toast2.default.loading({
          mask: true,
          message: '加载中...'
        });
        this.shake();
        this.getData();
      }
    },
    dispark: function dispark() {
      this.openType = this.open;
    }
  },
  mounted: function mounted() {
    this.imgPath = _Tools2.default.imgPath();
    var current_app_Id = window.localStorage.getItem("current_app_Id");
    var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.fans_id = fans.fans_id;
    this.isWeixin = _Tools2.default.isWeixin();
    this.dsId = _Tools2.default.getQueryDsId();
  },

  methods: {
    getData: function getData() {
      var that = this;
      var option = 'fans_id=' + this.fans_id + '&ds_id=' + this.dsId;
      this.axios.post(_Tools2.default.baseUrl() + '/activity/shake/index', option).then(function (data) {
        _toast2.default.clear();
        if (data.data.code == "200") {
          that.start_time = data.data.data.start_time;
          that.end_time = data.data.data.end_time;
          that.remark = data.data.data.remark;
          that.remark = that.remark.replace(/\n/g, '<br/>');
          that.aid = data.data.data.aid;
          that.prize_remark = data.data.data.prize_remark;
          that.shake_type = data.data.data.shake_type;
          that.remain = data.data.data.remain;
          that.timeSwitch();
          that.loaded = true;
          //console.log('正确111');
        } else {
            //console.log('错误222');
          }
      }).catch(function () {
        //console.log('错误333');
      });
    },
    prize: function prize() {
      //console.log('shake_type='+this.shake_type+'--openType='+this.openType+'---activeState='+this.activeState+'&remain='+this.remain+'---allow='+this.allow);
      if (!this.isWeixin) {
        (0, _toast2.default)("请微信登陆后重试");
        return;
      }
      if (this.openType == false || this.activeState != 0) {
        return false;
      }
      if (this.shake_type != 'fixed') {
        if (!this.allow) {
          return false;
        }
      } else {
        if (this.remain <= 0) {
          (0, _toast2.default)('您的摇奖次数已达上限');
          return false;
        }
      }
      this.shakeType = true;
      var that = this;
      var option = 'aid=' + this.aid + '&fans_id=' + this.fans_id + '&ds_id=' + this.dsId;
      //console.log(option);
      this.axios.post(_Tools2.default.baseUrl() + '/activity/shake/win', option).then(function (data) {
        that.getData();
        setTimeout(function () {
          that.shakeType = false;
        }, 2000);
        that.show2 = true;
        if (data.data.code == "200") {
          that.prizeImg = data.data.data.prize.pic_url;
        }
      }).catch(function () {
        setTimeout(function () {
          that.shakeType = false;
        }, 2000);
        (0, _toast2.default)('请求错误');
      });
    },
    shake: function shake() {
      var that = this;
      var SHAKE_THRESHOLD = 1800;
      var last_update = 0;
      var x = 0,
          y = 0,
          z = 0,
          last_x = 0,
          last_y = 0,
          last_z = 0;
      // 苹果端微信现在只支持https链接的事件触发HTTP不支持出发事件
      if (window.DeviceMotionEvent) {
        //console.log('设备支持摇一摇');
        window.addEventListener('devicemotion', deviceMotionHandler, false);
      } else {
        //console.log('QAQ本设备不支持摇一摇事件');
      }

      function deviceMotionHandler(eventData) {
        var acceleration = eventData.accelerationIncludingGravity;
        var curTime = new Date().getTime();
        if (curTime - last_update > 100) {
          var diffTime = curTime - last_update;
          last_update = curTime;
          x = acceleration.x;
          y = acceleration.y;
          z = acceleration.z;
          var speed = Math.abs(x + y + z - last_x - last_y - last_z) / diffTime * 10000;

          if (speed > SHAKE_THRESHOLD) {
            if (!that.shakeType) {
              that.prize();
            }
          }
          last_x = x;
          last_y = y;
          last_z = z;
        }
      }
    },
    timeSwitch: function timeSwitch() {
      var now = new Date().getTime();
      var start = new Date(this.start_time.replace(/-/g, "/")).getTime();
      var end = new Date(this.end_time.replace(/-/g, "/")).getTime();
      //console.log(now+'--'+start+'--'+end)
      if (now < start) {
        this.activeState = -1;
        this.countDown(parseInt((start - now) / 1000));
        //console.log('未开始');
      } else if (now > end) {
        this.activeState = 1;
        //console.log('已结束');
      } else {
        this.activeState = 0;
        this.countDown(parseInt((end - now) / 1000));
        if (this.shake_type == 'freq') {
          if (this.remain == 0) {
            this.allow = true;
          } else {
            this.countDown2(this.remain);
          }
        }
        //console.log('正在进行');
      }
    },
    countDown: function countDown(times) {
      clearInterval(timer);
      var that = this;
      var timer = setInterval(function () {
        if (times != 0) {
          times--;
          that.days = that.two(Math.floor(times / 24 / 3600));
          that.hours = that.two(Math.floor(times % (24 * 3600) / 3600));
          that.minites = that.two(Math.floor(times % 3600 / 60));
          that.seconds = that.two(Math.floor(times % 60));
        } else {
          clearInterval(timer);
          that.timeSwitch();
        }
      }, 1000);
    },
    two: function two(num) {
      if (num < 10) {
        return '0' + num;
      }
      return num;
    },
    countDown2: function countDown2(time) {
      clearInterval(timer);
      var that = this;
      var times = time;
      var timer = setInterval(function () {
        if (times != 0) {
          times--;
          that.hours2 = that.two(Math.floor(times % (24 * 3600) / 3600));
          that.minites2 = that.two(Math.floor(times % 3600 / 60));
          that.seconds2 = that.two(Math.floor(times % 60));
        } else {
          clearInterval(timer);
          that.allow = true;
        }
      }, 1000);
    },
    showPrizs: function showPrizs() {
      var that = this;
      this.show = true;
      var option = 'aid=' + this.aid + '&fans_id=' + this.fans_id + '&type=1' + '&page=' + this.page;
      this.axios.post(_Tools2.default.baseUrl() + '/activity/shake/lists', option).then(function (data) {
        if (data.data.code == "200") {
          if (data.data.data) {
            that.prizelist = data.data.data.list;
          }
        }
      }).catch(function (data) {
        console.log('错误' + data);
      });
    },
    cutdown: function cutdown() {
      this.show2 = false;
      this.prizeImg = '';
    },
    closeList: function closeList() {
      this.show = false;
    }
  }
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(258);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("57d58ca7", content, true);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".center[data-v-16c6edc6]{text-align:center}img[data-v-16c6edc6]{max-width:100%}#prizes[data-v-16c6edc6]{height:100%;background-color:#fa3d3e;background-repeat:no-repeat;background-size:100% 100%;background-position:50%;padding-top:30px;box-sizing:border-box;margin:-10px}.logo[data-v-16c6edc6]{margin:0 auto;margin-top:1rem;display:block;position:relative;top:3px;width:88%}.prize-win-panel[data-v-16c6edc6]{background-color:#fcefc8;margin:0 auto;width:88%;display:flex;flex-direction:column;align-items:center;position:relative;padding-bottom:30px}.prize-win-list[data-v-16c6edc6]{width:100%;text-align:center}.prize-win-list tr[data-v-16c6edc6]{line-height:30px}.prize-win-list thead th[data-v-16c6edc6]{color:#fc453a;font-size:16px}.prize-win-list tbody th[data-v-16c6edc6]{font-weight:400}.prize-win-list tbody th img[data-v-16c6edc6]{max-width:40px}.main-top[data-v-16c6edc6]{position:absolute;bottom:0;max-width:none;width:113%;left:-6.5%}h3[data-v-16c6edc6]{text-align:center;padding-top:40px;margin-bottom:10px}.way[data-v-16c6edc6]{width:94%;background-color:#fc453a;box-shadow:0 0 33px 3px rgba(0,0,0,.2);margin:0 auto;text-align:center;color:#fcefc7}.way img[data-v-16c6edc6]{width:80%;margin-bottom:10px}.way p[data-v-16c6edc6]{padding:0 10px 10px}.tbbox[data-v-16c6edc6]{max-height:200px;overflow-x:hidden;overflow-y:scroll;width:100%}", ""]);

// exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            imgPath: ''
        };
    },

    props: ['prizelist', 'prizeRemark'],
    mounted: function mounted() {
        this.imgPath = _Tools2.default.imgPath();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/bg3.png)'),
    attrs: {
      "id": "prizes"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.imgPath + 'luckdraw/person.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prize-win-panel"
  }, [_c('div', {
    staticClass: "tbbox"
  }, [(_vm.prizelist) ? _c('table', {
    staticClass: "prize-win-list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.prizelist), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.exchange_code))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.create_time.split(' ')[1]))])])
  }), 0)]) : _c('p', {
    staticClass: "center"
  }, [_c('br'), _vm._v("暂无中奖信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "main-top",
    attrs: {
      "src": _vm.imgPath + 'luckdraw/main-top.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "way"
  }, [_c('h3', [_vm._v("兑奖方式")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/manner_border.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.prizeRemark))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("奖品")]), _vm._v(" "), _c('th', [_vm._v("兑奖码")]), _vm._v(" "), _c('th', [_vm._v("时间")])])])
}]}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "shake"
    }
  }, [_c('div', {
    staticClass: "shakebox"
  }, [_c('div', {
    staticClass: "prize"
  }, [_c('div', {
    staticClass: "radiation"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/light.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/bg5.png)')
  }, [_c('div', {
    staticClass: "shacks"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/title-top.png'
    }
  })]), _vm._v(" "), (_vm.activeState != 1) ? [(_vm.shake_type == 'fixed') ? _c('p', {
    staticClass: "center",
    on: {
      "click": function($event) {
        return _vm.prize()
      }
    }
  }, [(_vm.remain != 0) ? _c('span', [_vm._v("您还有" + _vm._s(_vm.remain) + "次机会")]) : _c('span', [_vm._v("您的摇奖次数已达上限")])]) : _c('p', {
    staticClass: "center",
    on: {
      "click": function($event) {
        return _vm.prize()
      }
    }
  }, [(_vm.allow) ? _c('span', [_vm._v("\n              摇一摇开始抽奖\n              ")]) : _c('span', [_vm._v("\n              下一次抽奖："), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.hours2) + ":" + _vm._s(_vm.minites2) + ":" + _vm._s(_vm.seconds2))])])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "prizes",
    on: {
      "click": function($event) {
        return _vm.showPrizs()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/prizes.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的奖品")])])]), _vm._v(" "), _c('div', {
    staticClass: "timebox"
  }, [(_vm.activeState == -1) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n          活动开始倒计时："), _c('span', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v("天"), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v("时"), _c('span', {
    staticClass: "minute"
  }, [_vm._v(_vm._s(_vm.minites))]), _vm._v("分"), _c('span', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v("秒\n        ")]) : _vm._e(), _vm._v(" "), (_vm.activeState == 0) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n          活动结束倒计时："), _c('span', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v("天"), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v("时"), _c('span', {
    staticClass: "minute"
  }, [_vm._v(_vm._s(_vm.minites))]), _vm._v("分"), _c('span', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v("秒\n        ")]) : _vm._e(), _vm._v(" "), (_vm.activeState == 1) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n          ~~~~~~~活动已结束~~~~~~~\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "introduce",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/bg4.png)')
  }, [_c('div', {
    staticClass: "rules rules_box"
  }, [_c('div', {
    staticClass: "title",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/title-bg.png)')
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.remark),
      expression: "remark"
    }]
  }, [_vm._v("\n          " + _vm._s(_vm.remark) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("- 由美时美客提供技术支持 -")])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('prizes', {
    attrs: {
      "prizelist": _vm.prizelist,
      "prizeRemark": _vm.prize_remark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.closeList
    }
  })])], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  }, [_c('div', {
    staticClass: "poup center"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    on: {
      "click": _vm.cutdown
    }
  }), _vm._v("中奖信息")]), _vm._v(" "), (_vm.prizeImg) ? _c('img', {
    staticClass: "prizeImg",
    attrs: {
      "src": _vm.prizeImg
    }
  }) : _c('img', {
    staticClass: "prizeImg",
    attrs: {
      "src": _vm.imgPath + 'nothing.jpg'
    }
  }), _vm._v(" "), (_vm.prizeImg) ? _c('p', [_vm._v("恭喜您，中奖了！！！")]) : _c('p', [_vm._v("此处空空如也，请再接再厉……")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(263);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("29424ef0", content, true);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#videoreview[data-v-8b5a4e30]{overflow:scroll}.lists[data-v-8b5a4e30]{height:100%}.list[data-v-8b5a4e30]{width:50%;padding:5px;box-sizing:border-box;overflow:hidden;display:inline-block;vertical-align:top}.img[data-v-8b5a4e30]{width:100%;padding-bottom:56.25%;position:relative;overflow:hidden}.list img[data-v-8b5a4e30]{width:100%;position:absolute;top:50%;left:0;transform:translateY(-50%);height:100%}.title[data-v-8b5a4e30]{height:40px;overflow:hidden;margin:5px 0;line-height:20px}", ""]);

// exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

__webpack_require__(7);

__webpack_require__(17);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	directives: {
		WaterfallLower: (0, _waterfall2.default)('lower'),
		WaterfallUpper: (0, _waterfall2.default)('upper')
	},
	props: ['mid', 'currentMid'],
	data: function data() {
		return {
			reViewData: [],
			loaded: false,
			disabled: false,
			page_nums: 10,
			page: 1
		};
	},

	watch: {
		currentMid: function currentMid() {
			if (!this.loaded && this.currentMid == this.mid) {
				this.onRefresh();
			}
		}
	},
	methods: {
		loadMore: function loadMore() {
			this.onRefresh();
		},
		onRefresh: function onRefresh() {

			if (this.disabled) {
				return;
			}
			this.disabled = true;
			var that = this;
			_toast2.default.loading({
				mask: true,
				message: '加载中...'
			});
			var params = 'mid=' + this.mid + '&page=' + this.page + "&page_nums=" + this.page_nums;
			this.axios.post(_Tools2.default.baseUrl() + "/init/index/pastDs", params).then(function (data) {
				_toast2.default.clear();
				if (data.data.code == "200") {
					if (data.data.data.list.length > 0) {
						that.reViewData = that.reViewData.concat(data.data.data.list);
						that.page++;
						that.disabled = false;
					}

					that.loaded = true;
				}
			}).catch(function (res) {
				(0, _toast2.default)(res.data.message);
			});
		},
		onPlay: function onPlay(id) {
			_data2.default.setInitData('');
			location.href = "http://ph.shikee.tv/?ds_id=" + id + "#/home/";
			//location.href = "http://192.168.0.110:8081/?ds_id="+id+"#/home/"
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "videoreview"
    }
  }, [_c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "lists",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "500"
    }
  }, _vm._l((_vm.reViewData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list",
      on: {
        "click": function($event) {
          return _vm.onPlay(item.ds_id)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "stop",
      attrs: {
        "src": item.coverpic
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.start_time))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(267);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("21573ae2", content, true);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".lists[data-v-8d479d24]{height:100%;overflow:scroll}.list[data-v-8d479d24]{width:50%;padding:5px;box-sizing:border-box;overflow:hidden;display:inline-block;vertical-align:top}.img[data-v-8d479d24]{width:100%;padding-bottom:56.25%;position:relative;overflow:hidden}.list img[data-v-8d479d24]{width:100%;position:absolute;top:50%;left:0;transform:translateY(-50%);height:100%}.title[data-v-8d479d24]{max-height:40px;overflow:hidden;margin:5px 0;line-height:20px}", ""]);

// exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

__webpack_require__(7);

__webpack_require__(17);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: ['breakPoint', 'dsId', 'currentMid', 'mid'],
	data: function data() {
		return {
			loaded: false,
			disabled: false,
			page_nums: 20,
			page: 2,
			breakPoints: []
		};
	},

	directives: {
		WaterfallLower: (0, _waterfall2.default)('lower'),
		WaterfallUpper: (0, _waterfall2.default)('upper')
	},
	watch: {
		currentMid: function currentMid() {
			if (!this.loaded && this.currentMid == this.mid) {
				this.onRefresh();
			}
		}
	},
	mounted: function mounted() {
		var img = document.getElementsByClassName('stop');
		for (var i = 0, mylength = img.length; i < mylength; i++) {
			img[i].addEventListener("click", function (e) {
				e.preventDefault();
			});
		}
		this.breakPoints = this.breakPoints.concat(this.breakPoint);
	},

	methods: {
		loadMore: function loadMore() {
			console.log("加载更多哦");
			this.onRefresh();
		},
		onRefresh: function onRefresh() {

			if (this.breakPoints.length < 20) {
				return;
			}

			if (this.disabled) {
				return;
			}
			this.disabled = true;
			var that = this;
			_toast2.default.loading({
				mask: true,
				message: '加载中...'
			});
			var params = 'ds_id=' + this.dsId + '&page_num=' + this.page + "&page_size=" + this.page_nums;
			this.axios.post(_Tools2.default.baseUrl2() + "/init/index/getBreakPoint", params).then(function (data) {
				_toast2.default.clear();
				if (data.data.code == "200") {
					if (data.data.data.length > 0) {
						that.breakPoints = that.breakPoints.concat(data.data.data);
						that.page++;
						that.disabled = false;
					}

					that.loaded = true;
				}
			}).catch(function (res) {
				(0, _toast2.default)(res.data.message);
			});
		},
		onPlay: function onPlay(item, index) {
			this.$emit('switchVideo', item, index);
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "videoreview"
    }
  }, [_c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "lists",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "500"
    }
  }, _vm._l((_vm.breakPoints), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list",
      on: {
        "click": function($event) {
          return _vm.onPlay(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "stop",
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.create_time))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(271);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("06e1c9bb", content, true);

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#payWatch[data-v-e8888c28]{height:100%}.banner[data-v-e8888c28]{height:100%;width:100%;text-align:center}.banner img[data-v-e8888c28]{height:100%;width:100%;display:block}.coupons[data-v-e8888c28]{padding:0 0 0 100px}.title[data-v-e8888c28]{background-color:#099aff;text-align:center;padding:10px 0;color:#fff;font-size:18px}.password[data-v-e8888c28]{width:60%;height:40px;line-height:40px;border-radius:20px;border:1px solid #ccc;padding:0 20px;margin:0 auto;display:block;position:relative;overflow:hidden}.password input[data-v-e8888c28]{width:100%;height:38px;border:none}.seeword[data-v-e8888c28]{position:absolute;height:42px;width:40px;top:0;right:0;text-align:center;border-radius:20px}.seeword img[data-v-e8888c28]{vertical-align:middle}.explain[data-v-e8888c28]{text-align:center;font-size:13px;color:#a8a8a8;margin-top:10px;line-height:20px}h3[data-v-e8888c28]{text-align:center;color:#383838;margin-top:20px;font-size:16px}.button[data-v-e8888c28]{width:80%;display:block;margin-left:10%;border:0;padding:8px 0;border-radius:5px;margin-top:14px;margin-bottom:24px;font-size:17.5px;color:#fff;background-image:linear-gradient(0deg,#0190f3,#2ba8ff),linear-gradient(#099aff,#099aff);background-blend-mode:normal,normal;box-shadow:2px 4px 21px 0 rgba(0,96,255,.42);border-radius:20.5px}.ticket[data-v-e8888c28]{width:30%;margin:20px auto;background:#ff9525;text-align:center;box-shadow:2px 2px 6px #ccc;border-radius:3px;color:#fff;padding:20px 10px;position:relative}.ticket[data-v-e8888c28]:after{position:absolute;content:\"\";width:20px;height:20px;background:#fff;top:-12px;left:50%;margin-left:-10px;border-radius:50%}.ticket h4[data-v-e8888c28]{color:#f6e667;letter-spacing:1px;border-bottom:1px solid #f6e667;padding-bottom:6px}.ticket h5[data-v-e8888c28]{margin-top:10px;font-size:16px}.ticket span[data-v-e8888c28]{font-size:30px;font-weight:700}.passwordBox[data-v-e8888c28]{padding:100px 0;background:#eee;height:100%;width:100%}.allot_yao[data-v-e8888c28]{border:1px solid #c49c5f;background:#fff;color:#c49c5f;margin-top:20px;box-sizing:border-box}.allot_pay[data-v-e8888c28],.allot_yao[data-v-e8888c28]{height:44px;line-height:44px;width:100%;text-align:center;font-size:18px}.allot_pay[data-v-e8888c28]{background:#c49c5f;color:#fff;margin-top:15px}.allot_info[data-v-e8888c28]{margin:15px 15px 0;text-align:center}.allot_info h4[data-v-e8888c28]{height:36px;font-size:16px;line-height:36px;color:#c49c5f;border-bottom:1px dashed #c49c5f}.allot_info p[data-v-e8888c28]{line-height:20px;margin-top:10px;color:#333;margin-bottom:10px}.allot_info p span[data-v-e8888c28]{color:#c49c5f}.arrow[data-v-e8888c28]{position:absolute;top:10px;right:40px;color:#fff;width:200px;text-align:right;font-size:18px}.arrow img[data-v-e8888c28]{width:68px}", ""]);

// exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _passwordInput = __webpack_require__(108);

var _passwordInput2 = _interopRequireDefault(_passwordInput);

var _numberKeyboard = __webpack_require__(273);

var _numberKeyboard2 = _interopRequireDefault(_numberKeyboard);

__webpack_require__(7);

__webpack_require__(109);

__webpack_require__(277);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _blueimpMd = __webpack_require__(37);

var _blueimpMd2 = _interopRequireDefault(_blueimpMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_passwordInput2.default).use(_numberKeyboard2.default);

exports.default = {
	data: function data() {
		return {
			initData: '',
			imgScr: "",
			fans_id: "",
			passwd: '',
			ds_id: '',
			type: 1,
			couponText: '',
			value: '',
			price: "0",
			payData: '',
			passshow: true,
			showKeyboard: true,
			coupons: [],
			payIndex: -1,
			coupon_id: 0,
			showArrow: false,
			imgPath: '',
			allot: {},
			sid: 0,
			user: ''
		};
	},
	mounted: function mounted() {
		var that = this;
		this.initData = _data2.default.getInitData();
		this.user = this.$route.params.user;

		console.log("设置了权限观看");
		console.log(this.initData);

		if (!this.initData) {
			if (this.user) {
				this.$router.push({
					name: 'home',
					params: {
						user: that.user
					}
				});
				return;
			} else {
				this.$router.push({
					name: 'home'
				});
				return;
			}
		}

		this.type = this.$route.params.type;
		this.ds_id = _Tools2.default.getQueryDsId();
		this.sid = sessionStorage.getItem('sid');
		this.imgScr = _Tools2.default.baseUrl1() + "/wap/index/dsImg/?ds_id=" + this.ds_id;
		this.allot = this.initData.ds_pwd.params;
		this.allot.pic = this.initData.direct_seeding.pic_url;
		this.allot.title = this.initData.direct_seeding.name;
		if (this.type == 1) {
			this.passwd = this.initData.ds_pwd.params.http_url;
		} else if (this.type == 2) {
			this.price = this.initData.ds_pwd.params.price;
			if (this.initData.ds_pwd.params.ticket_switch == 1) {
				_Tools2.default.getCoupon(this.getCoupon);
			}
		} else {
			//获取用户信息
			_Tools2.default.login(_Tools.app_Id, this.initData.direct_seeding.uid, this.personDataInit);
		}
		this.imgPath = _Tools2.default.imgPath();
		this.couponText = this.initData.ds_pwd.params.text;
	},

	methods: {
		personDataInit: function personDataInit(fans) {
			//重缓存中获取数据
			this.fans_id = fans.fans_id;
		},
		getCoupon: function getCoupon(coupons) {
			this.coupons = coupons;
			console.log(this.coupons.length);
		},
		password: function password() {
			//加密成md5
			var passwd = (0, _blueimpMd2.default)(this.value + 'auth');
			var that = this;
			if (!this.value) {
				(0, _toast2.default)("请输入密码");
			}
			if (passwd == this.passwd) {
				(0, _toast2.default)("验证通过");
				var today = new Date().toLocaleDateString();
				localStorage.setItem("passwordDay", today);
				//tool.setCookie("password",passwd,1)
				setTimeout(function () {
					that.$router.push({
						name: 'home'
					});
				}, 2000);
			} else {
				(0, _toast2.default)('密码错误');
				this.value = "";
			}
		},
		showpass: function showpass() {
			this.passshow = !this.passshow;
		},
		bugTicket: function bugTicket() {
			_Tools2.default.bugTicket(this.coupon_id, this.payLoad);
		},
		onInput: function onInput(key) {
			this.value = (this.value + key).slice(0, 6);
		},
		onDelete: function onDelete() {
			this.value = this.value.slice(0, this.value.length - 1);
		},
		select: function select(index, id) {
			this.payIndex = index;
			this.coupon_id = id;
		},
		payLoad: function payLoad() {
			var that = this;
			sessionStorage.setItem('initData', null);
			setTimeout(function () {
				that.$router.replace('/home');
				window.location.reload();
			}, 2000);
		},
		onshowArrow: function onshowArrow() {
			this.showArrow = true;
		},
		oncloseArrow: function oncloseArrow() {
			this.showArrow = false;
		},
		allotPay: function allotPay() {
			var that = this;
			var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
			if (this.sid && this.sid != 'undefined') {
				option += '&is_allot=1&share_fans_id=' + this.sid;
			}
			this.axios.post(_Tools2.default.baseUrl3() + "/ticket/order", option).then(function (data) {
				_Tools2.default.weixinPay(data.data.data, function () {
					(0, _toast2.default)('付费成功');
					setTimeout(function () {
						that.$router.replace('/home');
						window.location.reload();
					}, 2000);
				});
			}).catch(function (data) {
				console.log('错误' + data);
			});
		}
	}
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var _Key = __webpack_require__(274);

var _Key2 = _interopRequireDefault(_Key);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('number-keyboard'),
    sfc = _use[0],
    bem = _use[1],
    t = _use[2];

var CLOSE_KEY_TYPE = ['blue', 'big'];
var DELETE_KEY_TYPE = ['delete', 'big', 'gray'];
exports.default = sfc({
  props: {
    show: Boolean,
    title: String,
    closeButtonText: String,
    deleteButtonText: String,
    safeAreaInsetBottom: Boolean,
    theme: {
      type: String,
      "default": 'default'
    },
    extraKey: {
      type: String,
      "default": ''
    },
    zIndex: {
      type: Number,
      "default": 100
    },
    transition: {
      type: Boolean,
      "default": true
    },
    showDeleteKey: {
      type: Boolean,
      "default": true
    },
    hideOnClickOutside: {
      type: Boolean,
      "default": true
    }
  },
  mounted: function mounted() {
    this.handler(true);
  },
  destroyed: function destroyed() {
    this.handler(false);
  },
  activated: function activated() {
    this.handler(true);
  },
  deactivated: function deactivated() {
    this.handler(false);
  },
  watch: {
    show: function show() {
      if (!this.transition) {
        this.$emit(this.show ? 'show' : 'hide');
      }
    }
  },
  computed: {
    keys: function keys() {
      var keys = [];

      for (var i = 1; i <= 9; i++) {
        keys.push({
          text: i
        });
      }

      switch (this.theme) {
        case 'default':
          keys.push({
            text: this.extraKey,
            type: ['gray']
          }, {
            text: 0
          }, {
            text: this.deleteText,
            type: ['gray', 'delete']
          });
          break;

        case 'custom':
          keys.push({
            text: 0,
            type: ['middle']
          }, {
            text: this.extraKey
          });
          break;
      }

      return keys;
    },
    deleteText: function deleteText() {
      return this.deleteButtonText || t('delete');
    }
  },
  methods: {
    handler: function handler(action) {
      /* istanbul ignore if */
      if (this.$isServer) {
        return;
      }

      if (action !== this.handlerStatus && this.hideOnClickOutside) {
        this.handlerStatus = action;
        document.body[(action ? 'add' : 'remove') + 'EventListener']('touchstart', this.onBlur);
      }
    },
    onBlur: function onBlur() {
      this.$emit('blur');
    },
    onClose: function onClose() {
      this.$emit('close');
      this.onBlur();
    },
    onAnimationEnd: function onAnimationEnd() {
      this.$emit(this.show ? 'show' : 'hide');
    },
    onPress: function onPress(text) {
      if (text === '') {
        return;
      }

      if (text === this.deleteText) {
        this.$emit('delete');
      } else if (text === this.closeButtonText) {
        this.onClose();
      } else {
        this.$emit('input', text);
      }
    }
  },
  render: function render(h) {
    var title = this.title,
        theme = this.theme,
        onPress = this.onPress,
        closeButtonText = this.closeButtonText;
    var titleLeftSlot = this.slots('title-left');
    var showTitleClose = closeButtonText && theme === 'default';
    var showTitle = title || showTitleClose || titleLeftSlot;
    return h("transition", {
      "attrs": {
        "name": this.transition ? 'van-slide-up' : ''
      }
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.show
      }],
      "style": {
        zIndex: this.zIndex
      },
      "class": bem([theme, {
        'safe-area-inset-bottom': this.safeAreaInsetBottom
      }]),
      "on": {
        "touchstart": _event.stopPropagation,
        "animationend": this.onAnimationEnd,
        "webkitAnimationEnd": this.onAnimationEnd
      }
    }, [showTitle && h("div", {
      "class": [bem('title'), 'van-hairline--top']
    }, [titleLeftSlot && h("span", {
      "class": bem('title-left')
    }, [titleLeftSlot]), title && h("span", [title]), showTitleClose && h("span", {
      "class": bem('close'),
      "on": {
        "click": this.onClose
      }
    }, [closeButtonText])]), h("div", {
      "class": bem('body')
    }, [this.keys.map(function (key) {
      return h(_Key2.default, {
        "key": key.text,
        "attrs": {
          "text": key.text,
          "type": key.type
        },
        "on": {
          "press": onPress
        }
      });
    })]), theme === 'custom' && h("div", {
      "class": bem('sidebar')
    }, [h(_Key2.default, {
      "attrs": {
        "text": this.deleteText,
        "type": DELETE_KEY_TYPE
      },
      "on": {
        "press": onPress
      }
    }), h(_Key2.default, {
      "attrs": {
        "text": closeButtonText,
        "type": CLOSE_KEY_TYPE
      },
      "on": {
        "press": onPress
      }
    })])])]);
  }
});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var _use = (0, _utils.use)('key'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    type: Array,
    text: [String, Number]
  },
  data: function data() {
    return {
      active: false
    };
  },
  computed: {
    className: function className() {
      var types = this.type.slice(0);
      this.active && types.push('active');
      return bem(types);
    }
  },
  methods: {
    onFocus: function onFocus() {
      this.active = true;
      this.$emit('press', this.text);
    },
    onBlur: function onBlur(event) {
      (0, _event.preventDefault)(event, true);
      this.active = false;
    }
  },
  render: function render(h) {
    var onBlur = this.onBlur;
    return h("i", {
      "class": ['van-hairline', this.className],
      "on": {
        "touchstart": this.onFocus,
        "touchmove": onBlur,
        "touchend": onBlur,
        "touchcancel": onBlur
      }
    }, [this.text]);
  }
});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(276);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-password-input{margin:0 15px;-webkit-user-select:none;user-select:none;position:relative}.van-password-input:focus{outline:0}.van-password-input__error-info,.van-password-input__info{font-size:14px;margin-top:15px;text-align:center}.van-password-input__info{color:#969799}.van-password-input__error-info{color:#f44}.van-password-input__security{width:100%;height:50px;display:-webkit-box;display:-webkit-flex;display:flex;background-color:#fff}.van-password-input__security:after{border-radius:6px}.van-password-input__security li{-webkit-box-flex:1;-webkit-flex:1;flex:1;height:100%;position:relative;font-size:20px;line-height:50px;text-align:center}.van-password-input__security li:not(:first-of-type):after{border-left-width:1px}.van-password-input__security i{position:absolute;left:50%;top:50%;width:10px;height:10px;margin:-5px 0 0 -5px;visibility:hidden;border-radius:100%;background-color:#000}", ""]);

// exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(278);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(279);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-number-keyboard{left:0;bottom:0;width:100%;position:fixed;-webkit-user-select:none;user-select:none;background-color:#fff;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}.van-number-keyboard__title{height:30px;font-size:14px;line-height:30px;text-align:center;position:relative;color:#7d7e80}.van-number-keyboard__title-left{left:0;position:absolute}.van-number-keyboard__body{box-sizing:border-box}.van-number-keyboard__close{right:0;color:#1989fa;font-size:14px;padding:0 15px;position:absolute}.van-number-keyboard__close:active{background-color:#f2f3f5}.van-number-keyboard__sidebar{top:0;right:0;width:25%;position:absolute;height:216px}.van-number-keyboard--custom .van-number-keyboard__body{padding-right:25%}.van-number-keyboard--safe-area-inset-bottom{padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}.van-key{width:33.33333333%;font-size:24px;font-style:normal;text-align:center;display:inline-block;vertical-align:middle;height:54px;line-height:54px}.van-key:after{border-width:1px 1px 0 0}.van-key--middle{width:66.66666667%}.van-key--big{width:100%;height:108px;line-height:108px}.van-key--blue,.van-key--delete{font-size:16px}.van-key--blue{color:#fff}.van-key--blue,.van-key--blue.van-key--active{background-color:#1989fa}.van-key--blue:after{border-color:#1989fa}.van-key--gray{background-color:#ebedf0}.van-key--active{background-color:#f2f3f5}", ""]);

// exports


/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "payWatch"
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgScr
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "musk"
  }, [(_vm.type == 1) ? _c('div', {
    staticClass: "passwordBox"
  }, [_c('van-password-input', {
    attrs: {
      "value": _vm.value,
      "info": '说明：' + _vm.couponText
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.password
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.showKeyboard
    },
    on: {
      "input": _vm.onInput,
      "delete": _vm.onDelete
    }
  })], 1) : (_vm.type == 2) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("门票观看")]), _vm._v(" "), _c('div', {
    staticClass: "ticket"
  }, [_c('h4', [_vm._v("门票价格")]), _vm._v(" "), _c('h5', [_vm._v("￥ \n\t\t\t\t\t"), (_vm.payIndex >= 0) ? _c('span', {
    staticClass: "money"
  }, [((_vm.price >= _vm.coupons[_vm.payIndex].money) / 100) ? [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s((_vm.price - _vm.coupons[_vm.payIndex].money) / 100) + "\n\t\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t\t0\n\t\t\t\t\t\t")]], 2) : _c('span', [_vm._v(_vm._s(_vm.price / 100))])])]), _vm._v(" "), (_vm.coupons.length) ? _c('ul', {
    staticClass: "coupons"
  }, [_vm._l((_vm.coupons), function(item, index) {
    return _c('li', {
      class: {
        cur: _vm.payIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.select(index, item.id)
        }
      }
    }, [_c('i'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.money / 100) + "元门票券")])])
  }), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.payIndex == -1
    },
    on: {
      "click": function($event) {
        return _vm.select(-1, 0)
      }
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("不使用")])])], 2) : _vm._e(), _vm._v(" "), (_vm.couponText) ? _c('p', {
    staticClass: "explain"
  }, [_vm._v("说明：" + _vm._s(_vm.couponText))]) : _c('p', {
    staticClass: "explain"
  }, [_vm._v("说明：请购买门票进行观看")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.bugTicket
    }
  }, [_vm._v("购买")])]) : _c('div', {
    staticClass: "box allot shareCard"
  }, [_c('img', {
    attrs: {
      "src": _vm.allot.pic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "allot_title"
  }, [_vm._v(_vm._s(_vm.allot.title)), _c('span', [_vm._v("精选课程")])]), _vm._v(" "), _c('div', {
    staticClass: "allot_price"
  }, [_c('span', {
    staticClass: "yuan"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.allot.price / 100))]), _vm._v(" "), _c('div', {
    staticClass: "allot_ul"
  }, [_vm._v("\n\t\t\t\t邀请收益：¥ " + _vm._s(_vm.allot.allot_money / 100) + " / 人 "), _c('span'), _vm._v("收益比例：" + _vm._s(_vm.allot.rate * 100) + "％\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "allot_yao",
    on: {
      "click": _vm.onshowArrow
    }
  }, [_vm._v("邀请好友")]), _vm._v(" "), _c('div', {
    staticClass: "allot_pay",
    on: {
      "click": _vm.allotPay
    }
  }, [_vm._v("立即购买")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showArrow),
      expression: "showArrow"
    }],
    staticClass: "musk2",
    on: {
      "click": _vm.oncloseArrow
    }
  }, [_c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'payWatch/arrow.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击这里分享邀请哦～")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allot_info"
  }, [_c('h4', [_vm._v("邀请说明")]), _vm._v(" "), _c('p', [_vm._v("每当好友购买成功，即可立即获得本次邀请收益，收益将自动存入您的"), _c('span', [_vm._v("微信钱包")])])])
}]}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(282)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  "data-v-36cad140",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(283);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7eb05f92", content, true);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".topBox[data-v-36cad140]{position:absolute;width:100%;left:0;top:56vw;overflow:hidden}.scroll[data-v-36cad140]{height:24px;background:rgba(220,29,0,.8);line-height:24px;display:flex;color:#fcefa9;overflow:hidden}.scroll .news[data-v-36cad140]{margin:0 5px;color:#f7c85d;display:flex}.scroll .news img[data-v-36cad140]{width:16px;height:16px;margin-top:4px;margin-right:4px}.scrollList[data-v-36cad140]{flex:1;position:absolute;overflow:hidden;height:24px;top:0;left:94px;width:100%}.scrollList ul[data-v-36cad140]{position:absolute;transition:top .5s;width:100%;height:34px}.scrollList ul span[data-v-36cad140]{color:#fcefa9}", ""]);

// exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	data: function data() {
		return {
			ds_id: '',
			news: [],
			giftName: '',
			activeIndex: 0
		};
	},

	computed: {
		top: function top() {
			return -this.activeIndex * 24 + 'px';
		}
	},
	props: ['playHeight', 'pieceHeight', 'fans_id'],
	mounted: function mounted() {
		var that = this;
		this.ds_id = _Tools2.default.getQueryDsId();
		this.getBuyList();
		// setInterval(function(){
		// 	that.getBuyList();
		// },100000)

		setInterval(function () {
			if (that.activeIndex < that.news.length - 1) {
				that.activeIndex += 1;
			} else {
				that.activeIndex = 0;
			}
		}, 3000);
	},

	methods: {
		getBuyList: function getBuyList() {
			var that = this;
			var url = _Tools2.default.baseUrl1() + '/shop/order/get_buy_list';
			var option = 'fans_id=' + this.fans_id + '&ds_id=' + this.ds_id;
			//var option = 'fans_id=26&ds_id=6';

			this.axios.post(url, option).then(function (data) {
				var data = data.data;
				if (data.code == 200) {
					that.news = that.news.concat(data.data);
				}
			}, function (res) {
				console.log(res);
			});
		},
		moneyEnter: function moneyEnter(name, money) {
			this.news.push({ 'nick': name, 'money': money });
		}
	}
};

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "topBox",
    style: ('margin-top:' + (_vm.playHeight + _vm.pieceHeight) + 'px')
  }, [_c('div', {
    staticClass: "scroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollList"
  }, [(_vm.news.length) ? _c('ul', {
    style: ({
      top: _vm.top
    })
  }, _vm._l((_vm.news), function(item) {
    return _c('li', [_vm._v(_vm._s(item.nick) + " 获得了 "), _c('span', [_vm._v(_vm._s(item.money / 100))]), _vm._v(" 元分享收益")])
  }), 0) : _c('ul', {
    style: ({
      top: _vm.top
    })
  }, [_c('li', [_vm._v("暂无数据")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/toupiao/horn.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("分销动态：")])])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(287)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  "data-v-4a4b0526",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(288);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("d1082552", content, true);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-popup[data-v-4a4b0526]{border-radius:2px;margin-top:80px}.roomBar[data-v-4a4b0526]{position:fixed;display:-webkit-box;display:-moz-box;display:flex;bottom:0;background-color:#eee;width:100%;padding:5px 0;align-items:center;z-index:1401;box-shadow:0 -3px 10px #ddd}.roomBar.typebg2[data-v-4a4b0526]{background:#333}.roomBar.typebg3[data-v-4a4b0526]{background:#ec1a1a}.bottom-gift[data-v-4a4b0526],.bottom-zan[data-v-4a4b0526]{margin-left:5px;height:30px;width:30px;padding:3px}.bottom-img[data-v-4a4b0526]{width:100%}.quick-button[data-v-4a4b0526]{border-radius:5px;border:none;margin-left:10px;width:90px;font-size:13px;padding:0 5px;height:30px;color:#fff}.inputValue[data-v-4a4b0526]{display:block;margin-left:10px;font-size:12px;padding-left:10px;padding-right:8px;flex:1;background:#fff}.bottom-button[data-v-4a4b0526],.inputValue[data-v-4a4b0526]{height:30px;border:none;margin-right:10px;border-radius:5px;line-height:30px}.bottom-button[data-v-4a4b0526]{width:50px;padding:0;padding-bottom:0;color:#fff}.type1[data-v-4a4b0526]{background-color:#1483ff;border-color:#1483ff}.type2[data-v-4a4b0526],.type3[data-v-4a4b0526]{background-color:#e5bc4b;border-color:#e5bc4b}.textarea[data-v-4a4b0526]{border:none;width:100%;resize:none;box-sizing:border-box;padding:5px}.btnBox[data-v-4a4b0526]{display:-webkit-box;display:-moz-box;display:flex;text-align:center}.btnBox .btn[data-v-4a4b0526]{flex:1;height:42px;line-height:42px;color:#fff;font-size:16px}.btnBox .btn[data-v-4a4b0526]:first-child{background:#0084ff}.quickArrow[data-v-4a4b0526]{width:30px;height:30px;transform:rotate(45deg) translateX(-50%);background-color:#fff;position:absolute;left:50%;bottom:46px}.quickPanel[data-v-4a4b0526]{position:absolute;background-color:#fff;max-height:410px;min-height:100px;padding:10px 0;border-radius:5px;overflow:scroll;bottom:60px;width:100%}.quickPanel li[data-v-4a4b0526]{padding:8px 20px;display:-webkit-box;display:-moz-box;display:flex}.getGift[data-v-4a4b0526]{text-align:center;position:fixed;font-size:18px;line-height:18px;top:50%;padding:10px;width:80%;left:50%;z-index:1900;margin-left:-40%;background:#fff;border-radius:3px;box-shadow:0 0 6px 1px #b1b1b1}.giftImg[data-v-4a4b0526]{position:absolute;top:-100px;width:80px;height:80px;left:50%;margin-left:-40px;animation:changebig 1.5s infinite}@keyframes changebig{0%{width:80px}30%{transform:scale(1.2)}to{transform:scale(1)}}.getGift .name[data-v-4a4b0526]{color:#ff4040}.getGift .num[data-v-4a4b0526]{color:#ffa340;font-style:italic;font-weight:700}.occupy[data-v-4a4b0526]{color:#262626;line-height:28px}.occupy .title[data-v-4a4b0526]{position:absolute;top:-50px;font-size:28px;color:#e5bc4b}.occupy .textarea[data-v-4a4b0526]{position:relative}.occupy textarea[data-v-4a4b0526]{width:100%;border:1px solid #ccc;border-radius:5px;resize:none;box-sizing:border-box}.occupy textarea[data-v-4a4b0526]::placeholder{color:#ccc}.occupy .number[data-v-4a4b0526]{position:absolute;right:7px;background:#fff;bottom:16px;line-height:20px}.occupy .number span[data-v-4a4b0526]{color:#e5bc4b}.occupy .addimg[data-v-4a4b0526]{position:relative;min-height:100px;overflow:hidden}.occupy .addimg .img[data-v-4a4b0526]{width:100px;height:100px;overflow:hidden;position:relative}.occupy .addimg .img img[data-v-4a4b0526]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.occupy .addimg .guide[data-v-4a4b0526]{width:50px}.occupy .addimg .container[data-v-4a4b0526]{position:absolute;top:0;left:0;width:100px;height:100px}.occupy .addimg .buttom[data-v-4a4b0526]{background:#579fee;color:#fff;padding:0 4px;border-radius:5px;display:inline-block;vertical-align:top}.occupy .addimg .success[data-v-4a4b0526]{background:#83bb01}.occupy .times a[data-v-4a4b0526]{display:inline-block;text-align:center;width:30%;margin-right:1%;height:34px;line-height:34px;border:1px solid #ccc;border-radius:5px}.occupy .times .cur[data-v-4a4b0526]{background:#e5bc4b;border-color:#e5bc4b;color:#fff}.occupy .money[data-v-4a4b0526]{margin:10px 0}.occupy .money span[data-v-4a4b0526]{color:#e5bc4b;font-weight:700;font-size:20px}.occupy .btns[data-v-4a4b0526]{margin-bottom:10px}.occupy .btns a[data-v-4a4b0526]{width:40%;margin:0 4%;display:inline-block;line-height:34px;height:34px;border:1px solid #e5bc4b;border-radius:17px;text-align:center;color:#e5bc4b}.occupy .btns a[data-v-4a4b0526]:last-child{background:#e5bc4b;color:#fff}.occupy .prompt[data-v-4a4b0526]{color:#e5bc4b}.selectfiles[data-v-4a4b0526]{width:100px;height:100px}.imgPl .addimg[data-v-4a4b0526]{margin:5px;border:1px dashed #8e8e8e;text-align:center;width:100px;height:100px;line-height:100px;border-radius:6px;overflow:hidden;position:relative}.imgPl .addimg img[data-v-4a4b0526]{position:absolute;left:50%;top:50%;max-width:90%;max-height:90%;transform:translate(-50%,-50%)}.imgPl .addimg[data-v-4a4b0526]:after,.imgPl .addimg[data-v-4a4b0526]:before{content:\"\";display:block;position:absolute;top:50%;left:50%;background:#979797;z-index:-1}.imgPl .addimg[data-v-4a4b0526]:before{height:24px;width:2px;margin-left:-1px;margin-top:-12px}.imgPl .addimg[data-v-4a4b0526]:after{width:24px;height:2px;margin-left:-12px;margin-top:-1px}.imgPl .addimg p[data-v-4a4b0526]{margin-top:30px;font-size:16px}.imgPl .textarea[data-v-4a4b0526]{margin:20px 5px;border-top:1px solid silver;padding-top:5px}.imgPl textarea[data-v-4a4b0526]{border:none}.imgPl .btns[data-v-4a4b0526]{display:-webkit-box;display:-moz-box;display:flex}.imgPl .btns a[data-v-4a4b0526]{flex:1;margin:0 5px;border-radius:6px;height:42px;line-height:42px;font-size:16px}.imgPl .btns a.disabled[data-v-4a4b0526],.occupy .btns a.disabled[data-v-4a4b0526]{background:#ccc;border-color:#ccc}.bottomView[data-v-4a4b0526]{border-radius:0!important}.senMsgBtn[data-v-4a4b0526]{margin-right:10px;background:linear-gradient(137deg,#73aaff 5%,#0053ff 93%);border-radius:4px;border:none}", ""]);

// exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__(21);

__webpack_require__(7);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _handleim = __webpack_require__(40);

var _handleim2 = _interopRequireDefault(_handleim);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _eventBus = __webpack_require__(95);

var _eventBus2 = _interopRequireDefault(_eventBus);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

var _giftAlertView = __webpack_require__(290);

var _giftAlertView2 = _interopRequireDefault(_giftAlertView);

var _vuex = __webpack_require__(29);

var _cosUpload = __webpack_require__(307);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

_vue2.default.use(_popup2.default).use(_toast2.default);
exports.default = {
  data: function data() {
    return {
      tid: 0,
      ds_id: "",
      imgPath: "",
      fid: "",
      isReply: false, //是否是回复
      comment_id: 0,
      isShowQuickBtn: false,
      inputValue: "",
      placeholder: "请输入你要发表的内容",
      focusState: false,
      imgStatus: false,
      occupyStatus: false,
      occupyText: "",
      occupyImg: "",
      occupyImgUrl: "",
      occupyFile: "",
      occupyPath: "",
      occupyList: [5, 10, 15],
      payLevel: 1,
      occupyImgUp: false,
      occupyRatio: 1,
      showgift: false,
      commentBox: false,
      isShowQuickPanel: false,
      key: "uploads/comment/",
      expire: 0,
      g_object_name: "live",
      suffix: "",
      g_object_name_type: "local_name",
      now: Date.parse(new Date()) / 1000,
      timestamp: Date.parse(new Date()) / 1000,
      uploadAble: false,
      giftTimer: null,
      showgetGift: false,
      giftMessages: {},
      sendMsgTimer: null,
      sendFollowerText: ""
      // flowers: ''
    };
  },

  directives: {
    focus: {
      update: function update(el, _ref) {
        var value = _ref.value;

        if (value) {
          el.focus();
        }
      }
    }
  },
  props: ["styleType", "picComment", "isshowgift", "isWeixin", "commentList", "isIOS", "fans_id", "isMaster", "giftList", "wallSign", "wall_id", "payPrice", "verify_comment", "directStatus", "is_all_users_muted", "say_self"],
  components: {
    giftAlertView: _giftAlertView2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)({
    userConfig: "dsInfo/getUserConfig",
    BusinessConfigs: "dsInfo/getBusinessConfigs",
    Sendflowers: 'dsInfo/getSendflowers'
  })),
  mounted: function mounted() {
    var that = this;
    this.tid = _Tools2.default.getQueryString("tid");
    this.imgPath = _Tools2.default.imgPath();
    _eventBus2.default.$on("showcomment", function () {
      that.showcommentBox();
    });
    _eventBus2.default.$on("replying", function (msg) {
      that.reply(msg);
    });
  },

  methods: {
    getFilef: function getFilef(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var file;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = e.target.files[0];
                _context.prev = 1;
                _context.next = 4;
                return (0, _cosUpload.cosUploadFile)(file, _this.uid);

              case 4:
                _this.occupyImg = _context.sent;
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

              case 9:
                _this.uploadAble = true;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    },
    picCommentTap: function picCommentTap() {
      if (this.is_all_users_muted) {
        (0, _toast2.default)("当前直播全员禁止发言");
        return;
      }
      this.imgStatus = true;
    },
    sendFllowerTap: function sendFllowerTap(type) {
      if (type == 1) {
        this.sendFollowerText = "送给老师的鲜花<img style='width:20px;ertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/xianhua.png'/>";
      } else if (type == 2) {
        this.sendFollowerText = "给老师点个赞<img style='width:20px;vertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/dianzhan.png'/>";
      }

      this.sendMsg(1);
    },
    onInputClicked: function onInputClicked() {
      this.commentBox = true;
    },
    imgPlShow: function imgPlShow() {
      this.imgStatus = !this.imgStatus;
    },
    showcommentBox: function showcommentBox() {
      this.focusState = !this.focusState;
      this.commentBox = !this.commentBox;
    },
    giftClicked: function giftClicked() {
      this.showgift = true;
    },
    showQuickMsgPanelAction: function showQuickMsgPanelAction() {
      this.isShowQuickPanel = true;
      this.commentBox = false;
    },

    //获取焦点
    inputFocus: function inputFocus() {
      this.focusState = true;
      if (!this.isIOS) {
        this.isShowQuickBtn = true;
      }
    },
    inputblur: function inputblur() {
      window.scrollTo(0, 0);
      var that = this;
      document.body.addEventListener("click", function () {
        that.placeholder = "请输入你要发表的内容";
        that.isReply = false;
        that.comment_id = "";
      });
      this.isShowQuickBtn = false;
      this.focusState = false;
    },
    sendMsg: function sendMsg(type) {
      var _this2 = this;

      var contentText = "";
      if (type == 1) {
        contentText = this.sendFollowerText;
      } else {
        contentText = this.inputValue.replaceAll("<", "#").replaceAll(">", "#").replaceAll("&lt;", "#").replaceAll("&gt;", "#");
      }

      if (this.directStatus == "end" && this.userConfig && this.userConfig.all_no_speak) {
        (0, _toast2.default)("当前未直播禁止发言");
        return;
      }

      if (this.is_all_users_muted) {
        return;
      }

      if (contentText.length < 1) {
        (0, _toast2.default)("发送消息不能为空");
        return false;
      }

      // if (this.inputValue.length > 500) {
      //   Toast("发送消息不能超过500字");
      //   return false;
      // }
      if (contentText == "@debug") {
        this.testSendMessage(location.href, '');
        this.inputValue = "";
        return;
      }

      if (this.sendMsgTimer) {
        (0, _toast2.default)("评论发送太快了");
        return;
      } else {
        this.sendMsgTimer = setTimeout(function () {
          clearTimeout(_this2.sendMsgTimer);
          _this2.sendMsgTimer = null;
        }, type == 1 ? 5000 : 1000);
      }

      var that = this;
      var url = _Tools2.default.baseUrl2() + "/comment/index/addSub";
      var url2 = _Tools2.default.baseUrl2() + "/comment/index/add";

      var option = {
        fans_id: this.fans_id,
        ds_id: _Tools2.default.getDs_id(),
        content: contentText,
        debug: 1,
        is_master: this.isMaster,
        quick_id: this.quick_id,
        fid: this.fid,
        comment_id: this.comment_id
      };

      var option2 = {
        terminal_type: 1,
        fans_id: this.fans_id,
        ds_id: _Tools2.default.getDs_id(),
        content: contentText,
        debug: 1,
        is_master: this.isMaster,
        quick_id: this.quick_id,
        fid: this.fid
      };

      if (this.tid) {
        option.tid = this.tid;
        option2.tid = this.tid;
      }

      option = _qs2.default.stringify(option);
      option2 = _qs2.default.stringify(option2);

      this.commentBox = false;
      if (this.isReply) {
        this.isReply = false;
        this.placeholder = "请输入你要发表的内容";
        this.axios.post(url, option).then(function (data) {
          var data = data.data;
          if (data.code == "200") {
            (0, _toast2.default)("回复成功");
            that.commentBox = false;
            that.quick_id = "";
            that.fid = "";
          } else {
            (0, _toast2.default)(data.message);
          }
        }).catch(function (data) {
          (0, _toast2.default)("回复失败");
          that.quick_id = "";
          that.fid = "";
          console.log("错误" + data);
        });
      } else {

        if (that.say_self.enabled && that.say_self.all == 1) {
          //全员自嗨
          that.sendMessageMySelf(contentText, '');
          if (type != 1) {
            that.inputValue = "";
          }
          return;
        }

        this.axios.post(url2, option2, { timeout: 3000 }).then(function (data) {
          var data = data.data;
          if (data.code == "200") {
            if (data.data.isCheck) {
              var newObj = Object.assign({}, data.data.content);
              newObj.module = "check_comment";
              _handleim2.default.sendTextMsg(newObj);
            } else {
              _handleim2.default.sendTextMsg(data.data.content);
            }
            _eventBus2.default.$emit("messageisCheck", data.data.content);
            that.quick_id = "";
            that.fid = "";
            that.commentBox = false;
          } else {
            if (that.say_self.enabled) {
              //开启自嗨
              that.sendMessageMySelf(contentText, '');
            } else {
              (0, _toast2.default)(data.message);
            }
            // Toast(data.message);
          }

          if (type != 1) {
            that.inputValue = "";
          }
        }).catch(function (error) {
          //判断是否有评论审核
          that.sendMessageBy505Error(contentText, '');
          if (type != 1) {
            that.inputValue = "";
          }
          that.quick_id = "";
          that.fid = "";
          console.log("错误" + data);
        });
      }
    },
    testSendMessage: function testSendMessage(text, pic_url) {
      var app_id = localStorage.getItem("current_app_Id");
      if (app_id) {
        var userInfo = localStorage.getItem(app_id);
        if (userInfo) {
          var userInfo2 = JSON.parse(userInfo);
          var message = {
            content: text,
            create_time: _Tools2.default.getCommentTimes(),
            fans_id: userInfo2.fans_id,
            header: userInfo2.header,
            key: _Tools2.default.getDs_id() + "_comment_" + new Date().getTime(),
            like_num: 0,
            module: "text_comment",
            nick: userInfo2.nick,
            pic_url: pic_url,
            user_type: "real",
            terminal_type: 1,
            ds_id: _Tools2.default.getDs_id(),
            _id: _Tools2.default.getDs_id() + "_comment_" + new Date().getTime()
          };
          _eventBus2.default.$emit("messageisCheck", message);
        }
      }
    },
    sendMessageMySelf: function sendMessageMySelf(text, pic_url) {
      var app_id = localStorage.getItem("current_app_Id");
      if (app_id) {
        var userInfo = localStorage.getItem(app_id);
        if (userInfo) {
          var userInfo2 = JSON.parse(userInfo);
          var message = {
            content: text,
            create_time: _Tools2.default.getCommentTimes(),
            fans_id: userInfo2.fans_id,
            header: userInfo2.header,
            key: _Tools2.default.getDs_id() + "_comment_" + new Date().getTime(),
            like_num: 0,
            module: "text_comment",
            nick: userInfo2.nick,
            pic_url: pic_url,
            user_type: "real",
            terminal_type: 1,
            ds_id: _Tools2.default.getDs_id(),
            _id: _Tools2.default.getDs_id() + "_comment_" + new Date().getTime()
          };
          _eventBus2.default.$emit("messageisCheck", message);
          if (this.say_self.type == 1) {
            //是否发送给助教
            _handleim2.default.sendTextMsg(Object.assign({}, message, { module: 'my_self_hi' }));
          }
        }
      }
    },
    sendMessageBy505Error: function sendMessageBy505Error(text, pic_url) {
      var app_id = localStorage.getItem("current_app_Id");
      if (app_id) {
        var userInfo = localStorage.getItem(app_id);
        if (userInfo) {
          var userInfo2 = JSON.parse(userInfo);
          var message = {
            content: text,
            create_time: _Tools2.default.getCommentTimes(),
            fans_id: userInfo2.fans_id,
            header: userInfo2.header,
            key: _Tools2.default.getDs_id() + "_comment_" + new Date().getTime(),
            like_num: 0,
            module: "text_comment",
            nick: userInfo2.nick,
            pic_url: pic_url,
            user_type: "real",
            terminal_type: 1,
            ds_id: _Tools2.default.getDs_id(),
            _id: _Tools2.default.getDs_id() + "_comment_" + new Date().getTime()
          };
          _eventBus2.default.$emit("messageisCheck", message);
          if (this.verify_comment) {
            //审核评论
            var message2 = Object.assign({}, message);
            message2.module = "check_comment";
            _handleim2.default.sendTextMsg(message2);
          } else {
            _handleim2.default.sendTextMsg(message);
          }
        }
      }
    },
    occupy: function occupy() {
      if (!this.occupyImg) {
        if (this.occupyText) {
          console.log("111");
          this.occupySub();
        } else {
          (0, _toast2.default)("霸屏内容为空！");
          return false;
        }
      } else {
        console.log("222");
        this.occupySub();
      }
    },
    occupySub: function occupySub() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + "/wall/pay_up_wall";
      var option = "fans_id=" + this.fans_id + "&content=" + this.occupyText + "&pay_level=" + (this.payLevel + 1) + "&wall_id=" + this.wall_id + "&pic_url=" + this.occupyImg;

      this.uploadAble = false;
      _toast2.default.loading({
        mask: true,
        message: "发布中..."
      });
      this.axios.post(url, option).then(function (data) {
        var data = data.data;
        that.uploadAble = true;
        if (data.code == 200) {
          that.occupyRefresh();
          that.weixinPay(data.data);
        } else {
          console.log(data.message);
        }
      }).catch(function (data) {
        that.uploadAble = true;
        //Toast(data);
      });
    },
    choice: function choice(index) {
      this.payLevel = index;
    },
    occupyShow: function occupyShow() {
      this.occupyStatus = true;
    },
    occupyRefresh: function occupyRefresh() {
      var that = this;
      this.occupyStatus = false;
      this.imgStatus = false;
      this.occupyImg = "";
      this.occupyText = "";
    },
    imgPl: function imgPl() {
      //设置未直播禁止发言
      if (this.directStatus == "end" && this.userConfig && this.userConfig.all_no_speak) {
        (0, _toast2.default)("当前未直播禁止发言");
        return;
      }

      if (!this.occupyImg) {
        if (this.occupyText) {
          //500字符限制
          // if (this.occupyText.length > 500) {
          //   Toast("内容不能超过500字符");
          //   return;
          // }
          this.imgSub();
        } else {
          (0, _toast2.default)("评论内容为空！");
          return false;
        }
      } else {
        this.imgSub();
      }
    },
    imgSub: function imgSub() {
      var that = this;

      if (that.say_self.enabled && that.say_self.all == 1) {
        //开启全员自嗨
        that.sendMessageMySelf(that.occupyText, that.occupyImg);
        that.occupyRefresh();
        return;
      }

      var url = _Tools2.default.baseUrl2() + "/comment/index/add";
      var option = {
        fans_id: this.fans_id,
        ds_id: _Tools2.default.getDs_id(),
        content: this.occupyText,
        pic_url: this.occupyImg,
        debug: 1,
        terminal_type: 1
      };
      console.log(option);
      this.uploadAble = false;
      _toast2.default.loading({
        mask: true,
        message: "发布中..."
      });
      option = _qs2.default.stringify(option);
      // option = tool.encrypt(option);
      this.axios.post(url, option, { timeout: 3000 }).then(function (data) {
        var data = data.data;
        that.uploadAble = true;
        if (data.code == "200") {
          if (data.data.isCheck) {
            var newObj = Object.assign({}, data.data.content);
            newObj.module = "check_comment";
            _handleim2.default.sendTextMsg(newObj);
          } else {
            _handleim2.default.sendTextMsg(data.data.content);
          }
          _eventBus2.default.$emit("messageisCheck", data.data.content);
          that.occupyRefresh();
        } else {
          if (that.say_self.enabled) {
            //开启自嗨
            that.sendMessageMySelf(that.occupyText, that.occupyImg);
          } else {
            (0, _toast2.default)(data.message);
          }
          that.occupyRefresh();
        }
      }).catch(function (data) {
        that.uploadAble = false;
        if (that.say_self.enabled) {
          //开启自嗨
          that.sendMessageMySelf(that.occupyText, that.occupyImg);
        } else {
          that.sendMessageBy505Error(that.occupyText, that.occupyImg);
        }
        that.occupyRefresh();
        // Toast("评论失败");
      });
    },
    weixinPay: function weixinPay(p) {
      var that = this;
      var params = "appId:" + p.appId + "timeStamp:" + p.timeStamp + "nonceStr:" + p.nonceStr + "package:" + p.package + "sing:" + p.paySign;
      WeixinJSBridge.invoke("getBrandWCPayRequest", {
        appId: p.appId, //公众号名称，由商户传入
        timeStamp: String(p.timeStamp), //时间戳，自1970年以来的秒数
        nonceStr: p.nonceStr, //随机串
        package: p.package,
        signType: p.signType, //微信签名方式：
        paySign: p.paySign //微信签名
      }, function (res) {
        // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回		ok，但并不保证它绝对可靠。
        if (res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
          (0, _toast2.default)("霸屏成功！");
          console.log("霸屏成功！");
        } else {
          that.occupyStatus = false;
        }
      });
    },
    sendTalk: function sendTalk(msg, fid, type) {
      var Base64 = __webpack_require__(34).Base64;
      var that = this;
      var url;
      if (type == 0) {
        url = _Tools2.default.baseUrl() + "/comment/index/redPassword";
      } else {
        url = _Tools2.default.baseUrl() + "/comment/index/couponPassword";
      }
      var option = {
        fans_id: this.fans_id,
        ds_id: _Tools2.default.getDs_id(),
        content: msg,
        flag: 1
      };

      option = _Tools2.default.encrypt(option);
      this.fid = fid;

      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          setTimeout(function () {
            that.$emit("showtalk", data.data);
          }, 1000);
          that.inputValue = msg;
          that.sendMsg();
        } else {
          (0, _toast2.default)(data.message);
          that.$emit("colsetalkred");
        }
      }).catch(function (res) {
        console.log(res);
      });
    },
    sendquickMsgAction: function sendquickMsgAction(index) {
      this.isShowQuickPanel = false;
      this.inputValue = this.commentList[index].comment;
      this.quick_id = this.commentList[index].id;
      this.sendMsg();
    },
    gift: function gift(item) {
      var self = this;
      clearTimeout(this.giftTimer);
      this.giftMessages = item;
      this.showgift = false;
      this.showgetGift = true;
      this.giftTimer = setTimeout(function () {
        self.showgetGift = false;
      }, 3000);
    },
    reply: function reply(item) {
      //回复
      this.isReply = true;
      this.comment_id = item._id;
      this.inputValue = "";
      this.placeholder = "请输入回复" + item.nick + "的内容";
      if (this.isIOS) {
        _eventBus2.default.$emit("showcomment");
      } else {
        _eventBus2.default.$emit("focus");
      }
    }
  }
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(291)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  "data-v-920fc988",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(292);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b6d6ae00", content, true);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".gitbottomView[data-v-920fc988]{background:#fff;border-top:1px solid #d6d6d6}.van-col--6[data-v-920fc988]{height:100px;background:#fff;border-right:1px solid #d6d6d6;border-bottom:1px solid #d6d6d6}.van-col--6[data-v-920fc988]:nth-child(4n){border-right:none}.gitbottomView .on[data-v-920fc988]{background-color:hsla(38,72%,75%,.3)}.list[data-v-920fc988]{width:100%;height:100%;text-align:center}.list .img[data-v-920fc988]{width:35px;height:35px;padding-top:10px;text-align:center;margin:0 auto 7px;line-height:35px}.list .img img[data-v-920fc988]{max-width:100%;max-height:100%;vertical-align:middle}.money[data-v-920fc988]{color:#999}.paybar[data-v-920fc988]{background:#fff;padding:10px;display:flex;align-items:center}.paynumber[data-v-920fc988]{display:flex;align-items:center;justify-content:flex-start;flex:1}.paynumber span[data-v-920fc988]{margin-right:10px}.paybutton[data-v-920fc988]{display:flex;align-items:center;justify-content:flex-end;flex:1}.paybutton .cost[data-v-920fc988]{padding-right:10px;color:#ff9239}.van-button--small[data-v-920fc988]{color:#fff;background:#01b3e9;border:none}", ""]);

// exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

var _stepper = __webpack_require__(294);

var _stepper2 = _interopRequireDefault(_stepper);

var _row = __webpack_require__(295);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(296);

var _col2 = _interopRequireDefault(_col);

__webpack_require__(7);

__webpack_require__(25);

__webpack_require__(297);

__webpack_require__(300);

__webpack_require__(303);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _blueimpMd = __webpack_require__(37);

var _blueimpMd2 = _interopRequireDefault(_blueimpMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_row2.default).use(_col2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_stepper2.default);
_vue2.default.use(_button2.default);
_vue2.default.use(_toast2.default);
exports.default = {
	data: function data() {
		return {
			value: 1,
			sumMoney: 0,
			selected: -1,
			giftData: [],
			currentPrice: 0,
			currentGift: {},
			payData: {},
			ds_id: ''
		};
	},

	props: ["renum", 'fans_id', 'giftList'],
	mounted: function mounted() {
		this.ds_id = _Tools2.default.getQueryDsId();
	},

	methods: {
		changeOnClick: function changeOnClick() {
			this.sumMoney = this.currentPrice * this.value / 100;
		},
		selectGiftAction: function selectGiftAction(item, index) {
			this.selected = index;
			this.currentPrice = item.price;
			this.currentGift = item;
			this.sumMoney = item.price * this.value / 100;
		},
		closeAction: function closeAction() {
			this.selected = -1;
			this.currentGift = '';
			this.currentPrice = 0;
			this.value = 1;
			this.sumMoney = 0;
		},
		bugGifAction: function bugGifAction() {
			var that = this;
			if (this.value <= 0) {
				(0, _toast2.default)('请输入大于等于1的数量');
				return;
			}
			var Base64 = __webpack_require__(34).Base64;
			var url = _Tools2.default.baseUrl() + "/gift/index/rewardGift";

			var option = {
				'ds_id': this.ds_id,
				'gift_id': this.currentGift.gift_id,
				'fans_id': this.fans_id,
				'nums': this.value
			};
			console.log(option);
			var data = JSON.stringify(option);
			var params = Base64.encode(data);
			var verifyCode = _data2.default.verifyCode;
			var newstr = '';
			var tmp = params.substring(0, 3);
			var tmp1 = params.substring(3, params.length);
			newstr += tmp + (0, _blueimpMd2.default)(data + verifyCode) + tmp1;
			newstr = "data=" + newstr;

			this.axios.post(url, newstr).then(function (data) {
				if (data.data.code == "200") {
					that.payData = data.data.data;
					that.weixinPay(that.payData);
				} else {
					(0, _toast2.default)('购买礼物失败！');
				}
			}).catch(function (res) {
				(0, _toast2.default)('购买礼物失败！');
			});
		},
		weixinPay: function weixinPay(p) {
			var that = this;
			WeixinJSBridge.invoke('getBrandWCPayRequest', {
				"appId": p.appId, //公众号名称，由商户传入     
				"timeStamp": String(p.timeStamp), //时间戳，自1970年以来的秒数     
				"nonceStr": p.nonceStr, //随机串     
				"package": p.package,
				"signType": p.signType, //微信签名方式：
				"paySign": p.paySign //微信签名 
			}, function (res) {
				// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
				if (res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
					(0, _toast2.default)('购买礼物成功！');
					that.closeAction();
				} else {
					that.closeAction();
				}
			});
		}
	},
	watch: {
		renum: function renum() {
			this.closeAction();
		}
	}
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _use = (0, _utils.use)('stepper'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    value: null,
    integer: Boolean,
    disabled: Boolean,
    inputWidth: String,
    asyncChange: Boolean,
    disableInput: Boolean,
    min: {
      type: [String, Number],
      "default": 1
    },
    max: {
      type: [String, Number],
      "default": Infinity
    },
    step: {
      type: [String, Number],
      "default": 1
    },
    defaultValue: {
      type: [String, Number],
      "default": 1
    }
  },
  data: function data() {
    var value = this.range((0, _utils.isDef)(this.value) ? this.value : this.defaultValue);

    if (value !== +this.value) {
      this.$emit('input', value);
    }

    return {
      currentValue: value
    };
  },
  computed: {
    minusDisabled: function minusDisabled() {
      return this.disabled || this.currentValue <= this.min;
    },
    plusDisabled: function plusDisabled() {
      return this.disabled || this.currentValue >= this.max;
    }
  },
  watch: {
    value: function value(val) {
      if (val !== this.currentValue) {
        this.currentValue = this.format(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  },
  methods: {
    // filter illegal characters
    format: function format(value) {
      value = String(value).replace(/[^0-9.-]/g, '');
      return value === '' ? 0 : this.integer ? Math.floor(value) : +value;
    },
    // limit value range
    range: function range(value) {
      return Math.max(Math.min(this.max, this.format(value)), this.min);
    },
    onInput: function onInput(event) {
      var value = event.target.value;
      var formatted = this.format(value);

      if (!this.asyncChange) {
        if (+value !== formatted) {
          event.target.value = formatted;
        }

        this.currentValue = formatted;
      } else {
        event.target.value = this.currentValue;
        this.$emit('input', formatted);
        this.$emit('change', formatted);
      }
    },
    onChange: function onChange(type) {
      if (this[type + "Disabled"]) {
        this.$emit('overlimit', type);
        return;
      }

      var diff = type === 'minus' ? -this.step : +this.step;
      var value = Math.round((this.currentValue + diff) * 100) / 100;

      if (!this.asyncChange) {
        this.currentValue = this.range(value);
      } else {
        this.$emit('input', value);
        this.$emit('change', value);
      }

      this.$emit(type);
    },
    onFocus: function onFocus(event) {
      this.$emit('focus', event);
    },
    onBlur: function onBlur(event) {
      this.currentValue = this.range(this.currentValue);
      this.$emit('blur', event); // fix edge case when input is empty and min is 0

      if (this.currentValue === 0) {
        event.target.value = this.currentValue;
      }
    }
  },
  render: function render(h) {
    var _this = this;

    var onChange = function onChange(type) {
      return function () {
        _this.onChange(type);
      };
    };

    return h("div", {
      "class": bem()
    }, [h("button", {
      "class": bem('minus', {
        disabled: this.minusDisabled
      }),
      "on": {
        "click": onChange('minus')
      }
    }), h("input", {
      "attrs": {
        "type": "number",
        "disabled": this.disabled || this.disableInput
      },
      "class": bem('input'),
      "domProps": {
        "value": this.currentValue
      },
      "style": {
        width: this.inputWidth
      },
      "on": {
        "input": this.onInput,
        "focus": this.onFocus,
        "blur": this.onBlur
      }
    }), h("button", {
      "class": bem('plus', {
        disabled: this.plusDisabled
      }),
      "on": {
        "click": onChange('plus')
      }
    })]);
  }
});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _use = (0, _utils.use)('row'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    type: String,
    align: String,
    justify: String,
    tag: {
      type: String,
      "default": 'div'
    },
    gutter: {
      type: [Number, String],
      "default": 0
    }
  },
  render: function render(h) {
    var _bem;

    var align = this.align,
        justify = this.justify;
    var flex = this.type === 'flex';
    var margin = "-" + Number(this.gutter) / 2 + "px";
    var style = this.gutter ? {
      marginLeft: margin,
      marginRight: margin
    } : {};
    return h(this.tag, {
      "style": style,
      "class": bem((_bem = {
        flex: flex
      }, _bem["align-" + align] = flex && align, _bem["justify-" + justify] = flex && justify, _bem))
    }, [this.slots()]);
  }
});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _use = (0, _utils.use)('col'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    span: [Number, String],
    offset: [Number, String],
    tag: {
      type: String,
      "default": 'div'
    }
  },
  computed: {
    gutter: function gutter() {
      return this.$parent && Number(this.$parent.gutter) || 0;
    },
    style: function style() {
      var padding = this.gutter / 2 + "px";
      return this.gutter ? {
        paddingLeft: padding,
        paddingRight: padding
      } : {};
    }
  },
  render: function render(h) {
    var _bem;

    var span = this.span,
        offset = this.offset;
    return h(this.tag, {
      "class": bem((_bem = {}, _bem[span] = span, _bem["offset-" + offset] = offset, _bem)),
      "style": this.style
    }, [this.slots()]);
  }
});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(298);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(299);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-stepper{font-size:0}.van-stepper__minus,.van-stepper__plus{width:28px;height:28px;box-sizing:border-box;background-color:#f2f3f5;border:0;margin:1px;position:relative;padding:5px;vertical-align:middle}.van-stepper__minus:before,.van-stepper__plus:before{width:9px;height:1px}.van-stepper__minus:after,.van-stepper__plus:after{width:1px;height:9px}.van-stepper__minus:after,.van-stepper__minus:before,.van-stepper__plus:after,.van-stepper__plus:before{content:\"\";position:absolute;margin:auto;top:0;left:0;right:0;bottom:0;background-color:#323233}.van-stepper__minus:active,.van-stepper__plus:active{background-color:#e8e8e8}.van-stepper__minus--disabled,.van-stepper__minus--disabled:active,.van-stepper__plus--disabled,.van-stepper__plus--disabled:active{background-color:#f7f8fa}.van-stepper__minus--disabled:after,.van-stepper__minus--disabled:before,.van-stepper__plus--disabled:after,.van-stepper__plus--disabled:before{background-color:#c8c9cc}.van-stepper__minus{border-radius:4px 0 0 4px}.van-stepper__minus:after{display:none}.van-stepper__plus{border-radius:0 4px 4px 0}.van-stepper__input{width:30px;height:26px;padding:1px;border:0;margin:1px;background-color:#f2f3f5;border-width:1px 0;border-radius:0;box-sizing:content-box;color:#323233;font-size:14px;vertical-align:middle;text-align:center;-webkit-appearance:none}.van-stepper__input[disabled]{color:#c8c9cc;background-color:#f2f3f5}.van-stepper input[type=number]::-webkit-inner-spin-button,.van-stepper input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(301);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(302);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-row:after{content:\"\";display:table;clear:both}.van-row--flex{display:-webkit-box;display:-webkit-flex;display:flex}.van-row--flex:after{display:none}.van-row--justify-center{-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}.van-row--justify-end{-webkit-box-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end}.van-row--justify-space-between{-webkit-box-pack:justify;-webkit-justify-content:space-between;justify-content:space-between}.van-row--justify-space-around{-webkit-justify-content:space-around;justify-content:space-around}.van-row--align-center{-webkit-box-align:center;-webkit-align-items:center;align-items:center}.van-row--align-bottom{-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end}", ""]);

// exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(304);

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(305);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-col{float:left;min-height:1px;box-sizing:border-box}.van-col--1{width:4.16666667%}.van-col--offset-1{margin-left:4.16666667%}.van-col--2{width:8.33333333%}.van-col--offset-2{margin-left:8.33333333%}.van-col--3{width:12.5%}.van-col--offset-3{margin-left:12.5%}.van-col--4{width:16.66666667%}.van-col--offset-4{margin-left:16.66666667%}.van-col--5{width:20.83333333%}.van-col--offset-5{margin-left:20.83333333%}.van-col--6{width:25%}.van-col--offset-6{margin-left:25%}.van-col--7{width:29.16666667%}.van-col--offset-7{margin-left:29.16666667%}.van-col--8{width:33.33333333%}.van-col--offset-8{margin-left:33.33333333%}.van-col--9{width:37.5%}.van-col--offset-9{margin-left:37.5%}.van-col--10{width:41.66666667%}.van-col--offset-10{margin-left:41.66666667%}.van-col--11{width:45.83333333%}.van-col--offset-11{margin-left:45.83333333%}.van-col--12{width:50%}.van-col--offset-12{margin-left:50%}.van-col--13{width:54.16666667%}.van-col--offset-13{margin-left:54.16666667%}.van-col--14{width:58.33333333%}.van-col--offset-14{margin-left:58.33333333%}.van-col--15{width:62.5%}.van-col--offset-15{margin-left:62.5%}.van-col--16{width:66.66666667%}.van-col--offset-16{margin-left:66.66666667%}.van-col--17{width:70.83333333%}.van-col--offset-17{margin-left:70.83333333%}.van-col--18{width:75%}.van-col--offset-18{margin-left:75%}.van-col--19{width:79.16666667%}.van-col--offset-19{margin-left:79.16666667%}.van-col--20{width:83.33333333%}.van-col--offset-20{margin-left:83.33333333%}.van-col--21{width:87.5%}.van-col--offset-21{margin-left:87.5%}.van-col--22{width:91.66666667%}.van-col--offset-22{margin-left:91.66666667%}.van-col--23{width:95.83333333%}.van-col--offset-23{margin-left:95.83333333%}.van-col--24{width:100%}.van-col--offset-24{margin-left:100%}", ""]);

// exports


/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gitfAlertView"
    }
  }, [_c('div', {
    staticClass: "gitbottomView"
  }, [_c('van-row', _vm._l((_vm.giftList), function(item, index) {
    return _c('van-col', {
      key: index,
      attrs: {
        "span": "6"
      }
    }, [_c('div', {
      staticClass: "list",
      class: index == _vm.selected ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.selectGiftAction(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "money"
    }, [_vm._v(_vm._s(item.price / 100)), _c('span', [_vm._v("元")])])])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "paybar"
  }, [_c('div', {
    staticClass: "paynumber"
  }, [_c('span', [_vm._v("数量")]), _vm._v(" "), _c('van-stepper', {
    attrs: {
      "min": 1,
      "max": 10000,
      "step": 1
    },
    on: {
      "change": _vm.changeOnClick
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "paybutton"
  }, [_c('span', {
    staticClass: "cost"
  }, [_vm._v("合计: " + _vm._s(_vm.sumMoney) + "元")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.bugGifAction()
      }
    }
  }, [_vm._v("支付")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelTask = exports.cosUploadFile = undefined;

var _cosJsSdkV = __webpack_require__(308);

var _cosJsSdkV2 = _interopRequireDefault(_cosJsSdkV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var cos = null;
var taskId = null;
cos = new _cosJsSdkV2.default({
  getAuthorization: function getAuthorization(options, callback) {
    var url = 'https://online.tenghuiwangxiao.cn/common/index/getCosSign';
    console.log(url);
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function (e) {
      console.log(e);
      try {
        var data = JSON.parse(e.target.responseText);
        var credentials = data.data.credentials;
      } catch (e) {
        console.log(e);
      }
      if (!data || !credentials) {
        return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2));
      }
      // eslint-disable-next-line standard/no-callback-literal
      callback({
        TmpSecretId: credentials.tmpSecretId,
        TmpSecretKey: credentials.tmpSecretKey,
        SecurityToken: credentials.sessionToken,
        StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.data.expiredTime // 时间戳，单位秒，如：1580000000
      });
    };
    xhr.send();
  },
  UseAccelerate: true
});

function randomString(len) {
  len = len || 8;
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = chars.length;
  var pwd = '';
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

function cosUploadFile(file, uid, callback, fileName) {
  var _this = this;

  console.log('file', file);
  return new Promise(function (resolve) {
    var time = new Date();
    var y = time.getFullYear();
    var m = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1);
    var d = time.getDate() > 9 ? time.getDate() : '0' + time.getDate();
    var name = fileName || file.name;
    var fileNameTmp = randomString() + '_' + name;
    var uploadPath = '/uploads/' + uid + '/' + y + '/' + m + '/' + d;
    var storeAs = uploadPath + '/' + fileNameTmp;
    cos.uploadFile({
      Bucket: 'tengface-live-user-1308721187',
      /* 填入您自己的存储桶，必须字段 */
      Region: 'ap-guangzhou',
      /* 存储桶所在地域，例如ap-beijing，必须字段 */
      Key: storeAs,
      /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
      StorageClass: 'STANDARD',
      Body: file, // 上传文件对象
      onTaskReady: function onTaskReady(id) {
        /* 非必须 */
        // this.form.file[0].taskId = taskId
        taskId = id;
      },
      onProgress: function onProgress(progressData) {
        if (callback) {
          callback(progressData, file.name);
        }
      }
    }, function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err, data) {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data.statusCode === 200) {
                  url = 'https://' + data.Location;

                  resolve(url);
                  taskId = null;
                }
                if (err) {
                  console.log(err);
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  });
}

function cancelTask() {
  if (taskId) {
    cos.cancelTask(taskId);
  }
}

exports.cosUploadFile = cosUploadFile;
exports.cancelTask = cancelTask;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _createClass2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof2(exports)) === 'object' && ( false ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["COS"] = factory();else root["COS"] = factory();
})(undefined, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
          /******/
        }
        /******/Object.defineProperty(exports, '__esModule', { value: true });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/__webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/if (mode & 8) return value;
        /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === 'object' && value && value.__esModule) return value;
        /******/var ns = Object.create(null);
        /******/__webpack_require__.r(ns);
        /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
        /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        } /******/return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "/dist/";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = "./index.js");
      /******/
    }(
    /************************************************************************/
    /******/{

      /***/"./index.js":
      /*!******************!*\
        !*** ./index.js ***!
        \******************/
      /*! no static exports found */
      /***/function indexJs(module, exports, __webpack_require__) {

        var COS = __webpack_require__( /*! ./src/cos */"./src/cos.js");
        module.exports = COS;

        /***/
      },

      /***/"./lib/base64.js":
      /*!***********************!*\
        !*** ./lib/base64.js ***!
        \***********************/
      /*! no static exports found */
      /***/function libBase64Js(module, exports) {

        /*
         * $Id: base64.js,v 2.15 2014/04/05 12:58:57 dankogai Exp dankogai $
         *
         *  Licensed under the BSD 3-Clause License.
         *    http://opensource.org/licenses/BSD-3-Clause
         *
         *  References:
         *    http://en.wikipedia.org/wiki/Base64
         */

        var Base64 = function (global) {
          global = global || {};
          'use strict';
          // existing version for noConflict()
          var _Base64 = global.Base64;
          var version = "2.1.9";
          // if node.js, we use Buffer
          var buffer;
          // constants
          var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
          var b64tab = function (bin) {
            var t = {};
            for (var i = 0, l = bin.length; i < l; i++) {
              t[bin.charAt(i)] = i;
            }return t;
          }(b64chars);
          var fromCharCode = String.fromCharCode;
          // encoder stuff
          var cb_utob = function cb_utob(c) {
            if (c.length < 2) {
              var cc = c.charCodeAt(0);
              return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
            } else {
              var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
              return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
            }
          };
          var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
          var utob = function utob(u) {
            return u.replace(re_utob, cb_utob);
          };
          var cb_encode = function cb_encode(ccc) {
            var padlen = [0, 2, 1][ccc.length % 3],
                ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0),
                chars = [b64chars.charAt(ord >>> 18), b64chars.charAt(ord >>> 12 & 63), padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63), padlen >= 1 ? '=' : b64chars.charAt(ord & 63)];
            return chars.join('');
          };
          var btoa = global.btoa ? function (b) {
            return global.btoa(b);
          } : function (b) {
            return b.replace(/[\s\S]{1,3}/g, cb_encode);
          };
          var _encode = buffer ? function (u) {
            return (u.constructor === buffer.constructor ? u : new buffer(u)).toString('base64');
          } : function (u) {
            return btoa(utob(u));
          };
          var encode = function encode(u, urisafe) {
            return !urisafe ? _encode(String(u)) : _encode(String(u)).replace(/[+\/]/g, function (m0) {
              return m0 == '+' ? '-' : '_';
            }).replace(/=/g, '');
          };
          var encodeURI = function encodeURI(u) {
            return encode(u, true);
          };
          // decoder stuff
          var re_btou = new RegExp(['[\xC0-\xDF][\x80-\xBF]', '[\xE0-\xEF][\x80-\xBF]{2}', '[\xF0-\xF7][\x80-\xBF]{3}'].join('|'), 'g');
          var cb_btou = function cb_btou(cccc) {
            switch (cccc.length) {
              case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3),
                    offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
              case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
              default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
            }
          };
          var btou = function btou(b) {
            return b.replace(re_btou, cb_btou);
          };
          var cb_decode = function cb_decode(cccc) {
            var len = cccc.length,
                padlen = len % 4,
                n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0),
                chars = [fromCharCode(n >>> 16), fromCharCode(n >>> 8 & 0xff), fromCharCode(n & 0xff)];
            chars.length -= [0, 0, 2, 1][padlen];
            return chars.join('');
          };
          var atob = global.atob ? function (a) {
            return global.atob(a);
          } : function (a) {
            return a.replace(/[\s\S]{1,4}/g, cb_decode);
          };
          var _decode = buffer ? function (a) {
            return (a.constructor === buffer.constructor ? a : new buffer(a, 'base64')).toString();
          } : function (a) {
            return btou(atob(a));
          };
          var decode = function decode(a) {
            return _decode(String(a).replace(/[-_]/g, function (m0) {
              return m0 == '-' ? '+' : '/';
            }).replace(/[^A-Za-z0-9\+\/]/g, ''));
          };
          var noConflict = function noConflict() {
            var Base64 = global.Base64;
            global.Base64 = _Base64;
            return Base64;
          };
          // export Base64
          var Base64 = {
            VERSION: version,
            atob: atob,
            btoa: btoa,
            fromBase64: decode,
            toBase64: encode,
            utob: utob,
            encode: encode,
            encodeURI: encodeURI,
            btou: btou,
            decode: decode,
            noConflict: noConflict
          };
          return Base64;
        }();
        module.exports = Base64;

        /***/
      },

      /***/"./lib/crypto.js":
      /*!***********************!*\
        !*** ./lib/crypto.js ***!
        \***********************/
      /*! no static exports found */
      /***/function libCryptoJs(module, exports, __webpack_require__) {

        /* WEBPACK VAR INJECTION */(function (module) {
          var _typeof = __webpack_require__( /*! @babel/runtime/helpers/typeof */"./node_modules/@babel/runtime/helpers/typeof.js");
          /*
           CryptoJS v3.1.2
           code.google.com/p/crypto-js
           (c) 2009-2013 by Jeff Mott. All rights reserved.
           code.google.com/p/crypto-js/wiki/License
           */
          var CryptoJS = CryptoJS || function (g, l) {
            var e = {},
                d = e.lib = {},
                m = function m() {},
                k = d.Base = {
              extend: function extend(a) {
                m.prototype = this;
                var c = new m();
                a && c.mixIn(a);
                c.hasOwnProperty("init") || (c.init = function () {
                  c.$super.init.apply(this, arguments);
                });
                c.init.prototype = c;
                c.$super = this;
                return c;
              },
              create: function create() {
                var a = this.extend();
                a.init.apply(a, arguments);
                return a;
              },
              init: function init() {},
              mixIn: function mixIn(a) {
                for (var c in a) {
                  a.hasOwnProperty(c) && (this[c] = a[c]);
                }a.hasOwnProperty("toString") && (this.toString = a.toString);
              },
              clone: function clone() {
                return this.init.prototype.extend(this);
              }
            },
                p = d.WordArray = k.extend({
              init: function init(a, c) {
                a = this.words = a || [];
                this.sigBytes = c != l ? c : 4 * a.length;
              },
              toString: function toString(a) {
                return (a || n).stringify(this);
              },
              concat: function concat(a) {
                var c = this.words,
                    q = a.words,
                    f = this.sigBytes;
                a = a.sigBytes;
                this.clamp();
                if (f % 4) for (var b = 0; b < a; b++) {
                  c[f + b >>> 2] |= (q[b >>> 2] >>> 24 - 8 * (b % 4) & 255) << 24 - 8 * ((f + b) % 4);
                } else if (65535 < q.length) for (b = 0; b < a; b += 4) {
                  c[f + b >>> 2] = q[b >>> 2];
                } else c.push.apply(c, q);
                this.sigBytes += a;
                return this;
              },
              clamp: function clamp() {
                var a = this.words,
                    c = this.sigBytes;
                a[c >>> 2] &= 4294967295 << 32 - 8 * (c % 4);
                a.length = g.ceil(c / 4);
              },
              clone: function clone() {
                var a = k.clone.call(this);
                a.words = this.words.slice(0);
                return a;
              },
              random: function random(a) {
                for (var c = [], b = 0; b < a; b += 4) {
                  c.push(4294967296 * g.random() | 0);
                }return new p.init(c, a);
              }
            }),
                b = e.enc = {},
                n = b.Hex = {
              stringify: function stringify(a) {
                var c = a.words;
                a = a.sigBytes;
                for (var b = [], f = 0; f < a; f++) {
                  var d = c[f >>> 2] >>> 24 - 8 * (f % 4) & 255;
                  b.push((d >>> 4).toString(16));
                  b.push((d & 15).toString(16));
                }
                return b.join("");
              },
              parse: function parse(a) {
                for (var c = a.length, b = [], f = 0; f < c; f += 2) {
                  b[f >>> 3] |= parseInt(a.substr(f, 2), 16) << 24 - 4 * (f % 8);
                }return new p.init(b, c / 2);
              }
            },
                j = b.Latin1 = {
              stringify: function stringify(a) {
                var c = a.words;
                a = a.sigBytes;
                for (var b = [], f = 0; f < a; f++) {
                  b.push(String.fromCharCode(c[f >>> 2] >>> 24 - 8 * (f % 4) & 255));
                }return b.join("");
              },
              parse: function parse(a) {
                for (var c = a.length, b = [], f = 0; f < c; f++) {
                  b[f >>> 2] |= (a.charCodeAt(f) & 255) << 24 - 8 * (f % 4);
                }return new p.init(b, c);
              }
            },
                h = b.Utf8 = {
              stringify: function stringify(a) {
                try {
                  return decodeURIComponent(escape(j.stringify(a)));
                } catch (c) {
                  throw Error("Malformed UTF-8 data");
                }
              },
              parse: function parse(a) {
                return j.parse(unescape(encodeURIComponent(a)));
              }
            },
                r = d.BufferedBlockAlgorithm = k.extend({
              reset: function reset() {
                this._data = new p.init();
                this._nDataBytes = 0;
              },
              _append: function _append(a) {
                "string" == typeof a && (a = h.parse(a));
                this._data.concat(a);
                this._nDataBytes += a.sigBytes;
              },
              _process: function _process(a) {
                var c = this._data,
                    b = c.words,
                    f = c.sigBytes,
                    d = this.blockSize,
                    e = f / (4 * d),
                    e = a ? g.ceil(e) : g.max((e | 0) - this._minBufferSize, 0);
                a = e * d;
                f = g.min(4 * a, f);
                if (a) {
                  for (var k = 0; k < a; k += d) {
                    this._doProcessBlock(b, k);
                  }k = b.splice(0, a);
                  c.sigBytes -= f;
                }
                return new p.init(k, f);
              },
              clone: function clone() {
                var a = k.clone.call(this);
                a._data = this._data.clone();
                return a;
              },
              _minBufferSize: 0
            });
            d.Hasher = r.extend({
              cfg: k.extend(),
              init: function init(a) {
                this.cfg = this.cfg.extend(a);
                this.reset();
              },
              reset: function reset() {
                r.reset.call(this);
                this._doReset();
              },
              update: function update(a) {
                this._append(a);
                this._process();
                return this;
              },
              finalize: function finalize(a) {
                a && this._append(a);
                return this._doFinalize();
              },
              blockSize: 16,
              _createHelper: function _createHelper(a) {
                return function (b, d) {
                  return new a.init(d).finalize(b);
                };
              },
              _createHmacHelper: function _createHmacHelper(a) {
                return function (b, d) {
                  return new s.HMAC.init(a, d).finalize(b);
                };
              }
            });
            var s = e.algo = {};
            return e;
          }(Math);
          (function () {
            var g = CryptoJS,
                l = g.lib,
                e = l.WordArray,
                d = l.Hasher,
                m = [],
                l = g.algo.SHA1 = d.extend({
              _doReset: function _doReset() {
                this._hash = new e.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
              },
              _doProcessBlock: function _doProcessBlock(d, e) {
                for (var b = this._hash.words, n = b[0], j = b[1], h = b[2], g = b[3], l = b[4], a = 0; 80 > a; a++) {
                  if (16 > a) m[a] = d[e + a] | 0;else {
                    var c = m[a - 3] ^ m[a - 8] ^ m[a - 14] ^ m[a - 16];
                    m[a] = c << 1 | c >>> 31;
                  }
                  c = (n << 5 | n >>> 27) + l + m[a];
                  c = 20 > a ? c + ((j & h | ~j & g) + 1518500249) : 40 > a ? c + ((j ^ h ^ g) + 1859775393) : 60 > a ? c + ((j & h | j & g | h & g) - 1894007588) : c + ((j ^ h ^ g) - 899497514);
                  l = g;
                  g = h;
                  h = j << 30 | j >>> 2;
                  j = n;
                  n = c;
                }
                b[0] = b[0] + n | 0;
                b[1] = b[1] + j | 0;
                b[2] = b[2] + h | 0;
                b[3] = b[3] + g | 0;
                b[4] = b[4] + l | 0;
              },
              _doFinalize: function _doFinalize() {
                var d = this._data,
                    e = d.words,
                    b = 8 * this._nDataBytes,
                    g = 8 * d.sigBytes;
                e[g >>> 5] |= 128 << 24 - g % 32;
                e[(g + 64 >>> 9 << 4) + 14] = Math.floor(b / 4294967296);
                e[(g + 64 >>> 9 << 4) + 15] = b;
                d.sigBytes = 4 * e.length;
                this._process();
                return this._hash;
              },
              clone: function clone() {
                var e = d.clone.call(this);
                e._hash = this._hash.clone();
                return e;
              }
            });
            g.SHA1 = d._createHelper(l);
            g.HmacSHA1 = d._createHmacHelper(l);
          })();
          (function () {
            var g = CryptoJS,
                l = g.enc.Utf8;
            g.algo.HMAC = g.lib.Base.extend({
              init: function init(e, d) {
                e = this._hasher = new e.init();
                "string" == typeof d && (d = l.parse(d));
                var g = e.blockSize,
                    k = 4 * g;
                d.sigBytes > k && (d = e.finalize(d));
                d.clamp();
                for (var p = this._oKey = d.clone(), b = this._iKey = d.clone(), n = p.words, j = b.words, h = 0; h < g; h++) {
                  n[h] ^= 1549556828, j[h] ^= 909522486;
                }p.sigBytes = b.sigBytes = k;
                this.reset();
              },
              reset: function reset() {
                var e = this._hasher;
                e.reset();
                e.update(this._iKey);
              },
              update: function update(e) {
                this._hasher.update(e);
                return this;
              },
              finalize: function finalize(e) {
                var d = this._hasher;
                e = d.finalize(e);
                d.reset();
                return d.finalize(this._oKey.clone().concat(e));
              }
            });
          })();
          (function () {
            // Shortcuts
            var C = CryptoJS;
            var C_lib = C.lib;
            var WordArray = C_lib.WordArray;
            var C_enc = C.enc;

            /**
             * Base64 encoding strategy.
             */
            var Base64 = C_enc.Base64 = {
              /**
               * Converts a word array to a Base64 string.
               *
               * @param {WordArray} wordArray The word array.
               *
               * @return {string} The Base64 string.
               *
               * @static
               *
               * @example
               *
               *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
               */
              stringify: function stringify(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;

                // Clamp excess bits
                wordArray.clamp();

                // Convert
                var base64Chars = [];
                for (var i = 0; i < sigBytes; i += 3) {
                  var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                  var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                  var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                  var triplet = byte1 << 16 | byte2 << 8 | byte3;
                  for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
                    base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                  }
                }

                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                  while (base64Chars.length % 4) {
                    base64Chars.push(paddingChar);
                  }
                }
                return base64Chars.join('');
              },
              /**
               * Converts a Base64 string to a word array.
               *
               * @param {string} base64Str The Base64 string.
               *
               * @return {WordArray} The word array.
               *
               * @static
               *
               * @example
               *
               *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
               */
              parse: function parse(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;

                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                  var paddingIndex = base64Str.indexOf(paddingChar);
                  if (paddingIndex != -1) {
                    base64StrLength = paddingIndex;
                  }
                }

                // Convert
                var words = [];
                var nBytes = 0;
                for (var i = 0; i < base64StrLength; i++) {
                  if (i % 4) {
                    var bits1 = map.indexOf(base64Str.charAt(i - 1)) << i % 4 * 2;
                    var bits2 = map.indexOf(base64Str.charAt(i)) >>> 6 - i % 4 * 2;
                    words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
                    nBytes++;
                  }
                }
                return WordArray.create(words, nBytes);
              },
              _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
            };
          })();
          if ((false ? undefined : _typeof(module)) === 'object') {
            module.exports = CryptoJS;
          } else {
            window.CryptoJS = CryptoJS;
          }
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__( /*! ./../node_modules/webpack/buildin/module.js */"./node_modules/webpack/buildin/module.js")(module));

        /***/
      },

      /***/"./lib/md5.js":
      /*!********************!*\
        !*** ./lib/md5.js ***!
        \********************/
      /*! no static exports found */
      /***/function libMd5Js(module, exports, __webpack_require__) {

        /* WEBPACK VAR INJECTION */(function (module) {
          var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = __webpack_require__( /*! @babel/runtime/helpers/typeof */"./node_modules/@babel/runtime/helpers/typeof.js");
          /* https://github.com/emn178/js-md5 */
          (function () {
            'use strict';

            var WINDOW = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
            var root = WINDOW ? window : {};
            if (root.JS_MD5_NO_WINDOW) {
              WINDOW = false;
            }
            var WEB_WORKER = !WINDOW && (typeof self === "undefined" ? "undefined" : _typeof(self)) === 'object';
            if (WEB_WORKER) {
              root = self;
            }
            var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && (false ? undefined : _typeof(module)) === 'object' && module.exports;
            var AMD = true && __webpack_require__( /*! !webpack amd options */"./node_modules/webpack/buildin/amd-options.js");
            var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
            var HEX_CHARS = '0123456789abcdef'.split('');
            var EXTRA = [128, 32768, 8388608, -2147483648];
            var SHIFT = [0, 8, 16, 24];
            var OUTPUT_TYPES = ['hex', 'array', 'digest', 'buffer', 'arrayBuffer', 'base64'];
            var BASE64_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
            var blocks = [],
                buffer8;
            if (ARRAY_BUFFER) {
              var buffer = new ArrayBuffer(68);
              buffer8 = new Uint8Array(buffer);
              blocks = new Uint32Array(buffer);
            }
            if (root.JS_MD5_NO_NODE_JS || !Array.isArray) {
              Array.isArray = function (obj) {
                return Object.prototype.toString.call(obj) === '[object Array]';
              };
            }
            if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
              ArrayBuffer.isView = function (obj) {
                return _typeof(obj) === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
              };
            }

            /**
             * @method hex
             * @memberof md5
             * @description Output hash as hex string
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {String} Hex string
             * @example
             * md5.hex('The quick brown fox jumps over the lazy dog');
             * // equal to
             * md5('The quick brown fox jumps over the lazy dog');
             */
            /**
             * @method digest
             * @memberof md5
             * @description Output hash as bytes array
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {Array} Bytes array
             * @example
             * md5.digest('The quick brown fox jumps over the lazy dog');
             */
            /**
             * @method array
             * @memberof md5
             * @description Output hash as bytes array
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {Array} Bytes array
             * @example
             * md5.array('The quick brown fox jumps over the lazy dog');
             */
            /**
             * @method arrayBuffer
             * @memberof md5
             * @description Output hash as ArrayBuffer
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {ArrayBuffer} ArrayBuffer
             * @example
             * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
             */
            /**
             * @method buffer
             * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
             * @memberof md5
             * @description Output hash as ArrayBuffer
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {ArrayBuffer} ArrayBuffer
             * @example
             * md5.buffer('The quick brown fox jumps over the lazy dog');
             */
            /**
             * @method base64
             * @memberof md5
             * @description Output hash as base64 string
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {String} base64 string
             * @example
             * md5.base64('The quick brown fox jumps over the lazy dog');
             */
            var createOutputMethod = function createOutputMethod(outputType) {
              return function (message, isBinStr) {
                return new Md5(true).update(message, isBinStr)[outputType]();
              };
            };

            /**
             * @method create
             * @memberof md5
             * @description Create Md5 object
             * @returns {Md5} Md5 object.
             * @example
             * var hash = md5.create();
             */
            /**
             * @method update
             * @memberof md5
             * @description Create and update Md5 object
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {Md5} Md5 object.
             * @example
             * var hash = md5.update('The quick brown fox jumps over the lazy dog');
             * // equal to
             * var hash = md5.create();
             * hash.update('The quick brown fox jumps over the lazy dog');
             */
            var createMethod = function createMethod() {
              var method = createOutputMethod('hex');
              method.getCtx = method.create = function () {
                return new Md5();
              };
              method.update = function (message) {
                return method.create().update(message);
              };
              for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
                var type = OUTPUT_TYPES[i];
                method[type] = createOutputMethod(type);
              }
              return method;
            };

            /**
             * Md5 class
             * @class Md5
             * @description This is internal class.
             * @see {@link md5.create}
             */
            function Md5(sharedMemory) {
              if (sharedMemory) {
                blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
                this.blocks = blocks;
                this.buffer8 = buffer8;
              } else {
                if (ARRAY_BUFFER) {
                  var buffer = new ArrayBuffer(68);
                  this.buffer8 = new Uint8Array(buffer);
                  this.blocks = new Uint32Array(buffer);
                } else {
                  this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                }
              }
              this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
              this.finalized = this.hashed = false;
              this.first = true;
            }

            /**
             * @method update
             * @memberof Md5
             * @instance
             * @description Update hash
             * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
             * @returns {Md5} Md5 object.
             * @see {@link md5.update}
             */
            Md5.prototype.update = function (message, isBinStr) {
              if (this.finalized) {
                return;
              }
              var code,
                  index = 0,
                  i,
                  length = message.length,
                  blocks = this.blocks;
              var buffer8 = this.buffer8;
              while (index < length) {
                if (this.hashed) {
                  this.hashed = false;
                  blocks[0] = blocks[16];
                  blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
                }
                if (ARRAY_BUFFER) {
                  for (i = this.start; index < length && i < 64; ++index) {
                    code = message.charCodeAt(index);
                    if (isBinStr || code < 0x80) {
                      buffer8[i++] = code;
                    } else if (code < 0x800) {
                      buffer8[i++] = 0xc0 | code >> 6;
                      buffer8[i++] = 0x80 | code & 0x3f;
                    } else if (code < 0xd800 || code >= 0xe000) {
                      buffer8[i++] = 0xe0 | code >> 12;
                      buffer8[i++] = 0x80 | code >> 6 & 0x3f;
                      buffer8[i++] = 0x80 | code & 0x3f;
                    } else {
                      code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                      buffer8[i++] = 0xf0 | code >> 18;
                      buffer8[i++] = 0x80 | code >> 12 & 0x3f;
                      buffer8[i++] = 0x80 | code >> 6 & 0x3f;
                      buffer8[i++] = 0x80 | code & 0x3f;
                    }
                  }
                } else {
                  for (i = this.start; index < length && i < 64; ++index) {
                    code = message.charCodeAt(index);
                    if (isBinStr || code < 0x80) {
                      blocks[i >> 2] |= code << SHIFT[i++ & 3];
                    } else if (code < 0x800) {
                      blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                      blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else if (code < 0xd800 || code >= 0xe000) {
                      blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                      blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                      blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else {
                      code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                      blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                      blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                      blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                      blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    }
                  }
                }
                this.lastByteIndex = i;
                this.bytes += i - this.start;
                if (i >= 64) {
                  this.start = i - 64;
                  this.hash();
                  this.hashed = true;
                } else {
                  this.start = i;
                }
              }
              if (this.bytes > 4294967295) {
                this.hBytes += this.bytes / 4294967296 << 0;
                this.bytes = this.bytes % 4294967296;
              }
              return this;
            };
            Md5.prototype.finalize = function () {
              if (this.finalized) {
                return;
              }
              this.finalized = true;
              var blocks = this.blocks,
                  i = this.lastByteIndex;
              blocks[i >> 2] |= EXTRA[i & 3];
              if (i >= 56) {
                if (!this.hashed) {
                  this.hash();
                }
                blocks[0] = blocks[16];
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
              }
              blocks[14] = this.bytes << 3;
              blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
              this.hash();
            };
            Md5.prototype.hash = function () {
              var a,
                  b,
                  c,
                  d,
                  bc,
                  da,
                  blocks = this.blocks;
              if (this.first) {
                a = blocks[0] - 680876937;
                a = (a << 7 | a >>> 25) - 271733879 << 0;
                d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
                d = (d << 12 | d >>> 20) + a << 0;
                c = (-271733879 ^ d & (a ^ -271733879)) + blocks[2] - 1126478375;
                c = (c << 17 | c >>> 15) + d << 0;
                b = (a ^ c & (d ^ a)) + blocks[3] - 1316259209;
                b = (b << 22 | b >>> 10) + c << 0;
              } else {
                a = this.h0;
                b = this.h1;
                c = this.h2;
                d = this.h3;
                a += (d ^ b & (c ^ d)) + blocks[0] - 680876936;
                a = (a << 7 | a >>> 25) + b << 0;
                d += (c ^ a & (b ^ c)) + blocks[1] - 389564586;
                d = (d << 12 | d >>> 20) + a << 0;
                c += (b ^ d & (a ^ b)) + blocks[2] + 606105819;
                c = (c << 17 | c >>> 15) + d << 0;
                b += (a ^ c & (d ^ a)) + blocks[3] - 1044525330;
                b = (b << 22 | b >>> 10) + c << 0;
              }
              a += (d ^ b & (c ^ d)) + blocks[4] - 176418897;
              a = (a << 7 | a >>> 25) + b << 0;
              d += (c ^ a & (b ^ c)) + blocks[5] + 1200080426;
              d = (d << 12 | d >>> 20) + a << 0;
              c += (b ^ d & (a ^ b)) + blocks[6] - 1473231341;
              c = (c << 17 | c >>> 15) + d << 0;
              b += (a ^ c & (d ^ a)) + blocks[7] - 45705983;
              b = (b << 22 | b >>> 10) + c << 0;
              a += (d ^ b & (c ^ d)) + blocks[8] + 1770035416;
              a = (a << 7 | a >>> 25) + b << 0;
              d += (c ^ a & (b ^ c)) + blocks[9] - 1958414417;
              d = (d << 12 | d >>> 20) + a << 0;
              c += (b ^ d & (a ^ b)) + blocks[10] - 42063;
              c = (c << 17 | c >>> 15) + d << 0;
              b += (a ^ c & (d ^ a)) + blocks[11] - 1990404162;
              b = (b << 22 | b >>> 10) + c << 0;
              a += (d ^ b & (c ^ d)) + blocks[12] + 1804603682;
              a = (a << 7 | a >>> 25) + b << 0;
              d += (c ^ a & (b ^ c)) + blocks[13] - 40341101;
              d = (d << 12 | d >>> 20) + a << 0;
              c += (b ^ d & (a ^ b)) + blocks[14] - 1502002290;
              c = (c << 17 | c >>> 15) + d << 0;
              b += (a ^ c & (d ^ a)) + blocks[15] + 1236535329;
              b = (b << 22 | b >>> 10) + c << 0;
              a += (c ^ d & (b ^ c)) + blocks[1] - 165796510;
              a = (a << 5 | a >>> 27) + b << 0;
              d += (b ^ c & (a ^ b)) + blocks[6] - 1069501632;
              d = (d << 9 | d >>> 23) + a << 0;
              c += (a ^ b & (d ^ a)) + blocks[11] + 643717713;
              c = (c << 14 | c >>> 18) + d << 0;
              b += (d ^ a & (c ^ d)) + blocks[0] - 373897302;
              b = (b << 20 | b >>> 12) + c << 0;
              a += (c ^ d & (b ^ c)) + blocks[5] - 701558691;
              a = (a << 5 | a >>> 27) + b << 0;
              d += (b ^ c & (a ^ b)) + blocks[10] + 38016083;
              d = (d << 9 | d >>> 23) + a << 0;
              c += (a ^ b & (d ^ a)) + blocks[15] - 660478335;
              c = (c << 14 | c >>> 18) + d << 0;
              b += (d ^ a & (c ^ d)) + blocks[4] - 405537848;
              b = (b << 20 | b >>> 12) + c << 0;
              a += (c ^ d & (b ^ c)) + blocks[9] + 568446438;
              a = (a << 5 | a >>> 27) + b << 0;
              d += (b ^ c & (a ^ b)) + blocks[14] - 1019803690;
              d = (d << 9 | d >>> 23) + a << 0;
              c += (a ^ b & (d ^ a)) + blocks[3] - 187363961;
              c = (c << 14 | c >>> 18) + d << 0;
              b += (d ^ a & (c ^ d)) + blocks[8] + 1163531501;
              b = (b << 20 | b >>> 12) + c << 0;
              a += (c ^ d & (b ^ c)) + blocks[13] - 1444681467;
              a = (a << 5 | a >>> 27) + b << 0;
              d += (b ^ c & (a ^ b)) + blocks[2] - 51403784;
              d = (d << 9 | d >>> 23) + a << 0;
              c += (a ^ b & (d ^ a)) + blocks[7] + 1735328473;
              c = (c << 14 | c >>> 18) + d << 0;
              b += (d ^ a & (c ^ d)) + blocks[12] - 1926607734;
              b = (b << 20 | b >>> 12) + c << 0;
              bc = b ^ c;
              a += (bc ^ d) + blocks[5] - 378558;
              a = (a << 4 | a >>> 28) + b << 0;
              d += (bc ^ a) + blocks[8] - 2022574463;
              d = (d << 11 | d >>> 21) + a << 0;
              da = d ^ a;
              c += (da ^ b) + blocks[11] + 1839030562;
              c = (c << 16 | c >>> 16) + d << 0;
              b += (da ^ c) + blocks[14] - 35309556;
              b = (b << 23 | b >>> 9) + c << 0;
              bc = b ^ c;
              a += (bc ^ d) + blocks[1] - 1530992060;
              a = (a << 4 | a >>> 28) + b << 0;
              d += (bc ^ a) + blocks[4] + 1272893353;
              d = (d << 11 | d >>> 21) + a << 0;
              da = d ^ a;
              c += (da ^ b) + blocks[7] - 155497632;
              c = (c << 16 | c >>> 16) + d << 0;
              b += (da ^ c) + blocks[10] - 1094730640;
              b = (b << 23 | b >>> 9) + c << 0;
              bc = b ^ c;
              a += (bc ^ d) + blocks[13] + 681279174;
              a = (a << 4 | a >>> 28) + b << 0;
              d += (bc ^ a) + blocks[0] - 358537222;
              d = (d << 11 | d >>> 21) + a << 0;
              da = d ^ a;
              c += (da ^ b) + blocks[3] - 722521979;
              c = (c << 16 | c >>> 16) + d << 0;
              b += (da ^ c) + blocks[6] + 76029189;
              b = (b << 23 | b >>> 9) + c << 0;
              bc = b ^ c;
              a += (bc ^ d) + blocks[9] - 640364487;
              a = (a << 4 | a >>> 28) + b << 0;
              d += (bc ^ a) + blocks[12] - 421815835;
              d = (d << 11 | d >>> 21) + a << 0;
              da = d ^ a;
              c += (da ^ b) + blocks[15] + 530742520;
              c = (c << 16 | c >>> 16) + d << 0;
              b += (da ^ c) + blocks[2] - 995338651;
              b = (b << 23 | b >>> 9) + c << 0;
              a += (c ^ (b | ~d)) + blocks[0] - 198630844;
              a = (a << 6 | a >>> 26) + b << 0;
              d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
              d = (d << 10 | d >>> 22) + a << 0;
              c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
              c = (c << 15 | c >>> 17) + d << 0;
              b += (d ^ (c | ~a)) + blocks[5] - 57434055;
              b = (b << 21 | b >>> 11) + c << 0;
              a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
              a = (a << 6 | a >>> 26) + b << 0;
              d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
              d = (d << 10 | d >>> 22) + a << 0;
              c += (a ^ (d | ~b)) + blocks[10] - 1051523;
              c = (c << 15 | c >>> 17) + d << 0;
              b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
              b = (b << 21 | b >>> 11) + c << 0;
              a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
              a = (a << 6 | a >>> 26) + b << 0;
              d += (b ^ (a | ~c)) + blocks[15] - 30611744;
              d = (d << 10 | d >>> 22) + a << 0;
              c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
              c = (c << 15 | c >>> 17) + d << 0;
              b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
              b = (b << 21 | b >>> 11) + c << 0;
              a += (c ^ (b | ~d)) + blocks[4] - 145523070;
              a = (a << 6 | a >>> 26) + b << 0;
              d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
              d = (d << 10 | d >>> 22) + a << 0;
              c += (a ^ (d | ~b)) + blocks[2] + 718787259;
              c = (c << 15 | c >>> 17) + d << 0;
              b += (d ^ (c | ~a)) + blocks[9] - 343485551;
              b = (b << 21 | b >>> 11) + c << 0;
              if (this.first) {
                this.h0 = a + 1732584193 << 0;
                this.h1 = b - 271733879 << 0;
                this.h2 = c - 1732584194 << 0;
                this.h3 = d + 271733878 << 0;
                this.first = false;
              } else {
                this.h0 = this.h0 + a << 0;
                this.h1 = this.h1 + b << 0;
                this.h2 = this.h2 + c << 0;
                this.h3 = this.h3 + d << 0;
              }
            };

            /**
             * @method hex
             * @memberof Md5
             * @instance
             * @description Output hash as hex string
             * @returns {String} Hex string
             * @see {@link md5.hex}
             * @example
             * hash.hex();
             */
            Md5.prototype.hex = function () {
              this.finalize();
              var h0 = this.h0,
                  h1 = this.h1,
                  h2 = this.h2,
                  h3 = this.h3;
              return HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F];
            };

            /**
             * @method toString
             * @memberof Md5
             * @instance
             * @description Output hash as hex string
             * @returns {String} Hex string
             * @see {@link md5.hex}
             * @example
             * hash.toString();
             */
            Md5.prototype.toString = Md5.prototype.hex;

            /**
             * @method digest
             * @memberof Md5
             * @instance
             * @description Output hash as bytes array
             * @returns {Array} Bytes array
             * @see {@link md5.digest}
             * @example
             * hash.digest();
             */
            Md5.prototype.digest = function (format) {
              if (format === 'hex') return this.hex();
              this.finalize();
              var h0 = this.h0,
                  h1 = this.h1,
                  h2 = this.h2,
                  h3 = this.h3;
              var res = [h0 & 0xFF, h0 >> 8 & 0xFF, h0 >> 16 & 0xFF, h0 >> 24 & 0xFF, h1 & 0xFF, h1 >> 8 & 0xFF, h1 >> 16 & 0xFF, h1 >> 24 & 0xFF, h2 & 0xFF, h2 >> 8 & 0xFF, h2 >> 16 & 0xFF, h2 >> 24 & 0xFF, h3 & 0xFF, h3 >> 8 & 0xFF, h3 >> 16 & 0xFF, h3 >> 24 & 0xFF];
              return res;
            };

            /**
             * @method array
             * @memberof Md5
             * @instance
             * @description Output hash as bytes array
             * @returns {Array} Bytes array
             * @see {@link md5.array}
             * @example
             * hash.array();
             */
            Md5.prototype.array = Md5.prototype.digest;

            /**
             * @method arrayBuffer
             * @memberof Md5
             * @instance
             * @description Output hash as ArrayBuffer
             * @returns {ArrayBuffer} ArrayBuffer
             * @see {@link md5.arrayBuffer}
             * @example
             * hash.arrayBuffer();
             */
            Md5.prototype.arrayBuffer = function () {
              this.finalize();
              var buffer = new ArrayBuffer(16);
              var blocks = new Uint32Array(buffer);
              blocks[0] = this.h0;
              blocks[1] = this.h1;
              blocks[2] = this.h2;
              blocks[3] = this.h3;
              return buffer;
            };

            /**
             * @method buffer
             * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
             * @memberof Md5
             * @instance
             * @description Output hash as ArrayBuffer
             * @returns {ArrayBuffer} ArrayBuffer
             * @see {@link md5.buffer}
             * @example
             * hash.buffer();
             */
            Md5.prototype.buffer = Md5.prototype.arrayBuffer;

            /**
             * @method base64
             * @memberof Md5
             * @instance
             * @description Output hash as base64 string
             * @returns {String} base64 string
             * @see {@link md5.base64}
             * @example
             * hash.base64();
             */
            Md5.prototype.base64 = function () {
              var v1,
                  v2,
                  v3,
                  base64Str = '',
                  bytes = this.array();
              for (var i = 0; i < 15;) {
                v1 = bytes[i++];
                v2 = bytes[i++];
                v3 = bytes[i++];
                base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] + BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] + BASE64_ENCODE_CHAR[v3 & 63];
              }
              v1 = bytes[i];
              base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[v1 << 4 & 63] + '==';
              return base64Str;
            };
            var exports = createMethod();
            if (COMMON_JS) {
              module.exports = exports;
            } else {
              /**
               * @method md5
               * @description Md5 hash function, export to global in browsers.
               * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
               * @returns {String} md5 hashes
               * @example
               * md5(''); // d41d8cd98f00b204e9800998ecf8427e
               * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
               * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
               *
               * // It also supports UTF-8 encoding
               * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
               *
               * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
               * md5([]); // d41d8cd98f00b204e9800998ecf8427e
               * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
               */
              root.md5 = exports;
              if (AMD) {
                !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                  return exports;
                }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
              }
            }
          })();
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__( /*! ./../node_modules/webpack/buildin/module.js */"./node_modules/webpack/buildin/module.js")(module));

        /***/
      },

      /***/"./lib/request.js":
      /*!************************!*\
        !*** ./lib/request.js ***!
        \************************/
      /*! no static exports found */
      /***/function libRequestJs(module, exports, __webpack_require__) {

        var _typeof = __webpack_require__( /*! @babel/runtime/helpers/typeof */"./node_modules/@babel/runtime/helpers/typeof.js");
        var stringifyPrimitive = function stringifyPrimitive(v) {
          switch (_typeof(v)) {
            case 'string':
              return v;
            case 'boolean':
              return v ? 'true' : 'false';
            case 'number':
              return isFinite(v) ? v : '';
            default:
              return '';
          }
        };
        var queryStringify = function queryStringify(obj, sep, eq, name) {
          sep = sep || '&';
          eq = eq || '=';
          if (obj === null) {
            obj = undefined;
          }
          if (_typeof(obj) === 'object') {
            return Object.keys(obj).map(function (k) {
              var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
              if (Array.isArray(obj[k])) {
                return obj[k].map(function (v) {
                  return ks + encodeURIComponent(stringifyPrimitive(v));
                }).join(sep);
              } else {
                return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
              }
            }).filter(Boolean).join(sep);
          }
          if (!name) return '';
          return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
        };
        var xhrRes = function xhrRes(err, xhr, body) {
          var headers = {};
          var strHeaders = xhr.getAllResponseHeaders();
          if (strHeaders && strHeaders.length > 0) {
            strHeaders.trim().split('\n').forEach(function (item) {
              if (item) {
                var index = item.indexOf(':');
                var key = item.substr(0, index).trim().toLowerCase();
                var val = item.substr(index + 1).trim();
                headers[key] = val;
              }
            });
          }
          return {
            error: err,
            statusCode: xhr.status,
            statusMessage: xhr.statusText,
            headers: headers,
            body: body
          };
        };
        var xhrBody = function xhrBody(xhr, dataType) {
          return !dataType && dataType === 'text' ? xhr.responseText : xhr.response;
        };
        var request = function request(opt, callback) {
          // method
          var method = (opt.method || 'GET').toUpperCase();

          // url、qs
          var url = opt.url;
          if (opt.qs) {
            var qsStr = queryStringify(opt.qs);
            if (qsStr) {
              url += (url.indexOf('?') === -1 ? '?' : '&') + qsStr;
            }
          }

          // 创建 ajax 实例
          var xhr = new XMLHttpRequest();
          xhr.open(method, url, true);
          xhr.responseType = opt.dataType || 'text';

          // 处理 xhrFields 属性
          if (opt.xhrFields) {
            for (var xhrField in opt.xhrFields) {
              xhr[xhrField] = opt.xhrFields[xhrField];
            }
          }

          // 处理 headers
          var headers = opt.headers;
          if (headers) {
            for (var key in headers) {
              if (headers.hasOwnProperty(key) && key.toLowerCase() !== 'content-length' && key.toLowerCase() !== 'user-agent' && key.toLowerCase() !== 'origin' && key.toLowerCase() !== 'host') {
                xhr.setRequestHeader(key, headers[key]);
              }
            }
          }

          // onprogress
          if (opt.onProgress && xhr.upload) xhr.upload.onprogress = opt.onProgress;
          if (opt.onDownloadProgress) xhr.onprogress = opt.onDownloadProgress;

          // timeout
          if (opt.timeout) xhr.timeout = opt.timeout;
          xhr.ontimeout = function (event) {
            var error = new Error('timeout');
            callback(xhrRes(error, xhr));
          };

          // success 2xx/3xx/4xx
          xhr.onload = function () {
            callback(xhrRes(null, xhr, xhrBody(xhr, opt.dataType)));
          };

          // error 5xx/0 (网络错误、跨域报错、Https connect-src 限制的报错时 statusCode 为 0)
          xhr.onerror = function (err) {
            var body = xhrBody(xhr, opt.dataType);
            if (body) {
              // 5xx
              callback(xhrRes(null, xhr, body));
            } else {
              // 0
              var error = xhr.statusText;
              if (!error && xhr.status === 0) error = new Error('CORS blocked or network error');
              callback(xhrRes(error, xhr, body));
            }
          };

          // send
          xhr.send(opt.body || '');

          // 返回 ajax 实例，用于外部调用 xhr.abort
          return xhr;
        };
        module.exports = request;

        /***/
      },

      /***/"./node_modules/@babel/runtime/helpers/classCallCheck.js":
      /*!***************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
        \***************************************************************/
      /*! no static exports found */
      /***/function node_modulesBabelRuntimeHelpersClassCallCheckJs(module, exports) {

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

        /***/
      },

      /***/"./node_modules/@babel/runtime/helpers/createClass.js":
      /*!************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
        \************************************************************/
      /*! no static exports found */
      /***/function node_modulesBabelRuntimeHelpersCreateClassJs(module, exports, __webpack_require__) {

        var toPropertyKey = __webpack_require__( /*! ./toPropertyKey.js */"./node_modules/@babel/runtime/helpers/toPropertyKey.js");
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          Object.defineProperty(Constructor, "prototype", {
            writable: false
          });
          return Constructor;
        }
        module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

        /***/
      },

      /***/"./node_modules/@babel/runtime/helpers/toPrimitive.js":
      /*!************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/toPrimitive.js ***!
        \************************************************************/
      /*! no static exports found */
      /***/function node_modulesBabelRuntimeHelpersToPrimitiveJs(module, exports, __webpack_require__) {

        var _typeof = __webpack_require__( /*! ./typeof.js */"./node_modules/@babel/runtime/helpers/typeof.js")["default"];
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

        /***/
      },

      /***/"./node_modules/@babel/runtime/helpers/toPropertyKey.js":
      /*!**************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/toPropertyKey.js ***!
        \**************************************************************/
      /*! no static exports found */
      /***/function node_modulesBabelRuntimeHelpersToPropertyKeyJs(module, exports, __webpack_require__) {

        var _typeof = __webpack_require__( /*! ./typeof.js */"./node_modules/@babel/runtime/helpers/typeof.js")["default"];
        var toPrimitive = __webpack_require__( /*! ./toPrimitive.js */"./node_modules/@babel/runtime/helpers/toPrimitive.js");
        function _toPropertyKey(arg) {
          var key = toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

        /***/
      },

      /***/"./node_modules/@babel/runtime/helpers/typeof.js":
      /*!*******************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
        \*******************************************************/
      /*! no static exports found */
      /***/function node_modulesBabelRuntimeHelpersTypeofJs(module, exports) {

        function _typeof(o) {
          "@babel/helpers - typeof";

          return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (o) {
            return typeof o === 'undefined' ? 'undefined' : _typeof2(o);
          } : function (o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o === 'undefined' ? 'undefined' : _typeof2(o);
          }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
        }
        module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/fxp.js":
      /*!*************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/fxp.js ***!
        \*************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcFxpJs(module, exports, __webpack_require__) {

        "use strict";

        var validator = __webpack_require__( /*! ./validator */"./node_modules/fast-xml-parser/src/validator.js");
        var XMLParser = __webpack_require__( /*! ./xmlparser/XMLParser */"./node_modules/fast-xml-parser/src/xmlparser/XMLParser.js");
        var XMLBuilder = __webpack_require__( /*! ./xmlbuilder/json2xml */"./node_modules/fast-xml-parser/src/xmlbuilder/json2xml.js");

        module.exports = {
          XMLParser: XMLParser,
          XMLValidator: validator,
          XMLBuilder: XMLBuilder

          /***/ };
      },

      /***/"./node_modules/fast-xml-parser/src/util.js":
      /*!**************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/util.js ***!
        \**************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcUtilJs(module, exports, __webpack_require__) {

        "use strict";

        var nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
        var nameChar = nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
        var nameRegexp = '[' + nameStartChar + '][' + nameChar + ']*';
        var regexName = new RegExp('^' + nameRegexp + '$');

        var getAllMatches = function getAllMatches(string, regex) {
          var matches = [];
          var match = regex.exec(string);
          while (match) {
            var allmatches = [];
            allmatches.startIndex = regex.lastIndex - match[0].length;
            var len = match.length;
            for (var index = 0; index < len; index++) {
              allmatches.push(match[index]);
            }
            matches.push(allmatches);
            match = regex.exec(string);
          }
          return matches;
        };

        var isName = function isName(string) {
          var match = regexName.exec(string);
          return !(match === null || typeof match === 'undefined');
        };

        exports.isExist = function (v) {
          return typeof v !== 'undefined';
        };

        exports.isEmptyObject = function (obj) {
          return Object.keys(obj).length === 0;
        };

        /**
         * Copy all the properties of a into b.
         * @param {*} target
         * @param {*} a
         */
        exports.merge = function (target, a, arrayMode) {
          if (a) {
            var keys = Object.keys(a); // will return an array of own properties
            var len = keys.length; //don't make it inline
            for (var i = 0; i < len; i++) {
              if (arrayMode === 'strict') {
                target[keys[i]] = [a[keys[i]]];
              } else {
                target[keys[i]] = a[keys[i]];
              }
            }
          }
        };
        /* exports.merge =function (b,a){
          return Object.assign(b,a);
        } */

        exports.getValue = function (v) {
          if (exports.isExist(v)) {
            return v;
          } else {
            return '';
          }
        };

        // const fakeCall = function(a) {return a;};
        // const fakeCallNoReturn = function() {};

        exports.isName = isName;
        exports.getAllMatches = getAllMatches;
        exports.nameRegexp = nameRegexp;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/validator.js":
      /*!*******************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/validator.js ***!
        \*******************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcValidatorJs(module, exports, __webpack_require__) {

        "use strict";

        var util = __webpack_require__( /*! ./util */"./node_modules/fast-xml-parser/src/util.js");

        var defaultOptions = {
          allowBooleanAttributes: false, //A tag can have attributes without any value
          unpairedTags: []
        };

        //const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
        exports.validate = function (xmlData, options) {
          options = Object.assign({}, defaultOptions, options);

          //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
          //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
          //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
          var tags = [];
          var tagFound = false;

          //indicates that the root tag has been closed (aka. depth 0 has been reached)
          var reachedRoot = false;

          if (xmlData[0] === '\uFEFF') {
            // check for byte order mark (BOM)
            xmlData = xmlData.substr(1);
          }

          for (var i = 0; i < xmlData.length; i++) {

            if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
              i += 2;
              i = readPI(xmlData, i);
              if (i.err) return i;
            } else if (xmlData[i] === '<') {
              //starting of tag
              //read until you reach to '>' avoiding any '>' in attribute value
              var tagStartPos = i;
              i++;

              if (xmlData[i] === '!') {
                i = readCommentAndCDATA(xmlData, i);
                continue;
              } else {
                var closingTag = false;
                if (xmlData[i] === '/') {
                  //closing tag
                  closingTag = true;
                  i++;
                }
                //read tagname
                var tagName = '';
                for (; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++) {
                  tagName += xmlData[i];
                }
                tagName = tagName.trim();
                //console.log(tagName);

                if (tagName[tagName.length - 1] === '/') {
                  //self closing tag without attributes
                  tagName = tagName.substring(0, tagName.length - 1);
                  //continue;
                  i--;
                }
                if (!validateTagName(tagName)) {
                  var msg = void 0;
                  if (tagName.trim().length === 0) {
                    msg = "Invalid space after '<'.";
                  } else {
                    msg = "Tag '" + tagName + "' is an invalid name.";
                  }
                  return getErrorObject('InvalidTag', msg, getLineNumberForPosition(xmlData, i));
                }

                var result = readAttributeStr(xmlData, i);
                if (result === false) {
                  return getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", getLineNumberForPosition(xmlData, i));
                }
                var attrStr = result.value;
                i = result.index;

                if (attrStr[attrStr.length - 1] === '/') {
                  //self closing tag
                  var attrStrStart = i - attrStr.length;
                  attrStr = attrStr.substring(0, attrStr.length - 1);
                  var isValid = validateAttributeString(attrStr, options);
                  if (isValid === true) {
                    tagFound = true;
                    //continue; //text may presents after self closing tag
                  } else {
                    //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                  }
                } else if (closingTag) {
                  if (!result.tagClosed) {
                    return getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", getLineNumberForPosition(xmlData, i));
                  } else if (attrStr.trim().length > 0) {
                    return getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, tagStartPos));
                  } else if (tags.length === 0) {
                    return getErrorObject('InvalidTag', "Closing tag '" + tagName + "' has not been opened.", getLineNumberForPosition(xmlData, tagStartPos));
                  } else {
                    var otg = tags.pop();
                    if (tagName !== otg.tagName) {
                      var openPos = getLineNumberForPosition(xmlData, otg.tagStartPos);
                      return getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", getLineNumberForPosition(xmlData, tagStartPos));
                    }

                    //when there are no more tags, we reached the root level.
                    if (tags.length == 0) {
                      reachedRoot = true;
                    }
                  }
                } else {
                  var _isValid = validateAttributeString(attrStr, options);
                  if (_isValid !== true) {
                    //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return getErrorObject(_isValid.err.code, _isValid.err.msg, getLineNumberForPosition(xmlData, i - attrStr.length + _isValid.err.line));
                  }

                  //if the root level has been reached before ...
                  if (reachedRoot === true) {
                    return getErrorObject('InvalidXml', 'Multiple possible root nodes found.', getLineNumberForPosition(xmlData, i));
                  } else if (options.unpairedTags.indexOf(tagName) !== -1) {
                    //don't push into stack
                  } else {
                    tags.push({ tagName: tagName, tagStartPos: tagStartPos });
                  }
                  tagFound = true;
                }

                //skip tag text value
                //It may include comments and CDATA value
                for (i++; i < xmlData.length; i++) {
                  if (xmlData[i] === '<') {
                    if (xmlData[i + 1] === '!') {
                      //comment or CADATA
                      i++;
                      i = readCommentAndCDATA(xmlData, i);
                      continue;
                    } else if (xmlData[i + 1] === '?') {
                      i = readPI(xmlData, ++i);
                      if (i.err) return i;
                    } else {
                      break;
                    }
                  } else if (xmlData[i] === '&') {
                    var afterAmp = validateAmpersand(xmlData, i);
                    if (afterAmp == -1) return getErrorObject('InvalidChar', "char '&' is not expected.", getLineNumberForPosition(xmlData, i));
                    i = afterAmp;
                  } else {
                    if (reachedRoot === true && !isWhiteSpace(xmlData[i])) {
                      return getErrorObject('InvalidXml', "Extra text at the end", getLineNumberForPosition(xmlData, i));
                    }
                  }
                } //end of reading tag text value
                if (xmlData[i] === '<') {
                  i--;
                }
              }
            } else {
              if (isWhiteSpace(xmlData[i])) {
                continue;
              }
              return getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", getLineNumberForPosition(xmlData, i));
            }
          }

          if (!tagFound) {
            return getErrorObject('InvalidXml', 'Start tag expected.', 1);
          } else if (tags.length == 1) {
            return getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", getLineNumberForPosition(xmlData, tags[0].tagStartPos));
          } else if (tags.length > 0) {
            return getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map(function (t) {
              return t.tagName;
            }), null, 4).replace(/\r?\n/g, '') + "' found.", { line: 1, col: 1 });
          }

          return true;
        };

        function isWhiteSpace(char) {
          return char === ' ' || char === '\t' || char === '\n' || char === '\r';
        }
        /**
         * Read Processing insstructions and skip
         * @param {*} xmlData
         * @param {*} i
         */
        function readPI(xmlData, i) {
          var start = i;
          for (; i < xmlData.length; i++) {
            if (xmlData[i] == '?' || xmlData[i] == ' ') {
              //tagname
              var tagname = xmlData.substr(start, i - start);
              if (i > 5 && tagname === 'xml') {
                return getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', getLineNumberForPosition(xmlData, i));
              } else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
                //check if valid attribut string
                i++;
                break;
              } else {
                continue;
              }
            }
          }
          return i;
        }

        function readCommentAndCDATA(xmlData, i) {
          if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
            //comment
            for (i += 3; i < xmlData.length; i++) {
              if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
                i += 2;
                break;
              }
            }
          } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
            var angleBracketsCount = 1;
            for (i += 8; i < xmlData.length; i++) {
              if (xmlData[i] === '<') {
                angleBracketsCount++;
              } else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) {
                  break;
                }
              }
            }
          } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
            for (i += 8; i < xmlData.length; i++) {
              if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
                i += 2;
                break;
              }
            }
          }

          return i;
        }

        var doubleQuote = '"';
        var singleQuote = "'";

        /**
         * Keep reading xmlData until '<' is found outside the attribute value.
         * @param {string} xmlData
         * @param {number} i
         */
        function readAttributeStr(xmlData, i) {
          var attrStr = '';
          var startChar = '';
          var tagClosed = false;
          for (; i < xmlData.length; i++) {
            if (xmlData[i] === doubleQuote || xmlData[i] === singleQuote) {
              if (startChar === '') {
                startChar = xmlData[i];
              } else if (startChar !== xmlData[i]) {
                //if vaue is enclosed with double quote then single quotes are allowed inside the value and vice versa
              } else {
                startChar = '';
              }
            } else if (xmlData[i] === '>') {
              if (startChar === '') {
                tagClosed = true;
                break;
              }
            }
            attrStr += xmlData[i];
          }
          if (startChar !== '') {
            return false;
          }

          return {
            value: attrStr,
            index: i,
            tagClosed: tagClosed
          };
        }

        /**
         * Select all the attributes whether valid or invalid.
         */
        var validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');

        //attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""

        function validateAttributeString(attrStr, options) {
          //console.log("start:"+attrStr+":end");

          //if(attrStr.trim().length === 0) return true; //empty string

          var matches = util.getAllMatches(attrStr, validAttrStrRegxp);
          var attrNames = {};

          for (var i = 0; i < matches.length; i++) {
            if (matches[i][1].length === 0) {
              //nospace before attribute name: a="sd"b="saf"
              return getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", getPositionFromMatch(matches[i]));
            } else if (matches[i][3] !== undefined && matches[i][4] === undefined) {
              return getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", getPositionFromMatch(matches[i]));
            } else if (matches[i][3] === undefined && !options.allowBooleanAttributes) {
              //independent attribute: ab
              return getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", getPositionFromMatch(matches[i]));
            }
            /* else if(matches[i][6] === undefined){//attribute without value: ab=
                            return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                        } */
            var attrName = matches[i][2];
            if (!validateAttrName(attrName)) {
              return getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", getPositionFromMatch(matches[i]));
            }
            if (!attrNames.hasOwnProperty(attrName)) {
              //check for duplicate attribute.
              attrNames[attrName] = 1;
            } else {
              return getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", getPositionFromMatch(matches[i]));
            }
          }

          return true;
        }

        function validateNumberAmpersand(xmlData, i) {
          var re = /\d/;
          if (xmlData[i] === 'x') {
            i++;
            re = /[\da-fA-F]/;
          }
          for (; i < xmlData.length; i++) {
            if (xmlData[i] === ';') return i;
            if (!xmlData[i].match(re)) break;
          }
          return -1;
        }

        function validateAmpersand(xmlData, i) {
          // https://www.w3.org/TR/xml/#dt-charref
          i++;
          if (xmlData[i] === ';') return -1;
          if (xmlData[i] === '#') {
            i++;
            return validateNumberAmpersand(xmlData, i);
          }
          var count = 0;
          for (; i < xmlData.length; i++, count++) {
            if (xmlData[i].match(/\w/) && count < 20) continue;
            if (xmlData[i] === ';') break;
            return -1;
          }
          return i;
        }

        function getErrorObject(code, message, lineNumber) {
          return {
            err: {
              code: code,
              msg: message,
              line: lineNumber.line || lineNumber,
              col: lineNumber.col
            }
          };
        }

        function validateAttrName(attrName) {
          return util.isName(attrName);
        }

        // const startsWithXML = /^xml/i;

        function validateTagName(tagname) {
          return util.isName(tagname) /* && !tagname.match(startsWithXML) */;
        }

        //this function returns the line number for the character at the given index
        function getLineNumberForPosition(xmlData, index) {
          var lines = xmlData.substring(0, index).split(/\r?\n/);
          return {
            line: lines.length,

            // column number is last line's length + 1, because column numbering starts at 1:
            col: lines[lines.length - 1].length + 1
          };
        }

        //this function returns the position of the first character of match within attrStr
        function getPositionFromMatch(match) {
          return match.startIndex + match[1].length;
        }

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlbuilder/json2xml.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlbuilder/json2xml.js ***!
        \*****************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlbuilderJson2xmlJs(module, exports, __webpack_require__) {

        "use strict";

        //parse Empty Node as self closing node

        var buildFromOrderedJs = __webpack_require__( /*! ./orderedJs2Xml */"./node_modules/fast-xml-parser/src/xmlbuilder/orderedJs2Xml.js");

        var defaultOptions = {
          attributeNamePrefix: '@_',
          attributesGroupName: false,
          textNodeName: '#text',
          ignoreAttributes: true,
          cdataPropName: false,
          format: false,
          indentBy: '  ',
          suppressEmptyNode: false,
          suppressUnpairedNode: true,
          suppressBooleanAttributes: true,
          tagValueProcessor: function tagValueProcessor(key, a) {
            return a;
          },
          attributeValueProcessor: function attributeValueProcessor(attrName, a) {
            return a;
          },
          preserveOrder: false,
          commentPropName: false,
          unpairedTags: [],
          entities: [{ regex: new RegExp("&", "g"), val: "&amp;" }, //it must be on top
          { regex: new RegExp(">", "g"), val: "&gt;" }, { regex: new RegExp("<", "g"), val: "&lt;" }, { regex: new RegExp("\'", "g"), val: "&apos;" }, { regex: new RegExp("\"", "g"), val: "&quot;" }],
          processEntities: true,
          stopNodes: [],
          // transformTagName: false,
          // transformAttributeName: false,
          oneListGroup: false
        };

        function Builder(options) {
          this.options = Object.assign({}, defaultOptions, options);
          if (this.options.ignoreAttributes || this.options.attributesGroupName) {
            this.isAttribute = function () /*a*/{
              return false;
            };
          } else {
            this.attrPrefixLen = this.options.attributeNamePrefix.length;
            this.isAttribute = isAttribute;
          }

          this.processTextOrObjNode = processTextOrObjNode;

          if (this.options.format) {
            this.indentate = indentate;
            this.tagEndChar = '>\n';
            this.newLine = '\n';
          } else {
            this.indentate = function () {
              return '';
            };
            this.tagEndChar = '>';
            this.newLine = '';
          }
        }

        Builder.prototype.build = function (jObj) {
          if (this.options.preserveOrder) {
            return buildFromOrderedJs(jObj, this.options);
          } else {
            if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) {
              jObj = _defineProperty({}, this.options.arrayNodeName, jObj);
            }
            return this.j2x(jObj, 0).val;
          }
        };

        Builder.prototype.j2x = function (jObj, level) {
          var attrStr = '';
          var val = '';
          for (var key in jObj) {
            if (!Object.prototype.hasOwnProperty.call(jObj, key)) continue;
            if (typeof jObj[key] === 'undefined') {
              // supress undefined node only if it is not an attribute
              if (this.isAttribute(key)) {
                val += '';
              }
            } else if (jObj[key] === null) {
              // null attribute should be ignored by the attribute list, but should not cause the tag closing
              if (this.isAttribute(key)) {
                val += '';
              } else if (key[0] === '?') {
                val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
              } else {
                val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
              }
              // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
            } else if (jObj[key] instanceof Date) {
              val += this.buildTextValNode(jObj[key], key, '', level);
            } else if (_typeof2(jObj[key]) !== 'object') {
              //premitive type
              var attr = this.isAttribute(key);
              if (attr) {
                attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
              } else {
                //tag value
                if (key === this.options.textNodeName) {
                  var newval = this.options.tagValueProcessor(key, '' + jObj[key]);
                  val += this.replaceEntitiesValue(newval);
                } else {
                  val += this.buildTextValNode(jObj[key], key, '', level);
                }
              }
            } else if (Array.isArray(jObj[key])) {
              //repeated nodes
              var arrLen = jObj[key].length;
              var listTagVal = "";
              for (var j = 0; j < arrLen; j++) {
                var item = jObj[key][j];
                if (typeof item === 'undefined') {
                  // supress undefined node
                } else if (item === null) {
                  if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                  // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                } else if ((typeof item === 'undefined' ? 'undefined' : _typeof2(item)) === 'object') {
                  if (this.options.oneListGroup) {
                    listTagVal += this.j2x(item, level + 1).val;
                  } else {
                    listTagVal += this.processTextOrObjNode(item, key, level);
                  }
                } else {
                  listTagVal += this.buildTextValNode(item, key, '', level);
                }
              }
              if (this.options.oneListGroup) {
                listTagVal = this.buildObjectNode(listTagVal, key, '', level);
              }
              val += listTagVal;
            } else {
              //nested node
              if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
                var Ks = Object.keys(jObj[key]);
                var L = Ks.length;
                for (var _j = 0; _j < L; _j++) {
                  attrStr += this.buildAttrPairStr(Ks[_j], '' + jObj[key][Ks[_j]]);
                }
              } else {
                val += this.processTextOrObjNode(jObj[key], key, level);
              }
            }
          }
          return { attrStr: attrStr, val: val };
        };

        Builder.prototype.buildAttrPairStr = function (attrName, val) {
          val = this.options.attributeValueProcessor(attrName, '' + val);
          val = this.replaceEntitiesValue(val);
          if (this.options.suppressBooleanAttributes && val === "true") {
            return ' ' + attrName;
          } else return ' ' + attrName + '="' + val + '"';
        };

        function processTextOrObjNode(object, key, level) {
          var result = this.j2x(object, level + 1);
          if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) {
            return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
          } else {
            return this.buildObjectNode(result.val, key, result.attrStr, level);
          }
        }

        Builder.prototype.buildObjectNode = function (val, key, attrStr, level) {
          if (val === "") {
            if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;else {
              return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
            }
          } else {

            var tagEndExp = '</' + key + this.tagEndChar;
            var piClosingChar = "";

            if (key[0] === "?") {
              piClosingChar = "?";
              tagEndExp = "";
            }

            // attrStr is an empty string in case the attribute came as undefined or null
            if ((attrStr || attrStr === '') && val.indexOf('<') === -1) {
              return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
            } else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) {
              return this.indentate(level) + ('<!--' + val + '-->') + this.newLine;
            } else {
              return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
            }
          }
        };

        Builder.prototype.closeTag = function (key) {
          var closeTag = "";
          if (this.options.unpairedTags.indexOf(key) !== -1) {
            //unpaired
            if (!this.options.suppressUnpairedNode) closeTag = "/";
          } else if (this.options.suppressEmptyNode) {
            //empty
            closeTag = "/";
          } else {
            closeTag = '></' + key;
          }
          return closeTag;
        };

        function buildEmptyObjNode(val, key, attrStr, level) {
          if (val !== '') {
            return this.buildObjectNode(val, key, attrStr, level);
          } else {
            if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;else {
              return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
              // return this.buildTagStr(level,key, attrStr);
            }
          }
        }

        Builder.prototype.buildTextValNode = function (val, key, attrStr, level) {
          if (this.options.cdataPropName !== false && key === this.options.cdataPropName) {
            return this.indentate(level) + ('<![CDATA[' + val + ']]>') + this.newLine;
          } else if (this.options.commentPropName !== false && key === this.options.commentPropName) {
            return this.indentate(level) + ('<!--' + val + '-->') + this.newLine;
          } else if (key[0] === "?") {
            //PI tag
            return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
          } else {
            var textValue = this.options.tagValueProcessor(key, val);
            textValue = this.replaceEntitiesValue(textValue);

            if (textValue === '') {
              return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
            } else {
              return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
            }
          }
        };

        Builder.prototype.replaceEntitiesValue = function (textValue) {
          if (textValue && textValue.length > 0 && this.options.processEntities) {
            for (var i = 0; i < this.options.entities.length; i++) {
              var entity = this.options.entities[i];
              textValue = textValue.replace(entity.regex, entity.val);
            }
          }
          return textValue;
        };

        function indentate(level) {
          return this.options.indentBy.repeat(level);
        }

        function isAttribute(name /*, options*/) {
          if (name.startsWith(this.options.attributeNamePrefix) && name !== this.options.textNodeName) {
            return name.substr(this.attrPrefixLen);
          } else {
            return false;
          }
        }

        module.exports = Builder;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlbuilder/orderedJs2Xml.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlbuilder/orderedJs2Xml.js ***!
        \**********************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlbuilderOrderedJs2XmlJs(module, exports) {

        var EOL = "\n";

        /**
         * 
         * @param {array} jArray 
         * @param {any} options 
         * @returns 
         */
        function toXml(jArray, options) {
          var indentation = "";
          if (options.format && options.indentBy.length > 0) {
            indentation = EOL;
          }
          return arrToStr(jArray, options, "", indentation);
        }

        function arrToStr(arr, options, jPath, indentation) {
          var xmlStr = "";
          var isPreviousElementTag = false;

          for (var i = 0; i < arr.length; i++) {
            var tagObj = arr[i];
            var tagName = propName(tagObj);
            if (tagName === undefined) continue;

            var newJPath = "";
            if (jPath.length === 0) newJPath = tagName;else newJPath = jPath + '.' + tagName;

            if (tagName === options.textNodeName) {
              var tagText = tagObj[tagName];
              if (!isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = replaceEntitiesValue(tagText, options);
              }
              if (isPreviousElementTag) {
                xmlStr += indentation;
              }
              xmlStr += tagText;
              isPreviousElementTag = false;
              continue;
            } else if (tagName === options.cdataPropName) {
              if (isPreviousElementTag) {
                xmlStr += indentation;
              }
              xmlStr += '<![CDATA[' + tagObj[tagName][0][options.textNodeName] + ']]>';
              isPreviousElementTag = false;
              continue;
            } else if (tagName === options.commentPropName) {
              xmlStr += indentation + ('<!--' + tagObj[tagName][0][options.textNodeName] + '-->');
              isPreviousElementTag = true;
              continue;
            } else if (tagName[0] === "?") {
              var _attStr = attr_to_str(tagObj[":@"], options);
              var tempInd = tagName === "?xml" ? "" : indentation;
              var piTextNodeName = tagObj[tagName][0][options.textNodeName];
              piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
              xmlStr += tempInd + ('<' + tagName + piTextNodeName + _attStr + '?>');
              isPreviousElementTag = true;
              continue;
            }
            var newIdentation = indentation;
            if (newIdentation !== "") {
              newIdentation += options.indentBy;
            }
            var attStr = attr_to_str(tagObj[":@"], options);
            var tagStart = indentation + ('<' + tagName + attStr);
            var tagValue = arrToStr(tagObj[tagName], options, newJPath, newIdentation);
            if (options.unpairedTags.indexOf(tagName) !== -1) {
              if (options.suppressUnpairedNode) xmlStr += tagStart + ">";else xmlStr += tagStart + "/>";
            } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) {
              xmlStr += tagStart + "/>";
            } else if (tagValue && tagValue.endsWith(">")) {
              xmlStr += tagStart + ('>' + tagValue + indentation + '</' + tagName + '>');
            } else {
              xmlStr += tagStart + ">";
              if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) {
                xmlStr += indentation + options.indentBy + tagValue + indentation;
              } else {
                xmlStr += tagValue;
              }
              xmlStr += '</' + tagName + '>';
            }
            isPreviousElementTag = true;
          }

          return xmlStr;
        }

        function propName(obj) {
          var keys = Object.keys(obj);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (!obj.hasOwnProperty(key)) continue;
            if (key !== ":@") return key;
          }
        }

        function attr_to_str(attrMap, options) {
          var attrStr = "";
          if (attrMap && !options.ignoreAttributes) {
            for (var attr in attrMap) {
              if (!attrMap.hasOwnProperty(attr)) continue;
              var attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
              attrVal = replaceEntitiesValue(attrVal, options);
              if (attrVal === true && options.suppressBooleanAttributes) {
                attrStr += ' ' + attr.substr(options.attributeNamePrefix.length);
              } else {
                attrStr += ' ' + attr.substr(options.attributeNamePrefix.length) + '="' + attrVal + '"';
              }
            }
          }
          return attrStr;
        }

        function isStopNode(jPath, options) {
          jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
          var tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
          for (var index in options.stopNodes) {
            if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
          }
          return false;
        }

        function replaceEntitiesValue(textValue, options) {
          if (textValue && textValue.length > 0 && options.processEntities) {
            for (var i = 0; i < options.entities.length; i++) {
              var entity = options.entities[i];
              textValue = textValue.replace(entity.regex, entity.val);
            }
          }
          return textValue;
        }
        module.exports = toXml;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlparser/DocTypeReader.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlparser/DocTypeReader.js ***!
        \*********************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlparserDocTypeReaderJs(module, exports, __webpack_require__) {

        var util = __webpack_require__( /*! ../util */"./node_modules/fast-xml-parser/src/util.js");

        //TODO: handle comments
        function readDocType(xmlData, i) {

          var entities = {};
          if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
            i = i + 9;
            var angleBracketsCount = 1;
            var hasBody = false,
                comment = false;
            var exp = "";
            for (; i < xmlData.length; i++) {
              if (xmlData[i] === '<' && !comment) {
                //Determine the tag type
                if (hasBody && isEntity(xmlData, i)) {
                  i += 7;

                  var _readEntityExp = readEntityExp(xmlData, i + 1);

                  var _readEntityExp2 = _slicedToArray(_readEntityExp, 3);

                  entityName = _readEntityExp2[0];
                  val = _readEntityExp2[1];
                  i = _readEntityExp2[2];

                  if (val.indexOf("&") === -1) //Parameter entities are not supported
                    entities[validateEntityName(entityName)] = {
                      regx: RegExp('&' + entityName + ';', "g"),
                      val: val
                    };
                } else if (hasBody && isElement(xmlData, i)) i += 8; //Not supported
                else if (hasBody && isAttlist(xmlData, i)) i += 8; //Not supported
                  else if (hasBody && isNotation(xmlData, i)) i += 9; //Not supported
                    else if (isComment) comment = true;else throw new Error("Invalid DOCTYPE");

                angleBracketsCount++;
                exp = "";
              } else if (xmlData[i] === '>') {
                //Read tag content
                if (comment) {
                  if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                    comment = false;
                    angleBracketsCount--;
                  }
                } else {
                  angleBracketsCount--;
                }
                if (angleBracketsCount === 0) {
                  break;
                }
              } else if (xmlData[i] === '[') {
                hasBody = true;
              } else {
                exp += xmlData[i];
              }
            }
            if (angleBracketsCount !== 0) {
              throw new Error('Unclosed DOCTYPE');
            }
          } else {
            throw new Error('Invalid Tag instead of DOCTYPE');
          }
          return { entities: entities, i: i };
        }

        function readEntityExp(xmlData, i) {
          //External entities are not supported
          //    <!ENTITY ext SYSTEM "http://normal-website.com" >

          //Parameter entities are not supported
          //    <!ENTITY entityname "&anotherElement;">

          //Internal entities are supported
          //    <!ENTITY entityname "replacement text">

          //read EntityName
          var entityName = "";
          for (; i < xmlData.length && xmlData[i] !== "'" && xmlData[i] !== '"'; i++) {
            // if(xmlData[i] === " ") continue;
            // else 
            entityName += xmlData[i];
          }
          entityName = entityName.trim();
          if (entityName.indexOf(" ") !== -1) throw new Error("External entites are not supported");

          //read Entity Value
          var startChar = xmlData[i++];
          var val = "";
          for (; i < xmlData.length && xmlData[i] !== startChar; i++) {
            val += xmlData[i];
          }
          return [entityName, val, i];
        }

        function isComment(xmlData, i) {
          if (xmlData[i + 1] === '!' && xmlData[i + 2] === '-' && xmlData[i + 3] === '-') return true;
          return false;
        }
        function isEntity(xmlData, i) {
          if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'N' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'I' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'Y') return true;
          return false;
        }
        function isElement(xmlData, i) {
          if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'L' && xmlData[i + 4] === 'E' && xmlData[i + 5] === 'M' && xmlData[i + 6] === 'E' && xmlData[i + 7] === 'N' && xmlData[i + 8] === 'T') return true;
          return false;
        }

        function isAttlist(xmlData, i) {
          if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'A' && xmlData[i + 3] === 'T' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'L' && xmlData[i + 6] === 'I' && xmlData[i + 7] === 'S' && xmlData[i + 8] === 'T') return true;
          return false;
        }
        function isNotation(xmlData, i) {
          if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'N' && xmlData[i + 3] === 'O' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'A' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'I' && xmlData[i + 8] === 'O' && xmlData[i + 9] === 'N') return true;
          return false;
        }

        function validateEntityName(name) {
          if (util.isName(name)) return name;else throw new Error('Invalid entity name ' + name);
        }

        module.exports = readDocType;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlparser/OptionsBuilder.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlparser/OptionsBuilder.js ***!
        \**********************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlparserOptionsBuilderJs(module, exports) {

        var defaultOptions = {
          preserveOrder: false,
          attributeNamePrefix: '@_',
          attributesGroupName: false,
          textNodeName: '#text',
          ignoreAttributes: true,
          removeNSPrefix: false, // remove NS from tag name or attribute name if true
          allowBooleanAttributes: false, //a tag can have attributes without any value
          //ignoreRootElement : false,
          parseTagValue: true,
          parseAttributeValue: false,
          trimValues: true, //Trim string values of tag and attributes
          cdataPropName: false,
          numberParseOptions: {
            hex: true,
            leadingZeros: true,
            eNotation: true
          },
          tagValueProcessor: function tagValueProcessor(tagName, val) {
            return val;
          },
          attributeValueProcessor: function attributeValueProcessor(attrName, val) {
            return val;
          },
          stopNodes: [], //nested tags will not be parsed even for errors
          alwaysCreateTextNode: false,
          isArray: function isArray() {
            return false;
          },
          commentPropName: false,
          unpairedTags: [],
          processEntities: true,
          htmlEntities: false,
          ignoreDeclaration: false,
          ignorePiTags: false,
          transformTagName: false,
          transformAttributeName: false,
          updateTag: function updateTag(tagName, jPath, attrs) {
            return tagName;
          }
          // skipEmptyListItem: false
        };

        var buildOptions = function buildOptions(options) {
          return Object.assign({}, defaultOptions, options);
        };

        exports.buildOptions = buildOptions;
        exports.defaultOptions = defaultOptions;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlparser/OrderedObjParser.js":
      /*!************************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlparser/OrderedObjParser.js ***!
        \************************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlparserOrderedObjParserJs(module, exports, __webpack_require__) {

        "use strict";

        ///@ts-check

        var util = __webpack_require__( /*! ../util */"./node_modules/fast-xml-parser/src/util.js");
        var xmlNode = __webpack_require__( /*! ./xmlNode */"./node_modules/fast-xml-parser/src/xmlparser/xmlNode.js");
        var readDocType = __webpack_require__( /*! ./DocTypeReader */"./node_modules/fast-xml-parser/src/xmlparser/DocTypeReader.js");
        var toNumber = __webpack_require__( /*! strnum */"./node_modules/strnum/strnum.js");

        // const regx =
        //   '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
        //   .replace(/NAME/g, util.nameRegexp);

        //const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
        //const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");

        var OrderedObjParser = function OrderedObjParser(options) {
          _classCallCheck2(this, OrderedObjParser);

          this.options = options;
          this.currentNode = null;
          this.tagsNodeStack = [];
          this.docTypeEntities = {};
          this.lastEntities = {
            "apos": { regex: /&(apos|#39|#x27);/g, val: "'" },
            "gt": { regex: /&(gt|#62|#x3E);/g, val: ">" },
            "lt": { regex: /&(lt|#60|#x3C);/g, val: "<" },
            "quot": { regex: /&(quot|#34|#x22);/g, val: "\"" }
          };
          this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" };
          this.htmlEntities = {
            "space": { regex: /&(nbsp|#160);/g, val: " " },
            // "lt" : { regex: /&(lt|#60);/g, val: "<" },
            // "gt" : { regex: /&(gt|#62);/g, val: ">" },
            // "amp" : { regex: /&(amp|#38);/g, val: "&" },
            // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
            // "apos" : { regex: /&(apos|#39);/g, val: "'" },
            "cent": { regex: /&(cent|#162);/g, val: "¢" },
            "pound": { regex: /&(pound|#163);/g, val: "£" },
            "yen": { regex: /&(yen|#165);/g, val: "¥" },
            "euro": { regex: /&(euro|#8364);/g, val: "€" },
            "copyright": { regex: /&(copy|#169);/g, val: "©" },
            "reg": { regex: /&(reg|#174);/g, val: "®" },
            "inr": { regex: /&(inr|#8377);/g, val: "₹" },
            "num_dec": { regex: /&#([0-9]{1,7});/g, val: function val(_, str) {
                return String.fromCharCode(Number.parseInt(str, 10));
              } },
            "num_hex": { regex: /&#x([0-9a-fA-F]{1,6});/g, val: function val(_, str) {
                return String.fromCharCode(Number.parseInt(str, 16));
              } }
          };
          this.addExternalEntities = addExternalEntities;
          this.parseXml = parseXml;
          this.parseTextData = parseTextData;
          this.resolveNameSpace = resolveNameSpace;
          this.buildAttributesMap = buildAttributesMap;
          this.isItStopNode = isItStopNode;
          this.replaceEntitiesValue = replaceEntitiesValue;
          this.readStopNodeData = readStopNodeData;
          this.saveTextToParentTag = saveTextToParentTag;
          this.addChild = addChild;
        };

        function addExternalEntities(externalEntities) {
          var entKeys = Object.keys(externalEntities);
          for (var i = 0; i < entKeys.length; i++) {
            var ent = entKeys[i];
            this.lastEntities[ent] = {
              regex: new RegExp("&" + ent + ";", "g"),
              val: externalEntities[ent]
            };
          }
        }

        /**
         * @param {string} val
         * @param {string} tagName
         * @param {string} jPath
         * @param {boolean} dontTrim
         * @param {boolean} hasAttributes
         * @param {boolean} isLeafNode
         * @param {boolean} escapeEntities
         */
        function parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
          if (val !== undefined) {
            if (this.options.trimValues && !dontTrim) {
              val = val.trim();
            }
            if (val.length > 0) {
              if (!escapeEntities) val = this.replaceEntitiesValue(val);

              var newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
              if (newval === null || newval === undefined) {
                //don't parse
                return val;
              } else if ((typeof newval === 'undefined' ? 'undefined' : _typeof2(newval)) !== (typeof val === 'undefined' ? 'undefined' : _typeof2(val)) || newval !== val) {
                //overwrite
                return newval;
              } else if (this.options.trimValues) {
                return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
              } else {
                var trimmedVal = val.trim();
                if (trimmedVal === val) {
                  return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
                } else {
                  return val;
                }
              }
            }
          }
        }

        function resolveNameSpace(tagname) {
          if (this.options.removeNSPrefix) {
            var tags = tagname.split(':');
            var prefix = tagname.charAt(0) === '/' ? '/' : '';
            if (tags[0] === 'xmlns') {
              return '';
            }
            if (tags.length === 2) {
              tagname = prefix + tags[1];
            }
          }
          return tagname;
        }

        //TODO: change regex to capture NS
        //const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
        var attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');

        function buildAttributesMap(attrStr, jPath, tagName) {
          if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
            // attrStr = attrStr.replace(/\r?\n/g, ' ');
            //attrStr = attrStr || attrStr.trim();

            var matches = util.getAllMatches(attrStr, attrsRegx);
            var len = matches.length; //don't make it inline
            var attrs = {};
            for (var i = 0; i < len; i++) {
              var attrName = this.resolveNameSpace(matches[i][1]);
              var oldVal = matches[i][4];
              var aName = this.options.attributeNamePrefix + attrName;
              if (attrName.length) {
                if (this.options.transformAttributeName) {
                  aName = this.options.transformAttributeName(aName);
                }
                if (aName === "__proto__") aName = "#__proto__";
                if (oldVal !== undefined) {
                  if (this.options.trimValues) {
                    oldVal = oldVal.trim();
                  }
                  oldVal = this.replaceEntitiesValue(oldVal);
                  var newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
                  if (newVal === null || newVal === undefined) {
                    //don't parse
                    attrs[aName] = oldVal;
                  } else if ((typeof newVal === 'undefined' ? 'undefined' : _typeof2(newVal)) !== (typeof oldVal === 'undefined' ? 'undefined' : _typeof2(oldVal)) || newVal !== oldVal) {
                    //overwrite
                    attrs[aName] = newVal;
                  } else {
                    //parse
                    attrs[aName] = parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
                  }
                } else if (this.options.allowBooleanAttributes) {
                  attrs[aName] = true;
                }
              }
            }
            if (!Object.keys(attrs).length) {
              return;
            }
            if (this.options.attributesGroupName) {
              var attrCollection = {};
              attrCollection[this.options.attributesGroupName] = attrs;
              return attrCollection;
            }
            return attrs;
          }
        }

        var parseXml = function parseXml(xmlData) {
          xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
          var xmlObj = new xmlNode('!xml');
          var currentNode = xmlObj;
          var textData = "";
          var jPath = "";
          for (var i = 0; i < xmlData.length; i++) {
            //for each char in XML data
            var ch = xmlData[i];
            if (ch === '<') {
              // const nextIndex = i+1;
              // const _2ndChar = xmlData[nextIndex];
              if (xmlData[i + 1] === '/') {
                //Closing Tag
                var closeIndex = findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                var tagName = xmlData.substring(i + 2, closeIndex).trim();

                if (this.options.removeNSPrefix) {
                  var colonIndex = tagName.indexOf(":");
                  if (colonIndex !== -1) {
                    tagName = tagName.substr(colonIndex + 1);
                  }
                }

                if (this.options.transformTagName) {
                  tagName = this.options.transformTagName(tagName);
                }

                if (currentNode) {
                  textData = this.saveTextToParentTag(textData, currentNode, jPath);
                }

                //check if last tag of nested tag was unpaired tag
                var lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
                if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) {
                  throw new Error('Unpaired tag can not be used as closing tag: </' + tagName + '>');
                }
                var propIndex = 0;
                if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
                  propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.') - 1);
                  this.tagsNodeStack.pop();
                } else {
                  propIndex = jPath.lastIndexOf(".");
                }
                jPath = jPath.substring(0, propIndex);

                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
              } else if (xmlData[i + 1] === '?') {

                var tagData = readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");

                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) {} else {

                  var childNode = new xmlNode(tagData.tagName);
                  childNode.add(this.options.textNodeName, "");

                  if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) {
                    childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
                  }
                  this.addChild(currentNode, childNode, jPath);
                }

                i = tagData.closeIndex + 1;
              } else if (xmlData.substr(i + 1, 3) === '!--') {
                var endIndex = findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (this.options.commentPropName) {
                  var comment = xmlData.substring(i + 4, endIndex - 2);

                  textData = this.saveTextToParentTag(textData, currentNode, jPath);

                  currentNode.add(this.options.commentPropName, [_defineProperty({}, this.options.textNodeName, comment)]);
                }
                i = endIndex;
              } else if (xmlData.substr(i + 1, 2) === '!D') {
                var result = readDocType(xmlData, i);
                this.docTypeEntities = result.entities;
                i = result.i;
              } else if (xmlData.substr(i + 1, 2) === '![') {
                var _closeIndex = findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                var tagExp = xmlData.substring(i + 9, _closeIndex);

                textData = this.saveTextToParentTag(textData, currentNode, jPath);

                var _val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true, true);
                if (_val == undefined) _val = "";

                //cdata should be set even if it is 0 length string
                if (this.options.cdataPropName) {
                  currentNode.add(this.options.cdataPropName, [_defineProperty({}, this.options.textNodeName, tagExp)]);
                } else {
                  currentNode.add(this.options.textNodeName, _val);
                }

                i = _closeIndex + 2;
              } else {
                //Opening tag
                var _result = readTagExp(xmlData, i, this.options.removeNSPrefix);
                var _tagName = _result.tagName;
                var rawTagName = _result.rawTagName;
                var _tagExp = _result.tagExp;
                var attrExpPresent = _result.attrExpPresent;
                var _closeIndex2 = _result.closeIndex;

                if (this.options.transformTagName) {
                  _tagName = this.options.transformTagName(_tagName);
                }

                //save text as child node
                if (currentNode && textData) {
                  if (currentNode.tagname !== '!xml') {
                    //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
                  }
                }

                //check if last tag was unpaired tag
                var lastTag = currentNode;
                if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
                  currentNode = this.tagsNodeStack.pop();
                  jPath = jPath.substring(0, jPath.lastIndexOf("."));
                }
                if (_tagName !== xmlObj.tagname) {
                  jPath += jPath ? "." + _tagName : _tagName;
                }
                if (this.isItStopNode(this.options.stopNodes, jPath, _tagName)) {
                  var tagContent = "";
                  //self-closing tag
                  if (_tagExp.length > 0 && _tagExp.lastIndexOf("/") === _tagExp.length - 1) {
                    if (_tagName[_tagName.length - 1] === "/") {
                      //remove trailing '/'
                      _tagName = _tagName.substr(0, _tagName.length - 1);
                      jPath = jPath.substr(0, jPath.length - 1);
                      _tagExp = _tagName;
                    } else {
                      _tagExp = _tagExp.substr(0, _tagExp.length - 1);
                    }
                    i = _result.closeIndex;
                  }
                  //unpaired tag
                  else if (this.options.unpairedTags.indexOf(_tagName) !== -1) {

                      i = _result.closeIndex;
                    }
                    //normal tag
                    else {
                        //read until closing tag is found
                        var _result2 = this.readStopNodeData(xmlData, rawTagName, _closeIndex2 + 1);
                        if (!_result2) throw new Error('Unexpected end of ' + rawTagName);
                        i = _result2.i;
                        tagContent = _result2.tagContent;
                      }

                  var _childNode = new xmlNode(_tagName);
                  if (_tagName !== _tagExp && attrExpPresent) {
                    _childNode[":@"] = this.buildAttributesMap(_tagExp, jPath, _tagName);
                  }
                  if (tagContent) {
                    tagContent = this.parseTextData(tagContent, _tagName, jPath, true, attrExpPresent, true, true);
                  }

                  jPath = jPath.substr(0, jPath.lastIndexOf("."));
                  _childNode.add(this.options.textNodeName, tagContent);

                  this.addChild(currentNode, _childNode, jPath);
                } else {
                  //selfClosing tag
                  if (_tagExp.length > 0 && _tagExp.lastIndexOf("/") === _tagExp.length - 1) {
                    if (_tagName[_tagName.length - 1] === "/") {
                      //remove trailing '/'
                      _tagName = _tagName.substr(0, _tagName.length - 1);
                      jPath = jPath.substr(0, jPath.length - 1);
                      _tagExp = _tagName;
                    } else {
                      _tagExp = _tagExp.substr(0, _tagExp.length - 1);
                    }

                    if (this.options.transformTagName) {
                      _tagName = this.options.transformTagName(_tagName);
                    }

                    var _childNode2 = new xmlNode(_tagName);
                    if (_tagName !== _tagExp && attrExpPresent) {
                      _childNode2[":@"] = this.buildAttributesMap(_tagExp, jPath, _tagName);
                    }
                    this.addChild(currentNode, _childNode2, jPath);
                    jPath = jPath.substr(0, jPath.lastIndexOf("."));
                  }
                  //opening tag
                  else {
                      var _childNode3 = new xmlNode(_tagName);
                      this.tagsNodeStack.push(currentNode);

                      if (_tagName !== _tagExp && attrExpPresent) {
                        _childNode3[":@"] = this.buildAttributesMap(_tagExp, jPath, _tagName);
                      }
                      this.addChild(currentNode, _childNode3, jPath);
                      currentNode = _childNode3;
                    }
                  textData = "";
                  i = _closeIndex2;
                }
              }
            } else {
              textData += xmlData[i];
            }
          }
          return xmlObj.child;
        };

        function addChild(currentNode, childNode, jPath) {
          var result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
          if (result === false) {} else if (typeof result === "string") {
            childNode.tagname = result;
            currentNode.addChild(childNode);
          } else {
            currentNode.addChild(childNode);
          }
        }

        var replaceEntitiesValue = function replaceEntitiesValue(val) {

          if (this.options.processEntities) {
            for (var _entityName in this.docTypeEntities) {
              var entity = this.docTypeEntities[_entityName];
              val = val.replace(entity.regx, entity.val);
            }
            for (var _entityName2 in this.lastEntities) {
              var _entity = this.lastEntities[_entityName2];
              val = val.replace(_entity.regex, _entity.val);
            }
            if (this.options.htmlEntities) {
              for (var _entityName3 in this.htmlEntities) {
                var _entity2 = this.htmlEntities[_entityName3];
                val = val.replace(_entity2.regex, _entity2.val);
              }
            }
            val = val.replace(this.ampEntity.regex, this.ampEntity.val);
          }
          return val;
        };
        function saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
          if (textData) {
            //store previously collected data as textNode
            if (isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;

            textData = this.parseTextData(textData, currentNode.tagname, jPath, false, currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false, isLeafNode);

            if (textData !== undefined && textData !== "") currentNode.add(this.options.textNodeName, textData);
            textData = "";
          }
          return textData;
        }

        //TODO: use jPath to simplify the logic
        /**
         * 
         * @param {string[]} stopNodes 
         * @param {string} jPath
         * @param {string} currentTagName 
         */
        function isItStopNode(stopNodes, jPath, currentTagName) {
          var allNodesExp = "*." + currentTagName;
          for (var stopNodePath in stopNodes) {
            var stopNodeExp = stopNodes[stopNodePath];
            if (allNodesExp === stopNodeExp || jPath === stopNodeExp) return true;
          }
          return false;
        }

        /**
         * Returns the tag Expression and where it is ending handling single-double quotes situation
         * @param {string} xmlData 
         * @param {number} i starting index
         * @returns 
         */
        function tagExpWithClosingIndex(xmlData, i) {
          var closingChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ">";

          var attrBoundary = void 0;
          var tagExp = "";
          for (var index = i; index < xmlData.length; index++) {
            var ch = xmlData[index];
            if (attrBoundary) {
              if (ch === attrBoundary) attrBoundary = ""; //reset
            } else if (ch === '"' || ch === "'") {
              attrBoundary = ch;
            } else if (ch === closingChar[0]) {
              if (closingChar[1]) {
                if (xmlData[index + 1] === closingChar[1]) {
                  return {
                    data: tagExp,
                    index: index
                  };
                }
              } else {
                return {
                  data: tagExp,
                  index: index
                };
              }
            } else if (ch === '\t') {
              ch = " ";
            }
            tagExp += ch;
          }
        }

        function findClosingIndex(xmlData, str, i, errMsg) {
          var closingIndex = xmlData.indexOf(str, i);
          if (closingIndex === -1) {
            throw new Error(errMsg);
          } else {
            return closingIndex + str.length - 1;
          }
        }

        function readTagExp(xmlData, i, removeNSPrefix) {
          var closingChar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ">";

          var result = tagExpWithClosingIndex(xmlData, i + 1, closingChar);
          if (!result) return;
          var tagExp = result.data;
          var closeIndex = result.index;
          var separatorIndex = tagExp.search(/\s/);
          var tagName = tagExp;
          var attrExpPresent = true;
          if (separatorIndex !== -1) {
            //separate tag name and attributes expression
            tagName = tagExp.substring(0, separatorIndex);
            tagExp = tagExp.substring(separatorIndex + 1).trimStart();
          }

          var rawTagName = tagName;
          if (removeNSPrefix) {
            var colonIndex = tagName.indexOf(":");
            if (colonIndex !== -1) {
              tagName = tagName.substr(colonIndex + 1);
              attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
            }
          }

          return {
            tagName: tagName,
            tagExp: tagExp,
            closeIndex: closeIndex,
            attrExpPresent: attrExpPresent,
            rawTagName: rawTagName
          };
        }
        /**
         * find paired tag for a stop node
         * @param {string} xmlData 
         * @param {string} tagName 
         * @param {number} i 
         */
        function readStopNodeData(xmlData, tagName, i) {
          var startIndex = i;
          // Starting at 1 since we already have an open tag
          var openTagCount = 1;

          for (; i < xmlData.length; i++) {
            if (xmlData[i] === "<") {
              if (xmlData[i + 1] === "/") {
                //close tag
                var closeIndex = findClosingIndex(xmlData, ">", i, tagName + ' is not closed');
                var closeTagName = xmlData.substring(i + 2, closeIndex).trim();
                if (closeTagName === tagName) {
                  openTagCount--;
                  if (openTagCount === 0) {
                    return {
                      tagContent: xmlData.substring(startIndex, i),
                      i: closeIndex
                    };
                  }
                }
                i = closeIndex;
              } else if (xmlData[i + 1] === '?') {
                var _closeIndex3 = findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
                i = _closeIndex3;
              } else if (xmlData.substr(i + 1, 3) === '!--') {
                var _closeIndex4 = findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
                i = _closeIndex4;
              } else if (xmlData.substr(i + 1, 2) === '![') {
                var _closeIndex5 = findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
                i = _closeIndex5;
              } else {
                var tagData = readTagExp(xmlData, i, '>');

                if (tagData) {
                  var openTagName = tagData && tagData.tagName;
                  if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") {
                    openTagCount++;
                  }
                  i = tagData.closeIndex;
                }
              }
            }
          } //end for loop
        }

        function parseValue(val, shouldParse, options) {
          if (shouldParse && typeof val === 'string') {
            //console.log(options)
            var newval = val.trim();
            if (newval === 'true') return true;else if (newval === 'false') return false;else return toNumber(val, options);
          } else {
            if (util.isExist(val)) {
              return val;
            } else {
              return '';
            }
          }
        }

        module.exports = OrderedObjParser;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlparser/XMLParser.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlparser/XMLParser.js ***!
        \*****************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlparserXMLParserJs(module, exports, __webpack_require__) {
        var _webpack_require__ = __webpack_require__( /*! ./OptionsBuilder */"./node_modules/fast-xml-parser/src/xmlparser/OptionsBuilder.js"),
            buildOptions = _webpack_require__.buildOptions;

        var OrderedObjParser = __webpack_require__( /*! ./OrderedObjParser */"./node_modules/fast-xml-parser/src/xmlparser/OrderedObjParser.js");

        var _webpack_require__2 = __webpack_require__( /*! ./node2json */"./node_modules/fast-xml-parser/src/xmlparser/node2json.js"),
            prettify = _webpack_require__2.prettify;

        var validator = __webpack_require__( /*! ../validator */"./node_modules/fast-xml-parser/src/validator.js");

        var XMLParser = function () {
          function XMLParser(options) {
            _classCallCheck2(this, XMLParser);

            this.externalEntities = {};
            this.options = buildOptions(options);
          }
          /**
           * Parse XML dats to JS object 
           * @param {string|Buffer} xmlData 
           * @param {boolean|Object} validationOption 
           */


          _createClass2(XMLParser, [{
            key: 'parse',
            value: function parse(xmlData, validationOption) {
              if (typeof xmlData === "string") {} else if (xmlData.toString) {
                xmlData = xmlData.toString();
              } else {
                throw new Error("XML data is accepted in String or Bytes[] form.");
              }
              if (validationOption) {
                if (validationOption === true) validationOption = {}; //validate with default options

                var result = validator.validate(xmlData, validationOption);
                if (result !== true) {
                  throw Error(result.err.msg + ':' + result.err.line + ':' + result.err.col);
                }
              }
              var orderedObjParser = new OrderedObjParser(this.options);
              orderedObjParser.addExternalEntities(this.externalEntities);
              var orderedResult = orderedObjParser.parseXml(xmlData);
              if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;else return prettify(orderedResult, this.options);
            }

            /**
             * Add Entity which is not by default supported by this library
             * @param {string} key 
             * @param {string} value 
             */

          }, {
            key: 'addEntity',
            value: function addEntity(key, value) {
              if (value.indexOf("&") !== -1) {
                throw new Error("Entity value can't have '&'");
              } else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) {
                throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
              } else if (value === "&") {
                throw new Error("An entity with value '&' is not permitted");
              } else {
                this.externalEntities[key] = value;
              }
            }
          }]);

          return XMLParser;
        }();

        module.exports = XMLParser;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlparser/node2json.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlparser/node2json.js ***!
        \*****************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlparserNode2jsonJs(module, exports, __webpack_require__) {

        "use strict";

        /**
         * 
         * @param {array} node 
         * @param {any} options 
         * @returns 
         */

        function prettify(node, options) {
          return compress(node, options);
        }

        /**
         * 
         * @param {array} arr 
         * @param {object} options 
         * @param {string} jPath 
         * @returns object
         */
        function compress(arr, options, jPath) {
          var text = void 0;
          var compressedObj = {};
          for (var i = 0; i < arr.length; i++) {
            var tagObj = arr[i];
            var property = propName(tagObj);
            var newJpath = "";
            if (jPath === undefined) newJpath = property;else newJpath = jPath + "." + property;

            if (property === options.textNodeName) {
              if (text === undefined) text = tagObj[property];else text += "" + tagObj[property];
            } else if (property === undefined) {
              continue;
            } else if (tagObj[property]) {

              var _val2 = compress(tagObj[property], options, newJpath);
              var isLeaf = isLeafTag(_val2, options);

              if (tagObj[":@"]) {
                assignAttributes(_val2, tagObj[":@"], newJpath, options);
              } else if (Object.keys(_val2).length === 1 && _val2[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) {
                _val2 = _val2[options.textNodeName];
              } else if (Object.keys(_val2).length === 0) {
                if (options.alwaysCreateTextNode) _val2[options.textNodeName] = "";else _val2 = "";
              }

              if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
                if (!Array.isArray(compressedObj[property])) {
                  compressedObj[property] = [compressedObj[property]];
                }
                compressedObj[property].push(_val2);
              } else {
                //TODO: if a node is not an array, then check if it should be an array
                //also determine if it is a leaf node
                if (options.isArray(property, newJpath, isLeaf)) {
                  compressedObj[property] = [_val2];
                } else {
                  compressedObj[property] = _val2;
                }
              }
            }
          }
          // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
          if (typeof text === "string") {
            if (text.length > 0) compressedObj[options.textNodeName] = text;
          } else if (text !== undefined) compressedObj[options.textNodeName] = text;
          return compressedObj;
        }

        function propName(obj) {
          var keys = Object.keys(obj);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== ":@") return key;
          }
        }

        function assignAttributes(obj, attrMap, jpath, options) {
          if (attrMap) {
            var keys = Object.keys(attrMap);
            var len = keys.length; //don't make it inline
            for (var i = 0; i < len; i++) {
              var atrrName = keys[i];
              if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) {
                obj[atrrName] = [attrMap[atrrName]];
              } else {
                obj[atrrName] = attrMap[atrrName];
              }
            }
          }
        }

        function isLeafTag(obj, options) {
          var textNodeName = options.textNodeName;

          var propCount = Object.keys(obj).length;

          if (propCount === 0) {
            return true;
          }

          if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) {
            return true;
          }

          return false;
        }
        exports.prettify = prettify;

        /***/
      },

      /***/"./node_modules/fast-xml-parser/src/xmlparser/xmlNode.js":
      /*!***************************************************************!*\
        !*** ./node_modules/fast-xml-parser/src/xmlparser/xmlNode.js ***!
        \***************************************************************/
      /*! no static exports found */
      /***/function node_modulesFastXmlParserSrcXmlparserXmlNodeJs(module, exports, __webpack_require__) {

        "use strict";

        var XmlNode = function () {
          function XmlNode(tagname) {
            _classCallCheck2(this, XmlNode);

            this.tagname = tagname;
            this.child = []; //nested tags, text, cdata, comments in order
            this[":@"] = {}; //attributes map
          }

          _createClass2(XmlNode, [{
            key: 'add',
            value: function add(key, val) {
              // this.child.push( {name : key, val: val, isCdata: isCdata });
              if (key === "__proto__") key = "#__proto__";
              this.child.push(_defineProperty({}, key, val));
            }
          }, {
            key: 'addChild',
            value: function addChild(node) {
              if (node.tagname === "__proto__") node.tagname = "#__proto__";
              if (node[":@"] && Object.keys(node[":@"]).length > 0) {
                var _child$push2;

                this.child.push((_child$push2 = {}, _defineProperty(_child$push2, node.tagname, node.child), _defineProperty(_child$push2, ":@", node[":@"]), _child$push2));
              } else {
                this.child.push(_defineProperty({}, node.tagname, node.child));
              }
            }
          }]);

          return XmlNode;
        }();

        ;

        module.exports = XmlNode;

        /***/
      },

      /***/"./node_modules/process/browser.js":
      /*!*****************************************!*\
        !*** ./node_modules/process/browser.js ***!
        \*****************************************/
      /*! no static exports found */
      /***/function node_modulesProcessBrowserJs(module, exports) {

        // shim for using process in browser
        var process = module.exports = {};

        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }
        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }
        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }
          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();
        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          }
          // if setTimeout wasn't available but was latter defined
          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }
        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          }
          // if clearTimeout wasn't available but was latter defined
          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }
          draining = false;
          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }
          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }
          var timeout = runTimeout(cleanUpNextTick);
          draining = true;

          var len = queue.length;
          while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }
            queueIndex = -1;
            len = queue.length;
          }
          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);
          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }
          queue.push(new Item(fun, args));
          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        };

        // v8 likes predictible objects
        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }
        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues
        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };

        process.cwd = function () {
          return '/';
        };
        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };
        process.umask = function () {
          return 0;
        };

        /***/
      },

      /***/"./node_modules/strnum/strnum.js":
      /*!***************************************!*\
        !*** ./node_modules/strnum/strnum.js ***!
        \***************************************/
      /*! no static exports found */
      /***/function node_modulesStrnumStrnumJs(module, exports) {

        var hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
        var numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
        // const octRegex = /0x[a-z0-9]+/;
        // const binRegex = /0x[a-z0-9]+/;


        //polyfill
        if (!Number.parseInt && window.parseInt) {
          Number.parseInt = window.parseInt;
        }
        if (!Number.parseFloat && window.parseFloat) {
          Number.parseFloat = window.parseFloat;
        }

        var consider = {
          hex: true,
          leadingZeros: true,
          decimalPoint: "\.",
          eNotation: true
          //skipLike: /regex/
        };

        function toNumber(str) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          // const options = Object.assign({}, consider);
          // if(opt.leadingZeros === false){
          //     options.leadingZeros = false;
          // }else if(opt.hex === false){
          //     options.hex = false;
          // }

          options = Object.assign({}, consider, options);
          if (!str || typeof str !== "string") return str;

          var trimmedStr = str.trim();
          // if(trimmedStr === "0.0") return 0;
          // else if(trimmedStr === "+0.0") return 0;
          // else if(trimmedStr === "-0.0") return -0;

          if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;else if (options.hex && hexRegex.test(trimmedStr)) {
            return Number.parseInt(trimmedStr, 16);
            // } else if (options.parseOct && octRegex.test(str)) {
            //     return Number.parseInt(val, 8);
            // }else if (options.parseBin && binRegex.test(str)) {
            //     return Number.parseInt(val, 2);
          } else {
            //separate negative sign, leading zeros, and rest number
            var match = numRegex.exec(trimmedStr);
            if (match) {
              var sign = match[1];
              var leadingZeros = match[2];
              var numTrimmedByZeros = trimZeros(match[3]); //complete num without leading zeros
              //trim ending zeros for floating number

              var eNotation = match[4] || match[6];
              if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
              else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
                else {
                    //no leading zeros or leading zeros are allowed
                    var num = Number(trimmedStr);
                    var numStr = "" + num;
                    if (numStr.search(/[eE]/) !== -1) {
                      //given number is long and parsed to eNotation
                      if (options.eNotation) return num;else return str;
                    } else if (eNotation) {
                      //given number has enotation
                      if (options.eNotation) return num;else return str;
                    } else if (trimmedStr.indexOf(".") !== -1) {
                      //floating number
                      // const decimalPart = match[5].substr(1);
                      // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));


                      // const p = numStr.indexOf(".");
                      // const givenIntPart = numStr.substr(0,p);
                      // const givenDecPart = numStr.substr(p+1);
                      if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                      else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                        else if (sign && numStr === "-" + numTrimmedByZeros) return num;else return str;
                    }

                    if (leadingZeros) {
                      // if(numTrimmedByZeros === numStr){
                      //     if(options.leadingZeros) return num;
                      //     else return str;
                      // }else return str;
                      if (numTrimmedByZeros === numStr) return num;else if (sign + numTrimmedByZeros === numStr) return num;else return str;
                    }

                    if (trimmedStr === numStr) return num;else if (trimmedStr === sign + numStr) return num;
                    // else{
                    //     //number with +/- sign
                    //     trimmedStr.test(/[-+][0-9]);

                    // }
                    return str;
                  }
              // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
            } else {
              //non-numeric string
              return str;
            }
          }
        }

        /**
         * 
         * @param {string} numStr without leading zeros
         * @returns 
         */
        function trimZeros(numStr) {
          if (numStr && numStr.indexOf(".") !== -1) {
            //float
            numStr = numStr.replace(/0+$/, ""); //remove ending zeros
            if (numStr === ".") numStr = "0";else if (numStr[0] === ".") numStr = "0" + numStr;else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
            return numStr;
          }
          return numStr;
        }
        module.exports = toNumber;

        /***/
      },

      /***/"./node_modules/webpack/buildin/amd-options.js":
      /*!****************************************!*\
        !*** (webpack)/buildin/amd-options.js ***!
        \****************************************/
      /*! no static exports found */
      /***/function node_modulesWebpackBuildinAmdOptionsJs(module, exports) {

        /* WEBPACK VAR INJECTION */(function (__webpack_amd_options__) {
          /* globals __webpack_amd_options__ */
          module.exports = __webpack_amd_options__;

          /* WEBPACK VAR INJECTION */
        }).call(this, {});

        /***/
      },

      /***/"./node_modules/webpack/buildin/module.js":
      /*!***********************************!*\
        !*** (webpack)/buildin/module.js ***!
        \***********************************/
      /*! no static exports found */
      /***/function node_modulesWebpackBuildinModuleJs(module, exports) {

        module.exports = function (module) {
          if (!module.webpackPolyfill) {
            module.deprecate = function () {};
            module.paths = [];
            // module.parent = undefined by default
            if (!module.children) module.children = [];
            Object.defineProperty(module, "loaded", {
              enumerable: true,
              get: function get() {
                return module.l;
              }
            });
            Object.defineProperty(module, "id", {
              enumerable: true,
              get: function get() {
                return module.i;
              }
            });
            module.webpackPolyfill = 1;
          }
          return module;
        };

        /***/
      },

      /***/"./package.json":
      /*!**********************!*\
        !*** ./package.json ***!
        \**********************/
      /*! exports provided: name, version, description, main, types, scripts, repository, keywords, author, license, bugs, homepage, dependencies, devDependencies, default */
      /***/function packageJson(module) {

        module.exports = JSON.parse("{\"name\":\"cos-js-sdk-v5\",\"version\":\"1.8.4\",\"description\":\"JavaScript SDK for [腾讯云对象存储](https://cloud.tencent.com/product/cos)\",\"main\":\"dist/cos-js-sdk-v5.js\",\"types\":\"index.d.ts\",\"scripts\":{\"prettier\":\"prettier --write src demo/demo.js demo/CIDemos/*.js test/test.js server/sts.js lib/request.js index.d.ts\",\"server\":\"node server/sts.js\",\"dev\":\"cross-env NODE_ENV=development webpack -w --mode=development\",\"build\":\"cross-env NODE_ENV=production webpack --mode=production\",\"cos-auth.min.js\":\"uglifyjs ./demo/common/cos-auth.js -o ./demo/common/cos-auth.min.js -c -m\",\"test\":\"jest --runInBand --coverage\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/tencentyun/cos-js-sdk-v5.git\"},\"keywords\":[],\"author\":\"carsonxu\",\"license\":\"ISC\",\"bugs\":{\"url\":\"https://github.com/tencentyun/cos-js-sdk-v5/issues\"},\"homepage\":\"https://github.com/tencentyun/cos-js-sdk-v5#readme\",\"dependencies\":{\"fast-xml-parser\":\"^4.4.0\"},\"devDependencies\":{\"@babel/core\":\"7.17.9\",\"@babel/plugin-transform-runtime\":\"7.18.10\",\"@babel/preset-env\":\"7.16.11\",\"babel-loader\":\"8.2.5\",\"body-parser\":\"^1.18.3\",\"cross-env\":\"^5.2.0\",\"express\":\"^4.16.4\",\"jest\":\"^29.3.1\",\"jest-environment-jsdom\":\"^29.3.1\",\"prettier\":\"^3.0.1\",\"qcloud-cos-sts\":\"^3.0.2\",\"request\":\"^2.87.0\",\"terser-webpack-plugin\":\"4.2.3\",\"uglifyjs\":\"^2.4.11\",\"webpack\":\"4.46.0\",\"webpack-cli\":\"4.10.0\"}}");

        /***/
      },

      /***/"./src/advance.js":
      /*!************************!*\
        !*** ./src/advance.js ***!
        \************************/
      /*! no static exports found */
      /***/function srcAdvanceJs(module, exports, __webpack_require__) {

        var _typeof = __webpack_require__( /*! @babel/runtime/helpers/typeof */"./node_modules/@babel/runtime/helpers/typeof.js");
        var session = __webpack_require__( /*! ./session */"./src/session.js");
        var Async = __webpack_require__( /*! ./async */"./src/async.js");
        var EventProxy = __webpack_require__( /*! ./event */"./src/event.js").EventProxy;
        var util = __webpack_require__( /*! ./util */"./src/util.js");
        var Tracker = __webpack_require__( /*! ./tracker */"./src/tracker.js");

        // 文件分块上传全过程，暴露的分块上传接口
        function sliceUploadFile(params, callback) {
          var self = this;
          var ep = new EventProxy();
          var TaskId = params.TaskId;
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var Body = params.Body;
          var ChunkSize = params.ChunkSize || params.SliceSize || self.options.ChunkSize;
          var AsyncLimit = params.AsyncLimit;
          var StorageClass = params.StorageClass;
          var ServerSideEncryption = params.ServerSideEncryption;
          var FileSize;
          var onProgress;
          var onHashProgress = params.onHashProgress;
          var tracker = params.tracker;
          tracker && tracker.setParams({
            chunkSize: ChunkSize
          });

          // 上传过程中出现错误，返回错误
          ep.on('error', function (err) {
            if (!self._isRunningTask(TaskId)) return;
            err.UploadId = params.UploadData.UploadId || '';
            return callback(err);
          });

          // 上传分块完成，开始 uploadSliceComplete 操作
          ep.on('upload_complete', function (UploadCompleteData) {
            var _UploadCompleteData = util.extend({
              UploadId: params.UploadData.UploadId || ''
            }, UploadCompleteData);
            callback(null, _UploadCompleteData);
          });

          // 上传分块完成，开始 uploadSliceComplete 操作
          ep.on('upload_slice_complete', function (UploadData) {
            var metaHeaders = {};
            util.each(params.Headers, function (val, k) {
              var shortKey = k.toLowerCase();
              if (shortKey.indexOf('x-cos-meta-') === 0 || ['pic-operations', 'x-cos-callback', 'x-cos-callback-var', 'x-cos-return-body'].includes(shortKey)) {
                metaHeaders[k] = val;
              }
            });
            uploadSliceComplete.call(self, {
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              UploadId: UploadData.UploadId,
              SliceList: UploadData.SliceList,
              Headers: metaHeaders,
              tracker: tracker
            }, function (err, data) {
              if (!self._isRunningTask(TaskId)) return;
              session.removeUsing(UploadData.UploadId);
              if (err) {
                onProgress(null, true);
                return ep.emit('error', err);
              }
              session.removeUploadId.call(self, UploadData.UploadId);
              onProgress({
                loaded: FileSize,
                total: FileSize
              }, true);
              ep.emit('upload_complete', data);
            });
          });

          // 获取 UploadId 完成，开始上传每个分片
          ep.on('get_upload_data_finish', function (UploadData) {
            // 处理 UploadId 缓存
            var uuid = session.getFileId(Body, params.ChunkSize, Bucket, Key);
            uuid && session.saveUploadId.call(self, uuid, UploadData.UploadId, self.options.UploadIdCacheLimit); // 缓存 UploadId
            session.setUsing(UploadData.UploadId); // 标记 UploadId 为正在使用

            // 获取 UploadId
            onProgress(null, true); // 任务状态开始 uploading
            uploadSliceList.call(self, {
              TaskId: TaskId,
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              Body: Body,
              FileSize: FileSize,
              SliceSize: ChunkSize,
              AsyncLimit: AsyncLimit,
              ServerSideEncryption: ServerSideEncryption,
              UploadData: UploadData,
              Headers: params.Headers,
              onProgress: onProgress,
              tracker: tracker
            }, function (err, data) {
              if (!self._isRunningTask(TaskId)) return;
              if (err) {
                onProgress(null, true);
                return ep.emit('error', err);
              }
              ep.emit('upload_slice_complete', data);
            });
          });

          // 开始获取文件 UploadId，里面会视情况计算 ETag，并比对，保证文件一致性，也优化上传
          ep.on('get_file_size_finish', function () {
            onProgress = util.throttleOnProgress.call(self, FileSize, params.onProgress);
            if (params.UploadData.UploadId) {
              ep.emit('get_upload_data_finish', params.UploadData);
            } else {
              var _params = util.extend({
                TaskId: TaskId,
                Bucket: Bucket,
                Region: Region,
                Key: Key,
                Headers: params.Headers,
                StorageClass: StorageClass,
                Body: Body,
                FileSize: FileSize,
                SliceSize: ChunkSize,
                onHashProgress: onHashProgress,
                tracker: tracker
              }, params);
              getUploadIdAndPartList.call(self, _params, function (err, UploadData) {
                if (!self._isRunningTask(TaskId)) return;
                if (err) return ep.emit('error', err);
                params.UploadData.UploadId = UploadData.UploadId;
                params.UploadData.PartList = UploadData.PartList;
                ep.emit('get_upload_data_finish', params.UploadData);
              });
            }
          });

          // 获取上传文件大小
          FileSize = params.ContentLength;
          delete params.ContentLength;
          !params.Headers && (params.Headers = {});
          util.each(params.Headers, function (item, key) {
            if (key.toLowerCase() === 'content-length') {
              delete params.Headers[key];
            }
          });

          // 控制分片大小
          (function () {
            var SIZE = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 1024 * 2, 1024 * 4, 1024 * 5];
            var AutoChunkSize = 1024 * 1024;
            for (var i = 0; i < SIZE.length; i++) {
              AutoChunkSize = SIZE[i] * 1024 * 1024;
              if (FileSize / AutoChunkSize <= self.options.MaxPartNumber) break;
            }
            params.ChunkSize = params.SliceSize = ChunkSize = Math.max(ChunkSize, AutoChunkSize);
          })();

          // 开始上传
          if (FileSize === 0) {
            params.Body = '';
            params.ContentLength = 0;
            params.SkipTask = true;
            self.putObject(params, callback);
          } else {
            ep.emit('get_file_size_finish');
          }
        }

        // 获取上传任务的 UploadId
        function getUploadIdAndPartList(params, callback) {
          var TaskId = params.TaskId;
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var StorageClass = params.StorageClass;
          var self = this;

          // 计算 ETag
          var ETagMap = {};
          var FileSize = params.FileSize;
          var SliceSize = params.SliceSize;
          var SliceCount = Math.ceil(FileSize / SliceSize);
          var FinishSliceCount = 0;
          var FinishSize = 0;
          var onHashProgress = util.throttleOnProgress.call(self, FileSize, params.onHashProgress);
          var getChunkETag = function getChunkETag(PartNumber, callback) {
            var start = SliceSize * (PartNumber - 1);
            var end = Math.min(start + SliceSize, FileSize);
            var ChunkSize = end - start;
            if (ETagMap[PartNumber]) {
              callback(null, {
                PartNumber: PartNumber,
                ETag: ETagMap[PartNumber],
                Size: ChunkSize
              });
            } else {
              util.fileSlice(params.Body, start, end, false, function (chunkItem) {
                util.getFileMd5(chunkItem, function (err, md5) {
                  if (err) return callback(util.error(err));
                  var ETag = '"' + md5 + '"';
                  ETagMap[PartNumber] = ETag;
                  FinishSliceCount += 1;
                  FinishSize += ChunkSize;
                  onHashProgress({
                    loaded: FinishSize,
                    total: FileSize
                  });
                  callback(null, {
                    PartNumber: PartNumber,
                    ETag: ETag,
                    Size: ChunkSize
                  });
                });
              });
            }
          };

          // 通过和文件的 md5 对比，判断 UploadId 是否可用
          var isAvailableUploadList = function isAvailableUploadList(PartList, callback) {
            var PartCount = PartList.length;
            // 如果没有分片，通过
            if (PartCount === 0) {
              return callback(null, true);
            }
            // 检查分片数量
            if (PartCount > SliceCount) {
              return callback(null, false);
            }
            // 检查分片大小
            if (PartCount > 1) {
              var PartSliceSize = Math.max(PartList[0].Size, PartList[1].Size);
              if (PartSliceSize !== SliceSize) {
                return callback(null, false);
              }
            }
            // 逐个分片计算并检查 ETag 是否一致
            var next = function next(index) {
              if (index < PartCount) {
                var Part = PartList[index];
                getChunkETag(Part.PartNumber, function (err, chunk) {
                  if (chunk && chunk.ETag === Part.ETag && chunk.Size === Part.Size) {
                    next(index + 1);
                  } else {
                    callback(null, false);
                  }
                });
              } else {
                callback(null, true);
              }
            };
            next(0);
          };
          var ep = new EventProxy();
          ep.on('error', function (errData) {
            if (!self._isRunningTask(TaskId)) return;
            return callback(errData);
          });

          // 存在 UploadId
          ep.on('upload_id_available', function (UploadData) {
            // 转换成 map
            var map = {};
            var list = [];
            util.each(UploadData.PartList, function (item) {
              map[item.PartNumber] = item;
            });
            for (var PartNumber = 1; PartNumber <= SliceCount; PartNumber++) {
              var item = map[PartNumber];
              if (item) {
                item.PartNumber = PartNumber;
                item.Uploaded = true;
              } else {
                item = {
                  PartNumber: PartNumber,
                  ETag: null,
                  Uploaded: false
                };
              }
              list.push(item);
            }
            UploadData.PartList = list;
            callback(null, UploadData);
          });

          // 不存在 UploadId, 初始化生成 UploadId
          ep.on('no_available_upload_id', function () {
            if (!self._isRunningTask(TaskId)) return;
            var _params = util.extend({
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              Query: util.clone(params.Query),
              StorageClass: StorageClass,
              Body: params.Body,
              calledBySdk: 'sliceUploadFile',
              tracker: params.tracker
            }, params);
            var headers = util.clone(params.Headers);
            delete headers['x-cos-mime-limit'];
            _params.Headers = headers;
            self.multipartInit(_params, function (err, data) {
              if (!self._isRunningTask(TaskId)) return;
              if (err) return ep.emit('error', err);
              var UploadId = data.UploadId;
              if (!UploadId) {
                return callback(util.error(new Error('no such upload id')));
              }
              ep.emit('upload_id_available', {
                UploadId: UploadId,
                PartList: []
              });
            });
          });

          // 如果已存在 UploadId，找一个可以用的 UploadId
          ep.on('has_and_check_upload_id', function (UploadIdList) {
            // 串行地，找一个内容一致的 UploadId
            UploadIdList = UploadIdList.reverse();
            Async.eachLimit(UploadIdList, 1, function (UploadId, asyncCallback) {
              if (!self._isRunningTask(TaskId)) return;
              // 如果正在上传，跳过
              if (session.using[UploadId]) {
                asyncCallback(); // 检查下一个 UploadId
                return;
              }
              // 判断 UploadId 是否可用
              wholeMultipartListPart.call(self, {
                Bucket: Bucket,
                Region: Region,
                Key: Key,
                UploadId: UploadId,
                tracker: params.tracker
              }, function (err, PartListData) {
                if (!self._isRunningTask(TaskId)) return;
                if (err) {
                  session.removeUsing(UploadId);
                  return ep.emit('error', err);
                }
                var PartList = PartListData.PartList;
                PartList.forEach(function (item) {
                  item.PartNumber *= 1;
                  item.Size *= 1;
                  item.ETag = item.ETag || '';
                });
                isAvailableUploadList(PartList, function (err, isAvailable) {
                  if (!self._isRunningTask(TaskId)) return;
                  if (err) return ep.emit('error', err);
                  if (isAvailable) {
                    asyncCallback({
                      UploadId: UploadId,
                      PartList: PartList
                    }); // 马上结束
                  } else {
                    asyncCallback(); // 检查下一个 UploadId
                  }
                });
              });
            }, function (AvailableUploadData) {
              if (!self._isRunningTask(TaskId)) return;
              onHashProgress(null, true);
              if (AvailableUploadData && AvailableUploadData.UploadId) {
                ep.emit('upload_id_available', AvailableUploadData);
              } else {
                ep.emit('no_available_upload_id');
              }
            });
          });

          // 在本地缓存找可用的 UploadId
          ep.on('seek_local_avail_upload_id', function (RemoteUploadIdList) {
            // 在本地找可用的 UploadId
            var uuid = session.getFileId(params.Body, params.ChunkSize, Bucket, Key);
            var LocalUploadIdList = session.getUploadIdList.call(self, uuid);
            if (!uuid || !LocalUploadIdList) {
              ep.emit('has_and_check_upload_id', RemoteUploadIdList);
              return;
            }
            var next = function next(index) {
              // 如果本地找不到可用 UploadId，再一个个遍历校验远端
              if (index >= LocalUploadIdList.length) {
                ep.emit('has_and_check_upload_id', RemoteUploadIdList);
                return;
              }
              var UploadId = LocalUploadIdList[index];
              // 如果不在远端 UploadId 列表里，跳过并删除
              if (!util.isInArray(RemoteUploadIdList, UploadId)) {
                session.removeUploadId.call(self, UploadId);
                next(index + 1);
                return;
              }
              // 如果正在上传，跳过
              if (session.using[UploadId]) {
                next(index + 1);
                return;
              }
              // 判断 UploadId 是否存在线上
              wholeMultipartListPart.call(self, {
                Bucket: Bucket,
                Region: Region,
                Key: Key,
                UploadId: UploadId,
                tracker: params.tracker
              }, function (err, PartListData) {
                if (!self._isRunningTask(TaskId)) return;
                if (err) {
                  // 如果 UploadId 获取会出错，跳过并删除
                  session.removeUploadId.call(self, UploadId);
                  next(index + 1);
                } else {
                  // 找到可用 UploadId
                  ep.emit('upload_id_available', {
                    UploadId: UploadId,
                    PartList: PartListData.PartList
                  });
                }
              });
            };
            next(0);
          });

          // 获取线上 UploadId 列表
          ep.on('get_remote_upload_id_list', function () {
            // 获取符合条件的 UploadId 列表，因为同一个文件可以有多个上传任务。
            wholeMultipartList.call(self, {
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              tracker: params.tracker
            }, function (err, data) {
              if (!self._isRunningTask(TaskId)) return;
              if (err) return ep.emit('error', err);
              // 整理远端 UploadId 列表
              var RemoteUploadIdList = util.filter(data.UploadList, function (item) {
                return item.Key === Key && (!StorageClass || item.StorageClass.toUpperCase() === StorageClass.toUpperCase());
              }).reverse().map(function (item) {
                return item.UploadId || item.UploadID;
              });
              if (RemoteUploadIdList.length) {
                ep.emit('seek_local_avail_upload_id', RemoteUploadIdList);
              } else {
                // 远端没有 UploadId，清理缓存的 UploadId
                var uuid = session.getFileId(params.Body, params.ChunkSize, Bucket, Key),
                    LocalUploadIdList;
                if (uuid && (LocalUploadIdList = session.getUploadIdList.call(self, uuid))) {
                  util.each(LocalUploadIdList, function (UploadId) {
                    session.removeUploadId.call(self, UploadId);
                  });
                }
                ep.emit('no_available_upload_id');
              }
            });
          });

          // 开始找可用 UploadId
          ep.emit('get_remote_upload_id_list');
        }

        // 获取符合条件的全部上传任务 (条件包括 Bucket, Region, Prefix)
        function wholeMultipartList(params, callback) {
          var self = this;
          var UploadList = [];
          var sendParams = {
            Bucket: params.Bucket,
            Region: params.Region,
            Prefix: params.Key,
            calledBySdk: params.calledBySdk || 'sliceUploadFile',
            tracker: params.tracker
          };
          var next = function next() {
            self.multipartList(sendParams, function (err, data) {
              if (err) return callback(err);
              UploadList.push.apply(UploadList, data.Upload || []);
              if (data.IsTruncated === 'true') {
                // 列表不完整
                sendParams.KeyMarker = data.NextKeyMarker;
                sendParams.UploadIdMarker = data.NextUploadIdMarker;
                next();
              } else {
                callback(null, {
                  UploadList: UploadList
                });
              }
            });
          };
          next();
        }

        // 获取指定上传任务的分块列表
        function wholeMultipartListPart(params, callback) {
          var self = this;
          var PartList = [];
          var sendParams = {
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            UploadId: params.UploadId,
            calledBySdk: 'sliceUploadFile',
            tracker: params.tracker
          };
          var next = function next() {
            self.multipartListPart(sendParams, function (err, data) {
              if (err) return callback(err);
              PartList.push.apply(PartList, data.Part || []);
              if (data.IsTruncated === 'true') {
                // 列表不完整
                sendParams.PartNumberMarker = data.NextPartNumberMarker;
                next();
              } else {
                callback(null, {
                  PartList: PartList
                });
              }
            });
          };
          next();
        }

        // 上传文件分块，包括
        /*
         UploadId (上传任务编号)
         AsyncLimit (并发量)，
         SliceList (上传的分块数组)，
         FilePath (本地文件的位置)，
         SliceSize (文件分块大小)
         FileSize (文件大小)
         onProgress (上传成功之后的回调函数)
         */
        function uploadSliceList(params, cb) {
          var self = this;
          var TaskId = params.TaskId;
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var UploadData = params.UploadData;
          var FileSize = params.FileSize;
          var SliceSize = params.SliceSize;
          var ChunkParallel = Math.min(params.AsyncLimit || self.options.ChunkParallelLimit || 1, 256);
          var Body = params.Body;
          var SliceCount = Math.ceil(FileSize / SliceSize);
          var FinishSize = 0;
          var ServerSideEncryption = params.ServerSideEncryption;
          var Headers = params.Headers;
          var needUploadSlices = util.filter(UploadData.PartList, function (SliceItem) {
            if (SliceItem['Uploaded']) {
              FinishSize += SliceItem['PartNumber'] >= SliceCount ? FileSize % SliceSize || SliceSize : SliceSize;
            }
            return !SliceItem['Uploaded'];
          });
          var _onProgress2 = params.onProgress;
          Async.eachLimit(needUploadSlices, ChunkParallel, function (SliceItem, asyncCallback) {
            if (!self._isRunningTask(TaskId)) return;
            var PartNumber = SliceItem['PartNumber'];
            var currentSize = Math.min(FileSize, SliceItem['PartNumber'] * SliceSize) - (SliceItem['PartNumber'] - 1) * SliceSize;
            var preAddSize = 0;
            uploadSliceItem.call(self, {
              TaskId: TaskId,
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              SliceSize: SliceSize,
              FileSize: FileSize,
              PartNumber: PartNumber,
              ServerSideEncryption: ServerSideEncryption,
              Body: Body,
              UploadData: UploadData,
              Headers: Headers,
              onProgress: function onProgress(data) {
                FinishSize += data.loaded - preAddSize;
                preAddSize = data.loaded;
                _onProgress2({
                  loaded: FinishSize,
                  total: FileSize
                });
              },
              tracker: params.tracker
            }, function (err, data) {
              if (!self._isRunningTask(TaskId)) return;
              if (!err && !data.ETag) err = 'get ETag error, please add "ETag" to CORS ExposeHeader setting.( 获取ETag失败，请在CORS ExposeHeader设置中添加ETag，请参考文档：https://cloud.tencent.com/document/product/436/13318 )';
              if (err) {
                FinishSize -= preAddSize;
              } else {
                FinishSize += currentSize - preAddSize;
                SliceItem.ETag = data.ETag;
              }
              _onProgress2({
                loaded: FinishSize,
                total: FileSize
              });
              asyncCallback(err || null, data);
            });
          }, function (err) {
            if (!self._isRunningTask(TaskId)) return;
            if (err) return cb(err);
            cb(null, {
              UploadId: UploadData.UploadId,
              SliceList: UploadData.PartList
            });
          });
        }

        // 上传指定分片
        function uploadSliceItem(params, callback) {
          var self = this;
          var TaskId = params.TaskId;
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var FileSize = params.FileSize;
          var FileBody = params.Body;
          var PartNumber = params.PartNumber * 1;
          var SliceSize = params.SliceSize;
          var ServerSideEncryption = params.ServerSideEncryption;
          var UploadData = params.UploadData;
          var Headers = params.Headers || {};
          var ChunkRetryTimes = self.options.ChunkRetryTimes + 1;
          var start = SliceSize * (PartNumber - 1);
          var ContentLength = SliceSize;
          var end = start + SliceSize;
          if (end > FileSize) {
            end = FileSize;
            ContentLength = end - start;
          }
          var headersWhiteList = ['x-cos-traffic-limit', 'x-cos-mime-limit'];
          var headers = {};
          util.each(Headers, function (v, k) {
            if (headersWhiteList.indexOf(k) > -1) {
              headers[k] = v;
            }
          });
          var PartItem = UploadData.PartList[PartNumber - 1];
          Async.retry(ChunkRetryTimes, function (tryCallback) {
            if (!self._isRunningTask(TaskId)) return;
            util.fileSlice(FileBody, start, end, true, function (Body) {
              self.multipartUpload({
                TaskId: TaskId,
                Bucket: Bucket,
                Region: Region,
                Key: Key,
                ContentLength: ContentLength,
                PartNumber: PartNumber,
                UploadId: UploadData.UploadId,
                ServerSideEncryption: ServerSideEncryption,
                Body: Body,
                Headers: headers,
                onProgress: params.onProgress,
                calledBySdk: 'sliceUploadFile',
                tracker: params.tracker
              }, function (err, data) {
                if (!self._isRunningTask(TaskId)) return;
                if (err) return tryCallback(err);
                PartItem.Uploaded = true;
                return tryCallback(null, data);
              });
            });
          }, function (err, data) {
            if (!self._isRunningTask(TaskId)) return;
            return callback(err, data);
          });
        }

        // 完成分块上传
        function uploadSliceComplete(params, callback) {
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var UploadId = params.UploadId;
          var SliceList = params.SliceList;
          var self = this;
          var ChunkRetryTimes = this.options.ChunkRetryTimes + 1;
          var Headers = params.Headers;
          var Parts = SliceList.map(function (item) {
            return {
              PartNumber: item.PartNumber,
              ETag: item.ETag
            };
          });
          // 完成上传的请求也做重试
          Async.retry(ChunkRetryTimes, function (tryCallback) {
            self.multipartComplete({
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              UploadId: UploadId,
              Parts: Parts,
              Headers: Headers,
              calledBySdk: 'sliceUploadFile',
              tracker: params.tracker
            }, tryCallback);
          }, function (err, data) {
            callback(err, data);
          });
        }

        // 抛弃分块上传任务
        /*
         AsyncLimit (抛弃上传任务的并发量)，
         UploadId (上传任务的编号，当 Level 为 task 时候需要)
         Level (抛弃分块上传任务的级别，task : 抛弃指定的上传任务，file ： 抛弃指定的文件对应的上传任务，其他值 ：抛弃指定Bucket 的全部上传任务)
         */
        function abortUploadTask(params, callback) {
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var UploadId = params.UploadId;
          var Level = params.Level || 'task';
          var AsyncLimit = params.AsyncLimit;
          var self = this;
          var ep = new EventProxy();
          ep.on('error', function (errData) {
            return callback(errData);
          });

          // 已经获取到需要抛弃的任务列表
          ep.on('get_abort_array', function (AbortArray) {
            abortUploadTaskArray.call(self, {
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              Headers: params.Headers,
              AsyncLimit: AsyncLimit,
              AbortArray: AbortArray
            }, callback);
          });
          if (Level === 'bucket') {
            // Bucket 级别的任务抛弃，抛弃该 Bucket 下的全部上传任务
            wholeMultipartList.call(self, {
              Bucket: Bucket,
              Region: Region,
              calledBySdk: 'abortUploadTask'
            }, function (err, data) {
              if (err) return callback(err);
              ep.emit('get_abort_array', data.UploadList || []);
            });
          } else if (Level === 'file') {
            // 文件级别的任务抛弃，抛弃该文件的全部上传任务
            if (!Key) return callback(util.error(new Error('abort_upload_task_no_key')));
            wholeMultipartList.call(self, {
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              calledBySdk: 'abortUploadTask'
            }, function (err, data) {
              if (err) return callback(err);
              ep.emit('get_abort_array', data.UploadList || []);
            });
          } else if (Level === 'task') {
            // 单个任务级别的任务抛弃，抛弃指定 UploadId 的上传任务
            if (!UploadId) return callback(util.error(new Error('abort_upload_task_no_id')));
            if (!Key) return callback(util.error(new Error('abort_upload_task_no_key')));
            ep.emit('get_abort_array', [{
              Key: Key,
              UploadId: UploadId
            }]);
          } else {
            return callback(util.error(new Error('abort_unknown_level')));
          }
        }

        // 批量抛弃分块上传任务
        function abortUploadTaskArray(params, callback) {
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var AbortArray = params.AbortArray;
          var AsyncLimit = params.AsyncLimit || 1;
          var self = this;
          var index = 0;
          var resultList = new Array(AbortArray.length);
          Async.eachLimit(AbortArray, AsyncLimit, function (AbortItem, nextItem) {
            var eachIndex = index;
            if (Key && Key !== AbortItem.Key) {
              resultList[eachIndex] = {
                error: {
                  KeyNotMatch: true
                }
              };
              nextItem(null);
              return;
            }
            var UploadId = AbortItem.UploadId || AbortItem.UploadID;
            self.multipartAbort({
              Bucket: Bucket,
              Region: Region,
              Key: AbortItem.Key,
              Headers: params.Headers,
              UploadId: UploadId
            }, function (err) {
              var task = {
                Bucket: Bucket,
                Region: Region,
                Key: AbortItem.Key,
                UploadId: UploadId
              };
              resultList[eachIndex] = {
                error: err,
                task: task
              };
              nextItem(null);
            });
            index++;
          }, function (err) {
            if (err) return callback(err);
            var successList = [];
            var errorList = [];
            for (var i = 0, len = resultList.length; i < len; i++) {
              var item = resultList[i];
              if (item['task']) {
                if (item['error']) {
                  errorList.push(item['task']);
                } else {
                  successList.push(item['task']);
                }
              }
            }
            return callback(null, {
              successList: successList,
              errorList: errorList
            });
          });
        }

        // 高级上传
        function uploadFile(params, callback) {
          var self = this;

          // 判断多大的文件使用分片上传
          var SliceSize = params.SliceSize === undefined ? self.options.SliceSize : params.SliceSize;
          var taskList = [];
          var Body = params.Body;
          var FileSize = Body.size || Body.length || 0;
          var fileInfo = {
            TaskId: ''
          };

          // 上传链路
          if (self.options.EnableReporter) {
            var accelerate = self.options.UseAccelerate || typeof self.options.Domain === 'string' && self.options.Domain.includes('accelerate.');
            var realApi = FileSize > SliceSize ? 'sliceUploadFile' : 'putObject';
            params.tracker = new Tracker({
              Beacon: self.options.BeaconReporter,
              clsReporter: self.options.ClsReporter,
              bucket: params.Bucket,
              region: params.Region,
              apiName: 'uploadFile',
              realApi: realApi,
              fileKey: params.Key,
              fileSize: FileSize,
              accelerate: accelerate,
              deepTracker: self.options.DeepTracker,
              customId: self.options.CustomId,
              delay: self.options.TrackerDelay
            });
          }

          // 整理 option，用于返回给回调
          util.each(params, function (v, k) {
            if (_typeof(v) !== 'object' && typeof v !== 'function') {
              fileInfo[k] = v;
            }
          });

          // 处理文件 TaskReady
          var _onTaskReady = params.onTaskReady;
          var onTaskReady = function onTaskReady(tid) {
            fileInfo.TaskId = tid;
            _onTaskReady && _onTaskReady(tid);
          };
          params.onTaskReady = onTaskReady;

          // 添加上传任务,超过阈值使用分块上传，小于等于则简单上传
          var api = FileSize > SliceSize ? 'sliceUploadFile' : 'putObject';

          // 处理文件完成
          var _onFileFinish = params.onFileFinish;
          var onFileFinish = function onFileFinish(err, data) {
            // 格式化上报参数并上报
            params.tracker && params.tracker.report(err, data);
            _onFileFinish && _onFileFinish(err, data, fileInfo);
            callback && callback(err, data);
          };
          taskList.push({
            api: api,
            params: params,
            callback: onFileFinish
          });
          self._addTasks(taskList);
        }

        // 批量上传文件
        function uploadFiles(params, callback) {
          var self = this;

          // 判断多大的文件使用分片上传
          var SliceSize = params.SliceSize === undefined ? self.options.SliceSize : params.SliceSize;

          // 汇总返回进度
          var TotalSize = 0;
          var TotalFinish = 0;
          var onTotalProgress = util.throttleOnProgress.call(self, TotalFinish, params.onProgress);

          // 汇总返回回调
          var unFinishCount = params.files.length;
          var _onTotalFileFinish = params.onFileFinish;
          var resultList = Array(unFinishCount);
          var onTotalFileFinish = function onTotalFileFinish(err, data, options) {
            onTotalProgress(null, true);
            _onTotalFileFinish && _onTotalFileFinish(err, data, options);
            resultList[options.Index] = {
              options: options,
              error: err,
              data: data
            };
            if (--unFinishCount <= 0 && callback) {
              callback(null, {
                files: resultList
              });
            }
          };

          // 开始处理每个文件
          var taskList = [];
          util.each(params.files, function (fileParams, index) {
            (function () {
              var Body = fileParams.Body;
              var FileSize = Body.size || Body.length || 0;
              var fileInfo = {
                Index: index,
                TaskId: ''
              };

              // 如果 批量上传的 Key 是 / 开头，强制去掉第一个 /
              if (!self.options.UseRawKey && fileParams.Key && fileParams.Key.substr(0, 1) === '/') {
                fileParams.Key = fileParams.Key.substr(1);
              }

              // 更新文件总大小
              TotalSize += FileSize;

              // 单个文件上传链路
              if (self.options.EnableReporter) {
                var accelerate = self.options.UseAccelerate || typeof self.options.Domain === 'string' && self.options.Domain.includes('accelerate.');
                var realApi = FileSize > SliceSize ? 'sliceUploadFile' : 'putObject';
                fileParams.tracker = new Tracker({
                  Beacon: self.options.BeaconReporter,
                  clsReporter: self.options.ClsReporter,
                  bucket: fileParams.Bucket,
                  region: fileParams.Region,
                  apiName: 'uploadFiles',
                  realApi: realApi,
                  fileKey: fileParams.Key,
                  fileSize: FileSize,
                  accelerate: accelerate,
                  deepTracker: self.options.DeepTracker,
                  customId: self.options.CustomId,
                  delay: self.options.TrackerDelay
                });
              }

              // 整理 option，用于返回给回调
              util.each(fileParams, function (v, k) {
                if (_typeof(v) !== 'object' && typeof v !== 'function') {
                  fileInfo[k] = v;
                }
              });

              // 处理单个文件 TaskReady
              var _onTaskReady = fileParams.onTaskReady;
              var onTaskReady = function onTaskReady(tid) {
                fileInfo.TaskId = tid;
                _onTaskReady && _onTaskReady(tid);
              };
              fileParams.onTaskReady = onTaskReady;

              // 处理单个文件进度
              var PreAddSize = 0;
              var _onProgress = fileParams.onProgress;
              var onProgress = function onProgress(info) {
                TotalFinish = TotalFinish - PreAddSize + info.loaded;
                PreAddSize = info.loaded;
                _onProgress && _onProgress(info);
                onTotalProgress({
                  loaded: TotalFinish,
                  total: TotalSize
                });
              };
              fileParams.onProgress = onProgress;

              // 添加上传任务
              var api = FileSize > SliceSize ? 'sliceUploadFile' : 'putObject';

              // 处理单个文件完成
              var _onFileFinish = fileParams.onFileFinish;
              var onFileFinish = function onFileFinish(err, data) {
                // 格式化上报参数并上报
                fileParams.tracker && fileParams.tracker.report(err, data);
                _onFileFinish && _onFileFinish(err, data);
                onTotalFileFinish && onTotalFileFinish(err, data, fileInfo);
              };
              taskList.push({
                api: api,
                params: fileParams,
                callback: onFileFinish
              });
            })();
          });
          self._addTasks(taskList);
        }

        // 分片复制文件
        function sliceCopyFile(params, callback) {
          var ep = new EventProxy();
          var self = this;
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var CopySource = params.CopySource;
          var m = util.getSourceParams.call(this, CopySource);
          if (!m) {
            callback(util.error(new Error('CopySource format error')));
            return;
          }
          var SourceBucket = m.Bucket;
          var SourceRegion = m.Region;
          var SourceKey = decodeURIComponent(m.Key);
          var CopySliceSize = params.CopySliceSize === undefined ? self.options.CopySliceSize : params.CopySliceSize;
          CopySliceSize = Math.max(0, CopySliceSize);
          var ChunkSize = params.CopyChunkSize || this.options.CopyChunkSize;
          var ChunkParallel = this.options.CopyChunkParallelLimit;
          var ChunkRetryTimes = this.options.ChunkRetryTimes + 1;
          var ChunkCount = 0;
          var FinishSize = 0;
          var FileSize;
          var onProgress;
          var SourceResHeaders = {};
          var SourceHeaders = {};
          var TargetHeader = {};

          // 分片复制完成，开始 multipartComplete 操作
          ep.on('copy_slice_complete', function (UploadData) {
            var metaHeaders = {};
            util.each(params.Headers, function (val, k) {
              if (k.toLowerCase().indexOf('x-cos-meta-') === 0) metaHeaders[k] = val;
            });
            var Parts = util.map(UploadData.PartList, function (item) {
              return {
                PartNumber: item.PartNumber,
                ETag: item.ETag
              };
            });
            // 完成上传的请求也做重试
            Async.retry(ChunkRetryTimes, function (tryCallback) {
              self.multipartComplete({
                Bucket: Bucket,
                Region: Region,
                Key: Key,
                UploadId: UploadData.UploadId,
                Parts: Parts,
                tracker: params.tracker,
                calledBySdk: 'sliceCopyFile'
              }, tryCallback);
            }, function (err, data) {
              session.removeUsing(UploadData.UploadId); // 标记 UploadId 没被使用了，因为复制没提供重试，所以只要出错，就是 UploadId 停用了。
              if (err) {
                onProgress(null, true);
                return callback(err);
              }
              session.removeUploadId(UploadData.UploadId);
              onProgress({
                loaded: FileSize,
                total: FileSize
              }, true);
              callback(null, data);
            });
          });
          ep.on('get_copy_data_finish', function (UploadData) {
            // 处理 UploadId 缓存
            var uuid = session.getCopyFileId(CopySource, SourceResHeaders, ChunkSize, Bucket, Key);
            uuid && session.saveUploadId(uuid, UploadData.UploadId, self.options.UploadIdCacheLimit); // 缓存 UploadId
            session.setUsing(UploadData.UploadId); // 标记 UploadId 为正在使用

            var needCopySlices = util.filter(UploadData.PartList, function (SliceItem) {
              if (SliceItem['Uploaded']) {
                FinishSize += SliceItem['PartNumber'] >= ChunkCount ? FileSize % ChunkSize || ChunkSize : ChunkSize;
              }
              return !SliceItem['Uploaded'];
            });
            Async.eachLimit(needCopySlices, ChunkParallel, function (SliceItem, asyncCallback) {
              var PartNumber = SliceItem.PartNumber;
              var CopySourceRange = SliceItem.CopySourceRange;
              var currentSize = SliceItem.end - SliceItem.start;
              Async.retry(ChunkRetryTimes, function (tryCallback) {
                copySliceItem.call(self, {
                  Bucket: Bucket,
                  Region: Region,
                  Key: Key,
                  CopySource: CopySource,
                  UploadId: UploadData.UploadId,
                  PartNumber: PartNumber,
                  CopySourceRange: CopySourceRange,
                  tracker: params.tracker,
                  calledBySdk: 'sliceCopyFile'
                }, tryCallback);
              }, function (err, data) {
                if (err) return asyncCallback(err);
                FinishSize += currentSize;
                onProgress({
                  loaded: FinishSize,
                  total: FileSize
                });
                SliceItem.ETag = data.ETag;
                asyncCallback(err || null, data);
              });
            }, function (err) {
              if (err) {
                session.removeUsing(UploadData.UploadId); // 标记 UploadId 没被使用了，因为复制没提供重试，所以只要出错，就是 UploadId 停用了。
                onProgress(null, true);
                return callback(err);
              }
              ep.emit('copy_slice_complete', UploadData);
            });
          });
          ep.on('get_chunk_size_finish', function () {
            var createNewUploadId = function createNewUploadId() {
              self.multipartInit({
                Bucket: Bucket,
                Region: Region,
                Key: Key,
                Headers: TargetHeader,
                tracker: params.tracker,
                calledBySdk: 'sliceCopyFile'
              }, function (err, data) {
                if (err) return callback(err);
                params.UploadId = data.UploadId;
                ep.emit('get_copy_data_finish', {
                  UploadId: params.UploadId,
                  PartList: params.PartList
                });
              });
            };

            // 在本地找可用的 UploadId
            var uuid = session.getCopyFileId(CopySource, SourceResHeaders, ChunkSize, Bucket, Key);
            var LocalUploadIdList = session.getUploadIdList(uuid);
            if (!uuid || !LocalUploadIdList) return createNewUploadId();
            var next = function next(index) {
              // 如果本地找不到可用 UploadId，再一个个遍历校验远端
              if (index >= LocalUploadIdList.length) return createNewUploadId();
              var UploadId = LocalUploadIdList[index];
              // 如果正在被使用，跳过
              if (session.using[UploadId]) return next(index + 1);
              // 判断 UploadId 是否存在线上
              wholeMultipartListPart.call(self, {
                Bucket: Bucket,
                Region: Region,
                Key: Key,
                UploadId: UploadId,
                tracker: params.tracker,
                calledBySdk: 'sliceCopyFile'
              }, function (err, PartListData) {
                if (err) {
                  // 如果 UploadId 获取会出错，跳过并删除
                  session.removeUploadId(UploadId);
                  next(index + 1);
                } else {
                  // 如果异步回来 UploadId 已经被用了，也跳过
                  if (session.using[UploadId]) return next(index + 1);
                  // 找到可用 UploadId
                  var finishETagMap = {};
                  var offset = 0;
                  util.each(PartListData.PartList, function (PartItem) {
                    var size = parseInt(PartItem.Size);
                    var end = offset + size - 1;
                    finishETagMap[PartItem.PartNumber + '|' + offset + '|' + end] = PartItem.ETag;
                    offset += size;
                  });
                  util.each(params.PartList, function (PartItem) {
                    var ETag = finishETagMap[PartItem.PartNumber + '|' + PartItem.start + '|' + PartItem.end];
                    if (ETag) {
                      PartItem.ETag = ETag;
                      PartItem.Uploaded = true;
                    }
                  });
                  ep.emit('get_copy_data_finish', {
                    UploadId: UploadId,
                    PartList: params.PartList
                  });
                }
              });
            };
            next(0);
          });
          ep.on('get_file_size_finish', function () {
            // 控制分片大小
            (function () {
              var SIZE = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 1024 * 2, 1024 * 4, 1024 * 5];
              var AutoChunkSize = 1024 * 1024;
              for (var i = 0; i < SIZE.length; i++) {
                AutoChunkSize = SIZE[i] * 1024 * 1024;
                if (FileSize / AutoChunkSize <= self.options.MaxPartNumber) break;
              }
              params.ChunkSize = ChunkSize = Math.max(ChunkSize, AutoChunkSize);
              ChunkCount = Math.ceil(FileSize / ChunkSize);
              var list = [];
              for (var partNumber = 1; partNumber <= ChunkCount; partNumber++) {
                var start = (partNumber - 1) * ChunkSize;
                var end = partNumber * ChunkSize < FileSize ? partNumber * ChunkSize - 1 : FileSize - 1;
                var item = {
                  PartNumber: partNumber,
                  start: start,
                  end: end,
                  CopySourceRange: 'bytes=' + start + '-' + end
                };
                list.push(item);
              }
              params.PartList = list;
            })();
            if (params.Headers['x-cos-metadata-directive'] === 'Replaced') {
              TargetHeader = params.Headers;
            } else {
              TargetHeader = SourceHeaders;
            }
            TargetHeader['x-cos-storage-class'] = params.Headers['x-cos-storage-class'] || SourceHeaders['x-cos-storage-class'];
            TargetHeader = util.clearKey(TargetHeader);
            /**
             * 对于归档存储的对象，如果未恢复副本，则不允许 Copy
             */
            if (SourceHeaders['x-cos-storage-class'] === 'ARCHIVE' || SourceHeaders['x-cos-storage-class'] === 'DEEP_ARCHIVE') {
              var restoreHeader = SourceHeaders['x-cos-restore'];
              if (!restoreHeader || restoreHeader === 'ongoing-request="true"') {
                callback(util.error(new Error('Unrestored archive object is not allowed to be copied')));
                return;
              }
            }
            /**
             * 去除一些无用的头部，规避 multipartInit 出错
             * 这些头部通常是在 putObjectCopy 时才使用
             */
            delete TargetHeader['x-cos-copy-source'];
            delete TargetHeader['x-cos-metadata-directive'];
            delete TargetHeader['x-cos-copy-source-If-Modified-Since'];
            delete TargetHeader['x-cos-copy-source-If-Unmodified-Since'];
            delete TargetHeader['x-cos-copy-source-If-Match'];
            delete TargetHeader['x-cos-copy-source-If-None-Match'];
            ep.emit('get_chunk_size_finish');
          });

          // 获取远端复制源文件的大小
          self.headObject({
            Bucket: SourceBucket,
            Region: SourceRegion,
            Key: SourceKey,
            tracker: params.tracker,
            calledBySdk: 'sliceCopyFile'
          }, function (err, data) {
            if (err) {
              if (err.statusCode && err.statusCode === 404) {
                callback(util.error(err, {
                  ErrorStatus: SourceKey + ' Not Exist'
                }));
              } else {
                callback(err);
              }
              return;
            }
            FileSize = params.FileSize = data.headers['content-length'];
            if (FileSize === undefined || !FileSize) {
              callback(util.error(new Error('get Content-Length error, please add "Content-Length" to CORS ExposeHeader setting.（ 获取Content-Length失败，请在CORS ExposeHeader设置中添加Content-Length，请参考文档：https://cloud.tencent.com/document/product/436/13318 ）')));
              return;
            }
            params.tracker && params.tracker.setParams({
              httpSize: FileSize
            });
            onProgress = util.throttleOnProgress.call(self, FileSize, params.onProgress);

            // 开始上传
            if (FileSize <= CopySliceSize) {
              if (!params.Headers['x-cos-metadata-directive']) {
                params.Headers['x-cos-metadata-directive'] = 'Copy';
              }
              self.putObjectCopy(Object.assign(params, {
                calledBySdk: 'sliceCopyFile'
              }), function (err, data) {
                if (err) {
                  onProgress(null, true);
                  return callback(err);
                }
                onProgress({
                  loaded: FileSize,
                  total: FileSize
                }, true);
                callback(err, data);
              });
            } else {
              var resHeaders = data.headers;
              SourceResHeaders = resHeaders;
              SourceHeaders = {
                'Cache-Control': resHeaders['cache-control'],
                'Content-Disposition': resHeaders['content-disposition'],
                'Content-Encoding': resHeaders['content-encoding'],
                'Content-Type': resHeaders['content-type'],
                Expires: resHeaders['expires'],
                'x-cos-storage-class': resHeaders['x-cos-storage-class']
              };
              util.each(resHeaders, function (v, k) {
                var metaPrefix = 'x-cos-meta-';
                if (k.indexOf(metaPrefix) === 0 && k.length > metaPrefix.length) {
                  SourceHeaders[k] = v;
                }
              });
              ep.emit('get_file_size_finish');
            }
          });
        }

        // 复制指定分片
        function copySliceItem(params, callback) {
          var TaskId = params.TaskId;
          var Bucket = params.Bucket;
          var Region = params.Region;
          var Key = params.Key;
          var CopySource = params.CopySource;
          var UploadId = params.UploadId;
          var PartNumber = params.PartNumber * 1;
          var CopySourceRange = params.CopySourceRange;
          var ChunkRetryTimes = this.options.ChunkRetryTimes + 1;
          var self = this;
          Async.retry(ChunkRetryTimes, function (tryCallback) {
            self.uploadPartCopy({
              TaskId: TaskId,
              Bucket: Bucket,
              Region: Region,
              Key: Key,
              CopySource: CopySource,
              UploadId: UploadId,
              PartNumber: PartNumber,
              CopySourceRange: CopySourceRange,
              tracker: params.tracker,
              calledBySdk: params.calledBySdk
            }, function (err, data) {
              tryCallback(err || null, data);
            });
          }, function (err, data) {
            return callback(err, data);
          });
        }
        var API_MAP = {
          sliceUploadFile: sliceUploadFile,
          abortUploadTask: abortUploadTask,
          uploadFile: uploadFile,
          uploadFiles: uploadFiles,
          sliceCopyFile: sliceCopyFile
        };
        module.exports.init = function (COS, task) {
          task.transferToTaskMethod(API_MAP, 'sliceUploadFile');
          util.each(API_MAP, function (fn, apiName) {
            COS.prototype[apiName] = util.apiWrapper(apiName, fn);
          });
        };

        /***/
      },

      /***/"./src/async.js":
      /*!**********************!*\
        !*** ./src/async.js ***!
        \**********************/
      /*! no static exports found */
      /***/function srcAsyncJs(module, exports) {

        var eachLimit = function eachLimit(arr, limit, iterator, callback) {
          callback = callback || function () {};
          if (!arr.length || limit <= 0) {
            return callback();
          }
          var completed = 0;
          var started = 0;
          var running = 0;
          (function replenish() {
            if (completed >= arr.length) {
              return callback();
            }
            while (running < limit && started < arr.length) {
              started += 1;
              running += 1;
              iterator(arr[started - 1], function (err) {
                if (err) {
                  callback(err);
                  callback = function callback() {};
                } else {
                  completed += 1;
                  running -= 1;
                  if (completed >= arr.length) {
                    callback();
                  } else {
                    replenish();
                  }
                }
              });
            }
          })();
        };
        var retry = function retry(times, iterator, callback) {
          var next = function next(index) {
            iterator(function (err, data) {
              if (err && index < times) {
                next(index + 1);
              } else {
                callback(err, data);
              }
            });
          };
          if (times < 1) {
            callback();
          } else {
            next(1);
          }
        };
        var async = {
          eachLimit: eachLimit,
          retry: retry
        };
        module.exports = async;

        /***/
      },

      /***/"./src/base.js":
      /*!*********************!*\
        !*** ./src/base.js ***!
        \*********************/
      /*! no static exports found */
      /***/function srcBaseJs(module, exports, __webpack_require__) {

        var _typeof = __webpack_require__( /*! @babel/runtime/helpers/typeof */"./node_modules/@babel/runtime/helpers/typeof.js");
        var REQUEST = __webpack_require__( /*! ../lib/request */"./lib/request.js");
        var util = __webpack_require__( /*! ./util */"./src/util.js");

        // Bucket 相关

        /**
         * 获取用户的 bucket 列表
         * @param  {Object}  params         回调函数，必须，下面为参数列表
         * 无特殊参数
         * @param  {Function}  callback     回调函数，必须
         */
        function getService(params, callback) {
          var protocol = this.options.Protocol || (util.isBrowser && (typeof location === "undefined" ? "undefined" : _typeof(location)) === 'object' && location.protocol === 'http:' ? 'http:' : 'https:');
          var domain = this.options.ServiceDomain;
          var appId = params.AppId || this.options.appId;
          var region = params.Region;
          if (domain) {
            domain = domain.replace(/\{\{AppId\}\}/gi, appId || '').replace(/\{\{Region\}\}/gi, region || '').replace(/\{\{.*?\}\}/gi, '');
            if (!/^[a-zA-Z]+:\/\//.test(domain)) {
              domain = protocol + '//' + domain;
            }
            if (domain.slice(-1) === '/') {
              domain = domain.slice(0, -1);
            }
          } else if (region) {
            domain = protocol + '//cos.' + region + '.myqcloud.com';
          } else {
            domain = protocol + '//service.cos.myqcloud.com';
          }
          var SignHost = '';
          var standardHost = region ? 'cos.' + region + '.myqcloud.com' : 'service.cos.myqcloud.com';
          var urlHost = domain.replace(/^https?:\/\/([^/]+)(\/.*)?$/, '$1');
          if (standardHost === urlHost) SignHost = standardHost;
          submitRequest.call(this, {
            Action: 'name/cos:GetService',
            url: domain,
            method: 'GET',
            headers: params.Headers,
            SignHost: SignHost,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var buckets = data && data.ListAllMyBucketsResult && data.ListAllMyBucketsResult.Buckets && data.ListAllMyBucketsResult.Buckets.Bucket || [];
            buckets = util.isArray(buckets) ? buckets : [buckets];
            var owner = data && data.ListAllMyBucketsResult && data.ListAllMyBucketsResult.Owner || {};
            callback(null, {
              Buckets: buckets,
              Owner: owner,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 创建 Bucket，并初始化访问权限
         * @param  {Object}  params                         参数对象，必须
         *     @param  {String}  params.Bucket              Bucket名称，必须
         *     @param  {String}  params.Region              地域名称，必须
         *     @param  {String}  params.ACL                 用户自定义文件权限，可以设置：private，public-read；默认值：private，非必须
         *     @param  {String}  params.GrantRead           赋予被授权者读的权限，格式x-cos-grant-read: uin=" ",uin=" "，非必须
         *     @param  {String}  params.GrantWrite          赋予被授权者写的权限，格式x-cos-grant-write: uin=" ",uin=" "，非必须
         *     @param  {String}  params.GrantFullControl    赋予被授权者读写权限，格式x-cos-grant-full-control: uin=" ",uin=" "，非必须
         * @param  {Function}  callback                     回调函数，必须
         * @return  {Object}  err                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                          返回的数据
         *     @return  {String}  data.Location             操作地址
         */
        function putBucket(params, callback) {
          var self = this;
          var xml = '';
          if (params['BucketAZConfig']) {
            var CreateBucketConfiguration = {
              BucketAZConfig: params.BucketAZConfig
            };
            xml = util.json2xml({
              CreateBucketConfiguration: CreateBucketConfiguration
            });
          }
          submitRequest.call(this, {
            Action: 'name/cos:PutBucket',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            body: xml,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var url = getUrl({
              protocol: self.options.Protocol,
              domain: self.options.Domain,
              bucket: params.Bucket,
              region: params.Region,
              isLocation: true
            });
            callback(null, {
              Location: url,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 查看是否存在该Bucket，是否有权限访问
         * @param  {Object}  params                     参数对象，必须
         *     @param  {String}  params.Bucket          Bucket名称，必须
         *     @param  {String}  params.Region          地域名称，必须
         * @param  {Function}  callback                 回调函数，必须
         * @return  {Object}  err                       请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                      返回的数据
         *     @return  {Boolean}  data.BucketExist     Bucket是否存在
         *     @return  {Boolean}  data.BucketAuth      是否有 Bucket 的访问权限
         */
        function headBucket(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:HeadBucket',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            method: 'HEAD',
            tracker: params.tracker
          }, callback);
        }

        /**
         * 获取 Bucket 下的 object 列表
         * @param  {Object}  params                         参数对象，必须
         *     @param  {String}  params.Bucket              Bucket名称，必须
         *     @param  {String}  params.Region              地域名称，必须
         *     @param  {String}  params.Prefix              前缀匹配，用来规定返回的文件前缀地址，非必须
         *     @param  {String}  params.Delimiter           定界符为一个符号，如果有Prefix，则将Prefix到delimiter之间的相同路径归为一类，非必须
         *     @param  {String}  params.Marker              默认以UTF-8二进制顺序列出条目，所有列出条目从marker开始，非必须
         *     @param  {String}  params.MaxKeys             单次返回最大的条目数量，默认1000，非必须
         *     @param  {String}  params.EncodingType        规定返回值的编码方式，非必须
         * @param  {Function}  callback                     回调函数，必须
         * @return  {Object}  err                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                          返回的数据
         *     @return  {Object}  data.ListBucketResult     返回的 object 列表信息
         */
        function getBucket(params, callback) {
          var reqParams = {};
          reqParams['prefix'] = params['Prefix'] || '';
          reqParams['delimiter'] = params['Delimiter'];
          reqParams['marker'] = params['Marker'];
          reqParams['max-keys'] = params['MaxKeys'];
          reqParams['encoding-type'] = params['EncodingType'];
          submitRequest.call(this, {
            Action: 'name/cos:GetBucket',
            ResourceKey: reqParams['prefix'],
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            qs: reqParams,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var ListBucketResult = data.ListBucketResult || {};
            var Contents = ListBucketResult.Contents || [];
            var CommonPrefixes = ListBucketResult.CommonPrefixes || [];
            Contents = util.isArray(Contents) ? Contents : [Contents];
            CommonPrefixes = util.isArray(CommonPrefixes) ? CommonPrefixes : [CommonPrefixes];
            var result = util.clone(ListBucketResult);
            util.extend(result, {
              Contents: Contents,
              CommonPrefixes: CommonPrefixes,
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }

        /**
         * 删除 Bucket
         * @param  {Object}  params                 参数对象，必须
         *     @param  {String}  params.Bucket      Bucket名称，必须
         *     @param  {String}  params.Region      地域名称，必须
         * @param  {Function}  callback             回调函数，必须
         * @return  {Object}  err                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                  返回的数据
         *     @return  {String}  data.Location     操作地址
         */
        function deleteBucket(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucket',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            method: 'DELETE',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 设置 Bucket 的 权限列表
         * @param  {Object}  params                         参数对象，必须
         *     @param  {String}  params.Bucket              Bucket名称，必须
         *     @param  {String}  params.Region              地域名称，必须
         *     @param  {String}  params.ACL                 用户自定义文件权限，可以设置：private，public-read；默认值：private，非必须
         *     @param  {String}  params.GrantRead           赋予被授权者读的权限，格式x-cos-grant-read: uin=" ",uin=" "，非必须
         *     @param  {String}  params.GrantWrite          赋予被授权者写的权限，格式x-cos-grant-write: uin=" ",uin=" "，非必须
         *     @param  {String}  params.GrantFullControl    赋予被授权者读写权限，格式x-cos-grant-full-control: uin=" ",uin=" "，非必须
         * @param  {Function}  callback                     回调函数，必须
         * @return  {Object}  err                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                          返回的数据
         */
        function putBucketAcl(params, callback) {
          var headers = params.Headers;
          var xml = '';
          if (params['AccessControlPolicy']) {
            var AccessControlPolicy = util.clone(params['AccessControlPolicy'] || {});
            var Grants = AccessControlPolicy.Grants || AccessControlPolicy.Grant;
            Grants = util.isArray(Grants) ? Grants : [Grants];
            delete AccessControlPolicy.Grant;
            delete AccessControlPolicy.Grants;
            AccessControlPolicy.AccessControlList = {
              Grant: Grants
            };
            xml = util.json2xml({
              AccessControlPolicy: AccessControlPolicy
            });
            headers['Content-Type'] = 'application/xml';
            headers['Content-MD5'] = util.b64(util.md5(xml));
          }

          // Grant Header 去重
          util.each(headers, function (val, key) {
            if (key.indexOf('x-cos-grant-') === 0) {
              headers[key] = uniqGrant(headers[key]);
            }
          });
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketACL',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: headers,
            action: 'acl',
            body: xml,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的 权限列表
         * @param  {Object}  params                         参数对象，必须
         *     @param  {String}  params.Bucket              Bucket名称，必须
         *     @param  {String}  params.Region              地域名称，必须
         * @param  {Function}  callback                     回调函数，必须
         * @return  {Object}  err                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                          返回的数据
         *     @return  {Object}  data.AccessControlPolicy  访问权限信息
         */
        function getBucketAcl(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketACL',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'acl',
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var AccessControlPolicy = data.AccessControlPolicy || {};
            var Owner = AccessControlPolicy.Owner || {};
            var Grant = AccessControlPolicy.AccessControlList.Grant || [];
            Grant = util.isArray(Grant) ? Grant : [Grant];
            var result = decodeAcl(AccessControlPolicy);
            if (data.headers && data.headers['x-cos-acl']) {
              result.ACL = data.headers['x-cos-acl'];
            }
            result = util.extend(result, {
              Owner: Owner,
              Grants: Grant,
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }

        /**
         * 设置 Bucket 的 跨域设置
         * @param  {Object}  params                             参数对象，必须
         *     @param  {String}  params.Bucket                  Bucket名称，必须
         *     @param  {String}  params.Region                  地域名称，必须
         *     @param  {Object}  params.CORSConfiguration       相关的跨域设置，必须
         * @param  {Array}  params.CORSConfiguration.CORSRules  对应的跨域规则
         * @param  {Function}  callback                         回调函数，必须
         * @return  {Object}  err                               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                              返回的数据
         */
        function putBucketCors(params, callback) {
          var CORSConfiguration = params['CORSConfiguration'] || {};
          var CORSRules = CORSConfiguration['CORSRules'] || params['CORSRules'] || [];
          CORSRules = util.clone(util.isArray(CORSRules) ? CORSRules : [CORSRules]);
          util.each(CORSRules, function (rule) {
            util.each(['AllowedOrigin', 'AllowedHeader', 'AllowedMethod', 'ExposeHeader'], function (key) {
              var sKey = key + 's';
              var val = rule[sKey] || rule[key] || [];
              delete rule[sKey];
              rule[key] = util.isArray(val) ? val : [val];
            });
          });
          var Conf = {
            CORSRule: CORSRules
          };
          if (params.ResponseVary) Conf.ResponseVary = params.ResponseVary;
          var xml = util.json2xml({
            CORSConfiguration: Conf
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketCORS',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'cors',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的 跨域设置
         * @param  {Object}  params                         参数对象，必须
         *     @param  {String}  params.Bucket              Bucket名称，必须
         *     @param  {String}  params.Region              地域名称，必须
         * @param  {Function}  callback                     回调函数，必须
         * @return  {Object}  err                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                          返回的数据
         *     @return  {Object}  data.CORSRules            Bucket的跨域设置
         */
        function getBucketCors(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketCORS',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'cors',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.error && err.error.Code === 'NoSuchCORSConfiguration') {
                var result = {
                  CORSRules: [],
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            var CORSConfiguration = data.CORSConfiguration || {};
            var CORSRules = CORSConfiguration.CORSRules || CORSConfiguration.CORSRule || [];
            CORSRules = util.clone(util.isArray(CORSRules) ? CORSRules : [CORSRules]);
            var ResponseVary = CORSConfiguration.ResponseVary;
            util.each(CORSRules, function (rule) {
              util.each(['AllowedOrigin', 'AllowedHeader', 'AllowedMethod', 'ExposeHeader'], function (key) {
                var sKey = key + 's';
                var val = rule[sKey] || rule[key] || [];
                delete rule[key];
                rule[sKey] = util.isArray(val) ? val : [val];
              });
            });
            callback(null, {
              CORSRules: CORSRules,
              ResponseVary: ResponseVary,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 删除 Bucket 的 跨域设置
         * @param  {Object}  params                 参数对象，必须
         *     @param  {String}  params.Bucket      Bucket名称，必须
         *     @param  {String}  params.Region      地域名称，必须
         * @param  {Function}  callback             回调函数，必须
         * @return  {Object}  err                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                  返回的数据
         */
        function deleteBucketCors(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketCORS',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'cors',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode || err.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的 地域信息
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据，包含地域信息 LocationConstraint
         */
        function getBucketLocation(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketLocation',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'location',
            tracker: params.tracker
          }, callback);
        }
        function putBucketPolicy(params, callback) {
          var Policy = params['Policy'];
          try {
            if (typeof Policy === 'string') Policy = JSON.parse(Policy);
          } catch (e) {}
          if (!Policy || typeof Policy === 'string') return callback(util.error(new Error('Policy format error')));
          var PolicyStr = JSON.stringify(Policy);
          if (!Policy.version) Policy.version = '2.0';
          var headers = params.Headers;
          headers['Content-Type'] = 'application/json';
          headers['Content-MD5'] = util.b64(util.md5(PolicyStr));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketPolicy',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            action: 'policy',
            body: PolicyStr,
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的读取权限策略
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketPolicy(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketPolicy',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'policy',
            rawBody: true,
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode && err.statusCode === 403) {
                return callback(util.error(err, {
                  ErrorStatus: 'Access Denied'
                }));
              }
              if (err.statusCode && err.statusCode === 405) {
                return callback(util.error(err, {
                  ErrorStatus: 'Method Not Allowed'
                }));
              }
              if (err.statusCode && err.statusCode === 404) {
                return callback(util.error(err, {
                  ErrorStatus: 'Policy Not Found'
                }));
              }
              return callback(err);
            }
            var Policy = {};
            try {
              Policy = JSON.parse(data.body);
            } catch (e) {}
            callback(null, {
              Policy: Policy,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 删除 Bucket 的 跨域设置
         * @param  {Object}  params                 参数对象，必须
         *     @param  {String}  params.Bucket      Bucket名称，必须
         *     @param  {String}  params.Region      地域名称，必须
         * @param  {Function}  callback             回调函数，必须
         * @return  {Object}  err                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                  返回的数据
         */
        function deleteBucketPolicy(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketPolicy',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'policy',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode || err.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 设置 Bucket 的标签
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         *     @param  {Array}   params.TagSet  标签设置，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function putBucketTagging(params, callback) {
          var Tagging = params['Tagging'] || {};
          var Tags = Tagging.TagSet || Tagging.Tags || params['Tags'] || [];
          Tags = util.clone(util.isArray(Tags) ? Tags : [Tags]);
          var xml = util.json2xml({
            Tagging: {
              TagSet: {
                Tag: Tags
              }
            }
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketTagging',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'tagging',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的标签设置
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketTagging(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketTagging',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'tagging',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.error && (err.error === 'Not Found' || err.error.Code === 'NoSuchTagSet')) {
                var result = {
                  Tags: [],
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            var Tags = [];
            try {
              Tags = data.Tagging.TagSet.Tag || [];
            } catch (e) {}
            Tags = util.clone(util.isArray(Tags) ? Tags : [Tags]);
            callback(null, {
              Tags: Tags,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 删除 Bucket 的 标签设置
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回的数据
         */
        function deleteBucketTagging(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketTagging',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'tagging',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function putBucketLifecycle(params, callback) {
          var LifecycleConfiguration = params['LifecycleConfiguration'] || {};
          var Rules = LifecycleConfiguration.Rules || params.Rules || [];
          Rules = util.clone(Rules);
          var xml = util.json2xml({
            LifecycleConfiguration: {
              Rule: Rules
            }
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketLifecycle',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'lifecycle',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function getBucketLifecycle(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketLifecycle',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'lifecycle',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.error && err.error.Code === 'NoSuchLifecycleConfiguration') {
                var result = {
                  Rules: [],
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            var Rules = [];
            try {
              Rules = data.LifecycleConfiguration.Rule || [];
            } catch (e) {}
            Rules = util.clone(util.isArray(Rules) ? Rules : [Rules]);
            callback(null, {
              Rules: Rules,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function deleteBucketLifecycle(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketLifecycle',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'lifecycle',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function putBucketVersioning(params, callback) {
          if (!params['VersioningConfiguration']) {
            callback(util.error(new Error('missing param VersioningConfiguration')));
            return;
          }
          var VersioningConfiguration = params['VersioningConfiguration'] || {};
          var xml = util.json2xml({
            VersioningConfiguration: VersioningConfiguration
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketVersioning',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'versioning',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function getBucketVersioning(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketVersioning',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'versioning',
            tracker: params.tracker
          }, function (err, data) {
            if (!err) {
              !data.VersioningConfiguration && (data.VersioningConfiguration = {});
            }
            callback(err, data);
          });
        }
        function putBucketReplication(params, callback) {
          var ReplicationConfiguration = util.clone(params.ReplicationConfiguration);
          var xml = util.json2xml({
            ReplicationConfiguration: ReplicationConfiguration
          });
          xml = xml.replace(/<(\/?)Rules>/gi, '<$1Rule>');
          xml = xml.replace(/<(\/?)Tags>/gi, '<$1Tag>');
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketReplication',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'replication',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function getBucketReplication(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketReplication',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'replication',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.error && (err.error === 'Not Found' || err.error.Code === 'ReplicationConfigurationnotFoundError')) {
                var result = {
                  ReplicationConfiguration: {
                    Rules: []
                  },
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            !data.ReplicationConfiguration && (data.ReplicationConfiguration = {});
            if (data.ReplicationConfiguration.Rule) {
              data.ReplicationConfiguration.Rules = util.makeArray(data.ReplicationConfiguration.Rule);
              delete data.ReplicationConfiguration.Rule;
            }
            callback(err, data);
          });
        }
        function deleteBucketReplication(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketReplication',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'replication',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 设置 Bucket 静态网站配置信息
         * @param  {Object}  params                                                 参数对象，必须
         *     @param  {String}  params.Bucket                                      Bucket名称，必须
         *     @param  {String}  params.Region                                      地域名称，必须
         *     @param  {Object}  params.WebsiteConfiguration                        地域名称，必须
         *         @param  {Object}   WebsiteConfiguration.IndexDocument            索引文档，必须
         *         @param  {Object}   WebsiteConfiguration.ErrorDocument            错误文档，非必须
         *         @param  {Object}   WebsiteConfiguration.RedirectAllRequestsTo    重定向所有请求，非必须
         *         @param  {Array}   params.RoutingRules                            重定向规则，非必须
         * @param  {Function}  callback                                             回调函数，必须
         * @return  {Object}  err                                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                                  返回数据
         */
        function putBucketWebsite(params, callback) {
          if (!params['WebsiteConfiguration']) {
            callback(util.error(new Error('missing param WebsiteConfiguration')));
            return;
          }
          var WebsiteConfiguration = util.clone(params['WebsiteConfiguration'] || {});
          var RoutingRules = WebsiteConfiguration['RoutingRules'] || WebsiteConfiguration['RoutingRule'] || [];
          RoutingRules = util.isArray(RoutingRules) ? RoutingRules : [RoutingRules];
          delete WebsiteConfiguration.RoutingRule;
          delete WebsiteConfiguration.RoutingRules;
          if (RoutingRules.length) WebsiteConfiguration.RoutingRules = {
            RoutingRule: RoutingRules
          };
          var xml = util.json2xml({
            WebsiteConfiguration: WebsiteConfiguration
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketWebsite',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'website',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的静态网站配置信息
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketWebsite(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketWebsite',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            action: 'website',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.error.Code === 'NoSuchWebsiteConfiguration') {
                var result = {
                  WebsiteConfiguration: {},
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            var WebsiteConfiguration = data.WebsiteConfiguration || {};
            if (WebsiteConfiguration['RoutingRules']) {
              var RoutingRules = util.clone(WebsiteConfiguration['RoutingRules'].RoutingRule || []);
              RoutingRules = util.makeArray(RoutingRules);
              WebsiteConfiguration.RoutingRules = RoutingRules;
            }
            callback(null, {
              WebsiteConfiguration: WebsiteConfiguration,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 删除 Bucket 的静态网站配置
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function deleteBucketWebsite(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketWebsite',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'website',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 设置 Bucket 的防盗链白名单或者黑名单
         * @param  {Object}  params                                                 参数对象，必须
         *     @param  {String}  params.Bucket                                      Bucket名称，必须
         *     @param  {String}  params.Region                                      地域名称，必须
         *     @param  {Object}  params.RefererConfiguration                        地域名称，必须
         *         @param  {String}   RefererConfiguration.Status                   是否开启防盗链，枚举值：Enabled、Disabled
         *         @param  {String}   RefererConfiguration.RefererType              防盗链类型，枚举值：Black-List、White-List，必须
         *         @param  {Array}   RefererConfiguration.DomianList.Domain         生效域名，必须
         *         @param  {String}   RefererConfiguration.EmptyReferConfiguration  ，非必须
         * @param  {Function}  callback                                             回调函数，必须
         * @return  {Object}  err                                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                                  返回数据
         */
        function putBucketReferer(params, callback) {
          if (!params['RefererConfiguration']) {
            callback(util.error(new Error('missing param RefererConfiguration')));
            return;
          }
          var RefererConfiguration = util.clone(params['RefererConfiguration'] || {});
          var DomainList = RefererConfiguration['DomainList'] || {};
          var Domains = DomainList['Domains'] || DomainList['Domain'] || [];
          Domains = util.isArray(Domains) ? Domains : [Domains];
          if (Domains.length) RefererConfiguration.DomainList = {
            Domain: Domains
          };
          var xml = util.json2xml({
            RefererConfiguration: RefererConfiguration
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketReferer',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'referer',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的防盗链白名单或者黑名单
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketReferer(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketReferer',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            action: 'referer',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.error.Code === 'NoSuchRefererConfiguration') {
                var result = {
                  WebsiteConfiguration: {},
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            var RefererConfiguration = data.RefererConfiguration || {};
            if (RefererConfiguration['DomainList']) {
              var Domains = util.makeArray(RefererConfiguration['DomainList'].Domain || []);
              RefererConfiguration.DomainList = {
                Domains: Domains
              };
            }
            callback(null, {
              RefererConfiguration: RefererConfiguration,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 设置 Bucket 自定义域名
         * @param  {Object}  params                                                 参数对象，必须
         *     @param  {String}  params.Bucket                                      Bucket名称，必须
         *     @param  {String}  params.Region                                      地域名称，必须
         * @param  {Function}  callback                                             回调函数，必须
         * @return  {Object}  err                                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                                  返回数据
         */
        function putBucketDomain(params, callback) {
          var DomainConfiguration = params['DomainConfiguration'] || {};
          var DomainRule = DomainConfiguration.DomainRule || params.DomainRule || [];
          DomainRule = util.clone(DomainRule);
          var xml = util.json2xml({
            DomainConfiguration: {
              DomainRule: DomainRule
            }
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketDomain',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'domain',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的自定义域名
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketDomain(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketDomain',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'domain',
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var DomainRule = [];
            try {
              DomainRule = data.DomainConfiguration.DomainRule || [];
            } catch (e) {}
            DomainRule = util.clone(util.isArray(DomainRule) ? DomainRule : [DomainRule]);
            callback(null, {
              DomainRule: DomainRule,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 删除 Bucket 自定义域名
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function deleteBucketDomain(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketDomain',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'domain',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 设置 Bucket 的回源
         * @param  {Object}  params                                                 参数对象，必须
         *     @param  {String}  params.Bucket                                      Bucket名称，必须
         *     @param  {String}  params.Region                                      地域名称，必须
         * @param  {Function}  callback                                             回调函数，必须
         * @return  {Object}  err                                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                                  返回数据
         */
        function putBucketOrigin(params, callback) {
          var OriginConfiguration = params['OriginConfiguration'] || {};
          var OriginRule = OriginConfiguration.OriginRule || params.OriginRule || [];
          OriginRule = util.clone(OriginRule);
          var xml = util.json2xml({
            OriginConfiguration: {
              OriginRule: OriginRule
            }
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketOrigin',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'origin',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的回源
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketOrigin(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketOrigin',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'origin',
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var OriginRule = [];
            try {
              OriginRule = data.OriginConfiguration.OriginRule || [];
            } catch (e) {}
            OriginRule = util.clone(util.isArray(OriginRule) ? OriginRule : [OriginRule]);
            callback(null, {
              OriginRule: OriginRule,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 删除 Bucket 的回源
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function deleteBucketOrigin(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketOrigin',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'origin',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 设置 Bucket 的日志记录
         * @param  {Object}  params                                                 参数对象，必须
         *     @param  {String}  params.Bucket                                      Bucket名称，必须
         *     @param  {String}  params.Region                                      地域名称，必须
         *     @param  {(Object|String)}  params.BucketLoggingStatus                         说明日志记录配置的状态，如果无子节点信息则意为关闭日志记录，必须
         * @param  {Function}  callback                                             回调函数，必须
         * @return  {Object}  err                                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                                  返回数据
         */
        function putBucketLogging(params, callback) {
          var xml = util.json2xml({
            BucketLoggingStatus: params['BucketLoggingStatus'] || ''
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketLogging',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'logging',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的日志记录
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketLogging(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketLogging',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'logging',
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            callback(null, {
              BucketLoggingStatus: data.BucketLoggingStatus,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 创建/编辑 Bucket 的清单任务
         * @param  {Object}  params                                                 参数对象，必须
         *     @param  {String}  params.Bucket                                      Bucket名称，必须
         *     @param  {String}  params.Region                                      地域名称，必须
         *     @param  {String}  params.Id                                          清单任务的名称，必须
         *     @param  {Object}  params.InventoryConfiguration                      包含清单的配置参数，必须
         * @param  {Function}  callback                                             回调函数，必须
         * @return  {Object}  err                                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                                  返回数据
         */
        function submitBucketInventory(method, params, callback) {
          var InventoryConfiguration = util.clone(params['InventoryConfiguration']);
          if (InventoryConfiguration.OptionalFields) {
            var Field = InventoryConfiguration.OptionalFields || [];
            InventoryConfiguration.OptionalFields = {
              Field: Field
            };
          }
          if (InventoryConfiguration.Destination && InventoryConfiguration.Destination.COSBucketDestination && InventoryConfiguration.Destination.COSBucketDestination.Encryption) {
            var Encryption = InventoryConfiguration.Destination.COSBucketDestination.Encryption;
            if (Object.keys(Encryption).indexOf('SSECOS') > -1) {
              Encryption['SSE-COS'] = Encryption['SSECOS'];
              delete Encryption['SSECOS'];
            }
          }
          var xml = util.json2xml({
            InventoryConfiguration: InventoryConfiguration
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          var action = method === 'PUT' ? 'name/cos:PutBucketInventory' : 'name/cos:PostBucketInventory';
          submitRequest.call(this, {
            Action: action,
            method: method,
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'inventory',
            qs: {
              id: params['Id']
            },
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 创建一个清单任务
         */
        function putBucketInventory(params, callback) {
          return submitBucketInventory.call(this, 'PUT', params, callback);
        }

        /**
         * 创建一个一次性清单任务 会立即执行
         */
        function postBucketInventory(params, callback) {
          return submitBucketInventory.call(this, 'POST', params, callback);
        }

        /**
         * 获取 Bucket 的清单任务信息
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         *     @param  {String}  params.Id      清单任务的名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function getBucketInventory(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketInventory',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'inventory',
            qs: {
              id: params['Id']
            },
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var InventoryConfiguration = data['InventoryConfiguration'];
            if (InventoryConfiguration && InventoryConfiguration.OptionalFields && InventoryConfiguration.OptionalFields.Field) {
              var Field = InventoryConfiguration.OptionalFields.Field;
              if (!util.isArray(Field)) {
                Field = [Field];
              }
              InventoryConfiguration.OptionalFields = Field;
            }
            if (InventoryConfiguration.Destination && InventoryConfiguration.Destination.COSBucketDestination && InventoryConfiguration.Destination.COSBucketDestination.Encryption) {
              var Encryption = InventoryConfiguration.Destination.COSBucketDestination.Encryption;
              if (Object.keys(Encryption).indexOf('SSE-COS') > -1) {
                Encryption['SSECOS'] = Encryption['SSE-COS'];
                delete Encryption['SSE-COS'];
              }
            }
            callback(null, {
              InventoryConfiguration: InventoryConfiguration,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Bucket 的清单任务信息
         * @param  {Object}  params                             参数对象，必须
         *     @param  {String}  params.Bucket                  Bucket名称，必须
         *     @param  {String}  params.Region                  地域名称，必须
         *     @param  {String}  params.ContinuationToken       当 COS 响应体中 IsTruncated 为 true，且 NextContinuationToken 节点中存在参数值时，您可以将这个参数作为 continuation-token 参数值，以获取下一页的清单任务信息，非必须
         * @param  {Function}  callback                         回调函数，必须
         * @return  {Object}  err                               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                              返回数据
         */
        function listBucketInventory(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:ListBucketInventory',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'inventory',
            qs: {
              'continuation-token': params['ContinuationToken']
            },
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var ListInventoryConfigurationResult = data['ListInventoryConfigurationResult'];
            var InventoryConfigurations = ListInventoryConfigurationResult.InventoryConfiguration || [];
            InventoryConfigurations = util.isArray(InventoryConfigurations) ? InventoryConfigurations : [InventoryConfigurations];
            delete ListInventoryConfigurationResult['InventoryConfiguration'];
            util.each(InventoryConfigurations, function (InventoryConfiguration) {
              if (InventoryConfiguration && InventoryConfiguration.OptionalFields && InventoryConfiguration.OptionalFields.Field) {
                var Field = InventoryConfiguration.OptionalFields.Field;
                if (!util.isArray(Field)) {
                  Field = [Field];
                }
                InventoryConfiguration.OptionalFields = Field;
              }
              if (InventoryConfiguration.Destination && InventoryConfiguration.Destination.COSBucketDestination && InventoryConfiguration.Destination.COSBucketDestination.Encryption) {
                var Encryption = InventoryConfiguration.Destination.COSBucketDestination.Encryption;
                if (Object.keys(Encryption).indexOf('SSE-COS') > -1) {
                  Encryption['SSECOS'] = Encryption['SSE-COS'];
                  delete Encryption['SSE-COS'];
                }
              }
            });
            ListInventoryConfigurationResult.InventoryConfigurations = InventoryConfigurations;
            util.extend(ListInventoryConfigurationResult, {
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, ListInventoryConfigurationResult);
          });
        }

        /**
         * 删除 Bucket 的清单任务
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         *     @param  {String}  params.Id      清单任务的名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回数据
         */
        function deleteBucketInventory(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketInventory',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'inventory',
            qs: {
              id: params['Id']
            },
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /* 全球加速 */
        function putBucketAccelerate(params, callback) {
          if (!params['AccelerateConfiguration']) {
            callback(util.error(new Error('missing param AccelerateConfiguration')));
            return;
          }
          var configuration = {
            AccelerateConfiguration: params.AccelerateConfiguration || {}
          };
          var xml = util.json2xml(configuration);
          var headers = {};
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketAccelerate',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'accelerate',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function getBucketAccelerate(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketAccelerate',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            action: 'accelerate',
            tracker: params.tracker
          }, function (err, data) {
            if (!err) {
              !data.AccelerateConfiguration && (data.AccelerateConfiguration = {});
            }
            callback(err, data);
          });
        }
        function putBucketEncryption(params, callback) {
          var conf = params.ServerSideEncryptionConfiguration || {};
          var Rules = conf.Rule || conf.Rules || [];
          var xml = util.json2xml({
            ServerSideEncryptionConfiguration: {
              Rule: Rules
            }
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutBucketEncryption',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'encryption',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }
        function getBucketEncryption(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketEncryption',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'encryption',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.code === 'NoSuchEncryptionConfiguration') {
                var result = {
                  EncryptionConfiguration: {
                    Rules: []
                  },
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            var Rules = util.makeArray(data.EncryptionConfiguration && data.EncryptionConfiguration.Rule || []);
            data.EncryptionConfiguration = {
              Rules: Rules
            };
            callback(err, data);
          });
        }
        function deleteBucketEncryption(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteBucketReplication',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'encryption',
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        // Object 相关

        /**
         * 取回对应Object的元数据，Head的权限与Get的权限一致
         * @param  {Object}  params                         参数对象，必须
         *     @param  {String}  params.Bucket              Bucket名称，必须
         *     @param  {String}  params.Region              地域名称，必须
         *     @param  {String}  params.Key                 文件名称，必须
         *     @param  {String}  params.IfModifiedSince     当Object在指定时间后被修改，则返回对应Object元信息，否则返回304，非必须
         * @param  {Function}  callback                     回调函数，必须
         * @return  {Object}  err                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                          为指定 object 的元数据，如果设置了 IfModifiedSince ，且文件未修改，则返回一个对象，NotModified 属性为 true
         *     @return  {Boolean}  data.NotModified         是否在 IfModifiedSince 时间点之后未修改该 object，则为 true
         */
        function headObject(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:HeadObject',
            method: 'HEAD',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            VersionId: params.VersionId,
            headers: params.Headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              var statusCode = err.statusCode;
              if (params.Headers['If-Modified-Since'] && statusCode && statusCode === 304) {
                return callback(null, {
                  NotModified: true,
                  statusCode: statusCode
                });
              }
              return callback(err);
            }
            data.ETag = util.attr(data.headers, 'etag', '');
            callback(null, data);
          });
        }
        function listObjectVersions(params, callback) {
          var reqParams = {};
          reqParams['prefix'] = params['Prefix'] || '';
          reqParams['delimiter'] = params['Delimiter'];
          reqParams['key-marker'] = params['KeyMarker'];
          reqParams['version-id-marker'] = params['VersionIdMarker'];
          reqParams['max-keys'] = params['MaxKeys'];
          reqParams['encoding-type'] = params['EncodingType'];
          submitRequest.call(this, {
            Action: 'name/cos:GetBucketObjectVersions',
            ResourceKey: reqParams['prefix'],
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            qs: reqParams,
            action: 'versions',
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var ListVersionsResult = data.ListVersionsResult || {};
            var DeleteMarkers = ListVersionsResult.DeleteMarker || [];
            DeleteMarkers = util.isArray(DeleteMarkers) ? DeleteMarkers : [DeleteMarkers];
            var Versions = ListVersionsResult.Version || [];
            Versions = util.isArray(Versions) ? Versions : [Versions];
            var result = util.clone(ListVersionsResult);
            delete result.DeleteMarker;
            delete result.Version;
            util.extend(result, {
              DeleteMarkers: DeleteMarkers,
              Versions: Versions,
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }

        /**
         * 下载 object
         * @param  {Object}  params                                 参数对象，必须
         *     @param  {String}  params.Bucket                      Bucket名称，必须
         *     @param  {String}  params.Region                      地域名称，必须
         *     @param  {String}  params.Key                         文件名称，必须
         *     @param  {WriteStream}  params.Output                 文件写入流，非必须
         *     @param  {String}  params.IfModifiedSince             当Object在指定时间后被修改，则返回对应Object元信息，否则返回304，非必须
         *     @param  {String}  params.IfUnmodifiedSince           如果文件修改时间早于或等于指定时间，才返回文件内容。否则返回 412 (precondition failed)，非必须
         *     @param  {String}  params.IfMatch                     当 ETag 与指定的内容一致，才返回文件。否则返回 412 (precondition failed)，非必须
         *     @param  {String}  params.IfNoneMatch                 当 ETag 与指定的内容不一致，才返回文件。否则返回304 (not modified)，非必须
         *     @param  {String}  params.ResponseContentType         设置返回头部中的 Content-Type 参数，非必须
         *     @param  {String}  params.ResponseContentLanguage     设置返回头部中的 Content-Language 参数，非必须
         *     @param  {String}  params.ResponseExpires             设置返回头部中的 Content-Expires 参数，非必须
         *     @param  {String}  params.ResponseCacheControl        设置返回头部中的 Cache-Control 参数，非必须
         *     @param  {String}  params.ResponseContentDisposition  设置返回头部中的 Content-Disposition 参数，非必须
         *     @param  {String}  params.ResponseContentEncoding     设置返回头部中的 Content-Encoding 参数，非必须
         * @param  {Function}  callback                             回调函数，必须
         * @param  {Object}  err                                    请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @param  {Object}  data                                   为对应的 object 数据，包括 body 和 headers
         */
        function getObject(params, callback) {
          if (this.options.ObjectKeySimplifyCheck) {
            // getObject 的 Key 需要校验，避免调用成 getBucket
            var formatKey = util.simplifyPath(params.Key);
            if (formatKey === '/') {
              callback(util.error(new Error('The Getobject Key is illegal')));
              return;
            }
          }
          var reqParams = params.Query || {};
          var reqParamsStr = params.QueryString || '';
          var onProgress = util.throttleOnProgress.call(this, 0, params.onProgress);
          var tracker = params.tracker;
          tracker && tracker.setParams({
            signStartTime: new Date().getTime()
          });
          reqParams['response-content-type'] = params['ResponseContentType'];
          reqParams['response-content-language'] = params['ResponseContentLanguage'];
          reqParams['response-expires'] = params['ResponseExpires'];
          reqParams['response-cache-control'] = params['ResponseCacheControl'];
          reqParams['response-content-disposition'] = params['ResponseContentDisposition'];
          reqParams['response-content-encoding'] = params['ResponseContentEncoding'];

          // 如果用户自己传入了 output
          submitRequest.call(this, {
            Action: 'name/cos:GetObject',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            VersionId: params.VersionId,
            DataType: params.DataType,
            headers: params.Headers,
            qs: reqParams,
            qsStr: reqParamsStr,
            rawBody: true,
            onDownloadProgress: onProgress,
            tracker: tracker
          }, function (err, data) {
            onProgress(null, true);
            if (err) {
              var statusCode = err.statusCode;
              if (params.Headers['If-Modified-Since'] && statusCode && statusCode === 304) {
                return callback(null, {
                  NotModified: true
                });
              }
              return callback(err);
            }
            callback(null, {
              Body: data.body,
              ETag: util.attr(data.headers, 'etag', ''),
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 上传 object
         * @param  {Object} params                                          参数对象，必须
         *     @param  {String}  params.Bucket                              Bucket名称，必须
         *     @param  {String}  params.Region                              地域名称，必须
         *     @param  {String}  params.Key                                 文件名称，必须
         *     @param  {File || Blob || String}  params.Body                上传文件对象或字符串，必须
         *     @param  {String}  params.CacheControl                        RFC 2616 中定义的缓存策略，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentDisposition                  RFC 2616 中定义的文件名称，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentEncoding                     RFC 2616 中定义的编码格式，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentLength                       RFC 2616 中定义的 HTTP 请求内容长度（字节），必须
         *     @param  {String}  params.ContentType                         RFC 2616 中定义的内容类型（MIME），将作为 Object 元数据保存，非必须
         *     @param  {String}  params.Expect                              当使用 Expect: 100-continue 时，在收到服务端确认后，才会发送请求内容，非必须
         *     @param  {String}  params.Expires                             RFC 2616 中定义的过期时间，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ACL                                 允许用户自定义文件权限，有效值：private | public-read，非必须
         *     @param  {String}  params.GrantRead                           赋予被授权者读取对象的权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.GrantReadAcp                        赋予被授权者读取对象的访问控制列表（ACL）的权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.GrantWriteAcp                       赋予被授权者写入对象的访问控制列表（ACL）的权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.GrantFullControl                    赋予被授权者操作对象的所有权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.StorageClass                        设置对象的存储级别，枚举值：STANDARD、STANDARD_IA、ARCHIVE，默认值：STANDARD，非必须
         *     @param  {String}  params.x-cos-meta-*                        允许用户自定义的头部信息，将作为对象的元数据保存。大小限制2KB，非必须
         *     @param  {String}  params.ContentSha1                         RFC 3174 中定义的 160-bit 内容 SHA-1 算法校验，非必须
         *     @param  {String}  params.ServerSideEncryption                支持按照指定的加密算法进行服务端数据加密，格式 x-cos-server-side-encryption: "AES256"，非必须
         *     @param  {Function}  params.onProgress                        上传进度回调函数
         * @param  {Function}  callback                                     回调函数，必须
         * @return  {Object}  err                                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                          为对应的 object 数据
         *     @return  {String}  data.ETag                                 为对应上传文件的 ETag 值
         */
        function putObject(params, callback) {
          var self = this;
          var FileSize = params.ContentLength;
          var onProgress = util.throttleOnProgress.call(self, FileSize, params.onProgress);

          // 特殊处理 Cache-Control、Content-Type，避免代理更改这两个字段导致写入到 Object 属性里
          var headers = params.Headers;
          if (!headers['Cache-Control'] && !headers['cache-control']) headers['Cache-Control'] = '';
          if (!headers['Content-Type'] && !headers['content-type']) headers['Content-Type'] = params.Body && params.Body.type || '';
          var needCalcMd5 = params.UploadAddMetaMd5 || self.options.UploadAddMetaMd5 || self.options.UploadCheckContentMd5;
          var tracker = params.tracker;
          needCalcMd5 && tracker && tracker.setParams({
            md5StartTime: new Date().getTime()
          });
          util.getBodyMd5(needCalcMd5, params.Body, function (md5) {
            if (md5) {
              tracker && tracker.setParams({
                md5EndTime: new Date().getTime()
              });
              if (self.options.UploadCheckContentMd5) headers['Content-MD5'] = util.b64(md5);
              if (params.UploadAddMetaMd5 || self.options.UploadAddMetaMd5) headers['x-cos-meta-md5'] = md5;
            }
            if (params.ContentLength !== undefined) headers['Content-Length'] = params.ContentLength;
            onProgress(null, true); // 任务状态开始 uploading
            submitRequest.call(self, {
              Action: 'name/cos:PutObject',
              TaskId: params.TaskId,
              method: 'PUT',
              Bucket: params.Bucket,
              Region: params.Region,
              Key: params.Key,
              headers: params.Headers,
              qs: params.Query,
              body: params.Body,
              onProgress: onProgress,
              tracker: tracker
            }, function (err, data) {
              if (err) {
                onProgress(null, true);
                return callback(err);
              }
              onProgress({
                loaded: FileSize,
                total: FileSize
              }, true);
              var url = getUrl({
                ForcePathStyle: self.options.ForcePathStyle,
                protocol: self.options.Protocol,
                domain: self.options.Domain,
                bucket: params.Bucket,
                region: !self.options.UseAccelerate ? params.Region : 'accelerate',
                object: params.Key
              });
              url = url.substr(url.indexOf('://') + 3);
              data.Location = url;
              data.ETag = util.attr(data.headers, 'etag', '');
              callback(null, data);
            });
          }, params.onHashProgress);
        }

        /**
         * 删除 object
         * @param  {Object}  params                     参数对象，必须
         *     @param  {String}  params.Bucket          Bucket名称，必须
         *     @param  {String}  params.Region          地域名称，必须
         *     @param  {String}  params.Key             object名称，必须
         * @param  {Function}  callback                 回调函数，必须
         * @param  {Object}  err                        请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @param  {Object}  data                       删除操作成功之后返回的数据
         */
        function deleteObject(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteObject',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            VersionId: params.VersionId,
            action: params.Recursive ? 'recursive' : '',
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              var statusCode = err.statusCode;
              if (statusCode && statusCode === 404) {
                return callback(null, {
                  BucketNotFound: true,
                  statusCode: statusCode
                });
              } else {
                return callback(err);
              }
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 object 的 权限列表
         * @param  {Object}  params                         参数对象，必须
         *     @param  {String}  params.Bucket              Bucket名称，必须
         *     @param  {String}  params.Region              地域名称，必须
         *     @param  {String}  params.Key                 object名称，必须
         * @param  {Function}  callback                     回调函数，必须
         * @return  {Object}  err                           请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                          返回的数据
         *     @return  {Object}  data.AccessControlPolicy  权限列表
         */
        function getObjectAcl(params, callback) {
          var reqParams = {};
          if (params.VersionId) {
            reqParams.versionId = params.VersionId;
          }
          submitRequest.call(this, {
            Action: 'name/cos:GetObjectACL',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            qs: reqParams,
            action: 'acl',
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var AccessControlPolicy = data.AccessControlPolicy || {};
            var Owner = AccessControlPolicy.Owner || {};
            var Grant = AccessControlPolicy.AccessControlList && AccessControlPolicy.AccessControlList.Grant || [];
            Grant = util.isArray(Grant) ? Grant : [Grant];
            var result = decodeAcl(AccessControlPolicy);
            delete result.GrantWrite;
            if (data.headers && data.headers['x-cos-acl']) {
              result.ACL = data.headers['x-cos-acl'];
            }
            result = util.extend(result, {
              Owner: Owner,
              Grants: Grant,
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }

        /**
         * 设置 object 的 权限列表
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         *     @param  {String}  params.Key     object名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回的数据
         */
        function putObjectAcl(params, callback) {
          var headers = params.Headers;
          var xml = '';
          if (params['AccessControlPolicy']) {
            var AccessControlPolicy = util.clone(params['AccessControlPolicy'] || {});
            var Grants = AccessControlPolicy.Grants || AccessControlPolicy.Grant;
            Grants = util.isArray(Grants) ? Grants : [Grants];
            delete AccessControlPolicy.Grant;
            delete AccessControlPolicy.Grants;
            AccessControlPolicy.AccessControlList = {
              Grant: Grants
            };
            xml = util.json2xml({
              AccessControlPolicy: AccessControlPolicy
            });
            headers['Content-Type'] = 'application/xml';
            headers['Content-MD5'] = util.b64(util.md5(xml));
          }

          // Grant Header 去重
          util.each(headers, function (val, key) {
            if (key.indexOf('x-cos-grant-') === 0) {
              headers[key] = uniqGrant(headers[key]);
            }
          });
          submitRequest.call(this, {
            Action: 'name/cos:PutObjectACL',
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            action: 'acl',
            headers: headers,
            body: xml,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * Options Object请求实现跨域访问的预请求。即发出一个 OPTIONS 请求给服务器以确认是否可以进行跨域操作。
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         *     @param  {String}  params.Key     object名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data              返回的数据
         */
        function optionsObject(params, callback) {
          var headers = params.Headers;
          headers['Origin'] = params['Origin'];
          headers['Access-Control-Request-Method'] = params['AccessControlRequestMethod'];
          headers['Access-Control-Request-Headers'] = params['AccessControlRequestHeaders'];
          submitRequest.call(this, {
            Action: 'name/cos:OptionsObject',
            method: 'OPTIONS',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode && err.statusCode === 403) {
                return callback(null, {
                  OptionsForbidden: true,
                  statusCode: err.statusCode
                });
              }
              return callback(err);
            }
            var headers = data.headers || {};
            callback(null, {
              AccessControlAllowOrigin: headers['access-control-allow-origin'],
              AccessControlAllowMethods: headers['access-control-allow-methods'],
              AccessControlAllowHeaders: headers['access-control-allow-headers'],
              AccessControlExposeHeaders: headers['access-control-expose-headers'],
              AccessControlMaxAge: headers['access-control-max-age'],
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * @param  {Object}                                     参数列表
         *     @param  {String}  Bucket                         Bucket 名称
         *     @param  {String}  Region                         地域名称
         *     @param  {String}  Key                            文件名称
         *     @param  {String}  CopySource                     源文件URL绝对路径，可以通过versionid子资源指定历史版本
         *     @param  {String}  ACL                            允许用户自定义文件权限。有效值：private，public-read默认值：private。
         *     @param  {String}  GrantRead                      赋予被授权者读的权限，格式 x-cos-grant-read: uin=" ",uin=" "，当需要给子账户授权时，uin="RootAcountID/SubAccountID"，当需要给根账户授权时，uin="RootAcountID"。
         *     @param  {String}  GrantWrite                     赋予被授权者写的权限，格式 x-cos-grant-write: uin=" ",uin=" "，当需要给子账户授权时，uin="RootAcountID/SubAccountID"，当需要给根账户授权时，uin="RootAcountID"。
         *     @param  {String}  GrantFullControl               赋予被授权者读写权限，格式 x-cos-grant-full-control: uin=" ",uin=" "，当需要给子账户授权时，uin="RootAcountID/SubAccountID"，当需要给根账户授权时，uin="RootAcountID"。
         *     @param  {String}  MetadataDirective              是否拷贝元数据，枚举值：Copy, Replaced，默认值Copy。假如标记为Copy，忽略Header中的用户元数据信息直接复制；假如标记为Replaced，按Header信息修改元数据。当目标路径和原路径一致，即用户试图修改元数据时，必须为Replaced
         *     @param  {String}  CopySourceIfModifiedSince      当Object在指定时间后被修改，则执行操作，否则返回412。可与x-cos-copy-source-If-None-Match一起使用，与其他条件联合使用返回冲突。
         *     @param  {String}  CopySourceIfUnmodifiedSince    当Object在指定时间后未被修改，则执行操作，否则返回412。可与x-cos-copy-source-If-Match一起使用，与其他条件联合使用返回冲突。
         *     @param  {String}  CopySourceIfMatch              当Object的ETag和给定一致时，则执行操作，否则返回412。可与x-cos-copy-source-If-Unmodified-Since一起使用，与其他条件联合使用返回冲突。
         *     @param  {String}  CopySourceIfNoneMatch          当Object的ETag和给定不一致时，则执行操作，否则返回412。可与x-cos-copy-source-If-Modified-Since一起使用，与其他条件联合使用返回冲突。
         *     @param  {String}  StorageClass                   存储级别，枚举值：存储级别，枚举值：Standard, Standard_IA，Archive；默认值：Standard
         *     @param  {String}  CacheControl                   指定所有缓存机制在整个请求/响应链中必须服从的指令。
         *     @param  {String}  ContentDisposition             MIME 协议的扩展，MIME 协议指示 MIME 用户代理如何显示附加的文件
         *     @param  {String}  ContentEncoding                HTTP 中用来对「采用何种编码格式传输正文」进行协定的一对头部字段
         *     @param  {String}  ContentLength                  设置响应消息的实体内容的大小，单位为字节
         *     @param  {String}  ContentType                    RFC 2616 中定义的 HTTP 请求内容类型（MIME），例如text/plain
         *     @param  {String}  Expect                         请求的特定的服务器行为
         *     @param  {String}  Expires                        响应过期的日期和时间
         *     @param  {String}  params.ServerSideEncryption   支持按照指定的加密算法进行服务端数据加密，格式 x-cos-server-side-encryption: "AES256"，非必须
         *     @param  {String}  ContentLanguage                指定内容语言
         *     @param  {String}  x-cos-meta-*                   允许用户自定义的头部信息，将作为 Object 元数据返回。大小限制2K。
         */
        function putObjectCopy(params, callback) {
          // 特殊处理 Cache-Control
          var self = this;
          var headers = params.Headers;
          if (!headers['Cache-Control'] && !headers['cache-control']) headers['Cache-Control'] = '';
          var CopySource = params.CopySource || '';
          var m = util.getSourceParams.call(this, CopySource);
          if (!m) {
            callback(util.error(new Error('CopySource format error')));
            return;
          }
          var SourceBucket = m.Bucket;
          var SourceRegion = m.Region;
          var SourceKey = decodeURIComponent(m.Key);
          submitRequest.call(this, {
            Scope: [{
              action: 'name/cos:GetObject',
              bucket: SourceBucket,
              region: SourceRegion,
              prefix: SourceKey
            }, {
              action: 'name/cos:PutObject',
              bucket: params.Bucket,
              region: params.Region,
              prefix: params.Key
            }],
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            VersionId: params.VersionId,
            headers: params.Headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var result = util.clone(data.CopyObjectResult || {});
            var url = getUrl({
              ForcePathStyle: self.options.ForcePathStyle,
              protocol: self.options.Protocol,
              domain: self.options.Domain,
              bucket: params.Bucket,
              region: params.Region,
              object: params.Key,
              isLocation: true
            });
            util.extend(result, {
              Location: url,
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }
        function uploadPartCopy(params, callback) {
          var CopySource = params.CopySource || '';
          var m = util.getSourceParams.call(this, CopySource);
          if (!m) {
            callback(util.error(new Error('CopySource format error')));
            return;
          }
          var SourceBucket = m.Bucket;
          var SourceRegion = m.Region;
          var SourceKey = decodeURIComponent(m.Key);
          submitRequest.call(this, {
            Scope: [{
              action: 'name/cos:GetObject',
              bucket: SourceBucket,
              region: SourceRegion,
              prefix: SourceKey
            }, {
              action: 'name/cos:PutObject',
              bucket: params.Bucket,
              region: params.Region,
              prefix: params.Key
            }],
            method: 'PUT',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            VersionId: params.VersionId,
            qs: {
              partNumber: params['PartNumber'],
              uploadId: params['UploadId']
            },
            headers: params.Headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var result = util.clone(data.CopyPartResult || {});
            util.extend(result, {
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }
        function deleteMultipleObject(params, callback) {
          var Objects = params.Objects || [];
          var Quiet = params.Quiet;
          Objects = util.isArray(Objects) ? Objects : [Objects];
          var xml = util.json2xml({
            Delete: {
              Object: Objects,
              Quiet: Quiet || false
            }
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          var Scope = util.map(Objects, function (v) {
            return {
              action: 'name/cos:DeleteObject',
              bucket: params.Bucket,
              region: params.Region,
              prefix: v.Key
            };
          });
          submitRequest.call(this, {
            Scope: Scope,
            method: 'POST',
            Bucket: params.Bucket,
            Region: params.Region,
            body: xml,
            action: 'delete',
            headers: headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            var DeleteResult = data.DeleteResult || {};
            var Deleted = DeleteResult.Deleted || [];
            var Errors = DeleteResult.Error || [];
            Deleted = util.isArray(Deleted) ? Deleted : [Deleted];
            Errors = util.isArray(Errors) ? Errors : [Errors];
            var result = util.clone(DeleteResult);
            util.extend(result, {
              Error: Errors,
              Deleted: Deleted,
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }
        function restoreObject(params, callback) {
          var headers = params.Headers;
          if (!params['RestoreRequest']) {
            callback(util.error(new Error('missing param RestoreRequest')));
            return;
          }
          var RestoreRequest = params.RestoreRequest || {};
          var xml = util.json2xml({
            RestoreRequest: RestoreRequest
          });
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:RestoreObject',
            method: 'POST',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            VersionId: params.VersionId,
            body: xml,
            action: 'restore',
            headers: headers,
            tracker: params.tracker
          }, callback);
        }

        /**
         * 设置 Object 的标签
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Object名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         *     @param  {Array}   params.TagSet  标签设置，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/42998
         * @return  {Object}  data              返回数据
         */
        function putObjectTagging(params, callback) {
          var Tagging = params['Tagging'] || {};
          var Tags = Tagging.TagSet || Tagging.Tags || params['Tags'] || [];
          Tags = util.clone(util.isArray(Tags) ? Tags : [Tags]);
          var xml = util.json2xml({
            Tagging: {
              TagSet: {
                Tag: Tags
              }
            }
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:PutObjectTagging',
            method: 'PUT',
            Bucket: params.Bucket,
            Key: params.Key,
            Region: params.Region,
            body: xml,
            action: 'tagging',
            headers: headers,
            VersionId: params.VersionId,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 获取 Object 的标签设置
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Bucket名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/42998
         * @return  {Object}  data              返回数据
         */
        function getObjectTagging(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:GetObjectTagging',
            method: 'GET',
            Key: params.Key,
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            action: 'tagging',
            VersionId: params.VersionId,
            tracker: params.tracker
          }, function (err, data) {
            if (err) {
              if (err.statusCode === 404 && err.error && (err.error === 'Not Found' || err.error.Code === 'NoSuchTagSet')) {
                var result = {
                  Tags: [],
                  statusCode: err.statusCode
                };
                err.headers && (result.headers = err.headers);
                callback(null, result);
              } else {
                callback(err);
              }
              return;
            }
            var Tags = [];
            try {
              Tags = data.Tagging.TagSet.Tag || [];
            } catch (e) {}
            Tags = util.clone(util.isArray(Tags) ? Tags : [Tags]);
            callback(null, {
              Tags: Tags,
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 删除 Object 的 标签设置
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Bucket  Object名称，必须
         *     @param  {String}  params.Region  地域名称，必须
         * @param  {Function}  callback         回调函数，必须
         * @return  {Object}  err               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/42998
         * @return  {Object}  data              返回的数据
         */
        function deleteObjectTagging(params, callback) {
          submitRequest.call(this, {
            Action: 'name/cos:DeleteObjectTagging',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            action: 'tagging',
            VersionId: params.VersionId,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 使用 SQL 语句从指定对象（CSV 格式或者 JSON 格式）中检索内容
         * @param  {Object}  params                   参数对象，必须
         *     @param  {String}  params.Bucket        Object名称，必须
         *     @param  {String}  params.Region        地域名称，必须
         *     @param  {Object}  params.SelectRequest 地域名称，必须
         * @param  {Function}  callback               回调函数，必须
         * @return  {Object}  err                     请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/42998
         * @return  {Object}  data                    返回的数据
         */
        function selectObjectContent(params, callback) {
          var SelectType = params['SelectType'];
          if (!SelectType) return callback(util.error(new Error('missing param SelectType')));
          var SelectRequest = params['SelectRequest'] || {};
          var xml = util.json2xml({
            SelectRequest: SelectRequest
          });
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:GetObject',
            method: 'POST',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            action: 'select',
            qs: {
              'select-type': params['SelectType']
            },
            VersionId: params.VersionId,
            body: xml,
            DataType: 'arraybuffer',
            rawBody: true,
            tracker: params.tracker
          }, function (err, data) {
            if (err && err.statusCode === 204) {
              return callback(null, {
                statusCode: err.statusCode
              });
            } else if (err) {
              return callback(err);
            }
            var result = util.parseSelectPayload(data.body);
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers,
              Body: result.body,
              Payload: result.payload
            });
          });
        }

        // 分块上传

        /**
         * 初始化分块上传
         * @param  {Object}  params                                     参数对象，必须
         *     @param  {String}  params.Bucket                          Bucket名称，必须
         *     @param  {String}  params.Region                          地域名称，必须
         *     @param  {String}  params.Key                             object名称，必须
         *     @param  {String}  params.UploadId                        object名称，必须
         *     @param  {String}  params.CacheControl                    RFC 2616 中定义的缓存策略，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentDisposition              RFC 2616 中定义的文件名称，将作为 Object 元数据保存    ，非必须
         *     @param  {String}  params.ContentEncoding                 RFC 2616 中定义的编码格式，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentType                     RFC 2616 中定义的内容类型（MIME），将作为 Object 元数据保存，非必须
         *     @param  {String}  params.Expires                         RFC 2616 中定义的过期时间，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ACL                             允许用户自定义文件权限，非必须
         *     @param  {String}  params.GrantRead                       赋予被授权者读的权限 ，非必须
         *     @param  {String}  params.GrantWrite                      赋予被授权者写的权限 ，非必须
         *     @param  {String}  params.GrantFullControl                赋予被授权者读写权限 ，非必须
         *     @param  {String}  params.StorageClass                    设置Object的存储级别，枚举值：Standard，Standard_IA，Archive，非必须
         *     @param  {String}  params.ServerSideEncryption           支持按照指定的加密算法进行服务端数据加密，格式 x-cos-server-side-encryption: "AES256"，非必须
         * @param  {Function}  callback                                 回调函数，必须
         * @return  {Object}  err                                       请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                      返回的数据
         */
        function multipartInit(params, callback) {
          var self = this;
          // 特殊处理 Cache-Control
          var headers = params.Headers;
          var tracker = params.tracker;

          // 特殊处理 Cache-Control、Content-Type
          if (!headers['Cache-Control'] && !headers['cache-control']) headers['Cache-Control'] = '';
          if (!headers['Content-Type'] && !headers['content-type']) headers['Content-Type'] = params.Body && params.Body.type || '';
          var needCalcMd5 = params.Body && (params.UploadAddMetaMd5 || self.options.UploadAddMetaMd5);
          needCalcMd5 && tracker && tracker.setParams({
            md5StartTime: new Date().getTime()
          });
          util.getBodyMd5(needCalcMd5, params.Body, function (md5) {
            if (md5) params.Headers['x-cos-meta-md5'] = md5;
            needCalcMd5 && tracker && tracker.setParams({
              md5EndTime: new Date().getTime()
            });
            submitRequest.call(self, {
              Action: 'name/cos:InitiateMultipartUpload',
              method: 'POST',
              Bucket: params.Bucket,
              Region: params.Region,
              Key: params.Key,
              action: 'uploads',
              headers: params.Headers,
              qs: params.Query,
              tracker: tracker
            }, function (err, data) {
              if (err) {
                tracker && tracker.parent && tracker.parent.setParams({
                  errorNode: 'multipartInit'
                });
                return callback(err);
              }
              data = util.clone(data || {});
              if (data && data.InitiateMultipartUploadResult) {
                return callback(null, util.extend(data.InitiateMultipartUploadResult, {
                  statusCode: data.statusCode,
                  headers: data.headers
                }));
              }
              callback(null, data);
            });
          }, params.onHashProgress);
        }

        /**
         * 分块上传
         * @param  {Object}  params                                 参数对象，必须
         *     @param  {String}  params.Bucket                      Bucket名称，必须
         *     @param  {String}  params.Region                      地域名称，必须
         *     @param  {String}  params.Key                         object名称，必须
         *     @param  {File || Blob || String}  params.Body        上传文件对象或字符串
         *     @param  {String} params.ContentLength                RFC 2616 中定义的 HTTP 请求内容长度（字节），非必须
         *     @param  {String} params.Expect                       当使用 Expect: 100-continue 时，在收到服务端确认后，才会发送请求内容，非必须
         *     @param  {String} params.ServerSideEncryption         支持按照指定的加密算法进行服务端数据加密，格式 x-cos-server-side-encryption: "AES256"，非必须
         *     @param  {String} params.ContentSha1                  RFC 3174 中定义的 160-bit 内容 SHA-1 算法校验值，非必须
         * @param  {Function}  callback                             回调函数，必须
         *     @return  {Object}  err                               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         *     @return  {Object}  data                              返回的数据
         *     @return  {Object}  data.ETag                         返回的文件分块 sha1 值
         */
        function multipartUpload(params, callback) {
          var self = this;
          util.getFileSize('multipartUpload', params, function () {
            var tracker = params.tracker;
            var needCalcMd5 = self.options.UploadCheckContentMd5;
            needCalcMd5 && tracker && tracker.setParams({
              md5StartTime: new Date().getTime()
            });
            util.getBodyMd5(needCalcMd5, params.Body, function (md5) {
              if (md5) params.Headers['Content-MD5'] = util.b64(md5);
              needCalcMd5 && tracker && tracker.setParams({
                md5EndTime: new Date().getTime()
              });
              tracker && tracker.setParams({
                partNumber: params.PartNumber
              });
              submitRequest.call(self, {
                Action: 'name/cos:UploadPart',
                TaskId: params.TaskId,
                method: 'PUT',
                Bucket: params.Bucket,
                Region: params.Region,
                Key: params.Key,
                qs: {
                  partNumber: params['PartNumber'],
                  uploadId: params['UploadId']
                },
                headers: params.Headers,
                onProgress: params.onProgress,
                body: params.Body || null,
                tracker: tracker
              }, function (err, data) {
                if (err) {
                  tracker && tracker.parent && tracker.parent.setParams({
                    errorNode: 'multipartUpload'
                  });
                  return callback(err);
                }
                callback(null, {
                  ETag: util.attr(data.headers, 'etag', ''),
                  statusCode: data.statusCode,
                  headers: data.headers
                });
              });
            });
          });
        }

        /**
         * 完成分块上传
         * @param  {Object}  params                             参数对象，必须
         *     @param  {String}  params.Bucket                  Bucket名称，必须
         *     @param  {String}  params.Region                  地域名称，必须
         *     @param  {String}  params.Key                     object名称，必须
         *     @param  {Array}   params.Parts                   分块信息列表，必须
         *     @param  {String}  params.Parts[i].PartNumber     块编号，必须
         *     @param  {String}  params.Parts[i].ETag           分块的 sha1 校验值
         * @param  {Function}  callback                         回调函数，必须
         * @return  {Object}  err                               请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                              返回的数据
         *     @return  {Object}  data.CompleteMultipartUpload  完成分块上传后的文件信息，包括Location, Bucket, Key 和 ETag
         */
        function multipartComplete(params, callback) {
          var self = this;
          var UploadId = params.UploadId;
          var Parts = params['Parts'];
          var tracker = params.tracker;
          for (var i = 0, len = Parts.length; i < len; i++) {
            if (Parts[i]['ETag'] && Parts[i]['ETag'].indexOf('"') === 0) {
              continue;
            }
            Parts[i]['ETag'] = '"' + Parts[i]['ETag'] + '"';
          }
          var xml = util.json2xml({
            CompleteMultipartUpload: {
              Part: Parts
            }
          });
          // CSP/ceph CompleteMultipartUpload 接口 body 写死了限制 1MB，这里最多 10000 片时，xml 字符串去掉空格853KB
          xml = xml.replace(/\n\s*/g, '');
          var headers = params.Headers;
          headers['Content-Type'] = 'application/xml';
          headers['Content-MD5'] = util.b64(util.md5(xml));
          submitRequest.call(this, {
            Action: 'name/cos:CompleteMultipartUpload',
            method: 'POST',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            qs: {
              uploadId: UploadId
            },
            body: xml,
            headers: headers,
            tracker: tracker
          }, function (err, data) {
            if (err) {
              tracker && tracker.parent && tracker.parent.setParams({
                errorNode: 'multipartComplete'
              });
              return callback(err);
            }
            var url = getUrl({
              ForcePathStyle: self.options.ForcePathStyle,
              protocol: self.options.Protocol,
              domain: self.options.Domain,
              bucket: params.Bucket,
              region: params.Region,
              object: params.Key,
              isLocation: true
            });
            var res = data.CompleteMultipartUploadResult || {};
            // pic-operations 处理
            if (res.ProcessResults) {
              res.UploadResult = {
                OriginalInfo: {
                  Key: res.Key,
                  Location: url,
                  ETag: res.ETag,
                  ImageInfo: res.ImageInfo
                },
                ProcessResults: res.ProcessResults
              };
              delete res.ImageInfo;
              delete res.ProcessResults;
            }
            // callback 处理
            if (res.CallbackResult) {
              var callbackResult = res.CallbackResult;
              if (callbackResult.Status === '200' && callbackResult.CallbackBody) {
                try {
                  res.CallbackBody = JSON.parse(util.decodeBase64(callbackResult.CallbackBody));
                } catch (e) {
                  res.CallbackBody = {};
                }
              } else {
                res.CallbackError = callbackResult.Error || {};
              }
              delete res.CallbackResult;
            }
            // returnBody 处理
            if (res.ReturnBodyResult) {
              var returnBodyResult = res.ReturnBodyResult;
              if (returnBodyResult.Status === '200' && returnBodyResult.ReturnBody) {
                try {
                  res.ReturnBody = JSON.parse(util.decodeBase64(returnBodyResult.ReturnBody));
                } catch (e) {
                  res.ReturnBody = {};
                }
              } else {
                res.ReturnError = {
                  Code: returnBodyResult.Code,
                  Message: returnBodyResult.Message,
                  Status: returnBodyResult.Status
                };
              }
              delete res.ReturnBodyResult;
            }
            var result = util.extend(res, {
              Location: url,
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }

        /**
         * 分块上传任务列表查询
         * @param  {Object}  params                                 参数对象，必须
         *     @param  {String}  params.Bucket                      Bucket名称，必须
         *     @param  {String}  params.Region                      地域名称，必须
         *     @param  {String}  params.Delimiter                   定界符为一个符号，如果有Prefix，则将Prefix到delimiter之间的相同路径归为一类，定义为Common Prefix，然后列出所有Common Prefix。如果没有Prefix，则从路径起点开始，非必须
         *     @param  {String}  params.EncodingType                规定返回值的编码方式，非必须
         *     @param  {String}  params.Prefix                      前缀匹配，用来规定返回的文件前缀地址，非必须
         *     @param  {String}  params.MaxUploads                  单次返回最大的条目数量，默认1000，非必须
         *     @param  {String}  params.KeyMarker                   与upload-id-marker一起使用 </Br>当upload-id-marker未被指定时，ObjectName字母顺序大于key-marker的条目将被列出 </Br>当upload-id-marker被指定时，ObjectName字母顺序大于key-marker的条目被列出，ObjectName字母顺序等于key-marker同时UploadId大于upload-id-marker的条目将被列出，非必须
         *     @param  {String}  params.UploadIdMarker              与key-marker一起使用 </Br>当key-marker未被指定时，upload-id-marker将被忽略 </Br>当key-marker被指定时，ObjectName字母顺序大于key-marker的条目被列出，ObjectName字母顺序等于key-marker同时UploadId大于upload-id-marker的条目将被列出，非必须
         * @param  {Function}  callback                             回调函数，必须
         * @return  {Object}  err                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                  返回的数据
         *     @return  {Object}  data.ListMultipartUploadsResult   分块上传任务信息
         */
        function multipartList(params, callback) {
          var reqParams = {};
          reqParams['delimiter'] = params['Delimiter'];
          reqParams['encoding-type'] = params['EncodingType'];
          reqParams['prefix'] = params['Prefix'] || '';
          reqParams['max-uploads'] = params['MaxUploads'];
          reqParams['key-marker'] = params['KeyMarker'];
          reqParams['upload-id-marker'] = params['UploadIdMarker'];
          reqParams = util.clearKey(reqParams);
          var tracker = params.tracker;
          tracker && tracker.setParams({
            signStartTime: new Date().getTime()
          });
          submitRequest.call(this, {
            Action: 'name/cos:ListMultipartUploads',
            ResourceKey: reqParams['prefix'],
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            headers: params.Headers,
            qs: reqParams,
            action: 'uploads',
            tracker: tracker
          }, function (err, data) {
            if (err) {
              tracker && tracker.parent && tracker.parent.setParams({
                errorNode: 'multipartList'
              });
              return callback(err);
            }
            if (data && data.ListMultipartUploadsResult) {
              var Upload = data.ListMultipartUploadsResult.Upload || [];
              Upload = util.isArray(Upload) ? Upload : [Upload];
              data.ListMultipartUploadsResult.Upload = Upload;
            }
            var result = util.clone(data.ListMultipartUploadsResult || {});
            util.extend(result, {
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }

        /**
         * 上传的分块列表查询
         * @param  {Object}  params                                 参数对象，必须
         *     @param  {String}  params.Bucket                      Bucket名称，必须
         *     @param  {String}  params.Region                      地域名称，必须
         *     @param  {String}  params.Key                         object名称，必须
         *     @param  {String}  params.UploadId                    标示本次分块上传的ID，必须
         *     @param  {String}  params.EncodingType                规定返回值的编码方式，非必须
         *     @param  {String}  params.MaxParts                    单次返回最大的条目数量，默认1000，非必须
         *     @param  {String}  params.PartNumberMarker            默认以UTF-8二进制顺序列出条目，所有列出条目从marker开始，非必须
         * @param  {Function}  callback                             回调函数，必须
         * @return  {Object}  err                                   请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         * @return  {Object}  data                                  返回的数据
         *     @return  {Object}  data.ListMultipartUploadsResult   分块信息
         */
        function multipartListPart(params, callback) {
          var reqParams = {};
          var tracker = params.tracker;
          reqParams['uploadId'] = params['UploadId'];
          reqParams['encoding-type'] = params['EncodingType'];
          reqParams['max-parts'] = params['MaxParts'];
          reqParams['part-number-marker'] = params['PartNumberMarker'];
          submitRequest.call(this, {
            Action: 'name/cos:ListParts',
            method: 'GET',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            qs: reqParams,
            tracker: tracker
          }, function (err, data) {
            if (err) {
              tracker && tracker.parent && tracker.parent.setParams({
                errorNode: 'multipartListPart'
              });
              return callback(err);
            }
            var ListPartsResult = data.ListPartsResult || {};
            var Part = ListPartsResult.Part || [];
            Part = util.isArray(Part) ? Part : [Part];
            ListPartsResult.Part = Part;
            var result = util.clone(ListPartsResult);
            util.extend(result, {
              statusCode: data.statusCode,
              headers: data.headers
            });
            callback(null, result);
          });
        }

        /**
         * 抛弃分块上传
         * @param  {Object}  params                 参数对象，必须
         *     @param  {String}  params.Bucket      Bucket名称，必须
         *     @param  {String}  params.Region      地域名称，必须
         *     @param  {String}  params.Key         object名称，必须
         *     @param  {String}  params.UploadId    标示本次分块上传的ID，必须
         * @param  {Function}  callback             回调函数，必须
         *     @return  {Object}    err             请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         *     @return  {Object}    data            返回的数据
         */
        function multipartAbort(params, callback) {
          var reqParams = {};
          reqParams['uploadId'] = params['UploadId'];
          submitRequest.call(this, {
            Action: 'name/cos:AbortMultipartUpload',
            method: 'DELETE',
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            headers: params.Headers,
            qs: reqParams,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            callback(null, {
              statusCode: data.statusCode,
              headers: data.headers
            });
          });
        }

        /**
         * 抛弃分块上传
         * @param  {Object}  params                 参数对象，必须
         *     @param  {String}  params.Bucket      Bucket名称，必须
         *     @param  {String}  params.Region      地域名称，必须
         *     @param  {String}  params.Key         object名称，必须
         *     @param  {String}  params.UploadId    标示本次分块上传的ID，必须
         * @param  {Function}  callback             回调函数，必须
         *     @return  {Object}    err             请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         *     @return  {Object}    data            返回的数据
         */
        function request(params, callback) {
          submitRequest.call(this, {
            method: params.Method,
            Bucket: params.Bucket,
            Region: params.Region,
            Key: params.Key,
            action: params.Action,
            headers: params.Headers,
            qs: params.Query,
            body: params.Body,
            Url: params.Url,
            rawBody: params.RawBody,
            DataType: params.DataType,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            if (data && data.body) {
              data.Body = data.body;
              delete data.body;
            }
            callback(err, data);
          });
        }

        /**
         * 追加上传
         * @param  {Object}  params                                         参数对象，必须
         *     @param  {String}  params.Bucket                              Bucket名称，必须
         *     @param  {String}  params.Region                              地域名称，必须
         *     @param  {String}  params.Key                                 object名称，必须
         *     @param  {File || Blob || String}  params.Body                上传文件对象或字符串
         *     @param  {Number}  params.Position                            追加操作的起始点，单位为字节，必须
         *     @param  {String}  params.CacheControl                        RFC 2616 中定义的缓存策略，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentDisposition                  RFC 2616 中定义的文件名称，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentEncoding                     RFC 2616 中定义的编码格式，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ContentLength                       RFC 2616 中定义的 HTTP 请求内容长度（字节），必须
         *     @param  {String}  params.ContentType                         RFC 2616 中定义的内容类型（MIME），将作为 Object 元数据保存，非必须
         *     @param  {String}  params.Expect                              当使用 Expect: 100-continue 时，在收到服务端确认后，才会发送请求内容，非必须
         *     @param  {String}  params.Expires                             RFC 2616 中定义的过期时间，将作为 Object 元数据保存，非必须
         *     @param  {String}  params.ACL                                 允许用户自定义文件权限，有效值：private | public-read，非必须
         *     @param  {String}  params.GrantRead                           赋予被授权者读取对象的权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.GrantReadAcp                        赋予被授权者读取对象的访问控制列表（ACL）的权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.GrantWriteAcp                       赋予被授权者写入对象的访问控制列表（ACL）的权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.GrantFullControl                    赋予被授权者操作对象的所有权限，格式：id="[OwnerUin]"，可使用半角逗号（,）分隔多组被授权者，非必须
         *     @param  {String}  params.StorageClass                        设置对象的存储级别，枚举值：STANDARD、STANDARD_IA、ARCHIVE，默认值：STANDARD，非必须
         *     @param  {String}  params.x-cos-meta-*                        允许用户自定义的头部信息，将作为对象的元数据保存。大小限制2KB，非必须
         *     @param  {String}  params.ContentSha1                         RFC 3174 中定义的 160-bit 内容 SHA-1 算法校验，非必须
         *     @param  {String}  params.ServerSideEncryption                支持按照指定的加密算法进行服务端数据加密，格式 x-cos-server-side-encryption: "AES256"，非必须
         * @param  {Function}  callback                                     回调函数，必须
         *     @return  {Object}    err                                     请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         *     @return  {Object}    data                                    返回的数据
         */
        function appendObject(params, callback) {
          // 特殊处理 Cache-Control、Content-Type，避免代理更改这两个字段导致写入到 Object 属性里
          var headers = params.Headers;
          if (!headers['Cache-Control'] && !headers['cache-control']) headers['Cache-Control'] = '';
          if (!headers['Content-Type'] && !headers['content-type']) headers['Content-Type'] = params.Body && params.Body.type || '';
          submitRequest.call(this, {
            Action: 'name/cos:AppendObject',
            method: 'POST',
            Bucket: params.Bucket,
            Region: params.Region,
            action: 'append',
            Key: params.Key,
            body: params.Body,
            qs: {
              position: params.Position
            },
            headers: params.Headers,
            tracker: params.tracker
          }, function (err, data) {
            if (err) return callback(err);
            callback(null, data);
          });
        }

        /**
         * 获取签名
         * @param  {Object}  params             参数对象，必须
         *     @param  {String}  params.Method  请求方法，必须
         *     @param  {String}  params.Key     object名称，必须
         *     @param  {String}  params.Expires 名超时时间，单位秒，可选
         * @return  {String}  data              返回签名字符串
         */
        function getAuth(params) {
          var self = this;
          return util.getAuth({
            SecretId: params.SecretId || this.options.SecretId || '',
            SecretKey: params.SecretKey || this.options.SecretKey || '',
            Bucket: params.Bucket,
            Region: params.Region,
            Method: params.Method,
            Key: params.Key,
            Query: params.Query,
            Headers: params.Headers,
            Expires: params.Expires,
            UseRawKey: self.options.UseRawKey,
            SystemClockOffset: self.options.SystemClockOffset
          });
        }

        /**
         * 获取文件下载链接
         * @param  {Object}  params                 参数对象，必须
         *     @param  {String}  params.Bucket      Bucket名称，必须
         *     @param  {String}  params.Region      地域名称，必须
         *     @param  {String}  params.Key         object名称，必须
         *     @param  {String}  params.Method      请求的方法，可选
         *     @param  {String}  params.Expires     签名超时时间，单位秒，可选
         * @param  {Function}  callback             回调函数，必须
         *     @return  {Object}    err             请求失败的错误，如果请求成功，则为空。https://cloud.tencent.com/document/product/436/7730
         *     @return  {Object}    data            返回的数据
         */
        function getObjectUrl(params, callback) {
          var self = this;
          var useAccelerate = params.UseAccelerate === undefined ? self.options.UseAccelerate : params.UseAccelerate;
          var url = getUrl({
            ForcePathStyle: self.options.ForcePathStyle,
            protocol: params.Protocol || self.options.Protocol,
            domain: params.Domain || self.options.Domain,
            bucket: params.Bucket,
            region: useAccelerate ? 'accelerate' : params.Region,
            object: params.Key
          });
          var queryParamsStr = '';
          if (params.Query) {
            queryParamsStr += util.obj2str(params.Query);
          }
          if (params.QueryString) {
            queryParamsStr += (queryParamsStr ? '&' : '') + params.QueryString;
          }
          var syncUrl = url;
          if (params.Sign !== undefined && !params.Sign) {
            queryParamsStr && (syncUrl += '?' + queryParamsStr);
            callback(null, {
              Url: syncUrl
            });
            return syncUrl;
          }

          // 签名加上 Host，避免跨桶访问
          var SignHost = getSignHost.call(this, {
            Bucket: params.Bucket,
            Region: params.Region,
            UseAccelerate: params.UseAccelerate,
            Url: url
          });
          var AuthData = getAuthorizationAsync.call(this, {
            Action: (params.Method || '').toUpperCase() === 'PUT' ? 'name/cos:PutObject' : 'name/cos:GetObject',
            Bucket: params.Bucket || '',
            Region: params.Region || '',
            Method: params.Method || 'get',
            Key: params.Key,
            Expires: params.Expires,
            Headers: params.Headers,
            Query: params.Query,
            SignHost: SignHost,
            ForceSignHost: params.ForceSignHost === false ? false : self.options.ForceSignHost // getObjectUrl支持传参ForceSignHost
          }, function (err, AuthData) {
            if (!callback) return;
            if (err) {
              callback(err);
              return;
            }

            // 兼容万象url qUrlParamList需要再encode一次
            var replaceUrlParamList = function replaceUrlParamList(url) {
              var urlParams = url.match(/q-url-param-list.*?(?=&)/g)[0];
              var encodedParams = 'q-url-param-list=' + encodeURIComponent(urlParams.replace(/q-url-param-list=/, '')).toLowerCase();
              var reg = new RegExp(urlParams, 'g');
              var replacedUrl = url.replace(reg, encodedParams);
              return replacedUrl;
            };
            var signUrl = url;
            signUrl += '?' + (AuthData.Authorization.indexOf('q-signature') > -1 ? replaceUrlParamList(AuthData.Authorization) : 'sign=' + encodeURIComponent(AuthData.Authorization));
            AuthData.SecurityToken && (signUrl += '&x-cos-security-token=' + AuthData.SecurityToken);
            AuthData.ClientIP && (signUrl += '&clientIP=' + AuthData.ClientIP);
            AuthData.ClientUA && (signUrl += '&clientUA=' + AuthData.ClientUA);
            AuthData.Token && (signUrl += '&token=' + AuthData.Token);
            queryParamsStr && (signUrl += '&' + queryParamsStr);
            setTimeout(function () {
              callback(null, {
                Url: signUrl
              });
            });
          });
          if (AuthData) {
            syncUrl += '?' + AuthData.Authorization + (AuthData.SecurityToken ? '&x-cos-security-token=' + AuthData.SecurityToken : '');
            queryParamsStr && (syncUrl += '&' + queryParamsStr);
          } else {
            queryParamsStr && (syncUrl += '?' + queryParamsStr);
          }
          return syncUrl;
        }

        /**
         * 私有方法
         */
        function decodeAcl(AccessControlPolicy) {
          var result = {
            GrantFullControl: [],
            GrantWrite: [],
            GrantRead: [],
            GrantReadAcp: [],
            GrantWriteAcp: [],
            ACL: ''
          };
          var GrantMap = {
            FULL_CONTROL: 'GrantFullControl',
            WRITE: 'GrantWrite',
            READ: 'GrantRead',
            READ_ACP: 'GrantReadAcp',
            WRITE_ACP: 'GrantWriteAcp'
          };
          var AccessControlList = AccessControlPolicy && AccessControlPolicy.AccessControlList || {};
          var Grant = AccessControlList.Grant;
          if (Grant) {
            Grant = util.isArray(Grant) ? Grant : [Grant];
          }
          var PublicAcl = {
            READ: 0,
            WRITE: 0,
            FULL_CONTROL: 0
          };
          Grant && Grant.length && util.each(Grant, function (item) {
            if (item.Grantee.ID === 'qcs::cam::anyone:anyone' || item.Grantee.URI === 'http://cam.qcloud.com/groups/global/AllUsers') {
              PublicAcl[item.Permission] = 1;
            } else if (item.Grantee.ID !== AccessControlPolicy.Owner.ID) {
              result[GrantMap[item.Permission]].push('id="' + item.Grantee.ID + '"');
            }
          });
          if (PublicAcl.FULL_CONTROL || PublicAcl.WRITE && PublicAcl.READ) {
            result.ACL = 'public-read-write';
          } else if (PublicAcl.READ) {
            result.ACL = 'public-read';
          } else {
            result.ACL = 'private';
          }
          util.each(GrantMap, function (item) {
            result[item] = uniqGrant(result[item].join(','));
          });
          return result;
        }

        // Grant 去重
        function uniqGrant(str) {
          var arr = str.split(',');
          var exist = {};
          var i, item;
          for (i = 0; i < arr.length;) {
            item = arr[i].trim();
            if (exist[item]) {
              arr.splice(i, 1);
            } else {
              exist[item] = true;
              arr[i] = item;
              i++;
            }
          }
          return arr.join(',');
        }

        // 生成操作 url
        function getUrl(params) {
          var region = params.region || '';
          var longBucket = params.bucket || '';
          var shortBucket = longBucket.substr(0, longBucket.lastIndexOf('-'));
          var appId = longBucket.substr(longBucket.lastIndexOf('-') + 1);
          var domain = params.domain;
          var object = params.object;
          if (typeof domain === 'function') {
            domain = domain({
              Bucket: longBucket,
              Region: region
            });
          }
          // 兼容不带冒号的http、https
          if (['http', 'https'].includes(params.protocol)) {
            params.protocol = params.protocol + ':';
          }
          var protocol = params.protocol || (util.isBrowser && (typeof location === "undefined" ? "undefined" : _typeof(location)) === 'object' && location.protocol === 'http:' ? 'http:' : 'https:');
          if (!domain) {
            if (['cn-south', 'cn-south-2', 'cn-north', 'cn-east', 'cn-southwest', 'sg'].indexOf(region) > -1) {
              domain = '{Region}.myqcloud.com';
            } else {
              domain = 'cos.{Region}.myqcloud.com';
            }
            if (!params.ForcePathStyle) {
              domain = '{Bucket}.' + domain;
            }
          }
          domain = domain.replace(/\{\{AppId\}\}/gi, appId).replace(/\{\{Bucket\}\}/gi, shortBucket).replace(/\{\{Region\}\}/gi, region).replace(/\{\{.*?\}\}/gi, '');
          domain = domain.replace(/\{AppId\}/gi, appId).replace(/\{BucketName\}/gi, shortBucket).replace(/\{Bucket\}/gi, longBucket).replace(/\{Region\}/gi, region).replace(/\{.*?\}/gi, '');
          if (!/^[a-zA-Z]+:\/\//.test(domain)) {
            domain = protocol + '//' + domain;
          }

          // 去掉域名最后的斜杆
          if (domain.slice(-1) === '/') {
            domain = domain.slice(0, -1);
          }
          var url = domain;
          if (params.ForcePathStyle) {
            url += '/' + longBucket;
          }
          url += '/';
          if (object) {
            url += util.camSafeUrlEncode(object).replace(/%2F/g, '/');
          }
          if (params.isLocation) {
            url = url.replace(/^https?:\/\//, '');
          }
          return url;
        }
        var getSignHost = function getSignHost(opt) {
          if (!opt.Bucket || !opt.Region) return '';
          var useAccelerate = opt.UseAccelerate === undefined ? this.options.UseAccelerate : opt.UseAccelerate;
          var url = opt.Url || getUrl({
            ForcePathStyle: this.options.ForcePathStyle,
            protocol: this.options.Protocol,
            domain: this.options.Domain,
            bucket: opt.Bucket,
            region: useAccelerate ? 'accelerate' : opt.Region
          });
          var urlHost = url.replace(/^https?:\/\/([^/]+)(\/.*)?$/, '$1');
          return urlHost;
        };

        // 异步获取签名
        function getAuthorizationAsync(params, callback) {
          var headers = util.clone(params.Headers);
          var headerHost = '';
          util.each(headers, function (v, k) {
            (v === '' || ['content-type', 'cache-control', 'expires'].indexOf(k.toLowerCase()) > -1) && delete headers[k];
            if (k.toLowerCase() === 'host') headerHost = v;
          });
          // ForceSignHost明确传入false才不加入host签名
          var forceSignHost = params.ForceSignHost === false ? false : true;

          // Host 加入签名计算
          if (!headerHost && params.SignHost && forceSignHost) headers.Host = params.SignHost;

          // 获取凭证的回调，避免用户 callback 多次
          var cbDone = false;
          var cb = function cb(err, AuthData) {
            if (cbDone) return;
            cbDone = true;
            if (AuthData && AuthData.XCosSecurityToken && !AuthData.SecurityToken) {
              AuthData = util.clone(AuthData);
              AuthData.SecurityToken = AuthData.XCosSecurityToken;
              delete AuthData.XCosSecurityToken;
            }
            callback && callback(err, AuthData);
          };
          var self = this;
          var Bucket = params.Bucket || '';
          var Region = params.Region || '';

          // PathName
          var KeyName = params.Key || '';
          if (self.options.ForcePathStyle && Bucket) {
            KeyName = Bucket + '/' + KeyName;
          }
          var Pathname = '/' + KeyName;

          // Action、ResourceKey
          var StsData = {};
          var Scope = params.Scope;
          if (!Scope) {
            var Action = params.Action || '';
            var ResourceKey = params.ResourceKey || params.Key || '';
            Scope = params.Scope || [{
              action: Action,
              bucket: Bucket,
              region: Region,
              prefix: ResourceKey
            }];
          }
          var ScopeKey = util.md5(JSON.stringify(Scope));

          // STS
          self._StsCache = self._StsCache || [];
          (function () {
            var i, AuthData;
            for (i = self._StsCache.length - 1; i >= 0; i--) {
              AuthData = self._StsCache[i];
              var compareTime = Math.round(util.getSkewTime(self.options.SystemClockOffset) / 1000) + 30;
              if (AuthData.StartTime && compareTime < AuthData.StartTime || compareTime >= AuthData.ExpiredTime) {
                self._StsCache.splice(i, 1);
                continue;
              }
              if (!AuthData.ScopeLimit || AuthData.ScopeLimit && AuthData.ScopeKey === ScopeKey) {
                StsData = AuthData;
                break;
              }
            }
          })();
          var calcAuthByTmpKey = function calcAuthByTmpKey() {
            var KeyTime = '';
            if (StsData.StartTime && params.Expires) KeyTime = StsData.StartTime + ';' + (StsData.StartTime + params.Expires * 1);else if (StsData.StartTime && StsData.ExpiredTime) KeyTime = StsData.StartTime + ';' + StsData.ExpiredTime;
            var Authorization = util.getAuth({
              SecretId: StsData.TmpSecretId,
              SecretKey: StsData.TmpSecretKey,
              Method: params.Method,
              Pathname: Pathname,
              Query: params.Query,
              Headers: headers,
              Expires: params.Expires,
              UseRawKey: self.options.UseRawKey,
              SystemClockOffset: self.options.SystemClockOffset,
              KeyTime: KeyTime,
              ForceSignHost: forceSignHost
            });
            var AuthData = {
              Authorization: Authorization,
              SecurityToken: StsData.SecurityToken || StsData.XCosSecurityToken || '',
              Token: StsData.Token || '',
              ClientIP: StsData.ClientIP || '',
              ClientUA: StsData.ClientUA || '',
              SignFrom: 'client'
            };
            cb(null, AuthData);
          };
          var checkAuthError = function checkAuthError(AuthData) {
            if (AuthData.Authorization) {
              // 检查签名格式
              var formatAllow = false;
              var auth = AuthData.Authorization;
              if (auth) {
                if (auth.indexOf(' ') > -1) {
                  formatAllow = false;
                } else if (auth.indexOf('q-sign-algorithm=') > -1 && auth.indexOf('q-ak=') > -1 && auth.indexOf('q-sign-time=') > -1 && auth.indexOf('q-key-time=') > -1 && auth.indexOf('q-url-param-list=') > -1) {
                  formatAllow = true;
                } else {
                  try {
                    auth = atob(auth);
                    if (auth.indexOf('a=') > -1 && auth.indexOf('k=') > -1 && auth.indexOf('t=') > -1 && auth.indexOf('r=') > -1 && auth.indexOf('b=') > -1) {
                      formatAllow = true;
                    }
                  } catch (e) {}
                }
              }
              if (!formatAllow) return util.error(new Error('getAuthorization callback params format error'));
            } else {
              if (!AuthData.TmpSecretId) return util.error(new Error('getAuthorization callback params missing "TmpSecretId"'));
              if (!AuthData.TmpSecretKey) return util.error(new Error('getAuthorization callback params missing "TmpSecretKey"'));
              if (!AuthData.SecurityToken && !AuthData.XCosSecurityToken) return util.error(new Error('getAuthorization callback params missing "SecurityToken"'));
              if (!AuthData.ExpiredTime) return util.error(new Error('getAuthorization callback params missing "ExpiredTime"'));
              if (AuthData.ExpiredTime && AuthData.ExpiredTime.toString().length !== 10) return util.error(new Error('getAuthorization callback params "ExpiredTime" should be 10 digits'));
              if (AuthData.StartTime && AuthData.StartTime.toString().length !== 10) return util.error(new Error('getAuthorization callback params "StartTime" should be 10 StartTime'));
            }
            return false;
          };

          // 先判断是否有临时密钥
          if (StsData.ExpiredTime && StsData.ExpiredTime - util.getSkewTime(self.options.SystemClockOffset) / 1000 > 60) {
            // 如果缓存的临时密钥有效，并还有超过60秒有效期就直接使用
            calcAuthByTmpKey();
          } else if (self.options.getAuthorization) {
            // 外部计算签名或获取临时密钥
            self.options.getAuthorization.call(self, {
              Bucket: Bucket,
              Region: Region,
              Method: params.Method,
              Key: KeyName,
              Pathname: Pathname,
              Query: params.Query,
              Headers: headers,
              Scope: Scope,
              SystemClockOffset: self.options.SystemClockOffset,
              ForceSignHost: forceSignHost
            }, function (AuthData) {
              if (typeof AuthData === 'string') AuthData = {
                Authorization: AuthData
              };
              var AuthError = checkAuthError(AuthData);
              if (AuthError) return cb(AuthError);
              if (AuthData.Authorization) {
                cb(null, AuthData);
              } else {
                StsData = AuthData || {};
                StsData.Scope = Scope;
                StsData.ScopeKey = ScopeKey;
                self._StsCache.push(StsData);
                calcAuthByTmpKey();
              }
            });
          } else if (self.options.getSTS) {
            // 外部获取临时密钥
            self.options.getSTS.call(self, {
              Bucket: Bucket,
              Region: Region
            }, function (data) {
              StsData = data || {};
              StsData.Scope = Scope;
              StsData.ScopeKey = ScopeKey;
              if (!StsData.TmpSecretId) StsData.TmpSecretId = StsData.SecretId;
              if (!StsData.TmpSecretKey) StsData.TmpSecretKey = StsData.SecretKey;
              var AuthError = checkAuthError(StsData);
              if (AuthError) return cb(AuthError);
              self._StsCache.push(StsData);
              calcAuthByTmpKey();
            });
          } else {
            // 内部计算获取签名
            return function () {
              var KeyTime = '';
              if (self.options.StartTime && params.Expires) {
                if (self.options.StartTime.toString().length !== 10) {
                  return cb(util.error(new Error('params "StartTime" should be 10 digits')));
                }
                KeyTime = self.options.StartTime + ';' + (self.options.StartTime + params.Expires * 1);
              } else if (self.options.StartTime && self.options.ExpiredTime) {
                if (self.options.StartTime.toString().length !== 10) {
                  return cb(util.error(new Error('params "StartTime" should be 10 digits')));
                }
                if (self.options.ExpiredTime.toString().length !== 10) {
                  return cb(util.error(new Error('params "ExpiredTime" should be 10 digits')));
                }
                KeyTime = self.options.StartTime + ';' + self.options.ExpiredTime * 1;
              }
              var Authorization = util.getAuth({
                SecretId: params.SecretId || self.options.SecretId,
                SecretKey: params.SecretKey || self.options.SecretKey,
                Method: params.Method,
                Pathname: Pathname,
                Query: params.Query,
                Headers: headers,
                Expires: params.Expires,
                KeyTime: KeyTime,
                UseRawKey: self.options.UseRawKey,
                SystemClockOffset: self.options.SystemClockOffset,
                ForceSignHost: forceSignHost
              });
              var AuthData = {
                Authorization: Authorization,
                SecurityToken: self.options.SecurityToken || self.options.XCosSecurityToken,
                SignFrom: 'client'
              };
              cb(null, AuthData);
              return AuthData;
            }();
          }
          return '';
        }

        // 判断当前请求出错时能否重试
        function allowRetry(err) {
          var self = this;
          var canRetry = false;
          var isTimeError = false;
          var networkError = false;
          var serverDate = err.headers && (err.headers.date || err.headers.Date) || err.error && err.error.ServerTime;
          try {
            var errorCode = err.error.Code;
            var errorMessage = err.error.Message;
            if (errorCode === 'RequestTimeTooSkewed' || errorCode === 'AccessDenied' && errorMessage === 'Request has expired') {
              isTimeError = true;
            }
          } catch (e) {}
          if (err) {
            // 调整时间偏差
            if (isTimeError && serverDate) {
              var serverTime = Date.parse(serverDate);
              if (this.options.CorrectClockSkew && Math.abs(util.getSkewTime(this.options.SystemClockOffset) - serverTime) >= 30000) {
                console.error('error: Local time is too skewed.');
                this.options.SystemClockOffset = serverTime - Date.now();
                canRetry = true;
              }
            } else if (Math.floor(err.statusCode / 100) === 5) {
              canRetry = true;
            } else if (err.message === 'CORS blocked or network error') {
              // 跨域/网络错误都包含在内
              networkError = true;
              canRetry = self.options.AutoSwitchHost;
            }
          }
          return {
            canRetry: canRetry,
            networkError: networkError
          };
        }

        /**
         * requestUrl：请求的url，用于判断是否cos主域名，true才切
         * clientCalcSign：是否客户端计算签名，服务端返回的签名不能切，true才切
         * networkError：是否未知网络错误，true才切
         * */
        function canSwitchHost(_ref) {
          var requestUrl = _ref.requestUrl,
              clientCalcSign = _ref.clientCalcSign,
              networkError = _ref.networkError;
          if (!this.options.AutoSwitchHost) return false;
          if (!requestUrl) return false;
          if (!clientCalcSign) return false;
          if (!networkError) return false;
          var commonReg = /^https?:\/\/[^\/]*\.cos\.[^\/]*\.myqcloud\.com(\/.*)?$/;
          var accelerateReg = /^https?:\/\/[^\/]*\.cos\.accelerate\.myqcloud\.com(\/.*)?$/;
          // 当前域名是cos主域名才切换
          var isCommonCosHost = commonReg.test(requestUrl) && !accelerateReg.test(requestUrl);
          return isCommonCosHost;
        }

        // 获取签名并发起请求
        function submitRequest(params, callback) {
          var self = this;

          // 处理 headers
          !params.headers && (params.headers = {});

          // 处理 query
          !params.qs && (params.qs = {});
          params.VersionId && (params.qs.versionId = params.VersionId);
          params.qs = util.clearKey(params.qs);

          // 清理 undefined 和 null 字段
          params.headers && (params.headers = util.clearKey(params.headers));
          params.qs && (params.qs = util.clearKey(params.qs));
          var Query = util.clone(params.qs);
          params.action && (Query[params.action] = '');

          /**
           * 手动传params.SignHost的场景：cos.getService、cos.getObjectUrl
           * 手动传Url的场景：cos.request
           */
          var paramsUrl = params.url || params.Url;
          var SignHost = params.SignHost || getSignHost.call(this, {
            Bucket: params.Bucket,
            Region: params.Region,
            Url: paramsUrl
          });
          var tracker = params.tracker;
          var next = function next(tryTimes) {
            var oldClockOffset = self.options.SystemClockOffset;
            tracker && tracker.setParams({
              signStartTime: new Date().getTime(),
              httpRetryTimes: tryTimes - 1
            });
            if (params.SwitchHost) {
              // 更换要签的host
              SignHost = SignHost.replace(/myqcloud.com/, 'tencentcos.cn');
            }
            getAuthorizationAsync.call(self, {
              Bucket: params.Bucket || '',
              Region: params.Region || '',
              Method: params.method,
              Key: params.Key,
              Query: Query,
              Headers: params.headers,
              SignHost: SignHost,
              Action: params.Action,
              ResourceKey: params.ResourceKey,
              Scope: params.Scope,
              ForceSignHost: self.options.ForceSignHost,
              SwitchHost: params.SwitchHost
            }, function (err, AuthData) {
              if (err) {
                callback(err);
                return;
              }
              tracker && tracker.setParams({
                signEndTime: new Date().getTime(),
                httpStartTime: new Date().getTime()
              });
              params.AuthData = AuthData;
              _submitRequest.call(self, params, function (err, data) {
                tracker && tracker.setParams({
                  httpEndTime: new Date().getTime()
                });
                var canRetry = false;
                var networkError = false;
                if (err) {
                  var info = allowRetry.call(self, err);
                  canRetry = info.canRetry || oldClockOffset !== self.options.SystemClockOffset;
                  networkError = info.networkError;
                }
                if (err && tryTimes < 2 && canRetry) {
                  if (params.headers) {
                    delete params.headers.Authorization;
                    delete params.headers['token'];
                    delete params.headers['clientIP'];
                    delete params.headers['clientUA'];
                    params.headers['x-cos-security-token'] && delete params.headers['x-cos-security-token'];
                    params.headers['x-ci-security-token'] && delete params.headers['x-ci-security-token'];
                  }
                  // 进入重试逻辑时 需判断是否需要切换cos备用域名
                  var switchHost = canSwitchHost.call(self, {
                    requestUrl: (err === null || err === void 0 ? void 0 : err.url) || '',
                    clientCalcSign: AuthData.SignFrom === 'client',
                    networkError: networkError
                  });
                  params.SwitchHost = switchHost;
                  params.retry = true;
                  next(tryTimes + 1);
                } else {
                  callback(err, data);
                }
              });
            });
          };
          next(1);
        }

        // 发起请求
        function _submitRequest(params, callback) {
          var self = this;
          var TaskId = params.TaskId;
          if (TaskId && !self._isRunningTask(TaskId)) return;
          var bucket = params.Bucket;
          var region = params.Region;
          var object = params.Key;
          var method = params.method || 'GET';
          var url = params.Url || params.url;
          var body = params.body;
          var rawBody = params.rawBody;

          // url
          if (self.options.UseAccelerate) {
            region = 'accelerate';
          }
          url = url || getUrl({
            ForcePathStyle: self.options.ForcePathStyle,
            protocol: self.options.Protocol,
            domain: self.options.Domain,
            bucket: bucket,
            region: region,
            object: object
          });
          if (params.SwitchHost) {
            // 更换请求的url
            url = url.replace(/myqcloud.com/, 'tencentcos.cn');
          }
          var repoterUrl = object ? url : '';
          if (params.action) {
            // 已知问题，某些版本的qq会对url自动拼接（比如/upload被拼接成/upload=(null)）导致签名错误，这里做下兼容。
            url = url + '?' + (util.isIOS_QQ ? "".concat(params.action, "=") : params.action);
          }
          if (params.qsStr) {
            if (url.indexOf('?') > -1) {
              url = url + '&' + params.qsStr;
            } else {
              url = url + '?' + params.qsStr;
            }
          }
          var opt = {
            method: method,
            url: url,
            headers: params.headers,
            qs: params.qs,
            body: body
          };

          // 兼容ci接口
          var token = 'x-cos-security-token';
          if (util.isCIHost(url)) {
            token = 'x-ci-security-token';
          }

          // 获取签名
          opt.headers.Authorization = params.AuthData.Authorization;
          params.AuthData.Token && (opt.headers['token'] = params.AuthData.Token);
          params.AuthData.ClientIP && (opt.headers['clientIP'] = params.AuthData.ClientIP);
          params.AuthData.ClientUA && (opt.headers['clientUA'] = params.AuthData.ClientUA);
          params.AuthData.SecurityToken && (opt.headers[token] = params.AuthData.SecurityToken);

          // 清理 undefined 和 null 字段
          opt.headers && (opt.headers = util.clearKey(opt.headers));
          if (params.retry) {
            opt.headers['x-cos-sdk-retry'] = true;
          }
          opt = util.clearKey(opt);

          // progress
          if (params.onProgress && typeof params.onProgress === 'function') {
            var contentLength = body && (body.size || body.length) || 0;
            opt.onProgress = function (e) {
              if (TaskId && !self._isRunningTask(TaskId)) return;
              var loaded = e ? e.loaded : 0;
              params.onProgress({
                loaded: loaded,
                total: contentLength
              });
            };
          }
          if (params.onDownloadProgress) {
            opt.onDownloadProgress = params.onDownloadProgress;
          }
          if (params.DataType) {
            opt.dataType = params.DataType;
          }
          if (this.options.Timeout) {
            opt.timeout = this.options.Timeout;
          }
          self.options.ForcePathStyle && (opt.pathStyle = self.options.ForcePathStyle);
          self.emit('before-send', opt);
          var useAccelerate = opt.url.includes('accelerate.');
          var queryString = opt.qs ? Object.keys(opt.qs).map(function (key) {
            return "".concat(key, "=").concat(opt.qs[key]);
          }).join('&') : '';
          var fullUrl = queryString ? opt.url + '?' + queryString : opt.url;
          if (params.tracker) {
            var _opt$body;
            params.tracker.setParams({
              url: fullUrl,
              httpMethod: opt.method,
              accelerate: useAccelerate,
              httpSize: ((_opt$body = opt.body) === null || _opt$body === void 0 ? void 0 : _opt$body.size) || 0
            });
            // 分块上传时给父级tracker设置url信息
            if (params.tracker.parent && !params.tracker.parent.params.url) {
              params.tracker.parent.setParams({
                url: repoterUrl,
                accelerate: useAccelerate
              });
            }
          }
          var sender = (self.options.Request || REQUEST)(opt, function (r) {
            if (r && r.error === 'abort') return;
            var receive = {
              options: opt,
              error: r && r.error,
              statusCode: r && r.statusCode || 0,
              statusMessage: r && r.statusMessage || '',
              headers: r && r.headers || {},
              body: r && r.body
            };
            // 抛出事件，允许修改返回值的 error、statusCode、statusMessage、body
            self.emit('after-receive', receive);
            var err = receive.error;
            var body = receive.body;
            // 返回内容添加 状态码 和 headers
            var response = {
              statusCode: receive.statusCode,
              statusMessage: receive.statusMessage,
              headers: receive.headers
            };
            var hasReturned;
            var cb = function cb(err, data) {
              TaskId && self.off('inner-kill-task', killTask);
              if (hasReturned) return;
              hasReturned = true;
              var attrs = {};
              response && response.statusCode && (attrs.statusCode = response.statusCode);
              response && response.headers && (attrs.headers = response.headers);
              if (err) {
                opt.url && (attrs.url = opt.url);
                opt.method && (attrs.method = opt.method);
                err = util.extend(err || {}, attrs);
                callback(err, null);
              } else {
                // putObject 返回回调处理
                if (params.Action === 'name/cos:PutObject') {
                  var pHeaders = {};
                  for (var i in params.headers) {
                    var key = i.toLowerCase();
                    pHeaders[key] = params.headers[i];
                  }
                  if (pHeaders['x-cos-callback']) {
                    if (data.Error) {
                      data.CallbackError = util.clone(data.Error);
                      delete data.Error;
                    } else {
                      data.CallbackBody = util.clone(data);
                    }
                  } else if (pHeaders['x-cos-return-body']) {
                    if (data.Error) {
                      data.ReturnError = util.clone(data.Error);
                      delete data.Error;
                    } else {
                      data.ReturnBody = util.clone(data);
                    }
                  }
                }
                data = util.extend(data || {}, attrs);
                callback(null, data);
              }
              sender = null;
            };

            // 请求错误，发生网络错误
            if (err) return cb(util.error(err));

            // 请求返回码不为 200
            var statusCode = response.statusCode;
            var statusSuccess = Math.floor(statusCode / 100) === 2; // 200 202 204 206

            // 不对 body 进行转换，body 直接挂载返回
            if (rawBody) {
              if (statusSuccess) {
                return cb(null, {
                  body: body
                });
              } else {
                // 兼容报错时返回了 blob，需要解析成 string
                if (body instanceof Blob) {
                  util.readAsBinaryString(body, function (content) {
                    var json = util.parseResBody(content);
                    var errorBody = json.Error || json;
                    return cb(util.error(new Error(errorBody.Message || 'response body error'), {
                      code: errorBody.Code,
                      error: errorBody
                    }));
                  });
                  return;
                }
              }
            }

            // 解析body，兼容 xml、json，解析失败时完整返回
            var json = util.parseResBody(body);

            // 处理返回值
            var errorBody = json.Error || json;
            if (statusSuccess) {
              // 正确返回，状态码 2xx 时，body 不会有 Error
              cb(null, json);
            } else if (errorBody) {
              // 正常返回了 xml body，且有 Error 节点
              cb(util.error(new Error(errorBody.Message), {
                code: errorBody.Code,
                error: errorBody
              }));
            } else if (statusCode) {
              // 有错误的状态码
              cb(util.error(new Error(response.statusMessage), {
                code: '' + statusCode
              }));
            } else if (statusCode) {
              // 无状态码，或者获取不到状态码
              cb(util.error(new Error('statusCode error')));
            }
          });

          // kill task
          var killTask = function killTask(data) {
            if (data.TaskId === TaskId) {
              sender && sender.abort && sender.abort();
              self.off('inner-kill-task', killTask);
            }
          };
          TaskId && self.on('inner-kill-task', killTask);
        }
        var API_MAP = {
          // Bucket 相关方法
          getService: getService,
          // Bucket
          putBucket: putBucket,
          headBucket: headBucket,
          // Bucket
          getBucket: getBucket,
          deleteBucket: deleteBucket,
          putBucketAcl: putBucketAcl,
          // BucketACL
          getBucketAcl: getBucketAcl,
          putBucketCors: putBucketCors,
          // BucketCors
          getBucketCors: getBucketCors,
          deleteBucketCors: deleteBucketCors,
          getBucketLocation: getBucketLocation,
          // BucketLocation
          getBucketPolicy: getBucketPolicy,
          // BucketPolicy
          putBucketPolicy: putBucketPolicy,
          deleteBucketPolicy: deleteBucketPolicy,
          putBucketTagging: putBucketTagging,
          // BucketTagging
          getBucketTagging: getBucketTagging,
          deleteBucketTagging: deleteBucketTagging,
          putBucketLifecycle: putBucketLifecycle,
          // BucketLifecycle
          getBucketLifecycle: getBucketLifecycle,
          deleteBucketLifecycle: deleteBucketLifecycle,
          putBucketVersioning: putBucketVersioning,
          // BucketVersioning
          getBucketVersioning: getBucketVersioning,
          putBucketReplication: putBucketReplication,
          // BucketReplication
          getBucketReplication: getBucketReplication,
          deleteBucketReplication: deleteBucketReplication,
          putBucketWebsite: putBucketWebsite,
          // BucketWebsite
          getBucketWebsite: getBucketWebsite,
          deleteBucketWebsite: deleteBucketWebsite,
          putBucketReferer: putBucketReferer,
          // BucketReferer
          getBucketReferer: getBucketReferer,
          putBucketDomain: putBucketDomain,
          // BucketDomain
          getBucketDomain: getBucketDomain,
          deleteBucketDomain: deleteBucketDomain,
          putBucketOrigin: putBucketOrigin,
          // BucketOrigin
          getBucketOrigin: getBucketOrigin,
          deleteBucketOrigin: deleteBucketOrigin,
          putBucketLogging: putBucketLogging,
          // BucketLogging
          getBucketLogging: getBucketLogging,
          putBucketInventory: putBucketInventory,
          // BucketInventory
          postBucketInventory: postBucketInventory,
          getBucketInventory: getBucketInventory,
          listBucketInventory: listBucketInventory,
          deleteBucketInventory: deleteBucketInventory,
          putBucketAccelerate: putBucketAccelerate,
          getBucketAccelerate: getBucketAccelerate,
          putBucketEncryption: putBucketEncryption,
          getBucketEncryption: getBucketEncryption,
          deleteBucketEncryption: deleteBucketEncryption,
          // Object 相关方法
          getObject: getObject,
          headObject: headObject,
          listObjectVersions: listObjectVersions,
          putObject: putObject,
          deleteObject: deleteObject,
          getObjectAcl: getObjectAcl,
          putObjectAcl: putObjectAcl,
          optionsObject: optionsObject,
          putObjectCopy: putObjectCopy,
          deleteMultipleObject: deleteMultipleObject,
          restoreObject: restoreObject,
          putObjectTagging: putObjectTagging,
          getObjectTagging: getObjectTagging,
          deleteObjectTagging: deleteObjectTagging,
          selectObjectContent: selectObjectContent,
          appendObject: appendObject,
          // 分块上传相关方法
          uploadPartCopy: uploadPartCopy,
          multipartInit: multipartInit,
          multipartUpload: multipartUpload,
          multipartComplete: multipartComplete,
          multipartList: multipartList,
          multipartListPart: multipartListPart,
          multipartAbort: multipartAbort,
          // 工具方法
          request: request,
          getObjectUrl: getObjectUrl,
          getAuth: getAuth
        };
        function warnOldApi(apiName, fn, proto) {
          util.each(['Cors', 'Acl'], function (suffix) {
            if (apiName.slice(-suffix.length) === suffix) {
              var oldName = apiName.slice(0, -suffix.length) + suffix.toUpperCase();
              var apiFn = util.apiWrapper(apiName, fn);
              var warned = false;
              proto[oldName] = function () {
                !warned && console.warn('warning: cos.' + oldName + ' has been deprecated. Please Use cos.' + apiName + ' instead.');
                warned = true;
                apiFn.apply(this, arguments);
              };
            }
          });
        }
        module.exports.init = function (COS, task) {
          task.transferToTaskMethod(API_MAP, 'putObject');
          util.each(API_MAP, function (fn, apiName) {
            COS.prototype[apiName] = util.apiWrapper(apiName, fn);
            warnOldApi(apiName, fn, COS.prototype);
          });
        };

        /***/
      },

      /***/"./src/cos.js":
      /*!********************!*\
        !*** ./src/cos.js ***!
        \********************/
      /*! no static exports found */
      /***/function srcCosJs(module, exports, __webpack_require__) {

        "use strict";

        var util = __webpack_require__( /*! ./util */"./src/util.js");
        var event = __webpack_require__( /*! ./event */"./src/event.js");
        var task = __webpack_require__( /*! ./task */"./src/task.js");
        var base = __webpack_require__( /*! ./base */"./src/base.js");
        var advance = __webpack_require__( /*! ./advance */"./src/advance.js");
        var pkg = __webpack_require__( /*! ../package.json */"./package.json");
        var defaultOptions = {
          AppId: '',
          // AppId 已废弃，请拼接到 Bucket 后传入，例如：test-1250000000
          SecretId: '',
          SecretKey: '',
          SecurityToken: '',
          // 使用临时密钥需要注意自行刷新 Token
          StartTime: 0,
          // 临时密钥返回起始时间
          ExpiredTime: 0,
          // 临时密钥过期时间
          ChunkRetryTimes: 2,
          FileParallelLimit: 3,
          ChunkParallelLimit: 3,
          ChunkSize: 1024 * 1024,
          SliceSize: 1024 * 1024,
          CopyChunkParallelLimit: 20,
          CopyChunkSize: 1024 * 1024 * 10,
          CopySliceSize: 1024 * 1024 * 10,
          MaxPartNumber: 10000,
          ProgressInterval: 1000,
          Domain: '',
          ServiceDomain: '',
          Protocol: '',
          CompatibilityMode: false,
          ForcePathStyle: false,
          UseRawKey: false,
          Timeout: 0,
          // 单位毫秒，0 代表不设置超时时间
          CorrectClockSkew: true,
          SystemClockOffset: 0,
          // 单位毫秒，ms
          UploadCheckContentMd5: false,
          UploadQueueSize: 10000,
          UploadAddMetaMd5: false,
          UploadIdCacheLimit: 50,
          UseAccelerate: false,
          ForceSignHost: true,
          // 默认将host加入签名计算，关闭后可能导致越权风险，建议保持为true
          AutoSwitchHost: true,
          CopySourceParser: null,
          // 自定义拷贝源解析器
          ObjectKeySimplifyCheck: true,
          // 开启合并校验 getObject Key
          /** 上报相关 **/
          DeepTracker: false,
          // 上报时是否对每个分块上传做单独上报
          TrackerDelay: 5000,
          // 周期性上报，单位毫秒。0代表实时上报
          CustomId: '',
          // 自定义上报id
          BeaconReporter: null,
          // 灯塔上报组件，如有需要请自行传入，传入即代表开启上报
          ClsReporter: null // cls 上报组件，如有需要请自行传入，传入即代表开启上报
        };

        // 对外暴露的类
        var COS = function COS(options) {
          this.options = util.extend(util.clone(defaultOptions), options || {});
          this.options.FileParallelLimit = Math.max(1, this.options.FileParallelLimit);
          this.options.ChunkParallelLimit = Math.max(1, this.options.ChunkParallelLimit);
          this.options.ChunkRetryTimes = Math.max(0, this.options.ChunkRetryTimes);
          this.options.ChunkSize = Math.max(1024 * 1024, this.options.ChunkSize);
          this.options.CopyChunkParallelLimit = Math.max(1, this.options.CopyChunkParallelLimit);
          this.options.CopyChunkSize = Math.max(1024 * 1024, this.options.CopyChunkSize);
          this.options.CopySliceSize = Math.max(0, this.options.CopySliceSize);
          this.options.MaxPartNumber = Math.max(1024, Math.min(10000, this.options.MaxPartNumber));
          this.options.Timeout = Math.max(0, this.options.Timeout);
          this.options.EnableReporter = this.options.BeaconReporter || this.options.ClsReporter;
          if (this.options.AppId) {
            console.warn('warning: AppId has been deprecated, Please put it at the end of parameter Bucket(E.g: "test-1250000000").');
          }
          if (this.options.SecretId && this.options.SecretId.indexOf(' ') > -1) {
            console.error('error: SecretId格式错误，请检查');
            console.error('error: SecretId format is incorrect. Please check');
          }
          if (this.options.SecretKey && this.options.SecretKey.indexOf(' ') > -1) {
            console.error('error: SecretKey格式错误，请检查');
            console.error('error: SecretKey format is incorrect. Please check');
          }
          if (util.isNode()) {
            console.log('Tip: Next.js、Nuxt.js 等服务端渲染技术可正常使用JavaScript SDK，请忽略下方 nodejs 环境警告');
            console.warn('warning: cos-js-sdk-v5 不支持 nodejs 环境使用，请改用 cos-nodejs-sdk-v5，参考文档： https://cloud.tencent.com/document/product/436/8629');
            console.warn('warning: cos-js-sdk-v5 does not support nodejs environment. Please use cos-nodejs-sdk-v5 instead. See: https://cloud.tencent.com/document/product/436/8629');
          }
          if (this.options.ForcePathStyle) {
            console.warn('cos-js-sdk-v5不再支持使用path-style，仅支持使用virtual-hosted-style，参考文档：https://cloud.tencent.com/document/product/436/96243');
            throw new Error('ForcePathStyle is not supported');
          }
          event.init(this);
          task.init(this);
        };
        base.init(COS, task);
        advance.init(COS, task);
        COS.util = {
          md5: util.md5,
          xml2json: util.xml2json,
          json2xml: util.json2xml,
          encodeBase64: util.encodeBase64
        };
        COS.getAuthorization = util.getAuth;
        COS.version = pkg.version;
        module.exports = COS;

        /***/
      },

      /***/"./src/event.js":
      /*!**********************!*\
        !*** ./src/event.js ***!
        \**********************/
      /*! no static exports found */
      /***/function srcEventJs(module, exports) {

        var initEvent = function initEvent(cos) {
          var listeners = {};
          var getList = function getList(action) {
            !listeners[action] && (listeners[action] = []);
            return listeners[action];
          };
          cos.on = function (action, callback) {
            if (action === 'task-list-update') {
              console.warn('warning: Event "' + action + '" has been deprecated. Please use "list-update" instead.');
            }
            getList(action).push(callback);
          };
          cos.off = function (action, callback) {
            var list = getList(action);
            for (var i = list.length - 1; i >= 0; i--) {
              callback === list[i] && list.splice(i, 1);
            }
          };
          cos.emit = function (action, data) {
            var list = getList(action).map(function (cb) {
              return cb;
            });
            for (var i = 0; i < list.length; i++) {
              list[i](data);
            }
          };
        };
        var EventProxy = function EventProxy() {
          initEvent(this);
        };
        module.exports.init = initEvent;
        module.exports.EventProxy = EventProxy;

        /***/
      },

      /***/"./src/session.js":
      /*!************************!*\
        !*** ./src/session.js ***!
        \************************/
      /*! no static exports found */
      /***/function srcSessionJs(module, exports, __webpack_require__) {

        var util = __webpack_require__( /*! ./util */"./src/util.js");

        // 按照文件特征值，缓存 UploadId
        var cacheKey = 'cos_sdk_upload_cache';
        var expires = 30 * 24 * 3600;
        var cache;
        var timer;
        var getCache = function getCache() {
          try {
            var val = JSON.parse(localStorage.getItem(cacheKey));
          } catch (e) {}
          if (!val) val = [];
          cache = val;
        };
        var setCache = function setCache() {
          try {
            if (cache.length) localStorage.setItem(cacheKey, JSON.stringify(cache));else localStorage.removeItem(cacheKey);
          } catch (e) {}
        };
        var init = function init() {
          if (cache) return;
          getCache.call(this);
          // 清理太老旧的数据
          var changed = false;
          var now = Math.round(Date.now() / 1000);
          for (var i = cache.length - 1; i >= 0; i--) {
            var mtime = cache[i][2];
            if (!mtime || mtime + expires < now) {
              cache.splice(i, 1);
              changed = true;
            }
          }
          changed && setCache();
        };

        // 把缓存存到本地
        var save = function save() {
          if (timer) return;
          timer = setTimeout(function () {
            setCache();
            timer = null;
          }, 400);
        };
        var mod = {
          using: {},
          // 标记 UploadId 正在使用
          setUsing: function setUsing(uuid) {
            mod.using[uuid] = true;
          },
          // 标记 UploadId 已经没在使用
          removeUsing: function removeUsing(uuid) {
            delete mod.using[uuid];
          },
          // 用上传参数生成哈希值
          getFileId: function getFileId(file, ChunkSize, Bucket, Key) {
            if (file.name && file.size && file.lastModifiedDate && ChunkSize) {
              return util.md5([file.name, file.size, file.lastModifiedDate, ChunkSize, Bucket, Key].join('::'));
            } else {
              return null;
            }
          },
          // 用上传参数生成哈希值
          getCopyFileId: function getCopyFileId(copySource, sourceHeaders, ChunkSize, Bucket, Key) {
            var size = sourceHeaders['content-length'];
            var etag = sourceHeaders.etag || '';
            var lastModified = sourceHeaders['last-modified'];
            if (copySource && ChunkSize) {
              return util.md5([copySource, size, etag, lastModified, ChunkSize, Bucket, Key].join('::'));
            } else {
              return null;
            }
          },
          // 获取文件对应的 UploadId 列表
          getUploadIdList: function getUploadIdList(uuid) {
            if (!uuid) return null;
            init.call(this);
            var list = [];
            for (var i = 0; i < cache.length; i++) {
              if (cache[i][0] === uuid) list.push(cache[i][1]);
            }
            return list.length ? list : null;
          },
          // 缓存 UploadId
          saveUploadId: function saveUploadId(uuid, UploadId, limit) {
            init.call(this);
            if (!uuid) return;
            // 清理没用的 UploadId，js 文件没有 FilePath ，只清理相同记录
            for (var i = cache.length - 1; i >= 0; i--) {
              var item = cache[i];
              if (item[0] === uuid && item[1] === UploadId) {
                cache.splice(i, 1);
              }
            }
            cache.unshift([uuid, UploadId, Math.round(Date.now() / 1000)]);
            if (cache.length > limit) cache.splice(limit);
            save();
          },
          // UploadId 已用完，移除掉
          removeUploadId: function removeUploadId(UploadId) {
            init.call(this);
            delete mod.using[UploadId];
            for (var i = cache.length - 1; i >= 0; i--) {
              if (cache[i][1] === UploadId) cache.splice(i, 1);
            }
            save();
          }
        };
        module.exports = mod;

        /***/
      },

      /***/"./src/task.js":
      /*!*********************!*\
        !*** ./src/task.js ***!
        \*********************/
      /*! no static exports found */
      /***/function srcTaskJs(module, exports, __webpack_require__) {

        var session = __webpack_require__( /*! ./session */"./src/session.js");
        var util = __webpack_require__( /*! ./util */"./src/util.js");
        var originApiMap = {};
        var transferToTaskMethod = function transferToTaskMethod(apiMap, apiName) {
          originApiMap[apiName] = apiMap[apiName];
          apiMap[apiName] = function (params, callback) {
            if (params.SkipTask) {
              originApiMap[apiName].call(this, params, callback);
            } else {
              this._addTask(apiName, params, callback);
            }
          };
        };
        var initTask = function initTask(cos) {
          var queue = [];
          var tasks = {};
          var uploadingFileCount = 0;
          var nextUploadIndex = 0;

          // 接口返回简略的任务信息
          var formatTask = function formatTask(task) {
            var t = {
              id: task.id,
              Bucket: task.Bucket,
              Region: task.Region,
              Key: task.Key,
              FilePath: task.FilePath,
              state: task.state,
              loaded: task.loaded,
              size: task.size,
              speed: task.speed,
              percent: task.percent,
              hashPercent: task.hashPercent,
              error: task.error
            };
            if (task.FilePath) t.FilePath = task.FilePath;
            if (task._custom) t._custom = task._custom; // 控制台使用
            return t;
          };
          var emitListUpdate = function () {
            var timer;
            var emit = function emit() {
              timer = 0;
              cos.emit('task-list-update', {
                list: util.map(queue, formatTask)
              });
              cos.emit('list-update', {
                list: util.map(queue, formatTask)
              });
            };
            return function () {
              if (!timer) timer = setTimeout(emit);
            };
          }();
          var clearQueue = function clearQueue() {
            if (queue.length <= cos.options.UploadQueueSize) return;
            for (

            // 如果还太多，才继续清理
            var i = 0; i < nextUploadIndex &&
            // 小于当前操作的 index 才清理
            i < queue.length &&
            // 大于队列才清理
            queue.length > cos.options.UploadQueueSize;) {
              var isActive = queue[i].state === 'waiting' || queue[i].state === 'checking' || queue[i].state === 'uploading';
              if (!queue[i] || !isActive) {
                tasks[queue[i].id] && delete tasks[queue[i].id];
                queue.splice(i, 1);
                nextUploadIndex--;
              } else {
                i++;
              }
            }
            emitListUpdate();
          };
          var startNextTask = function startNextTask() {
            // 检查是否允许增加执行进程
            if (uploadingFileCount >= cos.options.FileParallelLimit) return;
            // 跳过不可执行的任务
            while (queue[nextUploadIndex] && queue[nextUploadIndex].state !== 'waiting') {
              nextUploadIndex++;
            } // 检查是否已遍历结束
            if (nextUploadIndex >= queue.length) return;
            // 上传该遍历到的任务
            var task = queue[nextUploadIndex];
            nextUploadIndex++;
            uploadingFileCount++;
            task.state = 'checking';
            task.params.onTaskStart && task.params.onTaskStart(formatTask(task));
            !task.params.UploadData && (task.params.UploadData = {});
            var apiParams = util.formatParams(task.api, task.params);
            originApiMap[task.api].call(cos, apiParams, function (err, data) {
              if (!cos._isRunningTask(task.id)) return;
              if (task.state === 'checking' || task.state === 'uploading') {
                task.state = err ? 'error' : 'success';
                err && (task.error = err);
                uploadingFileCount--;
                emitListUpdate();
                startNextTask();
                task.callback && task.callback(err, data);
                if (task.state === 'success') {
                  if (task.params) {
                    delete task.params.UploadData;
                    delete task.params.Body;
                    delete task.params;
                  }
                  delete task.callback;
                }
              }
              clearQueue();
            });
            emitListUpdate();
            // 异步执行下一个任务
            setTimeout(startNextTask);
          };
          var killTask = function killTask(id, switchToState) {
            var task = tasks[id];
            if (!task) return;
            var waiting = task && task.state === 'waiting';
            var running = task && (task.state === 'checking' || task.state === 'uploading');
            if (switchToState === 'canceled' && task.state !== 'canceled' || switchToState === 'paused' && waiting || switchToState === 'paused' && running) {
              task.state = switchToState;
              cos.emit('inner-kill-task', {
                TaskId: id,
                toState: switchToState
              });
              try {
                var UploadId = task && task.params && task.params.UploadData.UploadId;
              } catch (e) {}
              if (switchToState === 'canceled' && UploadId) session.removeUsing(UploadId);
              emitListUpdate();
              if (running) {
                uploadingFileCount--;
                startNextTask();
              }
              if (switchToState === 'canceled') {
                if (task.params) {
                  delete task.params.UploadData;
                  delete task.params.Body;
                  delete task.params;
                }
                delete task.callback;
              }
            }
            clearQueue();
          };
          cos._addTasks = function (taskList) {
            util.each(taskList, function (task) {
              cos._addTask(task.api, task.params, task.callback, true);
            });
            emitListUpdate();
          };
          var isTaskReadyWarning = true;
          cos._addTask = function (api, params, callback, ignoreAddEvent) {
            // 复制参数对象
            params = util.formatParams(api, params);

            // 生成 id
            var id = util.uuid();
            params.TaskId = id;
            params.onTaskReady && params.onTaskReady(id);
            if (params.TaskReady) {
              params.TaskReady(id);
              isTaskReadyWarning && console.warn('warning: Param "TaskReady" has been deprecated. Please use "onTaskReady" instead.');
              isTaskReadyWarning = false;
            }
            var task = {
              // env
              params: params,
              callback: callback,
              api: api,
              index: queue.length,
              // task
              id: id,
              Bucket: params.Bucket,
              Region: params.Region,
              Key: params.Key,
              FilePath: params.FilePath || '',
              state: 'waiting',
              loaded: 0,
              size: 0,
              speed: 0,
              percent: 0,
              hashPercent: 0,
              error: null,
              _custom: params._custom
            };
            var onHashProgress = params.onHashProgress;
            params.onHashProgress = function (info) {
              if (!cos._isRunningTask(task.id)) return;
              task.hashPercent = info.percent;
              onHashProgress && onHashProgress(info);
              emitListUpdate();
            };
            var onProgress = params.onProgress;
            params.onProgress = function (info) {
              if (!cos._isRunningTask(task.id)) return;
              task.state === 'checking' && (task.state = 'uploading');
              task.loaded = info.loaded;
              task.speed = info.speed;
              task.percent = info.percent;
              onProgress && onProgress(info);
              emitListUpdate();
            };

            // 异步获取 filesize
            util.getFileSize(api, params, function (err, size) {
              // 开始处理上传
              if (err) return callback(util.error(err)); // 如果获取大小出错，不加入队列
              // 获取完文件大小再把任务加入队列
              tasks[id] = task;
              queue.push(task);
              task.size = size;
              !ignoreAddEvent && emitListUpdate();
              startNextTask();
              clearQueue();
            });
            return id;
          };
          cos._isRunningTask = function (id) {
            var task = tasks[id];
            return !!(task && (task.state === 'checking' || task.state === 'uploading'));
          };
          cos.getTaskList = function () {
            return util.map(queue, formatTask);
          };
          cos.cancelTask = function (id) {
            killTask(id, 'canceled');
          };
          cos.pauseTask = function (id) {
            killTask(id, 'paused');
          };
          cos.restartTask = function (id) {
            var task = tasks[id];
            if (task && (task.state === 'paused' || task.state === 'error')) {
              task.state = 'waiting';
              emitListUpdate();
              nextUploadIndex = Math.min(nextUploadIndex, task.index);
              startNextTask();
            }
          };
          cos.isUploadRunning = function () {
            return uploadingFileCount || nextUploadIndex < queue.length;
          };
        };
        module.exports.transferToTaskMethod = transferToTaskMethod;
        module.exports.init = initTask;

        /***/
      },

      /***/"./src/tracker.js":
      /*!************************!*\
        !*** ./src/tracker.js ***!
        \************************/
      /*! no static exports found */
      /***/function srcTrackerJs(module, exports, __webpack_require__) {

        var _classCallCheck = __webpack_require__( /*! @babel/runtime/helpers/classCallCheck */"./node_modules/@babel/runtime/helpers/classCallCheck.js");
        var _createClass = __webpack_require__( /*! @babel/runtime/helpers/createClass */"./node_modules/@babel/runtime/helpers/createClass.js");
        var _typeof = __webpack_require__( /*! @babel/runtime/helpers/typeof */"./node_modules/@babel/runtime/helpers/typeof.js");
        var pkg = __webpack_require__( /*! ../package.json */"./package.json");
        var beacon = null;
        var getBeacon = function getBeacon(Beacon, delay) {
          if (!beacon) {
            // 生成 beacon
            if (typeof Beacon !== 'function') {
              throw new Error('Beacon not found');
            }
            beacon = new Beacon({
              appkey: '0WEB05PY6MHRGK0U',
              versionCode: pkg.version,
              channelID: 'js_sdk',
              //渠道,选填
              openid: 'openid',
              // 用户id, 选填
              unionid: 'unid',
              //用户unionid , 类似idfv,选填
              strictMode: false,
              //严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
              delay: delay,
              // 普通事件延迟上报时间(单位毫秒), 默认1000(1秒),选填
              sessionDuration: 60 * 1000 // session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
            });
          }
          return beacon;
        };

        // 毫秒转秒
        var ms2s = function ms2s(ms) {
          if (!ms || ms < 0) return 0;
          return (ms / 1000).toFixed(3);
        };
        var utils = {
          // 生成uid 每个链路对应唯一一条uid
          getUid: function getUid() {
            var S4 = function S4() {
              return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
            };
            return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
          },
          // 获取网络类型 4g ｜ wifi
          getNetType: function getNetType() {
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object') {
              var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
              return (connection === null || connection === void 0 ? void 0 : connection.type) || (connection === null || connection === void 0 ? void 0 : connection.effectiveType) || 'unknown';
            }
            return 'unknown';
          },
          // http | https
          getProtocol: function getProtocol() {
            if ((typeof location === "undefined" ? "undefined" : _typeof(location)) === 'object') {
              return location.protocol.replace(/:/, '');
            }
            return 'unknown protocol';
          },
          // 获取pc端操作系统类型
          getOsType: function getOsType() {
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== 'object') {
              return 'unknown os';
            }
            var agent = navigator.userAgent.toLowerCase();
            var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
            if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
              return 'win32';
            }
            if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
              return 'win64';
            }
            if (isMac) {
              return 'mac';
            }
            return 'unknown os';
          },
          isMobile: function isMobile() {
            var exp = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && navigator.userAgent.match(exp)) {
              return true; // 移动端
            }
            return false; // PC端
          },
          isAndroid: function isAndroid() {
            var exp = /(Android|Adr|Linux)/i;
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && navigator.userAgent.match(exp)) {
              return true;
            }
            return false;
          },
          isIOS: function isIOS() {
            var exp = /(iPhone|iPod|iPad|iOS)/i;
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && navigator.userAgent.match(exp)) {
              return true;
            }
            return false;
          },
          isOtherMobile: function isOtherMobile() {
            return isMobile && !isAndroid && !isIOS;
          },
          getUA: function getUA() {
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== 'object') {
              return 'unknown device';
            }
            var explorer = navigator.userAgent;
            return explorer;
          }
        };
        var isMobile = utils.isMobile();
        var mobileOsType = utils.isAndroid() ? 'android' : utils.isIOS ? 'ios' : 'other_mobile';
        var pcOsType = utils.getOsType();
        var devicePlatform = isMobile ? mobileOsType : pcOsType;
        var ua = utils.getUA();
        var protocol = utils.getProtocol();
        var transApiName = function transApiName(api) {
          if (['putObject', 'sliceUploadFile', 'uploadFile', 'uploadFiles'].includes(api)) {
            return 'UploadTask';
          } else if (api === 'getObject') {
            return 'DownloadTask';
          } else if (['putObjectCopy', 'sliceCopyFile'].includes(api)) {
            return 'CopyTask';
          }
          return api;
        };

        // 上报参数驼峰改下划线
        function camel2underline(key) {
          return key.replace(/([A-Z])/g, '_$1').toLowerCase();
        }
        function formatParams(params) {
          var formattedParams = {};
          var successKeys = ['sdkVersionName', 'sdkVersionCode', 'osName', 'networkType', 'requestName', 'requestResult', 'bucket', 'region', 'appid', 'accelerate', 'url', 'host', 'requestPath', 'userAgent', 'networkProtocol', 'httpMethod', 'httpSize', 'httpSpeed', 'httpTookTime', 'httpMd5', 'httpSign', 'httpFullTime', 'httpDomain', 'partNumber', 'httpRetryTimes', 'customId', 'traceId', 'realApi'];
          var failureKeys = [].concat(successKeys, ['errorNode', 'errorCode', 'errorName', 'errorMessage', 'errorRequestId', 'errorHttpCode', 'errorServiceName', 'errorType', 'fullError']);
          // 需要上报的参数字段
          var reporterKeys = params.requestResult === 'Success' ? successKeys : failureKeys;
          for (var key in params) {
            if (!reporterKeys.includes(key)) continue;
            var formattedKey = camel2underline(key);
            formattedParams[formattedKey] = params[key];
          }
          formattedParams['request_name'] = params.realApi ? transApiName(params.realApi) : params.requestName;
          return formattedParams;
        }

        // 链路追踪器
        var Tracker = /*#__PURE__*/function () {
          "use strict";

          function Tracker(opt) {
            _classCallCheck(this, Tracker);
            var parent = opt.parent,
                traceId = opt.traceId,
                bucket = opt.bucket,
                region = opt.region,
                apiName = opt.apiName,
                realApi = opt.realApi,
                httpMethod = opt.httpMethod,
                fileKey = opt.fileKey,
                fileSize = opt.fileSize,
                accelerate = opt.accelerate,
                customId = opt.customId,
                delay = opt.delay,
                deepTracker = opt.deepTracker,
                Beacon = opt.Beacon,
                clsReporter = opt.clsReporter;
            var appid = bucket && bucket.substr(bucket.lastIndexOf('-') + 1) || '';
            this.parent = parent;
            this.deepTracker = deepTracker;
            this.delay = delay;
            if (clsReporter && !this.clsReporter) {
              this.clsReporter = clsReporter;
            }
            // 上报用到的字段
            this.params = {
              // 通用字段
              sdkVersionName: 'cos-js-sdk-v5',
              sdkVersionCode: pkg.version,
              osName: devicePlatform,
              networkType: '',
              requestName: apiName || '',
              requestResult: '',
              // sdk api调用结果Success、Failure
              realApi: realApi,
              bucket: bucket,
              region: region,
              accelerate: accelerate,
              httpMethod: httpMethod,
              url: '',
              // 请求url
              host: '',
              httpDomain: '',
              requestPath: fileKey || '',
              userAgent: ua,
              networkProtocol: protocol,
              errorType: '',
              errorCode: '',
              errorName: '',
              errorMessage: '',
              errorRequestId: '',
              errorHttpCode: 0,
              errorServiceName: '',
              errorNode: '',
              httpTookTime: 0,
              // http整体耗时
              httpSize: fileSize || 0,
              // 主要是文件大小，大小 B
              httpMd5: 0,
              // MD5耗时
              httpSign: 0,
              // 计算签名耗时
              httpFullTime: 0,
              // 任务整体耗时(包括md5、签名等)
              httpSpeed: 0,
              // 主要关注上传速度，KB/s

              md5StartTime: 0,
              // md5计算开始时间
              md5EndTime: 0,
              // md5计算结束时间
              signStartTime: 0,
              // 计算签名开始时间
              signEndTime: 0,
              // 计算签名结束时间
              httpStartTime: 0,
              // 发起网络请求开始时间
              httpEndTime: 0,
              // 网路请求结束时间
              startTime: new Date().getTime(),
              // sdk api调用起始时间，不是纯网络耗时
              endTime: 0,
              //  sdk api调用结束时间，不是纯网络耗时

              // js补充字段
              traceId: traceId || utils.getUid(),
              // 每条上报唯一标识
              appid: appid,
              partNumber: 0,
              // 分块上传编号
              httpRetryTimes: 0,
              // sdk内部发起的请求重试
              customId: customId || '',
              // 业务id
              partTime: 0
            };
            if (Beacon) {
              this.beacon = getBeacon(Beacon, delay);
            }
          }

          // 格式化sdk回调
          _createClass(Tracker, [{
            key: "formatResult",
            value: function formatResult(err, data) {
              var _err$error, _err$error2, _err$error3, _err$error4, _err$error5, _err$error6;
              var now = new Date().getTime();
              var networkType = utils.getNetType();
              var errorCode = err ? (err === null || err === void 0 ? void 0 : err.code) || (err === null || err === void 0 ? void 0 : (_err$error = err.error) === null || _err$error === void 0 ? void 0 : _err$error.code) || (err === null || err === void 0 ? void 0 : (_err$error2 = err.error) === null || _err$error2 === void 0 ? void 0 : _err$error2.Code) : '';
              var errorMessage = err ? (err === null || err === void 0 ? void 0 : err.message) || (err === null || err === void 0 ? void 0 : (_err$error3 = err.error) === null || _err$error3 === void 0 ? void 0 : _err$error3.message) || (err === null || err === void 0 ? void 0 : (_err$error4 = err.error) === null || _err$error4 === void 0 ? void 0 : _err$error4.Message) : '';
              var errorName = errorMessage;
              var errorServiceName = err ? (err === null || err === void 0 ? void 0 : err.resource) || (err === null || err === void 0 ? void 0 : (_err$error5 = err.error) === null || _err$error5 === void 0 ? void 0 : _err$error5.resource) || (err === null || err === void 0 ? void 0 : (_err$error6 = err.error) === null || _err$error6 === void 0 ? void 0 : _err$error6.Resource) : '';
              var errorHttpCode = err ? err === null || err === void 0 ? void 0 : err.statusCode : data.statusCode;
              var requestId = err ? (err === null || err === void 0 ? void 0 : err.headers) && (err === null || err === void 0 ? void 0 : err.headers['x-cos-request-id']) : (data === null || data === void 0 ? void 0 : data.headers) && (data === null || data === void 0 ? void 0 : data.headers['x-cos-request-id']);
              var errorType = err ? requestId ? 'Server' : 'Client' : '';
              if (this.params.requestName === 'getObject') {
                this.params.httpSize = data ? data.headers && data.headers['content-length'] : 0;
              }

              // 上报 sliceUploadFile || uploadFile || uploadFiles 命中分块上传时
              var isSliceUploadFile = this.params.realApi === 'sliceUploadFile';
              var isSliceCopyFile = this.params.realApi === 'sliceCopyFile';
              if (isSliceUploadFile || isSliceCopyFile) {
                var speed = this.params.httpSize / 1024 / this.params.partTime;
                Object.assign(this.params, {
                  httpSpeed: speed < 0 ? 0 : speed.toFixed(3)
                });
              } else {
                var httpFullTime = now - this.params.startTime;
                var httpTookTime = this.params.httpEndTime - this.params.httpStartTime;
                var _speed = this.params.httpSize / 1024 / (httpTookTime / 1000);
                var httpMd5 = this.params.md5EndTime - this.params.md5StartTime;
                var httpSign = this.params.signEndTime - this.params.signStartTime;
                if (this.parent) {
                  this.parent.addParamValue('httpTookTime', ms2s(httpTookTime));
                  this.parent.addParamValue('httpFullTime', ms2s(httpFullTime));
                  this.parent.addParamValue('httpMd5', ms2s(httpMd5));
                  this.parent.addParamValue('httpSign', ms2s(httpSign));
                  if (['multipartUpload', 'uploadPartCopy', 'putObjectCopy'].includes(this.params.requestName)) {
                    // 只有小分块上传|复制才累计纯请求耗时，计算速度时用到
                    this.parent.addParamValue('partTime', ms2s(httpTookTime));
                  }
                }
                Object.assign(this.params, {
                  httpFullTime: ms2s(httpFullTime),
                  httpMd5: ms2s(httpMd5),
                  httpSign: ms2s(httpSign),
                  httpTookTime: ms2s(httpTookTime),
                  httpSpeed: _speed < 0 ? 0 : _speed.toFixed(3)
                });
              }
              Object.assign(this.params, {
                networkType: networkType,
                requestResult: err ? 'Failure' : 'Success',
                errorType: errorType,
                errorCode: errorCode,
                errorHttpCode: errorHttpCode,
                errorName: errorName,
                errorMessage: errorMessage,
                errorServiceName: errorServiceName,
                errorRequestId: requestId
              });
              if (err && (!errorCode || !errorMessage)) {
                // 暂存全量err一段时间 观察是否所有err格式都可被解析
                this.params.fullError = err ? JSON.stringify(err) : '';
              }
              if (this.params.url) {
                try {
                  var execRes = /^http(s)?:\/\/(.*?)\//.exec(this.params.url);
                  this.params.host = execRes[2];
                } catch (e) {
                  this.params.host = this.params.url;
                }
                this.params.httpDomain = this.params.host;
              }
            }

            // 上报
          }, {
            key: "report",
            value: function report(err, data) {
              if (!this.beacon && !this.clsReporter) return;
              this.formatResult(err, data);
              var formattedParams = formatParams(this.params);
              if (this.beacon) {
                this.sendEventsToBeacon(formattedParams);
              }
              if (this.clsReporter) {
                this.sendEventsToCLS(formattedParams);
              }
            }

            // 设置当前链路的参数
          }, {
            key: "setParams",
            value: function setParams(params) {
              Object.assign(this.params, params);
            }
          }, {
            key: "addParamValue",
            value: function addParamValue(key, value) {
              this.params[key] = (+this.params[key] + +value).toFixed(3);
            }

            // 上报灯塔
          }, {
            key: "sendEventsToBeacon",
            value: function sendEventsToBeacon(formattedParams) {
              // DeepTracker模式下才会上报分块上传内部细节
              var isSliceUploadFile = this.params.requestName === 'sliceUploadFile' || this.params.realApi === 'sliceUploadFile';
              if (isSliceUploadFile && !this.deepTracker) {
                return;
              }
              var eventCode = 'qcloud_track_cos_sdk';
              if (this.delay === 0) {
                // 实时上报
                this.beacon && this.beacon.onDirectUserAction(eventCode, formattedParams);
              } else {
                // 周期性上报
                this.beacon && this.beacon.onUserAction(eventCode, formattedParams);
              }
            }

            // 上报 cls
          }, {
            key: "sendEventsToCLS",
            value: function sendEventsToCLS(formattedParams) {
              // 是否实时上报
              var immediate = !!(this.delay === 0);
              this.clsReporter.log(formattedParams, immediate);
            }

            // 生成子实例，与父所属一个链路，可用于分块上传内部流程上报单个分块操作
          }, {
            key: "generateSubTracker",
            value: function generateSubTracker(subParams) {
              Object.assign(subParams, {
                parent: this,
                deepTracker: this.deepTracker,
                traceId: this.params.traceId,
                bucket: this.params.bucket,
                region: this.params.region,
                accelerate: this.params.accelerate,
                fileKey: this.params.requestPath,
                customId: this.params.customId,
                delay: this.delay,
                clsReporter: this.clsReporter
              });
              return new Tracker(subParams);
            }
          }]);
          return Tracker;
        }();
        module.exports = Tracker;

        /***/
      },

      /***/"./src/util.js":
      /*!*********************!*\
        !*** ./src/util.js ***!
        \*********************/
      /*! no static exports found */
      /***/function srcUtilJs(module, exports, __webpack_require__) {

        "use strict";
        /* WEBPACK VAR INJECTION */
        (function (process) {

          var _typeof = __webpack_require__( /*! @babel/runtime/helpers/typeof */"./node_modules/@babel/runtime/helpers/typeof.js");
          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;var i = 0;var F = function F() {};return { s: F, n: function n() {
                    if (i >= o.length) return { done: true };return { done: false, value: o[i++] };
                  }, e: function e(_e) {
                    throw _e;
                  }, f: F };
              }throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }var normalCompletion = true,
                didErr = false,
                err;return { s: function s() {
                it = it.call(o);
              }, n: function n() {
                var step = it.next();normalCompletion = step.done;return step;
              }, e: function e(_e2) {
                didErr = true;err = _e2;
              }, f: function f() {
                try {
                  if (!normalCompletion && it.return != null) it.return();
                } finally {
                  if (didErr) throw err;
                }
              } };
          }
          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
          }
          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }return arr2;
          }
          var md5 = __webpack_require__( /*! ../lib/md5 */"./lib/md5.js");
          var CryptoJS = __webpack_require__( /*! ../lib/crypto */"./lib/crypto.js");
          var _require = __webpack_require__( /*! fast-xml-parser */"./node_modules/fast-xml-parser/src/fxp.js"),
              XMLParser = _require.XMLParser,
              XMLBuilder = _require.XMLBuilder;
          var xmlParser = new XMLParser({
            ignoreDeclaration: true,
            // 忽略 XML 声明
            ignoreAttributes: true,
            // 忽略属性
            parseTagValue: false // 关闭自动解析
          });
          var xmlBuilder = new XMLBuilder();
          var base64 = __webpack_require__( /*! ../lib/base64 */"./lib/base64.js");
          var Tracker = __webpack_require__( /*! ./tracker */"./src/tracker.js");

          // XML 对象转 JSON 对象
          var xml2json = function xml2json(bodyStr) {
            var d = xmlParser.parse(bodyStr);
            return d;
          };

          // JSON 对象转 XML 对象
          var json2xml = function json2xml(json) {
            var xml = xmlBuilder.build(json);
            return xml;
          };
          function camSafeUrlEncode(str) {
            return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A');
          }
          function getObjectKeys(obj, forKey) {
            var list = [];
            for (var key in obj) {
              if (obj.hasOwnProperty(key)) {
                list.push(forKey ? camSafeUrlEncode(key).toLowerCase() : key);
              }
            }
            return list.sort(function (a, b) {
              a = a.toLowerCase();
              b = b.toLowerCase();
              return a === b ? 0 : a > b ? 1 : -1;
            });
          }

          /**
           * obj转为string
           * @param  {Object}  obj                需要转的对象，必须
           * @param  {Boolean} lowerCaseKey       key是否转为小写，默认false，非必须
           * @return {String}  data               返回字符串
           */
          var obj2str = function obj2str(obj, lowerCaseKey) {
            var i, key, val;
            var list = [];
            var keyList = getObjectKeys(obj);
            for (i = 0; i < keyList.length; i++) {
              key = keyList[i];
              val = obj[key] === undefined || obj[key] === null ? '' : '' + obj[key];
              key = lowerCaseKey ? camSafeUrlEncode(key).toLowerCase() : camSafeUrlEncode(key);
              val = camSafeUrlEncode(val) || '';
              list.push(key + '=' + val);
            }
            return list.join('&');
          };

          // 可以签入签名的headers
          var signHeaders = ['cache-control', 'content-disposition', 'content-encoding', 'content-length', 'content-md5', 'expect', 'expires', 'host', 'if-match', 'if-modified-since', 'if-none-match', 'if-unmodified-since', 'origin', 'range', 'transfer-encoding', 'pic-operations'];
          var getSignHeaderObj = function getSignHeaderObj(headers) {
            var signHeaderObj = {};
            for (var i in headers) {
              var key = i.toLowerCase();
              if (key.indexOf('x-cos-') > -1 || signHeaders.indexOf(key) > -1) {
                signHeaderObj[i] = headers[i];
              }
            }
            return signHeaderObj;
          };

          //测试用的key后面可以去掉
          var getAuth = function getAuth(opt) {
            opt = opt || {};
            var SecretId = opt.SecretId;
            var SecretKey = opt.SecretKey;
            var KeyTime = opt.KeyTime;
            var method = (opt.method || opt.Method || 'get').toLowerCase();
            var queryParams = clone(opt.Query || opt.params || {});
            var headers = getSignHeaderObj(clone(opt.Headers || opt.headers || {}));
            var Key = opt.Key || '';
            var pathname;
            if (opt.UseRawKey) {
              pathname = opt.Pathname || opt.pathname || '/' + Key;
            } else {
              pathname = opt.Pathname || opt.pathname || Key;
              pathname.indexOf('/') !== 0 && (pathname = '/' + pathname);
            }

            // ForceSignHost明确传入false才不加入host签名
            var forceSignHost = opt.ForceSignHost === false ? false : true;

            // 如果有传入存储桶且需要强制签名，那么签名默认加 Host 参与计算，避免跨桶访问
            if (!headers.Host && !headers.host && opt.Bucket && opt.Region && forceSignHost) headers.Host = opt.Bucket + '.cos.' + opt.Region + '.myqcloud.com';
            if (!SecretId) throw new Error('missing param SecretId');
            if (!SecretKey) throw new Error('missing param SecretKey');

            // 签名有效起止时间
            var now = Math.round(getSkewTime(opt.SystemClockOffset) / 1000) - 1;
            var exp = now;
            var Expires = opt.Expires || opt.expires;
            if (Expires === undefined) {
              exp += 900; // 签名过期时间为当前 + 900s
            } else {
              exp += Expires * 1 || 0;
            }

            // 要用到的 Authorization 参数列表
            var qSignAlgorithm = 'sha1';
            var qAk = SecretId;
            var qSignTime = KeyTime || now + ';' + exp;
            var qKeyTime = KeyTime || now + ';' + exp;
            var qHeaderList = getObjectKeys(headers, true).join(';').toLowerCase();
            var qUrlParamList = getObjectKeys(queryParams, true).join(';').toLowerCase();

            // 签名算法说明文档：https://www.qcloud.com/document/product/436/7778
            // 步骤一：计算 SignKey
            var signKey = CryptoJS.HmacSHA1(qKeyTime, SecretKey).toString();

            // 步骤二：构成 FormatString
            var formatString = [method, pathname, util.obj2str(queryParams, true), util.obj2str(headers, true), ''].join('\n');

            // 步骤三：计算 StringToSign
            var stringToSign = ['sha1', qSignTime, CryptoJS.SHA1(formatString).toString(), ''].join('\n');

            // 步骤四：计算 Signature
            var qSignature = CryptoJS.HmacSHA1(stringToSign, signKey).toString();

            // 步骤五：构造 Authorization
            var authorization = ['q-sign-algorithm=' + qSignAlgorithm, 'q-ak=' + qAk, 'q-sign-time=' + qSignTime, 'q-key-time=' + qKeyTime, 'q-header-list=' + qHeaderList, 'q-url-param-list=' + qUrlParamList, 'q-signature=' + qSignature].join('&');
            return authorization;
          };
          var readIntBE = function readIntBE(chunk, size, offset) {
            var bytes = size / 8;
            var buf = chunk.slice(offset, offset + bytes);
            new Uint8Array(buf).reverse();
            return new {
              8: Uint8Array,
              16: Uint16Array,
              32: Uint32Array
            }[size](buf)[0];
          };
          var buf2str = function buf2str(chunk, start, end, isUtf8) {
            var buf = chunk.slice(start, end);
            var str = '';
            new Uint8Array(buf).forEach(function (charCode) {
              str += String.fromCharCode(charCode);
            });
            if (isUtf8) str = decodeURIComponent(escape(str));
            return str;
          };
          var parseSelectPayload = function parseSelectPayload(chunk) {
            var header = {};
            var body = buf2str(chunk);
            var result = {
              records: []
            };
            while (chunk.byteLength) {
              var totalLength = readIntBE(chunk, 32, 0);
              var headerLength = readIntBE(chunk, 32, 4);
              var payloadRestLength = totalLength - headerLength - 16;
              var offset = 0;
              var content;
              chunk = chunk.slice(12);
              // 获取 Message 的 header 信息
              while (offset < headerLength) {
                var headerNameLength = readIntBE(chunk, 8, offset);
                var headerName = buf2str(chunk, offset + 1, offset + 1 + headerNameLength);
                var headerValueLength = readIntBE(chunk, 16, offset + headerNameLength + 2);
                var headerValue = buf2str(chunk, offset + headerNameLength + 4, offset + headerNameLength + 4 + headerValueLength);
                header[headerName] = headerValue;
                offset += headerNameLength + 4 + headerValueLength;
              }
              if (header[':event-type'] === 'Records') {
                content = buf2str(chunk, offset, offset + payloadRestLength, true);
                result.records.push(content);
              } else if (header[':event-type'] === 'Stats') {
                content = buf2str(chunk, offset, offset + payloadRestLength, true);
                result.stats = util.xml2json(content).Stats;
              } else if (header[':event-type'] === 'error') {
                var errCode = header[':error-code'];
                var errMessage = header[':error-message'];
                var err = new Error(errMessage);
                err.message = errMessage;
                err.name = err.code = errCode;
                result.error = err;
              } else if (['Progress', 'Continuation', 'End'].includes(header[':event-type'])) {
                // do nothing
              }
              chunk = chunk.slice(offset + payloadRestLength + 4);
            }
            return {
              payload: result.records.join(''),
              body: body
            };
          };
          var getSourceParams = function getSourceParams(source) {
            var parser = this.options.CopySourceParser;
            if (parser) return parser(source);
            var m = source.match(/^([^.]+-\d+)\.cos(v6|-cdc|-cdz|-internal)?\.([^.]+)\.((myqcloud\.com)|(tencentcos\.cn))\/(.+)$/);
            if (!m) return null;
            return {
              Bucket: m[1],
              Region: m[3],
              Key: m[7]
            };
          };
          var noop = function noop() {};

          // 清除对象里值为的 undefined 或 null 的属性
          var clearKey = function clearKey(obj) {
            var retObj = {};
            for (var key in obj) {
              if (obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null) {
                retObj[key] = obj[key];
              }
            }
            return retObj;
          };
          var readAsBinaryString = function readAsBinaryString(blob, callback) {
            var readFun;
            var fr = new FileReader();
            if (FileReader.prototype.readAsBinaryString) {
              readFun = FileReader.prototype.readAsBinaryString;
              fr.onload = function () {
                callback(this.result);
              };
            } else if (FileReader.prototype.readAsArrayBuffer) {
              // 在 ie11 添加 readAsBinaryString 兼容
              readFun = function readFun(fileData) {
                var binary = '';
                var pt = this;
                var reader = new FileReader();
                reader.onload = function (e) {
                  var bytes = new Uint8Array(reader.result);
                  var length = bytes.byteLength;
                  for (var i = 0; i < length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                  }
                  callback(binary);
                };
                reader.readAsArrayBuffer(fileData);
              };
            } else {
              console.error('FileReader not support readAsBinaryString');
            }
            readFun.call(fr, blob);
          };
          var fileSliceNeedCopy = function () {
            var compareVersion = function compareVersion(a, b) {
              a = a.split('.');
              b = b.split('.');
              for (var i = 0; i < b.length; i++) {
                if (a[i] !== b[i]) {
                  return parseInt(a[i]) > parseInt(b[i]) ? 1 : -1;
                }
              }
              return 0;
            };
            var check = function check(ua) {
              if (!ua) return false;
              var ChromeVersion = (ua.match(/Chrome\/([.\d]+)/) || [])[1];
              var QBCoreVersion = (ua.match(/QBCore\/([.\d]+)/) || [])[1];
              var QQBrowserVersion = (ua.match(/QQBrowser\/([.\d]+)/) || [])[1];
              var need = ChromeVersion && compareVersion(ChromeVersion, '53.0.2785.116') < 0 && QBCoreVersion && compareVersion(QBCoreVersion, '3.53.991.400') < 0 && QQBrowserVersion && compareVersion(QQBrowserVersion, '9.0.2524.400') <= 0 || false;
              return need;
            };
            return check(typeof navigator !== 'undefined' && navigator.userAgent);
          }();

          // 获取文件分片
          var fileSlice = function fileSlice(file, start, end, isUseToUpload, callback) {
            var blob;
            if (file.slice) {
              blob = file.slice(start, end);
            } else if (file.mozSlice) {
              blob = file.mozSlice(start, end);
            } else if (file.webkitSlice) {
              blob = file.webkitSlice(start, end);
            }
            if (isUseToUpload && fileSliceNeedCopy) {
              var reader = new FileReader();
              reader.onload = function (e) {
                blob = null;
                callback(new Blob([reader.result]));
              };
              reader.readAsArrayBuffer(blob);
            } else {
              callback(blob);
            }
          };

          // 获取文件内容的 MD5
          var getBodyMd5 = function getBodyMd5(UploadCheckContentMd5, Body, callback, onProgress) {
            callback = callback || noop;
            if (UploadCheckContentMd5) {
              if (typeof Body === 'string') {
                callback(util.md5(Body, true));
              } else if (Blob && Body instanceof Blob) {
                util.getFileMd5(Body, function (err, md5) {
                  callback(md5);
                }, onProgress);
              } else {
                callback();
              }
            } else {
              callback();
            }
          };

          // 获取文件 md5 值
          var md5ChunkSize = 1024 * 1024;
          var getFileMd5 = function getFileMd5(blob, callback, onProgress) {
            var size = blob.size;
            var loaded = 0;
            var md5ctx = md5.getCtx();
            var next = function next(start) {
              if (start >= size) {
                var hash = md5ctx.digest('hex');
                callback(null, hash);
                return;
              }
              var end = Math.min(size, start + md5ChunkSize);
              util.fileSlice(blob, start, end, false, function (chunk) {
                readAsBinaryString(chunk, function (content) {
                  chunk = null;
                  md5ctx = md5ctx.update(content, true);
                  loaded += content.length;
                  content = null;
                  if (onProgress) onProgress({
                    loaded: loaded,
                    total: size,
                    percent: Math.round(loaded / size * 10000) / 10000
                  });
                  next(start + md5ChunkSize);
                });
              });
            };
            next(0);
          };
          function clone(obj) {
            return map(obj, function (v) {
              return _typeof(v) === 'object' && v !== null ? clone(v) : v;
            });
          }
          function attr(obj, name, defaultValue) {
            return obj && name in obj ? obj[name] : defaultValue;
          }
          function extend(target, source) {
            each(source, function (val, key) {
              target[key] = source[key];
            });
            return target;
          }
          function isArray(arr) {
            return arr instanceof Array;
          }
          function isInArray(arr, item) {
            var flag = false;
            for (var i = 0; i < arr.length; i++) {
              if (item === arr[i]) {
                flag = true;
                break;
              }
            }
            return flag;
          }
          function makeArray(arr) {
            return isArray(arr) ? arr : [arr];
          }
          function each(obj, fn) {
            for (var i in obj) {
              if (obj.hasOwnProperty(i)) {
                fn(obj[i], i);
              }
            }
          }
          function map(obj, fn) {
            var o = isArray(obj) ? [] : {};
            for (var i in obj) {
              if (obj.hasOwnProperty(i)) {
                o[i] = fn(obj[i], i);
              }
            }
            return o;
          }
          function filter(obj, fn) {
            var iaArr = isArray(obj);
            var o = iaArr ? [] : {};
            for (var i in obj) {
              if (obj.hasOwnProperty(i)) {
                if (fn(obj[i], i)) {
                  if (iaArr) {
                    o.push(obj[i]);
                  } else {
                    o[i] = obj[i];
                  }
                }
              }
            }
            return o;
          }
          var b64 = function b64(str) {
            var i,
                len,
                char,
                res = '';
            for (i = 0, len = str.length / 2; i < len; i++) {
              char = parseInt(str[i * 2] + str[i * 2 + 1], 16);
              res += String.fromCharCode(char);
            }
            return btoa(res);
          };
          var uuid = function uuid() {
            var S4 = function S4() {
              return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
            };
            return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
          };
          var hasMissingParams = function hasMissingParams(apiName, params) {
            var Bucket = params.Bucket;
            var Region = params.Region;
            var Key = params.Key;
            var Domain = this.options.Domain;
            var checkBucket = !Domain || typeof Domain === 'string' && Domain.indexOf('{Bucket}') > -1;
            var checkRegion = !Domain || typeof Domain === 'string' && Domain.indexOf('{Region}') > -1;
            if (apiName.indexOf('Bucket') > -1 || apiName === 'deleteMultipleObject' || apiName === 'multipartList' || apiName === 'listObjectVersions') {
              if (checkBucket && !Bucket) return 'Bucket';
              if (checkRegion && !Region) return 'Region';
            } else if (apiName.indexOf('Object') > -1 || apiName.indexOf('multipart') > -1 || apiName === 'sliceUploadFile' || apiName === 'abortUploadTask' || apiName === 'uploadFile') {
              if (checkBucket && !Bucket) return 'Bucket';
              if (checkRegion && !Region) return 'Region';
              if (!Key) return 'Key';
            }
            return false;
          };
          var formatParams = function formatParams(apiName, params) {
            // 复制参数对象
            params = extend({}, params);

            // 统一处理 Headers
            if (apiName !== 'getAuth' && apiName !== 'getV4Auth' && apiName !== 'getObjectUrl') {
              var Headers = params.Headers || {};
              if (params && _typeof(params) === 'object') {
                (function () {
                  for (var key in params) {
                    if (params.hasOwnProperty(key) && key.indexOf('x-cos-') > -1) {
                      Headers[key] = params[key];
                    }
                  }
                })();
                var headerMap = {
                  // params headers
                  'x-cos-mfa': 'MFA',
                  'Content-MD5': 'ContentMD5',
                  'Content-Length': 'ContentLength',
                  'Content-Type': 'ContentType',
                  Expect: 'Expect',
                  Expires: 'Expires',
                  'Cache-Control': 'CacheControl',
                  'Content-Disposition': 'ContentDisposition',
                  'Content-Encoding': 'ContentEncoding',
                  Range: 'Range',
                  'If-Modified-Since': 'IfModifiedSince',
                  'If-Unmodified-Since': 'IfUnmodifiedSince',
                  'If-Match': 'IfMatch',
                  'If-None-Match': 'IfNoneMatch',
                  'x-cos-copy-source': 'CopySource',
                  'x-cos-copy-source-Range': 'CopySourceRange',
                  'x-cos-metadata-directive': 'MetadataDirective',
                  'x-cos-copy-source-If-Modified-Since': 'CopySourceIfModifiedSince',
                  'x-cos-copy-source-If-Unmodified-Since': 'CopySourceIfUnmodifiedSince',
                  'x-cos-copy-source-If-Match': 'CopySourceIfMatch',
                  'x-cos-copy-source-If-None-Match': 'CopySourceIfNoneMatch',
                  'x-cos-acl': 'ACL',
                  'x-cos-grant-read': 'GrantRead',
                  'x-cos-grant-write': 'GrantWrite',
                  'x-cos-grant-full-control': 'GrantFullControl',
                  'x-cos-grant-read-acp': 'GrantReadAcp',
                  'x-cos-grant-write-acp': 'GrantWriteAcp',
                  'x-cos-storage-class': 'StorageClass',
                  'x-cos-traffic-limit': 'TrafficLimit',
                  'x-cos-mime-limit': 'MimeLimit',
                  // SSE-C
                  'x-cos-server-side-encryption-customer-algorithm': 'SSECustomerAlgorithm',
                  'x-cos-server-side-encryption-customer-key': 'SSECustomerKey',
                  'x-cos-server-side-encryption-customer-key-MD5': 'SSECustomerKeyMD5',
                  // SSE-COS、SSE-KMS
                  'x-cos-server-side-encryption': 'ServerSideEncryption',
                  'x-cos-server-side-encryption-cos-kms-key-id': 'SSEKMSKeyId',
                  'x-cos-server-side-encryption-context': 'SSEContext',
                  // 上传时图片处理
                  'Pic-Operations': 'PicOperations',
                  'x-cos-callback': 'Callback',
                  'x-cos-callback-var': 'CallbackVar',
                  'x-cos-return-body': 'ReturnBody'
                };
                util.each(headerMap, function (paramKey, headerKey) {
                  if (params[paramKey] !== undefined) {
                    Headers[headerKey] = params[paramKey];
                  }
                });
                params.Headers = clearKey(Headers);
              }
            }
            return params;
          };
          var apiWrapper = function apiWrapper(apiName, apiFn) {
            return function (params, callback) {
              var self = this;

              // 处理参数
              if (typeof params === 'function') {
                callback = params;
                params = {};
              }

              // 整理参数格式
              params = formatParams(apiName, params);

              // tracker传递
              var tracker;
              if (self.options.EnableReporter) {
                if (params.calledBySdk === 'sliceUploadFile' || params.calledBySdk === 'sliceCopyFile') {
                  // 分块上传内部方法使用sliceUploadFile的子链路
                  tracker = params.tracker && params.tracker.generateSubTracker({
                    apiName: apiName
                  });
                } else if (['uploadFile', 'uploadFiles'].includes(apiName)) {
                  // uploadFile、uploadFiles方法在内部处理，此处不处理
                  tracker = null;
                } else {
                  var fileSize = 0;
                  if (params.Body) {
                    fileSize = typeof params.Body === 'string' ? params.Body.length : params.Body.size || params.Body.byteLength || 0;
                  }
                  var accelerate = self.options.UseAccelerate || typeof self.options.Domain === 'string' && self.options.Domain.includes('accelerate.');
                  tracker = new Tracker({
                    Beacon: self.options.BeaconReporter,
                    clsReporter: self.options.ClsReporter,
                    bucket: params.Bucket,
                    region: params.Region,
                    apiName: apiName,
                    realApi: apiName,
                    accelerate: accelerate,
                    fileKey: params.Key,
                    fileSize: fileSize,
                    deepTracker: self.options.DeepTracker,
                    customId: self.options.CustomId,
                    delay: self.options.TrackerDelay
                  });
                }
              }
              params.tracker = tracker;

              // 代理回调函数
              var formatResult = function formatResult(result) {
                if (result && result.headers) {
                  result.headers['x-cos-request-id'] && (result.RequestId = result.headers['x-cos-request-id']);
                  result.headers['x-ci-request-id'] && (result.RequestId = result.headers['x-ci-request-id']);
                  result.headers['x-cos-version-id'] && (result.VersionId = result.headers['x-cos-version-id']);
                  result.headers['x-cos-delete-marker'] && (result.DeleteMarker = result.headers['x-cos-delete-marker']);
                }
                return result;
              };
              var _callback = function _callback(err, data) {
                // 格式化上报参数并上报
                tracker && tracker.report(err, data);
                callback && callback(formatResult(err), formatResult(data));
              };
              var checkParams = function checkParams() {
                if (apiName !== 'getService' && apiName !== 'abortUploadTask') {
                  // 判断参数是否完整
                  var missingResult = hasMissingParams.call(self, apiName, params);
                  if (missingResult) {
                    return 'missing param ' + missingResult;
                  }
                  // 判断 region 格式
                  if (params.Region) {
                    if (self.options.CompatibilityMode) {
                      if (!/^([a-z\d-.]+)$/.test(params.Region)) {
                        return 'Region format error.';
                      }
                    } else {
                      if (params.Region.indexOf('cos.') > -1) {
                        return 'param Region should not be start with "cos."';
                      } else if (!/^([a-z\d-]+)$/.test(params.Region)) {
                        return 'Region format error.';
                      }
                    }
                    // 判断 region 格式
                    if (!self.options.CompatibilityMode && params.Region.indexOf('-') === -1 && params.Region !== 'yfb' && params.Region !== 'default' && params.Region !== 'accelerate') {
                      console.warn('warning: param Region format error, find help here: https://cloud.tencent.com/document/product/436/6224');
                    }
                  }
                  // 兼容不带 AppId 的 Bucket
                  if (params.Bucket) {
                    if (!/^([a-z\d-]+)-(\d+)$/.test(params.Bucket)) {
                      if (params.AppId) {
                        params.Bucket = params.Bucket + '-' + params.AppId;
                      } else if (self.options.AppId) {
                        params.Bucket = params.Bucket + '-' + self.options.AppId;
                      } else {
                        return 'Bucket should format as "test-1250000000".';
                      }
                    }
                    if (params.AppId) {
                      console.warn('warning: AppId has been deprecated, Please put it at the end of parameter Bucket(E.g Bucket:"test-1250000000" ).');
                      delete params.AppId;
                    }
                  }
                  // 如果 Key 是 / 开头，强制去掉第一个 /
                  if (!self.options.UseRawKey && params.Key && params.Key.substr(0, 1) === '/') {
                    params.Key = params.Key.substr(1);
                  }
                }
              };
              var errMsg = checkParams();
              var isSync = ['getAuth', 'getObjectUrl'].includes(apiName);
              if (typeof Promise === 'function' && !isSync && !callback) {
                return new Promise(function (resolve, reject) {
                  callback = function callback(err, data) {
                    err ? reject(err) : resolve(data);
                  };
                  if (errMsg) return _callback(util.error(new Error(errMsg)));
                  apiFn.call(self, params, _callback);
                });
              } else {
                if (errMsg) return _callback(util.error(new Error(errMsg)));
                var res = apiFn.call(self, params, _callback);
                if (isSync) return res;
              }
            };
          };
          var throttleOnProgress = function throttleOnProgress(total, onProgress) {
            var self = this;
            var size0 = 0;
            var size1 = 0;
            var time0 = Date.now();
            var time1;
            var timer;
            function update() {
              timer = 0;
              if (onProgress && typeof onProgress === 'function') {
                time1 = Date.now();
                var speed = Math.max(0, Math.round((size1 - size0) / ((time1 - time0) / 1000) * 100) / 100) || 0;
                var percent;
                if (size1 === 0 && total === 0) {
                  percent = 1;
                } else {
                  percent = Math.floor(size1 / total * 100) / 100 || 0;
                }
                time0 = time1;
                size0 = size1;
                try {
                  onProgress({
                    loaded: size1,
                    total: total,
                    speed: speed,
                    percent: percent
                  });
                } catch (e) {}
              }
            }
            return function (info, immediately) {
              if (info) {
                size1 = info.loaded;
                total = info.total;
              }
              if (immediately) {
                clearTimeout(timer);
                update();
              } else {
                if (timer) return;
                timer = setTimeout(update, self.options.ProgressInterval);
              }
            };
          };
          var getFileSize = function getFileSize(api, params, callback) {
            var size;
            if (typeof params.Body === 'string') {
              params.Body = new Blob([params.Body], {
                type: 'text/plain'
              });
            } else if (params.Body instanceof ArrayBuffer) {
              params.Body = new Blob([params.Body]);
            }
            if (params.Body && (params.Body instanceof Blob || params.Body.toString() === '[object File]' || params.Body.toString() === '[object Blob]')) {
              size = params.Body.size;
            } else {
              callback(util.error(new Error('params body format error, Only allow File|Blob|String.')));
              return;
            }
            params.ContentLength = size;
            callback(null, size);
          };

          // 获取调正的时间戳
          var getSkewTime = function getSkewTime(offset) {
            return Date.now() + (offset || 0);
          };
          var error = function error(err, opt) {
            var sourceErr = err;
            err.message = err.message || null;
            if (typeof opt === 'string') {
              err.error = opt;
              err.message = opt;
            } else if (_typeof(opt) === 'object' && opt !== null) {
              extend(err, opt);
              if (opt.code || opt.name) err.code = opt.code || opt.name;
              if (opt.message) err.message = opt.message;
              if (opt.stack) err.stack = opt.stack;
            }
            if (typeof Object.defineProperty === 'function') {
              Object.defineProperty(err, 'name', {
                writable: true,
                enumerable: false
              });
              Object.defineProperty(err, 'message', {
                enumerable: true
              });
            }
            err.name = opt && opt.name || err.name || err.code || 'Error';
            if (!err.code) err.code = err.name;
            if (!err.error) err.error = clone(sourceErr); // 兼容老的错误格式

            return err;
          };
          var isWebWorker = function isWebWorker() {
            // 有限判断 worker 环境的 constructor name 其次用 worker 独有的 FileReaderSync 兜底 详细参考 https://developer.mozilla.org/zh-CN/docs/Web/API/Web_Workers_API/Using_web_workers
            return (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === 'object' && (globalThis.constructor.name === 'DedicatedWorkerGlobalScope' || globalThis.FileReaderSync);
          };
          var isNode = function isNode() {
            // 得兜底 web worker 环境中 webpack 用了 process 插件之类的情况
            return (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object' && (typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && "function" === 'function' && !isWebWorker();
          };
          var isCIHost = function isCIHost(url) {
            return (/^https?:\/\/([^/]+\.)?ci\.[^/]+/.test(url)
            );
          };

          //判断是否是ios
          var isIOS = function () {
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== 'object') {
              return false;
            }
            var u = navigator.userAgent;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            return isIOS;
          }();

          // 判断是qq内置浏览器
          var isQQ = function () {
            if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== 'object') {
              return false;
            }
            return (/\sQQ/i.test(navigator.userAgent)
            );
          }();
          var encodeBase64 = function encodeBase64(str, safe) {
            var base64Str = base64.encode(str);
            // 万象使用的安全base64格式需要特殊处理
            if (safe) {
              base64Str = base64Str.replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
            }
            return base64Str;
          };
          var decodeBase64 = function decodeBase64(base64Str) {
            if (!base64Str) return '';
            return base64.decode(base64Str);
          };
          var simplifyPath = function simplifyPath(path) {
            var names = path.split('/');
            var stack = [];
            var _iterator = _createForOfIteratorHelper(names),
                _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var name = _step.value;
                if (name === '..') {
                  if (stack.length) {
                    stack.pop();
                  }
                } else if (name.length && name !== '.') {
                  stack.push(name);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return '/' + stack.join('/');
          };

          // 解析响应体，兼容 xml、json
          var parseResBody = function parseResBody(responseBody) {
            var json;
            if (responseBody && typeof responseBody === 'string') {
              var trimBody = responseBody.trim();
              var isXml = trimBody.indexOf('<') === 0;
              var isJson = trimBody.indexOf('{') === 0;
              if (isXml) {
                // xml 解析，解析失败返回{}
                json = util.xml2json(responseBody) || {};
              } else if (isJson) {
                // json解析，解析失败返回原始 Body
                try {
                  // 替换 json 中的换行符为空格，否则解析会出错
                  var formatBody = responseBody.replace(/\n/g, ' ');
                  var parsedBody = JSON.parse(formatBody);
                  // 确保解析出 json 对象
                  if (Object.prototype.toString.call(parsedBody) === '[object Object]') {
                    json = parsedBody;
                  } else {
                    json = responseBody;
                  }
                } catch (e) {
                  json = responseBody;
                }
              } else {
                json = responseBody;
              }
            } else {
              json = responseBody || {};
            }
            return json;
          };
          var util = {
            noop: noop,
            formatParams: formatParams,
            apiWrapper: apiWrapper,
            xml2json: xml2json,
            json2xml: json2xml,
            md5: md5,
            clearKey: clearKey,
            fileSlice: fileSlice,
            getBodyMd5: getBodyMd5,
            getFileMd5: getFileMd5,
            b64: b64,
            extend: extend,
            isArray: isArray,
            isInArray: isInArray,
            makeArray: makeArray,
            each: each,
            map: map,
            filter: filter,
            clone: clone,
            attr: attr,
            uuid: uuid,
            camSafeUrlEncode: camSafeUrlEncode,
            throttleOnProgress: throttleOnProgress,
            getFileSize: getFileSize,
            getSkewTime: getSkewTime,
            error: error,
            obj2str: obj2str,
            getAuth: getAuth,
            parseSelectPayload: parseSelectPayload,
            getSourceParams: getSourceParams,
            isBrowser: true,
            isNode: isNode,
            isCIHost: isCIHost,
            isIOS_QQ: isIOS && isQQ,
            encodeBase64: encodeBase64,
            decodeBase64: decodeBase64,
            simplifyPath: simplifyPath,
            readAsBinaryString: readAsBinaryString,
            parseResBody: parseResBody
          };
          module.exports = util;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__( /*! ./../node_modules/process/browser.js */"./node_modules/process/browser.js"));

        /***/
      }

      /******/ })
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar",
    attrs: {
      "id": "toolbar"
    }
  }, [_c('div', {
    staticClass: "roomBar",
    class: 'typebg' + _vm.styleType
  }, [(_vm.picComment) ? _c('img', {
    staticStyle: {
      "width": "20px",
      "display": "inline-block",
      "margin-left": "10px"
    },
    attrs: {
      "src": __webpack_require__(310)
    },
    on: {
      "click": _vm.picCommentTap
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isshowgift && _vm.Sendflowers == 'true') ? _c('img', {
    staticStyle: {
      "width": "20px",
      "display": "inline-block",
      "margin-left": "10px"
    },
    attrs: {
      "src": __webpack_require__(311)
    },
    on: {
      "click": function($event) {
        return _vm.sendFllowerTap(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isshowgift && _vm.Sendflowers == 'true') ? _c('img', {
    staticStyle: {
      "width": "20px",
      "display": "inline-block",
      "margin-left": "10px"
    },
    attrs: {
      "src": __webpack_require__(312)
    },
    on: {
      "click": function($event) {
        return _vm.sendFllowerTap(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_all_users_muted) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#FFFFFF",
      "padding-bottom": "5px",
      "padding-top": "5px",
      "padding-left": "5px",
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "solid 1px #F5F5F5",
      "border-radius": "10px"
    }
  }, [_vm._v("\n         全员禁言中...\n      ")]) : _c('van-field', {
    staticStyle: {
      "background-color": "#FFFFFF",
      "padding-bottom": "5px",
      "padding-top": "5px",
      "padding-left": "5px",
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "solid 1px #F5F5F5",
      "border-radius": "10px"
    },
    attrs: {
      "placeholder": "说点什么..."
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMsg.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), _c('van-button', {
    staticClass: "senMsgBtn",
    attrs: {
      "disabled": _vm.is_all_users_muted,
      "type": "primary",
      "size": "small"
    },
    on: {
      "touchstart": _vm.sendMsg
    }
  }, [_vm._v("发送")])], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "close-on-click-overlay": false,
      "lock-scroll": false,
      "lazy-render": false
    },
    model: {
      value: (_vm.imgStatus),
      callback: function($$v) {
        _vm.imgStatus = $$v
      },
      expression: "imgStatus"
    }
  }, [_c('div', {
    staticClass: "occupy imgPl"
  }, [_c('div', {
    staticClass: "addimg"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.occupyImg),
      expression: "!occupyImg"
    }]
  }, [_vm._v("添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "selectfiles",
    on: {
      "click": function($event) {
        return _vm.$refs.onkeyupdateBtn.click()
      }
    }
  }, [(_vm.occupyImg) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.occupyImg
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupyText),
      expression: "occupyText"
    }],
    attrs: {
      "cols": "30",
      "rows": "3",
      "maxlength": "60",
      "placeholder": "再说点什么…"
    },
    domProps: {
      "value": (_vm.occupyText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.occupyText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(_vm._s(_vm.occupyText.length))]), _vm._v("/60\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.occupyRefresh
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.uploadAble) ? _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.imgPl
    }
  }, [_vm._v("确定")]) : _c('a', {
    staticClass: "button disabled"
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "iosPosition",
    attrs: {
      "close-on-click-overlay": false,
      "lazy-render": false
    },
    model: {
      value: (_vm.occupyStatus),
      callback: function($$v) {
        _vm.occupyStatus = $$v
      },
      expression: "occupyStatus"
    }
  }, [_c('div', {
    staticClass: "occupy"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("重金霸屏")]), _vm._v(" "), _c('p', [_vm._v("霸评内容：")]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.occupyText),
      expression: "occupyText"
    }],
    attrs: {
      "cols": "30",
      "rows": "3",
      "maxlength": "60",
      "placeholder": "请勿发布广告涉黄等内容，霸屏不支持退款"
    },
    domProps: {
      "value": (_vm.occupyText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.occupyText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(_vm._s(_vm.occupyText.length))]), _vm._v("/60\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "addimg"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "selectfiles",
    attrs: {
      "id": "selectfiles1"
    }
  }, [(_vm.occupyImg) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.occupyImg
    }
  })]) : _c('img', {
    staticClass: "guide",
    attrs: {
      "src": _vm.imgPath + 'home/img.png'
    }
  })])])]), _vm._v(" "), _c('p', [_vm._v("霸屏时间：")]), _vm._v(" "), _c('div', {
    staticClass: "times"
  }, _vm._l((_vm.occupyList), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        cur: _vm.occupyList[_vm.payLevel] == item
      },
      on: {
        "click": function($event) {
          return _vm.choice(index)
        }
      }
    }, [_vm._v(_vm._s(item) + "S")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v("\n          预计支付金额："), _c('span', [_vm._v("￥" + _vm._s(((1 + _vm.payLevel) * 100 * _vm.payPrice) / 100))])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.occupyRefresh
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.uploadAble) ? _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.occupy
    }
  }, [_vm._v("确定")]) : _c('a', {
    staticClass: "button disabled"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_vm._v("\n          温馨提示：请在主办方提供的大屏幕查看您的霸屏内容与效果。\n        ")])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.commentBox),
      callback: function($$v) {
        _vm.commentBox = $$v
      },
      expression: "commentBox"
    }
  }, [_c('textarea', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focusState),
      expression: "focusState"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "textarea",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "placeholder": _vm.placeholder,
      "cols": "30",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "focus": _vm.inputFocus,
      "blur": _vm.inputblur,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMsg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnBox"
  }, [_c('a', {
    staticClass: "btn",
    class: 'type' + _vm.styleType,
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("发送")])])]), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "overflow": "visible",
      "width": "90%"
    },
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.isShowQuickPanel),
      callback: function($$v) {
        _vm.isShowQuickPanel = $$v
      },
      expression: "isShowQuickPanel"
    }
  }, [_c('div', {
    staticClass: "quickArrow"
  }), _vm._v(" "), _c('ul', {
    staticClass: "quickPanel"
  }, _vm._l((_vm.commentList), function(word, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.sendquickMsgAction(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(word.comment))])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgetGift),
      expression: "showgetGift"
    }],
    staticClass: "getGift"
  }, [_c('img', {
    staticClass: "giftImg",
    attrs: {
      "src": _vm.giftMessages.gift_pic_url,
      "alt": _vm.giftMessages.gift_name
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.giftMessages.nick) + " 赠送")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.giftMessages.gift_name))]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v("x " + _vm._s(_vm.giftMessages.gift_num))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "onkeyupdateBtn",
    attrs: {
      "type": "file"
    },
    on: {
      "click": function (e) {
        e.target.value = ''
      },
      "change": function($event) {
        return _vm.getFilef($event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(314);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0d89f574", content, true);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".rightBar[data-v-4b88013c]{position:fixed;bottom:52px;right:10px;width:40px;height:40px;line-height:40px;z-index:1200;text-align:center}.siders[data-v-4b88013c]{transition:height .5s;position:absolute;bottom:40px;left:0;overflow:hidden;min-height:42px}.siders.hideside[data-v-4b88013c]{height:0}.rightBar a[data-v-4b88013c]{display:block;width:40px;height:40px;margin-bottom:6px;border-radius:50%;overflow:hidden}.rightBar a[data-v-4b88013c]:last-child{margin-bottom:0}.rightBar a img[data-v-4b88013c]{width:30px;vertical-align:middle}.rightBar .stretch[data-v-4b88013c]{text-align:center;position:absolute;bottom:0;left:0;transition:.5s}.goldList[data-v-4b88013c]{position:absolute;top:-80px;left:0;width:100%;min-height:50px;z-index:-1}.goldList li[data-v-4b88013c]{position:absolute;top:0;left:0;width:100%;height:50px}.goldList li img[data-v-4b88013c]{position:absolute;left:10px;bottom:0;width:20px;height:20px;opacity:0}.goldList li img.anim1[data-v-4b88013c]{animation:doller1 1s linear}.goldList li img.anim2[data-v-4b88013c]{animation:doller2 2s linear}.goldList li img.anim3[data-v-4b88013c]{animation:doller3 1s linear}.goldList li img.anim4[data-v-4b88013c]{animation:doller4 2s linear}@keyframes doller1{0%{opacity:1}50%{opacity:.5}to{opacity:0;transform:translateY(-190px);margin-left:5px}}@keyframes doller2{0%{opacity:1}40%{opacity:.5}to{opacity:0;transform:translateY(-200px);margin-left:15px}}@keyframes doller3{0%{opacity:1}60%{opacity:.6}to{opacity:0;transform:translateY(-210px);margin-left:-15px}}@keyframes doller4{0%{opacity:1}50%{opacity:.6}to{opacity:0;transform:translateY(-220px);margin-left:-5px}}.glodsound[data-v-4b88013c]{position:absolute;bottom:0;left:0;opacity:1;z-index:5000}.code1[data-v-4b88013c]{background:linear-gradient(#fe9231,#ff7d0a)}.code2[data-v-4b88013c],.home2[data-v-4b88013c],.shang2[data-v-4b88013c],.switch2[data-v-4b88013c],.tel2[data-v-4b88013c],.user2[data-v-4b88013c],.yao2[data-v-4b88013c]{background:linear-gradient(#e9cf80,#dfab33)}.code3[data-v-4b88013c],.home3[data-v-4b88013c],.shang1[data-v-4b88013c],.shang3[data-v-4b88013c],.switch1[data-v-4b88013c],.switch3[data-v-4b88013c],.tel3[data-v-4b88013c],.user1[data-v-4b88013c],.user3[data-v-4b88013c],.yao3[data-v-4b88013c]{background:linear-gradient(#fe3535,red)}.yao1[data-v-4b88013c]{background:linear-gradient(#238bfe,#007aff)}.tel1[data-v-4b88013c]{background:linear-gradient(#93d720,#83c714)}.user4[data-v-4b88013c]{background:linear-gradient(-90deg,#7d2792,#d36993)}.switch4[data-v-4b88013c]{background:linear-gradient(-90deg,#5b35d2,#8d2bd9)}.shang4[data-v-4b88013c],.yao4[data-v-4b88013c]{background:url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/Vertical/yao.png) no-repeat 50%;-webkit-background-size:100%;background-size:100%}.userimg[data-v-4b88013c]{box-sizing:border-box;padding:2px;line-height:34px}.rightBar .userimg img[data-v-4b88013c]{width:100%;border-radius:50%}.closeside[data-v-4b88013c]{background:linear-gradient(45deg,#d3d3d3,#a0a0a0);transform:rotate(135deg)}.codebox[data-v-4b88013c]{line-height:23px;font-size:16px;text-align:center}.codebox p[data-v-4b88013c]{padding:0 20px}.codebox p.title[data-v-4b88013c]{line-height:60px;border-bottom:1px solid #f0f0f0;margin-left:-10px;margin-right:-10px;font-size:20px;color:#313131}.codebox .code[data-v-4b88013c]{width:222px;margin:10px auto 0;display:block}#qrcode[data-v-4b88013c]{padding:10px}.codebox .text[data-v-4b88013c]{color:#909090;font-size:17px;margin-bottom:20px}.codebox .close[data-v-4b88013c]{width:17px;height:17px}.van-popup.codebox[data-v-4b88013c]{border-radius:5px}", ""]);

// exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _rewardRedBag = __webpack_require__(111);

var _rewardRedBag2 = _interopRequireDefault(_rewardRedBag);

var _qrcoder = __webpack_require__(26);

var _qrcoder2 = _interopRequireDefault(_qrcoder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			imgPath: '',
			goldList: [],
			goldListIndex: -1,
			stretchStatus: false,
			delayNum: true,
			qrCodeUrl: "",
			qrCodeStr: "",
			showQR: false,
			isShowQRimg: false,
			followed: true,
			sendredbag: false, //发红包
			ritMenuNum: 2,
			ritNum: 1,
			isShowInvitation: false,
			isShowRedPack: false,
			isShowCall: false,
			iphoneNum: "",
			isShowTimg: false,
			glodsound: '',
			ds_id: '',
			stretchTimer: null
		};
	},

	components: {
		rewardRedBag: _rewardRedBag2.default
	},
	props: ['styleType', 'fans_id', 'headerUrl'],
	mounted: function mounted() {
		this.glodsound = document.getElementById('glodsound');
		this.ds_id = _Tools2.default.getQueryDsId();
		this.imgPath = _Tools2.default.imgPath();
		// this.getHeaderUrl();
		this.getCodeImg();
	},

	methods: {
		getCodeImg: function getCodeImg() {
			var link = _Tools2.default.baseUrl1() + '/live?ds_id=' + this.ds_id + '&sid=' + this.fans_id;
			// var qrcoder = new QRCoder({
			// 	data: link,
			// 	size: 225
			// });
			new QRCode('qrcode', {
				text: link,
				width: 256,
				height: 256,
				colorDark: '#000000',
				colorLight: '#ffffff'
			});
		},
		getHeaderUrl: function getHeaderUrl() {
			// var that = this;
			// var timer = setInterval(function(){
			// 	if(that.headerUrl){
			// 		clearInterval(timer);
			// 	}else{
			// 		var current_app_Id = window.localStorage.getItem("current_app_Id");
			// 		var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
			// 		if(fans&&(typeof fans)!="string"){
			// 			that.headerUrl = fans.header;
			// 		}
			// 	}
			// },500)
		},
		stretch: function stretch() {
			this.stretchStatus = !this.stretchStatus;
			this.delayNum = false;
			if (this.stretchStatus) {
				this.ritNum = 1;
				clearInterval(this.stretchTimer);
			} else {
				this.ritNum = this.ritMenuNum;
			}
		},
		unStretch: function unStretch() {
			var that = this;
			document.body.addEventListener('click', function () {
				if (!that.stretchStatus) {
					that.stretch();
				}
			});
		},
		onToUserInfo: function onToUserInfo() {
			this.$router.push({
				name: 'UserInfo'
			});
		},
		onGotoInvitaion: function onGotoInvitaion() {
			this.$router.push({
				name: 'InviteCard'
			});
		},
		onShangBtnClicked: function onShangBtnClicked() {
			this.sendredbag = true;
		},
		onCloseQRCode: function onCloseQRCode() {
			this.isShowQRimg = !this.isShowQRimg;
			this.delay();
		},
		onTimg: function onTimg() {
			this.isShowTimg = !this.isShowTimg;
		},
		buyProduct: function buyProduct(json) {
			var that = this;
			var arr = parseInt(Math.random() * 3 + 1);
			that.goldList.push(arr);
			setTimeout(function () {
				that.goldList.push(arr);
			}, Math.random() * 400 + 100);
			setTimeout(function () {
				that.goldListIndex += 2;
				console.log(that.goldListIndex);
			}, 6000);
			this.glodsound.play();
		},
		delay: function delay() {
			var that = this;
			if (!this.delayNum) {
				return;
			}
			this.stretchTimer = setTimeout(function () {
				that.stretch();
				that.unStretch();
			}, 5000);
		},
		closeAction: function closeAction() {
			this.sendredbag = false;
		},
		dsFunc: function dsFunc(Obj) {

			if (Obj.wx_follow && this.styleType != 4) {
				//微信关注二维码

				this.qrCodeUrl = Obj.wx_follow.pic_url;
				this.qrCodeStr = Obj.wx_follow.remark;
				this.desc = Obj.wx_follow.wx_withdraw_des;
				if (!_data2.default.isShowQRimg) {
					_data2.default.isShowQRimg = true;
					this.isShowQRimg = true;
				}
				if (Obj.wx_follow.float != 'no') {
					this.showQR = true;
					this.ritMenuNum++;
				}
				if (Obj.wx_follow.wx_isFollow == 'yes') {
					this.followed = false;
					//console.log(tool.getCookie('wx_follow'))
					if (_Tools2.default.getCookie(Obj.wx_follow.wx_nameSec)) {
						this.followed = true;
					}
				}
			} else {
				this.delay();
			}

			if (Obj.mobile && this.styleType != 4) {
				//手机号码
				this.iphoneNum = "tel:" + Obj.mobile.mobile;
				this.isShowCall = true;
				this.ritMenuNum++;
			}

			if (Obj.act_invite) {
				//邀请
				this.isShowInvitation = true;
				this.ritMenuNum++;
			}

			if (Obj.reward && this.styleType != 4) {
				//红包
				this.isShowRedPack = true;
				this.ritMenuNum++;
			}
			this.ritNum = this.ritMenuNum;
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(317);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("c2a2f1e8", content, true);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#redbag[data-v-71c958ab]{margin:-10px;background:#e9251e;padding-bottom:20px;line-height:20px;text-align:left}.m-header[data-v-71c958ab]{background-repeat:no-repeat;background-size:100% 100%;height:55px;line-height:40px}.u-title[data-v-71c958ab]{text-align:center;font-size:17px;color:#ebcb8a}.m-li[data-v-71c958ab]{float:left;width:50%;text-align:center;font-size:15px;color:#fff}.redbag .close[data-v-71c958ab]{width:20px;height:auto;top:10px;right:12px}.u-tab[data-v-71c958ab]{display:inline-block;padding-bottom:6px;color:#d6b87d}.action[data-v-71c958ab]{color:#ffe0a1;border-bottom:4px solid #ffe0a1}.m-bottom[data-v-71c958ab]{width:90%;margin:0 auto}.u-detail[data-v-71c958ab]{padding:0 0 15px 20px;font-size:13px;font-weight:400;font-stretch:normal;color:#fff}.u-input[data-v-71c958ab]{border-radius:4px;background-color:#fff;height:40px;line-height:40px;margin-bottom:15px;display:flex;color:#333}.m-totalmoney[data-v-71c958ab]{margin:0 10px;width:60px;white-space:nowrap}.m-textfiled[data-v-71c958ab]{flex:1;text-align:right;border:none;color:#999;padding:0;height:40px;line-height:40px}.u-unit[data-v-71c958ab]{display:inline-block;padding:0 10px}.text[data-v-71c958ab]{padding:0 10px 0 0;border:none;flex:1;text-align:right;height:40px;line-height:40px}.u-redbtn[data-v-71c958ab]{display:block;width:100%;background:#ebcb8a;border-radius:20px;line-height:40px;color:#e9251e;font-size:15px;border:none}", ""]);

// exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	props: ['fans_id'],
	data: function data() {
		return {
			sendType: 0,
			sumMoney: '',
			message: '',
			redsumMoney: '',
			rednum: '',
			redMessage: '',
			master: true,
			ds_id: '',
			imgPath: ''
		};
	},
	mounted: function mounted() {
		this.ds_id = _Tools2.default.getQueryDsId();
		this.imgPath = _Tools2.default.imgPath();
	},

	methods: {
		tabSelect: function tabSelect(tabsel) {
			if (tabsel == 0) {
				this.sendType = 0;
				this.sumMoney = "";
				this.message = '';
				this.master = true;
			} else {
				this.sendType = 1;
				this.redsumMoney = "";
				this.redMessage = "";
				this.rednum = "";
				this.master = false;
			}
		},
		closeAction: function closeAction() {
			this.redsumMoney = "";
			this.redMessage = "";
			this.rednum = "";
			this.sumMoney = "";
			this.message = '';
			this.$emit('close');
		},
		blurAction: function blurAction() {
			window.scrollTo(0, 0);
		},
		sendRedAction: function sendRedAction() {
			var that = this;
			var url;
			var option;
			if (this.sendType == 1) {
				if (Number(this.redsumMoney) < 1) {
					(0, _toast2.default)('红包金额不能小于1元');
					return;
				}
				if (Number(this.rednum) < 1) {
					(0, _toast2.default)('请输入红包个数');
					return;
				}
				url = _Tools2.default.baseUrl() + "/redPacket/index/randomRedpacket";
				option = 'fans_id=' + this.fans_id + '&ds_id=' + this.ds_id + '&msg=' + this.redMessage + '&nums=' + this.rednum + '&money=' + this.redsumMoney;
			} else {
				//打赏红包
				if (Number(this.sumMoney) < 1) {
					(0, _toast2.default)('红包金额不能小于1元');
					return;
				}
				url = _Tools2.default.baseUrl() + "/redPacket/index/rewardRedpacket";
				option = 'fans_id=' + this.fans_id + '&ds_id=' + this.ds_id + '&msg=' + this.message + '&money=' + this.sumMoney;
			}
			console.log(option);
			this.axios.post(url, option).then(function (res) {
				that.payFunc(res);
			}).catch(function (res) {
				(0, _toast2.default)(res.message);
				that.closeAction();
			});
		},
		payFunc: function payFunc(res) {
			var data = res.data;
			if (data.code == 200) {
				if (typeof WeixinJSBridge == "undefined") {
					if (document.addEventListener) {
						document.addEventListener('WeixinJSBridgeReady', weixinPay, false);
					} else if (document.attachEvent) {
						document.attachEvent('WeixinJSBridgeReady', weixinPay);
						document.attachEvent('onWeixinJSBridgeReady', weixinPay);
					}
				} else {
					this.weixinPay(data.data);
				}
			} else {
				if (data.message) {
					(0, _toast2.default)(data.message);
				}
			}
		},
		weixinPay: function weixinPay(p) {
			var that = this;
			var params = 'appId:' + p.appId + 'timeStamp:' + p.timeStamp + 'nonceStr:' + p.nonceStr + 'package:' + p.package + 'sing:' + p.paySign;
			WeixinJSBridge.invoke('getBrandWCPayRequest', {
				"appId": p.appId, //公众号名称，由商户传入     
				"timeStamp": String(p.timeStamp), //时间戳，自1970年以来的秒数     
				"nonceStr": p.nonceStr, //随机串     
				"package": p.package,
				"signType": "MD5", //微信签名方式：
				"paySign": p.paySign //微信签名 
			}, function (res) {
				// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
				if (res.errMsg == "get_brand_wcpay_request:ok" || res.err_msg == "get_brand_wcpay_request:ok") {
					(0, _toast2.default)('发送红包成功！');
					that.closeAction();
				} else {
					(0, _toast2.default)('支付失败！');
				}
			});
		}
	}
};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redbag",
    attrs: {
      "id": "redbag"
    }
  }, [_c('div', {
    staticClass: "m-header",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/hongbaohead_03.png)')
  }, [_c('p', {
    staticClass: "u-title"
  }, [_vm._v("发红包")]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'redbag/redclose_03.png'
    },
    on: {
      "click": _vm.closeAction
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-bottom"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "m-li",
    on: {
      "click": function($event) {
        return _vm.tabSelect(0)
      }
    }
  }, [_c('a', {
    staticClass: "u-tab",
    class: {
      action: _vm.master
    }
  }, [_vm._v("打赏红包")])]), _vm._v(" "), _c('li', {
    staticClass: "m-li",
    on: {
      "click": function($event) {
        return _vm.tabSelect(1)
      }
    }
  }, [_c('a', {
    staticClass: "u-tab",
    class: {
      action: !_vm.master
    }
  }, [_vm._v("拼手气红包")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.master),
      expression: "master"
    }],
    staticClass: "m-tab1"
  }, [_c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("总金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumMoney),
      expression: "sumMoney"
    }],
    staticClass: "m-textfiled",
    attrs: {
      "type": "number",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.sumMoney)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sumMoney = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-unit"
  }, [_vm._v("元")])]), _vm._v(" "), (_vm.ds_id != 194) ? _c('p', {
    staticClass: "u-detail"
  }, [_vm._v("打赏红包为向主办方打赏")]) : _c('p', {
    staticClass: "u-detail"
  }, [_vm._v("向主演打赏")]), _vm._v(" "), _c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("留言")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "恭喜发财，大吉大利"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.master),
      expression: "!master"
    }],
    staticClass: "m-tab2"
  }, [_c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("总金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redsumMoney),
      expression: "redsumMoney"
    }],
    staticClass: "m-textfiled",
    attrs: {
      "type": "number",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.redsumMoney)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redsumMoney = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-unit"
  }, [_vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "u-detail"
  }, [_vm._v("拼手气红包为向观众打赏")]), _vm._v(" "), _c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("红包个数")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rednum),
      expression: "rednum"
    }],
    staticClass: "m-textfiled",
    attrs: {
      "type": "number",
      "placeholder": "填写个数",
      "max": "50",
      "min": "1"
    },
    domProps: {
      "value": (_vm.rednum)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rednum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-unit"
  }, [_vm._v("个")])]), _vm._v(" "), _c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("留言")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redMessage),
      expression: "redMessage"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "恭喜发财，大吉大利"
    },
    domProps: {
      "value": (_vm.redMessage)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redMessage = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "u-redbtn",
    on: {
      "click": function($event) {
        return _vm.sendRedAction()
      }
    }
  }, [_vm._v("发红包")])])])
},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rightBar"
    }
  }, [_c('div', {
    staticClass: "rightBar"
  }, [_c('div', {
    staticClass: "goldList",
    style: ('top:-' + (34 + parseInt(46 * _vm.ritNum)) + 'px')
  }, _vm._l((_vm.goldList), function(item, index) {
    return (index > _vm.goldListIndex) ? _c('li', _vm._l((item), function(item) {
      return _c('img', {
        class: 'anim' + parseInt(Math.random() * 4 + 1),
        attrs: {
          "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/doller.png"
        }
      })
    }), 0) : _vm._e()
  }), 0), _vm._v(" "), _c('audio', {
    staticClass: "glodsound",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/musics/glod.mp3",
      "id": "glodsound"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "siders",
    style: ('height:' + 46 * (_vm.ritNum - 1) + 'px')
  }, [_c('a', {
    staticClass: "userimg",
    class: 'user' + _vm.styleType,
    on: {
      "click": _vm.onToUserInfo
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.headerUrl
    }
  })]), _vm._v(" "), (_vm.isShowInvitation) ? _c('a', {
    class: 'yao' + _vm.styleType,
    on: {
      "click": _vm.onGotoInvitaion
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/yao.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowRedPack) ? _c('a', {
    class: 'shang' + _vm.styleType,
    on: {
      "click": _vm.onShangBtnClicked
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/shang.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowCall) ? _c('a', {
    class: 'tel' + _vm.styleType,
    attrs: {
      "href": _vm.iphoneNum
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/tel.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showQR) ? _c('a', {
    staticClass: "codeImg",
    class: 'code' + _vm.styleType,
    on: {
      "click": _vm.onCloseQRCode
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/code.png'
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "codeImg",
    class: 'code' + _vm.styleType,
    on: {
      "click": _vm.onTimg
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/timg.png'
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "stretch",
    class: [{
      closeside: !_vm.stretchStatus
    }, 'switch' + _vm.styleType],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stretch.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/switch.png'
    }
  })])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', [(_vm.qrCodeStr) ? _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.qrCodeStr))]) : _c('p', {
    staticClass: "title"
  }, [_vm._v("长按关注公众号")]), _vm._v(" "), _c('img', {
    staticClass: "code stop",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("关注二维码，了解更多信息")])]), _vm._v(" "), (_vm.followed) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'code-close.png'
    },
    on: {
      "click": _vm.onCloseQRCode
    }
  }) : _vm._e()]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "lazy-render": false
    },
    model: {
      value: (_vm.isShowTimg),
      callback: function($$v) {
        _vm.isShowTimg = $$v
      },
      expression: "isShowTimg"
    }
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("小程序观看直播")]), _vm._v(" "), _c('div', {
    staticClass: "code stop",
    attrs: {
      "id": "qrcode"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("小程序观看直播，更快更流畅")])]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'code-close.png'
    },
    on: {
      "click": _vm.onTimg
    }
  })]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "lazy-render": false
    },
    model: {
      value: (_vm.sendredbag),
      callback: function($$v) {
        _vm.sendredbag = $$v
      },
      expression: "sendredbag"
    }
  }, [_c('rewardRedBag', {
    attrs: {
      "fans_id": _vm.fans_id
    },
    on: {
      "close": _vm.closeAction
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(322);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("daaf71ee", content, true);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".leftBox[data-v-f7bdc892]{position:fixed;bottom:52px;left:10px;width:50px;z-index:1200}.leftBox a[data-v-f7bdc892]{display:block;width:50px;height:50px;border-radius:50%;margin-top:6px;font-size:10px;color:#fff;position:relative;text-align:center}.leftBox .income[data-v-f7bdc892],.leftBox .orders[data-v-f7bdc892]{width:56px;height:56px;line-height:20px;border:2px solid #fff;box-shadow:1px 1px 10px #999}.leftBox .income[data-v-f7bdc892]{background:linear-gradient(#fe5945,#e63232)}.leftBox .orders[data-v-f7bdc892]{background:linear-gradient(#5494fe,#4277fb)}.leftBox a[data-v-f7bdc892]:first-child{margin-top:0}.leftBox .fullimg[data-v-f7bdc892]{width:100%;vertical-align:middle}.leftBox .ltimg[data-v-f7bdc892]{width:20px;vertical-align:middle;margin-top:8px}.leftBox .time[data-v-f7bdc892]{position:absolute;bottom:0;left:50%;transform:translateX(-50%);min-width:100%;height:10px;line-height:10px;font-size:10px;background:#ffe42d;color:#ff4022;border-radius:6px;padding:1px 0;text-align:center}", ""]);

// exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _turntable = __webpack_require__(324);

var _turntable2 = _interopRequireDefault(_turntable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	data: function data() {
		return {
			imgPath: '',
			showTable: false,
			TactiveState: -1,
			Ttimer: '',
			Thours: '',
			Tminites: '',
			Tseconds: ''
		};
	},

	components: {
		turntable: _turntable2.default
	},
	props: ['curCid', 'showBigTable', 'voteList', 'isPlay', 'fans_id'],
	mounted: function mounted() {
		this.imgPath = _Tools2.default.imgPath();
	},

	methods: {
		swichTable: function swichTable() {
			this.showTable = !this.showTable;
		},
		timeSwitch: function timeSwitch(S, E) {
			var now = new Date().getTime();
			var start = new Date(S.replace(/-/g, "/")).getTime();
			var end = new Date(E.replace(/-/g, "/")).getTime();
			//console.log(now+'--'+start+'--'+end)
			if (now < start) {
				this.TactiveState = -1;
				this.countDown(parseInt((start - now) / 1000));
				console.log('未开始');
			} else if (now > end) {
				this.TactiveState = 1;
				console.log('已结束');
			} else {
				this.TactiveState = 0;
				this.countDown(parseInt((end - now) / 1000));
				console.log('正在进行');
			}
		},
		countDown: function countDown(times) {
			clearInterval(this.Ttimer);
			var that = this;
			this.Ttimer = setInterval(function () {
				if (times != 0) {
					times--;
					that.Thours = _Tools2.default.two(Math.floor(times / 3600));
					that.Tminites = _Tools2.default.two(Math.floor(times % 3600 / 60));
					that.Tseconds = _Tools2.default.two(Math.floor(times % 60));
				} else {
					clearInterval(that.Ttimer);
					that.timeSwitch();
				}
			}, 1000);
		},
		getStatus: function getStatus(status) {
			this.$refs.turntable.getStatus(status);
		}
	}
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(328),
  /* scopeId */
  "data-v-4032375c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(326);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("75cf3598", content, true);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#shake[data-v-4032375c]{height:100%;background:#f93d3e}.shakebox[data-v-4032375c]{height:100%;overflow:scroll}.center[data-v-4032375c]{text-align:center}img[data-v-4032375c]{max-width:100%}.prize[data-v-4032375c]{min-height:50%;position:relative;padding-bottom:60px}.introduce[data-v-4032375c],.prize[data-v-4032375c]{width:100%;overflow:hidden}.prizes[data-v-4032375c]{position:absolute;height:65px;text-align:center;line-height:16px;width:65px;border-radius:50%;background:rgba(0,0,0,.3);top:10px;left:20px;animation:swing 2s ease-in-out infinite;font-size:12px;color:#fff}.prizes img[data-v-4032375c]{width:70%;margin-top:5px}@keyframes swing{0%{transform:rotate(10deg)}50%{transform:rotate(-10deg)}to{transform:rotate(10deg)}}.tableBox[data-v-4032375c]{width:280px;padding-bottom:280px;max-width:300px;position:relative;margin:30px auto 110px}.tableBox .rotate[data-v-4032375c],.tableBox .tableImg[data-v-4032375c]{position:absolute;width:100%;height:100%;top:0;left:0}.tableBox .tableImg[data-v-4032375c]{padding:15px;box-sizing:border-box;transition:4s}.tableBox .rotate[data-v-4032375c]{animation:circle 4s linear infinite;box-shadow:0 0 5px 5px rgba(160,0,0,.2);border-radius:50%;overflow:hidden}@keyframes circle{0%{transform:rotate(0deg)}50%{transform:rotate(180deg)}to{transform:rotate(1turn)}}.arrow[data-v-4032375c]{position:absolute;top:50%;left:50%;margin-top:-52px;margin-left:-31px;width:62px}.luck[data-v-4032375c]{position:absolute;bottom:-110px;left:50%;width:360px;margin-left:-180px}.main[data-v-4032375c]{background-repeat:no-repeat;background-position:top;background-size:100%}.main h4[data-v-4032375c]{font-size:18px;color:#fff;font-weight:700;line-height:40px}.main p[data-v-4032375c]{background:#fda513;width:200px;height:30px;line-height:30px;overflow:hidden;border-radius:15px;margin:0 auto;color:#fff}.timebox[data-v-4032375c]{position:relative;height:0;width:100%;z-index:100}.time[data-v-4032375c]{width:80%;position:absolute;bottom:-30px;left:50%;margin-left:-40%;background:#fff;border-radius:3px;padding:20px 5px;text-align:center;line-height:20px;box-sizing:border-box}.time span[data-v-4032375c]{display:inline-block;background:#f93d3e;color:#fff;padding:0 3px;border-radius:2px;margin:0 2px}.introduce[data-v-4032375c]{background-repeat:no-repeat;background-position:bottom;-webkit-background-size:100%;min-height:50%;box-sizing:border-box;padding-top:30px;background-size:100%;line-height:26px;color:#9c9c9c;position:relative;padding-bottom:80px}.introduce .box[data-v-4032375c]{width:90%;border:4px dotted #f3f91f;border-radius:3px;margin:24px auto 0;box-sizing:border-box;padding:15px;background:#eb6861}.introduce .title[data-v-4032375c]{background-repeat:no-repeat;background-position:50%;-webkit-background-size:100% auto;background-size:100% auto;line-height:36px;text-align:center;color:#f3f91f;font-size:16px;font-weight:700}.introduce p[data-v-4032375c]{color:#fff}.copyright[data-v-4032375c]{position:absolute;width:100%;bottom:0;text-align:center;color:#f93d3e}.prizeImg[data-v-4032375c]{max-width:80%;margin:10px 0}.poup[data-v-4032375c]{background:#fff;border-radius:10px;margin:-10px;overflow:hidden}.poup .title[data-v-4032375c]{height:52px;line-height:52px;background:#ff601a;color:#fff;font-size:17px;position:relative}.poup .title span[data-v-4032375c]{height:20px;width:20px;position:absolute;transform:rotate(45deg);top:16px;right:20px}.poup .title span[data-v-4032375c]:after{content:\"\";height:2px;width:20px;background:#fff;position:absolute;left:0;top:9px}.poup .title span[data-v-4032375c]:before{content:\"\";height:20px;width:2px;background:#fff;position:absolute;top:0;left:9px}.poup p[data-v-4032375c]{margin-bottom:36px;font-size:17px}.turnMusic[data-v-4032375c]{position:absolute;top:0;left:0;z-index:10000}", ""]);

// exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

__webpack_require__(7);

__webpack_require__(21);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _prizes = __webpack_require__(54);

var _prizes2 = _interopRequireDefault(_prizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_popup2.default);

exports.default = {
  components: {
    prizes: _prizes2.default
  },
  data: function data() {
    return {
      aid: "1",
      ds_id: "",
      days: "00",
      hours: "00",
      minites: "00",
      seconds: "00",
      end: false,
      show: false,
      show2: false,
      prizeImg: "",
      start_time: "",
      end_time: "",
      running: false,
      degNum: -90,
      imgList: [],
      imgIndex: 0,
      basicDeg: 0,
      eqIndex: 0,
      interval: 0,
      remark: "",
      prize_remark: "",
      activeState: -1,
      prizelist: [],
      page: 1,
      act_type: "fixed",
      remain: 0,
      hours2: "00",
      minites2: "00",
      seconds2: "00",
      allow: false,
      tableImg: "",
      isWeixin: true,
      loaded: false,
      text: "您的抽奖次数已达上限",
      imgPath: "",
      turnMusic: null,
      timer1: null,
      timer2: null
    };
  },

  props: ["fansId", "showTable"],
  watch: {
    showTable: function showTable() {
      if (!this.loaded) {
        _toast2.default.loading({
          mask: true,
          message: "加载中..."
        });

        this.getData();
      }
    }
  },
  mounted: function mounted() {
    this.imgPath = _Tools2.default.imgPath();
    this.isWeixin = _Tools2.default.isWeixin();
    this.ds_id = _Tools2.default.getQueryDsId();
    this.turnMusic = document.getElementById("turnMusic");
  },

  methods: {
    getData: function getData() {
      var that = this;
      var option = "fans_id=" + this.fansId + "&ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl() + "/activity/bigTurnTable/index", option).then(function (res) {
        _toast2.default.clear();
        var data = res.data;
        console.log(data);
        if (data.code == 200) {
          that.loaded = true;
          that.tableImg = data.data.svg;
          that.start_time = data.data.start_time;
          that.end_time = data.data.end_time;
          that.getActiveState(data.data.status);
          that.remark = data.data.remark;
          if (that.remark) {
            that.remark = that.remark.replace(/\n/g, "<br/>");
          }
          that.aid = data.data.aid;
          that.prize_remark = data.data.prize_remark;
          that.act_type = data.data.act_type;
          that.remain = data.data.remain;
          that.interval = data.data.second;
          that.imgList = data.data.prize_list;
          that.imgIndex = that.imgList.length;
          that.basicDeg = parseInt(3600 / that.imgIndex) / 10;
          that.degNum -= that.basicDeg / 2;
          that.timeSwitch();
        } else {
          console.log(data.message);
        }
      }).catch(function () {
        //console.log('错误333');
      });
    },
    getActiveState: function getActiveState(status) {
      if (status == "not_started") {
        this.activeState = -1;
      } else if (status == "running") {
        this.activeState = 0;
      } else {
        this.activeState = 1;
      }
    },
    prize: function prize() {
      var that = this;
      if (!this.isWeixin) {
        (0, _toast2.default)("请微信登陆后重试");
        return;
      }
      if (this.activeState == -1) {
        (0, _toast2.default)("活动还未开始");
        return false;
      }
      if (this.activeState == 1) {
        (0, _toast2.default)("活动已结束");
        return false;
      }
      if (this.act_type != "fixed") {
        if (!this.allow) {
          return false;
        }
      } else {
        if (this.remain <= 0) {
          (0, _toast2.default)("您的抽奖次数已达上限");
          return false;
        }
      }
      if (this.running) {
        return false;
      }
      this.running = true;
      that.turnMusic.play();
      var that = this;
      var option = "aid=" + this.aid + "&fans_id=" + this.fansId + "&ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl() + "/activity/bigTurnTable/win", option).then(function (res) {
        var data = res.data;
        that.running = false;
        if (data.code == "200") {
          if (that.act_type != "fixed") {
            that.allow = false;
            that.countDown2(that.interval);
          } else {
            that.remain--;
          }
          for (var index in that.imgList) {
            if (that.imgList[index].id == data.data.prize.id) {
              that.degNum = that.degNum - 360 * 6 - (parseInt(index) + that.imgIndex - that.eqIndex) * that.basicDeg;
              that.eqIndex = index;
              break;
            }
          }
          that.prizeImg = data.data.prize.pic_url;
          setTimeout(function () {
            if (that.prizeImg) {
              that.show2 = true;
            }
          }, 4000);
        } else {
          (0, _toast2.default)(data.message);
          if (data.message == "中奖次数已经达到上限") {
            that.remain = 0;
            that.text = data.message;
          }
        }
      }).catch(function () {
        setTimeout(function () {
          that.running = false;
        }, 1000);
        (0, _toast2.default)("请求错误");
      });
    },
    timeSwitch: function timeSwitch() {
      var now = new Date().getTime();
      var start = new Date(this.start_time.replace(/-/g, "/")).getTime();
      var end = new Date(this.end_time.replace(/-/g, "/")).getTime();
      //console.log(now+'--'+start+'--'+end)
      if (this.activeState == -1) {
        this.countDown(parseInt((start - now) / 1000));
        //console.log('未开始');
      } else if (this.activeState == 1) {
        //console.log('已结束');
      } else {
        if (end - now < 0) {
          this.activeState = 1;
        } else {
          this.countDown(parseInt((end - now) / 1000));
          if (this.act_type == "freq") {
            if (this.remain == 0) {
              this.allow = true;
            } else {
              this.countDown2(this.remain);
            }
          }
        }
        //console.log('正在进行');
      }
    },
    countDown: function countDown(times) {
      clearInterval(this.timer1);
      var that = this;
      console.log(times);
      this.timer1 = setInterval(function () {
        console.log(times);
        if (times != 0) {
          times--;
          that.days = _Tools2.default.two(Math.floor(times / 24 / 3600));
          that.hours = _Tools2.default.two(Math.floor(times % (24 * 3600) / 3600));
          that.minites = _Tools2.default.two(Math.floor(times % 3600 / 60));
          that.seconds = _Tools2.default.two(Math.floor(times % 60));
        } else {
          clearInterval(that.timer1);
          that.timeSwitch();
        }
      }, 1000);
    },
    countDown2: function countDown2(time) {
      clearInterval(this.timer2);
      var that = this;
      var times = time;
      this.timer2 = setInterval(function () {
        if (times != 0) {
          times--;
          that.hours2 = _Tools2.default.two(Math.floor(times % (24 * 3600) / 3600));
          that.minites2 = _Tools2.default.two(Math.floor(times % 3600 / 60));
          that.seconds2 = _Tools2.default.two(Math.floor(times % 60));
        } else {
          clearInterval(that.timer2);
          that.allow = true;
        }
      }, 1000);
    },
    showPrizs: function showPrizs() {
      var that = this;
      this.show = true;
      var option = "aid=" + this.aid + "&fans_id=" + this.fansId + "&type=1" + "&page=" + this.page;
      //var option = 'fans_id=6';
      this.axios.post(_Tools2.default.baseUrl() + "/activity/bigTurnTable/lists", option).then(function (data) {
        if (data.data.code == "200") {
          that.prizelist = data.data.data.list;
          //console.log('正确11');
        } else {
            //console.log('错误22');
          }
      }).catch(function () {
        //console.log('错误33');
      });
    },
    cutdown: function cutdown() {
      this.show2 = false;
      this.prizeImg = "";
    },
    closeList: function closeList() {
      this.show = false;
    },
    getStatus: function getStatus(status) {
      this.activeState = status;
      this.timeSwitch();
    }
  }
};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "shake"
    }
  }, [_c('div', {
    staticClass: "shakebox"
  }, [_c('div', {
    staticClass: "prize"
  }, [_c('div', {
    staticClass: "main",
    style: ('background-image:url(' + _vm.imgPath + 'turntable/turntable1.png)')
  }, [_c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'turntable/turntable2.png'
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.tableImg),
      expression: "tableImg"
    }],
    staticClass: "tableImg",
    style: ('transform:rotate(' + _vm.degNum + 'deg)')
  }, [_vm._v(_vm._s(_vm.tableImg))]), _vm._v(" "), _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.prize
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'turntable/turntable3.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "luck"
  }, [_c('img', {
    staticClass: "stop",
    attrs: {
      "src": _vm.imgPath + 'turntable/turntable4.png'
    }
  })])]), _vm._v(" "), (_vm.activeState != 1) ? [(_vm.act_type == 'fixed') ? _c('p', {
    staticClass: "center"
  }, [(_vm.remain != 0) ? _c('span', [_vm._v("您还有" + _vm._s(_vm.remain) + "次机会")]) : _c('span', [_vm._v(_vm._s(_vm.text))])]) : _c('p', {
    staticClass: "center"
  }, [(_vm.allow) ? _c('span', [_vm._v("点击开始抽奖")]) : _c('span', [_vm._v("\n              下一次抽奖：\n              "), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.hours2) + ":" + _vm._s(_vm.minites2) + ":" + _vm._s(_vm.seconds2))])])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "prizes",
    on: {
      "click": function($event) {
        return _vm.showPrizs()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/prizes.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的奖品")])])]), _vm._v(" "), _c('div', {
    staticClass: "timebox"
  }, [(_vm.activeState == -1) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n        活动开始倒计时：\n        "), _c('span', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v("天\n        "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v("时\n        "), _c('span', {
    staticClass: "minute"
  }, [_vm._v(_vm._s(_vm.minites))]), _vm._v("分\n        "), _c('span', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v("秒\n      ")]) : _vm._e(), _vm._v(" "), (_vm.activeState == 0) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("\n        活动结束倒计时：\n        "), _c('span', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v("天\n        "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v("时\n        "), _c('span', {
    staticClass: "minute"
  }, [_vm._v(_vm._s(_vm.minites))]), _vm._v("分\n        "), _c('span', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v("秒\n      ")]) : _vm._e(), _vm._v(" "), (_vm.activeState == 1) ? _c('div', {
    staticClass: "time"
  }, [_vm._v("~~~~~~~活动已结束~~~~~~~")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "introduce",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/bg4.png)')
  }, [_c('div', {
    staticClass: "rules box"
  }, [_c('div', {
    staticClass: "title",
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/title-bg.png)')
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.remark),
      expression: "remark"
    }]
  }, [_vm._v(_vm._s(_vm.remark))])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("- 由美时美客提供技术支持 -")])])]), _vm._v(" "), _c('audio', {
    staticClass: "turnMusic",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/musics/bigTurn.mp3",
      "id": "turnMusic",
      "preload": ""
    }
  }), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('prizes', {
    attrs: {
      "prizelist": _vm.prizelist,
      "prizeRemark": _vm.prize_remark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.closeList
    }
  })])], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  }, [_c('div', {
    staticClass: "poup center"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    on: {
      "click": _vm.cutdown
    }
  }), _vm._v("中奖信息\n      ")]), _vm._v(" "), (_vm.prizeImg) ? _c('img', {
    staticClass: "prizeImg",
    attrs: {
      "src": _vm.prizeImg
    }
  }) : _c('img', {
    staticClass: "prizeImg",
    attrs: {
      "src": _vm.imgPath + 'nothing.jpg'
    }
  }), _vm._v(" "), (_vm.prizeImg) ? _c('p', [_vm._v("恭喜您，中奖了！！！")]) : _c('p', [_vm._v("此处空空如也，请再接再厉……")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftBar",
    attrs: {
      "id": "leftBar"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCid == 1),
      expression: "curCid == 1"
    }],
    staticClass: "leftBox"
  }, [(_vm.showBigTable) ? _c('a', {
    staticClass: "bigTable",
    on: {
      "click": _vm.swichTable
    }
  }, [_c('img', {
    staticClass: "fullimg",
    attrs: {
      "src": _vm.imgPath + 'home/bigTrun.png'
    }
  }), _vm._v(" "), (_vm.TactiveState != 1) ? _c('div', {
    staticClass: "time"
  }, [_c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.Thours))]), _vm._v(":"), _c('span', {
    staticClass: "minute"
  }, [_vm._v(_vm._s(_vm.Tminites))]), _vm._v(":"), _c('span', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.Tseconds))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.voteList) ? _c('a', {
    attrs: {
      "href": 'http://ph.shikee.tv/vote?vid=' + _vm.voteList[0].vid
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/vote.png'
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCid == 9),
      expression: "curCid == 9"
    }],
    staticClass: "leftBox"
  }, [_c('a', {
    staticClass: "income",
    attrs: {
      "href": "http://ph.shikee.tv/store/#/Distribution"
    }
  }, [_c('img', {
    staticClass: "ltimg",
    attrs: {
      "src": _vm.imgPath + 'user/sales2.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的收益")])]), _vm._v(" "), _c('a', {
    staticClass: "orders",
    attrs: {
      "href": "http://ph.shikee.tv/store/#/orders"
    }
  }, [_c('img', {
    staticClass: "ltimg",
    attrs: {
      "src": _vm.imgPath + 'user/orders2.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的订单")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTable),
      expression: "showTable"
    }],
    staticClass: "fullBox"
  }, [(_vm.fans_id) ? _c('turntable', {
    ref: "turntable",
    attrs: {
      "fansId": _vm.fans_id,
      "showTable": _vm.showTable
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlay) ? _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.swichTable
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'close.png'
    }
  })]) : _c('div', {
    staticClass: "close",
    staticStyle: {
      "top": "60px"
    },
    on: {
      "click": _vm.swichTable
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'close.png'
    }
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  "data-v-5fa2d77a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(332);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("11e61682", content, true);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".topAD[data-v-5fa2d77a]{height:24px;line-height:24px;padding:7px;overflow:hidden;background:#1c2744;color:#ed2203}.topAD img[data-v-5fa2d77a]{height:24px}.topAD a[data-v-5fa2d77a]{display:block;border:1px solid #eb2203;border-radius:12px;height:22px;line-height:22px;font-size:12px;padding:0 12px;margin-right:10px}", ""]);

// exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {
	data: function data() {
		return {
			imgPath: ''
		};
	},

	props: ['topObj'],
	mounted: function mounted() {
		this.imgPath = _Tools2.default.imgPath();
	},

	methods: {
		closeAD: function closeAD() {
			this.$emit('closeAD');
		}
	}
};

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topAD",
    attrs: {
      "id": "topAD"
    }
  }, [_c('img', {
    staticClass: "fr",
    attrs: {
      "src": _vm.imgPath + 'close_b.png'
    },
    on: {
      "click": _vm.closeAD
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fr",
    style: ('color:' + _vm.topObj.btn_clor + ';border-color:' + _vm.topObj.btn_clor),
    attrs: {
      "href": _vm.topObj.jump_url
    }
  }, [_vm._v(_vm._s(_vm.topObj.btn_text))]), _vm._v(" "), (_vm.topObj.pic_url) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.topObj.pic_url
    }
  }) : _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/logo/logo_red1024x388.png"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(336);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6f5857e2", content, true);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".progress{position:absolute;top:0;left:0;width:100%;background-color:#4a4a4a;height:56vw;z-index:99}.progress .progressbg{background-color:#eee}.progress .progressbg,.progress .progressfg{position:absolute;width:200px;top:50%;left:50%;margin-left:-100px;height:10px;margin-top:-10px;border-radius:5px}.progress .progressfg{animation:progressfgAnim 5s;animation-iteration-count:infinite}.progress .progressimgbg{position:absolute;width:100px;top:50%;left:50%;margin-left:-100px;height:10px;margin-top:-10px}.progress .progressimgbg .progressimg{animation:progressimgAnim 5s;animation-iteration-count:infinite;position:absolute;width:31px;top:50%;left:100%;margin-left:-15px;height:33px;margin-top:-19px}.progress .progressText{position:absolute;width:100%;top:50%;height:20px;text-align:center;margin-top:30px;color:#fff;font-size:18px}.progress .progressText .progressTextdot{white-space:nowrap;overflow:hidden;animation:progressTextdotAnim 3s;animation-iteration-count:infinite;display:inline-block}@keyframes progressfgAnim{0%{width:0}to{width:200px}}@keyframes progressimgAnim{0%{left:0}to{left:200px}}@keyframes progressTextdotAnim{0%{width:0}20%{width:5px}40%{width:9px}60%{width:10px}80%{width:15px}to{width:20px}}", ""]);

// exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	data: function data() {
		return {
			imgPath: ''
		};
	},

	props: ['playHeight'],
	mounted: function mounted() {
		this.imgPath = _Tools2.default.imgPath();
	},

	methods: {}
};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress",
    style: ('margin-top:' + _vm.playHeight + 'px'),
    attrs: {
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "progressbg"
  }), _vm._v(" "), _c('div', {
    staticClass: "progressfg",
    style: ('background-image:url(' + _vm.imgPath + 'home/loadingbg.png)')
  }), _vm._v(" "), _c('div', {
    staticClass: "progressimgbg"
  }, [_c('img', {
    staticClass: "progressimg",
    attrs: {
      "src": _vm.imgPath + 'home/loadingImg.png'
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "progressText"
  }, [_vm._v("\n\t\tloading"), _c('span', {
    staticClass: "progressTextdot"
  }, [_vm._v(".....")])])
}]}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(340);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0b9d1303", content, true);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".piecewise[data-v-4b0693c6]{height:40px;line-height:30px;overflow-x:scroll;position:absolute;top:56vw;left:0;background:#fff;width:100%;box-sizing:border-box;-webkit-overflow-scrolling:touch;overflow-scrolling:touch}.piecewise ul[data-v-4b0693c6]{height:40px;overflow:hidden}.piecewise li[data-v-4b0693c6]{width:92px;padding:4px;float:left;height:32px;overflow:hidden;position:relative}.piecewise li[data-v-4b0693c6]:after{content:\"\";display:block;position:absolute;top:8px;left:0;width:1px;height:24px;background:#d4d4d4}.piecewise li a[data-v-4b0693c6]{display:block;text-align:center;border-radius:5px;height:32px;overflow:hidden}.piecewise li.active[data-v-4b0693c6]{background:#1483ff}.piecewise2 li.active[data-v-4b0693c6]{background:#e5bc4b}.piecewise3 li.active[data-v-4b0693c6]{background:#ec1a1a}.piecewise li.active+li[data-v-4b0693c6]:after,.piecewise li.active[data-v-4b0693c6]:after,.piecewise li[data-v-4b0693c6]:first-child:after{display:none}.piecewise li.active a[data-v-4b0693c6]{color:#fff}.piecewise li.mini a[data-v-4b0693c6]{line-height:16px;font-size:11px}", ""]);

// exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	props: ['playHeight', 'breakPoint', 'styleType', 'videoIndex', 'dsId'],
	data: function data() {
		return {
			loaded: false,
			disabled: false,
			page_nums: 20,
			page: 2,
			breakPoints: []
		};
	},
	created: function created() {},
	mounted: function mounted() {
		this.breakPoints = this.breakPoints.concat(this.breakPoint);
	},

	methods: {
		switchVideo: function switchVideo(item, index) {
			this.$emit('switchVideo', item, index);
		}
	}
};

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "piecewise"
    }
  }, [_c('div', {
    ref: "viewoutBox",
    staticClass: "piecewise",
    style: ('margin-top:' + _vm.playHeight + 'px'),
    attrs: {
      "id": "piecewise"
    }
  }, [_c('ul', {
    ref: "innerBox",
    staticClass: "clearfix",
    class: 'piecewise' + _vm.styleType,
    style: ('width:' + _vm.breakPoints.length * 100 + 'px')
  }, _vm._l((_vm.breakPoints), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: (index == _vm.videoIndex),
        mini: (item.title.length > 6)
      }
    }, [(item.title.length > 6 && item.title.length <= 10) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.switchVideo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title.substr(0, 5))), _c('br'), _vm._v(_vm._s(item.title.substr(5)))]) : (item.title.length > 10) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.switchVideo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title.substr(0, 7))), _c('br'), _vm._v(_vm._s(item.title.substr(7)))]) : _c('a', {
      on: {
        "click": function($event) {
          return _vm.switchVideo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(347),
  /* scopeId */
  "data-v-28d64522",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(345);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("dca6c24e", content, true);

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".buyList[data-v-28d64522]{position:absolute;top:50%;left:0;width:90%;height:100px;margin-top:100px;margin-left:5%;height:0;z-index:1900}.buyList li[data-v-28d64522]{line-height:40px;animation:tohide 4s linear;opacity:0;position:absolute;bottom:0;left:0;text-align:center;width:100%}.buyList img[data-v-28d64522]{height:28px;vertical-align:middle;display:inline-block}.buyList span[data-v-28d64522]:first-child{font-size:22px;color:#ff4040;position:relative;font-weight:700;z-index:0;display:inline-block;vertical-align:middle}.buyList span[data-v-28d64522]:nth-child(2){display:inline-block;font-size:0;vertical-align:middle}.buyList span[data-v-28d64522]:before{content:attr(data-text);display:block;position:absolute;-webkit-text-stroke:4px #282828;z-index:-1}@keyframes tohide{0%{opacity:1}50%{opacity:.8}to{opacity:0;transform:translateY(-40px)}}", ""]);

// exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	props: ['buyList', 'buyListIndex']
};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "buyList"
  }, _vm._l((_vm.buyList), function(item, index) {
    return (index > _vm.buyListIndex) ? _c('li', {
      key: index
    }, [_c('span', {
      attrs: {
        "data-text": item.nick
      }
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/buy.png'
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/' + item.shop_num.toString().substr(0, 1) + '.png'
      }
    }), _vm._v(" "), (item.shop_num > 9) ? _c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/' + item.shop_num.toString().substr(1, 1) + '.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.imgPath + 'sales/Piece.png'
      }
    })])]) : _vm._e()
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  "data-v-fb47e720",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(350);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("75c0853c", content, true);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".rainImg[data-v-fb47e720]{position:fixed;display:block;z-index:2000;top:-100px;animation:rain 5s ease-in}@keyframes rain{0%{top:-100px}to{top:120%}}#redrainfails[data-v-fb47e720]{text-align:center;font-size:16px;color:#666;padding:10px 0}#redrainfails img[data-v-fb47e720]{width:100px}#redrainSuccess[data-v-fb47e720]{margin:-10px;background:#fff;text-align:center}#redrainSuccess .title[data-v-fb47e720]{background-color:#e9251e;padding:15px;color:#fff}#redrainSuccess .money[data-v-fb47e720]{padding:28px;font-family:Impact;font-size:29px;color:#393939}#redrainSuccess .mannum[data-v-fb47e720]{color:#696969;padding-bottom:30px}#redrainSuccess .mannum span[data-v-fb47e720]{color:#e9251e}", ""]);

// exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	data: function data() {
		return {
			imgPath: '',
			rainlist: [],
			rainIndex: -20,
			redrain1: false,
			redrain2: false,
			rainmoney: 0,
			mannum: 0
		};
	},

	props: ['rainProbab', 'rainId', 'fans_id'],
	mounted: function mounted() {
		this.imgPath = _Tools2.default.imgPath();
	},

	methods: {
		redbagRain: function redbagRain(json) {
			//下红包雨
			var that = this;
			console.log('rainProbab' + this.rainProbab + 'rainId' + this.rainId);
			if (json) {
				if (json.module == "red_rain_close") {
					clearInterval(this.timer3);
					return false;
				}
			}

			function add() {
				var width = parseInt(Math.random() * 40 + 20);
				var Left = parseInt(Math.random() * 60 + 10);
				var rot = parseInt(Math.random() * 90 - 45) + "deg";
				var style = {
					"left": Left + '%',
					"width": width + 'px',
					"transform": "rotate(" + rot + ")"
				};
				that.rainlist.push(style);
				setTimeout(function () {
					that.rainIndex++;
				}, 15000);
			};
			this.timer3 = setInterval(add, 500);
		},
		getRainRed: function getRainRed() {
			var that = this;
			var Base64 = __webpack_require__(34).Base64;
			if (100 * Math.random() <= Number(this.rainProbab)) {

				this.axios.post(_Tools2.default.baseUrl3() + "/redrain/index", 'fans_id=' + this.fans_id + '&msg_id=' + this.rainId).then(function (data) {
					var data = data.data;
					console.log("抢到的红包数据:" + JSON.stringify(data));
					if (data.code == 200) {
						if (data.data.amount == 0 || data.data.amount == '0') {
							that.redrain1OO();
						} else {
							that.redrain2OO();
							that.rainmoney = data.data.amount;
							that.mannum = data.data.count;
						}
					}
				}).catch(function (data) {
					console.log(data);
				});
			} else {
				that.redrain1OO();
			}
		},
		redrain1OO: function redrain1OO() {
			this.redrain1 = !this.redrain1;
		},
		redrain2OO: function redrain2OO() {
			this.redrain2 = !this.redrain2;
		}
	}
};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "redRain"
    }
  }, [_vm._l((_vm.rainlist), function(n, index) {
    return _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > _vm.rainIndex),
        expression: "index > rainIndex"
      }],
      key: index,
      staticClass: "rainImg",
      style: (n),
      attrs: {
        "src": _vm.imgPath + 'home/redbagrain.png'
      },
      on: {
        "click": _vm.getRainRed
      }
    })
  }), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.redrain1),
      callback: function($$v) {
        _vm.redrain1 = $$v
      },
      expression: "redrain1"
    }
  }, [_c('div', {
    attrs: {
      "id": "redrainfails"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/redrainno.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("空空如也，再接再厉")])]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.redrain1OO
    }
  })]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.redrain2),
      callback: function($$v) {
        _vm.redrain2 = $$v
      },
      expression: "redrain2"
    }
  }, [_c('div', {
    attrs: {
      "id": "redrainSuccess"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("恭喜您，成功抢到")]), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.rainmoney / 100)), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "mannum"
  }, [_c('span', [_vm._v(_vm._s(_vm.mannum))]), _vm._v("人已抢到。")]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.redrain2OO
    }
  })])])], 2)
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  "data-v-0930e935",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(355);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("22da9fe0", content, true);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".wallet[data-v-0930e935]{position:absolute;left:0;top:41vw;z-index:1260}.wallet img[data-v-0930e935]{width:52px;animation:tobig 1s linear infinite}@keyframes tobig{0{transform:scale(1)}50%{transform:scale(1.1)}to{transform:scale(1)}}.sales[data-v-0930e935]{width:100%;height:100%;position:fixed;top:0;left:0;z-index:4000}.sales_musk[data-v-0930e935]{position:absolute;background:rgba(25,25,25,.83);width:100%;height:100%}.sales_box[data-v-0930e935]{position:absolute;top:10vh;left:50%;width:320px;margin-left:-160px}.sales .close[data-v-0930e935]{position:absolute;top:25px;right:10px;width:36px;height:36px}.sales .tabs[data-v-0930e935]{position:absolute;top:150px;left:50px;width:226px;height:220px;overflow:scroll}.sales .tabs .list[data-v-0930e935]{height:184px;overflow:scroll}.sales li[data-v-0930e935]{height:36px;padding:0 5px;line-height:36px;border-bottom:1px solid #ffd889}.sales li[data-v-0930e935]:last-child{border:none}.sales .nothing[data-v-0930e935]{margin-top:50px}", ""]);

// exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

__webpack_require__(7);

__webpack_require__(17);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	directives: {
		WaterfallLower: (0, _waterfall2.default)('lower'),
		WaterfallUpper: (0, _waterfall2.default)('upper')
	},
	data: function data() {
		return {
			imgPath: '',
			showSales: false,
			salesList: [],
			salesLists: [],
			curSale: 1,
			ds_id: '',
			salesPage: 1,
			salesPageNums: 20,
			disabledSale: false,
			disabledSales: false
		};
	},

	props: ['fans_id', 'playHeight'],
	mounted: function mounted() {
		this.imgPath = _Tools2.default.imgPath();
		this.ds_id = _Tools2.default.getQueryDsId();
	},

	methods: {
		showSalesList: function showSalesList() {
			this.showSales = true;
			if (!this.disabledSale) {
				this.getSalesList();
			}
			if (!this.disabledSales) {
				this.getSalesList2();
			}
		},
		getSalesList: function getSalesList() {
			var that = this;
			var url = _Tools2.default.baseUrl1() + "/shop/top/get_data";
			var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + '&page=' + this.salesPage + '&page_nums=' + this.salesPageNums + '&type=1';
			_toast2.default.loading();
			this.disabledSale = true;
			this.axios.post(url, option).then(function (res) {
				var data = res.data;
				_toast2.default.clear();
				if (data.code == "200") {
					that.salesPage++;
					if (data.data.length < that.salesPageNums) {
						that.disabledSale = true;
					} else {
						that.disabledSale = false;
					}
					that.salesList = that.salesList.concat(data.data);
				}
			}).catch(function (res) {
				_toast2.default.clear();
				(0, _toast2.default)('请求错误' + res.data.message);
			});
		},
		getSalesList2: function getSalesList2() {
			var that = this;
			var url = _Tools2.default.baseUrl1() + "/shop/top/get_data";
			var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + '&page=' + this.salesPage + '&page_nums=' + this.salesPageNums;
			_toast2.default.loading();
			this.disabledSales = true;
			this.axios.post(url, option).then(function (res) {
				var data = res.data;
				_toast2.default.clear();
				if (data.code == "200") {
					that.salesPage++;
					if (data.data.length < that.salesPageNums) {
						that.disabledSales = true;
					} else {
						that.disabledSales = false;
					}
					that.salesLists = that.salesLists.concat(data.data);
				}
			}).catch(function (res) {
				_toast2.default.clear();
				(0, _toast2.default)('请求错误' + res.data.message);
			});
		},
		closeSales: function closeSales() {
			this.showSales = false;
		},
		changeCur: function changeCur(index) {
			this.curSale = index;
		}
	}
};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wallet"
    }
  }, [_c('div', {
    staticClass: "wallet",
    style: ('margin-top:' + _vm.playHeight + 'px')
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/wallet.png'
    },
    on: {
      "click": _vm.showSalesList
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSales),
      expression: "showSales"
    }],
    staticClass: "sales"
  }, [_c('div', {
    staticClass: "sales_musk"
  }), _vm._v(" "), _c('div', {
    staticClass: "sales_box"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/sales-bg.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/close.png"
    },
    on: {
      "click": _vm.closeSales
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs_title"
  }, [_c('div', {
    staticClass: "btn",
    class: {
      cur: (_vm.curSale == 1)
    },
    on: {
      "click": function($event) {
        return _vm.changeCur(1)
      }
    }
  }, [_c('a', [_vm._v("我的动态")])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: {
      cur: (_vm.curSale == 2)
    },
    on: {
      "click": function($event) {
        return _vm.changeCur(2)
      }
    }
  }, [_c('a', [_vm._v("全部动态")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curSale == 1),
      expression: "curSale == 1"
    }, {
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getSalesList),
      expression: "getSalesList"
    }],
    staticClass: "list",
    attrs: {
      "waterfall-disabled": "disabledSale",
      "waterfall-offset": "100"
    }
  }, [(_vm.salesList.length) ? _c('ul', _vm._l((_vm.salesList), function(item) {
    return _c('li', {
      staticClass: "ellipsis"
    }, [(item.share_fans_id == 0) ? [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 从你的链接购买了" + _vm._s(item.buy_num) + "件商品\n\t\t\t\t\t\t\t")] : [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 获得了"), _c('span', {
      staticClass: "pink"
    }, [_vm._v(_vm._s(item.money / 100) + "元")]), _vm._v("分享收益\n\t\t\t\t\t\t\t")]], 2)
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/nothing.png"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curSale == 2),
      expression: "curSale == 2"
    }, {
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getSalesList2),
      expression: "getSalesList2"
    }],
    staticClass: "list",
    attrs: {
      "waterfall-disabled": "disabledSales",
      "waterfall-offset": "100"
    }
  }, [(_vm.salesLists.length) ? _c('ul', _vm._l((_vm.salesLists), function(item) {
    return _c('li', {
      staticClass: "ellipsis"
    }, [(item.share_fans_id == 0) ? [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 购买了" + _vm._s(item.buy_num) + "件商品\n\t\t\t\t\t\t\t")] : [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 获得了"), _c('span', {
      staticClass: "pink"
    }, [_vm._v(_vm._s(item.money / 100) + "元")]), _vm._v("分享收益\n\t\t\t\t\t\t\t")]], 2)
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/nothing.png"
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  "data-v-35c0a265",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(360);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7f050dfd", content, true);

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".robing[data-v-35c0a265]{color:#f4d79d;background:#ea251d}#robredbaglist[data-v-35c0a265]{margin:-10px;border-radius:10px;overflow:hidden}.topView[data-v-35c0a265]{padding-bottom:10px}.header[data-v-35c0a265]{background-repeat:no-repeat;background-size:100% 100%;height:60px}.hb_headerImage[data-v-35c0a265]{position:absolute;top:30px;left:50%;margin-left:-25px;height:50px;width:50px;border-radius:5px;border:2px solid #f4d79d}.lists[data-v-35c0a265]{min-height:200px;max-height:300px;overflow:auto;-webkit-overflow-scrolling:touch}.userNameLabel[data-v-35c0a265]{margin-top:30px;text-align:center}.userNamebottomLabel[data-v-35c0a265]{margin-top:5px;text-align:center;font-size:15px}.redtext[data-v-35c0a265]{margin:auto;margin-top:5px;text-align:center;width:80%;font-size:12px}.hb_ping[data-v-35c0a265]{display:inline-block;background-color:#ffbb29;color:#fff;padding:0 4px;border-radius:3px;margin-left:10px;font-size:10px}.redmoney[data-v-35c0a265]{padding-top:5px;text-align:center;font-size:40px;color:#f99c3a}.yuan[data-v-35c0a265]{font-size:10px;padding-left:5px}.detail[data-v-35c0a265]{padding-top:10px;text-align:center;color:#5074bd;font-size:13px}.status[data-v-35c0a265]{padding:10px 20px;color:#6a6a6a;border-bottom:1px solid #d2d2d2}.list-row[data-v-35c0a265]{padding:4px;border-bottom:1px solid #f1f1f1}.list-row img[data-v-35c0a265]{float:left;width:50px;border-radius:10px}.redbag_box[data-v-35c0a265]{padding:5px 15px;padding-left:55px}.otherName[data-v-35c0a265]{color:#242424}.othertime[data-v-35c0a265]{color:#a5a5a5;padding-top:5px}.other_money[data-v-35c0a265]{color:#f99c3a}.openimage[data-v-35c0a265]{display:block;width:100px;height:100px;background-size:100% 100%;margin:auto;margin-top:30px}.iconi-image[data-v-35c0a265]{display:block;width:20px;height:20px;background-size:100% 100%;margin:auto;margin-top:40px}", ""]);

// exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

__webpack_require__(25);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_button2.default);
exports.default = {
  data: function data() {
    return {
      imgPath: ''
    };
  },

  props: ['man', 'list'],
  mounted: function mounted() {
    this.imgPath = _Tools2.default.imgPath();
  },

  methods: {
    cash: function cash() {
      this.$router.push({
        name: 'UserInfo'
      });
    },
    close: function close() {
      this.$emit('close');
    },
    openAction: function openAction() {
      this.list.status = 'is_open';
    }
  }
};

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      robing: (_vm.list.status == 'is_close')
    },
    attrs: {
      "id": "robredbaglist"
    }
  }, [_c('div', {
    staticClass: "topView"
  }, [_c('div', {
    staticClass: "header",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/redheader_03.png)')
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hb_headerImage",
    attrs: {
      "src": _vm.man.header
    }
  })]), _vm._v(" "), (_vm.list.status != 'is_close') ? [_c('p', {
    staticClass: "userNameLabel"
  }, [_vm._v(_vm._s(_vm.man.nick) + "的红包"), _c('span', {
    staticClass: "hb_ping"
  }, [_vm._v("拼")])]), _vm._v(" "), (_vm.list.amount) ? _c('div', {
    staticClass: "midContent"
  }, [(_vm.man.content) ? _c('p', {
    staticClass: "redtext"
  }, [_vm._v(_vm._s(_vm.man.content))]) : _c('p', {
    staticClass: "redtext"
  }, [_vm._v("恭喜发财，大吉大利")]), _vm._v(" "), _c('p', {
    staticClass: "redmoney"
  }, [_vm._v(_vm._s(_vm.list.amount)), _c('span', {
    staticClass: "yuan"
  }, [_vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "detail"
  }, [_vm._v("已存入零钱，可 "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.cash
    }
  }, [_vm._v("提现")])], 1)]) : _c('p', {
    staticClass: "redtext"
  }, [_vm._v("手慢了,红包派完了")])] : _vm._e()], 2), _vm._v(" "), (_vm.list.status != 'is_close') ? _c('div', {
    staticClass: "lists"
  }, _vm._l((_vm.list.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-row clearfix"
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "redbag_box"
    }, [_c('span', {
      staticClass: "otherName"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('span', {
      staticClass: "other_money fr"
    }, [_vm._v(_vm._s(item.amount / 100) + " 元")]), _vm._v(" "), _c('p', {
      staticClass: "othertime"
    }, [_vm._v(_vm._s(item.create_time))])])])
  }), 0) : _c('div', {
    staticClass: "redbagBottom"
  }, [_c('p', {
    staticClass: "userNameLabel"
  }, [_vm._v(_vm._s(_vm.man.nick))]), _vm._v(" "), _c('p', {
    staticClass: "userNamebottomLabel"
  }), _vm._v(" "), _c('p', {
    staticClass: "userNamebottomLabel"
  }, [_vm._v("给你发了个红包")]), _vm._v(" "), (_vm.man.content) ? _c('p', {
    staticClass: "redtext"
  }, [_vm._v(_vm._s(_vm.man.conent))]) : _c('p', {
    staticClass: "redtext"
  }, [_vm._v("恭喜发财,大吉大利")]), _vm._v(" "), _c('i', {
    staticClass: "openimage",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/open_10.png)'),
    on: {
      "click": _vm.openAction
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconi-image",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/redbottomImage_10.png)')
  })])])
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(364);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7eb4f924", content, true);

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#registerView[data-v-05ab0426]{top:0;bottom:0;overflow-y:auto;overflow-x:hidden;position:fixed;z-index:10002;background:#f5f5f5;width:100%}#registerView .title-box[data-v-05ab0426]{background-color:red}.img[data-v-05ab0426]{width:100%;height:100%;background-size:cover;background-position:50%}.timeDown[data-v-05ab0426]{position:absolute;right:15px;top:15px;background-color:rgba(0,0,0,.4);padding:6px 12px;border-radius:5px;font-size:12px;color:#fff}p[data-v-05ab0426]{padding:100px 0;text-align:center;font-size:18px}", ""]);

// exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _telTest = __webpack_require__(41);

var _telTest2 = _interopRequireDefault(_telTest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    TelTest: _telTest2.default
  },
  data: function data() {
    return {
      ds_data: {
        ds_info: {
          fid: ""
        },
        picArticl: {
          name: "",
          content: ""
        }
      },
      keyData: {},
      registerIsShow: false
    };
  },

  props: ["loaded", "fans_id", "ds_id"],
  watch: {
    ds_id: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          this.getDsInfo();
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {},

  methods: {
    getDsInfo: function getDsInfo() {
      var that = this;
      var option = "ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/getDsData", option).then(function (data) {
        console.log("data:", data);
        that.ds_data = data.data.data;
      }).catch(function (data) {
        Toast("网络错误！");
        console.log("错误" + data);
      });

      var that = this;
      var that = this;
      var option = "ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/getCheckPlayParams", option).then(function (data) {
        console.log("data:", data);
        that.keyData = data.data.data;
      }).catch(function (data) {
        Toast("网络错误！");
        console.log("错误" + data);
      });
    },
    showKey: function showKey() {
      if (this.ds_data.is_check_play == "yes") {
        this.registerIsShow = true;
      } else {
        this.registerok();
      }
    },
    registerok: function registerok() {
      this.registerIsShow = false;
      this.$emit("registerOk");
    }
  }
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(367);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2e05ef6b", content, true);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#telTest[data-v-030933f8]{top:0;bottom:0;overflow-y:auto;overflow-x:hidden;position:fixed;z-index:10001;background:#f5f5f5;width:100%;background-color:#fff}#telTest .content-box[data-v-030933f8]{position:relative;border-bottom:1px solid #e5e5e5;display:flex;align-items:center}#telTest .content-box_span[data-v-030933f8]{margin-left:20px;width:120px;text-overflow:-o-ellipsis-lastline;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical}#telTest .content-box_title[data-v-030933f8]{line-height:13px}#telTest .content-box_input[data-v-030933f8]{height:48px;line-height:50px;margin-left:10px;background:transparent;flex:1}#telTest .content-box_code_buttom[data-v-030933f8]{height:35px;width:103px;background-color:#fff;color:#0883fd;font-size:14px;border:1px solid #0883fd;border-radius:17px;position:absolute;right:20px;top:7px}#telTest input[data-v-030933f8]{border:0}.head[data-v-030933f8]{height:44px;width:100%;background-color:#fff;font-size:17px;font-weight:600;line-height:44px;color:#333;text-align:center;border-bottom:1px solid #f0f0f0}#telTest .van-button--primary[data-v-030933f8]{background-color:#0883fd;border:1px solid #0883fd;border-radius:25px}#telTest .van-button--large[data-v-030933f8]{height:44px;line-height:42px}.tishi[data-v-030933f8]{margin:30px 15px 0}", ""]);

// exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(369);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a69f75e6", content, true);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-toast.van-toast--text.van-toast--middle{z-index:11000!important}", ""]);

// exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

__webpack_require__(7);

__webpack_require__(25);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_button2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	created: function created() {},

	props: {
		show_type: {
			type: Number,
			default: 1
		},
		fans_id: {
			type: Number,
			default: ""
		},
		ds_id: {
			type: Number | String,
			default: ""
		},
		need_check_bool: {
			type: Boolean,
			default: true
		}
	},
	data: function data() {
		return {
			phone: "",
			value: "",
			ds_data: {},
			list: [],
			phone_text: "获取验证码",
			account_white_name: "",
			account_white_password: ""
		};
	},

	watch: {
		ds_id: {
			handler: function handler(newVal, oldVal) {
				if (newVal) {
					this.getFetchData();
				}
			},
			immediate: true
		}
	},
	methods: {
		getFetchData: function getFetchData() {
			var that = this;
			var option = "ds_id=" + this.ds_id;
			this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/getCheckPlayParams", option).then(function (data) {
				console.log("data:", data);
				that.ds_data = data.data.data;
				that.list = JSON.parse(data.data.data.params);
				for (var index in that.list) {
					var obj = that.list[index];
					obj.value = "";
					obj.phone = "";
				}
			}).catch(function (data) {
				// Toast("网络错误！");
				console.log("错误" + data);
			});
		},
		inputChange: function inputChange(item, index, event) {
			item.value = event.target.value;
		},
		commitData: function commitData() {
			var that = this;
			if (that.show_type === 1) {
				var obj = {};
				for (var index in this.list) {
					var o = this.list[index];
					obj[o.name_title] = o;
					if (o.type == 1) {
						if (!/^1\d{10}$/.test(o.value)) {
							(0, _toast2.default)("请输入正确的手机号码");
							return;
						}
					}
				}

				var str = JSON.stringify([obj]);

				var option = "ds_id=" + this.ds_id + "&content=" + str + "&fans_id=" + this.fans_id;
				this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/playerRegist", option).then(function (data) {
					console.log(data);
					if (data.data.code == 200) {
						(0, _toast2.default)("登记成功");
						that.$emit("registerok");
					} else {
						(0, _toast2.default)(data.data.message);
						console.log(data.data.message);
					}
				}).catch(function (data) {
					(0, _toast2.default)("网络错误！");
					console.log("错误" + data);
				});
			} else if (that.show_type === 2) {
				var _option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + "&mobile=" + that.phone + "&code=" + that.value;
				this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/whiteNumCheck", _option, {
					mobile: that.phone,
					code: that.value
				}).then(function (data) {
					console.log(data);
					if (data.data.code == 200) {
						(0, _toast2.default)("登记成功");
						that.$emit("whiteNumOk");
					} else {
						(0, _toast2.default)(data.data.message);
						console.log(data.data.message);
					}
				}).catch(function (data) {
					(0, _toast2.default)("网络错误！");
					console.log("错误" + data);
				});
			} else if (that.show_type === 3) {

				if (that.account_white_name == "") {
					(0, _toast2.default)("账号不能为空！");
					return;
				}

				if (that.account_white_password == "") {
					(0, _toast2.default)("密码不能为空！");
					return;
				}

				var _option2 = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + "&account=" + that.account_white_name + "&password=" + that.account_white_password;
				this.axios.post(_Tools2.default.baseUrl1() + "/customer/whiteList/check", _option2).then(function (data) {
					console.log(data);
					if (data.data.code == 200 && data.data.data.result) {
						(0, _toast2.default)("登录成功");
						that.$emit("whiteNumOk");
					} else {
						(0, _toast2.default)("校验失败!");
					}
				}).catch(function (data) {
					(0, _toast2.default)("网络错误！");
					console.log("错误" + data);
				});
			}
		},
		sendMsg: function sendMsg(mobile, type) {
			var self = this;
			var option = "mobile=" + mobile + "&sms_type=" + type;
			this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/sendSMS", option).then(function (data) {
				if (data.data.code == 200) {
					(0, _toast2.default)("短信已发送");
					self.phone_text = "60秒重发";
					var timer = setInterval(function () {
						var i = parseInt(self.phone_text);
						if (i == 1) {
							clearInterval(timer);
							self.phone_text = "获取验证码";
							return;
						}
						self.phone_text = i - 1 + "秒重发";
					}, 1000);
				} else {
					(0, _toast2.default)(data.data.message);
				}
			}).catch(function (data) {
				(0, _toast2.default)("网络错误！");
				console.log("错误" + data);
			});
		}
	}
};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "telTest"
    }
  }, [(_vm.show_type === 2 || _vm.show_type == 3) ? _c('div', {
    staticClass: "tishi"
  }, [_c('p', {
    staticStyle: {
      "font-size": "25px",
      "font-weight": "549",
      "color": "#313541",
      "line-height": "35px"
    }
  }, [_vm._v("\n\t\t\t白名单观看\n\t\t")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "20px",
      "margin-top": "5px",
      "color": "#7B838E"
    }
  }, [_vm._v("\n\t\t\t只允许添加了白名单的用户观看\n\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.show_type === 1) ? _c('div', {
    staticClass: "tishi"
  }, [_c('p', {
    staticStyle: {
      "font-size": "25px",
      "font-weight": "549",
      "color": "#313541",
      "line-height": "35px"
    }
  }, [_vm._v("\n\t\t\t登记信息\n\t\t")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "20px",
      "margin-top": "5px",
      "color": "#7B838E"
    }
  }, [_vm._v("\n\t\t\t为了保障课程知识产权，需登记学员信息核实后即可观看\n\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.show_type === 2) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入内容",
      "type": "number"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function($event) {
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.need_check_bool) ? _c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone_text == '获取验证码') ? _c('button', {
    staticClass: "content-box_code_buttom",
    on: {
      "click": function($event) {
        return _vm.sendMsg(_vm.phone, 2)
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t")]) : _c('button', {
    staticClass: "content-box_code_buttom",
    staticStyle: {
      "background-color": "#fff",
      "color": "#afafaf",
      "border": "1px solid #afafaf"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_type === 3) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_white_name),
      expression: "account_white_name"
    }],
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入账号",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_white_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account_white_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_white_password),
      expression: "account_white_password"
    }],
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入密码",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_white_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account_white_password = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.show_type === 1) ? _c('div', {
    staticStyle: {
      "margin": "30px 0 0 0px"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.type == 1) ? _c('div', [_c('div', {
      staticClass: "content-box"
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(item.name_title))]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "type": "number",
        "placeholder": "请输入内容"
      },
      domProps: {
        "value": item.value
      },
      on: {
        "input": function($event) {
          return _vm.inputChange(item, index, $event)
        }
      }
    })]), _vm._v(" "), (item.is_phone_check == 'yes') ? _c('div', {
      staticClass: "content-box"
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v("验证码")]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": item.code
      },
      on: {
        "input": function($event) {
          item.code = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.phone_text == '获取验证码') ? _c('button', {
      staticClass: "content-box_code_buttom",
      attrs: {
        "placeholder": "请输入内容"
      },
      on: {
        "click": function($event) {
          return _vm.sendMsg(item.value, 1)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t\t\t")]) : _c('button', {
      staticClass: "content-box_code_buttom",
      staticStyle: {
        "background-color": "#fff",
        "color": "#afafaf",
        "border": "1px solid #afafaf"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t\t\t")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
      staticStyle: {
        "border-bottom": "#e5e5e5 solid 1px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(item.name_title))]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "placeholder": "请输入内容"
      },
      domProps: {
        "value": item.value
      },
      on: {
        "input": function($event) {
          item.value = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item.type == 3) ? _c('div', {
      staticStyle: {
        "border-bottom": "#e5e5e5 solid 1px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(item.name_title))]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "placeholder": "请输入内容"
      },
      domProps: {
        "value": item.value
      },
      on: {
        "input": function($event) {
          item.value = $event.target.value
        }
      }
    })]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "bottom": "0px",
      "left": "0px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "80%",
      "display": "inline-block"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "block": ""
    },
    on: {
      "click": _vm.commitData
    }
  }, [_vm._v("进入观看\n\t\t")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "registerView"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.ds_data.ds_info.fid
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#333333",
      "line-height": "30px",
      "font-size": "20px",
      "font-weight": "bold",
      "padding": "20px 20px 10px 20px",
      "text-align": "left"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.ds_data.ds_info.name) + _vm._s(_vm.ds_data.ds_info.name) + "\n    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "left",
      "padding": "0px 0px 20px 20px",
      "color": "#afafaf"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007AFF"
    }
  }, [_vm._v(_vm._s(_vm.ds_data.ds_info.create_time))]), _vm._v(" | " + _vm._s(_vm.ds_data.ds_info.view_num) + "人观看\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "white",
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "#333333",
      "padding": "10px 20px 10px 20px",
      "text-align": "left"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.ds_data.picArticl.name) + "\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.ds_data.picArticl.content),
      expression: "ds_data.picArticl.content"
    }]
  }, [_vm._v("\n      " + _vm._s(_vm.ds_data.picArticl.content) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0px",
      "bottom": "0px",
      "position": "fixed",
      "width": "100%"
    }
  }, [(_vm.ds_data.is_check_play == 'yes') ? _c('van-button', {
    attrs: {
      "size": "large",
      "type": "primary",
      "block": ""
    },
    on: {
      "click": _vm.showKey
    }
  }, [_vm._v("登记观看")]) : _c('van-button', {
    attrs: {
      "size": "large",
      "type": "primary",
      "block": ""
    },
    on: {
      "click": _vm.showKey
    }
  }, [_vm._v("进入直播间")])], 1), _vm._v(" "), (_vm.registerIsShow) ? _c('tel-test', {
    attrs: {
      "fans_id": _vm.fans_id,
      "show_type": 1,
      "ds_id": _vm.ds_id,
      "param-data": _vm.keyData
    },
    on: {
      "registerok": _vm.registerok
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("ae5290ea", content, true);

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".link{width:100%;height:100%;background-color:rgba(0,0,0,.6);display:block;position:fixed;top:0;left:0;z-index:4000}.link .main_view{border-radius:20px;text-align:center;width:80%;background-color:#fff;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);padding:10px}.link .main_view p{margin-top:20px}.link .main_view .t1-title{margin-top:10px;font-size:20px}.link .main_view .t1-desc{font-size:18px}.link .main_view .accept{margin-right:20px;width:33%;height:46px;display:inline-block;border:1px solid #008cf8;border-radius:24px;background-color:#008cf8}.link .main_view .accept span{line-height:46px;color:#fff}.link .main_view .refuse{width:33%;height:46px;display:inline-block;border:1px solid #008cf8;border-radius:24px;background-color:#fff;margin-right:10%}.link .main_view .refuse span{line-height:46px;color:#008cf8}.link .main_view .footer{margin-top:20px;margin-bottom:10px;text-align:center}.link .main_view .t2-refuse{margin-right:18%}.link .main_view .t2-accept,.link .main_view .t2-refuse{display:inline-block;width:25%}.link .main_view .t2-desc{font-size:20px;margin-top:30px;margin-bottom:40px}.link .main_view .t2-footer{margin-bottom:30px}", ""]);

// exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    linkType: {
      type: Number,
      default: 1 //1 申请连麦  2老师邀请连麦  3取消连麦
    }
  },
  watch: {
    isShow: function isShow(to) {
      this.viewShow = to;
    },
    linkType: function linkType(to) {
      if (to === 1) {
        this.title = "申请连麦";
        this.desc = "是否申请与主播连麦？";
        this.sureBtn = "申请连麦";
        this.cancelBtn = "取消";
      } else if (to === 2) {
        this.title = "邀请连麦";
        this.desc = "老师 申请与您连麦…";
        this.sureBtn = "同意连麦";
        this.cancelBtn = "拒绝连麦";
      } else if (to === 3) {
        this.title = "你确认下麦吗？";
        this.sureBtn = "确认";
        this.cancelBtn = "取消";
      }
    }
  },
  data: function data() {
    return {
      title: "申请连麦",
      desc: "是否申请与主播连麦？",
      sureBtn: "申请连麦",
      cancelBtn: "取消",
      viewShow: false
    };
  },

  methods: {
    onAcceptClicked: function onAcceptClicked() {
      this.$emit("accept");
    },
    onRefuseClicked: function onRefuseClicked() {
      this.$emit("refuse");
    }
  }
};

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewShow),
      expression: "viewShow"
    }],
    staticClass: "link"
  }, [_c('div', {
    staticClass: "main_view"
  }, [(_vm.linkType == 1) ? _c('div', [_c('p', {
    staticClass: "t1-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "t1-desc"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "refuse",
    on: {
      "click": _vm.onRefuseClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cancelBtn))])]), _vm._v(" "), _c('div', {
    staticClass: "accept",
    on: {
      "click": _vm.onAcceptClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.sureBtn))])])])]) : _vm._e(), _vm._v(" "), (_vm.linkType == 2) ? _c('div', [_c('p', {
    staticClass: "t2-desc"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
    staticClass: "footer t2-footer"
  }, [_c('div', {
    staticClass: "t2-refuse",
    on: {
      "click": _vm.onRefuseClicked
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/refuse_lianmai.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "t2-accept",
    on: {
      "click": _vm.onAcceptClicked
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/accpet_lianmai.png"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.linkType == 3) ? _c('div', [_c('p', {
    staticClass: "t1-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "refuse",
    on: {
      "click": _vm.onRefuseClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cancelBtn))])]), _vm._v(" "), _c('div', {
    staticClass: "accept",
    on: {
      "click": _vm.onAcceptClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.sureBtn))])])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("093ccf83", content, true);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".consultTeacher[data-v-6f42bad8]{width:100%;height:355px;position:fixed;bottom:0;left:0;z-index:5000}.consultTeacher .consultTeacherMain[data-v-6f42bad8],.consultTeacher .messageMain[data-v-6f42bad8]{position:relative;border-top-left-radius:10px;border-top-right-radius:10px;width:100%;height:100%;background-color:#fff}.messageMain .header[data-v-6f42bad8]{height:40px;width:100%;border-bottom:1px solid #f5f5f5}.messageMain .header .back[data-v-6f42bad8]{width:20px;margin-left:15px;vertical-align:-5px}.messageMain .header span[data-v-6f42bad8]{line-height:40px}.consultTeacherMain .header[data-v-6f42bad8]{height:40px;width:100%;border-bottom:1px solid #f5f5f5}.consultTeacherMain .header span[data-v-6f42bad8]{line-height:40px;margin-left:20px}.closeBtn[data-v-6f42bad8]{width:20px;height:20px;position:absolute;right:10px;top:10px}.consultTeacher .consultTeacherMain .TeacherList[data-v-6f42bad8]{width:100%;height:259px;overflow:auto}.consultTeacherMain .TeacherList .teacherCell[data-v-6f42bad8]{height:50px;width:100%;border-bottom:1px solid #f5f5f5;position:relative}.consultTeacherMain .TeacherList .teacherCell .nameSpan[data-v-6f42bad8]{line-height:50px;margin-left:10px}.consultTeacherMain .TeacherList .teacherCell .unRead[data-v-6f42bad8]{color:#f0f8ff;display:inline-block;position:absolute;top:12px;right:24px;padding:5px;text-align:center;background-color:red;border-radius:10px;font-size:12px}.consultTeacherMain .TeacherList .teacherCell img[data-v-6f42bad8]{margin-left:20px;height:40px;width:40px;border-radius:20px}.messageBox[data-v-6f42bad8]{overflow-x:hidden;height:219px}.messageCell[data-v-6f42bad8]{margin-top:5px;margin-bottom:5px}.messageCell .messageHeader[data-v-6f42bad8]{height:40px;position:relative}.messageHeader .time[data-v-6f42bad8]{font-size:12px;position:absolute;top:8px;right:20px}.messageHeader .name[data-v-6f42bad8]{font-size:14px;position:absolute;top:2px;left:42px}.messageCell .messageHeader img[data-v-6f42bad8]{height:30px;position:absolute;width:30px;border-radius:15px}.messageCell .other[data-v-6f42bad8]{top:5px;left:10px}.messageCell .content[data-v-6f42bad8]{padding-left:48px;word-wrap:break-word;word-break:normal;padding-right:20px;white-space:pre-line}.inputBox[data-v-6f42bad8]{width:100%;height:40px}.inputBox .inputField[data-v-6f42bad8]{float:left;background-color:#fff;padding-bottom:5px;padding-top:5px;padding-left:5px;margin-left:10px;margin-right:10px;border:1px solid #f5f5f5;border-radius:10px;width:70%;margin-top:2px}.inputBox .sendBtn[data-v-6f42bad8]{float:left;width:20%;margin-top:5px}.contentImg[data-v-6f42bad8]{max-width:45%;padding:10px;padding-left:48px}", ""]);

// exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

var _newim = __webpack_require__(84);

var _newim2 = _interopRequireDefault(_newim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        dsId: {
            type: Number | String,
            default: 0
        },
        fansId: {
            type: Number | String,
            default: 0
        },
        tid: {
            type: Number | String,
            default: 0
        }
    },
    data: function data() {
        return {
            teacherList: [],
            timer: null,
            showType: 1,
            selectItem: null,
            messageList: [],
            comment: ''
        };
    },

    watch: {
        // dsId (to) {
        //     if (to) {

        //         this.startTimeList()
        //     }
        // },
        showType: function showType(to) {
            this.switchTimeList();
        }
    },
    methods: {
        preview: function preview(url) {
            wx.previewImage({
                current: url, // 当前显示图片的http链接
                urls: [url] // 需要预览的图片http链接列表
            });
        },
        switchTimeList: function switchTimeList() {
            if (this.showType === 1) {
                this.startTimeList();
            } else {
                this.stopTimeList();
            }
        },
        stopTimeList: function stopTimeList() {
            clearInterval(this.timer);
            this.timer = null;
        },
        closeBtnClicked: function closeBtnClicked() {
            this.stopTimeList();
            this.$emit("closeBtnClicked");
        },
        sendC2CMsg: function sendC2CMsg() {
            if (this.selectItem) {
                if (this.comment === "") {
                    return;
                }
                var param = {
                    ds_id: this.dsId,
                    to: this.selectItem.fans_id,
                    fans_id: this.fansId,
                    content: this.comment,
                    terminal_type: 1
                };
                if (this.tid) {
                    param.tid = this.tid;
                }
                var self = this;
                this.axios.post(_Tools2.default.baseUrl2() + '/comment/index/addC2C', _qs2.default.stringify(param)).then(function (data) {
                    self.comment = "";
                    self.messageList.push(data.data.data.content);
                    setTimeout(function () {
                        var chatContent = document.getElementById('messageBox');
                        chatContent.scrollTop = chatContent.scrollHeight;
                    }, 50);
                    _newim2.default.onSendP2PMsg(JSON.stringify(data.data.data.content), self.selectItem.fans_id);
                }).catch(function (data) {
                    console.log(data);
                });
            }
        },
        getTeacherList: function getTeacherList() {
            var param = {
                ds_id: this.dsId
            };
            if (this.tid) {
                param.tid = this.tid;
            }
            var self = this;
            this.axios.post(_Tools2.default.baseUrlUser() + '/app/index/getOnlineTeacherList', _qs2.default.stringify(param)).then(function (data) {
                if (data.data.code === 2000) {
                    var tList = [];
                    data.data.data.list.forEach(function (element) {
                        var item = self.teacherList.find(function (item) {
                            return item.fans_id == element.fans_id;
                        });
                        element.unRead = item && item.unRead ? item.unRead : 0;
                        tList.push(element);
                    });
                    self.teacherList = tList;
                }
            }).catch(function (data) {});
        },
        toDetail: function toDetail(item) {
            this.selectItem = item;
            this.showType = 2;
            item.unRead = 0;
            this.getMessageList();
        },
        startTimeList: function startTimeList() {
            var _this = this;

            this.getTeacherList();
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(function () {
                _this.getTeacherList();
            }, 10000);
        },
        getMessageList: function getMessageList() {
            var param = {
                ds_id: this.dsId,
                fans_id: this.fansId,
                to: this.selectItem.fans_id
            };
            if (this.tid) {
                param.tid = this.tid;
            }
            var self = this;
            this.axios.post(_Tools2.default.baseUrl2() + '/comment/index/getC2CHistory', _qs2.default.stringify(param)).then(function (data) {
                if (data.data.code === 200) {
                    self.messageList = data.data.data;
                    setTimeout(function () {
                        var chatContent = document.getElementById('messageBox');
                        chatContent.scrollTop = chatContent.scrollHeight;
                    }, 50);
                }
            }).catch(function (data) {});
        },
        backList: function backList() {
            this.showType = 1;
            this.selectItem = null;
        },
        receivedMsg: function receivedMsg(json) {
            if (this.showType == 1) {
                this.teacherList.forEach(function (item) {
                    if (item.fans_id == json.fans_id) {
                        item.unRead = item.unRead + 1;
                    }
                });
                return;
            }

            if (this.showType == 2 && this.selectItem && json.fans_id == this.selectItem.fans_id) {
                this.messageList.push(json);
                setTimeout(function () {
                    var chatContent = document.getElementById('messageBox');
                    chatContent.scrollTop = chatContent.scrollHeight;
                }, 50);
            }
        }
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultTeacher"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 1),
      expression: "showType == 1"
    }],
    staticClass: "consultTeacherMain"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TeacherList"
  }, _vm._l((_vm.teacherList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "teacherCell",
      on: {
        "click": function($event) {
          return _vm.toDetail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "nameSpan"
    }, [_vm._v(_vm._s(item.wx_nick_name))]), _vm._v(" "), (item.unRead > 0) ? _c('span', {
      staticClass: "unRead"
    }, [_vm._v(_vm._s(item.unRead))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType == 2),
      expression: "showType == 2"
    }],
    staticClass: "messageMain"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/jiantou_back.png"
    },
    on: {
      "click": _vm.backList
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.backList
    }
  }, [_vm._v("返回列表")])]), _vm._v(" "), _c('div', {
    staticClass: "messageBox",
    attrs: {
      "id": "messageBox"
    }
  }, _vm._l((_vm.messageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "messageCell"
    }, [_c('div', [_c('div', {
      staticClass: "messageHeader other"
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.create_time))])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "content"
    }), _vm._v(" "), (item.pic_url) ? _c('div', {
      staticClass: "contentImg"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "inputBox"
  }, [_c('van-field', {
    staticClass: "inputField",
    attrs: {
      "placeholder": "说点什么..."
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendC2CMsg.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _vm._v(" "), _c('van-button', {
    staticClass: "sendBtn",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "touchstart": _vm.sendC2CMsg
    }
  }, [_vm._v("发送")])], 1), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("在线老师列表")])])
}]}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("37d1e093", content, true);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".consultTeacher[data-v-ad5dd668]{width:100%;height:500px;position:fixed;bottom:0;left:0;z-index:5000}.consultTeacher .consultTeacherMain[data-v-ad5dd668],.consultTeacher .messageMain[data-v-ad5dd668]{position:relative;border-top-left-radius:10px;border-top-right-radius:10px;width:100%;height:100%;background-color:#fff}.messageMain .header[data-v-ad5dd668]{height:40px;width:100%;border-bottom:1px solid #f5f5f5}.messageMain .header .back[data-v-ad5dd668]{width:20px;margin-left:15px;vertical-align:-5px}.messageMain .header span[data-v-ad5dd668]{line-height:40px}.consultTeacherMain .header[data-v-ad5dd668]{height:40px;width:100%;border-bottom:1px solid #f5f5f5}.consultTeacherMain .header span[data-v-ad5dd668]{line-height:40px;margin-left:20px}.closeBtn[data-v-ad5dd668]{width:20px;height:20px;position:absolute;right:10px;top:10px}.consultTeacher .consultTeacherMain .TeacherList[data-v-ad5dd668]{width:100%;height:459px;overflow:auto;box-sizing:border-box;padding:16px}.consultTeacherMain .TeacherList .teacherCell[data-v-ad5dd668]{width:100%;margin-bottom:16px;display:flex;align-items:center}.consultTeacherMain .TeacherList .teacherCell .goods-num[data-v-ad5dd668]{width:30px}.consultTeacherMain .TeacherList .teacherCell.order[data-v-ad5dd668]{padding-bottom:25px;border-bottom:1px solid #eee}.consultTeacherMain .TeacherList .teacherCell .goods-content[data-v-ad5dd668]{margin-left:10px;width:170px}.consultTeacherMain .TeacherList .teacherCell .goods-content .goods-title[data-v-ad5dd668]{font-weight:700px;font-size:14px;line-height:20px;font-size:#101010;width:170px;height:40px;font-weight:700;margin-bottom:10px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal!important;word-wrap:break-word}.consultTeacherMain .TeacherList .teacherCell .goods-price[data-v-ad5dd668]{display:flex;color:#f34718;font-weight:700;align-items:center}.consultTeacherMain .TeacherList .teacherCell .goods-price .stepper[data-v-ad5dd668]{margin-left:auto;font-weight:400}.consultTeacherMain .TeacherList .teacherCell .money-symbol[data-v-ad5dd668]{font-size:12px}.consultTeacherMain .TeacherList .teacherCell .money-num[data-v-ad5dd668]{font-size:18px}.consultTeacherMain .TeacherList .teacherCell .right[data-v-ad5dd668]{display:flex;flex-direction:column;justify-content:space-between;height:63px}.consultTeacherMain .TeacherList .teacherCell .right .num[data-v-ad5dd668]{font-size:12px}.consultTeacherMain .TeacherList .teacherCell .to-buy[data-v-ad5dd668]{width:60px;height:25px;color:#f5f5f5;text-align:center;line-height:25px;background:linear-gradient(315deg,#ed3f10,#fb724d);border-radius:4px;margin-left:auto}.consultTeacherMain .TeacherList .teacherCell .to-buy.disabled[data-v-ad5dd668]{background:#ddd}.consultTeacherMain .TeacherList .teacherCell .cover[data-v-ad5dd668]{height:72px;width:110px;border-radius:4px}.consultTeacherMain .TeacherList .form[data-v-ad5dd668]{outline:none;position:relative}.consultTeacherMain .TeacherList i[data-v-ad5dd668]{position:absolute;font-style:normal;left:-8px;top:4px}.consultTeacherMain .footer[data-v-ad5dd668]{position:fixed;bottom:0;left:0;display:flex;width:100%;padding:0 10px;height:50px;box-sizing:border-box;align-items:center}.consultTeacherMain .footer .sum-text[data-v-ad5dd668]{margin-right:4px}.consultTeacherMain .footer .sum-money[data-v-ad5dd668]{color:#f34718;font-weight:700}.consultTeacherMain .footer .sum-money span[data-v-ad5dd668]:first-child{font-size:14px;margin-right:2px}.consultTeacherMain .footer .sum-money span[data-v-ad5dd668]:last-child{font-size:22px}.consultTeacherMain .footer .comfirm-btn[data-v-ad5dd668]{margin-left:auto}.consultTeacherMain .footer .comfirm-btn button[data-v-ad5dd668]{border:none;color:#fff;width:100px;height:36px;border-radius:20px;background:#0084ff}.messageBox[data-v-ad5dd668]{overflow-x:hidden;height:219px}.messageCell[data-v-ad5dd668]{margin-top:5px;margin-bottom:5px}.messageCell .messageHeader[data-v-ad5dd668]{height:40px;position:relative}.messageHeader .time[data-v-ad5dd668]{font-size:12px;position:absolute;top:8px;right:20px}.messageHeader .name[data-v-ad5dd668]{font-size:14px;position:absolute;top:2px;left:42px}.messageCell .messageHeader img[data-v-ad5dd668]{height:30px;position:absolute;width:30px;border-radius:15px}.messageCell .other[data-v-ad5dd668]{top:5px;left:10px}.messageCell .content[data-v-ad5dd668]{padding-left:48px;word-wrap:break-word;word-break:normal;padding-right:20px;white-space:pre-line}.inputBox[data-v-ad5dd668]{width:100%;height:40px}.inputBox .inputField[data-v-ad5dd668]{float:left;background-color:#fff;padding-bottom:5px;padding-top:5px;padding-left:5px;margin-left:10px;margin-right:10px;border:1px solid #f5f5f5;border-radius:10px;width:70%;margin-top:2px}.inputBox .sendBtn[data-v-ad5dd668]{float:left;width:20%;margin-top:5px}.contentImg[data-v-ad5dd668]{max-width:45%;padding:10px;padding-left:48px}", ""]);

// exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notify = __webpack_require__(119);

var _notify2 = _interopRequireDefault(_notify);

__webpack_require__(121);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

var _axios = __webpack_require__(28);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    props: {
        dsId: {
            type: Number | String,
            default: 0
        },
        fansId: {
            type: Number | String,
            default: 0
        },
        tid: {
            type: Number | String,
            default: 0
        },
        uid: {
            type: Number | String,
            default: 0
        },
        gid: {
            type: Number | String,
            default: 0
        },
        channel_id: {
            type: String | Number,
            default: 0
        },
        goodsIds: {
            type: Array | Object,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            teacherList: [],
            timer: null,
            showType: 1,
            selectItem: null,
            messageList: [],
            comment: '',
            username: '',
            tel: '',
            goodsNum: 1,
            goodsList: []
        };
    },

    watch: {
        // dsId (to) {
        //     if (to) {

        //         this.startTimeList()
        //     }
        // },
        showType: function showType(to) {
            this.switchTimeList();
        }
    },
    mounted: function mounted() {
        console.log('gid--------------', this.gid);
    },

    methods: {
        preview: function preview(url) {
            wx.previewImage({
                current: url, // 当前显示图片的http链接
                urls: [url] // 需要预览的图片http链接列表
            });
        },
        switchTimeList: function switchTimeList() {
            if (this.showType === 1) {
                this.startTimeList();
            } else {
                this.stopTimeList();
            }
        },
        stopTimeList: function stopTimeList() {
            clearInterval(this.timer);
            this.timer = null;
        },
        closeBtnClicked: function closeBtnClicked() {
            this.stopTimeList();
            this.$emit("closeBtnClicked");
        },
        getTeacherList: function getTeacherList() {
            var param = {
                ds_id: this.dsId
            };
            if (this.tid) {
                param.tid = this.tid;
            }
            var self = this;
            this.axios.post(_Tools2.default.baseUrlUser() + '/app/index/getOnlineTeacherList', _qs2.default.stringify(param)).then(function (data) {
                if (data.data.code === 2000) {
                    var tList = [];
                    data.data.data.list.forEach(function (element) {
                        var item = self.teacherList.find(function (item) {
                            return item.fans_id == element.fans_id;
                        });
                        element.unRead = item && item.unRead ? item.unRead : 0;
                        tList.push(element);
                    });
                    self.teacherList = tList;
                }
            }).catch(function (data) {});
        },
        toDetail: function toDetail(_ref) {
            var id = _ref.id,
                count = _ref.count,
                infinite = _ref.infinite,
                jump = _ref.jump,
                payurl = _ref.payurl;

            if (jump === 1) {
                window.open(payurl);
                return;
            }
            if (count == 0 && infinite == 0) {
                (0, _notify2.default)('商品库存不足');
                return;
            }
            if (_Tools2.default.isWeixinMP()) {
                //小程序内打开
                var appid = localStorage.getItem("current_app_Id");
                var fans = JSON.parse(localStorage.getItem(appid));
                var data = {
                    gid: id,
                    uid: this.uid,
                    header: fans.header,
                    nick: fans.nick,
                    openid: fans.openid,
                    fansid: fans.fans_id,
                    ds_id: this.dsId,
                    channel_id: this.channel_id
                };
                var option = '';
                for (var i in data) {
                    if (data[i]) {
                        option = option + (i + '=' + data[i] + '&');
                    }
                }
                option = option.slice(0, option.length - 1);
                wx.miniProgram.navigateTo({ url: '/pages/goods/goods?' + option });
            } else if (_Tools2.default.isWeixin()) {
                this.$router.push({ path: '/goodsDetail?id=' + id + '&uid=' + this.uid + '&channel_id=' + this.channel_id + '&dsId=' + this.dsId });
            } else {
                (0, _notify2.default)('请在微信内打开');
            }
        },
        startTimeList: function startTimeList() {
            var _this = this;

            this.getTeacherList();
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(function () {
                _this.getTeacherList();
            }, 10000);
        },
        getGoodsList: function getGoodsList() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var ids, option, res;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // const current_app_Id = window.localStorage.getItem("current_app_Id");
                                // const fans = JSON.parse(window.localStorage.getItem(current_app_Id));
                                // const token = fans.token;
                                // const option = "ds_id="+ this.dsId 
                                ids = JSON.stringify(_this2.goodsIds);
                                option = 'ds_id=' + _this2.dsId + '&goods_id=' + ids;
                                _context.prev = 2;
                                _context.next = 5;
                                return _axios2.default.post(_Tools2.default.baseUrl2() + '/goods/list', option);

                            case 5:
                                res = _context.sent;

                                // const res =  await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/list',option)
                                console.log(res);
                                if (res.data.code === 200) {
                                    _this2.goodsList = res.data.data.list;
                                    _this2.goodsList.forEach(function (item) {
                                        _this2.getGoodsNum(item.id);
                                    });
                                }
                                _context.next = 13;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](2);

                                console.log(_context.t0);

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[2, 10]]);
            }))();
        },
        getGoodsNum: function getGoodsNum(id) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var option, _ref2, _ref2$data, code, data;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // const option = `ds_id=209972&goods_id=27`
                                // const { data: { code, data } } =  await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/goodsInventory',option)
                                option = 'ds_id=' + _this3.dsId + '&goods_id=' + id;
                                _context2.next = 3;
                                return _axios2.default.post(_Tools2.default.baseUrl2() + '/goods/goodsInventory', option);

                            case 3:
                                _ref2 = _context2.sent;
                                _ref2$data = _ref2.data;
                                code = _ref2$data.code;
                                data = _ref2$data.data;

                                if (code === 200) {
                                    _this3.goodsList = _this3.goodsList.map(function (item) {
                                        if (item.id == data.goods_id) {
                                            item.count = data.count;
                                            item.infinite = data.infinite;
                                        }
                                        return item;
                                    });
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    }
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _color = __webpack_require__(120);

var _functional = __webpack_require__(15);

var _popup = __webpack_require__(30);

var _popup2 = __webpack_require__(19);

var _popup3 = _interopRequireDefault(_popup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('notify'),
    sfc = _use[0],
    bem = _use[1];

function Notify(h, props, slots, ctx) {
  var style = {
    color: props.color,
    background: props.background
  };
  return h(_popup3.default, (0, _babelHelperVueJsxMergeProps2.default)([{
    "attrs": {
      "value": props.value,
      "position": "top",
      "overlay": false,
      "lockScroll": false
    },
    "style": style,
    "class": [bem(), props.className],
    "on": {
      "input": function input(value) {
        (0, _functional.emit)(ctx, 'input', value);
      }
    }
  }, (0, _functional.inherit)(ctx)]), [props.message]);
}

Notify.props = (0, _extends3.default)({}, _popup.PopupMixin.props, {
  className: null,
  message: [String, Number],
  color: {
    type: String,
    "default": _color.WHITE
  },
  background: {
    type: String,
    "default": _color.RED
  },
  duration: {
    type: Number,
    "default": 3000
  }
});
exports.default = sfc(Notify);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(386);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-notify{text-align:center;box-sizing:border-box;padding:6px 15px;font-size:14px;line-height:20px;white-space:pre-wrap}", ""]);

// exports


/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultTeacher"
  }, [_c('div', {
    staticClass: "consultTeacherMain"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TeacherList"
  }, _vm._l((_vm.goodsList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "teacherCell"
    }, [_c('div', {
      staticStyle: {
        "width": "110px"
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.cover
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-content"
    }, [_c('div', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_c('span', {
      staticClass: "money-symbol"
    }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
      staticClass: "money-num"
    }, [_vm._v(_vm._s(item.price))])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "to-buy",
      class: {
        'disabled': item.count == 0 && item.infinite == 0
      },
      on: {
        "click": function($event) {
          return _vm.toDetail(item)
        }
      }
    }, [_vm._v("去抢购")]), _vm._v(" "), (item.infinite !== 1) ? _c('div', {
      staticClass: "num"
    }, [_vm._v("库存: " + _vm._s(item.count))]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("商品列表")])])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(389);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5ea0f660", content, true);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#Launch[data-v-3a3aa7e2]{height:100%;width:100%;position:fixed;z-index:11000;background:#f5f5f5;top:0;left:0}.img[data-v-3a3aa7e2]{width:100%;height:100%;background-size:cover;background-position:50%}.timeDown[data-v-3a3aa7e2]{position:absolute;right:15px;top:15px;background-color:rgba(0,0,0,.4);padding:6px 12px;border-radius:5px;font-size:12px;color:#fff}p[data-v-3a3aa7e2]{padding:100px 0;text-align:center;font-size:18px}", ""]);

// exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      currentCount: 3,
      timer: "",
      imgScr: "",
      ds_id: "",
      timer2: ""
    };
  },

  props: ["loaded", "message"],
  mounted: function mounted() {},

  methods: {
    enterHome: function enterHome() {}
  }
}; //
//
//
//
//

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Launch"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.message || "你无权观看此直播，请联系管理员"))])])
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(396),
  /* scopeId */
  "data-v-19595ade",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4c7d3b77", content, true);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#Launch[data-v-19595ade]{height:100%;width:100%;position:fixed;z-index:11000;background:#f5f5f5;top:0;left:0}.img[data-v-19595ade]{width:100%;height:100%;background-size:cover;background-position:50%}p[data-v-19595ade]{margin-top:100px;padding:50px 0;text-align:center;font-size:18px}.imageBox[data-v-19595ade]{text-align:center}", ""]);

// exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//

var _qrcoder = __webpack_require__(26);

var _qrcoder2 = _interopRequireDefault(_qrcoder);

var _vuex = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      imageCode: ""
    };
  },

  props: ["message", "ds_id", "channel_id"],
  computed: _extends({}, (0, _vuex.mapGetters)({
    wechat_mp_url: "dsInfo/getWechat_mp_url"
  })),
  watch: {
    wechat_mp_url: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          _this.makeCodeImage();
        });
      },

      immediate: true
    }
  },
  mounted: function mounted() {},

  methods: {
    makeCodeImage: function makeCodeImage() {
      var xcxurl = "";
      if (this.channel_id) {
        xcxurl = this.wechat_mp_url + "?channel_id=" + this.channel_id;
      } else {
        xcxurl = this.wechat_mp_url + "?ds_id=" + this.ds_id;
      }
      var qrcoder = new _qrcoder2.default({
        data: xcxurl,
        size: 240
      });
      this.imageCode = qrcoder.getDataURL();
    }
  }
};

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Launch"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "imageBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageCode
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(401),
  /* scopeId */
  "data-v-36a631fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(399);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("10abeff4", content, true);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".white-board-box[data-v-36a631fc]{width:100%;height:100%;position:relative}.white-board-box #white-board[data-v-36a631fc]{width:100%;height:56vw}.white-board-bottom[data-v-36a631fc]{position:absolute;bottom:0;left:0;right:0;height:40px;background:linear-gradient(hsla(0,0%,100%,.2),rgba(0,0,0,.2));display:flex;justify-items:center;align-items:center;justify-content:flex-end;padding:0 10px}.fullsrceenBtn[data-v-36a631fc]{width:25px;height:25px}.positionIcon[data-v-36a631fc]{left:11px}.positionIcon[data-v-36a631fc],.refreshIcon[data-v-36a631fc]{position:absolute;width:25px;height:25px;top:50%;z-index:1;transform:translateY(-50%)}.refreshIcon[data-v-36a631fc]{right:11px}.white-board-box-full[data-v-36a631fc]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1900;background-color:#000;display:flex;align-items:center}.noDataTip[data-v-36a631fc]{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:#1e1e1e}", ""]);

// exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _timJsSdk = __webpack_require__(85);

var _timJsSdk2 = _interopRequireDefault(_timJsSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: ['ds_id', 'fans_id', 'direct_status', 'im_type'],
    data: function data() {
        return {
            teduBoard: null,
            fullsrceen: false,
            Landscape: false,
            LandscapeStyle: {},
            isShowBoardBottom: true
        };
    },

    computed: {
        userInfo: function userInfo() {
            return {
                ds_id: this.ds_id,
                fans_id: this.fans_id,
                direct_status: this.direct_status
            };
        }
    },
    watch: {
        userInfo: function userInfo(newVla, oldVal) {
            var _this = this;

            if (newVla.ds_id && newVla.fans_id) {
                this.$nextTick(function () {
                    _this.createwhiteboard();
                });
            }
        }
    },
    mounted: function mounted() {
        if (this.userInfo.ds_id && this.userInfo.fans_id) {
            this.createwhiteboard();
        }
    },

    methods: {
        whiteboardTap: function whiteboardTap() {},
        exitFullScreen: function exitFullScreen() {
            if (this.fullsrceen) {
                //退出全屏
                this.Landscape = false;
                this.fullsrceen = false;
                this.LandscapeStyle = {};
            }
        },
        refreshTap: function refreshTap() {
            if (this.teduBoard) {
                this.teduBoard.refresh();
            }
        },
        addMessageSyncData: function addMessageSyncData(data) {
            //添加画板消息
            if (this.teduBoard) {
                this.teduBoard.addSyncData(data);
            }
        },
        createwhiteboard: function createwhiteboard() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params, res, initParams;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log("createwhiteboard---im_type", _this2.im_type);

                                if (!(!_this2.teduBoard && _this2.direct_status == 'running')) {
                                    _context.next = 12;
                                    break;
                                }

                                _context.prev = 2;
                                params = "uid=" + _this2.fans_id + "&ds_id=" + _this2.ds_id;
                                _context.next = 6;
                                return _this2.axios.post(_Tools2.default.baseUrl1() + "/api/whiteboard/getThreeUserSig", params);

                            case 6:
                                res = _context.sent;

                                if (res && res.data && res.data.code == 200) {
                                    console.log("res=====data", res.data.data);
                                    initParams = {
                                        id: 'white-board',
                                        classId: _this2.ds_id,
                                        sdkAppId: res.data.data.appid,
                                        userId: res.data.data.uid,
                                        userSig: res.data.data.tl_sign,
                                        authConfig: {
                                            drawEnable: false
                                        },
                                        config: {
                                            ratio: '16:9'
                                        }
                                    };

                                    _this2.teduBoard = new TEduBoard(initParams);
                                    if (_this2.im_type == 2) {
                                        _this2.loginWhiteBoardIM({ sdkAppId: res.data.data.appid, userSig: res.data.data.tl_sign });
                                    }
                                }
                                _context.next = 12;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](2);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[2, 10]]);
            }))();
        },
        loginWhiteBoardIM: function loginWhiteBoardIM(loginInfo) {
            var _this3 = this;

            var that = this;
            var tim = _timJsSdk2.default.create({ SDKAppID: parseInt(loginInfo.sdkAppId) });
            // 监听消息事件
            tim.on(_timJsSdk2.default.EVENT.MESSAGE_RECEIVED, function (event) {
                // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
                for (var index = 0; index < event.data.length; index++) {
                    var element = event.data[index];
                    if (element.conversationType === _timJsSdk2.default.TYPES.CONV_GROUP && _this3.ds_id == element.to) {
                        // 群消息
                        if (element.type === 'TIMCustomElem') {
                            if (element.payload.extension === 'TXWhiteBoardExt') {
                                _this3.addMessageSyncData(element.payload.data);
                            }
                        }
                    }
                }
            });
            // 登录IM
            tim.login({ userID: '' + this.fans_id, userSig: loginInfo.userSig }).then(function (imResponse) {
                console.log('开始登录', imResponse.data);
                tim.joinGroup({ groupID: '' + _this3.ds_id, type: _timJsSdk2.default.TYPES.GRP_AVCHATROOM }).then(function (imResponse) {
                    console.log('开始登录', imResponse);
                });
            }).catch(function (imError) {
                that.$emit('errorReport', { msg: '白板加入群聊错误', error: imError });
                console.warn('login error:', imError); // 登录失败的相关信息
            });
        },
        fullScreenTap: function fullScreenTap() {
            this.fullsrceen = !this.fullsrceen;
            // this.$nextTick(()=>{
            // this.teduBoard.resize()
            // })
        },
        changeScreenPostionTap: function changeScreenPostionTap() {
            this.$emit("changPosion");
        },
        LandscapeTap: function LandscapeTap() {
            this.Landscape = !this.Landscape;
            if (this.Landscape) {
                var conW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                var conH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                // transform: rotate(90deg); width: 667px; height: 375px;transform-origin:28% 50%;
                this.LandscapeStyle = {
                    transform: "rotate(90deg) translate(" + (conH - conW) / 2 + "px," + (conH - conW) / 2 + "px)",
                    height: "100vw",
                    width: "100vh",
                    'transform-origin': "center center"
                };
            } else {
                this.fullsrceen = false;
                this.LandscapeStyle = {};
            }
        }
    }
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-board-box",
    class: {
      'white-board-box-full': _vm.fullsrceen
    },
    style: (_vm.LandscapeStyle),
    on: {
      "click": _vm.whiteboardTap
    }
  }, [(_vm.direct_status == 'running') ? [_c('div', {
    style: ({
      height: _vm.Landscape ? '100%' : '56vw'
    }),
    attrs: {
      "id": "white-board"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowBoardBottom),
      expression: "isShowBoardBottom"
    }],
    staticClass: "white-board-bottom"
  }, [(_vm.fullsrceen) ? _c('img', {
    staticClass: "fullsrceenBtn",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "src": __webpack_require__(402)
    },
    on: {
      "click": _vm.LandscapeTap
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.Landscape) ? [(_vm.fullsrceen) ? _c('img', {
    staticClass: "fullsrceenBtn",
    attrs: {
      "src": __webpack_require__(403)
    },
    on: {
      "click": _vm.fullScreenTap
    }
  }) : _c('img', {
    staticClass: "fullsrceenBtn",
    attrs: {
      "src": __webpack_require__(404)
    },
    on: {
      "click": _vm.fullScreenTap
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullsrceen),
      expression: "!fullsrceen"
    }],
    staticClass: "positionIcon",
    attrs: {
      "src": __webpack_require__(405)
    },
    on: {
      "click": _vm.changeScreenPostionTap
    }
  })] : _c('p', {
    staticClass: "noDataTip"
  }, [_c('img', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/wbnothing.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ccc",
      "font-size": "14px",
      "margin": "10px 7px 0 0"
    }
  }, [_vm._v("暂无内容")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAu1JREFUWEftmEuITmEYx3//5JJbKJbjujCpEY2w0CzIpZhkZOOSsVGiKBZkJ0OhyWXKRq5JJBvjUsiCKUluK1LCgizcG3ePnvGe6fj6jvOdb85oFt+zO+d53+f5nf/7vOe9iB5q6qFcdBnMzPoDB4Ca8JEGvAZeAY+B+0CbpA9ZRMgDbA3QkpL0J3ATOA2ckPQ+DTIPsEXA2bREMf+n8CE7Jb1L6pcHmMc4BDQWSeLDmpTDh3utpDPF4LoM5kHNrFcYJlcvbnuA48AsYDEwrQhEM7BR0q+4LxewANcHaA0QUY4tknZED2Y2BdgGzCkAPAaslOQKd1huYAHOZ+g1YGqIv0rS4UKVzGw5cBDw9pF5zW3uFrAAN8SHBvgINEv6VqyGzGwScBkYHvyuVr2k87krljTDkt6bmSt7BRgY2jwHqiW1/zWUZjYBaADGAf2yJvpH+++AJ22VdCPezsxWAEdj7zZJ2t0BZmZeuHuB1XnXXRHYi8AySW9ik+I6UBeeXwJVMjOHOwUsyVGhtFB3gBmSPgdhZoYhjfrNdrCFwLlYpC+Ay/02LXoG/wBgOjA01merpO0BzMV5AowJ/hYH85kxO7zwhbdOki++uZqZjQAuAT4b3V4AI6N/l5ntA9YF3wMH8wV1cHjRUXi5EsWCmdlcwGssMgfzSeF1Pg+4EBy3HKzzbwssiP4j3QFnZqOAp7HYNZIeRs9mth6YDDQVgs2X5MtKt5iZVQHPksDiSStgoY4qimWqxUqNZZLrz7+qUmOZRKsolkmuSo1llasMxfwU0zvkaZR0pIycJXUxs1rgdqzxeEmPinX2RfweMDE4r/qmsfBUXFLWEhqZ2X6/FghN24Fhkr4mgfkhsynmbANctcQLjxIYCpv4wbYeiF8hnJS0NCmWKzYIuAuMLSNhuV1811wryff5RS06vlWHe4fR5WbK0M+hGiR52SRa54HXzPxovyF24O2bIVla0x/hwOt7+l3RPr8ksLTI/9v/GyfcXsIpsOcOAAAAAElFTkSuQmCC"

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAUlJREFUWEftmDFKBEEQRd/HQBQRTEQTDyCYGRiZiCYamu0JPIoX8ARqsukaGXoBMRbEzMBE0ESDksIdaDaYrnE7WqrT/n+q5tNdv6pFYJnZOrBUQL8kfQeomNkysFpgfyR91riqAXzfzJ6AvQI7knQb5F4AVwX2TtJZjZuJpWJ5xvpuSd7KQh2Z2RYwqdSVXWClUR37AJ774kna98R2gNdawZvZn6fAVkPJ16Ildijpofrrf3Z2Dowj2A7TKeYGezqA+BZNauqzbntHwEY0hqRxyCujH2yJy8SGqpmKpWJDFRiKzzO2OIpNZ0YfsaLrxb3P/T9CMDOfR0fAdgTvGEmX/+0uTiTdRwKZmSd1HcHOmnj2Y1HVurZnE7ipkA6AtUat9TvwWGmtj0N1LKekQsZUrBAjn6F6L7SZ5cOdKzTPJN7ujEUrdkvcL8qXCTY40L+jAAAAAElFTkSuQmCC"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAgFJREFUaEPtWUtKA0EQfQ8/BFFwKbhQT6Bu3Gpu4A3UE5gj6AnUG+QI8Qa6dKVbNxrFhTsJBEQIPinowDAx091DJjqhazOLqaquV1U9XfOaqLmw5vEjAfjrCqYK/OsKSFoFsAHAnkXSJfkSC0ZSw/lf89i+k3z8TWdsC0laAfAaEPzQ7xXJVgwISfcAdgJtbkg287pFALYBPAQ6N7VrkocR+pCkGH0ACyQHWZsiAHsA7pxyzwPmBkCHZAxgA2CADwqqYK1riRzKEsnPMgBuSdpCU5dclRKAVIHYDKQWchmr/SaO/sbHtso4/VwLNUh+hX5G1wG8OeVzkmeTCirGjyQ7W+ws6JEcGWkKp1FJlwA2AbRIdmMWnpSuO+xsRGmTbAePEpMKoGo/6X+g6gz7/KcK+DJU9ftUgaoz7POfKuDLUNXvUwWqzrDP/+xWQNKiYyWMt2mSNOZh6uIGylM3zJ0ED3OStgA8/YNx+tlNxCA50jGhvFDt/8gSgLKbJ7ESs8JK1H4PPJDcLdvHZe3cBctHxr40ueuLwagPo146PsXse0kXAIxiN+YjRKIAZA+yEOfRbVbigmOO5Hc2GB8vZOPDfkD0dgFyXKICxvMcBfg3lV/JNe8w5y7i7DJunAxI9gODGFGTNA9g2WPfz18tDfW9AMoGNi27BGBamR63Tu0r8ANBmAhAl9fZQAAAAABJRU5ErkJggg=="

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAA6BJREFUWEfVmctLVHEUxz8WJL1Ic9EDx+iB0mORRIE5UWALk2xRoBAhQSC0roUL+wvEdeBs2rRoYUiFQmgUBoGVDWLFOFim0WPsJZXVQA++ca+Mt5m59/7ueMkDAw73nPP7zPF3f7/zKCK4rAI2A2sA/W1/5PlLxmcGeG59N161yNCyDNgKVABrffr4ALwAngHvfdriF7gU2GNF1K+tk+23FfH7gKLvSbwuqn/zXmAb+P6RbiC/gATwEJh1U/YCXA4cBpa5OQv4PA30Ay/z+XED3gnUAEsCwng1V7TvAMlcBvmA9wO7vK5UYL1h4EE2n7mAtwMHCgzh190g8NRplA14HdAY4jbI9UO0PW4AbzIVnMArgePAcr/hWCD9b8BV4Kvt3wl8BIiYLJ5IJM7G4/Gx5ubmAae9npWWlpbV1tZ2JpNJQfiRKaAvG/AGayv4cTanOzk5eW50dHSsoaHhutOBnkUikcrp6ekpQ2j5fC2/mRE+Bqw3ogXcgEtKSsqKi4tXzMzMvDOA1j6+lgmsvKDOFFZ2bsDSaW9vvxKLxc4bQt8EJuwIC1bQxuIFuKKiorOlpaVc0BMTE4mqqqqLPhYcA24LWLdYS9Cr1yuwAAUdjUYjra2t93wA66S4LOBAL5u9oB9gH5BO1R4B7wN2B3Dy1zQk4LiAjc/ezB8ZEvCUgE8AqiACSUjAKQGfAlYEog1vS3wW8Blg6SIB/ing00GPtBBfurSAm4CSRRLhTwI+CmxcJMCvBBz4Wg5xS4wLWJeGLo9AEtKxNiRgncE6i31JKpW60NPT02/nAyEBd9vZ2kmrJ+YZenBwsCkajdbFYrFLgg4BeC75EeQhoNIzraU4PDx8urq6ukbQ9fX1+/NVHDJReul3jQz9J8BdO8LGCbwNnU6nZwcGBm7lKpEKADwvgZc/45zChu7r67uxQMD/lEgCVrWszM1Ient7G0dGRqba2triTgddXV01yWTyfUdHh6oGE8lahMpRQS4RE6I8NjnLfNn8b42U70B3vkaKoFXqK9JhdSxzBVetKm2Ft5kK/3MzUG1XNbrnSb52axTYUeD96NWdXtyhbMpuDW2NCA4WIsH3SPpTvQdgPJe+G7Ds1H7VyEAv5EKK5hu6HFL5FvECLPtioBrQCCFwOeUAUlQfA4+AH24R8Qps+1ltTZN0lfu1dbJo7KVZnfbqZzdQ+7npokpJtwCbDAeLk9Y+XfDBYrZAeB3dfrQmoBrnGssfkKfHZSh7t+oAAAAASUVORK5CYII="

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(411),
  /* scopeId */
  "data-v-2ba35adc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5b12a402", content, true);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(70);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".liveanser[data-v-2ba35adc]{width:100%;height:100%;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7);z-index:2000}.liveanser .liveanserbg[data-v-2ba35adc]{position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7)}.liveanser .liveanserContent[data-v-2ba35adc]{position:absolute;top:28vw;left:50%;width:80%;transform:translateX(-50%);background-color:#fff;border-radius:12px;overflow:hidden}.liveanser .liveanser-top[data-v-2ba35adc]{padding:12px 16px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #e8eaec}.liveanser .liveanser-top-timeicon[data-v-2ba35adc]{width:22px;height:22px}.liveanser .liveanser-middle[data-v-2ba35adc]{padding:20px 16px}.liveanser .liveanserbtn[data-v-2ba35adc]{width:74px;height:32px;display:inline-block;background:#10a675;border-radius:16px;text-align:center;color:#fff;line-height:32px}.liveanser .anserTextA[data-v-2ba35adc]{width:100%;height:100px;background:#fff;border:1px solid #dee2e9;border-radius:4px;padding:5px 8px;box-sizing:border-box}.liveanser .anserSccussContent[data-v-2ba35adc]{position:absolute;top:50%;left:50%;transform:translate(-50%,-88%);width:200px;height:200px}.liveanser .anserSccussContentBg[data-v-2ba35adc]{width:200px;height:200px;background-image:url(" + escape(__webpack_require__(409)) + ");background-repeat:no-repeat;background-size:100% 100%;text-align:center;animation:liveAnserRotate 3s linear infinite}@keyframes liveAnserRotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.liveanser .anserSccussImg[data-v-2ba35adc]{height:70px;width:70px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.liveanser .anserSccussText[data-v-2ba35adc]{color:#fff;font-size:16px;line-height:24px;position:absolute;top:181px;left:50%;width:133px;transform:translateX(-50%)}.liveanser .ansercontent[data-v-2ba35adc]{margin-left:6px;font-size:14px;color:#202020;display:inline-block;word-break:break-all}.liveanser .anserSccussBtn[data-v-2ba35adc]{width:120px;height:40px;background:linear-gradient(137deg,#73aaff 5%,#0053ff 93%);border-radius:20px;position:absolute;left:50%;top:223px;font-size:14px;text-align:center;line-height:40px;color:#fff;transform:translateX(-50%)}", ""]);

// exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e81c35982912106ab7132abfe3fd7d62.png";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: ['ds_id', 'fans_id', 'uid', 'channel_code', 'LiveanserObj'],
    data: function data() {
        return {
            AnSerOption: [],
            titTypeObj: {
                3: '判断题',
                1: '单选题',
                2: '多选题',
                4: '简答题'
            },
            question: {
                type: 1,
                title: ""
            },
            sigleAnserAnser: '',
            mulitAnserAnser: '',
            rightErrorAnser: '',
            userTextAnswer: '',
            currsecond: 0,
            countdown: 0,
            secodeTimer: null,
            isAnsering: true,
            isSatus: ''
        };
    },

    computed: {
        userInfo: function userInfo() {
            return {
                ds_id: this.ds_id,
                fans_id: this.fans_id,
                direct_status: this.direct_status
            };
        },
        timeoutStr: function timeoutStr() {
            if (this.countdown > 0) {
                var min = parseInt(this.countdown / 60);
                var second = parseInt(this.countdown % 60);
                return (min < 10 ? '0' + min : min) + ":" + (second < 10 ? '0' + second : second);
            }
            return "00:00";
        }
    },
    watch: {
        LiveanserObj: {
            handler: function handler(newValue, oldValue) {
                console.error("newValue", newValue);
                if (newValue && newValue.lqid) {
                    this.getQuestion();
                }
            },
            immediate: true //第一次刷新页面时就会执行
        }
    },
    mounted: function mounted() {},

    methods: {
        ikonwnTap: function ikonwnTap() {
            this.$emit("hideOrShowPop", false);
        },
        resetData: function resetData() {
            this.sigleAnserAnser = '';
            this.mulitAnserAnser = '';
            this.rightErrorAnser = '';
            this.userTextAnswer = '';
            this.countdown = 0;
            this.currsecond = 0;
            this.isAnsering = true;
            this.isSatus = '';
        },
        getQuestion: function getQuestion() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params, res;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.resetData();
                                _context.prev = 1;
                                params = "lqid=" + _this.LiveanserObj.lqid + '&qpid=' + _this.LiveanserObj.qpid + '&org_id=' + _this.uid;
                                _context.next = 5;
                                return _this.axios.post(_Tools2.default.baseUrlSchool() + "/ds/user/question", params);

                            case 5:
                                res = _context.sent;

                                if (res && res.data && res.data.code == 200) {
                                    _this.question = res.data.data;
                                    if (_this.question.type == 3) {
                                        _this.AnSerOption = [{ key: "A", content: "正确" }, { key: "B", content: "错误" }];
                                    } else {
                                        _this.AnSerOption = res.data.data.option;
                                    }
                                    _this.currsecond = _this.question.second;
                                    _this.countdown = _this.question.countdown;
                                    _this.$emit("hideOrShowPop", true);
                                    _this.daojishi();
                                }
                                _context.next = 11;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](1);

                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 9]]);
            }))();
        },
        daojishi: function daojishi() {
            var _this2 = this;

            if (this.secodeTimer) {
                clearInterval(this.secodeTimer);
                this.secodeTimer = null;
            }

            if (this.currsecond > 0 && this.countdown > 0) {
                this.secodeTimer = setInterval(function () {
                    var i = parseInt(_this2.countdown);
                    if (i == 0) {
                        clearInterval(_this2.secodeTimer);
                        _this2.secodeTimer = null;
                        _this2.$emit("hideOrShowPop", false);
                        return;
                    }
                    _this2.countdown = _this2.countdown - 1;
                }, 1000);
            }
        },
        commitAnserTap: function commitAnserTap() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var answerTmp, question_answer, params, res;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                //暂停倒计时
                                if (_this3.secodeTimer) {
                                    clearInterval(_this3.secodeTimer);
                                    _this3.secodeTimer = null;
                                }
                                answerTmp = "";

                                _this3.isSatus = 3;

                                if (!(_this3.question.type == 1)) {
                                    _context2.next = 10;
                                    break;
                                }

                                if (_this3.sigleAnserAnser) {
                                    _context2.next = 7;
                                    break;
                                }

                                (0, _toast2.default)("请选择答案");
                                return _context2.abrupt("return");

                            case 7:
                                answerTmp = _this3.sigleAnserAnser;
                                _context2.next = 29;
                                break;

                            case 10:
                                if (!(_this3.question.type == 2)) {
                                    _context2.next = 17;
                                    break;
                                }

                                if (_this3.mulitAnserAnser) {
                                    _context2.next = 14;
                                    break;
                                }

                                (0, _toast2.default)("请选择答案");
                                return _context2.abrupt("return");

                            case 14:
                                answerTmp = _this3.mulitAnserAnser;
                                _context2.next = 29;
                                break;

                            case 17:
                                if (!(_this3.question.type == 3)) {
                                    _context2.next = 24;
                                    break;
                                }

                                if (_this3.rightErrorAnser) {
                                    _context2.next = 21;
                                    break;
                                }

                                (0, _toast2.default)("请选择答案");
                                return _context2.abrupt("return");

                            case 21:
                                answerTmp = _this3.rightErrorAnser == 'A' ? 1 : 2;
                                _context2.next = 29;
                                break;

                            case 24:
                                if (!(_this3.question.type == 4)) {
                                    _context2.next = 29;
                                    break;
                                }

                                if (_this3.userTextAnswer) {
                                    _context2.next = 28;
                                    break;
                                }

                                (0, _toast2.default)("请填写答案");
                                return _context2.abrupt("return");

                            case 28:
                                answerTmp = _this3.userTextAnswer;

                            case 29:

                                if (_this3.question.type != 4) {
                                    question_answer = _this3.question.answer;

                                    if (_this3.question.type != 3) {
                                        question_answer = JSON.parse(question_answer).sort().join(",");
                                    }
                                    if (answerTmp == question_answer) {
                                        _this3.isSatus = 1;
                                    } else {
                                        _this3.isSatus = 2;
                                    }
                                    console.error("res=====data==question_answer", question_answer);
                                }
                                console.error("res=====data", answerTmp);
                                if (_this3.isSatus == 1) {
                                    //回答正确
                                    _this3.isAnsering = false;
                                } else if (_this3.isSatus == 2) {
                                    //回答错误
                                    _this3.isAnsering = false;
                                } else {
                                    $emit;
                                }

                                _context2.prev = 32;
                                params = {
                                    org_id: _this3.uid,
                                    dsid: _this3.ds_id,
                                    qpid: _this3.LiveanserObj.qpid,
                                    lqid: _this3.LiveanserObj.lqid,
                                    fans_id: _this3.fans_id,
                                    answer: answerTmp,
                                    status: _this3.isSatus,
                                    channel_code: _this3.channel_code
                                };
                                _context2.next = 36;
                                return _this3.axios.post(_Tools2.default.baseUrlSchool() + "/ds/user/answer", _qs2.default.stringify(params));

                            case 36:
                                res = _context2.sent;

                                if (res && res.data && res.data.code == 200) {
                                    console.error("res=====data", res.data.data);
                                    _this3.question = res.data.data;
                                    _this3.AnSerOption = res.data.data.option;
                                } else {}
                                _context2.next = 42;
                                break;

                            case 40:
                                _context2.prev = 40;
                                _context2.t0 = _context2["catch"](32);

                            case 42:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[32, 40]]);
            }))();
        },
        anserSelect: function anserSelect(item, index) {
            if (this.question.type == 1) {
                //单选题
                this.AnSerOption.forEach(function (element) {
                    element.select = false;
                });
                var currItem = Object.assign({}, item);
                currItem.select = true;
                this.$set(this.AnSerOption, index, currItem);

                this.sigleAnserAnser = item.key;
                console.log("sigleAnserOption", this.sigleAnserAnser);
            } else if (this.question.type == 2) {
                //多选
                var _currItem = Object.assign({}, item);
                _currItem.select = !_currItem.select;
                this.$set(this.AnSerOption, index, _currItem);
                var selectAndser = this.AnSerOption.filter(function (item) {
                    return item.select;
                });
                this.mulitAnserAnser = selectAndser.map(function (item) {
                    return item.key;
                }).join(",");
                console.log("mulitAnserOption", this.mulitAnserAnser);
            } else if (this.question.type == 3) {
                //判断题
                this.AnSerOption.forEach(function (element) {
                    element.select = false;
                });
                var _currItem2 = Object.assign({}, item);
                _currItem2.select = true;
                this.$set(this.AnSerOption, index, _currItem2);
                this.rightErrorAnser = item.key;
            }
        }
    }
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveanser"
  }, [(_vm.isAnsering) ? _c('div', {
    staticClass: "liveanserContent"
  }, [_c('div', {
    staticClass: "liveanser-top"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.titTypeObj[_vm.question.type]))]), _vm._v(" "), (this.question.second != 0) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticClass: "liveanser-top-timeicon",
    attrs: {
      "src": __webpack_require__(412)
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "6px",
      "color": "#202020",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.timeoutStr))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "liveanser-middle"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#202020",
      "line-height": "22px",
      "word-break": "break-all"
    }
  }, [_vm._v(_vm._s(_vm.question.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.question.type != 4) ? _vm._l((_vm.AnSerOption), function(item, index) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "14px",
        "display": "flex",
        "align-items": "center"
      },
      on: {
        "click": function($event) {
          return _vm.anserSelect(item, index)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.select),
        expression: "item.select"
      }],
      staticStyle: {
        "width": "18px",
        "height": "18px"
      },
      attrs: {
        "src": __webpack_require__(413)
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.select),
        expression: "!item.select"
      }],
      staticStyle: {
        "width": "18px",
        "height": "18px"
      },
      attrs: {
        "src": __webpack_require__(414)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ansercontent"
    }, [_vm._v(_vm._s(item.key) + "." + _vm._s(item.content))])])
  }) : _vm._e(), _vm._v(" "), (_vm.question.type == 4) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userTextAnswer),
      expression: "userTextAnswer"
    }],
    staticClass: "anserTextA",
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.userTextAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userTextAnswer = $event.target.value
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "liveanserbtn",
    on: {
      "click": _vm.commitAnserTap
    }
  }, [_vm._v("提交")])])])]) : _vm._e(), _vm._v(" "), (!_vm.isAnsering && _vm.isSatus != 3) ? _c('div', {
    staticClass: "anserSccussContent"
  }, [_c('div', {
    staticClass: "anserSccussContentBg"
  }), _vm._v(" "), (_vm.isSatus == 1) ? _c('img', {
    staticClass: "anserSccussImg",
    attrs: {
      "src": __webpack_require__(415)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSatus == 2) ? _c('img', {
    staticClass: "anserSccussImg",
    attrs: {
      "src": __webpack_require__(416)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "anserSccussText"
  }, [_vm._v(" " + _vm._s(_vm.isSatus == 1 ? "恭喜你，回答正确" : "很遗憾，回答错误"))]), _vm._v(" "), _c('div', {
    staticClass: "anserSccussBtn",
    on: {
      "click": _vm.ikonwnTap
    }
  }, [_vm._v(_vm._s(_vm.isSatus == 1 ? "我知道啦" : "再接再历"))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAPFBMVEUAAAAQp3QQpnUQpnQQpXUQpnQQpnQQpXUQpnQQpnQQpXUQp3gQpnYQpXQQr3AQpnUQpnQQpnUQpXUQpnWRnP25AAAAE3RSTlMAQMDwYICgMODQzyBQsBCQcD9vr+zzmwAAAURJREFUOMulleFyhCAMhAMhIojnefv+71pG2+Zq8NDp/nA0fhOXCAkdVcT7DGTvpdBHhZkBFc/hFHUZQBLnJqLo3JIAZNdEowfGUDnVFEbAR8sWBosNSw2b5C9geFBDjwE4OK8RoRMJMLw/P8HhQ434PXfRL7Vp4Nd3ZOPBOOGfmngM9svxsCa/3ziwqYOH+1sT/g5kNWFhNZJ39yP1YRq3GswIV+CAuV4Z0xV4AtcaI9EVmFINCeQavEA03IMd/D14xHQNjsgE0DW4kqdwacBqw2wzYyOdLJAGpU012rSBFyzUofWnFGRq63CsM5xupA49gXWL9ugnZt38TYnS436Xzs+2ZhIkc2CNitMDa1rBqXt/q8ncaV93GuP9lqu5+81c5Tpjoj+AXjqATPJtli3rWl/HdV22Sef+MTTtOE5A8l5M0i8TSRK7eu/frQAAAABJRU5ErkJggg=="

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAclBMVEUAAAAHwWAAxFoJxF8Av14IwWAIwV8JwmAIwWAHwWAJw14IwV8HwV8Hwl8IwV8Iw2AHwWAIwWAJwmAJwWEHwmAIwWAHwmEEwWEIwWAIwWAIwV8Kwl8HwmAGxGAHwWAIwl8IwV8IwF8IwmAIwGAJwWAIwWAiFBa6AAAAJXRSTlMA+AkbEuzrtJeIN+TUrJZ40r1YV/PLbhbeyJ9PRS0lw7aBfXpavL6vgwAAATVJREFUOMuVlemygyAMRj8UrCJuvbZ2v2ve/xWvONayyFDPr+ickUhCgI1sqlYwJtqqkQiSFiUZlEW6qvGakQOrue/tM1oh+3C9nALklpbsKMguMUTthU1v3ejqe4ow/xHPYmLGJ7GmKPVUD0Yh1Hc/77yuURH0TgOqOSxGsQxm9sCjf9YdkCGvl8BheZJoAh67WVk1qALiH3AzHiuoJT6c6MURGMzsFcQzbMFfKRVuAwiwJRzAz3N8Gb2jnTKY2SXJ5xR9jd6dOaKw8ko6IjonY6DIQsB4we6TqfhK57XW9ij9qYuu65UcKjRul2hS4YqNU8IrJjpykU5TZKn2fj2v9NqsSwDpd2jhN277k/seSzcchfcO17bjGh8AW0dKfEhtH3vxQRofzduHvX99KH19KO/6+AcbFJ/I7gWfOgAAAABJRU5ErkJggg=="

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAATlBMVEUAAADd3d3d3d3d3d3x8fHd3d3d3d3d3d3f39/a2trj4+PX19fd3d3e3t7c3Nzf39/e3t7d3d3////d3d34+Pj6+vry8vLq6urh4eHm5ubRjGTpAAAAEnRSTlMA+OuXBeO0h3g3GxPTq1hX0qz9SrcOAAAA80lEQVQ4y42VW46DMAxFnQTKewZ87STsf6NV1aoCCsTn+0iWE/ua9nTtNHvn/Dy1HV3SNzU21E1/qg3BATlFUWaVmDLgwvDr/XkgCW+QBPj/g1YFYFU+oCsQqp33ACKfEIFHtfOy8CmSt2ZAVr5AM8K3D0D4EgE+HQ0ekW+I8MOn8Mq3rO/ivYPeiwr3+qMGiQskNERUQ0qioCbqkLlIRkctUllMaGlBLIsRE42QsigYyUPLosKTAxuAM4vm0tZmZpqMz2N+cPMXWofCPGbmwbWugnm5rOtqDQBzpJhDyh579iC1R7M97H/OxzK+zse4HM/HEx4ZWF2WCjvHAAAAAElFTkSuQmCC"

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LiveHotel"
    }
  }, [_c('launch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "loaded": _vm.loaded
    },
    on: {
      "closeload": _vm.closeload
    }
  }), _vm._v(" "), (_vm.isShowNoWatchQrCode) ? _c('noWatchTips', {
    attrs: {
      "message": "请使用手机微信扫码打开",
      "ds_id": _vm.ds_id,
      "channel_id": _vm.channel_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isBlack) ? _c('tipsView', {
    attrs: {
      "message": _vm.blackMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isyxinImLoginOut) ? _c('tipsView', {
    attrs: {
      "message": "你在其他端登陆，刷新后可以重新登陆!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.registerViewShow) ? _c('RegisterView', {
    attrs: {
      "fans_id": _vm.fans_id,
      "ds_id": _vm.ds_id
    },
    on: {
      "registerOk": _vm.registerOk,
      "closeload": _vm.registerViewClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.TelTestShow) ? _c('TelTest', {
    staticStyle: {
      "z-index": "9900"
    },
    attrs: {
      "fans_id": _vm.fans_id,
      "ds_id": _vm.ds_id,
      "show_type": _vm.show_type,
      "need_check_bool": _vm.need_check_bool
    },
    on: {
      "whiteNumOk": _vm.whiteNumOk
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showhead),
      expression: "showhead"
    }],
    staticClass: "headtitle",
    style: ('background:' + _vm.headtitleBg)
  }, [_c('p', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.titleName))])]), _vm._v(" "), (_vm.topAD) ? _c('topAd', {
    attrs: {
      "topObj": _vm.topObj
    },
    on: {
      "closeAD": _vm.closeAD
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fullscr && _vm.isIOS) ? _c('div', {
    staticClass: "videoMusk"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    style: ({
      'flex-direction': _vm.threeScreenDirection
    })
  }, [_c('div', {
    staticClass: "player"
  }, [(_vm.showLivePlayer) ? _c('TFPlayer', {
    ref: "tfPlayer",
    attrs: {
      "initData": _vm.initData,
      "fans_id": _vm.fans_id,
      "videoIndex": _vm.videoIndex,
      "selectPlayType": _vm.selectPlayType,
      "showH5Xianlu": _vm.isThreeScreen,
      "isThreeScreen": _vm.isThreeScreen,
      "runObj": _vm.runObj,
      "copyrightObj": _vm.copyrightObj
    },
    on: {
      "statusChange": _vm.playerStatusChange,
      "linkTypeChange": _vm.linkTypeChange,
      "isSupportRTC": _vm.isSupportRTCCallBack,
      "unAutoPlay": _vm.unAutoPlay,
      "playFailed": _vm.playFailed,
      "playerListener": _vm.playerListener,
      "showH5XianluAlert": function($event) {
        _vm.showLiveWay = true
      }
    }
  }) : _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.initData && _vm.initData.direct_seeding.pic_url
    }
  }), _vm._v(" "), (_vm.isShowTeacherBtnTop) ? _c('div', {
    staticClass: "showTeacherBtnTop",
    on: {
      "click": _vm.showTeacherBtnTopClicked
    }
  }, [_c('img', {
    attrs: {
      "src": "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/rad_heart.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hot) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showView),
      expression: "showView"
    }],
    staticClass: "view_num",
    style: ('margin-top:' + _vm.barHeight + 'px')
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/hot_num.png"
    }
  }), _vm._v("\n          " + _vm._s(_vm.view_num) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isThreeScreen) ? _c('div', {
    staticClass: "player"
  }, [_c('whiteboard', {
    ref: "whiteboard",
    attrs: {
      "fans_id": _vm.fans_id,
      "im_type": _vm.im_type,
      "direct_status": _vm.directStatus,
      "ds_id": _vm.ds_id
    },
    on: {
      "errorReport": _vm.errorReport,
      "changPosion": _vm.changeScreenPostion
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "floatBox",
    style: ('margin-top:' + _vm.playHeight + 'px')
  }, [(_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    staticClass: "trySee",
    style: ('opacity:' + _vm.tryOpacity)
  }, [_vm._v("\n      试看" + _vm._s(_vm.tryTime) + "秒，付费观看完整版\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tryPayBtn && !_vm.fullscr),
      expression: "tryPayBtn && !fullscr"
    }],
    staticClass: "tryPay",
    style: ('margin-top:' + _vm.barHeight + 'px'),
    on: {
      "click": _vm.onShowPay
    }
  }, [_vm._v("\n      付费\n    ")]) : _vm._e(), _vm._v(" "), (_vm.openRolling) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRolling),
      expression: "isRolling"
    }],
    staticClass: "scrollbar",
    style: ('margin-top:' + _vm.marqueeheight + 'px' + _vm.marqueeStyle)
  }, [_c('p', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.MerryGoRound),
      expression: "MerryGoRound"
    }]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "window",
    on: {
      "click": _vm.swichWindow
    }
  }, [(_vm.forbid) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-g.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-w.png'
    }
  })]), _vm._v(" "), (_vm.musicStatusexist) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.musicStatus),
      expression: "musicStatus"
    }],
    staticClass: "music",
    class: {
      musicPlay: _vm.musicPlay
    },
    style: ('margin-top:' + _vm.barHeight + 'px'),
    attrs: {
      "id": "music"
    },
    on: {
      "click": _vm.setMusic
    }
  }, [(_vm.musicPlay) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/music.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/music1.png'
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "autoplay": "autoplay",
      "id": "audio",
      "src": _vm.musicUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allot_sale) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPlayUI),
      expression: "!isPlayUI"
    }],
    staticClass: "allot_btn",
    on: {
      "click": _vm.onShowAllot
    }
  }, [_c('span', [_vm._v("邀")]), _vm._v(" "), _c('span', [_vm._v("邀请好友")])]) : _vm._e(), _vm._v(" "), (_vm.shareRedexist) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareRed),
      expression: "shareRed"
    }],
    staticClass: "shareRed",
    attrs: {
      "id": "shareRed"
    }
  }, [_vm._v("\n      分享得\n      "), (_vm.shareType == 0) ? [_vm._v("红包")] : [_vm._v("卡券")]], 2) : _vm._e(), _vm._v(" "), (_vm.talkredexist) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.talkred && !_vm.isPlay),
      expression: "talkred && !isPlay"
    }],
    staticClass: "talkred",
    on: {
      "click": _vm.showtalkredpoup
    }
  }, [(_vm.talkType == 0) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/passred.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/passcard.png'
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.openShop) ? _c('salesList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr && !_vm.forbid && !_vm.isPlay),
      expression: "!fullscr && !forbid && !isPlay"
    }],
    attrs: {
      "fans_id": _vm.fans_id,
      "playHeight": _vm.playHeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.haveNav) ? _c('pieceWise', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr),
      expression: "!fullscr"
    }],
    attrs: {
      "currLiveDic": _vm.currLiveDic,
      "playHeight": _vm.playHeight,
      "dsId": _vm.ds_id,
      "breakPoint": _vm.breakPoint,
      "styleType": _vm.styleType,
      "videoIndex": _vm.videoIndex
    },
    on: {
      "switchVideo": _vm.switchVideo
    }
  }) : _vm._e(), _vm._v(" "), (_vm.openShop && _vm.fans_id) ? _c('Top', {
    ref: "top",
    attrs: {
      "fans_id": _vm.fans_id,
      "playHeight": _vm.playHeight,
      "pieceHeight": _vm.pieceHeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.adImages.length != 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAd),
      expression: "isShowAd"
    }],
    staticClass: "banner",
    style: ({
      'margin-top': (_vm.playHeight + _vm.pieceHeight + _vm.salesHeight) + 'px',
      'height': _vm.bannerHeight + 'px'
    })
  }, [_c('van-swipe', {
    attrs: {
      "autoplay": 5000,
      "show-indicators": false,
      "height": _vm.bannerHeight
    }
  }, _vm._l((_vm.adImages), function(item, index) {
    return _c('van-swipe-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.adJumpItemTap(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    })])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.haveMenu) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "menu",
    class: {
      noline: _vm.initData && _vm.initData.direct_seeding.play_style != 3
    },
    style: ('margin-top:' +
      (_vm.playHeight + _vm.pieceHeight + _vm.salesHeight + _vm.bannerHeight) +
      'px')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initData && _vm.initData.direct_seeding.play_style == 3),
      expression: "initData && initData.direct_seeding.play_style == 3"
    }],
    staticClass: "leftFocus",
    on: {
      "click": function($event) {
        _vm.showLiveWay = true
      }
    }
  }, [_vm._v("\n        线路\n      ")]), _vm._v(" "), _c('van-tabs', {
    class: 'menu' + _vm.styleType,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-render": false,
      "lineWidth": _vm.navitemWidth,
      "sticky": "",
      "animated": ""
    },
    on: {
      "click": _vm.handleTabClick
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openRolling),
      expression: "openRolling"
    }],
    staticClass: "scrollbar",
    staticStyle: {
      "z-index": "10000",
      "background": "#ffeabd",
      "height": "30px",
      "line-height": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#814000",
      "line-height": "30px"
    }
  }, [_vm._v(_vm._s(_vm.MerryGoRound))])]), _vm._v(" "), _vm._l((_vm.dsMenu), function(item, index) {
    return _c('van-tab', {
      key: index,
      style: (_vm.contentStyle),
      attrs: {
        "title": item.name
      }
    }, [_c('div', {
      staticClass: "home-content",
      style: (_vm.contentStyle)
    }, [(item.cid == 1) ? _c('ChatRoom', {
      ref: "chat",
      refInFor: true,
      attrs: {
        "fans_id": _vm.fans_id,
        "mid": item.mid,
        "dsId": _vm.ds_id,
        "currentMid": _vm.currentMid,
        "playerStatus": _vm.playerStatus,
        "linkType": _vm.linkType,
        "initData": _vm.initData,
        "forbid": _vm.forbid,
        "channel_code": _vm.channel_REL_ID,
        "isLoadHistory": _vm.isLoadHistory,
        "totalLike": _vm.totalLike,
        "dynamicData": _vm.dynamicData,
        "startTime": _vm.startTime,
        "directStatus": _vm.directStatus,
        "openWx_follow": _vm.openWx_follow,
        "isshowCart": _vm.isshowCart,
        "showTeacherBtn": _vm.showTeacherBtn,
        "noticeObj": _vm.noticeObj
      },
      on: {
        "personnum": _vm.personnum,
        "robRedBagAction": _vm.robRedBagAction,
        "sendApplyLink": _vm.sendApplyLink,
        "sendEndLink": _vm.sendEndLink,
        "onShowTeacherList": _vm.onShowTeacherList,
        "onShowGoodsList": _vm.onShowGoodsList,
        "onShowFouceAlert": _vm.onShowFouceAlert
      }
    }) : (item.cid == 2) ? _c('Vote', {
      attrs: {
        "mid": item.mid,
        "vid": _vm.vid,
        "currentMid": _vm.currentMid
      },
      on: {
        "switchSider": _vm.switchSider
      }
    }) : (item.cid == 3) ? _c('ImgText', {
      attrs: {
        "mid": item.mid,
        "currentMid": _vm.currentMid,
        "uid": _vm.uid,
        "fans_id": _vm.fans_id
      }
    }) : (item.cid == 4) ? _c('List', {
      attrs: {
        "toplist": _vm.toplist,
        "fans_id": _vm.fans_id,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 5) ? _c('EmbeddedWeb', {
      attrs: {
        "resuouce": item.content,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 6) ? _c('shake', {
      attrs: {
        "dispark": _vm.dispark,
        "initData": _vm.initData,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 7) ? _c('VideoReView', {
      attrs: {
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 8) ? _c('special', {
      attrs: {
        "breakPoint": _vm.breakPoint,
        "dsId": _vm.ds_id,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      },
      on: {
        "switchVideo": _vm.switchVideo
      }
    }) : (item.cid == 9) ? _c('Store', {
      attrs: {
        "resuouce": _vm.StoreUrl
      }
    }) : _vm._e()], 1)])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isThreeScreen) ? _c('div', {
    staticClass: "home-content",
    style: (_vm.contentStyle)
  }, [_vm._l((_vm.dsMenu), function(item, index) {
    return [(item.cid == 1) ? _c('ChatRoom', {
      ref: "chat",
      refInFor: true,
      attrs: {
        "fans_id": _vm.fans_id,
        "mid": item.mid,
        "dsId": _vm.ds_id,
        "currentMid": _vm.currentMid,
        "playerStatus": _vm.playerStatus,
        "linkType": _vm.linkType,
        "initData": _vm.initData,
        "forbid": _vm.forbid,
        "channel_code": _vm.channel_REL_ID,
        "isLoadHistory": _vm.isLoadHistory,
        "totalLike": _vm.totalLike,
        "dynamicData": _vm.dynamicData,
        "startTime": _vm.startTime,
        "directStatus": _vm.directStatus,
        "openWx_follow": _vm.openWx_follow,
        "isshowCart": _vm.isshowCart,
        "showTeacherBtn": _vm.showTeacherBtn,
        "noticeObj": _vm.noticeObj,
        "isThreeScreen": _vm.isThreeScreen
      },
      on: {
        "personnum": _vm.personnum,
        "robRedBagAction": _vm.robRedBagAction,
        "sendApplyLink": _vm.sendApplyLink,
        "sendEndLink": _vm.sendEndLink,
        "onShowTeacherList": _vm.onShowTeacherList,
        "onShowGoodsList": _vm.onShowGoodsList,
        "onShowFouceAlert": _vm.onShowFouceAlert,
        "changeVideoLine": function($event) {
          _vm.showLiveWay = true
        }
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), [_c('leftBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr),
      expression: "!fullscr"
    }],
    ref: "left",
    attrs: {
      "curCid": _vm.curCid,
      "voteList": _vm.voteList,
      "showBigTable": _vm.showBigTable,
      "isPlay": _vm.isPlay,
      "TstartTime": _vm.TstartTime,
      "Tend_time": _vm.Tend_time,
      "fans_id": _vm.fans_id
    }
  }), _vm._v(" "), _c('rightBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "right",
    attrs: {
      "styleType": _vm.styleType,
      "fans_id": _vm.fans_id,
      "headerUrl": _vm.headerUrl
    }
  }), _vm._v(" "), _c('toolBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCid == 1 && !_vm.fullscr),
      expression: "curCid == 1 && !fullscr"
    }],
    ref: "toolbar",
    attrs: {
      "styleType": _vm.styleType,
      "isWeixin": _vm.isWeixin,
      "picComment": _vm.picComment,
      "isshowgift": _vm.isshowgift,
      "verify_comment": _vm.verify_comment,
      "commentList": _vm.commentList,
      "isIOS": _vm.isIOS,
      "fans_id": _vm.fans_id,
      "isMaster": _vm.isMaster,
      "giftList": _vm.giftList,
      "wallSign": _vm.wallSign,
      "wall_id": _vm.wall_id,
      "payPrice": _vm.payPrice,
      "directStatus": _vm.directStatus,
      "is_all_users_muted": _vm.is_all_users_muted,
      "say_self": _vm.say_self
    },
    on: {
      "switchSider": _vm.switchSider,
      "showtalk": _vm.showtalk,
      "colsetalkred": _vm.colsetalkred,
      "loginIM": _vm.loginIM
    }
  }), _vm._v(" "), _c('ConsultTeacher', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConsultTeacher),
      expression: "showConsultTeacher"
    }],
    ref: "consultTeacher",
    attrs: {
      "dsId": _vm.ds_id,
      "fansId": _vm.fans_id,
      "tid": _vm.tid
    },
    on: {
      "closeBtnClicked": _vm.consultTeacherCloseBtnClicked
    }
  }), _vm._v(" "), _c('goodsList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGoods),
      expression: "showGoods"
    }],
    ref: "goodsList",
    attrs: {
      "dsId": _vm.ds_id,
      "fansId": _vm.fans_id,
      "tid": _vm.tid,
      "gid": _vm.gid,
      "uid": _vm.uid,
      "channel_id": _vm.channel_id,
      "goodsIds": _vm.goodsIdsList
    },
    on: {
      "closeBtnClicked": _vm.goodsListCloseBtnClicked
    }
  })], _vm._v(" "), (!_vm.fullscr) ? _c('redRain', {
    ref: "redrain",
    attrs: {
      "rainProbab": _vm.rainProbab,
      "rainId": _vm.rainId,
      "fans_id": _vm.fans_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.openShop) ? _c('buyList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr && !_vm.forbid),
      expression: "!fullscr && !forbid"
    }],
    attrs: {
      "buyList": _vm.buyList,
      "buyListIndex": _vm.buyListIndex
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowLoginErr) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "z-index": "1911",
      "background": "rgba(0, 0, 0, 0.84)"
    },
    style: (_vm.loginErrroStyle)
  }, [_c('van-button', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.tryLogin
    }
  }, [_vm._v("重新登录")])], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "overflow": "visible"
    },
    model: {
      value: (_vm.talkredstatus),
      callback: function($$v) {
        _vm.talkredstatus = $$v
      },
      expression: "talkredstatus"
    }
  }, [_c('div', {
    staticClass: "sharebao"
  }, [_c('img', {
    staticClass: "gold",
    attrs: {
      "src": _vm.imgPath + 'home/gold.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sharehead",
    style: ('background-image:url(' + _vm.imgPath + 'home/sharebg.jpg)')
  }, [_c('div', {
    staticClass: "height25"
  }), _vm._v(" "), (_vm.talkType == 0) ? _c('p', [_vm._v("口令红包")]) : _c('p', [_vm._v("口令卡券")]), _vm._v(" "), (_vm.talkType == 0) ? _c('p', {
    staticClass: "loll"
  }, [_vm._v("发送口令得红包")]) : _c('p', {
    staticClass: "loll"
  }, [_vm._v("发送口令得卡券")])]), _vm._v(" "), _c('div', {
    staticClass: "talktext"
  }, [_vm._v(_vm._s(_vm.talktext))]), _vm._v(" "), _c('div', {
    staticClass: "sharebody"
  }, [_c('p', [_vm._v("\n          中奖条件：发送口令即有机会获得\n          "), (_vm.talkType == 0) ? _c('span', [_vm._v("红包")]) : _c('span', [_vm._v("卡券")])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.sedTalk
    }
  }, [_vm._v("发送口令")])])])]), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "overflow": "visible"
    },
    model: {
      value: (_vm.rewardredpack),
      callback: function($$v) {
        _vm.rewardredpack = $$v
      },
      expression: "rewardredpack"
    }
  }, [_c('div', {
    staticClass: "sharebao"
  }, [_c('img', {
    staticClass: "gold",
    attrs: {
      "src": _vm.imgPath + 'home/gold.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sharehead"
  }, [_c('div', {
    staticClass: "height25"
  }), _vm._v(" "), (_vm.rewardType == 1) ? _c('p', [_vm._v("口令红包")]) : [_c('p', [_vm._v("分享红包")]), _vm._v(" "), _c('p', {
    staticClass: "loll"
  }, [_vm._v("分享直播得红包")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sharebody"
  }, [_c('p', [_vm._v("红包金额：")]), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v("\n          " + _vm._s(_vm.rewardMoney / 100) + "\n          "), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('p', [_vm._v("\n          中奖说明：红包已存入钱包，可\n          "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.cash
    }
  }, [_vm._v("提现")])], 1), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.closeRedpack
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.rewardQuan),
      callback: function($$v) {
        _vm.rewardQuan = $$v
      },
      expression: "rewardQuan"
    }
  }, [_c('div', {
    staticClass: "sharebao"
  }, [_c('div', {
    staticClass: "sharehead"
  }, [(_vm.rewardType == 1) ? [_c('p', [_vm._v("口令卡券")]), _vm._v(" "), _c('p', {
    staticClass: "loll"
  }, [_vm._v("发送口令得卡券")])] : [_c('p', [_vm._v("分享卡券")]), _vm._v(" "), _c('p', {
    staticClass: "loll"
  }, [_vm._v("分享直播得卡券")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sharebody"
  }, [_c('p', [_vm._v("恭喜您获得")]), _vm._v(" "), (_vm.quanData) ? _c('p', {
    staticClass: "money"
  }, [_vm._v("\n          “" + _vm._s(_vm.quanData.coupon_title) + "”\n          "), _c('span', [_vm._v("1张")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n          中奖说明：卡券已存入“个人中心”-“我的卡包”\n          "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.cards
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.closeQuan
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "paydialog",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.showPay),
      callback: function($$v) {
        _vm.showPay = $$v
      },
      expression: "showPay"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("付费观看")]), _vm._v(" "), _c('div', {
    staticClass: "payContent"
  }, [_c('div', {
    staticClass: "tryBox"
  }, [_c('span', {
    staticClass: "moneyIcon"
  }, [_vm._v("￥")]), _vm._v(" "), (_vm.payIndex >= 0) ? _c('span', {
    staticClass: "money"
  }, [(_vm.tryPrice >= parseInt(_vm.coupons[_vm.payIndex].money) / 100) ? [_vm._v(_vm._s((_vm.tryPrice - _vm.coupons[_vm.payIndex].money) / 100))] : [_vm._v("0")]], 2) : _c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.tryPrice / 100))]), _vm._v(" "), (_vm.payIndex >= 0) ? _c('span', {
    staticClass: "oldMoney"
  }, [_vm._v(_vm._s(_vm.tryPrice / 100))]) : _vm._e()]), _vm._v(" "), (_vm.coupons.length) ? _c('ul', {
    staticClass: "coupons"
  }, [_vm._l((_vm.coupons), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        cur: _vm.payIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.select(index, item.id)
        }
      }
    }, [_c('i'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.money / 100) + "元门票券")])])
  }), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.payIndex == -1
    },
    on: {
      "click": function($event) {
        return _vm.select(-1, 0)
      }
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("不使用")])])], 2) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.couponText),
      expression: "couponText"
    }],
    staticClass: "explain"
  }, [_vm._v("说明：" + _vm._s(_vm.couponText))])]), _vm._v(" "), _c('div', {
    staticClass: "twobtn"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.payCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "sure",
    on: {
      "click": _vm.tryPay
    }
  }, [_vm._v("确认购买")])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.showrobRedlist),
      callback: function($$v) {
        _vm.showrobRedlist = $$v
      },
      expression: "showrobRedlist"
    }
  }, [_c('robRedBaglist', {
    attrs: {
      "man": _vm.redBagData,
      "list": _vm.redBaglistData
    },
    on: {
      "close": _vm.closeRodRedList
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllot),
      expression: "showAllot"
    }],
    staticClass: "musk2",
    on: {
      "click": _vm.onCloseAllot
    }
  }, [_c('div', {
    staticClass: "box allot"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.canvas),
      expression: "!canvas"
    }],
    staticClass: "shareCard",
    attrs: {
      "id": "shareCard"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.base64Img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "allot_title"
  }, [_vm._v("\n          " + _vm._s(_vm.allot.title) + "\n          "), _c('span', [_vm._v("精选课程")])]), _vm._v(" "), _c('div', {
    staticClass: "allot_price"
  }, [_c('span', {
    staticClass: "yuan"
  }, [_vm._v("￥")]), _vm._v("\n          " + _vm._s(_vm.allot.price / 100) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "allot_ul"
  }, [_vm._v("\n          邀请收益：¥ " + _vm._s(_vm.allot.allot_money / 100) + " / 人\n          "), _c('span'), _vm._v("\n          收益比例：" + _vm._s(_vm.allot.rate * 100) + "％\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "allot_dashed"
  }, [_c('div', {
    staticClass: "allot_dasheds"
  }, _vm._l((30), function(item, index) {
    return _c('span', {
      key: index
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "userInfo clearfix"
  }, [_c('div', {
    staticClass: "userImg fl"
  }, [_c('img', {
    attrs: {
      "src": _vm.headerData,
      "crossorigin": "anonymous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name fl"
  }, [(_vm.fans) ? _c('span', {
    staticClass: "colors"
  }, [_vm._v(_vm._s(_vm.fans.nick))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("给你分享了一堂好课程")]), _vm._v(" "), _c('p', [_vm._v("长按扫码购买")])]), _vm._v(" "), _c('div', {
    staticClass: "code fr"
  }, [_c('img', {
    attrs: {
      "src": _vm.code
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvas),
      expression: "canvas"
    }],
    staticClass: "allot_canvas",
    attrs: {
      "src": _vm.canvas,
      "crossorigin": "anonymous"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "allot_tip"
  }, [_vm._v("长按保存图片，或发送给朋友")])]), _vm._v(" "), _c('div', {
    staticClass: "weixincode"
  }, [_c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/title-popup.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.weixintopText))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/title-popup.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "130px"
    },
    attrs: {
      "src": _vm.weixincodeUrl
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#353535",
      "font-size": "13px",
      "margin-top": "10px"
    }
  }, [_vm._v("\n            - " + _vm._s(_vm.weixinbottomText) + " -\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.isShowQRimg = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.showLiveWay),
      callback: function($$v) {
        _vm.showLiveWay = $$v
      },
      expression: "showLiveWay"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body live-way"
  }, [_c('p', [(_vm.selectPlayType == 2) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tid),
      expression: "!tid"
    }]
  }, [(_vm.selectPlayType == 1) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")])], 1), _vm._v(" "), _c('p', [(_vm.selectPlayType == 3) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.showLiveWay = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.isShowTeacherQrCode),
      callback: function($$v) {
        _vm.isShowTeacherQrCode = $$v
      },
      expression: "isShowTeacherQrCode"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.teacher_qrcode_title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "375px"
    },
    attrs: {
      "src": _vm.teacher_qrcode_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    staticStyle: {
      "background": "#f56c6c",
      "color": "white"
    },
    on: {
      "click": _vm.showTeacherQrCodeCliced
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showQQPopUp),
      callback: function($$v) {
        _vm.showQQPopUp = $$v
      },
      expression: "showQQPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("授权登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "padding": "20px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.mploginTap
    }
  }, [_c('img', {
    staticClass: "qqlogoImg",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/weChat.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("微信登录")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.qqloginTap
    }
  }, [_c('img', {
    staticClass: "qqlogoImg",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/QQ1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("QQ登录")])])])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.isShowMPJumpAlert),
      callback: function($$v) {
        _vm.isShowMPJumpAlert = $$v
      },
      expression: "isShowMPJumpAlert"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n             即将打开小程序，进行听课\n          ")]), _vm._v(" "), (_vm.isWeixin) ? _c('div', {
    staticStyle: {
      "margin-top": "35px",
      "text-align": "center"
    }
  }, [_c('wx-open-launch-weapp', {
    attrs: {
      "id": "launch-btn",
      "username": _vm.miniConfig.mp_1v1_orgin_id,
      "path": _vm.weappPathData
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n              <style>.mpbtn {\n                        background: #07c160;\n                        margin: auto;\n                        border: none;\n                        border-radius: 10px;\n                        color: #ffffff;\n                        padding: 0px 70px;\n                        height: 44px;\n                        font-size:14px;\n                        line-height: 44px;\n                    }</style>\n                <button class=\"mpbtn\">跳转</button>\n              ")])])], 1) : _c('div', {
    staticStyle: {
      "margin-top": "35px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "padding": "0px 70px",
      "height": "44px",
      "line-height": "44px"
    },
    attrs: {
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.mploginJump
    }
  }, [_vm._v("跳转")])], 1)])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "onlineSchoolLogin",
    style: ({
      width: '100%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showLineSchoolPopUp),
      callback: function($$v) {
        _vm.showLineSchoolPopUp = $$v
      },
      expression: "showLineSchoolPopUp"
    }
  }, [_c('div', {
    staticClass: "onlineSchoolLoginWay"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("网校账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("此课程为VIP课程，需要登录后观看")]), _vm._v(" "), _c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "account"
  }, [_c('span', {
    staticClass: "area"
  }, [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolAccount),
      expression: "onlineSchoolAccount"
    }],
    staticClass: "loginInput",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.onlineSchoolAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.loginType == 1) ? _c('div', {
    staticClass: "account"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolPassword),
      expression: "onlineSchoolPassword"
    }],
    staticClass: "loginInput",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.onlineSchoolPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolPassword = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onLIneSchoolSMSCode),
      expression: "onLIneSchoolSMSCode"
    }],
    staticClass: "loginInput passwordInput",
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.onLIneSchoolSMSCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onLIneSchoolSMSCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('van-button', {
    staticClass: "sendBtn",
    attrs: {
      "size": "small",
      "disabled": _vm.onlineSendMsgNum != 0,
      "type": "primary"
    },
    on: {
      "click": _vm.onlineLineSchoolSendMsg
    }
  }, [_vm._v(_vm._s(_vm.onlineSednMsgText))])], 1), _vm._v(" "), (_vm.loginType == 1) ? _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolPWDLoginClick
    }
  }, [_vm._v("网校登录")]) : _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolLoginClick
    }
  }, [_vm._v("网校登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#10a675",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        _vm.loginType == 1 ? (_vm.loginType = 2) : (_vm.loginType = 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.loginType == 1 ? "验证码登录" : "账号密码登录"))])])], 1)])])], 1), _vm._v(" "), _c('LinkPopup', {
    attrs: {
      "isShow": _vm.linkDialogVisible,
      "linkType": _vm.linkType
    },
    on: {
      "accept": _vm.linkAccept,
      "refuse": _vm.linkRefuse
    }
  }), _vm._v(" "), (_vm.tosafariShow) ? _c('div', {
    staticClass: "tosafari"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "https://tengface-project.oss-cn-shenzhen.aliyuncs.com/tmp/quxiaofei.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.tosafariShow = false
      }
    }
  }, [_vm._v("我不需要连麦")])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowLiveAnser) ? _c('liveanserPopup', {
    attrs: {
      "ds_id": _vm.ds_id,
      "channel_code": _vm.channel_id,
      "fans_id": _vm.fans_id,
      "uid": _vm.uid,
      "LiveanserObj": _vm.LiveanserObj
    },
    on: {
      "hideOrShowPop": _vm.hideliveAnser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShoppingType) ? _c('div', {
    staticClass: "shopping-cart",
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_c('div', {
    staticClass: "goods-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsInfo.cover,
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "pirce"
  }, [_c('span', [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))]), _vm._v(" "), _c('span', {
    staticClass: "go"
  }, [_vm._v("抢")])]), _vm._v(" "), _c('van-icon', {
    staticClass: "close",
    attrs: {
      "name": "cross"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showShoppingType = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "shopping-dialog",
    model: {
      value: (_vm.showShoppingDialog),
      callback: function($$v) {
        _vm.showShoppingDialog = $$v
      },
      expression: "showShoppingDialog"
    }
  }, [_c('div', {
    staticClass: "shopping-dialog-content"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "goods-content"
  }, [_c('img', {
    staticClass: "goods-pic",
    attrs: {
      "src": _vm.goodsInfo.cover,
      "width": "96"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))])])])]), _vm._v(" "), _c('div', {
    staticClass: "shopping-btn",
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_vm._v("立即抢购")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(123)
    },
    on: {
      "click": _vm.hideShoppingPop
    }
  })])]), _vm._v(" "), (_vm.showBuyTipsState) ? [_c('div', {
    staticClass: "bug-tips user-buy-goods",
    class: [_vm.showBuyGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(124),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuyUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "bug-tips buy-goods-success",
    class: [_vm.showBuySuccessGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(125),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessText))]), _vm._v(" "), (_vm.inventoryNum !== -1) ? _c('span', [_vm._v(", 库存剩余" + _vm._s(_vm.inventoryNum) + "件")]) : _vm._e()])])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyRight"
  }, [_c('span', [_vm._v("腾慧云直播")])])
}]}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  "data-v-66e361c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(420);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("d50cfc82", content, true);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "img[data-v-66e361c4]{vertical-align:middle}a[data-v-66e361c4]{color:#333}.UserInfo[data-v-66e361c4]{background-color:#f5f5f5}.user_head_backgound[data-v-66e361c4]{height:150px;background-color:#1b75f9;background-repeat:no-repeat;background-position:bottom;background-size:100% auto;position:relative;overflow:hidden}.user_head_img[data-v-66e361c4]{width:68px;height:68px;margin:19px auto 0;border-radius:50%;overflow:hidden;background:blue;border:1px solid #fff}.user_head_img img[data-v-66e361c4]{width:100%}.user_head_name[data-v-66e361c4]{color:#fff;display:flex;line-height:16px;overflow:hidden;margin-top:10px;font-size:15px}.user_head_name p[data-v-66e361c4]{flex:1;padding:0 18px}.user_head_name p[data-v-66e361c4]:first-child{text-align:right;border-right:1px solid #fff}.user_set[data-v-66e361c4]{position:absolute;top:10px;right:10px}.user_head_set_img[data-v-66e361c4]{width:30px;height:30px}.menuBox[data-v-66e361c4]{height:94px;background:#f1f1f1;position:relative;margin:0 12px}.userMenu[data-v-66e361c4]{position:absolute;width:100%;top:-24px;display:flex;padding:10px 0;background:#fff;border-radius:5px;box-shadow:0 2px 10px 0 rgba(91,91,91,.3)}.userMenu a[data-v-66e361c4]{flex:1;padding:4px 0;text-align:center;font-size:12px;color:#333;line-height:24px}.userMenu .img[data-v-66e361c4]{height:44px;width:44px;line-height:43px;border-radius:50%;overflow:hidden;text-align:center;background:#3976ff;margin:0 auto;margin-bottom:4px}.userMenu a:first-child .img[data-v-66e361c4]{background:linear-gradient(#76d139,#66b82f)}.userMenu a:nth-child(2) .img[data-v-66e361c4]{background:linear-gradient(#ffb546,#ff9000)}.userMenu a:nth-child(3) .img[data-v-66e361c4]{background:linear-gradient(#719eff,#477ef5)}.userMenu a:nth-child(4) .img[data-v-66e361c4]{background:linear-gradient(#ff5a5a,#f25252)}.userMenu img[data-v-66e361c4]{width:27px}.user_image_type_img[data-v-66e361c4]{width:21px;float:left;margin-right:10px;margin-top:2px;font-size:20px;font-weight:700}.van-cell:nth-child(4n) .user_image_type_img[data-v-66e361c4]{color:#66b82f}.van-cell:nth-child(4n+1) .user_image_type_img[data-v-66e361c4]{color:#ff9000}.van-cell:nth-child(4n+2) .user_image_type_img[data-v-66e361c4]{color:#477ef5}.van-cell:nth-child(4n+3) .user_image_type_img[data-v-66e361c4]{color:#f25252}.van-cell[data-v-66e361c4]{padding:15px}.user_type_backgound[data-v-66e361c4]{width:100%;padding-left:10px;padding-top:8px;padding-bottom:4px;background-color:#fff;box-sizing:border-box}.user_type_text[data-v-66e361c4]{position:absolute;width:200px;left:30px;font-size:12px;padding-top:2px;margin-top:auto;padding-left:6px}.user_type_goto[data-v-66e361c4]{position:absolute;margin:0 auto;padding-top:6px;height:10px;right:16px}.valuebox[data-v-66e361c4]{width:90%;margin:10px auto;border-radius:5px;border:1px solid #e5e5e5;padding:10px;color:#999}.valuebox .input[data-v-66e361c4]{position:relative;padding:5px 0}.valuebox input[data-v-66e361c4]{width:100%;height:40px;line-height:40px;border:none;border-bottom:1px solid #ccc;box-sizing:border-box;padding-left:30px;font-size:18px}.valuebox .input span[data-v-66e361c4]{font-size:24px;position:absolute;top:8px;left:0;color:#666}.valuebox h6[data-v-66e361c4]{line-height:32px}.van-popup--right[data-v-66e361c4]{width:100%;height:100%;right:-10px;border-radius:0}.band[data-v-66e361c4]{margin:-10px;background:#fff;border-radius:10px}.band .title[data-v-66e361c4]{height:40px;text-align:center;line-height:40px;background:#099aff;color:#fff}.form[data-v-66e361c4]{padding:20px;line-height:28px}.form p span[data-v-66e361c4]{color:#099aff}.phone[data-v-66e361c4]{color:#383838;margin:10px 0;padding-left:5em;position:relative}.form label[data-v-66e361c4]{width:5em;text-align:right;position:absolute;top:0;left:0}.form input[data-v-66e361c4]{border:1px solid #989898;padding:0 5px;width:100%;box-sizing:border-box}.form .code[data-v-66e361c4]{position:relative;padding:0 7em 0 5em}.getcode[data-v-66e361c4]{width:6em;display:inline-block;position:absolute;text-align:center;right:.5em;top:0;background:#099aff;color:#fff;border-radius:5px;height:30px;line-height:30px}.btns[data-v-66e361c4]{height:40px;text-align:center}.btns a[data-v-66e361c4]{float:left;width:50%;height:40px;line-height:40px}.confirm[data-v-66e361c4]{background:#099aff;color:#fff}.cancel[data-v-66e361c4]{background:#eeeded;color:#333}.codebox img[data-v-66e361c4]{width:80%}.UserInfo ..van-button--large[data-v-66e361c4]{background-color:#4a7ae6}.red[data-v-66e361c4]{color:red}", ""]);

// exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = __webpack_require__(46);

var _dialog2 = _interopRequireDefault(_dialog);

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _icon = __webpack_require__(23);

var _icon2 = _interopRequireDefault(_icon);

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

__webpack_require__(50);

__webpack_require__(7);

__webpack_require__(101);

__webpack_require__(25);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_button2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_icon2.default);
exports.default = {
  data: function data() {
    return {
      initData: {},
      fans_id: '',
      nickname: '',
      show: false,
      value: '',
      balance: '0',
      headImg: '',
      payBut: false,
      tixianType: false,
      realMoney: 0,
      showPhone: false,
      mobile: '',
      code: '',
      seconds: 120,
      showGet: true,
      ds_id: '',
      isShowQRimg: false,
      qrCodeTitle: '',
      qrCodeStr: '',
      qrCodeUrl: '',
      withdraw: false,
      followed: false,
      limitText: '',
      isWeixin: true,
      imgPath: ''
    };
  },
  mounted: function mounted() {
    var that = this;
    _toast2.default.loading({ mask: true });
    this.imgPath = _Tools2.default.imgPath();
    this.ds_id = _Tools2.default.getQueryDsId();
    this.isWeixin = _Tools2.default.isWeixin();
    _Tools2.default.login(_Tools.app_Id, function (fans) {
      //重缓存中获取数据
      that.fans_id = fans.fans_id;
      that.headerUrl = fans.header;

      that.getData();
    });

    if (this.ds_id) {
      this.follow();
    }

    this.limitText = _Tools2.default.getQueryString('text');
    if (this.limitText) {
      _Tools2.default.setCookie(this.limitText, true, 30);
      location.href = location.href.split('&text')[0] + '#/user';
    }
  },

  methods: {
    follow: function follow() {
      this.initData = _data2.default.getInitData();

      if (!this.initData) {
        return;
      }
      var Obj = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.initData.ds_func[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var j = _step.value;

          Obj[j.module] = j.params || true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (Obj.wx_follow) {
        //微信关注二维码
        this.qrCodeUrl = Obj.wx_follow.pic_url;
        this.qrCodeStr = Obj.wx_follow.wx_withdraw_des;
        this.qrCodeTitle = Obj.wx_follow.wx_name;
        if (Obj.wx_follow.wx_withdraw == 'yes') {
          this.withdraw = true;
        } else {
          this.withdraw = false;
        }
        if (_Tools2.default.getCookie(Obj.wx_follow.wx_nameSec)) {
          this.followed = true;
        } else {
          this.followed = false;
        }
      }
    },
    getData: function getData() {
      var that = this;
      this.axios.post(_Tools2.default.baseUrl() + "/fans/finance/balance", 'fans_id=' + this.fans_id).then(function (data) {
        _toast2.default.clear();
        var userms = data.data.data;
        if (data.data.code == "200") {
          _toast2.default.clear();
          that.balance = userms.balance;
          that.headImg = userms.header;
          that.nickname = userms.nick;
        } else {
          (0, _toast2.default)("请求错误");
        }
      }).catch(function (res) {
        _toast2.default.clear();
        (0, _toast2.default)("请求错误");
      });
    },
    withdrawals: function withdrawals() {
      if (this.balance < 2) {
        (0, _toast2.default)("您的余额小于2元，暂不能提现");
        return false;
      }
      console.log(this.withdraw);
      if (!this.followed && this.withdraw) {
        this.isShowQRimg = true;
        return false;
      }
      if (localStorage.getItem('real_auth') == 0) {
        this.showPhone = true;
        return false;
      }
      this.show = true;
    },
    onConfirm: function onConfirm() {
      var that = this;
      var url = _Tools2.default.baseUrl() + '/fans/index/real_auth';
      var option = 'mobile=' + this.mobile + '&fans_id=' + this.fans_id + '&code=' + this.code;
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.mobile)) {
        (0, _toast2.default)('请填写正确的手机号码');
        return false;
      }
      if (!/^\d{6}$/.test(this.code)) {
        (0, _toast2.default)('请填写验证码');
        return false;
      }
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        (0, _toast2.default)(data.message);
        if (data.code == 200) {
          that.showPhone = false;
          _Tools2.default.setCookie('real_auth', 1, 5);
          that.show = true;
          that.mobile = '';
          that.code = '';
        }
      }).catch(function (res) {
        (0, _toast2.default)(res.data.message);
      });
    },
    onCancel: function onCancel() {
      this.showPhone = false;
      this.mobile = '';
      this.code = '';
    },
    onCloseQRCode: function onCloseQRCode() {
      this.isShowQRimg = !this.isShowQRimg;
    },
    payment: function payment() {
      var that = this;
      this.payBut = false;
      _toast2.default.loading({ duration: 0, message: '正在申请提现' });
      this.axios.post(_Tools2.default.baseUrl() + "/fans/Enchashment/index", 'fans_id=' + this.fans_id + '&money=' + this.value).then(function (data) {
        _toast2.default.clear();
        var userms = data.data.data;
        if (data.data.code == "200") {
          that.realMoney = userms.realMoney;
          that.tixianType = true;
          that.getData();
          that.show = false;
          that.value = '';
        } else {
          (0, _toast2.default)(data.data.message);
          that.show = false;
          that.value = '';
        }
      }).catch(function (res) {
        (0, _toast2.default)("请求错误");
      });
    },
    getCode: function getCode() {
      var that = this;
      var url = _Tools2.default.baseUrl() + '/common/SendSms/send';
      var option = 'mobile=' + this.mobile + '&type=certification';
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.mobile)) {
        (0, _toast2.default)('请填写正确的手机号码');
        return false;
      }
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        (0, _toast2.default)(data.message);
        if (data.code == 200) {
          that.showGet = false;
          that.countdown();
        }
      }).catch(function (res) {
        (0, _toast2.default)(res.data.message);
      });
    },
    countdown: function countdown() {
      var that = this;
      var timer = setInterval(function () {
        that.seconds--;
        if (that.seconds == 0) {
          that.showGet = true;
          clearInterval(timer);
          that.seconds = 120;
        }
      }, 1000);
    },
    closePp: function closePp() {
      this.value = '';
      this.show = false;
    },
    onInput: function onInput(key) {
      this.value = this.value + key;
      if (/^[1-9]+[0-9]?(\.\d{1,2})?$/.test(Number(this.value))) {
        if (Number(this.value) === 0) {
          this.value = '';
          (0, _toast2.default)("首位不能为0");
        } else if (Number(this.value) > 1) {
          this.payBut = true;
          if (Number(this.value) > this.balance) {
            (0, _toast2.default)("最多可提现" + this.balance + '元');
            this.value = this.value.substring(0, this.value.length - 1);
          }
        }
      } else {
        this.value = this.value.substring(0, this.value.length - 1);
        (0, _toast2.default)("最多可输入2位小数");
      }
    },
    onDelete: function onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
      if (parseInt(this.value) <= 1 || !this.value) {
        this.payBut = false;
      }
    },
    allPay: function allPay() {
      this.value = this.balance.toString();
      this.payBut = true;
    },
    ok: function ok() {
      this.tixianType = false;
    },
    goBack: function goBack() {
      this.$router.push({ 'path': '/home' });
    },
    toLiveCenter: function toLiveCenter() {
      location.href = 'http://ph.shikee.tv/phoneAdmin/#/manageBackstage';
    },
    toSalesCenter: function toSalesCenter() {
      location.href = 'http://ph.shikee.tv/sales/#/index';
    },
    toOrders: function toOrders() {
      location.href = 'http://ph.shikee.tv/store/#/orders';
    },
    toDistribution: function toDistribution() {
      location.href = 'http://ph.shikee.tv/store/#/Distribution';
    },
    toAddr: function toAddr() {
      location.href = 'http://ph.shikee.tv/store/#/addrs';
    },
    clearDataAction: function clearDataAction() {
      _dialog2.default.confirm({
        title: '提示',
        message: '是否清空缓存数据重新登录'
      }).then(function () {
        // on confirm
        localStorage.clear();
        // 从 sessionStorage 删除所有保存的数据
        sessionStorage.clear();
        location.reload();
      }).catch(function () {
        // on cancel
      });
    }
  }
};

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "UserInfo",
    attrs: {
      "id": "UserInfo"
    }
  }, [_c('div', {
    staticClass: "user_head_backgound clearfix",
    style: ('background-image:url(' + _vm.imgPath + 'user/mountBg.jpg)'),
    attrs: {
      "id": "user_head"
    }
  }, [_c('div', {
    staticClass: "user_head_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.headImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_head_name"
  }, [_c('p', [_vm._v(_vm._s(_vm.nickname))]), _vm._v(" "), _c('p', [_vm._v("余额：¥ " + _vm._s(_vm.balance))])])]), _vm._v(" "), _c('div', {
    staticClass: "menuBox"
  }, [_c('div', {
    staticClass: "userMenu"
  }, [_c('a', {
    on: {
      "click": _vm.withdrawals
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/recharge.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("提现")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/income"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/income.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("收入")])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toOrders
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/orders2.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("订单")])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toDistribution
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/sales2.png'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("分销")])])], 1)]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/cards"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/user_card.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("我的卡包")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/historys"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/user_eye.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("观看历史")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": ""
    },
    on: {
      "click": _vm.toLiveCenter
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/user_live.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("直播中心")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": ""
    },
    on: {
      "click": _vm.toAddr
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/addrs.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("地址管理")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/expend"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/consumption2.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("消费中心")])]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "is-link": "",
      "to": "/cash/1"
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/jiangpin2.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("奖品中心")])]), _vm._v(" "), _c('van-cell', {
    on: {
      "click": _vm.clearDataAction
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/huancunqingli.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("清空缓存数据")])]), _vm._v(" "), (_vm.ds_id) ? _c('van-cell', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'user/live_back.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("返回直播")])]) : _vm._e()], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "box-center clearfix"
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('van-button', {
    attrs: {
      "type": "default",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closePp()
      }
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "valuebox"
  }, [_c('div', [_c('h5', {
    staticClass: "fr"
  }, [_vm._v("您的余额为"), _c('b', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.balance))]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.allPay()
      }
    }
  }, [_vm._v(" 全部提现 ")])], 1), _vm._v(" "), _c('h4', [_vm._v("提现金额")])]), _vm._v(" "), _c('div', {
    staticClass: "input clearfix"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v("￥")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "fl red",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "red"
  }, [_vm._v("特别说明：余额超过2元可提现，将收取20%的手续费，申请成功后在1-2小时内入账微信钱包")])]), _vm._v(" "), _c('div', {
    staticClass: "linebox"
  }, [(_vm.payBut) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.payment()
      }
    }
  }, [_vm._v("立即提现")]) : _c('van-button', {
    attrs: {
      "disabled": "",
      "size": "large"
    }
  }, [_vm._v("立即提现")])], 1), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.show,
      "extra-key": "."
    },
    on: {
      "input": _vm.onInput,
      "delete": _vm.onDelete
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.tixianType),
      callback: function($$v) {
        _vm.tixianType = $$v
      },
      expression: "tixianType"
    }
  }, [_c('div', {
    staticClass: "box-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user/ok.png'
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "bigsize"
  }, [_vm._v("提现成功")]), _vm._v(" "), _c('p', [_vm._v("已提现"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.realMoney * 100 / 100) + "元")]), _vm._v("至微信钱包")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.showPhone),
      callback: function($$v) {
        _vm.showPhone = $$v
      },
      expression: "showPhone"
    }
  }, [_c('div', {
    staticClass: "band"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("提示")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('p', [_vm._v("为了保证您的账户安全，"), _c('span', [_vm._v("首次提现")]), _vm._v("需要进行手机绑定。")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_c('label', [_vm._v("手机号码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "tel",
      "name": "mobile",
      "maxlength": "11",
      "minlength": "11"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('label', [_vm._v("验证码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "name": "code",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showGet) ? _c('a', {
    staticClass: "getcode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _c('a', {
    staticClass: "getcode"
  }, [_vm._v(_vm._s(_vm.seconds) + "秒")])])]), _vm._v(" "), _c('div', {
    staticClass: "btns clearfix"
  }, [_c('a', {
    staticClass: "confirm",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "codebox"
  }, [_c('p', [_vm._v(_vm._s(_vm.qrCodeTitle))]), _vm._v(" "), _c('img', {
    staticClass: "stop",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  }), _vm._v(" "), (_vm.qrCodeStr) ? _c('p', [_vm._v(_vm._s(_vm.qrCodeStr))]) : _c('p', [_vm._v("关注公众号后方可提现")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  "data-v-167dc27e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(425);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4029eb34", content, true);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#InviteCard[data-v-167dc27e]{padding:20px}#imgecard[data-v-167dc27e]{display:block;width:100%}.Label[data-v-167dc27e]{font-size:16px;padding:5px 0}.text[data-v-167dc27e]{font-size:13px;padding-bottom:20px}.u-btn[data-v-167dc27e]{display:block;text-align:center;padding:10px;color:#fff;margin:30px auto 10px;background-color:#00acff;border-radius:2px}.u-btn[data-v-167dc27e]:active{background-color:#f44336}", ""]);

// exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _qrcoder = __webpack_require__(26);

var _qrcoder2 = _interopRequireDefault(_qrcoder);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import blue  from  '../../../statics/imgs/yaoqingblue.jpg';
// import red  from  '../../../statics/imgs/yaoqingred.jpg';
// import black  from  '../../../statics/imgs/yaoqingblack.jpg';


//保存数据
exports.default = {
	data: function data() {
		return {
			initData: {},
			currentIndex: 0,
			theme: ["", "", ""], //[blue,red,black],
			base64URLData: "",
			showcont: false,
			fans_id: '',
			headImg: '',
			titleRect: '',
			timeRect: '',
			infoRect: '',
			ctx: '',
			imgSrc: '',
			qrcodeurl: '',
			livetime: '',
			titleStr: '',
			descStr: '',
			canvas: ''
		};
	},
	mounted: function mounted() {
		_toast2.default.loading({
			mask: true,
			message: '加载中...'
		});
		this.initData = _data2.default.getInitData();
		if (!this.initData) {
			this.$router.push({
				name: 'home'
			});
			return;
		}
		var current_app_Id = window.localStorage.getItem("current_app_Id");
		var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
		this.fans_id = fans.fans_id;
		var direct_seeding = this.initData.direct_seeding;
		var startTime = direct_seeding.start_time;
		if (startTime) {
			this.livetime = "直播时间：" + startTime.substr(0, 4) + "年" + startTime.substr(5, 2) + "月" + startTime.substr(8, 2) + "日 " + startTime.substr(11, 2) + startTime.substr(13, 3);
		}
		this.titleStr = direct_seeding.name;
		this.descStr = direct_seeding.desc;
		this.qrcodeurl = "http://ph.shikee.tv/?ds_id=" + direct_seeding.ds_id + "#/home/" + this.fans_id;
		this.canvas = document.createElement("canvas");
		this.canvas.width = 750;
		this.canvas.height = 1330;
		this.ctx = this.canvas.getContext("2d");
		this.getHeadImg();
	},

	methods: {
		changeThem: function changeThem() {
			this.currentIndex++;
			if (this.currentIndex > 2) {
				this.currentIndex = 0;
			}
			this.drawBackgroud();
		},
		getHeadImg: function getHeadImg() {
			var that = this;
			var avatorimage = _Tools2.default.baseUrl() + "/fans/invite/getImg/?fans_id=" + this.fans_id;
			this.axios.post(avatorimage).then(function (res) {
				that.base64URLData = res.data;
				that.drawBackgroud();
			}).catch(function (res) {
				console.log(res);
			});
		},
		drawBackgroud: function drawBackgroud() {
			//绘制背景图片
			var that = this;
			var img = new Image();
			img.src = this.theme[this.currentIndex];

			this.headImg = {
				x: 296,
				y: 197,
				width: 149,
				height: 149
			};
			this.titleRect = {
				y: 454,
				width: 382
			};
			this.timeRect = {
				x: 121,
				y: 700
			};
			this.infoRect = {
				x: 112,
				y: 860,
				width: 450,
				height: 28
			};

			if (this.currentIndex == 2) {
				this.headImg = {
					x: 305,
					y: 260,
					width: 130,
					height: 130
				};
				this.timeRect = {
					x: 132,
					y: 680
				};
				this.infoRect = {
					x: 112,
					y: 798,
					width: 450,
					height: 28
				};
			}

			img.onload = function () {
				that.ctx.drawImage(img, 0, 0);
				that.drawHeadImage();
			};
		},
		drawHeadImage: function drawHeadImage() {
			//头像
			var img3 = new Image();
			var that = this;
			var ctx = this.ctx;
			var headImg = this.headImg;
			var infoRect = this.infoRect;
			var color = '#333333';
			img3.src = that.base64URLData;

			img3.onload = function () {
				ctx.save();
				ctx.arc(headImg.x + headImg.width / 2.0, headImg.y + headImg.height / 2.0, headImg.width / 2.0, 0, Math.PI * 2, true);
				ctx.clip();
				ctx.drawImage(img3, headImg.x, headImg.y, headImg.width, headImg.height);
				ctx.restore();
				//titleStr
				that.drawMultilineText(that.titleStr, ctx, 750, that.titleRect.y, that.titleRect.width, 50, 10, "48px PingFangSC-Regular", color, true);

				that.drawSingleLineText(that.livetime, ctx, that.timeRect.x, that.timeRect.y, "30px PingFangSC-Regular", color);

				that.drawMultilineText(that.descStr, ctx, infoRect.x, infoRect.y, infoRect.width, infoRect.height, 14, "28px PingFangSC-Regular", color, false);

				that.drawleftImage();
			};
		},
		drawSingleLineText: function drawSingleLineText(text, ctx, x, y, font, color) {
			//绘制单行文字
			ctx.font = font;
			ctx.fillStyle = color;
			ctx.fillText(text, x, y);
		},
		drawMultilineText: function drawMultilineText(t, ctx, bgWidth, y, w, lineHeight, spaceLine, font, color, isCenter) {
			//绘制多行文字
			var that = this;
			var chr = t.split("");
			var temp = "";
			var row = [];

			ctx.font = font;
			ctx.fillStyle = color;

			for (var a = 0; a < chr.length; a++) {
				if (ctx.measureText(temp).width < w) {
					temp += chr[a];
				} else {
					temp += chr[a];
					if (row.length < 1) {
						row.push(temp);
						temp = "";
					} else if (row.length == 1) {
						if (that.currentIndex == 2 && !isCenter) {
							row.push(temp.slice(0, -4) + "...");
						} else {
							row.push(temp.slice(0, -1) + "...");
						}
						temp = "";
					} else {
						break;
					}
				}
			}

			row.push(temp);

			for (var b = 0; b < row.length; b++) {
				var xTmp = bgWidth;
				if (isCenter) {
					xTmp = (bgWidth - ctx.measureText(row[b]).width) / 2.0;
				}

				if (b < 2) {
					if (b == 1) {
						y = y + spaceLine;
					}
					if (row.length == 1) {
						y = y + 30;
					}
					ctx.fillText(row[b], xTmp, y + (b + 1) * lineHeight);
				}
			}
		},
		drawleftImage: function drawleftImage() {
			var img4 = new Image();
			var that = this;
			var ctx = this.ctx;
			var qrcoder = new _qrcoder2.default({
				data: this.qrcodeurl,
				size: 225
			});
			img4.src = qrcoder.getDataURL();
			img4.onload = function () {
				ctx.save();
				that.roundedRectPP(ctx, 123, 1034, 215, 215, 10);
				ctx.clip();
				ctx.drawImage(img4, 123, 1034, 215, 215);
				ctx.restore();
				that.imgSrc = that.canvas.toDataURL("image/png");
				that.showcont = true;
				_toast2.default.clear();
			};
		},
		roundedRectPP: function roundedRectPP(ctx, X, Y, W, H, radius) {
			//圆角矩形
			ctx.beginPath();
			if (W > 0) {
				ctx.moveTo(X + radius, Y);
			} else {
				ctx.moveTo(X - radius, Y);
			}
			ctx.arcTo(X + W, Y, X + W, Y + H, radius);
			ctx.arcTo(X + W, Y + H, X, Y + H, radius);
			ctx.arcTo(X, Y + H, X, Y, radius);
			if (W > 0) {
				ctx.arcTo(X, Y, X + radius, Y, radius);
			} else {
				ctx.arcTo(X, Y, X - radius, Y, radius);
			}
			ctx.fill();
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showcont),
      expression: "showcont"
    }],
    attrs: {
      "id": "InviteCard"
    }
  }, [_c('img', {
    attrs: {
      "id": "imgecard",
      "src": _vm.imgSrc
    },
    on: {
      "click": _vm.changeThem
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "u-btn",
    on: {
      "click": _vm.changeThem
    }
  }, [_vm._v("更换邀请卡主题")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "context"
  }, [_c('p', {
    staticClass: "Label"
  }, [_vm._v("如何玩转邀请卡")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t1.公开话题/加密话题邀请好友来看直播，榜上有名;"), _c('br'), _vm._v(" 2.长按保存图片发送给好友即可邀请;\n\t\t\t"), _c('br'), _vm._v(" 3.点击\"更换邀请卡主题\"，切换邀请卡主题样式。\n\t\t\t"), _c('br')])])
}]}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  "data-v-3a30bd5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("597da7ac", content, true);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".headImg[data-v-3a30bd5b]{overflow:hidden;width:100px;height:100px;margin:10px auto;border-radius:50%}.headImg img[data-v-3a30bd5b]{width:100%}", ""]);

// exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

exports.default = {
  name: 'Setting',
  data: function data() {
    return { fansId: '', nickname: "", username: "", headImg: '', sex: '保密', address: '', show: false, adrCode: '', telephone: "", region: '', regionCode: '', show2: false,
      areaList: {
        province_list: {
          110000: '北京市',
          120000: '天津市'
        },
        city_list: {
          110100: '北京市',
          110200: '县',
          120100: '天津市',
          120200: '县'
        },
        county_list: {
          110101: '东城区'
        }
      }
    };
  },
  created: function created() {
    var current_app_Id = window.localStorage.getItem("current_app_Id");
    var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.fans_id = fans.fans_id;
  },
  mounted: function mounted() {
    this.$toast.loading({ duration: 0 });
    this.getDate();
  },

  methods: {
    getDate: function getDate() {
      var that = this;
      var option = 'fans_id=' + this.fansId;
      this.axios.post(_Tools2.default.baseUrl() + '/fans/finance/balance', option).then(function (data) {
        that.$toast.clear();
        var userms = data.data.data;
        if (data.data.code == "200") {
          that.headImg = userms.header;
          that.nickname = userms.nick;
          that.region = userms.region;
          that.telephone = userms.mobile;
          that.real_name = userms.real_name;
          if (userms.sex == 'man') {
            that.sex = '男';
          } else if (userms.sex == 'woman') {
            that.sex = '女';
          } else {
            that.sex = '保密';
          }
        } else {}
      }).catch(function () {
        that.$toast.clear();
      });
    },
    choiceAdd: function choiceAdd() {
      //this.show = true;
    },
    addadr: function addadr(adrs) {
      // this.region = adrs[0].name+adrs[1].name+adrs[2].name;
      // this.regionCode = adrs[0].code+adrs[1].code+adrs[2].code;
      // this.show = false;
    },
    cancel: function cancel() {
      //this.show = false;
    },
    choiceSex: function choiceSex() {
      //this.show2 = true;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting",
    attrs: {
      "id": "Setting"
    }
  }, [_c('div', {
    staticClass: "headImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headImg
    }
  })]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "昵称",
      "disabled": ""
    },
    model: {
      value: (_vm.nickname),
      callback: function($$v) {
        _vm.nickname = $$v
      },
      expression: "nickname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "姓名",
      "disabled": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "性别",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.choiceSex()
      }
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "手机号码",
      "placeholder": "请输入手机号",
      "disabled": ""
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = $$v
      },
      expression: "telephone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "地区",
      "placeholder": "请选择地址",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.choiceAdd()
      }
    },
    model: {
      value: (_vm.region),
      callback: function($$v) {
        _vm.region = $$v
      },
      expression: "region"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "disabled": "",
      "label": "详细地址",
      "type": "textarea",
      "rows": "1",
      "autosize": ""
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.adrCode,
      "title": "选择地址"
    },
    on: {
      "confirm": _vm.addadr,
      "cancel": _vm.cancel
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "男"
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }, [_vm._v("男")]), _c('br'), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "女"
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }, [_vm._v("女")]), _c('br'), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "保密"
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }, [_vm._v("保密")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/shake"
    }
  }, [_c('p', [_c('br')])])], 1)
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  "data-v-6f68fcce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("caa911f4", content, true);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".incomeList li[data-v-6f68fcce]{padding:10px;border-top:1px solid #eee}.incomeList .money[data-v-6f68fcce]{float:right;width:60px;height:30px;line-height:30px;color:#33c533;text-align:right;font-size:18px}.incomeList .content[data-v-6f68fcce]{padding-right:70px}.incomeList h4[data-v-6f68fcce]{font-weight:400}.incomeList p[data-v-6f68fcce]{font-size:11px}.incomeList .time[data-v-6f68fcce]{color:#999;margin-top:4px}", ""]);

// exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

__webpack_require__(7);

__webpack_require__(17);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

exports.default = {
  directives: {
    WaterfallLower: (0, _waterfall2.default)('lower')
  },
  data: function data() {
    return {
      fans_id: "",
      incomeList: [],
      have: true,
      page: 1,
      page_nums: 20,
      disabled: false,
      noMore: false,
      imgPath: ''
    };
  },
  mounted: function mounted() {
    var current_app_Id = window.localStorage.getItem("current_app_Id");
    var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.fans_id = fans.fans_id;
    this.$toast.loading({ duration: 0 });
    this.imgPath = _Tools2.default.imgPath();
  },

  methods: {
    loadMore: function loadMore() {
      var that = this;
      var option = 'fans_id=' + this.fans_id + '&type=income&page=' + this.page + '&nums=' + this.page_nums;
      _toast2.default.loading({ duration: 0 });
      this.disabled = true;
      this.axios.post(_Tools2.default.baseUrl() + '/fans/finance/flow', option).then(function (data) {
        _toast2.default.clear();
        if (data.data.code == "200") {
          that.incomeList = that.incomeList.concat(data.data.data);
          that.page++;
          if (that.incomeList.length == 0) {
            that.have = false;
          }
          if (data.data.data.length < that.page_nums) {
            that.disabled = true;
            that.noMore = true;
          } else {
            that.disabled = false;
          }
        } else {
          (0, _toast2.default)(data.data.message);
        }
      }).catch(function (res) {
        _toast2.default.clear();
        (0, _toast2.default)(res.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "income"
    }
  }, [(_vm.have) ? _c('div', [_c('ul', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "incomeList",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "200"
    }
  }, _vm._l((_vm.incomeList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "money"
    }, [_vm._v("+" + _vm._s(item.amount))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h4', [_vm._v(_vm._s(item.des))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.create_time))])])])
  }), 0), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMore),
      expression: "noMore"
    }],
    staticClass: "nomore"
  }, [_vm._v("数据加载完成")])]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(439)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  "data-v-0b94a1a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(440);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2d32bccf", content, true);

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passwordInput = __webpack_require__(108);

var _passwordInput2 = _interopRequireDefault(_passwordInput);

__webpack_require__(109);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_passwordInput2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'passWord',
  data: function data() {
    return {
      seted: true,
      oldpass: '',
      value: '',
      showKeyboard: true,
      passWord1: '',
      passWord2: '',
      show: true
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onInput: function onInput(key) {
      this.value = (this.value + key).slice(0, 6);
      if (this.value.length == 6) {
        if (this.seted) {
          this.oldpass = this.value;
          this.seted = false;
          this.value = '';
        } else {
          if (!this.passWord1) {
            this.passWord1 = this.value;
            this.value = '';
            this.show = false;
          } else {
            this.passWord2 = this.value;
            this.value = '';
            this.showKeyboard = false;
          }
        }
      }
    },
    onDelete: function onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    }
  }
};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "passWord"
    }
  }, [(_vm.seted) ? _c('div', {
    staticClass: "box-center"
  }, [_vm._v("\n    请输入旧密码\n  ")]) : [(_vm.show) ? _c('div', {
    staticClass: "box-center"
  }, [_vm._v("\n      请输入密码\n    ")]) : _c('div', {
    staticClass: "box-center"
  }, [_vm._v("\n      请确认密码\n    ")])], _vm._v(" "), _c('van-password-input', {
    attrs: {
      "value": _vm.value,
      "info": "密码为 6 位数字"
    },
    on: {
      "focus": function($event) {
        _vm.showKeyboard = true
      }
    }
  }), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.showKeyboard
    },
    on: {
      "input": _vm.onInput,
      "delete": _vm.onDelete,
      "blur": function($event) {
        _vm.showKeyboard = false
      }
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  "data-v-bff1737a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(445);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("82689656", content, true);

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".incomeList li[data-v-bff1737a]{padding:10px;border-top:1px solid #eee}.incomeList .money[data-v-bff1737a]{float:right;width:60px;height:30px;line-height:30px;color:#fb8d00;text-align:right;font-size:18px}.incomeList .content[data-v-bff1737a]{padding-right:70px}.incomeList h4[data-v-bff1737a]{font-weight:400}.incomeList p[data-v-bff1737a]{font-size:11px}.incomeList .time[data-v-bff1737a]{color:#999;margin-top:4px}", ""]);

// exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

__webpack_require__(7);

__webpack_require__(17);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

exports.default = {
  directives: {
    WaterfallLower: (0, _waterfall2.default)('lower')
  },
  data: function data() {
    return {
      fans_id: "",
      incomeList: [],
      have: true,
      page: 1,
      page_nums: 20,
      disabled: false,
      noMore: false,
      imgPath: ''
    };
  },
  mounted: function mounted() {
    var current_app_Id = window.localStorage.getItem("current_app_Id");
    var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.fans_id = fans.fans_id;
    this.imgPath = _Tools2.default.imgPath();
  },

  methods: {
    loadMore: function loadMore() {
      var that = this;
      var option = 'fans_id=' + this.fans_id + '&type=expend&page=' + this.page + '&nums=' + this.page_nums;
      _toast2.default.loading({ duration: 0 });
      this.disabled = true;
      this.axios.post(_Tools2.default.baseUrl() + '/fans/finance/flow', option).then(function (data) {
        _toast2.default.clear();
        if (data.data.code == "200") {
          that.incomeList = that.incomeList.concat(data.data.data);
          that.page++;
          if (that.incomeList.length == 0) {
            that.have = false;
          }
          if (data.data.data.length < that.page_nums) {
            that.disabled = true;
            that.noMore = true;
          } else {
            that.disabled = false;
          }
        } else {
          (0, _toast2.default)(data.data.message);
        }
      }).catch(function (res) {
        _toast2.default.clear();
        (0, _toast2.default)(res.message);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "expend"
    }
  }, [(_vm.have) ? _c('div', [_c('ul', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "incomeList",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "200"
    }
  }, _vm._l((_vm.incomeList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "money"
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h4', [_vm._v(_vm._s(item.des))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.create_time))])])])
  }), 0), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMore),
      expression: "noMore"
    }],
    staticClass: "nomore"
  }, [_vm._v("数据加载完成")])]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  "data-v-129dfdbb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(450);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4165c31c", content, true);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "img[data-v-129dfdbb]{height:24px;line-height:24px;vertical-align:middle}span[data-v-129dfdbb]{line-height:24px}", ""]);

// exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cell = __webpack_require__(126);

var _cell2 = _interopRequireDefault(_cell);

var _cellGroup = __webpack_require__(452);

var _cellGroup2 = _interopRequireDefault(_cellGroup);

__webpack_require__(453);

__webpack_require__(454);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_cell2.default).use(_cellGroup2.default);
//保存数据

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      fans_id: "",
      shakeList: 0,
      redbaoList: 0,
      imgPath: ''
    };
  },
  mounted: function mounted() {
    var current_app_Id = window.localStorage.getItem("current_app_Id");
    var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.fans_id = fans.fans_id;
    this.imgPath = _Tools2.default.imgPath();
    this.getData();
  },

  methods: {
    getData: function getData() {
      var that = this;
      var option = 'fans_id=' + this.fans_id;
      this.axios.post(_Tools2.default.baseUrl() + '/activity/shake/lists', option).then(function (data) {
        if (data.data.code == "200") {
          that.shakeList = data.data.data.count || '0';
        } else {
          console.log(data.data.message);
        }
      }).catch(function () {
        console.log('错误');
      });
    }
  }
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _functional = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types

var _use = (0, _utils.use)('cell-group'),
    sfc = _use[0],
    bem = _use[1];

function CellGroup(h, props, slots, ctx) {
  var Group = h("div", (0, _babelHelperVueJsxMergeProps2.default)([{
    "class": [bem(), {
      'van-hairline--top-bottom': props.border
    }]
  }, (0, _functional.inherit)(ctx, true)]), [slots["default"] && slots["default"]()]);

  if (props.title) {
    return h("div", [h("div", {
      "class": bem('title')
    }, [props.title]), Group]);
  }

  return Group;
}

CellGroup.props = {
  title: String,
  border: {
    type: Boolean,
    "default": true
  }
};
exports.default = sfc(CellGroup);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "winning"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "is-link": "",
      "value": _vm.shakeList,
      "to": "cash/1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    staticClass: "user_image_type_img",
    attrs: {
      "src": _vm.imgPath + 'shake.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "van-cell-text"
  }, [_vm._v("摇一摇")])])], 2)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "box-center"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("说明：")]), _vm._v("红包中奖记录在个人中心——收入栏显示明细")])
}]}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  "data-v-2efc3ed0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(458);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("c298130e", content, true);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".fixed[data-v-2efc3ed0]{position:fixed;top:0;left:0;width:100%;background:#f94040;color:#fff;z-index:1000}.codebox[data-v-2efc3ed0]{text-align:center}.list[data-v-2efc3ed0],.thead[data-v-2efc3ed0]{display:flex;height:50px}.list span[data-v-2efc3ed0],.thead span[data-v-2efc3ed0]{flex:2;text-align:center;height:40px;line-height:40px;position:relative;padding:5px 0}.list span[data-v-2efc3ed0]:nth-child(2),.thead span[data-v-2efc3ed0]:nth-child(2){flex:3}.thead span[data-v-2efc3ed0]:first-child:after,.thead span[data-v-2efc3ed0]:nth-child(2):after{content:\"\";height:38px;width:1px;background:#fff;top:6px;right:0;position:absolute}.list span[data-v-2efc3ed0]{color:#3f3f3f;font-size:13px}.list .min[data-v-2efc3ed0]{line-height:20px}.list[data-v-2efc3ed0]:nth-child(odd){background:#ffdfdf}.list[data-v-2efc3ed0]:nth-child(2n){background:#ffeaea}.list span[data-v-2efc3ed0]:first-child,.list span[data-v-2efc3ed0]:nth-child(2){border-right:1px solid #fff}.list img[data-v-2efc3ed0]{max-width:40px;margin:0 auto;max-height:40px;vertical-align:middle}.list .btn[data-v-2efc3ed0]{margin:5px auto;border-radius:3px;background:#f94040;color:#fff;display:block;width:70px;line-height:30px}.list .disabled[data-v-2efc3ed0]{background:#999}.line[data-v-2efc3ed0]{height:50px}", ""]);

// exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

__webpack_require__(7);

__webpack_require__(17);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _qrcoder = __webpack_require__(26);

var _qrcoder2 = _interopRequireDefault(_qrcoder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  directives: {
    WaterfallLower: (0, _waterfall2.default)("lower")
  },
  data: function data() {
    return {
      fansId: "",
      prizeList: [],
      have: true,
      page: 1,
      page_nums: 20,
      prizeType: 0,
      isShowQRimg: false,
      qrCode: "",
      disabled: false,
      noMore: false,
      timer: "",
      item: "",
      imgPath: "",
      codeImg: ""
    };
  },
  mounted: function mounted() {
    var that = this;
    this.prizeType = this.$route.params.type;
    _Tools2.default.login(_Tools.app_Id, function (user) {
      that.fansId = user.fans_id;
      that.loadMore();
    });
    //     var current_app_Id = window.localStorage.getItem("current_app_Id");
    //     var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.imgPath = _Tools2.default.imgPath();
    console.log(this.$route);
  },

  methods: {
    loadMore: function loadMore() {
      if (!this.fansId) {
        return;
      }
      var that = this;
      var option, url;
      if (this.prizeType == "0") {
        url = _Tools2.default.baseUrl() + "/redRain/index/lists";
      } else {
        url = _Tools2.default.baseUrl() + "/activity/shake/lists";
      }

      option = "fans_id=" + this.fansId + "&page=" + this.page + "&page_nums=" + this.page_nums;
      _toast2.default.loading({ duration: 0 });
      this.disabled = true;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        _toast2.default.clear();
        if (data.code == "200") {
          if (data.data.list) {
            that.prizeList = that.prizeList.concat(data.data.list);
          }
          that.page++;
          if (that.prizeList.length == 0) {
            that.have = false;
          }
          if (data.data.list.length < that.page_nums) {
            that.disabled = true;
            that.noMore = true;
          } else {
            that.disabled = false;
          }
        } else {
          (0, _toast2.default)(data.message);
        }
      }).catch(function (res) {
        console.log("错误" + res);
      });
    },
    getCode: function getCode(item) {
      var that = this;
      var url = _Tools2.default.baseUrl() + "/fans/index/createLink";
      var option = "fans_id=" + this.fansId + "&type=2&code=" + item.exchange_code;
      //var option = 'fans_id='+this.fansId+'&type=2&code=20507283';
      this.item = item;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          var link;
          if (location.href.indexOf("?") != -1) {
            link = location.href.split("?")[0];
          } else {
            link = location.href.split("#")[0];
          }
          link += "?type=" + data.data.type + "&data0=" + data.data.data0 + "&data1=" + data.data.data1 + "&data2=" + data.data.data2;
          link += "#/check";
          var qrcoder = new _qrcoder2.default({
            data: link,
            size: 225
          });
          that.codeImg = qrcoder.getDataURL();
          that.qrCode = item.exchange_code;
          that.isShowQRimg = true;
          console.log(link);
        } else {
          (0, _toast2.default)(data.message);
        }
      }).catch(function (data) {
        (0, _toast2.default)(data.message);
      });
    },
    cance: function cance(item) {
      var that = this;
      var url = _Tools2.default.baseUrl() + "/fans/index/createLink";
      var option = "fans_id=" + this.fansId + "&type=2&code=" + item.exchange_code;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "202") {
          that.isShowQRimg = false;
          (0, _toast2.default)("核销成功");
          clearInterval(that.timer);
          setTimeout(function () {
            location.reload();
          }, 2000);
        }
      }).catch(function (data) {
        (0, _toast2.default)(data.message);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },

  watch: {
    isShowQRimg: function isShowQRimg() {
      var that = this;
      if (this.isShowQRimg) {
        this.timer = setInterval(function () {
          that.cance(that.item);
        }, 1000);
      } else {
        clearInterval(this.timer);
      }
    }
  }
};

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cash"
    }
  }, [(_vm.have) ? _c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "300"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._l((_vm.prizeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [(item.name.length > 7) ? _c('span', {
      staticClass: "min"
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.create_time))]), _vm._v(" "), _c('span', [(item.exchange_status == 'no') ? _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.getCode(item)
        }
      }
    }, [_vm._v("立即兑换")]) : _c('a', {
      staticClass: "btn disabled"
    }, [_vm._v("已兑换")])])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMore),
      expression: "noMore"
    }],
    staticClass: "nomore"
  }, [_vm._v("数据加载完成")])], 2) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "codebox"
  }, [_c('p', [_vm._v("兑奖二维码")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.codeImg
    }
  }), _vm._v(" "), _c('p', [_vm._v("兑奖码：" + _vm._s(_vm.qrCode))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('span', [_vm._v("奖品")]), _vm._v(" "), _c('span', [_vm._v("中奖时间")]), _vm._v(" "), _c('span', [_vm._v("兑换")])])])
}]}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  "data-v-20a79464",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(463);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4a98df26", content, true);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#cards[data-v-20a79464]{padding:24px 30px;height:100%;background:#f1f0f6;box-sizing:border-box;overflow:scroll}.codebox[data-v-20a79464]{text-align:center}h3[data-v-20a79464]{font-weight:700;color:#252525}p[data-v-20a79464]{color:#7f7f7f;line-height:30px}.quan[data-v-20a79464]{margin-bottom:24px;display:flex;background:#fff;height:90px}.quan.used[data-v-20a79464]{opacity:.8}.quan .info[data-v-20a79464]{padding:20px 0 20px 10px;flex:1;display:flex}.quan .img[data-v-20a79464]{width:50px;height:50px;position:relative;background:#f1f0f6;margin-right:8px;overflow-y:hidden}.quan .img img[data-v-20a79464]{width:100%}.quan .tip[data-v-20a79464]{position:absolute;left:-18px;top:4px;width:60px;height:14px;line-height:14px;font-size:8px;background:#ffc11a;text-align:center;color:#fff;transform:rotate(-45deg)}.quan .tip1[data-v-20a79464]{background:#ff8e1f}.quan .tip2[data-v-20a79464]{background:#fd3f3f}.quan .tip3[data-v-20a79464]{background:#3fd2bf}.quan .state[data-v-20a79464]{width:70px;position:relative;padding-right:8px;background:#fd3f3f;text-align:center;line-height:88px;color:#fff;overflow:hidden;font-size:16px}.quan .btn[data-v-20a79464]{display:block}.quan .over[data-v-20a79464]{background:#d0d0d0}.quan .cut[data-v-20a79464],.quan .state[data-v-20a79464]:after,.quan .state[data-v-20a79464]:before{content:\"\";position:absolute;right:-16px;width:24px;height:24px;background:#f1f0f6;border-radius:50%}.quan .cut[data-v-20a79464]{top:5px}.quan .state[data-v-20a79464]:after{top:34px}.quan .state[data-v-20a79464]:before{top:63px}", ""]);

// exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(17);

__webpack_require__(7);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _qrcoder = __webpack_require__(26);

var _qrcoder2 = _interopRequireDefault(_qrcoder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_toast2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//保存数据

exports.default = {
  directives: {
    WaterfallLower: (0, _waterfall2.default)('lower')
  },
  data: function data() {
    return {
      fansId: "",
      cardList: [],
      isShowQRimg: false,
      qrCode: '',
      timer: '',
      item: '',
      imgPath: '',
      codeImg: ''
    };
  },
  mounted: function mounted() {
    var that = this;
    this.imgPath = _Tools2.default.imgPath();
    _Tools2.default.login(_Tools.app_Id, function (user) {
      that.fansId = user.fans_id;
      _toast2.default.loading({ mask: true });
      that.getData();
    });
  },

  methods: {
    getData: function getData() {
      var that = this;
      var option = 'fans_id=' + this.fansId + '&page=1&page_nums=100';
      this.axios.post(_Tools2.default.baseUrl() + '/coupon/index/lists', option).then(function (data) {
        _toast2.default.clear();
        if (data.data.code == "200") {
          that.cardList = data.data.data.list;
        } else {
          console.log(data.data.message);
        }
      }).catch(function () {
        console.log(data.data.message);
      });
    },
    getCode: function getCode(item) {
      var that = this;
      var url = _Tools2.default.baseUrl() + '/fans/index/createLink';
      var option = 'fans_id=' + this.fansId + '&type=1&code=' + item.code;
      this.item = item;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          var link;
          if (location.href.indexOf('?') != -1) {
            link = location.href.split('?')[0];
          } else {
            link = location.href.split('#')[0];
          }
          link += '?type=' + data.data.type + '&data0=' + data.data.data0 + '&data1=' + data.data.data1 + '&data2=' + data.data.data2;
          link += '#/check';
          var qrcoder = new _qrcoder2.default({
            data: link,
            size: 225
          });
          that.codeImg = qrcoder.getDataURL();
          that.qrCode = item.code;
          that.isShowQRimg = true;
          console.log(link);
        } else {
          (0, _toast2.default)(data.message);
        }
      }).catch(function (data) {
        (0, _toast2.default)(data.message);
      });
    },
    cance: function cance(item) {
      var that = this;
      var url = _Tools2.default.baseUrl() + '/fans/index/createLink';
      var option = 'fans_id=' + this.fansId + '&type=1&code=' + item.code;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "202") {
          that.isShowQRimg = true;
          (0, _toast2.default)('核销成功');
          clearInterval(that.timer);
          setTimeout(function () {
            location.reload();
          }, 2000);
        }
      }).catch(function (data) {
        (0, _toast2.default)(data.message);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },

  watch: {
    isShowQRimg: function isShowQRimg() {
      var that = this;
      if (this.isShowQRimg) {
        this.timer = setInterval(function () {
          that.cance(that.item);
        }, 1000);
      } else {
        clearInterval(this.timer);
      }
    }
  }
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cards"
    }
  }, [(_vm.cardList.length) ? _vm._l((_vm.cardList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "quan",
      class: {
        used: (item.use_status == 'yes')
      }
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "img"
    }, [(item.type == 'discount') ? _c('div', {
      staticClass: "tip"
    }, [_vm._v("折扣券")]) : (item.type == 'money') ? _c('div', {
      staticClass: "tip tip1"
    }, [_vm._v("代金券")]) : (item.type == 'gift') ? _c('div', {
      staticClass: "tip tip2"
    }, [_vm._v("礼品券")]) : (item.type == 'coupon') ? _c('div', {
      staticClass: "tip tip3"
    }, [_vm._v("优惠券")]) : _c('div', {
      staticClass: "tip tip3"
    }, [_vm._v("门票券")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": __webpack_require__(466),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("有效期：" + _vm._s(item.end_time.split(' ')[0]))])])]), _vm._v(" "), (item.use_status == 'no') ? _c('div', {
      staticClass: "state"
    }, [_c('div', {
      staticClass: "cut"
    }), _vm._v(" "), (item.type == 'ticket') ? _c('a', {
      staticClass: "btn"
    }) : _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.getCode(item)
        }
      }
    }, [_vm._v("兑换")])]) : _c('div', {
      staticClass: "state over"
    }, [_c('div', {
      staticClass: "cut"
    }), _vm._v("\n          已使用\n        ")])])
  }) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "codebox"
  }, [_c('p', [_vm._v("兑奖二维码")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.codeImg
    }
  }), _vm._v(" "), _c('p', [_vm._v("兑奖码：" + _vm._s(_vm.qrCode))])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(468)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  "data-v-cb277094",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(469);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3e111d65", content, true);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "img[data-v-cb277094]{max-width:100%;vertical-align:middle}#quan[data-v-cb277094]{height:100%;background:#f4f4f4;padding:15px;box-sizing:border-box;color:#fff}.quan[data-v-cb277094]{box-shadow:4px 4px 16px -5px #e2a5a5;background:#fff;position:relative;padding-bottom:30px}.info[data-v-cb277094]{position:relative;overflow:hidden;background-color:#f44343;background-repeat:repeat;-webkit-background-size:13px;background-size:13px;padding:30px 20px 50px}.bolls[data-v-cb277094]{position:absolute;top:-20px;left:0}.boll[data-v-cb277094]{height:30px;width:30px;background:#f4f4f4;border-radius:50%;margin-left:10px;display:inline-block}.use[data-v-cb277094]{position:absolute;top:0;width:70px;height:28px;line-height:28px;border-bottom-right-radius:6px;border-bottom-left-radius:6px;background:#ffd34c;color:#f44343;right:10px;text-align:center;box-shadow:0 0 10px #d41e1e}.head-card[data-v-cb277094]{display:flex}.head-img[data-v-cb277094]{width:82px;height:82px;border-radius:50%;overflow-y:hidden;text-align:center;box-shadow:4px 4px 10px #c41f1f;background:#fff}.head-img img[data-v-cb277094]{width:80%;margin-top:14px}.head-right[data-v-cb277094]{padding-top:20px;padding-left:10px;line-height:25px}.text[data-v-cb277094]{text-align:center;margin-top:20px}.text h3[data-v-cb277094]{font-size:16px;position:relative}.text h3[data-v-cb277094]:after,.text h3[data-v-cb277094]:before{position:absolute;content:\"\";width:82px;top:12px;border-top:2px dashed #fff}.text h3[data-v-cb277094]:after{left:0}.text h3[data-v-cb277094]:before{right:0}.text p[data-v-cb277094]{color:#fff9af;margin-top:10px}.explain li[data-v-cb277094]{line-height:25px}.explain li span[data-v-cb277094]{width:5em;text-align:right;float:left}.explain li p[data-v-cb277094]{padding-left:5em}.circle[data-v-cb277094]{height:40px;position:relative;overflow:hidden;width:100%;margin-top:-40px}.rcircle[data-v-cb277094]{position:absolute;top:0;width:1000px;height:1000px;background:#ea3434;border-radius:50%;left:50%;margin-left:-500px}.wcircle[data-v-cb277094]{position:absolute;top:0;width:1200px;height:1200px;background:#fff;border-radius:50%;left:50%;margin-left:-600px;top:10px}.btn[data-v-cb277094]{position:relative;height:36px;width:60%;line-height:36px;border-radius:18px;background:#fd3f3f;text-align:center;margin:0 auto}.btn[data-v-cb277094]:before{width:18px;right:30px}.btn[data-v-cb277094]:after,.btn[data-v-cb277094]:before{content:\"\";position:absolute;height:3px;top:5px;background:#fff;border-radius:3px}.btn[data-v-cb277094]:after{width:3px;right:20px}.master[data-v-cb277094]{color:#949494;line-height:36px;text-align:center}.coupon-box[data-v-cb277094]{margin:10px 20px;box-shadow:3px 3px 20px #ffd0d0;padding:9px}.coupon[data-v-cb277094]{background-repeat:repeat;border-radius:3px;-webkit-background-size:32px;background-size:32px;height:84px;overflow:hidden;position:relative}.line[data-v-cb277094]{position:absolute;left:30%;top:15px;height:56px;width:0;border-left:2px dashed #fff}.line[data-v-cb277094]:after,.line[data-v-cb277094]:before{content:\"\";position:absolute;height:32px;width:32px;border-radius:50%;background:#fff;left:-16px}.line[data-v-cb277094]:before{top:-40px}.line[data-v-cb277094]:after{bottom:-40px}.year[data-v-cb277094]{position:absolute;top:16px;left:40%;width:105px}.dog[data-v-cb277094]{position:absolute;top:36px;left:50%;width:48px}.coupontext[data-v-cb277094]{position:absolute;top:16px;right:5%;color:#fff79a;line-height:12px;font-size:12px}.coupontext p[data-v-cb277094]:nth-child(2){font-size:8px;line-height:8px}", ""]);

// exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

exports.default = {
    data: function data() {
        return {
            fansId: "",
            quanId: 0,
            quan: '',
            imgPath: ''
        };
    },
    created: function created() {
        this.imgPath = _Tools2.default.imgPath();
        var current_app_Id = window.localStorage.getItem("current_app_Id");
        var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
        this.fans_id = fans.fans_id;
        this.quanId = this.$route.params.id;
        console.log(this.quanId);
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var that = this;
            var option = 'id=' + this.quanId;
            this.axios.post(_Tools2.default.baseUrl() + '/coupon/index/info', option).then(function (data) {
                if (data.data.code == "200") {
                    that.quan = data.data.data.list[0];
                } else {
                    console.log(data.data.message);
                }
            }).catch(function () {
                console.log(data.data.message);
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "quan"
    }
  }, [_c('div', {
    staticClass: "quan"
  }, [_c('div', {
    staticClass: "info",
    style: ('background-image:url(' + _vm.imgPath + 'quan/quan-bg.png)')
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "use"
  }, [(_vm.quan.enabled == 'yes') ? _c('span', [_vm._v("未使用")]) : _c('span', [_vm._v("已使用")])]), _vm._v(" "), _c('div', {
    staticClass: "head-card"
  }, [_c('div', {
    staticClass: "head-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.quan.pic_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-right"
  }, [_c('p', [_vm._v("商户名称：" + _vm._s(_vm.quan.ds_name))]), _vm._v(" "), _c('p', [_vm._v("卡号：" + _vm._s(_vm.quan.code))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "explain"
  }, [_c('li', [_c('span', [_vm._v("卡券类型：")]), _vm._v(" "), (_vm.quan.type == 'discount') ? _c('p', [_vm._v("折扣券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'money') ? _c('p', [_vm._v("代金券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'gift') ? _c('p', [_vm._v("礼品券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'coupon') ? _c('p', [_vm._v("优惠券")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', [_vm._v("销券方式：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.quan.ds_name))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("有效期：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.quan.use_time) + " - " + _vm._s(_vm.quan.use_time))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("使用说明：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.quan.ds_name))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("立即使用")]), _vm._v(" "), _c('p', {
    staticClass: "master"
  }, [_vm._v("最终解释权归活动举办方所有")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon",
    style: ('background-image:url(' + _vm.imgPath + 'quan/quan-bg2.jpg)')
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('img', {
    staticClass: "year",
    attrs: {
      "src": _vm.imgPath + 'quan/2018.png',
      "alt": "2017"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "dog",
    attrs: {
      "src": _vm.imgPath + 'quan/dog.png',
      "alt": "小狗"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupontext"
  }, [(_vm.quan.type == 'discount') ? _c('p', [_vm._v("折扣券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'money') ? _c('p', [_vm._v("代金券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'gift') ? _c('p', [_vm._v("礼品券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'coupon') ? _c('p', [_vm._v("优惠券")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Raffle ticket")]), _c('p', [_vm._v("●●●●")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bolls"
  }, [_c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h3', [_vm._v("中秋月饼优惠券")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("（ 总购物金额满200元可用 ）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circle"
  }, [_c('div', {
    staticClass: "rcircle"
  }), _vm._v(" "), _c('div', {
    staticClass: "wcircle"
  })])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(473)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  "data-v-7205af44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(474);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("27183ac4", content, true);

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".header[data-v-7205af44]{position:relative}.bgImg[data-v-7205af44]{width:100%}.headImg[data-v-7205af44]{position:absolute;bottom:-10px;right:10px;width:74px;height:74px;border:3px solid #fff;border-radius:50%}.userName[data-v-7205af44]{position:absolute;bottom:30px;right:100px;text-align:right;color:#fff;font-size:18px;line-height:20px}.list[data-v-7205af44]{padding:5px}.list .year[data-v-7205af44]{font-size:26px;color:#020202;line-height:76px;font-weight:700}.list .year span[data-v-7205af44]{font-size:14px;font-weight:400;margin-left:0}.list .oneDay[data-v-7205af44]{margin-bottom:20px}.list .time[data-v-7205af44]{width:70px;float:left;font-size:0}.list .img[data-v-7205af44]{background:#f3f3f5;color:#525254;padding:7px 10px;min-height:50px;line-height:16px;margin-left:74px;margin-bottom:10px;overflow:hidden}.list img[data-v-7205af44]{height:50px;width:80px;float:left}.title[data-v-7205af44]{margin-left:87px;font-size:13px;color:#525254}.time[data-v-7205af44]{font-size:28px;color:#020202;font-weight:700}.list .time .day[data-v-7205af44]{font-size:28px}.list .time .month[data-v-7205af44]{padding-left:3px;font-size:13px;font-weight:400}.list .livetime[data-v-7205af44]{clear:both;font-size:12px;padding-top:8px}", ""]);

// exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _waterfall = __webpack_require__(16);

var _waterfall2 = _interopRequireDefault(_waterfall);

__webpack_require__(7);

__webpack_require__(17);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  directives: {
    WaterfallLower: (0, _waterfall2.default)("lower")
  },
  data: function data() {
    return {
      reViewData: [],
      fans_id: "",
      headImg: "",
      userName: "",
      day: "",
      month: "",
      year: "",
      Today: "",
      Yesterday: "",
      page: 1,
      page_nums: 10,
      disabled: false,
      noMore: false,
      finishData: [],
      have: true,
      imgPath: ""
    };
  },
  mounted: function mounted() {
    var that = this;

    this.imgPath = _Tools2.default.imgPath();

    var current_app_Id = window.localStorage.getItem("current_app_Id");
    var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.fans_id = fans.fans_id;
    this.userName = fans.nick;
    this.headImg = fans.header;
    this.init();
  },

  methods: {
    loadMore: function loadMore() {
      var that = this;
      var url = _Tools2.default.baseUrl() + "/fans/index/history";
      var option = "fans_id=" + this.fans_id + "&page=" + this.page + "&page_nums=" + this.page_nums;
      _toast2.default.loading({ duration: 0 });
      this.disabled = true;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        _toast2.default.clear();
        if (data.code == "200") {
          that.reViewData = that.reViewData.concat(data.data.list);
          that.reArray();
          that.page++;
          if (that.reViewData.length == 0) {
            that.have = false;
          }
          if (that.page_nums > data.data.list.length) {
            that.disabled = true;
            that.noMore = true;
          } else {
            that.disabled = false;
          }
        } else {
          (0, _toast2.default)(data.message);
        }
      }).catch(function (res) {
        (0, _toast2.default)(res.data.message);
      });
    },
    onPlay: function onPlay(id) {
      _data2.default.setInitData("");
      location.href = "https://ph.shikee.tv/?ds_id=" + id + "#/home/";
      //location.href = "http://192.168.100.126:8081/?ds_id="+id+"#/home/"
    },
    init: function init() {
      var myDate = new Date();
      this.day = myDate.getDate();
      this.month = myDate.getMonth();
      this.year = myDate.getFullYear();
      //昨天的时间
      var day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      var month1 = day1.getMonth() + 1;
      var data1Str = day1.getDate();
      if (month1 < 10) {
        month1 = "0" + month1;
      }
      if (data1Str < 10) {
        data1Str = "0" + data1Str;
      }
      this.Yesterday = day1.getFullYear() + "-" + month1 + "-" + data1Str;
      //今天的时间
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var month2 = day2.getMonth() + 1;
      var dataStr2 = day2.getDate();
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      if (dataStr2 < 10) {
        dataStr2 = "0" + dataStr2;
      }
      this.Today = day2.getFullYear() + "-" + month2 + "-" + dataStr2;
    },
    reArray: function reArray() {
      var A = {};
      for (var i = 0; i < this.reViewData.length; i++) {
        var year = this.reViewData[i].create_time.split("-")[0];
        var data = this.reViewData[i].create_time.substr(5, 5);
        year = "_" + year;
        if (!A[year]) {
          A[year] = {};
        }
        if (!A[year][data]) {
          A[year][data] = [];
        }
        if (A[year][data].length > 0) {
          A[year][data].unshift(this.reViewData[i]);
        } else {
          A[year][data] = [this.reViewData[i]];
        }
      }
      this.finishData = A;
      console.log(A);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "videoreview"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "bgImg",
    attrs: {
      "src": _vm.imgPath + 'historyBg.png'
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "headImg",
    attrs: {
      "src": _vm.headImg,
      "alt": _vm.userName
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "userName"
  }, [_vm._v("昵称：" + _vm._s(_vm.userName))])]), _vm._v(" "), (_vm.have) ? _c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "lists",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "100"
    }
  }, [_vm._l((_vm.finishData), function(value, key, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_c('p', {
      staticClass: "year"
    }, [_vm._v(_vm._s(key.substr(1, 4))), _c('span', [_vm._v("年")])]), _vm._v(" "), _vm._l((value), function(val2, key2, index2) {
      return _c('div', {
        key: index2,
        staticClass: "oneDay"
      }, [(key.substr(1, 4) + '-' + key2 == _vm.Today) ? _c('div', {
        staticClass: "time"
      }, [_c('span', {
        staticStyle: {
          "font-size": "28px"
        }
      }, [_vm._v("今天")])]) : (key.substr(1, 4) + '-' + key2 == _vm.Yesterday) ? _c('div', {
        staticClass: "time"
      }, [_c('span', {
        staticStyle: {
          "font-size": "28px"
        }
      }, [_vm._v("昨天")])]) : _c('div', {
        staticClass: "time"
      }, [_c('span', {
        staticClass: "day"
      }, [_vm._v(_vm._s(key2.split("-")[1]))]), _vm._v(" "), _c('span', {
        staticClass: "month"
      }, [_vm._v(_vm._s(key2.split("-")[0]) + "月")])]), _vm._v(" "), _vm._l((val2), function(item3, index3) {
        return _c('div', {
          key: index3,
          staticClass: "img",
          on: {
            "click": function($event) {
              return _vm.onPlay(item3.ds_id)
            }
          }
        }, [_c('img', {
          staticClass: "stop",
          attrs: {
            "src": item3.pic_url
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item3.name))]), _vm._v(" "), _c('div', {
          staticClass: "livetime"
        }, [_vm._v("\n            直播观看时长:\n            "), _c('span', {
          staticStyle: {
            "color": "#F29B05"
          }
        }, [_vm._v(_vm._s(item3.liveTimes))]), _vm._v("分钟 | 点播观看时长:\n            "), _c('span', {
          staticStyle: {
            "color": "#F29B05"
          }
        }, [_vm._v(_vm._s(item3.vodTimes))]), _vm._v("分钟\n          ")])])
      })], 2)
    })], 2)
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMore),
      expression: "noMore"
    }],
    staticClass: "nomore"
  }, [_vm._v("数据加载完成")])], 2) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(478)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  "data-v-42a01267",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(479);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0bc1a30b", content, true);

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".banner[data-v-42a01267]{height:100%;width:100%;text-align:center;position:absolute;z-index:-1;background:#000;overflow:hidden}.banner img[data-v-42a01267]{height:100%;width:100%;display:block;opacity:.5}.signIn[data-v-42a01267]{width:100%;max-height:100%;text-align:center;position:absolute;top:50%;left:0;transform:translateY(-50%);overflow-y:scroll;padding:40px 0;box-sizing:border-box}.logo[data-v-42a01267]{margin:10px auto;max-width:80%}h2[data-v-42a01267]{font-size:24px;color:#fff;text-shadow:0 4px 10px #333;width:80%;margin:0 auto}.userImg[data-v-42a01267]{width:100px;height:100px;border-radius:50%;border:2px solid #ebbf61;overflow:hidden;margin:24px auto}.userImg img[data-v-42a01267]{width:100%}p[data-v-42a01267]{color:#ebbf61}.sign[data-v-42a01267]{width:80%;margin:10px auto;line-height:40px;color:#fff}.sign input[data-v-42a01267]{width:100%;height:40px;display:block;border:1px solid #fff;padding:0 5px;background:hsla(0,0%,100%,.17);box-sizing:border-box;margin-bottom:16px;border-radius:5px;color:#fff}input[data-v-42a01267]::placeholder{color:hsla(0,0%,100%,.5)}.buttom[data-v-42a01267]{width:100%;height:40px;display:block;background:linear-gradient(#ebbf61,#d8ad4f);font-size:22px;border-radius:5px}", ""]);

// exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _field = __webpack_require__(56);

var _field2 = _interopRequireDefault(_field);

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

__webpack_require__(7);

__webpack_require__(57);

__webpack_require__(25);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_button2.default);
_vue2.default.use(_field2.default);

exports.default = {
  data: function data() {
    return {
      imgScr: "",
      fans_id: "",
      ds_id: '',
      wall: '',
      wallId: '',
      name: '',
      mobile: '',
      mail: '',
      other1: '',
      other2: '',
      other3: '',
      text: '留下您的信息，让我们记住您！',
      userImg: 'https://tengfaceliveuser.tengface.net/web/common/logo.png',
      isCache: false,
      dynamicData: null,
      share: {
        title: '评论上墙签到',
        desc: '签到后可在现场大屏幕上看到您的评论',
        link: location.href,
        image: 'https://tengfaceliveuser.tengface.net/web/common/logo.png'
      }
    };
  },
  mounted: function mounted() {
    this.ds_id = _Tools2.default.getQueryDsId();
    this.imgScr = _Tools2.default.baseUrl1() + "/wap/index/dsImg/?ds_id=" + this.ds_id;
    _Tools2.default.login(_Tools.app_Id, this.personDataInit);
  },

  methods: {
    loadAll: function loadAll(data) {
      var that = this;
      this.wall = data.wall_sign_conf;
      if (this.wall == null) {
        this.text = '签到功能未开启！';
        return false;
      }
      this.wallId = this.wall.wall_id;
      this.share.title = this.wall.title;
      this.share.desc = data.direct_seeding.desc;
      this.checkSign();
      this.weixinShare();
    },
    personDataInit: function personDataInit(fans) {
      //重缓存中获取数据
      this.fans_id = fans.fans_id;
      this.userImg = fans.header;
      _Tools2.default.getDsInfo(this.loadAll);
      console.log(this.userImg);
    },
    checkSign: function checkSign() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + '/wall/is_sign';
      var option = 'wall_id=' + this.wallId + '&fans_id=' + this.fans_id;
      this.axios.post(url, option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          (0, _toast2.default)(data.data);
          setTimeout(function () {
            that.$router.push({ 'path': '/home' });
          }, 2000);
        } else {
          console.log(data);
        }
      }).catch(function (data) {});
    },
    signIn: function signIn() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + '/wall/sence_sign';
      var option = 'is_sence=1' + '&ds_id=' + this.ds_id + '&fans_id=' + this.fans_id + '&name=' + this.name + '&mail=' + this.mail;
      option += '&mobile=' + this.mobile + '&other1=' + this.other1 + '&other2=' + this.other2 + '&other3=' + this.other3;
      if (this.wall.name != '0' && !this.name) {
        (0, _toast2.default)('姓名不能为空');
        return false;
      }
      if (this.wall.mobile != '0' && !this.mobile) {
        (0, _toast2.default)('电话不能为空');
        return false;
      }
      if (this.wall.mobile != '0' && !/^[1][3,4,5,7,8][0-9]{9}$/.test(this.mobile)) {
        (0, _toast2.default)('请填写正确的手机号码');
        return false;
      }
      if (this.wall.mail != '0' && !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.mail)) {
        (0, _toast2.default)('请填写正确的邮箱地址');
        return false;
      }
      _toast2.default.loading({
        mask: true,
        message: '签到中...'
      });
      this.axios.post(url, option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          (0, _toast2.default)('签到成功！');
          setTimeout(function () {
            that.$router.push({ 'path': '/home' });
          }, 1000);
        } else {
          (0, _toast2.default)(data.data);
        }
      }).catch(function (data) {});
    },
    weixinShare: function weixinShare() {
      var that = this;
      var url = 'http://plive.shikee.tv/fans/share/getWxParams';
      var option = 'no_dsid=1';
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          wx.config({
            appId: data.data.params.appid, // 必填
            timestamp: data.data.params.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.data.params.noncestr, // 必填，生成签名的随机串
            signature: data.data.params.signature, // 必填，签名，见附录1
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });

          wx.ready(function () {
            //微信好友分享
            wx.onMenuShareAppMessage({
              title: that.share.title, // 分享标题
              desc: that.share.desc, // 分享描述
              link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
              imgUrl: that.share.image, // 分享图标
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function success() {},
              cancel: function cancel() {
                console.log("用户取消分享后执行的回调函数");
              }
            });

            //微信朋友圈分享
            wx.onMenuShareTimeline({
              title: that.share.title, // 分享标题
              link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
              imgUrl: that.share.image, // 分享图标
              success: function success() {},
              cancel: function cancel() {
                console.log("用户取消分享后执行的回调函数");
              }
            });
          });
        } else {
          console.log(data);
        }
      }).catch(function (res) {
        console.log(res.data);
      });
    },
    liveing: function liveing() {
      this.$router.push({ 'path': '/home' });
    }
  }
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = isNumber;
function isNumber(value) {
  return (/^\d+$/.test(value)
  );
}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(483);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-field__label{max-width:90px}.van-field__label--center{text-align:center}.van-field__label--right{text-align:right}.van-field__body{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center}.van-field__control{border:0;margin:0;padding:0;width:100%;resize:none;display:block;color:#323233;box-sizing:border-box;background-color:transparent}.van-field__control::-webkit-input-placeholder{color:#969799}.van-field__control::placeholder{color:#969799}.van-field__control:disabled{opacity:1;color:#969799;background-color:transparent}.van-field__control--center{text-align:center}.van-field__control--right{text-align:right}.van-field__control[type=date],.van-field__control[type=datetime-local],.van-field__control[type=time]{min-height:24px}.van-field__button,.van-field__clear,.van-field__icon,.van-field__right-icon{-webkit-flex-shrink:0;flex-shrink:0}.van-field__clear,.van-field__right-icon{padding:0 10px;line-height:inherit;margin-right:-10px}.van-field__clear{color:#c8c9cc;font-size:16px}.van-field__left-icon .van-icon,.van-field__right-icon .van-icon{display:block;min-width:1em;font-size:16px;line-height:inherit}.van-field__left-icon{margin-right:5px}.van-field--disabled .van-field__control,.van-field__right-icon{color:#969799}.van-field__button{padding-left:10px}.van-field__error-message{color:#f44;font-size:12px;text-align:left}.van-field__error-message--center{text-align:center}.van-field__error-message--right{text-align:right}.van-field--error .van-field__control,.van-field--error .van-field__control::-webkit-input-placeholder{color:#f44}.van-field--error .van-field__control,.van-field--error .van-field__control::placeholder{color:#f44}.van-field--min-height .van-field__control{min-height:60px}", ""]);

// exports


/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgScr,
      "alt": " "
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "signIn"
  }, [(_vm.wall) ? _c('h2', [_vm._v(_vm._s(_vm.wall.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.wall) ? _c('div', {
    staticClass: "sign"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.name != 0),
      expression: "wall.name != 0"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "maxlength": "6",
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.mobile != 0),
      expression: "wall.mobile != 0"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "maxlength": "11",
      "type": "tel",
      "placeholder": "电话"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.mail != 0),
      expression: "wall.mail != 0"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mail),
      expression: "mail"
    }],
    attrs: {
      "maxlength": "30",
      "type": "email",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.other1),
      expression: "wall.other1"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.other1),
      expression: "other1"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.wall.other1
    },
    domProps: {
      "value": (_vm.other1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.other2),
      expression: "wall.other2"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.other2),
      expression: "other2"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.wall.other2
    },
    domProps: {
      "value": (_vm.other2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wall.other3),
      expression: "wall.other3"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.other3),
      expression: "other3"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.wall.other3
    },
    domProps: {
      "value": (_vm.other3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other3 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "buttom",
    on: {
      "click": _vm.signIn
    }
  }, [_vm._v("签到")])]) : _c('div', {
    staticClass: "sign"
  }, [_c('a', {
    staticClass: "buttom",
    on: {
      "click": _vm.liveing
    }
  }, [_vm._v("进入直播间")])])])])
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(486)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(487);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("cd67b8e2", content, true);

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#login{min-height:100%;background:#5582e7 url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/8ecaff914dfca8cee00e58ecb784971d.jpg) no-repeat bottom;-webkit-background-size:100%;background-size:100%;color:#fff;padding:0 18px}#login h2{text-align:center;line-height:80px;font-size:20px}#login .login{padding:35px;background:#fff;color:#999;border-radius:5px;box-shadow:0 4px 14px 0 #3664d0}#login .field{display:flex;line-height:45px;border-bottom:1px solid #adadad;margin-bottom:20px}#login .field img{height:26px;margin-top:9px;margin-right:10px}#login .input{flex:1}.loginBtn{line-height:45px;text-align:center;background:#4a7ae6;color:#fff;border-radius:3px;display:block;margin-top:40px}#login .keep{margin-top:10px}#login .van-checkbox__control:checked+.van-icon-success{background-color:#4a7ae6;border-color:#4a7ae6}#login .content{margin-top:20px;line-height:30px}", ""]);

// exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _checkbox = __webpack_require__(489);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _checkboxGroup = __webpack_require__(490);

var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);

var _field = __webpack_require__(56);

var _field2 = _interopRequireDefault(_field);

__webpack_require__(7);

__webpack_require__(491);

__webpack_require__(494);

__webpack_require__(57);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_field2.default);

_vue2.default.use(_checkbox2.default).use(_checkboxGroup2.default);

//保存数据

exports.default = {
  data: function data() {
    return {
      username: "",
      password: "",
      checked: true,
      imgPath: ""
    };
  },
  mounted: function mounted() {
    this.imgPath = _Tools2.default.imgPath();
    var username = _Tools2.default.getCookie("username");
    var password = _Tools2.default.getCookie("password");
    if (username) {
      this.username = unescape(username).split(" ").join("");
    }
    if (password) {
      this.password = unescape(password).split(" ").join("");
    }
  },

  methods: {
    login: function login() {
      var that = this;
      var option = "name=" + this.username + "&password=" + this.password;
      if (!this.username || !this.password) {
        (0, _toast2.default)("用户名和密码不能为空");
        return false;
      }
      this.axios.defaults.withCredentials = true;
      this.axios.post(_Tools2.default.baseUrl() + "/coupon/verify/login", option).then(function (data) {
        console.log(data);
        if (data.data.code == "200") {
          (0, _toast2.default)(data.data.message);
          if (that.checked) {
            _Tools2.default.setCookie("username", escape(that.username.split("").join(" ")), 30);
            _Tools2.default.setCookie("password", escape(that.password.split("").join(" ")), 30);
          } else {
            _Tools2.default.setCookie("username", null, -1);
            _Tools2.default.setCookie("password", null, -1);
          }
          console.log(document.cookie);
          setTimeout(function () {
            that.$router.push({ path: "/scan" });
          }, 300);
        } else {
          (0, _toast2.default)(data.data.message);
        }
      }).catch(function () {
        console.log("错误");
      });
    }
  }
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _checkbox = __webpack_require__(75);

var _use = (0, _utils.use)('checkbox'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  mixins: [(0, _checkbox.CheckboxMixin)('van-checkbox-group', bem)],
  computed: {
    checked: {
      get: function get() {
        return this.parent ? this.parent.value.indexOf(this.name) !== -1 : this.value;
      },
      set: function set(val) {
        if (this.parent) {
          this.setParentValue(val);
        } else {
          this.$emit('input', val);
        }
      }
    }
  },
  watch: {
    value: function value(val) {
      this.$emit('change', val);
    }
  },
  methods: {
    toggle: function toggle() {
      var _this = this;

      var checked = !this.checked; // When toggle method is called multiple times at the same time,
      // only the last call is valid.
      // This is a hack for usage inside Cell.

      clearTimeout(this.toggleTask);
      this.toggleTask = setTimeout(function () {
        _this.checked = checked;
      });
    },
    onClickIcon: function onClickIcon() {
      if (!this.isDisabled) {
        this.toggle();
      }
    },
    onClickLabel: function onClickLabel() {
      if (!this.isDisabled && !this.labelDisabled) {
        this.toggle();
      }
    },
    setParentValue: function setParentValue(val) {
      var parent = this.parent;
      var value = parent.value.slice();

      if (val) {
        if (parent.max && value.length >= parent.max) {
          return;
        }
        /* istanbul ignore else */

        if (value.indexOf(this.name) === -1) {
          value.push(this.name);
          parent.$emit('input', value);
        }
      } else {
        var index = value.indexOf(this.name);
        /* istanbul ignore else */

        if (index !== -1) {
          value.splice(index, 1);
          parent.$emit('input', value);
        }
      }
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(5);

var _use = (0, _utils.use)('checkbox-group'),
    sfc = _use[0],
    bem = _use[1];

exports.default = sfc({
  props: {
    max: Number,
    value: Array,
    disabled: Boolean
  },
  watch: {
    value: function value(val) {
      this.$emit('change', val);
    }
  },
  render: function render(h) {
    return h("div", {
      "class": bem()
    }, [this.slots()]);
  }
});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(492);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(493);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-checkbox{overflow:hidden;-webkit-user-select:none;user-select:none}.van-checkbox__icon,.van-checkbox__label{display:inline-block;vertical-align:middle;line-height:20px}.van-checkbox__icon{height:20px}.van-checkbox__icon .van-icon{font-size:14px;color:transparent;text-align:center;line-height:inherit;width:20px;height:20px;box-sizing:border-box;border:1px solid #e5e5e5;-webkit-transition:.2s;transition:.2s}.van-checkbox__icon--round .van-icon{border-radius:100%}.van-checkbox__icon--checked .van-icon{color:#fff;border-color:#1989fa;background-color:#1989fa}.van-checkbox__icon--disabled .van-icon{border-color:#c8c9cc;background-color:#ebedf0}.van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{color:#c8c9cc}.van-checkbox__label{color:#323233;margin-left:10px}.van-checkbox__label--left{float:left;margin:0 10px 0 0}.van-checkbox__label--disabled{color:#c8c9cc}", ""]);

// exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('h2', [_vm._v("核销中心")]), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "field name"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('van-field', {
    attrs: {
      "icon": "clear",
      "placeholder": "用户名"
    },
    on: {
      "click-icon": function($event) {
        _vm.username = ''
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field password"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'password.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('van-field', {
    attrs: {
      "type": "password",
      "icon": "clear",
      "placeholder": "密码"
    },
    on: {
      "click-icon": function($event) {
        _vm.password = ''
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "loginBtn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("立即登陆")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('van-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("使用说明：")]), _vm._v(" "), _c('p', [_vm._v("主办方在后台设置核销管理员用户名、密码，核销管理员在该页面进行登录。登录完成后即可扫码进行核销。")])])
}]}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  "data-v-1a94c98e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(498);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("730b126f", content, true);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".Sweep[data-v-1a94c98e]{text-align:center}.Sweep img[data-v-1a94c98e]{width:80%}.loginBtn[data-v-1a94c98e]{margin-top:0}", ""]);

// exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      imgPath: ""
    };
  },
  mounted: function mounted() {
    var that = this;
    this.imgPath = _Tools2.default.imgPath();
    var username = _Tools2.default.getCookie("username");
    var password = _Tools2.default.getCookie("password");
    if (!username || !password) {
      (0, _toast2.default)("请登陆后操作。");
      setTimeout(function () {
        that.$router.push({ path: "/login" });
      }, 2000);
      return;
    }
    this.getDynamicData();
  },

  methods: {
    scan: function scan() {
      var that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function success(res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          window.location.href = result; //因为我这边是扫描后有个链接，然后跳转到该页面
        }
      });
    },
    getDynamicData: function getDynamicData() {
      var that = this;
      var option = "no_dsid=1";
      this.axios.post("https://plive.shikee.tv/fans/share/getWxParams", option).then(function (data) {
        var data = data.data;
        var params = data.data.params;
        if (data.code == 200) {
          wx.config({
            appId: params.appid, // 必填
            timestamp: params.timestamp, // 必填，生成签名的时间戳
            nonceStr: params.noncestr, // 必填，生成签名的随机串
            signature: params.signature, // 必填，签名，见附录1
            jsApiList: ["checkJsApi", "scanQRCode"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });

          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ["scanQRCode"],
              success: function success(res) {
                console.log("1111");
              }
            });
          });
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    }
  }
};

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('h2', [_vm._v("扫码核销")]), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "Sweep"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'Sweep.jpg'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "loginBtn",
    on: {
      "click": _vm.scan
    }
  }, [_vm._v("扫一扫核销")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("使用说明：")]), _vm._v(" "), _c('p', [_vm._v("\n      用户打开直播间的【个人中心】，进入【我的卡包】页面。点击【立即核销】按钮，核销管理员扫描核销二维码，确认核销信息，即可完成核销。\n    ")])])
}]}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  "data-v-29a98108",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(503);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("668e424e", content, true);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#check[data-v-29a98108]{background:#f5f5f5;min-height:100%}.card[data-v-29a98108]{padding:0 5px;background:#fff;margin-bottom:10px}.card h3[data-v-29a98108]{line-height:50px;border-bottom:1px solid #b5b5b5;color:#858585;font-size:19px}.card p[data-v-29a98108]{color:#323232;font-size:17px;line-height:30px;min-height:60px;padding:10px 0}.btns[data-v-29a98108]{display:flex;padding:10px}.btns a[data-v-29a98108]{display:block;margin:0 10px;background:#c8c8c8;color:#fff;text-align:center;height:45px;line-height:45px;border-radius:3px;flex:1;font-size:18px}.btns a[data-v-29a98108]:nth-child(2n){background:#4a7ae6}", ""]);

// exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//保存数据

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      liveName: "",
      activityName: "",
      prizeName: "",
      type: "",
      data0: "",
      data1: "",
      data2: "",
      data3: "",
      data4: "",
      code: ""
    };
  },
  mounted: function mounted() {
    this.type = _Tools2.default.getQueryString("type");
    this.data0 = _Tools2.default.getQueryString("data0");
    this.data1 = _Tools2.default.getQueryString("data1");
    this.data2 = _Tools2.default.getQueryString("data2");
    this.getData();
  },

  methods: {
    getData: function getData() {
      var that = this;
      var option = "type=" + this.type + "&data0=" + this.data0 + "&data1=" + this.data1 + "&data2=" + this.data2;
      this.axios.defaults.withCredentials = true;
      console.log(document.cookie);
      this.axios.post(_Tools2.default.baseUrl() + "/coupon/verify/auth", option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          that.data3 = data.data.data3;
          that.data4 = data.data.data4;
          that.code = data.data.code;
          that.liveName = data.data.name;
          that.activityName = data.data.activity_name;
          that.prizeName = data.data.prize_name;
        } else {
          (0, _toast2.default)(data.message);
        }
      }).catch(function () {
        console.log("错误");
      });
    },
    check: function check() {
      var that = this;
      var option = "type=" + this.type + "&data3=" + this.data3 + "&data4=" + this.data4 + "&code=" + this.code;
      this.axios.post(_Tools2.default.baseUrl() + "/coupon/verify/past", option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          (0, _toast2.default)(data.message);
          setTimeout(function () {
            that.$router.push({ path: "/scan" });
          }, 2000);
        } else {
          (0, _toast2.default)(data.message);
        }
      }).catch(function () {
        console.log("错误");
      });
    },
    cancel: function cancel() {
      this.$router.push({ path: "/scan" });
    }
  }
};

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "check"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("直播名称")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.liveName))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("活动名称")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.activityName))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("奖品名称")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.prizeName))])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回扫码")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("确认")])])])
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)
__webpack_require__(509)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  "data-v-0a3c79ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(508);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3a04d49d", content, true);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports
exports.i(__webpack_require__(71), "");

// module
exports.push([module.i, ".tosafari[data-v-0a3c79ba]{position:fixed;top:0;left:0;height:100%;width:100%;z-index:3000}.tosafari .content[data-v-0a3c79ba]{width:100%;height:100%;display:flex;flex-direction:column}.tosafari .content img[data-v-0a3c79ba]{width:100%;flex:1;height:0}.tosafari .content .bottom[data-v-0a3c79ba]{height:50px;width:100%;background-color:#d3d3d3;text-align:center}.tosafari .content .bottom button[data-v-0a3c79ba]{width:100%;line-height:50px;border:none}.van-popup.iosPosition[data-v-0a3c79ba]{position:absolute}.player[data-v-0a3c79ba]{position:absolute;top:0;bottom:0;left:0;right:0;width:100%;height:100%;display:block}.height25[data-v-0a3c79ba]{height:25px}.menu .van-tab--active[data-v-0a3c79ba]{color:#1483ff;position:relative}.menu .van-tabs__line[data-v-0a3c79ba]{background-color:#1483ff;color:#1483ff;height:2px}.van-tabs--line .van-tabs__wrap[data-v-0a3c79ba]{height:44px;margin-left:44px}.hidefouce .van-tabs--line .van-tabs__wrap[data-v-0a3c79ba]{margin-right:0!important}.noline .van-tabs--line .van-tabs__wrap[data-v-0a3c79ba]{height:44px;margin-left:0}.menu2 .van-tab--active[data-v-0a3c79ba]{color:#e5bc4b}.menu2 .van-tabs__line[data-v-0a3c79ba]{background:#e5bc4b;color:#e5bc4b}.menu3 .van-tab--active[data-v-0a3c79ba]{color:#ec1a1a}.menu3 .van-tabs__line[data-v-0a3c79ba]{background:#ec1a1a;color:#ec1a1a}.Vote .van-tabs__wrap[data-v-0a3c79ba]{border-radius:5px;overflow:hidden}.Vote .van-tab--active[data-v-0a3c79ba]{background:#dcb45a;color:#fff}.Vote .van-tabs__line[data-v-0a3c79ba]{background:none}.Vote .van-tabs__line[data-v-0a3c79ba]:after{border-width:0}.view_num[data-v-0a3c79ba]{position:absolute;left:10px;top:26px;border-radius:10px;padding:0 10px;height:20px;line-height:21px;color:#fff;font-size:13px;background-color:hsla(0,3%,8%,.67);z-index:1000}.view_num img[data-v-0a3c79ba]{width:16px;vertical-align:middle}.scrollbar[data-v-0a3c79ba]{position:absolute;left:0;top:0;width:100%;z-index:1250;background:rgba(0,0,0,.2);overflow:hidden;height:20px;line-height:20px}.scrollbar p[data-v-0a3c79ba]{animation:scroll 24s linear infinite;white-space:nowrap;display:inline-block}@keyframes scroll{0%{transform:translateX(100vw)}to{transform:translateX(-100%)}}.scrollbar a[data-v-0a3c79ba]{color:#0dff0a}.headtitle[data-v-0a3c79ba]{position:absolute;height:54px;width:100%;background:#212126;top:0}.headtitle p[data-v-0a3c79ba]{margin:auto;text-align:center;padding:0 15%;height:54px;color:#fff;line-height:54px}.home-content[data-v-0a3c79ba]{background:#eee;width:100%;position:absolute;z-index:1400}.home-content>div[data-v-0a3c79ba]{-webkit-overflow-scrolling:touch;overflow-scrolling:touch;height:100%;scroll-behavior:smooth}.control[data-v-0a3c79ba]{width:100%;height:40px;line-height:40px;background-color:rgba(0,0,0,.5);position:absolute;bottom:0;z-index:1200;display:-webkit-box;display:-moz-box;display:flex}#midControl[data-v-0a3c79ba]{flex:1;display:-webkit-box;display:-moz-box;display:flex}#midControl span[data-v-0a3c79ba]{color:#fff;font-size:10px;line-height:42px}#progressWrap[data-v-0a3c79ba]{position:relative;flex:1;margin:0 16px 0 4px}#playLine[data-v-0a3c79ba]{position:absolute;height:2px;width:100%;background-color:#f5f5f5;top:19px;margin-left:6px}#playSchedule[data-v-0a3c79ba]{position:absolute;height:2px;width:20%;background-color:#1296db;top:19px;margin-left:6px}#playPoint[data-v-0a3c79ba]{position:absolute;background-color:#fff;width:0;height:0;border-radius:6px;top:14px;left:0;border:6px solid #fff}.fullSrceenBtn[data-v-0a3c79ba],.playpause[data-v-0a3c79ba]{width:40px;text-align:center;line-height:40px}.fullSrceenBtn img[data-v-0a3c79ba],.playpause img[data-v-0a3c79ba]{vertical-align:middle;width:20px}.shareRed[data-v-0a3c79ba]{position:absolute;top:45vw;background:#ff2a00;color:#fff;text-align:center;padding:0 10px;line-height:20px;right:10px;border-radius:10px;font-size:12px;z-index:1200}.sharebao[data-v-0a3c79ba]{margin:-10px;background:#fff;border-radius:10px;position:relative}.sharebao .gold[data-v-0a3c79ba]{position:absolute;width:56px;height:56px;border-radius:50%;box-shadow:0 0 10px 1px #fff;top:-28px;left:50%;margin-left:-28px}.sharehead[data-v-0a3c79ba]{padding:15px 10px;overflow:hidden;border-radius:10px;line-height:24px;background-color:#de3041;background-repeat:no-repeat;background-position:bottom;text-align:center;color:#fff;background-size:100% auto}.sharehead .loll[data-v-0a3c79ba]{color:#f8be41}.sharebody[data-v-0a3c79ba]{padding:10px;color:#7a7a7a;text-align:center;line-height:30px}.sharebody .money[data-v-0a3c79ba]{color:#c32938;font-size:24px}.sharebody .money span[data-v-0a3c79ba]{font-size:14px;color:#333}.sharebody .button[data-v-0a3c79ba]{line-height:32px;font-size:16px;background:#de3041;color:#fff;border-radius:16px;text-align:center;margin:10px auto;width:160px;display:block}.talktext[data-v-0a3c79ba]{width:80%;border:1px dashed #c32938;border-radius:5px;margin:20px auto 10px;padding:10px;text-align:center;color:#c32938;font-size:16px}.playPause[data-v-0a3c79ba]{position:absolute;width:80px;left:50%;transform:translate(-40px,-40px);top:28vw;z-index:1300;opacity:.7}.music[data-v-0a3c79ba]{position:absolute;right:20px;top:20px;width:32px;height:32px;border-radius:20px;z-index:1030}.musicPlay[data-v-0a3c79ba]{animation:swing 1s ease-in-out infinite}.music img[data-v-0a3c79ba]{display:block}@keyframes swing{0%{transform:rotate(10deg)}50%{transform:rotate(-10deg)}to{transform:rotate(10deg)}}.talkred[data-v-0a3c79ba]{position:absolute;top:20vw;right:0;z-index:1200;height:50px;width:50px}.talkred img[data-v-0a3c79ba]{width:100%}.controlbox[data-v-0a3c79ba]{position:absolute;z-index:200;width:100%;height:56vw;top:0;left:0}.menu[data-v-0a3c79ba]{position:absolute;z-index:1000;width:100%;height:44px;top:56vw}.close[data-v-0a3c79ba]{position:absolute;top:15px;right:15px;height:20px;width:20px}.close img[data-v-0a3c79ba]{width:100%}.fullBox[data-v-0a3c79ba]{width:100%;height:100%;background:rgba(0,0,0,.5);position:absolute;top:0;left:0;z-index:2000}a.bigTable img[data-v-0a3c79ba]{width:100%}.clarity[data-v-0a3c79ba]{width:40px;position:relative;text-align:center;color:#fff;font-size:12px}.clarity .cur[data-v-0a3c79ba]{display:block;height:20px;width:80%;line-height:20px;border:1px solid #eee;border-radius:3px;margin:10px auto}.clarity ul[data-v-0a3c79ba]{position:absolute;bottom:40px;left:0;width:100%;background:rgba(0,0,0,.5)}.clarity li[data-v-0a3c79ba]{height:30px;line-height:30px;border-bottom:1px solid #eee}.clarity li[data-v-0a3c79ba]:last-child{border:none}.clarity li.active[data-v-0a3c79ba]{color:#ff0}.clarity.ios[data-v-0a3c79ba]{position:absolute;top:6px;right:70px;z-index:1300;height:30px;background:rgba(51,51,51,.67);line-height:30px;border-radius:5px}.clarity.ios a[data-v-0a3c79ba]{margin:0 auto}.clarity.ios .cur[data-v-0a3c79ba]{width:100%;height:30px;line-height:30px;border:none}.clarity.ios ul[data-v-0a3c79ba]{bottom:auto;top:32px;border-radius:5px;overflow:hidden}.iosfull[data-v-0a3c79ba]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:10000}.videoMusk[data-v-0a3c79ba]{position:fixed;z-index:9000;background:#333;height:100%;width:100%}.window[data-v-0a3c79ba]{position:absolute;top:36vw;right:0;padding:5px 7px;background:rgba(30,30,30,.4);z-index:1200;border-top-left-radius:5px;border-bottom-left-radius:5px}.window img[data-v-0a3c79ba]{width:30px;vertical-align:middle}.msg_conent p img[data-v-0a3c79ba]{vertical-align:middle}.floatBox[data-v-0a3c79ba]{width:100%;top:0;left:0;position:absolute;z-index:600}.rightFunction[data-v-0a3c79ba]{bottom:80px;right:10px;position:fixed;z-index:600}.rightFunction .rightfuncImage[data-v-0a3c79ba]{width:40px;height:40px;display:block}.ripple[data-v-0a3c79ba]{background:#e94c69 url(https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/home/ripple_5.gif) no-repeat 50%!important;-webkit-background-size:100% auto!important;background-size:100% auto!important;color:#fff!important}.comment-text p img[data-v-0a3c79ba]{vertical-align:middle}.tabs_title .btn[data-v-0a3c79ba]{display:inline-block;width:48%;text-align:center}.tabs_title .btn a[data-v-0a3c79ba]{line-height:30px;font-size:15px;padding-bottom:5px}.tabs_title .btn.cur a[data-v-0a3c79ba]{color:#fa4053;border-bottom:1px solid #fa4053}.trySee[data-v-0a3c79ba]{top:0;left:0;width:100%;line-height:20px;text-align:center;background:rgba(0,0,0,.5);transition:.5s;opacity:0}.tryPay[data-v-0a3c79ba],.trySee[data-v-0a3c79ba]{position:absolute;height:20px;color:#fff;z-index:1020}.tryPay[data-v-0a3c79ba]{right:45px;top:7px;padding:0 10px;background:#ff2a00;border-radius:10px}.tryBox[data-v-0a3c79ba]{text-align:center}.tryBox .money[data-v-0a3c79ba]{color:#ff2a00;font-size:28px}.tryBox .moneyIcon[data-v-0a3c79ba]{color:#ff2a00}.tryBox .oldMoney[data-v-0a3c79ba]{color:#999;text-decoration:line-through;margin-left:5px}.paydialog .title[data-v-0a3c79ba]{color:#2c2c2c;font-size:16px;line-height:50px;text-align:center}.coupons[data-v-0a3c79ba]{padding:10px 10px 10px 100px;line-height:30px;max-height:180px;overflow:scroll}.coupons li i[data-v-0a3c79ba]{width:16px;height:16px;border:1px solid #999;border-radius:50%;position:relative;margin-right:5px}.coupons li i[data-v-0a3c79ba],.coupons li span[data-v-0a3c79ba]{display:inline-block;vertical-align:middle}.coupons li.cur[data-v-0a3c79ba]{color:#3e78fb}.coupons li.cur i[data-v-0a3c79ba]{background:#3e78fb;border-color:#3e78fb}.coupons li.cur i[data-v-0a3c79ba]:after{position:absolute;content:\"\";display:block;width:12px;height:12px;background:#3e78fb;border:2px solid #fff;top:0;left:0;border-radius:50%}.twobtn[data-v-0a3c79ba]{height:50px;line-height:50px;display:flex;border-top:1px solid #eee}.twobtn a[data-v-0a3c79ba]{flex:1;text-align:center;color:#2c2c2c;font-size:16px}.twobtn .cancel[data-v-0a3c79ba]{border-right:1px solid #eee}.twobtn .sure[data-v-0a3c79ba]{color:#3e78fb}.explain[data-v-0a3c79ba]{text-align:center;color:#999;line-height:40px}.occupy .addimg .container .moxie-shim[data-v-0a3c79ba]{width:100px!important;height:100px!important}.allot_btn[data-v-0a3c79ba]{position:absolute;top:42px;right:0;height:22px;line-height:22px;padding:4px;border-top-left-radius:15px;border-bottom-left-radius:15px;background:#ad935c;color:#fff;z-index:1300;text-align:center}.allot_btn span[data-v-0a3c79ba]:first-child{border:1px solid #fff;height:20px;border-radius:50%;display:inline-block;width:20px}.shareCard[data-v-0a3c79ba]{padding:18px;background:linear-gradient(#dfd0bd,#fff);border-radius:10px;overflow:hidden}.boxCloseBtn[data-v-0a3c79ba]{position:absolute;top:10px;right:14px;font-size:30px}#LiveHotel .showTeacherBtnTop[data-v-0a3c79ba]{position:absolute;top:10px;right:10px;z-index:9999}#LiveHotel .showTeacherBtnTop img[data-v-0a3c79ba]{width:30px}.allot_pic[data-v-0a3c79ba]{box-shadow:0 4px 10px #efd6af}.allot_title[data-v-0a3c79ba]{font-size:15px;color:#191919;font-weight:700;line-height:24px;margin-top:10px;max-height:48px;overflow:hidden}.allot_title span[data-v-0a3c79ba]{display:inline-block;background:#c49c5f;color:#fff;height:16px;line-height:17px;text-align:center;border-radius:8px;vertical-align:middle;padding:0 8px;font-size:10px;word-break:keep-all;margin-left:5px}.allot_price[data-v-0a3c79ba]{color:#c49c5f;font-size:25px;margin-left:-2px}.allot_price span[data-v-0a3c79ba]{font-size:18px}.allot_ul[data-v-0a3c79ba]{font-size:12px}.allot_ul span[data-v-0a3c79ba]{display:inline-block;width:1px;height:13px;background:#666;vertical-align:middle;margin:0 10px}.allot_dashed[data-v-0a3c79ba]{text-align:center;margin-top:30px;position:relative;height:20px;line-height:20px}.allot_dasheds[data-v-0a3c79ba]{height:20px;width:100%;overflow:hidden}.allot_dashed span[data-v-0a3c79ba]{display:inline-block;width:5px;height:5px;border-radius:50%;background:#dcc9b0;margin:0 5px;vertical-align:middle}.allot_dashed[data-v-0a3c79ba]:after,.allot_dashed[data-v-0a3c79ba]:before{position:absolute;content:\"\";display:block;top:0;width:20px;height:20px;border-radius:50%;background:linear-gradient(90deg,#303030,#303030)}.allot_dashed[data-v-0a3c79ba]:before{left:-32px}.allot_dashed[data-v-0a3c79ba]:after{right:-32px}.allot .userInfo[data-v-0a3c79ba]{padding:15px 0}.allot .userInfo .userImg[data-v-0a3c79ba]{width:44px;height:44px;border-radius:50%;overflow:hidden;margin-right:8px;margin-top:7px}.allot .userInfo .name[data-v-0a3c79ba]{font-size:12px;line-height:16px;margin-top:4px;color:#666}.allot .userInfo .colors[data-v-0a3c79ba]{color:#c49c5f}.allot .code[data-v-0a3c79ba]{width:60px;height:60px;margin-right:6px;overflow:hidden}.allot .copyRight[data-v-0a3c79ba]{text-align:center;color:#c49c5f;font-size:10px;height:20px;line-height:20px}.allot .copyRight span[data-v-0a3c79ba]{position:relative;display:inline-block}.allot .copyRight span[data-v-0a3c79ba]:after,.allot .copyRight span[data-v-0a3c79ba]:before{position:absolute;display:block;content:\"\";top:8px;width:40px;height:1px;background:#c49c5f}.allot .copyRight span[data-v-0a3c79ba]:before{left:-50px}.allot .copyRight span[data-v-0a3c79ba]:after{right:-50px}.allot_tip[data-v-0a3c79ba]{position:absolute;top:50%;margin-top:240px;color:#fff;text-align:center;width:100%;font-size:16px}.schooldialog[data-v-0a3c79ba]{background:#fff;border-radius:16px;padding:0 21px;padding-bottom:37px}.schooldialog .title[data-v-0a3c79ba]{font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:#666;padding:0 0 0 20px}.el-input__inner[data-v-0a3c79ba]{margin-top:16px;-webkit-appearance:none;background-color:#fff;background-image:none;border-radius:20px;border:1px solid #bfbfbf;box-sizing:border-box;color:#606266;display:inline-block;font-size:inherit;height:40px;line-height:40px;outline:none;padding:0 15px;transition:border-color .2s cubic-bezier(.645,.045,.355,1);width:100%}.select-down[data-v-0a3c79ba]{position:absolute;top:80px;left:10px;right:10px;z-index:1000;background:#fff;box-shadow:0 3px 15px 0 rgba(136,148,189,.31);border-radius:16px;max-height:250px;overflow:scroll}.select-down li[data-v-0a3c79ba]{padding:10px 19px;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:#333}.select-down li[data-v-0a3c79ba]:active{background:#f2f4fb}.shoolsureBtn[data-v-0a3c79ba]{margin-top:33px;background:linear-gradient(104deg,#00cefc,#008af9);box-shadow:0 4px 11px 0 rgba(0,127,204,.31);border-radius:20px;text-indent:none;border:none;display:block;width:100%;color:#fff;height:40px}.banner[data-v-0a3c79ba]{height:67px;overflow:hidden;position:absolute;z-index:1000;width:100%;top:56vw}.banner a[data-v-0a3c79ba]{width:100%;height:100%;display:block}.banner img[data-v-0a3c79ba]{width:100%;height:67px;display:block}.rightFocus[data-v-0a3c79ba]{right:0;width:62.5px}.leftFocus[data-v-0a3c79ba],.rightFocus[data-v-0a3c79ba]{position:absolute;top:0;height:44px;line-height:44px;background:#0084ff;z-index:100;text-align:center;color:#fff;cursor:pointer}.leftFocus[data-v-0a3c79ba]{left:0;width:44px}.weixincode .van-popup[data-v-0a3c79ba]{padding:0}.popup-head[data-v-0a3c79ba]{padding:12px 10px;border-bottom:1px solid #eee;text-align:center}.popup-head .pp-title-top[data-v-0a3c79ba]{display:flex;border-bottom:0;justify-content:center}img[data-v-0a3c79ba]{vertical-align:middle;border:none}.popup .popup-head>div>img[data-v-0a3c79ba]{width:13px;height:7px;align-self:center;margin:0 9px}.popup-title[data-v-0a3c79ba]{margin:0;padding:0;font-size:15px}.popup-body[data-v-0a3c79ba]{padding:10px;text-align:center}.live-way .van-button[data-v-0a3c79ba]{width:200px;margin-bottom:10px;height:34px;line-height:34px}.popup .popup-body[data-v-0a3c79ba]{padding-bottom:10px;padding-top:10px}.popup .popup-end[data-v-0a3c79ba]{font-size:15px;font-weight:500;color:#747474;height:50px;line-height:50px;text-align:center;border-top:1px solid #f0f0f0}.teacherQr[data-v-0a3c79ba]{position:absolute;top:7px;right:10px;width:45px;height:45px;z-index:2002}.loginWay[data-v-0a3c79ba]{padding:10%}.loginWay .qqtitle[data-v-0a3c79ba]{color:#000;font-size:16px;text-align:center}.loginWay .qqBox[data-v-0a3c79ba]{display:block;font-size:12px;color:#000;text-decoration:none;margin:25px 8px 15px;text-align:center}.loginWay .qqlogoImg[data-v-0a3c79ba]{display:block;width:60px;height:60px;margin:0 auto 5px}.qqLogin[data-v-0a3c79ba]{z-index:2002!important}.onlineSchoolLogin[data-v-0a3c79ba]{z-index:2003!important}.onlineSchoolLoginWay[data-v-0a3c79ba]{height:100vh;background:linear-gradient(0deg,#fff 70%,#78d4b6)}.onlineSchoolLoginWay .title[data-v-0a3c79ba]{font-size:24px;font-weight:600;color:#303133;line-height:33px;padding-top:77px;margin-left:7%}.onlineSchoolLoginWay .desc[data-v-0a3c79ba]{font-size:14px;font-weight:400;color:#888;line-height:20px;margin-top:10px;margin-left:7%}.onlineSchoolLoginWay .loginContent .loginOnlineBtn[data-v-0a3c79ba]{width:100%;margin-left:7%;width:86%;height:44px;margin-top:46px;border-radius:22px;background:linear-gradient(95deg,#78d4b6 4%,#0bb67e 95%);font-size:15px}.onlineSchoolLoginWay .loginContent .loginInput[data-v-0a3c79ba]{border:none;background-color:transparent;width:100%;margin-left:10px;flex:1}.onlineSchoolLoginWay .loginContent .passwordInput[data-v-0a3c79ba]{padding-left:8px}.onlineSchoolLoginWay .loginContent .account[data-v-0a3c79ba]{display:flex;margin-top:20px;margin-bottom:10px;height:44px;line-height:44px;margin-left:7%;width:86%;background-color:#f6f6f6;border-radius:22px}.onlineSchoolLoginWay .loginContent .account .area[data-v-0a3c79ba]{font-size:14px;font-weight:550;color:#101010;line-height:44px;margin-left:16px}.onlineSchoolLoginWay .loginContent .sendBtn[data-v-0a3c79ba]{float:right}.onlineSchoolLoginWay .loginContent .password[data-v-0a3c79ba]{margin-top:20px;margin-bottom:10px;height:44px;line-height:44px;margin-left:7%;width:86%;background-color:#f6f6f6;border-radius:22px}.weixincode .van-popup[data-v-0a3c79ba]{border-radius:0}.onlineSchoolLoginWay .loginContent .password .van-button--primary[data-v-0a3c79ba]{background-color:transparent;border:none;color:#10a675;font-size:14px;margin-top:7px;margin-right:10px}", ""]);

// exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(510);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("46f37891", content, true);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".SPZBPlayer .controns{display:none!important}", ""]);

// exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _swipe = __webpack_require__(35);

var _swipe2 = _interopRequireDefault(_swipe);

var _swipeItem = __webpack_require__(36);

var _swipeItem2 = _interopRequireDefault(_swipeItem);

var _picker = __webpack_require__(72);

var _picker2 = _interopRequireDefault(_picker);

var _radio = __webpack_require__(74);

var _radio2 = _interopRequireDefault(_radio);

var _radioGroup = __webpack_require__(77);

var _radioGroup2 = _interopRequireDefault(_radioGroup);

var _tab = __webpack_require__(43);

var _tab2 = _interopRequireDefault(_tab);

var _tabs = __webpack_require__(44);

var _tabs2 = _interopRequireDefault(_tabs);

var _noticeBar = __webpack_require__(45);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

var _dialog = __webpack_require__(46);

var _dialog2 = _interopRequireDefault(_dialog);

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

var _button = __webpack_require__(20);

var _button2 = _interopRequireDefault(_button);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(7);

__webpack_require__(38);

__webpack_require__(39);

__webpack_require__(81);

__webpack_require__(82);

__webpack_require__(83);

__webpack_require__(47);

__webpack_require__(48);

__webpack_require__(49);

__webpack_require__(50);

__webpack_require__(21);

__webpack_require__(25);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _handleim = __webpack_require__(40);

var _handleim2 = _interopRequireDefault(_handleim);

var _data = __webpack_require__(10);

var _data2 = _interopRequireDefault(_data);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _FakeIm = __webpack_require__(86);

var _FakeIm2 = _interopRequireDefault(_FakeIm);

var _vuex = __webpack_require__(29);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

var _qrcoder = __webpack_require__(26);

var _qrcoder2 = _interopRequireDefault(_qrcoder);

var _html2canvas = __webpack_require__(88);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _tfplayer = __webpack_require__(89);

var _tfplayer2 = _interopRequireDefault(_tfplayer);

var _launch = __webpack_require__(90);

var _launch2 = _interopRequireDefault(_launch);

var _ChatRoom = __webpack_require__(91);

var _ChatRoom2 = _interopRequireDefault(_ChatRoom);

var _EmbeddedWeb = __webpack_require__(97);

var _EmbeddedWeb2 = _interopRequireDefault(_EmbeddedWeb);

var _Store = __webpack_require__(98);

var _Store2 = _interopRequireDefault(_Store);

var _ImgText = __webpack_require__(99);

var _ImgText2 = _interopRequireDefault(_ImgText);

var _vote = __webpack_require__(100);

var _vote2 = _interopRequireDefault(_vote);

var _List = __webpack_require__(102);

var _List2 = _interopRequireDefault(_List);

var _shake = __webpack_require__(105);

var _shake2 = _interopRequireDefault(_shake);

var _VideoReView = __webpack_require__(106);

var _VideoReView2 = _interopRequireDefault(_VideoReView);

var _special = __webpack_require__(107);

var _special2 = _interopRequireDefault(_special);

var _payWatch = __webpack_require__(55);

var _payWatch2 = _interopRequireDefault(_payWatch);

var _rightBar = __webpack_require__(110);

var _rightBar2 = _interopRequireDefault(_rightBar);

var _leftBar = __webpack_require__(112);

var _leftBar2 = _interopRequireDefault(_leftBar);

var _proGress = __webpack_require__(113);

var _proGress2 = _interopRequireDefault(_proGress);

var _pieceWise = __webpack_require__(114);

var _pieceWise2 = _interopRequireDefault(_pieceWise);

var _RegisterView = __webpack_require__(115);

var _RegisterView2 = _interopRequireDefault(_RegisterView);

var _telTest = __webpack_require__(41);

var _telTest2 = _interopRequireDefault(_telTest);

var _LinkPopup = __webpack_require__(116);

var _LinkPopup2 = _interopRequireDefault(_LinkPopup);

var _index = __webpack_require__(117);

var _index2 = _interopRequireDefault(_index);

var _tipsView = __webpack_require__(122);

var _tipsView2 = _interopRequireDefault(_tipsView);

var _chatlist = __webpack_require__(512);

var _chatlist2 = _interopRequireDefault(_chatlist);

var _toolbar = __webpack_require__(517);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _index3 = __webpack_require__(118);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_button2.default);

_vue2.default.use(_popup2.default);

_vue2.default.use(_dialog2.default);

_vue2.default.use(_noticeBar2.default);

_vue2.default.use(_tab2.default).use(_tabs2.default);

_vue2.default.use(_radioGroup2.default);
_vue2.default.use(_radio2.default);

_vue2.default.use(_picker2.default);

_vue2.default.use(_swipe2.default).use(_swipeItem2.default);

//./Modular/menu/goodsList/index.vue


exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      tid: 0,
      tosafariShow: false,
      isCanMucsic: true,
      TelTestShow: false,
      registerViewShow: false,
      fans: null,
      user: "",
      loading: false,
      showControl: true,
      isShowControl: true,
      orientation: "portraint",
      initData: null,
      openRolling: false,
      isRolling: false,
      MerryGoRound: "", //走马灯内容
      videoLinkno: "", //mp4第一个视频
      videoImg: "",
      videoDuration: "00:00:00",
      videoCurrentTime: "00:00:00",
      dsMenu: [], //导航栏
      isPlay: false,
      styleType: 1,
      view_num: 0,
      playerStyle: {},
      showCover: true,
      contentStyle: {}, //内容布局
      showhead: false,
      headtitleBg: "#212126",
      showView: true,
      screenH: 0,
      noPlayH: 0,
      before_ad: [], //广告视频
      directStatus: "not_started", //直播状态
      dispark: false,
      titleName: "",
      isshowgift: false,
      controlTimer: null,
      isShowMidControl: false,
      startTime: "",
      bottomSider: true,
      shareData: {},
      fans_id: "",
      ds_id: "",
      shareRedexist: false,
      shareType: 0,
      shareRed: true,
      musicStatusexist: true,
      musicStatus: true,
      musicPlay: true,
      musicList: [],
      musicIndex: 0,
      musicUrl: "",
      talkredexist: false,
      talkred: true,
      talkredstatus: false,
      talktext: "",
      rewardMoney: 0,
      talkType: 0,
      isShowProgress: false,
      playHeight: 0,
      showMenu: true,
      controlStyle: {},
      rainProbab: 0,
      rainId: "",
      isWeixin: true,
      marqueeheight: 0,
      marqueeStyle: "",
      adIndex: -1,
      haveMenu: true,
      toplist: [],
      showBigTable: false,
      scrollDir: "up",
      shareLimit: true,
      breakPoint: [],
      limitText: "",
      desc: "",
      ds_func: {},
      voteList: "",
      TstartTime: "",
      Tend_time: "",
      loaded: false,
      currentMid: "",
      curCid: 1,
      fullscr: false,
      pieceHeight: 0,
      haveNav: false,
      clarityList: [],
      curClarity: "原画",
      showClarity: false,
      videoIndex: 0,
      isIOS: false,
      barHeight: 0,
      currentTime: 0,
      timeupdate: "",
      myPlayer: "",
      wall_id: "",
      share: {
        title: "",
        dec: "",
        image: "",
        url: ""
      },
      passwordID: "",
      forbid: false,
      totalLike: 0,
      dynamicData: "",
      quanData: null,
      rewardQuan: false,
      rewardredpack: false,
      rewardType: 1,
      imgPath: "",
      vid: "",
      uid: "",
      canBack: true,
      playtimer: null,
      playStart: false,
      picComment: false,
      hot: true,
      topAD: false,
      topObj: {},
      StoreUrl: "",
      storeActive: "",
      pic_url: "",
      uploader: "",
      accessid: "",
      accesskey: "",
      host: "",
      policyBase64: "",
      signature: "",
      callbackbody: "",
      entered: true,
      imIsLogin: false,
      shopIndex: -1,
      openShop: false,
      buyList: [],
      buyListIndex: -1,
      salesHeight: 0,
      bannerHeight: 0,
      commentList: [],
      isMaster: 0,
      giftList: null,
      inviting: false,
      wallSign: false,
      payPrice: 1,
      tryOpacity: 0,
      tryTime: 5,
      tryPayBtn: false,
      isTrySee: false,
      tryPrice: 1,
      is_pay: false,
      reload: false,
      showPay: false,
      payIndex: -1,
      coupons: [],
      coupon_id: 0,
      ticket_switch: false,
      couponText: "",
      isGradRedStart: false,
      redBagData: {},
      showrobRedlist: false,
      redBaglistData: {},
      ds_pwd: null,
      allot_sale: false,
      allot: {},
      showAllot: false,
      headerUrl: "",
      code: "",
      headerData: "",
      isPlayUI: false,
      canvas: null,
      base64Img: "",
      IMtimer: null,
      showSchool: false,
      showSchoolSuc: false,
      isShowSchoolSure: false,
      showSchoolTip: false,
      isShowAddressList: false,
      isShowAgeList: false,
      isShowClassList: false,
      userClassName: "",
      navitemWidth: 47,
      isFirstPlay: true,
      currLiveDic: null, //直播时的链接
      loginErrroStyle: {},
      isShowLoginErr: false,
      adImages: [],
      isShowAd: false,
      isShowQRimg: false,
      weixincodeUrl: "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/tengface.jpg",
      weixintopText: "关注后可收到直播最新动态哦",
      weixinbottomText: "长按关注公众号接收最新动态",
      isNotShowWebRTC: true,
      rtcClient: null,
      rtcRemoteStream: null,
      playerStatus: 1,
      linkDialogVisible: false,
      linkType: 1, // 1 没有连麦  2 用户申请了连麦  3 正在连麦
      heardTimer: null,
      heardVodTimer: null,
      isSupportRTC: true,
      outOfTime: false,
      showConsultTeacher: false,
      showLiveWay: false,
      selectPlayType: 0,
      verify_comment: false,
      channel_id: "",
      isBlack: false,
      openWx_follow: false, //开启微信
      isShowGift: false, //显示点赞送花
      showTeacherBtn: false,
      playerType: "live",
      currentPlayerData: null,
      show_type: 2, //2手机号短信验证码 3账号密码
      is_all_users_muted: false,
      heart_time: 30,
      need_check_bool: true,
      isShowTeacherQrCode: false,
      isShowTeacherBtnTop: false,
      teacher_qrcode_title: "",
      teacher_qrcode_url: "",
      liveType: "open",
      classUserId: null,
      say_self: {
        enabled: false,
        type: "2",
        all: "2"
      },
      showQQPopUp: false,
      showLineSchoolPopUp: false,
      onlineSendMsgNum: 0,
      onlineSednMsgText: "获取验证码",
      onlineSchoolAccount: "",
      onlineSchoolPassword: "",
      onLIneSchoolSMSCode: "",
      loginType: 1, //1账户密码 2 验证码
      noticeObj: {
        open: false,
        content: "",
        time: 0
      },
      checkNetSchoolTokenTimmer: null,
      showWxPopUp: false,
      noClearScreen: true,
      HeartMode: "",
      im_type: "",
      pageUUID: _Tools2.default.guid(),
      isyxinImLoginOut: false,
      showGoods: false,
      gid: '',
      goodsIdsList: [],
      isshowCart: false,
      showShoppingDialog: false,
      showBuyTipsState: false,
      showShoppingType: false,
      goodsInfo: {}
    }, _defineProperty(_ref, "goodsIdsList", []), _defineProperty(_ref, "inventoryNum", 0), _defineProperty(_ref, "showBuyGoodsTips", false), _defineProperty(_ref, "tipsBuyTimer", null), _defineProperty(_ref, "tipsBuyText", ""), _defineProperty(_ref, "tipsBuyUsername", ""), _defineProperty(_ref, "saveUserBuyList", []), _defineProperty(_ref, "showBuySuccessGoodsTips", false), _defineProperty(_ref, "tipsBuySuccessTimer", null), _defineProperty(_ref, "tipsBuySuccessText", ''), _defineProperty(_ref, "tipsBuySuccessUsername", ''), _defineProperty(_ref, "saveUserBuySuccessList", []), _defineProperty(_ref, "im_type", ""), _defineProperty(_ref, "runObj", {
      open: false,
      fontSize: "",
      fontColor: "",
      fontTrans: 1
    }), _defineProperty(_ref, "copyrightObj", {
      open: false,
      inputValue: "",
      copyrightTrans: 1
    }), _ref;
  },

  computed: _extends({}, (0, _vuex.mapGetters)({
    businessConfigs: "dsInfo/getBusinessConfigs"
  })),
  watch: {},
  components: {
    launch: _launch2.default,
    ChatRoom: _ChatRoom2.default,
    ImgText: _ImgText2.default,
    Vote: _vote2.default,
    List: _List2.default,
    EmbeddedWeb: _EmbeddedWeb2.default,
    Store: _Store2.default,
    shake: _shake2.default,
    VideoReView: _VideoReView2.default,
    special: _special2.default,
    toolBar: _toolbar2.default,
    rightBar: _rightBar2.default,
    leftBar: _leftBar2.default,
    proGress: _proGress2.default,
    pieceWise: _pieceWise2.default,
    RegisterView: _RegisterView2.default,
    TelTest: _telTest2.default,
    payWatch: _payWatch2.default,
    TFPlayer: _tfplayer2.default,
    LinkPopup: _LinkPopup2.default,
    ConsultTeacher: _index2.default,
    tipsView: _tipsView2.default,
    chatlist: _chatlist2.default,
    goodsList: _index4.default
  },
  beforeDestroy: function beforeDestroy() {
    if (this.heardTimer) {
      clearInterval(this.heardTimer);
      this.heardTimer = null;
    }
    if (this.heardVodTimer) {
      clearInterval(this.heardVodTimer);
      this.heardTimer = null;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var that, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this;

              _this.limitText = _Tools2.default.getQueryString("text");
              _this.tid = _Tools2.default.getQueryString("tid");
              _this.user = _Tools2.default.getQueryString("fromuser");
              _this.ds_id = _Tools2.default.getQueryDsId();
              _this.reload = sessionStorage.getItem("reload");
              _this.channel_id = _Tools2.default.getQueryChannelId();
              _context.prev = 7;

              if (!(!_this.ds_id && _this.channel_id)) {
                _context.next = 13;
                break;
              }

              _context.next = 11;
              return _this.axios.post(_Tools2.default.baseUrl1() + "/customer/channel/getDsIdByChannelId", "channel_code=" + _this.channel_id);

            case 11:
              data = _context.sent;

              if (data.data.code == 200) {
                _this.ds_id = data.data.data.ds_id;
                _Tools2.default.setDs_id(_this.ds_id);
              } else {
                (0, _toast2.default)({ message: data.data.message, duration: 0 });
              }

            case 13:
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](7);

              (0, _toast2.default)({ message: '网络存在问题,请刷新重试', duration: 0 });

            case 18:

              if (_this.ds_id) {
                _Tools2.default.setDs_id(_this.ds_id);
              }

              if (!(_this.ds_id && parseInt(_this.ds_id) != _this.ds_id)) {
                _context.next = 22;
                break;
              }

              alert("直播间ID错误，请检查链接");
              return _context.abrupt("return");

            case 22:

              _this.key += _this.ds_id + "/";
              _this.imgPath = _Tools2.default.imgPath();

              sessionStorage.setItem("sid", _this.user);

              _this.isWeixin = _Tools2.default.isWeixin();

              //强制关注参数
              if (_this.limitText) {
                _Tools2.default.setCookie(_this.limitText, true, 30);
                location.href = location.href.split("&text")[0];
              }

              //断点视频参数
              if (_Tools2.default.getQueryString("videoIndex")) {
                _this.videoIndex = _Tools2.default.getQueryString("videoIndex");
              }

              if (localStorage.getItem("forbid") == "true") {
                _this.forbid = true;
              } else {
                _this.forbid = false;
              }

              if (_Tools2.default.checkPhoneType() == 2) {
                _this.isIOS = true;
              }

              if (_this.tid) {
                //这里说明是伪直播
                _Tools2.default.getFakeLiveInfo(_this.tid, function (isOk, fakeInfo) {
                  if (isOk) {
                    _Tools2.default.getDsInfo(function (dsInFo) {
                      that.liveType = dsInFo.direct_seeding.type;
                      _Tools2.default.login(dsInFo.direct_seeding.appid, dsInFo.direct_seeding.uid, function (userInfo) {
                        that.personDataInit(userInfo, dsInFo);
                      });
                    }, fakeInfo);
                  } else {
                    alert("网络错误请稍后重试");
                  }
                });
              } else {
                //获取直播间信息
                _Tools2.default.getDsInfo(function (dsInFo) {
                  that.liveType = dsInFo.direct_seeding.type;
                  that.uid = dsInFo.direct_seeding.uid;
                  that.im_type = dsInFo.direct_seeding.im_type;
                  that.initData = dsInFo;
                  // 微信授权登录
                  _Tools2.default.login(dsInFo.direct_seeding.appid, dsInFo.direct_seeding.uid, function (userInfo) {
                    if (userInfo && userInfo.showQQPopUp) {
                      that.showQQPopUp = true;
                    } else if (userInfo && userInfo.showWxPopUp) {
                      that.showWxPopUp = true;
                      _Tools2.default.LoginJumpWx(dsInFo.direct_seeding.name);
                    }
                    that.personDataInit(userInfo, dsInFo);
                  }, dsInFo.direct_seeding.name);
                  // that.classRoomCheckAccess((isNeedLogin)=>{
                  //     if (isNeedLogin) {//需要网课登录
                  //         that.checkClassLiveUserInfo(dsInFo.direct_seeding.appid,(userInfo)=>{
                  //             that.personDataInit(userInfo, dsInFo);
                  //         });
                  //     }else{

                  //     }
                  // })
                });
              }
              if (_Tools2.default.checkPhoneType() == 2 && _this.isWeixin) {
                _this.isSupportRTC = false;
              }

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[7, 15]]);
    }))();
  },

  methods: {
    /**
     * 描述：展示“正在购买”提示
    **/
    showTipsByUserBuy: function showTipsByUserBuy() {
      var _this2 = this;

      if (this.saveUserBuyList.length > 0) {
        this.showBuyGoodsTips = true;
        var text = this.saveUserBuyList.length > 1 ? "\u7B49" + this.saveUserBuyList.length + "\u4EBA" : '';
        this.tipsBuyText = text + " \u6B63\u5728\u53BB\u8D2D\u4E70";
        this.tipsBuyUsername = this.saveUserBuyList[0];
        this.saveUserBuyList = [];
        this.tipsBuyTimer = setTimeout(function () {
          _this2.showBuyGoodsTips = false;
          if (_this2.tipsBuyTimer) {
            clearTimeout(_this2.tipsBuyTimer);
          }
          _this2.tipsBuyTimer = setTimeout(function () {
            _this2.showTipsByUserBuy();
          }, 300);
        }, 5000);
      } else {
        clearTimeout(this.tipsBuyTimer);
        this.tipsBuyTimer = null;
      }
    },

    /**
     * 描述：展示“购买成功”提示
    **/
    showTipsByUserBuySuccess: function showTipsByUserBuySuccess() {
      var _this3 = this;

      if (this.saveUserBuySuccessList.length > 0) {
        this.showBuySuccessGoodsTips = true;
        var text = this.saveUserBuySuccessList.length > 1 ? "\u7B49" + this.saveUserBuySuccessList.length + "\u4EBA" : '';
        this.tipsBuySuccessText = text + " \u8D2D\u4E70\u6210\u529F";
        this.tipsBuySuccessUsername = this.saveUserBuySuccessList[0];
        this.saveUserBuySuccessList = [];
        this.tipsBuySuccessTimer = setTimeout(function () {
          _this3.showBuySuccessGoodsTips = false;
          if (_this3.tipsBuySuccessTimer) {
            clearTimeout(_this3.tipsBuySuccessTimer);
          }
          _this3.tipsBuySuccessTimer = setTimeout(function () {
            _this3.showTipsByUserBuySuccess();
          }, 300);
        }, 5000);
      } else {
        clearTimeout(this.tipsBuySuccessTimer);
        this.tipsBuySuccessTimer = null;
      }
    },
    toGoodsDetailPage: function toGoodsDetailPage() {
      var _goodsInfo = this.goodsInfo,
          id = _goodsInfo.id,
          jump = _goodsInfo.jump,
          payurl = _goodsInfo.payurl;

      if (jump === 1) {
        window.open(payurl);
        return;
      }
      this.$router.push({ path: "/goodsDetail?id=" + id + "&uid=" + this.uid + "&channel_id=" + this.channel_id + "&dsId=" + this.ds_id });
    },
    hideShoppingPop: function hideShoppingPop() {
      localStorage.setItem('IS_SHOW_ShOPPING_CART', '1');
      this.showShoppingDialog = false;
    },
    goodsListCloseBtnClicked: function goodsListCloseBtnClicked() {
      this.showGoods = false;
    },
    onShowTeacherList: function onShowTeacherList() {
      this.showConsultTeacher = true;
      this.$refs.consultTeacher.switchTimeList();
    },
    onShowGoodsList: function onShowGoodsList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$refs.goodsList.getGoodsList();

              case 2:
                _this4.showGoods = true;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    onlineSchoolLoginClick: function onlineSchoolLoginClick() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var postData, data, postData2, data2;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this5.onlineSchoolAccount == "")) {
                  _context3.next = 3;
                  break;
                }

                (0, _toast2.default)("账号不能为空");
                return _context3.abrupt("return");

              case 3:
                if (!(_this5.onLIneSchoolSMSCode == "")) {
                  _context3.next = 6;
                  break;
                }

                (0, _toast2.default)("验证码不能为空");
                return _context3.abrupt("return");

              case 6:
                _context3.prev = 6;
                postData = {
                  area: 86,
                  phone: _this5.onlineSchoolAccount,
                  code: _this5.onLIneSchoolSMSCode,
                  org_id: _this5.uid
                };
                // this.showLineSchoolPopUp = false;

                _context3.next = 10;
                return _this5.axios.post(_Tools2.default.baseUrlSchool() + "/user/index/phoneLogin", _qs2.default.stringify(postData));

              case 10:
                data = _context3.sent;

                console.log("data", data);

                if (!(data.data.code == 200)) {
                  _context3.next = 22;
                  break;
                }

                _Tools2.default.setCookie("netschool_token", data.data.data.token, 30);
                postData2 = {
                  fans_id: data.data.data.fansId,
                  ds_id: _this5.ds_id
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData2));
                _context3.next = 18;
                return _this5.axios.post(_Tools2.default.baseUrlSchool() + "/stu/course/dsAuth", _qs2.default.stringify(postData2));

              case 18:
                data2 = _context3.sent;

                if (data2.data.code == 200) {
                  if (data2.data.data.result) {
                    _Tools2.default.getUserInfoReloadByToken(data2.data.data.liveToken);
                  } else {
                    (0, _toast2.default)("此账号无权限观看此课程请联系管理员开通");
                  }
                } else {
                  (0, _toast2.default)(data2.data.message);
                }
                _context3.next = 23;
                break;

              case 22:
                (0, _toast2.default)(data.data.message);

              case 23:
                _context3.next = 28;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t0 = _context3["catch"](6);

                console.error("onlineSchoolLoginClick", _context3.t0);

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[6, 25]]);
      }))();
    },
    onlineSchoolPWDLoginClick: function onlineSchoolPWDLoginClick() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var postData, data, postData2, data2;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this6.onlineSchoolAccount == "")) {
                  _context4.next = 3;
                  break;
                }

                (0, _toast2.default)("账号不能为空");
                return _context4.abrupt("return");

              case 3:
                if (!(_this6.onlineSchoolPassword == "")) {
                  _context4.next = 6;
                  break;
                }

                (0, _toast2.default)("密码不能为空");
                return _context4.abrupt("return");

              case 6:
                _context4.prev = 6;
                postData = {
                  account: _this6.onlineSchoolAccount,
                  password: _this6.onlineSchoolPassword,
                  org_id: _this6.uid
                };
                _context4.next = 10;
                return _this6.axios.post(_Tools2.default.baseUrlSchool() + "/user/index/login", _qs2.default.stringify(postData));

              case 10:
                data = _context4.sent;

                console.log("data", data);

                if (!(data.data.code == 200)) {
                  _context4.next = 22;
                  break;
                }

                _Tools2.default.setCookie("netschool_token", data.data.data.token, 30);
                postData2 = {
                  fans_id: data.data.data.fansId,
                  ds_id: _this6.ds_id
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData2));
                _context4.next = 18;
                return _this6.axios.post(_Tools2.default.baseUrlSchool() + "/stu/course/dsAuth", _qs2.default.stringify(postData2));

              case 18:
                data2 = _context4.sent;

                if (data2.data.code == 200) {
                  if (data2.data.data.result) {
                    _Tools2.default.getUserInfoReloadByToken(data2.data.data.liveToken);
                  } else {
                    (0, _toast2.default)("此账号无权限观看此课程请联系管理员开通");
                  }
                } else {
                  (0, _toast2.default)(data2.data.message);
                }
                _context4.next = 23;
                break;

              case 22:
                (0, _toast2.default)(data.data.message);

              case 23:
                _context4.next = 28;
                break;

              case 25:
                _context4.prev = 25;
                _context4.t0 = _context4["catch"](6);

                console.error("onlineSchoolLoginClick", _context4.t0);

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[6, 25]]);
      }))();
    },
    checkNetSchoolTokenValid: function checkNetSchoolTokenValid() {
      this.axios.post(_Tools2.default.baseUrlSchool() + "/user/index/checkToken").then(function (res) {}).catch(function (error) {
        console.log(error);
      });
    },
    qqloginTap: function qqloginTap() {
      _Tools2.default.LoginJumpQQ(this.initData.direct_seeding.name);
    },
    wxloginTap: function wxloginTap() {
      _Tools2.default.LoginJumpWx(this.initData.direct_seeding.name);
    },
    closeWindow: function closeWindow() {
      wx.closeWindow();
    },
    onlineLineSchoolSendMsg: function onlineLineSchoolSendMsg() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var postData, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                postData = {
                  area: 86,
                  phone: _this7.onlineSchoolAccount,
                  org_id: _this7.uid
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData));
                _context5.next = 5;
                return _this7.axios.post(_Tools2.default.baseUrlSchool() + "/common/index/sendSms", _qs2.default.stringify(postData));

              case 5:
                data = _context5.sent;

                console.log("data", data);
                if (data.data.code == 200) {
                  _this7.sendMsgStartTimer();
                } else {
                  (0, _toast2.default)(data.data.message);
                }
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                console.error("checkClassLiveUserInfo", _context5.t0);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 10]]);
      }))();
    },
    sendMsgStartTimer: function sendMsgStartTimer() {
      var _this8 = this;

      this.onlineSednMsgText = "59S";
      this.onlineSendMsgNum = 59;
      this.onlineSchoolTimer = setInterval(function () {
        _this8.onlineSendMsgNum = _this8.onlineSendMsgNum - 1;
        if (_this8.onlineSendMsgNum <= 0) {
          _this8.onlineSendMsgNum = 0;
          _this8.onlineSednMsgText = "获取验证码";
          clearInterval(_this8.onlineSchoolTimer);
          return;
        }
        _this8.onlineSednMsgText = _this8.onlineSendMsgNum + "S";
      }, 1000);
    },
    showTeacherQrCodeCliced: function showTeacherQrCodeCliced() {
      this.isShowTeacherQrCode = false;
      this.isShowTeacherBtnTop = true;
    },
    showTeacherBtnTopClicked: function showTeacherBtnTopClicked() {
      this.isShowTeacherQrCode = true;
      this.isShowTeacherBtnTop = false;
    },
    playFailed: function playFailed(playType, data) {
      if (playType != 2) {
        (0, _toast2.default)("加载视频失败,正在切换备选线路");
        this.$refs.tfPlayer.changePlayType(2);
      } else {
        (0, _toast2.default)("加载视频失败,请检查网络");
      }
    },
    onShowFouceAlert: function onShowFouceAlert() {
      this.isShowQRimg = true;
    },
    changePlayType: function changePlayType(type) {
      this.showLiveWay = false;
      this.$refs.tfPlayer.changePlayType(type);
      //走结束连麦流程
      this.$refs.tfPlayer.rtcLinkDown();
      this.linkType = 1;
    },
    isSupportRTCCallBack: function isSupportRTCCallBack(value) {
      console.log("isSupportRTCCallBack", value);
    },
    unAutoPlay: function unAutoPlay(message) {
      var _this9 = this;

      if (message.type == 511) {
        _dialog2.default.alert({
          message: "正在直播，点击观看精彩直播",
          confirmButtonText: "点击观看"
        }).then(function () {
          _this9.$refs.tfPlayer.playVideoClicked();
        });
      } else {
        console.error("1371", message.message);
        (0, _toast2.default)(message.message);
      }
    },
    consultTeacherCloseBtnClicked: function consultTeacherCloseBtnClicked() {
      this.showConsultTeacher = false;
    },

    // onShowTeacherList() {
    //   this.showConsultTeacher = true;
    //   this.$refs.consultTeacher.switchTimeList();
    // },
    sendApplyLink: function sendApplyLink() {
      var canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
      if (_Tools2.default.isWeixin() && this.isIOS && !canLink) {
        this.tosafariShow = true;
        return;
      }
      this.linkType = 1;
      this.linkDialogVisible = true;
    },
    sendEndLink: function sendEndLink() {
      this.linkDialogVisible = true;
    },
    playerStatusChange: function playerStatusChange(to, playType) {
      this.playerStatus = to;
      this.selectPlayType = playType;
      console.log("播放状态变化了", to, playType);
      if (to == 2) {
        this.hideMusicAndStop();
      } else if (to == 1 || to == 3) {
        this.showMusic();
      }
    },
    linkTypeChange: function linkTypeChange(to) {
      this.linkType = to;
      console.log("连麦状态变化了");
    },
    tryLogin: function tryLogin() {
      location.reload();
    },
    loadAll: function loadAll(data) {
      var that = this;
      // data.direct_seeding.play_style = 3
      this.initData = data;
      //this.isRegisterData();
      this.loaded = true;
      this.init();
      //获取动态数据接口
      // alert("sdfsdf"+that.fans_id)
      if (that.fans_id) {
        this.getDynamicData();
        this.isShowLoginErr = false;
        _toast2.default.clear();
      } else {
        // this.isShowLoginErr = true;
        if (!this.showQQPopUp && !this.showWxPopUp) {
          //如果不是QQ弹窗
          _toast2.default.clear();
          _Tools2.default.clearFansInfo();
          (0, _toast2.default)("登录失败！");
          setTimeout(function () {
            location.reload();
          }, 1000);
        }
      }

      // this.initUI();

      setTimeout(function () {
        that.handleTabClick(0);
      }, 300);

      setTimeout(function () {
        that.setControl();
        var clarity = localStorage.getItem("clarity");
        if (clarity == "hls_fhd") {
          that.curClarity = "超清";
        } else if (clarity == "hls_hd") {
          that.curClarity = "高清";
        } else if (clarity == "hls_standard") {
          that.curClarity = "标清";
        } else if (clarity == "hls_smooth") {
          that.curClarity = "流畅";
        } else if (clarity == "playback" || !clarity) {
          that.curClarity = "原画";
        }
      }, 300);

      this.playBack();
      //数据统计上报接口
      // this.resize();
      // 上报渠道信息
      if (this.fans_id) {
        this.channelInfoUpload();
      }
    },
    personDataInit: function personDataInit(fans, dsInfo) {
      //获取用户信息
      var that = this;
      //重缓存中获取数据
      this.fans = fans;
      this.fans_id = this.fans.fans_id;
      this.headerUrl = this.fans.header;

      var queryData = _Tools2.default.getQueryData(location.href);
      var hasToken = false;
      if (queryData.token !== "" && queryData.token) {
        hasToken = true;
      }
      var otherLogin = getQueryString("other");
      //替换邀请码
      if (this.user != this.fans_id && this.fans_id && this.fans.token || this.isIOS && this.isWeixin && !hasToken && !otherLogin) {
        var data = _Tools2.default.getQueryData(location.href);
        data.fromuser = this.fans_id;
        if (this.isIOS && this.isWeixin && !otherLogin) {
          data.token = this.fans.token;
        }
      }

      // 上报邀请数据
      if (this.user && this.fans_id) {
        this.invite();
      }

      // 加载微信分享参数
      that.shareToWeChat();
      //获取直播间信息
      this.loadAll(dsInfo);
    },
    classRoomCheckAccess: function classRoomCheckAccess(callback) {
      var _this10 = this;

      if (this.liveType == 'class') {
        this.axios.post(_Tools2.default.baseUrl1() + "/customer/index/qryUserConfigs", _qs2.default.stringify({ uid: this.uid })).then(function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
            var data1, businessConfigsTmp;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    data1 = res.data.data;

                    if (res.data.code == "200") {
                      if (data1) {
                        businessConfigsTmp = {};

                        data1.forEach(function (item) {
                          businessConfigsTmp[item.key] = item.value == "true";
                        });

                        if (businessConfigsTmp.classroom_check_access) {
                          callback && callback(true);
                        } else {
                          callback && callback(false);
                        }
                      }
                    }

                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, _this10);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()).catch(function (error) {
          callback && callback(false);
          console.log(error);
        });
      } else {
        callback && callback(false);
      }
    },
    checkClassLiveUserInfo: function checkClassLiveUserInfo(appid, callback) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var userInfo, postData, data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                userInfo = _Tools2.default.getCacheUserInfo(appid);

                if (!userInfo) {
                  _context7.next = 16;
                  break;
                }

                _context7.prev = 2;
                postData = {
                  fans_id: userInfo.fans_id,
                  ds_id: _this11.ds_id
                };

                console.log("qs.stringify(postData)", _qs2.default.stringify(postData));
                _context7.next = 7;
                return _this11.axios.post(_Tools2.default.baseUrlSchool() + "/stu/course/dsAuth", _qs2.default.stringify(postData));

              case 7:
                data = _context7.sent;

                if (data.data.code == 222222) {
                  _this11.showLineSchoolPopUp = true;
                  _this11.loaded = true;
                } else if (data.data.code == 200) {
                  console.log("有权限,可以看");
                  callback && callback(userInfo);
                  _this11.checkNetSchoolTokenValid();
                  setInterval(function () {
                    _this11.checkNetSchoolTokenValid();
                  }, 10000);
                } else {
                  console.log("1519", data);
                  (0, _toast2.default)(data.data.message);
                  _this11.showLineSchoolPopUp = true;
                  _this11.loaded = true;
                }
                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](2);

                console.error("checkClassLiveUserInfo", _context7.t0);

              case 14:
                _context7.next = 19;
                break;

              case 16:
                console.error("checkClassLiveUserInfo-showLineSchoolPopUp");
                _this11.showLineSchoolPopUp = true;
                _this11.loaded = true;

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this11, [[2, 11]]);
      }))();
    },
    isRegisterData: function isRegisterData() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios.post(_Tools2.default.baseUrl3() + "/infoCollection/isRegister", option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          if (data.data.isRegister == 0) {
            var dateStr = "2019-03-31 22:00:00";
            dateStr = dateStr.substring(0, 19);
            dateStr = dateStr.replace(/-/g, "/");
            var timestamp = new Date(dateStr).getTime();
            if (timestamp > new Date().getTime()) {
              that.showSchool = true;
            }
          } else {
            that.userClassName = data.data.where.area + data.data.where.school + data.data.where.grade + data.data.where.class;
            that.showSchoolTip = true;
          }
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    getDynamicData: function getDynamicData() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios.post(_Tools2.default.baseUrl2() + "/init/getDynamicData", option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          that.dynamicData = data.data;
          // that.view_num = data.data.view_num;
          that.totalLike = data.data.like_num;

          if (data.data.share_red_chance > 0) {
            //开启分享得红包
            that.shareRedexist = true;
            that.shareType = 0;
          } else if (data.data.share_coupon_chance > 0) {
            //开启分享得卡券
            that.shareRedexist = true;
            that.shareType = 1;
          }

          if (data.data.pwd_red_chance > 0) {
            //口令的红包
            // that.talkredexist = true;
            // that.talkType = 0;
          } else if (data.data.pwd_coupon_chance > 0) {
            //口令的卡券
            that.talkredexist = true;
            that.talkType = 1;
          }

          if (data.data.red_rain != null) {
            that.rainProbab = data.data.red_rain.percent;
            that.rainId = data.data.red_rain.msgid;
            that.$refs.redrain.redbagRain();
          }
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    switchVideo: function switchVideo(item, index) {
      //切换视频信息
      if (index == this.videoIndex) {
        return;
      }
      this.videoIndex = index;
    },
    getISBack: function getISBack(callBack) {
      var that = this;
      var option = "ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl2() + "/ds/getIsBlack", option, {
        credentials: false,
        emulateJSON: true
      }).then(function (data) {
        if (data.data.code == 200) {
          if (data.data.data.in_black == "yes") {
            that.isBlack = true;
            callBack && callBack(true);
          } else {
            callBack && callBack(false);
          }
        } else if (data.data.code != 100068 && data.data.code != 100067) {
          callBack && callBack(false);
        }
      }).catch(function (data) {
        callBack && callBack(false);
        console.log("错误" + data);
      });
    },
    invite: function invite() {
      if (this.user && this.fans_id != this.user) {
        var that = this;
        var option = "invite_id=" + this.user + "&ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;

        if (this.tid) {
          option = option + "&tid=" + this.tid;
        }
        this.axios.post(_Tools2.default.baseUrl3() + "/invite/index", option, {
          credentials: false,
          emulateJSON: true
        }).then(function (data) {
          var data = data.data;
        }).catch(function (data) {
          console.log("错误" + data);
        });
      }
    },
    sedTalk: function sedTalk() {
      this.$refs.toolbar.sendTalk(this.talktext, this.passwordID, this.talkType);
      this.talkredstatus = false;
    },
    showtalkredpoup: function showtalkredpoup() {
      this.talkredstatus = !this.talkredstatus;
    },
    colsetalkred: function colsetalkred() {
      this.talkred = false;
    },
    showtalk: function showtalk(data) {
      this.rewardType = 1;
      if (this.talkType == 0) {
        this.rewardredpack = true;
        this.rewardMoney = data.money;
        this.talkred = false;
      } else {
        this.rewardQuan = true;
        this.quanData = data;
      }
    },
    closeRedpack: function closeRedpack() {
      this.rewardredpack = false;
    },
    closeQuan: function closeQuan() {
      this.rewardQuan = false;
    },
    getMusic: function getMusic() {
      if (this.initData.music_list) {
        this.musicList = this.initData.music_list;
        var self = this;
        setTimeout(function () {
          self.initMusic();
        }, 500);
      }
    },
    setMusic: function setMusic() {
      var audio = document.getElementById("audio");
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    stopMusic: function stopMusic() {
      //如果有音乐关闭音乐
      var audio = document.getElementById("audio");
      if (audio) {
        audio.pause();
      }
      // 移除音乐监听
      document.body.removeEventListener("click", this.playmusic);
    },
    hideMusicAndStop: function hideMusicAndStop() {
      this.stopMusic();
      this.musicStatus = false;
    },
    showMusic: function showMusic() {
      this.musicStatus = true;
    },
    initMusic: function initMusic() {
      var that = this;
      var audio = document.getElementById("audio");
      this.musicUrl = this.musicList[0].url;
      audio.addEventListener("play", function () {
        that.musicPlay = true;
      });
      audio.addEventListener("pause", function () {
        that.musicPlay = false;
      });
      audio.addEventListener("ended", function () {
        if (that.musicList.length > 0) {
          that.musicIndex++;
          if (that.musicIndex == that.musicList.length) {
            that.musicIndex = 0;
          }
          that.musicUrl = that.musicList[that.musicIndex].url;
          audio.load();
          setTimeout(function () {
            audio.play();
          }, 300);
        }
      });
      this.triggerAudio();
    },
    resize: function resize() {
      var that = this;
      window.onresize = function (e) {
        if (that.isIOS) {
          return false;
        }
        //页面大小改变了
        var clientH = document.documentElement.clientHeight;
        var screenH = window.screen.height;
        var w = window.screen.width;
        //判断是否进入播放模式但是没有横屏  全屏
        that.fullscr = false;
        if (that.orientation == "portraint") {
          if (clientH != that.noPlayH) {
            if (clientH > that.noPlayH) {
              that.playUI();
            }
          } else {
            that.initUI();
          }
        } else {
          if (that.screenH != screenH && that.noPlayH != clientH) {
            //进入横屏状态
            that.fullScreenUI();
          } else {
            //退出横屏状态
            that.orientation = "portraint";
            that.initUI();
          }
        }
      };
    },
    triggerAudio: function triggerAudio() {
      document.body.addEventListener("click", this.playmusic);
    },
    playmusic: function playmusic() {
      var audio = document.getElementById("audio");
      audio.play();
      document.body.removeEventListener("click", this.playmusic);
    },
    cash: function cash() {
      this.$router.push({
        name: "UserInfo"
      });
    },
    cards: function cards() {
      this.$router.push({
        name: "cards"
      });
    },
    closeload: function closeload() {
      var _this12 = this;

      if (!this.loading) {
        setTimeout(function () {
          if (!_this12.showQQPopUp && !_this12.showWxPopUp) {
            _this12.$refs.tfPlayer && _this12.$refs.tfPlayer.playVideoClicked();
          }
        }, 200);
      }
      this.loading = true;
    },
    registerViewClose: function registerViewClose() {},
    limit: function limit() {
      var passwd = this.ds_pwd.params.http_url;
      var today = new Date().toLocaleDateString();

      if (this.ds_pwd.params.view_type == "password_view") {
        console.log(localStorage.getItem("passwordDay"));
        if (localStorage.getItem("passwordDay") == null || localStorage.getItem("passwordDay") != today) {
          this.$router.push({
            name: "payWatch",
            params: {
              type: 1
            }
          });
        } else {
          this.shareLimit = true;
        }
      } else if (this.ds_pwd.params.view_type == "allot_sale_view") {
        this.allot_sale = true;
        this.allot = this.initData.ds_pwd.params;
        this.allot.title = this.initData.direct_seeding.name;
        //需要付费观看
        // this.ispay();
      } else {
          //需要付费观看
          // this.ispay();
        }
    },
    ispay: function ispay() {
      var that = this;
      var url = _Tools2.default.baseUrl() + "/directSeeding/ticket/isPayed";
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          if (data.data.is_pay == 0) {
            if (that.ds_pwd.params.view_type == "allot_sale_view") {
              setTimeout(function () {
                that.$router.push({
                  path: "/payWatch/3/" + that.fans_id
                });
              }, 2000);
            } else {
              if (that.isTrySee) {
                that.is_pay = false;
              } else {
                that.$router.push({
                  name: "payWatch",
                  params: {
                    type: 2
                  }
                });
              }
            }
          } else {
            if (that.isTrySee) {
              that.is_pay = true;
            } else {
              that.shareLimit = true;
            }
          }
        }
      }).catch(function (res) {
        (0, _toast2.default)("请求错误" + res.data.message);
      });
    },
    hidefunc: function hidefunc() {
      var audio = document.getElementById("audio");
      console.log(audio);
      if (audio) {
        if (this.shareRedexist) {
          this.shareRed = false;
        }
        if (this.musicStatusexist) {
          audio.pause();
          this.musicStatus = false;
        }
      }
    },
    playerListener: function playerListener(data) {
      if (data.playType == "vod") {
        this.playerType = "vod";
        if (data.type == "timeupdate") {
          this.currentPlayerData = data;
        }
      }
    },
    showfunc: function showfunc() {
      if (this.talkredexist) {
        this.talkred = true;
      }
      if (this.shareRedexist) {
        this.shareRed = true;
      }
      if (this.musicStatusexist) {
        this.musicStatus = true;
      }
    },
    talkredend: function talkredend() {
      this.talkredexist = false;
    },
    shareredend: function shareredend() {
      this.shareRedexist = false;
    },
    init: function init() {
      var _this13 = this;

      var that = this;
      this.myPlayer = document.getElementById("myVideo");

      this.titleName = this.initData.direct_seeding.name;
      if (this.initData.direct_seeding.style != 0) {
        this.styleType = this.initData.direct_seeding.style;
      }
      if (this.initData.comment_list) {
        this.commentList = this.initData.comment_list;
      }

      document.title = this.initData.direct_seeding.name;
      this.uid = this.initData.direct_seeding.uid;
      this.giftList = this.initData.gift_list;
      this.ds_pwd = this.initData.ds_pwd;
      this.noPlayH = document.documentElement.clientHeight;
      this.screenH = window.screen.height;

      this.dsMenu = this.initData.ds_menu;

      for (var i = 0; i < this.dsMenu.length; i++) {
        if (this.dsMenu[i].cid == 9) {
          this.shopIndex = i;
          this.openShop = true;
          this.salesHeight = 24;
        }
      }

      this.navitemWidth = (window.screen.width - 62.5 - 44) / this.dsMenu.length;

      this.breakPoint = this.initData.direct_seeding.break_point ? this.initData.direct_seeding.break_point : [];

      this.voteList = this.initData.vote_list;

      if (this.initData.wall_sign_conf != null && this.initData.wall_sign_conf.is_open != 0) {
        this.wall_id = this.initData.wall_sign_conf.wall_id;
        this.payPrice = this.initData.wall_sign_conf.price;
        this.wallSign = true;
      }

      _data2.default.verifyCode = this.initData.verifyCode;

      if (this.dsMenu.length == 0) {
        this.haveMenu = false;
      }

      this.is_all_users_muted = this.initData.direct_seeding.comment_on_off == 0;

      this.fullscr = false;
      //功能解析
      var Obj = this.ds_func;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.initData.ds_func[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var j = _step.value;

          Obj[j.module] = j.params || true;
          if (j.module == "red_password" || j.module == "coupon_password") {
            this.passwordID = j.module.id;
          } else if (j.module == "master") {
            //主持人功能
            if (this.fans_id == j.params.fans_id) {
              this.isMaster = 1;
            }
            console.log(this.isMaster + "////");
          }

          if (j.module == "say_self") {
            //自嗨
            this.say_self = {
              enabled: true,
              type: j.params.type,
              all: j.params.all
            };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var obj2 = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.initData.ds_func[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _j = _step2.value;

          obj2[_j.module] = _j;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.ds_func = Obj;

      //判断是否是黑名单

      this.fans_id && this.getISBack(function (isBlack) {
        if (!isBlack) {
          _this13.loginIM(); //登录IM
          if (obj2.view_auth && (obj2.view_auth.params.view_type == "white_num_view" || obj2.view_auth.params.view_type == "account_white_list")) {
            console.log("account_white_list", obj2.view_auth.params);
            //白名单
            if (obj2.view_auth.params.view_type == "white_num_view") {
              that.need_check_bool = obj2.view_auth.params.need_check == 1;
            }
            //开启了手机号密码或者账号密码
            var option = "ds_id=" + _this13.ds_id + "&fans_id=" + _this13.fans_id;
            _this13.axios.post(_Tools2.default.baseUrl1() + "/wap/index/whiteLoginCheck", option, {
              fans_id: _this13.fans_id,
              credentials: false,
              emulateJSON: true
            }).then(function (res) {
              if (res.data.code == 200) {
                if (res.data.data.is_white_checked == "true") {
                  that.TelTestShow = false;
                  console.log("用户已验证");
                  //心跳
                  that.isWeixinUserCheck(function (isSuccess) {
                    isSuccess && that.getHeartMode();
                  });
                } else {
                  if (obj2.view_auth.params.view_type == "account_white_list") {
                    //账号白名单
                    that.show_type = 3;
                  } else {
                    that.show_type = 2;
                  }

                  that.TelTestShow = true;
                  console.log("用户未验证");
                }
              } else {
                this.$message.error(res.data.message);
              }
            }).catch(function (res) {
              (0, _toast2.default)("请求错误" + res.data.message);
            });
          } else {
            //没有开启白名单 //地理位置上报
            _this13.isWeixinUserCheck(function (isSuccess) {
              isSuccess && _this13.getHeartMode();
            });
          }
        }
      });

      if (obj2.check_play && obj2.check_play.enabled == "yes") {
        //开启了登记观看
        var _that = this;
        var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
        if (this.fans_id) {
          this.registerViewShow = true;
          this.axios.post(_Tools2.default.baseUrl1() + "/wap/index/isRegist", option, {
            ds_id: this.dsId,
            fans_id: this.fans_id,
            credentials: false,
            emulateJSON: true
          }).then(function (res) {
            if (res.data.code == 200) {
              if (res.data.data.isRegist == "yes") {
                _that.registerViewShow = false;
                console.log("用户已登记");
              } else {
                _that.registerViewShow = true;
                console.log("用户未登记");
              }
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(function (res) {
            (0, _toast2.default)("请求错误" + res.data.message);
          });
          console.log("用户开启了登记观看");
        }
      }

      if (Obj.rolling) {
        //跑马灯
        this.openRolling = true;
        this.isRolling = true;
        this.MerryGoRound = Obj.rolling.text.replace(/\d{11}/g, function (data) {
          return '<a href="tel:' + data + '">' + data + "</a>";
        });
        this.scrollDir = Obj.rolling.position;
        this.marqueeStyle = ";color:" + Obj.rolling.color + ";font-size:" + Obj.rolling.fontsize + "px;";
        if (this.scrollDir == "down") {
          this.marqueeheight = -20;
          this.marqueeStyle += "top:56vw";
        } else {
          this.barHeight = 20;
        }
      }

      // if (Obj.bg_music) {
      //   //开启背景音乐
      //   this.getMusic();
      // } else {
      //   this.musicStatusexist = false;
      // }

      if (Obj.before_ad) {
        //广告视频
        if (Obj.before_ad.user_type == 1) {
          this.before_ad = [{
            url: Obj.before_ad.ad_url
          }];
        } else {
          this.before_ad = JSON.parse(Obj.before_ad.video_list);
        }
      }

      if (Obj.gift) {
        //开启礼物
        this.isshowgift = true;
      }

      // if (Obj.consulting_teacher) {
      //   this.showTeacherBtn = true;
      // }

      if (!Obj.boot_pic) {
        //关闭大图
        this.loading = true;
        //播放
        setTimeout(function () {
          if (!_this13.showQQPopUp && !_this13.showWxPopUp) {
            _this13.$refs.tfPlayer && _this13.$refs.tfPlayer.playVideoClicked();
          }
        }, 200);
      }

      if (Obj.share) {
        //自定义分享功能
        this.shareData = Obj.share;
      }

      // if (Obj.top_list) {
      //   //开启榜单
      //   this.toplist = Obj.top_list.type;
      // }

      if (Obj.verify_comment) {
        //开启评论审核
        this.verify_comment = true;
      }
      console.log("开启榜单", Obj);

      if (Obj.big_turn_table && this.initData.big_turn_table) {
        //大转盘
        if (this.isWeixin) {
          this.showBigTable = true;
          this.TstartTime = this.initData.big_turn_table.start_time;
          this.Tend_time = this.initData.big_turn_table.end_time;
          this.$refs.left.timeSwitch(this.TstartTime, this.Tend_time);
        }
      }

      // if (Obj.nav) {
      //   //开启导航条
      //   this.haveNav = true;
      //   this.pieceHeight = 40;
      // }

      // if (Obj.pic_comment) {
      //   //图文评论
      //   this.picComment = true;
      // }

      // if (Obj.top_ad) {
      //   //顶部广告
      //   this.topAD = true;
      //   this.topObj = Obj.top_ad;
      // }

      if (Obj.hot) {
        //热度
        this.hot = true;
      } else {
        this.hot = false;
      }

      if (Obj.wx_follow) {
        this.openWx_follow = true;
        this.weixincodeUrl = Obj.wx_follow.pic_url;
        this.weixintopText = Obj.wx_follow.remark;
        this.weixinbottomText = Obj.wx_follow.wx_under_des;
        this.isShowQRimg = Obj.wx_follow.float == "yes";
        // this.isShowQRimg = Obj.wx_follow.wx_show_now == "yes";
      }
      if (Obj.shopping_cart) {
        //开启购物车
        this.isshowCart = true;
        if (Obj.shopping_cart.length > 0) {
          var _Obj$shopping_cart$ = Obj.shopping_cart[0],
              type = _Obj$shopping_cart$.type,
              shangpingID = _Obj$shopping_cart$.shangpingID;
          // 如果已经显示过了，再次返回到首页则不再显示购物车弹框

          var isFirstShow = localStorage.getItem('IS_SHOW_ShOPPING_CART');
          if (isFirstShow !== '1') {
            if (type === '3') {
              this.showShoppingDialog = true;
            } else if (type === '2') {
              this.showShoppingType = true;
            }
            // 标记已显示
            localStorage.setItem('IS_SHOW_ShOPPING_CART', '1');
          }
          if (type !== '1') {
            // 二、三购物车样式只会有一个商品信息
            this.goodsInfo = shangpingID[0];
            this.goodsIdsList = [this.goodsInfo.id];
          } else {
            // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
            this.goodsInfo = {};
            this.goodsIdsList = shangpingID;
          }
        }
      } else {
        localStorage.removeItem('IS_SHOW_ShOPPING_CART');
      }
      // 是否开启购买提示
      if (Obj.purchase_prompt) {
        this.showBuyTipsState = true;
      }
      // if (Obj.ad) {
      //   this.isShowAd = true;
      //   this.adImages = Obj.ad;
      //   this.bannerHeight = 67;
      // }

      if (Obj.screen_image) {
        this.isShowTeacherQrCode = true;
        this.isShowTeacherBtnTop = false;
        this.teacher_qrcode_title = Obj.screen_image.title || "";
        this.teacher_qrcode_url = Obj.screen_image.image || "";
      }
      // 公告
      if (Obj.notice) {
        this.noticeObj = {
          open: true,
          content: Obj.notice.content,
          time: Obj.notice.time
        };
      }
      // if (this.isWeixin) {
      //   this.$refs.right.dsFunc(Obj);
      // }

      if (this.ds_pwd.enabled == "yes") {
        //开启观看权限
        this.couponText = this.ds_pwd.params.text;
        if (this.ds_pwd.params.is_try_see == 1) {
          this.tryTime = this.ds_pwd.params.watch_time;
          this.tryPrice = this.ds_pwd.params.price;
          this.isTrySee = true;
        } else {
          this.shareLimit = false;
        }
        this.ticket_switch = this.ds_pwd.params.ticket_switch == 1 ? true : false;
        setTimeout(function () {
          that.limit();
        }, 500);
      }

      //视频开屏图片
      this.videoImg = this.initData.direct_seeding.pic_url;
      //直播状态
      this.directStatus = this.initData.direct_seeding.direct_status;

      var clarity = localStorage.getItem("clarity");
      //解析播放地址
      if (this.directStatus == "end") {
        if (this.breakPoint.length > 0) {
          if (clarity) {
            if (this.breakPoint[0][clarity]) {
              this.videoLinkno = this.breakPoint[0][clarity];
            } else {
              if (this.breakPoint[0].hls_hd) {
                this.videoLinkno = this.breakPoint[0].hls_hd;
              } else {
                this.videoLinkno = this.breakPoint[0].playback;
              }
            }
          } else {
            if (this.breakPoint[0].hls_hd) {
              this.videoLinkno = this.breakPoint[0].hls_hd;
            } else {
              this.videoLinkno = this.breakPoint[0].playback;
            }
          }
          this.videoImg = this.breakPoint[0].pic_url;
          this.getClarity(this.breakPoint[0]);
        }
      } else if (this.directStatus == "running") {
        this.videoLinkno = this.initData.pull_url.m3u8_url;
        var live = {};
        live.pic_url = this.initData.direct_seeding.pic_url;
        live.title = this.initData.direct_seeding.name;
        live.playback = this.initData.pull_url.m3u8_url;
        live.create_time = this.initData.direct_seeding.start_time;

        this.currLiveDic = live;
        this.breakPoint.unshift(live);
      } else {
        if (this.before_ad.length > 0) {
          this.videoLinkno = this.before_ad[0].url;
          var live = {};
          live.pic_url = this.initData.direct_seeding.pic_url;
          live.title = this.initData.direct_seeding.name;
          live.create_time = this.initData.direct_seeding.start_time;
          live.playback = this.before_ad[0].url;
          this.currLiveDic = live;
          this.breakPoint.unshift(live);
        } else {
          this.videoIndex = -1;
        }
      }
      if (this.videoIndex > 0) {
        document.title = this.breakPoint[this.videoIndex].title;
        this.titleName = this.breakPoint[this.videoIndex].title;
        this.getClarity(this.breakPoint[this.videoIndex]);
      }
      this.startTime = this.initData.direct_seeding.start_time;
      // this.myPlayer.load();
    },
    getClarity: function getClarity(obj) {
      var hls_fhd = {},
          hls_hd = {},
          hls_standard = {},
          hls_smooth = {},
          playback = {};
      this.clarityList = [];
      if (obj.hls_fhd) {
        hls_fhd.clarity = "超清";
        hls_fhd.url = obj.hls_fhd;
        hls_fhd.clarityMode = "hls_fhd";
        this.clarityList.push(hls_fhd);
      }
      if (obj.hls_hd) {
        hls_hd.clarity = "高清";
        hls_hd.url = obj.hls_hd;
        hls_hd.clarityMode = "hls_hd";
        this.clarityList.push(hls_hd);
      }
      if (obj.hls_standard) {
        hls_standard.clarity = "标清";
        hls_standard.url = obj.hls_standard;
        hls_standard.clarityMode = "hls_standard";
        this.clarityList.push(hls_standard);
      }
      if (obj.hls_smooth) {
        hls_smooth.clarity = "流畅";
        hls_smooth.url = obj.hls_smooth;
        hls_smooth.clarityMode = "hls_smooth";
        this.clarityList.push(hls_smooth);
      }
      if (obj.playback) {
        playback.clarity = "原画";
        playback.url = obj.playback;
        playback.clarityMode = "playback";
        this.clarityList.push(playback);
      }

      var clarity = localStorage.getItem("clarity");

      //默认画质
      if (obj.hls_hd) {
        this.videoLinkno = obj.hls_hd;
        this.curClarity = "高清";
        localStorage.setItem("clarity", "hls_hd");
      } else {
        this.curClarity = "原画";
        localStorage.setItem("clarity", "playback");
        this.videoLinkno = obj.playback;
      }
    },
    channelInfoUpload: function channelInfoUpload() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + "&uid=" + this.uid + "&channel_code=" + this.channel_id;
      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }
      that.axios.post(_Tools2.default.baseUrl1() + "/customer/channel/channelInfoUpload", option).then(function (data) {}).catch(function (data) {
        console.log(data);
      });
    },
    isWeixinUserCheck: function isWeixinUserCheck(callback) {
      if (this.fans && this.fans.nick == "微信用户" && this.isWeixin) {
        var isSuccess = false;
        wx.getNetworkType({
          success: function success(res) {
            isSuccess = true;
            console.error("isWeixinUserCheck---success");
          },
          fail: function fail() {
            isSuccess = false;
            console.error("isWeixinUserCheck---fail");
          },
          complete: function complete(res) {
            callback(isSuccess);
            console.error("isWeixinUserCheck---complete", isSuccess);
          }
        });
      } else {
        callback(true);
      }
    },
    addPageViewDatas: function addPageViewDatas() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id + "&cip=" + returnCitySN["cip"] + "&cname=" + returnCitySN["cname"] + "&cid=" + returnCitySN["cid"] + "&uid=" + this.uid + "&channel_ds_code=" + this.channel_id + "&terminal_type=1" + "&interval=" + this.heart_time;

      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }

      that.axios.post(_Tools2.default.baseUrlUser() + "/app/index/come_in", option).then(function (data) {
        that.heard(5000);
      }).catch(function (data) {
        console.log(data);
      });
    },
    loginYunXinIM: function loginYunXinIM(type) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var param, yxInfo, imDataNet, UserType, channelInfoStr, userparam, userDataInfo, firstUser, newUser, channelInfo, marktags, param1, _imDataNet, marktagsTmp, loginParams;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // 1 im  2 心跳
                param = "fans_id=" + _this14.fans_id + "&chatroomId=" + _this14.initData.direct_seeding.chatroom_id;

                _this14.errorReport({ search: "\u4E91\u4FE1\u65E5\u5FD7" + _this14.fans_id, msg: "获取云信token2", error: param });

                yxInfo = null;
                _context8.prev = 3;
                _context8.next = 6;
                return _this14.axios.post(_Tools2.default.baseUrl2() + "/init/getYxToken", param);

              case 6:
                imDataNet = _context8.sent;

                yxInfo = imDataNet.data.data;
                console.error("imDataNet", imDataNet);
                _context8.next = 13;
                break;

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](3);

              case 13:
                UserType = 'old';
                channelInfoStr = "";

                if (!_this14.channel_id) {
                  _context8.next = 29;
                  break;
                }

                _context8.prev = 16;
                userparam = "ds_id=" + _this14.ds_id + "&terminal_type=1" + "&channel_ds_code=" + _this14.channel_id;
                _context8.next = 20;
                return _this14.axios.post(_Tools2.default.baseUrlUser() + "/app/index/getUserDataInfo", userparam, { timeout: 3000 });

              case 20:
                userDataInfo = _context8.sent;
                firstUser = userDataInfo.data.data.first;
                newUser = userDataInfo.data.data.new;

                if (firstUser == 1) {
                  UserType = 'first';
                } else if (newUser == 1) {
                  UserType = "new";
                }
                if (userDataInfo.data.data.channel_id) {
                  channelInfo = {
                    channel_name: userDataInfo.data.data.channelName,
                    channel_id: userDataInfo.data.data.channel_id,
                    grouping: userDataInfo.data.data.groupId
                  };

                  channelInfoStr = JSON.stringify(channelInfo);
                }

                _context8.next = 29;
                break;

              case 27:
                _context8.prev = 27;
                _context8.t1 = _context8["catch"](16);

              case 29:
                //标签
                marktags = "";
                _context8.prev = 30;
                param1 = "fansId=" + _this14.fans_id;
                _context8.next = 34;
                return _this14.axios.post(_Tools2.default.baseUrl1() + "/tags/getFromFansId", param1, { timeout: 3000 });

              case 34:
                _imDataNet = _context8.sent;
                marktagsTmp = _imDataNet.data.data[_this14.fans_id];

                if (marktagsTmp && marktagsTmp.length > 0) {
                  marktags = JSON.stringify(_imDataNet.data.data[_this14.fans_id]);
                }
                console.log("标签===", marktags);
                _context8.next = 42;
                break;

              case 40:
                _context8.prev = 40;
                _context8.t2 = _context8["catch"](30);

              case 42:

                if (yxInfo) {
                  loginParams = {
                    appKey: yxInfo.appKey,
                    yxToken: yxInfo.yxToken,
                    fans_id: _this14.fans_id,
                    token: yxInfo.token,
                    address: yxInfo.addr,
                    uid: _this14.uid,
                    ds_id: _this14.ds_id,
                    sessionID: _this14.pageUUID,
                    identifier: _this14.fans_id,
                    identifierNick: _this14.fans.nick,
                    header: _this14.fans.header,
                    headurl: _this14.fans.header,
                    chatroomId: _this14.initData.direct_seeding.chatroom_id,
                    tags: [_this14.fans_id || '0', _this14.ds_id || '0', '0', _this14.channel_id || '0', '1', '0', UserType],
                    custom: [_this14.fans_id || '0', _this14.ds_id || '0', '0', _this14.channel_id || '0', '1', '0', UserType, channelInfoStr, marktags]
                  };

                  if (type == 1) {
                    //im登录
                    _handleim2.default.loginIM(loginParams, 2, {
                      setMsgListener: _this14.onReceivedMsgCallBack,
                      setMemberMsgListener: _this14.onReceivedP2PMsgCallback,
                      setImStatusListener: function setImStatusListener(data) {
                        if (data.error == "kicked") {
                          _this14.yxImChatRoomStatusListener("kicked");
                        }
                      }
                    });
                  } else {
                    _handleim2.default.loginYunXinChatRoom(loginParams, {
                      setImStatusListener: function setImStatusListener(data) {
                        if (data.error == "kicked") {
                          _this14.yxImChatRoomStatusListener("kicked");
                        } else if (data.error == "noconnect") {
                          _this14.yxImNoConnectListener();
                        }
                      }
                    });
                  }
                }

              case 43:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this14, [[3, 11], [16, 27], [30, 40]]);
      }))();
    },
    yxImLogListenerCB: function yxImLogListenerCB(message, error) {
      this.errorReport({ search: "\u4E91\u4FE1\u65E5\u5FD7" + this.fans_id, msg: message, error: error });
    },
    yxImChatRoomStatusListener: function yxImChatRoomStatusListener(status) {
      //云信聊天室回调
      if (status == "kicked") {
        this.isyxinImLoginOut = true;
        if (this.heardTimer) {
          clearInterval(this.heardTimer);
          this.heardTimer = null;
        }
        _handleim2.default.logout(function () {});
      }
    },
    yxImNoConnectListener: function yxImNoConnectListener() {
      if (this.HeartMode == '3' && !this.isBlack) {
        this.addPageViewDatas();
      }
    },
    getHeartMode: function getHeartMode() {
      var _this15 = this;

      if (this.initData.direct_seeding.im_type == 2) {
        //1 腾讯IM 2网易IM
        return;
      }
      //开启了手机号密码或者账号密码
      this.errorReport({ msg: "获取心跳模式" });
      var option = "ds_id=" + this.ds_id;
      this.axios.post(_Tools2.default.baseUrl2() + "/init/getHeartMode", option).then(function (res) {
        _this15.errorReport({ msg: "心跳模式", HeartMode: res });
        if (res.data.code == 200) {
          _this15.HeartMode = res.data.data.mode;
          if (res.data.data.mode == '2') {
            _this15.addPageViewDatas();
          } else if (res.data.data.mode == '3') {
            //  this.addPageViewDatas()
            _this15.loginYunXinIM(2);
          } else if (res.data.data.mode == '4') {
            _this15.loginYunXinIM(2);
          } else if (res.data.data.mode == '5') {
            _this15.loginYunXinIM(2);
            _this15.addPageViewDatas();
          } else {
            _this15.addPageViewDatas();
          }
        } else {
          _this15.errorReport({ msg: "getHeartMode调用异常", userinfo: _this15.fans });
          _this15.addPageViewDatas();
        }
      }).catch(function (error) {
        _this15.addPageViewDatas();
        _this15.errorReport({ msg: "getHeartMode调用异常", userinfo: _this15.fans });
      });
    },
    errorReport: function errorReport(data) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var postData;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (data) {
                  data.sessionID = _this16.pageUUID;
                }
                postData = {
                  fans_id: parseInt(_this16.fans_id || 0),
                  error_code: '70000',
                  ds_id: parseInt(_this16.ds_id),
                  uid: parseInt(_this16.uid || 0),
                  terminal_type: 1,
                  data: data
                  // let param = `data=${JSON.stringify(postData)}`
                };
                _context9.prev = 2;
                _context9.next = 5;
                return _this16.axios.post('https://report.tenghuiwangxiao.cn/app/report/errorReport', postData);

              case 5:
                _context9.next = 9;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](2);

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this16, [[2, 7]]);
      }))();
    },
    heard: function heard(time) {
      var _this17 = this;

      var that = this;
      if (this.heardTimer) {
        return;
      }
      this.heardTimer = setInterval(function () {
        var option = "ds_id=" + _this17.ds_id + "&fans_id=" + _this17.fans_id + "&cip=" + returnCitySN["cip"] + "&cname=" + returnCitySN["cname"] + "&cid=" + returnCitySN["cid"] + "&uid=" + _this17.uid + "&channel_ds_code=" + _this17.channel_id + "&terminal_type=1" + "&interval=" + _this17.heart_time;
        if (_this17.tid) {
          option = option + "&tid=" + _this17.tid;
        }
        that.axios.post(_Tools2.default.baseUrlUser() + "/app/index/heart", option).then(function (data) {
          if (data.data.code == 2000) {
            if (_this17.heart_time != data.data.data.interval) {
              _this17.heart_time = data.data.data.interval || 30;
              clearInterval(_this17.heardTimer);
              _this17.heardTimer = null;
              _this17.heard(_this17.heart_time * 1000);
            }
          }
        }).catch(function (data) {});
      }, this.heart_time * 1000);

      if (this.heardVodTimer) {
        clearInterval(this.heardVodTimer);
        this.heardVodTimer = null;
      }

      this.heardVodTimer = setInterval(function () {
        if (_this17.playerType == "vod" && _this17.currentPlayerData) {
          var videoData = {
            file_id: _this17.currentPlayerData.playData.file_id,
            fans_id: _this17.fans_id,
            uid: _this17.uid,
            ds_id: _this17.ds_id,
            progress: parseInt(_this17.currentPlayerData.currentPlayTime)
          };
          _this17.axios.post(_Tools2.default.baseUrlUser() + "/app/index/videoHeart", _qs2.default.stringify(videoData)).then(function (data) {}).catch(function (data) {});
        }
      }, 5000);
    },
    cutClarity: function cutClarity(item) {
      var that = this;
      this.currentTime = this.myPlayer.currentTime;
      this.videoLinkno = item.url;
      this.curClarity = item.clarity;
      this.switchClarity();
      localStorage.setItem("clarity", item.clarityMode);
      this.isShowControl = false;
      // this.myPlayer.load();
      setTimeout(function () {
        that.videoPlay();
      }, 200);
    },
    switchClarity: function switchClarity() {
      this.showClarity = !this.showClarity;
    },
    setControl: function setControl() {},
    update: function update() {
      var playSchedule = document.getElementById("playSchedule");
      var playPoint = document.getElementById("playPoint");
      this.videoCurrentTime = _Tools2.default.changeTime(this.myPlayer.currentTime);
      var percent = this.myPlayer.currentTime / this.myPlayer.duration;
      playSchedule.style.width = percent * 100 + "%";
      playPoint.style.left = percent * 100 + "%";
    },
    onControlClicked: function onControlClicked() {
      var that = this;
      that.showClarity = false;
      clearTimeout(this.controlTimer);
      if (this.isShowControl) {
        this.isShowControl = false;
        if (this.scrollDir == "down") {
          this.isRolling = true;
        }
      } else {
        if (this.scrollDir == "down") {
          this.isRolling = false;
        }
        this.isShowControl = true;
        this.controlTimer = setTimeout(function () {
          that.onControlClicked();
        }, 5000);
      }
    },
    onPlayBtnClicked: function onPlayBtnClicked() {
      if (this.myPlayer.paused) {
        this.myPlayer.play();
      } else {
        this.myPlayer.pause();
        this.currentTime = this.myPlayer.currentTime;
      }
    },
    videoPlay: function videoPlay() {
      var that = this;
      if (this.videoIndex == 0 && this.directStatus == "end" || this.videoIndex > 0) {
        if (!this.canBack) {
          (0, _toast2.default)("直播已结束");
          return false;
        }
      }
      //如果有音乐关闭音乐
      var audio = document.getElementById("audio");
      if (audio) {
        audio.pause();
      }
      // 移除音乐监听
      document.body.removeEventListener("click", this.playmusic);
      that.myPlayer.currentTime = that.currentTime;
      that.myPlayer.play();

      if (this.isIOS) {} else {
        if (this.isFirstPlay) {
          //历史播放记录加载
          if (this.currentTime == 0) {
            var time = window.localStorage.getItem(this.videoLinkno);
            if (time > 0) {
              this.currentTime = time;
            }
          }
          //播放
          this.playtimer = setInterval(function () {
            that.myPlayer.play();
            that.myPlayer.currentTime = that.currentTime;
          }, 200);

          var s = this.currentTime;
          if (s != 0) {
            var timer = setInterval(function () {
              that.myPlayer.currentTime = s;
              if (that.myPlayer.currentTime != 0) {
                that.isFirstPlay = false;
                clearInterval(timer);
              }
            }, 500);
          }
        }
      }

      return true;
    },
    initUI: function initUI() {
      //初始化页面
      var w = document.body.clientWidth;
      var screenH = this.screenH;
      var h = this.noPlayH;
      var contentHeight;
      if (!this.isIOS) {
        this.playerStyle = {
          display: "none"
        };
      }
      if (this.topAD) {
        contentHeight = h - w * 0.56 - 44 - this.pieceHeight - 38 - this.salesHeight - this.bannerHeight;
      } else {
        contentHeight = h - w * 0.56 - 44 - this.pieceHeight - this.salesHeight - this.bannerHeight;
      }

      this.contentStyle = {
        height: contentHeight + "px"
      };

      this.isPlayUI = false;
      clearTimeout(this.controlTimer);
      this.isShowControl = true;
      this.showhead = false;
      this.showControl = true;
      this.headtitleBg = "#212126";
      this.showCover = true;
      this.showMenu = true;
      if (this.topAD) {
        this.playHeight = 38;
      } else {
        this.playHeight = 0;
      }
      this.bottomSider = true;
      this.showView = true;
      this.showfunc();
      if (this.ds_func.rolling) {
        this.openRolling = true;
        this.isRolling = true;
      }

      this.loginErrroStyle = {
        display: "block",
        height: h - w * 0.56 - (this.playHeight + this.pieceHeight + this.salesHeight + this.bannerHeight) + "px"
      };
    },
    playUI: function playUI() {
      var w = document.body.clientWidth;
      var screenH = this.screenH;
      var h = this.noPlayH;
      var headerH = 54;
      var that = this;
      this.orientation = "portraint";
      if (!this.isIOS) {
        this.playerStyle = {
          height: screenH + "px",
          width: w + "px",
          objectFit: "contain",
          objectPosition: "top " + headerH + "px left 0px",
          display: "block"
        };
      }

      this.isPlayUI = true;
      //影藏遮盖层
      this.showCover = false;
      if (this.topAD) {
        this.playHeight = 0;
      }
      this.hidefunc();
      this.showControl = true;
      this.isShowControl = false;
      this.onControlClicked();
      this.fullscr = false;
      this.talkred = true;
      this.showView = true;
      this.showMenu = true;
      this.bottomSider = true;
      if (this.isIOS) {
        this.playerStyle = {};
        this.controlStyle = {};
        return false;
      }

      this.controlStyle = {
        height: w * 0.56 + "px",
        top: headerH + "px"
      };
      this.contentStyle = {
        height: screenH - w * 0.56 - 98 - this.pieceHeight + "px",
        display: "block"
      };

      this.playHeight = 54;
      this.showhead = true;
      this.headtitleBg = "#212126";

      this.loginErrroStyle = {
        display: "block",
        height: screenH - w * 0.56 - (this.playHeight + this.pieceHeight + this.salesHeight + this.bannerHeight) + "px",
        bottom: 0
      };
    },
    fullScreenUI: function fullScreenUI() {
      var screenH = window.screen.height;
      var screenW = window.screen.width;
      var that = this;
      this.orientation = "landscape";
      this.fullscr = true;
      this.bottomSider = false;
      this.showView = false;
      this.openRolling = false;
      this.talkred = false;
      this.showMenu = false;
      if (this.isIOS) {
        this.controlStyle = {
          height: "100%",
          width: "100%"
        };
        return false;
      }
      this.playerStyle = {
        height: "100%",
        width: "100%",
        display: "block",
        objectFit: "fill"
      };
      this.controlStyle = {
        height: "100%",
        width: "100%",
        top: "0px"
      };
      this.playHeight = 0;
      this.headtitleBg = "none";
      this.contentStyle = {
        display: "none"
      };
      this.loginErrroStyle = {
        display: "none"
      };
    },
    handleTabClick: function handleTabClick(item) {
      if (!this.initData.ds_menu.length) {
        return;
      }
      this.curCid = this.initData.ds_menu[item].cid;
      this.currentMid = this.initData.ds_menu[item].mid;
      if (this.curCid == 6) {
        this.dispark = true;
      } else if (this.curCid == 5) {
        if (this.initData.ds_menu[item].config == 1) {
          location.href = this.initData.ds_menu[item].content;
        }
      } else if (this.curCid == 2) {
        this.vid = this.initData.ds_menu[item].config;
      } else if (this.curCid == 9) {
        if (!this.storeActive) {
          this.storeActive = this.initData.ds_menu[item].config;
          this.StoreUrl = "http://ph.shikee.tv/store/?ds_id=" + this.ds_id + "&active=" + this.storeActive + "#/index";
          console.log(this.StoreUrl);
        }
      } else {
        this.dispark = false;
        this.ripple(100);
      }
    },
    playPause: function playPause() {
      // rtc播放
      if (!this.isNotShowWebRTC) {
        if (this.rtcRemoteStream) {
          this.rtcLiveResume();
          this.isShowProgress = true;
          this.isPlay = true;
          this.showCover = false;
          this.play = true;
          this.topAD = false;
        } else {
          (0, _toast2.default)("老师还没上课，请稍后!");
        }
        return;
      }

      var that = this;
      if (this.playStart) {
        this.myPlayer.play();
        return;
      }
      var start = new Date(this.startTime.replace(/-/g, "/"));
      if (this.directStatus == "not_started" && this.before_ad.length == 0) {
        (0, _toast2.default)("直播时间：" + (1 + start.getMonth()) + "月" + start.getDate() + "日 " + start.getHours() + "时" + start.getMinutes() + "分");
        return;
      }

      if (this.directStatus == "end" && this.canBack) {
        if (this.breakPoint.length < 1) {
          (0, _toast2.default)("回放视频正在生成!");
          return;
        } else {
          if (!this.myPlayer.currentTime) {
            (0, _toast2.default)("直播已结束，开始播放回放视频");
          }
        }
      }

      if (!this.videoPlay()) {
        return;
      }
      if (!this.fullscr && this.isIOS) {
        this.playUI();
      }
      this.tryUi();
      this.playStart = true;

      console.log("播放方法被执行了:" + this.videoLinkno);
    },
    tryUi: function tryUi() {
      var that = this;
      this.tryOpacity = 1;
      setTimeout(function () {
        if (that.directStatus == "end" || that.videoIndex != 0) {
          that.tryOpacity = 0;
          that.tryPayBtn = true;
        }
      }, 5000);
    },
    shareToWeChat: function shareToWeChat() {
      var that = this;
      var option = "url=" + encodeURIComponent(location.href);
      this.axios.post(_Tools2.default.baseUrl2() + "/init/getWechatShareData", option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          that.wxReady(data.data.shareData);
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    wxReady: function wxReady(params) {
      var that = this;

      //配置分享
      wx.config({
        debug: false,
        appId: params.appid, // 必填
        timestamp: params.timestamp, // 必填，生成签名的时间戳
        nonceStr: params.noncestr, // 必填，生成签名的随机串
        signature: params.signature, // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });

      console.log("直播间数据", that.initData);

      this.share.url = params.url;
      this.share.dec = that.initData.direct_seeding.desc;
      this.share.title = that.initData.direct_seeding.name;
      this.share.image = that.initData.direct_seeding.pic_url;
      this.share.groupImage = that.initData.direct_seeding.pic_url;
      this.share.groupDesc = that.initData.direct_seeding.name;

      var funcList = this.initData.ds_func;

      var shareItem = funcList.find(function (item) {
        return item.module == "share";
      });

      if (shareItem) {
        this.share.dec = shareItem.params.friend_des;
        this.share.title = shareItem.params.friend_title;
        this.share.image = shareItem.params.friend_pic_url;
        this.share.groupImage = shareItem.params.moment_pic_url;
        this.share.groupDesc = shareItem.params.moment_des;
      }

      console.log("分享参数", this.share, params);

      wx.ready(function () {
        //微信好友分享
        wx.updateAppMessageShareData({
          title: that.share.title, // 分享标题
          desc: that.share.dec, // 分享描述
          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
          imgUrl: that.share.image, // 分享图标
          success: function success() {
            console.log("设置分享微信好友分享参数成功");
          }
        });

        //微信朋友圈分享
        wx.updateTimelineShareData({
          title: that.share.groupDesc, // 分享标题
          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
          imgUrl: that.share.groupImage, // 分享图标
          success: function success() {
            console.log("设置分享微信朋友圈分享参数成功");
          }
        });
      });
      wx.error(function (data) {
        console.log("错误");
        console.log(data);
      });
    },
    getshare: function getshare() {
      var that = this;
      var url = _Tools2.default.baseUrl() + "/fans/share/index";

      var option = {
        fans_id: that.fans_id,
        ds_id: that.ds_id
      };

      option = _Tools2.default.encrypt(option);
      that.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          that.rewardType = 2;
          that.rewardredpack = true;
          that.shareRedexist = false;
          that.rewardMoney = data.data.money;
        } else {
          (0, _toast2.default)(data.message);
          that.shareRedexist = false;
        }
      }).catch(function (res) {
        console.log("获取分享数据失败失败" + res);
      });
    },
    getshareQuan: function getshareQuan() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + "/share/coupon";

      var option = {
        fans_id: that.fans_id,
        ds_id: that.ds_id
      };

      option = _Tools2.default.encrypt(option);
      that.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          that.rewardType = 2;
          that.rewardQuan = true;
          that.shareRedexist = false;
          that.quanData = data.data;
        } else {
          (0, _toast2.default)(data.message);
          that.shareRedexist = false;
        }
      }).catch(function (res) {
        console.log("获取分享数据失败失败" + res);
      });
    },
    livestart: function livestart(json) {
      var message;
      if (json.module == "ds_start") {
        var timesecond = 0;
        if (json.delay_status) {
          timesecond = json.delay_time * 1000;
        } else {
          timesecond = 0;
        }

        setTimeout(function () {
          message = "直播已经开始，点击播放";
          _dialog2.default.alert({
            title: "温馨提示",
            message: message
          }).then(function () {
            window.location.reload();
          });
        }, timesecond);
      } else {
        message = "直播已经结束";
        _dialog2.default.alert({
          title: "温馨提示",
          message: message
        }).then(function () {
          window.location.reload();
        });
      }
    },
    personnum: function personnum(numValue) {
      //增加观看人数
      // if (numValue == "0") {
      //   this.view_num++;
      // } else {
      //   if (this.view_num < numValue) {
      //     this.view_num = numValue;
      //   }
      // }
    },
    timestamps: function timestamps() {
      var time = new Date();
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();

      return "" + y + _Tools2.default.two(m) + _Tools2.default.two(d) + _Tools2.default.two(h) + _Tools2.default.two(mm) + _Tools2.default.two(s);
    },
    swichWindow: function swichWindow() {
      this.forbid = !this.forbid;
      localStorage.setItem("forbid", this.forbid);
    },
    playBack: function playBack() {
      var that = this;
      var url = _Tools2.default.baseUrl2() + "/playback/index";
      var option = "uid=" + this.uid + "&ds_id=" + this.ds_id;
      this.axios.post(url, option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          that.canBack = true;
        } else {
          that.canBack = false;
          console.log(data.message);
        }
      }).catch(function (data) {
        //Toast(data);
      });
    },
    closeAD: function closeAD() {
      this.topAD = false;
      this.initUI();
    },
    loginIM: function loginIM(noShowToast) {
      var _this18 = this;

      if (this.initData.direct_seeding.im_type == 2) {
        //网易IM
        this.loginYunXinIM(1);
      } else {
        if (!noShowToast) {
          _toast2.default.loading();
        }
        var option = "fans_id=" + this.fans_id;
        this.axios.post(_Tools2.default.baseUrl1() + "/api/im/getUserSign", option).then(function (res) {
          localStorage.setItem("tl_sign", res.data.data.tl_sign);
          _this18.loginIMToDo(res.data.data.tl_sign);
        }).catch(function (error) {
          _this18.axios.post("https://service-r0p4y9rc-1258158934.gz.apigw.tencentcs.com/release/api/login/getImUserSign", option).then(function (res) {
            localStorage.setItem("tl_sign", res.data.data);
            _this18.loginIMToDo(res.data.data);
          }).catch(function (error) {});
        });
      }
    },
    loginIMToDo: function loginIMToDo(tl_sign) {
      var that = this;
      var obj = {};
      obj["currentGroupId"] = that.initData.direct_seeding.room_id;
      // obj["currentGroupId"] = '@TGS#aOYDEPXMX'
      obj["identifier"] = this.fans_id;
      obj["identifierNick"] = that.fans.nick;
      obj["headurl"] = that.fans.header;
      obj["userSig"] = tl_sign;
      //腾讯IM登录
      _handleim2.default.loginIM(obj, 1, {
        setMsgListener: this.onReceivedMsgCallBack,
        setMemberMsgListener: this.onReceivedP2PMsgCallback,
        setImStatusListener: this.imStatusListener
      });
    },
    onReceivedP2PMsgCallback: function onReceivedP2PMsgCallback(json) {
      this.$refs.consultTeacher.receivedMsg(json);
      if (!this.showConsultTeacher) {
        // this.$refs.chat[0].receivedMsg(json);
        // this.$refs.chat[0].showUnReadViewFunc(json);
      }
    },
    loadFakeComment: function loadFakeComment() {
      var self = this;
      // 获取服务器时间校准
      var url = _Tools2.default.baseUrl1() + "/wap/live/getServerTime";
      var option = "";
      this.axios.post(url, option).then(function (data) {
        if (data.data.code == 200) {
          var time = data.data.data.time;
          var real_start_time = self.initData.direct_seeding.real_start_time && self.initData.direct_seeding.real_start_time.replace(/-/g, "/") || self.initData.direct_seeding.start_time;
          var tempTime = new Date(real_start_time).valueOf() + new Date().valueOf() - new Date(time.replace(/-/g, "/")).valueOf();
          var startTime = self.getTimes(tempTime);
          console.log("时间校准", data.data.data.time, self.getTimes(new Date().valueOf()));
          var tid = self.initData.fakeTemplateId;
          _FakeIm2.default.setCommentCallback(self.onReceivedMsgCallBack);
          console.log("校准后时间:", startTime);
          _FakeIm2.default.startLoad(startTime, tid, function (isOK) {
            if (isOK) {
              _FakeIm2.default.startCommentRun();
            } else {
              (0, _toast2.default)("获取评论失败，请刷新重试");
            }
          });
        } else {
          (0, _toast2.default)("网络错误" + data.data.message);
        }
      }).catch(function (data) {
        console.log("时间校准错误", data);
        (0, _toast2.default)("网络错误" + data);
      });
    },
    getNot: function getNot() {
      var that = this;
      // im.getNotification(function(data) {
      //   if (data != false && data != null) {
      //     console.log("动态秘钥：" + data.Notification);
      //     vxxData.verifyCode = data.Notification;
      //   } else {
      //     var flag = confirm("获取聊天动态秘钥失败");
      //     if (flag) {
      //       that.getNot();
      //     } else {
      //       that.getNot();
      //     }
      //   }
      // });
    },
    ripple: function ripple(num) {
      var that = this;
      if (that.shopIndex < 0) {
        return;
      }
      setTimeout(function () {
        document.querySelectorAll(".van-tab")[that.shopIndex].className = "van-tab ripple";
      }, num);
    },
    robRedBagAction: function robRedBagAction(item) {
      //抢红包
      var that = this;
      if (!this.isWeixin) {
        return;
      }
      if (this.isGradRedStart) {
        return;
      }
      this.redBagData = item;
      this.isGradRedStart = true;
      var url = _Tools2.default.baseUrl() + "/redPacket/Grab/index";
      var option = {
        fans_id: this.fans_id,
        msg_id: item._id
      };

      option = _Tools2.default.encrypt(option);

      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == 200) {
          that.redBaglistData = data.data;
          if (data.data.status == "is_open") {
            that.showrobRedlist = true;
          } else if (data.data.status == "is_close") {
            that.showrobRedlist = true;
          } else {
            (0, _toast2.default)("抢红包失败！稍后再试！");
          }
        }
        that.isGradRedStart = false;
      }).catch(function (res) {
        that.isGradRedStart = false;
        (0, _toast2.default)("抢红包失败！稍后再试！");
        console.log(res);
      });
    },
    closeRodRedList: function closeRodRedList() {
      this.showrobRedlist = false;
    },
    switchSider: function switchSider() {
      this.bottomSider = !this.bottomSider;
      this.shareRed = !this.shareRed;
      this.talkred = !this.talkred;
    },
    getTimes: function getTimes(timeStr) {
      var time = new Date();
      if (timeStr) {
        time = new Date(timeStr);
      }
      var year = time.getFullYear();
      var month = _Tools2.default.two(time.getMonth() + 1);
      var date = _Tools2.default.two(time.getDate());
      var hours = _Tools2.default.two(time.getHours());
      var minutes = _Tools2.default.two(time.getMinutes());
      var seconds = _Tools2.default.two(time.getSeconds());

      return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
    },
    onReceivedMsgCallBack: function onReceivedMsgCallBack(json) {
      var _this19 = this;

      console.error("json", json);

      var that = this;
      // console.log(JSON.stringify(json));
      if (!json.create_time) {
        json.create_time = this.getTimes();
      }
      switch (json["module"]) {
        case "shopping_cart":
          //是否显示购物车
          if (json.status == "yes") {
            this.isshowCart = true;
            var data = JSON.parse(json.params);
            if (data.length > 0) {
              var _data$ = data[0],
                  type = _data$.type,
                  shangpingID = _data$.shangpingID;

              if (type === '3') {
                this.showShoppingType = false;
                this.showShoppingDialog = true;
              } else if (type === '2') {
                this.showShoppingType = true;
                this.showShoppingDialog = false;
              }
              if (type !== '1') {
                // 二、三购物车样式只会有一个商品信息
                this.goodsInfo = shangpingID[0];
                this.goodsIdsList = [this.goodsInfo.id];
              } else {
                // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
                this.goodsInfo = {};
                this.goodsIdsList = shangpingID;
              }
            }
          } else {
            this.isshowCart = false;
            this.goodsIdsList = [];
            this.showShoppingType = false;
            this.showShoppingDialog = false;
          }
          break;
        case "red_rain_close":
          //红包雨结束
          that.$refs.redrain.redbagRain(json);
          break;
        case "rain_random":
          //红包雨随机
          this.rainProbab = json.percent;
          this.rainId = json.id;
          setTimeout(function () {
            that.$refs.redrain.redbagRain(json);
          }, 300);
          break;
        case "rain_normal":
          //红包雨
          this.rainProbab = json.percent;
          this.rainId = json.id;
          setTimeout(function () {
            that.$refs.redrain.redbagRain(json);
          }, 300);
          break;
        case "ds_start":
          //直播开始了
          this.livestart(json);
          break;
        case "ds_end":
          //直播结束了
          this.livestart(json);
          break;
        case "delete_comment":
          //删除评论
          this.$refs.chat.deleteComment(json);
          break;
        case "text_comment":
          //文字评论
          this.$refs.chat.textComment(json);
          break;
        case "gift_comment":
          //礼物打赏
          this.$refs.toolbar.gift(json);
          this.$refs.chat.giftComment(json);
          break;
        case "share_red_pack_end":
          //分享红包结束
          this.shareredend();
          break;
        case "red_password_end":
          //口令红包结束
          this.talkredend();
          break;
        case "update_verify_code":
          //更新秘钥
          _data2.default.verifyCode = json.content.verify;
          break;
        case "agreeLink":
          //老师邀请连麦
          this.linkLive(json);
          break;
        case "linkDown":
          this.linkDown(json);
          break;
        case "system_message_group_introduction":
          //群公告
          {
            if (json.content && json.content.online_num != undefined) {
              this.view_num = json.content.online_num;
            }
          }
          break;
        case "system_message_group_notification":
          //群通知
          // let content = JSON.parse(json.content);
          // if (content.showConsultTeacher != undefined) {
          //   //咨询老师
          //   this.$refs.chat[0].showConsultTeacher(content);
          // }
          break;
        case "wx_follow_change":
          //是否显示二维码
          this.isShowQRimg = json.params.wx_show_now == "yes";
          this.openWx_follow = json.params.wx_show_now == "yes";

          if (this.isShowQRimg) {
            setTimeout(function () {
              _this19.isShowQRimg = false;
            }, 5000);
          }

          break;
        case "PERSON_IN_BLACK":
          console.log(json.fans_id_list, this.fans_id, "黑名单");
          if (json.fans_id_list.indexOf("" + this.fans_id) > -1) {
            if (json.in_black == "yes") {
              this.isBlack = true;
              clearInterval(this.heardTimer);
              this.heardTimer = null;
              location.reload();
            } else {
              location.reload();
              this.isBlack = false;
            }
          }
          break;
        case "PERSON_KICK_OUT":
          if (json.fans_id == this.fans_id) {
            window.location.href = json.to_web;
          }
          break;
        case "screenCaptureChange":
          console.log("需要刷新播放器");
          setTimeout(function () {
            _this19.$refs.tfPlayer.playVideoClicked();
          }, 500);
          break;
        case "GIFT_CHANGE_STATUS":
          //送花点赞
          if (json.status == "yes") {
            this.isshowgift = true;
          } else {
            this.isshowgift = false;
          }
          break;
        case "CONSULTING_TEACHER_STATUS":
          //是否显示联系老师
          // if (json.status == "yes") {
          //   this.showTeacherBtn = true;
          // } else {
          //   this.showTeacherBtn = false;
          // }
          break;
        case "comment_on_off":
          //全员静言
          {
            this.is_all_users_muted = json.status == "0";
          }
          break;
        case "show_teacher_qrcode":
          //是否显示老师二维码
          {
            if (json.open == 1) {
              this.isShowTeacherQrCode = true;
              this.isShowTeacherBtnTop = false;
              if (this.$refs.tfPlayer.getPlayerIsfullScreen()) {
                if (this.isIOS) {
                  window.location.reload();
                } else {
                  this.$refs.tfPlayer.exitFullScreen();
                }
              }
            } else {
              this.isShowTeacherQrCode = false;
              this.isShowTeacherBtnTop = false;
            }
            this.teacher_qrcode_title = json.title || "";
            this.teacher_qrcode_url = json.image || "";
          }
          break;
        case "say_self":
          //自嗨消息
          {
            this.say_self = {
              enabled: json.status == "yes",
              type: json.params.type,
              all: json.params.all
            };
          }
          break;
        case "notice":
          //公告
          {
            this.noticeObj = {
              open: json.status == "yes",
              content: json.params.content,
              time: json.params.time
            };
          }
          break;
        // 正在购买
        case 'shopping_purchase':
          this.saveUserBuyList.push(json.nick);
          if (!this.tipsBuyTimer) {
            this.showTipsByUserBuy();
          }
          break;
        // 购买成功
        case 'shopping_success':
          this.saveUserBuySuccessList.push(json.nick_name);
          this.inventoryNum = json.num;
          if (!this.tipsBuySuccessTimer) {
            this.showTipsByUserBuySuccess();
          }
          break;
        // 购买提示
        case 'purchase_prompt':
          this.showBuyTipsState = json.status === 'yes';
          break;
        case "ds_refresh":
          //刷新直播间
          {
            setTimeout(function () {
              location.reload();
            }, Math.round(Math.random() * 10) * 1000);
          }
          break;
        default:
          //this.$refs.chat[0].addReviewWrap(json);
          break;
      }
    },
    imStatusListener: function imStatusListener(resp) {
      var _this20 = this;

      if (resp.ErrorCode == 1) {
        //网络恢复，需要重新连接
        (0, _toast2.default)("网络恢复正在重新连接聊天室...");
        if (this.playerStatus == 2 && this.initData.direct_seeding.play_style == "3") {
          if (this.outOfTime == 2 && this.linkType == 3) {
            // 连麦操作
            this.$refs.tfPlayer.rtcLiveLeave(function () {
              _this20.$refs.tfPlayer.rtcLink();
            });
          } else {
            this.linkType = 1;
            this.$refs.tfPlayer.rtcLiveLeave(function () {
              _this20.$refs.tfPlayer.playVideoClicked();
            });
          }
        }
        return;
      }

      if (resp.ErrorCode == 9999) {
        //网络断开了
        (0, _toast2.default)("聊天室网络中断，将无法收到消息，请检查网络或刷新页面");
      }
    },
    buyProduct: function buyProduct(json) {
      var that = this;
      this.buyList.push(json);
      setTimeout(function () {
        that.buyListIndex++;
      }, 6000);
    },
    tryPay: function tryPay() {
      _Tools2.default.bugTicket(this.coupon_id, this.payLoad);
    },
    select: function select(index, id) {
      this.payIndex = index;
      this.coupon_id = id;
    },
    payCancel: function payCancel() {
      this.showPay = false;
      this.myPlayer.play();
    },
    onShowPay: function onShowPay() {
      if (this.ticket_switch) {
        _toast2.default.loading();
        _Tools2.default.getCoupon(this.getCoupon);
      } else {
        this.showPay = true;
      }
      console.log(this.coupons);
    },
    getCoupon: function getCoupon(coupons) {
      _toast2.default.clear();
      this.coupons = coupons;
      console.log(this.coupons.length);
      this.showPay = true;
    },
    payLoad: function payLoad() {
      var that = this;
      sessionStorage.setItem("initData", null);
      setTimeout(function () {
        that.$router.replace("/home");
        window.location.reload();
      }, 2000);
    },
    onShowAllot: function onShowAllot() {
      var that = this;
      this.showAllot = true;
      if (!this.headerData) {
        this.getHeadImg();
      }
      if (!this.code) {
        var qrcodeurl = "http://u.tenghuiwangxiao.cn/?ds_id=" + this.ds_id + "#/home/" + this.fans_id;
        var qrcoder = new _qrcoder2.default({
          data: qrcodeurl,
          size: 240
        });
        this.code = qrcoder.getDataURL();
      }
      if (!this.base64Img) {
        this.getBase64(this.initData.direct_seeding.pic_url);
      }
      console.log(this.canvas);
      if (!this.canvas) {
        var timer = setInterval(function () {
          if (that.headerData && that.code && that.base64Img) {
            clearInterval(timer);
            (0, _html2canvas2.default)(document.querySelector("#shareCard"), {
              useCORS: true,
              allowTaint: true,
              taintTest: true,
              backgroundColor: "transparent"
            }).then(function (canvas) {
              console.log(canvas);
              that.canvas = canvas.toDataURL("image/png");
              _toast2.default.clear();
            });
          }
        }, 100);
      }
    },
    onCloseAllot: function onCloseAllot() {
      this.showAllot = false;
    },
    getHeadImg: function getHeadImg() {
      var that = this;
      var option;
      _toast2.default.loading();
      option = "fans_id=" + this.fans_id;
      this.axios.post(_Tools2.default.baseUrl() + "/fans/invite/getImg", option).then(function (res) {
        that.headerData = res.data;
        console.log(that.headerData);
      }).catch(function (res) {
        console.log(res);
      });
    },
    getBase64: function getBase64(url) {
      var that = this;
      this.axios.post("http://plive.shikee.tv/fans/invite/shareCardImage", "url=" + encodeURIComponent(url)).then(function (data) {
        that.base64Img = data.data;
        console.log(that.base64Img);
        console.log(data.data);
      }).catch(function (res) {
        console.log(res);
      });
    },
    registerOk: function registerOk() {
      this.registerViewShow = false;
    },
    whiteNumOk: function whiteNumOk() {
      var _this21 = this;

      console.log("执行成功！！！！！！！！！！");
      this.TelTestShow = false;
      //开启白名单 //地理位置上报
      this.isWeixinUserCheck(function (isSuccess) {
        isSuccess && _this21.getHeartMode();
      });
    },
    linkAccept: function linkAccept() {
      if (this.linkType === 1) {
        console.log("发送连麦消息");
        _handleim2.default.sendApplyLink();
      } else if (this.linkType === 2) {
        _handleim2.default.sendSureLink();
        //开始走连麦流程了
        this.$refs.tfPlayer.rtcLink();
      } else if (this.linkType === 3) {
        //走结束连麦流程
        this.$refs.tfPlayer.rtcLinkDown();
        this.linkType = 1;
      }
      this.linkDialogVisible = false;
    },
    linkRefuse: function linkRefuse() {
      console.log("拒绝连麦");
      if (this.linkType === 2) {
        _handleim2.default.sendRefuseLink();
      }
      this.linkDialogVisible = false;
    },
    linkLive: function linkLive(data) {
      if (this.initData.direct_seeding.play_style != 2) {
        return;
      }

      if (data.content == this.fans_id) {
        var canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
        if (!canLink) {
          _handleim2.default.sendCannotLink("1");
          return;
        }
        this.linkType = 2;
        this.linkDialogVisible = true;
      }
    },
    linkDown: function linkDown(data) {
      if (data.content == this.fans_id) {
        //需要下麦操作
        this.$refs.tfPlayer.rtcLinkDown();
      }
    }
  }
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-dbe8ab8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(514);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a41eb8bc", content, true);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".vertical_message_box[data-v-dbe8ab8c]{position:absolute;bottom:60px;left:0;width:100%;padding:10px;z-index:100;height:200px;box-sizing:border-box;overflow:scroll;scroll-behavior:smooth}.chatList[data-v-dbe8ab8c]{scroll-behavior:smooth;height:100%}.chatList li[data-v-dbe8ab8c]{margin-right:10px;line-height:26px;margin-top:10px;overflow:hidden}.chat_box[data-v-dbe8ab8c]{background:rgba(0,0,0,.28);padding:4px;border-radius:20px;padding-right:15px;display:inline-block}.chatList li .img[data-v-dbe8ab8c],.chatList li .img img[data-v-dbe8ab8c]{width:26px;height:26px;border-radius:50%}.chat_info[data-v-dbe8ab8c]{padding:4px 0;line-height:18px;color:#fff;padding-left:35px}.chat_info img[data-v-dbe8ab8c]{border-radius:5px;margin-top:5px}.zhuTeacher[data-v-dbe8ab8c]{display:inline-block;text-align:center;color:#fff;background:red;font-size:10px;margin-left:2px;line-height:13px;padding:2px 3px;border-radius:3px}", ""]);

// exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pullRefresh = __webpack_require__(103);

var _pullRefresh2 = _interopRequireDefault(_pullRefresh);

__webpack_require__(104);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_pullRefresh2.default);
exports.default = {
  props: ["ds_id", 'noticeObj'],
  data: function data() {
    return {
      chatRecord: [],
      disabled: false,
      fristMsgId: "",
      isLoading: false,
      reviewWrap: [],
      isFristMsg: true
    };
  },

  watch: {
    ds_id: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          this.loadMore();
        }
      },

      immediate: false
    },
    noticeObj: function noticeObj(newVal, oldVal) {
      if (newVal.open) {
        var index_tmp = this.reviewWrap.findIndex(function (item) {
          return item.module == "notice";
        });
        console.error("================", newVal);
        if (index_tmp != -1) {
          this.reviewWrap.splice(index_tmp, 1);
        }
        this.reviewWrap.unshift({
          module: "notice",
          content: newVal.content,
          nick: "公告",
          header: "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/wx-user/img/ico_gonggao%402x.png"
        });
        this.chatRecord = this.reviewWrap.concat().reverse();
      } else {
        var _index_tmp = this.reviewWrap.findIndex(function (item) {
          return item.module == "notice";
        });
        if (_index_tmp != -1) {
          this.reviewWrap.splice(_index_tmp, 1);
        }
        this.chatRecord = this.reviewWrap.concat().reverse();
      }
    }
  },
  methods: {
    loadMore: function loadMore() {
      console.error("加载更多");
      var that = this;
      var url = _Tools2.default.baseUrl2() + "/comment/index/listsForStudent";
      var option = "ds_id=" + this.ds_id + "&_id=" + this.fristMsgId;
      this.axios.post(url, option).then(function (res) {
        var data = res.data;
        if (data.code == "200") {
          that.reviewWrap = that.reviewWrap.concat(data.data);
          that.chatRecord = that.reviewWrap.concat().reverse();
          if (data.data.length > 0) {
            that.fristMsgId = that.reviewWrap[that.reviewWrap.length - 1]._id;
            that.isLoading = false;
          }
        } else {
          console.log(data.message);
        }
        that.isLoading = false;
        if (that.isFristMsg) {
          that.isFristMsg = false;
          that.msgScrollBottom();
        }
      }).catch(function (res) {
        that.isLoading = false;
        console.log(res);
      });
    },
    imgOnload: function imgOnload() {
      this.msgScrollBottom();
    },
    preview: function preview(url) {
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: [url] // 需要预览的图片http链接列表
      });
    },
    deleteComment: function deleteComment(json) {
      console.log(this.reviewWrap);
      for (var i = 0; i < this.reviewWrap.length; i++) {
        var item = this.reviewWrap[i];
        if (item._id == json._id) {
          this.reviewWrap.splice(i, 1);
          break;
        }
      }
    },
    textComment: function textComment(json) {
      //先审后发处理
      var hasKey = this.reviewWrap.find(function (item1) {
        return item1.key == json.key && item1.key;
      });
      if (hasKey) {
        return;
      }
      //未读消息处理
      // if (this.isOnscroll) {
      // this.isShowUnReadMsg = true;
      // this.unReadMsgNum = this.unReadMsgNum + 1;
      // } else {
      // this.isShowUnReadMsg = false;
      // this.unReadMsgNum = 0;
      // }
      if (json.content && json.content != "null") {
        json.content = json.content.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
      }

      this.reviewWrap.unshift(json);

      //评论超过1千删除200
      if (this.reviewWrap.length > 400) {
        this.reviewWrap = this.reviewWrap.slice(0, 250);
      }
      this.chatRecord = this.reviewWrap.concat().reverse();
      //一秒内收到多条消息时，只刷新一次
      this.msgScrollBottom();
    },
    msgScrollBottom: function msgScrollBottom() {
      setTimeout(function () {
        document.getElementById("vertical_message_box").scrollTop = document.getElementById("vertical_message_box").scrollHeight;
      }, 0);
    }
  }
};

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical_message_box",
    attrs: {
      "id": "vertical_message_box"
    }
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.loadMore
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('div', {
    attrs: {
      "id": "ChatRoomContent"
    }
  }, _vm._l((_vm.chatRecord), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "chatList"
    }, [(item.module == 'text_comment') ? _c('li', [_c('div', {
      staticClass: "chat_box"
    }, [_c('div', {
      staticClass: "img fl"
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    })]), _vm._v(" "), (item.module == 'text_comment') ? _c('div', {
      staticClass: "chat_info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nick) + ":")]), _vm._v(" "), (item.showzhu == 1) ? _c('span', {
      staticClass: "zhuTeacher"
    }, [_vm._v("老师")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "chat_text"
    }), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticStyle: {
        "max-width": "50%",
        "display": "block"
      },
      attrs: {
        "src": item.pic_url
      },
      on: {
        "load": _vm.imgOnload,
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.module == 'notice') ? _c('div', {
      staticClass: "chat_info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nick) + ":")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "chat_text"
    })]) : _vm._e()])]) : _vm._e()])
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  "data-v-1e9c0f32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(519);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("8fea26d2", content, true);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".toolbar[data-v-1e9c0f32]{position:absolute;bottom:0;left:0;background:rgba(0,0,0,.6);z-index:800;height:52px;padding:8px;display:flex}.iosPosition .textarea[data-v-1e9c0f32],.toolbar[data-v-1e9c0f32]{width:100%;box-sizing:border-box}.zanBtn[data-v-1e9c0f32]{width:36px;height:36px;margin-right:5px}.comment[data-v-1e9c0f32]{position:relative;display:flex;background:#cfbbbb;height:36px;line-height:36px;border-radius:18px;width:100%}.comment .inputValue[data-v-1e9c0f32]{width:100%;padding:0 40px 0 20px;box-sizing:border-box;background:none;border:none}.comment img[data-v-1e9c0f32]{position:absolute;top:2px;right:2px;width:32px;height:32px}.btnBox[data-v-1e9c0f32]{display:-webkit-box;display:-moz-box;display:flex;text-align:center;margin-top:10px;margin-bottom:10px}.btnBox .btn[data-v-1e9c0f32]{flex:1;margin:0 5px;height:42px;line-height:42px;color:#fff;border-radius:3px;font-size:16px;background:#ccc}.btnBox .btn[data-v-1e9c0f32]:last-child{background:#3377db}", ""]);

// exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _popup = __webpack_require__(19);

var _popup2 = _interopRequireDefault(_popup);

__webpack_require__(7);

__webpack_require__(21);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _handleim = __webpack_require__(40);

var _handleim2 = _interopRequireDefault(_handleim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_popup2.default);

exports.default = {
	data: function data() {
		return {
			fid: '',
			imgPath: '',
			placeholder: "请输入你要发表的内容",
			commentBox: false,
			inputValue: '',
			sendFollowerText: '',
			sendMsgTimer: null
		};
	},

	props: ['isWeixin', 'commentList', 'isIOS', 'fans_id', 'isMaster', 'ds_id', 'isshowgift', 'say_self'],
	mounted: function mounted() {
		this.imgPath = _Tools2.default.imgPath();
	},

	methods: {
		showcommentBox: function showcommentBox() {
			this.commentBox = !this.commentBox;
		},
		sendFllowerTap: function sendFllowerTap(type) {
			if (type == 1) {
				this.sendFollowerText = "送给老师的鲜花<img style='width:20px;ertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/xianhua.png'/>";
			} else if (type == 2) {
				this.sendFollowerText = "给老师点个赞<img style='width:20px;vertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/dianzhan.png'/>";
			}
			this.sendMsg(1);
		},
		sendMsg: function sendMsg(type) {
			var _this = this;

			var that = this;
			var contentText = "";
			if (type == 1) {
				contentText = this.sendFollowerText;
			} else {
				contentText = this.inputValue.replaceAll("<", "#").replaceAll(">", "#").replaceAll("&lt;", "#").replaceAll("&gt;", "#");
			}

			if (contentText.length < 1) {
				(0, _toast2.default)('发送消息不能为空');
				return false;
			}

			if (this.sendMsgTimer) {
				(0, _toast2.default)("评论发送太快了");
				return;
			} else {
				this.sendMsgTimer = setTimeout(function () {
					clearTimeout(_this.sendMsgTimer);
					_this.sendMsgTimer = null;
				}, type == 1 ? 5000 : 1000);
			}

			if (that.say_self.enabled && that.say_self.all == 1) {
				//全员自嗨
				that.sendMessageMySelf(contentText, '');
				if (type != 1) {
					that.inputValue = "";
				}
				that.commentBox = false;
				return;
			}

			var url2 = _Tools2.default.baseUrl2() + '/comment/index/add';
			var option2 = {
				terminal_type: 1,
				fans_id: this.fans_id,
				ds_id: _Tools2.default.getDs_id(),
				content: contentText,
				debug: 1,
				fid: this.fid
			};
			option2 = _qs2.default.stringify(option2);
			this.axios.post(url2, option2).then(function (data) {
				var data = data.data;
				if (data.code == "200") {
					// Toast('评论成功');
					that.quick_id = '';
					that.fid = '';
					if (data.data.isCheck) {
						var newObj = Object.assign({}, data.data.content);
						newObj.module = "check_comment";
						_handleim2.default.sendTextMsg(newObj);
					} else {
						_handleim2.default.sendTextMsg(data.data.content);
					}
					that.$emit("comment", data.data.content);
				} else {
					if (that.say_self.enabled) {
						//开启自嗨
						that.sendMessageMySelf(contentText, '');
					} else {
						(0, _toast2.default)(data.message);
					}
				}
				that.commentBox = false;
			}).catch(function (data) {
				(0, _toast2.default)('评论失败');
				that.quick_id = '';
				that.fid = '';

				console.log('错误' + data);
			});

			if (type != 1) {
				this.inputValue = "";
			}
		},
		sendMessageMySelf: function sendMessageMySelf(text, pic_url) {
			var app_id = localStorage.getItem("current_app_Id");
			if (app_id) {
				var userInfo = localStorage.getItem(app_id);
				if (userInfo) {
					var userInfo2 = JSON.parse(userInfo);
					var message = {
						content: text,
						create_time: _Tools2.default.getCommentTimes(),
						fans_id: userInfo2.fans_id,
						header: userInfo2.header,
						key: _Tools2.default.getDs_id() + '_comment_' + new Date().getTime(),
						like_num: 0,
						module: "text_comment",
						nick: userInfo2.nick,
						pic_url: pic_url,
						user_type: "real",
						terminal_type: 1,
						ds_id: _Tools2.default.getDs_id(),
						_id: _Tools2.default.getDs_id() + '_comment_' + new Date().getTime()
					};
					this.$emit("comment", message);
					if (this.say_self.type == 1) {
						//是否发送给助教
						_handleim2.default.sendTextMsg(Object.assign({}, message, { module: 'my_self_hi' }));
					}
				}
			}
		}
	}
};

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "toolbar"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowgift),
      expression: "isshowgift"
    }],
    staticClass: "zanBtn fl",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_songhua.png"
    },
    on: {
      "click": function($event) {
        return _vm.sendFllowerTap(1)
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowgift),
      expression: "isshowgift"
    }],
    staticClass: "zanBtn fl",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_dianzan.png"
    },
    on: {
      "click": function($event) {
        return _vm.sendFllowerTap(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "inputValue",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showcommentBox.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/Vertical/send.png"
    },
    on: {
      "click": _vm.sendMsg
    }
  })])]), _vm._v(" "), _c('van-popup', {
    staticClass: "iosPosition",
    model: {
      value: (_vm.commentBox),
      callback: function($$v) {
        _vm.commentBox = $$v
      },
      expression: "commentBox"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": _vm.placeholder,
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMsg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnBox"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.showcommentBox
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("发送")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LiveHotel"
    }
  }, [_c('launch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "loaded": _vm.loaded
    },
    on: {
      "closeload": _vm.closeload
    }
  }), _vm._v(" "), (_vm.isBlack) ? _c('tipsView', {
    attrs: {
      "message": "你无权观看此直播，请联系管理员"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isyxinImLoginOut) ? _c('tipsView', {
    attrs: {
      "message": "你在其他端登陆，刷新后可以重新登陆!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.TelTestShow) ? _c('TelTest', {
    staticStyle: {
      "z-index": "9900"
    },
    attrs: {
      "fans_id": _vm.fans_id,
      "ds_id": _vm.ds_id,
      "show_type": _vm.show_type,
      "need_check_bool": _vm.need_check_bool
    },
    on: {
      "whiteNumOk": _vm.whiteNumOk
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showhead),
      expression: "showhead"
    }],
    staticClass: "headtitle",
    style: ('background:' + _vm.headtitleBg)
  }, [_c('p', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.titleName))])]), _vm._v(" "), (!_vm.isBlack) ? _c('div', {
    staticClass: "player SPZBPlayer"
  }, [_c('TFPlayer', {
    ref: "tfPlayer",
    attrs: {
      "initData": _vm.initData,
      "fans_id": _vm.fans_id,
      "videoIndex": _vm.videoIndex,
      "selectPlayType": _vm.selectPlayType,
      "runObj": _vm.runObj,
      "copyrightObj": _vm.copyrightObj
    },
    on: {
      "statusChange": _vm.playerStatusChange,
      "linkTypeChange": _vm.linkTypeChange,
      "isSupportRTC": _vm.isSupportRTCCallBack,
      "unAutoPlay": _vm.unAutoPlay,
      "playFailed": _vm.playFailed,
      "playerListener": _vm.playerListener
    }
  })], 1) : _c('div', {
    staticClass: "player"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.initData && _vm.initData.direct_seeding.pic_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "floatBox",
    style: ('margin-top:' + _vm.playHeight + 'px')
  }, [(_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    staticClass: "trySee",
    style: ('opacity:' + _vm.tryOpacity)
  }, [_vm._v("\n      试看" + _vm._s(_vm.tryTime) + "秒，付费观看完整版\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tryPayBtn && !_vm.fullscr),
      expression: "tryPayBtn && !fullscr"
    }],
    staticClass: "tryPay",
    style: ('margin-top:' + _vm.barHeight + 'px'),
    on: {
      "click": _vm.onShowPay
    }
  }, [_vm._v("\n      付费\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hot && _vm.noClearScreen),
      expression: "hot && noClearScreen"
    }],
    staticClass: "view_num",
    style: ('margin-top:' + _vm.barHeight + 'px')
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "src": "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/hot_num.png"
    }
  }), _vm._v(" "), (_vm.view_num > 10000) ? [_vm._v(_vm._s(parseInt(_vm.view_num / 100) / 100) + "万")] : [_vm._v(_vm._s(_vm.view_num))]], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "window",
    on: {
      "click": _vm.swichWindow
    }
  }, [(_vm.forbid) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-g.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-w.png'
    }
  })]), _vm._v(" "), (_vm.allot_sale) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPlayUI),
      expression: "!isPlayUI"
    }],
    staticClass: "allot_btn",
    on: {
      "click": _vm.onShowAllot
    }
  }, [_c('span', [_vm._v("邀")]), _vm._v(" "), _c('span', [_vm._v("邀请好友")])]) : _vm._e(), _vm._v(" "), (_vm.shareRedexist) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareRed),
      expression: "shareRed"
    }],
    staticClass: "shareRed",
    attrs: {
      "id": "shareRed"
    }
  }, [_vm._v("\n      分享得\n      "), (_vm.shareType == 0) ? [_vm._v("红包")] : [_vm._v("卡券")]], 2) : _vm._e()]), _vm._v(" "), _c('chatlist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noClearScreen),
      expression: "noClearScreen"
    }],
    ref: "chat",
    attrs: {
      "noticeObj": _vm.noticeObj,
      "ds_id": _vm.ds_id
    }
  }), _vm._v(" "), [_c('toolBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noClearScreen),
      expression: "noClearScreen"
    }],
    attrs: {
      "fans_id": _vm.fans_id,
      "say_self": _vm.say_self,
      "isshowgift": _vm.isshowgift
    },
    on: {
      "comment": _vm.onReceivedMsgCallBack
    }
  }), _vm._v(" "), _c('goodsList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGoods),
      expression: "showGoods"
    }],
    ref: "goodsList",
    attrs: {
      "dsId": _vm.ds_id,
      "fansId": _vm.fans_id,
      "tid": _vm.tid,
      "gid": _vm.gid,
      "uid": _vm.uid,
      "channel_id": _vm.channel_id,
      "goodsIds": _vm.goodsIdsList
    },
    on: {
      "closeBtnClicked": _vm.goodsListCloseBtnClicked
    }
  })], _vm._v(" "), _c('div', {
    staticClass: "rightFunction"
  }, [(_vm.noClearScreen && (_vm.businessConfigs && (_vm.businessConfigs.student_room_link_mic_show || _vm.businessConfigs.student_room_link_mic_show == undefined)) &&
    _vm.initData && _vm.initData.direct_seeding.direct_status == 'running' && _vm.playerStatus == 2) ? _c('div', {
    staticClass: "rightfuncImage"
  }, [(_vm.linkType != 3) ? _c('img', {
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "src": __webpack_require__(523)
    },
    on: {
      "click": _vm.sendApplyLink
    }
  }) : _vm._e(), _vm._v(" "), (_vm.linkType == 3) ? _c('img', {
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "src": __webpack_require__(524)
    },
    on: {
      "click": _vm.sendEndLink
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isshowCart == true) ? _c('img', {
    staticClass: "rightfuncImage",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "src": __webpack_require__(96)
    },
    on: {
      "click": _vm.onShowGoodsList
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "rightfuncImage",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_clear.png"
    },
    on: {
      "click": function($event) {
        _vm.noClearScreen = !_vm.noClearScreen
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noClearScreen),
      expression: "noClearScreen"
    }],
    staticClass: "rightfuncImage",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_qiehuan.png"
    },
    on: {
      "click": function($event) {
        _vm.showLiveWay = true
      }
    }
  })]), _vm._v(" "), (_vm.isShowLoginErr) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "z-index": "1911",
      "background": "rgba(0, 0, 0, 0.84)"
    },
    style: (_vm.loginErrroStyle)
  }, [_c('van-button', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.tryLogin
    }
  }, [_vm._v("重新登录")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weixincode"
  }, [_c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('img', {
    attrs: {
      "src": "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/title-popup.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.weixintopText))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/img/title-popup.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "130px"
    },
    attrs: {
      "src": _vm.weixincodeUrl
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#353535",
      "font-size": "13px",
      "margin-top": "10px"
    }
  }, [_vm._v("\n            - " + _vm._s(_vm.weixinbottomText) + " -\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.isShowQRimg = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.showLiveWay),
      callback: function($$v) {
        _vm.showLiveWay = $$v
      },
      expression: "showLiveWay"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body live-way"
  }, [_c('p', [(_vm.selectPlayType == 2) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tid),
      expression: "!tid"
    }]
  }, [(_vm.selectPlayType == 1) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")])], 1), _vm._v(" "), _c('p', [(_vm.selectPlayType == 3) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.showLiveWay = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.isShowTeacherQrCode),
      callback: function($$v) {
        _vm.isShowTeacherQrCode = $$v
      },
      expression: "isShowTeacherQrCode"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.teacher_qrcode_title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "375px"
    },
    attrs: {
      "src": _vm.teacher_qrcode_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": _vm.showTeacherQrCodeCliced
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showQQPopUp),
      callback: function($$v) {
        _vm.showQQPopUp = $$v
      },
      expression: "showQQPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("QQ授权登录")]), _vm._v(" "), _c('div', {
    staticClass: "qqBox",
    on: {
      "click": _vm.qqloginTap
    }
  }, [_c('img', {
    staticClass: "qqlogoImg",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/img/QQ1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("点击登录")])])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "onlineSchoolLogin",
    style: ({
      width: '100%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showLineSchoolPopUp),
      callback: function($$v) {
        _vm.showLineSchoolPopUp = $$v
      },
      expression: "showLineSchoolPopUp"
    }
  }, [_c('div', {
    staticClass: "onlineSchoolLoginWay"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("网校账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("此课程为VIP课程，需要登录后观看")]), _vm._v(" "), _c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "account"
  }, [_c('span', {
    staticClass: "area"
  }, [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolAccount),
      expression: "onlineSchoolAccount"
    }],
    staticClass: "loginInput",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.onlineSchoolAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.loginType == 1) ? _c('div', {
    staticClass: "account"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolPassword),
      expression: "onlineSchoolPassword"
    }],
    staticClass: "loginInput",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.onlineSchoolPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolPassword = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onLIneSchoolSMSCode),
      expression: "onLIneSchoolSMSCode"
    }],
    staticClass: "loginInput passwordInput",
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.onLIneSchoolSMSCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onLIneSchoolSMSCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('van-button', {
    staticClass: "sendBtn",
    attrs: {
      "size": "small",
      "disabled": _vm.onlineSendMsgNum != 0,
      "type": "primary"
    },
    on: {
      "click": _vm.onlineLineSchoolSendMsg
    }
  }, [_vm._v(_vm._s(_vm.onlineSednMsgText))])], 1), _vm._v(" "), (_vm.loginType == 1) ? _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolPWDLoginClick
    }
  }, [_vm._v("网校登录")]) : _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolLoginClick
    }
  }, [_vm._v("网校登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#10a675",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        _vm.loginType == 1 ? (_vm.loginType = 2) : (_vm.loginType = 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.loginType == 1 ? "验证码登录" : "账号密码登录"))])])], 1)])])], 1), _vm._v(" "), _c('LinkPopup', {
    attrs: {
      "isShow": _vm.linkDialogVisible,
      "linkType": _vm.linkType
    },
    on: {
      "accept": _vm.linkAccept,
      "refuse": _vm.linkRefuse
    }
  }), _vm._v(" "), (_vm.tosafariShow) ? _c('div', {
    staticClass: "tosafari"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "https://tengface-project.oss-cn-shenzhen.aliyuncs.com/tmp/quxiaofei.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.tosafariShow = false
      }
    }
  }, [_vm._v("我不需要连麦")])])])]) : _vm._e(), _vm._v(" "), (_vm.showShoppingType) ? _c('div', {
    staticClass: "shopping-cart",
    staticStyle: {
      "right": "10px",
      "bottom": "230px"
    },
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_c('div', {
    staticClass: "goods-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsInfo.cover,
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "pirce"
  }, [_c('span', [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))]), _vm._v(" "), _c('span', {
    staticClass: "go"
  }, [_vm._v("抢")])]), _vm._v(" "), _c('van-icon', {
    staticClass: "close",
    staticStyle: {
      "top": "10px",
      "right": "-4px"
    },
    attrs: {
      "name": "cross"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showShoppingType = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "shopping-dialog",
    model: {
      value: (_vm.showShoppingDialog),
      callback: function($$v) {
        _vm.showShoppingDialog = $$v
      },
      expression: "showShoppingDialog"
    }
  }, [_c('div', {
    staticClass: "shopping-dialog-content"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "goods-content"
  }, [_c('img', {
    staticClass: "goods-pic",
    attrs: {
      "src": _vm.goodsInfo.cover,
      "width": "96"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))])])])]), _vm._v(" "), _c('div', {
    staticClass: "shopping-btn",
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_vm._v("立即抢购")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(123)
    },
    on: {
      "click": _vm.hideShoppingPop
    }
  })])]), _vm._v(" "), (_vm.showBuyTipsState) ? [_c('div', {
    staticClass: "bug-tips user-buy-goods",
    class: [_vm.showBuyGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(124),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuyUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "bug-tips buy-goods-success",
    class: [_vm.showBuySuccessGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(125),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessText))]), _vm._v(" "), (_vm.inventoryNum !== -1) ? _c('span', [_vm._v(", 库存剩余" + _vm._s(_vm.inventoryNum) + "件")]) : _vm._e()])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(527);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1184d98c", content, true);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".mpbtn{padding:12px;display:block;background:#409eff;margin:auto;border:none;border-radius:10px;color:#fff;margin-top:40px;width:80%;position:absolute;top:0;left:50%;transform:translateX(-50%)}", ""]);

// exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      share: {},
      pathData: "",
      ds_id: "",
      isWeixin: true
    };
  },
  mounted: function mounted() {
    this.shareToWeChat();
    // pqIRxDsAj89/V5lVJADLXDMZkkVioyrEFuM9QibeWJ5WGAiCqnEezz2fpo1G5rRd7do3/MNnVrBNWiJJDdeG2xmS6ORfgUvRdmdK/i2Ksnw=

    this.ds_id = _Tools2.default.getQueryDsId();
    this.isWeixin = _Tools2.default.isWeixin();
    var that = this;
    //获取直播间信息
    _Tools2.default.getDsInfo(function (dsInFo) {
      // 加载微信分享参数
      _Tools2.default.login(dsInFo.direct_seeding.appid, function (userInfo) {
        that.personDataInit(userInfo, dsInFo);
      });
    });
  },

  methods: {
    personDataInit: function personDataInit(fans, dsInfo) {
      //获取用户信息
      var that = this;
      this.pathData = "pages/liveRoom/liveRoom?ds_id=" + this.ds_id + "&token=" + fans.token;

      //重缓存中获取数据
      // this.fans = fans;
      // this.fans_id = this.fans.fans_id;
      // this.headerUrl = this.fans.header;

      // this.checkIsAuth();

      // var queryData = tool.getQueryData(location.href);
      // var hasToken = false;
      // if(queryData.token !== "" && queryData.token){
      //   hasToken = true;
      // }
      // var otherLogin = getQueryString('other');
      //替换邀请码
      // if ((this.user != this.fans_id && this.fans_id && this.fans.token) || (this.isIOS && this.isWeixin && !hasToken && !otherLogin)) {
      //   var data = tool.getQueryData(location.href);
      //   data.fromuser = this.fans_id;
      //   if(this.isIOS && this.isWeixin && !otherLogin){
      //     data.token = this.fans.token;
      //   }
      //   if (tool.checkPhoneType() == 2) {
      //     const url = tool.getUrlAddQuery(
      //         window.location.pathname,
      //         data
      //       );
      //     window.history.replaceState({}, "除去URL参数", url);
      //   }else{
      //     const url = tool.getUrlAddQuery(
      //         window.location.protocol + "//" + window.location.host + window.location.pathname,
      //         data
      //       );
      //     window.location.href = url;
      //   }
      // }

      // 上报邀请数据
      // if(this.user && this.fans_id){
      //   this.invite();
      // }

      // 加载微信分享参数
      that.shareToWeChat();
      //获取直播间信息
      // this.loadAll(dsInfo);
    },
    shareToWeChat: function shareToWeChat() {
      var that = this;
      var option = "url=" + encodeURIComponent(location.href);
      this.axios.post(_Tools2.default.baseUrl2() + "/init/getWechatShareData", option).then(function (data) {
        var data = data.data;
        if (data.code == 200) {
          that.wxReady(data.data.shareData);
        }
      }).catch(function (data) {
        console.log("错误" + data);
      });
    },
    wxReady: function wxReady(params) {
      var that = this;

      //配置分享
      wx.config({
        debug: false,
        appId: params.appid, // 必填
        timestamp: params.timestamp, // 必填，生成签名的时间戳
        nonceStr: params.noncestr, // 必填，生成签名的随机串
        signature: params.signature, // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: ["wx-open-launch-weapp"]
      });

      // this.share.url = params.url;
      // this.share.dec = that.initData.direct_seeding.desc;
      // this.share.title = that.initData.direct_seeding.name;
      // this.share.image = that.initData.direct_seeding.pic_url;
      // this.share.groupImage = that.initData.direct_seeding.pic_url;
      // this.share.groupDesc = that.initData.direct_seeding.name;

      // const funcList = this.initData.ds_func;

      // const shareItem = funcList.find((item) => {
      //   return item.module == "share";
      // });

      // if (shareItem) {
      //   this.share.dec = shareItem.params.friend_des;
      //   this.share.title = shareItem.params.friend_title;
      //   this.share.image = shareItem.params.friend_pic_url;
      //   this.share.groupImage = shareItem.params.moment_pic_url;
      //   this.share.groupDesc = shareItem.params.moment_des;
      // }

      // console.log("分享参数", this.share, params);

      // wx.ready(function() {
      //   //微信好友分享
      //   wx.updateAppMessageShareData({
      //     title: that.share.title, // 分享标题
      //     desc: that.share.dec, // 分享描述
      //     link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
      //     imgUrl: that.share.image, // 分享图标
      //     success: function() {
      //       console.log("设置分享微信好友分享参数成功");
      //     },
      //   });

      //   //微信朋友圈分享
      //   wx.updateTimelineShareData({
      //     title: that.share.groupDesc, // 分享标题
      //     link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
      //     imgUrl: that.share.groupImage, // 分享图标
      //     success: function() {
      //       console.log("设置分享微信朋友圈分享参数成功");
      //     },
      //   });
      // });
      wx.error(function (data) {
        console.log("错误");
        console.log(data);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isWeixin) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_vm._v("\n    请在微信浏览器中打开\n  ")]) : [_c('wx-open-launch-weapp', {
    attrs: {
      "id": "launch-btn",
      "username": "gh_691c02fc94f9",
      "path": _vm.pathData
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n            <style>.mpbtn {\n                    padding: 12px;\n                    display: block;\n                    background: #409eff;\n                    margin: auto;\n                    border: none;\n                    border-radius: 10px;\n                    color: #ffffff;\n                    margin-top: 40px;\n                    width: 320px;\n                    margin-left:50px;\n                  }</style>\n             <button class=\"mpbtn\">打开腾慧直播小程序</button>\n      ")])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  "data-v-53b97572",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("550007d4", content, true);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".cover[data-v-53b97572]{width:100%;position:relative}.cover .poster[data-v-53b97572]{position:absolute;left:0;right:0;top:0;bottom:0;height:100%}.cover .back-btn[data-v-53b97572]{position:absolute;z-index:10;width:30px;height:30px;top:13px;left:13px;border-radius:50%;display:flex;justify-content:center;align-items:center;background:rgba(0,0,0,.5)}.cover .back-btn img[data-v-53b97572]{width:20px;height:20px}.dialogpay[data-v-53b97572]{position:fixed;width:100%;border-top-left-radius:10px;border-top-right-radius:10px;bottom:0;background-color:#fff;z-index:9999999}.info[data-v-53b97572]{display:flex;align-items:center;padding:0 16px}.info .price[data-v-53b97572]{width:100%;height:54px;box-sizing:border-box;color:#f34718;font-weight:700;display:flex;align-items:center}.info .price .symbol[data-v-53b97572]{font-size:16px}.info .price .num[data-v-53b97572]{font-size:28px}.info .inventory-num[data-v-53b97572]{flex-shrink:0}.goods-title[data-v-53b97572]{color:#101010;font-weight:700;line-height:28px;box-sizing:border-box;padding:0 16px;overflow:hidden;font-size:18px;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal!important;word-wrap:break-word;margin-bottom:16px}.payname[data-v-53b97572]{color:#888;font-size:12px;margin-top:34px;text-align:center}.goods-detail[data-v-53b97572]{box-sizing:border-box;padding:0 16px;color:#101010}.goods-detail .title[data-v-53b97572]{font-size:14px;font-weight:700;margin-bottom:16px}.goods-detail .text-desc[data-v-53b97572]{width:100%;padding-bottom:50px}.buy-btn[data-v-53b97572]{position:fixed;bottom:5px;left:50%;transform:translateX(-50%);width:75%}.buy-btn .van-button.disabled[data-v-53b97572]{background-color:#ddd;border-color:#ddd}.consultTeacher[data-v-53b97572]{width:100%;height:500px;position:fixed;bottom:0;left:0;z-index:5100}.payclose[data-v-53b97572]{position:absolute;right:20px;top:15px;width:20px;height:20px}.paytitle[data-v-53b97572]{width:100%;text-align:center;color:#000;font-size:16px;font-weight:700;margin-top:18px}.consultTeacher .consultTeacherMain[data-v-53b97572],.consultTeacher .messageMain[data-v-53b97572]{position:relative;border-top-left-radius:10px;border-top-right-radius:10px;width:100%;height:100%;background-color:#fff}.messageMain .header[data-v-53b97572]{height:40px;width:100%;border-bottom:1px solid #f5f5f5}.messageMain .header .back[data-v-53b97572]{width:20px;margin-left:15px;vertical-align:-5px}.messageMain .header span[data-v-53b97572]{line-height:40px}.consultTeacherMain .header[data-v-53b97572]{height:40px;width:100%;border-bottom:1px solid #f5f5f5}.consultTeacherMain .header span[data-v-53b97572]{line-height:40px;margin-left:20px}.mask1[data-v-53b97572]{z-index:999}.mask1[data-v-53b97572],.mask2[data-v-53b97572]{position:fixed;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,.5)}.mask2[data-v-53b97572]{z-index:99999999}.mask3[data-v-53b97572]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:999}.closeBtn[data-v-53b97572]{width:20px;height:20px;position:absolute;right:10px;top:10px}.consultTeacher .consultTeacherMain .TeacherList[data-v-53b97572]{width:100%;height:459px;overflow:auto;box-sizing:border-box;padding:16px}.consultTeacherMain .TeacherList .teacherCell[data-v-53b97572]{width:100%;margin-bottom:16px;display:flex;align-items:center}.consultTeacherMain .TeacherList .teacherCell .goods-num[data-v-53b97572]{width:30px}.consultTeacherMain .TeacherList .teacherCell.order[data-v-53b97572]{padding-bottom:25px;border-bottom:1px solid #eee}.consultTeacherMain .TeacherList .teacherCell .goods-content[data-v-53b97572]{margin-left:10px;flex:1}.consultTeacherMain .TeacherList .teacherCell .goods-content .goods-title[data-v-53b97572]{font-weight:700px;font-size:14px;line-height:20px;font-size:#101010;width:170px;height:40px;font-weight:700;margin-bottom:10px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal!important;word-wrap:break-word}.consultTeacherMain .TeacherList .teacherCell .goods-price[data-v-53b97572]{display:flex;color:#f34718;font-weight:700;align-items:center}.consultTeacherMain .TeacherList .teacherCell .goods-price .stepper[data-v-53b97572]{margin-left:auto;font-weight:400}.consultTeacherMain .TeacherList .teacherCell .money-symbol[data-v-53b97572]{font-size:12px}.consultTeacherMain .TeacherList .teacherCell .money-num[data-v-53b97572]{font-size:18px}.consultTeacherMain .TeacherList .teacherCell .to-buy[data-v-53b97572]{width:60px;height:25px;color:#f5f5f5;text-align:center;line-height:25px;background:linear-gradient(315deg,#ed3f10,#fb724d);border-radius:4px;margin-left:auto}.consultTeacherMain .TeacherList .teacherCell .cover[data-v-53b97572]{height:72px;width:110px;border-radius:4px}.consultTeacherMain .TeacherList .form[data-v-53b97572]{outline:none;position:relative}.consultTeacherMain .TeacherList .form input[data-v-53b97572]{width:200px}.consultTeacherMain .TeacherList i[data-v-53b97572]{position:absolute;font-style:normal;left:-8px;top:4px}.consultTeacherMain .footer[data-v-53b97572]{position:fixed;bottom:0;left:0;display:flex;width:100%;padding:0 10px;height:50px;box-sizing:border-box;align-items:center}.consultTeacherMain .footer .sum-text[data-v-53b97572]{margin-right:4px}.consultTeacherMain .footer .sum-money[data-v-53b97572]{color:#f34718;font-weight:700}.consultTeacherMain .footer .sum-money span[data-v-53b97572]:first-child{font-size:14px;margin-right:2px}.consultTeacherMain .footer .sum-money span[data-v-53b97572]:last-child{font-size:22px}.consultTeacherMain .footer .comfirm-btn[data-v-53b97572]{margin-left:auto}.consultTeacherMain .footer .comfirm-btn button[data-v-53b97572]{border:none;color:#fff;width:100px;height:36px;border-radius:20px;background:#0084ff}.qqLogin[data-v-53b97572]{z-index:2002!important}.loginWay[data-v-53b97572]{padding:10%}.loginWay .qqtitle[data-v-53b97572]{color:#000;font-size:16px;text-align:center}.loginWay .qqBox[data-v-53b97572]{display:block;font-size:12px;color:#000;text-decoration:none;margin:25px 8px 15px;text-align:center}.loginWay .qqlogoImg[data-v-53b97572]{display:block;width:60px;height:60px;margin:0 auto 5px}.tips[data-v-53b97572]{display:flex;align-items:center;justify-content:center;flex-direction:column;width:100vw;height:100vh;margin-top:-50%}.tips img[data-v-53b97572]{width:200px}.tips span[data-v-53b97572]{font-size:20px;margin-top:20px}.mask[data-v-53b97572]{position:fixed;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,.5);z-index:9999}.qpayb[data-v-53b97572]{font-weight:700;font-size:20px;margin-top:8px;margin-bottom:50px;text-align:center;color:#202020}.payprice[data-v-53b97572]{font-size:40px}.paybx[data-v-53b97572]{padding:0 28px;margin-bottom:30px;display:flex;justify-content:space-between}.wxpaybx[data-v-53b97572]{display:flex;align-items:center}.logot[data-v-53b97572]{width:24px;height:24px}.checkin[data-v-53b97572]{width:20px;height:20px}.qrpaybx[data-v-53b97572]{display:flex;margin-top:240px;margin-bottom:10px;justify-content:center}.qrpay[data-v-53b97572]{width:351px;line-height:22px;color:#fff;border-radius:20px;display:flex;justify-content:center;background:#08c160;padding:13px 0}.tzbxs[data-v-53b97572]{width:19px;height:19px;position:relative;top:-8px}.tzbx[data-v-53b97572]{padding:0 10px;display:flex;align-items:center;margin-bottom:30px}.tzbx1[data-v-53b97572]{padding-top:40px;display:flex;justify-content:space-between}.coybx[data-v-53b97572]{margin-left:10px}.copy1[data-v-53b97572]{background:red;color:#fff;width:60px;height:25px;display:flex;justify-content:center;align-items:center;margin-right:40px;margin-top:10px;border-radius:20px}.bzt[data-v-53b97572]{position:relative}.logot1[data-v-53b97572]{position:absolute;top:-35px;left:7px}", ""]);

// exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

var _field = __webpack_require__(56);

var _field2 = _interopRequireDefault(_field);

var _notify = __webpack_require__(119);

var _notify2 = _interopRequireDefault(_notify);

var _swipeItem = __webpack_require__(36);

var _swipeItem2 = _interopRequireDefault(_swipeItem);

var _swipe = __webpack_require__(35);

var _swipe2 = _interopRequireDefault(_swipe);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(7);

__webpack_require__(57);

__webpack_require__(121);

__webpack_require__(39);

__webpack_require__(38);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

var _axios = __webpack_require__(28);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_swipe2.default);
_vue2.default.use(_swipeItem2.default);
_vue2.default.use(_notify2.default);
_vue2.default.use(_field2.default);
_vue2.default.use(_toast2.default);
exports.default = {
  data: function data() {
    return {
      paydatile: false,
      maskshow: false,
      maskshow1: false,
      maskshow2: false,
      coyshow: false,
      wxcheck: 1,
      apilcheck: 0,
      gid: '',
      goodsInfo: {},
      confirm: false,
      goodsNum: 1,
      username: '',
      tel: '',
      formList: [],
      form: {},
      ds_id: '',
      app_id: 'wxf7f90bb2c6ec7815',
      showWxPopUp: false,
      showAliPopUp: false,
      showTips: false,
      uid: '',
      wx_app_id: '',
      ali_app_id: '',
      platform: '',
      channel_id: '',
      tipsText: '',
      aliCode: '',
      fans: '',
      header: '',
      nick: '',
      aLiPayUrl: '',
      loginAliUrl: ''
    };
  },

  watch: {
    goodsNum: function goodsNum(val) {
      if (val < 1) {
        (0, _notify2.default)('商品数量必须大于1');
        this.goodsNum = 1;
        return;
      }
      if (this.goodsInfo.infinite == 0 && this.goodsInfo.count < val) {
        (0, _notify2.default)('商品数量不能大于库存数');
        this.goodsNum = this.goodsInfo.count;
        return;
      }
    }
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.ds_id = _Tools2.default.getDs_id();
              _this.gid = _this.$route.query.id;
              _this.uid = _this.$route.query.uid;
              _this.platform = _this.$route.query.platform;
              _this.channel_id = _this.$route.query.channel_id;
              if (!_this.ds_id) {
                _this.ds_id = _this.$route.query.dsId || _this.$route.query.ds_Id || _this.$route.query.ds_id;
              }
              if (_this.channel_id === 'null') {
                _this.channel_id = '';
              }
              if (_this.platform == 'ali') {
                _this.qcheck1();
              } else if (_this.platform == 'wx') {
                _this.qcheck();
              }
              console.log(_this.platform, 'this.platform');
              if (_this.platform) {
                _this.ds_id = _this.$route.query.dsId || _this.$route.query.ds_id;
              }
              _this.aliCode = _this.$route.query.aliCode;
              // await this.getAppId(this.uid)
              // if(tool.isWeixin()){
              //     if(this.platform == 'ali'){
              //       this.tipsText = '请在支付宝内打开'
              //       this.showTips = true
              //       return
              //     }
              //     this.login(this.wx_app_id)
              // }else if(this.isInAliPay()){
              //   if(this.platform == 'wx'){
              //       this.tipsText = '请微信内打开'
              //       this.showTips = true
              //       return
              //     }
              //     this.aliLogin(this.ali_app_id)
              // }else{
              //     this.tipsText = '请在微信或者支付宝内打开'
              //     this.showTips = true
              // }
              _this.getGoodsDetail(_this.gid);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {},

  methods: {
    getOrgPayConfig: function getOrgPayConfig(opid) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var option, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                option = 'opid=' + opid;
                _context2.next = 4;
                return _axios2.default.post('https://zhifu-api.tenghuiwangxiao.cn/common/getOrgPayConfig', option);

              case 4:
                res = _context2.sent;

                _this2.wx_app_id = res.data.data.wxappid;
                if (_this2.wx_app_id) {
                  _Tools2.default.setAppID(_this2.wx_app_id);
                }
                _this2.ali_app_id = res.data.data.aliappid;
                _this2.loginAliUrl = res.data.data.aliurl;
                console.log("getOrgPayConfig", res);

                if (!_Tools2.default.isWeixin()) {
                  _context2.next = 18;
                  break;
                }

                if (!(_this2.platform == 'ali')) {
                  _context2.next = 15;
                  break;
                }

                _this2.tipsText = '请在支付宝内打开';
                _this2.showTips = true;
                return _context2.abrupt('return');

              case 15:
                _this2.login(_this2.wx_app_id);
                _context2.next = 28;
                break;

              case 18:
                if (!_this2.isInAliPay()) {
                  _context2.next = 26;
                  break;
                }

                if (!(_this2.platform == 'wx')) {
                  _context2.next = 23;
                  break;
                }

                _this2.tipsText = '请微信内打开';
                _this2.showTips = true;
                return _context2.abrupt('return');

              case 23:
                _this2.aliLogin(_this2.ali_app_id);
                _context2.next = 28;
                break;

              case 26:
                _this2.tipsText = '请在微信或者支付宝内打开';
                _this2.showTips = true;

              case 28:
                _context2.next = 32;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t0 = _context2['catch'](0);

              case 32:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 30]]);
      }))();
    },
    close1: function close1() {
      this.paydatile = false;
      this.closeBtnClicked();
      this.maskshow = false;
    },
    close2: function close2() {
      // console.log(888);
      this.coyshow = false;
      // this.maskshow=false
      this.closeBtnClicked();
      this.maskshow = false;
    },
    copy: function copy() {
      var copy = this.aLiPayUrl;
      this.$copyText(copy).then(function () {
        (0, _notify2.default)({ type: 'success', message: '复制成功', background: '#4fc08d' });
        // Toast('复制成功！');
      });
    },
    quzhifu: function quzhifu() {
      if (!this.platform) {
        if (!this.apilcheck) {
          // 微信支付
          this.submitOrder();
          // console.log('微信支付')
        } else {
          this.submitOrder();
          // 支付宝
          this.coyshow = true;
          this.paydatile = false;
          this.confirm = false;
          this.maskshow2 = false;
        }
      } else {
        this.submitOrder();
      }
    },
    submitOrdert: function submitOrdert() {
      var that = this;
      for (var i in this.form) {
        if (i) {
          if (this.form[i].required == 1 && !this.form[i].value) {
            (0, _notify2.default)('\u8BF7\u586B\u5199' + this.form[i].name);
            return;
          }
        }
      }
      var extObj = {};
      for (var i in this.form) {
        extObj[this.form[i].id] = this.form[i].value;
      }
      //URL支付
      if (this.goodsInfo.flag == 2) {
        this.submitLinkURlOrder(this.goodsInfo.payurl);
        return;
      }
      this.maskshow = true;
      this.paydatile = true;
    },
    qcheck: function qcheck() {
      // console.log(e);
      this.wxcheck = 1, this.apilcheck = 0;
    },
    qcheck1: function qcheck1() {
      // console.log(e);
      this.wxcheck = 0, this.apilcheck = 1;
    },
    handleBack: function handleBack() {
      this.$router.back();
    },
    toConfirm: function toConfirm() {
      if (this.goodsInfo.flag == 2) {
        //链接购买
        location.href = this.goodsInfo.payurl;
      } else {
        var _goodsInfo = this.goodsInfo,
            count = _goodsInfo.count,
            infinite = _goodsInfo.infinite;

        if (count == 0 && infinite == 0) {
          (0, _notify2.default)('商品库存不足');
          return;
        }
        this.confirm = true;
        this.maskshow2 = true;
        this.stopScroll();
      }
    },
    closeBtnClicked: function closeBtnClicked() {
      this.confirm = false;
      this.maskshow2 = false;
      this.canScroll();
    },

    // 获取appid
    getAppId: function getAppId(uid) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _ref, _ref$data$data, appid, ali_appid;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.axios.get(_Tools2.default.baseUrl2() + "/user/login/getWxAppid?uid=" + uid);

              case 2:
                _ref = _context3.sent;
                _ref$data$data = _ref.data.data;
                appid = _ref$data$data.appid;
                ali_appid = _ref$data$data.ali_appid;

                if (appid) {
                  _this3.wx_app_id = appid;
                  _Tools2.default.setAppID(_this3.wx_app_id);
                }
                if (ali_appid) {
                  _this3.ali_app_id = ali_appid;
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    login: function login(appId) {
      var _this4 = this;

      if (!this.getCache(appId) || !this.fans.openid) {
        var loginCode = _Tools2.default.getQueryString("code");
        if (!loginCode) {
          this.showWxPopUp = true;
        } else {
          console.log('code', loginCode);
          var loginUrl = _Tools2.default.baseUrl2() + "/user/login/wxAuthForGoods?code=" + loginCode + "&goods_id=" + this.gid;
          console.log('loginUrl', loginUrl);
          _axios2.default.get(loginUrl, { timeout: 2000 }).then(function (res) {
            console.log(res);
            if (res.data.code == 200) {
              var _data = res.data.data;
              var fans = {
                fans_id: _data.fans_id,
                header: _data.header,
                nick: _data.nick,
                userSig: _data.tsl_sig,
                real_auth: _data.real_auth,
                status: _data.status,
                token: _data.token,
                openid: _data.openid
              };
              _this4.header = _data.header;
              _this4.nick = _data.nick;
              if (appId) {
                localStorage.setItem("current_app_Id", appId);
                localStorage.setItem(appId, JSON.stringify(fans));
              }
            } else if (data.data.code == 400) {
              _this4.initLoginJumpWx(appId);
            }
          });
        }
      }
    },
    aliLogin: function aliLogin(appId) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, _res$data, code, _res$data$data, avatar, nick_name, user_id, fans;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this5.getCache(appId)) {
                  _context4.next = 11;
                  break;
                }

                if (_this5.aliCode) {
                  _context4.next = 5;
                  break;
                }

                _this5.showAliPopUp = true;
                _context4.next = 11;
                break;

              case 5:
                if (!(appId && _this5.aliCode)) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 8;
                return _axios2.default.get(_Tools2.default.baseUrl2() + ('/user/login/zfbLogin?code=' + _this5.aliCode));

              case 8:
                res = _context4.sent;
                _res$data = res.data, code = _res$data.code, _res$data$data = _res$data.data, avatar = _res$data$data.avatar, nick_name = _res$data$data.nick_name, user_id = _res$data$data.user_id;

                if (code == 200) {
                  fans = {
                    header: avatar,
                    userId: user_id,
                    nick: nick_name
                  };

                  _this5.header = avatar;
                  _this5.nick = nick_name;
                  localStorage.setItem("current_app_Id", appId);
                  localStorage.setItem(appId, JSON.stringify(fans));
                  // this.clearAliInfo()
                }

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },

    // 清除支付宝授权信息
    clearAliInfo: function clearAliInfo() {
      var data = getQueryData(window.location.href);
      data.aliCode = '';
      if (_Tools2.default.checkPhoneType() == 2) {
        var url = _Tools2.default.getUrlAddQuery(window.location.pathname, data);
        console.log(url);
        window.history.replaceState({}, "除去URL参数", url);
      } else {
        var url = _Tools2.default.getUrlAddQuery(window.location.protocol + "//" + window.location.host + window.location.pathname, data);
        window.location.href = url;
      }
    },

    //微信确认登录
    initLoginJumpWx: function initLoginJumpWx(appid) {
      var redirect_uri = window.location.href;
      redirect_uri = redirect_uri.split("&code")[0];
      console.log('redirect_uri', redirect_uri);
      // window.location.href =
      //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      //   appid +
      //   "&redirect_uri=" +
      //   encodeURIComponent(redirect_uri) +
      //   "&response_type=code&scope=snsapi_userinfo&state=STATE";
      var redirectUrl = encodeURIComponent(redirect_uri);
      window.location.href = 'https://login.bbxiuc.cn/login/#/wx-login?appId=' + appid + '&redirectUrl=' + redirectUrl + '&title=' + this.goodsInfo.name + '&origin=tengface';
    },

    // 取消登录
    closeWindow: function closeWindow() {
      wx.closeWindow();
    },
    closeAliWindow: function closeAliWindow() {
      AlipayJSBridge.call('closeWebview');
    },

    // 点击登录
    wxloginTap: function wxloginTap() {
      this.initLoginJumpWx(this.wx_app_id);
    },
    aliLoginTap: function aliLoginTap() {
      // const url = `https://login.tengface.net/login?appid=${this.ali_app_id}&redirect_url=${encodeURIComponent(window.location.href)}`
      var url = this.loginAliUrl + 'ali_login?appid=' + this.ali_app_id + '&redirect_url=' + encodeURIComponent(window.location.href);
      window.location.href = url;
    },
    getCache: function getCache(appIdTmp) {
      //判断缓存是否存在
      try {
        var fans = JSON.parse(localStorage.getItem(appIdTmp));
        this.fans = fans;
        if (fans) {
          return true;
        }
      } catch (e) {
        localStorage.removeItem(appIdTmp);
        return false;
      }
      return false;
    },

    // 判断是否在支付宝浏览器
    isInAliPay: function isInAliPay() {
      if (/AlipayClient/.test(window.navigator.userAgent)) {
        //判断是否是支付宝浏览器打开
        return true;
      }
    },

    // 获取商品详情
    getGoodsDetail: function getGoodsDetail(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var appid, fans, option, _ref2, _data2;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                appid = localStorage.getItem("current_app_Id");
                fans = JSON.parse(localStorage.getItem(appid) || "{}");
                // tool.baseUrl2()+

                option = 'id=' + id + '&type=1&ds_id=' + _this6.ds_id + '&fans_id=' + fans.fans_id + '&channel_code=' + _this6.channel_id;
                // "id=" +
                // id +
                // "&type=1" +
                // "&ds_id=" +
                // this.ds_id +
                // "&fans_id=" +
                // fans.fans_id +
                // "&channel_id=" +
                // this.channel_id;

                _context5.next = 6;
                return _this6.axios.post(_Tools2.default.baseUrl2() + '/goods/info', option);

              case 6:
                _ref2 = _context5.sent;
                _data2 = _ref2.data.data;

                // const {data:{data}} = await this.axios.post(`http://liveapi2.tenghuiwangxiao.com/api/goods/info`, option)
                console.log(_data2);
                _data2.desc = _data2.desc.replace(/<iframe /g, '<iframe style= "width:100%"');
                console.log(_data2.desc);
                _this6.goodsInfo = _data2;
                if (_data2.flag != 2) {
                  //链接支付 
                  _this6.getOrgPayConfig(_data2.opid);
                }
                _this6.formList = JSON.parse(_data2.ext);
                _this6.formList.forEach(function (item) {
                  _this6.$set(_this6.form, 'custom' + item.id, { value: '', required: item.required, name: item.name, id: item.id });
                });
                _this6.getGoodsNum();
                _context5.next = 21;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);

              case 21:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 18]]);
      }))();
    },

    // 提交订单
    submitOrder: function submitOrder() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var i, extObj, data, appid, fans, _appid, _fans, option, _ref3, _ref3$data, code, resData, message, money, order_no;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.maskshow1 = true;
                // console.log('微信支付')
                _context6.t0 = regeneratorRuntime.keys(_this7.form);

              case 2:
                if ((_context6.t1 = _context6.t0()).done) {
                  _context6.next = 10;
                  break;
                }

                i = _context6.t1.value;

                if (!i) {
                  _context6.next = 8;
                  break;
                }

                if (!(_this7.form[i].required == 1 && !_this7.form[i].value)) {
                  _context6.next = 8;
                  break;
                }

                (0, _notify2.default)('\u8BF7\u586B\u5199' + _this7.form[i].name);
                return _context6.abrupt('return');

              case 8:
                _context6.next = 2;
                break;

              case 10:
                extObj = {};

                for (i in _this7.form) {
                  extObj[_this7.form[i].id] = _this7.form[i].value;
                }

                data = {
                  goods_id: _this7.gid,
                  num: _this7.goodsNum,
                  channel_id: _this7.channel_id
                };


                if (_this7.ds_id) {
                  data.ds_id = _this7.ds_id;
                }
                //  console.log('zhifu')
                if (_this7.isInAliPay()) {
                  appid = localStorage.getItem("current_app_Id");
                  fans = JSON.parse(localStorage.getItem(appid) || "{}");

                  data.nick_name = fans.nick;
                  data.header = fans.header;
                } else {
                  _appid = localStorage.getItem("current_app_Id");
                  _fans = JSON.parse(localStorage.getItem(_appid) || "{}");

                  data.fans_id = _fans.fans_id;
                  data.nick_name = _fans.nick;
                  data.header = _fans.header;
                }
                _this7.header = data.header;
                _this7.nick_name = data.nick_name;
                data = _extends({}, data, extObj);
                option = '';

                for (i in data) {
                  if (data[i]) {
                    option = option + (i + '=' + data[i] + '&');
                  }
                }
                option = option.slice(0, option.length - 1);
                _context6.next = 23;
                return _axios2.default.post(_Tools2.default.baseUrl2() + '/goods/submitOrder', option);

              case 23:
                _ref3 = _context6.sent;
                _ref3$data = _ref3.data;
                code = _ref3$data.code;
                resData = _ref3$data.data;
                message = _ref3$data.message;


                // const { data: { code, data:resData, message } } = await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/submitOrder', option)

                // const {data:{order_no,money}, code} = res.data
                // console.log('data',code)
                if (code == 200) {
                  // this.maskshow1=false
                  money = resData.money, order_no = resData.order_no;

                  _this7.handlePayRequest(money, order_no);
                } else {
                  _this7.maskshow1 = false;
                  (0, _notify2.default)(message);
                }

              case 29:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    submitLinkURlOrder: function submitLinkURlOrder(payUrl) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var i, extObj, data, appid, fans, _appid2, _fans2, option, _ref4, _ref4$data, code, message;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.maskshow1 = true;
                // console.log('微信支付')
                _context7.t0 = regeneratorRuntime.keys(_this8.form);

              case 2:
                if ((_context7.t1 = _context7.t0()).done) {
                  _context7.next = 10;
                  break;
                }

                i = _context7.t1.value;

                if (!i) {
                  _context7.next = 8;
                  break;
                }

                if (!(_this8.form[i].required == 1 && !_this8.form[i].value)) {
                  _context7.next = 8;
                  break;
                }

                (0, _notify2.default)('\u8BF7\u586B\u5199' + _this8.form[i].name);
                return _context7.abrupt('return');

              case 8:
                _context7.next = 2;
                break;

              case 10:
                extObj = {};

                for (i in _this8.form) {
                  extObj[_this8.form[i].id] = _this8.form[i].value;
                }

                data = {
                  goods_id: _this8.gid,
                  num: _this8.goodsNum,
                  payurl: payUrl,
                  channel_id: _this8.channel_id
                };


                if (_this8.ds_id) {
                  data.ds_id = _this8.ds_id;
                }
                //  console.log('zhifu')
                if (_this8.isInAliPay()) {
                  appid = localStorage.getItem("current_app_Id");
                  fans = JSON.parse(localStorage.getItem(appid) || "{}");

                  data.nick_name = fans.nick;
                  data.header = fans.header;
                } else {
                  _appid2 = localStorage.getItem("current_app_Id");
                  _fans2 = JSON.parse(localStorage.getItem(_appid2) || "{}");

                  data.fans_id = _fans2.fans_id;
                  data.nick_name = _fans2.nick;
                  data.header = _fans2.header;
                }
                _this8.header = data.header;
                _this8.nick_name = data.nick_name;
                data = _extends({}, data, extObj);
                option = '';

                for (i in data) {
                  if (data[i]) {
                    option = option + (i + '=' + data[i] + '&');
                  }
                }
                option = option.slice(0, option.length - 1);
                _context7.prev = 21;
                _context7.next = 24;
                return _axios2.default.post(_Tools2.default.baseUrl2() + '/goods/submitOrder', option);

              case 24:
                _ref4 = _context7.sent;
                _ref4$data = _ref4.data;
                code = _ref4$data.code;
                message = _ref4$data.message;

                // const {data:{order_no,money}, code} = res.data
                // console.log('data',code)
                if (code == 200) {
                  _this8.maskshow1 = false;
                  location.href = payUrl;
                } else {
                  _this8.maskshow1 = false;
                  (0, _notify2.default)(message);
                }
                _context7.next = 34;
                break;

              case 31:
                _context7.prev = 31;
                _context7.t2 = _context7['catch'](21);

                _this8.maskshow1 = false;

              case 34:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[21, 31]]);
      }))();
    },
    handlePayRequest: function handlePayRequest(money, orderno) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var appid, fans, data, _option, i, _option2, res, _res$data2, code, rc_Result;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                appid = localStorage.getItem("current_app_Id");
                fans = JSON.parse(localStorage.getItem(appid) || "{}");
                data = {
                  money: money,
                  orderno: orderno,
                  opid: _this9.goodsInfo.opid,
                  uid: _this9.uid,
                  header: fans.header,
                  nick: fans.nick,
                  channel_id: _this9.channel_id
                };

                _this9.header = data.header;
                _this9.nick = data.nick;
                console.log('data----', data);
                if (_this9.isInAliPay()) {
                  data.flag = 3;
                  data.alipayid = fans.userId;
                }
                if (_Tools2.default.isWeixin()) {
                  if (_this9.wxcheck === 1) {
                    data.flag = 1; // 微信公众号
                  } else {
                    data.flag = 3; // 复制支付宝链接支付
                  }
                  data.openid = fans.openid;
                  data.fansid = fans.fans_id;
                }

                if (!_Tools2.default.isWeixinMP()) {
                  _context8.next = 15;
                  break;
                }

                //小程序
                _option = '';

                for (i in data) {
                  if (data[i]) {
                    _option = _option + (i + '=' + data[i] + '&');
                  }
                }
                _option = _option.slice(0, _option.length - 1);
                wx.miniProgram.navigateTo({ url: '/pages/pay/pay?' + _option });
                _context8.next = 28;
                break;

              case 15:
                _option2 = '';

                for (i in data) {
                  if (data[i]) {
                    _option2 = _option2 + (i + '=' + data[i] + '&');
                  }
                }

                _option2 = _option2.slice(0, _option2.length - 1);
                _context8.next = 20;
                return _axios2.default.post('https://zhifu-api.tenghuiwangxiao.cn/cartPay', _option2);

              case 20:
                res = _context8.sent;
                _res$data2 = res.data, code = _res$data2.code, rc_Result = _res$data2.data.rc_Result;

                console.log(res.data);

                if (!(code === 2000 && rc_Result && _this9.wxcheck === 0 && !_this9.isInAliPay())) {
                  _context8.next = 27;
                  break;
                }

                _this9.maskshow1 = false;
                _this9.aLiPayUrl = rc_Result;
                return _context8.abrupt('return');

              case 27:
                if (code == 2000 && rc_Result) {
                  _this9.maskshow1 = false;
                  window.location.href = rc_Result;
                } else if (code == 2000 && _Tools2.default.isWeixin()) {
                  _this9.maskshow1 = false;
                  _this9.onBridgeReady(res.data.data);
                } else {
                  _this9.maskshow1 = false;
                  (0, _notify2.default)(res.data.data);
                }

              case 28:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    onBridgeReady: function onBridgeReady(params) {
      WeixinJSBridge.invoke('getBrandWCPayRequest', {
        "appId": params.appId, //公众号名称，由商户传入
        "timeStamp": String(params.timeStamp), //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        "nonceStr": params.nonceStr, //支付签名随机串，不长于 32 位
        "package": params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        "signType": 'MD5', //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        "paySign": params.paySign //支付签名
      }, function (res) {
        if (res.err_msg === "get_brand_wcpay_request:ok") {
          (0, _toast2.default)('支付成功！');
        } else if (res.err_msg === "get_brand_wcpay_request:fail") {
          (0, _toast2.default)('支付失败！');
        }
      });
    },

    //禁止滚动
    stopScroll: function stopScroll() {
      var mo = function mo(e) {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },

    /***取消滑动限制***/
    canScroll: function canScroll() {
      var mo = function mo(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ''; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    getGoodsNum: function getGoodsNum() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var option, _ref5, _ref5$data, code, data;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // const res =  await axios.post(tool.baseUrl2()+'/goods/goodsInventory',option)
                option = 'ds_id=' + _this10.ds_id + '&goods_id=' + _this10.goodsInfo.id;
                _context9.next = 3;
                return _axios2.default.post(_Tools2.default.baseUrl2() + '/goods/goodsInventory', option);

              case 3:
                _ref5 = _context9.sent;
                _ref5$data = _ref5.data;
                code = _ref5$data.code;
                data = _ref5$data.data;

                // const option = `ds_id=209972&goods_id=27`
                // const { data: { code, data } } =  await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/goodsInventory',option)
                if (code === 200) {
                  _this10.goodsInfo = _extends({}, _this10.goodsInfo, { count: data.count, infinite: data.infinite });
                }

              case 8:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    }
  }
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.maskshow) ? _c('div', {
    staticClass: "mask1"
  }) : _vm._e(), _vm._v(" "), (_vm.maskshow1) ? _c('div', {
    staticClass: "mask2"
  }) : _vm._e(), _vm._v(" "), (_vm.maskshow2) ? _c('div', {
    staticClass: "mask3"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showTips),
      expression: "!showTips"
    }]
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, _vm._l((_vm.goodsInfo.img_list), function(item, index) {
    return _c('van-swipe-item', {
      key: index
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "symbol"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.goodsInfo.price))])]), _vm._v(" "), (_vm.goodsInfo.infinite !== 1) ? _c('div', {
    staticClass: "inventory-num"
  }, [_vm._v("库存: " + _vm._s(_vm.goodsInfo.count))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "goods-title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.goodsInfo.desc),
      expression: "goodsInfo.desc"
    }],
    staticClass: "text-desc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_c('van-button', {
    class: {
      'disabled': _vm.goodsInfo.infinite == 0 && _vm.goodsInfo.count == 0
    },
    attrs: {
      "type": "primary",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.toConfirm
    }
  }, [_vm._v("立即购买")])], 1), _vm._v(" "), (_vm.confirm) ? _c('div', {
    staticClass: "consultTeacher"
  }, [_c('div', {
    staticClass: "consultTeacherMain"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TeacherList"
  }, [_c('div', {
    staticClass: "teacherCell order"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.goodsInfo.cover
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-content"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "goods-price"
  }, [_c('span', {
    staticClass: "money-symbol"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "money-num"
  }, [_vm._v(_vm._s(_vm.goodsInfo.price))]), _vm._v(" "), _c('div', {
    staticClass: "stepper"
  }, [_c('van-stepper', {
    attrs: {
      "theme": "round",
      "integer": ""
    },
    model: {
      value: (_vm.goodsNum),
      callback: function($$v) {
        _vm.goodsNum = $$v
      },
      expression: "goodsNum"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-wrap"
  }, [_c('van-cell-group', _vm._l((_vm.formList), function(item, index) {
    return _c('van-field', {
      key: index,
      attrs: {
        "label": item.name,
        "placeholder": ("请输入" + (item.name)),
        "required": (item.required == 1)
      },
      model: {
        value: (_vm.form[("custom" + (item.id))]['value']),
        callback: function($$v) {
          _vm.$set(_vm.form[("custom" + (item.id))], 'value', $$v)
        },
        expression: "form[`custom${item.id}`]['value']"
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "sum-text"
  }, [_vm._v("合计：")]), _vm._v(" "), _c('div', {
    staticClass: "sum-money"
  }, [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.goodsInfo.price * _vm.goodsNum).toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "comfirm-btn"
  }, [_c('button', {
    on: {
      "click": _vm.submitOrdert
    }
  }, [_vm._v("提交订单")])])]), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })])]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showWxPopUp),
      callback: function($$v) {
        _vm.showWxPopUp = $$v
      },
      expression: "showWxPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("微信授权登录即可查看详情")]), _vm._v(" "), _c('div', {
    staticClass: "qqBox"
  }, [_c('van-button', {
    staticStyle: {
      "padding": "0px 45px"
    },
    attrs: {
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.wxloginTap
    }
  }, [_vm._v("确认登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px",
      "color": "#c9c9c9"
    },
    on: {
      "click": _vm.closeWindow
    }
  }, [_vm._v("取消")])], 1)])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showAliPopUp),
      callback: function($$v) {
        _vm.showAliPopUp = $$v
      },
      expression: "showAliPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("支付宝授权登录即可查看详情")]), _vm._v(" "), _c('div', {
    staticClass: "qqBox"
  }, [_c('van-button', {
    staticStyle: {
      "padding": "0px 45px"
    },
    attrs: {
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.aliLoginTap
    }
  }, [_vm._v("确认登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px",
      "color": "#c9c9c9"
    },
    on: {
      "click": _vm.closeAliWindow
    }
  }, [_vm._v("取消")])], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }],
    staticClass: "tips"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(535)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tipsText))])]), _vm._v(" "), (_vm.paydatile) ? _c('div', {
    staticClass: "dialogpay"
  }, [_c('img', {
    staticClass: "payclose",
    attrs: {
      "src": __webpack_require__(128)
    },
    on: {
      "click": _vm.close1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "paytitle"
  }, [_vm._v("\n          支付详情\n        ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "payname"
  }, [_vm._v("\n            " + _vm._s(_vm.goodsInfo.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "qpayb"
  }, [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "payprice"
  }, [_vm._v(_vm._s(_vm.goodsInfo.price))])]), _vm._v(" "), _c('div', [(_vm.platform == 'wx' || !_vm.platform) ? _c('div', {
    staticClass: "paybx"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.qcheck
    }
  }, [(!_vm.wxcheck) ? _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": __webpack_require__(129),
      "mode": ""
    }
  }) : _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": __webpack_require__(130),
      "mode": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.platform == 'ali' || !_vm.platform) ? _c('div', {
    staticClass: "paybx"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.qcheck1
    }
  }, [(!_vm.apilcheck) ? _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": __webpack_require__(129),
      "mode": ""
    }
  }) : _c('img', {
    staticClass: "checkin",
    attrs: {
      "src": __webpack_require__(130),
      "mode": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "qrpaybx"
  }, [_c('div', {
    staticClass: "qrpay",
    on: {
      "click": _vm.quzhifu
    }
  }, [_vm._v("\n              确认支付\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.coyshow) ? _c('div', {
    staticClass: "dialogpay"
  }, [_c('div', {
    staticClass: "paytitle"
  }, [_vm._v("\n        支付宝支付\n      ")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "payclose",
    attrs: {
      "src": __webpack_require__(128)
    },
    on: {
      "click": _vm.close2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tzbx1"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "copy1",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("\n              复制\n            ")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("确认订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxpaybx"
  }, [_c('img', {
    staticClass: "logot",
    attrs: {
      "src": __webpack_require__(536),
      "mode": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("微信支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxpaybx"
  }, [_c('img', {
    staticClass: "logot",
    attrs: {
      "src": __webpack_require__(537),
      "mode": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("支付宝支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tzbx"
  }, [_c('img', {
    staticClass: "tzbxs",
    attrs: {
      "src": __webpack_require__(538)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coybx"
  }, [_c('div', [_vm._v(" 复制链接")]), _vm._v(" "), _c('div', {
    staticClass: "coy"
  }, [_vm._v(" 点击右侧按钮复制链接")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bzt"
  }, [_c('img', {
    staticClass: "logot logot1",
    attrs: {
      "src": __webpack_require__(539),
      "mode": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tzbx"
  }, [_c('div', [_c('img', {
    staticClass: "tzbxs",
    attrs: {
      "src": __webpack_require__(540),
      "mode": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "coybx"
  }, [_c('div', [_vm._v("在浏览器粘贴链接")]), _vm._v(" "), _c('div', {
    staticClass: "coy"
  }, [_vm._v("打开手机浏览器，粘贴链接并使用")])])])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAEXpJREFUeF7tnXuMXHUVx8+5021pRBOQio+2OzuzG4gkgJSiEWKsiVHxURuwEdi5uxVoaVFUHvWFsqhRERRBEIq1sLMUtQhiNaiYAIovoJFXUGrncactjSIvjdBaduaYuzPb9LHb+d17z9zzu3fO/Am/3++c7/d7Pp29u3PvIOhLHVAHpnUA1Rt1QB2Y3gEFRKdDHTiIAwqIjoc6oIDoDKgD4RzQd5BwvumuLnFAAemSoFVmOAcUkHC+6a4ucUAB6ZKgVWY4BxSQcL7pri5xQAHpkqBVZjgHFJBwvumuLnFAAemSoFVmOAcUkP186x0tLUHMDAA2ZoezNL27iGAOIc5xGlRFatxbHR64J71qm8oUkL0SzhYrawBoedpD59KHCPfgOFxaWZZ/mOtM285RQFqJZIul1QB4hW0BWdEPTfNPqT89BM8QwqpaIX+HFb0yN6GATAIyVt4EBAuY/e2C45qUAMCFnpu/Om2CFZA97yDliZT1FdCBfd9dvuO5+U8HPMHq5QqIAhJtQA/88evOV2jW8qeH5j4X7WA7disgCki0SZzi+gQBNgGNn18dOuqhaIfL71ZAFJBoUzjdBTzRvxrgrNo6lPtJtAKyuxUQI0DwfqjXL5eNSqh6xhkCgOFpq08HSGsDEVxUG8p/W6j7yGUVEENAPDe3KLLbCTwgO1a+DAhGwgIysQ/hGq+Q/1QC5esfCidDyxbL/wGAV08ZIsIvvUL+1CQGHLVnFkCakPzUK4+dDiMjjag9xblf30FabvcVyw8QwClTmU+EV9WGcpfEGYwttdgAmRBEf3HqOFxZln/CFn3t+lBAWg71FitnI9DaqQwbP2Tma7cvnfd8OzPT+P/bAVJvNBbPyDjrieBQE/0E9KwDtKrqDtxusl56jQKyVwLZm7e8EzLONwFgYes/391wZlyydbD3r9JBSdVvBwjUG4u8ZQP3Z4vlPwDA2037JMCLa27uW6brpdYpIFM43zf61LGZTMYrDQ741yVd/TIFxDcpWyzfAADnmRuG13pu7pPm6+NfqYDE73miKgYBpAWJD4gPiunrLs/NLzFdHPc6BSRuxxNWLyggvrzcaPmUBsID5lLpkXGa9cHtQ/OeNt8Tz0oFJB6fE1slDCAtSOaTA0+aXrwD0HPoOGdWB3NW3YSlgCR2dONpPCwgre4wWyz/PsjFu20fm1dA4pmzxFaJCMiE7qAX7wT43Zqbu8AG01gByRZLHwXCDwHiG2wQZ1UP1DgcwZndcOqPOYSPvQwvXf1P97iXrOpximY4AAl38Y4/89zch6X9YQMkWyxX/X8spAUlpj7iTgA63yvkb7a5Zy5AmpBU3wPQ+JWxXoJHd+964eQdK0582XgP80IWQLLF0hUAuJq5ty45zrnMc/u+bKtYTkB8jfPXbXlzpsd50PjineB5pwHvlXowBBMg5RIA5G0NWbavPfdsT9sGAfygNi93HizCcdleD6zODYhfYc6GJw991a5Dfh3s4p2WeW7/LXH7wwWI3s8dNTmCexozZqzcelZvJepRnPs7Achkf4Ev3gU+NKqAcE5T5LPwb1Cvr/I/2xT5KKYDOglI6+Ldf8iD+Q1ViBu9Qm4xk7y2xyggbS2KdwEi/BcIV1Xd3Fi8laeu1mlA/Kq9Y+XTkCDIrbmPeW7++Dj8UUDicDlEDUL8Qq2Q+1qIraxb4gDEbzh3a3khEdxrfPEO8EK90Vi4bXigzCp4v8NiAKSL7+f2zc4494UOkGiNN9Qf4NOxoStNuzEuQPwG+m6rHEnjdGeQi3dEXFwt5DbyK2+eGAsg3Xo/d+tn7Ki/wLh7hjNrRWlw7vZODcHBzo0TkMk+eoulmxDw3AB6P++5+a8HWG+8VAExtircwmyR5YmNTzQcWrl1sN+/KSnWlwQgE+8mxcqlBPSVAGJv89z8WQHWGy1VQIxsCr+ICRC/gRehAau84fwPw3cTfKcUIBOQjFVcIhoN0DX7xbsCEsD9MEsNAPHvgXiT+dn0Gc/t928LjuUlCYgvsHe0tMhxcGOAi/cXx3fvym8/5xiWZwgoIB0es7aAZJy3wHj9BkB8m2krhHhdrZD7hOn6KOukAfF7n3fLlnzGcYoBL97fUS3kAty0NbVLCkiU6THY2w4Qz83j/PW1w5zx+o2AtNTgyOYSoo0ZhHPLbv8zxntCLLQBEL/tBWs29Tw3+zD/oyZnBpCx0nPzNwZYf8BSBSSKewZ7TQCZPKa3WLoKAS8yOLa1hB5xYObyijt/k/meYCttAWSy62yx7P+26rOmKojoutpQf+h3WwXE1OmQ64IA4pfIFqsXADSuMS1HAM8Cwnmd+oYnE0BMe2Vbh85iQDj4o0z3nez7PDf/rjD1FZAwrgXYExQQ/+jmF4ni9wDg9aalOvWQ6LaAmDYosm6fT1I/47n5I4O2oYAEdSzg+jCATEAytuUEJMf/+XnyIXYmldm/4SnZgOxvGd4f9I/WCojJ2EVYExYQv+TcDdsO7/nf7puI4DTTFhDhDpwFZ1eW5v9tuudg69IFiK+UzvDc/h+ZeqOAmDoVcl0UQPa6MPW/HDPI1wc8jITnVIdyj4dse8+2dACy149aBJ/zhvLfMPVFATF1KuQ6DkCa1yVbLkR0gjzL9h8IjeVVd+DnIVuf2NZXrBQIyP8bRDpeCCNeIW/8ZUgKSIdj5wKkeV1SPg2IbkTAI0zbJsCP19zc9abr91/nfwy90YDEf9fgHl0KSNhR6Mw+TkD8DuevLy1w6ngTAJxg2jEhXVkr9Id+qEY6fsxquaWAmI5NPOu4AfG7fuOazUfMnJ1ZC4ABbj3FH48f0rNs+9J5O8Mo9594D87MkwgowOfGwlSKuIcmHj3V+k7FKb+CV3/Eimgx6/ZOADLZYG+xci0CBfkr8R8R8WPVQm4zq0iLDmt9x8v0N6npO4hFaTUfu3nQG6b8z2JF6bhvrHQxEV5pegYBbHcaeHZ12K6HRJv2326dAtLOIcv+f6cB8eX2jVZOJyT/uuQwU/kItLzq9n/fdH1S1ikgSUmq1WccgPilcsXyiQ3AtQB0nKlFBPjVmpv7oun6JKxTQJKQ0l49xgWIX7J/3ZY5r8xw1iHAB0xtIqCxWiU/DCOYqK9nnk6fAmKavCXr4gRkUnLfaPl6QlhlbAHB7whfGa65R/sPIE/0SwFJWHwSgDSvS0qXEKL5rbkEHqAz7Ll9v02Yxfu0q4AkLD0pQCYgKVY+Qs3vfn+NoW311q+BE/vREgXEMGlblkkC0nwn2XwSQWYdIB5j6gkSfak61B/kkTumR3d8nQLScYt5C0gD4qvJF0uvqwP6X9Rzqqk6QlxbK+SCPLzN9OiOrlNAOmov/+E2ADKpKlss+3cprgyg8jf1np7hbWfM3xFgj+hSBUTU/uDF2wECCCPBTw2/AwFOJoJ3H/wEAkAEaH4G4O9EjeHa0MCfwleNb6cCEp/XLJXaAsJSpeOH7AKkM7xC/10drxSxgAIS0cC4t6cEEP8d5VEYx0Xesr4X4/YwSD0FJIhbFqxNByDNW1YJYbBWyK+3wNZpW1BAbE5nit5SAcjkbRUBPyouEZUCIuF6hJrZYtn/9WrrBp4IB4lubT30QAEJl8LB/5UM/iyicF3Yuav11+wNdnZn0NXez15TQAwMC/xjRHcD4tvVO1p6HyBci4D94Ry2ZJcCEi4IfQdp79vcDdtm9+x8aYAamcPbrxZbcTw4ztXTfjGfAhIuGAUknG+27eK+wJXQx60h0v3QkwYoIBKjwF+Te7j4O2x/IrcGBaS9512zgnu4JIzj1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTe7gkZHJrUEAkUrS0JvdwScjk1qCASKRoaU3u4ZKQya1BAZFI0dKa3MMlIZNbgwIikaKlNbmHS0ImtwYFRCJFS2tyD5eETG4NCohEipbW5B4uCZncGhQQiRQtrck9XBIyuTUoIBIpWlqTa7gmzpF8ZZz7pi2PMOIV8pebtqeAmDrVBeuiApItlm8GgvcDwhxr7VJArI3G+saiAJItVv4MQG+1XqQCYn1E1jYYFpDe0dISRLzTWmF7N6aAJCImK5sMC0i2WF0N0LjCSlH7N6WAJCImK5sMC0hfsVIgoKKVovZrCgHdqpsbM+1VL9JNneqCdWEByd1aXthowENJsMhx4KTKYP5h014VEFOnumBdWEB8a7Jj5cuAYMRqmwL+eOVrUUCsTjTe5qIA4nfaN/rUseT0LAFC2b+DHGBb4yGk8fXVoaMfD+qoAhLUsRSvjwpIGq1RQNKYakhNCsiBxikgIYcpjdsUEAUkjXPNpkkBUUDYhimNBykgCkga55pNkwKigLANUxoPUkAUkDTONZsmBUQBYRumNB6kgCggaZxrNk0KiALCNkxpPEgBEQIE6nXje4DTOHiJ0sR4P3eidE/TbAx/SU+DTaphwoEQn4ZNunMKSNITjLN/BSSc29limcLt1F2JckABCReXAhLOt8TtUkDCRZYdK28CggXhduuupDiAgEurbu72pPTL0SfTNUhpNQAm46kWHK515xmbd+8cP2XHiqOe7Sb5LID4hmWLlTUAtLybzOsarYg7HKQVlcH8L7pGc0soGyD+ec0HiGUGABuzu83ItOpFwKcR6cHKYP6JtGo8mC5WQLrRQNWcbgcUkHTnq+oiOqCARDRQt6fbAQUk3fmquogOKCARDdTt6XZAAUl3vqouogMKSEQDdXu6HVBA0p2vqovogAIS0UDdnm4HFJB056vqIjqggEQ0ULen2wEFJN35qrqIDvwfx8wcbghEpUMAAAAASUVORK5CYII="

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  "data-v-9486f75a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("76a357d1", content, true);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".liveStop[data-v-9486f75a]{margin-top:250px;text-align:center}.liveStop .buttom[data-v-9486f75a]{width:200px;height:40px;line-height:40px;display:inline-block;text-align:center;background:#3844e8;font-size:20px;color:#fff;border-radius:5px}", ""]);

// exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {};
    },

    methods: {
        backLivePage: function backLivePage() {
            var ds_id = this.$route.query.ds_id || '';
            var channel_id = this.$route.query.channel_id || '';
            var link_mic_jump = this.$route.query.link_mic_jump || '';
            if (channel_id) {
                location.href = "./?channel_id=" + channel_id + "&link_mic_jump=" + link_mic_jump;
            } else {
                location.href = "./?ds_id=" + ds_id + "&link_mic_jump=" + link_mic_jump;
            }
        }
    }
};

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "liveStop"
  }, [_c('a', {
    staticClass: "buttom",
    on: {
      "click": function($event) {
        return _vm.backLivePage()
      }
    }
  }, [_vm._v("返回直播页")])])])
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  "data-v-3c4cad3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("750fe843", content, true);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".tijiaoanniu[data-v-3c4cad3e]{width:130px;height:30px;background:#06f;border:none;color:#fff;border-radius:20px;margin-top:20px}.shuruyanz[data-v-3c4cad3e]{width:220px;height:40px}.yanzhengmade[data-v-3c4cad3e]{text-align:center;margin-top:20px}.anquan p[data-v-3c4cad3e]{color:#000;font-weight:600}.anquan[data-v-3c4cad3e]{text-align:center}.guanbi[data-v-3c4cad3e]{text-align:right}.yanzhengma[data-v-3c4cad3e]{height:230px}.chakang[data-v-3c4cad3e]{text-align:center;color:#000;margin-top:20px}.baozheng[data-v-3c4cad3e]{text-align:center;color:#a9a9a9;margin-top:20px}.quyanz[data-v-3c4cad3e]{width:240px;height:40px;background:#32cd32;margin:0 auto;border-radius:20px;margin-top:20px;text-align:center;line-height:40px;color:#fff}", ""]);

// exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(6);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(7);

var _VerifyStyle = __webpack_require__(550);

var _VerifyStyle2 = _interopRequireDefault(_VerifyStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { VerifyStyle: _VerifyStyle2.default },
  data: function data() {
    return {
      show: false,
      identifyCodeType: "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ", //定义验证类型 1.数字 2.字母
      identifyCode: "",
      inputCode: "" //text框输入的验证码
    };
  },
  created: function created() {
    console.log('ggggggggggggg', this.$route.query.uid);
  },

  methods: {
    goOff: function goOff() {
      this.$router.go(-1);
    },

    //验证码规则
    getSubmitData: function getSubmitData() {
      if (this.inputCode == "") {
        _toast2.default.fail('请输入验证码');
        return;
      }
      var num = this.inputCode.toUpperCase();
      if (this.identifyCode !== num) {
        this.inputCode = "";
        this.refreshCode();
        _toast2.default.fail('请输入正确验证码');
        return;
      } else {
        this.inputCode = "";
        this.refreshCode();
        _toast2.default.success('验证成功');
        this.$router.push({ 'path': '/Informationpage', query: { uid: this.$route.query.uid } });
      }
    },

    //验证码
    randomNum: function randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    //初始化验证码
    refreshCode: function refreshCode() {
      this.identifyCode = ""; //输入框置空
      this.makeCode(this.identifyCodeType, 4); //验证码长度为4
    },

    //随机切换验证码
    makeCode: function makeCode(o, l) {
      for (var i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodeType[this.randomNum(0, this.identifyCodeType.length)];
      }
      //   console.log(this.identifyCode);
    }
  },
  mounted: function mounted() {
    this.refreshCode();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: "securityCode",
  props: {
    identifyCode: {
      type: String,
      default: "1234"
    },
    fontSizeMin: {
      type: Number,
      default: 16
    },
    fontSizeMax: {
      type: Number,
      default: 40
    },
    backgroundColorMin: {
      type: Number,
      default: 180
    },
    backgroundColorMax: {
      type: Number,
      default: 240
    },
    colorMin: {
      type: Number,
      default: 50
    },
    colorMax: {
      type: Number,
      default: 160
    },
    lineColorMin: {
      type: Number,
      default: 40
    },
    lineColorMax: {
      type: Number,
      default: 180
    },
    dotColorMin: {
      type: Number,
      default: 0
    },
    dotColorMax: {
      type: Number,
      default: 255
    },
    contentWidth: {
      type: Number,
      default: 220
    },
    contentHeight: {
      type: Number,
      default: 60
    }
  },
  methods: {
    // 生成一个随机数
    randomNum: function randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    // 生成一个随机的颜色
    randomColor: function randomColor(min, max) {
      var r = this.randomNum(min, max);
      var g = this.randomNum(min, max);
      var b = this.randomNum(min, max);
      return "rgb(" + r + "," + g + "," + b + ")";
    },
    drawPic: function drawPic() {
      var canvas = document.getElementById("s-canvas");
      var ctx = canvas.getContext("2d");
      ctx.textBaseline = "bottom";
      // 绘制背景
      ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax);
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
      // 绘制文字
      for (var i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    },
    drawText: function drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
      ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + "px SimHei";
      var x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
      var y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
      var deg = this.randomNum(-45, 45);
      // 修改坐标原点和旋转角度
      ctx.translate(x, y);
      ctx.rotate(deg * Math.PI / 180);
      ctx.fillText(txt, 0, 0);
      // 恢复坐标原点和旋转角度
      ctx.rotate(-deg * Math.PI / 180);
      ctx.translate(-x, -y);
    },
    drawLine: function drawLine(ctx) {
      // 绘制干扰线
      for (var i = 0; i < 8; i++) {
        ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax);
        ctx.beginPath();
        ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.stroke();
      }
    },
    drawDot: function drawDot(ctx) {
      // 绘制干扰点
      for (var i = 0; i < 100; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI);
        ctx.fill();
      }
    }
  },
  watch: {
    identifyCode: function identifyCode() {
      this.drawPic();
    }
  },
  mounted: function mounted() {
    this.drawPic();
  }
};

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": "s-canvas",
      "width": _vm.contentWidth,
      "height": _vm.contentHeight
    }
  })
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("公司信息")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chakang"
  }, [_vm._v("您即将查看公司信息")]), _vm._v(" "), _c('div', {
    staticClass: "baozheng"
  }, [_vm._v("为了保证双方信息安全，请先按照提示完成安全验证")]), _vm._v(" "), _c('div', {
    staticClass: "quyanz",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v("去验证")]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "yanzhengma"
  }, [_c('p', {
    staticClass: "guanbi",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "anquan",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("安全验证")])]), _vm._v(" "), _c('div', {
    staticClass: "yanzhengmade"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputCode),
      expression: "inputCode"
    }],
    staticClass: "shuruyanz",
    attrs: {
      "type": "text",
      "placeholder": "请输入下图验证码，不区分大小写"
    },
    domProps: {
      "value": (_vm.inputCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('VerifyStyle', {
    attrs: {
      "identifyCode": _vm.identifyCode
    }
  }), _vm._v(" "), _c('van-icon', {
    staticStyle: {
      "position": "absolute",
      "right": "15px",
      "margin-top": "16px"
    },
    attrs: {
      "name": "replay",
      "size": "2em"
    },
    on: {
      "click": function($event) {
        return _vm.refreshCode()
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "tijiaoanniu",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getSubmitData()
      }
    }
  }, [_vm._v("提交")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePreview = __webpack_require__(556);

var _imagePreview2 = _interopRequireDefault(_imagePreview);

__webpack_require__(558);

var _Tools = __webpack_require__(3);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            business_img: '',
            org_name: ''
        };
    },
    created: function created() {
        this.storedata();
        console.log('haaaaaaaaaaaaaaa', this.$route.query.uid);
    },

    methods: {
        goOff: function goOff() {
            this.$router.go(-1);
        },
        yulantupian: function yulantupian() {
            (0, _imagePreview2.default)([this.business_img]);
            console.log('111', this.business_img);
        },
        storedata: function storedata() {
            var _this = this;

            var param = "uid=" + this.$route.query.uid;
            this.axios.post(_Tools2.default.baseUrl1() + "/api/store_data", param).then(function (res) {
                if (res.data.code == 200) {
                    _this.business_img = res.data.data.business_img;
                    _this.org_name = res.data.data.org_name;
                }
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _ImagePreview = __webpack_require__(557);

var _ImagePreview2 = _interopRequireDefault(_ImagePreview);

var _utils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance;
var defaultConfig = {
  images: [],
  loop: true,
  value: true,
  minZoom: 1 / 3,
  maxZoom: 3,
  className: '',
  lazyLoad: false,
  showIndex: true,
  asyncClose: false,
  startPosition: 0,
  showIndicators: false
};

var initInstance = function initInstance() {
  instance = new (_vue2.default.extend(_ImagePreview2.default))({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};

var ImagePreview = function ImagePreview(images, startPosition) {
  if (startPosition === void 0) {
    startPosition = 0;
  }

  /* istanbul ignore if */
  if (_utils.isServer) {
    return;
  }

  if (!instance) {
    initInstance();
  }

  var options = Array.isArray(images) ? {
    images: images,
    startPosition: startPosition
  } : images;

  (0, _extends3.default)(instance, defaultConfig, options);

  instance.$once('input', function (show) {
    instance.value = show;
  });

  if (options.onClose) {
    instance.$once('close', options.onClose);
  }

  return instance;
};

ImagePreview.install = function () {
  _vue2.default.use(_ImagePreview2.default);
};

exports.default = ImagePreview;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _babelHelperVueJsxMergeProps = __webpack_require__(14);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _utils = __webpack_require__(5);

var _event = __webpack_require__(12);

var _popup = __webpack_require__(30);

var _touch = __webpack_require__(31);

var _swipe = __webpack_require__(35);

var _swipe2 = _interopRequireDefault(_swipe);

var _swipeItem = __webpack_require__(36);

var _swipeItem2 = _interopRequireDefault(_swipeItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _use = (0, _utils.use)('image-preview'),
    sfc = _use[0],
    bem = _use[1];

function getDistance(touches) {
  return Math.sqrt(Math.abs((touches[0].clientX - touches[1].clientX) * (touches[0].clientY - touches[1].clientY)));
}

exports.default = sfc({
  mixins: [_popup.PopupMixin, _touch.TouchMixin],
  props: {
    images: Array,
    className: null,
    lazyLoad: Boolean,
    asyncClose: Boolean,
    startPosition: Number,
    showIndicators: Boolean,
    loop: {
      type: Boolean,
      "default": true
    },
    overlay: {
      type: Boolean,
      "default": true
    },
    showIndex: {
      type: Boolean,
      "default": true
    },
    minZoom: {
      type: Number,
      "default": 1 / 3
    },
    maxZoom: {
      type: Number,
      "default": 3
    },
    overlayClass: {
      type: String,
      "default": 'van-image-preview__overlay'
    },
    closeOnClickOverlay: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      scale: 1,
      moveX: 0,
      moveY: 0,
      moving: false,
      zooming: false,
      active: 0
    };
  },
  computed: {
    imageStyle: function imageStyle() {
      var scale = this.scale;
      var style = {
        transition: this.zooming || this.moving ? '' : '.3s all'
      };

      if (scale !== 1) {
        style.transform = "scale3d(" + scale + ", " + scale + ", 1) translate(" + this.moveX / scale + "px, " + this.moveY / scale + "px)";
      }

      return style;
    }
  },
  watch: {
    value: function value() {
      this.active = this.startPosition;
    },
    startPosition: function startPosition(active) {
      this.active = active;
    }
  },
  methods: {
    onWrapperTouchStart: function onWrapperTouchStart() {
      this.touchStartTime = new Date();
    },
    onWrapperTouchEnd: function onWrapperTouchEnd(event) {
      (0, _event.preventDefault)(event);
      var deltaTime = new Date() - this.touchStartTime;

      var _ref = this.$refs.swipe || {},
          _ref$offsetX = _ref.offsetX,
          offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
          _ref$offsetY = _ref.offsetY,
          offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY; // prevent long tap to close component


      if (deltaTime < 300 && offsetX < 10 && offsetY < 10) {
        var index = this.active;
        this.resetScale();
        this.$emit('close', {
          index: index,
          url: this.images[index]
        });

        if (!this.asyncClose) {
          this.$emit('input', false);
        }
      }
    },
    startMove: function startMove(event) {
      var image = event.currentTarget;
      var rect = image.getBoundingClientRect();
      var winWidth = window.innerWidth;
      var winHeight = window.innerHeight;
      this.touchStart(event);
      this.moving = true;
      this.startMoveX = this.moveX;
      this.startMoveY = this.moveY;
      this.maxMoveX = Math.max(0, (rect.width - winWidth) / 2);
      this.maxMoveY = Math.max(0, (rect.height - winHeight) / 2);
    },
    startZoom: function startZoom(event) {
      this.moving = false;
      this.zooming = true;
      this.startScale = this.scale;
      this.startDistance = getDistance(event.touches);
    },
    onTouchStart: function onTouchStart(event) {
      var touches = event.touches;

      var _ref2 = this.$refs.swipe || {},
          _ref2$offsetX = _ref2.offsetX,
          offsetX = _ref2$offsetX === void 0 ? 0 : _ref2$offsetX;

      if (touches.length === 1 && this.scale !== 1) {
        this.startMove(event);
      }
      /* istanbul ignore else */
      else if (touches.length === 2 && !offsetX) {
          this.startZoom(event);
        }
    },
    onTouchMove: function onTouchMove(event) {
      var touches = event.touches;

      if (this.moving || this.zooming) {
        (0, _event.preventDefault)(event, true);
      }

      if (this.moving) {
        this.touchMove(event);
        var moveX = this.deltaX + this.startMoveX;
        var moveY = this.deltaY + this.startMoveY;
        this.moveX = (0, _utils.range)(moveX, -this.maxMoveX, this.maxMoveX);
        this.moveY = (0, _utils.range)(moveY, -this.maxMoveY, this.maxMoveY);
      }

      if (this.zooming && touches.length === 2) {
        var distance = getDistance(touches);
        var scale = this.startScale * distance / this.startDistance;
        this.scale = (0, _utils.range)(scale, this.minZoom, this.maxZoom);
      }
    },
    onTouchEnd: function onTouchEnd(event) {
      /* istanbul ignore else */
      if (this.moving || this.zooming) {
        var stopPropagation = true;

        if (this.moving && this.startMoveX === this.moveX && this.startMoveY === this.moveY) {
          stopPropagation = false;
        }

        if (!event.touches.length) {
          this.moving = false;
          this.zooming = false;
          this.startMoveX = 0;
          this.startMoveY = 0;
          this.startScale = 1;

          if (this.scale < 1) {
            this.resetScale();
          }
        }

        if (stopPropagation) {
          (0, _event.preventDefault)(event, true);
        }
      }
    },
    onChange: function onChange(active) {
      this.resetScale();
      this.active = active;
      this.$emit('change', active);
    },
    resetScale: function resetScale() {
      this.scale = 1;
      this.moveX = 0;
      this.moveY = 0;
    }
  },
  render: function render(h) {
    var _this = this;

    if (!this.value) {
      return;
    }

    var active = this.active,
        images = this.images;
    var Index = this.showIndex && h("div", {
      "class": bem('index')
    }, [this.slots('index') || active + 1 + "/" + images.length]);
    var Images = h(_swipe2.default, {
      "ref": "swipe",
      "attrs": {
        "loop": this.loop,
        "indicatorColor": "white",
        "initialSwipe": this.startPosition,
        "showIndicators": this.showIndicators
      },
      "on": {
        "change": this.onChange
      }
    }, [images.map(function (image, index) {
      var props = {
        "class": bem('image'),
        style: index === active ? _this.imageStyle : null,
        on: {
          touchstart: _this.onTouchStart,
          touchmove: _this.onTouchMove,
          touchend: _this.onTouchEnd,
          touchcancel: _this.onTouchEnd
        }
      };
      return h(_swipeItem2.default, [_this.lazyLoad ? h("img", (0, _babelHelperVueJsxMergeProps2.default)([{
        "directives": [{
          name: "lazy",
          value: image
        }]
      }, props])) : h("img", (0, _babelHelperVueJsxMergeProps2.default)([{
        "attrs": {
          "src": image
        }
      }, props]))]);
    })]);
    return h("transition", {
      "attrs": {
        "name": "van-fade"
      }
    }, [h("div", {
      "class": [bem(), this.className],
      "on": {
        "touchstart": this.onWrapperTouchStart,
        "touchend": this.onWrapperTouchEnd,
        "touchcancel": this.onWrapperTouchEnd
      }
    }, [Index, Images])]);
  }
});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

__webpack_require__(32);

__webpack_require__(79);

__webpack_require__(80);

__webpack_require__(559);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(560);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(9)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".van-image-preview{top:0;left:0;width:100%;height:100%;position:fixed}.van-image-preview__image{top:0;left:0;right:0;bottom:0;margin:auto;max-width:100%;max-height:100%;position:absolute}.van-image-preview__index{position:absolute;top:10px;left:50%;color:#fff;font-size:14px;letter-spacing:2px;-webkit-transform:translate(-50%);transform:translate(-50%)}.van-image-preview__overlay{background-color:rgba(0,0,0,.9)}.van-image-preview .van-swipe{height:100%}", ""]);

// exports


/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("店铺信息")])], 1), _vm._v(" "), _c('van-cell-group', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('van-cell', {
    attrs: {
      "title": "企业名称",
      "value": _vm.org_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "营业执照",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.yulantupian()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  "data-v-53059a2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6683979f", content, true);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".touyide[data-v-53059a2c]{height:68px;margin-top:20px;display:flex}.touxiang[data-v-53059a2c]{width:68px;height:68px;border-radius:34px;margin-left:20px}.tongbu[data-v-53059a2c]{width:110px;height:30px;border:1px solid silver;border-radius:20px;margin-left:12px;margin-top:16px;display:flex;line-height:30px}.xuexijilu[data-v-53059a2c]{width:350px;height:100px;margin:0 auto;margin-top:20px;border-radius:4px;display:flex;border:1px solid silver}", ""]);

// exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			header: '',
			nick: '',
			nums: '',
			times: ''
		};
	},
	created: function created() {
		this.infogeren();
		console.log('ggggggggggggg', this.$route.query.uid, this.$route.query.fans_id);
	},

	methods: {
		infogeren: function infogeren() {
			var that = this;
			this.axios.post('http://liveapi2.tenghuiwangxiao.com/api/ds/user/info', _qs2.default.stringify({ fansId: 1076933 })).then(function (data) {
				if (data.data.code == "200") {
					that.header = data.data.data.header;
					that.nick = data.data.data.nick;
					that.nums = data.data.data.nums;
					that.times = data.data.data.times;
				}
			});
		},
		goOff: function goOff() {
			this.$router.go(-1);
		},
		xuexijilu: function xuexijilu() {
			this.$router.push({ 'path': '/Learningrecord', query: { fans_id: this.$route.query.fans_id } });
		},
		yigoujilu: function yigoujilu() {
			this.$router.push({ 'path': '/MyPurchased', query: { fans_id: this.$route.query.fans_id } });
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "touyide"
  }, [_c('div', [_c('img', {
    staticClass: "touxiang",
    attrs: {
      "src": _vm.header,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "18px"
    }
  }, [_vm._v(_vm._s(_vm.nick))])])]), _vm._v(" "), _c('div', {
    staticClass: "xuexijilu"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "56px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_vm._v("累计学习" + _vm._s(_vm.times))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.xuexijilu()
      }
    }
  }, [_vm._v("听课记录")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "82px",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_vm._v(_vm._s(_vm.nums))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.yigoujilu()
      }
    }
  }, [_vm._v("我的已购")])])])])
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  "data-v-21227704",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(569);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4957b012", content, true);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".touyide[data-v-21227704]{height:68px;margin-top:20px;display:flex}.touxiang[data-v-21227704]{width:68px;height:68px;border-radius:34px;margin-left:20px}.xuexitou[data-v-21227704]{margin-top:20px;height:50px;width:100%;background:#add8e6}.biaoxiang[data-v-21227704]{width:336px;height:50px;display:flex;margin:0 auto}.xiaotanyi[data-v-21227704]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.xiaotaner[data-v-21227704],.xiaotansan[data-v-21227704],.xiaotanyi[data-v-21227704]{width:112px;height:50px;text-align:center}", ""]);

// exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            activeName: '0',
            touxiang: '',
            xuexi: [],
            show: false,
            xiaodetan: [],
            diff: '',
            nick: ''
        };
    },
    created: function created() {
        this.studydata(1);
    },

    methods: {
        showPopup: function showPopup(index) {
            // console.log(index)
            this.xiaodetan = index;
            this.show = true;
        },
        onClick: function onClick(name, title) {
            console.log('ghssssss', name + 1, title);
            this.studydata(name + 1);
        },
        studydata: function studydata(item) {
            // http://liveapi2.tenghuiwangxiao.com/api/ds/user/study_data
            var that = this;
            this.axios.post('http://liveapi2.tenghuiwangxiao.com/api/ds/user/study_data', _qs2.default.stringify({ fans_id: 1076933, type: item })).then(function (data) {
                if (data.data.code == "200") {
                    console.log('gsawwwwwwtttttttttttt---', data.data.data);
                    that.xuexi = data.data.data.list;
                    that.diff = data.data.data.info.diff;
                    that.touxiang = data.data.data.info.header;
                    that.nick = data.data.data.info.nick;
                    // let xuexilist = [] 
                    // data.data.data.list.forEach(item1=>{
                    //   item1.channels.forEach(item2=>{
                    //     item2.itemzbmc = item1.name
                    //     console.log(item1.name)
                    //     xuexilist.push(item2)
                    //   })
                    // })
                    // that.xuexi = xuexilist
                    // console.log('fshsssssssssss-----', xuexilist)
                }
            });
        },
        zhuanhuan: function zhuanhuan(value) {
            var result = parseInt(value);
            var y = Math.floor(result / 86400) < 10 ? "0" + Math.floor(result / 86400) : Math.floor(result / 86400);
            var h = Math.floor(result / 3600 % 24) < 10 ? "0" + Math.floor(result / 3600 % 24) : Math.floor(result / 3600 % 24);
            var m = Math.floor(result / 60 % 60) < 10 ? "0" + Math.floor(result / 60 % 60) : Math.floor(result / 60 % 60);
            var s = Math.floor(result % 60) < 10 ? "0" + Math.floor(result % 60) : Math.floor(result % 60);
            var res = "";
            // if (y !== "00") res += `${y}天`;
            res += h + ':';
            res += m + ':';
            res += '' + s;
            return res;
        },
        goOff: function goOff() {
            this.$router.go(-1);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "touyide"
  }, [_c('div', [_c('img', {
    staticClass: "touxiang",
    attrs: {
      "src": _vm.touxiang,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "18px"
    }
  }, [_vm._v(_vm._s(_vm.nick))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "20px"
    }
  }, [_vm._v("已加入"), _c('span', [_vm._v(_vm._s(_vm.diff))]), _vm._v("天")])]), _vm._v(" "), _c('van-tabs', {
    on: {
      "click": _vm.onClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "近十天数据",
      "name": "1"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("学习记录")]), _vm._v(" "), _c('div', {
    staticClass: "xuexitou"
  }, [_c('div', {
    staticClass: "biaoxiang"
  }, [_c('div', {
    staticClass: "xiaotanyi",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("直播间名称")])])])]), _vm._v(" "), _vm._l((_vm.xuexi), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "biaoxiang",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('div', {
      staticClass: "xiaotanyi"
    }, [_c('p', {
      staticStyle: {
        "margin-top": "11px"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotaner",
      staticStyle: {
        "margin-left": "100px"
      }
    }, [_c('van-cell', {
      attrs: {
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.showPopup(item.channels)
        }
      }
    }, [_vm._v("详情")]), _vm._v(" "), _c('van-popup', {
      style: ({
        height: '50%'
      }),
      attrs: {
        "lock-scroll": false,
        "closeable": ""
      },
      model: {
        value: (_vm.show),
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    }, [_c('p', {
      staticStyle: {
        "float": "right",
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.show = false
        }
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "xuexitou"
    }, [_c('div', {
      staticClass: "biaoxiang"
    }, [_c('div', {
      staticClass: "xiaotaner",
      staticStyle: {
        "line-height": "50px"
      }
    }, [_c('span', [_vm._v("进入时间")])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotansan",
      staticStyle: {
        "line-height": "50px"
      }
    }, [_c('span', [_vm._v("停留时间")])])])]), _vm._v(" "), _vm._l((_vm.xiaodetan), function(item1, index) {
      return _c('div', {
        key: index,
        staticClass: "biaoxiang",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "xiaotaner"
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item1.create_time))])]), _vm._v(" "), _c('div', {
        staticClass: "xiaotansan"
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.zhuanhuan(item1.second_time)))])])])
    })], 2)])], 1)])
  })], 2)]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "十天以外数据",
      "name": "2"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("学习记录")]), _vm._v(" "), _c('div', {
    staticClass: "xuexitou"
  }, [_c('div', {
    staticClass: "biaoxiang"
  }, [_c('div', {
    staticClass: "xiaotanyi",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("直播间名称")])])])]), _vm._v(" "), _vm._l((_vm.xuexi), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "biaoxiang",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('div', {
      staticClass: "xiaotanyi"
    }, [_c('p', {
      staticStyle: {
        "margin-top": "11px"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotaner",
      staticStyle: {
        "margin-left": "100px"
      }
    }, [_c('van-cell', {
      attrs: {
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.showPopup(item.channels)
        }
      }
    }, [_vm._v("详情")]), _vm._v(" "), _c('van-popup', {
      style: ({
        height: '50%'
      }),
      attrs: {
        "lock-scroll": false,
        "closeable": ""
      },
      model: {
        value: (_vm.show),
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    }, [_c('div', [_c('div', {
      staticClass: "xuexitou"
    }, [_c('div', {
      staticClass: "biaoxiang"
    }, [_c('div', {
      staticClass: "xiaotaner",
      staticStyle: {
        "line-height": "50px"
      }
    }, [_c('span', [_vm._v("进入时间")])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotansan",
      staticStyle: {
        "line-height": "50px"
      }
    }, [_c('span', [_vm._v("停留时间")])])])]), _vm._v(" "), _vm._l((_vm.xiaodetan), function(item1, index) {
      return _c('div', {
        key: index,
        staticClass: "biaoxiang",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "xiaotaner"
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(item1.create_time))])]), _vm._v(" "), _c('div', {
        staticClass: "xiaotansan"
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(_vm.zhuanhuan(item1.second_time)))])])])
    })], 2)])], 1)])
  })], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  "data-v-5635a938",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(574);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a141eb42", content, true);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".xuexitou[data-v-5635a938]{margin-top:20px;height:50px;width:100%;background:#add8e6}.biaoxiang[data-v-5635a938]{width:348px;height:55px;display:flex;margin:0 auto;margin-top:10px}.xiaotanyi[data-v-5635a938]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.xiaotaner[data-v-5635a938],.xiaotanyi[data-v-5635a938]{width:87px;height:55px;text-align:center;line-height:55px}.xiaotansan[data-v-5635a938]{width:87px;height:55px;text-align:center;line-height:26px}.xiaotansi[data-v-5635a938]{width:87px;height:55px;text-align:center;word-wrap:break-word}", ""]);

// exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _qs = __webpack_require__(18);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			xuexi: []
		};
	},
	created: function created() {
		this.infogeren();
		console.log('hhhhhhhhk==========', this.$route.query.fans_id);
	},

	methods: {
		infogeren: function infogeren() {
			var that = this;
			this.axios.post('http://liveapi2.tenghuiwangxiao.com/api/ds/user/order_data', _qs2.default.stringify({ fansId: 1076933 })).then(function (data) {
				if (data.data.code == "200") {
					that.xuexi = data.data.data;
				}
			});
		},
		goOff: function goOff() {
			this.$router.go(-1);
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("购买记录")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.xuexi), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "biaoxiang"
    }, [_c('div', {
      staticClass: "xiaotanyi"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.goods_name))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotaner"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotansan"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.pay_time))])]), _vm._v(" "), _c('div', {
      staticClass: "xiaotansi"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.order_no))])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xuexitou"
  }, [_c('div', {
    staticClass: "biaoxiang"
  }, [_c('div', {
    staticClass: "xiaotanyi",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("商品名称")])]), _vm._v(" "), _c('div', {
    staticClass: "xiaotaner",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("商品售价")])]), _vm._v(" "), _c('div', {
    staticClass: "xiaotansan",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("下单时间")])]), _vm._v(" "), _c('div', {
    staticClass: "xiaotansi",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('span', [_vm._v("订单号")])])])])
}]}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build@1727228849296.js